(function () {
  'use strict';
  angular.module('hdfc-mf-distributor-web', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'vcRecaptcha', 'daterangepicker','ngDroplet', 'gridster',
    'angularjs-dropdown-multiselect','720kb.tooltips','oc.lazyLoad','ng.deviceDetector','ngFileSaver','timer']);
})();

/**
 * Created by ttn on 15/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionFailController', transactionFailController);

  /** @ngInject */
  function transactionFailController(AppConstants) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants);
     var q = localStorage.getItem('q')||"";
     var a = decodeURI(q);
     vm.formData = angular.isDefined(a) ? JSON.parse(a):{};
     if (vm.formData.transactionType === "Flex SIP") {
       vm.tenureDiff = moment(vm.formData.endDate,"DD-MMM-YYYY").diff(moment(vm.formData.startDate,"DD-MMM-YYYY"), 'years') + 1;
     }
  }
})();

/**
 * Created by Sonakshi on 12/15/2016.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('PaymentBillJunctionController', paymentBillJunctionController);

  /** @ngInject */
  function paymentBillJunctionController(UtilService, $stateParams, $state, MessageService, AppConstants, LoaderService, TransactionService, $log,$rootScope,HDFC_API) {

    var vm = this;
    vm.responseData = null;
    vm.uniqueLink = '';
    vm.message = '';
    vm.isSuccess = false;
    vm.instrmNo = false;
    vm.instrnDate = false;

    vm.init = function () {

      if (!$stateParams.msg) {
        vm.isSuccess = false;
        vm.isActionPerformed = true;
        MessageService.error(AppConstants.ToastrMessage.PAYMENT_FAILED);
        return;
      }

      if ($stateParams.msg) {
        vm.isSuccess = true;
        vm.isActionPerformed = false;
        var msg = atob($stateParams.msg);
        try {
          vm.responseData = angular.fromJson(msg);
        } catch (e) {
          MessageService.error('JSON parsing exception');
          $log.info(e);
        }
      }
    };

    vm.rejectTransaction = function () {
      $state.go('main.dashboard');
    };

    vm.approveTransaction = function () {

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isActionPerformed = true;
            MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
          } else {
            MessageService.error(resp.message);
            vm.isActionPerformed = false;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var version=($rootScope.apiVersion==HDFC_API.VERSION)?HDFC_API.VERSION:($rootScope.apiVersion);
      TransactionService.get({
        VERSION:version,
        controller: 'otp',
        child2: 'approve',
        uniqueLink:"c2a8467d-7448-4014-ae22-787bd430aa15"  //vm.uniqueLink
      }, null).$promise.then(success, error);

    };

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('PaymentBillDeskController', paymentBillDeskController);

  /** @ngInject */
  function paymentBillDeskController($state, $stateParams, UtilService, TransactionService, MessageService, LoaderService, AppConstants,$rootScope,HDFC_API) {
    var vm = this;
    vm.responseData = null;
    vm.uniqueLink = '';
    vm.message = '';
    vm.isSuccess = false;
    vm.instrmNo = false;
    vm.instrnDate = false;

    vm.init = function () {
      if (!$stateParams.msg) {
        vm.isSuccess = false;
        vm.isActionPerformed = true;
        MessageService.error(AppConstants.ToastrMessage.PAYMENT_FAILED);
        return;
      }

      if ($stateParams.msg) {
        var msg = atob($stateParams.msg);
        vm.responseData = angular.fromJson(msg);
        vm.isSuccess = true;
        vm.isActionPerformed = false;
      }
    };

    vm.rejectTransaction = function () {
      $state.go('main.dashboard');
    };

    vm.approveTransaction = function () {

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isActionPerformed = true;
            MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
          } else {
            MessageService.error(resp.message);
            vm.isActionPerformed = false;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var version=($rootScope.apiVersion==HDFC_API.VERSION)?HDFC_API.VERSION:($rootScope.apiVersion);

      TransactionService.get({
        VERSION:version,
        controller: 'otp',
        child2: 'approve',
        uniqueLink:"c2a8467d-7448-4014-ae22-787bd430aa15"  //vm.uniqueLink
      }, null).$promise.then(success, error);
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BulkStatusController', BulkStatusController);

  /** @ngInject */
  function BulkStatusController($scope, $timeout, $state, $window, AppConstants, MessageService, BulkTransactionService, LoaderService,
                                UtilService, HDFC_API, ModalService) {
    var vm = this;
    vm.isReset = false;
    vm.selectedStatusType = null;
    vm.dateFilter = {startDate: null, endDate: null};
    vm.TRANSACTION_TYPES = [{key: 'SIP', value: 'SIP'}, {key: 'PURCHASE', value: 'PURCHASE'}];
    vm.transactionType = null;
    vm.transactionSettings = {displayProp: 'key', idProp: 'value', dynamicTitle: true, selectionLimit: 1};
    vm.transactionTranslationTexts = {buttonDefaultText: 'Transaction Type (All)'};
    vm.dateFilter = {startDate: $window.moment().subtract(14, 'days'), endDate: $window.moment()};
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;

    vm.bulkTransactionList = [];
    vm.bulkTransactionDetailList = [];

    vm.currentPageBulkList = 1;
    vm.currentPageBulkListDetails = 1;
    vm.currentSearchPageBulkList = 1;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.searchPageLimit = vm.PAGE_LIMITS[0];
    vm.detailPageLimit = vm.PAGE_LIMITS[0];

    vm.isPagination = false;
    vm.isDetailPagination = false;
    vm.searchPagination = false;
    vm.isSearching = false;
    vm.regexHtml = /(<([^>]+)>)/gi

    vm.status = {
      "sent for approval": "sent_for_approval",
      "approved by investor": "approved_by_investor",
      "rejected by investor": "reject_by_investor",
      "expired": "expired",
      "failed": "failed"
    };

    var bulkPayload = {
      "toDate" : vm.dateFilter.endDate.format("DD-MMM-YYYY"),
      "fromDate" : vm.dateFilter.startDate.format("DD-MMM-YYYY"),
      'pageIndex': vm.currentPageBulkList - 1,
      'pageLimit': vm.selectedPageLimit,
      "sortValue" : "DESC",
      'transactionType': null
    };

    var bulkDetailsPayload = {
      "transactionId" : "",
      "pageIndex": vm.currentPageBulkListDetails - 1,
      "pageLimit": vm.detailPageLimit,
      "sortValue": "DESC"
    };

    var bulkSearchPayload = {
      "investorNameOrFolioNum" : null,
      "pageIndex" : vm.currentSearchPageBulkList - 1,
      "pageLimit" : vm.searchPageLimit,
      "sortValue" : "DESC"
    };

    vm.transactionEvents = {
      onSelectionChanged: function () {
        resetDefaults();
        var trType = vm.transactionType;
        vm.selectedType = trType;
        reInitPayload();
        bulkPayload.transactionType = vm.transactionType;
        vm.getBulkList(bulkPayload);
      }
    };

    vm.getBulkList = getBulkList;
    vm.filterByDate = filterByDate;
    vm.fetchDetailedRecords = fetchDetailedRecords;
    vm.limitChanged = limitChanged;
    vm.searchBulkDetails = searchBulkDetails;
    vm.searchList = searchList;
    vm.searchLimitChanged = searchLimitChanged;
    vm.detailLimitChanged = detailLimitChanged;
    vm.showMore = showMore;
    vm.init = init;
    init();

    function init() {
      bulkPayload.pageIndex = vm.currentPageBulkList - 1;
      getBulkList(bulkPayload);
    }

    var resetDefaults = function () {
      vm.currentPageBulkList = 1;
      vm.currentPageBulkListDetails = 1;
      vm.currentSearchPageBulkList = 1;

      vm.totalBulkListData = 0;
      vm.totalBulkListDetailData = 0;
      vm.totalSearchListDetailData = 0;

      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.searchPageLimit = vm.PAGE_LIMITS[0];
      vm.isPagination = false;
      vm.isSearching = false;
      vm.searchText = null;
    };

    function getBulkList(payload) {
      LoaderService.showLoader();
      $(".panel-collapse").collapse('hide');
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.bulkTransactionList = resp.data.transactionDataList;
          vm.totalBulkListData = resp.data.totalTransactions;
          vm.isPagination = !!(vm.bulkTransactionList && vm.bulkTransactionList.length);
        } else {
          vm.bulkTransactionList = null;
          vm.totalBulkListData = 0;
          vm.isPagination = false;
          MessageService.error(resp.message);
        }
      }, error = function(error) {
        vm.isPagination = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(error);
      };
      BulkTransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'bulkTransaction',
        child2: 'fetch',
        child3: 'bulk',
        child4: 'transaction'
      }, payload).$promise.then(success, error);
    }

    var reInitPayload = function () {
      bulkPayload.fromDate = vm.dateFilter.startDate ? $window.moment(vm.dateFilter.startDate, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString() : '';
      bulkPayload.pageIndex = vm.currentPageSystematicList;
      bulkPayload.pageLimit = vm.selectedPageLimit;
      bulkPayload.transactionType =  null;
      bulkPayload.toDate = vm.dateFilter.endDate ? $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
      bulkPayload.investorNameOrFolioNum = null;
    };

    function limitChanged () {
      vm.currentPageBulkList = 1;
      bulkPayload.pageIndex = vm.currentPageBulkList;
      bulkPayload.pageLimit = vm.selectedPageLimit;
      vm.getBulkList(bulkPayload);
    }

    function searchLimitChanged() {
      vm.currentSearchPageBulkList = 1;
      bulkSearchPayload.pageIndex = vm.currentSearchPageBulkList;
      bulkSearchPayload.pageLimit = vm.searchPageLimit;
      vm.searchList(bulkPayload);
    }

    function detailLimitChanged() {
      vm.currentPageBulkListDetails = 1;
      bulkDetailsPayload.pageIndex = vm.currentPageBulkListDetails;
      bulkDetailsPayload.pageLimit = vm.detailPageLimit;
      vm.fetchDetailedRecords(bulkPayload);
    }

    function filterByDate(dateFilter) {
      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          getBulkList(bulkPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        getBulkList(bulkPayload);
      }
    }

    function fetchDetailedRecords(bulkRefNo, collapseId) {
      var isVisible = $("#"+ collapseId).is(':visible');
      $('.collapse').on('shown.bs.collapse', function(){
        $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
      }).on('hidden.bs.collapse', function(){
        $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
      });
      if (!isVisible) {
        bulkDetailsPayload.pageIndex = vm.currentPageBulkListDetails - 1;
        bulkDetailsPayload.transactionId = bulkRefNo;
        //vm.totalBulkListDetailData = 0;
        LoaderService.showLoader();
        var success = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.bulkTransactionDetailList = resp.data.transactionDetailList;
            vm.bulkTransactionDetailList.forEach(function(el) {
              if(el.statusDescription.match(vm.regexHtml)) {
                el.panAdharUrl = el.statusDescription;
                el.statusDescription = el.statusDescription.replace(vm.regexHtml, "");
              }
            })
            vm.totalBulkListDetailData = resp.data.totalTransactions;
            vm.isDetailPagination = !!(vm.bulkTransactionDetailList && vm.bulkTransactionDetailList.length);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function(error) {
          LoaderService.hideLoader();
          UtilService.errorHandler(error);
        };
        BulkTransactionService.post({
          VERSION: HDFC_API.VERSION,
          child1: 'bulkTransaction',
          child2: 'fetch',
          child3: 'bulk',
          child4: 'transaction',
          child5: 'detail'
        }, bulkDetailsPayload).$promise.then(success, error);
      }
    }

    function searchList() {
      if (vm.searchText.length > 3) {
        vm.isSearching = true;
        bulkSearchPayload.pageIndex = vm.currentSearchPageBulkList - 1;
        bulkSearchPayload.investorNameOrFolioNum = vm.searchText;
        vm.searchBulkDetails(bulkSearchPayload);
      } else {
        vm.isSearching = false;
      }
    }

    function searchBulkDetails(payload) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.searchListData = resp.data.transactionDetailList;
          vm.searchListData.forEach(function(el) {
            if(el.statusDescription.match(vm.regexHtml)) {
              el.panAdharUrl = el.statusDescription;
              el.statusDescription = el.statusDescription.replace(vm.regexHtml, "");
            }
          })
          vm.totalSearchListDetailData = resp.data.totalTransactions;
          vm.searchPagination = !!(vm.searchListData && vm.searchListData.length);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(error) {
        LoaderService.hideLoader();
        UtilService.errorHandler(error);
      };
      BulkTransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'bulkTransaction',
        child2: 'fetch',
        child3: 'filtered',
        child4: 'transaction',
        child5: 'detail'
      }, payload).$promise.then(success, error);
    }

    function showMore(message,panAdharPopup) {
      var popupMessage;
      var isPanAdharPopup = false;
      if(panAdharPopup) {
        isPanAdharPopup = true;
        popupMessage = panAdharPopup;
      } else {
        isPanAdharPopup = false;
        popupMessage = message;
      }
      ModalService.genericModal({
        text: popupMessage,
        isFromBulk: true,
        isPanAdharPopup : isPanAdharPopup
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('bulkTransactionSummary', bulkTransactionSummary);

  /*@ngInject*/
  function bulkTransactionSummary(AppConstants, BulkTransactionService, LoaderService, MessageService, UtilService,
                                  HDFC_API, ModalService, $state, $window) {
    return {
      restrict: 'E',
      scope: {formData: '=', isSummaryViewEnabled: '=', transactionType: '@', transactionSubType: '@'},
      templateUrl: 'app/transactions/initiate/bulk-transaction/summary/bulk-transaction.summary.html',
      link: function (scope) {
        scope.formValue = scope.formData;
        scope.sendForApproval = sendForApproval;
        scope.redirectToInitiate = redirectToInitiate;
        scope.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
        scope.searchList = searchList;
        scope.showMore = showMore;
        scope.collapseExpand = collapseExpand;
        scope.searchText = null;
        scope.folioDetailsWithNameCopy = scope.formValue.folioDetailsWithName;
        scope.date = $window.moment().format("DD-MMM-YYYY");

        if (scope.formValue.stats.SUCCESS === 0) {
          ModalService.genericModal({
            text: AppConstants.BULK_ALL_TRANSACTION_INVALID,
            isFromBulk: true
          });
        }

        function sendForApproval() {
          var payload = {};
          if (scope.transactionType === scope.TRANSACTION_FORM_TYPE.SIP) {
            payload = {
              "investmentOption": scope.formValue.investmentOption,
              "dividendOption": scope.formValue.dividendOption,
              "formType": scope.formValue.formType,
              "frequency": scope.formValue.frequency,
              "schemeCode": scope.formValue.schemeCode,
              "schemeType": scope.formValue.schemeType,
              "schemeName": scope.formValue.schemeName,
              "sipDay":null,
              "sipTopupEnabled": false,
              "totalRecord": scope.formValue.stats.TOTAL_COUNT,
              "successful": scope.formValue.stats.SUCCESS,
              "failure": scope.formValue.stats.FAILURE,
              "euinCode": scope.formValue.formData.euinCode,
              "toDate": scope.formValue.formData.toDate,
              "sipDate": scope.formValue.formData.sipDate,
              "bulkTransactionFolioAmountDTOList": scope.formValue.folioDetailsWithName,
              "payMech": "EC",
              "euinOpted": scope.formValue.euinOpted,
              "euinName": scope.formValue.euinName
            }
            if (scope.formValue.sipWithFirstInstallment) {
              payload.sipWithFirstInstallment = scope.formValue.sipWithFirstInstallment;
            }
          } else if (scope.transactionType === scope.TRANSACTION_FORM_TYPE.PURCHASE) {
            payload = {
              "investmentOption": scope.formValue.investmentOption,
              "dividendOption": scope.formValue.dividendOption,
              "formType": scope.formValue.formType,
              "schemeCode": scope.formValue.schemeCode,
              "schemeType": scope.formValue.schemeType,
              "schemeName": scope.formValue.schemeName,
              "totalRecord": scope.formValue.stats.TOTAL_COUNT,
              "successful": scope.formValue.stats.SUCCESS,
              "failure": scope.formValue.stats.FAILURE,
              "euinCode": scope.formValue.formData.euinCode,
              "bulkTransactionFolioAmountDTOList": scope.formValue.folioDetailsWithName,
              "euinOpted": scope.formValue.euinOpted,
              "euinName": scope.formValue.euinName
            }
          }

          if(scope.formValue.subBrokerArn){
            payload.subBrokerArn = 'ARN-'+scope.formValue.subBrokerArn;
          }
          if(scope.formValue.subBrokerCode){
            payload.subBrokerCode = scope.formValue.subBrokerCode;
          }

          payload.bulkTransactionFolioAmountDTOList.forEach(function(el) {
            if(el.panAdharUrl) {
              el.statusDescription = el.panAdharUrl;
              delete el.panAdharUrl;
            }
          })

          submitPurchaseRequest(payload);
        }

        function redirectToInitiate() {
          scope.isSummaryViewEnabled = false;
          $state.reload();
        }

        function submitPurchaseRequest(payload) {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              ModalService.bulkSuccess({
                transactionType: scope.transactionType
              }, function() {
                redirectToInitiate();
                $state.reload();
              });
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(error) {
            LoaderService.hideLoader();
            UtilService.errorHandler(error);
          };
          BulkTransactionService.post({
            VERSION: HDFC_API.VERSION,
            child1: 'bulkTransaction',
            child2: 'approve',
            child3: scope.transactionType.toLowerCase()
          }, payload).$promise.then(success, error);
        }

        function searchList() {
          if (scope.searchText.length > 3) {
            if (isNaN(scope.searchText)) { /*check if search text is a string*/
              scope.folioDetailsWithNameCopy = filterByInvestorName();
            } else if (!isNaN(scope.searchText)) { /*check if search text is a number*/
              scope.folioDetailsWithNameCopy = filterByFolioNumber();
            }
          } else if (scope.searchText.length === 0) {
            scope.folioDetailsWithNameCopy = scope.formValue.folioDetailsWithName;
          }
        }

        function filterByInvestorName() {
          var filteredList = scope.folioDetailsWithNameCopy.filter(function(details) {
            if (details.hasOwnProperty("investorName")) {
              return details.investorName.toLowerCase().includes(scope.searchText.toLowerCase());
            }
          });
          return filteredList;
        }

        function filterByFolioNumber() {
          var filteredList = scope.folioDetailsWithNameCopy.filter(function(details) {
            return details.folioNumber.includes(scope.searchText);
          });
          return filteredList;
        }

        function showMore(message,panAdharPopup) {
          var popupMessage;
          var isPanAdharPopup = false;
          if(panAdharPopup) {
            popupMessage = panAdharPopup;
            isPanAdharPopup = true;
          } else {
            popupMessage = message;
            isPanAdharPopup = false;
          }
          ModalService.genericModal({
            text: popupMessage,
            isFromBulk: true,
            isPanAdharPopup : isPanAdharPopup
          });
        }

        function collapseExpand() {
          $('.collapse').on('shown.bs.collapse', function(){
            $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
          }).on('hidden.bs.collapse', function(){
            $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
          });
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BulkInitiateController', BulkInitiateController);

  /** @ngInject */
  function BulkInitiateController($scope, $timeout, $state, AppConstants, MessageService, UtilService, LoaderService, SchemeService, $window,
                                  TransactionInitiateModel, TransactionService, HDFC_API, ModalService, BulkTransactionService, BulkTransactionUploadService,
                                  InvestorsCommonService , dynamicData) {
    var vm = this;
    $scope.$parent.BulkTransaction.tabs[0].active = true;
    $scope.$parent.BulkTransaction.tabs[1].active = false;
    vm.startDate = null;
    vm.viewMode = 'days';
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.startMaxDate = $window.moment().add(350, 'days');
    vm.enabledStartDates = [];
    vm.endDate = null;
    vm.sipDay = null;
    vm.enabledEndDates = [];
    vm.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.EUIN_OPTED = AppConstants.EUIN_OPTED;
    vm.SIP_FREQ_LIST = AppConstants.Dynamic_BULK_SIP_FREQ_LIST;
    vm.formData = TransactionInitiateModel.getSipPurchaseBulkPayload();
    vm.formData.investmentType = vm.TRANSACTION_FORM_TYPE.PURCHASE;
    vm.isSummaryViewEnabled = false;
    var _isSelectingFromDropDown = false;
    vm.mimeType = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

    vm.changeInvestmentType = changeInvestmentType;
    vm.euinChanged = euinChanged;
    vm.uploadFile = uploadFile;
    vm.submitBulkSubmission = submitBulkSubmission;
    vm.termsAndContitions = termsAndContitions;
    vm.cancelTransaction = cancelTransaction;
    vm.reInitiateFileSelect = reInitiateFileSelect;
    vm.dynamicDataSip = dynamicData.noteDTO.noteDTOMap.Note_Sip_Bulk;
    vm.dynamicDataPurchase = dynamicData.noteDTO.noteDTOMap.Note_Purchase_Bulk;

    /*purchase method declarations*/
    vm.filterPurchaseInSchemeList = filterPurchaseInSchemeList;
    vm.openPurchaseSchemesModal = openPurchaseSchemesModal;
    vm.purchaseInSchemeChanged = purchaseInSchemeChanged;
    vm.tpv = tpv;

    /*SIP methods declarations*/
    vm.selectSipScheme = selectSipScheme;
    vm.openSipSchemesModal = openSipSchemesModal;
    vm.filterSipSchemeList = filterSipSchemeList;
    vm.changeFrequency = changeFrequency;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.showTerms = false;
    vm.changeFirstInstallment = changeFirstInstallment;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;

    init();

    /****************** Common methods for both SIP and PURCHASE **********************/
    function init() {
      getEuinCodes();
      fetchPurchaseEnabledSchemes();
       var successHandler = function(resp) {
         vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
         vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
       }

       UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
       });
    }

    function changeInvestmentType() {
      var investmentType = vm.formData.investmentType;
      var euinOpted = vm.formData.euinOpted;
      var euinCode = vm.formData.euinCode;
      var minorFlag = vm.formData.minorFlag;
      var schemeType = vm.formData.schemeType;
      resetAllPayloads();
      vm.formData.investmentType = investmentType;
      vm.transactionType = investmentType;
      if (investmentType === 'SIP') {
        fetchSipEnabledSchemes();
        vm.formData.sipDividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
      } else if (investmentType === 'PURCHASE') {
        fetchPurchaseEnabledSchemes();
      }
      vm.formData.euinOpted = euinOpted;
      vm.formData.euinCode = euinCode;
      vm.formData.minorFlag = minorFlag;
      vm.formData.schemeType = schemeType;
      vm.formData.frequency = vm.SIP_FREQ_LIST[2].code;
      vm.selectedFrequency = vm.SIP_FREQ_LIST[2];
      vm.formData.sipFirstInstallment = false;
    }

    function resetAllPayloads() {
      vm.formData = TransactionInitiateModel.getSipPurchaseBulkPayload();
      TransactionInitiateModel.setSipPurchaseBulkPayload(vm.formData);
      vm.isCheckedTandC = false;
      vm.endDateSelectionOption = false;
      vm.myFile = null;
      vm.formData.bulkFile = null;
      vm.subBrokerCodeError = '';
      if(vm.subBrokerName){
        vm.subBrokerName = '';
        vm.fetchEuinListSubBroker();
      }
    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
          vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function euinChanged() {
      var filterEuin = vm.euinList.filter(function (euin) {
        return euin.euinCode == vm.formData.euinCode;
      })[0]
      vm.formData.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinNameSelected = vm.formData.euinName;
    }

    function uploadFile(file) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("Please upload valid file for processing.");
          return;
        }
        vm.myFile = file;
        vm.formData.bulkFile = file.name
      }
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    /******************************* Common methods ends here ***************************************/
    /******************************* Purchase Methhods **********************************************/
    function fetchPurchaseEnabledSchemes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterPurchaseInSchemeList = resp.data.schemeList;
          if (vm.purchasePayload && vm.purchasePayload.schemeCode && vm.masterPurchaseInSchemeList.length) {
            var result = vm.masterPurchaseInSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.purchasePayload.schemeCode;
            });
            vm.purchaseScheme = result && result.scheme || null;
            vm.formData.inSchemeName = result.scheme;
            vm.formData.schemeType = result.schemeType;
            fetchPurchaseSchemeValidations(vm.purchasePayload.schemeCode);
          }
          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.purchaseScheme);
        } else {
          vm.masterPurchaseInSchemeList = null;
          vm.purchaseInSchemeList = null;
          vm.purchaseScheme = null;
          vm.formData.schemeType = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.masterPurchaseInSchemeList = null;
        vm.purchaseInSchemeList = null;
        vm.purchaseScheme = null;
        vm.formData.schemeType = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload= {
        transactionType: vm.formData.investmentType,
        flowName: 'BULK_TRANSACTION',
        schemeType: 'ALL'
      };
      SchemeService.post({
        controller: 'bulkTrasnaction',
        child1: 'schemeList'
      }, payload).$promise.then(success, error);
    }

    function openPurchaseSchemesModal() {
      var success = function (result) {
        if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
          vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        vm.selectedSchemeType = result.selectedSchemeType;
        vm.formData.inSchemeCode = result.schemeCode;
        vm.formData.inSchemeName = result.scheme;
        vm.formData.schemeType = result.schemeType;
        if (result.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        fetchPurchaseSchemeValidations(result.schemeCode);
      }, error = function () {
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
      };
      ModalService.schemeListModal({
        enabledScheme: "purchaseenabled",
        isMinor: true,
        transactionType: 'bulkPurchase'
      }, success, error);
    }

    function filterPurchaseInSchemeList() {
      vm.formData.inSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.formData.paymentMode = '';
    }

    function purchaseInSchemeChanged(schemeData) {
      vm.formData.isAutoSwitch = false;
      _isSelectingFromDropDown = true;
      if (!schemeData) {
        return;
      } else {
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && vm.investorInfo && !vm.investorInfo.retirementFundApplicable) {
          vm.showChequeLeaf = true;
        } else vm.showChequeLeaf = false;
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchPurchaseSchemeValidations(vm.formData.inSchemeCode);
      }
      $timeout(function () {
        _isSelectingFromDropDown = false;
      }, 0)
    }

    function fetchPurchaseSchemeValidations(schemeCode) {
      vm.purchaseValidations = null;
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.purchaseValidations = resp.data;
          vm.formData.cgfFlag=vm.purchaseValidations.cgfFlag;
          vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.purchaseInvestmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.purchaseInvestmentOption || AppConstants.TRANSACTION.DIVIDEND);
          if (vm.purchaseValidations.isGrowth) {
            vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false) {
              vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
              vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
              vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            }
          }
        } else {
          MessageService.error(resp.message);
          vm.purchaseValidations = null;
          vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.purchaseInvestmentOption = AppConstants.TRANSACTION.GROWTH;
        }
        if (vm.selectedSchemeType == 'ELSS' && !vm.purchaseValidations.isGrowth) {
          vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
      },
      error = function (err) {
        vm.purchaseValidations = null;
        if (vm.selectedSchemeType == 'ELSS' && !vm.purchaseValidations.isGrowth) {
          vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        else {
          vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
        }
        vm.formData.purchaseInvestmentOption = AppConstants.TRANSACTION.GROWTH;
        UtilService.errorHandler(err);
      };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'purchase',
        child1: schemeCode
      }, null).$promise.then(success, error);
    }

    function submitBulkSubmission() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.isSummaryViewEnabled = true;
          var regexHtml = /(<([^>]+)>)/gi
          vm.summaryData = resp.data;
          vm.summaryData.folioDetailsWithName.forEach(function(el) {
            if(el.statusDescription.match(regexHtml)) {
              el.panAdharUrl = el.statusDescription;
              el.statusDescription = el.statusDescription.replace(regexHtml, "");
            }
          })
          vm.summaryData.formType = vm.formData.investmentType;
          vm.summaryData.schemeCode = vm.formData.inSchemeCode;
          vm.summaryData.dividendOption = vm.formData.purchaseDividendOption;
          vm.summaryData.schemeType = vm.formData.schemeType;
          vm.transactionType = vm.formData.investmentType;
          vm.summaryData.schemeName = vm.formData.inSchemeName;
          vm.summaryData.investmentOption = vm.formData.investmentOption;
          vm.summaryData.euinOpted = vm.formData.euinOpted;
          vm.summaryData.euinName = vm.euinNameSelected;
          if(vm.formData.subBrokerARN){
            vm.summaryData.subBrokerArn = vm.formData.subBrokerARN;
          }
          if(vm.formData.subBrokerCode){
            vm.summaryData.subBrokerCode = vm.formData.subBrokerCode;
          }
          if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
            vm.summaryData.frequency = vm.formData.frequency;
            vm.summaryData.dividendOption = vm.formData.dividendOption;
            if (vm.formData.sipFirstInstallment) {
              vm.summaryData.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(error) {
        LoaderService.hideLoader();
        UtilService.errorHandler(error);
      };
      var payload = vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE ? createPurchasePayload(): createSipPayload();
      BulkTransactionUploadService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'bulkTransaction',
        child2: 'upload'
      }, payload).$promise.then(success, error);
    }

    function createPurchasePayload() {
      var formDetail = {
        "dividendOption": vm.formData.purchaseDividendOption,
        "formType": vm.formData.investmentType,
        "schemeCode": vm.formData.inSchemeCode,
        "schemeName" : vm.formData.inSchemeName,
        "euinOpted": vm.formData.euinOpted,
        "euinName": vm.euinNameSelected,
        "euinCode": vm.formData.euinCode
      };
      if(vm.formData.subBrokerARN){
        formDetail.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        formDetail.subBrokerCode = vm.formData.subBrokerCode;
      }
      var fd = new FormData();
      fd.append("file", vm.myFile);
      fd.append('formData', $window.JSON.stringify(formDetail));
      fd.append('transactionType', vm.formData.investmentType);
      return fd;
    }

    /******************************* SIP methods ****************************************************/
    /*
    * Function responsible to fetch SIP schemes
    * */
    function fetchSipEnabledSchemes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterSipSchemeList = resp.data.schemeList;
          if (vm.sipPayload && vm.sipPayload.schemeCode && vm.masterSipSchemeList.length) {
            var result = vm.masterSipSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.sipPayload.schemeCode;
            });
            vm.sipScheme = result && result.scheme || null;
            vm.formData.inSchemeName = vm.sipScheme;
            fetchSipSchemeValidations(vm.sipPayload.schemeCode);
          }
          vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
        } else {
          vm.sipSchemeList = null;
          vm.masterSipSchemeList = null;
          vm.sipScheme = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.sipSchemeList = null;
        vm.masterSipSchemeList = null;
        vm.sipScheme = null;
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader();
      var payload= {
        transactionType: vm.formData.investmentType,
        flowName: 'BULK_TRANSACTION',
        schemeType: 'ALL'
      };
      SchemeService.post({
        controller: 'bulkTrasnaction',
        child1: 'schemeList'
      }, payload).$promise.then(success, error);
    }

    function openSipSchemesModal() {
      var success = function (result) {
        if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
          vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        vm.selectedSchemeType = result.selectedSchemeType;
        vm.formData.inSchemeCode = result.schemeCode;
        vm.formData.inSchemeName = result.scheme;
        vm.formData.schemeType = result.schemeType;
        fetchSipSchemeValidations(result.schemeCode);
        changeStartDate();
      }, error = function () {
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
      };
      ModalService.schemeListModal({
        enabledScheme: "sipenabled",
        isMinor: true,
        transactionType: 'bulkSip'
      }, success, error);
    }

    function filterSipSchemeList() {
      vm.formData && (vm.formData.inSchemeCode = '');
      vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
    }

    function fetchSipSchemeValidations(schemeCode) {
      vm.sipValidationsData = null;
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.sipValidationsData = resp.data;
          vm.SIP_FREQ_LIST = vm.sipValidationsData.additionalValidation.frequency?vm.sipValidationsData.additionalValidation.frequency:null;
            var frequency = vm.SIP_FREQ_LIST.find(function (d) {
              return d.code === 'OM';
            }) || {};
            vm.selectedFrequency = frequency?frequency:'';
          vm.formData.cgfFlag = vm.sipValidationsData.cgfFlag;
          vm.formData.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
          if (vm.sipValidationsData.isGrowth) {
            vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
          } else {
            if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === false) {
              vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.sipValidationsData.dividendPayoutApplicable === false && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
              vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
              vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            }
          }
          getDateValidation();
          extractSipValidationObject(resp.data, vm.selectedFrequency);
        } else {
          MessageService.error(resp.message);
          vm.sipValidationsData = null;
          vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
          vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
        }
      }, error = function (err) {
        vm.sipValidationsData = null;
        if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
          vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        else {
          vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
        }
        vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
        UtilService.errorHandler(err);
      };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'sip',
        child1: schemeCode, child2: 'BULK_SIP'
      }, null).$promise.then(success, error);
    }

    function selectSipScheme(data) {
      if (!data) {
        return;
      } else {
        vm.formData.inSchemeName = data.scheme;
        vm.formData.inSchemeCode = data.schemeCode;
        vm.formData.schemeType = data.schemeType;
        if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && vm.investorInfo && !vm.investorInfo.retirementFundApplicable) {
          vm.showChequeLeaf = true;
        } else {
          vm.showChequeLeaf = false;
        }
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
        changeFrequency();
        fetchSipSchemeValidations(data.schemeCode);
        changeStartDate();
        if(data.schemeType === "NFO"){
          var message = data.message;
          ModalService.nfoEnabledModal({message: message});
        }

      }
      $timeout(function () {
        _isSelectingFromDropDown = false;
      }, 0)
    }

    function changeFrequency() {
      vm.formData.installment = '';
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      vm.endDateSelectionOption = false;
      vm.formData.startDate = null;
      vm.sipDay = null;
      vm.formData.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.sipDay = null;
      vm.formData.sipFirstInstallment=false;
      extractSipValidationObject(vm.sipValidationsData, vm.selectedFrequency);
      vm.formData.frequency = vm.selectedFrequency.code;
      if (vm.selectedFrequency && vm.selectedFrequency.code === 'BZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.formData.sipTopupSelected = false;
      } else if (vm.selectedFrequency && vm.selectedFrequency.code === 'OM') {
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'months';
        vm.startDateFormat = 'DD-MMM-YYYY';
        vm.formData.sipTopupSelected = false;
      } else {
        vm.daysList = AppConstants.SIP_DAYS_LIST;
        vm.viewMode = 'months';
        vm.startDateFormat = 'DD-MMM-YYYY';
        vm.formData.sipTopupSelected = false;
      }
      vm.sipStartMonth = null;
      getDateValidation();
    }

    function getDateValidation(cb){
      cb = cb || function () {};
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      vm.endDateSelectionOption = false;
      var success = function (resp) {
        vm.enabledOTMStartDatesList = [];
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var todayDate = $window.moment(resp.data.currentDate);
          vm.startMinDate = $window.moment(resp.data.currentDate, "DD-MMM-YYYY").add(vm.sipValidationsData.sipTDay, 'days');//T+10+7+2
          var startDate = todayDate.clone();
          var freq = $window.moment(vm.startMaxDate).diff(todayDate, 'days');
          var counter=0;
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            if(counter<7) {
              angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') == 0) {
                  isEnable = false;
                }
              });
            }
            if(isEnable){
              vm.enabledStartDates.push(indexDate);
              counter++;
            }
          }
          vm.startMaxDate = $window.moment($window.moment(resp.data.currentDate, "DD-MMM-YYYY").add(90, 'days'), "DD-MMM-YYYY").clone();
          if(vm.enabledStartDates && vm.enabledStartDates.length > 0 && vm.formData.frequency !== 'OW'){
            vm.formData.startDate = angular.copy($window.moment(vm.startMinDate, "DD-MMM-YYYY"));
            updateEndDates();
          }
          vm.resetting = false;
          cb(true);
        } else {
          MessageService.error(resp.message);
          vm.resetting = false;
          cb(false);
        }
      }, error = function (err) {
        vm.resetting = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        cb(false);
      };
      LoaderService.showLoader();
      InvestorsCommonService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    function changeStartDate (date) {
      vm.formData.startDate = date ? date : null;
      vm.sipDay = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      vm.formData.endDate = null;
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      /*$timeout(function () {
        vm.resetting = false;
      });*/
      updateEndDates();
    }

    function changeEndDate(date) {
      vm.formData.endDate = date ? date : null;
      if($window.moment(vm.endDateDefaultForPertuity).isSame(vm.formData.endDate)){
        vm.endDateSelectionOption = true;
      } else {
        vm.endDateSelectionOption = false;
      }
    }

    function extractSipValidationObject(validationsData, frequency) {
      if (!validationsData || !frequency) {
        return;
      }
      vm.sipValidations = {};
      switch (frequency.code) {
        case 'BZ':
          vm.sipValidations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          vm.sipValidations.minInstallments = validationsData.additionalValidation.BZ;
          // vm.sipValidations.minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          vm.sipValidations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          vm.sipValidations.minInstallments = validationsData.additionalValidation.OW;
          // vm.sipValidations.minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          vm.sipValidations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.sipValidations.minInstallments = validationsData.additionalValidation.Q;
          // vm.sipValidations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.sipValidations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.sipValidations.minInstallments = validationsData.additionalValidation.OM;
          // vm.sipValidations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.sipValidations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.sipValidations.minInstallments = validationsData.additionalValidation.H;
          // vm.sipValidations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.sipValidations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.sipValidations.minInstallments =  validationsData.additionalValidation.Y;
          // vm.sipValidations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      var s = vm.sipValidations.minInstallments[0].min_installments;
      vm.sipValidations.minInstallments.forEach(function (val, key) {
          if(val.min_installments < s){
            s = val.min_installments;
          }
      });
      vm.sipValidations.minInstallments = s;
      vm.sipValidations.isGrowth = validationsData.isGrowth;
      vm.sipValidations.endingType = validationsData.endingType;
    }

    vm.changeTillPerpetuityFlag = function () {
      vm.formData.endDate = null;
      vm.resetting = false;
      if (vm.endDateSelectionOption) {
        var defaultMonths = null;
        // var endDate = $window.moment(new Date("12/31/2099"));
        var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
        vm.formData.startDate = $window.moment(vm.formData.startDate);
        var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
        var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
        var newEndDate = day + '/'+ (month + 1) +'/2099';
        var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
        switch (vm.selectedFrequency.code) {
          case'BZ':
            var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
            if(endDateYear > 2099){
              endDateYear = 2099;
            }
            var newEndDateForDaily = day + '/'+ (month + 1) +'/' + endDateYear;
            vm.formData.endDate = $window.moment(newEndDateForDaily, "DD-MM-YYYY");

            //check end date exists between enabled end dates
            var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
            if (!isBetween) {
              if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
              }else {
                endDateYear = endDateYear - 1;
                var dailyNewDate = day + '/'+ (month + 1) +'/' + endDateYear;
                vm.formData.endDate = $window.moment(dailyNewDate, "DD-MM-YYYY");
              }
            }
            break;
          case'OW':
            // defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, $window.moment(endDate));
            // freq = freq || Math.floor((defaultMonths * 30) / vm.selectedFrequency.duration) * vm.selectedFrequency.duration;
            // vm.formData.endDate = vm.formData.startDate.clone().add(freq, 'days');
            var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
            endDate = new Date(weeklyEndate);
            var startDate = vm.formData.startDate.toDate();
            // var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
            var weeksDiff = UtilService.getNumberOfWeeks(startDate,endDate);
            vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff*7, 'days');
            break;
          default :
            var newday = $window.moment().date();
            var newMonth = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
            var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
            var endDateCal = $window.moment(newEndDateCal, "DD-MM-YYYY");

            if (!moment(endDateCal).isValid()) {
              var initialStartDate = vm.formData.startDate.clone().day(1)
              endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
            }

            // var months = 0;
            defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(vm.selectedFrequency, 'months'), $window.moment(endDateCal));
            freq = freq || Math.floor(defaultMonths / vm.selectedFrequency.duration);
            freq = vm.sipValidations && vm.sipValidations.maxInstallments ? freq - 1 : freq;
            var months = vm.selectedFrequency.duration * freq;
            vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');
            var calculatedEndDateMonth = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

            if(calculatedEndDateMonth > month) {
              var endDateCalculated = angular.copy(vm.formData.endDate);
              var checkDate = angular.copy(endDateCalculated.set('month', month));

              var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
              if (DateisBetween) {
                vm.formData.endDate = checkDate;
              }

            }
            break;
        }

        if (vm.sipValidations && vm.sipValidations.maxInstallments) {
          var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
          var EndDatemonth = angular.copy($window.moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
          var EndDateYear = angular.copy($window.moment(lastEndDate, 'DD-MMM-YYYY').year());

          var EndDateCalculatedMonth = angular.copy($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
          var EndDateCalculatedYear = angular.copy($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

          if (EndDateCalculatedYear <= EndDateYear) {
            if (EndDatemonth < EndDateCalculatedMonth) {
              if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                EndDateYear = EndDateYear - 1;
                var newEndDateCheck = day + '/'+ (month + 1) +'/' + EndDateYear;
                vm.formData.endDate = $window.moment(newEndDateCheck, "DD-MM-YYYY");
              }
              var isBetweenCheck = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetweenCheck) {
                vm.formData.endDate = angular.copy(lastEndDate);
              }
              if (EndDateYear > 2099) {
                vm.formData.endDate.set('year', 2099);
              }
            } else if (EndDatemonth === EndDateCalculatedMonth) {
              if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                EndDateYear = EndDateYear - 1;
                var newEndDateChecking = day + '/'+ (month + 1) +'/' + EndDateYear;
                vm.formData.endDate = $window.moment(newEndDateChecking, "DD-MM-YYYY");
              }
              var isBetweenChecking = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetweenChecking) {
                vm.formData.endDate = angular.copy(lastEndDate);
              }
              if (EndDateYear > 2099) {
                vm.formData.endDate.set('year', 2099);
              }
            }else {
              if (EndDateYear > 2099) {
                vm.formData.endDate.set('year', 2099);
              }
            }
          } else if ((EndDateCalculatedYear > EndDateYear)) {
            if (EndDateCalculatedYear <= 2099) {
              vm.formData.endDate.set('year', EndDateYear);
            } else {
              vm.formData.endDate.set('year', 2099);
            }

          }
        }
        vm.endDateDefaultForPertuity = vm.formData.endDate;
        changeEndDate(vm.formData.endDate);
      } else {
        // vm.formData.startDate && updateEndDates();
      }
    }

    function updateEndDates(installment) {
      if (vm.isTillPerpetuity || !vm.formData.startDate) {
        return;
      }
      var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
      var i = 0, minInstallments = 1;
      switch (vm.selectedFrequency.code) {
        case'BZ':
          var days = 0;
          endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          var days = getMonthsCount(endDate.clone(), defaultEndDate);
          freq = ((defaultMonths * 30) / vm.selectedFrequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        case'OW':
          days = 0;
          endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.duration);
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          minInstallments = (vm.sipValidations && vm.sipValidations.minInstallments) ? vm.sipValidations.minInstallments : 1;
          var installmentTotal = vm.selectedFrequency.code == 'Q' ? ((minInstallments * 3) - 1) : ((minInstallments * 1) - 1);
          defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.duration);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(months, 'months'));
          }
          break;
      }
      if (!installment) {
        minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 1) || 0;
        vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      } else {
        vm.enabledEndDates = enabledEndDates;
      }
      vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
      if (vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
        if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
          vm.endDateSelectionOption = true;
        } else {
          vm.endDateSelectionOption = false;
        }
      }else {
        vm.formData.endDate = null;
        vm.endDateSelectionOption = true;
        vm.changeTillPerpetuityFlag()
      }
    }

    function createSipPayload() {
      var formDetail = {
        "investmentOption": vm.formData.investmentOption,
        "dividendOption": vm.formData.dividendOption,
        "formType": vm.formData.investmentType,
        "frequency": vm.selectedFrequency.code,
        "sipDay": null,
        "sipTopupEnabled": false,
        "toDate": vm.formData.endDate.format("DD-MMM-YYYY"),
        "sipDate": vm.formData.startDate.format("DD-MMM-YYYY"),
        "schemeCode": vm.formData.inSchemeCode,
        "schemeName" : vm.formData.inSchemeName,
        "euinOpted": vm.formData.euinOpted,
        "euinName": vm.euinNameSelected,
        "euinCode": vm.formData.euinCode
      };
      if (vm.formData.sipFirstInstallment) {
        formDetail.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
      }
      if (vm.formData.subBrokerARN) {
        formDetail.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if (vm.formData.subBrokerCode) {
        formDetail.subBrokerCode = vm.formData.subBrokerCode;
      }
      var fd = new FormData();
      fd.append("file", vm.myFile);
      fd.append('formData', $window.JSON.stringify(formDetail));
      fd.append('transactionType', vm.formData.investmentType);
      return fd;
    }
    function cancelTransaction() {
      var success = function () {
        $state.go('main.dashboard')
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Are you sure, you want to cancel this action?'}, success, error);
    }

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function reInitiateFileSelect() {
      vm.myFile = null;
    }

    function changeFirstInstallment(isSelected) {
      if (isSelected) {
        vm.formData.sipFirstInstallment = true;
      } else {
        vm.formData.sipFirstInstallment = false;
      }
      getDateValidation();
    }

    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
            vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
            vm.formData.euinName = vm.euinNameSelected;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      if(vm.formData.subBrokerARN){
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          controller: 'getEuin',
          child2: 'ARN-' + vm.formData.subBrokerARN,
          isSubBroker: true
        }).$promise.then(success, error);
      }
    }
  }
})();



(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SelectSchemeController', SelectSchemeController);

  /** @ngInject */
  function SelectSchemeController($rootScope, LoaderService, $location, ChangeDividendService, $window, AuthService, $log, AppConstants, MessageService, $state, UtilService, InvestorServiceDynamicData) {
    var vm = this;
    vm.$state = $state;
    vm.showDetails = false;
    vm.DirectScheme = true;
    vm.filterwithname = "";
    vm.init = init;
    vm.selectedscheme = {};
    vm.setGetDraftData = setGetDraftData;
    vm.GetSchemeCategoryList = GetSchemeCategoryList;
    vm.GetSchemeCategoryDetailsList = GetSchemeCategoryDetailsList;
    vm.schemeCategoryDetailsList = [];
    vm.schemeCategoryList = [];
    vm.selectedschemeCategoryDetails;
    vm.saveDraftPayload = {};
    vm.selectedschemeCategory;
    $rootScope.currentstate = $state.current.url;
    vm.selectedYourScheme = "";
    vm.hideArnTogg = true;
    var identifierData = AuthService.getToken();
    sessionStorage.removeItem("onotp");
    vm.closeSession = function () {
      sessionStorage.removeItem("verifyObj");
      AuthService.clearCookies(AppConstants.IDENTIFIER);
      $rootScope.refreshme = true;
      $state.go('main.newinvestor.kycverify');
    }

    vm.toggleDetails = function (index) {
      vm.selectedschemeCategoryDetails[index].Expand = !vm.selectedschemeCategoryDetails[index].Expand;
    }
    vm.getScheme = function (scheme) {
      if (scheme.selectedScheme) {
        $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = true;
          $rootScope.stepperSecondary.steps[1].stepCompleted = false;
        var verifyObjData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
        vm.saveDraftPayload.panNumber = verifyObjData.pan;
        vm.saveDraftPayload.investmentGoal = null;
        vm.saveDraftPayload.fundName = scheme.fundName;
        vm.saveDraftPayload.fundCategory = vm.selectedschemeCategory;
        if (!scheme.selectedScheme.schemeCode) {
          var SchemeData = JSON.parse(scheme.selectedScheme);
        } else {
          var SchemeData = scheme.selectedScheme;
        }

        vm.saveDraftPayload.schemeCode = SchemeData.schemeCode;
        vm.saveDraftPayload.investmentOption = SchemeData.investmentOption;
        vm.saveDraftPayload.schemeName = SchemeData.schemeName;
        vm.saveDraftPayload.schemeType = SchemeData.schemeType;
        vm.saveDraftPayload.purchaseEnabled = SchemeData.purchaseEnabled;
        vm.saveDraftPayload.sipEnabled = SchemeData.sipEnabled;
        vm.saveDraftPayload.step = "FIRST";
        vm.saveDraftPayload.brokerCode = identifierData.arnCode;
        LoaderService.showLoader();
        var success = function (resp) {
          if (resp.data && resp.status) {
            var data = resp.data;
            var Details = JSON.parse(sessionStorage.getItem("userData"));
            if (Details || !Details.transactionDraftId) {
              var details = {};
              details.transactionDraftId = data.id;
              $window.sessionStorage.setItem("userData", JSON.stringify(details));
              $rootScope.stepperSecondary.steps[0].stepActive = false;
              $rootScope.stepperSecondary.steps[0].stepCompleted = true;
              $rootScope.stepperSecondary.steps[1].stepActive = true;
            }
            $state.go('main.newinvestor.investmentDetails.investmentMode');
            updateSiebarScheme();
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
          error = function () {
            LoaderService.hideLoader();
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        ChangeDividendService.post({
          child1: 'v2',
          child2: 'distributorNewInvestor',
          child3: 'save',
          child4: 'transaction'
        }, vm.saveDraftPayload).$promise.then(success, error);
      }
      else {
        alert("Please select scheme");
      }
    }

    // setDraftData
    function setGetDraftData() {

      if (vm.schemeCategoryDetailsList && vm.schemeCategoryList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
          }
        })
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        if (Details.transactionDraftId) {
          LoaderService.showLoader();
          var success = function (resp) {
            if (resp.data && resp.status) {
              if (resp.data.fundCategory) {
                vm.selectedschemeCategory = resp.data.fundCategory;
                vm.saveDraftPayload = resp.data;
                vm.selectedscheme.schemeCode = resp.data.schemeCode;
                vm.schemeCategoryDetailsList.forEach(function (res) {
                  if (vm.selectedschemeCategory == res.type) {
                    var tempArray = [];
                    res.funds.forEach(function (res1) {
                    var filteredArray = res1.regularSchemes.filter(function(itm){
                        return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                      });
                    if(filteredArray.length == 1){
                      res1.selectedScheme = {};
                      res1.selectedScheme = filteredArray[0];
                    }else{
                      res1.selectedScheme = null;
                    }
                      tempArray.push(res1);
                    });
                    // vm.selectedschemeCategoryDetails = tempArray;
                    tempArray = tempArray.sort(function (a, b) {
                      if (a.selectedScheme === null) // a is null? last
                        return 1;
                      else (b.selectedScheme === null) // b is null? last
                      return -1;
                    })
                    vm.selectedschemeCategoryDetails = tempArray;
                  }
                })
              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          },
            error = function (err) {
              LoaderService.hideLoader();
              MessageService.error(err.data.message);
            };
          vm.processFlag = false;
          var arnCode = identifierData.arnCode;
          var Data = {};
          Data.id = Details.transactionDraftId;
          Data.arnCode = arnCode;
          ChangeDividendService.post({
            child1: 'v2',
            child2: 'distributorNewInvestor',
            child3: 'saved',
            child4: 'draft'
          }, Data).$promise.then(success, error);
        }
        LoaderService.hideLoader();
      }
      //  stop
    }
    function init() {
      LoaderService.showLoader();
      updateSiebar();
      vm.GetSchemeCategoryList();
      vm.GetSchemeCategoryDetailsList();
    }
    // get scheme category  list
    function GetSchemeCategoryList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCategoryList = resp.data;
          vm.selectedschemeCategory = vm.schemeCategoryList[0];
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      InvestorServiceDynamicData.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category',
        child5: 'list',
        nriFlag:  vm.nriTaxStatus
      },{}).$promise.then(success, error);
    }
    // get scheme category details list
    function GetSchemeCategoryDetailsList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.schemeCategoryDetailsList = resp.data;
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      InvestorServiceDynamicData.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category',
        nriFlag:  vm.nriTaxStatus
      }).$promise.then(success, error);
    }

    // change scheme Category
    vm.changeSchemeCategory = function () {
      vm.selectedschemeCategoryDetails = [];
      if (vm.schemeCategoryDetailsList) {
          vm.schemeCategoryDetailsList.forEach(function (res) {
            if (vm.selectedschemeCategory == res.type) {
              vm.selectedschemeCategoryDetails = [];
              res.funds.forEach(function (res) {
                res.Expand = false;
                vm.selectedschemeCategoryDetails.push(res);
              })
            }
          })
      }
    }
    vm.changewithFilterName = function () {
      if (vm.schemeCategoryDetailsList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
            if (vm.filterwithname) {
              var filterschemarray = [];
              vm.selectedschemeCategoryDetails.forEach(function (filterlist) {
                var fundName = new String(filterlist.fundName.toUpperCase());
                var filterName = new String(vm.filterwithname.toUpperCase());
                if (fundName.indexOf(filterName) > -1) {
                  filterschemarray.push(filterlist);
                }
              });
              vm.selectedschemeCategoryDetails = filterschemarray;
            }
          }
        })
      }
    }





    vm.togScheme = function () {
        vm.DirectScheme = !vm.DirectScheme;
        vm.schemeCategoryDetailsList.forEach(function (res) {
        if (vm.selectedschemeCategory == res.type) {
          var tempArray = [];
          res.funds.forEach(function (res1) {
            res1.selectedScheme = null;
            tempArray.push(res1);
          });
          vm.selectedschemeCategoryDetails = tempArray;
        }
      })
    }

    function updateSiebar() {
      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].investorName = uContext.name;
      $rootScope.testObj.steps[0].panNumber = uContext.pan;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepActive = true;
      $rootScope.testObj.steps[2].stepActive = false;
      vm.nriTaxStatus = uContext.nriTaxStatus;
    }
    function updateSiebarScheme(){
      $rootScope.testObj.steps[1].schemeName = vm.saveDraftPayload.schemeName;
    }
  }
})();



(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('InvestmentGoalController', InvestmentGoalController);

  /** @ngInject */
  function InvestmentGoalController($window, $rootScope, $state,ChangeDividendService, $scope, $timeout, AuthService, LoaderService, AppConstants, MessageService, ModalService, InvestorFileUploadService,UtilService,InvestorServiceDynamicData) {
    var vm = this;
    vm.$state = $state;
    vm.init = init;
    vm.DirectScheme = true;
    vm.GetInvestmentGoalList = GetInvestmentGoalList;
    vm.categoryDetailsList = categoryDetailsList;
    vm.InvestmentGoalList = [];
    vm.changeScheme = changeScheme;
    vm.setGetDraftData = setGetDraftData;
    vm.selectedInvestmentGoal = {};
    vm.selectedCard  = false;
    $rootScope.currentstate = $state.current.url;
    vm.saveDraftPayload = {};
    vm.selectedInvestmentGoalName = "Wealth Creation";
    vm.selectedscheme = null;
    vm.hideArnTogg = true;
    var identifierData = AuthService.getToken();
    var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = uContext.nriTaxStatus;
    function init() {
      LoaderService.showLoader();
      vm.selectedCard = false
      vm.GetInvestmentGoalList();
      vm.categoryDetailsList();
      // $rootScope.testObj.steps[0].stepCompleted = true;
      // $rootScope.testObj.steps[1].stepCompleted = false;
      // $rootScope.testObj.steps[2].stepCompleted = false;
      // $rootScope.testObj.steps[0].stepActive = false;
      // $rootScope.testObj.steps[1].stepActive = true;
      // $rootScope.testObj.steps[2].stepActive = false;
    }

    // setDraftData
    function setGetDraftData() {
      if (vm.InvestmentGoalDetails && vm.InvestmentGoalList) {
        vm.InvestmentGoalDetails.forEach(function (res) {
          if (vm.selectedInvestmentGoalName == res.type) {
            vm.SelectedInvestmentGoalDetailsList = res.funds;
            vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
            vm.pageArray = [];
            for (var i = 0; i < vm.pageNumber; i++) {
              vm.pageArray.push(i + 1);
            }
          }
        })
        // SelectedInvestmentGoalDetailsList
        var tempArray = [];
          vm.SelectedInvestmentGoalDetailsList.forEach(function(item){
            var tempObj = item;
            tempObj.selectedInvestmentGoalcard = null;
            tempArray.push(tempObj);
          })
          vm.SelectedInvestmentGoalDetailsList = tempArray;

          tempArray = [];
          vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
              vm.pageArray = [];
              for (var i = 0; i < vm.pageNumber; i++) {
                vm.pageArray.push(i + 1);
              }
          vm.getPageData(1);
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        if (Details.transactionDraftId) {
          LoaderService.showLoader();
          var success = function (resp) {
            if (resp.data && resp.status) {
              if (resp.data.investmentGoal) {
                vm.selectedInvestmentGoalName = resp.data.investmentGoal;
                vm.saveDraftPayload = resp.data;
                vm.selectedscheme = {};
                vm.selectedscheme.schemeCode = vm.saveDraftPayload.schemeCode;
                vm.selectedscheme.purchaseEnabled = vm.saveDraftPayload.purchaseEnabled;
                vm.selectedscheme.sipEnabled = vm.saveDraftPayload.sipEnabled;
                if(vm.InvestmentGoalDetails){
                  vm.selectedCard = true;
                  vm.InvestmentGoalDetails.forEach(function (res) {
                    if(vm.selectedInvestmentGoalName == res.type){
                      var tempArray = [];
                      res.funds.forEach(function (res1) {
                        var filteredArray = [];
                        if(res1.directSchemes){
                          var filteredArray = res1.directSchemes.filter(function(itm){
                            return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                          });
                        }
                      if(filteredArray.length == 0){
                        if(res1.directSchemes){
                          filteredArray = res1.regularSchemes.filter(function(itm){
                            return vm.selectedscheme.schemeCode.indexOf(itm.schemeCode) > -1;
                          });
                        }
                      }
                      if(filteredArray.length == 1){
                        res1.selectedInvestmentGoalcard = {};
                        res1.selectedInvestmentGoalcard = filteredArray[0];
                        vm.selectedInvestmentGoal = res1;
                      }else{
                        res1.selectedInvestmentGoalcard = null;
                      }
                        tempArray.push(res1);
                      });
                      tempArray = tempArray.sort(function(a, b) {
                        if (a.selectedInvestmentGoalcard === null) // a is null? last
                        return 1;
                        else (b.selectedInvestmentGoalcard === null) // b is null? last
                        return -1;
                        })
                      // vm.SelectedInvestmentGoalDetailsList = res.funds;
                      vm.SelectedInvestmentGoalDetailsList = tempArray;
                    }
                  })
                  vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
                  vm.pageArray = [];
                  for(var i = 0; i < vm.pageNumber; i++){
                    vm.pageArray.push(i + 1);
                  }
                  vm.getPageData(1);
                }

              }
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader();
          },
            error = function (err) {
              LoaderService.hideLoader();
              MessageService.error(err.data.message);
            };
          try {
            vm.processFlag = false;
            var arnCode = identifierData.arnCode;
            var Data = {};
            Data.arnCode = arnCode;
            Data.id = Details.transactionDraftId;
          } catch (e) { }
          ChangeDividendService.post({
            child1:'v2',
            child2:'distributorNewInvestor',
            child3: 'saved',
            child4: 'draft'
          }, Data).$promise.then(success, error);
        }
        LoaderService.hideLoader();
      }
    }
    vm.SelectedInvestmentGoalDetailsArray = [];

    vm.changeInvestmentGoalcard = function(data){
      var tempArray = [];
      vm.selectedInvestmentGoal = data;
      if(data.selectedInvestmentGoalcard){
        vm.selectedCard = true;
      }else{
        vm.selectedCard = false;
      }
         vm.SelectedInvestmentGoalDetailsList.forEach(function(item){
          var tempObj = item;
          if(item.selectedInvestmentGoalcard && data.selectedInvestmentGoalcard.schemeCode == item.selectedInvestmentGoalcard.schemeCode){
            tempObj.selectedInvestmentGoalcard = data.selectedInvestmentGoalcard;
            vm.selectedscheme = data.selectedInvestmentGoalcard;
          }else{
            tempObj.selectedInvestmentGoalcard = null;
          }
          tempArray.push(tempObj);
        })
      vm.investmentModeValidation = {};
      vm.investmentModeValidation.purchaseEnabled = data.selectedInvestmentGoalcard.purchaseEnabled;
      vm.investmentModeValidation.sipEnabled = data.selectedInvestmentGoalcard.sipEnabled;
      vm.investmentModeValidation.directSchemes = vm.DirectScheme;
      sessionStorage.setItem("investmentModeValidation", JSON.stringify(vm.investmentModeValidation));
    }
    vm.getPageData = function (pageNumber) {
      vm.CurrentPage = pageNumber;
      vm.SelectedInvestmentGoalDetailsArray = [];
      var startIndex = 0;
      vm.limit = pageNumber * 6;
      if (vm.limit > vm.SelectedInvestmentGoalDetailsList.length) {
        vm.limit = vm.SelectedInvestmentGoalDetailsList.length;
        startIndex = (pageNumber - 1) * 6;
      } else {
        startIndex = vm.limit - 6;
      }
      for (var i = startIndex; i < vm.limit; i++) {
        vm.SelectedInvestmentGoalDetailsArray.push(vm.SelectedInvestmentGoalDetailsList[i]);
      }
    }
    vm.nextPage = function () {
      vm.getPageData(vm.CurrentPage + 1);
    }
    vm.prev = function () {
      vm.getPageData(vm.CurrentPage - 1);
    }
    vm.iconsArray = [
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABI5JREFUSImllGtsVFUUhdc6c2emhTYBwltFSjqXUguG+PhBQrEKxlQrUmfaGFBDUBCNSpCIkc4wnWnVhEADja8EYowx2ukIBkQTEyDUID6iIREKvVNegkCoIBTsa+492x90aqkzlOL+effe69vr3H0OMYQIhBILAFkMMFtEDBJ/Kk0F4LxWuCPpTT775ZrCC+l61VBAIjIZ4EeNEd+8eNQsSXrtFxpqfE86qicCSKf3ktuVqXdQUOWbVlll9Ph4APDY3KE0FqVyfdNnyxURjG5Y5zt/yyAAx3RPz3uBkLU9acgcDa39YWvF+J1iAMDj6xO3o8MbM8hNNxLhTYDwWM3Jkd5kV6XSCAlUu9JyRRTyCGiQnSJyAMSvjRGz+pYdVVS13jesu/tTl02bmvVK4Ba3bCje6xsbi5pje2CXCcQh+ND/cuRfa81HVs8u+dudr8j3qdkEJQsEMoEAAXZoJd9SjMvQtlHcZC5/uYl6yCAA8Adb5hGsEhcWxsPm6cx11molzItF85eDlKE5ihwpYFJtyWpXpZ9szL88WH0gZL0lgrZ41Ky7aVBpdcI73JZd4jYWxkNTTvYKPQ2RpRBMpPCsUA5BVENjrW83AECEgZD1lWipjtcW/JTSuuEy5Nj6Fa1kSwpybTL1A8S9yVFGUMA/QHYkc3jw39Ep4uIyQkUh0mckI6i0OuHVVGUP7DE/vi4hzgzSvscQZwaVkBozPVfF178kHjZPw4Vf/EFrwaCgYVoeAbB94AbZhrSKxikIkwIZrthTHqv17RvYrxTqSD4/KIgac6H1zv8IEN1QWC3QR4v3mmWf1xRdTNffEDbbhBzuX3U4FwCMyqqWKQCmpAocZR+KR+46CyCfE0xroEA8VHCkPNhcbNCIN81OtKAJ+zMNC5F9rmHGdADfK4es1uR8IedqcjFoPAcA0FCNL9FJ1781WnhCu/AElGysDCVmZTwV8oxDGQP0Hp3yuGtjUfMNkJtdmnkVVYnXAEz2B1vmPbP0oCedSDxsnlYuPmpr3ZERJDpLEZ19oD6nlEIh7tWCZkC/RbKkc5xnfyBoLUkHbAibbV/UTD2QCSSkaTu2BQDGgISLtpyI1/q+SX0rrU68k2PLis5xnj2BNdZVKJyj5jkokWs90ErL5oaaqcf6a9UXi2oSa7qL7rz6Yvn9OlC6+Hqtrx1ABEAk8K64ePHIJCdpjEo9Km7hCJt6R8nK3Xfv2fCgDQBL6n52f/dX61oIxiiNir1zEvcPCuofvctxvLQ6cSbbQREAJCmXlODymJxJD/uDidFKMKv9ohQZNra1FdnTRrW4VyoHF4YESkVuUt+mFZcI4aUjNoDfNPRspXGUgvpYra+5NNKaO8Jyvy1acjDRXHcdSDlii5I7y4PNk7dGC09kAvX+jxfT5fyrDudWVCVe1S6WE6xrrDG3AQOWwXaj2ZPkASWucCBoTYSSnd2GbtwenHZmMJeBsDWTNpcJZboQH3Bcfkn/e8hAVcuHIAtA9lBkJISfxWp86xe9fiq7K6trPkWeAmQUqLoyUkSyQRymyOZYdOqP6Ur+AVXKC01p5weIAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAABHNCSVQICAgIfAhkiAAABHtJREFUSImllWtMFFcUx38zszv7XthdYFlYYMtDRcVQ3482aFqbSkx80JbQtLbVhkbTpLFNSUkp0aY1qW1MbSoJNprYhBip8UklfrGaUIwm1hqtWiNUEBREWGDZxyy7O/2AGhEWsT1fJjnnnv/vnnPn3CsweZOyXNYGrQaPxSgZfIHo/eGIqkdFGVZVIaSo1X39/obxEjXPAIkaZCH/4k5PliBAOMLIN6yyq9Eb23msLyleojgJ8R1AGsBwTD1z6nJQBZA1oJXAZBBovOD39nr9v8UTkCYB8QNVwMfeQaX+fGtkOaqgExC42KpQvb8vcr0z1DQ4FN71fyo5BzQBAb1Brn37zXzdLWzhbSeHwwf+0ihLV0wTDSbDtIkEJgM5AKjAhlSHpe1YQxsmk6wtK8mRCwscuiPHbw1HwtEUIDeegDAJyBSgz+O2N1S9k18wb5rNeOJs13BbdyDqdOikpYUpWqdNx5rK5u473vvFvgH++C+QhOfcjnN11fPzCqckxq28qzdEcUVT1/WWniLgxuOxp7VL40mzHf/psznZEwEAUh16Dn65KDUnw9EAGB+PTfh3uV22ig/fyCstKUrXA/T5wqyubGbLnqv88MtN6k910DOg8MKskRGxWWVSHPqESy1DOd7B4KHJVJKYZJU3bVyVbXro0GtFpmZaKF6UyqsLU/H6wpj1o+f5taJ0jcdlWg7kPbUSV2riB5+WTV1bmJf4aI1WIzLDY2Vevp1wNEavV+GL9dMxyKNl8twW0+9XvHl9A8E6mOBaseg160qWpmsf96kqrK1qRgAWz0yitmIuNrM8Jndevg1RFOYAOkCJ2y6jXnIYn2iFIMDhrxdjt8q8t9KD066Ll8786XYZeB5ANCc5v7c63S0JTvdNqyO1HXgJkI16aewWgQynkZ+rFlBZc5mzV3rjQmZlJ5qNZjwAoiRqZjqLN2W7Xq/MSZj9ihvIADzBkBq3SqddR93WBRxvvhsXImoEITA0ModjziQjzbVzYcEMn8/vty376IJa9nKy8O4KN7JmNNNukdlWPjMupLXDNwTcGReysmiJtWZrhRWAaJTdB4+oaz4/JuSmGcjNMJBulzAbJAZDUUQVlsxKGvdszly6HwL+HhcyyiSJ8tISoby0hLb2Dm603aa98y4d9/oBSDRbef/bE9RsziUjxQBAJKpSc+im6gtqrHMK8v8c8geqJ/0yZmW6ycp0jwgFFYKK8mAfEifOnsZl17Hn1zblVndESEtOjp6s3WFoae/QbN7+Y/qzPL+PbEvNXs5fuYbw4HoNKUosN8sRfWv1Ou3yhXNFlyuF3fsPB7bvrbvW0n77mzGQ1o7OqK9/ULIkWuNCvvpk45MuERBRVRpPN0VWbqro8voG9/1zu3MLEBkDOX/p6v7ZpesLPS5X8sbS1cmrlr0oSvpxR+aR9Xv7qa0/Gth3tLE/pCj1D8QHHsYFc5LzgCTrigRBE4uE/Yahnu4NwCEgM8OdVi5LUpktwWIShPHHJhaL4Q8E7/T6Br/rudd7EAg/ueZf7ziIbwUW/ksAAAAASUVORK5CYII="
      },
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABJFJREFUSImtVG1sk1UUft77vl0/tlJnRxEcOoeZMhazOECMxAWmRsWgySaDIAgBEhRQIZIY2CDbcMimEhPZD0YyJQZGQFwEIcSBiTFjZHzIDGOF0UEZpev6ta7t1r3ve48/apd26WCLPH9uzrnnPs+595x7gAmgZHvn3JJy6ycTORMDe9Dm0vKuopJK29MxW4CYBgZTzF6w5ZxUvNO6/n8LKaQ6BFk5XFxmzY8KkZ8pwn0AKPn8ujEjbXqTwJk6HiHhYQElO65NZSzlgyM7n/UBWAFgEoBz6/faz/vdkciR6pwTj0QIAIioorUztOPEeT9klTDrGT1WFpkvCcDLgiDI4+EYj0iayy/Luw45SFY4cSKqP9NHzVcDRERLxssjxRtra231TBTeBXDFGRpa/Wv5TAeAGTZXRHoxxwBJjD5AYZ4RzX8HUPSCceZ4hRKaQeXU8+HbkydvLJ7yukWna1ux59aezXX2uqzJWrrSFYbKCQDQcj2InEwdDv3pfX9FtW1jaVX3Ew8TSqhRaZn1tcJ56ccVTin/3AoLpQvN4rznUsVULUOLNYRTrX4QB3Ke0mFlkRkuv4xr9iHlTFu/y+tXflc9/RsadueHHi60u326JOttc/Mn8U3vWFKEcbVKFJdsYeXACVeH3x1a0Lgrzzt6P6FGaRrjgVWLM2h+blpKvL/utz70ehObSwDw8WILLKYoRUG2QUpfNjXv28be0yCaB0GgpBktKeuaU3XI4ab/cLLNT7LCaaJouuALrKmxrRvNzwCguMyar9fhi0UvmcwAQACcPhmqmjypB2FRgcloMIibR/uFdbXdF7MytVnZ07SG4lfS9RpxAoUZAzVHnT2X24IFXEcHBUAWSNrOdHr25LalU81LX338kYgAQF62wUKplH+0KudNrpE2cqZ+M+ZQdfUr2Frfg8/q7Oi4OwQAON7iw6mL/QAAlRP2nXTBPaDgpz8Sm8yUylIMBjETAI7tyL4DAFJ4UBVCEY5UbaKmxSShuDAdDo+M3Ok6qJzQ2hECA/DWbBNEJsCgZfj6iBPL3zAnnBUZwDibXbrtxgUu0nwQH2CDg7R88/f29jU1t71O39jzsaUzBLNRhN7A0N49CADIzdKjzyNjhkWbEOsOKBQckqepGmxhnGWIJK8d2VxWcXPT8fPecHyrtt4I0i8tPiIiqjrsoOarATp92U+1x+4TEdHW+rt0tj1APzS7E1p8/+k+X0ll5/NJM37vyw7zmlqbczju7wwrnEKDKhERBYfUEb/TN0xERP6QkrASESkqp0/33bk5mn+kME3bcz3Dw/TV3qZeT8ynEQUYdNGQ+BpOeUwDADAZxIQVABqaPYHwIC8fswYxrK7uqqs+7OjjExwKdneEdjc6+jZ8d7sqGW/Sj7N6T/fFmo8yCzKM0Tn2c4sv+NfVYH98jEYSNBWrpln0muhNyxru9d66PVDYWDnTmoxTSuYUGCLxttU+FOlxDsw5Vjnrfsy3rrb7bDDMF+pNI0+qjiUyphBXyFNx0OGUmKACgM87nCpxShBXVPJU/nivV9IwBQD8/UpSrhj+Bbf5rMjEKC/eAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAABI5JREFUSImtlntMU1cYwH+3LyhFQKA8SrHIlNii4iMKZCqomTE6nW46NRo3shl1m04000zjHmYvs/gYOl22xD00bDodkcSYOdGp0YHOGBkLKOJAqEBpKQW8IGDP/iiwVu0A4/fPvd/r/M757jnfPTAwSQHWDzAHAEUf/tmAyUvXAaFeuhJ462mAKoBcYEy33gTUdr8HAUeA5v6ApH7ExGq12mWyLDcCy/Cs6LTZbD5bVlYGcLI/oH6JEOLD/PxfxLSMsWJa5mixZcs64Xa7i4QQqqcJCbZarZ0zpo8U8o1FQtxZIrZmp4qDB78VQoiX+juOzzcaaog6kBQfY3smLvosYOw2DysuLlZNTw9Fq/WEL35eT2HhGQDzE4E63O6qnBVz9IeyF2YMNUQVGmP0n6SlmPdYLBZxptBFe7sbgMMnGkhNncp7mza8HBsZvhqI7guk9FZaWmWNPixk3tXbd7ljawp+f9HUSdsWZybExMZIwaZxrN2cxw95NgyJk8nOyiK5pSR6hDFyhq2lfSkKxUhXq1wAdD4O9PCuM+nDB5cvSEtm39r5aiQvd/woiDWDSgOOO1BRCF0dve6CP290rtp//O9bNXXTgcb/BSXGRf22ffnMzAWZY3x206qcY1TZmnwTJfh69TyMhoheW0l5jfvF7T9eKa+uTQeEP9CEWamjTp3YlhUGsC//Im/MSgOVT3X7lO0/FTh3Hb+0qb7R+Y23vWczpBj04e+unjkxDAAhqKh10NXZNSAIwMb5UwaH6AIf6YeqRGP0lUkjTENShxuDZ49P8lgliR0r5w4YAiAFqEkyRGjLq2sNwA48/fED1WCd1vj9O4ujnmhUPzLZkhB+oqgkBVgCxACH/TbVypoG0rO/ZPyaHM5duwlATt4Fvjt5uTcma8dhKmvsfHTotE/ukMiQYJ1O1zP5OkConK2y1CG3owkK9AlOMOrZvCCDaoeLjLFJ8MDN0YslIMGrMyeAJJEcH8XCz3M5+PZCn9xAjUYKUCvG3YMi4FngnsLpkpda1uT8lfDKp466eqffcvx84TqG8EGEBgVScMWzwmGxkTiaZYwRIT6xVbamzsamFhOwAdADyxXO1taCipq60e3tXevz/iht905QKRSoFJ7q5p4rZu7EEcydaGbfqSIAdudfYu/KOWw7ctYHVHa3oRHYCqwAPgMc3udIlzw0rqxk7zpj79npegBuN2jUeJe3ymrHFBdJV9t9VNqA3mdPjuXN3eWlldYkb7j3aewMDAi0l1bbpsxJswQBoFCA0hOiVP/XLMJCut3dNoWXb81Xxx3Xb9dubJHbSvyBaL4nF7vaugZdK68xz0tP1vn0uj7kVlU9r39xrP5iadX+qrqGPQ/7H/lDVlhrt6rVUqqjsfm5iAjPPWTn0XOu3PPXW73jgjTqwN8/fi1CEaABYOnOI3WXy/7JAG4+biKP/RWrlcoO4dUSz5dUyldvVKYC1h7bcFPM1Za2+xGh3SABbn8Q8HM5GR4ffUAI6QWVUnID2Jtljd3pSgQcPTEJsfpfVSrleJVCEgD2FlmyN7oi/YH+BSfZn/xiQV8WAAAAAElFTkSuQmCC"
      },
      {
        "icon": "data:image/png;base64,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",
        "activeIcon": "data:image/png;base64,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"
      },
      {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAVCAYAAABYHP4bAAAABHNCSVQICAgIfAhkiAAABQlJREFUSImdlGlsVFUUx//3LfM6+9KdUqW1Qy3IIigJIiJGo6IgwWkrtIBIIDEGE4gJYh2KLRUVsKigiQkCIobCRKQBwYJsxhIoFoRCawtFW+leprO9eTNvuX5oWOwAsZxP9557zvnd7X8IBhql5M1P//5AoXQaCO2gGkaxDOMPBKKL+gg5+1OxMxKT8z+M3D5ZWF7DKyH7wknjrWvznrKbOvsUOFMFdHhlfLans7fXK9OIhILt7syq+wa51tSZHHGmc0MTdeZlruQko8DEBHf5FLz7VWtrICQ/71mdXT8Y0K1qYf3Y8dkGm7sgNckoMOjsk3H4Dz8O1vpx4a8wKIAkK4clecnpFgt/fMGKc8b7AlktTMmEh00GANj1qxdf7OmCGNHAssBvl4Jwb7kGf1jFo5kGpCboiMhaHho0aM6KpqzMVGHk2Ay9/mhdAMdq/bBZWEzMNuHZMRY4zByiCsUnFe0AgBmT7XaTmWwYNEg0yV5R0phjdQFs29eNiaPNmP10PMo9Hdhc1YOLV8MoKkhFS1sUVbV+PJZlYKOqNmrQoB+LRvR2+6LV+0/6qE4g0AiFT1ShExiY9CxkWYNPVMGzBBdbwlhb0R4hhBwdDIi7MeiQ4mYTSA2Jdt4shTVbdX0QS2clw2pg4TCx2HuyD3oDK05+xKKWf/9PPWfj592taP6qxkQ1qEqedTmBG77/6KigtHm6Tkc3vTLFkZBg5fTtvTKcQ+Jw9oqIlx63YtXWa52SpPlFMTJ9Z0nOnwMBrxU3TzBbsCM1UWcIixrxhpTmgEhcFe6MDjIw2PVOvdmWLNQVv572QG2ziJauKF59wo6Ne7u8V1rExYaIeGDLmrGhmFOUXk2JtzI1y2enDD12PoBkG4f0RB3dsKvz/OjKYeNiVOlZlxMIeJVpxd9e87f1KkqSjadl37VFO68rH1asGu65EwQABFaZN+c5xxAdS9DplfHzKT+y0+LICKc+7cQzTWO4OyUx0PqCPrXmWPX1j0AZE2XoaJXSe/a4OB2flWTlGZ4l6OiWsWRWMliGID1ep6cqTbsFopS4ii/nE2AhwyKD4xmrKGo9stFYHc+EpkWi7EqXu2k+A3pY0qmfV7pz2m4H+YLRqtONofyCKQ7L4umJqG8NIyNZh5qGUABE+Z0BgLzS+gzXyqYjoBinamyhxcy3v52bkmDQc6fipJB/VLZ57syp9gBRlY8pIafiomxlXlGj63bQk0ecPxyv8dftP+MLZaYImDTChI37ur1ev7zDUzKyncwsuxTPS9xBqjBveNZkXZi67AiX5kj3Go28LxrRvoyEoodMdmE1gImqjH2bl2fMWbDinDHIGTwg5OvdJc49+aVXUww8PSHoGLtGoWcBgTKUKiokjoMkhWkDyXU3llONVHnKnAduXuH7l1/oDbceOrp+qppb3FS4u2T49vz3GkcSgbwoq+gXKlH1RGO2Eg1zKcdmDkvVbZgx2ZZwp/f7prK7hwMwwVPmXHrTSwj1AP3Q9ZQwKngAMFr5Rc4HhcJ4K190I1TVqJ4hpOpKmyR39cjCwdN9UgxFA9UoDXGUEPWuX4kQqm2i2wBAUTVrj1cxhiTtpiQ0DSwhhA0GVZ5hQBlCYuSisf1+kutuPEnQv+t7maAn2W+5Uk0OU6wizlwWtbMNQXnRy0lCDEijWLuzrTumM9zNCsua5hv03EqOY7SBa9GoRjSNikYDa44BUUqkCP3lX0IPONazfl+eAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAABHNCSVQICAgIfAhkiAAABLBJREFUOI2dlXts01UUx7+/29+vvz7W9cHarl23jg03GOtGWWWwQBxbVB4aQXQq/rGoTDQhhuj4Zy7BGBZjUP8xJEYDcVMxRDHICAosjnd4TxmPTR4b2+jouq1d37/29/td/xAilGYBzz/nntyc8zn3nnPvYfCw5DjNhl9EyDYAsoZTaOIpaWjEH9oI4DKAWAafaYVJs0tyc3RffVDrrK3K1zGCTKHlCM4Ph4WuvkDkwu1QYHQ8VPm4IMV964o5jhlHVpSZC5bNMfGEMFAq/s3BrufZxcV6Dcsw3MBUclE0nuwEIPwfyLMvuu0vr/VYNNGUjH1Xg+jsi+DUUAzhhIiZJh5lNi1vy1YVXptIqkMx4eCjQti7WuvMNWxZXmZSBuMi2rrHsK5hJd52lyGZEvHzgWPY8sc5tNbZUGrVsBRY8KgAACB39XxPfrZJp2ax+cg4BokOWztPQqtWwTsRQvuZv3ExzmNnzwQsWRxKLNoSAJWPAwIA7RN5Jv9S9yyqLyqmuBik2NRGy0qKqKPAQXGgl6Ljd2opLqafra2iDQuddwAse9Tg92qS0mqU8FSU1/mCYcqdP06Mvaex+6P1yC/IQ09HO7JOHkKJmtCLIxF66Za/LxxPtgCgjwNBKCqcFVJyo4Ywih82rFG9vmQeymflo9BsxNJiMyotOhqNJHzD/snx60N3KgFIGeK5CguMzUaT9rlgMD4J4PYDEACyfzLYIcrUYtRlzU6KIt+67Ud07DuMl+oXYfO2Xf7e64OXgrHIq7FoYjw9utNhaJo3N6d9a4vr6YYVedXjQWlVSiLqYDB+JNPpSGG+7ejW5jeTQ13b6c3fvqGr62tCTkfulmluRFc+2+wN9zfQZUudtMZjp77za2iNxz4KwMFmcJAHh0c//m7f4YN7u8+AMAQDXp9qyOtrnQbiemaJhedYgjybGjYzj2wdi1eedxhOnvNWp0N0OXZjIwPS9tSTLuaL9xsBAO7GZtZEjT2To4FWAAcAiGl+vlu3EymeY1BdaYRex0GlIhgcjsUAjN77uxh7qfVDwpENC5vKTRe+7+N4LQfBmwRkGWaPCb7+AEqXF/r+2nUtKoSTGwNjwc77IEyR03Ri+6dV1bU1OaS3PwRJonTNu6cv3xyYcDMAiL3UundBk6t20XqXNhYQ8HXdT9A7ssCpOYgJCVSWERmL4Y3OVeCzlNj9TlfA++d4m2/Q/zkAWCy6dRoN20gYpsyg47SEYRAMpeKSJF8lwJeMpcDUUv1WRcuS5vlaAJi8OYVz315B9XoXEgEBkkTBqQi6PzmL2k0eWObOAJUpdqzc4+8/OlAH4FKu1TDWtXOxWa0kEGUKyBQsS5CSZKxuOjXMWGaab7x35rUipebhHgiNRCBRCp1ZjZ0v/AoS/68UsigjGUkJkkTDqZSQUPKsNVNHyJJ0hWU5kp0JAABcFgeOUsQDAoTJBOrcpvQnzkuSzB06PpCsr4qwSJ9PDOj+EzCziamkuGPlnpGMlLsiJmWFGJ2y1lf4CJM25gIRYH+3nlRUuqFQkAf2KKU42nNDYABoAPDTQQDwNhsOWQ2YcT+EYUCTIhCKZkeMerVWQR7MgIJCEORj/wAwEOmu7K0f+QAAAABJRU5ErkJggg=="
      }
      , {
        "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAAAttJREFUSIndlUFoXFUUhr//vjeTzqRKQQSpKBhJo92IVq2h4kK3koXNM5YuxZWLInVRap4amwYp3RVciKCLLBpNW5QKgmAXtiJoNgoZ8hpasSVUhdLQtC8zmXeOC5ugk0lCSSrov7zn/v9/zr33nCs2GH0jM9WO/PqTjnojo9elx2T+Yrxe4YHBqS5z9RJ4RtDr+dx2pJ8j0/fIxky+OZJ26nazLc/nT0jNHTLtcngOcMGPGBOSny01qudGjzyQL3KSNDsc3MurVtR3qLa13Ih2Ra5nTb6DfO5xh18wzpp0Oip8aOxw9ySSr6QhqJnYs2TUNtsGCH5w94mAv5tX7/rui4Nbb/5DaWSNYzAmpbBdf5V34XWneUzQcLweTPNA3QMLa8isDUXCiwdjAKf5O/BVsbn8quWN+2xTXJhHl9ZtcguVenFV/YNTjwKnCIHIOGPy3cCsu/eND/fU/k54JZ1+ocD2CO4295sK4fPP3us+1SqcvJXtJTAKIDHgzpiSNJuWccYjtuBct+Dfnhjq+XgZ+Z2pfZj2O340mGYE9xZB+wj+5fjQtv3tKknS7FgwJi3wQQw8DHwKbPGID4UuL2O4i7fPH/AFPT3+/ralI+1/szaqSjT90uCFIyeHu35rpQlOFxZmFAwlaeaIWZxCcBHA4QZSY8kngAp/Humb5Xn7U8h/kulKu6pu6SUxQCiVHrF8oaeINQdQKoqqSx1LOw1wnUR2vlXEIrrUCL8SW6eh0M5IsJskzVZsto1CkmZ52wzuBNY9VBfRn2ZvBNjbLuaw+qy7HQh2IsYL9HVrLLif2zAjAEwXTwx3T7QuJ2nm/9od/fceA+Kq48eTNDveGnLw/18fBeDSy4dqD91po1jwkTeiTwYOZkcJngO4h7yImF+NWKI55xZW/YHrlWK26Z1GvU78x43LI/d03n/NYr0GobK4SdAR3KsriRREmxCVleJAtTwfd5Sp4zD9J3sbPP0WTheSAAAAAElFTkSuQmCC",
        "activeIcon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAABHNCSVQICAgIfAhkiAAAAwhJREFUSIm9lk2IHEUUx39V1VPTX7Oz3ZuNOztrwoJxJmtQ1JUYF6KXFSGIUZTgIZ7EXCQhgngSP2+iSLyEnBQxeJB4CRIICEIcUBH8QEUiegmSrLCZ7E7PV09X5TCJsu5MkoVJ/qduXr3f/73XXdUtGL08YB6fBc+PFrNeOtetNx5yRgC+HVjIjwW7VS73SNpqbtMTUZJUZ/Ktyozrnfl1lR/Ozm/UyAEqwEJ+orgorNlte3bcmYraydzWgEpZUSmThm7xakLrwiWf38/tuJ7RFPCAHg8fzGn9aLrausfx3SzbNi0622fyVGZgdjMdIfRQwnSsvMBd05ECqsD9bhwtgn04TdMptxS3kjvKQbdaVsxtoTvm5TY0g+kIY7lLXLl9IZiMjwolDUoaq6RBqQwpzIagQ2TriXe1o2VRituNl/d51BsKIWDTGAgxOLPZAT9/Yy7GwLNv4QA74mJ4JF1pSj4/Q1j7BXyXxuv7Yba0Fn70JP5XP9JcrpMvBJj77iQ9uBc2R2vhp7+HNz/qX7/6HAAiCoOle8uT0bfFoNW4bbzA9i3w+K71lb19HNIeHNgDpRgursInX1L46U9Wjx0e3P37J6C8CY58hrzYSCYVwgKwZyfsrK5PyAz52s/wyj6YnuhD4zF48QlsqwN//D14bLvm4O7ZfkeAjQphT+qcVcUgFVIoAJnXSEeClNIIK1f+WlLJ84+tYxVPfI32NMrVCFcjHAmABTIhsdbS+e63vtHHB56m3mz/m9zq9jDGDq5ygJrdLpkdvv6dUzUcgInAYzL0bxi8Ub13qpbJm0b/n0ZxqLLS7vDayRodM3h/ZyBGYlRP2iw1OxTm9w6Mqwsf2pEYAUipyEWl4fFRGV23kFtlNJLR+dohadT55/gbA+NaayEA+8VL+5HDTuoR6MkPPr11+0jGhXD5/KXkphs5wlHH3j39zaFn5queq/57ZEKCr6/91daOQit1zTVBvs8QgBMWvIN+zn1KCjyAnjEeZsiLIgErXJP1hv6QWJCpyXwAaaWQDucvA/115VDvXsBrAAAAAElFTkSuQmCC"
      }
    ];
    vm.InvestmentGoalList.goalName = "Wealth Creation";
    // get Investment goal list
    function GetInvestmentGoalList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.InvestmentGoalList = [];
          for (var i = 0; i < resp.data.length; i++) {
            var obj = {
              "goalName": resp.data[i],
              "icon": vm.iconsArray[i].icon,
              "iconAcitve": vm.iconsArray[i].activeIcon,
            }
            vm.InvestmentGoalList.push(obj);
          }

          // vm.InvestmentGoalList = resp.data;

          // vm.selectedInvestmentGoalName = vm.InvestmentGoalList[0];
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
          $state.go('main.newinvestor.kycverify');
        };
        InvestorServiceDynamicData.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'investmentGoal',
        child5: 'list',
          nriFlag: vm.nriTaxStatus
      }).$promise.then(success, error);
    }
    // get category details list
    function categoryDetailsList() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.InvestmentGoalDetails = resp.data;
          setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
          $state.go('main.newinvestor.kycverify');
        };
        InvestorServiceDynamicData.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'investmentGoal',
          nriFlag: vm.nriTaxStatus
      }).$promise.then(success, error);
    }

    function changeScheme(schemes) {
      vm.selectedInvestmentGoal = schemes;
    }
    // change investment goal list
    vm.changeInvestmentGoal = function (investmentGoal) {
      vm.selectedInvestmentGoalName = investmentGoal;
      vm.SelectedInvestmentGoalDetailsList = [];
      vm.SelectedInvestmentGoalDetailsArray = [];
      if (vm.InvestmentGoalDetails) {
          vm.InvestmentGoalDetails.forEach(function (res) {
            if (vm.selectedInvestmentGoalName == res.type) {
              vm.SelectedInvestmentGoalDetailsList = res.funds;
            }
          })
        vm.pageNumber = vm.SelectedInvestmentGoalDetailsList.length / 6;
        vm.pageArray = [];
        for (var i = 0; i < vm.pageNumber; i++) {
          vm.pageArray.push(i + 1);
        }
        vm.getPageData(1);
      }
    }

    vm.next = function () {
      var verifyObjData = $state.params.verificationData ? $state.params.verificationData : JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.saveDraftPayload.panNumber = verifyObjData.pan;
      vm.saveDraftPayload.investmentGoal = vm.selectedInvestmentGoalName;
      vm.saveDraftPayload.fundName = vm.selectedInvestmentGoal.fundName;
      vm.saveDraftPayload.fundCategory = null;
      vm.saveDraftPayload.step = "FIRST";
      vm.saveDraftPayload.brokerCode = identifierData.arnCode;
      vm.saveDraftPayload.schemeCode = vm.selectedscheme.schemeCode;
      vm.saveDraftPayload.investmentOption = vm.selectedscheme.investmentOption;
      vm.saveDraftPayload.schemeName = vm.selectedscheme.schemeName;
      vm.saveDraftPayload.schemeType = vm.selectedscheme.schemeType;
      vm.saveDraftPayload.purchaseEnabled = vm.selectedscheme.purchaseEnabled;
      vm.saveDraftPayload.sipEnabled = vm.selectedscheme.sipEnabled;
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.data && resp.status) {
          var data = resp.data;
          var Details = JSON.parse(sessionStorage.getItem("userData"));
          if (Details && !Details.transactionDraftId) {
            var details = {}
            details.transactionDraftId = data.id;
            $window.sessionStorage.setItem("userData", JSON.stringify(details));

          }
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = true;
              $state.go('main.newinvestor.investmentDetails.investmentMode');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      ChangeDividendService.post({
        child1:'v2',
        child2:'distributorNewInvestor',
        child3: 'save',
        child4: 'transaction'
      }, vm.saveDraftPayload).$promise.then(success, error);
    }

  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipApprovalController', sipApprovalController);

  /** @ngInject */
  function sipApprovalController(ModalService) {
    var success=function () {

    },dismiss=function () {

    };
    ModalService.investmentSuccessModal({},success,dismiss);
    ModalService.rejectionReasonModal({},success,dismiss);
    var msg='Are you sure, you want to reject<br/>Systematic Investment?';
    ModalService.rejectionApprovalModal({msg:msg},success,dismiss);
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('LumpsumApprovalController', lumpsumApprovalController);

  /** @ngInject */
  function lumpsumApprovalController(ModalService) {
    var success=function () {

    },dismiss=function () {

    };
    ModalService.investmentSuccessModal({},success,dismiss);
    ModalService.rejectionReasonModal({},success,dismiss);
    var msg='Are you sure, you want to reject<br/>Lumpsum Investment?';
    ModalService.rejectionApprovalModal({msg:msg},success,dismiss);
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('HolderApprovalController', holderApprovalController);

  /** @ngInject */
  function holderApprovalController($stateParams, AppConstants, ModalService, MessageService,
                                    InvestorModel, InvestorsService, UtilService, LoaderService, InvestorServiceDynamicData, $window, $rootScope, HDFC_API, FolioApproval , panAdharLinkingService) {
    var vm = this;
    // var investorId = InvestorModel.getInvestorId();
    var formData = {};
    vm.CONST = AppConstants;
    vm.confirmCancelModaltoReject = confirmCancelModaltoReject;
    vm.changeStartDateJointHolder = changeStartDateJointHolder;
    vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
    vm.addMoreTaxResidencyJointHolder = addMoreTaxResidencyJointHolder;
    vm.deleteTaxResidencyJointHolder = deleteTaxResidencyJointHolder;
    vm.resetNetWorthDate = resetNetWorthDate;
    vm.approveFolioSubmit = approveFolioSubmit;
    vm.mobileEmailBelongsTo = mobileEmailBelongsTo;
    vm.init = init;
    vm.uniqueLink = $stateParams.uuid;
    vm.isLoaded = false;
    vm.changedUniqueLink = '';
    init();

    function init() {
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      LoaderService.showLoader();
      if (!$stateParams.uuid) {
        UtilService.errorHandler('Not a valid link');
        return;
      } else {
        vm.uniqueLink = $stateParams.uuid;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          initiateOtpModal();
        } else {
          MessageService.error(resp.message)
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      FolioApproval.get({
        VERSION: version,
        controller: 'otp',
        child2: vm.uniqueLink,
        child3: true
      }, null).$promise.then(success, error);
    }

    function initiateOtpModal() {
      var successOtpModal = function(resp) {
        vm.changedUniqueLink = resp.holderLinkId;
        vm.isLoaded = true;
        InvestorModel.setInvestorModel(resp);
        proceedToGetDetails();
      }, errorOtpModal = function(resp) {
        MessageService.error(resp.message);
      };
      ModalService.folioCreationOtpModal({
        uniqueLink: vm.uniqueLink,
        type: 'holder'
      }, successOtpModal, errorOtpModal);
    }

    function proceedToGetDetails() {
      mobileEmailBelongsTo();
      getFolioInfo();
      lookupList();
      getCountryList();
      getCityList();
      taxStatusLookup();
      getTaxIdType();
    }

    function lookupList() {
      occupationLookup();
      incomeSlab();
      addressTypeLookup();
    }

    function getFolioInfo() {

      // LoaderService.showLoader();
      // var success = function (resp) {
          formData = angular.copy(InvestorModel.getInvestorModel());
        if (formData) {
          vm.folioDetails = formData;
          vm.holder = formData && formData.jointHolders && formData.jointHolders.length > 0 ? formData.jointHolders[0] : {};
          if(vm.holder.jointHolderApplicantDetail){
            vm.holder.jointHolderApplicantDetail.payTaxInIndia = (vm.holder.jointHolderApplicantDetail)&&(angular.isUndefined(vm.holder.jointHolderApplicantDetail.payTaxInIndia)) ?
              true:vm.holder.jointHolderApplicantDetail.payTaxInIndia;
          }
          vm.defaultDateNetWorthDate = (vm.holder.jointHolderApplicantDetail && vm.holder.jointHolderApplicantDetail.netWorthDate) || null;
          vm.nominees = formData && formData.nominees;
        }
      /*else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestorsService.post({
        controller: 'new',
        child1: 'folio',
        child2: 'joint',
        child3: 'holder',
        child4: 'data'
      }, {/!*id: InvestorModel.getInvestorId(),*!/ linkId: $stateParams.uuid}).$promise.then(success, error);*/
    }


    function changeStartDateJointHolder(date) {

      if (date && date._i) {
        vm.holder.jointHolderApplicantDetail.netWorthDate = date && date._i ? date._i : '';
        vm.defaultDateNetWorthDate = date.toString();
      }
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
            var countrySelected = vm.countryList.filter(function(country,index) {
              return country.countryCode === vm.holder.jointHolderApplicantDetail.birthCountry;
            });
            vm.holder.jointHolderApplicantDetail.birthCountry = countrySelected && countrySelected.length> 0 && countrySelected[0].countryName ? countrySelected[0].countryName: vm.holder.jointHolderApplicantDetail.birthCountry;

            vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses =
            vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.map(function(address) {
              var matchedCountry = vm.countryList.find(function(country) {
                return country.countryCode === address.countryName;
              });
              if (matchedCountry) {
                address.countryName = matchedCountry.countryName;
              }
              return address;
            });

        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id:vm.changedUniqueLink
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'holder'
      }, payload).$promise.then(success, error);
    }

    function getCityList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.cityList = resp.data.cities;
        } else {
          vm.cityList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.cityList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id:vm.changedUniqueLink
      };
      InvestorsService.post({
        controller: 'city',
        child1: 'list',
        child2: 'holder'
      }, payload).$promise.then(success, error);
    }

    function taxStatusLookup() {
      var successTaxStatus = function (resp) {
          if (resp.status && resp.data) {
            vm.taxStatusList = resp.data.taxStatus;
          } else {
            MessageService.error(resp.message);
          }
        },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var payloadTaxStatus = {
        taxStatusFilter: 'ADULT',
        id:vm.changedUniqueLink,
        nriFlag: vm.folioDetails.jointHolders[0].nriFlag
      };
      InvestorsService.post({
        controller: 'tax-status',
        child1: 'holder'
      }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);

    }

    function occupationLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.occupationList = resp.data.investorOccupations;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id:vm.changedUniqueLink
      }

      InvestorsService.post({controller: 'get-occupation', child1: 'holder'}, payload).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id:vm.changedUniqueLink
      };
      InvestorsService.post({
        controller: 'income',
        child1: 'slab',
        child2: 'holder'
      }, payload).$promise.then(success, error);
    }

    function addressTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.addressDescriptions = resp.data.addressTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id:vm.changedUniqueLink
      };

      InvestorsService.post({
        controller: 'address',
        child1: 'type',
        child2: 'holder'
      }, payload).$promise.then(success, error);
    }

    function confirmCancelModaltoReject() {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.actionTaken = true;
              var message = 'Your request for rejection has been submitted successfully.';
              ModalService.successMessageModal({message:message,hideOKButton:true},success);
              // MessageService.success('Your request for rejection has been submitted successfully.')
              //$state.go('approval.folio.rejected');
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: formData.id,
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId:vm.changedUniqueLink,
            uniqueLink : $stateParams.uuid
          };
          LoaderService.showLoader();
          InvestorsService.post({
            controller: 'folio',
            child1: 'holder',
            child2: 'details',
            child3: 'reject'
          }, payload).$promise.then(successFolioReject, errorFolioReject);


        }, dismissReason = function () {
          //UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);

      }, dismiss = function () {
        //UtilService.errorHandler(err);

      };
      var msg = "Are you sure, you want to reject<br/>'Folio Creation?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function sanitizingFormData() {
      // formData.id = InvestorModel.getInvestorId();
      formData.changed = false;
      formData.linkId = vm.changedUniqueLink;
      formData.uniqueLink = $stateParams.uuid;
      formData.holderLinkId = '';
    }
    vm.actionTaken = false;
    function approveFolioSubmit() {
      var success = function () {
        sanitizingFormData();
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.actionTaken = true;
            var message = 'Your request for approval has been submitted successfully.';
            ModalService.successMessageModal({message:message,hideOKButton:true},success);
            // MessageService.success('Your request for approval has been submitted successfully.')
          } else {
             if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
             } else {
               MessageService.error(resp.message);
             }
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        //var tmp = formData.jointHolders[0];delete formData.jointHolders;
        formData.jointHolders = [vm.holder];
        InvestorsService.post({
          controller: 'folio',
          child1: 'holder',
          child2: 'details',
          child3: 'approve'
        }, formData).$promise.then(successFolioApprove, errorFolioApprove);


      }, dismiss = function () {

      };
      if (angular.equals(vm.duplicatePaymentForm, formData.bankDetails)) {
        InvestorModel.setBankDataChanged(false);
      } else {
        InvestorModel.setBankDataChanged(true);
      }
      var msg = "Are you sure, you want to approve<br/> your details?";

      var successHandler = function(resp) {
        ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
      }

      var errorHandler = function(resp) {}

      panAdharLinkingService.checkPanAdharStatus(vm.holder.jointHolderApplicantDetail.panNumber,'',formData.arnCode).then(successHandler).catch(errorHandler);

    }

    function getTaxIdType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxIdTypeList = resp.data.taxIdTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({
        controller: 'taxId-type',
        child1: 'holder'
      }, {"id":vm.changedUniqueLink}).$promise.then(success, error);
    }


    function fileTaxActionJointHolder() {
      if (!vm.holder.jointHolderApplicantDetail.payTaxInIndia) {
        vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
        vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
      }

    }

    function addMoreTaxResidencyJointHolder() {
      var array = vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
    }


    function deleteTaxResidencyJointHolder(index) {
      var array = vm.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function mobileEmailBelongsTo() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.emaillList = resp.data.emailList;
            vm.mobileList=resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'}).$promise.then(success, error);
    }


      function resetNetWorthDate() {
         vm.holder.jointHolderApplicantDetail.netWorthDate= '';
         vm.defaultDateNetWorthDate = null;
      }

  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('UpdateIFSCController', updateIFSCController);

  /** @ngInject */
  function updateIFSCController(ModalService, LoaderService, MessageService, UtilService, InvestorsService, AppConstants, InvestorFileUploadService, AuthService, $state, $stateParams, $window) {
    var vm = this;
    vm.init = init;
    vm.updateIFSCSuccessful = updateIFSCSuccessful;
    vm.copyPasteHandler = copyPasteHandler;
    vm.accFocus = accFocus;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.back = back;
    vm.setHeader = setHeader;
    vm.removeLocalStorage = removeLocalStorage;
    vm.uploadNewBankProof = uploadNewBankProof;
    vm.uploadOldBankProof = uploadOldBankProof;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankList = null;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.chequeLeafUrl = '';
    vm.payload = {bankHolderType: 'MINOR'};

    function updateIFSCSuccessful() {
      var success = function (res) {
        if (res.status) {
          // ModalService.addBankModal(vm.payload);
          var modalSuccess = function(){
            $state.go('main.profile.folioDetails');
          };
          ModalService.forgotPasswordModal({message:res.data.message},modalSuccess);
        }
        else {
          MessageService.error(res.message)
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      InvestorsService.post({
        child1: 'folio',
        child2: 'bank',
        child3: 'update',
        child4: 'ifsc'
      }, vm.payload).$promise.then(success, error);

    }

    function init() {
      if(!$stateParams.folioNumber){
        $state.go('main.profile.folioDetails');
      }
      setHeader();
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.MainFolioParent.uuid = $stateParams.folioNumber;
      vm.payload.folioNumber = $stateParams.folioNumber;
      vm.MainFolioParent.currentState = 'main.profile.addBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBank = $window.JSON.parse(localStorage.getItem('updateIFSC'));
      vm.payload.bankAccountNumber = vm.oldBank.accountNumber;
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    function accFocus() {
      vm.accModelDirty = true;
    }

    function uploadOldBankProof(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'profile',
              child2: type,
              child3: 'bank',
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }
    }


    function uploadChequeLeafFile(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'folio',
              child2: 'bank',
              child3: type,
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }

    }

    function uploadNewBankProof(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
                if (type === 'add') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.payload.chequeLeaf = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, type);
                //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            // DistributorProfileUploadService.post({

            InvestorFileUploadService.post({
              child1: 'profile',
              child2: type,
              child3: 'bank',
              child4: 'upload',
              child5: (type && type === 'add') ? 'cheque-leaf' : 'proof'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }

    }

    function breakFileUrl(url, type) {
      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if (type === 'add') {
        vm.chequeLeafUrlNew = a[a.length - 1] + extension;
        vm.chooseAFileNew = false;
      }
      else if (type === 'modify') {
        vm.chequeLeafUrlOld = a[a.length - 1] + extension;
        vm.chooseAFileOld = false;
      }

    }

    function openUploadedDoc() {
      $window.open(vm.payload.bankDetails.chequeLeaf);
    }

    function back() {
      vm.removeLocalStorage();
      history.back();
    }

    function removeLocalStorage() {
      localStorage.removeItem('updateIFSC');
      localStorage.removeItem('folioId');
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CobmStatusController', cobmStatusController);

  /** @ngInject */
  function cobmStatusController($stateParams, $state, $window) {
    var vm = this;
    vm.init = init;

    vm.investorId = $stateParams.investorId;

    function init() {
      if(localStorage.getItem('cobmDetailList')){
        vm.cobmDetailList = $window.JSON.parse(localStorage.getItem('cobmDetailList'));
      }
    }

    vm.goToBasicInfo = function () {
      $state.go('main.investors.profile.basicinfo',{investorId:vm.investorId});
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ModifyBankController', modifyBankController);

  /** @ngInject */
  function modifyBankController($log, $scope, $rootScope, $state, AuthService, $cookies, UtilService, $timeout, AppConstants) {

    var vm = this;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ChangeBankController', changeBankController);

  /** @ngInject */
  function changeBankController(ModalService, LoaderService, $window, InvestorFileUploadService, MessageService, UtilService, InvestorsService, AppConstants, AuthService, $log) {

    var vm = this;
    vm.init = init;
    vm.fetchBankList = fetchBankList;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.getAcccountType = getAcccountType;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.bankList = null;
    vm.accModelDirty = false;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.openUploadedDocOld = openUploadedDocOld;
    vm.changeBank = changeBank;
    vm.changeBankSubmit = changeBankSubmit;
    vm.payload = {makeDefaultBank:true};
    vm.back = back;

    function init() {
      setHeader();
      fetchBankList();
      getPayoutMechanism();
      getAcccountType();
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.MainFolioParent.uuid = localStorage.getItem('folioId');
      vm.folioNumberToDisplay = localStorage.getItem('folioId');
      vm.payload.folioNumber = localStorage.getItem('folioId');
      vm.MainFolioParent.currentState = 'main.profile.changeBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBankName = vm.bankDetails[0].bankName;
    }

    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if(res.status && res.data){
          vm.bankList = res.data.bankList;
        }
        else{
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorsService.get({child1:'bank',child2:'list',child3:'sip'}).$promise.then(success,error);
    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      InvestorsService.get({child1: 'folio', child2: 'payout-mechanism', child3:'cobm'}).$promise.then(success, error);
    }

    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

      InvestorsService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list'
      }).$promise.then(success, error);
    }

    vm.accFocus = function () {
      vm.accModelDirty = true;
    };

    vm.copyPasteHandler=function (e) {

      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if ( key == 86 && ctrl ) {
        e.preventDefault();
      } else if ( key == 67 && ctrl ) {
        e.preventDefault();
      }
    };

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if(file){
        if (file.size <= 5000000) {
          vm.fileNew = file;
          vm.bankDetails.chequeLeaf = file.name;
          vm.chooseAFileNew = false;
          /* var success = function (resp) {
           LoaderService.hideLoader();
           if (resp.status && resp.data) {
           //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
           if(type === 'add'){
           vm.payload.chequeLeaf = resp.data.fileUrl;
           }
           else if(type === 'modify'){
           vm.payload.chequeLeaf = resp.data.fileUrl;
           }
           breakFileUrl(resp.data.fileUrl,type);
           }
           else {
           MessageService.error(resp.message);
           }
           },
           error = function (err) {
           LoaderService.hideLoader();
           console.log("err=== ", err);
           };

           if (file) {
           LoaderService.showLoader();
           var fd = new FormData();
           fd.append('file', file);
           // DistributorProfileUploadService.post({

           InvestorFileUploadService.post({
           child1:'folio',
           child2: 'bank',
           child3: type,
           child4: 'upload',
           child5: (type && type === 'add')?'cheque-leaf':'proof'
           }, fd).$promise.then(success, error);
           }*/
        }
        else {
          MessageService.error("File size should not be more than 5 MB.")
          vm.chooseAFileNew = true;
        }
      }

    }

    function uploadChequeLeafFileOld(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if(file){
        if (file.size <= 5000000) {
          vm.fileOld = file;
          vm.bankDetails.chequeLeafOld = file.name;
          vm.chooseAFileOld = false;
          /* var success = function (resp) {
           LoaderService.hideLoader();
           if (resp.status && resp.data) {
           //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
           if(type === 'add'){
           vm.payload.chequeLeaf = resp.data.fileUrl;
           }
           else if(type === 'modify'){
           vm.payload.chequeLeaf = resp.data.fileUrl;
           }
           breakFileUrl(resp.data.fileUrl,type);
           }
           else {
           MessageService.error(resp.message);
           }
           },
           error = function (err) {
           LoaderService.hideLoader();
           console.log("err=== ", err);
           };

           if (file) {
           LoaderService.showLoader();
           var fd = new FormData();
           fd.append('file', file);
           // DistributorProfileUploadService.post({

           InvestorFileUploadService.post({
           child1:'folio',
           child2: 'bank',
           child3: type,
           child4: 'upload',
           child5: (type && type === 'add')?'cheque-leaf':'proof'
           }, fd).$promise.then(success, error);
           }*/
        }
        else {
          MessageService.error("File size should not be more than 5 MB.");
          vm.chooseAFileOld = true;
        }
      }

    }

    function breakFileUrl(url,type) {
      url = url.replace(/ /g,'');
      var a, extension;
      if(url.split('.jp').length > 1){
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if(url.split('.png').length > 1){
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if(url.split('.pdf').length > 1){
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if(url.split('.bmp').length > 1){
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if(type === 'add'){
        vm.chequeLeafUrlNew = a[a.length-1]+extension;
        vm.chooseAFileNew = false;
      }
      else if(type === 'modify'){
        vm.chequeLeafUrlOld = a[a.length-1]+extension;
        vm.chooseAFileOld = false;
      }

    }

    function openUploadedDoc() {
      $window.open(vm.payload.bankDetails.chequeLeaf);
    }

    function openUploadedDocOld() {
      $window.open(vm.payload.bankDetails.chequeLeafOld);
    }

    function changeBank() {
      vm.payload.bankName = $window.JSON.parse(vm.selectedBank).bankName;
      vm.payload.bankRGTSCode = $window.JSON.parse(vm.selectedBank).bankCode;

      if(vm.payload.bankRGTSCode==='HDF'){
       vm.payload.payoutMechanism = 'DC';
      } else vm.payload.payoutMechanism = null;
    }

    function changeBankSubmit() {
      if(vm.fileNew.type!=vm.fileOld.type){
        MessageService.error("Both Bank Proofs must be of same file extensions");
      } else {
        changeBankSuccessful();
      }
    }

    vm.changeBankSuccessful = changeBankSuccessful;

    function changeBankSuccessful(){
      var success = function (res) {
        LoaderService.hideLoader();
        if(res.status){
          var successModal= function () {

          }, errorModal = function () {

          };
          ModalService.changeBankSuccessModal(vm.payload, successModal, errorModal);
        }
        else{
          MessageService.error(res.message)
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
      };
      $log.info(vm.payload);
      $log.info(vm.fd);
      vm.fd = new FormData();
      vm.fd.append('bankCO',$window.JSON.stringify(vm.payload));
      /*var files = [vm.fileNew,vm.fileOld];
       vm.fd.append('proofs', files);*/
      vm.fd.append('newBankProof', vm.fileNew);
      vm.fd.append('oldBankProof', vm.fileOld);
      /* vm.fd.append('RGTSCode',vm.payload.RGTSCode);
       vm.fd.append('accountNumber',vm.payload.accountNumber);
       vm.fd.append('accountType',vm.payload.accountType);
       vm.fd.append('bankBranch',vm.payload.bankBranch);
       vm.fd.append('bankCity',vm.payload.bankCity);
       vm.fd.append('bankHolderType',vm.payload.bankHolderType);
       vm.fd.append('bankName',vm.payload.bankName);
       vm.fd.append('folioNumber',vm.payload.folioNumber);
       vm.fd.append('ifsccode',vm.payload.ifsccode);
       vm.fd.append('makeDefaultBank',vm.payload.makeDefaultBank);
       vm.fd.append('micrnumber',vm.payload.micrnumber);
       vm.fd.append('payoutMechanism',vm.payload.payoutMechanism);
       vm.fd.append('verifyAccountNumber',vm.payload.verifyAccountNumber);*/
      LoaderService.showLoader();
      InvestorFileUploadService.post({child1:'folio',child2:'bank',child3:'add'},vm.fd).$promise.then(success,error);
      /*var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/folio/bank/modify';
      $http.post(_path, vm.fd, {
        headers: {
          'Content-Type': undefined
        }
      }).then(success, error);*/
    }

    function back() {
      history.back();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AddBankController', addBankController);

  /** @ngInject */
  function addBankController(ModalService, LoaderService, $window, MessageService, UtilService, InvestorsService, InvestorsCommonService, AppConstants, InvestorFileUploadService, AuthService, $log, InvestorModel, HDFC_API, FileUploadService, DownloadPdfService, FileSaver, dynamicData, $stateParams) {
    var vm = this;
    vm.init = init;
    vm.fetchBankList = fetchBankList;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.getAcccountType = getAcccountType;
    vm.copyPasteHandler = copyPasteHandler;
    vm.accFocus = accFocus;
    // vm.uploadChequeLeafFile = uploadChequeLeafFile;
    // vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.breakFileUrl = breakFileUrl;
    // vm.openUploadedDoc = openUploadedDoc;
    // vm.openUploadedDocOld = openUploadedDocOld;
    vm.back = back;
    vm.setHeader = setHeader;
    vm.changeBank = changeBank;
    vm.addBankSubmit = addBankSubmit;
    vm.selectIFSC = selectIFSC;
    vm.tpv = tpv;
    vm.formData = InvestorModel.getAddToBankPayload();

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.investorId = $stateParams.investorId;
    vm.bankList = null;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.payload = {makeDefaultBank: false};
    var pennyDropEnablSelectedBank = false;
    vm.showTerms = true;
    vm.payload.pennyDropValid = false;
    vm.folioTaxStatusCode = localStorage.getItem('folioTaxStatusCode');
    vm.isCheckedCobmTandC = false;
    vm.dynamicData = dynamicData;
    if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK) {
      vm.note = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK.content;
    }
    if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST) {
      vm.noteBankRestrict = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST.content;
    }
    //
    // if(Object.keys(dynamicData.termAndConditionDTO.termAndConditionDTOMap).length == 0 || !dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK) {
    //   vm.showTerms = false;
    // } else if (typeof dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK.content === 'undefined' || dynamicData.termAndConditionDTO.termAndConditionDTOMap.TNC_ADD_NEWBANK.content == '') {
    //   vm.showTerms = false;
    // }
    //
    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function changeBank() {
      vm.payload.bankName = $window.JSON.parse(vm.selectedBank).bankName;
      vm.payload.bankRGTSCode = $window.JSON.parse(vm.selectedBank).bankCode;

      if (vm.payload.bankRGTSCode === 'HDF') {
        vm.payload.payoutMechanism = 'DC';
      } else vm.payload.payoutMechanism = null;
    }

    /*function addBankSuccessful() {
      if(0 && vm.fileNew.type!=vm.fileOld.type){
        MessageService.error("Both Bank Proofs must be of same file extensions");
      } else {
        addBankSubmit();
      }
    }*/

    function addBankSubmit() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          var successModal = function () {
            // $state.go('main.profile.folioDetails');
            vm.back();
          }, errorModal = function () {

          };
          ModalService.addBankModal({modalPayload : vm.payload, requestType:'add', responseData: resp.data}, successModal, errorModal);
        }
        else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message)
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {
        accountHolderName: vm.investorName,
        accountNumber: vm.formData.folioCreationRequestCO.bankDetails.accountNumber,
        accountType: vm.formData.folioCreationRequestCO.bankDetails.accountType.accountTypeCode,
        bankBranch: vm.formData.folioCreationRequestCO.bankDetails.bankBranch,
        bankCity: vm.formData.folioCreationRequestCO.bankDetails.bankCity,
        bankName: vm.formData.folioCreationRequestCO.bankDetails.bankName,
        folioNumber: vm.payload.folioNumber,
        ifscCode: vm.formData.folioCreationRequestCO.bankDetails.ifsccode,
        makeDefaultBank: vm.payload.makeDefaultBank,
        newBankProofURL: vm.formData.folioCreationRequestCO.chequeLeafUrl ? vm.formData.folioCreationRequestCO.chequeLeafUrl: null,
        oldBankProofURL: vm.formData.folioCreationRequestCO.oldChequeLeafUrl? vm.formData.folioCreationRequestCO.oldChequeLeafUrl: null,
        payoutMechanism: vm.payoutMechanism.payoutCode
      }
      InvestorsCommonService.post({
        child1: 'cobm',
        child2: vm.payload.makeDefaultBank? 'AIPDBM':'AIPR',
        child3: 'bank',
        child4: 'initiate',
        child5: 'save'
      }, payload).$promise.then(success, error);
    }

    function init() {
      $window.scroll({
        top:0,
        left:0,
        behaviour:'smooth'
      });
      setHeader();
      fetchBankList();
      getPayoutMechanism();
      getAcccountType();
      vm.constraints = angular.fromJson($window.sessionStorage.getItem('bankConstraints'));
      vm.payload.pennyDropValid = vm.constraints.uploadChequeLeafEnabled ? false : true;
    }

    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status && res.data) {
          vm.bankList = res.data.bankList || res.data;
        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      // InvestorsService.get({child1: 'bank', child2: 'list', child3: 'sip'}).$promise.then(success, error);
      InvestorsCommonService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);

    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
            var payoutMechanism = vm.payoutMechanismList.filter(function (e) {
              return e.payoutCode == "DC";
            });
            vm.payoutMechanism = payoutMechanism[0] && payoutMechanism[0].payoutCode ? payoutMechanism[0]: null;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };

      /*InvestorsService.get({child1: 'folio', child2: 'payout-mechanism', child3: 'cobm'}).$promise.then(success, error);*/
      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism'
      }, {}).$promise.then(success, error);
    }

    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
                var sbAccount = vm.bankTypeList.filter(function (e) {
                  return e.accountTypeCode == "SB";
                })
              vm.formData.folioCreationRequestCO.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };

     /* InvestorsService.get({
        child1: 'folio',
        child2: 'bank',
        child3: 'account-type-list'
      }).$promise.then(success, error);*/

      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: vm.folioTaxStatusCode
      }).$promise.then(success, error);
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.payload.pan = localStorage.getItem('pan');
      vm.MainFolioParent.uuid = localStorage.getItem('folioId');
      vm.folioNumberToDisplay = localStorage.getItem('folioId');
      vm.payload.folioNumber = localStorage.getItem('folioId');
      vm.MainFolioParent.currentState = 'main.profile.addBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBankName = vm.bankDetails && vm.bankDetails.length > 0 && vm.bankDetails[0].bankName ? vm.bankDetails[0].bankName : '';
      vm.investorName = localStorage.getItem('InvestorName');
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    function accFocus() {
      vm.accModelDirty = true;
    }

    // function uploadChequeLeafFile(file, type) {
    //   if (vm.mimeType.indexOf(file.type) === -1) {
    //     MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
    //     return;
    //   }
    //   if (file) {
    //     if (file.size <= 5000000) {
    //       vm.fileNew = file;
    //       vm.bankDetails.chequeLeaf = file.name;
    //       vm.chooseAFileNew = false;
    //
    //       var success = function (resp) {
    //           LoaderService.hideLoader();
    //           if (resp.status && resp.data) {
    //             //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
    //               vm.payload.newBankProofURL = resp.data.fileUrl;
    //             /*if (type === 'add') {
    //             }
    //             else if (type === 'modify') {
    //               vm.payload.chequeLeaf = resp.data.fileUrl;
    //             }*/
    //             breakFileUrl(resp.data.fileUrl, type);
    //           }
    //           else {
    //             MessageService.error(resp.message);
    //           }
    //         },
    //         error = function (err) {
    //           LoaderService.hideLoader(err);
    //         };
    //
    //       if (file) {
    //         LoaderService.showLoader();
    //         var fd = new FormData();
    //         fd.append('file', file);
    //
    //        InvestorFileUploadService.post({
    //        child1:'cobm',
    //        child2: 'upload',
    //        child3: 'newBankProof',
    //        child5: vm.payload.folioNumber
    //        }, fd).$promise.then(success, error);
    //        }
    //     }
    //     else {
    //       MessageService.error("File size should not be more than 5 MB.")
    //       vm.chooseAFileNew = true;
    //     }
    //   }
    //
    // }

    vm.uploadFile = function (file,proofType) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format not supported. Supported format are tif, tiff, jpg and jpeg'");
          resetCheckLeaf();
          return;
        }
        if (file.size <= 2000000) {
          vm.myFile = file;
          if(proofType == 'old'){
            vm.oldChequeLeaf = file.name;
            vm.isOldCheckLeaf = true;
          } else {
            vm.chequeLeaf = file.name;
            vm.isNewCheckLeaf = true;
          }
          var taxIdentifierNumber = vm.payload.pan;

          var modalSuccess = function () {
              var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/cobm/upload/'+vm.constraints.tokenData.arnCode+'/'+taxIdentifierNumber+'/CHEQUE_LEAF';
              LoaderService.showLoader();
              FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  if(proofType == 'new') {
                    vm.formData.folioCreationRequestCO.chequeLeafUrl = resp.data.fileUrl;
                    vm.fileType= getFileType(file.type);
                  } else{
                    vm.formData.folioCreationRequestCO.oldChequeLeafUrl = resp.data.fileUrl;
                    vm.fileTypeold= getFileType(file.type);
                  }

                } else {
                  resetCheckLeaf();
                  MessageService.error(resp.message)
                }
              }, function () {
                resetCheckLeaf();
                LoaderService.hideLoader();
              });
            } ,
            modalError = function () {
              resetCheckLeaf(proofType);
            };

          ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }else{
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
      }
    };

    function resetCheckLeaf(proofType) {
      if(proofType == 'new') {
        vm.formData.folioCreationRequestCO.chequeLeafUrl = "";
        vm.formData.folioCreationRequestCO.chequeLeaf = "";
        vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
        angular.element("#uploadFileId").val("");
        vm.fileType = "";
      } else {
        vm.formData.folioCreationRequestCO.oldChequeLeafUrl = "";
        vm.formData.folioCreationRequestCO.oldChequeLeaf = "";
        vm.oldChequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
        angular.element("#uploadFileIdOld").val("");
        vm.fileTypeold = ''
      }


    }

    function getFileType(fileType) {
      return fileType.split('/')[1]
    }

    vm.openUploadedDoc = function(chequeLeaf,type) {
      if(type=='new'){
        if(angular.isUndefined(vm.formData.folioCreationRequestCO.chequeLeafUrl)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.formData.folioCreationRequestCO.chequeLeafUrl});
      } else {
        if(angular.isUndefined(vm.formData.folioCreationRequestCO.oldChequeLeafUrl)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.formData.folioCreationRequestCO.oldChequeLeafUrl});
      }

    };

    vm.downloadFile = function(url, fileType, proofType) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, proofType+'.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    // function uploadChequeLeafFileOld(file, type) {
    //   if (vm.mimeType.indexOf(file.type) === -1) {
    //     MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
    //     return;
    //   }
    //   if (file) {
    //     if (file.size <= 5000000) {
    //       vm.fileOld = file;
    //       vm.bankDetails.chequeLeafOld = file.name;
    //       vm.chooseAFileOld = false;
    //       var success = function (resp) {
    //           LoaderService.hideLoader();
    //           if (resp.status && resp.data) {
    //             //vm.payload.bankDetails.chequeLeaf = resp.data.fileUrl;
    //             // if (type === 'add') {
    //               vm.payload.oldBankProofURL = resp.data.fileUrl;
    //             // }
    //             // else if (type === 'modify') {
    //             //   vm.payload.chequeLeafOld = resp.data.fileUrl;
    //             // }
    //             breakFileUrl(resp.data.fileUrl, type);
    //           }
    //           else {
    //             MessageService.error(resp.message);
    //           }
    //         },
    //         error = function (err) {
    //           LoaderService.hideLoader(err);
    //         };
    //
    //       if (file) {
    //         LoaderService.showLoader();
    //         var fd = new FormData();
    //         fd.append('file', file);
    //
    //         InvestorFileUploadService.post({
    //           child1:'cobm',
    //           child2: 'upload',
    //           child3: 'oldBankProof',
    //           child5: vm.payload.folioNumber
    //         }, fd).$promise.then(success, error);
    //       }
    //     }
    //     else {
    //       MessageService.error("File size should not be more than 5 MB.");
    //       vm.chooseAFileOld = true;
    //     }
    //   }
    //
    // }

    function breakFileUrl(url, type) {
      url = url.replace(/ /g, '');
      var a, extension;
      if (url.split('.jp').length > 1) {
        extension = '.jpg';
        a = url.split('.jp')[0].split('/');
      } else if (url.split('.png').length > 1) {
        extension = '.png';
        a = url.split('.png')[0].split('/');
      } else if (url.split('.pdf').length > 1) {
        extension = '.pdf';
        a = url.split('.pdf')[0].split('/');
      } else if (url.split('.bmp').length > 1) {
        extension = '.bmp';
        a = url.split('.bmp')[0].split('/');
      }

      if (type === 'add') {
        vm.chequeLeafUrlNew = a[a.length - 1] + extension;
        vm.chooseAFileNew = false;
      }
      else if (type === 'modify') {
        vm.chequeLeafUrlOld = a[a.length - 1] + extension;
        vm.chooseAFileOld = false;
      }

    }

    // function openUploadedDoc() {
    //   ModalService.imagePreviewModal({file: vm.payload.newBankProofURL,showOnly:true});
    //   // $window.open(vm.payload.newBankProofURL);
    // }

    // function openUploadedDocOld() {
    //   ModalService.imagePreviewModal({file: vm.payload.oldBankProofURL,showOnly:true});
    //   // $window.open(vm.payload.oldBankProofURL);
    // }

    function back() {
      history.back();
    }

    function selectIFSC() {
      var successModal = function(data){
        vm.formData.folioCreationRequestCO.bankDetails.ifsccode= data.ifscCode;
        vm.formData.folioCreationRequestCO.bankDetails.bankName = data.bankName;
        vm.formData.folioCreationRequestCO.bankDetails.bankCity = data.branchCity;
        vm.formData.folioCreationRequestCO.bankDetails.branchLocation = data.branch;
        vm.formData.folioCreationRequestCO.bankDetails.accountNumber = '';
        vm.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber = '';
        if(data.branch && data.branch.length>40) vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch.slice(0,40)
        else vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch;

        // if (data.pennyDropEnabled && vm.folioTaxStatusCode ==="01") {
        //   vm.payload.pennyDropValid = true;
        // }
        // else {
        //   vm.payload.pennyDropValid = false;
        // }
        // pennyDropEnablSelectedBank = vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid;
        resetCheckLeaf();
      };
      var errorModal = function(e){
        vm.showValidate = false;
      };
      ModalService.IFSCSelectionModal({bankList : vm.bankList}, successModal, errorModal);
    }

    vm.showCobmTermConditions = function () {
      ModalService.nonTransactionalTncModal({});
    };

  }
})();

/**
 * Created by ttn on 21/08/18.
 */

(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .directive('updateNewFolioMobile', updateNewFolioMobile)
    .directive('updateNewFolioEmail', updateNewFolioEmail);

  /*@ngInject*/
  function updateNewFolioMobile(AppConstants, InvestorsNewFolioContactService, LoaderService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currMobileNumber: '=',pan:'=',dob:'=',currEmail: '@',updateContactInfo: "&", showEdit : '=', flowType : '@', kycEmail : '=' , kycMobile : '=' , hideUi: '=', hideUiFnc: "&" , showUiFnc: "&"},
      templateUrl: 'app/components/modal/transactionReview/directive/updateNewFolioMobile.html',
      link: function (scope) {
        //AppConstants.mobile_regex;
        callLinkBodyMobile(scope,AppConstants, InvestorsNewFolioContactService, LoaderService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window);
      }
    }
  }

function callLinkBodyMobile(scope, AppConstants, InvestorsNewFolioContactService, LoaderService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window) {
  scope.isEdit = false;
  scope.AppConstants = AppConstants;
  scope.change = {newMobileNumber : ""};
  scope.secLink = '';
  scope.secLink2 = '';
  scope.sendOTP = function (component) {
    sendOtp('mobile', scope, LoaderService, MessageService, InvestorsNewFolioContactService, component, ModalService , panAdharLinkingService , InvestorModel , $window);
  }

  scope.$on('formUpdated',function (event,args) {
    scope.currMobileNumber = args.mobileNo;
    scope.kycEmail = args.oldemail;
    scope.kycMobile = args.oldmobileNo;
  });
  /*scope.reSendOTP = function () {
    reSendOtp('mobile', scope, LoaderService, MessageService, InvestorsNewFolioContactService);
  }
  scope.verifyOTP = function () {
    verifyOTP('mobile', scope, LoaderService, MessageService, InvestorsNewFolioContactService);
  }*/
  scope.makeEdit = function () {
    var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
    var successHandler = function(resp) {
      scope.isEdit=true;
      scope.change.newMobileNumber = scope.currMobileNumber;
      scope.hideUiFnc();
    }

    var errorHandler = function(resp) {}


    if (scope.flowType === 'folio-creation-post-login') {
      var formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
      if ((formData.folioCreationRequestCO.soleApplicantDetail.oldemail || formData.folioCreationRequestCO.soleApplicantDetail.oldemail == "") && (formData.folioCreationRequestCO.soleApplicantDetail.oldemail !== formData.folioCreationRequestCO.soleApplicantDetail.email)) {
        scope.showEdit = false;
      } else if ((formData.folioCreationRequestCO.soleApplicantDetail.oldemail || formData.folioCreationRequestCO.soleApplicantDetail.oldemail == "") && (formData.folioCreationRequestCO.soleApplicantDetail.oldemail == formData.folioCreationRequestCO.soleApplicantDetail.email)) {
        scope.showEdit = true;
      }
    } else if (scope.flowType === 'new-investor') {
      var formData = JSON.parse(sessionStorage.getItem("verifyObj"));
      if ((formData.oldSoleApplicantEmail || formData.oldSoleApplicantEmail == "") && (formData.oldSoleApplicantEmail !== formData.email)) {
        scope.showEdit = false;
      } else if ((formData.oldSoleApplicantEmail || formData.oldSoleApplicantEmail == "") && (formData.oldSoleApplicantEmail == formData.email)) {
        scope.showEdit = true;
      }
    }



    if (scope.showEdit) {
      panAdharLinkingService.checkPanAdharStatus(scope.pan,'',brokerCode).then(successHandler).catch(errorHandler);
    } else {
      MessageService.error(scope.AppConstants.ToastrMessage.VALIDATE_DATA.UPDATE_CONTACT_EDIT_ERROR);
    }

  };
  scope.cancelUpdate =  function () {
    scope.isEdit = false;
    scope.showUiFnc();
  }
}

  /*@ngInject*/
  function updateNewFolioEmail(AppConstants, LoaderService, InvestorsNewFolioContactService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currEmail: '=',pan:'=',dob:'=',currMobileNumber: '@',updateContactInfo: "&" , showEdit : '=', flowType : '@' , kycEmail : '=' , kycMobile : '=', hideUi: '=' , hideUiFnc: "&" , showUiFnc: "&"},
      templateUrl: 'app/components/modal/transactionReview/directive/updateNewFolioEmail.html',
      link: function (scope) {
        callLinkBodyEmail(scope, AppConstants, LoaderService, InvestorsNewFolioContactService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window)
      }
    }
  }

  function callLinkBodyEmail(scope, AppConstants, LoaderService, InvestorsNewFolioContactService, MessageService, ModalService , panAdharLinkingService , InvestorModel , $window) {
    scope.isEdit = false;
    scope.AppConstants = AppConstants;
    scope.change = {newEmailId : ""};
    scope.secLink = '';
    scope.secLink2 = '';
    scope.sendOTP = function (component) {
      sendOtp('email', scope, LoaderService, MessageService, InvestorsNewFolioContactService, component, ModalService , panAdharLinkingService , InvestorModel , $window);
    }

    scope.$on('formUpdated',function (event,args) {
      scope.currEmail = args.email;
      scope.kycEmail = args.oldemail;
      scope.kycMobile = args.oldmobileNo;
    });
  /*  scope.reSendOTP = function () {
      reSendOtp('email', scope, LoaderService, MessageService, InvestorsNewFolioContactService);
    }
    scope.verifyOTP = function () {
      verifyOTP('email', scope, LoaderService, MessageService, InvestorsNewFolioContactService);
    }
    scope.cancelEdit = function () {
      scope.isEdit=false;
      scope.change.checkOTP='';
      scope.change.checkNewOTP='';
      scope.change.newEmailId='';
      scope.secretLink='';
    }
    */
    scope.makeEdit = function () {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var successHandler = function(resp) {
        scope.isEdit=true;
        scope.change.newEmailId = scope.currEmail;
        scope.hideUiFnc();
      }

      var errorHandler = function(resp) {}

      if (scope.flowType === 'folio-creation-post-login') {
        var formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
        if ((formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo || formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo == "") && (formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo !== formData.folioCreationRequestCO.soleApplicantDetail.mobileNo)) {
          scope.showEdit = false;
        } else if ((formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo || formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo == "") && (formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo == formData.folioCreationRequestCO.soleApplicantDetail.mobileNo)) {
          scope.showEdit = true;
        }
      } else if (scope.flowType === 'new-investor') {
        var formData = JSON.parse(sessionStorage.getItem("verifyObj"));
        if ((formData.oldSoleApplicantMobile || formData.oldSoleApplicantMobile == "") && (formData.oldSoleApplicantMobile !== formData.mobileNumber)) {
          scope.showEdit = false;
        } else if ((formData.oldSoleApplicantMobile || formData.oldSoleApplicantMobile == "") && (formData.oldSoleApplicantMobile == formData.mobileNumber)) {
          scope.showEdit = true;
        }
      }

      if (scope.showEdit) {
        panAdharLinkingService.checkPanAdharStatus(scope.pan,'',brokerCode).then(successHandler).catch(errorHandler);
      } else {
        MessageService.error(scope.AppConstants.ToastrMessage.VALIDATE_DATA.UPDATE_CONTACT_EDIT_ERROR);
      }

    };
    scope.cancelUpdate =  function () {
      scope.isEdit = false;
      scope.showUiFnc();
    }
  }

  function sendOtp(type, scope, LoaderService, MessageService, InvestorsNewFolioContactService, component, ModalService , panAdharLinkingService , InvestorModel , $window) {
    var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
            var confirmSuccess = function () {
              scope.isEdit = false;
              if(type === 'email'){
                scope.currEmail = scope.change.newEmailId;
              }else{
                scope.currMobileNumber = scope.change.newMobileNumber;
              }
            }
            var confirmError = function () {
              scope.isEdit = false;
            }
          ModalService.otpModal({
            'component': component,
            uuid: resp.data.id,
            respMessage: resp.data.message,
            secLink: resp.data.secretLink,
            secLink2: resp.data.secretLink2,
            folioNumber: scope.folioNumber,
            currMobileNumber: scope.currMobileNumber,
            newMobileNumber: scope.change.newMobileNumber,
            currEmail: scope.currEmail,
            newEmailId: scope.change.newEmailId,
            pan: scope.pan,
            dob: scope.dob
          }, confirmSuccess, confirmError);
        }
        else MessageService.error(resp.message);
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        MessageService.error();
        scope.isEdit = false;
      };
    var payload = {
      pan : scope.pan,
      dob: scope.dob
    };
    if(type==="email"){
      payload.email = scope.change.newEmailId;
      payload.change = "EMAIL";
    }else if(type==="mobile"){
      payload.mobileNo = scope.change.newMobileNumber;
      payload.change = "MOBILE";
    }

    if (component === 'new_folio') {
      if (scope.flowType === 'folio-creation-post-login') {
        var formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
        if(type==="email"){
          formData.folioCreationRequestCO.soleApplicantDetail.oldemail = scope.kycEmail ? scope.kycEmail : "";
          formData.folioCreationRequestCO.soleApplicantDetail.email = scope.change.newEmailId;
        }else if(type==="mobile"){
          formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo = scope.kycMobile ? scope.kycMobile : "";
          formData.folioCreationRequestCO.soleApplicantDetail.mobileNo = scope.change.newMobileNumber;
        }
        InvestorModel.setInvestorModel(formData);
        $window.sessionStorage.investorForm = angular.toJson(formData);
      } else if (scope.flowType === 'new-investor') {
        var formData = JSON.parse(sessionStorage.getItem("verifyObj"));
        if(type==="email"){
          formData.email = scope.change.newEmailId;
          formData.oldSoleApplicantEmail = scope.kycEmail;
        } else if(type==="mobile"){
          formData.mobileNumber = scope.change.newMobileNumber;
          formData.oldSoleApplicantMobile = scope.kycMobile;
        }
        $window.sessionStorage.setItem("verifyObj", JSON.stringify(formData));
      }
      scope.isEdit = false;
      scope.updateContactInfo();
      scope.showUiFnc();

    } else {
      LoaderService.showLoader('.popup');//v2/investor/unit-holder/update/contact/send/otp
      InvestorsNewFolioContactService.post({
        controller: 'unit-holder',
        child1:'2FA',
        child2: 'update',
        child3: 'contact',
        child4: 'send',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    }
  }

 /* function reSendOtp(type, scope, LoaderService, MessageService, InvestorsNewFolioContactService) {
    var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
          scope.secLink = resp.data.secretLink;
          scope.secLink2 = resp.data.secretLink2;
          scope.change.otpMessage = resp.data.message;
          resetTimer();
        } else MessageService.error(resp.message);
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        MessageService.error();
      };
    var payload = {
      pan : scope.pan,
      secretLink: scope.secLink,
      secretLink2: scope.secLink2,
      dob:scope.dob};
    if(type==="email"){
      payload.email = scope.change.newEmailId;
      payload.change = "EMAIL";
    }else if(type==="mobile"){
      payload.mobileNo = scope.change.newMobileNumber;
      payload.change = "MOBILE";
    }
    LoaderService.showLoader('.popup');//v2/investor/unit-holder/update/contact/send/otp
    InvestorsNewFolioContactService.post({
      controller: 'unit-holder',
      child1:'2FA',
      child2: 'update',
      child3: 'contact',
      child4: 'send',
      child5: 'otp'
    }, payload).$promise.then(success, error);
    var resetTimer = function () {
      scope.$broadcast('timer-add-cd-seconds', 30);
    }
  }

  function verifyOTP(type, scope, LoaderService, MessageService, InvestorsNewFolioContactService) {
    var success = function (resp) {
        scope.change.checkOTP = '';
        scope.change.checkNewOTP = '';
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
          scope.isEdit = false;
          if(type === 'email'){
            scope.currEmail = scope.change.newEmailId;
          }else{
            scope.currMobileNumber = scope.change.newMobileNumber;
          }
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        scope.isOTPSent = false;
        scope.isEdit = false;
        scope.change.checkOTP = '';
        scope.change.checkNewOTP = '';
        MessageService.error();
      };
    var payload = {
      otp: scope.change.checkOTP,
      otp2: scope.change.checkNewOTP,
      uniqueLink: scope.secLink,
      uniqueLink2: scope.secLink2
    }
    LoaderService.showLoader('.popup');
    InvestorsNewFolioContactService.post({
      controller: 'holder',
      child1: 'pan',
      child2: 'add',
      child3: 'email',
      child4: 'verify',
      child5: 'otp'
    }, payload).$promise.then(success, error);
  }
*/
})();


/**
 * Created by ttn on 21/08/18.
 */

(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .directive('updateSummaryMobile', updateSummaryMobile)
    .directive('updateFolioMobile', updateFolioMobile)
    .directive('updateSummaryEmail', updateSummaryEmail)
    .directive('updateFolioEmail', updateFolioEmail);

  /*@ngInject*/
  function updateSummaryMobile(AppConstants, InvestorsContactService, LoaderService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currMobileNumber: '=',folioNumber:'=',currEmail: '=', investorPan:'=',cFlag: '='},
      templateUrl: 'app/components/modal/transactionReview/directive/updateMobile.html',
      link: function (scope) {
        callLinkBodyMobile(scope,AppConstants, InvestorsContactService, LoaderService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService);
      }
    }
  }

  /*@ngInject*/
  function updateFolioMobile(AppConstants, InvestorsContactService, LoaderService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currMobileNumber: '=',folioNumber:'=',currEmail:'=', investorPan:'=',cFlag: '=', canEdit: '=', contactUpdated:'=',contactUpdatedError:'='},
      templateUrl: 'app/components/modal/transactionReview/directive/updateFolioMobile.html',
      link: function (scope) {
        callLinkBodyMobile(scope, AppConstants, InvestorsContactService, LoaderService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService);
      }
    }
  }

  function callLinkBodyMobile(scope, AppConstants, InvestorsContactService, LoaderService, MessageService, ModalService, InvestorServiceDynamicData, panAdharLinkingService) {
    scope.isEdit = false;
    scope.isOTPSent=false;
    scope.AppConstants = AppConstants;
    scope.change = {newMobileNumber : "", mobileBelongsTo : ""};
    scope.secLink = '';
    scope.secLink2 = '';
    scope.change.checkOTP='';
    scope.change.checkNewOTP='';
    scope.mobile_regex_digits = new RegExp(/^\+91[6-9][0-9]{9}$/);
    scope.mobile_regex_sameDigits = new RegExp(/^(\d)\1*$/);
    scope.isValid = true;
    scope.isMobileNotValid = false;
    scope.mobileList = [];
    scope.$watch(
      function() {
        return scope.canEdit;
      },
      function() {
        if(scope.canEdit == false) {
          scope.cancelEdit();
        }
      });
    scope.sendOTP = function (component) {
      sendOTP('mobile', scope, LoaderService, MessageService, InvestorsContactService, component, ModalService);
    }
    scope.reSendOTP = function () {
      reSendOTP('mobile', scope, LoaderService, MessageService, InvestorsContactService);
    }
    scope.verifyOTP = function () {
      verifyOTP('mobile', scope, LoaderService, MessageService, InvestorsContactService);
    }
    scope.makeEdit = function () {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var successHandler = function(resp) {
        scope.isEdit=true;
        scope.canEdit = true;
        scope.change.newMobileNumber = scope.currMobileNumber;
        scope.currFolioNumber = scope.folioNumber;
        scope.change.mobileBelongsTo = '';
        scope.mobileEmailBelongsTo();
      }

      var errorHandler = function(resp) {}

      if (scope.contactUpdated) {
        panAdharLinkingService.checkPanAdharStatus('',scope.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
      } else {
        MessageService.error(scope.contactUpdatedError);
      }


    };
    scope.cancelEdit = function () {
        scope.isEdit=false;
        scope.isOTPSent=false;
        scope.change.checkOTP='';
        scope.change.checkNewOTP='';
        scope.change.newEmailId='';
        scope.change.newMobileNumber='';
        scope.uuid='';
        scope.change.mobileBelongsTo = '';
    }
    scope.cancelUpdate =  function () {
      scope.isEdit = false;
      scope.change.mobileBelongsTo = '';
    }
    scope.changeMobileNumber = function(value) {
      changeMobileNumber(scope.change, scope);
    }

    scope.mobileEmailBelongsTo= function (){
      mobileEmailBelongsTo(scope, LoaderService, InvestorsContactService, MessageService, InvestorServiceDynamicData);
    };
  }

  /*@ngInject*/
  function updateSummaryEmail(AppConstants, LoaderService, InvestorsContactService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currEmail: '=',folioNumber:'=',currMobileNumber: '=',investorPan:'=',cFlag: '='},
      templateUrl: 'app/components/modal/transactionReview/directive/updateEmail.html',
      link: function (scope) {
        callLinkBodyEmail(scope, AppConstants, LoaderService, InvestorsContactService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService)
      }
    }
  }

  /*@ngInject*/
  function updateFolioEmail(AppConstants, LoaderService, InvestorsContactService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {currEmail: '=',folioNumber:'=',currMobileNumber: '=', investorPan:'=',cFlag: '=', canEdit: '=', contactUpdated:'=',contactUpdatedError:'='},
      templateUrl: 'app/components/modal/transactionReview/directive/updateFolioEmail.html',
      link: function (scope) {
        callLinkBodyEmail(scope, AppConstants, LoaderService, InvestorsContactService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService)
      }
    }
  }

  function callLinkBodyEmail(scope, AppConstants, LoaderService, InvestorsContactService, MessageService, ModalService, InvestorServiceDynamicData,panAdharLinkingService) {
    scope.isEdit = false;
    scope.isOTPSent=false;
    scope.AppConstants = AppConstants;
    scope.change = {newEmailId : "",emailBelongsTo: ""};
    scope.secLink = '';
    scope.secLink2 = '';
    scope.change.checkOTP='';
    scope.change.checkNewOTP='';
    scope.emailList = [];

    scope.$watch(
      function() {
        return scope.canEdit;
      },
      function() {
        if(scope.canEdit == false) {
          scope.cancelEdit();
        }
      });

    scope.sendOTP = function (component) {
      sendOTP('email', scope, LoaderService, MessageService, InvestorsContactService, component, ModalService,  panAdharLinkingService);
    }
    scope.reSendOTP = function () {
      reSendOTP('email', scope, LoaderService, MessageService, InvestorsContactService);
    }
    scope.verifyOTP = function () {
      verifyOTP('email', scope, LoaderService, MessageService, InvestorsContactService);
    }
    scope.makeEdit = function () {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var successHandler = function(resp) {
        scope.isEdit=true;
        scope.canEdit = true;
        scope.change.newEmailId = scope.currEmail;
        scope.currFolioNumber = scope.folioNumber;
        scope.change.emailBelongsTo = '';
        scope.mobileEmailBelongsTo();
      }

      var errorHandler = function(resp) {}

      if (scope.contactUpdated) {
        panAdharLinkingService.checkPanAdharStatus('',scope.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
      } else {
        MessageService.error(scope.contactUpdatedError);
      }



    };

    scope.cancelEdit = function () {
        scope.isEdit=false;
        scope.isOTPSent=false;
        scope.change.checkOTP='';
        scope.change.checkNewOTP='';
        scope.change.newEmailId='';
        scope.change.newMobileNumber='';
        scope.uuid='';
        scope.change.emailBelongsTo = '';
    }
    scope.cancelUpdate =  function () {
      scope.isEdit = false;
      scope.change.emailBelongsTo = '';
    }
    scope.mobileEmailBelongsTo= function (){
      mobileEmailBelongsTo(scope, LoaderService, InvestorsContactService, MessageService, InvestorServiceDynamicData);
    }
  }

  function sendOTP(type, scope, LoaderService, MessageService, InvestorsContactService, component, ModalService ,panAdharLinkingService) {
    var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
          if (component === 'folio') {
            var confirmSuccess = function () {
              scope.isEdit = false;
            }
            var confirmError = function () {
              scope.isEdit = false;
            }
            ModalService.otpModal({
              'component': component,
                uuid: resp.data.id,
                respMessage: resp.data.message,
                secLink: resp.data.secretLink,
                secLink2: resp.data.secretLink2,
                folioNumber: scope.folioNumber,
                currMobileNumber: scope.currMobileNumber,
                newMobileNumber: scope.change.newMobileNumber,
                currEmail: scope.currEmail,
                newEmailId: scope.change.newEmailId
            }, confirmSuccess, confirmError);
          } else {
            scope.uuid = resp.data.id;
            scope.sendOtpRespMessage = resp.data.message;
            scope.isOTPSent = true;
            scope.secLink = resp.data.secretLink;
            scope.secLink2 = resp.data.secretLink2;
          }
        }
        else {
          if(resp.popupEnabled) {
          ModalService.genericModal({
            text: resp.message
          });
        } else {
          MessageService.error(resp.message);            }
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        scope.isOTPSent = false;
        MessageService.error();
      };
    var payload = {folioNumber: scope.folioNumber,panNumber: scope.investorPan};
    if(type === 'email'){
      payload.oldValue = scope.currEmail;
      payload.value = scope.change.newEmailId;
      payload.changeFor = 'EMAIL';
      payload.emailBelongsTo = scope.change.emailBelongsTo;
    }else{
      payload.oldValue = scope.currMobileNumber;
      payload.value = scope.change.newMobileNumber;
      payload.changeFor = 'MOBILE';
      payload.mobileBelongsTo = scope.change.mobileBelongsTo;
    }
    LoaderService.showLoader('.popup');
    InvestorsContactService.post({
      controller: 'update',
      child1: 'folio',
      child2: 'contact-details'
    }, payload).$promise.then(success, error);
  }

  function reSendOTP(type, scope, LoaderService, MessageService, InvestorsContactService, ModalService) {
    scope.change.checkOTP = '';
    scope.change.checkNewOTP='';
    var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
          scope.uuid = resp.data.id;
          scope.sendOtpRespMessage = resp.data.message;
          scope.isOTPSent = true;
          resetTimer();
          scope.secLink = resp.data.secretLink;
          scope.secLink2 = resp.data.secretLink2;
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          } else {
            MessageService.error(resp.message);            }
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        scope.isOTPSent = false;
        MessageService.error();
      };
    var payload = {
      folioNumber: scope.folioNumber,
      secretLink: scope.secLink,
      secretLink2: scope.secLink2
    };
    if(type === 'email'){
      payload.oldValue = scope.currEmail;
      payload.value = scope.change.newEmailId;
      payload.changeFor = 'EMAIL';
    }else{
      payload.oldValue = scope.currMobileNumber;
      payload.value = scope.change.newMobileNumber;
      payload.changeFor = 'MOBILE';
    }
    LoaderService.showLoader('.popup');
    InvestorsContactService.post({
      controller: 'update',
      child1: 'folio',
      child2: 'contact-details'
    }, payload).$promise.then(success, error);
    var resetTimer = function () {
      scope.$broadcast('timer-add-cd-seconds', scope.AppConstants.RESEND_OTP_COUNTER);
    }
  }

  function  verifyOTP(type, scope, LoaderService, MessageService, InvestorsContactService) {
    var success = function (resp) {
        scope.change.checkOTP = '';
        scope.change.checkNewOTP='';
        LoaderService.hideLoader('.popup');
        if (resp && resp.status) {
          scope.isOTPSent = false;
          scope.isEdit = false;
          if(type === 'email'){
            scope.currEmail = scope.change.newEmailId;
          }else{
            scope.currMobileNumber = scope.change.newMobileNumber;
          }
          MessageService.success(resp.data.message);
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        scope.isOTPSent = false;
        scope.isEdit = false;
        scope.change.checkOTP = '';
        scope.change.checkNewOTP='';
        MessageService.error();
      };
    var payload = {
      otp: scope.change.checkOTP,
      otp2: scope.change.checkNewOTP,
      uniqueLink: scope.secLink,
      uniqueLink2: scope.secLink2
    }
    LoaderService.showLoader('.popup');
    InvestorsContactService.post({
      controller: 'folio',
      child1: 'verify',
      child2: 'otp'
    }, payload).$promise.then(success, error);
  }

  function mobileEmailBelongsTo(scope, LoaderService, InvestorsContactService, MessageService, InvestorServiceDynamicData){
    var success = function (resp) {
        if (resp.status && resp.data) {
          scope.emailList = resp.data.emailList;
          scope.mobileList=resp.data.mobileList;
        } else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        MessageService.error(resp.error);
      };

    InvestorServiceDynamicData.get({
      child1: 'contactType',
      child2: 'details'}).$promise.then(success, error);
  }

  function changeMobileNumber(value, scope) {

    if(value.newMobileNumber){
      scope.isValid = scope.mobile_regex_digits.test(scope.change.newMobileNumber);
      if(scope.isValid && scope.change.newMobileNumber && scope.change.newMobileNumber.length == 13) {
        scope.isMobileNotValid = scope.mobile_regex_sameDigits.test(scope.change.newMobileNumber.substring(3))
      }
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .directive('tpv', tpv);

  /*@ngInject*/
  function tpv($stateParams) {
    return {
      restrict: 'E',
      scope: {transactionType: '@'},
      templateUrl: 'app/mobile/tpv/tpv.html',
      link: function (scope) {
        scope.init = function(){
          scope.transactionType = $stateParams.tncType;
        }
      }
    }
  }
})();


/**
 * Created by ttn on 08/07/20.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NonKycModalController', nonKycModalController);

  /** @ngInject */
  function nonKycModalController($uibModalInstance, modalData, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function (arg) {
      $uibModalInstance.close(arg);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 08/07/20.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('KycInitiateModalController', kycInitiateModalController);

  /** @ngInject */
  function kycInitiateModalController($uibModalInstance, modalData, modalView, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.investorForm = {};
    vm.formData = {};
    vm.AppConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.closeModal = function (arg) {
      $uibModalInstance.dismiss();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.submitValue = function() {
      $uibModalInstance.close(vm.formData);
    };
  }
})();

/**
 * Created by ttn on 08/07/20.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('KycModalController', kycModalController);

  /** @ngInject */
  function kycModalController($uibModalInstance, modalData, modalView, $state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function (arg) {
      $uibModalInstance.close(arg);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionSwpController', initiateTransactionSwpController);

  /** @ngInject */
  function initiateTransactionSwpController($stateParams, $state, $timeout, $scope, AppConstants, AuthService, MessageService, ModalService, InvestorsService, moment, UtilService, TransactionService, LoaderService, SchemeService,HDFC_API, AgentSocketService, panAdharLinkingService, $cookies , $window , InvestorServiceDynamicData) {

    var vm = this;
    var identifier=AuthService.getToken();
    vm.formData = {};
    vm.init = init;
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.selectedSwpType = selectedSwpType;
    vm.submit = submit;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.changeDay = changeDay;
    vm.checkValidations = checkValidations;
    vm.confirmCancel = confirmCancel;
    vm.getTransactionDetails = getTransactionDetails;

    vm.frequencyList = AppConstants.SWP_FREQ_LIST_FOR_FIXED;
    vm.daysList = AppConstants.DAYS_LIST;
    vm.transactionConstants = AppConstants.TRANSACTION;
    vm.formData.swpType = 'F';
    vm.investorUUID = $stateParams.uuid;
    vm.folioListData = null;
    vm.startDate = null;
    vm.endDate = null;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isSubmitted = false;
    vm.investorInfo = '';
    vm.unitsDetails = null;
    vm.validations = null;
    vm.validationsData = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isReseting = false;
    vm.displayFlag = false;
    vm.displayScheme = false;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.hasFolioEmailId = true;
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.startMinDate = moment().add(13, 'days');/*10(valid day gap)+3(buffer day added)*/
    vm.startMaxDate = moment().add(120, 'days');
    vm.termsAndContitions = termsAndContitions;
    vm.showTerms = true;
    vm.blockFolioForTransaction = false;

    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }
      vm.appConstants = AppConstants;
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;

      if ($stateParams.transactionId) {
        vm.investorUUID = $stateParams.uuid;
        getInvestorInfo(function() {
          getTransactionDetails();
        });
      }
      else {
        getInvestorInfo(function() {
          folioList();
        });
      }

      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }
    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.schemeCode = resp.data.schemeCode;
            fetchUnitDetails();
            fetchSchemeValidations(function (err) {
              if (!err) {
                vm.formData.swpType = resp.data.swpType;
                vm.frequencyList = (vm.formData.swpType == vm.transactionConstants.CAPITAL_APPRECIATION) ? AppConstants.SWP_FREQ_LIST_FOR_CAPITAL : AppConstants.SWP_FREQ_LIST_FOR_FIXED;
                vm.formData.selectedFrequency = vm.frequencyList.find(function (item) {
                  return item.key === resp.data.frequency;
                });
                changeFrequency();
                vm.isShowDefault = 'true';
                vm.formData.selectedDay = vm.daysList.find(function (item) {
                  return item.value === +resp.data.swpDay;
                });
                vm.startDate = moment(resp.data.startDate);
                vm.endDate = moment(resp.data.toDate);
                changeDay();
                vm.formData.swpAmount = resp.data.amount;
                checkValidations();
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function getInvestorInfo(cb) {
      cb = cb || function () {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            if(identifierData && identifierData.loginType=='A'){
              $state.go('agent.home.distributor-home');
            } else {
              $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            }
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.selectedFrequency || !vm.unitsDetails) {
        return;
      }
      vm.validations = {};
      switch (vm.formData.selectedFrequency.key) {
        case 'Q':
          vm.validations.amountMultiples = validationsData.quarterlyAmtMultiples;
          vm.validations.maxAmount = validationsData.quarterlyMaxAmt;
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.quarterlyMinAmt;
          vm.validations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.validations.amountMultiples = validationsData.monAmtMultiples;
          vm.validations.maxAmount = validationsData.monMaxAmt;
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.monMinAmt;
          vm.validations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.validations.amountMultiples = validationsData.halfYearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.halfYearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.halfYearlyMinAmt;
          vm.validations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.validations.amountMultiples = validationsData.yearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.yearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.yearlyMinAmt;
          vm.validations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      checkValidations();
      vm.validations.minInstallDivisionFlag = validationsData.minInstallDivisionFlag;
      vm.validations.swpTaxCode = validationsData.swpTaxCode;
    }

    function folioList() {
      LoaderService.showLoader();
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = resp.data.folioList || [];
          var folio = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            folio.push(obj);
          }
          vm.folioListData = folio;
          if ($stateParams.folioNumber) {
            vm.formData.folioNumber = $stateParams.folioNumber;
            vm.changeFolio();
          }
        } else {
          vm.folioListData = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.folioListData = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function fetchSchemes() {
      vm.schemes = null;
      vm.unitsDetails = null;
      if (!vm.formData.folioNumber) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;

            if ($stateParams.schemeCode) {
              vm.formData.schemeCode = $stateParams.schemeCode;
              fetchUnitDetails();
            }
            else if ($stateParams.transactionId) {
              fetchUnitDetails();
            }
          } else {
            vm.schemes = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.schemes = null;
        };
      InvestorsService.post({
        controller: 'folio',
        child1: 'schemes'
      }, {folioNumber: vm.formData.folioNumber, transactionType: 'swp', swpType:vm.formData.swpType}).$promise.then(success, error);
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
        };
      if (!vm.formData.schemeCode) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_OUT_SCHEME);
        return;
      }
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.selectedDay = '';
      vm.formData.swpAmount = '';
      vm.formData.selectedFrequency = null;
      vm.validationsData = null;
      vm.validations = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      var success = function (resp) {
          if (resp.status && resp.data) {
            cb(null);
            vm.validationsData = resp.data;
            vm.isSchemeDisabled = vm.validationsData.swpEnabled === 'N';
          } else {
            cb('error');
            MessageService.error(resp.message);
            vm.validationsData = null;
          }
        },
        error = function (err) {
          vm.validationsData = null;
          cb('error');
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'swp',
        child1: vm.formData.schemeCode
      }, null).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      vm.validations = null;
      vm.unitsDetails = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      fetchSchemeValidations();
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "SWP"
      }).$promise.then(success, error);
    }

    function selectedSwpType(transferOpt) {
      vm.formData.swpType = transferOpt;
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.selectedDay = '';
      vm.formData.swpAmount = '';
      vm.formData.selectedFrequency = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      resetDefaults();

      if (vm.formData.swpType == 'F') {
        vm.frequencyList = AppConstants.SWP_FREQ_LIST_FOR_FIXED;
        vm.formData.selectedFrequency = vm.frequencyList[0];
      } else {
        vm.frequencyList = AppConstants.SWP_FREQ_LIST_FOR_CAPITAL;
        vm.formData.selectedFrequency = vm.frequencyList[0];
      }
      fetchSchemes();
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.hasWarning){
              var successModal= function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg:resp.data.warningMessage}, successModal, errorModal)
            }
            else{
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType:'SWP',
        folioNumber:vm.formData.folioNumber,
        schemeCode:vm.formData.schemeCode,
        amount: vm.formData.swpAmount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    function submit() {
      var payload = {
        "amount": vm.formData.swpAmount,
        "folioNumber": vm.formData.folioNumber,
        "formType": "SWP",
        "frequency": vm.formData.selectedFrequency.key,
        "id": $stateParams.transactionId || "",
        "schemeCode": vm.formData.schemeCode,
        "startDate": vm.startDate.clone().format('DD-MMM-YYYY'),
        "swpDay": vm.formData.selectedDay,
        "swpType": vm.formData.swpType,
        "toDate": vm.endDate.clone().format('DD-MMM-YYYY')
      };

      vm.isSubmitted = true;
      var successSwpModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
          }
          // $state.go('main.dashboard');
        },
        errorSwpModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }

        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'SWP',
              investorName: vm.investorInfo.name
            }, successSwpModal, errorSwpModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };

      var _scheme = vm.schemes && vm.schemes.find(function (i) {
          return i.schemeCode == vm.formData.schemeCode;
        }) || {};
      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        schemeName: _scheme.schemeName,
        swpDay: vm.formData.selectedDay,
        frequency: vm.formData.selectedFrequency.value,
        mobileNumber : vm.mobileNumber ? vm.mobileNumber : '',
        emailId : vm.emailId ? vm.emailId : '',
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag
      };
      ModalService.transactionReviewModal({payload: payload, controller: 'swp', additionalData: additionalData}, success, error);
    }

    function updateDatesForDaily() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      // var _dd = vm.startDate.format('DD');
      //vm.formData.selectedDay = {name: _dd, value: _dd};
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = moment(vm.startDate);
      } else {
        currentDay = moment().add(3, 'days');
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === vm.formData.selectedDay) {
          enabledStartDates.push(_date.clone());
        }
      }
      !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      vm.enabledStartDates = angular.copy(enabledStartDates);
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? moment(vm.startDate) : moment();
      } else {
        // currentDay = moment();
        currentDay = vm.startMinDate?vm.startMinDate:moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      /*var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.selectedDay.value);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      while (_diff < 10) {
        updatedDate.add(1, 'months').set('date', vm.formData.selectedDay.value);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }
      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }
      !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      vm.enabledStartDates = angular.copy(enabledStartDates);*/
      //vm.startDate = angular.copy(currentDay.clone());
      updateEndDates();
    }

    function updateEndDates() {
      if (!vm.startDate) {
        return;
      }
      // var defaultEndDate = new Date(2036, 12, 31);
      var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      switch (vm.formData.selectedFrequency.key) {
        case'DZ':
        case'OW':
          var days = 0;
          endDate = vm.startDate.clone().add(vm.formData.selectedFrequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.formData.selectedFrequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = vm.formData.selectedFrequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          //endDate = vm.startDate.clone().add(vm.formData.selectedFrequency.monthfreq, 'months');
          endDate = vm.startDate.clone().add(vm.formData.selectedFrequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.formData.selectedFrequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = vm.formData.selectedFrequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      // !$stateParams.transactionId && (vm.endDate = vm.enabledEndDates[0]);
      // vm.endDate = vm.enabledEndDates[0];
      vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
      vm.maxEndDate = new Date(2099, 12, 31);
    }

    function changeFrequency() {
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.selectedDay = null;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);

      extractValidationObject(vm.validationsData);
      if (vm.formData.selectedFrequency && vm.formData.selectedFrequency.key === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        updateDatesForDaily()
      } else if (vm.formData.selectedFrequency && vm.formData.selectedFrequency.key === 'OW') {
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'days';
      } else {
        vm.daysList = AppConstants.DAYS_LIST;
        vm.viewMode = 'months';
      }
      vm.changeDay();
    }

    function changeDay() {
      if (!vm.formData.selectedFrequency) {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
        return;
      }

      switch (vm.formData.selectedFrequency.key) {
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          vm.endDate = null;
          vm.enabledEndDates = null;
          break;
      }
    }

    function changeStartDate(date) {
      /*if(date) {
        vm.startDate = moment(date);
        vm.startDate && vm.startDate.set({'year': date.year(), 'month': date.month()});
        updateEndDates();
      }
      else {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
      }*/

      vm.startDate = date ? date : null;
      //vm.sipDay = vm.startDate ? vm.startDate.format('D') : '';
      vm.formData.selectedDay = vm.startDate ? vm.startDate.format('D') : '';
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);

      updateEndDates();
      /*vm.startDate && vm.startDate.set({'year': date.year(), 'month': date.month()});
      updateEndDates();*/
    }

    function changeEndDate(date) {
      /*if(date) {
        vm.endDate && vm.endDate.set({'year': date.year(), 'month': date.month()});
      }
      else {
        vm.endDate = null;
        vm.enabledEndDates = null;
      }*/
      vm.endDate = date ? date : null;
      //setInstallmentCount();
      /*vm.endDate && vm.endDate.set({'year': date.year(), 'month': date.month()});*/
    }

/*
    function setInstallmentCount() {
      var daysDuration;
      switch (vm.formData.selectedFrequency.key) {
        case'DZ':
          vm.formData.installment = vm.endDate.diff(vm.startDate, 'days') + 1;
          break;
        case 'OW':
          daysDuration = (vm.endDate.diff(vm.startDate, 'days') + 1) / 7;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'OM' :
          daysDuration = vm.endDate.diff(vm.startDate, 'months') + 1;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'Q':
          daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 3;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'H':
          daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 6;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'Y':
          vm.formData.installment = vm.endDate.diff(vm.startDate, 'years');
          break;
        default :
      }
    }
*/

    function checkValidations() {
      if (vm.formData.swpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations && vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.swpAmount);
        vm.isMin = !!(vm.validations && vm.validations.minAmount && vm.validations.minAmount > vm.formData.swpAmount);
        vm.isMultiples = vm.validations && vm.formData.swpAmount && (vm.formData.swpAmount % vm.validations.amountMultiples === 0) || false;
      }
    }

    function resetDefaults() {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = null;
      extractValidationObject(vm.validationsData);
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;
        var identifier = AuthService.getToken();
        if(identifier && identifier.loginType=='A'){
          $state.go('agent.home.distributor-home');
        } else{
          _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
        }
      };

      ModalService.confirmCancelModal({}, success);
    }

    vm.changeFrequency = function () {
      resetDefaults();
      changeFrequency();
      if (vm.formData.swpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.formData.swpAmount = 300;
      } else {
        vm.formData.swpAmount = '';
      }
    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        vm.submit();
        e.preventDefault();
      }
      return false;
    };

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.folioNumber = null;
            resetAll();
          }
        });
      }

      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.formData.selectedFrequency = vm.frequencyList[0];
          vm.hasFolioEmailId && fetchSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.hasFolioEmailId = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);


    };

    function getSwpPayloadToSave() {
      var payload = {
        "amount": vm.formData.swpAmount,
        "folioNumber": vm.formData.folioNumber,
        "formType": "SWP",
        "frequency": vm.formData.selectedFrequency?vm.formData.selectedFrequency.key:'',
        "id": $stateParams.transactionId || "",
        "schemeCode": vm.formData.schemeCode,
        "swpDay": vm.formData.selectedDay,
        "swpType": vm.formData.swpType
      };
      /*var payload = {
        "amount":1000,
        "folioNumber":"10301635",
        "formType":"SWP",
        "frequency":"OM",
        "id":"",
        "schemeCode":"44",
        "startDate":"02-Mar-2018",
        "swpDay":"2",
        "swpType":"F",
        "toDate":"02-Jan-2019",
        "approvalMode":"Online"
      }*/
      return angular.copy(payload);
    }
    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getSwpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'swp',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.formData.schemeCode) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });
    /*Socket code End*/

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };

    function resetAll() {
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.selectedDay = '';
      vm.formData.swpAmount = '';
      vm.formData.selectedFrequency = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.formData.schemeCode = null;
      vm.unitsDetails = null;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionSwitchController', initiateTransactionSwitchController);

  /** @ngInject */
  function initiateTransactionSwitchController($log, $timeout, $stateParams, $scope, $rootScope, AuthService, StoreInvestorModel, MessageService, ModalService, InvestorsService, SchemeService, TransactionService, AppConstants, $state, LoaderService, UtilService, HDFC_API, AgentSocketService, $window , DynamicData,panAdharLinkingService, $cookies , InvestorServiceDynamicData) {

    var vm = this;
    vm.switchDevidendOptions = [AppConstants.TRANSACTION.REINVEST, AppConstants.TRANSACTION.PAYOUT];
    vm.CONST = {
      GROWTH: AppConstants.TRANSACTION.GROWTH,
      DIVIDEND: AppConstants.TRANSACTION.DIVIDEND,
      REINVEST: AppConstants.TRANSACTION.REINVEST,
      PAYOUT: AppConstants.TRANSACTION.PAYOUT,
      AMOUNT_TYPE: AppConstants.TRANSACTION.AMOUNT_TYPE
    };
    vm.formData = {
      switchDividentOption: '',
      selectedInSchemeCode: '',
      selectedOutScheme: '',
      amountType: 'amount',
      selectedFolioNo: '',
      allUnits: '',
      switchAmount: '',
      noOfUnits: '',
      amount: '',
      units: '',
      minorFlag:'false',
      subBrokerARN:'',
      subBrokerCode: ''
    };
    vm.isSelectedInScheme = true;
    vm.isSelectedSwitchInScheme = true;
    vm.conversionValue = '';
    vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.folioListData = null;
    vm.investorUUID = $stateParams.uuid;
    vm.unitsDetails = null;
    vm.isInScheme = false;
    vm.inSchemeValidations = null;
    vm.outSchemeValidations = null;
    vm.isReseting = false;
    vm.validations = {minAmount: 0, minUnits: 0, maxAmount: 0, maxUnits: 0};
    vm.investorInfo = null;
    vm.amountFromTransaction = null;
    vm.unitsFromTrancsaction = null;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.isSubmitted = false;
    vm.hasFolioEmailId = true;
    vm.getEuinCodes = getEuinCodes;
    vm.changeAmountType = changeAmountType;
    vm.formData.euinObj = null;
    vm.downloadReport = $scope.$parent.InitiateTransaction.downloadReport;
    vm.termsAndContitions = termsAndContitions;
    vm.fetchSwitchInSchemeValidations = fetchSwitchInSchemeValidations;
    vm.round = round;
    vm.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.DynamicData = DynamicData ;
    vm.DynamicNote = vm.DynamicData.noteDTO.noteDTOMap.Note_Switch;
    vm.showTerms = true;
    vm.blockFolioForTransaction = false;

    function round(value, decimals) {
      return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    }
    var identifier = AuthService.getToken();
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      StoreInvestorModel.setInvestorDetail(null);
    });

    function resetValueFields() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function folioList() {
      var payload = {
        "investorUUID": vm.investorUUID
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = resp.data.folioList || [];
            var folio = [];
            for (var i in folioList) {
              var obj = {}, item = folioList[i];
              obj.key = i;
              obj.activeFlag = item.activeFlag;
              obj.folioId = item.folioId;
              obj.folioNo = item.folioNumber;
              obj.minorFlag=item.minorFlag;
              obj.holderDOBExists = item.holderDOBExists;
              obj.retirementSchemeBlankDOBErrorMsg = item.retirementSchemeBlankDOBErrorMsg;
              obj.corporateInvestor = item.corporateInvestor;
              folio.push(obj);
            }
            vm.folioListData = folio;
            if ($stateParams.folioNumber) {
              vm.formData.selectedFolioNo = $stateParams.folioNumber;
              vm.changeFolio();
            }
            else if ($stateParams.transactionId) {
              vm.changeFolio();
            }
          } else {
            vm.folioListData = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function checkValidations() {

      if (vm.formData.selectedInSchemeCode && vm.formData.selectedInSchemeCode) {
        fetchCalculatedSwitchValidations();
      }
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.minUnits = vm.validations.minUnits || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : vm.unitsDetails.freeValueUnits;
      }

      var minAmount = 0;
      var minUnits = 0;
      var maxAmount = 0;
      var maxUnits = 0;

      if (vm.outSchemeValidations) {
        minAmount = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) || minAmount;
        minAmount = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt > minAmount) ? vm.outSchemeValidations.switchOutMinAmt : minAmount;
        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit * vm.outSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt < maxAmount) ? vm.outSchemeValidations.switchOutMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        minUnits = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit > minUnits) ? vm.outSchemeValidations.switchOutMinUnit : minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        maxUnits = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt / vm.outSchemeValidations.navValue) || maxUnits;
        maxUnits = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit < maxUnits) ? vm.outSchemeValidations.switchOutMaxUnit : maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
      }

      if (vm.inSchemeValidations && vm.outSchemeValidations) {
        if (vm.inSchemeValidations && vm.inSchemeValidations.addlswitchInPurchase
          && vm.inSchemeValidations.switchInMinAddlPurchaseAmt) {
          minAmount = vm.inSchemeValidations.switchInMinAddlPurchaseAmt;
          vm.validations.minAmount = minAmount;
        } else {
          minAmount = vm.inSchemeValidations.switchInMinUnit && (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) || minAmount;
          minAmount = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt > minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount;
          vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;
        }

        maxAmount = vm.inSchemeValidations.switchInMaxUnit && (vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt < maxAmount) ? vm.inSchemeValidations.switchInMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        var _minUnits = vm.inSchemeValidations.switchInMinUnit && ((vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = minUnits > _minUnits ? minUnits : _minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        var _maxUnits = vm.inSchemeValidations.switchInMaxUnit && ((vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = maxUnits < _maxUnits ? maxUnits : _maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;

        vm.validations.isEnabled = vm.inSchemeValidations.switchInUnitEnabled;
        $log.info('F vali>>', vm.validations);
      }
    }

    vm.changePurchaseAmount = function (sipPurchaseForm) {
      if (vm.inSchemeValidations && vm.inSchemeValidations.addlswitchInPurchase) {
        vm.isMinPurchaseAmount = vm.inSchemeValidations && vm.inSchemeValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
        vm.minAmountValidation = vm.inSchemeValidations.minAddlPurchaseAmt;
      } else {
        vm.isMinSwitchAmount = vm.inSchemeValidations && vm.inSchemeValidations.switchInMinAmt > vm.formData.purchaseAmount;
        vm.minAmountValidation = vm.inSchemeValidations.minFirstPurchaseAmt;
      }

      if (vm.formData.purchaseAmount < vm.minAmountValidation) {
        sipPurchaseForm.$invalid = true;
      }
    };

    function fetchInSchemes(cb) {
      cb = cb || function () {

      }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemes = resp.data.schemeList;
            vm.filteredinSchemeList = UtilService.getFilteredList(vm.inSchemes);
            cb(true)
          } else {
            vm.inSchemes = null;
            cb(false);
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.inSchemes = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'switchenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function fetchOutSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.selectedOutScheme) {
       return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            cb(null);
            vm.outSchemeValidations = resp.data;
          } else {
            cb('error');
            vm.outSchemeValidations = null;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          vm.outSchemeValidations = null;
          cb('error');
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'switch',
        child1: vm.formData.selectedOutScheme,
        child2: vm.formData.selectedFolioNo
      }, null).$promise.then(success, error);
    }
    vm.validationsApi = {};
    function fetchCalculatedSwitchValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.selectedInSchemeCode && !vm.formData.selectedOutScheme) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            // vm.inSchemeValidations = resp.data;
            (angular.isDefined(resp.data.minAmount)) && (vm.validationsApi.minAmount = resp.data.minAmount);
            (angular.isDefined(resp.data.maxAmount)) && (vm.validationsApi.maxAmount = resp.data.maxAmount);
            (angular.isDefined(resp.data.maxUnits)) && (vm.validationsApi.maxUnits = resp.data.maxUnits);
            (angular.isDefined(resp.data.minUnits)) && (vm.validationsApi.minUnits = resp.data.minUnits);
            if(angular.isDefined(vm.outSchemeValidations.navValue)){
              var _minUnitByNav = vm.outSchemeValidations.navValue !=0?
                vm.validationsApi.minAmount/vm.outSchemeValidations.navValue:0;
              vm.validationsApi.minUnits = round(Math.max(vm.validationsApi.minUnits, _minUnitByNav),2)
            }
            $log.info('S vali>>', vm.validationsApi);
            cb(null);
          } else {
            cb('error');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb('error');
          UtilService.errorHandler(err);
        };

      var valPayload = {
        "folioNo":vm.formData.selectedFolioNo,
        "inSchemeCode":vm.formData.selectedInSchemeCode,
        "outSchemeCode":vm.formData.selectedOutScheme,
        "transactionType":"SWITCH"
      };
      SchemeService.post({
        controller: 'schemeValidation',
        child1: 'validationCal',
      }, valPayload).$promise.then(success, error);
    }

    function fetchInSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.selectedInSchemeCode) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;


            if (vm.inSchemeValidations.investmentOption=== vm.CONST.GROWTH) {
              vm.formData.switchDividentOption = AppConstants.DIVIDEND_OPTIONS.GROWTH;
            } else {

              if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === false){
                vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
              }else if(vm.inSchemeValidations.dividendPayoutApplicable === false && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                vm.formData.switchDividentOption = AppConstants.TRANSACTION.REINVEST;
              }else if(vm.inSchemeValidations.dividendPayoutApplicable === true && vm.inSchemeValidations.dividendReinvestmentApplicable === true) {
                vm.formData.switchDividentOption = AppConstants.TRANSACTION.REINVEST;
              }
            }
            cb(null);

            /*if (vm.selectedSchemeType === 'ELSS' && vm.inSchemeValidations.investmentOption !== "GROWTH") {
              vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
            }
            else if (vm.inSchemeValidations) {
              vm.formData.switchDividentOption = (vm.inSchemeValidations.investmentOption === "GROWTH") ? "Z" : (vm.inSchemeValidations.endingType === vm.ENDING_TYPES.CLOSED ? AppConstants.TRANSACTION.PAYOUT : AppConstants.TRANSACTION.REINVEST)
            } else {
              vm.formData.switchDividentOption = AppConstants.TRANSACTION.REINVEST;
            }*/
          } else {
            cb('error');
            // vm.inSchemeValidations = null;
            // MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'switch',
        child1: vm.formData.selectedInSchemeCode,
        child2: vm.formData.selectedFolioNo
      }, null).$promise.then(success, error);
    }

    function fetchSwitchInSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.selectedInSchemeCode) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.switchInSchemeValidations = resp.data;
            vm.switchSchemeInvestmentOption = vm.switchInSchemeValidations.investmentOption;
            if (vm.selectedSwitchInSchemeType === 'ELSS' && vm.switchInSchemeValidations.investmentOption !== "GROWTH") {
              vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
            }
            else if (vm.switchInSchemeValidations) {
              vm.formData.autoSwitchSchemeDividendOption = (vm.switchInSchemeValidations.investmentOption === "GROWTH") ? "Z" : (vm.switchInSchemeValidations.endingType === vm.ENDING_TYPES.CLOSED ? AppConstants.TRANSACTION.PAYOUT : AppConstants.TRANSACTION.REINVEST)
            } else {
              vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.REINVEST;
            }
            checkValidations();
            cb(null);
          } else {
            cb('error');
            vm.switchInSchemeValidations = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb('error');
          vm.switchInSchemeValidations = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'switch',
        child1: vm.formData.selectedAutoSwitchInSchemeCode,
        child2: vm.formData.selectedFolioNo
      }, null).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      vm.unitsDetails = null;
      if (!vm.formData.selectedOutScheme) {
        return;
      }
      LoaderService.showLoader();

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.isDisabled = !resp.data.freeValueUnits;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            checkValidations();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        schemeCode: vm.formData.selectedOutScheme,
        folioNo: vm.formData.selectedFolioNo,
        transactionType:'switch'
      }).$promise.then(success, error);
    }

    function getInvestorInfo(cb) {
      cb = cb || function () {

      }
      var payload = {"investorUUID": vm.investorUUID};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb(false);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.investorInfo = null;
        UtilService.errorHandler(err);
        cb(false);
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function getEuinCodes() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.euinList = resp.data.euinList;
          vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
        } else {
          LoaderService.hideLoader();
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinList = [
              {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              }
            ];
            vm.formData.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
            vm.formData.selectedFolioNo = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.selectedOutScheme = resp.data.switchOutSchemeCode;
            fetchUnitDetails();
            fetchOutSchemeValidations(function (err) {
              if (!err) {
                vm.formData.selectedInSchemeCode = resp.data.switchInSchemeCode;
                vm.formData.switchDividentOption = resp.data.dividendOption;
                if (vm.inSchemes && vm.inSchemes.length > 0) {
                  var result = vm.inSchemes.find(function (scheme) {
                    return scheme.schemeCode === resp.data.switchInSchemeCode;
                  });
                  vm.selectedInScheme = result.scheme;
                }
                fetchInSchemeValidations(function (err) {
                  if (!err) {
                    vm.formData.switchAmount = resp.data.amount;
                    vm.formData.units = resp.data.units;
                    vm.formData.amountType = !vm.formData.units ? 'amount' : (vm.formData.units < vm.unitsDetails.freeValueUnits) ? 'units' : 'all_units';
                    checkValidations();
                  }
                });
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller: 'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function submitSwitchTransaction() {
      vm.isSubmitted = true;

      if (!vm.inSchemeValidations || !vm.inSchemeValidations.investmentOption) {
        MessageService.error("Invalid Investment option is selected.");
        vm.isSubmitted = false;
        return;
      }

      if (!vm.inSchemeValidations || !vm.inSchemeValidations.navValue) {
        MessageService.error("Scheme validations is unavailable to calculate equivalent value.");
        vm.isSubmitted = false;
        return;
      }

      var payload = {
        folioNumber: vm.formData.selectedFolioNo,
        formType: "SWITCH",
        id: $stateParams.transactionId || "",
        investmentOption: vm.inSchemeValidations.investmentOption,
        dividendOption: vm.inSchemeValidations.investmentOption === "GROWTH" ? "Z" : vm.formData.switchDividentOption,
        switchInSchemeCode: vm.formData.selectedInSchemeCode,
        switchOutSchemeCode: vm.formData.selectedOutScheme,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.selectedAutoSwitchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null,
        transactionMode: vm.CONST.AMOUNT_TYPE[vm.formData.amountType]
      };
      if (!vm.oversea_arn) {
        payload.euinOpted = vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N';
        payload.euinCode = vm.formData.euinObj && vm.formData.euinObj.euinCode || '';
        payload.euinName = vm.formData.euinObj && vm.formData.euinObj.euinName || '';
      } else {
        payload.euinOpted = 'N';
      }
      if (vm.formData.amountType == 'units') {
        payload.units = vm.formData.units;
        payload.amount = 0;
      } else if (vm.formData.amountType === 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      } else {
        payload.amount = vm.formData.switchAmount;
        payload.units = 0;
      }

      if(vm.formData.subBrokerARN){
        payload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        payload.subBrokerCode = vm.formData.subBrokerCode;
      }

      var successSwitchModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go('agent.home.distributor-home');
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
          // $state.go('main.dashboard');
        },
        errorSwitchModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier.loginType == 'A') {
            $state.go('agent.home.distributor-home');
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'SWITCH',
              investorName: vm.investorInfo.name
            }, successSwitchModal, errorSwitchModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };

      var _scheme = vm.outSchemes && vm.outSchemes.find(function (i) {
        return i.schemeCode === vm.formData.selectedOutScheme;
      }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        sourceSchemeName: _scheme.schemeName,
        targetSchemeName: vm.selectedInScheme,
        mobileNumber: vm.mobileNumber ? vm.mobileNumber : '',
        emailId: vm.emailId ? vm.emailId : '',
        autoSchemeToSwitchIn: vm.selectedAutoSwitchInScheme,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        switchSchemeInvestmentOption: vm.switchSchemeInvestmentOption,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null,
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag,
        subBrokerArn: vm.formData.subBrokerARN,
        subBrokerCode: vm.formData.subBrokerCode,
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName ? vm.formData.euinObj.euinName : null,
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode ? vm.formData.euinObj.euinCode : null
      };

      ModalService.transactionReviewModal({
        payload: payload, controller: 'switch', additionalData: additionalData
      }, success, error);

    }

    vm.init = function () {

      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }
      if ($stateParams.transactionId) {
        vm.investorUUID = $stateParams.uuid;
        getInvestorInfo(function () {
          getTransactionDetails();
        });
      } else {
        getEuinCodes();
        getInvestorInfo(function() {
          folioList();
        });
      }
      checkForTermsAndConditions();

    };

    vm.confirmCancel = function () {
      var success = function () {
        var _statusType = $stateParams.status;

        var identifier = AuthService.getToken();
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }

      };
      ModalService.confirmCancelModal({}, success);
    };

    vm.fetchOutSchemes = function () {
      vm.outSchemes = null;
      if (!vm.formData.selectedFolioNo) {
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.outSchemes = resp.data.schemes;
            if ($stateParams.schemeCode) {
              vm.formData.selectedOutScheme = $stateParams.schemeCode;
              fetchUnitDetails();
            }
          } else {
            vm.outSchemes = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.outSchemes = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'folio',
        child1: 'schemes'
      }, {folioNumber: vm.formData.selectedFolioNo,transactionType: 'switch'}).$promise.then(success, error);
    };

    vm.fetchNfoEnabledSchemes = function () {
      if (vm.formData.isAutoSwitch) {

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.autoSwitchInSchemes = resp.data.schemeList;
              for (var i in vm.autoSwitchInSchemes) {
                if (vm.autoSwitchInSchemes[i].schemeCode == 'LFGN') {
                  vm.selectedAutoSwitchInScheme = vm.autoSwitchInSchemes[i].scheme;
                  vm.formData.selectedAutoSwitchInSchemeCode = vm.autoSwitchInSchemes[i].schemeCode;
                  vm.isSwitchInScheme = !!(vm.selectedAutoSwitchInScheme);
                  //vm.inSchemeChanged(vm.autoSwitchInSchemes[i])
                  if (vm.autoSwitchInSchemes[i].schemeType == 'ELSS' && vm.autoSwitchInSchemes[i].scheme.toLowerCase().includes('dividend')) {
                    vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
                  }
                  fetchSwitchInSchemeValidations();
                }
              }
            } else {
              vm.autoSwitchInSchemes = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            vm.autoSwitchInSchemes = null;
            UtilService.errorHandler(err);
          };
        SchemeService.get({
          controller: 'scheme',
          type: 'ALL',
          child1: 'autoSwitchenabled',
          child2: vm.formData.minorFlag
        }, null).$promise.then(success, error);

      }
    };

    vm.getSchemesList = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.isInScheme = false;
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      resetValueFields();
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.selectedInScheme = null;
            return;
          }
          if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
            vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
          }
          vm.formData.selectedInSchemeCode = result.schemeCode;
          vm.selectedInScheme = result.scheme;
          vm.isInScheme = true;
          vm.selectedSchemeType = result.selectedSchemeType;
          if (result.nfoEnabled == 'Y') {
            vm.nfoEnabled = true;
          } else {
            vm.nfoEnabled = false;
          }
          fetchInSchemeValidations();
        },
        errorSchemeList = function () {
          vm.isInScheme = false;
          vm.formData.selectedInSchemeCode = '';
          vm.selectedInScheme = '';
        };

      ModalService.schemeListModal({
        enabledScheme: "switchenabled",
        isMinor: vm.formData.minorFlag,
        corporateFlag: vm.selectedFolioData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    };

    vm.getAutoSwitchEnabledList = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.isInScheme = false;
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      resetValueFields();
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
            vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
          }
          vm.formData.selectedAutoSwitchInSchemeCode = result.schemeCode;
          vm.selectedAutoSwitchInScheme = result.scheme;
          vm.isSwitchInScheme = true;
          vm.selectedSwitchInSchemeType = result.selectedSchemeType;
          fetchSwitchInSchemeValidations();
        },
        errorSchemeList = function () {
          vm.isSwitchInScheme = false;
          vm.formData.selectedAutoSwitchInSchemeCode = '';
          vm.autoSwitchInSchemes = '';
        };

      ModalService.schemeListModal({
        enabledScheme: "autoSwitchenabled",
        isMinor: vm.investorInfo.minor
      }, successSchemeList, errorSchemeList);
    };

    vm.outSchemeChanged = function () {
      vm.formData.isAutoSwitch = false;
      vm.formData.selectedInSchemeCode = '';
      vm.selectedInScheme = '';
      vm.isInScheme = false;
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      vm.formData.allUnits = '';
      vm.formData.amountType='amount';
      resetValueFields();
      fetchUnitDetails();
      fetchOutSchemeValidations();
    };

    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.selectedInScheme = null;
          vm.filterInSchemeList();
          return;
        }
        vm.formData.selectedInSchemeCode = schemeData.schemeCode;
        vm.selectedSchemeType = schemeData.schemeType;
        vm.selectedInScheme = schemeData.scheme;
        vm.isInScheme = !!(vm.selectedInScheme);
        vm.formData.switchAmount = '';
        vm.formData.noOfUnits = '';

        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        if (schemeData.schemeType == 'ELSS' && schemeData.scheme.toLowerCase().includes('dividend')) {
          vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
        }
        resetValueFields();
        fetchInSchemeValidations();
      }
    };

    vm.switchInSchemeChanged = function (schemeData) {
      vm.formData.selectedAutoSwitchInSchemeCode = schemeData.schemeCode;
      vm.selectedSwitchInSchemeType = schemeData.schemeType;
      vm.selectedAutoSwitchInScheme = schemeData.scheme;
      vm.isSwitchInScheme = !!(vm.selectedAutoSwitchInScheme);
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';

      if (schemeData.schemeType == 'ELSS' && schemeData.scheme.toLowerCase().includes('dividend')) {
        vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
      }
      resetValueFields();
      fetchSwitchInSchemeValidations();
    };

    vm.amountTypeChanged = function () {
      if (vm.formData.amountType === 'amount') {
        vm.formData.units = '';
      } else if (vm.formData.amountType === 'all_units') {
        vm.formData.amount = '';
        vm.formData.units = vm.unitsDetails.freeValueUnits;
      } else {
        vm.formData.amount = '';
        vm.formData.units = '';
      }
    };

    vm.changedNoOfUnit = function () {
      if (vm.formData.noOfUnits >= 9) {
        if (vm.unitsDetails && vm.unitsDetails.currentNavValue) {
          vm.conversionValue = vm.formData.noOfUnits * vm.unitsDetails.currentNavValue;
          vm.formData.units = vm.formData.noOfUnits;
          vm.formData.amount = vm.conversionValue;
        }
      }
    };

    vm.changedSwitchAmount = function () {
      if (vm.formData.switchAmount >= 500) {
        if (vm.unitsDetails && vm.unitsDetails.currentNavValue) {
          vm.conversionValue = vm.formData.switchAmount / vm.unitsDetails.currentNavValue;
          vm.formData.units = vm.conversionValue;
          vm.formData.amount = vm.formData.switchAmount;
        }
      }
    };

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.filteredinSchemeList = UtilService.getFilteredList(vm.inSchemes, 'scheme', vm.selectedInScheme);

    };

    vm.checkValidScheme = function () {
      $timeout(function () {
        if (vm.inSchemes && vm.inSchemes.length > 0) {
          var Arr = [];
          Arr = vm.inSchemes.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            // vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
            vm.isInScheme = false;
          }
        }
      }, 200);
    };

    vm.checkValidSwitchInScheme = function () {
      $timeout(function () {
        if (vm.autoSwitchInSchemes && vm.autoSwitchInSchemes.length > 0) {
          var Arr = [];
          Arr = vm.autoSwitchInSchemes.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            vm.selectedSwitchInScheme = '';
            vm.isSelectedSwitchInScheme = true;
            vm.isSwitchInScheme = false;
          }
        }
      }, 100);
    };

    vm.submitFormFirst = function () {
      if((vm.formData.amountType == 'units')
        && (vm.formData.units * vm.unitsDetails.currentNavValue < vm.validationsApi.minAmount)){
        MessageService.error('Amount/Units is less than minimum required value');
        return;
      }else if(vm.formData.amountType == 'all_units'
        && (vm.formData.all_units * vm.unitsDetails.currentNavValue < vm.validationsApi.minAmount)){
        MessageService.error('Amount/Units is less than minimum required value');
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                vm.submitForm();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              vm.submitForm();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: 'SWITCH',
        folioNumber: vm.formData.selectedFolioNo,
        schemeCode: vm.formData.selectedOutScheme,
        targetSchemeCode: vm.formData.selectedInSchemeCode
      };
      if (vm.formData.amountType == 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits
      } else if (vm.formData.amountType == 'units') {
        payload.units = vm.formData.units
      } else payload.amount = vm.formData.switchAmount;
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);

    };

    vm.submitForm = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.sKycStatus) {
              submitSwitchTransaction();
            }
            else {
              MessageService.error(resp.data.message);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {"panNumber": vm.investorInfo.panNumber, "folioNumber": vm.formData.selectedFolioNo};
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'sKycStatus'
      }, payload).$promise.then(success, error);

    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        if (vm.switchForm.$valid && vm.isCheckedTandC) {
          vm.submitForm();
          e.preventDefault();
        }
      }
      return false;
    };

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      vm.formData.isAutoSwitch = false;

      if (!vm.formData.selectedFolioNo) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.selectedFolioNo)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.selectedFolioNo = null;
            vm.formData.selectedOutScheme = null;
            vm.isInScheme = false;
            vm.formData.switchAmount = '';
            vm.formData.noOfUnits = '';
            vm.unitsDetails = null;
            resetValueFields();
            vm.switchForm.$setPristine();
          }
        });
      }
      var selectedFolioObj = vm.folioListData.filter(function (row) {
        return row.folioNo == vm.formData.selectedFolioNo
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
      }
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");


      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.formData.amountType='amount';
          vm.hasFolioEmailId && vm.fetchOutSchemes();
          fetchInSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.selectedFolioNo
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.selectedFolioNo = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.selectedFolioNo,brokerCode).then(successHandler).catch(errorHandler);

    };

    function changeAmountType(amountType) {
      vm.formData.amountType = amountType ? amountType : vm.formData.amountType;
      /*(vm.formData.amountType === 'amount') ? (vm.formData.units = '') : (vm.formData.amount = '');*/
      if (vm.formData.amountType === 'amount') {
        vm.formData.units = '';
        vm.formData.all_units = '';
      } else if (vm.formData.amountType === 'all_units') {
        vm.formData.amount = '';
        vm.formData.units = '';
        //  vm.formData.units = vm.unitsDetails.freeValueUnits;
        vm.formData.all_units = vm.unitsDetails.freeValueUnits;
      } else {
        vm.formData.amount = '';
        vm.formData.all_units = '';
      }
      // vm.conversionValue = vm.formData.amount || (vm.formData.units ? vm.formData.units * vm.unitsDetails.currentNavValue : '');
    }

    function getSwitchPayloadToSave() {
      var payload = {
        folioNumber: vm.formData.selectedFolioNo,
        formType: "SWITCH",
        id: $stateParams.transactionId || "",
        investmentOption: vm.inSchemeValidations ? (vm.inSchemeValidations.investmentOption) : '',
        dividendOption: vm.inSchemeValidations ? (vm.inSchemeValidations.investmentOption === "GROWTH" ? "Z" : vm.formData.switchDividentOption) : '',
        switchInSchemeCode: vm.formData.selectedInSchemeCode,
        switchOutSchemeCode: vm.formData.selectedOutScheme,
        euinOpted: vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName || '',
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.selectedAutoSwitchInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null
      };
      if (vm.formData.amountType == 'units') {
        payload.units = vm.formData.units;
        payload.amount = 0;
      } else if (vm.formData.amountType === 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      } else {
        payload.amount = vm.formData.switchAmount;
        payload.units = 0;
      }
      payload = {
        "folioNumber": "10301635",
        "formType": "SWITCH",
        "id": "",
        "investmentOption": "DIVIDEND",
        "dividendOption": "Y",
        "switchInSchemeCode": "31",
        "switchOutSchemeCode": "44",
        "euinOpted": "Y",
        "euinCode": "E030803",
        "euinName": "Richa Tripathi",
        "checkedNfoAutoSwitch": false,
        "autoSwitchScheme": null,
        "autoSwitchSchemeDividendOption": null,
        "approvalMode": "Online",
        "amount": 1000,
        "units": 0
      }
      return angular.copy(payload);
    }

    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getSwitchPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'switch',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload = {};
      if (!vm.formData.selectedOutScheme) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload, function (saveClicked) {
          if (saveClicked) {
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          } else {
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
      if (angular.isFunction(stateChangeStart())) {
        stateChangeStart();
      }

    });
    /*Socket code End*/

    function checkForTermsAndConditions() {
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.showTerms = vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ? true : false;
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euinObj = null;
            vm.euinList = [];
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateSummaryController', initiateSummaryController);

  /** @ngInject */
  function initiateSummaryController($rootScope, $stateParams, $timeout, $location, DistributorGenericService,
                                     ChangeDividendService, HDFC_API, $state, $log, $window, $scope, LoaderService,
                                     InvestorsService, BillJunctionService, TransactionService, TransactionApprovalService,
                                     ModalService, MessageService, AppConstants, UtilityService, UtilService, moment, deviceDetector ,SchemeService , dynamicData, $sce, ChequeLeafFileUploadService , DownloadPdfService , FileSaver, InvestorServiceDynamicData, panAdharLinkingService, InvestorCommonServiceVersion2, PaymentService) {
    var Card = $window.Card || {};
    var vm = this;
    // vm.uniqueLink = $stateParams.uniqueLink;
    var links = $stateParams.uniqueLink.split('_');
    vm.uniqueLink = links[0];
    if (links.length == 2) {
      vm.sipModifyEnabled = true;
      vm.cancelLink = links[1];
    }
    vm.date = new Date();
    vm.summaryType = $stateParams.summaryType.toLocaleUpperCase();
    if(vm.summaryType == 'DREAMSIP'){
      vm.isDREAMSIP = true;
      vm.summaryType = "SIP";
    }else{
      vm.isDREAMSIP = false;
    }
    if(vm.summaryType === 'SMART_SWAP') {
      vm.summaryType = vm.summaryType.toLowerCase();
    }

    $rootScope.apiVersion = $stateParams.version;
    vm.showMessageForUPI = $stateParams.UAP ? true: false;
    vm.showRegulatoryChanges = $stateParams.sebi_reg ? true : false;
    vm.summaryDetails = {};
    vm.activeTab = 0;
    // vm.summaryDetails.summaryType = vm.summaryType || 'PURCHASE';
    vm.selectedBank = null;
    vm.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.termaAndConditions = false;
    vm.nomineetermsAndConditions = false;
    vm.termsAndConditionsEMandate = false;
    vm.CARD_EXPIRY_MONTH = AppConstants.SUMMARY_EXPIRY_MONTH;
    vm.CARD_EXPIRY_YEAR = AppConstants.SUMMARY_EXPIRY_YEAR;
    vm.cardTypeChanged = cardTypeChanged;
    vm.changedCardBank = changedCardBank;
    vm.getAccountNumber = getAccountNumber;
    vm.updateDates=updateDates;
    vm.initialiseInstallment=initialiseInstallment;
    vm.holdersForm = {};
    vm.isOTMdisabled = true;
    vm.isSipPauseStartDate = false;
    vm.changeStartDate=changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.setActiveTab = setActiveTab;
    vm.SipPauseEndDate = null;
    vm.actionHappened=false;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.dynamicData = dynamicData.popupDTO.popupDTOMap;
    vm.isIFSCReadonly = false;
    vm.changeBank = changeBank;
    vm.downloadPdfFile = downloadPdfFile;
    vm.isFromEcart = false;
    vm.utilService = UtilService;
    $scope.billdeskUrl = HDFC_API.BILLDESK_URL_ECART;
    vm.ecsBankModal = {
      "bankAcNo": '',
      "verifyBankAcNo": '',
      "bankName": '',
      "bankBranch": '',
      "bankCity": '',
      "ifscCode": '',
      "bankAcType": '',
      "omUmrn": '',
      "payoutId": '',
    };
    vm.purchaseBankModal = {
      "bankAcNo": '',
      "verifyBankAcNo": '',
      "bankName": '',
      "bankBranch": '',
      "ifscCode": '',
      "bankCity": '',
      "utr": '',
      "verifyUtr": '',
      "omUmrn": '',
      "payoutId": '',
      "purchasebankAcType": ''
    };
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.ischecked = false;
    vm.selectedPaymentOption = null;
    vm.ecsReadOnly = false;
    vm.showBankFiels = true;
    vm.isActionPerformed = false;
    vm.bankdata = null;
    vm.otmBankData = null;
    vm.otmBankList = [];
    vm.bankList = [];
    vm.ECbankList = [];
    vm.purchasePayload = {};
    vm.cardDetails = {};
    vm.euinObj = null;
    vm.paymentOptionsPurchase = [
      /*{'key': 'NETBANKING', 'value': 'Net Banking'}, for HMF-6034*/
      {'key': 'WEB', 'value': 'Net Banking'},
      {'key': 'RTGS', 'value': 'NEFT/RTGS'},
      {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
      {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
      {'key': 'UPI', 'value': 'UPI'}
    ];
    vm.paymentOptionsPurchase4Liquid = [
      {'key': 'WEB', 'value': 'Net Banking'},
      {'key': 'RTGS', 'value': 'NEFT/RTGS'},
      {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
      {'key': 'UPI', 'value': 'UPI'}
    ];
    vm.paymentOptionsSip = [
      {'key': 'UPI', 'value': 'UPI Autopay'},
      {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
      {'key': 'EC', 'value': 'Standing Instruction/Biller'}
    ];
    vm.paymentOptionForFirstInstallment = AppConstants.SIP_WITH_FI.PAYMENT_MODE
    vm.paymentOptionsFlexSip = [{
      'key': 'OTM',
      'value': 'OTM(One Time Mandate)'
    },{'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}];
    vm.paymentOptionForFirstInstallmentFlexSip = AppConstants.FLEX_SIP_PAYMENT_MODES.PAYMENT_MODES_SIP_FI;
    vm.paymentOptionForFirstInstallment.push({'key': 'UPI', 'value': 'UPI Autopay'});
    vm.isUPIVerified = true;

    vm.sentToPaymentGatewayOptions = [
      {'key': 'AMOUNT_DEDUCTED','value': 'Amount is debited from bank account and you have received confirmation of same from your bank'},
      {'key': 'AMOUNT_NOT_DEDUCTED','value': 'Amount is NOT debited from bank account'}
    ];
    vm.fiOtmBankModal = {
      "bankAcNo": '',
      "verifyBankAcNo": '',
      "bankName": '',
      "bankBranch": '',
      "bankCity": '',
      "ifscCode": '',
      "bankAcType": '',
      "omUmrn": '',
      "payoutId": ''
    };
    vm.fibankData={
      "ifscCode":null,
      "accType":null,
    }

    vm.init = init;
    vm.termaAndContitions = termaAndContitions;
    vm.termsAndConditionsEMandateModal = termsAndConditionsEMandateModal;
    vm.rejectTransaction = rejectTransaction;
    vm.paymentOptionChanged = paymentOptionChanged;
    vm.checkMinorBankFlag= checkMinorBankFlag;
    vm.changedOtmBank = changedOtmBank;
    vm.approveTransaction = approveTransaction;
    vm.approveNominee = approveNominee;
    vm.rejectNominee = rejectNominee;
    vm.verifyPaymentAddress = verifyPaymentAddress;
    vm.approveTransactionForSWP_REDEMPTION = approveTransactionForSWP_REDEMPTION;
    vm.approveTransactionForSWITCH_STP_DTP_REDEEM = approveTransactionForSWITCH_STP_DTP_REDEEM;
    vm.approveTransactionForROLLOVER = approveTransactionForROLLOVER;
    vm.approveTransactionForCANCELLATION = approveTransactionForCANCELLATION;
    vm.approveTransactionForPAUSE = approveTransactionForPAUSE;
    vm.approveTransactionForChangeDividend = approveTransactionForChangeDividend;
    vm.viewLater = viewLater;
    vm.rejectTransactionRollover = rejectTransactionRollover;
    vm.rejectTransactionForCANCELLATION = rejectTransactionForCANCELLATION;
    vm.rejectTransactionForPAUSE = rejectTransactionForPAUSE;
    vm.sentToPaymentGatewayOptionChanged = sentToPaymentGatewayOptionChanged;
    vm.showAmountDeductedButton = false;
    vm.showAmountNotDeductedButton = false;
    vm.showNotSentToPaymentGatewayButton = true;
    vm.submitTransaction = submitTransaction;
    vm.isUPIVerified = false;
    vm.isUPIVerifiedForFI = false;
    vm.otmLimitValidation = false;
    vm.endDateValidation = false;
    vm.tpv = tpv
    vm.authModeSelect = null;
    vm.authMode = [];
    vm.authModeData = null;
    vm.selectedAuthMode = null;
    vm.SipActionHappened=false;
    vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.tncURL = HDFC_API.TNC_OF_APPROVAL;
    vm.termsAndContitionsSip = termsAndContitionsSip;
    vm.paymentOptionChangedForFi = paymentOptionChangedForFi;
    vm.changedFiOtmBank = changedFiOtmBank;
    vm.isNewPayment = true;
    vm.changeRtgsPayment = changeRtgsPayment;
    vm.bankUploadChequeLeafFile = bankUploadChequeLeafFile;
    vm.getAccountType=getAccountType;
    vm.chooseAFile = true;
    vm.openUploadedDoc = openUploadedDoc;
    vm.fileMimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.billdeskPayload = {
      hidRequestId : "PGIME1000",
      hidOperation : "ME100",
      msg : ""
    };
    vm.startDateValidation = false;
    vm.startDateValidationForFi = false;
    vm.eMandateBankList = false;
    vm.takeMandateFields = false;
    vm.tpvModalOpen = tpvModalOpen


    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };
    vm.emandateEnabled = false;
    vm.isOtmEnabled = true;
    vm.siEnabled = true;
    vm.emandateBankNotAvailable = false;
    vm.hideValidateMinor = false;
    vm.vaForm = {};
    vm.cancelledTopupDetailsWerePresent = false;
    vm.otmStartValidationPurchase = otmStartValidationPurchase;
    vm.TnC = true;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.emandateWord = {};
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.changedUPIBank = changedUPIBank;
    vm.upiEnabledForSIP = true;
    vm.showNudgeReasons = showNudgeReasons;

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }
    function init() {
      if (vm.summaryType == 'PURCHASE' || vm.summaryType == 'E_CART') {
        var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
        if (popUp == null || typeof(popUp) == 'undefined') {
          vm.isActionPerformed = false;
          alert('Please disable your pop-up blocker then submit the form.');
          return;
        }
        else {
          popUp.close();
        }
      }
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      /*
      * condition to check the user navigator agent
      * if user navigator agent not match with the supported browser than redirect to browser support page.
      */
      if (browserForceUpdate()) {
        return;
      }

      /*if (vm.summaryType == 'SIP' || vm.summaryType == 'SIP_TOPUP') {
        vm.selectedPaymentOption = 'EC';
        vm.showBankFiels = true;
        getSipEnabledBankList();
      }*/

      if (vm.summaryType == 'SIP_TOPUP') {
        vm.paymentOptionsSip = [{'key': 'UPI', 'value': 'UPI Autopay'}, {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}];
        vm.selectedPaymentOption = 'OTM';
        vm.showBankFiels = true;
      }


      /* else if (vm.summaryType == 'PURCHASE') {
         vm.selectedPaymentOption = 'NETBANKING';
         vm.showBankFiels = false;
         // getBillDeskBilljenBankList();
       }*/

      LoaderService.showLoader();
      var successOptModal = function (result) {
          if(result.summaryType == 'DREAMSIP'){
            vm.isDREAMSIP = true;
            result.summaryType = "SIP";
          }else{
          vm.isDREAMSIP = false;
          }
          vm.summaryDetails = result;
          // result.summaryType = 'E_CART';
          if(result.summaryType == 'E_CART'){
            vm.isFromEcart = true;
            vm.ecartTransactionType = result.distributorDetails.transactionType;
            if(result.distributorDetails.transactionType == 'PURCHASE'){
              vm.summaryType = 'PURCHASE';
              result.summaryType = 'PURCHASE';
              if(vm.summaryDetails.paymentOptions == 'NET_BANKING'){
                vm.summaryDetails.payMech = 'WEB';
              }
              if(vm.summaryDetails.paymentOptions == 'OTM'){
                vm.summaryDetails.payMech = 'OTM';
              }
            } else if(result.distributorDetails.transactionType == 'SIP'){
              vm.summaryType = 'SIP';
              result.summaryType = 'SIP';
              vm.summaryDetails.payMech = result.paymentModeSip;
            } else {
              vm.summaryType = 'PURCHASE';
              result.summaryType = 'PURCHASE';
              if(vm.summaryDetails.paymentOptions == 'NET_BANKING'){
                vm.summaryDetails.payMech = 'WEB';
              } else if(vm.summaryDetails.paymentOptions == 'OTM'){
                vm.summaryDetails.payMech = 'OTM';
              }
              if(vm.ecartTransactionType == 'MIX') {
                vm.paymentOptionsPurchase = [
                  {'key': 'WEB', 'value': 'Net Banking/Biller'},
                  {'key': 'RTGS', 'value': 'NEFT/RTGS'},
                  {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                  {'key': 'UPI', 'value': 'UPI'}
                ];
              }
            }
            if(result.cartItems && result.cartItems.length > 0) {
              vm.summaryDetails.euinCode = result.cartItems[0].euinCode;
              vm.summaryDetails.euinName = result.cartItems[0].euinName;
            }
            vm.totalSum = vm.summaryDetails.totalAmount + vm.summaryDetails.totalInstallmentAmount;
          }else{
            vm.isFromEcart = false;
          }
          if(vm.summaryDetails && vm.summaryDetails.minorFolioFlag && vm.summaryDetails.distributorDetails && (vm.summaryDetails.distributorDetails.transactionType == "PURCHASE" || vm.summaryDetails.distributorDetails.transactionType == "SIP" || vm.summaryDetails.distributorDetails.transactionType == "FLEXSIP")){
            vm.summaryDetails.cgfFlag = vm.summaryDetails.cgfFlag ? vm.summaryDetails.cgfFlag : true;
          }
          checkTopDetailsExistForCancelledSip();
          vm.upiPaymentOptionForSIP = vm.summaryDetails.payMech;
          vm.summaryDetails.payMech = vm.summaryDetails.payMech === "UAP" ? "UPI" : vm.summaryDetails.payMech;
          if(vm.summaryDetails.firstInstallmentDetails) {
            vm.summaryDetails.firstInstallmentDetails.paymentMode = vm.summaryDetails.firstInstallmentDetails && vm.summaryDetails.firstInstallmentDetails.paymentMode === "UAP" ? "UPI" : vm.summaryDetails.firstInstallmentDetails.paymentMode;
          }
          if (vm.summaryType === "FLEXSIP") {
            vm.summaryDetails.summaryType = 'FLEX_SIP'
            vm.tenureDiff = moment(vm.summaryDetails.sipEndDate,"DD-MMM-YYYY").diff(moment(vm.summaryDetails.sipDate,"DD-MMM-YYYY"), 'years') + 1;
          } else if (vm.summaryType === "SYSTEMATIC-CANCEL" && vm.summaryDetails.transactionType === 'FLEXSIP') {
            vm.tenureDiff = moment(vm.summaryDetails.endDate,"DD-MMM-YYYY").diff(moment(vm.summaryDetails.startDate,"DD-MMM-YYYY"), 'years') + 1;
          }
          if(result.summaryType == 'changeOption' || result.summaryType == 'changeTargetScheme'){
            if(result.amount){
              var amt = result.amount.split('.');
              result.amount = amt[0];
              var fromDate = result.fromDate.split(' ');
              result.fromDate = fromDate[0];
              var toDate = result.toDate.split(' ');
              result.toDate = toDate[0];
            }
            vm.summaryDetails = result;
          }
          if (vm.summaryType === 'NOMINEEOPTOUT') {
            vm.summaryDetails.summaryType = "NOMINEEOPTOUT";
            vm.optOutMessage = result.message;
            vm.NomineeEmail = result.inv_Email;
            vm.NomineeMobile = result.inv_Mobile;
          } else if (vm.summaryType === 'NOMINEEADDUPDATE') {
            vm.NomineeEmail = result.inv_Email;
            vm.NomineeMobile = result.inv_Mobile;
          }
          vm.upiMaxAmountLimit = result.upiMaxAmountLimit;
          vm.upiErrorMessage = result.upiMaxAmountErrMessage;
          changeStartDate($window.moment(vm.summaryDetails.pauseStartDate, "DD-MMM-YYYY"));
          if (vm.summaryDetails.sentToPaymentGateway) {
            vm.showNotSentToPaymentGatewayButton = false;
          } else {
            vm.showNotSentToPaymentGatewayButton = true;
          }

          vm.summaryDetails.euinOpted = vm.summaryDetails.summaryType === 'SIP_TOPUP' ? 'N' : 'Y';
          if (vm.summaryDetails.folioBankDetails && (vm.summaryDetails.folioBankDetails.bankName == 'HDFC' || vm.summaryDetails.folioBankDetails.bankName == 'hdfc')) {
            vm.ecsBankModal = angular.copy(vm.summaryDetails.folioBankDetails);
            vm.ecsBankModal.verifyBankAcNo = vm.summaryDetails.folioBankDetails.bankAcNo;
          }

          if(vm.summaryType == 'NOMINEE'){

          }

          if (vm.summaryType == 'SIP' || vm.summaryType == 'PURCHASE' || vm.summaryType == 'FLEXSIP') {
            vm.selectedPaymentOption = (vm.summaryDetails && vm.summaryDetails.payMech) || 'WEB';// set default true, due to mobile payMech not set
            if (vm.selectedPaymentOption) {
              if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') && vm.summaryDetails.sipWithFirstInstallment ) {
                if(!vm.summaryDetails.bulkTransactionFlag && vm.summaryDetails.firstInstallmentDetails){
                  vm.selectedPaymentOptionForFI = vm.summaryDetails.firstInstallmentDetails.paymentMode;
                }
                vm.paymentOptionChangedForFi();
              }
              if(vm.summaryDetails.bulkTransactionFlag){
                vm.upiEnabledForSIP = false;
              }
              if(vm.summaryDetails && vm.upiPaymentOptionForSIP !== "UAP"){
                getOTMBankList(function () {
                  if (angular.isArray(vm.otmBankList) && vm.otmBankList.length > 0) {
                    vm.selectedOtmBankData = vm.otmBankList.filter(function (item) {
                      return item.omUmrn == vm.summaryDetails.omUmrn;});
                    vm.otmBankData = vm.selectedOtmBankData[0];
                    if(vm.selectedPaymentOptionForFI=="OTM"){
                      vm.selectedFiOtmBankData = vm.otmBankList.filter(function (item) {
                        return item.omUmrn == vm.summaryDetails.firstInstallmentDetails.omUmrn;});
                      vm.fiOtmBankData= vm.selectedFiOtmBankData[0];
                      $timeout(function () { changedFiOtmBank();})
                    }
                    if (vm.selectedPaymentOption === 'OTM') {
                      $timeout(function () { changedOtmBank();})
                    }
                  }
                  else{
                    var purchasebankAcType = vm.purchaseBankModal.purchasebankAcType ? vm.purchaseBankModal.purchasebankAcType : null;
                    vm.purchaseBankModal = {};
                    vm.purchaseBankModal.purchasebankAcType = purchasebankAcType;
                  }
                });
              }
            }
            vm.showBankFiels = true;
          }

          if (vm.summaryType == 'PURCHASE' && vm.selectedPaymentOption == 'WEB') {
            vm.showBankFiels = false;
          }


          if ((vm.summaryType == 'SIP' || vm.summaryType == 'SIP_TOPUP' ) && vm.selectedPaymentOption == 'EC') {
            vm.siEnabled = true;
            getSipEnabledBankList();
          }

          if (vm.summaryType == 'SWP' || vm.summaryType == 'REDEMPTION') {
            if (vm.summaryDetails.accountList && vm.summaryDetails.accountList.length > 0 && vm.summaryDetails) {
              vm.summaryDetails.accountList.filter(function (item) {
                return item.primaryFlag == true;
              });
            }
          }
          else if (vm.summaryType == 'PURCHASE') {
            if (vm.summaryDetails.euinCode) {
              vm.euinObj = true;
            } else {
              getEuinNumber();
            }
            getBillDeskBilljenBankList();
            if (vm.summaryDetails.payMech) {
              paymentOptionChanged();
            }
          }
          if (vm.summaryType == 'SIP_TOPUP') {
            getOTMBankList();
          }
          else {
            if (vm.summaryDetails.euinCode) {
              vm.euinObj = true;
            } else {
              getEuinNumber();
            }
          }
          if (vm.summaryType == 'SIP' && vm.selectedPaymentOption == 'UPI') {
            getSipEnabledBankList();
            if (vm.summaryDetails.payMech) {
              paymentOptionChanged();
            }
          }

          /*if (vm.summaryDetails.newFolio != true) {
            vm.isDocSubmitted = true;
          } else {
            vm.isDocSubmitted = false;
          }*/

          if (vm.summaryDetails && vm.summaryDetails.sourceScheme && vm.summaryDetails.sourceScheme.valuesDTO) {
            vm.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount);
            vm.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit = UtilService.getUnitSting(vm.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount);
            vm.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit = UtilService.getUnitSting(vm.summaryDetails.sourceScheme.valuesDTO.freeValueAmount);
          }

          if (vm.summaryDetails && vm.summaryDetails.stpTargetScheme) {
            vm.summaryDetails.stpTargetScheme.amountUnit = UtilService.getUnitSting(vm.summaryDetails.stpTargetScheme.amount);
          }

          if (vm.summaryDetails && vm.summaryDetails.targetScheme) {
            vm.summaryDetails.targetScheme.amountUnit = UtilService.getUnitSting(vm.summaryDetails.targetScheme.amount);
          }

          if (vm.summaryDetails && vm.summaryDetails.swpWithdrawalOptions) {
            vm.summaryDetails.swpWithdrawalOptions.amountUnit = UtilService.getUnitSting(vm.summaryDetails.swpWithdrawalOptions.amount);
          }

          if (vm.summaryDetails && vm.summaryDetails.sourceScheme && vm.summaryDetails.sourceScheme.withDrawalAmount) {
            vm.summaryDetails.sourceScheme.withDrawalAmountUnit = UtilService.getUnitSting(vm.summaryDetails.sourceScheme.withDrawalAmount);
          }

          if (vm.summaryDetails && vm.summaryDetails.liquidSchemeFlag) {
            if(vm.ecartTransactionType == 'MIX') {
              vm.paymentOptionsPurchase4Liquid = [
                {'key': 'WEB', 'value': 'Net Banking/Biller'},
                {'key': 'RTGS', 'value': 'NEFT/RTGS'},
                {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
                {'key': 'UPI', 'value': 'UPI'}
              ];
            }
            vm.paymentOptionsPurchase = vm.paymentOptionsPurchase4Liquid;
          }
          if (!vm.summaryDetails.bulkTransactionFlag) {
            if (vm.summaryDetails.sipFrequency == 'Daily') {
              vm.paymentOptionsSip = [{'key': 'UPI', 'value': 'UPI Autopay'}, {
                'key': 'OTM',
                'value': 'OTM(One Time Mandate)'
              },{'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}];
              vm.selectedPaymentOption = vm.summaryDetails.payMech;
              paymentOptionChanged();
            } else {

              vm.paymentOptionsSip = [{'key': 'UPI', 'value': 'UPI Autopay'}, {
                'key': 'OTM',
                'value': 'OTM(One Time Mandate)'
              },{'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}, {'key': 'EC', 'value': 'Standing Instruction/Biller'}];
               vm.paymentOptionsFlexSip = [
               {
                 'key': 'OTM',
                 'value': 'OTM(One Time Mandate)'
               },{'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}];
              vm.liquidSchemeFlag = result.liquidSchemeFlag;
              /*  if(vm.summaryType == 'PURCHASE'){
                  vm.selectedPaymentOption = 'NETBANKING';
                }*/
            }
          } else if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') && vm.summaryDetails.bulkTransactionFlag) {
            if (vm.summaryDetails.sipFrequency == 'Daily') {
              if (vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus && vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus !== "01") { //for NRI
                vm.paymentOptionsSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.paymentOptionsFlexSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                vm.emandateEnabled = false;
                vm.isOtmEnabled = true;
                vm.siEnabled = false;
              } else {
                if (vm.summaryDetails.minorFolioFlag) {
                  vm.paymentOptionsSip = [
                    {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                  ];
                  vm.paymentOptionsFlexSip = [
                    {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                  ];
                  vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                  vm.emandateEnabled = false;
                  vm.isOtmEnabled = true;
                  vm.siEnabled = false;
                } else {
                  vm.paymentOptionsSip = [
                    {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                    {'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}
                  ];
                  vm.paymentOptionsFlexSip = [
                    {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                    {'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}
                  ];
                  vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                  vm.emandateEnabled = true;
                  vm.isOtmEnabled = true;
                  vm.siEnabled = false;
                }
              }
              paymentOptionChanged();
            } else {
              if (vm.summaryDetails.minorFolioFlag && vm.summaryDetails.cgfFlag) {
                vm.paymentOptionsSip = [
                  {'key': 'EC', 'value': 'Standing Instruction/Biller'},
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.paymentOptionsFlexSip = [
                   {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                vm.emandateEnabled = false;
                vm.isOtmEnabled = true;
                vm.siEnabled = true;
              } else if (vm.summaryDetails.minorFolioFlag && !vm.summaryDetails.cgfFlag) {
                vm.paymentOptionsSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.paymentOptionsFlexSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                vm.emandateEnabled = false;
                vm.isOtmEnabled = true;
                vm.siEnabled = false;
              } else if (vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus && vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus !== "01") { //for NRI
                vm.paymentOptionsSip = [
                  {'key': 'EC', 'value': 'Standing Instruction/Biller'},
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.paymentOptionsFlexSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'}
                ];
                vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                vm.emandateEnabled = false;
                vm.isOtmEnabled = true;
                vm.siEnabled = true;
              } else if (!vm.eMandateBankList){
                vm.paymentOptionsSip = [
                  {'key': 'UPI', 'value': 'UPI Autopay'},
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                  {'key': 'EC', 'value': 'Standing Instruction/Biller'}
                ];
              } else {
                vm.paymentOptionsSip = [
                  {'key': 'UPI', 'value': 'UPI Autopay'},
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                  {'key': 'HEM', 'value': 'Register E-mandate (eOTM)'},
                  {'key': 'EC', 'value': 'Standing Instruction/Biller'}
                ];
                vm.paymentOptionsFlexSip = [
                  {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
                  {'key': 'HEM', 'value': 'Register E-mandate (eOTM)'}
                ];
                vm.selectedPaymentOption = vm.paymentOptionsSip[0].key;
                vm.liquidSchemeFlag = result.liquidSchemeFlag;
                vm.emandateEnabled = true;
                vm.isOtmEnabled = true;
                vm.siEnabled = true;
              }
            }
          }

          if (vm.summaryType == 'SIP_TOPUP') {
            vm.paymentOptionsSip = [ {
              'key': 'UPI',
              'value': 'UPI Autopay'
            },{
              'key': 'OTM',
              'value': 'OTM(One Time Mandate)'
            }
            ];
            vm.selectedPaymentOption = 'OTM';
            vm.showBankFiels = true;
            getSipEnabledBankList();
          }

          if(vm.summaryDetails.payMech == 'HEM'){
            vm.emPayoutId = result.emPayoutId;
            vm.amount = result.mandateAmount;

            vm.eMandateStartDate = result.mandateStartDate ? result.mandateStartDate : result.emandateStartDate ? result.emandateStartDate : null;
            vm.eMandateEndDate = result.mandateEndDate ? result.mandateEndDate : result.emandateEndDate ? result.emandateEndDate : null;

            if (!vm.amount && !vm.eMandateStartDate && !vm.eMandateEndDate) {
              vm.takeMandateFields = true;
            }

            if(vm.isFromEcart && vm.summaryDetails.cartItems.length > 0) {
              vm.summaryDetails.cartItems.forEach(function (item) {
                if (item.liquid == true) {
                  result.liquidSchemeFlag = true;
                } else {
                  result.liquidSchemeFlag = false;
                }
              })
            }
            vm.liquidSchemeFlag = result.liquidSchemeFlag;
            getEmandateBankList(function () {
              if(!vm.emandateValidationData && !vm.amount && !vm.eMandateStartDate && !vm.eMandateEndDate){
                var successHandler = function(resp){
                  vm.emandateValidationData = resp.eOTM;
                  vm.maxMandateDurationYears = vm.emandateValidationData.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
                  setEmandatePaymentOption();
                  vm.eMandateNoOfDays = vm.emandateValidationData.noOfDays;
                  vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
                  vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
                  vm.summaryDetails.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
                  vm.amount = vm.summaryDetails.emandateAmount;
                  checkAmountValidationEmandate();
                  vm.emandateWord = {};
                  $window.NumToWord(vm.summaryDetails.emandateAmount, 'amountInwordsEmandate',vm.emandateWord);
                  vm.mandateInfo = vm.emandateValidationData.mandateInfo;
                  vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
                  vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
                  vm.emandateMinStartDay = vm.emandateValidationData.minStartDays;
                  vm.summaryDetails.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
                  changeDateEmandate(vm.summaryDetails.emandateDate);
                  updateEmandateEndDate();
                }

                UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
                  MessageService.error(resp);
                });

              }
            });
          }

          if(vm.summaryType == 'SIP_TOPUP'){
            vm.upiEnabledForSIP = false;
          }

          if (vm.summaryType == 'SIP' && vm.summaryDetails.bulkTransactionFlag && !vm.summaryDetails.sipWithFirstInstallment) {
            getEmandateBankList(function() {
              setEmandatePaymentOption();
            });
          }

          // console.log("vm.summaryDetails==== ",JSON.stringify(vm.summaryDetails));

        if(vm.summaryDetails.distributorDetails && vm.summaryDetails.distributorDetails.transactionType!=null && vm.summaryDetails.distributorDetails.transactionType==='ROLLOVER')
        {
          vm.summaryDetails.summaryType=vm.summaryDetails.distributorDetails.transactionType;
        }
          var arn = vm.summaryDetails.distributorDetails && vm.summaryDetails.distributorDetails.arnNo;
          if (arn) {
            arn = arn.substring(arn.lastIndexOf("-")+1, arn.length);
          }
          vm.oversea_arn = vm.appConstants.OVERSEA_ARN_REGEX.test(arn) ? true : false;

        if(vm.summaryDetails.distributorDetails && vm.summaryDetails.distributorDetails.transactionType!=null && vm.summaryDetails.distributorDetails.transactionType==='FLEXINDEX'){
          vm.summaryDetails.distributorDetails.arnNo = vm.summaryDetails.distributorDetails.arnNo.replace('ARN-','');
        }

          if(vm.summaryDetails.summaryType === 'SMART_SWAP') {
            $timeout(function () {
              $window.NumToWord(vm.summaryDetails.sourceScheme.withDrawalAmount, 'divDisplayWords');
            }, 500);
          }
          if(vm.summaryDetails.summaryType == 'changeTargetScheme' || vm.summaryDetails.summaryType == 'changeOption'){

          } else if (vm.summaryDetails.folioDetails) {
            getAccountType();
          }

          mobileEmailBelongsTo();

        },
        errorOtpModal = function () {
          vm.summaryDetails = null;
        },
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // setting summary for FLEX SIP as SIP
            var summaryType = vm.summaryType === 'FLEXSIP' ? 'SIP' : vm.summaryType;
            ModalService.otpForApprovalModal({
              backdrop: 'static',
              summaryType: summaryType,
              uniqueLink: vm.uniqueLink,
              cancelInk : vm.cancelLink,
              sipModify : vm.sipModifyEnabled,
              showMessageForUPI: vm.showMessageForUPI,
              showRegulatoryChanges: vm.showRegulatoryChanges
            }, successOptModal, errorOtpModal);
          } else {
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      // version=version?version:HDFC_API.VERSION;
      if (vm.summaryType === 'NOMINEEADDUPDATE') {
        InvestorServiceDynamicData.post({
          child1: 'nominee',
          child2: 'sendOTP',
          child3:'NOMINEE_UPDATE',
          child4: vm.uniqueLink
        }, null).$promise.then(success, error);
      } else if (vm.summaryType === 'NOMINEEOPTOUT') {
        InvestorServiceDynamicData.post({
          child1: 'nominee',
          child2: 'sendOTP',
          child3:'NOMINEE_OPT_OUT',
          child4: vm.uniqueLink
        }, null).$promise.then(success, error);
      } else {
        TransactionService.get({
          VERSION: version,
          controller: 'otp',
          uniqueLink: vm.uniqueLink
        }, null).$promise.then(success, error);
      }

      vm.summaryDetails = $window.JSON.parse(localStorage.getItem('summaryDetails'));

      var successHandler = function(resp) {
       vm.dynamicNoteNetBanking = resp.noteDTO.noteDTOMap.Note_Net_Banking;
       vm.dynamicNoteHdfc =  resp.noteDTO.noteDTOMap.Note_HDFC_Fund_Transfer;
       vm.dynamicNoteNeft = resp.noteDTO.noteDTOMap.Note_NEFT_RTGS;
       vm.dynamicNoteOtm = resp.noteDTO.noteDTOMap.Note_OTM;
       vm.dynamicNoteUpi = resp.noteDTO.noteDTOMap.Note_UPI;
       vm.dynamicNoteGeneral = resp.noteDTO.noteDTOMap.Note_GENERAL;
       vm.dynamicNoteSwitch = resp.noteDTO.noteDTOMap.Note_SWITCH;
       vm.dynamicNoteEmandate = resp.noteDTO.noteDTOMap.Note_Emandate;
       vm.dynamicNoteStp = resp.noteDTO.noteDTOMap.Note_Review_STP;
       vm.dynamicNoteIDCW = resp.noteDTO.noteDTOMap.Note_IDCW;
       vm.dynamicNoteDTP = resp.noteDTO.noteDTOMap.Note_Review_TIP;
       vm.dynamicDataCutOff = resp.popupDTO.popupDTOMap.Note_Smartlink_Popup;
        vm.dynamicNoteSIOTM= resp.noteDTO.noteDTOMap.Note_SIP_SI_FI_OTM;
        vm.dynamicNoteOTMWEB= resp.noteDTO.noteDTOMap.Note_SIP_OTM_FI_NETBANKING;
        vm.dynamicNoteOTMOTM= resp.noteDTO.noteDTOMap.Note_SIP_OTM_FI_OTM;
        vm.dynamicNoteSIWEB= resp.noteDTO.noteDTOMap.Note_SIP_SI_FI_NETBANKING;
       vm.dynamicNoteOtmFlexSip = resp.noteDTO.noteDTOMap.Note_FLEX_SIP_OTM;
       vm.dynamicNoteOTMOTMFlexSip = resp.noteDTO.noteDTOMap.Note_FLEX_SIP_OTM_FI_OTM;
       vm.dynamicNoteEmandateFlexSip = resp.noteDTO.noteDTOMap.Note_FLEX_SIP_Emandate;
       vm.dynamicDataForFIUPI = resp.noteDTO.noteDTOMap.Note_SIP_FI_UPI;
       vm.dynamicNoteSIPUPI = resp.noteDTO.noteDTOMap.Note_SIP_UPI;
       vm.dynamicNoteMixNetBanking = resp.noteDTO.noteDTOMap.Note_Purchase_Mix_Net_Banking;
       vm.dynamicNoteMixOTM = resp.noteDTO.noteDTOMap.Note_Mix_OTM_Review;
       vm.dynamicNoteSipCancel = resp.noteDTO.noteDTOMap.Note_SIP_Cancel;
        vm.dynamicNoteEmandateDebitCard = resp.noteDTO.noteDTOMap.Note_Emandate_Debit_Card;
        vm.dynamicNoteEmandateFlexSipDebitCard = resp.noteDTO.noteDTOMap.Note_FLEX_SIP_Emandate_Debit_Card;
        vm.nomineeDynamicData = resp.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
      }

      UtilService.fetchDynamicData("SMARTLINK_WEB").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });

      var successHandlerTnc = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General_EMANDATE && vm.termsConditionData.TNC_General_EMANDATE.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandlerTnc).catch(function(resp) {
         MessageService.error(resp);
      });

    }

    vm.copyPasteHandler=function(e){
      UtilService.copyPasteHandler(e);
    }

    function initialiseInstallment() {
      vm.frequency = vm.summaryDetails.frequency;
      vm.noOfInstallmentList =[];
      for(var i = 0; i < vm.summaryDetails.maxInstallmentsPauseSip; i++){vm.noOfInstallmentList.push(i+1)}
    }

    function getEmandateBankList(cb) {// function to fetch e-mandate registered bank w.r.t selected folio
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.emandateEnabled = resp.data.folioEmandateStatus;
            if (angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0 && vm.emandateEnabled) {
              vm.bankList = resp.data.bankList;
              if(vm.selectedPaymentOption == 'HEM') {
                vm.bankdata = vm.bankList[0];
              }
              vm.isEmandateMaxLimit = resp.data.maxAmountLimit;
              vm.emandateBankNotAvailable = false;
              vm.eMandateBankList = true;
              // vm.maxMandateDurationYears = resp.data.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
              var selectedBank = [];
              if (vm.summaryDetails.bulkTransactionFlag) {
                // vm.emandateEnabled = true;
                if (!vm.amount && !vm.eMandateStartDate && !vm.eMandateEndDate) {
                  vm.takeMandateFields = true;
                }
                selectedBank = [vm.bankList[0]];
                vm.emPayoutId = selectedBank[0].bankName;
                if(!vm.emandateValidationData && !vm.amount && !vm.eMandateStartDate && !vm.eMandateEndDate){
                  var successHandler = function(resp){
                    vm.emandateValidationData = resp.eOTM;
                    vm.maxMandateDurationYears = vm.emandateValidationData.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
                    if (!vm.summaryDetails.sipWithFirstInstallment) {
                      setEmandatePaymentOption();
                    }
                    vm.eMandateNoOfDays = vm.emandateValidationData.noOfDays;
                    vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
                    vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
                    vm.summaryDetails.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
                    vm.amount = vm.summaryDetails.emandateAmount;
                    checkAmountValidationEmandate();
                    vm.emandateWord = {};
                    $window.NumToWord(vm.summaryDetails.emandateAmount, 'amountInwordsEmandate',vm.emandateWord);
                    vm.mandateInfo = vm.emandateValidationData.mandateInfo;
                    vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
                    vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
                    vm.emandateMinStartDay = vm.emandateValidationData.minStartDays;
                    vm.summaryDetails.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
                    changeDateEmandate(vm.summaryDetails.emandateDate);
                    updateEmandateEndDate();
                  }

                  UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
                    MessageService.error(resp);
                  });

                }
              } else {
                if (vm.emPayoutId) {
                  var selectedBank = vm.bankList.filter(function(bank) {
                    return bank.bankName === vm.emPayoutId;
                  });
                  vm.bankdata = selectedBank[0];
                } else {
                  vm.emPayoutId = vm.bankdata.bankName;
                }
              }
              
              if(vm.isFromEcart && vm.selectedPaymentOption === 'HEM' && vm.summaryDetails.accNo) {
                var res = vm.bankList.filter(function(obj) {
                  return obj.accountNumber === vm.summaryDetails.accNo;
                });
                if(res.length === 1) {
                  vm.bankdata = res[0];
                  vm.emPayoutId = vm.bankdata.bankName;
                  }
               }
            
              vm.authMode = vm.bankdata;
              if (vm.summaryDetails.authMode || vm.summaryDetails.authenticationMode) {
                vm.selectedAuthMode = vm.authMode.authenticationModes.filter(function (item) {
                  var selectedAuthMode;
                  if (vm.summaryDetails.authMode) {
                    selectedAuthMode = vm.summaryDetails.authMode;
                  } else if (vm.summaryDetails.authenticationMode) {
                    selectedAuthMode = vm.summaryDetails.authenticationMode;
                  }
                  return item.value == selectedAuthMode;
                });
                vm.authModeSelect = vm.selectedAuthMode[0];
              } else if (vm.summaryDetails.bulkTransactionFlag) {
                vm.selectedAuthMode = [vm.authMode.authenticationModes[0]];
                vm.authModeSelect = vm.selectedAuthMode[0];
              } else {
                vm.authModeSelect = vm.authMode.authenticationModes[0];
              }
              vm.authModeData = vm.authModeSelect;
              vm.authModePreSelected = vm.summaryDetails.authMode;
              cb();
            }
            else{
              vm.bankList  = [];
              if (vm.summaryDetails.bulkTransactionFlag) {
                vm.emandateEnabled = false;
              } else {
                vm.emandateBankNotAvailable = true;
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.bankList = null;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        "folioNumber": vm.summaryDetails.folioNumber,
        "trnxType": vm.summaryType,
        "liquidSchemeFlag": vm.liquidSchemeFlag
      }
      LoaderService.showLoader();
      BillJunctionService.post({VERSION: 'v2',
        controller: 'bank',
        child1: 'list',
        child2: 'emandate'
      }, payload ).$promise.then(success, error);
    };

    function sentToPaymentGatewayOptionChanged() {
      if (vm.sentToPaymentGatewayOption == 'AMOUNT_NOT_DEDUCTED') {
        vm.showAmountNotDeductedButton = true;
        vm.showAmountDeductedButton = false;
      } else {
        vm.showAmountDeductedButton = true;
        vm.showAmountNotDeductedButton = false;
      }
    }

    function submitTransaction() {
      var success = function (resp) {
          if (resp && resp.status) {
            $state.go('transactionconfirmation');
          }
        },
        error = function (err) {
          MessageService.error(err.data.trnxActionMsg || err.message);
        };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      TransactionApprovalService.get({
        VERSION: version,
        controller: 'purchase',
        child1: 'amount',
        child2: 'deducted',
        child3: 'nigo',
        uniqueLink: vm.uniqueLink
      }, null).$promise.then(success, error);
    }

    function termaAndContitions() {
      ModalService.termConditionModal({});
    }
    function termsAndConditionsEMandateModal() {
      ModalService.termsAndConditionsEMandateModal({});
    }

    function rejectTransaction() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      var success = function () {
          MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_REJECTED);
          vm.isActionPerformed = true;
        },
        error = function (err) {
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };

      ModalService.rejectTransactionModal({
        uniqueLink: vm.uniqueLink,
        transactionId: vm.summaryDetails.transactionId,
        summaryType: vm.isFromEcart ? 'E_CART': vm.summaryDetails.summaryType,
        arnCode: vm.summaryDetails.distributorDetails.arnNo
      }, success, error);
    }

    function rejectTransactionRollover() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      var success = function () {
          MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_REJECTED);
          vm.isActionPerformed = true;
        },
        error = function (err) {
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      ModalService.rejectTransactionModal({
        uniqueLink: vm.uniqueLink,
        folioNumber: vm.summaryDetails.folioNumber,
        summaryType: vm.summaryDetails.summaryType,
        transactionId: vm.summaryDetails.transactionId
      }, success, error);
    }

    function rejectTransactionForCANCELLATION() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      var success = function () {
          MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_REJECTED);
          vm.isActionPerformed = true;
        },
        error = function (err) {
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      ModalService.rejectTransactionModal({
        uniqueLink: vm.uniqueLink,
        folioNumber: vm.summaryDetails.folioNumber,
        summaryType: vm.summaryDetails.summaryType,
        transactionId: vm.summaryDetails.transactionId
      }, success, error);
    }

      function rejectTransactionForPAUSE() {
        if (!vm.uniqueLink || !vm.summaryType) {
          return;
        }
        var success = function (resp) {
            MessageService.success(resp.trnxActionMsg);
            vm.isActionPerformed = true;
            vm.actionHappened=true;
          },
          error = function (err) {
            vm.isActionPerformed = false;
            UtilService.errorHandler(err);
          };
        ModalService.rejectTransactionModal({
          uniqueLink: vm.uniqueLink,
          folioNumber: vm.summaryDetails.folioNumber,
          summaryType: vm.summaryDetails.summaryType,
          transactionId: vm.summaryDetails.transactionId
        }, success, error);
      }


    function getBillDeskBilljenBankList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') && vm.summaryDetails.sipWithFirstInstallment ) {
              vm.bankListForFi = resp.data;
            } else {
              vm.bankList = resp.data;
            }

            // auto populate upi bank selection
            if(vm.selectedPaymentOption == 'UPI') {
              var result = vm.bankList.find(function(el) {
                return el.accountNumber == vm.summaryDetails.accountNumber;
              })
              vm.bankdata = result;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var flowVersion = localStorage.getItem('flowVersion');
      if(vm.selectedPaymentOption == 'RTGS'){
        var payload = {
          "trnxType": vm.summaryType.toLowerCase(),
          "liquidSchemeFlag": vm.summaryDetails.liquidSchemeFlag != undefined ? vm.summaryDetails.liquidSchemeFlag : false,
          "neftFlag": true
        }
      }else {
        var payload = {
          "trnxType": vm.summaryType.toLowerCase(),
          "liquidSchemeFlag": vm.summaryDetails.liquidSchemeFlag != undefined ? vm.summaryDetails.liquidSchemeFlag : false,
          // "folioNumber": vm.summaryDetails.folioNumber //uncomment for tpv
        }
      }
      if(flowVersion === 'NEW'){
        payload.folioNumber = vm.summaryDetails.folioNumber;
      }
      UtilityService.post({
        controller: 'bank',
        child: 'list'
      }, payload).$promise.then(success, error);
    }

    function getEuinNumber() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
        } else {
          vm.euinList = null;
        }
      }, error = function (err) {
        vm.euinList = null;
        $log.info("error====", err);
      };
      var payload = {};
      payload.uniqueLink = vm.uniqueLink;
      var version = $rootScope.apiVersion ? $rootScope.apiVersion : HDFC_API.VERSION;
      TransactionService.post({
        VERSION: version,
        controller: 'getEuin',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function getOTMBankList(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmResp = resp.data;
            if (Object.keys(resp.data).length > 0) {
              if (vm.summaryDetails.sipWithFirstInstallment ) {
                vm.otmBankList = angular.copy(resp.data.nonCOTMBankList);
              } else {
                vm.otmBankList = angular.copy(resp.data.folioBankDetailsList);
              }
              vm.isOTMdisabled = false;
              cb(true);
              vm.isOtmEnabled = true;
            }
            else
            {
              vm.isOtmEnabled = false;
              if(vm.ecartTransactionType == 'MIX') {
                vm.paymentOptionsPurchase4Liquid = [
                  {'key': 'WEB', 'value': 'Net Banking/Biller'},
                  {'key': 'RTGS', 'value': 'NEFT/RTGS'},
                  {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
                  {'key': 'UPI', 'value': 'UPI'}
                ];
              } else {
                vm.paymentOptionsPurchase = [
                  {'key': 'WEB', 'value': 'Net Banking'},
                  {'key': 'RTGS', 'value': 'NEFT/RTGS'},
                  {'key': 'HDFC', 'value': "HDFC Bank's Fund Transfer"},
                  {'key': 'UPI', 'value': "UPI"}
                ];
              }
            }
          }
          else {
            vm.otmBankList = null;
            cb(false);
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          cb(false);
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.get({
        controller: 'accounts',
        child1: 'otm',
        transactionType: vm.summaryType.toLowerCase(),
        child2: vm.summaryDetails.folioNumber //'8524114'
      }, {}).$promise.then(success, error);
    }

    function checkMinorBankFlag() {

      if(vm.summaryType === 'PURCHASE')
      {
        if(vm.summaryDetails.minorFolioFlag && !vm.summaryDetails.cgfFlag && !vm.bankdata.minorBankFlag)
        {
          ModalService.minorBankModal({dynamicDataPopup : vm.dynamicData});
          vm.bankdata=null;
          vm.hideValidateMinor = true;
        } else {
          vm.hideValidateMinor = false;
          if(vm.selectedPaymentOption == "RTGS"){
            if(vm.isNewPayment && vm.bankdata){
              vm.purchaseBankModal.bankName = vm.bankdata.bankNameOnly ? vm.bankdata.bankNameOnly : null;
              vm.purchaseBankModal.bankBranch = vm.bankdata.bankBranch ? vm.bankdata.bankBranch : null;
              vm.purchaseBankModal.bankAcNo = vm.bankdata.accountNumber ? vm.bankdata.accountNumber : null;
              vm.purchaseBankModal.ifscCode = vm.bankdata.ifscCode ? vm.bankdata.ifscCode : null;
              vm.purchaseBankModal.purchasebankAcType = vm.bankdata.bankAcType && vm.bankTypeList && vm.bankTypeList.find(function (data) {
                return data.accountTypeCode === vm.bankdata.bankAcType;
              })
              vm.purchaseBankForm.bankAcNo.$setDirty();
              vm.purchaseBankForm.bankBranch.$setDirty();
              vm.purchaseBankForm.bankName.$setDirty();
              vm.purchaseBankForm.ifscCode.$setDirty();
              vm.purchaseBankForm.accountType.$setDirty();
              vm.isAccFieldFilled = vm.purchaseBankModal.purchasebankAcType ? true : false;
              vm.purchaseBankModal.utr = null;
              vm.purchaseBankModal.verifyUtr = null;
            }else {
              vm.purchaseBankForm.bankBranch.$dirty = false;
              vm.purchaseBankForm.bankAcNo.$dirty = false;
              vm.purchaseBankForm.bankName.$dirty = false;
              vm.purchaseBankForm.ifscCode.$dirty = false;
              vm.purchaseBankForm.utr.$dirty = false;
              vm.purchaseBankForm.verifyUtr.$dirty = false;
              vm.purchaseBankModal.bankName = null;
              vm.purchaseBankModal.bankBranch = null;
              vm.purchaseBankModal.bankAcNo = null;
              vm.purchaseBankModal.ifscCode = null;
              vm.purchaseBankModal.purchasebankAcType = null;
              vm.purchaseBankModal.utr = null;
              vm.purchaseBankModal.verifyUtr = null;
              vm.purchaseBankModal.chequeLeaf = null;
              vm.fileType = null;
              vm.isAccFieldFilled = false;
            }
          }
        }
        // vm.purchaseBankModal.ifscCode = null;
        // vm.purchaseBankModal.purchasebankAcType=null;
      }
      else if(vm.summaryType === 'SWP' || vm.summaryType === 'REDEMPTION' || vm.summaryType === 'smart_swap')
      {
        if(vm.summaryDetails.minorFolioFlag && !vm.selectedBank.minorBankFlag)
        {
          ModalService.minorBankModal({dynamicDataPopup : vm.dynamicData});
          vm.selectedBank=null;
        }
      }
      if(vm.summaryType ==='SIP' && vm.selectedPaymentOptionForFI){
        if(vm.selectedPaymentOptionForFI==='WEB'){
          vm.fibankData.ifscCode= null;
          vm.fibankData.accType=null;
        }
      }
    }

    function getSipEnabledBankList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankList = resp.data;
            vm.ECbankList = angular.copy(vm.bankList);
            var bankName = vm.summaryDetails.folioBankDetails && vm.summaryDetails.folioBankDetails.bankName;

            // check if bank data set exists in biller bank list and clearing bank data if it doesnt exists in list

            if(vm.selectedPaymentOption == 'EC' && vm.bankdata) {
              var isExistInList = vm.ECbankList.find(function(el) {
                 return el === vm.bankdata
              })


              if (!isExistInList) {
                vm.bankdata = null;
              }
            }

            if (bankName && bankName.toUpperCase() == "HDFC") {
              var banklist = resp.data.filter(function (bank) {
                return bank.bankName == "HDFC BANK";
              });
              vm.bankdata = banklist[0];
            }
            // auto populate upi bank selection
            if(vm.selectedPaymentOption == 'UPI') {
              var accountNumber = vm.summaryDetails.accountNumber? vm.summaryDetails.accountNumber: vm.summaryDetails.folioBankDetails.bankAcNo
              var result = vm.bankList.find(function(el) {
                return el.accountNumber == accountNumber;
              })
              vm.bankdata = result;
              changedUPIBank();
            }

            // auto populate biller bank when initiated from quick sip and getting default bank
            if (vm.summaryDetails && vm.summaryDetails.quickSip && vm.selectedPaymentOption == 'EC') {
              var result = vm.ECbankList.find(function(el) {
                return el.default === true;
              });
              vm.bankdata = result;
              changeBank();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "trnxType": vm.summaryType.toLowerCase(),
        "liquidSchemeFlag": vm.summaryDetails.liquidSchemeFlag != undefined ? vm.summaryDetails.liquidSchemeFlag : false,
        "folioNumber": vm.summaryDetails.folioNumber,//uncomment for tpv
        "sipFlow": true
      };
      if(vm.selectedPaymentOption == 'UPI'){
        delete payload.sipFlow;
        payload.trnxType = "purchase"
        payload.sipUpiFlow = true;
      }
      UtilityService.post({
        controller: 'bank',
        child: 'list'
      },payload).$promise.then(success, error);
    }

    function execute_Config(configJson) {
      new Card(configJson).init();
    }

    function handleResponse() {
      //$log.info("response======== ", res);
    }

    function approveEcsBankTransaction() {
      // if (vm.ecsBankModal.bankAcNo && vm.ecsBankModal.verifyBankAcNo && (vm.ecsBankModal.bankAcNo == vm.ecsBankModal.verifyBankAcNo)) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          vm.isActionPerformed = true;
          vm.ecsReadOnly = true;
          if (resp.status && resp.data) {
            if(!vm.summaryDetails.sipWithFirstInstallment){
              MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
            }
            if (resp.data.eMandateEnabled && resp.data.paymentOption == 'EC') {
              if (vm.summaryDetails.sipWithFirstInstallment) {
                redirectToPaymentGateway(resp.data);
              } else {
                vm.isActionPerformed = true;
                //openPaynimo(resp.data.trxnNo, resp.data.srnNo, vm.summaryDetails.pNMFreq);
              }
            }
            else if(resp.data.eMandateEnabled && resp.data.paymentOption == 'OTM'){
              if (vm.summaryDetails.sipWithFirstInstallment) {
                redirectToPaymentGateway(resp.data);
              }
            }
            else if (!resp.data.eMandateEnabled && (resp.data.paymentOption == 'OTM' || resp.data.paymentOption == 'EC')) {
              if (vm.summaryDetails.sipWithFirstInstallment) {
                redirectToPaymentGateway(resp.data);
              } else {
                var payload = {
                  investorName: vm.summaryDetails.investorName,
                  folioInvestorName: vm.summaryDetails.investorName,
                  srnNo: resp.data.srnNo,
                  folioNumber: vm.summaryDetails.folioNumber,
                  schemeName: vm.summaryDetails.schemeName,
                  investmentOption: vm.summaryDetails.investmentOption ? vm.summaryDetails.investmentOption : '',
                  amount: vm.summaryDetails.amount,
                  sipDividendOption: vm.summaryDetails.sipDividendOption ? vm.summaryDetails.sipDividendOption:'',
                  netBankingUrl: resp.data.netBankingUrl,
                  paymentOption: resp.data.paymentOption,
                  transactionId: resp.data.trxnNo,
                  transactionInitiateDate: resp.data.transactionInitiateDate,
                  frequency: vm.summaryDetails.sipFrequency,
                  startDate: vm.summaryDetails.sipDate ? vm.summaryDetails.sipDate : null,
                  endDate: vm.summaryDetails.sipEndDate ? vm.summaryDetails.sipEndDate : null,
                  bankName: vm.ecsBankModal ? vm.ecsBankModal.bankName : '',
                  bankAcNo: vm.ecsBankModal ? vm.ecsBankModal.bankAcNo : '',
                  transactionType : vm.summaryType == 'FLEXSIP' ? 'Flex SIP' : 'SIP'
                };
                if(vm.summaryDetails.sipDate){
                  payload.startDate = vm.summaryDetails.sipDate;
                }else{
                  payload.startDate = vm.summaryDetails.sipStartDate;
                }
                if(vm.isDREAMSIP){
                  payload.transactionType = 'DREAMSIP';
                }
                localStorage.setItem('q',encodeURI(JSON.stringify(payload)));
                $state.go('manual');
              }
            } else if (resp.data.paymentOption == 'UAP') {
              if(!resp.data.redirectUrl) {
                MessageService.error("something went wrong");
                $state.go('main.dashboard');
              } else {
                $window.location.href = resp.data.redirectUrl
              }
            } else if(vm.isFromEcart && vm.summaryDetails.summaryType === 'SIP'){
              handleEcartPurchaseResponse(resp.data);
            }
            else {
              vm.isActionPerformed = true;
            }
          } else {
            if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.ecsReadOnly = true;
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      var payload = {
        bankDetailsForECS: {
          gateWayVendor: vm.bankdata && vm.bankdata.gateWayVendor? vm.bankdata.gateWayVendor :'',
          paymentOption: vm.selectedPaymentOption,
          accType: vm.ecsBankModal.bankAcType,
          accNumber: vm.ecsBankModal.bankAcNo?vm.ecsBankModal.bankAcNo:vm.bankdata.accountNumber,
          sourceAccountNo: vm.ecsBankModal.bankAcNo?vm.ecsBankModal.bankAcNo:vm.bankdata.accountNumber,
          ifscCode: vm.ecsBankModal.ifscCode,
          neftCode: vm.ecsBankModal.ifscCode,
          bankName: vm.ecsBankModal.bankName,
          branchName: vm.ecsBankModal.bankBranch,
          bankCity: vm.ecsBankModal.bankCity,
          omUmrn: vm.ecsBankModal.omUmrn,
          payoutId: vm.ecsBankModal.payoutId,
          netBankingUrl: vm.ecsBankModal.netBankingUrl,
          camsMandateIdNo: vm.ecsBankModal.camsMandateIdNo
        }
      }
      payload.euin = {};
      if (!vm.summaryDetails.euinCode && vm.euinObj != true) {

        payload.euin.euinOpted = !vm.oversea_arn ? vm.summaryDetails.euinOpted: "N" || 'Y';
        if (vm.summaryDetails.euinOpted == 'Y') {
          payload.euin.euinCode = vm.euinObj ? (vm.euinObj.euinCode ? vm.euinObj.euinCode : vm.summaryDetails.euinCode) : '';
          payload.euin.euinName = vm.euinObj ? (vm.euinObj.euinName ? vm.euinObj.euinName : vm.summaryDetails.euinName) : '';
        }
      }
      if(vm.isDREAMSIP){
        payload.transactionType = "DREAMSIP";
      }
      /*} else {
        MessageService.error("Account Number and Verify Account Number doesn't match");
      }*/
      if (vm.summaryDetails.sipWithFirstInstallment && vm.selectedPaymentOption !== 'UPI') {
        payload.firstInstallmentDetails = vm.selectedPaymentOptionForFI === 'WEB' ? getWebFiPayload() : getOtmFiPayload();
      } else if(vm.summaryDetails.sipWithFirstInstallment && vm.selectedPaymentOption == 'UPI'){
        payload.firstInstallmentDetails = getUPIFiPayload();
      }
      if(vm.sipModifyEnabled){
        payload.uniqueLinkForCancelTransaction = vm.cancelLink;
      }
      if(vm.selectedPaymentOption == 'UPI'){
        payload.bankDetailsForECS.paymentOption = 'UAP';
        payload.payerVpa = vm.virtualAddress;
        payload.payerName = vm.name;
        delete payload.bankDetailsForECS.gateWayVendor;
        delete payload.bankDetailsForECS.camsMandateIdNo;
        delete payload.bankDetailsForECS.payoutId;
      }

      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if(vm.isFromEcart && vm.summaryDetails.summaryType === 'SIP'){
        delete payload.bankDetailsForECS;
        delete payload.euin;
        payload.folioNumber = vm.summaryDetails.folioNumber;
        payload.investorId = vm.summaryDetails.investorId;
        payload.paymentModeSip = vm.selectedPaymentOption;
        payload.installmentAmount = vm.summaryDetails.totalInstallmentAmount;
        payload.gatewayVendor = vm.bankdata && vm.bankdata.gateWayVendor? vm.bankdata.gateWayVendor: null;
        payload.accNo = vm.ecsBankModal.bankAcNo?vm.ecsBankModal.bankAcNo:vm.bankdata.accountNumber;
        payload.accType = vm.ecsBankModal.bankAcType;
        payload.bankName = vm.ecsBankModal.bankName;
        payload.bankCity = vm.ecsBankModal.bankCity;
        payload.bankCode = vm.ecsBankModal.bankCode;
        payload.ifscCode = vm.ecsBankModal.ifscCode;
        payload.payoutId = vm.ecsBankModal.payoutId;
        payload.omUmrn = vm.ecsBankModal.omUmrn;
        payload.netBankingUrl = vm.ecsBankModal.netBankingUrl;
        payload.cartItems = vm.summaryDetails.cartItems;
        payload.flowName = 'E_CART';
        var params = {
          VERSION: version,
          controller: 'transaction',
          child1: 'otp',
          child2: 'approve',
          child3: 'E_CART',
          uniqueLink: vm.uniqueLink
        }
      } else if (vm.summaryDetails.summaryType === 'SIP' || vm.summaryDetails.summaryType === 'FLEX_SIP') {
        var params = {
          VERSION: version,
          controller: 'otp',
          child1: 'approve',
          child2: 'sip',
          uniqueLink: vm.uniqueLink
        }
      }
      else if(vm.summaryDetails.summaryType === 'SIP_TOPUP'){
        var params = {
          VERSION:version,
          controller: 'otp',
          child1: 'approve',
          child2: 'sip_topup',
          uniqueLink: vm.uniqueLink
        }
      }
      if(vm.isFromEcart && vm.summaryDetails.summaryType === 'SIP') {
        BillJunctionService.post(params, payload).$promise.then(success, error);
      } else {
        TransactionApprovalService.post(params, payload).$promise.then(success, error);
      }


    }

    function paymentOptionChanged() {
      vm.startDateValidation = false;
      vm.ischecked = false;
      vm.EcsBankForm && vm.EcsBankForm.$setPristine();
      vm.purchaseBankForm && vm.purchaseBankForm.$setPristine();
      vm.vaForm.purchaseBankForm && vm.vaForm.purchaseBankForm.$setPristine();
      vm.termaAndConditions = false;
      vm.purchaseBankModal = {};
      vm.bankChequeLeaf = "No File Chosen";
      vm.bankchequeLeafUrl = null;
      vm.isIFSCReadonly = false;
      vm.bankdata = null;
      vm.virtualAddress = null;
      vm.fileName = null;
      switch (vm.selectedPaymentOption) {
        case 'EC':
          vm.ecsReadOnly = false;
          var bankName = vm.summaryDetails.folioBankDetails && vm.summaryDetails.folioBankDetails.bankName;
          bankName = bankName ? bankName : '';
          if (bankName.toUpperCase() == 'HDFC') {
            vm.ecsBankModal = angular.copy(vm.summaryDetails.folioBankDetails);
            vm.ecsBankModal.verifyBankAcNo = vm.summaryDetails.folioBankDetails.bankAcNo;
          }
          else {
            vm.ecsBankModal = {};
          }
          getSipEnabledBankList();
          break;
        case 'OTM':
          vm.ecsReadOnly = true;
          vm.showBankFiels = true;
          vm.ecsBankModal = {};
          vm.purchaseBankModal = {};
          vm.otmBankData = null;
          vm.isNewPayment = false;
          vm.startDateValidationPurchase = false;
          getOTMBankList();
          break;
        case 'WEB':
          vm.showBankFiels = false;
          getBillDeskBilljenBankList();
          break;
        case 'VISA':
          vm.showBankFiels = true;
          getBillDeskBilljenBankList();
          break;
        case 'MASTERCARD':
          vm.showBankFiels = true;
          getBillDeskBilljenBankList();
          break;
        case 'RTGS':
          vm.showBankFiels = true;
          vm.ecsReadOnly = false;
          vm.isNewPayment = true;
          vm.fileType='';
          vm.chooseAFile=true;
          if(vm.bankTypeList && vm.appConstants.NRI_STATUS_CODES.includes(vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus)){
            vm.purchaseBankModal.purchasebankAcType = vm.bankTypeList[0];
          }
          getBillDeskBilljenBankList();

          break;
        case 'HDFC':
          vm.showBankFiels = true;
          vm.ecsReadOnly = false;
          vm.isNewPayment = false;
          vm.fileType='';
          vm.chooseAFile=true;
          break;
        case 'DebitCreditCard':
          vm.selectedCardType = 'visa';
          vm.showBankFiels = false;
          cardTypeChanged();
          break;
        case 'UPI':
          if(vm.summaryDetails.amount > vm.upiMaxAmountLimit) {
            vm.selectedPaymentOption = WEB;
            var success = function() {
              vm.selectedPaymentOption = 'WEB';
              vm.paymentOptionChanged();
            }
            ModalService.genericModal({
              text: vm.upiErrorMessage
            },success);
          }
          vm.showBankFiels = false;
          vm.isUPIVerified = false;
          vm.isUPIVerifiedForFI = false;
          break;
        case 'HEM':
          if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') && vm.summaryDetails.bulkTransactionFlag) {
            getEmandateBankList();
          }
          break;
      }
    }

    function changedOtmBank() {
      vm.otmBankLimit = vm.otmBankData && vm.otmBankData.maxAmount;
      var cartItemArr = [];
      var maxCartItem = null;
      if (vm.isFromEcart) {
        vm.summaryDetails.cartItems.forEach(function(el) {
          cartItemArr.push(el.installmentAmount);
          cartItemArr.push(el.amount);
        });
        cartItemArr = cartItemArr.filter(function(item) {
          return item !== undefined && item !== null;
        });
        cartItemArr.sort(function(a, b){return a - b});
        maxCartItem = cartItemArr[cartItemArr.length - 1];
        vm.otmLimitValidation = maxCartItem > vm.otmBankLimit;
      } else {
        vm.otmLimitValidation = vm.summaryDetails.amount > vm.otmBankLimit;
      }
      vm.otmExpDate = vm.otmBankData && moment(vm.otmBankData.omExpiryDate, 'DD-MMM-YYYY');
      vm.otmStartDate = vm.otmBankData && moment(vm.otmBankData.omStartDate, 'DD-MMM-YYYY');

      if(vm.otmBankData) {
        if(vm.otmBankData.ifscCode == null) {
          vm.isIFSCReadonly = false;
        } else {
          vm.isIFSCReadonly = true;
        }
      }

      if(vm.summaryDetails.minorFolioFlag && !vm.summaryDetails.cgfFlag && (vm.otmBankData && !vm.otmBankData.minorBankFlag))
      {
        ModalService.minorBankModal({dynamicDataPopup : vm.dynamicData});
        vm.otmBankData=null;
        vm.ecsBankModal = {};
        vm.purchaseBankModal = {};
      }
      else
      {
        if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') &&
          vm.summaryDetails.sipEndDate && vm.otmExpDate) {
          vm.endDateValidation = vm.summaryDetails.sipEndDate && (moment(vm.summaryDetails.sipEndDate, "DD-MMM-YYYY")> moment(vm.otmExpDate,"DD-MMM-YYYY"));
        }
        if (vm.summaryType == 'SIP' && vm.summaryDetails.sipDate && vm.otmStartDate) {
          vm.startDateValidation = vm.summaryDetails.sipDate && (moment(vm.summaryDetails.sipDate, "DD-MMM-YYYY") < moment(vm.otmStartDate,"DD-MMM-YYYY"));
        }
        vm.ecsReadOnly = false;
        if (vm.otmBankData && vm.selectedPaymentOption == 'OTM') {
          if (vm.summaryType == 'SIP' || vm.summaryType == 'SIP_TOPUP' || vm.summaryType == 'FLEXSIP') {
            vm.ecsBankModal.bankAcNo = vm.otmBankData.bankAcNo;
            vm.ecsBankModal.verifyBankAcNo = vm.otmBankData.bankAcNo;
            vm.ecsBankModal.bankName = vm.otmBankData.bankName;
            vm.ecsBankModal.bankBranch = vm.otmBankData.bankBranch;
            vm.ecsBankModal.ifscCode = vm.otmBankData.ifscCode;
            vm.ecsBankModal.bankAcType = vm.otmBankData.bankAcType;
            vm.ecsBankModal.bankCity = vm.otmBankData.bankCity;
            vm.ecsBankModal.omUmrn = vm.otmBankData.omUmrn;
            vm.ecsBankModal.omExpiryDate = vm.otmBankData.omExpiryDate;
            vm.ecsBankModal.maxAmount = parseInt(vm.otmBankData.maxAmount);
            vm.ecsBankModal.payoutId = vm.otmBankData.payoutId;
            vm.ecsBankModal.camsMandateIdNo = vm.otmBankData.camsMandateIdNo;
            vm.ecsBankModal.omStartDate = vm.otmBankData.omStartDate ? vm.otmBankData.omStartDate : null;
            if((vm.otmBankData.otmFrequency !== 'AWP') && (vm.summaryDetails.sipFrequency === 'Daily')){
              MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
            }
          }
          else if (vm.summaryType == 'PURCHASE') {
            vm.purchaseBankModal.bankAcNo = vm.otmBankData.bankAcNo;
            vm.purchaseBankModal.verifyBankAcNo = vm.otmBankData.bankAcNo;
            vm.purchaseBankModal.bankName = vm.otmBankData.bankName;
            vm.purchaseBankModal.bankBranch = vm.otmBankData.bankBranch;
            vm.purchaseBankModal.ifscCode = vm.otmBankData.ifscCode;
            vm.purchaseBankModal.bankAcType = vm.otmBankData.bankAcType;
            vm.purchaseBankModal.bankCity = vm.otmBankData.bankCity;
            vm.purchaseBankModal.omUmrn = vm.otmBankData.omUmrn;
            vm.purchaseBankModal.payoutId = vm.otmBankData.payoutId;
            vm.purchaseBankModal.camsMandateIdNo = vm.otmBankData.camsMandateIdNo;
            vm.purchaseBankModal.maxAmount = vm.otmBankData.maxAmount;
            vm.purchaseBankModal.omExpiryDate = vm.otmBankData.omExpiryDate;
          }
          $timeout(function () {
            vm.ecsReadOnly = true;
          }, 100);
        }
        else {
          vm.ecsBankModal = {};
          vm.purchaseBankModal = {};
        }
      }
      otmStartValidationPurchase();
    }

    function approveTransaction() {
      vm.purchasePayload = {};
      var message = "";
      var successHandler = function(resp) {
        switch (vm.selectedPaymentOption) {
          case 'EC':
            var success = function () {
              approveEcsBankTransaction();
            };

          if(vm.dynamicDataCutOff && vm.dynamicDataCutOff.content) {
            ModalService.cutOffModal({message: message}, success);
          } else {
            approveEcsBankTransaction();
          }
          break;
        case 'WEB':
          vm.purchasePayload.paymentMode = 'WEB';
          checkForMakePayment();
          break;
        case 'VISA':
          checkForMakePayment();
          break;
        case 'MASTERDEBITCARD':
          checkForMakePayment();
          break;
        case 'RTGS':
          vm.purchasePayload.paymentMode = 'RTGS';
          checkForMakePayment();
          break;
        case 'HDFC':
          vm.purchasePayload.paymentMode = 'HDFC';
          checkForMakePayment();
          break;
        case 'OTM':
          vm.purchasePayload.paymentMode = 'OTM';
          if (vm.summaryType == 'SIP' || vm.summaryType == 'SIP_TOPUP' || vm.summaryType == 'FLEXSIP') {
            var success = function () {
              approveEcsBankTransaction();
            };

              if (vm.dynamicDataCutOff && vm.dynamicDataCutOff.content) {
                ModalService.cutOffModal({message: message}, success);
              } else {
                approveEcsBankTransaction();
              }
            } else if (vm.summaryType == 'PURCHASE') {
              checkForMakePayment();
            }
            break;
          case 'DebitCreditCard':
            checkForMakePayment();
            break;
          case 'UPI':
            if(vm.summaryType == 'SIP'){
              approveEcsBankTransaction();
            } else {
              checkForMakePayment();
            }
            break;
          case 'HEM':
            var success = function () {
              approveEmandate();
            };

            if (vm.dynamicDataCutOff && vm.dynamicDataCutOff.content) {
              ModalService.cutOffModal({message: message}, success);
            } else {
              approveEmandate();
            }
            break;
        }
      }

      var errorHandler = function(resp) {}

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);

    }

    function handleEmandateSipResponse(data) {
      data = data && data.data ? data.data : data;
      if (!data) {
        MessageService.error();
        return;
      }
      $window.location.href="https://www.billdesk.in/billpay/APIEMandateController?action=APIEMandateHDFCOTMReg&msg="+data.emandateMsg;
    }

    function finalSubmit (payload) {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(vm.isFromEcart){
              handleEcartPurchaseResponse(resp.data);
            } else {
              handleEmandateSipResponse(resp.data);
            }
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if(vm.isFromEcart) {
        var params = {
          VERSION: version,
          controller: 'transaction',
          child1: 'otp',
          child2: 'approve',
          child3: 'E_CART',
          uniqueLink: vm.uniqueLink
        }
        BillJunctionService.post(params, payload).$promise.then(success, error);
      } else {
        var params = {
          VERSION: version,
          controller: 'otp',
          child1: 'approve',
          child2: 'sip',
          uniqueLink: vm.uniqueLink
        }
        TransactionApprovalService.post(params, payload).$promise.then(success, error);
      }

    }

    function approveEmandate() {
      var successCallback = function () {
        var payload={
          "bankDetailsForECS" : {
            "accNumber" : vm.bankdata.accountNumber,
            "accType" : vm.bankdata.bankAcType,
            "authenticationMode" : vm.authModeData.value,
            "bankCity" : vm.bankdata.bankCity,
            "bankCode" : vm.bankdata.bankCode,
            "bankName" : vm.bankdata.bankName,
            "branchName" : vm.bankdata.bankBranch,
            "gatewayVendor" : vm.bankdata.gateWayVendor,
            "gateWayVendor" : vm.bankdata.gateWayVendor,
            "ifscCode" : vm.bankdata.ifscCode,
            "paymentOption" : vm.selectedPaymentOption
          }
        }

        if(vm.isFromEcart && vm.summaryDetails.summaryType === 'SIP' && vm.selectedPaymentOption == 'HEM'){
          delete payload.bankDetailsForECS;
          payload.folioNumber = vm.summaryDetails.folioNumber;
          payload.investorId = vm.summaryDetails.investorId;
          payload.paymentModeSip = vm.selectedPaymentOption;
          payload.installmentAmount = vm.summaryDetails.totalInstallmentAmount;
          payload.gatewayVendor = vm.bankdata && vm.bankdata.gateWayVendor? vm.bankdata.gateWayVendor: null;
          payload.accNo = vm.bankdata.accountNumber;
          payload.accType = vm.bankdata.bankAcType;
          payload.authenticationMode = vm.authModeData.value;
          payload.bankName = vm.bankdata.bankName;
          payload.bankCity = vm.bankdata.bankCity;
          payload.bankCode = vm.bankdata.bankCode;
          payload.ifscCode = vm.bankdata.ifscCode;
          payload.cartItems = vm.summaryDetails.cartItems;
          payload.flowName = 'E_CART';
          payload.mandateAmount = vm.amount;
          payload.emandateStartDate = vm.eMandateStartDate;
          payload.emandateEndDate = vm.eMandateEndDate;
        }

        payload.authenticationMode = vm.authModeData.value;
        payload.mandateAmount = vm.amount;
        if(!vm.isFromEcart) {
          payload.mandateStartDate = vm.eMandateStartDate;
          payload.mandateEndDate = vm.eMandateEndDate;
        }

        if(vm.sipModifyEnabled){
          payload.uniqueLinkForCancelTransaction = vm.cancelLink;
        }
        finalSubmit(payload);
      }
      var errorCallback = function () {
        LoaderService.hideLoader();
        scope.isCheckedTandC=true;
      }
      ModalService.registerEMandateModal({payoutId: vm.emPayoutId.substr(0, vm.emPayoutId.lastIndexOf('-')), authMode: vm.authModeData.value},successCallback,errorCallback);
    }

    function verifyPaymentAddress() {
      vm.verifyUPIResp = {};
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.isUPIVerified = true;
              vm.errorMessage = '';
            } else {
              vm.isUPIVerified = false;
              MessageService.error('Not a valid address.');
              vm.errorMessage = '';
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
            vm.errorMessage = resp.message;
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          vm.isUPIVerified = false;
          $log.info("upi error====", err);
          LoaderService.hideLoader();
          vm.errorMessage = '';
        };

      LoaderService.showLoader();

      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if(vm.summaryDetails.summaryType === "SIP" && vm.selectedPaymentOption == 'UPI'){
        var payload = {
          "virtualAddress": vm.virtualAddress,
          "folioNo": vm.summaryDetails.folioNumber,
          "isBasketFlow": false
        }
        InvestorCommonServiceVersion2.post({
          child1 : 'upi',
          child2 : 'check',
          child3 : 'virtualAddress'
        },payload).$promise.then(success, error);
      }else{
        UtilityService.post({
          controller: 'upi',
          child: 'check',
          child1: 'virtualAddress'
        }, {"virtualAddress": vm.virtualAddress}).$promise.then(success, error);
      }
    }

    function getAccountNumber(bankCode) {
      vm.bankAccounts = [];
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                checkForMakePayment(accountNo)
              }, error = function () {

              };
              ModalService.selectAccountNoModal({bankAccounts: vm.bankAccounts, backdrop: 'static'}, success, error);
            } else {
              checkForMakePayment(vm.bankAccounts[0]);
            }
          } else {
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
        error = function (err) {
          vm.bankAccounts = [];
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.summaryDetails.folioNumber, //'9422332',
        "bankCode": bankCode
      };
      UtilityService.post({
        controller: 'bank',
        child: 'account'
      }, payload).$promise.then(success, error);
    }

    vm.showCutOffModal = function (message) {
      var success = function () {
        finalPayment();
      }, error = function () {

      };

      if(vm.dynamicDataCutOff && vm.dynamicDataCutOff.content) {
        ModalService.cutOffModal({message: message}, success, error);
      } else {
       finalPayment();
      }
    };

    vm.showLiquidPurchaseModal = function () {
      var success = function () {
        finalPayment();
      }, error = function () {
      };
      ModalService.liquidPurchaseModal({}, success, error);
    };

    function informationPopup() {
      // var currentTime = $window.moment(new Date(), "HH:mm:ss a");
      // var dow = currentTime.format('dddd');
      // var d = new Date();
      // var message = '';
      // var notAllowedDays = ['Saturday', 'Sunday'];
      // if ((!(vm.summaryDetails.schemeName && vm.summaryDetails.schemeName.match(/liquid/ig))
      //   || ((vm.summaryDetails.sourceScheme && vm.summaryDetails.sourceScheme.schemeName))
      //   || ((vm.summaryDetails.targetScheme && vm.summaryDetails.targetScheme.schemeName))
      // )&& notAllowedDays.indexOf(dow) == -1) {
      //   d.setHours(13);
      //   d.setMinutes(0);
      //   d.setSeconds(0);
      //   var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
      //   var status = currentTime.isAfter(timeToCompareNonLiquid);
      //   status ? vm.showCutOffModal() : finalPayment();
      // } else if ((vm.summaryDetails.schemeName && vm.summaryDetails.schemeName.match(/liquid/ig))){
      //   d.setHours(12);
      //   d.setMinutes(30);
      //   d.setSeconds(0);
      //   var timeToCompareNonLiquid = $window.moment(d, "HH:mm:ss a");
      //   var status = currentTime.isAfter(timeToCompareNonLiquid);
      //   status ? vm.showLiquidPurchaseModal() : finalPayment();
      // } else {
        vm.showCutOffModal()
      // }
    }
    function finalPayment() {
      if(vm.summaryType == 'PURCHASE')
        makePayment();
      else if(vm.summaryType == 'REDEMPTION')
        approveSWP_REDEMPTION();
      else if(vm.summaryType == "SWITCH")
        approveSWITCH_STP_DTP_REDEEM();
    }

    function checkForMakePayment(){
      if(vm.summaryType == 'PURCHASE'){
        informationPopup();
      } else {
        makePayment();
      }
  }

    function makePayment(accountNo) {
      if (vm.sentToPaymentGatewayOption && vm.sentToPaymentGatewayOption == 'AMOUNT_NOT_DEDUCTED') {
        vm.purchasePayload.retryPayment = true;
      }
      if (vm.selectedPaymentOption == 'WEB') {
        if (vm.bankdata.gateWayVendor == "BILLDESK") {
          vm.purchasePayload.webMode = 'BILLDESK';
          vm.purchasePayload.bankCode = vm.bankdata.bankCode;
        }
        else if (vm.bankdata.gateWayVendor == "BILLJUNCTION") {
          vm.purchasePayload.webMode = 'BILLJUNCTION';
          vm.purchasePayload.bankCode = vm.bankdata.bankCode;
        }
        else if(vm.bankdata.gateWayVendor == "RAZORPAY")
        {
          vm.purchasePayload.webMode = 'RAZORPAY';
          vm.purchasePayload.bankCode = vm.bankdata.bankCode;
        }
        vm.purchasePayload.uniqueLink = vm.uniqueLink;
        vm.purchasePayload.amount = vm.summaryDetails.amount;
        vm.purchasePayload.transactionId = null;
        vm.purchasePayload.instrnDate = null;
        vm.purchasePayload.instrmNo = null;
        vm.purchasePayload.accountNumber = vm.bankdata.accountNumber || null;  //uncomment for tpv
        vm.purchasePayload.sourceAccountNo =  vm.bankdata.accountNumber || null;
        vm.purchasePayload.tpvEnableFlag = vm.bankdata.tpvEnableFlag;
        vm.purchasePayload.branchName = null;
        vm.purchasePayload.bankCity = null;
        vm.purchasePayload.accType = vm.bankdata.bankAcType?vm.bankdata.bankAcType:vm.purchaseBankModal.purchasebankAcType.accountTypeCode;
        vm.purchasePayload.bankName = vm.bankdata.bankName;
        vm.purchasePayload.omUmrn = null;
        vm.purchasePayload.payoutId = null;
        vm.purchasePayload.ifscCode = vm.bankdata.ifscCode? vm.bankdata.ifscCode:vm.purchaseBankModal.ifscCode;
      }
      else if (vm.selectedPaymentOption == 'VISA') {
        vm.purchasePayload.webMode = 'VISA';
        vm.purchasePayload.cardHolderName = vm.cardDetails.cardHolderName;
        vm.purchasePayload.cardNumber = vm.cardDetails.cardNumberVisa;
        vm.purchasePayload.cardExpiryMonth = vm.cardDetails.cardExpiryMonth;
        vm.purchasePayload.cardExpiryYear = vm.cardDetails.cardExpiryYear;
        vm.purchasePayload.CVV = vm.cardDetails.CVV;
        vm.purchasePayload.paymentMode = 'WEB';
        vm.purchasePayload.bankCode = vm.bankdata.bankCode;
      }
      else if (vm.selectedPaymentOption == 'MASTERCARD') {
        vm.purchasePayload.webMode = 'MASTERCARD';
        vm.purchasePayload.cardHolderName = vm.cardDetails.cardHolderName;
        vm.purchasePayload.cardNumber = vm.cardDetails.cardNumberMaster;
        vm.purchasePayload.cardExpiryMonth = vm.cardDetails.cardExpiryMonth;
        vm.purchasePayload.cardExpiryYear = vm.cardDetails.cardExpiryYear;
        vm.purchasePayload.CVV = vm.cardDetails.CVV;
        vm.purchasePayload.paymentMode = 'WEB';
        vm.purchasePayload.bankCode = vm.bankdata.bankCode;
      }
      else if (vm.selectedPaymentOption == 'RTGS' || vm.selectedPaymentOption == 'HDFC') {
        vm.purchasePayload.accNo = vm.purchaseBankModal.bankAcNo;
        vm.purchasePayload.branchName = vm.purchaseBankModal.bankBranch;
        vm.purchasePayload.bankName = vm.bankdata && vm.bankdata.bankNameOnly ? vm.bankdata.bankNameOnly : vm.purchaseBankModal.bankName;
        vm.purchasePayload.utr = vm.purchaseBankModal.utr;
        vm.purchasePayload.bankCode = null;
        vm.purchasePayload.bankCity = null;
        vm.purchasePayload.accType = vm.isNewPayment ? vm.purchaseBankModal.purchasebankAcType.accountTypeCode : vm.bankdata && vm.bankdata.bankAcType ? vm.bankdata.bankAcType : vm.purchaseBankModal.purchasebankAcType.accountTypeCode;
        vm.purchasePayload.uniqueLink = vm.uniqueLink;
        vm.purchasePayload.amount = vm.summaryDetails.amount;
        vm.purchasePayload.transactionId = null;
        vm.purchasePayload.instrnDate = null;
        vm.purchasePayload.instrmNo = null;
        vm.purchasePayload.omUmrn = null;
        vm.purchasePayload.payoutId = null;
        vm.purchasePayload.webMode = null;
        vm.purchasePayload.chequeLeaf = vm.purchaseBankModal.chequeLeaf;
        vm.purchasePayload.ifscCode = vm.isNewPayment ? vm.purchaseBankModal.ifscCode : vm.bankdata && vm.bankdata.ifscCode ? vm.bankdata.ifscCode : vm.purchaseBankModal.ifscCode;
        // vm.purchasePayload.bankName = vm.bankdata ? vm.bankName : vm.purchaseBankModal.bankName ;
        vm.purchasePayload.sourceAccountNo = vm.bankdata ? vm.bankdata.accountNumber : vm.purchaseBankModal.bankAcNo;
      }
      else if (vm.selectedPaymentOption == 'OTM') {
        vm.purchasePayload.uniqueLink = vm.uniqueLink;
        vm.purchasePayload.amount = vm.amount;
        vm.purchasePayload.transactionId = null;
        vm.purchasePayload.instrnDate = null;
        vm.purchasePayload.instrmNo = null;
        vm.purchasePayload.accNo = vm.otmBankData.bankAcNo;
        vm.purchasePayload.branchName = null;
        vm.purchasePayload.bankName = null;
        vm.purchasePayload.bankCode = null;
        vm.purchasePayload.bankCity = null;
        vm.purchasePayload.accType = null;
        vm.purchasePayload.webMode = null;
        vm.purchasePayload.omUmrn = vm.purchaseBankModal.omUmrn;
        vm.purchasePayload.payoutId = vm.purchaseBankModal.payoutId;
        vm.purchasePayload.camsMandateIdNo = vm.purchaseBankModal.camsMandateIdNo;
        vm.purchasePayload.sourceAccountNo = vm.otmBankData.bankAcNo;
        vm.purchasePayload.ifscCode = vm.otmBankData.ifscCode ? vm.otmBankData.ifscCode : vm.purchaseBankModal.ifscCode;
        vm.purchasePayload.accType  =  vm.otmBankData.bankAcType ? vm.otmBankData.bankAcType : vm.purchaseBankModal.purchasebankAcType.accountTypeCode;
        vm.purchasePayload.bankName = vm.otmBankData.bankName;
      }
      else if (vm.selectedPaymentOption == 'DebitCreditCard') {
        if (vm.selectedCardType === 'visa') {
          vm.purchasePayload.uniqueLink = vm.uniqueLink;
          vm.purchasePayload.webMode = vm.cardBankData.gateWayVendor;
          vm.purchasePayload.bankCode = vm.cardBankData.bankCode;
          vm.purchasePayload.bankName = vm.cardBankData.bankName;
          //vm.purchasePayload.tpvEnableFlag = vm.cardBankData.tpvEnableFlag; //uncomment for tpv
          vm.purchasePayload.paymentMode = 'WEB';
        }
        else if (vm.selectedCardType === 'maestro') {
          vm.purchasePayload.uniqueLink = vm.uniqueLink;
          vm.purchasePayload.webMode = vm.cardBankData.gateWayVendor;
          vm.purchasePayload.bankCode = vm.cardBankData.bankCode;
          vm.purchasePayload.bankName = vm.cardBankData.bankName;
          //vm.purchasePayload.tpvEnableFlag = vm.cardBankData.tpvEnableFlag; //uncomment for tpv
          vm.purchasePayload.paymentMode = 'WEB';
        }
        vm.purchasePayload.amount = vm.summaryDetails.amount;
      } else if (vm.selectedPaymentOption == 'UPI') {
        vm.purchasePayload.webMode = 'UPI';
        vm.purchasePayload.paymentMode = 'WEB';
        vm.purchasePayload.uniqueLink = vm.uniqueLink;
        vm.purchasePayload.amount = vm.summaryDetails.amount;
        vm.purchasePayload.transactionId = null;
        vm.purchasePayload.instrnDate = null;
        vm.purchasePayload.instrmNo = null;
        vm.purchasePayload.accountNumber = vm.bankdata.accountNumber || null;  //uncomment for tpv
        vm.purchasePayload.tpvEnableFlag = vm.bankdata.tpvEnableFlag;
        vm.purchasePayload.branchName = null;
        vm.purchasePayload.bankCity = null;
        vm.purchasePayload.accType = vm.bankdata.bankAcType?vm.bankdata.bankAcType:vm.purchaseBankModal.purchasebankAcType.accountTypeCode;
        vm.purchasePayload.bankName = vm.bankdata.bankName;
        vm.purchasePayload.omUmrn = null;
        vm.purchasePayload.payoutId = null;
        vm.purchasePayload.virtualAddress = vm.virtualAddress;
        vm.purchasePayload.ifscCode = vm.bankdata.ifscCode ? vm.bankdata.ifscCode : vm.purchaseBankModal.ifscCode;
        vm.purchasePayload.sourceAccountNo = vm.bankdata.accountNumber;
      }
      if (!vm.summaryDetails.euinCode && vm.euinObj != true) {
        vm.purchasePayload.euin = {};
        vm.purchasePayload.euin.euinOpted = !vm.oversea_arn ? vm.summaryDetails.euinOpted : 'N' || 'Y';
        if (vm.summaryDetails.euinOpted == 'Y') {
          vm.purchasePayload.euin.euinCode = (vm.summaryDetails.euinOpted == 'Y' && vm.euinObj) ? (vm.euinObj.euinCode ? vm.euinObj.euinCode : vm.summaryDetails.euinCode) : '';
          vm.purchasePayload.euin.euinName = (vm.summaryDetails.euinOpted == 'Y' && vm.euinObj) ? (vm.euinObj.euinName ? vm.euinObj.euinName : vm.summaryDetails.euinName) : '';
        }
      }

      if(vm.isFromEcart){
        vm.purchasePayload.gatewayVendor = vm.purchasePayload.webMode;
        vm.purchasePayload.accNo = vm.purchasePayload.accountNumber? vm.purchasePayload.accountNumber: vm.purchasePayload.sourceAccountNo;
        if(vm.ecartTransactionType == 'PURCHASE'){
          if(vm.selectedPaymentOption == 'WEB'){
            vm.purchasePayload.paymentOption = 'NET_BANKING';
          }  else if(vm.selectedPaymentOption == 'OTM'){
            vm.purchasePayload.paymentOption = 'OTM';
          }
        } else if(vm.ecartTransactionType == 'MIX'){
          if(vm.selectedPaymentOption == 'WEB'){
            vm.purchasePayload.paymentOption = 'NET_BANKING';
            vm.purchasePayload.paymentModeSip = 'EC';
          } else if(vm.selectedPaymentOption == 'OTM'){
            vm.purchasePayload.paymentOption = 'OTM';
            vm.purchasePayload.paymentModeSip = 'OTM';
          }
        }
        vm.purchasePayload.cartItems = vm.summaryDetails.cartItems;
        vm.purchasePayload.investorId = vm.summaryDetails.investorId;
        vm.purchasePayload.flowName = 'E_CART';
        vm.purchasePayload.folioNumber = vm.summaryDetails.folioNumber;
        vm.purchasePayload.amount = vm.summaryDetails.totalAmount;
        delete vm.purchasePayload.uniqueLink;
        delete vm.purchasePayload.webMode;
        delete vm.purchasePayload.accountNumber;
        delete vm.purchasePayload.paymentMode;
        delete vm.purchasePayload.transactionId;
        delete vm.purchasePayload.sourceAccountNo;
      }

      var success = function (resp) {
          LoaderService.hideLoader();
          // console.log("resp==== ",resp)

          if (resp.data && resp.status) {
            vm.isActionPerformed = true;
            if (vm.purchasePayload.paymentMode == 'WEB' && vm.purchasePayload.webMode == 'BILLDESK') {
              vm.billdeskPayload.msg = resp.data.trnxActionMsg;
              /*$timeout(function () {
                $location.path('/').replace();
              }, 1000);*/
              if (vm.selectedPaymentOption === 'DebitCreditCard' || vm.purchasePayload.bankCode === 'NA') {
                /*angular.element('#msgDebitOnly').value = resp.data.trnxActionMsg;*/
                $timeout(function () {
                  angular.element('#billdeskForm').submit();
                }, 100);
                //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
              } else {
                //angular.element('#msg').value = resp.data.trnxActionMsg;
                $timeout(function () {
                  angular.element('#billdeskForm').submit();
                }, 100);
                //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
              }
            }
            else if (vm.purchasePayload.paymentMode == 'WEB' && vm.purchasePayload.webMode == 'BILLJUNCTION') {
              /*$timeout(function () {
                $location.path('/').replace();
              }, 10);*/
              $window.open(resp.data.trnxActionMsg, '_self');
            }
            else if (vm.purchasePayload.paymentMode == 'WEB' && vm.selectedPaymentOption == 'UPI') {
              if(!resp.data.redirectUrl) {
                MessageService.error("something went wrong");
                $state.go('main.dashboard');
              } else {
                $window.location.href = resp.data.redirectUrl
              }
            } else if (vm.isFromEcart) {
              handleEcartPurchaseResponse(resp.data);
            } else if (vm.purchasePayload.paymentMode == 'WEB' && vm.purchasePayload.webMode == 'RAZORPAY') {
              PaymentService.openRazorPay(resp.data);
            }
            else {
              //MessageService.success(resp.data);
              $state.go('transactionsuccess');
            }
          }
          else {
            if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      vm.isActionPerformed = true;
      // var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if(vm.isFromEcart){
        BillJunctionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'transaction',
          child1: 'otp',
          child2: 'approve',
          child3: 'E_CART',
          uniqueLink: vm.uniqueLink
        }, vm.purchasePayload).$promise.then(success, error);
      } else {
        BillJunctionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'transaction',
          child1: 'otp',
          child2: 'pay',
          child3: 'purchase'
        }, vm.purchasePayload).$promise.then(success, error);
      }
    }

    function approveTransactionForSWP_REDEMPTION() {
      var successHandler = function(resp) {
       if(vm.summaryType == 'REDEMPTION')
         finalPayment();
       else approveSWP_REDEMPTION();
      }

      var errorHandler = function(resp) {}

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.sourceScheme.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);

    }

    function approveSWP_REDEMPTION() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.isActionPerformed = true;
            // MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_APPROVED);
            $state.go('transactionsuccess');
          }
          else {
            if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          $log.info("error====", err);
          MessageService.error();
        };
      var payload = {
        "accountNumber": vm.selectedBank.bankAcNo,
        "bankName": vm.selectedBank.bankName,
        "branchName": vm.selectedBank.bankBranch,
        "ifscCode": vm.selectedBank.ifscCode,
        "payMech": vm.selectedBank.payoutDescription,
        "payoutId": vm.selectedBank.payoutId,
        "primaryBankFlag": vm.selectedBank.primaryFlag
      };
      LoaderService.showLoader();
      vm.isActionPerformed = true;
      var version = $rootScope.apiVersion ? $rootScope.apiVersion : HDFC_API.VERSION;
      BillJunctionService.post({
        VERSION: version,
        controller: 'transaction',
        child1: 'otp',
        child2: 'approve',
        child3: vm.summaryType.toLowerCase(), //'swp',
        uniqueLink: vm.uniqueLink
      }, payload).$promise.then(success, error);
    }

    function approveTransactionForSWITCH_STP_DTP_REDEEM() {
      var successHandler = function(resp) {
        if (!vm.summaryType || !vm.uniqueLink) {
          return;
        }
        if(vm.summaryType == "SWITCH"){
          informationPopup();
        }else approveSWITCH_STP_DTP_REDEEM();
      }

      var errorHandler = function(resp) {}

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.sourceScheme.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);

    }

    function approveSWITCH_STP_DTP_REDEEM() {
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isActionPerformed = true;
            $state.go('transactionsuccess');
          } else {
            if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };

      var payload = {euinOpted: 'N'};

      if (vm.summaryType != 'DTP' && !vm.summaryDetails.euinCode && vm.euinObj != true) {
        payload.euinOpted = !vm.oversea_arn ? vm.summaryDetails.euinOpted : 'N' || 'Y';
        payload.euinCode = vm.euinObj && vm.euinObj.euinCode ? vm.euinObj.euinCode : vm.summaryDetails.euinCode;
        payload.euinName = vm.euinObj && vm.euinObj.euinName ? vm.euinObj.euinName : vm.summaryDetails.euinName;
      }

      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      version = version ? version : HDFC_API.VERSION;
      if (version == 'v1') {
        TransactionService.get({
          VERSION: version,
          controller: 'otp',
          child2: 'approve',
          uniqueLink: vm.uniqueLink
        }, null).$promise.then(success, error);
      }
      else {
        TransactionService.post({
          VERSION: version,
          controller: 'otp',
          child2: 'approve',
          uniqueLink: vm.uniqueLink
        }, payload).$promise.then(success, error);
      }
    }

    function approveTransactionForROLLOVER() {
      if (!vm.summaryType || !vm.uniqueLink) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.trnxActionFlag) {
              vm.isActionPerformed = true;
              $state.go('transactionsuccess');
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.data.trnxActionMsg);
            }
          } else {
             if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };

      var payload = {
        "linkId": vm.uniqueLink,
        "folioNumber": vm.summaryDetails.folioNumber
      };

      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      version = version ? version : HDFC_API.VERSION;

      var successHandler = function(resp) {
        DistributorGenericService.post({
          controller: 'rollover',
          child1: 'approve'
        }, payload).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
      }

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);

    }

    function approveTransactionForCANCELLATION(cancelPayload) {
      if (!vm.summaryType || !vm.uniqueLink) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.trnxActionFlag) {
              vm.isActionPerformed = true;
              MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_CANCELATION);
              //$state.go('transactionsuccess');
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.data.trnxActionMsg);
            }
          } else {
              if(resp.popupEnabled) {
                vm.isActionPerformed = false;
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                vm.isActionPerformed = false;
                MessageService.error(resp.message);
              }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };


      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      version = version ? version : HDFC_API.VERSION;
      var payload = cancelPayload ? cancelPayload : {};

      TransactionService.post({
        VERSION: version,
        controller: 'otp',
        child2: 'systematic',
        child3: 'approveCancel',
        uniqueLink: vm.uniqueLink
      }, payload).$promise.then(success, error);

      /*var successHandler = function(resp) {

      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
      }

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);*/

    }


    function approveTransactionForPAUSE() {

      if (!vm.summaryType || !vm.uniqueLink) {
        return;
      }
      var sipFrequency = (vm.summaryDetails.frequency === 'Monthly' ? 'OM' : 'Q');
      if (vm.summaryDetails) {
        var folioNumber = vm.summaryDetails.folioNumber;
        var frequency = sipFrequency;
        var amount = vm.summaryDetails.amount;
        var schemeCode = vm.summaryDetails.schemeCode;
        var atrxnNo = vm.summaryDetails.camsRefNo;
        var installmentsPaused = (vm.summaryDetails.frequency === 'Quarterly' ? 1 : (vm.noOfInstallment ? vm.noOfInstallment : vm.summaryDetails.installmentsPaused));
        var transactionId = vm.summaryDetails.transactionId;
        var transactionType = vm.summaryDetails.transactionType;
      }
      var payload = {
        "atrxnNo":atrxnNo,
        "amount": amount,
        "folioNumber": folioNumber,
        "frequency": frequency,
        "schemeCode": schemeCode,
        "installmentsPaused": installmentsPaused,
        "pauseFromDate": localStorage.getItem("selDate"),
        "pauseToDate": vm.SipPauseEndDate.clone().format("DD-MMM-YYYY"),
        "transactionId": transactionId,
        "transactionType": transactionType
      };
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.trnxActionFlag) {
              vm.isActionPerformed = true;
              if(vm.summaryDetails.transactionType == 'DREAMSIP'){
                MessageService.success("Your DREAM SIP Paused successfully.");
              }else{
                MessageService.success(resp.data.trnxActionMsg);
              }
              //$state.go('transactionsuccess');
              vm.actionHappened=true;
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.trnxActionMsg);
            }
          } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                vm.isActionPerformed = false;
                MessageService.error(resp.message);
              }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };


      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      version = version ? version : HDFC_API.VERSION;
      TransactionService.post({
        VERSION: version,
        controller: 'otp',
        child2: 'systematic',
        child3: 'approvePause',
        uniqueLink: vm.uniqueLink
      }, payload).$promise.then(success, error);

      /*var successHandler = function(resp) {

      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
      }

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.folioNumber,vm.summaryDetails.distributorDetails.arnNo).then(successHandler).catch(errorHandler);*/
    }


    function approveNominee() {
      if (!vm.summaryType || !vm.uniqueLink) {
        return;
      }
      if (vm.summaryDetails) {
        var folioNumber = vm.summaryDetails.folioNumber;
      }
      var payload = {
        "folioNo": folioNumber,
        "approved":true,
        "summaryType":vm.summaryType,
        "jH_mail": vm.NomineeEmail,
        "jh_Mobile":vm.NomineeMobile,
        "jH_mail_belongs_to": vm.emailBelongsTo,
        "jH_Mobile_belongs_to": vm.mobileBelongsTo
      };

      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.message) {
              vm.isActionPerformed = true;
              MessageService.success(resp.data.message);
              //$state.go('transactionsuccess');
              vm.actionHappened=true;
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          } else {
            vm.isActionPerformed = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };


      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      version = version ? version : HDFC_API.VERSION;
      if(vm.showRegulatoryChanges) {
        version = HDFC_API.VERSION;
        TransactionService.post3({
          VERSION: version,
          controller: 'otp',
          child2: 'nominee',
          child3: 'action',
          uniqueLink: vm.uniqueLink
        }, payload).$promise.then(success, error);
      } else {
        TransactionService.post({
          VERSION: version,
          controller: 'otp',
          child2: 'nominee',
          child3: 'action',
          uniqueLink: vm.uniqueLink
        }, payload).$promise.then(success, error);
      }
    }


    function rejectNominee() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      var success = function () {
          MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.TRANSACTION_REJECTED);
          vm.isActionPerformed = true;
        },
        error = function (err) {
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };
      ModalService.rejectTransactionModal({
        uniqueLink: vm.uniqueLink,
        folioNumber: vm.summaryDetails.folioNumber,
        summaryType: vm.summaryDetails.summaryType,
        transactionId: vm.summaryDetails.transactionId,
        mail: vm.NomineeEmail,
        Mobile: vm.NomineeMobile,
        mail_belongs_to: vm.emailBelongsTo,
        Mobile_belongs_to: vm.mobileBelongsTo,
        showRegulatoryChanges: vm.showRegulatoryChanges
      }, success, error);
    }

    function approveTransactionForChangeDividend() {
      if (!vm.summaryType || !vm.uniqueLink) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isActionPerformed = true;
            $state.go('transactionsuccess');
          } else {
            if(resp.popupEnabled) {
              vm.isActionPerformed = false;
              ModalService.genericModal({
              text: resp.message
             });
            } else {
              vm.isActionPerformed = false;
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };

      var successHandler = function(resp) {
        ChangeDividendService.get({
          child1: 'v2',
          child2: 'nft',
          child3: 'approve',
          child4: 'CHANGE_DIVIDEND_OPTION',
          child5: vm.summaryDetails.transactionId
        }, null).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
      }

      panAdharLinkingService.checkPanAdharStatus('',vm.summaryDetails.folioNumber,vm.summaryDetails.arnCode).then(successHandler).catch(errorHandler);

    }

    function cardTypeChanged() {
      switch (vm.selectedCardType) {
        case 'visa':
          cardBankLists();
          break;
        case 'maestro':
          cardBankLists();
          break;
      }
    }

    function cardBankLists() {
      var success = function (res) {
        if (res && res.data && res.data.bankList) {
          vm.cardBankList = res.data.bankList;
        }
        else {
          MessageService.error(res.message);
        }
      };

      var error = function (err) {
        UtilService.errorHandler(err);
      };

      BillJunctionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'bank',
        child1: 'list',
        child2: vm.selectedCardType,
        child3: 'debit',
        uniqueLink: $stateParams.uniqueLink
      }).$promise.then(success, error);
    }

    function changedCardBank() {

    }

    function viewLater() {
      var success = function () {
          vm.isActionPerformed = true;
          ModalService.genericSuccessModal({
            text: vm.appConstants.VIEW_LATER_SUCCESS
          });
        },
        error = function (msg) {
          $log.info(msg)
        };
      var msg = {};
      msg.Text = 'You can view this transaction request later to process it further';
      ModalService.confirmCancelModal(msg, success, error);
    }

    vm.doc = {};
    // vm.isDocSubmitted = false;
    /*vm.submitDoc = function () {

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isDocSubmitted = true;
            MessageService.success(AppConstants.ToastrMessage.VALIDATE_DATA.DOC_UPLOADED);
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };


      LoaderService.showLoader();
      var fd = new FormData();
      fd.append('chequeLeaf', vm.doc.chequeLeaf);
      fd.append('investorUUID', vm.summaryDetails ? vm.summaryDetails.folioId : '');
      if (vm.summaryDetails && vm.summaryDetails.minor) {
        fd.append('guardianProof', vm.doc.guardianProof);
        fd.append('minorProof', vm.doc.minorProof);
      }
      FileUploadGeneric.post({
        controller: 'investor',
        child1: 'document',
        child2: 'upload'
      }, fd).$promise.then(success, error);
    };*/

    vm.validImage = {};
    vm.mimeType = ['image/jpeg', 'image/png'];
    vm.validLength = [];
    vm.verifyDoc = function (file, index) {

      switch (index.toString()) {
        case "1" :
          vm.doc.chequeLeaf = file;
          checkValid(file, 1);
          break;
        case "2" :
          vm.doc.minorProof = file;
          checkValid(file, 2);
          break;
        case "3" :
          vm.doc.guardianProof = file;
          checkValid(file, 3);
          break;
      }
      $scope.$apply();

      function checkValid(file, serial) {
        vm.validLength.indexOf(serial) > -1 && vm.validLength.splice(vm.validLength.indexOf(serial), 1);
        if (file.size >= 1500000) {//1500000
          vm.validImage['Img' + serial] = "File size should not be more than 1.5 MB.";
        }
        else if (vm.mimeType.indexOf(file.type) == -1) {
          vm.validImage['Img' + serial] = "Invalide file type.";
        } else {
          vm.validImage['Img' + serial] = '';
          vm.validLength.push(serial);
        }
      }
    }

    function updateDates() {
      vm.startMinDateBiller = vm.summaryDetails.nextInstallmentDate;
      localStorage.setItem("mindate", vm.startMinDateBiller);
      vm.startMaxDate = vm.summaryDetails.lastInstallmentDate;
      localStorage.setItem("date", vm.startMaxDate);
    }


    vm.changeInstallment = function () {
      if(localStorage.getItem("selDate")){
        changeStartDate(localStorage.getItem("selDate"))
      }
    };

    function setActiveTab(index) {
      vm.activeTab = index;
    }


    function changeStartDate(date) {
      vm.endDate = date;
      initialiseInstallment();
      updateDates();
      updateEndDates();
    }

    function updateEndDates() {
      var defaultEndDate = null;
      defaultEndDate = $window.moment(localStorage.getItem("date"), "DD-MMM-YYYY");
      var endDate = null;
      var enabledEndDates = [];
      var freq = 0;
      var i = 0;
      endDate = $window.moment(localStorage.getItem("mindate"), "DD-MMM-YYYY");

      freq = UtilService.getNumberOfMonths(endDate, defaultEndDate);
      if(vm.summaryDetails.frequency === 'Monthly') {
        for (i = 0; i <= freq; i++) {
          enabledEndDates.push(endDate.clone().add(i, 'months'));
        }
      }
      else {
        for (i = 0; i <= freq; i+=3) {
          enabledEndDates.push(endDate.clone().add(i, 'months'));
        }}
      vm.maxEndDate = defaultEndDate;
      vm.enabledEndDates = enabledEndDates;
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      updateInstallment();
      vm.isSipPauseStartDate = true;
    }

    function updateInstallment() {
      localStorage.setItem("selDate", $window.moment(vm.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"));
      var selectedDate = localStorage.getItem("selDate");
      switch (vm.noOfInstallment ? vm.noOfInstallment : vm.summaryDetails.installmentsPaused) {
        case "1":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(1,'months');
          vm.noInstallment = false;
          break;
        case "2":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(2,'months');
          vm.noInstallment = false;
          break;
        case "3":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(3,'months');
          vm.noInstallment = false;
          break;
        default : vm.noInstallment = true;break;
      }
      if(!vm.noInstallment)
        vm.SipPauseEndDate = $window.moment(vm.SipPauseEndDate, "DD-MMM-YYYY").subtract(1,'days');
      if(vm.summaryDetails.frequency != 'Monthly'){
        vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(3,'months').subtract(1,'days');
        vm.noInstallment = false;
      }
      vm.SipActionHappened = ((vm.endDate === "null" || vm.endDate === null) ? false : true);
    }
    function changeEndDate(){}
    function browserForceUpdate() {
      if (deviceDetector.browser == 'chrome' && parseInt(deviceDetector.browser_version, 10) < 60) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'firefox' && parseInt(deviceDetector.browser_version, 10) < 50) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'ms-edge' && parseInt(deviceDetector.browser_version, 10) < 16) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'ie') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }
      return false;
    }

    function termsAndContitionsSip() {
      ModalService.termsAndConditionSip({});
    }

    /*
    * if upi virtual address is verified and user types virtual address again . enabling verify button
    */
    vm.virtualAddressChange = function() {
      if(vm.isUPIVerified) {
        vm.isUPIVerified = false;
      }
      if(vm.summaryType !== 'PURCHASE' && vm.virtualAddress){
        vm.virtualAddress = vm.virtualAddress.toLowerCase();
      }
      if(vm.virtualAddress && vm.selectedPaymentOptionForFI == 'UPI'){
        vm.virtualAddressForFi = vm.virtualAddress;
      }
      vm.errorMessage = '';
    }

    vm.resetUpiForm = function() {
        vm.verifyUPIResp = {};
        vm.isUPIVerified = false;
    }

    function paymentOptionChangedForFi() {
      vm.startDateValidationForFi = false;
      vm.ischecked = false;
      vm.fiOtmBankForm && vm.fiOtmBankForm.$setPristine();
      vm.termaAndConditions = false;
      vm.purchaseBankModal = {};
      vm.virtualAddressForFi = null;
      switch (vm.selectedPaymentOptionForFI) {
        case 'OTM':
          vm.ecsReadOnly = true;
          vm.showBankFiels = true;
          vm.fiOtmBankModal={}
          vm.purchaseBankModal = {};
          vm.fiOtmBankData=null;
          getOTMBankList();
          break;
        case 'WEB':
          vm.showBankFiels = false;
          getBillDeskBilljenBankList();
          break;
      }
    }

    function changedFiOtmBank() {
      vm.fiOtmBankLimit = vm.fiOtmBankData && vm.fiOtmBankData.maxAmount;
      if(vm.summaryDetails.firstInstallmentDetails){
        vm.fiOtmLimitValidation = vm.summaryDetails.firstInstallmentDetails.amount > vm.fiOtmBankLimit;
      } else if (vm.summaryDetails.bulkTransactionFlag && vm.summaryDetails.sipWithFirstInstallment){
        vm.fiOtmLimitValidation = vm.summaryDetails.amount > vm.fiOtmBankLimit;
      }
      vm.fiOtmExpDate = vm.fiOtmBankData && moment(vm.fiOtmBankData.omExpiryDate, 'DD-MMM-YYYY');
      vm.fiOtmStartDate = vm.fiOtmBankData && moment(vm.fiOtmBankData.omStartDate, 'DD-MMM-YYYY')

      if( vm.summaryDetails && vm.summaryDetails.minorFolioFlag && !vm.summaryDetails.cgfFlag && !vm.fiOtmBankData.minorBankFlag)
      {
        ModalService.minorBankModal({});
        vm.fiOtmBankData=null;
        vm.fiOtmBankModal = {};
      }
      else
      {
        if ((vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') &&
          vm.summaryDetails.sipEndDate && vm.fiOtmExpDate) {
          vm.fiEndDateValidation = vm.summaryDetails.sipEndDate && (moment(vm.summaryDetails.sipEndDate,"DD-MMM-YYYY")>moment(vm.fiOtmExpDate,"DD-MMM-YYYY"));
        }
        if(vm.summaryType == 'SIP' && vm.summaryDetails.sipDate && vm.fiOtmStartDate){
          vm.startDateValidationForFi = vm.fiOtmBankData && vm.fiOtmBankData.currentDate && (moment(vm.fiOtmBankData.currentDate,"DD-MMM-YYYY") < moment(vm.fiOtmStartDate,"DD-MMM-YYYY"));
        }
        vm.ecsReadOnly = false;
        if (vm.fiOtmBankData && vm.selectedPaymentOptionForFI == 'OTM') {
          if (vm.summaryType == 'SIP' || vm.summaryType == 'FLEXSIP') {
            vm.fiOtmBankModal.bankAcNo = vm.fiOtmBankData.bankAcNo;
            vm.fiOtmBankModal.verifyBankAcNo = vm.fiOtmBankData.bankAcNo;
            vm.fiOtmBankModal.bankName = vm.fiOtmBankData.bankName;
            vm.fiOtmBankModal.bankBranch = vm.fiOtmBankData.bankBranch;
            vm.fiOtmBankModal.ifscCode = vm.fiOtmBankData.ifscCode;
            vm.fiOtmBankModal.bankAcType = vm.fiOtmBankData.bankAcType;
            vm.fiOtmBankModal.bankCity = vm.fiOtmBankData.bankCity;
            vm.fiOtmBankModal.omUmrn = vm.fiOtmBankData.omUmrn;
            vm.fiOtmBankModal.omExpiryDate = vm.fiOtmBankData.omExpiryDate;
            vm.fiOtmBankModal.maxAmount = parseInt(vm.fiOtmBankData.maxAmount);
            vm.fiOtmBankModal.payoutId = vm.fiOtmBankData.payoutId;
            vm.fiOtmBankModal.camsMandateIdNo = vm.fiOtmBankData.camsMandateIdNo;
            vm.fiOtmBankModal.omStartDate = vm.fiOtmBankData.omStartDate ? vm.fiOtmBankData.omStartDate : null;
            if((vm.fiOtmBankData.otmFrequency !== 'AWP') && (vm.summaryDetails.sipFrequency === 'Daily')){
              MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
            }
          }
          $timeout(function () {
            vm.ecsReadOnly = true;
          }, 100);
        }
        else {
          vm.fiOtmBankModal = {};
        }
      }
    }

    function getWebFiPayload() {
      if(vm.summaryDetails.bulkTransactionFlag && vm.summaryDetails.sipWithFirstInstallment){
        return {
          "amount": vm.summaryDetails.amount,
          "paymentMode": "WEB",
          "bankCode": vm.fiBankdata.bankCode,
          "webMode": vm.fiBankdata.gateWayVendor,
          "bankName": vm.fiBankdata.bankName,
          "accNumber": vm.fiBankdata.accountNumber,
          "ifscCode": vm.fiBankdata.ifscCode?vm.fiBankdata.ifscCode:vm.fibankData.ifscCode,
          "accType":vm.fiBankdata.bankAcType?vm.fiBankdata.bankAcType:vm.fibankData.accType,
          "sourceAccountNo": vm.fiBankdata.accountNumber
        };
      } else {
        return {
          "amount": vm.summaryDetails.firstInstallmentDetails?vm.summaryDetails.firstInstallmentDetails.amount:vm.summaryDetails.amount,
          "paymentMode": "WEB",
          "bankCode": vm.fiBankdata.bankCode,
          "webMode": vm.fiBankdata.gateWayVendor,
          "bankName": vm.fiBankdata.bankName,
          "accNumber": vm.fiBankdata.accountNumber,
          "ifscCode": vm.fiBankdata.ifscCode?vm.fiBankdata.ifscCode:vm.fibankData.ifscCode,
          "accType":vm.fiBankdata.bankAcType?vm.fiBankdata.bankAcType:vm.fibankData.accType,
          "sourceAccountNo": vm.fiBankdata.accountNumber
        };
      }

    }

    function getOtmFiPayload() {
      if(vm.summaryDetails.bulkTransactionFlag && vm.summaryDetails.sipWithFirstInstallment){
        return {
          "accNumber": vm.fiOtmBankData.bankAcNo,
          "ifscCode": vm.fiOtmBankData.ifscCode?vm.fiOtmBankData.ifscCode:vm.fiOtmBankModal.ifscCode,
          "bankName": vm.fiOtmBankData.bankName,
          "omUmrn": vm.fiOtmBankData.omUmrn,
          "payoutId": vm.fiOtmBankData.payoutId,
          "amount": vm.summaryDetails.amount,
          "paymentMode": 'OTM',
          "accType":vm.fiOtmBankData.bankAcType?vm.fiOtmBankData.bankAcType:vm.fibankData.accType,
          "sourceAccountno": vm.fiOtmBankData.accountNumber
        };
      } else{
        return {
          "accNumber": vm.fiOtmBankData.bankAcNo,
          "ifscCode": vm.fiOtmBankData.ifscCode?vm.fiOtmBankData.ifscCode:vm.fiOtmBankModal.ifscCode,
          "bankName": vm.fiOtmBankData.bankName,
          "omUmrn": vm.fiOtmBankData.omUmrn,
          "payoutId": vm.fiOtmBankData.payoutId,
          "amount": vm.summaryDetails.firstInstallmentDetails? vm.summaryDetails.firstInstallmentDetails.amount:vm.summaryDetails.amount,
          "paymentMode": 'OTM',
          "accType":vm.fiOtmBankData.bankAcType?vm.fiOtmBankData.bankAcType:vm.fibankData.accType,
          "sourceAccountno": vm.fiOtmBankData.accountNumber
        };
      }
    }

    function getUPIFiPayload() {
      if(vm.summaryDetails.sipWithFirstInstallment){
        return {
          "amount": vm.summaryDetails.amount,
          "paymentMode": "UAP",
          "bankCode": vm.fiBankdata.bankCode,
          "bankName": vm.fiBankdata.bankName,
          "accNumber": vm.fiBankdata.accountNumber,
          "ifscCode": vm.fiBankdata.ifscCode?vm.fiBankdata.ifscCode:vm.fibankData.ifscCode,
          "accType":vm.fiBankdata.bankAcType?vm.fiBankdata.bankAcType:vm.fibankData.accType,
          "sourceAccountNo": vm.fiBankdata.accountNumber
        };
      }
    }

    function redirectToPaymentGateway(gatewayResponse) {
      if (gatewayResponse) {
        if (vm.selectedPaymentOptionForFI === 'WEB' && vm.fiBankdata.gateWayVendor == 'BILLDESK') {
          vm.billdeskPayload.msg = gatewayResponse.emandateMsg;
          $timeout(function () {
            angular.element('#billdeskForm').submit();
          }, 100);
        } else if (vm.selectedPaymentOptionForFI === 'WEB' && vm.fiBankdata.gateWayVendor == 'BILLJUNCTION') {
          $window.open(gatewayResponse.emandateMsg, '_self');
        } else if (vm.selectedPaymentOptionForFI === 'OTM') {
          $window.open(gatewayResponse.redirectUrl, '_self');
        } else if(vm.selectedPaymentOptionForFI === 'WEB' && vm.fiBankdata.gateWayVendor == "RAZORPAY") {
          if(vm.summaryDetails.summaryType == "SIP") {
            gatewayResponse.trnxActionMsg = gatewayResponse.emandateMsg;
          }
          PaymentService.openRazorPay(gatewayResponse);
        }
      }
    }

    function changeRtgsPayment() {
      if(vm.purchaseBankModal && vm.purchaseBankModal.bankName){
        vm.purchaseBankModal.bankName = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.bankBranch){
        vm.purchaseBankModal.bankBranch = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.bankAcNo || (vm.purchaseBankModal.bankAcNo == undefined)){
        vm.purchaseBankModal.bankAcNo = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.ifscCode || (vm.purchaseBankModal.ifscCode == undefined)){
        vm.purchaseBankModal.ifscCode = null
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.purchasebankAcType){
        vm.purchaseBankModal.purchasebankAcType = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.utr){
        vm.purchaseBankModal.utr = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.verifyUtr || (vm.purchaseBankModal.verifyUtr == undefined)){
        vm.purchaseBankModal.verifyUtr = null;
      }
      if(vm.purchaseBankModal && vm.purchaseBankModal.chequeLeaf){
        vm.purchaseBankModal.chequeLeaf = null;
      }
      // vm.purchaseBankModal = {};
      vm.bankChequeLeaf = "No File Chosen";
      vm.bankchequeLeafUrl = null;
      vm.bankdata = null;
      vm.fileType = '';
      vm.purchaseBankForm.$setPristine();
      if(vm.isNewPayment){
        vm.ecsReadOnly = true;
        vm.bankdata = null;
      }else {
        vm.ecsReadOnly = false;
        vm.isAccFieldFilled = false;
      }
      if(vm.selectedPaymentOption == 'RTGS' && vm.appConstants.NRI_STATUS_CODES.includes(vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus)){

        vm.purchaseBankModal.purchasebankAcType = vm.bankTypeList[0];
      }
    }

    function getAccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if(vm.selectedPaymentOption == 'RTGS' && vm.appConstants.NRI_STATUS_CODES.includes(vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus)){
              vm.purchaseBankModal.purchasebankAcType = vm.bankTypeList[0];
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
      InvestorsService.get({
        child1: 'bank',
        child2: 'account-type',
        child3: 'list',
        child4: vm.summaryDetails.folioDetails.soleApplicantDetails.taxStatus
      }).$promise.then(success, error);
    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.purchaseBankModal.chequeLeaf)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.purchaseBankModal.chequeLeaf});
    }

    function bankUploadChequeLeafFile(file) {
      if (vm.fileMimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if(file){
        if (file.size <= 3145728) {
          vm.fileName = file.name;
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                vm.purchaseBankModal.chequeLeaf = vm.bankchequeLeafUrl;
                vm.fileType = file.type.split('/')[1];
                breakFileUrl(vm.bankchequeLeafUrl);
              }
              else {
                vm.fileType = '';
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
            };
          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            ChequeLeafFileUploadService.post({
              child0: 'investor',
              child1: 'folio',
              child2: 'add',
              child3: 'document',
              child4: 'upload',
              child5: vm.summaryDetails.summaryType,
              child6: 'CHEQUE_LEAF',
              child7: vm.summaryDetails.distributorDetails.arnNo
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 3 MB.")
          if(vm.purchaseBankModal && vm.purchaseBankModal.chequeLeaf){
            vm.purchaseBankModal.chequeLeaf = null;
            vm.bankchequeLeafUrl = null;
            vm.fileType = null;
            vm.chooseAFile = true;
          }
        }
      }
    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.chooseAFile = false;
      vm.bankchequeLeafUrl = url;
      return;
    }

    function changeBank() {
      var data = angular.copy(vm.bankdata);
      vm.ecsBankModal = data;
      if(!vm.bankdata.ifscCode) {
        vm.ecsReadOnly = false;
      } else {
        vm.ecsReadOnly = true;
      }
    }

    function downloadPdfFile(url, fileType) {
      var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.data) {
        var data = new Blob([resp.data], { type: 'application/'+fileType });
        FileSaver.saveAs(data, vm.fileName.replaceAll("." + fileType, "") + '.' +fileType);
      } else {
          MessageService.error('No Data Available');
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    };

    function checkTopDetailsExistForCancelledSip() {
      if(vm.summaryDetails.systematicCancelSummary && vm.summaryDetails.systematicCancelSummary.topupDetails){
        if(Object.keys(vm.summaryDetails.systematicCancelSummary.topupDetails).length > 0){
          vm.cancelledTopupDetailsWerePresent = true;
        }else {
          vm.cancelledTopupDetailsWerePresent = false;
        }
      }
    }

    function otmStartValidationPurchase() { // function to validate investment start date  with otm expiry
      vm.otmStrDate = vm.otmBankData && moment(vm.otmBankData.omStartDate, 'DD-MMM-YYYY');
      if(vm.otmResp){
        vm.otmCurDate = moment(vm.otmResp.currentDate, 'DD-MMM-YYYY');
      }
      if (vm.summaryType == 'PURCHASE' &&
        vm.otmCurDate && angular.isDefined(vm.otmCurDate) && vm.otmStrDate) {
        vm.startDateValidationPurchase =  vm.otmCurDate < vm.otmStrDate;
      }
    };
    vm.targetSchemeChanged = function(data){
      vm.targetScheme = {};
      if(!data){
        return;
      }
      vm.targetScheme.targetSchemecode = data.schemeCode;
      vm.targetScheme.targetSchemeName = data.scheme;
      vm.targetScheme.targetSchemeType = data.schemeType;
    }
    vm.approveTransactionForChangeOption = function(){
    if (!vm.summaryType || !vm.uniqueLink) {
      return;
    }

    var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        if (resp.data.trnxActionFlag) {
          MessageService.success(resp.data.trnxActionMsg);
          $state.go('transactionsuccess');
        } else {
          MessageService.error(resp.data.trnxActionMsg);
        }
      } else {
        MessageService.error(resp.message);
      }
    },
    error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
    };
    if(vm.summaryDetails.summaryType == "changeOption"){
      var payload = {
        id:vm.summaryDetails.transactionId,
        folioNumber: vm.summaryDetails.folioNumber,
        schemeCode: vm.summaryDetails.sourceSchemeCode,
        sipStpId: vm.summaryDetails.sipRegistrationNumber,
        systematicTransactionType: "changeOption",
        oldOption: vm.summaryDetails.oldDreamsipOption,
        newOption: vm.summaryDetails.newDreamsipOption,
        targetScheme: vm.summaryDetails.targetSchemeCode,
        oldTargetScheme: vm.summaryDetails.oldTargetScheme,
        newTargetScheme: vm.summaryDetails.newTargetScheme,
        brokerCode:vm.summaryDetails.arnCode,
        applicationSource: "MF_ONLINE",
      }
    }
    if(vm.summaryDetails.summaryType == "changeTargetScheme"){
      var payload = {
        id: vm.summaryDetails.transactionId,
        folioNumber : vm.summaryDetails.folioNumber,
        schemeCode: vm.summaryDetails.sourceSchemeCode,
        sipStpId:  vm.summaryDetails.sipRegistrationNumber,
        systematicTransactionType: "changeTargetScheme",
        oldOption : 'B',
        newOption: 'B',
        targetScheme:"",
        oldTargetScheme: vm.summaryDetails.targetSchemeCode,
        newTargetScheme: vm.summaryDetails.newTargetScheme,
        brokerCode:vm.summaryDetails.arnCode,
        applicationSource: "MF_ONLINE",
      }
    }
    var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
    version = version ? version : HDFC_API.VERSION;
    LoaderService.showLoader();
    if(vm.summaryDetails.summaryType == "changeOption"){
      InvestorServiceDynamicData.post({child1: 'dreamSip',child2: 'transaction',child3: 'otp', child4:'changeOptionApprove',child5:vm.uniqueLink}, payload).$promise.then(success, error);
    }
    if(vm.summaryDetails.summaryType == "changeTargetScheme"){
      InvestorServiceDynamicData.post({child1: 'dreamSip',child2: 'transaction',child3: 'otp', child4:'changeTargetSchemeApprove',child5:vm.uniqueLink}, payload).$promise.then(success, error);
    }
  }

  vm.stoppProp = function(){
    var v = $(".tagetScheme")
    v.on("click",function(event){
      event.stopPropagation();
    })
  }
  angular.element(document).ready(function(){
    $(document).on("click",function(){
      $(".hideDropDown").hide();
    })
  });


    function mobileEmailBelongsTo() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.emaillList = resp.data.emailList;
            vm.mobileList=resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'}).$promise.then(success, error);
    }

    function setEmandatePaymentOption() {
      if (!vm.eMandateBankList) {
        vm.paymentOptionsSip = [
          {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
          {'key': 'EC', 'value': 'Standing Instruction/Biller'},
        ];
      } else {
        var emandateEndDate = $window.moment(vm.summaryDetails.sipDate, "DD-MMM-YYYY").add(vm.maxMandateDurationYears, 'years');
        if ($window.moment(vm.summaryDetails.sipEndDate, "DD-MMM-YYYY").isBefore(emandateEndDate)) {
          vm.paymentOptionsSip = [
            {'key': 'OTM', 'value': 'OTM(One Time Mandate)'},
            {'key': 'HEM', 'value': 'Register E-mandate (eOTM)'},
            {'key': 'EC', 'value': 'Standing Instruction/Biller'}
          ];
        } else {
          vm.paymentOptionsSip.map(function (el,index) {
            if (el.key === 'HEM') {
              vm.paymentOptionsSip.splice(index,1);
            }
          })
        }
      }
    }
    function handleEcartPurchaseResponse(data) {
      var transactionId = data && data.transactionId ? data.transactionId : null;
      data = data && data.data ? data.data : data;
      vm.billdeskMsg = data;
      if (!data) {
        MessageService.error();
        return;
      }
      LoaderService.showLoader();
      if (vm.selectedPaymentOption === 'HEM') {
        handleEmandateRedirection();
      } else if (vm.selectedPaymentOption === 'OTM' || vm.selectedPaymentOption === 'EC') {
        handleOtherRedirection();
      } else if(vm.isFromEcart && vm.purchasePayload.gatewayVendor == 'BILLDESK') {
        handleBillDeskRedirection();
      } else if (vm.isFromEcart && vm.purchasePayload.gatewayVendor == 'BILLJUNCTION') {
        handleBillJunctionRedirection();
      } else if (vm.isFromEcart && vm.purchasePayload.gatewayVendor == 'RAZORPAY') {
        data.trnxActionMsg = data.redirectUrl;
        PaymentService.openRazorPay(data);
      }
    }

    function handleEmandateRedirection() {
      $window.location.href = $scope.billdeskUrl + vm.billdeskMsg.redirectUrl;
    }

    function handleOtherRedirection() {
      $window.location.href = vm.billdeskMsg.redirectUrl;
    }

    function handleBillDeskRedirection() {
      if (vm.billdeskMsg.cartId) {
        $window.open(vm.billdeskMsg.redirectUrl, '_self');
      } else {
        vm.billdeskPayload.msg = vm.billdeskMsg.redirectUrl;
        $timeout(function () {
          angular.element('#billdeskForm').submit();
        },100);
      }
    }
    function handleBillJunctionRedirection() {
      $window.open(vm.billdeskMsg.redirectUrl, '_self');
    }

    function findMinDate(items){
      var min_dt = items[0].sipDate,
        min_dtObj = new Date(items[0].sipDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.sipDate ) < min_dtObj) {
          min_dt = dt.sipDate;
          min_dtObj = new Date(dt.sipDate);
        }
      });
      return min_dt;
    }

    function findMaxDate(items) {
      var max_dt = items[0].toDate,
        max_dtObj = new Date(items[0].toDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.toDate ) > max_dtObj) {
          max_dt = dt.toDate;
          max_dtObj = new Date(dt.toDate);
        }
      });
      return max_dt;
    }

    function updateEmandateEndDate() {

      if (!vm.summaryDetails.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.summaryDetails.endDateEmandate = '';
      if(vm.summaryDetails.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.summaryDetails.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.summaryDetails.emandateDate, "DD-MMM-YYYY").add(vm.maxMandateDurationYears, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.summaryDetails.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
      changeEndDateEmandate(vm.summaryDetails.endDateEmandate);
      vm.eMandateStartDate = angular.copy(moment(vm.summaryDetails.emandateDate).format('DD-MMM-YYYY'));
      vm.eMandateEndDate = angular.copy(moment(vm.summaryDetails.endDateEmandate).format('DD-MMM-YYYY'));
    }


    function checkAmountValidationEmandate() {
      if (vm.summaryDetails.emandateAmount) {
        vm.amountLess = vm.summaryDetails.emandateAmount < vm.emandateMinAmountLimit ? true : false;
        vm.amountMore = vm.summaryDetails.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
        vm.isLessThanSipAmount =  vm.summaryDetails.emandateAmount < vm.summaryDetails.amount ? true : false;
        $window.NumToWord(vm.summaryDetails.emandateAmount, 'amountInwordsEmandate',vm.emandateWord);
        vm.amount = vm.summaryDetails.emandateAmount;
      } else {
        vm.emandateWord = {};
      }
    }

    function changeEndDateEmandate(date) {
      vm.summaryDetails.endDateEmandate = date ? date : null;
      vm.eMandateEndDate =  date ?  angular.copy(moment(date,"DD-MMM-YYYY").format("DD-MMM-YYYY")) : null;
      if (vm.summaryDetails.sipEndDate) {
        vm.sipDateLessEmandate = $window.moment(vm.summaryDetails.sipEndDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.summaryDetails.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
      }
    }

    function changeDateEmandate(date) {
      vm.summaryDetails.emandateDate = date ? date : null;
    }
    function tpvModalOpen(){
      ModalService.tpvModal({});
    }

    function changedUPIBank(){
      if(vm.summaryType ==='SIP' && vm.selectedPaymentOptionForFI) {
        if (vm.selectedPaymentOption == 'UPI') {
          vm.fiBankdata = vm.bankdata;
        }
      }
      if (vm.summaryType == 'SIP' || vm.summaryType == 'SIP_TOPUP') {
        vm.ecsBankModal.bankAcNo = vm.bankdata.bankAcNo;
        vm.ecsBankModal.verifyBankAcNo = vm.bankdata.bankAcNo;
        vm.ecsBankModal.bankName = vm.bankdata.bankName;
        vm.ecsBankModal.bankBranch = vm.bankdata.bankBranch;
        vm.ecsBankModal.ifscCode = vm.bankdata.ifscCode;
        vm.ecsBankModal.bankAcType = vm.bankdata.bankAcType;
        vm.ecsBankModal.bankCity = vm.bankdata.bankCity;
        vm.ecsBankModal.camsMandateIdNo = vm.bankdata.camsMandateIdNo;
        vm.ecsBankModal.netBankingUrl = vm.bankdata.netBankingUrl;
      }
    }



    function showNudgeReasons() {
      var success = function(resp) {
          if(resp.status && resp.data) {

            if (angular.isDefined(resp.data.popUpDescriptionList.SIP_CANCELLATION_NUDGE_REASONS)) {
              var nudgeData = angular.copy(vm.summaryDetails);
              nudgeData.nudgePopupData = resp.data.popUpDescriptionList.SIP_CANCELLATION_NUDGE_REASONS;
              nudgeData.reasonsList = nudgeData.nudgePopupData.reasonsList;

              var payload = {
                "reasons": vm.summaryDetails.reasons,
                "nudgeRequestId": vm.summaryDetails.nudgeRequestId
              }

              if (payload.reasons === "Others") {
                payload.nudgeOtherReason = vm.summaryDetails.nudgeOtherReason;
              }

              switch (vm.summaryDetails.transactionType) {
                case 'SIP':
                  vm.tncType = 'SIP'
                  break
                case 'DREAMSIP':
                  vm.tncType = 'DREAM SIP'
                  break
                case 'FLEXSIP':
                  vm.tncType = 'Flex SIP'
                  break
              }

              var text = 'Please let us know the reason for Cancelling ' + vm.tncType  + ' :' ;

              var success = function(payload) {
                approveTransactionForCANCELLATION(payload);
              } , error = function() {}

              ModalService.showNudgeReasons({Text: text, payload:payload, transactionType: vm.summaryDetails.transactionType, buttonProceed:true, nudgeData:nudgeData , approveRequest : true}, success ,error);
            } else {
              approveTransactionForCANCELLATION();
            }
          }
          else {
            MessageService.error("Something went wrong");
          }

        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      if (vm.summaryDetails.transactionType === 'SIP' || vm.summaryDetails.transactionType === 'DREAMSIP' || vm.summaryDetails.transactionType === 'FLEXSIP') {
        InvestorServiceDynamicData.get({
          child1: 'nudge',
          child2: 'sip',
          child3: 'popup'
        }).$promise.then(success, error);
      } else {
        approveTransactionForCANCELLATION();
      }
    }


  }
})();


/**
 * Created by rajnishkumar on 31/05/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionSwingStpController', initiateTransactionSwingStpController);

  /** @ngInject */
  function initiateTransactionSwingStpController($state, $stateParams, $scope, $timeout, InvestorsService, TransactionService, UtilService, AuthService, MessageService, ModalService, SchemeService, AppConstants, LoaderService, moment, HDFC_API, AgentSocketService, InvestorsCommonService){

    var vm = this;
    var identifier = AuthService.getToken();
    vm.fill_end_date = '';
    vm.FlexStpForm = {};
    vm.formData = {};
    vm.formData.euinObj = null;
    vm.folioListData = [];
    vm.transactionConstants = AppConstants.TRANSACTION;
    var dividendConstants = AppConstants.DIVIDEND_OPTIONS;
    vm.daysList = null;
    vm.formData.dividentOption = '';
    vm.formData.stpType = 'Q'; //vm.transactionConstants.FIXED_AMOUNT;
    vm.frequencyList = AppConstants.STP_FREQ_LIST_FOR_FIXED;
    vm.allSchemesList = null;
    vm.isSelectedInScheme = true;
    vm.investorUUID = $stateParams.uuid;
    vm.startDate = null;
    vm.endDate = null;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isSubmitted = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.unitsDetails = null;
    vm.isInScheme = false;
    vm.validations = null;
    vm.validationsData = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isResetting = false;
    vm.investorInfo = null;
    vm.viewMode = 'months';
    vm.selectedFrequency = null;
    vm.isShowDefault = 'false';
    vm.stpDevidendOptions = [vm.transactionConstants.REINVEST, vm.transactionConstants.PAYOUT];
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.hasFolioEmailId = true;
    vm.showOrMessage=false;
    var now=new Date();
    vm.minStartDate = now.setMonth(now.getMonth()-1);
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.getSchemesList = getSchemesList;

    vm.fields= {
      showDateOfTransfer: false,
      showDayOfTransfer : false,
      showStartEndDate : false,
      showInstallment : false
    };

    vm.init=init;
    vm.changeFolio=changeFolio;
    vm.fetchUnitDetails=fetchUnitDetails;
    vm.inSchemeChanged=inSchemeChanged;
    vm.changeDay=changeDay;
    vm.changeEndDate=changeEndDate;
    vm.changeStartDate=changeStartDate;
    vm.changeInstallments=changeInstallments;
    vm.checkValidations=checkValidations;
    vm.handleEnter=handleEnter;
    vm.submit=submit;
    vm.amountChanged = amountChanged;
    vm.blured = blured;


    function init(){
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      if ($stateParams.schemeCode) {
        vm.formData.schemeCode = $stateParams.schemeCode;
        fetchUnitDetails();
      } else if ($stateParams.transactionId) {
        getTransactionDetails();
      }
      vm.formData.startDate=null;
      vm.formData.endDate=null;
      getEuinCodes();
      getInvestorInfo();
      folioList();
    }

    function handleEnter(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        submit();
        e.preventDefault();
      }
      return false;
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.hasWarning){
              var successModal= function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg:resp.data.warningMessage}, successModal, errorModal)
            }
            else{
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType:'STPSWING',
        folioNumber:vm.formData.folioNumber,
        schemeCode:vm.formData.schemeCode,
        targetSchemeCode:vm.selectedInSchemeCode,
        amount: vm.formData.amount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);

    };

    function submit() {
      vm.isSubmitted = true;
      if (!identifier || !identifier.arnCode) {
        MessageService.error('Invalid arnCode');
        return;
      }

      if (!vm.validationsData || !vm.validationsData.investmentOption) {
        MessageService.error("Invalid Investment option is selected.");
        vm.isSubmitted = false;
        return;
      }

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay.value,
        "amount": vm.formData.amount,
        "brokerCode": identifier.arnCode,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency.key,
        "startDate": vm.startDate.clone().format('DD-MMM-YYYY'),
        "endDate": vm.endDate && vm.endDate.clone().format('DD-MMM-YYYY'),
        "formType": "STPSWING",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment||0,
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };

      var successSTPModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'SWINGSTP',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };


      var _scheme = vm.schemes && vm.schemes.find(function (i) {
          return i.schemeCode === vm.formData.schemeCode;
        }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        mobileNumber : vm.mobileNumber ? vm.mobileNumber : '',
        emailId : vm.emailId ? vm.emailId : '',
        sourceSchemeName: _scheme.schemeName,
        targetSchemeName: vm.selectedInScheme,
        stpDay: vm.formData.stpDay.name,
        frequency: vm.selectedFrequency.value,
        installments:vm.formData.installment||0,
        startDate: vm.startDate.clone().format('DD-MMM-YYYY'),
        endDate: vm.endDate && vm.endDate.clone().format('DD-MMM-YYYY'),
        investmentOption: vm.validationsData.investmentOption,
        dividendOption: (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        folioNumber: vm.formData.folioNumber,
        amount: vm.formData.amount,
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag
      };
      ModalService.transactionReviewModal({
        payload: payload, controller: 'swingstp', additionalData: additionalData
      }, success, error);
    }

    function getEuinCodes() {
    var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        vm.euinList = resp.data.euinList;
      } else {
        vm.euinList = null;
      }
    }, error = function () {
      LoaderService.hideLoader();
      vm.euinList = null;
    };
    LoaderService.showLoader();
    TransactionService.get({VERSION:HDFC_API.VERSION,controller: 'getEuin'}).$promise.then(success, error);
  }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinList = [
              {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              }
            ];
            vm.formData.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.schemeCode = resp.data.sourceSchemeCode;
            fetchUnitDetails();
            vm.selectedInSchemeCode = resp.data.targetSchemeCode;
            vm.selectedInScheme = resp.data.targetSchemeName;
            fetchSchemeValidations(function (err) {
              if (!err) {
                vm.formData.dividentOption = resp.data.dividendOption;
                vm.formData.stpType = resp.data.stpType;
                vm.frequencyList = (vm.formData.stpType == 'F') ? AppConstants.STP_FREQ_LIST_FOR_FIXED : AppConstants.STP_FREQ_LIST_FOR_CAPITAL;
                vm.selectedFrequency = vm.frequencyList.find(function (item) {
                  return item.key === resp.data.frequency;
                });
                changeFrequency();
                vm.isShowDefault = 'true';
                vm.isSelectedInScheme = true;
                vm.formData.stpDay = vm.daysList.find(function (item) {
                  return item.value === +resp.data.stpDay;
                });
                vm.startDate = moment(resp.data.startDate);
                vm.endDate = moment(resp.data.endDate);
                changeDay();
                vm.formData.amount = resp.data.amount;
                checkValidations();
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function getInvestorInfo() {
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          fetchAllSchemeType();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function folioList() {
      var payload = {"investorUUID": vm.investorUUID},
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.folioListData=resp.data.folioList || [];
            if ($stateParams.folioNumber) {
              vm.formData.folioNumber = $stateParams.folioNumber;
              vm.changeFolio();
            }
          } else {
            vm.folioListData = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function resetAll() {
      vm.selectedInScheme='';
      vm.selectedFrequency='';
      vm.formData.installment='';
      vm.fields.showInstallment=false;
      vm.formData.amount='';
    }

    function fetchUnitDetails() {
      vm.validations = null;
      vm.unitsDetails = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "STP"
      }).$promise.then(success, error);
    }

    function fetchSchemes() {
     // resetAll();
      vm.schemes = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;
          } else {
            vm.schemes = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemes = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsCommonService.post({
        child1: 'folio',
        child2: 'schemes',
        child3:'swing',
        child4:'stp'
      }, {folioNumber: vm.formData.folioNumber, transactionType:'swingstp'}).$promise.then(success, error);
    }

    function fetchAllSchemeType() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.schemeList) {
            vm.allSchemesList = resp.data.schemeList;
            if(vm.selectedInSchemeCode){
              var result = vm.allSchemesList.find(function (scheme) {
                return scheme.schemeCode == vm.selectedInSchemeCode;
              });
              vm.selectedInScheme = result.scheme;
            }
          } else {
            vm.allSchemesList = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.allSchemesList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'swingstpenabled',
        child2: vm.investorInfo.minor
      }, null).$promise.then(success, error);
    }

    function changeFolio() {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      }
      resetAll();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'folio',
        child1: 'contact-details'
      }, {
        folioNumber: vm.formData.folioNumber
      }).$promise.then(success, error);
    }

    function getSchemesList() {
      if (vm.unitsDetails && vm.unitsDetails.message) {
        MessageService.error(vm.unitsDetails.message);
        return;
      }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      resetDefaults();
      var successSchemeList = function (result) {
          vm.formData.inSchemeCode = result.schemeCode;
          vm.selectedInSchemeCode = result.schemeCode;
          vm.formData.inSchemeName = result.scheme;
          vm.selectedInScheme = result.scheme;
          fetchSchemeValidations();
        },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "swingstpenabled",
        isMinor: vm.investorInfo.minor
      }, successSchemeList, errorSchemeList);
    }

    function inSchemeChanged(schemeData) {
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
     resetDefaults();
      vm.isSelectedInScheme = true;
      vm.selectedInScheme = schemeData.scheme;
      vm.selectedInSchemeCode = schemeData.schemeCode;
      vm.selectedInSchemeType = schemeData.schemeType;
      fetchSchemeValidations();
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
        };
      if (!vm.selectedInSchemeCode) {
        MessageService.error('Please select a scheme first');
        return;
      }
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.selectedFrequency = null;
      vm.validationsData = null;
      vm.validations = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.validationsData = resp.data;

            if (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) {
              vm.formData.dividentOption = dividendConstants.GROWTH;
            } else {

              if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === false){
                vm.formData.dividentOption = dividendConstants.PAYOUT;
              }else if(vm.validationsData.dividendPayoutApplicable === false && vm.validationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividentOption = dividendConstants.REINVEST;
              }else if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividentOption = dividendConstants.REINVEST;
              }
            }


            cb(null);
          } else {
            cb('error');
            MessageService.error('Some error occurred. Please try again.');
            vm.validationsData = null;
          }
        },
        error = function (err) {
          cb('error');
          vm.validationsData = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'stp',
        child1: vm.selectedInSchemeCode
      }, null).$promise.then(success, error);
    }

    vm.changeFrequency = function () {
      vm.formData.amount = '';
      resetDefaults();
      changeFrequency();
      if (vm.selectedFrequency && vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
         setAmountForCapitalType();
      }
    };

    vm.checkValidScheme = function () {
      $timeout(function () {
        if (vm.allSchemesList && vm.allSchemesList.length > 0) {
          var Arr = [];
          Arr = vm.allSchemesList.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
          }
        }
      }, 100);
    };

    function changeFrequency() {
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = null;
      vm.formData.endDate=null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      vm.formData.startDate=null;
      vm.formData.installment = null;
      extractValidationObject(vm.validationsData);
      if (vm.selectedFrequency && vm.selectedFrequency.key === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.fields.showDateOfTransfer= false;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = false;
        vm.fields.showInstallment= true;
        vm.showOrMessage=false;
        updateDatesForDaily()
      } else if (vm.selectedFrequency && vm.selectedFrequency.key === 'OW') {  //week
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'days';
        vm.fields.showDateOfTransfer= true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment= false;
        vm.showOrMessage=false;
      }
      else if(vm.selectedFrequency && vm.selectedFrequency.key === 'OM'){
        vm.viewMode = 'months';
        vm.daysList = AppConstants.SIP_DAYS_LIST;
        vm.fields.showDateOfTransfer= true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment= false;
        vm.showOrMessage=true;
      }
      else if(vm.selectedFrequency && vm.selectedFrequency.key === 'Q'){
        vm.viewMode = 'months';
        vm.daysList = AppConstants.SIP_DAYS_LIST;
        vm.fields.showDateOfTransfer= true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment= false;
        vm.showOrMessage=true;
      }
      else {
        vm.daysList = AppConstants.DAYS_LIST;
        vm.viewMode = 'months';
        vm.fields.showDateOfTransfer= false;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = false;
        vm.fields.showInstallment= false;
        vm.showOrMessage=false;
      }
    }

    function resetDefaults() {
      vm.isResetting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = null;
      extractValidationObject(vm.validationsData);
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }

    function changeDay() {
      if (!vm.selectedFrequency || !vm.formData.stpDay) {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.amount = '';
        return;
      }
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.amount = '';
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      switch (vm.selectedFrequency.key) {
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          vm.endDate = null;
          vm.enabledEndDates = null;
          break;
      }
    }

    function updateDatesForDaily() {
      var currentDay = moment().add(3+3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var _dd = vm.startDate.format('DD');
      vm.formData.stpDay = {name: _dd, value: _dd};
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? moment(vm.startDate):moment(new Date());
      } else {
        currentDay = moment().add(3+3, 'days');
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === vm.formData.stpDay.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //console.log('enabledStartDates[0]===== ',enabledStartDates);
      //vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate?moment(vm.startDate):moment(new Date());
      } else {
        currentDay = moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.stpDay.value);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      while (_diff < 10) {
        updatedDate.add(30+3, 'days').set('date', vm.formData.stpDay.value);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }
      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //console.log(enabledStartDates)
      //vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      updateEndDates();
    }

    function updateEndDates() {
      //var installment = vm.formData && vm.formData.installment ? vm.formData.installment : null;
      if (!vm.startDate) {
        return;
      }
      var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      switch (vm.selectedFrequency.key) {
        case'DZ':
        case'OW':
          var days = 0;
          endDate = vm.startDate.clone().add(vm.selectedFrequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          //endDate = vm.startDate.clone().add(vm.formModel.selectedFrequency.monthfreq, 'months');
          endDate = vm.startDate.clone().add(vm.selectedFrequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      vm.minEndDate = vm.enabledEndDates[0];
      reSetting();

      /*if (!installment) {
       var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
       vm.enabledEndDates = enabledEndDates.slice(minInstallments);
       } else {
       vm.enabledEndDates = enabledEndDates;
       }*/
    }
    function reSetting() {
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }

    function changeStartDate(date) {
      /*if (date) {
        vm.formData.startDate && vm.formData.startDate.set({'year': date.year(), 'month': date.month(), 'date': date.date()});
        vm.formData.startDate=date._i?date._i:null;
        updateEndDates();
        // vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate,'days')+1;
      } else {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
      }*/
      vm.formData.startDate = date ? date : null;
      vm.startDate = vm.formData.startDate;
      /*if(vm.selectedFrequency.key=='DZ'){
        var _dd = vm.startDate.format('DD');
        vm.formData.stpDay = {name: _dd, value: _dd};
      }*/
      vm.formData.endDate = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      updateEndDates();
    }

    function changeEndDate(date) {
      if (date) {
        vm.endDate = date;
        vm.formData.endDate=date._i?date._i:"";
        var daysDuration;
        if(!vm.endDate){
          return;
        }
        switch (vm.selectedFrequency.key) {
          case'DZ':
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'days') + 1;break;
          case 'OW':
            daysDuration = (vm.endDate.diff(vm.startDate, 'days') + 1) / 7;
            vm.formData.installment = Math.ceil(daysDuration);
            break;
          case 'OM' :
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'months');break;
          case 'Q':
            daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 3;
            vm.formData.installment = Math.ceil(daysDuration);
            break;
          case 'H':
            daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 6;
            vm.formData.installment = Math.ceil(daysDuration);
            break;
          case 'Y':
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'years');
            break;
          default :
        }
      } else {
        vm.endDate = null;
        vm.enabledEndDates = null;
      }
    }

    function changeInstallments() {
      updateEndDates();
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.selectedFrequency || !vm.unitsDetails) {
        return;
      }
      vm.validations = {};

      switch (vm.selectedFrequency.key) {
        case 'DZ':
          vm.validations.amountMultiples = validationsData.dailyAmtMultiples;
          vm.validations.maxAmount = validationsData.dailyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.dailyMaxAmt;
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.dailyMinAmt;
          vm.validations.minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          vm.validations.amountMultiples = validationsData.weeklyAmtMultiples;
          vm.validations.maxAmount = validationsData.weeklyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.weeklyMaxAmt;
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.weeklyMinAmt;
          vm.validations.minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          vm.validations.amountMultiples = validationsData.quarterlyAmtMultiples;
          vm.validations.maxAmount = validationsData.quarterlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.quarterlyMaxAmt;
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.quarterlyMinAmt;
          vm.validations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.validations.amountMultiples = validationsData.monAmtMultiples;
          vm.validations.maxAmount = validationsData.monMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.monMaxAmt;
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.monMinAmt;
          vm.validations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.validations.amountMultiples = validationsData.halfYearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.halfYearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.halfYearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.halfYearlyMinAmt;
          vm.validations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.validations.amountMultiples = validationsData.yearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.yearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.yearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.yearlyMinAmt;
          vm.validations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      vm.validations.minInstallDivisionFlag = validationsData.minInstallDivisionFlag;
      vm.validations.swpTaxCode = validationsData.swpTaxCode;
      vm.validations.isGrowth = validationsData.isGrowth;
      vm.validations.endingType = validationsData.endingType;
      //vm.formData.installment = vm.validations.minInstallments;
      checkValidations();
    }

    function checkValidations() {
      if (vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations && vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount || (vm.unitsDetails && vm.formData.amount > vm.unitsDetails.freeValueAmount));
        vm.isMin = !!(vm.validations && vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false
      }
      if(vm.selectedFrequency.key === 'OW') {
        if(vm.selectedInSchemeType === "ELSS"){
          vm.validations.minInstallments = 6;
        }
        else{
          if(vm.formData.amount === ''){
            vm.validations.minInstallments = 6;
            vm.fill_end_date = "";
          }
          else if(vm.formData.amount < 1000){
            vm.validations.minInstallments = 12;
            vm.formData.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
          else {
            vm.validations.minInstallments = 6;
            vm.formData.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
        }

      }
    }

    function setAmountForCapitalType() {
      switch (vm.selectedFrequency.key) {
        case 'OM':
          vm.formData.amount = 300;
          break;
        case 'Q':
          vm.formData.amount = 1000;
          break;
        default :
          vm.formData.amount = '';
          break;
      }
    }

    function amountChanged(className) {
      UtilService.currentFocusedElement.set(className);
      vm.checkValidations();
    }

    function blured() {
      UtilService.currentFocusedElement.clear();
    }


    vm.confirmCancel = function () {
      var success = function () {
        var _statusType = $stateParams.status;

        var identifier = AuthService.getToken();
        if(identifier && identifier.loginType=='A'){
          $state.go('agent.home.distributor-home');
        } else{
          _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
        }

      };
      ModalService.confirmCancelModal({}, success);
    };

    function getSwingStpPayloadToSave() {

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay?vm.formData.stpDay.value:null,
        "amount": vm.formData.amount,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency?vm.selectedFrequency.key:null,
        "formType": "STPSWING",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment||0,
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };
      /*var payload = {
        "amount": "",
        "brokerCode": "ARN-0411",
        "dividendOption": "Z",
        "euinCode": "E030803",
        "euinName": "Richa Tripathi",
        "euinOpted": "Y",
        "folioNumber": 5663377,
        "formType": "STP",
        "frequency": "OM",
        "id": "",
        "investmentOption": "GROWTH",
        "investorUuid": "182a63da-a110-4b78-b742-350b66318bf6",
        "noOfInstallments": 6,
        "sourceSchemeCode": "44",
        "stpDay": 1,
        "stpType": vm.formData.stpType,
        "subBrokerCode": "",
        "targetSchemeCode": "32"
      }*/
      return angular.copy(payload);
    }
    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getSwingStpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
             cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'stp',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.selectedInScheme) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionStpController', initiateTransactionStpController);

  /** @ngInject */
  function initiateTransactionStpController($state, $stateParams, $scope, $rootScope, $timeout, $window, StoreInvestorModel, InvestorsService, TransactionService, UtilService, AuthService, MessageService, ModalService, SchemeService, AppConstants, LoaderService, HDFC_API, $log, AgentSocketService, DynamicData, panAdharLinkingService, $cookies , InvestorServiceDynamicData) {
    var vm = this;
    var identifier = AuthService.getToken();
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.selectedStpType = selectedStpType;
    vm.fetchAllSchemeType = fetchAllSchemeType;
    vm.getSchemesList = getSchemesList;
    vm.inSchemeChanged = inSchemeChanged;
    vm.submit = submit;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.changeDay = changeDay;
    vm.init = init;
    vm.amountChanged = amountChanged;
    vm.blured = blured;
    vm.checkValidations = checkValidations;
    vm.changeInvestmentOption = changeInvestmentOption;
    vm.confirmCancel = confirmCancel;
    vm.getEuinCodes = getEuinCodes;
    vm.displayCalendar = true;
    vm.displayWeekdays = true;
    vm.fill_end_date = "";
    vm.changeInstallments = changeInstallments;
    vm.dynamicNote = DynamicData.noteDTO.noteDTOMap;

    vm.stpForm = {};
    vm.formData = {minorFlag:'false'};
    vm.formData.euinObj = null;
    vm.folioListData = [];
    vm.transactionConstants = AppConstants.TRANSACTION;
    var dividendConstants = AppConstants.DIVIDEND_OPTIONS;
    vm.daysList = null;
    vm.formData.dividentOption = '';
    vm.formData.stpType = vm.transactionConstants.FIXED_AMOUNT;
    vm.frequencyList = AppConstants.STP_FREQ_LIST_FOR_FIXED;
    vm.allSchemesList = null;
    vm.isSelectedInScheme = true;
    vm.investorUUID = $stateParams.uuid;
    vm.startDate = null;
    vm.endDate = null;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isSubmitted = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.unitsDetails = null;
    vm.isInScheme = false;
    vm.validations = null;
    vm.validationsData = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isResetting = false;
    vm.investorInfo = null;
    vm.viewMode = 'days';
    vm.selectedFrequency = null;
    vm.isShowDefault = 'false';
    vm.stpDevidendOptions = [vm.transactionConstants.REINVEST, vm.transactionConstants.PAYOUT];
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.hasFolioEmailId = true;
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.today = $window.moment();
    vm.isSelectedInScheme = true;
    vm.maxDateStart = $window.moment().add(3,'months')
    vm.maxDateEnd = new Date(2040, 12, 31);
    vm.inSchemsType = null;

    vm.termsAndContitions = termsAndContitions;
    vm.validationsApi = {};
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.blockFolioForTransaction = false;

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      StoreInvestorModel.setInvestorDetail(null);
    });

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function resetAll() {
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.formData.dividentOption = '';
      vm.formData.stpType = vm.transactionConstants.FIXED_AMOUNT;
      vm.isSelectedInScheme = true;
      vm.isSubmitted = false;
      vm.unitsDetails = null;
      vm.showSelectDay = true;
      vm.schemes = null;
      vm.isResetting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = null;
      vm.viewMode = 'months';
      vm.isShowDefault = 'false';
      vm.selectedInSchemeCode = '';
      vm.selectedInScheme = '';
      vm.selectedInSchemeType = '';
      vm.validationsData = null;
      vm.fill_end_date = "";
      vm.stpForm.$setPristine();
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      if ($stateParams.transactionId) {
        vm.formData.schemeCode = vm.formData && vm.formData.schemeCode ? vm.formData.schemeCode : '';
      } else {
        vm.formData.schemeCode = '';
      }

    }

    function resetDefaults() {
      vm.isResetting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = null;
      vm.fill_end_date = "";
      extractValidationObject(vm.validationsData);
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }

    function init() {
      $log.debug("TransactionInitiate STP  StateParams: ", $stateParams);

      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      if ($stateParams.schemeCode) {
        vm.formData.schemeCode = $stateParams.schemeCode;
        fetchUnitDetails();
      }
      if ($stateParams.transactionId) {
        getInvestorInfo(function() {
          getTransactionDetails();
        });
      }
      getEuinCodes();
      getInvestorInfo(function () {
        folioList();
      });
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });

    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinList = [
              {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              }
            ];
            vm.formData.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber, activeFlag: true}];
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.schemeCode = resp.data.sourceSchemeCode;
            fetchUnitDetails();
            vm.selectedInSchemeCode = resp.data.targetSchemeCode;
            vm.selectedInScheme = resp.data.targetSchemeName;
            fetchSchemeValidations(function (err) {
              if (!err) {
                vm.formData.dividentOption = resp.data.dividendOption;
                vm.formData.stpType = resp.data.stpType;
                vm.frequencyList = (vm.formData.stpType == 'F') ? AppConstants.STP_FREQ_LIST_FOR_FIXED : AppConstants.STP_FREQ_LIST_FOR_CAPITAL;
                vm.selectedFrequency = vm.frequencyList.find(function (item) {
                  return item.key === resp.data.frequency;
                });
                changeFrequency();
                vm.isShowDefault = 'true';
                vm.isSelectedInScheme = true;
                vm.formData.stpDay = vm.daysList.find(function (item) {
                  return item.value === +resp.data.stpDay;
                });
                vm.startDate = $window.moment(resp.data.startDate);
                vm.endDate = $window.moment(resp.data.endDate);
                changeDay();
                vm.formData.amount = resp.data.amount;
                checkValidations();
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }

    }

    function getInvestorInfo(cb) {
      cb = cb || function() {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function folioList() {
      var payload = {"investorUUID": vm.investorUUID},
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = resp.data.folioList || [];
            var folio = [];
            for (var i in folioList) {
              var obj = {}, item = folioList[i];
              obj.key = i;
              obj.activeFlag = item.activeFlag;
              obj.folioId = item.folioId;
              obj.folioNo = item.folioNumber;
              obj.minorFlag = item.minorFlag;
              obj.holderDOBExists = item.holderDOBExists;
              obj.retirementSchemeBlankDOBErrorMsg = item.retirementSchemeBlankDOBErrorMsg;
              obj.corporateInvestor = item.corporateInvestor;
              folio.push(obj);
            }
            vm.folioListData = folio;
            if ($stateParams.folioNumber) {
              vm.formData.folioNumber = $stateParams.folioNumber;
              vm.changeFolio();
            }
          } else {
            vm.folioListData = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.selectedFrequency || !vm.unitsDetails) {
        return;
      }
      vm.validations = {};
      switch (vm.selectedFrequency.key) {
        case 'DZ':
          vm.validations.amountMultiples = validationsData.dailyAmtMultiples;
          vm.validations.maxAmount = validationsData.dailyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.dailyMaxAmt;
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.dailyMinAmt;
          vm.validations.minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          vm.validations.amountMultiples = validationsData.weeklyAmtMultiples;
          vm.validations.maxAmount = validationsData.weeklyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.weeklyMaxAmt;
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.weeklyMinAmt;
          vm.validations.minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          vm.validations.amountMultiples = validationsData.quarterlyAmtMultiples;
          vm.validations.maxAmount = validationsData.quarterlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.quarterlyMaxAmt;
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.quarterlyMinAmt;
          vm.validations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.validations.amountMultiples = validationsData.monAmtMultiples;
          vm.validations.maxAmount = validationsData.monMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.monMaxAmt;
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.monMinAmt;
          vm.validations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.validations.amountMultiples = validationsData.halfYearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.halfYearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.halfYearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.halfYearlyMinAmt;
          vm.validations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.validations.amountMultiples = validationsData.yearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.yearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.yearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.yearlyMinAmt;
          vm.validations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      vm.validations.minInstallDivisionFlag = validationsData.minInstallDivisionFlag;
      vm.validations.swpTaxCode = validationsData.swpTaxCode;
      vm.validations.isGrowth = validationsData.isGrowth;
      vm.validations.endingType = validationsData.endingType;
      vm.formData.installment = vm.validations.minInstallments;
      vm.changeInstallments();
      checkValidations();
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.selectedInSchemeCode) {
        MessageService.error('Please select a scheme first');
        return;
      }
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.selectedFrequency = null;
      vm.validationsData = null;
      vm.validations = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.isMinApi = false;
      vm.isMaxApi = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.validationsData = resp.data;
            vm.inSchemsType = resp.data.schemeType;
            if (vm.validateData) {

              if (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) {
                vm.formData.dividentOption = dividendConstants.GROWTH;
              } else {

                if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === false){
                  vm.formData.dividentOption = dividendConstants.PAYOUT;
                }else if(vm.validationsData.dividendPayoutApplicable === false && vm.validationsData.dividendReinvestmentApplicable === true) {
                  vm.formData.dividentOption = dividendConstants.REINVEST;
                }else if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === true) {
                  vm.formData.dividentOption = dividendConstants.REINVEST;
                }
              }
              resetInputAndSelectField();
            }
            cb(null);
          } else {
            cb('error');
            MessageService.error('Some error occurred. Please try again.');
            vm.validationsData = null;
          }
        },
        error = function (err) {
          cb('error');
          vm.validationsData = null;
          UtilService.errorHandler(err);
        };
      var data = {
        schemeCode: vm.selectedInSchemeCode,
        folioNo: vm.formData.folioNumber,
        transactionType: 'STP'
      }
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'stp'
      }, data).$promise.then(success, error);
    }


    function fetchCalculatedSwitchValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.schemeCode && (!vm.selectedFrequency || !vm.selectedFrequency.key)) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
        return;
      }

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            (angular.isDefined(resp.data.minAmount)) && (vm.validationsApi.minAmount = resp.data.minAmount);
            (angular.isDefined(resp.data.maxAmount)) && (vm.validationsApi.maxAmount = resp.data.maxAmount);
            (angular.isDefined(resp.data.minUnits)) && (vm.validationsApi.minUnits = resp.data.minUnits);
            (angular.isDefined(resp.data.maxUnits)) && (vm.validationsApi.maxUnits = resp.data.maxUnits);
            (angular.isDefined(resp.data.investmentOption)) && (vm.validationsApi.investmentOption = resp.data.investmentOption);
            (angular.isDefined(resp.data.validationType)) && (vm.validationsApi.validationType = resp.data.validationType);
            (angular.isDefined(resp.data.endingType)) && (vm.validationsApi.endingType = resp.data.endingType);
            (angular.isDefined(resp.data.amtMultiples)) && (vm.validationsApi.amountMultiples = resp.data.amtMultiples);
            $log.info('S vali>>', vm.validationsApi);
            checkValidationsApi();
            cb(null);
          } else {
            cb('error');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          cb('error');
          UtilService.errorHandler(err);
        };

      var valPayload = {
        "folioNo":vm.formData.folioNumber,
        "inSchemeCode": vm.selectedInSchemeCode,
        "outSchemeCode": vm.formData.schemeCode,
        "frequency":vm.selectedFrequency && vm.selectedFrequency.key?vm.selectedFrequency.key:'',
        "transactionType":"STP"
      };
      LoaderService.showLoader();
      SchemeService.post({
        controller: 'schemeValidation',
        child1: 'validationCal',
      }, valPayload).$promise.then(success, error);
    }

    function fetchSchemes() {
      // resetAll();
      vm.schemes = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;
          } else {
            vm.schemes = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemes = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'folio',
        child1: 'schemes'
      }, {folioNumber: vm.formData.folioNumber, transactionType: 'STP'}).$promise.then(success, error);
    }

    function fetchAllSchemeType() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.schemeList) {
            vm.allSchemesList = resp.data.schemeList;
            vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList);
            if(vm.selectedInSchemeCode){
              var result = vm.allSchemesList.find(function (scheme) {
                return scheme.schemeCode == vm.selectedInSchemeCode;
              });
              vm.selectedInScheme = result.scheme;
            }
          } else {
            vm.allSchemesList = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.allSchemesList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'stpenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      vm.validations = null;
      vm.unitsDetails = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
          vm.selectedFrequency = null;
          vm.formData.installment = null;
          vm.formData.amount = null;
          if(vm.stpForm && vm.stpForm.frequency){
            vm.stpForm.frequency.$setPristine();
          }
          if(vm.stpForm && vm.stpForm.installment){
            vm.stpForm.installment.$setPristine();
          }
          if(vm.stpForm && vm.stpForm.stpAmount){
            vm.stpForm.stpAmount.$setPristine();
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber || $stateParams.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "STP"
      }).$promise.then(success, error);
    }

    function changeInvestmentOption() {
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      resetDefaults();
      if (vm.validationsData && (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH)) {
        vm.formData.dividentOption = "Z"
      } else {
        vm.formData.dividentOption = (vm.validationsData.endingType === vm.ENDING_TYPES.CLOSED) ? vm.transactionConstants.PAYOUT : vm.transactionConstants.REINVEST;
      }
    }

    function setAmountForCapitalType() {
      switch (vm.selectedFrequency.key) {
        case 'OM':
          vm.formData.amount = '';
          break;
        case 'Q':
          vm.formData.amount = '';
          break;
        default :
          vm.formData.amount = '';
          break;
      }
    }

    function selectedStpType(stpType) {
      vm.formData.stpType = stpType?stpType:vm.formData.stpType;
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      resetInputAndSelectField();
      resetDefaults();
      if (vm.formData.stpType == 'F') {
        vm.frequencyList = AppConstants.STP_FREQ_LIST_FOR_FIXED;
      } else {
        vm.frequencyList = AppConstants.STP_FREQ_LIST_FOR_CAPITAL;
      }
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: 'STP',
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        targetSchemeCode: vm.selectedInSchemeCode,
        amount: vm.formData.amount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);

    };

    function submit() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.sKycStatus) {
              submitStpTransaction();
            }
            else {
              MessageService.error(resp.data.message);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {"panNumber": vm.investorInfo.panNumber, "folioNumber": vm.formData.folioNumber};
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'sKycStatus'
      }, payload).$promise.then(success, error);
    }

    function submitStpTransaction() {

      vm.isSubmitted = true;

      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Invalid arnCode');
        return;
      }

      if (!vm.validationsData || !vm.validationsData.investmentOption) {
        MessageService.error("Invalid Investment option is selected.");
        vm.isSubmitted = false;
        return;
      }

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay.value,
        "amount": vm.formData.amount,
        "brokerCode": identifierData.arnCode,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency.key,
        "startDate": vm.startDate.clone().format('DD-MMM-YYYY'),
        "endDate": vm.endDate && vm.endDate.clone().format('DD-MMM-YYYY'),
        "formType": "STP",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment
      };
      if (!vm.oversea_arn) {
        payload.euinOpted = vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N';
        payload.euinCode = vm.formData.euinObj && vm.formData.euinObj.euinCode || '';
        payload.euinName = vm.formData.euinObj && vm.formData.euinObj.euinName || '';
      } else {
        payload.euinOpted = 'N';
      }

      if(vm.formData.subBrokerARN){
        payload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        payload.subBrokerCode = vm.formData.subBrokerCode;
      }

      var successSTPModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'STP',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };


      var _scheme = vm.schemes && vm.schemes.find(function (i) {
        return i.schemeCode === vm.formData.schemeCode;
      }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        sourceSchemeName: _scheme.schemeName,
        targetSchemeName: vm.selectedInScheme,
        stpDay: vm.formData.stpDay.name,
        frequency: vm.selectedFrequency.value,
        mobileNumber: vm.mobileNumber ? vm.mobileNumber : '',
        emailId: vm.emailId ? vm.emailId : '',
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag,
        subBrokerArn: vm.formData.subBrokerARN,
        subBrokerCode: vm.formData.subBrokerCode,
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName ? vm.formData.euinObj.euinName : null,
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode ? vm.formData.euinObj.euinCode : null
      };

      ModalService.transactionReviewModal({
        payload: payload, controller: 'stp', additionalData: additionalData
      }, success, error);

    }

    function getSchemesList() {
      if (vm.unitsDetails && vm.unitsDetails.message) {
        MessageService.error(vm.unitsDetails.message);
        return;
      }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      resetDefaults();
      var successSchemeList = function (result) {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.selectedInScheme = null;
            return;
          }
          vm.selectedInSchemeCode = result.schemeCode;
          vm.selectedInScheme = result.scheme;
          vm.selectedInSchemeType = result.schemeType;
          fetchSchemeValidations();
          vm.formData.stpType = vm.transactionConstants.FIXED_AMOUNT;
          selectedStpType(vm.formData.stpType);
        },
        errorSchemeList = function () {
          vm.selectedInSchemeCode = '';
          vm.selectedInScheme = '';
          vm.selectedInSchemeType = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "stpenabled",
        isMinor: vm.formData.minorFlag,
        corporateFlag: vm.selectedFolioData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    }

    function inSchemeChanged(schemeData) {
      if (!schemeData) {
        return;
      }
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.formData.amount = '';
      vm.selectedFrequency = null;
      vm.isResetting = true;
      resetInputAndSelectField();
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      resetDefaults();
      vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
      if (vm.showRetirementSchemeError) {
        MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
        vm.selectedInScheme = null;
        vm.filterInSchemeList();
        return;
      }
      vm.isSelectedInScheme = true;
      vm.selectedInScheme = schemeData.scheme;
      vm.selectedInSchemeCode = schemeData.schemeCode;
      vm.selectedInSchemeType = schemeData.schemeType;
      if(schemeData.schemeType === 'NFO'){
        ModalService.nfoTransactionPointNotes();
      }
      fetchSchemeValidations();
      vm.formData.stpType = vm.transactionConstants.FIXED_AMOUNT;
      selectedStpType(vm.formData.stpType)
    }

    function updateDatesForDaily() {
      var currentDay = $window.moment().add(3+2, 'days');/*3(valid day gap)+2(buffer day added)*/
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var _dd = vm.startDate.format('DD');
      vm.formData.stpDay = {name: _dd, value: _dd};
      vm.minDateStart = $window.moment(vm.enabledStartDates[0]).add(1,'minutes');
      // updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? $window.moment(vm.startDate) : $window.moment(new Date());
      } else {
        currentDay = $window.moment().add(3+2, 'days');/*3(valid day gap)+2(buffer day added)*/
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === vm.formData.stpDay.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.maxDateStart = $window.moment(vm.enabledStartDates[vm.enabledStartDates.length -1]).add(1,'days');
      vm.minDateStart = $window.moment(vm.enabledStartDates[0]).add(1,'minutes');
      vm.startDate = vm.enabledStartDates[0];
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? $window.moment(vm.startDate) : $window.moment(new Date());
      } else {
        currentDay = $window.moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      // updatedDate.set('date', vm.formData.stpDay.value);
      // var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      // while (_diff < 10) {
      //   updatedDate.add(30+3, 'days').set('date', vm.formData.stpDay.value);/*30(valid day gap)+3(buffer day added)*/
      //   _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      // }
      // var enabledStartDates = [];
      // for (var i = 0; i <= 3; i++) {
      //   var _date = updatedDate.clone().add(i, 'months');
      //   _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
      //   if (_diff <= 90) {
      //     enabledStartDates.push(_date.clone());
      //   }
      // }
      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //vm.startDate = angular.copy(enabledStartDates[0]);
      // vm.enabledStartDates = angular.copy(enabledStartDates);
      // vm.maxDateStart = $window.moment(vm.enabledStartDates[vm.enabledStartDates.length -1]).add(1,'days');
      // vm.minDateStart = $window.moment(vm.enabledStartDates[0]).add(1,'minutes');
        vm.minDateStart = updatedDate.clone().add(10, 'days');
        vm.maxDateStart = $window.moment(Date.parse(updatedDate)).add(90, 'days').add(1, 'minutes');
      updateEndDates();
    }

    function updateEndDates() {
      //var installment = vm.formData && vm.formData.installment ? vm.formData.installment : null;
      if (!vm.startDate) {
        return;
      }
      var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      // var defaultEndDate =  new Date(2040, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      switch (vm.selectedFrequency.key) {
        case'DZ':
        case'OW':
          var days = 0;
          var minInstallmentsDays = vm.validations.minInstallments || 6;
          minInstallmentsDays =  minInstallmentsDays - 1;
          endDate = vm.startDate.clone().add(minInstallmentsDays, 'weeks');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0,minInstallmentIndex;
          minInstallmentIndex = vm.validations && vm.validations.minInstallments ?  vm.validations.minInstallments * vm.selectedFrequency.monthfreq : vm.selectedFrequency.key === 'OM' ? 5:1;
          minInstallmentIndex = minInstallmentIndex - 1 * vm.selectedFrequency.monthfreq;
          endDate = vm.startDate.clone().add(minInstallmentIndex, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates;//enabledEndDates.slice(minInstallments);
      vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
      if(vm.selectedFrequency.key == 'OW'){
        vm.addNoOfInstallments =vm.formData.installment - 1;
        vm.endDate = vm.startDate.clone().add(vm.addNoOfInstallments, 'weeks');
      }
      reSetting();

      /*if (!installment) {
        var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
        vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      } else {
        vm.enabledEndDates = enabledEndDates;
      }*/
    }

    function changeFrequency() {
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = null;
      vm.isResetting = true;
      (vm.formData) && (vm.formData.installments = '');
      if(vm.stpForm && vm.stpForm.stpAmount){
        vm.stpForm.stpAmount.$setPristine();
      }
      if(vm.stpForm && vm.stpForm.day){
        vm.stpForm.day.$setPristine();
      }
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      extractValidationObject(vm.validationsData);
      vm.selectedFrequency && vm.selectedFrequency.key && fetchCalculatedSwitchValidations();
      if (vm.selectedFrequency && vm.selectedFrequency.key === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.displayWeekdays = false;
        vm.endDate = null;
        vm.displayCalendar = false;
        updateDatesForDaily()
      } else if (vm.selectedFrequency && vm.selectedFrequency.key === 'OW') {
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'days';
        vm.displayWeekdays = true;
        vm.displayCalendar = false;
      } else {
        vm.daysList = null;
        vm.viewMode = 'months';
        vm.displayWeekdays = true;
        vm.displayCalendar = true;
        updateDatesForOthers();
      }
    }

    function changeDay() {
      if (!vm.selectedFrequency || !vm.formData.stpDay) {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
        vm.fill_end_date = "";
        vm.formData.amount = '';
        if(vm.stpForm && vm.stpForm.stpAmount){
          vm.stpForm.stpAmount.$setPristine();
        }
        return;
      }
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.fill_end_date = "";
      vm.formData.amount = '';
      if(vm.stpForm && vm.stpForm.stpAmount){
        vm.stpForm.stpAmount.$setPristine();
      }
      vm.fill_end_date = "";

      if (vm.selectedFrequency && vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        setAmountForCapitalType();
      }
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      switch (vm.selectedFrequency.key) {
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          vm.endDate = null;
          vm.enabledEndDates = null;
          break;
      }
    }

    function changeStartDate(date) {
      /*if (date) {
        vm.startDate && vm.startDate.set({'year': date.year(), 'month': date.month(), 'date': date.date()});
        updateEndDates();
        // vm.formData.installment = vm.endDate.diff(vm.startDate,'days')+1;
      } else {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
      }*/
      vm.startDate = date ? date : null;
      /*if(vm.selectedFrequency.key=='DZ'){
        var _dd = vm.startDate.format('DD');
        vm.formData.stpDay = {name: _dd, value: _dd};
      }*/
      vm.endDate = null;
      vm.fill_end_date = "";
      vm.enabledEndDates = null;
      vm.formData.amount = "";
      if(vm.stpForm && vm.stpForm.stpAmount){
        vm.stpForm.stpAmount.$setPristine();
      }
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      if((vm.selectedFrequency.key == "OM" || vm.selectedFrequency.key == "Q")){
        var _dd = vm.startDate.format('DD');
        vm.formData.stpDay = {name: _dd, value: _dd};
      }
      updateEndDates();
    }

    function changeEndDate(date) {
      if (date) {
        vm.endDate = date;
        // var daysDuration;
        switch (vm.selectedFrequency.key) {
          case'DZ':
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'days') + 1;
            calculateSTPMinAmountAndMultples('DZ', vm.validationsData.dailyMinInstallmentNumber);
            break;
          case 'OW':
            var daysDuration = (vm.endDate.diff(vm.startDate, 'days') + 1) / 7;
            var installment = Math.ceil(daysDuration);
            vm.formData.installment = installment;
            calculateSTPMinAmountAndMultples('OW', vm.validationsData.weeklyMinInstallmentNumber);

            if (vm.selectedInSchemeType === "ELSS" && (installment >= 6)) {
              vm.fill_end_date = "Since your selected ELSS scheme, So please keep your minimum installment amount as Rs" + vm.validations.minAmount + ".";
            }else if(installment >= 6 && installment < 12) {
              vm.fill_end_date = "Since your selected no. of installments are "+ vm.formData.installment +", So please keep your minimum " +
                "installment amount as Rs "+ (vm.validations.minAmount) +".";
            }else {
              vm.fill_end_date = "Since your selected no. of installments are more than 12 or equal to 12, So please keep your minimum installment amount as Rs " + vm.validations.minAmount +".";
            }
            vm.formData.amount="";
            vm.stpForm.stpAmount.$setPristine();

            break;
          case 'OM' :
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'months') +1;
            // vm.formData.installment = 0;debugger;
            calculateSTPMinAmountAndMultples('OM', vm.validationsData.monMinInstallmentNumber);
            break;
          case 'Q':
            daysDuration = (vm.endDate.diff(vm.startDate, 'months') + 1) / 3;
            vm.formData.installment = Math.ceil(daysDuration);
            // vm.formData.installment = 0;
            calculateSTPMinAmountAndMultples('Q', vm.validationsData.quarterlyMinInstallmentNumber);
            break;
          case 'H':
            /*daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 6;
            vm.formData.installment = Math.ceil(daysDuration);*/
            vm.formData.installment = 0;
            break;
          case 'Y':
            /*vm.formData.installment = vm.endDate.diff(vm.startDate, 'years');*/
            vm.formData.installment = 0;
            break;
          default :
        }
      } else {
        vm.endDate = null;
        vm.enabledEndDates = null;
      }
    }

    function changeInstallments() {
      vm.formData.amount = "";
      if(vm.stpForm && vm.stpForm.stpAmount){
        vm.stpForm.stpAmount.$setPristine();
      }
      if(vm.selectedFrequency.key == "OW"){
        calculateSTPMinAmountAndMultples('OW', vm.validationsData.weeklyMinInstallmentNumber);
            if (vm.selectedInSchemeType === "ELSS" && (vm.formData.installment >= 6)) {
              vm.fill_end_date = "Since your selected ELSS scheme, So please keep your minimum installment amount as Rs" + vm.validations.minAmount + ".";
            }else if(vm.formData.installment >= 6 && vm.formData.installment < 12) {
              vm.fill_end_date = "Since your selected no. of installments are "+ vm.formData.installment +", So please keep your minimum " +
                "installment amount as Rs "+ (vm.validations.minAmount) +".";
            }else {
              vm.fill_end_date = "Since your selected no. of installments are more than 12 or equal to 12, So please keep your minimum installment amount as Rs " + vm.validations.minAmount +".";
            }
            vm.formData.amount="";
            vm.stpForm.stpAmount.$setPristine();
            if(vm.startDate){
              updateDatesForWeekly();
            }
      }else{
      calculateSTPMinAmountAndMultples('BZ', vm.validationsData.dailyMinInstallmentNumber);
      }
      // updateEndDates();
    }

    function checkValidations() {
      if (vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations && vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount || (vm.unitsDetails && vm.formData.amount > vm.unitsDetails.freeValueAmount));
        vm.isMin = !!(vm.validations && vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
      }
      /*if (vm.selectedFrequency.key === 'OW') {
        if (vm.selectedInSchemeType === "ELSS") {
          vm.validations.minInstallments = 6;
        }
        else {
          if (vm.formData.amount === '') {
            vm.validations.minInstallments = 6;
            vm.fill_end_date = "";
          }
          else if (vm.formData.amount < 1000) {
            vm.validations.minInstallments = 12;
            vm.endDate = '';
            // updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
          else {
            vm.validations.minInstallments = 6;
            vm.endDate = '';
            // updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
        }

      }*/
      $log.info('F vali>>', vm.validations);
    }

    function checkValidationsApi() {
      if (vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.isMaxApi = false;
        vm.isMinApi = false;
        vm.isMultiplesApi = true;
      } else {
        vm.isMaxApi = !!(vm.validationsApi && vm.validationsApi.maxAmount && vm.validationsApi.maxAmount < vm.formData.amount || (vm.unitsDetails && vm.formData.amount > vm.unitsDetails.freeValueAmount));
        vm.isMinApi = !!(vm.validationsApi && vm.validationsApi.minAmount && vm.validationsApi.minAmount > vm.formData.amount);
        vm.isMultiplesApi = vm.validationsApi && vm.formData.amount && (vm.formData.amount % vm.validationsApi.amountMultiples === 0) || false;
      }
      /*if (vm.selectedFrequency.key === 'OW') {
        if (vm.selectedInSchemeType === "ELSS") {
          vm.validationsApi.minInstallments = 6;
        }
        else {
          if (vm.formData.amount === '') {
            vm.validationsApi.minInstallments = 6;
            vm.fill_end_date = "";
          }
          else if (vm.formData.amount < 1000) {
            vm.validationsApi.minInstallments = 12;
            vm.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
          else {
            vm.validationsApi.minInstallments = 6;
            vm.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
        }

      }*/
    }

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.selectedInSchemeType = '';
      vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList, 'scheme', vm.selectedInScheme);
      vm.formData.stpType = vm.transactionConstants.FIXED_AMOUNT;
      selectedStpType(vm.formData.stpType)
    };

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }
      };
      ModalService.confirmCancelModal({}, success);
    }

    vm.checkValidScheme = function () {
      $timeout(function () {
        if (vm.allSchemesList && vm.allSchemesList.length > 0) {
          var Arr = [];
          Arr = vm.allSchemesList.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            // vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
          }
        }
      }, 200);
    };

    vm.changeFrequency = function () {
      vm.formData.amount = '';
      resetDefaults();
      changeFrequency();
      if (vm.selectedFrequency && vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        setAmountForCapitalType();
      }
    };

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        if((vm.stpForm.stpAmount.$valid && !vm.isMin && !vm.isMax) && vm.isCheckedTandC){
          vm.submit();
        }
        e.preventDefault();
      }
      return false;
    };

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.folioNumber = null;
            resetAll();
          }
        });
      }
      var selectedFolioObj = vm.folioListData.filter(function (row) {
        return row.folioNo == vm.formData.folioNumber
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
      }
      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
          fetchAllSchemeType();
          if(!$stateParams.schemeCode)
          {
            resetAll();
          }
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    };

    function amountChanged(className) {
      UtilService.currentFocusedElement.set(className);
      vm.checkValidations();
      // checkValidationsApi();
    }

    function blured() {
      UtilService.currentFocusedElement.clear();
    }


    function reSetting() {
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }


    function getStpPayloadToSave() {

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay?vm.formData.stpDay.value:null,
        "amount": vm.formData.amount,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency?vm.selectedFrequency.key:null,
        "formType": "STP",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment,
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };
      /*
      var payload = {
        "amount": "",
        "brokerCode": "ARN-0411",
        "dividendOption": "Z",
        "euinCode": "E030803",
        "euinName": "Richa Tripathi",
        "euinOpted": "Y",
        "folioNumber": 5663377,
        "formType": "STP",
        "frequency": "OM",
        "id": "",
        "investmentOption": "GROWTH",
        "investorUuid": "182a63da-a110-4b78-b742-350b66318bf6",
        "noOfInstallments": 6,
        "sourceSchemeCode": "44",
        "stpDay": 1,
        "stpType": "F",
        "subBrokerCode": "",
        "targetSchemeCode": "32"
      }*/
      return angular.copy(payload);
    }

    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getStpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'stp',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.selectedInScheme) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
      if (angular.isFunction(stateChangeStart())) {
        stateChangeStart();
      }
    });
    /*Socket code End*/

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };

    function calculateSTPMinAmountAndMultples(frequency, freqInstallmentNumber) {

      var stopLoop = false;
      if (vm.formData.installment && freqInstallmentNumber && (vm.formData.installment >= freqInstallmentNumber)) {
        vm.validationsData.additionalValidation[frequency].forEach(function (el) {

          if (stopLoop) {
            return;
          }

          if (el.min_installments && el.max_installments) {
            if (vm.formData.installment >= el.min_installments && vm.formData.installment <= el.max_installments) {
              vm.validations.minAmount = el.min_amount_lower;
              vm.validations.amountMultiples = el.amt_multiples;
              stopLoop = true;
            }
          } else {
            vm.validations.minAmount = el.min_amount_lower;
            vm.validations.amountMultiples = el.amt_multiples;
            stopLoop = true;
          }

        });
      }
    }

    function resetInputAndSelectField(){
      vm.selectedFrequency = null;
      vm.formData.amount = null;
      vm.formData.installment = null;
      vm.fill_end_date = null;
      if(vm.stpForm && vm.stpForm.frequency){
        vm.stpForm.frequency.$setPristine();
      }
      if(vm.stpForm && vm.stpForm.installment){
        vm.stpForm.installment.$setPristine();
      }
      if(vm.stpForm && vm.stpForm.day){
        vm.stpForm.day.$setPristine();
      }
      if(vm.stpForm && vm.stpForm.stpAmount){
        vm.stpForm.stpAmount.$setPristine();
      }
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SmartSwapController', smartSwapController);

  /** @ngInject */
  function smartSwapController($stateParams, $state, $timeout, $scope, AppConstants, AuthService, MessageService, ModalService, InvestorsService, moment, UtilService, TransactionService, LoaderService, SchemeService,HDFC_API, AgentSocketService ,panAdharLinkingService, $cookies , $window , InvestorServiceDynamicData) {

    var vm = this;
    var identifier=AuthService.getToken();
    vm.formData = {};
    vm.init = init;
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.selectedSwpType = selectedSwpType;
    vm.submit = submit;
    vm.changeStartDate = changeStartDate;
    vm.changeDay = changeDay;
    vm.checkValidations = checkValidations;
    vm.confirmCancel = confirmCancel;
    vm.frequencyList = null;
    vm.percentageList = null;
    vm.daysList = AppConstants.DAYS_LIST;
    vm.transactionConstants = AppConstants.TRANSACTION;
    vm.formData.swpType = 'F';
    vm.investorUUID = $stateParams.uuid;
    vm.folioListData = null;
    vm.startDate = null;
    vm.enabledStartDates = null;
    vm.isSubmitted = false;
    vm.investorInfo = '';
    vm.unitsDetails = null;
    vm.validations = {};
    vm.validationsData = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isReseting = false;
    vm.displayFlag = false;
    vm.displayScheme = false;
    vm.isSchemeDisabled = false;
    vm.isShowDefault = 'false';
    vm.hasFolioEmailId = true;
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.startMinDate = moment().add(7, 'days');/*10(valid day gap)+3(buffer day added)*/
    vm.startMaxDate = moment().add(120, 'days').add(1, 'minutes');
    vm.termsAndContitions = termsAndContitions;
    vm.SwpForm = {};
    vm.showTerms = true;
    vm.blockFolioForTransaction = false;

    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }
      vm.appConstants = AppConstants;
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      getInvestorInfo(function() {
        folioList();
      });
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General_SMART_SWAP && vm.termsConditionData.TNC_General_SMART_SWAP.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });

    }

    function termsAndContitions() {
      ModalService.termsAndConditionSmartSwap({});
    }

    function getInvestorInfo(cb) {
      cb = cb || function() {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.formData.selectedFrequency || !vm.unitsDetails) {
        return;
      }
      var amountMultiples = 1;
      var maxAmount = 0;
      var maxInstallments = 0;
      var minInstallments = 0;
      var minAmount = 0;
      vm.validations.amountMultiples = amountMultiples;
      vm.validations.maxInstallments = maxInstallments;
      vm.validations.minInstallments = minInstallments;
      vm.validations.minAmount = validationsData ? validationsData.smartSwapMinAmount ? validationsData.smartSwapMinAmount : minAmount : minAmount;
      vm.isMin=vm.validations.minAmount>vm.formData.amount;
      vm.validations.maxAmount = maxAmount;
    }

    function folioList() {
      LoaderService.showLoader();
      var payload = {"investorUUID": vm.investorUUID,"folioTrxnType":"SMART_SWAP"};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = resp.data.folioList || [];
          var folio = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            folio.push(obj);
          }
          vm.folioListData = folio;
          if ($stateParams.folioNumber) {
            vm.formData.folioNumber = $stateParams.folioNumber;
            vm.changeFolio();
          }
        } else {
          vm.folioListData = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.folioListData = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function fetchSchemes() {
      vm.schemes = null;
      vm.unitsDetails = null;
      if (!vm.formData.folioNumber) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;

            if ($stateParams.schemeCode) {
              vm.formData.schemeCode = $stateParams.schemeCode;
              fetchUnitDetails();
            }
            else if ($stateParams.transactionId) {
              fetchUnitDetails();
            }
          } else {
            vm.schemes = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.schemes = null;
        };
      InvestorsService.post({
        controller: 'folio',
        child1: 'schemes'
      }, {folioNumber: vm.formData.folioNumber,transactionType:"SMART_SWAP"}).$promise.then(success, error);
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.schemeCode) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_OUT_SCHEME);
        return;
      }
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.formData.selectedDay = '';
      vm.formData.amount = '';
      vm.formData.selectedFrequency = null;
      vm.formData.percentage = null;
      vm.validationsData = null;
      vm.validations = {};
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      var success = function (resp) {
          if (resp.status && resp.data) {
            cb(null);
            vm.validationsData = resp.data;
            vm.isSchemeDisabled = !vm.validationsData.smartSwapEnabled;
            vm.frequencyList = resp.data.frequency;
            vm.percentageList = resp.data.smartSwapAllowedPercentage;
          } else {
            cb('error');
            MessageService.error(resp.message);
            vm.validationsData = null;
          }
        },
        error = function (err) {
          vm.validationsData = null;
          cb('error');
          UtilService.errorHandler(err);
        };
      var payload= {
        folioNumber: vm.formData.folioNumber,
        transactionType: "SMART_SWAP",
        schemeCode: vm.formData.schemeCode
      }
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'smart_swap'
      }, payload).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      vm.validations = {};
      vm.unitsDetails = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      fetchSchemeValidations();
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            checkValidations();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "SMART_SWAP"
      }).$promise.then(success, error);
    }

    function selectedSwpType(transferOpt) {
      vm.formData.swpType = transferOpt;
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.formData.selectedDay = '';
      vm.formData.amount = '';
      vm.formData.selectedFrequency = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      resetDefaults();

      if (vm.formData.swpType == 'F') {
        vm.frequencyList = AppConstants.SWP_FREQ_LIST_FOR_FIXED;
        vm.formData.selectedFrequency = vm.frequencyList[0];
      } else {
        vm.frequencyList = AppConstants.SWP_FREQ_LIST_FOR_CAPITAL;
        vm.formData.selectedFrequency = vm.frequencyList[0];
      }
      fetchSchemes();
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.hasWarning){
              var successModal= function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg:resp.data.warningMessage}, successModal, errorModal)
            }
            else{
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType:'SMART_SWAP',
        folioNumber:vm.formData.folioNumber,
        schemeCode:vm.formData.schemeCode,
        amount: vm.formData.amount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    function submit() {
      var payload = {
        "amount": vm.formData.amount,
        "folioNumber": vm.formData.folioNumber,
        "formType": "SMART_SWAP",
        "frequency": vm.formData.selectedFrequency,
        "id": $stateParams.transactionId || "",
        "schemeCode": vm.formData.schemeCode,
        "startDate": vm.startDate.clone().format('DD-MMM-YYYY'),
        "swpDay": vm.formData.selectedDay,
        "percentage": vm.formData.percentage
      };

      vm.isSubmitted = true;
      var successSwpModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
          }
          // $state.go('main.dashboard');
        },
        errorSwpModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }

        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'SMART SWAP',
              investorName: vm.investorInfo.name
            }, successSwpModal, errorSwpModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };

      var _scheme = vm.schemes && vm.schemes.find(function (i) {
        return i.schemeCode == vm.formData.schemeCode;
      }) || {};
      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        schemeName: _scheme.schemeName,
        swpDay: vm.formData.selectedDay,
        frequency: vm.formData.selectedFrequency,
        mobileNumber : vm.mobileNumber ? vm.mobileNumber : '',
        emailId : vm.emailId ? vm.emailId : '',
        coperateFlag: vm.investorInfo.corporateFlag
      };
      ModalService.transactionReviewModal({payload: payload, controller: 'smart_swap', additionalData: additionalData}, success, error);
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? moment(vm.startDate) : moment();
      } else {
        // currentDay = moment();
        currentDay = vm.startMinDate?vm.startMinDate:moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });
    }

    function changeDay() {
      if (!vm.formData.selectedFrequency) {
        vm.startDate = null;
        vm.enabledStartDates = null;
        return;
      }

      switch (vm.formData.selectedFrequency.key) {
        case 'OM' :
        case 'Q':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          break;
      }
    }

    function changeStartDate(date) {
      vm.startDate = date ? date : null;
      //vm.sipDay = vm.startDate ? vm.startDate.format('D') : '';
      vm.formData.selectedDay = vm.startDate ? vm.startDate.format('D') : '';
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function checkValidations() {
      vm.isInvalidForm = false;
      if (!vm.validationsData) {
        vm.validations = {};
      }

      if (vm.validationsData) {
        vm.validations.isEnabled = vm.validationsData ? vm.validationsData.smartSwapEnabled : null;
        extractValidationObject(vm.validationsData);
      }
    }

    function resetDefaults() {
      vm.isReseting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = {};
      extractValidationObject(vm.validationsData);
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;
        var identifier = AuthService.getToken();
        if(identifier && identifier.loginType=='A'){
          $state.go('agent.home.distributor-home');
        } else{
          _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
        }
      };

      ModalService.confirmCancelModal({}, success);
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        vm.submit();
        e.preventDefault();
      }
      return false;
    };

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      vm.startDate = null;
      vm.formData.amount = '';
      vm.formData.selectedFrequency = null;
      vm.formData.percentage = null;
      vm.SwpForm.amount.$setPristine(false);
      vm.SwpForm.percentage.$setPristine(false);
      vm.SwpForm.scheme.$setPristine(false);
      vm.SwpForm.frequency.$setPristine(false);
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.folioNumber = null;
            vm.schemeCode.schemeCode = null;
            vm.unitsDetails = null;
            vm.startDate = null;
            vm.formData.amount = '';
            vm.formData.selectedFrequency = null;
            vm.formData.percentage = null;
            vm.SwpForm.$setPristine();
          }
        });
      }

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.hasFolioEmailId = false;
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);


    };

    function getSwpPayloadToSave() {
      var payload = {
        "amount": vm.formData.amount,
        "folioNumber": vm.formData.folioNumber,
        "formType": "SWP",
        "frequency": vm.formData.selectedFrequency?vm.formData.selectedFrequency.key:'',
        "id": $stateParams.transactionId || "",
        "schemeCode": vm.formData.schemeCode,
        "swpDay": vm.formData.selectedDay,
        "swpType": vm.formData.swpType
      };
      /*var payload = {
        "amount":1000,
        "folioNumber":"10301635",
        "formType":"SWP",
        "frequency":"OM",
        "id":"",
        "schemeCode":"44",
        "startDate":"02-Mar-2018",
        "swpDay":"2",
        "swpType":"F",
        "toDate":"02-Jan-2019",
        "approvalMode":"Online"
      }*/
      return angular.copy(payload);
    }
    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getSwpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'swp',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.formData.schemeCode) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });
    /*Socket code End*/

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionSipTopupController', initiateTransactionSipTopupController);

  /** @ngInject */
  function initiateTransactionSipTopupController($state, $timeout, $stateParams, UtilService, MessageService, LoaderService, SchemeService, ModalService, TransactionService, HDFC_API, AppConstants) {

    var vm = this;
    vm.init = init;
    var changeEndDate = changeEndDate;
    vm.capAmountChanged = capAmountChanged;
    vm.sipValidationsData = null;
    vm.formData = {topupDetails: {}};
    var sipData = $stateParams.transactionData;
    vm.investorInfo = sipData;
    vm.isminCapAmount = false;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;

    function init() {
      changeEndDate();
      vm.topupFrequencyList = [
        {key: 'Y', value: 'Yearly', monthfreq: 12},
        {key: 'H', value: 'Half Yearly', monthfreq: 6}
      ];
      vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;

      fetchSipSchemeValidations($stateParams.transactionData.schemeCode);
      vm.getTopupFrequencyList();
    }

    vm.getTopupFrequencyList = function () {
      var startDate = $stateParams.transactionData.startDate;
      var endDate = $stateParams.transactionData.endDate;
      var diffInMonths = parseInt(moment(endDate,"DD-MMM-YYYY").diff(moment(startDate,"DD-MMM-YYYY"), 'months', true));
      if (diffInMonths >= 12) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      } else if (diffInMonths < 12) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
      }
      if (vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if ($stateParams.transactionData.autoFrequency == 'Quarterly' && !vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      } else if (sipData.autoFrequency == 'Monthly') {
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
      }
      else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }
    }

    function changeEndDate() {
      //Sip-topup month count check
      var today = moment().format("DD-MMM-YYYY");
      var diffInMonths = parseInt(moment($stateParams.transactionData.endDate,"DD-MMM-YYYY").diff(moment($stateParams.transactionData.startDate,"DD-MMM-YYYY"), 'months', true));
      if (diffInMonths >= 12) {
        var capStartDate = moment($stateParams.transactionData.startDate, "MMM-YYYY").add(12, 'months').format("MMM-YYYY");
      }else{
        capStartDate = moment($stateParams.transactionData.startDate, "MMM-YYYY").add(6, 'months').format("MMM-YYYY");
      }
        vm.capDates = [];
        var capLastDate = capStartDate;

        while (!capLastDate || moment(capLastDate,"MMM-YYYY").isSameOrBefore(moment($stateParams.transactionData.endDate,"MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          capStartDate = moment(capStartDate,"MMM-YYYY").add(12, 'months').format("MMM-YYYY");
          if (moment(capStartDate,"MMM-YYYY").isSameOrBefore(moment($stateParams.transactionData.endDate,"MMM-YYYY"))) {

            vm.capDates.push(capStartDate);

          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
    };

    vm.changeTopUpFreq = function () {
      var today = moment().format("DD-MMM-YYYY");
      var duration = 6;
      switch (vm.formData.topupDetails.frequency) {
        case 'H':
          duration = 6;
          break;
        case 'Y':
          duration = 12;
          break;
      }

      if(duration == 12){
        var capStartDate = moment($stateParams.transactionData.startDate,"DD-MMM-YYYY").add(12, 'months').format("MMM-YYYY");
      }else{
        capStartDate = moment($stateParams.transactionData.startDate, "DD-MMM-YYYY").add(6, 'months').format("MMM-YYYY");
      }
      vm.capDates = [];
      var capLastDate = capStartDate;
      while (!capLastDate || moment(capLastDate,"MMM-YYYY").isBefore(moment($stateParams.transactionData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = moment(capStartDate,"MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
        if (moment(capStartDate,"MMM-YYYY").isBefore(moment($stateParams.transactionData.endDate,"MMM-YYYY"))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
    }

    function fetchSipSchemeValidations(schemeCode) {
      vm.sipValidationsData = null;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.sipValidationsData = resp.data;
          } else {
            MessageService.error(resp.message);
            vm.sipValidationsData = null;
          }
        },
        error = function () {
          vm.sipValidationsData = null;
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'sip',
        child1: schemeCode,
        child2: sipData.folioNumber
      }, null).$promise.then(success, error);
    }

    vm.changeTopupAmount = function (sipTopupForm) {
      vm.isMinTopupAmount = vm.sipValidationsData && vm.sipValidationsData.topupMinAmt > vm.formData.topupDetails.amount;
      if (vm.formData.topupDetails.amount < vm.sipValidationsData.topupMinAmt) {
        sipTopupForm.$invalid = true;
      }

      vm.isMultipleTopupAmount = vm.sipValidationsData.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.sipValidationsData.topupAmtMultples === 0) || false;
      if (vm.sipValidationsData.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.sipValidationsData.topupAmtMultples !== 0)) {
        sipTopupForm.$invalid = true;
      }

      if(vm.formData.topupDetails.amount >= 2000000){
        vm.amountExceeded = true;
      }else{
        vm.amountExceeded = false;
      }

    };

    vm.changeTopupPercentage = function (sipTopupForm) {
      vm.isMinTopupPercentage = vm.sipValidationsData && vm.sipValidationsData.topupMinPercentage > vm.formData.topupDetails.percentage;
      if (vm.formData.topupDetails.percentage < vm.sipValidationsData.topupMinPercentage) {
        sipTopupForm.$invalid = true;
      }

      vm.isMultipleTopupPercentage = vm.sipValidationsData.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.sipValidationsData.topupPercentageMultples === 0) || false;
      if (vm.sipValidationsData.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.sipValidationsData.topupPercentageMultples === 0) || false) {
        sipTopupForm.$invalid = true;
      }

    };

    vm.submitTopupForm = function () {
      var topupFrequency = '';
      if (sipData.autoFrequency === "Monthly") {
        topupFrequency = 'OM'
      }
      else if (sipData.autoFrequency === "Half Yearly") {
        topupFrequency = 'H'
      }else if(sipData.autoFrequency === "Quarterly"){
        topupFrequency = 'Q'
      }

      var topupPayload = {
        uuid: null,
        investorUuid: sipData.investorId,
        transactionId: sipData.transactionID,
        folioNumber: sipData.folioNumber,
        schemeCode: sipData.schemeCode,
        amount: sipData.amount,
        frequency: topupFrequency,
        topupAmount: vm.formData.topupDetails.amount,
        topupPercentage: vm.formData.topupDetails.percentage,
        topupFrequency: vm.formData.topupDetails.frequency,
        topupCapAmount: vm.formData.topupDetails.capAmount,
        topupCapMonthYear: moment(vm.formData.topupDetails.capMonthYear,"MMM-YYYY").format('DD-MMM-YYYY'),
        toDate: sipData.endDate,
        bankDetailsForECS: {
          accType: "",
          accNumber: "",
          ifscCode: "",
          neftCode: "",
          bankName: "",
          branchName: "",
          bankCity: "",
          paymentOption: "",
          payoutId: ""
        }
      }
      if (topupPayload.topupCapAmount) {
        topupPayload.topupCapMonthYear = undefined;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

          var successSipTopupModal = function () {
              $state.go("main.dashboard")
            },
            errorSipTopupModal = function () {

            }

          ModalService.initiateSuccessModal({
            transactionType: 'Sip-Topup',
            investorName: sipData.name
          }, successSipTopupModal, errorSipTopupModal);
        }
        else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'existing',
        child2: 'sip',
        child3: 'topup',
        uniqueLink: 'initiate'
      }, topupPayload).$promise.then(success, error);
    }

    function capAmountChanged(sipTopupForm) {
      if (vm.formData.topupDetails.amount) {
        vm.minCapAmount = sipData.amount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage) {
        vm.minCapAmount = sipData.amount + (vm.formData.topupDetails.percentage * sipData.amount / 100)
      }


      if (vm.formData.topupDetails.capAmount < vm.minCapAmount) {
        vm.isminCapAmount = true
        $timeout(function () {
          if(vm.formData.topupDetails.capAmount !== null) {
            sipTopupForm.$invalid = true;
          }
        })
      }
      else {
        vm.isminCapAmount = false
      }
    }


    vm.confirmCancel = function () {
      var success = function () {
        $state.go('main.sipcorner')
      };
      ModalService.confirmCancelModal({}, success);
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipCancel', SipCancel);

  /** @ngInject */
  function SipCancel($window, LoaderService,  MessageService, $state, ModalService, UtilService, AppConstants , TransactionService, HDFC_API, InvestorServiceDynamicData , dynamicData) {
    var vm = this;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.showNudgeReasons = showNudgeReasons;
    vm.confirmCancelTransaction = confirmCancelTransaction;
    vm.NoteSipCancel = dynamicData.noteDTO.noteDTOMap.Note_SIP_Cancel;
    init();

    function init() {
      vm.summaryDetails = $window.JSON.parse(localStorage.getItem('summaryDetailsSipCancel'));
      switch (vm.summaryDetails.transactionType) {
        case 'SIP':
          vm.tncType = 'SIP'
          break
        case 'DREAMSIP':
          vm.tncType = 'DREAM SIP'
          break
        case 'FLEXSIP':
          vm.tncType ='Flex SIP'
          break
      }
      // localStorage.removeItem("summaryDetailsSipCancel");
    }

    function confirmCancelTransaction () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            resp.data.txnType = vm.summaryDetails.transactionType;
            ModalService.systematicCancellation(resp);
          } else {
            MessageService.error(resp.message);
          }
        },

        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }

      var payload = {
        transactionId: vm.summaryDetails.transactionId,
        transactionType: vm.summaryDetails.transactionType,
        folioNumber: vm.summaryDetails.folioNumber,
        amount: vm.summaryDetails.amount,
        frequency: vm.summaryDetails.frequency,
        schemeCode: vm.summaryDetails.schemeCode
      }

        LoaderService.showLoader();
        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'systematic',
          child2: 'cancel'
        }, payload).$promise.then(success, error);
    }

    function showNudgeReasons() {

      var success = function(resp) {
          if(resp.status && resp.data) {

            if (angular.isDefined(resp.data.popUpDescriptionList.SIP_CANCELLATION_NUDGE_REASONS)) {
              var nudgeData = {};
              nudgeData.nudgePopupData = resp.data.popUpDescriptionList.SIP_CANCELLATION_NUDGE_REASONS;
              nudgeData.reasonsList = nudgeData.nudgePopupData.reasonsList;

              var payload = {
                transactionId: vm.summaryDetails.transactionId,
                transactionType: vm.summaryDetails.transactionType,
                folioNumber: vm.summaryDetails.folioNumber,
                amount: vm.summaryDetails.amount,
                frequency: vm.summaryDetails.frequency,
                schemeCode: vm.summaryDetails.schemeCode
              }

              var text = 'Please let us know the reason for Cancelling ' + vm.tncType  + ' :' ;
              ModalService.showNudgeReasons({Text: text, payload:payload, transactionType: vm.summaryDetails.transactionType, buttonProceed:true, nudgeData:nudgeData,approveRequest : false});
            } else {
              confirmCancelTransaction();
            }
          }
          else {
            MessageService.error("Something went wrong");
          }

        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorServiceDynamicData.get({
        child1: 'nudge',
        child2: 'sip',
        child3: 'popup'
      }).$promise.then(success, error);

    }
  }
})();

/**
 * Created by ttn on 22/11/16.
 */

 (function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionSipPurchaseController', initiateTransactionSipController);

  /** @ngInject */
  function initiateTransactionSipController($state, $stateParams, $scope, $rootScope, $window, DistributorFileUploadService,
                                            AuthService, $timeout, InvestorModel,
                                            MessageService, UtilService, InvestorsService,
                                            TransactionInitiateModel, AppConstants, ModalService, moment,
                                            LoaderService, SchemeService, TransactionService, HDFC_API,
                                            $log, AgentSocketService, InvestorsCommonService, BillJunctionService , InvestorCommonServiceVersion2 , dynamicDataPurchase , dynamicDataSip,panAdharLinkingService ) {
    var vm = this;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.startDate = null;
    vm.enabledStartDates = [];
    vm.endDate = null;
    vm.sipDay = null;
    vm.enabledEndDates = [];
    vm.investorUUID = $stateParams.uuid;
    vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
    vm.sipPayload = TransactionInitiateModel.getSipPayload() || TransactionInitiateModel.getSipDataModel();
    vm.purchasePayload = TransactionInitiateModel.getPurchasePayload() || TransactionInitiateModel.getPurchaseDataModel();
    vm.investorPayload = TransactionInitiateModel.getInvestorPayload();
    vm.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.EUIN_OPTED = AppConstants.EUIN_OPTED;
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.SIP_FREQ_LIST = AppConstants.Dynamic_SIP_FREQ_LIST;
    vm.SIP_END_DATE_OPTIONS = AppConstants.SIP_END_DATE_OPTIONS;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.PAYMENT_MODE = angular.copy(AppConstants.PAYMENT_MODE);
    vm.SIP_PAYMENT_MODE = AppConstants.SIP_PAYMENT_MODE;
    vm.newFolioClickAction = newFolioClickAction;
    vm.isMinPurchaseAmount = false;
    vm.isOtmLimitLess = false;
    vm.otmLimitvalidation = false;
    vm.endDateValidation = false;
    vm.fiendDateValidation=false;
    vm.startDateValidation = false;
    vm.startDateValidationForFi = false;
    vm.otmBankList = null;
    vm.purchaseValidations = null;
    vm.isSubmitted = false;
    vm.sipValidationsData = null;
    vm.sipValidations = null;
    vm.daysList = AppConstants.SIP_DAYS_LIST;
    vm.startDateFormat = 'DD-MMM-YYYY';
    // vm.startDateFlag = true;
    // vm.startMinDateBiller = moment().add(33, 'days');
    // vm.defaultStartDateSIP = angular.copy(vm.startMinDateBiller);
    /*30(valid day gap)+3(buffer day added)*/
    vm.startMaxDate = moment().add(350, 'days');
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.isCheckedTandC = false;
    vm.isSelectedInScheme = true;
    vm.termsAndContitions = termsAndContitions;
    vm.checkValidScheme = checkValidScheme;
    vm.changeSipTopupSelected = changeSipTopupSelected;
    vm.capAmountChanged = capAmountChanged;
    vm.checkUPIForSipWithFI = checkUPIForSipWithFI;
    vm.showTopUpBlock = false;
    vm.sipTopupSelected = false;
    vm.formData.topupDetails = {};
    vm.hideTopupPercentage = false;
    vm.topupQuarterCheck = false;
    vm.isminCapAmount = false;
    vm.isEmailinValid = false;
    vm.isMobileinValid = false;
    vm.isEmailMobileinValid = false;
    vm.emandateDisplay = true;
    vm.emailMobileValidation = emailMobileValidation;
    vm.isEmandateEnabled = false;
    vm.fromInvestorDetail = false;
    vm.weeklyDaysList=null;
    vm.minEndDate = new Date();
    vm.changeInstallments = changeInstallments;
    var identifier = AuthService.getToken();
    vm.loginType = identifier.loginType;
    var _isSelectingFromDropDown = false;
    vm.isMultiples = false;
    vm.hideOtmRadio = false;
    vm.tpv = tpv;
    vm.invalidAmount = false;
    vm.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.fetchEmailMobile = fetchEmailMobile;
    vm.email = '';
    vm.mobile = '';
    vm.upiErrorMessage = '';
    vm.upiAmountLimit = '';
    vm.upiBankList = null;
    vm.upiNoBankError = '';
    // getDateValidation(); //no by defalut api sud be called
    vm.corporateFlag = false;
    vm.sipFirstInstallmentAmount = AppConstants.SIP_WITH_FI.SUGGESTED_AMOUNT;
    vm.changeFirstInstallment = changeFirstInstallment;
    vm.formData.sipFirstInstallment = false;
    vm.sipFirstInstallmentPaymentMode =  AppConstants.SIP_WITH_FI.PAYMENT_MODE;
    vm.paymentNavUrl = function ($event) {
      $event.preventDefault();
      $window.open(vm.paymentNavURL);
    };
    vm.modalDataPurchase = dynamicDataPurchase;
    vm.modalDataSip = dynamicDataSip;
    vm.fiOtmLimitvalidation=false;

    vm.dynamicNoteNetBanking = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.dynamicNoteHdfc =  vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_HDFC_Fund_Transfer;
    vm.dynamicNoteNeft = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_NEFT_RTGS;
    vm.dynamicNoteOtm = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_OTM;
    vm.dynamicNoteUpi = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_UPI;
    vm.dynamicDataPopupMinorPurchase = vm.modalDataPurchase.popupDTO.popupDTOMap.Popup_MINOR_PURCHASE;

    vm.dynamicNoteOtmSip = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_OTM;
    vm.dynamicNoteStandard = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_STANDARD;
    vm.dynamicNoteEotm = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_eOTM;
    vm.dynamicDataPopupMinorSip = vm.modalDataSip.popupDTO.popupDTOMap.Popup_MINOR_SIP;
    vm.dynamicNoteSIWEB= vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_SI_FI_NETBANKING;
    vm.dynamicNoteSIOTM= vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_SI_FI_OTM;
    vm.dynamicNoteOTMWEB= vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_OTM_FI_NETBANKING;
    vm.dynamicNoteOTMOTM= vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_OTM_FI_OTM;
    vm.dynamicDataMinorBank = vm.modalDataSip.popupDTO.popupDTOMap;
    vm.dynamicDataForFIUPI = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_FI_UPI;
    vm.dynamicNoteSIPUPI = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_UPI;
    vm.termsConditionData = null;
    vm.showTerms = true;
    if($stateParams.amount && $stateParams.fromRenew){
      vm.sipRenewAmount= true;
    }
    vm.checkFolio=false;
    vm.appConstants = AppConstants;
    vm.modifiedSipDetails = false;
    vm.sipPurchaseForm = {};
    vm.modifySipData = null;
    vm.dateNotModified = false;
    vm.panDetailsNotVerified = false;
    vm.topupDetailsInvalid = false;
    vm.schemeChangeCheck = false;
    vm.isSipAmountModified = false;
    vm.showEcartModel = false;
    vm.sidebarTitle = 'CART_DETAILS';
    vm.showAddCart = true;
    vm.checkFromState = $stateParams;
    vm.isFromInitiateSipPurchase = false;
    vm.sipPurchaseAddToCart = sipPurchaseAddToCart;
    vm.closeAction = closeAction;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.formData.emandateWord = {};
    vm.handleMandateCalender = handleMandateCalender;
    vm.UpiSelectedFI = false;
    vm.changeEotmNotes = changeEotmNotes;
    vm.topUpDetailsUpdated = false;
    vm.changeTopUpDetails = changeTopUpDetails;
    vm.fromQuickSip = $stateParams.fromQuickSip;
    vm.setQuickSipPaymentOptionsAndBank = setQuickSipPaymentOptionsAndBank;
    vm.paymentOptionOrdering = paymentOptionOrdering;
    vm.checkUpiError = checkUpiError;
    var euinDataFromQuickSip = JSON.parse(sessionStorage.getItem('eData'));

    // removed euin data if exist when journey is not from quick sip flow
    if (!vm.fromQuickSip && euinDataFromQuickSip) {
      sessionStorage.removeItem('eData');
    }
    vm.isModifySip = false;

    function tpv() {
      ModalService.tpvModal({});
    }
    function getTaxStatusList(minor) {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusList = resp.data.taxStatus;
        } else {
          vm.taxStatusList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.taxStatusList = null;
        UtilService.errorHandler(err);
      };
      vm.taxStatusList = null;
      InvestorsService.post({controller: 'tax-status'}, {taxStatusFilter: minor ? 'MINOR' : 'ADULT'}).$promise.then(success, error);
    }

    function fetchPurchaseEnabledSchemes() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterPurchaseInSchemeList = resp.data.schemeList;
          if (vm.purchasePayload && vm.purchasePayload.schemeCode && vm.masterPurchaseInSchemeList.length) {
            var result = vm.masterPurchaseInSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.purchasePayload.schemeCode;
            });
            vm.purchaseScheme = result && result.scheme || null;
            vm.formData.inSchemeName = result.scheme;
            vm.formData.schemeType = result.schemeType;
            fetchPurchaseSchemeValidations(vm.purchasePayload.schemeCode);
          }

          if ($stateParams.schemeCode && vm.fromInvestorDetail) {
            var selectedScheme = vm.masterPurchaseInSchemeList.find(function (scheme) {
              return scheme.schemeCode === ($stateParams.schemeCode || vm.purchasePayload.schemeCode);
            });
            vm.formData.inSchemeName = selectedScheme.scheme;
            vm.formData.schemeType = selectedScheme.schemeType;
            vm.formData.inSchemeCode = selectedScheme.schemeCode;
            vm.purchaseInSchemeChanged(selectedScheme);
            vm.formData.schemeType = selectedScheme.schemeType;
            fetchPurchaseSchemeValidations(selectedScheme.schemeCode);
            vm.fromInvestorDetail = false;
          }else if($stateParams.schemeCode){
            var selectedScheme = vm.masterPurchaseInSchemeList.find(function (scheme) {
              return scheme.schemeCode === ($stateParams.schemeCode || vm.purchasePayload.schemeCode);
            });
            if(selectedScheme){
              vm.formData.inSchemeName = selectedScheme.scheme;
              vm.formData.schemeType = selectedScheme.schemeType;
              vm.formData.inSchemeCode = selectedScheme.schemeCode;
              vm.purchaseInSchemeChanged(selectedScheme);
              vm.formData.schemeType = selectedScheme.schemeType;
              fetchPurchaseSchemeValidations(selectedScheme.schemeCode);
            }
          }

          vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.purchaseScheme);
        } else {
          vm.masterPurchaseInSchemeList = null;
          vm.purchaseInSchemeList = null;
          vm.purchaseScheme = null;
          vm.formData.schemeType = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.masterPurchaseInSchemeList = null;
        vm.purchaseInSchemeList = null;
        vm.purchaseScheme = null;
        vm.formData.schemeType = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'purchaseenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, null).$promise.then(success, error);
    }

    function fetchSipEnabledSchemes() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterSipSchemeList = resp.data.schemeList;
          if (vm.sipPayload && vm.sipPayload.schemeCode && vm.masterSipSchemeList.length) {
            var result = vm.masterSipSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.sipPayload.schemeCode;
            });

            vm.sipScheme = result && result.scheme || null;
            vm.formData.inSchemeName = vm.sipScheme;
            fetchSipSchemeValidations(vm.sipPayload.schemeCode);
          }
          if ($stateParams.schemeCode || ($stateParams.fromModify && vm.modifySipData && !vm.modifiedSipDetails)) {
            var selectedScheme = vm.masterSipSchemeList.find(function (scheme) {
              if(vm.modifySipData){
                return  scheme.schemeCode === vm.modifySipData.schemeCode;
              }else{
                return scheme.schemeCode === $stateParams.schemeCode;
              }
            });
            if(selectedScheme){
              vm.formData.inSchemeName = selectedScheme.scheme;
              vm.formData.inSchemeCode = selectedScheme.schemeCode;
              vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(selectedScheme, vm.selectedFolioData);
              if (vm.showRetirementSchemeError) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.inSchemeName = null;
                vm.filterSipSchemeList();
                return;
              }
            }
            vm.getEmandateBankList(function () {
              vm.changeFrequency();
              if($stateParams.fromModify && vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && !vm.defaultPaymentMode){
                var selectedPaymentMode = vm.PAYMENT_MODE.find(function (el) {
                  return el.key == vm.modifySipData.paymentOption[0].code;
                })
                if(selectedPaymentMode){
                  vm.formData.paymentMode = selectedPaymentMode;
                }else{

                  if ($stateParams.fromQuickSip && $stateParams.schemeCode) {
                    vm.setQuickSipPaymentOptionsAndBank();
                  } else {
                    vm.formData.paymentMode = vm.PAYMENT_MODE[0];
                  }
                }
                // vm.formData.paymentMode = selectedPaymentMode ? selectedPaymentMode : vm.PAYMENT_MODE[0];
                if($stateParams.fromModify && vm.modifySipData){
                  if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM'){
                    vm.formData.otmBank = vm.modifySipData.folioBankDetails && vm.otmBankList && vm.otmBankList.find(function (bank) {
                      return bank.omUmrn === vm.modifySipData.folioBankDetails.omUmrn;
                    });
                    vm.changeOtmbank();
                  }
                }
                if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'HEM'){
                  vm.formData.eMandateBank = vm.modifySipData.folioBankDetails && vm.eMandateBankList && vm.eMandateBankList.find(function (bank) {
                    return bank.accountNumber === vm.modifySipData.folioBankDetails.bankAcNo;
                  });
                  if(vm.formData.eMandateBank){
                    vm.defaultPaymentMode = true;
                    vm.changeEMandateBank();
                  }
                }
                if(vm.formData.fiPaymentMode && vm.formData.fiPaymentMode.key == "OTM" && vm.modifySipData.firstInstallmentDetails){
                  vm.formData.fiOtmBank = vm.otmBankList && vm.otmBankList.find(function (bank) {
                    return bank.omUmrn === vm.modifySipData.firstInstallmentDetails.omUmrn;
                  });
                  vm.changeOtmbank();
                }
              }
            });
            if(selectedScheme){
              fetchSipSchemeValidations(selectedScheme.schemeCode);
            }
            fetchBankListForSipUpi();
          }

          vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
        } else {
          vm.sipSchemeList = null;
          vm.masterSipSchemeList = null;
          vm.sipScheme = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.sipSchemeList = null;
        vm.masterSipSchemeList = null;
        vm.sipScheme = null;
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'sipenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, null).$promise.then(success, error);
    }

    function getInvestorInfo(cb) {
      var payload = {"investorUUID": vm.investorUUID};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          vm.corporateFlag = vm.investorInfo.corporateFlag;
          getTaxStatusList(vm.investorInfo && vm.investorInfo.minor);
          cb(true);
          if($stateParams.schemeCode || ($stateParams.fromModify && vm.modifySipData && !vm.modifiedSipDetails))
          {
            if ($stateParams.transactionType == 'SIP' || ($stateParams.fromModify && vm.modifySipData && vm.modifySipData.type == "SIP")) { //this will be called on folio selection
              fetchSipEnabledSchemes();
            }
            else {
              fetchPurchaseEnabledSchemes();
            }
          }
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        //setDefaults();
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function fetchFolioList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.folioList = resp.data.folioList || [];
          if ($stateParams.folioNumber) {

            if (vm.fromQuickSip) {
              var initialFolio = sessionStorage.getItem('initialFolioSetQS');
              var isNewFolioSet = sessionStorage.getItem('isNewFolioSet');

              if (!initialFolio) {
                vm.folioNumber = $stateParams.folioNumber;
              } else {
                if (initialFolio && isNewFolioSet) {
                  vm.folioNumber = initialFolio;
                } else if (initialFolio && !isNewFolioSet) {
                  vm.folioNumber = $stateParams.folioNumber;
                  sessionStorage.setItem('isNewFolioSet',true);
                }
              }
            } else {
              vm.folioNumber = $stateParams.folioNumber;
            }
          }else if($stateParams.fromModify && vm.modifySipData){
            vm.folioNumber = vm.modifySipData.folioNumber ? vm.modifySipData.folioNumber : null;
          } else {
            var activeFolioList = vm.folioList.filter(function(folio){
              return folio.activeFlag === true;
            });
            vm.folioNumber = activeFolioList[0].folioNumber;
          }
          vm.formData.folioNumber = vm.folioNumber;
          if(vm.formData.folioNumber && vm.checkFolio){
            $timeout(function() {
              vm.changeFolio();
            }, 0);
          }
        } else {
          vm.folioList = null;
          vm.folioNumber = '';
          vm.sipPayload.folioNumber = vm.folioNumber;
          vm.purchasePayload.folioNumber = vm.folioNumber;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.folioList = null;
        vm.folioNumber = '';
        vm.sipPayload.folioNumber = vm.folioNumber;
        vm.purchasePayload.folioNumber = vm.folioNumber;
        UtilService.errorHandler(err);
      };

      InvestorsService.post({controller: 'folioList'}, {investorUUID: vm.investorUUID}).$promise.then(success, error);
    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
          vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
          vm.formData.euinName = vm.euinNameSelected;
          if($stateParams.fromModify && vm.modifySipData){
            vm.formData.euinCode = vm.modifySipData.euinCode ? vm.modifySipData.euinCode : null;
            vm.euinNameSelected = vm.modifySipData.euinName ? vm.modifySipData.euinName : null;
          }

          // setting euin field when redirected from quick sip review
          if (vm.fromQuickSip && euinDataFromQuickSip) {
            vm.formData.euinCode = angular.copy(euinDataFromQuickSip.euinCode);
          }

        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function folioInit() {
      fetchFolioList();
    }

    function fetchPurchaseSchemeValidations(schemeCode) {
      vm.purchaseValidations = null;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.purchaseValidations = resp.data;
            vm.upiErrorMessage = vm.purchaseValidations.upiMaxAmountErrMessage;
            vm.upiAmountLimit = vm.purchaseValidations.upiMaxAmountLimit;
            if(vm.purchaseValidations && vm.formData.minorFlag){
              vm.purchaseValidations.cgfFlag = vm.purchaseValidations.cgfFlag ? vm.purchaseValidations.cgfFlag : true;
            }
            vm.formData.cgfFlag=vm.purchaseValidations.cgfFlag;
            vm.formData.purchaseInvestmentOption = vm.purchaseValidations.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.purchaseInvestmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.purchaseInvestmentOption || AppConstants.TRANSACTION.DIVIDEND);
            if (vm.purchaseValidations.isGrowth) {
              vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
            } else {

              if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false) {
                vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
              } else if (vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
                vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              } else if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
                vm.formData.purchaseDividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              }

            }
            if($stateParams.transactionType === "PURCHASE"){
              if(vm.purchaseValidations.schemeType === AppConstants.LIQUID){
                vm.PAYMENT_MODE = angular.copy(AppConstants.PAYMENT_MODE);
              }else{
                vm.PAYMENT_MODE = angular.copy(PAYMENT_MODE_AT_FOLIO);
              }
              if($stateParams.amount){
                vm.formData.purchaseAmount = $stateParams.amount ? parseInt($stateParams.amount) : null;
                if(vm.formData.purchaseAmount){
                  $window.NumToWord(vm.formData.purchaseAmount, 'divDisplayWords392');
                }
                vm.changePurchaseAmount(vm.sipPurchaseForm);
              }
            }
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
          } else {
            MessageService.error(resp.message);
            vm.purchaseValidations = null;
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.purchaseInvestmentOption = AppConstants.TRANSACTION.GROWTH;
          }
          if (vm.selectedSchemeType == 'ELSS' && !vm.purchaseValidations.isGrowth) {
            vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
          }
        },
        error = function (err) {
          vm.purchaseValidations = null;
          if (vm.selectedSchemeType == 'ELSS' && !vm.purchaseValidations.isGrowth) {
            vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
          }
          else {
            vm.formData.purchaseDividendOption = vm.formData.purchaseDividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
          }
          vm.formData.purchaseInvestmentOption = AppConstants.TRANSACTION.GROWTH;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'purchase',
        child1: schemeCode,
        child2: vm.formData && vm.formData.folioNumber || 0
      }, null).$promise.then(success, error);
    }

    function fetchSipSchemeValidations(schemeCode) {
      vm.sipValidationsData = null;
      //vm.sipPayload.frequency = vm.selectedFrequency.code;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.sipValidationsData = resp.data;
            if(vm.sipValidationsData && vm.formData.minorFlag){
              vm.sipValidationsData.cgfFlag = vm.sipValidationsData.cgfFlag ? vm.sipValidationsData.cgfFlag : true;
            }
            vm.upiErrorMessageForSIP = vm.sipValidationsData.upiMaxAmountErrMessage ? vm.sipValidationsData.upiMaxAmountErrMessage : "Unified Payments Interface (UPI) transaction limit as per NPCI is Rs. 1 lakh per transaction, while your purchase transaction amount is more than Rs. 1 lakh. Please select other payment mode to proceed.";
            vm.upiAmountLimitForSIP = vm.sipValidationsData.upiMaxAmountLimit ? vm.sipValidationsData.upiMaxAmountLimit : 100000;
            vm.SIP_FREQ_LIST = vm.sipValidationsData.additionalValidation.frequency?vm.sipValidationsData.additionalValidation.frequency:null;
            if(vm.SIP_FREQ_LIST.length == 0){
              vm.PAYMENT_MODE=[];
              vm.formData.paymentMode=null;
            }
            var frequency = vm.SIP_FREQ_LIST.find(function (d) {
              return d.code === 'OM';
            }) || {};
            vm.selectedFrequency = frequency?frequency:'';
            if($stateParams.frequency || ($stateParams.fromModify && vm.modifySipData && !vm.modifiedSipDetails)){
              var freq = vm.SIP_FREQ_LIST.find(function (d) {
                if($stateParams.frequency === "Business Days(BZ)"){
                  return d.code === 'BZ';
                }else if(vm.modifySipData && !vm.modifiedSipDetails){
                  return d.name === vm.modifySipData.autoFrequency;
                } else {
                  return d.name === $stateParams.frequency;
                }
              }) || {};
              vm.selectedFrequency = freq?freq:'';
            }
            vm.changeFrequency();
            vm.formData.cgfFlag = vm.sipValidationsData.cgfFlag;
            vm.formData.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
            // vm.formData.dividendOption = vm.sipValidationsData.isGrowth ? vm.DIVIDEND_OPTIONS.GROWTH : (vm.formData.dividendOption !== vm.DIVIDEND_OPTIONS.GROWTH && vm.formData.dividendOption) || (vm.sipValidationsData.endingType === vm.ENDING_TYPES.CLOSED ? vm.DIVIDEND_OPTIONS.PAYOUT : vm.DIVIDEND_OPTIONS.REINVEST);
            if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.dividendOption && !vm.modifiedSipDetails){
              if(vm.modifySipData.growth){
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
              }else {
                if(vm.modifySipData.dividendOption && vm.modifySipData.dividendOption == 'Y'){
                  vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
                }else if(vm.modifySipData.dividendOption && vm.modifySipData.dividendOption == 'N') {
                  vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
                }
              }
            }else {
            if (vm.sipValidationsData.isGrowth) {
              vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
            } else {

              if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === false) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
              } else if (vm.sipValidationsData.dividendPayoutApplicable === false && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              } else if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              }

            }
            }
            extractSipValidationObject(resp.data, vm.selectedFrequency);
            vm.sipFirstInstallmentAmount = resp.data.amountArray;
            vm.setOtmData();
          } else {
            MessageService.error(resp.message);
            vm.sipValidationsData = null;
            vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
          }
          /*if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
            vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
          }*/
        },
        error = function (err) {
          vm.sipValidationsData = null;
          if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
            vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
          }
          else {
            vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
          }
          vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'sip',
        child1: schemeCode
        //  child2: vm.formData.folioNumber
      }, null).$promise.then(success, error);
    }

    function getPurchasePayload() {
      var purchasePayload = {};
      purchasePayload.amount = vm.formData.purchaseAmount;
      purchasePayload.dividendOption = vm.formData.purchaseDividendOption;
      purchasePayload.folioNumber = vm.formData.folioNumber;
      purchasePayload.formType = vm.formData.investmentType;
      purchasePayload.schemeCode = vm.formData.inSchemeCode;
      purchasePayload.schemeType = vm.formData.schemeType;
      purchasePayload.investmentOption = vm.formData.purchaseInvestmentOption;
      if (vm.formData.euinOpted === vm.EUIN_OPTED.YES && !vm.oversea_arn) {
        purchasePayload.euinOpted = vm.EUIN_OPTED.YES;
        purchasePayload.euinName = vm.euinName ? vm.euinName : vm.euinNameSelected;
        purchasePayload.euinCode = vm.formData.euinCode;
      } else {
        vm.formData.euinOpted = vm.EUIN_OPTED.NO;
      }
      purchasePayload.checkedNfoAutoSwitch = vm.formData.isAutoSwitch,
        purchasePayload.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.selectedInSchemeCode : null,
        purchasePayload.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null

      if (vm.formData.retirementAgeProofURL) {
        purchasePayload.retirementAgeProofURL = vm.formData.retirementAgeProofURL;
      }
      purchasePayload.payMech = vm.formData.paymentMode.key;
      if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
        purchasePayload.payoutId = vm.formData.otmBank.payoutId;
        purchasePayload.omUmrn = vm.formData.otmBank.omUmrn;
        purchasePayload.camsMandateIdNo = vm.formData.otmBank.camsMandateIdNo;
      }
      if(vm.formData.subBrokerARN){
        purchasePayload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        purchasePayload.subBrokerCode = vm.formData.subBrokerCode;
      }
      return purchasePayload;
    }

    function getSipPayload() {
      var sipPayload = {
        "installmentAmount": vm.formData.installmentAmount,
        "investmentOption": vm.formData.investmentOption,
        "dividendOption": vm.formData.dividendOption,
        "formType": "SIP",
        "frequency": vm.selectedFrequency.code,
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.inSchemeCode,
        "schemeType": vm.formData.schemeType,
        "sipDay": vm.formData.sipDay,
        "sipTopupEnabled": vm.formData.sipTopupSelected,
        "topupDetails": vm.formData.topupDetails
      }
      if (vm.formData.eMandateBank) {
        sipPayload['bankDetailsForECS'] = {
          "accNumber": vm.formData.eMandateBank.accountNumber,
          "accType": vm.formData.eMandateBank.bankAcType,
          "authenticationMode": vm.authMode.value,
          "bankCity": vm.formData.eMandateBank.bankCity,
          "bankCode": vm.formData.eMandateBank.bankCode,
          "bankName": vm.formData.eMandateBank.bankName,
          "branchName": vm.formData.eMandateBank.bankBranch,
          "gateWayVendor": vm.formData.eMandateBank.gateWayVendor,
          "ifscCode": vm.formData.eMandateBank.ifscCode,
          "paymentOption": vm.formData.paymentMode.key
        }
        sipPayload.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
        sipPayload.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
        sipPayload.authenticationMode = vm.authMode.value;
        sipPayload.mandateAmount = vm.formData.emandateAmount;
      }
      try {
        sipPayload.toDate = vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '';
        sipPayload.sipDate = vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '';
      } catch (e) {
        sipPayload.toDate = null;
        sipPayload.sipDate = null;
      }


      if (vm.formData.euinOpted === vm.EUIN_OPTED.YES && !vm.oversea_arn) {
        sipPayload.euinName = vm.euinNameSelected;
        sipPayload.euinCode = vm.formData.euinCode;
      }
      if (vm.formData.retirementAgeProofURL) {
        sipPayload.retirementAgeProofURL = vm.formData.retirementAgeProofURL;
      }
      sipPayload.payMech = vm.formData.paymentMode.key === "UPI" ? "UAP" : vm.formData.paymentMode.key;
      if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
        sipPayload.payoutId = vm.formData.otmBank.payoutId;
        sipPayload.omUmrn = vm.formData.otmBank.omUmrn;
        sipPayload.camsMandateIdNo = vm.formData.otmBank.camsMandateIdNo;
      }
      if ($stateParams.txnId) {
        sipPayload.oldTransactionId = $stateParams.txnId;
      }
      if(vm.selectedFrequency.code === 'OW'){
        sipPayload.weeklyDay = vm.formData.weeklyDay;
      }
      if (vm.formData.sipFirstInstallment) {
        sipPayload.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
        sipPayload.firstInstallmentDetails = {};
        if (vm.formData.fiPaymentMode.key === 'WEB') {
          sipPayload.firstInstallmentDetails.paymentMode = vm.formData.fiPaymentMode.key;
        } else if (vm.formData.fiPaymentMode.key === 'OTM') {
          sipPayload.firstInstallmentDetails.paymentMode = vm.formData.fiPaymentMode.key;
          sipPayload.firstInstallmentDetails.payoutId = vm.formData.fiOtmBank.payoutId;
          sipPayload.firstInstallmentDetails.omUmrn = vm.formData.fiOtmBank.omUmrn;
        } else if (vm.formData.fiPaymentMode.key === 'UPI') {
          sipPayload.firstInstallmentDetails.paymentMode = vm.formData.fiPaymentMode.key ? 'UAP': '';
        }
      }

      // setting payload key when initiated via quick sip flow
      if (vm.fromQuickSip) {
        sipPayload.quickSip = true;
      }

      if(vm.formData.subBrokerARN){
        sipPayload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        sipPayload.subBrokerCode = vm.formData.subBrokerCode;
      }
      return sipPayload;
    }

    function resetAllPayloads() {
      vm.formData = TransactionInitiateModel.getSipPurchaseDataModel();
      TransactionInitiateModel.setSipPurchaseDataModel(vm.formData);
    }

    function extractSipValidationObject(validationsData, frequency, from) {
      if (!validationsData || !frequency) {
        return;
      }
      vm.sipValidations = {};
      switch (frequency.code) {
        case 'BZ':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.BZ;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.BZ[0].min_amount_lower;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.dailyMaxInstallmentNumber;
          break;
        case 'OW':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.OW;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.OW[0].min_amount_lower;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.weeklyMaxInstallmentNumber;
          break;
        case 'Q':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.Q;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.Q[0].min_amount_lower;
          vm.sipValidations.minTopupAmount = validationsData.topupMinAmt;
          vm.sipValidations.topupAmountMultiples = validationsData.topupAmtMultples;
          vm.sipValidations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.sipValidations.topupPercentageMultiples = validationsData.topupPercentageMultples;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.quarterlyMaxInstallmentNumber;
          break;
        case 'OM':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.OM;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.OM[0].min_amount_lower;
          vm.sipValidations.minTopupAmount = validationsData.topupMinAmt;
          vm.sipValidations.topupAmountMultiples = validationsData.topupAmtMultples;
          vm.sipValidations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.sipValidations.topupPercentageMultiples = validationsData.topupPercentageMultples;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.monMaxInstallmentNumber;
          break;
        case 'H':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.H;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.H[0].min_amount_lower;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.halfYearlyMaxInstallmentNumber;
          break;
        case 'Y':
          vm.additionValidation = vm.sipValidationsData.additionalValidation.Y;
          vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.Y[0].min_amount_lower;
          vm.sipValidations.maxInstallments = vm.sipValidationsData.yearlyMaxInstallmentNumber;
          break;
      }
      if(!$stateParams.folioNumber){
        vm.formData.installmentAmount =  (vm.sipValidationsData.sipDefaultAmount > vm.sipValidations.minAmount) ?  vm.sipValidationsData.sipDefaultAmount :  vm.sipValidations.minAmount;
        }
      if($stateParams.fromModify && vm.modifySipData && (!vm.modifiedSipDetails || !vm.isSipAmountModified) && (vm.modifySipData.amount > vm.sipValidationsData.sipDefaultAmount)){
        vm.formData.installmentAmount = vm.modifySipData.amount;
      }
      if(vm.formData.installmentAmount){
        $timeout(function () {
         $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392');
       });
     }
      vm.sipValidations.isGrowth = validationsData.isGrowth;
      vm.sipValidations.endingType = validationsData.endingType;
      if(vm.formData.investmentType === 'SIP')
      {
        vm.changeSipAmount(vm.sipPurchaseForm, from) ;
      }
    }

    function updateDatesForOthers(sipFlag) {
      var currentDay = '';
      if ($stateParams.transactionId && vm.formData.startDate) {
        currentDay = vm.formData.startDate ? moment(vm.formData.startDate) : moment();
      } else {
        currentDay = moment();
        vm.formData.startDate = currentDay;
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.sipDay.value);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      while (_diff < 15) {
        updatedDate.add(1, 'months').set('date', vm.sipDay.value);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }
      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          // var a = _date.format('MMM, YYYY').toString();
          enabledStartDates.push(_date.clone());
        }
      }
      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      vm.formData.startDate = angular.copy(enabledStartDates[0]);
      // vm.startMinDateBiller = vm.formData.startDate;
      vm.startMaxDate = enabledStartDates[enabledStartDates.length - 1];
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.monthList = enabledStartDates.map(function (ele) {
        return ele.format('MMM, YYYY').toString();
      });
      sipFlag != 'sipFlag' && updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = $window.moment().add(7, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d === vm.formData.weeklyDay;
      }) || {};
      for (var i = 0; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd').toLowerCase() === _day.toLowerCase()) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.startDate = vm.enabledStartDates[0].isBefore(vm.startMinDateOTM)?vm.enabledStartDates[1]:vm.enabledStartDates[0];
      updateEndDates();
    }

    function updateEndDates(installment, amountDateCheck,calledFromOtherFlow) {
      if (vm.isTillPerpetuity || !vm.formData.startDate) {
        return;
      }
      var defaultEndDate = vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.maxMandateDurationYears, 'years')
        : vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI ? moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.maxMandateDurationYears, 'years')
          : moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
      var i = 0, minInstallments = 1;// installmentTotal = 1;
      switch (vm.selectedFrequency.code) {
        case'BZ':
          var days = 0;
          //endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'days');
          defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
          var days = getMonthsCount(vm.formData.startDate.clone(), defaultEndDate);
          freq = vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? defaultEndDate.diff(vm.formData.startDate, 'days', true)
            : vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI ? defaultEndDate.diff(vm.formData.startDate, 'days', true) : ((defaultMonths * 30) / vm.selectedFrequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
          }
          break;
        case'OW':
          var days = 0;
          defaultEndDate = vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM || vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI ? moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.maxMandateDurationYears, 'years').toDate() : new Date("12/31/2099");
          //endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'days');
          freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
          for (i = 0; i <= freq; i++) {
            days = vm.selectedFrequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          // if (vm.sipValidations.minInstallments) {
          minInstallments = (vm.sipValidations && vm.sipValidations.minInstallments) ? vm.sipValidations.minInstallments : 1;
          var installmentTotal = vm.selectedFrequency.code == 'Q' ? ((minInstallments * 3) - 1) : ((minInstallments * 1) - 1);
          //endDate = vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months'); // commented to hanndle sip minimum installment issue for 6 months
          /*} else {
           endDate = vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months');
           }*/
          // endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months');
          defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.duration);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.duration * i;
            enabledEndDates.push(vm.formData.startDate.clone().add(months, 'months'));
          }
          break;
      }
      //vm.minEndDate = angular.copy(vm.formData.startDate.clone());
      //vm.minEndDate = vm.minEndDate.add(installmentTotal, 'months');
      if (!installment) {
        // var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
        if(vm.selectedFrequency.code == "OM" && vm.sipValidations && !vm.sipValidations.minInstallments) {
          vm.sipValidations.minInstallments = 6;
        }
        minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 1) || 0;
        vm.enabledEndDates = enabledEndDates.slice(minInstallments);

      } else {
        vm.enabledEndDates = enabledEndDates;
      }
      vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
      vm.maxEndDate = new Date(2099, 12, 31);
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      if(vm.formData.frequency == 'OW'){
        vm.minEndDateForWeekly = angular.copy(vm.enabledEndDates[0]);
      }

      if ((vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM || vm.formData.paymentMode.key === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI) && vm.enabledEndDates.length > 0) {
        vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
        vm.maxEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length -1].add(1, 'minutes'));
        if (!calledFromOtherFlow) {
          vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length -1]);
        }
        vm.changeEndDate(vm.formData.endDate,calledFromOtherFlow);
      }
      // vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      // !$stateParams.transactionId && (vm.endDate = vm.enabledEndDates[0]);

      //vm.formData.endDate = vm.enabledEndDates[0];

      if (amountDateCheck && vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
        if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
          vm.endDateSelectionOption = true;
        } else {
          vm.endDateSelectionOption = false;
        }
      }else {
        if (vm.formData.paymentMode.key !== AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM && vm.formData.paymentMode.key !== 'UPI') {
          vm.formData.endDate = null;
          vm.endDateSelectionOption = true;
          vm.changeTillPerpetuityFlag();
        }
      }
    }

    function setInstallmentCount() {
      if(vm.formData.endDate == null || vm.formData.endDate == ''){return;}
      var daysDuration;
      switch (vm.selectedFrequency.code) {
        case'BZ':
          vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate, 'days') + 1;
          break;
        case 'OW':
          daysDuration = (vm.formData.endDate.diff(vm.formData.startDate, 'days') + 1) / 7;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'OM' :
          vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate, 'months') * 1 + 1;
          break;
        case 'Q':
          daysDuration = (vm.formData.endDate.diff(vm.formData.startDate, 'months')) / 3;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'H':
          daysDuration = (vm.formData.endDate.diff(vm.formData.startDate, 'months')) / 6;
          vm.formData.installment = Math.ceil(daysDuration);
          break;
        case 'Y':
          vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate, 'years');
          break;
        default :
      }
    }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.isExistingFolio = true;
            vm.sipPayload = null;
            vm.purchasePayload = null;
            vm.investorPayload = null;
            // vm.formData = resp.data;
            // vm.investmentType = resp.data.formType;
            resp.data.formType = resp.data.formType || $stateParams.transactionType.toUpperCase();
            vm.investmentType = resp.data.formType;
            vm.formData = {};
            vm.formData.investmentType = resp.data.formType;
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.formData.inSchemeName = resp.data.schemeName;
            vm.formData.inSchemeCode = resp.data.schemeCode;
            vm.formData.euinOpted = resp.data.euinOpted;
            vm.formData.euinCode = resp.data.euinCode;
            if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
              vm.formData.purchaseDividendOption = resp.data.dividendOption;
              vm.formData.purchaseAmount = resp.data.amount;
            }
            else {
              vm.formData.dividendOption = resp.data.dividendOption;
              vm.formData.installmentAmount = resp.data.installmentAmount;
              vm.formData.endDate = resp.data.toDate ? resp.data.toDate : null;
              vm.selectedFrequency = resp.data.frequency;
              vm.sipDay = resp.data.sipDay;
              vm.sipStartMonth = moment(resp.data.sipDate).format('MMM, YYYY').toString();
              vm.formData.startDate = resp.data.sipDate ? resp.data.sipDate : null;
              vm.monthList = [moment(resp.data.sipDate).format('MMM, YYYY').toString()];
            }
            vm.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
              vm.sipPayload = resp.data;
              vm.folioNumber = resp.data.folioNumber;
              // vm.selectedFrequency = vm.sipPayload && vm.sipPayload.frequency && vm.SIP_FREQ_LIST.find(function (item) {
              //   return item.key === vm.sipPayload.frequency;
              // }) || vm.SIP_FREQ_LIST[0];//default monthly selection
              vm.startDate = vm.sipPayload.sipDate ? moment(vm.sipPayload.sipDate) : null;
              vm.endDate = vm.sipPayload.toDate ? moment(vm.sipPayload.toDate) : null;
              if (vm.sipPayload.sipDay) {
                vm.sipDay = {};
                vm.sipDay.name = vm.sipPayload.sipDay;
                vm.sipDay.value = vm.sipPayload.sipDay;
              }
            } else {
              vm.purchasePayload = resp.data;
              vm.folioNumber = vm.purchasePayload.folioNumber;
              // delete vm.purchasePayload.schemeName;
            }

            TransactionInitiateModel.setPurchasePayload(vm.purchasePayload);
            TransactionInitiateModel.setSipPayload(vm.sipPayload);
            TransactionInitiateModel.setInvestorPayload(vm.investorPayload);

            schemeInit();
          } else {
            $rootScope.$previousState && $state.go('main.dashboard');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $rootScope.$previousState && $state.go('main.dashboard');
          UtilService.errorHandler(err);
        };

      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller: 'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function newFolioClickAction() {
      if (!vm.investorInfo && !vm.investorInfo.panNumber) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.verify) {
            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            model.folioCreationRequestCO.soleApplicantDetail.name = vm.investorInfo.name;
            model.folioCreationRequestCO.soleApplicantDetail.dob = vm.investorInfo.dob;
            model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.investorInfo.panNumber;
            model.folioCreationRequestCO.soleApplicantDetail.email = vm.email;
            model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.mobile;
            model.folioCreationRequestCO.showNomineeUpdate = vm.sebiNomineeRegulatory01650Active;
            model.folioCreationRequestCO.nomineeLimit = vm.nomineeLimit;
            //model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
            InvestorModel.setInvestorModel(model);
            InvestorModel.setFolioCreationFromProfileAndToDo(true);
            delete $window.sessionStorage.investorForm;
            $window.sessionStorage.investorForm = angular.toJson(model);
            InvestorModel.setTab({
              "tab1": false,
              "tab2": false,
              "tab3": false,
              "tab4": false,
              "tabJointHolderAddable": false,
              "tabGuardianDetailShow": false
            });
            // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
            $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              var message = resp.data && !resp.data.verify ? 'Either KYC verification is pending or name is missing.' : resp.message;
              MessageService.error(message);
            }

          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        //dob: moment(vm.investorInfo.dateOfBirth, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString(),
        pan: vm.investorInfo.panNumber
      };

      LoaderService.showLoader();

      var successHandler = function(resp) {
        fetchEmailMobile(vm.investorInfo.panNumber, vm.investorInfo.dob, function() {
          InvestorsService.post({
            controller: 'pan',
            child1: 'verify'
          }, payload).$promise.then(success, error);
        });
      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,'',brokerCode).then(successHandler).catch(errorHandler);

    }

    function changeInstallments() {
      if (vm.endDateSelectionOption == vm.SIP_END_DATE_OPTIONS.NO_OF_INSTALLMENT) {
        updateEndDates(vm.formData.installment);
      }
    }

    function schemeInit() {
      getEuinCodes();
      getInvestorInfo(function(resp) {
        if (resp) {
          $timeout(function() {
            vm.changeFolio();
          }, 0);
        }
      });
    }

    function finishPurchase() {
      vm.isSubmitted = true;
      var successSipModal = function () {
          vm.isSubmitted = false;
          resetAllPayloads();
          // $state.go('main.dashboard');
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType && !$stateParams.fromDash ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSipModal = function () {
          resetAllPayloads();
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: vm.formData.investmentType,
              investorName: vm.investorInfo.name,
              isFromQuickSip: vm.fromQuickSip ? vm.fromQuickSip: false
            }, successSipModal, errorSipModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
          if (vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear) {
            vm.formData.topupDetails.capMonthYear = moment(vm.formData.topupDetails.capMonthYear,'DD-MMM-YYYY').format('MMM-YYYY')
          }
        };
      var payLoadForReview = vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE
        ? getPurchasePayload() : getSipPayload();
      var payload = [], additionalData = {};
      payload.push(payLoadForReview);
      //vm.sipPayload = vm.sipPayload || TransactionInitiateModel.getSipDataModel();
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
        additionalData.investorName = vm.investorInfo.name;
        additionalData.panNumber = vm.investorInfo.panNumber;
        additionalData.folioNumber = vm.formData.folioNumber;
        additionalData.purchaseScheme = vm.formData.inSchemeName;
        additionalData.purchaseAmount = vm.formData.purchaseAmount;
        additionalData.purchaseSchemeToSwitchIn = vm.selectedInScheme;
        additionalData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
        additionalData.switchSchemeInvestmentOption = vm.switchSchemeInvestmentOption;
        additionalData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null;
        if (vm.purchaseValidations && !vm.purchaseValidations.isGrowth) {
          additionalData.dividendOption = vm.formData.purchaseDividendOption;
        }
        additionalData.paymentMode = vm.formData.paymentMode;
        if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
          additionalData.otmBank = vm.formData.otmBank;
        }
        if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'UPI') {
          payload[0].bankDetailsForECS = {
            "accNumber": vm.formData.upiBank.accountNumber,
            "branchName": vm.formData.upiBank.bankBranch,
            "bankName": vm.formData.upiBank.bankName,
            "accType":vm.formData.upiBank.bankAcType,
            "bankCity":vm.formData.upiBank.bankCity
          }
        }

      } else {
        additionalData.investorName = vm.investorInfo.name;
        additionalData.panNumber = vm.investorInfo.panNumber;
        additionalData.folioNumber = vm.formData.folioNumber;
        additionalData.sipScheme = vm.formData.inSchemeName;
        additionalData.installmentAmount = vm.formData.installmentAmount;
        additionalData.noOfInstallments = vm.formData.installment;
        if (vm.sipValidations && !vm.sipValidations.isGrowth) {
          additionalData.dividendOption = vm.formData.dividendOption;
        }
        //additionalData.sipFrequency = vm.selectedFrequency.code;
        additionalData.sipFrequency = vm.selectedFrequency.name;
        additionalData.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
        additionalData.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();
        additionalData.sipTopupEnabled = vm.formData.sipTopupSelected;
        additionalData.topupDetails = vm.formData.topupDetails;
        additionalData.weeklyDay = vm.formData.weeklyDay;
        if (!additionalData.topupDetails.capAmount) {
          additionalData.topupDetails.capMonthYear = vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear ?
            moment(vm.formData.topupDetails.capMonthYear,'MMM-YYYY').format('DD-MMM-YYYY') : null;
        } else {
          additionalData.topupDetails.capMonthYear = undefined
        }
        additionalData.paymentMode = vm.formData.paymentMode;
        if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
          additionalData.otmBank = vm.formData.otmBank;
        }
        if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'HEM') {
          additionalData.eMandateBank = vm.formData.eMandateBank.bankName.substr(0,vm.formData.eMandateBank.bankName.lastIndexOf('-'));
          additionalData.accountNumber = vm.formData.eMandateBank.accountNumber;
          additionalData.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
          additionalData.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
          additionalData.authenticationMode = vm.authMode;
          additionalData.mandateAmount = vm.formData.emandateAmount;
        }
        if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'UPI') {
          payload[0].bankDetailsForECS = {
            "accNumber": vm.formData.upiBank.accountNumber,
            "branchName": vm.formData.upiBank.bankBranch,
            "bankName": vm.formData.upiBank.bankName,
            "accType":vm.formData.upiBank.bankAcType,
            "bankCity":vm.formData.upiBank.bankCity
          }
        }
      }
      additionalData.emailId = vm.emailId;
      additionalData.mobileNumber = vm.mobileNumber;
      additionalData.coperateFlag = vm.investorInfo.corporateFlag;
      additionalData.sipFirstInstallment = vm.formData.sipFirstInstallment;
      additionalData.fiPaymentMode = vm.formData.fiPaymentMode;

      if (vm.fromQuickSip) {
        additionalData.fromQuickSip = true;
        additionalData.oversea_arn =  vm.oversea_arn;
        //additionalData.fromSipPage = true;
      }

      if(vm.formData.subBrokerARN){
        additionalData.subBrokerArn = vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        additionalData.subBrokerCode = vm.formData.subBrokerCode;
      }
      if(vm.formData.euinName){
        additionalData.euinName = vm.formData.euinName;
      }
      if(vm.formData.euinCode){
        additionalData.euinCode = vm.formData.euinCode;
      }
      ModalService.transactionReviewModal({
        payload: payload, controller: 'many', additionalData: additionalData
      }, success, error);

    }

    vm.openPurchaseSchemesModal = function () {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (result) {
        if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
          vm.formData.purchaseDividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          return;
        }
        vm.selectedSchemeType = result.selectedSchemeType;
        vm.formData.inSchemeCode = result.schemeCode;
        vm.formData.inSchemeName = result.scheme;
        vm.formData.schemeType = result.schemeType;
        vm.formData.fundCode = result.fundCode;
        if (result.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchPurchaseSchemeValidations(result.schemeCode);
        /*if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && !vm.investorInfo.retirementFundApplicable) {
          vm.showChequeLeaf = true;
        } else vm.showChequeLeaf = false;*/
        vm.setOtmData();
      }, error = function () {
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
      };
      ModalService.schemeListModal({
        enabledScheme: "purchaseenabled",
        isMinor: vm.formData.minorFlag,
        retirementFundApplicable: vm.investorInfo.retirementFundApplicable,
        corporateFlag: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, success, error);
    };

    vm.openSipSchemesModal = function () {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (result) {

        if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
          vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
        }
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          return;
        }
        vm.selectedSchemeType = result.selectedSchemeType;
        vm.formData.inSchemeCode = result.schemeCode;
        vm.formData.inSchemeName = result.scheme;
        vm.formData.schemeType = result.schemeType;
        vm.formData.fundCode = result.fundCode;
        vm.sipRenewAmount = false;
        vm.isFromModify = false;
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchSipSchemeValidations(result.schemeCode);
        vm.getEmandateBankList(function () {
          vm.changeFrequency();
        });
        fetchBankListForSipUpi();
        /*if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && !vm.investorInfo.retirementFundApplicable) {
          vm.showChequeLeaf = true;
        } else {vm.showChequeLeaf = false;}*/

        getDateValidation();

      }, error = function () {
        vm.formData.inSchemeCode = '';
        vm.formData.inSchemeName = '';
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
      };
      ModalService.schemeListModal({
        enabledScheme: "sipenabled",
        isMinor: vm.formData.minorFlag,
        corporateFlag: vm.selectedFolioData && vm.selectedFolioData.corporateInvestor ? vm.selectedFolioData.corporateInvestor : false
      }, success, error);
    };

    vm.purchaseInSchemeChanged = function (schemeData) {
      vm.formData.isAutoSwitch = false;
      //_isSelectingFromDropDown = true;
      if (!schemeData) {
        return;
      } else {
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          vm.filterPurchaseInSchemeList();
          return;
        }
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.formData.fundCode = schemeData.fundCode;
        vm.formData.otmBank = null;
        vm.otmLimitvalidation = false;
        vm.setOtmData();
        if (schemeData.nfoEnabled == 'Y') {
          vm.nfoEnabled = true;
        } else {
          vm.nfoEnabled = false;
        }
        vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchPurchaseSchemeValidations(vm.formData.inSchemeCode);
      }
      vm.formData.purchaseAmount = '';
      $timeout(function () {
        _isSelectingFromDropDown = false;
      }, 0)
    };

    vm.getSchemesList = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.isInScheme = false;
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      resetValueFields();
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
            vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
          }
          vm.formData.selectedInSchemeCode = result.schemeCode;
          vm.selectedInScheme = result.scheme;
          vm.isInScheme = true;
          vm.selectedSchemeType = result.selectedSchemeType;
          fetchInSchemeValidations();
        },
        errorSchemeList = function () {
          vm.isInScheme = false;
          vm.formData.selectedInSchemeCode = '';
          vm.selectedInScheme = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "switchenabled",
        isMinor: vm.investorInfo.minor
      }, successSchemeList, errorSchemeList);
    };

    vm.getAutoSwitchEnabledList = function () {
      if (vm.unitsDetails && vm.unitsDetails.isDisabled) {
        MessageService.error('No free available units');
        return;
      }
      vm.isInScheme = false;
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      resetValueFields();
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var successSchemeList = function (result) {
          if (result.selectedSchemeType == 'ELSS' && result.scheme.toLowerCase().includes('dividend')) {
            vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
          }
          vm.formData.selectedInSchemeCode = result.schemeCode;
          vm.selectedInScheme = result.scheme;
          vm.isInScheme = true;
          vm.selectedSchemeType = result.selectedSchemeType;
          fetchInSchemeValidations();
        },
        errorSchemeList = function () {
          vm.isInScheme = false;
          vm.formData.selectedInSchemeCode = '';
          vm.selectedInScheme = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "autoSwitchenabled",
        isMinor: vm.investorInfo.minor
      }, successSchemeList, errorSchemeList);
    };

    vm.inSchemeChanged = function (schemeData) {
      vm.formData.selectedInSchemeCode = schemeData.schemeCode;
      vm.selectedSchemeType = schemeData.schemeType;
      vm.formData.selectedInScheme = schemeData.scheme;
      vm.isInScheme = !!(vm.selectedInScheme);
      vm.formData.switchAmount = '';
      vm.formData.noOfUnits = '';
      if (schemeData.schemeType == 'ELSS' && schemeData.scheme.toLowerCase().includes('dividend')) {
        vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
      }
      fetchInSchemeValidations();
      getDateValidation();
    };

    function resetValueFields() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function checkValidScheme() {
      $timeout(function () {
        if (vm.inSchemes && vm.inSchemes.length > 0) {
          var Arr = [];
          Arr = vm.inSchemes.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
            vm.isInScheme = false;
          }
        }
      }, 100);
    }

    function fetchInSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.selectedInSchemeCode) {
        MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            cb(null);
            vm.inSchemeValidations = resp.data;
            vm.switchSchemeInvestmentOption = vm.inSchemeValidations.investmentOption;
            if (vm.inSchemeValidations.schemeType === 'ELSS' && vm.inSchemeValidations.investmentOption !== "GROWTH") {
              vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
            }
            else if (vm.inSchemeValidations) {
              vm.formData.autoSwitchSchemeDividendOption = (vm.inSchemeValidations.investmentOption === "GROWTH") ? "Z" : (vm.inSchemeValidations.endingType === vm.ENDING_TYPES.CLOSED ? AppConstants.TRANSACTION.PAYOUT : AppConstants.TRANSACTION.REINVEST)
            } else {
              vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.REINVEST;
            }
          } else {
            cb('error');
            vm.inSchemeValidations = null;
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'switch',
        child1: vm.formData.selectedInSchemeCode
      }, null).$promise.then(success, error);
    }

    function checkValidations() {
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.minUnits = vm.validations.minUnits || 0;
      if (vm.unitsDetails) {
        vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : vm.unitsDetails.freeValueUnits;
      }

      var minAmount = 0;
      var minUnits = 0;
      var maxAmount = 0;
      var maxUnits = 0;

      if (vm.outSchemeValidations) {
        minAmount = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) || minAmount;
        minAmount = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt > minAmount) ? vm.outSchemeValidations.switchOutMinAmt : minAmount;
        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit * vm.outSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt < maxAmount) ? vm.outSchemeValidations.switchOutMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        minUnits = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit > minUnits) ? vm.outSchemeValidations.switchOutMinUnit : minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        maxUnits = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt / vm.outSchemeValidations.navValue) || maxUnits;
        maxUnits = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit < maxUnits) ? vm.outSchemeValidations.switchOutMaxUnit : maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
      }

      if (vm.inSchemeValidations && vm.outSchemeValidations) {
        minAmount = vm.inSchemeValidations.switchInMinUnit && (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) || minAmount;
        minAmount = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt > minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount;
        vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

        maxAmount = vm.inSchemeValidations.switchInMaxUnit && (vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) || maxAmount;
        maxAmount = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt < maxAmount) ? vm.inSchemeValidations.switchInMaxAmt : maxAmount;
        vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

        var _minUnits = vm.inSchemeValidations.switchInMinUnit && ((vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt / vm.outSchemeValidations.navValue) || minUnits;
        minUnits = minUnits > _minUnits ? minUnits : _minUnits;
        vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

        var _maxUnits = vm.inSchemeValidations.switchInMaxUnit && ((vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt / vm.outSchemeValidations.navValue) || maxAmount;
        maxUnits = maxUnits < _maxUnits ? maxUnits : _maxUnits;
        vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;

        vm.validations.isEnabled = vm.inSchemeValidations.switchInUnitEnabled;
      }
    }

    function termsAndContitions() {
      if (vm.transactionType === 'PURCHASE') {
        ModalService.termConditionModal({});
      } else if (vm.transactionType === 'SIP') {
        ModalService.termsAndConditionSip({});
      }
    }

    vm.selectSipScheme = function (data) {
      // _isSelectingFromDropDown = true;
      if (!data) {
        // vm.sipScheme = '';
        // vm.formData.inSchemeName = '';
        //resetSchemeDuration();
        // vm.formData && (vm.formData.inSchemeCode = '');
        // vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList);
        // $scope.$digest();
        // getDateValidation();
        return;
      } else {
        //resetSchemeDuration();
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(data, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          vm.filterSipSchemeList();
          return;
        }
        vm.formData.inSchemeName = data.scheme;
        vm.formData.inSchemeCode = data.schemeCode;
        vm.formData.schemeType = data.schemeType;
        vm.formData.fundCode = data.fundCode;
        vm.getEmandateBankList(function () {
          vm.changeFrequency();
        });
        vm.getOtmBankList(function () {
          //vm.setOtmData();
          // vm.getSmsValidations();
        });

        fetchBankListForSipUpi();

        /*if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && !vm.investorInfo.retirementFundApplicable) {
          vm.showChequeLeaf = true;
        } else vm.showChequeLeaf = false;*/
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
        /*vm.sipScheme*/
        fetchSipSchemeValidations(data.schemeCode);
        //getDateValidation();

        if(data.schemeType === "NFO"){
            var message = data.message;
            ModalService.nfoEnabledModal({message: message});
          }

      }
      $timeout(function () {
        _isSelectingFromDropDown = false;
      }, 0)
      vm.sipRenewAmount = false;
      vm.isFromModify = false;
      checkIsModified();
      vm.checkModifySipDetails();
    };

    vm.euinChanged = function () {
      var filterEuin = vm.euinList.filter(function (euin) {
        return euin.euinCode == vm.formData.euinCode;
      })[0]
      vm.formData.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinNameSelected = vm.formData.euinName;
      checkIsModified();
    };

    vm.filterPurchaseInSchemeList = function () {
      if (_isSelectingFromDropDown) {
        return;
      }
      vm.formData.inSchemeCode = '';
      vm.purchaseInSchemeList = UtilService.getFilteredList(vm.masterPurchaseInSchemeList, 'scheme', vm.formData.inSchemeName);
      vm.formData.paymentMode = '';
    };

    vm.filterSipSchemeList = function () {
      if (_isSelectingFromDropDown) {
        return;
      }
      vm.formData && (vm.formData.inSchemeCode = '');
      vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
      // getDateValidation();
      /*vm.sipScheme*/
    };

    vm.changePurchaseAmount = function (sipPurchaseForm) {
      if (vm.purchaseValidations && !vm.purchaseValidations.minAdlAmountApplicable) {
        vm.isMinPurchaseAmount = vm.purchaseValidations && vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.purchaseAmount;
        vm.minAmountValidation = vm.purchaseValidations.minFirstPurchaseAmt;
      }
      else if (vm.purchaseValidations && vm.purchaseValidations.minAdlAmountApplicable) {
        vm.isMinPurchaseAmount = vm.purchaseValidations && vm.purchaseValidations.minAddlPurchaseAmt > vm.formData.purchaseAmount;
        vm.minAmountValidation = vm.purchaseValidations.minAddlPurchaseAmt;
      }
      vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.formData.purchaseAmount && (vm.formData.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;

      if (vm.formData.purchaseAmount < vm.minAmountValidation) {
        sipPurchaseForm.$invalid = true;
      }
      vm.otmAmountLimitValidation(); // to validate entered amount with otm limit


      if(vm.formData.paymentMode.key == 'UPI' && vm.formData.purchaseAmount > vm.upiAmountLimit && vm.formData.inSchemeName) {
         var success = function() {
            vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
               return el.key == 'WEB'
            });
            vm.changePaymentMode();
         }
         ModalService.genericModal({
            text: vm.upiErrorMessage
         },success);
      }
    };
  vm.changeSipAmount = function (sipPurchaseForm, from) {
    if(vm.sipRenewAmount && !from){
      vm.formData.installmentAmount = vm.sipValidationsData.sipDefaultAmount > parseInt($stateParams.amount) ? vm.sipValidationsData.sipDefaultAmount : parseInt($stateParams.amount);
    } else if(vm.isFromModify && !from){
      vm.formData.installmentAmount = vm.sipValidationsData.sipDefaultAmount > vm.modifySIPAmountValue ? vm.sipValidationsData.sipDefaultAmount : vm.modifySIPAmountValue;
    } else {
       if(!from){
         vm.formData.installmentAmount = vm.sipValidationsData.sipDefaultAmount
       }
    }
    var newValidation = vm.additionValidation;
      for (var i=0; i<newValidation.length;i++){
        var condition = vm.formData.installmentAmount < newValidation[i].min_amount_lower ||  vm.formData.installmentAmount <= newValidation[i].min_amount_upper;
        if(!newValidation[i].min_amount_upper){
          var condition=vm.formData.installmentAmount >= newValidation[i].min_amount_lower
        }
        if(condition )
        {
          // vm.formData.startDate = null;
          // vm.formData.endDate = null;
          vm.sipValidations.amountMultiples = newValidation[i].amt_multiples;
          vm.sipValidations.maxAmount = newValidation[i].min_amount_upper;
          vm.sipValidations.minAmount = newValidation[i].min_amount_lower;
          vm.sipValidations.minInstallments = newValidation[i].min_installments;
          break;
        }
      }
      vm.isMinSipAmount = vm.sipValidations && vm.sipValidations.minAmount > vm.formData.installmentAmount;
      vm.isMaxSipAmount = !!(vm.sipValidations.minAmount && vm.sipValidations.minAmount > vm.formData.installmentAmount);
      vm.isEmandateMaxLimit = vm.formData.installmentAmount > vm.eMandateMaxAmount ;
      vm.isMultiples = vm.sipValidations.amountMultiples && vm.formData.installmentAmount && (vm.formData.installmentAmount % vm.sipValidations.amountMultiples === 0) || false;
      vm.invalidAmount=false;
      if (vm.formData.installmentAmount < vm.sipValidations.minAmount) {
        vm.invalidAmount=true;
        sipPurchaseForm.$invalid = true;
      } else if (vm.sipValidations.amountMultiples && !vm.isMultiples) {
        vm.invalidAmount=true;
        if(sipPurchaseForm != undefined){
          sipPurchaseForm.$invalid = true;
        }
      }
      vm.otmAmountLimitValidation(); // to validate entered amount with otm limit
     if(vm.formData.sipFirstInstallment){
       vm.fiOtmAmountLimitValidation();
     }

    if(vm.formData.installmentAmount >= 2000000){
      vm.amountExceeded = true;
    }else {
      vm.amountExceeded = false;
    }
    if(vm.formData.startDate){
      vm.changeStartDate(vm.formData.startDate, true);
    }
    if(vm.formData.installmentAmount){
      $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392');
    }

    if (vm.formData.installmentAmount && vm.formData.emandateAmount) {
      checkAmountValidationEmandate();
    }

    checkIsModified();
    /*vm.formData.sipTopupSelected = false;
    vm.sipTopupSelected = true;
    changeSipTopupSelected();*/
    if (!$stateParams.fromModify && !vm.modifySipData) {
      resetTopUpDetails();
    } else if ($stateParams.fromModify && vm.modifySipData) {
      checkForModifyAndSetTopUp();
    }
  };

    vm.changeTopupAmount = function (sipPurchaseForm) {
      vm.isMinTopupAmount = vm.sipValidations && vm.sipValidations.minTopupAmount > vm.formData.topupDetails.amount;
      if (vm.formData.topupDetails.amount < vm.sipValidations.minTopupAmount) {
        sipPurchaseForm.$invalid = true;
      }

      vm.isMultipleTopupAmount = vm.sipValidations.topupAmountMultiples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.sipValidations.topupAmountMultiples === 0) || false;
      if (vm.sipValidations.topupAmountMultiples && !vm.isMultipleTopupAmount) {
        sipPurchaseForm.$invalid = true;
      }
      capAmountChanged(sipPurchaseForm);
      validateTopUpDetailsInCaseOfModify();
      checkIsModified();

    };

    vm.changeTopupPercentage = function (sipPurchaseForm) {
      vm.isMinTopupPercentage = vm.sipValidations && vm.sipValidations.topupMinPercentage > vm.formData.topupDetails.percentage;
      if (vm.formData.topupDetails.percentage < vm.sipValidations.topupMinPercentage) {
        sipPurchaseForm.$invalid = true;
      }

      vm.isMultipleTopupPercentage = vm.sipValidations.topupPercentageMultiples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.sipValidations.topupPercentageMultiples === 0) || false;
      if (vm.sipValidations.topupPercentageMultiples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.sipValidations.topupPercentageMultiples === 0) || false) {
        sipPurchaseForm.$invalid = true;
      }

    };

    /*vm.changeCapAmount = function (sipPurchaseForm) {
      vm.isMultipleCapAmount = vm.formData.topupDetails.amount && vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount % vm.formData.topupDetails.amount === 0) || false;
      $timeout(function () {
      sipPurchaseForm.$invalid = !vm.isMultipleCapAmount;
      })
      // if (vm.isMultipleCapAmount) {}
    };*/

    vm.changeFrequency = function (form, from) {
      vm.startDateValidationForFi = false;
      vm.formData.installment = '';
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      vm.endDateSelectionOption = false;
      vm.formData.weeklyDay = null;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (!$stateParams.transactionId) {
        vm.formData.startDate = null;
        vm.sipDay = null;
        vm.formData.endDate = null;
        // vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.sipDay = null;
      } else {
        // vm.formData.startDate = vm.formData.startDate ? moment(vm.formData.startDate) : null;
        // vm.formData.endDate = vm.formData.endDate ? moment(vm.formData.endDate) : null;
        getDateValidation();
        if (vm.formData.sipDay) {
          vm.sipDay = {};
          vm.sipDay.name = vm.formData.sipDay;
          vm.sipDay.value = vm.formData.sipDay;
        }
      }

      // if (from === 'fromHtml' && vm.modifySipData) {
      //   vm.modifySipData.amount = null;
      // }

      $timeout(function () {
        vm.resetting = false;
      }, 0);
      extractSipValidationObject(vm.sipValidationsData, vm.selectedFrequency, from);

      if(vm.selectedFrequency){
        vm.formData.frequency = vm.selectedFrequency.code;
      }
      if (vm.selectedFrequency && vm.selectedFrequency.code === 'BZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.formData.topupDetails = {};
        vm.formData.sipTopupSelected = false;
        vm.showTopUpBlock = false;
        vm.sipTopupSelected = false;
        vm.formData.sipFirstInstallment = false;
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        }
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          if($stateParams.transactionType === "SIP"){
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'HEM', value: 'Register E-mandate (eOTM)'}
            ];
          } else {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'}
          ];
          }
        }
        if (vm.eMandateBankList && vm.eMandateBankList.length > 0) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'}
          ];
          vm.hideOtmRadio = false;
        }
        if ((vm.otmBankList && vm.otmBankList.length > 0)&&(vm.eMandateBankList && vm.eMandateBankList.length > 0)) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'}
          ];
          vm.hideOtmRadio = false;
        }
        //updateDatesForDaily()
      } else if (vm.selectedFrequency && vm.selectedFrequency.code === 'OM') {
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'months';
        vm.startDateFormat = 'DD-MMM-YYYY';
        if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.sipWithFirstInstallment && !vm.modifiedSipDetails){
          vm.formData.sipFirstInstallment = true;
        }else{
        vm.formData.sipFirstInstallment = false;
        }
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        }
        vm.PAYMENT_MODE=[{key: 'UPI',value: 'UPI Autopay'}, {key: 'EC',  value: 'Standing Instruction/Biller'}];
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
        } else if ((vm.otmBankList && vm.otmBankList.length > 0 ) && (vm.eMandateBankList && vm.eMandateBankList.length > 0)){
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
        }
      }else if (vm.selectedFrequency && vm.selectedFrequency.code === 'OW') {
        if(vm.weeklyDaysList == null){
          vm.weeklyDaysList = [];
          AppConstants.WEEKS_LIST.forEach(function(d) {
            vm.weeklyDaysList.push(d.name);
          })
          vm.daysList = vm.weeklyDaysList;
        } else {
          vm.daysList = vm.weeklyDaysList;
        }
        if($stateParams.fromModify && vm.modifySipData){
          vm.formData.weeklyDay = vm.modifySipData.weeklyDay ? vm.modifySipData.weeklyDay : null;
          if(vm.formData.weeklyDay){
            updateDatesForWeekly();
          }
        }
        vm.viewMode = 'days';
        vm.formData.topupDetails = {};
        vm.formData.sipTopupSelected = false;
        vm.showTopUpBlock = false;
        vm.sipTopupSelected = false;
        vm.formData.sipFirstInstallment = false;
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        }
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          if($stateParams.transactionType==="SIP"){
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'HEM', value: 'Register E-mandate (eOTM)'}
            ];

            // if emandate bank doesnt exist removing mandate payment option
            if (vm.eMandateBankList && vm.eMandateBankList.length === 0) {
              vm.PAYMENT_MODE.map(function (el,index) {
                if (el.key === 'HEM') {
                  vm.PAYMENT_MODE.splice(index,1)
                }
              })
            }

          } else {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'}
          ];
          }
        }
        if (vm.eMandateBankList && vm.eMandateBankList.length > 0) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'}
          ];
          vm.hideOtmRadio = false;
        }
        if ((vm.otmBankList && vm.otmBankList.length > 0)&&(vm.eMandateBankList && vm.eMandateBankList.length > 0)) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'}
          ];
        } else if (vm.otmBankList.length==0 && (vm.eMandateBankList && vm.eMandateBankList.length==0)){
          vm.PAYMENT_MODE=[];
        }
      }
      else {
        vm.daysList = AppConstants.SIP_DAYS_LIST;
        vm.viewMode = 'months';
        vm.startDateFormat = 'DD-MMM-YYYY';
        vm.formData.sipFirstInstallment = false;
        vm.showTopUpBlock = false;
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        }
    }

      if (vm.selectedFrequency && vm.selectedFrequency.code !== 'BZ' && vm.selectedFrequency.code !== 'OW' && vm.selectedFrequency.code !== undefined){
        if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.sipWithFirstInstallment && !vm.modifiedSipDetails){
          vm.formData.sipFirstInstallment = true;
        }else {
          vm.formData.sipFirstInstallment = false;
        }
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        }
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          if($stateParams.transactionType==="SIP"){
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'HEM', value: 'Register E-mandate (eOTM)'},
              {key: 'EC',  value: 'Standing Instruction/Biller'}
            ];

            // if emandate bank doesnt exist removing mandate payment option
            if (vm.eMandateBankList && vm.eMandateBankList.length === 0) {
              vm.PAYMENT_MODE.map(function (el,index) {
                if (el.key === 'HEM') {
                  vm.PAYMENT_MODE.splice(index,1)
                }
              })
            }

          } else if(vm.formData.minorFlag && !vm.formData.cgfFlag ){
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          }
          else {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
          }
        }
        if (vm.eMandateBankList && vm.eMandateBankList.length > 0) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
          vm.hideOtmRadio = false;
        }
        if ((vm.otmBankList && vm.otmBankList.length > 0)&&(vm.eMandateBankList && vm.eMandateBankList.length > 0)) {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'HEM', value: 'Register E-mandate (eOTM)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
        }
      }
      if (!vm.isEMandateEnabled) {
        vm.PAYMENT_MODE.map(function (el,index) {
          if (el.key === 'HEM') {
            vm.PAYMENT_MODE.splice(index,1)
          }
        })
      }

      if ($stateParams.fromQuickSip && $stateParams.schemeCode) {
        vm.setQuickSipPaymentOptionsAndBank();
      } else {
        vm.formData.paymentMode = vm.PAYMENT_MODE[0];
      }

      vm.sipStartMonth = null;
      if(vm.formData.minorFlag && vm.sipValidationsData && vm.formData.investmentType === 'SIP' && !vm.sipValidationsData.cgfFlag) {
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
            return el.key == 'OTM'
          });
        } else {
          vm.PAYMENT_MODE = [];
        }
      } else if (vm.formData.minorFlag && vm.sipValidationsData && vm.formData.investmentType === 'SIP' && vm.sipValidationsData.cgfFlag && vm.selectedFrequency.code !== 'BZ' && vm.selectedFrequency.code !== 'OW') {
        if(vm.otmBankList.length > 0 ){
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
        } else {
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'EC',  value: 'Standing Instruction/Biller'}
          ];
        }
        vm.formData.paymentMode =  vm.PAYMENT_MODE[0];
      }
      if (vm.PAYMENT_MODE.length > 0) {
        if(vm.formData.minorFlag && vm.sipValidationsData && vm.otmBankList && vm.otmBankList.length > 0 && vm.formData.investmentType === 'SIP' && !vm.sipValidationsData.cgfFlag){
          vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
            return el.key == 'OTM'
          });
        } else {

          // if redirected to sip page via quick sip review setting payment mode mandate as default and set bank list based on default value on mandate bank list

          if ($stateParams.fromQuickSip && !from && $stateParams.schemeCode) {

            vm.setQuickSipPaymentOptionsAndBank();

          } else {

            if (from === 'fromHtml') {
              vm.formData.eMandateBank = null;
              vm.authMode = null;
            }
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
          }
        }
        vm.changePaymentMode();
      }
      if(vm.formData.sipFirstInstallment == false){
        vm.formData.fiPaymentMode=null;
        vm.formData.fiOtmBank= null;
      }
      checkIsModified();
    };

    vm.changeDay = function () {
      if (!vm.selectedFrequency || (!vm.sipDay && !vm.formData.weeklyDay)) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        return;
      }
      switch (vm.selectedFrequency.code) {
        case 'OW':
          if(!vm.formData.weeklyDay){
            vm.formData.startDate = null;
            vm.formData.endDate = null;
            return;
          }
          vm.formData.endDate = null;
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers('sipFlag');
          break;
        default :
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          break;
      }
    };

    vm.changeStartDate = function (date, calledFromAmountChanged) {
      LoaderService.showLoader();
      vm.formData.startDate = date ? date : null;
      vm.sipDay = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
      // vm.formData.endDate = null;
      vm.isTillPerpetuity = false;
      vm.endDateSelectionOption = true;
      vm.resetting = true;
      $timeout(function (){
        vm.resetting=false;
        LoaderService.hideLoader();
      })
      vm.otmStartValidation();
      vm.otmStartValidationPurchase();
      if(vm.formData.sipFirstInstallment){
        vm.fiOtmStartValidation();
      }
      if(calledFromAmountChanged){
        updateEndDates(false, true);
      }else {
        updateEndDates();
      }
    };

    vm.changeEndDate = function (date,calledFromOtherFlow) {
      if($window.moment(vm.endDateDefaultForPertuity).isSame(vm.formData.endDate)){
        vm.endDateSelectionOption = true;
      } else {
        vm.endDateSelectionOption = false;
      }
      vm.formData.endDate = date ? date : null;
      //Sip-topup month count check
      var diffInMonths = parseInt(moment(vm.formData.endDate).diff(moment(vm.formData.startDate), 'months', true));
      if (diffInMonths >= 6) {
        if (vm.selectedFrequency.code == 'OM' || vm.selectedFrequency.code == 'Q') {
          vm.showTopUpBlock = true;
        }
        if (diffInMonths >= 12) {
          var capStartDate = moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        }
        else {
          var capStartDate = moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
        }

        vm.capDates = [];
        var capLastDate = capStartDate;
        while (moment(capLastDate,"MMM-YYYY").isBefore(moment(vm.formData.endDate,"MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          capStartDate = moment(capStartDate,"MMM-YYYY").add(12, 'months').format("MMM-YYYY");
          if (moment(capStartDate,"MMM-YYYY").isBefore(moment(vm.formData.endDate,"MMM-YYYY"))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }

        if (vm.selectedFrequency.code == 'Q' && diffInMonths < 12) {
          vm.showTopUpBlock = false;
          vm.topupQuarterCheck = true;
        }

        if (diffInMonths < 12) {
          vm.topupFrequencyList = [
            {key: 'H', value: 'Half Yearly', monthfreq: 6}
          ];
          vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;

          vm.hideTopupPercentage = true;
        }
        else if (diffInMonths >= 12) {
          vm.hideTopupPercentage = false;
        }
        checkForModifyAndSetTopUp();
      }
      else {
        vm.showTopUpBlock = false;
        vm.formData.topupDetails = {}
        vm.topupDetailsInvalid = false;
      }
      //------------


      if(vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM' && vm.formData.endDateEmandate) {
        vm.sipDateLessEmandate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
        if (vm.sipDateLessEmandate) {
          var setEndDateLess = false;
          var indexSipEndDate = vm.enabledEndDates.length - 1;
          var tempEndDate;
          while (!setEndDateLess) {
            tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
            indexSipEndDate = indexSipEndDate - 1;
            if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
              setEndDateLess = true;
              var newEnabledEndDates = angular.copy(vm.enabledEndDates);
              newEnabledEndDates.splice(indexSipEndDate + 1);
              vm.enabledEndDates = angular.copy(newEnabledEndDates);
              if (!calledFromOtherFlow) {
                vm.formData.endDate = angular.copy(tempEndDate);
                vm.changeEndDate(vm.formData.endDate);
              }
            }

            if (indexSipEndDate == 0) {
              break;
            }

          }

          if (calledFromOtherFlow) {
            var endDateField =  vm.formData.frequency === 'OW' ? angular.element('#endDateCalenderWeekly') : angular.element('#endDateCalender');
            endDateField.focus();
          }
        }
      }

      if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'UPI' && vm.enabledEndDates) {
        var defaultEndDate = $window.moment().add(vm.maxMandateDurationYears, 'years').subtract(1,'days');
        var sipDateLessUPI = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter(defaultEndDate) ? true : false;
        if (sipDateLessUPI) {
          var setEndDateLess = false;
          var indexSipEndDate = vm.enabledEndDates.length - 1;
          var tempEndDate;
          while (!setEndDateLess) {
            tempEndDate = angular.copy(vm.enabledEndDates[indexSipEndDate - 1]);
            indexSipEndDate = indexSipEndDate - 1;
            if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(defaultEndDate, 'DD-MMM-YYYY'))) {
              setEndDateLess = true;
              var newEnabledEndDates = angular.copy(vm.enabledEndDates);
              newEnabledEndDates.splice(indexSipEndDate + 1);
              vm.enabledEndDates = angular.copy(newEnabledEndDates);
              vm.formData.endDate = angular.copy(tempEndDate);
              vm.changeEndDate(vm.formData.endDate);
            }

            if (indexSipEndDate == 0) {
              break;
            }
          }
        }
      }


      setInstallmentCount();
      vm.otmExpiryValidation(); // to validate entered end date with otm expiry date
      if(vm.formData.sipFirstInstallment){
        vm.fiOtmExpiryValidation();
      }
      checkIsModified();
      vm.checkModifySipDetails();
    };

    vm.changeTopUpFreq = function () {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency) {
        case 'H':
          duration = 6;
          break;
        case 'Y':
          duration = 12;
          break;
      }
      if (duration === 12) {
        var capStartDate = moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
      }
      else {
        var capStartDate = moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");

      }


      vm.capDates = [];
      var capLastDate = capStartDate;
      while (moment(capLastDate,"MMM-YYYY").isBefore(moment(vm.formData.endDate,"MMM-YYYY"))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = moment(capStartDate,"MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
        if (moment(capStartDate,"MMM-YYYY").isBefore(moment(vm.formData.endDate,"MMM-YYYY"))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
      checkIsModified();
    }

    vm.cancelTransaction = function () {
      var success = function () {
        TransactionInitiateModel.setPurchasePayload(null);
        TransactionInitiateModel.setSipPayload(null);
        TransactionInitiateModel.setInvestorPayload(null);
        TransactionInitiateModel.setInvestmentType(null);
        var _statusType = $stateParams.status;
        var identifier = AuthService.getToken();
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Are you sure, you want to cancel this action?'}, success, error);
    };

    vm.finishPurchaseFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                vm.finishPurchase();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              vm.finishPurchase();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      if(vm.formData.investmentType === 'SIP' && vm.formData.minorFlag && angular.isArray(vm.otmBankList ) && vm.otmBankList.length<1 && (vm.eMandateBankList && vm.eMandateBankList.length < 1) && (vm.formData.cgfFlag===false && vm.formData.paymentMode.key==="EC"))
      {
        MessageService.error("No valid payment mode available to proceed with SIP transaction");
        return;
      }
      var payload = {
        transactionType: vm.formData.investmentType,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode,
        targetSchemeCode: vm.formData.targetSchemeCode ? vm.formData.targetSchemeCode : "",
        amount: vm.formData.investmentType == 'PURCHASE' ? vm.formData.purchaseAmount : vm.formData.installmentAmount,
        checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
        autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.selectedInSchemeCode : null,
        autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null,
        sipTopupEnabled: vm.formData.sipTopupSelected,
        topupDetails: vm.formData.topupDetails,
        paymentMode: vm.formData.investmentType == 'SIP' && vm.formData.paymentMode.key == 'UPI' ? 'UAP' : vm.formData.paymentMode.key
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    vm.finishPurchase = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.sKycStatus) {
              if($stateParams.fromModify && vm.modifySipData){
                finishModifySip();
              }else{
              finishPurchase();
              }
            }
            else {
              MessageService.error(resp.data.message);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {"panNumber": vm.investorInfo.panNumber, "folioNumber": vm.formData.folioNumber};
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'sKycStatus'
      }, payload).$promise.then(success, error);
    };

    vm.init = function () {
      if($stateParams.fromModify){
        vm.modifySipData = JSON.parse(sessionStorage.getItem('modifySipData'));
        if(vm.modifySipData && vm.modifySipData.amount){
          vm.modifySIPAmountValue = vm.modifySipData.amount;
          vm.isFromModify = true;
        }
        vm.defaultPaymentMode = false;
        vm.isModifySip = true;
      }else {
        sessionStorage.removeItem('modifySipData');
        vm.isModifySip = false;
      }
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      vm.formData.investmentType = TransactionInitiateModel.getInvestmentType() || vm.TRANSACTION_FORM_TYPE.PURCHASE;
      if(vm.modifySipData){
        vm.formData.investmentType = vm.modifySipData.type;
      }
      // vm.selectedFrequency = vm.formData && vm.formData.frequency && vm.SIP_FREQ_LIST.find(function (item) {
      //   return item.key === vm.formData.frequency;
      // }) || vm.SIP_FREQ_LIST[0];//default monthly selection
      vm.endDateSelectionOption = vm.SIP_END_DATE_OPTIONS.SELECT_END_DATE;
      folioInit();

      if ($stateParams.transactionId) {
        vm.isReinitiate = true;
        getTransactionDetails();
      } else {
        vm.isReinitiate = false;
        schemeInit();
      }
      if ($stateParams.transactionType) {
        vm.formData.investmentType = $stateParams.transactionType;
      }
      checkForTermsAndCondition();
    };


    var currentDate = Date();
    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb){
      // if no scheme code available not calling api
      if (!vm.formData.inSchemeCode) {
        return;
      }
      cb = cb || function () {};
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      vm.endDateSelectionOption = false;
      var success = function (resp) {
          vm.enabledOTMStartDatesList = [];
          if (resp.status && resp.data) {
            vm.weeklyDaysList=resp.data.listOfDays;
            var currentDate = resp.data.currentDate;
            var todayDate = $window.moment(currentDate);
            if ( vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM' || vm.formData.paymentMode && vm.formData.paymentMode.key === 'UPI') {
              vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.eMandateNoOfDays, 'days');
            } else if(vm.formData.paymentMode && vm.formData.paymentMode.key === 'EC' || ($stateParams.fromModify && vm.modifySipData && vm.modifySipData.sipTDay && !vm.modifiedSipDetails)){
              vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.sipValidationsData.sipTDay ? vm.sipValidationsData.sipTDay : vm.modifySipData.sipTDay, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(currentDate, "DD-MMM-YYYY").add(13, 'days');//T+10+2+1
            }
            var startMaxDate = $window.moment(currentDate, "DD-MMM-YYYY").add(90, 'days');
            var startDate = todayDate.clone();
            var freq = $window.moment(vm.startMaxDate).diff(todayDate, 'days');
            var counter=0;
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<7)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(indexDate);
                counter++;
              }
            }
            vm.startMinDateOTM = vm.enabledOTMStartDatesList[7];//T+5+2
            if( vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM') {
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandateNoOfDays];
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }
            else if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'EC') {
              vm.enabledBillerStartDatesList = [];
            }
            vm.startMaxDate = $window.moment(startMaxDate, "DD-MMM-YYYY").add(1, 'minutes').clone();

            if(vm.enabledOTMStartDatesList.length > 0 && vm.formData.frequency !== 'OW'){
              if(vm.formData.paymentMode && (vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE || vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)){
                vm.formData.startDate = angular.copy($window.moment(vm.startMinDateOTM, "DD-MMM-YYYY"));
              }else {
                vm.formData.startDate = angular.copy($window.moment(vm.startMinDateBiller, "DD-MMM-YYYY"));
              }
              updateEndDates();
            }

            vm.resetting = false;
            cb(true);
          } else {
            MessageService.error(resp.message);
            vm.resetting = false;
            cb(false);
          }
        },
        error = function (err) {
          vm.resetting = false;
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorsCommonService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    vm.schemeInit = function () {
      if ($stateParams.transactionId) {
        vm.isReinitiate = true;
        getTransactionDetails();
      } else {
        vm.isReinitiate = false;
        schemeInit();
      }
    };
    var PAYMENT_MODE_AT_FOLIO;
    vm.setOtmData = function () {
      // function to set payment mode if otm is registered
      if (vm.formData.investmentType) {
        if (vm.otmBankList && vm.otmBankList.length > 0) {
          if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE ) {
            if(vm.formData.schemeType && vm.formData.schemeType.toUpperCase() !== 'LIQUID')
            {
              vm.PAYMENT_MODE = [
                {key: 'OTM', value: 'OTM(One Time Mandate)'},
                {key: 'WEB', value: 'Net Banking'},
                {key: 'HDFC',value: "HDFC Bank's Fund Transfer"},
                {key: 'RTGS',value: 'NEFT/RTGS'}
              ];
            }
            else
            {
              vm.PAYMENT_MODE = [
                {key: 'WEB', value: 'Net Banking'},
                {key: 'HDFC',value: "HDFC Bank's Fund Transfer"},
                {key: 'RTGS',value: 'NEFT/RTGS'}
              ];
            }
          }
          else {
            if(vm.selectedFrequency){
              if(vm.selectedFrequency.code === "BZ"){
                if( $stateParams.transactionType==="SIP"){
                  vm.PAYMENT_MODE = [
                    {key: 'UPI', value: 'UPI Autopay'},
                    {key: 'OTM', value: 'OTM(One Time Mandate)'},
                    {key: 'HEM', value: 'Register E-mandate (eOTM)'}
                  ];
                } else {
                vm.PAYMENT_MODE = [
                  {key: 'UPI', value: 'UPI Autopay'},
                  {key: 'OTM', value: 'OTM(One Time Mandate)'}
                ];
                }
              }
              else{
                if(vm.SIP_FREQ_LIST.length !==0){
                  if($stateParams.frequency && $stateParams.transactionType==="SIP" || ($stateParams.fromModify && vm.modifySipData)){
                    if($stateParams.frequency === "Business Days(BZ)" || $stateParams.frequency === "Weekly" || ($stateParams.fromModify && vm.modifySipData && (vm.modifySipData.autoFrequency == "Weekly" || vm.modifySipData.autoFrequency == "Daily"))){
                      vm.PAYMENT_MODE= [
                        {key: 'UPI', value: 'UPI Autopay'},
                        {key: 'OTM', value: 'OTM(One Time Mandate)'},
                        {key: 'HEM', value: 'Register E-mandate (eOTM)'}
                      ];
                    } else if($stateParams.frequency === "Monthly" || $stateParams.frequency === "Quarterly" || $stateParams.frequency === "Yearly" || $stateParams.frequency === "Half-Yearly" || ($stateParams.fromModify && vm.modifySipData && (vm.modifySipData.autoFrequency == "Monthly" || vm.modifySipData.autoFrequency == "Quarterly"  || vm.modifySipData.autoFrequency == "Half-Yearly"))){
                      vm.PAYMENT_MODE= [
                        {key: 'UPI', value: 'UPI Autopay'},
                        {key: 'OTM', value: 'OTM(One Time Mandate)'},
                        {key: 'HEM', value: 'Register E-mandate (eOTM)'},
                        {key: 'EC',  value: 'Standing Instruction/Biller'}
                      ];
                    }
                  } else {
                  vm.PAYMENT_MODE = [
                    {key: 'UPI', value: 'UPI Autopay'},
                    {key: 'OTM', value: 'OTM(One Time Mandate)'},
                    {key: 'EC',  value: 'Standing Instruction/Biller'}
                  ];
                  }
                }

              //  vm.selectedFrequency = vm.SIP_FREQ_LIST[0];
              }
            } else {
                vm.PAYMENT_MODE = [
                  {key: 'UPI', value: 'UPI Autopay'},
                  {key: 'OTM', value: 'OTM(One Time Mandate)'},
                  {key: 'HEM', value: 'Register E-mandate (eOTM)'},
                  {key: 'EC',  value: 'Standing Instruction/Biller'}
                ];
            }
          }

          if (!vm.isEMandateEnabled) {
            vm.PAYMENT_MODE.map(function (el,index) {
              if (el.key === 'HEM') {
                vm.PAYMENT_MODE.splice(index,1)
              }
            })
          }
        }

        else if (angular.isArray(vm.otmBankList ) && vm.otmBankList.length == 0 ) {
          if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
            vm.PAYMENT_MODE = angular.copy(AppConstants.PAYMENT_MODE);
          }
          else {
            vm.PAYMENT_MODE = [];
            if (vm.sipValidationsData) {
              if (vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag) {
                vm.PAYMENT_MODE = [];
                vm.formData.paymentMode = null;
              } else {
                vm.PAYMENT_MODE = [{key: 'UPI', value: 'UPI Autopay'}, {key: 'EC', value: 'Standing Instruction/Biller'}];
              }
            }
          }
        } else if(vm.otmBankList == null){
          if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
            vm.PAYMENT_MODE = angular.copy(AppConstants.PAYMENT_MODE);
          }
          else {
            vm.PAYMENT_MODE = [];
            if (vm.sipValidationsData) {
              if (vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag) {
                vm.PAYMENT_MODE = [
                  {key: 'UPI', value: 'UPI Auto Pay'}
                ];
              } else {
                vm.PAYMENT_MODE = [ {key: 'UPI', value: 'UPI Autopay'}, {key: 'EC', value: 'Standing Instruction/Biller'}];
              }
            }
          }
        }
        if(vm.formData.investmentType != vm.TRANSACTION_FORM_TYPE.PURCHASE && (vm.eMandateBankList && vm.eMandateBankList.length > 0)){
          // vm.PAYMENT_MODE=[{key: 'HEM', value: 'Register E-mandate (eOTM)'}].concat(vm.PAYMENT_MODE);
          // vm.PAYMENT_MODE.shift();
          // vm.PAYMENT_MODE=vm.PAYMENT_MODE.concat([{key: 'HEM', value: 'Register E-mandate (eOTM)'}]);
          for(var i = 0; i < vm.PAYMENT_MODE.length; i++){
            var elementExists = vm.PAYMENT_MODE[i].key.includes("HEM");
          }
          if(!elementExists){
            // vm.PAYMENT_MODE.push({key: 'HEM', value: 'Register E-mandate (eOTM)'});
            paymentOptionOrdering();
          }
          vm.hideOtmRadio=false;
        }
        if(vm.formData.minorFlag && vm.sipValidationsData && vm.formData.investmentType === 'SIP' && !vm.sipValidationsData.cgfFlag) {
          if (vm.otmBankList && vm.otmBankList.length > 0) {
            vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
              return el.key == 'OTM'
            });
          }
        } else {
          if($stateParams.fromModify && vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && !vm.defaultPaymentMode){
            var selectedPaymentMode = vm.PAYMENT_MODE.find(function (el) {
              return el.key == vm.modifySipData.paymentOption[0].code;
            })
            vm.formData.paymentMode = selectedPaymentMode ? selectedPaymentMode : vm.PAYMENT_MODE[0];
          }else{
            if ($stateParams.fromQuickSip && $stateParams.schemeCode) {
              vm.setQuickSipPaymentOptionsAndBank();
            } else {
              vm.formData.paymentMode = vm.PAYMENT_MODE[0];
            }
          }
        }

      }
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
        var data = vm.PAYMENT_MODE.filter(function(payment) {
          return payment.key === 'UPI';
        });
        if (data.length === 0) {
          vm.PAYMENT_MODE.push({key: 'UPI',value: 'UPI'});
        }
      }

      // if redirected to sip page via quick sip review setting payment mode mandate as default and set bank list based on default value on mandate bank list
      if ($stateParams.fromQuickSip && $stateParams.schemeCode) {
        vm.setQuickSipPaymentOptionsAndBank();
      }


      PAYMENT_MODE_AT_FOLIO = angular.copy(vm.PAYMENT_MODE);
    };

    vm.getOtmBankList = function (cb) {// function to fetch otm registered bank w.r.t selected folio
      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.otmResp = resp.data;
          if (angular.isArray(resp.data.folioBankDetailsList) && resp.data.folioBankDetailsList.length > 0) {
            vm.otmBankList = resp.data.folioBankDetailsList;
            vm.hideOtmRadio = false;
            vm.showSmsRadio = true;
            var otmExists = false;
            for(var i = 0; i < vm.PAYMENT_MODE.length; i++) {
              if (vm.PAYMENT_MODE[i].key == "OTM") {
                otmExists = true;
                break;
              }
            }
            if(vm.selectedFrequency){
              if(vm.SIP_FREQ_LIST){
                if (otmExists && vm.PAYMENT_MODE.length > 1) {
                  $timeout(function(){
                    var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                      return d.code === 'OM';
                    }) || {};
                    vm.selectedFrequency = frequency?frequency:'';//default monthly selection
                  });
                } else {
                  if(!$stateParams.frequency && !$stateParams.fromModify){
                    $timeout(function(){
                      var freqToSet = vm.fromQuickSip ? 'OM' : 'OW';
                      var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                        return d.code === freqToSet;
                      }) || {};
                      vm.selectedFrequency = frequency?frequency:'';//OTM selected
                      vm.changeFrequency();
                    });
                  }
                }
              }
            }
          }
          else{
            vm.otmBankList  = [];
            vm.hideOtmRadio = true;
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
            vm.showSmsRadio = false;
            vm.approvalMode = 'ONLINE';
            vm.isOtmLimitLess = false;
            $timeout(function(){
              if(!$stateParams.fromModify && !vm.modifySipData){
              // if((vm.otmBankList && vm.otmBankList.length > 0) || (vm.eMandateBankList && vm.eMandateBankList.length > 0)){
              //   vm.selectedFrequency = vm.SIP_FREQ_LIST[0];//default monthly selection
              // } else {
                for(var i = 0; i <= vm.SIP_FREQ_LIST; i++){
                  if(i.code == "OM"){
                    vm.selectedFrequency = i;
                  }
                }
              // }
              }
            });
          }
          cb(true);
        } else {
          vm.otmBankList = null;
          vm.hideOtmRadio = true;
          vm.formData.paymentMode = vm.PAYMENT_MODE[0];
          cb(false);
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
        vm.otmBankList = null;
          vm.hideOtmRadio = true;
        vm.formData.paymentMode = vm.PAYMENT_MODE[0];
        cb(false);
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'otm',
        child2: 'banks'/*,
        folioNumber: vm.formData.folioNumber*/
      }, {folioNumber: vm.formData.folioNumber,pan: vm.investorInfo.panNumber}).$promise.then(success, error);
    };

    vm.otmAmountLimitValidation = function () { // function to validate investment amount with otm limit
      vm.otmBankLimit = vm.formData.otmBank && vm.formData.otmBank.maxAmount;
      if (vm.formData.investmentType && vm.otmBankLimit &&
        (vm.formData.purchaseAmount || vm.formData.installmentAmount)) {
        if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
          vm.otmLimitvalidation = vm.formData.purchaseAmount > vm.otmBankLimit;
        }
        else if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
          vm.otmLimitvalidation = vm.formData.installmentAmount > vm.otmBankLimit;
        }
      }
      if((vm.formData.otmBank && vm.formData.otmBank.otmFrequency !== 'AWP') && (vm.selectedFrequency.code === 'BZ')){
          MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
      }
    };

    vm.otmExpiryValidation = function () { // function to validate investment end date  with otm expiry
      vm.otmExpDate = vm.formData.otmBank && moment(vm.formData.otmBank.omExpiryDate, 'DD-MMM-YYYY');
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP &&
        vm.formData.endDate && angular.isDefined(vm.formData.endDate.format) && vm.otmExpDate) {
        vm.endDateValidation = vm.formData.endDate && (moment(vm.formData.endDate,"DD-MMM-YYYY")) > (moment(vm.otmExpDate,"DD-MMM-YYYY"));
      } else if(vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE){
        vm.endDateValidation = moment().isAfter(vm.otmExpDate);
      }
    };
    vm.otmStartValidation = function () { // function to validate investment start date  with otm expiry
      vm.otmStrDate = vm.formData.otmBank && moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY');
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP &&
        vm.formData.startDate && angular.isDefined(vm.formData.startDate.format) && vm.otmStrDate) {
        vm.startDateValidation = vm.formData.startDate && (moment(vm.formData.startDate,"DD-MMM-YYYY")) < (moment(vm.otmStrDate,"DD-MMM-YYYY"));
      }
      else if(vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP && vm.formData.startDate && !vm.otmStrDate) {
        vm.startDateValidation = false;
      }else {
        vm.startDateValidation = false;
      }
    };
    vm.otmStartValidationPurchase = function () { // function to validate investment start date  with otm expiry
      vm.otmStrDate = vm.formData.otmBank && moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY');
      if(vm.otmResp){
        vm.otmCurDate = moment(vm.otmResp.currentDate, 'DD-MMM-YYYY');
      }
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE &&
        vm.otmCurDate && angular.isDefined(vm.otmCurDate) && vm.otmStrDate) {
        vm.startDateValidationPurchase =  vm.otmCurDate < vm.otmStrDate;
      }
    };

    vm.changeOtmbank = function () {
      // function to check otm limit and expiry date on change of otm bank
      if(!vm.formData.otmBank && !vm.formData.fiOtmBank){
        return ;
      }
      vm.otmAmountLimitValidation();
      vm.otmExpiryValidation();
      vm.otmStartValidation();
      vm.otmStartValidationPurchase();
      if((vm.formData.eMandateBank !== undefined && vm.formData.eMandateBank !==null)  || ( vm.formData.otmBank!== undefined && vm.formData.otmBank !== null)){
        if(vm.formData.minorFlag && !vm.formData.cgfFlag )
        {
          if( vm.formData.otmBank.minorBankFlag !== undefined){
            if(!vm.formData.otmBank.minorBankFlag){
              if(vm.dynamicDataMinorBank) {
                ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
              }
              vm.formData.otmBank=null;
            }
          }
          if( vm.formData.eMandateBank && vm.formData.eMandateBank.minorBankFlag !== undefined){
            if(!vm.formData.eMandateBank.minorBankFlag){
              if(vm.dynamicDataMinorBank) {
                ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
              }
              vm.formData.otmBank=null;
            }
          }
        }
      }
      if(vm.formData.weeklyDay){
        vm.formData.weeklyDay = null;
        vm.formData.startDate = null;
        vm.formData.endDate = null;
      }
      if (vm.formData.sipFirstInstallment) {
        vm.fiOtmAmountLimitValidation();
        vm.fiOtmExpiryValidation();
        vm.fiOtmStartValidation();
      }else {
        vm.fiOtmLimitvalidation=false;
      }
      checkIsModified();
    };

    vm.changeEMandateBank = function (){
      if(!vm.formData.eMandateBank){
        return ;
      }
      if($stateParams.fromModify && vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && vm.modifySipData.paymentOption[0].code == "HEM" && !vm.modifiedSipDetails){
        var selectedAuthmode = vm.formData.eMandateBank.authenticationModes.find(function (data) {
          return data.value == vm.modifySipData.folioBankDetails.authenticationMode
        });
        if(selectedAuthmode){
          vm.authMode = selectedAuthmode
        }else {
          vm.authMode = vm.formData.eMandateBank.authenticationModes[0];
        }
      }else {
        vm.authMode = vm.formData.eMandateBank && vm.formData.eMandateBank.authenticationModes ? vm.formData.eMandateBank.authenticationModes[0] : null;
      }
      if(vm.formData.minorFlag && !vm.formData.cgfFlag && !vm.formData.eMandateBank.minorBankFlag)
      {
        if(vm.dynamicDataMinorBank) {
          ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
        }
        vm.formData.eMandateBank=null;
      }
    };

    vm.changeUpiBank = function (){
      if(vm.formData.minorFlag && !vm.formData.cgfFlag && !vm.formData.upiBank.minorBankFlag)
        {
          ModalService.minorBankModal({});
          vm.formData.upiBank=null;
        }
    }

    vm.changePaymentMode = function () { // function to set and check otm details on change of payment mode
      vm.checkModifySipDetails();
      if($stateParams.fromModify && vm.modifiedSipDetails){
        if(!vm.modifySipData.weeklyDay){
          vm.formData.startDate = null;
        }
        vm.formData.endDate = null;
      }
      if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'OTM') {
        if(!$stateParams.fromModify){
          vm.formData.otmBank=null;
        }
        vm.changeOtmbank();
        vm.formData.upiBank=null;
      }
      else if(vm.formData.paymentMode && vm.formData.paymentMode.key === 'UPI') {
        if(vm.formData.investmentType !=='SIP') {
          if (vm.upiNoBankError !== '') {
            MessageService.error(vm.upiNoBankError)
          }
        }

        if(vm.formData.purchaseAmount > vm.upiAmountLimit && vm.formData.inSchemeName) {
          var success = function() {
            vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
               return el.key == 'WEB'
            });
            vm.changePaymentMode();
          }
          ModalService.genericModal({
            text: vm.upiErrorMessage
          },success);
        }

        if(vm.formData.investmentType == 'SIP'){
          if (vm.upiBankListForSIP && vm.upiBankListForSIP.length === 1) {
            vm.formData.upiBank = vm.upiBankListForSIP[0];
          }
        }

        vm.otmLimitvalidation = false;
        vm.endDateValidation = false;
      }
      else {
        vm.otmLimitvalidation = false;
        vm.formData.otmBank=null;
        vm.endDateValidation = false;
        vm.formData.upiBank=null;
        vm.startDateValidation = false;
      }
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.startDateValidationPurchase = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (vm.emandateValidationData) {
        vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
        checkAmountValidationEmandate();
      }

      if(vm.formData.investmentType == 'SIP' && (vm.formData.paymentMode.key == 'HEM' || vm.formData.paymentMode.key == 'UPI') && !vm.emandateValidationData){
        var successHandler = function(resp){
          vm.emandateUpiData = resp;
          if (vm.formData.paymentMode.key == 'HEM') {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.paymentMode.key=='UPI') {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          }
          if (vm.emandateValidationData) {
            setEmandateUpiSetting();
          }
        }

        UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
          MessageService.error(resp);
        });

      } else {
        if(vm.emandateUpiData) {
          if (vm.formData.paymentMode.key == 'HEM') {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.paymentMode.key == 'UPI') {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          }
          if (vm.emandateValidationData) {
            setEmandateUpiSetting();
          }
        }
        if (vm.formData.investmentType == 'SIP' && vm.formData.paymentMode.key == 'HEM' && vm.enabledEmandateEndDatesList) {
          vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
          changeEndDateEmandate(vm.formData.endDateEmandate);
        }
        checkUPIForSipWithFI();
        $timeout(function () {
          getDateValidation();
        },100);
        checkIsModified();
      }

    };

    vm.getEmandateBankList = function (cb) {// function to fetch e-mandate registered bank w.r.t selected folio
      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if ((angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) && vm.isEMandateEnabled) {
              vm.eMandateBankList = resp.data.bankList;

              // vm.eMandateNoOfDays = resp.data.noOfDays;
              vm.eMandateMaxAmount = resp.data.maxAmountLimit;
              checkUpiError();
              // vm.maxMandateDurationYears = resp.data.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
              // vm.isEmandateEnabled = true;
            }
            else{
              vm.eMandateBankList  = [];
              vm.PAYMENT_MODE.map(function (el,index) {
                if (el.key === 'HEM') {
                  vm.PAYMENT_MODE.splice(index,1)
                }
              })
              checkUpiError();
            }
            cb(true);
          } else {
            vm.eMandateBankList = null;
            MessageService.error(resp.message);
            checkUpiError();
          }
        },
        error = function (err) {
          vm.eMandateBankList = null;
          vm.hideOtmRadio = true;
          checkUpiError();
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "trnxType": vm.formData.investmentType,
        "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false
      }
      LoaderService.showLoader();
      BillJunctionService.post({VERSION: 'v2',
        controller: 'bank',
        child1: 'list',
        child2: 'emandate',
      }, payload ).$promise.then(success, error);
    };

    vm.changeFolio = function (userAction) {

      // removing scheme code from state params when folio is changes to reset scheme in quick sip
      if (userAction && vm.fromQuickSip && $stateParams.schemeCode) {

        sessionStorage.setItem('initialFolioSetQS', $stateParams.folioNumber);

        $state.go('main.transactions.initiate.sip', {
          uuid: vm.investorUUID,
          schemeCode: '',
          folioNumber: vm.formData.folioNumber,
          transactionType: 'SIP',
          transactionId: '',
          fromModify: '',
          fromQuickSip : true
        });

        return;
      }

      if ($stateParams && $stateParams.folioNumber && !userAction) {

        if (vm.fromQuickSip) {
          vm.formData.folioNumber = null;

          var initialFolio = sessionStorage.getItem('initialFolioSetQS');
          var isNewFolioSet = sessionStorage.getItem('isNewFolioSet');

          if (!isNewFolioSet) {
            vm.formData.folioNumber = $stateParams.folioNumber;
          } else if(initialFolio) {
            vm.formData.folioNumber = initialFolio;
          }
        } else {
          vm.formData.folioNumber = $stateParams.folioNumber;
        }

        vm.fromInvestorDetail = true;
      }
      if (!vm.formData.folioNumber) {
        vm.checkFolio=true;
        return;
      }
      vm.formData.folioNumber = vm.formData.folioNumber || vm.folioNumber;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      if (userAction) {
        vm.emandateValidationData = null;
      }

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.investorInfo.name = resp.data.folioHolderName
          emailMobileValidation();
          vm.getOtmBankList(function () {
            vm.setOtmData();
            if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.firstInstallmentDetails && !vm.modifiedSipDetails){
              changeFirstInstallment(true);
            }
            // vm.getSmsValidations();
          });
          vm.getUpiBankList();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        if(selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        if (vm.formData.transactionType == 'SIP' ) {
          fetchSipEnabledSchemes();
        } else if (vm.formData.transactionType == 'PURCHASE') {
          vm.investorInfo && fetchPurchaseEnabledSchemes();
        }
        vm.changeInvestmentType();
        vm.hasFolioEmailId = true;
        LoaderService.showLoader();
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
    };

    function emailMobileValidation(){
      if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
        if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isMobileinValid = true;
          vm.emandateDisplay = false;
        }
      }
      else if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
        if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isEmailinValid = true;
          vm.emandateDisplay = false;
        }
      } else {
        vm.isEmailinValid = false;
        vm.isMobileinValid = false;
        vm.isEmailMobileinValid = false;
        vm.emandateDisplay = true;
      }
    }

    // vm.getSmsValidations = function () {
    //   if (!vm.formData.folioNumber) {
    //     return;
    //   }
    //
    //   var success = function (resp) {
    //     LoaderService.hideLoader();
    //     if (resp.status && resp.data) {
    //       if (resp.data.otmRegistered) {
    //         vm.showSmsRadio = true;
    //         vm.hideOtmRadio = angular.isArray(vm.otmBankList)&&vm.otmBankList.length>0?false:true;
    //         vm.otmLimit = resp.data.otmLimit;
    //         $timeout(function(){
    //           vm.selectedFrequency = vm.SIP_FREQ_LIST[2];//OTM selected
    //         });
    //       } else  {
    //         vm.showSmsRadio = false;
    //         vm.hideOtmRadio = angular.isArray(vm.otmBankList)&&vm.otmBankList.length>0?false:true;;
    //         vm.approvalMode = 'ONLINE';
    //         vm.isOtmLimitLess = false;
    //         $timeout(function(){
    //           vm.selectedFrequency = vm.SIP_FREQ_LIST[0];//default monthly selection
    //         });
    //       }
    //     } else {
    //       MessageService.error(resp.message);
    //     }
    //   }, error = function (err) {
    //     LoaderService.hideLoader();
    //     UtilService.errorHandler(err);
    //   };
    //   LoaderService.showLoader();
    //   TransactionService.get({
    //     VERSION: HDFC_API.VERSION,
    //     controller: 'otm',
    //     child2: 'limit',
    //     folioNumber: vm.formData.folioNumber
    //   }, {}).$promise.then(success, error);
    // };

    vm.checkOtmValidation = function (sipPurchaseForm) {
    //  vm.changePurchaseAmount(sipPurchaseForm);
      if(vm.approvalMode=='SMS'){
        if ( vm.formData.purchaseAmount > vm.otmLimit) {
          vm.isOtmLimitLess = true;
        }
        else vm.isOtmLimitLess = false;
      }
      else {
        vm.isOtmLimitLess = false;
      }

      };

      vm.checkSIPOtmValidation = function (sipPurchaseForm) {
    //  vm.changePurchaseAmount(sipPurchaseForm);
      if(vm.approvalMode=='SMS'){
        if ( vm.formData.installmentAmount > vm.otmLimit) {
          vm.isOtmLimitLess = true;
        }
        else {
          vm.isOtmLimitLess = false;
        }
      }
      else {
        vm.isOtmLimitLess = false;
      }

      };

    /* function schemeInit() {
     getEuinCodes();
     getInvestorInfo();
     vm.changeFolio();
     }*/

    /*vm.uploadFile = function (file) {
      if (vm.formData.folioNumber) {
        if (file) {
          if (vm.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }
          vm.myFile = file;
          vm.chequeLeaf = file.name;

          var modalSuccess = function () {
              if (file.size <= 2000000) {
                var success = function (resp) {
                    LoaderService.hideLoader();
                    if (resp.status && resp.data) {
                      vm.formData.retirementAgeProofURL = resp.data.fileUrl;

                      vm.breakFileUrl(resp.data.fileUrl);
                      //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                    }
                    else {
                      MessageService.error(resp.message);
                    }
                  },
                  error = function (err) {
                    LoaderService.hideLoader();
                    $log.info("err=== ", err);
                  };

                if (file) {
                  LoaderService.showLoader();
                  var fd = new FormData();
                  fd.append('file', file);

                  DistributorFileUploadService.post({
                    child1: 'transaction',
                    child2: 'retirement',
                    child3: 'ageProof',
                    child4: 'upload',
                    child5: vm.formData.folioNumber
                  }, fd).$promise.then(success, error);
                }
              } else {
                MessageService.error("File size should not be more than 2 MB.")
              }
            },
            modalError = function () {
              document.getElementById("uploadFileId").value = '';
              vm.chequeLeaf = '';
            };

          ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }
      } else {
        MessageService.error("Please select folio Number");
      }
    };*/

    vm.changeInvestmentType = function () {
      // specific to sip-purchase transaction only
      var folioNumber = vm.formData.folioNumber;
      var investmentType = vm.formData.investmentType;
      var sipPaymentOption = vm.formData.sipPaymentOption;
      var euinOpted = vm.formData.euinOpted;
      var euinCode = vm.formData.euinCode;
      var minorFlag=vm.formData.minorFlag;
      var schemeType=vm.formData.schemeType;
      vm.transactionType = investmentType;
      if (investmentType === 'SIP') {
        // fetchInSchemes();
        checkForTermsAndCondition();
        fetchSipEnabledSchemes();
        vm.formData.sipDividendOption = vm.DIVIDEND_OPTIONS.GROWTH;//vm.devidendOptions[0];
      } else if (investmentType === 'PURCHASE') {
        vm.fromInvestorDetail = true;
        checkForTermsAndCondition();
        vm.investorInfo && fetchPurchaseEnabledSchemes();
      }
      resetAllPayloads();
      vm.formData.minorFlag=minorFlag;
      vm.formData.folioNumber = folioNumber;
      vm.formData.investmentType = investmentType;
      vm.formData.sipPaymentOption = sipPaymentOption;
      vm.formData.euinOpted = euinOpted;
      vm.formData.euinCode = euinCode;
      vm.formData.startDate = null;
      $state.$previous = null;
      // vm.formData.frequency =  vm.SIP_FREQ_LIST[0].key;
      // vm.selectedFrequency = vm.SIP_FREQ_LIST[0];
      vm.formData.schemeType = schemeType;
      vm.setOtmData();
      vm.formData.paymentMode = vm.PAYMENT_MODE[0];//vm.frequencyList[0].key;
      if(vm.subBrokerName || vm.subBrokerCodeError){
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.fetchEuinListSubBroker();
      }
    };

    vm.changeTillPerpetuityFlag = function () {
      vm.formData.endDate = null;
      // vm.enabledEndDates = null;
      vm.resetting = true;
        vm.resetting = false;
        if (vm.endDateSelectionOption) {
          var defaultMonths = null;
          // var endDate = moment(new Date("12/31/2099"));
          var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
          vm.formData.startDate = moment(vm.formData.startDate);
          var day = moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
          var month = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
          var newEndDate = day + '/'+ (month + 1) +'/2099';
          var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
          switch (vm.selectedFrequency.code) {
            case'BZ':
              var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
              if(endDateYear > 2099){
                endDateYear = 2099;
              }
              var newEndDateForDaily = day + '/'+ (month + 1) +'/' + endDateYear;
              vm.formData.endDate = $window.moment(newEndDateForDaily, "DD-MM-YYYY");

              //check end date exists between enabled end dates
              var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
              if (!isBetween) {
                if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                  vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                }else {
                  endDateYear = endDateYear - 1;
                  var dailyNewDate = day + '/'+ (month + 1) +'/' + endDateYear;
                  vm.formData.endDate = $window.moment(dailyNewDate, "DD-MM-YYYY");
                }
              }
              break;
            case'OW':
              //var days = 0;
              // endDate = new Date("12/31/2099");
              var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
              endDate = new Date(weeklyEndate);
              var startDate = vm.formData.startDate.toDate();
              var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
              var weeksDiff = UtilService.getNumberOfWeeks(startDate,endDate);
              vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff*7, 'days');
              break;
            default :
              var newday = moment().date();
              var newMonth = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
              var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
              var endDateCal = $window.moment(newEndDateCal, "DD-MM-YYYY");

              if (!moment(endDateCal).isValid()) {
                var initialStartDate = vm.formData.startDate.clone().day(1)
                endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
              }

              // var months = 0;
              defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(vm.selectedFrequency, 'months'), $window.moment(endDateCal));
              freq = freq || Math.floor(defaultMonths / vm.selectedFrequency.duration);
              freq = vm.sipValidations && vm.sipValidations.maxInstallments ? freq - 1 : freq;
              var months = vm.selectedFrequency.duration * freq;
              vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');
              var calculatedEndDateMonth = moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

              if(calculatedEndDateMonth > month) {
                var endDateCalculated = angular.copy(vm.formData.endDate);
                var checkDate = angular.copy(endDateCalculated.set('month', month));

                var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
                if (DateisBetween) {
                  vm.formData.endDate = checkDate;
                }

              }
              break;
          }

          if (vm.sipValidations && vm.sipValidations.maxInstallments) {
            var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
            var EndDatemonth = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

            var EndDateCalculatedMonth = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
            var EndDateCalculatedYear = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

            if (EndDateCalculatedYear <= EndDateYear) {
              if (EndDatemonth < EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDateCheck = day + '/'+ (month + 1) +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDateCheck, "DD-MM-YYYY");
                }
                var isBetweenCheck = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetweenCheck) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else if (EndDatemonth === EndDateCalculatedMonth) {
                if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                  EndDateYear = EndDateYear - 1;
                  var newEndDateChecking = day + '/'+ (month + 1) +'/' + EndDateYear;
                  vm.formData.endDate = $window.moment(newEndDateChecking, "DD-MM-YYYY");
                }
                var isBetweenChecking = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetweenChecking) {
                  vm.formData.endDate = angular.copy(lastEndDate);
                }
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              } else {
                if (EndDateYear > 2099) {
                  vm.formData.endDate.set('year', 2099);
                }
              }
            } else if ((EndDateCalculatedYear > EndDateYear)) {
              if (EndDateCalculatedYear <= 2099) {
                vm.formData.endDate.set('year', EndDateYear);
              } else {
                vm.formData.endDate.set('year', 2099);
              }

            }
          }
          setInstallmentCount();
          vm.endDateDefaultForPertuity = vm.formData.endDate;
          vm.changeEndDate(vm.formData.endDate);
        } else {
          vm.showTopUpBlock = false;
          // vm.formData.startDate && updateEndDates();
        }
    };

    /*Save transaction Start*/

    function getFinalPayloadData() {
      var payload = null;
      switch (vm.formData.investmentType) {
        case vm.TRANSACTION_FORM_TYPE.SIP:
          payload = vm.isSaving ? getSipPayload() : getSipPayload();
          break;
        case vm.TRANSACTION_FORM_TYPE.PURCHASE:
          payload = vm.isSaving ? getPurchasePayload() : getPurchasePayload();
          break;
      }
      return angular.copy(payload);
    }

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getFinalPayloadData();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: vm.formData.investmentType.toLowerCase(),
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload = {};
      if (!vm.formData.inSchemeName) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload, function (saveClicked) {
          if (saveClicked) {
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          } else {
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    /*Socket code End*/

    function changeSipTopupSelected() {
      vm.sipTopupSelected = !vm.sipTopupSelected;
      vm.formData.topupDetails = {};
      vm.getTopupFrequencyList();
    }

    vm.getTopupFrequencyList = function () {
      vm.topupFrequencyList = [
        {key: 'Y', value: 'Yearly', monthfreq: 12},
        {key: 'H', value: 'Half Yearly', monthfreq: 6}
      ];
      if (vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'Q' && !vm.formData.topupDetails.percentage) {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12}
        ];
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
      } else if (vm.formData.frequency == 'OM') {
        if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.topupDetails){
          var selectedTopupFreq = vm.topupFrequencyList.find(function (data) {
            return data.key == vm.formData.topupDetails.frequency;
          });
          if(selectedTopupFreq){
            vm.formData.topupDetails.frequency = selectedTopupFreq.key;
          }else{
            vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key
          }
        }else{
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
        }
      }
      else {
        vm.topupFrequencyList = [
          {key: 'Y', value: 'Yearly', monthfreq: 12},
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
      }

      var diffInMonths = parseInt(moment(vm.formData.endDate).diff(moment(vm.formData.startDate), 'months', true));
      if (diffInMonths < 12) {
        vm.topupFrequencyList = [
          {key: 'H', value: 'Half Yearly', monthfreq: 6}
        ];
        vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;

        vm.hideTopupPercentage = true;
      }
      else if (diffInMonths >= 12) {
        vm.hideTopupPercentage = false;
      }
    }

    function capAmountChanged(sipPurchaseForm) {
      if (vm.formData.topupDetails.amount) {
        vm.minCapAmount = vm.formData.installmentAmount + vm.formData.topupDetails.amount;
      }
      else if (vm.formData.topupDetails.percentage) {
        vm.minCapAmount = vm.formData.installmentAmount + (vm.formData.topupDetails.percentage * vm.formData.installmentAmount / 100)
      }


      if (vm.formData.topupDetails.capAmount < vm.minCapAmount) {
        vm.isminCapAmount = true
        sipPurchaseForm.$invalid = true;
      }
      else {
        vm.isminCapAmount = false
      }
      validateTopUpDetailsInCaseOfModify();
      checkIsModified();
    }

     function fetchEmailMobile(panNumber,Dob, cb) {
       cb = cb || function () {
       };
       var success = function (resp) {
       LoaderService.hideLoader();
        if (resp.status) {
           vm.mobile = resp.data.mobileNumber;
           vm.email = resp.data.email;
          vm.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
          vm.nomineeLimit = resp.data.nomineeLimit;
          cb();
        }

        if(!resp.data && resp.message) {
          if(resp.message !== "The given Date Of Birth is invalid."){
            MessageService.error(resp.message)
          }
        }

        if(resp.data && resp.data.ekycStatus == "NOT_VERIFIED" && $stateParams.fromModify){
          MessageService.error('KYC verification is pending for selected investor');
          vm.panDetailsNotVerified = true;
        }

       },
       error = function () {
         LoaderService.hideLoader();
         MessageService.error("something went wrong")
       };
       vm.payload = {
         pan: panNumber,
         dob: Dob,
         transactionEnabled : true
       };
       LoaderService.showLoader();
       InvestorsService.post({
         child1: 'pan',
         child2: 'details'
       }, vm.payload).$promise.then(success, error);
     }

    function checkEndNote(endDate,startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showNote = true;
      } else {
        vm.showNote = false;
      }
    }

    function checkEndPopup(endDate,startDate) {
       if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
          vm.showpopup = true;
       } else {
          vm.showpopup = false;
       }
    }

    function checkForTermsAndCondition() {
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        if (vm.formData.investmentType === 'PURCHASE') {
          vm.showTerms = vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ? true : false;
        } else if (vm.formData.investmentType === 'SIP') {
          vm.showTerms = vm.termsConditionData.TNC_General_SIP && vm.termsConditionData.TNC_General_SIP.content ? true : false;
        }
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    /*
    * fetching upi bank list
    */
    vm.getUpiBankList = function (cb) {
      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.upiNoBankError = '';
          if (angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) {
            vm.upiBankList = resp.data.bankList
          }
          else{
            vm.upiBankList  = [];
          }
        cb(true);
        } else {
          vm.upiBankList = null;
          vm.upiNoBankError = resp.message;
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "trnxType": vm.formData.investmentType,
        "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false
      }
      LoaderService.showLoader();
      InvestorCommonServiceVersion2.post({
        child1: 'investor',
        child2: 'upi',
        child3: 'bank',
        child4: 'list'
      }, payload).$promise.then(success, error);
    };

    function tpv(event) {
      event.preventDefault()
      ModalService.tpvModal({});
    }
    function changeFirstInstallment(installmentActivated) {
      if (installmentActivated) {
        vm.topupQuarterCheck=false;
        vm.formData.otmBank=null;
        vm.formData.sipFirstInstallment = true;
        vm.otmBankList = vm.otmResp.nonCOTMBankList;
        if (vm.otmBankList.length === 0) {
          vm.sipFirstInstallmentPaymentMode = vm.sipFirstInstallmentPaymentMode.filter(function(paymentMode) {
            return paymentMode.key !== 'OTM';
          });
        } else {
          vm.sipFirstInstallmentPaymentMode=[
            {key: 'OTM', value: 'OTM(One Time Mandate)'},
            {key: 'WEB',  value: 'Net Banking'}
          ]
        }
        if(vm.selectedFrequency && vm.selectedFrequency.code !== 'OW'){
          if(vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag){
            if(vm.otmBankList.length!=0){
              vm.PAYMENT_MODE = [
                {key: 'UPI',value: 'UPI Autopay'},
                {key: 'OTM', value: 'OTM(One Time Mandate)'}
              ];
            }else if( vm.otmBankList==0){
              vm.PAYMENT_MODE=[];
            }
          } else if(vm.otmBankList.length === 0){
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'EC',  value: 'Standing Instruction/Biller'}
            ];
          } else{
            vm.PAYMENT_MODE = [
              {key: 'UPI',value: 'UPI Autopay'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'EC',  value: 'Standing Instruction/Biller'},

            ];
          }
        } else if (vm.selectedFrequency && vm.selectedFrequency.code == 'OW' && vm.otmBankList.length != 0 ){
          vm.PAYMENT_MODE = [
            {key: 'UPI',value: 'UPI Autopay'},
            {key: 'OTM', value: 'OTM(One Time Mandate)'}
          ];
        }
        if(vm.selectedFrequency && vm.selectedFrequency.code == 'OW' && vm.otmBankList.length == 0){
          vm.sipFirstInstallmentPaymentMode =[
            {key: 'WEB',  value: 'Net Banking'}
          ]
          if(!$stateParams.fromModify) {
            vm.PAYMENT_MODE = [
              {key: 'UPI', value: 'UPI Auto Pay'}
            ];
          }
        }
        vm.formData.paymentMode=  vm.PAYMENT_MODE[0]
        if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.firstInstallmentDetails && !vm.modifiedSipDetails){
          var selectedFiPaymentMode = vm.sipFirstInstallmentPaymentMode && vm.sipFirstInstallmentPaymentMode.find(function (data) {
            return data.key == vm.modifySipData.firstInstallmentDetails.paymentMode;
          });
          vm.formData.fiPaymentMode = selectedFiPaymentMode ? selectedFiPaymentMode : vm.sipFirstInstallmentPaymentMode[0];
        }else{
        vm.formData.fiPaymentMode = vm.sipFirstInstallmentPaymentMode[0];
        }
        checkUPIForSipWithFI();
      } else {
        vm.modifiedFiDetails = true;
        vm.checkModifySipDetails();
        vm.formData.sipFirstInstallment = false;
        vm.formData.fiPaymentMode = null;
        vm.otmBankList = vm.otmResp? vm.otmResp.folioBankDetailsList:[];
        vm.changeFrequency()
      }
      vm.minCapAmount = null;
      vm.isminCapAmount = false;
      vm.changePaymentMode();
      getDateValidation();
      checkIsModified();
    }
    vm.fiOtmAmountLimitValidation = function() {
      vm.otmBankLimit = vm.formData.fiOtmBank && vm.formData.fiOtmBank.maxAmount;
      if (vm.formData.investmentType && vm.otmBankLimit &&
        (vm.formData.purchaseAmount || vm.formData.installmentAmount)) {
        if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
          vm.fiOtmLimitvalidation = vm.formData.installmentAmount > vm.otmBankLimit;
        }
      }
      if((vm.formData.fiOtmBank && vm.formData.fiOtmBank.otmFrequency !== 'AWP') && (vm.selectedFrequency.code === 'BZ')){
        MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
      }
    };
    vm.fiOtmExpiryValidation = function() {
      vm.fiotmExpDate = vm.formData.fiOtmBank && moment(vm.formData.fiOtmBank.omExpiryDate, 'DD-MMM-YYYY');
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP &&
        vm.formData.endDate && angular.isDefined(vm.formData.endDate.format) && vm.fiotmExpDate) {
        vm.fiendDateValidation = vm.formData.endDate && (moment(vm.formData.endDate,"DD-MMM-YYYY")) > (moment(vm.fiotmExpDate,'DD-MMM-YYYY'));
      } else if(vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE){
        vm.endDateValidation = moment().isAfter(vm.fiotmExpDate);
      }
    };
    vm.fiOtmStartValidation = function() {
      vm.otmStrDate = vm.formData.fiOtmBank && moment(vm.formData.fiOtmBank.omStartDate, 'DD-MMM-YYYY');
      if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP && vm.otmStrDate) {
        vm.startDateValidationForFi = vm.formData.fiOtmBank && vm.formData.fiOtmBank.currentDate && (moment(vm.formData.fiOtmBank.currentDate,"DD-MMM-YYYY")) < (moment(vm.otmStrDate,"DD-MMM-YYYY"));
      }
    };
    vm.changedFiPaymentMode = function(){
      if(vm.formData.fiPaymentMode.key=='WEB'){
        vm.formData.fiOtmBank=null;
        vm.fiendDateValidation=false;
        vm.fiOtmLimitvalidation=false;
        vm.startDateValidationForFi = false;
      }
      getDateValidation();
      checkIsModified();
    }

    vm.checkModifySipDetails = function(){
      if($stateParams.fromModify && vm.modifySipData){
        if(vm.modifySipData.startDate && vm.formData.startDate && (vm.modifySipData.startDate !== vm.formData.startDate.format('DD-MMM-YYYY'))){
          vm.modifiedSipDetails = true;
          vm.isSipAmountModified = false;
          return;
        }
        if(vm.modifySipData.endDate && vm.formData.endDate && (vm.modifySipData.endDate !== vm.formData.endDate.format('DD-MMM-YYYY'))){
          vm.modifiedSipDetails = true;
          return;
        }
        if(vm.modifySipData.schemeName && vm.formData.inSchemeName && (vm.modifySipData.schemeName !== vm.formData.inSchemeName)){
          vm.modifiedSipDetails = true;
          vm.isSipAmountModified = true;
          return;
        }
        if(vm.modifySipData.amount && vm.formData.amount && (vm.modifySipData.amount !== vm.formData.amount)){
          vm.modifiedSipDetails = true;
          vm.isSipAmountModified = true;
          return;
        }
        if(vm.modifySipData.folioNumber && vm.formData.folioNumber && (vm.modifySipData.folioNumber !== vm.formData.folioNumber)){
          vm.modifiedSipDetails = true;
          return;
        }
        if(vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && vm.formData.paymentMode.key && (vm.modifySipData.paymentOption[0].code !== vm.formData.paymentMode.key)){
          vm.modifiedSipDetails = true;
          return;
        }
        if(vm.modifySipData.dividendOption && vm.formData.dividendOption && (vm.modifySipData.dividendOption !== vm.formData.dividendOption)){
          vm.modifiedSipDetails = true;
          return;
        }
        if(vm.modifySipData.firstInstallmentDetails && vm.modifiedFiDetails){
          vm.modifiedSipDetails = true;
          return;
        }
        if(vm.modifySipData.autoFrequency && vm.formData.frequency){
          var selectedFreq = vm.SIP_FREQ_LIST.find(function (data) {
            return data.code == vm.formData.frequency;
          });
          if(selectedFreq && (selectedFreq.name !== vm.modifySipData.autoFrequency)){
            vm.modifiedSipDetails = true;
            vm.isSipAmountModified = true;
            return;
          }
        }
        if(vm.modifySipData.euinCode && vm.formData.euinCode && (vm.modifySipData.euinCode !== vm.formData.euinCode)){
          vm.modifiedSipDetails = true;
          return;
        }
      }
    };

    /**
     * Function responsible for setting payload for modify initiate and showing review screen to user
     */

    function finishModifySip() {
      vm.isSubmitted = true;
      var successSipModal = function () {
          vm.isSubmitted = false;
          resetAllPayloads();
          // $state.go('main.dashboard');
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSipModal = function () {
          resetAllPayloads();
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: vm.formData.investmentType,
              investorName: vm.investorInfo.name
            }, successSipModal, errorSipModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
          if (vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear) {
            vm.formData.topupDetails.capMonthYear = moment(vm.formData.topupDetails.capMonthYear,'DD-MMM-YYYY').format('MMM-YYYY')
          }
        };
      var payLoadForReview = angular.copy(getSipPayload());
      var payload = [];
      var additionalData = {};
      payload.push(payLoadForReview);
      //vm.sipPayload = vm.sipPayload || TransactionInitiateModel.getSipDataModel();
      additionalData.investorName = vm.investorInfo.name;
      additionalData.folioNumber = vm.formData.folioNumber;
      additionalData.sipScheme = vm.formData.inSchemeName;
      additionalData.installmentAmount = vm.formData.installmentAmount;
      additionalData.noOfInstallments = vm.formData.installment;
      if (vm.sipValidations && !vm.sipValidations.isGrowth) {
        additionalData.dividendOption = vm.formData.dividendOption;
        additionalData.growth = false;
      }else if(vm.sipValidations && vm.sipValidations.isGrowth){
        additionalData.growth = true;
      }
      //additionalData.sipFrequency = vm.selectedFrequency.code;
      additionalData.sipFrequency = vm.selectedFrequency.name;
      // additionalData.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
      // additionalData.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();

      if (typeof vm.formData.startDate !== 'string') {
        additionalData.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
      } else {
        additionalData.startDate = vm.formData.startDate;
      }

      additionalData.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();
      var diffInMonthsOfDates = parseInt(moment(vm.formData.endDate).diff(moment(vm.formData.startDate), 'months', true));
      additionalData.sipTopupEnabled = vm.formData.sipTopupSelected && diffInMonthsOfDates >= 6;
      additionalData.topupDetails = vm.formData.topupDetails;
      additionalData.weeklyDay = vm.formData.weeklyDay;
      if (!additionalData.topupDetails.capAmount) {
        additionalData.topupDetails.capMonthYear = moment(vm.formData.topupDetails.capMonthYear).format('DD-MMM-YYYY');
      } else {
        additionalData.topupDetails.capMonthYear = undefined
      }
      additionalData.paymentMode = vm.formData.paymentMode;
      if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
        additionalData.otmBank = vm.formData.otmBank;
      }
      if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'HEM') {
        additionalData.eMandateBank = vm.formData.eMandateBank.bankName.substr(0,vm.formData.eMandateBank.bankName.lastIndexOf('-'));
        additionalData.accountNumber = vm.formData.eMandateBank.accountNumber;
        additionalData.authMode = vm.authMode;
        additionalData.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
        additionalData.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
        additionalData.authenticationMode = vm.authMode;
        additionalData.mandateAmount = vm.formData.emandateAmount;
      }

      if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'UPI') {
        payload[0].bankDetailsForECS = {
          "accNumber": vm.formData.upiBank.accountNumber,
          "branchName": vm.formData.upiBank.bankBranch,
          "bankName": vm.formData.upiBank.bankName,
          "accType":vm.formData.upiBank.bankAcType,
          "bankCity":vm.formData.upiBank.bankCity
        }
      }

      if(vm.formData.fiPaymentMode && vm.formData.fiPaymentMode.key == "OTM"){
        additionalData.fiOtmBankName = vm.formData.fiOtmBank.bankName;
        additionalData.fiOtmAccNo = vm.formData.fiOtmBank.bankAcNo;
      }
      if(additionalData.topupDetails.capMonthYear){
        additionalData.topupDetails.capMonthYear = moment(vm.formData.topupDetails.capMonthYear).format('DD-MMM-YYYY');
      }
      additionalData.emailId = vm.emailId;
      additionalData.mobileNumber = vm.mobileNumber;
      additionalData.coperateFlag = vm.investorInfo.corporateFlag;
      additionalData.sipFirstInstallment = vm.formData.sipFirstInstallment;
      additionalData.fiPaymentMode = vm.formData.fiPaymentMode;
      if(vm.formData.subBrokerARN){
        additionalData.subBrokerArn = vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        additionalData.subBrokerCode = vm.formData.subBrokerCode;
      }
      additionalData.euinName = vm.formData.euinName ? vm.formData.euinName : vm.euinNameSelected ? vm.euinNameSelected : null;
      if(vm.formData.euinCode){
        additionalData.euinCode = vm.formData.euinCode;
      }

      ModalService.transactionReviewModal({
        payload: payload, controller: 'sip_modify', additionalData: additionalData , unmodifiedData : vm.modifySipData
      }, success, error);

    }

    function checkIsModified() {
      if($stateParams.fromModify && vm.modifySipData){
        if(vm.formData.startDate && vm.modifySipData.startDate && (vm.formData.startDate.format('DD-MMM-YYYY') !== vm.modifySipData.startDate) || (vm.formData.endDate && vm.modifySipData.endDate && (vm.formData.endDate.format('DD-MMM-YYYY') !== vm.modifySipData.endDate))){
          vm.dateModified = true;
        }else {
          vm.dateModified = false;
        }
        //Checking Euin Modification
        if(vm.formData.euinCode && vm.modifySipData.euinCode && (vm.formData.euinCode !== vm.modifySipData.euinCode) || (vm.formData.euinCode && !vm.modifySipData.euinCode)){
          vm.euinModified = true;
        }else {
          vm.euinModified = false;
        }

        //Checking Scheme Modification
        if(vm.formData.inSchemeName && vm.modifySipData.schemeName && (vm.formData.inSchemeName !== vm.modifySipData.schemeName)){
          vm.schemeModified = true;
          vm.schemeChangeCheck = true;
        }else {
          vm.schemeModified = false;
        }

        //Checking Amount Modification
        if(vm.formData.amount && vm.modifySipData.amount && (vm.formData.amount !== vm.modifySipData.amount)){
          vm.amountModified = true;
        }else {
          vm.amountModified = false;
        }

        //Checking SIP paymentMode Modification
        if(vm.modifySipData.paymentOption && vm.formData.paymentMode && vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && (vm.formData.paymentMode.key !== vm.modifySipData.paymentOption[0].code) || (vm.formData.paymentMode && (!vm.modifySipData.paymentOption || vm.modifySipData.paymentOption.length ==0))){
          vm.sipPaymentModeModified = true;
        }else {
          vm.sipPaymentModeModified = false;
        }

        //checking for change in bank ,in case of OTM/HEM payment Mode
        if(vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.length > 0 && vm.formData.paymentMode){
          if(vm.modifySipData.paymentOption.code == "OTM" && vm.formData.paymentMode.key == "OTM"){
            if(vm.modifySipData.folioBankDetails && vm.formData.otmBank && (vm.modifySipData.folioBankDetails.omUmrn !== vm.formData.otmBank.omUmrn)){
              vm.otmBankDetailModified = true;
            }else {
              vm.otmBankDetailModified = false;
            }
          }else if(vm.modifySipData.paymentOption && vm.modifySipData.paymentOption.code == "HEM" && vm.formData.paymentMode.key == "HEM"){
            if(vm.modifySipData.folioBankDetails && vm.formData.eMandateBank && (vm.modifySipData.folioBankDetails.bankAcNo !== vm.formData.eMandateBank.accountNumber)){
              vm.emandateBankModified = true;
            }else {
              vm.emandateBankModified = false;
            }
          }
        }

        //Checking SIP With Fi paymentMode Modification
        if(vm.formData.fiPaymentMode && vm.modifySipData.firstInstallmentDetails && ((vm.formData.fiPaymentMode.key !== vm.modifySipData.firstInstallmentDetails.paymentMode) || (vm.formData.fiPaymentMode && !vm.modifySipData.firstInstallmentDetails.paymentMode))){
          vm.sipWithFiPaymentModeModified = true;
        }else {
          vm.sipWithFiPaymentModeModified = false;
        }

        //checking for change in bank ,in case of OTM payment Mode For FI
        if(vm.modifySipData.firstInstallmentDetails && vm.modifySipData.firstInstallmentDetails.paymentMode > 0 && vm.formData.fiPaymentMode){
          if(vm.modifySipData.firstInstallmentDetails.paymentMode == "OTM" && vm.formData.fiPaymentMode.key == "OTM"){
            if(vm.modifySipData.folioBankDetails && vm.formData.fiOtmBank && (vm.modifySipData.firstInstallmentDetails.omUmrn !== vm.formData.fiOtmBank.omUmrn)){
              vm.otmBankDetailForFiModified = true;
            }else {
              vm.otmBankDetailForFiModified = false;
            }
          }
        }

        //Checking Frequency Modification
        if(vm.modifySipData.autoFrequency && vm.selectedFrequency && (vm.modifySipData.autoFrequency !== vm.selectedFrequency.name)){
          vm.freqModified = true;
          vm.isSipAmountModified = true;
        }else{
          vm.freqModified = false;
        }

        //checking Topup Details
        if(vm.modifySipData.topupDetails && vm.formData.topupDetails){
          if(!vm.modifySipData.topupDetails && vm.formData.topupDetails){
            vm.topupModified = true;
          }
          if(vm.modifySipData.topupDetails.amount && vm.formData.topupDetails.amount && (vm.modifySipData.topupDetails.amount !== vm.formData.topupDetails.amount)){
            vm.topupAmountModified = true;
          }else{
            vm.topupAmountModified = false;
          }
          if(vm.modifySipData.topupDetails.frequency && vm.formData.topupDetails.frequency && (vm.modifySipData.topupDetails.frequency !== vm.formData.topupDetails.frequency)){
            vm.topupFreqModified = true;
          }else {
            vm.topupFreqModified = false;
          }
          if(vm.modifySipData.topupDetails.capMonthYear && vm.formData.topupDetails.capMonthYear && (vm.modifySipData.topupDetails.capMonthYear !==vm.formData.topupDetails.capMonthYear)){
            vm.capMonthYearModified = true
          }else {
            vm.capMonthYearModified = false;
          }
          if(vm.modifySipData.capAmount && vm.formData.topupDetails.capAmount && (vm.modifySipData.capAmount !== vm.formData.topupDetails.capAmount)){
            vm.capAmountModified = true;
          }else {
            vm.capAmountModified = false;
          }
        }
        checkBtnDisableForModifySip();
      }
    }

    function checkBtnDisableForModifySip() {
      if(vm.dateModified || vm.euinModified || vm.schemeModified || vm.amountModified || vm.sipPaymentModeModified || vm.otmBankDetailModified
         || vm.emandateBankModified || vm.sipWithFiPaymentModeModified || vm.otmBankDetailForFiModified || vm.freqModified || vm.topupModified
         || vm.topupAmountModified || vm.topupFreqModified || vm.capMonthYearModified || vm.capAmountModified){
        vm.disableBtnForModify = false;
      }else {
        vm.disableBtnForModify = true;
      }
    }

    function validateTopUpDetailsInCaseOfModify() {
      if(vm.formData.topupDetails && vm.sipTopupSelected){
        if((vm.formData.topupDetails.capAmount && vm.isminCapAmount) || vm.isMinTopupAmount){
          vm.topupDetailsInvalid = true
        }else {
          vm.topupDetailsInvalid = false;
        }
      }else {
        return
      }
    }

    function fetchBankListForSipUpi() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) {
              vm.upiBankListForSIP = resp.data.bankList;
              if (vm.upiBankListForSIP && vm.upiBankListForSIP.length === 1) {
                vm.formData.upiBank = vm.upiBankListForSIP[0];
              }

              // if redirected to sip page via quick sip review setting payment mode mandate as default and set bank list based on default value on mandate bank list
              if ($stateParams.fromQuickSip && $stateParams.schemeCode && !vm.isEmandateEnabled && vm.formData.paymentMode !== 'UPI') {
                vm.setQuickSipPaymentOptionsAndBank();
              }
            }
            else{
              vm.upiBankListForSIP  = [];
            }
          } else {
            vm.upiBankListForSIP = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.upiBankListForSIP = null;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "trnxType": "PURCHASE",
        "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false,
        "sipUpiFlow" : true
      };
      LoaderService.showLoader();
      InvestorCommonServiceVersion2.post({
        child1: 'investor',
        child2: 'upi',
        child3: 'bank',
        child4: 'list'
      }, payload).$promise.then(success, error);
    }

    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }


    function sipPurchaseAddToCart(transaction){
      addToEcart();
    }

    function addToEcart() {
      var payload = {
        folioNumber: vm.formData.folioNumber,
        fundCode :  vm.formData.fundCode,
        schemeCode: vm.formData.inSchemeCode,
        installmentAmount: vm.formData.installmentAmount,
        amount: vm.formData.purchaseAmount,
        dividendOption: vm.formData.purchaseDividendOption || vm.formData.dividendOption,
        euinOpted:(vm.formData.euinCode && vm.formData.euinName) ? 'Y' : 'N',
        euinCode: vm.formData.euinCode ? vm.formData.euinCode:null,
        euinName: vm.formData.euinName ? vm.formData.euinName:null,
        minorFlag: vm.formData.minorFlag,
        purchaseOpted: vm.formData.investmentType === 'PURCHASE' ? true : false,
        sipOpted : vm.formData.investmentType === 'SIP' ? true : false,
        addTocart : true
      };
      if (vm.formData.investmentType === 'SIP') {
        payload.frequency =  vm.formData.frequency;
        payload.sipDate =  $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
        payload.toDate = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY");
      }
      vm.ecartData = payload;
      vm.showEcartModel = true;
      vm.isFromInitiateSipPurchase = true;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }
    function closeAction(action) {
      vm.showEcartModel = false;
      if (action === 'saved') {
        $state.reload();
      }
    }
    $scope.$on('hidingSidebar',function (){
      vm.showSideBarCart = false;
      vm.showSideBarInvest = false;
      vm.showSideAllFunds = false;
      vm.showAddCart = false;
    });

    function checkUPIForSipWithFI(){
      if(vm.formData.sipFirstInstallment && vm.formData.paymentMode.key === 'UPI'){
        vm.UpiSelectedFI = true;
        vm.formData.fiPaymentMode= {key: 'UPI',value: 'UPI Autopay'};
      } else {
        vm.UpiSelectedFI = false;
        if(vm.formData.fiPaymentMode && vm.formData.fiPaymentMode.key == 'UPI'){
          vm.formData.fiPaymentMode = vm.sipFirstInstallmentPaymentMode[0];
        }
      }
    }



    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.maxMandateDurationYears, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }


    function checkAmountValidationEmandate() {
      if (vm.formData.emandateAmount) {
        vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
        vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
        vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.installmentAmount ? true : false;
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      } else {
        vm.formData.emandateWord = {};
      }
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        updateEndDates(false,false,true);
      }
    }

    function handleMandateCalender() {
      if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM' && vm.sipDateLessEmandate) {
        vm.formData.endDate = null;
      }
    }

    function changeDateEmandate(date) {
      vm.formData.emandateDate = date ? date : null;
    }

    function changeEotmNotes() {
      if (vm.authMode.value === "DEBIT_CARD") {
        vm.dynamicNoteEotm = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_eOTM_Debit_Card;
      } else {
        vm.dynamicNoteEotm = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_eOTM;
      }
    }
    function checkForModifyAndSetTopUp() {
      if($stateParams.fromModify && vm.modifySipData && vm.modifySipData.topupDetails && (vm.selectedFrequency.code == 'OM' || vm.selectedFrequency.code == 'Q')) {
        if (vm.topUpDetailsUpdated) {
          resetTopUpDetails();
        } else {
          setModifyTopUpData();
          vm.getTopupFrequencyList();
          vm.changeTopupAmount(vm.sipPurchaseForm);
          capAmountChanged(vm.sipPurchaseForm);
          if(vm.formData.topupDetails && vm.formData.topupDetails.amount){
            $window.NumToWord(vm.formData.topupDetails.amount, 'topupAmntInWords');
          }
          if(vm.formData.topupDetails && vm.formData.topupDetails.capAmount){
            $window.NumToWord(vm.formData.topupDetails.amount, 'capAmntInWords');
          }
        }
        /*vm.formData.topupDetails =  ? {} : angular.copy(vm.modifySipData.topupDetails);
        vm.formData.sipTopupSelected = (vm.topupAmountModified || vm.topupFreqModified || vm.capMonthYearModified || vm.capAmountModified) ? false : true;
        vm.sipTopupSelected = (vm.topupAmountModified || vm.topupFreqModified || vm.capMonthYearModified || vm.capAmountModified) ? false : true;*/

      } else{
        //vm.topupDetailsInvalid = false;
        resetTopUpDetails();
      }
    }

    function resetTopUpDetails() {
      vm.formData.sipTopupSelected = false;
      vm.sipTopupSelected = false;
      vm.formData.topupDetails = {};
    }

    function setModifyTopUpData() {
      vm.formData.topupDetails = angular.copy(vm.modifySipData.topupDetails);
      vm.formData.topupDetails.capAmount = null;
      vm.formData.sipTopupSelected = true;
      vm.sipTopupSelected = true;
    }

    function changeTopUpDetails() {
      if ($stateParams.fromModify && vm.modifySipData && (vm.formData.topupDetails.amount || vm.formData.topupDetails.frequency || vm.formData.topupDetails.capAmount || vm.formData.topupDetails.capMonthYear)) {
        vm.topUpDetailsUpdated = true;
      }
    }
    function setEmandateUpiSetting(){
      vm.maxMandateDurationYears = vm.emandateValidationData.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
      vm.eMandateNoOfDays = vm.emandateValidationData.noOfDays;
      vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
      vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
      vm.emandateMinStartDay = vm.emandateValidationData.minStartDays;
      vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
      vm.formData.emandateWord = {};
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      checkAmountValidationEmandate();
      vm.mandateInfo = vm.emandateValidationData.mandateInfo;
      vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
      vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
      vm.formData.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
      changeDateEmandate(vm.formData.emandateDate);
      updateEmandateEndDate();
      checkUPIForSipWithFI();
      $timeout(function () {
        getDateValidation();
      },100);
      checkIsModified();
    }

    /**
     * function responsible for setting payment option and bank for quick sip flow
     */
    function setQuickSipPaymentOptionsAndBank() {


      var selectedPaymentMode = vm.PAYMENT_MODE.find(function (el) {
        var paymentMode =  vm.upiBankListForSIP && vm.upiBankListForSIP.length > 0 ? 'UPI' : vm.eMandateBankList && vm.eMandateBankList.length > 0 && !vm.isMobileinValid ? 'HEM' : 'EC';
        return el.key === paymentMode;
      });

      if (selectedPaymentMode) {
        vm.formData.paymentMode = selectedPaymentMode;
      }

      if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'UPI') {

        // finding and setting default bank for upi

        var defaultBankUPI = vm.upiBankListForSIP && vm.upiBankListForSIP.length > 0 && vm.upiBankListForSIP.findIndex(function(el) {
          return el.default === true;
        });

        if (typeof defaultBankUPI === 'number' && defaultBankUPI >= 0) {
          $timeout(function () {
            vm.formData.upiBank = vm.upiBankListForSIP[defaultBankUPI];
          },500)
        } else {

          setQuickSipEmandatePaymentOption();

        }
      } else if (vm.formData.paymentMode && vm.formData.paymentMode.key === "HEM") {

        setQuickSipEmandatePaymentOption();

      }


    }

    function paymentOptionOrdering() {
      if (angular.isArray(vm.PAYMENT_MODE)) {
        var emandateOption = { key: 'HEM', value: 'Register E-mandate (eOTM)' };
        var otmIndex = vm.PAYMENT_MODE.findIndex(function(option) {
          return option.key === 'OTM';
        });
        var ecIndex = vm.PAYMENT_MODE.findIndex(function(option) {
          return option.key === 'EC';
        });
        var emandateIndex = vm.PAYMENT_MODE.findIndex(function(option) {
          return option.key === 'HEM';
        });

        if (emandateIndex !== -1) {
          vm.PAYMENT_MODE.splice(emandateIndex, 1);
        }
        if (otmIndex !== -1) {
          vm.PAYMENT_MODE.splice(otmIndex + 1, 0, emandateOption);
        } else if (ecIndex !== -1) {
          vm.PAYMENT_MODE.splice(ecIndex, 0, emandateOption);
        } else {
          vm.PAYMENT_MODE.push(emandateOption);
        }
      }
    }

    function checkUpiError(){
      $timeout(function () {
        if (vm.formData.paymentMode && vm.formData.paymentMode.key == "UPI") {
          if (vm.formData.investmentType == 'SIP' && vm.formData.installmentAmount && vm.upiAmountLimitForSIP && (vm.formData.installmentAmount > vm.upiAmountLimitForSIP && vm.formData.inSchemeName)) {
            var successHandler = function () {
              // vm.formData.paymentMode = vm.PAYMENT_MODE[1];
              vm.formData.paymentMode = vm.PAYMENT_MODE.find(function (el) {
                return el.key === 'OTM' || el.key === 'HEM' || el.key === 'EC';
              }) || null;
              vm.changePaymentMode();

              if (vm.formData.fiPaymentMode && vm.formData.fiPaymentMode.key == "UPI" && vm.formData.sipFirstInstallment) {
                vm.formData.fiPaymentMode = vm.sipFirstInstallmentPaymentMode && vm.sipFirstInstallmentPaymentMode[0];
                vm.changedFiPaymentMode();
              }
            };
            ModalService.genericModal({
              text: vm.upiErrorMessageForSIP
            }, successHandler);
          }
        }
      },100);

      // if(vm.formData.fiPaymentMode && vm.formData.fiPaymentMode.key == "UPI" && vm.formData.sipFirstInstallment){
      //   if(vm.formData.investmentType == 'SIP' && vm.formData.installmentAmount && vm.upiAmountLimitForSIP && (vm.formData.installmentAmount > vm.upiAmountLimitForSIP && vm.formData.inSchemeName)){
      //     var successHandlerForFi = function() {
      //       vm.formData.fiPaymentMode =  vm.sipFirstInstallmentPaymentMode && vm.sipFirstInstallmentPaymentMode[0];
      //       vm.changedFiPaymentMode();
      //     };
      //     ModalService.genericModal({
      //       text: vm.upiErrorMessageForSIP
      //     },successHandlerForFi);
      //   }
      // }
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
            vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
            vm.formData.euinName = vm.euinNameSelected;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      if(vm.formData.subBrokerARN){
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          controller: 'getEuin',
          child2: 'ARN-' + vm.formData.subBrokerARN,
          isSubBroker: true
        }).$promise.then(success, error);
      }
    }

    function setQuickSipEmandatePaymentOption() {

      if (vm.formData.paymentMode && vm.formData.paymentMode.key === "HEM") {
        // finding and setting default bank for emandate

        var defaultBank = vm.eMandateBankList.find(function(el) {
          return el.default === true;
        });

        vm.formData.eMandateBank = angular.copy(defaultBank);

        if (vm.formData.eMandateBank) {
          vm.authMode = vm.formData.eMandateBank && vm.formData.eMandateBank.authenticationModes ? vm.formData.eMandateBank.authenticationModes[0] : null;
        } else {

          var selectedPaymentMode = vm.PAYMENT_MODE.find(function (el) {
            return el.key === 'EC';
          });

          vm.formData.paymentMode = selectedPaymentMode;
        }

      }
    }

  }

})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('RolloverController', rolloverController);

  /** @ngInject */
  function rolloverController(ModalService, LoaderService, $state, $log, $window, AuthService, DistributorGenericService, AppConstants, MessageService, InvestorsService, UtilService, $timeout,$stateParams, panAdharLinkingService) {
    var vm = this;
    vm.isSearching = false;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.showInvestors = showInvestors;
    vm.getRolloverSchemes = getRolloverSchemes;
    vm.fetchRolloverData = fetchRolloverData;
    vm.rolloverDetail = rolloverDetail;
    vm.showInvestorsFlag = false;
    vm.formData = {};
    vm.formData.investorsObj = null;
    vm.investorsObj = {};
    vm.folioCount = null;
    vm.schemeList = null;

    vm.rolloverForm = rolloverForm;
    vm.checkRolloverValidations = checkRolloverValidations;
    vm.fetchFolioList = fetchFolioList;
    vm.validations = {};
    vm.isInvalidForm = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.formData.isChecked = false;
    var identifier = AuthService.getToken();
    vm.loginType = identifier.loginType;
    vm.investorUUID = $stateParams.uuid;
    vm.folioList=null;
    vm.schemeData=null;
    vm.totalUnitsValue = null;
    vm.freeUnitsValue = null;
    vm.totalAmountValue = null;
    vm.freeAmountValue = null;
    vm.dynamicNotes = null;
    vm.init = function () {
      fetchFolioList(vm.investorUUID);
      //getRolloverSchemes();


     var successHandler = function(resp) {
       vm.dynamicNotes = resp.noteDTO.noteDTOMap.Note_Roll_Over;
     }

    UtilService.fetchDynamicData("ROLLOVER").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
     });
    };

    function getRolloverSchemes() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.rolloverSchemes = resp.data.schemes;
          } else {
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        "investorUUID": vm.investorUUID
      };

      LoaderService.showLoader();
      DistributorGenericService.post({
        controller: 'rollover',
        child1: 'schemes-and-investors'
      }, payload).$promise.then(success, error);
    }

    function showInvestors(data) {
      vm.showInvestorsFlag = true;
      vm.investorDetails = data;
      fetchFolioList(vm.investorDetails.uuid);
      vm.searchString = null;
      vm.searchResult = null;
    }

    vm.searchInvestor = function () {
      vm.showInvestorsFlag = false;
      var success = function (resp) {
          // resp = resp.data;
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.searchResult = resp.data && resp.data.searchResponse;
          } else {
            vm.searchResult = null;
            !resp.status && MessageService.error(resp.message)
          }
        },
        error = function () {
          vm.searchResult = null;
          LoaderService.hideLoader();
          MessageService.error();
        };


      if (vm.isSearching || !vm.searchString || vm.searchString.length < 2) {
        vm.searchResult = null;
        return;
      }

      vm.searchResult = null;
      vm.selectedInvestor = null;
      vm.isSearching = true;

      $timeout(function () {
        vm.isSearching = false;
      }, 200);

      LoaderService.showLoader('.popup');
      /*
       var _path = HDFC_API.COMMON_SERVICE_URL + tokenData.arnCode + '/investor/search/' + vm.searchString;
       $http.get(_path).then(success, error);*/
      InvestorsService.post({
        //arnCode: tokenData.arnCode,//vm.modalData.arnCode,
        controller: 'search',
        child1: vm.searchString
      }, null).$promise.then(success, error);
    };

   /* $document[0].addEventListener('keyup', getInvestorOnEnter, false);

    function getInvestorOnEnter() {
      vm.showInvestorsFlag = false;
      if ($state.current.controller === 'RolloverController' && event.which === 13) {
        vm.searchInvestor();
      }
    }

    $scope.$on('$destroy', function () {
      $log.info('Destroy');
      $document[0].removeEventListener('keyup', getInvestorOnEnter, false);
    });*/

    vm.investorChanged = function (val) {
      val = val;
      /*val.isSelectedInvestor = true;
        vm.formData.folioNumber = null;
      val.investorsObj = vm.formData.investorsObj;
      vm.currentIndex = index;*/
    };

    vm.folioChanged = function (val) {
      var result = vm.folioList.find(function (folioList) {
        return folioList.folioNumber === val;
      });
      vm.formData.folioNumber=result.folioNumber;
      vm.formData.investorName=result.investorName;
      vm.formData.emailAddress=result.email;
      vm.formData.mobileNumber=result.mobileNumber;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var successHandler = function(resp) {
        schemeList(val);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus('',vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    };

    vm.SchemeChanged= function (val) {
      var result = vm.schemeList.find(function (schemeList) {
        return schemeList.schemeCode === val;
      });
      vm.formData.schemeData=result;
    };
    function schemeList(folioNo) {
      vm.schemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemeList = resp.data.schemes;
          } else {
            vm.schemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var _config = {child1: 'rollover', child2: 'schemes'};

      DistributorGenericService.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
    }


    function rolloverForm() {
      var scheme = {};
      if (!vm.formData.schemeData.schemeName && vm.loginType=='D') {
        $state.go('main.rolloverView');
      } else if(!vm.formData.schemeData.schemeName && vm.loginType=='A'){
        $state.go('agent.rolloverView');
      }


      scheme.schemeName = vm.formData.schemeData.schemeName;
      scheme.schemeCode = vm.formData.schemeData.schemeCode;
      scheme.folioNumber = vm.formData.folioNumber;
      scheme.totalUnits = vm.formData.schemeData.folioDetails[0].currentValue.totalCurrentValueUnits;
      scheme.freeUnits = vm.formData.schemeData.folioDetails[0].currentValue.freeValueUnits;
      scheme.freeAmount = vm.formData.schemeData.folioDetails[0].currentValue.freeValueAmount;
      scheme.totalAmount = vm.formData.schemeData.folioDetails[0].currentValue.totalCurrentValueAmount;
      scheme.name = vm.formData.investorName ;
      scheme.email=vm.formData.emailAddress;
      scheme.mobileNumber=vm.formData.mobileNumber;
      scheme.investorId = vm.investorUUID;

      sessionStorage.removeItem('rollOverRequest');
      sessionStorage.setItem('rollOverRequest', angular.toJson(scheme));
      vm.loginType=='D' ? $state.go('main.rollover',{uuid: $stateParams.uuid}) : $state.go('agent.rollover');
      //$state.go('main.rollover');
    }

    vm.initAdd = function () {
      vm.schemeData = $window.JSON.parse(sessionStorage.getItem('rollOverRequest'));
      sessionStorage.removeItem('rollOverRequest');
      if (!vm.schemeData) {
        vm.loginType=='D' ? $state.go('main.rolloverView',{uuid: $stateParams.uuid}) : $state.go('agent.home.rolloverView',{uuid: $stateParams.uuid});
      }

      vm.investorId = vm.schemeData && vm.schemeData.investorId;
      vm.formData = vm.schemeData;
      vm.formData.amountType = "Amount";
      vm.formData.amount = "";
      vm.formData.units = vm.schemeData.freeUnits;
      vm.totalUnitsValue = UtilService.getUnitSting(vm.formData.totalUnits);
      vm.freeUnitsValue = UtilService.getUnitSting(vm.formData.freeUnits);
      vm.totalAmountValue = UtilService.getUnitSting(vm.formData.totalAmount);
      vm.freeAmountValue = UtilService.getUnitSting(vm.formData.freeAmount);
    };


    function checkRolloverValidations() {
      vm.validations.minAmount = 0;
      vm.validations.minUnits = 0;
      vm.validations.maxAmount = vm.schemeData && vm.schemeData.currentValue && vm.schemeData.currentValue.freeValueAmount;
      vm.validations.maxUnits = vm.schemeData && vm.schemeData.currentValue && vm.schemeData.currentValue.freeValueUnits;
      if (vm.formData.amountType == 'Amount') {
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount > vm.formData.amount);
      }
      else {
        vm.isMax = !!(vm.validations.maxUnits && vm.validations.maxUnits < vm.formData.units);
        vm.isMin = !!(vm.validations.minUnits > vm.formData.units);
      }


      vm.isInvalidForm = (vm.formData.amount <= 0 && vm.formData.units <= 0) || (vm.formData.amount && (vm.isMax || vm.isMin )) || (vm.formData.units && (vm.isMax || vm.isMin))

    }

    vm.initiateTransaction = function () {
      sessionStorage.removeItem('rollOverRequest');
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.schemeCode,
        "schemeName": vm.formData.schemeName,
        "rolloverMode": vm.formData.amountType,
        "amount":  vm.formData.amount ? vm.formData.amount : 0,
        "units": vm.formData.units ? vm.formData.units : 0,
        "investorUuid": vm.schemeData.investorId,
        "investorName": vm.schemeData.name,
        "email":vm.schemeData.email,
        "mobile":vm.schemeData.mobileNumber
      };

      var successSTPModal = function () {
          vm.isSubmitted = false;
          //var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            //_statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
            $state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'ROLLOVER',
              investorName: vm.schemeData.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        };
        ModalService.transactionReviewModal({
        payload: payload, controller: 'rollover'
      }, success, error);
    }

    function fetchFolioList(investorId) {
      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.folioList = resp.data.folioList;
            vm.folioCount = vm.folioList.length - 1;
            /*vm.sliderWidth = angular.element(".capsule-box").inner;*/
            //angular.element(".capsule-box").innerWidth(vm.dynCapsuleboxWidth);
            vm.selectedFolio = (vm.folioList && vm.folioList.length) ? vm.folioList[0].folioNumber : '';
          }
          else {
            vm.folioList = null;
            vm.isLoading = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('err ', err);
          vm.isLoading = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;

      var payload = {
        "investorUUID": investorId,
        "folioTrxnType": "ROLLOVER"
      };

      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);

    }

    vm.getFolioData = function (folioNumber) {


      vm.rolloverData = null;
      vm.totalrolloverData = 0;
      vm.isPagination = false;
      vm.currentPageRollover = 1;
      vm.selectedFolio = folioNumber ? folioNumber : '';


      if (vm.selectedFolio) {
        fetchRolloverData(folioNumber);
      }
    };

    function fetchRolloverData(folioNumber) {
      LoaderService.showLoader();
      vm.isLoading = true;

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var rolloverData = resp.data;
            vm.rolloverData = [];

            rolloverData && rolloverData.registered && rolloverData.registered.forEach(function (item) {
              item.type = 'registered';
              if (item.rolloverMode == "NoOfUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "AllUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "Amount") {
                item.mode = "amount";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              vm.rolloverData.push(item);
              /*item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
               item.currentValueUnit = UtilService.getUnitSting(item.currentValue);*/
            });
            rolloverData && rolloverData.cancelled && rolloverData.cancelled.forEach(function (item) {
              item.type = 'cancelled';

              if (item.rolloverMode == "NoOfUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "AllUnits") {
                item.mode = "unit";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else if (item.rolloverMode == "Amount") {
                item.mode = "amount";
                item.unitValue = UtilService.getUnitSting(item.amountOrUnits);
              }
              else {
                item.rolloverMode = 'NA'
                item.mode = "amount";
                item.unitValue = 'NA'
                item.amountOrUnits = item.amountOrUnits ? item.amountOrUnits : 'NA'
              }
              vm.rolloverData.push(item);
            });
            vm.totalrolloverData = vm.rolloverData.length;
            vm.isPagination = !!(vm.rolloverData && vm.rolloverData.length);
          }
          else {
            vm.rolloverData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('rollover Err ', err);
          vm.isLoading = false;
          vm.isPagination = false;
          MessageService.error();
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      DistributorGenericService.get({
        controller: 'rollover',
        child1: 'get',
        child2: 'all',
        child3: folioNumber
      }, null).$promise.then(success, error);
    }

    function rolloverDetail(data) {
      var successModal = function () {
          $state.go('login')
        },
        errorModal = function () {
          // MessageService.error(err)
        };
      ModalService.rollOverOverviewModal(data, successModal, errorModal)

    }

  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('RolloverModel', rolloverModel);

  /** @ngInject */
  function rolloverModel() {
    var payload = null, masterRawData = {

    }, schemePayLoad = null;

    function getMasterRawData(type) {
      // if (type.toUpperCase() === 'SIP' || type === 'PURCHASE') {
      //   return angular.copy(masterRawData['SIP-PURCHASE']);
      // }
      return angular.copy(masterRawData[type]);
    }

    function getPayloadRawData() {
      return angular.copy(payload);
    }

    function setPayloadRawData(_payload) {
      payload = angular.copy(_payload);
    }

    function setSchemePayload(_payload) {
      schemePayLoad = angular.copy(_payload);
    }

    function getSchemePayload() {
      return angular.copy(schemePayLoad);
    }

    function emptySchemePayload() {
      schemePayLoad = null;
    }

    function emptyFormPayload() {
      payload = null;
    }

    return {
      getPayloadRawData: getPayloadRawData,
      setPayloadRawData: setPayloadRawData,
      getMasterRawData: getMasterRawData,
      setSchemePayload: setSchemePayload,
      getSchemePayload: getSchemePayload,
      emptySchemePayload: emptySchemePayload,
      emptyFormPayload: emptyFormPayload
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionRedeemController', initiateTransactionRedeemController);

  /** @ngInject */
  function initiateTransactionRedeemController($stateParams, $state, $scope, $rootScope, StoreInvestorModel, SchemeService, MessageService, AppConstants, LoaderService, InvestorsService, AuthService, TransactionService, NudgeRedemptionDynamicData, ModalService, UtilService, HDFC_API, AgentSocketService , panAdharLinkingService, $cookies , $window , InvestorServiceDynamicData) {

    var vm = this;
    var identifier = AuthService.getToken();
    vm.formData = {};
    vm.redeemForm = {};
    vm.init = init;
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.getNudgeDetailsRedemption=getNudgeDetailsRedemption;
    vm.getNudgeRequest=getNudgeRequest;
    vm.changeAmountType = changeAmountType;
    vm.submit = submit;
    vm.getTransactionDetails = getTransactionDetails;
    vm.fetchOutSchemeValidations = fetchOutSchemeValidations;
    vm.confirmCancel = confirmCancel;
    vm.CONST = {
      AMOUNT_TYPE: AppConstants.TRANSACTION.AMOUNT_TYPE
    };
    vm.redeemNudgeDetails = {};
    vm.formData.amountType = 'amount';
    vm.investorUUID = $stateParams.uuid;
    vm.folioListData = null;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investorInfo = null;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.unitsFromTrancsaction = null;
    vm.validations = {minAmount: 0, minUnits: 0, amtMultiples: ''};
    vm.isSubmitted = false;
    vm.hasFolioEmailId = true;
    vm.downloadReport = $scope.$parent.InitiateTransaction.downloadReport;
    vm.formData.all_units = null;
    vm.termsAndContitions = termsAndContitions;
    vm.showTerms = true;
    vm.blockFolioForTransaction = false;

    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
      StoreInvestorModel.setInvestorDetail(null);
    });

    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }
      if ($stateParams.transactionId) {
        vm.investorUUID = $stateParams.uuid;
        getInvestorInfo(function() {
          getTransactionDetails();
        });
      }
      else {
        getInvestorInfo(function() {
          folioList();
        });
      }
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }
    function getTransactionDetails() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
          vm.formData.folioNumber = resp.data.folioNumber;
          vm.changeFolio();
          vm.formData.schemeCode = resp.data.schemeCode;
          fetchUnitDetails();
          fetchOutSchemeValidations(function (err) {
            if (!err) {
              vm.formData.amount = resp.data.amount;
              vm.formData.units = resp.data.units;
            }
          });
        }
        else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function fetchOutSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.schemeCode) {
        return;
      }
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            var _scheme = vm.schemes && vm.schemes.find(function (i) {
              return i.schemeCode === vm.formData.schemeCode;
            }) || {};
            vm.inSchemeName =_scheme.schemeName;
            cb()
          } else {
            vm.inSchemeValidations = null;
            cb('error');
            MessageService.error(resp.message);
          }
          checkValidations();
        },
        error = function (err) {
          cb('error');
          vm.inSchemeValidations = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'redeem',
        child1: vm.formData.schemeCode
      }, null).$promise.then(success, error);
    }

    function checkValidations() {

      if (!vm.inSchemeValidations) {
        vm.validations.minUnits = 0;
        vm.validations.minAmount = 0;
        vm.validations.amtMultiples = '';
      }

      if (vm.inSchemeValidations) {
        vm.validations.minAmount = vm.inSchemeValidations.minRedemptionAmt;
        vm.validations.minUnits = vm.inSchemeValidations.minRedemptionUnit;
        vm.validations.amtMultiples = vm.inSchemeValidations.redeemAmtMultiples;
      }

    }

    function getInvestorInfo(cb) {
      cb = cb || function () {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            if(identifierData && identifierData.loginType=='A'){
              $state.go('agent.home.distributor-home');
            } else {
              $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            }
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        vm.investorInfo = null;
        UtilService.errorHandler(err);
        cb();
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function folioList() {
      LoaderService.showLoader();
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = resp.data.folioList || [];
          var folio = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            folio.push(obj);
          }
          vm.folioListData = folio;
          if ($stateParams.folioNumber) {
            vm.formData.folioNumber = $stateParams.folioNumber;
            vm.changeFolio();
          }
          else if ($stateParams.transactionId) {
            vm.changeFolio();
          }
        } else {
          vm.folioListData = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.folioListData = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function fetchSchemes() {
      vm.schemes = null;
      vm.unitsDetails = null;
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;
            if ($stateParams.schemeCode) {
              vm.formData.schemeCode = $stateParams.schemeCode;
              fetchUnitDetails();
              fetchOutSchemeValidations();
            }
            else if ($stateParams.transactionId) {
              fetchUnitDetails();
              fetchOutSchemeValidations();
            }
          } else {
            vm.schemes = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.schemes = null;
        };
      InvestorsService.post({
        controller: 'folio',
        child1: 'schemes'
      }, {folioNumber: vm.formData.folioNumber, transactionType: 'redemption'}).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      if (!vm.formData.schemeCode) {
        vm.unitsDetails = null;
        return;
      }
      LoaderService.showLoader();
      vm.unitsDetails = null;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.unitsDetails = resp.data;
          vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
          vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
          vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
          if ($stateParams.transactionId) {
            vm.formData.amountType = !vm.formData.units ? 'amount' : (vm.formData.units < vm.unitsDetails.freeValueUnits) ? 'units' : 'all_units';
          }
        } else {
          vm.unitsDetails = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.unitsDetails = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: 'REDEEM'
      }).$promise.then(success, error);
    }

    function changeAmountType() {
      /*(vm.formData.amountType === 'amount') ? (vm.formData.units = '') : (vm.formData.amount = '');*/
      if (vm.formData.amountType === 'amount') {
        vm.formData.units = '';
      } else if (vm.formData.amountType === 'all_units') {
        vm.formData.amount = '';
        vm.formData.units = vm.unitsDetails.freeValueUnits;
        vm.formData.all_units = vm.unitsDetails.freeValueUnits;
        vm.redeemForm.$invalid = false;
      } else {
        vm.formData.amount = '';
        vm.formData.units = '';
      }
      vm.conversionValue = vm.formData.amount || (vm.formData.units ? vm.formData.units * vm.unitsDetails.currentNavValue : '');
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: 'REDEMPTION',
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode
      };
      if (vm.formData.amountType == 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits
      } else if (vm.formData.amountType == 'units') {
        payload.units = vm.formData.units
      } else payload.amount = vm.formData.amount;
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    function submit() {
      vm.isSubmitted = true;

      if (!vm.inSchemeValidations || !vm.inSchemeValidations.navValue) {
        MessageService.error("Scheme validations is unavailable to calculate equivalent value.");
        vm.isSubmitted = false;
        return;
      }

      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.schemeCode,
        "formType": "REDEMPTION",
        "id": $stateParams.transactionId || ""
      };

      if (vm.formData.amountType === 'amount') {
        payload.amount = vm.formData.amount;
        payload.units = 0;
      }
      else if (vm.formData.amountType === 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      }
      else {
        payload.units = vm.formData.units;
        payload.amount = 0;
      }
      payload.transactionMode = vm.CONST.AMOUNT_TYPE[vm.formData.amountType];

      LoaderService.showLoader();
      var successSwitch = function () {
          // $state.go('main.dashboard');
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSwitch = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'Redeem',
              investorName: vm.investorInfo.name
            }, successSwitch, errorSwitch);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isSubmitted = false;
        };


      var _scheme = vm.schemes && vm.schemes.find(function (i) {
        return i.schemeCode === vm.formData.schemeCode;
      }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        schemeName: _scheme.schemeName,
        mobileNumber: vm.mobileNumber ? vm.mobileNumber : '',
        emailId: vm.emailId ? vm.emailId : '',
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag
      };

      var successModal= function()
      {
        ModalService.transactionReviewModal({
          payload: payload, controller: 'redemption', additionalData: additionalData
        }, success, error);
        getNudgeRequest(false);

      };
      var errorModal = function(){
        getNudgeRequest(true);
      };

      var apiCallbackModalService = function (data){
        if(data.exitLoad)
        {
          payload.exitLoad = data.exitLoad;
        }
        if(data.capitalGain)
        {
          payload.capitalGain = data.capitalGain;
        }

        if(angular.isUndefined(data.popUpDescriptionList.REDEMPTION_NUDGE)) {
          successModal();
        } else {
          ModalService.showExitLoadMessageModal({message:data.popUpDescriptionList.REDEMPTION_NUDGE.popUpDescription},successModal, errorModal);
        }
      }
      getNudgeDetailsRedemption(apiCallbackModalService);
    }

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;

        var identifier = AuthService.getToken();
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }

      };
      ModalService.confirmCancelModal({}, success);
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        if(vm.redeemForm.$valid && vm.isCheckedTandC){
          vm.submit();
        }
        e.preventDefault();
      }
      return false;
    };

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData = {};
            vm.formData.folioNumber = null;
            vm.formData.schemeCode = null;
            vm.formData.amount = '';
            vm.formData.units = '';
            vm.formData.amountType = 'amount';
            vm.unitsDetails = null;
            vm.redeemForm.$setPristine();
          }
        });
      }
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);


    };

    function getRedeemPayloadToSave() {

      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.schemeCode,
        "formType": "REDEMPTION",
        "id": $stateParams.transactionId || ""
      };

      if (vm.formData.amountType === 'amount') {
        payload.amount = vm.formData.amount;
        payload.units = 0;
      }
      else if (vm.formData.amountType === 'all_units') {
        payload.units = vm.unitsDetails.freeValueUnits;
        payload.amount = 0;
      }
      else {
        payload.units = vm.formData.units;
        payload.amount = 0;
      }
      payload = {
        "folioNumber": "13016301",
        "schemeCode": "MCOG",
        "formType": "REDEMPTION",
        "id": "",
        "amount": 1000,
        "units": 0
      }
      return angular.copy(payload);
    }

    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getRedeemPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'redemption',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.formData.schemeCode) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
      if (angular.isFunction(stateChangeStart())) {
        stateChangeStart();
      }
    });
    /*Socket code End*/
    function getNudgeDetailsRedemption(apiCallbackModalService){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.status) {
          apiCallbackModalService && apiCallbackModalService(resp.data);
        } else {
          vm.isSubmitted=false;
          MessageService.error(resp.message);
        }
      }, error = function () {
      };
      var payload = {
        "folioNumber":vm.formData.folioNumber,
        "schemeCode":vm.formData.schemeCode,
        "transactionType":"REDEMPTION",
        "redemptionAmount":vm.formData.amount ? vm.formData.amount : 0,
        "redemptionUnits":vm.formData.units ? vm.formData.units :0
      };

      NudgeRedemptionDynamicData.post({
        child1: 'nudge',
        child2: 'popup'
      }, payload).$promise.then(success, error);
    }

    function getNudgeRequest(nudgeSuccess){
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp && resp.status)
        {
          var successModal= function(){
          };
          var errorModal= function(){
            $state.go('main.dashboard');
            return;
          }
          if(nudgeSuccess)
          {
            ModalService.stayInvestedModal({msg:(resp.data && resp.data.message)}, successModal, errorModal)
          }

        }
        else{
          MessageService.error(resp.message);
        }
      }, error = function () {

      };

      var nudgePayload = {
        "folioNumber":vm.formData.folioNumber,
        "popUpType":"REDEMPTION_NUDGE",
        "nudgePopup":true,
        "nudgeSuccess":nudgeSuccess
      };

      NudgeRedemptionDynamicData.post({
        child1: 'nudge',
        child2: 'request'
      }, nudgePayload).$promise.then(success, error);
    }

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };
  }
})();

/** Created by TTN on 03-05-2023 **/

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionInstantRedeemController', initiateTransactionInstantRedeemController);

  /** @ngInject */
  function initiateTransactionInstantRedeemController($stateParams, $state, $scope, $rootScope, StoreInvestorModel, SchemeService, MessageService, AppConstants, ModalService, UtilService, InvestorsService, AuthService, LoaderService, InvestorsCommonService, TransactionService, HDFC_API, NudgeRedemptionDynamicData, DynamicDataReview, panAdharLinkingService) {

    var vm = this;
    vm.init = init;
    vm.formData = {};
    vm.redeemForm = {};

    vm.CONST = {
      AMOUNT_TYPE: AppConstants.TRANSACTION.AMOUNT_TYPE
    };
    vm.redeemNudgeDetails = {};
    vm.formData.amountType = 'amount';
    vm.investorUUID = $stateParams.uuid;
    vm.folioListData = null;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investorInfo = null;
    vm.unitsDetails = null;
    vm.inSchemeValidations = null;
    vm.unitsFromTrancsaction = null;
    vm.hasFolioEmailId = true;
    vm.downloadReport = $scope.$parent.InitiateTransaction.downloadReport;
    vm.formData.all_units = null;
    vm.showTerms = true;
    vm.isMin = false;
    vm.isMax = false;
    vm.bankList = null;
    vm.checkInstantRedeemAmtValidation = checkInstantRedeemAmtValidation;
    vm.confirmCancel = confirmCancel;
    vm.schemeErrorMessage = null;
    vm.bankErrorMessage = null;
    vm.termsAndContitions = termsAndContitions;
    vm.validateDataForScheme = {};
    vm.dynamicData = DynamicDataReview;
    vm.IAF_NOTES = vm.dynamicData.noteDTO.noteDTOMap.Note_IAF;
    vm.schemeChanged = schemeChanged;


    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }
      getInvestorInfo();
      folioList();
    }

    function getInvestorInfo() {
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //checkIsTxnBlock(resp.data.panNumber);
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            if(identifierData && identifierData.loginType=='A'){
              $state.go('agent.home.distributor-home');
            } else {
              $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            }
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        vm.investorInfo = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function folioList() {
      LoaderService.showLoader();
      // var payload = {"investorUUID": vm.investorUUID};
      var payload = {
        "investorUUID" : vm.investorUUID,
        "folioTrxnType": "IAF"
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = resp.data.folioList || [];
          var folio = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            folio.push(obj);
          }
          vm.folioListData = folio;
          if ($stateParams.folioNumber) {
            vm.formData.folioNumber = $stateParams.folioNumber;
            vm.changeFolio();
          }
          else if ($stateParams.transactionId) {
            vm.changeFolio();
          }
        } else {
          vm.folioListData = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.folioListData = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    vm.changeFolio = function () {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.nomineefolioList && vm.nomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.nomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            $state.reload();
          }
        });
      }
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var successHandlerForPanAadhar = function(){
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }, errorHandlerForPanAadhar = function(){
        vm.formData.folioNumber = null;
      }
      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,identifierData.arnCode).then(successHandlerForPanAadhar).catch(errorHandlerForPanAadhar);
    };

    function fetchSchemes() {
      vm.schemes = null;
      vm.unitsDetails = null;
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemeList;
            vm.bankList = resp.data.bankList;
            vm.minAmount = resp.data.minAmount;
            if(vm.schemes.length == 0){
              vm.schemeErrorMessage = 'Scheme data not available under this folio';
            }
            if(vm.bankList.length == 0){
              vm.bankErrorMessage == 'No any bank mapped under this folio.';
            }
          } else {
            vm.schemes = null;
            vm.bankList = null;
            vm.schemeErrorMessage = null;
            vm.bankErrorMessage = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.schemes = null;
          vm.bankList = null;
          vm.schemeErrorMessage = null;
          vm.bankErrorMessage = null;
        };
      var payload = {
        folioNumber : vm.formData.folioNumber,
        transactionType : 'redemption'
      };
      InvestorsCommonService.post({
        child1: 'scheme',
        child2: 'instantRedemption'
      }, payload).$promise.then(success, error);
    }

    function checkInstantRedeemAmtValidation() {
      vm.isMax = false;
      vm.isMin = false;
      if(vm.formData.amount && vm.minAmount && (vm.formData.amount < vm.minAmount)){
        vm.isMin = true;
      }else if(vm.formData.amount && vm.formData.scheme && vm.formData.scheme.maxAmount && (vm.formData.amount > vm.formData.scheme.maxAmount)){
        vm.isMax = true;
      }
    }

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;

        // var token = AuthService.getToken();
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }

      };
      ModalService.confirmCancelModal({}, success);
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        if(vm.redeemForm.$valid && vm.isCheckedTandC && !vm.isMin && !vm.isMax){
          vm.submitFirst();
        }
        e.preventDefault();
      }
      return false;
    };

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: 'REDEMPTION',
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.scheme.schemeCode,
        amount : vm.formData.amount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    function submit() {
      vm.isSubmitted = true;

      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.scheme.schemeCode,
        "formType": "REDEMPTION",
        "amount" : vm.formData.amount,
        "id" : "",
        "units" : 0,
        "transactionMode" : "AMOUNT",
        "isInstantRedemption" : true
      };

      LoaderService.showLoader();
      var successSwitch = function () {
          // $state.go('main.dashboard');
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSwitch = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'Redeem',
              investorName: vm.investorInfo.name
            }, successSwitch, errorSwitch);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isSubmitted = false;
        };

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        schemeName: vm.formData.scheme.schemeName,
        mobileNumber: vm.mobileNumber ? vm.mobileNumber : '',
        emailId: vm.emailId ? vm.emailId : '',
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag
      };

      var successModal= function()
      {
        ModalService.transactionReviewModal({
          payload: payload, controller: 'instant_redemption', additionalData: additionalData
        }, success, error);
        getNudgeRequest(false);

      };
      var errorModal = function(){
        getNudgeRequest(true);
      };

      var apiCallbackModalService = function (data){
        if(data.exitLoad)
        {
          payload.exitLoad = data.exitLoad;
        }
        if(data.capitalGain)
        {
          payload.capitalGain = data.capitalGain;
        }
        if(angular.isUndefined(data.popUpDescriptionList.REDEMPTION_NUDGE)){
          successModal();
        }else {
          ModalService.showExitLoadMessageModal({message:data.popUpDescriptionList.REDEMPTION_NUDGE.popUpDescription},successModal, errorModal);
        }
      };
      getNudgeDetailsRedemption(apiCallbackModalService);
    }

    function getNudgeDetailsRedemption(apiCallbackModalService){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.status) {
          apiCallbackModalService && apiCallbackModalService(resp.data);
        } else {
          vm.isSubmitted=false;
          MessageService.error(resp.message);
        }
      }, error = function () {
      };
      var payload = {
        "folioNumber":vm.formData.folioNumber,
        "schemeCode":vm.formData.schemeCode,
        "transactionType":"REDEMPTION",
        "redemptionAmount":vm.formData.amount ? vm.formData.amount : 0
      };

      NudgeRedemptionDynamicData.post({
        child1: 'nudge',
        child2: 'popup'
      }, payload).$promise.then(success, error);
    }

    function getNudgeRequest(nudgeSuccess){
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp && resp.status)
        {
          var successModal= function(){
          };
          var errorModal= function(){
            $state.go('main.dashboard');
            return;
          }
          if(nudgeSuccess)
          {
            ModalService.stayInvestedModal({msg:(resp.data && resp.data.message)}, successModal, errorModal)
          }

        }
        else{
          MessageService.error(resp.message);
        }
      }, error = function () {

      };

      var nudgePayload = {
        "folioNumber":vm.formData.folioNumber,
        "popUpType":"REDEMPTION_NUDGE",
        "nudgePopup":true,
        "nudgeSuccess":nudgeSuccess
      };

      NudgeRedemptionDynamicData.post({
        child1: 'nudge',
        child2: 'request'
      }, nudgePayload).$promise.then(success, error);
    }

    function schemeChanged() {
      vm.formData.amount = null;
      vm.isMin = false;
      vm.isMax = false;
    }

    function checkIsTxnBlock(panNumber) {
      var successHandler = function(resp){
        if (resp) {
          vm.nomineefolioList = resp.folioList;
          vm.nomineeMessage = resp.popUpMessage;
          vm.blockFolioForTransaction = resp.blockFolioForTransaction ? resp.blockFolioForTransaction : false;
        } else {
          MessageService.error();
        }
      };
      UtilService.checkTxnBlock(panNumber).then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }

  }
})();


/**
 * Created by rajnishkumar on 31/05/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionFlexStpController', initiateTransactionFlexStpController);

  /** @ngInject */
  function initiateTransactionFlexStpController($state, $stateParams, $scope, $timeout, InvestorsService, TransactionService, InvestorsCommonService, UtilService, AuthService, MessageService, ModalService, SchemeService, AppConstants, LoaderService, moment, HDFC_API, AgentSocketService, $window , panAdharLinkingService, $cookies , InvestorServiceDynamicData) {

    var vm = this;
    var identifier = AuthService.getToken();
    var VALIDATION_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.fill_end_date = '';
    vm.FlexStpForm = {};
    vm.formData = {minorFlag:'False'};
    vm.formData.euinObj = null;
    vm.folioListData = [];
    vm.transactionConstants = AppConstants.TRANSACTION;
    var dividendConstants = AppConstants.DIVIDEND_OPTIONS;
    vm.daysList = null;
    vm.formData.dividentOption = '';
    vm.formData.stpType = 'T'; //vm.transactionConstants.FIXED_AMOUNT;
    vm.frequencyList = AppConstants.STP_FREQ_LIST_FOR_FIXED;
    vm.allSchemesList = null;
    vm.isSelectedInScheme = true;
    vm.investorUUID = $stateParams.uuid;
    vm.startDate = null;
    vm.endDate = null;
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isSubmitted = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.unitsDetails = null;
    vm.isInScheme = false;
    vm.validations = null;
    vm.validationsData = null;
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isMax = false;
    vm.isResetting = false;
    vm.investorInfo = null;
    vm.viewMode = 'months';
    vm.selectedFrequency = null;
    vm.isShowDefault = 'false';
    vm.stpDevidendOptions = [vm.transactionConstants.REINVEST, vm.transactionConstants.PAYOUT];
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.hasFolioEmailId = true;
    vm.showOrMessage = false;
    var now = moment(new Date(), 'DD-MMM-YYYY');
    vm.startDateFormat = 'DD-MMM-YYYY';
    vm.isSelectedInScheme = true;

    vm.getSchemesList = getSchemesList;

    vm.fields = {
      showDateOfTransfer: false,
      showDayOfTransfer: false,
      showStartEndDate: false,
      showInstallment: false
    };

    vm.init = init;
    vm.changeFolio = changeFolio;
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.inSchemeChanged = inSchemeChanged;
    vm.changeDay = changeDay;
    vm.changeEndDate = changeEndDate;
    vm.changeStartDate = changeStartDate;
    vm.changeInstallments = changeInstallments;
    vm.checkValidations = checkValidations;
    vm.handleEnter = handleEnter;
    vm.submit = submit;
    vm.confirmCancel = confirmCancel;
    vm.termsAndContitions = termsAndContitions;
    vm.amountChanged = amountChanged;
    vm.blured = blured;
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.showTerms = true;
    vm.blockFolioForTransaction = false;


    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      if ($stateParams.schemeCode) {
        vm.formData.schemeCode = $stateParams.schemeCode;
        fetchUnitDetails();
      } else if ($stateParams.transactionId) {
        getInvestorInfo(function() {
          getTransactionDetails();
        });
      }
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      getEuinCodes();
      getInvestorInfo(function() {
        folioList();
      });
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function handleEnter(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        submit();
        e.preventDefault();
      }
      return false;
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType: 'STP',
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        targetSchemeCode: vm.selectedInSchemeCode,
        amount: vm.formData.amount
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);

    };

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function submit() {
      vm.isSubmitted = true;

      if (!identifier || !identifier.arnCode) {
        MessageService.error('Invalid arnCode');
        return;
      }

      if (!vm.validationsData || !vm.validationsData.investmentOption) {
        MessageService.error("Invalid Investment option is selected.");
        vm.isSubmitted = false;
        return;
      }
      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay.value,
        "amount": vm.formData.amount,
        "brokerCode": identifier.arnCode,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency.key,
        "startDate": vm.startDate.clone().format('DD-MMM-YYYY'),
        "endDate": vm.endDate && vm.endDate.clone().format('DD-MMM-YYYY'),
        "formType": "STP",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment || 0
      };

      if (!vm.oversea_arn) {
        payload.euinOpted = vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N';
        payload.euinCode = vm.formData.euinObj && vm.formData.euinObj.euinCode || '';
        payload.euinName = vm.formData.euinObj && vm.formData.euinObj.euinName || '';
      } else {
        payload.euinOpted = 'N';
      }

      if(vm.formData.subBrokerARN){
        payload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        payload.subBrokerCode = vm.formData.subBrokerCode;
      }

      var successSTPModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'FLEXSTP',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };


      var _scheme = vm.schemes && vm.schemes.find(function (i) {
        return i.schemeCode === vm.formData.schemeCode;
      }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        mobileNumber: vm.mobileNumber ? vm.mobileNumber : '',
        emailId: vm.emailId ? vm.emailId : '',
        sourceSchemeName: _scheme.schemeName,
        targetSchemeName: vm.selectedInScheme,
        stpDay: vm.formData.stpDay.name,
        frequency: vm.selectedFrequency.value,
        installments: vm.formData.installment || 0,
        startDate: vm.startDate.clone().format('DD-MMM-YYYY'),
        endDate: vm.endDate && vm.endDate.clone().format('DD-MMM-YYYY'),
        investmentOption: vm.validationsData.investmentOption,
        dividendOption: (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        folioNumber: vm.formData.folioNumber,
        amount: vm.formData.amount,
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag,
        subBrokerArn: vm.formData.subBrokerARN,
        subBrokerCode: vm.formData.subBrokerCode,
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName ? vm.formData.euinObj.euinName : null,
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode ? vm.formData.euinObj.euinCode : null
      };
      ModalService.transactionReviewModal({
        payload: payload, controller: 'flexstp', additionalData: additionalData
      }, success, error);
    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinList = [
              {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              }
            ];
            vm.formData.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.schemeCode = resp.data.sourceSchemeCode;
            fetchUnitDetails();
            vm.selectedInSchemeCode = resp.data.targetSchemeCode;
            vm.selectedInScheme = resp.data.targetSchemeName;
            fetchSchemeValidations(function (err) {
              if (!err) {
                vm.formData.dividentOption = resp.data.dividendOption;
                vm.formData.stpType = resp.data.stpType;
                vm.frequencyList = (vm.formData.stpType == 'F') ? AppConstants.STP_FREQ_LIST_FOR_FIXED : AppConstants.STP_FREQ_LIST_FOR_CAPITAL;
                vm.selectedFrequency = vm.frequencyList.find(function (item) {
                  return item.key === resp.data.frequency;
                });
                changeFrequency();
                vm.isShowDefault = 'true';
                vm.isSelectedInScheme = true;
                vm.formData.stpDay = vm.daysList.find(function (item) {
                  return item.value === +resp.data.stpDay;
                });
                vm.startDate = moment(resp.data.startDate);
                vm.endDate = moment(resp.data.endDate);
                changeDay();
                vm.formData.amount = resp.data.amount;
                checkValidations();
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function getInvestorInfo(cb) {
      cb = cb || function() {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          //getNomineeFolioList(resp.data.panNumber);
          cb();
        } else {
          vm.isSelectedInScheme = true;
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList, 'scheme', vm.selectedInScheme);
    };

    function folioList() {
      var payload = {"investorUUID": vm.investorUUID},
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.folioListData = resp.data.folioList ||[];
            if ($stateParams.folioNumber) {
              vm.formData.folioNumber = $stateParams.folioNumber;
              vm.changeFolio();
            }
          } else {
            vm.folioListData = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function resetAll() {
      vm.isSelectedInScheme=true;
      vm.selectedInScheme = '';
      vm.selectedInSchemeCode = '';
      vm.selectedFrequency = '';
      vm.formData.installment = '';
      vm.fields.showInstallment = false;
      vm.formData.amount = '';
      vm.validationsData = null;
      vm.fill_end_date = "";
      vm.FlexStpForm.$setPristine();
    }

    function fetchUnitDetails() {
      vm.validations = null;
      vm.unitsDetails = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);
            resetAll();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "STP"
      }).$promise.then(success, error);
    }

    function fetchSchemes() {
      // resetAll();
      vm.schemes = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemes = resp.data.schemes;
          } else {
            vm.schemes = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemes = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsCommonService.post({
        child1: 'folio',
        child2: 'schemes',
        child3: 'flex',
        child4: 'stp'
      }, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

    function fetchAllSchemeType() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.schemeList) {
            vm.allSchemesList = resp.data.schemeList;
            vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList);
            if(vm.selectedInSchemeCode){
              var result = vm.allSchemesList.find(function (scheme) {
                return scheme.schemeCode == vm.selectedInSchemeCode;
              });
              vm.selectedInScheme = result.scheme;
            }

          } else {
            vm.allSchemesList = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.allSchemesList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'flexstpenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function changeFolio() {
      vm.hasFolioEmailId = true;
      if (!vm.formData.folioNumber) {
        return;
      } else if (vm.NomineefolioList && vm.NomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.NomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.folioNumber = null;
            resetAll();
          }
        });
      }

      var selectedFolioObj = vm.folioListData.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
      }
      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && fetchSchemes();
          fetchAllSchemeType();
          resetAll();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
       }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    }

    function getSchemesList() {
      if (vm.unitsDetails && vm.unitsDetails.message) {
        MessageService.error(vm.unitsDetails.message);
        return;
      }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      resetDefaults();
      var successSchemeList = function (result) {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.selectedInScheme = null;
            return;
          }
          vm.formData.inSchemeCode = result.schemeCode;
          vm.selectedInSchemeCode = result.schemeCode;
          vm.formData.inSchemeName = result.scheme;
          vm.selectedInScheme = result.scheme;
          vm.selectedInSchemeType = result.schemeType;
          fetchSchemeValidations();
        },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "flexstpenabled",
        isMinor: vm.formData.minorFlag,
        corporateFlag: vm.selectedFolioData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    }

    function inSchemeChanged(schemeData) {
      if (!schemeData) {
        return;
      }else {
        vm.startDate = null;
        vm.endDate = null;
        vm.enabledStartDates = null;
        vm.enabledEndDates = null;
        vm.formData.stpDay = '';
        vm.formData.amount = '';
        vm.selectedFrequency = null;
        vm.isResetting = true;
        resetInputAndSelectField();
        vm.fields.showInstallment = false;
        $timeout(function () {
          vm.isResetting = false;
        }, 0);
        resetDefaults();
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.selectedInScheme = null;
          vm.filterInSchemeList();
          return;
        }
        vm.isSelectedInScheme = true;
        vm.selectedInScheme = schemeData.scheme;
        vm.selectedInSchemeCode = schemeData.schemeCode;
        vm.selectedInSchemeType = schemeData.schemeType;
        fetchSchemeValidations();
      }
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.selectedInSchemeCode) {
        MessageService.error('Please select a scheme first');
        return;
      }
      vm.startDate = null;
      vm.endDate = null;
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = '';
      vm.selectedFrequency = null;
      vm.validationsData = null;
      vm.validations = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.validationsData = resp.data;

            if (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) {
              vm.formData.dividentOption = dividendConstants.GROWTH;
            } else {

              if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === false){
                vm.formData.dividentOption = dividendConstants.PAYOUT;
              }else if(vm.validationsData.dividendPayoutApplicable === false && vm.validationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividentOption = dividendConstants.REINVEST;
              }else if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividentOption = dividendConstants.REINVEST;
              }
            }
            vm.fields.showInstallment = false;
            resetInputAndSelectField();


            cb(null);
          } else {
            cb('error');
            MessageService.error('Some error occurred. Please try again.');
            vm.validationsData = null;
          }
        },
        error = function (err) {
          cb('error');
          vm.validationsData = null;
          UtilService.errorHandler(err);
        };
      var payload = {
        "schemeCode": vm.selectedInSchemeCode,
        "folioNo": vm.formData.folioNumber,
        "transactionType": "STPFLEX"
      };
      SchemeService.post({
        controller: 'schemeValidation',
        type: 'stp',
      }, payload).$promise.then(success, error);
    }

    vm.changeFrequency = function () {
      vm.formData.amount = '';
      resetDefaults();
      changeFrequency();
      if (vm.selectedFrequency && vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        setAmountForCapitalType();
      }
    };

    vm.checkValidScheme = function () {
      $timeout(function () {
        if (vm.allSchemesList && vm.allSchemesList.length > 0) {
          var Arr = [];
          Arr = vm.allSchemesList.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            // vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
          }
        }
      }, 200);
    };

    function changeFrequency() {
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.formData.stpDay = null;
      vm.formData.endDate = null;
      vm.fill_end_date = "";
      if(vm.FlexStpForm && vm.FlexStpForm.amount){
        vm.FlexStpForm.amount.$setPristine();
      }
      if(vm.FlexStpForm && vm.FlexStpForm.day){
        vm.FlexStpForm.day.$setPristine();
      }
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      vm.formData.startDate = null;
      vm.formData.installment = null;
      extractValidationObject(vm.validationsData);
      if (vm.selectedFrequency && vm.selectedFrequency.key === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        vm.fields.showDateOfTransfer = false;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = false;
        vm.fields.showInstallment = true;
        vm.showOrMessage = false;
        updateDatesForDaily()
      } else if (vm.selectedFrequency && vm.selectedFrequency.key === 'OW') {  //week
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'days';
        vm.fields.showDateOfTransfer = true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment = false;
        vm.showOrMessage = false;
      }
      else if (vm.selectedFrequency && vm.selectedFrequency.key === 'OM') {
        vm.viewMode = 'months';
        vm.daysList = AppConstants.DAYS_LIST;
        vm.fields.showDateOfTransfer = true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment = false;
        vm.showOrMessage = true;
      }
      else if (vm.selectedFrequency && vm.selectedFrequency.key === 'Q') {
        vm.viewMode = 'months';
        vm.daysList = AppConstants.DAYS_LIST;
        vm.fields.showDateOfTransfer = true;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = true;
        vm.fields.showInstallment = false;
        vm.showOrMessage = true;
      }
      else {
        vm.daysList = AppConstants.DAYS_LIST;
        vm.viewMode = 'months';
        vm.fields.showDateOfTransfer = false;
        vm.fields.showDayOfTransfer = false;
        vm.fields.showStartEndDate = false;
        vm.fields.showInstallment = false;
        vm.showOrMessage = false;
      }
    }

    function resetDefaults() {
      vm.isResetting = true;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.validations = null;
      extractValidationObject(vm.validationsData);
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }

    function changeDay() {
      if (!vm.selectedFrequency || !vm.formData.stpDay) {
        vm.startDate = null;
        vm.enabledStartDates = null;
        vm.endDate = null;
        vm.enabledEndDates = null;
        vm.fill_end_date = "";
        vm.formData.amount = '';
        if(vm.FlexStpForm && vm.FlexStpForm.amount){
          vm.FlexStpForm.amount.$setPristine();
        }
        return;
      }
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.fill_end_date = "";
      vm.formData.amount = '';
      if(vm.FlexStpForm && vm.FlexStpForm.amount){
        vm.FlexStpForm.amount.$setPristine();
      }
      vm.formData.startDate = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      switch (vm.selectedFrequency.key) {
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          vm.endDate = null;
          vm.enabledEndDates = null;
          break;
      }
    }

    function updateDatesForDaily() {
      var currentDay = moment().add(3+3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var _dd = vm.startDate.format('DD');
      vm.formData.stpDay = {name: _dd, value: _dd};
      // updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? moment(vm.startDate) : moment(new Date());
      } else {
        currentDay = moment().add(3+3, 'days');
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === vm.formData.stpDay.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //console.log('enabledStartDates[0]===== ',enabledStartDates);
      //vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.maxDateStart = $window.moment(vm.enabledStartDates[vm.enabledStartDates.length -1]).add(1,'days');
      vm.minStartDate = angular.copy($window.moment(vm.enabledStartDates[0]).subtract(1,'minutes'));
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = vm.startDate ? moment(vm.startDate) : moment(new Date());
      } else {
        currentDay = moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.formData.stpDay.value);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      while (_diff < 10) {
        updatedDate.add(30+3, 'days').set('date', vm.formData.stpDay.value);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }
      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }

      // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      //console.log(enabledStartDates)
      //vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.maxDateStart = $window.moment(vm.enabledStartDates[vm.enabledStartDates.length -1]).add(1,'days');
      vm.minStartDate = angular.copy($window.moment(vm.enabledStartDates[0]).subtract(1,'minutes'));
      updateEndDates();
    }

    function updateEndDates() {
      //var installment = vm.formData && vm.formData.installment ? vm.formData.installment : null;
      if (!vm.startDate) {
        return;
      }
      var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      switch (vm.selectedFrequency.key) {
        case'DZ':
        case'OW':
          var days = 0;
          var minInstallmentsDays = vm.validations.minInstallments || 6;
          minInstallmentsDays =  minInstallmentsDays - 1;
          endDate = vm.startDate.clone().add(minInstallmentsDays, 'weeks');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0,minInstallmentIndex;
          minInstallmentIndex = vm.validations && vm.validations.minInstallments ? vm.validations.minInstallments * vm.selectedFrequency.monthfreq : vm.selectedFrequency.key === 'OM' ? 5:2;
          minInstallmentIndex = minInstallmentIndex - 1 * vm.selectedFrequency.monthfreq;
          endDate = vm.startDate.clone().add(minInstallmentIndex, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates;//enabledEndDates.slice(minInstallments);
      vm.minEndDate = vm.enabledEndDates[0];
      vm.maxDateEnd = new Date(2099, 12, 31);
      reSetting();

      /*if (!installment) {
       var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
       vm.enabledEndDates = enabledEndDates.slice(minInstallments);
       } else {
       vm.enabledEndDates = enabledEndDates;
       }*/
    }

    function reSetting() {
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
    }

    function changeStartDate(date) {
      /*if (date) {
        vm.formData.startDate && vm.formData.startDate.set({'year': date.year(), 'month': date.month(), 'date': date.date()});
        vm.formData.startDate=date._i?date._i:null;
        updateEndDates();
        // vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate,'days')+1;
      } else {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
      }*/
      vm.formData.startDate = date ? date : null;
      vm.startDate = vm.formData.startDate;
      /*if(vm.selectedFrequency.key=='DZ'){
        var _dd = vm.startDate.format('DD');
        vm.formData.stpDay = {name: _dd, value: _dd};
      }*/
      vm.formData.endDate = null;
      vm.endDate = null;
      vm.fill_end_date = "";
      vm.enabledEndDates = null;
      vm.formData.amount = "";
      if(vm.FlexStpForm && vm.FlexStpForm.amount){
        vm.FlexStpForm.amount.$setPristine();
      }
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      updateEndDates();
    }

    function changeEndDate(date) {
      if (date) {
        vm.endDate = date;
        vm.formData.endDate = date._i ? date._i : "";
        var daysDuration;
        if (!vm.endDate) {
          return;
        }
        vm.fill_end_date = "";
        switch (vm.selectedFrequency.key) {
          case'DZ':
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'days') + 1;
            calculateSTPMinAmountAndMultiples('BZ', vm.validationsData.dailyMinInstallmentNumber);
            break;
          case 'OW':
            daysDuration = (vm.endDate.diff(vm.startDate, 'days') + 1) / 7;
            vm.formData.installment = Math.ceil(daysDuration);
            calculateSTPMinAmountAndMultiples('OW', vm.validationsData.weeklyMinInstallmentNumber);

            if (vm.selectedInSchemeType === "ELSS" && (vm.formData.installment >= 6)) {
              vm. fill_end_date = "Since your selected ELSS scheme, So please keep your minimum installment amount as Rs " + vm.validations.minAmount + ".";
            }else if(vm.formData.installment >= 6 && vm.formData.installment < 12) {
              vm.fill_end_date = "Since your selected no. of installments are less than 12, So please keep your minimum " +
                "installment amount as Rs "+(vm.validations.minAmount)+".";
            }else {
              vm.fill_end_date = "Since your selected no. of installments are more than 12 or equal to 12, So please keep your minimum installment amount as Rs " + (vm.validations.minAmount)+".";
            }
            vm.formData.amount="";
            if(vm.FlexStpForm && vm.FlexStpForm.amount){
              vm.FlexStpForm.amount.$setPristine();
            }

            break;
          case 'OM' :
            vm.formData.installment = (vm.endDate.diff(vm.startDate, 'months'))+1;
            calculateSTPMinAmountAndMultiples('OM', vm.validationsData.monMinInstallmentNumber);
            break;
          case 'Q':
            daysDuration = (vm.endDate.diff(vm.startDate, 'months') + 1) / 3;
            vm.formData.installment = Math.ceil(daysDuration);
            calculateSTPMinAmountAndMultiples('Q', vm.validationsData.quarterlyMinInstallmentNumber);
            break;
          case 'H':
            daysDuration = (vm.endDate.diff(vm.startDate, 'months')) / 6;
            vm.formData.installment = Math.ceil(daysDuration);
            break;
          case 'Y':
            vm.formData.installment = vm.endDate.diff(vm.startDate, 'years');
            break;
          default :
        }
      } else {
        vm.endDate = null;
        vm.enabledEndDates = null;
      }
    }

    function changeInstallments() {
      vm.formData.amount = "";
      if(vm.FlexStpForm && vm.FlexStpForm.amount){
        vm.FlexStpForm.amount.$setPristine();
      }
      calculateSTPMinAmountAndMultiples('BZ', vm.validationsData.dailyMinInstallmentNumber);
      // updateEndDates();
    }

    function extractValidationObject(validationsData) {
      if (!validationsData || !vm.selectedFrequency || !vm.unitsDetails) {
        return;
      }
      vm.validations = {};

      switch (vm.selectedFrequency.key) {
        case 'DZ':
          vm.validations.amountMultiples = validationsData.dailyAmtMultiples;
          vm.validations.maxAmount = validationsData.dailyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.dailyMaxAmt;
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.dailyMinAmt;
          vm.validations.minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          vm.validations.amountMultiples = validationsData.weeklyAmtMultiples;
          vm.validations.maxAmount = validationsData.weeklyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.weeklyMaxAmt;
          vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.weeklyMinAmt;
          vm.validations.minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          vm.validations.amountMultiples = validationsData.quarterlyAmtMultiples;
          vm.validations.maxAmount = validationsData.quarterlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.quarterlyMaxAmt;
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.quarterlyMinAmt;
          vm.validations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.validations.amountMultiples = validationsData.monAmtMultiples;
          vm.validations.maxAmount = validationsData.monMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.monMaxAmt;
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.monMinAmt;
          vm.validations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.validations.amountMultiples = validationsData.halfYearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.halfYearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.halfYearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.halfYearlyMinAmt;
          vm.validations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.validations.amountMultiples = validationsData.yearlyAmtMultiples;
          vm.validations.maxAmount = validationsData.yearlyMaxAmt > vm.unitsDetails.freeValueAmount ? vm.unitsDetails.freeValueAmount : validationsData.yearlyMaxAmt;
          vm.validations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.validations.minAmount = validationsData.yearlyMinAmt;
          vm.validations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      vm.validations.minInstallDivisionFlag = validationsData.minInstallDivisionFlag;
      vm.validations.swpTaxCode = validationsData.swpTaxCode;
      vm.validations.isGrowth = validationsData.isGrowth;
      vm.validations.endingType = validationsData.endingType;
      //vm.formData.installment = vm.validations.minInstallments;
      checkValidations();
    }

    function checkValidations() {
      if (vm.formData.stpType === vm.transactionConstants.CAPITAL_APPRECIATION) {
        vm.isMax = false;
        vm.isMin = false;
        vm.isMultiples = true;
      } else {
        vm.isMax = !!(vm.validations && vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount || (vm.unitsDetails && vm.formData.amount > vm.unitsDetails.freeValueAmount));
        vm.isMin = !!(vm.validations && vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isMultiples = vm.validations && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false
      }/*
      if (vm.selectedFrequency && vm.selectedFrequency.key === 'OW') {
        if (vm.selectedInSchemeType === "ELSS") {
          vm.validations.minInstallments = 6;
        }
        else {
          if (vm.formData.amount === '') {
            vm.validations.minInstallments = 6;
            vm.fill_end_date = "";
          }
          else if (vm.formData.amount < 1000) {
            vm.validations.minInstallments = 12;
            vm.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
          else {
            vm.validations.minInstallments = 6;
            vm.endDate = '';
            updateEndDates();
            vm.fill_end_date = "Please Fill The End Date";
          }
        }

      }*/
    }

    function setAmountForCapitalType() {
      switch (vm.selectedFrequency.key) {
        case 'OM':
          vm.formData.amount = 300;
          break;
        case 'Q':
          vm.formData.amount = 1000;
          break;
        default :
          vm.formData.amount = '';
          break;
      }
    }

    function amountChanged(className) {
      UtilService.currentFocusedElement.set(className);
      vm.checkValidations();
    }

    function blured() {
      UtilService.currentFocusedElement.clear();
    }


    function confirmCancel() {

      var success = function () {
        var _statusType = $stateParams.status;
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }
      };
      ModalService.confirmCancelModal({}, success);

    }


    function getFlexStpPayloadToSave() {

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay?vm.formData.stpDay.value:null,
        "amount": vm.formData.amount,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency?vm.selectedFrequency.key:null,
        "formType": "STP",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment||0,
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };
      /*var payload = {
        "investmentOption": "GROWTH",
        "dividendOption": "Z",
        "stpType": "T",
        "folioNumber": "5663377",
        "sourceSchemeCode": "41",
        "stpDay": 1,
        "amount": 1000,
        "brokerCode": "ARN-0821",
        "targetSchemeCode": "62",
        "frequency": "OM",
        "startDate": "01-Mar-2018",
        "endDate": "02-Feb-2018",
        "formType": "STP",
        "id": "",
        "noOfInstallments": 0,
        "subBrokerCode": "",
        "euinOpted": "Y",
        "euinCode": "E031040",
        "euinName": "Pawan Kumar Agrawal"
      }*/
      return angular.copy(payload);
    }

    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var payload = getFlexStpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(VALIDATION_DATA.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(VALIDATION_DATA.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'stp',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.selectedInScheme) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    function getNomineeFolioList(pan) {
      LoaderService.showLoader();
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.NomineefolioList = resp.data.folioList;
            vm.NomineeMessage = resp.data.popUpMessage;
            vm.blockFolioForTransaction = resp.data.blockFolioForTransaction ? resp.data.blockFolioForTransaction : false;
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : pan
      }).$promise.then(success, error);
    };

    function calculateSTPMinAmountAndMultiples(frequency, freqInstallmentNumber) {

      var stopLoop = false;
      if (vm.formData.installment && freqInstallmentNumber && (vm.formData.installment >= freqInstallmentNumber)) {
        vm.validationsData.additionalValidation[frequency].forEach(function (el) {

          if (stopLoop) {
            return;
          }

          if (el.min_installments && el.max_installments) {
            if (vm.formData.installment >= el.min_installments && vm.formData.installment <= el.max_installments) {
              vm.validations.minAmount = el.min_amount_lower;
              vm.validations.amountMultiples = el.amt_multiples;
              stopLoop = true;
            }
          } else {
            vm.validations.minAmount = el.min_amount_lower;
            vm.validations.amountMultiples = el.amt_multiples;
            stopLoop = true;
          }
        });
      }
    }

    function resetInputAndSelectField(){
      vm.selectedFrequency = null;
      vm.formData.amount = null;
      vm.formData.installment = null;
      vm.fill_end_date = null;
      vm.fields.showInstallment = false;
      if(vm.FlexStpForm && vm.FlexStpForm.frequency){
        vm.FlexStpForm.frequency.$setPristine();
      }
      if(vm.FlexStpForm && vm.FlexStpForm.installment){
        vm.FlexStpForm.installment.$setPristine();
      }
      if(vm.FlexStpForm && vm.FlexStpForm.day){
        vm.FlexStpForm.day.$setPristine();
      }
      if(vm.FlexStpForm && vm.FlexStpForm.amount){
        vm.FlexStpForm.amount.$setPristine();
      }
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionFlexSipController', initiateTransactionFlexsipController);

    /** @ngInject */
    function initiateTransactionFlexsipController($state, $stateParams, $scope, $rootScope, $window, DistributorFileUploadService,
                                              AuthService, $timeout, InvestorModel,
                                              MessageService, UtilService, InvestorsService,
                                              TransactionInitiateModel, AppConstants, ModalService, moment,
                                              LoaderService, SchemeService, TransactionService, HDFC_API,
                                              $log, AgentSocketService, InvestorsCommonService, BillJunctionService , dynamicDataSip, panAdharLinkingService) {
      var vm = this;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
      vm.startDate = null;
      vm.enabledStartDates = [];
      vm.endDate = null;
      vm.sipDay = null;
      vm.enabledEndDates = [];
      vm.investorUUID = $stateParams.uuid;
      vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
      vm.sipPayload = TransactionInitiateModel.getSipPayload() || TransactionInitiateModel.getSipDataModel();
      vm.investorPayload = TransactionInitiateModel.getInvestorPayload();
      vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
      vm.EUIN_OPTED = AppConstants.EUIN_OPTED;
      vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
      vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.SIP_END_DATE_OPTIONS = AppConstants.SIP_END_DATE_OPTIONS;
      vm.IFSC_REGEX = AppConstants.ifsc_regex;
      vm.NO_PAYMENT_MODE_ERROR = AppConstants.FLEXSIP_NO_PAYMENT_MODE_ERROR;
      vm.PAYMENT_MODE = AppConstants.FLEX_SIP_PAYMENT_MODES.PAYMENT_MODES_NON_SIP_FI;
      vm.newFolioClickAction = newFolioClickAction;
      vm.isMinPurchaseAmount = false;
      vm.isOtmLimitLess = false;
      vm.otmLimitvalidation = false;
      vm.endDateValidation = false;
      vm.startDateValidation = false;
      vm.otmBankList = null;
      vm.isSubmitted = false;
      vm.sipValidationsData = null;
      vm.sipValidations = null;
      vm.daysList = AppConstants.SIP_DAYS_LIST;
      vm.startDateFormat = 'DD-MMM-YYYY';
      vm.startMaxDate = moment().add(350, 'days');
      vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
      vm.isCheckedTandC = false;
      vm.isSelectedInScheme = true;
      vm.termsAndContitions = termsAndContitions;
      vm.checkValidScheme = checkValidScheme;
      vm.isminCapAmount = false;
      vm.isEmailinValid = false;
      vm.isMobileinValid = false;
      vm.isEmailMobileinValid = false;
      vm.emandateDisplay = true;
      vm.emailMobileValidation = emailMobileValidation;
      vm.isEmandateEnabled = false;
      vm.fromInvestorDetail = false;
      vm.weeklyDaysList=null;
      vm.minEndDate = new Date();
      vm.changeInstallments = changeInstallments;
      var identifier = AuthService.getToken();
      vm.loginType = identifier.loginType;
      var _isSelectingFromDropDown = false;
      vm.isMultiples = false;
      vm.hideOtmRadio = false;
      vm.tpv = tpv;
      vm.invalidAmount = false;
      vm.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
      vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
      vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
      vm.fetchEmailMobile = fetchEmailMobile;
      vm.email = '';
      vm.mobile = '';
      vm.corporateFlag = false;
      vm.modalDataSip = dynamicDataSip;
      vm.dynamicNoteOtmSip = vm.modalDataSip.noteDTO.noteDTOMap.Note_FLEX_SIP_OTM;
      vm.dynamicNoteEotm = vm.modalDataSip.noteDTO.noteDTOMap.Note_FLEX_SIP_eOTM;
      vm.dynamicNoteEotmDebitCard = vm.modalDataSip.noteDTO.noteDTOMap.Note_FLEX_SIP_eOTM_Debit_Card;
      vm.dynamicDataPopupMinorSip = vm.modalDataSip.popupDTO.popupDTOMap.Popup_MINOR_FLEX_SIP;
      vm.dynamicDataMinorBank = vm.modalDataSip.popupDTO.popupDTOMap;
      vm.FLEX_SIP_ONLY_GROWTH = vm.modalDataSip.popupDTO.popupDTOMap.FLEX_SIP_GROWTH_MESSAGE;
      vm.validationMessage = "OTM limit should be twice the SIP amount to proceed with the transaction.";
      vm.isAmountValid = true;
      vm.FlexsipSuggestedAmount = AppConstants.SUGGESTED_AMOUNT_FLEX_SIP;
      vm.changeFirstInstallment = changeFirstInstallment;
      vm.formData.sipFirstInstallment = false;
      vm.sipFirstInstallmentPaymentMode = AppConstants.FLEX_SIP_PAYMENT_MODES.PAYMENT_MODES_SIP_FI;
      vm.dynamicNoteOTMOTM= vm.modalDataSip.noteDTO.noteDTOMap.Note_FLEX_SIP_OTM_FI_OTM;
      vm.fiOtmLimitvalidation=false;
      vm.checkFolio=false;
      vm.emandateMinAmountLimit = null;
      vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.changeEndDateEmandate = changeEndDateEmandate;
      vm.defaultMandateYearDate = AppConstants.EMANDATE_MAX_DURATION_YEARS;
      vm.formData.emandateWord = {};
      vm.handleMandatePaymentOption = handleMandatePaymentOption;

      vm.paymentNavUrl = function ($event) {
        $event.preventDefault();
        $window.open(vm.paymentNavURL);
      };

      /**
       * function responsible for opeing tpv modal
       */
      function tpv() {
        ModalService.tpvModal({});
      }

      /**
       * function responsible for fetching tax status
       */
      function getTaxStatusList(minor) {
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxStatusList = resp.data.taxStatus;
          } else {
            vm.taxStatusList = null;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          vm.taxStatusList = null;
          UtilService.errorHandler(err);
        };
        vm.taxStatusList = null;
        InvestorsService.post({controller: 'tax-status'}, {taxStatusFilter: minor ? 'MINOR' : 'ADULT'}).$promise.then(success, error);
      }

      /**
       * function responsible for fetching flex sip enabled schemes
       */
      function fetchFlexSipEnabledSchemes() {
        if (!vm.investorInfo) {
          MessageService.error("Investor's sole applicant details not found");
          return;
        }
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.masterSipSchemeList = resp.data.schemeList;
            if (vm.sipPayload && vm.sipPayload.schemeCode && vm.masterSipSchemeList.length) {
              var result = vm.masterSipSchemeList.find(function (scheme) {
                return scheme.schemeCode === vm.sipPayload.schemeCode;
              });

              vm.sipScheme = result && result.scheme || null;
              vm.formData.inSchemeName = vm.sipScheme;
              fetchFlexSipSchemeValidations(vm.sipPayload.schemeCode);
            }
            if ($stateParams.schemeCode) {
              var selectedScheme = vm.masterSipSchemeList.find(function (scheme) {
                return scheme.schemeCode === $stateParams.schemeCode;
              });
              vm.formData.inSchemeName = selectedScheme.scheme;
              vm.formData.inSchemeCode = selectedScheme.schemeCode;
              vm.getEmandateBankList(function () {
                vm.changeFrequency();
              });
              fetchFlexSipSchemeValidations(selectedScheme.schemeCode);
            }

            vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
          } else {
            vm.sipSchemeList = null;
            vm.masterSipSchemeList = null;
            vm.sipScheme = null;
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          vm.sipSchemeList = null;
          vm.masterSipSchemeList = null;
          vm.sipScheme = null;
          UtilService.errorHandler(err);
        };

        LoaderService.showLoader();
        SchemeService.get({
          controller: 'scheme',
          type: 'ALL',
          child1: 'flexsipenabled',
          child2: vm.formData.minorFlag,
          child3: vm.selectedFolioData.corporateInvestor
        }, null).$promise.then(success, error);
      }

      /**
       * function responsible for fetching investor info
       */

      function getInvestorInfo(cb) {
        var payload = {"investorUUID": vm.investorUUID};

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.investorInfo = resp.data;
            vm.corporateFlag = vm.investorInfo.corporateFlag;
            getTaxStatusList(vm.investorInfo && vm.investorInfo.minor);
            cb(true);
            /*if($stateParams.schemeCode)
            {
              fetchFlexSipEnabledSchemes(); //this will be called on folio selection
            }*/
          } else {
            vm.investorInfo = null;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          //setDefaults();
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
          vm.investorInfo = null;
        };
        LoaderService.showLoader();
        InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      }

      /**
       * function responsible for fetching folio list
       */

      function fetchFolioList(cb) {
        cb = cb || function () {};
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.folioList = resp.data.folioList || [];
            if ($stateParams.folioNumber) {
              vm.folioNumber = $stateParams.folioNumber;
            } else {
              var activeFolioList = vm.folioList.filter(function(folio){
                return folio.activeFlag === true;
              });
              vm.folioNumber = activeFolioList[0].folioNumber;
            }
            vm.formData.folioNumber = vm.folioNumber;
            if(vm.formData.folioNumber && vm.checkFolio){
              $timeout(function() {
                vm.changeFolio();
              }, 0);
            }
          } else {
            vm.folioList = null;
            vm.folioNumber = '';
            vm.sipPayload.folioNumber = vm.folioNumber;
            // vm.purchasePayload.folioNumber = vm.folioNumber;
            MessageService.error(resp.message);
          }
          cb(true);
        }, error = function (err) {
          vm.folioList = null;
          vm.folioNumber = '';
          vm.sipPayload.folioNumber = vm.folioNumber;
          // vm.purchasePayload.folioNumber = vm.folioNumber;
          UtilService.errorHandler(err);
          cb();
        };

        InvestorsService.post({controller: 'folioList'}, {investorUUID: vm.investorUUID}).$promise.then(success, error);
      }

      /**
       * function responsible for fetching euin list
       */

      function getEuinCodes() {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinList = resp.data.euinList;
            vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
            vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
            vm.formData.euinName = vm.euinNameSelected;
          } else {
            vm.euinList = null;
          }
        }, error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
        };
        LoaderService.showLoader();
        TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
      }

      /**
       * function responsible for fetching the folio list during initialisation
       */

      function folioInit() {
        fetchFolioList();
      }


      /**
       * function responsible for fetching flex sip scheme validations
       *          frequencies are also set dynamically here
       */

      function fetchFlexSipSchemeValidations(schemeCode) {
        vm.sipValidationsData = null;
        //vm.sipPayload.frequency = vm.selectedFrequency.code;
        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.sipValidationsData = resp.data;
              if(vm.sipValidationsData && vm.formData.minorFlag){
                vm.sipValidationsData.cgfFlag = vm.sipValidationsData.cgfFlag ? vm.sipValidationsData.cgfFlag : true;
              }
              vm.SIP_FREQ_LIST = vm.sipValidationsData.additionalValidation.frequency?vm.sipValidationsData.additionalValidation.frequency:null;
              if(vm.SIP_FREQ_LIST.length == 0){
                vm.PAYMENT_MODE=[];
                vm.formData.paymentMode=null;
              }
              var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                return d.code === 'OM';
              }) || {};
              vm.selectedFrequency = frequency?frequency:'';

              if($stateParams.frequency){
                var freq = vm.SIP_FREQ_LIST.find(function (d) {
                  return d.name === $stateParams.frequency;
                }) || {};
                vm.selectedFrequency = freq?freq:'';
              }

              vm.formData.cgfFlag = vm.sipValidationsData.cgfFlag;
              vm.formData.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
              extractSipValidationObject(resp.data, vm.selectedFrequency);
              vm.FlexsipSuggestedAmount = resp.data.amountArray;
              if (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH) {
                ModalService.genericModal({
                  text: vm.FLEX_SIP_ONLY_GROWTH.content,
                },function () {
                  vm.resetAll();
                }, function () {
                  vm.resetAll();
                })
              }
            } else {
              MessageService.error(resp.message);
              vm.sipValidationsData = null;
              vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
            }

          },
          error = function (err) {
            vm.sipValidationsData = null;
            vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
            UtilService.errorHandler(err);
          };
        SchemeService.get({
          controller: 'schemeValidation',
          type: 'sip',
          child1: schemeCode,
          child2: 'FLEXSIP'
        }, null).$promise.then(success, error);
      }


      /**
      * function responsible for setting flex sip payload
      */
      function getFlexSipPayload() {
        var sipPayload = {
          "installmentAmount": vm.formData.installmentAmount,
          "investmentOption": vm.formData.investmentOption,
          "dividendOption": vm.DIVIDEND_OPTIONS.GROWTH,
          "formType": "FLEXSIP",
          "flexSipFrequency": vm.selectedFrequency.code,
          "folioNumber": vm.formData.folioNumber,
          "schemeCode": vm.formData.inSchemeCode,
          "schemeType": vm.formData.schemeType,
          "sipDay": vm.formData.sipDay,
          "flexSip": true
        }

        if (vm.formData.eMandateBank) {
          sipPayload['bankDetailsForECS'] = {
            "accNumber": vm.formData.eMandateBank.accountNumber,
            "accType": vm.formData.eMandateBank.bankAcType,
            "authenticationMode": vm.authMode.value,
            "bankCity": vm.formData.eMandateBank.bankCity,
            "bankCode": vm.formData.eMandateBank.bankCode,
            "bankName": vm.formData.eMandateBank.bankName,
            "branchName": vm.formData.eMandateBank.bankBranch,
            "gateWayVendor": vm.formData.eMandateBank.gateWayVendor,
            "ifscCode": vm.formData.eMandateBank.ifscCode,
            "paymentOption": vm.formData.paymentMode.key
          }
          sipPayload.installmentAmountEMandate = vm.formData.emandateAmount;
          sipPayload.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
          sipPayload.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
          sipPayload.authenticationMode = vm.authMode.value;
          sipPayload.mandateAmount = vm.formData.emandateAmount;
        }
        try {
          sipPayload.toDate = vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '';
          sipPayload.sipDate = vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '';
        } catch (e) {
          sipPayload.toDate = null;
          sipPayload.sipDate = null;
        }


        if (vm.formData.euinOpted === vm.EUIN_OPTED.YES && !vm.oversea_arn) {
          sipPayload.euinName = vm.euinNameSelected;
          sipPayload.euinCode = vm.formData.euinCode;
        }
        if (vm.formData.retirementAgeProofURL) {
          sipPayload.retirementAgeProofURL = vm.formData.retirementAgeProofURL;
        }
        sipPayload.payMech = vm.formData.paymentMode.key;
        if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
          sipPayload.payoutId = vm.formData.otmBank.payoutId;
          sipPayload.omUmrn = vm.formData.otmBank.omUmrn;
          sipPayload.camsMandateIdNo = vm.formData.otmBank.camsMandateIdNo;
        }
        if ($stateParams.txnId) {
          sipPayload.oldTransactionId = $stateParams.txnId;
        }
        if (vm.formData.sipFirstInstallment) {
          sipPayload.sipWithFirstInstallment = vm.formData.sipFirstInstallment;
          sipPayload.firstInstallmentDetails = {};
          if (vm.formData.fiPaymentMode.key === 'OTM') {
            sipPayload.firstInstallmentDetails.paymentMode = vm.formData.fiPaymentMode.key;
            sipPayload.firstInstallmentDetails.payoutId = vm.formData.fiOtmBank.payoutId;
            sipPayload.firstInstallmentDetails.omUmrn = vm.formData.fiOtmBank.omUmrn;
          }
        }
        if(vm.formData.subBrokerARN){
          sipPayload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
        }
        if(vm.formData.subBrokerCode){
          sipPayload.subBrokerCode = vm.formData.subBrokerCode;
        }
        return sipPayload;
      }

      /**
      * function responsible to reset payload data
      */
      function resetAllPayloads() {
        vm.formData = TransactionInitiateModel.getSipPurchaseDataModel();
        TransactionInitiateModel.setSipPurchaseDataModel(vm.formData);
        vm.formData.sipFirstInstallment = false;
        vm.otmBankList = null;
        vm.eMandateBankList = null;
      }

      function extractSipValidationObject(validationsData, frequency) {
        if (!validationsData || !frequency) {
          return;
        }
        vm.sipValidations = {};
        switch (frequency.code) {
          case 'Q':
            vm.additionValidation = vm.sipValidationsData.additionalValidation.Q;
            vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.Q[0].min_amount_lower;
            break;
          case 'OM':
            vm.additionValidation = vm.sipValidationsData.additionalValidation.OM;
            vm.sipValidations.minAmount = vm.sipValidationsData.additionalValidation.OM[0].min_amount_lower;
            break;
        }
        if(!$stateParams.folioNumber){
          vm.formData.installmentAmount =  (vm.sipValidationsData.sipDefaultAmount > vm.sipValidations.minAmount) ?  vm.sipValidationsData.sipDefaultAmount :  vm.sipValidations.minAmount;
          vm.emandateMinAmountLimit = angular.copy(vm.formData.installmentAmount * 2);
          vm.formData.emandateAmount = angular.copy(vm.formData.installmentAmount * 2);
          vm.formData.emandateWord = {};
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate()
        }
        if(vm.formData.installmentAmount){
          $timeout(function () {
           $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392');
         });
       }
        vm.sipValidations.isGrowth = validationsData.isGrowth;
        vm.sipValidations.endingType = validationsData.endingType;
      }

      function updateDatesForOthers(sipFlag) {
        var currentDay = '';
        if ($stateParams.transactionId && vm.formData.startDate) {
          currentDay = vm.formData.startDate ? moment(vm.formData.startDate) : moment();
        } else {
          currentDay = moment();
          vm.formData.startDate = currentDay;
        }
        currentDay.set({
          'hour': 0,
          'minute': 0,
          'second': 0,
          'millisecond': 0
        });

        var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
        updatedDate.set('date', vm.sipDay.value);
        var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

        while (_diff < 15) {
          updatedDate.add(1, 'months').set('date', vm.sipDay.value);
          _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
        }
        var enabledStartDates = [];
        for (var i = 0; i <= 3; i++) {
          var _date = updatedDate.clone().add(i, 'months');
          _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
          if (_diff <= 90) {
            // var a = _date.format('MMM, YYYY').toString();
            enabledStartDates.push(_date.clone());
          }
        }
        // !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
        vm.formData.startDate = angular.copy(enabledStartDates[0]);
        // vm.startMinDateBiller = vm.formData.startDate;
        vm.startMaxDate = enabledStartDates[enabledStartDates.length - 1];
        vm.enabledStartDates = angular.copy(enabledStartDates);
        vm.monthList = enabledStartDates.map(function (ele) {
          return ele.format('MMM, YYYY').toString();
        });
        sipFlag != 'sipFlag' && updateEndDates();
      }

      function updateEndDates(installment) {
        if (vm.isTillPerpetuity || !vm.formData.startDate) {
          return;
        }
        var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
        var defaultMonths = null;
        var endDate = null;
        var enabledEndDates = [];
        var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
        var i = 0, minInstallments = 1;// installmentTotal = 1;
            var months = 0;
            // if (vm.sipValidations.minInstallments) {
            minInstallments = (vm.sipValidations && vm.sipValidations.minInstallments) ? vm.sipValidations.minInstallments : 1;
            var installmentTotal = vm.selectedFrequency.code == 'Q' ? ((minInstallments * 3) - 1) : ((minInstallments * 1) - 1);
            //endDate = vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months'); // commented to hanndle sip minimum installment issue for 6 months
            /*} else {
             endDate = vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months');
             }*/
            // endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'months');
            defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
            freq = freq || (defaultMonths / vm.selectedFrequency.duration);
            for (i = 0; i < freq; i++) {
              months = vm.selectedFrequency.duration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(months, 'months'));
            }
        //vm.minEndDate = angular.copy(vm.formData.startDate.clone());
        //vm.minEndDate = vm.minEndDate.add(installmentTotal, 'months');
        if (!installment) {
          // var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 2) || 0;
          minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 1) || 0;
          vm.enabledEndDates = enabledEndDates.slice(minInstallments);
        } else {
          vm.enabledEndDates = enabledEndDates;
        }
        vm.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        // vm.enabledEndDates = enabledEndDates.slice(minInstallments);
        // !$stateParams.transactionId && (vm.endDate = vm.enabledEndDates[0]);

        //vm.formData.endDate = vm.enabledEndDates[0];
      }

      function setInstallmentCount() {
        if(vm.formData.endDate == null || vm.formData.endDate == ''){return;}
        var daysDuration;
        switch (vm.selectedFrequency.code) {
          case 'OM' :
            vm.formData.installment = vm.formData.endDate.diff(vm.formData.startDate, 'months') * 1 + 1;
            break;
          case 'Q':
            daysDuration = (vm.formData.endDate.diff(vm.formData.startDate, 'months')) / 3;
            vm.formData.installment = Math.ceil(daysDuration);
            break;
          default :
        }
      }

      function getTransactionDetails() {
        var success = function (resp) {
            if (resp.data && resp.status) {
              vm.isExistingFolio = true;
              vm.sipPayload = null;
              // vm.purchasePayload = null;
              vm.investorPayload = null;
              // vm.formData = resp.data;
              // vm.investmentType = resp.data.formType;
              resp.data.formType = resp.data.formType || $stateParams.transactionType.toUpperCase();
              vm.investmentType = resp.data.formType;
              vm.formData = {};
              vm.formData.investmentType = resp.data.formType;
              vm.formData.folioNumber = resp.data.folioNumber;
              vm.formData.inSchemeName = resp.data.schemeName;
              vm.formData.inSchemeCode = resp.data.schemeCode;
              vm.formData.euinOpted = resp.data.euinOpted;
              vm.formData.euinCode = resp.data.euinCode;
              vm.formData.installmentAmount = resp.data.installmentAmount;
              vm.emandateMinAmountLimit = angular.copy(vm.formData.installmentAmount * 2);
              vm.formData.emandateAmount = angular.copy(vm.formData.installmentAmount * 2);
              vm.formData.emandateWord = {};
              $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
              checkAmountValidationEmandate()
              vm.formData.endDate = resp.data.toDate ? resp.data.toDate : null;
              vm.selectedFrequency = resp.data.frequency;
              vm.sipDay = resp.data.sipDay;
              vm.sipStartMonth = moment(resp.data.sipDate).format('MMM, YYYY').toString();
              vm.formData.startDate = resp.data.sipDate ? resp.data.sipDate : null;
              vm.monthList = [moment(resp.data.sipDate).format('MMM, YYYY').toString()];
              vm.euinObj = {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              };

              vm.sipPayload = resp.data;
              vm.folioNumber = resp.data.folioNumber;
              vm.startDate = vm.sipPayload.sipDate ? moment(vm.sipPayload.sipDate) : null;
              vm.endDate = vm.sipPayload.toDate ? moment(vm.sipPayload.toDate) : null;
              if (vm.sipPayload.sipDay) {
                vm.sipDay = {};
                vm.sipDay.name = vm.sipPayload.sipDay;
                vm.sipDay.value = vm.sipPayload.sipDay;
              }

              // TransactionInitiateModel.setPurchasePayload(vm.purchasePayload);
              TransactionInitiateModel.setSipPayload(vm.sipPayload);
              TransactionInitiateModel.setInvestorPayload(vm.investorPayload);

              schemeInit();
            } else {
              $rootScope.$previousState && $state.go('main.dashboard');
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            $rootScope.$previousState && $state.go('main.dashboard');
            UtilService.errorHandler(err);
          };

        if (identifier.loginType == 'A') {
          TransactionService.get({
            VERSION: HDFC_API.VERSION,
            child1: 'agent',
            controller: 'saved',
            child2: 'draft',
            child3: $stateParams.transactionId
          }).$promise.then(success, error);

        } else {
          TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
            transactionId: $stateParams.transactionId,
            type: $stateParams.transactionType
          }).$promise.then(success, error);
        }
      }

      /**
       * function responsible for redirection to folio creation
       */
      function newFolioClickAction() {
        if (!vm.investorInfo && !vm.investorInfo.panNumber) {
          MessageService.error("Investor's sole applicant details not found");
          return;
        }
        var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data && resp.data.verify) {
              InvestorModel.resetInvestorModel();
              var model = InvestorModel.getNewInvestorModel();
              model.folioCreationRequestCO.soleApplicantDetail.name = vm.investorInfo.name;
              model.folioCreationRequestCO.soleApplicantDetail.dob = vm.investorInfo.dob;
              model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.investorInfo.panNumber;
              model.folioCreationRequestCO.soleApplicantDetail.email = vm.email;
              model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.mobile;
              model.folioCreationRequestCO.showNomineeUpdate = vm.sebiNomineeRegulatory01650Active;
              model.folioCreationRequestCO.nomineeLimit = vm.nomineeLimit;
              //model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
              InvestorModel.setInvestorModel(model);
              InvestorModel.setFolioCreationFromProfileAndToDo(true);
              delete $window.sessionStorage.investorForm;
              $window.sessionStorage.investorForm = angular.toJson(model);
              InvestorModel.setTab({
                "tab1": false,
                "tab2": false,
                "tab3": false,
                "tab4": false,
                "tabJointHolderAddable": false,
                "tabGuardianDetailShow": false
              });
              // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
              $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
            } else {
              var message = resp.data && !resp.data.verify ? 'Either KYC verification is pending or name is missing.' : resp.message;
              MessageService.error(message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        var payload = {
          //dob: moment(vm.investorInfo.dateOfBirth, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString(),
          pan: vm.investorInfo.panNumber
        };
        LoaderService.showLoader();
        var successHandler = function(resp) {
          fetchEmailMobile(vm.investorInfo.panNumber, vm.investorInfo.dob, function() {
            InvestorsService.post({
              controller: 'pan',
              child1: 'verify'
            }, payload).$promise.then(success, error);
          });
        }
        var errorHandler = function(resp) {
          LoaderService.hideLoader();
        }
        panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,'', brokerCode).then(successHandler).catch(errorHandler);
      }

      function changeInstallments() {
        if (vm.endDateSelectionOption == vm.SIP_END_DATE_OPTIONS.NO_OF_INSTALLMENT) {
          updateEndDates(vm.formData.installment);
        }
      }

      function schemeInit() {
        getEuinCodes();
        getInvestorInfo(function(resp) {
          if (resp) {
            $timeout(function() {
              vm.changeFolio();
            }, 0);
          }
        });
      }

      /**
       * function responsible to set payload for initiating transaction and open review modal
       */
      function finishFlexSip() {
        vm.isSubmitted = true;
        var successSipModal = function () {
            vm.isSubmitted = false;
            resetAllPayloads();
            // $state.go('main.dashboard');
            var _statusType = $stateParams.status;
            var identifier = AuthService.getToken();
            if (identifier && identifier.loginType == 'A') {
              $state.go("agent.home.distributor-home")
            } else {
              _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
            }
          },
          errorSipModal = function () {
            resetAllPayloads();
            vm.isSubmitted = false;
            var identifier = AuthService.getToken();
            if (identifier && identifier.loginType == 'A') {
              $state.go("agent.home.distributor-home")
            } else {
              $state.go('main.dashboard');
            }
          },
          success = function (resp) {
            if (resp.status && resp.data) {
              ModalService.initiateSuccessModal({
                transactionType: "Flex SIP",
                investorName: vm.investorInfo.name
              }, successSipModal, errorSipModal);
            } else {
              vm.isSubmitted = false;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            vm.isSubmitted = false;
            UtilService.errorHandler(err);
          };
        var payLoadForReview = getFlexSipPayload();
        var payload = [], additionalData = {};
        payload.push(payLoadForReview);
        //vm.sipPayload = vm.sipPayload || TransactionInitiateModel.getSipDataModel();

        additionalData.investorName = vm.investorInfo.name;
        additionalData.folioNumber = vm.formData.folioNumber;
        additionalData.sipScheme = vm.formData.inSchemeName;
        additionalData.installmentAmount = vm.formData.installmentAmount;
        additionalData.noOfInstallments = vm.formData.installment;
        //additionalData.sipFrequency = vm.selectedFrequency.code;
        additionalData.sipFrequency = vm.selectedFrequency.name;
        additionalData.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
        additionalData.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();
        additionalData.paymentMode = vm.formData.paymentMode;
        if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
          additionalData.otmBank = vm.formData.otmBank;
        }
        if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'HEM') {
          additionalData.eMandateBank = vm.formData.eMandateBank.bankName.substr(0,vm.formData.eMandateBank.bankName.lastIndexOf('-'));
          additionalData.accountNumber = vm.formData.eMandateBank.accountNumber;
          additionalData.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
          additionalData.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
          additionalData.authenticationMode = vm.authMode;
          additionalData.mandateAmount = vm.formData.emandateAmount;
        }
        additionalData.emailId = vm.emailId;
        additionalData.mobileNumber = vm.mobileNumber;
        additionalData.coperateFlag = vm.investorInfo.corporateFlag;
        additionalData.isFlexSip = true;
        additionalData.tenureDuration = vm.formData.tenure;
        additionalData.sipFirstInstallment = vm.formData.sipFirstInstallment;
        additionalData.fiPaymentMode = vm.formData.fiPaymentMode;
        if(vm.formData.subBrokerARN){
          additionalData.subBrokerArn = vm.formData.subBrokerARN;
        }
        if(vm.formData.subBrokerCode){
          additionalData.subBrokerCode = vm.formData.subBrokerCode;
        }
        additionalData.euinName = vm.formData.euinName ? vm.formData.euinName : vm.euinNameSelected ? vm.euinNameSelected : null;
        if(vm.formData.euinCode){
          additionalData.euinCode = vm.formData.euinCode;
        }
        ModalService.transactionReviewModal({
          payload: payload, controller: 'flexsip', additionalData: additionalData
        }, success, error);

      }

      /**
       * function responsible for schemes modal
       */
      vm.openSipSchemesModal = function () {
        if (!vm.investorInfo) {
          MessageService.error("Investor's sole applicant details not found");
          return;
        }
        var success = function (result) {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.formData.inSchemeName = null;
            return;
          }
          vm.selectedSchemeType = result.selectedSchemeType;
          vm.formData.inSchemeCode = result.schemeCode;
          vm.formData.inSchemeName = result.scheme;
          vm.formData.schemeType = result.schemeType;
          fetchFlexSipSchemeValidations(result.schemeCode);
          vm.getEmandateBankList(function () {
            vm.changeFrequency();
          });
          if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && !vm.investorInfo.retirementFundApplicable) {
            vm.showChequeLeaf = true;
          } else {vm.showChequeLeaf = false;}

          getDateValidation();

        }, error = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
        };
        ModalService.schemeListModal({
          enabledScheme: "flexsipenabled",
          isMinor: vm.formData.minorFlag,
          corporateFlag: vm.selectedFolioData.corporateInvestor
        }, success, error);
      };

      vm.inSchemeChanged = function (schemeData) {
        vm.formData.selectedInSchemeCode = schemeData.schemeCode;
        vm.selectedSchemeType = schemeData.schemeType;
        vm.formData.selectedInScheme = schemeData.scheme;
        vm.isInScheme = !!(vm.selectedInScheme);
        vm.formData.switchAmount = '';
        vm.formData.noOfUnits = '';
        if (schemeData.schemeType == 'ELSS' && schemeData.scheme.toLowerCase().includes('dividend')) {
          vm.formData.switchDividentOption = AppConstants.TRANSACTION.PAYOUT;
        }
        fetchInSchemeValidations();
        getDateValidation();
      };

      function resetValueFields() {
        vm.isReseting = true;
        $timeout(function () {
          vm.isReseting = false;
        }, 0);
      }

      function checkValidScheme() {
        $timeout(function () {
          if (vm.inSchemes && vm.inSchemes.length > 0) {
            var Arr = [];
            Arr = vm.inSchemes.filter(function (item) {
              return item.scheme == vm.selectedInScheme;
            });
            if (Arr.length == 0) {
              vm.selectedInScheme = '';
              vm.isSelectedInScheme = true;
              vm.isInScheme = false;
            }
          }
        }, 100);
      }

      function fetchInSchemeValidations(cb) {
        cb = cb || function () {
        };
        if (!vm.formData.selectedInSchemeCode) {
          MessageService.error(AppConstants.ToastrMessage.VALIDATE_DATA.BLANK_IN_SCHEME);
          return;
        }

        var success = function (resp) {
            if (resp.status && resp.data) {
              cb(null);
              vm.inSchemeValidations = resp.data;
              vm.switchSchemeInvestmentOption = vm.inSchemeValidations.investmentOption;
              if (vm.inSchemeValidations.schemeType === 'ELSS' && vm.inSchemeValidations.investmentOption !== "GROWTH") {
                vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.PAYOUT;
              }
              else if (vm.inSchemeValidations) {
                vm.formData.autoSwitchSchemeDividendOption = (vm.inSchemeValidations.investmentOption === "GROWTH") ? "Z" : (vm.inSchemeValidations.endingType === vm.ENDING_TYPES.CLOSED ? AppConstants.TRANSACTION.PAYOUT : AppConstants.TRANSACTION.REINVEST)
              } else {
                vm.formData.autoSwitchSchemeDividendOption = AppConstants.TRANSACTION.REINVEST;
              }
            } else {
              cb('error');
              vm.inSchemeValidations = null;
              MessageService.error(resp.message);
            }
            checkValidations();
          },
          error = function (err) {
            cb('error');
            vm.inSchemeValidations = null;
            UtilService.errorHandler(err);
          };
        SchemeService.get({
          controller: 'schemeValidation',
          type: 'switch',
          child1: vm.formData.selectedInSchemeCode
        }, null).$promise.then(success, error);
      }

      function checkValidations() {
        vm.validations.minAmount = vm.validations.minAmount || 0;
        vm.validations.minUnits = vm.validations.minUnits || 0;
        if (vm.unitsDetails) {
          vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
          vm.validations.maxUnits = vm.validations.maxUnits > vm.unitsDetails.freeValueUnits ? vm.validations.maxUnits : vm.unitsDetails.freeValueUnits;
        }

        var minAmount = 0;
        var minUnits = 0;
        var maxAmount = 0;
        var maxUnits = 0;

        if (vm.outSchemeValidations) {
          minAmount = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit * vm.outSchemeValidations.navValue) || minAmount;
          minAmount = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt > minAmount) ? vm.outSchemeValidations.switchOutMinAmt : minAmount;
          vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

          maxAmount = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit * vm.outSchemeValidations.navValue) || maxAmount;
          maxAmount = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt < maxAmount) ? vm.outSchemeValidations.switchOutMaxAmt : maxAmount;
          vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

          minUnits = vm.outSchemeValidations.switchOutMinAmt && (vm.outSchemeValidations.switchOutMinAmt / vm.outSchemeValidations.navValue) || minUnits;
          minUnits = vm.outSchemeValidations.switchOutMinUnit && (vm.outSchemeValidations.switchOutMinUnit > minUnits) ? vm.outSchemeValidations.switchOutMinUnit : minUnits;
          vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

          maxUnits = vm.outSchemeValidations.switchOutMaxAmt && (vm.outSchemeValidations.switchOutMaxAmt / vm.outSchemeValidations.navValue) || maxUnits;
          maxUnits = vm.outSchemeValidations.switchOutMaxUnit && (vm.outSchemeValidations.switchOutMaxUnit < maxUnits) ? vm.outSchemeValidations.switchOutMaxUnit : maxUnits;
          vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;
        }

        if (vm.inSchemeValidations && vm.outSchemeValidations) {
          minAmount = vm.inSchemeValidations.switchInMinUnit && (vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) || minAmount;
          minAmount = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt > minAmount) ? vm.inSchemeValidations.switchInMinAmt : minAmount;
          vm.validations.minAmount = minAmount > vm.validations.minAmount ? minAmount : vm.validations.minAmount;

          maxAmount = vm.inSchemeValidations.switchInMaxUnit && (vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) || maxAmount;
          maxAmount = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt < maxAmount) ? vm.inSchemeValidations.switchInMaxAmt : maxAmount;
          vm.validations.maxAmount = (maxAmount > 0 && maxAmount < vm.validations.maxAmount) ? maxAmount : vm.validations.maxAmount;

          var _minUnits = vm.inSchemeValidations.switchInMinUnit && ((vm.inSchemeValidations.switchInMinUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || minUnits;
          minUnits = vm.inSchemeValidations.switchInMinAmt && (vm.inSchemeValidations.switchInMinAmt / vm.outSchemeValidations.navValue) || minUnits;
          minUnits = minUnits > _minUnits ? minUnits : _minUnits;
          vm.validations.minUnits = minUnits > vm.validations.minUnits ? minUnits : vm.validations.minUnits;

          var _maxUnits = vm.inSchemeValidations.switchInMaxUnit && ((vm.inSchemeValidations.switchInMaxUnit * vm.inSchemeValidations.navValue) / vm.outSchemeValidations.navValue) || maxAmount;
          maxUnits = vm.inSchemeValidations.switchInMaxAmt && (vm.inSchemeValidations.switchInMaxAmt / vm.outSchemeValidations.navValue) || maxAmount;
          maxUnits = maxUnits < _maxUnits ? maxUnits : _maxUnits;
          vm.validations.maxUnits = (maxUnits > 0 && maxUnits < vm.validations.maxUnits) ? maxUnits : vm.validations.maxUnits;

          vm.validations.isEnabled = vm.inSchemeValidations.switchInUnitEnabled;
        }
      }

      function termsAndContitions() {
        ModalService.termsAndConditionFlexSip({});
      }

      vm.selectFlexSipScheme = function (data) {
        if (!data) {
          return;
        } else {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(data, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.formData.inSchemeName = null;
            vm.filterSipSchemeList();
            return;
          }
          vm.formData.inSchemeName = data.scheme;
          vm.formData.inSchemeCode = data.schemeCode;
          vm.formData.schemeType = data.schemeType;
          vm.getEmandateBankList(function () {
            vm.changeFrequency();
            $timeout(function() {
              if (vm.eMandateBankList && vm.eMandateBankList.length === 1) {
                vm.formData.eMandateBank = vm.eMandateBankList[0];
                vm.changeEMandateBank();
              }
            });
          });
          vm.getOtmBankList(function () {
            vm.setOtmData();
            // vm.getSmsValidations();
            $timeout(function() {
              if (vm.otmBankList && vm.otmBankList.length === 1) {
                vm.formData.otmBank = vm.otmBankList[0];
              }
            });
          });

          /*if (vm.formData.inSchemeName.toLowerCase().includes("retirement") && !vm.investorInfo.retirementFundApplicable) {
            vm.showChequeLeaf = true;
          } else vm.showChequeLeaf = false;*/
          vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
          /*vm.sipScheme*/
          fetchFlexSipSchemeValidations(data.schemeCode);
          getDateValidation();

          if(data.schemeType === "NFO"){
              var message = data.message;
              ModalService.nfoEnabledModal({message: message});
          }

        }
        $timeout(function () {
          _isSelectingFromDropDown = false;
        }, 0)
      };

      vm.euinChanged = function () {
        var filterEuin = vm.euinList.filter(function (euin) {
          return euin.euinCode == vm.formData.euinCode;
        })[0]
        vm.formData.euinName = filterEuin ? filterEuin.euinName : '';
        vm.euinName = filterEuin ? filterEuin.euinName : '';
        vm.euinNameSelected = vm.formData.euinName;
      };

      vm.filterSipSchemeList = function () {
        if (_isSelectingFromDropDown) {
          return;
        }
        vm.formData && (vm.formData.inSchemeCode = '');
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
        // getDateValidation();
        /*vm.sipScheme*/
      };

    vm.changeSipAmount = function (flexSipForm) {
      var newValidation = vm.additionValidation;
        for (var i=0; i<newValidation.length;i++){
        var condition = vm.formData.installmentAmount < newValidation[i].min_amount_lower ||  vm.formData.installmentAmount <= newValidation[i].min_amount_upper;
        if(!newValidation[i].min_amount_upper){
          var condition=vm.formData.installmentAmount >= newValidation[i].min_amount_lower
        }
              if(condition )
              {
                // vm.formData.startDate = null;
                // vm.formData.endDate = null;
                // vm.formData.tenure = null;
                vm.sipValidations.amountMultiples = newValidation[i].amt_multiples;
                vm.sipValidations.maxAmount = newValidation[i].min_amount_upper;
                vm.sipValidations.minAmount = newValidation[i].min_amount_lower;
                vm.sipValidations.minInstallments = newValidation[i].min_installments;
                break;
              }
          }
        vm.isMinSipAmount = vm.sipValidations && vm.sipValidations.minAmount > vm.formData.installmentAmount;
        vm.isMaxSipAmount = !!(vm.sipValidations.minAmount && vm.sipValidations.minAmount > vm.formData.installmentAmount);
        vm.isEmandateMaxLimit = vm.formData.installmentAmount > vm.eMandateMaxAmount ;
        vm.isOTMMaxLimit =  vm.formData.installmentAmount >  vm.FlexSipMaxAmount ;
        vm.isMultiples = vm.sipValidations.amountMultiples && vm.formData.installmentAmount && (vm.formData.installmentAmount % vm.sipValidations.amountMultiples === 0) || false;
        vm.invalidAmount=false;
        if (vm.formData.installmentAmount < vm.sipValidations.minAmount) {
          vm.invalidAmount=true;
          flexSipForm.$invalid = true;
        } else if (vm.sipValidations.amountMultiples && !vm.isMultiples) {
          vm.invalidAmount=true;
          if(flexSipForm != undefined){
            flexSipForm.$invalid = true;
          }
        } else if (vm.formData.installmentAmount) {

        }
        vm.otmAmountLimitValidation(); // to validate entered amount with otm limit
        if (vm.formData.sipFirstInstallment) {
          vm.fiOtmAmountLimitValidation();
        }

        if (vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) {
          vm.emandateMinAmountLimit = angular.copy(vm.formData.installmentAmount * 2);
          vm.formData.emandateAmount = angular.copy(vm.formData.installmentAmount * 2);
          vm.formData.emandateWord = {};
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate()
        }

      };


      /*vm.changeCapAmount = function (flexSipForm) {
        vm.isMultipleCapAmount = vm.formData.topupDetails.amount && vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount % vm.formData.topupDetails.amount === 0) || false;
        $timeout(function () {
        flexSipForm.$invalid = !vm.isMultipleCapAmount;
        })
        // if (vm.isMultipleCapAmount) {}
      };*/

      vm.changeFrequency = function (flexSipForm) {
        vm.formData.installment = '';
        vm.isTillPerpetuity = false;
        vm.resetting = true;
        vm.endDateSelectionOption = false;
        //vm.formData.tenure = null;
        if (!$stateParams.transactionId) {
          vm.formData.startDate = null;
          vm.sipDay = null;
          vm.formData.endDate = null;
          // vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.sipDay = null;
        } else {
          // vm.formData.startDate = vm.formData.startDate ? moment(vm.formData.startDate) : null;
          // vm.formData.endDate = vm.formData.endDate ? moment(vm.formData.endDate) : null;
          getDateValidation();
          if (vm.formData.sipDay) {
            vm.sipDay = {};
            vm.sipDay.name = vm.formData.sipDay;
            vm.sipDay.value = vm.formData.sipDay;
          }
        }
        $timeout(function () {
          vm.resetting = false;
        }, 0);
        extractSipValidationObject(vm.sipValidationsData, vm.selectedFrequency);
        if (vm.selectedFrequency) {
          vm.formData.frequency = vm.selectedFrequency.code;
        }
        if (vm.selectedFrequency && vm.selectedFrequency.code === 'OM') {
          vm.daysList = AppConstants.WEEKS_LIST;
          vm.viewMode = 'months';
          vm.startDateFormat = 'DD-MMM-YYYY';
          vm.formData.sipFirstInstallment = false;
          if(vm.formData.sipFirstInstallment == false){
            vm.formData.fiPaymentMode=null;
            vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
          }
          if (vm.otmBankList && vm.otmBankList.length > 0) {
            vm.PAYMENT_MODE = [
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          }

        } else {
          vm.daysList = AppConstants.SIP_DAYS_LIST;
          vm.viewMode = 'months';
          vm.startDateFormat = 'DD-MMM-YYYY';
          vm.formData.sipFirstInstallment = false;
          if(vm.formData.sipFirstInstallment == false){
            vm.formData.fiPaymentMode=null;
            vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
          }
      }

        if (vm.selectedFrequency){
          vm.formData.sipFirstInstallment = false;
          if(vm.formData.sipFirstInstallment == false){
            vm.formData.fiPaymentMode=null;
            vm.otmBankList=vm.otmResp? vm.otmResp.folioBankDetailsList:[];
          }
          if (vm.otmBankList && vm.otmBankList.length > 0) {
            vm.PAYMENT_MODE = [
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          }
          if (vm.eMandateBankList && vm.eMandateBankList.length > 0) {
            vm.PAYMENT_MODE = [
              {key: 'HEM', value: 'Register E-mandate (eOTM)'}
            ];
            vm.hideOtmRadio = false;
          }
          if ((vm.otmBankList && vm.otmBankList.length > 0)&&(vm.eMandateBankList && vm.eMandateBankList.length > 0 && vm.isEMandateEnabled)) {
            vm.PAYMENT_MODE = [
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'HEM', value: 'Register E-mandate (eOTM)'}
            ];
          }
        }
        vm.formData.paymentMode = vm.PAYMENT_MODE[0];
        vm.sipStartMonth = null;
        vm.changePaymentMode();
        vm.changeSipAmount(flexSipForm);
        if(vm.formData.sipFirstInstallment == false){
          vm.formData.fiPaymentMode=null;
          vm.formData.fiOtmBank= null;
        }
        if (vm.otmBankList && vm.otmBankList.length === 1) {
          vm.formData.otmBank = vm.otmBankList[0];
        }
        if (vm.eMandateBankList && vm.eMandateBankList.length === 1) {
          vm.formData.eMandateBank = vm.eMandateBankList[0];
          vm.changeEMandateBank();
        }
      };

      vm.changeDay = function () {
        if (!vm.selectedFrequency || !vm.sipDay) {
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          vm.formData.tenure = null;
          return;
        }
        switch (vm.selectedFrequency.code) {
          case 'OM' :
          case 'Q':
            updateDatesForOthers('sipFlag');
            break;
          default :
            vm.formData.startDate = null;
            vm.enabledStartDates = null;
            vm.formData.endDate = null;
            vm.enabledEndDates = null;
            break;
        }
      };

      vm.changeStartDate = function (date) {
        LoaderService.showLoader();
        vm.formData.startDate = date ? date : null;
        vm.sipDay = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
        vm.formData.endDate = null;
        vm.isTillPerpetuity = false;
        vm.endDateSelectionOption = false;
        vm.resetting = true;
        $timeout(function () {
          vm.resetting = false;
          LoaderService.hideLoader();
        });
        vm.otmStartValidation();
        if(vm.formData.sipFirstInstallment){
          vm.fiOtmStartValidation();
        }
        // vm.otmStartValidationPurchase();
        updateEndDates();
        vm.changeTenure();
      };

      vm.changeEndDate = function () {
        setInstallmentCount();
        if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'OTM') {
          vm.otmExpiryValidation(); // to validate entered end date with otm expiry date
        }
      };

      vm.cancelTransaction = function () {
        var success = function () {
          // TransactionInitiateModel.setPurchasePayload(null);
          TransactionInitiateModel.setSipPayload(null);
          TransactionInitiateModel.setInvestorPayload(null);
          TransactionInitiateModel.setInvestmentType(null);
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go('agent.home.distributor-home');
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        }, error = function () {
        };
        ModalService.confirmCancelModal({Text: 'Are you sure, you want to cancel this action?'}, success, error);
      };

      /**
       * function to check for duplicate transaction
       */

      vm.checkDuplicateTransaction = function () {
         // vm.checkKycStatus();
       var success = function (resp) {
           LoaderService.hideLoader();
           if (resp.status && resp.data) {
             if (resp.data.hasWarning) {
               var successModal = function () {
                 vm.checkKycStatus();
               }, errorModal = function () {
               };
               ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
             }
             else {
               vm.checkKycStatus();
             }
           } else {
             MessageService.error(resp.message);
           }
         },
         error = function (err) {
           LoaderService.hideLoader();
           UtilService.errorHandler(err);
         };
       if(vm.formData.minorFlag && angular.isArray(vm.otmBankList ) && vm.otmBankList.length<1 && (vm.eMandateBankList && vm.eMandateBankList.length < 1))
       {
         MessageService.error("No valid payment mode available to proceed with SIP transaction");
         return;
       }
       var payload = {
         transactionType: 'FLEXSIP',
         folioNumber: vm.formData.folioNumber,
         schemeCode: vm.formData.inSchemeCode,
         targetSchemeCode: vm.formData.targetSchemeCode ? vm.formData.targetSchemeCode : "",
         amount: vm.formData.installmentAmount,
         checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
         autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.selectedInSchemeCode : null,
         autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.autoSwitchSchemeDividendOption : null,
         paymentMode: vm.formData.paymentMode.key
       };
       LoaderService.showLoader();
       TransactionService.post({
         VERSION: HDFC_API.VERSION,
         controller: 'check',
         child2: 'duplicate'
       }, payload).$promise.then(success, error);
      };

      /**
       * function to check kyc status , called after duplicate transaction check
       */

      vm.checkKycStatus = function () {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (resp.data.sKycStatus) {
                finishFlexSip();
              }
              else {
                MessageService.error(resp.data.message);
              }
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        var payload = {"panNumber": vm.investorInfo.panNumber, "folioNumber": vm.formData.folioNumber};
        LoaderService.showLoader();
        InvestorsService.post({
          controller: 'sKycStatus'
        }, payload).$promise.then(success, error);
      };

      vm.init = function () {
        if (!vm.investorUUID) {
          $state.go('main.dashboard');
          return;
        }
        vm.formData.startDate = null;
        vm.endDateSelectionOption = vm.SIP_END_DATE_OPTIONS.SELECT_END_DATE;
        //folioInit();
        fetchTenureList();
        fetchFolioList(function() {
          if ($stateParams.transactionId) {
            vm.isReinitiate = true;
            getTransactionDetails();
          } else {
            vm.isReinitiate = false;
            schemeInit();
          }
        });

        checkForTermsAndCondition();
      };


      var currentDate = Date();
      vm.enabledOTMStartDatesList = [];
      vm.enabledBillerStartDatesList = [];
      function getDateValidation(cb){
        cb = cb || function () {};
        vm.isTillPerpetuity = false;
        vm.resetting = true;
        vm.endDateSelectionOption = false;
        var success = function (resp) {
            vm.enabledOTMStartDatesList = [];
            if (resp.status && resp.data) {
              vm.weeklyDaysList=resp.data.listOfDays;
              var currentDate = resp.data.currentDate;
              var todayDate = $window.moment(currentDate, "DD-MMM-YYYY");
              if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM') {
                vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.eMandateNoOfDays, 'days');
              } else {
                vm.startMinDateBiller = $window.moment(currentDate, "DD-MMM-YYYY").add(13, 'days');//T+10+2+1
              }
              var startMaxDate = $window.moment(currentDate, "DD-MMM-YYYY").add(90, 'days');
              var startDate = todayDate.clone();
              var freq = $window.moment(vm.startMaxDate).diff(todayDate, 'days');
              var counter=0;
              for (var i = 0; i <= freq; i++) {
                var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                var isEnable = true;
                if(counter<7)
                {
                  angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                    if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                      isEnable = false;
                    }
                  });
                }
                if(isEnable){
                  vm.enabledOTMStartDatesList.push(indexDate);
                  counter++;
                }
              }
              vm.startMinDateOTM = vm.enabledOTMStartDatesList[7];//T+5+2
              if(vm.formData.paymentMode && vm.formData.paymentMode.key === 'HEM') {
                vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandateNoOfDays];
                vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
              }
              vm.startMaxDate = $window.moment(startMaxDate, "DD-MMM-YYYY").clone();
              if(vm.enabledOTMStartDatesList.length > 0){
                if(vm.formData.paymentMode && (vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM || vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE)){
                  vm.formData.startDate = angular.copy($window.moment(vm.startMinDateOTM, "DD-MMM-YYYY"));
                }else {
                  vm.formData.startDate = angular.copy($window.moment(vm.startMinDateBiller, "DD-MMM-YYYY"));
                }
                vm.formData.tenure = vm.tenureDuration[vm.tenureDuration.length - 1].tenureValue;
                vm.changeTenure();
              }
              vm.resetting = false;
              cb(true);
            } else {
              MessageService.error(resp.message);
              vm.resetting = false;
              cb(false);
            }
          },
          error = function (err) {
            vm.resetting = false;
            UtilService.errorHandler(err);
            cb(false);
          };
        InvestorsCommonService.get({
          child1: 'nonBusinessDate',
          schemeCode: vm.formData.inSchemeCode //'AFWDQ'
        }).$promise.then(success, error);
      }

      vm.schemeInit = function () {
        if ($stateParams.transactionId) {
          vm.isReinitiate = true;
          getTransactionDetails();
        } else {
          vm.isReinitiate = false;
          schemeInit();
        }
      };
      var PAYMENT_MODE_AT_FOLIO;

      vm.setOtmData = function () {
        // function to set payment mode if otm is registered
          if (vm.otmBankList && vm.otmBankList.length > 0) {
              if(vm.selectedFrequency){
                if(vm.SIP_FREQ_LIST.length !==0){
                  if($stateParams.frequency && $stateParams.frequency === "Monthly" || $stateParams.frequency === "Quarterly"){
                    vm.PAYMENT_MODE= [
                      {key: 'OTM', value: 'OTM(One Time Mandate)'}
                    ];
                  } else {
                    vm.PAYMENT_MODE = [
                      {key: 'OTM', value: 'OTM(One Time Mandate)'}
                    ];
                  }
                }
              } else {
                vm.PAYMENT_MODE = [
                  {key: 'OTM', value: 'OTM(One Time Mandate)'}
                ];
              }
          }

         else if (angular.isArray(vm.otmBankList ) && vm.otmBankList.length == 0 ) {
           vm.PAYMENT_MODE = [];
            if (vm.sipValidationsData) {
              if (vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag) {
                vm.PAYMENT_MODE = [];
                vm.formData.paymentMode = null;
              }
            }
         }

         else if(vm.otmBankList == null){
            vm.PAYMENT_MODE = [];
            if (vm.sipValidationsData) {
              if (vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag) {
                vm.PAYMENT_MODE = [];
              }
            }
         }

          if(vm.eMandateBankList && vm.eMandateBankList.length > 0){
            vm.PAYMENT_MODE=[{key: 'HEM', value: 'Register E-mandate (eOTM)'}].concat(vm.PAYMENT_MODE);
            vm.PAYMENT_MODE.shift();
            vm.PAYMENT_MODE=vm.PAYMENT_MODE.concat([{key: 'HEM', value: 'Register E-mandate (eOTM)'}]);
            vm.hideOtmRadio=false;
            vm.changePaymentMode();
          }

          // adding

          if(vm.formData.minorFlag && vm.sipValidationsData && !vm.sipValidationsData.cgfFlag) {
            if (vm.otmBankList && vm.otmBankList.length > 0) {
              vm.formData.paymentMode = vm.PAYMENT_MODE.find(function(el) {
                return el.key == 'OTM'
              });
            }
          } else {
            vm.formData.paymentMode = vm.PAYMENT_MODE.length !== 0 ? vm.PAYMENT_MODE[0] : null;
          }

          vm.formData.paymentMode = vm.PAYMENT_MODE[0];

          PAYMENT_MODE_AT_FOLIO = angular.copy(vm.PAYMENT_MODE);
      };

      /**
       * function responsible for fetching and setting otm bank list
       */
      vm.getOtmBankList = function (cb) {// function to fetch otm registered bank w.r.t selected folio
        cb = cb || function () {
        };
        if (!vm.formData.folioNumber) {
          return;
        }
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmResp = resp.data;
            if (angular.isArray(resp.data.folioBankDetailsList) && resp.data.folioBankDetailsList.length > 0) {
              vm.otmBankList = resp.data.folioBankDetailsList;
              vm.hideOtmRadio = false;
              vm.showSmsRadio = true;
              var otmExists = false;
              for(var i = 0; i < vm.PAYMENT_MODE.length; i++) {
                if (vm.PAYMENT_MODE[i].key == "OTM") {
                  otmExists = true;
                  break;
                }
              }
              if(vm.selectedFrequency){
                if(vm.SIP_FREQ_LIST){
                  var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                    return d.code === 'OM';
                  }) || {};
                  vm.selectedFrequency = frequency?frequency:'';//default monthly selection
                 if (otmExists && vm.PAYMENT_MODE.length > 1) {
                   $timeout(function(){
                     var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                       return d.code === 'OM';
                     }) || {};
                     vm.selectedFrequency = frequency?frequency:'';//default monthly selection
                   });
                 }
                }
              }
            }
            else{
              vm.otmBankList  = [];
              vm.hideOtmRadio = true;
              vm.formData.paymentMode = vm.PAYMENT_MODE[0];
              vm.showSmsRadio = false;
              vm.approvalMode = 'ONLINE';
              vm.isOtmLimitLess = false;
              $timeout(function(){
                vm.selectedFrequency = vm.SIP_FREQ_LIST[0];//default monthly selection
              });
            }
            cb(true);
          } else {
            vm.otmBankList = null;
            vm.hideOtmRadio = true;
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
            cb(false);
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
          vm.otmBankList = null;
            vm.hideOtmRadio = true;
          vm.formData.paymentMode = vm.PAYMENT_MODE[0];
          cb(false);
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'otm',
          child2: 'banks'
        }, {folioNumber: vm.formData.folioNumber,pan: vm.investorInfo.panNumber}).$promise.then(success, error);
      };

      vm.otmAmountLimitValidation = function () { // function to validate investment amount with otm limit
        vm.otmBankLimit = vm.formData.otmBank && vm.formData.otmBank.maxAmount;
        if (vm.otmBankLimit && (vm.formData.purchaseAmount || vm.formData.installmentAmount)) {
            var doubleAmount = 2 * vm.formData.installmentAmount;
            vm.otmLimitvalidation = vm.otmBankLimit >= doubleAmount ? false : true;
        }
      };

      vm.otmExpiryValidation = function () { // function to validate investment end date  with otm expiry
        vm.otmExpDate = vm.formData.otmBank && moment(vm.formData.otmBank.omExpiryDate, 'DD-MMM-YYYY');
        if (vm.formData.endDate && angular.isDefined(vm.formData.endDate.format) && vm.otmExpDate) {
          vm.endDateValidation = vm.formData.endDate && (moment(vm.formData.endDate.format("DD-MMM-YYYY"))) > vm.otmExpDate;
        }
      };
      vm.otmStartValidation = function () { // function to validate investment start date  with otm expiry
        vm.otmStrDate = vm.formData.otmBank && moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY');
        if (vm.formData.startDate && angular.isDefined(vm.formData.startDate.format) && vm.otmStrDate) {
          vm.startDateValidation = vm.formData.startDate && (moment(vm.formData.startDate,"DD-MMM-YYYY")) < vm.otmStrDate;
        }
      };
      vm.otmStartValidationPurchase = function () { // function to validate investment start date  with otm expiry
        vm.otmStrDate = vm.formData.otmBank && moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY');
        vm.otmCurDate = moment(vm.otmResp.currentDate, 'DD-MMM-YYYY');
      };

      /**
       * function responsible for handling otm bank selection
       */

      vm.changeOtmbank = function () {
        // function to check otm limit and expiry date on change of otm bank

        if(!vm.formData.otmBank && !vm.formData.fiOtmBank){
          return ;
        }

        vm.otmAmountLimitValidation();
        vm.otmExpiryValidation();
        vm.otmStartValidation();
        vm.otmStartValidationPurchase();
        if((vm.formData.eMandateBank !== undefined && vm.formData.eMandateBank !==null)  || ( vm.formData.otmBank!== undefined && vm.formData.otmBank !== null)){
          if(vm.formData.minorFlag && !vm.formData.cgfFlag )
          {
            if( vm.formData.otmBank.minorBankFlag !== undefined){
              if(!vm.formData.otmBank.minorBankFlag){
                if(vm.dynamicDataMinorBank) {
                  ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
                }
                vm.formData.otmBank=null;
              }
            }
            if( vm.formData.eMandateBank && vm.formData.eMandateBank.minorBankFlag !== undefined){
              if(!vm.formData.eMandateBank.minorBankFlag){
                if(vm.dynamicDataMinorBank) {
                  ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
                }
                vm.formData.otmBank=null;
              }
            }
          }
        }
        if (vm.formData.sipFirstInstallment) {
          vm.fiOtmAmountLimitValidation();
          vm.fiOtmExpiryValidation();
          vm.fiOtmStartValidation();
        }
      };

      /**
       * function responsible for handling emandate bank selection
       */
      vm.changeEMandateBank = function (){
        vm.canshowAuthError = false;
        $timeout(function () {
          vm.authMode = vm.formData.eMandateBank.authenticationModes ? vm.formData.eMandateBank.authenticationModes[0] : null;
          vm.canshowAuthError = true;
         }, 500);
        if(vm.formData.minorFlag && !vm.formData.cgfFlag && !vm.formData.eMandateBank.minorBankFlag)
        {
          if(vm.dynamicDataMinorBank) {
            ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
          }
          vm.formData.eMandateBank=null;
        }
      };

      /**
       * function responsible for handling payment modes change
       */
      vm.changePaymentMode = function () { // function to set and check otm details on change of payment mode

        if ((vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) && !vm.emandateObj) {
          UtilService.fetchMandateValidations().then(function (resp) {
            vm.emandateObj = resp.eOTM;
            vm.emandateMaxYear = vm.emandateObj.maxMandateDurationYears ? vm.emandateObj.maxMandateDurationYears : vm.defaultMandateYearDate;
            vm.eMandatenoOfDays = vm.emandateObj.noOfDays;
            vm.eMandatemaxAmountLimit = vm.emandateObj.maxAmountLimit;
            vm.emandateMinimumAmountLimit = vm.emandateObj.minAmountLimit;
            vm.emandateMinStartDay = vm.emandateObj.minStartDays;
            vm.emandateMinAmountLimit = angular.copy(vm.formData.installmentAmount * 2);
            vm.formData.emandateAmount = angular.copy(vm.formData.installmentAmount * 2);
            vm.formData.emandateWord = {};
            $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
            checkAmountValidationEmandate()
            vm.mandateInfo = vm.emandateObj.mandateInfo;
            vm.minEndDateGapMandate = vm.emandateObj.minEndDateGap;
            vm.mandateMaxString = vm.emandateObj.maxAmountLimitInfo;
            vm.formData.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
            updateEmandateEndDate();
          }).catch(function(resp) {
            MessageService.error(resp)
          });
        } else {
          if (vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) {
            vm.formData.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
            updateEmandateEndDate();
          }

          if (vm.formData.installmentAmount) {
            vm.formData.emandateAmount = angular.copy(vm.formData.installmentAmount * 2);
            vm.formData.emandateWord = {};
            $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
            checkAmountValidationEmandate();
          } else {
            vm.formData.emandateAmount = null;
          }
        }

        if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'OTM') {
          vm.formData.otmBank=null;
          vm.formData.eMandateBank = null;
          vm.authMode = null;
          vm.changeOtmbank();
        }
        else {
          vm.otmLimitvalidation = false;
          vm.formData.otmBank=null;
          vm.formData.eMandateBank = null;
          vm.authMode = null;
          vm.endDateValidation = false;
        }
        vm.isCheckedTandC = false;
        vm.formData.startDate = null;
        vm.formData.tenure = null;
        vm.formData.endDate = null;
        vm.amountLess = false;
        vm.amountMore = false;
        vm.isLessThanSipAmount = false;
        vm.sipDateLessEmandate = false;
        if(vm.formData.inSchemeCode){
          getDateValidation();
        }
      };

      /**
       * function responsible for fetching and setting emandate bank list
       */
      vm.getEmandateBankList = function (cb) {// function to fetch e-mandate registered bank w.r.t selected folio
        cb = cb || function () {
        };
        if (!vm.formData.folioNumber) {
          return;
        }
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.isEMandateEnabled = resp.data.folioEmandateStatus;
              if (angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) {
                vm.eMandateBankList = resp.data.bankList;
                vm.eMandateNoOfDays = resp.data.noOfDays;
                vm.eMandateMaxAmount = vm.FlexSipMaxAmount;
                // vm.isEmandateEnabled = true;
              }
              else{
                vm.eMandateBankList  = [];
                // vm.isEmandateEnabled = false;
              }
              cb(true);
            } else {
              vm.eMandateBankList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            vm.eMandateBankList = null;
            vm.hideOtmRadio = true;
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        var payload = {
          "folioNumber": vm.formData.folioNumber,
          "trnxType": "SIP",
          "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false
        }
        LoaderService.showLoader();
        BillJunctionService.post({VERSION: 'v2',
          controller: 'bank',
          child1: 'list',
          child2: 'emandate',
        }, payload ).$promise.then(success, error);
      };

      /**
       * function responsible for handling folio change
       */
      vm.changeFolio = function (userAction) {
        if ($stateParams && $stateParams.folioNumber && !userAction) {
          vm.formData.folioNumber = $stateParams.folioNumber;
          vm.fromInvestorDetail = true;
        }
        if (!vm.formData.folioNumber) {
          vm.checkFolio=true;
          return;
        }
        vm.formData.folioNumber = vm.formData.folioNumber || vm.folioNumber;
        var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        if(selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        vm.formData.subBrokerARN = '';
        if(vm.subBrokerName || vm.subBrokerCodeError) {
          vm.subBrokerCodeError = '';
          vm.subBrokerName = '';
          vm.fetchEuinListSubBroker();
        }
        fetchFlexSipEnabledSchemes();
        vm.resetAll();
        vm.hasFolioEmailId = true;
        var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.hasFolioEmailId = !!resp.data.emailId;
            vm.emailId = resp.data.emailId;
            vm.mobileNumber = resp.data.mobileNumber;
            emailMobileValidation();
            vm.getOtmBankList(function () {
              vm.getEmandateBankList(function () {
                vm.setOtmData();
              });
              // vm.getSmsValidations();
            });
          } else {
            vm.hasFolioEmailId = false;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          vm.hasFolioEmailId = false;
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        var successHandler = function(resp) {
          //vm.resetAll();
          //fetchFlexSipEnabledSchemes();
          InvestorsService.post({
            controller: 'folio',
            child1: 'contact-details'
          }, {
            folioNumber: vm.formData.folioNumber
          }).$promise.then(success, error);
        }
        var errorHandler = function(resp) {
          vm.formData.folioNumber = null;
        }

        panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
      };

      /**
       * function responsible for email and mobile validation
       */
      function emailMobileValidation(){
        if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
          if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isMobileinValid = true;
            vm.emandateDisplay = false;
          }
        }
        else if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
          if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isEmailinValid = true;
            vm.emandateDisplay = false;
          }
        } else {
          vm.isEmailinValid = false;
          vm.isMobileinValid = false;
          vm.isEmailMobileinValid = false;
          vm.emandateDisplay = true;
        }
      }

      vm.checkOtmValidation = function () {

        if(vm.approvalMode=='SMS'){
          if ( vm.formData.purchaseAmount > vm.otmLimit) {
            vm.isOtmLimitLess = true;
          }
          else vm.isOtmLimitLess = false;
        }
        else {
          vm.isOtmLimitLess = false;
        }

      };

      vm.checkSIPOtmValidation = function () {

        if(vm.approvalMode=='SMS'){
          if ( vm.formData.installmentAmount > vm.otmLimit) {
            vm.isOtmLimitLess = true;
          }
          else {
            vm.isOtmLimitLess = false;
          }
        }
        else {
          vm.isOtmLimitLess = false;
        }

      };

      /**
       * function responsible for check leafue upload functinality
       */

      vm.uploadFile = function (file) {
        if (vm.formData.folioNumber) {
          if (file) {
            if (vm.mimeType.indexOf(file.type) == -1) {
              MessageService.error("Only image file is allowed");
              return;
            }
            vm.myFile = file;
            vm.chequeLeaf = file.name;

            var modalSuccess = function () {
                if (file.size <= 2000000) {
                  var success = function (resp) {
                      LoaderService.hideLoader();
                      if (resp.status && resp.data) {
                        vm.formData.retirementAgeProofURL = resp.data.fileUrl;

                        vm.breakFileUrl(resp.data.fileUrl);
                        //  $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.logoUrl});
                      }
                      else {
                        MessageService.error(resp.message);
                      }
                    },
                    error = function (err) {
                      LoaderService.hideLoader();
                      $log.info("err=== ", err);
                    };

                  if (file) {
                    LoaderService.showLoader();
                    var fd = new FormData();
                    fd.append('file', file);

                    DistributorFileUploadService.post({
                      child1: 'transaction',
                      child2: 'retirement',
                      child3: 'ageProof',
                      child4: 'upload',
                      child5: vm.formData.folioNumber
                    }, fd).$promise.then(success, error);
                  }
                } else {
                  MessageService.error("File size should not be more than 2 MB.")
                }
              },
              modalError = function () {
                document.getElementById("uploadFileId").value = '';
                vm.chequeLeaf = '';
              };

            ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
          }
        } else {
          MessageService.error("Please select folio Number");
        }
      };

      /**
       * function responsible for resetting value during folio change
       */
      vm.resetAll = function () {

        var folioNumber = vm.formData.folioNumber;
        var sipPaymentOption = vm.formData.sipPaymentOption;
        var euinOpted = vm.formData.euinOpted;
        var euinCode = vm.formData.euinCode;
        var minorFlag=vm.formData.minorFlag;
        var schemeType=vm.formData.schemeType;
        checkForTermsAndCondition();
        /*if(minorFlag)
        {
          if(vm.dynamicDataPopupMinorSip) {
            ModalService.minorSipModal({dynamicDataPopup : vm.dynamicDataPopupMinorSip});
          }
        }*/
        //fetchFlexSipEnabledSchemes();
        vm.formData.sipDividendOption = vm.DIVIDEND_OPTIONS.GROWTH;//vm.devidendOptions[0];
        resetAllPayloads();
        vm.formData.minorFlag=minorFlag;
        vm.formData.folioNumber = folioNumber;
        vm.formData.sipPaymentOption = sipPaymentOption;
        vm.formData.euinOpted = euinOpted;
        vm.formData.euinCode = euinCode;
        vm.formData.startDate = null;
        $state.$previous = null;
        vm.formData.schemeType = schemeType;
        // vm.setOtmData();
        vm.formData.paymentMode = vm.PAYMENT_MODE[0];
      };


      /*Save transaction Start*/

      function getFinalPayloadData() {
        var payload = null;
        payload = vm.isSaving ? getFlexSipPayload() : getFlexSipPayload();
        return angular.copy(payload);
      }

      vm.saveForm = function (cb) {
        cb = cb || function () {

        }
        vm.isSaving = true;
        var identifier = AuthService.getToken();
        var payload = getFinalPayloadData();
        payload.agentId = identifier.userId;
        payload.investorUuid = $stateParams.uuid;
        payload.brokerCode = identifier.arnCode;
        payload.subBrokerCode = '';

        if (!payload) {
          return;
        }
        LoaderService.showLoader();
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              cb(true);
            } else {
              MessageService.error(vm.validations.FORM_SAVE_FAILED);
              cb(false);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          };

        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller: vm.formData.investmentType.toLowerCase(),
          child2: 'save'
        }, payload).$promise.then(success, error);

      };
      /*Save transaction End*/

      /*Socket code Start*/
      var listeners = {};
      listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
        var payload = {};
        if (!vm.formData.inSchemeName) {
          payload.saveEnable = false;
          AgentSocketService.showDisconnedtPopUp(payload, function () {
            AgentSocketService.impersonateLogout(args);
          });
        } else {
          payload.saveEnable = true;
          AgentSocketService.showDisconnedtPopUp(payload, function (saveClicked) {
            if (saveClicked) {
              vm.saveForm(function () {
                AgentSocketService.impersonateLogout(args);
              })
            } else {
              AgentSocketService.impersonateLogout(args);
            }
          });
        }
      });

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in listeners) {
          if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
            listeners[key]();
          }
        }
      });

      /*Socket code End*/

      /**
       * function responsible for fetching kyc email and mobile for folio creation
       */
      function fetchEmailMobile(panNumber,Dob, cb) {
        cb = cb || function () {
        };
         var success = function (resp) {
         LoaderService.hideLoader('.popup');
          if (resp.status) {
             vm.mobile = resp.data.mobileNumber;
             vm.email = resp.data.email;
            vm.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
            vm.nomineeLimit = resp.data.nomineeLimit;
            cb();
          }

          if(!resp.data && resp.message) {
            MessageService.error(resp.message)
          }

         },
         error = function () {
           MessageService.error("something went wrong")
         };
         vm.payload = {
           pan: panNumber,
           dob: Dob,
           transactionEnabled : true
         };
         InvestorsService.post({
           child1: 'pan',
           child2: 'details'
         }, vm.payload).$promise.then(success, error);
       }

      /**
       * function responsible for setting TNC
       */
      function checkForTermsAndCondition() {
        var successHandler = function(resp) {
          vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
          vm.showTerms = vm.termsConditionData.TNC_General_SIP && vm.termsConditionData.TNC_General_SIP.content ? true : false;
        }

        UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
          MessageService.error(resp);
        });
      }

      /**
       * function to fetch and set tenure list
       */
      function fetchTenureList() {

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.tenureDuration = resp.data.tenureDTOList;
            vm.FlexSipMaxAmount = resp.data.maxInstallmentAmount;
          } else {
            vm.tenureDuration = null;
          }
        }

        var error = function () {
          LoaderService.hideLoader();
          vm.tenureDuration = null;
        }

        LoaderService.showLoader();
        TransactionService.get({
            VERSION: HDFC_API.VERSION,
            controller: 'tenure',
            child2:'FLEXSIP'
          }).$promise.then(success, error);
      }

      /**
       * function for setting end date based on tenure selection
       */
      vm.changeTenure = function () {
        vm.formData.endDate = null;
        if (vm.formData.startDate && vm.formData.tenure) {
          if (vm.selectedFrequency.code === 'OM') {
            vm.formData.endDate = moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.formData.tenure, 'years').subtract(1, 'months');
          } else if (vm.selectedFrequency.code === 'Q') {
            vm.formData.endDate = moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.formData.tenure, 'years').subtract(3, 'months');
          }
          if(vm.formData.paymentMode && vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM && vm.formData.endDateEmandate) {
            vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
          }
          handleMandatePaymentOption();
          vm.changeEndDate();
        }
      }

      /**
       * function for handling suggested sip amount change
       */
      vm.changeAmountSuggestion = function (amount) {
        vm.formData.installmentAmount=amount;
        $timeout(function () {
          $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392');
        });
        vm.changeSipAmount(flexSipForm);
        vm.formData.tenure = null;
        vm.formData.otmBank = null;
        vm.formData.eMandateBank = null;
        vm.authMode = null;
        vm.isCheckedTandC = false;
        if(vm.formData.sipFirstInstallment){
          vm.fiOtmExpiryValidation();
        }
      }

      /**
       * function for handling first installment toggle changes
       */
      function changeFirstInstallment(installmentActivated) {
        if (installmentActivated) {
          vm.formData.otmBank = null;
          vm.formData.eMandateBank = null;
          vm.authMode = null;
          vm.formData.sipFirstInstallment = true;
          vm.formData.sipTopupSelected=false;
          vm.formData.topupDetails={};
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.tenure = null;
          vm.otmBankList = vm.otmResp.nonCOTMBankList;
          if (vm.otmBankList.length === 0) {
            vm.sipFirstInstallmentPaymentMode = vm.sipFirstInstallmentPaymentMode.filter(function(paymentMode) {
              return paymentMode.key !== 'OTM';
            });
          } else {
            vm.sipFirstInstallmentPaymentMode=[
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ]
          }
          if( vm.selectedFrequency.code !== 'OW'){
            if(vm.formData.minorFlag && !vm.sipValidationsData.cgfFlag){
              if(vm.otmBankList.length!=0){
                vm.PAYMENT_MODE = [
                  {key: 'OTM', value: 'OTM(One Time Mandate)'}
                ];
              }else if( vm.otmBankList==0){
                vm.PAYMENT_MODE=[];
              }
            } else if(vm.otmBankList.length === 0){
              vm.PAYMENT_MODE = [];
            } else{
              vm.PAYMENT_MODE = [
                {key: 'OTM', value: 'OTM(One Time Mandate)'}
              ];
            }
          }
          vm.formData.paymentMode=  vm.PAYMENT_MODE[0]
          vm.formData.fiPaymentMode = vm.sipFirstInstallmentPaymentMode[0];
        } else {
          vm.formData.sipFirstInstallment = false;
          vm.formData.fiPaymentMode = null;
          vm.otmBankList = vm.otmResp? vm.otmResp.folioBankDetailsList:[];
          vm.changeFrequency()
        }
        vm.isCheckedTandC = false;
      }

      /**
       * function for handling first installment amount validations
       */
      vm.fiOtmAmountLimitValidation = function() {
        vm.otmBankLimit = vm.formData.fiOtmBank && vm.formData.fiOtmBank.maxAmount;
        if (vm.otmBankLimit &&
          (vm.formData.purchaseAmount || vm.formData.installmentAmount)) {

          vm.fiOtmLimitvalidation = vm.formData.installmentAmount > vm.otmBankLimit;

        }
        if((vm.formData.fiOtmBank && vm.formData.fiOtmBank.otmFrequency !== 'AWP') && (vm.selectedFrequency.code === 'BZ')){
          MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
        }
      };

      /**
       * function for handling first installment max date validations
       */
      vm.fiOtmExpiryValidation = function() {
        vm.fiotmExpDate = vm.formData.fiOtmBank && moment(vm.formData.fiOtmBank.omExpiryDate, 'DD-MMM-YYYY');
        if (vm.formData.endDate && angular.isDefined(vm.formData.endDate.format) && vm.fiotmExpDate) {
          vm.fiendDateValidation = vm.formData.endDate && (moment(vm.formData.endDate,"DD-MMM-YYYY")) > (moment(vm.fiotmExpDate,'DD-MMM-YYYY'));
        }
      };

      /**
       * function for handling first installment start date validations
       */
      vm.fiOtmStartValidation = function() {
        vm.otmStrDate = vm.formData.fiOtmBank && moment(vm.formData.fiOtmBank.omStartDate, 'DD-MMM-YYYY');
        if (vm.formData.startDate && angular.isDefined(vm.formData.startDate.format) && vm.otmStrDate) {
          vm.startDateValidation = vm.formData.startDate && (moment(vm.formData.startDate,"DD-MMM-YYYY")) < (moment(vm.otmStrDate,"DD-MMM-YYYY"));
        }
      };


      function updateEmandateEndDate() {

        if (!vm.formData.emandateDate) {
          return;
        }

        var enabledEndDates = [];
        vm.formData.endDateEmandate = '';
        if(vm.formData.emandateDate)
        {
          vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
          vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
          vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
        }

        var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
        for (var i = 0; i <= freq; i++) {
          enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
        }
        vm.enabledEmandateEndDatesList = enabledEndDates;
        vm.endDateViewEmandate = enabledEndDates[0].clone();
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
      }


      function checkAmountValidationEmandate() {
        vm.amountLessMin = vm.formData.emandateAmount < vm.emandateMinimumAmountLimit ? true : false;
        vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
        vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
        vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.installmentAmount ? true : false;
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      }

      function changeEndDateEmandate(date) {
        vm.formData.endDateEmandate = date ? date : null;
        if (vm.formData.endDate) {
          vm.changeStartDate(vm.formData.startDate);
        }
      }

      function handleMandatePaymentOption() {
        if (vm.formData.tenure >= vm.emandateMaxYear) {
          vm.isEMandateEnabled = false;

          if ((vm.otmBankList && vm.otmBankList.length > 0)) {
            vm.PAYMENT_MODE = [
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          } else {
            vm.PAYMENT_MODE = [];
          }

          if(vm.formData.paymentMode.key === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) {
            vm.formData.paymentMode = vm.PAYMENT_MODE.length === 0 ? null : vm.PAYMENT_MODE[0];
            if (vm.formData.paymentMode) {
              vm.changePaymentMode();
            }
          }

          $window.scrollTo(0, 0);

        } else {
          var EmandadateExist = vm.PAYMENT_MODE.filter(function (el) {
            return el.key === 'HEM';
          })

          if (vm.eMandateBankList && vm.eMandateBankList.length > 0 && (!EmandadateExist || vm.PAYMENT_MODE.length === 0) && !vm.formData.sipFirstInstallment) {
            vm.isEMandateEnabled = true;
            vm.PAYMENT_MODE.push({key: 'HEM', value: 'Register E-mandate (eOTM)'});
          }

          if (!vm.formData.paymentMode) {
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
            vm.changePaymentMode();
            $window.scrollTo(0, 0);
          }
        }
      }

      vm.changeSubBrokerArn = function () {
        vm.formData.subBrokerCode = ''
        vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
        vm.isCheckedTandC = false;
        //vm.formData.euin = '';
        vm.subBrokerName = '';
        if(!vm.formData.subBrokerARN){
          vm.subBrokerCodeError = '';
        }
      }

      vm.fetchEuinListSubBroker = function () {

        if (!vm.formData.subBrokerARN) {
          vm.subBrokerCodeError = '';
          vm.subBrokerName = '';
          vm.isSubarnSuccess = false;
          getEuinCodes();
          return;
        }
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.euinMasterList = resp.data.euinList;
              vm.euinList = vm.euinMasterList;
              vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
              vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
              vm.formData.euinName = vm.euinNameSelected;
              vm.subBrokerName = resp.data.distributorName;
              vm.subBrokerCodeError = '';
              vm.isSubarnSuccess = false;
              vm.isArnSuccess =false;
              // if (vm.localData) {
              //   var euinData = vm.euinMasterList.filter(function (value) {
              //     if (value.euinCode == vm.localData.Euin) { return value; }
              //   })[0];
              //   vm.selectEuin(euinData);
              // }
            } else {
              vm.subBrokerCodeError = resp.message;
              vm.isSubarnSuccess = true;
              vm.formData.euin = '';
              vm.euinList = null;
              MessageService.error(resp.message);
              vm.isArnSuccess =true;
            }
          },
          error = function () {
            LoaderService.hideLoader();
            vm.subBrokerCodeError = '';
            //UtilService.errorHandler(err);
          };

        LoaderService.showLoader();
        if(vm.formData.subBrokerARN){
          TransactionService.get({
            VERSION: HDFC_API.VERSION,
            controller: 'getEuin',
            child2: 'ARN-' + vm.formData.subBrokerARN,
            isSubBroker: true
          }).$promise.then(success, error);
        }
      }

    }
})();

/**
 * Created by ttn on 30/5/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionFlexIndexController', initiateTransactionFlexindexController);

  /** @ngInject */
  function initiateTransactionFlexindexController($stateParams, $state, $scope, $window, SchemeService, MessageService, AppConstants, LoaderService, InvestorsService, TransactionService, ModalService, UtilService, $timeout, $log, TransactionInitiateModel, AuthService, HDFC_API, AgentSocketService, panAdharLinkingService) {
    var vm = this;
    var identifier = AuthService.getToken();
    vm.fetchUnitDetails = fetchUnitDetails;
    vm.fetchAllSchemeType = fetchAllSchemeType;
    vm.schemeListModal = schemeListModal;
    vm.inSchemeChanged = inSchemeChanged;
    vm.changeFolio = changeFolio;
    vm.checkValidations = checkValidations;
    vm.confirmCancel = confirmCancel;
    vm.getEuinCodes = getEuinCodes;
    vm.stageValueChanged = stageValueChanged;
    vm.investModeChanged = investModeChanged;
    vm.installmentValueChanged = installmentValueChanged;
    vm.submitForm = _submitForm;
    vm.init = _init;
    vm.confirmCancel = confirmCancel;

    vm.formData = {};
    vm.euinList = "";
    vm.investorUUID = $stateParams.uuid;
    vm.formData.schemeCode = null;
    vm.formData.euinObj = null;
    vm.folioListData = [];
    vm.allSchemesList = null;
    vm.isSelectedInScheme = true;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.unitsDetails = null;
    vm.validations = null;
    vm.formData.euinCode = "";
    vm.formData.euinName = "";
    vm.isMultiples = false;
    vm.isMin = false;
    vm.isReseting = false;
    vm.investorInfo = null;
    vm.hasFolioEmailId = true;
    vm.isRequired = true;
    vm.isFormDisable = true;
    vm.specificProperties = {};
    vm.downloadReport = $scope.$parent.InitiateTransaction.downloadReport;
    vm.termsAndContitions = termsAndContitions;
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.showTerms = true;

    function _init() {
      // $log.debug("Logging Here");
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      if ($stateParams.schemeCode) {
        vm.formData.schemeCode = $stateParams.schemeCode;
        fetchUnitDetails();
      } else if ($stateParams.transactionId) {
        getInvestorInfo(function() {
          getTransactionDetails();
        });

      }
      vm.specificProperties = TransactionInitiateModel.getInitialspecificProperties();
      // $log.debug("Specific Properties: ",vm.specificProperties);
      getEuinCodes();
      getInvestorInfo(function() {
        folioList();
      });
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }


    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinList = [
              {
                euinName: resp.data.euinName,
                euinCode: resp.data.euinCode
              }
            ];
            vm.formData.euinObj = {
              euinName: resp.data.euinName,
              euinCode: resp.data.euinCode
            };
            vm.folioListData = [{key: resp.data.id, folioNo: resp.data.folioNumber}];
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.changeFolio();
            vm.formData.schemeCode = resp.data.sourceScheme;
            fetchUnitDetails();
            vm.selectedInSchemeCode = resp.data.targetScheme;
            // vm.selectedInScheme = resp.data.targetSchemeName;
            fetchSchemeValidations(function (err) {
              if (!err) {
                vm.formData.dividentOption = resp.data.dividendOption;
                vm.formData.stpType = resp.data.stpType;
                vm.frequencyList = (vm.formData.stpType == 'F') ? AppConstants.STP_FREQ_LIST_FOR_FIXED : AppConstants.STP_FREQ_LIST_FOR_CAPITAL;
                vm.selectedFrequency = vm.frequencyList.find(function (item) {
                  return item.key === resp.data.frequency;
                });
                vm.isShowDefault = 'true';
                vm.isSelectedInScheme = true;
                vm.formData.stpDay = vm.daysList.find(function (item) {
                  return item.value === +resp.data.stpDay;
                });
                vm.startDate = $window.moment(resp.data.startDate);
                vm.endDate = $window.moment(resp.data.endDate);
                // changeDay();
                vm.formData.amount = resp.data.amount;
                checkValidations();
              }
            });
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    function getInvestorInfo(cb) {
      cb = cb || function() {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          // $log.debug("Investor Info-----",vm.investorInfo);
          //checkIsTxnBlock(resp.data.panNumber);
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
          cb();
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
        cb();
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function folioList() {
      var payload = {"investorUUID": vm.investorUUID},
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioList = resp.data.folioList || [];
            var folio = [];
            for (var i in folioList) {
              var obj = {}, item = folioList[i];
              obj.key = i;
              obj.activeFlag = item.activeFlag;
              obj.folioId = item.folioId;
              obj.folioNo = item.folioNumber;
              obj.isMinor = item.minorFlag;
              obj.holderDOBExists = item.holderDOBExists;
              obj.retirementSchemeBlankDOBErrorMsg = item.retirementSchemeBlankDOBErrorMsg;
              obj.corporateInvestor = item.corporateInvestor;
              folio.push(obj);
            }
            vm.folioListData = folio;
            if ($stateParams.folioNumber) {
              vm.formData.folioNumber = $stateParams.folioNumber;
              vm.changeFolio();
            }
          } else {
            vm.folioListData = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function changeFolio() {
      vm.hasFolioEmailId = true;
      vm.isFormDisable = true;
      if (!vm.formData.folioNumber) {
        $log.debug("Called:  ");
        vm.schemeList = null;
        return;
      } else if (vm.nomineefolioList && vm.nomineefolioList.includes(vm.formData.folioNumber)) {
        ModalService.genericModal({
          text: vm.nomineeMessage
        },function () {
          if (vm.blockFolioForTransaction) {
            vm.formData.folioNumber = null;
            vm.formData.schemeCode = null;
            vm.unitsDetails = null;
            vm.tForm.$setPristine();
            //$state.reload();
          }
        });
      }
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var selectedFolioObj = vm.folioListData.filter(function (row) {
        return row.folioNo == vm.formData.folioNumber
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
      }
      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.isMinor) ? selectedFolioObj.isMinor : false;

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.isFormDisable = false;
          fetchSchemes();
          fetchAllSchemeType();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    }

    function fetchSchemes() {
      // resetAll();
      vm.schemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemeList = resp.data.schemes;
            if(vm.formData.schemeCode){
              var result = vm.allSchemesList.find(function (scheme) {
                return scheme.schemeCode == vm.formData.schemeCode;
              });
              vm.selectedInScheme = result.scheme;
            }
          } else {
            vm.schemeList = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      SchemeService.post({
        controller: 'folio',
        child1: 'schemes',
        child2: 'source',
        child3: 'flex-index-enabled'
      }, {folioNumber: vm.formData.folioNumber, corporateFlag: vm.selectedFolioData.corporateInvestor}).$promise.then(success, error);
    }

    function fetchAllSchemeType() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.schemeList) {
            vm.allSchemesList = resp.data.schemeList;
            vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList);
            if(vm.selectedInSchemeCode){
              var result = vm.filteredinSchemeList.find(function (scheme) {
                return scheme.schemeCode == vm.selectedInSchemeCode;
              });
              vm.selectedInScheme = result.scheme;
            }
          } else {
            vm.allSchemesList = null;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.allSchemesList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        minor: vm.formData.minorFlag,
        portalName: "",
        schemeType: "ALL",
        taxStatusCode: "",
        investThroughDistributor: false
      };
      SchemeService.post({
        controller: 'schemes',
        child1: 'target',
        child2: 'flex-index-enabled'
      }, payload).$promise.then(success, error);
    }

    function fetchUnitDetails() {
      vm.validations = null;
      vm.unitsDetails = null;
      // vm.selectedInScheme = null;
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme: ');
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.unitsDetails = resp.data;
            vm.unitsDetails.message = resp.message || '';
            vm.unitsDetails.freeValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.freeValueAmount);
            vm.unitsDetails.lockedValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.lockedValueAmount);
            vm.unitsDetails.totalCurrentValueAmountUnit = UtilService.getUnitSting(vm.unitsDetails.totalCurrentValueAmount);

            if(vm.allSchemesList&&vm.allSchemesList.length>0){
              vm.sourceScheme = vm.allSchemesList.filter(function (scheme) {
                return scheme.schemeCode === vm.formData.schemeCode
              });
              vm.sourceScheme = vm.sourceScheme[0];
            }
            fetchSchemeValidations();
            // checkValidations();
          } else {
            vm.unitsDetails = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.unitsDetails = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'transaction',
        child1: 'folio',
        child2: 'scheme-value'
      }, {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "FLEXINDEX"
      }).$promise.then(success, error);
    }

    function inSchemeChanged(data) {
      // if (vm.unitsDetails && vm.unitsDetails.message) {
      //   MessageService.error(vm.unitsDetails.message);
      //   return;
      // }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      if (!data) {
        return;
      }


      vm.isResetting = true;
      vm.isSelectedInScheme = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      // resetDefaults();
      if (data) {
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(data, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.selectedInScheme = null;
          vm.filterInSchemeList();
          return;
        }
        vm.selectedInSchemeCode = data.schemeCode;
        vm.selectedInScheme = data.scheme;
        vm.validations.investmentOption = data.investmentMode;
        $log.debug("New Changed Schemes: ", data);
        // fetchSchemeValidations();
      }
      else {
        vm.selectedInSchemeCode = '';
        vm.selectedInScheme = '';
        $log.debug("Else Calling: ", vm.selectedInScheme);
      }
    }

    function schemeListModal() {
      if (vm.unitsDetails && vm.unitsDetails.message) {
        MessageService.error(vm.unitsDetails.message);
        return;
      }
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      vm.formData.amount = '';
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      // resetDefaults();
      var successSchemeList = function (result) {
          vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
          if (vm.showRetirementSchemeError) {
            MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
            vm.selectedInScheme = null;
            return;
          }
          vm.selectedInSchemeCode = result.schemeCode;
          vm.selectedInScheme = result.scheme;
          fetchSchemeValidations();
        },
        errorSchemeList = function () {
          vm.selectedInSchemeCode = '';
          vm.selectedInScheme = '';
        };


      ModalService.schemeListModal({
        isMinor: vm.formData.minorFlag,
        transactionType: 'flexindex',
        corporateFlag: vm.selectedFolioData.corporateInvestor
      }, successSchemeList, errorSchemeList);
    }

    function fetchSchemeValidations(cb) {
      cb = cb || function () {
      };
      if (!vm.formData.schemeCode) {
        MessageService.error('Please select a scheme first');
        return;
      }
      // vm.validationsData = null;
      vm.validations = null;
      vm.isMultiples = false;
      vm.isMin = false;
      vm.isMax = false;
      vm.isResetting = true;
      angular.element("#divDisplayWords").text('(In Words)');

      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      // vm.validations = {
      //   minAmount: 20000,
      //   // maxAmount: resp.data.maxAmount,
      //   multiples: 1000
      // };

      var success = function (resp) {
          if (resp.status && resp.data) {

            vm.validations = {
              minAmount: resp.data.minAmount,
              // maxAmount: resp.data.maxAmount,
              multiples: resp.data.multiples
            };
            checkValidations();
            // if (vm.validateData) {
            //   vm.formData.dividentOption = (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH ? 'Z' : (vm.validationsData.endingType === vm.ENDING_TYPES.CLOSED ? vm.transactionConstants.PAYOUT : vm.transactionConstants.REINVEST));
            // } else {
            //   vm.formData.dividentOption = vm.formData.dividentOption || vm.transactionConstants.REINVEST;
            // }

            cb(null);
          } else {
            cb('error');
            MessageService.error(resp.message);
            vm.validationsData = null;
          }
        },
        error = function (err) {
          cb('error');
          vm.validationsData = null;
          UtilService.errorHandler(err);
        };
      var payload = {
        folioNo: vm.formData.folioNumber,
        schemeCode: vm.formData.schemeCode,
        transactionType: "FLEXINDEX"
      };
      SchemeService.post({
        controller: 'validation',
        type: 'flexIndex'
      }, payload).$promise.then(success, error);
    }

    function investModeChanged(type) {
      if (type === "Fixed") {
        vm.specificProperties.validations = {
          stage1: vm.specificProperties.validations.stage1,
          stage2: vm.specificProperties.validations.stage2,
          stage3: vm.specificProperties.validations.stage3,
          stage4: vm.specificProperties.validations.stage4,
          installment1: true,
          installment2: true,
          installment3: true,
          installment4: true,
          installmentsSumHundred: true
        }
      }
      else {
        var validations = validateFlexible(vm.specificProperties.investmentModeData);
        $log.debug("Validations Keys: ", validations);
        vm.specificProperties.validations = {
          stage1: vm.specificProperties.validations.stage1,
          stage2: vm.specificProperties.validations.stage2,
          stage3: vm.specificProperties.validations.stage3,
          stage4: vm.specificProperties.validations.stage4,
          installment1: validations[0],
          installment2: validations[1],
          installment3: validations[2],
          installment4: validations[3],
          installmentsSumHundred: validations[4]
        }
      }
    }

    function validateFlexible(investmentModeData) {
      var values = [];
      // $log.debug("InvestmentModeData : ",investmentModeData);
      values[0] = investmentModeData.installment1;
      values[1] = investmentModeData.installment2;
      values[2] = investmentModeData.installment3;
      values[3] = investmentModeData.installment4;
      var total = investmentModeData.totalInvestment;
      var valid = [];
      values.forEach(function (value, index) {
        if (value > 9 && value < 100) {
          valid[index] = true;
        } else {
          valid[index] = false;
        }
      });
      valid[4] = (total) ? (total === 100) : false;
      return valid;
    }


    function stageValueChanged(changed_Stage) {
      var _investmentModeData = vm.specificProperties.investmentModeData;
      _investmentModeData[changed_Stage] = parseInt(_investmentModeData[changed_Stage]);
      var newValue = _investmentModeData[changed_Stage];
      if (newValue % 100 !== 0) {
        vm.specificProperties.validations[changed_Stage] = false;
        $log.debug(vm.specificProperties.validations);
      }
      else {
        vm.specificProperties.validations[changed_Stage] = true;
      }
    }

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.filteredinSchemeList = UtilService.getFilteredList(vm.allSchemesList, 'scheme', vm.selectedInScheme);
    };

    function installmentValueChanged(change_InstallMent) {
      var _investmentModeData = vm.specificProperties.investmentModeData;
      _investmentModeData[change_InstallMent] = parseInt(_investmentModeData[change_InstallMent]);
      if (isNaN(_investmentModeData[change_InstallMent])) {
        _investmentModeData[change_InstallMent] = "";
      }

      _investmentModeData.totalInvestment = TransactionInitiateModel.getTotalInvesment(_investmentModeData);

      vm.specificProperties.validations[change_InstallMent] = !(_investmentModeData[change_InstallMent] > 99 || _investmentModeData[change_InstallMent] < 10 || _investmentModeData[change_InstallMent] == "");

      vm.specificProperties.validations.installmentsSumHundred = _investmentModeData.totalInvestment === 100;

      $log.debug("Total value", _investmentModeData.totalInvestment);

    }

    vm.checkValidScheme = function () {
      $timeout(function () {
        if (vm.allSchemesList && vm.allSchemesList.length > 0) {
          var Arr = [];
          Arr = vm.allSchemesList.filter(function (item) {
            return item.scheme == vm.selectedInScheme;
          });
          if (Arr.length == 0) {
            // vm.selectedInScheme = '';
            vm.isSelectedInScheme = true;
          }
        }
      }, 100);
    };


    function checkValidations() {
      var amount;
      amount = (amount = parseInt(vm.formData.amount)) ? amount : 0;
      $log.debug(amount);
      vm.isMin = (amount < vm.validations.minAmount) ? false : true;
      vm.isMax = (amount === vm.validations.maxAmount) ? true : false;
      if (vm.isMin) {
        vm.isMultiples = (amount % vm.validations.multiples === 0) ? true : false;
      } else {
        vm.isMultiples = true;
      }
      $log.debug("Values After Changes: ", vm.isMin);
    }

    function confirmCancel() {
      var success = function () {
        var _statusType = $stateParams.status;
        var identifier = AuthService.getToken();
        if (identifier && identifier.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
        }
      };
      ModalService.confirmCancelModal({}, success);
    }

    function validateForm() {
      return vm.tForm.$valid;
    }

    function _submitForm() {
      vm.isSubmitted = true;

      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Invalid arnCode');
        return;
      }

      if (!validateForm()) {
        MessageService.error('Please Fill All Mandatory');
        return;
      }
      // if (!vm.validationsData || !vm.validationsData.investmentOption) {
      //   MessageService.error("Invalid Investment option is selected.");
      //   vm.isSubmitted = false;
      //   return;
      // }

      $log.debug("Log From Submit:   ", vm.specificProperties.investmentModeData);

      if (vm.specificProperties.investmentMode !== "Fixed") {
        var switchExecutionDetails = {
          firstSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage1,
            switchPercentage: vm.specificProperties.investmentModeData.installment1
          },
          secondSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage2,
            switchPercentage: vm.specificProperties.investmentModeData.installment2
          },
          thirdSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage3,
            switchPercentage: vm.specificProperties.investmentModeData.installment3
          },
          fourthSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage4,
            switchPercentage: vm.specificProperties.investmentModeData.installment4
          }
        }
      }
      else {
        switchExecutionDetails = {
          firstSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage1,
            switchPercentage: "25"
          },
          secondSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage2,
            switchPercentage: "25"
          },
          thirdSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage3,
            switchPercentage: "25"
          },
          fourthSwitchExecutionEntry: {
            sensexLevelForSwitch: vm.specificProperties.investmentModeData.stage4,
            switchPercentage: "25"
          }
        }
      }

      var payload = {
        amountForRegistration: vm.formData.amount,
        brokerCode: identifierData.arnCode,
        compositeTransactionId: "",
        dividendOption: "Z",
        folioNumber: vm.formData.folioNumber,
        formType: "FLEXINDEX",
        id: $stateParams.transactionId || "",
        investmentMode: (vm.specificProperties.investmentMode === "Fixed") ? 'F' : 'V',
        inverstorUuid: vm.investorUUID,
        sourceScheme: vm.formData.schemeCode,
        subBrokerCode: "",
        switchExecutionDetails: switchExecutionDetails,
        targetScheme: vm.selectedInSchemeCode
      };

      var _scheme = vm.schemeList && vm.schemeList.find(function (i) {
        return i.schemeCode === vm.formData.schemeCode;
      }) || {};
      if (!vm.oversea_arn) {
        payload.euinOpted = vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N';
        payload.euinCode = vm.formData.euinObj && vm.formData.euinObj.euinCode || '';
        payload.euinName = vm.formData.euinObj && vm.formData.euinObj.euinName || '';
      } else {
        payload.euinOpted = 'N';
      }

      if(vm.formData.subBrokerARN){
        payload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        payload.subBrokerCode = vm.formData.subBrokerCode;
      }

      var additionalData = {
        targetScheme: vm.selectedInScheme,
        sourceScheme: vm.formData.schemeCode,
        sourceSchemeName: _scheme.schemeName,
        subBrokerArn: vm.formData.subBrokerARN,
        subBrokerCode: vm.formData.subBrokerCode,
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName ? vm.formData.euinObj.euinName : null,
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode ? vm.formData.euinObj.euinCode : null
      };
      /*vm.formData.schemeCode*/

      var successSTPModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A') {
            $state.go("agent.home.distributor-home")
          } else {
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'FLEXINDEX',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };


      ModalService.transactionReviewModal({
        payload: payload, controller: 'flexindex', additionalData: additionalData
      }, success, error);
    }


    function getFlexIndexPayloadToSave() {
      var payload;
      payload = {
        "investmentOption": vm.validationsData?vm.validationsData.investmentOption:null,
        "dividendOption": vm.validationsData?((vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption):'',
        "stpType": vm.formData.stpType,
        "folioNumber": vm.formData.folioNumber,
        "sourceSchemeCode": vm.formData.schemeCode,
        "stpDay": vm.formData.stpDay?vm.formData.stpDay.value:null,
        "amount": vm.formData.amount,
        "targetSchemeCode": vm.selectedInSchemeCode,
        "frequency": vm.selectedFrequency ? vm.selectedFrequency.key : null,
        "formType": "STP",
        "id": $stateParams.transactionId || "",
        "noOfInstallments": vm.formData.installment,
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };
      /*payload = {
        "amountForRegistration": 100000,
        "brokerCode": "ARN-0411",
        "compositeTransactionId": "",
        "dividendOption": "Z",
        "euinCode": "E030803",
        "euinName": "Richa Tripathi",
        "euinOpted": "Y",
        "folioNumber": "5663377",
        "formType": "FLEXINDEX",
        "id": "",
        "investmentMode": "F",
        "inverstorUuid": "12138f10-29ac-487f-946c-7b570bf1c264",
        "sourceScheme": "44",
        "subBrokerCode": "",
        "switchExecutionDetails": {
          "firstSwitchExecutionEntry": {
            "sensexLevelForSwitch": 9600,
            "switchPercentage": "25"
          },
          "secondSwitchExecutionEntry": {
            "sensexLevelForSwitch": 10300,
            "switchPercentage": "25"
          },
          "thirdSwitchExecutionEntry": {
            "sensexLevelForSwitch": 8900,
            "switchPercentage": "25"
          },
          "fourthSwitchExecutionEntry": {
            "sensexLevelForSwitch": 8900,
            "switchPercentage": "25"
          }
        },
        "targetScheme": "BFG",
        "approvalMode": "Online"
      }*/
      return angular.copy(payload);
    }

    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var identifier = AuthService.getToken();
      var payload = getFlexIndexPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'flexIndex',
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.selectedInScheme) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
          if(saveClicked){
            vm.saveForm(function () {
              AgentSocketService.impersonateLogout(args);
            })
          }else{
            AgentSocketService.impersonateLogout(args);
          }
        });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    function checkIsTxnBlock(panNumber) {
      var successHandler = function(resp){
        if (resp) {
          vm.nomineefolioList = resp.folioList;
          vm.nomineeMessage = resp.popUpMessage;
          vm.blockFolioForTransaction = resp.blockFolioForTransaction ? resp.blockFolioForTransaction : false;
        } else {
          MessageService.error();
        }
      };
      UtilService.checkTxnBlock(panNumber).then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DtpController', dtpController);

  /** @ngInject */
  function dtpController(MessageService, ModalService, $stateParams, AuthService, LoaderService, InvestorsService, AppConstants, UtilService, $state, $timeout, SchemeService, TransactionService,HDFC_API,$scope,AgentSocketService, $window , DynamicData, panAdharLinkingService ) {
    var vm = this;
    var identifier = AuthService.getToken();
    vm.validationsData = {};
    vm.formData = {minorFlag:'false'};
    vm.submit = submit;
    vm.init = init;
    vm.inSchemeChanged = inSchemeChanged;
    vm.getSchemesList = getSchemesList;
    vm.transactionConstants = AppConstants.TRANSACTION;
    vm.dtpDevidendOptions = [vm.transactionConstants.REINVEST, vm.transactionConstants.PAYOUT];
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants);
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investorUUID = $stateParams.uuid;
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.termsAndContitions = termsAndContitions;
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
    vm.showTerms = true;
    vm.dynamicNote = DynamicData.noteDTO.noteDTOMap;

    function init() {
      if (!vm.investorUUID) {
        $state.go('main.dashboard');
        return;
      }

      vm.investorUUID = $stateParams.uuid;

      if ($stateParams.transactionId) {
        vm.investorUUID = $stateParams.uuid;
          getTransactionDetails();
      }
        getInvestorInfo();
        getEuinCodes();
        fetchFolioList();

      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });

    }

    function getTransactionDetails() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.formData.folioNumber = resp.data.folioNumber;
            vm.formData.outSchemeCode = resp.data.sourceScheme;
            vm.formData.inSchemeCode = resp.data.targetScheme;
            vm.changeFolio();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      if (identifier.loginType == 'A') {
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          child1: 'agent',
          controller:'saved',
          child2: 'draft',
          child3: $stateParams.transactionId
        }).$promise.then(success, error);

      } else {
        TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'read'}, {
          transactionId: $stateParams.transactionId,
          type: $stateParams.transactionType
        }).$promise.then(success, error);
      }
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function getInvestorInfo() {
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function fetchInSchemes() {
      if (!vm.investorInfo) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }

      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.masterInSchemeList = resp.data.schemeList;
            vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
            if(vm.inSchemeList && vm.inSchemeList && vm.inSchemeList.length>0 && vm.formData.inSchemeCode){
              var result = vm.inSchemeList.find(function (scheme) {
                return scheme.schemeCode == vm.formData.inSchemeCode;
              });
              vm.formData.inSchemeName = result.scheme;
            }

          } else {
            vm.masterInSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.masterInSchemeList = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'dtpenabled',
        child2: vm.formData.minorFlag,
        child3: vm.selectedFolioData.corporateInvestor
      }, null).$promise.then(success, error);
    }

    function fetchFolioList() {
      var payload = {
        "investorUUID": vm.investorUUID,
        "folioTrxnType": "DTP"
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioListData = resp.data.folioList || [];
            var folioList = [];
            Object.keys(folioListData).forEach(function (key) {
              var obj = Object.assign({key: key}, folioListData[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'folioList'},payload).$promise.then(success, error);
    }

    vm.changeFolio = function () {
      //resetAll();
      // fetchOutSchemes();
      vm.hasFolioEmailId =true;
      if (!vm.formData.folioNumber) {
        return;
      }

      var selectedFolioObj = vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      if(selectedFolioObj) {
        vm.selectedFolioData = selectedFolioObj;
      }
      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.hasFolioEmailId && vm.fetchOutSchemes();
          fetchInSchemes();//Fetch in scheme on change folio
        } else {
          vm.hasFolioEmailId =false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId =false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    };

    vm.outSchemeChanged = function () {
      //resetAll();
    };

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinObj = vm.euinList.length==1?vm.euinList[0]:null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION:HDFC_API.VERSION,controller: 'getEuin'}).$promise.then(success, error);
    }

    vm.fetchOutSchemes = function(cb) {
      cb = cb || function () {
        };

      if (!vm.formData.folioNumber) {
        return;
      }

      vm.outSchemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.outSchemeList = resp.data.schemes;
            cb();
          } else {
            vm.outSchemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.outSchemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var _config = {controller: 'folio', child1: 'schemes', child2: 'dtp'};
      SchemeService.post(_config, {folioNumber: vm.formData.folioNumber}).$promise.then(success, error);
    }

     vm.filterInSchemeList = function () {
     vm.formData.inSchemeCode = '';
     vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
     };

      function getSchemesList() {
          if (vm.unitsDetails && vm.unitsDetails.message) {
              MessageService.error(vm.unitsDetails.message);
              return;
          }
          if (!vm.investorInfo) {
              MessageService.error("Investor's sole applicant details not found");
              return;
          }

          resetDefaults();
          var successSchemeList = function (result) {
              vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(result, vm.selectedFolioData);
              if (vm.showRetirementSchemeError) {
                MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
                vm.formData.inSchemeName = null;
                return;
              }
                  vm.formData.inSchemeCode = result.schemeCode;
                  vm.formData.inSchemeName = result.scheme;
                  vm.selectedInSchemeCode = vm.formData.inSchemeCode?vm.formData.inSchemeCode:null;
                  fetchInSchemeValidations();
              },
              errorSchemeList = function () {
                  vm.formData.inSchemeCode = '';
                  vm.formData.inSchemeName = '';
              };
          ModalService.schemeListModal({
              enabledScheme: "dtpenabled",
              isMinor: vm.formData.minorFlag,
            corporateFlag: vm.selectedFolioData.corporateInvestor
          }, successSchemeList, errorSchemeList);
      }

    function inSchemeChanged(schemeData) {
        vm.selectedInSchemeCode = schemeData?schemeData.schemeCode:null;
      if (!schemeData) {
       return
      } else {
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          vm.filterInSchemeList();
          return;
        }
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
        fetchInSchemeValidations();
      }
      vm.formData.amount = '';
      vm.formData.units = '';
      vm.formData.amountType = 'amount';
      reSetting();
      resetDefaults();
    }


      function fetchInSchemeValidations() {
          if (!vm.selectedInSchemeCode) {
              MessageService.error('Please select a scheme first');
              return;
          }

          var success = function (resp) {
                  if (resp.status && resp.data) {
                      vm.validationsData = resp.data;
                    if (vm.validationsData && vm.validationsData.investmentOption===AppConstants.TRANSACTION.GROWTH) {
                      vm.formData.dividentOption = AppConstants.DIVIDEND_OPTIONS.GROWTH;
                    } else {

                      if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === false){
                        vm.formData.dividentOption = AppConstants.TRANSACTION.PAYOUT;
                      }else if(vm.validationsData.dividendPayoutApplicable === false && vm.validationsData.dividendReinvestmentApplicable === true) {
                        vm.formData.dividentOption = AppConstants.TRANSACTION.REINVEST;
                      }else if(vm.validationsData.dividendPayoutApplicable === true && vm.validationsData.dividendReinvestmentApplicable === true) {
                        vm.formData.dividentOption = AppConstants.TRANSACTION.REINVEST;
                      }else {
                        vm.formData.dividentOption = '';
                      }
                    }
                  } else {
                      MessageService.error('Some error occurred. Please try again.');
                      vm.validationsData = null;
                  }
              },
              error = function (err) {
                  vm.validationsData = null;
                  UtilService.errorHandler(err);
              };
          SchemeService.get({
              controller: 'schemeValidation',
              type: 'dtp',
              child1: vm.selectedInSchemeCode
          }, null).$promise.then(success, error);
      }

    function reSetting() {
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    function resetDefaults() {
      vm.isReseting = true;
      vm.validations = {};
      $timeout(function () {
        vm.isReseting = false;
      }, 0);
    }

    vm.submitFirst = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if(resp.data.hasWarning){
              var successModal= function () {
                submit();
              }, errorModal = function () {
              };
              ModalService.transactionWarningModal({msg:resp.data.warningMessage}, successModal, errorModal)
            }
            else{
              submit();
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        transactionType:'DTP',
        folioNumber:vm.formData.folioNumber,
        schemeCode:vm.formData.outSchemeCode,
        targetSchemeCode:vm.formData.inSchemeCode
      };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'check',
        child2: 'duplicate'
      }, payload).$promise.then(success, error);
    };

    vm.confirmCancel = function () {
      var success = function () {
        var _statusType = $stateParams.status;

        if(identifier && identifier.loginType=='A'){
          $state.go('agent.home.distributor-home');
        } else{
          _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
        }

      };
      ModalService.confirmCancelModal({}, success);
    };

    function submit() {
      vm.isSubmitted = true;

      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "folioNumber": vm.formData.folioNumber,
        "sourceScheme": vm.formData.outSchemeCode,
        "targetScheme": vm.formData.inSchemeCode,
        "formType": "DTP",
        "id": $stateParams.transactionId || "",
        "subBrokerCode": ""
      };

      if (!vm.oversea_arn) {
        payload.euinOpted = vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N';
        payload.euinCode = vm.formData.euinObj && vm.formData.euinObj.euinCode || '';
        payload.euinName = vm.formData.euinObj && vm.formData.euinObj.euinName || '';
      } else {
        payload.euinOpted = 'N';
      }

      if(vm.formData.subBrokerARN){
        payload.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
      }
      if(vm.formData.subBrokerCode){
        payload.subBrokerCode = vm.formData.subBrokerCode;
      }

      var successSTPModal = function () {
          vm.isSubmitted = false;
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.home.distributor-home")
          } else{
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'DTP',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };


      var _scheme = vm.outSchemeList && vm.outSchemeList.find(function (i) {
          return i.schemeCode === vm.formData.outSchemeCode;
        }) || {};

      var additionalData = {
        investorName: vm.investorInfo ? vm.investorInfo.name : '',
        sourceSchemeName: _scheme.schemeName,
        targetSchemeName: vm.formData.inSchemeName,
        mobileNumber : vm.mobileNumber ? vm.mobileNumber : '',
        emailId : vm.emailId ? vm.emailId : '',
        panNumber: vm.investorInfo.panNumber,
        coperateFlag: vm.investorInfo.corporateFlag,
        subBrokerArn: vm.formData.subBrokerARN,
        subBrokerCode: vm.formData.subBrokerCode,
        euinName: vm.formData.euinObj && vm.formData.euinObj.euinName ? vm.formData.euinObj.euinName : null,
        euinCode: vm.formData.euinObj && vm.formData.euinObj.euinCode ? vm.formData.euinObj.euinCode : null
        // stpDay: vm.formData.stpDay.name,
        // frequency: vm.selectedFrequency.value
      };
      ModalService.transactionReviewModal({
        payload: payload, controller: 'dtp', additionalData: additionalData
      }, success, error);
    }


    function getDtpPayloadToSave() {
      var payload = {
        "investmentOption": vm.validationsData.investmentOption,
        "dividendOption": (vm.validationsData.investmentOption === vm.transactionConstants.GROWTH) ? "Z" : vm.formData.dividentOption,
        "folioNumber": vm.formData.folioNumber,
        "sourceScheme": vm.formData.outSchemeCode,
        "targetScheme": vm.formData.inSchemeCode,
        "formType": "DTP",
        "id": $stateParams.transactionId || "",
        "subBrokerCode": "",
        'euinOpted': vm.formData.euinObj && vm.formData.euinObj.euinCode ? 'Y' : 'N',
        'euinCode': vm.formData.euinObj && vm.formData.euinObj.euinCode || '',
        'euinName': vm.formData.euinObj && vm.formData.euinObj.euinName || ''
      };
      /*var payload = {
        "amount":1000,
        "folioNumber":"10301635",
        "formType":"SWP",
        "frequency":"OM",
        "id":"",
        "schemeCode":"44",
        "startDate":"02-Mar-2018",
        "swpDay":"2",
        "swpType":"F",
        "toDate":"02-Jan-2019",
        "approvalMode":"Online"
      }*/
      return angular.copy(payload);
    }
    /*Save transaction Start*/

    vm.saveForm = function (cb) {
      cb = cb || function () {

      }
      vm.isSaving = true;
      var payload = getDtpPayloadToSave();
      payload.agentId = identifier.userId;
      payload.investorUuid = $stateParams.uuid;
      payload.brokerCode = identifier.arnCode;
      payload.subBrokerCode = '';

      if (!payload) {
        return;
      }
      LoaderService.showLoader();
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            cb(true);
          } else {
            MessageService.error(vm.validations.FORM_SAVE_FAILED);
            cb(false);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(vm.validations.FORM_SAVE_FAILED);
          cb(false);
        };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        child1: 'agent',
        controller: 'dtp',//vm.formData.investmentType.toLowerCase(),
        child2: 'save'
      }, payload).$promise.then(success, error);

    };
    /*Save transaction End*/

    /*Socket code Start*/
    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var payload={};
      if (!vm.formData.inSchemeName) {
        payload.saveEnable = false;
        AgentSocketService.showDisconnedtPopUp(payload, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        payload.saveEnable = true;
        AgentSocketService.showDisconnedtPopUp(payload  , function (saveClicked) {
            if(saveClicked){
              vm.saveForm(function () {
                AgentSocketService.impersonateLogout(args);
              })
            }else{
              AgentSocketService.impersonateLogout(args);
            }
          });
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });
    /*Socket code End*/

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinObj = vm.euinList.length == 1 ? vm.euinList[0] : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DreamSipController', dreamSipController);

  /** @ngInject */
  function dreamSipController($state, $stateParams, $scope,BillJunctionService, $rootScope, $window, AuthService, $timeout, InvestorModel,
    MessageService, UtilService, InvestorsService,
    TransactionInitiateModel, AppConstants, ModalService, moment,
    LoaderService, SchemeService, TransactionService, HDFC_API,InvestorServiceDynamicData,InvestorCommonServiceVersion2, panAdharLinkingService) {
    var vm = this;
    vm.investorInfo = null;
    vm.AppConstants = AppConstants;
    vm.investorUUID = $stateParams.uuid;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.transactionType = 'DREAMSIP';
    vm.SUMMARY_CONST = angular.copy(AppConstants.SUMMARY_TYPES);
    vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
    vm.formData.sipFirstInstallment = false;
    vm.formData.startDate = null;
    vm.formData.endDate = null;
    vm.formData.installmentAmount = 5000;
    $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392', vm);
    vm.liquidSchemeFlag = false;
    vm.NAV_APPLICABILITY_NOTE = AppConstants.NAV_APPLICABILITY_NOTE;
    vm.folioList = null;
    vm.validTopUpData = false;
    vm.profile = AuthService.getToken();
    vm.optionList = AppConstants.OPTION_LIST;
    vm.formData.sipPaymentOption = 'UPI';
    vm.validPaymentOption = true;
    vm.changeSipTopupSelected = changeSipTopupSelected;
    vm.changedPaymentOption = changedPaymentOption;
    vm.checkEmandateBank = checkEmandateBank;
    vm.valiadtTopUpdata = valiadtTopUpdata;
    vm.validateSchemeRequrement = validateSchemeRequrement;
    vm.newFolioClickAction = newFolioClickAction;
    vm.euinChanged = euinChanged;
    vm.fetchDreamSipPeriod = fetchDreamSipPeriod;
    vm.validaBankProcced = validaBankProcced;
    vm.validateSchemeRequrementData = true;
    vm.checkOTM = checkOTM;
    vm.kycVerifiedFlag = null;
    vm.capAmountChanged = capAmountChanged;
    vm.showNote = true;
    vm.devidendOptions = [];
   // vm.DynamicDataSipPurchaseReview = DynamicDataSipPurchaseReview;
    vm.setDynamicData = setDynamicData;
    vm.isEMandateEnabled = false;
    vm.EMbankList = null;
    vm.validations = {};
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.checkEndNoteOtm = checkEndNoteOtm;
    vm.checkEndNoteEOtm = checkEndNoteEOtm;
    vm.checkSipValidations = checkSipValidations;
    vm.checkSwapValidations = checkSwapValidations;
    vm.checkValidations = checkValidations;
    vm.showOtmNote = true;
    vm.today = $window.moment($window.moment(), "DD-MMM-YYYY HH:mm A");
    vm.popup = {};
    vm.showEotmNote = true;
    vm.showTerms = true;
    vm.showTermsEmandate = false;
    vm.SIP_Installment_disable = false;
    vm.sip_topup_details =false;
    vm.DIVIDEND_DESCRIPTIONS = {
      "Y":'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option',
      "N":'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option'
    }
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.defaultMandateYearDate = AppConstants.EMANDATE_MAX_DURATION_YEARS;
    vm.formData.emandateWord = {};
    vm.upiBankList = null;
    vm.upiAmountLimit = '';
    vm.handleMandatePaymentOption = handleMandatePaymentOption;
    vm.handleUpiError = handleUpiError;
    vm.fetchEmailMobile = fetchEmailMobile;

    vm.init = function () {
      var isFromFolio = $window.JSON.parse(localStorage.getItem('isFromFolio'))? $window.JSON.parse(localStorage.getItem('isFromFolio')):false;
      if(isFromFolio && vm.summaryData){
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
         vm.formData = vm.summaryData;
      }else if ($stateParams.transactionId && $stateParams.initiatedBy !== 'schedule') {
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
         getTransactionDetails();
        if (vm.transactionType == "DREAMSIP") {
          vm.formData.investmentType = vm.formData.investmentType;
        }
          vm.viewMode = 'months';
        vm.showTermsEmandate = false;
      }else{
        localStorage.removeItem('isDreamSip');
        localStorage.removeItem('isFromFolio');
        fetchFolioList();
      }
      vm.getInvestorInfo();
    }
    if (vm.notesOtm && vm.notesEOtm !== undefined) {
      checkEndNote(vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.endDate, vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review.startDate);
      checkEndNoteOtm(vm.notesOtm.endDate, vm.notesOtm.startDate);
      checkEndNoteEOtm(vm.notesEOtm.endDate, vm.notesEOtm.startDate);
    }
    // setDynamicData();
    if (vm.popup !== undefined) {
      checkEndPopup(vm.popup.endDate, vm.popup.startDate);
    }
    vm.folioChanged = function () {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var successHandler = function(resp) {
        vm.dynamicData=  UtilService.fetchDynamicData("FOLIO_CREATION");
        vm.fetchDynamicData('SIP_SCREEN');
        if (!vm.formData.folioNumber) { return; }
        var oldData = angular.copy(vm.formData);
        //recoverFromResetting(oldData);
        var selectedFolioObj = vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        if(selectedFolioObj) {
          vm.selectedFolioData = selectedFolioObj;
        }
        resetAll();
        vm.folioMinor = false;
        vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
        vm.selectedFolioEmail = selectedFolioObj.email;
        vm.selectedFolioMobile = selectedFolioObj.mobileNumber;
        vm.formData.option = vm.optionList[0].value;
        getEuinCodes();
        if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
          if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isMobileinValid = true;
            vm.emandateDisplay = false;
          }
        }
        else if (vm.selectedFolioEmail === null || vm.selectedFolioEmail === '') {
          if (vm.selectedFolioMobile === null || vm.selectedFolioMobile === '') {
            vm.isEmailMobileinValid = true;
            vm.emandateDisplay = false;
          }
          else {
            vm.isEmailinValid = true;
            vm.emandateDisplay = false;
          }
        }
        checkOTM(function (success) {
          if (success) {
            changedPaymentOption();
          }
        })
        fetchDreamSipPeriod();
        vm.getInvestorInfo();
        if(vm.subBrokerName) {
          vm.subBrokerName = '';
          vm.fetchEuinListSubBroker();
        }
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
    };

    vm.getScheme = function(){
      checkEmandateBank();
      fetchBankList();
    }
        //E-manadate  bank

    function checkEmandateBank() {
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.isEMandateEnabled = resp.data.folioEmandateStatus;
              if ((resp.data.bankList && resp.data.bankList.length == 0) || !vm.isEMandateEnabled) {
                // vm.isEMandateEnabled = false;
                vm.EMbankList = null;
              }else{
                // vm.isEMandateEnabled = true;
                if(vm.isOTMEnabled && vm.isEMandateEnabled){
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                }
                if(!vm.isOTMEnabled && vm.isEMandateEnabled){
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                }
                if(!vm.isOTMEnabled && !vm.isEMandateEnabled){
                  vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
                }
                if(vm.sipFirstInstallment){
                  vm.isEMandateEnabled = false;
                }else {
                  vm.EMbankList = resp.data.bankList;
                  vm.eMandatenoOfDays=resp.data.noOfDays;
                  vm.eMandatemaxAmountLimit=resp.data.maxAmountLimit;
                }

                // if (vm.isEMandateEnabled) {
                  if (!vm.emandateUpiData) {
                    UtilService.fetchMandateValidations().then(function (resp) {
                      vm.emandateUpiData = resp;
                      if (vm.formData.sipPaymentOption == 'HEM' && vm.isEMandateEnabled) {
                        vm.emandateValidationData = vm.emandateUpiData.eOTM;
                      } else if (vm.formData.sipPaymentOption=='UPI') {
                        vm.emandateValidationData = vm.emandateUpiData.upi;
                      } else {
                        vm.emandateUpiData = null;
                      }
                      if(vm.emandateValidationData){
                        setEmandateUpiSetting();
                      }
                    }).catch(function(resp) {
                      MessageService.error(resp)
                    });
                  }
                // }
              }
            }

            if (vm.isUPIEnabled) {
              vm.formData.sipPaymentOption =  'UPI';
            } else if (vm.isOTMEnabled) {
              vm.formData.sipPaymentOption =  'OTM';
            } else if (vm.isEMandateEnabled && !vm.formData.sipFirstInstallment) {
              vm.formData.sipPaymentOption =  'HEM';
            } else if (vm.ECbankList) {
              vm.formData.sipPaymentOption =  'EC';
            }
          },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };

          LoaderService.showLoader();
          var payload = {
            "folioNumber": vm.formData.folioNumber,
            "trnxType": "SIP",
            "liquidSchemeFlag": vm.liquidSchemeFlag
          }
          LoaderService.showLoader();
          BillJunctionService.post({
            VERSION: 'v2',
            controller: 'bank',
            child1: 'list',
            child2: 'emandate'
          }, payload ).$promise.then(success, error);
    }
    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb) {
      cb = cb || function () {};
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.enabledOTMStartDatesList = [];
            var currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
            var todayDate = $window.moment(Date.parse(parsedDate));
            var counter = 0;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM || vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
            }else if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC){
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add( vm.inSchemeValidations && vm.inSchemeValidations.sipTDay? vm.inSchemeValidations.sipTDay: 19, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            // vm.startMinDateEMandate= $window.moment(Date.parse(parsedDate)).add(7,'days');
            /* if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
              vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            } */
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<7)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days').format('DD-MMM-YYYY'));
                counter++;
              }
            }
            vm.enabledBillerStartDatesList = [];
            if(vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM || vm.formData.sipPaymentOption===vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI){
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandatenoOfDays];
            }
            vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            vm.isReseting = true;
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          cb(false);
        };
        SchemeService.get({
        child1: 'nonBusinessDate',
        schemeCode: vm.formData.inSchemeCode //'AFWDQ'
      }).$promise.then(success, error);
    }

    function getTransactionDetails() {
      if (!$stateParams.transactionId) {
        MessageService.error("TransactionId is missing for saved transaction.");
        $state.go('main.dashboard');
        return;
      }

      var success = function (resp) {
          if (resp.data && resvicp.status) {
            showPrefillValues(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
        SchemeService.get({
        controller1: 'transaction',
        controller2: 'saved',
        controller3: $stateParams.transactionId,
        controller4: $stateParams.isCompId
      }).$promise.then(success, error);
    }

    function showPrefillValues(rawData) {
          if (rawData) {
            sipPrefillValues(rawData)
          }
    }

    function sipPrefillValues(data) {

      fetchFolioList(function (success) {
        if (success) {
          var rawData;
          var frequencyList = null;
          rawData = {sipForm: data};
          var folioNumber = data.folioNumber|| data.folioNo;
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == folioNumber;
          })[0];
          vm.folioMinor = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
          vm.folioInvestorName = selectedFolioObj && selectedFolioObj.investorName ?selectedFolioObj.investorName:'';
          vm.formData.isThroughDistributor = data.euinOpted === 'Y' ? true : false;
          if (rawData.sipForm) {
            vm.validations = vm.validations ? vm.validations : {};
            vm.formData.sTransactionId = rawData.sipForm.id;
            vm.formData.folioNumber = rawData.sipForm.folioNumber;
            vm.formData.amount = rawData.sipForm.installmentAmount;
            vm.formData.inSchemeCode = rawData.sipForm.schemeCode;
            vm.formData.frequency = rawData.sipForm.frequency || vm.formData.frequency || frequencyList[0].key;
            vm.formData.amount && $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
            vm.formData.option = (rawData.sipForm.option == 'B')? 'Option B':'Option A';
            vm.formData.sipPaymentOption = vm.paymentOptions && vm.paymentOptions[0]?vm.paymentOptions[0] : 'EC';
            if(rawData.sipForm.option == 'B'){
              vm.formData.targetSchemecode = rawData.sipForm.targetSchemeCode;
            }
            if (rawData.sipForm.bankDetailsForECS) {
              vm.formData.bankAcNo = rawData.sipForm.bankDetailsForECS.accNumber;
              vm.formData.bankCity = rawData.sipForm.bankDetailsForECS.bankCity;
              vm.formData.bankName = rawData.sipForm.bankDetailsForECS.bankName;
              vm.formData.bankBranch = rawData.sipForm.bankDetailsForECS.branchName;
            }
            if (vm.calenderEndDateString === rawData.sipForm.toDate) {
              vm.formData.isTillPerpetuity = true;
            }

            if (rawData.sipForm.primaryFlag) {
              vm.formData.investmentType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
            }

            if (rawData.purchaseForm && rawData.sipForm) {
              vm.formData.optionalInvestmentType = 'SIP';

              if (vm.formData.investmentType === 'SIP') {
                vm.formData.optionalInvestmentType = 'PURCHASE';
              }
            }
            if (rawData.sipForm.euinOpted === 'Y') {
              vm.formData.euin = {euinCode: rawData.sipForm.euinCode, euinName: rawData.sipForm.euinName,euinNameCode: rawData.sipForm.euinName+"-"+rawData.sipForm.euinCode}
            }
            if (rawData.sipForm.riaOpted) {
              vm.formData.isThroughDistributor = false;
              vm.formData.isThroughRia = true;
              vm.formData.isDirect = false;
              vm.isArnSuccess = false;
              vm.formData.riaBrokerCode = rawData.sipForm.brokerCode;
              vm.riaConsent = rawData.sipForm.riaConsent;
              vm.isCheckedTandC = rawData.sipForm.riaConsent;
              vm.searchDistributor();
            }
            if (rawData.sipForm.brokerCode && !rawData.sipForm.riaOpted) {
              vm.formData.brokerCode = rawData.sipForm.brokerCode.replace('ARN-', '');
              vm.formData.isThroughDistributor = true;
              vm.formData.euinInput = rawData.sipForm.euinName + ' - ' + rawData.sipForm.euinCode;
              vm.searchDistributor();   // it will show the name of distributor based on broker code (ARN)
            }

            fetchInSchemes(function () {
              if(rawData.sipForm.option == 'B' && vm.targetSchemeList){
                vm.targetSchemeList.forEach(function(item) {
                  if(vm.formData.targetSchemeCode == item.targetSchemeCode){
                    vm.formData.targetSchemeName = item.scheme;
                    vm.formData.schemeType = item.schemeType;
                  }
                });
              }
              var scheme = vm.inSchemeList && vm.inSchemeList.find(function (item) {
                return vm.formData.inSchemeCode === item.schemeCode;
              }) || {};
              vm.formData.inSchemeName = scheme.scheme || '';
              checkOTM();
              fetchInSchemeValidations(function (err) {
                LoaderService.hideLoader();
              });
            });
            fetchBankList(function (success) {
              if (success){
                var bankDetails = vm.bankList && vm.bankList.find(function (item) {
                  // return i.bankCode === rawData.bankCode;
                  return item === rawData.sipForm.bankDetailsForECS;
                }) || {};
                angular.isDefined(vm.formData.bankInfo) && angular.isDefined(vm.formData.bankInfo.bankName) && (vm.formData.bankInfo.bankName = bankDetails.bankName || '');
              }

            });
            checkOTM();

          }
          vm.formData.isBackFromSummary = false;
        }
      })
    }
    function fetchFolioList(cb) {

      cb = cb || function () {
      };
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var folioList = resp.data.sortedFolios || [];
          vm.kycVerifiedFlag = resp.data.kycVerifiedFlag;
          if (resp.data.kycVerifiedFlag === false && $stateParams.initiatedBy != "schedule") {
            ModalService.genericModal({
              text: resp.data.kycMessage
            }, function () {
              $state.go("welcome");
            });
          }
          vm.folioList = folioList.length ? folioList : null;
          if (vm.folioList && vm.folioList.length === 1) {
            vm.formData.folioNumber = vm.folioList[0].folioNumber;
            fetchDreamSipPeriod();
            getEuinCodes();
            vm.fetchDynamicData('SIP_SCREEN');
            vm.getInvestorInfo(function(resp) {
              if(resp) {
                if (!vm.formData.isBackFromSummary && !$stateParams.transactionId) {
                  vm.folioChanged();
                }
              }
            });
          }
          if (vm.formData.dynamicData && vm.formData.dynamicData.folioNumber) {
            vm.formData.folioNumber = vm.formData.dynamicData.folioNumber;
            vm.folioChanged();
          }
          if ($stateParams.eCart) {
            vm.folioChanged();
          }

          cb(true);
        } else {
          vm.folioList = null;
          MessageService.error(resp.message);
          cb(false);
        }
      },error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      // InvestorsService
      InvestorServiceDynamicData.post({
        child1: 'dreamSip',
        child2: 'getNonMinorFolioList'
      },{investorUUID:vm.investorUUID}).$promise.then(success, error);
    }

    vm.handleEnter = function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        e.preventDefault();
      }
      return false;
    };

    function resetAll() {
      vm.formData.frequency = 'OM';
      vm.formData.amountType = 'amount';
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.outSchemeCode = '';
      vm.formData.dividendOption = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.amount = '';
      vm.formData.swapAmount = '';
      vm.formData.units = '';
      vm.formData.bankInfo = null;
      vm.formData.isTillPerpetuity = false;
      vm.formData.subBrokerArn = '';
      vm.formData.subBrokerCode = '';
      vm.subBrokerName = '';
      // vm.formData.transferOption = vm.TRANSACTIONS_CONST.TRANSFER_OPTIONS.FIXED_AMOUNT;


      vm.formData.euin = {};
      vm.euinData = {};
      vm.formData.brokerCode = '';
      vm.formData.brokerName = '';
      vm.euinList = null;
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.formData.subBrokerARN = '';
      vm.formData.subBrokerCode = '';
      vm.isCheckedTandC = false;
      vm.isArnSuccess = true;
      vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;

      vm.inSchemeValidations = null;
      vm.validations = {};
      vm.isRequired = false;
      vm.bankList = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
      vm.formData.option = "Option A";
      vm.changeOption(vm.formData.option);
      resetBankDetails();
      vm.formData.riaBrokerCode = "";
      vm.formData.riaBrokerName = "";
      vm.formData.isCheckedTandC = false;
      vm.brokerCodeError = "";
      vm.riaCodeError = "";
    }

    function resetBankDetails() {
      vm.formData.bankCity = '';
      vm.formData.bankBranch = '';
      vm.formData.bankAcNo = '';
      vm.formData.verifyBankAcNo = '';

    }


    function fetchInSchemes(cb) {
      cb = cb || function () {
      };

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.masterInSchemeList = resp.data.sourceSchemeList;
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
          if (vm.formData.option == "Option B") {
            vm.masterTargetInSchemeList = resp.data.targetSchemeList;
            vm.targetSchemeList = resp.data.targetSchemeList;
          }
          cb();
        } else {
          vm.masterInSchemeList = null;
          vm.masterTargetInSchemeList = null;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

        var payload = {
           option : vm.formData.option == 'Option B' ? 'B': 'A',
          corporateFlag: vm.selectedFolioData.corporateInvestor
        }
        InvestorServiceDynamicData.post({
          child1: 'dreamSip',
          child2: 'getSchemeList'
        }, payload).$promise.then(success, error);
    }

    vm.changeDistributorCode = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.distributorName = '';
      vm.euinList = null;
      vm.isArnSuccess = true;
      vm.riaCodeError = "";
    }
//  vm.subBrokerCodeError = '';
//     // vm.fetchEuinListSubBroker = function () {
//     //   if (!vm.formData.subBrokerARN) {
//     //     vm.subBrokerCodeError = '';
//     //     vm.subBrokerName = '';
//     //     vm.isSubarnSuccess = false;
//     //     vm.formData.euin = {};
//     //     vm.euinData = {};
//     //     fetchEuinList();
//     //     return;
//     //   }
//     //   if(vm.formData.brokerCode !== vm.formData.subBrokerARN){
//     //     vm.formData.euin = {};
//     //     vm.euinData = {};
//     //   }
//     //   var success = function (resp) {
//     //       LoaderService.hideLoader();
//     //       if (resp.status && resp.data) {
//     //         vm.euinMasterList = resp.data.euinList;
//     //         vm.euinList = vm.euinMasterList;
//     //         for(var i = 0; i<vm.euinList.length; i++){
//     //           if(vm.euinData.euinNameCode === vm.euinList[i].euinNameCode){
//     //             vm.formData.euin = vm.euinList[i];
//     //             break;
//     //           } else {
//     //             vm.formData.euin = {};
//     //           }
//     //         }
//     //         vm.euinData = vm.formData.euin;
//     //         vm.subBrokerName = resp.data.distributorName;
//     //         vm.subBrokerCodeError = '';
//     //         vm.isSubarnSuccess = false;
//     //       } else {
//     //         vm.euinList = null;
//     //         vm.subBrokerCodeError = resp.message;
//     //         vm.isSubarnSuccess = true;
//     //         vm.formData.euin = {};
//     //         MessageService.error(resp.message);
//     //       }
//     //     },
//     //     error = function () {
//     //       LoaderService.hideLoader();
//     //       vm.subBrokerCodeError = '';
//     //       //UtilService.errorHandler(err);
//     //     };

//     //   LoaderService.showLoader();
//     //   SchemeService.get({
//     //     /*controller1: 'transaction',*/
//     //     controller1: 'getEuin',
//     //     controller2: 'ARN-' + vm.formData.subBrokerARN,
//     //     isSubBroker: vm.formData.isThroughDistributor
//     //   }).$promise.then(success, error);
//     // }

    vm.searchDistributor = function () {
      //vm.isInvalidForm = vm.formData.brokerCode ? false : (vm.isArnSuccess ? true : false);
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      fetchEuinList();
    };

    vm.searchDistributorByName = function () {
      vm.formData.brokerName = '';
      vm.formData.distributorARN = '';
      vm.formData.brokerCode = '';
      //vm.isInvalidForm = true;
      vm.brokerCodeError = '';
      vm.isArnSuccess = true;
      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        vm.distributorList = null;
        vm.euinList = null;
        //vm.formData.euinInput = '';
        vm.formData.euin = null;
        return;
      }
      fetchARNByName();

    };

    function fetchARNByName() {

      if ((!vm.formData.distributorName) || (vm.formData.distributorName && vm.formData.distributorName.length < 3)) {
        return;
      }
      vm.formData.distributorARN = '';
      vm.distributorList = null;
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.distributorList = resp.data.distributorList;
            if (vm.distributorList.length == 0) {
              //vm.isInvalidForm = true;
              vm.formData.euin = {};
              vm.isCheckedTandC = false;
            }
            //vm.formData.brokerName = resp.data.distributorName;
          } else {
            vm.distributorList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.distributorList=null;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      SchemeService.get({
        /*controller1: 'transaction',*/
        controller1: 'getDistributor',
        controller2: vm.formData.distributorName
      }).$promise.then(success, error);
    }

    // vm.distributorListChanged = function (data) {
    //   if (!data) {
    //     // vm.isArnSuccess = true;
    //     return;
    //   } else {
    //     vm.brokerCodeError = '';
    //     vm.formData.distributorARN = data.arnCode;
    //     vm.formData.distributorName = data.name + ' - ' + data.arnCode;
    //     vm.showArnLabel = false;
    //     if (vm.formData.distributorARN) {
    //       //vm.isInvalidForm = false;
    //       vm.isArnSuccess = false;
    //     }
    //     else {
    //       vm.isArnSuccess = true;
    //     }
    //     fetchEuinListThroughDistributor(vm.formData.distributorARN);
    //   }
    // };


    // function fetchEuinListThroughDistributor(arnCode) {
    //   if (!arnCode) {
    //     return;
    //   }
    //   vm.formData.brokerName = '';
    //   var success = function (resp) {
    //       LoaderService.hideLoader();
    //       if (resp.status && resp.data) {
    //         vm.euinMasterList = resp.data.euinList;
    //         vm.euinList = vm.euinMasterList;
    //         vm.euinData = vm.formData.euin;
    //         //vm.formData.brokerName = resp.data.distributorName;
    //       } else {
    //         vm.euinList = null;
    //         //MessageService.error(resp.message);
    //       }
    //     },
    //     error = function () {
    //       LoaderService.hideLoader();
    //       vm.euinList = null;
    //       //UtilService.errorHandler(err);
    //     };

    //   LoaderService.showLoader();
    //   TransactionService.get({ VERSION: HDFC_API.VERSION, controller: 'getEuin' }).$promise.then(success, error);

    // }
    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
          vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
          vm.formData.euinName = vm.euinNameSelected;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({ VERSION: HDFC_API.VERSION, controller: 'getEuin' }).$promise.then(success, error);
    }
    vm.brokerCodeError = '';
    function fetchEuinList() {
      if (vm.formData.isThroughDistributor) {
        if (!vm.formData.brokerCode) {
          return;
        }
      } else if (vm.formData.isThroughRia) {
        if (!vm.formData.riaBrokerCode) {
          return;
        }
      }
      vm.formData.brokerName = vm.formData.brokerName ? vm.formData.brokerName : '';
      vm.formData.riaBrokerName = vm.formData.riaBrokerName ? vm.formData.riaBrokerName : '';
      vm.subBrokerCodeError = '';
      vm.euinData = {};
      //vm.isArnSuccess = vm.formData.brokerCode ? false : true;
      vm.isArnSuccess = true;
      vm.distributorList = null;
      // vm.formData.euinInput = '';
      if (!vm.formData.isBackFromSummary && !vm.riaConsent) {
        vm.isCheckedTandC = vm.formData.isCheckedTandC;
        if (!$stateParams.isCompId && !$stateParams.trackId) {
          vm.formData.euin = vm.formData.euin ? vm.formData.euin : '';
        }
      }

      //vm.isInvalidForm = true;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinMasterList = resp.data.euinList;
          vm.euinList = vm.euinMasterList;
          vm.euinData = vm.formData.euin ? vm.formData.euin : {};
          vm.brokerCodeError = '';
          vm.riaCodeError = '';
          vm.isArnSuccess = false;
          if (vm.formData.isThroughDistributor) {
            vm.formData.brokerName = resp.data.distributorName;
          } else if (vm.formData.isThroughRia) {
            vm.formData.riaBrokerName = resp.data.distributorName;
          }
          //vm.isInvalidForm = false;
        } else {
          vm.euinList = null;
          if (vm.formData.isThroughDistributor) {
            vm.brokerCodeError = resp.message;
          } else if (vm.formData.isThroughRia) {
            vm.riaCodeError = resp.message;
            vm.isCheckedTandC = false;
            vm.formData.isCheckedTandC = false;
          }
          MessageService.error(resp.message);
        }
      },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {};
      if (vm.formData.isThroughDistributor) {
        path = {
          controller1: 'getEuin',
          controller2: 'ARN-' + vm.formData.brokerCode
        };
      } else if (vm.formData.isThroughRia) {
        path = {
          controller1: 'getEuin',
          controller2: vm.formData.riaBrokerCode,
          riaOpted: vm.formData.isThroughRia
        };
      }
      TransactionService.get(path).$promise.then(success, error);
    }

    vm.isSelectedEuin = true;

    vm.filterEuinList = function () {
      vm.formData.euin = {};
      vm.isSelectedEuin = false ;
      if(vm.euinData.euinNameCode){
        if(vm.euinData.euinNameCode.length>=3){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length<3 ? vm.euinMasterList : vm.euinList;
    };

    // get inschemes

    vm.schemeListModal = function () {

      var successSchemeList = function (result) {
        vm.inSchemeChanged(result);
      },
        errorSchemeList = function () {
          vm.formData.inSchemeCode = '';
          vm.formData.inSchemeName = '';
          vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList);
        };

        var payload = {
          option : (vm.formData.option == 'Option B')? 'B':'A',
          isBroker: vm.formData.isThroughDistributor ? true : false,
          corporateFlag: vm.selectedFolioData.corporateInvestor
       }
      ModalService.dreamSchemeListModal({
        transactionType: 'dreamSip',
        payload:payload
      }, successSchemeList, errorSchemeList);
    };


    vm.selectEuin = function(data) {
      if (!data) {
        return;
      }
      vm.euinData = {};
      vm.euinData.euinNameCode = data.euinNameCode;
      vm.isSelectedEuin = vm.euinData.euinNameCode ? true : false;
    }

    //change Option

    vm.changeOption = function (value) {
      vm.formData.inSchemeCode = '';
      vm.formData.inSchemeName = '';
      vm.formData.schemeType = '';
      if (vm.formData.targetSchemeCode) {
        vm.formData.targetSchemeCode = '';
        vm.formData.targetSchemeName = '';
        vm.formData.schemeType = '';
      }
      if(value != undefined){
        fetchInSchemes();
      }
      vm.formData.amount = null;
      $window.NumToWord('', 'divDisplayWords', vm);
      vm.formData.swapAmount = null;
      $window.NumToWord('', 'divDisplayWords1', vm);
      vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      // setStartDate();
    };

    vm.goToSipSummary = function () {
      vm.isCheckedTandC = false;
      if (vm.formData.inSchemeName && vm.formData.inSchemeName.includes('Children')) {
        var success = function () {
          beforeSummary();
        },
          error = function () {

          };
        var message = AppConstants.TRANSACTIONS.CGF_SCHEME_MSG;
        ModalService.childrenFundMessage({ message: message }, success, error);
      } else {
        beforeSummary();
      }
    };
    function checkEndPopup(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showpopup = true;
      } else {
        vm.showpopup = false;
      }
    }
    function beforeSummary() {
      if (vm.popup !== undefined) {
        vm.showCutOffModal({ cutoffData: vm.popup, showCutOff: vm.showpopup });
      }
      else {
        vm.moveToSummary();
      }
    }

    vm.showCutOffModal = function (message) {
      var success = function () {
        vm.moveToSummary();
      }, error = function () {

      };
      ModalService.cutOffModal({ message: message }, success, error);
    };

    vm.moveToSummary = function () {
      vm.transactionType;
      vm.setTandCVariable();
      userActivityTracking(function (trackResp) {
        var params = { transactionType: vm.transactionType };
        if ((trackResp && angular.isDefined(trackResp.transactionId)) || $stateParams.trackId) {
          params.trackId = trackResp.transactionId || $stateParams.trackId;
          vm.formData.trackId = params.trackId;
        }
        vm.isRequired = true;
        vm.isSaving = false;
        if (vm.formData.euin && !vm.formData.euin.euinName && !vm.formData.euin.euinCode && vm.formData.euinInput) {
          vm.formData.euin.euinName = (vm.formData.euinInput.split('-')[0]).trim();
          vm.formData.euin.euinCode = (vm.formData.euinInput.split('-')[1]).trim();
        }
        $state.$previous = $state.current;
        if (vm.tForm.$valid) {
          var payloadData = getFinalPayloadData();
          if (!payloadData) {
            return;
          }
          var selectedFolioObj = vm.folioList.filter(function (row) {
            return row.folioNumber == vm.formData.folioNumber
          })[0];
          payloadData.email = selectedFolioObj.email ? selectedFolioObj.email : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          payloadData.mobileNumber = selectedFolioObj.mobileNumber ? selectedFolioObj.mobileNumber : vm.SUMMARY_CONST.CHECK_UPDATE.value;
          TransactionModel.setPayloadRawData(payloadData);
          /*Netcore Event Start*/
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            NetcoreEvntService.Proceed_To_Transact_SIP_IP(payloadData);
          }
          /*Netcore Event End*/
          vm.summaryData = payloadData;
          localStorage.setItem('summaryData',JSON.stringify(vm.summaryData));
          vm.transactionType = 'DREAM_SIP';
          vm.formData.isSummaryViewEnabled = true;
        }

      });
    };

    function userActivityTracking(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && (resp.data || resp)) {
          resp = resp.data || resp;
          LoaderService.hideLoader();
          cb(resp);
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        cb(err);
      };

      var userTrackerPayload = setUserTrackerPayload();
      InvestorsService.post({
        child1: 'userBehavior',
        child2: 'addupdate'
      }, userTrackerPayload).$promise.then(success, error);
    }

    function setUserTrackerPayload() {
      var _payload = {
        "trxnRefNo": $stateParams.trackId ? $stateParams.trackId : "", //required in case of update
        "trxnType": vm.formData.investmentType, //SIP, PURCHASE
        "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
        "step": "FIRST", // FIRST,SECOND,THIRD,FOURTH
        "schemeCd": vm.formData.purchaseInSchemeCode || vm.formData.inSchemeCode, // required
        "folioNo": vm.formData.folioNumber, // required
        "formData": getSipPurchasePayloadToSave(), // required
        "amount": vm.formData.purchaseAmount || vm.formData.amount, //required
        "trxnStatus": "OPEN",  // OPEN,PROCESSED
        "promoterCode": "" // capture from the transaction link
      };
      return _payload;
    }

    function getFinalPayloadData() {
      var payload = null;
      payload = vm.isSaving ? getSipPurchasePayloadToSave() : getSipPurchasePayloadToSubmit();
      return angular.copy(payload);
    };
    function getSipPurchasePayloadToSubmit() {
      if (!vm.validations.investmentOption && (vm.formData.investmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.formData.optionalInvestmentType == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        MessageService.error('Invalid Investment option for sip is selected.');
        return false;
      }
      vm.formData.dividendOption = vm.formData.sipDividendOption;
      vm.formData.topupDetails.capMonthYear = $window.moment(vm.formData.topupDetails.capMonthYear).format("DD-MMM-YYYY");

      var selectedFolioObj = vm.folioList.filter(function (row) {              // for investor's name initialisation
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      vm.folioInvestorName = selectedFolioObj ? selectedFolioObj.investorName : '';
      vm.formData.investmentOption = vm.validations.investmentOption;
      vm.formData.checkedNfoAutoSwitch = vm.formData.isAutoSwitch;
      vm.formData.autoSwitchScheme = vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null;
      vm.formData.autoSwitchSchemeDividendOption = vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null;
      vm.formData.switchSchemeInvestmentOption = vm.formData.isAutoSwitch ? vm.switchSchemeInvestmentOption : null;
      vm.formData.folioInvestorName = vm.folioInvestorName;
      vm.formData.euinOpted = (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N';
      return angular.copy(vm.formData);
    }

    function getSipPurchasePayloadToSave() {

      if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
        vm.formData.bankInfo.bankName = vm.formData.bankName;
      }
      if (vm.formData.isThroughDistributor === false && vm.formData.isThroughRia === false) {
        vm.formData.euin = {};
        vm.formData.brokerCode = '';
        vm.formData.brokerName = '';
        vm.euinList = null;
        vm.formData.distributorARN = '';
        vm.formData.distributorName = '';
        vm.formData.subBrokerARN = '';
        vm.formData.subBrokerCode = '';
        vm.isCheckedTandC = false;
        vm.isArnSuccess = true;
      }
      var sipPayload = {
        authMode: vm.formData.authMode ? vm.formData.authMode.value : null,
        installmentAmount: vm.formData.amount,
        investmentOption: fetchInvestmentOption(vm.validations.investmentOption),
        dividendOption: vm.validations.investmentOption === vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.GROWTH ? vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH : vm.formData.sipDividendOption,
        formType: "DREAMSIP",
        frequency: vm.formData.frequency,
        folioNumber: vm.formData.folioNumber,
        schemeCode: vm.formData.inSchemeCode,
        schemeType: vm.formData.schemeType,
        toDate: vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
        sipDate: vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
        sipDay: vm.formData.day,
        euinOpted: (vm.formData.euin && vm.formData.euin.euinName) ? 'Y' : 'N',
        euinName: vm.formData.euin ? vm.formData.euin.euinName : '',
        euinCode: vm.formData.euin ? vm.formData.euin.euinCode : '',
        id: vm.formData.sTransactionId,
        compositeTransactionId: $stateParams.ctId ? $stateParams.ctId : '',
        isTillPerpetuityvm: vm.formData.isTillPerpetuity ? vm.formData.isTillPerpetuity : false,
        bankDetailsForECS: {
          accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : '',
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          ifscCode: vm.formData.ifscCode,
          branchName: vm.formData.bankBranch,
          bankCity: vm.formData.bankCity,
          paymentOption: vm.formData.sipPaymentOption,
          otmId: vm.formData.otmId,
          netBankingUrl: vm.formData.netBankingUrl
        },
        option: vm.formData.option == 'Option A' ? 'A':'B',
        swapAmount:vm.formData.swapAmount,
        sipPeriod:vm.formData.sipPeriod,
        targetSchemeCode:vm.formData.targetSchemeCode,
        targetSchemeName:vm.formData.targetSchemeName,
        subBrokerARN: vm.formData.subBrokerARN ? 'ARN-' + vm.formData.subBrokerARN : '',
        subBrokerCode: vm.formData.subBrokerCode,
        sipTopupEnabled: vm.sipTopupSelected,
        topupDetails: {
          amount: vm.formData.topupDetails ? vm.formData.topupDetails.amount : '',
          percentage: vm.formData.topupDetails ? vm.formData.topupDetails.percentage : '',
          frequency: vm.formData.topupDetails ? vm.formData.topupDetails.frequency : '',
          capAmount: vm.formData.topupDetails ? vm.formData.topupDetails.capAmount : '',
          capMonthYear: vm.formData.topupDetails ? (vm.formData.topupDetails.capMonthYear ? $window.moment(vm.formData.topupDetails.capMonthYear).format("DD-MMM-YYYY") : '') : ''
        },
        mandateStartDate : vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
        mandateEndDate : vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null,
        mandateAmount : vm.formData.emandateAmount ? vm.formData.emandateAmount : null
      }

      if (!sipPayload.investmentOption) {
        sipPayload.investmentOption = vm.formData.sipPaymentOption;
      }
      if (!sipPayload.dividendOption) {
        sipPayload.dividendOption = vm.formData.sipDividendOption;
      }

      var payload = {};

      if (vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
        sipPayload = handleBrokerCode(sipPayload);
        payload = angular.copy(sipPayload);
      }
      payload.trackId = vm.formData.trackId;

      return payload;
    };
    /*
     * Function responsible to manage the broker code for purchase and sip payload
     * */
    function handleBrokerCode(payload) {
      if (vm.formData.isThroughDistributor) {
        payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
        payload['riaConsent'] = false;
      } else if (vm.formData.isThroughRia) {
        payload['brokerCode'] = vm.formData.riaBrokerCode;
        payload['riaConsent'] = vm.isCheckedTandC ? true : false;
      } else if (vm.formData.isDirect) {
        payload['brokerCode'] = '';
        payload['riaConsent'] = false;
      }
      return payload;
    }
    function fetchInvestmentOption(investmentOption) {
      var investmentOptionKey = "";
      Object.keys(vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS).forEach(function (key) {
        if (vm.TRANSACTIONS_CONST.INVESTMENT_OPTIONS[key] == investmentOption) {
          investmentOptionKey = key;
        }
      });
      return investmentOptionKey;
    };
    vm.setTandCVariable = function () {
      vm.formData.isCheckedTandC = vm.isCheckedTandC;
    };


    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.showRetirementSchemeError = UtilService.checkForRetirementScheme(schemeData, vm.selectedFolioData);
        if (vm.showRetirementSchemeError) {
          MessageService.error(vm.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
          vm.formData.inSchemeName = null;
          vm.filterInSchemeList();
          return;
        }
        vm.formData.inSchemeCode = schemeData.schemeCode;
        vm.formData.inSchemeName = schemeData.scheme;
        vm.formData.inSchemeType = schemeData.schemeType;
        vm.liquidSchemeFlag = false;
        if (vm.ECbankList) {
          vm.formData.sipPaymentOption = 'EC';
        }
        vm.validPaymentOption = true;
        if(vm.formData.schemeType == 'LIQUID'){
          vm.liquidSchemeFlag = true;
        }else{
          vm.liquidSchemeFlag = false;
        }
        fetchBankList(function () {
          checkEmandateBank();
        });
        if(vm.formData.option == 'Option A') {
          fetchInSchemeValidations();
        }
        if(vm.formData.option == 'Option B') {
          vm.formData.targetSchemecode = '';
          vm.formData.targetSchemeName = '';
          vm.filterTargetSchemeList(vm.formData.inSchemeCode);
        }
        retrieveUPIBankList();
      }
      validateSchemeRequrement();
      getDateValidation();
    };

    vm.filterInSchemeList = function () {
      vm.formData.inSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.formData.inSchemeName);
      resetNumInWords();
    };
    vm.filterTargetSchemeList = function () {
      vm.formData.targetSchemecode = '';
      vm.targetSchemeList = UtilService.getFilteredList(vm.masterTargetInSchemeList, 'scheme', vm.formData.targetSchemeName);
    };
    function resetNumInWords() {
      var inWordsDiv = $window.document.getElementById('divDisplayWords');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }
    vm.targetSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.formData.targetSchemeCode = schemeData.schemeCode;
        vm.formData.targetSchemeName = schemeData.scheme;
        vm.formData.targetSchemeType = schemeData.schemeType;
        if(vm.formData.option == 'Option B') {
           fetchInSchemeValidations();
        }
      }
      validateSchemeRequrement();
    };

    function fetchInSchemeValidations(cb) {
      vm.inSchemeValidations = null;
      cb = cb || function () {
      };
      if (!vm.formData.inSchemeCode) {
        return;
      }
     var success = function (resp) {
        if (resp.status && resp.data) {
          vm.inSchemeValidations = resp.data;
          vm.validations = vm.inSchemeValidations;
          vm.upiErrorMessage = vm.inSchemeValidations.upiMaxAmountErrMessage;
          vm.upiAmountLimit = vm.inSchemeValidations.upiMaxAmountLimit;
          _setSipDividendOptionsVali(vm.inSchemeValidations);
          cb(null);
        } else {
          cb('error');
          MessageService.error(resp.message);
        }
        checkValidations();
      },
        error = function (err) {
          cb('error');
          LoaderService.hideLoader();
          cb(null);
          UtilService.errorHandler(err);
        };


      var data = {
        schemeSource: vm.formData.inSchemeCode,
        schemeDestination: vm.formData.targetSchemeCode ? vm.formData.targetSchemeCode : vm.formData.inSchemeCode
      }
      InvestorServiceDynamicData.post({
        child1: 'dreamSip',
        child2: 'schemeValidation',
        child3: 'dreamSip'
      }, data).$promise.then(success, error);
    }

    vm.changeSipPeriod = function () {
      if (vm.formData.startDate) {
        updateEndDates();
      }
      if (vm.formData.amount) {
        checkSipValidations();
      }

      handleMandatePaymentOption();

    };
    vm.changeStartDate = function (date) {
      vm.formData.startDate = date ? date : null;
      if(vm.formData.startDate){
        vm.formData.startDate.format('DD-MMM-YYYY');
      }
      vm.formData.day = vm.formData.startDate ? +(vm.formData.startDate.format('DD')): null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = false;
      vm.isReseting = true;
      $timeout(function () {
        vm.isReseting = false;
      });
      checkOTMAmountAndDate();
      updateEndDates();
    };
    function setbacksummaryStartDate() {
      var currentDay = $window.moment();
      vm.viewMode = 'days';
      var enabledStartDates = [];
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var dateValid;
       if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        dateValid = vm.inSchemeValidations ? vm.inSchemeValidations.sipTDay : 17;
      } else {
        dateValid = 11;
      }

      for (var i = dateValid; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
    }
    function setStartDate() {
      vm.formData.startDate = null;
      var currentDay = $window.moment();
      vm.viewMode = 'days';
      var enabledStartDates = [];
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var dateValid;
       if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
        dateValid = vm.inSchemeValidations ? vm.inSchemeValidations.sipTDay : 19;
      } else {
        dateValid = 11;
      }

      for (var i = dateValid; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.formData.endDate = null;
    }


    function updateEndDates() {
      if(vm.formData.startDate){
        var maxYear = vm.formData.sipPeriod > vm.emandateMaxYear ? vm.emandateMaxYear : vm.formData.sipPeriod;
        vm.formData.endDate = $window.moment(vm.formData.startDate).add(maxYear, 'years')
        vm.formData.endDate = $window.moment(vm.formData.endDate).add(-1, 'months');
      }else{
        vm.formData.endDate = null;
      }
     if(vm.formData.endDate){
      if (vm.formData.sipPaymentOption != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) {
        vm.formData.showTopUpBlock = true;
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          capStartDate = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate).isBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
        checkOTMAmountAndDate();
      }
      if(vm.formData.sipPaymentOption == 'OTM'){
        vm.otmExpDate = vm.formData.bankInfo && moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY')
        vm.endDateValidation = vm.formData.endDate && (moment(vm.formData.endDate,"DD-MMM-YYYY")) > (moment(vm.otmExpDate,"DD-MMM-YYYY"));
        if(vm.endDateValidation){
          vm.validPaymentOption = false;
        }
      } else if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM && vm.formData.endDateEmandate) {
        vm.sipDateLessEmandate =  $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
        if (vm.sipDateLessEmandate) {
          var endDateField =  angular.element('#endDateManddate');
          endDateField.focus();
        }
        // if (vm.sipDateLessEmandate) {
        //   var setEndDateLess = false;
        //   var tempEndDate = angular.copy($window.moment(vm.formData.endDate));
        //   while (!setEndDateLess) {
        //     tempEndDate = angular.copy($window.moment(tempEndDate).subtract(1, 'months'));
        //     if ($window.moment(tempEndDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY'))) {
        //       setEndDateLess = true;
        //       vm.formData.endDate = angular.copy(tempEndDate);
        //       vm.sipDateLessEmandate = false;
        //     }
        //   }
        // }
      }
     }
    }



    // set topup frequency
    function getTopupFrequencyList() {
      vm.topupFrequencyList = [
        { key: 'Y', value: 'Yearly', monthfreq: 12 },
        { key: 'H', value: 'Half Yearly', monthfreq: 6 }
      ];
      vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;
    }

    function resetTopupDetails() {
      vm.formData.topupDetails = {};
      vm.formData.sipTopupEnabled = false;
    }

    function changeSipTopupSelected() {
      vm.validTopUpData = true;
      vm.isminCapAmount = false;
      if(!vm.formData.sipTopupSelected){
        vm.validTopUpData = false;
      }
      vm.formData.topupDetails.amount = null;
      vm.formData.topupDetails.percentage = null;
      vm.formData.topupDetails.capAmount = null;
      vm.formData.topupDetails.capMonthYear = null;
      if (vm.formData.sipPaymentOption === 'OTM' && ((vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency) !== 'AWP')) {
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.OTM_VALIDATION_ERROR);
      }
      else if (vm.formData.bankInfo && vm.isOTMAmount) {
        vm.formData.sipTopupSelected = false;
        vm.formData.sipTopupEnabled = false;
        MessageService.error(vm.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR);
      }
      getTopupFrequencyList();
    }

    vm.changeTopUpFreq = function () {
      var duration = 6;
      switch (vm.formData.topupDetails.frequency) {
        case 'H': duration = 6; break;
        case 'Y': duration = 12; break;
      }
      if (duration === 12) {
        var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
      }
      else {
        capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
      }

      vm.capDates = [];
      var capLastDate = capStartDate;
      while ($window.moment(capLastDate).isSameOrBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
        if (vm.capDates.length === 0) {
          vm.capDates.push(capStartDate);
        }
        capStartDate = $window.moment(capStartDate).add(duration, 'months').format("MMM-YYYY");
        if ($window.moment(capStartDate).isSameOrBefore($window.moment(vm.formData.endDate.format("MMM-YYYY")))) {
          vm.capDates.push(capStartDate);
        }
        else {
          break;
        }
        capLastDate = vm.capDates[vm.capDates.length - 1];
      }
    };


    // payment options

    function changedPaymentOption() {

      sipSettingValidation();

      vm.formData.bankInfo = null;
      vm.formData.otmId = '';
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.formData.isTillPerpetuity = null;
      vm.formData.authMode = null;
      vm.authenticationMode = null;
      vm.enabledBillerStartDatesList = null;
      vm.disableEndDateSelection = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.EmandateBank = null;
      if (vm.emandateUpiData) {
        vm.formData.emandateAmount = Math.floor(vm.emandateUpiData.eOTM.defaultMandateAmount);
      }
      fetchBankList();
       checkOTMAmountAndDate();
        vm.formData.sipTopupSelected = false;
        vm.formData.showTopUpBlock = true;
        resetTopupDetails();
        getTopupFrequencyList();
      if (vm.formData.sipPaymentOption === "E-mandate" && vm.enabledEmandateEndDatesList) {
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
        changeEndDateEmandate(vm.formData.endDateEmandate);
      }
      handleUpiError();
    }

    function checkOTM(cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.folioBankDetailsList.length == 0) {
            vm.isOTMEnabled = false;
            vm.hideOtmRadio = true;
            vm.paymentOptions =  [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            var index = vm.paymentOptions.indexOf('OTM');
            if (index > -1) {
              vm.paymentOptions.splice(index, 1);
            }
            vm.formData.sipPaymentOption = vm.paymentOptions[0];

          }
          else {
            vm.isOTMEnabled = true;
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
            vm.formData.sipPaymentOption = vm.paymentOptions ? vm.paymentOptions[0] : '';
            vm.OTMbankList = resp.data.folioBankDetailsList;
            vm.COTMBANKLIST = resp.data.nonCOTMBankList;
          }
        }
        cb(true);
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          cb(false);
        };
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'otm',
        child2: 'banks'
      }, {folioNumber: vm.formData.folioNumber,pan: vm.investorInfo.panNumber}).$promise.then(success, error);
    }

    //fetch bank list

    function fetchBankList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length == 0) {
            vm.formData.sipPaymentOption = vm.paymentOptions[0];
            vm.hideOtmRadio = true;
            vm.formData.showTopUpBlock = true;
            //fetchBankList();
          }
          else if (vm.formData.sipPaymentOption == 'OTM' && resp.data.bankList.length > 0) {
            vm.hideOtmRadio = false;
          }
          else if (vm.formData.sipPaymentOption == 'EC' || vm.formData.sipPaymentOption == 'UPI') {
            vm.ECbankList = resp.data.bankList;
            if (vm.hideOtmRadio) {
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC ]
              vm.formData.sipPaymentOption = vm.paymentOptions[0];

            }
            else {
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM,vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC ];
              vm.hideOtmRadio = false;

            }
          }

          vm.bankList = resp.data.bankList;
        } else {
          vm.bankList = null;
          MessageService.error(resp.message);
        }
        cb(true);
      },
        error = function (err) {
          LoaderService.hideLoader();
          vm.bankList = null;
          UtilService.errorHandler(err);
          cb(false);
        };
      LoaderService.showLoader();
      var payload ={
        folioNumber:vm.formData.folioNumber,
        trxnType: 'PURCHASE',
        liquidSchemeFlag: vm.liquidSchemeFlag
      }
      InvestorCommonServiceVersion2.post({child1: 'investor',child2: 'upi',child3: 'bank',child4: 'list'}, payload).$promise.then(success, error);
    }


    function setDynamicData() {

      vm.notesReview = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_Registration;
      vm.popup = vm.DynamicDataSipPurchaseReview.popupDTO.popupDTOMap.Popup_SIP_Review;
      vm.notesOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_OTM;
      vm.notesEOtm = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_eOTM;
      vm.riaMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Review_Through_RIA;
      vm.distributorMessage = vm.DynamicDataSipPurchaseReview.termAndConditionDTO.termAndConditionDTOMap.TNC_SIP_Through_Distributor;
      vm.key = "TNC_SIP_Review_Registration"
      vm.keyOtm = "TNC_SIP_Review_Registration_eOTM"

      if (!vm.distributorMessage)
        vm.formData.isCheckedTandC = false;

      if (!vm.riaMessage)
        vm.formData.isCheckedTandC = false;


    }

    vm.paymentNavUrl = function () {
      // $event.preventDefault();
      $window.open(vm.paymentNavURL);
    };
    //note show hide

    function checkEndNote(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showNote = true;
      } else {
        vm.showNote = false;
      }
    }

    function checkEndNoteOtm(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showOtmNote = true;
      } else {
        vm.showOtmNote = false;
      }
    }

    function checkEndNoteEOtm(endDate, startDate) {
      if (vm.today.isSameOrBefore($window.moment(endDate, "DD-MMM-YYYY HH:mm A")) && vm.today.isSameOrAfter($window.moment(startDate, "DD-MMM-YYYY HH:mm A"))) {
        vm.showEotmNote = true;
      } else {
        vm.showEotmNote = false;
      }
    }

    function checkSipValidations() {
      vm.formData.startDate = null;
      vm.formData.endDate = null;
     // vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
      // vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
      // vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      // vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
      vm.isMultiples = vm.validations.amountMultiples && vm.formData.installmentAmount && (vm.formData.installmentAmount % vm.validations.amountMultiples === 0) || false;
      // vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      // vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      // vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && ( vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
      // if (!vm.isInvalidForm && vm.formData.topupDetails.amount) {
      //   vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
      // }
      // (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
      // vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
      // vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
      // if (!vm.formData.isBackFromSummary) {
      //   angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) && (vm.formData.topupDetails.capAmount = '');
      // }
      if(vm.formData.installmentAmount){
        if(vm.formData.installmentAmount > 2000000){
          vm.amountExceeded = true;
          vm.inValidInstallmentAmount = true;
        }else{
          vm.amountExceeded = false;
          vm.inValidInstallmentAmount = false;
        }
      }else{
        vm.amountExceeded = false;
        vm.inValidInstallmentAmount = true;
      }

      if (!vm.isMin) {
        var swapAmountMultiple = vm.sipPeriodArray.filter(function (data) {
          return data.value == vm.formData.sipPeriod
        })[0];
        vm.formData.swapAmount = vm.formData.installmentAmount * swapAmountMultiple.multiple;
        $window.NumToWord(vm.formData.swapAmount, 'divDisplayWords1', vm);
        vm.maxSwapAmount = vm.formData.installmentAmount * swapAmountMultiple.multiple;
        if(vm.formData.swapAmount){
          $window.NumToWord(vm.formData.swapAmount, 'divDisplayWords1', vm);
        }else{
          $window.NumToWord('', 'divDisplayWords1', vm);
        }
        checkSwapValidations();
      } else {
        vm.formData.swapAmount = '';
        $window.NumToWord('', 'divDisplayWords1', vm);
      }
      validateSchemeRequrement();
      if(vm.formData.sipPaymentOption == 'EC' && vm.formData.sipPaymentMode == 'COTM'){
        validaBankProcced();
      }

      if(vm.formData.installmentAmount){
        if(vm.formData.installmentAmount < vm.validations.minAmount){
          vm.isMinSipAmount = true;
        }else{
          vm.isMinSipAmount = false;
        }
      }


      if (vm.formData.sipPaymentOption == 'HEM') {

        if (vm.formData.installmentAmount && vm.formData.emandateAmount) {
          checkAmountValidationEmandate();
        }
      }

      handleMandatePaymentOption();
    }
    function checkSwapValidations() {
      var swapAmountMultiple = vm.sipPeriodArray.filter(function (data) {
        return data.value == vm.formData.sipPeriod;
      })[0];
      vm.maxSwapAmount = vm.formData.installmentAmount * swapAmountMultiple.multiple;

      vm.isSwapMax = !!(vm.maxSwapAmount && vm.maxSwapAmount < vm.formData.swapAmount);
      vm.isSwapMin = !!(vm.validations.swpValidationDTO && vm.validations.swpValidationDTO.monMinAmt > vm.formData.swapAmount);
      vm.isSwapMultiples = vm.validations.swpValidationDTO && vm.validations.swpValidationDTO.monAmtMultiples && vm.formData.swapAmount && (vm.formData.swapAmount % vm.validations.swpValidationDTO.monAmtMultiples === 0) || false;
      validateSchemeRequrement();
    }

    function _setSipDividendOptionsVali(inSchemeValidations) {

      vm.inSchemeValidations = inSchemeValidations;
      vm.isSchemeTypeELSS = (vm.inSchemeValidations && vm.inSchemeValidations.schemeType == "ELSS") ? true : false;
      vm.devidendOptions = [];
      if(vm.inSchemeValidations && vm.inSchemeValidations.swpValidationDTO){
        if(vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable){
          vm.validations.investmentOption = 'DIVIDEND';
          vm.devidendOptions = 'N';
        }
        if(vm.inSchemeValidations.swpValidationDTO.dividendReinvestmentApplicable){
          vm.validations.investmentOption = 'DIVIDEND';
          vm.devidendOptions = 'Y';
        }
        if(vm.devidendOptions.length > 0){
          vm.formData.sipDividendOption = vm.devidendOptions[0];
        }
        if(!vm.inSchemeValidations.swpValidationDTO.dividendReinvestmentApplicable && !vm.inSchemeValidations.swpValidationDTO.dividendPayoutApplicable){
          vm.validations.investmentOption = 'GROWTH';
          vm.devidendOptions = 'Z';
        }
      }
    }

    function checkValidations() {
      vm.isInvalidForm = false;

      if (!vm.inSchemeValidations && !vm.outSchemeValidations) {
        vm.validations = {};
      }


      if (vm.inSchemeValidations) {
        vm.validations.minInstallDivisionFlag = vm.inSchemeValidations.minInstallDivisionFlag;
        vm.validations.swpTaxCode = vm.inSchemeValidations.swpTaxCode;
        vm.validations.endingType = vm.inSchemeValidations.endingType;
        vm.validations.topupAmtMultples = vm.inSchemeValidations.topupAmtMultples;
        vm.validations.topupPercentageMultples = vm.inSchemeValidations.topupPercentageMultples;
        vm.validations.topupMinAmt = vm.inSchemeValidations.topupMinAmt;
        vm.validations.topupMinPercentage = vm.inSchemeValidations.topupMinPercentage;
        vm.validations.amountMultiples = vm.inSchemeValidations.monAmtMultiples;

        vm.validations.minInstallments = vm.inSchemeValidations.monMinInstallmentNumber;
        vm.validations.minAmount = vm.inSchemeValidations.additionalValidation.OM[0].min_amount_lower;
        // vm.validations.maxAmount = vm.inSchemeValidations;
        vm.validations.swpValidationDTO = vm.inSchemeValidations.swpValidationDTO;
        if (!vm.backFromPayment && !$stateParams.transactionId) {
          if (vm.validations.minAmount > vm.inSchemeValidations.sipDefaultAmount) {
            vm.formData.amount = vm.validations.minAmount;
          } else {
            vm.formData.amount = vm.inSchemeValidations.sipDefaultAmount;
          }
          vm.formData.amount = 5000;
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm.formData);
        }
        checkSipValidations();
      }

    }

    function checkOTMAmountAndDate() {

      vm.isOTMAmount = false;
      vm.isOTMDate = false;
      vm.isOTMStartDate = false;
      vm.isOTMEndDate = false;
      // Check Ammout
      if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
        vm.isOTMAmount = true;
      } else {
        vm.isOTMAmount = false;
      }

      //Compare Start Dates
      if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
        vm.isOTMDate = true;
      }
      else {
        vm.isOTMDate = false;
      }
      //Compare End Dates
      if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
        if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(vm.formData.startDate))) {
          if (vm.formData.startDate == null) {
            vm.isOTMStartDate = false;
          }
          else {
            vm.isOTMStartDate = true;
          }
        }
        else {
          vm.isOTMStartDate = false;
        }
      }

      if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(vm.formData.endDate)) {
        vm.isOTMEndDate = true;
      }
      else {
        vm.isOTMEndDate = false;
      }
      //Check for amount or date
      if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
        vm.isInvalidForm = true;
      } else {
        vm.isInvalidForm = false;
      }
    }

    vm.changeBank = function () {
      if(vm.formData.sipPaymentOption == 'OTM'){
        vm.formData.bankInfo = vm.formData.otmBank;
        vm.validPaymentOption = true;
      }
      if(vm.formData.sipPaymentOption == 'HEM'){
        vm.formData.bankInfo = JSON.parse(vm.formData.eMandateBank);
        vm.formData.authModeSelect = vm.formData.bankInfo.authenticationModes[0];
        if(vm.formData.authModeSelect){
          vm.validPaymentOption = true;
        }else{
          vm.validPaymentOption = false;
        }
      }
      if(vm.formData.sipPaymentOption == 'EC' ){
        if(vm.formData.sipPaymentMode == 'COTM'){
          if(typeof(vm.formData.cOtmBankInfo) == 'string'){
            vm.formData.bankInfo = JSON.parse(vm.formData.cOtmBankInfo);
          }
        }
        if(vm.formData.sipPaymentMode == 'NETBANKING'){
          vm.formData.bankInfo = {};
        }
        vm.validPaymentOption = true;
      }

      if(vm.formData.sipPaymentOption == 'UPI'){
        vm.formData.bankInfo = vm.formData.upiBankInfo;
        vm.validPaymentOption = true;
      }
      if(typeof(vm.formData.bankInfo) == 'string'){
        vm.formData.bankInfo = JSON.parse(vm.formData.bankInfo);
      }
      if (!vm.formData.bankInfo) {
        return;
      }
      validaBankProcced();
      vm.formData.sipTopupSelected = !!vm.formData.sipTopupSelected;
      vm.formData.sipTopupEnabled = !!vm.formData.sipTopupEnabled;
      if(!vm.formData.bankInfo)
        vm.authenticationMode=null;
      switch (vm.formData.sipPaymentOption) {
        case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
          vm.formData.otmId = vm.formData.bankInfo ? vm.formData.bankInfo.otmId : '';
          vm.formData.bankName = vm.formData.bankInfo ? vm.formData.bankInfo.bankName : '';
          vm.formData.bankBranch = vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '';
          vm.formData.bankAcNo = vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : '';
          vm.formData.ifscCode = vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : '';
          vm.formData.payoutId = vm.formData.bankInfo ? vm.formData.bankInfo.payoutId : '';
          (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))&&(vm.formData.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
          if(angular.isDefined(vm.formData.bankInfo) && (vm.formData.bankInfo.otmFrequency !== 'AWP') && (vm.formData.frequency === 'BZ')){
            vm.isInvalidForm = true;
            MessageService.error('This OTM Bank does not have OTM frequency As & when presented. To proceed with Daily SIP OTM frequency As & when presented is mandatory.');
          }
          delete vm.formData.netBankingUrl;
          checkOTMAmountAndDate();
          break;
        default :
          vm.formData.netBankingUrl = vm.formData.bankInfo.netBankingUrl;
          vm.formData.bankName = '';
          vm.formData.otmId = '';
          break;
      }
      resetBankDetails();   // need for sip transaction
    };

    vm.otherBankSelected = function () {
      //vm.formData.bankInfo = '';
    }
    // end
    function fetchDreamSipPeriod() {
      var success = function (resp) {
        if (resp.status && resp.data) {
           vm.sipPeriodArray= resp.data.sipPeriod;
           vm.formData.sipPeriod = "20";
           var swapAmountMultiple = vm.sipPeriodArray.filter(function (data) {
            return data.value == vm.formData.sipPeriod
          })[0];
      vm.formData.swapAmount = vm.formData.installmentAmount * swapAmountMultiple.multiple;
      $window.NumToWord(vm.formData.swapAmount, 'divDisplayWords1', vm);
      $window.NumToWord(vm.formData.installmentAmount, 'divDisplayWords392', vm);
        } else {
          vm.sipPeriodArray = null;
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorServiceDynamicData.get({
        child1: 'dreamSip',
        child2: 'sipPeriod'
      }).$promise.then(success, error);
    }

    vm.getInvestorInfo = function(cb) {
      cb = cb || function () {};
      var payload = {"investorUUID": vm.investorUUID};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          if(resp.data.email){
            vm.hasFolioEmailId = true;
          }else{
            vm.hasFolioEmailId = false;
          }
          cb(true);
        } else {
          vm.investorInfo = null;
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function (err) {
        //setDefaults();
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    vm.finishPurchase = function() {
      vm.isSubmitted = true;

       var success = function (resp) {
          if (resp.status && resp.data) {
            var successSipModal = function () {
              vm.isSubmitted = false;
              var _statusType = $stateParams.status;
              var identifier = AuthService.getToken();
              if (identifier && identifier.loginType == 'A') {
                $state.go("agent.home.distributor-home")
              } else {
                _statusType ? $state.go('main.transactions.all', {status: _statusType}) : $state.go('main.dashboard');
              }
            },
            errorSipModal = function () {
              vm.isSubmitted = false;
              var identifier = AuthService.getToken();
              if (identifier && identifier.loginType == 'A') {
                $state.go("agent.home.distributor-home")
              } else {
                $state.go('main.dashboard');
              }
            }
            ModalService.initiateSuccessModal({
              transactionType: vm.formData.investmentType,
              investorName: vm.investorInfo.name
            }, successSipModal, errorSipModal);
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };
      var payload = getDreamSipPayload();
      ModalService.transactionReviewModal({payload: payload, controller: 'dream_sip', additionalData: payload}, success, error);
    }

    function getDreamSipPayload(){
        vm.sipPayload = {};
        vm.sipPayload.formType = 'DREAMSIP',
        vm.sipPayload.investorName = vm.investorInfo.name;
        vm.sipPayload.emailID = vm.investorInfo.email;
        vm.sipPayload.phoneNo = vm.investorInfo.mobileNumber;
        vm.sipPayload.folioNumber = vm.formData.folioNumber;
        vm.schemeCode = vm.formData.schemeCode;
        if(vm.formData.option == 'Option A'){
          vm.sipPayload.inSipScheme = vm.formData.inSchemeName;
          vm.sipPayload.schemeCode = vm.formData.inSchemeCode;
          vm.sipPayload.inSchemeType = vm.formData.inSchemeType;
        }
        if(vm.formData.option == 'Option B'){
          vm.sipPayload.inSipScheme = vm.formData.inSchemeName;
          vm.sipPayload.targetSipScheme = vm.formData.targetSchemeName;
          vm.sipPayload.inSchemeType = vm.formData.inSchemeType;

          vm.sipPayload.schemeCode = vm.formData.inSchemeCode;
          vm.sipPayload.targetSchemeCode = vm.formData.targetSchemeCode;
          vm.sipPayload.targetSchemeType = vm.formData.targetSchemeType;
        }


        vm.sipPayload.investmentOption =  vm.validations.investmentOption;//"DIVIDENT","GROWTH"
        vm.sipPayload.devidendOptions = vm.devidendOptions;//"Z","Y","N"
        vm.sipPayload.installmentAmount = vm.formData.installmentAmount;
        vm.sipPayload.swapInstallmentAmount = vm.formData.swapAmount;


        vm.sipPayload.noOfInstallments = vm.formData.installment;
        vm.sipPayload.sipTenure = vm.formData.sipPeriod;
        vm.sipPayload.sipOptions= vm.formData.option;
        vm.sipPayload.paymentOption = vm.formData.sipPaymentOption;
        vm.sipPayload.sipFrequency = vm.formData.frequency;
        vm.sipPayload.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
        vm.sipPayload.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();
        vm.sipPayload.paymentMode = vm.formData.paymentMode;
        vm.sipPayload.sipTopupEnabled = vm.formData.sipTopupSelected;
        // if(vm.sipPayload.sipTopupEnabled){
          vm.sipPayload.topupDetails = vm.formData.topupDetails;
        // }else{
        //   vm.sipPayload.topupDetails = null;
        // }

        if (vm.sipPayload.sipTopupEnabled) {
          if(!vm.sipPayload.topupDetails.capAmount){
            vm.sipPayload.topupDetails.capMonthYear = moment(vm.formData.topupDetails.capMonthYear).format('DD-MMM-YYYY');
          }else{
            vm.sipPayload.topupDetails.capMonthYear = "";
          }
        } else {
          vm.sipPayload.topupDetails = null;
        }
        if (vm.formData.sipPaymentOption == 'EC') {
          vm.sipPayload.bankInfo = vm.formData.bankInfo ?  vm.formData.bankInfo : {};
        }
        if (vm.formData.sipPaymentOption == 'OTM') {
          vm.sipPayload.bankInfo = vm.formData.bankInfo;
        }
        if(vm.formData.sipPaymentOption == 'HEM') {
          vm.sipPayload.bankInfo = vm.formData.bankInfo;
          vm.sipPayload.eMandateBank = vm.formData.bankInfo.bankName.substr(0,vm.formData.bankInfo.bankName.lastIndexOf('-'));
          vm.sipPayload.accountNumber = vm.formData.bankInfo.accountNumber;
          vm.sipPayload.authenticationMode = vm.formData.authModeSelect;
          vm.sipPayload.mandateStartDate  = vm.formData.emandateDate ? $window.moment(vm.formData.emandateDate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          vm.sipPayload.mandateEndDate = vm.formData.endDateEmandate ? $window.moment(vm.formData.endDateEmandate,'DD-MMM-YYYY').format('DD-MMM-YYYY') : null;
          vm.sipPayload.mandateAmount = vm.formData.emandateAmount ? vm.formData.emandateAmount : null;
        }
      if(vm.formData.sipPaymentOption && vm.formData.sipPaymentOption == 'UPI') {
        vm.sipPayload.bankInfo = vm.formData.bankInfo;
      }
        vm.sipPayload.euinName = vm.formData.euinName;
        vm.sipPayload.euinCode = vm.formData.euinCode;
        vm.sipPayload.coperateFlag = vm.investorInfo.corporateFlag;
        vm.sipPayload.sipFirstInstallment = vm.formData.sipFirstInstallment;
        vm.sipPayload.fiPaymentMode = vm.formData.fiPaymentMode;
        vm.sipPayload.subBrokerArn = vm.formData.subBrokerARN;
        vm.sipPayload.subBrokerCode = vm.formData.subBrokerCode;
      return vm.sipPayload;
    }

    vm.openDreamDocumentFile = function (url) {
        $window.open(url);
    };
    vm.changePaymentOption = function(){

      sipSettingValidation();
      vm.validPaymentOption = false;
      vm.endDateValidation = false;
      vm.formData.startDate = null;
      vm.formData.endDate = "";
      vm.formData.bankInfo = "";
      vm.formData.otmBank = '';
      vm.formData.eMandateBank = '';
      vm.formData.upiBankInfo = '';
      vm.formData.sipTopupSelected = false;
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      vm.EmandateBank = null;
      if (vm.emandateUpiData) {
        vm.formData.emandateAmount = Math.floor(vm.emandateUpiData.eOTM.defaultMandateAmount);
      }

      if (vm.formData.sipPaymentOption == 'EC') {
        vm.validPaymentOption = true;
      }
      if (vm.formData.sipPaymentOption == 'OTM') {
        vm.bankList = vm.OTMbankList;
      }
      if(vm.formData.sipPaymentOption == 'HEM') {
        vm.bankList = vm.EMbankList;
        if(vm.formData.sipPaymentOption == 'HEM'){
          vm.contactValidattion();
          if (vm.enabledEmandateEndDatesList) {
            vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
            changeEndDateEmandate(vm.formData.endDateEmandate);
          }
        }
      }
      if (vm.formData.sipPaymentOption == 'UPI') {
        vm.bankList = vm.upiBankList;
        vm.validPaymentOption = true;
      }
      getDateValidation();
      handleUpiError();
    }

    vm.changeTopupAmount = function(dreamSipForm){
      vm.isTopupMinPerc = false;
      dreamSipForm.topupPercentage.$dirty = false;
      dreamSipForm.topupAmount.$dirty = true;
      vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
      vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
      if( !vm.isTopupMinAmt && vm.isTopUpMultiples){
        vm.validTopupAmount = true;
      }else{
        vm.validTopupAmount = false;
      }
      valiadtTopUpdata();
    }
    vm.changeTopupPercentage = function(dreamSipForm){
      vm.isTopupMinAmt = false;
      dreamSipForm.topupAmount.$dirty = false;
      dreamSipForm.topupPercentage.$dirty = true;
      vm.validations;
      vm.isTopupMinPerc = !(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage <= vm.formData.topupDetails.percentage);
      vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
      if(!vm.isTopupMinPerc && vm.isTopupPercMultiples){
        vm.validTopupPercentage = true;
      }else{
        vm.validTopupPercentage = false;
      }
      valiadtTopUpdata();
    }

    function capAmountChanged() {
      if(vm.formData.topupDetails.amount){
        vm.minCapAmount = vm.formData.installmentAmount + vm.formData.topupDetails.amount;
      }else if (vm.formData.topupDetails.percentage){
        vm.minCapAmount = vm.formData.installmentAmount + (vm.formData.topupDetails.percentage * vm.formData.amount/100)
      }

      if(vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount )){
        vm.isminCapAmount = true
      }else{
        vm.isminCapAmount = false
      }
      valiadtTopUpdata();
    }

    function valiadtTopUpdata(){
      if(vm.formData.sipTopupSelected){
        vm.validTopUpData = true;
        if((vm.validTopupAmount || vm.validTopupPercentage ) && ( (vm.formData.topupDetails.capAmount && !vm.isminCapAmount ) || vm.formData.topupDetails.capMonthYear) ){
          vm.validTopUpData = false;
        }
      }
    }

    function validateSchemeRequrement(){
      vm.validateSchemeRequrementData = true;
      if(vm.formData.option == 'Option A'){
        if(vm.formData.inSchemeCode){
          vm.validateSchemeRequrementData = false;
        }
      }
      if(vm.formData.option == 'Option B'){
        if(vm.formData.inSchemeCode && vm.formData.targetSchemeCode ){
          vm.validateSchemeRequrementData = false;
        }
      }
    }
    function euinChanged(){
      vm.euinList.forEach(function(i)
      {
        if(i.euinCode == vm.formData.euinCode){
          vm.formData.euinName = i.euinName;
        }
      });
    }

    function newFolioClickAction() {
      if (!vm.investorInfo && !vm.investorInfo.panNumber) {
        MessageService.error("Investor's sole applicant details not found");
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data && resp.data.verify) {
            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            model.folioCreationRequestCO.soleApplicantDetail.name = vm.investorInfo.name;
            model.folioCreationRequestCO.soleApplicantDetail.dob = vm.investorInfo.dob;
            model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.investorInfo.panNumber;
            model.folioCreationRequestCO.soleApplicantDetail.email = vm.email;
            model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.mobile;
            model.folioCreationRequestCO.showNomineeUpdate = vm.sebiNomineeRegulatory01650Active;
            model.folioCreationRequestCO.nomineeLimit = vm.nomineeLimit;
            //model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
            InvestorModel.setInvestorModel(model);
            InvestorModel.setFolioCreationFromProfileAndToDo(true);
            delete $window.sessionStorage.investorForm;
            $window.sessionStorage.investorForm = angular.toJson(model);
            InvestorModel.setTab({
              "tab1": false,
              "tab2": false,
              "tab3": false,
              "tab4": false,
              "tabJointHolderAddable": false,
              "tabGuardianDetailShow": false
            });
            // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
            $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
          } else {
            var message = resp.data && !resp.data.verify ? 'Either KYC verification is pending or name is missing.' : resp.message;
            MessageService.error(message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        //dob: moment(vm.investorInfo.dateOfBirth, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString(),
        pan: vm.investorInfo.panNumber
      };

      LoaderService.showLoader();
      fetchEmailMobile(vm.investorInfo.panNumber, vm.investorInfo.dob, function() {
        InvestorsService.post({
          controller: 'pan',
          child1: 'verify'
        }, payload).$promise.then(success, error);
      });
    }


    function validaBankProcced(){
      vm.bankProcced = true;
      if(vm.formData.sipPaymentOption == 'EC'){
        if(vm.formData.sipPaymentMode == 'NETBANKING'){
          vm.bankProcced = false;
        }
        if(vm.formData.sipPaymentMode == 'COTM'){
          if(vm.formData.bankInfo){
            if(vm.formData.bankInfo.maxAmount < vm.formData.installmentAmount){
              vm.bankProcced = true;
            }else{
              vm.bankProcced = false;
            }

          }
        }
      }
      if(vm.formData.sipPaymentOption == 'OTM'){
        if(vm.formData.bankInfo){
          vm.bankProcced = false;
        }
      }
      if(vm.formData.sipPaymentOption == 'HEM'){
        if(vm.formData.bankInfo){
          vm.bankProcced = false;
        }
      }
      if(vm.formData.sipPaymentOption == 'UPI'){
        if(vm.formData.bankInfo){
          vm.bankProcced = false;
        }
      }

    }
    vm.changeFirstInstallment = function(value){
      if(vm.formData.sipPaymentOption == "EC"){
        vm.formData.sipPaymentMode = 'NETBANKING';
      }
    }
    vm.changePaymentMode = function(){
      vm.formData.bankInfo = null;
      validaBankProcced();
      vm.formData.cOtmBankInfo = "";
      vm.formData.upiBankInfo = "";
    }
    vm.contactValidattion = function(){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.emailMobileValidation();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'folio',
        child1: 'contact-details'
      }, {
        folioNumber: vm.formData.folioNumber
      }).$promise.then(success, error);
    }
    vm.emailMobileValidation = function(){
      if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
        if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isMobileinValid = true;
          vm.emandateDisplay = false;
        }
      }
      else if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
        if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isEmailinValid = true;
          vm.emandateDisplay = false;
        }
      }
    }
    vm.getAuthModeSelect = function(){
      if(vm.formData.authModeSelect){
        vm.validPaymentOption = true;
      }else{
        vm.validPaymentOption = false;
      }
    }
    vm.DreamSipTenure = function () {
      var successSchemeList = function (result) {
      },
        errorSchemeList = function () {
        };
      ModalService.dreamSipTenureModal(vm.sipPeriodArray, successSchemeList, errorSchemeList);
    };
    vm.fetchDynamicData =  function(pageName) {
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.DynamicDataSipPurchaseReview = resp.data;
          vm.dynamicNoteSIPUPI = vm.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_DREAMSIP_UPI;
        } else {
          vm.DynamicDataSipPurchaseReview = {};
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };

      var payload = {
        "pageName": pageName
      };

      InvestorServiceDynamicData.post({
        "child1": "dynamicContent"
      }, payload).$promise.then(successHandler, errorHandler);
    };

    vm.filterTargetSchemeList = function(inSchemeCode){
      vm.targetSchemeList = [];
      vm.masterTargetInSchemeList.forEach(function(item){
        if(item.schemeCode != inSchemeCode){
          vm.targetSchemeList.push(item);
        }
      });
    }

    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.emandateMaxYear, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }


    function checkAmountValidationEmandate() {
      vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
      vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
      vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.formData.installmentAmount ? true : false;
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        vm.changeStartDate(vm.formData.startDate);
      }
    }

    function handleMandatePaymentOption() {
      if (vm.emandateUpiData && (vm.formData.sipPeriod > vm.emandateUpiData.eOTM.maxMandateDurationYears)) {
        vm.isEMandateEnabled = false;
        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) {
          if(vm.isUPIEnabled){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
          } else if (vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if (vm.ECbankList) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          }
        }

      } else {
        if (vm.EMbankList && vm.EMbankList.length > 0) {
          vm.isEMandateEnabled = true;
        }
      }

      if (vm.emandateUpiData && (vm.formData.sipPeriod > vm.emandateUpiData.upi.maxMandateDurationYears)) {
        vm.isUPIEnabled = false;
        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
          if (vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if (vm.ECbankList) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          }
        }

      } else {
        if (vm.upiBankList && vm.upiBankList.length > 0) {
          vm.isUPIEnabled = true;
        }
      }

      handleUpiError();
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
            vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
            vm.formData.euinName = vm.euinNameSelected;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      if(vm.formData.subBrokerARN){
        TransactionService.get({
          VERSION: HDFC_API.VERSION,
          controller: 'getEuin',
          child2: 'ARN-' + vm.formData.subBrokerARN,
          isSubBroker: true
        }).$promise.then(success, error);
      }
    }

    function retrieveUPIBankList(){
      UtilService.fetchBankListForSipUpi(vm.formData.investmentType, vm.formData.folioNumber, vm.formData.schemeType).then(function (resp) {
        vm.isUPIEnabled = true;
        vm.upiBankList = resp.bankList;

      }).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    function sipSettingValidation(){
      if ((vm.formData.sipPaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) && !vm.emandateUpiData) {
        UtilService.fetchMandateValidations().then(function (resp) {
          vm.emandateUpiData = resp;
          if (vm.formData.sipPaymentOption == 'HEM') {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption=='UPI') {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          } else {
            vm.emandateUpiData = null;
          }
          if(vm.emandateValidationData) {
            setEmandateUpiSetting();
          }
        }).catch(function(resp) {
          MessageService.error(resp)
        });
      } else {
        if (vm.emandateUpiData) {
          if (vm.formData.sipPaymentOption == 'HEM') {
            vm.emandateValidationData = vm.emandateUpiData.eOTM;
          } else if (vm.formData.sipPaymentOption == 'UPI') {
            vm.emandateValidationData = vm.emandateUpiData.upi;
          }
          if (vm.emandateValidationData) {
            setEmandateUpiSetting();
          }
        }
      }
    }

    function setEmandateUpiSetting(){
      vm.emandateMaxYear = vm.emandateValidationData.maxMandateDurationYears ? vm.emandateValidationData.maxMandateDurationYears : vm.defaultMandateYearDate;
      vm.eMandatenoOfDays = vm.emandateValidationData.noOfDays;
      vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
      vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
      vm.emandateMinStartDay = vm.emandateValidationData.minStartDays;
      vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
      $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      vm.mandateInfo = vm.emandateValidationData.mandateInfo;
      vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
      vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
      vm.formData.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
      updateEmandateEndDate();
      // checkUPIForSipWithFI();
      $timeout(function () {
        getDateValidation();
      },100);
    }

    function handleUpiError() {
      if(vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI && vm.formData.installmentAmount > vm.upiAmountLimit && vm.formData.inSchemeName) {
        var success = function() {
          if(vm.paymentOptions.includes("OTM") && vm.isOTMEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
          } else if(vm.paymentOptions.includes("HEM") && vm.isEMandateEnabled) {
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM;
          } else if(vm.paymentOptions.includes("EC")){
            vm.formData.sipPaymentOption = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC;
          } else {
            vm.formData.sipPaymentOption = null;
          }
          vm.changedPaymentOption();
          vm.changePaymentMode();
        }
        ModalService.genericModal({
          text: vm.upiErrorMessage
        },success);
      }
    }


    function fetchEmailMobile(panNumber,Dob, cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.mobile = resp.data.mobileNumber;
            vm.email = resp.data.email;
            vm.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
            vm.nomineeLimit = resp.data.nomineeLimit;
            cb();
          }

          if(!resp.data && resp.message) {
            if(resp.message !== "The given Date Of Birth is invalid."){
              MessageService.error(resp.message)
            }
          }

          if(resp.data && resp.data.ekycStatus == "NOT_VERIFIED" && $stateParams.fromModify){
            MessageService.error('KYC verification is pending for selected investor');
            vm.panDetailsNotVerified = true;
          }

        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error("something went wrong")
        };
      vm.payload = {
        pan: panNumber,
        dob: Dob,
        transactionEnabled : true
      };
      LoaderService.showLoader();
      InvestorsService.post({
        child1: 'pan',
        child2: 'details'
      }, vm.payload).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BulkTransactionController', BulkTransactionController);

  /** @ngInject */
  function BulkTransactionController($scope, $timeout, $state) {
    var vm = this;
    vm.tabs = [
      {key: 'Initiate', active: true, action: "main.bulk.initiate"},
      {key: 'View Status', active: false, action: "main.bulk.status"}
    ];

    init();

    function init() {
      $timeout(function() {
        $state.go("main.bulk.initiate");
      });
    }

    vm.redirectToTab = function(tabKey){
      if (tabKey === "Initiate") {
        vm.tabs[0].active = true;
        vm.tabs[1].active = false;
        $state.go("main.bulk.initiate");
      } else {
        vm.tabs[0].active = false;
        vm.tabs[1].active = true;
        $state.go("main.bulk.status");
      }
    };
  }
})();



(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SummaryController', SummaryController);

  /** @ngInject */
  function SummaryController($rootScope, $stateParams, $state, LoaderService,$window, InvestorServiceDynamicData, MessageService, NewInvestorServiceV3, ModalService, InvestorsService,$log,UtilService,HDFC_API) {
    var vm = this;
    vm.bankDetails = JSON.parse(sessionStorage.getItem('folioBank'));
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    vm.nomineeData = [];
    vm.nomineeCountry = [];
    vm.guardianRelationshipWithNominee=[];
    vm.addressLine1 = [];
    vm.countryList = [];
    vm.holderIncomdeslab = [];
    vm.taxIdTypeList = [];
    vm.gAddress = [];
    vm.folioData = {};
    vm.holders = {};
    vm.init = init;
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.belongToListEmail = null;
    vm.belongToListMobile = null;
    vm.uuid = $stateParams.uuid;
    vm.folioCreationProcess = sessionStorage.getItem('folioCreationProcess');
    vm.folioNumber = localStorage.getItem('folioNumber');
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    if(vm.folioCreationProcess == 'Completed' && vm.folioNumber && vm.folioDetails.folioWithoutTransaction == 'N'){
      $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
      // $window.location.href ="http://localhost:3000/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
    }
    vm.guardianRelationshipList = [
      {
        "relationDesc": "Mother",
        "value": "MOTHER"
      },
      {
        "relationDesc": "Father",
        "value": "FATHER"
      },
      {
        "relationDesc": "Legal Guardian",
        "value": "LEGAL_GUARDIAN"
      }
    ];
    function init() {
      vm.UserData = JSON.parse(sessionStorage.getItem('folioDetails'));
      if(vm.UserData == null){
        vm.UserData = {};
      }
      vm.UserData.bankDetails = vm.bankDetails;
      if (vm.UserData) {
        getOccupations();
        getIncomeSlab();
        getCountry();
        getTaxIdType();
        mobileEmailBelongsTo();
        getPayoutMechanism();

        vm.folioDetails.bankDetails = vm.UserData.bankDetails;
        vm.folioDetails.birthPlace = vm.UserData.soleApplicantDetail.birthCity;
        vm.folioDetails.minor = vm.UserData.soleApplicantDetail.minor;
        vm.folioDetails.soleApplicantDetail.addressType = vm.UserData.soleApplicantDetail.fatcaAddressType;
        vm.showNomineeUpdate = vm.UserData.sebiNomineeRegulatory01650Active ? vm.UserData.sebiNomineeRegulatory01650Active : false;

        if (vm.UserData.soleApplicantDetail.minor) {
          vm.userTaxStatusCode = vm.UserData.soleApplicantDetail.taxStatusCode;
          taxStatus(vm.userTaxStatusCode);
          vm.folioDetails.soleApplicantDetail.personalDetail = {};
          vm.folioDetails.soleApplicantDetail.personalDetail.firstName = vm.UserData.soleApplicantDetail.firstName;
          vm.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth = vm.UserData.soleApplicantDetail.dob;
          vm.folioDetails.soleApplicantDetail.politicalStatus = vm.UserData.guardianDetails.basicDetails.politicalStatus;
          vm.folioDetails.soleApplicantDetail.relation = vm.UserData.guardianDetails.relationship;
          vm.folioDetails.soleApplicantDetail.birthPlace = vm.UserData.guardianDetails.basicDetails.birthCity;
          vm.folioDetails.guardianDetails.politicalStatus =  vm.UserData.guardianDetails.basicDetails.politicalStatus == 'NONE' ? 'Not Applicable' : vm.UserData.guardianDetails.basicDetails.politicalStatus;
          getBankcAccountType();
          vm.belongToListEmail = vm.UserData.soleApplicantDetail.emailBelongsTo;
          vm.belongToListMobile = vm.UserData.soleApplicantDetail.mobileBelongsTo;
        } else {
          vm.userTaxStatusCode = vm.UserData.soleApplicantDetail.taxStatusCode;
          vm.belongToListEmail = vm.UserData.soleApplicantDetail.emailBelongsTo;
          vm.belongToListMobile = vm.UserData.soleApplicantDetail.mobileBelongsTo;
          taxStatus(vm.userTaxStatusCode);
          getBankcAccountType();
        }
        setData();
      }
    }
    if(vm.folioDetails && vm.bankDetails){
      init();
    }
    function getOccupations() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
          if(vm.UserData.guardianDetails){
          var occupationId = vm.UserData.guardianDetails.basicDetails.occupation;
          vm.investorOccupations.forEach(function (item) {
            if (item.occupationCode === occupationId) {
              vm.occupationData = item;
            }
          });
          }else{
          var occupationId = vm.UserData.soleApplicantDetail.occupation ? vm.UserData.soleApplicantDetail.occupation : vm.UserData.guardianDetails.basicDetails.occupation;
          vm.investorOccupations.forEach(function (item) {
            if (item.occupationCode === occupationId) {
              vm.occupationData = item;
            }
          });
          }
        } else {
          vm.investorOccupations = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in occupation list!");
        };
      var payload = {
        id: vm.folioDetails.holderLinkId
      }
      InvestorsService.post({ controller: 'get-occupation', child1: 'investor' }, payload).$promise.then(success, error);
    }
    function getIncomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
          if (vm.UserData) {
            if (vm.UserData.guardianDetails) {
              if (vm.UserData.guardianDetails.basicDetails) {
                if (vm.UserData.guardianDetails.basicDetails.grossAnnualIncome) {
                  var grossincomeId = vm.UserData.guardianDetails.basicDetails.grossAnnualIncome;
                  vm.incomeSlabList.forEach(function (item) {
                    if (item.incomeCode === grossincomeId) {
                      vm.grossIncomeData = item;
                    }
                  });
                }
              }
            } else {
              if (vm.UserData.soleApplicantDetail.grossAnnualIncome) {
                var grossincomeId = vm.UserData.soleApplicantDetail.grossAnnualIncome;
                vm.incomeSlabList.forEach(function (item) {
                  if (item.incomeCode === grossincomeId) {
                    vm.grossIncomeData = item;
                  }
                });
              }
            }
          }
        } else {
          vm.incomeSlabList = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in income slab list!");
        };
      var payload = {
        id: vm.folioDetails.holderLinkId
      }
      InvestorsService.post({ controller: 'income', child1: 'slab', child2: 'investor' }, payload).$promise.then(success, error);
    }
    function getCountry() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
          if (vm.UserData) {
            if (vm.UserData.soleApplicantDetail) {
              var countryId = vm.UserData.soleApplicantDetail.birthCountry;
              vm.countries.forEach(function (item) {
                if (item.countryCode === countryId) {
                  vm.countryData = item;
                }
              });
            }
            if (vm.UserData.guardianDetails) {
              if (vm.UserData.guardianDetails.basicDetails) {
                var countryId = vm.UserData.guardianDetails.basicDetails.birthCountry;
                vm.countries.forEach(function (item) {
                  if (item.countryCode === countryId) {
                    vm.countryData = item;
                  }
                });
              }
            }
            if(vm.UserData){
              if (vm.UserData.soleApplicantDetail.payOutsideIndiaAddresses[0]) {
                var indiaOutsideCity = vm.UserData.soleApplicantDetail.payOutsideIndiaAddresses[0].countryName;
                vm.countries.forEach(function (item) {
                  if (item.countryCode === indiaOutsideCity) {
                    vm.taxCountry = item;
                  }
                });
              }
            }
            if(vm.folioDetails.guardianDetails){
              if (vm.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0]) {
                var indiaOutsideCity = vm.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0].countryName;
                vm.countries.forEach(function (item) {
                  if (item.countryCode === indiaOutsideCity) {
                    vm.taxCountry = item;
                  }
                });
              }
            }

          }

          //nominee start
          if (vm.nomineeData && vm.nomineeData.length == 0) {

          } else {
            for (var i = 0; i < vm.nomineeData.length; i++) {
              if (vm.nomineeData[i].nomineeAddress.addressLine1 == null) {
                var ncountryId = vm.nomineeData[i].guardianAddress.country;
                vm.countries.forEach(function (value) {
                  if (value.countryCode == ncountryId) {
                    vm.nomineeCountry.push(value);
                  }
                });
                var guardianRelationship = vm.nomineeData[i].guardianRelationWithNominee;
                vm.guardianRelationshipList.forEach(function (item) {
                  if (item.value == guardianRelationship) {
                    vm.guardianRelationshipWithNominee.push(item);
                  }
                });
                vm.addressLine1.push(vm.nomineeData[i].guardianAddress.addressLine1);
                vm.gAddress.push(true);
              } else if (vm.nomineeData[i].guardianAddress.addressLine1 == null) {
                var ncountryId = vm.nomineeData[i].nomineeAddress.country;
                vm.countries.forEach(function (value) {
                  if (value.countryCode == ncountryId) {
                    vm.nomineeCountry.push(value);
                  }
                });
                vm.addressLine1.push(vm.nomineeData[i].nomineeAddress.addressLine1);
                vm.gAddress.push(false);
              }
              if(ncountryId == null){
                vm.nomineeCountry.push({
                  countryCode: "",
                  countryName: ""
                  });
              }
              if(guardianRelationship == null){
                vm.guardianRelationshipWithNominee.push({
                  "relationDesc": "",
                  "value": ""
                });
              }
            }
          }
          //nominee  end
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in country list!");
        };
      var payload = {
        id: vm.folioDetails.holderLinkId
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdType = null;
          MessageService.error(resp.message);
        }
        if(vm.UserData){
          if (vm.UserData.soleApplicantDetail.payOutsideIndiaAddresses[0]) {
            var taxPayingIdType = vm.UserData.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType;
            vm.taxIdType.forEach(function (item) {
              if (item.key === taxPayingIdType) {
                vm.taxPayIdType = item;
              }
            });
          }
        }
         if(vm.folioDetails.guardianDetails){
          if (vm.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0]) {
            var taxPayingIdType = vm.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0].taxIdType;
            vm.taxIdType.forEach(function (item) {
              if (item.key === taxPayingIdType) {
                vm.taxPayIdType = item;
              }
            });
          }
        }
      },
        error = function () {
          MessageService.error("Error in tax id type list!");
        };
      InvestorsService.post({
        controller: 'taxId-type',
        child1: 'investor'
      }, { "id": vm.folioDetails.holderLinkId }).$promise.then(success, error);
    }
    function taxStatus(taxStatusCode) {
      var successTaxStatus = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
          vm.taxStatusData.forEach(function (value) {
            if (value.taxStatusCode == taxStatusCode) {
              vm.taxStatusDescription = value.taxStatusDescription;
            }
          });
        }
        else {
          MessageService.error(resp.message);
        }
      },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
          var payloadTaxStatus = {
            id: vm.folioDetails.holderLinkId,
            taxStatusFilter: vm.UserData.soleApplicantDetail.minor ? 'MINOR' : 'ADULT'
          };
          InvestorsService.post({ controller: 'tax-status', child1: 'investor' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
      }
    function getBankcAccountType() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          vm.AccountTypes = resp.data.bankAccountTypes;
          var accId = vm.UserData.bankDetails.accountType;
          vm.AccountTypes.forEach(function (item) {
            if (item.accountTypeCode === accId) {
              vm.bank = item;
            }
          });
        }
        else {
          vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };
      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: vm.userTaxStatusCode
      }).$promise.then(success, error);
    }

    function getPayoutMechanism() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payoutMechanismList = resp.data.payoutMechanisms;
          $rootScope.payoutMechanismData = resp.data.payoutMechanisms;
          var payoutMechanismId = vm.UserData.bankDetails.payoutMechanism;
          $rootScope.payoutMechanismData.forEach(function (item) {
            if (item.payoutCode === payoutMechanismId) {
              vm.payoutDescriptionData = item;
            }
          });
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };
      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism',
        child2: 'investor'
      }, {
        id: vm.folioDetails.holderLinkId
      }).$promise.then(success, error);
    }
    vm.createNewFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data && resp.data.folioNumber) {
          vm.folioData = resp.data;
          localStorage.setItem("folioDataCreate", resp.data);
          localStorage.setItem("folioNumber", resp.data.folioNumber);
          sessionStorage.setItem('folioCreationProcess','Completed');
          var panevent = $('#callModal');
          panevent.click();
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              panErrorText: resp.message
            });
          } else {
            MessageService.error(resp.message);
          }
        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      LoaderService.showLoader();
      var folioLinkID = sessionStorage.getItem('unicLinkID');
      var payload ={
        "id": vm.folioDetails.id,
        "bankDetails" : vm.bankDetails,
        "folioLinkId" :folioLinkID,
        "emailBelongsTo":vm.belongToListEmail,
        "mobileBelongsTo":vm.belongToListMobile
     }
      NewInvestorServiceV3.post({ child1: 'folio',child2: 'distributorNewInvestor', child3: 'createNew'}, payload).$promise.then(success, error);
    }

    vm.getModal = function () {
      ModalService.folioSuccssModal(vm.folioData);
    }
    vm.rejectTransaction = function () {
        var success = function () {
          var successReason = function (respModal) {
            var successFolioReject = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                $state.go('newinvestorApprove.folio.reject');
              } else {
                MessageService.error(resp.message);
              }
            }, errorFolioReject = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
            var payload = {
              id: vm.uuid,
              reason: respModal.reason ? respModal.reason : 'Rejected',
              linkId: vm.folioDetails.holderLinkId,
              uniqueLink : vm.uuid,
              newUserFlow:true
            };
            LoaderService.showLoader();
            InvestorsService.post({
              controller: 'folio',
              child1: 'details',
              child2: 'reject'
            }, payload).$promise.then(successFolioReject, errorFolioReject);
          }, dismissReason = function () {
          };
          ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);
        }, dismiss = function () {
        };
        var msg = "Are you sure, you want to reject<br/>'Folio Creation?'";
        ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

      vm.openUploadedDoc = function (url) {
        vm.cheaqueleafUrl=url;
        if(vm.cheaqueleafUrl){
          vm.isInvestor = false;
          var demo = vm.cheaqueleafUrl.split('/');
          demo.forEach(function (item){
            if(item == $stateParams.uuid){
              vm.isInvestor = true;
            }
          })
          if(vm.isInvestor){
            vm.previewChequeleaf = vm.cheaqueleafUrl;
          }else{
            vm.previewChequeleaf= HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + "/investor/image/open/"+vm.folioDetails.holderLinkId+"/CHEQUE_LEAF?"+performance.now();
          }
        }
        if (angular.isUndefined(vm.previewChequeleaf)) { return; }
        ModalService.imagePreviewModal({ showOnly: true, file: vm.previewChequeleaf });
      };

    function setData() {

      if (vm.UserData) {
        vm.pan = vm.UserData.investorPanDetails.pan;
        vm.UserData.panHolderName = vm.UserData.investorPanDetails.name;
        vm.folioData.holdmode = vm.UserData.holdMode;
        vm.nomineeData = vm.UserData.nominees?vm.UserData.nominees:[];
        vm.nomineeRegistrationCO = vm.UserData.nomineeRegistrationCO ? vm.UserData.nomineeRegistrationCO : null;
        vm.accountHoldingDeclaration = vm.nomineeRegistrationCO && vm.nomineeRegistrationCO.accountHoldingDeclaration ? vm.nomineeRegistrationCO.accountHoldingDeclaration : "NOMINATION_YES";
        vm.incapacitationDeclaration = vm.nomineeRegistrationCO && vm.nomineeRegistrationCO.incapacitationDeclaration ? vm.nomineeRegistrationCO.incapacitationDeclaration : null;
        vm.jointHoldersData = vm.UserData.jointHolders;

        if (vm.folioDetails.minor) {
          vm.soleApplicantEmail = vm.UserData.soleApplicantDetail.email ? vm.UserData.soleApplicantDetail.email : vm.UserData.investorPanDetails.email;
          vm.soleApplicantMobile = vm.UserData.soleApplicantDetail.mobileNo ? vm.UserData.soleApplicantDetail.mobileNo : vm.UserData.investorPanDetails.mobileNumber;
        } else if (!vm.folioDetails.minor) {
          vm.soleApplicantEmail = vm.UserData.soleApplicantDetail.email ? vm.UserData.soleApplicantDetail.email : vm.UserData.investorPanDetails.email;
          vm.soleApplicantMobile = vm.UserData.soleApplicantDetail.mobileNo ? vm.UserData.soleApplicantDetail.mobileNo : vm.UserData.investorPanDetails.mobileNumber;
        }

        // holder data *******************************************************************************
        // if (vm.jointHoldersData != null) {
        //   for (var i = 0; i < vm.jointHoldersData.length; i++) {
        //     // id type
        //     if (vm.jointHoldersData[i].jointHolderApplicantDetail.payTaxInIndia == false) {
        //       var taxId2 = vm.jointHoldersData[i].jointHolderApplicantDetail.fatcaTax1.taxIdType;
        //       vm.taxIdTypeList = vm.taxIdType.filter(function (character) { character.value === taxId2 });
        //     } else {
        //       vm.taxIdTypeList.push('-');
        //     }
        //     //  country
        //     var jointholdercountryId = vm.jointHoldersData[i].jointHolderApplicantDetail.birthCountry;
        //     vm.countryList = vm.countries? vm.countries.filter(function (character) { character.countryCode === jointholdercountryId }):null;
        //     // income
        //     var incomeId = vm.jointHoldersData[i].grossAnnualIncome;
        //     vm.holderIncomdeslab = vm.incomeSlabList?vm.incomeSlabList.filter(function (character) { character.incomeCode === incomeId }):null;
        //   }
        // }
        if (vm.UserData.soleApplicantDetail.minor) {
          if (vm.UserData.guardianDetails.basicDetails.taxIdType) {
            var taxId = vm.UserData.guardianDetails.basicDetails.taxIdType;
            vm.taxIdType.forEach(function (item) {
              if (item.value === taxId) {
                vm.taxIdDetails = item;
              }
            });
          }
        } else {
          if (vm.UserData.soleApplicantDetail.taxIdType) {
            var taxId = vm.UserData.soleApplicantDetail.taxIdType;
            vm.taxIdType.forEach(function (item) {
              if (item.value === taxId) {
                vm.taxIdDetails = item;
              }
            });
          }
        }
      }
    }

    vm.gotoBankPage = function () {
      $state.go('newinvestorApprove.folio.bank');
    }
    function mobileEmailBelongsTo() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.emailBelongsToList = resp.data.emailList;
          vm.mobileBelongsToList = resp.data.mobileList;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(resp.error);
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NomineeController', NomineeController);

  /** @ngInject */
  function NomineeController(InvestorsService, $state, $window, InvestorsCommonService, AppConstants, $log, LoaderService,
    $rootScope, MessageService, NewInvestorServiceV3, $stateParams) {
    var vm = this;

    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.conformation = false;
    vm.nomineeMinor = false;
    vm.addAddress = true;
    vm.addressLine1 = "";
    vm.addressLine2 = "";
    vm.country = "";
    vm.city = "";
    vm.pinCode = "";
    vm.startval = 0;
    vm.addanotherNominee = true;
    vm.shownextSteps1 = false;
    vm.shownextSteps2 = false;
    vm.extraNomineeVar = false;
    vm.proceed = true;
    vm.addnomineedata = addnomineedata;
    vm.uuid = $stateParams.uuid;
    vm.nominees = [];
    vm.numberofnominees = vm.nominees.length;
    vm.guardianRelationshipList = [
      {
        "relationDesc": "Mother",
        "value": "MOTHER"
      },
      {
        "relationDesc": "Father",
        "value": "FATHER"
      },
      {
        "relationDesc": "Legal Guardian",
        "value": "LEGAL_GUARDIAN"
      }
    ];
    vm.showDeleteBtn = false;
    vm.currentNominee = function (val) {
      if (val == 3) {
        val = 0;
      }
      vm.currentNomineeValue = val;
      if (vm.nominees.length > val) {
        try {
          vm.showDeleteBtn = true;
          vm.currentNomineeValue = val;
          vm.data = vm.nominees[val];
          vm.nomineeDetails = {
            nomineeName: vm.data.nomineeName,
            nomineeRelation: vm.data.nomineeRelation,
            percentage: vm.data.percentage,
            dob: vm.data.dob,
            minor: true
          };
          vm.nomineePan = vm.data.panNumber;
          if (vm.data.minor) {
            vm.guardianName = vm.data.guardianName;
            vm.guardianRelation = vm.data.guardianRelationWithNominee;
            vm.guardianPan = vm.data.guardianPanNumber;
            vm.nomineeMinor = true;
          }

          if (!vm.data.guardianName) {
            vm.addAddress = false;
            vm.addressLine1 = vm.data.nomineeAddress.addressLine1;
            vm.addressLine2 = vm.data.nomineeAddress.addressLine2;
            vm.country = vm.data.nomineeAddress.country;
            vm.city = vm.data.nomineeAddress.city;
            vm.pinCode = vm.data.nomineeAddress.pinCode;
            vm.state = vm.data.nomineeAddress.state;
          } else if (vm.data.guardianAddress && Object.keys(vm.data.guardianAddress).length > 0) {
            vm.addAddress = true;
            vm.addressLine1 = vm.data.guardianAddress.addressLine1;
            vm.addressLine2 = vm.data.guardianAddress.addressLine2;
            vm.country = vm.data.guardianAddress.country;
            vm.city = vm.data.guardianAddress.city;
            vm.pinCode = vm.data.guardianAddress.pinCode;
            vm.state = vm.data.guardianAddress.state;
          }
        }
        catch (e) {
          console.log(e);
        }
      } else {
        vm.showDeleteBtn = false;
        vm.nomineeDetails = {
        };
        vm.addressLine1 = "";
        vm.addressLine2 = "",
          vm.pinCode = "",
          vm.city = "",
          vm.country = ""
        if (vm.fromForm) {
          vm.fromForm.$setPristine();
          vm.fromForm.$setUntouched();
        }
      }

    }
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    if (vm.folioDetails != null) {
      if (vm.folioDetails.nominees != null) {
        if (vm.folioDetails.nominees.length > 0) {
          vm.addnominee = true;
          vm.nominees = vm.folioDetails.nominees;
          vm.numberofnominees = vm.nominees.length;
          countPercentage();
          if (vm.nominees.length > 0) {
            vm.currentNominee(0);
            addnomineedata(1);

            vm.numberofnominees = vm.nominees.length;
            if (vm.numberofnominees == 1) {
              if (vm.totalShare == 100) {
                vm.shownextSteps1 = false;
                vm.currentNominee(0);
              } else {
                vm.shownextSteps1 = true;
              }
            }
            if (vm.numberofnominees == 2) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = false;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              } else {
                vm.shownextSteps2 = true;
              }
            }
            if (vm.numberofnominees == 3) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = true;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              }
            }
          }
          vm.numberofnominees = vm.nominees.length;

        } else {
          vm.addnominee = false;
          vm.nominees = [];
        }
      }
    }
    $rootScope.myState = $state.current.url;
    vm.init = function () {
      getRelationshipList();
      getStateList();
    }

    vm.deleteNominee = function (index) {

      if (index > -1) {
        vm.nominees.splice(index, 1)
      }
      vm.numberofnominees = vm.nominees.length;
      MessageService.success("Nominee deteleted success.");
      vm.nomineePan = "";
      vm.guardianName = "";
      vm.guardianRelation = "";
      vm.guardianPan = "";
      vm.nomineeMinor = false;
      countPercentage();
      vm.currentNominee(0);
    }


    function countPercentage() {
      vm.totalpercent = vm.startval;
      vm.totalShare = vm.startval;

      angular.forEach(vm.nominees, function (p) {
        vm.totalpercent = vm.totalpercent + parseInt(p.percentage);
      });

      vm.totalShare = vm.totalpercent;
      if (vm.totalShare == 100) {
        vm.addanotherNominee = false;
      } else {
        vm.addanotherNominee = true;
      }
    }

    vm.addnewnominee = function (form) {
      vm.fromForm = form;
      vm.numberofnominees = vm.nominees.length;
      vm.totalShare = 0;
      countPercentage();

      if (vm.totalShare == 100) {
        vm.submitNomineeData();
        return;
      }

      vm.totalShare = vm.totalpercent + parseInt(vm.nomineeDetails.percentage);
      if (vm.numberofnominees < 3 && (vm.totalShare <= 100)) {
        if (vm.nomineeMinor) {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.nomineePan = vm.nomineePan;
          vm.nomineeDetails.minor = true;
        } else {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.minor = false;
        }
        if (vm.nomineeMinor == false) {
          vm.nomineeDetails.nomineeAddress = {};
          vm.nomineeDetails.nomineeAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.nomineeAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.nomineeAddress.country = vm.country ? vm.country : vm.payload.soleApplicantDetail.selfDetail.fatca.birthCountry;
          vm.nomineeDetails.nomineeAddress.state = vm.state;
          vm.nomineeDetails.nomineeAddress.city = vm.city ? vm.city : vm.payload.soleApplicantDetail.selfDetail.fatca.birthPlace;
          vm.nomineeDetails.nomineeAddress.pinCode = vm.pinCode;
          console.log(vm.nomineeDetails);
          vm.nominees.push(vm.nomineeDetails);
        } else {
          // var incomdeData = JSON.parse(sessionStorage.getItem("incomeDetails"));
          vm.nomineeDetails.guardianAddress = {};
          vm.nomineeDetails.guardianAddress.addressLine1 = "";
          vm.nomineeDetails.guardianAddress.addressLine2 = "";
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.guardianAddress.country = vm.payload.soleApplicantDetail.selfDetail.fatca.birthCountry;
          vm.nomineeDetails.guardianAddress.city = vm.payload.soleApplicantDetail.selfDetail.fatca.birthPlace;
          vm.nomineeDetails.guardianAddress.pinCode = "";
          vm.nomineeDetails.guardianAddress.state = "";
          console.log(vm.nomineeDetails);
          vm.nominees.push(vm.nomineeDetails);
          MessageService.success("Added Nominee");
        }
        vm.nomineeMinor = false;
        vm.nomineeDetails = {
          nomineeName: "",
          nomineeRelation: "",
          panNumber: "",
          percentage: 0,
          dob: ""
        };
        vm.numberofnominees = vm.nominees.length;
        vm.currentNominee(vm.numberofnominees);
      }
      else {
        if (vm.numberofnominees == 3) {
          MessageService.error('You cant add more than 3 nominee');
        } else if (vm.numberofnominees <= 3 && vm.totalShare > 100) {
          MessageService.error('Sum of percentage proportion of all nominees should be equal to 100%.');
        }
      }
      countPercentage();
      if (vm.numberofnominees == 1) {
        if (vm.totalShare == 100) {
          vm.shownextSteps1 = false;
          vm.extraNomineeVar = false;
          vm.submitNomineeData();
        } else {
          vm.extraNomineeVar = true;
          vm.currentNominee(0);
        }
      }
      if (vm.numberofnominees == 2) {
        if (vm.totalShare == 100) {
          vm.shownextSteps2 = false;
          vm.extraNomineeVar = false;
          vm.submitNomineeData();
        } else {
          vm.extraNomineeVar = true;
          vm.currentNominee(1);
        }
      }

      countPercentage();
    }

    vm.checkpan = function () {
      if (vm.guardianName && vm.guardianRelation && vm.guardianPan) {
        vm.proceed = true;
      } else {
        vm.proceed = false;
      }
    }
    vm.checkgNmae = function () {
      if (vm.guardianName && vm.guardianRelation && vm.guardianPan) {
        vm.proceed = true;
      } else {
        vm.proceed = false;
      }
    }
    vm.checkGRelation = function () {
      if (vm.guardianName && vm.guardianRelation && vm.guardianPan) {
        vm.proceed = true;
      } else {
        vm.proceed = false;
      }
    }
    vm.addExtraNomineeFun = function () {
      vm.numberofnominees = vm.nominees.length;
      if (vm.numberofnominees == 1) {
        vm.shownextSteps1 = true;
        vm.currentNominee(1);
        vm.extraNomineeVar = false;
      }
      if (vm.numberofnominees == 2) {
        vm.shownextSteps2 = true;
        vm.currentNominee(2);
        vm.extraNomineeVar = false;
      }
    }





    vm.shownomineeList = false;

    // vm.nomineeDetails = {
    //   nomineeName: "",
    //   nomineeRelation: "",
    //   percentage: 0,
    //   dob: "",
    //   minor: true
    // };

    vm.totalpercent;


    vm.addNomineeNewAddress = function () {
      vm.addAddress = !vm.addAddress;
    }



    function addnomineedata(value) {
      if (value == 1) {
        vm.addnominee = true;
      }
      else {
        vm.addnominee = false;
        vm.nominees = [];
      }
    }
    vm.getNomineeDob = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.nomineeDetails.dob = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.age < 18) {
          //  minor
          vm.proceed = false;
          vm.nomineeMinor = true;
        }
        else {
          vm.nomineeMinor = false;
          vm.proceed = true;
        }



        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.nomineeDetails.dob = "";
      }
      return;
    }
    vm.getconformation = function () {
      vm.conformation = !vm.conformation;
    }
    vm.getNewUserDetails = function () {
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      var uContext = JSON.parse(sessionStorage.getItem("userData"));
      var taxIdentifier = uContext.pan;
      var payload = {
        "panNumber": taxIdentifier
      }
      InvestorsService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
    }
    // vm.getNewUserDetails();


    vm.getPayload = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payload = resp.data;
          vm.holdeMode = resp.data.holdmode;
          $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
          var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");

          if (isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE") {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            sessionStorage.removeItem("investorIsEditButtonClick");
          } else {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            $rootScope.nextStep(2);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }

          vm.nominees = resp.data.nominees;
          vm.numberofnominees = vm.nominees.length;
          countPercentage();
          if (vm.nominees.length > 0) {
            vm.currentNominee(0);
            addnomineedata(1);

            vm.numberofnominees = vm.nominees.length;
            if (vm.numberofnominees == 1) {
              if (vm.totalShare == 100) {
                vm.shownextSteps1 = false;
                vm.currentNominee(0);
              } else {
                vm.shownextSteps1 = true;
              }
            }
            if (vm.numberofnominees == 2) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = false;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              } else {
                vm.shownextSteps2 = true;
              }
            }
            if (vm.numberofnominees == 3) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = true;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              }
            }
          }
          vm.numberofnominees = vm.nominees.length;
          localStorage.setItem('folioId', resp.data.id);
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }

    // vm.getPayload();

    vm.setState = function () {
      if (vm.country != 'IN') {
        vm.state = "OTHER";
      } else {

      }
    }

    vm.submitNomineeData = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (vm.holdeMode == 'SINGLE') {
            $rootScope.nextStep(2);
            $state.go('newInvestor.folioDetails.bankdetails');
          } else {
            $state.go('newInvestor.folioDetails.bankdetails');
            $rootScope.nextStep(3);
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      if (vm.addnominee) {
        vm.payload.nominees = vm.nominees;
      } else {
        vm.payload.nominees = [];
      }

      $window.smartech('dispatch', 'nominee details', {
        'addnominee': vm.addnominee
      });

      vm.payload.nominees = vm.nominees;
      vm.payload.id = localStorage.getItem("folioId");
      vm.payload.folioSaveStep = "FOUR";
      vm.payload.brokerCode = "DIRECT";
      countPercentage();

      if (vm.addnominee) {
        if (vm.totalShare == 100) {
          NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
        } else {
          MessageService.error('Total sum of percentage is 100 required!');
        }
      } else {
        NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payload).$promise.then(success, error);
      }
    }

    vm.autoDate = function () {
      vm.dobString = $("#nomineedob").val();;
      if (vm.dobString.length == 2) {
        $("#nomineedob").val(vm.dobString + "-");
      }
      if (vm.dobString.length == 5) {
        $("#nomineedob").val(vm.dobString + "-");
      }
    }
    vm.datethreeToTwo = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "Jan":
          vm.cdate = dateChar[0] + "-01-" + dateChar[2];
          return vm.cdate;
          break;
        case "Feb":
          vm.cdate = dateChar[0] + "-02-" + dateChar[2];
          return vm.cdate;
          break;
        case "Mar":
          vm.cdate = dateChar[0] + "-03-" + dateChar[2];
          return vm.cdate;
          break;
        case "Apr":
          vm.cdate = dateChar[0] + "-04-" + dateChar[2];
          return vm.cdate;
          break;
        case "May":
          vm.cdate = dateChar[0] + "-05-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jun":
          vm.cdate = dateChar[0] + "-06-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jul":
          vm.cdate = dateChar[0] + "-07-" + dateChar[2];
          return vm.cdate;
          break;
        case "Aug":
          vm.cdate = dateChar[0] + "-08-" + dateChar[2];
          return vm.cdate;
          break;
        case "Sep":
          vm.cdate = dateChar[0] + "-09-" + dateChar[2];
          return vm.cdate;
          break;
        case "Oct":
          vm.cdate = dateChar[0] + "-10-" + dateChar[2];
          return vm.cdate;
          break;
        case "Nov":
          vm.cdate = dateChar[0] + "-11-" + dateChar[2];
          return vm.cdate;
          break;
        case "Dec":
          vm.cdate = dateChar[0] + "-12-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.datetwoTothree = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "01":
          vm.cdate = dateChar[0] + "-Jan-" + dateChar[2];
          return vm.cdate;
          break;
        case "02":
          vm.cdate = dateChar[0] + "-Feb-" + dateChar[2];
          return vm.cdate;
          break;
        case "03":
          vm.cdate = dateChar[0] + "-Mar-" + dateChar[2];
          return vm.cdate;
          break;
        case "04":
          vm.cdate = dateChar[0] + "-Apr-" + dateChar[2];
          return vm.cdate;
          break;
        case "05":
          vm.cdate = dateChar[0] + "-May-" + dateChar[2];
          return vm.cdate;
          break;
        case "06":
          vm.cdate = dateChar[0] + "-Jun-" + dateChar[2];
          return vm.cdate;
          break;
        case "07":
          vm.cdate = dateChar[0] + "-Jul-" + dateChar[2];
          return vm.cdate;
          break;
        case "08":
          vm.cdate = dateChar[0] + "-Aug-" + dateChar[2];
          return vm.cdate;
          break;
        case "09":
          vm.cdate = dateChar[0] + "-Sep-" + dateChar[2];
          return vm.cdate;
          break;
        case "10":
          vm.cdate = dateChar[0] + "-Oct-" + dateChar[2];
          return vm.cdate;
          break;
        case "11":
          vm.cdate = dateChar[0] + "-Nov-" + dateChar[2];
          return vm.cdate;
          break;
        case "12":
          vm.cdate = dateChar[0] + "-Dec-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.applicantRelationShip = [];
    function getRelationshipList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantRelationShip = resp.data.nomineeRelationshipList;
          console.log(vm.applicantRelationShip);
        } else {
          vm.applicantRelationShip = [];
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.applicantRelationShip = [];
      };
      InvestorsCommonService.get({ child1: 'nominee', child2: 'relation' }, {}).$promise.then(success, error);
    }
    vm.stateList = [];
    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsCommonService.get({ child1: 'state', child2: 'list' }).$promise.then(success, error);
    }
    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countries = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: vm.uuid
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }
    getCountryList();

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('IncomeController', IncomeController);

  /** @ngInject */
  function IncomeController($state,$stateParams, $window, AppConstants, $log, InvestorServiceDynamicData, LoaderService, $rootScope, MessageService, InvestorsService, NewInvestorServiceV3, $timeout) {
    var vm = this;
    
    vm.countries = [];
    vm.taxIdType = [];
    vm.taxStatusData = [];
    vm.investorOccupations = [];
    vm.incomeSlabList = [];
    vm.addressType = [];
    vm.uuid = $stateParams.uuid;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.dateErrorMessage = "";
    vm.folioIncomeForm = {}
    vm.folioIncomeForm.occupation = '';
    vm.folioIncomeForm.annualincome = '';
    vm.folioIncomeForm.grossAnnualIncomeDate = '';
    vm.folioIncomeForm.Fatca = {};
    vm.folioIncomeForm.Fatca.city = '';
    vm.networth = false;
    vm.holders = {};
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.init = init;
    function init() {
      vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
      vm.folioIncomeForm.taxstatus = vm.folioDetails.soleApplicantDetail.taxStatusCode;
      vm.folioIncomeForm.occupation = vm.folioDetails.soleApplicantDetail.occupation;
      vm.folioIncomeForm.annualincome = vm.folioDetails.soleApplicantDetail.grossAnnualIncome ? vm.folioDetails.soleApplicantDetail.grossAnnualIncome : '';
      vm.folioIncomeForm.annualincome = vm.folioIncomeForm.annualincome.toString();
      if(!vm.folioIncomeForm.annualincome){
        vm.networth = true;
        vm.folioIncomeForm.networth = vm.folioDetails.soleApplicantDetail.netWorth;
        vm.folioIncomeForm.grossAnnualIncomeDate = vm.datethreeToTwo(vm.folioDetails.soleApplicantDetail.netWorthDate);
      }
      vm.folioIncomeForm.Fatca.countrie = vm.folioDetails.soleApplicantDetail.birthCountry;
      vm.folioIncomeForm.Fatca.addressType = vm.folioDetails.soleApplicantDetail.fatcaAddressType;
      vm.folioIncomeForm.Fatca.city = vm.folioDetails.soleApplicantDetail.birthCity;
      taxStatus();
      getCountryList();
      getTaxIdType();
      occupation();
      incomeSlab();
      addressType();
    }
    function fetchBelongsToDropdown(cb) {
      cb = cb || function () {

      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.holders = {};
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
        cb();
      },
        error = function (err) {
          $log.info('Belongs Dropdown error >>>>', err);
          LoaderService.hideLoader();
          cb();
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'
      }).$promise.then(success, error);
    }
    // vm.fetchBelongsToDropdown();
    $rootScope.myState = $state.current.url;
    vm.getGrossAnnualIncomeDate = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.folioIncomeForm.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
        }
        else {
          vm.folioIncomeForm.grossAnnualIncomeDate = "";
          alert('Not older than 1 year');
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
      return;
    }
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if (vm.networth) {
        vm.folioIncomeForm.annualincome = '';
      } else {
        vm.folioIncomeForm.networth = "";
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
    }

    vm.getNewUserDetails = function () {
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
        // console.log(resp.data.folioCreationDraftId);
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      vm.pan = vm.UserData.panNumber;
      var payload = {
        "panNumber": vm.pan
      }
      InvestorsService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
    }
    fetchBelongsToDropdown(function () {
      // getPayload();
    });
    //  vm.getNewUserDetails();
    function getPayload() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.soleApplicantEmail = resp.data.soleApplicantDetail.personalDetail.kycEmail;
          vm.soleApplicantMobile = resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
          vm.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
          vm.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;

          var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
          if (isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE") {
            $rootScope.nextStep(0);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }
          vm.currentFolio = resp.data;
          if ($rootScope.folioBasicDetail) {
            $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
          }
          vm.holdeMode = vm.currentFolio.holdmode;
          if (resp.data.soleApplicantDetail.personalDetail.taxStatusCode) {
            $rootScope.showSaveTag = true;
            $timeout(function () {
              $rootScope.showSaveTag = false;
            }, 3000);

          }
          vm.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode ? resp.data.soleApplicantDetail.personalDetail.taxStatusCode : "01";
          vm.folioIncomeForm.occupation = resp.data.soleApplicantDetail.selfDetail.occupation;
          if (vm.folioIncomeForm.grossAnnualIncomeDate) {
            vm.folioIncomeForm.grossAnnualIncomeDate = vm.datethreeToTwo(resp.data.soleApplicantDetail.selfDetail.netWorthDate);
          }


          if (resp.data.soleApplicantDetail.selfDetail.netWorthDate) {
            vm.networth = true;
            vm.folioIncomeForm.networth = resp.data.soleApplicantDetail.selfDetail.netWorth;
          } else {
            vm.networth = false;
            vm.folioIncomeForm.annualincome = resp.data.soleApplicantDetail.selfDetail.grossAnnualIncome;
          }
          vm.folioIncomeForm.Fatca.countrie = resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry ? resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry : "IN";
          vm.folioIncomeForm.Fatca.addressType = resp.data.soleApplicantDetail.selfDetail.fatca.addressType ? resp.data.soleApplicantDetail.selfDetail.fatca.addressType : "RESIDENTIAL";
          vm.folioIncomeForm.Fatca.city = resp.data.soleApplicantDetail.selfDetail.fatca.birthPlace;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }


    vm.submitFolioIncomeForm = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $rootScope.nextStep(1);
          if (vm.holdeMode == "SINGLE") {
            $state.go('newInvestor.folioDetails.nomineeDetails');
          } else {
            $state.go('newInvestor.folioDetails.jointHolderDetails');
          }
        } else {
          MessageService.error(error.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };

      $window.smartech('dispatch', 'income details', {
        'taxstatus': vm.folioIncomeForm.taxstatus,
        'occupation': vm.folioIncomeForm.occupation,
        'grossannualincome': vm.folioIncomeForm.annualincome,
        'fatca': {
          birthCountry: vm.folioIncomeForm.Fatca.countrie,
          birthPlace: vm.folioIncomeForm.Fatca.city,
          addressType: vm.folioIncomeForm.Fatca.addressType,
          payTaxInIndia: vm.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
        }
      });

      var payload = {
        soleApplicantDetail: {
          selfDetail: {
            panNumber: vm.pan,
            occupation: vm.folioIncomeForm.occupation,
            fatca: {
              birthCountry: vm.folioIncomeForm.Fatca.countrie,
              birthPlace: vm.folioIncomeForm.Fatca.city,
              addressType: vm.folioIncomeForm.Fatca.addressType,
              payTaxInIndia: vm.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
            }
          },
          personalDetail: {
            taxStatusCode: vm.folioIncomeForm.taxstatus,
            kycEmail: vm.soleApplicantEmail,
            kycMobileNo: vm.soleApplicantMobile,
            emailBelongsTo: vm.holders.emailBelongsTo,
            mobileBelongsTo: vm.holders.mobileBelongsTo
          }
        },

        jointHolders: [],
        nominees: [],
        holdmode: vm.currentFolio.holdmode,
        id: localStorage.getItem("folioId"),
        folioSaveStep: "TWO",
        newUserFlow: true
      }
      payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
      if (vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1) {
        payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
      }

      if (vm.networth) {
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = "";
        payload.soleApplicantDetail.selfDetail.netWorth = vm.folioIncomeForm.networth;
        if (vm.folioIncomeForm.grossAnnualIncomeDate.match(/[a-zA-Z]/i)) {
          payload.soleApplicantDetail.selfDetail.netWorthDate = vm.folioIncomeForm.grossAnnualIncomeDate;
        } else {
          if (vm.folioIncomeForm.grossAnnualIncomeDate) {
            payload.soleApplicantDetail.selfDetail.netWorthDate = vm.datetwoTothree(vm.folioIncomeForm.grossAnnualIncomeDate);
          }
        }
      } else {
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = vm.folioIncomeForm.annualincome;
        payload.soleApplicantDetail.selfDetail.netWorth = '';
        payload.soleApplicantDetail.selfDetail.netWorthDate = "";
      }

      sessionStorage.setItem("incomeDetails", JSON.stringify(vm.folioIncomeForm));
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, payload).$promise.then(success, error);
    }

    vm.autoDate = function () {
      var oldlength = 0;
      if (vm.dobString) {
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if (vm.dobString.length == 2) {

        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#grossAnnualIncomeDateId").val(vm.dobString + "-");
        }
      }
      if (vm.dobString.length == 5) {

        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#grossAnnualIncomeDateId").val(vm.dobString + "-");
        }
      }
    }

    vm.datethreeToTwo = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "Jan":
          vm.cdate = dateChar[0] + "-01-" + dateChar[2];
          return vm.cdate;
          break;
        case "Feb":
          vm.cdate = dateChar[0] + "-02-" + dateChar[2];
          return vm.cdate;
          break;
        case "Mar":
          vm.cdate = dateChar[0] + "-03-" + dateChar[2];
          return vm.cdate;
          break;
        case "Apr":
          vm.cdate = dateChar[0] + "-04-" + dateChar[2];
          return vm.cdate;
          break;
        case "May":
          vm.cdate = dateChar[0] + "-05-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jun":
          vm.cdate = dateChar[0] + "-06-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jul":
          vm.cdate = dateChar[0] + "-07-" + dateChar[2];
          return vm.cdate;
          break;
        case "Aug":
          vm.cdate = dateChar[0] + "-08-" + dateChar[2];
          return vm.cdate;
          break;
        case "Sep":
          vm.cdate = dateChar[0] + "-09-" + dateChar[2];
          return vm.cdate;
          break;
        case "Oct":
          vm.cdate = dateChar[0] + "-10-" + dateChar[2];
          return vm.cdate;
          break;
        case "Nov":
          vm.cdate = dateChar[0] + "-11-" + dateChar[2];
          return vm.cdate;
          break;
        case "Dec":
          vm.cdate = dateChar[0] + "-12-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.datetwoTothree = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "01":
          vm.cdate = dateChar[0] + "-Jan-" + dateChar[2];
          return vm.cdate;
          break;
        case "02":
          vm.cdate = dateChar[0] + "-Feb-" + dateChar[2];
          return vm.cdate;
          break;
        case "03":
          vm.cdate = dateChar[0] + "-Mar-" + dateChar[2];
          return vm.cdate;
          break;
        case "04":
          vm.cdate = dateChar[0] + "-Apr-" + dateChar[2];
          return vm.cdate;
          break;
        case "05":
          vm.cdate = dateChar[0] + "-May-" + dateChar[2];
          return vm.cdate;
          break;
        case "06":
          vm.cdate = dateChar[0] + "-Jun-" + dateChar[2];
          return vm.cdate;
          break;
        case "07":
          vm.cdate = dateChar[0] + "-Jul-" + dateChar[2];
          return vm.cdate;
          break;
        case "08":
          vm.cdate = dateChar[0] + "-Aug-" + dateChar[2];
          return vm.cdate;
          break;
        case "09":
          vm.cdate = dateChar[0] + "-Sep-" + dateChar[2];
          return vm.cdate;
          break;
        case "10":
          vm.cdate = dateChar[0] + "-Oct-" + dateChar[2];
          return vm.cdate;
          break;
        case "11":
          vm.cdate = dateChar[0] + "-Nov-" + dateChar[2];
          return vm.cdate;
          break;
        case "12":
          vm.cdate = dateChar[0] + "-Dec-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }


    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countries = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: vm.uuid
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorsService.post({
        controller: 'taxId-type',
        child1: 'investor'
      }, { "id": $stateParams.uuid }).$promise.then(success, error);
    }

    function taxStatus() {
      var successTaxStatus = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
        }
        else {
          MessageService.error(resp.message);
        }
      },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var payloadTaxStatus = {
        id: vm.uuid,
        taxStatusFilter: 'ADULT'
      };
      InvestorsService.post({ controller: 'tax-status', child1: 'investor' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    function occupation() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        id: vm.uuid
      }

      InvestorsService.post({ controller: 'get-occupation', child1: 'investor' }, payload).$promise.then(success, error);
    }
    function incomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        id: vm.uuid
      }
      InvestorsService.post({ controller: 'income', child1: 'slab', child2: 'investor' }, payload).$promise.then(success, error);
    }
    function addressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressType = resp.data.addressTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: vm.uuid
      };
      InvestorsService.post({ controller: 'address', child1: 'type', child2: 'investor' }, payload).$promise.then(success, error);
    }

  }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('JointHolderController', JointHolderController);

  /** @ngInject */
  function JointHolderController(InvestorsService,ChangeDividendService, $stateParams, HDFC_API, FolioApproval, UtilService, AppConstants, LoaderService, $rootScope, InvestorsCommonService, TransactionService, MessageService, ModalService,InvestorServiceDynamicData,$log) {
    var vm = this;
    vm.panMessage = "";
    vm.holders = [];
    vm.holderLinkId = '';
    vm.notolderthan1year = false;
    vm.init = init;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.holderLinkId = '';
    vm.countries = [];
    vm.taxIdType = [];
    vm.taxStatusData = [];
    vm.investorOccupations = [];
    vm.incomeSlabList = [];
    vm.addressType = [];
    vm.networth = false;
    vm.uuid = $stateParams.uuid;
    vm.uniqueLink = vm.uuid;
    vm.folioDetails = sessionStorage.getItem('folioDetails');
    init();
    function init() {
      if ($rootScope.myState == '/JointHolder') {
        if (vm.uniqueLink) {
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
             initiateOtpModal();
            } else {
              MessageService.error(resp.message)
            }
          },
            error = function (err) {
              UtilService.errorHandler(err);
            };
          LoaderService.showLoader();
          ChangeDividendService.get({
            child1: 'v2',
            child2: 'transaction',
            child3: 'otp',
            child4: vm.uniqueLink,
            child5: true
          }, null).$promise.then(success, error);
        } else {
          UtilService.errorHandler('Not a valid link');
          return;
        }
      }

    }
    function initiateOtpModal() {
      var successOtpModal = function (resp) {
        vm.holderLinkId = resp.holderLinkId;
        getfolioDetails(resp);
      }, errorOtpModal = function (resp) {
        MessageService.error(resp.message);
      };
      ModalService.newInvestorOtpVerify({
        uniqueLink: vm.uniqueLink,
        type: 'holder'
      }, successOtpModal, errorOtpModal);
    }
    vm.autoDate = function () {
      var oldlength = 0;
      if (vm.dobString) {
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if (vm.dobString.length == 2) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#grossAnnualIncomeDateId").val(vm.dobString + "-");
        }
      }
      if (vm.dobString.length == 5) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#grossAnnualIncomeDateId").val(vm.dobString + "-");
        }
      }
    }
    vm.jointHolderDetails = {
      email: '',
      fatcaDetail: {
        birthPlace: '',
        birthCountry: '',
        payTaxInIndia: true,
        addressType: '',
        countryCitizenship: "",
        thirdTax: false
      },
      grossAnnualIncome: '',
      netWorth: "",
      netWorthDate: '',
      occupationCode: '',
      pan: '',
      politicalStatus: "NONE",
      taxStatusCode: '',
      jointHolderName: '',
      kycverified: ''
    };
    vm.sameFirstHoderDetails = false;
    vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
    vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;
    vm.jointHolderTaxDetails_politicalStatus = 'No';

    vm.getTaxFileStatusForJointHolder = function (value) {
      try {
        if (value == 'Yes') {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = false;
          vm.jointHolderDetails.fatcaDetail.secondTax = {
            taxPayingCountry: "",
            taxIdType: "",
            taxPayingCity: "",
            taxId: ""
          }
          // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;
          vm.jointHolderDetails.fatcaDetail.secondTax = false;
          // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
        }
      }
      catch (e) {

      }
    }
    vm.getPEPStatusForJointHolder = function (value) {
      // console.log(vm.jointHolderDetails.politicalStatus);
      if (value == 'Yes') {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.jointHolderDetails.politicalStatus = 'POLITICAL';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'No';
        vm.jointHolderDetails.politicalStatus = 'NONE';
      }
      // console.log(vm.jointHolderDetails.politicalStatus);
    }
    vm.resetValues = function () {
      vm.errorMessage = "";
      vm.errorMessageVerify = "";
      vm.panMessage = "";
      vm.availableMessage = "";
      vm.otpResendMessage = "";
      vm.dateErrorMessage = "";
    }
    // holder
    vm.stopaddholder = true;
    vm.holderData = {};
    vm.holderData.pan = '';
    vm.holderData.HolderName = '';
    vm.holderData.email = '';
    vm.holderData.mobileNumber = '';
    vm.jointHolderDetails.kycverified = false;
    vm.AllowedJointHolder = true;


    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if (vm.networth) {
        vm.notolderthan1year = true;
        vm.jointHolderDetails.grossAnnualIncome = "";
      } else {
        vm.notolderthan1year = false;
        vm.jointHolderDetails.netWorth = "";
        vm.jointHolderDetails.netWorthDate = "";
      }
    }


    vm.getholdersdata = function (numberofholder) {
      // console.log(numberofholder);
      if (numberofholder == 1) {
        vm.showSameHOlderDetail = true;
      } else {
        vm.showSameHOlderDetail = false;
      }
      vm.holderCount = vm.holders.length
      vm.holderTab = numberofholder;
      vm.currentHolder = vm.holders[numberofholder];
      vm.currentHolder.fatcaDetail = {};
      vm.currentHolder.fatcaDetail.fatcaTax1 = {};

      if (vm.currentHolder.jointHolderApplicantDetail.netWorthDate) {
        vm.networth = true;
      } else {
        vm.networth = false;
      }

      if (vm.currentHolder.jointHolderApplicantDetail.payTaxInIndia == true) {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
        vm.currentHolder.fatcaDetail.payTaxInIndia = true;
      } else {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
        vm.currentHolder.fatcaDetail.payTaxInIndia = false;
      }

      if (vm.currentHolder.jointHolderApplicantDetail.politicalStatus == 'NONE') {
        vm.jointHolderTaxDetails_politicalStatus = 'No';
        vm.currentHolder.politicalStatus = 'NONE';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.currentHolder.politicalStatus = 'POLITICAL';
      }


      vm.jointHolderDetails = {
        email: vm.currentHolder.email,
        emailDeclaration : vm.currentHolder.jointHolderApplicantDetail.emailBelongsTo ? vm.currentHolder.jointHolderApplicantDetail.emailBelongsTo : '',
        fatcaDetail: {
          birthPlace: vm.currentHolder.jointHolderApplicantDetail.birthCity,
          birthCountry: vm.currentHolder.jointHolderApplicantDetail.birthCountry,
          payTaxInIndia: vm.currentHolder.jointHolderApplicantDetail.payTaxInIndia,
          addressType: vm.currentHolder.jointHolderApplicantDetail.fatcaAddressType,
          fatcaTax1: {
            taxPayingCountry: vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0]? vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0].countryName:null,
            taxIdType:vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0]? vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0].taxIdType:null,
            taxId: vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0]? vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0].taxIdNumber:null,
            taxPayingCity: vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0]? vm.currentHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses[0].taxPayingCity:null
          },
          secondTax: false,
          thirdTax: false
        },

        netWorth: vm.currentHolder.jointHolderApplicantDetail.netWorth ? vm.currentHolder.jointHolderApplicantDetail.netWorth : '',
        netWorthDate: vm.currentHolder.jointHolderApplicantDetail.netWorthDate ? vm.currentHolder.jointHolderApplicantDetail.netWorthDate : '',
        occupationCode: vm.currentHolder.jointHolderApplicantDetail.occupation,
        pan: vm.currentHolder.jointHolderApplicantDetail.panNumber,
        politicalStatus: vm.currentHolder.jointHolderApplicantDetail.politicalStatus,
        taxStatusCode: vm.currentHolder.jointHolderApplicantDetail.taxStatusCode,
        jointHolderName: vm.currentHolder.jointHolderName ? vm.currentHolder.jointHolderName : vm.currentHolder.jointHolderApplicantDetail.firstName,
        kycverified: vm.currentHolder.kycverified,
        mobileDeclaration : vm.currentHolder.jointHolderApplicantDetail.mobileBelongsTo ? vm.currentHolder.jointHolderApplicantDetail.mobileBelongsTo : ''
      };
      vm.jointHolderDetails.grossAnnualIncome = vm.currentHolder.jointHolderApplicantDetail.grossAnnualIncome;
      if (vm.jointHolderDetails.grossAnnualIncome) {
        vm.jointHolderDetails.grossAnnualIncome = vm.jointHolderDetails.grossAnnualIncome.toString();
      }
    }

    vm.getGrossAnnualIncomeDateOfHolder = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.jointHolderDetails.netWorthDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
          vm.notolderthan1year = false;
        }
        else {
          vm.jointHolderDetails.netWorthDate = "";
          MessageService.error('Not older than 1 year');
          vm.notolderthan1year = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.GROSS_ANNUAL_INCOME;
        vm.jointHolderDetails.netWorthDate = "";
      }
      return;
    }

    vm.addFirstHolderData = function () {
      vm.sameFirstHoderDetails = !vm.sameFirstHoderDetails;
      if (vm.sameFirstHoderDetails == true) {
        vm.fistHolder = vm.holders[0];
        if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.fistHolder.fatcaDetail.payTaxInIndia = true;
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.fistHolder.fatcaDetail.payTaxInIndia = false;
        }

        if (vm.fistHolder.netWorthDate) {
          vm.networth = true;
        } else {
          vm.networth = false;
        }
        if (vm.fistHolder.politicalStatus == 'NONE') {
          vm.fistHolder.politicalStatus = 'NONE';
          vm.jointHolderTaxDetails_politicalStatus = 'No';
        } else {
          vm.jointHolderTaxDetails_politicalStatus = 'Yes';
          vm.fistHolder.politicalStatus = 'POLITICAL';
        }
        var taxData = vm.fistHolder.fatcaDetail.fatcaTax1;

        vm.jointHolderDetails = {
          email: vm.fistHolder.email,
          fatcaDetail: {
            birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
            birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
            payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
            addressType: vm.fistHolder.fatcaDetail.addressType,
            countryCitizenship: "",
            fatcaTax1: taxData,
            secondTax: false,
            thirdTax: false
          },
          grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
          netWorth: vm.fistHolder.netWorth,
          netWorthDate: vm.fistHolder.netWorthDate,
          occupationCode: vm.fistHolder.occupationCode,
          pan: vm.currentHolder.pan,
          politicalStatus: vm.fistHolder.politicalStatus,
          taxStatusCode: vm.fistHolder.taxStatusCode,
          jointHolderName: vm.currentHolder.jointHolderName,
          kycverified: vm.fistHolder.kycverified
        };

      } else {
        vm.fistHolder = vm.holders[1];
        if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.currentHolder.fatcaDetail.payTaxInIndia = true;
        } else {
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.currentHolder.fatcaDetail.payTaxInIndia = false;
        }
        if (vm.fistHolder.netWorthDate) {
          vm.networth = true;
        } else {
          vm.networth = false;
        }
        if (vm.fistHolder.politicalStatus == 'NONE') {
          vm.jointHolderTaxDetails_politicalStatus = 'No';
          vm.fistHolder.politicalStatus = 'NONE';
        } else {
          vm.jointHolderTaxDetails_politicalStatus = 'Yes';
          vm.fistHolder.politicalStatus = 'POLITICAL';
        }
        var taxData1 = vm.fistHolder.fatcaDetail.fatcaTax1;

        vm.jointHolderDetails = {
          email: vm.fistHolder.email,
          fatcaDetail: {
            birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
            birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
            payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
            addressType: vm.fistHolder.fatcaDetail.addressType,
            countryCitizenship: "",
            fatcaTax1: taxData1,
            secondTax: false,
            thirdTax: false
          },
          grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
          netWorth: vm.fistHolder.netWorth,
          netWorthDate: vm.fistHolder.netWorthDate,
          occupationCode: vm.fistHolder.occupationCode,
          pan: vm.currentHolder.pan,
          politicalStatus: vm.fistHolder.politicalStatus,
          taxStatusCode: vm.fistHolder.taxStatusCode,
          jointHolderName: vm.currentHolder.jointHolderName,
          kycverified: false
        };
      }
    }

    function getfolioDetails(resp) {
        if (resp) {
          vm.folioDetails = resp;
          taxStatus();
          getCountryList();
          getTaxIdType();
          occupation();
          incomeSlab();
          addressType();
          sessionStorage.setItem('folioDetails', JSON.stringify(vm.folioDetails));
          vm.holders = resp.jointHolders;
          vm.getholdersdata(0);
          LoaderService.hideLoader();
          fetchBelongsToDropdown();
        }
    }

    vm.approve = function () {
      var success = function () {
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.actionTaken = true;
            var message = 'Your request for approval has been submitted successfully.';
            ModalService.successMessageModal({ message: message, hideOKButton: true }, successFolioApprove);
            // MessageService.success('Your request for approval has been submitted successfully.')
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                panErrorText: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        var formData = vm.folioDetails;
        formData.linkId = $stateParams.uuid;
        formData.changed = false;

        var currentJointHolder = {
          "jointHolderName": vm.currentHolder.jointHolderName,
          "email": vm.currentHolder.email,
          "citizenship": vm.currentHolder.citizenship,
          "kycverified": vm.currentHolder.kycverified,
          "jointHolderApplicantDetail": {
            "nameTitle": vm.currentHolder.nameTitle,
            "firstName": vm.currentHolder.firstName,
            "middleName": vm.currentHolder.middleName,
            "lastName": vm.currentHolder.lastName,
            "taxStatusCode": vm.jointHolderDetails.taxStatusCode,
            "occupation": vm.jointHolderDetails.occupationCode,
            "panNumber": vm.currentHolder.panNumber,
            "grossAnnualIncome": vm.currentHolder.grossAnnualIncome,
            "netWorth": vm.currentHolder.netWorth,
            "netWorthDate": vm.currentHolder.netWorthDate,
            "politicalStatus": vm.jointHolderTaxDetails_politicalStatus == 'No' ? 'NONE' : 'POLITICAL',
            "fatcaAddressType": vm.jointHolderDetails.fatcaDetail.addressType,
            "payTaxInIndia": vm.jointHolderDetails.fatcaDetail.payTaxInIndia,
            "payOutsideIndiaAddresses": [
              {
                "countryName": vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry,
                "taxIdType": vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType,
                "taxIdNumber": vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxId,
                "taxPayingCity":vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity
              }
            ],
            "birthCity": vm.jointHolderDetails.fatcaDetail.birthPlace,
            "dob": vm.currentHolder.dob,
            "birthCountry": vm.jointHolderDetails.fatcaDetail.birthCountry,
            "minor": vm.currentHolder.minor,
            "minorAgeProof": vm.currentHolder.minorAgeProof,
            "gender": vm.currentHolder.gender,
            "email": vm.currentHolder.email,
            "mobileNo": vm.currentHolder.mobileNo,
            "name": vm.currentHolder.name,
            "emailBelongsTo":  vm.jointHolderDetails.emailDeclaration,
            "mobileBelongsTo":  vm.jointHolderDetails.mobileDeclaration,
            "nriFlag": vm.currentHolder.nriFlag
          }
        };
        formData.jointHolders = [];
        formData.jointHolders.push(currentJointHolder);
        var payload = {
          "soleApplicantDetail": vm.folioDetails.soleApplicantDetail,
          "jointHolders": [
            {
              "firstName": vm.currentHolder.jointHolderApplicantDetail.firstName,
              "middleName": vm.currentHolder.jointHolderApplicantDetail.middleName,
              "lastName": vm.currentHolder.jointHolderApplicantDetail.lastName,
              "dOB": vm.currentHolder.jointHolderApplicantDetail.dob,
              "gender": vm.currentHolder.jointHolderApplicantDetail.gender,
              "pan": vm.currentHolder.jointHolderApplicantDetail.panNumber,
              "email": vm.currentHolder.email,
              "mobileNumber": vm.currentHolder.mobileNo,
              "validPan": true,
              "occupationCode": vm.jointHolderDetails.occupationCode,
              "grossAnnualIncome": vm.currentHolder.jointHolderApplicantDetail.grossAnnualIncome,
              "politicalStatus": vm.jointHolderTaxDetails_politicalStatus == 'No' ? 'NONE' : 'POLITICAL',
              "taxStatusCode": vm.jointHolderDetails.taxStatusCode,
              "fatcaDetail": {
                "birthCountry": vm.jointHolderDetails.fatcaDetail.birthCountry,
                "birthPlace": vm.jointHolderDetails.fatcaDetail.birthPlace,
                "payTaxInIndia": vm.jointHolderDetails.fatcaDetail.payTaxInIndia,
                "addressType": vm.jointHolderDetails.fatcaDetail.addressType,

              },
              "kycverified": vm.folioDetails.investorPanDetails.kycverified? "Y":"N",
              "mobileDeclaration": vm.jointHolderDetails.mobileDeclaration,
              "emailDeclaration": vm.jointHolderDetails.emailDeclaration,
              "nriFlag": vm.currentHolder.nriFlag
            }
          ],
          "nominees": vm.folioDetails.nominees,
          "guardianDetail": vm.folioDetails.guardianDetails,
          "brokerCode": "DIRECT",
          "holdmode": vm.folioDetails.holdMode,
          "id": vm.folioDetails.id,
          "linkId": vm.folioDetails.holderLinkId,
          "uniqueLink": vm.uniqueLink,
          "nriFlag": vm.folioDetails.nriFlag
        }
        payload.soleApplicantDetail.personalDetail = {
              "firstName": vm.folioDetails.soleApplicantDetail.firstName,
              "middleName": vm.folioDetails.soleApplicantDetail.middleName,
              "lastName": vm.folioDetails.soleApplicantDetail.lastName
            } ;

            if(!vm.jointHolderDetails.fatcaDetail.payTaxInIndia){
              payload.jointHolders[0].fatcaDetail.fatcaTax1 ={
                "countryName": vm.taxOutsidePayCountry.countryName,
                "taxIdType": vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType,
                "taxIdNumber": vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxId,
                "taxPayingCity":vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity
              }
              payload.jointHolders[0].fatcaDetail.fatcaTax2 ={}
              payload.jointHolders[0].fatcaDetail.fatcaTax3 ={}
            }else{
              payload.jointHolders[0].fatcaDetail.fatcaTax1 ={}
              payload.jointHolders[0].fatcaDetail.fatcaTax2 ={}
              payload.jointHolders[0].fatcaDetail.fatcaTax3 ={}
            } 
        ChangeDividendService.post2({
          child1: 'v1',
          child2: 'folio',
          child3: 'any-or-survivor',
          child4: 'distributorNewInvestor',
          child5: 'approve',
          child6: 'holder',
          child7: vm.folioDetails.holderLinkId
        }, payload).$promise.then(successFolioApprove, errorFolioApprove);

    },dismiss = function () {};
      var msg = "Are you sure, you want to approve your details?";
      ModalService.confirmCancelModal({ Text: msg }, success, dismiss);
    }
    vm.reject = function () {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var message = 'Your request for rejection has been submitted successfully.';
              ModalService.successMessageModal({message:message,hideOKButton:true},success);
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            "id":vm.holderLinkId,
            "reason":  respModal.reason ? respModal.reason : 'Rejected',
            "linkId": vm.holderLinkId
        };
          LoaderService.showLoader();
          ChangeDividendService.post({
            child1: 'v1',
            child2: 'folio',
            child3: 'any-or-survivor',
            child4: 'distributorNewInvestor',
            child5: 'reject',
            child6: 'holder'
        }, payload).$promise.then(successFolioReject, errorFolioReject);
        }, dismissReason = function () {
        };
        ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);

      }, dismiss = function () {
      };
      var msg = "Are you sure, you want to reject<br/>'Folio Creation?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }
    function taxStatus() {
      var successTaxStatus = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
        }
        else {
          MessageService.error(resp.message);
        }
      },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var payloadTaxStatus = {
        id: vm.holderLinkId,
        taxStatusFilter: vm.folioDetails.soleApplicantDetail.minor ? 'MINOR' : 'ADULT',
        nriFlag: vm.folioDetails.jointHolders[0].nriFlag? vm.folioDetails.jointHolders[0].nriFlag: null
      };
      InvestorsService.post({ controller: 'tax-status', child1: 'holder' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    function occupation() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        id: vm.holderLinkId
      }

      InvestorsService.post({ controller: 'get-occupation', child1: 'holder' }, payload).$promise.then(success, error);
    }
    function incomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        id: vm.holderLinkId
      }
      InvestorsService.post({ controller: 'income', child1: 'slab', child2: 'holder' }, payload).$promise.then(success, error);
    }
    function addressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressType = resp.data.addressTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: vm.holderLinkId
      };
      InvestorsService.post({ controller: 'address', child1: 'type', child2: 'holder' }, payload).$promise.then(success, error);
    }
    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
          if (vm.folioDetails.jointHolders[0].jointHolderApplicantDetail.payOutsideIndiaAddresses.length != 0) {
            var taxPayingCountrycode = vm.folioDetails.jointHolders[0].jointHolderApplicantDetail.payOutsideIndiaAddresses[0].countryName;
            vm.countries.forEach(function (item) {
              if (item.countryCode === taxPayingCountrycode) {
                vm.taxOutsidePayCountry = item;
              }
            });
          }
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countries = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: vm.holderLinkId
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'holder'
      }, payload).$promise.then(success, error);
    }
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorsService.post({
        controller: 'taxId-type',
        child1: 'holder'
      }, { "id": vm.holderLinkId }).$promise.then(success, error);
    }

    function fetchBelongsToDropdown(cb) {
      cb = cb ||function () {
      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.holders  = {};
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
        cb();
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
        LoaderService.hideLoader();
        cb();
      };
      InvestorServiceDynamicData.get({child1: 'contactType',child2: 'details'}).$promise.then(success, error);
    }

  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BasicMinorController', BasicMinorController);

  /** @ngInject */
  function BasicMinorController(InvestorsService, $stateParams, FileUploadService, ModalService, HDFC_API, $state, $window, AppConstants, LoaderService, $rootScope, NewInvestorServiceV3, MessageService, $timeout, NewInvestorFolioServiceV1) {
    var vm = this;
    $rootScope.folioBasicDetail = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicMinorDetail = {}
    $rootScope.folioBasicMinorDetail.Fatca = {};
    $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.minorFormData = {}
    vm.uuid = $stateParams.uuid;
    vm.tempData = {
      "id": "07b8577c-1df0-4e80-8cc0-622b0303e9d0",
      "investorPanDetails": {
        "name": "NISHANT KUMAR",
        "pan": "CCEPK0828G",
        "minor": false,
        "email": null,
        "mobileNumber": null,
        "emailExists": false,
        "ekycStatus": null,
        "message": null,
        "kycverified": true
      },
      "uuid": null,
      "approved": null,
      "arnCode": "ARN-0411",
      "distributorName": "Richa Tripathi",
      "reason": null,
      "chequeLeafUrl": "dev/ARN-0411/CCEPK0828G/ChequeLeaf/bg_profile36b26a23-02ef-4153-ae18-0860b974f88f",
      "soleApplicantDetail": {
        "nameTitle": null,
        "firstName": "test",
        "middleName": null,
        "lastName": "",
        "taxStatusCode": "02",
        "occupation": null,
        "panNumber": null,
        "grossAnnualIncome": null,
        "netWorth": null,
        "netWorthDate": null,
        "politicalStatus": null,
        "fatcaAddressType": "RESIDENTIAL",
        "payTaxInIndia": null,
        "payOutsideIndiaAddresses": [],
        "birthCity": null,
        "dob": "28-Aug-2022",
        "birthCountry": null,
        "minor": true,
        "minorAgeProof": "dev/ARN-0411/CCEPK0828G/MinorProof/bg_profile4217a7d2-8115-4639-8d6c-e3d573630481",
        "gender": "MALE",
        "email": "NIS2011KUMAR@GMAIL.COM",
        "mobileNo": "8527014446",
        "name": null,
        "emailBelongsTo": null,
        "mobileBelongsTo": null
      },
      "jointHolders": null,
      "nominees": null,
      "bankDetails": {
        "accountType": "SB",
        "accountNumber": "05014150000457",
        "bankName": "Bank of India",
        "bankBranch": "JINTI",
        "branchLocation": "JINTI",
        "rtgsCode": null,
        "payoutMechanism": "DC",
        "bankHolderType": "MINOR",
        "accountHolderName": null,
        "pennyDropValid": false,
        "micrnumber": "",
        "ifsccode": "BKID0000740"
      },
      "guardianDetails": {
        "relationship": "FATHER",
        "kycStatus": true,
        "citizenship": null,
        "basicDetails": {
          "nameTitle": null,
          "firstName": null,
          "middleName": null,
          "lastName": null,
          "taxStatusCode": "02",
          "occupation": "7",
          "panNumber": "CCEPK0828G",
          "grossAnnualIncome": 32,
          "netWorth": null,
          "netWorthDate": null,
          "politicalStatus": "NONE",
          "fatcaAddressType": "RESIDENTIAL",
          "payTaxInIndia": true,
          "payOutsideIndiaAddresses": [],
          "birthCity": "MUMBAI",
          "dob": "12-Jan-1988",
          "birthCountry": "IN",
          "minor": false,
          "minorAgeProof": null,
          "gender": null,
          "email": null,
          "mobileNo": null,
          "name": null,
          "emailBelongsTo": null,
          "mobileBelongsTo": null
        },
        "guardianRelationshipProofUrl": "dev/ARN-0411/CCEPK0828G/GuardianProof/bg_profile596bbd23-f143-40a2-a2a1-715017b735a1"
      },
      "holdMode": "SINGLE"
    };

    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.minorFormData.minorsFullName = '';
    $rootScope.myState = $state.current.url;
    vm.minorFormData.dob = 'dd-mmm-yyyy';
    vm.minorFormData.gender = '';
    vm.minorFormData.ageproofType = '';
    vm.minorFormData.ageproofimageurl = '';
    vm.minorFormData.ageproofimageName = '';
    vm.minorFormData.taxstatus = '02';
    vm.genderObj = [{ name: 'Male', value: 'MALE' }, { name: 'Female', value: 'FEMALE' }];
    vm.taxStatus = [];
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    $rootScope.folioBasicDetail.folioForUser = $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.UserData = {};
    vm.UserData.panNumber = 'BXVPS3619C';//delete

    vm.minorFormData.minorsFullName = vm.tempData.soleApplicantDetail.firstName;
    vm.minorFormData.dob = vm.tempData.soleApplicantDetail.dob;
    vm.minorFormData.gender = vm.tempData.soleApplicantDetail.gender;
    vm.minorFormData.ageproofimageName = vm.tempData.soleApplicantDetail.minorAgeProof;
    vm.getTaxStatus = function () {
      var successTaxStatus = function (resp) {
        vm.taxStatus = resp.data.taxStatus;
      },
        errorTaxStatus = function () {
          MessageService.error("Error in minor tax status!");
        };
      var payloadTaxStatus = {
        id: vm.uuid,
        taxStatusFilter: 'MINOR'
      };
      InvestorsService.post({ controller: 'tax-status', child1: 'investor' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    vm.getTaxStatus();


    vm.chooseFolioFor = function (foliofor) {
      if (foliofor == 'Self') {
        $rootScope.folioBasicMinorDetail.folioForUser = 'Self';
        vm.showPopUp = true;
      }
      else {
        $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
      }
    }

    vm.getMinordob = function (date) {
      vm.MINOR_DOB_ERROR = false;
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.minorFormData.dob = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.age < 18) {
          // console.log(vm.age);
          //console.log(moment(date).format("DD-MMM-YYYY"));
          vm.MINOR_DOB_ERROR = false;
        }
        else {
          vm.MINOR_DOB_ERROR = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }
    vm.getProofType = function () {
      var success = function (resp) {
        vm.minorAgeProofType = resp.data.proofTypeDTOList;
      },
        error = function () {
          MessageService.error("Error in proof type list!");
        };
      InvestorsService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
    }
    // vm.getProofType();

    vm.getMinorAgeProofImage = function (file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file.size < 2000000) {
        vm.minorFormData.ageproofimageName = file.name;
        var modalSuccess = function () {
          var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + vm.UserData.panNumber + '/MINOR_PROOF';
          LoaderService.showLoader();
          FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.minorFormData.ageproofimageurl = resp.data.fileUrl;
              try {
                const file = resp.data.fileUrl;
                const fileName = file.split("/");
                vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
              } catch (e) { }
              localStorage.setItem('folioId', resp.data.uuid);
            } else {
              MessageService.error(resp.message);
            }
          }, function () {
            LoaderService.hideLoader();
          });

        },
          modalError = function () {
            MessageService.error("file not upload");
          };
        ModalService.imagePreviewModal({ file: file }, modalSuccess, modalError);
      }
      else {
        MessageService.error("File size should not be more than 2 MB.")
      }

    }


    vm.getNewUserDetails = function () {
      try {
        var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.folioCreationDraftId) {
              localStorage.setItem("folioId", resp.data.folioCreationDraftId);
              vm.getOldFoliData();
            } else {
              vm.initiatFirstFolio();
              vm.getOldFoliData();
            }

          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (error) {
            MessageService.error(error.message);
          };
        var uContext = JSON.parse(sessionStorage.getItem("userData"));
        var taxIdentifier = uContext.pan;
        var payload = {
          "panNumber": taxIdentifier,
          "arnCode":tokenData.arnCode
        }
        InvestorsService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
      } catch (e) { }
    }
    vm.getNewUserDetails();
    vm.showPopUp = false;

    vm.getOldFoliData = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        $timeout(function () { }, 1000);
        if (resp.status && resp.data) {
          if (resp.data.minor == false) {
            vm.isMinor = false;
            vm.showPopUp = true;
          } else {
            vm.isMinor = true;
            $rootScope.showSaveTag = true;
            $timeout(function () {
              $rootScope.showSaveTag = false;
            }, 3000);

            sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
            var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
            var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
            if (isEditbuttonClick) {
              $rootScope.setProgress();
              sessionStorage.removeItem("investorIsEditButtonClick");
            } else {
              if (resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick) {
                $state.go('newInvestor.folioDetails.baiscMinorDetails');
              } else if (resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick) {
                $state.go('newInvestor.folioDetails.guardianMinorDetails');
              } else if (resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick) {
                $state.go('newInvestor.folioDetails.bankdetails');
              }
            }

            vm.currentPayload = resp.data;
            vm.minorFormData.minorsFullName = resp.data.soleApplicantDetail.personalDetail.firstName;
            vm.minorFormData.dob = resp.data.soleApplicantDetail.personalDetail.dateOfBirth;
            vm.minorFormData.gender = resp.data.soleApplicantDetail.personalDetail.gender;
            vm.minorFormData.ageproofType = resp.data.soleApplicantDetail.minorDetail.minorProofType;
            vm.minorFormData.ageproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
            try {
              const file = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
              const fileName = file.split("/");
              vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
            } catch (e) { }
            vm.minorFormData.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
          }
        } else {
          if (resp.message == "Invalid Folio State") {
            vm.initiatFirstFolio();
            vm.getOldFoliData();
          }
        }
      }, error = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      };
      LoaderService.showLoader();
      var investorId = localStorage.getItem("folioId");
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'getDetails' }, { id: investorId }).$promise.then(success, error);
    }


    vm.gotoSelf = function () {
      if (!vm.isMinor) {
        vm.showPopUp = false;
        $state.go('newInvestor.folioDetails.baiscDetails');
      }
      else {
        vm.deleteCurrentFolio();
        vm.showPopUp = false;
        $state.go('newInvestor.folioDetails.baiscDetails');
      }

    }

    vm.deleteCurrentFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status) {
          MessageService.success("Successfully delete folio draft data.");
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var uuid = localStorage.getItem("folioId");
      NewInvestorFolioServiceV1.post({ child1: 'new',child2: 'user', child3: 'delete', child4: 'draft', child5: 'folio', child6: uuid},{}).$promise.then(success, error);
    }
    vm.stayWithMinor = function () {
      if (!vm.isMinor) {
        vm.deleteCurrentFolio();
        vm.initiatFirstFolio();
        vm.showPopUp = false;
      }
      else {
        vm.showPopUp = false;
      }
      $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    }


    vm.submitMinorBsicDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
          $rootScope.minornext(0);
          $state.go('newInvestor.folioDetails.guardianMinorDetails');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };

      $window.smartech('dispatch', 'folio basic details', {
        'creatingfoliofor': 'Minor',
        'modeofholding': 'SINGLE',
        'taxinindia': vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia,
        'pepstatus': vm.currentPayload.soleApplicantDetail.minorDetail.guardian.politicalStatus
      });

      vm.currentPayload.minor = true;
      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.minorStep = "FIRST";
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.newUserFlow = true;
      // vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia = true;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorAgeProof = vm.minorFormData.ageproofimageurl;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorProofType = vm.minorFormData.ageproofType;
      vm.currentPayload.soleApplicantDetail.personalDetail.firstName = vm.minorFormData.minorsFullName;
      vm.currentPayload.soleApplicantDetail.personalDetail.dateOfBirth = vm.minorFormData.dob;
      vm.currentPayload.soleApplicantDetail.personalDetail.gender = vm.minorFormData.gender;
      vm.currentPayload.soleApplicantDetail.personalDetail.taxStatusCode = vm.minorFormData.taxstatus;
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.currentPayload).$promise.then(success, error);
    }

    vm.initiatFirstFolio = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData', { 'userFolioBackState': 'BACK_ROUTE4' });
          localStorage.setItem("folioId", resp.data.id);
          vm.getOldFoliData();
        } else {
          MessageService.error(error.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'initiate' }, vm.payloadData).$promise.then(success, error);
    }
    vm.autoDate = function () {
      var oldlength = 0;
      if (vm.dobString) {
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if (vm.dobString.length == 2) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
      if (vm.dobString.length == 5) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
    }

    vm.payloadData = {
      soleApplicantDetail: {
        minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
            panNumber: null,
            occupation: null,
            taxStatusCode: null,
            grossAnnualIncome: null,
            politicalStatus: null,
            netWorth: null,
            netWorthDate: null,
            kycVerified: null,
            name: null,
            gender: null,
            panValid: null,
            relation: null,
            fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: true,
              addressType: null,
              fatcaTax1: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              }
            },
            guardianRelationshipProofUrl: null
          }
        },
        selfDetail: null,
        personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
        }
      },
      nominees: null,
      holdmode: "SINGLE",
      minor: true,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow: true
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BanksController', BanksController);

  /** @ngInject */
  function BanksController($window, $stateParams, $rootScope, $state, HDFC_API, FileUploadService, LoaderService, AppConstants, MessageService, NewInvestorServiceV3, ModalService, UtilService, InvestorsService, InvestorsCommonService,$log,InvestorModel) {
    var vm = this;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankAccountType = [];
    vm.bankAccountDetailsForm = {};
    vm.bankAccountDetailsForm.bankDetails = {};
    vm.folioCreationProcess = sessionStorage.getItem('folioCreationProcess');
    vm.folioNumber = localStorage.getItem('folioNumber');
    vm.isContactUpdate = $stateParams.contact;
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    if(vm.folioCreationProcess == 'Completed' && vm.folioNumber && vm.folioDetails.folioWithoutTransaction == 'N'){
      $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
      // $window.location.href ="http://localhost:3000/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
    }
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    if (vm.folioDetails) {
      if(JSON.parse(sessionStorage.getItem('folioBank'))){
        vm.folioDetails.bankDetails = JSON.parse(sessionStorage.getItem('folioBank'));
        vm.bankAccountDetailsForm.branchLocation = vm.folioDetails.bankDetails.bankBranch;
        if (vm.folioDetails.bankDetails.chequeLeaf) {
          vm.showcheckLeaf = true;
          const fileName = vm.folioDetails.bankDetails.chequeLeaf.split("/");
          vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
          vm.bankchequeLeafUrl = vm.folioDetails.bankDetails.chequeLeaf;
        } else {
          if(vm.folioDetails.soleApplicantDetail.minor || vm.folioDetails.soleApplicantDetail.taxStatusCode == 24  || vm.folioDetails.soleApplicantDetail.taxStatusCode == 21 ){
            vm.showcheckLeaf = true;
          }else{
            vm.showcheckLeaf = false;
          }
          vm.bankAccountDetailsForm.chequesleafImageUrl = "";
        }
      }else{
        vm.bankAccountDetailsForm.branchLocation = vm.folioDetails.bankDetails.bankBranch;
        if (vm.folioDetails.chequeLeafUrl) {
          vm.showcheckLeaf = true;
          vm.bankAccountDetailsForm.chequesleafImageUrl = vm.folioDetails.chequeLeafUrl;
          const fileName =  vm.bankAccountDetailsForm.chequesleafImageUrl.split("/");
          vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
          vm.bankchequeLeafUrl = vm.folioDetails.chequeLeafUrl;
        } else {
          if(vm.folioDetails.soleApplicantDetail.minor || vm.folioDetails.soleApplicantDetail.taxStatusCode == 24  || vm.folioDetails.soleApplicantDetail.taxStatusCode == 21 ){
            vm.showcheckLeaf = true;
          }else{
            vm.showcheckLeaf = false;
          }
          vm.bankAccountDetailsForm.chequesleafImageUrl = "";
        }
      }
      vm.bankAccountDetailsForm.ifscCode = vm.folioDetails.bankDetails.ifsccode;
      vm.bankAccountDetailsForm.accountType = vm.folioDetails.bankDetails.accountType;
      vm.bankAccountDetailsForm.bankDetails.payoutMechanism = vm.folioDetails.bankDetails.payoutMechanism;
      vm.bankAccountDetailsForm.accountNumber = vm.folioDetails.bankDetails.accountNumber;
      vm.bankAccountDetailsForm.pennyDropValid = vm.folioDetails.bankDetails.pennyDropValid;
      vm.bankAccountDetailsForm.bankName = vm.folioDetails.bankDetails.bankName;
      vm.bankAccountDetailsForm.bankCity = vm.folioDetails.bankDetails.bankCity;
      vm.bankAccountDetailsForm.accountNumberverify = '';
      vm.userTaxStatusCode = vm.folioDetails.soleApplicantDetail.taxStatusCode;
    }
    vm.showValidateBtn = false;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.getBankcAccountType = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          $rootScope.AccountTypes = resp.data.bankAccountTypes;
        }
        else {
          vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };

        InvestorsService.get({
          child1: 'bank',
           child2: 'account-type',
           child3: 'list',
           child4: vm.userTaxStatusCode
       }).$promise.then(success, error);
    }
    vm.getBankcAccountType();
    vm.getPayoutMechanism = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payoutMechanismList = resp.data.payoutMechanisms;
          $rootScope.payoutMechanismData = resp.data.payoutMechanisms;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };
      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism',
        child2: 'investor'
      }, {
        id: vm.folioDetails.holderLinkId
      }).$promise.then(success, error);
    }
    vm.getPayoutMechanism();

    vm.matchAccountNumber = function () {
      if (vm.bankAccountDetailsForm.accountNumber === vm.bankAccountDetailsForm.accountNumberverify) {
        vm.showValidateBtn = true;
      } else {
        vm.showValidateBtn = false;
      }
    }

    vm.fetchBankList = function () {
      var success = function (res) {
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;

        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorsCommonService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
    }
    vm.fetchBankList();

    vm.selectIFSC = function () {
      var successModal = function (data) {
        vm.bankAccountDetailsForm.ifscCode = data.ifscCode;
        vm.bankAccountDetailsForm.bankName = data.bankName;
        vm.bankAccountDetailsForm.bankCity = data.branchCity;
        vm.bankAccountDetailsForm.branchLocation = data.branch;

        if (data.branch && data.branch.length > 40)
          vm.bankAccountDetailsForm.bankBranch = data.branch.slice(0, 40)
        else vm.bankAccountDetailsForm.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.userTaxStatusCode === '01') {
          vm.bankAccountDetailsForm.pennyDropValid = true;
        }
        else {
          vm.bankAccountDetailsForm.pennyDropValid = false;
        }
        vm.bankAccountDetailsForm.accountType = "SB";
        vm.bankAccountDetailsForm.bankDetails.payoutMechanism = "DC";
        vm.bankAccountDetailsForm.accountNumber = '';
        vm.bankAccountDetailsForm.accountNumberverify = '';
        vm.bankAccountDetailsForm.chequesleafImageUrl = '';
        if(vm.folioDetails.soleApplicantDetail.minor || vm.folioDetails.soleApplicantDetail.taxStatusCode == 24  || vm.folioDetails.soleApplicantDetail.taxStatusCode == 21 ){
          vm.showcheckLeaf = true;
        }else{
          vm.showcheckLeaf = false;
        }
        vm.showValidateBtn = true;
      },
        errorModal = function () {

        };
      ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList }, successModal, errorModal);
    }

    vm.submitBankAccountDetails = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.valid === false) {
            MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
            vm.bankAccountDetailsForm.pennyDropValid = false;
            vm.showcheckLeaf = true;
            vm.showValidateBtn = false;
          } else {
            vm.bankAccountDetailsForm.pennyDropValid = true;
            vm.showcheckLeaf = false;
            vm.bankAccountDetailsForm.accountHolderName = resp.data.name;
            vm.continueFolio();
          }
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },
        error = function () {
          LoaderService.hideLoader();
        };

      var pennyDropValidatePayload = {
        "beneficiaryIFSC": vm.bankAccountDetailsForm.ifscCode,
        "benificiaryAccountNo": vm.bankAccountDetailsForm.accountNumber,
        "benificiaryName": vm.folioDetails.investorPanDetails.name,
        "arncode" : vm.folioDetails.arnCode,
        "panNo": vm.folioDetails.investorPanDetails.pan
      };
      if(vm.bankAccountDetailsForm.accountNumber === vm.folioDetails.bankDetails.accountNumber && vm.folioDetails.bankDetails.pennyDropValid){
        vm.bankAccountDetailsForm.pennyDropValid = true;
        vm.bankAccountDetailsForm.accountHolderName = vm.folioDetails.bankDetails.accountHolderName;
        vm.continueFolio();
      }else{
        LoaderService.showLoader();
        InvestorsCommonService.post({
          child1: 'account',
          child2: 'validate',
          child3: 'pennyDrop'
        }, pennyDropValidatePayload).$promise.then(success, error);
      }
    }


    vm.continueFolio = function () {
      vm.bankDetailsData = {
        accountHolderName: vm.bankAccountDetailsForm.accountHolderName ? vm.bankAccountDetailsForm.accountHolderName : vm.folioDetails.investorPanDetails.name,
        pennyDropValid: vm.bankAccountDetailsForm.pennyDropValid,
        bankHolderType: vm.folioDetails.soleApplicantDetail.minor ? 'MINOR' : 'INVESTOR',
        accountType: vm.bankAccountDetailsForm.accountType,
        payoutMechanism: vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
        accountNumber: vm.bankAccountDetailsForm.accountNumber,
        verifyAccountNumber: vm.bankAccountDetailsForm.accountNumberverify,
        ifsccode: vm.bankAccountDetailsForm.ifscCode,
        bankName: vm.bankAccountDetailsForm.bankName,
        bankCity: vm.bankAccountDetailsForm.bankCity,
        chequeLeaf: vm.bankchequeLeafUrl,
      }
      if(vm.bankDetailsData && vm.bankDetailsData.pennyDropValid){
        vm.bankDetailsData.chequeLeaf = '';
      }else{
        vm.bankDetailsData.chequeLeaf = vm.bankchequeLeafUrl;
      }
      vm.bankDetailsData.bankBranch = vm.bankAccountDetailsForm.branchLocation;
      sessionStorage.setItem('folioBank', JSON.stringify(vm.bankDetailsData));
      if (vm.isContactUpdate) {
        $state.go('newinvestorApprove.folio.summary',{
          contact : true
        });
      } else {
        $state.go('newinvestorApprove.folio.summary');
      }
    }
    vm.submitWithCheckLeaf = function () {
      vm.bankDetailsData = {
        accountHolderName: vm.folioDetails.investorPanDetails.name,
        pennyDropValid: vm.bankAccountDetailsForm.pennyDropValid,
        bankHolderType: vm.folioDetails.soleApplicantDetail.minor ? 'MINOR' : 'INVESTOR',
        accountType: vm.bankAccountDetailsForm.accountType,
        payoutMechanism: vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
        accountNumber: vm.bankAccountDetailsForm.accountNumber,
        verifyAccountNumber: vm.bankAccountDetailsForm.accountNumberverify,
        ifsccode: vm.bankAccountDetailsForm.ifscCode,
        bankName: vm.bankAccountDetailsForm.bankName,
        bankCity: vm.bankAccountDetailsForm.bankCity,
        bankBranch : vm.bankAccountDetailsForm.branchLocation
      }
      if(vm.bankDetailsData && vm.bankDetailsData.pennyDropValid){
        vm.bankDetailsData.chequeLeaf = '';
      }else{
        vm.bankDetailsData.chequeLeaf = vm.bankchequeLeafUrl;
      }
      sessionStorage.setItem('folioBank', JSON.stringify(vm.bankDetailsData));
      if (vm.isContactUpdate) {
        $state.go('newinvestorApprove.folio.summary',{
          contact : true
        });
      } else {
        $state.go('newinvestorApprove.folio.summary');
      }
    }


    vm.bankUploadChequeLeafFile = function (file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var modalSuccess = function () {
            var taxIdentifierNumber = vm.folioDetails.investorPanDetails.pan;
            var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/CHEQUE_LEAF/' + $stateParams.uuid;
            LoaderService.showLoader();
            FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                try {
                  const fileName = vm.bankchequeLeafUrl.split("/");
                  vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
                } catch (e) { }
                breakFileUrl(vm.bankchequeLeafUrl);
              } else {
                MessageService.error(resp.message)
              }
            }, function () {
              LoaderService.hideLoader();
            });
          },
            modalError = function () {

            };

          ModalService.imagePreviewModal({ file: file }, modalSuccess, modalError);
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.bankchequeLeafUrl = url;
      return;
    }

    vm.openUploadedDoc = function () {
      if(vm.bankchequeLeafUrl){
        vm.isInvestor = false;
        var demo = vm.bankchequeLeafUrl.split('/');
        demo.forEach(function (item){
          if(item == $stateParams.uuid){
            vm.isInvestor = true;
          }
        })
        if(vm.isInvestor){
          vm.previewChequeleaf = vm.bankchequeLeafUrl;
        }else{
          vm.previewChequeleaf= HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + "/investor/image/open/"+vm.folioDetails.holderLinkId+"/CHEQUE_LEAF?"+performance.now();
        }
      }
      if (angular.isUndefined(vm.previewChequeleaf)) { return; }
      ModalService.imagePreviewModal({ showOnly: true, file: vm.previewChequeleaf });
    }
    vm.rejectTransaction = function () {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              $state.go('newinvestorApprove.folio.reject');
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: $stateParams.uuid,
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId: vm.folioDetails.holderLinkId,
            uniqueLink : $stateParams.uuid,
            newUserFlow:true
          };
          LoaderService.showLoader();
          InvestorsService.post({
            controller: 'folio',
            child1: 'details',
            child2: 'reject'
          }, payload).$promise.then(successFolioReject, errorFolioReject);
        }, dismissReason = function () {
        };
        ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);
      }, dismiss = function () {
      };
      var msg = "Are you sure, you want to reject<br/>'Folio Creation?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
  }
  vm.clearFileSelection = function(){
    angular.element('input[type="file"]').val(null);
  }

  vm.editAccountNumber = function(){
    if(vm.folioDetails.soleApplicantDetail.minor || vm.folioDetails.soleApplicantDetail.taxStatusCode == 24  || vm.folioDetails.soleApplicantDetail.taxStatusCode == 21 ){
      vm.showcheckLeaf = true;
    }else{
      vm.showcheckLeaf = false;
    }
  }
  }
})();

(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('SchemeInvestmentController', SchemeInvestmentController);

  /** @ngInject */
  function SchemeInvestmentController($state) {
    var vm = this;
    $state.go('main.newinvestor.investmentDetails.select-scheme.scheme');
    // $state.go('main.newinvestor.investmentDetails.select-scheme.goal');
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestmentModeController', InvestmentModeController);

  /** @ngInject */
  function InvestmentModeController($window, ChangeDividendService, DistributorProfileService, $filter, $state, UtilService, InvestorServiceDynamicData, $rootScope, $stateParams, $scope, toastr, AuthService, HDFC_API, LoaderService,
    AppConstants, InvestorsService, $location, $timeout, TransactionService, MessageService, ModalService) {
    var vm = this;
    vm.investmentTypeList = ['SIP', 'Lumpsum'];
    vm.investingThroughList = ['Distributor'];
    vm.EUINList = ['EUIN', 'EUIN Declaration'];
    vm.SelectedInvestmentType = 'SIP';
    vm.SelectedInvestingThrough = 'Distributor';
    vm.euintempData = {};
    vm.init = init;
    vm.inSearchSchemeName = '';
    vm.subBrokerCode = '';
    vm.subBrokerARN = '';
    vm.investmentARN = '';
    vm.saveDraftPayload = {};
    vm.investmentValidation = {};
    vm.searchARN = false;
    vm.togglesubBrokerCode = false;
    $rootScope.currentstate = $state.current.url;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.tForm = {};
    vm.investmentModeDetailsForm = {};
    vm.brokerCodeError = '';
    vm.inSchemeList = [];
    vm.investmentModeDetailsForm.SelectedInvestmentType = 'SIP';
    vm.investmentModeDetailsForm.accountNumber = '';
    vm.brokerName = '';
    vm.setGetDraftData = setGetDraftData;
    vm.fetchEuinList = fetchEuinList;
    vm.distributorName = '';
    vm.distributorARN = '';
    vm.distributorList = null;
    vm.isCheckedTandC = false;
    vm.investmentEUNIList = null;
    vm.euinData = {};
    vm.euin = {};
    vm.subBrokerName = '';
    var identifierData = AuthService.getToken();
    vm.investorDetails = JSON.parse(sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].panNumber = vm.investorDetails.pan;
      $rootScope.testObj.steps[0].investorName = vm.investorDetails.name;
    init();
    vm.getconformation = function () {
      vm.isCheckedTandC = !vm.isCheckedTandC;
    }
    getEuinCodes();
    function getEuinCodes() {
      LoaderService.showLoader("getEuinList");
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.investmentEUNIList = resp.data.euinList;
        } else {
          vm.euinList = null;
        }
        LoaderService.hideLoader("getEuinList");
      }, error = function () {
        LoaderService.hideLoader("getEuinList");
        vm.euinList = null;
      };
      TransactionService.get({ VERSION: HDFC_API.VERSION, controller: 'getEuin' }).$promise.then(success, error);
    }
    function init() {
      vm.saveDraftPayload = {};
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[2].stepCompleted = false;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepActive = true;
      $rootScope.testObj.steps[2].stepActive = false;
      // $rootScope.testObj.steps[0].stepCompleted = true;
      // $rootScope.testObj.steps[1].stepCompleted = true;
      // $rootScope.testObj.steps[2].stepCompleted = false;
      // $rootScope.testObj.steps[0].stepActive = false;
      // $rootScope.testObj.steps[1].stepActive = false;
      // $rootScope.testObj.steps[2].stepActive = true;

    }
    vm.chooseInvestmentType = function (InvestmentType) {
      vm.SelectedInvestmentType = InvestmentType;
    }
    vm.chooseInvestmentThrough = function (InvestmentThrough) {
      vm.SelectedInvestingThrough = InvestmentThrough;
    }
    vm.disabledDistributtonAlert = function (data) {
      if (data == 'Distributor') {
        MessageService.error("For direct scheme distributor is not allowed.");

      }
    }
    vm.disableAlertSIPLumbsum = function (data) {
      if (data == 'PURCHASE') {
        MessageService.error("For this scheme lumpsum is not allowed.");
      }
      if (data == 'SIP') {
        MessageService.error("For this scheme sip is not allowed.");
      }
    }
    vm.filterInSchemeList = function () {
      vm.inSearchSchemeCode = '';
      vm.authenticationMode = null;
      vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSearchSchemeName);
    };
    // setDraftData
    function setGetDraftData() {
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.saveDraftPayload = resp.data;
          vm.investmentValidation.purchaseEnabled = vm.saveDraftPayload.purchaseEnabled;
          vm.investmentValidation.sipEnabled = vm.saveDraftPayload.sipEnabled;
          if (vm.saveDraftPayload && !vm.saveDraftPayload.sipEnabled && !vm.saveDraftPayload.purchaseEnabled) {
            MessageService.error("For this scheme sip & lumpsum is not allowed.");
            vm.SelectedInvestmentType = null;
          } else if (vm.saveDraftPayload && !vm.saveDraftPayload.sipEnabled) {
            MessageService.error("For this scheme sip is not allowed.");
            vm.SelectedInvestmentType = "PURCHASE";
          } else if (vm.saveDraftPayload && !vm.saveDraftPayload.purchaseEnabled) {
            MessageService.error("For this scheme lumpsum is not allowed.");
            vm.SelectedInvestmentType = "SIP";
          } else {
            vm.SelectedInvestmentType = vm.saveDraftPayload.investmentType ? vm.saveDraftPayload.investmentType : vm.SelectedInvestmentType;
          }
          //  $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
          $rootScope.testObj.steps[1].schemeName = resp.data.schemeName;
          vm.SelectedInvestingThrough = 'Distributor';
          vm.investmentARN = vm.saveDraftPayload.brokerCode;

          vm.subBrokerARN = vm.saveDraftPayload.subBrokerArn ? vm.saveDraftPayload.subBrokerArn.split('-')[1] : '';
          if(vm.subBrokerARN){
            vm.fetchEuinListSubBroker();
          }
          vm.subBrokerCode = vm.saveDraftPayload.subBrokerCode;
          if (vm.saveDraftPayload.euinOpted == "Y") {
            vm.euinData = {};
            vm.euinData.euinCode = vm.saveDraftPayload.euinCode;
            vm.euinData.euinName = vm.saveDraftPayload.euinName;
          }else{
            vm.euinData = {};
          }
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      var Details = JSON.parse(sessionStorage.getItem("userData"));
      var arnCode = identifierData.arnCode;
      var Data = {};
      Data.id = Details.transactionDraftId;
      Data.arnCode = arnCode;
      ChangeDividendService.post({
        child1: 'v2',
        child2: 'distributorNewInvestor',
        child3: 'saved',
        child4: 'draft'
      }, Data).$promise.then(success, error);
    }
    // vm.searchDistributorByName = function () {
    //   if ((!vm.distributorName) || (vm.distributorName && vm.distributorName.length < 3)) {
    //     vm.distributorList = null;
    //     vm.investmentEUNIList = null;
    //     return;
    //   }
    //   fetchARNByName();

    // };
    // function fetchARNByName() {

    //   if ((!vm.distributorName) || (vm.distributorName && vm.distributorName.length < 3)) {
    //     return;
    //   }
    //   LoaderService.showLoader("fetch-arn");
    //   var success = function (resp) {
    //     if (resp.status && resp.data) {
    //       vm.distributorList = resp.data.distributorList;
    //       if (vm.distributorList.length == 0) {
    //         vm.isInvalidForm = true;
    //         vm.euin = {};
    //         vm.isCheckedTandC = false;
    //       }
    //       vm.formData.brokerName = resp.data.distributorName;
    //     } else {
    //       vm.distributorList = null;
    //       MessageService.error(resp.message);
    //     }
    //     LoaderService.hideLoader("fetch-arn");
    //   },
    //     error = function (err) {
    //       LoaderService.hideLoader("fetch-arn");
    //       vm.distributorList = null;
    //       UtilService.errorHandler(err);
    //     };
    //   TransactionService.get({
    //     controller1: 'getDistributor',
    //     controller2: vm.distributorName
    //   }).$promise.then(success, error);
    // }

    vm.inSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        if (vm.inSearchSchemeCode !== schemeData.schemeCode) { //block responsible to reset all values if scheme code doesn't match
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.day = '';
          vm.formData.bankInfo = null;
          //vm.formData.frequency = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? vm.frequencyList[0].key : null;
          vm.enabledStartDates = null;
          vm.enabledEndDates = null;
          vm.formData.amount = '';
          vm.formData.sipFirstAmount = '';
          vm.formData.units = '';
          vm.formData.amountType = 'amount';
          vm.formData.isTillPerpetuity = false;
          vm.formData.showTopUpBlock = false;
          vm.formData.sipTopupEnabled = false;
          vm.disableEndDateSelection = false;
          vm.formData.weeklyDay = null;
          vm.backFromPayment = false;
          vm.formData.sipFirstInstallment = false;
          vm.sipFirstInstallment = false;
          resetTopupDetails();
          changeSipTopupSelected(false);
          reSetting();
          resetDefaults();
          resetNumInWords();
        }

        if (!vm.backFromPayment)
          vm.formData.sipDividendOption = null;

        vm.inSearchSchemeCode = schemeData.schemeCode;
        vm.inSearchSchemeName = schemeData.scheme;
        vm.formData.schemeType = schemeData.schemeType;
        vm.inSchemeList = UtilService.getFilteredList(vm.masterInSchemeList, 'scheme', vm.inSearchSchemeName);
        checkEMandate(function () {
        });
        fetchInSchemeValidations(function () {
          vm.validations.investmentOption = vm.validations.investmentOption;
          if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            getDateValidation();
            if (schemeData.schemeType === 'NFO') {
              var message = schemeData.message;
              ModalService.nfoEnabledModal({ message: message });
            }
            checkEMandate();
          }
          if (vm.checkForMinorBankListCondition()) {
            vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if (vm.isOTMEnabled) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            else {
              vm.formData.sipPaymentOption = null;
            }
            getDetails();
          }
          else if (vm.isOTMEnabled || !vm.checkForMinorBankListCondition()) {
            if (vm.formData.frequency === 'BZ' || vm.formData.frequency === 'OW')
              if (vm.isOTMEnabled) vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
              else vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            else
              vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM, vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE];
            if (!vm.formData.sipPaymentOption) {
              vm.formData.sipPaymentOption = vm.paymentOptions[0];
            }
            checkEMandate();
          }
          else {
            vm.formData.sipPaymentOption = null;
            vm.paymentOptions = [];
          }
          checkValidations();
          if (vm.formData.bankInfo) {
            vm.changeBank();
            updateEndDates();
            vm.changeEndDate(vm.formData.endDate);
          }
        });
      }
      NetcoreEvntService.Complete_Selected_Scheme_SIP_IP(vm.formData);
    };

    vm.next = function () {
      var identifier = AuthService.getToken();
      vm.saveDraftPayload.brokerCode =  identifier.arnCode;
        vm.saveDraftPayload.euinCode = vm.euinData.euinCode;
        vm.saveDraftPayload.euinName = vm.euinData.euinName;
        vm.saveDraftPayload.euinNameCode = vm.euinData.euinName + vm.euinData.euinCode;
        vm.saveDraftPayload.euinOpted = vm.saveDraftPayload.euinCode ? "Y" : "";
      var transactionDetails = JSON.parse(sessionStorage.getItem("userData"));
      vm.saveDraftPayload.investmentType = vm.SelectedInvestmentType.toUpperCase();
      vm.saveDraftPayload.id = transactionDetails.transactionDraftId;
      vm.saveDraftPayload.step = "SECOND";
      vm.saveDraftPayload.brokerCode = identifierData.arnCode;
      if(vm.subBrokerARN) {
        vm.saveDraftPayload.subBrokerArn = 'ARN-'+vm.subBrokerARN;
      }
      vm.saveDraftPayload.subBrokerCode = vm.subBrokerCode;
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.data && resp.status) {
            $rootScope.testObj.steps[1].schemeInfo.investmentType = vm.SelectedInvestmentType;
            if(vm.SelectedInvestmentType == "PURCHASE"){
              $rootScope.testObj.steps[1].frequency = '';
            }
            $rootScope.stepperSecondary.steps[0].stepActive = false;
            $rootScope.stepperSecondary.steps[0].stepCompleted = true;
            $rootScope.stepperSecondary.steps[1].stepActive = false;
            $rootScope.stepperSecondary.steps[1].stepCompleted = true;
            $rootScope.stepperSecondary.steps[2].stepActive = true;

            $state.go('main.newinvestor.investmentDetails.amount');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      ChangeDividendService.post({
        child1: 'v2',
        child2: 'distributorNewInvestor',
        child3: 'save',
        child4: 'transaction'
      }, vm.saveDraftPayload).$promise.then(success, error);
    }
    vm.distributorListChanged = function (data) {
      if (!data) {
        // vm.isArnSuccess = true;
        return;
      } else {
        vm.brokerCodeError = '';
        vm.distributorARN = data.arnCode;
        vm.distributorName = data.name + ' - ' + data.arnCode;
      }
    };
    function fetchEuinList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.brokerCodeError = '';
          vm.isArnSuccess = false;
          vm.brokerName = resp.data.distributorName;
          vm.investmentEUNIList = resp.data.euinList;
          if (vm.investmentEUNIList) {
            var td = $filter('filter')(vm.investmentEUNIList,
              {
                euinCode: vm.euintempData.euinCode
              });
            vm.euinData = {};
            vm.euinData = td[0];
            if (!vm.euinData.euinCode) {
              vm.isCorrectEuin = false;
            } else {
              vm.isCorrectEuin = true;
            }
          }
          //vm.isInvalidForm = false;
        } else {
          vm.brokerCodeError = resp.message;
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.investmentEUNIList = null;
          UtilService.errorHandler(err);
        };

      var path = {};
      path = {
        controller1: 'getEuin',
        controller2: vm.distributorData.kydInformation.arnCode
      };
      TransactionService.get(path).$promise.then(success, error);
    }
    vm.filterEuinList = function () {
      vm.euin = {};
      if (vm.euinData.euinNameCode) {
        if (vm.euinData.euinNameCode.length >= 3) {
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.euinData.euinNameCode);
        }
      }
      vm.euinList = vm.euinData.euinNameCode == '' || vm.euinData.euinNameCode == undefined || vm.euinData.euinNameCode.length < 3 ? vm.euinMasterList : vm.euinList;
    };
    vm.selectEuin = function (data) {
      if (!data) {
        return;
      }
      vm.investmentEUNIList.forEach(function (value) {
        if (value.euinCode == data) {
          vm.euinData = value;
        }
      });
    }

    vm.fetchEuinListSubBroker = function () {
      if (!vm.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        vm.euinData = {};
        vm.brokerProcess = false;
        vm.subBrokerCode = "";
        getEuinCodes();
        return;
      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.euinMasterList = resp.data.euinList;
          vm.euinList = vm.euinMasterList;
          vm.investmentEUNIList = vm.euinMasterList;
          if (vm.euinData) {
            for (var i = 0; i < vm.euinList.length; i++) {
              if (vm.euinData.euinNameCode === vm.euinList[i].euinNameCode) {
                vm.euin = vm.euinList[i];
                break;
              } else {
                vm.euin = {};
              }
            }
          } else {
            vm.euin = {};
          }
          // vm.euinData = vm.euin;
          vm.subBrokerName = resp.data.distributorName;
          vm.subBrokerCodeError = '';
          vm.isSubarnSuccess = false;
        } else {
          vm.euinList = null;
          vm.investmentEUNIList = null;
          vm.subBrokerCodeError = resp.message;
          vm.isSubarnSuccess = true;
          vm.euin = {};
          MessageService.error(resp.message);
        }
      },
        error = function () {
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }
    vm.brokerProcess = false;
    vm.changeSubBrokerArn = function () {
      if (vm.subBrokerARN) {
        vm.brokerProcess = true;
      } else {
        vm.brokerProcess = false;
      }
      vm.isCheckedTandC = false;
      vm.subBrokerName = '';
    }
    vm.checksubbrokercode = function () {
      if (vm.subBrokerCode) {
        vm.brokerProcess = false;
      } else {
        vm.brokerProcess = true;
      }
    }
    vm.changeinvestmentARN = function () {
      vm.isCheckedTandC = false;
      vm.brokerName = '';
    }
  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('AmountDetailsController', AmountDetailsController);

    /** @ngInject */
    function AmountDetailsController($window,SchemeService,InvestorsCommonService,TransactionInitiateModel,ChangeDividendService,InvestorsService, UtilService, $state, $timeout, $rootScope, $stateParams,HDFC_API, LoaderService,AppConstants, MessageService,AuthService,ModalService,InvestorServiceDynamicData) {
      var vm = this;
      vm.stage = 0;
      vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
      vm.AppConstantsData = angular.copy(AppConstants);
      vm.transactionType = getTransactionTypeFromStateParams() || getTransactionType();
      vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
      vm.formData.showTopUpBlock = false;
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.isReseting = false;
      vm.PAYMENT_MODE =  [];
      vm.upiBankList = null;
      vm.init = init;
      vm.newAmountInWords = '';
      // vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      vm.paymentOptions = {
        EC : "EC"
      };
      vm.PaymentOptionDescription ={};
      vm.PaymentOptionDescription.EC = "Standing Instruction/Biller"
      vm.ispurchseMinAmount = false;
      vm.purchseSchemeValidationData = {};
      vm.capAmountChanged = capAmountChanged;
      vm.changeSipTopupSelected = changeSipTopupSelected;
      vm.getTopupFrequencyList = getTopupFrequencyList;
      vm.sipFirstInstallment = false;
      vm.saveDraftPayload = {};
      $rootScope.currentstate = $state.current.url;
      vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
      vm.viewMode = 'days';
      vm.dividenInevstmentOption = "Y";
      vm.changeTopUpFreq = changeTopUpFreq;
      vm.checkSipValidations = checkSipValidations;
      vm.checkPurchseAmountValidations = checkPurchseAmountValidations;
      vm.inSchemeValidations = null;
      vm.extractValidationObject = extractValidationObject;
      vm.frequency = vm.AppConstantsData.NEW_INVESTOR_JOURNY;
      vm.updateEndDates = updateEndDates;
      vm.changedPaymentOption = changedPaymentOption;
      vm.changeFrequency = changeFrequency;
      vm.enabledStartDates = null;
      vm.SelectedFrequency = null;
      vm.validations = {};
      var identifierData = AuthService.getToken();
      vm.investorDetails = JSON.parse(sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].panNumber = vm.investorDetails.pan;
      $rootScope.testObj.steps[0].investorName = vm.investorDetails.name;
      vm.showTopUpPercentage = vm.AppConstantsData.SET_TOP_UP_PERCENTAGE_VIEW;
      vm.showAmtExceedMsg = showAmtExceedMsg;
      vm.isDpNewInv ="Y"
      function getTransactionTypeFromStateParams() {
        return $stateParams.transactionType;
      }
      function resetTopupDetails() {
        vm.formData.topupDetails = {};
      }
      function capAmountChanged() {
        vm.amountInWords = '';
        if (vm.formData.topupDetails.amount) {
          vm.minCapAmount = vm.formData.amount + vm.formData.topupDetails.amount;
        }
        else if (vm.formData.topupDetails.percentage) {
          vm.minCapAmount = vm.formData.amount + (vm.formData.topupDetails.percentage * vm.formData.amount / 100)
        }

        if (vm.formData.topupDetails.capAmount && (vm.formData.topupDetails.capAmount < vm.minCapAmount)) {
          vm.isminCapAmount = true
        }
        else {
          vm.isminCapAmount = false
        }
      }
      function changeSipTopupSelected() {
        vm.formData.sipTopupEnabled = !vm.formData.sipTopupEnabled;
        if(!vm.formData.sipTopupEnabled){
          resetTopupDetails();
        }
        if (!vm.formData.isBackFromSummary) {
          vm.formData.sipTopupSelected = vm.formData.sipTopupEnabled;
        }
        if (vm.formData.sipPaymentOption === 'OTM' && ((vm.formData.bankInfo && vm.formData.bankInfo.otmFrequency) !== 'AWP')) {
          vm.formData.sipTopupSelected = false;
          vm.formData.sipTopupEnabled = false;
          MessageService.error(vm.VALIDATE_DATA.OTM_VALIDATION_ERROR);
        }
        else if (vm.formData.bankInfo && vm.isOTMAmount) {
          vm.formData.sipTopupSelected = false;
          vm.formData.sipTopupEnabled = false;
          MessageService.error(vm.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ERROR);
        }
        getTopupFrequencyList();
      }
     $(function(){
      $('#selectbank option:selected').text('Select bank');
     })

      function init(cb) {
        vm.fetchDynamicData('NEW_INVESTOR_JOURNEY');
        vm.formData.sipPaymentOption = 'EC';
        vm.formData.paymentMode = "WEB";
        $rootScope.testObj.steps[0].stepCompleted = true;
        $rootScope.testObj.steps[1].stepCompleted = true;
        $rootScope.testObj.steps[2].stepCompleted = false;
        $rootScope.testObj.steps[0].stepActive = false;
        $rootScope.testObj.steps[1].stepActive = false;
        $rootScope.testObj.steps[2].stepActive = true;
        LoaderService.showLoader();
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        var arnCode = identifierData.arnCode;
        var Data = {};
        Data.id = Details.transactionDraftId;
        Data.arnCode = arnCode;
        var success = function (resp) {
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            $rootScope.testObj.steps[1].schemeName = resp.data.schemeName;
            $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;
            $rootScope.testObj.steps[1].schemeInfo.amount = resp.data.amount;
            vm.saveDraftPayload = resp.data;
            if(vm.saveDraftPayload.topUpEnable == true){
              getTopupFrequencyList();
            }
            // $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
            // $rootScope.testObj.steps[1].schemeName = resp.data.fundName;
            switch(resp.data.installmentFrequency){
              case'OM':
                 $rootScope.testObj.steps[1].frequency = "Monthly";
                 break;
              case 'Q':
                $rootScope.testObj.steps[1].frequency = "Quarterly";
                break;
                case'H':
                 $rootScope.testObj.steps[1].frequency = "Half Yearly";
                 break;
              case 'Y':
                $rootScope.testObj.steps[1].frequency = "Yearly";
                break;
            }
            vm.formData.inSchemeCode = vm.saveDraftPayload.schemeCode;
            vm.sipFirstInstallment = vm.saveDraftPayload.sipFI;
            vm.formData.amount = vm.saveDraftPayload.amount;
            $timeout(function(){if(vm.formData.amount){
              if(vm.saveDraftPayload.investmentType == "PURCHASE"){
                $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
              }
            }},1000)

            if(vm.frequency){
              vm.frequency.forEach(function (value) {
                  if (value.code == vm.saveDraftPayload.installmentFrequency) {
                    vm.SelectedFrequency = value;
                  }
              });
            }
            if (vm.saveDraftPayload.topUpEnable) {
              vm.formData.sipTopupSelected = true;
              vm.formData.sipTopupEnabled = true;
              if (vm.saveDraftPayload.topUpDetails.amount) {
                vm.formData.topupDetails.amount = vm.saveDraftPayload.topUpDetails.amount;
                delete vm.saveDraftPayload.topUpDetails.percentage;
              } else {
                vm.formData.topupDetails.percentage = vm.saveDraftPayload.topUpDetails.percentage;
                delete vm.saveDraftPayload.topUpDetails.amount;
              }
              if (vm.saveDraftPayload.topUpDetails.capAmount) {
                vm.formData.topupDetails.capAmount = vm.saveDraftPayload.topUpDetails.capAmount;
                delete vm.saveDraftPayload.topUpDetails.capMonthYear;
              } else {
                var d = vm.saveDraftPayload.topUpDetails.capMonthYear.split("-");
                vm.formData.topupDetails.capMonthYear = d[1]+"-"+d[2];
                delete vm.saveDraftPayload.topUpDetails.capAmount;
              }
              // vm.saveDraftPayload.topUpDetails.diffInMonths = vm.formData.topupDetails.diffInMonths;
              vm.formData.topupDetails.frequency = vm.saveDraftPayload.topUpDetails.frequency;
            }
            vm.dividenInevstmentOption = vm.saveDraftPayload.dividendOption;
            if(vm.saveDraftPayload.investmentOption && vm.saveDraftPayload.investmentOption.toUpperCase() != 'GROWTH'){
              if(!vm.saveDraftPayload.dividenInevstmentOption){
                vm.dividenInevstmentOption = 'Y';
              }
            }
            vm.formData.investmentOption = vm.saveDraftPayload.investmentOption;
            $rootScope.stepperSecondary.steps[0].stepActive = false;
            $rootScope.stepperSecondary.steps[0].stepCompleted = true;
            $rootScope.stepperSecondary.steps[1].stepActive = false;
            $rootScope.stepperSecondary.steps[1].stepCompleted = true;
            $rootScope.stepperSecondary.steps[2].stepActive = true;
            if(vm.saveDraftPayload && vm.saveDraftPayload.paymentOption){
              vm.formData.sipPaymentOption = vm.saveDraftPayload.paymentOption;
            }else{
              vm.formData.sipPaymentOption = 'EC';
            }
            if(vm.saveDraftPayload.investmentType == "SIP"){
              vm.PAYMENT_MODE = [{key: 'WEB', value: 'Net Banking'}];
              if(vm.sipFirstInstallment){
                if(vm.saveDraftPayload.paymentMode == null){
                  vm.formData.paymentMode = 'WEB'
                }else{
                  vm.formData.paymentMode = vm.saveDraftPayload.paymentMode;
                }
              }
              vm.formData.startDate = $window.moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
              vm.formData.endDate =  $window.moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");
              vm.savedDateSet = true;
              vm.savedDate = angular.copy(vm.saveDraftPayload.installmentStartDate);
              vm.savedEndDate = angular.copy(vm.saveDraftPayload.installmentEndDate);
              vm.savedFrequency = angular.copy(vm.saveDraftPayload.installmentFrequency);
            }
            // vm.formData.startDate = moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
            // vm.formData.endDate =  moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");

            LoaderService.hideLoader();
            if (vm.saveDraftPayload.investmentType && vm.saveDraftPayload.investmentType.toUpperCase() == vm.AppConstantsData.TRANSACTION_FORM_TYPE.PURCHASE) {
              vm.PaymentModePurchse = 'PURCHASE';
              vm.getPurchseSchemeValidationData();
            }
            if (vm.saveDraftPayload.investmentType && vm.saveDraftPayload.investmentType.toUpperCase() == vm.AppConstantsData.TRANSACTION_FORM_TYPE.SIP) {
              vm.PaymentModePurchse = 'SIP';
              vm.getSchemValidationData();
            }
            if(vm.saveDraftPayload.investmentType == "PURCHASE"){
              vm.PAYMENT_MODE = [
                {key: 'WEB', value: 'Net Banking'},
                {key: 'RTGS',value: 'NEFT/RTGS'},
                {key: 'UPI',value: 'UPI'}
              ];
              if(vm.saveDraftPayload.paymentMode == null){
                vm.formData.paymentMode = 'WEB'
              }else{
                vm.formData.paymentMode = vm.saveDraftPayload.paymentMode;
              }
            }
          } else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        vm.processFlag = false;
        ChangeDividendService.post({
            child1:'v2',
            child2:'distributorNewInvestor',
          child3: 'saved',
          child4: 'draft'
        }, Data).$promise.then(success, error);

      }


      vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
      vm.paymentNavUrl = function(){
        $window.open(vm.paymentNavURL);
      }


      // vm.autoDate1 = function(){
      //   vm.dobString = $("#startDate").val();;
      //   if( vm.dobString.length == 2){
      //       $("#startDate").val(vm.dobString+"-");
      //   }
      //   if( vm.dobString.length == 5){
      //       $("#startDate").val(vm.dobString+"-");
      //   }
      // }
      // vm.autoDate2 = function(){
      //   vm.dobString = $("#endDate").val();;
      //   if( vm.dobString.length == 2){
      //       $("#endDate").val(vm.dobString+"-");
      //   }
      //   if( vm.dobString.length == 5){
      //       $("#endDate").val(vm.dobString+"-");
      //   }
      // }




      function changeTopUpFreq() {
        var duration = 6;
        switch (vm.formData.topupDetails.frequency) {
          case 'H': duration = 6; break;
          case 'Y': duration = 12; break;
        }
        if (duration === 12) {
          var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
        }
        else {
          capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
        }

        vm.capDates = [];
        var capLastDate = capStartDate;
        while ($window.moment(capLastDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
          if (vm.capDates.length === 0) {
            vm.capDates.push(capStartDate);
          }
          capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(duration, 'months').format("MMM-YYYY");
          if ($window.moment(capStartDate, "MMM-YYYY").isSameOrBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
            vm.capDates.push(capStartDate);
          }
          else {
            break;
          }
          capLastDate = vm.capDates[vm.capDates.length - 1];
        }
      };
      vm.getAmount = function (condition,amountValue) {
        if(condition){
          vm.formData.amount = amountValue;
        }else{
          vm.formData.amount = amountValue;
          vm.checkSipValidations();
        }
      }
      vm.getPurchseSchemeValidationData = function () {
        if (!vm.formData.inSchemeCode) {
          return;
        }
        LoaderService.showLoader();
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.formData.amountArray = resp.data.amountArray;
            if (!vm.formData.amount) {
              vm.formData.amount = vm.formData.amountArray[0];
            }else{
              vm.formData.amount = vm.formData.amount;
            }

            vm.purchseSchemeValidationData = resp.data;
            vm.changepaymentMode();
            LoaderService.hideLoader();
          }
          else {
            LoaderService.hideLoader();
            vm.inSchemeValidations = null;
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          SchemeService.get({
            controller: 'schemeValidation',
            type: 'purchase',
            child1: vm.formData.inSchemeCode
          }, null).$promise.then(success, error);
    }
      function getTopupFrequencyList() {

        if ((vm.diffInMonths >= 6 && vm.diffInMonths <= 12) || (vm.formData.topupDetails.diffInMonths >= 6 && vm.formData.topupDetails.diffInMonths <= 12)) {
          vm.topupFrequencyList = [
            { key: 'H', value: 'Half Yearly', monthfreq: 6 }
          ];
        } else {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 },
            { key: 'H', value: 'Half Yearly', monthfreq: 6 }
          ];
        }
        vm.formData.topupDetails.frequency = vm.formData.isBackFromSummary ? vm.formData.topupDetails.frequency : null;
        if (vm.formData.topupDetails.percentage) {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 }
          ];
          vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
        } else if (vm.formData.frequency == 'Q' && !vm.formData.topupDetails.percentage) {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 }
          ];
          vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
        } else if (vm.formData.frequency == 'OM') {
          vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
        }
        else {
          vm.topupFrequencyList = [
            { key: 'Y', value: 'Yearly', monthfreq: 12 },
            { key: 'H', value: 'Half Yearly', monthfreq: 6 }
          ];
          vm.formData.topupDetails.frequency = vm.formData.topupDetails.frequency || vm.topupFrequencyList[0].key;
        }

        if (vm.diffInMonths < 12 || vm.formData.topupDetails.diffInMonths < 12) {
          vm.topupFrequencyList = [
            { key: 'H', value: 'Half Yearly', monthfreq: 6 }
          ];
          vm.formData.topupDetails.frequency = vm.topupFrequencyList[0].key;

          vm.hideTopupPercentage = true;
        }
        else if ((vm.diffInMonths >= 12 && vm.formData.frequency !== 'Q') || (vm.formData.topupDetails.diffInMonths >= 12 && vm.formData.frequency !== 'Q')) {
          vm.hideTopupPercentage = false;
          if (vm.formData.topupDetails.percentage) {
            vm.topupFrequencyList = [
              { key: 'Y', value: 'Yearly', monthfreq: 12 }
            ];
            if (vm.formData.sipTopupSelected) {
              changeTopUpFreq();
            }
          } else {
            vm.topupFrequencyList = [
              { key: 'Y', value: 'Yearly', monthfreq: 12 },
              { key: 'H', value: 'Half Yearly', monthfreq: 6 }
            ];
            if (vm.formData.sipTopupSelected) {
              changeTopUpFreq();
            }
          }

        }

      }
      vm.getSchemValidationData = function (cb) {
        cb = cb || function () {
        };
        if (!vm.formData.inSchemeCode) {
          return;
        }
        LoaderService.showLoader();
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.inSchemeValidations = resp.data;
            if (!vm.formData.amount) {
              vm.formData.amount = vm.inSchemeValidations.amountArray[0];
            }else{
              vm.formData.amount = vm.formData.amount;
            }
            if (!vm.SelectedFrequency) {
              vm.SelectedFrequency = vm.frequency[0];
            }
            vm.formData.amountArray = vm.inSchemeValidations.amountArray;
            vm.formData.sipDefaultAmount = vm.inSchemeValidations.sipDefaultAmount;
            vm.formData.frequency = vm.SelectedFrequency.code;
            vm.additionalSipData = vm.inSchemeValidations.additionalValidation;
            vm.formData.sipPaymentOption = 'EC';

            getDateValidation();
            extractValidationObject(vm.inSchemeValidations);
            // fetchBankList();

            LoaderService.hideLoader();
          }
          else {

            LoaderService.hideLoader();
            cb('error');
            vm.inSchemeValidations = null;
            MessageService.error(resp.message);
          }
          // checkValidations();
        },
          error = function (err) {
            LoaderService.hideLoader();
            cb('error');
            vm.inSchemeValidations = null;
            vm.validations.investmentOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.dividendOption = vm.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.GROWTH;
            UtilService.errorHandler(err);
          };
          InvestorsCommonService.get({
            child1: 'new',
            child2: 'schemeValidation',
            child3: 'sip',
            child4:vm.formData.inSchemeCode,
            child5:vm.isDpNewInv
            //  child2: vm.formData.folioNumber
          }, null).$promise.then(success, error);
      }
      function getTransactionType() {
        var transactionType = '';
        switch ($state.current.name) {
          case 'newInvestor.investmentDetails.amountdetails':
            transactionType = vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP;
            break;
          default:
            $state.go('welcome');
            break;
        }
        return transactionType;
      }
      vm.changeTillPerpetuityFlag = function (cb, fromCheckBox) {
        cb = cb || function () {
        };
        // vm.formData.endDate = null;
        vm.formData.isTillPerpetuity = !vm.formData.isTillPerpetuity ;
        vm.resetting = true;
        $timeout(function () {
          vm.resetting = false;
          if (vm.formData.isTillPerpetuity) {
            vm.disableEndDateSelection = true;
            var defaultMonths = null;
            // var endDate = $window.moment(new Date("12/31/2099"));
            var freq = vm.validations && vm.validations.maxInstallments || 0;
            var frequency = vm.frequency.find(function (f) {
              return f.code === vm.formData.frequency;
            }) || {};
            var day = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
            var month = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
            var newEndDate = day + '/'+ (month + 1) +'/2099';
            var endDate = $window.moment(newEndDate, "DD-MM-YYYY");

            switch (vm.formData.frequency) {
              case 'BZ':
                var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
                if(endDateYear > 2099){
                  endDateYear = 2099;
                }
                var newEndDateForDaily = day + '/'+ (month + 1) +'/' + endDateYear;
                vm.formData.endDate = $window.moment(newEndDateForDaily, "DD-MM-YYYY");

                //check end date exists between enabled end dates
                var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                if (!isBetween) {
                  if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                    vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
                  }else {
                    endDateYear = endDateYear - 1;
                    var dailyNewDate = day + '/'+ (month + 1) +'/' + endDateYear;
                    vm.formData.endDate = $window.moment(dailyNewDate, "DD-MM-YYYY");
                  }
                }
                // vm.formData.endDate = endDate;
                break;
              case 'OW':
                // var days = 0;
                // endDate = new Date("12/31/2099");
                var weeklyEndate = (month + 1) + '/'+ '31' +'/2099';
                endDate = new Date(weeklyEndate);
                var startDate = vm.formData.startDate.toDate();
                var weeksDiff = UtilService.getNumberOfWeeks(startDate, endDate);
                vm.formData.endDate = vm.formData.startDate.clone().add(weeksDiff * 7, 'days');
                break;
              default :
                var newday = $window.moment().date();
                var newMonth = $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
                var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
                var endDateCal = $window.moment(newEndDateCal, "DD-MM-YYYY");

                if (!moment(endDateCal).isValid()) {
                  var initialStartDate = vm.formData.startDate.clone().day(1)
                  endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
                }

                // var months = 0;
                defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone().add(frequency, 'months'), $window.moment(endDateCal));
                freq = freq || Math.floor(defaultMonths / frequency.duration);
                freq = vm.validations && vm.validations.maxInstallments ? freq - 1 : freq;
                var months = frequency.duration * freq;
                vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');
                var calculatedEndDateMonth = $window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

                if(calculatedEndDateMonth > month) {
                  var endDateCalculated = angular.copy(vm.formData.endDate);
                  var checkDate = angular.copy(endDateCalculated.set('month', month));

                  var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
                  if (DateisBetween) {
                    vm.formData.endDate = checkDate;
                  }

                }
                break;
            }

            if (vm.validations && vm.validations.maxInstallments) {
              var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
              var EndDatemonth = angular.copy($window.moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
              var EndDateYear = angular.copy($window.moment(lastEndDate, 'DD-MMM-YYYY').year());

              var EndDateCalculatedMonth = angular.copy($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
              var EndDateCalculatedYear = angular.copy($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

              if (EndDateCalculatedYear <= EndDateYear) {
                if (EndDatemonth < EndDateCalculatedMonth) {
                  if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                    EndDateYear = EndDateYear - 1;
                    var newEndDateCheck = day + '/'+ (month + 1) +'/' + EndDateYear;
                    vm.formData.endDate = $window.moment(newEndDateCheck, "DD-MM-YYYY");
                  }
                  var isBetweenCheck = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                  if (!isBetweenCheck) {
                    vm.formData.endDate = angular.copy(lastEndDate);
                  }
                  if (EndDateYear > 2099) {
                    vm.formData.endDate.set('year', 2099);
                  }
                } else if (EndDatemonth === EndDateCalculatedMonth) {
                  if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== $window.moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
                    EndDateYear = EndDateYear - 1;
                    var newEndDateChecking = day + '/'+ (month + 1) +'/' + EndDateYear;
                    vm.formData.endDate = $window.moment(newEndDateChecking, "DD-MM-YYYY");
                  }
                  var isBetweenChecking = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
                  if (!isBetweenChecking) {
                    vm.formData.endDate = angular.copy(lastEndDate);
                  }
                  if (EndDateYear > 2099) {
                    vm.formData.endDate.set('year', 2099);
                  }
                } else {
                  if (EndDateYear > 2099) {
                    vm.formData.endDate.set('year', 2099);
                  }
                }
              } else if ((EndDateCalculatedYear > EndDateYear)) {
                if (EndDateCalculatedYear <= 2099) {
                  vm.formData.endDate.set('year', EndDateYear);
                } else {
                  vm.formData.endDate.set('year', 2099);
                }

              }
            }
            vm.endDateDefaultForPertuity = vm.formData.endDate;
            vm.changeEndDate(vm.formData.endDate);
            cb(true);
          } else {
            if(!vm.savedDateSet){
              vm.formData.endDate = null;
              vm.disableEndDateSelection = false;
            }else {
              if(fromCheckBox){
                vm.formData.endDate = null;
              }
            }
            // vm.formData.startDate && updateEndDates();
          }
        }, 0);
      };

      vm.changeEndDate = function (date) {
        vm.formData.sipTopupSelected = vm.formData.sipTopupSelected ? vm.formData.sipTopupSelected : false;
        vm.formData.sipTopupEnabled = vm.formData.sipTopupEnabled ? vm.formData.sipTopupEnabled : false;
        if(date && vm.endDateDefaultForPertuity) {
          if (vm.endDateDefaultForPertuity.isSame($window.moment(date))) {
            vm.formData.isTillPerpetuity = true;
          } else {
            vm.formData.isTillPerpetuity = false;
          }
        }
        vm.formData.endDate = date ? date : null;
        vm.diffInMonths = parseInt($window.moment(vm.formData.endDate).diff($window.moment(vm.formData.startDate), 'months', true));
        vm.formData.topupDetails.diffInMonths = vm.diffInMonths;
        if (vm.formData.sipPaymentOption != vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          if (!vm.diffInMonths ? false : vm.diffInMonths >= 6 && 'BZ' !== vm.formData.frequency && 'OW' !== vm.formData.frequency && 'H' !== vm.formData.frequency && 'Y' !== vm.formData.frequency) {
            vm.formData.showTopUpBlock = true;
            if (vm.diffInMonths >= 12) {
              var capStartDate = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
              // var capStartDateValue = $window.moment(vm.formData.startDate).add(12, 'months').format("MMM-YYYY");
            }
            else {
              capStartDate = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
              // capStartDateValue = $window.moment(vm.formData.startDate).add(6, 'months').format("MMM-YYYY");
              if (vm.formData.frequency === 'Q') {
                vm.formData.showTopUpBlock = false;
                vm.formData.sipTopupSelected = false;
                vm.formData.sipTopupEnabled = false;
              }
            }

            vm.capDates = [];
            var capLastDate = capStartDate;
            while ($window.moment(capLastDate, "MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
              if (vm.capDates.length === 0) {
                vm.capDates.push(capStartDate);
              }
              // capStartDateValue = $window.moment(capStartDate).add(12, 'months').format("MMM-YYYY");
              capStartDate = $window.moment(capStartDate, "MMM-YYYY").add(12, 'months').format("MMM-YYYY");
              if ($window.moment(capStartDate, "MMM-YYYY").isBefore($window.moment(vm.formData.endDate, "MMM-YYYY"))) {
                vm.capDates.push(capStartDate);
              }
              else {
                break;
              }
              capLastDate = vm.capDates[vm.capDates.length - 1];
            }
          }
          else vm.formData.showTopUpBlock = false;
        }
        (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) && checkOTMAmountAndDate();
      };
      vm.enabledOTMStartDatesList = [];
      vm.enabledBillerStartDatesList = [];


      function getDateValidation(cb) {

        LoaderService.showLoader();
        cb = cb || function () { };
        var success = function (resp) {
          if (resp.status && resp.data) {
            var currentDate = resp.data.currentDate || Date();
            vm.daysList = resp.data.listOfDays;
            var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
            var todayDate = $window.moment(Date.parse(parsedDate));
            var counter = 0;
            // vm.formData.startDate = todayDate;
            vm.nonBusinessDatess = resp.data.nonBuisnessDates;
            if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
            } else if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(vm.inSchemeValidations.sipTDay, 'days');
            } else {
              vm.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(11, 'days');
            }
            vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
            var startDate = todayDate.clone();
            var freq = vm.startMaxDate.diff(todayDate, 'days');
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if (counter < 5) {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') === 0) {
                    isEnable = false;
                  }
                });
              }
              if (isEnable) {
                vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
                counter++;
              }
            }

            vm.startMinDateOTM = vm.enabledOTMStartDatesList[17];
            if(vm.startMinDateOTM && vm.formData.frequency !== 'OW'){
              if (vm.savedDate && !$window.moment(vm.savedDate).isSameOrAfter($window.moment(vm.startMinDateOTM, "DD-MMM-YYYY HH:mm A"))) {
                vm.savedDateSet = false;
                // vm.savedDate = null;
                vm.savedEndDate = null;
                vm.savedFrequency = null;
              }else if(!vm.savedDateSet){
                vm.formData.startDate = angular.copy($window.moment(vm.startMinDateOTM, "DD-MMM-YYYY"));
                updateEndDates();
              }
            }
            vm.isReseting = true;

            LoaderService.hideLoader();
            $timeout(function () {
              vm.isReseting = false;
            });
            cb(true);
          } else {

            LoaderService.hideLoader();
            MessageService.error(resp.message);
            cb(false);
          }
        },
          error = function (err) {

            LoaderService.hideLoader();
            UtilService.errorHandler(err);
            cb(false);
          };
          InvestorsCommonService.get({
            child1: 'nonBusinessDate',
            schemeCode: vm.formData.inSchemeCode
        }).$promise.then(success, error);
      }
      function updateDatesForOthers() {
        LoaderService.showLoader();
        var currentDay = $window.moment();
        currentDay.set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 });
        var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
        updatedDate.set('date', vm.formData.day);
        var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
        var tDays = vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP ? 15 : 10;
        while (_diff < tDays) {
          updatedDate.add(1, 'months').set('date', vm.formData.day);
          _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
        }

        var enabledStartDates = [];
        for (var i = 0; i <= 3; i++) {
          var _date = updatedDate.clone().add(i, 'months');
          _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
          /*  if (HDFC_API.ENV === 'prod' || HDFC_API.ENV === 'beta') {
             if (_diff <= 90) {
               enabledStartDates.push(_date.clone());
             }
           } */
          if (_diff <= 90) {
            enabledStartDates.push(_date.clone());
          }
        }

        vm.enabledStartDates = angular.copy(enabledStartDates);
        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
          calculateMonthsForSip();
        } else {
          // vm.formData.startDate = vm.enabledStartDates[0];
        }
        updateEndDates();
        LoaderService.hideLoader();
      }
      vm.next = function () {
        if (vm.stage === 0) {
          vm.stage = 1;
        }
      }
      function checkPurchseAmountValidations() {
        if (vm.formData.amount < vm.purchseSchemeValidationData.minFirstPurchaseAmt) {
          vm.ispurchseMinAmount = true;
        } else {
          vm.ispurchseMinAmount = false;
        }
        if (vm.formData.amount == "" || vm.formData.amount == null) {
          resetNumInWords();
        } else {
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        }
        vm.changepaymentMode();
      }
      function checkSipValidations(fromTopUp) {
        if (vm.additionalSipData) {
          var newValidation = vm.additionalSipData;
          for (var i = 0; i < newValidation.length; i++) {
            var condition = vm.formData.amount < newValidation[i].min_amount_lower || vm.formData.amount <= newValidation[i].min_amount_upper
            if (!newValidation[i].min_amount_upper) {
              var condition = true;
            }
            if (condition) {
              if (!vm.formData.showTopUpBlock || !vm.formData.sipTopupSelected) {
                if(vm.saveDraftPayload && vm.saveDraftPayload.installmentStartDate && vm.saveDraftPayload.installmentEndDate){
                  // vm.formData.startDate = moment(vm.saveDraftPayload.installmentStartDate, "DD-MMM-YYYY");
                  // vm.formData.endDate =  moment(vm.saveDraftPayload.installmentEndDate, "DD-MMM-YYYY");
                  // vm.formData.startDate = null;
                  // vm.formData.endDate = null;
                }else{
                  // vm.formData.startDate = null;
                  // vm.formData.endDate = null;
                  vm.enabledStartDates = null;
                  vm.enabledEndDates = null;
                  vm.formData.day = null;
                  vm.formData.weeklyDay = null;
                  vm.formData.month = null;
                }
              }
              vm.validations.amountMultiples = newValidation[i].amt_multiples;
              vm.validations.maxAmount = newValidation[i].min_amount_upper;
              vm.validations.minAmount = newValidation[i].min_amount_lower;
              vm.validations.minInstallments = newValidation[i].min_installments;
              break;
            }
          }
        }
        if (vm.unitsDetails) {
          vm.validations.maxAmount = vm.validations.maxAmount > vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        }
        vm.isMax = !!(vm.validations.maxAmount && vm.validations.maxAmount < vm.formData.amount);
        vm.isMin = !!(vm.validations.minAmount && vm.validations.minAmount > vm.formData.amount);
        vm.isTopupMinAmt = !!(vm.validations.topupMinAmt && vm.validations.topupMinAmt > vm.formData.topupDetails.amount);
        vm.isTopupMinPerc = !!(vm.validations.topupMinPercentage && vm.validations.topupMinPercentage > vm.formData.topupDetails.percentage);
        vm.isMultiples = vm.validations.amountMultiples && vm.formData.amount && (vm.formData.amount % vm.validations.amountMultiples === 0) || false;
        vm.isTopUpMultiples = vm.validations.topupAmtMultples && vm.formData.topupDetails.amount && (vm.formData.topupDetails.amount % vm.validations.topupAmtMultples === 0) || false;
        vm.isTopupPercMultiples = vm.validations.topupPercentageMultples && vm.formData.topupDetails.percentage && (vm.formData.topupDetails.percentage % vm.validations.topupPercentageMultples === 0) || false;
        vm.isInvalidForm = vm.formData.amount <= 0 || (vm.formData.amount && (vm.isMax || vm.isMin || (vm.validations.amountMultiples && !vm.isMultiples)));
        if (!vm.isInvalidForm && vm.formData.topupDetails.amount) {
          vm.isInvalidForm = vm.formData.topupDetails.amount <= 0 || (vm.formData.topupDetails.amount && (vm.isTopupMinAmt || (vm.validations.topupAmtMultples && !vm.isTopUpMultiples)));
        }
        checkEMandateValidation();
        if (vm.formData.topupDetails.amount) {
          vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.amount) && $window.NumToWord(vm.formData.topupDetails.amount, 'divDisplayInWords', vm);
        }
        if (vm.formData.topupDetails.capAmount) {
          vm.formData.topupDetails && angular.isDefined(vm.formData.topupDetails.capAmount) && $window.NumToWord(vm.formData.topupDetails.capAmount, 'capAmntDisplayInWords', vm);
        }
        if (!vm.formData.isBackFromSummary) {
          angular.isDefined(vm.formData.topupDetails) && angular.isDefined(vm.formData.topupDetails.capAmount) && (vm.formData.topupDetails.capAmount = vm.formData.topupDetails.capAmount ? vm.formData.topupDetails.capAmount : '');
        }
        if (vm.formData.amount == "" || vm.formData.amount == null) {
          resetNumInWords();
        } else {
          $window.NumToWord(vm.formData.amount, 'divDisplayWords', vm);
        }

        if (vm.sipFirstInstallment)
          vm.formData.sipFirstAmount = vm.formData.amount;
          if(vm.formData.amount >= 2000000){
            vm.amountExceeded = true;
          }else {
            vm.amountExceeded = false;
          }

        if (vm.formData.startDate && !fromTopUp) {
          vm.changeStartDate(vm.formData.startDate, true);
        }
      }


      vm.chooseFrequency = function (frequency) {
        vm.SelectedFrequency = frequency;
        vm.formData.frequency = vm.SelectedFrequency.code;
        vm.enabledStartDates = null;
        extractValidationObject(vm.inSchemeValidations);
      }

      vm.next1 = function () {
        var success = function (resp) {
          if (resp.data && resp.status) {
            var data = resp.data;
            $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[2].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepCompleted = true;
            $rootScope.testObj.steps[1].schemeInfo.amount = vm.formData.amount;
            $rootScope.testObj.steps[1].frequency = vm.updatedFreq;
            $state.go('main.newinvestor.folioCreation.folioDetails');
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        vm.saveDraftPayload.id = Details.transactionDraftId;
        vm.saveDraftPayload.amount = vm.formData.amount;
        if (vm.PaymentModePurchse == "SIP") {
          // vm.saveDraftPayload.netBankingUrl = vm.formData.bankInfo.netBankingUrl;
          // vm.saveDraftPayload.bankName = vm.formData.bankInfo.bankName;
          // vm.saveDraftPayload.bankCode = vm.formData.bankInfo.bankCode;
          vm.saveDraftPayload.installmentFrequency = this.SelectedFrequency.code;
          if (vm.sipFirstInstallment) {
            vm.saveDraftPayload.sipFI = true;
          } else {
            vm.saveDraftPayload.sipFI = false;
          }
          vm.saveDraftPayload.installmentEndDate = vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '';
          vm.saveDraftPayload.installmentStartDate = vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '';
          if (vm.daysList && vm.daysList.length > 0) {
            vm.saveDraftPayload.sipDay = vm.daysList.length;
          }
          if (vm.formData.sipTopupEnabled) {
            vm.saveDraftPayload.topUpDetails = {};
            vm.saveDraftPayload.topUpEnable = true;
            if (vm.formData.topupDetails.amount) {
              vm.saveDraftPayload.topUpDetails.amount = vm.formData.topupDetails.amount;
              delete vm.saveDraftPayload.topUpDetails.percentage;
            } else {
              vm.saveDraftPayload.topUpDetails.percentage = vm.formData.topupDetails.percentage;
              delete vm.saveDraftPayload.topUpDetails.amount;
            }
            if (vm.formData.topupDetails.capAmount) {
              vm.saveDraftPayload.topUpDetails.capAmount = vm.formData.topupDetails.capAmount;
              delete vm.saveDraftPayload.topUpDetails.capMonthYear;
            } else {
              vm.saveDraftPayload.topUpDetails.capMonthYear = "01-"+vm.formData.topupDetails.capMonthYear;
              delete vm.saveDraftPayload.topUpDetails.capAmount;
            }
            // vm.saveDraftPayload.topUpDetails.diffInMonths = vm.formData.topupDetails.diffInMonths;
            vm.saveDraftPayload.topUpDetails.frequency = vm.formData.topupDetails.frequency;
          }
          else {
            vm.saveDraftPayload.topUpEnable = false;
            vm.saveDraftPayload.topUpDetails = {};
          }
          vm.saveDraftPayload.paymentOption = vm.formData.sipPaymentOption;
          if (vm.sipFirstInstallment) {
          vm.saveDraftPayload.paymentMode = vm.formData.paymentMode;
          }

        }
        if(vm.PaymentModePurchse == "PURCHASE"){
          if(vm.saveDraftPayload['paymentOption']){
            delete vm.saveDraftPayload['paymentOption']
          }
          vm.saveDraftPayload.paymentMode = vm.formData.paymentMode;
        }

          vm.investingthrough = 'Distributer'
        // $window.smartech('dispatch', 'investment details', {
        //   'investmenttype': vm.saveDraftPayload.investmentType,
        //   'investingthrough': vm.investingthrough,
        //   'amount': vm.saveDraftPayload.amount,
        //   'ARN': vm.saveDraftPayload.brokerCode ? vm.saveDraftPayload.brokerCode : '',
        //   'subbrokerARN': vm.saveDraftPayload.subBrokerArn ? vm.saveDraftPayload.subBrokerArn : '',
        //   'EUIN': vm.saveDraftPayload.euinCode ? vm.saveDraftPayload.euinCode : '',
        //   'Installmentfrequency': vm.saveDraftPayload.installmentFrequency
        // });
        if(vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH'){
          delete vm.saveDraftPayload.dividendOption;
        }else{
          vm.saveDraftPayload.dividendOption  = vm.dividenInevstmentOption;
        }
        vm.saveDraftPayload.step = "THIRD";
        vm.saveDraftPayload.brokerCode = identifierData.arnCode;
        vm.processFlag = false;
        ChangeDividendService.post({
          child1:'v2',
          child2:'distributorNewInvestor',
          child3: 'save',
          child4: 'transaction'
        }, vm.saveDraftPayload).$promise.then(success, error);
      }
      vm.changeStartDate = function (date, calledFromAmountChanged) {

        if (date && vm.savedDateSet && vm.savedDate) {
          var isSameDate = date.isSame($window.moment(vm.savedDate,"DD-MMM-YYYY HH:mm A"));
          if (!isSameDate) {
            vm.savedDateSet = false;
            // vm.savedDate = null;
            vm.savedEndDate = null;
            vm.savedFrequency = null;
          }
        }

        if(vm.saveDraftPayload){
          vm.saveDraftPayload ={};
        }

        LoaderService.showLoader();
        vm.formData.startDate = date ? date : null;
        vm.formData.day = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
        // vm.formData.endDate = null;
        vm.formData.isTillPerpetuity = false;
        vm.isReseting = true;
        $timeout(function () {
          vm.isReseting = false;
        });
        checkOTMAmountAndDate();
        if(calledFromAmountChanged && !vm.savedDateSet){
          updateEndDates(false, true);
        }else {
          updateEndDates();
        }
        LoaderService.hideLoader();
      };
      function updateEndDates(doNotUpdateEndDate, amountDateCheck) {
        if (!vm.formData.startDate) {
          return;
        }


        var defaultEndDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
        //var defaultEndDate = new Date(2036, 12, 31);
        var defaultMonths = null;
        var endDate = null;
        var enabledEndDates = [];
        var freq = vm.validations && vm.validations.maxInstallments || 0;
        var i = 0;
        var frequency = vm.frequency.find(function (f) {
          return f.code === vm.formData.frequency;
        }) || {};


        switch (vm.formData.frequency) {
          case 'BZ':
            var days = 0;
            endDate = vm.formData.startDate.clone();//.add(minInstallments, 'days');
            defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
            freq = freq || ((defaultMonths * 30) / frequency.duration);
            for (i = 0; i < freq; i++) {
              days = frequency.duration * i;
              enabledEndDates.push(endDate.clone().add(days, 'days'));
            }
            break;
          case 'OW':
            var days = 0;
            defaultEndDate = new Date("12/31/2099");
            freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
            for (i = 0; i <= freq; i++) {
              days = frequency.duration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
            }
            break;
          default:
            var months = 0;
            endDate = vm.formData.startDate.clone().add(frequency, 'months');
            defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
            freq = freq || (defaultMonths / frequency.duration);
            for (i = 0; i < freq; i++) {
              months = frequency.duration * i;
              enabledEndDates.push(endDate.clone().add(months, 'months'));
            }
            break;
        }
        var minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;

        vm.enabledEndDates = enabledEndDates.slice(minInstallments);
        vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
        if (!doNotUpdateEndDate) {
          //vm.formData.endDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
          vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);
        } else {
          //vm.formData.endDate = null;
          vm.formData.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]);

        }

        if (vm.savedDateSet) {
          // var currrentDateCheck = $window.moment();
          var savedEndate = angular.copy($window.moment(vm.savedEndDate,'DD-MMM-YYYY'));
          // var savedStartDate = angular.copy($window.moment(vm.savedDate, 'DD-MMM-YYYY'));
          if(!(($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0])) || (savedEndate.isSame($window.moment(vm.enabledEndDates.length - 1))))){
            vm.savedDateSet = false;
            vm.savedDate = null;
            vm.savedEndDate = null;
            vm.savedFrequency = null;
            vm.formData.endDate = null;
            vm.formData.isTillPerpetuity = false;
            vm.changeTillPerpetuityFlag()
          }else {
            // if(!vm.savedDateSet){
            //   vm.formData.isTillPerpetuity = true;
            // }
            vm.formData.isTillPerpetuity = false;
            vm.changeTillPerpetuityFlag(function () {
              vm.formData.endDate = angular.copy(savedEndate);
              if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
                vm.formData.isTillPerpetuity = true;
              } else {
                vm.formData.isTillPerpetuity = false;
              }
            });
          }
        }else {
          if (amountDateCheck && vm.formData.endDate && (($window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates[0]))) || (vm.formData.endDate.isSame($window.moment(vm.enabledEndDates.length - 1))))) {
            if (vm.formData.endDate.isSame($window.moment(vm.endDateDefaultForPertuity))) {
              vm.formData.isTillPerpetuity = true;
            } else {
              vm.formData.isTillPerpetuity = false;
            }
          }else {
            vm.formData.isTillPerpetuity = false;
            vm.changeTillPerpetuityFlag();
          }
        }


        //reSetting();
      }
      function checkOTMAmountAndDate() {

        vm.isOTMAmount = false;
        vm.isOTMDate = false;
        vm.isOTMStartDate = false;
        vm.isOTMEndDate = false;
        // Check Ammout
        if (vm.formData.amount && vm.formData.bankInfo && (vm.formData.amount > vm.formData.bankInfo.maxAmount)) {
          vm.isOTMAmount = true;
        } else {
          vm.isOTMAmount = false;
        }

        //Compare Start Dates
        if (vm.formData.bankInfo && ($window.moment(vm.formData.bankInfo.omExpiryDate, "DD-MMM-YYYY").isBefore(vm.formData.startDate))) {
          vm.isOTMDate = true;
        }
        else {
          vm.isOTMDate = false;
        }
        //Compare End Dates
        if (vm.formData.bankInfo && vm.formData.bankInfo.omStartDate) {
          if (!(vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omStartDate, 'DD-MMM-YYYY').isSameOrBefore(new Date($window.moment(vm.formData.startDate))))) {
            if (vm.formData.startDate == null) {
              vm.isOTMStartDate = false;
            } else {
              vm.isOTMStartDate = true;
            }
          } else {
            vm.isOTMStartDate = false;
          }
        }

        if (vm.formData.bankInfo && $window.moment(vm.formData.bankInfo.omExpiryDate, 'DD-MMM-YYYY').isBefore(new Date($window.moment((vm.formData.endDate))))) {
          vm.isOTMEndDate = true;
        }
        else {
          vm.isOTMEndDate = false;
        }
        //Check for amount or date
        if (vm.isOTMAmount || vm.isOTMDate || vm.isOTMEndDate) {
          vm.isInvalidForm = true;
        } else {
          vm.isInvalidForm = false;
        }
      }
      function checkEMandateValidation() {
        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          vm.validations.maxAmount = vm.eMandatemaxAmountLimit;
          vm.isMax = !!(vm.validations.maxAmount && vm.formData.amount > vm.validations.maxAmount);
        }
        else vm.isMax = false;
      }
      function extractValidationObject(validationsData, fromHTML) {
        if (!validationsData || !vm.formData.frequency) {
          return;
        }

        vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
        vm.validations.topupAmtMultples = vm.validations.topupAmtMultples || 1;
        vm.validations.topupPercentageMultples = vm.validations.topupPercentageMultples || 1;
        vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
        vm.validations.minInstallments = vm.validations.minInstallments || 0;
        vm.validations.minAmount = vm.validations.minAmount || 0;
        vm.validations.maxAmount = vm.validations.maxAmount || 0;
        vm.validations.topupMinAmt = vm.validations.topupMinAmt || 0;
        vm.validations.topupMinPercentage = vm.validations.topupMinPercentage || 0;
        if (vm.unitsDetails) {
          vm.validations.maxAmount = vm.validations.maxAmount > 0 && vm.validations.maxAmount < vm.unitsDetails.freeValueAmount ? vm.validations.maxAmount : vm.unitsDetails.freeValueAmount;
        }
        switch (vm.formData.frequency) {
          case 'BZ':
            vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
            if (validationsData.additionalValidation.BZ) {
              vm.additionalSipData = validationsData.additionalValidation.BZ;
              vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
            }
            break;
          case 'OW':
            vm.validations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
            if (validationsData.additionalValidation.OW) {
              vm.additionalSipData = validationsData.additionalValidation.OW;
              vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
            }
            break;
          case 'Q':
            vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
            vm.validations.topupMinAmt = validationsData.topupMinAmt;
            vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
            vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
            vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
            if (validationsData.additionalValidation.Q) {
              vm.additionalSipData = validationsData.additionalValidation.Q;
              vm.validations.minAmount = validationsData.additionalValidation.Q[0].min_amount_lower;

            }
            break;
          case 'OM':
            vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
            vm.validations.topupMinAmt = validationsData.topupMinAmt;
            vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
            vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
            vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
            if (validationsData.additionalValidation.OM) {
              vm.additionalSipData = validationsData.additionalValidation.OM;
              vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
            }
            break;
          case 'H':
            vm.additionalSipData = validationsData.additionalValidation.H;
            vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
            break;
          case 'Y':
            vm.additionalSipData = validationsData.additionalValidation.Y;
            vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
            break;
        }
        if (!vm.backFromPayment && !$stateParams.transactionId) {
          if (vm.validations.minAmount > validationsData.sipDefaultAmount) {
            vm.formData.amount = vm.validations.minAmount;
          } else {
            if(vm.saveDraftPayload && !fromHTML){
              vm.formData.amount = vm.formData.amount ? vm.formData.amount : validationsData.sipDefaultAmount;
            }else {
              vm.formData.amount = validationsData.sipDefaultAmount;
            }
          }
        }
        if (vm.additionalSipData) {
          checkSipValidations();
        }
        getDateValidation();

      }
      vm.frequencyData = [
        {
          "name": "Monthly",
          "code": "OM",
          "duration": 1
      },
        {
        "name": "Quarterly",
        "code": "Q",
        "duration": 3
    },
    {
        "name": "Half Yearly",
        "code": "H",
        "duration": 6
    },
    {
        "name": "Yearly",
        "code": "Y",
        "duration": 12
    }];
      function changeFrequency(freq, fromHTML) {
        vm.formData.startDate = null;
        vm.enabledStartDates = null;
        vm.formData.endDate = null;
        vm.enabledEndDates = null;
        vm.formData.day = null;
        vm.formData.weeklyDay = null;
        vm.formData.month = null;
        vm.SelectedFrequency = freq;
        vm.formData.frequency = freq.code;
        if (vm.formData.frequency !== vm.savedFrequency) {
          vm.savedDateSet = false;
          vm.savedDate = null;
          vm.savedEndDate = null;
          vm.savedFrequency = null;
        }
        extractValidationObject(vm.inSchemeValidations, fromHTML);
        vm.updatedFreq = freq.name
      }
      vm.changeFirstInstallment = function (installmentActivated) {
        if (installmentActivated === false) {
          vm.sipFirstInstallment = false;
          vm.formData.sipFirstInstallment = false;
          vm.formData.sipFirstAmount = '';
        } else {
          vm.sipFirstInstallment = true;
          vm.formData.sipFirstInstallment = true;
          vm.formData.sipFirstAmount = vm.formData.amount ? vm.formData.amount : "";
          vm.formData.sipPaymentOption = 'EC';
        }
        if(vm.sipFirstInstallment){
          vm.PAYMENT_MODE = [{key: 'WEB', value: 'Net Banking'}];
        }else{
          vm.PAYMENT_MODE = [];
        }
        vm.formData.startDate = angular.copy(vm.startMinDateOTM);
        vm.formData.isTillPerpetuity = false;
        vm.changeTillPerpetuityFlag()
      }

      // function fetchBankList(cb) {
      //   cb = cb || function () {
      //   };
      //   LoaderService.showLoader();
      //   var success = function (resp) {
      //     LoaderService.hideLoader();
      //     if (resp.status && resp.data) {
      //       if (vm.formData.sipPaymentOption == 'EC') {
      //         vm.ECbankList = resp.data.bankList;
      //         vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      //         vm.formData.sipPaymentOption = vm.paymentOptions[0];
      //         if (vm.formData.inSchemeCode)
      //           getDateValidation();
      //       }

      //       vm.bankList = resp.data.bankList;
      //     } else {
      //       vm.bankList = null;
      //       MessageService.error(resp.message);
      //     }
      //     cb(true);
      //   },
      //     error = function (err) {
      //       LoaderService.hideLoader();
      //       vm.bankList = null;
      //       UtilService.errorHandler(err);
      //       cb(false);
      //     };
      //   LoaderService.showLoader();

      //   if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) {
      //     if (!vm.ECbankList)
      //       InvestorsService.get({ child1: 'bank', child2: 'list', child3: 'sip' }, null).$promise.then(success, error);
      //     else {
      //       LoaderService.hideLoader();
      //       vm.paymentOptions = [vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC];
      //       vm.bankList = vm.ECbankList;
      //       getDateValidation();
      //     }
      //   } else {
      //     LoaderService.hideLoader();
      //     vm.bankList = null;
      //   }
      // }
      //change payment option

      function changedPaymentOption() {
        vm.formData.bankInfo = null;
        vm.formData.otmId = '';
        vm.formData.startDate = null;
        vm.formData.endDate = null;
        vm.formData.isTillPerpetuity = null;
        vm.formData.authMode = null;
        vm.authenticationMode = null;
        vm.enabledBillerStartDatesList = null;
        vm.formData.weeklyDay = null;
        vm.disableEndDateSelection = false;
        // fetchBankList();
        //checkEMandateValidation();
        //checkOTMAmountAndDate();
        // getDateValidation();
      }

      //change day

      function reSetting() {
        vm.isReseting = true;
        $timeout(function () {
          vm.isReseting = false;
        }, 0);
      }

      vm.changeDay = function () {
        vm.disableEndDateSelection = false;
        if (!vm.formData.frequency || (!vm.formData.day && !vm.formData.weeklyDay && (vm.transactionType !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP))) {
          vm.formData.startDate = null;
          vm.enabledStartDates = null;
          vm.formData.endDate = null;
          vm.enabledEndDates = null;
          reSetting();
          return;
        }

        if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP || vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SWP) {
          vm.formData.startDate = null;
          vm.formData.endDate = null;
          vm.formData.month = '';
          vm.formData.enabledEndDates = [];
        }

        switch (vm.formData.frequency) {
          case 'BZ':
            reSetting();
            break;
          case 'OW':
            updateDatesForWeekly();
            break;
          case 'OM':
          case 'Q':
          case 'H':
          case 'Y':
            updateDatesForOthers();
            break;
          default:
            vm.formData.startDate = null;
            vm.enabledStartDates = null;
            vm.formData.endDate = null;
            vm.enabledEndDates = null;
            reSetting();
            break;
        }
      };

      function resetNumInWords() {
        vm.amountInWords = '';
        var inWordsDiv = $window.document.getElementById('divDisplayWords');
        if (inWordsDiv) {
          inWordsDiv.innerHTML = '';
        }
      }
      function showAmtExceedMsg(){
        ModalService.genericModal({
          text: vm.VALIDATE_DATA.AMOUNT_EXCEEDED
        });
      }
      vm.changepaymentMode =function(){
        if(vm.formData.paymentMode === "UPI"){
          if(vm.formData.amount > vm.purchseSchemeValidationData.upiMaxAmountLimit){
            vm.upiErrorMessage = vm.purchseSchemeValidationData.upiMaxAmountErrMessage;
            var success = function() {
              vm.formData.paymentMode = 'WEB';
            }
            ModalService.genericModal({
              text: vm.upiErrorMessage
            },success);
          }
        }
      }
      vm.fetchDynamicData =  function(pageName) {
        LoaderService.showLoader();
        var successHandler = function(resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.DynamicDataSipPurchaseReview = resp.data;
          } else {
            vm.DynamicDataSipPurchaseReview = {};
          }
        };

        var errorHandler = function(resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        };

        var payload = {
          "pageName": pageName
        };

        InvestorServiceDynamicData.post({
          "child1": "dynamicContent"
        }, payload).$promise.then(successHandler, errorHandler);
      };

    }
  })();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SummaryPageController', SummaryPageController);

  /** @ngInject */
  function SummaryPageController($rootScope, $timeout,$window, $state, LoaderService, InvestorServiceDynamicData, MessageService, ChangeDividendService, ModalService, InvestorsService, NewInvestorServiceV3,$log, AuthService) {
    var vm = this;
    vm.folioDetails = {};
    vm.folioData = {};
    vm.holders = {};
    vm.payload = {};
    vm.init = init;
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.belongToListEmail = null;
    vm.belongToListMobile = null;
    $rootScope.myState = $state.current.url;
    vm.skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
    getOccupations();
    getIncomeSlab();
    getCountry();
    getTaxIdType();
    getPayoutMechanism();
    var identifierData = AuthService.getToken();
    vm.guardianRelationshipList = [
      {
        "relationDesc": "Mother",
        "value": "MOTHER"
      },
      {
        "relationDesc": "Father",
        "value": "FATHER"
      },
      {
        "relationDesc": "Legal Guardian",
        "value": "LEGAL_GUARDIAN"
      }
    ];
    function init() {
      vm.userData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      vm.pan = vm.userData.pan;
      vm.userData.panHolderName = vm.userData.name;
      vm.soleApplicantEmail = vm.userData.email;
      vm.soleApplicantMobile = vm.userData.mobileNumber;
      getFolioDetails();
      $rootScope.testObj.steps[1].stepActive = false;
      $rootScope.testObj.steps[1].stepCompleted = true;
    }

    function getOccupations() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          vm.investorOccupations = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in occupation list!");
        };
      InvestorsService.post({ controller: 'get-occupation' }, {}).$promise.then(success, error);
    }
    function getIncomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          vm.incomeSlabList = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in income slab list!");
        };
      InvestorsService.post({ controller: 'income', child1: 'slab' }, {}).$promise.then(success, error);
    }
    function getCountry() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in country list!");
        };
      InvestorsService.post({ controller: 'country', child1: 'list' }, null).$promise.then(success, error);
    }
    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
        } else {
          vm.taxIdType = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          MessageService.error("Error in tax id type list!");
        };
      InvestorsService.post({ controller: 'taxId-type' }, {}).$promise.then(success, error);
    }
    function getBankcAccountType() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          $rootScope.AccountTypes = resp.data.bankAccountTypes;
        }
        else {
          vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };

      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: vm.taxStatus
      }, {}).$promise.then(success, error);
    }
    function getPayoutMechanism() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payoutMechanismList = resp.data.payoutMechanisms;
          $rootScope.payoutMechanismData = resp.data.payoutMechanisms;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };
      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism'
      }, {}).$promise.then(success, error);
    }

    vm.nomineeData = [];
    vm.nomineeCountry = [];
    vm.guardianRelationshipWithNominee=[];
    vm.addressLine1 = [];
    vm.addressLine2 = [];
    vm.countryList = [];
    vm.holderIncomdeslab = [];
    vm.taxIdTypeList = [];
    vm.gAddress = [];
    function getFolioDetails() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.payload = resp.data;
          mobileEmailBelongsTo();
          // vm.soleApplicantEmail = resp.data.soleApplicantDetail.personalDetail.kycEmail;
          // vm.soleApplicantMobile = resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
          vm.folioDetails = resp.data;
          vm.taxStatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
          vm.showNomineeUpdate = resp.data.sebiNomineeRegulatory01650Active ? resp.data.sebiNomineeRegulatory01650Active : false;
          vm.nomineeRegistrationCO = resp.data.nomineeRegistrationCO ? resp.data.nomineeRegistrationCO : null;
          vm.accountHoldingDeclaration = vm.nomineeRegistrationCO && vm.nomineeRegistrationCO.accountHoldingDeclaration ? vm.nomineeRegistrationCO.accountHoldingDeclaration : "NOMINATION_YES";
          vm.incapacitationDeclaration = vm.nomineeRegistrationCO && vm.nomineeRegistrationCO.incapacitationDeclaration ? vm.nomineeRegistrationCO.incapacitationDeclaration : null;
          if (vm.taxStatus) {
            getBankcAccountType();
          }
          vm.folioData.holdmode = resp.data.holdmode;
          vm.nomineeData = resp.data.nominees;
          vm.jointHoldersData = resp.data.jointHolders;

          if (vm.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription == "Individual") {
            vm.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription = "RESIDENT INDIVIDUAL";
          }
          // holder data
          if (vm.jointHoldersData.length > 0) {
            for (var i = 0; i < vm.jointHoldersData.length; i++) {
              // id type
              if (vm.jointHoldersData[i].fatcaDetail.payTaxInIndia == false) {
                var taxId2 = vm.jointHoldersData[i].fatcaDetail.fatcaTax1.taxIdType;
                vm.taxIdTypeList = vm.taxIdType.filter(function (character) { character.value === taxId2 });
              } else {
                vm.taxIdTypeList.push('-');
              }

              //  country
              var jointholdercountryId = vm.jointHoldersData[i].fatcaDetail.birthCountry;
              // vm.countryList = vm.countries.filter(function (character) { character.countryCode === jointholdercountryId });

              // income
              var incomeId = vm.jointHoldersData[i].grossAnnualIncome;
              vm.holderIncomdeslab = vm.incomeSlabList.filter(function (character) { character.incomeCode === incomeId });
            }
          }

          // end holder
          if (vm.nomineeData.length === 0) {

          } else {
            for (var i = 0; i < vm.nomineeData.length; i++) {

              if (vm.nomineeData[i].nomineeAddress.addressLine1 === null || vm.nomineeData[i].nomineeAddress.addressLine1 === undefined ) {
                var ncountryId = vm.nomineeData[i].guardianAddress.country;
                if(vm.countries){
                vm.countries.forEach(function (value) {
                  if (value.countryCode == ncountryId) {
                    vm.nomineeCountry.push(value);
                  }
                });
              }
                  var guardianRelationship = vm.nomineeData[i].guardianRelationWithNominee;
                  vm.guardianRelationshipList.forEach(function (item) {
                    if (item.value == guardianRelationship) {
                      vm.guardianRelationshipWithNominee.push(item);
                    }
                  });
                vm.addressLine1.push(vm.nomineeData[i].guardianAddress.addressLine1);
                vm.addressLine2.push(vm.nomineeData[i].guardianAddress.addressLine2);
                vm.gAddress.push(true);

              } else if (vm.nomineeData[i].guardianAddress.addressLine1 === null || vm.nomineeData[i].guardianAddress.addressLine1 === undefined) {

                var ncountryId = vm.nomineeData[i].nomineeAddress.country;
                if(vm.countries){
                vm.countries.forEach(function (value) {
                  if (value.countryCode == ncountryId) {
                    vm.nomineeCountry.push(value);
                  }
                });
                }
                guardianRelationship = null;
                vm.addressLine1.push(vm.nomineeData[i].nomineeAddress.addressLine1);
                vm.addressLine2.push(vm.nomineeData[i].nomineeAddress.addressLine2);
                vm.gAddress.push(false);

              }
            if(ncountryId == null){
              vm.nomineeCountry.push({
                countryCode: "",
                countryName: ""
                });
            }
            if(guardianRelationship == null){
              vm.guardianRelationshipWithNominee.push({
                "relationDesc": "",
                "value": ""
              });
            }
            }
          }

          if (vm.folioDetails.minor) {
            // getOccupations();
            var occupationId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.occupation;
            vm.investorOccupations.forEach(function (item) {
              if (item.occupationCode === occupationId) {
                vm.occupationData = item;
              }
            });
            // getIncomeSlab();
            var grossincomeId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
            vm.incomeSlabList.forEach(function (item) {
              if (item.incomeCode === grossincomeId) {
                vm.grossIncomeData = item;
              }
            });

            // getCountry();
            var countryId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
            vm.countries.forEach(function (item) {
              if (item.countryCode === countryId) {
                vm.countryData = item;
              }
            });
            // getTaxIdType();
            if (vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1) {
              var taxId = vm.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxIdType;
              vm.taxIdType.forEach(function (item) {
                if (item.key === taxId) {
                  vm.taxIdDetails = item;
                }
              });
            }
          } else {
            var occupationId = vm.folioDetails.soleApplicantDetail.selfDetail.occupation;
            vm.investorOccupations.forEach(function (item) {
              if (item.occupationCode === occupationId) {
                vm.occupationData = item;
              }
            });

            var grossincomeId = vm.folioDetails.soleApplicantDetail.selfDetail.grossAnnualIncome;
            vm.incomeSlabList.forEach(function (item) {
              if (item.incomeCode === grossincomeId) {
                vm.grossIncomeData = item;
              }
            });

            var countryId = vm.folioDetails.soleApplicantDetail.selfDetail.fatca.birthCountry;
            vm.countries.forEach(function (item) {
              if (item.countryCode === countryId) {
                vm.countryData = item;
              }
            });

            if (vm.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1) {
              var taxId = vm.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType;
              vm.taxIdType.forEach(function (item) {
                if (item.key === taxId) {
                  vm.taxIdDetails = item;
                }
              });
            }
          }

          if (vm.folioDetails.bankDetails) {
            var accId = vm.folioDetails.bankDetails.accountType;
            $rootScope.AccountTypes.forEach(function (item) {
              if (item.accountTypeCode === accId) {
                vm.bank = item;
              }
            });
          }
          if (vm.folioDetails.bankDetails) {
            var payoutMechanismId = vm.folioDetails.bankDetails.payoutMechanism;
            $rootScope.payoutMechanismData.forEach(function (item) {
              if (item.payoutCode === payoutMechanismId) {
                vm.payoutDescriptionData = item;
              }
            });
          }


        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      LoaderService.showLoader();
      $timeout(function () {
      ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId ,"arnCode" : identifierData.arnCode}).$promise.then(success, error);
      }, 3000);
    }



    vm.getModal = function () {
      ModalService.folioSuccssModal(vm.folioData);
    }
    vm.backpage = function () {
      $state.go('main.newinvestor.kycverify');
    }

    vm.openUploadedDoc = function (url) {
      if (angular.isUndefined(url)) { return; }
      ModalService.imagePreviewModal({ showOnly: true, file: url });
    };


    // Edit nav
    vm.gotoMinorBasic = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $rootScope.minornext(0);
      $state.go('main.newinvestor.folioCreation.folioMinorDetails');
    }
    vm.gotoMinorGuardian = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $rootScope.minornext(1);
      $state.go('main.newinvestor.folioCreation.guardianMinorDetails');
    }
    vm.gotoBankPage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('main.newinvestor.folioCreation.bankdetails');
    }
    vm.gotofolioBasic = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
    }
    vm.gotoIncomePage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
    }
    vm.gotoHolderPage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('main.newinvestor.folioCreation.jointholder');
    }
    vm.gotoNomineePage = function () {
      sessionStorage.setItem("investorIsEditButtonClick", true);
      $state.go('main.newinvestor.folioCreation.folioNomineeDetails');
    }


    vm.stepperForMinor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Guardian Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    vm.stepperThird = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 4,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    vm.stepperForAnyoneSurvivor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 3,
        name: "Holder Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 4,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }, {
        step: 5,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: true
      }
      ]
    };

    function mobileEmailBelongsTo() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.emailBelongsToList = resp.data.emailList;
          vm.mobileBelongsToList = resp.data.mobileList;
          vm.emailBelongsToList.forEach(function (value) {
            if (value.familyCode == vm.folioDetails.soleApplicantDetail.personalDetail.emailBelongsTo) {
              vm.belongToListEmail = value.familyDescription;
            }
          });
          vm.mobileBelongsToList.forEach(function (value) {
            if (value.familyCode == vm.folioDetails.soleApplicantDetail.personalDetail.mobileBelongsTo) {
              vm.belongToListMobile = value.familyDescription;
            }
          });
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(resp.error);
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'
      }).$promise.then(success, error);
    }

    vm.createNewFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var successPayDetails = function () {
            $state.go('main.dashboard');
          },errorPayDetails = function () {
            };
          ModalService.succInvestorModal({
            'task':'newINvestor',
            'name':vm.userData.panHolderName
          }, successPayDetails, errorPayDetails);
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      LoaderService.showLoader();
      vm.payload.userType = 'distributor';
      vm.payload.pageDetail = 'review';
      if(vm.skipInvestmentDetails){
        vm.payload.folioWithoutTransaction = true;
      }
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'distributorNewInvestor', child3: 'initiate' }, vm.payload).$promise.then(success, error);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioNomineeDetailsController', FolioNomineeDetailsController);

  /** @ngInject */
  function FolioNomineeDetailsController(InvestorsService, $state, $window, InvestorsCommonService, AppConstants, $log, LoaderService,
    $rootScope, MessageService, NewInvestorServiceV3, $timeout, ChangeDividendService,AuthService, InvestorServiceDynamicData, InvestorCommonServiceVersion2) {
    var vm = this;

    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.conformation = false;
    vm.addAddress = true;
    vm.addressLine1 = "";
    vm.addressLine2 = "";
    vm.country = "";
    vm.city = "";
    vm.pinCode = "";
    vm.validateDOB = false;
    vm.currentNomineedob = null;
    vm.showNomineeUpdate = true;
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.CONST = AppConstants;
    vm.changeEmailId = changeEmailId;
    vm.changeMobileNumber = changeMobileNumber;
    vm.changeNomineeIdentityProof = changeNomineeIdentityProof;
    vm.changeDrivingLicense = changeDrivingLicense;
    vm.checkNomineeIsMinor = checkNomineeIsMinor;
    vm.changeAadharCard = changeAadharCard;
    vm.changePassport = changePassport;
    vm.changeNomineePan = changeNomineePan;
    vm.buttonEnable = buttonEnable;
    vm.updateOldNomineeData = updateOldNomineeData;
    vm.isEmptyObject = isEmptyObject;
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    $rootScope.myState = $state.current.url;
    var identifierData = AuthService.getToken();
    vm.investorDetails = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.investorDetails.nriTaxStatus;
    vm.showNomineeUpdate = vm.investorDetails && vm.investorDetails.sebiNomineeRegulatory01650Active ? vm.investorDetails.sebiNomineeRegulatory01650Active : false;
    vm.nomineeLimit = vm.investorDetails.nomineeLimit || 3;
    vm.currentNomineeValue = 0;
    vm.incapcitationList = [];
    vm.setincapcitationList = setincapcitationList;
    vm.setStatement = setStatement;
    vm.selectedNominee = selectedNominee;
    vm.hasNomineeName = hasNomineeName;
    vm.nomination = true;
    vm.emailIdValid = true;

    vm.nomineeRegistrationCO = {
      "accountHoldingDeclaration": 'NOMINATION_YES',
      "incapacitationDeclaration": {
        percentage:'',
        amount: '',
        nomineeName: '',
        nomineeNumber: ''
      }
    };
    vm.init = function () {
      // vm.getPayload();
      vm.fetchDynamicData('NEW_INVESTOR_JOURNEY');
      getRelationshipList();
      getStateList();
      if(vm.showNomineeUpdate) {
        getPersonalIdentifier();
      }
    }

    vm.deleteNominee = function (index) {
      vm.beforedeleteLength = vm.nominees.length
      if (index > -1) {
        vm.nominees.splice(index, 1)
      }
      if(vm.beforedeleteLength == 2){
        vm.shownextSteps1 = false;
      }
      if(vm.beforedeleteLength == 3){
        vm.shownextSteps2 = false;
      }
      vm.numberofnominees = vm.nominees.length;
      MessageService.success("Nominee deleted successfully");
      vm.nomineePan = "";
      vm.guardianName = "";
      vm.guardianRelation = "";
      vm.guardianPanNumber = "";
      vm.countPercentage();
      vm.currentNominee(0);
      vm.extraNomineeVar = true;
      setincapcitationList();
    }

    vm.startval = 0;
    vm.addanotherNominee = true;
    vm.countPercentage = function () {
      vm.totalpercent = vm.startval;
      vm.totalShare = vm.startval;

      angular.forEach(vm.nominees, function (p) {
        vm.totalpercent = vm.totalpercent + parseInt(p.percentage);
      });

      vm.totalShare = vm.totalpercent;
      if (vm.totalShare == 100) {
        vm.addanotherNominee = false;
      } if(vm.totalShare < 100) {
        vm.addanotherNominee = true;
      }
    }
    vm.guardianRelationshipList = [
      {
        "relationDesc": "Mother",
        "value": "MOTHER"
      },
      {
        "relationDesc": "Father",
        "value": "FATHER"
      },
      {
        "relationDesc": "Legal Guardian",
        "value": "LEGAL_GUARDIAN"
      }
    ];
    vm.shownextSteps1 = false;
    vm.shownextSteps2 = false;
    vm.extraNomineeVar = false;
    vm.addnewnominee = function (form) {
      vm.fromForm = form;
      vm.numberofnominees = vm.nominees.length;
      vm.totalShare = 0;
      vm.countPercentage();
      vm.nominees.forEach(function (item,index) {
        if(!item.minor){
          if(item.guardianName || item.guardianRelationWithNominee || item.guardianPanNumber){
              vm.nominees[index].guardianName = null;
              vm.nominees[index].guardianRelationWithNominee =null;
              vm.nominees[index].guardianPanNumber=null;
            }
            if(!isEmptyObject(vm.nominees[index].guardianAddress) && vm.nominees[index].guardianAddress !== undefined){
              vm.nominees[index].nomineeAddress = vm.nominees[index].guardianAddress;
              delete vm.nominees[index].guardianAddress;
            }
        }
      });
      // if (vm.totalShare == 100) {
      //   vm.submitNomineeData();
      //   return;
      // }
      if (vm.totalShare != 100 && vm.nominees.length === 0) {
        vm.totalShare = vm.totalpercent + parseInt(vm.nomineeDetails.percentage);
      } else {
        vm.totalShare = angular.copy(vm.totalpercent);
      }

      vm.nominees.forEach(function (p) {
        vm.totalpercent = vm.totalpercent + parseInt(p.percentage);
      });
      if (vm.numberofnominees < vm.nomineeLimit && (vm.totalShare <= 100)) {
        if (vm.nomineeMinor) {
          MessageService.success("Added Nominee");
          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue , 1 , vm.nomineeDetails)
          } else {
            vm.nominees[vm.currentNomineeValue] = vm.nomineeDetails;
          }
        }
        vm.nomineeDetails = {
          nomineeName: "",
          nomineeRelation: "",
          panNumber: "",
          percentage: null,
          dob: ""
        };
        vm.numberofnominees = vm.nominees.length - 1;
        vm.currentNominee(vm.numberofnominees);
      }
      else {
        if (vm.numberofnominees > vm.nomineeLimit) {
          MessageService.error('You cant add more than '+vm.nomineeLimit+' nominee');
        }
         if (vm.numberofnominees <= vm.nomineeLimit && vm.totalShare > 100) {
          MessageService.error('Sum of percentage proportion of all nominees should be equal to 100%.');
        }
         if (vm.numberofnominees <= vm.nomineeLimit && vm.totalShare < 100) {
          MessageService.error('Sum of percentage proportion of all nominees should be equal to 100%.');
        }
      }
      vm.countPercentage();
      if (vm.numberofnominees < vm.nomineeLimit) {
        if (vm.totalShare == 100) {
          vm.extraNomineeVar = false;
          vm.submitNomineeData();
        } else {
          if (vm.totalShare < 100) {
            vm.extraNomineeVar = true;
          }
          vm.currentNominee(vm.currentNomineeValue);
        }
      }
      // if (vm.numberofnominees == 1) {
      //   if (vm.totalShare == 100) {
      //     vm.shownextSteps1 = false;
      //     vm.extraNomineeVar = false;
      //     vm.submitNomineeData();
      //   } if (vm.totalShare < 100) {
      //     vm.extraNomineeVar = true;
      //     vm.currentNominee(0);
      //   }
      // }
      // if (vm.numberofnominees == 2) {
      //   if (vm.totalShare == 100) {
      //     vm.shownextSteps2 = false;
      //     vm.extraNomineeVar = false;
      //     vm.submitNomineeData();
      //   } if (vm.totalShare < 100) {
      //     vm.extraNomineeVar = true;
      //     vm.currentNominee(1);
      //   }
      // }

      if (vm.numberofnominees == vm.nomineeLimit) {
        if (vm.totalShare == 100) {
          vm.shownextSteps2 = false;
          vm.extraNomineeVar = false;
          vm.submitNomineeData();
        }
      }
      vm.countPercentage();
    }
    vm.proceed = true;
    vm.checkProceedValidation = function () {
      if (vm.nominees[vm.currentNomineeValue] && vm.nominees[vm.currentNomineeValue].guardianPanNumber) {
        if(vm.nominees[vm.currentNomineeValue].guardianPanNumber == vm.nominees[vm.currentNomineeValue].panNumber){
          MessageService.error("Guardian PAN should not be same as Nominee PAN");
          vm.guardianPan = "";
          vm.proceed = false;
        }else{
          if (vm.nominees[vm.currentNomineeValue].guardianName && vm.nominees[vm.currentNomineeValue].guardianRelationWithNominee) {
            vm.proceed = true;
          } else {
            vm.proceed = false;
          }
        }
      } else {
        vm.proceed = !vm.showNomineeUpdate ? false : true;
      }
      vm.validateDob();
    }
    vm.addExtraNomineeFun = function () {
      vm.numberofnominees = vm.nominees.length;
      // if (vm.numberofnominees == 1) {
      //   vm.shownextSteps1 = true;
      //   vm.currentNominee(1);
      //   vm.extraNomineeVar = false;
      // }
      // if (vm.numberofnominees == 2) {
      //   vm.shownextSteps2 = true;
      //   vm.currentNominee(2);
      //   vm.extraNomineeVar = false;
      // }
      if (vm.numberofnominees < vm.nomineeLimit) {
        // vm.shownextSteps1 = true;
        vm.currentNominee(vm.currentNomineeValue + 1);
        var noOfNominee = vm.nominees.length;
        if(noOfNominee === vm.nomineeLimit) {
          vm.extraNomineeVar = false;
        }
        if(vm.extraNomineeVar) {
          vm.extraNomineeVar = false;
        }
      } else if (vm.numberofnominees === vm.nomineeLimit) {
        vm.extraNomineeVar = false;
      }
      vm.validateDob();
    }
    vm.showDeleteBtn = false;
    vm.currentNominee = function (val, userTriggered, drivingLicense, aadharCard, passport) {
      // updating data on tab change
      if (userTriggered) {
        vm.updateOldNomineeData();
      }

      if (val === vm.nomineeLimit) {
        val = 0;
      }
      vm.currentNomineeValue = val;
      if (vm.nominees.length > val) {
        try {
          vm.showDeleteBtn = true;
          vm.currentNomineeValue = val;
          vm.data = vm.nominees[val];
          vm.nomineeDetails = {
            nomineeName: vm.data.nomineeName,
            nomineeRelation: vm.data.nomineeRelation,
            percentage: vm.data.percentage,
            dob: vm.data.dob,
            minor: true
          };

          if (vm.showNomineeUpdate) {
            vm.nomineeDetails.emailId = vm.data.emailId;
            vm.nomineeDetails.mobile = vm.data.mobile;
            vm.nomineeDetails.identityProofList = vm.data.identityProofList ? vm.data.identityProofList : vm.applicantPersonalIdentifiers;
            vm.nomineeDetails.identityProofType = vm.data.identityProofType;
            vm.nomineeDetails.drivingLicense = vm.data.drivingLicense;
            vm.nomineeDetails.aadharCard = vm.data.aadharCard;
            vm.nomineeDetails.passport = vm.data.passport;
          }

          vm.nomineePan = vm.data.panNumber;
          if (vm.data.minor) {
            vm.guardianName = vm.data.guardianName;
            vm.guardianRelation = vm.data.guardianRelationWithNominee;
            vm.guardianPanNumber = vm.data.guardianPanNumber;
          }

          if (vm.data.nomineeAddress && Object.keys(vm.data.nomineeAddress).length > 0) {
            vm.addAddress = false;
            vm.addressLine1 = vm.data.nomineeAddress.addressLine1;
            vm.addressLine2 = vm.data.nomineeAddress.addressLine2;
            vm.country = vm.data.nomineeAddress.country;
            vm.city = vm.data.nomineeAddress.city;
            vm.pinCode = vm.data.nomineeAddress.pinCode;
            vm.state = vm.data.nomineeAddress.state;
          } else if (vm.data.guardianAddress && Object.keys(vm.data.guardianAddress).length > 0) {
            vm.addAddress = true;
            vm.addressLine1 = vm.data.guardianAddress.addressLine1;
            vm.addressLine2 = vm.data.guardianAddress.addressLine2;
            vm.country = vm.data.guardianAddress.country;
            vm.city = vm.data.guardianAddress.city;
            vm.pinCode = vm.data.guardianAddress.pinCode;
            vm.state = vm.data.guardianAddress.state;
          }
        }
        catch (e) {

        }
      } else {
        vm.showDeleteBtn = false;
        vm.nomineeDetails = {
          nomineeName: "",
          nomineeRelation: "",
          percentage: null,
          dob: "",
          minor: false,
          identityProofList: vm.applicantPersonalIdentifiers,
        };
        vm.addressLine1 = "";
        vm.addressLine2 = "",
        vm.pinCode = "",
        vm.city = "",
        vm.country = ""
        vm.state = "";
        vm.guardianName ="";
        vm.guardianRelation = "";
        vm.guardianPan = "";
        vm.nomineePan = "";
        // pushing empty data for maintaining nominee list
        vm.nominees.push(vm.nomineeDetails);
        if (vm.fromForm) {
          vm.fromForm.$setPristine();
          vm.fromForm.$setUntouched();
        }
      }

      if(vm.nominees[vm.currentNomineeValue] && vm.nominees[vm.currentNomineeValue].dob){
        vm.currentNomineedob = moment(vm.nominees[vm.currentNomineeValue].dob);
        vm.dobDate = moment(vm.currentNomineedob).format("DD-MMM-YYYY");
      }else{
        vm.currentNomineedob = null;
      }
      if(vm.showNomineeUpdate) {
        changeDrivingLicense(vm.currentNomineeValue, drivingLicense);
        changeAadharCard(vm.currentNomineeValue, aadharCard);
        changePassport(vm.currentNomineeValue, passport);
      }
      vm.validateDob();
    }
    vm.addnominee = false;
    vm.shownomineeList = false;
    vm.nominees = [];
    vm.nomineeDetails = {
      nomineeName: "",
      nomineeRelation: "",
      percentage: null,
      dob: "",
      minor: false
    };
    vm.numberofnominees = vm.nominees.length;
    vm.totalpercent;

    vm.addnomineedata = function (value,savedData) {
      if (value == 1) {
        vm.addnominee = true;
        vm.currentNomineeValue = 0;
        if(!savedData && vm.nominees.length === 0) {
          var nomineeDetails = {
            nomineeName: "",
            nomineeRelation: "",
            percentage: null,
            dob: "",
            minor: false
          }
          vm.nominees.push(nomineeDetails);
          getPersonalIdentifier(function(){
            checkNomineeIsMinor(value - 1);
          });
        }

      }
      else {
        vm.addnominee = false;
        vm.nominees = [];
        vm.incapcitationNomineeIndex = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration = {
          percentage: '',
          amount: '',
          nomineeName: '',
          nomineeNumber: ''
        };
      }
    }
    vm.getNomineeDob = function (date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
          vm.currentNomineedob = date;
          vm.dobDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.nominees[vm.currentNomineeValue].minor) {
          //  minor
          vm.proceed = false;
          vm.checkProceedValidation();
        }
        else {
          vm.proceed = true;
        }
        vm.nominees[vm.currentNomineeValue].dob = vm.dobDate;


        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.nominees[vm.currentNomineeValue].dob ="";
      }
      return;
    }
    vm.getconformation = function () {
      vm.conformation = !vm.conformation;
    }
    vm.getNewUserDetails = function () {
      var success = function (resp) {
        localStorage.setItem("folioId", resp.data.folioCreationDraftId);
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      var uContext = JSON.parse(sessionStorage.getItem("userData"));
      var taxIdentifier = uContext.pan;
      var payload = {
        "panNumber": taxIdentifier,
        "arnCode":identifierData.arnCode
      }
      InvestorsService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
    }
    // vm.getNewUserDetails();
    vm.getPayload = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payload = resp.data;
          vm.soleApplicantEmail = resp.data.soleApplicantDetail.personalDetail.kycEmail;
          vm.soleApplicantMobile = resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
          vm.payload.nominees.forEach(function(nomineeData,index) {
            if(nomineeData.minor){
              nomineeData.nomineeAddress = nomineeData.guardianAddress;
            }
            if(vm.showNomineeUpdate) {
              if(nomineeData.identityProofType === 'AADHAR_CARD') {
                nomineeData.aadharCard= nomineeData.identityProofNumber;
              } else if(nomineeData.identityProofType === 'DRIVING_LICENSE') {
                nomineeData.drivingLicense = nomineeData.identityProofNumber;
              } else if(nomineeData.identityProofType === 'PAN_CARD') {
                nomineeData.panNumber = nomineeData.identityProofNumber;
              } else if(nomineeData.identityProofType === 'PASSPORT') {
                nomineeData.passport = nomineeData.identityProofNumber;
              }
            }
            vm.incapcitationList.push(angular.copy({
              key : nomineeData.nomineeName + '-' + vm.enum[index],
              value : index,
              isMinor : nomineeData.minor,
              index : index
            }));
          });
          vm.holdeMode = vm.payload.holdmode;
          $rootScope.folioBasicDetail.folioHoldingMode = vm.payload.holdmode;
          var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");

          if (isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE") {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            sessionStorage.removeItem("investorIsEditButtonClick");
          } else {
            $rootScope.nextStep(0);
            $rootScope.nextStep(1);
            $rootScope.nextStep(2);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }

          if(vm.payload.nominees && vm.payload.nominees.length > 0) {
            vm.nominees = vm.payload.nominees;
            vm.nominees.forEach(function(nomineeData,index) {
              getPersonalIdentifier(function(){
                checkNomineeIsMinor(index);
                if (!vm.nominees[index].nomineeAddress.country) {
                  vm.nominees[index].nomineeAddress.state = null;
                }
                if(vm.nominees[index].nomineeAddress.country != 'IN' && vm.nominees[index].nomineeAddress.state === 'OTHER'){
                  vm.nominees[index].nomineeAddress.state = "XX";
                }else if (vm.nominees[index].nomineeAddress.state === 'OTHER'){
                  vm.nominees[index].nomineeAddress.state = "XX";
                }
              });
            });
            vm.countPercentage();
            vm.currentNominee(0);
            vm.addnomineedata(1,true);

            vm.numberofnominees = vm.nominees.length;
            if (vm.numberofnominees < vm.nomineeLimit) {
              if (vm.totalShare == 100) {
                vm.currentNominee(0);
              } else {
                vm.shownextSteps1 = true;
              }
            }
            if (vm.numberofnominees == vm.nomineeLimit) {
              if (vm.totalShare == 100) {
                vm.shownextSteps2 = true;
                vm.shownextSteps1 = true;
                vm.currentNominee(0);
              }
            }
            if(vm.payload.nomineeRegistrationCO) {
              vm.nomineeRegistrationCO = {
                "accountHoldingDeclaration": vm.payload.nomineeRegistrationCO.accountHoldingDeclaration || "NOMINATION_YES"
              }
              if(vm.nomineeRegistrationCO && vm.nomineeRegistrationCO.accountHoldingDeclaration) {
                if(vm.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_YES') {
                  vm.nomination = true;
                } else {
                  vm.nomination = false;
                }
              }
              if(vm.payload.nomineeRegistrationCO.incapacitationDeclaration) {
                vm.nomineeRegistrationCO.incapacitationDeclaration = {
                  percentage: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage || '',
                  amount: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.amount || '',
                  nomineeName: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName || '',
                  nomineeNumber: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber || ''
                }
                vm.incapcitationNomineeIndex = vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber - 1;
                selectedNominee();
              } else {
                vm.nomineeRegistrationCO.incapacitationDeclaration = {};
              }
            }
          } else {
            vm.nominees.push(vm.nomineeDetails);
            getPersonalIdentifier(function(){
              checkNomineeIsMinor(0);
            });
          // else {
              vm.nomineeRegistrationCO.incapacitationDeclaration = {
                percentage:'',
                amount: '',
                nomineeName: '',
                nomineeNumber: ''
              };
            // }
            vm.addnomineedata(0);
          }
          //
          // if(vm.payload.nomineeRegistrationCO && vm.showNomineeUpdate) {
          //   vm.nomineeRegistrationCO = {
          //     "accountHoldingDeclaration": vm.payload.nomineeRegistrationCO.accountHoldingDeclaration || []
          //   }
          //   if(vm.payload.nomineeRegistrationCO.incapacitationDeclaration) {
          //     vm.nomineeRegistrationCO.incapacitationDeclaration = {
          //       percentage: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.percentage || '',
          //       amount: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.amount || '',
          //       nomineeName: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeName || '',
          //       nomineeNumber: vm.payload.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber || ''
          //     }
          //   }
          // }
          // vm.countPercentage();
          // if (vm.nominees.length > 0) {
          //   vm.currentNominee(0);
          //   vm.addnomineedata(1);
          //
          //   vm.numberofnominees = vm.nominees.length;
          //   if (vm.numberofnominees < vm.nomineeLimit) {
          //     if (vm.totalShare == 100) {
          //       vm.currentNominee(0);
          //     } else {
          //       vm.shownextSteps1 = true;
          //     }
          //   }
          //   if (vm.numberofnominees == vm.nomineeLimit) {
          //     if (vm.totalShare == 100) {
          //       vm.shownextSteps2 = true;
          //       vm.shownextSteps1 = true;
          //       vm.currentNominee(0);
          //     }
          //   }
            // if (vm.numberofnominees == 1) {
            //   if (vm.totalShare == 100) {
            //     vm.shownextSteps1 = false;
            //     vm.currentNominee(0);
            //   } if (vm.totalShare < 100) {
            //     vm.shownextSteps1 = true;
            //   }
            // }
            // if (vm.numberofnominees == 2) {
            //   if (vm.totalShare == 100) {
            //     vm.shownextSteps2 = false;
            //     vm.shownextSteps1 = true;
            //     vm.currentNominee(0);
            //   } if (vm.totalShare < 100) {
            //     vm.shownextSteps2 = true;
            //   }
            // }
            // if (vm.numberofnominees == 3) {
            //   if (vm.totalShare == 100) {
            //     vm.shownextSteps2 = true;
            //     vm.shownextSteps1 = true;
            //     vm.currentNominee(0);
            //   }
            // }
          // }
          vm.numberofnominees = vm.nominees.length;
          localStorage.setItem('folioId', vm.payload.id);
          vm.checkProceedValidation();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId ,"arnCode" : identifierData.arnCode}).$promise.then(success, error);
    }

    vm.getPayload();

    vm.setState = function () {

      if (!vm.nominees[vm.currentNomineeValue].nomineeAddress.country) {
        vm.nominees[vm.currentNomineeValue].nomineeAddress.state = null;
      }
      if(vm.nominees[vm.currentNomineeValue].nomineeAddress.country != 'IN'){
        vm.nominees[vm.currentNomineeValue].nomineeAddress.state = "XX";
      }else{
        vm.nominees[vm.currentNomineeValue].nomineeAddress.state = "XX";
      }
    }

    vm.submitNomineeData = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (vm.holdeMode == 'SINGLE') {
            $rootScope.nextStep(2);
            $state.go('main.newinvestor.folioCreation.bankdetails');
          } else {
            $state.go('main.newinvestor.folioCreation.bankdetails');
            $rootScope.nextStep(3);
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      if (vm.addnominee) {
        vm.payload.nominees = vm.nominees;
        vm.payload.nomineeOptOut = "N";
      } else {
        vm.payload.nominees = [];
        vm.payload.nomineeOptOut = "Y";
      }
      vm.copyOfNominee = angular.copy(vm.nominees);
      vm.copyOfNominee.forEach(function(nomineeData) {
        if(nomineeData.minor){
          nomineeData.guardianAddress = nomineeData.nomineeAddress;
          delete nomineeData.nomineeAddress;
        }

        if(vm.showNomineeUpdate) {
          if(nomineeData.identityProofType === 'AADHAR_CARD') {
            nomineeData.identityProofNumber = nomineeData.aadharCard;
          } else if(nomineeData.identityProofType === 'DRIVING_LICENSE') {
            nomineeData.identityProofNumber = nomineeData.drivingLicense;
          } else if(nomineeData.identityProofType === 'PAN_CARD') {
            nomineeData.identityProofNumber = nomineeData.panNumber;
          } else if(nomineeData.identityProofType === 'PASSPORT') {
            nomineeData.identityProofNumber = nomineeData.passport;
          }

          if (!nomineeData.identityProofObj) {
            nomineeData.identityProofObj = vm.identityProofList && vm.identityProofList.find(function (el) {
              return el.identityProofType == nomineeData.identityProofType
            })
          }

          nomineeData.identityProofCamsCode = nomineeData.identityProofObj ? angular.copy(nomineeData.identityProofObj.identityProofCamsCode) : null;

        }
        delete nomineeData.aadharCard;
        delete nomineeData.drivingLicense;
        delete nomineeData.panNumber;
        delete nomineeData.passport;
        delete nomineeData.identityProofList;

      });

      if(vm.showNomineeUpdate) {
        if(vm.nomineeRegistrationCO.incapacitationDeclaration && !vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeName) {
          delete vm.nomineeRegistrationCO.incapacitationDeclaration;
        }
        vm.payload.nomineeRegistrationCO = vm.nomineeRegistrationCO;
        if(!vm.addnominee) {
          delete vm.payload.nomineeRegistrationCO;
        }
      }
      vm.payload.nominees = vm.copyOfNominee;
      vm.payload.id = localStorage.getItem("folioId");
      vm.payload.folioSaveStep = "FOUR";
      vm.payload.brokerCode = "DIRECT";
      vm.payload.nriFlag = vm.nriTaxStatus;
      vm.countPercentage();

      if (vm.addnominee) {
        if (vm.totalShare == 100) {
          NewInvestorServiceV3.post({ child1: 'folio',child2: 'distributorNewInvestor', child3: 'initiate' }, vm.payload).$promise.then(success, error);
        } else {
          MessageService.error('Sum of percentage proportion of all nominees should be equal to 100%.');
        }
      } else {
        NewInvestorServiceV3.post({ child1: 'folio',child2: 'distributorNewInvestor', child3: 'initiate' }, vm.payload).$promise.then(success, error);
      }
    }

    vm.autoDate = function () {
      vm.dobString = $("#nomineedob").val();
      if (vm.dobString.length == 2) {
        $("#nomineedob").val(vm.dobString + "-");
      }
      if (vm.dobString.length == 6) {
        $("#nomineedob").val(vm.dobString + "-");
      }
    }
    vm.datethreeToTwo = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "Jan":
          vm.cdate = dateChar[0] + "-01-" + dateChar[2];
          return vm.cdate;
          break;
        case "Feb":
          vm.cdate = dateChar[0] + "-02-" + dateChar[2];
          return vm.cdate;
          break;
        case "Mar":
          vm.cdate = dateChar[0] + "-03-" + dateChar[2];
          return vm.cdate;
          break;
        case "Apr":
          vm.cdate = dateChar[0] + "-04-" + dateChar[2];
          return vm.cdate;
          break;
        case "May":
          vm.cdate = dateChar[0] + "-05-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jun":
          vm.cdate = dateChar[0] + "-06-" + dateChar[2];
          return vm.cdate;
          break;
        case "Jul":
          vm.cdate = dateChar[0] + "-07-" + dateChar[2];
          return vm.cdate;
          break;
        case "Aug":
          vm.cdate = dateChar[0] + "-08-" + dateChar[2];
          return vm.cdate;
          break;
        case "Sep":
          vm.cdate = dateChar[0] + "-09-" + dateChar[2];
          return vm.cdate;
          break;
        case "Oct":
          vm.cdate = dateChar[0] + "-10-" + dateChar[2];
          return vm.cdate;
          break;
        case "Nov":
          vm.cdate = dateChar[0] + "-11-" + dateChar[2];
          return vm.cdate;
          break;
        case "Dec":
          vm.cdate = dateChar[0] + "-12-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.datetwoTothree = function (date) {
      var dateChar = date.split("-");
      switch (dateChar[1]) {
        case "01":
          vm.cdate = dateChar[0] + "-Jan-" + dateChar[2];
          return vm.cdate;
          break;
        case "02":
          vm.cdate = dateChar[0] + "-Feb-" + dateChar[2];
          return vm.cdate;
          break;
        case "03":
          vm.cdate = dateChar[0] + "-Mar-" + dateChar[2];
          return vm.cdate;
          break;
        case "04":
          vm.cdate = dateChar[0] + "-Apr-" + dateChar[2];
          return vm.cdate;
          break;
        case "05":
          vm.cdate = dateChar[0] + "-May-" + dateChar[2];
          return vm.cdate;
          break;
        case "06":
          vm.cdate = dateChar[0] + "-Jun-" + dateChar[2];
          return vm.cdate;
          break;
        case "07":
          vm.cdate = dateChar[0] + "-Jul-" + dateChar[2];
          return vm.cdate;
          break;
        case "08":
          vm.cdate = dateChar[0] + "-Aug-" + dateChar[2];
          return vm.cdate;
          break;
        case "09":
          vm.cdate = dateChar[0] + "-Sep-" + dateChar[2];
          return vm.cdate;
          break;
        case "10":
          vm.cdate = dateChar[0] + "-Oct-" + dateChar[2];
          return vm.cdate;
          break;
        case "11":
          vm.cdate = dateChar[0] + "-Nov-" + dateChar[2];
          return vm.cdate;
          break;
        case "12":
          vm.cdate = dateChar[0] + "-Dec-" + dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.applicantRelationShip = [];
    function getRelationshipList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.applicantRelationShip = resp.data.nomineeRelationshipList;
        } else {
          vm.applicantRelationShip = [];
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.applicantRelationShip = [];
      };
      InvestorsCommonService.get({ child1: 'nominee', child2: 'relation' }, {}).$promise.then(success, error);
    }
    vm.stateList = [];
    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsCommonService.get({ child1: 'state', child2: 'list' }).$promise.then(success, error);
    }
    vm.updatePercentage = function(){
        vm.totalpercent = 0;
        vm.nominees.forEach(function (p) {
          vm.totalpercent = vm.totalpercent + parseInt(p.percentage);
        });
        if(vm.totalpercent > 100){
          MessageService.error("Sum of percentage proportion of all nominees should be equal to 100%.");
        }
    }

    vm.checkPan = function(){
      if(vm.investorDetails.pan == vm.nominees[vm.currentNomineeValue].panNumber){
        MessageService.error("Nominee's PAN should not be same as Investor's PAN");
        vm.nomineePan = '';

      }
      if (vm.nominees[vm.currentNomineeValue].guardianName && vm.nominees[vm.currentNomineeValue].guardianRelationWithNominee && vm.nominees[vm.currentNomineeValue].guardianPanNumber) {
        if(vm.nominees[vm.currentNomineeValue].guardianName == vm.nominees[vm.currentNomineeValue].guardianPanNumber){
          MessageService.error("Nominee PAN should not be same as Guardian PAN");
          vm.nomineePan = '';
        }
      }
    }

    vm.changeFolioMinor = function(){
        vm.currentNomineedob = null;
        vm.nominees[vm.currentNomineeValue].dob = "";
        vm.validateDob();
      checkNomineeIsMinor(vm.currentNomineeValue);
      setincapcitationList(true);
    }
    vm.validateDob = function(){
      vm.validateDOB = false;
      vm.nominees.forEach(function(el){
        if(el.minor){
          if(!el.dob){
            vm.validateDOB = true;
          }
        }
      });
    }
    vm.setMaxMinDate = function(){
      var currentDate = Date();
      var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
      var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.dataMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');;
        vm.dataMaxDate1 = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMinDate1 = $window.moment(Date.parse(initiateDate));
    }
    vm.setMaxMinDate();
    vm.fetchDynamicData =  function(pageName) {
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.dynamicDataNomineeOptOut = resp.data.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT;
        }
      };
      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      var payload = {
        "pageName": pageName
      };
      InvestorServiceDynamicData.post({
        "child1": "dynamicContent"
      }, payload).$promise.then(successHandler, errorHandler);
    };

    function changeEmailId(index, emailId) {
      /*if (!emailId) {
        return;
      }
      if (vm.soleApplicantEmail && (vm.soleApplicantEmail.toLowerCase() === emailId.toLowerCase())) {
        vm.nominees[index].emailIdInvalid = true;
        vm.emailIdValid = false;
        vm.errorMessageEmail = vm.validateData.NOMINEE_EMAIL_SAME_AS_INVESTOR;
      } else {
        vm.nominees[index].emailIdInvalid = false;
        vm.emailIdValid = true;
        vm.errorMessageEmail = null;
      }*/
    }

    function changeMobileNumber(index, mobileNumber) {
      if (!mobileNumber) {
        return;
      }
      if (vm.soleApplicantMobile && (vm.soleApplicantMobile === mobileNumber)) {
        vm.nominees[index].mobileInvalid = true;
        vm.mobileValid = false;
        vm.errorMessageMobile = vm.validateData.NOMINEE_MOBILE_SAME_AS_INVESTOR;
      } else {
        vm.nominees[index].mobileInvalid = false;
        vm.mobileValid = true;
        vm.errorMessageMobile = null;
      }
    }


    /*** function responsible to fetching and setting personal identifier dropdown list **/

    function getPersonalIdentifier(cb) {
      cb = cb || function (){}
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.applicantPersonalIdentifiers = resp.data.identityProofs;
            vm.identityProofList = vm.applicantPersonalIdentifiers;
            cb(true);
          } else {
            MessageService.error(resp.message);
            cb(false);
          }
      },
      error = function (err) {
        UtilService.errorHandler(err);
        cb(false);
      };

      if(!vm.applicantPersonalIdentifiers) {
        InvestorCommonServiceVersion2.get({
          child1: 'identity-proofs'
        }, {}).$promise.then(success, error);
      } else {
        cb();
      }
    }

    function changeNomineeIdentityProof(index,identifier){
      vm.nominees[index].identityProofList.map(function (el) {
        if (el.value === identifier) {
          vm.nominees[index].identityProofType = el.value;
        }
      });
      vm.nominees[index].panNumber = '';
      vm.nominees[index].drivingLicense = '';
      vm.nominees[index].aadharCard = '';
      vm.nominees[index].passport = '';
      vm.nominees[index].identityProofObj = null;
    }

    function changeDrivingLicense(index, drivingLicense) {
      checkDuplicateNomineeDL(index,drivingLicense)
    }

    function changeAadharCard(index, aadharCard) {
      checkDuplicateNomineeAadhaar(index,aadharCard);
    }

    function changeNomineePan(index, panNumber) {
      checkDuplicateNomineePan(index,panNumber);
    }

    function checkDuplicateNomineeDL(index, drivingLicense) {

      if (!drivingLicense) {
        return;
      }

      var nominees = vm.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].drivingLicense) {
          nominees[i].nomineeDLInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].drivingLicense && drivingLicense && (i !== index && nominees[i].drivingLicense === drivingLicense)) {
          nominees[index].nomineeDLInvalid = true;
          nominees[i].nomineeDLInvalid = false;
          vm.errorMessageDLIdentity = vm.validateData.DRIVING_LICENSE_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeDLInvalid = false;
      vm.nominees[index].identityProofNumber = drivingLicense;

      if (!vm.nominees[index].identityProofObj && vm.nominees[index].identityProofType) {
        vm.nominees[index].identityProofObj = vm.identityProofList && vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.nominees[index].identityProofType
        })
      }

      vm.nominees[index].identityProofCamsCode = vm.nominees[index].identityProofObj && angular.copy(vm.nominees[index].identityProofObj.identityProofCamsCode);

    }

    function checkDuplicateNomineeAadhaar(index, aadharCard) {

      if (!aadharCard) {
        return;
      }

      var nominees = vm.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty aadharCard
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].aadharCard) {
          nominees[i].nomineeAadharInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].aadharCard && aadharCard && (i !== index && nominees[i].aadharCard === aadharCard)) {
          // nominees[index].nomineeAadharInvalid = true;
          nominees[i].nomineeAadharInvalid = false;
          // vm.errorMessageDLIdentity = vm.validateData.AADHAAR_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeAadharInvalid = false;
      vm.nominees[index].identityProofNumber = aadharCard;

      if (!vm.nominees[index].identityProofObj && vm.nominees[index].identityProofType) {
        vm.nominees[index].identityProofObj = vm.identityProofList && vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.nominees[index].identityProofType
        })
      }

      vm.nominees[index].identityProofCamsCode = vm.nominees[index].identityProofObj && angular.copy(vm.nominees[index].identityProofObj.identityProofCamsCode);

    }

    function checkDuplicateNomineePan(index,panNumber) {
      var nominees = vm.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].panNumber) {
          nominees[i].nomineePanInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].panNumber && panNumber && (i !== index && nominees[i].panNumber === panNumber)) {
          nominees[index].nomineePanInvalid = true;
          nominees[i].nomineePanInvalid = false;
          vm.errorMessagePanIdentity = vm.validateData.PAN_NUMBER_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineePanInvalid = false;
      vm.nominees[index].identityProofNumber = panNumber;

      if (!vm.nominees[index].identityProofObj && vm.nominees[index].identityProofType) {
        vm.nominees[index].identityProofObj = vm.identityProofList && vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.nominees[index].identityProofType
        })
      }

      vm.nominees[index].identityProofCamsCode = vm.nominees[index].identityProofObj && angular.copy(vm.nominees[index].identityProofObj.identityProofCamsCode);


    }
    function checkNomineeIsMinor(index) {
      // var nominee = vm.nomineeDetails;
      var nominee = vm.nominees[index];
      nominee.identityProofList = [];
      if (nominee.minor && nominee) {
        for (var i = 0; i < vm.applicantPersonalIdentifiers.length; i++) {
          if (vm.applicantPersonalIdentifiers[i].identityProofType !== "DRIVING_LICENSE") {
            nominee.identityProofList.push(vm.applicantPersonalIdentifiers[i]);
          }
        }
      } else {
        nominee.identityProofList = vm.applicantPersonalIdentifiers.slice();
      }
    }

    function buttonEnable() {
      if(!vm.nominees && vm.nominees.length == 0) {
        return;
      }
      for(var i=0;i<vm.nominees.length;i++){
        if(vm.showNomineeUpdate) {
          if(vm.nominees[i].nomineeAddress) {
            if(!vm.nominees[i].nomineeAddress.addressLine1 || !vm.nominees[i].nomineeAddress.country || !vm.nominees[i].nomineeAddress.state || !vm.nominees[i].nomineeAddress.city || !vm.nominees[i].nomineeAddress.pinCode) {
              return true;
            }
          } else if (!vm.nominees[i].nomineeAddress) {
            return true;
          }
          if(!vm.nominees[i].emailId || !vm.nominees[i].mobileNumber || vm.nominees[i].emailIdInvalid || vm.nominees[i].mobileInvalid || !vm.nominees[i].identityProofType) {
            return true;
          }
          if(vm.nominees[i].identityProofType) {
            if(vm.nominees[i].identityProofType === "DRIVING_LICENSE" && (!vm.nominees[i].drivingLicense || vm.nominees[i].nomineeDLInvalid)) {
              return true;
            }
            if(vm.nominees[i].identityProofType === 'AADHAR_CARD' && (!vm.nominees[i].aadharCard || vm.nominees[i].nomineeAadharInvalid)) {
              return true
            }
            if(vm.nominees[i].identityProofType === "PAN_CARD" && (!vm.nominees[i].panNumber)) {
              return true;
            }
            if(vm.nominees[i].identityProofType === "PASSPORT" && (!vm.nominees[i].passport || vm.nominees[i].nomineePassportInvalid)) {
              return true;
            }
          }
          if(vm.nomineeRegistrationCO.incapacitationDeclaration && vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeName && ((!vm.nomineeRegistrationCO.incapacitationDeclaration.percentage && !vm.nomineeRegistrationCO.incapacitationDeclaration.amount) || (vm.nomineeRegistrationCO.incapacitationDeclaration.percentage && (vm.nomineeRegistrationCO.incapacitationDeclaration.percentage > 100 || vm.nomineeRegistrationCO.incapacitationDeclaration.percentage == 0)))){
            return true;
          }
          /*if(vm.nomineeRegistrationCO.accountHoldingDeclaration && vm.nomineeRegistrationCO.accountHoldingDeclaration.length == 0){
            return true;
          }*/
        } else {
          return false;
        }
      }
    }

    function updateOldNomineeData() {

      if (vm.numberofnominees <= vm.maxNominee && (vm.totalShare <= 100)) {
        if (vm.nomineeDetails.minor) {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.nomineePan = vm.nomineePan;
        } else {
          vm.nomineeDetails.guardianName = vm.guardianName;
          vm.nomineeDetails.guardianRelationWithNominee = vm.guardianRelation;
          vm.nomineeDetails.guardianPanNumber = vm.guardianPan;
          vm.nomineeDetails.minor = false;
        }

        if (!vm.nomineeDetails.minor) {
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.nomineeAddress = {};
          vm.nomineeDetails.nomineeAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.nomineeAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.nomineeAddress.country = vm.country ? vm.country : "";
          vm.nomineeDetails.nomineeAddress.state = vm.state;
          vm.nomineeDetails.nomineeAddress.city = vm.city ? vm.city : "";
          vm.nomineeDetails.nomineeAddress.pinCode = vm.pinCode;

          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue, 1, vm.nomineeDetails)
          } else {
            vm.nominees.push(vm.nomineeDetails);
          }
        } else {
          // var incomdeData = JSON.parse(sessionStorage.getItem("incomeDetails"));
          vm.nomineeDetails.guardianAddress = {};
          vm.nomineeDetails.guardianAddress.addressLine1 = vm.addressLine1;
          vm.nomineeDetails.guardianAddress.addressLine2 = vm.addressLine2;
          vm.nomineeDetails.panNumber = vm.nomineePan;
          vm.nomineeDetails.guardianAddress.country = vm.country ? vm.country : "";
          vm.nomineeDetails.guardianAddress.city = vm.city ? vm.city : "";
          vm.nomineeDetails.guardianAddress.pinCode = vm.pinCode;
          vm.nomineeDetails.guardianAddress.state = vm.state;

          if (vm.currentNomineeValue !== undefined) {
            vm.nominees.splice(vm.currentNomineeValue, 1, vm.nomineeDetails)
          } else {
            vm.nominees.push(vm.nomineeDetails);
          }
        }
      }
    }

    function setincapcitationList(isMinor) {

      vm.incapcitationList = [];
      vm.currentNomineeValue = vm.currentNomineeValue ?  vm.currentNomineeValue : 0;
      if(isMinor) {
        vm.incapcitationNomineeIndex = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration = {
          percentage: '',
          amount: '',
          nomineeName: '',
          nomineeNumber: ''
        };
      }

      // when nominees array is filled iterate and fill the data
      vm.nominees && vm.nominees.forEach(function(nominee, index) {
        if (nominee.nomineeName) {
          vm.incapcitationList.push(angular.copy({
            key : nominee.nomineeName + '-' + vm.enum[index],
            value : index,
            isMinor : nominee.minor,
            index : index
          }));
        }
      })

      // add current tab data
      if (vm.nomineeDetails.nomineeName) {
        if (vm.incapcitationList.length > 0 && vm.incapcitationList[vm.currentNomineeValue]) {
          vm.incapcitationList[vm.currentNomineeValue].key = vm.nomineeDetails.nomineeName + '-' + vm.enum[vm.currentNomineeValue];
        } else {
          vm.incapcitationList.push(angular.copy({
            key : vm.nomineeDetails.nomineeName + '-' + vm.enum[vm.currentNomineeValue],
            value : vm.currentNomineeValue,
            isMinor : vm.nomineeDetails.minor
          }));
        }
      }

      vm.incapcitationNomineeIndex = vm.incapcitationNomineeIndex === vm.currentNomineeValue ? null : vm.incapcitationNomineeIndex;

    }

    function setStatement() {
      //vm.nomineeRegistrationCO.accountHoldingDeclaration = [];
      if (vm.nomination) {
        vm.nomineeRegistrationCO.accountHoldingDeclaration = 'NOMINATION_YES';
      } else {
        vm.nomineeRegistrationCO.accountHoldingDeclaration = 'NOMINATION_NO';
      }
    }

    function selectedNominee(value) {
      if (vm.incapcitationNomineeIndex !== null) {
        vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = parseInt(vm.incapcitationNomineeIndex) + 1;
        vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = vm.nomineeDetails.nomineeName;
      } else {
        vm.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = null;
        vm.nomineeRegistrationCO.incapacitationDeclaration = {};
      }
    }

    function hasNomineeName() {
      if (!vm.nominees) {
        return false;
      }

      for (var i = 0; i < vm.nominees.length; i++) {
        if (vm.nominees[i].nomineeName) {
          return true;
        }
      }
      return false;
    }

    function isEmptyObject(obj) {
      return angular.equals({}, obj);
    }

    function changePassport(index, passport) {

      if (!passport) {
        return;
      }

      var nominees = vm.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineePassportInvalid for empty passport
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].passport) {
          nominees[i].nomineePassportInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].passport && passport && (i !== index && nominees[i].passport === passport)) {
          nominees[index].nomineePassportInvalid = true;
          nominees[i].nomineePassportInvalid = false;
          vm.errorMessagePassportIdentity = vm.validateData.PASSPORT_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineePassportInvalid = false;
      vm.nominees[index].identityProofNumber = passport;


      if (!vm.nominees[index].identityProofObj && vm.nominees[index].identityProofType) {
        vm.nominees[index].identityProofObj = vm.identityProofList && vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.nominees[index].identityProofType
        })
      }

      vm.nominees[index].identityProofCamsCode = vm.nominees[index].identityProofObj && angular.copy(vm.nominees[index].identityProofObj.identityProofCamsCode);


    }
  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioIncomeDetailsController', FolioIncomeDetailsController);

    /** @ngInject */
    function FolioIncomeDetailsController($state,$window, AppConstants,$log,InvestorServiceDynamicData,LoaderService,$rootScope,MessageService,InvestorsService,NewInvestorServiceV3,$timeout,ChangeDividendService,AuthService, InvestorModel) {
      var vm = this;
      var date = new Date();
      date.setFullYear(date.getFullYear() - 1);
      vm.minDate = date;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.dateErrorMessage = "";
    vm.folioIncomeForm = {}
    vm.folioIncomeForm.Fatca = {};
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    vm.networth = false;
    vm.holders  = {};
    vm.soleApplicantEmail = null;
    vm.soleApplicantMobile = null;
    vm.folioIncomeForm.taxstatus = "01";
    vm.UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.UserData.nriTaxStatus;
    var identifierData = AuthService.getToken();
    vm.pan = vm.UserData.pan;
    vm.fatcaDetails = $window.JSON.parse(localStorage.getItem("fatcadetails"));
      vm.userDob = vm.UserData.dob;
      vm.showEditEmail = true;
      vm.showEditMobile = true;
      vm.isEmailEdited = false;
      vm.isMobileEdited = false;
      vm.updateContactInfo = updateContactInfo;
      vm.AppConstants = AppConstants;
      vm.hideUiFnc = hideUiFnc;
      vm.showUiFnc = showUiFnc;
      vm.hideEditMobile = false;
      vm.hideEditEmail = false;
    function fetchBelongsToDropdown(cb) {
      cb = cb ||function () {

      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.holders  = {};
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
        cb();
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
        LoaderService.hideLoader();
        cb();
      };

      InvestorServiceDynamicData.get({child1: 'contactType',child2: 'details'}).$promise.then(success, error);
    }
    fetchBelongsToDropdown();
    getPayload();
    $rootScope.myState = $state.current.url;
    vm.getGrossAnnualIncomeDate = function (date) {
      if (!date) {
        vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
      } else vm.dateErrorMessage = '';
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.folioIncomeForm.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
          vm.dateErrorMessage = '';
        }
        else {
          vm.folioIncomeForm.grossAnnualIncomeDate = "";
          vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
          MessageService.error('Networth date should not be older than 1 year');
        }

      } else {
        vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
      vm.formatNetworthDate = vm.folioIncomeForm.grossAnnualIncomeDate;
      return;
    }
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if(vm.networth){
        vm.folioIncomeForm.annualincome = '';
        if(!vm.draftdataNetworth){
          vm.folioIncomeForm.networth = vm.fatcaDetails.netWorth ? parseInt(vm.fatcaDetails.netWorth) : '';
          if(vm.formatNetworthDate){
            vm.folioIncomeForm.grossAnnualIncomeDate =  vm.datethreeToTwo(vm.formatNetworthDate);
          }else{
            if(vm.fatcaDetails.netWorthDate){
              vm.getGrossAnnualIncomeDate(moment(vm.fatcaDetails.netWorthDate));
              vm.folioIncomeForm.grossAnnualIncomeDate = vm.datethreeToTwo(vm.formatNetworthDate);
            }
          }
        }else{
          vm.folioIncomeForm.networth = vm.draftdataNetworth;
          vm.folioIncomeForm.grossAnnualIncomeDate = vm.draftdataNetworthDate;
        }

      }else{
      if(!vm.draftdataAnnualIncome){
        vm.folioIncomeForm.annualincome = vm.fatcaDetails.annualIncomeSlab ? vm.fatcaDetails.annualIncomeSlab: '';
      }else{
        vm.folioIncomeForm.annualincome = vm.draftdataAnnualIncome;
      }
        vm.folioIncomeForm.networth = "";
        vm.folioIncomeForm.grossAnnualIncomeDate = "";
      }
    }

   function getPayload() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
            vm.oldSoleApplicantEmail = angular.copy(resp.data.soleApplicantDetail.personalDetail.kycEmail) ? angular.copy(resp.data.soleApplicantDetail.personalDetail.kycEmail) : "";
            vm.oldSoleApplicantMobile = angular.copy(resp.data.soleApplicantDetail.personalDetail.kycMobileNo) ? angular.copy(resp.data.soleApplicantDetail.personalDetail.kycMobileNo) : "";
            vm.soleApplicantEmail = UserData.email ? UserData.email : resp.data.soleApplicantDetail.personalDetail.kycEmail;
            vm.soleApplicantMobile = UserData.mobileNumber ? UserData.mobileNumber : resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
            vm.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
            vm.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo;

            var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
          if(isEditbuttonClick && $rootScope.folioBasicDetail.folioHoldingMode == "SINGLE"){
            $rootScope.nextStep(0);
            sessionStorage.removeItem("investorIsEditButtonClick");
          }
            vm.currentFolio = resp.data;
            if($rootScope.folioBasicDetail){
              $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
            }
            vm.holdeMode = vm.currentFolio.holdmode;
            if(resp.data.soleApplicantDetail.personalDetail.taxStatusCode){
              $rootScope.showSaveTag = true;
              $timeout(function () {
                $rootScope.showSaveTag = false;
              }, 3000);

            }
            var getNewInvestorResponseData = InvestorModel.getInvestorResponse();
            if(getNewInvestorResponseData && getNewInvestorResponseData.length > 0){
              getNewInvestorResponseData.forEach(function(taxStatus,index){
                if(vm.nriTaxStatus == false && resp.data.soleApplicantDetail.personalDetail.taxStatusCode !== '01') {
                  if(taxStatus.taxStatusCode == '01'){
                    vm.folioIncomeForm.taxstatus = taxStatus.taxStatusCode;
                  }
                } else if(vm.nriTaxStatus == false && resp.data.soleApplicantDetail.personalDetail.taxStatusCode == '01'){
                  vm.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
                } else if(vm.nriTaxStatus == true && resp.data.soleApplicantDetail.personalDetail.taxStatusCode == '01'){
                  if(taxStatus.taxStatusCode !== '01'){
                    vm.folioIncomeForm.taxstatus = null;
                  }
                } else if(vm.nriTaxStatus == true && resp.data.soleApplicantDetail.personalDetail.taxStatusCode !== '01'){
                  vm.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
                }
              });
            }
            // vm.folioIncomeForm.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode ? resp.data.soleApplicantDetail.personalDetail.taxStatusCode : null;

            vm.folioIncomeForm.occupation = resp.data.soleApplicantDetail.selfDetail.occupation != null ? resp.data.soleApplicantDetail.selfDetail.occupation : vm.folioIncomeForm.occupation ;
            if(vm.folioIncomeForm.grossAnnualIncomeDate){
              vm.folioIncomeForm.grossAnnualIncomeDate = vm.datethreeToTwo(resp.data.soleApplicantDetail.selfDetail.netWorthDate);
              vm.draftdataNetworthDate = vm.folioIncomeForm.grossAnnualIncomeDate;
            }


            if(resp.data.soleApplicantDetail.selfDetail.netWorthDate){
              vm.networth = true;
              vm.folioIncomeForm.networth = resp.data.soleApplicantDetail.selfDetail.netWorth != null ? resp.data.soleApplicantDetail.selfDetail.netWorth : vm.folioIncomeForm.networth ;
              vm.draftdataNetworth = vm.folioIncomeForm.networth;
            }else{
              vm.networth = false;
              vm.folioIncomeForm.annualincome = resp.data.soleApplicantDetail.selfDetail.grossAnnualIncome !=null ? resp.data.soleApplicantDetail.selfDetail.grossAnnualIncome.toString() : vm.folioIncomeForm.annualincome;
              vm.draftdataAnnualIncome = vm.folioIncomeForm.annualincome;
            }
            vm.folioIncomeForm.Fatca.countrie = resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry ? resp.data.soleApplicantDetail.selfDetail.fatca.birthCountry : vm.folioIncomeForm.Fatca.countrie;
            vm.folioIncomeForm.Fatca.addressType = resp.data.soleApplicantDetail.selfDetail.fatca.addressType ? resp.data.soleApplicantDetail.selfDetail.fatca.addressType : vm.folioIncomeForm.Fatca.addressType;
            vm.folioIncomeForm.Fatca.city = resp.data.soleApplicantDetail.selfDetail.fatca.birthPlace != null? resp.data.soleApplicantDetail.selfDetail.fatca.birthPlace :vm.folioIncomeForm.Fatca.city;
          }else{
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      ChangeDividendService.post({child1: 'folio',child2: 'getFolioDetails'},{id:investorId,"arnCode" : identifierData.arnCode}).$promise.then(success, error);
    }


    vm.submitFolioIncomeForm = function () {
      var success = function (resp) {
        if(resp.status && resp.data){
          $rootScope.nextStep(1);
          if (vm.holdeMode == "SINGLE") {
            $state.go('main.newinvestor.folioCreation.folioNomineeDetails');
          } else {
            $state.go('main.newinvestor.folioCreation.jointholder');
          }
        }else{
          MessageService.error(resp.message);
        }
      },
      error = function (error) {
        MessageService.error(error.message);
      };


      var payload = {
        soleApplicantDetail: {
          selfDetail: {
            panNumber: vm.pan,
            occupation: vm.folioIncomeForm.occupation,
            fatca: {
              birthCountry: vm.folioIncomeForm.Fatca.countrie,
              birthPlace: vm.folioIncomeForm.Fatca.city,
              addressType: vm.folioIncomeForm.Fatca.addressType,
              payTaxInIndia : vm.currentFolio.soleApplicantDetail.selfDetail.fatca.payTaxInIndia
            }
          },
          personalDetail: {
            taxStatusCode: vm.folioIncomeForm.taxstatus,
            kycEmail: vm.oldSoleApplicantEmail,
            kycMobileNo: vm.oldSoleApplicantMobile,
            emailBelongsTo:vm.holders.emailBelongsTo,
            mobileBelongsTo:vm.holders.mobileBelongsTo
          }
        },
        nomineeOptOut:vm.currentFolio.nomineeOptOut,
        jointHolders:vm.currentFolio.jointHolders,
        nominees: vm.currentFolio.nominees,
        holdmode: vm.currentFolio.holdmode,
        id: localStorage.getItem("folioId"),
        folioSaveStep: "TWO",
        newUserFlow: true
      }
      payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
      if(vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
        payload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = vm.currentFolio.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
      }

      if(vm.networth){
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = "";
        payload.soleApplicantDetail.selfDetail.netWorth = vm.folioIncomeForm.networth;
        if(vm.folioIncomeForm.grossAnnualIncomeDate.match(/[a-zA-Z]/i)){
          payload.soleApplicantDetail.selfDetail.netWorthDate = vm.folioIncomeForm.grossAnnualIncomeDate;
        }else{
          if(vm.folioIncomeForm.grossAnnualIncomeDate){
            payload.soleApplicantDetail.selfDetail.netWorthDate = vm.datetwoTothree(vm.folioIncomeForm.grossAnnualIncomeDate);
          }
        }
      }else{
        payload.soleApplicantDetail.selfDetail.grossAnnualIncome = vm.folioIncomeForm.annualincome;
        payload.soleApplicantDetail.selfDetail.netWorth = '';
        payload.soleApplicantDetail.selfDetail.netWorthDate = "";
      }
      payload.nriFlag = vm.nriTaxStatus;

      if ((vm.oldSoleApplicantEmail || vm.oldSoleApplicantEmail == "") && (vm.oldSoleApplicantEmail !== vm.soleApplicantEmail)) {
        vm.isEmailEdited = true;
      } else if ((vm.oldSoleApplicantEmail || vm.oldSoleApplicantEmail == "") && (vm.oldSoleApplicantEmail === vm.soleApplicantEmail)) {
        vm.isEmailEdited = false;
      }

      if ((vm.oldSoleApplicantMobile || vm.oldSoleApplicantMobile == "") && (vm.oldSoleApplicantMobile !== vm.soleApplicantMobile)) {
        vm.isMobileEdited = true;
      } else if ((vm.oldSoleApplicantMobile || vm.oldSoleApplicantMobile == "") && (vm.oldSoleApplicantMobile === vm.soleApplicantMobile)){
        vm.isMobileEdited = false;
      }

      if (vm.isEmailEdited || vm.isMobileEdited) {
        if (vm.isEmailEdited) {
          payload.updateContactCo = {
            "email": vm.soleApplicantEmail,
            "change":"EMAIL"
          };
        } else if (vm.isMobileEdited) {
          payload.updateContactCo = {
            "mobileNo": vm.soleApplicantMobile,
            "change":"MOBILE"
          };
        } else {

          if (vm.currentPayload.updateContactCo) {
            delete vm.currentPayload.updateContactCo;
          }

          vm.showEditMobile = true;
          vm.isEmailEdited = true;
        }
      }

      sessionStorage.setItem("incomeDetails", JSON.stringify(vm.folioIncomeForm));
      NewInvestorServiceV3.post({child1: 'folio',child2: 'distributorNewInvestor',child3: 'initiate'},payload).$promise.then(success, error);
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){

        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){

        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
    }

  vm.datethreeToTwo = function(date) {
    var dateChar = date.split("-");
    switch(dateChar[1]){
      case "Jan":
          vm.cdate = dateChar[0]+"-01-"+dateChar[2];
          return vm.cdate;
          break;
          case "Feb":
          vm.cdate = dateChar[0]+"-02-"+dateChar[2];
          return vm.cdate;
          break;
          case "Mar":
          vm.cdate = dateChar[0]+"-03-"+dateChar[2];
          return vm.cdate;
          break;
          case "Apr":
          vm.cdate = dateChar[0]+"-04-"+dateChar[2];
          return vm.cdate;
          break;
          case "May":
          vm.cdate = dateChar[0]+"-05-"+dateChar[2];
          return vm.cdate;
          break;
          case "Jun":
          vm.cdate = dateChar[0]+"-06-"+dateChar[2];
          return vm.cdate;
          break;
          case "Jul":
          vm.cdate = dateChar[0]+"-07-"+dateChar[2];
          return vm.cdate;
          break;
          case "Aug":
          vm.cdate = dateChar[0]+"-08-"+dateChar[2];
          return vm.cdate;
          break;
          case "Sep":
          vm.cdate = dateChar[0]+"-09-"+dateChar[2];
          return vm.cdate;
          break;
          case "Oct":
          vm.cdate = dateChar[0]+"-10-"+dateChar[2];
          return vm.cdate;
          break;
          case "Nov":
          vm.cdate = dateChar[0]+"-11-"+dateChar[2];
          return vm.cdate;
          break;
          case "Dec":
          vm.cdate = dateChar[0]+"-12-"+dateChar[2];
          return vm.cdate;
          break;
      default:
        return "wrong date.";
    }
  }

  vm.datetwoTothree = function(date) {
    var dateChar = date.split("-");
    switch(dateChar[1]){
      case "01":
          vm.cdate = dateChar[0]+"-Jan-"+dateChar[2];
          return vm.cdate;
          break;
          case "02":
          vm.cdate = dateChar[0]+"-Feb-"+dateChar[2];
          return vm.cdate;
          break;
          case "03":
          vm.cdate = dateChar[0]+"-Mar-"+dateChar[2];
          return vm.cdate;
          break;
          case "04":
          vm.cdate = dateChar[0]+"-Apr-"+dateChar[2];
          return vm.cdate;
          break;
          case "05":
          vm.cdate = dateChar[0]+"-May-"+dateChar[2];
          return vm.cdate;
          break;
          case "06":
          vm.cdate = dateChar[0]+"-Jun-"+dateChar[2];
          return vm.cdate;
          break;
          case "07":
          vm.cdate = dateChar[0]+"-Jul-"+dateChar[2];
          return vm.cdate;
          break;
          case "08":
          vm.cdate = dateChar[0]+"-Aug-"+dateChar[2];
          return vm.cdate;
          break;
          case "09":
          vm.cdate = dateChar[0]+"-Sep-"+dateChar[2];
          return vm.cdate;
          break;
          case "10":
          vm.cdate = dateChar[0]+"-Oct-"+dateChar[2];
          return vm.cdate;
          break;
          case "11":
          vm.cdate = dateChar[0]+"-Nov-"+dateChar[2];
          return vm.cdate;
          break;
          case "12":
          vm.cdate = dateChar[0]+"-Dec-"+dateChar[2];
          return vm.cdate;
          break;
      default:
        return "wrong date.";
    }
  }
  if(vm.fatcaDetails){
      vm.folioIncomeForm.occupation = vm.fatcaDetails.occupation ? vm.fatcaDetails.occupation :'';
      vm.folioIncomeForm.Fatca.countrie =vm.fatcaDetails.countryOfBirth ? vm.fatcaDetails.countryOfBirth:'IN';
      vm.folioIncomeForm.Fatca.addressType =vm.fatcaDetails.addressType ? vm.fatcaDetails.addressType:'RESIDENTIAL';
      vm.folioIncomeForm.Fatca.city =vm.fatcaDetails.placeOfBirth ? vm.fatcaDetails.placeOfBirth :'';
      vm.folioIncomeForm.annualincome = vm.fatcaDetails.annualIncomeSlab ? vm.fatcaDetails.annualIncomeSlab : '';
  }

      function updateContactInfo(changeType) {
        var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
        if(changeType === "email"){
          vm.soleApplicantEmail = angular.copy(UserData.email);
          vm.showEditMobile = false;
          vm.isEmailEdited = true;
        }else if(changeType === "mobile"){
          vm.soleApplicantMobile = angular.copy(UserData.mobileNumber);
          vm.showEditEmail = false;
          vm.isMobileEdited = true;
        }
      }

      function hideUiFnc(type) {
        if (type == 'email') {
          vm.hideEditEmail = true;
        } else if (type == 'mobile') {
          vm.hideEditMobile = true;
        }
      }

      function showUiFnc(type) {
        if (type == 'email') {
          vm.hideEditEmail = false;
        } else if (type == 'mobile') {
          vm.hideEditMobile = false;
        }
      }

    }
  })();

(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('FolioJointHolderDetailsController', FolioJointHolderDetailsController);

  /** @ngInject */
  function FolioJointHolderDetailsController(InvestorsService,$state,$window,AppConstants,LoaderService,$rootScope,$location,NewInvestorServiceV3,ChangeDividendService,MessageService, ModalService,AuthService,$scope,UtilService,InvestorServiceDynamicData, dynamicData) {
    var vm = this;
    var date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    vm.minDate = date;
    vm.panMessage = "";
    vm.addthirdholder = false;
    vm.holders = [];
    vm.emailDetails = {};
    $rootScope.myState = $state.current.url;
    vm.investorDetails = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.investorDetails.nriTaxStatus;
    var identifierData = AuthService.getToken();
    vm.taxStatus = taxStatus;
    vm.taxStatusChanged = taxStatusChanged;
    vm.changedRiNriTaxStatus = changedRiNriTaxStatus;
    vm.taxStatusHoldArray = []
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    vm.appconstants = AppConstants;
    $rootScope.addholder = {
    steps: [
      { step: 1, isactive: true },
      { step: 2, isactive: false },
      { step: 3, isactive: false }
    ]
  }
  vm.autoDate = function(){
    var oldlength = 0 ;
    if(vm.dobString){
       oldlength = vm.dobString.length;
    }
    vm.dobString = $("#grossAnnualIncomeDateId").val();
    var newlength = vm.dobString.length;
    if( vm.dobString.length == 2){
       if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
    }
    if( vm.dobString.length == 5){
      if((newlength== (oldlength - 1)) || (newlength == oldlength)){
      } else{
        $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
      }
    }
  }
  vm.jointHolderDetails = {
    email: '',
    mobileNumber: '',
    fatcaDetail: {
      birthPlace: '',
      birthCountry: '',
      payTaxInIndia: true,
      addressType: '',
      countryCitizenship: "",
      thirdTax: false
    },
    grossAnnualIncome: '',
    netWorth: "",
    netWorthDate: '',
    occupationCode: '',
    pan: '',
    politicalStatus: "NONE",
    taxStatusCode: '',
    jointHolderName: '',
    kycverified: '',
    nriFlag: null
  };
  vm.sameFirstHoderDetails = false;
  vm.addthirdholderinfolio = function () {
    var confirmSuccess = function (data) {
      vm.holderData.pan = data.pan;
      if (data) {
          vm.holderData.jointHolderName = data.name;
          vm.holderData.email = data.email;
          vm.holderData.mobileNoWithoutMask = data.mobileNoWithoutMask;
          vm.holderData.kycverified = data.kycverified;
          vm.AllowedJointHolder = true;
          vm.processFlag = true;
          vm.wrongMsg = '';
          vm.holderData.taxStatusResident = data.taxStatusResident;
        }
      vm.verifyOrAddHolder3();
      // vm.closeModal();
    };
    var confirmError = function () {
      // task.done = false;
    };
    ModalService.addJointHolderModal({}, confirmSuccess, confirmError);
    // vm.addthirdholder = !vm.addthirdholder;
  }
  vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
  vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;

  vm.jointHolderTaxDetails_politicalStatus = 'No';

  vm.getTaxFileStatusForJointHolder = function (value) {
    try{
      if (value == 'Yes') {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
        vm.jointHolderDetails.fatcaDetail.payTaxInIndia = false;
        vm.jointHolderDetails.fatcaDetail.fatcaTax1 = {
          taxPayingCountry:vm.FATACADETAILS.taxCountry,
          taxIdType:vm.FATACADETAILS.taxIdentificationType,
          taxPayingCity:"",
          taxId:vm.FATACADETAILS.taxIdentificationNumber
        }
        // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
      } else {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
        vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;
        vm.jointHolderDetails.fatcaDetail.fatcaTax1 = {};
        // console.log(vm.jointHolderDetails.fatcaDetail.secondTax);
      }
    }
    catch(e){

    }
  }
  vm.getPEPStatusForJointHolder = function (value) {
    // console.log(vm.jointHolderDetails.politicalStatus);
    if (value == 'Yes') {
      vm.jointHolderTaxDetails_politicalStatus = 'Yes';
      vm.jointHolderDetails.politicalStatus = 'POLITICAL';
    } else {
      vm.jointHolderTaxDetails_politicalStatus = 'No';
      vm.jointHolderDetails.politicalStatus = 'NONE';
    }
    // console.log(vm.jointHolderDetails.politicalStatus);
  }
  vm.resetValues = function () {
    vm.errorMessage = "";
    vm.errorMessageVerify = "";
    vm.panMessage = "";
    vm.availableMessage = "";
    vm.otpResendMessage = "";
    vm.dateErrorMessage = "";
  }
  // holder
  vm.stopaddholder = true;
  vm.holderData = {};
  vm.holderData.pan = '';
  vm.holderData.HolderName ='';
  vm.holderData.email = '';
  vm.holderData.mobileNumber = '';
  vm.jointHolderDetails.kycverified = false;
  vm.holderData.taxStatusResident = true;
  vm.AllowedJointHolder = true;
  vm.checkPanEmailExist = function () {
          var success = function (resp) {
            vm.processFlag = false;
            LoaderService.hideLoader('.popup');
            if (resp.status && resp.data) {
              if(resp.data.ekycStatus !== vm.appconstants.KYC_STATUS.NOT_VALIDATED && resp.data.ekycStatus !== vm.appconstants.KYC_STATUS.ON_HOLD) {
                if (resp.data && resp.data.emailExists === true) {
                  vm.holderData.jointHolderName = resp.data.name;
                  vm.holderData.email = resp.data.email;
                  vm.holderData.mobileNoWithoutMask = resp.data.mobileNoWithoutMask;
                  vm.holderData.kycverified = resp.data.kycverified;
                  vm.AllowedJointHolder = true;
                  vm.processFlag = true;
                  vm.wrongMsg = '';
                  vm.panMessage = '';
                } else {
                  vm.showEmail = true;
                  vm.holderData.jointHolderName = resp.data.name;
                  vm.holderData.mobileNoWithoutMask = resp.data.mobileNoWithoutMask;
                  vm.holderData.kycverified = resp.data.kycverified;
                }
              }
              if (resp.data.ekycStatus === vm.appconstants.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.appconstants.KYC_STATUS.ON_HOLD) {
                ModalService.nonKycModal({
                  'text': resp.data.ekycStatus === vm.appconstants.KYC_STATUS.ON_HOLD ?
                    "<p>Your KYC Status is 'On hold'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'.</p>" :
                    "<p>Your KYC Status is 'Registered'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate update KYC process to change KYC status to 'Validated'.</p>",
                  'showHtml': true,
                  'buttonText': 'OK',
                }, function () {
                  vm.processFlag = false;
                }, function () { });
              }
            } else {
              if(resp.popupEnabled){
                vm.panMessage = resp.message;
              }else{
                vm.wrongMsg = resp.message;
                MessageService.error(resp.message);
              }
            }
          },
          error = function () {
          vm.processFlag = false;
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          };
          var payload = {
            pan: vm.holderData.pan,
            nriFlag: !vm.holderData.taxStatusResident
          };
          LoaderService.showLoader('.popup');
          if(payload.pan){
            InvestorsService.post({controller: 'holder',child1: 'pan',child2: 'details'}, payload).$promise.then(success, error);
          }
    }

  vm.showEmail = false;
  vm.showOtp = false;
  vm.Otp = '';
  vm.AddEmailToHolderPan = function () {
    vm.Otp = '';
    var success = function (resp) {
      LoaderService.hideLoader('.popup');
      vm.processFlag = false;
      if (resp.status && resp.data) {
        // vm.AllowedJointHolder = false;
        vm.emailDetails.secretLink = resp.data.secretLink;
        vm.emailDetails.message = resp.data.message;
        vm.showOtp = true;
      }
    },
    error = function () {
      vm.processFlag = false;
      LoaderService.hideLoader('.popup');
      vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
    };
    var payload = {
      pan: vm.holderData.pan,
      email: vm.holderData.email
    };
    LoaderService.showLoader('.popup');
  InvestorsService.post({
    controller: 'holder',
    child1: 'pan',
    child2: 'add',
    child3: 'email',
    child4: 'send',
    child5: 'otp'
  }, payload).$promise.then(success, error);
  }

  vm.verifyOtp = function () {
    var success = function (resp) {
      LoaderService.hideLoader('.popup');
      vm.processFlag = false;
      if (resp.status && resp.data && resp.data.verified) {
        vm.showOtp = false;
        vm.AllowedJointHolder = true;
        vm.holderData.email=vm.holderData.email;
        vm.showEmail = false;
        vm.processFlag = true;
      } else {
        MessageService.error(resp.message);
      }
    },
    error = function () {
      vm.processFlag = false;
      vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
    };

    var payload = {
      uniqueLink: vm.emailDetails.secretLink,
      otp: vm.Otp
    };

  LoaderService.showLoader('.popup');
  InvestorsService.post({
    controller: 'holder',
    child1: 'pan',
    child2: 'add',
    child3: 'email',
    child4: 'verify',
    child5: 'otp'
  }, payload).$promise.then(success, error);
  }
  vm.OTPResendMsg = '';
  vm.reGenerateOtp = function () {
    var success = function (resp) {
      LoaderService.hideLoader('.popup');
      vm.processFlag = false;
      if (resp.status && resp.data) {
        vm.OTPResendMsg = resp.data.message;
        MessageService.success(vm.OTPResendMsg);
        vm.emailMsg = "";
        vm.emailDetails.secretLink = resp.data.secretLink;
        resetTimer();
      } else {
        vm.wrongMsg = resp.message;
        MessageService.error(resp.message);
      }
    },
    error = function () {
      LoaderService.hideLoader('.popup');
      vm.processFlag = false;
      vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
    };
    vm.payload = {
      pan: vm.holderData.pan,
      secretLink: vm.emailDetails.secretLink,
      email: vm.holderData.email
    };
    LoaderService.showLoader('.popup');
    InvestorsService.post({
      controller: 'holder',
      child1: 'pan',
      child2: 'add',
      child3: 'email',
      child4: 'resend',
      child5: 'otp'
    }, vm.payload).$promise.then(success, error);
  }
  // add holder
  vm.verifyOrAddHolder2 = function () {
    if(vm.investorDetails.pan === vm.holderData.pan){
      MessageService.error("You can't add joint holder yourself.");
    }else{
      $rootScope.addholder.steps[0].isactive = false;
    $rootScope.addholder.steps[1].isactive = true;
    vm.jointHolderDetails = {
      email: vm.holderData.email,
      mobileNumber:vm.holderData.mobileNoWithoutMask,
      fatcaDetail: {
        birthPlace: "",
        birthCountry: "",
        payTaxInIndia: true,
        addressType: "",
        countryCitizenship: "",
        fatcaTax1 : {},
        secondTax:false,
        thirdTax: false
      },
      grossAnnualIncome: '',
      netWorth: "",
      netWorthDate: "",
      occupationCode: "",
      pan: vm.holderData.pan,
      politicalStatus: "NONE",
      taxStatusCode: "",
      jointHolderName : vm.holderData.jointHolderName,
      kycverified : vm.holderData.kycverified,
      nriFlag: !vm.holderData.taxStatusResident
    };
    vm.holders.push(vm.jointHolderDetails);
    vm.holderLength = vm.holders.length;
    vm.holderData.pan = '';
    vm.holderData.jointHolderName = '';
    vm.holderData.kycverified = '';
    vm.holderData.email = '';
    }
  }

  vm.verifyOrAddHolder3 = function () {
    if(vm.holderData.pan === vm.investorDetails.pan){
      MessageService.error("You can't add joint holder yourself.");
    }else{
      if(vm.holderData.pan === vm.holders[0].pan){
        MessageService.error("You can't add same joint holder.");
      }else{
        $rootScope.addholder.steps[0].isactive = false;
        $rootScope.addholder.steps[1].isactive = true;
        vm.jointHolderDetails = {
          email: vm.holderData.email,
          mobileNumber:vm.holderData.mobileNoWithoutMask,
          fatcaDetail: {
            birthPlace: "",
            birthCountry: "",
            payTaxInIndia: true,
            addressType: "",
            countryCitizenship: "",
            fatcaTax1:{},
            secondTax:false,
            thirdTax: false
          },
          grossAnnualIncome: '',
          netWorth: "",
          netWorthDate: "",
          occupationCode: "",
          pan: vm.holderData.pan,
          politicalStatus: "NONE",
          taxStatusCode: "",
          jointHolderName : vm.holderData.jointHolderName,
          kycverified : vm.holderData.kycverified,
          nriFlag: !vm.holderData.taxStatusResident
        };
        vm.holders.push(vm.jointHolderDetails);
        vm.holderLength = vm.holders.length;
        vm.addthirdholder = false;
        vm.stopaddholder = false;
        vm.holderData.pan = '';
        vm.holderData.email = '';
      }

    }

  }
  vm.deleteHolder = function(index){

    var model = vm.holders || [];
    model.splice(index, 1);
    vm.holders = model;
    if(vm.holders && vm.holders.length >= 1 && $rootScope.addholder.steps[2].isactive) {
      vm.holdernext();
    }
    if(model && (model.length === 0 || model.length === 1)) {
      vm.stopaddholder = true;
    }
    // vm.holders.splice(index, 1);
    vm.holderLength = vm.holders.length;

    if(vm.holderLength == 0){
      // $rootScope.addholder.steps[0].isactive = true;
      // $rootScope.addholder.steps[1].isactive = false;
      // $rootScope.addholder.steps[2].isactive = false;
      vm.holderData.taxStatusResident = true;
      vm.submitHolder(true);
    }
    if(vm.holderLength == 1){
      vm.stopaddholder = true;
    }
  }
  vm.networth = false;
  vm.networthcall = function () {
    vm.networth = !vm.networth;
    if(vm.networth == false){
      vm.notolderthan1year = false;
      vm.jointHolderDetails.grossAnnualIncome = vm.FATACADETAILS.annualIncomeSlab;
    }
    if(vm.networth == true){
      vm.notolderthan1year = false;
      vm.jointHolderDetails.netWorth = vm.jointHolderDetails.netWorth ? vm.jointHolderDetails.netWorth : vm.FATACADETAILS.netWorth;
      vm.jointHolderDetails.netWorthDate = vm.jointHolderDetails.netWorthDate ? vm.jointHolderDetails.netWorthDate : vm.FATACADETAILS.netWorthDate;
      vm.getGrossAnnualIncomeDateOfHolder(moment(vm.jointHolderDetails.netWorthDate));
    }
  }
  vm.holdernext = function () {
    $rootScope.addholder.steps[0].isactive = false;
    $rootScope.addholder.steps[1].isactive = false;
    $rootScope.addholder.steps[2].isactive = true;
    vm.holderCount = vm.holders.length;
    vm.getholdersdata(0);
    vm.holderTab = 0;
  }

  vm.getholdersdata = function (numberofholder) {
    // console.log(numberofholder);
    if(numberofholder == 1){
      vm.showSameHOlderDetail = true;
      vm.sameFirstHoderDetails = false;
      taxStatus(numberofholder);
    }else{
      vm.showSameHOlderDetail = false;
      vm.sameFirstHoderDetails = false;
      taxStatus(numberofholder);
    }
    vm.holderCount = vm.holders.length
    vm.holderTab = numberofholder;
    vm.currentHolder = vm.holders[numberofholder];
    // console.log(vm.currentHolder);

    if(vm.currentHolder.netWorthDate){
      vm.networth = true;
    }else{
      vm.networth = false;
    }

    if (vm.currentHolder.fatcaDetail.payTaxInIndia == true) {
      vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
      vm.currentHolder.fatcaDetail.payTaxInIndia = true;
    } else {
      vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
      vm.currentHolder.fatcaDetail.payTaxInIndia = false;
    }

    if (vm.currentHolder.politicalStatus == 'NONE') {
      vm.jointHolderTaxDetails_politicalStatus = 'No';
      vm.currentHolder.politicalStatus = 'NONE';
    } else {
      vm.jointHolderTaxDetails_politicalStatus = 'Yes';
      vm.currentHolder.politicalStatus = 'POLITICAL';
    }


    vm.jointHolderDetails = {
      email: vm.currentHolder.email,
      emailBelongsTo : vm.currentHolder.emailBelongsTo ? vm.currentHolder.emailBelongsTo : "",
      mobileNumber: vm.currentHolder.mobileNumber,
      fatcaDetail: {
        birthPlace: vm.currentHolder.fatcaDetail.birthPlace,
        birthCountry: vm.currentHolder.fatcaDetail.birthCountry,
        payTaxInIndia: vm.currentHolder.fatcaDetail.payTaxInIndia,
        addressType: vm.currentHolder.fatcaDetail.addressType,
        fatcaTax1:vm.currentHolder.fatcaDetail.fatcaTax1,
        secondTax:false,
        thirdTax: false
      },
      netWorth: vm.currentHolder.netWorth ? vm.currentHolder.netWorth : '',
      netWorthDate: vm.currentHolder.netWorthDate ? vm.currentHolder.netWorthDate : '',
      occupationCode: vm.currentHolder.occupationCode,
      pan: vm.currentHolder.pan,
      politicalStatus: vm.currentHolder.politicalStatus,
      taxStatusCode: vm.currentHolder.taxStatusCode,
      jointHolderName: vm.currentHolder.jointHolderName,
      kycverified: false,
      mobileBelongsTo : vm.currentHolder.mobileBelongsTo ? vm.currentHolder.mobileBelongsTo : "",
      nriFlag: vm.currentHolder.nriFlag
    };
    vm.jointHolderDetails.grossAnnualIncome = vm.currentHolder && vm.currentHolder.grossAnnualIncome ? vm.currentHolder.grossAnnualIncome.toString() : "";
    vm.getFatacaDetails(vm.currentHolder, function(FATACADETAILS){
      vm.jointHolderDetails.occupationCode = vm.jointHolderDetails.occupationCode ? vm.jointHolderDetails.occupationCode :FATACADETAILS.occupation;
      if(vm.networth){
        vm.jointHolderDetails.netWorth = vm.jointHolderDetails.netWorth ? vm.jointHolderDetails.netWorth :FATACADETAILS.netWorth ;
        vm.jointHolderDetails.netWorthDate = vm.jointHolderDetails.netWorthDate ? vm.jointHolderDetails.netWorthDate :FATACADETAILS.netWorthDate;
      }else{
        vm.jointHolderDetails.grossAnnualIncome = vm.jointHolderDetails.grossAnnualIncome ? vm.jointHolderDetails.grossAnnualIncome : FATACADETAILS.annualIncomeSlab;
      }
      vm.jointHolderDetails.fatcaDetail.birthCountry = vm.jointHolderDetails.fatcaDetail.birthCountry ? vm.jointHolderDetails.fatcaDetail.birthCountry :FATACADETAILS.countryOfBirth;
      vm.jointHolderDetails.fatcaDetail.addressType = vm.jointHolderDetails.fatcaDetail.addressType ? vm.jointHolderDetails.fatcaDetail.addressType :FATACADETAILS.addressType;
      vm.jointHolderDetails.fatcaDetail.birthPlace = vm.jointHolderDetails.fatcaDetail.birthPlace ? vm.jointHolderDetails.fatcaDetail.birthPlace :FATACADETAILS.placeOfBirth;
      if(vm.currentHolder.occupationCode == ""){
        if(FATACADETAILS.taxOutsideIndia == 'Y'){
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = false;
        }else{
          vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
          vm.jointHolderDetails.fatcaDetail.payTaxInIndia = true;
        }
      }
      if(vm.jointHolderDetails.fatcaDetail.payTaxInIndia){
        if(vm.jointHolderDetails.fatcaDetail.fatcaTax1){
          vm.jointHolderDetails.fatcaDetail.fatcaTax1 = {};
        }
      }else{
        if(vm.jointHolderDetails.fatcaDetail.fatcaTax1){
          vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry = vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry ? vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry : FATACADETAILS.taxCountry;
          if($rootScope.taxIDType){
            var key = "";
            $rootScope.taxIDType.forEach(function(el){
              if(el.code == FATACADETAILS.taxIdentificationType){
                key = el.key;
              }
            });
          vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType = vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType ? vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType : key;
          }
          vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity = vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity ? vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity : "";
          vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxId = vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxId ? vm.jointHolderDetails.fatcaDetail.fatcaTax1.taxId : FATACADETAILS.taxIdentificationNumber;
        }
      }
    });
  }

  vm.getGrossAnnualIncomeDateOfHolder = function (date) {
    if (angular.isDefined(date._i) ||
      /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
      vm.jointHolderDetails.netWorthDate = moment(date).format("DD-MMM-YYYY");
      vm.dobmilisecond = moment(date).valueOf();
      vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
      if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
        // console.log(vm.grossAnnualIncomeYear);
        vm.notolderthan1year = false;
      }
      else {
        vm.jointHolderDetails.netWorthDate = "";
        MessageService.error('Networth date should not be older than 1 year');
        vm.notolderthan1year = true;
      }
      if (!date) {
        vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
      } else vm.dateErrorMessage = '';

    } else {
      vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
      vm.jointHolderDetails.netWorthDate = "";
    }
    return;
  }
  vm.nextFlag = false;
  vm.submithHolderIncomeDetails = function (holderIndex) {
    vm.holders[holderIndex] = vm.jointHolderDetails;
    vm.nextFlag = true;
    try{
      if(vm.holders.length == 2 && !vm.holders[1].occupationCode){
        vm.getholdersdata(1);
        vm.holderTab = 1;
        vm.nextFlag = false;
        $window.scroll({
          top:0,
          left:0,
          behaviour:'smooth'
        });
      }else  if(vm.holders.length == 2 && !vm.holders[1].emailBelongsTo && !vm.holders[1].mobileBelongsTo){
        vm.getholdersdata(1);
        vm.holderTab = 1;
        vm.nextFlag = false;
        $window.scroll({
          top:0,
          left:0,
          behaviour:'smooth'
        });
      }else{
        vm.nextFlag = true;
        vm.submitHolder();
      }
    }catch(e){}
  }

  vm.addFirstHolderData = function () {
    vm.sameFirstHoderDetails  = !vm.sameFirstHoderDetails;
    if (vm.sameFirstHoderDetails == true) {
      vm.fistHolder = vm.holders[0];
      if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
        vm.fistHolder.fatcaDetail.payTaxInIndia = true;
      } else {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
        vm.fistHolder.fatcaDetail.payTaxInIndia = false;
      }

      if(vm.fistHolder.netWorthDate){
        vm.networth = true;
      }else{
        vm.networth = false;
      }
      if (vm.fistHolder.politicalStatus == 'NONE') {
          vm.fistHolder.politicalStatus = 'NONE';
        vm.jointHolderTaxDetails_politicalStatus = 'No';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.fistHolder.politicalStatus = 'POLITICAL';
      }
      var taxData = vm.fistHolder.fatcaDetail.fatcaTax1;

      vm.jointHolderDetails = {
        email: vm.currentHolder.email,
        emailBelongsTo : vm.currentHolder.emailBelongsTo ? vm.currentHolder.emailBelongsTo : "",
        mobileNumber: vm.currentHolder.mobileNumber,
        fatcaDetail: {
          birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
          birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
          payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
          addressType: vm.fistHolder.fatcaDetail.addressType,
          countryCitizenship: "",
          fatcaTax1:taxData,
          secondTax:false,
          thirdTax: false
        },
        grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
        netWorth: vm.fistHolder.netWorth,
        netWorthDate: vm.fistHolder.netWorthDate,
        occupationCode: vm.fistHolder.occupationCode,
        pan: vm.currentHolder.pan,
        politicalStatus: vm.fistHolder.politicalStatus,
        taxStatusCode: vm.fistHolder.taxStatusCode,
        jointHolderName: vm.currentHolder.jointHolderName,
        kycverified: vm.fistHolder.kycverified,
        mobileBelongsTo : vm.currentHolder.mobileBelongsTo ? vm.currentHolder.mobileBelongsTo : "",
        nriFlag: null
      };
      if(vm.fistHolder.nriFlag == false && vm.currentHolder.nriFlag== false) {
        vm.jointHolderDetails.nriFlag = false;
        vm.jointHolderDetails.taxStatusCode = vm.fistHolder.taxStatusCode;
      } else if(vm.fistHolder.nriFlag == true && vm.currentHolder.nriFlag== true) {
        vm.jointHolderDetails.nriFlag = true;
        vm.jointHolderDetails.taxStatusCode = vm.fistHolder.taxStatusCode;
      } else if(vm.fistHolder.nriFlag == false && vm.currentHolder.nriFlag== true) {
        vm.jointHolderDetails.nriFlag = true;
        vm.jointHolderDetails.taxStatusCode = vm.currentHolder.taxStatusCode;
      } else if(vm.fistHolder.nriFlag == true && vm.currentHolder.nriFlag== false) {
        vm.jointHolderDetails.nriFlag = false;
        vm.jointHolderDetails.taxStatusCode = vm.currentHolder.taxStatusCode;
      }
    } else {
      vm.fistHolder = vm.holders[1];
      if (vm.fistHolder.fatcaDetail.payTaxInIndia == true) {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'No';
        vm.currentHolder.fatcaDetail.payTaxInIndia = true;
      } else {
        vm.jointHolderTaxDetails_fileTaxOtherIndian = 'Yes';
        vm.currentHolder.fatcaDetail.payTaxInIndia = false;
      }
      if(vm.fistHolder.netWorthDate){
        vm.networth = true;
      }else{
        vm.networth = false;
      }
      if (vm.fistHolder.politicalStatus == 'NONE') {
        vm.jointHolderTaxDetails_politicalStatus = 'No';
        vm.fistHolder.politicalStatus = 'NONE';
      } else {
        vm.jointHolderTaxDetails_politicalStatus = 'Yes';
        vm.fistHolder.politicalStatus = 'POLITICAL';
      }
      var taxData1 = vm.fistHolder.fatcaDetail.fatcaTax1;

      vm.jointHolderDetails = {
        email: vm.fistHolder.email,
        mobileNumber: vm.fistHolder.mobileNumber,
        fatcaDetail: {
          birthPlace: vm.fistHolder.fatcaDetail.birthPlace,
          birthCountry: vm.fistHolder.fatcaDetail.birthCountry,
          payTaxInIndia: vm.fistHolder.fatcaDetail.payTaxInIndia,
          addressType: vm.fistHolder.fatcaDetail.addressType,
          countryCitizenship: "",
          fatcaTax1:taxData1,
          secondTax:false,
          thirdTax: false
        },
        grossAnnualIncome: vm.fistHolder.grossAnnualIncome,
        netWorth: vm.fistHolder.netWorth,
        netWorthDate: vm.fistHolder.netWorthDate,
        occupationCode: vm.fistHolder.occupationCode,
        pan: vm.currentHolder.pan,
        politicalStatus: vm.fistHolder.politicalStatus,
        taxStatusCode: vm.fistHolder.taxStatusCode,
        jointHolderName: vm.currentHolder.jointHolderName,
        kycverified: false,
        nriFlag: vm.currentHolder.nriFlag
      };

      if(!vm.currentHolder.nriFlag && vm.taxStatusData && vm.taxStatusData.length > 0) {
        var taxStatus = vm.taxStatusData.filter(function (taxStatus) {
          return taxStatus.taxStatusCode == '01';
        });
        if (taxStatus && taxStatus.length > 0) {
          vm.jointHolderDetails.taxStatusCode = taxStatus[0].taxStatusCode;
          vm.holders[1].taxStatusCode = taxStatus[0].taxStatusCode;
        }
      }
      // console.log(vm.jointHolderDetails);
    }
  }

  vm.getNewUserDetails = function(){
    var success = function (resp) {
      localStorage.setItem("folioId", resp.data.folioCreationDraftId);
    },
    error = function (error) {
      MessageService.error(error.message);
    };
    var taxIdentifier = vm.investorDetails.pan;
    var payload = {
      "panNumber":taxIdentifier,
      "arnCode":identifierData.arnCode
    }
    InvestorsService.post({child1: 'new',child2: 'user',child3: 'getDetails'},payload).$promise.then(success, error);
  }
  // vm.getNewUserDetails();
  vm.notolderthan1year = false;
  vm.getOldFolioData = function () {
    var success = function (resp) {
      if (resp.status && resp.data) {
        vm.currentPayload = resp.data;
        if($rootScope.folioBasicDetail){
          $rootScope.folioBasicDetail.folioHoldingMode = resp.data.holdmode;
        }
        var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
          if(isEditbuttonClick){
            if($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE'){
            }else{
              $rootScope.nextStep(0);
              $rootScope.nextStep(1);
            }
          }
        vm.holdeMode = resp.data.holdmode;
        // if holder is already present
        if(resp.data.jointHolders.length  == 1){
          vm.holders = resp.data.jointHolders;
          vm.mapOldHoders(vm.holders);
          $rootScope.addholder.steps[0].isactive = false;
          $rootScope.addholder.steps[1].isactive = false;
          $rootScope.addholder.steps[2].isactive = true;
          vm.getholdersdata(0);
          vm.holderTab = 0;
        }
        if(resp.data.jointHolders.length  == 2){
          vm.holders = resp.data.jointHolders;
          vm.mapOldHoders(vm.holders);
          $rootScope.addholder.steps[0].isactive = false;
          $rootScope.addholder.steps[1].isactive = false;
          $rootScope.addholder.steps[2].isactive = true;
          vm.getholdersdata(0);
          vm.holderTab = 0;
        }


      } else {
        MessageService.error(resp.message);
      }
    }, error = function (error) {
      MessageService.error(error.message);
    };
    var investorId = localStorage.getItem("folioId");
    ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId,"arnCode" :identifierData.arnCode}).$promise.then(success, error);
  }
  vm.getOldFolioData();

  vm.submitHolder = function(latsHolderDeleted){
    var success = function (resp) {
      if(resp.status && resp.data){
        if(latsHolderDeleted){
          $rootScope.addholder.steps[0].isactive = true;
          $rootScope.addholder.steps[1].isactive = false;
          $rootScope.addholder.steps[2].isactive = false;
        } else {
          $rootScope.nextStep(2);
          $state.go('main.newinvestor.folioCreation.folioNomineeDetails');
        }
      }else{
        vm.nextFlag = false;
        MessageService.error(resp.message);
      }
    },
    error = function (error) {
      vm.nextFlag = false;
       MessageService.error(error.message);
    };

    vm.currentPayload.id = localStorage.getItem("folioId");
    vm.currentPayload.jointHolders = vm.holders;
    vm.currentPayload.holdmode = vm.holdeMode;
    vm.currentPayload.folioSaveStep = "THREE";
    vm.currentPayload.newUserFlow = true;
    vm.currentPayload.minor = false,
    vm.currentPayload.firstFolio = true;
    vm.currentPayload.nriFlag = vm.nriTaxStatus;
    if(latsHolderDeleted) {
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.resetHolder = "true";
    }
    NewInvestorServiceV3.post({child1: 'folio',child2: 'distributorNewInvestor',child3: 'initiate'},vm.currentPayload).$promise.then(success, error);
  }
  function resetTimer() {
    $scope.$broadcast('timer-add-cd-seconds', vm.appconstants.RESEND_OTP_COUNTER);
  }

  vm.mapOldHoders = function(val){
    var temmpHolders = [];
    val.forEach(function(item){
      if(!item.jointHolderName){
        item.jointHolderName = item.firstName +' '+ item.middleName +' '+item.lastName;
      }
      temmpHolders.push(item);
    })
    vm.holders = temmpHolders;
  }

  function fetchBelongsToDropdown() {
    var success = function (resp) {
      LoaderService.hideLoader();
      if (resp.status && resp.data) {
        vm.belongToListEmail = resp.data.emailList;
        vm.belongToListMobile = resp.data.mobileList;
      } else {
        MessageService.error(resp.message);
      }
    },error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
    };
    LoaderService.showLoader();
    InvestorServiceDynamicData.get({child1: 'contactType',child2: 'details'}).$promise.then(success, error);
  }
  fetchBelongsToDropdown();
  vm.getFatacaDetails = function (holder,cb) {
      cb = cb || function () {};
    var success = function (resp) {
      if (resp.status && resp.data) {
        vm.FATACADETAILS = resp.data;
        cb(vm.FATACADETAILS);
      } else {
        vm.FATACADETAILS = null;
        MessageService.error(resp.message);
      }
    }, error = function (err) {
      vm.FATACADETAILS = null;
      MessageService.error(err.message);
    };
    var payload = {
      "panNumber": holder.pan
    };
    InvestorsService.post({ controller: 'getFatcaDetailStandalone' }, payload).$promise.then(success, error);
  }

    function taxStatus(tab) {
      var successTaxStatus = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.taxStatusData = resp.data.taxStatus;
            if(!vm.holders[tab].nriFlag) {
              var taxStatus = vm.taxStatusData.filter(function (taxStatus) {
                return taxStatus.taxStatusCode == '01';
              });
              if (taxStatus && taxStatus.length > 0) {
                vm.jointHolderDetails.taxStatusCode = taxStatus[0].taxStatusCode;
                vm.holders[tab].taxStatusCode = taxStatus[0].taxStatusCode;
              }
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader('.popup');
        };
        var payloadTaxStatus = {
          taxStatusFilter: 'ADULT',
          nriFlag: tab == 0 ? vm.holders[0].nriFlag : vm.holders[1].nriFlag
        };
      LoaderService.showLoader('.popup');
      InvestorsService.post({ controller: 'tax-status' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }

    function taxStatusChanged(taxStatusValue, holderTab) {
      if(vm.holders && vm.holders.length > 0) {
        vm.holders[holderTab].taxStatusCode = taxStatusValue;
      }
    }

    function changedRiNriTaxStatus(){
        vm.holderData.pan = "";
        vm.resetValues();
    }

  }
})();

(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('FolioMinorGuardianDetailsController', FolioMinorGuardianDetailsController);

  /** @ngInject */
  function FolioMinorGuardianDetailsController(ModalService,LoaderService,FileUploadService,NewInvestorServiceV3,ChangeDividendService,$state,HDFC_API,AppConstants,$window,$rootScope,MessageService, AuthService,InvestorServiceDynamicData,InvestorsService) {
    var vm = this;
    var date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    vm.minDate = date;
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    $rootScope.myState = $state.current.url;
    vm.networth = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.minorFormGuardianData = {}
    $rootScope.folioBasicDetail.folioForUser  = 'Minor';
    // guardian form
    vm.minorFormGuardianData.relation = '';
    vm.minorFormGuardianData.guardianrelationproofType = '';
    vm.minorFormGuardianData.guardianrelationproofimageurl = '';
    vm.minorFormGuardianData.guardianrelationproofimagename = '';
    vm.minorFormGuardianData.occupation = '';
    vm.minorFormGuardianData.grossAnnualIncome = '';
    vm.minorFormGuardianData.grossAnnualIncomeDate = '';

    vm.minorFormGuardianData.Fatca = {};
    vm.minorFormGuardianData.Fatca.Countrie = '';
    vm.minorFormGuardianData.Fatca.City = '';
    vm.minorFormGuardianData.Fatca.taxPayIndian = true;
    vm.minorFormGuardianData.Fatca.addressType = "";
    vm.minorFormGuardianData.fileTaxOtherIndian = '';

    vm.minorFormGuardianData.Fatca.taxPay1 = {};
    vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxIdType = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCity = "";
    vm.minorFormGuardianData.Fatca.taxPay1.taxId = "";

    vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
    vm.minorFormGuardianData.politicalStatus = 'NONE';
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];

    vm.relationshipList = [
      { name: 'Father', value: 'FATHER' },
      { name: 'Mother', value: 'MOTHER' }, {
        name: 'Sibling', value: 'SIBLING'
      },
      { name: 'Other', value: 'OTHER' }
    ];
    vm.notolderthan1year = false;
    vm.userData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.userData.nriTaxStatus;
    var identifierData = AuthService.getToken();
    vm.holders  = {};
    vm.pan = vm.userData.pan;
    vm.userDob = vm.userData.dob;
    vm.showEditEmail = true;
    vm.showEditMobile = true;
    vm.isEmailEdited = false;
    vm.isMobileEdited = false;
    vm.updateContactInfo = updateContactInfo;
    vm.AppConstants = AppConstants;
    vm.hideUiFnc = hideUiFnc;
    vm.showUiFnc = showUiFnc;
    vm.hideEditMobile = false;
    vm.hideEditEmail = false;

    fetchBelongsToDropdown();
    vm.fatcaDetails = $window.JSON.parse(localStorage.getItem("fatcadetails"));
    vm.grossAnnualIncomeDate = function (date) {
      if (!date) {
        vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
      } else vm.dateErrorMessage = '';
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.minorFormGuardianData.grossAnnualIncomeDate = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.grossAnnualIncomeYear = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.grossAnnualIncomeYear < 1 || vm.grossAnnualIncomeYear == 1) {
          // console.log(vm.grossAnnualIncomeYear);
          vm.notolderthan1year = false;
          vm.dateErrorMessage = ''
        }
        else {
          vm.minorFormGuardianData.grossAnnualIncomeDate = "";
          vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
         MessageService.error('Networth date should not be older than 1 year');
         vm.notolderthan1year = true;
        }

      } else {
        vm.dateErrorMessage = vm.validateData.NET_WORTH_DATE;
        vm.minorFormGuardianData.grossAnnualIncomeDate = "";
      }
      vm.formatNetworthDate = vm.minorFormGuardianData.grossAnnualIncomeDate;
      return;
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#grossAnnualIncomeDateId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#grossAnnualIncomeDateId").val(vm.dobString+"-");
        }
      }
    }
    vm.getGuardianRelationProofImage = function (file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file.size < 2000000) {

    var modalSuccess = function () {
      var taxIdentifierNumber = vm.userData.pan;
      vm.minorFormGuardianData.guardianrelationproofimagename = file.name;
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/GUARDIAN_PROOF';
      LoaderService.showLoader();
      FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.minorFormGuardianData.minorRelationshipProof = resp.data.fileUrl;
          vm.minorFormGuardianData.guardianrelationproofimageurl = resp.data.fileUrl;
          try{
            const file = resp.data.fileUrl;
            const fileName = file.split("/");
            vm.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
          }catch(e){}
        }else {
          MessageService.error(resp.message);
        }
      }, function () {
        LoaderService.hideLoader();
      });
    },
    modalError = function () {
      MessageService.error(resp.message);
    };

  ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
      }
      else {
        MessageService.error("File size should not be more than 2 MB.")
      }
    }
    vm.getTaxFileStatusForGuardian = function (value) {
      if (value == 'Yes') {
        vm.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
        vm.minorFormGuardianData.Fatca.taxPayIndian = false;
        vm.minorFormGuardianData.Fatca.taxPay1 = {};
          vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :'';
        vm.minorFormGuardianData.Fatca.taxPay1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber:'';
        getTaxIdType();
      } else {
        vm.minorFormGuardianData.fileTaxOtherIndian = 'No';
        vm.minorFormGuardianData.Fatca.taxPayIndian = true;
      }
    }

    vm.getPEPStatusForGuardian = function (value) {
      if (value == 'Yes') {
        vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
        vm.minorFormGuardianData.politicalStatus = 'POLITICAL';
      } else {
        vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
        vm.minorFormGuardianData.politicalStatus = 'NONE';
      }
    }
    vm.networthcall = function () {
      vm.networth = !vm.networth;
      if(vm.networth){
        vm.notolderthan1year = true;
        vm.minorFormGuardianData.grossAnnualIncome = '';
        if(!vm.draftdataNetworth){
          vm.minorFormGuardianData.networth = vm.fatcaDetails.netWorth ? parseInt(vm.fatcaDetails.netWorth) : '';
          if(vm.formatNetworthDate){
            vm.minorFormGuardianData.grossAnnualIncomeDate =  vm.datethreeToTwo(vm.formatNetworthDate);
          }else{
            if(vm.fatcaDetails.netWorthDate){
              vm.grossAnnualIncomeDate(moment(vm.fatcaDetails.netWorthDate));
              vm.minorFormGuardianData.grossAnnualIncomeDate = vm.datethreeToTwo(vm.formatNetworthDate);
            }
          }
          vm.notolderthan1year = vm.minorFormGuardianData.grossAnnualIncomeDate ? false : true;
        }else{
          vm.minorFormGuardianData.networth = vm.draftdataNetworth;
          vm.minorFormGuardianData.grossAnnualIncomeDate = vm.draftdataNetworthDate;
          vm.notolderthan1year = vm.minorFormGuardianData.grossAnnualIncomeDate ? false : true;
        }
      }else{
        vm.notolderthan1year = false;
        vm.minorFormGuardianData.networth = '';
        vm.minorFormGuardianData.grossAnnualIncomeDate ='';
        if(!vm.draftdataAnnualIncome){
          vm.minorFormGuardianData.grossAnnualIncome = vm.fatcaDetails.annualIncomeSlab ? vm.fatcaDetails.annualIncomeSlab: '';
        }else{
          vm.minorFormGuardianData.grossAnnualIncome = vm.draftdataAnnualIncome;
        }
      }
    }
    // vm.getProofType = function () {
    //   var success = function (resp) {
    //     vm.relationProofType = resp.data.proofTypeDTOList;
    //   },
    //     error = function () {
    //       MessageService.error("Error in proof type list!");
    //     };
    //   InvestorsService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
    // }
    // vm.getProofType();

    vm.getOldFolioData = function () {
      var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
      if(isEditbuttonClick){
        $rootScope.minornext(0);
        var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
      }

      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.currentPayload = resp.data;

          vm.minorFormGuardianData.relation = resp.data.soleApplicantDetail.minorDetail.guardian.relation;
          vm.minorFormGuardianData.guardianrelationproofType = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProofType;
          vm.minorFormGuardianData.minorRelationshipProof = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
          vm.minorFormGuardianData.guardianrelationproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
          try{
            const file = resp.data.soleApplicantDetail.minorDetail.minorRelationshipProof;
            const fileName = file.split("/");
            vm.minorFormGuardianData.guardianrelationproofimagename = fileName[fileName.length - 1];
          }catch(e){}
          vm.minorFormGuardianData.occupation = resp.data.soleApplicantDetail.minorDetail.guardian.occupation != null ? resp.data.soleApplicantDetail.minorDetail.guardian.occupation : vm.minorFormGuardianData.occupation;
          vm.minorFormGuardianData.grossAnnualIncome = resp.data.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome !=null ? resp.data.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome : vm.minorFormGuardianData.grossAnnualIncome;
          vm.minorFormGuardianData.Fatca.Countrie = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry !=null ? resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry : vm.minorFormGuardianData.Fatca.Countrie ;
          vm.minorFormGuardianData.Fatca.City = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace !=null ? resp.data.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace : vm.minorFormGuardianData.Fatca.City;
          vm.minorFormGuardianData.Fatca.addressType = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType !=null ? resp.data.soleApplicantDetail.minorDetail.guardian.fatca.addressType : vm.minorFormGuardianData.Fatca.addressType;
          vm.minorFormGuardianData.Fatca.taxPay1 = resp.data.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1;

          if (resp.data.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia == true) {
            vm.minorFormGuardianData.fileTaxOtherIndian = 'No';
            vm.minorFormGuardianData.Fatca.taxPayIndian = true;
            if(resp.data.soleApplicantDetail.minorDetail.guardian.occupation == null && resp.data.soleApplicantDetail.minorDetail.guardian.relation == null){
              if(vm.fatcaDetails.taxOutsideIndia == "Y"){
                vm.getTaxFileStatusForGuardian("Yes");
                vm.minorFormGuardianData.Fatca.taxPay1 = {} ;
                vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry ? vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry :'';
                vm.minorFormGuardianData.Fatca.taxPay1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber:'';
               }else{
                vm.getTaxFileStatusForGuardian("No");
               }
            }
          } else {
            vm.minorFormGuardianData.fileTaxOtherIndian = 'Yes';
            vm.minorFormGuardianData.Fatca.taxPayIndian = false;
            if(resp.data.soleApplicantDetail.minorDetail.guardian.occupation == null && resp.data.soleApplicantDetail.minorDetail.guardian.relation == null){
              if(vm.fatcaDetails.taxOutsideIndia == "Y"){
                vm.getTaxFileStatusForGuardian("Yes");
                vm.minorFormGuardianData.Fatca.taxPay1 = {} ;
                vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :'';
                vm.minorFormGuardianData.Fatca.taxPay1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber:'';
                getTaxIdType();
               }else{
                vm.getTaxFileStatusForGuardian("No");
               }
            }
          }
          if(resp.data.soleApplicantDetail.minorDetail.guardian.occupation == null && resp.data.soleApplicantDetail.minorDetail.guardian.relation == null){
            if(vm.fatcaDetails.taxOutsideIndia == "Y"){
              vm.getTaxFileStatusForGuardian("Yes");
              vm.minorFormGuardianData.Fatca.taxPay1 = {} ;
              vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :''
              vm.minorFormGuardianData.Fatca.taxPay1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber:'';
              getTaxIdType();
            }else{
              vm.getTaxFileStatusForGuardian("No");
             }
          }

          if(resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus){
            if (resp.data.soleApplicantDetail.minorDetail.guardian.politicalStatus == 'NONE') {
              vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
              vm.minorFormGuardianData.politicalStatus = "NONE";
            } else {
              vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
              vm.minorFormGuardianData.politicalStatus = "POLITICAL";
            }
          }else{
            if(vm.fatcaDetails && vm.fatcaDetails.politicalStatus){
              if (vm.fatcaDetails.politicalStatus == 'POLITICAL') {
                vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
                vm.minorFormGuardianData.politicalStatus = 'POLITICAL';
              } else {
                vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
                vm.minorFormGuardianData.politicalStatus = 'NONE';
            }
          }else{
            vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
            vm.minorFormGuardianData.politicalStatus = "NONE";
            }
          }
          if(resp.data.soleApplicantDetail.minorDetail.guardian.netWorth){
            vm.minorFormGuardianData.networth = resp.data.soleApplicantDetail.minorDetail.guardian.netWorth;
            vm.minorFormGuardianData.grossAnnualIncomeDate = vm.datethreeToTwo(resp.data.soleApplicantDetail.minorDetail.guardian.netWorthDate);
            vm.networth = true;
            vm.draftdataNetworth = vm.minorFormGuardianData.networth;
            vm.draftdataNetworthDate = vm.minorFormGuardianData.grossAnnualIncomeDate;
          }else{
            vm.networth = false;
            vm.draftdataAnnualIncome = vm.minorFormGuardianData.grossAnnualIncome;
          }

          var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
          if(resp.data.soleApplicantDetail.personalDetail.kycEmail){
            vm.oldGuardianEmailId = angular.copy(resp.data.soleApplicantDetail.personalDetail.kycEmail);
            vm.guardianEmailId = UserData.email ? UserData.email : resp.data.soleApplicantDetail.personalDetail.kycEmail;
          }else{
            vm.oldGuardianEmailId = "";
            vm.guardianEmailId = UserData.email ? UserData.email : "";
          }
          if(resp.data.soleApplicantDetail.personalDetail.kycMobileNo){
            vm.oldGuardianMobileNo = angular.copy(resp.data.soleApplicantDetail.personalDetail.kycMobileNo);
            vm.guardianMobileNo = UserData.mobileNumber ? UserData.mobileNumber : resp.data.soleApplicantDetail.personalDetail.kycMobileNo;
          }else{
            vm.oldGuardianMobileNo = "";
            vm.guardianMobileNo = UserData.mobileNumber ? UserData.mobileNumber : "";
          }
          if(resp.data.soleApplicantDetail.personalDetail.emailBelongsTo){
            vm.holders.emailBelongsTo = resp.data.soleApplicantDetail.personalDetail.emailBelongsTo;
          }
          if(resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo){
            vm.holders.mobileBelongsTo = resp.data.soleApplicantDetail.personalDetail.mobileBelongsTo

          }

        } else { }
      }, error = function (error) {
        MessageService.error(error.message);
      };
      var investorId = localStorage.getItem("folioId");
      ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId,"arnCode" :identifierData.arnCode }).$promise.then(success, error);
    }
    vm.getOldFolioData();

    vm.submitMinorGuardianDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $rootScope.minornext(1);
          $state.go('main.newinvestor.folioCreation.bankdetails');
          vm.errorMsg = "";
        } else {
          // vm.errorMsg = resp.message;
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      var uContext = JSON.parse(sessionStorage.getItem("verifyObj"));
      var taxIdentifier = uContext.pan;

      vm.currentPayload.soleApplicantDetail.minorDetail.minorRelationshipProof = vm.minorFormGuardianData.minorRelationshipProof;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorRelationshipProofType = vm.minorFormGuardianData.guardianrelationproofType;
      // vm.currentPayload.soleApplicantDetail.minorDetail.minorRelationshipProofType = "Birth certificate";
      if(vm.minorFormGuardianData.grossAnnualIncomeDate.match(/[a-zA-Z]/i)){
        vm.minorFormGuardianData.grossAnnualIncomeDate = vm.minorFormGuardianData.grossAnnualIncomeDate;
      }else{
        if(vm.minorFormGuardianData.grossAnnualIncomeDate){
          vm.minorFormGuardianData.grossAnnualIncomeDate = vm.datetwoTothree(vm.minorFormGuardianData.grossAnnualIncomeDate);
        }
      }
      vm.currentPayload.soleApplicantDetail.minorDetail.guardian = {
        panNumber: taxIdentifier,
        occupation: vm.minorFormGuardianData.occupation,
        grossAnnualIncome: vm.minorFormGuardianData.grossAnnualIncome,
        politicalStatus: vm.minorFormGuardianData.politicalStatus,
        netWorth : vm.minorFormGuardianData.networth,
        netWorthDate : vm.minorFormGuardianData.grossAnnualIncomeDate,
        relation: vm.minorFormGuardianData.relation,
        fatca: {
          birthCountry: vm.minorFormGuardianData.Fatca.Countrie,
          birthPlace: vm.minorFormGuardianData.Fatca.City,
          payTaxInIndia: vm.minorFormGuardianData.Fatca.taxPayIndian,
          addressType: vm.minorFormGuardianData.Fatca.addressType,
        },
        guardianRelationshipProofUrl: null
      };
      if(vm.minorFormGuardianData.grossAnnualIncome){
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome = vm.minorFormGuardianData.grossAnnualIncome;
      }else{
        delete vm.currentPayload.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
      }



      vm.currentPayload.holdmode = "SINGLE";
      vm.currentPayload.minor = true;
      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.minorStep = "SECOND";
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.newUserFlow = true;

      if (vm.minorFormGuardianData.Fatca.taxPayIndian) {
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1 = null;
      } else {
        vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1 = {
          taxPayingCountry: vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry,
          taxIdType: vm.minorFormGuardianData.Fatca.taxPay1.taxIdType,
          taxPayingCity: vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCity,
          taxId: vm.minorFormGuardianData.Fatca.taxPay1.taxId
        }
      }
      if(vm.holders.emailBelongsTo){
        vm.currentPayload.soleApplicantDetail.personalDetail.emailBelongsTo = vm.holders.emailBelongsTo;
      }
      if(vm.holders.mobileBelongsTo){
        vm.currentPayload.soleApplicantDetail.personalDetail.mobileBelongsTo = vm.holders.mobileBelongsTo;
      }


      if (vm.oldGuardianEmailId !== vm.guardianEmailId) {
        vm.isEmailEdited = true;
      } else if (vm.oldGuardianEmailId === vm.guardianEmailId){
        vm.isEmailEdited = false;
      }

      if (vm.oldGuardianMobileNo !== vm.guardianMobileNo) {
        vm.isMobileEdited = true;
      } else if (vm.oldGuardianMobileNo === vm.guardianMobileNo) {
        vm.isMobileEdited = false;
      }

      if (vm.isEmailEdited || vm.isMobileEdited) {
        if (vm.isEmailEdited) {
          vm.currentPayload.updateContactCo = {
            "email": vm.guardianEmailId,
            "change":"EMAIL"
          };
        } else if (vm.isMobileEdited) {
          vm.currentPayload.updateContactCo = {
            "mobileNo": vm.guardianMobileNo,
            "change":"MOBILE"
          };
        } else {
          if (vm.currentPayload.updateContactCo) {
            delete vm.currentPayload.updateContactCo;
          }

          vm.showEditMobile = true;
          vm.isEmailEdited = true;
        }
      }
      vm.currentPayload.nriFlag = vm.nriTaxStatus;
      NewInvestorServiceV3.post({
        child1: 'folio',
        child2: 'distributorNewInvestor',
        child3: 'initiate' }, vm.currentPayload).$promise.then(success, error);
    }

    vm.showImage = function(){
    if(angular.isUndefined(vm.minorFormGuardianData.guardianrelationproofimageurl)){return;}
     ModalService.imagePreviewModal({showOnly:true, file: vm.minorFormGuardianData.guardianrelationproofimageurl});
    }
    function fetchBelongsToDropdown(cb) {
      cb = cb ||function () {

      };
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.holders  = {};
          vm.belongToListEmail = resp.data.emailList;
          vm.belongToListMobile = resp.data.mobileList;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
        cb();
      },
      error = function (err) {
        $log.info('Belongs Dropdown error >>>>', err);
        LoaderService.hideLoader();
        cb();
      };

      InvestorServiceDynamicData.get({child1: 'contactType',child2: 'details'}).$promise.then(success, error);
    }

    function updateContactInfo(changeType) {
      var UserData = JSON.parse(sessionStorage.getItem("verifyObj"));
      if(changeType === "email"){
        vm.guardianEmailId = angular.copy(UserData.email);
        vm.oldGuardianEmailId = angular.copy(UserData.oldSoleApplicantEmail);
        vm.showEditMobile = false;
        vm.isEmailEdited = true;
      }else if(changeType === "mobile"){
        vm.guardianMobileNo = angular.copy(UserData.mobileNumber);
        vm.oldGuardianMobileNo = angular.copy(UserData.oldSoleApplicantMobile);
        vm.showEditEmail = false;
        vm.isMobileEdited = true;
      }
    }

    function hideUiFnc(type) {
      if (type == 'email') {
        vm.hideEditEmail = true;
      } else if (type == 'mobile') {
        vm.hideEditMobile = true;
      }
    }

    function showUiFnc(type) {
      if (type == 'email') {
        vm.hideEditEmail = false;
      } else if (type == 'mobile') {
        vm.hideEditMobile = false;
      }
    }

    if(vm.fatcaDetails){
      vm.minorFormGuardianData.occupation =vm.fatcaDetails.occupation ? vm.fatcaDetails.occupation :'';
      vm.minorFormGuardianData.Fatca.Countrie =vm.fatcaDetails.countryOfBirth ? vm.fatcaDetails.countryOfBirth:'IN';
      vm.minorFormGuardianData.Fatca.addressType =vm.fatcaDetails.addressType ? vm.fatcaDetails.addressType:'RESIDENTIAL';
      vm.minorFormGuardianData.Fatca.City =vm.fatcaDetails.placeOfBirth ? vm.fatcaDetails.placeOfBirth :'';
      vm.minorFormGuardianData.grossAnnualIncome = vm.fatcaDetails.annualIncomeSlab ? vm.fatcaDetails.annualIncomeSlab : '';
      if(vm.fatcaDetails.taxOutsideIndia == "Y"){
        vm.getTaxFileStatusForGuardian("Yes");
        vm.minorFormGuardianData.Fatca.taxPay1 = {} ;
        vm.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :'';
        vm.minorFormGuardianData.Fatca.taxPay1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber:'';
        getTaxIdType();
      }else{
        vm.getTaxFileStatusForGuardian("No");
      }
      if(vm.fatcaDetails.politicalStatus){
        if (vm.fatcaDetails.politicalStatus == 'POLITICAL') {
          vm.minorFormGuardianData.userPEPStatusForGuardian = 'Yes';
          vm.minorFormGuardianData.politicalStatus = 'POLITICAL';
        } else {
          vm.minorFormGuardianData.userPEPStatusForGuardian = 'No';
          vm.minorFormGuardianData.politicalStatus = 'NONE';
        }
      }
    }

    function getTaxIdType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxIdType = resp.data.taxIdTypeResponses;
            if(vm.fatcaDetails && vm.fatcaDetails.taxIdentificationType){
              vm.taxIdType.forEach(function(item){
                if(item.code == vm.fatcaDetails.taxIdentificationType){
                  vm.minorFormGuardianData.Fatca.taxPay1.taxIdType = item.key;
                }
              });
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'taxId-type' }, {}).$promise.then(success, error);
    }

    vm.datethreeToTwo = function(date) {
      var dateChar = date.split("-");
      switch(dateChar[1]){
        case "Jan":
          vm.cdate = dateChar[0]+"-01-"+dateChar[2];
          return vm.cdate;
          break;
        case "Feb":
          vm.cdate = dateChar[0]+"-02-"+dateChar[2];
          return vm.cdate;
          break;
        case "Mar":
          vm.cdate = dateChar[0]+"-03-"+dateChar[2];
          return vm.cdate;
          break;
        case "Apr":
          vm.cdate = dateChar[0]+"-04-"+dateChar[2];
          return vm.cdate;
          break;
        case "May":
          vm.cdate = dateChar[0]+"-05-"+dateChar[2];
          return vm.cdate;
          break;
        case "Jun":
          vm.cdate = dateChar[0]+"-06-"+dateChar[2];
          return vm.cdate;
          break;
        case "Jul":
          vm.cdate = dateChar[0]+"-07-"+dateChar[2];
          return vm.cdate;
          break;
        case "Aug":
          vm.cdate = dateChar[0]+"-08-"+dateChar[2];
          return vm.cdate;
          break;
        case "Sep":
          vm.cdate = dateChar[0]+"-09-"+dateChar[2];
          return vm.cdate;
          break;
        case "Oct":
          vm.cdate = dateChar[0]+"-10-"+dateChar[2];
          return vm.cdate;
          break;
        case "Nov":
          vm.cdate = dateChar[0]+"-11-"+dateChar[2];
          return vm.cdate;
          break;
        case "Dec":
          vm.cdate = dateChar[0]+"-12-"+dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

    vm.datetwoTothree = function(date) {
      var dateChar = date.split("-");
      switch(dateChar[1]){
        case "01":
          vm.cdate = dateChar[0]+"-Jan-"+dateChar[2];
          return vm.cdate;
          break;
        case "02":
          vm.cdate = dateChar[0]+"-Feb-"+dateChar[2];
          return vm.cdate;
          break;
        case "03":
          vm.cdate = dateChar[0]+"-Mar-"+dateChar[2];
          return vm.cdate;
          break;
        case "04":
          vm.cdate = dateChar[0]+"-Apr-"+dateChar[2];
          return vm.cdate;
          break;
        case "05":
          vm.cdate = dateChar[0]+"-May-"+dateChar[2];
          return vm.cdate;
          break;
        case "06":
          vm.cdate = dateChar[0]+"-Jun-"+dateChar[2];
          return vm.cdate;
          break;
        case "07":
          vm.cdate = dateChar[0]+"-Jul-"+dateChar[2];
          return vm.cdate;
          break;
        case "08":
          vm.cdate = dateChar[0]+"-Aug-"+dateChar[2];
          return vm.cdate;
          break;
        case "09":
          vm.cdate = dateChar[0]+"-Sep-"+dateChar[2];
          return vm.cdate;
          break;
        case "10":
          vm.cdate = dateChar[0]+"-Oct-"+dateChar[2];
          return vm.cdate;
          break;
        case "11":
          vm.cdate = dateChar[0]+"-Nov-"+dateChar[2];
          return vm.cdate;
          break;
        case "12":
          vm.cdate = dateChar[0]+"-Dec-"+dateChar[2];
          return vm.cdate;
          break;
        default:
          return "wrong date.";
      }
    }

  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioBasicMinorDetailsController', folioBasicMinorDetailsController);

    /** @ngInject */
    function folioBasicMinorDetailsController(InvestorsService,FileUploadService,ModalService,HDFC_API, $state, $window, AppConstants,LoaderService,$rootScope,NewInvestorServiceV3,ChangeDividendService,InvestorServiceDynamicData, MessageService, $timeout,AuthService, NewInvestorFolioServiceV1) {
      var vm = this;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicMinorDetail = {}
    $rootScope.folioBasicMinorDetail.Fatca = {};
    $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.minorFormData = {}
    vm.viewMode = "days";
    vm.dateErrorMessage = "";
    vm.minorFormData.minorsFullName = '';
    $rootScope.myState = $state.current.url;
    vm.minorFormData.dob = 'dd-mmm-yyyy';
    vm.minorFormData.gender = '';
    vm.minorFormData.ageproofType = '';
    vm.minorFormData.ageproofimageurl = '';
    vm.minorFormData.ageproofimageName = '';
    vm.minorFormData.taxstatus = '02';
    vm.genderObj = [{ name: 'Male', value: 'MALE' }, { name: 'Female', value: 'FEMALE' }];
    vm.taxStatus = [];
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    $rootScope.folioBasicDetail.folioForUser = $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
    vm.userData = {};
    vm.userData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
    vm.nriTaxStatus = vm.userData.nriTaxStatus;
    var identifierData = AuthService.getToken();
    vm.getTransactionDetails = getTransactionDetails
    vm.init = init;
    init();
    function init(){
      if(!vm.skipInvestmentDetails){
      getTransactionDetails(function(){
        if(vm.retirementFlag || vm.nriTaxStatus) {
          ModalService.genericModal({
            text: "Only Self Folio can be created"
          }, function () {
            vm.gotoSelf();
          }, function () {
          });
        }
      })
      }
    }
    if(vm.userData){
      $rootScope.testObj.steps[0].panNumber = vm.userData.pan;
      $rootScope.testObj.steps[0].investorName = vm.userData.name;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      if(vm.skipInvestmentDetails){
        $rootScope.testObj.steps[1].stepCompleted = false;
        $rootScope.testObj.steps[1].stepActive = true;
      }else{
        $rootScope.testObj.steps[1].stepCompleted = true;
        $rootScope.testObj.steps[1].stepActive = false;
        $rootScope.testObj.steps[2].stepActive = true;
      }
    }
    vm.getTaxStatus = function() {
      var successTaxStatus = function (resp) {
        vm.taxStatus = resp.data.taxStatus;
      },
      errorTaxStatus = function () {
          MessageService.error("Error in minor tax status!");
        };
        var minorCheckParams = false;
        if($rootScope.folioBasicMinorDetail.folioForUser == 'Minor'){
          minorCheckParams = true;
        }else{
          minorCheckParams = false;
        }
      var payloadTaxStatus = {
        taxStatusFilter: minorCheckParams ? 'MINOR' : 'ADULT'
      };
      InvestorsService.post({controller: 'tax-status'}, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    vm.getTaxStatus();


    vm.chooseFolioFor = function (foliofor) {
      if (foliofor == 'Self') {
        if(vm.childSchemeFlag == "CGI" || vm.childSchemeFlag == "CGIL"){
          ModalService.genericModal({
            text: "Only Minor Folio can be created"
          });
        }else{
        $rootScope.folioBasicMinorDetail.folioForUser = 'Self';
        // vm.showPopUp = true;
        var successModal = function(resp) {
          vm.gotoSelf();
        }, errorModal = function(resp) {
          vm.stayWithMinor();
        };
        ModalService.newJourneyFolioSwitchModal({
          folioType: 'Minor'
        }, successModal, errorModal);
        }
      }
      else {
        $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
      }
    }

    vm.getMinordob = function (date) {
      vm.MINOR_DOB_ERROR = false;
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.minorFormData.dob = moment(date).format("DD-MMM-YYYY");
        vm.dobmilisecond = moment(date).valueOf();
        vm.age = (moment(new Date()).valueOf() - vm.dobmilisecond) / 31556952000;
        if (vm.age < 18) {
         // console.log(vm.age);
          //console.log(moment(date).format("DD-MMM-YYYY"));
          vm.MINOR_DOB_ERROR = false;
        }
        else {
          vm.MINOR_DOB_ERROR = true;
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';

      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.formData.dob = "";
      }
      return;
    }
    vm.getProofType = function () {
      var success = function (resp) {
        vm.minorAgeProofType = resp.data.proofTypeDTOList;
      },
        error = function () {
          MessageService.error("Error in proof type list!");
        };
      InvestorsService.get({ child1: 'folio', child2: 'proof', child3: 'type' }, null).$promise.then(success, error);
    }
    // vm.getProofType();

    vm.getMinorAgeProofImage = function (file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file.size < 2000000) {
        vm.minorFormData.ageproofimageName = file.name;
          var modalSuccess = function () {
              var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + vm.userData.pan + '/MINOR_PROOF';
              LoaderService.showLoader();
              FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  vm.minorFormData.ageproofimageurl = resp.data.fileUrl;
                  try{
                    const file = resp.data.fileUrl;
                    const fileName = file.split("/");
                    vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
                  }catch(e){}
                } else {
                  MessageService.error(resp.message);
                }
              }, function () {
                LoaderService.hideLoader();
              });

            },
            modalError = function () {
              MessageService.error("file not upload");
              vm.minorFormData.ageproofimageName = "";
          };
        ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
      }
      else {
        MessageService.error("File size should not be more than 2 MB.")
      }

  }


    vm.getNewUserDetails = function () {
      try {
        var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.folioCreationDraftId) {
              localStorage.setItem("folioId", resp.data.folioCreationDraftId);
              vm.getOldFoliData();
            } else {
              vm.initiatFirstFolio();
            }

          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (error) {
            MessageService.error(error.message);
          };

          var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
          var payload = { "panNumber": uContext.pan,"arnCode":identifierData.arnCode }
          InvestorServiceDynamicData.post({
            child1: 'new',
            child2: 'user',
            child3: 'getDetails'
          }, payload).$promise.then(success, error);
         } catch (e) { }
    }
    vm.getNewUserDetails();
    vm.showPopUp = false;
    vm.getOldFoliData = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        $timeout(function () {}, 1000);
        if (resp.status && resp.data) {
          if (resp.data.minor == false) {
            vm.isMinor = false;
            $state.go('main.newinvestor.folioCreation.folioDetails');
            }else{
            vm.isMinor = true;
            $rootScope.showSaveTag = true;
              $timeout(function () {
                $rootScope.showSaveTag = false;
              }, 3000);

              sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
              var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
              var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
              if(isEditbuttonClick){
                $rootScope.setProgress();
                sessionStorage.removeItem("investorIsEditButtonClick");
            }

            vm.currentPayload = resp.data;
            vm.minorFormData.minorsFullName = resp.data.soleApplicantDetail.personalDetail.firstName;
            vm.minorFormData.dob = resp.data.soleApplicantDetail.personalDetail.dateOfBirth;
            vm.minorFormData.gender = resp.data.soleApplicantDetail.personalDetail.gender;
            vm.minorFormData.ageproofType = resp.data.soleApplicantDetail.minorDetail.minorProofType;
            vm.minorFormData.ageproofimageurl = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
            try{
              const file = resp.data.soleApplicantDetail.minorDetail.minorAgeProof;
              const fileName = file.split("/");
              vm.minorFormData.ageproofimageName = fileName[fileName.length - 1];
            }catch(e){}
            vm.minorFormData.taxstatus = resp.data.soleApplicantDetail.personalDetail.taxStatusCode ? resp.data.soleApplicantDetail.personalDetail.taxStatusCode: '02';
          }
        } else {
          if (resp.message == "Invalid Folio State") {
            vm.initiatFirstFolio();
          }
        }
      }, error = function (error) {
        LoaderService.hideLoader();
        MessageService.error(error.message);
      };
      LoaderService.showLoader();
      var investorId = localStorage.getItem("folioId");
      ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId ,"arnCode" :identifierData.arnCode}).$promise.then(success, error);
    }


    vm.gotoSelf = function(){
      if(!vm.isMinor){
        vm.showPopUp = false;
        $state.go('main.newinvestor.folioCreation.folioDetails');
      }
      else{
      vm.deleteCurrentFolio();
      vm.showPopUp = false;
      $state.go('main.newinvestor.folioCreation.folioDetails');
      }

  }

   vm.deleteCurrentFolio =  function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status) {
          localStorage.removeItem("folioId");
          MessageService.success("Successfully delete folio draft data.");
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var uuid = localStorage.getItem("folioId");
      if(uuid){
        NewInvestorFolioServiceV1.post({ child1: 'new',child2: 'user', child3: 'delete', child4: 'draft', child5: 'folio', child6: uuid},{}).$promise.then(success, error);
      }
    }
   vm.stayWithMinor  =function(){
    if(!vm.isMinor){
      vm.deleteCurrentFolio();
      vm.initiatFirstFolio();
      vm.showPopUp = false;
    }
    else{
      vm.showPopUp = false;
    }
    $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
   }


    vm.submitMinorBsicDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData','BACK_ROUTE4');
          $rootScope.minornext(0);
          $state.go('main.newinvestor.folioCreation.guardianMinorDetails');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      if(!vm.currentPayload){
        vm.currentPayload={};
        vm.currentPayload.soleApplicantDetail = {};
        vm.currentPayload.soleApplicantDetail.minorDetail = {};
        vm.currentPayload.soleApplicantDetail.personalDetail = {};
      }
      vm.currentPayload.minor = true;
      vm.currentPayload.id = localStorage.getItem("folioId");
      vm.currentPayload.minorStep = "FIRST";
      vm.currentPayload.folioSaveStep = "TWO";
      vm.currentPayload.newUserFlow = true;
      var tempData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      vm.payloadData.soleApplicantDetail.minorDetail.guardian.panNumber = tempData.pan;
      // vm.currentPayload.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia = true;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorAgeProof = vm.minorFormData.ageproofimageurl;
      // vm.currentPayload.soleApplicantDetail.minorDetail.minorProofType = vm.minorFormData.ageproofType;
      vm.currentPayload.soleApplicantDetail.minorDetail.minorProofType = null;
      vm.currentPayload.soleApplicantDetail.personalDetail.firstName = vm.minorFormData.minorsFullName;
      vm.currentPayload.soleApplicantDetail.personalDetail.dateOfBirth = vm.minorFormData.dob;
      vm.currentPayload.soleApplicantDetail.personalDetail.gender = vm.minorFormData.gender;
      vm.currentPayload.soleApplicantDetail.personalDetail.taxStatusCode = vm.minorFormData.taxstatus;
      vm.currentPayload.nriFlag = vm.nriTaxStatus;
      NewInvestorServiceV3.post({
         child1: 'folio',
         child2: 'distributorNewInvestor',
         child3: 'initiate'  }, vm.currentPayload).$promise.then(success, error);
    }

    vm.initiatFirstFolio = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          sessionStorage.setItem('folioStateData', {'userFolioBackState':'BACK_ROUTE4'});
          localStorage.setItem("folioId", resp.data.id);
          vm.getOldFoliData();
        } else {
          MessageService.error(error.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };
      vm.payloadData.nriFlag = vm.nriTaxStatus;
        NewInvestorServiceV3.post({
            child1: 'folio',
            child2: 'distributorNewInvestor',
            child3: 'initiate'  }, vm.payloadData).$promise.then(success, error);
    }
    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
         oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 6){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    vm.payloadData = {
      soleApplicantDetail: {
        minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
            panNumber: vm.userData.pan,
            occupation: null,
            taxStatusCode: null,
            grossAnnualIncome: null,
            politicalStatus: null,
            netWorth: null,
            netWorthDate: null,
            kycVerified: null,
            name: null,
            gender: null,
            panValid: null,
            relation: null,
            fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: true,
              addressType: null,
              fatcaTax1: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              }
            },
            guardianRelationshipProofUrl: null
          }
        },
        selfDetail: null,
        personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
        }
      },
      pageDetail:null,
      userType:null,
      nominees: null,
      holdmode: "SINGLE",
      minor: true,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow: true,
      nriFlag : vm.nriTaxStatus == 'RI'? false: true
    }

    vm.showImage = function(){
      if(angular.isUndefined(vm.minorFormData.ageproofimageurl)){return;}
      ModalService.imagePreviewModal({showOnly:true, file: vm.minorFormData.ageproofimageurl});
     }

      function getTransactionDetails(cb) {
        cb = cb || function () {
        };
        vm.transactionDetailsId = JSON.parse($window.sessionStorage.getItem("userData"));
        var success = function (resp) {
            if (resp.data && resp.status) {
              vm.retirementFlag = resp.data.retirementFlag;
              vm.childSchemeFlag = resp.data.schemeCode;
              cb(true);
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            MessageService.error(AppConstants.ToastrMessage.FAILED);
          };
        LoaderService.showLoader('.pan-loader');
        ChangeDividendService.post({
          child1: 'v2',
          child2: 'distributorNewInvestor',
          child3: 'saved',
          child4: 'draft'
        }, {id:vm.transactionDetailsId.transactionDraftId,"arnCode":identifierData.arnCode }).$promise.then(success, error);

      }

    }
  })();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioBasicDetailsController', FolioBasicDetailsController);

  /** @ngInject */
  function FolioBasicDetailsController(InvestorServiceDynamicData,ModalService, $state, InvestorsService, $window, AppConstants,UtilService, LoaderService, NewInvestorServiceV3, $rootScope, MessageService, $timeout,ChangeDividendService,InvestorsApiService, AuthService, NewInvestorFolioServiceV1) {
    var vm = this;
    vm.init = init;
    $rootScope.folioBasicDetail = {}
    $rootScope.folioBasicDetail.Fatca = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    $rootScope.folioBasicDetail.Fatca = {};
    $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1 = {}
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity = '';
    $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = '';
    $rootScope.myState = $state.current.url;
    vm.showholderdetails = false;
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    $rootScope.folioBasicDetail.folioHoldingMode = "SINGLE";
    sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');
    $rootScope.folioBasicDetail.userPEPStatus = 'No';
    $rootScope.folioBasicDetail.politicalStatus = 'NONE';
    $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
    $rootScope.folioBasicDetail.Fatca.Countrie = '';
    $rootScope.folioBasicDetail.Fatca.City = '';
    $rootScope.folioBasicDetail.Fatca.addressType = '';
    localStorage.setItem("folioId", "");
    vm.userData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.userData.nriTaxStatus;
    var identifierData = AuthService.getToken();
    vm.skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
    if(vm.skipInvestmentDetails){
      $rootScope.showSidebar = false;
      $rootScope.updateSideBarSteps();
    }
    vm.fatcaDetails = $window.JSON.parse(localStorage.getItem("fatcadetails"));
    function init() {
      $rootScope.testObj.steps[0].panNumber = vm.userData.pan;
      $rootScope.testObj.steps[0].investorName = vm.userData.name;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      if(vm.skipInvestmentDetails){
        $rootScope.testObj.steps[1].stepCompleted = false;
        $rootScope.testObj.steps[1].stepActive = true;
      }else{
        $rootScope.testObj.steps[1].stepCompleted = true;
        $rootScope.testObj.steps[1].stepActive = false;
        $rootScope.testObj.steps[2].stepActive = true;
      }
      if(!vm.skipInvestmentDetails){
        getTransactionDetails();
      }

      getDetails();
      getCountryList();
      getTaxIdType();
      taxStatus();
      occupation();
      incomeSlab();
      addressType();
    }

    function getTransactionDetails() {
      vm.transactionDetailsId = JSON.parse($window.sessionStorage.getItem("userData"));
      var success = function (resp) {
        if (resp.data && resp.status) {
          $rootScope.testObj.steps[1].schemeName = resp.data.schemeName;
          $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;
          $rootScope.testObj.steps[1].schemeInfo.amount = resp.data.amount;
          vm.retirementFlag = resp.data.retirementFlag;
          vm.childSchemeFlag = resp.data.schemeCode;
          if(vm.createFolio == true){
            if(vm.childSchemeFlag == "CGI" || vm.childSchemeFlag == "CGIL"){
              ModalService.genericModal({
                text: "Only Minor Folio can be created"
              }, function () {
                $rootScope.folioBasicDetail.folioForUser = 'Minor';
                $state.go('main.newinvestor.folioCreation.folioMinorDetails');
              }, function () {
              });
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      LoaderService.showLoader('.pan-loader');
      ChangeDividendService.post({
        child1: 'v2',
        child2: 'distributorNewInvestor',
        child3: 'saved',
        child4: 'draft'
      }, {id:vm.transactionDetailsId.transactionDraftId,"arnCode":identifierData.arnCode }).$promise.then(success, error);

    }

    vm.folioSelfSingleBasicForm = {
      folioFor: '',
      holderMode: '',
      taxPayIndia: ''
    }
    vm.gotoSelf = function(){
      if(!vm.isMinor){
        vm.showPopUp = false;
        $state.go('main.newinvestor.folioCreation.folioDetails');
      }
      else{
      vm.deleteCurrentFolio();
      vm.showPopUp = false;
      $state.go('main.newinvestor.folioCreation.folioDetails');
      }
   }
    vm.chooseFolioFor = function (foliofor) {
      if (foliofor == 'Minor') {
        if(!vm.retirementFlag && !vm.nriTaxStatus) {
          if (!$rootScope.folioBasicMinorDetail) {
            $rootScope.folioBasicMinorDetail = {};
          }
          $rootScope.folioBasicMinorDetail.folioForUser = 'Minor';
          var successModal = function (resp) {
            vm.gotoMinor();
          }, errorModal = function (err) {
            $rootScope.folioBasicMinorDetail.folioForUser = 'Self';
          };
          ModalService.newJourneyFolioSwitchModal({
            folioType: 'Minor'
          }, successModal, errorModal);
        } else {
          ModalService.genericModal({
            text: "Only Self Folio can be created"
          });
        }
      }
      else {
        $rootScope.folioBasicMinorDetail.folioForUser = 'Self';
      }
    }

    vm.getholdingmode = function (value) {
      if (value == 'SINGLE') {
        $rootScope.folioBasicDetail.folioHoldingMode = 'SINGLE';
        sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
        localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
      }
      else {
        $rootScope.folioBasicDetail.folioHoldingMode = 'ANY_OR_SURVIVOR';
        sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
        localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
      }
    }


    vm.getTaxFileStatus = function (value) {
      if (value == 'Yes') {
        $rootScope.folioBasicDetail.fileTaxOtherIndian = 'Yes';
        $rootScope.folioBasicDetail.Fatca.taxPayIndia = false;
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :'';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber :'';
      } else {
        $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
        $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = '';
      }
    }
    vm.getPEPStatus = function (value) {
      if (value == 'Yes') {
        $rootScope.folioBasicDetail.userPEPStatus = 'Yes';
        $rootScope.folioBasicDetail.politicalStatus = 'POLITICAL';
      } else {
        $rootScope.folioBasicDetail.userPEPStatus = 'No';
        $rootScope.folioBasicDetail.politicalStatus = 'NONE';
      }
    }

    vm.getNewUserDetails = function () {
      var detailsSuccess = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.folioCreationDraftId) {
            localStorage.setItem("folioId", resp.data.folioCreationDraftId);
            vm.getPayload(resp.data.folioCreationDraftId);
            vm.createFolio = false;
          } else {
            vm.createFolio = true;
          }
        } else {
          MessageService.error(resp.message);
        }
        },
        error = function (error) {
          MessageService.error(error.message);
        };

      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      var payload = {"panNumber": uContext.pan, "arnCode": identifierData.arnCode}
      InvestorServiceDynamicData.post({
        child1: 'new',
        child2: 'user',
        child3: 'getDetails'
      }, payload).$promise.then(detailsSuccess, error);
    }
    vm.getNewUserDetails();

    vm.createFolio = true;
    $rootScope.showPopUpWindow = false;
    vm.getPayload = function (folioId) {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.minor) {
              $state.go('main.newinvestor.folioCreation.folioMinorDetails');
            } else {
              $rootScope.showSaveTag = true;
              $timeout(function () {
                $rootScope.showSaveTag = false;
              }, 3000);

              $rootScope.folioBasicDetail.folioForUser = 'Self';
              vm.currentPayload = resp.data;
              var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
              if (isEditbuttonClick) {
                sessionStorage.removeItem("investorIsEditButtonClick");
              } else {

                if (resp.data.holdmode == "SINGLE") {
                  if (vm.childSchemeFlag == "CGI" || vm.childSchemeFlag == "CGIL") {
                    ModalService.genericModal({
                    text: "Only Minor Folio can be created"
                  }, function () {
                    vm.gotoMinor();
                  }, function () {
                  });
                }else{
                $rootScope.folioBasicDetail.folioHoldingMode = "SINGLE";
                  sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
                  localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
                  sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');

                  // var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
                  // if (resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick) {
                  //   $rootScope.nextStep(0);
                  //   $rootScope.nextStep(1);
                  //   $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
                  // } else if (resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick) {
                  //   $rootScope.nextStep(0);
                  //   $rootScope.nextStep(1);
                  //   $rootScope.nextStep(2);
                  //   $state.go('main.newinvestor.folioCreation.folioNomineeDetails' && !isBackbuttonClick);
                  // }else if (resp.data.folioSaveStep == 'FOUR' && !isBackbuttonClick) {
                  //   $state.go('main.newinvestor.folioCreation.bankdetails');
                  // } else if (resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick) {
                  //   $state.go('main.newinvestor.folioCreation.bankdetails');
                  // }
                }
              } else {
                if (vm.childSchemeFlag == "CGI" || vm.childSchemeFlag == "CGIL") {
                  ModalService.genericModal({
                    text: "Only Minor Folio can be created"
                  }, function () {
                    vm.gotoMinor();
                  }, function () {
                  });
                } else {
                  $rootScope.folioBasicDetail.folioHoldingMode = "ANY_OR_SURVIVOR";
                sessionStorage.setItem('ModeOfHold', $rootScope.folioBasicDetail.folioHoldingMode);
                localStorage.setItem('holdmode', $rootScope.folioBasicDetail.folioHoldingMode);
                sessionStorage.setItem('folioStateData', 'BACK_ROUTE3');
                  // var isBackbuttonClick = sessionStorage.getItem("investorIsBackButtonClick");
                  // if (resp.data.folioSaveStep == 'ONE' && !isBackbuttonClick) {
                  //   $rootScope.nextStep(0);
                  //   $rootScope.nextStep(1);
                  //   $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
                  // } else if (resp.data.folioSaveStep == 'TWO' && !isBackbuttonClick) {
                  //   $rootScope.nextStep(0);
                  //   $rootScope.nextStep(1);
                  //   $rootScope.nextStep(2);
                  //   $state.go('main.newinvestor.folioCreation.jointholder');
                  // } else if (resp.data.folioSaveStep == 'THREE' && !isBackbuttonClick) {
                  //   $rootScope.nextStep(0);
                  //   $rootScope.nextStep(1);
                  //   $rootScope.nextStep(2);
                  //   $state.go('main.newinvestor.folioCreation.folioNomineeDetails');
                  // } else if (resp.data.folioSaveStep == 'FOUR' && !isBackbuttonClick) {
                  //   $state.go('main.newinvestor.folioCreation.bankdetails');
                  // } else if (resp.data.folioSaveStep == 'FIVE' && !isBackbuttonClick) {
                  //   $state.go('main.newinvestor.folioCreation.bankdetails');
                  // }
                }
              }
            }
            if (resp.data.soleApplicantDetail.selfDetail.fatca.payTaxInIndia) {
              $rootScope.folioBasicDetail.Fatca.taxPayIndia = true;
              $rootScope.folioBasicDetail.fileTaxOtherIndian = 'No';
            } else {
              $rootScope.folioBasicDetail.Fatca.taxPayIndia = false;
              $rootScope.folioBasicDetail.fileTaxOtherIndian = 'Yes';
              $rootScope.folioBasicDetail.Fatca.fatcaTax1 = resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
            }


            if(resp.data.soleApplicantDetail.selfDetail.politicalStatus == "POLITICAL") {
              $rootScope.folioBasicDetail.politicalStatus = "POLITICAL";
              $rootScope.folioBasicDetail.userPEPStatus = "Yes";
            }else{
              $rootScope.folioBasicDetail.politicalStatus = "NONE";
              $rootScope.folioBasicDetail.userPEPStatus = "No";
            }

            if (resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1) {
              $rootScope.folioBasicDetail.Fatca.fatcaTax1 = resp.data.soleApplicantDetail.selfDetail.fatca.fatcaTax1;
            }
          }
        } else {
          if (resp.message == "Invalid Folio State" || resp.message == "Invalid Folio Id or ArnCode!!") {
            vm.createFolio = true;
            if(vm.childSchemeFlag == "CGI" || vm.childSchemeFlag == "CGIL"){
              ModalService.genericModal({
                text: "Only Minor Folio can be created"
              }, function () {
                $rootScope.folioBasicDetail.folioForUser = 'Minor';
                $state.go('main.newinvestor.folioCreation.folioMinorDetails');
              }, function () {
              });
            }
          }
        }
      },
        error = function (err) {
          MessageService.error(err.message);
        };
      var investorId = localStorage.getItem("folioId");
      if (investorId) {
        ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId,"arnCode" :identifierData.arnCode}).$promise.then(success, error);
      }
    }
    vm.gotoMinor = function () {
      vm.deleteFolio();
      $rootScope.showPopUpWindow = false;
      $rootScope.folioBasicDetail.folioForUser = 'Minor';
      $state.go('main.newinvestor.folioCreation.folioMinorDetails');
    }
    vm.deleteFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status) {
          $rootScope.showPopUpWindow = false;
          localStorage.removeItem("folioId");
          MessageService.success("Successfully delete folio draft data.");
          // vm.getPayload(localStorage.getItem("folioId"));
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var uuid = localStorage.getItem("folioId");
      if(uuid){
        NewInvestorFolioServiceV1.post({ child1: 'new',child2: 'user', child3: 'delete', child4: 'draft', child5: 'folio', child6: uuid},{}).$promise.then(success, error);
      }
    }

    vm.submitFolioSelfSingleBsicForm = function () {
      if (vm.createFolio) {
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.createFolio = false;
            if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Self') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');
            } else if ($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && $rootScope.folioBasicDetail.folioForUser == 'Self') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE3');
            } else if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Minor') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
            } else {
              sessionStorage.setItem('folioStateData', 'NOROUTE');
            }

            localStorage.setItem("folioId", resp.data.id);
            vm.getPayload(resp.data.id);
            $rootScope.nextStep(0);
            $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (error) {
            MessageService.error(error.message);
          };

        var uContext = JSON.parse(sessionStorage.getItem("verifyObj"));
        var taxIdentifier = uContext.pan;
        vm.dataPayload.holdmode = $rootScope.folioBasicDetail.folioHoldingMode;
        vm.dataPayload.soleApplicantDetail.selfDetail.panNumber = taxIdentifier;
        vm.dataPayload.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
        vm.dataPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = $rootScope.folioBasicDetail.Fatca.taxPayIndia;
        if ($rootScope.folioBasicDetail.Fatca.taxPayIndia) {
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = null;
        } else {
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {};
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountry = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdNumber = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId;
          vm.dataPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType = $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType;
        }
        vm.dataPayload.nriFlag = vm.nriTaxStatus;
        NewInvestorServiceV3.post({ child1: 'folio', child2: 'distributorNewInvestor', child3: 'initiate' }, vm.dataPayload).$promise.then(success, error);
      } else {
        var success = function (resp) {
          if (resp.status && resp.data) {
            if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Self') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE2');
            } else if ($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && $rootScope.folioBasicDetail.folioForUser == 'Self') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE3');
            } else if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE' && $rootScope.folioBasicDetail.folioForUser == 'Minor') {
              sessionStorage.setItem('folioStateData', 'BACK_ROUTE4');
            } else {
              sessionStorage.setItem('folioStateData', 'NOROUTE');
            }
            $rootScope.nextStep(0);
            $state.go('main.newinvestor.folioCreation.folioIncomeDetails');
          } else {
            MessageService.error(resp.message);
          }
        },
          error = function (error) {
            MessageService.error(error.message);
          };



        vm.currentPayload.holdmode = $rootScope.folioBasicDetail.folioHoldingMode;
        vm.currentPayload.minor = false;
        vm.currentPayload.folioSaveStep = "ONE";
        vm.currentPayload.firstFolio = true;
        vm.currentPayload.newUserFlow = true;
        vm.currentPayload.id = localStorage.getItem("folioId");
        vm.currentPayload.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
        vm.currentPayload.soleApplicantDetail.selfDetail.fatca.payTaxInIndia = $rootScope.folioBasicDetail.Fatca.taxPayIndia;
        if ($rootScope.folioBasicDetail.Fatca.taxPayIndia) {
          vm.currentPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = null;

        } else {
          vm.currentPayload.soleApplicantDetail.selfDetail.fatca.fatcaTax1 = {
            taxPayingCountry: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry,
            taxPayingCity: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity,
            taxIdNumber: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId,
            taxId: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId,
            taxIdType: $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType
          }
        }
        vm.currentPayload.nriFlag = vm.nriTaxStatus;

        NewInvestorServiceV3.post({ child1: 'folio', child2: 'distributorNewInvestor', child3: 'initiate' }, vm.currentPayload).$promise.then(success, error);
      }

    }


    $rootScope.addholder = {
      steps: [
        { step: 1, isactive: false },
        { step: 2, isactive: false },
        { step: 3, isactive: false }
      ]
    }

    $rootScope.stepperThird = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 4,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };

    $rootScope.stepperForMinor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Guardian Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    $rootScope.stepperForAnyoneSurvivor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Holder Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 4,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 5,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    // $rootScope.nextStep = function (val) {
    //   if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE') {
    //     $rootScope.stepperThird.steps[val].stepActive = false;
    //     $rootScope.stepperThird.steps[val].stepCompleted = true;
    //     $rootScope.stepperThird.steps[val + 1].stepActive = true;
    //   }
    //   else {
    //     $rootScope.stepperForAnyoneSurvivor.steps[val].stepActive = false;
    //     $rootScope.stepperForAnyoneSurvivor.steps[val].stepCompleted = true;
    //     $rootScope.stepperForAnyoneSurvivor.steps[val + 1].stepActive = true;
    //   }

    //   if ($rootScope.stepperThird.steps[0].stepActive && $rootScope.stepperForAnyoneSurvivor.steps[0].stepActive) {
    //     vm.showincomedetails = false;
    //     vm.shownominidetails = false;
    //   }
    //   if ($rootScope.stepperThird.steps[1].stepActive || $rootScope.stepperForAnyoneSurvivor.steps[1].stepActive) {
    //     vm.showincomedetails = true;
    //     vm.shownominidetails = false;
    //   }
    //   if ($rootScope.stepperThird.steps[2].stepActive) {
    //     vm.showincomedetails = false;
    //     vm.shownomineedetails = true;
    //   }
    //   if ($rootScope.stepperForAnyoneSurvivor.steps[2].stepActive) {
    //     vm.showincomedetails = false;
    //     vm.showholderdetails = true;
    //   }
    //   if ($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && val == 2) {
    //     $rootScope.addholder.steps[2].isactive = false;
    //     $rootScope.stepperForAnyoneSurvivor.steps[2].stepActive = false;
    //     $rootScope.stepperForAnyoneSurvivor.steps[2].stepCompleted = true;
    //     $rootScope.stepperForAnyoneSurvivor.steps[3].stepActive = true;
    //   }
    //   if ($rootScope.stepperForAnyoneSurvivor.steps[3].stepActive) {
    //     vm.showholderdetails = false;
    //     vm.shownomineedetails = true;
    //   }
    // }

    function getDetails() {
      var success = function (resp) {
        if (resp.status && resp.data) {
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };

      var payload = { "panNumber": vm.userData.pan,"arnCode":identifierData.arnCode }
      InvestorServiceDynamicData.post({
        child1: 'new',
        child2: 'user',
        child3: 'getDetails'
      }, payload).$promise.then(success, error);
    }
    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries =resp.data.countries;
          vm.filteredCountry = resp.data.countries.filter(function(el){
            return el.countryCode != "IN";
          });
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countries = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({ controller: 'country', child1: 'list' }, null).$promise.then(success, error);
    }

    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
          if(vm.fatcaDetails && vm.fatcaDetails.taxIdentificationType){
            vm.taxIdType.forEach(function(item){
              if(item.code == vm.fatcaDetails.taxIdentificationType){
                $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType = item.key;
              }
            });
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'taxId-type' }, {}).$promise.then(success, error);
    }

    function taxStatus() {
      var successTaxStatus = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
        }
        else {
          MessageService.error(resp.message);
        }
      },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var minorCheckParams = false;
      if ($rootScope.folioBasicDetail.folioForUser == 'Self') {
        minorCheckParams = false;
      }else{
        minorCheckParams = true;
      }
      var payloadTaxStatus = {
        taxStatusFilter: minorCheckParams ? 'MINOR' : 'ADULT'
      };
      InvestorsService.post({ controller: 'tax-status' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    function occupation() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'get-occupation' }, {}).$promise.then(success, error);
    }
    function incomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'income', child1: 'slab' }, {}).$promise.then(success, error);
    }
    function addressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressType = resp.data.addressTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'address', child1: 'type' }, {}).$promise.then(success, error);
    }


    vm.dataPayload = {
      soleApplicantDetail: {
        minorDetail: {
          minorAgeProof: null,
          minorRelationshipProof: null,
          guardian: {
            panNumber: null,
            occupation: null,
            taxStatusCode: null,
            grossAnnualIncome: null,
            politicalStatus: null,
            netWorth: null,
            netWorthDate: null,
            kycVerified: null,
            name: null,
            gender: null,
            panValid: null,
            relation: null,
            fatca: {
              birthCountry: null,
              birthPlace: null,
              countryCitizenship: null,
              payTaxInIndia: false,
              addressType: null,
              fatcaTax1: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              },
              fatcaTax2: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              },
              fatcaTax: {
                taxPayingCountry: null,
                taxPayingCity: null,
                taxIdNumber: null,
                taxId: null,
                taxIdType: null
              }
            },
            guardianRelationshipProofUrl: null
          }
        },
        selfDetail: {
          panNumber: vm.userData.pan,
          occupation: null,
          taxStatusCode: null,
          grossAnnualIncome: null,
          politicalStatus: "NONE",
          netWorth: null,
          netWorthDate: null,
          kycVerified: null,
          address: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          fatca: {
            birthCountry: null,
            birthPlace: null,
            countryCitizenship: null,
            payTaxInIndia: true,
            addressType: null
          }
        },
        personalDetail: {
          dateOfBirth: null,
          firstName: null,
          gender: null,
          taxStatusCode: null
        }
      },

      nominees: [
        {
          title: null,
          nomineeName: null,
          nomineeRelation: null,
          percentage: null,
          dob: null,
          nomineeAddress: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          guardianAddress: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            pinCode: null,
            city: null,
            state: null,
            country: null
          },
          minor: null,
          guardianName: null,
          soleAddressApplicable: null
      }],
      pageDetail:null,
      userType:null,
      holdmode: "SINGLE",
      minor: false,
      folioSaveStep: "ONE",
      firstFolio: true,
      newUserFlow: true
    }
    if(vm.fatcaDetails){
      if(vm.fatcaDetails.taxOutsideIndia == "Y"){
        vm.getTaxFileStatus("Yes");
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = vm.fatcaDetails.taxCountry ? vm.fatcaDetails.taxCountry :'';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = vm.fatcaDetails.taxIdentificationNumber ? vm.fatcaDetails.taxIdentificationNumber :'';
       }else{
        vm.getTaxFileStatus("No")
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxIdType = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxPayingCity = '';
        $rootScope.folioBasicDetail.Fatca.fatcaTax1.taxId = '';
       }
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BankDetailsController', BankDetailsController);

  /** @ngInject */
  function BankDetailsController($window, $rootScope,$state,HDFC_API,FileUploadService,AuthService, LoaderService, AppConstants, MessageService, NewInvestorServiceV3, ModalService, UtilService, InvestorsService, InvestorsCommonService, $log,ChangeDividendService) {
    var vm = this;
    vm.tokenData = AuthService.getToken();
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankAccountType = [];
    vm.bankAccountDetailsForm = {};
    vm.bankAccountDetailsForm.bankDetails = {};
    vm.bankAccountDetailsForm.bankDetails.payoutMechanism = "";
    vm.bankAccountDetailsForm.ifscCode = '';
    $rootScope.myState = $state.current.url;
    vm.bankAccountDetailsForm.accountNumber = '';
    vm.bankAccountDetailsForm.accountNumberverify = '';
    vm.bankAccountDetailsForm.accountType = '';
    vm.userTaxStatusCode = "";
    vm.gettaxStatus = gettaxStatus;
    vm.showValidateBtn = false;
    vm.bankAccountDetailsForm.pennyDropValid = false;
    vm.bankAccountDetailsForm.chequesleafImageUrl = "";
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
    if(vm.skipInvestmentDetails){
      $rootScope.testObj.steps[1].stepCompleted = false;
      $rootScope.testObj.steps[1].stepActive = true;
    }else{
      $rootScope.testObj.steps[1].stepCompleted = true;
    }
    vm.showcheckLeaf = false;
    vm.userData = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    vm.nriTaxStatus = vm.userData.nriTaxStatus;
    function gettaxStatus() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.minor) {
            $rootScope.folioBasicDetail.folioForUser = "Minor";
            $rootScope.minornext(0);
            $rootScope.minornext(1);
          } else {
            $rootScope.folioBasicDetail.folioForUser = "Self";
            var isEditbuttonClick = sessionStorage.getItem("investorIsEditButtonClick");
            // if(isEditbuttonClick){
            if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE') {
              $rootScope.nextStep(0);
              $rootScope.nextStep(1);
              $rootScope.nextStep(2);
            } else {
              $rootScope.nextStep(0);
              $rootScope.nextStep(1);
              $rootScope.nextStep(2);
              $rootScope.nextStep(3);
            }
            // }
          }
          if(vm.skipInvestmentDetails){
            $rootScope.testObj.steps[1].stepActive = true;
            $rootScope.testObj.steps[1].stepCompleted = false;
          }else{
            $rootScope.testObj.steps[1].stepActive = false;
            $rootScope.testObj.steps[1].stepCompleted = true;
          }
          vm.userTaxStatusCode = resp.data.soleApplicantDetail.personalDetail.taxStatusCode;
          getBankcAccountType();
          sessionStorage.setItem('ModeOfHold', resp.data.holdmode);
          localStorage.setItem('holdmode', resp.data.holdmode);
          vm.payLoad = resp.data;
          var bankExistData = resp.data.bankDetails;
          vm.bankAccountDetailsForm.ifscCode = bankExistData.ifsccode;
          vm.bankAccountDetailsForm.accountType = bankExistData.accountType;
          vm.bankAccountDetailsForm.accountNumber = bankExistData.accountNumber;
          vm.bankAccountDetailsForm.accountNumberverify = bankExistData.accountNumber;
          vm.bankchequeLeafUrl = bankExistData.chequeLeaf;
          if (resp.data.bankDetails) {
            if (resp.data.bankDetails.accountHolderName) {
              if (resp.data.bankDetails.pennyDropValid == false) {
                vm.showcheckLeaf = true;
              } else {
                vm.showcheckLeaf = false;
              }
            } else {
              vm.showcheckLeaf = false;
            }
          }

          try {
            const checkLeafString = bankExistData.chequeLeaf;
            const fileName = checkLeafString.split("/");
            vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
          } catch (e) { }
          if (bankExistData.chequeLeaf) {
            vm.fileType = 'image/jpg'// bankExistData.chequeLeaf.substr(bankExistData.chequeLeaf.length - 3);
          }
          vm.bankAccountDetailsForm.bankName = bankExistData.bankName;
          vm.bankAccountDetailsForm.bankDetails.payoutMechanism = bankExistData.payoutMechanism;
          vm.bankAccountDetailsForm.bankCity = bankExistData.bankCity;
          vm.bankAccountDetailsForm.branchLocation = bankExistData.bankBranch;
          vm.bankAccountDetailsForm.pennyDropValid = bankExistData.pennyDropValid;
          if($rootScope.folioBasicDetail.folioForUser =='Minor' || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
            vm.showcheckLeaf = true;
          }
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          MessageService.error(err);
        };
      var investorId = localStorage.getItem("folioId");
      ChangeDividendService.post({ child1: 'folio', child2: 'getFolioDetails' }, { id: investorId,"arnCode" :vm.tokenData.arnCode }).$promise.then(success, error);
    }


    function getBankcAccountType() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.bankAccountType = resp.data.bankAccountTypes;
          $rootScope.AccountTypes = resp.data.bankAccountTypes;
        }
        else {
          vm.panMessage = resp.message;
        }
      },
        error = function () {
          MessageService.error("Bank account type service error!");
        };

      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: vm.userTaxStatusCode
      }, {}).$promise.then(success, error);
    }

    vm.getPayoutMechanism = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.payoutMechanismList = resp.data.payoutMechanisms;
          $rootScope.payoutMechanismData = resp.data.payoutMechanisms;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };
      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism'
      }, {}).$promise.then(success, error);
    }
    vm.getPayoutMechanism();

    vm.matchAccountNumber = function () {
      if (vm.bankAccountDetailsForm.accountNumber === vm.bankAccountDetailsForm.accountNumberverify) {
        vm.showValidateBtn = true;
      } else {
        vm.showValidateBtn = false;
      }
      vm.bankAccountDetailsForm.chequesleafImageUrl = '';
      if($rootScope.folioBasicDetail.folioForUser == "Minor"  || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
        vm.showcheckLeaf = true;

      }else{
        vm.showcheckLeaf = false;

      }
    }

    vm.fetchBankList = function () {
      var success = function (res) {
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;

        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorsCommonService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
    }
    vm.fetchBankList();

    vm.selectIFSC = function () {
      var successModal = function (data) {
        // console.log(data);
        vm.bankAccountDetailsForm.ifscCode = data.ifscCode;
        vm.bankAccountDetailsForm.bankName = data.bankName;
        vm.bankAccountDetailsForm.bankCity = data.branchCity;
        vm.bankAccountDetailsForm.branchLocation = data.branch;

        if (data.branch && data.branch.length > 40)
          vm.bankAccountDetailsForm.bankBranch = data.branch.slice(0, 40)
        else vm.bankAccountDetailsForm.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.userTaxStatusCode === '01') {
          vm.bankAccountDetailsForm.pennyDropValid = true;
        }
        else {
          vm.bankAccountDetailsForm.pennyDropValid = false;
        }
        if(vm.userTaxStatusCode == 21){
          vm.bankAccountDetailsForm.accountType = "NRE";
        }else if(vm.userTaxStatusCode == 24){
          vm.bankAccountDetailsForm.accountType = "NRO";
        }else{
          vm.bankAccountDetailsForm.accountType = "SB";
        }
        vm.bankAccountDetailsForm.bankDetails.payoutMechanism = "DC";
        vm.bankAccountDetailsForm.accountNumber = '';
        vm.bankAccountDetailsForm.accountNumberverify = '';
        vm.bankAccountDetailsForm.chequesleafImageUrl = '';
        if($rootScope.folioBasicDetail.folioForUser == "Minor"  || vm.userTaxStatusCode == 21 || vm.userTaxStatusCode == 24){
          vm.showcheckLeaf = true;
        }else{
          vm.showcheckLeaf = false;
        }
        vm.showValidateBtn = true;
      },
        errorModal = function () {

        };
      ModalService.IFSCSelectionModalNewJourney({ bankList: vm.bankList }, successModal, errorModal);
    }

    vm.getNewUserDetails = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          localStorage.setItem("folioId", resp.data.folioCreationDraftId);
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (error) {
          MessageService.error(error.message);
        };

      var payload = {
        "panNumber": vm.userData.pan,
        "arnCode":vm.tokenData.arnCode
      }
      InvestorsService.post({ child1: 'new', child2: 'user', child3: 'getDetails' }, payload).$promise.then(success, error);
    }
    // vm.getNewUserDetails();


    vm.submitBankAccountDetails = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.valid === false) {
            MessageService.error(resp.data.message || "We are unable to validate your bank account using IMPS service. Please upload cheque leaf to continue with add bank");
            vm.bankAccountDetailsForm.pennyDropValid = false;
            vm.showcheckLeaf = true;
            vm.showValidateBtn = false;
          } else {
            vm.bankAccountDetailsForm.pennyDropValid = true;
            vm.showcheckLeaf = false;
            vm.bankAccountDetailsForm.accountHolderName = resp.data.name;
            vm.continueFolio();
          }
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },
        error = function () {
          LoaderService.hideLoader();
        };
      var investorFullName = vm.userData.name;
      var pennyDropValidatePayload = {
        "beneficiaryIFSC": vm.bankAccountDetailsForm.ifscCode,
        "benificiaryAccountNo": vm.bankAccountDetailsForm.accountNumber,
        "benificiaryName": investorFullName,
        "arncode": vm.tokenData.arnCode,
        "panNo": vm.userData.pan,
        "distributorInitiate": true
      };
      LoaderService.showLoader();
      InvestorsCommonService.post({
        child1: 'account',
        child2: 'validate',
        child3: 'pennyDrop'
      }, pennyDropValidatePayload).$promise.then(success, error);
    }


    vm.continueFolio = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $state.go('main.newinvestor.folioCreation.folioSummaryDetails');
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('Occupation Errror>>>>', err);
        };

      vm.bankDetailsData = {
        accountHolderName: vm.bankAccountDetailsForm.accountHolderName ? vm.bankAccountDetailsForm.accountHolderName : vm.investorFullName,
        pennyDropValid: vm.bankAccountDetailsForm.pennyDropValid,
        bankHolderType: $rootScope.folioBasicDetail.folioForUser == 'Self' ? 'INVESTOR' : 'MINOR',
        accountType: vm.bankAccountDetailsForm.accountType,
        payoutMechanism: vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
        accountNumber: vm.bankAccountDetailsForm.accountNumber,
        verifyAccountNumber: vm.bankAccountDetailsForm.accountNumberverify,
        ifsccode: vm.bankAccountDetailsForm.ifscCode,
        bankName: vm.bankAccountDetailsForm.bankName,
        bankCity: vm.bankAccountDetailsForm.bankCity,
        chequeLeaf: vm.bankchequeLeafUrl,
      }
      vm.bankDetailsData.bankBranch = vm.bankAccountDetailsForm.branchLocation;
      vm.payLoad.newUserFlow = true;
      vm.payLoad.folioSaveStep = "FIVE";
      vm.payLoad.bankDetails = vm.bankDetailsData;
      vm.payLoad.newFolioComplete = true;
      vm.payLoad.firstFolio = true;
      vm.payLoad.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus;
      vm.payLoad.minor = $rootScope.folioBasicDetail.folioForUser == 'Self' ? false : true,
        vm.payLoad.id = localStorage.getItem("folioId");
        vm.payLoad.folioWithTransaction = true;
        if(vm.skipInvestmentDetails){
          vm.payLoad.folioWithoutTransaction = true;
        }
      var myData = vm.payLoad;
      NewInvestorServiceV3.post({
        child1: 'folio',
        child2: 'distributorNewInvestor',
        child3: 'initiate'
      }, myData).$promise.then(success, error);
    }



    vm.submitWithCheckLeaf = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          $state.go('main.newinvestor.folioCreation.folioSummaryDetails');
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          $log.info('Occupation Errror>>>>', err);
        };
      try {
        vm.investorFullName = vm.userData.name;
      } catch (e) { }
      vm.bankDetailsData = {
        accountHolderName: vm.investorFullName,
        pennyDropValid: vm.bankAccountDetailsForm.pennyDropValid,
        bankHolderType: $rootScope.folioBasicDetail.folioForUser == 'Self' ? 'INVESTOR' : 'MINOR',
        accountType: vm.bankAccountDetailsForm.accountType,
        payoutMechanism: vm.bankAccountDetailsForm.bankDetails.payoutMechanism,
        accountNumber: vm.bankAccountDetailsForm.accountNumber,
        verifyAccountNumber: vm.bankAccountDetailsForm.accountNumberverify,
        ifsccode: vm.bankAccountDetailsForm.ifscCode,
        bankName: vm.bankAccountDetailsForm.bankName,
        bankCity: vm.bankAccountDetailsForm.bankCity,
        chequeLeaf: vm.bankchequeLeafUrl,
      }
      vm.bankDetailsData.bankBranch = vm.bankAccountDetailsForm.branchLocation;
      vm.payLoad.newUserFlow = true;
      vm.payLoad.folioSaveStep = "FIVE";
      vm.payLoad.bankDetails = vm.bankDetailsData;
      vm.payLoad.newFolioComplete = true;
      vm.payLoad.firstFolio = true;
      // if(vm.payLoad.minor == true){
      //   vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus = $rootScope.folioBasicDetail.politicalStatus ? vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus : $rootScope.folioBasicDetail.politicalStatus;
      // }else{
      //   vm.payLoad.soleApplicantDetail.selfDetail.politicalStatus = $rootScope.folioBasicDetail.politicalStatus ? $rootScope.folioBasicDetail.politicalStatus :vm.payLoad.soleApplicantDetail.minorDetail.guardian.politicalStatus;
      // }
      vm.payLoad.minor = $rootScope.folioBasicDetail.folioForUser == 'Self' ? false : true;
      vm.payLoad.id = localStorage.getItem("folioId");
      vm.payLoad.folioWithTransaction = true;
      vm.payLoad.nriFlag = vm.nriTaxStatus;
      if(vm.skipInvestmentDetails){
        vm.payLoad.folioWithoutTransaction = true;
      }
      NewInvestorServiceV3.post({ child1: 'folio', child2: 'distributorNewInvestor', child3: 'initiate' }, vm.payLoad).$promise.then(success, error);
    }


    vm.bankUploadChequeLeafFile = function (file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
        return;
      }
      if (file) {
        if (file.size <= 2000000) {
          var modalSuccess = function () {
            var taxIdentifierNumber = vm.userData.pan;
            var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/investor/folio/add/document/upload/'+taxIdentifierNumber+'/CHEQUE_LEAF';
            LoaderService.showLoader();
            FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                try {
                  const fileName = vm.bankchequeLeafUrl.split("/");
                  vm.bankAccountDetailsForm.chequesleafImageUrl = fileName[fileName.length - 1];
                } catch (e) { }
                 vm.fileType = resp.data.type.toLowerCase();
                // breakFileUrl(vm.bankchequeLeafUrl);
              } else {

                MessageService.error(resp.message)
              }
            }, function () {
              LoaderService.hideLoader();
            });
          } ,
          modalError = function () {

          };

        ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }
        else {
          MessageService.error("File size should not be more than 2 MB.")
        }
      }

    }

    function breakFileUrl(url) {
      vm.bankChequeLeaf = 'Preview Uploaded Leaf Doc';
      vm.fileType = url && url.split('_').reverse()[0].toLowerCase();
      vm.bankchequeLeafUrl = url;
      return;
    }

    vm.openUploadedDoc = function () {
      if(angular.isUndefined(vm.bankchequeLeafUrl)){return;}
      ModalService.imagePreviewModal({showOnly:true, file: vm.bankchequeLeafUrl});
    };

    vm.clearFileSelection = function(){
      angular.element('input[type="file"]').val(null);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SoleApplicantSummary', soleApplicantSummary);

  /** @ngInject */
  function soleApplicantSummary($state, $location, $stateParams, $scope, $timeout, $window, ModalService, MessageService, InvestorModel, AppConstants, InvestorsService, UtilService, moment, LoaderService, HDFC_API, FileUploadService, InvestorsCommonService, InvestorFileUploadService, InvestorOtpVerifyService, AuthService, InvestorServiceDynamicData, FolioApproval, $rootScope , FolioApprovalUpdateContact) {
    var vm = this;
    vm.init = init;
    vm.uniqueLink = $stateParams.uuid;
    vm.isContactUpdate = $stateParams.contact;
    vm.isLoaded = false;
    init();

    function init() {
      $window.onload = function () {
        sessionStorage.removeItem("showDeclaration");
      };
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      LoaderService.showLoader();
      if (!$stateParams.uuid) {
        UtilService.errorHandler('Not a valid link');
        return;
      } else {
        vm.uniqueLink = $stateParams.uuid;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            initiateOtpModal(resp.data);
          } else {
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if (vm.isContactUpdate) {
        FolioApprovalUpdateContact.get({
          VERSION: version,
          controller: 'otp',
          child2: vm.uniqueLink,
          child3: true
        }, null).$promise.then(success, error);
      } else {
        FolioApproval.get({
          VERSION: version,
          controller: 'otp',
          child2: vm.uniqueLink,
          child3: true
        }, null).$promise.then(success, error);
      }
    }

    function initiateOtpModal(data) {
      var successOtpModal = function(resp) {
        vm.isLoaded = true;
        InvestorModel.setHolderlinkId(resp.holderLinkId);
        InvestorModel.setInvestorId(resp.id);
        $state.go('soleApplicant.folio');
      }, errorOtpModal = function(resp) {
        MessageService.error(resp.message);
      };

      var modalData = {
        uniqueLink: vm.uniqueLink,
        type: 'soleApplicant'
      }

      if (vm.isContactUpdate) {
        modalData.contactUpdate = vm.isContactUpdate,
        modalData.updateContactMessage1 = data.otpSentMsg,
        modalData.updateContactMessage2 = data.otpSentMsg2,
        modalData.uniqueLink1 = data.secretLink,
        modalData.uniqueLink2 = data.secretLink2
      }
      ModalService.folioCreationOtpModal(modalData, successOtpModal, errorOtpModal);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioApprovalController', folioApprovalController);

  /** @ngInject */
  function folioApprovalController($state, $location, $stateParams, $scope, $timeout, $window, ModalService, MessageService, InvestorModel, AppConstants, InvestorsService, UtilService, moment, LoaderService, HDFC_API, FileUploadService, InvestorsCommonService, InvestorFileUploadService, InvestorOtpVerifyService, AuthService, InvestorServiceDynamicData,panAdharLinkingService, DownloadPdfService, FileSaver,InvestorCommonServiceVersion2) {

    var vm = this;
    vm.HDFC_API=HDFC_API;
    vm.disabled = disabled;
    vm.fileTaxAction = fileTaxAction;
    vm.addMoreTaxResidency = addMoreTaxResidency;
    vm.addMoreTaxResidencyGD = addMoreTaxResidencyGD;
    vm.deleteTaxResidency = deleteTaxResidency;
    vm.deleteTaxResidencyGD = deleteTaxResidencyGD;
    vm.submitApplicantDetails = submitApplicantDetails;
    vm.submitJointHolders = submitJointHolders;
    vm.submitGuardianDetails = submitGuardianDetails;
    vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
    vm.fileTaxActionGuardianDetails = fileTaxActionGuardianDetails;
    vm.addMoreTaxResidencyJointHolder = addMoreTaxResidencyJointHolder;
    vm.deleteTaxResidencyJointHolder = deleteTaxResidencyJointHolder;
    vm.addMoreJointHolder = addMoreJointHolder;
    vm.switchHolder = switchHolder;
    vm.deleteCurrentJointHolder = deleteCurrentJointHolder;
    vm.submitJointHolder = submitJointHolder;
    vm.switchNominee = switchNominee;
    vm.addMoreNominee = addMoreNominee;
    vm.deleteCurrentNominee = deleteCurrentNominee;
    vm.submitNominee = submitNominee;
    vm.changeStartDate = changeStartDate;
    vm.changeNetWorthDate = changeNetWorthDate;
    vm.goPrevious = goPrevious;
    vm.changeStartDateJointHolder = changeStartDateJointHolder;
    vm.changeStartDateNominee = changeStartDateNominee;
    vm.confirmCancelModaltoReject = confirmCancelModaltoReject;
    vm.approveFolioSubmit = approveFolioSubmit;
    vm.minorCheck = minorCheck;
    vm.init = init;
    vm.onChangePercentage = onChangePercentage;
    vm.selectBirthCity = selectBirthCity;
    vm.selectHolderBirthCity = selectHolderBirthCity;
    vm.selectNomineeBirthCity = selectNomineeBirthCity;
    vm.selectGuardianBirthCity = selectGuardianBirthCity;
    vm.checkAddNominee = checkAddNominee;
    vm.uploadFile = uploadFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.uploadFileAgeProof = uploadFileAgeProof;
    vm.changeMinorDob = changeMinorDob;
    vm.uploadGuardianProofFile = uploadGuardianProofFile;
    vm.validatePennyDrop = validatePennyDrop;
    vm.hidePennyDrop = hidePennyDrop;
    vm.mobileEmailBelongsTo=mobileEmailBelongsTo;
    vm.checkDuplicateNomineePan=checkDuplicateNomineePan;
    vm.checkUniqueGuardianPan=checkUniqueGuardianPan;
    vm.buttonEnable= buttonEnable;
    vm.getStateList=getStateList;
    vm.singleNomineePan=singleNomineePan;
    vm.checkDecimal=checkDecimal;
    vm.getResponseFolioInfo = getResponseFolioInfo;
    vm.onPaste=onPaste;
    vm.changeNomineeRelation = changeNomineeRelation;
    vm.getIdentityProofList = getIdentityProofList;
    vm.changeNomineeIdentityProof = changeNomineeIdentityProof;
    vm.changeEmailId = changeEmailId;
    vm.changeMobileNumber = changeMobileNumber;
    vm.checkNomineeIsMinor = checkNomineeIsMinor;
    vm.changeDrivingLicense = changeDrivingLicense;
    vm.changeAadharCard = changeAadharCard;
    vm.changeSelectedName = changeSelectedName;
    vm.changeNomineeName = changeNomineeName;
    vm.setStatement = setStatement;
    vm.changePercentageOrAmount = changePercentageOrAmount;
    vm.changePassport = changePassport;
    vm.emailIdValid = true;
    // vm.showNomineeUpdate = true;
    if($stateParams.camsMessage){
      vm.camsMessage=$stateParams.camsMessage;
    }else{
      vm.camsMessage=null;
    }




    vm.nomineePanValidCheck=null;
    vm.guardianPanValidCheck=null;
    vm.CONST = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    var date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    vm.minDate = date;
    vm.defaultDate = date;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.chequeLeafMimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeaf = "No file chosen";
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.EMAIL_REGEX = AppConstants.email_regex;
    vm.defaultDob = null;
    var date1 = new Date();
    date1.setFullYear(date1.getFullYear() - 18);
    vm.maxWorthDate = date1;
    var scope = $scope;
    vm.headerDetails = scope.headerDetails || {name: 'Default', pan: 'Default', aadhaarLinking: false};
    vm.soleApplicantForm = {};
    vm.jointHolderForm = {};
    vm.currentJointHolder = 0;
    vm.currentNominee = 0;
    vm.payOutsideIndiaAddresses = null;
    vm.nomineePropertion = {
      min: 1,
      max: 100
    };
    vm.formData = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
    vm.formData = vm.formData.folioCreationRequestCO || vm.formData;
    vm.taxStatusList = [];
    vm.countryList = null;
    vm.cityList = null;
    vm.showAddNomineeLink = true;
    vm.occupationList = [];
    vm.addressDescriptions = [];
    vm.parentIndex = 0;
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth'

    };
    vm.genderList = [{key: 'MALE', value: 'Male'}, {key: 'FEMALE', value: 'Female'}];
    vm.minorRelationshipsList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];
    vm.minorGaurdianAgeProof = null;
    vm.minorGaurdianFileName = "No file chosen";
    vm.pennyDropCheck = null;
    vm.showValidate = false;
    vm.defaultDateNetWorthDate = $window.moment().toString();
    vm.formData.bankDetails.pennyDropValid = true;
    vm.selectIFSC = selectIFSC;
    var pennyDropEnablSelectedBank = true;
    vm.tpv = tpv;
    vm.isPanVerified=false;
    vm.fetchDynamicData = fetchDynamicData;
    vm.showDeclaration = sessionStorage.getItem('showDeclaration') == "true"? true:false;
    vm.downloadFile = downloadFile;

    function tpv() {
      ModalService.tpvModal({});
    }
    function init() {
      vm.stateForRedirection = $state.current.name
      sessionStorage.removeItem('newJourney');
      fetchDynamicData();
      mobileEmailBelongsTo();
      switch ($state.current.name) {
        case 'approval.holder':
        case 'soleApplicant.folio':
        case 'approval.folio.soleApplicant':

          if (vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.email
            && vm.formData.soleApplicantDetail.dob) {/*&& vm.formData.soleApplicantDetail.name*/

            //vm.headerDetails.name = vm.formData.soleApplicantDetail.name;
            vm.headerDetails.name = vm.formData.investorPanDetails.name;
            vm.headerDetails.pan = vm.formData.soleApplicantDetail.minor? vm.formData.guardianDetails.basicDetails.panNumber: vm.formData.soleApplicantDetail.panNumber;
            vm.headerDetails.distributorArn = vm.formData.arnCode;
            vm.headerDetails.distributorName = vm.formData.distributorName;
            scope.headerDetails = vm.headerDetails;
            if (vm.formData.soleApplicantDetail.minor == false) {
              delete vm.formData.guardianDetails;
            }
            fetchSoleLookUp();
            InvestorModel.setInvestorModel(vm.formData);
            vm.defaultDateNetWorthDate = vm.formData.soleApplicantDetail.netWorthDate || $window.moment().toString();
            if(vm.formData.soleApplicantDetail.netWorth){
              $timeout(function () {
                $window.NumToWord(vm.formData.soleApplicantDetail.netWorth, 'ApprovalDisplayWordsTaxAmount');
              });
            }
            if (vm.formData.soleApplicantDetail.minor && vm.formData.soleApplicantDetail.dob) {
              vm.formData.soleApplicantDetail.name=(vm.formData.soleApplicantDetail.firstName && vm.formData.soleApplicantDetail.lastName)?(vm.formData.soleApplicantDetail.firstName+' '+vm.formData.soleApplicantDetail.lastName):vm.formData.soleApplicantDetail.firstName;
              vm.defaultDob = moment(vm.formData.soleApplicantDetail.dob,'DD-MMM-YYYY');
              fileUrl = vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minorAgeProof;
              vm.minorFileType = vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minorAgeProof.substr(vm.formData.soleApplicantDetail.minorAgeProof.lastIndexOf(".") + 1);
              if (fileUrl) {
                myFile = fileUrl.split('/');
                vm.minorAgeProof = myFile[myFile.length - 1];
                vm.minorAgeProofName = myFile[myFile.length - 1];
              }
              var fileUrl1 = vm.formData.guardianDetails && vm.formData.guardianDetails.guardianRelationshipProofUrl;
              vm.guardianFileType = vm.formData.guardianDetails && vm.formData.guardianDetails.guardianRelationshipProofUrl.substr(vm.formData.guardianDetails.guardianRelationshipProofUrl.lastIndexOf(".") + 1);
              if (fileUrl1) {
                var myFile1 = fileUrl1.split('/');
                vm.minorGaurdianAgeProof = myFile1[myFile1.length - 1];
                vm.minorGaurdianFileName = myFile1[myFile1.length - 1];
              }
            }

          } else {
            getFolioInfo(function (isTrue) {
              if (isTrue) {

                // modelEmptyCheck();
                fetchSoleLookUp();
                if(vm.formData.soleApplicantDetail.netWorth){
                  $timeout(function () {
                    $window.NumToWord(vm.formData.soleApplicantDetail.netWorth, 'ApprovalDisplayWordsTaxAmount');
                  });
                }
                vm.defaultDateNetWorthDate = vm.formData.soleApplicantDetail.netWorthDate || $window.moment().toString();
                if (!vm.formData.soleApplicantDetail.dob) {
                  vm.formData.soleApplicantDetail.dob =
                    scope.headerDetails && scope.headerDetails.dob ? scope.headerDetails.dob
                      : vm.formData.soleApplicantDetail.dob;
                }
                if (!vm.formData.soleApplicantDetail.panNumber && !vm.formData.soleApplicantDetail.minor) {
                  vm.formData.soleApplicantDetail.panNumber =
                    scope.headerDetails && scope.headerDetails.pan ? scope.headerDetails.pan
                      : vm.formData.soleApplicantDetail.panNumber;
                }
              }
              if (vm.formData.soleApplicantDetail.minor && vm.formData.soleApplicantDetail.dob) {
                vm.defaultDob = moment(vm.formData.soleApplicantDetail.dob,'DD-MMM-YYYY');
                fileUrl = vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minorAgeProof;
                vm.minorFileType = vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minorAgeProof.substr(vm.formData.soleApplicantDetail.minorAgeProof.lastIndexOf(".") + 1);
                if (fileUrl) {
                  myFile = fileUrl.split('/');
                  vm.minorAgeProof = myFile[myFile.length - 1];
                  vm.minorAgeProofName = myFile[myFile.length - 1];
                }
                var fileUrl1 = vm.formData.guardianDetails && vm.formData.guardianDetails.guardianRelationshipProofUrl;
                vm.guardianFileType = vm.formData.guardianDetails && vm.formData.guardianDetails.guardianRelationshipProofUrl.substr(vm.formData.guardianDetails.guardianRelationshipProofUrl.lastIndexOf(".") + 1);
                if (fileUrl1) {
                  var myFile1 = fileUrl1.split('/');
                  vm.minorGaurdianAgeProof = myFile1[myFile1.length - 1];
                  vm.minorGaurdianFileName = myFile1[myFile1.length - 1];
                }
              }
            });
          }

          break;
        case 'soleApplicant.jointHolders':
        case 'approval.folio.jointHolders':
          // getFolioInfo();
          getResponseFolioInfo();
          break;
        case 'soleApplicant.nominee':
        case 'approval.folio.nominee':
          modelEmptyCheck();
          getCountryList();
          getStateList();
          getCityList();
          getRelationshipList();
          var nomineeArray = vm.formData.nominees;
          if (nomineeArray.length == 0) {
            if (!vm.formData.addNomineeLater) {
              vm.formData.nominees.push(InvestorModel.getNewNominee());
            }
          }
          vm.defaultDateNominee = null;
          if (vm.formData.nominees[vm.parentIndex].dob) {
            vm.defaultDateNominee = (moment(
              moment(vm.formData.nominees[vm.parentIndex].dob), 'DD-MMM-YYYY', true).isValid()) ?
              (moment(vm.formData.nominees[vm.parentIndex].dob).format('DD-MMM-YYYY')) : (moment());
            /*new Date()*/
          }
          if (vm.formData.nominees[vm.parentIndex].nomineeName == '') {
            $timeout(function () {
              if ($window.document.getElementById('nomineeDOBId-' + vm.parentIndex)) {
                $window.document.getElementById('nomineeDOBId-' + vm.parentIndex).value = "";
              }
            })
          }
          vm.duplicateFormNominees = angular.copy(vm.formData.nominees);
          vm.formData.showNomineeUpdate = vm.formData.sebiNomineeRegulatory01650Active;
          if (vm.formData.showNomineeUpdate) {
            vm.formData.incapacitationDeclarationNameList = null;
            vm.formData.incapacitationNameList = [];
            vm.allowedNomineeLength = vm.formData.nomineeLimit || 3;
            getIdentityProofList(function(){
              vm.formData.nominees.forEach(function(data,index){
                checkNomineeIsMinor(index);
              });
            });
            /*if(vm.formData.nomineeRegistrationCO.accountHoldingDeclaration.includes('NAME_OF_NOMINEES')) {
              vm.formData.nomineeName = true;
            }*/

            if(vm.formData.nomineeRegistrationCO.accountHoldingDeclaration === 'NOMINATION_YES') {
              vm.formData.nomination = true;
            } else {
              vm.formData.nomination = false;
            }
            vm.formData.nominees.forEach(function(nominee,index){
              changeNomineeName(index,nominee.nomineeName,function(){
                if(vm.formData.nomineeRegistrationCO.incapacitationDeclaration) {
                  var newList = vm.formData.incapacitationNameList.filter(function (item) {
                    return item.index === vm.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber - 1
                  });
                  vm.formData.incapacitationDeclarationNameList = newList[0];
                }
              });
            });

          } else {
            vm.allowedNomineeLength = vm.formData.nomineeLimit;
          }
          break;
        case 'soleApplicant.bankDetails':
        case 'approval.folio.bankDetails':
          bankNameList();
          modelEmptyCheck();
          acccountTypeLookup();
          payoutMechanismLookup();
          var fileUrl = vm.formData.chequeLeafUrl;
          vm.fileType = vm.formData.chequeLeafUrl.substr(vm.formData.chequeLeafUrl.lastIndexOf(".") + 1);
          if (fileUrl) {
            var myFile = fileUrl.split('/');
            vm.myFile = myFile[myFile.length - 1];
            vm.chequeLeaf = myFile[myFile.length - 1];
          }
          angular.element('#bankDetailsId').addClass('active');
          vm.formData.bankDetails.branchLocation = vm.formData.bankDetails.bankBranch;
          if(!vm.formData.bankDetails.pennyDropValid){
            vm.showValidate = true;
            var profile = AuthService.getToken();
            vm.formData.bankDetails.accountHolderName = profile && profile.investorFullName
          }
          vm.duplicatePaymentForm = angular.copy(vm.formData.bankDetails);
          vm.duplicatePaymentForm.verifyAccountNumber = vm.duplicatePaymentForm.accountNumber;
          vm.investorName= vm.formData.investorPanDetails ? vm.formData.investorPanDetails.name : '';
          angular.element('#verifyAccountNumber').focus();
          if(!fileUrl && vm.formData.soleApplicantDetail.taxStatusCode=="01"){
            vm.formData.bankDetails.pennyDropValid = true;
          }else{
            vm.formData.bankDetails.pennyDropValid = false;
          }
          if(vm.formData.soleApplicantDetail.minor){
            if(angular.isDefined(vm.formData.bankDetails)){
              vm.formData.bankDetails.bankHolderType = vm.formData.bankDetails.bankHolderType=== "INVESTOR"
                ?"INVESTOR":"MINOR";
            }
          }
            // $state.go('approval.folio.bankDetails');
          break;
        case 'soleApplicant.rejected':
        case 'approval.folio.rejected':
        case 'soleApplicant.approved':
        case 'approval.folio.approved':
          // modelEmptyCheck();
          break;

      }
    }

    function selectIFSC() {
      var successModal = function (data) {
        vm.formData.bankDetails.ifsccode = data.ifscCode;
        vm.formData.bankDetails.bankName = data.bankName;
        vm.formData.bankDetails.bankCity = data.branchCity;
        vm.formData.bankDetails.branchLocation = data.branch;
        vm.formData.bankDetails.accountNumber = '';
        vm.formData.bankDetails.verifyAccountNumber = '';
        vm.formData.bankDetails.payoutMechanism = null;
        if (data.branch && data.branch.length > 40) vm.formData.bankDetails.bankBranch = data.branch.slice(0, 40)
        else vm.formData.bankDetails.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.formData.soleApplicantDetail.taxStatusCode === '01') {
          vm.formData.bankDetails.pennyDropValid = true;
          vm.showValidate = true;
        } else {
          vm.formData.bankDetails.pennyDropValid = false;
          vm.showValidate = false;
        }
        pennyDropEnablSelectedBank = vm.formData.bankDetails.pennyDropValid;
        clearCheckLeaf();
      };
      var errorModal = function (e) {
        console.log('Error');
        vm.showValidate = false;
      };
      ModalService.IFSCSelectionModal({bankList: vm.bankList}, successModal, errorModal);
    }
    vm.accModelDirty = false;
    vm.accFocus = function () {
      vm.accModelDirty = true;
      clearCheckLeaf();
      if (pennyDropEnablSelectedBank) {
        vm.formData.bankDetails.pennyDropValid = true;
      }
    };

    function clearCheckLeaf() {
      vm.formData.chequeLeafUrl = "";
      vm.formData.chequeLeaf = "";
      vm.myFile= '';
      vm.chequeLeaf = "No file chosen";
      angular.element("#uploadFileId").val("");
    }

    function resetCheckLeaf() {
      $window.document.getElementById("uploadFileId").value = '';
      if(vm.formData.chequeLeafUrl){
        var fileUrl = vm.formData.chequeLeafUrl;
        var myFile = fileUrl.split('/');
        vm.chequeLeaf = myFile[myFile.length - 1];
      }else{
        vm.chequeLeaf = "No file chosen";
      }
    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('ApprovalDisplayWordsTaxAmount');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function fetchSoleLookUp() {
      setMinorFlag();
      lookupList();
      getCountryList();
      getStateList();
      getCityList();
      taxStatusLookup(vm.formData.soleApplicantDetail.minor);
      getTaxIdType();
    }

    function aadhaarEnrollment(cb) {
      cb = cb || function () {

      }
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.sessionId = resp.data;
          cb(true);
        } else {
          // cb(true);
          MessageService.error('Not able to enroll Aadhaar.');
          cb(false);
        }
      }, error = function (err) {
          // cb(true);
        cb(false);
        MessageService.error(err.message);

      };

      InvestorsService.get({
        controller: 'adhaar',
        child1: 'enrollment',
        child2: 'session-id',
        child3: 'generate',
        child4: InvestorModel.getHolderLinkid()
      }).$promise.then(success, error);
    }

    function uploadGuardianProofFile(file) {
      if (file) {
        if (vm.chequeLeafMimeType.indexOf(file.type) === -1) {
          MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
          return;
          }else if (file.size > 2000000) {
           resetRelationProof();
            MessageService.error("File size should not be more than 2 MB.");
            return;
          }
        vm.minorGaurdianAgeProof = file;
        vm.minorGaurdianFileName = file.name;
        vm.guardianFileType = file.type.split("/")[1];
        var taxIdentifierNumber = vm.headerDetails.pan;
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/GUARDIAN_PROOF/investor/' + InvestorModel.getHolderLinkid();
        LoaderService.showLoader();
        FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            resp.data = resp.data && resp.data.data ? resp.data.data : resp.data;
            vm.formData.guardianDetails.guardianRelationshipProofUrl = resp.data.fileUrl;
          } else {
            MessageService.error(resp.message);
          }
        }, function () {
          LoaderService.hideLoader();
          vm.minorGaurdianFileName = "No file chosen";

        });
      }

    }

    function checkDuplicateNomineePan(index,pan,guardianPan){
      for(var i=0;i<vm.formData.nominees.length;i++){
        if(vm.formData.nominees[i].panNumber==""){
          vm.formData.nominees[i].nomineePanInvalid=false;
        }
      }
      if (vm.formData.nominees[index].panNumber == pan) {
        if (vm.formData.nominees.length >0) {
          vm.formData.nominees[index].nomineePanInvalid = false;
          if((vm.formData.nominees[index].nomineePan && !vm.isPanVerified) || (vm.formData.nominees[index].panNumber=='' && !vm.isPanVerified) || vm.formData.nominees[index].panNumber ) {
            checkUniqueGuardianPan(index, guardianPan, true);

          }
        }
      }
      if (vm.formData.nominees.nomineePan == pan) {
        if (vm.formData.nominees.length == 1) {
          vm.formData.nominees[index].nomineePanInvalid = false;
        }
      }
      else if (vm.formData.nominees.panNumber !== pan) {
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (i !== index && vm.formData.nominees[index].panNumber) {
            if (vm.formData.nominees[i].panNumber == pan) {
              vm.formData.nominees[index].nomineePanInvalid = true;
              vm.formData.nominees[i].nomineePanInvalid = false;
              vm.errorMessage= vm.validateData.UNIQUE_NOMINEE_PAN;
              break;
            }
            else if (vm.formData.nominees[i].panNumber !== pan) {
              vm.formData.nominees[index].nomineePanInvalid = false;
            }
          }
        }
        for(var i=0;i<vm.formData.nominees.length;i++){
          if(vm.formData.soleApplicantDetail.panNumber==vm.formData.nominees[i].panNumber){
            vm.formData.nominees[i].nomineePanInvalid = true;
            vm.errorMessage= vm.validateData.NOMINEE_SAME_INVESTOR;
          }
        }
      }
      vm.formData.nominees[index].identityProofNumber = pan;
      if (!vm.formData.nominees[index].identityProofObj) {
        vm.formData.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.nominees[index].identityProofType
        })
      }

      vm.formData.nominees[index].identityProofCamsCode = vm.formData.nominees[index].identityProofObj ? angular.copy(vm.formData.nominees[index].identityProofObj.identityProofCamsCode) : null;
      checkUniqueGuardianPan(index,guardianPan, false);
    }

    function checkUniqueGuardianPan(index,guardianPan, value){
      if(value)
      {
        vm.formData.nominees[index].verifiedPan=true;
      }
      if(vm.formData.nominees.panNumber !== guardianPan)
      {
        vm.formData.nominees[index].guardianPanInvalid = false;
        for(var i = 0 ; i < vm.formData.nominees.length ; i ++) {
          if( i==index && vm.formData.nominees[i].panNumber == guardianPan && vm.formData.nominees[i].panNumber !== "") {
            vm.formData.nominees[index].guardianPanInvalid = true;
            vm.errorMessageGuardian= vm.validateData.GUARDIAN_SAME_NOMINEE;
            vm.isPanVerified=false;
            break;
          }
          else if(vm.formData.nominees[i].guardianPanNumber !== guardianPan && vm.formData.nominees[i].guardianPanNumber)
          {
            vm.formData.nominees[index].guardianPanInvalid = false;
          }
        }
        if(value){
          var success=function (resp){
            if(resp.data && resp.status){
              vm.isPanVerified=resp.data.panVerifiedFlag;
            } else{
              vm.isPanVerified=true;
              MessageService.error(resp.message);
              vm.formData.nominees[index].verifiedPan=false;
              vm.errorMessageGuardian= resp.message;
            }
          },error=function (resp){
            MessageService.error(resp.message);
          };
          if( vm.formData.nominees[index].guardianPanNumber !== '' && vm.formData.nominees[index].guardianPanInvalid==false
            && vm.formData.nominees[index].guardianPanNumber) {
            InvestorsCommonService.post({
              child1: 'guardian',
              child2: 'verifyPan'
            }, {pan: guardianPan}).$promise.then(success, error);
          }
        }
      }
    }

    function buttonEnable(){

      for(var i=0;i<vm.formData.nominees.length;i++){
        if(vm.formData.nominees[i].nomineePanInvalid == undefined){
          vm.formData.nominees[i].nomineePanInvalid=false;
        }
        if(vm.formData.nominees[i].guardianPanInvalid == undefined){
          vm.formData.nominees[i].guardianPanInvalid= false
        }
        if(vm.formData.nominees[i].verifiedPan ==undefined){
          vm.formData.nominees[i].verifiedPan=true;
        }
        if(vm.formData.nominees[i].panNumber){
          if(vm.formData.nominees[i].nomineePanInvalid){
            vm.nomineePanValidCheck=true;
            return vm.nomineePanValidCheck;
          }
        }
      }
      for(var i=0;i<vm.formData.nominees.length;i++){
        if(vm.formData.nominees[i].guardianPanNumber){
          if(vm.formData.nominees[i].guardianPanInvalid){
            vm.guardianPanValidCheck=true;
            return vm.guardianPanValidCheck;
          }
        }
      }
      for(var i=0;i<vm.formData.nominees.length;i++){
        if(vm.formData.nominees[i].guardianPanNumber){
          if(!vm.formData.nominees[i].verifiedPan){
            vm.guardianPanValidCheck=true;
            return vm.guardianPanValidCheck;
          }
        }
      }

      if(vm.formData.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (vm.formData.nominees[i].aadharCard) {
            if (vm.formData.nominees[i].nomineeAadharInvalid) {
              return true;
            }
          }
        }
      }

      if(vm.formData.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (vm.formData.nominees[i].drivingLicense) {
            if (vm.formData.nominees[i].nomineeDLInvalid) {
              return true;
            }
          }
        }
      }

      if(vm.formData.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (vm.formData.nominees[i].passport) {
            if (vm.formData.nominees[i].nomineePassportInvalid) {
              return true;
            }
          }
        }
      }
      return false;
    }

    function changeMinorDob(date) {
      if (date) {
        vm.formData.soleApplicantDetail.dob = date._d;
        vm.defaultDob = moment(date,'DD-MMM-YYYY');
      }
    }

    function setMinorFlag() {
      if (vm.formData.soleApplicantDetail.minor) {
        vm.minDateMinor = moment().subtract(18, 'years');
        vm.defaultDob = moment(vm.formData.soleApplicantDetail.dob,'DD-MMM-YYYY');
        var fileUrl = vm.formData.soleApplicantDetail.minorAgeProof;
        if (fileUrl) {
          var fileNames = fileUrl.split('/');
          vm.minorAgeProof = fileNames[fileNames.length - 1];
        }
        var fileUrl1 = vm.formData.guardianDetails.guardianRelationshipProofUrl;
        if (fileUrl1) {
          var fileNames1 = fileUrl1.split('/');
          vm.minorGaurdianFileName = fileNames1[fileNames1.length - 1];
        }
        getRelationshipList();
      }
    }

    function getRelationshipList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.relationshipsList = resp.data.nomineeRelationshipList;
            vm.guardianRelationShipList= resp.data.guardianRelationshipList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorsCommonService.get({child1:'nominee',child2:'relation'}, {id:InvestorModel.getHolderLinkid()}).$promise.then(success, error);
    }

    function uploadFileAgeProof(file) {
      if (file) {
        if (vm.chequeLeafMimeType.indexOf(file.type) === -1) {
          MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
          return;
        }else if (file.size > 2000000) {
          resetMinorAgeProof();
          MessageService.error("File size should not be more than 2 MB.");
          return;
        }
        vm.minorAgeProof = file;
        vm.minorAgeProofName = file.name;
        vm.minorFileType = file.type.split("/")[1];
        var taxIdentifierNumber = vm.formData.investorPanDetails.pan;
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/MINOR_PROOF/investor/' + InvestorModel.getHolderLinkid();
        LoaderService.showLoader();
        FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.formData.soleApplicantDetail.minorAgeProof = resp.data.fileUrl;
          } else {
            MessageService.error(resp.message);
          }
        }, function () {
          LoaderService.hideLoader();
          resetMinorAgeProof();
          vm.minorAgeProofName = "No file chosen";
        });
      }

    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };
      InvestorsService.post({
        controller: 'country',
        child1: 'list',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function getFolioInfo(cb) {
      cb = cb || function () {

      }
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          if(!(vm.formData.nominees.length > 0)) {
            vm.formData = resp.data;
          }
          vm.jointHolders = angular.copy(resp.data.jointHolders);
          if(resp.data.soleApplicantDetail.minor){
            vm.payOutsideIndiaAddresses=angular.copy(resp.data.guardianDetails.basicDetails.payOutsideIndiaAddresses);
          }
          else {
            vm.payOutsideIndiaAddresses = angular.copy(resp.data.soleApplicantDetail.payOutsideIndiaAddresses);
          }
          vm.formData.nominees = (resp.data.nominees || vm.formData.nominees) || [];
          vm.formData.linkId = InvestorModel.getHolderLinkid(); //link scret key
          //vm.headerDetails.name = vm.formData.soleApplicantDetail.name;
          vm.headerDetails.name = vm.formData.investorPanDetails.name;
          vm.headerDetails.pan = vm.formData.investorPanDetails.pan;
          vm.headerDetails.distributorArn = vm.formData.arnCode.replace('ARN-','');
          vm.headerDetails.distributorName = vm.formData.distributorName;
          scope.FolioApprovalParent && (scope.FolioApprovalParent.headerDetails = vm.headerDetails);
          vm.formData.soleApplicantDetail.name=(vm.formData.soleApplicantDetail.firstName && vm.formData.soleApplicantDetail.lastName)?(vm.formData.soleApplicantDetail.firstName+' '+vm.formData.soleApplicantDetail.lastName):vm.formData.soleApplicantDetail.firstName;
          vm.duplicateFormSoleApplicant = angular.copy(vm.formData.soleApplicantDetail);

            if (vm.formData.soleApplicantDetail.minor) {
              vm.duplicateFormGuardianDetails = angular.copy(vm.formData.guardianDetails);
            }
            scope.FolioApprovalParent.headerDetails = vm.headerDetails;
            cb(true);
          } else {
          //vm.formData.investorPanDetails.aadharLinked = false;
          //vm.headerDetails.aadhaarLinking = true;
          scope.FolioApprovalParent.headerDetails = vm.headerDetails;
          cb(false);
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        cb(false);
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };



      InvestorsService.post({
        controller: 'new',
        child1: 'folio',
        child2: 'data',
        child3: 'investor'
      }, {id: InvestorModel.getInvestorId(), linkId: InvestorModel.getHolderLinkid()}).$promise.then(success, error);



  }

    function getCityList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.cityList = resp.data.cities;
        } else {
          vm.cityList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.cityList = null;
        UtilService.errorHandler(err);
      };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };
      InvestorsService.post({
        controller: 'city',
        child1: 'list',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function lookupList() {
      occupationLookup();
      incomeSlab();
      addressTypeLookup();
    }

    function taxStatusLookup(minorCheckParams) {
      minorCheckParams = minorCheckParams;
      var successTaxStatus = function (resp) {
          if (resp.status && resp.data) {
            vm.taxStatusList = resp.data.taxStatus;
          } else {
            MessageService.error(resp.message);
          }
        },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };

      var payloadTaxStatus = {
        taxStatusFilter: minorCheckParams ? 'MINOR' :  'ADULT',
        id: InvestorModel.getHolderLinkid(),
        nriFlag: typeof vm.formData.nriFlag == 'boolean' ? vm.formData.nriFlag : null
      };
      InvestorsService.post({
        controller: 'tax-status',
        child1: 'investor'
      }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);


    }

    function occupationLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.occupationList = resp.data.investorOccupations;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      }

      InvestorsService.post({controller: 'get-occupation', child1: 'investor'}, payload).$promise.then(success, error);
    }

    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };
      InvestorsService.post({
        controller: 'income',
        child1: 'slab',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function bankNameList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };

      InvestorsCommonService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);
    }

    function acccountTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };

      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        transactionType:'list',
        child2: 'investor',
        child3: vm.formData.soleApplicantDetail.taxStatusCode
      }).$promise.then(success, error);
    }

    function payoutMechanismLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
            if (vm.formData && vm.formData.folioCreationRequestCO
              && vm.formData.bankDetails) {
              var index = vm.payoutMechanismList.map(function (e) {
                if (e.payoutCode == vm.formData.bankDetails.payoutMechanism) {
                  return vm.formData.bankDetails.accountType;
                }
              }).indexOf(vm.formData.bankDetails.accountType);
              vm.payoutMechanism = index > -1 ? vm.payoutMechanismList[index] : null;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };

      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function modelEmptyCheck() {
      if (!vm.formData.soleApplicantDetail.minor && (!vm.formData.soleApplicantDetail.dob || !vm.formData.soleApplicantDetail.panNumber)) {
        if($state.current.name == 'soleApplicant.nominee' || $state.current.name == 'soleApplicant.bankDetails' || $state.current.name == 'soleApplicant.folio'){
          $state.go('soleApplicant.folio');
        }else {
          $state.go('approval.folio.soleApplicant');
        }
      }
      else if (vm.formData.soleApplicantDetail.minor && (!vm.formData.guardianDetails.basicDetails.dob || !vm.formData.guardianDetails.basicDetails.panNumber)) {
        if($state.current.name.includes('soleApplicant.folio')){
          $state.go('soleApplicant.folio');
        }else {
          $state.go('approval.folio.soleApplicant');
        }
      }
    }

    function addressTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.addressDescriptions = resp.data.addressTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      var payload = {
        id: InvestorModel.getHolderLinkid()
      };

      InvestorsService.post({
        controller: 'address',
        child1: 'type',
        child2: 'investor'
      }, payload).$promise.then(success, error);
    }

    function disabled() {
      return false;
    }

    function fileTaxAction() {
      var array = [];
      if (!vm.formData.soleApplicantDetail.minor) {
        if (!vm.formData.soleApplicantDetail.payTaxInIndia) {
          if (vm.payOutsideIndiaAddresses) {
            vm.formData.soleApplicantDetail.payOutsideIndiaAddresses = angular.copy(vm.payOutsideIndiaAddresses);
          }
          else {
            vm.formData.soleApplicantDetail.payOutsideIndiaAddresses = [{}];
          }
        } else {
          array = vm.formData.soleApplicantDetail.payOutsideIndiaAddresses || [];
          vm.formData.soleApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
        }
      }
      else {
        if (!vm.formData.guardianDetails.basicDetails.payTaxInIndia) {
          if (vm.payOutsideIndiaAddresses) {
            vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses = angular.copy(vm.payOutsideIndiaAddresses);
          }
          else {
            vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses = [{}];
          }
        } else {
          array = vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
          vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses.splice(0, array.length);
        }
      }
    }

    function fileTaxActionJointHolder(index) {

      if (vm.formData.jointHolders[index].jointHolderApplicantDetail.payTaxInIndia) {
        vm.formData.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.formData.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
        vm.formData.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
      }

    }

    function fileTaxActionGuardianDetails() {
      if (vm.formData.guardianDetails.basicDetails.payTaxInIndia) {
        vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
        vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses.splice(0, array.length);
      }
    }

    function addMoreTaxResidency() {
      var array = vm.formData.soleApplicantDetail.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
      vm.payOutsideIndiaAddresses= angular.copy(array);
    }

    function addMoreTaxResidencyGD() {

      var array = vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
      array.length < 4 ? array.push({}) : '';
    }

    function addMoreTaxResidencyJointHolder(parentIndex) {
      var array = vm.formData.jointHolders[parentIndex].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.length < 4 ? array.push({}) : '';
    }

    function deleteTaxResidency(index) {
      var array = vm.formData.soleApplicantDetail.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
      vm.payOutsideIndiaAddresses = angular.copy(array);
    }

    function deleteTaxResidencyGD(index) {
      var array = vm.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function confirmCancelModal() {
      InvestorModel.setInvestorModel(vm.formData);
      var success = function () {
        InvestorModel.setTab({tab2: true, tabJointHolderAddable: true});
        if($state.current.name == 'soleApplicant.jointHolders' || $state.current.name == 'soleApplicant.folio'){
          $state.go('soleApplicant.nominee');
        }else{
          $state.go('approval.folio.nominee');
        }
      }, error = function (val) {
          vm.formData.nominees.push(InvestorModel.getNewNominee());
          vm.formData.addNomineeLater = true;
          InvestorModel.setInvestorModel(vm.formData);
          if(val == 'ok') {
            if ($state.current.name == 'soleApplicant.jointHolders' || $state.current.name == 'soleApplicant.folio'){
              sessionStorage.setItem('showDeclaration',true);
              $state.go('soleApplicant.bankDetails');
            }else {
              $state.go('approval.folio.bankDetails');
            }
            // $state.go('soleApplicant.folio.bankDetails');
          }else{
            if($state.current.name == 'soleApplicant.folio'){
              $state.go('soleApplicant.folio');
            }
          }
      };
      ModalService.confirmCancelModal({Text: 'Do you want to add a Nominee ?', fromFolioCreation: true, buttonText : 'OK', nomineeDetails : vm.formData.nominees, isOptOutDec : vm.dynamicDataForOptOutDec, forFolioCreation : true}, success, error);
    }

    function confirmCancelModaltoReject() {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if ($state.current.name == 'soleApplicant.nominee' || $state.current.name == 'soleApplicant.bankDetails' || $state.current.name == 'soleApplicant.jointHolders' || $state.current.name == 'soleApplicant.folio') {
                $state.go('soleApplicant.rejected');
              } else {
                $state.go('approval.folio.rejected');
              }
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: vm.formData.id,
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId: InvestorModel.getHolderLinkid(),
            uniqueLink : $stateParams.uuid
          };
          LoaderService.showLoader();
          InvestorsService.post({
            controller: 'folio',
            child1: 'details',
            child2: 'reject'
          }, payload).$promise.then(successFolioReject, errorFolioReject);


        }, dismissReason = function () {
          //UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'folioRejection'}, successReason, dismissReason);

      }, dismiss = function () {
        //UtilService.errorHandler(err);

      };
      var msg = "Are you sure, you want to reject<br/>'Folio Creation?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function submitApplicantDetails() {
      InvestorModel.setInvestorModel(vm.formData);
      if (angular.equals(vm.duplicateFormSoleApplicant, vm.formData.soleApplicantDetail)) {
        InvestorModel.setSoleApplicantDataChanged(false);
      } else {
        InvestorModel.setSoleApplicantDataChanged(true);
      }

      if (vm.formData.soleApplicantDetail.minor) {
        if (angular.equals(vm.duplicateFormGuardianDetails, vm.formData.guardianDetails)) {
          InvestorModel.setSoleApplicantDataChanged(false);
        } else {
          InvestorModel.setSoleApplicantDataChanged(true);
        }
      }

      if (vm.formData.soleApplicantDetail.minor) {
        //$state.go('main.investors.add.guardianDetails');

        if (vm.formData.soleApplicantDetail.name) {
          vm.formData.soleApplicantDetail.name = vm.formData.soleApplicantDetail.name.trim();
          var lastIndex = vm.formData.soleApplicantDetail.name.lastIndexOf(" ");
          if (lastIndex > 0) {
            vm.formData.soleApplicantDetail.firstName = vm.formData.soleApplicantDetail.name.substr(0, lastIndex);
            vm.formData.soleApplicantDetail.lastName = vm.formData.soleApplicantDetail.name.substr(lastIndex + 1);
          }
          else {
            vm.formData.soleApplicantDetail.firstName = vm.formData.soleApplicantDetail.name;
            vm.formData.soleApplicantDetail.lastName = '';
          }
          delete vm.formData.soleApplicantDetail.name;
        }
        vm.formData.soleApplicantDetail.dob = $window.moment(vm.formData.soleApplicantDetail.dob,'DD-MMM-YYYY').format('DD-MMM-YYYY');
        if ($state.current.name.includes('soleApplicant.folio')) {
          $state.go('soleApplicant.bankDetails');
        } else {
          $state.go('approval.folio.bankDetails');
        }
      } else {
        if(vm.formData.jointHolders && vm.formData.jointHolders.length>0){
          if ($state.current.name.includes('soleApplicant.folio')) {
            $state.go('soleApplicant.jointHolders');
          } else {
            $state.go('approval.folio.jointHolders');
          }
        }else{
          if(vm.formData.nominees && vm.formData.nominees.length>0 && !vm.formData.nominees[0].nomineeName){
            vm.formData.addNomineeLater=false;
            vm.formData.nominees=[];
          }
          if((!vm.formData.nominees || vm.formData.nominees.length == 0) && !vm.formData.addNomineeLater) {
            confirmCancelModal();
          }else {
            if(vm.formData.nominees.length==0) {
              sessionStorage.removeItem("showDeclaration");
            }
            if ($state.current.name.includes('soleApplicant.folio')) {
              $state.go('soleApplicant.nominee');
            } else {
              $state.go('approval.folio.nominee');
            }
          }
        }
      }
    }

    function submitJointHolders() {
      if(vm.formData.nominees && vm.formData.nominees.length>0 && !vm.formData.nominees[0].nomineeName){
        vm.formData.addNomineeLater=false;
        vm.formData.nominees=[];
      }
      if((!vm.formData.nominees || vm.formData.nominees.length == 0) && !vm.formData.addNomineeLater) {
        confirmCancelModal();
      }else {
        if($state.current.name.includes('soleApplicant.jointHolders')){
          $state.go('soleApplicant.nominee');
        }else {
          $state.go('approval.folio.nominee');
        }
      }
    }
    function submitGuardianDetails() {
      InvestorModel.setInvestorModel(vm.formData);
      confirmCancelModal();
    }

    function deleteTaxResidencyJointHolder(parentIndex, index) {
      var array = vm.formData.jointHolders[parentIndex].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function addMoreJointHolder() {

      var array = vm.formData.jointHolders || [];

      if (vm.formData.jointHolders[vm.parentIndex].jointHolderName) {
        if (array.length <= 2) {
          var blankObj = InvestorModel.getNewJointHolder();
          array.push(blankObj);
          InvestorModel.setInvestorModel(vm.formData);
        }
        else {
          array.length = 0;
        }
        vm.currentJointHolder++;
        pan4JointHolders();
      }
    }

    function deleteCurrentJointHolder(parentIndex) {
      var model = vm.formData.jointHolders || [];
      model.splice(parentIndex, 1);
      vm.currentJointHolder--;
      if (model.length == 0) {
        vm.formData.jointHolders = [];
        InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
        InvestorModel.setInvestorModel(vm.formData);
        $state.go('main.investors.add.appdetails');
      }
    }

    function switchHolder(index) {
      vm.currentJointHolder = index;
    }

    function switchNominee(index,pan,guardianPan, drivingLicense,aadharCard, passport) {
      vm.defaultDateNominee = null;
      vm.currentNominee = index;
      vm.parentIndex = index;
      if (vm.formData.nominees.length == 0) {
        vm.nomineePropertion.min = 0;
        vm.nomineePropertion.max = 100;
      }
      else {
        var tempProportion = 0;
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (i != vm.currentNominee && vm.formData.nominees[i].percentage) {
            tempProportion = tempProportion + vm.formData.nominees[i].percentage;
          }
        }
        vm.nomineePropertion.max = 100 - tempProportion;
        vm.defaultDateNominee = vm.formData.nominees[index].dob ?
          vm.formData.nominees[index].dob : null;
        vm.formData.nominees[index].verifiedPan=true;
        if (pan) {
          vm.checkDuplicateNomineePan(index,pan);
        }

        if (guardianPan) {
          vm.checkUniqueGuardianPan(index,guardianPan,true);
        }

        if(vm.formData.folioCreationRequestCO.showNomineeUpdate) {
          changeDrivingLicense(index, drivingLicense);
          changeAadharCard(index, aadharCard);
          changePassport(index, passport);
        }
      }
    }

    function onChangePercentage(index) {
      if (vm.formData.nominees.length == 0) {
        vm.nomineePropertion['min-0'] = 0;
        vm.nomineePropertion['max-0'] = 100;
      }
      else {
        var tempProportion = 0, totalProportion = 0;
        for (var i = 0; i < vm.formData.nominees.length; i++) {
          if (i != index && vm.formData.nominees[i].percentage) {
            tempProportion = tempProportion + vm.formData.nominees[i].percentage;
          }
          totalProportion += (vm.formData.nominees[i].percentage) * 1;
        }
        vm.showAddNomineeLink = (totalProportion < 100);
        vm.nomineePropertion['max-' + index] = 100 - tempProportion;
      }
    }

    function addMoreNominee() {
      var array = vm.formData.nominees || [];
      vm.parentIndex = array.length - 1;
      var totalPropotion = 0;
      array.map(function (ele) {
        if (parseInt(ele.percentage)) {
          totalPropotion += ele.percentage * 1;
        }
      });
      if (totalPropotion >= 100) {
        MessageService.error("Proportion % has been alloted full.");
      } else {
        if (vm.formData.nominees[vm.parentIndex] && vm.formData.nominees[vm.parentIndex].nomineeName
          && vm.formData.nominees[vm.parentIndex].percentage
        ) {
          if (array.length < vm.allowedNomineeLength) {
            array.push({});
            InvestorModel.setInvestorModel(vm.formData);
            vm.defaultDateNominee = null; //new Date();
          } else {
            array.length = 0;
          }
          vm.currentNominee++;
          checkNomineeIsMinor(array.length-1);
        } else {
          angular.element('#nomineeName-' + vm.parentIndex).focus();
          MessageService.error("Please enter Valid Nominee Details");
        }
        if (vm.formData.nominees.length == 0) {
          vm.nomineePropertion.min = 0;
          vm.nomineePropertion.max = 100;
        } else {
          var tempProportion = 0;
          for (var i = 0; i < vm.formData.nominees.length; i++) {
            if (vm.formData.nominees[i].percentage) {
              tempProportion = tempProportion + vm.formData.nominees[i].percentage;
            }
          }
          vm.nomineePropertion.max = 100 - tempProportion;
        }
      }
    }

    function checkAddNominee() {
      if (vm.formData.addNomineeLater) {
        vm.currentNominee = 0;
        vm.parentIndex = 0;
        vm.formData.addNomineeLater = true;
        InvestorModel.setInvestorModel(vm.formData);
      }
    }

    function deleteCurrentNominee(index) {
      var array = vm.formData.nominees || [];
      array.splice(index, 1);
      vm.currentNominee = (vm.currentNominee > 0 && vm.currentNominee == index) ? (vm.currentNominee - 1) : 0;

      if (array.length == 0) {
        vm.formData.nominees = [];
        InvestorModel.setInvestorModel(vm.formData);
        if($state.current.name.includes('soleApplicant.folio')){
          $state.go('soleApplicant.folio');
        }else {
        $state.go('approval.folio.soleApplicant');
        }
      }
      singleNomineePan();
      vm.validateDOBRequre();
      changeNomineeName(index);
    }

    function pan4JointHolders() {
      var addFlag = true;
      var successPanDetails = function (result) {
          if (result.status && result.data && result.data.kycverified) {
            if (vm.formData.soleApplicantDetail.panNumber != result.data.pan) {
              angular.forEach(vm.formData.jointHolders, function (val) {
                if (val.jointHolderApplicantDetail.panNumber == result.data.pan) {
                  MessageService.error("Valid PAN details required to add joint holder");
                  addFlag = false;
                  vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
                  --vm.currentJointHolder;
                }
              });

              if (addFlag) {

                var newModel = InvestorModel.getNewJointHolder();
                vm.formData.jointHolders[vm.currentJointHolder] = newModel;
                vm.formData.jointHolders[vm.currentJointHolder].jointHolderName = result.data.name;
                vm.formData.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.panNumber = result.data.pan;
                vm.formData.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.dob = result.data.dob;


                var successTaxStatus = function (resp) {
                    if (resp.status && resp.data) {
                      vm.taxStatusList = resp.data.taxStatus;
                      $window.scrollTo(0, 0);
                    } else {
                      MessageService.error(resp.message);
                    }
                  },
                  errorTaxStatus = function (err) {
                    UtilService.errorHandler(err);
                  };

                var payloadTaxStatus = {
                  taxStatusFilter: result.data.minor ? 'MINOR' : 'ADULT',
                  id: InvestorModel.getHolderLinkid()
                };
                InvestorsService.post({
                  controller: 'tax-status',
                  child1: 'investor'
                }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);

              }

            } else {
              vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
              --vm.currentJointHolder;
              MessageService.error("Valid PAN details required to add joint holder");
            }
          } else {
            MessageService.error(result.message || 'Kyc verification is pending.');
          }
        },
        errorPanDetails = function () {
          vm.formData.jointHolders.splice(vm.currentJointHolder, 1);
          --vm.currentJointHolder;
        };
      var labelSetter = {type: 'jointholders', label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}}
      ModalService.checkPanModal(labelSetter, successPanDetails, errorPanDetails);
    }

    function submitJointHolder() {
      InvestorModel.setInvestorModel(vm.formData);
      $state.go('main.investors.add.bankdetails')
    }

    function submitNominee() {
      var array = vm.formData.nominees || [];
      if (array[0] && array[0].nomineeName && !vm.formData.addNomineeLater) {
        var totalPropotion = 0;
        array.map(function (ele) {
          if (parseInt(ele.percentage)) {
            totalPropotion += ele.percentage * 1;
          }
        });
        if (totalPropotion != 100) {
          angular.element('#percentage-' + vm.parentIndex).focus();
          MessageService.error("Sum of percentage proportion of all nominees should be equal to 100%.");
        } else {
          InvestorModel.setInvestorModel(vm.formData);
          if (angular.equals(vm.duplicateFormNominees, vm.formData.nominees)) {
            InvestorModel.setNomineeDataChanged(false);
          } else {
            InvestorModel.setNomineeDataChanged(true);
          }
          if($state.current.name.includes('soleApplicant.nominee')){
            $state.go('soleApplicant.bankDetails');
          }else {
            $state.go('approval.folio.bankDetails');
          }
        }
      } else {
        InvestorModel.setInvestorModel(vm.formData);
        if (angular.equals(vm.duplicateFormNominees, vm.formData.nominees)) {
          vm.nomineesDataChanged = false;
        } else {
          vm.nomineesDataChanged = true;
        }
        if($state.current.name == 'soleApplicant.nominee' || $state.current.name == 'soleApplicant.folio'){
          $state.go('soleApplicant.bankDetails');
        }else {
          $state.go('approval.folio.bankDetails');
        }
      }
    }

    function approveFolioSubmit() {
      vm.formData.uniqueLink = $stateParams.uuid;
      var success = function () {
        InvestorModel.setInvestorModel(vm.formData);
        sanitizingFormData(vm.formData);
        if (InvestorModel.getDocumentChange()) {
          vm.formData.changed = true;
        }
        delete vm.formData.bankDetails.bankHolderType;
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.folioDataInvalid) {
              ModalService.genericModal({
                text: resp.data.message
              });
            } else {
              vm.camsMessage= resp.data.nomineeRegistrationFailureMessage;
              if($state.current.name == 'soleApplicant.bankDetails'){
                $state.go('soleApplicant.approved',{camsMessage:vm.camsMessage});
              }else {
                $state.go('approval.folio.approved',{camsMessage:vm.camsMessage});
              }
            }
          } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
              } else {
                MessageService.error(resp.message);
              }
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        InvestorsService.post({
          controller: 'folio',
          child1: 'details',
          child2: 'approve'
        }, vm.formData).$promise.then(successFolioApprove, errorFolioApprove);


      }, dismiss = function () {

      };
      if (angular.equals(vm.duplicatePaymentForm, vm.formData.bankDetails)) {
        InvestorModel.setBankDataChanged(false);
      } else {
        InvestorModel.setBankDataChanged(true);
      }
      var msg = "Are you sure, you want to approve<br/> 'Folio Creation?'";

      var successHandler = function(resp) {
        ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
      }

      var errorHandler = function(resp) {}

      panAdharLinkingService.checkPanAdharStatus(vm.formData.investorPanDetails.pan,'',vm.formData.arnCode).then(successHandler).catch(errorHandler);

    }


    function sanitizingFormData(model) {
      if (model.addNomineeLater) {
        model.nominees = [];
      } else if (model.nominees.length > 0) {
        model.nominees = model.nominees.filter(function (ele) {
          return !!ele.nomineeName;
        });
        angular.forEach(model.nominees, function (nominee) {
          if(nominee.nomineeRelation == ""){
            delete nominee.nomineeRelation;
          }else if(nominee.nomineeRelation === vm.CONST.RELATIONS.OTHER){
            nominee.nomineeRelation = nominee.nomineeRelationOther
              ?nominee.nomineeRelationOther:vm.CONST.RELATIONS.OTHER;
            delete nominee.nomineeRelationOther;
          }
          if(model.showNomineeUpdate) {
            delete nominee.identityProofList;
            delete nominee.drivingLicense;
            delete nominee.aadharCard;
            delete nominee.nomineePan;
            delete nominee.passport;
          }
        });
      }
      delete model.incapacitationDeclarationNameList;
      delete model.incapacitationNameList;
      delete model.sebiNomineeRegulatory01650Active;
      delete model.nomineeLimit;
      delete model.nomineeName;
      delete model.showNomineeUpdate;
      delete model.addNomineeLater;
      if (InvestorModel.getSoleApplicantDataChanged() || InvestorModel.getNomineeDataChanged() || InvestorModel.getBankDataChanged()) {
        model.changed = true;
      } else {
        model.changed = false;
      }
      if (model.guardianDetails) {
        if (!model.guardianDetails.basicDetails.dob || !model.guardianDetails.basicDetails.panNumber) {
          delete model.folioCreationRequestCO.guardianDetails;
        }
        if(model.soleApplicantDetail.name) {
          var lastIndex = model.soleApplicantDetail.name.lastIndexOf(" ");
          if (lastIndex > 0) {
            model.soleApplicantDetail.firstName = model.soleApplicantDetail.name.substr(0, lastIndex);
            model.soleApplicantDetail.lastName = model.soleApplicantDetail.name.substr(lastIndex + 1);
          }
          else {
            model.soleApplicantDetail.firstName = model.soleApplicantDetail.name;
            model.soleApplicantDetail.lastName = '';
          }
        }
      }
    }

    function changeStartDate(date) {
      if (date && date._i) {
        vm.formData.soleApplicantDetail.netWorthDate = date._i;
        vm.defaultDateNetWorthDate = date.toString();
      }
    }

    vm.resetNetWorthDateFlag = true;

    vm.showMessage = function () {
      if (vm.validationMsg) {
        MessageService.error(vm.validationMsg);
      }
    };

    vm.resetNetWorthDate = function () {
      vm.formData.soleApplicantDetail.netWorthDate = '';
      angular.element('#soleNetWorthDate2').val('');
    };

    vm.resetNetWorthDateG = function () {
      vm.formData.guardianDetails.basicDetails.netWorthDate = '';
      angular.element('#guardianDetailsNetWorthDate').val('');
    };

    vm.setOptionalEmptyG = function (flag) {

      if (flag == 'GrossAnnualIncome') {
        vm.formData.guardianDetails.basicDetails.netWorth = '';
        vm.formData.guardianDetails.basicDetails.netWorthDate = '';
        vm.resetNetWorthDateG();
      } else if (flag == 'NetWorth') {
        vm.formData.guardianDetails.basicDetails.grossAnnualIncome = '';
      }
    };



    vm.setOptionalEmpty = function (flag) {

      if (flag == 'GrossAnnualIncome') {
        vm.formData.soleApplicantDetail.netWorth = '';
        vm.formData.soleApplicantDetail.netWorthDate = '';
        vm.resetNetWorthDate();
      } else if (flag == 'NetWorth') {
        vm.formData.soleApplicantDetail.grossAnnualIncome = '';
      }
    };

    vm.changeNomineeDob = function (date) {
      vm.modalData = {};
      vm.modalData.dob = date && date._i ? date._i : '';
    };

    function changeNetWorthDate(date) {
      vm.formData.guardianDetails.basicDetails.netWorthDate = date && date._i ? date._i : '';
    }

    function changeStartDateJointHolder(date) {
      vm.formData.jointHolders[vm.parentIndex].jointHolderApplicantDetail.netWorthDate = date && date._i ? date._i : '';
    }

    function changeStartDateNominee(date) {
      if (date && date._i) {
        vm.formData.nominees[vm.currentNominee].dob = date._i;
        //vm.defaultDateNominee = date.toString();
        vm.defaultDateNominee = date ? date : null;
      }
      var currentDate = (new Date()).getTime();
      var selectedDate = (new Date(date._d)).getTime();
      var diff = Math.abs(currentDate - selectedDate);
      vm.formData.nominees[vm.currentNominee].minor = diff < (18 * 365 * 24 * 60 * 60 * 1000);
      if(vm.formData.nominees[vm.currentNominee].minor == false){
        vm.formData.nominees[vm.currentNominee].guardianPanNumber = null;
        if(vm.formData.nominees[vm.currentNominee].guardianAddress) {
          vm.formData.nominees[vm.currentNominee].guardianAddress.addressLine1 = null;
          vm.formData.nominees[vm.currentNominee].guardianAddress.addressLine2 = null;
          vm.formData.nominees[vm.currentNominee].guardianAddress.city = null;
          vm.formData.nominees[vm.currentNominee].guardianAddress.state = null;
          vm.formData.nominees[vm.currentNominee].guardianAddress.country = null;
          vm.formData.nominees[vm.currentNominee].guardianAddress.pinCode = null;
        }

      }
    }

    function goPrevious(togo) {
      switch (togo) {
        case 'nominee':
          $state.go('main.investors.add.nominee');
          break;
        case 'jointHolders':
          $state.go('main.investors.add.jointholders');
          break;
        case 'soleApplicant':
          $state.go('main.investors.add.appdetails');
          break;

      }
    }

    function minorCheck(index) {
      if (vm.formData.nominees[index]) {
        if (!vm.formData.nominees[index].minor) {
          vm.formData.nominees[index].nomineeGuardianAddress = {};
        }
      }
    }

    function selectBirthCity(_data) {
      vm.formData.soleApplicantDetail.birthCity = _data.cityName;
    }

    function selectHolderBirthCity(_data, holder) {
      holder.jointHolderApplicantDetail.birthCity = _data.cityName;
    }

    function selectNomineeBirthCity(_data, nomineeData) {
      nomineeData.nomineeAddress.city = _data.cityName;
    }

    function selectGuardianBirthCity(_data) {
      vm.formData.guardianDetails.basicDetails.birthCity = _data.cityName;
    }

    vm.changedTaxStatus = function () {
      if (vm.formData.soleApplicantDetail.taxStatusCode == "21" || vm.formData.soleApplicantDetail.taxStatusCode == "24") {
        vm.formData.soleApplicantDetail.payTaxInIndia = false;
        fileTaxAction();
      } else {
        vm.formData.soleApplicantDetail.payTaxInIndia = true;
      }
      vm.formData.bankDetails && (vm.formData.bankDetails.accountType = '');
    };

    function uploadFile(file) {
      if (file) {
        if (vm.chequeLeafMimeType.indexOf(file.type) === -1) {
          MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
          resetCheckLeaf();
          return;
        }
        if (file.size <= 2000000) {
          vm.chequeLeaf = file.name;
          vm.myFile = file.name;
          vm.fileType = file.type.split("/")[1];
          var taxIdentifierNumber = vm.formData.investorPanDetails.pan;
          var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/CHEQUE_LEAF/investor/' + InvestorModel.getHolderLinkid();
          LoaderService.showLoader();
          FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
          LoaderService.hideLoader();
          resp.data = resp.data && resp.data.data ? resp.data.data : resp.data;
          if (resp.status && resp.data) {
            resp.data = resp.data.data?resp.data.data:resp.data;
            InvestorModel.setDocumentChange(true);
              vm.formData.chequeLeafUrl = resp.data.fileUrl;
            } else {
            pennyDropEnablSelectedBank = true;
            InvestorModel.setDocumentChange(false);
              MessageService.error(resp.message);
              resetCheckLeaf();

            }
          }, function () {
            resetCheckLeaf();
            LoaderService.hideLoader();
          });
        }
        else {
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
      }
        else {
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
    }


    function resetMinorAgeProof() {
      $window.document.getElementById("minorAgeProof").value = '';
      if(vm.formData.soleApplicantDetail && vm.formData.soleApplicantDetail.minorAgeProof){
        var fileUrl = vm.formData.soleApplicantDetail.minorAgeProof;
        var myFile = fileUrl.split('/');
        vm.minorAgeProof = myFile[myFile.length - 1];
        vm.minorAgeProofName = myFile[myFile.length - 1];
      }else{
        vm.minorAgeProofName = "No file chosen";
        vm.minorAgeProof = {};
      }

    }


    function resetRelationProof() {
      $window.document.getElementById("uploadGurdianAgeProof").value = '';
      if(vm.formData.guardianDetails && vm.formData.guardianDetails.guardianRelationshipProofUrl){
        var fileUrl = vm.formData.guardianDetails.guardianRelationshipProofUrl;
        var myFile = fileUrl.split('/');
        vm.minorGaurdianAgeProof = myFile[myFile.length - 1];
        vm.minorGaurdianFileName = myFile[myFile.length - 1];

      }else{
        vm.minorGaurdianFileName = "No file chosen";
        vm.minorGaurdianAgeProof = {};
      }
    }

    function openUploadedDoc(url , type) {
      if(angular.isUndefined(url)){return;}
      var _path= HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + "/investor/image/open/"+InvestorModel.getHolderLinkid()+"/"+type+"?"+performance.now();
      ModalService.imagePreviewModal({showOnly:true, file: _path});
    }

    function getTaxIdType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxIdTypeList = resp.data.taxIdTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({
        controller: 'taxId-type',
        child1: 'investor'
      }, {"id": InvestorModel.getHolderLinkid()}).$promise.then(success, error);
    }

    vm.copyPasteHandler = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    };

    function validatePennyDrop() {
      if (vm.formData.bankDetails.pennyDropValid === true) {
        var profile = AuthService.getToken() ? AuthService.getToken(): {};
        var pennyDropValidatePayload = {
          beneficiaryIFSC:vm.formData.bankDetails.ifsccode,
          benificiaryAccountNo:vm.formData.bankDetails.accountNumber,
          benificiaryName:vm.formData.soleApplicantDetail.name,
          arncode: vm.formData.arnCode,
          panNo: vm.formData.soleApplicantDetail.panNumber
        };
        var success = function (resp) {
            vm.showValidate = false;
            if (resp.status && resp.data) {
              if(resp.data.valid === false) {
                MessageService.error(resp.data.message);
                vm.formData.bankDetails.pennyDropValid = false;
                pennyDropEnablSelectedBank = true
              }
              else {
                vm.formData.bankDetails.pennyDropValid = true;
                vm.formData.bankDetails.accountHolderName = resp.data.name;
                approveFolioSubmit();
              }
            } else {
             if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
             } else {
              MessageService.error(resp.message);
             }
            }
            LoaderService.hideLoader();
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
            LoaderService.hideLoader();
          };
        InvestorsCommonService.post({
          child1: 'account',
          child2: 'validate',
          child3: 'pennyDrop'
        }, pennyDropValidatePayload).$promise.then(success, error);
      }
      else {
        vm.showValidate = true;
        vm.formData.bankDetails.pennyDropValid = false;
      }
    }

    function hidePennyDrop(){
      if(vm.formData.soleApplicantDetail.taxStatusCode == "21"  || vm.formData.soleApplicantDetail.taxStatusCode == "24"){
        vm.formData.bankDetails.pennyDropValid = false;
      }
    }

    $scope.nominees = vm.formData.nominees;
    $scope.$watch('nominees', function (newValue) {
      if(angular.isUndefined(scope.nomineeForm) || scope.nomineeForm.$valid){vm.validationMsg = '';return;}
      var formFieldList = scope.nomineeForm.$error.required;

      if (angular.isArray(formFieldList) && formFieldList.length > 0) {
        var formTypeArray = formFieldList.map(function (ele) {
          return ele.$name.split('-')[1]
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
        var nomineeList = [];
        angular.forEach(formTypeArray, function (val) {
          switch (val) {
            case "0":
              nomineeList.push('First Nominee Details');
              break;
            case "1":
              nomineeList.push('Second Nominee Details');
              break;
            case "2":
              nomineeList.push('Third Nominee Details');
              break;
            case "3":
              nomineeList.push('Fourth Nominee Details');
              break;
            case "4":
              nomineeList.push('Fifth Nominee Details');
              break;
            case "5":
              nomineeList.push('Sixth Nominee Details');
              break;
            default:
              vm.validationMsg = '';
          }
        });
        vm.validationMsg = setMsg(nomineeList);
      } else {
        vm.validationMsg = '';
      }
    }, true);

    function setMsg(list) {
      var msg = 'Please complete the ';
      var array = angular.copy(list);
      if (array.length == 0) {
        return '';
      }
      else if (array.length == 1) {
        return msg + array.join(',') + ' Details';
      }
      else if (array.length > 1) {
        var listLast = array.pop();
        return msg + array.join(' , ') + ' and ' + listLast + ' Details';
      }
    }
    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsCommonService.get({
        child1: 'state',
        child2: 'list'
      }).$promise.then(success, error);
    }

    function singleNomineePan(){
      if(vm.formData.nominees.length == 1) {
        if (vm.formData.nominees[0].nomineePan && (vm.formData.soleApplicantDetail.panNumber == vm.formData.nominees[0].nomineePan)) {
          vm.formData.nominees[0].nomineePanInvalid = true;
          vm.errorMessage = "You cannot add yourself as Nominee"
        }
        else if(vm.formData.nominees[0].nomineePan && vm.formData.nominees[0].guardianPanNumber (vm.formData.nominees[0].nomineePan==vm.formData.nominees[0].guardianPanNumber)){
          vm.formData.nominees[0].guardianPanInvalid=true;
        }
        else {
          vm.formData.nominees[0].nomineePanInvalid = false;
          vm.formData.nominees[0].guardianPanInvalid = false;
        }
      }
    }
    vm.changeNomineeSelectedCountry = function(index,countryCode){
      if (!countryCode) {
        vm.formData.nominees[index].nomineeAddress.state = null;
        vm.formData.nominees[index].nomineeAddress.country = null;
      }
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.formData.nominees[index].nomineeAddress.country = country.countryCode;
          if (vm.formData.nominees[index].nomineeAddress.country != 'IN'){
            for(var i = 0; i<vm.stateList.length; i++){
              if (vm.stateList[i].stateCode == 'XX'){
                vm.formData.nominees[index].nomineeAddress.state = vm.stateList[i].stateCode;
                break;
              }
            }
          }
        }
      });
    }
    vm.changeSelectedCountry = function(index,countryCode){
      if (!countryCode) {
        vm.formData.nominees[index].guardianAddress.state = null;
        vm.formData.nominees[index].guardianAddress.country = null;
      }
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.formData.nominees[index].guardianAddress.country = country.countryCode;
          if (vm.formData.nominees[index].guardianAddress.country != 'IN'){
            for(var i = 0; i<vm.stateList.length; i++){
              if (vm.stateList[i].stateCode == 'XX'){
                vm.formData.nominees[index].guardianAddress.state = vm.stateList[i].stateCode;
                break;
              }
            }
          }
        }
      });
    }

    function mobileEmailBelongsTo() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.emaillList = resp.data.emailList;
            vm.mobileList=resp.data.mobileList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorServiceDynamicData.get({
        child1: 'contactType',
        child2: 'details'}).$promise.then(success, error);
    }
    function checkDecimal(event){
      if(event.key==='.') {
        event.preventDefault();
      }
    }

    function onPaste(event){
      event.preventDefault();
    }

    function fetchDynamicData(){
      UtilService.fetchDynamicData('FOLIO_CREATION')
        .then(function (data){
          if(data){
            vm.dynamicDataForOptOutDec = data.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT.content;
          }else{
            vm.dynamicDataForOptOutDec = null;
          }
        }).catch(function (error){
        vm.dynamicDataForOptOutDec = null;
      })
    }

    function downloadFile(url, fileType, proofType) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data) {
          var myFile = url.split('/');
          var fileName = myFile[myFile.length - 1];
          var data = new Blob([resp.data], { type: 'application/'+fileType });
          FileSaver.saveAs(data, fileName+'.'+fileType);
        } else {
          MessageService.error('No Data Available');
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {};
      var _path= HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + "/investor/image/open/"+InvestorModel.getHolderLinkid()+"/"+proofType+"?"+performance.now();
      DownloadPdfService.download(payload, fileType, _path).then(success, error);
    }

    vm.changeNomineeIsMinor = function(index){
      vm.formData.nominees[index].dob = null;
      $timeout(function () {
        if (vm.formData.nominees[index].minor) {
          vm.formData.nominees[index].panNumber = null;
        } else {
          vm.formData.nominees[index].guardianPan =null;
          vm.formData.nominees[index].guardianRelation = null;
          vm.formData.nominees[index].guardian = null;
        }
        checkNomineeIsMinor(vm.currentNominee);
        changeNomineeName(vm.currentNominee,vm.formData.nominees[vm.currentNominee].nomineeName);
      }, 25);
    }
    vm.setInitiatedDate = function(){
      $timeout(function () {
        vm.dataMinDate1 = "";
        vm.dataMaxDate1 = "";
        vm.dataMinDate = "";
        vm.dataMaxDate = "";
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
          vm.dataMinDate1 = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          vm.dataMaxDate1 = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
          vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          vm.dataMinDate = $window.moment(Date.parse(initiateDate));
      }, 25);
    }
    vm.setInitiatedDate();
    vm.validateDOBRequre = function(){
      vm.validateAllDOB = false;
      vm.formData.nominees.forEach(function(el){
        if(el.minor){
          if(!el.dob){
            vm.validateAllDOB = true;
          }
        }
      })
    }
    vm.changeGuardianName = function(){
      vm.validateDOBRequre();
    }

    function getResponseFolioInfo(cb) {
      cb = cb || function () {
      }
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.jointHolders = angular.copy(resp.data.jointHolders);
          cb(true);
        } else {
          cb(false);
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        cb(false);
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };


      InvestorsService.post({
        controller: 'new',
        child1: 'folio',
        child2: 'data',
        child3: 'investor'
      }, {id: InvestorModel.getInvestorId(), linkId: InvestorModel.getHolderLinkid()}).$promise.then(success, error);
    }


    // Nominee Regulatory
    function changeNomineeRelation(nomineeRelation, index) {
      if(nomineeRelation !== 'OTHERS') {
        vm.formData.nominees[index].nomineeOtherRelation = null;
      }
    }

    function getIdentityProofList(cb) {
      cb = cb || function () {

      }
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.applicantPersonalIdentifiers = resp.data.identityProofs;
            vm.identityProofList = vm.applicantPersonalIdentifiers;
            if(vm.formData.nominees && vm.formData.nominees.length > 0){
              vm.formData.nominees.forEach(function(nominee, index){
                if(nominee.identityProofType && nominee.identityProofType === 'AADHAR_CARD') {
                  nominee.aadharCard = nominee.identityProofNumber;
                }
                if(nominee.identityProofType && nominee.identityProofType === 'PAN_CARD') {
                  nominee.nomineePan = nominee.identityProofNumber;
                }
                if(nominee.identityProofType && nominee.identityProofType === 'DRIVING_LICENSE') {
                  nominee.drivingLicense = nominee.identityProofNumber;
                }
                if(nominee.identityProofType === 'PASSPORT') {
                  nominee.passport = nominee.identityProofNumber;
                }

                if (!nominee.identityProofObj) {
                  nominee.identityProofObj = vm.identityProofList.find(function (el) {
                    return el.identityProofType == nominee.identityProofType
                  })
                }

                nominee.identityProofCamsCode = nominee.identityProofObj ? angular.copy(nominee.identityProofObj.identityProofCamsCode) : null;
              });
            }
            cb(true);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorCommonServiceVersion2.get({child1: 'identity-proofs'}, {}).$promise.then(success, error);
    }

    function changeNomineeIdentityProof(index,identifier){
      vm.applicantPersonalIdentifiers.map(function (el) {
        if (el.value === identifier) {
          vm.formData.nominees[index].identityProofType = el.value;
        }
      });
      vm.formData.nominees[index].nomineePan = '';
      vm.formData.nominees[index].drivingLicense = '';
      vm.formData.nominees[index].aadharCard = '';
      vm.formData.nominees[index].passport = '';
      vm.formData.nominees[index].identityProofObj = null;
    }

    function changeEmailId(index, emailId) {
      /*if (!emailId) {
        return;
      }
      if (vm.formData.soleApplicantDetail.email && vm.formData.soleApplicantDetail.email.toLowerCase() === vm.formData.nominees[index].emailId.toLowerCase()) {
        vm.formData.nominees[index].emailIdInvalid = true;
        vm.emailIdValid = false;
        vm.errorMessageEmail = vm.validateData.NOMINEE_EMAIL_SAME_AS_INVESTOR;
      } else {
        vm.formData.nominees[index].emailIdInvalid = false;
        vm.emailIdValid = true;
        vm.errorMessageEmail = null;
      }*/
    }
    function changeMobileNumber(index, mobileNumber) {
      if (!mobileNumber) {
        return;
      }
      if (vm.formData.soleApplicantDetail.mobileNo && vm.formData.soleApplicantDetail.mobileNo === vm.formData.nominees[index].mobileNumber) {
        vm.formData.nominees[index].mobileInvalid = true;
        vm.mobileValid = false;
        vm.errorMessageMobile = vm.validateData.NOMINEE_MOBILE_SAME_AS_INVESTOR;
      } else {
        vm.formData.nominees[index].mobileInvalid = false;
        vm.mobileValid = true;
        vm.errorMessageMobile = null;
      }
    }

    function changeDrivingLicense(index, drivingLicense) {
      checkDuplicateNomineeDL(index,drivingLicense)
    }

    function changeAadharCard(index, aadharCard) {
      checkDuplicateNomineeAadhaar(index,aadharCard);
    }

    function checkNomineeIsMinor(index) {
      var nominee = vm.formData.nominees[index];
      nominee.identityProofList = [];
      if (nominee.minor) {
        for (var i = 0; i < vm.applicantPersonalIdentifiers.length; i++) {
          if (vm.applicantPersonalIdentifiers[i].identityProofType !== "DRIVING_LICENSE") {
            nominee.identityProofList.push(vm.applicantPersonalIdentifiers[i]);
          }
        }
      } else {
        nominee.identityProofList = vm.applicantPersonalIdentifiers.slice();
      }
    }

    function checkDuplicateNomineeDL(index, drivingLicense) {
      if (!drivingLicense) {
        return;
      }
      var nominees = vm.formData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].drivingLicense) {
          nominees[i].nomineeDLInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].drivingLicense && drivingLicense && (i !== index && nominees[i].drivingLicense === drivingLicense)) {
          nominees[index].nomineeDLInvalid = true;
          nominees[i].nomineeDLInvalid = false;
          vm.errorMessageDLIdentity = vm.validateData.DRIVING_LICENSE_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeDLInvalid = false;
      vm.formData.nominees[index].identityProofNumber = drivingLicense;
      if (!vm.formData.nominees[index].identityProofObj) {
        vm.formData.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.nominees[index].identityProofType
        })
      }

      vm.formData.nominees[index].identityProofCamsCode = vm.formData.nominees[index].identityProofObj ? angular.copy(vm.formData.nominees[index].identityProofObj.identityProofCamsCode) : null;
    }

    function checkDuplicateNomineeAadhaar(index, aadharCard) {

      if (!aadharCard) {
        return;
      }

      var nominees = vm.formData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty aadharCard
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].aadharCard) {
          nominees[i].nomineeAadharInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].aadharCard && aadharCard && (i !== index && nominees[i].aadharCard === aadharCard)) {
          // nominees[index].nomineeAadharInvalid = true;
          nominees[i].nomineeAadharInvalid = false;
          // vm.errorMessageDLIdentity = vm.validateData.AADHAAR_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeAadharInvalid = false;
      vm.formData.nominees[index].identityProofNumber = aadharCard;
      if (!vm.formData.nominees[index].identityProofObj) {
        vm.formData.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.nominees[index].identityProofType
        })
      }

      vm.formData.nominees[index].identityProofCamsCode = vm.formData.nominees[index].identityProofObj ? angular.copy(vm.formData.nominees[index].identityProofObj.identityProofCamsCode) : null;
    }

    function changeSelectedName(selectedName){
      if (!selectedName) {
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = null;
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = null;
      }
      if(selectedName) {
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = selectedName.index + 1;
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = selectedName.nomineeName;
      }
    }

    vm.hasNomineeName = function () {
      if (!vm.formData.nominees) {
        return false;
      }

      for (var i = 0; i < vm.formData.nominees.length; i++) {
        if (vm.formData.nominees[i].nomineeName) {
          return true;
        }
      }
      return false;
    };

    function changeNomineeName(index,nomineeName,cb){
      cb = cb || function () {
      }
      var updated = false;

      for (var i = 0; i < vm.formData.incapacitationNameList.length; i++) {
        if (vm.formData.incapacitationNameList[i].index === index) {
          if (!nomineeName) {
            vm.formData.incapacitationNameList.splice(i, 1);
          } else {
            vm.formData.incapacitationNameList[i].nomineeCode = nomineeName + '-' + vm.enum[index];
            vm.formData.incapacitationNameList[i].nomineeName = nomineeName;
            vm.formData.incapacitationNameList[i].activeFlag = vm.formData.nominees[index].minor
          }
          updated = true;
          break;
        }
      }
      if (!updated && nomineeName) {
        vm.formData.incapacitationNameList.push({
          "index": index,
          "nomineeCode": nomineeName + '-' + vm.enum[index],
          "nomineeName": nomineeName,
          "activeFlag": vm.formData.nominees[index].minor
        });
      }
      //Sorting and check next element will align after delete
      vm.formData.incapacitationNameList.sort(function (a, b) {
        return a.index - b.index;
      });
      for (var i = 0; i < vm.formData.incapacitationNameList.length; i++) {
        vm.formData.incapacitationNameList[i].index = i;
        vm.formData.incapacitationNameList[i].nomineeCode = vm.formData.incapacitationNameList[i].nomineeName + '-' + vm.enum[i];
      }
      cb(true);
    }

    function setStatement() {
      /*vm.formData.nomineeRegistrationCO.accountHoldingDeclaration = [];
      if (vm.formData.nomineeName) {
        vm.formData.nomineeRegistrationCO.accountHoldingDeclaration.push('NAME_OF_NOMINEES');
      }
      if (vm.formData.nomination) {
        vm.formData.nomineeRegistrationCO.accountHoldingDeclaration.push('NOMINATION_YES');
      }*/
    }

    function changePercentageOrAmount(from){
      if(from === 'percentage'){
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
      }

      if(from === 'amount'){
        vm.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
      }
    }

    function changePassport(index, passport) {

      if (!passport) {
        return;;
      }

      var nominees = vm.formData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineePassportInvalid for empty Passport
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].passport) {
          nominees[i].nomineePassportInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].passport && passport && (i !== index && nominees[i].passport === passport)) {
          nominees[index].nomineePassportInvalid = true;
          nominees[i].nomineePassportInvalid = false;
          vm.errorMessagePassportIdentity = vm.validateData.PASSPORT_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineePassportInvalid = false;
      vm.formData.nominees[index].identityProofNumber = passport;
      if (!vm.formData.nominees[index].identityProofObj) {
        vm.formData.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.nominees[index].identityProofType
        })
      }

      vm.formData.nominees[index].identityProofCamsCode = vm.formData.nominees[index].identityProofObj ? angular.copy(vm.formData.nominees[index].identityProofObj.identityProofCamsCode) : null;
    }
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CobmApprovalController', cobmApprovalController);

  /** @ngInject */
  function cobmApprovalController($state, $stateParams, $window, $scope, InvestorModel, ModalService, LoaderService, MessageService, UtilService, InvestorsCommonService, AppConstants, InvestorFileUploadService, AuthService) {
    var vm = this;
    vm.init = init;
    vm.copyPasteHandler = copyPasteHandler;
    vm.accFocus = accFocus;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.uploadChequeLeafFileOld = uploadChequeLeafFileOld;
    vm.breakFileUrl = breakFileUrl;
    vm.openUploadedDoc = openUploadedDoc;
    vm.openUploadedDocOld = openUploadedDocOld;
    vm.uploadChequeLeafFileDelete = uploadChequeLeafFileDelete;
    vm.back = back;
    vm.setHeader = setHeader;
    vm.changeBank = changeBank;
    vm.approveAddBank = approveAddBank;
    vm.approveDeleteBank = approveDeleteBank;
    vm.confirmCancelModaltoReject = confirmCancelModaltoReject;
    vm.confirmCancelModaltoRejectDeleteBank = confirmCancelModaltoRejectDeleteBank;

    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.bankList = null;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.formData = {makeDefaultBank: false};
    vm.formData.linkId = $stateParams.uuid;
    vm.formData = {};

    function changeBank() {
      vm.formData.bankName = $window.JSON.parse(vm.selectedBank).bankName;
      vm.formData.bankRGTSCode = $window.JSON.parse(vm.selectedBank).bankCode;

      if (vm.formData.bankRGTSCode === 'HDF') {
        vm.formData.payoutMechanism = 'DC';
      } else vm.formData.payoutMechanism = null;
    }

    function init() {
      getBankInfo();
      // setHeader();
    }

    function getBankInfo() {
      LoaderService.showLoader();
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.formData = resp.data;
          if (vm.formData.accountNumber) {
            vm.verifyAccountNumber = vm.formData.accountNumber;
          }
          // vm.formData.
          breakFileUrl(vm.formData.newBankProofURL, 'add');
          breakFileUrl(vm.formData.oldBankProofURL, 'modify');
        } else {
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestorsCommonService.post({
        child1: 'cobm',
        child2: 'summary'
      }, {requestId: InvestorModel.getInvestorId()}).$promise.then(success, error);
    }

    function setHeader() {
      var profile = AuthService.getToken();
      vm.MainFolioParent = {};
      // vm.MainFolioParent.panNumber = profile.investorPAN;
      vm.MainFolioParent.firstName = profile.investorFName;
      vm.MainFolioParent.lastName = profile.investorLName;
      vm.formData.pan = localStorage.getItem('pan');
      vm.MainFolioParent.uuid = localStorage.getItem('folioId');
      vm.folioNumberToDisplay = localStorage.getItem('folioId');
      vm.formData.folioNumber = localStorage.getItem('folioId');
      vm.MainFolioParent.currentState = 'main.profile.addBank';
      vm.bankDetails = $window.JSON.parse(localStorage.getItem('bankDetails'));
      vm.oldBankName = vm.bankDetails && vm.bankDetails[0].bankName ? vm.bankDetails[0].bankName : '';
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    function accFocus() {
      vm.accModelDirty = true;
    }

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 5000000) {
          vm.fileNew = file;
          vm.chequeLeaf = file.name;
          vm.chooseAFileNew = false;

          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.newBankProofURL = resp.data.fileUrl;
                breakFileUrl(resp.data.fileUrl, 'add');
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadService.post({
              child1: 'cobm',
              child2: 'upload',
              child3: 'newBankProof',
              child5: vm.formData.folioNumber
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 5 MB.")
          vm.chooseAFileNew = true;
        }
      }

    }

    function uploadChequeLeafFileOld(file, type) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 5000000) {
          vm.fileOld = file;
          vm.chequeLeafOld = file.name;
          vm.chooseAFileOld = false;
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                if (type === 'add') {
                  vm.formData.oldBankProofURL = resp.data.fileUrl;
                }
                else if (type === 'modify') {
                  vm.formData.oldBankProofURL = resp.data.fileUrl;
                }
                breakFileUrl(resp.data.fileUrl, 'modify');
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader(err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);

            InvestorFileUploadService.post({
              child1: 'cobm',
              child2: 'upload',
              child3: 'oldBankProof',
              child5: vm.formData.folioNumber
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 5 MB.");
          vm.chooseAFileOld = true;
        }
      }
    }

    function breakFileUrl(url, type) {
      if (url) {
        url = url.replace(/ /g, '');
        var a, extension;
        if (url.split('.jp').length > 1) {
          extension = '.jpg';
          a = url.split('.jp')[0].split('/');
        } else if (url.split('.png').length > 1) {
          extension = '.png';
          a = url.split('.png')[0].split('/');
        } else if (url.split('.pdf').length > 1) {
          extension = '.pdf';
          a = url.split('.pdf')[0].split('/');
        } else if (url.split('.bmp').length > 1) {
          extension = '.bmp';
          a = url.split('.bmp')[0].split('/');
        }

        if (type === 'add') {
          vm.chequeLeaf = a[a.length - 1] + extension;
          vm.chooseAFileNew = false;
        }
        else if (type === 'modify') {
          vm.chequeLeafOld = a[a.length - 1] + extension;
          vm.chooseAFileOld = false;
        }
      }
    }

    function openUploadedDoc() {
      $window.open(vm.formData.newBankProofURL);
    }

    function openUploadedDocOld() {
      $window.open(vm.formData.oldBankProofURL);
    }

    function back() {
      history.back();
    }

    function confirmCancelModaltoReject() {
      var success = function () {
        var successReason = function (respModal) {
          var successFolioReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              $state.go('approval.cobm.rejected');
            } else {
              MessageService.error(resp.message);
            }
          }, errorFolioReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: InvestorModel.getInvestorId(),
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId: $stateParams.uuid
          };
          LoaderService.showLoader();
          InvestorsCommonService.post({
            child1: 'cobm',
            child2: 'reject'
          }, payload).$promise.then(successFolioReject, errorFolioReject);


        }, dismissReason = function (err) {
          UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'bankRejection'}, successReason, dismissReason);

      }, dismiss = function (err) {
        UtilService.errorHandler(err);

      };
      var msg = "Are you sure, you want to reject<br/>'Adding Bank?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function confirmCancelModaltoRejectDeleteBank() {
      var success = function () {
        var successReason = function (respModal) {
          var successDeleteReject = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              $state.go('approval.cobm.rejected');
            } else {
              MessageService.error(resp.message);
            }
          }, errorDeleteReject = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          var payload = {
            id: InvestorModel.getInvestorId(),
            reason: respModal.reason ? respModal.reason : 'Rejected',
            linkId: $stateParams.uuid
          };
          LoaderService.showLoader();
          InvestorsCommonService.post({
            child1: 'cobm',
            child2: 'reject'
          }, payload).$promise.then(successDeleteReject, errorDeleteReject);


        }, dismissReason = function (err) {
          UtilService.errorHandler(err);

        };
        ModalService.rejectionReasonModal({type: 'bankRejection'}, successReason, dismissReason);

      }, dismiss = function (err) {
        UtilService.errorHandler(err);

      };
      var msg = "Are you sure, you want to reject<br/>'Deleting this Bank?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function approveAddBank() {
      var success = function () {
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $state.go('approval.cobm.approved');
          } else {
            MessageService.error(resp.message);
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        InvestorsCommonService.post({
          child1: 'cobm',
          child2: 'add',
          child3: 'approve'
        }, vm.formData).$promise.then(successFolioApprove, errorFolioApprove);


      }, dismiss = function () {

      };
      var msg = "Are you sure, you want to approve<br/> 'Adding New Bank?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function approveDeleteBank() {
      var success = function () {
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $state.go('approval.cobm.approved');
          } else {
            MessageService.error(resp.message);
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        var fd = new FormData();
        fd.append('bankCO', $window.JSON.stringify(vm.formData));
        fd.append('bankProof', vm.fileNew);
        InvestorFileUploadService.post({
          child1: 'cobm',
          child2: 'delete',
          child3: 'approve'
        }, fd).$promise.then(successFolioApprove, errorFolioApprove);
      }, dismiss = function () {

      };
      var msg = "Are you sure, you want to approve<br/> 'Deleting this Bank?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }


    function uploadChequeLeafFileDelete(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 5000000) {
          vm.fileNew = file;
          $scope.$apply(function () {
            vm.chequeLeaf = file.name;
            vm.chooseAFile = false;
          })
        }
        else {
          MessageService.error("File size should not be more than 5 MB.")
          vm.chooseAFile = true;
        }
      }
    }
  }
})();


/**
 * Created by ttn on 16/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('StatementsController', statementsController);

  /** @ngInject */
  function statementsController(LoaderService, DownloadReportsService, $timeout, $window, HDFC_API, $stateParams, $state, AppConstants, InvestorsService, InvestorsCommonService, MessageService, ModalService, UtilService, AuthService, FileSaver, Blob,
                                investorProfile , InvestorCommonServiceVersion2, DownloadReportsServiceV2) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    // vm.viewStatement = viewStatement;
    vm.generateStatement = generateStatement;
    vm.downloadStatement = downloadStatement;
    vm.selectedTab = 'classic';
    vm.changeSelectedTab = changeSelectedTab;
    vm.fetchFolioList = fetchFolioList;
    vm.fetchOutSchemes = fetchOutSchemes;
    vm.folioChanged = folioChanged;
    vm.updateEndDate = updateEndDate;
    vm.changeStartDate = changeStartDate;
    vm.changeEndDate = changeEndDate;
    vm.goToProfile = goToProfile;
    vm.statementOptionChanged = statementOptionChanged;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.viewMode = 'days';
    vm.enabledStartDates = null;
    vm.enabledEndDates = null;
    vm.isShowDefault = 'false';
    vm.folioList = null;
    vm.investorProfile = investorProfile;
    vm.STATEMENT_OPTIONS = {
      'CURRENT': 'CFY',
      'PREVIOUS': 'PFY',
      'FULL': 'FS',
      'PERIOD': 'P'
    };
    vm.CAPITAL_GAIN_STATEMENT_OPTION = {
      'CURRENT': 'CY',
      'PREVIOUS': 'PY',
      'FULL': 'SI',
      'PERIOD': 'SD'
    };
    vm.formData = {
      minEndDate: null,
      startDate: null,
      endDate: null
    };

    vm.startMaxDate = $window.moment();
    vm.endMaxDate = $window.moment();
    vm.changeCaptailGainStartDate = changeCaptailGainStartDate;

    vm.init = function () {
      fetchFolioList();
      vm.formData.statementOption = vm.STATEMENT_OPTIONS.FULL;

    };

    function updateEndDate(date) {
      // var day = null;
      var enabledEndDates = [];

      var currentDay = $window.moment();
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var diff = Math.abs(startDay.diff(currentDay, 'days'));

      //  var diff = startDay.diff(currentDay, 'days');
      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        enabledEndDates.push(_date.clone());
      }
      /*while(diff!=0){
       startDay = startDay.clone().add(1,'days');
       enabledEndDates.push(startDay);
       diff--;
       }*/
      vm.enabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.enabledEndDates[0];
      vm.formData.endDate = '';
      // startDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      //     enabledEndDates.push(startDay);
      //     vm.enabledEndDates = angular.copy(enabledEndDates);

    }

    function fetchFolioList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioListData = resp.data.folioList || [];
            var folioList = [];
            Object.keys(folioListData).forEach(function (key) {
              var obj = Object.assign({key: key}, folioListData[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "investorUUID": $stateParams.investorId
      };
      InvestorsService.post({controller: 'folioList'}, payload).$promise.then(success, error);
    }

    function folioChanged(folioNo) {
      if (folioNo && (vm.selectedTab == 'classic' || vm.selectedTab == 'exitLoad') || vm.selectedTab == 'balance') {
        fetchOutSchemes(folioNo);
      }
    }

    function fetchOutSchemes(folioNo) {
      vm.schemeList = null;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.schemeList = resp.data.schemes;
            if (vm.selectedTab == 'classic') {
              vm.schemeList.unshift({schemeCode: 'ALL', schemeName: 'All Schemes'});
              vm.formData.scheme = vm.schemeList[0].schemeCode;
            }
          } else {
            vm.schemeList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.schemeList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();

      var _config = {child1: 'folio', child2: 'schemes'};

      InvestorsService.post(_config, {folioNumber: folioNo}).$promise.then(success, error);
    }

    function changeSelectedTab(selectedTab) {

      vm.selectedTab = selectedTab;
      vm.resetFormData();
    }

    vm.resetFormData = function () {
      fetchFolioList();
      switch (vm.selectedTab) {
        case 'classic':
          vm.formData = {
            folioNumber: null,
            scheme: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.STATEMENT_OPTIONS.FULL
          };
          break;
        case 'capital':
          vm.formData = {
            folioNumber: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.CAPITAL_GAIN_STATEMENT_OPTION.CURRENT
          };
          vm.endMaxDate = $window.moment();
          break;
        case 'balance':
          vm.formData = {
            folioNumber: null,
            scheme: null
          };
          break;
        case 'dividend':
          vm.formData = {
            folioNumber: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.STATEMENT_OPTIONS.FULL
          };
          break;
        case 'exitLoad':
          vm.formData = {
            folioNumber: null,
            scheme: null
          };
          break;
      }
      var tmp = vm.selectedTab;
      vm.selectedTab = null;
      $timeout(function () {
        vm.selectedTab = tmp;
      });
    };
    vm.downloadResetFormData = function () {
      switch (vm.selectedTab) {
        case 'classic':
          vm.formData = {
            folioNumber: null,
            scheme: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.STATEMENT_OPTIONS.FULL
          };
          break;
        case 'capital':
          vm.formData = {
            folioNumber: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.CAPITAL_GAIN_STATEMENT_OPTION.CURRENT
          };
          vm.endMaxDate = $window.moment();
          break;
        case 'balance':
          vm.formData = {
            folioNumber: null,
            scheme: null
          };
          break;
        case 'dividend':
          vm.formData = {
            folioNumber: null,
            minEndDate: null,
            startDate: null,
            endDate: null,
            statementOption: vm.STATEMENT_OPTIONS.FULL
          };
          break;
        case 'exitLoad':
          vm.formData = {
            folioNumber: null,
            scheme: null
          };
          break;
      }
      var tmp = vm.selectedTab;
      vm.selectedTab = null;
      $timeout(function () {
        vm.selectedTab = tmp;
      });
    };

    /* function viewStatement() {
     var success= function () {

     },
     error = function () {

     };

     ModalService.statementPdfModal({},success,error);
     }*/

    function generateStatement(type) {
      var reportName = null;
      switch (type) {
        case 'classic':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
           payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'capitalGain';
          break;
        case 'balance':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "scheme": vm.formData.scheme.schemeCode,
            "schemeName": vm.formData.scheme.schemeName,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'balanceConfirmation';
          break;
        case 'dividend':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = 'dividend';
          break;
        case 'exitLoad':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "schemeCode": vm.formData.schemeCode,
            "commonReportCO": {
              "docDestination": "email"
            }
          };
          reportName = "exitLoad";
          break;
      }
      payload.panNumber = vm.investorProfile.PAN;

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp && resp.status) {
            // MessageService.success(resp.message);
            var success = function () {
                vm.resetFormData();
              },
              error = function () {
              };
            ModalService.successMessageModal({message: resp.message}, success, error);
          } else {
            vm.folioList = null;
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
            vm.resetFormData();
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
          vm.resetFormData();
        };
      LoaderService.showLoader();
      if (type !== 'capital') {
        InvestorsCommonService.post({
          child1: 'statement',
          child2: reportName
        }, payload).$promise.then(success, error);
      } else if (type === 'capital') {
        InvestorCommonServiceVersion2.post({
          child1: 'statement',
          child2: reportName
        }, payload).$promise.then(success, error);
      }
    }

    function downloadStatement(type) {
      var reportName = null;
      switch (type) {
        case 'classic':
          var payload = {
            "folioNumber": vm.formData.folioNumber, //'10006184'
            "schemeCode": vm.formData.scheme,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'accountStatement';
          break;
        case 'capital':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'capitalGain';
          break;
        case 'balance':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "scheme": vm.formData.scheme.schemeCode,
            "schemeName": vm.formData.scheme.schemeName,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'balanceConfirmation';
          break;
        case 'dividend':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "fromDate": vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '',
            "toDate": vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '',
            "year": vm.formData.statementOption,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = 'dividend';
          break;
        case 'exitLoad':
          payload = {
            "folioNumber": vm.formData.folioNumber,
            "schemeCode": vm.formData.schemeCode,
            "commonReportCO": {
              "docDestination": "download"
            }
          };
          reportName = "exitLoad";
          break;
      }

      payload.panNumber = vm.investorProfile.PAN;

      var success = function (resp) {

          var status = false;
          try {
            //var decodedString = String.fromCharCode.apply(null, new Uint8Array(resp.data));
            var decodedString = new TextDecoder("utf-8").decode(new Uint8Array(resp.data||resp));
            if (decodedString.indexOf('PDF') == -1) {
              var obj = $window.JSON.parse(decodedString);
              var message = obj['message'];
              status = false;
            }
            else {
              status = true;
            }
          }
          catch (error) {
            status = false;
          }

          if (resp.data && status) {
            /*var file = null;
            file = new Blob([resp.data], {type: 'application/pdf'});

            var fileURL = URL.createObjectURL(file);
            var link = document.createElement("a");
            link.target = '_blank';
            link.download = reportName;
            link.href = fileURL;

            document.body.appendChild(link);
            link.style = "display: none";
            link.click();
            ($window.URL || $window.webkitURL).revokeObjectURL(link.href);
            document.body.removeChild(link);
            file = '';
            fileURL = '';*/

            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, reportName+'.pdf');
            LoaderService.hideLoader();
            //vm.formData = {};
            vm.downloadResetFormData();
            // vm.formData.statementOption = vm.selectedTab === 'classic'?vm.STATEMENT_OPTIONS.FULL:vm.STATEMENT_OPTIONS.CURRENT;
          } else {
            LoaderService.hideLoader();
            if(obj.popupEnabled) {
              ModalService.genericModal({
                text: message
              })
            } else {
              MessageService.error(resp.message || message || 'No Data Available');
            }
            //vm.formData = {};
            vm.downloadResetFormData();
            // vm.formData.statementOption = vm.selectedTab === 'classic'?vm.STATEMENT_OPTIONS.FULL:vm.STATEMENT_OPTIONS.CURRENT;
          }
        },
        error = function (err) {
          vm.downloadResetFormData();
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      // DownloadPdfService.downloadFile(payload, reportName).then(success, error);
      var url= HDFC_API.VERSION +'/statement/'+reportName;
      if (type !== 'capital') {
        DownloadReportsService.downloadFile(url,payload).then(success, error);
      } else if (type === 'capital') {
        DownloadReportsServiceV2.downloadFile(url,payload).then(success, error);
      }
    }

    /*vm.statementOptionChanged = function () {

     };*/
    function changeStartDate(date) {

      if (date) {
        vm.formData.startDate = date;
        updateEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    function changeEndDate(date) {

      if (date) {
        vm.formData.endDate = date;
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.endDate = null;
      }
    }

    function statementOptionChanged() {
      if (vm.formData.statementOption != 'PE') {
        vm.formData.startDate = null;
        vm.formData.endDate = null;
      }
    }

    function goToProfile() {
      var investorId = $stateParams.investorId;
      var identifier = AuthService.getToken();
      if(identifier && identifier.loginType=='A'){
        $state.go('agent.home.distributor-home');
      } else{
        $state.go('main.investors.profile.portfolio',{investorId:investorId});
      }
    }

    /*
    * Capital Gain start date changes handler
    * */
    function changeCaptailGainStartDate(date) {
      if (date) {
        vm.formData.startDate = date;
        updateCaptialGainEndDate(date);
      } else {
        vm.errorMessage = 'Enter valid Date';
        vm.formData.startDate = null;
      }
    }

    /*
    * Function responsible to identify enabled dates.
    * */
    function updateCaptialGainEndDate(date) {
      var enabledEndDates = [];

      var endDate = $window.moment(date).add(365, 'days');
      endDate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var startDay = angular.copy($window.moment(date)).set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});

      var diff = Math.abs(startDay.diff(endDate, 'days'));
      for (var i = 1; i <= diff; i++) {
        var _date = startDay.clone().add(i, 'days');
        if ($window.moment(_date).isSameOrBefore($window.moment())) {
          enabledEndDates.push(_date.clone());
        }
      }
      if ($window.moment(endDate).isSameOrBefore($window.moment())) {
        vm.endMaxDate = $window.moment(endDate).add(1, 'minutes');
      } else {
        vm.endMaxDate = $window.moment().add(1, 'minutes');
      }
      vm.capitalGainEnabledEndDates = angular.copy(enabledEndDates);
      vm.formData.minEndDate = vm.capitalGainEnabledEndDates[0];
      vm.formData.endDate = '';
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OptOutNomineeController', optOutNomineeController);

  /** @ngInject */
  function optOutNomineeController($log, $scope, $rootScope, $state, AuthService, UtilService, $timeout, AppConstants, $stateParams, LoaderService, MessageService, ModalService, InvestorServiceDynamicData, dynamicData) {

    var vm = this;
    vm.TnC = false;
    vm.appConstants = AppConstants;
    vm.goToBack = goToBack;
    vm.init = init;
    vm.investorId = $stateParams.investorId;
    vm.folioNo = $stateParams.folioNo;
    vm.optOutNomination = optOutNomination;
    vm.tokenData = AuthService.getToken();
    vm.dynamicData = dynamicData;
    vm.dynamicDataForOptOutDec = vm.dynamicData && vm.dynamicData.noteDTO ? vm.dynamicData.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT.content : "";

    function init() {}

    function goToBack() {
      $state.go('main.investors.profile.basicinfo', {investorId : vm.investorId});
    }

    function optOutNomination() {
      LoaderService.showLoader();
      var success = function(resp){
        LoaderService.hideLoader();
        if(resp.data && resp.status){
          var successHandler = function(){
            $state.go('main.investors.profile.basicinfo', {investorId : vm.investorId});
          }
          ,errorHandler = function(){}
          ModalService.genericModal({text : resp.data.message}, successHandler, errorHandler);
        }else{
          MessageService.error(resp.message);
        }
      },
      error = function(err){
        LoaderService.hideLoader();
        MessageService.error(err.message);
      };
      var payload = {
        folioNo : vm.folioNo,
        arnCode : vm.tokenData.arnCode
      }
      InvestorServiceDynamicData.post({
        child1 : 'nominee',
        child2 : 'opt-out',
        child3 : 'initiate'
      },payload).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsAddSchemeController', investorsAddSchemeController);
  function investorsAddSchemeController($rootScope, $state, $stateParams, $scope, $timeout, ModalService, TransactionService, LoaderService, InvestorsService, InvestorModel, AppConstants, MessageService, SchemeService, TransactionInitiateModel, UtilService, moment) {
    var vm = this;
    vm.CONST = AppConstants;
    vm.submitScheme = submitScheme;
    vm.setOptionalScheme = setOptionalScheme;
    vm.getSchemesListOptionalSIP = getSchemesListOptionalSIP;
    vm.modelEmptyCheck = modelEmptyCheck;
    vm.filterPurchaseSchemeList = filterPurchaseSchemeList;
    vm.selectPurchaseScheme = selectPurchaseScheme;
    vm.init = init;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.SIP_FREQ_LIST = AppConstants.SIP_FREQ_LIST;
    vm.schemeOptional = '';
    vm.sipForm = {};
    vm.bankTypeList = vm.CONST.INVESTOR_ACC_TYPE;
    vm.formData = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
    vm.formData.sip = vm.formData.sip || InvestorModel.getSip();
    vm.formData.lumpsum = vm.formData.lumpsum || TransactionInitiateModel.getPurchaseDataModel();
    $rootScope.$state = $state;
    vm.sipSchemeList = null;
    vm.masterSipSchemeList = null;
    vm.sipScheme = null;
    vm.daysList = AppConstants.DAYS_LIST;
    vm.isSipOptional = false;
    vm.isPurchaseOptional = false;
    vm.isMinSipAmount = false;
    vm.sipDay = null;
    vm.startDate = null;
    vm.enabledStartDates = [];
    vm.endDate = null;
    vm.enabledEndDates = [];
    vm.selectedFrequency = vm.SIP_FREQ_LIST[0];
    vm.purchaseScheme = '';
    vm.purchaseSchemeList = null;
    vm.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
    vm.investmentType = TransactionInitiateModel.getInvestmentType() || vm.TRANSACTION_FORM_TYPE.PURCHASE;
    vm.investmentType = vm.TRANSACTION_FORM_TYPE.PURCHASE;
    vm.isMinPurchaseAmount = false;
    vm.purchaseValidations = null;
    vm.sipValidations = {};
    vm.changeDay = changeDay;
    vm.viewMode = 'months';
    vm.isTillPerpetuity = false;
    vm.isResetting = false;
    vm.ENDING_TYPES = AppConstants.SCHEME_ENDING_TYPES;
    vm.sipValidationsData = null;
    vm.getEuinCodes = getEuinCodes;

    function init() {
      vm.pageFlag = 'addscheme';
      vm.investmentType = vm.formData.lumpsum.isOptional ? (vm.TRANSACTION_FORM_TYPE.SIP) : (vm.TRANSACTION_FORM_TYPE.PURCHASE);
      getEuinCodes();
      fetchPurchaseEnabledSchemes();
      fetchSipEnabledSchemes();
      vm.modelEmptyCheck();
      changeDay();
      angular.element('#schemeId').addClass('active');
      setDefault();
    }

    function getEuinCodes() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        vm.euinList = null;
      };
      TransactionService.get({controller: 'getEuin'}).$promise.then(success, error);
    }

    function setDefault() {
      var defaultModel = InvestorModel.getInvestorModel();
      if (defaultModel && defaultModel.lumpsum && defaultModel.lumpsum.dividendOption) {
        vm.formData.lumpsum.dividendOption = defaultModel.lumpsum.dividendOption;
      }
    }

    function submitScheme() {
      if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
        if (vm.isSipOptional && vm.formData.sip) {
          vm.formData.sip.folioNumber = vm.formData.lumpsum.folioNumber;
          vm.formData.sip.investmentOption = vm.sipValidations.isGrowth ? "GROWTH" : "DIVIDEND";
          vm.formData.sip.dividendOption = vm.sipValidations.isGrowth ? "Z" : vm.formData.sip.dividendOption;
          vm.formData.sip.toDate = vm.endDate.format('DD-MMM-YYYY');
          vm.formData.sip.sipDate = vm.startDate.format('DD-MMM-YYYY');
          if(vm.euinObj){
            vm.formData.sip.euinOpted = vm.euinObj.euinCode? 'Y':'N';
            vm.formData.sip.euinCode = vm.euinObj.euinCode;
            vm.formData.sip.euinName = vm.euinObj.euinName;
          }
        }
        if(vm.euinObj){
          vm.formData.lumpsum.euinOpted = vm.euinObj.euinCode? 'Y':'N';
          vm.formData.lumpsum.euinCode = vm.euinObj.euinCode;
          vm.formData.lumpsum.euinName = vm.euinObj.euinName;
        }
      }

      if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
        if (vm.isPurchaseOptional && vm.formData.lumpsum) {
          vm.formData.lumpsum.folioNumber = vm.formData.sip.folioNumber;
          if(vm.euinObj){
            vm.formData.lumpsum.euinOpted = vm.euinObj.euinCode? 'Y':'N';
            vm.formData.lumpsum.euinCode = vm.euinObj.euinCode;
            vm.formData.lumpsum.euinName = vm.euinObj.euinName;
          }
        }
        vm.formData.sip.investmentOption = vm.sipValidations.isGrowth ? "GROWTH" : "DIVIDEND";
        vm.formData.sip.dividendOption = vm.sipValidations.isGrowth ? "Z" : vm.formData.sip.dividendOption;
        vm.formData.sip.toDate = vm.endDate.format('DD-MMM-YYYY');
        vm.formData.sip.sipDate = vm.startDate.format('DD-MMM-YYYY');
        if(vm.euinObj){
          vm.formData.sip.euinOpted = vm.euinObj.euinCode? 'Y':'N';
          vm.formData.sip.euinCode = vm.euinObj.euinCode;
          vm.formData.sip.euinName = vm.euinObj.euinName;
        }
      }
      InvestorModel.setInvestorModel(vm.formData);
      sanitizingFormData(vm.formData);

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var successPayDetails = function () {
                $state.go('main.dashboard');
              },
              errorPayDetails = function () {
                $state.go('main.dashboard');
              };
            ModalService.succInvestorModal(resp.data, successPayDetails, errorPayDetails);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'add'}, vm.formData).$promise.then(success, error);
    }

    function getSchemesListOptionalSIP() {
      var successSchemeList = function (result) {
          vm.selectedOptionalScheme = result.scheme;
        },
        errorSchemeList = function () {
          vm.isInScheme = false;
          vm.formData.scheme.schemeCode = '';
          vm.selectedInScheme = '';
        };
      ModalService.schemeListModal({
        enabledScheme: "sipenabled",
        isMinor: vm.formData.folioCreationRequestCO.soleApplicantDetail.minor
      }, successSchemeList, errorSchemeList);
    }

    function setOptionalScheme(schemeType) {
      switch (schemeType) {
        case vm.TRANSACTION_FORM_TYPE.PURCHASE:
          vm.isSipOptional = false;
          vm.isPurchaseOptional = true;
          vm.formData.lumpsum = TransactionInitiateModel.getPurchaseDataModel();
          break;
        case vm.TRANSACTION_FORM_TYPE.SIP:
          vm.isSipOptional = true;
          vm.isPurchaseOptional = false;
          vm.formData.sip = TransactionInitiateModel.getSipDataModel();
          break;
        default :
          vm.isSipOptional = false;
          vm.isPurchaseOptional = false;
          vm.formData.lumpsum = null;
          vm.formData.sip = null;
          break;
      }
    }

    function fetchPurchaseEnabledSchemes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterPurchaseSchemeList = resp.data.schemeList;
          if (vm.formData.lumpsum && vm.formData.lumpsum.schemeCode && vm.masterPurchaseSchemeList.length) {
            var result = vm.masterPurchaseSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.formData.lumpsum.schemeCode;
            });
            vm.purchaseScheme = result && result.scheme || null;
            fetchPurchaseSchemeValidations(vm.formData.lumpsum.schemeCode);
          }
          vm.purchaseSchemeList = UtilService.getFilteredList(vm.masterPurchaseSchemeList, 'scheme', vm.purchaseScheme);
        } else {
          vm.masterPurchaseSchemeList = null;
          vm.purchaseSchemeList = null;
          vm.purchaseScheme = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.masterPurchaseSchemeList = null;
        vm.purchaseSchemeList = null;
        vm.purchaseScheme = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'purchaseenabled',
        child2: vm.formData.folioCreationRequestCO.soleApplicantDetail.minor
      }, null).$promise.then(success, error);
    }

    function filterPurchaseSchemeList() {
      vm.formData.lumpsum.schemeCode = '';
      vm.purchaseSchemeList = UtilService.getFilteredList(vm.masterPurchaseSchemeList, 'scheme', vm.purchaseScheme);
    }

    function modelEmptyCheck() {
      if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.dob
        && !vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {
        $state.go('main.dashboard');
      }
    }

    function fetchSipEnabledSchemes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.masterSipSchemeList = resp.data.schemeList;
          if (vm.formData.sip && vm.formData.sip.schemeCode && vm.masterSipSchemeList.length) {
            var result = vm.masterSipSchemeList.find(function (scheme) {
              return scheme.schemeCode === vm.formData.sip.schemeCode;
            });
            vm.sipScheme = result && result.scheme || null;
            fetchSipSchemeValidations(vm.formData.sip.schemeCode);
          }
          vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
        } else {
          vm.sipSchemeList = null;
          vm.masterSipSchemeList = null;
          vm.sipScheme = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.sipSchemeList = null;
        vm.masterSipSchemeList = null;
        vm.sipScheme = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        type: 'ALL',
        child1: 'sipenabled',
        child2: vm.formData.folioCreationRequestCO.soleApplicantDetail.minor
      }, null).$promise.then(success, error);
    }

    function selectPurchaseScheme(data) {
      if (!data) {
        vm.purchaseScheme = '';
        vm.formData.lumpsum && (vm.formData.lumpsum.schemeCode = '');
        vm.purchaseSchemeList = UtilService.getFilteredList(vm.masterPurchaseSchemeList);
        resetPurchaseModel();
        $scope.$digest();
      } else {
        vm.purchaseScheme = data.scheme;
        vm.formData.lumpsum.schemeCode = data.schemeCode;
        vm.purchaseSchemeList = UtilService.getFilteredList(vm.masterPurchaseSchemeList, 'scheme', vm.purchaseScheme);
        fetchPurchaseSchemeValidations(data.schemeCode);
        resetPurchaseModel();
      }

    }

    function resetPurchaseModel() {
      vm.formData.lumpsum.amount = '';
    }

    vm.changeInvestmentType = function () {
      switch (vm.investmentType) {
        case vm.TRANSACTION_FORM_TYPE.PURCHASE:
          // vm.formData.sip = null;
          // vm.formData.lumpsum = TransactionInitiateModel.getPurchaseDataModel();
          vm.formData.lumpsum.folioNumber = vm.folioNumber;
          vm.formData.lumpsum.isOptional = false;
          vm.formData.sip.isOptional = true;
          break;
        case vm.TRANSACTION_FORM_TYPE.SIP:
          // vm.formData.lumpsum = null;
          vm.formData.sip = TransactionInitiateModel.getSipDataModel();
          vm.formData.sip.folioNumber = vm.folioNumber;
          vm.formData.sip.isOptional = false;
          vm.formData.lumpsum.isOptional = true;
          break;
      }
      vm.isSipOptional = false;
      vm.isPurchaseOptional = false;
      vm.isTillPerpetuity = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      TransactionInitiateModel.setInvestmentType(vm.investmentType);
    };

    function fetchPurchaseSchemeValidations(schemeCode) {
      vm.purchaseValidations = null;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.purchaseValidations = resp.data;
            vm.formData.lumpsum.dividendOption = vm.purchaseValidations.isGrowth ? vm.DIVIDEND_OPTIONS.GROWTH : (vm.formData.lumpsum.dividendOption !== vm.DIVIDEND_OPTIONS.GROWTH && vm.formData.lumpsum.dividendOption) || (vm.purchaseValidations.endingType === vm.ENDING_TYPES.CLOSED ? vm.DIVIDEND_OPTIONS.PAYOUT : vm.DIVIDEND_OPTIONS.REINVEST)
          } else {
            MessageService.error(resp.message);
            vm.purchaseValidations = null;
          }
        },
        error = function (err) {
          vm.purchaseValidations = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'purchase',
        child1: schemeCode,
        child2: 0
      }, null).$promise.then(success, error);
    }

    vm.openPurchaseSchemesModal = function () {

      var success = function (result) {
        vm.purchaseScheme = result.scheme;
        fetchPurchaseSchemeValidations(result.schemeCode);
        vm.formData.lumpsum.schemeCode = result.schemeCode;
      }, error = function () {
        vm.formData.lumpsum.schemeCode = '';
        vm.purchaseScheme = '';
      };

      var minor = !!vm.formData.folioCreationRequestCO.soleApplicantDetail.minor;
      ModalService.schemeListModal({
        enabledScheme: "purchaseenabled",
        isMinor: minor
      }, success, error);
    };

    vm.openSipSchemesModal = function () {

      var success = function (result) {
        vm.sipScheme = result.scheme;
        vm.formData.sip.schemeCode = result.schemeCode;
        fetchSipSchemeValidations(result.schemeCode);
      }, error = function () {
        vm.formData.sip.schemeCode = '';
        vm.sipScheme = '';
      };

      var minor = !!vm.formData.folioCreationRequestCO.soleApplicantDetail.minor;
      ModalService.schemeListModal({
        enabledScheme: "sipenabled",
        isMinor: minor
      }, success, error);
    };

    function updateDatesForDaily() {
      var currentDay = moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.startDate = angular.copy(enabledStartDates[0]);
      vm.enabledStartDates = angular.copy(enabledStartDates);
      var _dd = vm.startDate.format('DD');
      vm.sipDay = {name: _dd, value: _dd};
      updateEndDates();
    }

    function updateDatesForWeekly() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = moment(vm.startDate);
      } else {
        currentDay = moment().add(3, 'days');
      }
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd') === vm.sipDay.name) {
          enabledStartDates.push(_date.clone());
        }
      }
      !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      vm.enabledStartDates = angular.copy(enabledStartDates);
      updateEndDates();
    }

    function updateDatesForOthers() {
      var currentDay = '';
      if ($stateParams.transactionId) {
        currentDay = moment(vm.startDate);
      } else {
        currentDay = moment();
      }
      currentDay.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0
      });

      var updatedDate = currentDay.clone(), currentTimestamp = currentDay.format('x');
      updatedDate.set('date', vm.sipDay.value);
      var _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));

      while (_diff < 15) {
        updatedDate.add(1, 'months').set('date', vm.sipDay.value);
        _diff = UtilService.getDifferenceInDays(currentTimestamp, updatedDate.format('x'));
      }
      var enabledStartDates = [];
      for (var i = 0; i <= 3; i++) {
        var _date = updatedDate.clone().add(i, 'months');
        _diff = UtilService.getDifferenceInDays(currentTimestamp, _date.format('x'));
        if (_diff <= 90) {
          enabledStartDates.push(_date.clone());
        }
      }
      !$stateParams.transactionId && (vm.startDate = angular.copy(enabledStartDates[0]));
      vm.enabledStartDates = angular.copy(enabledStartDates);
      updateEndDates();
    }

    function updateEndDates() {
      if (vm.isTillPerpetuity || !vm.startDate) {
        return;
      }
      var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
      var i = 0;
      switch (vm.selectedFrequency.key) {
        case'DZ':
        case'OW':
          var days = 0;
          endDate = vm.startDate.clone().add(vm.selectedFrequency.dayfreq, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.dayfreq);
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.dayfreq * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
          var months = 0;
          endDate = vm.startDate.clone().add(vm.selectedFrequency.monthfreq, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          freq = freq || (defaultMonths / vm.selectedFrequency.monthfreq);
          for (i = 0; i < freq; i++) {
            months = vm.selectedFrequency.monthfreq * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      var minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 2) || 0;
      vm.enabledEndDates = enabledEndDates.slice(minInstallments);
      !$stateParams.transactionId && (vm.endDate = vm.enabledEndDates[0]);
    }

    function changeDay() {
      if (!vm.selectedFrequency || !vm.sipDay) {
        return;
      }
      vm.formData.sip.sipDay = vm.sipDay.value;
      switch (vm.selectedFrequency.key) {
        case 'OW':
          updateDatesForWeekly();
          break;
        case 'OM' :
        case 'Q':
        case 'H':
        case 'Y':
          updateDatesForOthers();
          break;
        default :
          vm.startDate = null;
          vm.enabledStartDates = null;
          vm.endDate = null;
          vm.enabledEndDates = null;
      }
    }

    vm.changeFrequency = function () {
      vm.formData.sip.amount = '';
      changeFrequency();
    };

    function changeFrequency() {
      vm.startDate = null;
      vm.enabledStartDates = null;
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.sipDay = null;
      vm.formData.sip.sipDay = null;
      vm.isTillPerpetuity = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);

      extractSipValidationObject(vm.sipValidationsData, vm.selectedFrequency);
      vm.formData.sip.frequency = vm.selectedFrequency.key;

      if (vm.selectedFrequency && vm.selectedFrequency.key === 'DZ') {
        vm.daysList = null;
        vm.viewMode = 'days';
        updateDatesForDaily()
      } else if (vm.selectedFrequency && vm.selectedFrequency.key === 'OW') {
        vm.daysList = AppConstants.WEEKS_LIST;
        vm.viewMode = 'days';
      } else {
        vm.daysList = AppConstants.DAYS_LIST;
        vm.viewMode = 'months';
      }
    }

    function extractSipValidationObject(validationsData, frequency) {
      if (!validationsData || !frequency) {
        return;
      }
      vm.sipValidations = {};
      switch (frequency.key) {
        case 'DZ':
          vm.sipValidations.amountMultiples = validationsData.dailyAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.dailyMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.dailyMinAmt;
          vm.sipValidations.minInstallments = validationsData.dailyMinInstallmentNumber;
          break;
        case 'OW':
          vm.sipValidations.amountMultiples = validationsData.weeklyAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.weeklyMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.weeklyMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.weeklyMinAmt;
          vm.sipValidations.minInstallments = validationsData.weeklyMinInstallmentNumber;
          break;
        case 'Q':
          vm.sipValidations.amountMultiples = validationsData.quarterlyAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.quarterlyMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.quarterlyMinAmt;
          vm.sipValidations.minInstallments = validationsData.quarterlyMinInstallmentNumber;
          break;
        case 'OM':
          vm.sipValidations.amountMultiples = validationsData.monAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.monMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.monMinAmt;
          vm.sipValidations.minInstallments = validationsData.monMinInstallmentNumber;
          break;
        case 'H':
          vm.sipValidations.amountMultiples = validationsData.halfYearlyAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.halfYearlyMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.halfYearlyMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.halfYearlyMinAmt;
          vm.sipValidations.minInstallments = validationsData.halfYearlyMinInstallmentNumber;
          break;
        case 'Y':
          vm.sipValidations.amountMultiples = validationsData.yearlyAmtMultiples;
          vm.sipValidations.maxAmount = validationsData.yearlyMaxAmt;
          vm.sipValidations.maxInstallments = validationsData.yearlyMaxInstallmentNumber;
          vm.sipValidations.minAmount = validationsData.yearlyMinAmt;
          vm.sipValidations.minInstallments = validationsData.yearlyMinInstallmentNumber;
          break;
      }
      vm.sipValidations.isGrowth = validationsData.isGrowth;
      vm.sipValidations.endingType = validationsData.endingType;
    }

    vm.filterSipSchemeList = function () {
      // if (_isSelectingFromDropDown) {
      //   return;
      // }
      vm.formData.sip && (vm.formData.sip.schemeCode = '');
      vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
    };

    vm.selectSipScheme = function (data) {
      if (!data) {
        vm.sipScheme = '';
        resetSchemeDuration();
        vm.formData.sip && (vm.formData.sip.schemeCode = '');
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList);
        $scope.$digest();
      } else {
        resetSchemeDuration();
        vm.sipScheme = data.scheme;
        vm.formData.sip.schemeCode = data.schemeCode;
        vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);
        fetchSipSchemeValidations(data.schemeCode);
      }
    };

    function resetSchemeDuration() {
      vm.formData.sip.sipDay = ''; // reset day dropdown vinod
      vm.sipDay = ''; // reset day dropdown vinod
      vm.formData.sip.installmentAmount = '';
      vm.startDate = null;
      vm.endDate = null;
      vm.isTillPerpetuity = false;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
      }, 0);
      angular.forEach(angular.element('.schemeDurationDate'), function (ele) {
        ele.value = ''
      });
      vm.enabledStartDates = null;
      vm.enabledEndDates = null;
    }

    function fetchSipSchemeValidations(schemeCode) {
      vm.sipValidationsData = null;
      vm.formData.sip.frequency = vm.selectedFrequency.key;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.sipValidationsData = resp.data;
            vm.formData.sip.dividendOption = vm.sipValidationsData.isGrowth ? vm.DIVIDEND_OPTIONS.GROWTH : (vm.formData.sip.dividendOption !== vm.DIVIDEND_OPTIONS.GROWTH && vm.formData.sip.dividendOption) || (vm.sipValidationsData.endingType === vm.ENDING_TYPES.CLOSED ? vm.DIVIDEND_OPTIONS.PAYOUT : vm.DIVIDEND_OPTIONS.REINVEST);
            vm.formData.sip.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.sip.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.sip.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
            extractSipValidationObject(vm.sipValidationsData, vm.selectedFrequency);
          } else {
            MessageService.error(resp.message);
            vm.sipValidationsData = null;
          }
        },
        error = function (err) {
          vm.sipValidationsData = null;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'sip',
        child1: schemeCode
      }, null).$promise.then(success, error);
    }

    vm.changeStartDate = function (date) {
      vm.startDate = moment(date);
      vm.startDate && vm.startDate.set({'year': date.year(), 'month': date.month()});
      updateEndDates();
    };

    vm.changeEndDate = function (date) {
      vm.endDate && vm.endDate.set({'year': date.year(), 'month': date.month()});
    };

    vm.changePurchaseAmount = function () {
      vm.isMinPurchaseAmount = vm.purchaseValidations && vm.purchaseValidations.minFirstPurchaseAmt > vm.formData.lumpsum.amount;
    };

    vm.changeSipAmount = function () {
      vm.isMinSipAmount = vm.sipValidations && vm.sipValidations.minAmount > vm.formData.sip.installmentAmount;
    };

    vm.goBack = function () {
      if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
        if (vm.isSipOptional && vm.formData.sip) {
          vm.formData.sip.folioNumber = vm.formData.lumpsum.folioNumber;
          vm.formData.sip.investmentOption = vm.sipValidations.isGrowth ? "GROWTH" : "DIVIDEND";
          vm.formData.sip.dividendOption = vm.sipValidations.isGrowth ? "Z" : vm.formData.sip.dividendOption;
          vm.formData.sip.toDate = vm.endDate && vm.endDate.format('DD-MMM-YYYY');
          vm.formData.sip.sipDate = vm.startDate && vm.startDate.format('DD-MMM-YYYY');
        }
      }

      if (vm.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
        if (vm.isPurchaseOptional && vm.formData.lumpsum) {
          vm.formData.lumpsum.folioNumber = vm.formData.sip.folioNumber;
        }
        vm.formData.sip.investmentOption = vm.sipValidations.isGrowth ? "GROWTH" : "DIVIDEND";
        vm.formData.sip.dividendOption = vm.sipValidations.isGrowth ? "Z" : vm.formData.sip.dividendOption;
        vm.formData.sip.toDate = vm.endDate ? vm.endDate.format('DD-MMM-YYYY') : "";
        vm.formData.sip.sipDate = vm.startDate ? vm.startDate.format('DD-MMM-YYYY') : "";
      }
      InvestorModel.setInvestorModel(vm.formData);
      $state.go('main.investors.add.bankdetails');
    };

    vm.cancelTransaction = function () {
      InvestorModel.setInvestorModel(null);
      InvestorModel.resetTab();
      TransactionInitiateModel.setInvestmentType(null);
      $state.go('main.dashboard');
    };

    vm.changeTillPerpetuityFlag = function () {
      vm.endDate = null;
      vm.enabledEndDates = null;
      vm.isResetting = true;
      $timeout(function () {
        vm.isResetting = false;
        if (vm.isTillPerpetuity) {
          vm.endDate = moment("12/31/2036");
          vm.enabledEndDates = [moment("12/31/2036")];
        } else {
          vm.startDate && updateEndDates();
        }
      }, 0);
    };

    vm.removeOptionalScheme = function (schemeType) {
      switch (schemeType) {
        case vm.TRANSACTION_FORM_TYPE.PURCHASE:
          vm.isPurchaseOptional = false;
          TransactionInitiateModel.setPurchasePayload(null);
          vm.formData.lumpsum = TransactionInitiateModel.getPurchaseDataModel();
          break;
        case vm.TRANSACTION_FORM_TYPE.SIP:
          vm.isSipOptional = false;
          vm.isTillPerpetuity = false;
          vm.formData.sip = TransactionInitiateModel.getSipDataModel();
          break;
        default :
          vm.isSipOptional = false;
          vm.isPurchaseOptional = false;
          vm.formData.sip = TransactionInitiateModel.getSipDataModel();
          vm.formData.lumpsum = TransactionInitiateModel.getPurchaseDataModel();
          break;
      }
    };

    function sanitizingFormData(model) {
      if (model.folioCreationRequestCO && model.folioCreationRequestCO.nominees.length > 0) {
        model.folioCreationRequestCO.nominees = model.folioCreationRequestCO.nominees.filter(function (ele) {
          return !!ele.nomineeName;
        });
      }
      if (model.folioCreationRequestCO && model.folioCreationRequestCO.guardianDetails) {
        if (!model.folioCreationRequestCO.guardianDetails.basicDetails.dob || !model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber) {
          delete model.folioCreationRequestCO.guardianDetails;
        }

      }
      if (model.sip && !model.sip.schemeCode && !model.sip.installmentAmount && !model.sip.toDate && !model.sip.sipDate) {
        delete model.sip;
      }
      if (model.lumpsum && !model.lumpsum.schemeCode && !model.lumpsum.amount) {
        delete model.lumpsum;
      }
      if (model.lumpsum && vm.purchaseValidations && vm.purchaseValidations.isGrowth) {
        model.lumpsum.dividendOption = "Z";
      }

    }

  }
})();

/**
 * Created by rajnishkumar on 27/06/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsAddReviewController', investorsAddReviewController);

  /** @ngInject */
  function investorsAddReviewController($state, AuthService, ModalService, MessageService, InvestorModel, InvestorsService, UtilService, $window,LoaderService, AppConstants, $rootScope) {

    var vm = this;
    var CONST = AppConstants;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.minorAgeProofFilename = "No file chosen";
    vm.chequeLeafFilename="No file chosen";
    vm.relationshipProofFilename="No file chosen";


    vm.init = init;
    vm.editSoleApplicantForm=editSoleApplicantForm;
    vm.editBankDetailsForm=editBankDetailsForm;
    vm.editNomineeApplicantForm=editNomineeApplicantForm;
    vm.sendForApproval=sendForApproval;
    vm.editJointHolderForm=editJointHolderForm;

    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    function init() {
      vm.formData = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
      console.log('review data ------> ', vm.formData)

      var myFile;
      if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor){
        //todo: need to check whether it is relavent or not
        vm.formData.folioCreationRequestCO.soleApplicantDetail.dob = $window.moment(vm.formData.folioCreationRequestCO.soleApplicantDetail.dob).format('DD-MMM-YYYY');

        var fileUrl=vm.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof;
        if(fileUrl){
          myFile=fileUrl.split('/');
          vm.minorAgeProofFilename=myFile[myFile.length-1];
        }

        var fileUrl2=vm.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl;
        if(fileUrl2){
          myFile=fileUrl2.split('/');
          vm.relationshipProofFilename=myFile[myFile.length-1];
        }

      }

      var fileUrl1=vm.formData.folioCreationRequestCO.chequeLeafUrl;
      if(fileUrl1){
        myFile=fileUrl1.split('/');
        vm.chequeLeafFilename=myFile[myFile.length-1];
      }

      vm.reviewModalData=InvestorModel.getReviewModalData();

    }


    function editSoleApplicantForm() {
      if(identifierData && identifierData.loginType=='A'){
        $state.go('agent.home.investors.add.appdetails');
      } else {
        $state.go('main.investors.add.appdetails');
      }
    }
    function editJointHolderForm() {
      if(identifierData && identifierData.loginType=='A'){
        $state.go('agent.home.investors.add.jointholders');
      } else {
        $state.go('main.investors.add.jointholders');
      }
    }
    function editBankDetailsForm() {
      var editFlag = true;
      if(identifierData && identifierData.loginType=='A'){
        $state.go('agent.home.investors.add.bankdetails');
      } else {
        $state.go('main.investors.add.bankdetails',{fromFolioReview:editFlag});
      }
    }
    function editNomineeApplicantForm() {
      if(identifierData && identifierData.loginType=='A'){
        $state.go('agent.home.investors.add.nominee');
      } else {
        $state.go('main.investors.add.nominee');
      }
    }

    function sendForApproval() {

      var payload=angular.copy(vm.formData);
      for(i=0;i<payload.folioCreationRequestCO.nominees.length;i++){
        payload.folioCreationRequestCO.nominees[i].guardianPanNumber=vm.formData.folioCreationRequestCO.nominees[i].guardianPan;
        payload.folioCreationRequestCO.nominees[i].guardianRelationWithNominee=vm.formData.folioCreationRequestCO.nominees[i].guardianRelation;
        payload.folioCreationRequestCO.nominees[i].panNumber=vm.formData.folioCreationRequestCO.nominees[i].nomineePan;
        delete payload.folioCreationRequestCO.nominees[i].guardianPan;
        delete payload.folioCreationRequestCO.nominees[i].guardianRelation;
        delete payload.folioCreationRequestCO.nominees[i].nomineePan;
        payload.folioCreationRequestCO.nominees[i].minor = vm.formData.folioCreationRequestCO.nominees[i].minor ? vm.formData.folioCreationRequestCO.nominees[i].minor : false;
      }
      if(payload.folioCreationRequestCO.soleApplicantDetail.name) {
        var lastIndex = payload.folioCreationRequestCO.soleApplicantDetail.name.lastIndexOf(" ");
        if (lastIndex > 0) {
          payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.name.substr(0, lastIndex);
          payload.folioCreationRequestCO.soleApplicantDetail.lastName = payload.folioCreationRequestCO.soleApplicantDetail.name.substr(lastIndex + 1);
        }
        else {
          payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.name;
          payload.folioCreationRequestCO.soleApplicantDetail.lastName = '';
        }
      }

      if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor){
        // var temp=angular.copy(payload.folioCreationRequestCO.guardianDetails);
        // payload.folioCreationRequestCO.guardianDetails={};
        // payload.folioCreationRequestCO.guardianDetails.relationship=temp.relationship;
        // payload.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl=temp.guardianRelationshipProofUrl;
        // payload.folioCreationRequestCO.guardianDetails.basicDetails=angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail);
        // payload.folioCreationRequestCO.guardianDetails.basicDetails.dob = $window.moment(payload.folioCreationRequestCO.guardianDetails.basicDetails.dob).format('DD-MMM-YYYY');
        //todo: need to check in minor folio creation
        // payload.folioCreationRequestCO.soleApplicantDetail=angular.copy(vm.formData.folioCreationRequestCO.minorDetails);
        // payload.folioCreationRequestCO.soleApplicantDetail.minor=true;
        // payload.folioCreationRequestCO.soleApplicantDetail.dob=$window.moment(payload.folioCreationRequestCO.soleApplicantDetail.dob).format('DD-MMM-YYYY');
        if(payload.folioCreationRequestCO.soleApplicantDetail.minorName) {
          var lastIndex = payload.folioCreationRequestCO.soleApplicantDetail.minorName.lastIndexOf(" ");
          if (lastIndex > 0) {
            payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.minorName.substr(0, lastIndex);
            payload.folioCreationRequestCO.soleApplicantDetail.lastName = payload.folioCreationRequestCO.soleApplicantDetail.minorName.substr(lastIndex + 1);
          }
          else {
            payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.minorName;
            payload.folioCreationRequestCO.soleApplicantDetail.lastName = '';
          }
          delete payload.folioCreationRequestCO.bankDetails.bankHolderType;
        }

        if(payload.folioCreationRequestCO.guardianDetails &&
          payload.folioCreationRequestCO.guardianDetails.basicDetails &&
          payload.folioCreationRequestCO.guardianDetails.basicDetails.name) {
          var lastIndex = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.lastIndexOf(" ");
          if (lastIndex > 0) {
            payload.folioCreationRequestCO.guardianDetails.basicDetails.firstName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.substr(0, lastIndex);
            payload.folioCreationRequestCO.guardianDetails.basicDetails.lastName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.substr(lastIndex + 1);
          }
          else {
            payload.folioCreationRequestCO.guardianDetails.basicDetails.firstName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name;
            payload.folioCreationRequestCO.guardianDetails.basicDetails.lastName = '';
          }
        }
        payload.folioCreationRequestCO.soleApplicantDetail.taxStatusCode='02';
        // delete payload.folioCreationRequestCO.guardianDetails;
        delete payload.folioCreationRequestCO.soleApplicantDetail.minorName;
        delete payload.folioCreationRequestCO.soleApplicantDetail.name;
        delete payload.folioCreationRequestCO.soleApplicantDetail.guardianDob;
        delete payload.folioCreationRequestCO.guardianDetails.basicDetails.minorAgeProof;
        payload.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry = payload.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry.countryCode;
        payload.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType = payload.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType.value;
        delete payload.minorAgeProof;
        delete payload.minorAgeProofFileType;
        delete payload.minorAgeProofName;
        delete payload.minorGaurdianAgeProof;
        delete payload.guardianProofFileType;
        delete payload.minorGaurdianFileName;
        //console.log(JSON.stringify(payload));
        delete payload.folioCreationRequestCO.nomineeRegistrationCO;
      }
      else{
        if(payload.folioCreationRequestCO.nominees){
          angular.forEach(payload.folioCreationRequestCO.nominees, function (nominee) {
              if(nominee.nomineeRelation == ""){
                delete nominee.nomineeRelation;
              }else if(nominee.nomineeRelation === CONST.RELATIONS.OTHER){
                nominee.nomineeRelation = nominee.nomineeRelationOther
                  ?nominee.nomineeRelationOther:CONST.RELATIONS.OTHER;
                delete nominee.nomineeRelationOther;
              }
              if(nominee.minor == true){
                delete nominee.nomineeAddress;
              }
              else{
                delete nominee.guardianAddress;
                  }
            if(payload.folioCreationRequestCO.showNomineeUpdate && !vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
              /*if(payload.folioCreationRequestCO.nomineeName) {
                payload.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration[0] = "NAME_OF_NOMINEES";
              }
              if(payload.folioCreationRequestCO.nomination) {
                payload.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration[1] = "NOMINATION_YES";
              }*/

              if (payload.folioCreationRequestCO.nomination) {
                payload.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration = 'NOMINATION_YES'
              } else {
                payload.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration = 'NOMINATION_NO'
              }
            } else {
              delete payload.folioCreationRequestCO.nomineeRegistrationCO;
            }
            delete nominee.identityProofList;
          });
          if(payload.folioCreationRequestCO && payload.folioCreationRequestCO.nomineeRegistrationCO && payload.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration && !payload.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeName) {
            delete payload.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration;
          }
          delete payload.folioCreationRequestCO.incapacitationDeclarationNameList;
          delete payload.folioCreationRequestCO.incapacitationNameList;
        }
        // delete payload.folioCreationRequestCO.minorDetails;
      }

      payload.folioCreationRequestCO.soleApplicantDetail.birthCountry = payload.folioCreationRequestCO.soleApplicantDetail.birthCountry.countryCode;
      payload.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = payload.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType.value;
      payload.folioCreationRequestCO.bankDetails.accountType = payload.folioCreationRequestCO.bankDetails.accountType.accountTypeCode;
      payload.folioCreationRequestCO.bankDetails.payoutMechanism = payload.folioCreationRequestCO.bankDetails.payoutMechanism.payoutCode;

      for(var i = 0; i<payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length; i++) {
        payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].countryName = payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].country.countryCode;
        payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].taxIdType = payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].taxIdType.key;
        delete payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].country;
      }

       /**
       * formatting guardian details payOutsideIndiaAddresses payload
       **/
       if(payload.folioCreationRequestCO.guardianDetails &&
         payload.folioCreationRequestCO.guardianDetails.basicDetails ) {
            for(var i = 0; i<payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.length; i++) {
              payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[i].countryName = payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[i].country.countryCode;
              payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[i].taxIdType = payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[i].taxIdType.key;
              delete payload.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[i].country;
            }
       }

      for(var i = 0; i<payload.folioCreationRequestCO.jointHolders.length; i++){
        payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.fatcaAddressType = payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.fatcaAddressType.value;
        for( var j = 0; j<payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses.length; j++) {
          payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses[j].taxIdType = payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses[j].taxIdType.key;

        }
      }

      if (payload.folioCreationRequestCO.soleApplicantDetail.oldmobileNo || payload.folioCreationRequestCO.soleApplicantDetail.oldmobileNo == "") {
        if ((payload.folioCreationRequestCO.soleApplicantDetail.oldmobileNo !== payload.folioCreationRequestCO.soleApplicantDetail.mobileNo)) {
          payload.folioCreationRequestCO.updateContactCo = {
            "mobileNo": payload.folioCreationRequestCO.soleApplicantDetail.mobileNo,
            "change":"MOBILE"
          };
          payload.folioCreationRequestCO.soleApplicantDetail.mobileNo = angular.copy(payload.folioCreationRequestCO.soleApplicantDetail.oldmobileNo);
        }
        delete payload.folioCreationRequestCO.soleApplicantDetail.oldmobileNo;
      } else {
        payload.folioCreationRequestCO.updateContactCo = {
          "mobileNo": payload.folioCreationRequestCO.soleApplicantDetail.mobileNo,
          "change":"MOBILE"
        };
      }

      if (payload.folioCreationRequestCO.soleApplicantDetail.oldemail || payload.folioCreationRequestCO.soleApplicantDetail.oldemail == "") {
        if (payload.folioCreationRequestCO.soleApplicantDetail.oldemail !== payload.folioCreationRequestCO.soleApplicantDetail.email) {
          payload.folioCreationRequestCO.updateContactCo = {
            "email": payload.folioCreationRequestCO.soleApplicantDetail.email,
            "change":"EMAIL"
          };
          payload.folioCreationRequestCO.soleApplicantDetail.email = angular.copy(payload.folioCreationRequestCO.soleApplicantDetail.oldemail);
        }
        delete payload.folioCreationRequestCO.soleApplicantDetail.oldemail;
      } else {
        payload.folioCreationRequestCO.updateContactCo = {
          "email": payload.folioCreationRequestCO.soleApplicantDetail.email,
          "change":"EMAIL"
        };
      }



      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            if (resp.data.folioDataInvalid) {
              ModalService.genericModal({
                text: resp.data.message
              }, function () {
                $state.go('main.dashboard');
              }, function () {
                $state.go('main.dashboard');
              });
            } else {
              InvestorModel.resetInvestorModel();
              var successPayDetails = function () {
                  if(identifierData && identifierData.loginType=='A'){
                    $state.go('agent.home.distributor-home');
                  } else {
                    $state.go('main.dashboard');
                  }
                },
                errorPayDetails = function () {
                  if(identifierData && identifierData.loginType=='A'){
                    $state.go('agent.home.distributor-home');
                  } else {
                    $state.go('main.dashboard');
                  }
                };
              ModalService.succInvestorModal(resp.data, successPayDetails, errorPayDetails);
            }
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
         InvestorModel.resetReviewModalData();
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'add'}, payload).$promise.then(success, error);
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsAddPaymentController', investorsAddPaymentController);

  /** @ngInject */
  function investorsAddPaymentController($state, $window, MessageService, UtilService, LoaderService, ModalService, AuthService, InvestorModel, AppConstants, InvestorsService, InvestorsCommonService, FileUploadService,HDFC_API,$log,DownloadPdfService,FileSaver, $stateParams ,dynamicData) {
    var vm = this;
    vm.CONST = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.IFSC_REGEX1 = AppConstants.ifsc_regex1;
    vm.EMAIL_REGEX = AppConstants.email_regex;
    vm.submitPayment = submitPayment;
    vm.bankNameList = bankNameList;
    // vm.bankChanged = bankChanged;
    vm.init = init;
    vm.paymentForm = {};
    vm.bankTypeList = vm.CONST.INVESTOR_ACC_TYPE;
    vm.formData = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
    vm.fileType = "";
    vm.validatePennyDrop = validatePennyDrop;
    vm.pennyDropCheck = null;
    vm.showValidate = false;
    vm.selectIFSC = selectIFSC;
    vm.tpv = tpv;
    vm.ischecked=false;
    vm.dynamicData = dynamicData;
    vm.dynamicNoteList = vm.dynamicData.noteDTO.noteDTOMap.Note_Folio_ADDBANK_LIST;
    vm.dynamicNoteValidate = vm.dynamicData.noteDTO.noteDTOMap.Note_Folio_ADDBANK;

    $log.debug(vm.formData);
    var identifierData = AuthService.getToken();
    if (identifierData && identifierData.loginType) {
      vm.loginType = identifierData.loginType;
    }

    function init() {
      switch ($state.current.name) {
        case 'main.investors.add.bankdetails':
        case 'agent.home.investors.add.bankdetails':
          modelEmptyCheck();
          acccountTypeLookup();
          payoutMechanismLookup();
          vm.bankNameList();
          angular.element('#bankDetailsId').addClass('active');

          if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor){
            if(angular.isDefined(vm.formData.folioCreationRequestCO.bankDetails)){
              vm.formData.folioCreationRequestCO.bankDetails.bankHolderType = vm.formData.folioCreationRequestCO.bankDetails.bankHolderType=== "INVESTOR"
              ?"INVESTOR":"MINOR";
            }
          }

          if (vm.formData.folioCreationRequestCO) {
            var fileUrl = vm.formData.folioCreationRequestCO.chequeLeafUrl;
            if (fileUrl) {
              var myFile = fileUrl.split('/');
              vm.chequeLeaf = myFile[myFile.length - 1];
            }
          }
          if(vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode === '01'){
            vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
          }else{
            vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = false;
          }
          break;
      }
    }
    var pennyDropEnablSelectedBank;
    function selectIFSC() {
      var successModal = function(data){
        vm.formData.folioCreationRequestCO.bankDetails.ifsccode= data.ifscCode;
        vm.formData.folioCreationRequestCO.bankDetails.bankName = data.bankName;
        vm.formData.folioCreationRequestCO.bankDetails.bankCity = data.branchCity;
        vm.formData.folioCreationRequestCO.bankDetails.branchLocation = data.branch;
        vm.formData.folioCreationRequestCO.bankDetails.accountNumber = '';
        vm.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber = '';
        if(data.branch && data.branch.length>40) vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch.slice(0,40)
        else vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode === '01') {
          vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
          vm.showValidate = true;
        }
        else {
          vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = false;
          vm.showValidate = false;
        }
        pennyDropEnablSelectedBank = vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid;
        resetCheckLeaf();
      };
      var errorModal = function(e){
        console.log('Error');
        vm.showValidate = false;
      };
      ModalService.IFSCSelectionModal({bankList : vm.bankList}, successModal, errorModal);
    }
    function tpv($event) {
      $event.preventDefault();
      ModalService.tpvModal({});
    }
    function resetCheckLeaf() {
      vm.formData.folioCreationRequestCO.chequeLeafUrl = "";
      vm.formData.folioCreationRequestCO.chequeLeaf = "";
      vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
      vm.fileType = "";
      angular.element("#uploadFileId").val("");
    }

    vm.openUploadedDoc = function() {
      if(angular.isUndefined(vm.formData.folioCreationRequestCO.chequeLeafUrl)){return;}
      ModalService.imagePreviewModal({showOnly:true, file: vm.formData.folioCreationRequestCO.chequeLeafUrl});
    };

    vm.downloadFile = function(url, fileType, proofType) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, proofType+'.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    function bankNameList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankList = resp.data.bankList;

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorsCommonService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);

    }

    function acccountTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var data = InvestorModel.getReviewModalData();
            vm.bankTypeList = resp.data.bankAccountTypes;
            if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
              if(data.accountType != "" && $stateParams.fromFolioReview){
                var sbAccount = vm.bankTypeList.filter(function (e) {
                  return e.accountType == data.accountType;
                })
              } else {
                sbAccount = resp.data.bankAccountTypes.filter(function(e) { return e.accountTypeCode === vm.validateData.SAVING_ACCOUNT_CODE; })
              }
              vm.formData.folioCreationRequestCO.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
              data.accountType = vm.formData.folioCreationRequestCO.bankDetails.accountType.accountType;
              InvestorModel.setReviewModalData(data);
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode
      }, {}).$promise.then(success, error);
    }

    function payoutMechanismLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            var data = InvestorModel.getReviewModalData();
            vm.payoutMechanismList = resp.data.payoutMechanisms;
            if (vm.formData.folioCreationRequestCO
              && vm.formData.folioCreationRequestCO.bankDetails) {
              if(data.payoutMechanism != "" && $stateParams.fromFolioReview){
                var payoutMechanism = vm.payoutMechanismList.filter(function (e) {
                  return e.payoutCode == data.payoutMechanism;
                })
              } else {
                  payoutMechanism = vm.payoutMechanismList.filter(function (e) {
                  return e.payoutCode == "DC";
                })
              }
              vm.payoutMechanism = payoutMechanism[0] && payoutMechanism[0].payoutCode ? payoutMechanism[0]: null;
              data.payoutMechanism = vm.payoutMechanism.payoutCode;
              InvestorModel.setReviewModalData(data);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({
        controller: 'payout',
        child1: 'mechanism'
      }, {}).$promise.then(success, error);
    }


    function modelEmptyCheck() {
      if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.dob && !vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.distributor-home')
        } else {
          $state.go('main.dashboard');
        }
      }
    }

    function submitPayment() {
      vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = vm.payoutMechanism;
      var profile = AuthService.getToken();
      if(profile.investorFullName) vm.formData.folioCreationRequestCO.bankDetails.accountHolderName = profile.investorFullName
      InvestorModel.setInvestorModel(vm.formData);
      sanitizingFormData(vm.formData);
      // $state.go('main.investors.add.scheme');
      var payload = angular.copy(vm.formData);
      if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor){
        if(payload.folioCreationRequestCO.soleApplicantDetail.minorName) {
          var lastIndex = payload.folioCreationRequestCO.soleApplicantDetail.minorName.lastIndexOf(" ");
          if (lastIndex > 0) {
            payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.minorName.substr(0, lastIndex);
            payload.folioCreationRequestCO.soleApplicantDetail.lastName = payload.folioCreationRequestCO.soleApplicantDetail.minorName.substr(lastIndex + 1);
          }
          else {
            payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.minorName;
            payload.folioCreationRequestCO.soleApplicantDetail.lastName = '';
          }
        }

        if(payload.folioCreationRequestCO.guardianDetails &&
          payload.folioCreationRequestCO.guardianDetails.basicDetails &&
          payload.folioCreationRequestCO.guardianDetails.basicDetails.name) {
          var lastIndex = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.lastIndexOf(" ");
          if (lastIndex > 0) {
            payload.folioCreationRequestCO.guardianDetails.basicDetails.firstName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.substr(0, lastIndex);
            payload.folioCreationRequestCO.guardianDetails.basicDetails.lastName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name.substr(lastIndex + 1);
          }
          else {
            payload.folioCreationRequestCO.guardianDetails.basicDetails.firstName = payload.folioCreationRequestCO.guardianDetails.basicDetails.name;
            payload.folioCreationRequestCO.guardianDetails.basicDetails.lastName = '';
          }
        }
        payload.folioCreationRequestCO.soleApplicantDetail.taxStatusCode='02';
        // delete payload.folioCreationRequestCO.guardianDetails;
        delete payload.folioCreationRequestCO.soleApplicantDetail.minorName;
        delete payload.folioCreationRequestCO.soleApplicantDetail.name;
        delete payload.folioCreationRequestCO.soleApplicantDetail.guardianDob;
        delete payload.folioCreationRequestCO.guardianDetails.basicDetails.minorAgeProof;
        payload.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry = payload.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry.countryCode;
        payload.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType = payload.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType.value;

        //console.log(JSON.stringify(payload));
      }
      else{
        if(payload.folioCreationRequestCO.nominees){
          angular.forEach(payload.folioCreationRequestCO.nominees, function (nominee) {
            if(nominee.nomineeRelation == ""){
              delete nominee.nomineeRelation;
            }else if(nominee.nomineeRelation === vm.CONST.RELATIONS.OTHER){
              nominee.nomineeRelation = nominee.nomineeRelationOther
                ?nominee.nomineeRelationOther:vm.CONST.RELATIONS.OTHER;
              delete nominee.nomineeRelationOther;
            }
            if(nominee.minor == true){
              delete nominee.nomineeAddress;
            }
            else{
              delete nominee.guardianAddress;
            }
          });
        }
      }

      payload.folioCreationRequestCO.soleApplicantDetail.birthCountry = payload.folioCreationRequestCO.soleApplicantDetail.birthCountry.countryCode;
      payload.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = payload.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType.value;
      payload.folioCreationRequestCO.bankDetails.accountType = payload.folioCreationRequestCO.bankDetails.accountType.accountTypeCode;
      payload.folioCreationRequestCO.bankDetails.payoutMechanism = payload.folioCreationRequestCO.bankDetails.payoutMechanism.payoutCode;
      for(var i=0; i<payload.folioCreationRequestCO.nominees.length;i++){
        payload.folioCreationRequestCO.nominees[i].panNumber = payload.folioCreationRequestCO.nominees[i].nomineePan;
        payload.folioCreationRequestCO.nominees[i].guardianPanNumber = payload.folioCreationRequestCO.nominees[i].guardianPan;
        payload.folioCreationRequestCO.nominees[i].guardianRelationWithNominee = payload.folioCreationRequestCO.nominees[i].guardianRelation;
        delete payload.folioCreationRequestCO.nominees[i].nomineePan;
        delete payload.folioCreationRequestCO.nominees[i].guardianPan;
        delete payload.folioCreationRequestCO.nominees[i].guardianRelation;
      }
      if(payload.folioCreationRequestCO.soleApplicantDetail.name) {
        var lastIndexForPennyDrop = payload.folioCreationRequestCO.soleApplicantDetail.name.lastIndexOf(" ");
        if (lastIndexForPennyDrop > 0) {
          payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.name.substr(0, lastIndexForPennyDrop);
          payload.folioCreationRequestCO.soleApplicantDetail.lastName = payload.folioCreationRequestCO.soleApplicantDetail.name.substr(lastIndexForPennyDrop + 1);
        } else {
          payload.folioCreationRequestCO.soleApplicantDetail.firstName = payload.folioCreationRequestCO.soleApplicantDetail.name;
          payload.folioCreationRequestCO.soleApplicantDetail.lastName = '';
        }
      }
      for(var i = 0; i<payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length; i++) {
        payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].countryName = payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].country.countryCode;
        payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].taxIdType = payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].taxIdType.key;
        delete payload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[i].country;
      }
      for(var i = 0; i<payload.folioCreationRequestCO.jointHolders.length; i++){
        payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.fatcaAddressType = payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.fatcaAddressType.value;
        for( var j = 0; j<payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses.length; j++) {
          payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses[j].taxIdType = payload.folioCreationRequestCO.jointHolders[i].jointHolderApplicantDetail.payOutsideIndiaAddresses[j].taxIdType.key;

        }
      }

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            InvestorModel.resetInvestorModel();
            var successPayDetails = function () {
                if (identifierData && identifierData.loginType == 'A') {
                  $state.go('agent.home.distributor-home')
                } else {
                  $state.go('main.dashboard');
                }
              },
              errorPayDetails = function () {
                if (identifierData && identifierData.loginType == 'A') {
                  $state.go('agent.home.distributor-home')
                } else {
                  $state.go('main.dashboard');
                }
              };
            ModalService.succInvestorModal(resp.data, successPayDetails, errorPayDetails);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      // InvestorsService.post({controller: 'add'}, vm.formData).$promise.then(success, error);
      InvestorsService.post({controller: 'add'}, payload).$promise.then(success, error);

    }

    vm.goBack = function () {
      vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = vm.payoutMechanism;
      InvestorModel.setInvestorModel(vm.formData);
      if (vm.formData.folioCreationRequestCO.addNomineeLater) {
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.nominee')
        } else {
          $state.go('main.investors.add.nominee');
        }
      } else {
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.appdetails')
        } else {
          $state.go('main.investors.add.appdetails');
        }
      }
    };
    vm.cancelTransaction = function () {
      var success = function () {
        InvestorModel.setInvestorModel(null);
        InvestorModel.resetTab();
        $state.go('main.dashboard');
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Do you want to cancel this action ?'}, success, error);
    };

    function getFileType(fileType) {
      return fileType.split('/')[1]
    }

    vm.uploadFile = function (file) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format not supported. Supported format are tif, tiff, jpg and jpeg'");
          resetCheckLeaf();
          return;
        }
        if (file.size <= 2000000) {
          vm.myFile = file;
          /*var ext =file.name.split('.').pop();
          vm.chequeLeaf= 'check-leaf-'+$window.moment().unix()+"."+ext ;*/
          vm.chequeLeaf = file.name ;
          var taxIdentifierNumber = vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber;

          var modalSuccess = function () {
              var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/investor/folio/add/document/upload/'+taxIdentifierNumber+'/CHEQUE_LEAF';
              LoaderService.showLoader();
              FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  vm.formData.folioCreationRequestCO.chequeLeafUrl=resp.data.fileUrl;
                  vm.fileType= getFileType(file.type);
                } else {
                  resetCheckLeaf();
                  MessageService.error(resp.message)
                }
              }, function () {
                resetCheckLeaf();
                LoaderService.hideLoader();
              });
            } ,
            modalError = function () {
              resetCheckLeaf();
            };

          ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }else{
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
      }
    };


    vm.copyPasteHandler = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    };


    vm.accModelDirty = false;
    vm.accFocus = function () {
      vm.accModelDirty = true;
      resetCheckLeaf();
      if(pennyDropEnablSelectedBank){
        vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
      }
    };

    vm.goToAppDetails = function () {
      if(vm.formData.folioCreationRequestCO.jointHolders && vm.formData.folioCreationRequestCO.jointHolders.length>0){
        if(identifierData && identifierData.loginType=='A'){
          $state.go('agent.home.investors.add.jointholders');
        } else {
          $state.go('main.investors.add.jointholders');
        }
      }else{
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.appdetails');
        } else {
          vm.formData.folioCreationRequestCO.addNomineeLater = vm.formData.folioCreationRequestCO.addNomineeLater ? vm.formData.folioCreationRequestCO.addNomineeLater: false;
          InvestorModel.setInvestorModel(vm.formData);
          $state.go('main.investors.add.appdetails');
        }
      }
    };

    vm.goToNominee = function () {
      if (identifierData && identifierData.loginType == 'A') {
        $state.go('agent.home.investors.add.nominee');
      } else {
        $state.go('main.investors.add.nominee');
      }
    };
    vm.setAccountType = function () {
      var account = vm.bankTypeList.filter(function (data) {
        if (vm.formData.folioCreationRequestCO.bankDetails.accountType.accountTypeCode == data.accountTypeCode) {
          return data;
        }
      });
      var data = InvestorModel.getReviewModalData();
      data.accountType = account[0] && account[0].accountType
        ? account[0].accountType : data.accountType;
      InvestorModel.setReviewModalData(data);
    };

    vm.setPayoutMechanism = function () {
      var payoutMech = vm.payoutMechanismList.filter(function (data) {
        if (vm.payoutMechanism.payoutCode == data.payoutCode) {
          return data;
        }
      });
      console.log(payoutMech);
      var data = InvestorModel.getReviewModalData();
      data.payoutMechanism = payoutMech[0] && payoutMech[0].payoutCode
        ? payoutMech[0].payoutCode : data.payoutMechanism;
      InvestorModel.setReviewModalData(data);
    };


    function sanitizingFormData(model) {
      if (model.folioCreationRequestCO && model.folioCreationRequestCO.nominees && model.folioCreationRequestCO.nominees.length > 0) {
        model.folioCreationRequestCO.nominees = model.folioCreationRequestCO.nominees.filter(function (ele) {
          return !!ele.nomineeName;
        });
      }
      if (model.folioCreationRequestCO && model.folioCreationRequestCO.guardianDetails && model.folioCreationRequestCO.guardianDetails.basicDetails) {
        if (!model.folioCreationRequestCO.guardianDetails.basicDetails.email) {
          // delete model.folioCreationRequestCO.guardianDetails;
        }
      }
      if (InvestorModel.isFolioCreationFromProfileAndToDo()) {
        model.toPanVerify = false;
      }
    }

    vm.reviewTransaction = function () {
      vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = vm.payoutMechanism;
      InvestorModel.setInvestorModel(vm.formData);
      sanitizingFormData(vm.formData);
      console.log("vm.formData>>>>>>>>>>>>>",vm.formData);
      if (identifierData && identifierData.loginType == 'A') {
        $state.go('agent.home.investors.review');
      } else {
        $state.go('main.investors.review');
      }
    };
    function validatePennyDrop() {
      var profile = AuthService.getToken();
      var pennyDropValidatePayload = {
        beneficiaryIFSC:vm.formData.folioCreationRequestCO.bankDetails.ifsccode,
        benificiaryAccountNo:vm.formData.folioCreationRequestCO.bankDetails.accountNumber,
        benificiaryName:vm.formData.folioCreationRequestCO.soleApplicantDetail.name,
        arncode: profile.arnCode,
        panNo: vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber,
        distributorInitiate: true
      };
        var success = function (resp) {
           vm.showValidate = false;
            if (resp.status && resp.data) {
              if(resp.data.valid === false) {
                MessageService.error(resp.data.message);
                vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = false;
                pennyDropEnablSelectedBank = true
              }

              else {
                vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
                vm.formData.folioCreationRequestCO.bankDetails.accountHolderName = resp.data.name;
                submitPayment();
              }
              LoaderService.hideLoader();
            } else {
              MessageService.error(resp.message);
              LoaderService.hideLoader();
            }
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
            LoaderService.hideLoader();
          };
      LoaderService.showLoader();
        InvestorsCommonService.post({
          child1: 'account',
          child2: 'validate',
          child3: 'pennyDrop'
        }, pennyDropValidatePayload).$promise.then(success, error);

    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsAddController', investorsAddController);

  /** @ngInject */
  function investorsAddController($state, $scope, $timeout, $window, ModalService, MessageService, InvestorModel, AppConstants, InvestorsService, UtilService, moment, HDFC_API, LoaderService, FileUploadService, AuthService,DownloadPdfService,FileSaver, InvestorsCommonService, dynamicData ,  $rootScope, InvestorCommonServiceVersion2) {
    var vm = this;
    vm.disabled = disabled;
    //vm.checkPanDetails = checkPanDetails;
    vm.fileTaxAction = fileTaxAction;
    vm.addMoreTaxResidency = addMoreTaxResidency;
    vm.addMoreTaxResidencyGD = addMoreTaxResidencyGD;
    vm.deleteTaxResidency = deleteTaxResidency;
    vm.deleteTaxResidencyGD = deleteTaxResidencyGD;
    vm.submitApplicantDetails = submitApplicantDetails;
    vm.submitGuardianDetails = submitGuardianDetails;
    vm.dobRequired = false;
    // vm.initJointHolders = initJointHolders;
    vm.fileTaxActionJointHolder = fileTaxActionJointHolder;
    vm.fileTaxActionGuardianDetails = fileTaxActionGuardianDetails;
    vm.addMoreTaxResidencyJointHolder = addMoreTaxResidencyJointHolder;
    vm.deleteTaxResidencyJointHolder = deleteTaxResidencyJointHolder;
    vm.addMoreJointHolder = addMoreJointHolder;
    vm.switchHolder = switchHolder;
    vm.deleteCurrentJointHolder = deleteCurrentJointHolder;
    vm.submitJointHolder = submitJointHolder;
    vm.switchNominee = switchNominee;
    vm.addMoreNominee = addMoreNominee;
    vm.deleteCurrentNominee = deleteCurrentNominee;
    vm.submitNominee = submitNominee;
    vm.changeStartDate = changeStartDate;
    vm.changeNetWorthDate = changeNetWorthDate;
    vm.goPrevious = goPrevious;
    vm.changeStartDateJointHolder = changeStartDateJointHolder;
    vm.changeStartDateNominee = changeStartDateNominee;
    vm.minorCheck = minorCheck;
    vm.init = init;
    vm.addJointHolderTab = addJointHolderTab;
    vm.onChangePercentage = onChangePercentage;
    vm.selectBirthCity = selectBirthCity;
    vm.selectHolderBirthCity = selectHolderBirthCity;
    vm.selectNomineeBirthCity = selectNomineeBirthCity;
    vm.selectGuardianBirthCity = selectGuardianBirthCity;
    vm.checkAddNominee = checkAddNominee;
    vm.setMinorFlag = setMinorFlag;
    vm.changeMinorDob = changeMinorDob;
    vm.uploadFile = uploadFile;
    vm.uploadGuardianProofFile = uploadGuardianProofFile;
    vm.submitHoldmode = submitHoldmode;
    vm.setHoldmode = setHoldmode;
    vm.openUploadedDoc = openUploadedDoc;
    vm.downloadFile = downloadFile;
    vm.checkDuplicateNomineePan=checkDuplicateNomineePan;
    vm.checkUniqueGuardianPan=checkUniqueGuardianPan;
    vm.getStateList=getStateList;
    vm.buttonEnable= buttonEnable;
    vm.singleNomineePan=singleNomineePan;
    vm.checkDecimal=checkDecimal;
    vm.onPaste=onPaste;
    vm.checkValid2ndHolder= checkValid2ndHolder;
    vm.getFolioList = getFolioList;
    vm.changeNomineeRelation = changeNomineeRelation;
    vm.getIdentityProofList = getIdentityProofList;
    vm.changeNomineeIdentityProof = changeNomineeIdentityProof;
    vm.changeEmailId = changeEmailId;
    vm.changeMobileNumber = changeMobileNumber;
    vm.checkNomineeIsMinor = checkNomineeIsMinor;
    vm.changeDrivingLicense = changeDrivingLicense;
    vm.changeAadharCard = changeAadharCard;
    vm.changeSelectedName = changeSelectedName;
    vm.changeNomineeName = changeNomineeName;
    vm.setStatement = setStatement;
    vm.changePercentageOrAmount = changePercentageOrAmount;
    vm.changePassport = changePassport;
    // vm.showNomineeUpdate = true; // will get from dynamic content api


    vm.nomineePanValidCheck=null;
    vm.guardianPanValidCheck=null;
    vm.genderList = [{name: 'Male', value: 'MALE'}, {name: 'Female', value: 'FEMALE'}];
    vm.defaultDob = null;
    vm.CONST = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.genderList = [{key: 'MALE', value: 'Male'}, {key: 'FEMALE', value: 'Female'}];
    vm.minorRelationshipsList = [{name: 'Father', value: 'FATHER'}, {name: 'Mother', value: 'MOTHER'}, {
      name: 'Sibling',
      value: 'SIBLING'
    }, {name: 'Other', value: 'OTHER'}];
    var date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    vm.minDate = date;
    vm.defaultDate = date;

    var date1 = new Date();
    date1.setFullYear(date1.getFullYear() - 18);
    vm.maxWorthDate = date1;
    var scope = $scope;
    vm.headerDetails = scope.headerDetails || {name: 'Default', pan: 'Default'};
    vm.soleApplicantForm = {};
    vm.jointHolderForm = {};
    vm.currentJointHolder = 0;
    vm.currentNominee = 0;
    vm.tabEnable = {};
    vm.nomineePropertion = {
      min: 1,
      'min-0': 1,
      max: 100
    };
    $window.sessionStorage.investorForm = $window.sessionStorage.investorForm ? $window.sessionStorage.investorForm : InvestorModel.getNewInvestorModel();
    vm.formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
    vm.headerDetails.holdmode = vm.formData.folioCreationRequestCO.holdMode;
    vm.taxStatusList = [];
    vm.countryList = null;
    vm.cityList = null;
    vm.statelist=null;
    vm.showAddNomineeLink = true;
    vm.occupationList = [];
    vm.addressDescriptions = [];
    vm.parentIndex = 0;
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'seventh',
      7: 'eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.mimeType = ["image/jpeg", "image/jpg","image/tiff","image/tif"];
    vm.chequeLeaf = "No file chosen";
    // vm.formData.minorGaurdianAgeProof = null;
    // vm.formData.minorGaurdianFileName = "No file chosen";
    // vm.formData.minorAgeProofName = "No file chosen";
    // vm.formData.minorAgeProofFileType = "";
    // vm.formData.guardianProofFileType = "";
    vm.isPanVerified=false;
    vm.dynamicData = dynamicData;
    vm.dynamicDataForOptOutDec = dynamicData.noteDTO.noteDTOMap.Note_Folio_NOMINEE_OPT_OUT.content;
    if(dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info) {
      vm.dynamicDataForTaxStatus = dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info.content;
    }
    vm.notValid2ndHolder = false;
    vm.screenTab = InvestorModel.getInvestorFolioModal();
    vm.updateContactInfo = updateContactInfo;
    vm.showEditEmail = true;
    vm.showEditMobile = true;
    vm.hideUiFnc = hideUiFnc;
    vm.showUiFnc = showUiFnc;
    vm.hideEditMobile = false;
    vm.hideEditEmail = false;
    vm.setOptionalEmptyJH = setOptionalEmptyJH;
    vm.emailIdValid = true;

    if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail && vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail !== "") {
      vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail = angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail.email);
    }

    if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo && vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo !== "") {
      vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo =  angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo);
    }

    var identifierData = AuthService.getToken();
    if (identifierData && identifierData.loginType) {
      vm.loginType = identifierData.loginType;
    }

    function uploadFile(file) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          resetMinorAgeProof();
          MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
          return;
        }else if (file.size > 2000000) {
          resetMinorAgeProof();
          MessageService.error("File size should not be more than 2 MB.");
          return;
        }
        vm.formData.minorAgeProof = file;
        vm.formData.minorAgeProofName = file.name;
        var taxIdentifierNumber = vm.headerDetails.pan;

        var modalSuccess = function () {
            var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/MINOR_PROOF';
            LoaderService.showLoader();
            FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof = resp.data.fileUrl;
                vm.formData.minorAgeProofFileType=getFileType(file.type);
              } else {
                MessageService.error(resp.message);
              }
            }, function () {
              LoaderService.hideLoader();
            });

          },
          modalError = function () {
            resetMinorAgeProof();
        };

        ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
      }

    }

    function getFileType(fileType) {
      return fileType.split('/')[1]
    }

    function resetMinorAgeProof() {
      $window.document.getElementById("minorAgeProof").value = '';
      if(vm.formData.folioCreationRequestCO.soleApplicantDetail && vm.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof){
        var fileUrl = vm.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof;
        var myFile = fileUrl.split('/');
        vm.formData.minorAgeProof = myFile[myFile.length - 1];
        vm.formData.minorAgeProofName = myFile[myFile.length - 1];

      }else{
        vm.formData.minorAgeProofName = "No file chosen";
        vm.formData.minorAgeProof = {};
        vm.formData.minorAgeProofFileType = "";
      }
    }

    function openUploadedDoc(url) {
      if(angular.isUndefined(url)){return;}
      ModalService.imagePreviewModal({showOnly:true, file: url});
    };

    function downloadFile(url, fileType, proofType) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, proofType+'.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    function uploadGuardianProofFile(file) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          resetRelationProof();
          MessageService.error("File format should be TIF, TIFF, JPG and JPEG extension.");
          return;
        }else if (file.size > 2000000) {
          resetRelationProof();
          MessageService.error("File size should not be more than 2 MB.");
          return;
        }
        vm.formData.minorGaurdianAgeProof = file;
        vm.formData.minorGaurdianFileName = file.name;
        var taxIdentifierNumber = vm.headerDetails.pan;


        var modalSuccess = function () {
            var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + taxIdentifierNumber + '/GUARDIAN_PROOF';
            LoaderService.showLoader();
            FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl = resp.data.fileUrl;
                vm.formData.guardianProofFileType=getFileType(file.type);
              } else {
                MessageService.error(resp.message);
              }
            }, function () {
              LoaderService.hideLoader();
            });
          },
          modalError = function () {
            resetRelationProof();
          };

        ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
      }

    }

    function resetRelationProof() {
      $window.document.getElementById("uploadGurdianAgeProof").value = '';
      if(vm.formData.folioCreationRequestCO.guardianDetails && vm.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl){
        var fileUrl = vm.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl;
        var myFile = fileUrl.split('/');
        vm.formData.minorGaurdianAgeProof = myFile[myFile.length - 1];
        vm.formData.minorGaurdianFileName = myFile[myFile.length - 1];

      }else{
        vm.formData.minorGaurdianFileName = "No file chosen";
        vm.formData.minorGaurdianAgeProof = {};
        vm.formData.guardianProofFileType = "";
      }

    }

    function init() {
      switch ($state.current.name) {
        case 'main.investors.add':
        case 'agent.home.investors.add':
          break;
        case 'main.investors.add.holdmode':
        case 'agent.home.investors.add.holdmode':
          vm.headerDetails.holdmode = vm.formData.folioCreationRequestCO.holdMode;
          if (vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {/*&& vm.formData.folioCreationRequestCO.soleApplicantDetail.name*/
            vm.headerDetails.name = vm.formData.folioCreationRequestCO.soleApplicantDetail.name;
            vm.headerDetails.pan = vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber;
            vm.headerDetails.reason = vm.formData.folioCreationRequestCO.reason;
          } else {
            MessageService.error("PAN & email Id is required.");
            if (identifierData && identifierData.loginType == 'A') {
              $state.go('agent.home.distributor-home');
            } else {
              $state.go('main.dashboard');
            }
          }
          scope.headerDetails = vm.headerDetails;
          InvestorModel.resetFolioModalTab();
          InvestorModel.resetInvestorModel();
          break;
        case 'main.investors.add.appdetails':
        case 'agent.home.investors.add.appdetails':
          vm.tabEnable = InvestorModel.getTab();
          if (vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {/*&& vm.formData.folioCreationRequestCO.soleApplicantDetail.name*/

            vm.headerDetails.name = vm.formData.folioCreationRequestCO.soleApplicantDetail.name;
            vm.headerDetails.pan = vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber;
            vm.headerDetails.reason = vm.formData.folioCreationRequestCO.reason;
            scope.headerDetails = vm.headerDetails;

            if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor == false) {
              InvestorModel.setTab({tab4: false, tabGuardianDetailShow: false});
              $timeout(function () {
                scope.$apply(function () {
                  vm.tabEnable = InvestorModel.getTab();
                  vm.tabEnable.tab4 = false;
                  vm.tabEnable.tabGuardianDetailShow = false;
                })
              });
              delete vm.formData.folioCreationRequestCO.guardianDetails;
            } else {
              //hide gaurdianDetails if minor
              InvestorModel.setTab({tab4: false, tabGuardianDetailShow: true});
              vm.tabEnable = InvestorModel.getTab();
              setMinorFlag();
            }
            vm.dateOfBirth = null;
            InvestorModel.setInvestorModel(vm.formData);
            $window.sessionStorage.investorForm = angular.toJson(vm.formData);
            if (identifierData && identifierData.loginType == 'A') {
              //$state.go('agent.investors.add.appdetails');
            } else {
              $state.go('main.investors.add.appdetails');
            }
          } else {
            if (identifierData && identifierData.loginType == 'A') {
              $state.go('agent.home.distributor-home');
            } else {
              $state.go('main.dashboard');
            }
          }

          modelEmptyCheck();
          lookupList();
          getCountryList();
          getStateList();
          getCityList();
          taxStatusLookup(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor);
          getTaxIdType();
          vm.headerDetails = scope.headerDetails || {name: 'Default', pan: ''};
          vm.defaultDateNetWorthDate = vm.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate || null;
          /*(new Date())*/
          if (!vm.defaultDateNetWorthDate) {
            vm.defaultDateNetWorthDate = new Date().toString();
            $timeout(function () {
              $window.document.getElementById('soleNetWorthDate2') && ($window.document.getElementById('soleNetWorthDate2').value = "");
            })
          }
          if(vm.formData.folioCreationRequestCO.soleApplicantDetail.netWorth){
            $timeout(function () {
              $window.NumToWord(vm.formData.folioCreationRequestCO.soleApplicantDetail.netWorth, 'DisplayWordsTaxAmount');
            });
          }
          if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.dob) {
            vm.formData.folioCreationRequestCO.soleApplicantDetail.dob =
              scope.headerDetails && scope.headerDetails.dob ? scope.headerDetails.dob
                : vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
          }
          if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {
            vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber =
              scope.headerDetails && scope.headerDetails.pan ? scope.headerDetails.pan
                : vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber;
          }

          if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor && vm.formData.folioCreationRequestCO.soleApplicantDetail.dob) {
            // vm.defaultDob = $window.moment(vm.formData.folioCreationRequestCO.soleApplicantDetail.dob, "DD-MMM-YYYY");
            vm.defaultDob = vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
            var fileUrl = vm.formData.folioCreationRequestCO.soleApplicantDetail && vm.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof;
            if (fileUrl) {
              var myFile = fileUrl.split('/');
              vm.minorAgeProof = myFile[myFile.length - 1];
              vm.minorAgeProofName = myFile[myFile.length - 1];
            }
            var fileUrl1 = vm.formData.folioCreationRequestCO.guardianDetails && vm.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl;
            if (fileUrl1) {
              var myFile1 = fileUrl1.split('/');
              vm.formData.minorGaurdianAgeProof = myFile1[myFile1.length - 1];
              vm.formData.minorGaurdianFileName = myFile1[myFile1.length - 1];
            }
          }
          if (!vm.defaultDob) {
            vm.defaultDob = new Date();
            $timeout(function () {
              $window.document.getElementById('minorDobId') && ($window.document.getElementById('minorDobId').value = "");
            })
          }
          $timeout(function(){
            vm.folioNumberFromModal = JSON.parse(sessionStorage.getItem('folioNumberFromModal'));
            if(vm.folioNumberFromModal && !vm.screenTab.appdetailsTab) {
              fetchFolioData(vm.folioNumberFromModal);
              InvestorModel.setInvestorFolioModal({appdetailsTab: true});
            }

          },500)

          break;
        case 'main.investors.add.guardianDetails':
        case 'agent.home.investors.add.guardianDetails':
          lookupList();
          getCountryList();
          getStateList()
          getCityList();
          taxStatusLookup(false);
          vm.defaultDateNetWorthDate = new Date();
          break;
        case 'main.investors.add.jointholders':
        case 'agent.home.investors.add.jointholders':
          modelEmptyCheck();
          lookupList();
          getCountryList();
          getStateList();
          getCityList();
          getTaxIdType();
          var isMinor = vm.formData.folioCreationRequestCO.jointHolders && vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail
            && vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.minor || false;

          if(vm.formData.folioCreationRequestCO.jointHolders && vm.formData.folioCreationRequestCO.jointHolders.length == 2){
            vm.formData.folioCreationRequestCO.jointHolders.forEach(function(holder,index){
              taxStatusLookup(isMinor, true, index);
            })
          } else {
            taxStatusLookup(isMinor, true, 0);
          }
          vm.defaultDateNetWorthDate = vm.formData.folioCreationRequestCO.jointHolders.length > 0
            ? ((vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorthDate)
              ? vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorthDate :null) : $window.moment();
          if (vm.formData.folioCreationRequestCO.jointHolders && (vm.formData.folioCreationRequestCO.jointHolders.length == 0)) {
            // pan4JointHolders();
          }
          break;
        case 'main.investors.add.nominee':
        case 'agent.home.investors.add.nominee':
          modelEmptyCheck();
          getCountryList();
          getStateList();
          getCityList();
          getRelationshipList();
          vm.formData.folioCreationRequestCO.nominees = vm.formData.folioCreationRequestCO.nominees || [];
          var nomineeArray = vm.formData.folioCreationRequestCO.nominees;
          if (nomineeArray.length == 0) {
            vm.formData.folioCreationRequestCO.nominees.push(InvestorModel.getNewNominee());
          } else {
            vm.formData.folioCreationRequestCO.nominees.forEach(function(nominee, index) {
              if (nominee.guardianPanNumber) {
                checkUniqueGuardianPan(index, nominee.guardianPanNumber, true);
              }
            });
          }
          vm.defaultDateNominee = (moment(moment(vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].dob).format('DD-MMM-YYYY').toString(), 'DD-MMM-YYYY', true).isValid())
            ? (moment(vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].dob).format('DD-MMM-YYYY').toString()) : null; // (moment(new Date()).format('DD-MMM-YYYY').toString());
          if (vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].nomineeName == '') {
            $timeout(function () {
              if ($window.document.getElementById('nomineeDOBId-' + vm.parentIndex)) {
                $window.document.getElementById('nomineeDOBId-' + vm.parentIndex).value = "";
              }
            })
          }
          if (vm.formData.folioCreationRequestCO.showNomineeUpdate) {
            vm.allowedNomineeLength = vm.formData.folioCreationRequestCO.nomineeLimit;
            vm.formData.folioCreationRequestCO.nomineeName = true;
            getIdentityProofList(function(){
              vm.formData.folioCreationRequestCO.nominees.forEach(function(data,index){
                checkNomineeIsMinor(index);
              });
            });
            if ((vm.formData.folioCreationRequestCO && vm.formData.folioCreationRequestCO.nomineeRegistrationCO && vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration && vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration === "NOMINATION_YES") || !vm.formData.folioCreationRequestCO.nomineeRegistrationCO || !vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration) {
              vm.formData.folioCreationRequestCO.nomination = true;
            } else {
              vm.formData.folioCreationRequestCO.nomination = false;
            }
          } else {
            vm.allowedNomineeLength = vm.formData.folioCreationRequestCO.nomineeLimit;
          }
          break;

      }
      vm.tabEnable = InvestorModel.getTab();
      checkValid2ndHolder(vm.formData.folioCreationRequestCO.jointHolders);
    }

    function setHoldmode(){
      vm.headerDetails.holdmode = vm.formData.folioCreationRequestCO.holdMode;
      scope.headerDetails = vm.headerDetails;
    }

    function changeMinorDob(date) {
      if (date) {
        vm.formData.folioCreationRequestCO.soleApplicantDetail.dob = date._d;
        vm.defaultDob = date.toString();
      }
    }

    function setMinorFlag() {
      if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
        // vm.formData.folioCreationRequestCO.minorDetails={};
        // vm.formData.folioCreationRequestCO.minorDetails.name=vm.formData.folioCreationRequestCO.soleApplicantDetail.name;
        vm.minDateMinor = $window.moment().clone().subtract(18, 'years').format("DD-MMM-YYYY");
        InvestorModel.setTab({tab4: false, tabGuardianDetailShow: true});
        vm.tabEnable = InvestorModel.getTab();
        $scope.$parent.isMinor = true;
        getRelationshipList();
      }
      else {
        InvestorModel.setTab({tab4: false, tabGuardianDetailShow: false});
        vm.tabEnable = InvestorModel.getTab();
        $scope.$parent.isMinor = false;
      }


    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;

          if(vm.countryList && vm.countryList.length > 0 && !vm.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry){
            var countrySelected = vm.countryList.filter(function(country) {
              return country.countryCode === "IN";
            });
            vm.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry = countrySelected[0];
          }

          if(vm.countryList && vm.countryList.length > 0 && vm.formData.folioCreationRequestCO.jointHolders.length > 0 && !vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.birthCountry){
            var data = InvestorModel.getReviewModalData();
            var countrySelected = vm.countryList.filter(function(country) {
              return country.countryCode === "IN";
            });
            vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.birthCountry = countrySelected[0].countryName;
            data.holders[0].birthCountry = countrySelected[0].countryName;
            InvestorModel.setReviewModalData(data);
          }
          vm.screenTab.responseDataStorage.countryList = vm.countryList;
          InvestorModel.setInvestorFolioModal(vm.screenTab);
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countryList = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'country', child1: 'list'}, null).$promise.then(success, error);
    }

    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsCommonService.get({
        child1: 'state',
        child2: 'list'
      }).$promise.then(success, error);
    }

    function getCityList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.cityList = resp.data.cities;
        } else {
          vm.cityList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.cityList = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'city', child1: 'list'}, null).$promise.then(success, error);
    }

    function lookupList() {
      occupationLookup();
      incomeSlab();
      addressTypeLookup();
    }

    function taxStatusLookup(minorCheckParams, fromHolder,index) {
      var successTaxStatus = function (resp) {
          if (resp.status && resp.data) {
            if(fromHolder) {
              vm.taxStatusList[index] = resp.data.taxStatus;
            } else {
              vm.taxStatusList = resp.data.taxStatus;
            }

            if (vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode === "") {
              vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode = vm.formData.folioCreationRequestCO.nriFlag == true? null: vm.taxStatusList.length && vm.taxStatusList.length > 0
                ? vm.taxStatusList[0].taxStatusCode
                : vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode;

              /*set description for review*/
              var data = InvestorModel.getReviewModalData();
              data.taxStatusDescription = vm.taxStatusList.length && vm.taxStatusList.length > 0
                ? vm.taxStatusList[0].taxStatusDescription
                : data.taxStatusDescription;
              InvestorModel.setReviewModalData(data);
            }
            if(vm.taxStatusList[vm.currentJointHolder].length && vm.taxStatusList[vm.currentJointHolder].length == 1 && !vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.taxStatusCode && !vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].nriFlag) {
              var data = InvestorModel.getReviewModalData();
              vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.taxStatusCode = vm.taxStatusList[vm.currentJointHolder][0].taxStatusCode;
              data.holders[vm.currentJointHolder].taxStatusDescription = vm.taxStatusList[vm.currentJointHolder][0].taxStatusDescription;
              InvestorModel.setReviewModalData(data);
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };

      var payloadTaxStatus = {
        taxStatusFilter: minorCheckParams ? 'MINOR' : 'ADULT',
      };
      if(fromHolder){
        payloadTaxStatus.nriFlag = vm.formData.folioCreationRequestCO.jointHolders.length > 0 && typeof vm.formData.folioCreationRequestCO.jointHolders[index].nriFlag == 'boolean'? vm.formData.folioCreationRequestCO.jointHolders[index].nriFlag: null;
      } else {
        payloadTaxStatus.nriFlag = typeof vm.formData.folioCreationRequestCO.nriFlag == 'boolean'? vm.formData.folioCreationRequestCO.nriFlag: null;
      }
      InvestorsService.post({controller: 'tax-status'}, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);


    }

    function occupationLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.occupationList = resp.data.investorOccupations;
            vm.screenTab.responseDataStorage.occupationList = vm.occupationList;
            InvestorModel.setInvestorFolioModal(vm.screenTab);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({controller: 'get-occupation'}, {}).$promise.then(success, error);
    }

    function getTaxIdType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.taxIdTypeList = resp.data.taxIdTypeResponses;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({controller: 'taxId-type'}, {}).$promise.then(success, error);
    }

    function getRelationshipList() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.relationshipsList = resp.data.nomineeRelationshipList;
            vm.guardianRelationShipList= resp.data.guardianRelationshipList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorsCommonService.get({child1: 'nominee', child2: 'relation'}, {}).$promise.then(success, error);
    }


    function incomeSlab() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.incomeSlabList = resp.data.incomeSlabList;
            vm.screenTab.responseDataStorage.incomeSlabList = vm.incomeSlabList;
            InvestorModel.setInvestorFolioModal(vm.screenTab);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({controller: 'income', child1: 'slab'}, {}).$promise.then(success, error);
    }

    function modelEmptyCheck() {/*!vm.formData.folioCreationRequestCO.soleApplicantDetail.dob ||*/
      if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber) {
        $state.go('main.dashboard');
      }
    }

    function addressTypeLookup() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.addressDescriptions = resp.data.addressTypeResponses;
            if(!vm.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType) {
              var fatcaAdressSelected = vm.addressDescriptions.filter(function (fatcaAdress) {
                return fatcaAdress.value === "RESIDENTIAL";
              });
              vm.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
            }
            if(vm.addressDescriptions && vm.addressDescriptions.length > 0 && vm.formData.folioCreationRequestCO.jointHolders.length > 0 && !vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.taxStatusCode && !vm.screenTab.responseDataStorage.isFromFolio) {
              var data = InvestorModel.getReviewModalData();
              var fatcaAdressSelected = vm.addressDescriptions.filter(function (fatcaAdress) {
                return fatcaAdress.value === "RESIDENTIAL";
              });
              vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
              data.holders[0].fatcaAddressType = vm.addressDescriptions[0].value;
              InvestorModel.setReviewModalData(data);
            }
            vm.screenTab.responseDataStorage.addressDescriptions = vm.addressDescriptions;
            InvestorModel.setInvestorFolioModal(vm.screenTab);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({controller: 'address', child1: 'type'}, {}).$promise.then(success, error);
    }

    function disabled() {
      return false;
    }

    function fileTaxAction() {
      if (!vm.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia) {
        vm.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses || [];
        vm.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
      }

    }

    function fileTaxActionJointHolder(index) {

      if (!vm.formData.folioCreationRequestCO.jointHolders[index].jointHolderApplicantDetail.payTaxInIndia) {
        vm.formData.folioCreationRequestCO.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.formData.folioCreationRequestCO.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
        vm.formData.folioCreationRequestCO.jointHolders[index].jointHolderApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
      }

    }

    function fileTaxActionGuardianDetails() {
      if (vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia) {
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses = [{}];
      } else {
        var array = vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.splice(0, array.length);
      }
    }

    function addMoreTaxResidency() {
      var array = vm.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
    }

    function addMoreTaxResidencyGD() {

      var array = vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
    }

    function addMoreTaxResidencyJointHolder() {
      var array = vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.length < 3 ? array.push({}) : '';
    }

    function deleteTaxResidency(index) {
      var array = vm.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function deleteTaxResidencyGD(index) {
      var array = vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function checkDuplicateNomineePan(index,pan,guardianPan) {

      for(var i=0;i<vm.formData.folioCreationRequestCO.nominees.length;i++) {
        if (vm.formData.folioCreationRequestCO.nominees[i].nomineePan == "") {
          vm.formData.folioCreationRequestCO.nominees[i].nomineePanInvalid = false;
        }
      }
      if (vm.formData.folioCreationRequestCO.nominees[index].nomineePan == pan) {
        if (vm.formData.folioCreationRequestCO.nominees.length > 0) {
          vm.formData.folioCreationRequestCO.nominees[index].nomineePanInvalid = false;
          if((vm.formData.folioCreationRequestCO.nominees[index].nomineePan && !vm.isPanVerified) || (vm.formData.folioCreationRequestCO.nominees[index].nomineePan=='' && !vm.isPanVerified) ) {
            checkUniqueGuardianPan(index, guardianPan, true);

          }
        }
      }
      if (vm.formData.folioCreationRequestCO.nominees.nomineePan == pan) {
        if (vm.formData.folioCreationRequestCO.nominees.length == 1) {
          vm.formData.folioCreationRequestCO.nominees[index].nomineePanInvalid = false;
        }
      }
      else if (vm.formData.folioCreationRequestCO.nominees.nomineePan !== pan) {
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (i !== index && vm.formData.folioCreationRequestCO.nominees[index].nomineePan) {
            if (vm.formData.folioCreationRequestCO.nominees[i].nomineePan == pan) {
              vm.formData.folioCreationRequestCO.nominees[index].nomineePanInvalid = true;
              vm.formData.folioCreationRequestCO.nominees[i].nomineePanInvalid = false;
              vm.errorMessage= vm.validateData.UNIQUE_NOMINEE_PAN;
              break;
            }
            else if (vm.formData.folioCreationRequestCO.nominees[i].nomineePan !== pan) {
              vm.formData.folioCreationRequestCO.nominees[index].nomineePanInvalid = false;
            }
          }
        }
        for(var i=0;i<vm.formData.folioCreationRequestCO.nominees.length;i++){
          if(vm.headerDetails.pan==vm.formData.folioCreationRequestCO.nominees[i].nomineePan){
            vm.formData.folioCreationRequestCO.nominees[i].nomineePanInvalid = true;
            vm.errorMessage= vm.validateData.NOMINEE_SAME_INVESTOR;
          }
        }
      }
      vm.formData.folioCreationRequestCO.nominees[index].identityProofNumber = pan;


      if (!vm.formData.folioCreationRequestCO.nominees[index].identityProofObj) {
        vm.formData.folioCreationRequestCO.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.folioCreationRequestCO.nominees[index].identityProofType
        })
      }

      vm.formData.folioCreationRequestCO.nominees[index].identityProofCamsCode = angular.copy(vm.formData.folioCreationRequestCO.nominees[index].identityProofObj.identityProofCamsCode);
      checkUniqueGuardianPan(index,guardianPan,false);
    }

    function checkUniqueGuardianPan(index,guardianPan,value){
      if(value)
      {
        vm.formData.folioCreationRequestCO.nominees[index].verifiedPan=true;
      }
         if(vm.formData.folioCreationRequestCO.nominees.nomineePan !== guardianPan)
      {
        vm.formData.folioCreationRequestCO.nominees[index].guardianPanInvalid = false;
        for(var i = 0 ; i < vm.formData.folioCreationRequestCO.nominees.length ; i ++) {
            if( i==index && vm.formData.folioCreationRequestCO.nominees[i].nomineePan == guardianPan && vm.formData.folioCreationRequestCO.nominees[i].nomineePan !== "") {
              vm.formData.folioCreationRequestCO.nominees[index].guardianPanInvalid = true;
              vm.errorMessageGuardian= vm.validateData.GUARDIAN_SAME_NOMINEE;
              vm.isPanVerified=false;
              break;
            }
            else if(vm.formData.folioCreationRequestCO.nominees[i].guardianPan !== guardianPan && vm.formData.folioCreationRequestCO.nominees[i].guardianPan)
            {
              vm.formData.folioCreationRequestCO.nominees[index].guardianPanInvalid = false;
            }
        }
        if(value){
          var success=function (resp){
            if(resp.data && resp.status){
              vm.isPanVerified=resp.data.panVerifiedFlag;
            } else{
              vm.isPanVerified=true;
              MessageService.error(resp.message);
              vm.formData.folioCreationRequestCO.nominees[index].verifiedPan=false;
              vm.errorMessageGuardian=resp.message;
            }
          },error=function (resp){
            MessageService.error(resp.message);
          };
          if( vm.formData.folioCreationRequestCO.nominees[index].guardianPan !== '' && vm.formData.folioCreationRequestCO.nominees[index].guardianPanInvalid==false
            && vm.formData.folioCreationRequestCO.nominees[index].guardianPan) {
            InvestorsCommonService.post({
              child1: 'guardian',
              child2: 'verifyPan'
            }, {pan: guardianPan}).$promise.then(success, error);
          }
        }
      }
    }

    function buttonEnable(){
      for(var i=0;i<vm.formData.folioCreationRequestCO.nominees.length;i++){
        if(vm.formData.folioCreationRequestCO.nominees[i].nomineePan){
          if(vm.formData.folioCreationRequestCO.nominees[i].nomineePanInvalid){
            vm.nomineePanValidCheck=true;
            return vm.nomineePanValidCheck;
          }
        }
      }
      for(var i=0;i<vm.formData.folioCreationRequestCO.nominees.length;i++){
        if(vm.formData.folioCreationRequestCO.nominees[i].guardianPan){
          if(vm.formData.folioCreationRequestCO.nominees[i].guardianPanInvalid){
            vm.guardianPanValidCheck=true;
            return vm.guardianPanValidCheck;
          }
        }
      }
      for(var i=0;i<vm.formData.folioCreationRequestCO.nominees.length;i++){
        if(vm.formData.folioCreationRequestCO.nominees[i].guardianPan){
          if(!vm.formData.folioCreationRequestCO.nominees[i].verifiedPan){
            vm.guardianPanValidCheck=true;
            return vm.guardianPanValidCheck;
          }
        }
      }

      if(vm.formData.folioCreationRequestCO.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (vm.formData.folioCreationRequestCO.nominees[i].aadharCard) {
            if (vm.formData.folioCreationRequestCO.nominees[i].nomineeAadharInvalid) {
              return true;
            }
          }
        }
      }

      if(vm.formData.folioCreationRequestCO.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (vm.formData.folioCreationRequestCO.nominees[i].drivingLicense) {
            if (vm.formData.folioCreationRequestCO.nominees[i].nomineeDLInvalid) {
              return true;
            }
          }
        }
      }

      if(vm.formData.folioCreationRequestCO.showNomineeUpdate) {
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (vm.formData.folioCreationRequestCO.nominees[i].passport) {
            if (vm.formData.folioCreationRequestCO.nominees[i].nomineePassportInvalid) {
              return true;
            }
          }
        }
      }
      return false;
    }

    function confirmCancelModal() {
      InvestorModel.setInvestorModel(vm.formData);
      $window.sessionStorage.investorForm = angular.toJson(vm.formData);
      var success = function () {
        vm.formData = InvestorModel.getInvestorModel();
        vm.formData.folioCreationRequestCO.addNomineeLater = vm.formData.folioCreationRequestCO.addNomineeLater ? vm.formData.folioCreationRequestCO.addNomineeLater : false;
        InvestorModel.setInvestorModel(vm.formData);
        $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        InvestorModel.setTab({tab2: true, tabJointHolderAddable: true});
        vm.tabEnable = InvestorModel.getTab();
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.nominee');
        } else {
          $state.go('main.investors.add.nominee');
        }
      }, error = function (val) {
        if(val == 'ok') {
          vm.formData.folioCreationRequestCO.addNomineeLater = true;
        }else {
          vm.formData.folioCreationRequestCO.addNomineeLater = vm.formData.folioCreationRequestCO.addNomineeLater ? vm.formData.folioCreationRequestCO.addNomineeLater : false;
        }
          InvestorModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.bankdetails');
          } else {
              if(val == 'ok'){
                $state.go('main.investors.add.bankdetails');
              }else if(val == 'close'){
                if($state.current.name == 'main.investors.add.jointholders'){
                  $state.go('main.investors.add.jointholders');
                }else if($state.current.name == 'main.investors.add.appdetails'){
                  $state.go('main.investors.add.appdetails');
                }
              }
          }
      };
      ModalService.confirmCancelModal({Text: 'Do you want to add a Nominee ?', fromFolioCreation: vm.formData.folioCreationRequestCO.addNomineeLater, buttonText : 'OK', isOptOutDec : vm.dynamicDataForOptOutDec, forFolioCreation : true}, success, error);
    }

    function submitApplicantDetails() {
      if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor){
        var soleapplicantdetails=angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail);
        // soleapplicantdetails.name=vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.name;
        soleapplicantdetails.dob=vm.formData.folioCreationRequestCO.soleApplicantDetail?vm.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob:'';
        soleapplicantdetails.minor=false;
        soleapplicantdetails.panNumber=vm.formData.folioCreationRequestCO.soleApplicantDetail?vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber:"";
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails=soleapplicantdetails;
      }

      InvestorModel.setInvestorModel(vm.formData);
      $window.sessionStorage.investorForm = angular.toJson(vm.formData);
      if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
        // $state.go('main.investors.add.guardianDetails');
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.bankdetails');
        } else {
          $state.go('main.investors.add.bankdetails');
        }
      } else {
        if (vm.formData.folioCreationRequestCO.holdMode !== vm.CONST.INVESTOR_HOLD_MODE.AOS) {
          if ((!vm.formData.folioCreationRequestCO.nominees || vm.formData.folioCreationRequestCO.nominees.length == 0) && !vm.formData.folioCreationRequestCO.addNomineeLater) {
            confirmCancelModal();
          }
          else if (vm.formData.folioCreationRequestCO.nominees.length == 0) {
            confirmCancelModal();
          }
          else {
            if (identifierData && identifierData.loginType == 'A') {
              $state.go('agent.home.investors.add.nominee');
            } else {
              $state.go('main.investors.add.nominee');
            }
          }
        } else {
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.jointholders');
          } else {
            $state.go('main.investors.add.jointholders');
          }
        }
      }
    }

    function submitHoldmode() {
      InvestorModel.setInvestorModel(vm.formData);
      $window.sessionStorage.investorForm = angular.toJson(vm.formData);
      getFolioList(function(){
        if(vm.folioList && vm.folioList.length > 0) {
          var success = function (resp) {
            if (resp === 'SELECT_NEW') {
              vm.screenTab.responseDataStorage.isFromFolio = true;
              InvestorModel.setInvestorFolioModal(vm.screenTab);
              // InvestorModel.resetFolioModalTab();
              proceedToFolioSelection(function () {
                if (identifierData && identifierData.loginType == 'A') {
                  $state.go('agent.home.investors.add.appdetails');
                } else {
                  $state.go('main.investors.add.appdetails');
                }
              });
            } else {
              createNewFolio();
            }
          }, error = function () {
          };
          ModalService.fillFolioDetailsModal({
            text: AppConstants.ToastrMessage.VALIDATE_DATA.FILL_FOLIO_DETAILS,
            journey: 'FOLIO_CREATION',
            isFromPostLogin: true
          }, success, error);
        } else {
          createNewFolio();
        }
      })
    }

    function submitGuardianDetails() {
      confirmCancelModal();
    }

    function addJointHolderTab() {
      vm.tabEnable = InvestorModel.getTab();
      if (vm.tabEnable.tab2) {
        // InvestorModel.setTab({tab3: true});
        // vm.tabEnable = InvestorModel.getTab();
        $state.go('main.investors.add.jointholders');
      }
    }

    function deleteTaxResidencyJointHolder(parentIndex, index) {
      var array = vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
      array.splice(index, 1);
    }

    function addMoreJointHolder() {
      var array = vm.formData.folioCreationRequestCO.jointHolders || [];

      if (vm.formData.folioCreationRequestCO.jointHolders[vm.parentIndex].jointHolderName) {
        if (array.length < 2) {
          var blankObj = InvestorModel.getNewJointHolder();
          array.push(blankObj);
          InvestorModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        }
        else {
          array.length = 0;
        }
        vm.currentJointHolder++;
        pan4JointHolders();

      }
      else {
        //angular.element('#nomineeName-'+vm.parentIndex).focus();
        //MessageService.error("please enter joint holder name");
      }

    }

    function deleteCurrentJointHolder(parentIndex) {
      var success = function () {
        var model = vm.formData.folioCreationRequestCO.jointHolders || [];
        model.splice(parentIndex, 1);
        if(parentIndex == 0){
          vm.currentJointHolder = 0;
        } else {
          vm.currentJointHolder = (parentIndex * 1) - 1;
        }
        vm.taxStatusList.splice(parentIndex, 1);
        if (model.length == 0) {
          vm.formData.folioCreationRequestCO.jointHolders = [];
          InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
          InvestorModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
          $state.go('main.investors.add.appdetails');
        } else {
          InvestorModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        }
        checkValid2ndHolder(model);
      };
      ModalService.confirmCancelModal({Text: 'Do you want to delete ' + vm.enum[parentIndex+1] + ' Holder?'}, success);
    }

    function switchHolder(index) {
      vm.currentJointHolder = index;
    }

    function switchNominee(index,pan,guardianPan,drivingLicense,aadharCard, passport) {
      vm.currentNominee = index;
      vm.parentIndex = index;
      if (vm.formData.folioCreationRequestCO.nominees.length == 0) {
        vm.nomineePropertion.min = 0;
        vm.nomineePropertion.max = 100;
      }
      else {
        var tempProportion = 0;
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (i != vm.currentNominee && vm.formData.folioCreationRequestCO.nominees[i].percentage) {
            tempProportion = tempProportion + vm.formData.folioCreationRequestCO.nominees[i].percentage;
          }
        }
        vm.nomineePropertion.max = 100 - tempProportion;
        vm.defaultDateNominee = vm.formData.folioCreationRequestCO.nominees[index].dob ?
          vm.formData.folioCreationRequestCO.nominees[index].dob : null; //(moment());
        vm.formData.folioCreationRequestCO.nominees[index].verifiedPan=true;
        if (pan) {
          vm.checkDuplicateNomineePan(index,pan);
        }

        if (guardianPan) {
          vm.checkUniqueGuardianPan(index,guardianPan,true);
        }
        if(vm.formData.folioCreationRequestCO.showNomineeUpdate) {
          changeDrivingLicense(index, drivingLicense);
          changeAadharCard(index, aadharCard);
          changePassport(index, passport);
        }
      }
      var currentDate = Date();
      var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
      var initiateDate = new Date('January 01, 1900 00:00:00');
      vm.isMinordataMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
      vm.isMinordataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
      vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
      vm.dataMinDate = $window.moment(Date.parse(initiateDate));
      vm.defaultDateNominee = vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  ? vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  : null;
    }

    function onChangePercentage(index) {
      if (vm.formData.folioCreationRequestCO.nominees.length == 0) {
        vm.nomineePropertion['min-0'] = 0;
        vm.nomineePropertion['max-0'] = 100;
      }
      else {
        var tempProportion = 0, totalProportion = 0;
        for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
          if (i != index && vm.formData.folioCreationRequestCO.nominees[i].percentage) {
            tempProportion = tempProportion + vm.formData.folioCreationRequestCO.nominees[i].percentage;
          }
          if(vm.formData.folioCreationRequestCO.nominees[i].percentage) {
            totalProportion += (vm.formData.folioCreationRequestCO.nominees[i].percentage) * 1;
          }
        }
        vm.showAddNomineeLink = (totalProportion < 100);
        vm.nomineePropertion['max-' + index] = 100 - tempProportion;
      }
    }

    function addMoreNominee() {
      var array = vm.formData.folioCreationRequestCO.nominees || [];
      vm.parentIndex = array.length - 1;
      var totalPropotion = 0;
      array.map(function (ele) {
        if (parseInt(ele.percentage)) {
          totalPropotion += ele.percentage * 1;
        }
      });
      if (totalPropotion >= 100) {
        MessageService.error("Proportion % has been alloted full.");
      } else {
        if (vm.formData.folioCreationRequestCO.nominees[vm.parentIndex] && vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].nomineeName
          && vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].percentage
        /*&& vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].nomineeRelation*/
        ) {
          if (array.length < vm.allowedNomineeLength) {
            array.push({});
            InvestorModel.setInvestorModel(vm.formData);
            $window.sessionStorage.investorForm = angular.toJson(vm.formData);
            vm.defaultDateNominee = null; //new Date();
          } else {
            array.length = 0;
          }
          vm.currentNominee++;
          checkNomineeIsMinor(array.length-1);
        } else {
          angular.element('#nomineeName-' + vm.parentIndex).focus();
          MessageService.error("Please enter valid nominee details");
        }
        if (vm.formData.folioCreationRequestCO.nominees.length == 0) {
          vm.nomineePropertion.min = 0;
          vm.nomineePropertion.max = 100;
        } else {
          var tempProportion = 0;
          for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
            if (vm.formData.folioCreationRequestCO.nominees[i].percentage) {
              tempProportion = tempProportion + vm.formData.folioCreationRequestCO.nominees[i].percentage;
            }
          }
          vm.nomineePropertion.max = 100 - tempProportion;
        }
      }
    }

    function deleteCurrentNominee(index) {
      var array = vm.formData.folioCreationRequestCO.nominees || [];
      array.splice(index, 1);
      vm.currentNominee = (vm.currentNominee > 0 && vm.currentNominee == index) ? (vm.currentNominee - 1) : 0;

      if (array.length == 0) {
        vm.formData.folioCreationRequestCO.nominees = [];
        InvestorModel.setInvestorModel(vm.formData);
        $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        $state.go('main.investors.add.appdetails');
      }
      singleNomineePan();
      changeNomineeName(index);
    }

    function pan4JointHolders() {
      var addFlag = true;
      var successPanDetails = function (result) {
          if (result.status && result.data && result.data.kycverified) {
            if (vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber != result.data.pan) {
              angular.forEach(vm.formData.folioCreationRequestCO.jointHolders, function (val) {
                if (val.jointHolderApplicantDetail.panNumber == result.data.pan) {
                  MessageService.error("Valid PAN details required to add joint holder");
                  addFlag = false;
                  vm.formData.folioCreationRequestCO.jointHolders.splice(vm.currentJointHolder, 1);
                  --vm.currentJointHolder;
                }
              });

              if (addFlag) {

                var newModel = InvestorModel.getNewJointHolder();
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder] = newModel;
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderName = result.data.name;
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].email = result.data.email;
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.panNumber = result.data.pan;
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].mobileNo = result.data.mobileNoWithoutMask;
                vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].nriFlag = !result.data.taxStatusResident;

                checkValid2ndHolder(vm.formData.folioCreationRequestCO.jointHolders);

                var successTaxStatus = function (resp) {
                    if (resp.status && resp.data) {
                      vm.taxStatusList = resp.data.taxStatus;
                      if(!vm.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType) {
                        var taxStatusSelected = vm.addressDescriptions.filter(function (country) {
                          return country.value === "RESIDENTIAL";
                        });
                        vm.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = taxStatusSelected[0];
                      }
                      if(vm.taxStatusList.length && vm.taxStatusList.length > 0 && !vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.taxStatusCode) {
                        var data = InvestorModel.getReviewModalData();
                        vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.taxStatusCode = vm.taxStatusList[0].taxStatusCode;
                        data.holders[1].taxStatusDescription = vm.taxStatusList[0].taxStatusDescription;
                        InvestorModel.setReviewModalData(data);
                      }
                      if(vm.countryList && vm.countryList.length > 0 && vm.formData.folioCreationRequestCO.jointHolders.length > 0 && !vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.birthCountry){
                        var data = InvestorModel.getReviewModalData();
                        var countrySelected = vm.countryList.filter(function(country) {
                          return country.countryCode === "IN";
                        });
                        vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.birthCountry = countrySelected[0].countryName;
                        data.holders[1].birthCountry = countrySelected[0].countryName;
                        InvestorModel.setReviewModalData(data);
                      }

                      if(vm.addressDescriptions && vm.addressDescriptions.length > 0 && vm.formData.folioCreationRequestCO.jointHolders.length > 0 && !vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.fatcaAddressType) {
                        var data = InvestorModel.getReviewModalData();
                        var fatcaAdressSelected = vm.addressDescriptions.filter(function (fatcaAdress) {
                          return fatcaAdress.value === "RESIDENTIAL";
                        });
                        vm.formData.folioCreationRequestCO.jointHolders[1].jointHolderApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
                        data.holders[1].fatcaAddressType = vm.addressDescriptions[0].value;
                        InvestorModel.setReviewModalData(data);
                      }
                      if(vm.taxStatusList[vm.currentJointHolder].length && vm.taxStatusList[vm.currentJointHolder].length == 1 && vm.formData.folioCreationRequestCO.jointHolders.length == 2 && !vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.taxStatusCode && !vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].nriFlag) {
                        var data = InvestorModel.getReviewModalData();
                        vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.taxStatusCode = vm.taxStatusList[vm.currentJointHolder][0].taxStatusCode;
                        data.holders[vm.currentJointHolder].taxStatusDescription = vm.taxStatusList[vm.currentJointHolder][0].taxStatusDescription;
                        InvestorModel.setReviewModalData(data);
                      }
                      InvestorModel.setInvestorModel(vm.formData);
                      $window.sessionStorage.investorForm = angular.toJson(vm.formData);
                      $window.scrollTo(0, 0);
                    } else {
                      MessageService.error(resp.message);
                    }
                  },
                  errorTaxStatus = function (err) {
                    UtilService.errorHandler(err);
                  };

                var payloadTaxStatus = {
                  taxStatusFilter: result.data.minor ? 'MINOR' : 'ADULT',
                  nriFlag: vm.formData.folioCreationRequestCO.jointHolders.length > 0 && typeof vm.formData.folioCreationRequestCO.jointHolders[1].nriFlag == 'boolean'?  vm.formData.folioCreationRequestCO.jointHolders[1].nriFlag == false? false: true : null

                };
                InvestorsService.post({controller: 'tax-status'}, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);

              }

            } else {
              vm.formData.folioCreationRequestCO.jointHolders.splice(vm.currentJointHolder, 1);
              --vm.currentJointHolder;
              MessageService.error("Valid PAN details required to add joint holder");
            }
          } else {
            MessageService.error(result.message || 'Kyc verification is pending.');
          }
        },
        errorPanDetails = function () {
          vm.formData.folioCreationRequestCO.jointHolders.splice(vm.currentJointHolder, 1);
          --vm.currentJointHolder;
          InvestorModel.setInvestorModel(vm.formData);
          $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        };
      var labelSetter = {type: 'jointholders', label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}}
      ModalService.checkPanJointHolder(labelSetter, successPanDetails, errorPanDetails);
    }

    function submitJointHolder() {
      if(vm.formData.folioCreationRequestCO.nominees.length && vm.screenTab.responseDataStorage.isFromFolio){
        $state.go('main.investors.add.nominee');
      } else {
        confirmCancelModal();
      }
      /*if (vm.formData.folioCreationRequestCO.jointHolders.length < 2) {
        var success = function () {
          addMoreJointHolder();
        },cancel = function () {
        };
        ModalService.confirmCancelModal({Text: 'Do you want to add more holder?'}, success, cancel);
      } else {
        confirmCancelModal();
      }*/
    }

    function submitNominee() {
      if (!vm.formData.folioCreationRequestCO.addNomineeLater) {
        var array = vm.formData.folioCreationRequestCO.nominees || [];
        if (array[0] && array[0].nomineeName) {
          var totalPropotion = 0;
          array.map(function (ele) {
            if (parseInt(ele.percentage)) {
              totalPropotion += ele.percentage * 1;
            }
          });
          if (totalPropotion != 100) {
            angular.element('#percentage-' + vm.parentIndex).focus();
            MessageService.error("Sum of percentage proportion of all nominees should be equal to 100%.");
          } else {
            InvestorModel.setInvestorModel(vm.formData);
            $window.sessionStorage.investorForm = angular.toJson(vm.formData);
            if (identifierData && identifierData.loginType == 'A') {
              $state.go('agent.home.investors.add.bankdetails');
            } else {
              $state.go('main.investors.add.bankdetails');
            }
          }
        } else {
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.bankdetails');
          } else {
            $state.go('main.investors.add.bankdetails');
          }
        }
      }
      else {
        vm.formData.folioCreationRequestCO.nominees = [];
        InvestorModel.setInvestorModel(vm.formData);
        $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.investors.add.bankdetails');
        } else {
          $state.go('main.investors.add.bankdetails');
        }
      }
    }

    function changeStartDate(date) {
      if (date && date._i) {
        vm.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = date._i;
        vm.defaultDateNetWorthDate = date;
      }
    }

    vm.resetNetWorthDateFlag = true;

    vm.showMessage = function () {
      if (vm.validationMsg) {
        MessageService.error(vm.validationMsg);
      }
      vm.formData.folioCreationRequestCO.nominees[index].verifiedPan=true;
    };
    vm.resetNetWorthDate = function () {
      vm.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = '';
      angular.element('#soleNetWorthDate2').val('');
    };

    vm.resetNetWorthDateG = function () {
      // vm.resetNetWorthDateFlag = false;
      // vm.guardianDetailsNetWorthDate = '';
      vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate = '';
      angular.element('#guardianDetailsNetWorthDate').val('');
      /*$timeout(function () {
        // vm.guardianDetailsNetWorthDate = new Date();
        // vm.resetNetWorthDateFlag = true;
      },0)*/
    }

    vm.setOptionalEmptyG = function (flag) {

      if (flag == 'GrossAnnualIncome') {
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth = '';
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate = '';
        vm.resetNetWorthDateG();
      } else if (flag == 'NetWorth') {
        vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome = '';
      }
    }

    vm.changeNomineeDob = function (date) {
      vm.modalData = {};
      vm.modalData.dob = date && date._i ? date._i : '';
    };

    function changeNetWorthDate(date) {
      vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate = date && date._i ? date._i : '';
    }

    function changeStartDateJointHolder(date) {

      if (date && date._i) {
      vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.netWorthDate = date && date._i ? date._i : '';
      vm.defaultDateNetWorthDate = date.toString();
      }
    }


    function checkAddNominee() {
      if (vm.formData.folioCreationRequestCO.addNomineeLater) {
        vm.currentNominee = 0;
        vm.parentIndex = 0;
        InvestorModel.setInvestorModel(vm.formData);
        $window.sessionStorage.investorForm = angular.toJson(vm.formData);
      }
    }

    function changeStartDateNominee(date) {
      vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob = "";
      if (date && date._i) {
        vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob = $window.moment(date, 'YYYY-MM-DD').format("DD-MMM-YYYY");
        vm.defaultDateNominee = vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  ? vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  : null;
      }else{
        vm.defaultDateNominee =  null;
      }
      var currentDate = (new Date()).getTime();
      var selectedDate = (new Date(date._d)).getTime();
      var diff = Math.abs(currentDate - selectedDate);
      // vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].minor = diff < (18 * 365 * 24 * 60 * 60 * 1000);
      // if(vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].minor == false){
      //   vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianPan =null;
      //   vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianRelation = null;
      //   vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianName = null;
      // }
      if(vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob){
        vm.dobRequired = false;
      }
      if(vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].minor){
        if(vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob){
          vm.dobRequired = false;
        }else{
          vm.dobRequired = true;
        }
      }
    }

    function goPrevious(togo) {
      switch (togo) {
        case 'nominee':
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.nominee');
          } else {
            $state.go('main.investors.add.nominee');
          }
          break;
        case 'jointHolders':
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.jointholders');
          } else {
            $state.go('main.investors.add.jointholders');
          }
          break;
        case 'soleApplicant':
          if (identifierData && identifierData.loginType == 'A') {
            $state.go('agent.home.investors.add.appdetails');
          } else {
            $state.go('main.investors.add.appdetails');
          }
          break;
      }
    }

    function minorCheck(index) {
      if (vm.formData.folioCreationRequestCO.nominees[index]) {
        if (!vm.formData.folioCreationRequestCO.nominees[index].minor) {
          vm.formData.folioCreationRequestCO.nominees[index].nomineeGuardianAddress = {};
        }
      }
    }

    function selectBirthCity(_data) {
      vm.formData.folioCreationRequestCO.soleApplicantDetail.birthCity = _data.cityName;
    }

    function selectHolderBirthCity(_data, holder) {
      holder.jointHolderApplicantDetail.birthCity = _data.cityName;
    }

    function selectNomineeBirthCity(_data, nomineeData) {
      nomineeData.nomineeAddress.city = _data.cityName;
    }

    function selectGuardianBirthCity(_data) {
      vm.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCity = _data.cityName;
    }

    vm.changedTaxStatus = function () {
      var data = InvestorModel.getReviewModalData();
      if($state.current.name === 'agent.home.investors.add.appdetails' || $state.current.name === 'main.investors.add.appdetails'){
        var taxStatus = vm.taxStatusList.filter(function (data) {
          if (vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode == data.taxStatusCode) {
            return data;
          }
        });
        data.taxStatusDescription = taxStatus.length>0?taxStatus[0].taxStatusDescription:'';
      }else{
        (angular.isUndefined(data.holders)) && (data.holders = [{},{}]);
        taxStatus = vm.taxStatusList[vm.currentJointHolder].filter(function (data) {
          if (vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail &&
            vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.taxStatusCode == data.taxStatusCode) {
            return data;
          }
        });
        data.holders[vm.currentJointHolder].taxStatusDescription = taxStatus.length>0?taxStatus[0].taxStatusDescription:'';
      }
      InvestorModel.setReviewModalData(data);
      if (vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode == "21" || vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode == "24") {
        vm.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia = false;
      } else {
        vm.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia = true;
      }
      if($state.current.name !== 'main.investors.add.jointholders' && $state.current.name !== 'agent.home.investors.add.jointholders') {
        vm.fileTaxAction();
      }
      //InvestorModel.setReviewModalData(data);
      vm.formData.folioCreationRequestCO.bankDetails
      && (vm.formData.folioCreationRequestCO.bankDetails.accountType = '');
    };

    vm.setOccuValidation=function () {
      var data = InvestorModel.getReviewModalData();
      if($state.current.name === 'agent.home.investors.add.appdetails' || $state.current.name === 'main.investors.add.appdetails'){
        var occupation= vm.occupationList.filter(function (data) {
        if(vm.formData.folioCreationRequestCO.soleApplicantDetail.occupation==data.occupationCode){
          return data;
        }
      });
       data.occupationDescription = occupation.length>0?occupation[0].occupationDescription:'';
      }else{
      (data.holders == undefined) && (data.holders = [{},{}]);
        occupation = vm.occupationList.filter(function (data) {
          if (vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail &&
            vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.occupation === data.occupationCode) {
            return data;
          }
        });
        data.holders[vm.currentJointHolder].occupationDescription=occupation.length>0?occupation[0].occupationDescription:'';}
      InvestorModel.setReviewModalData(data);
    };

    vm.setAnnualIncome = function () {
      var data = InvestorModel.getReviewModalData();
      if($state.current.name === 'agent.home.investors.add.appdetails' || $state.current.name === 'main.investors.add.appdetails'){var income= vm.incomeSlabList.filter(function (data) {
        if(vm.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome==data.incomeCode){
          return data;
        }
      });
       data.incomeDescription = income.length>0?income[0].incomeDescription:'';
      }else{
      (data.holders == undefined) && (data.holders = [{},{}]);
        income = vm.incomeSlabList.filter(function (data) {
          if (vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail &&
            vm.formData.folioCreationRequestCO.jointHolders[vm.currentJointHolder].jointHolderApplicantDetail.grossAnnualIncome === data.incomeCode) {
            return data;
          }
        });
        data.holders[vm.currentJointHolder].incomeDescription=income[0]&& income[0].incomeDescription
      ?income[0].incomeDescription:'';
      }
      InvestorModel.setReviewModalData(data);
    };

    vm.cancelTransaction = function () {
      var success = function () {
        InvestorModel.setInvestorModel(null);
        $window.sessionStorage.investorForm = null;
        InvestorModel.resetTab();
        if (identifierData && identifierData.loginType == 'A') {
          $state.go('agent.home.distributor-home');
        } else {
          $state.go('main.dashboard');
        }
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Do you want to cancel this action ?'}, success, error);
    };

    vm.goToAppDetails = function () {
      if (identifierData && identifierData.loginType == 'A') {
        $state.go('agent.home.investors.add.appdetails');
      } else {
        vm.formData.folioCreationRequestCO.addNomineeLater = vm.formData.folioCreationRequestCO.addNomineeLater ? vm.formData.folioCreationRequestCO.addNomineeLater: false;
        InvestorModel.setInvestorModel(vm.formData);
        $window.sessionStorage.investorForm = angular.toJson(vm.formData);
        $state.go('main.investors.add.appdetails');
      }
    };

    vm.setMinorFlag = function(){

      if(vm.formData.folioCreationRequestCO.nriFlag == true) {
        ModalService.genericModal({
          text: "Only Self Folio can be created"
        }, function () {
          vm.formData.folioCreationRequestCO.soleApplicantDetail.minor = false;
        }, function () {
        });
      } else {
        if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
          vm.formData.folioCreationRequestCO.holdMode = vm.CONST.INVESTOR_HOLD_MODE.SINGLE;
          vm.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob = vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
          delete vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
        }
        vm.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode = '';
      }

    };

    $scope.nominees = vm.formData.folioCreationRequestCO.nominees;
    $scope.$watch('nominees', function (newValue) {
      if(angular.isUndefined(scope.nomineeForm) || scope.nomineeForm.$valid){vm.validationMsg = '';return;}
      var formFieldList = scope.nomineeForm.$error.required;

      if (angular.isArray(formFieldList) && formFieldList.length > 0) {
        var formTypeArray = formFieldList.map(function (ele) {
          if(ele.$name) {
            return ele.$name.split('-')[1]
          }
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
        var nomineeList = [];
        angular.forEach(formTypeArray, function (val) {
          switch (val) {
            case "0":
              nomineeList.push('First Nominee Details');
              break;
            case "1":
              nomineeList.push('Second Nominee Details');
              break;
            case "2":
              nomineeList.push('Third Nominee Details');
              break;
            case "3":
              nomineeList.push('Fourth Nominee Details');
              break;
            case "4":
              nomineeList.push('Fifth Nominee Details');
              break;
            case "5":
              nomineeList.push('Sixth Nominee Details');
              break;
            case "6":
              nomineeList.push('Seventh Nominee Details');
              break;
            case "7":
              nomineeList.push('Eighth Nominee Details');
              break;
            case "8":
              nomineeList.push('Ninth Nominee Details');
              break;
            case "9":
              nomineeList.push('Tenth Nominee Details');
              break;
            default:
              vm.validationMsg = '';
          }
        });
        vm.validationMsg = setMsg(nomineeList);
      } else {
        vm.validationMsg = '';
      }
    }, true);

    function setMsg(list) {
      var msg = 'Please complete the ';
      var array = angular.copy(list);
      if (array.length == 0) {
        return '';
      }
      else if (array.length == 1) {
        return msg + array.join(',');
      }
      else if (array.length > 1) {
        var listLast = array.pop();
        return msg + array.join(' , ') + ' and ' + listLast + ' Details';
      }
    }

    function resetNumInWords() {
      vm.amountInWords = '';
      var inWordsDiv = $window.document.getElementById('DisplayWordsTaxAmount');
      if (inWordsDiv) {
        inWordsDiv.innerHTML = '(In Words)';
      }
    }

    function singleNomineePan(){
      if(vm.formData.folioCreationRequestCO.nominees.length == 1) {
        if (vm.formData.folioCreationRequestCO.nominees[0].nomineePan && (vm.headerDetails.pan == vm.formData.folioCreationRequestCO.nominees[0].nomineePan)) {
          vm.formData.folioCreationRequestCO.nominees[0].nomineePanInvalid = true;
          vm.errorMessage = "You cannot add yourself as Nominee"
        }
        else if(vm.formData.folioCreationRequestCO.nominees[0].nomineePan && vm.formData.folioCreationRequestCO.nominees[0].guardianPan && (vm.formData.folioCreationRequestCO.nominees[0].nomineePan==vm.formData.folioCreationRequestCO.nominees[0].guardianPan)){
          vm.formData.folioCreationRequestCO.nominees[0].guardianPanInvalid=true;
        }
        else {
          vm.formData.folioCreationRequestCO.nominees[0].nomineePanInvalid = false;
          vm.formData.folioCreationRequestCO.nominees[0].guardianPanInvalid = false;
        }
      }
    }

    vm.changeNomineeSelectedCountry = function(index,countryCode){
      if (!countryCode) {
        vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.state = null;
        vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.country = null;
      }
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.country = country.countryCode;
          vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.countryName = country.countryName;

          if (vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.country != 'IN'){
            for(var i = 0; i<vm.stateList.length; i++){
              if (vm.stateList[i].stateCode == 'XX'){
                vm.formData.folioCreationRequestCO.nominees[index].nomineeAddress.state = vm.stateList[i].stateCode;
                break;
              }
            }
          }
        }
      });
    }
    function setOptionalEmptyJH(flag) {
      if (flag == 'GrossAnnualIncome') {
       vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorth = '';
       vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorthDate = '';
       vm.defaultDateNetWorthDate = null ;
      } else if (flag == 'NetWorth') {
       vm.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.grossAnnualIncome = '';
      }
    }




    vm.changeSelectedCountry = function(index,countryCode){
      var getDataFromResp = InvestorModel.getInvestorFolioModal();
      if (!countryCode) {
        vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.state = null;
        vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.country = null;
      }
      vm.countryList = vm.countryList? vm.countryList: getDataFromResp.responseDataStorage.countryList;
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.country = country.countryCode;
          vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.countryName = country.countryName;
          if (vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.country != 'IN'){
            for(var i = 0; i<vm.stateList.length; i++){
              if (vm.stateList[i].stateCode == 'XX'){
                vm.formData.folioCreationRequestCO.nominees[index].guardianAddress.state = vm.stateList[i].stateCode;
                break;
              }
            }
          }
        }
      });
    }

    function checkDecimal(event){
      if(event.key==='.') {
        event.preventDefault();
      }
    }

    function onPaste(event){
      event.preventDefault();
    }

    function checkValid2ndHolder(obj){
      vm.notValid2ndHolder=false;
      for(var i =0; i<obj.length;i++){
        if(!obj[i].email && !obj[i].mobileNumber){
          vm.notValid2ndHolder=true;
        }
      }
    }
    vm.changeNomineeIsMinor = function(index){
      vm.defaultDateNominee = null;
      vm.formData.folioCreationRequestCO.nominees[index].dob = "";
      vm.dataMinDate = "";
      vm.dataMaxDate = "";
      vm.isMinordataMinDate = "";
      vm.isMinordataMaxDate = "";
      $timeout(function () {
        if(vm.formData.folioCreationRequestCO.nominees[index].minor){
          vm.dobRequired = true;
        }else{
          vm.dobRequired = false;
        }
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.isMinordataMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.isMinordataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
        vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMinDate = $window.moment(Date.parse(initiateDate));
        vm.defaultDateNominee = vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  ? vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  : null;
        if (vm.formData.folioCreationRequestCO.nominees[index].minor) {
          vm.formData.folioCreationRequestCO.nominees[index].minor = true;
          vm.formData.folioCreationRequestCO.nominees[index].panNumber = null;
        } else {
          vm.formData.folioCreationRequestCO.nominees[index].minor = false;
          vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianPan =null;
          vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianRelation = null;
          vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].guardianName = null;
        }
        var tempObj = vm.formData.folioCreationRequestCO;
        vm.formData.folioCreationRequestCO = "";
        vm.formData.folioCreationRequestCO = tempObj;
        checkNomineeIsMinor(vm.currentNominee);
        changeNomineeName(vm.currentNominee,vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].nomineeName);
      }, 1000);
    }
    vm.setInitiatedDate = function(){
      $timeout(function () {
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
        vm.isMinordataMinDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.isMinordataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
        vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
        vm.dataMinDate = $window.moment(Date.parse(initiateDate));
        vm.defaultDateNominee = vm.formData.folioCreationRequestCO.nominees.length >0 && vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  ? vm.formData.folioCreationRequestCO.nominees[vm.currentNominee].dob  : null;
      }, 1000);
    }
    vm.setInitiatedDate();

    function proceedToFolioSelection(cb) {
      cb = cb || function () {
      }
      var success = function (resp) {
        vm.folioNumberFromModal = sessionStorage.setItem('folioNumberFromModal',resp);
        $timeout(function(){
          fetchFolioData(resp);
        },100)

        cb(true);
      }, error = function () {};
      ModalService.selectFolioModal({
        minor: vm.formData.folioCreationRequestCO.soleApplicantDetail.minor,
        panNumber: vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber,
        folioList: vm.folioList
      }, success, error);
    }
    function fetchFolioData(folio) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.selectedFolioData = resp.data;

          $timeout(function(){
            if(vm.selectedFolioData){
              createNewFolio();
              autoPrefilledData(vm.selectedFolioData);
            }
          },500)

        } else {
          MessageService.error("Something went wrong")
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err)
      };
      var payload  = {
        panNumber: vm.headerDetails.pan,
        folioNumber: folio
      }
      InvestorsCommonService.post({
        child1: 'getFolioDetails'
      },payload).$promise.then(success, error);
    }

    function autoPrefilledData(folioData){
      var data = InvestorModel.getReviewModalData();
      var getDataFromResp = InvestorModel.getInvestorFolioModal();
      var folioModelData = {
        "folioCreationRequestCO": {
          "holdMode": vm.formData.folioCreationRequestCO.holdMode,
          "bankDetails": {
            "accountHolderName":"",
            "accountNumber": folioData.bankDetails && folioData.bankDetails.accountNumber,
            "accountType": folioData.bankDetails && folioData.bankDetails.accountType,
            "bankName": folioData.bankDetails && folioData.bankDetails.bankName,
            "bankCity": folioData.bankDetails && folioData.bankDetails.bankCity,
            "bankBranch": folioData.bankDetails && folioData.bankDetails.bankBranch,
            "branchLocation": folioData.bankDetails && folioData.bankDetails.bankBranch,
            "ifsccode": folioData.bankDetails && folioData.bankDetails.ifsccode,
            "micrnumber": "",
            "verifyAccountNumber": "",
            "payoutMechanism": folioData.bankDetails && folioData.bankDetails.payoutMechanism,
            "mobileNumber":"",
            "email":"",
            "throughPennyDrop":folioData.bankDetails && folioData.bankDetails.pennyDropValid
          },
          "jointHolders": [],
          "nominees": folioData.nominees ? folioData.nominees :[],
          "guardianDetails": {},
          "soleApplicantDetail": {
            "birthCity": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.birthPlace,
            "birthCountry": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.birthCountry,
            "minorName": folioData.soleApplicantDetail.personalDetail && folioData.soleApplicantDetail.personalDetail.firstName,
            "dob": folioData.soleApplicantDetail.personalDetail.dateOfBirth,
            "email": folioData.soleApplicantDetail.personalDetail.email,
            "mobileNo": folioData.soleApplicantDetail.personalDetail.mobileNo,
            "oldemail" : folioData.soleApplicantDetail.personalDetail.email ? angular.copy(folioData.soleApplicantDetail.personalDetail.email) : "",
            "oldmobileNo" :  folioData.soleApplicantDetail.personalDetail.mobileNo ? angular.copy(folioData.soleApplicantDetail.personalDetail.mobileNo) : "",
            "minor": folioData.minor,
            "minorAgeProof": folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.minorAgeProof,
            "fatcaAddressType": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.addressType,
            "occupation": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.occupation,
            "panNumber": vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber,
            "payOutsideIndiaAddresses": [],
            "payTaxInIndia": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.payTaxInIndia,
            "politicalStatus": folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.politicalStatus,
            "taxStatusCode": folioData.soleApplicantDetail.personalDetail.taxStatusCode,
            "gender": folioData.soleApplicantDetail.personalDetail.gender == 'MALE'? vm.genderList[0].key: vm.genderList[1].key,
            "name": vm.formData.folioCreationRequestCO.soleApplicantDetail.name
          }
        },
        "toPanVerify": true
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.grossAnnualIncome){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome = folioData.soleApplicantDetail.selfDetail.grossAnnualIncome;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorth = '';
        folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = '';
      } else if(folioData.soleApplicantDetail.selfDetail){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorth = folioData.soleApplicantDetail.selfDetail.netWorth;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = folioData.soleApplicantDetail.selfDetail.netWorthDate;
      }

      if(vm.taxStatusList && folioModelData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode){
        var taxStatusSelected = vm.taxStatusList.filter(function(taxStatus) {
          return taxStatus.taxStatusCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode;
        });
        folioModelData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode = taxStatusSelected.length>0 ?taxStatusSelected[0].taxStatusCode:'01';
      }

      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.birthCountry && getDataFromResp.responseDataStorage.countryList){
        var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
          return country.countryCode === folioData.soleApplicantDetail.selfDetail.fatca.birthCountry;
        });
        folioModelData.folioCreationRequestCO.soleApplicantDetail.birthCountry = countrySelected[0];
      } else {
        if (vm.countryList && vm.countryList.length > 0) {
          var countrySelected = vm.countryList.filter(function(country) {
            return country.countryCode === "IN";
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.birthCountry = countrySelected[0];
        }
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.addressType && getDataFromResp.responseDataStorage.addressDescriptions){
        var fatcaAdressSelected = getDataFromResp.responseDataStorage.addressDescriptions.filter(function(country) {
          return country.value === folioData.soleApplicantDetail.selfDetail.fatca.addressType;
        });
        folioModelData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
      } else {
        var fatcaAdressSelected = vm.addressDescriptions.filter(function (fatcaAdress) {
          return fatcaAdress.value === "RESIDENTIAL";
        });
        folioModelData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
      }
      if(folioData.minor){
        folioModelData.folioCreationRequestCO.guardianDetails.relationship =  folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.relation;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.occupation = folioData.soleApplicantDetail.minorDetail.guardian.occupation;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome = folioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome = folioData.soleApplicantDetail.minorDetail.guardian.grossAnnualIncome;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorth = '';
          folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = '';
        } else if(folioData.soleApplicantDetail.minorDetail.guardian.netWorth){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorth = folioData.soleApplicantDetail.minorDetail.guardian.netWorth;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.netWorthDate = folioData.soleApplicantDetail.minorDetail.guardian.netWorthDate;
        }
        folioModelData.folioCreationRequestCO.soleApplicantDetail.politicalStatus = folioData.soleApplicantDetail.minorDetail.guardian.politicalStatus;
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.addressType && getDataFromResp.responseDataStorage.addressDescriptions){
          var fatcaAdressSelected = getDataFromResp.responseDataStorage.addressDescriptions.filter(function(country) {
            return country.addressDescription === folioData.soleApplicantDetail.minorDetail.guardian.fatca.addressType;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry && getDataFromResp.responseDataStorage.countryList){
          var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
            return country.countryCode === folioData.soleApplicantDetail.minorDetail.guardian.fatca.birthCountry;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.birthCountry = countrySelected[0];
        }
        folioModelData.folioCreationRequestCO.soleApplicantDetail.birthCity = folioData.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia = folioData.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia;
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({});
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax2){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({},{});
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax3){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({},{},{});
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountry;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdNumber = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxIdType;
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country && getDataFromResp.responseDataStorage.countryList){
            var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
              return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country = countrySelected[0];
          }
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType && vm.taxIdTypeList){
            var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
              return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType = taxIdType[0];
          }
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax2){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax2.taxPayingCountry;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdNumber = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax2.taxId;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxIdType;
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country && getDataFromResp.responseDataStorage.countryList){
            var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
              return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country = countrySelected[0];
          }
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType && vm.taxIdTypeList){
            var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
              return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType = taxIdType[0];
          }
        }
        if(folioData.soleApplicantDetail.minorDetail && folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax3){
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax3.taxPayingCountry;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdNumber = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax3.taxId;
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType = folioData.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxIdType;
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country && getDataFromResp.responseDataStorage.countryList){
            var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
              return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country = countrySelected[0];
          }
          if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType && vm.taxIdTypeList){
            var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
              return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType;
            });
            folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType = taxIdType[0];
          }
        }
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.dob) {
          var formateDob = $window.moment(folioModelData.folioCreationRequestCO.soleApplicantDetail.dob);
          changeMinorDob(formateDob);
        }
        folioModelData.folioCreationRequestCO.soleApplicantDetail.guardianDob = vm.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.dob = vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
      }

      if(!folioModelData.folioCreationRequestCO.nominees){
        vm.formData.folioCreationRequestCO.nominees.push(InvestorModel.getNewNominee());
      }

      if(vm.formData.folioCreationRequestCO.holdMode !== 'ANY_OR_SURVIVOR'){
        if(folioData.jointHolders){
          var newModel = InvestorModel.getNewJointHolder();
          // folioData.jointHolders.forEach(function(emptyHolder,index){
          //   folioModelData.folioCreationRequestCO.jointHolders[index] = newModel;
          //   InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
          // });
          folioModelData.folioCreationRequestCO.jointHolders = [];
          InvestorModel.setTab({tab3: false, tabJointHolderAddable: false});
        }
      } else {
        if(folioData.jointHolders && folioData.jointHolders.length > 0) {
          var data = InvestorModel.getReviewModalData();
          (data.holders == undefined) && (data.holders = [{},{}]);
          var newModel = InvestorModel.getNewJointHolder();
          folioData.jointHolders.forEach(function(emptyHolder,index){
            folioModelData.folioCreationRequestCO.jointHolders[index] = newModel;
          });

          folioData.jointHolders.forEach(function(holder, index){
            var newJointHolder = {
              jointHolderName: folioData.jointHolders[index].firstName,
              email: folioData.jointHolders[index].email,
              jointHolderApplicantDetail: {
                panNumber: folioData.jointHolders[index].pan,
                occupation: folioData.jointHolders[index].occupationCode,
                politicalStatus : folioData.jointHolders[index].politicalStatus,
                fatcaAddressType: folioData.jointHolders[index].fatcaDetail.addressType,
                birthCountry: folioData.jointHolders[index].fatcaDetail.birthCountry,
                birthCity: folioData.jointHolders[index].fatcaDetail.birthPlace,
                payTaxInIndia: true,
                payOutsideIndiaAddresses: [],
                // payTaxInIndia: folioData.jointHolders[index].fatcaDetail.payTaxInIndia
                taxStatusCode: folioData.jointHolders[index].taxStatusCode? folioData.jointHolders[index].taxStatusCode: '01'
              },
              mobileNo: folioData.jointHolders[index].mobileNumber,
            };
            if(folioData.jointHolders[index].grossAnnualIncome){
              newJointHolder.jointHolderApplicantDetail.grossAnnualIncome = folioData.jointHolders[index].grossAnnualIncome;
              newJointHolder.jointHolderApplicantDetail.netWorth = '';
              newJointHolder.jointHolderApplicantDetail.netWorthDate = '';
            } else {
              newJointHolder.jointHolderApplicantDetail.netWorth = folioData.jointHolders[index].netWorth;
              newJointHolder.jointHolderApplicantDetail.netWorthDate = folioData.jointHolders[index].netWorthDate;
              newJointHolder.jointHolderApplicantDetail.grossAnnualIncome = '';
            }
            if(folioData.jointHolders && folioData.jointHolders[index].fatcaDetail.birthCountry && getDataFromResp.responseDataStorage.countryList){
              var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
                return country.countryName === folioData.jointHolders[index].fatcaDetail.birthCountry;
              });
              if(countrySelected && countrySelected.length > 0 && countrySelected[0].countryName) {
                newJointHolder.jointHolderApplicantDetail.birthCountry = countrySelected[0].countryName;
                data.holders[index].birthCountry = countrySelected[0].countryName;
              }
            } else {
              newJointHolder.jointHolderApplicantDetail.birthCountry = "INDIA";
              data.holders[index].birthCountry = "INDIA";
            }

            if(folioData.jointHolders && folioData.jointHolders[index].fatcaDetail.addressType && getDataFromResp.responseDataStorage.addressDescriptions){
              var fatcaAdressSelected = getDataFromResp.responseDataStorage.addressDescriptions.filter(function(country) {
                return country.value === folioData.jointHolders[index].fatcaDetail.addressType;
              });
              newJointHolder.jointHolderApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
              data.holders[index].fatcaAddressType = fatcaAdressSelected[0].value;
            } else {
              if(getDataFromResp.responseDataStorage.addressDescriptions && getDataFromResp.responseDataStorage.addressDescriptions.length > 0 && folioData.jointHolders.length > 0) {
                var fatcaAdressSelected = vm.addressDescriptions.filter(function (fatcaAdress) {
                  return fatcaAdress.value === "RESIDENTIAL";
                });
                newJointHolder.jointHolderApplicantDetail.fatcaAddressType = fatcaAdressSelected[0];
              }
            }
            var occupation = getDataFromResp.responseDataStorage.occupationList.filter(function (data) {
              if (newJointHolder.jointHolderApplicantDetail.occupation === data.occupationCode) {
                return data;
              }
            });
            var income = getDataFromResp.responseDataStorage.incomeSlabList.filter(function (data) {
              if (newJointHolder.jointHolderApplicantDetail.grossAnnualIncome === data.incomeCode) {
                return data;
              }
            });
            data.holders[index].incomeDescription=income[0]&& income[0].incomeDescription
              ?income[0].incomeDescription:'';

            data.holders[index].occupationDescription=occupation.length>0?occupation[0].occupationDescription:'';

            // if (!newJointHolder.jointHolderApplicantDetail.payTaxInIndia) {
            //   newJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses = [{}];
            // } else if(newJointHolder.jointHolderApplicantDetail.payTaxInIndia && (newJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses && newJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length > 0)){
            //   var array = newJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses || [];
            //   newJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses.splice(0, array.length);
            // }


            folioModelData.folioCreationRequestCO.jointHolders.splice(index, 1, newJointHolder);
          });
          checkValid2ndHolder(folioModelData.folioCreationRequestCO.jointHolders);
          InvestorModel.setReviewModalData(data);
        }
      }


      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({});
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax2){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({},{});
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax3){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses = [];
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.push({},{},{});
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountry;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdNumber = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType;
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country && getDataFromResp.responseDataStorage.countryList){
          var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
            return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].country = countrySelected[0];
        }

        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType && vm.taxIdTypeList){
          var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
            return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdType = taxIdType[0];
        }

      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax2){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax2.taxPayingCountry;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdNumber = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax2.taxId;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType;
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country && getDataFromResp.responseDataStorage.countryList){
          var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
            return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].country = countrySelected[0];
        }
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType && vm.taxIdTypeList){
          var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
            return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[1].taxIdType = taxIdType[0];
        }
      }
      if(folioData.soleApplicantDetail.selfDetail && folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax3){
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax3.taxPayingCountry;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdNumber = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax3.taxId;
        folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType = folioData.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxIdType;
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country && getDataFromResp.responseDataStorage.countryList){
          var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
            return country.countryCode === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].country = countrySelected[0];
        }
        if(folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType && vm.taxIdTypeList){
          var taxIdType = vm.taxIdTypeList.filter(function(taxType) {
            return taxType.code === folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType;
          });
          folioModelData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[2].taxIdType = taxIdType[0];
        }
      }
      folioModelData.folioCreationRequestCO.nominees.forEach(function(nominee) {
        nominee.guardianPan = nominee.guardianPanNumber;
        nominee.nomineePan = nominee.panNumber;

        if (nominee.identityProofType && nominee.identityProofType === 'PASSPORT') {
          nominee.passport = nominee.identityProofNumber;
        }

        if (nominee.identityProofType && nominee.identityProofType === 'AADHAR_CARD') {
          nominee.aadharCard = nominee.identityProofNumber;
        }


        if (nominee.identityProofType && nominee.identityProofType === 'DRIVING_LICENSE') {
          nominee.drivingLicense = nominee.identityProofNumber;
        }

      });
      folioModelData.folioCreationRequestCO.nriFlag = vm.formData.folioCreationRequestCO.nriFlag;
      folioModelData.folioCreationRequestCO.showNomineeUpdate = angular.copy(vm.formData.folioCreationRequestCO.showNomineeUpdate);
      folioModelData.folioCreationRequestCO.nomineeLimit = angular.copy(vm.formData.folioCreationRequestCO.nomineeLimit);
      folioModelData.folioCreationRequestCO.nomination =  vm.formData && vm.formData.folioCreationRequestCO && vm.formData.folioCreationRequestCO.nomination ? angular.copy(vm.formData.folioCreationRequestCO.nomination) : true;
      folioModelData.folioCreationRequestCO.nomineeRegistrationCO = angular.copy(vm.formData.folioCreationRequestCO.nomineeRegistrationCO);

      InvestorModel.setInvestorModel(folioModelData);
      $window.sessionStorage.investorForm = angular.toJson(folioModelData);
      vm.formData = InvestorModel.getInvestorModel();
      vm.formData.folioCreationRequestCO.soleApplicantDetail.email = folioModelData.folioCreationRequestCO.soleApplicantDetail.email ? angular.copy(folioModelData.folioCreationRequestCO.soleApplicantDetail.email) : "";
      vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo = folioModelData.folioCreationRequestCO.soleApplicantDetail.mobileNo ? angular.copy(folioModelData.folioCreationRequestCO.soleApplicantDetail.mobileNo) : "";


      if(folioModelData.folioCreationRequestCO.nominees && folioModelData.folioCreationRequestCO.nominees.length > 0){
        folioModelData.folioCreationRequestCO.nominees.forEach(function(nominee,index){
          if(nominee.dob) {
            vm.currentNominee = index;
            changeStartDateNominee($window.moment(nominee.dob));
            if(nominee.guardianAddress.country) {
              vm.changeSelectedCountry(index, nominee.guardianAddress.country.toUpperCase());
            }
          } else {
            vm.formData.folioCreationRequestCO.nominees[index].dob = "";
          }
          vm.formData.folioCreationRequestCO.nominees[index].guardianRelation = nominee.guardianRelationWithNominee;

          if(nominee.nomineeAddress && nominee.nomineeAddress.country && getDataFromResp.responseDataStorage.countryList && nominee.nomineeAddress.country.length > 2){
            var countrySelected = getDataFromResp.responseDataStorage.countryList.filter(function(country) {
              return country.countryName === nominee.nomineeAddress.country.toUpperCase();
            });
            nominee.nomineeAddress.country = countrySelected ? countrySelected[0].countryCode : nominee.nomineeAddress.country;
            nominee.nomineeAddress.countryName = countrySelected[0].countryName;
          } else {
            var countryCode = nominee.nomineeAddress.country ?  nominee.nomineeAddress.country : 'IN';
            if (vm.countryList && vm.countryList.length > 0) {
              nominee.nomineeAddress.country = countryCode;
              var countrySelected = vm.countryList.filter(function(country) {
                return country.countryName === nominee.nomineeAddress.country.toUpperCase();
              });
              nominee.nomineeAddress.countryName = countrySelected[0].countryName;
            }
          }

        })

        vm.formData.folioCreationRequestCO.nominees = angular.copy(vm.selectedFolioData.nominees);
      }


      if($state.current.name === 'main.investors.add.appdetails') {
        var occupation = getDataFromResp.responseDataStorage.occupationList.filter(function (data) {
          if (vm.formData.folioCreationRequestCO.soleApplicantDetail.occupation == data.occupationCode) {
            return data;
          }
        });
        data.occupationDescription = occupation.length > 0 ? occupation[0].occupationDescription : '';
      }
      InvestorModel.setReviewModalData(data);
      if(vm.incomeSlabList) {
        vm.setAnnualIncome();
      }
      // vm.changedTaxStatus();

      updateValues();
    }

    function getFolioList(cb) {
      cb = cb || function () {
      };
      LoaderService.showLoader();
      var success = function(resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          var folioList = resp.data.folioList || [];
          var folio = [];
          var filteredFolioList = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            obj.minorFlag = item.minorFlag;
            obj.taxstatus = item.taxstatus;
            obj.holdMode = item.holdMode;
            folio.push(obj);
          }
          // vm.folioList = folio;
          Object.keys(folio).forEach(function (key) {
            var obj = Object.assign({key: key}, folio[key]);
            if (vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
              if (obj.minorFlag) {
                filteredFolioList.push(angular.copy(obj));
              }
            } else if(obj.holdMode === 'ANY_OR_SURVIVOR' && vm.formData.folioCreationRequestCO.holdMode === vm.CONST.INVESTOR_HOLD_MODE.AOS){
              filteredFolioList.push(angular.copy(obj));
            } else if(obj.holdMode !== 'ANY_OR_SURVIVOR' && vm.formData.folioCreationRequestCO.holdMode !== vm.CONST.INVESTOR_HOLD_MODE.AOS) {
              if (!obj.minorFlag) {
                filteredFolioList.push(angular.copy(obj));
              }
            }
          });
          vm.folioList = filteredFolioList.length ? filteredFolioList : null;
          cb();
        } else {
          vm.folioList = null;
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        vm.folioList = null;
        UtilService.errorHandler(err);
      };
      InvestorsCommonService.post({
        child1: 'getFolioList'
      },{panNumber: vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber}).$promise.then(success, error);
    }

    function createNewFolio(){
      vm.screenTab.responseDataStorage.isFromFolio = false;
      InvestorModel.setInvestorFolioModal(vm.screenTab);
      sessionStorage.removeItem('folioNumberFromModal');
      // InvestorModel.resetFolioModalTab();
      InvestorModel.resetInvestorModel();
      var model = InvestorModel.getNewInvestorModel();
      model.folioCreationRequestCO.holdMode = vm.formData.folioCreationRequestCO.holdMode;
      model.folioCreationRequestCO.soleApplicantDetail.name = vm.formData.folioCreationRequestCO.soleApplicantDetail.name;
      model.folioCreationRequestCO.soleApplicantDetail.dob = vm.formData.folioCreationRequestCO.soleApplicantDetail.dob;
      model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.formData.folioCreationRequestCO.soleApplicantDetail.panNumber;
      model.folioCreationRequestCO.soleApplicantDetail.minor = vm.formData.folioCreationRequestCO.soleApplicantDetail.minor;
      model.folioCreationRequestCO.soleApplicantDetail.email = vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail ? vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail : vm.formData.folioCreationRequestCO.soleApplicantDetail.email;
      model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo ? vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo : vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo;
      model.folioCreationRequestCO.soleApplicantDetail.oldemail = angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail.oldemail);
      model.folioCreationRequestCO.soleApplicantDetail.oldmobileNo =  angular.copy(vm.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo);
      model.folioCreationRequestCO.showNomineeUpdate = angular.copy(vm.formData.folioCreationRequestCO.showNomineeUpdate);
      model.folioCreationRequestCO.nomineeLimit = angular.copy(vm.formData.folioCreationRequestCO.nomineeLimit);
      model.folioCreationRequestCO.nomination = vm.formData && vm.formData.folioCreationRequestCO && vm.formData.folioCreationRequestCO.nomination ? angular.copy(vm.formData.folioCreationRequestCO.nomination) : true;
      model.folioCreationRequestCO.nomineeRegistrationCO = angular.copy(vm.formData.folioCreationRequestCO.nomineeRegistrationCO);

      if(vm.formData.folioCreationRequestCO.soleApplicantDetail.minor) {
        model.folioCreationRequestCO.soleApplicantDetail.guardianDob = vm.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob;
      }
      model.folioCreationRequestCO.nriFlag = typeof vm.formData.folioCreationRequestCO.nriFlag == 'boolean'? vm.formData.folioCreationRequestCO.nriFlag: null;
      InvestorModel.setInvestorModel(model);
      delete $window.sessionStorage.investorForm;
      $window.sessionStorage.investorForm = angular.toJson(model);

      if (identifierData && identifierData.loginType == 'A') {
        $state.go('agent.home.investors.add.appdetails');
      } else {
        $state.go('main.investors.add.appdetails');
      }
    }

    function updateContactInfo(changeType) {
      $window.sessionStorage.investorForm = $window.sessionStorage.investorForm ? $window.sessionStorage.investorForm : InvestorModel.getNewInvestorModel();
      var formData = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
      if(changeType === "email"){
        vm.formData.folioCreationRequestCO.soleApplicantDetail.email = angular.copy(formData.folioCreationRequestCO.soleApplicantDetail.email);
        vm.showEditMobile = false;
      }else if(changeType === "mobile"){
        vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo = angular.copy(formData.folioCreationRequestCO.soleApplicantDetail.mobileNo);
        vm.showEditEmail = false;
      }

    }


    function hideUiFnc(type) {
      if (type == 'email') {
        vm.hideEditEmail = true;
      } else if (type == 'mobile') {
        vm.hideEditMobile = true;
      }
    }

    function showUiFnc(type) {
      if (type == 'email') {
        vm.hideEditEmail = false;
      } else if (type == 'mobile') {
        vm.hideEditMobile = false;
      }
    }

    function updateValues() {
      $rootScope.$broadcast('formUpdated', vm.formData.folioCreationRequestCO.soleApplicantDetail);
    }

    function changeNomineeRelation(nomineeRelation, index) {
      if(nomineeRelation !== 'OTHERS') {
        vm.formData.folioCreationRequestCO.nominees[index].nomineeOtherRelation = null;
      }
    }

    function getIdentityProofList(cb) {
      cb = cb || function () {

      }
      // vm.applicantPersonalIdentifiers = [
      //   {
      //     "identityProofType": "Aadhar Card",
      //     "identityProofTypeCode": "AADHAR_CARD"
      //   },
      //   {
      //     "identityProofType": "Driving License",
      //     "identityProofTypeCode": "DRIVING_LICENSE"
      //   },
      //   {
      //     "identityProofType": "Pan Card",
      //     "identityProofTypeCode": "PAN_CARD"
      //   }
      // ]
      // vm.identityProofList = vm.applicantPersonalIdentifiers;
      //       cb(true);
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.applicantPersonalIdentifiers = resp.data.identityProofs;
            vm.identityProofList = vm.applicantPersonalIdentifiers;
            cb(true);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      InvestorCommonServiceVersion2.get({child1: 'identity-proofs'}, {}).$promise.then(success, error);
    }

    function changeNomineeIdentityProof(index,identifier){
      vm.applicantPersonalIdentifiers.map(function (el) {
        if (el.value === identifier) {
          vm.formData.folioCreationRequestCO.nominees[index].identityProofType = el.value;
        }
      });
      vm.formData.folioCreationRequestCO.nominees[index].nomineePan = '';
      vm.formData.folioCreationRequestCO.nominees[index].drivingLicense = '';
      vm.formData.folioCreationRequestCO.nominees[index].aadharCard = '';
      vm.formData.folioCreationRequestCO.nominees[index].passport = '';
      vm.formData.folioCreationRequestCO.nominees[index].identityProofObj = null;
    }

    function changeEmailId(index, emailId) {
      /*if (!emailId) {
        return;
      }
      if (vm.formData.folioCreationRequestCO.soleApplicantDetail.email && vm.formData.folioCreationRequestCO.soleApplicantDetail.email.toLowerCase() === vm.formData.folioCreationRequestCO.nominees[index].emailId.toLowerCase()) {
        vm.formData.folioCreationRequestCO.nominees[index].emailIdInvalid = true;
        vm.emailIdValid = false;
        vm.errorMessageEmail = vm.validateData.NOMINEE_EMAIL_SAME_AS_INVESTOR;
      } else {
        vm.formData.folioCreationRequestCO.nominees[index].emailIdInvalid = false;
        vm.emailIdValid = true;
        vm.errorMessageEmail = null;
      }*/
    }
    function changeMobileNumber(index, mobileNumber) {
      if (!mobileNumber) {
        return;
      }
      if (vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo && vm.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo === vm.formData.folioCreationRequestCO.nominees[index].mobileNumber) {
        vm.formData.folioCreationRequestCO.nominees[index].mobileInvalid = true;
        vm.mobileValid = false;
        vm.errorMessageMobile = vm.validateData.NOMINEE_MOBILE_SAME_AS_INVESTOR;
      } else {
        vm.formData.folioCreationRequestCO.nominees[index].mobileInvalid = false;
        vm.mobileValid = true;
        vm.errorMessageMobile = null;
      }
    }

    function changeDrivingLicense(index, drivingLicense) {
      checkDuplicateNomineeDL(index,drivingLicense)
    }

    function changeAadharCard(index, aadharCard) {
      checkDuplicateNomineeAadhaar(index,aadharCard);
    }

    function checkNomineeIsMinor(index) {
      var nominee = vm.formData.folioCreationRequestCO.nominees[index];
      nominee.identityProofList = [];
      if (nominee.minor) {
        for (var i = 0; i < vm.applicantPersonalIdentifiers.length; i++) {
          if (vm.applicantPersonalIdentifiers[i].identityProofType !== "DRIVING_LICENSE") {
            nominee.identityProofList.push(vm.applicantPersonalIdentifiers[i]);
          }
        }
      } else {
        nominee.identityProofList = vm.applicantPersonalIdentifiers.slice();
      }
    }

    function checkDuplicateNomineeDL(index, drivingLicense) {
      if (!drivingLicense) {
        return;
      }
      var nominees = vm.formData.folioCreationRequestCO.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].drivingLicense) {
          nominees[i].nomineeDLInvalid = false;
        }
      }
        for (var i = 0; i < nomineeCount; i++) {
          if (nominees[i].drivingLicense && drivingLicense && (i !== index && nominees[i].drivingLicense === drivingLicense)) {
            nominees[index].nomineeDLInvalid = true;
            nominees[i].nomineeDLInvalid = false;
            vm.errorMessageDLIdentity = vm.validateData.DRIVING_LICENSE_ALREADY_EXIST;
            return;
          }
        }
        nominees[index].nomineeDLInvalid = false;
        vm.formData.folioCreationRequestCO.nominees[index].identityProofNumber = drivingLicense;
        if (!vm.formData.folioCreationRequestCO.nominees[index].identityProofObj) {
          vm.formData.folioCreationRequestCO.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
            return el.identityProofType == vm.formData.folioCreationRequestCO.nominees[index].identityProofType
          })
        }

        vm.formData.folioCreationRequestCO.nominees[index].identityProofCamsCode = angular.copy(vm.formData.folioCreationRequestCO.nominees[index].identityProofObj.identityProofCamsCode);

    }

    function checkDuplicateNomineeAadhaar(index, aadharCard) {

      if (!aadharCard) {
        return;
      }

      var nominees = vm.formData.folioCreationRequestCO.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty aadharCard
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].aadharCard) {
          nominees[i].nomineeAadharInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].aadharCard && aadharCard && (i !== index && nominees[i].aadharCard === aadharCard)) {
          // nominees[index].nomineeAadharInvalid = true;
          nominees[i].nomineeAadharInvalid = false;
          // vm.errorMessageDLIdentity = vm.validateData.AADHAAR_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeAadharInvalid = false;
      vm.formData.folioCreationRequestCO.nominees[index].identityProofNumber = aadharCard;
      if (!vm.formData.folioCreationRequestCO.nominees[index].identityProofObj) {
        vm.formData.folioCreationRequestCO.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.folioCreationRequestCO.nominees[index].identityProofType
        })
      }

      vm.formData.folioCreationRequestCO.nominees[index].identityProofCamsCode = angular.copy(vm.formData.folioCreationRequestCO.nominees[index].identityProofObj.identityProofCamsCode);

    }

    function changeSelectedName(selectedName){
      if (!selectedName) {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = null;
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = null;
      }
      if(selectedName) {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber = selectedName.index + 1;
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeName = selectedName.nomineeName;
      }
    }

    vm.hasNomineeName = function () {
      if (!vm.formData.folioCreationRequestCO.nominees) {
        return false;
      }

      for (var i = 0; i < vm.formData.folioCreationRequestCO.nominees.length; i++) {
        if (vm.formData.folioCreationRequestCO.nominees[i].nomineeName) {
          return true;
        }
      }
      return false;
    };

    function changeNomineeName(index,nomineeName){
      var updated = false;

      for (var i = 0; i < vm.formData.folioCreationRequestCO.incapacitationNameList.length; i++) {
        if (vm.formData.folioCreationRequestCO.incapacitationNameList[i].index === index) {
          if (!nomineeName) {
            vm.formData.folioCreationRequestCO.incapacitationNameList.splice(i, 1);
          } else {
            vm.formData.folioCreationRequestCO.incapacitationNameList[i].nomineeCode = nomineeName + '-' + vm.enum[index];
            vm.formData.folioCreationRequestCO.incapacitationNameList[i].nomineeName = nomineeName;
            vm.formData.folioCreationRequestCO.incapacitationNameList[i].activeFlag = vm.formData.folioCreationRequestCO.nominees[index].minor;
          }
          updated = true;
          break;
        }
      }
      if (!updated && nomineeName) {
        vm.formData.folioCreationRequestCO.incapacitationNameList.push({
          "index": index,
          "nomineeCode": nomineeName + '-' + vm.enum[index],
          "nomineeName": nomineeName,
          "activeFlag": vm.formData.folioCreationRequestCO.nominees[index].minor
        });
      }
      //Sorting and check next element will align after delete
      vm.formData.folioCreationRequestCO.incapacitationNameList.sort(function (a, b) {
        return a.index - b.index;
      });
      for (var i = 0; i < vm.formData.folioCreationRequestCO.incapacitationNameList.length; i++) {
        vm.formData.folioCreationRequestCO.incapacitationNameList[i].index = i;
        vm.formData.folioCreationRequestCO.incapacitationNameList[i].nomineeCode = vm.formData.folioCreationRequestCO.incapacitationNameList[i].nomineeName + '-' + vm.enum[i];
      }
    }

    function setStatement() {
      /*vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration = [];
      if (vm.formData.folioCreationRequestCO.nomineeName) {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration.push('NAME_OF_NOMINEES');
      }
      if (vm.formData.folioCreationRequestCO.nomination) {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration.push('NOMINATION_YES');
      }*/
      if (vm.formData.folioCreationRequestCO.nomination) {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration = "NOMINATION_YES";
      } else {
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.accountHoldingDeclaration = "NOMINATION_NO";
      }

    }

    function changePercentageOrAmount(from){
      if(from === 'percentage'){
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount = null;
      }

      if(from === 'amount'){
        vm.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage = null;
      }
    }

    function changePassport(index, passport) {

      if (!passport) {
        return;
      }

      var nominees = vm.formData.folioCreationRequestCO.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineePassportInvalid for empty Passport
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].passport) {
          nominees[i].nomineePassportInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].passport && passport && (i !== index && nominees[i].passport === passport)) {
          nominees[index].nomineePassportInvalid = true;
          nominees[i].nomineePassportInvalid = false;
          vm.errorMessagePassportIdentity = vm.validateData.PASSPORT_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineePassportInvalid = false;
      vm.formData.folioCreationRequestCO.nominees[index].identityProofNumber = passport;
      if (!vm.formData.folioCreationRequestCO.nominees[index].identityProofObj) {
        vm.formData.folioCreationRequestCO.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.formData.folioCreationRequestCO.nominees[index].identityProofType
        })
      }

      vm.formData.folioCreationRequestCO.nominees[index].identityProofCamsCode = angular.copy(vm.formData.folioCreationRequestCO.nominees[index].identityProofObj.identityProofCamsCode);

    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DistributorBankUpdateController', distributorBankUpdateController);

  /** @ngInject */
  function distributorBankUpdateController($state, AppConstants, HDFC_API, ModalService, MessageService, LoaderService, UtilService, $window,
                                           InvestorsService, InvestorsCommonService, DownloadPdfService, FileUploadService, dynamicData, FileSaver) {
    var vm = this;
    var pennyDropEnablSelectedBank;
    vm.CONST = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.mimeType = ["image/jpeg","image/png", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
    vm.bankForm = {};
    vm.formData = {};
    vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
    vm.chooseAFileNew = true;
    vm.fileType = "";
    vm.isCheckedTandC = false;
    vm.isCheckedDeclaration = false;
    vm.init = init;
    vm.selectIFSC = selectIFSC;
    vm.validatePennyDrop = validatePennyDrop;
    vm.uploadFile = uploadFile;
    vm.downloadFile = downloadFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.submitBankForm = submitBankForm;
    vm.goBack = goBack;
    vm.tpv = tpv;
    vm.copyPasteHandler = copyPasteHandler;
    vm.cancelTransaction = cancelTransaction;
    vm.termsAndContitions = termsAndContitions;
    vm.accFocus = accFocus;
    vm.restrictAccountAsAlpha = restrictAccountAsAlpha;
    vm.enabledSubmitButton = true;
    vm.dynamicData = dynamicData;
    if(vm.dynamicData.noteDTO.noteDTOMap.Note_UPDATE_DISTRIBUTOR_BANK ) {
      vm.note = vm.dynamicData.noteDTO.noteDTOMap.Note_UPDATE_DISTRIBUTOR_BANK.content;
    }
    if(vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.UPDATE_DISTRIBUTOR_BANK_DECLARATION){
      vm.bank_Update_Declaration = vm.dynamicData.termAndConditionDTO.termAndConditionDTOMap.UPDATE_DISTRIBUTOR_BANK_DECLARATION.content;
    }
    if(vm.dynamicData.noteDTO.noteDTOMap.UPDATE_DISTRIBUTOR_BANK_SUCCESS) {
      vm.bank_Update_Confirmation = vm.dynamicData.noteDTO.noteDTOMap.UPDATE_DISTRIBUTOR_BANK_SUCCESS.content;
    }
    /*
    * Initial method to be invoked when bank-update.html initialised
    * */
    function init() {
      $window.scroll({
        top:0,
        left:0,
        behaviour:'smooth'
      });

      vm.distributorProfileInfo = JSON.parse(sessionStorage.getItem('distributorProfileInfo'));
      vm.fetchBankList();
      getAccountType();
    }

    /*
    * Function responsible to get account type list
    * */
    function getAccountType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.bankTypeList = resp.data.bankAccountTypes;
          if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
            var sbAccount = vm.bankTypeList.filter(function (e) {
              return e.accountTypeCode == "SB";
            });
            vm.formData.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
          }
        }
        else {
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        UtilService.errorHandler(err);
      };
      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        child2: 'list',
        child3: '01'//vm.formData.taxStatusCode
      }, {}).$promise.then(success, error);
    }

    /*
    * Function responsible to show select ifsc modal and pre fill the value
    * */
    function selectIFSC() {
      var successModal = function(data){
        vm.formData.bankDetails.ifsccode= data.ifscCode;
        vm.formData.bankDetails.bankName = data.bankName;
        vm.formData.bankDetails.bankCity = data.branchCity;
        vm.formData.bankDetails.branchLocation = data.branch;
        vm.formData.bankDetails.accountNumber = '';
        vm.formData.bankDetails.verifyAccountNumber = '';
        if(data.branchCity && data.branchCity.length>40) {
          vm.formData.bankDetails.bankBranch = data.branchCity.slice(0,40);
        } else {
          vm.formData.bankDetails.bankBranch = data.branchCity;
        }
        vm.formData.bankDetails.pennyDropValid = true;
        vm.enabledSubmitButton = true;
        pennyDropEnablSelectedBank = vm.formData.bankDetails.pennyDropValid;
        resetCheckLeaf();
        if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
          var sbAccount = vm.bankTypeList.filter(function (e) {
            return e.accountTypeCode == "SB";
          });
          vm.formData.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
        }
      };
      var errorModal = function(e){
        vm.showValidate = false;
      };
      ModalService.IFSCSelectionModal({bankList : vm.bankList}, successModal, errorModal);
    }

    function resetCheckLeaf() {
      vm.formData.chequeLeafUrl = "";
      vm.formData.chequeLeaf = "";
      vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
      vm.fileType = "";
      vm.chooseAFileNew = true;
      vm.isCheckedDeclaration = false;
      vm.isCheckedTandC = false;
      angular.element("#uploadFileId").val(null);
    }

    function validatePennyDrop() {
      var pennyDropValidatePayload = {
        beneficiaryIFSC:vm.formData.bankDetails.ifsccode,
        benificiaryAccountNo:vm.formData.bankDetails.accountNumber,
        benificiaryName:vm.distributorProfileInfo.name,
        arncode: vm.distributorProfileInfo.arnCode,
        panNo: vm.distributorProfileInfo.panNumber,
        bankUpdationForBroker: true
      };
      var success = function (resp) {
        vm.showValidate = false;
        if (resp.status && resp.data) {
          if(resp.data.valid === false) {
            MessageService.error(resp.data.message);
            vm.formData.bankDetails.pennyDropValid = false;
            pennyDropEnablSelectedBank = true;
            vm.enabledSubmitButton = false;
          } else {
            vm.formData.bankDetails.pennyDropValid = true;
            vm.formData.bankDetails.accountHolderName = resp.data.name;
            vm.enabledSubmitButton = false;
            submitBankForm();
          }
          vm.chooseAFileNew = true;
          LoaderService.hideLoader();
        } else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
      };
      LoaderService.showLoader();
      InvestorsCommonService.post({
        child1: 'account',
        child2: 'validate',
        child3: 'pennyDrop'
      }, pennyDropValidatePayload).$promise.then(success, error);
    }

    function uploadFile(file) {
      var fi = document.getElementById('uploadFileId');
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format not supported. Supported format are tiff, jpg, jpeg, png and pdf extension");
          resetCheckLeaf();
          return;
        }
        if (fi.files.item(0).size <= 3000000) {
          vm.myFile = file;
          vm.chequeLeaf = file.name ;
          var modalSuccess = function () {
            fileUploadMethod(file);
          }, modalError = function () {
            resetCheckLeaf();
          };
          if(file.type == 'application/pdf') {
            fileUploadMethod(file);
          } else {
            ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
          }
        } else{
          resetCheckLeaf();
          MessageService.error("File size should not be more than 3 MB.");
          vm.chooseAFileNew = true;
        }
      }
    }

    function getFileType(fileType) {
      return fileType.split('/')[1];
    }

    function openUploadedDoc() {
      if(angular.isUndefined(vm.formData.chequeLeafUrl)){return;}
      ModalService.imagePreviewModal({showOnly:true, file: vm.formData.chequeLeafUrl});
    }

    function downloadFile(url, fileType, proofType) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data) {
          var data = new Blob([resp.data], { type: 'application/'+fileType });
          FileSaver.saveAs(data, proofType+'.'+fileType);
        } else {
          MessageService.error('No Data Available');
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    /*
    * Function responsible for:
    * Submit the final form updated by distributor
    * Invoked from: After penny drop success and when distributor click on submit
    * */
    function submitBankForm() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          var resp = vm.bank_Update_Confirmation;
          var successModal = function () {
              $state.go('main.distributorProfile');
          }, errorModal = function () {
            $state.go('main.distributorProfile');
          };
          ModalService.addBankModal({modalPayload : {},fromUpdateBankDistributor:true,responseData: resp}, successModal, errorModal);
        }
        else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          } else {
            MessageService.error(resp.message);
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var payload = {
        "distributorDetails": {
          "bankDetails": {
            "bankName": vm.formData.bankDetails.bankName,
            "bankBranch": vm.formData.bankDetails.bankBranch,
            "bankAccType": vm.formData.bankDetails.accountType.accountTypeCode,
            "bankAccNo": vm.formData.bankDetails.accountNumber,
            "bankAddress1": vm.formData.bankDetails.bankCity,
            "ifscCode": vm.formData.bankDetails.ifsccode,
            "impsVerified": vm.formData.bankDetails.pennyDropValid == false ? "N": 'Y',
            "chequeImageUrl": vm.formData.bankDetails.pennyDropValid == false? vm.formData.chequeLeafUrl: null
          }
        }
      }
      InvestorsCommonService.post({
        child1: 'profile',
        child2: 'bank',
        child3: 'update',
      }, payload).$promise.then(success, error);

    }

    /*
    * Function responsible to redirect distributor to profile section
    * */
    function goBack() {
      $window.history.back();
    }

    /*
    * Function responsible:
    * confirm the user to cancel action
    * redirect distributor to dashboard
    * */
    function cancelTransaction() {
      var success = function () {
        $state.go('main.dashboard');
      }, error = function () {};
      ModalService.confirmCancelModal({Text: 'Do you want to cancel this action ?'}, success, error);
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function tpv($event) {
      $event.preventDefault();
      ModalService.tpvModal({});
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    vm.fetchBankList = function () {
      var success = function (res) {
        if (res.status && res.data) {
          vm.bankList = res.data.bankList;

        }
        else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        vm.bankList = null;
        UtilService.errorHandler(err);
      };

      InvestorsCommonService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
    }
    function accFocus() {
      vm.accModelDirty = true;
      vm.formData.chequeLeafUrl = '';
      vm.fileType = '';
      vm.formData.bankDetails.pennyDropValid = true;
      vm.enabledSubmitButton = true;
      angular.element("#uploadFileId").val(null);
    }

    function fileUploadMethod(file) {
      var taxIdentifierNumber = vm.distributorProfileInfo.panNumber;
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/profile/upload/'+taxIdentifierNumber+'/CHEQUE_LEAF';
      LoaderService.showLoader();
      FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.formData.chequeLeafUrl=resp.data.fileUrl;
          vm.fileType= getFileType(file.type);
          vm.chooseAFileNew = false;
        } else {
          resetCheckLeaf();
          MessageService.error(resp.message);
        }
      }, function () {
        resetCheckLeaf();
        LoaderService.hideLoader();
      });
    }

    function restrictAccountAsAlpha(accountNumber, from){
      var restrictAcc = /[^0-9]/g;
      if(from == 'AccountNum') {
        if (restrictAcc.test(accountNumber)) {
          vm.formData.bankDetails.accountNumber = vm.formData.bankDetails.accountNumber.substring(0,vm.formData.bankDetails.accountNumber.length - 1)
        }
      } else {
        if (restrictAcc.test(accountNumber)) {
          vm.formData.bankDetails.verifyAccountNumber = vm.formData.bankDetails.verifyAccountNumber.substring(0,vm.formData.bankDetails.verifyAccountNumber.length - 1)
        }
      }

      if(vm.formData.bankDetails.accountNumber) {
        var isEqual = compareStrings(vm.formData.bankDetails.accountNumber, vm.formData.bankDetails.verifyAccountNumber);
        if (!isEqual) {
          vm.bankForm.verifyAccountNumber.$error.pattern = true;
          vm.bankForm.verifyAccountNumber.$invalid = true;
        } else {
          vm.bankForm.verifyAccountNumber.$error.pattern = false;
          vm.bankForm.verifyAccountNumber.$invalid = false;
        }
      }

    }

    function compareStrings(a,b){
      if (a.length !== b.length) {
        return false;
      }
      return a.localeCompare(b) === 0;
    }
  }
})();


/**
 * Created by ttn on 02/07/24.
 */

(function() {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('QuickSipTileWidget', quickSipTileWidget);

    function quickSipTileWidget(LoaderService, MessageService, TransactionInitiateModel, UtilService, ModalService, TransactionDynamicService, AuthService, InvestorsService, BillJunctionService, AppConstants, SchemeService, InvestorsCommonService, $window, TransactionService, HDFC_API, $state, InvestorCommonServiceVersion2, panAdharLinkingService) {
      var vm = this;
      vm.appConstants = AppConstants;
      vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
      vm.formData.investmentType = 'SIP';
      vm.formData.sipFirstInstallment = false;
      vm.formData.sipTopupSelected = false;
      vm.formData.topupDetails = {};
      vm.formData.weeklyDay = null;
      vm.quickSipSchemeList = [];
      vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
      vm.startMaxDate = moment().add(350, 'days');
      vm.token = AuthService.getToken();
      vm.fetchSchemeList = fetchSchemeList;
      vm.fetchAllSipEnabledSchemes = fetchAllSipEnabledSchemes;
      vm.selectSipScheme = selectSipScheme;
      vm.schemeChanged = schemeChanged;
      vm.searchInvestor = searchInvestor;
      vm.fetchInvestorLastTransactedFolio = fetchInvestorLastTransactedFolio;
      vm.getInvestorInfo = getInvestorInfo;
      vm.fetchContactDetails = fetchContactDetails;
      vm.fetchBankListEmandate = fetchBankListEmandate;
      vm.fetchSipSchemeValidations = fetchSipSchemeValidations;
      vm.extractSipValidationObject = extractSipValidationObject;
      vm.getDateValidation = getDateValidation;
      vm.updateEndDates = updateEndDates;
      vm.endDateSetMaxInstallment = endDateSetMaxInstallment;
      vm.checkDuplicate = checkDuplicate;
      vm.setQuickSipData = setQuickSipData;
      vm.setQuickSipDataReview = setQuickSipDataReview;
      vm.initiateSip = initiateSip;
      vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;
      vm.noFolioErrorMessage = 'No folio found.';
      vm.noFolioErrorMessageMinor = 'No minor folio found.';
      vm.noEmailError = 'Email ID is not updated in any folio.';
      vm.fetchBankListForSipUpi = fetchBankListForSipUpi;

      // clearing session storage values
      if (sessionStorage.getItem('initialFolioSetQS')) {
        sessionStorage.removeItem('initialFolioSetQS');
      }

      if (sessionStorage.getItem('isNewFolioSet')) {
        sessionStorage.removeItem('isNewFolioSet');
      }

      vm.init = init;

      function init() {
        LoaderService.showLoader('.quickSipTileLoader');

        // remove euin data when widget is re initialised

        if (sessionStorage.getItem('eData')) {
          sessionStorage.removeItem('eData');
        }

        // fetching schemes for quick sip

        vm.fetchSchemeList(function() {
          vm.fetchAllSipEnabledSchemes();
        });
      }

      /**
       * function responsible for fetching Quick Sip Scheme List for last transacted scheme
       * @param  {Function}   cb     - callback function
       */

      function fetchSchemeList(cb) {
        cb = cb || function () {};
        var success = function(resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader('.quickSipTileLoader');
            vm.quickSipSchemeList = resp.data;
            if (vm.quickSipSchemeList.length > 0) {
              vm.quickSipScheme = vm.quickSipSchemeList[0];
              vm.schemeCodeQuickSip = vm.quickSipScheme.schemeCode;
              selectSipScheme(vm.quickSipScheme);
            }
            cb();
          } else {
            LoaderService.hideLoader('.quickSipTileLoader');
            MessageService.error(resp.message);
          }
        } , error = function(err) {
          LoaderService.hideLoader('.quickSipTileLoader');
          UtilService.errorHandler(err);
        }


        TransactionDynamicService.get({
          VERSION:'v2',
          child1: 'quick-sip',
          child2: 'scheme'
        }, null).$promise.then(success, error);
      }


      /**
       * function responsible for fetching all Sip Schemes List
       */

      function fetchAllSipEnabledSchemes() {
        var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader('.quickSipTileLoader');
            vm.masterSipSchemeList = resp.data.schemeList;
            if (vm.schemeCodeQuickSip && vm.masterSipSchemeList.length) {

              var result = vm.masterSipSchemeList.find(function (scheme) {
                return scheme.schemeCode === vm.schemeCodeQuickSip;
              });

              vm.sipScheme = result && result.scheme || null;

            }

            vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.sipScheme);

          } else {
            LoaderService.hideLoader('.quickSipTileLoader');
            vm.sipSchemeList = null;
            vm.masterSipSchemeList = null;
            vm.sipScheme = null;
          }
        }, error = function (err) {
          LoaderService.hideLoader('.quickSipTileLoader');
          vm.sipSchemeList = null;
          vm.masterSipSchemeList = null;
          UtilService.errorHandler(err);
        };

        SchemeService.get({
          controller: 'scheme',
          type: 'ALL',
          child1: 'sipenabled',
          child2: false, // minor flag
          child3: false, // corporate flag
          child4: true // quick sip flag
        }, null).$promise.then(success, error);
      }


      /**
       * function responsible for handling drop down selection of scheme list
       * @param  {Object}   data     -  selected scheme data
       */

      function selectSipScheme(data) {
        if (!data) {
          return;
        } else {

          vm.quickSipScheme = data;
          vm.formData.inSchemeName = data.scheme;
          vm.formData.inSchemeCode = data.schemeCode;
          vm.formData.schemeType = data.schemeType;
          vm.formData.fundCode = data.fundCode;
          vm.isMinorSchemeSelected = data.minorFlag;
          vm.isRetirementScheme = data.retirementFlag;

          vm.sipSchemeList = UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);

          if(data.schemeType === "NFO"){
            var message = data.message;
            ModalService.nfoEnabledModal({message: message});
          }

        }
      }

      /**
       * function responsible for handling scheme input field change and filtering scheme list based on input typed by the user
       */

      vm.filterSipSchemeList = function (event) {
        vm.formData && !event && (vm.formData.inSchemeCode = '');
        vm.sipSchemeList = event && event.type === 'focus' ? UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', '') : UtilService.getFilteredList(vm.masterSipSchemeList, 'scheme', vm.formData.inSchemeName);
      }

      /**
       * function responsible for search investor functionality and fetching selected investor folio detail
       */

      function searchInvestor() {
        var success = function (investor) {
          if (investor && investor.uuid) {
            vm.investorDetails = investor;
            vm.fetchInvestorLastTransactedFolio();
          }
        }, error = function() {};

        ModalService.searchInvestorModal({
          investorSearch: true,
          arnCode: vm.token.arnCode
        }, success, error);
      }

      /**
       * function responsible for fetching investor folio details and getting emandate bank list for payment mode selection
       */

      function fetchInvestorLastTransactedFolio() {
        LoaderService.showLoader('.quickSipTileLoader');
        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.folioList = resp.data.folioList || [];
            var activeFolioList = [];
            vm.noEmailIDFound = false;
            var breakLoop = false;

            vm.folioList.map(function(folio, index){

              if (breakLoop) {
                return;
              }

              // does not execute code below when folio has been found
              if (vm.isMinorSchemeSelected) {
                // if scheme selected is minor set minor folio
                if (folio.activeFlag === true && folio.minorFlag) {
                  if (folio.email) {
                    activeFolioList.push(folio);
                    vm.noEmailIDFound = false;
                    breakLoop = true;
                  } else {
                    vm.noEmailIDFound = true;
                  }
                }

                // if no email in any folios show error
                if (activeFolioList.length === 0 && index === vm.folioList.length - 1 && vm.noEmailIDFound) {
                  MessageService.error(vm.noEmailError);
                  LoaderService.hideLoader('.quickSipTileLoader');
                  return;
                }

              } else if (vm.isRetirementScheme) {
                // if scheme selected is retirement set major folio
                if (folio.activeFlag === true && !folio.minorFlag) {

                  if (folio.email) {
                    activeFolioList.push(folio);
                    vm.noEmailIDFound = false;
                    breakLoop = true;
                  } else {
                    vm.noEmailIDFound = true;
                  }
                }

                 // if no email in any folios show error
                if (activeFolioList.length === 0 && index === vm.folioList.length - 1 && vm.noEmailIDFound) {
                  MessageService.error(vm.noEmailError);
                  LoaderService.hideLoader('.quickSipTileLoader');
                  return;
                }

              } else {

                if (folio.activeFlag === true) {
                  if (folio.email) {
                    activeFolioList.push(folio);
                    vm.noEmailIDFound = false;
                    breakLoop = true;
                  } else {
                    vm.noEmailIDFound = true;
                  }
                }

                 // if no email in any folios show error
                if (activeFolioList.length === 0 && index === vm.folioList.length - 1 && vm.noEmailIDFound) {
                  MessageService.error(vm.noEmailError);
                  LoaderService.hideLoader('.quickSipTileLoader');
                  return;
                }

              }


            });

             // if empty folio
            if (activeFolioList.length === 0 && !vm.noEmailIDFound) {
              var message = vm.isMinorSchemeSelected ? vm.noFolioErrorMessageMinor : vm.noFolioErrorMessage;
              MessageService.error(message);
              LoaderService.hideLoader('.quickSipTileLoader');
              return;
            }

            vm.formData.folioNumber = angular.copy(activeFolioList[0].folioNumber);
            vm.mobileExists = activeFolioList[0].mobileNumber ? true : false;

            // fetching investor info and contact details of investor
            vm.getInvestorInfo(function() {
              vm.fetchContactDetails(function() {

                var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
                  return row.folioNumber == vm.formData.folioNumber
                })[0];

                vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;

                // called for setting payment option based on emandate bak list response - default emandate have to be set else biller
                if(vm.formData.folioNumber) {

                  if (vm.mobileExists) {

                    vm.fetchBankListForSipUpi(function() {

                      if (vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI) {
                        // fetching scheme validation data
                        vm.schemeChanged();
                      } else {
                        vm.fetchBankListEmandate(function() {

                          // checking if mandate bank list exists and we have default bank else switch to UPI
                          if (vm.eMandateBankList && vm.eMandateBankList.length > 0 && vm.formData.eMandateBank) {
                            // fetching scheme validation data
                            vm.schemeChanged();
                          } else {
                            // vm.fetchBankListForSipUpi(function() {
                            //   // fetching scheme validation data
                            //   vm.schemeChanged();
                            // });

                            vm.schemeChanged();
                          }

                        });
                      }
                    });

                  } else {
                    vm.fetchBankListForSipUpi(function() {
                      // fetching scheme validation data
                      vm.schemeChanged();
                    });
                  }
                }

              })
            })

          } else {
            LoaderService.hideLoader('.quickSipTileLoader');
            vm.formData.folioNumber = '';
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.quickSipTileLoader');
          vm.formData.folioNumber = '';
          UtilService.errorHandler(err);
        };

        InvestorsService.post({controller: 'folioList'}, {investorUUID: vm.investorDetails.uuid}).$promise.then(success, error);
      }

      /**
       * function responsible for fetching investor details
       * @param  {Function}   cb     - callback function
       */

      function getInvestorInfo(cb) {
        cb = cb || function () {};
        var payload = {"investorUUID": vm.investorDetails.uuid};

        var success = function (resp) {
          if (resp.status && resp.data) {
            vm.investorInfo = resp.data;
            var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

            var successHandler = function () {
              // if pan aadhar linked continue flow else dont continue
              cb(true);
            }, errorHandler = function () {
              LoaderService.hideLoader('.quickSipTileLoader');
            }
            // checking if pan is pan aadhar linked
            panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,'',brokerCode).then(successHandler).catch(errorHandler);
          } else {
            LoaderService.hideLoader('.quickSipTileLoader');
            vm.investorInfo = null;
            if(resp.popupEnabled) {
              $state.go('main.investors.profile.basicinfo',{investorId: vm.investorDetails.uuid});
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              MessageService.error(resp.message);
            }
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader('.quickSipTileLoader');
          vm.investorInfo = null;
        };
        InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      }

      /**
       * function responsible for fetching investor contact details
       * @param  {Function}   cb     - callback function
       */

      function fetchContactDetails(cb) {
        cb = cb || function () {};
        var success = function(resp) {
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.investorInfo.name = resp.data.folioHolderName;
          cb(true);
        } , error = function (err) {
          LoaderService.hideLoader('.quickSipTileLoader');
          UtilService.errorHandler(err);
        }

        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      /**
       * function responsible for fetching mandate bank list , setting payment mode and mandate fields data - default emandate have to be set else biller
       * @param  {Function}   cb     - callback function
       */

      function fetchBankListEmandate(cb) {
        cb = cb || function () {};

        if (!vm.formData.folioNumber) {
          return;
        }

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if ((angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) && vm.isEMandateEnabled) {
              vm.eMandateBankList = resp.data.bankList;
              vm.eMandateMaxAmount = resp.data.maxAmountLimit;
              vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM;

              // finding and setting default bank for emandate

              var defaultBank = vm.eMandateBankList.find(function(el) {
                return el.default === true;
              });

              if (defaultBank) {
                vm.formData.eMandateBank = angular.copy(defaultBank);
              } else {
                // if default bank doesnt exist setting EC as payment option
                vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
                cb(true);
                return;
              }

              if (vm.formData.eMandateBank) {
                vm.authMode = vm.formData.eMandateBank && vm.formData.eMandateBank.authenticationModes ? vm.formData.eMandateBank.authenticationModes[0] : null;
              }

              // setting mandate fields data

              var successHandler = function(resp){
                vm.emandateValidationData = resp.eOTM;
                vm.maxMandateDurationYears = vm.emandateValidationData.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
                vm.eMandateNoOfDays = vm.emandateValidationData.noOfDays;
                vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
                vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
                vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
                vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
                vm.formData.emandateDate = $window.moment().add(3,'days');
                updateEmandateEndDate();
                cb(true);
              }

              // if mandate default bank exists fetching and setting mandate fields data
              if (vm.formData.eMandateBank) {
                UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
                  MessageService.error(resp);
                });
              }
            }
            else{
              vm.eMandateBankList  = [];
              vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
              cb(true);
            }
          } else {
            vm.eMandateBankList = null;
            vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
            cb(true);
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.eMandateBankList = null;
          vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
          cb(true);
          LoaderService.hideLoader('.quickSipTileLoader');
          UtilService.errorHandler(err);
        };

        var payload = {
          "folioNumber": vm.formData.folioNumber,
          "trnxType": vm.formData.investmentType,
          "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false
        }


        BillJunctionService.post({VERSION: 'v2',
          controller: 'bank',
          child1: 'list',
          child2: 'emandate',
        }, payload ).$promise.then(success, error);
      }

      /**
       * function responsible for calculating emandate date
       */

      function updateEmandateEndDate() {

        if (!vm.formData.emandateDate) {
          return;
        }

        var enabledEndDates = [];
        vm.formData.endDateEmandate = '';
        if(vm.formData.emandateDate)
        {
          vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
          vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
          vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.maxMandateDurationYears, 'years').subtract(1,'days');
        }

        var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
        for (var i = 0; i <= freq; i++) {
          enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
        }
        vm.enabledEmandateEndDatesList = enabledEndDates;
        vm.endDateViewEmandate = enabledEndDates[0].clone();
        vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
      }


      /**
       * function responsible for handling scheme change
       */


      function schemeChanged() {
        vm.fetchSipSchemeValidations(vm.formData.inSchemeCode);
      }



      /**
       * function responsible for fetching and setting sip validation data
       * @param  {String}   schemeCode     - scheme code
       */

      function fetchSipSchemeValidations(schemeCode) {

        vm.sipValidationsData = null;

        var success = function (resp) {
            if (resp.status && resp.data) {
              vm.sipValidationsData = resp.data;

              if(vm.sipValidationsData && vm.formData.minorFlag){
                vm.sipValidationsData.cgfFlag = true;
              }
              // setting up default amount - 5000

              vm.formData.installmentAmount = vm.sipValidationsData.sipDefaultAmount;

              // setting up default frequency Monthly
              vm.SIP_FREQ_LIST = vm.sipValidationsData.additionalValidation.frequency ? vm.sipValidationsData.additionalValidation.frequency: null;
              vm.formData.frequency = 'OM';
              vm.formData.frequencyText = 'Monthly';

              if (vm.SIP_FREQ_LIST) {
                var frequency = vm.SIP_FREQ_LIST.find(function (d) {
                  return d.code === vm.formData.frequency;
                }) || {};
              }

              // if duration value doesnt extst setting 1 as default for monthly as default frequency is monthly

              vm.frequencyDuration = frequency.duration ? frequency.duration : 1;


              vm.extractSipValidationObject(angular.copy(vm.sipValidationsData), function() {
                // setting start date
                vm.getDateValidation(function() {

                  vm.formData.cgfFlag = vm.sipValidationsData.cgfFlag;
                  vm.formData.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.investmentOption || AppConstants.TRANSACTION.DIVIDEND);

                  // setting number of installments
                  vm.formData.installment = UtilService.setInstallmentCount(vm.formData.startDate,vm.formData.endDate,vm.formData.frequency);

                  if (vm.sipValidationsData.isGrowth) {
                    vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
                  } else {
                    if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === false) {
                      vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
                    } else if (vm.sipValidationsData.dividendPayoutApplicable === false && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                      vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
                    } else if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                      vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
                    }

                  }

                  // checking duplicate transaction after setting formdata

                  vm.checkDuplicate();

                });
              });


            } else {
              MessageService.error(resp.message);
              vm.sipValidationsData = null;
              vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
              vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
            }

          },
          error = function (err) {
            vm.sipValidationsData = null;
            if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
              vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
            }
            else {
              vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
            }
            vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
            LoaderService.hideLoader('.quickSipTileLoader');
            UtilService.errorHandler(err);
          };

        SchemeService.get({
          controller: 'schemeValidation',
          type: 'sip',
          child1: schemeCode
        }, null).$promise.then(success, error);

      }


      /**
       * function responsible for setting validations data for particular frequency
       * @param  {Object}   validationsData     - sip validations data object
       * @param  {Function}   cb     - callback function
       */

      function extractSipValidationObject(validationsData,cb) {
        cb = cb || function () {};
        var sipValidationsData = validationsData;

        vm.sipValidations = {};
        switch (vm.formData.frequency) {
          case 'BZ':
            vm.additionValidation = sipValidationsData.additionalValidation.BZ;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.BZ[0].min_amount_lower;
            vm.sipValidations.maxInstallments = sipValidationsData.dailyMaxInstallmentNumber;
            break;
          case 'OW':
            vm.additionValidation = sipValidationsData.additionalValidation.OW;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.OW[0].min_amount_lower;
            vm.sipValidations.maxInstallments = sipValidationsData.weeklyMaxInstallmentNumber;
            break;
          case 'Q':
            vm.additionValidation = sipValidationsData.additionalValidation.Q;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.Q[0].min_amount_lower;
            vm.sipValidations.minTopupAmount = sipValidationsData.topupMinAmt;
            vm.sipValidations.topupAmountMultiples = sipValidationsData.topupAmtMultples;
            vm.sipValidations.topupMinPercentage = sipValidationsData.topupMinPercentage;
            vm.sipValidations.topupPercentageMultiples = sipValidationsData.topupPercentageMultples;
            vm.sipValidations.maxInstallments = sipValidationsData.quarterlyMaxInstallmentNumber;
            break;
          case 'OM':
            vm.additionValidation = sipValidationsData.additionalValidation.OM;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.OM[0].min_amount_lower;
            vm.sipValidations.minTopupAmount = sipValidationsData.topupMinAmt;
            vm.sipValidations.topupAmountMultiples = sipValidationsData.topupAmtMultples;
            vm.sipValidations.topupMinPercentage = sipValidationsData.topupMinPercentage;
            vm.sipValidations.topupPercentageMultiples = sipValidationsData.topupPercentageMultples;
            vm.sipValidations.maxInstallments = sipValidationsData.monMaxInstallmentNumber;
            break;
          case 'H':
            vm.additionValidation = sipValidationsData.additionalValidation.H;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.H[0].min_amount_lower;
            vm.sipValidations.maxInstallments = sipValidationsData.halfYearlyMaxInstallmentNumber;
            break;
          case 'Y':
            vm.additionValidation = sipValidationsData.additionalValidation.Y;
            vm.sipValidations.minAmount = sipValidationsData.additionalValidation.Y[0].min_amount_lower;
            vm.sipValidations.maxInstallments = sipValidationsData.yearlyMaxInstallmentNumber;
            break;
        }

        vm.sipValidations.isGrowth = sipValidationsData.isGrowth;
        vm.sipValidations.endingType = sipValidationsData.endingType;
        cb(true);

      }

       /**
       * function responsible for fetching non business dates and setting sip start date
       * @param  {Function}   cb     - callback function
       */

      function getDateValidation(cb) {
        cb = cb || function () {};
        vm.isTillPerpetuity = false;

        var success = function (resp) {
            vm.enabledOTMStartDatesList = [];
            if (resp.status && resp.data) {
              var currentDate = resp.data.currentDate;
              var todayDate = $window.moment(currentDate);

              if ( vm.formData.paymentMode && vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM) {
                vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.eMandateNoOfDays, 'days');
              } else if(vm.formData.paymentMode && vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC){
                vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.sipValidationsData.sipTDay ? vm.sipValidationsData.sipTDay : vm.modifySipData.sipTDay, 'days');
              } else if (vm.formData.paymentMode && vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI) {
                vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.eMandateNoOfDays, 'days');
              } else {
                vm.startMinDateBiller = $window.moment(currentDate, "DD-MMM-YYYY").add(13, 'days'); //T+10+2+1
              }


              if(vm.formData.paymentMode && vm.formData.paymentMode === 'HEM' || vm.formData.paymentMode && vm.formData.paymentMode === 'UPI') {

                var startDate = todayDate.clone();
                var freq = $window.moment(vm.startMaxDate).diff(todayDate, 'days');
                var counter=0;
                var enabledStartDatesList = [];

                for (var i = 0; i <= freq; i++) {
                  var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                  var isEnable = true;
                  if(counter<7)
                  {
                    angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                      if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                        isEnable = false;
                      }
                    });
                  }
                  if(isEnable){
                    enabledStartDatesList.push(indexDate);
                    counter++;
                  }
                }
                vm.startMinDateBiller = enabledStartDatesList[vm.eMandateNoOfDays];
              }

              if( vm.formData.paymentMode && vm.formData.paymentMode === 'HEM' || vm.formData.paymentMode && vm.formData.paymentMode === 'UPI') {
                vm.startMinDateBiller = enabledStartDatesList[vm.eMandateNoOfDays];
              }


              vm.formData.startDate = angular.copy($window.moment(vm.startMinDateBiller, "DD-MMM-YYYY"));


              // calculating end date
              if (vm.formData.startDate) {
                vm.updateEndDates();
              }

              cb(true);
            } else {
              LoaderService.hideLoader('.quickSipTileLoader');
              MessageService.error(resp.message);
              cb(false);
            }
          },
          error = function (err) {
            LoaderService.hideLoader('.quickSipTileLoader');
            UtilService.errorHandler(err);
            cb(false);
          };

        InvestorsCommonService.get({
          child1: 'nonBusinessDate',
          schemeCode: vm.formData.inSchemeCode
        }).$promise.then(success, error);

      }


      /**
       * function responsible for calculating end dates
       */

      function updateEndDates() {

        var defaultEndDate = vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.maxMandateDurationYears, 'years')
          : vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI ? moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.maxMandateDurationYears, 'years')
            : moment((new Date()), "DD-MM-YYYY").add(99, 'years');

        var defaultMonths = null;
        var enabledEndDates = [];
        var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
        var i = 0, minInstallments = 1; // installmentTotal = 1;
        switch (vm.formData.frequency) {
          case'BZ':
            var days = 0;
            defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
            var days = getMonthsCount(vm.formData.startDate.clone(), defaultEndDate);
            freq = vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? defaultEndDate.diff(vm.formData.startDate, 'days', true)
              : vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI ? defaultEndDate.diff(vm.formData.startDate, 'days', true) : ((defaultMonths * 30) / vm.frequencyDuration) + days;
            for (i = 0; i < freq; i++) {
              days = vm.frequencyDuration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
            }
            break;
          default :
            var months = 0;
            minInstallments = (vm.sipValidations && vm.sipValidations.minInstallments) ? vm.sipValidations.minInstallments : 1;
            defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
            freq = freq || (defaultMonths / vm.frequencyDuration);
            for (i = 0; i < freq; i++) {
              months = vm.frequencyDuration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(months, 'months'));
            }
            break;
        }


        if(vm.formData.frequency === "OM" && vm.sipValidations && !vm.sipValidations.minInstallments) {
          vm.sipValidations.minInstallments = 6;
        }

        minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 1) || 0;
        vm.enabledEndDates = enabledEndDates.slice(minInstallments);


        vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
        vm.maxEndDate = new Date(2099, 12, 31);


        if (vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM || vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI) {
          vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
          vm.maxEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length -1].add(1, 'minutes'));
          vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length -1]);
        } else if (vm.formData.paymentMode === AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC) {
          calculateTillPerpetuityEndDate();
        }

      }

      /**
       * function responsible for calculating Perpetuity End date for other payment modes (excluding emandate)
       */

      function calculateTillPerpetuityEndDate() {

        var defaultMonths = null;
        var day = moment(vm.formData.startDate, 'DD-MMM-YYYY').date();
        var month = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
        var newEndDate = day + '/'+ (month + 1) +'/2099';
        var endDate = $window.moment(newEndDate, "DD-MM-YYYY");
        var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;


        switch (vm.formData.frequency) {

          case'BZ':
            var endDateYear = $window.moment((vm.enabledEndDates[vm.enabledEndDates.length - 1]), "DD-MMM-YYYY").year();
            if(endDateYear > 2099){
              endDateYear = 2099;
            }
            var newEndDateForDaily = day + '/'+ (month + 1) +'/' + endDateYear;
            vm.formData.endDate = $window.moment(newEndDateForDaily, "DD-MM-YYYY");

            //check end date exists between enabled end dates
            var isBetween = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));
            if (!isBetween) {
              if ($window.moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1 < $window.moment(vm.enabledEndDates[0], 'DD-MMM-YYYY').month() + 1) {
                vm.formData.endDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
              }else {
                endDateYear = endDateYear - 1;
                var dailyNewDate = day + '/'+ (month + 1) +'/' + endDateYear;
                vm.formData.endDate = $window.moment(dailyNewDate, "DD-MM-YYYY");
              }
            }
            break;
          default :
            var newday = moment().date();
            var newMonth = moment(vm.formData.startDate, 'DD-MMM-YYYY').month();
            var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
            var endDateCal = $window.moment(newEndDateCal, "DD-MM-YYYY");

            if (!moment(endDateCal).isValid()) {
              var initialStartDate = vm.formData.startDate.clone().day(1)
              endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
            }

            defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate.clone(), $window.moment(endDateCal));
            freq = freq || Math.floor(defaultMonths / vm.frequencyDuration);
            freq = vm.sipValidations && vm.sipValidations.maxInstallments ? freq - 1 : freq;
            var months = vm.frequencyDuration * freq;
            vm.formData.endDate = vm.formData.startDate.clone().add(months, 'months');
            var calculatedEndDateMonth = moment(vm.formData.endDate, 'DD-MMM-YYYY').month();

            if(calculatedEndDateMonth > month) {
              var endDateCalculated = angular.copy(vm.formData.endDate);
              var checkDate = angular.copy(endDateCalculated.set('month', month));

              var DateisBetween = $window.moment(checkDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]))
              if (DateisBetween) {
                vm.formData.endDate = checkDate;
              }

            }
            break;
        }


        if (vm.sipValidations && vm.sipValidations.maxInstallments) {

          var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
          var EndDatemonth = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').month() + 1);
          var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

          var EndDateCalculatedMonth = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').month() + 1);
          var EndDateCalculatedYear = angular.copy(moment(vm.formData.endDate, 'DD-MMM-YYYY').year());

            if (EndDatemonth < EndDateCalculatedMonth) {
              vm.endDateSetMaxInstallment(day,month);
            } else if (EndDatemonth === EndDateCalculatedMonth) {
              vm.endDateSetMaxInstallment(day,month);
            } else if (EndDateYear > 2099) {
              vm.formData.endDate.set('year', 2099);
            }
          } else if ((EndDateCalculatedYear > EndDateYear)) {
            if (EndDateCalculatedYear <= 2099) {
              vm.formData.endDate.set('year', EndDateYear);
            } else {
              vm.formData.endDate.set('year', 2099);
            }
          }
        }


      /**
       * function responsible for updaing end date when we are getting max installment in sip validation
       * @param  {String}   day     - day value of date like for 04/Jul/2024 value will be 4
       *  @param  {String}   month     - month value of date like for 04/July/2024 value will be 6
       */

      function endDateSetMaxInstallment(day,month) {

        var lastEndDate = angular.copy(vm.enabledEndDates[vm.enabledEndDates.length - 1]);
        var EndDateYear = angular.copy(moment(lastEndDate, 'DD-MMM-YYYY').year());

        if (moment(vm.formData.endDate, 'DD-MMM-YYYY').month() !== moment(vm.formData.startDate, 'DD-MMM-YYYY').month()) {
          EndDateYear = EndDateYear - 1;
          var newEndDateCheck = day + '/'+ (month + 1) +'/' + EndDateYear;
          vm.formData.endDate = $window.moment(newEndDateCheck, "DD-MM-YYYY");
        }

        var isBetweenCheck = $window.moment(vm.formData.endDate).isBetween($window.moment(vm.enabledEndDates[0]), $window.moment(vm.enabledEndDates[vm.enabledEndDates.length - 1]));

        if (!isBetweenCheck) {
          vm.formData.endDate = angular.copy(lastEndDate);
        }

        if (EndDateYear > 2099) {
          vm.formData.endDate.set('year', 2099);
        }

      }

      /**
       * function responsible for setting payload data
       * @return {Object} sip payload data
       */

      function setQuickSipData() {

        var payload = [];

        var sipPayload = {
          "installmentAmount": vm.formData.installmentAmount,
          "investmentOption": vm.formData.investmentOption,
          "dividendOption": vm.formData.dividendOption,
          "formType": "SIP",
          "frequency": vm.formData.frequency,
          "folioNumber": vm.formData.folioNumber,
          "schemeCode": vm.formData.inSchemeCode,
          "schemeType": vm.formData.schemeType,
          "sipDay": vm.formData.startDate ? vm.formData.startDate.format('D') : '',
          "sipTopupEnabled": vm.formData.sipTopupSelected,
          "topupDetails": vm.formData.topupDetails
        }

        sipPayload.toDate = vm.formData.endDate ? vm.formData.endDate.clone().format('DD-MMM-YYYY') : '';
        sipPayload.sipDate = vm.formData.startDate ? vm.formData.startDate.clone().format('DD-MMM-YYYY') : '';

        if (vm.formData.eMandateBank) {
          sipPayload['bankDetailsForECS'] = {
            "accNumber": vm.formData.eMandateBank.accountNumber,
            "accType": vm.formData.eMandateBank.bankAcType,
            "authenticationMode": vm.authMode.value,
            "bankCity": vm.formData.eMandateBank.bankCity,
            "bankCode": vm.formData.eMandateBank.bankCode,
            "bankName": vm.formData.eMandateBank.bankName,
            "branchName": vm.formData.eMandateBank.bankBranch,
            "gateWayVendor": vm.formData.eMandateBank.gateWayVendor,
            "ifscCode": vm.formData.eMandateBank.ifscCode,
            "paymentOption": vm.formData.paymentMode
          }
          sipPayload.mandateStartDate = moment(angular.copy(vm.formData.emandateDate)).format('DD-MMM-YYYY');
          sipPayload.mandateEndDate = moment(angular.copy(vm.formData.endDateEmandate)).format('DD-MMM-YYYY');
          sipPayload.authenticationMode = vm.authMode.value;
          sipPayload.mandateAmount = vm.formData.emandateAmount;
        }

        sipPayload.payMech = angular.copy(vm.formData.paymentMode);
        sipPayload.quickSip = true;

        // added payload for UPI
        if(vm.formData.paymentMode && vm.formData.paymentMode == 'UPI') {
          sipPayload.bankDetailsForECS = {
            "accNumber": vm.formData.upiBank.accountNumber,
            "branchName": vm.formData.upiBank.bankBranch,
            "bankName": vm.formData.upiBank.bankName,
            "accType":vm.formData.upiBank.bankAcType,
            "bankCity":vm.formData.upiBank.bankCity
          }

          sipPayload.payMech = 'UAP';
        }

        payload.push(sipPayload);

        return payload;

      }

      /**
       * function responsible for setting payload data for review page
       * @return {Object} sip payload data
       */

      function setQuickSipDataReview() {

        var additionalData = {};

        additionalData.investorName = vm.investorInfo.name;
        additionalData.panNumber = vm.investorInfo.panNumber;
        additionalData.folioNumber = vm.formData.folioNumber;
        additionalData.sipScheme = vm.formData.inSchemeName;
        additionalData.installmentAmount = vm.formData.installmentAmount;
        additionalData.noOfInstallments = vm.formData.installment;
        if (vm.sipValidations && !vm.sipValidations.isGrowth) {
          additionalData.dividendOption = vm.formData.dividendOption;
        }

        additionalData.sipFrequency = vm.formData.frequencyText;
        additionalData.startDate = vm.formData.startDate.format('DD-MMM-YYYY').toString();
        additionalData.endDate = vm.formData.endDate.format('DD-MMM-YYYY').toString();
        additionalData.sipTopupEnabled = vm.formData.sipTopupSelected;
        additionalData.topupDetails = vm.formData.topupDetails;
        additionalData.weeklyDay = vm.formData.weeklyDay;
        if (!additionalData.topupDetails.capAmount) {
          additionalData.topupDetails.capMonthYear = vm.formData.topupDetails && vm.formData.topupDetails.capMonthYear ?
            moment(vm.formData.topupDetails.capMonthYear,'MMM-YYYY').format('DD-MMM-YYYY') : null;
        } else {
          additionalData.topupDetails.capMonthYear = undefined
        }

        additionalData.paymentMode = {};

        if(vm.formData.paymentMode && vm.formData.paymentMode == AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM) {
          additionalData.eMandateBank = vm.formData.eMandateBank.bankName.substr(0,vm.formData.eMandateBank.bankName.lastIndexOf('-'));
          additionalData.accountNumber = vm.formData.eMandateBank.accountNumber;
          additionalData.mandateStartDate = moment(vm.formData.emandateDate).format('DD-MMM-YYYY');
          additionalData.mandateEndDate = moment(vm.formData.endDateEmandate).format('DD-MMM-YYYY');
          additionalData.authenticationMode = vm.authMode;
          additionalData.mandateAmount = vm.formData.emandateAmount;

          additionalData.paymentMode.value = 'Register E-mandate (eOTM)';
          additionalData.paymentMode.key = AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM;
        } else if (vm.formData.paymentMode && vm.formData.paymentMode == AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC) {
          additionalData.paymentMode.value = 'Standing Instruction/Biller';
          additionalData.paymentMode.key = AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
        } else if (vm.formData.paymentMode && vm.formData.paymentMode == AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI) {
          additionalData.paymentMode.value = 'UPI Autopay';
          additionalData.paymentMode.key = AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI;
        }

        additionalData.emailId = vm.emailId;
        additionalData.mobileNumber = vm.mobileNumber;
        additionalData.coperateFlag = vm.investorInfo.corporateFlag;
        additionalData.sipFirstInstallment = vm.formData.sipFirstInstallment;
        additionalData.fiPaymentMode = null;
        additionalData.fromQuickSip = true;
        additionalData.investorUUID = vm.investorDetails.uuid;
        additionalData.oversea_arn =  vm.oversea_arn;

        return additionalData;
      }


      /**
       * function responsible for checking duplicate transaction
       */

      function checkDuplicate() {

        var success = function (resp) {

          if (resp.status && resp.data) {
            if (resp.data.hasWarning) {
              var successModal = function () {
                vm.initiateSip();
              }, errorModal = function () {
                LoaderService.hideLoader('.quickSipTileLoader');
              };
              ModalService.transactionWarningModal({msg: resp.data.warningMessage}, successModal, errorModal)
            }
            else {
              vm.initiateSip();
            }
          } else {
            LoaderService.hideLoader('.quickSipTileLoader');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.quickSipTileLoader');
          UtilService.errorHandler(err);
        };

        var payload = {
          transactionType: vm.formData.investmentType,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.inSchemeCode,
          targetSchemeCode: null,
          amount: vm.formData.investmentType == 'PURCHASE' ? vm.formData.purchaseAmount : vm.formData.installmentAmount,
          checkedNfoAutoSwitch: null,
          autoSwitchScheme: null,
          autoSwitchSchemeDividendOption: null,
          sipTopupEnabled: vm.formData.sipTopupSelected,
          topupDetails: vm.formData.topupDetails,
          paymentMode: vm.formData.paymentMode
        };


        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'check',
          child2: 'duplicate'
        }, payload).$promise.then(success, error);

      }

      /**
       * function responsible for initiating SIP
       */

      function initiateSip() {
        var payloadForInitiate = vm.setQuickSipData();
        var payloadForReview = vm.setQuickSipDataReview();

        var successSipModal = function() {
          $state.go('main.dashboard');
        } , errorSipModal = function() {}

        var success = function(resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader('.quickSipTileLoader');
            ModalService.initiateSuccessModal({
              transactionType: vm.formData.investmentType,
              investorName: vm.investorInfo.name,
              isFromQuickSip: true
            }, successSipModal, errorSipModal);
          } else if (resp && resp.message) {
            LoaderService.hideLoader('.quickSipTileLoader');
            MessageService.error(resp.message);
          }
        } , error = function(err) {
          LoaderService.hideLoader('.quickSipTileLoader');

          if (err && err.message) {
            MessageService.error(err.message);
          }

        }

        ModalService.transactionReviewModal({
          payload: payloadForInitiate, controller: 'many', additionalData: payloadForReview
        }, success, error);


      }

      /**
       * function responsible for fetching UPI Bank List for SIP
       * @param  {Function}   cb     - callback function
       */

      function fetchBankListForSipUpi(cb) {
        cb = cb || function () {};
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              if (angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) {
                vm.upiBankListForSIP = resp.data.bankList;

                var defaultBank = vm.upiBankListForSIP.find(function(el) {
                  return el.default === true;
                });


                if (defaultBank) {
                  vm.formData.paymentMode = AppConstants.TRANSACTION.PAYMENT_OPTIONS.UPI;
                  vm.formData.upiBank = angular.copy(defaultBank);
                } else {
                  // if default bank doesnt exist setting HEM/biller as payment option
                  vm.formData.paymentMode = vm.mobileExists ? AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM : AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
                  cb(true);
                  return;
                }

                var successHandler = function(resp){
                  vm.validationDataUPI = resp.upi;
                  vm.maxMandateDurationYears = vm.validationDataUPI.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
                  vm.eMandateNoOfDays = vm.validationDataUPI.noOfDays;
                  vm.minEndDateGapMandate = vm.validationDataUPI.minEndDateGap;
                  cb(true);
                }


                if (vm.formData.upiBank && !vm.validationDataUPI) {
                  UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
                    MessageService.error(resp);
                  });
                } else {
                  vm.maxMandateDurationYears = vm.validationDataUPI.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
                  vm.eMandateNoOfDays = vm.validationDataUPI.noOfDays;
                  vm.minEndDateGapMandate = vm.validationDataUPI.minEndDateGap;
                  cb(true);
                }

              }
              else{
                vm.upiBankListForSIP  = [];
                // if default bank doesnt exist setting HEM/biller as payment option
                vm.formData.paymentMode = vm.mobileExists ? AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM : AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
                cb(true);
              }
            } else {
              vm.upiBankListForSIP = null;
              // if default bank doesnt exist setting HEM/biller as payment option
              vm.formData.paymentMode = vm.mobileExists ? AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM : AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
              cb(true);
              // MessageService.error(resp.message);
            }
          },
          error = function (err) {
            vm.upiBankListForSIP = null;
            // if default bank doesnt exist setting HEM/biller as payment option
            vm.formData.paymentMode = vm.mobileExists ? AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM : AppConstants.TRANSACTION.PAYMENT_OPTIONS.EC;
            cb(true);
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        var payload = {
          "folioNumber": vm.formData.folioNumber,
          "trnxType": "PURCHASE",
          "liquidSchemeFlag": vm.formData.schemeType == 'LIQUID' ? true : false,
          "sipUpiFlow" : true
        };
        LoaderService.showLoader();
        InvestorCommonServiceVersion2.post({
          child1: 'investor',
          child2: 'upi',
          child3: 'bank',
          child4: 'list'
        }, payload).$promise.then(success, error);
      }


  }


  })();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('KnowledgeCenterWidget', knowledgeCenterWidget);

  function knowledgeCenterWidget(LoaderService, MessageService, UtilService, HDFC_API, $window, ModalService, DashboardServiceV3) {
    var vm = this;
    vm.widgetData = [];
    vm.init = init;
    vm.performAction = performAction;
    vm.openCalculator = openCalculator;
    init();
    function init() {
      getKnowledgeCenterData();
    }

    function getKnowledgeCenterData() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.widgetData = response.data.knowledgeCenterList;
          vm.widgetData.forEach(function(data) {
            if (data.header.toLowerCase() === "factsheets") {
              data.index = 1;
            } else if (data.header.toLowerCase() === "leaflets") {
              data.index = 2;
            } else {
              data.index = 3;
            }
          });
        } else {
          vm.widgetData = [];
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'knowledgeCenter'
      }).$promise.then(success, error);
    }

    function performAction(url) {
      $window.open(url, "_blank");
    }

    function openCalculator(title, url) {
      ModalService.genericUiModal({
        title: title,
        url: url
      });
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FundInFocusWidget', fundInFocusWidget);

  function fundInFocusWidget($timeout, WidgetCmsService, UtilService, LoaderService, MessageService, HDFC_API, $state,
                             $window, $scope, ModalService, AuthService, TransactionFlowVersion, AppConstants) {
    var vm = this;
    vm.init = init();
    vm.fundInFocus = [];
    vm.onOptionChange = onOptionChange;
    vm.websiteLink = HDFC_API.WEBSITE_LINK;
    vm.openCalculator = openCalculator;
    vm.isObjectType = isObjectType;
    vm.shownHeadingForFunds = "Funds in Focus";

    function init() {
      if($state.current.name === "login") {
        getTrendingFunds();
      } else if($state.current.name === "main.dashboard"){
        getRecommendedFunds();
      }
    }

    function getTrendingFunds() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.fundInFocus = response.data.funds;
          updateRecommendedFund();
        } else {
          vm.fundInFocus = [];
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      WidgetCmsService.get({
        VERSION: 'v1',
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'trending'
      }).$promise.then(success, error);
    }

    function setCarousel() {
      $timeout(function() {
        $('.funds-carousel').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          draggable: false,
          focusOnSelect: false,
          prevArrow: '<a><i class="left-arrow"></i></a>',
          nextArrow: '<a><i class="right-arrow"></i></a>',
          responsive: [{
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              focusOnSelect: false
            }
          }, {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              focusOnSelect: false
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              focusOnSelect: false
            }
          }]
        });
      }, 500);
    }

    function updateFundInFocus() {
      vm.fundInFocus.forEach(function (scheme, index) {
        var options = Object.keys(scheme.annualisedReturns);
        scheme.updAnnualisedReturns = [];
        scheme.updBenchmarkReturns = [];
        var orders = [1, 3, 5, 10, 11];
        orders.forEach(function(order) {
          var annualisedObj = {};
          var benchmarkObj = {};
          if (order !== 11) {
            if (scheme.annualisedReturns) {
              annualisedObj = {
                key: order,
                value: scheme.annualisedReturns[order]
              };
            }
            if (scheme.benchmarkReturns) {
              benchmarkObj = {
                key: order,
                value: scheme.benchmarkReturns[order]
              };
            }
          } else {
            if (scheme.annualisedReturns) {
              annualisedObj = {
                key: 'Since Inception',
                value: scheme.annualisedReturns[order]
              };
            }
            if (scheme.benchmarkReturns) {
              benchmarkObj = {
                key: 'Since Inception',
                value: scheme.benchmarkReturns[order]
              };
            }
          }
          scheme.updAnnualisedReturns.push(annualisedObj);
          scheme.updBenchmarkReturns.push(benchmarkObj);
        });

        var returns = scheme.updAnnualisedReturns[scheme.updAnnualisedReturns.length - 1];
        scheme.selectedOption = returns ?
          {
            id: returns.key,
            annualisedReturns: returns.value,
            benchmarkReturn: returns.key == "Since Inception" ? scheme.updBenchmarkReturns[scheme.updBenchmarkReturns.length - 1].value: scheme.updBenchmarkReturns[index].value
          } : {};
        if (scheme.regularSchemes) {
          scheme.regularSchemes.forEach(function(ele) {
            if (ele.investmentOption && ele.investmentOption.toUpperCase() === "GROWTH") {
              scheme.schemeCode = ele.schemeCode
            }
          });
        }
        scheme.proccedToLogin = proccedToLogin;
      });
      setCarousel();
    }

    function onOptionChange(scheme, key, value, index) {
      function getValue(obj, key, defaultValue) {
        return obj && obj[key] != null ? obj[key] : defaultValue;
      }

      function getValueForSinceInception(obj, defaultValue) {
        return obj && obj[11] != null ? obj[11] : defaultValue;
      }
      if(scheme.fundNavRegular){
        scheme.selectedOption = {
          id: key,
          annualisedReturns: value,
          benchmarkReturn: key !== 'Since Inception' ? getValue(scheme.fundNavRegular.bechmarkreturns, key, 0) : getValueForSinceInception(scheme.fundNavRegular.bechmarkreturns, 0)
        };
      } else {
        scheme.selectedOption = {
          id: key,
          annualisedReturns: value,
          benchmarkReturn: key !== 'Since Inception' ? getValue(scheme.benchmarkReturns, key, 0) : getValueForSinceInception(scheme.benchmarkReturns, 0)
        };
      }
      scheme.selectedOption.navDateTimestamp = scheme.navDateTimestamp[index].value ? scheme.navDateTimestamp[index].value : 0;
      scheme.selectedOption.navAmount = scheme.navAmount[index].value ? scheme.navAmount[index].value : 0;
    }

    function proccedToLogin(scheme) {
      if($state.current.name === "login") {
        $window.scrollTo(0, 0);
        angular.element(document.getElementById('arnCodeId')).focus();
        $scope.$emit('fundSelected', scheme);
      } else if ($state.current.name === "main.dashboard") {
        var identifier = AuthService.getToken();
        var success = function (investor) {
          if (investor && investor.uuid) {
            var _state = 'main.transactions.initiate.sip';
            $state.go(_state, {
              uuid: investor.uuid,
              schemeCode: scheme,
              folioNumber: '',
              transactionType: '',
              transactionId: '',
              fromModify: ''
            });
          }
        }, error = function () {
          $state.go('main.dashboard');
        };
        if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
          $state.go('main.newinvestor.kycverify');
          return;
        } else {
          ModalService.searchInvestorModal({
            transactionType: 'SIP or Purchase',
            arnCode: identifier.arnCode
          }, success, error);
        }
      }
    }

    function openCalculator(title, url) {
      ModalService.genericUiModal({
        title: title,
        url: url
      });
    }

    /*
    * function responsible to get recommended schemes
    * if available then show recommended schemes.
    * else fund in focus will be visible to user.
    * */
    function getRecommendedFunds() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.fundInFocus = response.data.funds;
          if (vm.fundInFocus.length === 0) {
            getTrendingFunds();
          } else {
            vm.shownHeadingForFunds = "Recommended Funds";
            updateRecommendedFund();
          }
        } else {
          vm.fundInFocus = [];
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      TransactionFlowVersion.get({
        VERSION: 'v1',
        child1: 'recommendedFunds',
      }).$promise.then(success, error);
    }

    function updateRecommendedFund() {
      vm.fundInFocus.forEach(function (scheme) {
        scheme.updAnnualisedReturns = [];
        scheme.updBenchmarkReturns = [];
        scheme.navDateTimestamp = [];
        scheme.navAmount = [];
        var orders = [1, 3, 5, 10, 11];
        orders.forEach(function(order) {
          var annualisedObj = {};
          var benchmarkObj = {};
          var navDateStampObj = {};
          var navAmountObj = {}
          if (order !== 11) {
            if (scheme.fundNavRegular.annualisedreturns) {
              annualisedObj = {
                key: order,
                value: scheme.fundNavRegular.annualisedreturns[order]
              };
            } else {
              annualisedObj = {
                key: order,
                value: 0
              };
            }
            if (scheme.fundNavRegular.bechmarkreturns) {
              benchmarkObj = {
                key: order,
                value: scheme.fundNavRegular.bechmarkreturns[order]
              };
            } else {
              benchmarkObj = {
                key: order,
                value: 0
              };
            }
          } else {
            if (scheme.fundNavRegular.annualisedreturns) {
              annualisedObj = {
                key: 'Since Inception',
                value: scheme.fundNavRegular.annualisedreturns[order]
              };
            } else {
              annualisedObj = {
                key: 'Since Inception',
                value: 0
              };
            }
            if (scheme.fundNavRegular.bechmarkreturns) {
              benchmarkObj = {
                key: 'Since Inception',
                value: scheme.fundNavRegular.bechmarkreturns[order]
              };
            } else {
              benchmarkObj = {
                key: 'Since Inception',
                value: 0
              };
            }
          }
          if(scheme.fundNavRegular.nav_date){
            navDateStampObj = {
              key: order,
              value: scheme.fundNavRegular.nav_date[11]
            }
          } else {
            navDateStampObj = {
              key: order,
              value: null
            }
          }
          if(scheme.fundNavRegular.nav_amount){
            navAmountObj = {
              key: order,
              value: scheme.fundNavRegular.nav_amount[11]
            }
          } else {
            navAmountObj = {
              key: order,
              value: 0
            }
          }
          scheme.updAnnualisedReturns.push(annualisedObj);
          scheme.updBenchmarkReturns.push(benchmarkObj);
          scheme.navDateTimestamp.push(navDateStampObj);
          scheme.navAmount.push(navAmountObj);
        });

        scheme.riskReturnProfile = scheme.riskReturnProfile[0];
        var returns = scheme.updAnnualisedReturns[scheme.updAnnualisedReturns.length - 1];
        var benchReturns = scheme.updBenchmarkReturns[scheme.updBenchmarkReturns.length - 1];
        var navDate = scheme.navDateTimestamp[scheme.navDateTimestamp.length - 1];
        var navAmt = scheme.navAmount[scheme.navAmount.length - 1];
        scheme.selectedOption = returns ?
          {
            id: returns.key,
            annualisedReturns: returns.value,
            benchmarkReturn: benchReturns.value,
            navDateTimestamp: navDate.value,
            navAmount: navAmt.value
          } : {};
        if (scheme.regularScheme) {
          scheme.regularScheme.forEach(function(ele) {
            if (ele.investmentOption && ele.investmentOption.toUpperCase() === "GROWTH") {
              scheme.schemeCode = ele.schemeCode
            }
          });
        }
        scheme.proccedToLogin = proccedToLogin;
      });
      setCarousel();
    }

    function isObjectType(value) {
      return angular.isObject(value);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcLoginSidebar', hdfcLoginSidebar);

  /** @ngInject */
  function hdfcLoginSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/sidebar/login-sidebar/login-sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: sidebarController,
      controllerAs: 'Sidebar',
      bindToController: true
    });

    /** @ngInject */
    function sidebarController(ModalService, $rootScope, $timeout, $scope, $state, HDFC_API, UtilService) {
      var vm = this;
      vm.active = null;
      vm.sidebarActive = null;
      vm.productSubMenu = true;
      vm.knowledgeCenterSubMenu = true;
      vm.openCalculator = openCalculator;
      vm.activateTab = activateTab;
      vm.active = {0: true};
      vm.HDFC_API = HDFC_API;
      vm.closeSidebar = closeSidebar;
      vm.count = 0;
      vm.contrast = contrast;
      vm.changedFont = changedFont;
      vm.toggleMode = toggleMode;
      vm.initTab = initTab;

      function activateTab(tab) {
        vm.active = {};
        vm.active[tab] = true;
        $rootScope.$broadcast('checkCurrentState');
        if(vm.active[4] || vm.active[41] || vm.active[42] || vm.active[43]){
          vm.knowledgeCenterSubMenu = !!vm.knowledgeCenterSubMenu;
        }else {
          vm.knowledgeCenterSubMenu = true;
        }
        if(vm.active[3] || vm.active[31] || vm.active[32]){
          vm.productSubMenu = !!vm.productSubMenu;
        }else {
          vm.productSubMenu = true;
        }

        $rootScope.$on('$locationChangeSuccess', function() {
          vm.initTab();
          vm.activateTab();
        });
      }

      function openCalculator(title, url) {
        ModalService.genericUiModal({
          title: title,
          url: url
        });
      }

      function closeSidebar() {
        document.getElementById('login-sidebar').style.removeProperty('display');
        angular.element(document.getElementsByClassName('login-affix side-nav')).removeClass('add-width');
      }

      /** color contrast */

      function contrast () {
        if(!vm.isDarkModeEnable){
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        }
        $rootScope.$broadcast('isChangeBackgroundOfDonut', !vm.isDarkModeEnable);
      }

      function changedFont(valType){
        UtilService.changedFont(valType);
        vm.count = UtilService.getCount();
        $rootScope.$broadcast('changeFontFromPreLoginMobileSidebar');
      }

      function toggleMode() {
        UtilService.toggleMode();
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        $rootScope.$broadcast('toggleModeValueUpdateFromMobileSidebar');
      }

      function initTab() {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        vm.count = UtilService.getCount();
        $timeout(function () {
          var baseState = null;
          if($state.current.name == "login"){
            baseState = "login"
          }else if($state.current.name == "contactUs"){
            baseState = $state.current.name;
          }else {
            baseState = $state.current.name.split('.')[0];
          }
          switch (baseState) {
            default:
              vm.active = {'-1': true};
              break;
            case 'login':
              vm.active = {0: true};
              break;
            case 'distributorempanellment':
              vm.active = {1: true};
              break;
            case 'registration':
              vm.active = {2: true};
              break;
            case 'contactUs':
              vm.active = {7: true};
              break;
          }
        }, 100);
        $rootScope.$broadcast('checkCurrentState');
      }
      initTab();
      $rootScope.$on('toggleModeValueUpdate', function () {
        vm.initTab();
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('WidgetStoreModalController', widgetSelectionModalController);

  /** @ngInject */
  function widgetSelectionModalController($uibModalInstance, UtilService, $rootScope, AppConstants, modalView, modalData, DashboardService, LoaderService, MessageService, moment) {
    var vm = this;
    vm.view = modalView;
    vm.moment = moment;
    vm.modalData = modalData;
    vm.distributorWidgetsList = null;
    vm.WIDGETS_ID = AppConstants.WIDGETS_ID;
    vm.getDistributorWidgets = getDistributorWidgets;
    vm.updateWidgets = updateWidgets;
    vm.selectedCount = selectedCount;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close("updated successful");
      MessageService.success("Widgets updated successfully");
    };

    vm.init = function () {
      LoaderService.showLoader('.widget');
      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        if (resp.data && resp.status) {
          vm.widgetList = resp.data.widgetList;
          vm.widgetIdArray = vm.widgetList.map(function (e) {
            return e.widgetId;
          });
        } else {
          MessageService.error(resp.message);
        }
        vm.getDistributorWidgets();
      }, error = function (err) {
        LoaderService.hideLoader('.widget');
        UtilService.errorHandler(err);
      };

      DashboardService.post({
        controller: 'widgets'
      }, {}).$promise.then(success, error);

      vm.submitWidgetList = function () {
        vm.selectedWidgets = [];
        var positionCount = 1;
        var previousWidgetsCount = vm.widgetIdArray.length;
        angular.forEach(vm.widgetList, function (val) {
          if (val.selected) {
            switch (val.widgetName) {
              case vm.WIDGETS_ID.SNAPSHOT_NAME:
                positionCount = (vm.WIDGETS_ID.SNAPSHOT_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.SNAPSHOT_ORDER;
                break;
              case vm.WIDGETS_ID.TODO_NAME:
                positionCount = (vm.WIDGETS_ID.TODO_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.TODO_ORDER;
                break;
              case vm.WIDGETS_ID.ASSETS_NAME:
                positionCount = (vm.WIDGETS_ID.ASSETS_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.ASSETS_ORDER;
                break;
              case vm.WIDGETS_ID.MARKET_NAME:
                positionCount = (vm.WIDGETS_ID.MARKET_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.MARKET_ORDER;
                break;
              case vm.WIDGETS_ID.LEADS_NAME:
                positionCount = (vm.WIDGETS_ID.LEADS_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.LEADS_ORDER;
                break;
              case vm.WIDGETS_ID.INVESTORS_NAME:
                positionCount = (vm.WIDGETS_ID.INVESTORS_ORDER == 0) ? (++previousWidgetsCount) : vm.WIDGETS_ID.INVESTORS_ORDER;
                break;
            }
            vm.selectedWidgets.push({position: positionCount, widgetId: val.widgetId});
          }
        });
        vm.selectedWidgetsIdArray = vm.selectedWidgets.map(function (ele) {
          return ele.widgetId;
        });
        setRestWidgetsOrder();
        vm.updateWidgets();
      }
    };


    function setRestWidgetsOrder() {

      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.ASSETS) < 0) {
        vm.WIDGETS_ID.ASSETS_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.INVESTORS) < 0) {
        vm.WIDGETS_ID.INVESTORS_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.LEADS) < 0) {
        vm.WIDGETS_ID.LEADS_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.MARKET) < 0) {
        vm.WIDGETS_ID.MARKET_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.SNAPSHOT) < 0) {
        vm.WIDGETS_ID.SNAPSHOT_ORDER = 0;
      }
      if (vm.selectedWidgetsIdArray.indexOf(vm.WIDGETS_ID.TODO) < 0) {
        vm.WIDGETS_ID.TODO_ORDER = 0;
      }
    }

    function updateWidgets() {
      var widgetList = vm.selectedWidgets;
      var success = function (resp) {
        if (resp.status) {
          $uibModalInstance.close(resp);
          $rootScope.$broadcast('UpdateDashboard', {listUpdated: true});
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      DashboardService.post({
        controller: 'widgets',
        child1: 'alignments'
      }, {widgetList: widgetList}).$promise.then(success, error);
    }

    function getDistributorWidgets() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var count = 0;
          vm.distributorWidgetsList = resp.data.widgetList;
          angular.forEach(vm.widgetList, function (value) {
            angular.forEach(vm.distributorWidgetsList, function (v) {
              if (value.widgetId == v.widgetId) {
                value.selected = true;
                count++;
              }
            });
          });
        } else {
          MessageService.error(resp.message);
        }
        vm.selectedCounter = count;
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      DashboardService.post({
        controller: 'distributorWidgets'
      }, {}).$promise.then(success, error);
    }

    function selectedCount() {
      var count = 0;
      angular.forEach(vm.widgetList, function (val) {
        if (val.selected) {
          count++;
        }
      });
      vm.selectedCounter = count;
    }

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('WidgetCampaignModalController', widgetCampaignModalController);

  /** @ngInject */
  function widgetCampaignModalController($uibModalInstance, UtilService, modalView, modalData, DashboardService, LoaderService, MessageService, moment) {
    var vm = this;
    vm.view = modalView;
    vm.moment = moment;
    vm.modalData = modalData;
    vm.formData = {};
    vm.distributorWidgetsList = null;
    vm.investorList = [];
    vm.investorFilterList = [{key:'ALL',value:'All'}];
    vm.filter = vm.investorFilterList[0];

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function (resp) {
      $uibModalInstance.close(resp);
    };


    vm.checkAll = function () {
      vm.user.roles = angular.copy(vm.roles);
    };
    vm.uncheckAll = function () {
      vm.user.roles = [];
    };

    vm.init = function () {
      var tmp = {};
      tmp.key = vm.modalData.tag;
      tmp.value = vm.modalData.tag.toString().replace(/_/g,' ');
      vm.investorFilterList.push(tmp);
      vm.getInvestorList();
    };

    vm.getInvestorList = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        if (resp.data && resp.status) {
          vm.investorTotalList = resp.data.investorList;
          vm.totalCount = resp.data.totalCount;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.widget');
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader('.widget');
      DashboardService.get({
        controller: 'campaign',
        child1: vm.modalData.campaignId,
        child2: vm.filter.key
      }).$promise.then(success, error);


    }

    vm.submitCampaignInvestorList = function () {

      LoaderService.showLoader('.widget');
      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        if (resp.data && resp.status) {
          vm.closeModal(resp);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.widget');
        UtilService.errorHandler(err);
      };
      vm.formData.campaignId = vm.modalData.campaignId;
      vm.formData.investorList = vm.investorTotalList.map(function (ele) {return ele.investorId;});

      DashboardService.post({
        controller: 'campaign',
        child1: 'save'
      }, vm.formData).$promise.then(success, error);

    }

    vm.toggleSelection = function () {
      if (vm.toggleCheckAll) {
        vm.formData.investorList = vm.investorTotalList.map(function (ele) {
          return ele.investorId;
        });
      } else {
        vm.formData.investorList = [];
      }
    }

  }

})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('UpdateInvestorModalController', updateInvestorModalController);

  /** @ngInject */
  function updateInvestorModalController($uibModalInstance, modalView, modalData, InvestorsService, LoaderService, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.dismissModal = dismissModal;
    vm.continue = continueModal;
    vm.updateInfo = updateInfo;
    vm.wrongMsg = '';
    vm.changeDob = changeDob;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investordob = null;

    function updateInfo() {

      if (!vm.investordob) {
        vm.wrongMsg = 'dob is required field';
        return;
      }

      var payload = {
        dob: vm.investordob.format('DD-MMM-YYYY'),
        id: modalData.investorId
      };

      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(payload);
            vm.wrongMsg = '';
          } else {
            vm.wrongMsg = resp.message;
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongMsg = AppConstants.ToastrMessage.FAILED;
        };

      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'info',
        child1: 'update'
      }, payload).$promise.then(success, error);
    }

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function continueModal() {
      $uibModalInstance.close('success');
    }

    function changeDob(date) {
      if (date) {
        vm.investordob = date;
        vm.wrongMsg = "";
      } else {
        vm.wrongMsg = vm.validateData.DOB_FIELD;
      }
    }
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionWarningController', transactionWarningController);

  /** @ngInject */
  function transactionWarningController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    if(modalData.msg){
    vm.modalData = modalData.msg;
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionSummaryModalController', transactionSummaryModalController);

  /** @ngInject */
  function transactionSummaryModalController($uibModalInstance, modalView, modalData,  $state, TransactionService, LoaderService, MessageService, moment, UtilService,HDFC_API) {
    var vm = this;
    vm.view = modalView;
    vm.moment = moment;
    vm.modalData = modalData;
    vm.transactionSummary = null;

    function sendReminder(listData) {
      var success = function (resp) {
          if (resp && resp.status) {
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
            $uibModalInstance.close();
          }
          else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'remind'}, {
        transactionId: vm.modalData.payload.uuid,
        type: listData.type.toUpperCase()
      }).$promise.then(success, error);
    }

    function getInvestorId(val) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            initiateTransactionType(resp.data, val.type, vm.modalData.payload.uuid);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'investor',
        'folioNumber': val.folioNumber
      }, {}).$promise.then(success, error);
    }

    function initiateTransactionType(investorId, transactionType, transactionId) {
      switch (transactionType) {
        case 'SWITCH':
          $state.go('main.transactions.initiate.switch', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'SIP':
        case 'PURCHASE':
          $state.go('main.transactions.initiate.sip', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'STP':
          $state.go('main.transactions.initiate.stp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'SWP':
          $state.go('main.transactions.initiate.swp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'REDEMPTION':
          $state.go('main.transactions.initiate.redeem', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
      }
      $uibModalInstance.close();
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.init = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.transactionSummary = resp.data;

        } else {
          vm.transactionSummary = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.transactionSummary = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'summary'
      }, vm.modalData.payload).$promise.then(success, error);
    };

    vm.initiateTransaction = function () {
      if (!vm.transactionSummary) {
        return;
      }
      switch (vm.transactionSummary.action) {
        case "REMIND":
          sendReminder(vm.transactionSummary);
          break;
        case "REINITIATE":
          getInvestorId(vm.transactionSummary);
          break;
      }
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionReviewModalController', transactionReviewModalController);

  /** @ngInject */
  function transactionReviewModalController($window, $uibModalInstance, modalView, modalData, InvestorsService, ChangeDividendService, TransactionService, DistributorGenericService, LoaderService, HDFC_API, AppConstants, MessageService, ModalService, moment, UtilService,  $state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData || {};
    vm.AppConstants = AppConstants;
    vm.utilService = UtilService;
    vm.T_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.disableButton = false;

    if (vm.modalData.additionalData && vm.modalData.additionalData.fromQuickSip) {
      vm.isFromQuickSip = vm.modalData.additionalData.fromQuickSip;
    }

    vm.getEuinCodes = getEuinCodes;
    if (vm.isFromQuickSip) {
      vm.getEuinCodes();
    }
    vm.editQuickSip = editQuickSip;

    if (vm.modalData.controller === 'sip_modify') {

      // checking scheme modified
      if (vm.modalData.unmodifiedData.schemeName !== vm.modalData.additionalData.sipScheme) {
        vm.modifiedScheme = true;
      }

      // checking dividend option modified
      var dividendModified = vm.modalData.additionalData.growth ? 'Growth' : 'IDCW';
      var dividendCancelled =vm.modalData.unmodifiedData.growth ? 'Growth' : 'IDCW';

      if (dividendCancelled !== dividendModified) {
        vm.modifiedDividend = true;
      }

      // checking dividend option selected modified
      if (dividendCancelled === dividendModified && (vm.modalData.additionalData.dividendOption && vm.modalData.unmodifiedData.dividendOption)) {
        var modifiedDividendOption = vm.modalData.additionalData.dividendOption=='Y'?'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option':'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option'
        if (vm.modalData.unmodifiedData.dividendOption !== vm.modalData.additionalData.dividendOption) {
          vm.modifiedDividendSelection = true;
        }
      }else if (dividendCancelled !== dividendModified){
        if(!vm.modalData.unmodifiedData.dividendOption && vm.modalData.additionalData.dividendOption){
          vm.modifiedDividendSelection = true;
        }
      }

      // checking frequency modified
      if (vm.modalData.unmodifiedData.autoFrequency !==  vm.modalData.additionalData.sipFrequency) {
        vm.modifiedFrequency = true;
      }

      // checking start date modified
      if (vm.modalData.unmodifiedData.startDate !== vm.modalData.additionalData.startDate) {
        vm.modifiedStartDate = true;
      }

      // checking end date modified
      if (vm.modalData.unmodifiedData.endDate !== vm.modalData.additionalData.endDate) {
        vm.modifiedEndDate = true;
      }

      // checking amount modified
      if (vm.modalData.unmodifiedData.amount !==  vm.modalData.additionalData.installmentAmount) {
        vm.modifiedAmount = true;
      }

      // checking top up details modified
      if (!vm.modalData.unmodifiedData.topupDetails && vm.modalData.additionalData.sipTopupEnabled) {
        vm.modifiedTopup = true;
      }

      if (vm.modalData.unmodifiedData.topupDetails && vm.modalData.additionalData.sipTopupEnabled) {

        if (!vm.modalData.additionalData.topupDetails.percentage && (vm.modalData.unmodifiedData.topupDetails.amount !== vm.modalData.additionalData.topupDetails.amount)) {
          vm.modifiedTopupAmount = true;
        }

        if (!vm.modalData.unmodifiedData.topupDetails.amount && (vm.modalData.unmodifiedData.topupDetails.percentage !== vm.modalData.additionalData.topupDetails.percentage)) {
          vm.modifiedTopupPercentage = true;
        }

        if (vm.modalData.unmodifiedData.topupDetails.frequency !== vm.modalData.additionalData.topupDetails.frequency) {
          vm.modifiedTopupFrequency = true;
        }

        if (!vm.modalData.additionalData.topupDetails.capMonthYear && (vm.modalData.unmodifiedData.topupDetails.capAmount !== vm.modalData.additionalData.topupDetails.capAmount)) {
          vm.modifiedTopupCapAmount = true;
        }

        if (!vm.modalData.additionalData.topupDetails.capAmount && ($window.moment(vm.modalData.unmodifiedData.topupDetails.capMonthYear,'MMM-YYYY').format('DD-MMM-YYYY') !== vm.modalData.additionalData.topupDetails.capMonthYear)) {
          vm.modifiedTopupCapMonth= true;
        }

      }

      if(vm.modalData.additionalData.paymentMode && vm.modalData.unmodifiedData.paymentOption && vm.modalData.unmodifiedData.paymentOption.length > 0 && (vm.modalData.additionalData.paymentMode.key !== vm.modalData.unmodifiedData.paymentOption[0].code)){
        vm.modifiedPaymentMode = true;
      }
      if(!vm.modalData.unmodifiedData.paymentOption && vm.modalData.additionalData.paymentMode && (vm.modalData.additionalData.paymentMode.key !== 'EC') || (vm.modalData.unmodifiedData.paymentOption && vm.modalData.unmodifiedData.paymentOption.length == 0 && vm.modalData.additionalData.paymentMode && (vm.modalData.additionalData.paymentMode.key !== 'EC'))){
        vm.modifiedPaymentMode = true;
      }

      if(vm.modalData.additionalData.sipFirstInstallment && !vm.modalData.unmodifiedData.sipWithFirstInstallment){
        vm.modifedSipWithFiDetails = true;
      }

      if(vm.modalData.unmodifiedData.sipWithFirstInstallment && !vm.modalData.additionalData.sipFirstInstallment){
        vm.modifedSipWithFiDetails = true;
      }

      if(vm.modalData.unmodifiedData.topupDetails && !vm.modalData.additionalData.sipTopupEnabled){
        vm.modifiedSipTopUpEnabled = true;
      }

      if(vm.modalData.unmodifiedData.paymentOption && vm.modalData.unmodifiedData.paymentOption.length > 0 && vm.modalData.additionalData.paymentMode && (vm.modalData.additionalData.paymentMode.key == "OTM")){
        if(vm.modalData.unmodifiedData.folioBankDetails && vm.modalData.additionalData.otmBank && (vm.modalData.unmodifiedData.folioBankDetails.bankAcNo !== vm.modalData.additionalData.otmBank.bankAcNo)){
          vm.modifiedBankAccountNo = true;
        }
        if(vm.modalData.unmodifiedData.folioBankDetails && vm.modalData.additionalData.otmBank && (vm.modalData.unmodifiedData.folioBankDetails.bankName !== vm.modalData.additionalData.otmBank.bankName)){
          vm.modifiedBankName = true;
        }
        if(!vm.modalData.unmodifiedData.folioBankDetails && vm.modalData.additionalData.otmBank){
          vm.modifiedBankAccountNo = true;
          vm.modifiedBankName = true;
        }
      }

      if(vm.modalData.unmodifiedData.paymentOption && vm.modalData.unmodifiedData.paymentOption.length > 0 && vm.modalData.additionalData.paymentMode && (vm.modalData.additionalData.paymentMode.key == "HEM")){
        if(vm.modalData.unmodifiedData.folioBankDetails && vm.modalData.additionalData.accountNumber && (vm.modalData.unmodifiedData.folioBankDetails.bankAcNo !== vm.modalData.additionalData.accountNumber)){
          vm.modifiedBankAccountNo = true;
        }
        if(vm.modalData.unmodifiedData.folioBankDetails && vm.modalData.additionalData.eMandateBank && (vm.modalData.unmodifiedData.folioBankDetails.bankName !== vm.modalData.additionalData.eMandateBank)){
          vm.modifiedBankName = true;
        }
      }

      if(vm.modalData.unmodifiedData.paymentOption && vm.modalData.unmodifiedData.paymentOption.length == 0 && vm.modalData.additionalData.paymentMode && (vm.modalData.additionalData.paymentMode.key == "OTM" || vm.modalData.additionalData.paymentMode.key == "HEM")){
        vm.modifiedBankAccountNo = true;
        vm.modifiedBankName = true;
      }

      if(vm.modalData.unmodifiedData.firstInstallmentDetails && vm.modalData.additionalData.fiPaymentMode){
        if(vm.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == "OTM" && vm.modalData.additionalData.fiPaymentMode.key == "HEM"){
          if(vm.modalData.unmodifiedData.firstInstallmentDetails.bankName !== vm.modalData.additionalData.fiOtmBankName){
            vm.modifiedFiOtmBankName = true;
          }
          if(vm.modalData.unmodifiedData.firstInstallmentDetails.bankAccNo !== vm.modalData.additionalData.fiOtmAccNo){
            vm.modifiedFiOtmAccNo = true;
          }
        }

        if (vm.modalData.unmodifiedData.firstInstallmentDetails.paymentMode !== vm.modalData.additionalData.fiPaymentMode.key) {
          vm.modifiedPaymentModeSI = true;
        }

        if (vm.modalData.additionalData.fiPaymentMode.key == 'OTM' && vm.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == "OTM" && vm.modalData.unmodifiedData.firstInstallmentDetails.bankAccNo !== vm.modalData.additionalData.fiOtmAccNo) {
          vm.modifiedFIbank = true;
        }
      }
    }


    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    if (modalData.payload[0]) {
      if (modalData.payload[0].formType === 'SIP' && modalData.payload[0].sipTopupEnabled) {
        vm.topupCapMonthYear = $window.moment(vm.modalData.additionalData.topupDetails.capMonthYear, "DD-MMM-YYYY").format('MMM-YYYY');
      }
    }
    vm.initiateTransaction = function () {
      vm.disableButton = true;
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if(vm.isFromQuickSip) {
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp);
          } else if (resp && resp.message) {
            MessageService.error(resp.message);
          }
        } else {
          $uibModalInstance.close(resp);
        }
        vm.disableButton = false;
      }, error = function (err) {
        vm.disableButton = false;
        LoaderService.hideLoader('.popup');
        if (vm.isFromQuickSip) {
          UtilService.errorHandler(err);
        } else {
          $uibModalInstance.dismiss(err);
        }
      };



      var controllerName = vm.modalData.controller == 'flexstp' ? 'stp' : vm.modalData.controller;
      if(vm.modalData && vm.modalData.controller == 'dream_sip'){
        var dreamSippayload =  [vm.makeDreamSippayload()];
        LoaderService.showLoader('.popup');
        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          controller: 'many',
          child2: 'initiate'
        }, dreamSippayload).$promise.then(success, error);
      } else if (modalData.controller === 'ECART') {
        success();
      } else{
        TransactionService.post({
          VERSION: HDFC_API.VERSION,
          controller: controllerName,
          child2: vm.modalData.controller !== 'add' ? 'initiate' : ''
        }, vm.modalData.payload).$promise.then(success, error);
      }
    };

    vm.makeDreamSippayload = function(){
      var payload = {
        "installmentAmount": vm.modalData.additionalData.installmentAmount,
        "investmentOption": vm.modalData.additionalData.investmentOption,
        "dividendOption": vm.modalData.additionalData.devidendOptions,
        "formType": vm.modalData.additionalData.formType,
        "frequency": vm.modalData.additionalData.sipFrequency,
        "euinName": vm.modalData.additionalData.euinName,
        "euinCode": vm.modalData.additionalData.euinCode,
        "folioNumber": vm.modalData.additionalData.folioNumber,
        "option": vm.modalData.additionalData.sipOptions,
        "schemeCode": vm.modalData.additionalData.schemeCode,
        "schemeType": vm.modalData.additionalData.inSchemeType,
        "targetSchemeCode": vm.modalData.additionalData.targetSchemeCode ? vm.modalData.additionalData.targetSchemeCode : "",
        "swapAmount":vm.modalData.additionalData.swapInstallmentAmount,
        "sipWithFirstInstallment":vm.modalData.additionalData.sipFirstInstallment,
        "sipDay": null,
        "sipTopupEnabled": vm.modalData.additionalData.sipTopupEnabled,
        "sipDate": vm.modalData.additionalData.startDate,
        "toDate": vm.modalData.additionalData.endDate ,
        "payMech": vm.modalData.additionalData.paymentOption === "UPI"? "UAP": vm.modalData.additionalData.paymentOption,
        "sipPeriod":vm.modalData.additionalData.sipTenure
      }
      if(vm.modalData.additionalData.startDate){
        var sipDaylist = vm.modalData.additionalData.startDate.split('-');
        payload.sipDay = sipDaylist[0];
      }
      if(vm.modalData.additionalData.sipTopupEnabled){
        payload.topupDetails = vm.modalData.additionalData.topupDetails;
      }
      if(payload.option == "Option A"){
        payload.option = "A";
      }
      if(payload.option == "Option B"){
        payload.option = "B";
      }

      if(vm.modalData.additionalData.paymentOption == 'OTM'){
        payload.payMech = vm.modalData.additionalData.paymentOption;
        payload.payoutId = vm.modalData.additionalData.bankInfo.payoutId;
        payload.omUmrn = vm.modalData.additionalData.bankInfo.omUmrn;
        payload.firstInstallmentDetails = {
          payMech : vm.modalData.additionalData.paymentOption,
          payoutId : vm.modalData.additionalData.bankInfo.payoutId,
          omUmrn : vm.modalData.additionalData.bankInfo.omUmrn,
        }
      }
      if(vm.modalData.additionalData.paymentOption == 'EC'){
       if(payload.sipWithFirstInstallment){
        payload.firstInstallmentDetails = {};
        if(vm.modalData.additionalData.bankInfo.payMech == 'OTM'){
          payload.firstInstallmentDetails.omUmrn =  vm.modalData.additionalData.bankInfo.omUmrn;
          payload.firstInstallmentDetails.amount = vm.modalData.additionalData.installmentAmount;
          payload.firstInstallmentDetails.paymentMode = vm.modalData.additionalData.bankInfo.payMech;
          payload.firstInstallmentDetails.payoutId = vm.modalData.additionalData.bankInfo.payoutId;
        }else{
          payload.firstInstallmentDetails = {
            "paymentMode": "WEB"
          }
        }
       }
      }
      if(vm.modalData.additionalData.paymentOption == 'HEM'){
        payload.bankDetailsForECS = {
          "accNumber": vm.modalData.additionalData.bankInfo.accountNumber,
          "accType": vm.modalData.additionalData.bankInfo.bankAcType,
          "authenticationMode": vm.modalData.additionalData.authenticationMode.value,
          "bankCity": vm.modalData.additionalData.bankInfo.bankCity,
          "bankCode": vm.modalData.additionalData.bankInfo.bankCode,
          "bankName": vm.modalData.additionalData.bankInfo.bankName,
          "branchName": vm.modalData.additionalData.bankInfo.bankBranch,
          "gateWayVendor": vm.modalData.additionalData.bankInfo.gateWayVendor,
          "ifscCode": vm.modalData.additionalData.bankInfo.ifscCode,
          "paymentOption": "HEM"
        }

        payload.mandateAmount =  vm.modalData.additionalData.mandateAmount;
        payload.mandateStartDate = vm.modalData.additionalData.mandateStartDate;
        payload.mandateEndDate  = vm.modalData.additionalData.mandateEndDate;
      }
      if(vm.modalData.additionalData.subBrokerArn){
        payload.subBrokerArn = 'ARN-'+vm.modalData.additionalData.subBrokerArn;
      }
      if(vm.modalData.additionalData.subBrokerCode){
        payload.subBrokerCode = vm.modalData.additionalData.subBrokerCode;
      }

      if(vm.modalData.additionalData.paymentOption == 'UPI'){
        payload.bankDetailsForECS = {
          "accNumber": vm.modalData.additionalData.bankInfo.accountNumber,
          "branchName": vm.modalData.additionalData.bankInfo.bankBranch,
          "bankName": vm.modalData.additionalData.bankInfo.bankName,
          "accType":vm.modalData.additionalData.bankInfo.bankAcType,
          "bankCity":vm.modalData.additionalData.bankInfo.bankCity
        }
      }
      return payload;
    }

    vm.initiateTransactionRollover = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if(resp.popupEnabled) {
          $uibModalInstance.close();
          ModalService.genericModal({
            text: resp.message
          })
        } else {
          $uibModalInstance.close(resp);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.dismiss(err)
      };

      LoaderService.showLoader('.popup');

      var controllerName = vm.modalData.controller;
      DistributorGenericService.post({
        controller: controllerName,
        child1: 'create'
      }, vm.modalData.payload).$promise.then(success, error);

    };

    vm.initiateChangeDividend = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.close(resp);
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.dismiss(err)
      };

      LoaderService.showLoader('.popup');

      ChangeDividendService.post({
        child1: 'v2',
        child2: 'nft',
        child3: 'initiate'
      }, vm.modalData.payload).$promise.then(success, error);

    };


    vm.sendOTP = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp && resp.status) {
            vm.uuid = resp.data.id;
            vm.isOTPSent = true;
          } else MessageService.error(resp.message);
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.isOTPSent = false;
          MessageService.error();
        };
      var payload = {
        email: vm.modalData.additionalData.emailId,
        folioNumber: vm.modalData.payload.folioNumber || vm.modalData.additionalData.folioNumber,
        newEmail: vm.newEmailId
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'folio',
        child1: 'contact-details',
        child2: 'edit'
      }, payload).$promise.then(success, error);
    }

    vm.verifyOTP = function () {
      var success = function (resp) {
          vm.emailOTP = '';
          LoaderService.hideLoader('.popup');
          if (resp && resp.status) {
            vm.modalData.additionalData.emailId = vm.newEmailId;
            vm.isOTPSent = false;
            vm.isEdit = false;
            MessageService.success(resp.data.message);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.isOTPSent = false;
          vm.isEdit = false;
          vm.emailOTP = '';
          MessageService.error();
        };
      var payload = {
        otp: vm.emailOTP,
        uniqueLink: vm.uuid
      }
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'folio',
        child1: 'otp',
        child2: 'verify'
      }, payload).$promise.then(success, error);
    }

    /**
     * function responsible to initiate emandate
     */
    vm.initiateEmandateTransaction = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.close(resp);
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.dismiss(err)
      };
      LoaderService.showLoader('.popup');
      delete vm.modalData.payload.fequency;
      delete vm.modalData.payload.purpose;
      delete vm.modalData.payload.accountType;
      var controllerName = vm.modalData.controller;
      DistributorGenericService.post({
        controller: controllerName,
        child2: 'initiate'
      }, vm.modalData.payload).$promise.then(success, error);

    };

    /**
     * function responsible to initiate flex sip
     */

    vm.initiateTransactionFlexSip = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.close(resp);
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.dismiss(err)
      };

      LoaderService.showLoader('.popup');

      var controllerName = vm.modalData.controller;
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: controllerName,
        child2: 'initiate'
      }, vm.modalData.payload[0]).$promise.then(success, error);

    };


    vm.initiateTransactionSipModify = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        $uibModalInstance.close(resp);
      }, error = function (err) {
        LoaderService.hideLoader();
        $uibModalInstance.dismiss(err)
      };

      LoaderService.showLoader();

      var controllerName = 'systematic';

      var cancelPayload = {
        "transactionId": vm.modalData.unmodifiedData.transactionID,
        "transactionType": "SIP",
        "folioNumber": vm.modalData.unmodifiedData.folioNumber,
        "amount": vm.modalData.unmodifiedData.amount,
        "frequency": vm.modalData.unmodifiedData.autoFrequency,
        "schemeCode": vm.modalData.unmodifiedData.schemeCode,
        "topupDetails" : vm.modalData.unmodifiedData.topupDetails
      }

      if(vm.modalData.payload[0].topupDetails && vm.modalData.payload[0].topupDetails.capMonthYear){
        vm.modalData.payload[0].topupDetails.capMonthYear = moment(vm.modalData.payload[0].topupDetails.capMonthYear).format('DD-MMM-YYYY');
      }

      var diffInMonthsOfDates = parseInt(moment(vm.modalData.payload[0].toDate).diff(moment(vm.modalData.payload[0].sipDate), 'months', true));
      if(diffInMonthsOfDates >= 6 && vm.modalData.additionalData.sipTopupEnabled){
        vm.modalData.payload[0].sipTopupEnabled = true;
      }else{
        vm.modalData.payload[0].sipTopupEnabled = false;
      }

      var payload = {
        sipForm : vm.modalData.payload[0],
        cancelSystematicTransactionCO : cancelPayload
      };

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: controllerName,
        child2: 'modify'
      }, payload).$promise.then(success, error);

    };

    vm.initiateInstantRedeemTransaction = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.close(resp);
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        $uibModalInstance.dismiss(err)
      };

      LoaderService.showLoader('.popup');
      // vm.modalData.payload.isInstantRedemption = true;
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'redemption',
        child2: 'initiate'
      }, vm.modalData.payload).$promise.then(success, error);

    };

    /**
     * function responsible for fetching euin list
     */

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
          vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;

          if (vm.euinList && vm.euinList.length == 1 && vm.euinCode) {
            vm.euinChanged();
          }

          if (vm.modalData.payload[0].euinCode) {
            vm.euinCode = vm.modalData.payload[0].euinCode;
            vm.euinChanged();
          }
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    /**
     * function responsible for handling euin change
     */

    vm.euinChanged = function () {
      var filterEuin = vm.euinList.filter(function (euin) {
        return euin.euinCode == vm.euinCode;
      })[0];

      vm.modalData.payload[0].euinName = angular.copy(filterEuin.euinName);
      vm.modalData.payload[0].euinCode = angular.copy(filterEuin.euinCode);
      sessionStorage.setItem('eData',JSON.stringify(filterEuin));
    };

    /**
     * function responsible for handling quick sip review back button redirection for edit
     */

    function editQuickSip() {
      $uibModalInstance.dismiss();
      $state.go('main.transactions.initiate.sip', {
        uuid: vm.modalData.additionalData.investorUUID,
        schemeCode: vm.modalData.payload[0].schemeCode,
        folioNumber: vm.modalData.payload[0].folioNumber,
        transactionType: 'SIP',
        transactionId: '',
        fromModify: '',
        fromQuickSip : true
      });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('tpvController', tpvController);

  /** @ngInject */
  function tpvController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;


    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TermConditionModalController', termConditionModalController);

  /** @ngInject */
  function termConditionModalController($uibModalInstance, modalView, modalData, ModalService ,UtilService,HDFC_API) {
    var vm = this;
    vm.HDFC_API =HDFC_API;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.dynamicTermsSip = null;
    vm.dynamicTermsCondition = null;
    vm.dynamicTermsEmandate = null;
    vm.dynamicTermsFlexSip = null;
    vm.init = init();

    /*
    * fetching terms conditions
    */
    function init() {
      var successHandler = function(resp) {
        vm.dynamicTermsSip = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SIP;
        vm.dynamicTermsCondition = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General;
        vm.dynamicTermsEmandate = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_EMANDATE;
        vm.dynamicTermsSmartSwap = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_SMART_SWAP;
        vm.dynamicTermsFlexSip = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_FlEX_SIP;
        vm.dynamicTermsSipModiyOtm = resp.termAndConditionDTO.termAndConditionDTOMap.MODIFY_TNC_OTM;
        vm.dynamicTermsEcart = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_General_Ecart;
        vm.dynamicTermsAddToBank = resp.termAndConditionDTO.termAndConditionDTOMap.TNC_COBM;
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.showGeneralTnc = function() {
      if(vm.dynamicTermsCondition) {
        ModalService.termConditionModal({});
      }
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SystematicCancellationModalController', systematicCancellationModalController);

  /** @ngInject */
  function systematicCancellationModalController($uibModalInstance, modalView, modalData,$state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();

      if (vm.modalData.data.txnType === 'SIP' || vm.modalData.data.txnType === 'DREAMSIP' || vm.modalData.data.txnType === 'FLEXSIP') {
        $state.go('main.sipcorner');
      }
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SuccessModalController', successModalController);

  /** @ngInject */
  function successModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SubscribeToggleController', subscribeToggleController);

  /** @ngInject */
  function subscribeToggleController(UtilService, $uibModalInstance, modalView, modalData, LoaderService, MessageService,DistributorProfileService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.notificationDetails = null;
    vm.reasonForOptingOut = '';

    vm.closeModal = function () {
      $uibModalInstance.close('close');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.confirmUnsubscribe = function () {

      var success = function (resp) {
        LoaderService.hideLoader();
        MessageService.success(resp.data.message);
      }, error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.data.message);
      };

      LoaderService.showLoader();
      DistributorProfileService.post({
        child1: 'marketing',
        child2: 'subscribe'
      }, {unSubscriptionReason:vm.reasonForOptingOut}).$promise.then(success, error);
      vm.closeModal();
    }


  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipPauseConfirmatonModalController', sipPauseConfirmatonModalController);

  /** @ngInject */
  function sipPauseConfirmatonModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SignUpModalController', signUpModalController);

  /** @ngInject */
  function signUpModalController($uibModalInstance, $window, AuthService, modalView, modalData, AppConstants, LoaderService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.myRecaptchaResponse = '';
    vm.otpVerificationPayload = {
      otpNumber: "",
      registrationRequestId: (vm.modalData && vm.modalData.registrationRequestId) ? (vm.modalData.registrationRequestId) : ''
    };
    vm.signupForm = {};
    vm.otpForm = {};
    vm.signupUser = {
      arnCode: "",
      bankAccountNumber: "",
      emailAddress: "",
      mobileNumber: ""
    };
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;
    vm.otpResendMessage = '';
    vm.errorMessage = '';

    vm.generateOtp = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status) {
            $uibModalInstance.close(resp);
          } else {
            vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
          }
          vm.processFlag = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        },
        payload = {
          arnCode: 'ARN-' + vm.signupUser.arnCode,
          bankAccountNumber: vm.signupUser.bankAccountNumber,
          emailAddress: vm.signupUser.emailAddress,
          mobileNumber: vm.signupUser.mobileNumber,
          gRecaptchaResponse: vm.myRecaptchaResponse//vcRecaptchaService.getResponse()
        };

      vm.errorMessage = '';
      vm.processFlag = true;
      LoaderService.showLoader('.popup');
      AuthService.generateOtp(payload).then(success, error);
    };

    vm.reGenerateOtp = function () {
      var success = function (resp) {
        vm.processOTPFlag = false;
        vm.otpResendMessage = 'OTP sent again successfully.';
        vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
      }, error = function (err) {
        vm.processOTPFlag = false;
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
      };
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      AuthService.reGenerateOtp(vm.otpVerificationPayload).then(success, error);
    };

    vm.verifyOtp = function () {
      var success = function (data) {
        LoaderService.hideLoader('.popup');
        if (data && data.status) {
          $uibModalInstance.close(data);
        } else {
          vm.errorMessage = data.message || AppConstants.ToastrMessage.FAILED;
        }
        vm.processFlag = false;
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
      };

      vm.otpVerificationPayload.otpNumber = vm.otpVerificationPayload.otpNumber.toString() + "";
      delete vm.otpVerificationPayload.__proto__;
      vm.errorMessage = '';
      vm.processFlag = true;
      AuthService.verifyOtp(vm.otpVerificationPayload).then(success, error);
    };

    vm.closeModal = function () {
      $uibModalInstance.close("sign up successfull");
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.goToNextEle = function () {
      // var myEl = angular.element($window.document.getElementsByTagName("iframe")[0].contentWindow);
      // myEl.addClass('recaptcha-checkbox-focused');
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('StayInvestedController', stayInvestedController);

  function stayInvestedController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ShowExitLoadModalController', showExitLoadModalController);

  function showExitLoadModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SelectAccountNoModalController', selectAccountNoModalController);

  /** @ngInject */
  function selectAccountNoModalController($uibModalInstance, modalView, modalData, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.bankAccounts = vm.modalData.bankAccounts? vm.modalData.bankAccounts : null;
    vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData.accountNo);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SelectFolioModalController', selectFolioModalController);

  /** @ngInject */
  function selectFolioModalController($uibModalInstance, modalView, modalData, AppConstants, LoaderService, UtilService, MessageService, $stateParams, InvestorsCommonService) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.formData = {};
    vm.tForm = {};
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.folioList = null;
    vm.investorUUID = $stateParams.uuid;
    vm.init = init;
    vm.folioChanged = folioChanged;
    init();

    function init() {
        // getFolioList();
      vm.folioList = vm.modalData.folioList;
    }

    // function getFolioList() {
    //   LoaderService.showLoader();
    //   var success = function(resp) {
    //     if (resp.status && resp.data) {
    //       LoaderService.hideLoader();
    //       var folioList = resp.data.folioList || [];
    //       var folio = [];
    //       var filteredFolioList = [];
    //       for (var i in folioList) {
    //         var obj = {}, item = folioList[i];
    //         obj.key = i;
    //         obj.activeFlag = item.activeFlag;
    //         obj.folioId = item.folioId;
    //         obj.folioNo = item.folioNumber;
    //         obj.minorFlag = item.minorFlag;
    //         obj.taxstatus = item.taxstatus;
    //         folio.push(obj);
    //       }
    //       // vm.folioList = folio;
    //       Object.keys(folio).forEach(function (key) {
    //         var obj = Object.assign({key: key}, folio[key]);
    //         if (vm.modalData.minor) {
    //           if (obj.minorFlag) {
    //             filteredFolioList.push(angular.copy(obj));
    //           }
    //         } else  {
    //           if (!obj.minorFlag) {
    //             filteredFolioList.push(angular.copy(obj));
    //           }
    //         }
    //       });
    //       vm.folioList = filteredFolioList.length ? filteredFolioList : null;
    //     } else {
    //       vm.folioList = null;
    //       LoaderService.hideLoader();
    //       MessageService.error(resp.message);
    //     }
    //   }, error = function(err) {
    //     LoaderService.hideLoader();
    //     vm.folioList = null;
    //     UtilService.errorHandler(err);
    //   };
    //   InvestorsCommonService.post({
    //     child1: 'getFolioList'
    //   },{panNumber: vm.modalData.panNumber}).$promise.then(success, error);
    // }



    function folioChanged() {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.selectedFolio = vm.folioList.filter(function(folio) {
        return folio.folioNo === vm.formData.folioNumber;
      });
      sessionStorage.setItem('isMinorFolioSelected', vm.selectedFolio[0].minorFlag);
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData.folioNumber);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SearchInvestorModalController', searchInvestorModalController);

  /** @ngInject */
  function searchInvestorModalController($uibModalInstance, modalView, modalData, $document, $http, UtilService, $q, AppConstants, LoaderService, $timeout, InvestorsService, MessageService, HDFC_API, moment, ModalService, InvestorServiceDynamicData , $window , $cookies) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.errorMessage = '';
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.searchResult = null;
    vm.selectedInvestor = null;
    vm.errorMessageDOB = null;
    vm.searchString = '';
    vm.isSearching = false;
    vm.timeout = null;
    vm.investorDob = null;
    vm.isUpdateInfo = modalData.isUpdateInfo?modalData.isUpdateInfo:false;
    vm.init = init();

    vm.updateSoleInfo = function () {
      if (!vm.investorDob) {
        MessageService.error('dob is required field');
        return;
      }
      if (!vm.selectedInvestor) {
        MessageService.error('Please select an investor');
        return;
      }
      var payload = {
        dob: vm.investorDob.format('DD-MMM-YYYY'),
        id: vm.selectedInvestor.uuid
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'info',
        child1: 'update'
      }, payload).$promise.then(function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(vm.selectedInvestor);
            vm.isUpdateInfo = false;
          } else {
            vm.errorMessage = resp.message;
          }
        }, function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        });
    };

    vm.updateInvestorDB = function () {
      if (!vm.investorDob) {
        MessageService.error('dob is required field');
        return;
      }
      if (!vm.modalData.uuid) {
        MessageService.error('Please select an investor');
        return;
      }
      var payload = {
        dob: vm.investorDob.format('DD-MMM-YYYY'),
        id: vm.modalData.uuid
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'info',
        child1: 'update'
      }, payload).$promise.then(function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close();
          } else {
            vm.errorMessageDOB = resp.message;
          }
        }, function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        });
    };


    function validateInvestor(investor) {
      var deferred = $q.defer();
      var payload = {"investorUUID": investor.uuid};
      if(vm.modalData && vm.modalData.isStatement) {
        payload.statementFlow = true;
      }
      vm.isUpdateInfo = false;

      var success = function (resp) {
        var investorInfo = null;
        var taxIdentifierInfo = null;

        if (resp.status && resp.data) {
          investorInfo = resp.data;
          var panPayload = {
            pan: investorInfo.panNumber
          }
          if(vm.modalData && vm.modalData.isStatement) {
            panPayload.statementFlow = true;
          }
          InvestorsService.post({
            controller: 'pan',
            child1: 'verify'
          }, panPayload).$promise.then(function (resp) {
              if (resp.status && resp.data) {
                taxIdentifierInfo = resp.data;
                if (investorInfo.minor && !investorInfo.gpanValid) {
                  deferred.reject({message: "Guardian's PAN is not verified for selected investor"});
                } else if (!investorInfo.minor && !taxIdentifierInfo.verify) {
                  deferred.reject({message: "KYC verification is pending for selected investor"});
                } else if (false && !investorInfo.dob) { // dob check made disabled
                  vm.isUpdateInfo = true;
                  deferred.reject({message: "Please update dob for selected investor"});
                } else {
                  deferred.resolve();
                }
              } else {
                deferred.reject({message: resp.message || "Investor's PAN info not found"})
              }
            }, function (err) {
              deferred.reject({message: err && err.message || "Something going wrong,Please try after some time."});
            });
        } else {
          if(resp.popupEnabled) {
            $uibModalInstance.dismiss();
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            deferred.reject({message: resp.message || "Investor's sole applicant details not found"})
          }
        }
      }, error = function (err) {
        deferred.reject({message: err && err.message || "Something going wrong,Please try after some time."});
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      return deferred.promise;
    }

    vm.dismissModal = function () {
      vm.searchResult = null;
      vm.selectedInvestor = null;
      vm.searchString = '';
      vm.isSearching = false;
      vm.isSubmitted = false;
      vm.errorMessage = '';
      $uibModalInstance.dismiss();
    };

    vm.searchTimeBetweenKeypress = function () {
      if (vm.timeout) {
        $timeout.cancel(vm.timeout);
      }
      vm.timeout = $timeout(function () {
        vm.search();
      }, 300);

      vm.showMessage = false;
    };

    vm.search = function () {
      vm.investorDob = null;
      vm.isUpdateInfo = false;
      vm.selectedInvestor = null;
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          resp = resp.data;
          if (resp.status && resp.data) {
            vm.searchResult = resp.data.searchResponse;
            for(var i=0;i<vm.searchResult.length; i++){
              var result1 = vm.searchResult[i].result;
              var find = result1.indexOf('-');
              vm.searchResult[i].result1 =result1.substring(0,find);
              vm.searchResult[i].result2 = result1.substring(find+1);
            }
            vm.errorMessage = !vm.searchResult.length ? "No result found" : "";
          } else {
            !resp.status && MessageService.error(resp.message)
          }
          angular.element("#search-result").show();
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

      if (!vm.searchString) {
        vm.searchResult = null;
      }

      if (vm.isSearching || !vm.searchString || vm.searchString.length < 2) {
        return;
      }

      vm.isSearching = true;

      $timeout(function () {
        vm.isSearching = false;
      }, 200);

      LoaderService.showLoader('.popup');

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/search/' + vm.searchString;
      $http.post(_path, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(success, error);
    };

    vm.setInvestor = function (data,index) {
      vm.selectedInvestor = data;
      LoaderService.showLoader();
      var taxIdentifier = vm.searchResult[index].panNumber;
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            vm.showMessage = true;
            vm.nomineeMessage = resp.data.popUpMessage;
            vm.folioList = resp.data.folioList;
            vm.searchString = vm.selectedInvestor.result;
            vm.isSubmitted = false;
            vm.errorMessage = '';
            angular.element("#search-result").hide();
            $timeout(function () {
              angular.element("#continueBtn").focus();
            }, 100);
          } else {
            vm.showMessage = false;
            vm.searchString = vm.selectedInvestor.result;
            vm.isSubmitted = false;
            vm.errorMessage = '';
            angular.element("#search-result").hide();
            $timeout(function () {
              angular.element("#continueBtn").focus();
            }, 100);
          }
        }
      } , error = function(err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
      }

      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : taxIdentifier
      }).$promise.then(success, error);
    };

    vm.continue = function () {
      vm.isSubmitted = true;
      var success = function () {
        sessionStorage.removeItem('modifySipData');
        $uibModalInstance.close(vm.selectedInvestor);
        LoaderService.hideLoader('.popup');
      }, error = function (err) {
        vm.errorMessage = err.message;
        LoaderService.hideLoader('.popup');
      };

      if (vm.selectedInvestor) {
        LoaderService.showLoader('.popup');
        if (vm.modalData.transactionType === 'Redemption' || vm.modalData.transactionType === 'Systematic Withdrawal Plan') {
          LoaderService.hideLoader('.popup');
          validateInvestor(vm.selectedInvestor).then(success, error);
        } else {
          validateInvestor(vm.selectedInvestor).then(success, error);
        }
      } else {
        MessageService.error('Please search/select an investor');
      }
    };

    vm.changeInvestorDob = function (date) {
      vm.errorMessageDOB = null
      vm.investorDob = moment(date);
    };

    $document.mouseup(function (e) {
      var container1 = angular.element("#search-result");
      var container2 = angular.element("#search-box");
      if (!container1.is(e.target) && !container2.is(e.target) && container1.has(e.target).length === 0) {
        container1.hide();
      } else {
        container1.show();
      }
    });

    function init() {
      if (vm.modalData.transactionType) {
        switch(vm.modalData.transactionType) {
          case "DTP":
            vm.title = "TIP";
            break;
          case "ChangeDividend":
            vm.title = "Change IDCW";
            break;
          case "SMARTSWAP":
            vm.title = "SMART SWAP";
            break;
          case "FLEXSIP" :
            vm.title = "Flex SIP"
            break;
          default:
            vm.title = vm.modalData.transactionType;
            break;
        }
      }
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SchemeListModalController', schemeListModalController);

  /** @ngInject */
  function schemeListModalController($uibModalInstance, UtilService, modalView, modalData, SchemeService,TransactionArnService, LoaderService, MessageService, ModalService, $state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.SchemeList = null;
    vm.schemesList = null;
    vm.selectedSchemeType = '';
    vm.isCheckedFromArnHardcoded = false;


    vm.fetchSchemes = function (schemeType) {
      vm.selectedSchemeType = schemeType.toUpperCase();
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemesList = resp.data.schemeList;
          /*if(vm.modalData.enabledScheme == "purchaseenabled" && !vm.modalData.retirementFundApplicable){
            for(var i=0;i<vm.schemesList.length;i++){
              var scheme = vm.schemesList[i];
              if(scheme.schemeCode == 'HRHRP' || scheme.schemeCode == 'HRERP' || scheme.schemeCode == 'HRDHR' ){
                vm.schemesList.splice(i, 1);
                i--;
              }
            }
          }*/
        } else {
          MessageService.error(resp.message);
          vm.schemesList = null;
        }
      }, error = function (err) {
        if(err.data.error == 'invalid_token' && vm.modalData.keyFrom == 'harnHardcoded'){
          vm.fromBack = true;
          $uibModalInstance.dismiss({"fromBack":vm.fromBack});
          return;
        }
        LoaderService.hideLoader('.popup');
        vm.schemesList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');


      if(vm.modalData.transactionType==='flexindex'){
        var payload= {
          minor: vm.modalData.isMinor,
          portalName: "",
          schemeType: vm.selectedSchemeType,
          taxStatusCode: "",
          investThroughDistributor: false,
          corporateFlag: vm.modalData.corporateFlag
        };
        if(vm.modalData.isARN){
          TransactionArnService.post({
            controller1: 'schemes',
            controller2: 'target',
            controller3: 'flex-index-enabled'
          }, payload).$promise.then(success, error);
        }else{
          SchemeService.post({
            controller: 'schemes',
            child1: 'target',
            child2: 'flex-index-enabled'
          }, payload).$promise.then(success, error);
        }
      } else if(vm.modalData.transactionType==='bulkPurchase' || vm.modalData.transactionType === 'bulkSip') {
        var payload= {
          transactionType: vm.modalData.transactionType==='bulkPurchase' ? 'PURCHASE': 'SIP',
          flowName: 'BULK_TRANSACTION',
          schemeType: vm.selectedSchemeType
        };
        SchemeService.post({
          controller: 'bulkTrasnaction',
          child1: 'schemeList'
        }, payload).$promise.then(success, error);
      } else {
        if(vm.modalData.isARN){
           TransactionArnService.get({
            controller1: 'scheme',
            controller2: schemeType,
            controller3: vm.modalData.enabledScheme,
            controller4: false,
            controller5: vm.modalData.isThroughDistributor
          }, null).$promise.then(success, error);
        } else {
          SchemeService.get({
            controller: 'scheme',
            type: vm.selectedSchemeType,
            child1: vm.modalData.enabledScheme,
            child2: vm.modalData.isMinor,
            child3: vm.modalData.corporateFlag
          }, null).$promise.then(success, error);
        }
      }


    };
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.selectScheme = function (scheme) {
      scheme.selectedSchemeType=vm.selectedSchemeType;
      $uibModalInstance.close(scheme);

      if(scheme.schemeType === "NFO" && vm.modalData.enabledScheme == 'sipenabled'){
        var message = scheme.message;
        ModalService.nfoEnabledModal({message: message});
      }
      if(scheme.schemeType === "NFO" && vm.modalData.enabledScheme == 'stpenabled'){
        ModalService.nfoTransactionPointNotes();
      }
    };

    vm.init = function () {
        var payload = {
          minor : vm.modalData.isMinor,
          investThroughDistributor : true,
          transactionType : vm.modalData.enabledScheme
        }
      if(vm.modalData.transactionType==='flexindex'){
        payload.transactionType = 'flex-index-enabled';
      }
      if($state.current.name == "arnHardcoded"){
        vm.isCheckedFromArnHardcoded = true;
      }
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.fetchSchemes(vm.schemeTypeList[0]);
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        if(err.data.error == 'invalid_token' && vm.modalData.keyFrom == 'harnHardcoded'){
          vm.fromBack = true;
          $uibModalInstance.dismiss({"fromBack":vm.fromBack});
          return;
        }
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');
      if(vm.modalData.isARN){
        TransactionArnService.post({
          controller1: 'filteredSchemeType'
        }, payload).$promise.then(success, error);
      }else{
        SchemeService.post({
          controller: 'filteredSchemeType'
        }, payload).$promise.then(success, error);
      }
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SchemeInFundListModalController', schemeInFundListModalController);

  /** @ngInject */
  function schemeInFundListModalController($uibModalInstance, UtilService,AppConstants, modalView, modalData, SchemeService,TransactionArnService, LoaderService, MessageService,CmsEcartService, ModalService, $state ) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.SchemeList = null;
    vm.schemesList = null;
    vm.selectedSchemeType = '';
    vm.isCheckedFromArnHardcoded = false;
    vm.utilService = UtilService;
    vm.formData = {};
    vm.selectedscheme = {};
    vm.GetSchemeCategoryList = GetSchemeCategoryList;
    vm.GetSchemeCategoryDetailsList = GetSchemeCategoryDetailsList;
    vm.clearSearch = clearSearch;
    vm.getScheme = getScheme;
    vm.SCHEME_FUND_LIST = angular.copy(AppConstants.SCHEME_FUND_LIST);
    vm.showRecommendedFundOnTop = showRecommendedFundOnTop;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };



    vm.init = function () {
      vm.GetSchemeCategoryList();
      vm.GetSchemeCategoryDetailsList();

    };


    // get scheme category  list
    function GetSchemeCategoryList() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.schemeCategoryList = resp.data;
            vm.schemeCategoryList = vm.schemeCategoryList.filter(function(category){
              return category !== 'ETF'
            })
            vm.selectedschemeCategory = vm.schemeCategoryList[0];
            setGetDefaultData();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      CmsEcartService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category',
        child5: 'list'
      }).$promise.then(success, error);
    }
     vm.tempArray = [];
    vm.changewithFilterName = function () {
      if (vm.schemeCategoryDetailsList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
            if (vm.filterwithname) {
              var filterschemarray = [];
              vm.selectedschemeCategoryDetails.forEach(function (filterlist) {
                var fundName = new String(filterlist.fundName.toUpperCase());
                var filterName = new String(vm.filterwithname.toUpperCase());
                if (fundName.indexOf(filterName) > -1) {
                  if(filterlist.regularSchemes && filterlist.regularSchemes.length > 0) {
                    filterschemarray.push(filterlist);
                  }
                }
              });
              vm.selectedschemeCategoryDetails = filterschemarray;
              vm.tempArray = []
              vm.selectedscheme.investmentOption = 'Growth';
              vm.selectedschemeCategoryDetails.forEach(function (res1) {
                  var filteredArray = res1.regularSchemes.filter(function(itm){
                    return vm.selectedscheme.investmentOption == itm.investmentOption
                  });
                  if(filteredArray.length > 0){
                    res1.selectedScheme = {};
                    res1.selectedScheme = filteredArray[0];
                  }else{
                    res1.selectedScheme = null;
                  }
                vm.tempArray.push(res1);
              })

              vm.selectedschemeCategoryDetails = vm.tempArray;
            }

            if(vm.filterwithname == ''){
              setGetDefaultData();
            }
          }
        })
        showRecommendedFundOnTop(vm.selectedschemeCategoryDetails);
      }
    }

    // get scheme category details list
    function GetSchemeCategoryDetailsList() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.schemeCategoryDetailsList = resp.data;
            setGetDefaultData();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      CmsEcartService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'category'
      }).$promise.then(success, error);
    }

    // change scheme Category
    vm.changeSchemeCategory = function () {
      vm.selectedschemeCategoryDetails = [];
      if (vm.schemeCategoryDetailsList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            vm.selectedschemeCategoryDetails = [];
            res.funds.forEach(function (res) {
              res.Expand = false;
              if(res.regularSchemes && res.regularSchemes.length > 0) {
                vm.selectedschemeCategoryDetails.push(res);
              }
            })
           showRecommendedFundOnTop(vm.selectedschemeCategoryDetails);
          }
        })
      }
    }

    function clearSearch(){
      vm.filterwithname = ""
      vm.changewithFilterName();
    }

    function setGetDefaultData() {

      if (vm.schemeCategoryDetailsList && vm.schemeCategoryList) {
        vm.schemeCategoryDetailsList.forEach(function (res) {
          if (vm.selectedschemeCategory == res.type) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              res1.selectedScheme = null;
              tempArray.push(res1);
            });
            vm.selectedschemeCategoryDetails = tempArray;
          }
        })
        vm.selectedscheme.investmentOption = 'Growth';
        vm.schemeCategoryDetailsList.forEach(function (res) {
            var tempArray = [];
            res.funds.forEach(function (res1) {
              if(res1.regularSchemes) {
                var filteredArray = res1.regularSchemes.filter(function (itm) {
                  return vm.selectedscheme.investmentOption == itm.investmentOption
                });
                if (filteredArray.length > 0) {
                  res1.selectedScheme = {};
                  res1.selectedScheme = filteredArray[0];
                } else {
                  res1.selectedScheme = null;
                }
                tempArray.push(res1);
              }
            });
            tempArray = tempArray.sort(function (a, b) {
              if (a.selectedScheme === null) // a is null? last
                return 1;
              else (b.selectedScheme === null) // b is null? last
              return -1;
            })
            vm.selectedschemeCategoryDetails = tempArray;
          vm.changeSchemeCategory();
            showRecommendedFundOnTop(vm.selectedschemeCategoryDetails)
        })
      }
    }
    function getScheme(scheme){
      var data = {
        dividendPayoutApplicable: '',
        dividendReinvestmentApplicable: '',
        investmentOption: scheme.selectedScheme.investmentOption,
        scheme: scheme.selectedScheme.schemeName,
        schemeCode: scheme.selectedScheme.schemeCode,
        schemeType: scheme.selectedScheme.schemeType,
        fundCode: scheme.fundCode
      }
      $uibModalInstance.close(data);
    }

    function showRecommendedFundOnTop(getCategory){
      if(getCategory) {
        getCategory.sort(function (a, b) {
          if (a.recommended && !b.recommended) {
            return -1;
          } else if (!a.recommended && b.recommended) {
            return 1;
          } else {
            return 0;
          }
        });
        vm.selectedschemeCategoryDetails = getCategory;
      }
    }

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('RollOverModalController', rollOverModalController);

  /** @ngInject */
  function rollOverModalController($uibModalInstance, modalView,$log, $state, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;


    vm.closeModal = function () {
      $uibModalInstance.close();
      $state.go('main.rolloverView');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.submitForm =function(){
      $uibModalInstance.dismiss("cancel");
      vm.modalData && vm.modalData.saveRolloverRequest();
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(ModalService, MessageService, $state, $stateParams, AuthService, UtilService, AppConstants) {

    var vm = this,
      successReset = function (result) {
        MessageService.success(result.message);
        $state.go('login');
      }, errorReset = function (err) {
        UtilService.errorHandler(err)
      };
    vm.resetPasswordPayload = {
      arnCode: $stateParams.arnCode,
      newPassword: '',
      secretKey: $stateParams.secretKey,
      confirmPassword: ''
    };
    vm.resetForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.confirmErr = '';
    vm.processFlag = false;
    vm.showPasswordFlag = false;
    vm.passwordType = 'password';
    vm.confirmShowPasswordFlag = false;
    vm.confirmPasswordType = 'password';
    vm.showPassword = showPassword;
    vm.tooltipText = '<ul class="info-card"><li>1) Password should be between 8 to 15 character.</li><li>2) Atleast one special character @, $, _, !</li><li>3) Atleast one Upper case letter.</li><li>4) Atleast one lower case letter.</li><li>5) Atleast one number.</li></ul>';


    vm.reset = function () {
      if ($stateParams.arnCode && $stateParams.secretKey) {
        var verifyForgotPasswordPayload = {arnCode: $stateParams.arnCode, secretKey: $stateParams.secretKey},
          success = function (data) {
            if (data.status) {
              // ModalService.resetPasswordModal({}, successReset, errorReset);
            } else {
              MessageService.error(data.message)
            }
          }, error = function (err) {
            $state.go('login');
            UtilService.errorHandler(err);
          };
        AuthService.verifyForgotPassword(verifyForgotPasswordPayload).then(success, error);
      }
    };


    vm.reset();

    vm.updateErrorMsg = function () {
      vm.confirmErr = "";
    };

    vm.resetPassword = function () {
      var success = function (data) {
        vm.processFlag = false;
        vm.confirmErr = '';
        // ModalService.resetPasswordDoneModal(data);
        MessageService.success(data.message);
        $state.go('login');
      }, error = function (err) {
        vm.processFlag = false;
        vm.confirmErr = err && err.message || AppConstants.ToastrMessage.FAILED;
      };

      if (vm.resetPasswordPayload.newPassword && vm.resetPasswordPayload.confirmPassword && vm.resetPasswordPayload.newPassword !== vm.resetPasswordPayload.confirmPassword) {
        vm.confirmErr = AppConstants.ToastrMessage.RESET_PASSWORD.MISSMATCH;
      } else {
        vm.confirmErr = '';
        delete vm.resetPasswordPayload.__proto__;
        vm.processFlag = true;
        var payload = angular.copy(vm.resetPasswordPayload);
        payload.newPassword = AuthService.encryptRSA(angular.copy(vm.resetPasswordPayload.newPassword));
        payload.confirmPassword = AuthService.encryptRSA(angular.copy(vm.resetPasswordPayload.confirmPassword));
        AuthService.resetPassword(payload).then(success, error);
      }

    };
    function showPassword(value) {
      if(value == 'newPassword') {
        if (vm.showPasswordFlag) {
          vm.passwordType = 'password';
          vm.showPasswordFlag = false;
        } else {
          vm.passwordType = 'text';
          vm.showPasswordFlag = true;
        }
      } else if('confirmPassword') {
        if (vm.confirmShowPasswordFlag) {
          vm.confirmPasswordType = 'password';
          vm.confirmShowPasswordFlag = false;
        } else {
          vm.confirmPasswordType = 'text';
          vm.confirmShowPasswordFlag = true;
        }
      }
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ResetPasswordModalController', resetPasswordModalController);

  /** @ngInject */
  function resetPasswordModalController($uibModalInstance, $stateParams, AuthService, AppConstants, ModalService, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.resetPasswordPayload = {
      arnCode: $stateParams.arnCode,
      newPassword: '',
      secretKey: $stateParams.secretKey,
      confirmPassword: ''
    };
    vm.resetForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.confirmErr = '';
    vm.processFlag = false;

    vm.updateErrorMsg = function () {
      vm.confirmErr = "";
    };

    vm.resetPassword = function () {
      var success = function (data) {
        vm.processFlag = false;
        vm.confirmErr = '';
        $uibModalInstance.close(data);
        ModalService.resetPasswordDoneModal(data);
      }, error = function (err) {
        vm.processFlag = false;
        vm.confirmErr = err && err.message || AppConstants.ToastrMessage.FAILED;
      };

      if (vm.resetPasswordPayload.newPassword && vm.resetPasswordPayload.confirmPassword && vm.resetPasswordPayload.newPassword !== vm.resetPasswordPayload.confirmPassword) {
        vm.confirmErr = AppConstants.ToastrMessage.RESET_PASSWORD.MISSMATCH;
      } else {
        vm.confirmErr = '';
        delete vm.resetPasswordPayload.__proto__;
        vm.processFlag = true;
        var payload = angular.copy(vm.resetPasswordPayload);
        payload.newPassword = AuthService.encryptRSA(angular.copy(vm.resetPasswordPayload.newPassword));
        payload.confirmPassword = AuthService.encryptRSA(angular.copy(vm.resetPasswordPayload.confirmPassword));
        AuthService.resetPassword(payload).then(success, error);
      }

    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MessagePasswordController', messagePasswordController);

  /** @ngInject */
  function messagePasswordController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = 'Something error';

    if(modalData.Text){
    vm.modalData = modalData.Text;
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 8/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ChangePasswordModalController', changePasswordModalController);

  /** @ngInject */
  function changePasswordModalController($uibModalInstance, AuthService, AppConstants, modalView, modalData, UtilService) {

    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.changePasswordPayload = {
      // oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    };
    vm.resetForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;
    vm.confirmErr = '';
    vm.passwordExpireMsg = vm.modalData.errMsg;

    vm.init = function () {
      angular.element("#newPassword").focus();
    };

    vm.ontextChane=function () {
      if(!vm.changePasswordPayload.newPassword || !vm.changePasswordPayload.confirmPassword){
        vm.confirmErr = "";
      }
    };

    vm.changePassword = function () {
      /*if (vm.changePasswordPayload.newPassword == vm.changePasswordPayload.oldPassword) {
        vm.confirmErr = "Old Password and New Password should not be match";
        return;
      }*/

      if(vm.changePasswordPayload.newPassword != vm.changePasswordPayload.confirmPassword){
        vm.confirmErr = "New Password and Confirm Password does not match";
        return;
      }
      var success = function (data) {
        vm.processFlag = false;
        if (data.status){
          vm.confirmErr = '';
          $uibModalInstance.close(data);
        }else{
          vm.confirmErr = data.message;
        }
      }, error = function (err) {
        vm.processFlag = false;
        vm.confirmErr = '';
        UtilService.errorHandler(err);
      };

      if(vm.passwordExpireMsg === "Password Expired"){
        var switchUrl = true;
      }
      if (vm.changePasswordPayload.newPassword && vm.changePasswordPayload.confirmPassword && vm.changePasswordPayload.newPassword !== vm.changePasswordPayload.confirmPassword) {
        vm.confirmErr = AppConstants.ToastrMessage.RESET_PASSWORD.MISSMATCH;
      }else{
        vm.confirmErr='';
        vm.processFlag = true;
        AuthService.changePassword({
          "newPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.newPassword)),
          // "oldPassword": AuthService.encryptRSA(angular.copy(vm.changePasswordPayload.oldPassword)),
          "arnCode" : "ARN-"+vm.modalData.arn
        },switchUrl).then(success, error);
      }
    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.copyPasteHandler=function (e) {
      vm.confirmErr = '';
      var key = e.keyCode?e.keyCode:e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('PurchaseSchedulerRecomendationModal', purchaseSchedulerRecomendationModal);

  /** @ngInject */
  function purchaseSchedulerRecomendationModal($stateParams,$window,$uibModalInstance, modalView, modalData, TransactionArnService,MessageService,AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.RISK_METER = AppConstants.RISK_METER;
    vm.riskmeterMap = new Map();
    for(var i=0;i < vm.RISK_METER.length;i++){
      vm.riskmeterMap.set(vm.RISK_METER[i].key,vm.RISK_METER[i])
    }
    vm.resp = {};
    vm.CategoryList = [];
    vm.schemeCategory = "";
    vm.schemeData = null;
    var tempArray = [];
    var tempArray2 = [];
    vm.getUniqueValues = function (el) {
      var uniqueObjects = [];
      var seenObjects = {};
      for (var i = 0; i < el.length; i++) {
        var obj = el[i];
        var key = obj.fundCode;

        if (!seenObjects[key]) {
          seenObjects[key] = true;
          uniqueObjects.push(obj);
        }
      }
      return uniqueObjects;
    }
    vm.catList = [];
    vm.setGetDraftData = function () {
      if (vm.InvestmentGoalDetails) {
        vm.InvestmentGoalDetails.forEach(function (res) {
          vm.SelectedInvestmentGoalDetailsList = res.funds;
          vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
            for (var i = 0; i < vm.fundCode.length; i++) {
              if (item.fundCode == vm.fundCode[i]) {
                var tempObj = {};
                tempObj.fundName = item.fundName;
                if(vm.modalData.ARN == 'DIRECT'){
                  if(item.fundNavDirect && item.fundNavDirect.nav_amount && item.fundNavDirect.nav_amount['1']){
                    tempObj.navValue = item.fundNavDirect.nav_amount['1'];
                  }
                  if(item.fundNavDirect && item.fundNavDirect.nav_date && item.fundNavDirect.nav_date['1']){
                    tempObj.navDateTimestamp = item.fundNavDirect.nav_date['1'];
                  }
                }else{
                  if(item.fundNavRegular && item.fundNavRegular.nav_amount && item.fundNavRegular.nav_amount['1']){
                    tempObj.navValue = item.fundNavRegular.nav_amount['1'];
                  }
                  if(item.fundNavRegular && item.fundNavRegular.nav_date && item.fundNavRegular.nav_date['1']){
                    tempObj.navDateTimestamp = item.fundNavRegular.nav_date['1'];
                  }
                } 
                tempObj.selected = false;
                // tempObj.benchmarkForFund = item.benchmarkForFund;
                tempObj.risk = item.riskReturnProfile;
                tempObj.schemeData = null;
                tempObj.fundCategory = item.fundCategory[0];
                vm.catList.push(item.fundCategory[0]);
                var schemeCodeList = [];
                if(vm.modalData.ARN == 'DIRECT'){
                  if (item.directSchemes) {
                    item.directSchemes.forEach(function (val) {
                      schemeCodeList.push(val);
                    });
                  }
                }else{
                  if (item.regularSchemes) {
                    item.regularSchemes.forEach(function (val) {
                      schemeCodeList.push(val);
                    });
                  }
                }
                tempObj.schemes = schemeCodeList;
                if(tempObj.schemes && tempObj.schemes.length > 0){
                  var purchaseEnabledScheme = [];
                  tempObj.schemes.forEach(function (el) {
                    if(el.purchaseEnabled){
                      purchaseEnabledScheme.push(el);
                    }
                  });
                  tempObj.schemes = purchaseEnabledScheme;
                }
                if(tempObj.schemes.length > 0){
                  tempObj.schemes.forEach(function(val){
                    if(val.investmentOption && val.investmentOption.toUpperCase() == "GROWTH"){
                      tempObj.schemeData = val; 
                    }
                  });
                }
                if(tempObj.schemeData && tempObj.schemeData.schemeCode){
                  tempObj.selected = true;
                }
                if(vm.riskmeterMap.has(tempObj.risk)){
                  tempObj.riskmeter = vm.riskmeterMap.get(tempObj.risk).img;
                  tempObj.riskicon = vm.riskmeterMap.get(tempObj.risk).icon;
                }
                tempObj.fundCode = item.fundCode;
                if(tempObj.schemes.length > 0){
                  tempArray.push(tempObj);
                }
              }
              vm.catList.push(item.fundCategory[0]);
            }
          });
          if (tempArray.length > 1) {
            vm.SelectedInvestmentGoalDetailsList = vm.getUniqueValues(tempArray);
          } else {
            vm.SelectedInvestmentGoalDetailsList = tempArray;
          }
          vm.recFund = vm.SelectedInvestmentGoalDetailsList;
          vm.masterFundList = vm.SelectedInvestmentGoalDetailsList;
        });

        vm.InvestmentGoalDetails.forEach(function (res) {
          vm.SelectedInvestmentGoalDetailsList = res.funds;
          vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
            for (var j = 0; j < vm.otherFundCode.length; j++) {
              if (item.fundCode == vm.otherFundCode[j]) {
                var tempObj = {};
                tempObj.fundName = item.fundName;
                if(vm.modalData.ARN == 'DIRECT'){
                  if(item.fundNavDirect && item.fundNavDirect.nav_amount && item.fundNavDirect.nav_amount['1']){
                    tempObj.navValue = item.fundNavDirect.nav_amount['1'];
                  }
                  if(item.fundNavDirect && item.fundNavDirect.nav_date && item.fundNavDirect.nav_date['1']){
                    tempObj.navDateTimestamp = item.fundNavDirect.nav_date['1'];
                  }
                }else{
                  if(item.fundNavRegular && item.fundNavRegular.nav_amount && item.fundNavRegular.nav_amount['1']){
                    tempObj.navValue = item.fundNavRegular.nav_amount['1'];
                  }
                  if(item.fundNavRegular && item.fundNavRegular.nav_date && item.fundNavRegular.nav_date['1']){
                    tempObj.navDateTimestamp = item.fundNavRegular.nav_date['1'];
                  }
                } 
                tempObj.selected = false;
                // tempObj.benchmarkForFund = item.benchmarkForFund;
                tempObj.risk = item.riskReturnProfile;
                tempObj.schemeData = null;
                tempObj.fundCategory = item.fundCategory[0];
                vm.catList.push(item.fundCategory[0]);
                var schemeCodeList = [];
                if(vm.modalData.ARN == 'DIRECT'){
                  if (item.directSchemes) {
                    item.directSchemes.forEach(function (val) {
                      schemeCodeList.push(val);
                    });
                  }
                }else{
                  if (item.regularSchemes) {
                    item.regularSchemes.forEach(function (val) {
                      schemeCodeList.push(val);
                    });
                  }
                }
                tempObj.schemes = schemeCodeList;
                if(tempObj.schemes && tempObj.schemes.length > 0){
                  var purchaseEnabledScheme = [];
                  tempObj.schemes.forEach(function (el) {
                    if(el.purchaseEnabled){
                      purchaseEnabledScheme.push(el);
                    }
                  });
                  tempObj.schemes = purchaseEnabledScheme;
                }
                if(tempObj.schemes.length > 0){
                  tempObj.schemes.forEach(function(val){
                    if(val.investmentOption && val.investmentOption.toUpperCase() == "GROWTH"){
                      tempObj.schemeData = val; 
                    }
                  });
                }
                if(tempObj.schemeData && tempObj.schemeData.schemeCode){
                  tempObj.selected = true;
                }
                if(vm.riskmeterMap.has(tempObj.risk)){
                  tempObj.riskmeter = vm.riskmeterMap.get(tempObj.risk).img;
                  tempObj.riskicon = vm.riskmeterMap.get(tempObj.risk).icon;
                }
                tempObj.fundCode = item.fundCode;
                if(tempObj.schemes.length > 0){
                  tempArray2.push(tempObj);
                }
              }
              vm.catList.push(item.fundCategory[0]);
            }
          });
          if (tempArray2.length > 1) {
            vm.SelectedInvestmentGoalDetailsList2 = vm.getUniqueValues(tempArray2);
          } else {
            vm.SelectedInvestmentGoalDetailsList2 = tempArray2;
          }
          vm.otherFund = vm.SelectedInvestmentGoalDetailsList2;
          vm.masterFundList2 = vm.SelectedInvestmentGoalDetailsList2;
        });
        vm.CategoryList = vm.distinctArray(vm.catList);
      }
    }
    vm.categoryDetailsList = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.allFund = [];
          vm.InvestmentGoalDetails = resp.data;
          vm.InvestmentGoalDetails.forEach(function (res) {
            vm.SelectedInvestmentGoalDetailsList = res.funds;
            vm.SelectedInvestmentGoalDetailsList.forEach(function (item) {
              if (item.fundCode) {
                vm.allFund.push(item.fundCode);
              }
            });
          });
          vm.allFundList = vm.distinctArray(vm.allFund);
         var result = vm.allFundList.filter(function(x) {
            return !vm.fundCode.includes(x)
          });
          vm.otherFundCode = result;
          vm.setGetDraftData();
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          vm.processFlag = true;
          MessageService.error(err.data.message);
        };
      TransactionArnService.get({
        controller1: 'new',
        controller2: 'user',
        controller3: 'fund',
        controller4: 'investmentGoal'
      }).$promise.then(success, error);
    }
    vm.recommendedFunds = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.fundCode = resp.data.fundList;
          vm.categoryDetailsList();
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err.data.message);
      };
      if($stateParams.x){
       var arn =  $window.atob($stateParams.x);
      }else{
        var arn = "0005";
      }
      TransactionArnService.get({
        controller1: "arnRecommendedSchemes",
        controller2: "ARN-"+arn,
        controller3: "PURCHASE_SCHEDULER"
      }).$promise.then(success, error);
    }
    vm.recommendedFunds();
    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };
    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.changeSchemeCategory = function () {
      vm.recFund = [];
      vm.otherFund = [];
      var tempRecFund = [];
      var tempRecFund2 = [];
      vm.masterFundList.forEach(function (val) {
        if (val.fundCategory == vm.schemeCategory) {
          tempRecFund.push(val);
        }
      });
      vm.recFund = tempRecFund;

      vm.masterFundList2.forEach(function (val) {
        if (val.fundCategory == vm.schemeCategory) {
          tempRecFund2.push(val);
        }
      });
      vm.otherFund = tempRecFund2;
      if(!vm.schemeCategory){
        vm.recFund = vm.masterFundList;
        vm.otherFund = vm.masterFundList2;
      }
    }
    vm.changeScheme = function (fundCode, value) {
      if (value == null) {
        if(fundCode){
          vm.recFund.forEach(function (element, index) {
            if (element.fundCode == fundCode) {  
              vm.recFund[index].selected = false;
            }
          });
          vm.otherFund.forEach(function (element, index) {
            if (element.fundCode == fundCode) {  
              vm.otherFund[index].selected = false;
            }
          });
        }
        return;
      }
      if (value && fundCode) {
        vm.recFund.forEach(function (element, index) {
          if (element.fundCode == fundCode) {
            element.schemes.forEach(function (element2) {
              if (element2.schemeCode == value.schemeCode) {
                vm.recFund[index].selected = true;
              }
            })
          }
        });
      }
      if (value && fundCode) {
        vm.otherFund.forEach(function (element, index) {
          if (element.fundCode == fundCode) {
            element.schemes.forEach(function (element2) {
              if (element2.schemeCode == value.schemeCode) {
                vm.otherFund[index].selected = true;
              }
            })
          }
        });
      }
    }
    vm.investnow = function (cData) {
      var data = {};
      vm.schemeData = cData;
      if (vm.schemeData) {
        data = {
          investmentOption: vm.schemeData.investmentOption,
          nfoEnabled: vm.schemeData.nfoEnabled,
          scheme: vm.schemeData.schemeName,
          schemeCode: vm.schemeData.schemeCode,
          schemeType: vm.schemeData.schemeType
        }
        if (vm.schemeData.investmentOption == "Dividend") {
          data.investmentOption = "DIVIDEND";
          data.dividendPayoutApplicable = "Y";
          data.dividendReinvestmentApplicable = "Y";
        } else {
          data.investmentOption = "GROWTH";
        }
      }

      $uibModalInstance.close(data);
    }
    vm.distinctArray = function (value) {
      vm.fil2 = new Set();
      var tem = [];
      value.forEach(function (el) {
        if (!vm.fil2.has(el) && el !="") {
          tem.push(el);
          vm.fil2.add(el);
        }
      });
      return tem;
    }
    vm.changewithFilterName = function(){
      vm.recFund = [];
      vm.otherFund = [];
      vm.masterFundList.forEach(function(el){
        if(el.fundName.toLowerCase().includes(vm.filterwithname.toLowerCase())){
          vm.recFund.push(el);
        }
      });
      vm.masterFundList2.forEach(function(el){
        if(el.fundName.toLowerCase().includes(vm.filterwithname.toLowerCase())){
          vm.otherFund.push(el);
        }
      });
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('PopupsModalController', popupsModalController);

  /** @ngInject */
  function popupsModalController($uibModalInstance, $window, modalView, modalData, $state, ModalService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.openLink = function () {
      $window.open("https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf");
    };
    vm.redirectToAddBank = function () {
      if(vm.modalData && vm.modalData.bankLength && vm.modalData.bankLength >= 5){
        ModalService.addBankMsg();
        $uibModalInstance.close();
      }else {
        $state.go('main.addBank');
        $uibModalInstance.close();
      }
    }
    }
})();

/**
 * Created by ttn on 13/01/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OtpModalController', otpModalController);

  /** @ngInject */
  function otpModalController($uibModalInstance, $timeout, $scope, $log, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorsContactService, InvestorsNewFolioContactService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.formData = {};

    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
    };

    vm.verifyOtp = function () {
      if (vm.modalData.component === 'folio') {
        vm.verifyOtpforFolio();
      } else if(vm.modalData.component === 'new_folio') {
        vm.verifyOtpforNewFolio();
      }
    };

    vm.verifyOtpforFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.status) {
          MessageService.success(resp.data.message);
          vm.closeModal();
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader();
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        otp: vm.formData.otpNumber,
        otp2: vm.formData.newOtpNumber,
        uniqueLink: vm.secLink || vm.modalData.secLink,
        uniqueLink2: vm.secLink2 || vm.modalData.secLink2
      };
      LoaderService.showLoader();
      vm.errorMessage = '';

      InvestorsContactService.post({
        controller: 'folio',
        child1: 'verify',
        child2: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.verifyOtpforNewFolio = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp && resp.status) {
          MessageService.success(resp.data.message);
          vm.closeModal();
        } else {
          MessageService.error(resp.message);
        }
        vm.processFlag = false;
      }, error = function () {
        LoaderService.hideLoader();
        vm.processFlag = false;
        vm.errorMessage = AppConstants.ToastrMessage.FAILED;
      };
      var payload = {
        otp: vm.formData.otpNumber,
        otp2: vm.formData.newOtpNumber,
        uniqueLink: vm.secLink || vm.modalData.secLink,
        uniqueLink2: vm.secLink2 || vm.modalData.secLink2
      };
      LoaderService.showLoader();
      vm.errorMessage = '';

      InvestorsNewFolioContactService.post({
        controller: 'holder',
        child1: 'pan',
        child2: 'add',
        child3: 'email',
        child4: 'verify',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };

    vm.resendOtp = function () {
      if (vm.modalData.component === "folio") {
        vm.resendFolioOtp();
      } else if(vm.modalData.component === "new_folio") {
        vm.resendNewFolioOtp();
      }
    };
    vm.resendNewFolioOtp = function () {
      vm.formData.otpNumber = '';
      vm.formData.newOtpNumber = '';
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.data) {
          vm.processOTPFlag = false;
          vm.modalData.respMessage = resp.data.message;
          vm.secLink = resp.data.secretLink,
          vm.secLink2 = resp.data.secretLink2
          resetTimer();
        } else {
          vm.processOTPFlag = true;
          vm.errorMessage = resp && resp.data.message || AppConstants.ToastrMessage.FAILED;
          MessageService.error(vm.errorMessage);
        }
      }, error = function () {
        LoaderService.hideLoader('.popup');
        vm.processOTPFlag = false;
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.respMessage = '';
      var payload = {
        pan: vm.modalData.pan,
        dob: vm.modalData.dob,
        secretLink: vm.modalData.secLink,
        secretLink2: vm.modalData.secLink2
      }
      if(vm.modalData.newEmailId) {
        payload.email = vm.modalData.newEmailId;
        payload.change = "EMAIL";
      } else if (vm.modalData.newMobileNumber)  {
        payload.mobileNo = vm.modalData.newMobileNumber;
        payload.change = "MOBILE";
      }
      LoaderService.showLoader('.popup');
      InvestorsNewFolioContactService.post({
        controller: 'unit-holder',
        child1:'2FA',
        child2: 'update',
        child3: 'contact',
        child4: 'send',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    };


    vm.resendFolioOtp = function () {
      vm.formData.otpNumber = '';
      vm.formData.newOtpNumber = '';
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp && resp.data) {
          vm.modalData.respMessage = resp.data.message;
          vm.uuid = resp.data.id;
          vm.secLink = resp.data.secretLink;
          vm.secLink2 = resp.data.secretLink2;
          resetTimer();
        } else {
          vm.errorMessage = resp && resp.data.message || AppConstants.ToastrMessage.FAILED;
          MessageService.error(vm.errorMessage);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      var payload = {
        folioNumber: vm.modalData.folioNumber,
        secretLink: vm.modalData.secLink,
        secretLink2: vm.modalData.secLink2
      };
      if(vm.modalData.newEmailId){
        payload.oldValue = vm.modalData.currEmail;
        payload.value = vm.modalData.newEmailId;
        payload.changeFor = 'EMAIL';
      }else {
        payload.oldValue = vm.modalData.currMobileNumber;
        payload.value = vm.modalData.newMobileNumber;
        payload.changeFor = 'MOBILE';
      }
      vm.errorMessage = '';
      vm.otpResendMessage = '';
      LoaderService.showLoader('.popup');
      InvestorsContactService.post({
        controller: 'update',
        child1: 'folio',
        child2: 'contact-details'
      }, payload).$promise.then(success, error);
    };
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }
  }
})();

/**
 * Created by ttn on 28/02/23.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OptOutNomineeModalController', optOutNomineeModalController);

  /** @ngInject */
  function optOutNomineeModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OfflineNomineeFormController', OfflineNomineeFormController);

  /** @ngInject */
  function OfflineNomineeFormController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 28/02/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NudgeReasonsController', nudgeReasonsController);

  /** @ngInject */
  function nudgeReasonsController($uibModalInstance,$state,$window, modalView, modalData, ModalService, LoaderService, TransactionService, UtilService, MessageService, InvestorServiceDynamicData,HDFC_API) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.initiateSipCancel = initiateSipCancel;
    vm.stayInvested = stayInvested;
    vm.nudgePopupData = {};
    vm.nudgeReason = '';
    vm.nudgeReasonChange = nudgeReasonChange;
    vm.reasonsList = [];
    vm.initiateCancel = initiateCancel;
    vm.showSipNudge = false;
    vm.placeHolderText = "Enter reason... Only upto 100 characters";
    vm.maxLength = 100;
    vm.init = init();

    function init() {
      if (vm.modalData.transactionType === 'SIP' || vm.modalData.transactionType === 'DREAMSIP' || vm.modalData.transactionType === 'FLEXSIP') {
        setReasonsList();
        if (!vm.modalData.approveRequest) {
          fetchNudgeID();
        }
      }
    }

    function setReasonsList() {
      vm.nudgePopupData = vm.modalData.nudgeData.nudgePopupData;

      if (vm.modalData.transactionType === 'SIP' || vm.modalData.transactionType === 'DREAMSIP' || vm.modalData.transactionType === 'FLEXSIP') {
        vm.reasonsList =  vm.modalData.nudgeData.nudgePopupData.sipCancellationReasons;
        vm.showSipNudge = true;
        vm.maxLength = 200;
        vm.placeHolderText = "Enter reason... Only upto 200 characters";
      }

      if (vm.modalData.approveRequest && vm.modalData.nudgeData.reasons && vm.modalData.nudgeData.reasonCode) {
        vm.nudgeReason = vm.modalData.nudgeData.reasons;
        vm.nudgeReasonCode = vm.modalData.nudgeData.reasonCode;
        if (vm.nudgeReason === 'Others') {
          vm.nudgeOtherReason = vm.modalData.nudgeData.nudgeOtherReason;
        }
      }
    }

    function nudgeReasonChange(reason) {
      if (vm.showSipNudge) {
        vm.nudgeReason = reason.reasonDetail;
        vm.nudgeReasonCode = reason.reasonCode;
      } else {
        vm.nudgeReason = reason;
      }
    }

    vm.closeModal = function (resp) {
      $uibModalInstance.close(resp);
    };

    vm.dismissModal = function () {
      LoaderService.hideLoader();
      $uibModalInstance.dismiss('cancel');
    };


    function initiateSipCancel() {

      vm.modalData.payload.reasons = vm.nudgeReason;
      vm.modalData.payload.reasonCode = vm.nudgeReasonCode;
      if(vm.nudgeReason === 'Others'){
        vm.modalData.payload.nudgeOtherReason = vm.nudgeOtherReason;
      }
      vm.modalData.payload.nudgeRequestId = vm.requestID;

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            $uibModalInstance.dismiss('cancel');
            resp.data.txnType = vm.modalData.transactionType;
            ModalService.systematicCancellation(resp);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        }

      LoaderService.showLoader();

      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'systematic',
        child2: 'cancel'
      }, vm.modalData.payload).$promise.then(success, error);
    }

    function stayInvested() {
      vm.closeModal('stay');
    }


    function initiateCancel() {
      if ((vm.modalData.transactionType === 'SIP' || vm.modalData.transactionType === 'DREAMSIP' || vm.modalData.transactionType === 'FLEXSIP') && !vm.modalData.approveRequest) {
        initiateSipCancel();
      } else if ((vm.modalData.transactionType === 'SIP' || vm.modalData.transactionType === 'DREAMSIP' || vm.modalData.transactionType === 'FLEXSIP') && vm.modalData.approveRequest) {
        approveSipCancel();
      }
    }

    function fetchNudgeID() {
      var success = function(resp) {
          if(resp.status && resp.data) {
            vm.requestID = resp.data.requestId;
          }
          else {
            MessageService.error("Something went wrong");
          }

        },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      var payload = {
        "folioNumber": vm.modalData.payload.folioNumber,
        "popUpType": "SIP_PAUSE_CANCELLATION_NUDGE",
        "nudgePopup": true,
        "nudgeSuccess": false
      }

      InvestorServiceDynamicData.post({
        child1: 'nudge',
        child2: 'request'
      },payload).$promise.then(success, error);
    }

    function approveSipCancel() {

      vm.modalData.payload.reasons = vm.nudgeReason;
      vm.modalData.payload.reasonCode = vm.nudgeReasonCode;
      if(vm.nudgeReason === 'Others'){
        vm.modalData.payload.nudgeOtherReason = vm.nudgeOtherReason;
      } else if (vm.modalData.payload.nudgeOtherReason) {
        delete vm.modalData.payload.nudgeOtherReason
      }
      $uibModalInstance.close(vm.modalData.payload);

    }
  }
})();

/**
 * Created by ttn on 29/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NotificationModalController', notificationModalController);

  /** @ngInject */
  function notificationModalController(UtilService, $uibModalInstance, modalView, modalData, MessageService, NotificationService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.notificationDetails = null;

    vm.closeModal = function () {
      $uibModalInstance.close('close');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.init = function () {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.notificationDetails = resp.data;
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      NotificationService.post({
        controller: 'notificationDetails'
      }, {id: vm.modalData.id}).$promise.then(success, error);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NonOtmFolioDetailsController', nonOtmFolioDetailsController);

  /** @ngInject */
  function nonOtmFolioDetailsController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.folioNumber = vm.modalData.folio? vm.modalData.folio.folioNumber : '';
    vm.email = vm.modalData.folio? vm.modalData.folio.email : '';
    vm.mobileNumber = vm.modalData.folio? vm.modalData.folio.mobileNumber : '';
    vm.folioHolderName = vm.modalData.folio? vm.modalData.folio.folioHolderName : '';

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NfoTransactionNotesModalController', NfoTransactionNotesModalController);

  NfoTransactionNotesModalController.$inject = ['$uibModalInstance', 'modalView', 'modalData'];
  /** @ngInject */
  function NfoTransactionNotesModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NfoEnabledModalController', nfoEnabledModalController);

  /** @ngInject */
  function nfoEnabledModalController($uibModalInstance, modalView, modalData, AppConstants) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('NewJourneyFolioSwitchController', newJourneyFolioSwitchController);
  
    /** @ngInject */
    function newJourneyFolioSwitchController($uibModalInstance, $timeout, $scope, $log, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorsService, FolioApproval, $rootScope, HDFC_API) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.appConstants = AppConstants; 
      vm.closeModal = function (message) {
        $uibModalInstance.close(message);
      };
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
    }
  })();
  
  
(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('NewJourneyFolioSelectController', newJourneyFolioSelectController);

  /** @ngInject */
  function newJourneyFolioSelectController($uibModalInstance, modalData, modalView,$state,AuthService,AppConstants,MessageService,InvestorServiceDynamicData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.investorDetails = JSON.parse(sessionStorage.getItem("userData"));
    vm.tokenData = AuthService.getToken();
    vm.addStandAlonFolioKey = function(pan,arnCode,key){
      var success = function (resp) {
      },error = function () {
        MessageService.error(AppConstants.ToastrMessage.FAILED);
      };
      var payload = {
        "panNumber":pan,
        "arnCode":arnCode,
        "folioWithoutTransaction": key
      };
      InvestorServiceDynamicData.post({
        child1: 'new',
        child2: 'user',
        child3: 'addStandaloneFolioKey'
      },payload).$promise.then(success, error);
    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
      $state.go('main.dashboard');
    };
    vm.folioWithTransaction = function(){
      vm.folioWithoutTransaction = false;
      localStorage.removeItem('skipInvestmentDetails');
      vm.addStandAlonFolioKey(vm.investorDetails.panNumber, vm.investorDetails.arnCode,'N');
      $uibModalInstance.close(vm.folioWithoutTransaction);
    }
    vm.folioWithoutTransaction =function (){
      vm.folioWithoutTransaction = true;
      localStorage.setItem('skipInvestmentDetails', true);
      vm.addStandAlonFolioKey(vm.investorDetails.panNumber, vm.investorDetails.arnCode,"Y");
      $uibModalInstance.close(vm.folioWithoutTransaction);
    }
  }
})();
(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('NewJourneyFolioConditionController', newJourneyFolioConditionController);

    /** @ngInject */
    function newJourneyFolioConditionController($uibModalInstance, modalView, modalData,LoaderService,InvestorModel,$window, $state,MessageService,InvestorsService,UtilService) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.foliotype = '';
      vm.fetchEmailMobileKYC = fetchEmailMobileKYC

      vm.closeModal = function () {
        $uibModalInstance.close();
      };

      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };


  vm.searchInvestor = function () {
    var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.searchResult = resp.data && resp.data.searchResponse;
          vm.investorUUID = vm.searchResult[0].uuid;
          vm.investorInformation();
        } else {
          vm.searchResult = null;
          !resp.status && MessageService.error(resp.message)
        }
      },
      error = function () {
        vm.searchResult = null;
        LoaderService.hideLoader();
        MessageService.error();
      };

    InvestorsService.post({
      controller: 'search',
      child1: vm.modalData.payload.pan
    }, null).$promise.then(success, error);

  };

      vm.additionalFolio = function(){
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status && resp.data.verify) {
              InvestorModel.resetInvestorModel();
              var model = InvestorModel.getNewInvestorModel();
              model.folioCreationRequestCO.soleApplicantDetail.name = vm.investorInfo.name;
              model.folioCreationRequestCO.soleApplicantDetail.dob = vm.investorInfo.dob;
              model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.investorInfo.panNumber;
              model.folioCreationRequestCO.soleApplicantDetail.minor = vm.investorInfo.minor;
              model.folioCreationRequestCO.soleApplicantDetail.email = vm.investorInfo.email ? vm.investorInfo.email.trim() : "";
              model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.investorInfo.mobileNumber ? vm.investorInfo.mobileNumber.trim() : "";
              model.folioCreationRequestCO.soleApplicantDetail.ekycStatus = vm.investorInfo.ekycStatus ? vm.investorInfo.ekycStatus : null;
              model.folioCreationRequestCO.nriFlag = typeof vm.modalData.payload.nriTaxStatus == 'boolean'? vm.modalData.payload.nriTaxStatus == false? false: true : null;
              model.folioCreationRequestCO.showNomineeUpdate = vm.sebiNomineeRegulatory01650Active;
              model.folioCreationRequestCO.nomineeLimit = vm.nomineeLimit;
              InvestorModel.setInvestorModel(model);
              InvestorModel.setFolioCreationFromProfileAndToDo(true);
              delete $window.sessionStorage.investorForm;
              $window.sessionStorage.investorForm = angular.toJson(model);
              if (resp.data.verify === true) {
                $uibModalInstance.close();
                $state.go('main.investors.add.holdmode', null, { reload: 'main.investors.add.holdmode' });
              }else{
                MessageService.error('KYC not verified');
              }
          }else{
              MessageService.error(resp.message);
          }
      }, error = function (error) {
          MessageService.error(error.message);
      }
      var payload = {
          pan: vm.modalData.payload.pan
      };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'pan',
        child1: 'verify'
      }, payload).$promise.then(success, error);
      }

      vm.investorInformation =  function(){
        var payload = {"investorUUID": vm.investorUUID};

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.investorInfo = resp.data;
            fetchEmailMobileKYC();
          } else {
            vm.investorInfo = null;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          //setDefaults();
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
          vm.investorInfo = null;
        };
        LoaderService.showLoader();
        InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      }

      vm.folioTypeData=function(){
        $uibModalInstance.close({
          folioWithTransaction:vm.foliotype
        });
      }

      function fetchEmailMobileKYC() {
        var success = function (resp) {
            if (resp.status) {
              vm.investorInfo.mobileNumber = resp.data.mobileNumber
              vm.investorInfo.email = resp.data.email
              vm.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
              vm.nomineeLimit = resp.data.nomineeLimit;
              vm.additionalFolio();
            }
          },
          error = function () {
            MessageService.error("something went wrong")
          };
        vm.payload = {
          pan: vm.investorInfo.panNumber,
          dob: vm.investorInfo.dob,
          transactionEnabled : true
        };
        InvestorsService.post({
          child1: 'pan',
          child2: 'details'
        }, vm.payload).$promise.then(success, error);
      }



}
  })();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('NewInvestorOtpVerifyController', newInvestorOtpVerifyController);
  
    /** @ngInject */
    function newInvestorOtpVerifyController($uibModalInstance,InvestorsService4, $timeout, $scope, $log, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorsService, FolioApproval, $rootScope, HDFC_API) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.appConstants = AppConstants;
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.otpResendMsg = '';
      vm.otpForm = {};
      vm.isProcessing = false;
      vm.isOtpValid = true;
      vm.counter = 0
  
      vm.closeModal = function (message) {
        $uibModalInstance.close(message);
      };
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      };
  
      vm.resetValues = function () {
        vm.errorMessage = "";
      };
  
      vm.confirmTransaction = function (){
        if (!vm.otpNumber) {
          MessageService.error(vm.validateData.OTP_REQUIRED);
          return;
        }
        vm.isProcessing = true;
        LoaderService.showLoader('.popup');
        var payload = {
          "otp": vm.otpNumber,
          "uniqueLink": vm.modalData.uniqueLink
        };
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            vm.incorrectOtpCounter+=1;
            if(vm.incorrectOtpCounter==6){
              vm.otpValid=false;
            }
            MessageService.error(resp.message)
          //  $uibModalInstance.close(resp.data);
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
        var config = {
          controller: 'folio',
          child1: vm.modalData.type,
          child2: 'otp',
          child3: 'confirm'
        };
        if(vm.modalData.type == 'holder'){
          InvestorsService4.post(config, payload).$promise.then(success, error);
        }else{
          InvestorsService.post(config, payload).$promise.then(success, error);
        } 
      };
  
      vm.resendOtp = function () {
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.otpResendMessage = 'OTP sent again successfully.';
            resetTimer();
          } else {
            vm.otpResendMessage = '';
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.otpResendMessage = '';
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
        FolioApproval.get({
          VERSION: version,
          controller: 'otp',
          child2: vm.modalData.uniqueLink,
          child3: true
        }, null).$promise.then(success, error);
      };
  
      function resetTimer() {
        $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
      }
    }
  })();
  
  
(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('NewInvestorDirectionController', NewInvestorDirectionController);
  
    /** @ngInject */
    function NewInvestorDirectionController($uibModalInstance, $state,$rootScope, modalView, modalData, AppConstants) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.selectAction = "0";
      vm.message = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.investorDetails = JSON.parse(sessionStorage.getItem("userData"));
      vm.closeModal = function () {
        // sessionStorage.setItem("userAction",vm.selectAction);
        if(vm.selectAction == "0"){
          $state.go('main.newinvestor.investmentDetails.select-scheme.scheme');
        }else if(vm.selectAction == "1"){
          $state.go('main.newinvestor.investmentDetails.select-scheme.scheme');
        } 
        $uibModalInstance.close();
      }; 
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      }; 
    }
  })();
  
/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ModifyBankModalController', modifyBankModalController);

  /** @ngInject */
  function modifyBankModalController($uibModalInstance, $window, $scope, modalView, modalData, LoaderService, InvestorFileUploadService, ModalService, MessageService, UtilService, InvestorsService, DownloadPdfService, HDFC_API, FileUploadService, FileSaver, InvestorsCommonService, AppConstants, $stateParams) {

    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.selectedDefault = 0;
    vm.chooseAFileNew = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investorId = $stateParams.investorId;
    vm.changeModifyDefaultBank = changeModifyDefaultBank;
    vm.changeDeleteBank = changeDeleteBank;
    vm.uploadChequeLeafFile = uploadChequeLeafFile;
    vm.openUploadedDoc = openUploadedDoc;
    vm.rejectConfirm = rejectConfirm;

    vm.folioId = (vm.modalData) && vm.modalData.modalPayload ? vm.modalData.modalPayload.folioNumber : undefined;
    vm.bankDetails = (vm.modalData) && vm.modalData.modalPayload ? vm.modalData.modalPayload.bankDetails : undefined;
    vm.requestType = vm.modalData.requestType ? vm.modalData.requestType: null;
    var bankdetails = [];
    for (var i in vm.bankDetails) {
      if (!vm.bankDetails[i].defaultBank) {
        bankdetails.push(vm.bankDetails[i]);
      }
    }

    if (vm.requestType === 'modify') {
      vm.selectedModifyBank = bankdetails[0];
      changeModifyDefaultBank(vm.selectedModifyBank);
    }
    else if (vm.requestType === 'delete') {
      vm.selectedDeleteBank = bankdetails[0];
      changeDeleteBank(vm.selectedDeleteBank);
    }

    vm.closeModal = function (dataFromApi) {
      localStorage.removeItem('bankDetails');
      localStorage.removeItem('InvestorName')
      $uibModalInstance.close(dataFromApi);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    function changeDeleteBank(banks) {
      vm.deleteBank = {};
      vm.deleteBank.payload = {
        //bankAccountNumber: banks.accountNumber,
        folioNumber: vm.folioId,
        accountType: banks.accountType,
        payoutMechanism: banks.payoutMethod,
        accountNumber: banks.accountNumber,
        ifsccode: banks.ifscCode,
        bankCity: banks.branchCity,
        bankBranch: banks.branchName || '',
        makeDefaultBank: false,
        bankName: banks.bankName,
        chequeLeaf:'',
        payoutId:modalData.modalPayload.bankDetails[0].payoutId
      };
    }

    vm.submitDeleteBank = function () {
      var success = function (res) {
        LoaderService.hideLoader('.deleteBank-loader');
        if (res.status) {
          vm.closeModal(res.data);
        }
        else {
          if(res.popupEnabled) {
            ModalService.genericModal({
              text: res.message
            })
          } else {
            MessageService.error(res.message);
          }
        }
      };
      var error = function (err) {
        LoaderService.hideLoader('.deleteBank-loader');
        UtilService.errorHandler(err);
      };

      LoaderService.showLoader('.deleteBank-loader');

      var payload = {
        accountHolderName: vm.modalData.modalPayload.investorFullName,
        accountNumber: vm.modalData.modalPayload.bankDetails[0].accountNumber ? vm.modalData.modalPayload.bankDetails[0].accountNumber: '',
        accountType: vm.modalData.modalPayload.bankDetails[0].accountType? vm.modalData.modalPayload.bankDetails[0].accountType: '',
        bankBranch: vm.modalData.modalPayload.bankDetails[0].branchName? vm.modalData.modalPayload.bankDetails[0].branchName: '',
        bankCity: vm.modalData.modalPayload.bankDetails[0].branchCity? vm.modalData.modalPayload.bankDetails[0].branchCity: '',
        bankName: vm.modalData.modalPayload.bankDetails[0].bankName? vm.modalData.modalPayload.bankDetails[0].bankName: '',
        folioNumber: vm.modalData.modalPayload.folioNumber,
        ifscCode: vm.modalData.modalPayload.bankDetails[0].ifscCode? vm.modalData.modalPayload.bankDetails[0].ifscCode: '',
        makeDefaultBank: false,
        newBankProofURL: null,
        oldBankProofURL: vm.deleteBank.payload.chequeLeaf ? vm.deleteBank.payload.chequeLeaf: null,
        payoutMechanism: vm.modalData.modalPayload.bankDetails[0].payoutMethod ? vm.modalData.modalPayload.bankDetails[0].payoutMethod: '',
        payoutId: vm.modalData.modalPayload.bankDetails[0].payoutId? vm.modalData.modalPayload.bankDetails[0].payoutId: ''
      }
      InvestorsCommonService.post({
        child1: 'cobm',
        child2: 'AIPC',
        child3: 'bank',
        child4: 'initiate',
        child5: 'save'
      }, payload).$promise.then(success, error);
    };

    function uploadChequeLeafFile(file) {
      if (vm.mimeType.indexOf(file.type) === -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 5000000) {
          vm.fileNew = file;
          $scope.$apply(function () {
            vm.chequeLeaf = file.name;
            vm.chooseAFile = false;
          })
        }
        else {
          MessageService.error("File size should not be more than 5 MB.");
          vm.chooseAFile = true;
        }
      }

    }

    function openUploadedDoc() {
      $window.open(vm.deleteBank.payload.oldBankProofURL);
    }

    function changeModifyDefaultBank(banks) {
      vm.changeDefaultBank = {};
      vm.changeDefaultBank.payload = {
        bankAccountNumber: banks.accountNumber,
        folioNumber: vm.folioId,
        accountType: banks.accountType,
        payoutMechanism: banks.payoutMethod,
        accountNumber: banks.accountNumber,
        ifscCode: banks.ifscCode,
        bankCity: banks.branchCity,
        bankBranch: banks.branchName || '',
        makeDefaultBank: false,
        bankName: banks.bankName
      };
    }

    vm.submitModifyDefaultBank = function () {
      var success = function (res) {
        if (res.data && res.status) {
          var Modalsuccess = function () {
            vm.closeModal();
          }, Modalerror = function(){
            $uibModalInstance.dismiss();
          }
          ModalService.changeBankSuccessModal({folioNumber: vm.folioId, changeModifyResponse: res.data}, Modalsuccess,Modalerror);
        }
        else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };
      var payload = {
        accountHolderName: vm.modalData.modalPayload.investorFullName,
        bankAccountNumber: vm.changeDefaultBank.payload.bankAccountNumber,
        folioNumber: vm.changeDefaultBank.payload.folioNumber,
        accountType: vm.changeDefaultBank.payload.accountType,
        payoutMechanism: vm.changeDefaultBank.payload.payoutMechanism,
        accountNumber: vm.changeDefaultBank.payload.bankAccountNumber,
        bankCity: vm.changeDefaultBank.payload.bankCity,
        bankBranch: vm.changeDefaultBank.payload.bankBranch,
        makeDefaultBank: false,
        bankName: vm.changeDefaultBank.payload.bankName,
        ifscCode: vm.changeDefaultBank.payload.ifscCode
      }

      if(vm.changeDefaultBank.payload.IFSCCode){
        payload.ifscCode = vm.changeDefaultBank.payload.IFSCCode
      }
      InvestorsCommonService.post({
        child1: 'cobm',
        child2: 'MBMR',
        child3: 'bank',
        child4: 'initiate',
        child5: 'save'
      }, payload).$promise.then(success, error);
    }


    vm.uploadFile = function (file,proofType) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format not supported. Supported format are tif, tiff, jpg and jpeg'");
          resetCheckLeaf();
          return;
        }
        if (file.size <= 2000000) {
          vm.myFile = file;
            vm.chequeLeaf = file.name;
            vm.isNewCheckLeaf = true;
          var taxIdentifierNumber = vm.modalData.modalPayload.panNumber;

          var modalSuccess = function () {
              var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/cobm/upload/'+vm.modalData.modalPayload.tokenData.arnCode+'/'+taxIdentifierNumber+'/CHEQUE_LEAF';
              LoaderService.showLoader();
              FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                    vm.deleteBank.payload.chequeLeaf = resp.data.fileUrl;
                    vm.fileType= getFileType(file.type);

                } else {
                  resetCheckLeaf();
                  MessageService.error(resp.message)
                }
              }, function () {
                resetCheckLeaf();
                LoaderService.hideLoader();
              });
            } ,
            modalError = function () {
              resetCheckLeaf(proofType);
            };

          ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }else{
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
      }
    };

    function resetCheckLeaf(proofType) {
        vm.deleteBank.payload.chequeLeaf = "";
        vm.deleteBank.payload.chequeLeaf = "";
        vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
        angular.element("#uploadFileId").val("");
        vm.fileType = "";
    }

    function getFileType(fileType) {
      return fileType.split('/')[1]
    }

    vm.openUploadedDoc = function(chequeLeaf,type) {
        if(angular.isUndefined(vm.deleteBank.payload.chequeLeaf)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.deleteBank.payload.chequeLeaf});

    };

    vm.downloadFile = function(url, fileType, proofType) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, proofType+'.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    function rejectConfirm() {
      $uibModalInstance.close(vm.comments);
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('LogoUploadModalController', logoUploadModalController);

  /** @ngInject */
  function logoUploadModalController(MessageService, $window, $timeout, $uibModalInstance, modalView, modalData, AppConstants, FileUploadService, LoaderService, HDFC_API, $rootScope) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.forgotPasswordPayload = {arnCode: ''};

    vm.first = false;


    vm.closeModal = function () {
      $uibModalInstance.close('sent an email successfully');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.init = function () {
      $timeout(function () {
        $window.document.getElementById('uploadFileId').focus();
      })
    };

    vm.uploadFile = function () {
      var file = vm.myFile;
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/uploadLogo';
      LoaderService.showLoader('.popup');
      FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoUrl});
        } else {
          MessageService.error(resp.message)
        }
        vm.dismissModal();
      }, function () {
        LoaderService.hideLoader('.popup');
        vm.dismissModal();
      });
    };

    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('LeapAcademyModalController', leapAcademyModalController);

  /** @ngInject */
  function leapAcademyModalController($uibModalInstance, modalView, modalData, $log, $sce, LoaderService, LeapAcademyService, MessageService, ModalService,UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.registerTrainingClass = registerTrainingClass;
    vm.modalData.url = vm.modalData.url ? $sce.trustAsResourceUrl(vm.modalData.url) :  $sce.trustAsResourceUrl("https://www.youtube.com/embed/IBpWkIsSUvs?autoplay=1");

    if (vm.modalData.name === 'registerModal') {
      vm.name = vm.modalData.data.name;
      vm.trainingClassId = vm.modalData.data.id;
    }

    if (vm.modalData.name === 'agendaModal') {
      vm.agenda = vm.modalData.data.agenda;
      vm.name = vm.modalData.data.name;
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    function registerTrainingClass() {
      var success = function (resp) {
        LoaderService.hideLoader();
        $uibModalInstance.close();
        if (resp.data && resp.status) {
          ModalService.leapAcademySuccessModal({});
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        $uibModalInstance.close();
      };
      LoaderService.showLoader();
      LeapAcademyService.post({
        controller: 'leapacademy',
        child1: 'training',
        child2: 'classes',
        child3: 'register'
      }, {trainingClassId: vm.trainingClassId}).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorStatementModalController', investorStatementModalController);

  /** @ngInject */
  function investorStatementModalController($window,$uibModalInstance, UtilService, modalView, modalData, LoaderService, MessageService, InvestorsService, ReportsService,DownloadReportsService, FileSaver, Blob) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData.data;
    vm.folioList = [];
    vm.buttons = vm.modalData.otherActions;
    vm.investorId = vm.modalData.investorId;
    vm.selectedFolioNo = '';
    vm.successFlag = false;
    vm.successMessage = '';
    fetchFolioList();

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.selectFolioNo = function (folioNo) {
      vm.selectedFolioNo = folioNo;
    };

    vm.sendStatement = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.successFlag = true;
            vm.successMessage = resp && resp.data;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

      var data = {
        Folio_no: vm.selectedFolioNo,
        ARNCode: vm.modalData.arnCode,
        Email: vm.modalData.investorsProfileData.addtionalDetails.email,
        investorName: vm.modalData.investorsProfileData.name
      };
      LoaderService.showLoader('.popup');
      ReportsService.post({
        controller: vm.statement
      }, data).$promise.then(success, error);
    };

    vm.downloadReport=function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
          var status=false;
          try {
            //var decodedString = String.fromCharCode.apply(null, new Uint8Array(resp.data));
            var decodedString = new TextDecoder("utf-8").decode(new Uint8Array(resp.data));
            if(decodedString.indexOf('PDF')==-1) {
              var obj = angular.fromJSON(decodedString);  //JSON.parse(decodedString);
              var message = obj['message'];
              status = false;
            }
            else{
              status=true;
            }
          }
          catch(error){
            status=false;
          }

          if (resp.data && status) {
            /*var file =  new Blob([resp.data], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            var link = $window.document.createElement("a");
            link.target = '_blank';
            link.download = 'AccountStatement';
            link.href = fileURL;
            $window.document.body.appendChild(link);
            link.style = "display: none";
            link.click();
            ($window.URL || $window.webkitURL).revokeObjectURL(link.href);
            $window.document.body.removeChild(link);*/

            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, 'AccountStatement.pdf');
          } else {
            MessageService.error(message || 'No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };
      var data = {
        folioNumber: vm.selectedFolioNo,
        fromDate:'' ,
        todate:''
      };
      LoaderService.showLoader('.popup');
      //var url='v1/report/accountStatement';
      var url='v2/report/accountStatementReport';
      DownloadReportsService.downloadFile(url,data).then(success, error);

    };

    function fetchFolioList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          var folioList = resp.data.folioList || [];
          var folio = [];
          for (var i in folioList) {
            var obj = {}, item = folioList[i];
            obj.key = i;
            obj.activeFlag = item.activeFlag;
            obj.folioId = item.folioId;
            obj.folioNo = item.folioNumber;
            folio.push(obj);
          }
          vm.folioList = folio;
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };

      InvestorsService.post({controller: 'folioList'}, {investorUUID: vm.investorId}).$promise.then(success, error);
    }
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('InvestorLinkStatusModalController', investorLinkStatusModalController);
  
    /** @ngInject */
    function investorLinkStatusModalController($uibModalInstance, modalView, modalData) {
        var vm = this;
        vm.view = modalView;
        vm.modalData = modalData; 
        vm.yes = function () {
          $uibModalInstance.close('yes');
        }; 
        vm.no = function () {
          $uibModalInstance.close('no');
        };  
    }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorApprovalModalController', investorApprovalModalController);

  /** @ngInject */
  function investorApprovalModalController($uibModalInstance, UtilService, modalView, modalData, DashboardService, LoaderService, MessageService, moment) {
    var vm = this;
    vm.view = modalView;
    vm.moment = moment;
    vm.modalData = modalData;
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    vm.closeModal = function () {
      $uibModalInstance.close(vm.formData);
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('RegisterModalController', registerModalController);

  /** @ngInject */
  function registerModalController($uibModalInstance, modalData, modalView) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function (arg) {
      $uibModalInstance.close(arg);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TnitiateTransactionModalController', initiateTransactionModalController);

  /** @ngInject */
  function initiateTransactionModalController($uibModalInstance, UtilService, modalView, modalData,ChangeDividendService , DistributorGenericService, LoaderService, TransactionService,TransactionFlowVersion, MessageService, AppConstants,$rootScope,HDFC_API, EkycService, $scope,AuthService,InvestorServiceDreamSIPService,InvestorServiceDynamicData ,$window, InvestorCommonServiceVersion2 ) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.otpForm = {};
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMessage = '';
    vm.isProcessing = false;
    vm.otpNumber = '';
    vm.comments = '';
    vm.appConstants = AppConstants;
    var version = $rootScope.apiVersion?$rootScope.apiVersion : HDFC_API.VERSION;
    vm.panNumber = null;
    vm.transactionType = false;
    vm.counter = 0
    vm.isOtpValid = true;
    vm.viewMode = "years";
    vm.nomineePayload = {
      panNumber: "",
      dob : "",
    };

    init();
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.continue = function () {
      $uibModalInstance.close('success');
    };

    vm.confirmTransaction = function () {
      if (!vm.otpNumber) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');
      if(vm.transactionType){
        var payload = {
          "otp": vm.otpNumber,
          "uniqueLink": vm.modalData.uniqueLink,
          "panNumber" : vm.panNumber
        }
      } else {
        payload = {
          "otp": vm.otpNumber,
          "uniqueLink": vm.modalData.uniqueLink
        };
      }
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            if(vm.transactionType){
              vm.counter++;
              if(vm.counter == 6){
                vm.isOtpValid = false;
              }
            }
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        },
        successResp = function(resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            localStorage.setItem('flowVersion',resp.data.transactionFlowVersion)
          } else {
            MessageService.error(resp.message)
          }
        };
      if (vm.modalData.initiatedFrom !== 'ekyc') {
        if(vm.modalData.summaryType == 'SIP' || vm.modalData.summaryType == 'DREAMSIP' || vm.modalData.summaryType == 'PURCHASE' ||  vm.modalData.summaryType == 'SWITCH' ||  vm.modalData.summaryType == 'SWP' ||  vm.modalData.summaryType == 'STP' || vm.modalData.summaryType == 'REDEMPTION' ||
            vm.modalData.summaryType == 'TIP' || vm.modalData.summaryType == 'FLEXINDEX' || vm.modalData.summaryType == 'STPFLEX' || vm.modalData.summaryType == 'ROLLOVER' || vm.modalData.summaryType == 'CHANGE-DIVIDEND' || vm.modalData.summaryType == 'smart_swap' ||
            vm.modalData.summaryType == 'SYSTEMATIC-PAUSE' || vm.modalData.summaryType == 'SYSTEMATIC-CANCEL' || vm.modalData.summaryType == 'SIP_TOPUP' || vm.modalData.summaryType == 'DTP' || vm.modalData.summaryType == 'CHANGE-OPTION' || vm.modalData.summaryType == 'CHANGE-TARGET-SCHEME' || vm.modalData.summaryType == 'E_CART' || vm.modalData.summaryType == 'COBM'){
            if(payload.otp){
                payload.otp = AuthService.encryptRSA(angular.copy(payload.otp));
            }
            if(payload.panNumber){
              payload.panNumber = AuthService.encryptRSA(angular.copy(payload.panNumber));
            }

            if (vm.modalData.sipModify) {
              payload.uniqueLinkForCancelTransaction = vm.modalData.cancelInk
            }
            if(vm.modalData.summaryType == 'E_CART'){
              payload.uniqueLink = vm.modalData.uniqueLink;
              payload.otp = vm.otpNumber;
              payload.panNumber = vm.panNumber;
              payload.investorPanNumber = vm.panNumber;
            }

            if(vm.modalData.summaryType == 'CHANGE-OPTION' || vm.modalData.summaryType == 'CHANGE-TARGET-SCHEME'){
              InvestorServiceDynamicData.post4({
                child1: 'dreamSip',
                child2: 'transaction',
                child3: 'otp',
                child4: 'SYSTEMATIC-CHANGE-OPTION-TARGET-SCHEME',
                child5: 'confirm'
              }, payload).$promise.then(success, error);
            } else if (vm.modalData.summaryType == 'COBM') {
              InvestorCommonServiceVersion2.post({
                child1: 'cobm',
                child2: 'otp',
                child3: 'confirm'
              }, payload).$promise.then(success, error);
            }else{
              TransactionService.post2({
               VERSION:version,
                controller: 'otp',
                child2: vm.modalData.summaryType == 'DREAMSIP' ? 'SIP' : vm.modalData.summaryType,
                child3: 'confirm'
              }, payload).$promise.then(success, error);
            }
          }else{
            if (vm.modalData.summaryType === 'NOMINEEOPTOUT') {
              payload.dob = moment(vm.dob, 'DD-MM-YYYY').format('DD-MM-YYYY');
              InvestorServiceDynamicData.post({
                child1: 'transaction',
                child2: 'otp',
                child3: 'OPTOUTNOMINEE',
                child4: 'confirm'
              }, payload).$promise.then(success, error);
            } else if (vm.modalData.summaryType === 'NOMINEEADDUPDATE') {
              payload.checkSebiValidation = true;
              payload.dob = moment(vm.dob, 'DD-MM-YYYY').format('DD-MM-YYYY');
              if(vm.modalData.showRegulatoryChanges) {
                InvestorCommonServiceVersion2.post({
                  child1: 'transaction',
                  child2: 'otp',
                  child3: vm.modalData.summaryType,
                  child4: 'confirm'
                }, payload).$promise.then(success, error);
              } else {
                InvestorServiceDynamicData.post({
                  child1: 'transaction',
                  child2: 'otp',
                  child3: vm.modalData.summaryType,
                  child4: 'confirm'
                }, payload).$promise.then(success, error);
              }
            } else {
              TransactionService.post({
                VERSION:version,
                controller: 'otp',
                child2: vm.modalData.summaryType,
                child3: 'confirm'
              }, payload).$promise.then(success, error);
            }
          }
        TransactionFlowVersion.get({
          VERSION:'v2',
          // controller: 'otp',
          child1: 'transactionFlowVersion'
        }, null).$promise.then(successResp, error);
      } else if (vm.modalData.initiatedFrom === 'ekyc') {
        EkycService.post({
          VERSION:version,
          controller: 'ekyc',
          child2: 'otp',
          child3: 'confirm'
        }, payload).$promise.then(success, error);
      }
    };

    vm.resendOtp = function () {
      LoaderService.showLoader('.popup');
      vm.isProcessing = true;
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.otpResendMessage = 'OTP sent again successfully.';
            resetTimer();
          } else {
            vm.otpResendMessage = '';
            MessageService.error(resp.message)
          }
          vm.isProcessing = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.otpResendMessage = '';
          vm.isProcessing = false;
          UtilService.errorHandler(err);
        };
      if (vm.modalData.initiatedFrom !== 'ekyc') {
        if (vm.modalData.summaryType === 'NOMINEEOPTOUT') {
          InvestorServiceDynamicData.get({
            child1: 'nominee',
            child2: 'resendOTP',
            child3: 'NOMINEE_OPT_OUT',
            child4: vm.modalData.uniqueLink
          }, null).$promise.then(success, error);
        } else if (vm.modalData.summaryType === 'NOMINEEADDUPDATE') {
          InvestorServiceDynamicData.get({
            child1: 'nominee',
            child2: 'resendOTP',
            child3: 'NOMINEE_UPDATE',
            child4: vm.modalData.uniqueLink
          }, null).$promise.then(success, error);
        } else {
          TransactionService.get({
            VERSION:'v2',
            controller: 'otp',
            // child2: 'resend',
            uniqueLink: vm.modalData.uniqueLink
          }, null).$promise.then(success, error);
        }
      } else if (vm.modalData.initiatedFrom === 'ekyc') {
        EkycService.get({
          VERSION: version,
          controller: 'ekyc',
          child2: 'otp',
          uniqueLink: vm.modalData.uniqueLink
        }, null).$promise.then(success, error);
      }
    };

    vm.rejectTransaction = function () {
      if(vm.modalData.summaryType=='ROLLOVER'){
        LoaderService.showLoader('.popup');
        var payload = {
          "comments": vm.comments,
          "folioNumber": vm.modalData.folioNumber,
          "linkId": vm.modalData.uniqueLink,
          "transactionId": vm.modalData.transactionId
        };
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        DistributorGenericService.post({
          controller: 'rollover',
          child1: 'cancel'
        }, payload).$promise.then(success, error);

      }
     else if(vm.modalData.summaryType=='SIP_TOPUP')
        {

          LoaderService.showLoader('.popup');
          var payload = {
            "comments": vm.comments,
          };
          var success = function (resp) {
            LoaderService.hideLoader('.popup');
            if (resp.status && resp.data) {
              $uibModalInstance.close(resp.data);
            } else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            LoaderService.hideLoader('.popup');
            UtilService.errorHandler(err);
          };

          TransactionService.post({
            VERSION:version,
            controller: 'otp', child2: 'reject',child3: 'sip_topup',
            uniqueLink: vm.modalData.uniqueLink
          }, payload).$promise.then(success, error);
        }


      else if(vm.modalData.summaryType=='SYSTEMATIC-CANCEL'){

        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'SYSTEMATIC-CANCEL',child3: 'reject',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }

      else if(vm.modalData.summaryType=='NOMINEECANCELLATION'){
        LoaderService.showLoader('.popup');
        payload = {
          "rejectionReason": vm.comments,
          "folioNo": vm.modalData.folioNumber,
          "approved":false,
          "summaryType":vm.modalData.summaryType
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'nominee',child3: 'action',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }

      else if(vm.modalData.summaryType=='NOMINEEADDUPDATE'){
        LoaderService.showLoader('.popup');
        payload = {
          "rejectionReason": vm.comments,
          "folioNo": vm.modalData.folioNumber,
          "approved":false,
          "summaryType":vm.modalData.summaryType,
          "jH_mail" : vm.modalData.mail,
          "jh_Mobile" : vm.modalData.Mobile ,
          "jH_mail_belongs_to": vm.modalData.mail_belongs_to ,
          "jH_Mobile_belongs_to" :vm.modalData.Mobile_belongs_to
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        if(vm.modalData.showRegulatoryChanges) {
          TransactionService.post3({
            VERSION:HDFC_API.VERSION,
            controller: 'otp', child2: 'nominee',child3: 'action',
            uniqueLink: vm.modalData.uniqueLink
          }, payload).$promise.then(success, error);
        } else {
          TransactionService.post({
            VERSION:version,
            controller: 'otp', child2: 'nominee',child3: 'action',
            uniqueLink: vm.modalData.uniqueLink
          }, payload).$promise.then(success, error);
        }
      }

      else if(vm.modalData.summaryType=='NOMINEEOPTOUT'){
        LoaderService.showLoader('.popup');
        payload = {
          "rejectionReason": vm.comments,
          "folioNo": vm.modalData.folioNumber,
          "approved":false,
          "summaryType":vm.modalData.summaryType,
          "jH_mail" : vm.modalData.mail,
          "jh_Mobile" : vm.modalData.Mobile ,
          "jH_mail_belongs_to": vm.modalData.mail_belongs_to ,
          "jH_Mobile_belongs_to" :vm.modalData.Mobile_belongs_to
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'nominee',child3: 'action',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }

      else if(vm.modalData.summaryType=='CHANGE_DIVIDEND_OPTION'){
        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        ChangeDividendService.post({
          child1:'v2',
          child2:'nft',
          child3:'reject',
          child4:'CHANGE_DIVIDEND_OPTION'
        }, payload).$promise.then(success, error);
      }
      else if(vm.modalData.summaryType=='SYSTEMATIC-PAUSE') {

        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };
        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'SYSTEMATIC-PAUSE',child3: 'reject',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }
      else if (vm.modalData.summaryType=='E-MANDATE') {
        $uibModalInstance.close(vm.comments);
      }
      else if(vm.modalData.summaryType=='changeOption' || vm.modalData.summaryType=='changeTargetScheme'){
        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };
        InvestorServiceDreamSIPService.post({child1: 'dreamSip',child2: 'transaction',child3: 'otp', child4:'SYSTEMATIC-CHANGE-OPTION-TARGET-SCHEME',child5:'reject',child6:vm.modalData.uniqueLink}, payload).$promise.then(success, error);
      } else if(vm.modalData.summaryType=='E_CART') {

        LoaderService.showLoader('.popup');
        payload = {
          "transactionId": vm.modalData.uniqueLink,
          "comments": vm.comments,
          "arnCode": vm.modalData.arnCode
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };
        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'reject',child3: 'E_CART',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }
      else if (vm.modalData.summaryType=='E-MANDATE') {
        $uibModalInstance.close(vm.comments);
      }
      else if(vm.modalData.summaryType=='changeOption' || vm.modalData.summaryType=='changeTargetScheme'){
        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };
        InvestorServiceDreamSIPService.post({child1: 'dreamSip',child2: 'transaction',child3: 'otp', child4:'SYSTEMATIC-CHANGE-OPTION-TARGET-SCHEME',child5:'reject',child6:vm.modalData.uniqueLink}, payload).$promise.then(success, error);
      }
      else {
        LoaderService.showLoader('.popup');
        payload = {
          "comments": vm.comments,
          "transactionId": vm.modalData.transactionId
        };
        success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            $uibModalInstance.close(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader('.popup');
          UtilService.errorHandler(err);
        };

        TransactionService.post({
          VERSION:version,
          controller: 'otp', child2: 'reject',
          uniqueLink: vm.modalData.uniqueLink
        }, payload).$promise.then(success, error);
      }

    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }
    function init(){
      if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.REDEMPTION){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.SWP){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.STP){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.SWITCH){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.SMART_SWAP){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.STPSWING){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.STP_FLEX){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.PURCHASE){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.SIP){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.SIP_TOPUP){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.E_CART){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.COBM){
        vm.transactionType = true;
      }else if(vm.modalData.summaryType && vm.modalData.summaryType.toUpperCase() == vm.appConstants.TRAN_TYPE_FOR_2FA.DTP){
        vm.transactionType = true;
      }else {
        vm.transactionType = false;
      }
    }


    vm.changeStartDate = function(date) {
      var doblength = vm.dob ? vm.dob.length : 0;
      if (doblength == 10) {
        date = $window.moment(vm.dob, "DD-MM-YYYY")
      }
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.nomineePayload.dob = date
        vm.dob = date;
        vm.dobtrue = true;
        var age = $window.moment().diff(vm.nomineePayload.dob, 'years');
        if (age < 18) {
          vm.ageErrorMessage = vm.validateData.DOB_MINOR;
        } else {
          vm.ageErrorMessage = '';
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.nomineePayload.dob = "";
        vm.ageErrorMessage = '';
      }
      return;
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    vm.varifyDate = function() {
      var doblength = vm.dob ? vm.dob.length : 0;
      vm.dobtrue = false;
      if (doblength == 10) {
        vm.nomineePayload.dob = $window.moment(vm.dob, "DD-MM-YYYY");
        vm.dobtrue = true;

        var age = $window.moment().diff(vm.nomineePayload.dob, 'years');
        if (age < 18) {
          vm.ageErrorMessage = vm.validateData.DOB_MINOR;
        } else {
          vm.ageErrorMessage = '';
        }
      } else {
        vm.ageErrorMessage = '';
      }
    }

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitialLoginModalController', initialLoginModalController);

  /** @ngInject */
  function initialLoginModalController($uibModalInstance, UtilService, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    if(modalData.Text){
      vm.modalData = modalData.Text;
    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.continue = function () {
      $uibModalInstance.close('success');
    };
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ImagePreviewModalController', imagePreviewModalController);

  /** @ngInject */
  function imagePreviewModalController($uibModalInstance, modalView, modalData) {
    var browserNotSupportedFileTypes = ["tif","tiff"];
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.uploaded= modalData.file.name ===undefined;
    vm.fileType = "";
    vm.init = init();
    vm.supportedFileType = !browserNotSupportedFileTypes.includes(vm.fileType);

    function init() {
      if(!vm.uploaded ){
        vm.fileType= modalData.file.type.split('/')[1];
      }
      if(vm.modalData.showOnly){
        vm.filepreview = vm.modalData.file;
      }else{
        var reader = new FileReader();
        reader.onload = function(loadEvent) {
          vm.filepreview = loadEvent.target.result;
        };
        reader.readAsDataURL(vm.modalData.file);
      }
    }
    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    }
})();

/**
 * Created by ttn on 15/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('GenericModalController', genericModalController);

  /** @ngInject */
  function genericModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

/**
 * Created by ttn on 15/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('GenericUiModalController', genericUiModalController);

  /** @ngInject */
  function genericUiModalController($uibModalInstance, modalView, modalData, $sce) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.iframeUrl = $sce.trustAsResourceUrl(vm.modalData.url);

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ForgotPasswordModalController', forgotPasswordModalController);

  /** @ngInject */
  function forgotPasswordModalController($uibModalInstance, $timeout, AuthService, modalView, modalData, AppConstants,MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.forgotPasswordPayload = {arnCode: '',pan: ''};
    vm.showCaptcha = true;

    vm.processFlag = false;
    vm.forgotPassword = function () {
      var success = function (resp) {
          vm.processFlag = false;
          if (resp.status) {
            $uibModalInstance.close(resp);
          } else {
            vm.wrongARNmsg = resp.message;

            vm.showCaptcha = false;
            vm.gRecaptchaResponse = "";
            $timeout(function () {
              vm.showCaptcha = true;
            });
            MessageService.error(vm.wrongARNmsg);
          }
        },
        error = function () {
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          vm.showCaptcha = false;
          vm.gRecaptchaResponse = "";
          $timeout(function () {
            vm.showCaptcha = true;
          });
          MessageService.error(vm.wrongARNmsg);
        };
        var payload = {};
        payload.arnCode = 'ARN-' + vm.forgotPasswordPayload.arnCode;
        payload.gRecaptchaResponse = vm.gRecaptchaResponse;
        payload.pan =vm.forgotPasswordPayload && vm.forgotPasswordPayload.pan ? AuthService.encryptRSA(angular.copy(vm.forgotPasswordPayload.pan)) : '';
      vm.processFlag = true;
      AuthService.forgotPassword(payload).then(success, error);
    };

    vm.closeModal = function () {
      $uibModalInstance.close('sent an email successfully');
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.clearModal = function () {
      vm.wrongARNmsg = "";
    }
    vm.forgotPasswordForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
  .module('hdfc-mf-distributor-web')
  .controller('FolioCompletModalController', folioCompletModalController);

  /** @ngInject */
  function folioCompletModalController($uibModalInstance,HDFC_API,$window,$stateParams, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
    vm.pay = function(){
      $uibModalInstance.close();
      $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
      // $window.location.href ="http://localhost:3000/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
      sessionStorage.setItem('folioCreationProcess','Completed');
    }
    }
})();

/**
 * Created by ttn on 13/01/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioCreationModalController', folioCreationModalController);

  /** @ngInject */
  function folioCreationModalController($uibModalInstance, $timeout, $scope, $log, AppConstants, MessageService, LoaderService, modalData, modalView, InvestorsService, FolioApproval, $rootScope, HDFC_API,InvestorsService4,UtilService,$window,FolioApprovalUpdateContact) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.otpResendMsg = '';
    vm.otpForm = {};
    vm.isProcessing = false;
    vm.isOtpValid = true;
    vm.counter = 0;
    vm.nomineePayload = {
      panNumber: "",
      dob : "",
    };
    vm.showContactUpdateUI = vm.modalData.contactUpdate;
    if (vm.showContactUpdateUI) {
      vm.updateContactMessage1 = vm.modalData.updateContactMessage1;
      vm.updateContactMessage2 = vm.modalData.updateContactMessage2;
      vm.uniqueLink1 = vm.modalData.uniqueLink1;
      vm.uniqueLink1 = vm.modalData.uniqueLink2;
    }

    vm.closeModal = function (message) {
      $uibModalInstance.close(message);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };

    vm.resetValues = function () {
      vm.errorMessage = "";
    };

    vm.confirmTransaction = function (){
      if ((!vm.otpNumber && !vm.showContactUpdateUI) || (vm.showContactUpdateUI && !vm.formData.otpNumber && !vm.formData.newOtpNumber)) {
        MessageService.error(vm.validateData.OTP_REQUIRED);
        return;
      }
      vm.isProcessing = true;
      LoaderService.showLoader('.popup');

      var payload = {};

      if (vm.showContactUpdateUI) {
        payload.otp = vm.formData.otpNumber;
        payload.uniqueLink = vm.modalData.uniqueLink1;
        payload.otp2 = vm.formData.newOtpNumber;
        payload.uniqueLink2 = vm.modalData.uniqueLink2;
      } else {
        payload.otp = vm.otpNumber;
        payload.uniqueLink = vm.modalData.uniqueLink;
      }


      if (vm.modalData.type === 'soleApplicant' || vm.modalData.type === 'holder') {
        payload.dob = moment(vm.dob, 'DD-MM-YYYY').format('DD/MM/YYYY');
        payload.checkSebiValidation = true;
      }

      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          $uibModalInstance.close(resp.data);
        } else {
          vm.incorrectOtpCounter+=1;
          if(vm.incorrectOtpCounter==6){
            vm.otpValid=false;
          }
          if($window.location.pathname.includes('newinvestorApprove')){
            if(resp.message == "Invalid Folio State" || resp.message == "The Link Has Been Expired."){
              MessageService.error('This unique link has already expired. Contact system admin.');
              vm.closeModal();
              LoaderService.showLoader();
              return;
            }else{
              MessageService.error(resp.message)
            }
          }else{
            MessageService.error(resp.message)
          }
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      var config = {
        controller: 'folio',
        child1: vm.modalData.type,
        child2: 'otp',
        child3: 'confirm'
      };
      if(sessionStorage.getItem('newJourney')){
        InvestorsService4.post(config, payload).$promise.then(success, error);
      }else{
        InvestorsService.post(config, payload).$promise.then(success, error);
      }
    };

    vm.resendOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          vm.otpResendMessage = 'OTP sent again successfully.';
          resetTimer();
        } else {
          vm.otpResendMessage = '';
          MessageService.error(resp.message)
        }
        vm.isProcessing = false;
      },
      error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.otpResendMessage = '';
        vm.isProcessing = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      if (vm.showContactUpdateUI) {
        FolioApprovalUpdateContact.get({
          VERSION: version,
          controller: 'otp',
          child2: vm.modalData.uniqueLink,
          child3: true
        }, null).$promise.then(success, error);
      } else {
        FolioApproval.get({
          VERSION: version,
          controller: 'otp',
          child2: vm.modalData.uniqueLink,
          child3: true
        }, null).$promise.then(success, error);
      }
    };

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    vm.changeStartDate = function(date) {
      var doblength = vm.dob ? vm.dob.length : 0;
      if (doblength == 10) {
        date = $window.moment(vm.dob, "DD-MM-YYYY")
      }
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.nomineePayload.dob = date
        vm.dob = date;
        vm.dobtrue = true;
        var age = $window.moment().diff(vm.nomineePayload.dob, 'years');
        if (age < 18) {
          vm.ageErrorMessage = vm.validateData.DOB_MINOR;
        } else {
          vm.ageErrorMessage = '';
        }
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD;
        vm.nomineePayload.dob = "";
        vm.ageErrorMessage = '';
      }
      return;
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    vm.varifyDate = function() {
      var doblength = vm.dob ? vm.dob.length : 0;
      vm.dobtrue = false;
      if (doblength == 10) {
        vm.nomineePayload.dob = $window.moment(vm.dob, "DD-MM-YYYY");
        vm.dobtrue = true;

        var age = $window.moment().diff(vm.nomineePayload.dob, 'years');
        if (age < 18) {
          vm.ageErrorMessage = vm.validateData.DOB_MINOR;
        } else {
          vm.ageErrorMessage = '';
        }
      } else {
        vm.ageErrorMessage = '';
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioChoiceModalController', folioChoiceModalController);

  /** @ngInject */
  function folioChoiceModalController($uibModalInstance, modalView, modalData, LoaderService, UtilService, $scope, $state, AppConstants) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;
    vm.userType = sessionStorage.getItem('userType');

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };
    vm.closeModal = function (param) {
      if (sessionStorage.getItem('isMinorFolioSelected')) {
        sessionStorage.removeItem('isMinorFolioSelected');
      }
      $uibModalInstance.close(param);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FileDownloadController', fileDownloadController);

  /** @ngInject */
  function fileDownloadController($log, UtilService, AppConstants, $uibModalInstance, $timeout, ReportsService, DownloadReportsService, modalView, modalData, MessageService, $window, LoaderService, FileSaver, Blob, HDFC_API, FormatterService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.DOWNLOAD_TYPES = AppConstants.DOWNLOAD_TYPES;
    vm.filetype = vm.DOWNLOAD_TYPES.PDF;
    vm.processFlow = false;
    vm.dateFlag = true;
    vm.fromdate = null;
    vm.todate = null;
    vm.today = $window.moment();


    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.sendReport = function () {
      LoaderService.showLoader('.widget');


      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        if (resp.data) {
          if (resp.data.status) {
            MessageService.success(resp.data.message);
            vm.closeModal();
          }
          else {
            MessageService.error(resp.data.message);
            vm.closeModal();
          }
        }

        else {
          LoaderService.hideLoader('.widget')
          MessageService.error(resp.data.message);
        }
      }

      var error = function (resp) {
        LoaderService.hideLoader('.widget')
        MessageService.error(resp.data.message);
      }

      var payload = vm.modalData.payload || {};
      payload.commonReportCO.generateType = vm.filetype;
      DownloadReportsService.sendFile(vm.modalData.downloadUrl, payload).then(success, error);
    }
    vm.download = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.widget');
          vm.processFlow = false;
          if (resp.data) {
            var file = null;
            if (vm.filetype == "pdf") {
              // file = new Blob([resp.data], {type: 'application/pdf'});
              file = new Blob([resp.data], {type: 'application/pdf'});
              FileSaver.saveAs(file, vm.modalData.fileName + '.pdf');
            } else {
              // file = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
              file = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
              FileSaver.saveAs(file, vm.modalData.fileName + '.xls');
            }

            /*var fileURL = URL.createObjectURL(file);
             var link = $window.document.createElement("a");
             link.target = '_blank';
             if (vm.filetype == "pdf") {
             link.download = vm.modalData.fileName;
             } else {
             link.download = vm.modalData.fileName + '.xls';
             }
             link.href = fileURL;

             $window.document.body.appendChild(link);
             link.style = "display: none";
             link.click();
             ($window.URL || $window.webkitURL).revokeObjectURL(link.href);
             $window.document.body.removeChild(link);*/

            vm.closeModal();
          } else {
            vm.closeModal();
            MessageService.error(resp.message || 'No Data Available');
          }
        },
        error = function (err) {
          vm.closeModal();
          LoaderService.hideLoader('.widget');
          vm.processFlow = false;
          var msg = "";
          if (typeof err.config.data === 'string') {
            msg = responseDecryptor(ab2str(err?err.data:err));
          } else {
            msg = ab2str(err?err.data:err);
          }
          msg = angular.fromJson(msg)
          UtilService.errorHandler(msg);
        };


      LoaderService.showLoader('.widget');
      var payload = vm.modalData.payload || {};
      vm.processFlow = true;
      if (vm.filetype == vm.DOWNLOAD_TYPES.PDF) {
        if (payload.commonReportCO) {
          payload.commonReportCO.generateType = vm.DOWNLOAD_TYPES.PDF;
        }
      } else {
        payload.generateType = vm.DOWNLOAD_TYPES.EXCEl;
        if (payload.commonReportCO && payload.commonReportCO.generateType) {
          payload.commonReportCO.generateType = vm.DOWNLOAD_TYPES.EXCEl;
          delete payload.generateType;
        }
      }
      DownloadReportsService.downloadFile(vm.modalData.downloadUrl, payload).then(success, error);
    };

    function ab2str(buf) {
      var arr = new Uint8Array(buf);
      var str = String.fromCharCode.apply(String, arr);
      if(/[\u0080-\uffff]/.test(str)){
        throw new Error("this string seems to contain (still encoded) multibytes");
      }
      return str||"";
    }

    vm.changeFromDate = function (date) {
      if (date && date._i) {
        vm.fromdate = date._i;
        vm.dateFlag = false;
        vm.todate = null;
        $timeout(function () {
          vm.dateFlag = true;
        });
      }
    };
    vm.changeToDate = function (date) {
      if (date && date._i) {
        vm.todate = date._i;
      }
    };

    vm.minDate = $window.moment().subtract(3,'months').toString();
    vm.maxDate = $window.moment().toString();

    vm.brokerageReportDownload = function () {
      var payload = {
        "fromDate": $window.moment(vm.date.startDate).format("DD-MMM-YYYY").toString(),
        "toDate": $window.moment(vm.date.endDate).format("DD-MMM-YYYY").toString(),
        "fileType": vm.filetype
      };
      var success = function (resp) {
        LoaderService.hideLoader('.widget');
        vm.processFlow = false;
        if (resp.status) {
          vm.closeModal();
          /*var file = null;
          if (vm.filetype == "pdf") {
            // file = new Blob([resp.data], {type: 'application/pdf'});
            file = new Blob([resp.data], {type: 'application/pdf'});
            FileSaver.saveAs(file, 'brokerage-report.pdf');
          } else {
            // file = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
            file = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
            FileSaver.saveAs(file, 'brokerage-report.xls');
          }*/
          MessageService.success(resp.message);
        } else {
          MessageService.error(resp.message || 'No Data Available');
        }
      }, error = function () {
        LoaderService.hideLoader('.widget');
        vm.processFlow = false;
        MessageService.error();
      };

      vm.processFlow = true;
      LoaderService.showLoader('.widget');

      ReportsService.post({
        controller: 'brokerageReport',
        child1: 'send'
      }, payload).$promise.then(success, error);
      /*if (vm.filetype == 'pdf') {
        DownloadReportsService.downloadFile(downloadUrl, payload).then(success, error);
      } else {
        payload.fileType = 'xls';
        DownloadReportsService.downloadFile(downloadUrl, payload).then(success, error);
      }*/


    }

    vm.setDatePickerCSS = function () {
      try{
        $timeout(function () {
          angular.element(".modal-open .daterangepicker.ltr.show-calendar.opensright")
            .css({'z-index':3000, 'transform': 'scale(0.95)','margin-top': '-55px', 'margin-left': '-42px'});
        })
      }catch (e) {
        $log.info("Date picker css setting error:",e);}
    }

    function responseDecryptor(response) {
      var header = response.substring(0, response.lastIndexOf("|"));
      var data = $window.CryptoJS.enc.Base64.parse(response.substring(response.lastIndexOf("|")+1, response.length));
      var responseData = readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);
      response = angular.fromJson(responseData);
      return response;
    }

    function readAesResponsePayload(header, data) {
      var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
      var decryptJson = $window.CryptoJS.AES.decrypt({
        ciphertext: data
      }, key, {iv: iv});
      return decryptJson.toString($window.CryptoJS.enc.Utf8);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FeedbackModalController', feedbackModalController);

  /** @ngInject */
  function feedbackModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EuinDeclarationOneClickModalController', euinDeclarationOneClickModalController);

  /** @ngInject */
  function euinDeclarationOneClickModalController($uibModalInstance, UtilService, modalView, modalData, SchemeService,TransactionArnService, LoaderService, MessageService, ModalService, $state) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function (success) {
      $uibModalInstance.close(success);
    };
  }
})();

/**
 * Created by ttn on 15/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ConfirmMandateController', confirmMandateController);

  /** @ngInject */
  function confirmMandateController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.submitAction = function() {
      $uibModalInstance.close("submit");
    };
  }
})();

/**
 * Created by ttn on 13/07/20.
*/
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CancelMandateController', cancelMandateController);

  /** @ngInject */
  function cancelMandateController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

/**
 * Created by ttn on 8/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EditNomineeModalController', editNomineeModalController);

  /** @ngInject */
  function editNomineeModalController(UtilService, $uibModalInstance, AppConstants, DistributorProfileService, LoaderService, modalView, modalData) {

    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    var months={'Jan':0,'Feb':1,'Mar':2,'Apr':3,'May':4,'Jun':5,'Jul':6,'Aug':7,'Sep':8,'Oct':9,'Nov':10,'Dec':11};
    if (vm.modalData && vm.modalData.dob) {
      var date=vm.modalData.dob.split('-');
      vm.defaultDate = (new Date(parseInt(date[2]),parseInt(months[date[1]]),parseInt(date[0])));
    }
    else {
      vm.defaultDate = new Date();
    }
    vm.processFlag = false;

    vm.confirmErr = '';
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;

    vm.editNominee = function () {
      if (!vm.modalData) {
        return false;
      }
      var success = function (data) {
        vm.processFlag=false;
        $uibModalInstance.close(data);
      }, error = function (err) {
        vm.processFlag=false;
        UtilService.errorHandler(err);
      };

      vm.modalData.name = vm.modalData.name ? vm.modalData.name : null;
      vm.modalData.relationship = vm.modalData.relationship ? vm.modalData.relationship : null;
      vm.modalData.dob = vm.modalData.dob ? vm.modalData.dob : null;

      if (vm.modalData.dob) {
        //var m = vm.modalData.dob.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
        var regex=/^(([0-9])|([0-2][0-9])|([3][0-1]))\-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-\d{4}$/
        var m = regex.test(vm.modalData.dob);
        vm.confirmErr = m ? '' : 'Please enter valid dob';
        vm.processFlag = m ? true : false;
      }
      else {
        vm.processFlag = true;
      }


      if (vm.modalData.name || vm.modalData.relationship || vm.modalData.dob) {
        vm.confirmErr = '';
        if (vm.processFlag) {
          DistributorProfileService.post({controller: 'nominee', child1: 'edit'}, {
            name: vm.modalData.name,
            relationship: vm.modalData.relationship,
            dob: vm.modalData.dob
          }).$promise.then(success, error);
        }
      }
      else {
        vm.confirmErr = 'You must type value in at least one field to update.'
      }

    };

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.changeNomineeDob = function (date) {
      if (date && date._i) {
        vm.modalData.dob = date._i;
      }
    }

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EditDashboardController', editDashboardController);

  /** @ngInject */
  function editDashboardController($uibModalInstance, modalView) {
    var vm = this;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('DreamSipTenureModalController', dreamSipTenureModalController);
  
    /** @ngInject */
    function dreamSipTenureModalController($uibModalInstance, $log, UtilService, modalView, modalData,InvestorServiceDynamicData,LoaderService,MessageService) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData; 
      vm.dismissModal = function () {
        $uibModalInstance.dismiss();
      }; 
       
    }
  })();
  
/**
 * Created on 16/02/22.
 */

 (function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('PointToNoteController', pointToNoteController);
  
    /** @ngInject */
    function pointToNoteController($uibModalInstance, modalView,modalData) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };

      vm.continue = function () {
        $uibModalInstance.close("success");
      };
  
  
    }
  })();
/**
 * Created on 16/02/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ChangeTargetSchemeController', changeTargetSchemeController);

  /** @ngInject */
  function changeTargetSchemeController($uibModalInstance,AuthService,UtilService, modalView, modalData, AppConstants, LoaderService, InvestorsService,InvestorServiceDynamicData,MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.optionList = AppConstants.OPTION_LIST;
    vm.fetchTargetScheme = fetchTargetScheme;
    function fetchTargetScheme() {
      if(vm.modalData.option == 'B'){
        vm.modalData.optionType = "Option B";
      if(!vm.modalData.optionType && vm.modalData.optionType == 'Option B'){
         $uibModalInstance.dismiss("cancel");
      }
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.targetSchemeList = resp.data.targetSchemeList;
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        var payload = {
          option: (vm.modalData.optionType == 'Option B') ? 'B' : 'A',
        }
        InvestorServiceDynamicData.post({
          child1: 'dreamSip',
          child2: 'getSchemeList'
        }, payload).$promise.then(success, error);
      }else{
        MessageService.error("For this Dream SIP has option is A so you can't change target scheme.");
        $uibModalInstance.dismiss("cancel");
      }
    }

    vm.targetSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.targetSchemeCode = schemeData.schemeCode;
        vm.targetSchemeName = schemeData.scheme;
      }
    };
    vm.changeOptionType = function () {
      vm.targetSchemeCode = null;
      vm.targetSchemeName = null;

    }
    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.continue = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.data && resp.status){
          MessageService.success(resp.data.trnxActionMsg);
          $uibModalInstance.close("success");
        }else{
          MessageService.success(resp.message);
        }
      },error = function(error){
        LoaderService.hideLoader();
        MessageService.error(error.message);
      };
      var identifierData = AuthService.getToken();
      var payload = {
        "sipStpId": vm.modalData.transactionID,
        "folioNumber":vm.modalData.folioNumber,
        "oldOption":"B",
        "newOption":'B',
        "schemeCode":vm.modalData.schemeCode,
        "targetScheme":"",
        "oldTargetScheme":vm.modalData.targetSchemeCode,
        "newTargetScheme": vm.targetSchemeCode,
        "systematicTransactionType":"changeTargetScheme",
        "brokerCode":identifierData.arnCode,
        "applicationSource":"MF_ONLINE"
      }
      LoaderService.showLoader();
      InvestorServiceDynamicData.post({
          child1: 'dreamSip',
          child2: 'initiate',
          child3: 'changeOptionTargetScheme',
          child4: 'dreamsip'
        }, payload).$promise.then(success, error);
    };
  }
})();

/**
 * Created on 16/02/22.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OptionChangeController', optionChangeController);

  /** @ngInject */
  function optionChangeController($uibModalInstance, modalView, modalData, AppConstants, LoaderService,MessageService, InvestorsService,InvestorServiceDynamicData,UtilService,AuthService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.optionList = AppConstants.OPTION_LIST;
    vm.fetchTargetScheme = fetchTargetScheme;
    if(vm.modalData){
    if(vm.modalData.option == 'A'){
      vm.modalData.optionType = 'Option A';
      vm.fetchTargetScheme();
    }
    if(vm.modalData.option == 'B'){
      vm.modalData.optionType = 'Option B';
    }
    }
    function fetchTargetScheme() {
      // vm.formData = vm.modalData;
      if(!vm.modalData.optionType){
         $uibModalInstance.dismiss("cancel");
      }
      if (vm.modalData.optionType == 'Option A') {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.targetSchemeList = resp.data.targetSchemeList;
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        };
        var payload = {
          option: 'B',
        }
        InvestorServiceDynamicData.post({
          child1: 'dreamSip',
          child2: 'getSchemeList'
        }, payload).$promise.then(success, error);

      }
    }

    vm.targetSchemeChanged = function (schemeData) {
      if (!schemeData) {
        return;
      } else {
        vm.targetSchemeCode = schemeData.schemeCode;
        vm.targetSchemeName = schemeData.scheme;
        //vm.formData.schemeType = schemeData.schemeType;
      }
    };
    vm.changeOptionType = function () {
      vm.targetSchemeCode = null;
      vm.targetSchemeName = null;

    }
    vm.dismissModal = function () {
      $uibModalInstance.close();
    };

    vm.continue = function () {

      LoaderService.showLoader();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && (resp.data || resp)) {
            MessageService.success(resp.data.trnxActionMsg);
             $uibModalInstance.close("success");
        }
        else {
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      // Make payload
        var payload = vm.makePayload() ;
        InvestorServiceDynamicData.post({
        child1: 'dreamSip',
        child2: 'initiate',
        child3: 'changeOptionTargetScheme',
        child4: 'dreamsip'
      }, payload).$promise.then(success, error);
    };
    vm.makePayload = function(){
      var identifierData = AuthService.getToken();
      var payload = {
        "sipStpId": vm.modalData.transactionID,
        "folioNumber":vm.modalData.folioNumber,
        "systematicTransactionType":"changeOption",
        "brokerCode":identifierData.arnCode,
        "applicationSource":"MF_ONLINE"
      }
      if(vm.modalData.optionType == "Option A"){
        payload.oldOption = "A";
        payload.newOption = "B";
        payload.schemeCode = vm.modalData.schemeCode;
        payload.targetScheme = vm.targetSchemeCode;
        payload.oldTargetScheme = null;
        payload.newTargetScheme = null;
      }
      if(vm.modalData.optionType == "Option B"){
        payload.oldOption = "B";
        payload.newOption = "A";
        payload.schemeCode = vm.modalData.schemeCode;
        payload.targetScheme = null;
        payload.oldTargetScheme = vm.modalData.targetScheme;
        payload.newTargetScheme = null;
      }
      return payload;
    }
  }
})();

/**
 * Created by HDFC on 01/02/23.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DreamSchemeListModalController', dreamSchemeListModalController);

  /** @ngInject */
  function dreamSchemeListModalController($uibModalInstance, $log,InvestorServiceDynamicData, UtilService, modalView, modalData, SchemeService, LoaderService, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.schemeTypeList = null;
    vm.schemeList = null;
    vm.masterSchemeList = null;
    vm.selectedSchemeType = '';

    vm.getSchemeslist = function () { 
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.masterSchemeList = resp.data.sourceSchemeList; 
          vm.filterSchemes(vm.schemeTypeList[0]);
        } else {
          MessageService.error(resp.message);
          vm.schemeList = null;
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeList = null;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader('.popup');

      InvestorServiceDynamicData.post({
        child1: 'dreamSip',
        child2: 'getSchemeList'
      }, vm.modalData.payload).$promise.then(success, error); 
    };
    vm.filterSchemes = function (schemeType) {
      vm.selectedSchemeType = schemeType.toUpperCase(); 
      if(schemeType == "ALL"){
        vm.schemeList = vm.masterSchemeList;
      }else{
        vm.schemeList = [];
        vm.masterSchemeList.forEach(function(val) {
          if(val.schemeType == schemeType){
            vm.schemeList.push(val);
          } 
        });
      } 
    }; 
    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    }; 
    vm.selectScheme = function (scheme) {
      $uibModalInstance.close(scheme);
    };

    vm.init = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.status) {
          vm.schemeTypeList = resp.data.schemeType;
          if (vm.schemeTypeList && vm.schemeTypeList.length > 0) {
            vm.getSchemeslist();
          }
        } else {
          vm.schemeTypeList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.schemeTypeList = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader('.popup');

      SchemeService.post({
        controller: 'schemeType'
      }, null).$promise.then(success, error);

    };
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DistributorTAndCModalController', distributorTAndCModalController);

  /** @ngInject */
  function distributorTAndCModalController($state, $uibModalInstance, ModalService, modalView,MessageService, modalData,EmpanellmentModal,DistributorEmpanellmentService,LoaderService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.formData={};
    vm.declerationTextAgreementModel=true;
    vm.declerationTextTnCModel=true;
    vm.isProcessing=false;

    vm.declerationConfirm=declerationConfirm;
    vm.changedSelection = changedSelection;
    vm.declerationExit = declerationExit;
    vm.termsAndConditions = termsAndConditions;
    vm.declerationTextAgreement={"key":true,"value":'I hereby confirm that the information furnished above is true and correct to the best of my knowledge and belief.'};
    vm.declerationTextTnC={"key":true,"value":'I agree for my KYD Bank Account to be considered for payout of my brokerage commission.'};

    vm.init = function () {
      vm.formData=EmpanellmentModal.getEmpanellmentModal();
      var success=function (resp) {
          LoaderService.hideLoader();
          if(resp.status && resp.data){
            vm.modalData=resp.data.declarationSet;
          }
          else{
            MessageService.error(resp.message);
          }
        },
        error=function () {
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      var payload={
        "empanelmentToken": vm.formData.empanelmentToken
      };
      DistributorEmpanellmentService.post({controller:'getDeclarationSet'}, payload).$promise.then(success, error);

    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    function declerationConfirm() {
      var success=function (resp) {
          vm.isProcessing=true;
          // LoaderService.hideLoader();
          if(resp.status){
            EmpanellmentModal.setEmpanellmentModal(vm.formData);
            $uibModalInstance.close("success");
          }
          else{
            MessageService.error(resp.message);
            $uibModalInstance.dismiss("cancel");
          }
        },
        error=function () {
          vm.isProcessing=false;
          // LoaderService.hideLoader();
        };
      // LoaderService.showLoader();
      vm.isProcessing=true;
      var payload={
        "empanelmentToken": vm.formData.empanelmentToken,
        "listOfDeclaration":vm.formData.declaretionArray,
        "termAndCondition": vm.declerationTextAgreementModel && vm.declerationTextTnCModel
      };
      DistributorEmpanellmentService.post({controller:'declarationSet'}, payload).$promise.then(success, error);

    }

    function declerationExit() {
      $state.go('login');
    }

    function changedSelection() {
      vm.formData.declaretionArray=[];
      angular.forEach(vm.modalData, function(data){
        if (data.selected){
          vm.formData.declaretionArray.push(data.key);
        }
      });
    }

    function termsAndConditions() {
      ModalService.termConditionModal();
    }


  }
})();

/**
 * Created by ttn on 19/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EmpanellmentSuccessModalController', empanellmentSuccessModalController);

  /** @ngInject */
  function empanellmentSuccessModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.init = function () {

    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 07/07/20.
*/
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CutOffLoginModalController', cutOffLoginModalController);

  /** @ngInject */
  function cutOffLoginModalController($uibModalInstance, modalView, modalData,HDFC_API,$window, UtilService , MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.headingFirst = "Applicability of NAV only after realization of funds";
    vm.headingSecond = "(effective February 1, 2021)";
    vm.headingThird = "Change in Name of Dividend Option ( Effective 1 April,2021 )";
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.DynamicDataFirstLogin = null;
    init();

    function init() {
      var successHandler = function(resp) {
        vm.DynamicDataFirstLogin = resp.popupDTO.popupDTOMap.Popup_Home;
      }

      UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss();
    };


    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };
  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ConfirmCancelController', confirmCancelController);

  /** @ngInject */
  function confirmCancelController($uibModalInstance, modalView, modalData, $window,HDFC_API, InvestorModel, UtilService , MessageService , ModalService ,  AppConstants , AuthService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = 'Are you sure, you want to cancel this action?';
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.formData = InvestorModel.getInvestorModel();
    vm.isOptOut = false;
    vm.init = init();
    vm.data = modalData;
    vm.CONST = AppConstants;

    if(modalData.isOptOutDec){
      vm.isOptOutDec = modalData.isOptOutDec;
    }
    if(vm.formData && modalData.forFolioCreation){
      if(vm.formData.folioCreationRequestCO) {
        if (modalData.nomineeDetails || vm.formData.folioCreationRequestCO.addNomineeLater) {
          vm.formData.folioCreationRequestCO.addNomineeLater = true;
          InvestorModel.setInvestorModel(vm.formData)
        } else {
          vm.formData.folioCreationRequestCO.addNomineeLater = false;
          InvestorModel.setInvestorModel(vm.formData);
        }
      }else{
        if(modalData.nomineeDetails.length == 0){
          vm.isOptOut = true;
        }else{
          vm.isOptOut = false;
        }
      }
    }

    function init() {
      var successHandler = function(resp) {
       vm.cutOffDynamicData = resp.popupDTO.popupDTOMap.Note_Smartlink_Popup;
      }

      UtilService.fetchDynamicData("SMARTLINK_WEB").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    if (modalData.Text) {
      vm.modalData = modalData.Text;
    }

    if (modalData.ButtonProceed) {
      vm.buttonProceed = true;
      vm.buttonCancel = true;
      vm.continueSip = true;
      if (!vm.data.otherFlow) {
        vm.buttonModify = true;
      } else {
        vm.buttonModify = false;
      }
      vm.buttonPause = vm.data.showPause;

      if (vm.modalData.SYSTEMATIC_NUDGE_MESSAGE && vm.modalData.SYSTEMATIC_NUDGE_MESSAGE.content && !vm.data.otherFlow) {
        if (!vm.buttonPause && vm.buttonModify) {
          vm.modifyPopupHeaderMessage = vm.modalData.SYSTEMATIC_NUDGE_MESSAGE.content.replace('or Pause ','');
        } else if (vm.buttonPause && !vm.buttonModify) {
          vm.modifyPopupHeaderMessage = vm.modalData.SYSTEMATIC_NUDGE_MESSAGE.content.replace(' Modify or','');
        } else {
          vm.modifyPopupHeaderMessage = vm.modalData.SYSTEMATIC_NUDGE_MESSAGE.content;
        }
      } else if (vm.modalData.SYSTEMATIC_NUDGE_MESSAGE && vm.modalData.SYSTEMATIC_NUDGE_MESSAGE.content && vm.data.otherFlow && vm.data.tncType === 'DREAMSIP') {
        vm.modifyPopupHeaderMessage = vm.modalData.SYSTEMATIC_NUDGE_MESSAGE_DREAMSIP.content;
      }
    }
    if(modalData.Text && modalData.buttonText){
      vm.modalData = {
        Text : modalData.Text,
        fromFolioCreation: modalData.fromFolioCreation,
        buttonText : modalData.buttonText
      }
    }
    if(modalData.Text && modalData.buttonText){
      vm.modalData = {
        Text : modalData.Text,
        fromFolioCreation: modalData.fromFolioCreation,
        buttonText : modalData.buttonText
      }
    }

    vm.closeModal = function () {
      sessionStorage.setItem('showDeclaration', true)
      $uibModalInstance.close();
    };

    vm.dismissModal = function (val) {
      $uibModalInstance.dismiss(val);
    };

    vm.openLink = function () {
      $window.open("https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf");
    }

    vm.paymentNavUrl = function () {
      $window.open(vm.paymentNavURL);
    };

    vm.displayOptOutMsg = function (){
      vm.modalData.fromFolioCreation = true;
    }

    vm.contineWithSip = function () {
      $uibModalInstance.close("continueSip");
    }

    vm.modifySip = function () {
      $uibModalInstance.close("modifySip");
    }

    vm.redirectToPause = function () {
      $uibModalInstance.close("pauseSip");
    }

    vm.cancelSip = function () {
      $uibModalInstance.close("cancelSip");
    }

    vm.getTransactionType = function (type) {
      $uibModalInstance.close(type);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CancelNomineeController', cancelNomineeController);

  /** @ngInject */
  function cancelNomineeController($uibModalInstance, modalView, modalData, InvestorsServiceVersion, MessageService, $window, ModalService) {
    var vm = this;
    vm.folioData = JSON.parse($window.sessionStorage.getItem('folioData'));
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };



    vm.cancelNominee = function () {
      var success = function (resp) {
        if (resp.status && resp.data) {
          ModalService.successMessageModal({message:resp.message},success);
        } else {

          vm.closeModal();
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsServiceVersion.get({
        child1: 'nominee',
        child2: 'cancellation',
        child3: 'initiate',
        child4: vm.folioData.folioNumber
      }).$promise.then(success, error);
    }


  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SuccessModalController', successModalController);

  /** @ngInject */
  function successModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.init = function () {

    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

/**
 * Created by ttn on 12/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BankPaymentModalController', bankPaymentModalController);

  /** @ngInject */
  function bankPaymentModalController($timeout, $uibModalInstance, modalView, $window, modalData, MessageService, BillJunctionService, UtilityService, LoaderService, UtilService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.selectedPaymentGateway = null;

    vm.init = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          LoaderService.hideLoader();
          vm.bankList = resp.data;
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };

      UtilityService.get({
        controller: 'bank',
        child: 'list'
      }).$promise.then(success, error);
    };

    vm.closeModal = function () {
      $uibModalInstance.close();
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

    vm.makePayment = function () {
      if (vm.bankdata) {
        var bankdata = angular.fromJson(vm.bankdata);
        if (bankdata.gateWayVendor == "BILLDESK") {
          vm.makePaymentwithBillDesk(vm.modalData.uniqueLink, vm.modalData.amount, bankdata.bankCode);
        }
        else if (bankdata.gateWayVendor == "BILLJUNCTION") {
          vm.makePaymentWithBillJunction(vm.modalData.uniqueLink, vm.modalData.amount, bankdata.bankCode);
        }
      }
    };

    vm.makePaymentWithBillJunction = function (uniqueLink, amount, bankCode) {

      var newWin = $window.open("about:blank", 'newtab');
      newWin.document.write("<h2>Please wait while we fetch details....</h2>");
      var success = function (resp) {
        if (resp.status && resp.data) {
          // $window.open(resp.data, '_blank');
          newWin.location = resp.data;
        } else {
          newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
        UtilService.errorHandler(err);
      };
      var payload = {"uniqueLink": uniqueLink, "amount": amount, bankCode: bankCode};
      BillJunctionService.post({
        controller: 'junction',
        child1: 'payment'
      }, payload).$promise.then(success, error);
    };

    vm.makePaymentwithBillDesk = function (uniqueLink, amount, bankCode) {
      var success = function (resp) {
        if (resp.data && resp.status) {
          if (resp.status && resp.data) {
            vm.billDeskpayload = resp.data;
            $timeout(function () {
              angular.element('#billdeskPayForm').submit();
            }, 100);
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };

      var payload = {"uniqueLink": uniqueLink, "amount": amount, bankCode: bankCode};
      BillJunctionService.post({
        controller: 'billdesk',
        child1: 'payment'
      }, payload).$promise.then(success, error);
    };
  }
})();

/**
 * Created by ttn on 13/12/2023.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AlertAndUpdateInfoController', alertAndUpdateInfoController);

  /** @ngInject */
  function alertAndUpdateInfoController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.modalData = modalData;
    vm.view = modalView;

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentDraftController', agentDraftController);

  /** @ngInject */
  function agentDraftController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close(vm.modalData);
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentCreateAgentSuccessModalController', agentCreateAgentSuccessModalController);

  /** @ngInject */
  function agentCreateAgentSuccessModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close("sign up successfull");
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };



  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentChangePasswordSuccessModalController', AgentChangePasswordSuccessModalController);

  /** @ngInject */
  function AgentChangePasswordSuccessModalController($uibModalInstance, modalView, modalData) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;

    vm.closeModal = function () {
      $uibModalInstance.close("Change password successfully");
    };

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };

  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AddNomineeController', addNomineeController);

  /** @ngInject */
  function addNomineeController($uibModalInstance, modalView, MessageService ,ModalService, $window, $state, InvestorModel, AppConstants, LoaderService, UtilService, InvestorsService, InvestorsCommonService, InvestorsServiceVersion, modalData,$timeout, InvestorCommonServiceVersion2) {
    var vm = this;
    vm.calculatePercentage = calculatePercentage;
    vm.addMoreNominee = addMoreNominee;
    vm.addNominee = addNominee;
    vm.formData = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel();
    vm.formData = vm.formData.folioCreationRequestCO || vm.formData;
    vm.parentIndex = 0;
    vm.maxNominee = 3;
    vm.onChangePercentage = onChangePercentage;
    vm.setActiveTab = setActiveTab;
    vm.activeTab = 0;
    vm.showAddNominee = true;
    vm.showStateList = true;
    vm.deleteNominee = deleteNominee;
    vm.nomineeChangeDob = nomineeChangeDob;
    vm.getStateList = getStateList;
    vm.checkPanValidation=checkPanValidation;
    vm.getRelationshipList = getRelationshipList;
    vm.checkUniqueGuardianPan = checkUniqueGuardianPan;
    vm.buttonHandler = buttonHandler;
    vm.singleNomineePanCheck = singleNomineePanCheck;
    vm.nomineePanInvalidCheck = null;
    vm.guardianPanInvalidCheck = null;
    vm.modalData = modalData;
    vm.appConstants = AppConstants;
    vm.manageRegulatoryDetails = vm.modalData.manageRegulatoryDetails ? vm.modalData.manageRegulatoryDetails : {};
    vm.showNomineeUpdate = vm.manageRegulatoryDetails.showNomineeUpdate;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.isPanVerified=false;
    vm.checkDecimal=checkDecimal;
    vm.validateDOBRequre = validateDOBRequre;
    vm.changeRelationshipWithApplicant = changeRelationshipWithApplicant;
    vm.changeNomineeIdentityProof = changeNomineeIdentityProof;
    vm.selectedNominee = selectedNominee;
    vm.changeDrivingLicense = changeDrivingLicense;
    vm.changeAadharCard = changeAadharCard;
    vm.toggleSelection = toggleSelection;
    vm.nameFilter = nameFilter;
    vm.hasNomineeName = hasNomineeName;
    vm.isEmptyObject = isEmptyObject;
    vm.changeSelectedName = changeSelectedName;
    vm.changeNomineeName = changeNomineeName;
    vm.setStatement = setStatement;
    vm.changePercentageOrAmount = changePercentageOrAmount;
    vm.onPaste=onPaste;
    vm.emailIdValid = true;
    vm.nomineePropertion = {
      min: 0,
      max: 100
    };
    vm.enum = {
      0: 'First',
      1: 'Second',
      2: 'Third',
      3: 'Fourth',
      4: 'Fifth',
      5: 'Sixth',
      6: 'Seventh',
      7: 'Eighth',
      8: 'Ninth',
      9: 'Tenth'
    };
    vm.view = modalView;
    vm.isPercentageValid = false;
    vm.isPrefillNomineeDataExist = false;
    vm.incapacitationDeclarationNameList = null;
    vm.incapacitationNameList = [];
    vm.changePassport = changePassport;
    vm.changeEmailId = changeEmailId;

    vm.init = init();

    function init() {
      LoaderService.showLoader();
      vm.folioData = JSON.parse($window.sessionStorage.getItem('folioData'));
      if (vm.folioData.accountHoldingDeclaration && vm.folioData.accountHoldingDeclaration === 'NOMINATION_YES' || !vm.folioData.accountHoldingDeclaration) {
        vm.folioData.nomination = true;
      } else if (vm.folioData.accountHoldingDeclaration && vm.folioData.accountHoldingDeclaration === 'NOMINATION_NO') {
        vm.folioData.nomination = false;
      }
      vm.isPrefillNomineeDataExist = vm.modalData.isNomineeData;
      if(vm.manageRegulatoryDetails && vm.manageRegulatoryDetails.nomineeLimit) {
        vm.maxNominee = vm.manageRegulatoryDetails.nomineeLimit;
      }

      if (vm.folioData.nominees) {
        for (var i = 0; i < vm.folioData.nominees.length; i++) {
          if(vm.folioData.nominees[i].isMinor == 'T'){
            vm.folioData.nominees[i].minor = true;
          }else {
            vm.folioData.nominees[i].minor = false;
          }
          if(vm.folioData.nominees[i].dateOfBirth) {
            vm.folioData.nominees[i].dateOfBirth = $window.moment(vm.folioData.nominees[i].dateOfBirth).format("DD-MMM-YYYY");
            nomineeChangeDob(vm.folioData.nominees[i].dateOfBirth, i);
          } else {
            vm.folioData.nominees[i].dateOfBirth = "";
          }
          if(vm.folioData.nominees[i].guardianName){
            vm.folioData.nominees[i].guardian = vm.folioData.nominees[i].guardianName;
          }
          if(vm.folioData.nominees[i].guardianRelationWithNominee){
            vm.folioData.nominees[i].guardianRelation = vm.folioData.nominees[i].guardianRelationWithNominee;
          }
          if(vm.folioData.nominees[i].guardianPanNumber){
            vm.folioData.nominees[i].guardianPan = vm.folioData.nominees[i].guardianPanNumber;
          }
          if(vm.folioData.nominees[i].panNumber){
            vm.folioData.nominees[i].nomineePan = vm.folioData.nominees[i].panNumber;
          }

          if(vm.folioData.nominees[i].identityProofType && vm.folioData.nominees[i].identityProofType === 'PASSPORT'){
            vm.folioData.nominees[i].passport = vm.folioData.nominees[i].identityProofNumber;
          }

          if(vm.folioData.nominees[i].identityProofType && vm.folioData.nominees[i].identityProofType === 'AADHAR_CARD'){
            vm.folioData.nominees[i].aadharCard = vm.folioData.nominees[i].identityProofNumber;
          }

          if(vm.folioData.nominees[i].identityProofType && vm.folioData.nominees[i].identityProofType === 'DRIVING_LICENSE'){
            vm.folioData.nominees[i].drivingLicense = vm.folioData.nominees[i].identityProofNumber;
          }

        }
      } else {
        var nomineesArray = [];
        var nomineeObject = {
          "firstName": "",
          "relation": null,
          "percentage": "",
          "dateOfBirth": "",
          "nomineeAddress1": "",
          "nomineeAddress2": "",
          "postalCode": "",
          "city": "",
          "state": "",
          "country": "",
          "guardian": "",
          "guardianRelation" : null,
          "guardianPan" : null,
          "nomineePan":null,
          "nomineePanInvalid":false,
          "guardianPanInvalid" : false,
          "verifyPan" : true,
          "otherRelation": null,
          "emailId": null,
          "mobileNumber": null,
          "nomineeIdentityProof": null,
          "drivingLicense": null,
          "aadharCard": null,
          "passport": null,
          "identityProofList": []
        };
        nomineesArray.push(nomineeObject);
        vm.folioData.nominees= nomineesArray;
      }
      /*if(!vm.folioData.accountHoldingDeclaration) {
        vm.folioData.accountHoldingDeclaration = [];
      }*/
      if(!vm.folioData.incapacitationDeclaration) {
        vm.folioData.incapacitationDeclaration = {};
      }
      LoaderService.hideLoader();
      getCountryList();
      calculatePercentage();
      getStateList();
      getRelationshipList();
      if(vm.showNomineeUpdate) {
        vm.folioData.nomineeName = true;
        setStatement();
        getIdentityProfList(function () {
          vm.folioData.nominees.forEach(function(data,index){
            checkNomineeIsMinor(index);
            changeNomineeName(index, data.firstName);
          })
        });
      }
    }

    function checkPanValidation(index, pan, guardianPan) {
      for(var i=0;i<vm.folioData.nominees.length;i++) {
        if (vm.folioData.nominees[i].nomineePan == "") {
          vm.folioData.nominees[i].nomineePanInvalid = false;
        }
      }
      if (vm.folioData.nominees[index].nomineePan == pan) {
        if (vm.folioData.nominees.length > 0) {
          // vm.folioData.nominees[index].nomineePanInvalid = false;
          if((vm.folioData.nominees[index].nomineePan && !vm.isPanVerified) || (vm.folioData.nominees[index].nomineePan=='' && !vm.isPanVerified) ) {
            checkUniqueGuardianPan(index, guardianPan, true);

          }
        }
      }
      if (vm.folioData.nominees.nomineePan == pan) {
        if (vm.folioData.nominees.length == 1) {
          vm.folioData.nominees[index].nomineePanInvalid = false;
        }
      }
      else if (vm.folioData.nominees.nomineePan !== pan) {
        for (var i = 0; i < vm.folioData.nominees.length; i++) {
          if (i !== index && vm.folioData.nominees[index].nomineePan) {
            if (vm.folioData.nominees[i].nomineePan == pan) {
              vm.folioData.nominees[index].nomineePanInvalid = true;
              vm.folioData.nominees[i].nomineePanInvalid = false;
              vm.errorMessage = vm.validateData.UNIQUE_NOMINEE_PAN;
              break;

            } else if (vm.folioData.nominees[i].nomineePan !== pan) {
              vm.folioData.nominees[index].nomineePanInvalid = false;
            }
          }
        }
        for(var i=0;i<vm.folioData.nominees.length;i++){
          if(vm.modalData.investorPan && vm.folioData.nominees[i].nomineePan && (vm.modalData.investorPan == vm.folioData.nominees[i].nomineePan)){
            vm.folioData.nominees[i].nomineePanInvalid = true;
            vm.errorMessage = vm.validateData.NOMINEE_SAME_INVESTOR;
          }
        }
      }
      vm.folioData.nominees[index].identityProofNumber = pan;

      if (!vm.folioData.nominees[index].identityProofObj) {
        vm.folioData.nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == vm.folioData.nominees[index].identityProofType
        })
      }

      vm.folioData.nominees[index].identityProofCamsCode = vm.folioData.nominees[index].identityProofObj ? angular.copy(vm.folioData.nominees[index].identityProofObj.identityProofCamsCode) : null;
      checkUniqueGuardianPan(index, guardianPan, false);
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countryList = resp.data.countries;
        } else {
          vm.countryList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.countryList = null;
      };
      InvestorsService.post({child1: 'country', child2: 'list'},null).$promise.then(success, error);
    }


    function checkValidation() {
      var arr = vm.folioData.nominees, msg = '';
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i]['firstName'] || !arr[i]['percentage']) {
          msg = 'Please fill details of ' + vm.enum[i]
            + ' nominee';
          break;
        }
      }
      return msg;
    }

    function addNominee() {
      var msg = checkValidation();
      if (msg) {
        MessageService.error(msg);
        return;
      }
      if (!vm.folioData.nominees)
        vm.folioData.nominees = [];
      vm.folioData.nominees.push(
        {
          "firstName": "",
          "relation": null,
          "percentage": "",
          "dateOfBirth": "",
          "nomineeAddress1": "",
          "nomineeAddress2": "",
          "postalCode:": "",
          "city": "",
          "state": "",
          "country": "",
          "guardian": "",
          "guardianRelation" : null,
          "guardianPan" : null,
          "nomineePan":null,
          "nomineePanInvalid":false,
          "guardianPanInvalid" : false,
          "verifyPan" : true,
          "otherRelation": null,
          "emailId": null,
          "mobileNumber": null,
          "nomineeIdentityProof": null,
          "drivingLicense": null,
          "aadharCard": null,
          "passport": null,
          "identityProofList": []
        }
      );

      vm.activeTab = vm.folioData.nominees.length - 1;
      checkNomineeIsMinor(vm.activeTab);

    }

    function getStateList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.stateList = resp.data.states;
        } else {
          vm.stateList = null;
          MessageService.error(resp.message);
        }
      }, error = function () {
        vm.stateList = null;
      };
      InvestorsCommonService.get({
        child1: 'state',
        child2: 'list'
      }).$promise.then(success, error);
    }




    vm.nomineeUpdate = function () {
      var payload = {
        folioNumber: vm.folioData.folioNumber,
        nomineeList: []
      }
      var isProportion = calculatePercentage();
      if (!isProportion) {
        vm.percentage_msg = vm.validateData.PROPORTION_PERCENTAGE;
      }
      if (isProportion) {
        LoaderService.showLoader();
        var nomineeArr = [];
        nomineeArr = vm.folioData.nominees;
        payload.folioNumber = vm.folioData.folioNumber;
        for (var j = 0; j < nomineeArr.length; j++) {
          if(nomineeArr[j].country == '' || nomineeArr[j].country == null){
            vm.countryList.map( function (country) {
              if(country.countryCode === nomineeArr[j].countryCode){
                vm.folioData.nominees[j].country = country.countryName;
              }
            });
          }
          payload.nomineeList.push({
            firstName: nomineeArr[j].firstName,
            guardianName: nomineeArr[j].guardian,
            nomineeAddress1: nomineeArr[j].nomineeAddress1,
            nomineeAddress2: nomineeArr[j].nomineeAddress2,
            relation: nomineeArr[j].relation,
            dateOfBirth: nomineeArr[j].dateOfBirth ? nomineeArr[j].dateOfBirth : null,
            percentage: parseInt(nomineeArr[j].percentage, 10),
            city: nomineeArr[j].city,
            minor:nomineeArr[j].minor ? nomineeArr[j].minor : false,
            stateCode: nomineeArr[j].stateCode,
            country: nomineeArr[j].country,
            countryCode: nomineeArr[j].countryCode,
            postalCode: nomineeArr[j].postalCode ? nomineeArr[j].postalCode : null,
            guardianPanNumber : nomineeArr[j].guardianPan,
            panNumber : nomineeArr[j].nomineePan == '' ? null :nomineeArr[j].nomineePan,
            guardianRelationWithNominee : nomineeArr[j].guardianRelation == '' ? null : nomineeArr[j].guardianRelation,
            emailId: vm.showNomineeUpdate ? nomineeArr[j].emailId : null,
            mobileNumber: vm.showNomineeUpdate ? nomineeArr[j].mobileNumber : null,
            identityProofType: vm.showNomineeUpdate ? nomineeArr[j].identityProofType : null,
            identityProofNumber: vm.showNomineeUpdate ? nomineeArr[j].identityProofNumber : null,
            identityProofCamsCode :vm.showNomineeUpdate ? nomineeArr[j].identityProofCamsCode : null
          });
          if(vm.showNomineeUpdate) {
            if (vm.folioData.nomination) {
              payload.accountHoldingDeclaration = "NOMINATION_YES";
            } else {
              payload.accountHoldingDeclaration = "NOMINATION_NO";
            }
          }
          if(vm.showNomineeUpdate && !isEmptyObject(vm.folioData.incapacitationDeclaration)) {
            payload.incapacitationDeclaration = vm.folioData.incapacitationDeclaration;
            delete payload.incapacitationDeclaration.nomineeIndex;
          }
        }
        if(vm.showNomineeUpdate) {
          InvestorsServiceVersion.post2({
            'child1': 'nominee',
            'child2': 'add-update',
            'child3': 'initiate'
          }, payload).$promise.then(success, failure);
        } else {
          InvestorsServiceVersion.post({
            'child1': 'nominee',
            'child2': 'add-update',
            'child3': 'initiate'
          }, payload).$promise.then(success, failure);
        }
      }
    };

    vm.changeSelectedCountry = function(index,countryCode){
      if (!countryCode) {
        vm.folioData.nominees[index].stateCode = null;
        vm.folioData.nominees[index].state = null;
        vm.folioData.nominees[index].country = null;
        return;
      }
      vm.countryList.map( function (country) {
        if(country.countryCode === countryCode){
          vm.folioData.nominees[index].country = country.countryName;
          if (vm.folioData.nominees[index].country != 'INDIA'){
            for(var i = 0; i<vm.stateList.length; i++){
              if (vm.stateList[i].stateCode == 'XX'){
                vm.folioData.nominees[index].stateCode = vm.stateList[i].stateCode;
                vm.folioData.nominees[index].state = vm.stateList[i].stateName;
                break;
              }
            }
          }
        }
      });
    }


    function success(resp) {
      if (resp.status == true ) {
        LoaderService.hideLoader();
        ModalService.successMessageModal({message:resp.message},success);
        vm.closeModal();
      } else {
        MessageService.error(resp.message);
        LoaderService.hideLoader();
      }
    }

    function failure(resp) {
      MessageService.error(resp.message);
      LoaderService.hideLoader();
    }



    function calculatePercentage() {
      var totalPercentage = 0;
      var nominees = vm.folioData.nominees;
      for (var i in nominees) {
        if(nominees[i].percentage == 0){
          vm.isPercentageValid = true;
        }else {
          vm.isPercentageValid = false;
        }
        totalPercentage += parseInt(nominees[i].percentage);
      }
      vm.totalPercentage = totalPercentage;

      if (vm.totalPercentage < 100 && (vm.folioData.nominees && vm.folioData.nominees.length) < vm.maxNominee) {
        vm.showAddNominee = true;
      } else {
        vm.showAddNominee = false;
      }
      if (totalPercentage != 100) {
          vm.percentage_msg = vm.validateData.PROPORTION_PERCENTAGE;
        return false;
      } else {
          vm.percentage_msg = '';
          return true;
      }

    }



    vm.changeState = function(index, stateCode) {
      vm.stateList.map( function (state) {
        if(state.stateCode === stateCode){
          vm.folioData.nominees[index].state = state.stateCode;
          vm.folioData.nominees[index].state = state.stateName;
        }
      });
    }


    function deleteNominee(index) {
      if (vm.showNomineeUpdate) {
        if (index === parseInt(vm.folioData.incapacitationDeclaration.nomineeIndex) && vm.folioData.nominees[index].firstName === vm.folioData.incapacitationDeclaration.nomineeName) {
          vm.folioData.incapacitationDeclaration = {};
          vm.folioData.incapacitationDeclaration.percentage = null;
          vm.folioData.incapacitationDeclaration.amount = null;
        }
      }
      if(index == 0 && vm.isPrefillNomineeDataExist && vm.folioData.nominees.length === 1){
        var success = function () {
          $state.go('main.investors.nomineeOptout', {investorId : vm.modalData.investorId, folioNo : vm.modalData.folioNo});
          vm.closeModal();
        }, error = function () {}
        ModalService.optOutNomineeModal({
          text : "You are trying to delete last nominee, in-order to proceed with the deletion you will have to Opt-out of Nomination. You can add a nominee later whenever required.",
          ctaText : "Opt-out of Nomination Declaration"
        }, success, error)
      }else {
        vm.folioData.nominees.splice(index, 1);
      }
      vm.activeTab = 0;
      vm.calculatePercentage();
      singleNomineePanCheck();
      changeNomineeName(index);
    }

    function singleNomineePanCheck(){
      if(vm.folioData.nominees.length == 1) {
        if (vm.modalData.investorPan == vm.folioData.nominees[0].nomineePan) {
          vm.folioData.nominees[0].nomineePanInvalid = true;
          vm.errorMessage = vm.validateData.NOMINEE_SAME_INVESTOR;
        } else if(vm.folioData.nominees[0].nomineePan && vm.folioData.nominees[0].guardianPan && (vm.folioData.nominees[0].nomineePan==vm.folioData.nominees[0].guardianPan)){
          vm.folioData.nominees[0].guardianPanInvalid=true;
        }
        else {
          vm.folioData.nominees[0].nomineePanInvalid = false;
          vm.folioData.nominees[0].guardianPanInvalid = false;
        }
      }
    }

    function onChangePercentage(index) {
      if (vm.folioData.nominees.length == 0) {
        vm.nomineePropertion['min-0'] = 0;
        vm.nomineePropertion['max-0'] = 100;
      }
      else {
        var tempProportion = 0, totalProportion = 0;
        for (var i = 0; i < vm.folioData.nominees.length; i++) {
          if (i != index && vm.folioData.nominees[i].percentage) {
            tempProportion = tempProportion + vm.folioData.nominees[i].percentage;
          }
          totalProportion += (vm.folioData.nominees[i].percentage) * 1;
        }
        vm.showAddNomineeLink = (totalProportion < 100);
        vm.nomineePropertion['max-' + index] = 100 - tempProportion;
      }
    }

    function setActiveTab(index,pan, guardianPan, drivingLicense,aadharCard, passport) {
      vm.activeTab = index;
      if (pan) {
        checkPanValidation(index,pan);
      }

      if (guardianPan) {
        checkUniqueGuardianPan(index, guardianPan, true);
      }
      if (vm.showNomineeUpdate) {
        changeDrivingLicense(index,drivingLicense);
        changeAadharCard(index,aadharCard);
        changePassport(index, passport);
      }
    }


    function nomineeChangeDob(date,index) {
      if (!date) {
        return;
      }
      if(typeof(date) == 'string'){
        if(index != null || index != undefined){
          vm.folioData.nominees[index].dateOfBirth = date;
        }else {
          vm.folioData.nominees[vm.activeTab].dateOfBirth = date;
        }
      }else {
        if(index != null || index != undefined){
          vm.folioData.nominees[index].dateOfBirth = $window.moment(date, 'YYYY-MM-DD').format("DD-MMM-YYYY");
        }else {
          vm.folioData.nominees[vm.activeTab].dateOfBirth = $window.moment(date, 'YYYY-MM-DD').format("DD-MMM-YYYY");
        }

      }
      var age = $window.moment().diff(date, 'years');
      if(index != null || index != undefined){
        if (age < 18) {
          vm.folioData.nominees[index].minor = true;
        } else {
          vm.folioData.nominees[index].minor = false;
          vm.folioData.nominees[index].guardian = null;
          vm.folioData.nominees[index].guardianRelation = null;
          vm.folioData.nominees[index].guardianPan = null;
        }
      }else {
        if (age < 18) {
          vm.folioData.nominees[vm.activeTab].minor = true;
        } else {
          vm.folioData.nominees[vm.activeTab].minor = false;
          vm.folioData.nominees[vm.activeTab].guardian = null;
          vm.folioData.nominees[vm.activeTab].guardianRelation = null;
          vm.folioData.nominees[vm.activeTab].guardianPan = null;
        }
      }
      validateDOBRequre();
    }

    function addMoreNominee() {
      var array = vm.folioData.nominees || [];
      vm.parentIndex = array.length - 1;
      var totalPropotion = 0;
      array.map(function (ele) {
        if (parseInt(ele.percentage)) {
          totalPropotion += ele.percentage * 1;
        }
      });
      if (totalPropotion >= 100) {
        MessageService.error("Proportion % has been alloted full.");
      } else {
        if (vm.folioData.nominees[vm.parentIndex] && vm.folioData.nominees[vm.parentIndex].nomineeName
          && vm.folioData.nominees[vm.parentIndex].percentage
          /*&& vm.formData.folioCreationRequestCO.nominees[vm.parentIndex].nomineeRelation*/
        ) {
          if (array.length < 4) {
            array.push({});
            InvestorModel.setInvestorModel(vm.folioData);
            $window.sessionStorage.investorForm = angular.toJson(vm.folioData);
            vm.defaultDateNominee = null; //new Date();
          } else {
            array.length = 0;
          }
          vm.currentNominee++;
        } else {
          angular.element('#nomineeName-' + vm.parentIndex).focus();
          MessageService.error("Please enter valid nominee details");
        }
        if (vm.folioData.nominees.length == 0) {
          vm.nomineePropertion.min = 0;
          vm.nomineePropertion.max = 100;
        } else {
          var tempProportion = 0;
          for (var i = 0; i < vm.folioData.nominees.length; i++) {
            if (vm.folioData.nominees[i].percentage) {
              tempProportion = tempProportion + vm.folioData.nominees[i].percentage;
            }
          }
          vm.nomineePropertion.max = 100 - tempProportion;
        }
      }
    }

    function checkUniqueGuardianPan(index,guardianPan, value){
      if(value){
        vm.folioData.nominees[index].verifyPan = true;
      }
       if(vm.folioData.nominees.nomineePan !== guardianPan)
      {
        vm.folioData.nominees[index].guardianPanInvalid = false;
        for(var i = 0 ; i < vm.folioData.nominees.length ; i ++) {
          if(vm.folioData.nominees[index].nomineePan ) {
            if(i == index && vm.folioData.nominees[i].nomineePan == guardianPan && vm.folioData.nominees[i].nomineePan !== "") {
              vm.folioData.nominees[index].guardianPanInvalid = true;
              vm.errorMessageForGuardianField = vm.validateData.GUARDIAN_SAME_NOMINEE;
              vm.isPanVerified=false;
              break;
            }
            else if(vm.folioData.nominees[i].guardianPan !== guardianPan && vm.folioData.nominees[i].guardianPan)
            {
              vm.folioData.nominees[index].guardianPanInvalid = false;
            }
          }
        }
      }
     if(value && guardianPan !== undefined){
       var success=function (resp){
         if(resp.data && resp.status){
           vm.isPanVerified=resp.data.panVerifiedFlag;
         }
         else{
           vm.isPanVerified=true;
           MessageService.error(resp.message);
           vm.folioData.nominees[index].verifyPan = false;
           vm.errorMessageForGuardianField = resp.message;
         }
       },error=function (resp){
         vm.errorMessageForGuardianField = vm.validateData.INVALID_PAN;
         MessageService.error(resp.message);
       };
       if( vm.folioData.nominees[index].guardianPan !== '' && vm.folioData.nominees[index].guardianPanInvalid==false
         && vm.folioData.nominees[index].guardianPan) {
         InvestorsCommonService.post({
           child1: 'guardian',
           child2: 'verifyPan'
         }, {pan: guardianPan}).$promise.then(success, error);
       }
     }
    }

    function buttonHandler(){
      for(var i = 0; i < vm.folioData.nominees.length; i++) {
        if(vm.folioData.nominees[i].nomineePanInvalid == undefined){
          vm.folioData.nominees[i].nomineePanInvalid = false;
        }
        if(vm.folioData.nominees[i].guardianPanInvalid == undefined){
          vm.folioData.nominees[i].guardianPanInvalid = false;
        }
        if(vm.folioData.nominees[i].verifyPan == undefined){
          vm.folioData.nominees[i].verifyPan = true;
        }
        if(vm.folioData.nominees[i].nomineePanInvalid){
          vm.nomineePanInvalidCheck = true;
          return vm.nomineePanInvalidCheck;
        }
        if(vm.folioData.nominees[i].guardianPanInvalid){
          vm.guardianPanInvalidCheck = true;
          return vm.guardianPanInvalidCheck;
        }
        if(!vm.folioData.nominees[i].verifyPan){
          vm.guardianPanInvalidCheck = true;
          return vm.guardianPanInvalidCheck;
        }
        // if(vm.folioData.email && vm.folioData.nominees[i].emailId && (vm.folioData.email === vm.folioData.nominees[i].emailId)) {
        //   return true;
        // }
        /*if(vm.folioData.mobileNumber && vm.folioData.nominees[i].mobileNumber && (vm.folioData.mobileNumber === vm.folioData.nominees[i].mobileNumber)) {
          return true;
        }*/

        if( vm.folioData.nominees[i].aadharCard){
          if(vm.folioData.nominees[i].nomineeAadharInvalid){
            return true;
          }
        }

        if(vm.folioData.nominees[i].drivingLicense){
          if(vm.folioData.nominees[i].nomineeDLInvalid){
            return true;
          }
        }

        if(vm.folioData.nominees[i].passport){
          if(vm.folioData.nominees[i].nomineePassportInvalid){
            return true;
          }
        }
      }
      // for(var i = 0; i < vm.folioData.nominees.length; i++){
      //   if(vm.folioData.nominees[i].guardianPanInvalid){
      //     vm.guardianPanInvalidCheck = true;
      //     return vm.guardianPanInvalidCheck;
      //   }
      // }
      // for(var i = 0; i < vm.folioData.nominees.length; i++){
      //   if(!vm.folioData.nominees[i].verifyPan){
      //     vm.guardianPanInvalidCheck = true;
      //     return vm.guardianPanInvalidCheck;
      //   }
      // }
      return false;
    }

    function getRelationshipList(){
      vm.relationList=[];
      vm.guardianRelationList = [];
      var succes = function(resp){
        if(resp.status && resp.data){
          vm.relationList = resp.data.nomineeRelationshipList;
          vm.guardianRelationList = resp.data.guardianRelationshipList;
          for(var i = 0; i < vm.folioData.nominees.length; i++){
            var applicantObject = vm.relationList.find(function (appRelation){
              return appRelation.relationDesc === vm.folioData.nominees[i].relation;
            })

            if(applicantObject){
              vm.folioData.nominees[i].relation = applicantObject.value;
            }

            var guardianRelationWithAppplicant = vm.guardianRelationList.find(function (guardianRelation){
              return guardianRelation.relationDesc === vm.folioData.nominees[i].guardianRelation;
            })

            if(guardianRelationWithAppplicant){
              vm.folioData.nominees[i].guardianRelation = guardianRelationWithAppplicant.value;
            }
          }
        }
        else{
          vm.relationList = [];
          vm.guardianRelationList = [];
          MessageService.error(resp.message);
        }
      }, error = function(){
        vm.relationList = [];
        vm.guardianRelationList = [];
      };
      InvestorsCommonService.get({
        child1 : 'nominee',
        child2: 'relation'
      }).$promise.then(succes, error);
    }

    vm.dismissModal = function () {
      $uibModalInstance.dismiss("cancel");
    };
    vm.closeModal = function () {
      $uibModalInstance.close();
    };
    vm.changeNomineeIsMinor = function(index){
      vm.folioData.nominees[index].dateOfBirth = null;
      $timeout(function () {
        if (vm.folioData.nominees[index].minor) {
          vm.folioData.nominees[index].panNumber = null;
        } else {
          vm.folioData.nominees[index].guardianPan =null;
          vm.folioData.nominees[index].guardianRelation = null;
          vm.folioData.nominees[index].guardian = null;
        }
        checkNomineeIsMinor(vm.activeTab);
        changeNomineeName(vm.activeTab,vm.folioData.nominees[vm.activeTab].firstName);
      }, 25);
    }
    vm.setInitiatedDate = function(){
      $timeout(function () {
        vm.dataMinDate1 = "";
        vm.dataMaxDate1 = "";
        vm.dataMinDate = "";
        vm.dataMaxDate = "";
        var currentDate = Date();
        var parsedDate = $window.moment(currentDate).format('DD-MMM-YYYY');
        var initiateDate = new Date('January 01, 1900 00:00:00');
          vm.dataMinDate1 = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          vm.dataMaxDate1 = $window.moment(Date.parse(parsedDate)).subtract(1, 'days');
          vm.dataMaxDate = $window.moment(Date.parse(parsedDate)).subtract(18, 'years');
          vm.dataMinDate = $window.moment(Date.parse(initiateDate));
      }, 25);
    }
    vm.setInitiatedDate();
    function validateDOBRequre(){
      vm.validateAllDOB = false;
      vm.folioData.nominees.forEach(function(el){
        if(el.minor){
          if(!el.dateOfBirth){
            vm.validateAllDOB = true;
          }
        }
      })
    }
    vm.changeGuardianName = function(){
      validateDOBRequre();
    }

    function getIdentityProfList(cb){
      cb = cb || function (){};
      var succes = function(resp){
        if(resp.status && resp.data){
          vm.applicantPersonalIdentifiers = resp.data.identityProofs;
          vm.identityProofList = vm.applicantPersonalIdentifiers;
          cb(true);
        }
        else{
          vm.identityProofList = [];
          MessageService.error(resp.message);
          cb(false);
        }
      }, error = function(){
        vm.identityProofList = [];
        cb(false);
      };
      InvestorCommonServiceVersion2.get({
        child1 : 'identity-proofs',
      }).$promise.then(succes, error);
    }

    function changeRelationshipWithApplicant(index) {
      vm.folioData.nominees[index].otherRelation = null;
    }

    function changeNomineeIdentityProof(index, identifier) {
      vm.applicantPersonalIdentifiers.map(function (el) {
        if (el.value === identifier) {
          vm.folioData.nominees[index].nomineeIdentityProof = el.value;
        }
      });
      vm.folioData.nominees[index].nomineePan = '';
      vm.folioData.nominees[index].drivingLicense = '';
      vm.folioData.nominees[index].aadharCard = '';
      vm.folioData.nominees[index].passport = '';
      vm.folioData.nominees[index].identityProofObj = null;
    }

    function selectedNominee() {
      if (vm.folioData.incapacitationDeclaration && !vm.folioData.incapacitationDeclaration.nomineeIndex) {
        vm.folioData.incapacitationDeclaration.percentage = null;
        vm.folioData.incapacitationDeclaration.amount = null;
      }
      vm.folioData.incapacitationDeclaration.nomineeNumber = parseInt(vm.folioData.incapacitationDeclaration.nomineeIndex) + 1;
      vm.folioData.incapacitationDeclaration.nomineeName = vm.folioData.nominees[vm.folioData.incapacitationDeclaration.nomineeIndex].firstName;
    }

    function checkNomineeIsMinor(index) {
      var nominee = vm.folioData.nominees[index];
      nominee.identityProofList = [];
      if (nominee.minor) {
        for (var i = 0; i < vm.applicantPersonalIdentifiers.length; i++) {
          if (vm.applicantPersonalIdentifiers[i].identityProofType !== "DRIVING_LICENSE") {
            nominee.identityProofList.push(vm.applicantPersonalIdentifiers[i]);
          }
        }
      } else {
        nominee.identityProofList = vm.applicantPersonalIdentifiers.slice();
      }
    }

    function changeDrivingLicense(index, drivingLicense) {
      // checkUniqueIdentity(index,'drivingLicense',drivingLicense);
      checkDuplicateNomineeDL(index,drivingLicense)
    }

    function changeAadharCard(index, aadharCard) {
      // checkUniqueIdentity(index,'aadharCard',aadharCard);
      checkDuplicateNomineeAadhaar(index,aadharCard);
    }

    function checkDuplicateNomineeDL(index, drivingLicense) {

      if (!drivingLicense) {
        return;
      }

      var nominees = vm.folioData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].drivingLicense) {
          nominees[i].nomineeDLInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].drivingLicense && drivingLicense && (i !== index && nominees[i].drivingLicense === drivingLicense)) {
          nominees[index].nomineeDLInvalid = true;
          nominees[i].nomineeDLInvalid = false;
          vm.errorMessageDLIdentity = vm.validateData.DRIVING_LICENSE_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeDLInvalid = false;
      nominees[index].identityProofNumber = drivingLicense;

      if (!nominees[index].identityProofObj) {
        nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == nominees[index].identityProofType
        })
      }

      nominees[index].identityProofCamsCode = nominees[index].identityProofObj ? angular.copy(nominees[index].identityProofObj.identityProofCamsCode) : null;

    }

    function checkDuplicateNomineeAadhaar(index, aadharCard) {

      if (!aadharCard) {
        return;
      }

      var nominees = vm.folioData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineeDLInvalid for empty drivingLicense
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].aadharCard) {
          nominees[i].nomineeAadharInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].aadharCard && aadharCard && (i !== index && nominees[i].aadharCard === aadharCard)) {
          // nominees[index].nomineeAadharInvalid = true;
          nominees[i].nomineeAadharInvalid = false;
          // vm.errorMessageDLIdentity = vm.validateData.AADHAAR_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineeAadharInvalid = false;
      nominees[index].identityProofNumber = aadharCard;
      if (!nominees[index].identityProofObj) {
        nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == nominees[index].identityProofType
        })
      }

      nominees[index].identityProofCamsCode = nominees[index].identityProofObj ? angular.copy(nominees[index].identityProofObj.identityProofCamsCode) : null;
    }

    function toggleSelection(value) {
      /*var index = vm.folioData.accountHoldingDeclaration.indexOf(value);
      if (index > -1) {
        vm.folioData.accountHoldingDeclaration.splice(index, 1);
      } else {
        vm.folioData.accountHoldingDeclaration.push(value);
      }*/
    }

    /*** function responsible  for handling incapcitaion dropdown - don't allow dropdown value to contain value without firstname **/

    function nameFilter(item) {
      return item.firstName !== '' && item.firstName !== undefined;
    }

    function hasNomineeName(){
      if (!vm.folioData.nominees) {
        return false;
      }

      for (var i = 0; i < vm.folioData.nominees.length; i++) {
        if (vm.folioData.nominees[i].firstName) {
          return true;
        }
      }
      return false;
    }

    function isEmptyObject(obj) {
      return angular.equals({}, obj);
    }

    function setStatement() {
      // vm.folioData.accountHoldingDeclaration = [];
      /*if (vm.folioData.nomineeName) {
        vm.folioData.accountHoldingDeclaration.push('NAME_OF_NOMINEES');
      }
      if (vm.folioData.nomination) {
        vm.folioData.accountHoldingDeclaration.push('NOMINATION_YES');
      }*/
    }

    function changeSelectedName(selectedName){
      if (!selectedName) {
        vm.folioData.incapacitationDeclaration.percentage = null;
        vm.folioData.incapacitationDeclaration.amount = null;
        vm.folioData.incapacitationDeclaration.nomineeNumber = null;
        vm.folioData.incapacitationDeclaration.nomineeName = null;
      }
      if(selectedName) {
        vm.folioData.incapacitationDeclaration.nomineeNumber = selectedName.index + 1;
        vm.folioData.incapacitationDeclaration.nomineeName = selectedName.nomineeName;
      }
    }

    function changePercentageOrAmount(from){
      if(from === 'percentage'){
        vm.folioData.incapacitationDeclaration.amount = null;
      }

      if(from === 'amount'){
        vm.folioData.incapacitationDeclaration.percentage = null;
      }
    }

    function changeNomineeName(index,nomineeName){
      var updated = false;

      for (var i = 0; i < vm.incapacitationNameList.length; i++) {
        if (vm.incapacitationNameList[i].index === index) {
          if (!nomineeName) {
            vm.incapacitationNameList.splice(i, 1);
          } else {
            vm.incapacitationNameList[i].nomineeCode = nomineeName + '-' + vm.enum[index];
            vm.incapacitationNameList[i].nomineeName = nomineeName;
            vm.incapacitationNameList[i].activeFlag = vm.folioData.nominees[index].minor;
          }
          updated = true;
          break;
        }
      }
      if (!updated && nomineeName) {
        vm.incapacitationNameList.push({
          "index": index,
          "nomineeCode": nomineeName + '-' + vm.enum[index],
          "nomineeName": nomineeName,
          "activeFlag": vm.folioData.nominees[index].minor
        });
      }
      //Sorting and check next element will align after delete
      vm.incapacitationNameList.sort(function (a, b) {
        return a.index - b.index;
      });
      for (var i = 0; i < vm.incapacitationNameList.length; i++) {
        vm.incapacitationNameList[i].index = i;
        vm.incapacitationNameList[i].nomineeCode = vm.incapacitationNameList[i].nomineeName + '-' + vm.enum[i];
      }
    }
    function checkDecimal(event){
      if(event.key==='.') {
        event.preventDefault();
      }
    }
    function onPaste(event){
      event.preventDefault();
    }

    function changePassport(index, passport) {

      if (!passport) {
        return;
      }

      var nominees = vm.folioData.nominees;
      var nomineeCount = nominees.length;

      // Reset nomineePassportInvalid for empty passport
      for (var i = 0; i < nomineeCount; i++) {
        if (!nominees[i].passport) {
          nominees[i].nomineePassportInvalid = false;
        }
      }
      for (var i = 0; i < nomineeCount; i++) {
        if (nominees[i].passport && passport && (i !== index && nominees[i].passport === passport)) {
          nominees[index].nomineePassportInvalid = true;
          nominees[i].nomineePassportInvalid = false;
          vm.errorMessagePassportIdentity = vm.validateData.PASSPORT_ALREADY_EXIST;
          return;
        }
      }
      nominees[index].nomineePassportInvalid = false;
      nominees[index].identityProofNumber = passport;
      if (!nominees[index].identityProofObj) {
        nominees[index].identityProofObj = vm.identityProofList.find(function (el) {
          return el.identityProofType == nominees[index].identityProofType
        })
      }

      nominees[index].identityProofCamsCode = nominees[index].identityProofObj ? angular.copy(nominees[index].identityProofObj.identityProofCamsCode) : null;
    }


    function changeEmailId(index, emailId) {
      /*if (!emailId) {
        return;
      }
      if (vm.folioData.email && (vm.folioData.email.toLowerCase() === emailId.toLowerCase())) {
        vm.folioData.nominees[index].emailIdInvalid = true;
        vm.emailIdValid = false;
        vm.errorMessageEmail = vm.validateData.NOMINEE_EMAIL_SAME_AS_INVESTOR;
      } else {
        vm.folioData.nominees[index].emailIdInvalid = false;
        vm.emailIdValid = true;
        vm.errorMessageEmail = null;
      }*/
    }
  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('AddJointHolderController', addJointHolderController);

    /** @ngInject */
    function addJointHolderController($uibModalInstance,LoaderService,InvestorsService,MessageService,AppConstants, modalView, modalData,$scope, ModalService){
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.holderData = {};
      vm.emailDetails = {};
      vm.formData = {
        taxStatusResident: true
      };
    vm.showEmail = false;
    vm.showOtp = false;
    vm.Otp = '';
    vm.tempdata= null;
    vm.submit = submit;
    vm.appConstants = AppConstants;
    function submit() {
      $uibModalInstance.close(vm.tempdata);
    }
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };
      vm.closeModal = function () {
        $uibModalInstance.close();
      };
      vm.checkPanEmailExist = function () {
        var success = function (resp) {
          vm.processFlag = false;
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.tempdata = resp.data;
            vm.tempdata.taxStatusResident = vm.formData.taxStatusResident;
            if(resp.data.ekycStatus !== vm.appConstants.KYC_STATUS.NOT_VALIDATED && resp.data.ekycStatus !== vm.appConstants.KYC_STATUS.ON_HOLD) {
              if (resp.data && resp.data.emailExists === true) {
                vm.holderData.mobileNumber = resp.data.mobileNoWithoutMask;
                vm.holderData.jointHolderName = resp.data.name;
                vm.holderData.kycverified = resp.data.kycverified;
                vm.AllowedJointHolder = true;
                vm.processFlag = true;
                vm.wrongMsg = '';
              } else {
                vm.showEmail = true;
                vm.holderData.mobileNumber = resp.data.mobileNoWithoutMask;
                vm.holderData.jointHolderName = resp.data.name;
                vm.holderData.kycverified = resp.data.kycverified;
              }
            }
            if (resp.data.ekycStatus === vm.appConstants.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.appConstants.KYC_STATUS.ON_HOLD) {
              ModalService.nonKycModal({
                'text': resp.data.ekycStatus === vm.appConstants.KYC_STATUS.ON_HOLD ?
                  "<p>Your KYC Status is 'On hold'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'.</p>" :
                  "<p>Your KYC Status is 'Registered'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate update KYC process to change KYC status to 'Validated'.</p>",
                'showHtml': true,
                'buttonText': 'OK',
              }, function () {
                vm.processFlag = false;
              }, function () { });
            }
          } else {
            vm.wrongMsg = resp.message;
            LoaderService.hideLoader('.popup');
            MessageService.error(resp.message);
          }
        },
        error = function () {
        vm.processFlag = false;
        LoaderService.hideLoader('.popup');
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
        var payload = {
          pan: vm.holderData.pan,
          nriFlag: !vm.formData.taxStatusResident
        };
        LoaderService.showLoader('.popup');
        if(payload.pan){
          InvestorsService.post({controller: 'holder',child1: 'pan',child2: 'details'}, payload).$promise.then(success, error);
        }
      }
      vm.verifyOtp = function () {
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data && resp.data.verified) {
            vm.tempdata.email = vm.holderData.email;
            vm.showOtp = false;
            vm.AllowedJointHolder = true;
            vm.showEmail = false;
            vm.processFlag = true;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };

        var payload = {
          uniqueLink: vm.emailDetails.secretLink,
          otp: vm.Otp
        };
        LoaderService.showLoader('.popup');
    InvestorsService.post({
      controller: 'holder',
      child1: 'pan',
      child2: 'add',
      child3: 'email',
      child4: 'verify',
      child5: 'otp'
    }, payload).$promise.then(success, error);
      }
      vm.OTPResendMsg = '';
    vm.reGenerateOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        if (resp.status && resp.data) {
          vm.OTPResendMsg = resp.data.message;
        MessageService.success(vm.OTPResendMsg);
        vm.emailDetails.secretLink = resp.data.secretLink;
          vm.emailMsg = "";
        resetTimer();
        } else {
          vm.wrongMsg = resp.message;
          MessageService.error(resp.message);
        }
      },
      error = function () {
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
      };
      vm.payload = {
        pan: vm.holderData.pan,
        secretLink: vm.emailDetails.secretLink,
        email: vm.holderData.email
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'holder',
        child1: 'pan',
        child2: 'add',
        child3: 'email',
        child4: 'resend',
        child5: 'otp'
      }, vm.payload).$promise.then(success, error);
    }
      vm.resetValues = function () {
        vm.panAdhaarNotLinked = null;
        vm.tempdata = null;
        vm.errorMessage = "";
        vm.errorMessageVerify = "";
        vm.panMessage = "";
        vm.availableMessage = "";
        vm.otpResendMessage = "";
        vm.dateErrorMessage = "";
      }
      vm.AddEmailToHolderPan = function () {
        vm.Otp = '';
        var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data) {
            // vm.AllowedJointHolder = false;
            vm.emailDetails.secretLink = resp.data.secretLink;
            vm.emailDetails.message = resp.data.message;
            vm.Otp = resp.data.otp;
            vm.showOtp = true;
          }
        },
        error = function () {
          vm.processFlag = false;
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
        var payload = {
          pan: vm.holderData.pan,
          email: vm.holderData.email
        };
        LoaderService.showLoader('.popup');
        InvestorsService.post({
          controller: 'holder',
          child1: 'pan',
          child2: 'add',
          child3: 'email',
          child4: 'send',
          child5: 'otp'
        }, payload).$promise.then(success, error);
      }
    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    vm.changedRiNriTaxStatus= function() {
      vm.holderData.pan = "";
      vm.resetValues();
    }
    }

  })();


/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('PanVerificationModalController', panVerificationModalController);

  /** @ngInject */
  function panVerificationModalController($uibModalInstance, $window, modalView, $timeout, modalData, InvestorsService, LoaderService, AppConstants, moment,ModalService, panAdharLinkingService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.formData = {};
    vm.verificationForm = {};
    vm.dismissModal = dismissModal;
    vm.continue = continueModal;
    vm.verifyDetails = verifyDetails;
    vm.wrongMsg = '';
    vm.defaultDate = new Date();
    vm.changeStartDate = changeStartDate;
    vm.defaultSetDate = defaultSetDate;
    vm.isShowDefault = 'false';
    vm.viewMode = 'days';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;

    /* Page init load method */
    function defaultSetDate() {

      var date = new Date();
      if (vm.modalData && vm.modalData.type == 'guardianDetails') {
        date.setFullYear(date.getFullYear() - 18);
        vm.maxDefaultDOB = date;
        vm.defaultDate = date;
        vm.formData.dob = date;
      } else {
        vm.maxDefaultDOB = date;
        vm.formData.dob = '';
        // vm.defaultDate = date;
        $timeout(function () {
          $window.document.getElementById('dobId').value = "";
        })
      }

    }

    function verifyDetails() {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status) {
            resp.data.dob = vm.payload.dob;
            vm.wrongMsg = '';
            $uibModalInstance.close(resp);
          } else {
            if(resp.popupEnabled) {
              $uibModalInstance.close();
              ModalService.genericModal({
                text: resp.message
              });
            } else {
              vm.wrongMsg = resp.message;
            }
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongMsg = AppConstants.ToastrMessage.FAILED;
        };
      vm.payload = {
        pan: vm.formData.pan
      };
      if(vm.modalData.label.dob){
        vm.payload.dob = moment(vm.formData.dob, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString();
      }
      LoaderService.showLoader('.popup');

      var successHandler = function(resp) {
        InvestorsService.post({
          controller: 'pan',
          child1: 'details'
        }, vm.payload).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
         LoaderService.hideLoader('.popup');
      }

      panAdharLinkingService.checkPanAdharStatus(vm.formData.pan,'',brokerCode).then(successHandler).catch(errorHandler);

    }

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function continueModal() {
      $uibModalInstance.close('success');
    }

    function changeStartDate(date) {
      if (date && date._i) {
        vm.formData.dob = date._i;
        vm.defaultDate = date.toString();
        vm.wrongMsg = "";
      } else {
        vm.wrongMsg = vm.validateData.DOB_FIELD;

      }
    }
  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AddJointHolderModalController', addJointHolderModalController);

  /** @ngInject */
  function addJointHolderModalController($uibModalInstance, $state, modalView, modalData, InvestorsService, LoaderService, AppConstants, MessageService, $scope , InvestorCommonServiceVersion1,ModalService ) {
    var vm = this;
    vm.appConstants = AppConstants;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.formData = {};
    vm.formData.taxStatusResident = true;
    vm.verificationForm = {};
    vm.dismissModal = dismissModal;
    vm.continue = continueModal;
    vm.verifyPAN = verifyPAN;
    vm.verifyEmail = verifyEmail;
    vm.verifyOTP = verifyOTP;
    vm.reGenerateOtp = reGenerateOtp;
    vm.wrongMsg = '';
    vm.panVerify = false;
    vm.emailVerify = false;
    vm.otpVerify = false;
    vm.appconstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    var panDetails = {};
    vm.emailMsg = '';
    vm.holdersPANMobile= '';
    vm.isPanBannedCountryInvalid = false;
    vm.changePAN = changePAN;
    vm.isPanAdharInvalid = false;

    switchVerify();

    function verifyPAN() {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            panDetails = resp;
            if(resp.data.ekycStatus !== vm.appconstants.KYC_STATUS.NOT_VALIDATED && resp.data.ekycStatus !== vm.appconstants.KYC_STATUS.ON_HOLD) {
              vm.holdersPANMobile = panDetails.data.mobileNumber;
              panDetails.data.taxStatusResident = vm.formData.taxStatusResident;
              if (resp.data && (angular.isDefined(resp.data.emailExists))
                && (resp.data.emailExists === true)) {
                panDetails.data.email = resp.data.email;
                $uibModalInstance.close(panDetails);
              } else {
                switchVerify('emailVerify');
              }
            }
            if (resp.data.ekycStatus === vm.appconstants.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.appconstants.KYC_STATUS.ON_HOLD) {
              ModalService.nonKycModal({
                'text': resp.data.ekycStatus === vm.appconstants.KYC_STATUS.ON_HOLD ?
                  "<p>Your KYC Status is 'On hold'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'.</p>" :
                  "<p>Your KYC Status is 'Registered'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate update KYC process to change KYC status to 'Validated'.</p>",
                'showHtml': true,
                'buttonText': 'OK',
              }, function () {
              }, function () { });
            }
          } else {
            if(resp.popupEnabled) {
              vm.isPanBannedCountryInvalid = true;
              vm.bannedCountryMessage = resp.message;
            } else {
              vm.isPanBannedCountryInvalid = false;
              vm.wrongMsg = resp.message;
            }
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };

      var payload = {
        pan: vm.formData.pan,
        nriFlag: !vm.formData.taxStatusResident
      };

      LoaderService.showLoader('.popup');
      var successHandler = function(resp) {
        LoaderService.hideLoader('.popup');
        if (resp.data && resp.data['popup-enabled']) {
          vm.isPanAdharInvalid = true;
          vm.panAdharMessage = resp.data.message;
        } else {
          if(typeof resp.data === 'undefined') {
            MessageService.error(resp.message);
            vm.isPanAdharInvalid = true;
          } else {
              vm.isPanAdharInvalid = false;
              InvestorsService.post({
                controller: 'holder',
                child1: 'pan',
                child2: 'details'
              }, payload).$promise.then(success, error);
          }
        }
      }

      var errorHandler = function(resp) {
        LoaderService.hideLoader('.popup');
        MessageService.error(resp.message);
      }

      var payloadPanAdhar = {
        panNumber : vm.formData.pan,
        folioNumber : '' ,
        brokerCode : brokerCode
      }

      InvestorCommonServiceVersion1.post({
      "child1": "verifyPanAadharLink"
      },payloadPanAdhar).$promise.then(successHandler, errorHandler);

    }
    var emailDetails = {};
    function verifyEmail() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          emailDetails = resp.data;
          vm.emailMsg = resp.data.message +" ("+vm.holdersPANMobile+") " +"registered in KYC.";
          switchVerify('otpVerify');
        }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        pan: vm.formData.pan,
        email:vm.formData.email
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'holder',
        child1: 'pan',
        child2: 'add',
        child3: 'email',
        child4: 'send',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    }

    function verifyOTP() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data && resp.data.verified){
            vm.wrongMsg = '';
            panDetails.data.email = vm.formData.email;
            $uibModalInstance.close(panDetails);
          } else {
            vm.wrongMsg = resp.message;
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      var payload = {
        uniqueLink :emailDetails.secretLink,
        otp: vm.formData.otp
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'holder',
        child1: 'pan',
        child2: 'add',
        child3: 'email',
        child4: 'verify',
        child5: 'otp'
      }, payload).$promise.then(success, error);
    }
    vm.OTPResendMsg='';
    function reGenerateOtp() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data){
            vm.wrongMsg = '';
            vm.OTPResendMsg = resp.data.message+" ("+vm.holdersPANMobile+") " +"registered in KYC.";
            resetTimer();
          } else {
            vm.wrongMsg = resp.message;
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      vm.payload = {
        pan: vm.formData.pan,
        secretLink:emailDetails.secretLink,
        email:vm.formData.email
      };
      LoaderService.showLoader('.popup');//investor/holder/pan/add/email/resend/otp
      InvestorsService.post({
        controller: 'holder',
        child1: 'pan',
        child2: 'add',
        child3: 'email',
        child4: 'resend',
        child5: 'otp'
      }, vm.payload).$promise.then(success, error);
    }

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function continueModal() {
      $uibModalInstance.close('success');
    }

    function switchVerify(verify) {

      switch (verify) {
        case 'panVerify':
          vm.panVerify = true;
          vm.emailVerify = false;
          vm.otpVerify = false;
          break;
        case 'emailVerify':
          vm.panVerify = false;
          vm.emailVerify = true;
          vm.otpVerify = false;
          break;
        case 'otpVerify':
          vm.panVerify = false;
          vm.emailVerify = false;
          vm.otpVerify = true;
          break;
        default:
          vm.panVerify = true;
          vm.emailVerify = false;
          vm.otpVerify = false;
      }

    }
   function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }


    function changePAN() {
      vm.wrongMsg='';
      vm.isPanBannedCountryInvalid='';
      vm.isPanAdharInvalid = false;
      vm.panAdharMessage = '';
    }

  }
})();

/**
 * Created by ttn on 25/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AddInvestorModalController', addInvestorModalController);

  /** @ngInject */
  function addInvestorModalController($uibModalInstance, $state, modalView, modalData, InvestorsService, LoaderService, AppConstants, MessageService) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.formData = {};
    vm.verificationForm = {};
    vm.dismissModal = dismissModal;
    vm.continue = continueModal;
    vm.verifyDetails = verifyDetails;
    vm.wrongMsg = '';
    vm.defaultDate = (new Date());
    vm.changeStartDate = changeStartDate;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;


    function verifyDetails() {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          if (resp.status && resp.data) {
            if (!resp.data.name) {
              MessageService.error('Wrong PAN details');
              $state.go('main.dashboard');
              return;
            }
            resp.data.dob = vm.payload.dob;
            $uibModalInstance.close(resp);
          } else {
            vm.wrongMsg = resp.message;
            MessageService.error(resp.message);
            $state.go('main.dashboard');
          }
        },
        error = function () {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
        };
      /*vm.payload = {
       dob: "31-Dec-1978",//vm.formData.dob
       pan: "BDKPS1141N" //vm.formData.pan
       };*/
      vm.payload = {
        dob: vm.formData.dob,
        pan: vm.formData.pan
      };
      LoaderService.showLoader('.popup');
      InvestorsService.post({
        controller: 'pan',
        child1: 'details'
      }, vm.payload).$promise.then(success, error);
    }

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function continueModal() {
      $uibModalInstance.close('success');
    }

    function changeStartDate(date) {
      if (date) {
        vm.formData.dob = date._i;
      }
    }

  }
})();

(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('AddDaysController', addDaysController);
  
    /** @ngInject */
    function addDaysController($uibModalInstance,$timeout,LoaderService,$stateParams,$window,UtilService,InvestorsService,SchemeService,InvestorsCommonService,MessageService,AppConstants, modalView, modalData){
      var vm = this;
      vm.formData = {};
      vm.formData.startDate = null;
      vm.viewMode = 'days';
      vm.startDateFormat = 'DD-MMM-YYYY';
      vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
      vm.view = modalView;
      vm.modalData = modalData;   
      vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.init = init;
      vm.init();
      function init(){
        //getDateValidation(); 
        fetchSipSchemeValidations(vm.modalData.schemeCode);
      }

    var currentDate = Date();
    vm.enabledOTMStartDatesList = [];
    vm.enabledBillerStartDatesList = [];
    function getDateValidation(cb){
      cb = cb || function () {};
      vm.isTillPerpetuity = false;
      vm.resetting = true;
      vm.endDateSelectionOption = false;
      var success = function (resp) {
          vm.enabledOTMStartDatesList = [];
          if (resp.status && resp.data) {
            vm.weeklyDaysList=resp.data.listOfDays;
            var currentDate = resp.data.currentDate;
            var todayDate = $window.moment(currentDate);
            if ( vm.modalData.paymentMode && vm.modalData.paymentMode.key === 'HEM') {
              vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.eMandateNoOfDays, 'days');
            } else if(vm.modalData.paymentMode && vm.modalData.paymentMode.key === 'EC'){
              vm.startMinDateBiller = $window.moment(Date.parse(currentDate)).add(vm.sipValidationsData.sipTDay, 'days');
            }else {
              vm.startMinDateBiller = $window.moment(currentDate, "DD-MMM-YYYY").add(13, 'days');//T+10+2+1
            }
            var startMaxDate = $window.moment(currentDate, "DD-MMM-YYYY").add(90, 'days');
            var startDate = todayDate.clone();
            var freq = $window.moment(startMaxDate).diff(todayDate, 'days');
            var counter=0;
            for (var i = 0; i <= freq; i++) {
              var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              var isEnable = true;
              if(counter<7)
              {
                angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                  if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                    isEnable = false;
                  }
                });
              }
              if(isEnable){
                vm.enabledOTMStartDatesList.push(indexDate);
                counter++;
              }
            }
            vm.startMinDateOTM = vm.enabledOTMStartDatesList[7];//T+5+2
            if( vm.modalData.paymentMode && vm.modalData.paymentMode.key === 'HEM') {
              vm.startMinDateBiller = vm.enabledOTMStartDatesList[vm.eMandateNoOfDays];
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }
            else if (vm.modalData.paymentMode && vm.modalData.paymentMode.key === 'EC') {
              vm.enabledBillerStartDatesList = vm.enabledOTMStartDatesList;
            }
            vm.startMaxDate = $window.moment(startMaxDate, "DD-MMM-YYYY").add(1, 'minutes').clone();
            vm.resetting = false;
            cb(true);
          } else {
            MessageService.error(resp.message);
            vm.resetting = false;
            cb(false);
          }
        },
        error = function (err) {
          vm.resetting = false;
          UtilService.errorHandler(err);
          cb(false);
        };
      InvestorsCommonService.get({
        child1: 'nonBusinessDate',
        schemeCode: 'AFWDQ'  //vm.formData.inSchemeCode //
      }).$promise.then(success, error);
    }
  
    function fetchSipSchemeValidations(schemeCode) {
      vm.sipValidationsData = null;
      //vm.sipPayload.frequency = vm.selectedFrequency.code;
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.sipValidationsData = resp.data;
            vm.SIP_FREQ_LIST = vm.sipValidationsData.additionalValidation.frequency?vm.sipValidationsData.additionalValidation.frequency:null;
            if(vm.SIP_FREQ_LIST.length == 0){
              vm.PAYMENT_MODE=[];
              vm.formData.paymentMode=null;
            }
            var frequency = vm.SIP_FREQ_LIST.find(function (d) {
              return d.code === 'OM';
            }) || {};
            vm.selectedFrequency = frequency?frequency:'';
            if($stateParams.frequency){
              var freq = vm.SIP_FREQ_LIST.find(function (d) {
                if($stateParams.frequency === "Business Days(BZ)"){
                  return d.code === 'BZ';
                } else {
                  return d.name === $stateParams.frequency;
                }
              }) || {};
              vm.selectedFrequency = freq?freq:'';
            }
            // vm.changeFrequency();
            vm.formData.cgfFlag = vm.sipValidationsData.cgfFlag;
            vm.formData.investmentOption = vm.sipValidationsData.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.formData.investmentOption !== AppConstants.TRANSACTION.GROWTH && vm.formData.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
            // vm.formData.dividendOption = vm.sipValidationsData.isGrowth ? vm.DIVIDEND_OPTIONS.GROWTH : (vm.formData.dividendOption !== vm.DIVIDEND_OPTIONS.GROWTH && vm.formData.dividendOption) || (vm.sipValidationsData.endingType === vm.ENDING_TYPES.CLOSED ? vm.DIVIDEND_OPTIONS.PAYOUT : vm.DIVIDEND_OPTIONS.REINVEST);
            if (vm.sipValidationsData.isGrowth) {
              vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
            } else {

              if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === false) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
              } else if (vm.sipValidationsData.dividendPayoutApplicable === false && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              } else if (vm.sipValidationsData.dividendPayoutApplicable === true && vm.sipValidationsData.dividendReinvestmentApplicable === true) {
                vm.formData.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
              }

            }
            // extractSipValidationObject(resp.data, vm.selectedFrequency);
            // vm.setOtmData();
            getDateValidation(); 
          } else {
            MessageService.error(resp.message);
            vm.sipValidationsData = null;
            vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
            vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
          }
          /*if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
            vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
          }*/
        },
        error = function (err) {
          vm.sipValidationsData = null;
          if (vm.selectedSchemeType == 'ELSS' && !vm.sipValidationsData.isGrowth) {
            vm.formData.dividendOption = AppConstants.TRANSACTION.PAYOUT;
          }
          else {
            vm.formData.dividendOption = vm.formData.dividendOption || vm.DIVIDEND_OPTIONS.GROWTH;
          }
          vm.formData.investmentOption = vm.formData.investmentOption || AppConstants.TRANSACTION.GROWTH;
          UtilService.errorHandler(err);
        };
      SchemeService.get({
        controller: 'schemeValidation',
        type: 'sip',
        child1: 'AFWG'  // schemeCode 
      }, null).$promise.then(success, error);
    }

      vm.submit =function() { 
        $uibModalInstance.close(vm.tempdata);
      }
      vm.dismissModal = function () {
        $uibModalInstance.dismiss("cancel");
      };
      vm.closeModal = function () {
        $uibModalInstance.close();
      }; 
      vm.changeStartDate = function (date) {
        LoaderService.showLoader();
        vm.formData.startDate = date ? date : null;
        vm.sipDay = vm.formData.startDate ? vm.formData.startDate.format('D') : '';
        vm.formData.endDate = null;
        vm.isTillPerpetuity = false;
        vm.endDateSelectionOption = false;
        vm.resetting = true;
        $timeout(function (){
          vm.resetting=false;
          LoaderService.hideLoader();
        }) 
         updateEndDates();
      };

      function updateEndDates(installment) {
        if (vm.isTillPerpetuity || !vm.formData.startDate) {
          return;
        }
        var defaultEndDate = moment((new Date()), "DD-MM-YYYY").add(99, 'years');
        var defaultMonths = null;
        var endDate = null;
        var enabledEndDates = [];
        var freq = vm.sipValidations && vm.sipValidations.maxInstallments || 0;
        var i = 0, minInstallments = 1;// installmentTotal = 1;
        switch (vm.selectedFrequency.code) {
          case'BZ':
            var days = 0;
            endDate = vm.formData.startDate && vm.formData.startDate.clone().add(vm.selectedFrequency.duration, 'days');
            defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
            freq = freq || ((defaultMonths * 30) / vm.selectedFrequency.duration);
            for (i = 0; i < freq; i++) {
              days = vm.selectedFrequency.duration * i;
              enabledEndDates.push(endDate.clone().add(days, 'days'));
            }
            break;
          case'OW':
            var days = 0;
            defaultEndDate = new Date("12/31/2099");
              freq = UtilService.getNumberOfWeeks(vm.formData.startDate.toDate(), defaultEndDate);
            for (i = 0; i <= freq; i++) {
              days = vm.selectedFrequency.duration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(days, 'days'));
            }
            break;
          default :
            var months = 0;
             minInstallments = (vm.sipValidations && vm.sipValidations.minInstallments) ? vm.sipValidations.minInstallments : 1;
            var installmentTotal = vm.selectedFrequency.code == 'Q' ? ((minInstallments * 3) - 1) : ((minInstallments * 1) - 1);
             defaultMonths = UtilService.getNumberOfMonths(vm.formData.startDate, moment(defaultEndDate));
            freq = freq || (defaultMonths / vm.selectedFrequency.duration);
            for (i = 0; i < freq; i++) {
              months = vm.selectedFrequency.duration * i;
              enabledEndDates.push(vm.formData.startDate.clone().add(months, 'months'));
            }
            break;
        } 
        if (!installment) {
          if(vm.selectedFrequency.code == "OM" && vm.sipValidations && !vm.sipValidations.minInstallments) {
            vm.sipValidations.minInstallments = 6;
          }
          minInstallments = vm.sipValidations && vm.sipValidations.minInstallments && (vm.sipValidations.minInstallments - 1) || 0;
          vm.enabledEndDates = enabledEndDates.slice(minInstallments);
  
        } else {
          vm.enabledEndDates = enabledEndDates;
        }
        vm.minEndDate = vm.formData.endDate ? vm.formData.endDate : angular.copy(vm.enabledEndDates[0]); 
      }
    }
    
  })();
  
  
/*
* Created on 09/Dec/2019
* */
(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .controller('IFSCSelectionNewJourney', IFSCSelectionNewJourney);
  
    /** @ngInject */
    function IFSCSelectionNewJourney(InvestorsCommonService, $uibModalInstance, modalView, modalData, AppConstants, $timeout) {
      var vm = this;
      vm.view = modalView;
      vm.modalData = modalData;
      vm.IFSC_REGEX = AppConstants.ifsc_regex;
      vm.APP_CONSTANT = AppConstants.ToastrMessage.VALIDATE_DATA;
      vm.bankChange = bankChange;
      vm.clearForm = clearForm;
      vm.searchIFSC = searchIFSC;
      vm.IFSCsearchResult = [];
      vm.submitIFSC = submitIFSC;
      vm.bankList = vm.modalData.bankList;
      vm.disabledCity = true;
      vm.cityList;
      vm.clearBankField = clearBankField;
      vm.clearIFSCField = clearIFSCField;
      vm.searchIFSCCLicked = false;
      vm.ifsccode = "";
      vm.showFieldifsc = true;
      vm.showFieldbank = true;
      vm.modeofifscsearch = "IFSC";
  
  
      function clearBankField() {
        vm.showFieldbank = false;
        if (vm.bankName) vm.bankName = null;
        if (vm.cityName) vm.cityName = null;
        if (vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
        if (vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
        $timeout(function () {
          vm.showFieldbank = true;
        })
      }
  
      function submitIFSC(val) {
        vm.ifscData = val;
        $uibModalInstance.close(vm.ifscData);
      }
  
      function clearForm() {
        clearBankField();
        clearIFSCField();
        vm.IFSCsearchResult = '';
      }
      function clearIFSCField() {
        vm.showFieldifsc = false;
        vm.ifsccode = "";
        $timeout(function () {
          vm.showFieldifsc = true;
          if (vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
          if (vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
        });
      }
      // Find City List
      function bankChange() {
        clearIFSCField();
        var bankName = vm.bankName;
        if (bankName) {
          var citySuccess = function (resp) {
            if (resp.data && resp.data.cities && resp.data.cities.length) {
              vm.disabledCity = false;
            }
            vm.cityList = resp.data.cities;
          };
          var error = function () {
            console.log('error')
          };
          InvestorsCommonService.post({
            child1: 'rbi',
            child2: 'bankCities'
          }, { bankName: vm.bankName }).$promise.then(citySuccess, error)
        } else {
          vm.disabledCity = true;
          vm.cityName = null;
        };
      }
  
      vm.getIfscSerchMode = function (val) {
        if (val === 'IFSC') {
          vm.modeofifscsearch = "IFSC";
        } else {
          vm.modeofifscsearch = "BANKNAME";
        }
  
      }
  
      function searchIFSC() {
        var payload = {
          bankName: vm.bankName,
          bankCity: vm.cityName,
          ifscCode: vm.ifsccode
        };
  
        var onSuccess = function (data) {
          vm.IFSCsearchResult = data.data.bankList;
          vm.searchIFSCCLicked = true;
        };
        onerror = function () {
        };
        InvestorsCommonService.post({
          child1: 'rbi',
          child2: 'bankList'
        }, payload).$promise.then(onSuccess, onerror);
      }
  
  
      vm.dismissModal = function () {
        $uibModalInstance.dismiss(null);
      };
      //  Find Bank List
      vm.fetchBankList = function () {
        var success = function (res) {
          if (res.status && res.data) {
            vm.bankList = res.data.bankList;
          }
          else {
            vm.bankList = null;
            MessageService.error(res.message);
          }
        };
        var error = function (err) {
          vm.bankList = null;
          UtilService.errorHandler(err);
          MessageService.error(err);
        };
  
        InvestorsCommonService.get({ child1: 'rbi', child2: 'bankNames' }).$promise.then(success, error);
      }
      vm.fetchBankList();
  
  
    }
  })();
  
/*
* Created on 12/Dec/2019
* */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('IFSCSelection', IFSCSelection);

  /** @ngInject */
  function IFSCSelection(InvestorsService, $uibModalInstance, modalView, modalData, AppConstants, InvestorsCommonService, $timeout) {
    var vm = this;
    vm.view = modalView;
    vm.modalData = modalData;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.APP_CONSTANT = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.bankChange = bankChange;
    vm.clearForm = clearForm;
    vm.clearBankField = clearBankField;
    vm.searchIFSC = searchIFSC;
    vm.IFSCsearchResult='';
    vm.submitIFSC= submitIFSC;
    vm.bankList = vm.modalData.bankList;
    vm.disabledCity =  true;
    vm.cityList;
    vm.searchIFSCCLicked = false;
    vm.showFieldbank = true;
    vm.showFieldifsc = true;

    function clearBankField(){
      vm.showFieldbank = false;
      vm.bankName =null;
      vm.cityName=null;
      vm.disabledCity = true;
      if(vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
      if(vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      $timeout(function () {
        vm.showFieldbank = true;
      })
    }

    function submitIFSC() {
      $uibModalInstance.close(vm.selectdIFSC);
    }
    function clearForm() {
      clearBankField();
      clearIFSCField();
      vm.IFSCsearchResult='';
      vm.disabledCity = true;
    }
    function clearIFSCField() {
      vm.showFieldifsc = false;
      vm.ifsccode = "";
      $timeout(function () {
        vm.showFieldifsc = true;
        if(vm.IFSCsearchResult.length) vm.IFSCsearchResult = '';
        if(vm.searchIFSCCLicked) vm.searchIFSCCLicked = false;
      });
    }
    function bankChange(){
      clearIFSCField();
      var bankName = vm.bankName;
      if(bankName) {
        var citySuccess = function (resp) {
          if(resp.data && resp.data.cities && resp.data.cities.length) {
            vm.disabledCity = false;
          }
          vm.cityList = resp.data.cities;
        };
        var error = function () {
          console.log('error')
        };
        InvestorsCommonService.post({
          child1: 'rbi',
          child2: 'bankCities'
        }, {bankName: vm.bankName}).$promise.then(citySuccess, error)
      }else {
        vm.disabledCity = true;
        vm.cityName = '';
      };
    }

    function searchIFSC(){
      const payload = {
        bankName : vm.bankName,
        bankCity : vm.cityName,
        ifscCode : vm.ifsccode
      };

      const onSuccess = function(data){
        vm.IFSCsearchResult = data.data.bankList;
        vm.searchIFSCCLicked = true;
      };
      const onerror = function(error){
        console.log(error)
      };
      InvestorsCommonService.post({
        child1: 'rbi',
        child2: 'bankList'
      }, payload).$promise.then(onSuccess, onerror);
    };

    vm.error = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcDashboardHeaders', hdfcHeaders);
  /** @ngInject */
  function hdfcHeaders() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/headers/dashboard-header.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });

    /** @ngInject */
    function headerController(HDFC_API, $rootScope, $timeout, $state, $window, UtilService, InvestorModel, InvestorsService, AuthService, $scope, ModalService, LoaderService, NotificationService, AppConstants, FileUploadService, MessageService, $document, $http, TransactionInitiateModel, InvestorsServiceVersion , InvestorServiceDynamicData , $cookies, EcartService) {
      var vm = this;
      var listeners = {};
      var currentPopup = '';

      vm.popup = "navigation";
      vm.myFile = {};
      vm.searchResult = null;
      vm.selectedInvestor = null;
      vm.searchString = '';
      vm.isSearching = false;
      vm.AppConstants = AppConstants;
      vm.notificationCount = 0;
      vm.latestNotificationList = null;
      vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
      vm.isEnablePopups = false;
      vm.changedFont = changedFont;
      vm.normalFontActive = true;
      vm.showSearch = false;
      vm.contrast= contrast;
      vm.toggleSidebar = toggleSidebar;
      vm.showSearchMobile = showSearchMobile;

      vm.distributorName = "";
      vm.profilePhotoUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
      vm.cartCount = 0;
      vm.openEcartSideBar = openEcartSideBar;
      vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      vm.toggleMode = toggleMode;
      vm.init = init;
      init();

      var resetTransactionInitiateModel = function () {
        TransactionInitiateModel.setPurchasePayload(null);
        TransactionInitiateModel.setSipPayload(null);
        TransactionInitiateModel.setInvestorPayload(null);
      };

      vm.searchInvestorEnterOnly = function (isClicked) {
        $document.bind('keydown', function (e) {
          var key = e.keyCode ? e.keyCode : e.which;
          if (key == 13 && vm.searchString.length > 0) {
            $state.go('main.globalSearch', {searchString: vm.searchString});
            $timeout(function () {
              vm.searchResult = null;
              vm.searchString = '';
              angular.element("#searchresult").hide();
            }, 200);
          }
        });
        if (isClicked === 'onButtonClick') {
          $state.go('main.globalSearch', {searchString: vm.searchString});
        }
      };

      vm.openNotification = function (notification) {
        if (notification.clickable) {
          $state.go('main.leapacademy.pdf-articles');
        }
      };

      vm.searchInvestor = function (isClicked) {
        vm.closeFilter();
        $document.bind('keydown', function (e) {
          var key = e.keyCode ? e.keyCode : e.which;
          if (key == 13 && vm.searchString.length > 0) {
            $state.go('main.globalSearch', {searchString: vm.searchString});
            $timeout(function () {
              /*vm.searchResult = null;
              vm.searchString = '';*/
              angular.element("#searchresult").hide();
            }, 200);
          }
        });
        if (isClicked === 'onButtonClick') {
          $state.go('main.globalSearch', {searchString: vm.searchString});
        }

        var success = function (resp) {
            // resp = resp.data;
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.searchResult = resp.data && resp.data.searchResponse;
              for(var i=0;i<vm.searchResult.length; i++){
                var searchResultItem = vm.searchResult[i].result;
                var findIndex = searchResultItem.indexOf('-');
                vm.searchResult[i].investorName =searchResultItem.substring(0,findIndex);
                vm.searchResult[i].investorEmail = searchResultItem.substring(findIndex+1);
              }
            } else {
              vm.searchResult = null;
              !resp.status && MessageService.error(resp.message)
            }
          },
          error = function () {
            vm.searchResult = null;
            LoaderService.hideLoader();
            MessageService.error();
          };


        if (vm.isSearching || !vm.searchString || vm.searchString.length < 3 || /[^A-Za-z\\d\\s@+-]/.test(vm.searchString)) {
          if(vm.searchString.length < 3){
            vm.searchResult = null;
          }
          return;
        }

        vm.searchResult = null;
        vm.selectedInvestor = null;
        vm.isSearching = true;

        $timeout(function () {
          vm.isSearching = false;
        }, 200);

        LoaderService.showLoader('.popup');
        /*
         var _path = HDFC_API.COMMON_SERVICE_URL + tokenData.arnCode + '/investor/search/' + vm.searchString;
         $http.get(_path).then(success, error);*/

        InvestorsService.post({
          //arnCode: tokenData.arnCode,//vm.modalData.arnCode,
          controller: 'search',
          child1: vm.searchString
        }, null).$promise.then(success, error);

      };

      vm.goToProfile = function (investor,index) {
        vm.selectedInvestor = investor;
        // vm.searchString = investor.result;

        LoaderService.showLoader();
        var taxIdentifier = vm.searchResult[index].panNumber;
        var success  = function(resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            if (resp.data.showPopup) {
              ModalService.optOutNomineeModalSearch({
                message: resp.data.popUpMessage,
                folioList : resp.data.folioList
              },function () {
                $timeout(function () {
                  vm.searchResult = null;
                  vm.searchString = '';
                  angular.element("#searchresult").hide();
                  $state.go('main.investors.profile.basicinfo', {investorId: vm.selectedInvestor.uuid});
                }, 200);
              } , function () {
                $timeout(function () {
                  vm.searchResult = null;
                  vm.searchString = '';
                  angular.element("#searchresult").hide();
                }, 200);
              });
            } else {
              $timeout(function () {
                vm.searchResult = null;
                vm.searchString = '';
                angular.element("#searchresult").hide();
                $state.go('main.investors.profile.basicinfo', {investorId: vm.selectedInvestor.uuid});
              }, 200);
            }
          }
        } , error = function(err) {
          LoaderService.hideLoader();
          MessageService.error(err.message);
        }

        InvestorServiceDynamicData.post({
          child1: 'profile',
          child2: 'check',
          child3: 'nominee',
          child4: 'details'
        }, {
          pan : taxIdentifier
        }).$promise.then(success, error);

      };

      var logoUpload = function () {
        ModalService.logoUploadModal();
      };

      var changePassword = function () {
        var success = function (result) {
          if (result.status) {
            MessageService.success(vm.AppConstants.ToastrMessage.RESET_PASSWORD.SUCCESS);
            vm.logoutMe();
          } else {
            MessageService.error(result.message);
            // vm.logoutMe();
          }
        }, error = function () {
          vm.logoutMe();
        };
        ModalService.changePasswordModal({backdrop: 'static', firstLogin: true}, success, error);
      };

      /*function showNotificationMsg() {
        // var msg = "A maintenance activity is ongoing at CAMS right now and will be completed at 2pm. You may experience issues within the application. If you do so try again after 30 minutes. Please do bear with us till the activity is completed. Thank you for your understanding.",
        var msg = "There is a back end activity at CAMS due to which there maybe data updation issues so please kindly bear with us.",
          success = function () {
          },
          error = function () {
          };
        ModalService.forgotPasswordDoneModal({message: msg}, success, error);
      }*/

      var search = function (transactionType) {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          $state.go('main.dashboard');
          return;
        }
        if (identifierData.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
          $state.go('main.newinvestor.kycverify');
          return;
        }
        var success = function (investor) {
            if (investor && investor.uuid) {
              switch (transactionType) {
                case 'SIP':
                  transactionType = 'SIP';
                  break;
                case 'Purchase':
                  transactionType = 'PURCHASE';
                  break;
                case 'Systematic Withdrawal Plan':
                  transactionType = 'SWP';
                  break;
                case 'Systematic Transfer Plan':
                  transactionType = 'STP';
                  break;
                case 'Redemption':
                  transactionType = 'Redeem';
                  break;
                case 'Switch':
                  transactionType = 'Switch';
                  break;
                case 'DTP':
                  transactionType = 'DTP';
                  break;
                case 'SWINGSTP':
                  transactionType = 'SWINGSTP';
                  break;
                case 'ChangeDividend':
                  transactionType = 'ChangeDividend';
                  break;
                case 'ROLLOVER':
                  transactionType = 'rollover';
                  break;
                case 'SMARTSWAP':
                  transactionType = 'SMARTSWAP';
                  break;
                case 'Instant Access Facility':
                  transactionType = 'instantRedeem';
                  break;
                case 'DREAMSIP':
                  transactionType = 'DREAMSIP';
                  break;
                case 'BULK_TRANSACTIONS':
                  transactionType = 'BULK_TRANSACTIONS';
                  break;
                case 'BULK_SIP':
                  transactionType = 'BULK_SIP';
                  break;
                case 'DREAMSIP':
                  transactionType = 'DREAMSIP';
                  break;
              }
              var state = transactionType.toLowerCase() === "sip" || transactionType.toLowerCase() === "purchase" ? "sip": transactionType.toLowerCase();
              var _state = 'main.transactions.initiate.' + state;
              $state.go(_state, {
                uuid: investor.uuid,
                schemeCode: '',
                folioNumber: '',
                transactionType: transactionType,
                transactionId: '',
                fromModify: ''
              });
            } else {
              MessageService.error('Unable to get uuid of selected investor');
            }
          },
          error = function () {
            $state.go('main.dashboard');
          };
        resetTransactionInitiateModel();
        if (transactionType == 'BULK_TRANSACTIONS') {
          $state.go('main.bulk.initiate');
        } else if (transactionType == 'BULK_SIP') {
          $state.go('main.siprenew.transaction');
        } else {
          ModalService.searchInvestorModal({
            transactionType: transactionType,
            arnCode: identifierData.arnCode
          }, success, error);
        }
      };
      if(localStorage.getItem('loginMethod')){
        var loginMethod = localStorage.getItem('loginMethod');
      }
      function isInitialLogin() {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          return;
        }
        var success = function (resp) {
          if (resp && resp.status && resp.data) {
            vm.count = UtilService.getCount();
            if (resp.data.firstTimeLogin && resp.data.firstPasswordChange) {
              vm.isEnablePopups = true;
              logoUpload();
            } else if (!resp.data.firstPasswordChange && loginMethod!='OTP') {
              vm.isEnablePopups = false;
              changePassword();
            } else {
              vm.isEnablePopups = true;
            }
            vm.lastLoginTime = $window.moment(resp.data.lastLoginTime).format("DD MMM YYYY, hh:mm:ss A");

            // showNotificationMsg();

            if (!resp.data.uploadedLogoLocation) {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: AppConstants.DEFAULT_LOGO});

            } else {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoLocation});
            }

            if (!resp.data.profilePhotoUrl) {
              vm.profilePhotoUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
            } else {
              vm.profilePhotoUrl = resp.data.profilePhotoUrl;
            }
            $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: vm.profilePhotoUrl});
            vm.upperCrustAward = resp.data.upperCrustAward;
            sessionStorage.setItem('distributorName', resp.data.distributorName + ' (' + resp.data.arnCode + ')');
            $rootScope.$broadcast('distributorName', {distributorName: resp.data.distributorName + ' (' + resp.data.arnCode + ')'});
            $rootScope.$broadcast('UpdateProfileDetails', {
              distributorName: resp.data.distributorName,
              lastLoginTime: vm.lastLoginTime,
              firstTimeLogin: resp.data.firstTimeLogin
            });
          } else {
            vm.isEnablePopups = true;
            $rootScope.$broadcast('UpdateProfileDetails', {
              distributorName: 'User',
              lastLoginTime: '',
              firstTimeLogin: false
            });
            $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: AppConstants.DEFAULT_LOGO});
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
          vm.isEnablePopups = true;
        };
        AuthService.isInitialLogin(identifierData.arnCode).then(success, error);
      }

      /** color contrast */

      function contrast () {
        if(!vm.isDarkModeEnable){
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        }
        $rootScope.$broadcast('isChangeBackgroundOfDonut', !vm.isDarkModeEnable);
      }

      function changedFont(valType){
        UtilService.changedFont(valType);
        vm.count = UtilService.getCount();
        $rootScope.$broadcast('changeFontPostLoginFromDesktopHeader');
      }

      function getTotalNotificationCount() {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status) {
              vm.notificationCount = resp.data;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        NotificationService.post({
          controller: 'totalNotificationCount'
        }, {}).$promise.then(success, error);
      }

      function init() {
        var identifier = AuthService.getToken();
        if(identifier && identifier.access_token) {
          isInitialLogin();

          getTotalNotificationCount();

          getCartCount();
        }
      }

      vm.latestNotification = function (throughMenuClick,type) {
        vm.closeFilter();
        if (throughMenuClick) {
          $timeout(function () {
            var className = type?'mobile-header-notification-icon':'header-notification-icon';
            var ele = angular.element($window.document.getElementById(className)).parent('.dropdown');
            var hasClass = ele.hasClass('open');
            if (ele && hasClass) {
              getLatestNotification();
            }
          },10)
        } else {
          getLatestNotification();
        }
      };

      function getLatestNotification(){
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.latestNotificationList = resp.data.notificationList;

              if (vm.notificationCount !== 0) {
                var successR = function () {
                    vm.notificationCount = 0;
                  },
                  errorR = function () {
                  };
                NotificationService.post({
                  controller: 'read'
                }, {}).$promise.then(successR, errorR);
              }
            }
            else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        NotificationService.post({
          controller: 'latestNotification'
        }, {}).$promise.then(success, error);

      }

      vm.openLeadmanagement = function () {
        var newWin = $window.open("about:blank", 'newtab');
        newWin.document.write("<h2>Please wait while we fetch details....</h2>");
        newWin.location = 'http://www.salespanda.com/bizight-client/hdfc/delinked-page/delinked-page.html';
        /*var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;
        var newWin = $window.open("about:blank", 'newtab');
        newWin.document.write("<h2>Please wait while we fetch details....</h2>");

        $http.get(_link, {}, {
          headers: {}
        }).then(function (resp) {
            if (resp) {
              if (resp.status && resp.data) {
                // window.open(resp.data, '_blank');
                newWin.location = resp.data;
              } else {
                newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
                MessageService.error(resp.message);
              }
            }
          }, function (err) {
            newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
            UtilService.errorHandler(err);
          });*/
      };

      vm.logoutMe = function () {
        sessionStorage.removeItem('brokerCodePanAdhar');
        AuthService.logout().then(function () {
          $state.go('login');
        }, function () {
          $state.go('login');
        });
      };

      /*
       vm.widgetSelection = function () {
       ModalService.widgetStoreModal();
       };
       */

      vm.updatePopup = function (popup) {
        vm.popup = popup;
      };

      vm.updateSideBar = function (transactionType) {
        if (transactionType) {
          $timeout(function () {
            search(transactionType);
          }, 50);
        }
        $rootScope.$emit('UpdateSideBar');
      };

      vm.updateSideBarInvestor = function () {
        vm.closeFilter();
        $rootScope.$emit('UpdateSideBar');


        var successPanDetails = function (resp) {
          if (resp.data && resp.status && resp.data.kycverified) {
            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            // resp.data.minor = true;
            model.folioCreationRequestCO.soleApplicantDetail.name = resp.data.name;
            model.folioCreationRequestCO.soleApplicantDetail.dob = resp.data.dob;
            model.folioCreationRequestCO.soleApplicantDetail.panNumber = resp.data.pan;
            model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
            model.folioCreationRequestCO.soleApplicantDetail.email = resp.data.email?resp.data.email.trim():"";
            model.folioCreationRequestCO.soleApplicantDetail.mobileNo = resp.data.mobileNumber?resp.data.mobileNumber.trim():"";
            model.folioCreationRequestCO.soleApplicantDetail.ekycStatus = resp.data.ekycStatus?resp.data.ekycStatus:null;
            //resp.data.ekycStatus = "NOT_VERIFIED";
            InvestorModel.setInvestorModel(model);
            delete $window.sessionStorage.investorForm;
            $window.sessionStorage.investorForm = angular.toJson(model);
            // InvestorModel.setTab({
            //   "tab1": false,
            //   "tab2": false,
            //   "tab3": false,
            //   "tab4": false,
            //   "tabJointHolderAddable": false,
            //   "tabGuardianDetailShow": false
            // });
            // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
            if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.IN_PROGRESS) {
              $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
            } else if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.NOT_VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.INCOMPLETE) {
              ModalService.kycInitiateModal({
                investorDetails: InvestorModel.getInvestorModel()
              }, initiateNextSteps, function(){});
            } else if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.SUSPENDED) {
              ModalService.nonKycModal({
                'text': resp.data.message,
                'buttonText': 'OK'
              }, function() {}, function() {});
            } else {
              ModalService.nonKycModal({
                'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
                'buttonText': 'OK'
              }, function() {}, function(){});
            }
          } else {
            MessageService.error(resp.message || 'Either KYC verification is pending or name is missing.');
          }
        };
        var labelSetter = {type: 'addInvestor', label: {header: 'Add Investor', pan: 'PAN', dob: 'Investor DOB'}};
        // ModalService.checkPanModal(labelSetter, successPanDetails);
        $state.go('main.newinvestor.kycverify');
      };

      vm.skipPopup = function () {
        vm.popup = "";
      };

      vm.uploadFile = function (file) {
        if (file) {
          if (vm.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }

          //var tokenData = angular.fromJson($cookies.get('token_data'));
          var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/uploadLogo';
          LoaderService.showLoader();
          FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoUrl});
            } else {
              MessageService.error(resp.message)
            }
          }, function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err)
          });
        }
      };


      vm.emptySearch = function () {
        $timeout(function () {
          vm.searchResult = null;
          vm.searchString = '';
          angular.element("#searchresult").hide();
          angular.element("#searchbox-header").focus();
        }, 200);
      };

      angular.element("#searchbox").blur(function () {
        $timeout(function () {
          vm.searchResult = null;
          vm.searchString = '';
          angular.element("#searchresult").hide();
        }, 200);
      });

      $document.bind('keydown', function (e) {
        var key = e.keyCode ? e.keyCode : e.which;
        if (!vm.isEnablePopups) {
          return;
        }
        switch (key) {
          case 37:
            currentPopup = vm.popup;
            if (currentPopup == 'add-investor') {
              vm.popup = 'initiate-transaction';
            }
            else if (currentPopup == 'initiate-transaction') {
              vm.popup = 'navigation';
            }
            break;
          case 39:
            currentPopup = vm.popup;
            if (currentPopup == 'navigation') {
              vm.popup = 'initiate-transaction';
            }
            else if (currentPopup == 'initiate-transaction') {
              vm.popup = 'add-investor';
            }
            break;
          case 27:
            vm.popup = '';
            break;
          case 13:
            vm.popup = '';
            break;
        }
        $scope.$digest();
        e.stopPropagation();
      });
      listeners['checkCurrentState'] = $scope.$on('checkCurrentState', function () {
        vm.sidebarActive = $state.current.name.split('.')[1];
      });
      listeners['$locationChangeSuccess'] = $scope.$on('$locationChangeSuccess', function () {
        closeSidebar();
      });
      listeners['UpdateLogoImage'] = $scope.$on('UpdateLogoImage', function (event, args) {
        vm.logoImgUrl = "";
        $timeout(function () {
          vm.logoImgUrl = args.logoImgUrl || AppConstants.DEFAULT_LOGO;
        });
      });
      listeners['UpdateProfileImage'] = $scope.$on('UpdateProfileImage', function (event, args) {
        vm.profilePhotoUrl = "";
        $timeout(function () {
          vm.profilePhotoUrl = args.profilePhotoUrl || AppConstants.DEFAULT_LOGO;
        });
      });
      listeners['UpdateProfileDetails'] = $scope.$on('UpdateProfileDetails', function (event, args) {
        vm.distributorName = args.distributorName;
        vm.firstTimeLogin = args.firstTimeLogin;
        if (args.lastLoginTime) {
          vm.lastLoginTime = args.lastLoginTime;
        }
      });

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in listeners) {
          if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
            listeners[key]();
          }
        }
      });

      /**
       * Function responsible to submit the investor ekyc modal form value
       */
      function initiateNextSteps(resp) {
        var investorData = InvestorModel.getInvestorModel();
        vm.investorDetails = resp;
        var payload = {
          investorName : resp.name,
          pan : investorData.folioCreationRequestCO.soleApplicantDetail.panNumber,
          email : resp.email,
          mobileNo : resp.mobile,
          dob : investorData.folioCreationRequestCO.soleApplicantDetail.dob,
          ekycStatus : investorData.folioCreationRequestCO.soleApplicantDetail.ekycStatus
        };
        InvestorsServiceVersion.post({
          child1 : 'save',
          child2 : 'investor',
          child3 : 'eKyc',
          child4 : 'details',
        }, payload).$promise.then(ekycValueSubmissionSuccess, ekycValueSubmissionError);
      }

      /**
       * function responsible to handle the success response of submitting investor form value
       * @param resp
       */
      function ekycValueSubmissionSuccess(resp) {
        var investorData = InvestorModel.getInvestorModel();
        if (resp.status) {
          ModalService.eKycModal({
            investorName: vm.investorDetails.name
          }, function() {}, function(){});
        }
      }

      /**
       * function responsible to handle the failure response of submitting investor form value
       * @param resp
       */
      function ekycValueSubmissionError(resp) {
        MessageService.error(resp.message);
      }

      vm.closeFilter = function() {
        angular.element(document.querySelector("#filterSideNav")).removeClass('halfWidth');
        angular.element(document.querySelector("#filterSideNav")).addClass('noWidth');
        angular.element(document.querySelector(".blur-area")).css('display', 'none');
        destroyInvestorFilter();
      }
      function destroyInvestorFilter() {
        var elem = document.getElementsByTagName("footer")[0];
        elem.classList.remove("menu-expanded");
      }

      function toggleSidebar() {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        vm.count = UtilService.getCount();
        angular.element(document.getElementById('login-sidebar')).toggle();
        angular.element(document.getElementsByClassName('login-affix side-nav')).toggleClass('add-width');
        $(window).resize(function() {
          document.getElementById('login-sidebar').style.removeProperty('display');
          angular.element(document.getElementsByClassName('login-affix side-nav')).removeClass('add-width');
        });
        $rootScope.$broadcast('toggleModeUpdateFromDashboard');
      }

      function closeSidebar() {
        document.getElementById('login-sidebar').style.removeProperty('display');
        angular.element(document.getElementsByClassName('login-affix side-nav')).removeClass('add-width');
      }

      function showSearchMobile() {
        vm.showSearch = !vm.showSearch;
      }

      function getCartCount() {
        var success = function (resp) {
            if (resp.status) {
              vm.cartCount = resp.data.total;
              // vm.cartCount = 2;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            UtilService.errorHandler(err);
          };
        EcartService.get({
          child1: 'cart',
          child2: 'item',
          child3: 'count'
        }).$promise.then(success, error);
      }

      function openEcartSideBar() {
        if(vm.cartCount > 0){
          $rootScope.$broadcast('openEcart','openEcartDetails');
        } else {
          $rootScope.$broadcast('openEcart', 'openAllFundsScreen');
        }
      }

      listeners['UpdateCart'] = $scope.$on('UpdateCart', function (event, args) {
        if (args.listUpdated) {
          getCartCount();
        }
      });

      function toggleMode(){
        UtilService.toggleMode();
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      }

      $rootScope.$on('toggleModeUpdateFromMobileDashboardSidebar', function () {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      });

      $rootScope.$on('changeFontFromPostLoginMobileSidebar', function () {
        vm.count = UtilService.getCount();
      });

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('agentSidebar', agentSidebar);

  /** @ngInject */
  function agentSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/agent/components/sidebar/sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: agentSidebarController,
      controllerAs: 'AgentSidebar',
      bindToController: true
    });

    /** @ngInject */
    function agentSidebarController($timeout, $state, $window, AuthService, InvestorModel, ModalService, $rootScope, $scope, MessageService) {
      var vm = this;
      vm.active = null;
      vm.sidebarActive = null;
      vm.searchInvestor = searchInvestor;
      var identifierData = AuthService.getToken();
      if(identifierData && identifierData.isDistributor){
        vm.isDistributor = identifierData.isDistributor;
      }
      vm.initTab = function () {
        if(!vm.isDistributor){
          $timeout(function () {
            var baseState = $state.current.name.split('.')[1];
            switch (baseState) {
              default:
                vm.active = {'-1': true};
                break;
              case 'distributor-list':
                vm.active = {0: true};
                break;
            }
          }, 100);
          $rootScope.$broadcast('checkCurrentState');
        } else {
          $timeout(function () {
            var baseState = $state.current.name.split('.')[1];
            switch (baseState) {
              default:
                vm.active = {'-1': true};
                break;
              case 'distributor-list':
                vm.active = {0: true};
                break;
            }
          }, 100);
          $rootScope.$broadcast('checkCurrentState');
        }
      };

      vm.activateTab = function (tab) {
        vm.active = {};
        vm.active[tab] = true;
        $rootScope.$broadcast('checkCurrentState');
      };

      function searchInvestor(value) {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          $state.go('agent.home.distributor-home');
          return;
        }
        var success = function (investor) {
            if (investor && investor.uuid) {
              var _state = '';
              var portal = 'agent';
              if(value ==='statements') {
                _state = 'agent.home.investors.statements';
              } else {
                _state = 'agent.home.investors.basicinfo'
              }
              $state.go(_state, {
                investorId: investor.uuid,
                from: portal
              });
            } else {
              MessageService.error('Unable to get uuid of selected investor');
            }
          },
          error = function () {
            $state.go('agent.home.distributor-home');
          };
        ModalService.searchInvestorModal({
          arnCode: identifierData.arnCode,
          statementSearch : true
        }, success, error);
      }

      vm.updateSideBarInvestor = function () {

        $rootScope.$emit('UpdateSideBar');


        var successPanDetails = function (resp) {
          if (resp.data && resp.status && resp.data.kycverified && resp.data.name) {
            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            // resp.data.minor = true;
            model.folioCreationRequestCO.soleApplicantDetail.name = resp.data.name;
            model.folioCreationRequestCO.soleApplicantDetail.dob = resp.data.dob;
            model.folioCreationRequestCO.soleApplicantDetail.panNumber = resp.data.pan;
            model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
            model.folioCreationRequestCO.soleApplicantDetail.email = resp.data.email;
            model.folioCreationRequestCO.soleApplicantDetail.mobileNo = resp.data.mobileNumber;

            InvestorModel.setInvestorModel(model);
            delete $window.sessionStorage.investorForm;
            $window.sessionStorage.investorForm = angular.toJson(model);
            InvestorModel.setTab({
              "tab1": false,
              "tab2": false,
              "tab3": false,
              "tab4": false,
              "tabJointHolderAddable": false,
              "tabGuardianDetailShow": false
            });
            $timeout(function () {
              // $state.go('agent.home.investors.add.appdetails', null, {reload: 'agent.home.investors.add.appdetails'});
              $state.go('agent.home.investors.add.holdmode', null, {reload: 'agent.home.investors.add.holdmode'});

            });
          } else {
            MessageService.error(resp.message || 'Either KYC verification is pending or name is missing.');
          }
        };
        var labelSetter = {type: 'addInvestor', label: {header: 'Add Investor', pan: 'PAN', dob: 'Investor DOB'}};
        ModalService.checkPanModal(labelSetter, successPanDetails);
      };

      var listener = $rootScope.$on('UpdateSideBar', vm.initTab);

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        if (angular.isFunction(listener)) {
          listener();
        }
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('hdfc-mf-distributor-web')
    .directive("agentHeader", agentHeader)
    .directive('myCurrentTime', myCurrentTime);


  /** @ngInject */
  function myCurrentTime($interval, dateFilter){

    return function(scope, element, attrs) {
      var format,
        stopTime;
      function updateTime() {
        element.text(dateFilter(new Date(), format));
      }
      scope.$watch(attrs.myCurrentTime, function(value) {
        format = value;
        updateTime();
      });

      stopTime = $interval(updateTime, 1000);
      element.on('$destroy', function() {
        $interval.cancel(stopTime);
      });
    }
  }
  /** @ngInject */
  function agentHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/agent/components/header/header.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });
  }

    /** @ngInject */
    function headerController($state, $scope, AppConstants, AuthService,$rootScope, ModalService, $timeout,
                              AgentService, MessageService, TransactionInitiateModel, LoaderService) {
      var vm = this;
      vm.format = 'dd-MMM-yyyy h:mm:ss a';
      var listeners = {};
      vm.agentLogout = agentLogout;
      vm.agentAsDistributorLogout = agentAsDistributorLogout;
      vm.impersonateLogout = impersonateLogout;
      vm.impersonateAgentLogout = impersonateAgentLogout;
      var identifier = AuthService.getToken();
      vm.searchInvestor = searchInvestor;
      vm.loadSidebar = loadSidebar;
      vm.sidebarBlackTint = sidebarBlackTint;
      vm.removeSidebarList = removeSidebarList;

      vm.changedFont = changedFont;
      vm.fontSizeChange = fontSizeChange;
      vm.count = 0;
      vm.contrast= contrast;

      if(identifier) {
        $rootScope.role = identifier.role?identifier.role:"";
        $rootScope.isDistributor = identifier.isDistributor ? identifier.isDistributor : false;
        $rootScope.agentName = identifier.name ? identifier.name : "";
        $rootScope.lastLoginDate = identifier.lastLoginDate ? identifier.lastLoginDate : "";
      }

      vm.updateSideBarAgent = function (transactionType) {
        if (transactionType) {
          $timeout(function () {
            search(transactionType);
          }, 50);
        }
        $rootScope.$emit('UpdateSideBar');
      };

      var search = function (transactionType) {
        var identifierData = AuthService.getToken();
        var success = function (investor) {
            if (investor && investor.uuid) {
              switch (transactionType) {
                case 'SIP or Purchase':
                  transactionType = 'SIP';
                  break;
                case 'Systematic Withdrawal Plan':
                  transactionType = 'SWP';
                  break;
                case 'Systematic Transfer Plan':
                  transactionType = 'STP';
                  break;
                case 'Redemption':
                  transactionType = 'Redeem';
                  break;
                case 'Switch':
                  transactionType = 'Switch';
                  break;
                case 'DTP':
                  transactionType = 'DTP';
                  break;
                // case 'FLEXINDEX':
                //   transactionType = 'FLEXINDEX';
                //   break;
                // case 'FLEXSTP':
                //   transactionType = 'FLEXSTP';
                //   break;
              }
              var _state = 'agent.home.transactions.initiate.' + transactionType.toLowerCase();
              $state.go(_state, {
                uuid: investor.uuid,
                schemeCode: '',
                folioNumber: '',
                transactionType: '',
                transactionId: ''
              });
            } else {
              MessageService.error('Unable to get uuid of selected investor');
            }
          },
          error = function () {
           if(identifierData && identifierData.loginType=='A'){
             $state.go('agent.home.distributor-home');
           }
          };
        resetTransactionInitiateModel();
        ModalService.searchInvestorModal({
          transactionType: transactionType,
          arnCode: identifierData.arnCode
        }, success, error);
      };

      var resetTransactionInitiateModel = function () {
        TransactionInitiateModel.setPurchasePayload(null);
        TransactionInitiateModel.setSipPayload(null);
        TransactionInitiateModel.setInvestorPayload(null);
      };

      /** color contrast */

      function contrast (){
        vm.contrastt = !vm.contrastt;
        if(vm.contrastt){
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        }
      }

      function changedFont(valType){
        switch (valType) {
          case 'increment' : {
            if(vm.count<3){
              vm.count++;
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'decrement' : {
            if(vm.count>-3){
              vm.count--;
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'original' : {
            vm.count = 0;
            vm.fontSizeChange(vm.count);
          }
            break;
        }
      }
      function fontSizeChange(val){
        var elem = document.getElementsByTagName("body")[0];
        elem.classList.add("newBigFont");
        var ele = document.getElementsByClassName('newBigFont')[0];
        switch (val) {
          case -2 : {
            ele.setAttribute("style","font-size: 55% !important");
          }
            break;
          case -1 : {
            ele.setAttribute("style","font-size: 65% !important");
          }
            break;
          case 0 : {
            elem.removeAttribute('style');
            elem.classList.remove('newBigFont');
          }
            break;
          case 1 : {
            ele.setAttribute("style","font-size: 97% !important");
          }
            break;
          case 2 : {
            ele.setAttribute("style","font-size: 110% !important");
          }
            break;
        }
      }

      function impersonateAgentLogout() {
        sessionStorage.removeItem('brokerCodePanAdhar');
        var success = function (resp) {
          if (resp.status) {
            $rootScope.isDistributor = false;
            AuthService.agentLogout().then(function () {
              $state.go('agent.login');
            }, function () {
              $state.go('agent.login');
            });
            LoaderService.hideLoader();
          }
          else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
          cb(false);
        };
        LoaderService.showLoader();
        AgentService.post({
          controller: 'logout',
          child1: 'impersonate'
        }, {}).$promise.then(success, error);
      }

      function impersonateLogout() {
        sessionStorage.removeItem('brokerCodePanAdhar');
        var success = function (resp) {
          if (resp.status) {
            $state.go('agent.home.distributor-list');
            var identifierData = AuthService.getToken();
            identifierData['arnCode'] = null;
            identifierData['isDistributor'] = false;
            AuthService.setToken(identifierData);
            localStorage.removeItem('distributorName')
            $rootScope.isDistributor = false;
            LoaderService.hideLoader();
          }
          else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
        };
        LoaderService.showLoader();
        AgentService.post({
          controller: 'logout',
          child1: 'impersonate'
        }, {}).$promise.then(success, error);
      }

      function agentAsDistributorLogout(logoutType) {
        var data = AuthService.getToken();
        sessionStorage.removeItem('brokerCodePanAdhar');
        function success(resp) {
          resp.status = true;
          if(resp.status){
            $rootScope.$broadcast('UpdateSocketDisconnect',{logoutType:logoutType});
            // distributorImpersonate();
          } else {
            MessageService.error('Not able to switch distributor');
          }
        }

        function error() {
          MessageService.error();
        }

        AgentService.post({
          controller: 'caller',
          child1: 'call',
          child2: 'end'
        }, { agentId : data.userId, arnCode : data.arnCode }).$promise.then(success, error);

      }

         // opening search investor modal on statements click

          function searchInvestor(value) {
            angular.element(".mobile-menu").removeClass("expanded");
            angular.element(".main-section").css("overflow", "none");
            angular.element(".main-section").css("position", "static");
            angular.element(".mobile-header>.black-tint").fadeOut();
            var identifierData = AuthService.getToken();
            if (!identifierData || !identifierData.arnCode) {
              MessageService.error('Unable to get arnCode');
              $state.go('agent.home.distributor-home');
              return;
            }
            var success = function (investor) {
             if (investor && investor.uuid) {
              var _state = '';
              var portal = 'agent';
              if(value ==='statements') {
                _state = 'agent.home.investors.statements';
              } else {
                _state = 'agent.home.investors.basicinfo'
              }
                $state.go(_state, {
                investorId: investor.uuid,
                from: portal
              });
              } else {
                MessageService.error('Unable to get uuid of selected investor');
              }
            },
              error = function () {
                $state.go('agent.home.distributor-home');
              };
            ModalService.searchInvestorModal({
              arnCode: identifierData.arnCode,
              statementSearch: true
            }, success, error);
          }

          //logic for opening sidebar

         function loadSidebar() {
            angular.element(".mobile-menu").addClass("expanded");
            angular.element(".main-section").css("overflow", "hidden");
            angular.element(".main-section").css("position", "static");
            angular.element(".mobile-header>.black-tint").fadeIn();
         }

         function sidebarBlackTint() {
          angular.element(".mobile-menu").removeClass("expanded");
          angular.element(".main-section").css("overflow", "none");
          angular.element(".main-section").css("position", "static");
          angular.element(".mobile-header>.black-tint").fadeOut();
         }

         function removeSidebarList() {
           angular.element(".mobile-menu").removeClass("expanded");
           angular.element(".mobile-header>.black-tint").fadeOut();
        }
/*

      function distributorImpersonate() {
        var success = function (resp) {
          if (resp.status) {
            LoaderService.hideLoader();
            var tokenData = AuthService.getToken();
            tokenData['isDistributor'] = resp.data.distributor;
            $window.sessionStorage.currentDistributorARN = '';
            // $rootScope.currentDistributorARN = '';
            //$cookies.put('token_data', angular.toJson(tokenData));
            AuthService.setToken(tokenData);
            $state.go('agent.home.distributor-list');
          }
          else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
        };

        localStorage.removeItem('distributorName');
        LoaderService.showLoader();
        AgentService.get({
          controller: 'logout',
          child1: 'impersonate'
        }, {}).$promise.then(success, error);

      }
*/

  /*    function closeARNConnection(logoutType) {}*/

      function agentLogout() {
        //$rootScope.isConnectionOpen = false;
        sessionStorage.removeItem('brokerCodePanAdhar');
        if($rootScope.socket)
            $rootScope.socket.close();

        if($rootScope.socketTimer)
          clearInterval($rootScope.socketTimer);

        AuthService.agentLogout().then(function () {
          $state.go('agent.login');
        }, function () {
          $state.go('agent.login');
        });
      }
      listeners['checkCurrentState'] = $scope.$on('checkCurrentState', function () {
        vm.sidebarActive = $state.current.name.split('.')[1];
      });
      listeners['UpdateLogoImage'] = $scope.$on('UpdateLogoImage', function (event, args) {
        vm.logoImgUrl = args.logoImgUrl || AppConstants.DEFAULT_LOGO;
      });

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in listeners) {
          if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
            listeners[key]();
          }
        }
      });


    }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcEcartSidebar', hdfcEcartSidebarDirective);

  /*@ngInject*/
  function hdfcEcartSidebarDirective($state, $window, AuthService, LoaderService, AppConstants, MessageService, UtilService, ModalService, TransactionArnService, TransactionEcartService, $cookies, $rootScope,TransactionAddToCartService,$timeout, $stateParams, TransactionFlowVersion) {
    return {
      restrict: 'EA',
      scope: {
        sideTitle: "=",
        euinDeclaration: "=",
        cartItemFromClick: "=",
        fromOneClickScreen: "=?",
        isBrokerTypeChange: "=",
        investThrough: "=",
        updateInfo: "&",
        investorData: '=',
        closeAction : "&",
        showAddCart: '=',
        onlyHdfcUserOneClick: "=?"
      },
      templateUrl: 'app/arn-hardcoded/e-cart/directives/sidebar.directive.html',
      link: function ($scope, element, attrs) {
        var _this = $scope;
        _this.$on('updatedTitle', function() {
          init();
        });
        var initialAnimSkip = false;
        _this.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
        _this.formData = {};
        _this.brokerTypeFromCookies = {};
        if((!_this.onlyHdfcUserOneClick && $cookies.get('broker_details')) || (_this.onlyHdfcUserOneClick && $cookies.get('broker_details_HDFC'))) {
          _this.brokerTypeFromCookies = _this.onlyHdfcUserOneClick? JSON.parse($cookies.get('broker_details_HDFC')): JSON.parse($cookies.get('broker_details'));
        }
        _this.investThroughFormData = {};
        _this.formAction = {};
        _this.investThroughFormData.isCheckedTandC = false;
        _this.sipWithFi = false;
        _this.appConstants = AppConstants;
        _this.transactionTypeList = [
          AppConstants.TRANSACTION_TYPES.SIP,
          AppConstants.TRANSACTION_TYPES.PURCHASE
        ];
        _this.transactionInFund = [];
        _this.filterList = AppConstants.ALL_FUNDS_FILTER;
        _this.amountSuggestion = [5000, 7000, 10000];
        _this.purchaseAmountSuggestion = [30000, 40000, 50000];
        _this.viewMode = "days";
        _this.investmentList = [];
        _this.suggestionList = [];
        _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
        _this.filterValues = [];
        _this.investmentOptions = [];
        _this.moment = $window.moment;
        _this.formData.sipOpted = true;
        _this.formData.purchaseOpted = true;
        _this.formData.yearSelected = [];
        _this.isRegular = false;
        _this.startDateFormat = 'DD-MMM-YYYY';
        _this.collapse = collapse;
        _this.init = init;
        _this.changeThroughDistributor = changeThroughDistributor;
        _this.changeDistributorCode = changeDistributorCode;
        _this.searchDistributor = searchDistributor;
        _this.selectEuin = selectEuin;
        _this.searchDistributorByName = searchDistributorByName;
        _this.distributorListChanged = distributorListChanged;
        _this.changeSubBrokerArn = changeSubBrokerArn;
        _this.fetchEuinListSubBroker = fetchEuinListSubBroker;
        _this.setTandCVariable = setTandCVariable;
        _this.updateCartViaInvestThrough = updateCartViaInvestThrough;

        _this.addTransactionFields = addTransactionFields;
        _this.removeTransactionFromList = removeTransactionFromList;
        _this.removeTransactionFromCart = removeTransactionFromCart;
        _this.editTransactionFromCart = editTransactionFromCart;
        _this.utilService = UtilService;
        _this.allFormData = {};
        _this.allFormData.searchModel = null;
        _this.changeInstallmentAmount = changeInstallmentAmount;
        _this.changeStartDate = changeStartDate;
        _this.changeEndDate = changeEndDate;
        _this.fetchSchemeList = fetchSchemeList;
        _this.filterInSchemeList = filterInSchemeList;
        _this.showCagrValue = showCagrValue;
        _this.displayCagrValue = displayCagrValue;
        _this.openFilter = openFilter;
        _this.filterFunds = filterFunds;
        _this.changeFundsListing = changeFundsListing;
        _this.moveToCartDetails = moveToCartDetails;
        _this.searchRecords = searchRecords;

        _this.setSideBarState = setSideBarState;
        _this.changeInvestmentOptions = changeInvestmentOptions;
        _this.inSchemeChanged = inSchemeChanged;
        _this.changeTillPerpetuity = changeTillPerpetuity;
        _this.saveCartEdited = saveCartEdited;
        _this.addToCart = addToCart;
        _this.nonArnAuth = nonArnAuth;
        _this.authARN = authARN;
        _this.editBrokerType = editBrokerType;
        _this.saveCartFromOneClick = saveCartFromOneClick;
        _this.addTrendingFund = addTrendingFund;
        _this.generateLink = generateLink;
        _this.authARNForSearchByDistributor = authARNForSearchByDistributor;
        _this.filterEuinList = filterEuinList;
        _this.getNote = '';
        _this.fetchDynamicDataEcart = fetchDynamicDataEcart;
        _this.showRecommendedFundOnTop = showRecommendedFundOnTop;
        _this.checkEuinValue = checkEuinValue;
        _this.formData.startDate = null;
        _this.formData.endDate = null;
        _this.enabledStartDates = [];
        _this.isEdit = false;
        _this.showSaveCart = false;
        _this.brokerTypeChange = false;
        _this.hideGenerateLinkButton = false;
        _this.arnNotEmpanneled = false;
        _this.checkFromTrendingFund = false;
        _this.startDateError = false;
        _this.isInstallmentChanged = false;
        _this.isExceedingEmandateDate = false;
        _this.NPCINote = '';
        _this.allSuggestionList = [];
        _this.isRecomendedFund = false;
        _this.addToCartItem = {
          "cartItems": []
        }
        _this.cartItem = {};
        _this.showingTrendingFunds = [];
        _this.investmentArray = AppConstants.ECART_CART_ITEM_NUMBER;
        $scope.$on('deleteBrokerType', function(event,args) {
          _this.addToCartItem.cartItems = [];
        });
        $scope.$on('headerSidebarCollapse', function(){
          _this.sideTitle = 'Cart Details';
        })
        init();

        function init() {
          if($stateParams.x){
            _this.isFromHdfcOneClick = true;
          }
          // collapse();
          if((!_this.onlyHdfcUserOneClick && localStorage.getItem('ecartItems')) || (_this.onlyHdfcUserOneClick && localStorage.getItem('ecartItemsForHDFC'))){
            _this.addToCartItem = _this.onlyHdfcUserOneClick? JSON.parse(localStorage.getItem('ecartItemsForHDFC')):JSON.parse(localStorage.getItem('ecartItems'));
            if (_this.isBrokerTypeChange) {
              _this.addToCartItem.cartItems = [];
            }
          } else {
            _this.addToCartItem = {
              "cartItems": []
            }
          }
          changeThroughDistributor('DISTRIBUTOR');
          if(_this.fromOneClickScreen) {
            _this.cartItem = _this.cartItemFromClick;
          }
          _this.sidebarTitle = _this.sideTitle;
          _this.setSideBarState();
        }

        function collapse() {
          if (initialAnimSkip) {
            initialAnimSkip = false;
            collapseDone();
            element.addClass('sidebar-container-width-0');
            angular.element($window.document.body).removeClass('hide-scroll');
          } else {
            element.removeClass('collapse in').addClass('collapsing-width');
            element.addClass('sidebar-container-width-0');
            collapseDone();
            angular.element($window.document.body).removeClass('hide-scroll');
          }
          resetValues();
          _this.closeAction();
          $rootScope.$broadcast('hidingSidebar');
          if(_this.addToCartItem && _this.addToCartItem.cartItems.length > 0) {
            $rootScope.$broadcast('showEcartWhenItemExist', _this.sidebarTitle);
          }
        }

        function collapseDone() {
          element.removeClass('collapsing-width');
          element.addClass('collapse');
        }


        function setSideBarState(state) {
          var state = state ? state :_this.sideTitle.replaceAll(" ", "_").replaceAll("-", "").toUpperCase();
          _this.sidebarSection = state;
          if (_this.sidebarSection === "INVEST_THROUGH") {
            changeThroughDistributor(_this.investThrough);
            _this.sidebarTitle = 'Invest Through';
            if(_this.isFromHdfcOneClick){
              _this.investThroughFormData.brokerCode = $window.atob($stateParams.x);
              if(_this.investThroughFormData.brokerCode && !_this.investThroughFormData.brokerName){
                authARN();
              }
            }
          } else if (_this.sidebarSection === 'ECART') {
            fetchInvestmentAdded();
            fetchSuggestion();
            _this.sidebarTitle = 'E-Cart';
          } else if(_this.sidebarSection === 'ALL_FUNDS') {
            _this.allFormData.searchModel = ''
            _this.fromOneClickScreen = false;
            _this.suggestedFundData = {};
            fetchFunds();
            fetchFundsFilters();
            _this.sidebarTitle = 'All Funds';
            _this.url = false;
            _this.formData.startDate = null;
          } else if (_this.sidebarSection === 'CART_DETAILS') {
            _this.sidebarTitle = 'Cart Details';
            fetchDynamicDataEcart(function(){
              initializeData();
            });

          }
          angular.element(document.getElementById('scrollTo')).animate({scrollTop: 0}, 500);
        }

        function changeThroughDistributor(investThrough) {
          if((!_this.onlyHdfcUserOneClick && $cookies.get('broker_details')) || (_this.onlyHdfcUserOneClick && $cookies.get('broker_details_HDFC'))) {
            _this.prefilledBrokerType = _this.onlyHdfcUserOneClick? JSON.parse($cookies.get('broker_details_HDFC')):JSON.parse($cookies.get('broker_details'));
          }
          if (investThrough === 'DIRECT') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isDirect = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.subBrokerARN = null;
            _this.investThroughFormData.isEuin = false;
          } else if (investThrough === 'DISTRIBUTOR') {
            _this.investThroughFormData.isThroughDistributor = true;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isEuin = true;
            _this.investThroughFormData.euin = null;
          } else if (investThrough === 'RIA') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.isEuin = false;
            _this.investThroughFormData.subBrokerARN = null;
            if ( _this.cartItem && _this.cartItem.brokerDetailsDTO.riaConsent) {
              _this.investThroughFormData.riaBrokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.brokerCode : null;
            }
          }

          if (!_this.investThroughFormData.isThroughDistributor || !_this.brokerTypeChange) {
            _this.investThroughFormData.euin = {};
            _this.investThroughFormData.brokerCode = '';
            _this.investThroughFormData.brokerName = '';
            _this.euinList = null;
            _this.investThroughFormData.distributorARN = '';
            _this.investThroughFormData.distributorName = '';
            _this.investThroughFormData.subBrokerARN = '';
            _this.investThroughFormData.isCheckedTandC = false;
            _this.isArnSuccess = true;
            _this.investThroughFormData.subBrokerCode = '';
            _this.isSelectedEuin = true;
            _this.subBrokerName = '';
            _this.investThroughFormData.riaBrokerCode = null;
            _this.investThroughFormData.riaBrokerName = null;
            _this.investThroughFormData.utmsource = null;
            _this.investThroughFormData.utmmedium = null;
          }
          if(_this.prefilledBrokerType && _this.brokerTypeChange && _this.prefilledBrokerType.brokerCode){
            _this.investThroughFormData.brokerCode = _this.prefilledBrokerType.brokerCode;
            _this.investThroughFormData.brokerName = _this.prefilledBrokerType.brokerName;
            if(_this.prefilledBrokerType.brokerCode && !_this.prefilledBrokerType.distributoName){
              authARN();
            }

            _this.investThroughFormData.distributorName = _this.prefilledBrokerType.distributoName;
            if(!_this.prefilledBrokerType.brokerCode && _this.prefilledBrokerType.distributoName){
              searchDistributorByName();

              var distributorNameObj = _this.brokerTypeFromCookies.distributoName.split('-');
              var distributorNameObject = {
                name:distributorNameObj[0],
                arnCode: 'ARN-'+ distributorNameObj[distributorNameObj.length - 1]
              };
              distributorListChanged(distributorNameObject);
            }
            if(_this.prefilledBrokerType.subBrokerArn){
              _this.investThroughFormData.subBrokerARN = _this.prefilledBrokerType.subBrokerArn.split('-')[1] ? _this.prefilledBrokerType.subBrokerArn.split('-')[1] : _this.prefilledBrokerType.subBrokerArn;
              $timeout(function () {
                fetchEuinListSubBroker();
              },100);
            }
            _this.investThroughFormData.subBrokerCode = _this.prefilledBrokerType.subBrokerCode;

            _this.investThroughFormData.euinNameCode = _this.prefilledBrokerType.euinCode;
            if(_this.prefilledBrokerType.euinOpted == 'Y'){
              _this.investThroughFormData.isEuin = true;
            } else if(_this.prefilledBrokerType.euinOpted == 'N') {
              _this.investThroughFormData.isEuin = false;
            }

            _this.investThroughFormData.utmsource = _this.prefilledBrokerType.utmsource;
            _this.investThroughFormData.utmmedium = _this.prefilledBrokerType.utmmedium;
          } else if(_this.prefilledBrokerType && _this.brokerTypeChange && _this.prefilledBrokerType.brokerType == 'RIA'){
            _this.investThroughFormData.isThroughRia = true;
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.riaBrokerCode = _this.investThroughFormData.riaBrokerCode;
            nonArnAuth();
          }
          _this.brokerTypeChange = false;
          }


        function changeDistributorCode() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          _this.investThroughFormData.distributorName = '';
          _this.euinList = null;
          _this.isArnSuccess = true;
          _this.riaCodeError = "";
        }

        function searchDistributor() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          fetchEuinList();
        }

        function fetchEuinList() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          _this.investThroughFormData.brokerName = null;
          _this.investThroughFormData.riaBrokerName = null;
          _this.subBrokerCodeError = '';
          _this.euinData = {};
          _this.isArnSuccess = true;
          _this.distributorList = null;

          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.euinMasterList = resp.data.euinList;
                _this.euinList = _this.euinMasterList;
                _this.euinData = _this.investThroughFormData.euin ? _this.investThroughFormData.euin : {};
                _this.brokerCodeError = '';
                _this.riaCodeError = '';
                _this.isArnSuccess = false;
                if (_this.investThroughFormData.isThroughDistributor) {
                  _this.investThroughFormData.brokerName = resp.data.distributorName;
                } else if (_this.investThroughFormData.isThroughRia) {
                  _this.investThroughFormData.riaBrokerName = resp.data.distributorName;
                }
              } else {
                _this.euinList = null;
                if (_this.investThroughFormData.isThroughDistributor) {
                  _this.brokerCodeError = resp.message;
                } else if (_this.investThroughFormData.isThroughRia) {
                  _this.riaCodeError = resp.message;
                  _this.investThroughFormData.isCheckedTandC = false;
                  _this.investThroughFormData.isCheckedTandC = false;
                }
                MessageService.error(resp.message);
              }
            },
            error = function () {
              LoaderService.hideLoader();
              _this.euinList = null;
            };
          LoaderService.showLoader();
          var path = {};
          if (_this.investThroughFormData.isThroughDistributor) {
            path  = {
              controller1: 'getEuin',
              controller2: 'ARN-' + _this.investThroughFormData.brokerCode
            };
          } else if (_this.investThroughFormData.isThroughRia) {
            path = {
              controller1: 'getEuin',
              controller2: _this.investThroughFormData.riaBrokerCode,
              riaOpted: _this.investThroughFormData.isThroughRia
            };
          }
          TransactionArnService.get(path).$promise.then(success, error);
        }

        // function filterEuinList() {
        //   _this.investThroughFormData.euin = {};
        //   _this.isSelectedEuin = false ;
        //   if(_this.euinData.euinNameCode){
        //     if(_this.euinData.euinNameCode.length>=3){
        //       _this.euinList = UtilService.getFilteredList(_this.euinMasterList, 'euinNameCode', _this.euinData.euinNameCode);
        //     }
        //   }
        //   _this.euinList = _this.euinData.euinNameCode == '' || _this.euinData.euinNameCode == undefined || _this.euinData.euinNameCode.length<3 ? _this.euinMasterList : _this.euinList;
        // }

        function selectEuin(data) {
          if (!data) {
            return;
          }
          _this.euinData = {};
          _this.investThroughFormData.euinNameCode = data.euinNameCode;
          _this.isSelectedEuin = _this.investThroughFormData.euinNameCode ? true : false;
          checkEuinValue(_this.investThroughFormData.euinNameCode);
        }

        function searchDistributorByName() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          if(_this.investThroughFormData.brokerCode) {
            _this.investThroughFormData.brokerCode = '';
          }
          _this.brokerCodeError = '';
          _this.isArnSuccess = true;
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            _this.distributorList = null;
            _this.euinList = null;
            _this.investThroughFormData.euin = null;
            return;
          }
          fetchARNByName();
        }

        function fetchARNByName() {
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            return;
          }
          _this.investThroughFormData.distributorARN = '';
          _this.distributorList = null;
          _this.isArnSuccess = true;
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.distributorList = resp.data.distributorList;
                if (_this.distributorList.length == 0) {
                  _this.investThroughFormData.euin = {};
                  _this.investThroughFormData.isCheckedTandC = false;
                }
                _this.arnNotEmpanneled = true;
              } else {
                _this.distributorList = null;
                MessageService.error(resp.message);
                _this.arnNotEmpanneled = false;
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              _this.distributorList=null;
              UtilService.errorHandler(err);
              _this.arnNotEmpanneled = false;
            };

          LoaderService.showLoader();
          TransactionAddToCartService.get({
            controller1: 'getDistributor',
            controller2: _this.investThroughFormData.distributorName
          }).$promise.then(success, error);
        }

        function distributorListChanged(data) {
          if (!data) {
            return;
          } else {
            _this.brokerCodeError = '';
            _this.investThroughFormData.distributorARN = data.arnCode;
            _this.investThroughFormData.distributorName = data.name + ' - ' + data.arnCode;
            _this.showArnLabel = false;
            if (_this.investThroughFormData.distributorARN) {
              _this.isArnSuccess = false;
            }
            else {
              _this.isArnSuccess = true;
            }
            authARNForSearchByDistributor()
          }

          _this.fetchEuinListThroughDistributor = function fetchEuinListThroughDistributor(arnCode) {
            if (!arnCode) {
              return;
            }
            _this.investThroughFormData.brokerName = '';
            var success = function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  _this.euinMasterList = resp.data.euinList;
                  _this.euinList = _this.euinMasterList;
                  _this.euinData = _this.investThroughFormData.euin;
                } else {
                  _this.euinList = null;
                }
              },
              error = function () {
                LoaderService.hideLoader();
                _this.euinList = null;
              };

            LoaderService.showLoader();
            TransactionArnService.get({
              controller1: 'getEuin',
              controller2: arnCode
            }).$promise.then(success, error);
          }
        };

        function changeSubBrokerArn() {
          _this.investThroughFormData.subBrokerCode = '';
          _this.investThroughFormData.isSubarnSuccess = _this.investThroughFormData.subBrokerARN ? true : false;
          _this.investThroughFormData.isCheckedTandC = false;
          _this.subBrokerName = '';
        }

        function fetchEuinListSubBroker() {
          if (!_this.investThroughFormData.subBrokerARN) {
            _this.subBrokerCodeError = '';
            _this.subBrokerName = '';
            _this.isSubarnSuccess = false;
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
            fetchEuinList();
            return;
          }
          if(_this.investThroughFormData.brokerCode !== _this.investThroughFormData.subBrokerARN){
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
          }
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.euinMasterList = resp.data.euinList;
                _this.euinList = _this.euinMasterList;
                for(var i = 0; i<_this.euinList.length; i++){
                  if(_this.euinData && _this.euinData.euinNameCode === _this.euinList[i].euinNameCode){
                    _this.investThroughFormData.euin = _this.euinList[i];
                    break;
                  } else {
                    _this.investThroughFormData.euin = {};
                  }
                }
                _this.euinData = _this.investThroughFormData.euin;
                _this.subBrokerName = resp.data.distributorName;
                _this.subBrokerCodeError = '';
                _this.isSubarnSuccess = false;
              } else {
                _this.euinList = null;
                _this.subBrokerCodeError = resp.message;
                _this.isSubarnSuccess = true;
                _this.investThroughFormData.euin = {};
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              _this.subBrokerCodeError = '';
              MessageService.error(err);
            };

          LoaderService.showLoader();
          TransactionArnService.get({
            controller1: 'getEuin',
            controller2: 'ARN-' + _this.investThroughFormData.subBrokerARN,
            isSubBroker: _this.investThroughFormData.isThroughDistributor
          }).$promise.then(success, error);
        }

        function setTandCVariable() {
          _this.investThroughFormData.isCheckedTandC = _this.investThroughFormData.isCheckedTandC;
        }

        function updateCartViaInvestThrough(type) {
          if((!_this.onlyHdfcUserOneClick && $cookies.get('broker_details')) || (_this.onlyHdfcUserOneClick && $cookies.get('broker_details_HDFC'))) {
            _this.checkBrokerType = _this.onlyHdfcUserOneClick? JSON.parse($cookies.get('broker_details_HDFC')): JSON.parse($cookies.get('broker_details'));
          }
          if(_this.checkBrokerType && _this.checkBrokerType.brokerType !== type){
            _this.addToCartItem.cartItems = [];
            if(_this.onlyHdfcUserOneClick){
              localStorage.removeItem('ecartItemsForHDFC')
            } else {
              localStorage.removeItem('ecartItems');
            }
            $rootScope.$broadcast("CartCount", _this.addToCartItem.cartItems.length);
          }
          var payload = getInvestThroughPayload();
          if(_this.onlyHdfcUserOneClick){
            $cookies.put('broker_details_HDFC', angular.toJson(payload));
            _this.brokerTypeFromCookies = JSON.parse($cookies.get('broker_details_HDFC'));
          } else {
            $cookies.put('broker_details', angular.toJson(payload));
            _this.brokerTypeFromCookies = JSON.parse($cookies.get('broker_details'));
          }
          setSideBarState('ALL_FUNDS');
        }

        function getInvestThroughPayload() {
          var payload = {
            "brokerType": _this.investThroughFormData.isThroughRia ? 'RIA': 'MFD',
            "directOpted": _this.investThroughFormData.isThroughDistributor ? false : true,
            "brokerCode": _this.investThroughFormData.isThroughDistributor? _this.investThroughFormData.brokerCode: null,
            "brokerName":_this.investThroughFormData.isThroughDistributor ? _this.investThroughFormData.brokerName: null,
            "subBrokerCode": _this.investThroughFormData.isThroughDistributor ? _this.investThroughFormData.subBrokerCode : null,
            "subBrokerArn": _this.investThroughFormData.isThroughDistributor ? _this.investThroughFormData.subBrokerARN : null,
            "euinOpted": _this.investThroughFormData.isEuin && _this.investThroughFormData.isEuin == true ? 'Y' : 'N',
            "euinCode": _this.investThroughFormData.isThroughDistributor ? _this.investThroughFormData.euinNameCode : null,
            "euinName": _this.investThroughFormData.isThroughDistributor ? _this.investThroughFormData.brokerName : null,
            "riaConsent": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.isCheckedTandC : false,
            "riaBrokerName": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.riaBrokerName : null,
            "distributoName":_this.investThroughFormData.distributorName? _this.investThroughFormData.distributorName: null,
            "utmsource":_this.investThroughFormData.utmsource? _this.investThroughFormData.utmsource : null,
            "utmmedium":_this.investThroughFormData.utmmedium? _this.investThroughFormData.utmmedium : null,
          };
          if(_this.investThroughFormData.isThroughRia){
            payload.riaBrokerCode = _this.investThroughFormData.riaBrokerCode;
          }
          return payload;
        }

        function identifyBrokerCode() {
          if (_this.investThroughFormData.isDirect) {
            return "DIRECT";
          } else if (_this.investThroughFormData.isThroughDistributor) {
            return 'ARN-'+_this.investThroughFormData.brokerCode;
          } else if (_this.investThroughFormData.isThroughRia) {
            return _this.investThroughFormData.riaBrokerCode;
          }
        }

        /*---------------------------------------- CART DETAILS SECTION ----------------------------------------------*/
        function initializeData() {
            //_this.formData.inSchemeName = _this.cartItem && _this.cartItem.schemeName;
            _this.fundName = _this.fundName ? _this.fundName : _this.cartItem.fundName;
            _this.fundCode = _this.fundCode ? _this.fundCode : _this.cartItem.fundCode;
            if(_this.cartItem && _this.cartItem.schemeCode){
              _this.formData.schemeCode = _this.cartItem.schemeCode;
            } else if(_this.isRegular && _this.suggestedFundData && Object.keys(_this.suggestedFundData).length > 0 &&  _this.suggestedFundData.directSchemes && _this.suggestedFundData.directSchemes[0].schemeCode){
              var getGrowthScheme = _this.suggestedFundData.directSchemes.filter(function(scheme){
                return scheme.investmentOption == "Growth"
              })
              if(getGrowthScheme[0].investmentOption == 'Growth'){
                _this.formData.schemeCode = getGrowthScheme[0].schemeCode;
              } else {
                _this.formData.schemeCode = _this.suggestedFundData.directSchemes[0].schemeCode;
              }

            } else if(!_this.isRegular && _this.suggestedFundData && Object.keys(_this.suggestedFundData).length > 0 && _this.suggestedFundData.regularSchemes.length>0 && _this.suggestedFundData.regularSchemes[0].schemeCode){
              var getGrowthScheme = _this.suggestedFundData.regularSchemes.filter(function(scheme){
                return scheme.investmentOption === "Growth"
              })
              if(getGrowthScheme[0].investmentOption == 'Growth'){
                _this.formData.schemeCode = getGrowthScheme[0].schemeCode;
              } else {
                _this.formData.schemeCode = _this.suggestedFundData.regularSchemes[0].schemeCode;
              }
            } else {
              _this.formData.schemeCode = '';
              _this.formData.schemeName = '';
              _this.formData.sipOpted = true;
              _this.formData.purchaseOpted = true;
            }
            _this.formData.cartItemId = _this.cartItem && _this.cartItem.cartItemId;
            if (!angular.isUndefined(_this.cartItem)) {
              _this.isRegular = _this.brokerTypeFromCookies.brokerType && _this.brokerTypeFromCookies.brokerType == 'RIA' ? true : false;
            }
            if (_this.cartItem && Object.keys(_this.cartItem).length > 0 && _this.cartItem.sipOpted == false) {
              _this.formData.sipOpted = false;
            } else if (_this.cartItem && Object.keys(_this.cartItem).length > 0 && _this.cartItem.sipOpted == true) {
              _this.formData.sipOpted = true;
            } else if(_this.checkFromTrendingFund){
              // _this.formData.sipOpted = _this.cartItem && Object.keys(_this.cartItem).length > 0 && _this.cartItem.sipOpted == true? true: false;
              _this.formData.sipOpted = true;
            }

            if (_this.cartItem && Object.keys(_this.cartItem).length > 0 && _this.cartItem.purchaseOpted == false) {
              _this.formData.purchaseOpted = false;
            } else if (_this.cartItem && Object.keys(_this.cartItem).length > 0 && _this.cartItem.purchaseOpted == true) {
              _this.formData.purchaseOpted = true;
            } else if(_this.checkFromTrendingFund){
              _this.formData.purchaseOpted = true;
            }

            if (_this.cartItem && _this.cartItem.brokerCode === 'DIRECT') {
              _this.formData.isDirectFund = true;
            }
            if (_this.cartItem && _this.cartItem.sipDate) {
              _this.formData.startDate = moment(_this.cartItem.sipDate, 'DD-MMM-YYYY');
              _this.setFromData = true;
            }
          fetchSchemeList();
        }

        function addTransactionFields(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = true;
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = true;
            _this.isAddTransaction = true;
          }
          if(_this.formData.sipOpted) {
            _this.formData.installmentDisplayAmount = _this.formData.installmentDisplayAmount ? _this.formData.installmentDisplayAmount : UtilService.amountInComma(_this.sipValidation.sipDefaultAmount).amountInComma;
            changeInstallmentAmount('SIP');
          }
          if (_this.formData.purchaseOpted) {
            _this.formData.displayAmount = _this.formData.displayAmount ? _this.formData.displayAmount : UtilService.amountInComma(_this.purchaseValidation.defaultAmount).amountInComma;
            changeInstallmentAmount('PURCHASE');
          }
          getDateValidation(function() {
            $timeout(function () {
              changeStartDate(_this.formData.startDate);
            },100)
          });
        }

        function removeTransactionFromList(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = false;
            _this.formData.displayAmount = null;
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = false;
            _this.formData.installmentDisplayAmount = null;
            _this.formData.startDate = null;
            _this.formData.endDate = null;
            delete _this.formData.installmentAmount;
          }
        }

        function removeTransactionFromCart(id) {
          _this.addToCartItem.cartItems = _this.addToCartItem.cartItems.filter(function(item){
            return item.cartItemId !== id;
          });
          if(_this.onlyHdfcUserOneClick){
            localStorage.setItem('ecartItemsForHDFC', angular.toJson(_this.addToCartItem));
          } else {
            localStorage.setItem('ecartItems', angular.toJson(_this.addToCartItem));
          }
          if(_this.addToCartItem.cartItems) {
            checkChildAndRetirementFund(_this.addToCartItem.cartItems);
          }
          fetchInvestmentAdded();
          _this.url = false;
          handleTrendingFund();
        }

        function editTransactionFromCart(screen,item) {
          _this.cartItem = {};
          _this.showSaveCart = true;
          _this.fromOneClickScreen = false;
          _this.url = false;
          _this.formData.startDate = null;
          _this.formData.endDate = null;
          switch (screen) {
            case 'CART_DETAILS':
              _this.cartItem = item;
              _this.isEdit = true;
              _this.fundName = '';
              _this.fundCode = '';
              setSideBarState('CART_DETAILS');
              break;
          }
        }

        /*
        *  scheme list methods defined here
        * */
        function fetchSchemeList() {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.inSchemeList = resp.data.schemeDetails;
              _this.fundName = resp.data.fundName;
              _this.fundCode = resp.data.fundCode;
              _this.currentDateFromFund = resp.data.currentDate;
              _this.maxMandateDurationYears = resp.data.sipSettings && resp.data.sipSettings.eOTM.maxMandateDurationYears;
              _this.NPCINote = _this.getNote.noteDTO.noteDTOMap.Note_NPCI_Info.content.replace('%@', _this.maxMandateDurationYears);
              _this.maximumItemAllowed = resp.data.maximumItemAllowed;

              if (_this.formData.schemeCode) {
                var schemeData = _this.inSchemeList.filter(function(scheme) {
                  return scheme.schemeCode === _this.formData.schemeCode;
                });
                _this.inSchemeChanged(schemeData[0]);
              } else {
                _this.inSchemeList.forEach(function(list, index) {
                  if(list.investmentOption === "GROWTH") {
                    _this.inSchemeChanged(list);
                  }
                });
              }
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionEcartService.post({
            child1: 'validate',
            child2: 'fund'
          }, {
            fundCode: _this.fundCode,
            directFund: _this.isRegular
          }).$promise.then(success, error);
        }

        function filterInSchemeList() {
          _this.formData.schemeCode = '';
          _this.inSchemeList = UtilService.getFilteredList(_this.inSchemeList, 'schemeName', _this.formData.schemeName);
        }

        function inSchemeChanged(schemeData , fromHtml) {
          if (!schemeData) {
            return;
          } else {
            _this.formData.schemeCode = schemeData.schemeCode;
            _this.formData.schemeName = schemeData.schemeName;
            _this.formData.schemeType = schemeData.schemeType;
            _this.formData.isDividend = schemeData.investmentOption && schemeData.investmentOption === 'DIVIDEND' ? true : false;
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            _this.formData.cgfApplicable = schemeData.cgfApplicable;
            _this.formData.retirementApplicable = schemeData.retirementApplicable;
            _this.investmentOptions = [];
            if (schemeData.dividendReinvestmentApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[0]);
            }
            if (schemeData.dividendPayoutApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[1]);
            }
            if(_this.cartItem.dividendOption){
              if(_this.formData.schemeName !== _this.cartItem.schemeName){
                _this.cartItem.dividendOption = null;
              }
            }
            if (_this.formData.isDividend) {
              if (_this.cartItem && _this.cartItem.dividendOption) {
                var dividendObject = _this.investmentOptions.find(function (el) {
                  return el.value === _this.cartItem.dividendOption;
                })
                _this.changeInvestmentOptions(dividendObject);
              } else {
                _this.changeInvestmentOptions(_this.investmentOptions[0]);
              }
            }
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            if(_this.cartItem && _this.cartItem.length > 1 && !_this.cartItem.sipOpted) {
              _this.formData.sipOpted = false;
            } else if (angular.isDefined(_this.formData.sipOpted)) {
              _this.formData.sipOpted = _this.formData.sipOpted;
            } else {
              if (_this.sipValidation.sipEnabled === 'Y') {
                _this.formData.sipOpted = true;
              } else {
                _this.formData.sipOpted = false;
              }
            }
            if (_this.cartItem && _this.cartItem.length > 1 && !_this.cartItem.purchaseOpted) {
              _this.formData.purchaseOpted = false;
            } else if (angular.isDefined(_this.formData.purchaseOpted)) {
              _this.formData.purchaseOpted = _this.formData.purchaseOpted;
            } else {
              if (_this.purchaseValidation.webPurchaseEnabled === 'Y') {
                _this.formData.purchaseOpted = true;
              } else {
                _this.formData.purchaseOpted = false;
              }
            }
            if(_this.formData.sipOpted) {
              _this.formData.installmentDisplayAmount = _this.formData.installmentDisplayAmount ? UtilService.amountInComma(_this.formData.installmentDisplayAmount).amountInComma : _this.cartItem && _this.cartItem.installmentAmount ? UtilService.amountInComma(_this.cartItem.installmentAmount).amountInComma : UtilService.amountInComma(_this.sipValidation.sipDefaultAmount).amountInComma;
              changeInstallmentAmount('SIP');
            }
            if (_this.formData.purchaseOpted) {
              _this.formData.displayAmount = _this.formData.displayAmount ? UtilService.amountInComma(_this.formData.displayAmount).amountInComma : _this.cartItem && _this.cartItem.amount ? UtilService.amountInComma(_this.cartItem.amount).amountInComma : UtilService.amountInComma(_this.purchaseValidation.defaultAmount).amountInComma;
              changeInstallmentAmount('PURCHASE');
            }
            getDateValidation(function() {
              $timeout(function () {
                changeStartDate(_this.formData.startDate);
              },100)
            });
          }
        }

        function changeInvestmentOptions(data) {
          if (!data) {
            return;
          }
          _this.formData.investmentOptionName = data.key;
          _this.formData.dividendOption = data.value;
        }

        /*
        *
        * Amount fields methods defined here
        *
        * */

        function changeInstallmentAmount(transaction, calledFromHtml) {
          if (transaction === 'PURCHASE') {
            var amountObj = UtilService.amountInComma(_this.formData.displayAmount);
            _this.formData.displayAmount = amountObj.amountInComma;
            _this.formData.amount = amountObj.amount;
          } else if (transaction === 'SIP') {
            var amountObj = UtilService.amountInComma(_this.formData.installmentDisplayAmount);
            _this.formData.installmentDisplayAmount = amountObj.amountInComma;
            _this.formData.installmentAmount = amountObj.amount;

            if(_this.cartItem.installmentAmount !== _this.formData.installmentAmount){
              _this.isInstallmentChanged = true;
            }
          }
          calculateValidations();
          getDateValidation(function() {
            $timeout(function () {
              changeStartDate(_this.formData.startDate);
            },100)
          });
        }

        /*
        *
        * Date fields methods defined here
        *
        * */

        function changeStartDate(date) {
          if (_this.setFromData) {

            var diff = date.isSame(_this.formData.startDate);

            if (!diff) {
              _this.setFromData = false;
            }
          }
          _this.formData.startDate = date ? date : null;
          _this.formData.day = _this.formData.startDate ? $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format('D') : '';
          _this.formData.endDate = null;
          _this.startDateError = _this.formData.startDate && _this.formData.startDate.isBefore(_this.startMinDateBiller);
          updateEndDates();
        }

        function changeEndDate(date) {
          if (date) {
            _this.formData.endDate = date ? date : null;
            _this.formData.storeEndDate = _this.formData.endDate;
            if ($window.moment(_this.formData.endDate, "DD-MMM-YYYY").isSame($window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY"))) {
              _this.formData.isTillPerpetuity = true;
            } else {
              _this.formData.isTillPerpetuity = false;
            }
            var emandateEndDate = $window.moment(_this.formData.startDate,'DD-MMM-YYYY').add(_this.maxMandateDurationYears,'years');
            var selectedEndDate = $window.moment(_this.formData.endDate,'DD-MMM-YYYY');
            var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
            if (!endDateEmandateBoundExist) {
              _this.isExceedingEmandateDate = true;
            } else {
              _this.isExceedingEmandateDate = false;
            }
          } else {
            _this.isExceedingEmandateDate = false;
          }
          checkEnableEndDate();
        }

        function getDateValidation(cb) {
          cb = cb || function () {
          };
          var currentDate = _this.currentDateFromFund || Date();
          var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
          var todayDate = $window.moment(Date.parse(parsedDate));
          var counter =0;
          _this.enabledStartDates = [];
          // _this.nonBusinessDatess = resp.data.nonBuisnessDates;
          _this.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(_this.sipValidation.sipTDay, 'days'); // t+17 need to change it to dynamically variable.
          _this.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
          var startDate = todayDate.clone();
          var freq = _this.startMaxDate.diff(todayDate, 'days');
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            if(counter<5)
                  {
                    // angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                    //   if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                    //     isEnable = false;
                    //   }
                    // });
                  }
            if(isEnable){
              _this.enabledStartDates.push(startDate.clone().add(i, 'days'));
              counter++;
            }
          }
          _this.formData.startDate =  _this.formData.startDate ?  _this.formData.startDate :_this.enabledStartDates[_this.sipValidation.sipTDay];
          cb();
        }

        function updateEndDates() {
          if (!_this.formData.startDate) {
            return;
          }
          var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
          var defaultMonths = null;
          var endDate = null;
          var enabledEndDates = [];
          var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber || 0;
          var i = 0;
          var frequency = {
            "name": "Monthly",
            "code": "OM",
            "duration": 1
          };
          var months = 0;
          endDate = _this.formData.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          var minInstallments = _this.validations && _this.validations.minInstallments && (_this.validations.minInstallments - 1) || 0;
          _this.enabledEndDates = enabledEndDates.slice(minInstallments);
          _this.enabledEndDateView = angular.copy(_this.enabledEndDates[0]);
          if (_this.setFromData && !_this.isInstallmentChanged) {
            if ( _this.cartItem && _this.cartItem.toDate) {
              if(_this.isAddTransaction){
                _this.formData.endDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + '2099';
                _this.formData.endDate = $window.moment(_this.formData.endDate, "DD-MM-YYYY");
              } else {
                _this.formData.endDate = moment(_this.cartItem.toDate, 'DD-MMM-YYYY');
              }
                _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + ($window.moment(_this.formData.endDate).year());
                _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");

            } else if(_this.checkFromTrendingFund){

              _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + '2099';
              _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");
              _this.formData.endDate =  _this.tillPerpetuityEndDate;
            } else {
              _this.formData.endDate = moment(_this.formData.storeEndDate, 'DD-MM-YYYY');
              _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + '2099';
              _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");
            }
          } else {
            _this.formData.isTillPerpetuity = true;
            changeTillPerpetuity();
          }
          checkEnableEndDate();
        }

        function changeTillPerpetuity() {
          _this.frequency = {
            "name": "Monthly",
            "code": "OM",
            "duration": 1
          };
          if (_this.formData.isTillPerpetuity) {
            var enabledEndDateMaxYear = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]).year();
            _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + enabledEndDateMaxYear;
            _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");
            var calculatedEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY");

            if (calculatedEndDate && (($window.moment(calculatedEndDate).isBetween($window.moment(_this.enabledEndDates[0]), $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates[0]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates.length - 1))))) {
              _this.formData.endDate = angular.copy(calculatedEndDate);
            } else {
              calculatedEndDate.set('year', enabledEndDateMaxYear - 1);
              if (!_this.moment(calculatedEndDate).isValid()) {
                var newday = _this.moment().date();
                var newMonth = _this.moment(_this.formData.startDate, 'DD-MMM-YYYY').month();
                var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
                var endDateCal = _this.moment(newEndDateCal, "DD-MM-YYYY");
                var initialStartDate = _this.formData.startDate.clone().day(1)
                endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
              }
              if(endDateCal){
                var defaultMonths = UtilService.getNumberOfMonths(_this.formData.startDate.clone().add(_this.frequency, 'months'), $window.moment(endDateCal));
                var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber || 0;
                var freq = freq || Math.floor(defaultMonths / _this.frequency.duration);
                var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber ? freq - 1 : freq;
                var months = _this.frequency.duration * freq;
                _this.formData.endDate = _this.formData.startDate.clone().add(months, 'months');
                _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
              } else {
                _this.tillPerpetuityEndDate = angular.copy(calculatedEndDate);
                _this.formData.endDate = angular.copy(calculatedEndDate);
              }
            }

            if ($window.moment(_this.formData.endDate).year() > 2099) {
              _this.formData.endDate.set('year', 2099);
              _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
            }

          } else {
            _this.formData.endDate = null;
          }
          checkEnableEndDate();
        }

        function saveCartEdited() {
          var payload = getUpdatePayload();
          _this.addToCartItem.cartItems.forEach(function (item,index){
            if(item.cartItemId === _this.cartItem.cartItemId){
              _this.addToCartItem.cartItems[index] = payload;
            }
          });
          if(_this.onlyHdfcUserOneClick){
            localStorage.setItem('ecartItemsForHDFC', angular.toJson(_this.addToCartItem));
          } else {
            localStorage.setItem('ecartItems', angular.toJson(_this.addToCartItem));
          }
          fetchInvestmentAdded();
          setSideBarState('ECART');
          _this.url = false;
          _this.isInstallmentChanged = false;
          _this.formData.installmentDisplayAmount = null;
          _this.formData.displayAmount = null;
        }

        function addToCart() {
          var payload = getPayload();
          _this.addToCartItem.cartItems.push(payload);
          _this.addToCartItem.cartItems.forEach(function(item, i){
            item.cartItemId = "TXNID"+(i + 1);
          });
          _this.addToCartItem.maximumItemAllowed = _this.maximumItemAllowed;
          checkChildAndRetirementFund(_this.addToCartItem.cartItems);
          if(!_this.hideGenerateLinkButton) {
            if (_this.addToCartItem.cartItems.length <= _this.maximumItemAllowed) {
              if(_this.onlyHdfcUserOneClick){
                localStorage.setItem('ecartItemsForHDFC', angular.toJson(_this.addToCartItem));
              } else {
                localStorage.setItem('ecartItems', angular.toJson(_this.addToCartItem));
              }
              MessageService.success("Selected scheme successfully added to the cart")
            } else {
              _this.addToCartItem.cartItems.pop();
              MessageService.error("Only " +_this.maximumItemAllowed+ " items to be selected")
            }
            setSideBarState('ECART');
            _this.isInstallmentChanged = false;
          } else {
            _this.addToCartItem.cartItems.pop();
          }
          _this.formData.installmentDisplayAmount = null;
          _this.formData.displayAmount = null;
        }

        function checkChildAndRetirementFund(allSchemes){
          var countMinorScheme = [];
          var countRetiredScheme = [];
          allSchemes.forEach(function(item){
            countMinorScheme.push(item.cgfApplicable);
            countRetiredScheme.push(item.retirementApplicable);
          });
          for(var i=0; i< countMinorScheme.length;i++){
            for(var j=0; j< countRetiredScheme.length; j++){
              if((countMinorScheme[i] && countRetiredScheme[j]) == true){
                MessageService.error('Children’s Gift Fund & Retirement cannot be added together');
                _this.hideGenerateLinkButton = true;
                return;
              } else {
                _this.hideGenerateLinkButton = false;
              }
            }
          }
        }

        function getPayload() {
            var payload = {
              "schemeCode": _this.formData.schemeCode,
              "schemeName" : _this.formData.schemeName,
              "amount": _this.formData.amount,
              "dividendOption": _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.DIVIDEND_OPTIONS.GROWTH,
              "liquid": _this.formData.schemeType === 'LIQUID' ? true: false,
              "folioNumber": _this.investorData && _this.investorData.folioNumber ? _this.investorData.folioNumber: null,
              "cgfApplicable": _this.formData.cgfApplicable ? _this.formData.cgfApplicable : false,
              "minorFlag": _this.investorData && _this.investorData.minorFlag ? _this.investorData.minorFlag: false,
              "newUser": false,
              "purchaseOpted": _this.formData.purchaseOpted,
              "sipOpted": _this.formData.sipOpted,
              "frequency": "OM",
              "sipDay": _this.formData.day,
              "numberOfInstallment": $window.moment($window.moment(_this.formData.endDate, "DD-MMM-YYYY")).diff($window.moment(_this.formData.startDate, "DD-MMM-YYYY"),'months') + 1,
              "installmentAmount": _this.formData.installmentAmount,
              "investmentOption": _this.formData.isDividend ? 'DIVIDEND': 'GROWTH',
              "fundName": _this.fundName,
              "fundCode": _this.fundCode,
              "retirementApplicable": _this.formData.retirementApplicable ?_this.formData.retirementApplicable:false,
            };
          if (_this.formData.sipOpted) {
            payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          return payload;
        }

        function getUpdatePayload() {
          var payload = {
            "cartItemId": _this.cartItem.cartItemId,
            "schemeCode": _this.formData.schemeCode,
            "schemeName" : _this.formData.schemeName,
            "amount": _this.formData.amount,
            "dividendOption": _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.DIVIDEND_OPTIONS.GROWTH,
            "liquid": _this.formData.schemeType === 'LIQUID' ? true: false,
            "folioNumber": _this.investorData && _this.investorData.folioNumber ? _this.investorData.folioNumber: null,
            "cgfApplicable": _this.formData.cgfApplicable ? _this.formData.cgfApplicable: false,
            "minorFlag": _this.investorData && _this.investorData.minorFlag ? _this.investorData.minorFlag: false,
            "newUser": false,
            "purchaseOpted": _this.formData.purchaseOpted,
            "sipOpted": _this.formData.sipOpted,
            "frequency": "OM",
            "sipDay": _this.formData.day,
            "numberOfInstallment": $window.moment($window.moment(_this.formData.endDate, "DD-MMM-YYYY")).diff($window.moment(_this.formData.startDate, "DD-MMM-YYYY"),'months') + 1,
            "installmentAmount": _this.formData.installmentAmount,
            "investmentOption": _this.formData.isDividend ? 'DIVIDEND': 'GROWTH',
            "fundName": _this.fundName,
            "fundCode": _this.fundCode,
            "retirementApplicable": _this.formData.retirementApplicable? _this.formData.retirementApplicable: false,
          };
          if (_this.formData.sipOpted) {
            payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
          }
          return payload;
        }

        function resetValues() {
          _this.formData.schemeName = '';
          _this.investThroughFormData = {};
          _this.formData.sipOpted = true;
          _this.formData.purchaseOpted = true;
          _this.formData.installmentDisplayAmount = null;
          _this.formData.displayAmount = null;
          _this.formData.startDate = null;
          _this.formData.endDate = null;
        }

        /*--------------------------------------- All funds section starts from here ---------------------------------*/
        function fetchFunds() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              if(_this.onlyHdfcUserOneClick){
                _this.allFunds = showRecommendedFundOnTop(resp.data.funds);
              } else {
                _this.allFunds = resp.data.funds;
              }

              _this.isRegular = _this.brokerTypeFromCookies.brokerType && _this.brokerTypeFromCookies.brokerType == 'RIA' ? true : false;
              filterDirectAndRegularFunds(function() {
                _this.funds = _this.isRegular == false ? _this.regularFunds : _this.directFunds;
                LoaderService.hideLoader();
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'detail'
          }).$promise.then(success, error);
        }

        function displayCagrValue(fund) {
          if (_this.isRegular) {
            fund.regularCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.regularCagr = x.value;
              }
            });
          } else if (!_this.isRegular) {
            fund.directCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.directCagr = x.value;
              }
            });
          }
        }

        function openFilter() {
          //angular.element(document.getElementsByClassName('filter-row')).toggle();
          angular.element(document.getElementsByClassName('filter-row')).toggleClass('showSidebar');
        }

        function filterDirectAndRegularFunds(cb) {
          _this.regularFunds = [];
          _this.directFunds= [];
          _this.allFunds.forEach(function(funds) {
            funds.selectedYear = 'Since Inception';
            if (funds.regularScheme.length > 0) {
              var returnsArray = [];
              funds.regularCagrReturns = [];
              if (!angular.equals(funds.fundNavRegular) && !angular.equals(funds.fundNavRegular.annualisedreturns)) {
                Object.keys(funds.fundNavRegular.annualisedreturns).forEach(function(key) {
                  if (key === '5') {
                    funds.regularCagr = funds.fundNavRegular.annualisedreturns[key];
                  }
                  var obj = {
                    key: key === 11 || key === '11' ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                    value: funds.fundNavRegular.annualisedreturns[key]
                  };
                  returnsArray.push(obj);
                });
              }
              funds.regularCagrReturns = returnsArray;
              if(funds.fundCode !== 'HDFCGF') {
                _this.regularFunds.push(funds);
              }
            }
            if(funds.directScheme.length > 0) {
              var returnsArray = [];
              funds.directCagrReturns = [];
              if (!angular.equals(funds.fundNavDirect, {}) && !angular.equals(funds.fundNavDirect.annualisedreturns, {})) {
                if(funds.fundNavDirect.annualisedreturns) {
                  Object.keys(funds.fundNavDirect.annualisedreturns).forEach(function (key) {
                    if (key === '5') {
                      funds.directCagr = funds.fundNavDirect.annualisedreturns[key];
                    }
                    var obj = {
                      key: key === "11" || key === 11 ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                      value: funds.fundNavDirect.annualisedreturns[key]
                    };
                    returnsArray.push(obj);
                  });
                }
              }
              funds.directCagrReturns = returnsArray;
              if(funds.fundCode !== 'HDFCGF') {
                _this.directFunds.push(funds);
              }
            }
          });
          cb();
        }

        function changeFundsListing() {
          _this.isRegular = !_this.isRegular;
          _this.funds = _this.isRegular ? _this.regularFunds : _this.directFunds;
          if(angular.element(document.getElementsByClassName('filter-row')).hasClass('showSidebar')) {
            angular.element(document.getElementsByClassName('filter-row')).removeClass('showSidebar');
            _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
            _this.filterValues = [];
          }
        }

        function filterFunds(key, filterOptions) {

            var fundsToBeFiltered = _this.isRegular == false ? _this.regularFunds : _this.directFunds;
            filterOptions.forEach(function(option) {
              if (option.checked) {
                if (!_this.filterValues.includes(option.value)) {
                  _this.filterValues.push(option.value);
                }
              } else if (!option.checked && _this.filterValues.includes(option.value)) {
                var index = _this.filterValues.indexOf(option.value);
                if (index > -1) {
                  _this.filterValues.splice(index, 1);
                }
              }
            });
            if (_this.filterValues.length > 0) {
              if (key === 'timeHorizons') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.timeHorizon);
                });
              } else if (key === 'riskRatings') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.riskReturnProfile[0]);
                });
              } else if (key === 'goalTypes') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  if (funds.goalsType.length > 0) {
                    return isEqual(funds.goalsType, _this.filterValues);
                  }
                });
              } else if (key === 'fundCategories') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.fundCategory[0]);
                });
              }
              else {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds[key][0]);
                });
              }
              _this.funds = filteredFunds;
            } else {
              _this.funds = fundsToBeFiltered;
            }

        }

        function moveToCartDetails(fund) {
          _this.fundName = fund.fundName;
          _this.fundCode = fund.fundCode;
          _this.cartItem = {};
          _this.setFromData = false;
          _this.showSaveCart = false;
          setSideBarState('CART_DETAILS');
        }

        function searchRecords() {
          var fundsToBeFiltered = _this.isRegular == false ? _this.regularFunds : _this.directFunds;
          if (_this.allFormData.searchModel.length > 0) {
            var filteredFunds = fundsToBeFiltered.filter(function(fund) {
              return fund.fundName.toLowerCase().includes(_this.allFormData.searchModel.toLowerCase());
            });
            _this.funds = filteredFunds;
          } else {
            _this.funds = fundsToBeFiltered;
          }
        }

        /*--------------------------------------- ECART section starts from here -------------------------------------*/
        function fetchInvestmentAdded() {
          _this.cartDetails = _this.onlyHdfcUserOneClick? JSON.parse(localStorage.getItem('ecartItemsForHDFC')):JSON.parse(localStorage.getItem('ecartItems'));
          _this.maximumItemAllowed = _this.cartDetails.maximumItemAllowed;
          _this.investmentList = _this.cartDetails.cartItems;
          _this.investThroughFormData.riaBrokerCode = _this.investThroughFormData.riaBrokerCode ? _this.investThroughFormData.riaBrokerCode : _this.brokerTypeFromCookies.riaBrokerCode;
          _this.investThroughFormData.riaBrokerName = _this.investThroughFormData.riaBrokerName? _this.investThroughFormData.riaBrokerName: _this.brokerTypeFromCookies.riaBrokerName;
          if(_this.brokerTypeFromCookies.brokerCode) {
            _this.investThroughFormData.brokerCode = _this.investThroughFormData.brokerCode ? _this.investThroughFormData.brokerCode : _this.brokerTypeFromCookies.brokerCode;
            _this.investThroughFormData.brokerName = _this.investThroughFormData.brokerName ? _this.investThroughFormData.brokerName: _this.brokerTypeFromCookies.brokerName;
          } else if(_this.brokerTypeFromCookies.distributoName){
            var distributorNameArray = _this.brokerTypeFromCookies.distributoName.split('-');
            _this.investThroughFormData.brokerCode = distributorNameArray[distributorNameArray.length - 1];
            _this.investThroughFormData.brokerName = distributorNameArray[0];
          }
          _this.investThroughFormData.isThroughRia = _this.investThroughFormData.isThroughRia ? true : false;
          if(_this.cartDetails.cartItems) {
            var sum = 0;
            _this.totalSum = sum;
            _this.cartDetails.cartItems.forEach(function (item, index) {
              sum = sum + item.amount + item.installmentAmount;
            });
            _this.totalSum = sum;
          }
          $rootScope.$broadcast("CartCount", _this.cartDetails.cartItems.length);
        }

        function fetchSuggestion(cb) {
          cb = cb ||function () {
          };
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              _this.suggestionList = resp.data.trending;
              if(_this.suggestionList) {
                _this.suggestionList.forEach(function (key, index) {
                  _this.formData.yearSelected[index] = "11";
                  showCagrValue(index);
                })
                _this.suggestionList = _this.suggestionList.filter(function(item){
                  return item.fundCode !== 'HDFCGF'
                })
                _this.suggestionList = _this.suggestionList.slice(0,3);
                $timeout(function () {
                  handleTrendingFund();
                }, 50);
              }
              handleRiskRating(_this.suggestionList);
              cb();
              LoaderService.hideLoader();
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'trending'
          }).$promise.then(success, error);
        }

        function handleRiskRating(suggestionListRating){
          _this.ratingArray = [];
          if(suggestionListRating) {
            suggestionListRating.forEach(function (risk,index) {
              _this.ratingArray.push(risk.riskReturnProfile.replace('risk','').trim());
            })
          }
        }
        function showCagrValue(index) {
          Object.keys(_this.suggestionList[index].annualisedReturns).forEach(function (x, i) {
            if(_this.formData.yearSelected && x === _this.formData.yearSelected[index]) {
              _this.suggestionList[index].cagrValue = _this.suggestionList[index].annualisedReturns[x];
            }
          });
        }

        function addTrendingFund(suggestedFund){
          _this.suggestedFundData = suggestedFund;
          _this.fundName = suggestedFund.fundName;
          _this.fundCode = suggestedFund.fundCode;
          _this.formData.startDate = null;
          _this.cartItem = {};
          _this.showSaveCart = false;
          _this.checkFromTrendingFund = true;
          setSideBarState('CART_DETAILS');
        }


        function generateLink(){
          var success = function (resp) {
            LoaderService.hideLoader();
            if(resp.url){
              _this.url = resp.url;
              lineBreakUrl(_this.url);
              $window.scrollTo(0,180);

            }else{
              MessageService.error(resp.message);
            }
          },error = function (resp) {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          };
          LoaderService.showLoader();
          _this.dataPayloadForUrl = _this.getCartItems();
          if(_this.dataPayload){
            if($stateParams.x){
              _this.dataPayload.hdfcBank = true;
              _this.dataPayload.mfdFlowName = 'HDFC_ONE_CLICK';
            } else if ($stateParams.rm) {
              _this.dataPayload.mfdFlowName = 'EMPLOYEE';
            } else {
              _this.dataPayload.mfdFlowName = 'ONE_CLICK';
            }
            TransactionAddToCartService.post({controller1: "getShortUrl"},_this.dataPayloadForUrl).$promise.then(success, error);
          }else{
            MessageService.error("Something went wrong");
          }
        }

        _this.getCartItems = function(){

           _this.dataPayload = {} ;

          if(_this.brokerTypeFromCookies.brokerType == "MFD") {
            if(_this.brokerTypeFromCookies.euinCode) {
              var mfdEuinCode = 'E' +_this.brokerTypeFromCookies.euinCode;
              // var mfdEuinName = _this.brokerTypeFromCookies.euinCode.split('-')[0];
            }
            if(_this.brokerTypeFromCookies.brokerCode){
              var arnBrokerCode = _this.brokerTypeFromCookies.brokerCode ? 'ARN-'+ _this.brokerTypeFromCookies.brokerCode: '';
            } else if(_this.brokerTypeFromCookies.distributoName){
              var distributorNameArray = _this.brokerTypeFromCookies.distributoName.split('-');
              var arnBrokerCode = 'ARN-'+ distributorNameArray[distributorNameArray.length - 1];
            }
            _this.dataPayload = {
              arnCode:  arnBrokerCode,
              euin: mfdEuinCode,
              // euinName: mfdEuinName,
              key: _this.brokerTypeFromCookies.brokerType,
              cartItems: _this.addToCartItem.cartItems
            };
            if(_this.brokerTypeFromCookies.subBrokerARN == undefined || _this.brokerTypeFromCookies.subBrokerARN == null){
              _this.dataPayload.subBrokerArn = "";
            }
            if(_this.brokerTypeFromCookies.subBrokerArn){
              _this.dataPayload.subBrokerArn = "ARN-"+_this.brokerTypeFromCookies.subBrokerArn;
              _this.dataPayload.subBrokerCode = _this.brokerTypeFromCookies.subBrokerCode;
            }

            if(_this.brokerTypeFromCookies.euinCode){
              _this.dataPayload.euin = mfdEuinCode;
            }else{
              delete _this.dataPayload['euin'];
            }
            _this.dataPayload.utmSource = _this.brokerTypeFromCookies.utmsource ? _this.brokerTypeFromCookies.utmsource : '' ;
            _this.dataPayload.utmMedium = _this.brokerTypeFromCookies.utmmedium ? _this.brokerTypeFromCookies.utmmedium : '';
          }else if(_this.brokerTypeFromCookies.brokerType == "RIA"){
            _this.dataPayload = {
              riaCode : _this.brokerTypeFromCookies.riaBrokerCode,
              key:_this.brokerTypeFromCookies.brokerType,
              arnCode: 'ARN-DIRECT',
              cartItems: _this.addToCartItem.cartItems
            };
          }
          return _this.dataPayload;
        }

        function calculateValidations() {
          _this.validations = {};
          if(_this.sipValidation.additionalValidation && _this.sipValidation.additionalValidation.OM){
            var newValidation =  _this.sipValidation.additionalValidation.OM;
            for (var i = 0; i < newValidation.length; i++){
              var condition = _this.formData.installmentAmount < newValidation[i].min_amount_lower ||  _this.formData.installmentAmount <= newValidation[i].min_amount_upper
              if(!newValidation[i].min_amount_upper){
                var condition = true;
              }
              if(condition)
              {
                _this.validations.amountMultiples = newValidation[i].amt_multiples;
                _this.validations.maxAmount = newValidation[i].min_amount_upper;
                _this.validations.minAmount = newValidation[i].min_amount_lower;
                _this.validations.minInstallments = newValidation[i].min_installments;
                break;
              }
            }
          }
          _this.isMax = !!(_this.validations.maxAmount && _this.validations.maxAmount < _this.formData.installmentAmount);
          _this.isMin = !!(_this.validations.minAmount && _this.validations.minAmount > _this.formData.installmentAmount);
          _this.isMultiples = _this.validations.amountMultiples && _this.formData.installmentAmount && (_this.formData.installmentAmount % _this.validations.amountMultiples === 0) || false;

          if(_this.formData.installmentAmount >= 2000000){
            _this.amountExceeded = true;
          }else {
            _this.amountExceeded = false;
          }


          if (_this.purchaseValidation) {
            _this.isPurchaseMin = _this.purchaseValidation.minFirstPurchaseAmt > _this.formData.amount ;
            _this.purchaseMinAmount = _this.purchaseValidation.minFirstPurchaseAmt;
            _this.isMultiplesPurchase = _this.purchaseValidation.purchaseMultiple && _this.formData.amount  && (_this.formData.amount  % _this.purchaseValidation.purchaseMultiple === 0) || false;
            if(_this.formData.amount % 1 != 0){
              _this.isPurchaseAmountDecimal = true;
            }
            else{
              _this.isPurchaseAmountDecimal = false;
            }
          }
        }
        function nonArnAuth(cb) {
          cb = cb || function () {
          };
          var successLogin = function (resp) {
            sessionStorage.setItem('arnAuth',true);
            LoaderService.hideLoader();
            searchDistributor();
          },errorLogin = function(resp){
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
          var oauthpayload = {
            arnCode:'ARN-DIRECT',
            grant_type: 'password',
            panNumber: null,
            appType: 'W',
            type:'arn'
          };
          LoaderService.showLoader();
          cb(true)
          AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);


        }


        function authARN(cb) {
          cb = cb || function () {
          };
          var length = _this.investThroughFormData.brokerCode?_this.investThroughFormData.brokerCode.length:0;
          if(length>3)
          {
            var successLogin = function (resp) {
              sessionStorage.setItem('arnAuth',true);
              if(resp.access_token){
                LoaderService.hideLoader();
                if(_this.investThroughFormData.brokerCode){
                  searchDistributor();
                }
                _this.arnNotEmpanneled = true;
              }else{
                LoaderService.hideLoader();
                MessageService.error(resp.message);
                _this.arnNotEmpanneled = false;
              }
            },errorLogin = function(resp){
              LoaderService.hideLoader();
              MessageService.error(resp.message);
              _this.arnNotEmpanneled = false;
            }
            var oauthpayload = {
              arnCode: _this.investThroughFormData.brokerCode ? 'ARN-'+_this.investThroughFormData.brokerCode: _this.brokerTypeFromCookies.brokerCode,
              grant_type: 'password',
              panNumber: null,
              appType: 'W',
              type:'arn'
            };
            LoaderService.showLoader();
            cb(true)
            AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

          }
        }

        function editBrokerType(){
          _this.url = false;
          _this.brokerTypeChange = true;
          _this.fromOneClickScreen = false;
          setSideBarState('INVEST_THROUGH');
        }

        function saveCartFromOneClick(){
          if(_this.isBrokerTypeChange){
            _this.addToCartItem.cartItems = [];
          }
          addToCart();
        }

        _this.scrollToTop = function () {
          angular.element(document.getElementById('scrollTo')).animate({scrollTop: 2500}, 500);
          return false;
        };

        function authARNForSearchByDistributor(cb) {
          cb = cb || function () {
          };
          var replaceARN = _this.investThroughFormData.distributorARN.replace('ARN-');
          var length = _this.investThroughFormData.distributorARN ? replaceARN.length : 0;
          if(length>3)
          {
            var successLogin = function (resp) {
              sessionStorage.setItem('arnAuth',true);
              if(resp.access_token){
                _this.fetchEuinListThroughDistributor(_this.investThroughFormData.distributorARN);
                LoaderService.hideLoader();
              }else{
                LoaderService.hideLoader();
                MessageService.error(resp.message);
              }
            },errorLogin = function(resp){
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
            var oauthpayload = {
              arnCode: _this.investThroughFormData.distributorARN ? _this.investThroughFormData.distributorARN: _this.brokerTypeFromCookies.distributorARN,
              grant_type: 'password',
              panNumber: null,
              appType: 'W',
              type:'arn'
            };
            LoaderService.showLoader();
            cb(true)
            AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

          }
        }

        function fetchFundsFilters() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              var filters = resp.data;
              _this.filterList = [];
              Object.keys(filters).forEach(function(filter) {
                var filterOptions = [];
                filters[filter].forEach(function(option) {
                  var filterOption = {
                    key: option,
                    value: option,
                    checked: false
                  };
                  filterOptions.push(filterOption);
                });
                var obj = {
                  filterName: titleCase(filter),
                  filterKey: filter.replaceAll(" ", "") === 'riskRating' ? 'riskReturnProfile' : filter.replaceAll(" ", ""),
                  filterOptions: filterOptions
                };
                _this.filterList.push(obj);
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          TransactionEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'filter',
            child5: 'option'
          }).$promise.then(success, error);
        }

        function titleCase(str) {
          str = str.split(/(?=[A-Z])/);
          for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
          }
          return str.join(' ');
        }

        function isEqual(a, b) {
          var arr = [];
          for (var i = 0; i < b.length; i++) {
            if (a.includes(b[i])) {
              arr.push(true);
            } else {
              arr.push(false);
            }
          }
          return arr.includes(true);
        }

        function filterEuinList  () {
          if(_this.investThroughFormData.euinNameCode){
            $("#euin").css("text-transform", "uppercase");
          }else{
            $("#euin").css("text-transform", "capitalize");
          }

          if(_this.investThroughFormData.euinNameCode){
            _this.euinList = UtilService.getFilteredList(_this.euinMasterList, 'euinNameCode', _this.investThroughFormData.euinNameCode);
          }
          _this.euinList = _this.investThroughFormData.euinNameCode == '' || _this.investThroughFormData.euinNameCode == undefined ? _this.euinMasterList : _this.euinList;
          _this.isEuinValid = false;
        };

        function lineBreakUrl(url){
          _this.urlArray = url.split('com/');
        }

        _this.copyToClipboard = function(string) {
          navigator.clipboard.writeText(string)
            .then(MessageService.success("Link Copied"));
        }

        function fetchDynamicDataEcart(cb){
          cb = cb || function () {
          }
          var successHandler = function(resp) {
            _this.getNote = resp;
            cb(true)
          }

          UtilService.fetchDynamicData("SIP_PURCHASE_E_CART").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
        }

        function checkEnableEndDate(){
          _this.isEndDateFound = false;
          if(_this.enabledEndDates) {
            _this.enabledEndDates.forEach(function (item) {
              if (item.isSame(_this.formData.endDate)) {
                _this.isEndDateFound = true;
              }
            })
          }
          if (_this.formData.endDate && $window.moment(_this.tillPerpetuityEndDate).year() < 2099) {
            _this.enabledDefaultYear = false;
          } else {
            _this.enabledDefaultYear = true;
          }
        }

        function handleTrendingFund(){
          var tempFund = [];
          if(_this.cartDetails && _this.cartDetails.cartItems.length == 0) {
            _this.suggestionList.forEach(function(item,index){
              if(index < 3) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails && _this.cartDetails.cartItems.length == 1){
            _this.suggestionList.forEach(function(item,index){
              if(index < 2) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails && _this.cartDetails.cartItems.length == 2){
            _this.suggestionList.forEach(function(item,index){
              if(index < 1) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails && _this.cartDetails.cartItems.length == 3){
            _this.suggestionList.forEach(function(item,index){
              tempFund = [];
            })
          }
          _this.showingTrendingFunds = tempFund;
        }

        _this.autoDate = function(type){
          if(type=='startDate') {
            var oldlength = 0;
            if (_this.startDateString) {
              oldlength = _this.startDateString.length;
            }
            _this.startDateString = $("#startDateId").val();
            var newlength = _this.startDateString.length;
            if (_this.startDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }
            if (_this.startDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }

          } else if(type=='endDate'){
            var oldlength = 0;
            if (_this.endDateString) {
              oldlength = _this.endDateString.length;
            }
            _this.endDateString = $("#endDateId").val();
            var newlength = _this.endDateString.length;
            if (_this.endDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
            if (_this.endDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
          }
        }

        function showRecommendedFundOnTop(getAllFund){
          if(getAllFund) {
            getAllFund.sort(function (a, b) {
              if (a.recommended && !b.recommended) {
                return -1;
              } else if (!a.recommended && b.recommended) {
                return 1;
              } else {
                return 0;
              }
            });
            return getAllFund;
          }
        }

        function checkEuinValue(euinNameCode){
          _this.isEuinValid = false;
          _this.euinList.forEach(function(list){
            if(list.euinNameCode == euinNameCode){
              _this.isEuinValid = true;
            }
          })
        }

      }
    }
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('StoreInvestorModel', storeInvestorModel);

  /** @ngInject */
  function storeInvestorModel() {
    var data1= null;
    function getInvestorDetail() {
      return data1;
    }

    function setInvestorDetail(data) {
      data1 = data;
    }

    return {
      getInvestorDetail: getInvestorDetail,
      setInvestorDetail: setInvestorDetail
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('TransactionInitiateModel', transactionInitiateModel);

  /** @ngInject */
  function transactionInitiateModel() {

    var masterSipPayload = {
        "installmentAmount": '',
        "investmentOption": "GROWTH",//values , DIVIDEND
        "dividendOption": "Z",//Dividend option values - Y (Reinvest), N(Payout), Z(GROWTH)k
        "formType": "SIP",
        "frequency": "",//OM
        "folioNumber": "",
        "schemeCode": "",
        "toDate": '',//DD-MM-YYYY
        "sipDate": '',//DD-MM-YYYY
        "sipDay": ''//DD-MM-YYYY
      },
      masterPurchasePayload = {
        "amount": "",
        "dividendOption": "Z",
        "folioNumber": "",
        "formType": "PURCHASE",
        "schemeCode": ""
      },
      masterSipPurchasePayload = {
        folioNumber: '',
        isThroughDistributor: false,
        brokerCode: '',
        brokerName: '',
        euinName: '',
        euinOpted: 'Y',
        optionalInvestmentType: '',
        dividendOption: '',
        investmentOption: '',
        frequency: '',
        day: '',
        startDate: new Date(),
        endDate: new Date(),
        sipDay: '',
        sipPaymentOption: '',
        bankAcNo: '',
        ifscCode: '',
        bankBranch: '',
        bankCity: '',
        bankName: '',
        bankInfo: '',
        otmId: '',
        inSchemeCode: '',
        inSchemeName: '',
        purchaseAmount: '',
        purchaseDividendOption: '',
        purchaseInvestmentOption: '',
        purchasePaymentOption: '',
        pTransactionId: '',
        sTransactionId: '',
        isTillPerpetuity: false,
        isBackFromSummary: false,
        topupDetails: {frequency : 'H'},
        sipTopupSelected : false,
        minorFlag : false,
        cgfFlag : false,
        isEuin : true
    },
     // sipPurchasePayload = null,
      sipPayload = null,
      purchasePayload = null,
      investorPayload = null,
      investmentType = null,
      payload = null;
    var masterSipPurchaseBulkPayload = {
      isThroughDistributor: false,
      brokerCode: '',
      brokerName: '',
      euinName: '',
      euinOpted: 'Y',
      optionalInvestmentType: '',
      dividendOption: '',
      investmentOption: '',
      frequency: '',
      day: '',
      startDate: '',
      endDate: '',
      sipDay: '',
      sipPaymentOption: '',
      inSchemeCode: '',
      inSchemeName: '',
      purchaseDividendOption: '',
      purchaseInvestmentOption: '',
      purchasePaymentOption: '',
      schemeType: ''
    };

    function getSipDataModel() {
      return angular.copy(masterSipPayload);
    }

    function getPurchaseDataModel() {
      return angular.copy(masterPurchasePayload);
    }

    function getSipPurchaseDataModel() {
      return angular.copy(masterSipPurchasePayload);
    }

    function setSipPurchaseDataModel(_masterSipPurchasePayload) {
      masterSipPurchasePayload = _masterSipPurchasePayload && angular.copy(_masterSipPurchasePayload) || null;
    }

    function getPayload() {
      return angular.copy(payload);
    }

    function setPayload(_payload) {
      payload = _payload;
    }

    function getSipPayload() {
      return angular.copy(sipPayload);
    }

    function setSipPayload(_sipPayload) {
      sipPayload = _sipPayload && angular.copy(_sipPayload) || null;
    }

    function getPurchasePayload() {
      return angular.copy(purchasePayload);
    }

    function setPurchasePayload(_purchasePayload) {
      purchasePayload = _purchasePayload && angular.copy(_purchasePayload) || null;
    }

    function getInvestorPayload() {
      return angular.copy(investorPayload);
    }

    function setInvestorPayload(_investorPayload) {
      investorPayload = _investorPayload && angular.copy(_investorPayload) || null;
    }

    function getInvestmentType() {
      return angular.copy(investmentType);
    }

    function setInvestmentType(_investmentType) {
      investmentType = _investmentType && angular.copy(_investmentType) || null;
    }

    function getInitialspecificProperties() {
      var _initial = {};
      _initial.investmentMode = "Fixed";
      _initial.investmentModeData = {
        stage1: 9600,
        stage2: 10300,
        stage3: 8900,
        stage4: 8900,
        totalInvestment: 0
      };

      _initial.validations = {
        stage1: true,
        stage2: true,
        stage3: true,
        stage4: true,
        installment1: true,
        installment2: true,
        installment3: true,
        installment4: true,
        installmentsSumHundred: true
      };
      return _initial;
    }

    function getTotalInvesment(_investmentModeData) {
      var install1, install2, install3, install4;
      install1 = (install1 =  parseInt(_investmentModeData.installment1))?install1:0;
      install2 = (install2 =  parseInt(_investmentModeData.installment2))?install2:0;
      install3 = (install3 =  parseInt(_investmentModeData.installment3))?install3:0;
      install4 = (install4 =  parseInt(_investmentModeData.installment4))?install4:0;

      return install1+install2+install3+install4;
    }

    function getSipPurchaseBulkPayload() {
      return angular.copy(masterSipPurchaseBulkPayload);
    }

    function setSipPurchaseBulkPayload(_masterSipPurchaseBulkPayload) {
      masterSipPurchaseBulkPayload = _masterSipPurchaseBulkPayload && angular.copy(_masterSipPurchaseBulkPayload) || null;
    }

    return {
      getSipDataModel: getSipDataModel,
      getPurchaseDataModel: getPurchaseDataModel,
      getSipPurchaseDataModel: getSipPurchaseDataModel,
      setSipPurchaseDataModel: setSipPurchaseDataModel,
      getPurchasePayload: getPurchasePayload,
      setPurchasePayload: setPurchasePayload,
      getInvestorPayload: getInvestorPayload,
      setInvestorPayload: setInvestorPayload,
      getSipPayload: getSipPayload,
      getPayload: getPayload,
      setSipPayload: setSipPayload,
      setPayload: setPayload,
      getInvestmentType: getInvestmentType,
      setInvestmentType: setInvestmentType,
      getInitialspecificProperties : getInitialspecificProperties,
      getTotalInvesment : getTotalInvesment,
      getSipPurchaseBulkPayload: getSipPurchaseBulkPayload,
      setSipPurchaseBulkPayload: setSipPurchaseBulkPayload
    };
  }
})();

/**
 * Created by ttn on 2/6/17.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory("FlexIndexFactory",flexIndexFactory);

  /** @ngInject */
  function flexIndexFactory() {
    var service = {};
    service.getInitialspecificProperties = getInitialspecificProperties;
    service.getTotalInvesment = getTotalInvesment;

    return service;

    //////////////////////////////////////////////////////////
    function getInitialspecificProperties() {
      var _initial = {};
      _initial.investmentMode = "Fixed";
      _initial.investmentModeData = {
        stage1: 9600,
        stage2: 10300,
        stage3: 8900,
        stage4: 8900,
        totalInvestment: 0
      };

      _initial.validations = {
        stage1: true,
        stage2: true,
        stage3: true,
        stage4: true,
        installment1: true,
        installment2: true,
        installment3: true,
        installment4: true,
        installmentsSumHundred: true
      };
      return _initial;
    }

    function getTotalInvesment(_investmentModeData) {
      var install1, install2, install3, install4;
      install1 = (install1 =  parseInt(_investmentModeData.installment1))?install1:0;
      install2 = (install2 =  parseInt(_investmentModeData.installment2))?install2:0;
      install3 = (install3 =  parseInt(_investmentModeData.installment3))?install3:0;
      install4 = (install4 =  parseInt(_investmentModeData.installment4))?install4:0;

      return install1+install2+install3+install4;
    }

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InitiateTransactionController', initiateTransactionController);

  /** @ngInject */
  function initiateTransactionController(UtilService, LoaderService, AuthService, DownloadReportsService, HDFC_API, MessageService, FileSaver, Blob) {
    var vm = this;
    vm.downloadReport = downloadReport;
    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    function downloadReport(folioNumber,outSchemeCode) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            /*var file = new Blob([resp.data], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            var link = $window.document.createElement("a");
            link.target = '_blank';
            link.download = 'exitLoad';
            link.href = fileURL;

            $window.document.body.appendChild(link);
            link.style = "display: none";
            link.click();
            $window.document.body.removeChild(link);*/

            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, 'exitLoad.pdf');
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "folioNumber": folioNumber,
        "schemeCode": outSchemeCode,
        "commonReportCO": {
          "docDestination": "download"
        }
      };

      // DownloadPdfService.downloadFile(payload).then(success, error);
      var url= HDFC_API.VERSION +'/statement/exitLoad';
      DownloadReportsService.downloadFile(url,payload).then(success, error);
    }


  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipRenewTransactionController', SipRenewTransactionController);

  /** @ngInject */
  function SipRenewTransactionController($window, LoaderService, InvestorsCommonService, MessageService, $state,
                                         ModalService, UtilService, moment, SchemeService, AppConstants, $timeout, $scope ) {
    var vm = this;
    $scope.$parent.SipRenew.tabs[0].active = true;
    $scope.$parent.SipRenew.tabs[1].active = false;
    /*transaction renew tab variable declaration starts from here*/
    vm.contants = AppConstants;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.STATUS_YEAR = AppConstants.STATUS_YEAR;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.isLoading = false;
    vm.isPagination = false;
    vm.checked = false;
    vm.searchText = "";
    vm.viewMode = 'days';
    vm.SIP_FREQ_LIST = AppConstants.Dynamic_BULK_SIP_FREQ_LIST;
    vm.dateFilter = {startDate: null, endDate: null};
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.currentPageSystematicList = 1;
    vm.enableSelectAll = false;
    var renewPayload = {
      'fromDate': '',
      'pageIndex': vm.currentPageSystematicList,
      'pageLimit': vm.selectedPageLimit,
      'searchText': vm.searchText,
      'sortKey': 'START_DATE',
      'sortValue': 'DESC',
      'toDate': ''
    };

    vm.transactionList = [];
    vm.transactionListSelected = [];
    vm.transactionListSelectedCopy = [];
    vm.startMaxDate = $window.moment().clone().add(3, "months");
    vm.endMaxDate = $window.moment().clone().add(1, "minutes").add(3, 'months');
    vm.viewDate = vm.startMaxDate.clone();
    vm.todayDate = null;
    vm.transactionSettings = { showCheckAll: false, showUncheckAll: false,
      displayProp: 'value', idProp: 'code', dynamicTitle: true,
      groupByTextProvider: function(groupValue) {
        if (groupValue === 'SIP') {
          return 'Payment Mode for SIP Registration';
        } else {
          return 'Payment Mode for First Installment of SIP';
        }
      }
    };
    vm.transactionTranslationTexts = {buttonDefaultText: 'Payment Mode'};

    /*transaction renew tab methods declaration starts from here*/
    vm.init = init();
    vm.fetchSipRenewTransactionList = fetchSipRenewTransactionList;
    vm.searchList = searchList;
    vm.calculateEndDate = calculateEndDate;
    vm.resetDateFilter = resetDateFilter;
    vm.changeFilterEndDate = changeFilterEndDate;
    vm.changeFilterStartDate = changeFilterStartDate;
    vm.limitChanged = limitChanged;
    vm.reInitSipRenew = reInitSipRenew;
    vm.validateAmount = validateAmount;
    vm.addToSelectedList = addToSelectedList;
    vm.reInitPayload = reInitPayload;
    vm.termsAndContitions = termsAndContitions;
    vm.cancelTransaction = cancelTransaction;
    vm.submitRenewTransactions = submitRenewTransactions;
    vm.changeFirstInstallment= changeFirstInstallment;
    vm.showAmtExceedMsg = showAmtExceedMsg;
    vm.upiErrorMessage = "Unified Payments Interface (UPI) transaction limit as per NPCI is Rs. 1 lakh per transaction, while your purchase transaction amount is more than Rs. 1 lakh. Please select other payment mode to proceed.";
    vm.upiAmountLimit = 100000;
    vm.upiMaxYear = 30;
    var fromChangeFiStartDate = null;
    var fromChangeFiEndDate = null;
    function init() {
      fetchSipRenewTransactionList(renewPayload);
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });
    }

    function reInitSipRenew() {
      vm.checked = false;
      fetchSipRenewTransactionList(renewPayload);
    }

    /*
    * function responsible to fetch all the SIP available for renew
    * */
    function fetchSipRenewTransactionList(payload) {
      LoaderService.showLoader(".siprenew");
      var success = function(resp) {
        LoaderService.hideLoader(".siprenew");
        if (resp && resp.data) {
          vm.todayDate = resp.data.currentDate;
          vm.totalSystematicListData = resp.data.totalCount;
          vm.transactionList = resp.data.sipdtoList;
          vm.upiErrorMessage = (resp.data.sipSettings && resp.data.sipSettings.sipUPIMaxAmountErrMessage) ? resp.data.sipSettings.sipUPIMaxAmountErrMessage : vm.upiErrorMessage;
          vm.upiAmountLimit = (resp.data.sipSettings && resp.data.sipSettings.upi  && resp.data.sipSettings.upi.maxAmountLimit) ? resp.data.sipSettings.upi.maxAmountLimit : vm.upiAmountLimit;
          vm.upiMaxYear = (resp.data.sipSettings && resp.data.sipSettings.upi  && resp.data.sipSettings.upi.maxMandateDurationYears) ? resp.data.sipSettings.upi.maxMandateDurationYears : vm.upiMaxYear;
          var transaction = angular.copy(vm.transactionList);
          for (var i = 0 ; i < transaction.length ; i ++) {
            
            // var isOtmExist = transaction[i].paymentOption.find(function (el) {
            //   return el.code === 'OTM'
            // });
            //
            // var isEmandateExist = transaction[i].paymentOption.find(function (el) {
            //   return el.code === 'HEM'
            // });
            
            var isOtmExist = paymentOptionArrayMethod(transaction[i].paymentOption, 'OTM', 'find');
            var isEmandateExist = paymentOptionArrayMethod(transaction[i].paymentOption, 'HEM' , 'find');
            var isUpiExist = paymentOptionArrayMethod(transaction[i].paymentOption, 'UAP' , 'find');
            vm.transactionList[i].isOtmExist = isOtmExist;
            vm.transactionList[i].isEmandateExist = isEmandateExist;
            vm.transactionList[i].isUpiExist = isUpiExist;
            vm.transactionList[i].isExceedingUpiDate = false;
          }

          vm.emandateSettings = resp.data.sipSettings && resp.data.sipSettings.eOTM ? resp.data.sipSettings.eOTM : {};
          vm.emandateSettings.maxMandateDurationYears = vm.emandateSettings.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;;
          vm.transactionList.forEach(function(item,index) {
            if (item.autoFrequency  === 'Daily'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.BZ;
            }
            if (item.autoFrequency  === 'Weekly'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.OW;
            }
            if (item.autoFrequency  === 'Quarterly'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.Q;
            }
            if (item.autoFrequency  === 'Monthly'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.OM;
            }
            if (item.autoFrequency  === 'Half Yearly'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.H;
            }
            if (item.autoFrequency  === 'Yearly'){
              vm.transactionList[index].additionalValidation = item.additionalValidation.Y;
            }
            if(item.amount >= 2000000){
              vm.transactionList[index].amountExceeded = true;
             }else {
              vm.transactionList[index].amountExceeded = false;
            }
            (item.amount > vm.upiAmountLimit) ? vm.transactionList[index].isUpiAmountExceeding =true : vm.transactionList[index].isUpiAmountExceeding =false;
            setMinInstallments(item,false);
          });
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          manipulateResponse(); // used to insert checkbox model, bind action to records, identify dates etc
        } else {
          vm.totalSystematicListData = 0;
          vm.transactionList = [];
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        LoaderService.hideLoader(".siprenew");
        MessageService.error(resp.message);
      };
      payload.pageIndex = vm.currentPageSystematicList - 1;
      payload.pageLimit = vm.selectedPageLimit;
      payload.searchText = vm.searchText;
      InvestorsCommonService.post({
        child1: 'get',
        child2: 'expired',
        child3: 'systematic'
      }, payload).$promise.then(success, failure);
    }

    /*
    * Helper function definations starts from here
    * */
    /* sip renew transaction header functions*/
    function searchList() {
      if (!vm.isSearching && (vm.searchText.length > 3 || vm.searchText == '')) {
        vm.isSearching = true;
        vm.currentPageSystematicList = 1;
        fetchSipRenewTransactionList(renewPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    }

    function changeFilterEndDate(date) {
      vm.dateFilter.endDate = date ? date: null;
      vm.startMaxDate = date ? date: vm.responseDate;
      if (!date) {
        vm.endMinDate = null;
      }
      if (vm.dateFilter.endDate && renewPayload.toDate !== vm.dateFilter.endDate.format("DD-MMM-YYYY")) {
        reInitPayload();
        fetchSipRenewTransactionList(renewPayload);
      }
    }

    function changeFilterStartDate(date) {
      vm.dateFilter.startDate = date ? date: null;
      if (date) {
        calculateEndDate();
      }
      if (vm.dateFilter.startDate && renewPayload.fromDate !== vm.dateFilter.startDate.format("DD-MMM-YYYY")) {
        reInitPayload();
        fetchSipRenewTransactionList(renewPayload);
      }
    }

    function setMinInstallments(data,item){
      var newValidation = data.additionalValidation;
      if(newValidation) {for (var i=0; i<newValidation.length;i++){
      var condition = data.amount < newValidation[i].min_amount_lower ||  data.amount <= newValidation[i].min_amount_upper;
      if(!newValidation[i].min_amount_upper){
        var condition=data.amount >= newValidation[i].min_amount_lower
      }
            if(condition)
            {
              data.minInstallments = newValidation[i].min_installments;
              break;
            }
      }}
      if(item){
        changeStartDate(data,data.startViewDate);
      }
    }
    function changeStartDate(transaction, date) {
      transaction.startViewDate = date ? date : null;
      if (date) {
        transaction.selected = false;
        transaction.endViewDate = null;
        $timeout(function() {
          transaction.enabledEndDates = identifyEndDates(transaction);
          transaction.minEndDate = transaction.enabledEndDates[0].clone();
          transaction.maxEndDate = transaction.enabledEndDates[transaction.enabledEndDates.length -1].clone();
          transaction.viewDate = transaction.minEndDate.clone();
          if (transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM || transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UAP) {
            if(fromChangeFiEndDate) {
              transaction.endViewDate = fromChangeFiEndDate;
            }
            fromChangeFiEndDate = null;
            (transaction.endViewDate && moment(transaction.endViewDate).isSameOrBefore(transaction.maxEndDate) && transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UAP) ? 
              transaction.changeEndDate(transaction.endViewDate)
            :
            transaction.changeEndDate(transaction.maxEndDate);
          }
          if(transaction.isUpiExist ) {
            var paymentModeIndex = paymentOptionArrayMethod(transaction.paymentOption , 'UAP', 'findIndex');
            
            if(paymentModeIndex === -1) {
              transaction.paymentOption.splice(0, 0, { code: 'UAP', value: 'UPI Autopay' });
              if(!checkIsExceedingUpiDate(transaction)) transaction.paymentModeSelected = transaction.paymentOption[0];
            }
          }
        });
        addToSelectedList(transaction);
      }
      if (transaction.endViewDate && transaction.startViewDate && checkAmountValidation(transaction)) {
        vm.enableSelectAll = true;
      } else {
        vm.enableSelectAll = false;
      }
    }

    function changeEndDate(transaction, date) {
      if (date) {
        transaction.endViewDate = date ? date : null;
      }
      if(transaction.endViewDate && transaction.startViewDate && transaction.isUpiExist) {
        transaction.isExceedingUpiDate = checkIsExceedingUpiDate(transaction);
        if (transaction.isExceedingUpiDate && transaction.paymentModeSelected.code === "UAP") { 
          changePaymentModeFromUpi(transaction,true) 
        }
        else {
          if (!transaction.isExceedingUpiDate) {
            var paymentModeIndex = paymentOptionArrayMethod(transaction.paymentOption , 'UAP', 'findIndex');
            if (paymentModeIndex === -1) {
              transaction.paymentOption.splice(0, 0, { code: 'UAP', value: 'UPI Autopay' });
              transaction.paymentModeSelected = transaction.paymentOption[0];
            }
          }
        }
      }
      if (transaction.endViewDate && transaction.startViewDate && checkAmountValidation(transaction)) {
        vm.enableSelectAll = true;
      } else {
        vm.enableSelectAll = false;
      }
    }

    function calculateEndDate() {
      if (!vm.dateFilter.endDate) {
        vm.dateFilter.endDate = vm.endMaxDate;
      }
      vm.endMinDate = vm.dateFilter.startDate;
      vm.enabledEndDatesList = [];
      var diff = vm.endMaxDate.diff(vm.dateFilter.startDate, 'days');
      for (var i = 0; i <= diff; i++) {
        var indexDate = vm.dateFilter.startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
        vm.enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
      }
    }

    function reInitPayload() {
      renewPayload.fromDate = vm.dateFilter.startDate ? moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
      renewPayload.pageIndex = vm.currentPageSystematicList;
      renewPayload.pageLimit = vm.selectedPageLimit;
      renewPayload.toDate = vm.dateFilter.endDate ? moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
    }

    function resetDateFilter() {
      $timeout(function() {
        vm.startMaxDate = $window.moment().clone().add(3, "months");
      });
      vm.viewDate = vm.startMaxDate.clone();
      changeFilterStartDate(null);
      changeFilterEndDate(null);
      reInitPayload();
      fetchSipRenewTransactionList(renewPayload);
    }

    function limitChanged() {
      vm.currentPageSystematicList = 1;
      renewPayload.pageIndex = vm.currentPageSystematicList;
      renewPayload.pageLimit = vm.selectedPageLimit;
      fetchSipRenewTransactionList(renewPayload);
    }

    function changePaymentMode(transaction) {
      if(transaction.paymentModeSelected) {
        if(transaction.paymentModeSelected.code === "UAP" && transaction.isUpiAmountExceeding) {
          var success = function() {
            changePaymentModeFromUpi(transaction)
          }
          ModalService.genericModal({
            text: vm.upiErrorMessage
          },success);
        }
        $timeout(function() {
          transaction.enabledStartDates = identifyStartDate(transaction);
        });
      }
      transaction.selected = false;
      addToSelectedList(transaction);
    }

    function validateAmount(list) {
      list.endViewDate = null;
      if(list.amount){
        list.isMinAmount = list.amount < list.additionalValidation[0].min_amount_lower;
      }
      if(!list.isMinAmount){
       setMinInstallments(list,true);
      }
      list.amountMultiple = list.amount % list.minAmountMultiple !== 0 || false;
      if(!list.amount || (list.amount < list.minAmount) || (!list.isMinAmount && list.amountMultiple)) {
        list.selected = false;
        addToSelectedList(list);
      }
      if (list.endViewDate && list.startViewDate && checkAmountValidation(list)) {
        vm.enableSelectAll = true;
      } else {
        vm.enableSelectAll = false;
      }
      if(list.amount >= 2000000){
        list.amountExceeded = true;
      }else {
        list.amountExceeded = false;
      }
      
      if(list.isUpiExist && list.amount > vm.upiAmountLimit) {
        list.isUpiAmountExceeding = true;
        changePaymentMode(list);
      }
      else {
        list.isUpiAmountExceeding = false;
      }
    }

    function manipulateResponse() {
      LoaderService.showLoader(".siprenew");
      vm.transactionList.map(function(transaction) {
        transaction.endViewDate = null;
        transaction.startViewDate = null;
        transaction.pan = UtilService.decryptPanNumber(transaction.pan);
        transaction.paymentModeSelected = transaction.paymentOption ? transaction.paymentOption[0]: null;
        transaction.changePaymentMethod = changePaymentMode.bind(null, transaction);
        transaction.isMinAmount = false;
        transaction.amountMultiple = false;
        transaction.kycVerificationSuccess = true;
        transaction.sipWithFirstInstallment = false;
        transaction.paymentOption.forEach(function(paymentMode) {
          paymentMode.category =  'SIP';
        });
        if (transaction.eKycStatus !== undefined && !transaction.eKycStatus) {
          transaction.kycVerificationSuccess = false;
          transaction.kycVerificationMessage = transaction.eKycMessage;
        } else if (!transaction.sKycStatus) {
          transaction.kycVerificationSuccess = false;
          transaction.kycVerificationMessage = transaction.message;
        }
        switch(transaction.autoFrequency) {
          case "Monthly":
            transaction.minInstallments = transaction.monthlyMinInstallment;
            transaction.maxInstallments = transaction.monthlyMaxInstallment;
            transaction.minAmountMultiple= transaction.monthlyAmountMultiple;
            break;
          case "Quarterly":
            transaction.minInstallments = transaction.quaterlyMinInstallment;
            transaction.maxInstallments = transaction.quaterlyMaxInstallment;
            transaction.minAmountMultiple= transaction.quarterlyAmountMultiple;
            break;
        }
        transaction.minAmount = transaction.additionalValidation ? transaction.additionalValidation[0].min_amount_lower : 0;
        transaction.enabledEndDates = [];
        transaction.changeStartDate = changeStartDate.bind(null, transaction);
        transaction.changeEndDate = changeEndDate.bind(null, transaction);
        //transaction.changeFirstInstallment = changeFirstInstallment.bind(null, transaction);
        changePaymentMode(transaction);

        transaction.investmentOption = transaction.growth ? AppConstants.TRANSACTION.GROWTH : (transaction.investmentOption !== AppConstants.TRANSACTION.GROWTH && transaction.investmentOption || AppConstants.TRANSACTION.DIVIDEND);
        if (transaction.growth) {
          transaction.dividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
        } else {
          if (transaction.dividendPayoutApplicable === true && transaction.dividendReinvestmentApplicable === false) {
            transaction.dividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
          } else if (transaction.dividendPayoutApplicable === false && transaction.dividendReinvestmentApplicable === true) {
            transaction.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
          } else if (transaction.dividendPayoutApplicable === true && transaction.dividendReinvestmentApplicable === true) {
            transaction.dividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
          }
        }
        transaction.selected = false;
        checkForAlreadySelected(transaction);
      });
      LoaderService.hideLoader(".siprenew");
    }

    function identifyStartDate(transaction) {
      var currentDate = $window.moment(vm.todayDate, "DD-MMM-YYYY");
      var enabledDates = [];
      var startDate = "";
      var paymodeKey = transaction.paymentModeSelected.code;
      var startMaxDate = null;
      if ($window.moment(transaction.endDate).isAfter(currentDate.format("DD-MMM-YYYY")) || $window.moment(transaction.endDate).isSame(currentDate.format("DD-MMM-YYYY"))) {
        startDate = $window.moment(transaction.endDate).add(1, 'months');
        startMaxDate = $window.moment(startDate).add(90, 'days');
        var freq = $window.moment(startMaxDate).diff(startDate, 'days');
        for (var i = 0; i <= freq; i++) {
          var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
          enabledDates.push(indexDate);
        }
      } else {
        startMaxDate = $window.moment(currentDate, "DD-MMM-YYYY").add(90, 'days');
        if (paymodeKey === 'EC') {
          startDate = $window.moment(currentDate, "DD-MMM-YYYY").add(transaction.sipTDay, 'days'); // T+17+2
          var freq = $window.moment(startMaxDate).diff(startDate, 'days');
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            enabledDates.push(indexDate);
          }
          transaction.minViewDate = enabledDates[0];
        } else if (paymodeKey === 'OTM' || paymodeKey === "HEM" || paymodeKey === "UAP") {
          //startDate = $window.moment(currentDate, "DD-MMM-YYYY").add(7, 'days'); // T+7
          startMaxDate = $window.moment(currentDate, "DD-MMM-YYYY").add(90, 'days');
          startDate = currentDate.clone();
          var freq = $window.moment(startMaxDate).diff(startDate, 'days');
          var counter=0;
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            if(counter<7)
            {
              angular.isArray(transaction.businessDates) && transaction.businessDates.forEach(function (value) {
                if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
                  isEnable = false;
                }
              });
            }
            if(isEnable){
              enabledDates.push(indexDate);
              counter++;
            }
          }
          enabledDates = enabledDates.splice(7, enabledDates.length); //T+5+2
          transaction.minViewDate = enabledDates[0];
        }
      }

      if(fromChangeFiStartDate) {
       var enabledLastDate = moment(enabledDates[enabledDates.length - 1], "DD-MMM-YYYY")
        if(moment(transaction.startViewDate).isSameOrBefore(enabledLastDate)) {
          enabledDates[0] = transaction.startViewDate;
        }
        fromChangeFiStartDate = null;
      }
      changeStartDate(transaction, enabledDates[0]);
      return enabledDates;
    }

    function identifyEndDates(transaction) {
      var defaultEndDate = transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? moment((transaction.startViewDate), "DD-MMM-YYYY").add(vm.emandateSettings.maxMandateDurationYears, 'years') :
          transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.UAP ? moment((transaction.startViewDate), "DD-MMM-YYYY").add(vm.upiMaxYear, 'years') : moment((vm.todayDate), "DD-MMM-YYYY").add(99, 'years');
      var defaultMonths = null;
      var endDate = null;
      var enabledEndDates = [];
      var freq = transaction && transaction.maxInstallments || 0;
      var i = 0, minInstallments = 1;
      vm.selectedFrequency = vm.SIP_FREQ_LIST.filter(function(frequency) {
        return frequency.name === transaction.autoFrequency;
      });
      vm.selectedFrequency = vm.selectedFrequency[0];
      var installment = null;
      switch (vm.selectedFrequency.code) {
        case 'BZ':
          var days = 0;
          endDate = transaction.startViewDate && $window.moment(transaction.startViewDate, "DD-MMM-YYYY").clone().add(vm.selectedFrequency.duration, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, moment(defaultEndDate));
          var days = getMonthsCount(endDate.clone(), defaultEndDate);
          freq = transaction.paymentModeSelected.code === AppConstants.TRANSACTION.PAYMENT_OPTIONS.HEM ? defaultEndDate.diff($window.moment(transaction.startViewDate, "DD-MMM-YYYY"), 'days', true) : ((defaultMonths * 30) / vm.selectedFrequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = vm.selectedFrequency.duration * i;
            enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          break;
        default :
        var months = 0;
        defaultMonths = UtilService.getNumberOfMonths($window.moment(transaction.startViewDate, "DD-MMM-YYYY"), moment(defaultEndDate));
        freq = freq || (defaultMonths / vm.selectedFrequency.duration);
        for (i = 0; i < freq; i++) {
          months = vm.selectedFrequency.duration * i;
          enabledEndDates.push($window.moment(transaction.startViewDate, "DD-MMM-YYYY").clone().add(months, 'months'));
        }
          break;
      }

      if (!installment) {
        minInstallments = transaction && transaction.minInstallments && (transaction.minInstallments - 1) || 0;
        enabledEndDates = enabledEndDates.slice(minInstallments);
      } else {
        enabledEndDates = enabledEndDates;
      }
      return enabledEndDates;
    }

    function addToSelectedList(list, event) {
      if (list === "ADD_ALL_CURRENT") {
        if (event) {
          vm.transactionList.map(function(currentList) {
            if (currentList.endViewDate && currentList.startViewDate && checkAmountValidation(currentList)) {
              currentList.selected = true;
            }
          });
          if (vm.transactionListSelected.length > 0) {
            vm.transactionListSelected.push(vm.transactionList.filter(function(transaction) {
              return transaction.selected === true;
            }));
          } else {
            vm.transactionListSelected = vm.transactionList.filter(function(transaction) {
              return transaction.selected === true;
            });
          }
          vm.transactionListSelectedCopy = vm.transactionListSelected;
        } else {
          vm.transactionList.map(function(currentList) {
            currentList.selected = false;
          });
          vm.transactionListSelected = [];
          vm.transactionListSelectedCopy = vm.transactionListSelected;
        }
      } else {
        var found = vm.transactionListSelected.some(function(transactionSelected) { // to check if array already contains value
          return transactionSelected.transactionID === list.transactionID;
        });
        if (!found && list.selected) {
          vm.transactionListSelected.push(list);
          vm.transactionListSelectedCopy = vm.transactionListSelected;
          vm.checked = vm.transactionListSelected.length === vm.transactionList.length || false;
        } else if (!list.selected) {
          vm.checked = false;
          vm.transactionListSelected = vm.transactionListSelected.filter(function(transactionList) { // to remove value from array
            return transactionList.transactionID !== list.transactionID;
          });
        }
      }
    }

    function termsAndContitions() {
      ModalService.termConditionModal({});
    }

    function cancelTransaction() {
      var success = function () {
        $state.go('main.dashboard');
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Are you sure, you want to cancel this action?'}, success, error);
    }

    function submitRenewTransactions() {
      LoaderService.showLoader(".siprenew");
      var success = function(resp) {
        LoaderService.hideLoader(".siprenew");
        if (resp && resp.data) {
          if(resp.data.trnxActionFlag == false) {
            ModalService.genericModal({
              panErrorText: resp.data.trnxActionMsg
            }, function() {

              resp.data.data.forEach(function(txnId) {
                vm.transactionList.forEach(function(el) {
                  if(el.transactionID == txnId) {
                    el.selected = false;
                    addToSelectedList(el);
                  }
                })
              })


              for(var i = 0 ; i < resp.data.data.length ; i++) {
                for(var j = 0; j < vm.transactionListSelected.length ; j++) {
                  if(vm.transactionListSelected[j].transactionID == resp.data.data[i]) {
                    vm.transactionListSelected.splice(j,1)
                  }
                }
              }

              vm.transactionListSelectedCopy = vm.transactionListSelected;

            }, function() {});
          } else {
              ModalService.initiateSuccessModal({
                transactionType: "BULK_SIP"
              }, function() {
                $state.reload();
              });
          }
        } else {
            MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        LoaderService.hideLoader(".siprenew");
        MessageService.error(resp.message);
      };
      var payload = getSubmissionPayload();
      InvestorsCommonService.post({
        child1: 'transaction',
        child2: 'many',
        child3: 'initiate'
      }, payload).$promise.then(success, failure);
    }

    function getSubmissionPayload() {
      var payload = [];
      vm.transactionListSelected.forEach(function(transaction) {
        if (transaction.selected) {
          var selectedFrequency = vm.SIP_FREQ_LIST.filter(function(frequency) {
            return frequency.name === transaction.autoFrequency;
          });
          selectedFrequency = selectedFrequency[0];
          var transactionObject = {
            "installmentAmount": transaction.amount,
            "investmentOption": transaction.investmentOption,
            "dividendOption": transaction.dividendOption,
            "formType": "SIP",
            "frequency": selectedFrequency.code,
            "folioNumber": transaction.folioNumber,
            "schemeCode": transaction.schemeCode,
            "schemeType": transaction.schemeType,
            "sipDay": null,
            "toDate": transaction.endViewDate.format("DD-MMM-YYYY"),
            "sipDate": $window.moment(transaction.startViewDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
            "payMech": transaction.paymentModeSelected.code,
            "bulkSIP": true,
            "oldTransactionId": transaction.transactionID
          };
          if (transaction.sipWithFirstInstallment) {
            transactionObject.sipWithFirstInstallment = transaction.sipWithFirstInstallment;
            transactionObject.firstInstallmentDetails = {};
            (transaction.paymentModeSelected.code === 'UAP') ? transactionObject.firstInstallmentDetails.paymentMode = 'UPI' : transactionObject.firstInstallmentDetails.paymentMode = transaction.paymentModeSelected.code;
          }
          transactionObject.payMech = transaction.paymentModeSelected.code;
          payload.push(transactionObject);
        }
      });
      return payload;
    }

    function checkForAlreadySelected(transaction) {
      if (vm.transactionListSelectedCopy.length > 0) {
        vm.transactionListSelectedCopy.map(function(selectedTransaction) {
          if (selectedTransaction.transactionID === transaction.transactionID) {
            $timeout(function() {
              transaction.selected = true;
              transaction.endViewDate = selectedTransaction.endViewDate;
              addToSelectedList(transaction);
            }, 100);
          }
        });
      }
    }

    function checkAmountValidation(list) {
      list.isMinAmount = list.amount < list.minAmount;
      list.amountMultiple = list.amount % list.minAmountMultiple !== 0 || false;
      if(!list.amount || (list.amount < list.minAmount) || (!list.isMinAmount && list.amountMultiple) || (list.amount >= 2000000)) {
        return false
      }
      return true;
    }

    function changeFirstInstallment(transaction) {
      var transactionList= vm.transactionList;
      var paymentOptions = null;
      if (transaction.sipWithFirstInstallment) {
       for (var i=0; i<=transactionList.length;i++){
         if(transactionList[i].transactionID==transaction.transactionID){

           if (transactionList[i].isOtmExist) {
             paymentOptions = [
                 {code: 'OTM', value: 'OTM (One Time Mandate)'},
                 {code: 'EC', value: 'Standing Instruction/Biller'}
               ];
           } else {
             paymentOptions = [
               {code: 'EC', value: 'Standing Instruction/Biller'}
             ];
           }
           if (transactionList[i].isUpiExist) {
             paymentOptions.splice(0, 0, { code: 'UAP', value: 'UPI Autopay' });
           }

           transaction.paymentOption = paymentOptions;
           transaction.paymentModeSelected= paymentOptions[0];
           if(transaction.paymentModeSelected.code === 'UAP') {
             fromChangeFiStartDate = transaction.startViewDate;
             fromChangeFiEndDate = transaction.endViewDate;
               changePaymentMode(transaction);
           }
         }
       }
      } else {
        for (var j=0; j<=transactionList.length; j++){
          if(transactionList[j].transactionID==transaction.transactionID){

            if (transactionList[j].isOtmExist && transactionList[j].isEmandateExist) {
              paymentOptions = [
                {code: 'OTM', value: 'OTM (One Time Mandate)'},
                {code: 'EC', value: 'Standing Instruction/Biller'},
                {code: 'HEM', value: 'Register E-mandate (eOTM)'}
              ];
            } else if(transactionList[j].isOtmExist && !transactionList[j].isEmandateExist) {
              paymentOptions = [
                {code: 'OTM', value: 'OTM (One Time Mandate)'},
                {code: 'EC', value: 'Standing Instruction/Biller'}
              ];
            } else if (!transactionList[j].isOtmExist && transactionList[j].isEmandateExist) {
              paymentOptions = [
                {code: 'EC', value: 'Standing Instruction/Biller'},
                {code: 'HEM', value: 'Register E-mandate (eOTM)'}
              ];
            } else if(!transactionList[j].isOtmExist && !transactionList[j].isEmandateExist) {
              paymentOptions = [
                {code: 'EC', value: 'Standing Instruction/Biller'}
              ];
            }
            if (transactionList[j].isUpiExist) {
              (paymentOptions) ? paymentOptions.splice(0, 0, { code: 'UAP', value: 'UPI Autopay' }) : paymentOptions = [{code: 'UAP', value: 'UPI Autopay' }]
            }
            transaction.paymentOption = paymentOptions;
            transaction.paymentModeSelected= paymentOptions[0];
            if(transaction.paymentModeSelected.code === 'UAP') {
              fromChangeFiStartDate = transaction.startViewDate;
              fromChangeFiEndDate = transaction.endViewDate;
              changePaymentMode(transaction);
            }
          }
        }
        // var paymentOptions =[{code: 'OTM', value: 'OTM (One Time Mandate)'},
        //   {code: 'EC', value: 'Standing Instruction/Biller'},
        //   {code: 'HEM', value: 'Register E-mandate (eOTM)'}
        // ];
        // transaction.paymentOption = paymentOptions;
        // transaction.paymentModeSelected= paymentOptions[0];

      }
    }

    function showAmtExceedMsg(){
      ModalService.genericModal({
        text: vm.VALIDATE_DATA.AMOUNT_EXCEEDED
      });
    }

    function getMonthsCount(startDate, endDate) {
      var daysToBeAdded = 0;
      var daysAdded = 0;
      while(startDate.isBefore(endDate)) {
        var dayInMonth = moment(startDate).daysInMonth();
        if (dayInMonth === 31) {
          daysToBeAdded = daysToBeAdded + 1;
        } else {
          daysAdded = daysAdded + 1;
        }
        startDate.add(1, 'month');
      }
      return daysToBeAdded;
    }
    function paymentOptionArrayMethod(arr , paymentOptionCode , methodName) {
      function conditionFunc (element) {
        return element.code === paymentOptionCode;
      }
      
      switch (methodName) {
        case 'find':
          return arr.find(conditionFunc);
        case 'findIndex':
          return arr.findIndex(conditionFunc);
      }
    }
    
    function changePaymentModeFromUpi(transaction,remove) {
    
      var paymentModeIndex = paymentOptionArrayMethod(transaction.paymentOption,'UAP','findIndex');
      if(transaction.paymentOption.length > 1) {
        for (var i=0 ;i<transaction.paymentOption.length ;i++) {
          if (i!== paymentModeIndex  && transaction.paymentModeSelected.code === 'UAP') {
            transaction.paymentModeSelected = transaction.paymentOption[i];
            break;
          }
        }
      }
      else {
        transaction.paymentModeSelected = null;
      }
      if(paymentModeIndex!== -1) {
        if(remove) transaction.paymentOption.splice(paymentModeIndex, 1);
        changePaymentMode(transaction);
      }
    }

    function checkIsExceedingUpiDate(transaction) {
      if(transaction.startViewDate && transaction.endViewDate) {
        var startSipDateWithMaxDuration = $window.moment(transaction.startViewDate,'DD-MMM-YYYY').add(30,'years');
        var endSipDateBoundExist= $window.moment(transaction.endViewDate,'DD-MMM-YYYY').isBefore(startSipDateWithMaxDuration);
        return (!endSipDateBoundExist);
      }
        return false;
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipRenewStatusController', SipRenewStatusController);

  /** @ngInject */
  function SipRenewStatusController($window, LoaderService, TransactionService, MessageService, $state, ModalService, UtilService, moment, SchemeService, AppConstants) {
    var vm = this;
    /* variable declared for status tabs*/
    vm.isReset = true;
    vm.transactionList = [];
    vm.SIP_RENEW_STATUS = AppConstants.SIP_RENEW_STATUS;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.headerTooltip = {
      Proposed: ' Total No. of transactions being initiated to investors.',
      Rejected: 'Transaction rejected by Investors.',
      Expired: 'Transaction not approved in time by Investors.',
      Processed: 'Investor Approved the Transactions.'
    };
    vm.dateFilter = {startDate: null, endDate: null};
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.currentPageSystematicList = 1;
    vm.searchText = "";
    var statusPayload = {
      "fromDate": "",
      'pageIndex': vm.currentPageSystematicList,
      'pageLimit': vm.selectedPageLimit,
      'searchText': vm.searchText,
      "toDate": "",
      "flowType": "ALL",
      "transactionNature": "ALL",
      "transactionStatus": "",
      "transactionType": [
        "SIP"
      ],
      "sourceType": "ALL",
      "sortKey": "initiateDate",
      "sortValue": "DESC"
    };
    var snapshotPayload = {
      "sourceType": "ALL",
      "transactionNature": "ALL",
      "flowType": "ALL",
      "transactionType": ["ALL"],
      "fromDate": "",
      "toDate": "",
      "transactionStatus": "ALL"
    };
    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'DESC',
      onoff: 'ALL',
      transactionNature: 'ALL',
      searchText: ''
    };
    vm.snapshotData = {
      proposedCount:0,
      expiredCount: 0,
      rejectedCount: 0,
      approvedCount: 0
    };
    vm.panDecrypterService = UtilService.decryptPanNumber;
    /*status tab varialble declaration ends here*/
    vm.init = init();
    vm.filterByDate = filterByDate;
    vm.statusChanged = statusChanged;
    vm.limitChanged = limitChanged;
    vm.changeSelectedYear = changeSelectedYear;
    vm.initSipSearch = initSipSearch;
    vm.showMore = showMore;

    function init() {
      vm.selectedStatus = vm.SIP_RENEW_STATUS[0];
      statusPayload.transactionStatus = vm.selectedStatus.value.toUpperCase();
      changeSelectedYear();
    }

    function initSipSearch() {
      fetchBulkSIPStatusTransactions(statusPayload);
    }

    function changeSelectedYear() {
      vm.isReset = false;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            statusPayload.fromDate = resp.data.customDate && resp.data.customDate.fromDate;
            statusPayload.toDate = resp.data.customDate && resp.data.customDate.toDate;
            vm.minDate = resp.data.customDate && resp.data.customDate.yearStartDate;
            vm.maxDate = resp.data.customDate && resp.data.customDate.yearEndDate;
            vm.dateFilter = {
              'startDate' : $window.moment(statusPayload.fromDate, "DD-MMM-YYYY"),
              'endDate' : $window.moment(statusPayload.toDate, "DD-MMM-YYYY")
            };
            snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
            snapshotPayload.sourceType = vm.sortOrder.onoff;
            snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
            snapshotPayload.transactionType = statusPayload.transactionType;
            snapshotPayload.fromDate = statusPayload.fromDate;
            snapshotPayload.toDate = statusPayload.toDate;
            fetchBulkSIPStatusSnapshot(snapshotPayload, function() {
              fetchBulkSIPStatusTransactions(statusPayload);
            });
          }
          $window.setTimeout(function(){
            vm.isReset = true;
          },100);
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.allList');
          vm.transactionRecentList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      TransactionService.get({VERSION:'v3',controller: 'date'}).$promise.then(success, error);
    }

    function fetchBulkSIPStatusSnapshot(payload, cb) {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp && resp.data) {
          vm.snapshotData = resp.data;
          cb();
        } else {
          cb();
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      TransactionService.post({
        VERSION:'v2',
        child2: 'bulkSipSnapshot'
      }, payload).$promise.then(success, failure);
    }

    function fetchBulkSIPStatusTransactions(payload) {
      LoaderService.showLoader();
      vm.transactionList = [];
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp && resp.data) {
          vm.totalSystematicListData = resp.data.totalTransactions;
          vm.transactionList = resp.data.transactionList;
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
        } else {
          vm.transactionList = [];
          vm.totalSystematicListData = 0;
          vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        vm.transactionList = [];
        vm.totalSystematicListData = 0;
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      payload.pageIndex = vm.currentPageSystematicList - 1;
      payload.pageLimit = vm.selectedPageLimit;
      payload.searchText = vm.searchText;
      TransactionService.post({
        VERSION:'v2',
        child2: 'bulkSipSearch'
      }, payload).$promise.then(success, failure);
    }

    /* SIP renew status helping functions*/
    function filterByDate(dateFilter) {
      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          statusPayload.fromDate = $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY');
          statusPayload.toDate = $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY');
          fetchBulkSIPStatusTransactions(statusPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        statusPayload.fromDate = $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY');
        statusPayload.toDate = $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY');
        fetchBulkSIPStatusTransactions(statusPayload);
      }
      snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
      snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      snapshotPayload.fromDate = statusPayload.fromDate;
      snapshotPayload.toDate = statusPayload.toDate;
      fetchBulkSIPStatusSnapshot(snapshotPayload);
    }

    function resetDefaults() {
      vm.currentPage = 1;
      vm.fromCount = 0;
      vm.toCount = 0;
      vm.totalTransactions = 0;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.transactionList = null;
      vm.isPagination = false;
    }

    function reInitPayload () {
      vm.selectedType = vm.selectedType || ['SIP'];
      statusPayload.pageIndex = vm.currentPage;
      statusPayload.pageLimit = vm.selectedPageLimit;
      statusPayload.transactionStatus = vm.selectedStatus.value.toUpperCase();
      statusPayload.transactionType = vm.selectedType;
    }

    function statusChanged(_status) {
      vm.currentPage=1;
      vm.selectedStatus = _status;
      vm.selectedType = vm.selectedType || ['SIP'];
      vm.currentPageSystematicList = 1;
      reInitPayload();
      snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
      snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      snapshotPayload.transactionType = statusPayload.transactionType;
      snapshotPayload.fromDate = statusPayload.fromDate;
      snapshotPayload.toDate = statusPayload.toDate;
      fetchBulkSIPStatusSnapshot(snapshotPayload, function() {
        fetchBulkSIPStatusTransactions(statusPayload);
      });
    }


    function limitChanged() {
      vm.currentPageSystematicList = 1;
      statusPayload.pageIndex = vm.currentPageSystematicList;
      statusPayload.pageLimit = vm.selectedPageLimit;
      fetchBulkSIPStatusTransactions(statusPayload);
    }

    function showMore(message) {
      ModalService.genericModal({
        text: message
      });
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('WidgetCmsService', widgetCmsService)
    .factory('WidgetService', widgetService);

  /** @ngInject */
  function widgetCmsService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST_CMS +   ':VERSION/:child1/:child2/:child3/:child4/:uniqueLink/:folioNumber';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      post2: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '4',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': 2
        }
      }
    });
  }

  /** @ngInject */
  function widgetService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/:child1/:child2/:child3/:child4/:uniqueLink/:folioNumber';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      post2: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '4',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('UtilityService', utilityService);

  /** @ngInject */
  function utilityService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child/:child1';
    return $resource(_path, {}, {
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('UtilService', utilService);

  /** @ngInject */
  function utilService($timeout, MessageService, $window, AppConstants, HDFC_API, $q , InvestorServiceDynamicData , LoaderService , FormatterService, InvestorCommonServiceVersion2) {
    var c3 = $window.c3 || {};

    var currentFocusedElement = null;
    var folioDataInvalid = false;
    var folioDataMessage = null;
    var darkMode = false; // Default mode is light
    var count = 0;

    var _getUnitSting = function (value) {
      value = value || 0;
      var data = value.toString().split('.')[0];
      var length = data.length;

      if (length >= 4 && length < 6) {
        return 'K';
      } else if (length >= 6 && length < 8) {
        return 'Lacs'
      } else if (length >= 8) {
        return 'Crore'
      } else {
        return ''
      }
    };

    var _getDifferenceInDays = function (timeStamp1, timeStamp2) {
      //Get 1 day in milliseconds
      var one_day = 1000 * 60 * 60 * 24;

      // Calculate the difference in milliseconds
      var difference_ms = timeStamp2 - timeStamp1;

      // Convert back to days and return
      return Math.round(difference_ms / one_day);
    };

    var _getBarChart = function (config) {

      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();

      if (containerWidth < 710) {
        config.rotate = 90;
        config.step = 0;
        config.x = -5;
        config.anchor = 'bottom-left';
        config.position = 'outsideGrid';
      }
      else {
        config.rotate = 0;
        config.step = 0.001;
        config.x = -80;
        config.anchor = 'top-left';
        config.position = 'inset';
      }
      var chart = c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        color: {
          pattern: config.pattern
        },
        legend: {
          show: true,
          position: config.position,
          inset: {
            anchor: config.anchor,
            x: config.x,
            y: -10,
            step: config.step
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'bar',
          empty: {
            label: {
              text: "No Data to Display"
            }
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              format: function (x) {
                if (config.key == 'money') {
                  return '₹ ' + x
                }
                else if (config.key == 'count') {
                  return (parseInt(x) == x) ? x : null;
                }
                else {
                  return x;
                }
              },
              count: config.count,
              values: config.tickValue,
              multiline: false,
              culling: {
                max: 5
              }
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: {
                max: 0
              },
              rotate: config.rotate
            }
          }
        }
      });

      switch (config.bindto) {
        case '#investor-overview':
          angular.element(config.bindto).find(".c3-target-Total-Investors .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-target-CGF-Investors .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
        case '#syatematic-investor-overview':
          angular.element(config.bindto).find(".c3-shapes-Total-SIP .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-shapes-SIP-Expired .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
        case '#lumpsum-investor-overview':
          angular.element(config.bindto).find(".c3-shapes-Net-Sale-Lumpsum-Investment .c3-shape.c3-bar").attr("transform", "translate(-10,0)");
          angular.element(config.bindto).find(".c3-shapes-Funds-Mature .c3-shape.c3-bar").attr("transform", "translate(-5,0)");
          break;
      }

      if (config.categories.length == 0) {
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }
      else {
        var elements = angular.element(config.bindto).find(".c3-axis-y .tick");
        if (config.columns.length > 0) {
          for (var i = 0; i < elements.length; i++) {
            if (!angular.element(elements[i]).find('text tspan').text()) {
              angular.element(elements[i]).css('display', 'none');
            }
          }
        }
      }
      return chart;
    };

    var _getEarnBarChart = function (config) {
      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();
      if (containerWidth < 710) {
        config.rotate = 90;
      }
      else {
        config.rotate = 0;
      }
      config.lines = [];

      var earnChart = c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        legend: {
          show: false,
          inset: {
            anchor: 'top-left',
            x: 10,
            y: 10,
            step: undefined
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'bar',
          empty: {
            label: {
              text: "No Data Available"
            }
          },
          color: function (color, d) {
            return config.pattern[d.index];
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            line: false,
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              multiline: false,
              culling: false,
              outer: false
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: false,
              outer: false,
              rotate: config.rotate
            }
          }
        }
      });

      angular.element(config.bindto).find(".c3-axis-y").find('path').css({stroke: '#fff'});
      angular.element(config.bindto).find(".c3-axis-y").find('.tick line').css({stroke: '#fff'});
      //angular.element(config.bindto).find(".c3-axis-x").find('path').css ({ stroke: '#fff' });
      angular.element(config.bindto).find(".c3-axis-x").find('.tick line').css({stroke: '#fff'});
      var elements = angular.element(config.bindto).find(".c3-axis-y .tick");
      if (config.columns.length > 0) {
        for (var i = 0; i < elements.length; i++) {
          config.lines.push({value: parseInt(angular.element(elements[i]).find('text tspan').text())});
        }
        $timeout(function () {
          earnChart.ygrids.add(config.lines);
        }, 0);
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      }
      else {
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#fff'});
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }


    };

    var _invesstorGrowthChart = function (config) {
      var graphWidth = angular.element(config.bindto).innerWidth();
      graphWidth = graphWidth - 30;
      var containerWidth = angular.element(config.bindto).innerWidth();
      if (containerWidth < 710) {
        config.rotate = 90;
      }
      else {
        config.rotate = 0;
      }
      config.lines = [];

      var growthChart = c3.generate({
        bindto: config.bindto,
        size: {
          width: graphWidth
        },
        legend: {
          show: false,
          inset: {
            anchor: 'top-left',
            x: 10,
            y: 10,
            step: undefined
          },
          item: {
            onclick: function () {
            }
          }
        },
        data: {
          labels: false,
          columns: config.columns,
          type: 'area',
          empty: {
            label: {
              text: "No Data Available"
            }
          },
          types: {
            EARNING: 'area'
          }
        },
        bar: {
          width: {
            ratio: 0.3
          }
        },
        line: {
          step: {
            type: 'step-after'
          }
        },
        axis: {
          y: {
            line: false,
            label: {
              text: config.yAxis.text,
              position: 'outer-middle'
            },
            tick: {
              multiline: false,
              culling: false,
              outer: false
            }
          },
          x: {
            label: {
              text: config.xAxis.text,
              position: 'outer-left'
            },
            type: 'category',
            categories: config.categories,
            tick: {
              multiline: false,
              culling: false,
              outer: false,
              rotate: config.rotate
            }
          }
        }
      });

      angular.element(config.bindto).find(".c3-axis-y").find('path').css({stroke: '#fff'});
      angular.element(config.bindto).find(".c3-axis-y").find('.tick line').css({stroke: '#fff'});
      //angular.element(config.bindto).find(".c3-axis-x").find('path').css ({ stroke: '#fff' });
      angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      angular.element(config.bindto).find(".c3-axis-x").find('.tick line').css({stroke: '#fff'});
      var elements = angular.element(config.bindto).find(".c3-axis-y .tick");

      if (config.columns.length > 0) {
        for (var i = 0; i < elements.length; i++) {
          config.lines.push({value: parseInt(angular.element(elements[i]).find('text tspan').text())});
        }
        $timeout(function () {
          growthChart.ygrids.add(config.lines);
        }, 0);
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#aaa'});
      }
      else {
        angular.element(config.bindto).find(".c3-axis-x").find('path').css({stroke: '#fff'});
        angular.element(config.bindto).find(".c3-axis-y .tick").css('display', 'none');
      }

      // for(var i=0;i<elements.length;i++){
      //   config.lines.push({'value':angular.element(elements[i]).find('text tspan').text()});
      // }
      //
      // $timeout(function () {
      //   growthChart.ygrids.add( config.lines);
      // },0);

    };

    var _getFilteredList = function (masterList, filterKey, filterValue) {
      if (!masterList || !angular.isArray(masterList)) {
        return null;
      }
      if (!filterKey || !filterValue || !angular.isString(filterKey) || !angular.isString(filterValue)) {
        return angular.copy(masterList);
      }
      var result = masterList.filter(function (item) {
        return (item[filterKey].toLowerCase().indexOf(filterValue.toLowerCase()) > -1);
      });
      return angular.copy(result);
    };

    var _getNumberOfMonths = function (fromDate, toDate) {
      var year1 = fromDate.year();
      var year2 = toDate.year();
      var month1 = fromDate.month();
      var month2 = toDate.month();
      if (month1 === 0) {
        month1++;
        month2++;
      }
      return Math.abs(((year2 - year1) * 12 + (month2 - month1)));
    };

    var _getNumberOfWeeks = function (fromDate, toDate) {
      var timeDiff = toDate.getTime()-fromDate.getTime();
      var daysDiff = timeDiff/(1000*3600*24);
      return Math.floor(daysDiff/7);
    };

    var _errorHandler = function (error) {
      if (error && error.status !== 401) {
        MessageService.error(error.message);
      }
    };

    var _currentFocusedElement = {
      get : function () {
        return currentFocusedElement;
      },
      set : function (ele) {
        currentFocusedElement = ele;
      },
      clear : function () {
        currentFocusedElement = null;
      }
    }


    var _decryptPanNumber = function(investorPan) {

      var ivKey = investorPan.substring(0, investorPan.lastIndexOf("|"));
      var data = investorPan.substring(investorPan.lastIndexOf("|")+1, investorPan.length);
      var header = FormatterService.getFormatterHDFC().decrypt(ivKey);

      var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));

      var decryptJson = $window.CryptoJS.AES.decrypt({
        ciphertext: $window.CryptoJS.enc.Base64.parse(data)
      }, key, {iv: iv});

      return (decryptJson.toString($window.CryptoJS.enc.Utf8));
    };

     /*
     * fetching dynamic data
     */
     var _fetchDynamicData =  function(pageName) {
       var defer = $q.defer();
       LoaderService.showLoader();
       var successHandler = function(resp) {
         LoaderService.hideLoader();
         if (resp.status && resp.data) {
           defer.resolve(resp.data);
         } else {
           defer.reject(resp.data);
         }
       };

       var errorHandler = function(resp) {
         LoaderService.hideLoader();
         MessageService.error(resp.message);
       };

       var payload = {
         "pageName": pageName
       };

       InvestorServiceDynamicData.post({
         "child1": "dynamicContent"
       }, payload).$promise.then(successHandler, errorHandler);
          return defer.promise;
     };

      var _addDynamicNotes = function(className, parentNode, child) {
        $timeout(function() {
          var elem = $window.document.getElementsByClassName(className)[parentNode];
          angular.forEach(AppConstants.TPV_NOTES, function(key) {
          var ul = $window.document.createElement("ul");
          var i = $window.document.createElement("i");
          var span = $window.document.createElement("li");
          i.classList.add("dot");
          span.innerHTML = key.note;
          ul.appendChild(i);
          ul.appendChild(span);
          ul.id = key.id;
          var hasChild = elem.querySelector("#" + key.id) === null;
          if (hasChild) {
            elem.appendChild(ul);
    //          elem.insertBefore(para, elem.children[child]);
             }
           });
       });
    };

     var _removeDynamicNotes = function() {
      angular.forEach(AppConstants.TPV_NOTES, function(key) {
        $window.document.getElementById(key.id).remove();
      });
     };

     var _setFolioDataValid = function(object) {
       folioDataInvalid = object.folioDataInvalid;
       folioDataMessage = object.message;
     };

     var _getFolioDataValid = function() {
       return {
         folioDataInvalid: folioDataInvalid, folioDataMessage: folioDataMessage
       };
     };

     var getMonthsCount = function(startDate, endDate) {
       var daysToBeAdded = 0;
       var daysAdded = 0;
       while(startDate.isBefore(endDate)) {
         var dayInMonth = moment(startDate).daysInMonth();
         if (dayInMonth === 31) {
           daysToBeAdded = daysToBeAdded + 1;
         } else {
           daysAdded = daysAdded + 1;
         }
         startDate.add(1, 'month');
       }
       return daysToBeAdded;
     };

    var _expandSideBar = function() {
      var sidebar = angular.element($window.document.getElementById("sidebarContainer"));
      sidebar.removeClass('sidebar-container-width-0');
      sidebar.addClass('collapse in');
      angular.element($window.document.body).addClass('hide-scroll');
    };

    var _getCommaSeperatedString = function(number) {
      if (number) {
        return parseInt(number).toLocaleString("en-IN");
      }
    };

    var _getCommaSeperatedWithFloatValue = function(number,decimal) {
      if (number) {
        var splitPart = number.toString().split('.');
        var commaSepratedPart = parseInt(splitPart[0]);
        var fractionalPart = splitPart[1] ? splitPart[1].slice(0, decimal): '';

        var multiplier = Math.pow(10, decimal);

        if (fractionalPart * 1 === 0) {
          fractionalPart = fractionalPart / multiplier;
        }

        if(fractionalPart) {
          var formattedNumber = commaSepratedPart.toLocaleString("en-IN") + '.' + fractionalPart;
          formattedNumber = formattedNumber.replace(/(\.[0-9]*?)0+$/, '$1');
        } else {
          var formattedNumber = commaSepratedPart.toLocaleString("en-IN");
        }
        return formattedNumber;
      }
    };

    var _amountInComma = function(amount) {
      if (amount) {
        if (amount === "₹") {
          return {
            amount: null,
            amountInComma: null
          }
        } else {
          return {
            amount: parseInt(amount.toString().replaceAll("₹ ", "").replaceAll(",", "")),
            amountInComma: '₹ ' + (parseInt(amount.toString().replaceAll('₹ ', "").replaceAll(",", "")) || '').toLocaleString('en-IN')
          };
        }
      }
    };
    var _fetchMandateValidations =  function() {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };

      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      InvestorServiceDynamicData.post({
        child1 : 'app',
        child2 : 'setting',
      },{
        name : "SIP"
      }).$promise.then(successHandler, errorHandler);

      return defer.promise;
    };

    var _copyPasteHandler = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : (key === 17);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    };

    var _amountInCommaARN = function(amount) {
      if (amount) {
          return {
            amount: parseInt(amount.toString().replaceAll("₹ ", "").replaceAll(",", "")),
            amountInComma: (parseInt(amount.toString().replaceAll('₹ ', "").replaceAll(",", "")) || '').toLocaleString('en-IN')
          };
      }
    };

    var _checkTxnBlock =  function(pan) {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };
      var errorHandler = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {pan: pan}).$promise.then(successHandler, errorHandler);
      return defer.promise;
    };

    var _toggleMode = function() {
      darkMode = !darkMode;
    };

    // Function to check if dark mode is enabled
    var _isDarkModeEnabled = function() {
      return darkMode;
    };

    var _changedFont = function(valType){
      switch (valType) {
        case 'increment' : {
          if(count<3){
            count++;
            fontSizeChange(count);
          }
        }
          break;
        case 'decrement' : {
          if(count>-3){
            count--;
            fontSizeChange(count);
          }
        }
          break;
        case 'original' : {
          count = 0;
          fontSizeChange(count);
        }
          break;
      }
    };

    var fontSizeChange = function(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 55% !important");
          elem.classList.add("font-size-xs");
          elem.classList.remove('font-size-s');
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 65% !important");
          elem.classList.add("font-size-s");
          elem.classList.remove('font-size-xs');
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove('newBigFont');
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
          elem.classList.add("font-size-l");
          elem.classList.remove('font-size-xl');
          elem.classList.remove('font-size-s');
          elem.classList.remove('font-size-xs');
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
          elem.classList.remove('font-size-l');
          elem.classList.add("font-size-xl");
        }
          break;
      }
    };

    var _getCount = function () {
      return count;
    };

    var _converter = function(authorizationKey){
      var originalKey = authorizationKey;
      var modifiedKey = originalKey.replace(/_/g, '/').replace(/-/g, '+');
      var crypt = new $window.JSEncrypt();
      crypt.setKey(HDFC_API.HDFC_CONFIG_ENDPOINT);
      return 'Basic'+' '+crypt.decrypt(modifiedKey);
    };

    /**
     * function responsible calculating installment
     * @param  {Object}   startDate     - SIP Start Date
     *  @param  {Object}   endDate     -  SIP End Date
     * @param {String} frequencyCode - SIP Frequency Code
     * @return {Number} number of installments
     */

    var _setInstallmentCount = function (startDate, endDate, frequencyCode) {
      var daysDuration;
      var installment;
      switch (frequencyCode) {
        case'BZ':
          installment = endDate.diff(startDate, 'days') + 1;
          break;
        case 'OW':
          daysDuration = (endDate.diff(startDate, 'days') + 1) / 7;
          installment = Math.ceil(daysDuration);
          break;
        case 'OM' :
          installment = endDate.diff(startDate, 'months') * 1 + 1;
          break;
        case 'Q':
          daysDuration = (endDate.diff(startDate, 'months')) / 3;
          installment = Math.ceil(daysDuration);
          break;
        case 'H':
          daysDuration = (endDate.diff(startDate, 'months')) / 6;
          installment = Math.ceil(daysDuration);
          break;
        case 'Y':
          installment = endDate.diff(startDate, 'years');
          break;
        default :
      }

      return installment


    }

    var _checkForRetirementScheme = function(schemeData, folioData) {
      if (schemeData && folioData && !folioData.holderDOBExists && schemeData.retirementFlag) {
        return true;
      } else {
        return false;
      }
    };

    var _genericConverter = function(value) {
      var modifiedKey = value.replace(/_/g, '/').replace(/-/g, '+');
      return FormatterService.getFormatterHDFC().decrypt(modifiedKey);
    };

    var _fetchBankListForSipUpi =  function(transactionType, folioNumber, schemeType, ecartFlow) {
      var defer = $q.defer();
      LoaderService.showLoader();
      var successHandler = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          defer.resolve(resp.data);
        } else {
          defer.reject(resp.data);
        }
      };
      var errorHandler = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      var payload = {
        "folioNumber": folioNumber,
        "transactionType": transactionType,
        "liquidSchemeFlag": schemeType == 'LIQUID' ? true : false,
        "sipUpiFlow" : true,
        "ecartFlow" :ecartFlow? ecartFlow: false
      };
      InvestorCommonServiceVersion2.post({
        child1: 'investor',
        child2: 'upi',
        child3: 'bank',
        child4: 'list'
      }, payload).$promise.then(successHandler, errorHandler);
      return defer.promise;
    };

    return {
      getUnitSting: _getUnitSting,
      getDifferenceInDays: _getDifferenceInDays,
      getBarChart: _getBarChart,
      getEarnBarChart: _getEarnBarChart,
      invesstorGrowthChart: _invesstorGrowthChart,
      getFilteredList: _getFilteredList,
      errorHandler: _errorHandler,
      getNumberOfMonths: _getNumberOfMonths,
      currentFocusedElement : _currentFocusedElement,
      decryptPanNumber: _decryptPanNumber,
      getNumberOfWeeks: _getNumberOfWeeks,
      fetchDynamicData: _fetchDynamicData,
      addDynamicNotes: _addDynamicNotes,
      removeDynamicNotes: _removeDynamicNotes,
      setFolioDataValid: _setFolioDataValid,
      getFolioDataValid: _getFolioDataValid,
      getMonthsCount: getMonthsCount,
      expandSideBar: _expandSideBar,
      getCommaSeperatedString: _getCommaSeperatedString,
      amountInComma: _amountInComma,
      fetchMandateValidations: _fetchMandateValidations,
      copyPasteHandler: _copyPasteHandler,
      getCommaSeperatedWithFloatValue: _getCommaSeperatedWithFloatValue,
      amountInCommaARN: _amountInCommaARN,
      checkTxnBlock : _checkTxnBlock,
      toggleMode: _toggleMode,
      isDarkModeEnabled: _isDarkModeEnabled,
      changedFont: _changedFont,
      getCount: _getCount,
      converter: _converter,
      setInstallmentCount : _setInstallmentCount,
      checkForRetirementScheme: _checkForRetirementScheme,
      genericConverter : _genericConverter,
      fetchBankListForSipUpi: _fetchBankListForSipUpi
    }
  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('UserService', userService);

  /** @ngInject */
  function userService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/user/:username/:controller';
    return $resource(_path, {},
      {
        get: {
          method: 'GET',
          params: {}
        },
        put: {
          method: 'PUT',
          params: {}
        },
        delete: {
          method: 'DELETE',
          params: {}
        },
        post: {
          method: 'post',
          params: {}
        }
      });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('TransactionService', transactionService)
    .factory('TransactionFlowVersion', transactionFlowVersion)
    .factory('ChangeDividendService', changeDividendService)
    .factory('TransactionApprovalService', transactionApprovalService)
    .factory('BillJunctionService', billJunctionService)
    .factory('EkycService', ekycService)
    .factory('TransactionArnService', transactionArnService)
    .factory('NudgeRedemptionDynamicData',nudgeRedemptionDynamicData)
    .factory('NewInvestorTransactionService',newInvestorTransactionService)
    .factory('FolioApproval',folioApproval)
    .factory('TransactionEcartService',transactionEcartService)
    .factory('TransactionAddToCartService',transactionAddToCartService)
    .factory('TransactionDynamicService',transactionDynamicService)
    .factory('FolioApprovalUpdateContact',folioApprovalUpdateContact);

  /** @ngInject */
  function transactionService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/:child1/:investorId/transaction/:controller/:child2/:child3/:uniqueLink/:folioNumber';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      post2: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '4',
          'app-type':'W'
        }
      },
      post3: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '2',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function transactionFlowVersion($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/:child1';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      }
    });
  }

  function changeDividendService($resource , HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + ':child1/:child2/:child3/:child4/:child5/:child6/:child7';

    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      post2: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '2'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }


  /** @ngInject */
  function transactionApprovalService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

   // var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/transaction/:controller/:child1/:child2/:uniqueLink';
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +  ':VERSION/transaction/:controller/:child1/:child2/:child3/:uniqueLink';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function billJunctionService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +':VERSION/:controller/:child1/:child2/:child3/:uniqueLink';
   // var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child1/:child2/:child3/:uniqueLink';

   // var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/transaction/otp/pay/purchase/:uniqueLink';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function ekycService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/:child1/:investorId/:controller/:child2/:child3/:uniqueLink/:folioNumber';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function transactionArnService($resource, HDFC_API,TransformResponse ) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.IHOST + 'v1' + '/:controller1/:controller2/:controller3/:controller4/:controller5';

    return $resource(_path, {}, {
        post: {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
           transformResponse: TransformResponse.transformApiResponse
        },
        post4: {
          method: 'post',
          headers: {
              'Content-Type': 'application/json',
              'X-API-VERSION':'4'
          },
         transformResponse: TransformResponse.transformApiResponse
      },
        get: {
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            },
            transformResponse: TransformResponse.transformApiResponse
        },
        get1: {
          method: 'get',
          transformResponse: TransformResponse.transformApiResponse
      },
        delete: {
            method: 'delete',
            headers: {
                'Content-Type': 'application/json'
            },
            transformResponse: TransformResponse.transformApiResponse
        }
    });
  }
    /** @ngInject */
    function newInvestorTransactionService($resource, HDFC_API, TransformResponse) {

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v1/:controller1/:controller2/:controller3/:controller4/:controller5';

      return $resource(_path, {}, {
          post: {
              method: 'post',
              headers: {
                  'Content-Type': 'application/json',
                  'X-API-VERSION': '2'
              },
              transformResponse: TransformResponse.transformApiResponse
          },
          get: {
              method: 'get',
              headers: {
                  'Content-Type': 'application/json'
              },
              transformResponse: TransformResponse.transformApiResponse
          },
          delete: {
              method: 'delete',
              headers: {
                  'Content-Type': 'application/json'
              },
              transformResponse: TransformResponse.transformApiResponse
          }
      });
  }


  function folioApproval($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/transaction/:controller/:child2/:child3/:child4/:child5/:child6';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function nudgeRedemptionDynamicData($resource, HDFC_API ,$window) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + "v1" + '/:child1/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function transactionEcartService($resource, HDFC_API,TransformResponse ) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.IHOST + 'v1' + '/:child1/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get1: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      delete: {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /** @ngInject */
  function transactionAddToCartService($resource, HDFC_API,TransformResponse ) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v1' + '/:controller1/:controller2/:controller3/:controller4/:controller5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post4: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get1: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      delete: {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

    /** @ngInject */
    function transactionDynamicService($resource, HDFC_API) {
      /*
       * value of :version could be v1 , v2 , v3 based on required api version
       * */

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/:child1/:child2/:child3';
      return $resource(_path, {}, {
        post: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'app-type':'W'
          }
        },
        post2: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-VERSION': '4',
            'app-type':'W'
          }
        },
        get: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      });
    }


  function folioApprovalUpdateContact($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST +   ':VERSION/transaction/:controller/:child2/:child3?contact=true';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

})();

/**
 * Created by sudarshan on 20/11/17.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .service('AgentSocketService', agentSocketService)

  /** @ngInject */
  function agentSocketService($window, HDFC_API, LoaderService, AuthService, MessageService,
                              AgentService, $rootScope, $state, ModalService) {
    this.ws = {};
    $window.soketObj = this.ws;
    this.WebSocket = function () {
      return $window.soketObj;
    }
    this.openSocket = function (cb) {
      // if ($window.soketObj.status) {
      //   cb(true);
      //
      // } else {
      //   var data = AuthService.getToken(), path;
      //   if (!data) return;
      //   if (HDFC_API.ENV !== 'mock') {
      //     path = 'wss://' + HDFC_API.HOST + 'connectAgent/' + data.userId;
      //   } else {
      //     path = 'wss://hdfc-uat-kong.tothenew.net/distributor/connectAgent/' + data.userId;
      //   }
      //   $window.soketObj = new WebSocket(path);
      //   (function (ws) {
      //
      //     if ($rootScope.socketTimer)
      //       clearInterval($rootScope.socketTimer);
      //
      //     $rootScope.socketTimer = setInterval(function () {
      //       if (ws && ws.readyState == 1) {
      //         ws.send('connection alive');
      //       }
      //     }, 2000);
      //   })($window.soketObj);
      //   $window.onbeforeunload = function () {
      //     // $window.soketObj && $window.soketObj.close();
      //   };
      //
      //   $window.soketObj.onmessage = function (evt) {
      //     var received_msg = evt.data;
      //     if (received_msg.indexOf('Disconnect') != -1) {
      //       $rootScope.$broadcast('UpdateSocketDisconnect');
      //     } else if (angular.isUndefined($window.sessionStorage.currentDistributorARN) || $window.sessionStorage.currentDistributorARN == "") {
      //       $rootScope.$broadcast('UpdateSocketData', received_msg);
      //     }
      //   };
      //   $window.soketObj.close = function () {
      //     $rootScope.$broadcast('UpdateSocketClose');
      //   };
      //   cb(true);
      // }
    }

    this.impersonateLogout = function distributorImpersonate(args, cb) {
      cb = cb || function () {

      }
      var identifierData = AuthService.getToken();
      if (!identifierData['isDistributor']) {
        cb(true);
      } else {
        var success = function (resp) {
          if (resp.status) {
            LoaderService.hideLoader();
            identifierData['isDistributor'] = resp.data.distributor;
            AuthService.setToken(identifierData);
            $window.sessionStorage.currentDistributorARN = '';
            // $rootScope.currentDistributorARN = '';
            // $window.soketObj.close();
            /*if($rootScope.soketObj)
              $rootScope.socket.close();*/
            if (args && args.logoutType == 'Agent') {

              if ($rootScope.soketObj)
                $rootScope.soketObj.close();
              if ($rootScope.socketTimer)
                clearInterval($rootScope.socketTimer);
              AuthService.agentLogout().then(function () {
                $state.go('agent.login');
              }, function () {
                $state.go('agent.login');
              });
            } else {
              $state.go('agent.home.distributor-list');
            }
            cb(true);
          }
          else {
            cb(false);
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
          cb(false);
        };
        localStorage.removeItem('distributorName');
        LoaderService.showLoader();
        AgentService.post({
          controller: 'logout',
          child1: 'impersonate'
        }, {}).$promise.then(success, error);
      }
    }
    this.showDisconnedtPopUp = function (payload, cb) {
      // cb = cb || function () {
      //
      // }
      // var success = function () {
      //   cb(true);
      // }, error = function () {
      //   cb(false);
      // }
      // var modalData = {};
      // modalData.text = payload.msg || 'Distributor Session has been expired';
      // modalData.saveEnable = payload.saveEnable;
      // modalData.backdrop = false;
      // ModalService.agentMessageModal(modalData, success, error);
    }

    /*this.onSocketMsg = function (cb) {
      cb = cb || function () {};
      soketObj.onmessage = function (evt) {
        $log.debug('Socket Response>>>>>>>>>', evt.data);
        cb(evt.data);
      }
    }
    this.onSocketClose = function (cb) {
      cb = cb || function () {
      };
      soketObj.onclose = function () {
        cb(true);
        // self.socketStatus = 'Offline';
        //MessageService.error('You are offline now');
        // $rootScope.isConnectionOpen = false;
      };
    }*/
    /*
        function openSocket() {
          var self = this;

          if ($rootScope.socket)
            $rootScope.socket.close();

          // mockOnMessage();

          var data = AuthService.getToken();
          if (!data) return;
          var path = 'wss://' + HDFC_API.HOST + 'connectAgent/' + data.userId;
          var ws = new WebSocket(path);
          // $rootScope.socket = ws;
          /!*
                ws.onopen = function () {
                  self.socketStatus = 'Online';
                  $rootScope.isConnectionOpen = true;
                };

                ws.onmessage = function (evt) {
                  var received_msg = evt.data;
                  $log.debug('Socket Response>>>>>>>>>',evt.data);

                  if (received_msg.indexOf('Disconnect') != -1) {
                    // if(localStorage.getItem('distributorName')){
                    if(self.distributorData && self.distributorData.length){
                      var success = function () {
                        if($state.current.name != 'agent.home.distributor-list'){
                          distributorImpersonate();
                        }

                        self.distributorData = [];
                        self.searchByArn = '';
                        self.searchDistributorByName = 'DISCONNECT';
                        $rootScope.currentDistributorARN = '';
                        // self.searchDistributor();

                      },error = function () {
                        if($state.current.name != 'agent.home.distributor-list'){
                          distributorImpersonate();
                        }

                        self.distributorData = [];
                        self.searchByArn = '';
                        self.searchDistributorByName = 'DISCONNECT';
                        $rootScope.currentDistributorARN = '';
                        // self.searchDistributor();
                      }
                      var message = 'Distributor Session has been expired';
                      ModalService.agentMessageModal({Text:message}, success, error);
                    }else{
                      self.distributorData = [];
                      self.searchByArn = '';
                      self.searchDistributorByName = 'DISCONNECT';
                      $rootScope.currentDistributorARN = '';
                      self.searchDistributor();
                    }

                  } else {

                    if(self.distributorData && self.distributorData.length){
                      return;
                    }
                    if (received_msg.indexOf('ARN-') != -1) {
                      self.searchDistributorList = received_msg.split(',');
                      self.searchDistributorByName = received_msg.split('-')[1];
                    } else {
                      self.searchDistributorByName = received_msg;
                    }

                    $rootScope.currentDistributorARN = 'ARN-' + self.searchDistributorByName;

                    if ($rootScope.$state.current.name != 'agent.home.distributor-list') {
                      $rootScope.$state.go('agent.home.distributor-list', {arn: self.searchDistributorByName});
                    }
                    (typeof self.searchDistributor == 'function') && self.searchDistributor();
                  }
                };

                ws.onclose = function () {
                  self.socketStatus = 'Offline';
                  //MessageService.error('You are offline now');
                  $rootScope.isConnectionOpen = false;
                };*!/

          (function (ws) {

            if ($rootScope.socketTimer)
              clearInterval($rootScope.socketTimer);

            $rootScope.socketTimer = setInterval(function () {
              if (ws && ws.readyState == 1) {
                ws.send('connection alive');
              }
            }, 2000);
          })(ws);

          $window.onbeforeunload = function () {
            socket.close();
          };

          return ws;

        }


        function distributorImpersonate() {
          var success = function (resp) {
            if (resp.status) {
              LoaderService.hideLoader();
              var tokenData = AuthService.getToken();
              tokenData['isDistributor'] = resp.data.distributor;
              // $cookies.put('token_data', angular.toJson(tokenData));
              AuthService.setToken(tokenData);
              $state.go('agent.home.distributor-list');
            }
            else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error(err);
          };

          localStorage.removeItem('distributorName');
          LoaderService.showLoader();
          AgentService.get({
            controller: 'logout',
            child1: 'impersonate'
          }, {}).$promise.then(success, error);

        }*/

    /*return {
      openSocket: openSocket
    }*/
  }

})();

/**
 * Created by ttn on 06/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('SipCornerService', sipCornerService)
    .factory('SipCornerVersionService', sipCornerVersionService);

  /** @ngInject */
  function sipCornerService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/systematic/:controller';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
  /** @ngInject */
  function sipCornerVersionService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v3/systematic/:controller';

    return $resource(_path, {}, {
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('SchemeService', schemeService);

  /** @ngInject */
  function schemeService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:type/:child1/:child2/:child3/:child4';
    return $resource(_path, {}, {
      get: {
        method: 'get'
      },
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('TransformResponse', transformResponse);

  /** @ngInject */
  function transformResponse() {
    function IsJsonString(str) {
      try {
        angular.fromJson(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    return {
      transformApiResponse: function (data) {
        if (angular.isString(data) && IsJsonString(data)) {
          return angular.fromJson(data);
        } else {
          return data;
        }
      }
    }
  }

})();

/**
 * Created by ttn on 28/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('ReportsService', reportsService)
    .factory('DownloadReportsService', downloadReportsService)
    .factory('DownloadReportsServiceV2', downloadReportsServiceV2);

  /** @ngInject */
  function reportsService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/report/:controller/:child1/:child2';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function downloadReportsService($http,$q, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */


    var downloadFile=function(downloadUrl,payload){
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + downloadUrl;
        var deferred = $q.defer();

      $http.post(_path,payload, {'responseType':'arraybuffer'}).then(function (resp) {
        deferred.resolve(resp||resp.data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    var sendFile=function(downloadUrl,payload){
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + downloadUrl;
      var deferred = $q.defer();

      $http.post(_path,payload, {}).then(function (resp) {
        deferred.resolve(resp);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    var fetchApiUrlForReports=function(controller,child){
      var _path ='';
      if(controller && child) {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/report/' + controller + '/' + child;
      }
      else{
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/report/' + controller ;
      }

      var deferred = $q.defer();

      $http.post(_path, {}, null).then(function (resp) {
        deferred.resolve(resp);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    return{
      downloadFile:downloadFile,
      sendFile:sendFile,
      fetchApiUrlForReports:fetchApiUrlForReports
    }

  }

  /** @ngInject */
  function downloadReportsServiceV2($http,$q, HDFC_API) {
    var downloadFile=function(downloadUrl,payload){
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + downloadUrl;
      var deferred = $q.defer();

      $http.post(_path,payload, {'responseType':'arraybuffer', headers:{'X-API-VERSION':'2'}}).then(function (resp) {
        deferred.resolve(resp||resp.data);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    return{
      downloadFile:downloadFile
    }

  }

})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('PaymentService', paymentService);

  /** @ngInject */
  function paymentService(AppConstants, HDFC_API, $window) {
    var Razorpay = $window.Razorpay || {};

    function _openRazorPay(data) {
      var authKey, merchantLogoImage;
      if(data && data.orderResponseDTO) {
        authKey = data.orderResponseDTO.razorPayKeyId;
        merchantLogoImage = AppConstants.RAZORPAY_CRADENTIALS.merchantLogoUrl;

        var razorpay = new Razorpay({
          key: authKey,
          // logo, displayed in the payment processing popup
          image: merchantLogoImage,
          redirect: true
        });

        var payload = {
          callback_url: data.trnxActionMsg ,
          amount: data.orderResponseDTO.amountInPaise, // in currency subunits. Here 1000 = 1000 paise, which equals to ₹10
          currency: data.orderResponseDTO.currency,// Default is INR. We support more than 90 currencies.
          order_id: data.orderResponseDTO.orderId,// Order ID generated in Step 1
          method: data.orderResponseDTO.method,
          bank: data.orderResponseDTO.bankCode,
          email: data.orderResponseDTO.email,
          description: data.orderResponseDTO.description,
          contact: data.orderResponseDTO.contact
        };

        razorpay.createPayment(payload);
      } else {
        $window.open(data.redirectUrl, '_self');
      }
    }

    return {
      openRazorPay: _openRazorPay
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('panAdharLinkingService', panAdharLinkingService);

    /** @ngInject */
    function panAdharLinkingService($q, $state, MessageService, AppConstants, InvestorCommonServiceVersion1 , ModalService, LoaderService) {
      var vm = this;

      function _checkPanAdharStatus(pan,folio,arnNumber) {
        var defer = $q.defer();
        LoaderService.showLoader();
        var successHandler = function(resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.data['popup-enabled']) {
            _showErrorMessageModal(resp.data.message);
            defer.reject(resp.data);
          } else {
            if(typeof resp.data === 'undefined') {
              MessageService.error(resp.message);
              defer.reject(resp.data);
            } else {
              defer.resolve(resp.data);
            }
          }
        };

        var errorHandler = function(resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
          defer.reject(resp);
        };

        var payload = {
          panNumber : pan ,
          folioNumber : folio ,
          brokerCode : arnNumber
        }

        InvestorCommonServiceVersion1.post({
         "child1": "verifyPanAadharLink"
        },payload).$promise.then(successHandler, errorHandler);
        return defer.promise;
      }

      function _showErrorMessageModal(message) {
        ModalService.genericModal({
          panErrorText: message
        });
      }

      return {
        checkPanAdharStatus: _checkPanAdharStatus,
        showErrorMessageModal: _showErrorMessageModal
      }
    }
})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('NotificationService', notificationService);

  /** @ngInject */
  function notificationService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/notification/:controller';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('ModalService', modalService);

  /** @ngInject */
  function modalService($uibModal) {
    function openModal(success, dismiss, view, controller, data, sizeClass) {
      success = success || function () {};
      dismiss = dismiss || function () {};
      var ctrl = controller + ' as Modal';
      var modalInstance = $uibModal.open({
        templateUrl: 'app/services/modal/modal-popup.html',
        controller: ctrl,
        size: sizeClass,
        // backdrop: (data && (data.backdrop != undefined )) ? data.backdrop : true ,  // set static/true to toggle dismiss on backdrop clic€k
        backdrop: 'static',
        keyboard  : false,// set static/true to toggle dismiss on backdrop click
        resolve: {
          modalView: function () {
            return view;
          },
          modalData: function () {
            return data;
          }
        }
      });
      modalInstance.result.then(success, dismiss || angular.noop);
    }

    return {
      signUpModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIGN_UP", "SignUpModalController", data, "lg");
      },
      otpVerificationModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_VERIFICATION", "SignUpModalController", data, "lg");
      },
      signUpDoneModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIGN_UP_DONE", "SignUpModalController", data, "lg");
      },
      forgotPasswordModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FORGOT_PASSWORD", "ForgotPasswordModalController", data, "md");
      },
      forgotPasswordDoneModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FORGOT_PASSWORD_DONE", "ForgotPasswordModalController", data, "md");
      },
      resetPasswordModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "RESET_PASSWORD", "ResetPasswordModalController", data, "md");
      },
      resetPasswordDoneModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "RESET_PASSWORD_DONE", "ResetPasswordModalController", data, "lg");
      },
      messagePasswordModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PASSWORD_MSG", "MessagePasswordController", data, "md pass-msg-modal");
      },
      logoUploadModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LOGO_UPLOAD", "LogoUploadModalController", data, "lg");
      },

      logoUploadAtHeaderModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LOGO_UPLOAD_HEADER", "LogoUploadAtHeaderModalController", data, "lg");
      },
      transactionSummaryModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SUMMARY", "TransactionSummaryModalController", data, "md");
      },
      transactionReviewModal: function (data, successCallback, dismissCallback) {
        var className=data.controller=="flexindex" || data.controller=="sip_modify"?"lg":"md";
        openModal(successCallback, dismissCallback, "TRANSACTION_REVIEW", "TransactionReviewModalController", data, className);
      },
      searchInvestorModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_INIT_SEARCH", "SearchInvestorModalController", data, "md");
      },
      updateDBInvestorModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_INIT_UPDATE_DB", "SearchInvestorModalController", data, "md");
      },
      schemeListModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SCHEME_LIST", "SchemeListModalController", data, "lg");
      },
      initiateSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INITATE_SUCCESS", "TnitiateTransactionModalController", data, "md");
      },
      otpForApprovalModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_FOR_APPROVAL", "TnitiateTransactionModalController", data, "md");
      },
      rejectTransactionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INITATE_REJECTION", "TnitiateTransactionModalController", data, "md");
      },
      widgetStoreModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "WIDGET_SELECTION", "WidgetStoreModalController", data, "lg");
      },
      checkPanJointHolder: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHECK_PAN_JOINT_HOLDER", "AddJointHolderModalController", data, "md");
      },
      checkPanModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHECK_PAN", "PanVerificationModalController", data, "md");
      },
      changePasswordModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHEANGE_PASSWORD", "ChangePasswordModalController", data, "md");
      },
      editNomineeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EDIT_NOMINEE", "EditNomineeModalController", data, "md");
      },
      succInvestorModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUCCESS_INVESTOR", "AddInvestorModalController", data, "md");
      },
      fileDownloadModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FILE_DOWNLOAD", "FileDownloadController", data, "md");
      },
      sendFileDownloadModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SEND_FILE_DOWNLOAD", "FileDownloadController", data, "md");
      },
      brokerageDownloadModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "BROCKERAGE_REPORT_DOWNLOAD", "FileDownloadController", data, "md");
      },
      bankPaymentMakeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "BANK_MAKE_PAYMENT", "BankPaymentModalController", data, "md");
      },
      bankPaymentSummeryModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "BANK_PAYMENT_SUMMERY", "BankPaymentModalController", data, "md");
      },
      termConditionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION", "TermConditionModalController", data, "lg tandCModalCommon");
      },
      termsAndConditionsEMandateModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION_E_MANDATE", "TermConditionModalController", data, "lg");
      },
      tpvModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TPV_MODAL", "tpvController", data, "md");
      },
      termsAndConditionEcartModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION_E_CART", "TermConditionModalController", data, "lg");
      },
      termConditionSummaryModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION_SUMMARY", "TermConditionModalController", data, "lg");
      },
      termConditionInitTransactionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TERM_CONDITION_INIT_TRAN", "TermConditionModalController", data, "lg");
      },
      empanellmentTandCModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EMPANELLMENT_TANDC_MODAL", "DistributorTAndCModalController", data, "lg empanelModalCustomCss");
      },
      empanellSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EMPANELLMENT_SUCCESS_MODAL", "EmpanellmentSuccessModalController", data, "lg");
      },
      proceedtoLoginModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PROCEED_LOGIN", "SuccessModalController", data, "lg");
      },
      leapAcademyRegisterModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LEAPACADEMY_REGISTER", "LeapAcademyModalController", data, "lg");
      },
      leapAcademyAgendaModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LEAPACADEMY_AGENDA", "LeapAcademyModalController", data, "lg");
      },
      leapAcademyVideoModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LEAPACADEMY_VIDEO", "LeapAcademyModalController", data, "md");
      },
      leapAcademySuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "LEAPACADEMY_SUCCESS", "LeapAcademyModalController", data, "lg");
      },
      notificationDetailModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NOTIFICATION_DETAILS", "NotificationModalController", data, "md");
      },
      confirmCancelModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL", "ConfirmCancelController", data, "md");
      },
      confirmSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_SUCCESS", "ConfirmCancelController", data, "md");
      },
      investorStatementModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INVESTOR_STATEMENT", "InvestorStatementModalController", data, "md");
      },
      updateInvestorModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "UPDATE_INVESTOR", "UpdateInvestorModalController", data, "md");
      },
      feedbackModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FEEDBACK_SUCCESS", "FeedbackModalController", data, "md");
      },
      editDashboardSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DASHBOARD_EDIT_SUCCESS", "EditDashboardController", data, "md");
      },
      investmentSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INVESTMENT_SUCCESS", "InvestorApprovalModalController", data, "mid-md");
      },
      rejectionReasonModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REJECTION_REASON", "InvestorApprovalModalController", data, "mid-md");
      },
      rejectionApprovalModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REJECTION_APPROVAL", "InvestorApprovalModalController", data, "mid-md");
      },
      transactionWarningModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_WARNING", "TransactionWarningController", data, "md");
      },
      successMessageModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUCCESS_MESSAGE", "SuccessModalController", data, "md");
      },
      nonOtmFolioDetailsModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NON_OTM_FOLIO_DETAILS", "NonOtmFolioDetailsController", data, "mid-md");
      },
      agentCreateAgentSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CREATE_AGENT_SUCCESSFUL", "AgentCreateAgentSuccessModalController", data, "md");
      },
      agentMessageModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "AGENT_MSG_TEMPLATE", "AgentCreateAgentSuccessModalController", data, "md");
      },
      agentChangePasswordSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_AGENT_PASSWORD_SUCCESSFUL", "AgentChangePasswordSuccessModalController", data, "md");
      },
      showAgentDraft: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "AGENT_DRAFT", "AgentDraftController", data, "md");
      },
      rollOverOverviewModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ROLL_OVER_OVERVIEW", "RollOverModalController", data, "sm");
      },
      imagePreviewModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "IMAGE_PREVIEW", "ImagePreviewModalController", data, "md");
      },
      selectAccountNoModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SELECT_ACCOUNT_NO", "SelectAccountNoModalController", data, "md");
      },
      addBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_BANK", "ModifyBankModalController", data, "md");
      },
      deleteBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DELETE_BANK", "ModifyBankModalController", data, "md");
      },
      deleteBankSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DELETE_BANK_SUCCESS", "ModifyBankModalController", data, "md");
      },
      changeBankSuccessModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_BANK_SUCCESS", "ModifyBankModalController", data, "md");
      },
      changeDefaultBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_DEFAULT_BANK", "ModifyBankModalController", data, "md");
      },
      rejectBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REJECT_BANK_SUCCESS", "ModifyBankModalController", data, "md");
      },
      widgetCampaignModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "WIDGET_CAMPAIGN", "WidgetCampaignModalController", data, "md");
      },
      systematicCancellation: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SYSTEMATIC_CANCELLATION_SUCCESS", "SystematicCancellationModalController", data, "md");
      },
      sipPauseConfirmation: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_PAUSE_CONFIRMATION_SUCCESS", "SipPauseConfirmatonModalController", data, "md");
      },
      initialLogin: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INITIAL_LOGIN", "InitialLoginModalController", data, "md");
      },
      IFSCSelectionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "IFSC_SELECTION", "IFSCSelection", data, "lg");
      },
      minorBankModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_BANK_MODAL", "PopupsModalController", data, "md");
      },
      minorSipModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_SIP_MODAL", "PopupsModalController", data, "md");
      },
      minorPurchaseModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "MINOR_PURCHASE_MODAL", "PopupsModalController", data, "md");
      },
      cutOffModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CUT_OFF", "ConfirmCancelController", data, "md");
      },
      liquidPurchaseModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_LIQUID", "ConfirmCancelController", data, "md");
      },
      registerEMandateModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "REGISTER_EMANDATE", "RegisterModalController", data, "md");
      },
      cutOffModalLogin: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CUT_OFF_LOGIN", "CutOffLoginModalController", data, "md");
      },
      nonKycModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NON_KYC", "NonKycModalController", data, "md");
      },
      kycInitiateModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "KYC_INITIATE", "KycInitiateModalController", data, "md");
      },
      eKycModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "KYC_MAIL_SUCCESS", "KycModalController", data, "md");
      },
      cancelMandateModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_MANDATE", "CancelMandateController", data, "md");
      },
      confirmMandateModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_MANDATE", "ConfirmMandateController", data, "md");
      },
      addNominee: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_NOMINEE", "AddNomineeController", data, "lg");
      },
      cancelNominee: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CANCEL_NOMINEE", "CancelNomineeController", data, "md");
      },
      offlineNomineeFormModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OFFLINE_NOMINEE_FORM", "CancelNomineeController", data, "md");
      },
      nfoEnabledModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NFO_ENABLED", "NfoEnabledModalController", data, "md");
      },
      genericModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "GENERIC_MODAL", "GenericModalController", data, "md");
      },
      otpModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OTP_CONFIRM", "OtpModalController", data, "md");
      },
      subscribeToggleModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SUBSCRIBE_TOGGLE_MODAL", "SubscribeToggleController", data, "md");
      },
      termsAndConditionSip: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_TNC", "TermConditionModalController", data, "lg");
      },
      bulkSuccess: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "BULK_SUCCESS", "TnitiateTransactionModalController", data, "md");
      },
      nfoTransactionPointNotes:  function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NFO_POINT_NOTES", "NfoTransactionNotesModalController", data, "md");
      },
      termsAndConditionSmartSwap: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SMART_SWAP", "TermConditionModalController", data, "lg");
      },
      showExitLoadMessageModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SHOW_MESSAGE", "ShowExitLoadModalController", data, "md");
      },
      stayInvestedModal : function (data, successCallback,dismissCallback){
        openModal(successCallback,dismissCallback, "STAY_INVESTED", "StayInvestedController", data, "md");
      },
      genericSuccessModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "GENERIC_SUCCESS_MODAL", "GenericModalController", data, "md");
      },
      IFSCSelectionModalNewJourney: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "IFSC_SELECTION_NEW_JOURNEY", "IFSCSelectionNewJourney", data, "lg");
      },
      addJointHolderModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_JOINT_HOLDER", "AddJointHolderController", data, "md");
      },
      newInvestorDirectionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_INVESTOR_DIRECTION", "NewInvestorDirectionController", data, "md");
      },
      addDays: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ADD_DAYS", "AddDaysController", data, "lg");
      },
      newInvestorOtpVerify: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_INVESTOR_OTP_VERIFY", "NewInvestorOtpVerifyController", data, "md");
      },
      newJourneyFolioSwitchModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_JOURNEY_FOLIO_SWITCH", "NewJourneyFolioSwitchController", data, "md");
      },
      folioCreationOtpModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_CREATION_OTP_MODAL", "FolioCreationModalController", data, "md");
      },
      termsAndConditionFlexSip: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FLEX_SIP_TNC", "TermConditionModalController", data, "lg");
      },
      euinDeclarationOneClickModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "EUIN_DECLARATION_ONE_CLICK_MODAL", "EuinDeclarationOneClickModalController", data, "md");
      },
      confirmCancelSystematicModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL_SYSTEMATIC", "ConfirmCancelController", data, "md");
      },
      termsAndConditionModifySipOTM: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SIP_TNC_MODIFY_OTM", "TermConditionModalController", data, "lg");
      },
      folioSuccssModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_SUCCESS", "FolioCompletModalController", data, "md");
      },
      newJourneyFolioCondition: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_JOURNEY_FOLIO_CONDITION", "NewJourneyFolioConditionController", data, "md");
      },
      dreamSipChangeOptionModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "DREAM_SIP_CHANGE_OPTION", "OptionChangeController", data, "lg");
      },
      changeTargetSchemeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CHANGE_TARGET_SCHEME", "ChangeTargetSchemeController", data, "md");
      },
      dreamSchemeListModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_DREAM_SCHEME_LIST", "DreamSchemeListModalController", data, "lg");
      },
      dreamSipTenureModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "Dream_Sip_Tenure", "DreamSipTenureModalController", data, "md");
      },
      optOutNomineeModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OPT_OUT_NOMINEE_MODAL", "OptOutNomineeModalController", data, "md");
      },
      optOutNomineeModalSearch: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "OPT_OUT_NOMINEE_SEARCH_MODAL", "OptOutNomineeModalController", data, "md");
      },
      investorLinkStatusModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "INVESTORLINKSTATUS", "InvestorLinkStatusModalController", data, "md");
      },
      confirmCancelModalEcart: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "CONFIRM_CANCEL_ECART", "ConfirmCancelController", data, "md");
      },
      showNudgeReasons: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NUDGE_REASONS", "NudgeReasonsController",data, "md");
      },
      getTransactionTypeModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "GET_TRANSACTION_TYPE", "ConfirmCancelController", data, "md");
      },
      genericUiModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "GENERIC_UI_MODAL", "GenericUiModalController", data, "xl");
      },
      alertAndUpdateInfoModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "ALERT_AND_UPDATE_INFO", "AlertAndUpdateInfoController", data, "md alert-info-modal");
      },
      purchaseSchedulerRecomendationModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "PURCHASE_SCHEDULER_RECOMENDATION_MODAL", "PurchaseSchedulerRecomendationModal", data, "lg");
      },
      schemeInFundListModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "TRANSACTION_SCHEME_FUND_LIST", "SchemeInFundListModalController", data, "lg scheme-select-modal");
      },
      newJourneyFolioSelectModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NEW_JOURNEY_FOLIO_SELECT", "NewJourneyFolioSelectController", data, "md");
      },
      nonTransactionalTncModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "NON_TRANSACTIONAL_TERM_CONDITION", "TermConditionModalController", data, "lg");
      },
      fillFolioDetailsModal: function (data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "FOLIO_CHOICE_MODAL", "FolioChoiceModalController", data, "md");
      },
      selectFolioModal: function(data, successCallback, dismissCallback) {
        openModal(successCallback, dismissCallback, "SELECT_FOLIO", "SelectFolioModalController", data, "md");
      }
    }
  }
})();

(function() {
  angular
    .module('hdfc-mf-distributor-web')
    .factory('MetaTagService', metaTagService);
  function metaTagService(AppConstants , HDFC_API) {
    var tagsElements = [];
    var scriptTagsList = [];
    var _setMetaTags = function() {
      var tags = {
        'description': AppConstants.META_TAGS.LOGIN_DESCRIPTION,
        'title': AppConstants.META_TAGS.LOGIN_TITLE,
        'keywords': AppConstants.META_TAGS.KEYWORDS
      };
      _clearTags();
      angular.forEach(tags, function(content, name) {
        var tagElement = getTagElement(content, name);
        document.head.append(tagElement);
        tagsElements.push(tagElement);
      });
    };

    function _addScriptTag() {
      var tags = {
        'script': 'script'
      };
      _removeScriptTag();
      angular.forEach(tags, function() {
        var script = document.createElement('script');
        script.setAttribute('id', 'allincall-script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src',HDFC_API.ALL_IN_CALL);
        document.head.append(script);
        scriptTagsList.push(script);
      });
    }

    function _removeScriptTag() {
      angular.forEach(scriptTagsList, function(tagElement){
        document.head.removeChild(tagElement);
      });
      scriptTagsList.length = 0;
    }
    function getTagElement(content, name) {
        var nameAttr = (name.indexOf('og:') === 0) ? 'property' : 'name';
        var meta = document.createElement('meta');
        meta.setAttribute(nameAttr, name);
        meta.setAttribute('content', content);
        return meta;
    }
    function _clearTags() {
      angular.forEach(tagsElements, function(tagElement){
        document.head.removeChild(tagElement);
      });
      tagsElements.length = 0;
    }
    return {
      clearTags: _clearTags,
      setMetaTags: _setMetaTags,
      addScriptTag: _addScriptTag,
      removeScriptTag: _removeScriptTag
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('LeapAcademyService', leapAcademyService)
    .factory('DownloadPdfService', downloadPdfService);

  /** @ngInject */
  function leapAcademyService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child1/:child2/:child3';
    return $resource(_path, {}, {
      post: {
        method: 'POST', headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function downloadPdfService($http, $q, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var downloadFile = function (payload) {
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/leapacademy/articles/download';
      var deferred = $q.defer();

      $http.post(_path, payload, { 'responseType': 'arraybuffer' }).then(function (resp) {
        deferred.resolve(resp);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    var download = function (payload, type, exposedUrl) {
      type = type ? type : 'exitLoad';
      var statementPath = exposedUrl ? exposedUrl : '/statement/';
      var _path = '';
      var deferred = $q.defer();
      if (type === 'pdf' || type === 'tif' || type === 'tiff') {
        _path = exposedUrl;
        $http.get(_path, { 'responseType': 'arraybuffer' }).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      } else {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + statementPath + type;
        $http.post(_path, payload, { 'responseType': 'arraybuffer' }).then(function (resp) {
          deferred.resolve(resp);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }

    };

    return {
      downloadFile: downloadFile, download: download
    };

  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('InvestorsService', investorsService)
    .factory('InvestorsService4', investorsService4)
    .factory('InvestorsApiService', investorsApiService)
    .factory('NewInvestorServiceV3', newInvestorServiceV3)
    .factory('InvestorsCommonService', investorsCommonService)
    .factory('InvestorFileUploadService', investorFileUploadService)
    .factory('InvestorCommonServiceVersion2',investorCommonServiceVersion2)
    .factory('InvestorOtpVerifyService', investorOtpVerifyService)
    .factory('InvestorsServiceVersion', investorServiceVersion)
    .factory('InvestorsContactService',investorsContactService)
    .factory('InvestorsNewFolioContactService',investorsNewFolioContactService)
    .factory('InvestorServiceDynamicData',investorServiceDynamicData)
    .factory('ChequeLeafFileUploadService', chequeLeafFileUploadService)
    .factory('WhatsappTransactionService',whatsappTransactionService)
    .factory('InvestorCommonServiceVersion1',InvestorCommonServiceVersion1)
    .factory('InvestorServiceDreamSIPService',investorServiceDreamSIPService)
    .factory('NewInvestorFolioServiceV1',newInvestorFolioServiceV1);

  /** @ngInject */
  function investorsService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:arnCode/investor/:controller/:child1/:transactionType/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
  /** @ngInject */
  function investorsService4($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:arnCode/investor/:controller/:child1/:transactionType/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4',
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }
  function investorsApiService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + '/:child1/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function investorsNewFolioContactService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:arnCode/investor/:controller/:child1/:transactionType/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2',
          'app-type': 'W'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function investorsCommonService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function investorCommonServiceVersion2($resource, HDFC_API, $window) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2',
          'app-type': 'W'
        }
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'4',
          'app-type': 'W'
        }
      },
      get: {
        method: 'get'
      }
    });
  }



  /** @ngInject */
  function investorFileUploadService($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      }
    });
  }

  /** @ngInject */
  function investorOtpVerifyService($http, $q, HDFC_API) {
    var verifyOtp = function (path,token, payload) {
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + path;
      var deferred = $q.defer();

      $http.post(_path, payload, {headers: {'token': token, 'X-API-VERSION': '4',}}).then(function (resp) {
        deferred.resolve(resp);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    return{
      verifyOtp:verifyOtp
    }
  }

  /** @ngInject */
  function investorServiceVersion($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:arnCode/:controller/:child1/:transactionType/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W'
        }
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W',
          'X-API-VERSION': 2
        }
      }
    });
  }

  /** @ngInject */
  function investorsContactService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION_AGENT + '/:arnCode/investor/:controller/:child1/:transactionType/:child2/:child3/:child4/:child5';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'app-type': 'W'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
    function investorServiceDynamicData($resource, HDFC_API ,$window) {
      HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + "v1" + '/:child1/:child2/:child3/:child4/:child5';

      return $resource(_path, {}, {
        post: {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'app-type': 'W'
          }
        },
        post4: {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'X-API-VERSION':'4',
          }
        },
        get: {
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        },
        post2: {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'X-API-VERSION':2,
          }
        }
      });
    }

  /** @ngInject */
  function chequeLeafFileUploadService($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child0/:child1/:child2/:child3/:child4/:child5/:child6/:child7';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      }
    });
  }

  /** @ngInject */
  function whatsappTransactionService($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function investorServiceDreamSIPService($resource, HDFC_API ,$window) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + "v1" + '/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
    function InvestorCommonServiceVersion1($resource, HDFC_API ,$window, TransformResponse) {
      HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + "v1" + '/:child1/:child2/:child3/:child4/:child5/:child6';

      return $resource(_path, {}, {
        post: {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          }
        }, get: {
          method: 'get',
          transformResponse: TransformResponse.transformApiResponse
        }
      });
    }



/** @ngInject */
function newInvestorServiceV3($resource, HDFC_API, $window, TransformResponse) {
  HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
  var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v3/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

  return $resource(_path, {}, {
    post: {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
       'X-API-VERSION':'2'
      },
      transformResponse: TransformResponse.transformApiResponse
    },
    get: {
      method: 'get',
      transformResponse: TransformResponse.transformApiResponse
    }
  });
}

  /** @ngInject */
  function newInvestorFolioServiceV1($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API  = $window.HDFC_API?$window.HDFC_API:HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST  + 'v1/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('FormatterService', formatterService);

  /** @ngInject */
  function formatterService($window,HDFC_API,AppConstants) {
    var formatter  = new $window.JSEncrypt();

    var _getFormatterHDFC = function () {
      formatter.setKey(HDFC_API.HDFC_CONFIG_ENDPOINT);
      return formatter;
    };

    var _getFormatter = function () {
      formatter.setKey(AppConstants.CONFIG_ENDPOINT);
      return formatter;
    };


    return {
      getFormatterHDFC: _getFormatterHDFC,
      getFormatter : _getFormatter,
    }
  }
  })();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('FileUploadService', fileUploadService)
    .factory('DistributorFileUploadService', distributorFileUploadService);

  /** @ngInject */
  function fileUploadService($http,$q) {
    var uploadFileToUrl = function(file, uploadUrl){
      var deferred = $q.defer();
      var fd = new FormData();
      fd.append('file', file);
      $http.post(uploadUrl,fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function (resp) {
        deferred.resolve(resp.data||resp);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    return{
      uploadFileToUrl:uploadFileToUrl
    }
  }

  /** @ngInject */
  function distributorFileUploadService($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:child1/:child2/:child3/:child4/:child5/:child6';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('FeedbackService', feedbackService);

  /** @ngInject */
  function feedbackService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v1/feedback/:controller';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('EcartService', ecartService)
    .factory('CmsEcartService',cmsEcartService);

  /** @ngInject */
  function ecartService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API = $window.HDFC_API ? $window.HDFC_API : HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION_AGENT + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    var identifier = localStorage.getItem('token');

    return $resource(_path, {}, {
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      get2: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  /** @ngInject */
  function cmsEcartService($resource, HDFC_API, $window, TransformResponse) {
    HDFC_API = $window.HDFC_API ? $window.HDFC_API : HDFC_API;
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST_CMS + HDFC_API.VERSION_AGENT + '/:child1/:child2/:child3/:child4/:child5/:child6/:child7/:child8';

    var identifier = localStorage.getItem('token');

    return $resource(_path, {}, {
      get: {
        method: 'get',
        transformResponse: TransformResponse.transformApiResponse
      },
      get2: {
        method: 'get',
        headers: {
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        transformResponse: TransformResponse.transformApiResponse
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION':'2'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }
})();

/**
 * Created by ttn on 6/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('DistributorEmpanellmentService', distributorEmpanellmentService)
    .factory('DistributorProfileService', distributorProfileService)
    .factory('DistributorProfileUploadService', distributorProfileUploadService)
    .factory('DistributorGenericService', distributorGenericService)
    .factory('FileUploadGeneric', fileUploadGeneric)
    .factory('UppercrustService', uppercrustService)
    .factory('DistributorGenericServiceV2', distributorGenericServiceV2);


  /** @ngInject */
  function distributorEmpanellmentService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/empanelment/:controller';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '4'
        }
      }
    });
  }

  /** @ngInject */
  function distributorGenericService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child1/:child2/:child3';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function distributorProfileService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/profile/:controller/:child1/:child2';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function uppercrustService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + 'v1/profile/:controller/:child1/:child2';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  /** @ngInject */
  function distributorProfileUploadService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/profile/:controller/:child1';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined
        }
      }
    });
  }
  /** @ngInject */
  function fileUploadGeneric($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child1/:child2/:child3';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': undefined//'image/png'
        }
      }
    });

  }

  /** @ngInject */
  function distributorGenericServiceV2($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/:controller/:child1/:child2/:child3';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': '2'
        }
      }
    });
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('DashboardService', dashboardService)
    .factory('FundService', fundService)
    .factory('DashboardServiceV3', dashboardServiceV3)

  /** @ngInject */
  function dashboardService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/dashboard/:controller/:child1/:child2/:child3/:child4';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function fundService($resource, HDFC_API,TransformResponse) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.IHOST + HDFC_API.VERSION_AGENT + '/:child1/:child2/:child3/:child4/:child5';
    return $resource(_path, {}, {
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        },
        transformResponse: TransformResponse.transformApiResponse
      }
    });
  }

  function dashboardServiceV3($resource, HDFC_API) {

    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION_3 + '/:child1/:child2/:child3/:child4';
    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      post2: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-API-VERSION': 2
        }
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('BrowserService', browserService);

  /** @ngInject */
  function browserService($timeout, MessageService, $window, deviceDetector) {
    var _browserDetector = function() {
      if (deviceDetector.browser == 'chrome' && parseInt(deviceDetector.browser_version, 10) < '60') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      } else if (deviceDetector.browser == 'firefox' && parseInt(deviceDetector.browser_version, 10) < '50') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      } else if (deviceDetector.browser == 'ms-edge' && parseInt(deviceDetector.browser_version, 10) < '16') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      } else if (deviceDetector.browser == 'ie') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }
      return false;
    };

    return {
      browserDetector: _browserDetector,
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('MessageService', messageService);

  /** @ngInject */
  function messageService(AppConstants, toastr) {
    var MessageService = {};

    MessageService = {
      /*
       * show toastr successful message
       */
      success: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': false,
          'progressBar': true,
          'iconClasses': {
            success: 'toast-success'
          },
          'positionClass': 'toast-top-right',
          'preventDuplicates': false,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut'
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.SUCCESS;
        }
        messages = messages + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
        toastr.success(messages);
      },
      /*
       * show toastr failed message
       */
      error: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': true,
          'progressBar': true,
          'positionClass': 'toast-top-right',
          'preventDuplicates': true,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut',
          'maxOpened': 9,
          iconClasses: {
            error: 'toast-error'
          }
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.FAILED;
        }
        messages = messages + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
        toastr.error(messages);
      },
      /*
       * show toastr warning message
       */
      warning: function (messages) {
        toastr.options = {
          'closeButton': true,
          'debug': false,
          'newestOnTop': true,
          'progressBar': true,
          'positionClass': 'toast-top-right',
          'preventDuplicates': true,
          'onclick': null,
          'showDuration': '300',
          'extendedTimeOut': '1000',
          'showEasing': 'swing',
          'hideEasing': 'linear',
          'showMethod': 'fadeIn',
          'hideMethod': 'fadeOut',
          'maxOpened': 9,
          iconClasses: {
            error: 'toast-warning'
          }
        };
        if (!messages) {
          messages = AppConstants.ToastrMessage.FAILED;
        }
        messages = messages + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
        toastr.warning(messages);
      },

      /*
       * clear all queue messages
       */
      clear:function(){
      toastr.clear();
    }

  };

    return MessageService;
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('LoaderService', loaderService);

  /** @ngInject */
  function loaderService() {
    var _showLoader = function (ele) {
      if (ele) {
        angular.element(ele).css('display', 'block');
      } else {
        angular.element('.loader.main').css('display', 'block');
      }
    };
    var _hideLoader = function (ele) {
      if (ele) {
        angular.element(ele).css('display', 'none');
      } else {
        angular.element('.loader.main').css('display', 'none');
      }
    };

    return {
      showLoader: _showLoader,
      hideLoader: _hideLoader
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('BulkTransactionService', bulkTransactionService)
    .factory('BulkTransactionUploadService', bulkTransactionUpload)

  /** @ngInject */
  function bulkTransactionService($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + ':VERSION/:child1/:child2/:child3/:child4/:child5/:child6';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'app-type':'W'
        }
      },
      get: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function bulkTransactionUpload($resource, HDFC_API) {
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + ':VERSION/:child1/:child2/:child3/:child4/:child5/:child6';
    return $resource(_path, {}, {
      post: {
        method: 'POST',
        headers: {
          'Content-Type': undefined,
          'app-type':'W'
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .service('AuthService', authService);

  /** @ngInject */
  function authService($q, $http, $cookies, HDFC_API, UserService, $timeout, $interval, MessageService, UtilService, $state, TransactionInitiateModel, AppConstants, $window, FormatterService) {
    var vm = this, currentUser = null, intervalListener = null;

    /**
     * function generatePassForSeamLessLogin
     * @return {Promise}
     */
    vm.generatePassForSeamLessLogin = function () {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME,
        success = function (resp) {
          deferred.resolve(resp.data);
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http.get(_path, {}).then(success, error);
      return deferred.promise;
    };

    /**
     * Authenticate user  -> with 2FA otp validate
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.validateLogin = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + 'two/factor/authentication',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            vm.clearCookie();
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          deferred.reject(err);
        };


      var header = {
        'Authorization': UtilService.converter('M17GjcPxvjPBIisqNoWpZ9eqcOxZtII7mTsidDthbron4-PTtVYutjTMY_wnc8rhfqQqbFarJg-IkOzPopM8czCNrkI7lyxrL903yTnHfojShcp67rlvBiQ7ffvssYiYoU9MFXfmAxphbsrirscMCWfPZpf8MxEzCjYyZqo0_qY='),
        'Content-Type': 'application/x-www-form-urlencoded',
        'app-type': 'W'
      };


      $http({
        method: 'POST',
        url: _path,
        headers: header,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data:payload
      }).then(success, error);
      return deferred.promise;
    };
    /**
     * Authenticate user and save token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.login = function (payload, type, secretLink, schemeCode) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + 'v1/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['arnCode'] = payload.arnCode;
            sessionStorage.setItem('brokerCodePanAdhar', resp.data['arnCode']);
            resp.data['loginType'] = 'D';
            // $cookies.put('token_data', angular.toJson(resp.data));
            resp.data["investInFund"] = schemeCode ? true: false;
            resp.data["schemeCode"] = schemeCode;
            vm.setToken(resp.data);
            sessionStorage.isLoggedIn = true;
            currentUser = resp.data;
            setIntervalToRefreshToken();
            $timeout(function () {
              deferred.resolve(resp.data);
            }, 1000);
          } else {
            vm.clearCookie();
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          deferred.reject(err);
        };

      if (type === 'ThroughPassword') {
        var header = {
          'Authorization': UtilService.converter('M17GjcPxvjPBIisqNoWpZ9eqcOxZtII7mTsidDthbron4-PTtVYutjTMY_wnc8rhfqQqbFarJg-IkOzPopM8czCNrkI7lyxrL903yTnHfojShcp67rlvBiQ7ffvssYiYoU9MFXfmAxphbsrirscMCWfPZpf8MxEzCjYyZqo0_qY='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W',
          'X-API-VERSION': '4',
          'login-type': 'OTP',
          'secret-link': secretLink
        }
      }

      else if (type === 'OTP') {
        header = {
          'Authorization': UtilService.converter('M17GjcPxvjPBIisqNoWpZ9eqcOxZtII7mTsidDthbron4-PTtVYutjTMY_wnc8rhfqQqbFarJg-IkOzPopM8czCNrkI7lyxrL903yTnHfojShcp67rlvBiQ7ffvssYiYoU9MFXfmAxphbsrirscMCWfPZpf8MxEzCjYyZqo0_qY='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W',
          'X-API-VERSION': '4',
          'login-type': type,
          'secret-link': secretLink
        }
      }

      var data = {
        "grant_type": "password",
        "username": vm.encryptRSA(angular.copy(payload.arnCode)),
        "password": payload.password
      };

      if (type === 'OTP') {
        data["pan"] = payload.pan
      }

      if(payload.gRecaptchaResponse){
        data.gRecaptchaResponse = payload.gRecaptchaResponse;
      }
      $http({
        method: 'POST',
        url: _path,
        headers: header,
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: data
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * function callCommonServiceUrl
     *
     * @return {Promise}
     */
    vm.callCommonServiceUrl = function () {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/transaction/update',
        success = function (resp) {
          deferred.resolve(resp.data);
        }, error = function (err) {
          deferred.reject(err);
        };
      $http.post(_path, null, {
        timeout: 120000
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Get refresh token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.getRefreshToken = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + 'v1/oauth/token',
        success = function (resp) {
          if (resp.data && resp.data.access_token) {
            resp.data['arnCode'] = payload.arnCode;
            resp.data['loginType'] = 'D';
            // $cookies.put('token_data', angular.toJson(resp.data));
            vm.setToken(resp.data);
            setIntervalToRefreshToken();
            currentUser = resp.data;
            deferred.resolve(resp.data);
          } else {
            vm.clearCookie();
            MessageService.clear();
            UtilService.errorHandler({message: "Session has been expired. Please login to continue."});
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          MessageService.clear();
          UtilService.errorHandler({message: "Session has been expired. Please login to continue."});
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': UtilService.converter('M17GjcPxvjPBIisqNoWpZ9eqcOxZtII7mTsidDthbron4-PTtVYutjTMY_wnc8rhfqQqbFarJg-IkOzPopM8czCNrkI7lyxrL903yTnHfojShcp67rlvBiQ7ffvssYiYoU9MFXfmAxphbsrirscMCWfPZpf8MxEzCjYyZqo0_qY='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "refresh_token",
          "refresh_token": payload.refresh_token
        }
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will send an email with new password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.forgotPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/password/forgot',
        success = function (resp) {
          if (resp.data) {
            deferred.resolve(resp.data);
          }
          // else {
          //   deferred.reject(resp.data);
          // }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {'X-API-VERSION': '4','app-type': 'W'},
        data: payload
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will verify new password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.verifyForgotPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/password/forgot/request/verify',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.resolve(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {'app-type': 'W'},
        data: {arnCode: payload.arnCode, secretKey: payload.secretKey}
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will reset password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.resetPassword = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/password/reset',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };
      payload['passwordResetEnable'] = true;
      $http({method: 'POST', url: _path, data: payload}).then(success, error);
      return deferred.promise;
    };

    vm.changePassword = function (payload, switchUrl) {
      var deferred = $q.defer();
      if (switchUrl) {
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/change-password-expiry';
      }
      else {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/change-password';
      }
      var success = function (resp) {
          if (resp && resp.data) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: payload}).then(success, error);
      return deferred.promise;
    };

    /**
     * Will generate a new one time password
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.generateOtp = function (payload, from) {

      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/generate';

      var headers =  {'app-type': 'W', 'X-API-VERSION': '4'};
      if (from === 'fromLogin') {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/login/otp/generate'
      }

      var success = function (resp) {
          if (resp.data && resp.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: headers,
        data: payload
      }).then(success, error);
      return deferred.promise;
    };

    /**
     * Will regenerate a new one time password
     *
     * @param registrationRequestId     - user registration Id
     * @return {Promise}
     */
    vm.reGenerateOtp = function (registrationRequestId, payload, from) {
      var deferred = $q.defer();


      if (from === 'fromLogin') {
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/login/otp/resend';
        var data = payload;
      }
      else {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/regenerate';
        data = {registrationRequestId: registrationRequestId};
      }
      var success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: data, headers: {'X-API-VERSION': '4', 'app-type': 'W'}}).then(success, error);
      return deferred.promise;
    };

    /**
     * Will verify new generated otp
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
    vm.verifyOtp = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/verify',
        success = function (resp) {
          if (resp.data && resp.data.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          deferred.reject(err);
        };

      $http({method: 'POST', url: _path, data: payload}).then(success, error);
      return deferred.promise;
    };

        /**
     * Will verify new encrypt generated otp
     *
     * @param  {Object}   payload     - user info
     * @return {Promise}
     */
         vm.verifyEncryptOtp = function (payload) {
          var deferred = $q.defer(),
            _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/registration/otp/verify',
            success = function (resp) {
              if (resp.data && resp.data.status) {
                deferred.resolve(resp.data);
              } else {
                deferred.reject(resp.data);
              }
            },
            error = function (err) {
              deferred.reject(err);
            };

          $http({method: 'POST', url: _path,headers: {
            'X-API-VERSION': '4'
          }, data: payload}).then(success, error);
          return deferred.promise;
        };
    /**
     * removes token when user logged out
     */
    vm.logout = function () {
      var deferred = $q.defer(),
        identifier = vm.getToken(),_path;
      if ($window.location.pathname.includes('agent')) {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST_AGENT + HDFC_API.VERSION_AGENT + '/logout';
      } else {
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/logout';
      }
      var success = function (resp) {
          vm.clearCookie();
          // vm.clearCookie();
          localStorage.removeItem('nonOtmPopupClosed');
          sessionStorage.removeItem('modifySipData');
          sessionStorage.removeItem('assetType');
          if (resp.data && resp.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          deferred.reject(err);
        };

      if (identifier && identifier.access_token) {
        $http.post(_path, null, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(success, error);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    };

    /**
     * Verify password reset token
     *
     * @param  {String}   identifier
     * @return {Promise}
     */
    vm.verifyToken = function (identifier) {
      var deferred = $q.defer();
      UserService.verifyToken({
        token: identifier
      }, function (user) {
        deferred.resolve(user);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    };

    /**
     * Gets all available info on authenticated user
     *
     * @return {Object} user
     */
    vm.getCurrentUser = function () {
      var deferred = $q.defer();
      if (currentUser) {
        deferred.resolve(currentUser);
      } else if (!currentUser && vm.getToken()) {
        currentUser = vm.getToken();
        deferred.resolve(currentUser);
      } else {
        vm.clearCookie();
        deferred.reject('User not logged-in');
      }
      return deferred.promise;
    };

    /**
     * get role of logged in user
     *
     * @return {String}
     */
    vm.getRole = function () {
      if (currentUser && currentUser.hasOwnProperty('role')) {
        return currentUser.role;
      }
      return null;
    };

    /**
     * Waits for currentUser to resolve before checking if user is logged in
     */
    vm.isLoggedIn = function () {
      var identifier = vm.getToken();
      var deferred = $q.defer();
      if (!identifier) {
        deferred.resolve(false);
      }else if (!sessionStorage.isLoggedIn) {
        deferred.resolve(false);
      } else if (!currentUser) {
        vm.getCurrentUser().then(function (user) {
          currentUser = user;
          deferred.resolve(true);
        }, function () {
          vm.clearCookie();
          deferred.resolve(false);
        });
      } else if (currentUser) {
        deferred.resolve(true);
      } else if (currentUser.hasOwnProperty('role')) {
        deferred.resolve(true);
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    };

    /**
     * Get user token
     */
    vm.getToken = function () {
      var ciphertext = $cookies.get(AppConstants.IDENTIFIER);
      /*Decrypt*/
      if(ciphertext){
        var bytes = $window.CryptoJS.AES.decrypt(ciphertext.toString(), AppConstants.IDENTIFIER);
        return $window.JSON.parse(bytes.toString($window.CryptoJS.enc.Utf8));
      }else{
        return;
      }
    };
    /**
     * This function is used to check initial login by user
     * @param arnCode
     * @returns {Function}
     */
    vm.isInitialLogin = function (arnCode) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/profile',
        success = function (resp) {
          (resp && resp.data) ? deferred.resolve(resp.data) : deferred.resolve(resp);
        },
        error = function (err) {
          deferred.reject(err);
        };
      $http.post(_path,
        {arnCode: arnCode}
      ).then(success, error);
      return deferred.promise;
    };

    function setIntervalToRefreshToken() {
      var identifier = vm.getToken();
      if (!identifier) {
        $state.go('login');
        vm.clearCookie();
        UtilService.errorHandler({message: "Session has been expired. Please login to continue."});
        return;
      }

      var expiresIn = !isNaN(identifier.expires_in) && (+identifier.expires_in) || 0;

      if (!expiresIn) {
        vm.clearCookie();
        $state.go('login');
        UtilService.errorHandler({message: "Session has been expired. Please login to continue."});
        return;
      }

      var interval = (expiresIn - (expiresIn * 0.1)) * 1000;
      if (intervalListener) {
        $interval.cancel(intervalListener);
        intervalListener = null;
      }

      intervalListener = $interval(function () {
        vm.getRefreshToken(identifier).then(null, function () {
          if (identifier.loginType == 'A') {
            $state.go('agent.login')
          } else {
            $state.go('login');
          }
        });
      }, interval);
    }

    vm.clearCookie = function () {
      intervalListener && $interval.cancel(intervalListener);
      intervalListener = null;
      // $cookies.remove('token_data');
      $cookies.remove(AppConstants.IDENTIFIER, AppConstants.COOKIE_CONFIG);
      currentUser = null;
      TransactionInitiateModel.setPurchasePayload(null);
      TransactionInitiateModel.setSipPayload(null);
      TransactionInitiateModel.setInvestorPayload(null);
      localStorage.removeItem('isWelcomeMessageShown');
    };


    /**
     * Authenticate user and save token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */
    vm.agentLogin = function (payload) {
      var deferred = $q.defer(),
        _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + 'v1/oauth/token',
        success = function (resp) {
          //TODO: remove this line-
          //resp.data.role = 'Agent';
          if (resp.data && resp.data.access_token) {
            resp.data['userId'] = payload.userId;
            resp.data['loginType'] = 'A';
            resp.data['isDistributor'] = false;
            // $cookies.put('token_data', angular.toJson(resp.data));
            vm.setToken(resp.data);
            sessionStorage.isLoggedIn = true;
            currentUser = resp.data;
            setIntervalToRefreshToken();
            $timeout(function () {
              deferred.resolve(resp.data);
            }, 1000);
          } else {
            vm.clearCookie();
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          deferred.reject(err);
        };

      $http({
        method: 'POST',
        url: _path,
        headers: {
          'Authorization': UtilService.converter('dAU3oQB6Kj-_18r5eMBzpO4MwrQMmMDW6WPGM6x2Cgal_tgfCVuV7H3uGlBorz9jTW0_Zc4v7UUPTyzUq0J9utGGEDhdOqccOJ9pyJ3pPiGsO95PHkgbfMEq50mx4TwuxK5Evc9srhYakizZtMo7wVzD0yzxcYrieNVjfjsw1Ik='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-type': 'W'
        },
        transformRequest: function (obj) {
          var str = [];
          for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          return str.join("&");
        },
        data: {
          "grant_type": "password",
          "username": payload.userId,
          "password": payload.password
        }
      }).then(success, error);
      return deferred.promise;
    };

    vm.agentLogout = function () {
      var deferred = $q.defer(),
        identifier = vm.getToken(),
        _path = HDFC_API.PROTOCOL + HDFC_API.HOST_AGENT + HDFC_API.VERSION_AGENT + '/logout',
        success = function (resp) {
          vm.clearCookie();
          sessionStorage.clear();
          localStorage.clear();
          if (resp.data && resp.status) {
            deferred.resolve(resp.data);
          } else {
            deferred.reject(resp.data);
          }
        },
        error = function (err) {
          vm.clearCookie();
          sessionStorage.clear();
          localStorage.clear();
          deferred.reject(err);
        };

      if (identifier && identifier.access_token) {
        $http.post(_path, null, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(success, error);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    };
    /**
     * Set the cookies with encrypted token name
     */
    vm.setToken = function (data) {
      /*Encrypt*/
      var config = {
        secure: true,
        path: HDFC_API.PATH
      };
      var ciphertext = $window.CryptoJS.AES.encrypt($window.JSON.stringify(data), AppConstants.IDENTIFIER);
      $cookies.put(AppConstants.IDENTIFIER, ciphertext, AppConstants.COOKIE_CONFIG);
    }
    /**
     * Set the password with RSA encrypted
     */
    vm.encryptRSA = function (data) {
      return FormatterService.getFormatter().encrypt(data);
    }

  /**
     * Authenticate instant user and save token
     *
     * @param  {Object}   payload     - login info
     * @return {Promise}
     */

   vm.InstantLogin = function (payload) {
    vm.arn = false;
    var deferred = $q.defer(),
      _path = HDFC_API.PROTOCOL + HDFC_API.OAUTH_HOST + 'v1' + '/oauth/token',
      success = function (resp) {
        if (resp.data && resp.data.access_token) {
          $cookies.remove(AppConstants.INSTA_IDENTIFIER, AppConstants.COOKIE_CONFIG);
          currentUser = null;
          vm.setToken(resp.data);
          currentUser = resp.data;
          deferred.resolve(currentUser);

        } else {
          $cookies.remove(AppConstants.INSTA_IDENTIFIER, AppConstants.COOKIE_CONFIG);
          currentUser = null;
          deferred.reject(resp.data);
        }
      },
      error = function (err) {
        $cookies.remove(AppConstants.INSTA_IDENTIFIER, AppConstants.COOKIE_CONFIG);
          currentUser = null;
        deferred.reject(err);
      };

      if(payload.type == 'arn'){
        var header = {
          'Authorization': UtilService.converter('ObwqCoUIiFXIH4GQHm_3YvpGSxUpPKIhXswAXSucFUZxuvVFOfRUVVI5LZVaePMx9t3LBQ3eBuD4vIxoLDgfDgWCElHR-t85nKAR_OVhiPMYxnqsoRpIO9Hlhl9ekK-IzMmfmabEyzjteot4EuIkKvhn1pIgAWqf8_TadVy6kq0='),
          'Content-Type': 'application/x-www-form-urlencoded',
          'secret-link': '8b5c3102-5191-40fc-a5f4-6bb34ca798a1'
        };
        delete payload['type'];
        vm.arn = true;
      }

    $http({
      method: 'POST',
      url: _path,
      headers: header ,
      transformRequest: function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      },
      data: payload
    }).then(success, error);
    return deferred.promise;
  };

  }
})();

/**
 * Created by ttn on 6/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('AgentService', agentService);


  /** @ngInject */
  function agentService($resource, HDFC_API) {
    /*
     * value of :controller could be one of search, snapshot, summary or total-sum
     * */
    var _path = HDFC_API.PROTOCOL + HDFC_API.HOST_AGENT + HDFC_API.VERSION_AGENT +'/:controller/:child1/:child2/:child3/:child4';

    return $resource(_path, {}, {
      post: {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      get: {
        method: 'get'
      }
    });
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FundsMaturingController', fundsMaturingController);

  /** @ngInject */
  function fundsMaturingController($window, DashboardService, LoaderService, $timeout, UtilService, AppConstants, MessageService) {

    var vm = this;
    vm.isLoading = false;
    vm.getFundsMaturingData = getFundsMaturingData;
    vm.reInitPayload = reInitPayload;

    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];

    vm.dateFilter = {startDate: null, endDate: null};
    vm.fundsMaturingList = null;
    vm.isPagination = false;
    vm.totalTransactions = 0;
    vm.selectedType = null;
    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'DESC',
      searchText: ''
    };
    vm.currentPage = 1;
    vm.searchText = '';

    var fundsMaturingListPayload = {
      fromDate: '',
      pageIndex: vm.currentPage,
      pageLimit: vm.selectedPageLimit,
      searchText: '',
      toDate: ''
    };

    vm.init = function () {
      fundsMaturingListPayload.sortValue = vm.sortOrder.sortValue;
      fundsMaturingListPayload.sortKey = vm.sortOrder.sortKey;
      getFundsMaturingData(fundsMaturingListPayload);
    };

    vm.searchList = function () {

      if (vm.isSearching) {
        return;
      }
      else if (vm.searchText.length > 3 || vm.searchText == '') {

        vm.isSearching = true;
        fundsMaturingListPayload.searchText = vm.searchText;
        vm.currentPage = 1;
        fundsMaturingListPayload.pageIndex = vm.currentPage;
        fundsMaturingListPayload.pageLimit = vm.selectedPageLimit;
        getFundsMaturingData(fundsMaturingListPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);

      }

    };

    vm.filterByHeader = function () {
      resetDefaults();
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      fundsMaturingListPayload.sortKey = vm.sortOrder.sortKey;
      fundsMaturingListPayload.sortValue = vm.sortOrder.sortValue;
      getFundsMaturingData(fundsMaturingListPayload);
    };

    function getFundsMaturingData(payload) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.fundsMaturingList = resp.data.transactionList;
            vm.totalFundsMaturingList = resp.data.totalTransactions;
            vm.isPagination = !!(vm.fundsMaturingList && vm.fundsMaturingList.length);
          } else {
            vm.fundsMaturingList = null;
            vm.totalFundsMaturingList = 0;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
          vm.sortOrder.searchText = '';
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.fundsMaturingList = null;
          vm.totalFundsMaturingList = 0;
          vm.isLoading = false;
          vm.isPagination = false;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      vm.isLoading = true;
      payload.pageIndex = vm.currentPage - 1;
      payload.pageLimit = vm.selectedPageLimit;
      DashboardService.post({
        controller: 'investors',
        child1: 'fundsmaturing'
      }, payload).$promise.then(success, error);
    }

    vm.limitChanged = function () {
      vm.currentPage = 1;
      fundsMaturingListPayload.pageIndex = vm.currentPage;
      fundsMaturingListPayload.pageLimit = vm.selectedPageLimit;
      getFundsMaturingData(fundsMaturingListPayload);
    };

    vm.filterByDate = function (dateFilter) {

      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          getFundsMaturingData(fundsMaturingListPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        getFundsMaturingData(fundsMaturingListPayload);
      }
    };

    function reInitPayload () {
      fundsMaturingListPayload.fromDate = vm.dateFilter.startDate ? $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
      fundsMaturingListPayload.toDate = vm.dateFilter.endDate ? $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
      fundsMaturingListPayload.pageIndex = vm.currentPage;
      fundsMaturingListPayload.pageLimit = vm.selectedPageLimit;
    }

    var resetDefaults = function () {
      vm.currentPage = 1;
      vm.fromCount = 0;
      vm.toCount = 0;
      vm.totalFundsMaturingList = 0;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.fundsMaturingList = null;
      vm.isPagination = false;
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FundsMaturedController', fundsMaturedController);

  /** @ngInject */
  function fundsMaturedController($window, DashboardService, LoaderService, $timeout, UtilService, AppConstants, MessageService) {

    var vm = this;
    vm.isLoading = false;
    vm.getFundsMaturedData = getFundsMaturedData;
    vm.reInitPayload = reInitPayload;

    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];

    vm.dateFilter = {startDate: null, endDate: null};
    vm.fundsMaturedList = null;
    vm.isPagination = false;
    vm.totalTransactions = 0;
    vm.selectedType = null;
    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'DESC',
      searchText: ''
    };
    vm.currentPage = 1;
    vm.searchText = '';

    var fundsMaturedListPayload = {
      fromDate: '',
      pageIndex: vm.currentPage,
      pageLimit: vm.selectedPageLimit,
      searchText: '',
      toDate: ''
    };

    vm.init = function () {
      fundsMaturedListPayload.sortValue = vm.sortOrder.sortValue;
      fundsMaturedListPayload.sortKey = vm.sortOrder.sortKey;
      getFundsMaturedData(fundsMaturedListPayload);
    };

    vm.searchList = function () {

      if (vm.isSearching) {
        return;
      }
      else if (vm.searchText.length > 3 || vm.searchText == '') {

        vm.isSearching = true;
        fundsMaturedListPayload.searchText = vm.searchText;
        vm.currentPage = 1;
        fundsMaturedListPayload.pageIndex = vm.currentPage;
        fundsMaturedListPayload.pageLimit = vm.selectedPageLimit;
        getFundsMaturedData(fundsMaturedListPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);

      }

    };

    vm.filterByHeader = function () {
      resetDefaults();
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      fundsMaturedListPayload.sortKey = vm.sortOrder.sortKey;
      fundsMaturedListPayload.sortValue = vm.sortOrder.sortValue;
      getFundsMaturedData(fundsMaturedListPayload);
    };

    function getFundsMaturedData(payload) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.fundsMaturedList = resp.data.transactionList;
            vm.totalFundsMaturedList = resp.data.totalTransactions;
            vm.isPagination = !!(vm.fundsMaturedList && vm.fundsMaturedList.length);
          } else {
            vm.fundsMaturedList = null;
            vm.totalFundsMaturedList = 0;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
          vm.sortOrder.searchText = '';
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.fundsMaturedList = null;
          vm.totalFundsMaturedList = 0;
          vm.isLoading = false;
          vm.isPagination = false;
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      vm.isLoading = true;
      payload.pageIndex = vm.currentPage - 1;
      payload.pageLimit = vm.selectedPageLimit;
      DashboardService.post({
        controller: 'investors',
        child1: 'fundsmatured'
      }, payload).$promise.then(success, error);
    }

    vm.limitChanged = function () {
      vm.currentPage = 1;
      fundsMaturedListPayload.pageIndex = vm.currentPage;
      fundsMaturedListPayload.pageLimit = vm.selectedPageLimit;
      getFundsMaturedData(fundsMaturedListPayload);
    };

    vm.filterByDate = function (dateFilter) {

      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          getFundsMaturedData(fundsMaturedListPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        getFundsMaturedData(fundsMaturedListPayload);
      }
    };

    function reInitPayload () {
      fundsMaturedListPayload.fromDate = vm.dateFilter.startDate ? $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
      fundsMaturedListPayload.toDate = vm.dateFilter.endDate ? $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
      fundsMaturedListPayload.pageIndex = vm.currentPage;
      fundsMaturedListPayload.pageLimit = vm.selectedPageLimit;
    }

    var resetDefaults = function () {
      vm.currentPage = 1;
      vm.fromCount = 0;
      vm.toCount = 0;
      vm.totalFundsMaturedList = 0;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.fundsMaturedList = null;
      vm.isPagination = false;
    };

  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .controller('NewInvestorPaymentController', NewInvestorPaymentController);
    /** @ngInject */
    function NewInvestorPaymentController($window,MessageService,UtilService, $sce,ModalService, $rootScope, $timeout, $state, $stateParams, $scope, AuthService, HDFC_API, toastr, LoaderService, AppConstants,NewInvestorTransactionService,UtilityService,InvestorsService,ChangeDividendService,ChequeLeafFileUploadService, DownloadPdfService, FileSaver, PaymentService) {
      var vm = this;
      vm.userName = '';
      $rootScope.myState = $state.current.url;
      vm.investorDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
      vm.PaymentMode = "Net Banking";
      vm.upiPaymet = {};
      vm.hdfcFundTransferObj = {};
      vm.upiPaymet.bank = '';
      vm.upiPaymet.upiID = '';
      vm.purchaseBillDeskUrl = $sce.trustAsResourceUrl(HDFC_API.BILLDESK_PURCHASE_URL);
      vm.tncURL = HDFC_API.TNC_OF_APPROVAL;
      $scope.billdeskUrl = HDFC_API.BILLDESK_URL;
      vm.billdeskPayload = {
        hidRequestId : "PGIME1000",
        hidOperation : "ME100",
        msg : ""
      };
      vm.isbuttonClicked = false;
      vm.expiryPayment = function(){
        if(vm.investorDetails === null || !JSON.parse(sessionStorage.getItem('folioDetails'))){
          LoaderService.showLoader();
          MessageService.error("This unique link has already expired. Contact system admin.");
        }
      }
      vm.expiryPayment();
      vm.TRANSACTION = angular.copy(AppConstants.INVESTMENT_OPTIONS);
      vm.openModel = function(){
        var Success = function (data) {
          alert("Hello");
        };
        var confirmError = function () {
          alert("Exit");
        };
        ModalService.addDays({sipName:'HDFC ARBITRAGE FUND - Wholesale Monthly IDCW Option ',
        amount:5000,frequency:'OM',paymentMode:{key:'EC'},
      schemeCode:'F123'}, Success, confirmError);
      }
      history.pushState(null, null, location.href);
      $window.onpopstate =function () {
        history.go(1);
      };
      vm.bankList = [];
      vm.bankInfo = {};
      vm.formData = {};
      vm.tpv = tpv;
      vm.folioBankData = null;
      vm.sipFirstInstallmentVisible = false;
      vm.IFSC_REGEX = AppConstants.ifsc_regex;
      vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
      vm.PATTERN = AppConstants;
      vm.isUPIVerified = false;
      vm.confirmation = false;
      vm.onlySipSummary = false;
      vm.onlySipInvestment = false;
      vm.netBankingAndUPIList = '';
      vm.formData.purchasePaymentOption = 'NETBANKING';
      vm.selectedUpiBank = selectedUpiBank;
      vm.getbankData = getbankData;
      vm.isUPIVerified = false;
      vm.rtgsForm = {};
      vm.TRANSACTIONS_CONST = {
        PAYMENT_OPTIONS: {
        EC: 'EC',
        SI: 'SI',
        OTM: 'OTM',
        EM: 'EM',
        //DEBIT: 'DEBIT',
        RTGS: 'RTGS',
        NETBANKING: 'NETBANKING',
        HDFC: 'HDFC',
        UPI: 'UPI',
        EMANDATE: 'E-mandate'
      },
      TRANSACTION_TYPE: {
        STP: 'STP',
        SIP: 'SIP',
        PURCHASE: 'PURCHASE',
        SWITCH: 'SWITCH',
        REDEMPTION: 'REDEMPTION',
        NFO_SWITCH_OUT: 'NFO_SWITCH_OUT',
        FLEX_INDEX: 'FLEX_INDEX',
        DTP: 'DTP',
        SWP: 'SWP',
        INSTANT_REDEMPTION: 'INSTANT_REDEMPTION',
        ROLLOVER: 'ROLLOVER',
        SIP_TOPUP: 'SIP-TOPUP',
        SCHEDULE_TRANSACTION_PURCHASE: 'SCHEDULE_TRANSACTION_PURCHASE',
        SCHEDULE_TRANSACTION_SWITCH: "SCHEDULE_TRANSACTION_SWITCH",
        SCHEDULE_TRANSACTION_REDEMPTION: "SCHEDULE_TRANSACTION_REDEMPTION",
        SMART_SWAP: 'SMART_SWAP'
      }
      }
      vm.setFormDataForNeft = setFormDataForNeft;

      // vm.investorInfo = null;
      vm.folioDraftId = "";
      vm.uuid = $stateParams.uuid;
      vm.init = function () {
            var success = function (resp) {
              vm.formData = resp.data;
              vm.formData.emailId = vm.investorDetails.soleApplicantDetail.email ? vm.investorDetails.soleApplicantDetail.email : vm.investorDetails.investorPanDetails.email;
              vm.formData.mobileNo = vm.investorDetails.soleApplicantDetail.mobileNo ? vm.investorDetails.soleApplicantDetail.mobileNo : vm.investorDetails.investorPanDetails.mobileNumber;
              LoaderService.hideLoader();
              vm.formData.purchasePaymentOption = 'NETBANKING';
              getbankData();
              vm.fetchBankList();
              vm.investmentType = vm.formData.investmentType;
              vm.transactionType = vm.formData.investmentType;
              if (vm.formData.investmentType == "SIP" && vm.formData.sipFI == false) {
                vm.onlySipInvestment = true;
                // vm.getBankForSip();
                vm.getNormalSIPBank();
              } else {
                if (vm.formData.investmentType == "SIP" && vm.formData.sipFI == true) {
                  vm.sipFirstInstallmentVisible = true;
               } else {
                  vm.sipFirstInstallmentVisible = false;
                }
                initActivity();
                vm.onlySipInvestment = false;
              }
              if(vm.formData.investmentType != "SIP"){
                vm.formData.purchasePaymentOption =  vm.formData.paymentMode;
                if(vm.formData.purchasePaymentOption=='WEB'|| vm.formData.purchasePaymentOption =='NETBANKING'){
                  vm.formData.purchasePaymentOption = 'NETBANKING';
                }
              }
              if(vm.formData.investmentType == "SIP" && vm.formData.sipFI == true){
                vm.formData.purchasePaymentOption = 'NETBANKING';
              }
              if(vm.formData.investmentType == "SIP" && vm.formData.sipFI == false){
                vm.formData.purchasePaymentOption = null;
              }

              if(vm.formData.investmentType != "SIP"){
                vm.changedPaymentOption();
              }
              if(vm.formData.investmentType == "SIP" && vm.formData.sipFI == true){
                vm.changedPaymentOption();
              }
            },
            error = function (err) {
                MessageService.error(AppConstants.ToastrMessage.FAILED);
            };
            vm.processFlag = false;
            LoaderService.showLoader('.pan-loader');
            ChangeDividendService.get({
              child1: 'v2',
              child2: 'distributorNewInvestor',
              child3: 'getTransacationDetailByPan',
              child4: vm.investorDetails.investorPanDetails.pan,
              child5: vm.investorDetails.arnCode
            }).$promise.then(success, error);
      }
      vm.init();
      vm.submitSipForm = function ($event) {
        // userSipActivityTracking(false, function (statusFlag) {
        approveTransaction($event)
        // });
      };
      function userSipActivityTracking(isProcessed, cb) {

        // /*Netcore Event Start*/
        // if (isProcessed && (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
        //   NetcoreEvntService.Complete_Transaction_SIP_IP(vm.formData, true);
        // }
        // /*Netcore Event End*/

        cb = cb || function () { };
        if (vm.transactionType != vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          cb(true);
        }
        var success = function (trackResp) {
          trackResp = trackResp.data || trackResp;
          LoaderService.hideLoader();
          cb(trackResp);
        }, error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
          cb(err);
        };
        LoaderService.showLoader();
        var userTrackerPayload = setUserTrackerPayload(isProcessed);
        UtilityService.post({
          child1: 'userBehavior',
          child2: 'addupdate'
        }, userTrackerPayload).$promise.then(success, error);
      }
      vm.sipBankData = [];
     vm.getNormalSIPBank = function(){
      var success = function (resp) {
        if(resp.status && resp.data){
          vm.formData.bankInfo = resp.data[0];
          vm.sipBankData = resp.data;
          vm.netBankingAndUPIList = resp.data;
        }else{
          MessageService.error(error.message);
        }
      },
      error = function (error) {
        MessageService.error(error.message);
      };
      UtilityService.post({ controller: 'bank',child: 'list',child1: 'dp'}, {
        trnxType: vm.investmentType,
        folioNumber: vm.formData.folioNumber,
        liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
      }).$promise.then(success, error);
    }
      function setUserTrackerPayload(isProcessed) {
        var _payload = {
          "trxnRefNo": $stateParams.trackId ? $stateParams.trackId : "", //required in case of update
          "trxnType": vm.formData.investmentType, //SIP, PURCHASE
          "loginType": AppConstants.LOGIN_TYPE.IP, //QI_WEB, IP_WEB, DP_WEB
          "step": "THIRD", // FIRST,SECOND,THIRD,FOURTH
          "schemeCd": vm.formData.purchaseInSchemeCode, // required
          "folioNo": vm.formData.folioNumber, // required
          "formData": vm.formData, // required
          "amount": vm.formData.purchaseAmount, //required
          "trxnStatus": isProcessed ? "PROCESSED" : "OPEN"  // OPEN,PROCESSED
        };
        return _payload;
      }
      function approveTransaction($event) {
        var payload = getSipPayload();
        if (!payload) {
          MessageService.error('Something went wrong while calculating payload.');
          return;
        }
        if(!payload.sipTopupEnabled){
          delete payload.topupDetails;
        }
        var success = function (resp) {
          // $event.currentTarget.disabled = false;
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            LoaderService.hideLoader();
            if (vm.transactionType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
              // userSipActivityTracking(true, function () {
              //   handleSipResponse(resp.data);
              // });
            }
            vm.srnNo = resp.data.srnNo;
            vm.sip_response = resp.data;
            vm.SIPtransactionInitiateDate = resp.data.transactionInitiateDate.slice(0, 11);
            vm.showSummary = true;
            sessionStorage.removeItem('folioDetails');
            vm.isbuttonClicked = true;
          } else {
            LoaderService.hideLoader();
            if (resp.popupEnabled && !resp.contentType) {
              ModalService.genericModal({
                text: resp.message
              });
            } else if(resp.popupEnabled && resp.contentType){
              ModalService.genericModal({
                panErrorText: resp.message
              });
            }else {
              MessageService.error(resp.message);
            }
            sessionStorage.removeItem('folioDetails');
            vm.isbuttonClicked = true;
            // /*Netcore Event Start*/
            // if (vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
            //   NetcoreEvntService.Complete_Transaction_SIP_IP(vm.formData, true);
            // }
            // /*Netcore Event End*/
          }
        },
         error = function (err) {
            // $event.currentTarget.disabled = false;
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
            sessionStorage.removeItem('folioDetails');
            vm.isbuttonClicked = true;
          };
         // $window.smartech('dispatch', 'user id creation post kyc', {});
          LoaderService.showLoader();
          if(vm.isbuttonClicked == true){
            if(!JSON.parse(sessionStorage.getItem('folioDetails'))){
              vm.expiryPayment()
            }
          }else{
         if(vm.sipBankData[0]){
          ChangeDividendService.post2({
            child1: 'v1',
            child2: 'newuser',
            child3: 'transaction',
            child4: 'sip',
            child5: 'approve'
          }, payload).$promise.then(success, error);
        }
         else{
          MessageService.error("Folio is in processing please try after sometime.");
        }
        }

      }

      function getSipPayload() {
        if (vm.formData.bankInfo && vm.formData.bankInfo.bankName == "OTHER BANKS") {
          vm.formData.bankInfo.bankName = vm.formData.bankName;
        }
        Object.keys(vm.TRANSACTION).forEach(function (key) {
          if (vm.TRANSACTION[key] == vm.formData.investmentOption)
            vm.formData.investmentOption = key;
        });
        if(vm.formData.investmentType === 'PURCHASE' || (vm.formData.investmentType === 'SIP' &&  vm.formData.sipFI)){
          vm.formData.bankInfo = vm.folioBankData && vm.folioBankData.bankList?vm.folioBankData.bankList[0]:null;
          }
        var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
          dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          euinOpted: vm.formData.euinOpted ? vm.formData.euinOpted : 'N',
          euinName: vm.formData.euinName ? vm.formData.euinName : '',
          euinCode: vm.formData.euinCode ? vm.formData.euinCode : '',
          frequency: vm.formData.installmentFrequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.schemeCode,
          schemeType: vm.formData.schemeType,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.installmentEndDate ? vm.formData.installmentEndDate : '',
          sipDate: vm.formData.installmentStartDate ? vm.formData.installmentStartDate : '',
          sipDay: (moment(vm.formData.installmentStartDate, 'DD-MMM-YYYY').date()).toString(),
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          id: vm.formData.id ? '' : '',
          panNumber:vm.formData.panNumber,
          bankDetailsForECS: {
            // accNumber: vm.formData.bankInfo.accountNumber,
            // bankName: vm.formData.bankName,
            // ifscCode: vm.formData.bankInfo ? vm.formData.bankInfo.ifscCode : null,
            // branchName: vm.formData.bankInfo ? vm.formData.bankInfo.bankBranch : '',
            // bankCity: vm.formData.bankInfo ? vm.formData.bankInfo.bankCity : '',
            paymentOption:  vm.formData.investmentType == "SIP" ? 'EC' : '',

            bankName: vm.sipBankData && vm.sipBankData[0] && vm.sipBankData[0].bankNameOnly ? vm.sipBankData[0].bankNameOnly : null ,
            ifscCode: vm.sipBankData && vm.sipBankData[0] && vm.sipBankData[0].ifscCode  ? vm.sipBankData[0].ifscCode : null,
            branchName:vm.sipBankData && vm.sipBankData[0] && vm.sipBankData[0].bankBranch ? vm.sipBankData[0].bankBranch : null,
            bankCity:vm.sipBankData && vm.sipBankData[0] &&  vm.sipBankData[0].bankCity ? vm.sipBankData[0].bankCity : null,
            accType:vm.sipBankData && vm.sipBankData[0] && vm.sipBankData[0].bankAcType? vm.sipBankData[0].bankAcType : null,
            accNo:vm.sipBankData && vm.sipBankData[0] ? vm.sipBankData[0].accountNumber : null,
            accNumber:vm.sipBankData && vm.sipBankData[0] ? vm.sipBankData[0].accountNumber : null,
            // payoutId: vm.formData.bankInfo && vm.formData.bankInfo.payoutId,
            netBankingUrl:vm.sipBankData && vm.sipBankData[0] && vm.sipBankData[0].netBankingUrl ? vm.sipBankData[0].netBankingUrl : null,
            bankCode:vm.sipBankData && vm.sipBankData[0] ? vm.sipBankData[0].bankCode : null
          },
          subBrokerArn: vm.formData.subBrokerArn ? vm.formData.subBrokerArn : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          sipTopupEnabled: vm.formData.topUpEnable ? vm.formData.topUpEnable : false ,
          brokerCode: vm.formData.brokerCode ? vm.formData.brokerCode : '',
          riaConsent: vm.formData.riaConsent,
          topupDetails: {
            amount: vm.formData.topUpDetails.amount,
            percentage: vm.formData.topUpDetails.percentage,
            frequency: vm.formData.topUpDetails.frequency ? 'Y' : 'N',
            capAmount: vm.formData.topUpDetails.capAmount,
            capMonthYear: vm.formData.topUpDetails.capMonthYear
          }
        };
        if (vm.formData.sipPaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EMANDATE) {
          sipPayload.bankDetailsForECS.accNumber = vm.formData.bankInfo.accountNumber,
            sipPayload.bankDetailsForECS.accType = vm.formData.bankInfo.bankAcType,
            sipPayload.bankDetailsForECS.authenticationMode = vm.formData.authMode ? vm.formData.authMode.value : '',
            sipPayload.bankDetailsForECSbankCode = vm.formData.bankInfo.bankCode
        }
        (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.camsMandateIdNo))
          && (sipPayload.bankDetailsForECS.camsMandateIdNo = vm.formData.bankInfo.camsMandateIdNo);
        (vm.formData.bankInfo && angular.isDefined(vm.formData.bankInfo.omUmrn))
          && (sipPayload.bankDetailsForECS.omUmrn = vm.formData.bankInfo.omUmrn);
        var payload = {};
        if (!vm.formData.optionalInvestmentType && vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP) {
          payload = angular.copy(sipPayload);
        } else {
          payload = null;
        }
        payload = handleBrokerCode(payload);
        return payload;
      }

      function handleBrokerCode(payload) {
        if (vm.formData.isThroughDistributor) {
          payload['brokerCode'] = vm.formData.brokerCode ? 'ARN-' + vm.formData.brokerCode : (vm.formData.distributorARN ? vm.formData.distributorARN : '');
          payload['riaConsent'] = false;
        } else if (vm.formData.riaConsent) {
          payload['brokerCode'] = vm.formData.riaCode;
          payload['riaConsent'] = true;
        } else if (vm.formData.isDirect) {
          payload['brokerCode'] = '';
          payload['riaConsent'] = false;
        }
        return payload;
      }
      function handleSipResponse(data) {
        if (!data) {
          MessageService.error();
          return;
        }

        if (vm.formData.investmentOption == Object.keys(vm.TRANSACTION)[1])
          vm.formData.investmentOption = vm.TRANSACTION.DIVIDEND;

        ModalService.manualInstructionsModal({
          investorName: vm.investorName,
          folioInvestorName: vm.formData.folioInvestorName,
          srnNo: data.srnNo,
          folioNumber: vm.formData.folioNumber,
          schemeName: vm.formData.inSchemeName,
          investmentOption: vm.formData.investmentOption,
          amount: vm.formData.amount,
          sipDividendOption: vm.formData.sipDividendOption,
          netBankingUrl: vm.bankInfo.netBankingUrl,
          paymentOption: data.paymentOption,
          transactionId: data.trxnNo,
          transactionInitiateDate: data.transactionInitiateDate,
          frequency: vm.formData.frequency,
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          startDate: vm.formData.startDate ? vm.formData.startDate.format('DD-MMM-YYYY') : null,
          endDate: vm.formData.endDate ? vm.formData.endDate.format('DD-MMM-YYYY') : null,
          bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
          bankAcNo: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : vm.formData.bankAcNo,
          type: 'newInvestor',
        });

      }

      vm.showTermConditions = function () {
        ModalService.termsAndConditionSip({});
      };
      vm.goToBack = function () {
        $state.go('newInvestor.folioDetails.baiscDetails');
      };

      // THIS FUNCTION CALL ON PURCHASE TYPE
      function initActivity() {
        if (!vm.formData || (vm.formData.investmentType.toUpperCase() !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE && vm.formData.investmentType.toUpperCase() !== vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP)) {
          $state.go('welcome');
          TransactionModel.setPayloadRawData(null);
          return null;
        }
        // if (vm.formData.schemeType === 'LIQUID') {
        //   vm.paymentOptions = paymentOptions4Liquid;
        // }

        // vm.formData.purchasePaymentOption = vm.paymentOptions[0];
        vm.formData.trackId = $stateParams.trackId ? $stateParams.trackId : vm.formData.trackId;

        // getDetails(function () {
          // vm.changedPaymentOption();
        // });

      }


      function getDetails(cb) {
        cb = cb || function () {
        };
        var success = function (resp) {
          var bankDetails = [];
          if(resp.data && resp.data){
            vm.folioTaxStatusCode = resp.data.folioTaxStatusCode;
            vm.bankAccountTypes();
          }
          LoaderService.hideLoader();
          vm.folioDetailsData = resp.data;
          if (vm.folioDetailsData && vm.folioDetailsData.bankDetails && vm.folioDetailsData.bankDetails.length > 0) {
            bankDetails = vm.folioDetailsData.bankDetails.filter(function (value) {
              if (value.defaultBank === true) { return value; }
            });
          }
          localStorage.setItem('bankDetails', $window.JSON.stringify(bankDetails));
          cb();
        }, error = function () {
          LoaderService.hideLoader();
          cb();
        };
        var myData = {
          folioNumber: vm.formData.folioNumber,
          newUser:true
        }
        LoaderService.showLoader();
        UtilityService.post({
          child1: 'profile',
          child2: 'folio',
          child3: 'details'
        }, myData).$promise.then(success, error);
      }

      vm.bankAccountTypes  = function() {
        var success = function (resp) {
          if (resp.data && resp.status) {
            vm.bankAccountType = resp.data.bankAccountTypes;
            $rootScope.AccountTypes = resp.data.bankAccountTypes;
          }
          else {
             vm.panMessage = resp.message;
          }
        },
          error = function () {
            MessageService.error("Bank account type service error!");
          };
          InvestorsService.get({
            controller: 'bank',
            child1: 'account-type',
            transactionType:'list',
            child2: 'investor',
            child3: vm.investorDetails.soleApplicantDetail.taxStatusCode
            }).$promise.then(success, error);
        }
      function getbankData(){
          var success = function (resp) {
            if(resp.data && resp.data){
              vm.folioBankData =  resp.data;
            }
            LoaderService.hideLoader();
          }, error = function () {
            LoaderService.hideLoader();
          };

          LoaderService.showLoader();
          UtilityService.post({ controller: 'bank',child: 'list',child1:'dp'}, {
            trnxType: vm.formData.investmentType,
            folioNumber: vm.formData.folioNumber,
            liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
          }).$promise.then(success, error);
        };
      vm.changedPaymentOption = function () {
        vm.isCheckedDeclaration = false;
        vm.bankInfo = null;
        vm.bankList = null;
        vm.formData.paymentInfo = { amount: vm.formData.purchaseAmount };
        vm.isOTMAmount = false;
        vm.isOTMDate = false;
        vm.isOTMStartDate = false;
        vm.isInvalidForm = false;
        vm.bankchequeLeafUrl = null;
        if(vm.formData.paymentInfo){
          vm.formData.paymentInfo.chequeLeaf = null;
        }
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.fetchBankList();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM;
            vm.fetchBankList();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            vm.rtgsBankTogg = true;
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            vm.rtgsBankTogg = true;
            vm.fetchBankList();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            resetUPIForm();
            vm.fetchBankList();
            vm.formData.paymentInfo.paymentMode = "WEB";
            vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
            if(vm.formData.paymentInfo.webMode == "UPI"){
              if(vm.formData.amount > vm.formData.upiMaxAmountLimit){
                vm.upiErrorMessage = vm.formData.upiMaxAmountErrMessage;
                var success = function() {
                  vm.formData.purchasePaymentOption = 'NETBANKING';
                  vm.fetchBankList();
                }
                ModalService.genericModal({
                  text: vm.upiErrorMessage
                },success);
              }
            }
            break;
        }
      };
      function resetUPIForm() {
        vm.verifyUPIResp = {};
        vm.isUPIVerified = false;
        (vm.formData.paymentInfo) && (vm.formData.paymentInfo.virtualAddress = "");
      }
      vm.loaderCounter = 0;
      vm.callBankList = function(){
        LoaderService.showLoader();
        vm.fetchBankList();
      }
      vm.fetchBankList = function() {
        LoaderService.showLoader();
        vm.bankList = null;
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmList = resp.data;
            if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
              vm.bankList = vm.formData.sipFI ? resp.data.nonCOTMBankList : resp.data;
            } else {
              vm.bankList = resp.data;
            }
            vm.bankList = vm.bankList.length ? vm.bankList : null;
            if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING ||
              vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI ||
              vm.formData.purchasePaymentOption === "WEB") {
              vm.netBankingAndUPIList = vm.bankList;
              if(vm.formData.purchasePaymentOption == 'UPI'){
                vm.formData.paymentInfo.bank = vm.netBankingAndUPIList[0];
              }
              if(vm.formData.purchasePaymentOption == 'NETBANKING' || vm.formData.purchasePaymentOption == 'WEB'){
                vm.formData.paymentInfo = vm.netBankingAndUPIList[0];
                vm.formData.paymentInfo.paymentMode = "WEB";
              }
            }
            // if(vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM){
            //   vm.OTMList = vm.bankList;
            // }
            if (vm.bankList && vm.bankList.length == 1) {
              vm.bankInfo = vm.bankList[0];
              if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
                localStorage.setItem('folioId', vm.formData.folioNumber);
                ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
                return;
              }
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
              vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
              vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
              vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
              vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
              vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
              vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
              vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
              vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
              vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
              vm.formData.paymentInfo.bankAcType = vm.bankInfo.bankAcType;
              vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
              vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
              (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
              // if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) {
              //   // checkOTMAmountAndDate();
              // }
              if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
                selectedUpiBank();
              }
              if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS) {
                vm.changeBank();
                if(!vm.rtgsBankTogg){
                  vm.formData.paymentInfo.bankName = null;
                  vm.formData.paymentInfo.ifscCode = null;
                  vm.formData.paymentInfo.branchName = null;
                  vm.formData.paymentInfo.accountNumber = null;
                  vm.formData.paymentInfo.accNo = null;
                  vm.formData.paymentInfo.bankAcType = null;
                  vm.formData.paymentInfo.accType = null;
                  vm.bankInfo = null;
                }
              }
            }
          } else {
            vm.bankList = null;
            MessageService.error(resp.message);
          }
        },
          error = function (err) {
            vm.bankList = null;
            MessageService.error("Folio creation is in process please wait.");
            if(vm.loaderCounter < 4 && vm.netBankingAndUPIList === ""){
              $timeout(function(){
                vm.callBankList();
              }, 15000);
              vm.loaderCounter = vm.loaderCounter + 1;
            }
          };
        LoaderService.showLoader();

        var config = null;
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            config = { child1: 'bank', child2: 'list', child3: vm.debitCardType, child4: 'debit' };
            UtilityService.get(config, null).$promise.then(success, error);
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            if (vm.netBankingAndUPIList === "") {
              // UtilityService.post({ child1: 'bank', child2: 'list' }, {
              //   trnxType: 'PURCHASE',
              //   folioNumber: vm.formData.folioNumber,
              //   liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
              // }).$promise.then(success, error);
              UtilityService.post({ controller: 'bank',child: 'list',child1:'dp'}, {
                trnxType: vm.investmentType,
                folioNumber: vm.formData.folioNumber,
                liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
              }).$promise.then(success, error);
            }else{
              if(vm.formData.paymentInfo && !vm.formData.paymentInfo.webMode){
                vm.formData.paymentInfo.webMode = vm.netBankingAndUPIList[0].gateWayVendor;
              }
              vm.bankInfo = vm.netBankingAndUPIList[0];
            }
            // vm.bankList = vm.netBankingAndUPIList;
            checkBankList();
            LoaderService.hideLoader();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            UtilityService.post({ controller: 'bank',child: 'list',child1:'dp'}, {
              trnxType: vm.investmentType,
              folioNumber: vm.formData.folioNumber,
              liquidSchemeFlag: vm.formData.schemeType == 'LIQUID' ? true : false
            }).$promise.then(success, error);
            // vm.bankList = vm.netBankingAndUPIList;
            checkBankList();
            LoaderService.hideLoader();
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            if (vm.OTMList === null) {
              config = { child1: 'folio', child2: 'otm' };
              UtilityService.post(config, {
                folioNumber: vm.formData.folioNumber,
                transactionType: 'purchase'
              }).$promise.then(success, error);
            }
            vm.bankList = vm.OTMList;
            checkBankList();
            LoaderService.hideLoader();
            break;
          default:
            vm.bankList = null;
            config = null;
            break;
        }
      }

      function checkBankList() {
        if (vm.bankList && vm.bankList.length == 1) {
          vm.bankInfo = vm.bankList[0];
          if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
            localStorage.setItem('folioId', vm.formData.folioNumber);
            ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
            return;
          };
          vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
          vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
          vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
          vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
          vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
          vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
          vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
          vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
          vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
          vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
          vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
          vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
          vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
          (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
          // checkOTMAmountAndDate();
          if (vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI) {
            selectedUpiBank();
          }
        }
      }

      function selectedUpiBank() {
        if (!vm.bankInfo) {
          return;
        }
        if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
          localStorage.setItem('folioId', vm.formData.folioNumber);
          ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
          vm.bankInfo = null;
          vm.isCheckedDeclaration = false;
          return;
        }
        vm.upiAccountNumber = vm.bankInfo.accountNumber;
        vm.upiBankName = vm.bankInfo.bankName;
        vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      }


      vm.checkForMinorBankListCondition = function () {
        if (vm.formData != null && vm.formData.minorFlag != null && vm.formData.cgfFlag != null)
          return vm.formData.minorFlag && !vm.formData.cgfFlag;
        else
          return false;
      };
      vm.verifyUPI = function () {
        vm.verifyUPIResp = {};
        var success = function (resp) {
          if (resp.data && resp.status) {
            vm.verifyUPIResp = resp.data;
            if (resp.data.valid) {
              vm.name = resp.data.name;
              vm.showUPIStatus = true;
              vm.isUPIVerified = true;
            } else {
              vm.isUPIVerified = false;
            }
          }
          else {
            vm.isUPIVerified = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
          error = function (err) {
            vm.isUPIVerified = false;
            $log.info("upi error====", err);
            LoaderService.hideLoader();

          };
        LoaderService.showLoader();
        UtilityService.post({
          controller: 'upi',
          child: 'check',
          child1: 'virtualAddress'
        }, {"virtualAddress": vm.formData.paymentInfo.virtualAddress }).$promise.then(success, error);
      }
      vm.copyPasteHandler = function (e) {
        UtilService.copyPasteHandler(e);
      };

      vm.changeBank = function () {
        if (!vm.bankInfo) {
          return;
        }
        vm.isInvalidForm = false;
        localStorage.setItem('folioId', vm.formData.folioNumber);
        switch (vm.formData.purchasePaymentOption) {
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
            // if(!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()){
            //   ModalService.minorBankModal({folioDetailsData:vm.folioDetailsData});
            //   vm.bankInfo = null;
            //   vm.isCheckedDeclaration = false;
            //   return;
            // };
            vm.formData.paymentInfo.paymentMode = 'WEB';
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            // if (vm.bankInfo.tpvEnableFlag == 'Y') {
            //   getAccountNumber(vm.bankInfo.bankCode);
            // }
            vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
            vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
            vm.formData.paymentInfo.paymentMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS;
            vm.formData.paymentInfo.bankCode = vm.bankInfo.bankCode;
            vm.formData.paymentInfo.webMode = vm.bankInfo.gateWayVendor;
            vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
            // vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankNameOnly ? vm.bankInfo.bankNameOnly : null;
            vm.formData.paymentInfo.bankNameWithAccountNumber = vm.bankInfo.bankName ? vm.bankInfo.bankName : null;
            vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
            vm.isAccTypeFieldDisabled = vm.formData.paymentInfo.accType ? true : false;
            vm.netBankingAndUPIList = vm.bankList;
            if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber){
              vm.formData.paymentInfo.verifyUtrNumber = null;
            }
            vm.bankAccountTypes();
            if(vm.rtgsBankTogg){
              vm.rtgsFormData.bankName.$setDirty();
              vm.rtgsFormData.bankBranch.$setDirty();
              vm.rtgsFormData.bankAcNo.$setDirty();
              vm.rtgsFormData.accountType.$setDirty();
              vm.rtgsFormData.ifscCode.$setDirty();
            }else{
              vm.rtgsFormData.bankName.$dirty = false;
              vm.rtgsFormData.bankBranch.$dirty = false;
              vm.rtgsFormData.bankAcNo.$dirty = false;
              vm.rtgsFormData.accountType.$dirty = false;
              vm.rtgsFormData.ifscCode.$dirty = false;
            }
            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM:
            if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
              ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
              vm.bankInfo = null;
              vm.isCheckedDeclaration = false;
              return;
            };
            vm.formData.paymentInfo.otmId = vm.bankInfo.otmId;
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.bankBranch = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.bankAcNo = vm.bankInfo.bankAcNo;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.payoutId = vm.bankInfo.payoutId;
            vm.formData.paymentInfo.omUmrn = vm.bankInfo.omUmrn;
            vm.formData.paymentInfo.eMandatebankAcNo = vm.bankInfo.eMandatebankAcNo;
            vm.formData.paymentInfo.eMandateUmrn = vm.bankInfo.eMandateUmrn;
            (angular.isDefined(vm.bankInfo.camsMandateIdNo)) && (vm.formData.paymentInfo.camsMandateIdNo = vm.bankInfo.camsMandateIdNo);
            checkOTMAmountAndDate();

            break;
          case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
            if (!vm.bankInfo.minorBankFlag && vm.checkForMinorBankListCondition()) {
              ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
              return;
            };
            break;
          default:
            vm.bankInfo = null;
            break;
        }
      };
      function tpv() {
        ModalService.tpvModal({});
      }
      function getAccountNumber(bankCode) {
        // if(vm.investorInfo && vm.investorInfo.transactionFlowVersion === TrFlowType.NEW){
        //   vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
        //   vm.formData.paymentInfo.accountNumber = vm.bankInfo.accountNumber;
        //   return;
        // }
        // alert(bankCode);
        vm.bankAccounts = [];
        vm.isInvalidForm = true;
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            LoaderService.hideLoader();
            vm.bankAccounts = resp.data.accountNumbers;
            if (vm.bankAccounts.length > 1) {
              var success = function (accountNo) {
                vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
                vm.formData.paymentInfo.accountNumber = accountNo;
                vm.isInvalidForm = false;
              }, error = function () {

              };
              ModalService.selectAccountNoModal({ bankAccounts: vm.bankAccounts }, success, error);
            } else {
              vm.formData.paymentInfo.tpvEnableFlag = vm.bankInfo.tpvEnableFlag;
              vm.formData.paymentInfo.accountNumber = vm.bankAccounts[0];
              vm.isInvalidForm = false;
            }
          } else {
            vm.isInvalidForm = true;
            MessageService.error(resp.message);
            vm.bankAccounts = [];
          }
        },
          error = function (err) {
            vm.bankAccounts = [];
            vm.isInvalidForm = true;
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        LoaderService.showLoader();
        var payload = {
          "folioNumber": vm.formData.folioNumber, //'9422332',
          "bankCode": vm.formData.bankCode
        };
        UtilityService.post({
          child1: 'bank',
          child2: 'account'
        }, payload).$promise.then(success, error);
      }
  // Existing functions
      vm.getconfirmation = function(){
        vm.confirmation = !vm.confirmation;
      }
      vm.getPaymenMode = function (val) {
        vm.formData.purchasePaymentOption = val;
        if(val == 'RTGS'){
          vm.formData.purchasePaymentOption = 'RTGS';
        }
        vm.changedPaymentOption();
        vm.rtgsBankTogg = true;
        if(val == 'UPI'){
          vm.formData.paymentInfo.bank = vm.netBankingAndUPIList[0];
        }
        if(val == 'NETBANKING' || val == "WEB"){
          vm.formData.paymentInfo = vm.netBankingAndUPIList[0];
          vm.formData.paymentInfo.webMode = vm.netBankingAndUPIList[0].gateWayVendor;
          vm.formData.paymentInfo.paymentMode = 'WEB';
        }
      }

      // UPI
      function selectedUpiBank() {
        if (!vm.formData.paymentInfo.bank) {
          return;
        }
        if (!vm.formData.paymentInfo.bank.minorBankFlag && vm.checkForMinorBankListCondition()) {
          localStorage.setItem('folioId', vm.formData.folioNumber);
          ModalService.minorBankModal({ folioDetailsData: vm.folioDetailsData });
          vm.formData.paymentInfo.bank = null;
          vm.isCheckedDeclaration = false;
          return;
        }
        vm.upiAccountNumber = vm.formData.paymentInfo.bank.accountNumber;
        vm.upiBankName = vm.formData.paymentInfo.bank.bankNameOnly;
        vm.formData.paymentInfo.webMode = vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI;
      }


      vm.purchaseSubmitForm = function ($event) {
        var payload = getSipPurchasePayload();
        if (!payload) {
          MessageService.error('Something went wrong while calculating purchase payload.');
          return;
        }
        if (payload.formType === 'PURCHASE' && vm.formData.purchasePaymentOption == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING &&
          vm.formData.amount >= 200000 && vm.formData.schemeType != 'LIQUID') { 
           vm.finalSubmit(payload);
        } else if (vm.formData.investmentType === 'SIP') {
          if (payload.bankDetailsForECS.paymentOption === 'HEM') {
            var successCallback = function () {
              vm.finalSubmit(payload);
            };
            var errorCallback = function () {
              LoaderService.hideLoader();
            };
            ModalService.registerEMandateModal({bankName: payload.bankDetailsForECS.bankName, authMode: payload.bankDetailsForECS.authenticationMode}, successCallback, errorCallback)
          }
          else
            vm.finalSubmit(payload);
        }
        else { 
          vm.finalSubmit(payload);
        }
      };
      

      function getSipPurchasePayload() {
        var sipPayload = {
          installmentAmount: vm.formData.amount,
          investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
          dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
          formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          frequency: vm.formData.installmentFrequency,
          folioNumber: vm.formData.folioNumber,
          schemeCode: vm.formData.schemeCode,
          primaryFlag: vm.formData.investmentType === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP,
          toDate: vm.formData.installmentEndDate ? $window.moment(vm.formData.installmentEndDate).format('DD-MMM-YYYY').toString() : '',
          sipDate: vm.formData.installmentStartDate ? $window.moment(vm.formData.installmentStartDate).format('DD-MMM-YYYY').toString() : '',
          sipDay: moment(vm.formData.installmentStartDate, 'DD-MMM-YYYY').date(),
          weeklyDay: vm.formData.weeklyDay ? vm.formData.weeklyDay : null,
          euinOpted: vm.formData.euinOpted ? vm.formData.euinOpted : 'N',
          euinCode: vm.formData.euinCode ? vm.formData.euinCode : '',
          euinName: vm.formData.euinName ? vm.formData.euinName : '',
          id: '',
          subBrokerArn: vm.formData.subBrokerArn ? vm.formData.subBrokerArn : '',
          subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
          brokerCode: vm.formData.brokerCode ? vm.formData.brokerCode : '',
          panNumber:vm.formData.panNumber
        },
          purchasePayload = {
            amount: vm.formData.amount,
            investmentOption: vm.formData.investmentOption ? vm.formData.investmentOption.toUpperCase() : '',
            dividendOption: vm.formData.investmentOption && vm.formData.investmentOption.toUpperCase() == 'GROWTH' ? 'Z' : vm.formData.dividendOption,
            folioNumber: vm.formData.folioNumber,
            formType: vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
            primaryFlag: vm.formData.investmentType.toUpperCase() === vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE,
            schemeCode: vm.formData.schemeCode,
            retirementAgeProofURL: vm.formData.retirementAgeProofURL ? vm.formData.retirementAgeProofURL : '',
            euinOpted: vm.formData.euinOpted ? 'Y' : 'N',
            euinCode: vm.formData.euinCode ? vm.formData.euinCode : '',
            euinName: vm.formData.euinName ? vm.formData.euinName : '',
            id: '',
            paymentInfo: getPaymentInfo(),
            subBrokerArn: vm.formData.subBrokerArn ? vm.formData.subBrokerArn : '',
            subBrokerCode: vm.formData.subBrokerCode ? vm.formData.subBrokerCode : '',
            brokerCode: vm.formData.brokerCode ? vm.formData.brokerCode : '',
            checkedNfoAutoSwitch: vm.formData.isAutoSwitch,
            autoSwitchScheme: vm.formData.isAutoSwitch ? vm.formData.inSchemeCode : null,
            riaConsent: vm.formData.riaConsent,
            autoSwitchSchemeDividendOption: vm.formData.isAutoSwitch ? vm.formData.switchDividendOption : null,
            panNumber:vm.formData.panNumber,
            secretLink:vm.uuid
          };
        Object.keys(vm.TRANSACTION).forEach(function (key) {
          if (vm.TRANSACTION[key] == purchasePayload.investmentOption) {
            purchasePayload.investmentOption = key;
          } else if (vm.TRANSACTION[key] == sipPayload.investmentOption) {
            sipPayload.investmentOption = key;
          }
        });
        if (purchasePayload.paymentInfo.accountNumber && vm.formData.investmentType.toUpperCase() == vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE) {
          purchasePayload.accountNumber = purchasePayload.paymentInfo.accountNumber;
          delete purchasePayload.paymentInfo.accountNumber;
        }
        if (purchasePayload.paymentInfo.tpvEnableFlag) {
          purchasePayload.tpvEnableFlag = purchasePayload.paymentInfo.tpvEnableFlag;
          delete purchasePayload.paymentInfo.tpvEnableFlag;
        }
        var payload = {};

        switch (vm.formData.investmentType.toUpperCase()) {
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.PURCHASE:
            purchasePayload = handleBrokerCode(purchasePayload);
            payload = angular.copy(purchasePayload);
            break;
          case vm.TRANSACTIONS_CONST.TRANSACTION_TYPE.SIP:
            sipPayload = handleBrokerCode(sipPayload);
            payload = angular.copy(sipPayload);
            break;
        }

        if (vm.formData.investmentType === 'SIP' && vm.formData.sipFI) {
          payload.sipWithFirstInstallment = vm.formData.sipFI;
          payload.firstInstallmentDetails = getPaymentInfo();
          vm.formData.sipPaymentOption = 'EC';

          if (vm.formData.sipPaymentOption === 'EC') {
            payload.bankDetailsForECS = {
              accNumber: vm.bankInfo.accountNumber,
              bankName: vm.bankInfo ? vm.bankInfo.bankNameOnly : vm.bankNameOnly,
              ifscCode: vm.bankInfo.ifscCode,
              branchName: vm.bankInfo.bankBranch,
              bankCity: vm.bankInfo.bankCity,
              paymentOption: 'EC',
              netBankingUrl: vm.bankInfo.netBankingUrl,
              bankCode: vm.bankInfo ? vm.bankInfo.bankCode : null
            }
          }
          else if (vm.formData.sipPaymentOption === 'E-mandate') {
            payload.bankDetailsForECS = {
              accNumber: vm.formData.bankInfo ? vm.formData.bankInfo.accountNumber : '',
              bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
              ifscCode: vm.formData.bankInfo.ifscCode,
              branchName: vm.formData.bankInfo.bankBranch,
              bankCity: vm.formData.bankInfo.bankCity,
              paymentOption: 'HEM',
              accType: vm.formData.bankInfo.bankAcType,
              bankCode: vm.formData.bankInfo ? vm.formData.bankInfo.bankCode : null,
              authenticationMode: vm.formData.authMode.value
            }
          }
          else if (vm.formData.sipPaymentOption === 'OTM') {
            payload.bankDetailsForECS = {
              accNumber: vm.formData.bankInfo.bankAcNo,
              bankName: vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
              ifscCode: vm.formData.bankInfo.ifscCode,
              branchName: vm.formData.bankInfo.bankBranch,
              bankCity: vm.formData.bankInfo.bankCity,
              paymentOption: vm.formData.sipPaymentOption,
              payoutId: vm.formData.bankInfo.payoutId,
              bankCode: vm.formData.bankInfo ? vm.formData.bankInfo.bankCode : null,
              accType: vm.formData.bankInfo.bankAcType,
              camsMandateIdNo: vm.formData.bankInfo.camsMandateIdNo,
              omUmrn: vm.formData.bankInfo.omUmrn
            }
          }


          if (vm.formData.sipTopupEnabled) {
            payload.sipTopupEnabled = vm.formData.sipTopupEnabled;
            payload.topupDetails = vm.formData.topupDetails;
          }

        }

        return payload;
      }

      function getPaymentInfo() {

        if (vm.formData.paymentInfo && vm.formData.paymentInfo.webMode === 'MASTER') {
          vm.formData.paymentInfo.webMode = 'MASTERCARD';
        }

        var paymentInfo = {};

        if (vm.formData.investmentType === 'SIP') {
          paymentInfo = {
            //amount: vm.formData.amount,
            paymentMode: vm.formData.paymentInfo.paymentMode

          };

          switch (vm.formData.purchasePaymentOption) {
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
              paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
              paymentInfo.webMode = vm.formData.paymentInfo.webMode;
              paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              paymentInfo.paymentMode = 'WEB';
          paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
          paymentInfo.webMode = vm.formData.paymentInfo.webMode;
          paymentInfo.bankName = vm.formData.paymentInfo.bankName;
          paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
          paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
          paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
            paymentInfo.accNumber = vm.formData.paymentInfo.accountNumber;
            paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
          }
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
              if (vm.rtgsBankTogg) {
                paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
                paymentInfo.accNo = vm.formData.paymentInfo.accNo;
                paymentInfo.accType = vm.formData.paymentInfo.accType;
                paymentInfo.otherBank = true;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
                paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
                paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
              } else {
                paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accountNumber;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
                paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
                paymentInfo.accType = vm.formData.paymentInfo.bankAcType;
                paymentInfo.otherBank = false;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
                paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              }
              break;
              case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
                paymentInfo.amount = vm.formData.amount;
                paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
                paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
                paymentInfo.accType = vm.formData.paymentInfo.accType;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
                paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
                paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
                paymentInfo.bankName = "HDFC Bank Ltd";
                paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
                break;
              case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
                paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
                paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
                paymentInfo.upiReferenceNumber = vm.transactionNumber;
                paymentInfo.accountNumber = vm.upiAccountNumber;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.accNo = paymentInfo.accountNumber;
                paymentInfo.accType = paymentInfo.accountNumber;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
          }

        }
        else {
          paymentInfo = {
            amount: vm.formData.paymentInfo.amount ? vm.formData.paymentInfo.amount : vm.formData.amount,
            paymentMode: vm.formData.paymentInfo.paymentMode

          };

          switch (vm.formData.purchasePaymentOption) {
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT:
              paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
              paymentInfo.webMode = vm.formData.paymentInfo.webMode;
              paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
              paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.NETBANKING:
              paymentInfo.paymentMode = 'WEB';
              paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
              paymentInfo.webMode = vm.formData.paymentInfo.webMode;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.accType =  vm.formData.paymentInfo.bankAcType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode
              paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
              if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
                paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
                paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
              }
              break;
              case 'WEB':
              paymentInfo.paymentMode = 'WEB';
              paymentInfo.bankCode = vm.formData.paymentInfo.bankCode;
              paymentInfo.webMode = vm.formData.paymentInfo.webMode;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.accType =  vm.formData.paymentInfo.bankAcType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode
              paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
              if (vm.formData.paymentInfo.tpvEnableFlag == 'Y' && vm.formData.paymentInfo.accountNumber) {
                paymentInfo.accountNumber = vm.formData.paymentInfo.accountNumber;
                paymentInfo.tpvEnableFlag = vm.formData.paymentInfo.tpvEnableFlag;
              }
              vm.formData.paymentInfo = paymentInfo;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.RTGS:
              if (!vm.rtgsBankTogg) {
                paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accNo;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
                paymentInfo.accType = vm.formData.paymentInfo.accType;
                paymentInfo.accNo = vm.formData.paymentInfo.accNo;
                paymentInfo.otherBank = true;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
                paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
                paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
              } else {
                paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.accNo;
                paymentInfo.bankName = vm.formData.paymentInfo.bankName;
                paymentInfo.bankBranch = vm.formData.paymentInfo.branchName;
                paymentInfo.accNo = vm.formData.paymentInfo.accNo;
                paymentInfo.accType = vm.formData.paymentInfo.accType;
                paymentInfo.otherBank = false;
                paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
                paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
                paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
              }
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HDFC:
              paymentInfo.amount = vm.formData.amount;
              paymentInfo.schemeAccountNumber = vm.formData.paymentInfo.schemeAccountNumber;
              paymentInfo.accountHolderName = vm.formData.paymentInfo.accountHolderName;
              paymentInfo.bankName = vm.formData.paymentInfo.bankName;
              paymentInfo.bankBranch = vm.formData.paymentInfo.bankBranch;
              paymentInfo.accType = vm.formData.paymentInfo.accType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.ifscCode;
              paymentInfo.accNo = vm.formData.paymentInfo.accountNumber;
              paymentInfo.utr = vm.formData.paymentInfo.utrNumber;
              paymentInfo.bankName = "HDFC Bank Ltd";
              paymentInfo.chequeLeaf = vm.formData.paymentInfo.chequeLeaf;
              break;
            case vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI:
              paymentInfo.virtualAddress = vm.formData.paymentInfo.virtualAddress;
              paymentInfo.webMode = angular.copy(vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI);
              paymentInfo.upiReferenceNumber = vm.transactionNumber;
              paymentInfo.accountNumber = vm.formData.paymentInfo.bank.accountNumber;

              paymentInfo.bankName = vm.formData.paymentInfo.bank.bankNameOnly;
              paymentInfo.accNo = vm.formData.paymentInfo.bank.accountNumber;
              paymentInfo.accType = vm.formData.paymentInfo.bank.bankAcType;
              paymentInfo.ifscCode = vm.formData.paymentInfo.bank.ifscCode;
              break;
          }
        }

    return angular.copy(paymentInfo);
  }
  vm.showTransactionSummaryForRTGSorHDFC = false;
  vm.showUPIStatus = false;
  vm.redirectUrl =null;
  vm.finalSubmit = function (payload) {
      LoaderService.showLoader();
    var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.srnNo = resp.data.srnNo;
          vm.redirectUrl = resp.data.redirectUrl;
          MessageService.success('Success');
          // userActivityTracking(true, function(){
          vm.razorPayRedirectionData = resp.data;
            handlePurchaseResponse(resp.data);
            // });
            sessionStorage.removeItem('folioDetails');
            vm.isbuttonClicked = true;
          } else {
          if(resp.popupEnabled){
            ModalService.genericModal({
              panErrorText : resp.message
            })
          } else {
            MessageService.error(resp.message);
           }
           sessionStorage.removeItem('folioDetails');
           vm.isbuttonClicked = true;
          }
        },error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          MessageService.error('Error');
          sessionStorage.removeItem('folioDetails');
          vm.isbuttonClicked = true;
        };
        if(vm.isbuttonClicked == true){
          if(!JSON.parse(sessionStorage.getItem('folioDetails'))){
            vm.expiryPayment()
          }
        }else{
        ChangeDividendService.post2({
          child1: 'v1',
          child2: 'newuser',
          child3: 'transaction',
          child4: vm.formData.investmentType.toLowerCase(),
          child5: 'approve'
        }, payload).$promise.then(success, error);
        }
            };

            vm.userdata = null;
            vm.transactionDetails=  null;
            function handlePurchaseResponse(data) {
              vm.userdata  = data;
              var transactionId = data && data.transactionId ? data.transactionId : null;
              var payloadData = data;
              data = data && data.data ? data.data : data;
              if (!data) {
                MessageService.error();
                return;
              }

                  if ((vm.formData.sipFI ||vm.formData.sipFirstInstallment) && vm.formData.sipPaymentOption === 'E-mandate') {
                    $window.location.href = $scope.billdeskUrl + data.emandateMsg;
                    return;
                  }

              if(vm.formData.investmentType==='SIP')
                vm.billdeskMsg = data.emandateMsg;
              else
                vm.billdeskMsg = data;
              if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLDESK') {
                if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
                  vm.billdeskPayload.msg = vm.billdeskMsg;
                  $timeout(function () { // commented as debit currently is not getting used
                    angular.element('#billdeskForm').submit();
                  });
                  //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
                } else {
                  vm.billdeskPayload.msg = vm.billdeskMsg;
                  $timeout(function () {
                    angular.element('#billdeskForm').submit();
                  });
                  //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
                }
              }
              else if (vm.formData.paymentInfo.paymentMode == 'WEB' && (vm.formData.paymentInfo.webMode == 'MASTERCARD' || vm.formData.paymentInfo.webMode == 'VISA')) {
                if (vm.formData.purchasePaymentOption === vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.DEBIT || vm.formData.paymentInfo.bankCode === 'NA') {
                  vm.billdeskPayload.msg = vm.billdeskMsg;
                  $timeout(function () {
                    angular.element('#billdeskForm').submit();
                  });
                  //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
                } else {
                  vm.billdeskPayload.msg = vm.billdeskMsg;
                  $timeout(function () {
                    angular.element('#billdeskForm').submit();
                  });
                  //$window.location.href = vm.purchaseBillDeskUrl + vm.billDeskpayload;
                }
                // ModalService.successTransactionModal();
              }
              else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'BILLJUNCTION') {
                $window.open(vm.billdeskMsg, '_self');
                // ModalService.successTransactionModal();
              } else if (vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'UPI') {
                // vm.showUPISuccessPopup();
                // ModalService.successTransactionModal();
                if(!vm.redirectUrl) {
                  MessageService.error("something went wrong");
                } else {
                  // $window.location.href = vm.redirectUrl
                  $window.location.href = vm.redirectUrl;
                }
              } else if(vm.formData.paymentInfo.paymentMode == 'WEB' && vm.formData.paymentInfo.webMode == 'RAZORPAY') {
                if(vm.formData.investmentType == "SIP") {
                  vm.razorPayRedirectionData.trnxActionMsg = vm.razorPayRedirectionData.emandateMsg;
                } else {
                  vm.razorPayRedirectionData.trnxActionMsg = vm.razorPayRedirectionData.data;
                }
                PaymentService.openRazorPay(vm.razorPayRedirectionData);
              } else if( vm.formData.sipFI ||vm.formData.sipFirstInstallment)
              {
                $window.location.href = data.redirectUrl;
                /*ModalService.manualInstructionsModal({
                  srnNo: data.srnNo,
                  investorName: vm.formData.folioInvestorName,
                  folioInvestorName: vm.formData.folioInvestorName,
                  folioNumber: vm.formData.folioNumber,
                  schemeName: vm.formData.inSchemeName,
                  investmentOption: vm.formData.investmentOption,
                  amount: vm.formData.amount,
                  sipDividendOption: vm.formData.sipDividendOption,
                  netBankingUrl:vm.formData.netBankingUrl,
                  paymentOption:data.paymentOption,
                  transactionId:data.trxnNo,
                  transactionInitiateDate:data.transactionInitiateDate,
                  frequency:vm.formData.frequency,
                  startDate:vm.formData.startDate ? $window.moment(vm.formData.startDate).format('DD-MMM-YYYY'):null,
                  endDate:vm.formData.endDate ? $window.moment(vm.formData.endDate).format('DD-MMM-YYYY'):null,
                  bankName:vm.formData.bankInfo ? vm.formData.bankInfo.bankName : vm.formData.bankName,
                  bankAcNo:vm.formData.bankInfo ? vm.formData.bankInfo.bankAcNo : vm.formData.bankAcNo,
                  sipFirstInstallment:vm.formData.sipFirstInstallment,
                  sipFirstAmount:vm.formData.sipFirstAmount,
                  sipFirstBankName: vm.formData.purchasePaymentOption === "HDFC" ? "HDFC Bank" : vm.formData.paymentInfo.bankName,
                  installmentPaymentOption: vm.TRANSACTIONS_CONST.DESCRIPTIONS[vm.formData.purchasePaymentOption]
                });*/
              }
              else {
                if(vm.formData.purchasePaymentOption == 'HDFC' || vm.formData.purchasePaymentOption == 'RTGS'){
                  LoaderService.showLoader();
                  var success = function (resp) {
                    LoaderService.hideLoader();
                    if (resp.status && resp.data) {
                      vm.showTransactionSummaryForRTGSorHDFC = true;
                      vm.transactionDetails = resp.data;

                    } else {
                      MessageService.error(resp.message);
                      deferred.reject(null);
                    }
                  }, error = function (err) {
                    LoaderService.hideLoader();
                    UtilService.errorHandler(err);
                    deferred.reject(null);
                  };
                  var payload = {
                    transactionId: vm.userdata.transactionId,
                    transactionType: 'PURCHASE'
                  }
                  UtilityService.post({
                    controller: 'transaction',
                    child: 'approved',
                    child1: 'summary'
                  }, payload).$promise.then(success, error);
                }else{
                  $state.go('newInvestor.investorProfile');
                }

                // var isFavourite = vm.formData.isFavourite ? true : false;
                // sessionStorage.setItem("riaName", vm.formData.riaBrokerName);
                // // $state.go('main.summary-success', {
                //   transactionId: transactionId,
                //   transactionType: vm.formData.investmentType, isFavourite: isFavourite
                // });

                  }
                }
      vm.showUPISuccessPopup = function () {
        var successModal = function () {
          // $state.go('welcome');
          $state.go('newInvestor.investorProfile');
        },
          errorModal = function () {
            // $state.go('welcome');
            $state.go('newInvestor.investorProfile');
          };
        ModalService.upiSuccessModal({}, successModal, errorModal);
      };


      vm.showSummary = false;

      // vm.gotoprofile = function () {
      //   $state.go('newInvestor.investorProfile');
      // }

      vm.rtgsBankTogg = true;
      vm.selectRtgsBank = function () {
        vm.rtgsBankTogg = !vm.rtgsBankTogg;
        vm.bankchequeLeafUrl = null;
        vm.rtgsFormData.$setPristine();
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankName){
          vm.formData.paymentInfo.bankName = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.branchName){
          vm.formData.paymentInfo.branchName = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.accNo){
          vm.formData.paymentInfo.accNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.accType){
          vm.formData.paymentInfo.accType = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyBankAcNo || (vm.formData.paymentInfo.verifyBankAcNo == undefined)){
          vm.formData.paymentInfo.verifyBankAcNo = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.ifscCode || (vm.formData.paymentInfo.ifscCode == undefined)){
          vm.formData.paymentInfo.ifscCode = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.utrNumber){
          vm.formData.paymentInfo.utrNumber = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.verifyUtrNumber || (vm.formData.paymentInfo.verifyUtrNumber == undefined)){
          vm.formData.paymentInfo.verifyUtrNumber = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
          vm.formData.paymentInfo.chequeLeaf = null;
        }
        if(vm.formData.paymentInfo && vm.formData.paymentInfo.bankNameWithAccountNumber){
          vm.formData.paymentInfo.bankNameWithAccountNumber = null;
        }
        if(vm.rtgsBankTogg){
          vm.bankchequeLeafUrl = null;
          vm.isAccTypeFieldDisabled = false;
          vm.getPaymenMode('RTGS');
          if(vm.bankInfo){
            vm.formData.paymentInfo.bankName = vm.bankInfo.bankName;
            vm.formData.paymentInfo.branchName = vm.bankInfo.bankBranch;
            vm.formData.paymentInfo.accNo = vm.bankInfo.accountNumber;
            vm.formData.paymentInfo.ifscCode = vm.bankInfo.ifscCode;
            vm.formData.paymentInfo.accType = vm.bankInfo.bankAcType;
          }
        }else{
          // vm.formData.paymentInfo = vm.folioBankData && vm.folioBankData.bankList?vm.folioBankData.bankList[0]:null;
          vm.bankInfo = null;
          if(vm.formData.paymentInfo && vm.formData.paymentInfo.tpvEnableFlag){
            vm.formData.paymentInfo.tpvEnableFlag = null;
          }
        }
        vm.bankAccountTypes();
      }
      vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff", "application/pdf"];
      vm.bankUploadChequeLeafFile = function (file) {
        var fi = document.getElementById('chequesleafImage');
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format should be PDF, TIF, TIFF, JPG and JPEG extension.");
          fi.value = '';
          return;
        }
        if (file) {
          if (fi.files[0].size <= 3145728) {
            var success = function (resp) {
              // LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.bankchequeLeafUrl = resp.data.fileUrl;
                vm.formData.paymentInfo.chequeLeaf = resp.data.fileUrl;
                vm.fileType = file.type.split('/')[1];
              }
              else {
                vm.fileType = '';
                MessageService.error(resp.message);
                fi.value = '';
              }
            },
              error = function (err) {
                // LoaderService.hideLoader(err);
                fi.value = '';
              };

            if (file) {
              // LoaderService.showLoader();
              var fd = new FormData();
              fd.append('file', file);
              // https://dev-api.hdfcfund.com/investor/v3/folio/upload/bankDetails/chequeLeaf
              ChequeLeafFileUploadService.post({
                child0: 'investor',
                 child1: 'folio',
                 child2: 'add',
                 child3: 'document',
                 child4: 'upload',
                 child5: 'PURCHASE',
                 child6: 'CHEQUE_LEAF',
                 child7: vm.investorDetails.arnCode
                 }, fd).$promise.then(success, error);
            }
          }
          else {
            MessageService.error("File size should not be more than 3 MB.");
            file.value = '';
            if(vm.formData.paymentInfo && vm.formData.paymentInfo.chequeLeaf){
              vm.formData.paymentInfo.chequeLeaf = null;
              vm.bankchequeLeafUrl = null;
              vm.fileType = null;
            }
          }
        }

      }
      vm.openUploadedDoc = function () {
        if (angular.isUndefined(vm.bankchequeLeafUrl)) { return; }
        ModalService.imagePreviewModal({  showOnly: true,file: vm.bankchequeLeafUrl });
      };

      function setFormDataForNeft(form) {
        vm.rtgsFormData = form
      }

      vm.downloadPdfFile = function(url, fileType){
        var success = function (resp){
            LoaderService.hideLoader();
            if (resp.data) {
              var data = new Blob([resp.data], { type: 'application/'+fileType });
              FileSaver.saveAs(data, 'Cheque_Leaf.'+fileType);
            } else {
              MessageService.error('No Data Available');
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        LoaderService.showLoader();
        var payload = {};
        DownloadPdfService.download(payload, fileType, url).then(success, error);
      }

    }
  })();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FolioController', FolioController);

  /** @ngInject */
  function FolioController(LoaderService,$state,$rootScope, $stateParams, InvestorsService, InvestorsCommonService, UtilService, MessageService) {
    var vm = this;
    $rootScope.myState = $state.current.url;
    vm.uuid = $stateParams.uuid;
  }
})();
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('KycVerificationController', KycVerificationController);
  /** @ngInject */
  function KycVerificationController($window, $state, $rootScope, AppConstants, AuthService, InvestorServiceDynamicData, ModalService, ChangeDividendService, MessageService, InvestorModel, LoaderService, InvestorsServiceVersion, panAdharLinkingService, NewInvestorFolioServiceV1) {
    var vm = this;
    vm.viewMode = "days";
    vm.formData = {};
    vm.formData.pan = '';
    vm.formData.dob = '';
    vm.formData.taxStatusResident = true;
    vm.AppConstants = AppConstants;
    vm.conformation = "";
    vm.btnClose = true;
    vm.changeStartDate = changeStartDate;
    vm.fetchSavedDraftFolioData = fetchSavedDraftFolioData;
    vm.redirectionToStep = redirectionToStep;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
   vm.checkInvestorStatus = JSON.parse(sessionStorage.getItem('checkInvestorStatus'));
   var identifierData = AuthService.getToken();
   vm.clearsidebar = function(){
    $rootScope.testObj.steps[0].stepActive = true;
    $rootScope.testObj.steps[0].stepCompleted = false;
    $rootScope.testObj.steps[1].stepActive = false;
    $rootScope.testObj.steps[1].stepCompleted = false;
    $rootScope.testObj.steps[2].stepActive = false;
    $rootScope.testObj.steps[2].stepCompleted = false;
    $rootScope.testObj.steps[0].investorName = "";
    $rootScope.testObj.steps[0].panNumber = "";
    $rootScope.testObj.steps[1].schemeName = "";
    $rootScope.testObj.steps[1].frequency = "";
    $rootScope.testObj.steps[1].schemeInfo.amount ="";
    $rootScope.testObj.steps[1].schemeInfo.investmentType = "";
   }
   vm.clearsidebar();
    vm.verifyDetails = function() {
      vm.processFlag = true;
      sessionStorage.removeItem("investorIsBackButtonClick");
      var success = function (resp) {
        sessionStorage.removeItem('checkInvestorStatus');
        if(resp.status && resp.data) {
          // var success = function(modalresp){
          // $window.sessionStorage.setItem('folioWithTransaction',modalresp.folioWithTransaction);
          var data = resp.data;
          data.dob = moment(vm.formData.dob).format("DD-MMM-YYYY");
          if(!vm.isFromPendingApproval) {
            resp.data.nriTaxStatus = vm.formData.taxStatusResident == false ? true : false;
          }
          $window.sessionStorage.setItem("verifyObj", JSON.stringify(resp.data));
          updateSiebar();
          vm.kycStatus = resp.data.ekycStatus;
          if(resp.data.investorAlreadyAssociated == true){
            LoaderService.hideLoader('.popup');
            ModalService.newJourneyFolioCondition({
              investorType: "oldUser",
              payload : {
                dob: moment(vm.formData.dob).format("DD-MMM-YYYY"),
                pan: vm.formData.pan,
                nriTaxStatus: vm.formData.taxStatusResident == false ? true : false
              }
            }, function () { }, function () { });
            vm.processFlag = false;
          }else{
          if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.IN_PROGRESS) {
            if((!resp.data.mobileNumber && !resp.data.email) && !resp.data.investorExists){
              LoaderService.hideLoader('.popup');
              vm.processFlag = false;
              if(!resp.data.mobileNumber && !resp.data.email){
                MessageService.error(vm.AppConstants.UPDATE_CONTACT_ERROR_BOTH);
                vm.clearsidebar();
                return;
              }else{
                // if(!resp.data.mobileNumber){
                //   MessageService.error("To proceed with Folio creation mobile number of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.");
                //   vm.clearsidebar();
                //   return;
                // }
                // if(!resp.data.email){
                //   MessageService.error("To proceed with Folio creation email id of investor are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.");
                //   vm.clearsidebar();
                //   return;
                // }
              }
            }
            else{
                    createmap();
                    var detailsSuccess = function (result) {
                        $window.sessionStorage.setItem("userData", JSON.stringify(result.data));
                      if(result.data && result.data.folioCreationDraftId && result.data.transactionDraftId && !resp.data.investorAlreadyAssociated && !result.data.jhSecretLinkActive && !result.data.invSecretLinkActive && !vm.isFromPendingApproval) {
                        fetchSavedDraftFolioData(result.data.transactionDraftId,function (draftData) {
                          localStorage.setItem("folioId", result.data.folioCreationDraftId);
                          if(draftData && (draftData.nriFlag !== resp.data.nriTaxStatus)){
                            var successModal = function(){
                                vm.deleteFolio( function(){
                                  redirectionToStep(result);
                                });
                            },
                              errorModal = function() {
                                resp.data.nriTaxStatus = typeof draftData.nriFlag == 'boolean'? draftData.nriFlag: null;
                                $window.sessionStorage.setItem("verifyObj", JSON.stringify(resp.data));
                                redirectionToStep(result);
                              };
                            ModalService.newJourneyFolioSwitchModal({
                              kycStatusMisMatched: true,
                              nriTaxStatus: draftData.nriFlag == false? 'RI':'NRI'
                            }, successModal, errorModal);
                          } else {
                            redirectionToStep(result);
                          }

                        });
                      } else {
                        if(vm.isFromPendingApproval && result.data.transactionDraftId){
                          fetchSavedDraftFolioData(result.data.transactionDraftId,function (draftData) {
                            resp.data.nriTaxStatus = typeof draftData.nriFlag == 'boolean'? draftData.nriFlag: null;
                            $window.sessionStorage.setItem("verifyObj", JSON.stringify(resp.data));
                            redirectionToStep(result);
                          });
                        }else if(result.data && result.data.folioCreationDraftId && !resp.data.investorAlreadyAssociated && !result.data.jhSecretLinkActive && !result.data.invSecretLinkActive && !vm.isFromPendingApproval) {
                          fetchSavedDraftDataByFolioId(result.data.folioCreationDraftId,function (draftData) {
                            localStorage.setItem("folioId", result.data.folioCreationDraftId);
                            if(draftData && (draftData.nriFlag !== resp.data.nriTaxStatus)){
                              var successModal = function(){
                                  vm.deleteFolio( function(){
                                    redirectionToStep(result);
                                  });
                              },
                                errorModal = function() {
                                  resp.data.nriTaxStatus = typeof draftData.nriFlag == 'boolean'? draftData.nriFlag: null;
                                  $window.sessionStorage.setItem("verifyObj", JSON.stringify(resp.data));
                                  redirectionToStep(result);
                                };
                              ModalService.newJourneyFolioSwitchModal({
                                kycStatusMisMatched: true,
                                nriTaxStatus: draftData.nriFlag == false? 'RI':'NRI'
                              }, successModal, errorModal);
                            } else {
                              redirectionToStep(result);
                            }
                            });
                        } else {
                          redirectionToStep(result);
                        }
                      }
                    },
                      derror = function (err) {
                        vm.processFlag = false;
                         LoaderService.hideLoader('.popup');
                        MessageService.error(AppConstants.ToastrMessage.FAILED);
                      };
                    var payload = {};
                    payload.panNumber = resp.data.pan;
                    payload.arnCode = identifierData.arnCode;
                    InvestorServiceDynamicData.post({
                      child1: 'new',
                      child2: 'user',
                      child3: 'getDetails'
                    }, payload).$promise.then(detailsSuccess, derror);
              }
          }
          if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.NOT_VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.INCOMPLETE) {
            ModalService.kycInitiateModal({
              investorDetails: InvestorModel.getInvestorModel()
            }, initiateNextSteps, function () { });
            vm.processFlag = false;
            LoaderService.hideLoader('.popup');
          }
          if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.SUSPENDED) {
            LoaderService.hideLoader('.popup');
            ModalService.nonKycModal({
              'text': resp.data.message,
              'buttonText': 'OK'
            }, function () { }, function () { });
            vm.processFlag = false;
          }
          if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.NOT_VERIFIED){
            LoaderService.hideLoader('.popup');
            $rootScope.testObj.steps[0].stepActive = true;
            $rootScope.testObj.steps[0].stepCompleted = false;
            $rootScope.testObj.steps[1].stepActive = false;
            $rootScope.testObj.steps[1].stepCompleted = false;
            vm.processFlag = false;
          }
          if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.NOT_VALIDATED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.ON_HOLD) {
            ModalService.nonKycModal({
              'text': resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.ON_HOLD ?
                "<p>Your KYC Status is 'On hold'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'.</p>" :
                "<p>Your KYC Status is 'Registered'. <a class='click-here-action' href='" + resp.data.updateEkycRedirectUrl+ "' target='_blank'>Click here</a> to initiate update KYC process to change KYC status to 'Validated'.</p>",
              'showHtml': true,
              'buttonText': 'OK',
            }, function () { }, function () { });
          }
          if(resp.data.investorAlreadyAssociated == true){
            LoaderService.hideLoader('.popup');
            ModalService.newJourneyFolioCondition({
              investorType: "oldUser",
              payload : {
                dob: moment(vm.formData.dob).format("DD-MMM-YYYY"),
                pan: vm.formData.pan,
                nriTaxStatus: resp.data.nriTaxStatus
              }
            }, function () { }, function () { });
            vm.processFlag = false;
          }
         // }
          // ModalService.newJourneyFolioCondition({
          //   investorType: "newUser",
          //   payload : {
          //     dob: moment(vm.formData.dob).format("DD-MMM-YYYY"),
          //     pan: vm.formData.pan
          //   }
          // }, success, error);
          }
          }
        else {
          vm.processFlag = false;
          LoaderService.hideLoader('.popup');
          MessageService.error(resp.message);
        }
      },error = function () {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
        };
      vm.payload = {
        dob: moment(vm.formData.dob).format("DD-MMM-YYYY"),
        pan: vm.formData.pan,
        nriFlag: vm.formData.taxStatusResident == false? true: false
      };
      vm.payload.pan = AuthService.encryptRSA(angular.copy(vm.payload.pan));
      vm.payload.dob = AuthService.encryptRSA(angular.copy(vm.payload.dob));
      LoaderService.showLoader('.popup');
      var successHandlerForPanAadhar = function(){
        ChangeDividendService.post({
          child1: 'v2',
          child2: 'distributorNewInvestor',
          child3: 'investor',
          child4: 'pan',
          child5: 'details'
        }, vm.payload).$promise.then(success, error);
      }, errorHandlerForPanAadhar = function(){
        LoaderService.hideLoader('.popup');
        vm.processFlag = false;
        return;
      };
      panAdharLinkingService.checkPanAdharStatus(vm.formData.pan,'', identifierData.arnCode).then(successHandlerForPanAadhar).catch(errorHandlerForPanAadhar);
    }


    function changeStartDate(date) {
      if (angular.isDefined(date._i) ||
        /^(0[1-9]|[1-9]|[12][0-9]|3[01])-([Jj][Aa][Nn]|[Ff][Ee][Bb]|[Mm][Aa][Rr]|[Aa][Pp][Rr]|[Mm][Aa][Yy]|[Jj][Uu][Nn]|[Jj][Uu][Ll]|[Aa][Uu][Gg]|[Ss][Ee][Pp]|[Oo][Cc][Tt]|[Nn][Oo][Vv]|[Dd][Ee][Cc])-(19|20)\d\d$/.test(date._i)) {
        vm.formData.dob = date;
        if (!date) {
          vm.dateErrorMessage = vm.validateData.DOB_FIELD_MM;
        } else vm.dateErrorMessage = '';
      } else {
        vm.dateErrorMessage = vm.validateData.DOB_FIELD_MM;
        vm.formData.dob = "";
      }
      return;
    }

    function initiateNextSteps(resp) {
      var investorData = InvestorModel.getInvestorModel();
      vm.investorDetails = resp;
      var payload = {
        investorName: resp.name,
        pan: vm.formData.pan,
        email: resp.email,
        mobileNo: resp.mobile,
        dob: moment(vm.formData.dob).format("DD-MMM-YYYY"),
        ekycStatus: vm.kycStatus
      };
      InvestorsServiceVersion.post({
        child1: 'save',
        child2: 'investor',
        child3: 'eKyc',
        child4: 'details',
      }, payload).$promise.then(ekycValueSubmissionSuccess, ekycValueSubmissionError);
    }

    function ekycValueSubmissionSuccess(resp) {
      var investorData = InvestorModel.getInvestorModel();
      if (resp.status) {
        ModalService.eKycModal({
          investorName: vm.investorDetails.name
        }, function () { }, function () { });
      }
    }

    function ekycValueSubmissionError(resp) {
      MessageService.error(resp.message);
    }

    vm.getconformation = function () {
      if ($("#confirmfoliocreate").prop("checked")) {
        $("#confirmfoliocreate1").prop("checked", false);
        vm.conformation = 'US_CANADA';
        vm.btnClose = true;
      } else {
        vm.conformation = '';
        vm.btnClose = true;
      }
    }
    vm.getconformation1 = function () {
      if ($("#confirmfoliocreate1").prop("checked")) {
        $("#confirmfoliocreate").prop("checked", false);
        vm.conformation = 'NOT_US_CANADA';
        vm.btnClose = false;
      } else {
        vm.conformation = '';
        vm.btnClose = true;
      }
    }

    vm.autoDate = function () {
      var oldlength = 0;
      if (vm.dobString) {
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if (vm.dobString.length == 2) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
      if (vm.dobString.length == 5) {
        if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
        } else {
          $("#dobId").val(vm.dobString + "-");
        }
      }
    }
    function createmap() {
      LoaderService.showLoader('.fundCreateMap');
      var success = function (resp) {
        LoaderService.hideLoader('.fundCreateMap');
      },
        error = function () {
          LoaderService.hideLoader('.fundCreateMap');
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      InvestorServiceDynamicData.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'create',
        child5: 'map'
      }).$promise.then(success, error);
    }

    function updateSiebar() {
      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].investorName = uContext.name;
      $rootScope.testObj.steps[0].panNumber = uContext.pan;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[1].stepActive = true;
    }

    if(vm.checkInvestorStatus){
      vm.formData.pan = vm.checkInvestorStatus.panNumber;
       vm.reverseDate = vm.checkInvestorStatus.dob.split('-')
      changeStartDate($window.moment( vm.reverseDate[2] +'-'+ vm.reverseDate[1]+'-'+vm.reverseDate[0] , "DD-MM-YYYY"));
      $("#confirmfoliocreate").prop("checked", false);
      $("#confirmfoliocreate1").prop("checked", true);
      vm.conformation = 'NOT_US_CANADA';
      vm.btnClose = false;
      vm.verifyDetails();
      vm.isFromPendingApproval = vm.checkInvestorStatus.isFromPendingApproval;
     }
     vm.fetchDynamicData =  function(pageName) {
      LoaderService.showLoader();
      var successHandler = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.dynamicDataNomineeOptOut = resp.data.popupDTO.popupDTOMap.Popup_StandAloneFolioCreation;
        }
      };
      var errorHandler = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      var payload = {
        "pageName": pageName
      };
      InvestorServiceDynamicData.post({
        "child1": "dynamicContent"
      }, payload).$promise.then(successHandler, errorHandler);
    };
    vm.fetchDynamicData('STAND_ALONE_FOLIO_JOURNEY');

    function fetchSavedDraftFolioData(transactionDraftId,cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.data && resp.status) {
            cb(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      LoaderService.showLoader('.pan-loader');
      if(transactionDraftId) {
        ChangeDividendService.post({
          child1: 'v2',
          child2: 'distributorNewInvestor',
          child3: 'saved',
          child4: 'draft'
        }, {
          id: transactionDraftId,
          "arnCode": identifierData.arnCode
        }).$promise.then(success, error);
      }
    }
    function redirectionToStep(result){
      // if(modalresp.folioWithTransaction){
      if (result.data.step == "FIRST" || result.data.step == "SECOND" || result.data.step == "THIRD") {
        if(result.data.jhSecretLinkActive === true || result.data.invSecretLinkActive === true){
          var successModal = function (resp) {
            if(resp == 'yes'){
              var popsuccess =function(data){
                vm.folioWithoutTransaction = data;
                if(vm.folioWithoutTransaction){
                  $state.go("main.newinvestor.folioCreation.folioDetails");
                }else{
                  $state.go("main.newinvestor.investmentDetails.select-scheme");
                }
              }
              var poperror =function () {
                // MessageService.error(AppConstants.ToastrMessage.FAILED);
              }
              ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
            }
          },errorModal = function () {
          };
          ModalService.investorLinkStatusModal({},successModal, errorModal);
        }else{
          var popsuccess =function(data){
            vm.folioWithoutTransaction = data;
            if(vm.folioWithoutTransaction){
              $state.go("main.newinvestor.folioCreation.folioDetails");
            }else{
              $state.go("main.newinvestor.investmentDetails.select-scheme");
            }
          }
          var poperror =function () {
            // MessageService.error(AppConstants.ToastrMessage.FAILED);
          }
          ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
        }
      }
      // }
      // if(!modalresp.folioWithTransaction){
      //   if((result.data.step == "FIRST" || result.data.step == "SECOND" || result.data.step == "THIRD")){
      //     $state.go("main.newinvestor.folioCreation.folioDetails");
      //   }
      // }
      if (result.data.step == "HOLD" && result.data.folioNumber == null) {
        // MessageService.error("For this investor folio Joint holder approval is in process.");
        // var successModal = function () {
        // },
        //   errorModal = function () {
        //     $state.go('main.newinvestor.kycverify');
        //   };
        // ModalService.holdHolderModal(result.data, successModal, errorModal);
        if(result.data.jhSecretLinkActive === true){
          var successModal = function (resp) {
            if(resp == 'yes'){
              var popsuccess =function(data){
                vm.folioWithoutTransaction = data;
                if(vm.folioWithoutTransaction){
                  $state.go("main.newinvestor.folioCreation.folioDetails");
                }else{
                  $state.go("main.newinvestor.investmentDetails.select-scheme");
                }
              }
              var poperror =function () {
                // MessageService.error(AppConstants.ToastrMessage.FAILED);
              }
              ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
            }
          },errorModal = function () {
          };
          ModalService.investorLinkStatusModal({},successModal, errorModal);
        }else{
          var popsuccess =function(data){
            vm.folioWithoutTransaction = data;
            if(vm.folioWithoutTransaction){
              $state.go("main.newinvestor.folioCreation.folioDetails");
            }else{
              $state.go("main.newinvestor.investmentDetails.select-scheme");
            }
          }
          var poperror =function () {
            // MessageService.error(AppConstants.ToastrMessage.FAILED);
          }
          ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
        }
      }
      if (result.data.step == "FOURTH" && result.data.folioNumber == null) {
        if(result.data.invSecretLinkActive === true){
          var successModal = function (resp) {
            if(resp == 'yes'){
              var popsuccess =function(data){
                vm.folioWithoutTransaction = data;
                if(vm.folioWithoutTransaction){
                  $state.go("main.newinvestor.folioCreation.folioDetails");
                }else{
                  $state.go("main.newinvestor.investmentDetails.select-scheme");
                }
              }
              var poperror =function () {
                // MessageService.error(AppConstants.ToastrMessage.FAILED);
              }
              ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
            }
          },errorModal = function () {
          };
          ModalService.investorLinkStatusModal({},successModal, errorModal);
        }else{
          var popsuccess =function(data){
            vm.folioWithoutTransaction = data;
            if(vm.folioWithoutTransaction){
              $state.go("main.newinvestor.folioCreation.folioDetails");
            }else{
              $state.go("main.newinvestor.investmentDetails.select-scheme");
            }
          }
          var poperror =function () {
            // MessageService.error(AppConstants.ToastrMessage.FAILED);
          }
          ModalService.newJourneyFolioSelectModal({message: vm.dynamicDataNomineeOptOut}, popsuccess,poperror);
        }
        // MessageService.error("For this user folio creation link has been created please check pending section in investor");
        // $state.go("main.newinvestor.investmentDetails.select-scheme");
      }
      if (result.data.step == null) {
        MessageService.error("Something went wrong. Please try again later.");
      }
      vm.errorMessageVerify = '';
      LoaderService.hideLoader('.popup');
      vm.processFlag = false;
    }

    vm.deleteFolio = function (cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            localStorage.removeItem("folioId");
            MessageService.success("Successfully delete folio draft data.");
            cb();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
        };
      var uuid = localStorage.getItem("folioId");
      if(uuid){
        NewInvestorFolioServiceV1.post({ child1: 'new',child2: 'user', child3: 'delete', child4: 'draft', child5: 'folio', child6: uuid},{}).$promise.then(success, error);
      }
    }
    function fetchSavedDraftDataByFolioId(folioDraftId,cb) {
      cb = cb || function () {
      };
      var success = function (resp) {
          if (resp.data && resp.status) {
            cb(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      LoaderService.showLoader('.pan-loader');
      ChangeDividendService.post({child1: 'folio',child2: 'getFolioDetails'},{id:folioDraftId,"arnCode" : identifierData.arnCode}).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestmentDetailController', InvestmentDetailController);

  /** @ngInject */
  function InvestmentDetailController($state, $rootScope, $window) {
    var vm = this;
    $rootScope.currentstate = $state.current.url;
    $rootScope.stepperSecondary = {
      "steps": [{
        step: 1,
        name: "Scheme Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
        state: 'newInvestor.investmentDetails.schemedetails'
      }, {
        step: 2,
        name: "Investment Mode",
        expanded: true,
        stepActive: false,
        stepCompleted: false,
        state: 'newInvestor.investmentDetails.investmentmode'
      }, {
        step: 3,
        name: "Amount Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false,
        state: 'newInvestor.investmentDetails.amountdetails'
      }
      ]
    };
    $rootScope.logoutBtn = function () {
      vm.myState = $state.current.url;
      if(vm.myState == '/amount-detail'){
        $state.go("main.newinvestor.investmentDetails.investmentMode");
      }
      if(vm.myState == '/Investment-mode'){
        $state.go("main.newinvestor.investmentDetails.select-scheme.scheme");
      }
      if(vm.myState == '/choose-scheme' || vm.myState == '/investment-goal'){
        sessionStorage.removeItem("verifyObj");
        $state.go("main.newinvestor.kycverify");
      }
    }
    var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
    if (!uContext) {
      $rootScope.logoutBtn();
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NewFolioCreationController', newFolioCreationController);

  /** @ngInject */
  function newFolioCreationController($state, AppConstants, InvestorServiceDynamicData, InvestorsService, $rootScope, UtilService, MessageService, AuthService,ChangeDividendService,LoaderService, InvestorModel,$window) {
    var vm = this;
    vm.showholderdetails = false;
    vm.countries = [];
    vm.taxIdType = [];
    vm.taxStatusData = [];
    vm.investorOccupations = [];
    vm.incomeSlabList = [];
    vm.addressType = [];
    $rootScope.folioBasicDetail = {}
    $rootScope.folioBasicDetail.folioForUser = 'Self';
    $rootScope.folioBasicDetail.folioHoldingMode = "SINGLE";
    vm.init = init;
    var identifierData = AuthService.getToken();

    vm.skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
    vm.investorDetails = JSON.parse(sessionStorage.getItem("verifyObj"));
    if(vm.skipInvestmentDetails){
      $rootScope.updateSideBarSteps();
      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      $rootScope.testObj = {
        steps: [{
          step: 1,
          name: "KYC Verification",
          expanded: true,
          stepActive: true,
          investorName: uContext.name,
          panNumber: uContext.pan,
          stepCompleted: false
        },
        {
          step: 2,
          name: "Folio Creation",
          expanded: true,
          stepActive: true,
          stepCompleted: false
        }]
      }
    }
    function init() {
      vm.investorDetails = JSON.parse(sessionStorage.getItem("verifyObj"));
      $rootScope.testObj.steps[0].panNumber = vm.investorDetails.pan;
      $rootScope.testObj.steps[0].investorName = vm.investorDetails.name;
      $rootScope.testObj.steps[0].stepCompleted = true;
      $rootScope.testObj.steps[0].stepActive = false;
      $rootScope.testObj.steps[1].stepCompleted = true;
      $rootScope.testObj.steps[1].stepActive = false;
      if(vm.skipInvestmentDetails){
        $rootScope.testObj.steps[1].stepCompleted = false;
        $rootScope.testObj.steps[1].stepActive = true;
      }else{
        $rootScope.testObj.steps[2].stepActive = true;
      }

      getCountryList();
      getTaxIdType();
      taxStatus();
      occupation();
      incomeSlab();
      addressType();
    }
    vm.transactionId = JSON.parse(sessionStorage.getItem("userData"));
    if(vm.transactionId){
      var identifierData = AuthService.getToken();
      var success = function (resp) {
        if (resp.data && resp.status) {
          LoaderService.hideLoader();
          if(!vm.skipInvestmentDetails){
            $rootScope.testObj.steps[1].schemeName = resp.data.schemeName;
            $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;
            $rootScope.testObj.steps[1].schemeInfo.amount = resp.data.amount;
            switch(resp.data.installmentFrequency){
              case'OM':
                $rootScope.testObj.steps[1].frequency = "Monthly";
                break;
              case 'Q':
                $rootScope.testObj.steps[1].frequency = "Quarterly";
                break;
                case'H':
                $rootScope.testObj.steps[1].frequency = "Half Yearly";
                break;
              case 'Y':
                $rootScope.testObj.steps[1].frequency = "Yearly";
                break;
            }
            $rootScope.stepperSecondary.steps[0].stepActive = false;
            $rootScope.stepperSecondary.steps[0].stepCompleted = true;
            $rootScope.stepperSecondary.steps[1].stepActive = false;
            $rootScope.stepperSecondary.steps[1].stepCompleted = true;
            $rootScope.stepperSecondary.steps[2].stepActive = true;
          }
          $rootScope.stepperSecondary.steps[0].stepActive = false;
          $rootScope.stepperSecondary.steps[0].stepCompleted = true;
          $rootScope.stepperSecondary.steps[1].stepActive = false;
          $rootScope.stepperSecondary.steps[1].stepCompleted = true;
          $rootScope.stepperSecondary.steps[2].stepActive = true;

        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      vm.processFlag = false;
      if(!vm.skipInvestmentDetails){
        ChangeDividendService.post({
            child1:'v2',
            child2:'distributorNewInvestor',
          child3: 'saved',
          child4: 'draft'
        },{id:vm.transactionId.transactionDraftId, arnCode:identifierData.arnCode}).$promise.then(success, error);
      }
    }

    function getCountryList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.countries = resp.data.countries;
          vm.filteredCountry = resp.data.countries.filter(function(el){
            return el.countryCode != "IN";
          });
        } else {
          vm.countries = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.countries = null;
        UtilService.errorHandler(err);
      };
      InvestorsService.post({ controller: 'country', child1: 'list' }, null).$promise.then(success, error);
    }

    function getTaxIdType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.taxIdType = resp.data.taxIdTypeResponses;
          $rootScope.taxIDType = vm.taxIdType;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'taxId-type' }, {}).$promise.then(success, error);
    }

    function taxStatus() {
      var successTaxStatus = function (resp) {
        if (resp.status && resp.data) {
          vm.taxStatusData = resp.data.taxStatus;
          InvestorModel.setInvestorResponse(vm.taxStatusData);
        }
        else {
          MessageService.error(resp.message);
        }
      },
        errorTaxStatus = function (err) {
          UtilService.errorHandler(err);
        };
      var minorCheckParams = false;
      if ($rootScope.folioBasicDetail.folioForUser == 'Self') {
        minorCheckParams = false;
      }else{
        minorCheckParams = true;
      }
      var payloadTaxStatus = {
        taxStatusFilter: minorCheckParams ? 'MINOR' : 'ADULT',
        nriFlag: vm.investorDetails.nriTaxStatus
      };
      InvestorsService.post({ controller: 'tax-status' }, payloadTaxStatus).$promise.then(successTaxStatus, errorTaxStatus);
    }
    function occupation() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.investorOccupations = resp.data.investorOccupations;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'get-occupation' }, {}).$promise.then(success, error);
    }
    function incomeSlab() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.incomeSlabList = resp.data.incomeSlabList;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'income', child1: 'slab' }, {}).$promise.then(success, error);
    }
    function addressType() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.addressType = resp.data.addressTypeResponses;
        } else {
          MessageService.error(resp.message);
        }
      },
        error = function (err) {
          UtilService.errorHandler(err);
        };

      InvestorsService.post({ controller: 'address', child1: 'type' }, {}).$promise.then(success, error);
    }


    $rootScope.addholder = {
      steps: [
        { step: 1, isactive: false },
        { step: 2, isactive: false },
        { step: 3, isactive: false }
      ]
    }

    $rootScope.stepperThird = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 4,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };

    $rootScope.stepperForMinor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Guardian Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    $rootScope.stepperForAnyoneSurvivor = {
      "steps": [{
        step: 1,
        name: "Basic Details",
        expanded: true,
        stepActive: true,
        stepCompleted: false,
      }, {
        step: 2,
        name: "Income Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 3,
        name: "Holder Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 4,
        name: "Nominee Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }, {
        step: 5,
        name: "Bank Details",
        expanded: true,
        stepActive: false,
        stepCompleted: false
      }
      ]
    };
    $rootScope.addholder = {
      steps: [
        { step: 1, isactive: false },
        { step: 2, isactive: false },
        { step: 3, isactive: false }
      ]
    }
    $rootScope.nextStep = function (val) {
      if ($rootScope.folioBasicDetail.folioHoldingMode == 'SINGLE') {
        $rootScope.stepperThird.steps[val].stepActive = false;
        $rootScope.stepperThird.steps[val].stepCompleted = true;
        $rootScope.stepperThird.steps[val + 1].stepActive = true;
      }
      else {
        $rootScope.stepperForAnyoneSurvivor.steps[val].stepActive = false;
        $rootScope.stepperForAnyoneSurvivor.steps[val].stepCompleted = true;
        $rootScope.stepperForAnyoneSurvivor.steps[val + 1].stepActive = true;
      }

      if ($rootScope.stepperThird.steps[0].stepActive && $rootScope.stepperForAnyoneSurvivor.steps[0].stepActive) {
        vm.showincomedetails = false;
        vm.shownominidetails = false;
      }
      if ($rootScope.stepperThird.steps[1].stepActive || $rootScope.stepperForAnyoneSurvivor.steps[1].stepActive) {
        vm.showincomedetails = true;
        vm.shownominidetails = false;
      }
      if ($rootScope.stepperThird.steps[2].stepActive) {
        vm.showincomedetails = false;
        vm.shownomineedetails = true;
      }
      if ($rootScope.stepperForAnyoneSurvivor.steps[2].stepActive) {
        vm.showincomedetails = false;
        vm.showholderdetails = true;
      }
      if ($rootScope.folioBasicDetail.folioHoldingMode == 'ANY_OR_SURVIVOR' && val == 2) {
        $rootScope.addholder.steps[2].isactive = false;
        $rootScope.stepperForAnyoneSurvivor.steps[2].stepActive = false;
        $rootScope.stepperForAnyoneSurvivor.steps[2].stepCompleted = true;
        $rootScope.stepperForAnyoneSurvivor.steps[3].stepActive = true;
      }
      if ($rootScope.stepperForAnyoneSurvivor.steps[3].stepActive) {
        vm.showholderdetails = false;
        vm.shownomineedetails = true;
      }
    }
  // minor
  vm.stepperForMinor = {
  "steps": [{
    step: 1,
    name: "Basic Details",
    expanded: true,
    stepActive: true,
    stepCompleted: false,
  }, {
    step: 2,
    name: "Guardian Details",
    expanded: true,
    stepActive: false,
    stepCompleted: false
  },{
    step: 3,
    name: "Bank Details",
    expanded: true,
    stepActive: false,
    stepCompleted: false
  }
  ]
  };
    $rootScope.minornext = function (val) {
      vm.stepperForMinor.steps[val].stepCompleted = true;
      vm.stepperForMinor.steps[val + 1].stepActive = true;
    }
    $rootScope.setProgress = function () {

    }

    vm.getTransactionDetails = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          $rootScope.testObj.steps[1].schemeName = resp.data.schemeName;
          switch (resp.data.installmentFrequency) {
            case 'OM':
              $rootScope.testObj.steps[1].frequency = "Monthly";
              break;
            case 'Q':
              $rootScope.testObj.steps[1].frequency = "Quarterly";
              break;
            case 'H':
              $rootScope.testObj.steps[1].frequency = "Half Yearly";
              break;
            case 'Y':
              $rootScope.testObj.steps[1].frequency = "Yearly";
              break;
          }
          $rootScope.testObj.steps[1].schemeInfo.amount = resp.data.amount;
          $rootScope.testObj.steps[0].stepActive = false;
          $rootScope.testObj.steps[0].stepCompleted = true;
          $rootScope.testObj.steps[1].stepActive = false;
          $rootScope.testObj.steps[1].stepCompleted = true;
          $rootScope.testObj.steps[2].stepActive = true;
          $rootScope.testObj.steps[1].schemeInfo.investmentType = resp.data.investmentType;
        } else {

          MessageService.error(resp.message);

        }

      },

        error = function (err) {

          MessageService.error(AppConstants.ToastrMessage.FAILED);

        };

      try {
        vm.processFlag = false;
        LoaderService.showLoader('.pan-loader');
        var Details = JSON.parse(sessionStorage.getItem("userData"));
        InvestorService.post({
          child1: 'new', child2: 'user', child3: 'saved', child4: 'draft'
        }, { "id": Details.transactionDraftId ,"arnCode":identifierData.arnCode}).$promise.then(success, error);
      } catch (e) { }
    }
    if(!vm.skipInvestmentDetails){
      vm.getTransactionDetails();
    }
    vm.getFatacaDetails = function() {
      var success = function (resp) {
      if (resp.status && resp.data) {
      vm.FATACADETAILS = resp.data;
      localStorage.setItem('fatcadetails',$window.JSON.stringify(vm.FATACADETAILS));
      } else {
        vm.FATACADETAILS = null;
        MessageService.error(resp.message);
      }
      }
      error = function (err) {
        vm.FATACADETAILS = null;
        UtilService.errorHandler(err);
      };
      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      var payload = {
        "panNumber": uContext.pan
    };
      InvestorsService.post({ controller: 'getFatcaDetailStandalone'}, payload).$promise.then(success, error);
    }
    vm.getFatacaDetails();
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TpvController', tpvController);
   function tpvController() {
      console.log('from tvp controller')
   }
});

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MobileTncController', mobileTncController);

  /** @ngInject */
  function mobileTncController($stateParams, ModalService , UtilService , MessageService , dynamicData) {
    var vm = this;
    vm.dynamicTerms = dynamicData.termAndConditionDTO.termAndConditionDTOMap;

    vm.init = function() {
      vm.transactionType = $stateParams.tncType;
    }

    vm.showGeneralTnc = function() {
      ModalService.termConditionModal({});
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MobileFaqController', mobileFaqController);

  function mobileFaqController(UtilService,MessageService) {
    var vm = this;
    vm.date = new Date();
    vm.scroll = function (id) {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView();
    }
    init();
    function init() {
    var successHandler = function(resp) {
      vm.DynamicDataFaq = resp.faqDTO.faqDTOMap.FAQ_Content;
    }

    UtilService.fetchDynamicData("FAQ").then(successHandler).catch(function(resp) {
      MessageService.error(resp);
    });
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .config(addInverstorRoute);

  /** @ngInject */
  function addInverstorRoute($stateProvider) {
    $stateProvider
      .state('approval', {
        url: '/approval',
        templateUrl: 'app/investors/summary/summary.html',
        authenticate: false
        //defaultRoute: '.appdetails',
      })
      .state('approval.holder', {
        url: '/folio/:uuid/holder',
        templateUrl: 'app/investors/summary/folioApproval/holderApproval/holder.html',
        controller: 'HolderApprovalController',
        controllerAs: 'HolderApproval',
        authenticate: false,
        resolve: {
          checkValidHolder: _checkValidHolder
        }
      })
      .state('approval.folio', {
        url: '/folio/:uuid',
        templateUrl: 'app/investors/summary/folioApproval/index.folioApproval.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApprovalParent',
        authenticate: false,
        resolve: {
          checkValidLink: _checkValidLink
        }
      })
      .state('approval.folio.soleApplicant', {
        url: '/soleApplicant',
        templateUrl: 'app/investors/summary/folioApproval/soleApplicant.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApproval',
        authenticate: false
      })
      .state('approval.folio.jointHolders', {
        url: '/jointHolders',
        templateUrl: 'app/investors/summary/folioApproval/jointHolders.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApproval',
        authenticate: false
      })
      .state('approval.folio.nominee', {
        url: '/nominee',
        templateUrl: 'app/investors/summary/folioApproval/nominee.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Nominee',
        authenticate: false
      })
      .state('approval.folio.bankDetails', {
        url: '/bankDetails',
        templateUrl: 'app/investors/summary/folioApproval/bankDetails.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Payment',
        authenticate: false
      })
      .state('approval.folio.approved', {
        url: '/approved/camsMessage?&camsMessage',
        templateUrl: 'app/investors/summary/folioApproval/approved.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Approved',
        authenticate: false
      })
      .state('approval.folio.rejected', {
        url: '/rejected',
        templateUrl: 'app/investors/summary/folioApproval/rejected.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Rejected',
        authenticate: false
      })
      .state('approval.investorLumpsum', {
        url: '/investor/lumpsum',
        templateUrl: 'app/investors/summary/investorApproval/lumpsum/lumpsumApproval.html',
        controller: 'InvestorApproval',
        controllerAs: 'Approval',
        authenticate: false
      })
      .state('approval.investorSip', {
        url: '/investor/sip',
        templateUrl: 'app/investors/summary/investorApproval/sip/sipApproval.html',
        controller: 'SipApprovalController',
        controllerAs: 'InvestorApproval',
        authenticate: false
      })
      .state('approval.cobm', {
        url: '/cobm/:uuid',
        templateUrl: 'app/investors/summary/cobmApproval/index.cobm.html',
        controller: 'CobmApprovalController',
        controllerAs: 'CobmApprovalParent',
        authenticate: false,
        resolve: {
          checkValidLink: _checkValidLink
        }
      })
      .state('approval.cobm.addBank', {
        url: '/addBank',
        templateUrl: 'app/investors/summary/cobmApproval/addBank.html',
        controller: 'CobmApprovalController',
        controllerAs: 'CobmApproval',
        authenticate: false
      })
      .state('approval.cobm.changeBank', {
        url: '/changeBank',
        templateUrl: 'app/investors/summary/cobmApproval/changeBank.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApproval',
        authenticate: false
      })
      .state('approval.cobm.deleteBank', {
        url: '/deleteBank',
        templateUrl: 'app/investors/summary/cobmApproval/deleteBank.html',
        controller: 'CobmApprovalController',
        controllerAs: 'CobmApproval',
        authenticate: false
      })
      .state('approval.cobm.approved', {
        url: '/approved',
        templateUrl: 'app/investors/summary/cobmApproval/approved.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Approved',
        authenticate: false
      })
      .state('approval.cobm.rejected', {
        url: '/rejected',
        templateUrl: 'app/investors/summary/cobmApproval/rejected.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Rejected',
        authenticate: false
      })
  }

  /** @ngInject */
  function _checkValidHolder($stateParams, $q, MessageService, InvestorModel, InvestorsService, UtilService) {
    if (!$stateParams.uuid) {
      UtilService.errorHandler('Not a valid link');
      return;
    } else {
      var deferred = $q.defer(),
        success = function (resp) {
          if (resp.status && resp.data) {
            InvestorModel.setInvestorModel(resp.data);
            deferred.resolve(true);
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp.message);
          }
        }, error = function (err) {
          MessageService.error('An unauthorized access');
          deferred.reject(err);
        };
      InvestorsService.post({
        controller: 'new',
        child1: 'folio',
        child2: 'joint',
        child3: 'holder',
        child4: 'data'
      }, {linkId: $stateParams.uuid}).$promise.then(success, error);
      return deferred.promise;
    }
  }

  /** @ngInject */
  function _checkValidLink($stateParams, $q, MessageService, InvestorModel, InvestorsCommonService, UtilService) {
    var investorId = InvestorModel.getInvestorId();
    if (!$stateParams.uuid) {
      UtilService.errorHandler('Not a valid link');
      return;
    } else if (!investorId) {
      var deferred = $q.defer(),
        success = function (resp) {
          if (resp.status && resp.data) {
            var _id = resp.data.id;
            InvestorModel.setInvestorId(_id);
            deferred.resolve(true);
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp.message);
          }
        }, error = function (err) {
          MessageService.error('An unauthorized access');
          deferred.reject(err);
        },
        payload = {
          id: $stateParams.uuid
        };
      InvestorsCommonService.post({
        child1: 'link',
        child2: 'status'
      }, payload).$promise.then(success, error);

      return deferred.promise;
    } else {
      UtilService.errorHandler();
      return;
    }
  }
})();

/**
 * Created by ttn on 16/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsProfileController', investorsProfileController);

  /** @ngInject */
  function investorsProfileController($window, SchemeService, ModalService, StoreInvestorModel, DistributorGenericService, $timeout, $rootScope, $stateParams, $state, AuthService, MessageService, AppConstants, InvestorsService, LoaderService, TransactionService, investorProfile, UtilService, moment, ReportsService, DashboardService, InvestorModel, HDFC_API, TransactionInitiateModel, WhatsappTransactionService,panAdharLinkingService ) {
    var vm = this;
    vm.breadCrumbLabel = null;
    vm.redirectToAddBank = redirectToAddBank;
    vm.redirectToCobmStatus = redirectToCobmStatus;
    vm.redirectToChangeBank = redirectToChangeBank;
    vm.fetchEmailMobile = fetchEmailMobile;
    if (!$stateParams.investorId || !investorProfile) {
      $state.go('main.investors.list');
      return;
    }

    if ($rootScope.$previousState != null) {
      vm.breadCrumbLabel = $rootScope.$previousState.url == '/sipcorner' ? $rootScope.$previousState.url : "";
    }

    vm.monthArr = {
      'Jan': '0',
      'Feb': '1',
      'Mar': '2',
      'Apr': '3',
      'May': '4',
      'Jun': '5',
      'Jul': '6',
      'Aug': '7',
      'Sep': '8',
      'Oct': '9',
      'Nov': '10',
      'Dec': '11'
    };
    // vm.active = {0: true};
    vm.isLoading = false;
    vm.isInvestorTransactionPagination = false;
    vm.isInvestorPagination = false;
    vm.investorsProfileData = investorProfile;
    vm.validateInvestor = validateInvestor;
    vm.sendReport = sendReport;
    vm.changeSelectedYear = changeSelectedYear;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.investorId = $stateParams.investorId;
    vm.NATURE = AppConstants.INVESTOR_TRANSACTION_NATURE;
    vm.TYPE = angular.copy(AppConstants.INVESTOR_TRANSACTION_TYPE).splice(1, AppConstants.INVESTOR_TRANSACTION_TYPE.length);
    vm.STATUS = angular.copy(AppConstants.INVESTOR_TRANSACTION_STATUS).splice(1, AppConstants.INVESTOR_TRANSACTION_STATUS.length);
    vm.MODE = angular.copy(AppConstants.INVESTOR_TRANSACTION_MODE).splice(1, AppConstants.INVESTOR_TRANSACTION_MODE.length);
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.SCHEMETYPES = [];//[{key: 'Scheme Type', value: 'ALL'}];
    vm.selectedNature = vm.NATURE[0].value;
    vm.selectedType = [];
    vm.selectedType[0] = 'ALL';
    vm.selectedStatus = [];
    vm.selectedStatus[0] = 'Processed';
    vm.selectedMode = [];
    vm.selectedMode[0] = 'ALL';
    vm.selectedSchemeType = [];
    vm.selectedSchemeType[0] = 'ALL';//vm.SCHEMETYPES[0].value;
    // vm.dateFilter = {startDate: null, endDate: null};
    vm.investorDetail = {};
    vm.otherActions = AppConstants.INVESTOR_PROFILE_OTHER_ACTIONS;
    vm.wishSomeone = wishSomeone;
    vm.isSearching = false;

    vm.totalInvestorsPortfolioData = 0;
    vm.currentPageInvestorsPortfolio = 1;
    vm.pageLimitInvestorsPortfolio = 25;

    vm.totalTransactionListData = 0;
    vm.currentPageTransactionListData = 1;
    vm.pageLimitTransactionListData = 25;

    vm.searchText = '';
    vm.multiSettings = {displayProp: 'key', idProp: 'value', dynamicTitle: true};
    vm.transactionTranslationTexts = {buttonDefaultText: 'Transaction Type (All)'};
    vm.modeTranslationTexts = {buttonDefaultText: 'Mode (All)'};
    vm.statusTranslationTexts = {buttonDefaultText: 'Status (PROCESSED)'};
    vm.schemeTranslationTexts = {buttonDefaultText: 'Scheme (All)'};

    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'DESC',
      searchText: ''
    };
    vm.initial = true;
    vm.rudAmountList=[];
    vm.deleteBank=deleteBank;
    vm.changeDefaultBank = changeDefaultBank;
    vm.deleteBankSuccess = deleteBankSuccess;
    vm.changePayoutSwitch = false;
    vm.payoutSwitch = payoutSwitch;
    vm.getPayoutMechanism = getPayoutMechanism;
    vm.UpdatePayoutMethod = UpdatePayoutMethod;
    vm.redirectIFSCUpdate = redirectIFSCUpdate;
    vm.toggleWhatsapp=toggleWhatsapp;
    vm.getSubscribedKey = getSubscribedKey;
    vm.corporateFlag = vm.investorsProfileData.corporateFlag || false;
    vm.cancelMandateUrl = null;
    vm.subscribed = true;
    vm.isDisabled = true;
    vm.redirectToOptOutNomination = redirectToOptOutNomination;
    vm.nomineeStatusCodeEnabled = AppConstants.TAX_STATUS_NOMINEE;
    vm.tokenData = AuthService.getToken();

    function redirectToAddBank() {
      getInvestorInfo(function(resp) {
        if(resp === true) {
          localStorage.setItem('folioId',vm.selectedFolio.folioNo);
          localStorage.setItem('pan',vm.investorsProfileData.PAN);
          localStorage.setItem('bankDetails',$window.JSON.stringify(vm.folioDetailsData.bankDetails));
          localStorage.setItem('InvestorName',vm.investorsProfileData.name);
          $window.sessionStorage.setItem('bankConstraints', angular.toJson({
            isFromProfile: true,
            uploadChequeLeafEnabled: vm.uploadChequeLeafEnabled,
            tokenData: vm.tokenData
          }));
          (vm.folioDetailsData) && (localStorage.setItem('folioTaxStatus', vm.folioDetailsData.folioTaxStatus));
          (vm.folioDetailsData) && (localStorage.setItem('folioTaxStatusCode', vm.folioDetailsData.folioTaxStatusCode));
          $state.go('main.investors.addNewBank',{investorId:vm.investorId});
          InvestorModel.setAddToBankPayload(null);
        }
      });
    }

    function redirectToCobmStatus() {
     // localStorage.setItem('folioId',vm.selectedFolio.folioNo);

      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status && res.data) {
          vm.cobmDetailList = res.data.cobmDetailList;
          localStorage.setItem('cobmDetailList',angular.toJson(res.data.cobmDetailList));
          $state.go('main.investors.cobmStatus',{investorId:vm.investorId});
        }
        else {
          if(localStorage.getItem('cobmDetailList')){
            localStorage.removeItem('cobmDetailList');
          }
          vm.cobmDetailList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        /* var res = {};
         res.cobmDetailList= [
         {
         "bankName": "HDFC Bank Ltd",
         "bankAccNo": "123456",
         "transactionType": "AIPR",
         "transactionDate": "08-Dec-2017",
         "status": "Pending",
         "rejectedReason": ""
         },
         {
         "bankName": "STATE BANK OF MYSORE",
         "bankAccNo": "1111111111",
         "transactionType": "AIPDBM",
         "transactionDate": "06-Dec-2017",
         "status": "Pending",
         "rejectedReason": ""
         },
         {
         "bankName": "STATE BANK OF MYSORE",
         "bankAccNo": "1111111111",
         "transactionType": "AIPR",
         "transactionDate": "05-Dec-2017",
         "status": "Pending",
         "rejectedReason": ""
         }
         ];
         //vm.cobmDetailList = res.cobmDetailList;
        localStorage.setItem('cobmDetailList',angular.toJson(res.cobmDetailList));
        $state.go('main.investors.cobmStatus',{investorId:vm.investorId});*/
        if(localStorage.getItem('cobmDetailList')){
          localStorage.removeItem('cobmDetailList');
        }
        vm.cobmDetailList = null;
        UtilService.errorHandler(err);
      } //10814494
      DistributorGenericService.get({controller:'cobm',child1:'status',child2: vm.selectedFolio.folioNo}).$promise.then(success,error);
    }

    function redirectToChangeBank() {
      localStorage.setItem('folioId',vm.selectedFolio.folioNo);
      localStorage.setItem('bankDetails',angular.toJson(vm.folioDetailsData.bankDetails));
      $state.go('main.investors.changeBank',{investorId:vm.investorId});
    }

    function validateInvestor(transactionType, portfolioDetails) {
      LoaderService.showLoader();
      var data = {
        investorInfo: vm.investorsProfileData,
        portfolioDetails: portfolioDetails,
        from: 'investor-portfolio'
      };
      StoreInvestorModel.setInvestorDetail(data);
      var payload = {"investorUUID": vm.investorsProfileData.investorId};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var investorInfo = resp.data;
          vm.folioLists.find(function (el) {
             if(el.folioNumber == portfolioDetails.folioNumber) {
               vm.isActive = el.activeFlag;
             }
          })

          if (false && !resp.data.dob) { // dob check made disabled

            var success = function () {
              if (transactionType !== 'Redeem' && transactionType !== 'SWP') {
                vm.callPanService(investorInfo, vm.investorsProfileData.investorId, transactionType, portfolioDetails);
              } else {
                switch (transactionType) {
                  case 'SWP' :
                    $state.go('main.transactions.initiate.swp', {
                      uuid: vm.investorsProfileData.investorId,
                      folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                      schemeCode: portfolioDetails.schemeCode
                    });
                    break;
                  case 'Redeem' :
                    $state.go('main.transactions.initiate.redeem', {
                      uuid: vm.investorsProfileData.investorId,
                      folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                      schemeCode: portfolioDetails.schemeCode
                    });
                    break;
                  case 'Change Dividend' :
                  case 'Change Dividend Option' :
                    $state.go('main.transactions.initiate.changedividend', {
                      uuid: vm.investorsProfileData.investorId,
                      folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                      schemeCode: portfolioDetails.schemeCode
                    });
                    break;
                }
              }

            }, error = function () {

            };

            ModalService.updateDBInvestorModal({
              transactionType: transactionType,
              isUpdateInfo: true,
              uuid: vm.investorsProfileData.investorId
            }, success, error);
          }else{
            if (transactionType !== 'Redeem' && transactionType !== 'SWP' && transactionType !== 'Change Dividend Option') {
              vm.callPanService(investorInfo, vm.investorsProfileData.investorId, transactionType, portfolioDetails);
            } else {
              switch (transactionType) {
                case 'SWP' :
                  $state.go('main.transactions.initiate.swp', {
                    uuid: vm.investorsProfileData.investorId,
                    folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                    schemeCode: portfolioDetails.schemeCode
                  });
                  break;
                case 'Redeem' :
                  $state.go('main.transactions.initiate.redeem', {
                    uuid: vm.investorsProfileData.investorId,
                    folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                    schemeCode: portfolioDetails.schemeCode
                  });
                  break;
                case 'Change Dividend' :
                case 'Change Dividend Option' :
                  $state.go('main.transactions.initiate.changedividend', {
                    uuid: vm.investorsProfileData.investorId,
                    folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                    schemeCode: portfolioDetails.schemeCode
                  });
                  break;
              }
            }

          }


        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message || "Investor's sole applicant details not found");
          }
        }
      },
        error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    vm.callPanService = function (investorInfo, investorId, transactionType, portfolioDetails) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

          var taxIdentifierInfo = resp.data;
          if (investorInfo.minor && !investorInfo.gpanValid) {
            MessageService.error("Guardian's PAN is not verified for selected investor");
          } else if (!investorInfo.minor && !taxIdentifierInfo.verify) {
            MessageService.error("KYC verification is pending for selected investor");
          } else {
            switch (transactionType) {
              case 'SIP or Purchase' :
                $state.go('main.transactions.initiate.sip', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'Switch' :
                $state.go('main.transactions.initiate.switch', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'STP' :
                $state.go('main.transactions.initiate.stp', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'DTP' :
                $state.go('main.transactions.initiate.dtp', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'FLEXSTP' :
                $state.go('main.transactions.initiate.flexstp', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'SMART SWAP':
                $state.go('main.transactions.initiate.smartswap', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
              case 'Flex SIP':
                $state.go('main.transactions.initiate.flexsip', {
                  uuid: investorId,
                  folioNumber: vm.isActive ? portfolioDetails.folioNumber : '',
                  schemeCode: portfolioDetails.schemeCode
                });
                break;
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err && err.message || "Something going wrong,Please try after some time.");
        //UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'pan',
        child1: 'verify'
      }, {
        pan: investorInfo.panNumber
      }).$promise.then(success, error);
    };

    function featchPortfolioData() {
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
      }

      LoaderService.showLoader();
      vm.isLoading = true;
      var investorsPortfolioPayload = {
        appType: 'W',
        investorUUID: vm.investorId,
        searchText: vm.searchText,
        schemeTypes: vm.selectedSchemeType.map(function (ele) {
          return ele.toUpperCase();
        }),
        arnCode: identifierData.arnCode,
        pageIndex: vm.currentPageInvestorsPortfolio - 1,
        pageLimit: vm.pageLimitInvestorsPortfolio
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.constantData = resp.data.portfolioCalculation;
            vm.purchaseValueCountUnit = UtilService.getUnitSting(vm.constantData.totalPurchaseValue);
            vm.currentValueCountUnit = UtilService.getUnitSting(vm.constantData.totalCurrentValue);

            vm.investorsPortfolioData = resp.data.portfolioDTOs;
            vm.investorsPortfolioData && vm.investorsPortfolioData.forEach(function (item) {
              item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
              item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
            });
            vm.totalInvestorsPortfolioData = resp.data.count;
            vm.isInvestorPagination = !!(vm.investorsPortfolioData && vm.investorsPortfolioData.length);
          }
          else {
            vm.constantData = null;
            vm.purchaseValueCountUnit = '';
            vm.currentValueCountUnit = '';

            vm.investorsPortfolioData = null;
            vm.isInvestorPagination = false;
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          vm.isInvestorPagination = false;
          UtilService.errorHandler(err);
        };

      InvestorsService.post({controller: 'portfolio', child1: 'detail'}, investorsPortfolioPayload).$promise.then(success, error);
    }

    function folioList() {
      vm.folioListData = [];
      var payload = {
        "investorUUID": vm.investorId
      };
      var success = function (resp) {
          if (resp.status && resp.data) {
            var folio = [];
            for (var i in resp.data.folioMap) {
              var obj = {};
              obj.key = i;
              obj.folioNo = resp.data.folioMap[i];
              folio.push(obj);
            }
            vm.folioListData = folio;
          } else {
            vm.folioListData = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.folioListData = null;
          UtilService.errorHandler(err);
        };
      InvestorsService.post({controller: 'folios'}, payload).$promise.then(success, error);
    }

    function fetchSchemeType() {
      var success = function (resp) {
          if (resp.status && resp.data && resp.data.schemeType) {
            for (var i = 0; i < resp.data.schemeType.length; i++) {
              var obj = {
                key: resp.data.schemeType[i].charAt(0).toUpperCase() + resp.data.schemeType[i].substr(1),
                value: resp.data.schemeType[i]
              };
              vm.SCHEMETYPES.push(obj);
            }
            vm.selectedSchemeType[0] = vm.SCHEMETYPES[0].value || 'ALL';
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
          vm.selectedSchemeType[0] =vm.SCHEMETYPES[0]?vm.SCHEMETYPES[0].value : 'ALL';
        };
      SchemeService.post({
        controller: 'schemeType'
      }, null).$promise.then(success, error);
    }

    function showTransactionList() {
      LoaderService.showLoader();
      vm.isLoading = true;
      var payload = {
          "flowType": "ALL",
          "fromDate": vm.dateFilter.startDate ? moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '',
          "toDate": vm.dateFilter.endDate ? moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '',
          "pageIndex": vm.currentPageTransactionListData - 1,
          "pageLimit": vm.pageLimitTransactionListData,
          "searchText": vm.sortOrder.searchText,
          "sourceType": vm.selectedMode,
          "transactionNature": vm.selectedNature,
          "transactionStatus": angular.isArray(vm.selectedStatus) && angular.isDefined(vm.selectedStatus[0])? [vm.selectedStatus[0].toUpperCase()] : ['PROCESSED'],
          "transactionType": vm.selectedType,
          "sortValue": vm.sortOrder.sortValue,
          "sortKey": vm.sortOrder.sortKey
        },
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.transactionListData = resp.data.transactionList;

            vm.transactionListData && vm.transactionListData.forEach(function (item) {
              item.amountUnit = UtilService.getUnitSting(item.amount);
            });

            vm.totalTransactionListData = resp.data.totalTransactions;
            vm.isInvestorTransactionPagination = !!(vm.transactionListData && vm.transactionListData.length);
          } else {
            // MessageService.error(resp.message);
            vm.totalTransactionListData = 0;
            vm.transactionListData = null;
            vm.isInvestorTransactionPagination = false;
          }
          vm.isLoading = false;
          // vm.sortOrder.searchText = '';
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          vm.isInvestorTransactionPagination = false;
          UtilService.errorHandler(err);
        };
      payload.pageIndex = vm.currentPageTransactionListData - 1;
      payload.pageLimit = vm.pageLimitTransactionListData;

      TransactionService.post({
        VERSION:'v3',
        investorId: vm.investorId,
        child1: 'investor',
        controller: 'search'
      }, payload).$promise.then(success, error);
    }

    function fetchInvestorData() {
      switch (vm.flowType) {
        case 'INFO':
          folioList();
          break;
        case 'PORTFOLIO':
          featchPortfolioData();
          if (vm.initial) {
            fetchSchemeType();
          }
          break;
        case 'TRANSACTIONS':
          vm.changeSelectedYear();
          break;
        case 'FINANCIALGOLAS':

          break;

      }
    }

    function sendReport(action, details) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            MessageService.success(resp.data);
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
      }
      var data = {
        Folio_no: details.folioNumber, ARNCode: identifierData.arnCode,
        Email: vm.investorsProfileData.addtionalDetails.email,
        investorName: vm.investorsProfileData.name
      };
      LoaderService.showLoader();
      ReportsService.post({
        controller: action.key
      }, data).$promise.then(success, error);

    }

    function wishSomeone(bday) {
      var success = function (res) {
        if (res.status) {
          MessageService.success(res.message);
        } else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      DashboardService.post({
        controller: 'investor',
        child1: 'birthDayWish'
      }, {'investorId': bday.investorId}).$promise.then(success, error);

    }

    function sendReminder(listData) {
      var success = function (resp) {
          if (resp && resp.status) {
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
          }
          else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'remind'}, {
        transactionId: listData.transactionsId,
        type: listData.investmentType.toUpperCase()
      }).$promise.then(success, error);
    }

    function getInvestorId(val) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            initiateTransactionType(resp.data, val.investmentType, val.transactionsId);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'investor',
        'folioNumber': val.folioNumber
      }, {}).$promise.then(success, error);
    }

    function initiateTransactionType(investorId, transactionType, transactionId) {
      investorId = investorId.investorId ? investorId.investorId : investorId;
      switch (transactionType) {
        case 'SWITCH':
          $state.go('main.transactions.initiate.switch', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'SIP':
        case 'PURCHASE':
          $state.go('main.transactions.initiate.sip', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'STP':
          $state.go('main.transactions.initiate.stp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'SWP':
          $state.go('main.transactions.initiate.swp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'REDEMPTION':
          $state.go('main.transactions.initiate.redeem', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'DTP':
          $state.go('main.transactions.initiate.dtp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
        case 'FLEXSTP' :
          $state.go('main.transactions.initiate.flexstp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId
          });
          break;
      }
    }

    function deleteBank(){
      getInvestorInfo(function(resp) {
        if (resp === true) {
          var banktoDelete = [vm.folioDetailsData.bankDetails[vm.currentBankIndx]];
          var modalPayload = {
            folioNumber: vm.selectedFolio.folioNo,
            bankDetails: banktoDelete,
            panNumber: vm.investorsProfileData.PAN,
            investorFullName: vm.investorsProfileData.name,
            tokenData: vm.tokenData
          };
          var success = function (resp) {
            deleteBankSuccess(modalPayload,resp);
          }, error = function () {};
          ModalService.deleteBankModal({modalPayload : modalPayload, requestType:'delete'}, success, error);
        }
      });
    }

    function deleteBankSuccess(modalPayload, response){
      ModalService.deleteBankSuccessModal({modalPayload : modalPayload,deleteMessage:response, requestType:'delete'});
    }

    function changeDefaultBank(){
      getInvestorInfo(function(resp) {
        if (resp === true) {
          var successHandler=function(resp) {
            LoaderService.hideLoader();
            var banktoMakeDefault = [vm.folioDetailsData.bankDetails[vm.currentBankIndx]];
            var modalPayload = {
              folioNumber: vm.selectedFolio.folioNo,
              bankDetails: banktoMakeDefault,
              investorFullName: vm.investorsProfileData.name,
            };
            ModalService.changeDefaultBankModal({modalPayload: modalPayload, requestType: 'modify'});
          };
          var errorHandler=function(resp) {
            LoaderService.hideLoader();
            return;
          };
          LoaderService.showLoader();
          panAdharLinkingService.checkPanAdharStatus(vm.investorsProfileData.PAN, '', vm.brokerCode).then(successHandler).catch(errorHandler);
        }
      });
    }

    function payoutSwitch() {
      vm.changePayoutSwitch = !vm.changePayoutSwitch;
    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {};

      InvestorsService.get({child1: 'folio', child2: 'payout-mechanism', child3:'cobm'}).$promise.then(success, error);
    }

    function UpdatePayoutMethod() {
      payoutSwitch();
      updatePayOut();
    }

    function updatePayOut() {
      var payload = {
        bankAccountNumber: vm.bankDetails.accountNumber,
        folioNumber: vm.selectedFolio.folioNo,
        payMech: vm.newPayoutMethod
      };
      var success = function (res) {
        if (res.status) {
          // ModalService.addBankModal(vm.payload);
          var modalSuccess = function(){
            //$state.go('main.profile.folioDetails');
            // vm.folioDetails();
            // vm.basicDetails();
          };
          ModalService.forgotPasswordDoneModal({message:res.data.message},modalSuccess);
        }
        else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      InvestorsService.post({
        controller: 'folio',
        child1: 'bank',
        transactionType: 'update',
        child2: 'pay-mech'
      }, payload).$promise.then(success, error);
    }

    function redirectIFSCUpdate() {
      localStorage.setItem('updateIFSC',$window.JSON.stringify(vm.bankDetails));
      $state.go('main.investors.updateIFSC',{folioNumber:vm.selectedFolio.folioNo});
    }


    vm.init = function (val) {
      vm.brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      fetchFolioList(vm.investorsProfileData.investorId);
      vm.coperateFlag = vm.investorsProfileData.corporateFlag;
      vm.initial = val;
      vm.investorsData = {};

      var successHandler = function(resp) {
        vm.dynamicCancelEmandate = resp.popupDTO.popupDTOMap;
      }

      UtilService.fetchDynamicData("CANCEL_EMANDATE_SCREEN").then(successHandler).catch(function(resp) {
        MessageService.error(resp)
      });

      switch ($state.current.name) {
        case 'main.investors.profile.transactions':
          //vm.active = {1: true};
          vm.flowType = AppConstants.INVESTOR_PROFILE_TYPES[1];
          fetchInvestorData();
          fetchEmailMobile(vm.investorsProfileData.PAN,vm.investorsProfileData.dateOfBirth);
          break;
        case 'main.investors.profile.basicinfo':
          //vm.active = {2: true};
          vm.flowType = AppConstants.INVESTOR_PROFILE_TYPES[2];
          fetchInvestorData();
          fetchEmailMobile(vm.investorsProfileData.PAN,vm.investorsProfileData.dateOfBirth);
          getSubscribedKey();
          break;
        case 'main.investors.profile.financialgoals':
          //vm.active = {3: true};
          vm.flowType = AppConstants.INVESTOR_PROFILE_TYPES[3];
          fetchInvestorData();
          fetchEmailMobile(vm.investorsProfileData.PAN,vm.investorsProfileData.dateOfBirth);
          break;
        case 'agent.home.investors.basicinfo':
          vm.flowType = AppConstants.INVESTOR_PROFILE_TYPES[2];
          fetchInvestorData();
           fetchEmailMobile(vm.investorsProfileData.PAN,vm.investorsProfileData.dateOfBirth);
          break;
        default :
          //vm.active = {0: true};
          vm.flowType = AppConstants.INVESTOR_PROFILE_TYPES[0];
          fetchInvestorData();
          fetchEmailMobile(vm.investorsProfileData.PAN,vm.investorsProfileData.dateOfBirth);
          break;
      }
    };
    function changeSelectedYear () {
      vm.isReset = false;
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {

            vm.dateFilter = {
              'startDate' : $window.moment(resp.data.customDate && resp.data.customDate.fromDate, "DD-MMM-YYYY"),
              'endDate' : $window.moment(resp.data.customDate && resp.data.customDate.toDate, "DD-MMM-YYYY")
            }
            $window.setTimeout(function(){
              vm.isReset = true;
            },100);
            showTransactionList();
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.transactionRecentList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      TransactionService.get({VERSION:'v3',controller: 'date'}).$promise.then(success, error);
    }

    vm.folioDetails = function (folio, index) {
      vm.canEdit = false;
      vm.folioIndex = index;
      LoaderService.showLoader();
      vm.isLoading = true;
      vm.folioDetailsData = {};
      vm.selectedFolio=folio;
      var payload = {
        "distributorInvestorUuid": folio.key
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          if (resp.data) {
            vm.folioDetailsData = resp.data;
            vm.folioDetailsData.cobmEnabled = resp.data.cobmEnabled;
            vm.showJointHolderDetails(vm.folioDetailsData.jointHolders ? vm.folioDetailsData.jointHolders[0] : '', 0);
            vm.showNomineeDetails(vm.folioDetailsData.nominees ? vm.folioDetailsData.nominees[0] : '', 0);
            vm.showBankDetails(vm.folioDetailsData.bankDetails ? vm.folioDetailsData.bankDetails[0] : '', 0);
            vm.showCotmBankDetails(vm.folioDetailsData.camsOTM ? vm.folioDetailsData.camsOTM[0] : '', 0);
            vm.showOtmBankDetails(vm.folioDetailsData.otmList ? vm.folioDetailsData.otmList[0] : '', 0);
            // vm.getPayoutMechanism();
            $window.sessionStorage.setItem('folioData', JSON.stringify(vm.folioDetailsData));
            vm.cancelMandateUrl = vm.folioDetailsData.cancelMandateUrl;
            vm.uploadChequeLeafEnabled = vm.folioDetailsData.uploadChequeLeafEnabled;
            if (vm.folioDetailsData.folioContactDetailsDTO) {
              vm.isContactUpdateAllowed = vm.folioDetailsData.folioContactDetailsDTO.isContactUpdateAllowed;

              if (!vm.isContactUpdateAllowed && vm.folioDetailsData.folioContactDetailsDTO.contactUpdateErrorMessage) {
                vm.updateContactRestrictMessage = vm.folioDetailsData.folioContactDetailsDTO.contactUpdateErrorMessage;
              }
            }
          }
          else {
            vm.folioDetailsData = null;
            if(resp && resp.message){
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          UtilService.errorHandler(err);
        };
      InvestorsService.post({controller: 'folios', child1: 'detail'}, payload).$promise.then(success, error);
    };


    vm.currentBankIndx = 0;
    vm.showBankDetails = function (banks, index) {
      vm.currentBankIndx = index;
      vm.bankDetails = banks;
    };

    vm.currentCotmBankIndx = 0;
    vm.showCotmBankDetails = function (banks, index) {
      vm.currentCotmBankIndx = index;
      vm.cotmBankDetails = banks;
    };

    vm.currentOtmBankIndx = 0;
    vm.showOtmBankDetails = function (banks, index) {
      vm.currentOtmBankIndx = index;
      vm.otmBankDetails = banks;
    };

    vm.showJointHolderDetails = function (jointHolder, index) {
      vm.jointholderIndex = index;
      vm.jointHolderDetails = jointHolder;
    };

    vm.showNomineeDetails = function (nominee, index) {
      vm.nomineeIndex = index;
      vm.nomineeDetails = nominee;
    };

    vm.natureChanged = function () {
      showTransactionList();
    };

    /*vm.modeChanged = function () {
     showTransactionList();
     };*/


    /*Multiselect code start*/
    vm.transactionModel = [];
    vm.modeModel = [];
    vm.statusModel = [];
    vm.schemeTypeModel = [];
    vm.schemeEvents = {
      onSelectionChanged: function () {
        var trType = vm.schemeTypeModel.map(function (ele) {
          return ele.id;
        });
        vm.selectedSchemeType = trType.length > 0 ? ((trType.length == vm.SCHEMETYPES.length) ? ['ALL'] : trType)  : ['ALL'];
        featchPortfolioData();
      }
    };
    vm.modeEvents = {
      onSelectionChanged: function () {
        var trType = vm.modeModel.map(function (ele) {
          return ele.id;
        });
        vm.selectedMode = trType.length > 0 ? trType : ['ALL'];
        showTransactionList();
      }
    };

      vm.onSelectionStatus= function (status) {
        vm.selectedStatus = status ? [status] : ['PROCESSED'];
        showTransactionList();
      }
    vm.transactionEvents = {
      onSelectionChanged: function () {
        var trType = vm.transactionModel.map(function (ele) {
          return ele.id;
        });
        vm.selectedType = trType.length > 0 ? trType : ['ALL'];
        showTransactionList();
      }
    };
    /*Multiselect code end*/

    vm.typeChanged = function () {
      showTransactionList();
    };

    vm.statusChanged = function () {
      vm.selectedNature = vm.NATURE[0].value;
      // vm.selectedType[0] = vm.TYPE[0].value || 'ALL';
      // vm.selectedMode = vm.MODE[0].value;
      vm.selectedSchemeType[0] = vm.SCHEMETYPES[0].value || 'ALL';
      vm.dateFilter = {startDate: null, endDate: null};
      showTransactionList();
    };

    /*    vm.statusSchemeType = function () {
     featchPortfolioData();
     };*/

    vm.filterByHeader = function () {
      // vm.sortOrder.searchText = '';
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      showTransactionList();
    };

    vm.searchByText = function () {

      if (vm.isSearching) {
        return;
      }
      else if (vm.sortOrder.searchText.length > 3 || vm.sortOrder.searchText =='') {
        vm.sortOrder.sortKey = "transactionDateTime";
        vm.sortOrder.sortValue = "DESC";
        vm.selectedMode[0] = "ALL";
        vm.selectedNature = "ALL";
        showTransactionList();
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.showSummary = function (transactiondata) {
      var payload = {
        folioNumber: transactiondata.folioNumber,
        uuid: transactiondata.transactionsId
      };
      ModalService.transactionSummaryModal({payload: payload});
    };

    vm.isBirthday = function (val) {
      var isbirthday = false;
      if (val) {
        var arr = val.split(' ')[0].split('-');
        var date = new Date(arr[2], vm.monthArr[arr[1]], arr[0]);
        var today = new Date();
        isbirthday = (today.getMonth() == date.getMonth()) ? (today.getDate() == date.getDate()) : false;
      }
      return isbirthday;
    };

    vm.filterByDate = function (dateFilter) {
      if (dateFilter.startDate && dateFilter.endDate) {
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          showTransactionList();
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        showTransactionList();
      }
    };

    angular.element(".add-detail").click(function () {
      if (angular.element(".view-details .collapse").hasClass('in')) {
        angular.element(".view-details i.collapse-icon").addClass('expand-icon');
        angular.element(".view-details i").removeClass('collapse-icon');
        angular.element(".view-details .add-detail").html('View Additional Details');
        angular.element(".view-details .add-detail").css('padding-left', '35px');
      } else {
        angular.element(".view-details i.expand-icon").removeClass('expand-icon');
        angular.element(".view-details i").addClass('collapse-icon');
        angular.element(".view-details .add-detail").html('Collapse Additional Details');
        angular.element(".view-details .add-detail").css('padding-left', '15px');
      }
    });

    vm.createNewFolio = function() {
      if (UtilService.getFolioDataValid().folioDataInvalid) {
        ModalService.genericModal({
          text: UtilService.getFolioDataValid().folioDataMessage
        });
      } else {
        var success = function (resp) {
            LoaderService.hideLoader('.popup');
            if (resp.status && resp.data && resp.data.verify) {
              InvestorModel.resetInvestorModel();
              var model = InvestorModel.getNewInvestorModel();
              model.folioCreationRequestCO.soleApplicantDetail.name = vm.investorsProfileData.name;
              model.folioCreationRequestCO.soleApplicantDetail.dob = vm.investorsProfileData.dateOfBirth;
              model.folioCreationRequestCO.soleApplicantDetail.panNumber = vm.investorsProfileData.PAN;
              model.folioCreationRequestCO.soleApplicantDetail.mobileNo = vm.investorsProfileData.mobile;
              model.folioCreationRequestCO.soleApplicantDetail.email = vm.investorsProfileData.email;
              model.folioCreationRequestCO.showNomineeUpdate = vm.investorsProfileData.sebiNomineeRegulatory01650Active;
              model.folioCreationRequestCO.nomineeLimit = vm.investorsProfileData.nomineeLimit;
              InvestorModel.setInvestorModel(model);
              delete $window.sessionStorage.investorForm;
              $window.sessionStorage.investorForm = angular.toJson(model);
              InvestorModel.setFolioCreationFromProfileAndToDo(true);
              InvestorModel.setTab({
                "tab1": false,
                "tab2": false,
                "tab3": false,
                "tab4": false,
                "tabJointHolderAddable": false,
                "tabGuardianDetailShow": false
              });
              // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
              $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
            } else {
              var message = resp.data && !resp.data.verify ? 'Either KYC verification is pending or name is missing.' : resp.message;
              if (resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                });
              } else {
                MessageService.error(message);
              }
            }
          },
          error = function () {
            LoaderService.hideLoader('.popup');
            vm.wrongMsg = AppConstants.ToastrMessage.FAILED;
          };
        vm.payload = {
          //dob: moment(vm.investorsProfileData.dateOfBirth, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString(),
          pan: vm.investorsProfileData.PAN
        };

        LoaderService.showLoader('.popup');

        var successHandler = function (resp) {
          InvestorsService.post({
            controller: 'pan',
            child1: 'verify'
          }, vm.payload).$promise.then(success, error);
        }

        var errorHandler = function (resp) {

        }

        panAdharLinkingService.checkPanAdharStatus(vm.investorsProfileData.PAN, '', vm.brokerCode).then(successHandler).catch(errorHandler);
      }
    };

    vm.sendStatement = function () {
      var investorId = $stateParams.investorId;
      $state.go('main.investors.statements',{investorId:investorId});

      // ModalService.investorStatementModal({data: vm});
    };

    vm.searchList = function () {
      if (!vm.isSearching&&(vm.searchText.length > 3 || vm.searchText == '')) {
        vm.isSearching = true;
        featchPortfolioData();
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.initiateTransaction = function (data) {
      switch (data.action) {
        case "REMIND":
          sendReminder(data);
          break;
        case "REINITIATE":
          getInvestorId(data);
          break;
      }
    };

   vm.viewRudDetails=function (investments,index) {
     if(vm.rudAmountList[index]){
       return;
     }
     else{
       vm.rudAmountList[index]={};
     }
     var success = function (resp) {
         LoaderService.hideLoader();
        if(resp.data && resp.status){
          vm.rudAmountList[index].amount=resp.data.unClaimedDividends[0].amount;
        }
        else{
          vm.rudAmountList[index]= null;
          if(resp.popupEnabled){
            ModalService.genericModal({
              text:resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
       },
       error = function () {
         LoaderService.hideLoader();
       };
     LoaderService.showLoader();
     var payload={
        folioNumber:vm.selectedFolio.folioNo,
        schemeCode:investments.schemeCode,
        panNumber: vm.investorsProfileData.PAN
     };
     InvestorsService.post({controller: 'unclaimed', child1: 'info'}, payload).$promise.then(success, error);
   };

   /*------------------------------------- E-mandate section starts from here ------------------------------*/
    /**
     * Function responsible to redirect to emandate state
     * Passing details like, folio number, email id, mobileNo, investorName
     */
    vm.redirectToEmandateRegister = function() {
      if (!vm.folioDetailsData.email && !vm.folioDetailsData.mobileNumber) {
        ModalService.genericModal({
          text: vm.VALIDATE_DATA.MANDATE_REQUIRED
        }, function() {}, function() {});
      } else if (!vm.folioDetailsData.email) {
        ModalService.genericModal({
          text: vm.VALIDATE_DATA.MANDATE_EMAIL_REQUIRED
        }, function() {}, function() {});
      } else if (!vm.folioDetailsData.mobileNumber) {
        ModalService.genericModal({
          text: vm.VALIDATE_DATA.MANDATE_MOBILE_REQUIRED
        }, function() {}, function() {});
      } else {
        var investorDetails = {
          folioNo: vm.folioDetailsData.folioNumber,
          emailId: vm.folioDetailsData.email,
          mobileNo: vm.folioDetailsData.mobileNumber,
          investorName: vm.investorsProfileData.name,
          panNumber: vm.investorsProfileData.PAN,
          investorId: vm.investorId
        };
        $window.sessionStorage.setItem("investorDetails", angular.toJson(investorDetails));
        $state.go("main.investors.emandate", {
          params: {
            investorDetails: investorDetails
          }
        });
      }
    };

    /**
     * Function responsible to show cancel emandate modal,
     * provide physical form link to download.
     */
    vm.cancelMandate = function() {
      getInvestorInfo(function(resp) {
        if (resp === true && vm.cancelMandateUrl) {
          if(vm.dynamicCancelEmandate.Note_Cancel_Emandate) {
            ModalService.cancelMandateModal({
              dynamicData : vm.dynamicCancelEmandate,
              cancelMandateUrl: vm.cancelMandateUrl
            }, function(){}, function(){});
          }
        }
      });
    };

    vm.updateSideBar = function (transactionType) {
      if (transactionType) {
        $timeout(function () {
          _headerSearch(transactionType);
        }, 50);
      }
      $rootScope.$emit('UpdateSideBar');
    };

    function _headerSearch(transactionType) {
      resetTransactionInitiateModel();
      if (vm.investorId) {
        switch (transactionType) {
          case 'SIP or Purchase':
            transactionType = 'SIP';
            break;
          case 'Systematic Withdrawal Plan':
            transactionType = 'SWP';
            break;
          case 'Systematic Transfer Plan':
            transactionType = 'STP';
            break;
          case 'Redemption':
            transactionType = 'Redeem';
            break;
          case 'Switch':
            transactionType = 'Switch';
            break;
          case 'DTP':
            transactionType = 'DTP';
            break;
          case 'SWINGSTP':
            transactionType = 'SWINGSTP';
            break;
          case 'ChangeDividend':
            transactionType = 'ChangeDividend';
            break;
          case 'ROLLOVER':
            transactionType = 'rollover';
            break;
          case 'SMART_SWAP':
            transactionType = 'smartswap';
            break;
          case 'Instant_Redemption':
            transactionType = 'instantRedeem';
            break;

          // case 'FLEXSTP':
          //   transactionType = 'FLEXSTP';
          //   break;
        }
        var _state = 'main.transactions.initiate.' + transactionType.toLowerCase();
        $state.go(_state, {
          uuid: vm.investorId,
          schemeCode: '',
          folioNumber: '',
          transactionType: '',
          transactionId: '',
          amount: ''
        });
      }
    }

    function resetTransactionInitiateModel() {
      TransactionInitiateModel.setPurchasePayload(null);
      TransactionInitiateModel.setSipPayload(null);
      TransactionInitiateModel.setInvestorPayload(null);
    }

    function fetchFolioList(id) {
       var success = function (resp) {
         if (resp.status && resp.data) {
            vm.folioLists = resp.data.folioList || [];
         }
       }, error = function (err) {
         UtilService.errorHandler(err);
       };
      InvestorsService.post({controller: 'folioList'}, {investorUUID: id}).$promise.then(success, error);
     }

     function fetchEmailMobile(panNumber,Dob) {
       var success = function (resp) {
        if (resp.status && resp.data) {
          if (resp.data.folioDataInvalid) {
            UtilService.setFolioDataValid(resp.data);
          } else {
            vm.investorsProfileData.mobile = resp.data.mobileNumber ? resp.data.mobileNumber : "";
            vm.investorsProfileData.email = resp.data.email ? resp.data.email : "";
            vm.investorsProfileData.sebiNomineeRegulatory01650Active = resp.data.sebiNomineeRegulatory01650Active;
            vm.investorsProfileData.nomineeLimit = resp.data.nomineeLimit;
            UtilService.setFolioDataValid(resp.data);
          }
        }

        if(!resp.data && resp.message) {
          MessageService.error(resp.message)
        }

       },
       error = function (err) {
         MessageService.error("something went wrong")
       };
       vm.payload = {
         pan: panNumber,
         dob: Dob,
         transactionEnabled : true
       };
       InvestorsService.post({
         child1: 'pan',
         child2: 'details'
       }, vm.payload).$promise.then(success, error);
     }

    vm.addNominee = function() {
      getInvestorInfo(function(resp){
        if (resp === true) {
          var successHandlerForPanAadhaar = function(){
            var manageRegulatoryDetails = {
          nomineeLimit: vm.folioDetailsData.nomineeLimit,
          showNomineeUpdate: vm.folioDetailsData.sebiNomineeRegulatory01650Active
        }
        ModalService.addNominee({investorPan : vm.investorsProfileData.PAN, isNomineeData : vm.folioDetailsData.nominees && vm.folioDetailsData.nominees.length > 0 ? true : false, investorId:vm.investorId, folioNo : vm.selectedFolio.folioNo, manageRegulatoryDetails: manageRegulatoryDetails}, function(){}, function(){});
          }, errorHandlerForPanAadhaar = function(){
            return;
          };
          panAdharLinkingService.checkPanAdharStatus(vm.investorsProfileData.PAN, vm.selectedFolio.folio, vm.brokerCode).then(successHandlerForPanAadhaar).catch(errorHandlerForPanAadhaar);
        }
      });
    };

    vm.offlineNomineeForm = function() {
      var successHandlerForPanAadhar = function(){
        ModalService.offlineNomineeFormModal({
          message: AppConstants.ToastrMessage.VALIDATE_DATA.OFFLINE_NOMINEE_FORM
        });
      }, errorHandlerForPanAadhar = function(){
        return;
      };
      panAdharLinkingService.checkPanAdharStatus(vm.investorsProfileData.PAN, vm.selectedFolio.folio, vm.brokerCode).then(successHandlerForPanAadhar).catch(errorHandlerForPanAadhar);
    };
    //
    // function cancelNominationSubmission() {
    //   LoaderService.showLoader();
    //   var success = function(response) {
    //     LoaderService.hideLoader();
    //     if (response.status) {
    //       $state.reload();
    //     } else {
    //       MessageService.error(response.message);
    //     }
    //   }, failure = function(response) {
    //     LoaderService.hideLoader();
    //     MessageService.error(response.message);
    //   };
    //   InvestorService.get({
    //     'child1': 'profile',
    //     'child2': 'cancel',
    //     'child3': 'nomination',
    //     'child4': vm.folioNo
    //   }).$promise.then(success, failure);
    // }

    vm.cancelNominee = function() {
      getInvestorInfo(function (resp) {
        if (resp === true) {
          var success = function(resp) {
            if (resp == "cancel") {
              // cancelNominationSubmission();
            }
          };
          ModalService.cancelNominee({'folio':vm.selectedFolio.folioNo}, success);
        }
      });
    };
     function toggleWhatsapp() {
      var identifier=AuthService.getToken();
        var success = function (resp) {
          if(resp && resp.status) {
            if (vm.subscribedToggleFlag) {
              LoaderService.hideLoader();
              MessageService.success(resp.data.message);
            } else {
              LoaderService.hideLoader();
              MessageService.success(resp.data.message);
            }
          }else{
            MessageService.error(resp.message);
            LoaderService.hideLoader();
          }
        }, error = function (resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.data.message);
        };
        if(vm.subscribedToggleFlag==true){
          vm.subscribed = false;
        }else{
         vm.subscribed = true;
       }
        var payload={
          "panNumber": vm.investorsProfileData.PAN,
          "whatsAppNotification":vm.subscribed
        }
       LoaderService.showLoader();
       WhatsappTransactionService.post({
          child1: 'whatsapp',
          child2: 'subscribe'
        }, payload).$promise.then(success, error);
    }

    function getSubscribedKey() {
      var success = function (resp) {
        if(resp.status && resp){
          vm.subscribed = resp.data;
          vm.subscribedToggleFlag = vm.subscribed.whatsAppNotification;
          vm.isDisabled = vm.subscribed.whatsAppNotificationButtonDisabled;
          LoaderService.hideLoader();
        }else{
          MessageService.error(resp.message);
          LoaderService.hideLoader();
        }
      }, error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.data.message);
      };
      LoaderService.showLoader();
      WhatsappTransactionService.get({
        child1: 'whatsapp',
        child2: 'investor',
        child3: 'whatsAppNotification',
        child4: vm.investorsProfileData.PAN
      }, null).$promise.then(success, error);
    }

    function redirectToOptOutNomination() {
      getInvestorInfo(function (resp) {
        if (resp === true) {
          var successHandlerForPanAadhaar = function(){
            $state.go('main.investors.nomineeOptout',{investorId:vm.investorId, folioNo : vm.selectedFolio.folioNo})
          }, errorHandlerForPanAadhaar = function(){
            return;
          };
          panAdharLinkingService.checkPanAdharStatus(vm.investorsProfileData.PAN, vm.selectedFolio.folio, vm.brokerCode).then(successHandlerForPanAadhaar).catch(errorHandlerForPanAadhaar);
        }
      });
    }

    function getInvestorInfo(cb) {
      LoaderService.showLoader();
      var payload = {
        "investorUUID": vm.investorsProfileData.investorId
      };
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          cb(true);
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            });
          } else {
            MessageService.error(resp.message || "Investor's sole applicant details not found");
          }
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsListController', InvestorsListController);

  /** @ngInject */
  function InvestorsListController($scope, $timeout, $state, SchemeService,MessageService, UtilService, LoaderService, AppConstants, InvestorModel) {
    var vm = this;
    vm.fetchSchemes = fetchSchemes;
    vm.isSearching = false;
    vm.analysisType = $state.params.analysisType ? $state.params.analysisType : '';
    vm.searchText = '';
    if(vm.analysisType){
      vm.tabs = [
        {key: 'Individual', active: true, action: "main.investors.list.individual"},
        {key: 'Non-Individual', active: false, action: "main.investors.list.non-individual"}
      ];
    }else{
      vm.tabs = [
        {key: 'Individual', active: true, action: "main.investors.list.individual"},
        {key: 'Non-Individual', active: false, action: "main.investors.list.non-individual"},
        {key: 'Pending', active: false, action: "main.investors.list.pending"}
      ];
    }

    vm.filterMultiSettings = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false
    };
    vm.filterMultiSettingsTypes = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , smartButtonTextProvider: function smartButtonTextProvider(selectionArray) {
        if(vm.filtersSelected.systematicFilter.categorySelected[0]=='ALL')
        {
          return "All"
        } else {
          return "Select Category"
        }
      }
    };

    vm.investorFilterMultiSettingsTypes = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , smartButtonTextProvider : function smartButtonTextProvider(selectionArray)
      {
        if(vm.selectionMadeInvestorType.investorTypeCategory[0]=='ALL')
        {
          return "All"
        } else {
          return "Select Category"
        }
      }
    };

    vm.currentHoldingFilterMultiSettingsTypes = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , smartButtonTextProvider : function smartButtonTextProvider(selectionArray)
      {
        if(vm.filtersSelected.currentHolding.categorySelected[0]=='ALL')
        {
          return "All"
        } else {
          return "Select Category"
        }
      }
    };

    vm.filterMultiSettingsGroup = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , enableSearch: true ,smartButtonTextProvider : function smartButtonTextProvider(selectionArray)
      {
        if(vm.filtersSelected.systematicFilter.groupSelected[0]=='ALL' && Object.keys(vm.filtersSelected.systematicFilter.group).length > 1)
        {
          return "All"
        } else {
          return "Select Scheme"
        }
      }
    };

    vm.investorFilterMultiSettingsGroup = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , enableSearch: true ,smartButtonTextProvider : function smartButtonTextProvider(selectionArray)
      {
        if( vm.filtersSelected.investorActivity.groupSelected[0]=='ALL' && Object.keys(vm.filtersSelected.investorActivity.group).length > 1 )
        {
          return "All"
        } else {
          return "Select Scheme"
        }
      }
    };

    vm.currentHoldingFilterMultiSettingsGroup = {
      displayProp: 'key', idProp: 'value', dynamicTitle: true, showCheckAll: false, showUncheckAll: false , enableSearch: true ,smartButtonTextProvider : function smartButtonTextProvider(selectionArray)
      {
        if( vm.filtersSelected.currentHolding.groupSelected[0]=='ALL' && Object.keys(vm.filtersSelected.currentHolding.group).length > 1)
        {
          return "All"
        } else {
          return "Select Scheme"
        }
      }
    };

    vm.schemeTranslationTexts = {buttonDefaultText: 'Select', dynamicButtonTextSuffix: ''};
    vm.categoryTranslationTexts = {buttonDefaultText: 'Select Category', dynamicButtonTextSuffix: ''}
    vm.groupTranslationTexts = {buttonDefaultText: 'Select Scheme', dynamicButtonTextSuffix: ''}
    vm.SCHEME_TYPE = null;
    vm.filterList = AppConstants.INVESTOR_LIST_FILTER.FILTER_LIST;
    vm.selectedFilter = vm.filterList[0].key;
    vm.investorFilter = AppConstants.INVESTOR_LIST_FILTER;
    vm.systematicOptionsError = false;
    vm.selectionMade = {
      eligibility: [],
      investorType: [],
      investorSubType: [],
      otmOption: [],
      currentHoldingState: [],
      currentHoldingScheme: [],
      currentHoldingOptions: [],
      systematicActiveState: [],
      systematicPlanType: [],
      systematicScheme: [],
      systematicOptions: [],
      investorActivityHave: [],
      investorActivityType: [],
      investorsActivityScheme: [],
      investorsActivityOptions: [],
      investorActivityDuration: []
    };

    vm.selectionMadeCurrentHolding = {
      currentHoldingCategory: [],
      currentHoldingGroup: []
    }

    vm.selectionMadeSystematic = {
      systematicCategory: [],
      systematicGroup: []
    }

    vm.selectionMadeInvestorType = {
      investorTypeCategory: [],
      investorTypeGroup: []
    }

    vm.filterSelectionList = {
      changeEvent: updateSelection,
      selectionKeys: Object.keys(vm.selectionMade)
    };

    vm.filterCurrentHolding = {
      changeEventSchemeType: updateSelectionCHscheme,
      selectionKeys: vm.selectionMadeCurrentHolding.currentHoldingCategory,
      selectionKeysGroup :  vm.selectionMadeCurrentHolding.currentHoldingGroup,
      changeEventGroupType : updateSelectionCHgroup
    };

    vm.filterSystematic = {
      changeEventSchemeType: updateSelectionSscheme,
      selectionKeys: vm.selectionMadeSystematic.systematicCategory,
      selectionKeysGroup :  vm.selectionMadeSystematic.systematicGroup,
      changeEventGroupType : updateSelectionSystematicgroup
    };

    vm.filterInvestorType = {
      changeEventSchemeType: updateSelectionITscheme,
      selectionKeys: vm.selectionMadeInvestorType.investorTypeCategory,
      selectionKeysGroup :  vm.selectionMadeInvestorType.investorTypeGroup,
      changeEventGroupType : updateSelectionITgroup
    };

    vm.selectedCategory = "ALL";
    vm.filtersSelected = {
      eligibility: "",
      otmOption: "",
      investorType: "",
      investorSubType: [],
      investorSelectedSubType: {
        CGF: false,
        Minor: false,
        Others: false
      },
      currentHolding: {
        holdingState: true,
        schemes: [],
        schemesSelected: [],
        category: [],
        categorySelected: [],
        group: [],
        groupSelected: [],
        options: [],
        option: {
          growth: true,
          payout: true,
          reInvest: true
        }
      },
      systematicFilter: {
        active: true,
        planTypes : [],
        planTypeSelected: [],
        schemes : [],
        schemesSelected: [],
        category: [],
        categorySelected: [],
        options: [],
        group: [],
        groupSelected: [],
        option: {
          growth: true,
          payout: true,
          reInvest: true
        }
      },
      investorActivity: {
        have: false,
        activityTypes : [],
        activityTypesSelected: [],
        schemes : [],
        schemesSelected: [],
        category: [],
        categorySelected: [],
        group: [],
        groupSelected: [],
        options: [],
        option: {
          growth: true,
          payout: true,
          reInvest: true
        },
        duration : ""
      }
    };

    vm.openNav = openNav;
    vm.closeNav = closeNav;
    vm.selectFilter = selectFilter;
    vm.changeEligibility = changeEligibility;
    vm.changeInvestorType = changeInvestorType;
    vm.changeInvestorSubType = changeInvestorSubType;
    vm.changeOtmRegistered = changeOtmRegistered;
    vm.changeHoldingState = changeHoldingState;
    vm.changeSystematicFilter = changeSystematicFilter;
    vm.changeInvestorActivity = changeInvestorActivity;
    vm.changeInvestorDuration = changeInvestorDuration;
    vm.changeOptionsSelected = changeOptionsSelected;
    vm.changeSystematicOptions = changeSystematicOptions;
    vm.changeInvestorActivityOptions = changeInvestorActivityOptions;
    vm.initiateFilterDefaultSelection = initiateFilterDefaultSelection;
    vm.applyFilters = applyFilters;
    vm.setCurrentHoldingGrouping = setCurrentHoldingGrouping;
    vm.setInvestorActivityGrouping = setInvestorActivityGrouping;
    vm.setSystematicGrouping = setSystematicGrouping;
    vm.clearAllOption = clearAllOption;
    vm.clearAllOptionInvestor = clearAllOptionInvestor;
    vm.clearAllOptionSystematic = clearAllOptionSystematic;
    vm.checkPageFilter = checkPageFilter;
    vm.defaultEligiblitySet = true;
    vm.defaultInvestorTypeSet = true;
    vm.defaultOtmSet = true;
    vm.defaultcurrentHoldingSet = true;
    vm.defaultCurrentHoldingScheme = true;
    vm.defaultCurrentHoldingOption = true;
    vm.defaultsystemicPlanSet = true;
    vm.defaultsystemicSchemeSet = true;
    vm.defaultsystemicOptionSet = true;
    vm.defaultInvestorActivity = true;
    vm.defaultInvestorActivityPlan = true;
    vm.defaultInvestorActivitySchemeSet = true;
    vm.defaultInvestorActivityGroupSet = true;
    vm.defaultSystematicGroupSet = true;
    vm.defaultInvestorActivityOptionSet = true;
    vm.defaultInvestorActivityDurationSet = true;
    vm.defaultCHgroupSelection = true;
    vm.defaultCurrentHoldingGroup = true;
    vm.allGroup = [];
    vm.currHoldingSchemeGroup = [];
    vm.investorActivitySchemeGroup = [];
    vm.systematicSchemeGroup = [];
    vm.borderHide=true;
    vm.resetPage = resetPage;

    vm.planTypeChangeEvent = {
      onItemSelect: function(event) {
        var planTypeArray = [];
        var planTypeArrayExceptAll = vm.investorFilter.SYSTEMATIC_PLAN_TYPE.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.investorFilter.SYSTEMATIC_PLAN_TYPE.forEach(function(type) {
          var obj = {
            id: type.value
          };
          planTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.planTypeArray = planTypeArray;
          vm.selectionMade.systematicPlanType = [];
          vm.filtersSelected.systematicFilter.planTypes = vm.planTypeArray;
          vm.filtersSelected.systematicFilter.planTypeSelected = ['ALL'];
          vm.selectionMade.systematicPlanType.push("All");
        } else if (planTypeArrayExceptAll.length === vm.filtersSelected.systematicFilter.planTypes.length) {
          vm.planTypeArray = planTypeArray;
          vm.selectionMade.systematicPlanType = [];
          vm.filtersSelected.systematicFilter.planTypes = vm.planTypeArray;
          vm.filtersSelected.systematicFilter.planTypeSelected = ['ALL'];
          vm.selectionMade.systematicPlanType.push("All");
        } else {
          vm.selectionMade.systematicPlanType = [];
          vm.filtersSelected.systematicFilter.planTypeSelected = vm.filtersSelected.systematicFilter.planTypes.map(function (ele) {
            vm.selectionMade.systematicPlanType.push("" + ele.id);
            return ele.id;
          });
        }
        if(vm.filtersSelected.systematicFilter.planTypes.length === 0 ) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }, onItemDeselect: function(event) {
        vm.defaultsystemicPlanSet = false;
        if (event.id === "ALL") {
          vm.filtersSelected.systematicFilter.planTypes = [];
          vm.filtersSelected.systematicFilter.planTypeSelected = [];
          vm.selectionMade.systematicPlanType = [];
        } else {
          vm.selectionMade.systematicPlanType = [];
          vm.filtersSelected.systematicFilter.planTypes = vm.filtersSelected.systematicFilter.planTypes.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.systematicFilter.planTypeSelected = vm.filtersSelected.systematicFilter.planTypes.map(function (ele) {
            vm.selectionMade.systematicPlanType.push("" + ele.id);
            return ele.id;
          });
        }

        if(vm.filtersSelected.systematicFilter.planTypes.length === 0 ) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }
    };

    vm.changeInvestorActivityType = {
      onItemSelect: function(event) {
        var activityTypeArray = [];
        var ativityTypeArrayExceptAll = vm.investorFilter.INVESTOR_ACTIVITY_TYPE.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.investorFilter.INVESTOR_ACTIVITY_TYPE.forEach(function(type) {
          var obj = {
            id: type.value
          };
          activityTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.activityTypeArray = activityTypeArray;
          vm.selectionMade.investorActivityType = [];
          vm.filtersSelected.investorActivity.activityTypes = vm.activityTypeArray;
          vm.filtersSelected.investorActivity.activityTypesSelected = ['ALL'];
          vm.selectionMade.investorActivityType.push("All");
        } else if (ativityTypeArrayExceptAll.length === vm.filtersSelected.investorActivity.activityTypes.length) {
          vm.activityTypeArray = activityTypeArray;
          vm.selectionMade.investorActivityType = [];
          vm.filtersSelected.investorActivity.activityTypes = vm.activityTypeArray;
          vm.filtersSelected.investorActivity.activityTypesSelected = ['ALL'];
          vm.selectionMade.investorActivityType.push("All");
        } else {
          vm.selectionMade.investorActivityType = [];
          vm.filtersSelected.investorActivity.activityTypesSelected = vm.filtersSelected.investorActivity.activityTypes.map(function (ele) {
            vm.selectionMade.investorActivityType.push("" + ele.id);
            return ele.id;
          });
        }

        if(vm.filtersSelected.investorActivity.activityTypes.length === 0 ) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }


      }, onItemDeselect: function(event) {
        vm.defaultInvestorActivityPlan = false;
        if (event.id === "ALL") {
          vm.filtersSelected.investorActivity.activityTypes = [];
          vm.filtersSelected.investorActivity.activityTypesSelected = [];
          vm.selectionMade.investorActivityType = [];
        } else {
          vm.selectionMade.investorActivityType = [];
          vm.filtersSelected.investorActivity.activityTypes = vm.filtersSelected.investorActivity.activityTypes.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.investorActivity.activityTypesSelected = vm.filtersSelected.investorActivity.activityTypes.map(function (ele) {
            vm.selectionMade.investorActivityType.push("" + ele.id);
            return ele.id;
          });
        }

        if(vm.filtersSelected.investorActivity.activityTypes.length === 0 ) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }
    };

    init();

    function init() {
      LoaderService.showLoader();
      vm.defaultsystemicSet = true;
      selectFilter({name: 'Eligibility', key: 'ELIGIBILITY', active: true});
      fetchSchemeType();
      $state.go("main.investors.list.individual");
      localStorage.removeItem("searchValue");
      destroyInvestorFilter();
    }

    vm.redirectToTab = function(tabKey){
      LoaderService.showLoader();
      if (tabKey === "Individual") {
        vm.tabs[0].active = true;
        vm.tabs[1].active = false;
        vm.tabs[2].active = false;
        applyFilters();
        $state.go("main.investors.list.individual");
      } else if (tabKey === "Non-Individual"){
        vm.tabs[0].active = false;
        vm.tabs[1].active = true;
        vm.tabs[2].active = false;
        $state.go("main.investors.list.non-individual");
      }else{
        vm.tabs[0].active = false;
        vm.tabs[1].active = false;
        vm.tabs[2].active = true;
        $state.go("main.investors.list.pending");
      }
    };

    function openNav() {
      angular.element(document.querySelector("#filterSideNav")).addClass('halfWidth');
      angular.element(document.querySelector("#filterSideNav")).removeClass('noWidth');
      angular.element(document.querySelector(".blur-area")).css('display', 'block');
      vm.handleFilterAction(true);
    }

    function closeNav() {
      angular.element(document.querySelector("#filterSideNav")).removeClass('halfWidth');
      angular.element(document.querySelector("#filterSideNav")).addClass('noWidth');
      angular.element(document.querySelector(".blur-area")).css('display', 'none');
      destroyInvestorFilter();
    }

    function checkPageFilter(){
      $scope.$broadcast('isCheck', true);
    }
    function resetPage(){
      $scope.$broadcast('isPageNumber',true);
    }

    function selectFilter(option) {
      vm.filterList.forEach(function(filter) {
        if (option.key === filter.key) {
          filter.active = true;
        } else {
          filter.active = false;
        }
      });
      vm.selectedFilter = option.key;
    }

    function fetchSchemeType() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          vm.schemeArray = [];
          var schemeType = [];
          vm.schemeTypearr = resp.data.schemeType;
          resp.data.schemeType.forEach(function(item) {
            var obj = {
              key: item,
              value: item,
              checked: true
            };
            schemeType.push(obj);
            vm.schemeArray.push({
              id: obj.value
            });
          });
          vm.currentHoldingSchemeType = angular.copy(schemeType);
          vm.systematicSchemeType = angular.copy(schemeType);
          vm.investorActivitySchemeType = angular.copy(schemeType);
         // getSchemes("ALL");
          vm.fetchSchemes("ALL")
        } else {
          vm.SCHEME_TYPE = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.schemeType = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader();

      SchemeService.post({
        controller: 'schemeType'
      }, null).$promise.then(success, error);
    }

    function initiateFilterDefaultSelection() {
      vm.filterList.forEach(function(filter) {
          filter.error = false;
      });
      vm.borderHide=true;
      vm.planTypeArray = [];
      vm.activityTypeArray = [];
      vm.schemeTypeArray = [];
      vm.schemeTypeArraySystematic = [];
      vm.investorTypeArraySystematic = [];
      vm.chGroupTypeArray = [];
      vm.investorActivityGroupTypeArray = [];
      vm.systematicGroupTypeArray = [];
      vm.filtersSelected.investorSubType = []
      vm.filtersSelected.investorSelectedSubType =  {
        CGF: false,
        Minor: false,
        Others: false
      }
      vm.selectionMade.investorSubType = [];

      vm.investorFilter.SYSTEMATIC_PLAN_TYPE.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.planTypeArray.push(obj);
      });
      vm.investorFilter.INVESTOR_ACTIVITY_TYPE.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.activityTypeArray.push(obj);
      });
      vm.currentHoldingSchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.schemeTypeArray.push(obj);
      });
      vm.systematicSchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.schemeTypeArraySystematic.push(obj);
      });
      vm.investorActivitySchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.investorTypeArraySystematic.push(obj);
      });
      vm.currHoldingSchemeGroup.forEach(function(type) {
        var obj = {
          id: type.value
        };
        vm.chGroupTypeArray.push(obj);
      });

      vm.filtersSelected.systematicFilter.planTypes = vm.planTypeArray;
      vm.filtersSelected.investorActivity.activityTypes = vm.activityTypeArray;
      changeEligibility({key: 'All', filterKey: 'Eligibility: ALL', value: "ALL"});
      changeInvestorType({key: 'All', filterKey: "All Investors", value: "ALL"});
      changeOtmRegistered({key: 'All', filterKey: 'OTM Registered: All', value: 'ALL'});
      changeHoldingState({key: 'All', filterKey: 'Current Holding: All', value: 'ALL'});
      changeSystematicFilter({key: 'All', filterKey: "Systematic Investment's: All", value: 'ALL'});
      changeInvestorActivity({key: 'All', filterKey: "Investor Activity: All", value: 'ALL'});

      vm.planTypeChangeEvent.onItemSelect({id: 'ALL'});
      vm.changeInvestorActivityType.onItemSelect({id: 'ALL'});
      vm.selectCurrentHoldingSchemeType.onItemSelect({id: 'ALL'});
      vm.selectSystematicSchemeType.onItemSelect({id: 'ALL'});
      vm.selectInvestorActivitySchemeType.onItemSelect({id: 'ALL'});

      changeOptionsSelected();
      changeSystematicOptions();
      changeInvestorActivityOptions();
      vm.filtersSelected.investorActivity.duration = vm.investorFilter.DURATION[0].value;
      changeInvestorDuration();
      applyFilters();
      $scope.$broadcast('isCheck', false);
    }

    vm.changeBorder=function(){
      if(vm.filtersSelected.eligibility==='ALL' && vm.filtersSelected.investorType=='ALL' && vm.filtersSelected.otmOption==='ALL'
        && vm.filtersSelected.currentHolding.holdingState==='ALL' && vm.filtersSelected.systematicFilter.active==='ALL' && vm.filtersSelected.investorActivity.have==='ALL' ){
        vm.borderHide=true;
      }

      Object.keys(vm.filtersSelected.investorSelectedSubType).forEach(function(key, index) {
        if (vm.filtersSelected.investorSelectedSubType[key] === true && vm.filtersSelected.investorType=='ALL' ) {
          vm.borderHide = false;
        }})
    }

    function changeEligibility(obj) {
      if(obj.key !== 'All') {
        vm.defaultEligiblitySet = false;
        vm.borderHide=false;
      } else {
        vm.defaultEligiblitySet = true;
      }
      vm.selectionMade.eligibility = [];
      vm.selectionMade.eligibility.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.eligibility = obj.value;
      vm.changeBorder();
    }

    function changeInvestorType(obj) {
      if(obj.key !== 'All') {
        vm.borderHide=false;
      }
      vm.defaultInvestorTypeSet = false;
      vm.selectionMade.investorType = [];
      vm.selectionMade.investorType.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.investorType = obj.value;
      if(vm.filtersSelected.investorType == 'ALL') {
        vm.defaultInvestorTypeSet = true;
      } else {
        vm.defaultInvestorTypeSet = false;
      }
      vm.changeBorder();
    }

    function changeInvestorSubType() {
      vm.filtersSelected.investorSubType = [];
      vm.selectionMade.investorSubType = [];

      Object.keys(vm.filtersSelected.investorSelectedSubType).forEach(function(key, index) {
        var object = fetchSubType(key);
        if (vm.filtersSelected.investorSelectedSubType[key] === true) {
          vm.borderHide=false;
          vm.filtersSelected.investorSubType.push(object.value);
          vm.selectionMade.investorSubType.push(object.filterKey);
        } else {
          if (vm.filtersSelected.investorSubType.includes(object.value)) {
            var index = vm.filtersSelected.investorSubType.indexOf(object.value);
            if (index > -1) {
              vm.filtersSelected.investorSubType.splice(index, 1);
            }
            var objectIndex = vm.selectionMade.investorSubType.indexOf(object.filterKey);
            if (objectIndex > -1) {
              vm.selectionMade.investorSubType.splice(objectIndex, 1);
            }
          }
        }
      });
      if(vm.filtersSelected.investorSubType.length === 0 && vm.filtersSelected.investorType=='ALL' &&
      vm.filtersSelected.eligibility =="ALL" && vm.filtersSelected.otmOption == 'ALL' && vm.filtersSelected.currentHolding.holdingState == 'ALL' &&
      vm.filtersSelected.systematicFilter.active == 'ALL' && vm.filtersSelected.investorActivity.have == 'ALL')
      {
        vm.borderHide=true;
      }
        }
    function changeOtmRegistered(obj) {
      if(obj.key !== 'All') {
        vm.defaultOtmSet = false;
        vm.borderHide=false;
      } else {
        vm.defaultOtmSet = true;
      }
      vm.selectionMade.otmOption = [];
      vm.selectionMade.otmOption.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.otmOption = obj.value;
      vm.changeBorder();
    }

    function changeHoldingState(obj) {
      if(obj.key !== 'All') {
        vm.defaultcurrentHoldingSet = false;
        vm.borderHide=false;
      } else {
        vm.defaultcurrentHoldingSet = true;
        vm.filtersSelected.currentHolding.option.growth = true
        vm.filtersSelected.currentHolding.option.payout= true
        vm.filtersSelected.currentHolding.option.reInvest= true
        vm.defaultCurrentHoldingScheme = true;
        vm.defaultCurrentHoldingGroup = true;
        vm.defaultCurrentHoldingOption = true;
        vm.changeOptionsSelected();
        vm.selectCurrentHoldingSchemeType.onItemSelect({id: 'ALL'});
      }
      vm.selectionMade.currentHoldingState = [];
      vm.selectionMade.currentHoldingState.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.currentHolding.holdingState = obj.value;
      vm.changeBorder();
    }

    function changeSystematicFilter(obj) {
      if(obj.key !== 'All') {
        vm.defaultsystemicSet = false;
        vm.borderHide=false;
      } else {
        vm.defaultsystemicSet = true;
        vm.planTypeChangeEvent.onItemSelect({id: 'ALL'});
        vm.selectSystematicSchemeType.onItemSelect({id: 'ALL'});
        vm.filtersSelected.systematicFilter.option.growth = true
        vm.filtersSelected.systematicFilter.option.payout= true
        vm.filtersSelected.systematicFilter.option.reInvest= true
        vm.changeSystematicOptions()
        vm.defaultsystemicPlanSet = true;
        vm.defaultsystemicSchemeSet = true;
        vm.defaultSystematicGroupSet = true;
        vm.defaultsystemicOptionSet = true;
      }
      vm.selectionMade.systematicActiveState = [];
      vm.selectionMade.systematicActiveState.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.systematicFilter.active = obj.value;
      vm.changeBorder();
    }

    function changeInvestorActivity(obj) {
      if(obj.key !== 'All') {
        vm.defaultInvestorActivity = false;
        vm.borderHide=false;
      } else {
        vm.defaultInvestorActivity = true;
        vm.changeInvestorActivityType.onItemSelect({id: 'ALL'});
        vm.selectInvestorActivitySchemeType.onItemSelect({id: 'ALL'});
        vm.filtersSelected.investorActivity.option.growth = true;
        vm.filtersSelected.investorActivity.option.payout= true;
        vm.filtersSelected.investorActivity.option.reInvest= true;
        vm.filtersSelected.investorActivity.duration = vm.investorFilter.DURATION[0].value;
        changeInvestorActivityOptions();
        changeInvestorDuration();
        vm.defaultInvestorActivityPlan = true;
        vm.defaultInvestorActivitySchemeSet = true;
        vm.defaultInvestorActivityGroupSet = true;
        vm.defaultInvestorActivityOptionSet = true;
        vm.defaultInvestorActivityDurationSet = true;
      }
      vm.selectionMade.investorActivityHave = [];
      vm.selectionMade.investorActivityHave.push(obj.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
      vm.filtersSelected.investorActivity.have = obj.value;
      vm.changeBorder();
    }

    function changeInvestorDuration() {
      vm.selectionMade.investorActivityDuration = [];
      var object = fetchInvestorActivityDuration(vm.filtersSelected.investorActivity.duration);
      vm.selectionMade.investorActivityDuration.push(object.filterKey);
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);
    }

    function changeOptionsSelected() {
      vm.filtersSelected.currentHolding.options = [];
      vm.selectionMade.currentHoldingOptions = [];
      Object.keys(vm.filtersSelected.currentHolding.option).forEach(function(key, index) {
        var object = fetchOptionValue(key);
        if (vm.filtersSelected.currentHolding.option[key] === true) {
          vm.filtersSelected.currentHolding.options.push(object.value);
          vm.selectionMade.currentHoldingOptions.push(object.filterKey);
        } else {
        vm.defaultCurrentHoldingOption = false;
         if (vm.filtersSelected.currentHolding.options.includes(object.value)) {
           var index = vm.filtersSelected.currentHolding.options.indexOf(object.value);
           if (index > -1) {
             vm.filtersSelected.currentHolding.options.splice(index, 1);
           }
           var objectIndex = vm.selectionMade.currentHoldingOptions.indexOf(object.filterKey);
           if (objectIndex > -1) {
             vm.selectionMade.currentHoldingOptions.splice(objectIndex, 1);
           }
         }
        }
      });
      vm.filterList.forEach(function(el) {
        if(el.key == 'CURRENT_HOLDING') {
          if(vm.filtersSelected.currentHolding.options.length == 0) {
            el.error = true;
          } else {
            el.error = false;
          }
        }
      })
      LoaderService.showLoader();
      vm.setCurrentHoldingGrouping()
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }

    function changeSystematicOptions() {
      vm.filtersSelected.systematicFilter.options = [];
      vm.selectionMade.systematicOptions = [];
      Object.keys(vm.filtersSelected.systematicFilter.option).forEach(function(key, index) {
        var object = fetchSystematicOptionsValue(key);
        if (vm.filtersSelected.systematicFilter.option[key] === true) {
          vm.filtersSelected.systematicFilter.options.push(object.value);
          vm.selectionMade.systematicOptions.push(object.filterKey);
        } else {
          vm.defaultsystemicOptionSet = false;
          if (vm.filtersSelected.systematicFilter.options.includes(object.value)) {
            var index = vm.filtersSelected.systematicFilter.options.indexOf(object.value);
            if (index > -1) {
              vm.filtersSelected.systematicFilter.options.splice(index, 1);
            }
            var objectIndex = vm.selectionMade.systematicOptions.indexOf(object.filterKey);
            if (objectIndex > -1) {
              vm.selectionMade.systematicOptions.splice(objectIndex, 1);
            }
          }
        }
      });
      vm.filterList.forEach(function(el) {
        if(el.key == 'SYSTEMATIC_INVESTMENT') {
          if(vm.filtersSelected.systematicFilter.options.length == 0) {
            el.error = true;
          } else {
            el.error = false;
          }
        }
      })
      LoaderService.showLoader();
      vm.setSystematicGrouping();
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }

    function changeInvestorActivityOptions() {
      vm.filtersSelected.investorActivity.options = [];
      vm.selectionMade.investorsActivityOptions = [];
      Object.keys(vm.filtersSelected.investorActivity.option).forEach(function(key, index) {
        var object = fetchInvestorActivityOptionsValue(key);
        if (vm.filtersSelected.investorActivity.option[key] === true) {
          vm.filtersSelected.investorActivity.options.push(object.value);
          vm.selectionMade.investorsActivityOptions.push(object.filterKey);
        } else {
          vm.defaultInvestorActivityOptionSet = false;
          if (vm.filtersSelected.investorActivity.options.includes(object.value)) {
            var index = vm.filtersSelected.investorActivity.options.indexOf(object.value);
            if (index > -1) {
              vm.filtersSelected.investorActivity.options.splice(index, 1);
            }
            var objectIndex = vm.selectionMade.investorsActivityOptions.indexOf(object.filterKey);
            if (objectIndex > -1) {
              vm.selectionMade.investorsActivityOptions.splice(objectIndex, 1);
            }
          }
        }
      });

      vm.filterList.forEach(function(el) {
        if(el.key == 'INVESTOR_ACTIVITY') {
          if(vm.filtersSelected.investorActivity.options.length == 0) {
            el.error = true;
          } else {
            el.error = false;
          }
        }
      })
      LoaderService.showLoader();
      vm.setInvestorActivityGrouping();
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 2000);

    }

    function fetchOptionValue(key) {
      var object = {};
      vm.investorFilter.CURRENT_HOLDING_OPTIONS_FILTER.forEach(function(options) {
        if (options.identifier === key || options.filterKey === key) {
          object = options;
        }
      });
      return object;
    }

    function fetchSystematicOptionsValue(key) {
      var object = {};
      vm.investorFilter.SYSTEMATIC_PLAN_OPTIONS_FILTER.forEach(function(options) {
        if (options.identifier === key || options.filterKey === key) {
          object = options;
        }
      });
      return object;
    }

    function fetchInvestorActivityOptionsValue(key) {
      var object = {};
      vm.investorFilter.INVESTOR_OPTIONS_FILTER.forEach(function(options) {
        if (options.identifier === key || options.filterKey === key) {
          object = options;
        }
      });
      return object;
    }

    function fetchSubType(key) {
      var object = {};
      vm.investorFilter.INVESTOR_SUB_TYPE.forEach(function(options) {
        if (options.key === key || options.filterKey === key) {
          object = options;
        }
      });
      return object;
    }

    function fetchInvestorActivityDuration(key) {

      if(key == 'MONTH2' || key == 'MONTH3' || key == 'MONTH6' || key == 'YEAR1' || key == 'YEAR2' || key == 'YEAR3' || key == 'CURRFINANCIALYEAR') {
        vm.defaultInvestorActivityDurationSet = false;
      }
      var object = {};
      vm.investorFilter.DURATION.forEach(function(options) {
        if (options.value === key) {
          object = options;
        }
      });
      return object;
    }

    function updateSelection(filter, filterKey) {
      var index = vm.selectionMade[filter].indexOf(filterKey);
      if(index > -1) {
        vm.selectionMade[filter].splice(index, 1);
      }
      vm.filterSelectionList.selectionKeys = Object.keys(vm.selectionMade);

      if (filter === "systematicActiveState") {
        changeSystematicFilter({key: 'All', filterKey: "All", value: 'ALL'});
      } else if (filter === "systematicPlanType") {
        var planId = filterKey.substr(filterKey.lastIndexOf(":") + 1, filterKey.length).toUpperCase().trim();
        var index = vm.filtersSelected.systematicFilter.planTypeSelected.indexOf(planId.trim());
        var planTypes = vm.filtersSelected.systematicFilter.planTypes.filter(function(el) {
          return el.id != planId.trim();
        });
        if(index > -1) {
          vm.filtersSelected.systematicFilter.planTypeSelected.splice(index, 1);
        }
        if (planId === "ALL") {
          vm.filtersSelected.systematicFilter.planTypeSelected = [];
          vm.filtersSelected.systematicFilter.planTypes = [];
        } else {
          vm.filtersSelected.systematicFilter.planTypes = planTypes;
          if(planTypes.length == 0) {
            vm.planTypeChangeEvent.onItemSelect({id: 'ALL'});
          }
        }
      } else if (filter === "systematicScheme") {
        var schemeId = filterKey.substr(filterKey.lastIndexOf(":") + 1, filterKey.length);
        vm.systematicSchemes.forEach(function(scheme) {
          if (scheme.schemeCode === schemeId.trim()) {
            scheme.checked = false;
          }
        });
        var index = vm.filtersSelected.systematicFilter.schemesSelected.indexOf(schemeId.trim());
        var scheme = vm.filtersSelected.systematicFilter.schemes.filter(function(el) {
          return el != schemeId.trim();
        });
        if(index > -1) {
          vm.filtersSelected.systematicFilter.schemesSelected.splice(index, 1);
        }
        if (scheme.length === vm.systematicSchemes.length) {
          vm.systematicSchemes.forEach(function(scheme) {
            scheme.checked = false;
          });
          vm.systematicSchemeType.forEach(function(type) {
            type.checked = false;
          });
          vm.filtersSelected.systematicFilter.schemes = [];
        } else {
          vm.filtersSelected.systematicFilter.schemes = scheme;
          if (scheme.length === 0) {
            vm.systematicSchemeType.forEach(function(type) {
              type.checked = false;
            });
          }
        }

      } else if (filter === "systematicOptions") {
        var object = fetchSystematicOptionsValue(filterKey);
        vm.filtersSelected.systematicFilter.option[object.identifier] = false;
        var index = vm.filtersSelected.systematicFilter.options.indexOf(object.value);
        if(index > -1) {
          vm.filtersSelected.systematicFilter.options.splice(index, 1);
        }
        LoaderService.showLoader();
        vm.setSystematicGrouping();
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);

      } else if (filter === "investorActivityHave") {
        changeInvestorActivity({key: 'All', filterKey: "Investor Activity: All", value: 'ALL'})
      }  else if (filter === "investorActivityType") {
        var activityId = filterKey.substr(filterKey.lastIndexOf(":") + 1, filterKey.length).toUpperCase().trim();
        var index = vm.filtersSelected.investorActivity.activityTypesSelected.indexOf(activityId.trim());
        var activityType = vm.filtersSelected.investorActivity.activityTypes.filter(function(el) {
          return el.id != activityId.trim();
        });
        if(index > -1) {
          vm.filtersSelected.investorActivity.activityTypesSelected.splice(index, 1);
        }
        if (activityId === "ALL") {
          vm.filtersSelected.investorActivity.activityTypesSelected = [];
          vm.filtersSelected.investorActivity.activityTypes = [];
        } else {
          vm.filtersSelected.investorActivity.activityTypesSelected = activityType;
          vm.filtersSelected.investorActivity.activityTypes = activityType;
        }
      }  else if (filter === "investorsActivityScheme") {
        var schemeId = filterKey.substr(filterKey.lastIndexOf(":") + 1, filterKey.length);

        vm.investorActivitySchemes.forEach(function(scheme) {
          if (scheme.schemeCode === schemeId.trim()) {
            scheme.checked = false;
          }
        });

        var index = vm.filtersSelected.investorActivity.schemesSelected.indexOf(schemeId.trim());
        var scheme = vm.filtersSelected.investorActivity.schemes.filter(function(el) {
          return el != schemeId.trim();
        });
        if(index > -1) {
          vm.filtersSelected.investorActivity.schemesSelected.splice(index, 1);
        }
        if (scheme.length === vm.investorActivitySchemes.length) {
          vm.investorActivitySchemes.forEach(function(scheme) {
            scheme.checked = false;
          });
          vm.investorActivitySchemeType.forEach(function(type) {
            type.checked = false;
          });
          vm.filtersSelected.investorActivity.schemes = [];
        } else {
          vm.filtersSelected.investorActivity.schemes = scheme;
          if (scheme.length === 0) {
            vm.investorActivitySchemeType.forEach(function(type) {
              type.checked = false;
            });
          }
        }
      }  else if (filter === "investorsActivityOptions") {
        var object = fetchInvestorActivityOptionsValue(filterKey);
        vm.filtersSelected.investorActivity.option[object.identifier] = false;
        var index = vm.filtersSelected.investorActivity.options.indexOf(object.value);
        if(index > -1) {
          vm.filtersSelected.investorActivity.options.splice(index, 1);
        }
        LoaderService.showLoader();
        vm.setInvestorActivityGrouping();
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
      }  else if (filter === "investorActivityDuration") {
          vm.filtersSelected.investorActivity.duration = vm.investorFilter.DURATION[0].value;
        changeInvestorDuration();
        vm.selectionMade.investorActivityDuration=[];
      } else if (filter === "currentHoldingState") {
        changeHoldingState({key: 'All', filterKey: 'All', value: 'ALL'});
      } else if (filter === "currentHoldingScheme") {
        var schemeId = filterKey.substr(filterKey.lastIndexOf(":") + 1, filterKey.length);
        vm.currentHoldingSchemes.forEach(function(scheme) {
          if (scheme.schemeCode === schemeId.trim()) {
            scheme.checked = false;
          }
        });
        var index = vm.filtersSelected.currentHolding.schemesSelected.indexOf(schemeId.trim());
        var scheme = vm.filtersSelected.currentHolding.schemes.filter(function(el) {
          return el != schemeId.trim();
        });

        if(index > -1) {
          vm.filtersSelected.currentHolding.schemesSelected.splice(index, 1);
        }
        if (scheme.length === vm.currentHoldingSchemes.length) {
          vm.currentHoldingSchemes.forEach(function(scheme) {
            scheme.checked = false;
          });
          vm.filtersSelected.currentHolding.schemes = [];
          vm.currentHoldingSchemeType.forEach(function(type) {
            type.checked = false;
          });
        } else {
          vm.filtersSelected.currentHolding.schemes = scheme;
          if (scheme.length === 0) {
            vm.currentHoldingSchemeType.forEach(function(type) {
              type.checked = false;
            });
          }
        }
      } else if (filter === "currentHoldingOptions") {
        var object = fetchOptionValue(filterKey);
        vm.filtersSelected.currentHolding.option[object.identifier] = false;
        var index = vm.filtersSelected.currentHolding.options.indexOf(object.value);
        if(index > -1) {
          vm.filtersSelected.currentHolding.options.splice(index, 1);
        }
        LoaderService.showLoader();
        vm.setCurrentHoldingGrouping();
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
      } else if (filter === "investorSubType") {
        var object = fetchSubType(filterKey);
        vm.filtersSelected.investorSelectedSubType[object.key] = false;
        var index = vm.filtersSelected.investorSubType.indexOf(object.value);
        if(index > -1) {
          vm.filtersSelected.investorSubType.splice(index, 1);
        }
      } else {
        vm.selectionMade.currentHoldingCategory = [];
        vm.filtersSelected[filter] = "ALL";

      }
      if(vm.filtersSelected.currentHolding.holdingState== 'ALL' && vm.filtersSelected.investorType == 'ALL' && vm.filtersSelected.otmOption == 'ALL' &&
      vm.filtersSelected.eligibility == 'ALL' && vm.filtersSelected.systematicFilter.active == 'ALL' && vm.filtersSelected.investorActivity.have == 'ALL' && vm.filtersSelected.systematicFilter.planTypeSelected[0]=='ALL' && vm.selectionMade.investorSubType.length == 0){
        vm.borderHide=true;
      }
    }

    vm.selectCurrentHoldingSchemeType = {
      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.currentHoldingSchemeType.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.currentHoldingSchemeType.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.schemeTypeArray = schemeTypeArray;
          vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
          vm.filtersSelected.currentHolding.category = vm.schemeTypeArray;
          vm.filtersSelected.currentHolding.categorySelected = ['ALL'];
          vm.selectionMadeCurrentHolding.currentHoldingCategory.push("ALL");
          vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;
          //vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
          vm.filtersSelected.currentHolding.schemesSelected = ['ALL']
          vm.currHoldingSchemeGroup = vm.allGroup;
          //vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'});
        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.currentHolding.category.length) {
          vm.schemeTypeArray = schemeTypeArray;
          vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
          vm.filtersSelected.currentHolding.category = vm.schemeTypeArray;
          vm.filtersSelected.currentHolding.categorySelected = ['ALL'];
          vm.selectionMadeCurrentHolding.currentHoldingCategory.push("ALL");
          vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;
          vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
          vm.filtersSelected.currentHolding.schemesSelected = ["ALL"];
          //vm.currHoldingSchemeGroup = vm.allGroup;
          //vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'});

        } else {
          vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
          vm.filtersSelected.currentHolding.categorySelected = vm.filtersSelected.currentHolding.category.map(function (ele) {
            vm.selectionMadeCurrentHolding.currentHoldingCategory.push(ele.id);
            return ele.id;
          });
          vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;
          vm.currHoldingSchemeGroup = [];
          vm.selectionMadeCurrentHolding.currentHoldingGroup = vm.previousSelection;
          LoaderService.showLoader();
          vm.setCurrentHoldingGrouping()
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
          vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
        }
        vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.currHoldingSchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                              key: elmn.schemeShortGroup,
                              value: elmn.schemeShortGroup,
                              checked: true
                            };
                            vm.currHoldingSchemeGroup.push(obj)
                         }
                      }
                  })
               })
            }

        })

        if(vm.filtersSelected.currentHolding.categorySelected.length == 0) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        } else {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }

        vm.filtersSelected.currentHolding.schemesSelected = [];
        LoaderService.showLoader();
        vm.setCurrentHoldingGrouping()
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
        if(vm.defaultCHgroupSelection) {
          vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
        }
        vm.selectionMadeCurrentHolding.currentHoldingGroup = vm.filterCurrentHolding.selectionKeysGroup
        if(vm.currHoldingSchemeGroup.length == 1) {
          vm.currHoldingSchemeGroup = [];
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filterCurrentHolding.selectionKeysGroup = [];
        }

          for (var i = 0; i < vm.currHoldingSchemeGroup.length; i++) {
            for (var j = i + 1; j < vm.currHoldingSchemeGroup.length; j++) {
              if (vm.currHoldingSchemeGroup[i].key === vm.currHoldingSchemeGroup[j].key) {
                vm.currHoldingSchemeGroup.splice(i, 1);
              }
            }
          }

      }, onItemDeselect: function(event) {
        vm.defaultCurrentHoldingScheme = false;
        if (event.id === "ALL") {
          vm.filtersSelected.currentHolding.category = [];
          vm.filtersSelected.currentHolding.categorySelected = [];
          vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
          vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;
          vm.filtersSelected.currentHolding.schemesSelected = []
          vm.filterCurrentHolding.selectionKeysGroup = [];
        } else {
          vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
          vm.filtersSelected.currentHolding.category = vm.filtersSelected.currentHolding.category.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.currentHolding.categorySelected = vm.filtersSelected.currentHolding.category.map(function (ele) {
            vm.selectionMadeCurrentHolding.currentHoldingCategory.push(ele.id);
            return ele.id;
          });
          vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;
          //vm.filtersSelected.currentHolding.schemesSelected = []
          //vm.currHoldingSchemeGroup = [];
          // vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          LoaderService.showLoader();
          vm.setCurrentHoldingGrouping()
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }

        if(vm.filtersSelected.currentHolding.categorySelected.length == 0) {
            vm.currHoldingSchemeGroup = [];
            vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
            vm.filterCurrentHolding.selectionKeysGroup = [];
        } else {
          vm.currHoldingSchemeGroup = [];
          vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.currHoldingSchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                              key: elmn.schemeShortGroup,
                              value: elmn.schemeShortGroup,
                              checked: true
                            };

                            vm.currHoldingSchemeGroup.push(obj)
                          }
                      }
                  })
               })
                LoaderService.showLoader();
                vm.setCurrentHoldingGrouping()
                setTimeout(function() {
                  LoaderService.hideLoader();
                }, 1500);
            }
          })

          for (var i = 0; i < vm.currHoldingSchemeGroup.length; i++) {
            for (var j = i + 1; j < vm.currHoldingSchemeGroup.length; j++) {
              if (vm.currHoldingSchemeGroup[i].key === vm.currHoldingSchemeGroup[j].key) {
                vm.currHoldingSchemeGroup.splice(i, 1);
              }
            }
          }
        }
        if(vm.ObjMap[event.id]  && event.id !== 'ALL') {
        vm.ObjMap[event.id].forEach(function(el) {
          el.forEach(function(elmn) {


            if(vm.filtersSelected.currentHolding.groupSelected.includes(elmn.schemeShortGroup)) {
              var index = vm.filtersSelected.currentHolding.groupSelected.indexOf(elmn.schemeShortGroup)
              vm.filtersSelected.currentHolding.groupSelected.splice(index,1)
            }
            vm.filtersSelected.currentHolding.group.forEach(function(elm) {
              if(elm.id == elmn.schemeShortGroup) {
                var index = vm.filtersSelected.currentHolding.group.indexOf(elm.id)
                vm.filtersSelected.currentHolding.group.splice(index,1)
              }
            })

            if(vm.filterCurrentHolding.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
              var index = vm.filterCurrentHolding.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
              vm.filterCurrentHolding.selectionKeysGroup.splice(index,1)
            }
          })
        })
      }
         var groupOptions = vm.currHoldingSchemeGroup.map(function(el) {
            return el.key
        })

        vm.selectionMadeCurrentHolding.currentHoldingGroup.forEach(function(el) {
          if(!groupOptions.includes(el)) {
            var index = vm.selectionMadeCurrentHolding.currentHoldingGroup.indexOf(el)
            vm.selectionMadeCurrentHolding.currentHoldingGroup.splice(index,1)
          }
        })
        vm.filtersSelected.currentHolding.schemesSelected = [];
        LoaderService.showLoader();
        vm.setCurrentHoldingGrouping()

        if(vm.filtersSelected.currentHolding.groupSelected[0] == 'ALL') {
          vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
        }

        if(vm.filtersSelected.currentHolding.categorySelected.length == 0) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        } else {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }

        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
      }
    }

    vm.selectCurrentHoldingGroupType = {
      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.currHoldingSchemeGroup.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.currHoldingSchemeGroup.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.chGroupTypeArray = schemeTypeArray;
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filtersSelected.currentHolding.group = vm.chGroupTypeArray;
          vm.filtersSelected.currentHolding.groupSelected = ['ALL'];
//          vm.filtersSelected.currentHolding.schemesSelected = ['ALL'];
          vm.selectionMadeCurrentHolding.currentHoldingGroup.push("ALL");
          vm.filterCurrentHolding.selectionKeysGroup  = vm.selectionMadeCurrentHolding.currentHoldingGroup;
          //vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.defaultCHgroupSelection = true;
        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.currentHolding.group.length) {
          vm.chGroupTypeArray = schemeTypeArray;
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filtersSelected.currentHolding.group = vm.chGroupTypeArray;
          vm.filtersSelected.currentHolding.groupSelected = ['ALL'];
          vm.selectionMadeCurrentHolding.currentHoldingGroup.push("ALL");
          vm.filterCurrentHolding.selectionKeysGroup = vm.selectionMadeCurrentHolding.currentHoldingGroup;
          vm.defaultCHgroupSelection = true;
        } else {
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filtersSelected.currentHolding.groupSelected = vm.filtersSelected.currentHolding.group.map(function (ele) {
            vm.selectionMadeCurrentHolding.currentHoldingGroup.push(ele.id);
            return ele.id;
          });
          vm.filterCurrentHolding.selectionKeysGroup = vm.selectionMadeCurrentHolding.currentHoldingGroup;
        }

        if(event.id == "ALL") {
            if(vm.filtersSelected.currentHolding.options.length == 3) {
              vm.filtersSelected.currentHolding.schemesSelected = [];
              vm.filtersSelected.currentHolding.schemesSelected.push("ALL")
            } else {
                if(vm.filtersSelected.currentHolding.categorySelected[0] !== 'ALL') {
                  var schArr = [];
                  vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
                    vm.filtersSelected.currentHolding.groupSelected.forEach(function(group) {
                      vm.schemeTypearr.forEach(function(elm) {
                        if(el == elm && vm.ObjMap[el]) {
                          vm.ObjMap[el][0].forEach(function(element) {
                          schArr.push(element)
                          })
                        }
                      })
                    })
                  })

                vm.filtersSelected.currentHolding.schemesSelected = [];
                schArr.forEach(function(el) {
                  el.schemeGroupDetailsDTOList.forEach(function(elm) {
                    if(vm.filtersSelected.currentHolding.options.length == 3) {
                      vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                    } else if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'Z') {
                      if(elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'Y') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') {
                        vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'N') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') {
                        vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
                      vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                    } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] == 'Z' && vm.filtersSelected.currentHolding.options[1] == 'Y') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] == 'Z' && vm.filtersSelected.currentHolding.options[1] == 'N') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                      }
                    }
                  })
                })
            }
        }
            LoaderService.showLoader();
            vm.setCurrentHoldingGrouping()
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
        } else {
          LoaderService.showLoader();
          vm.setCurrentHoldingGrouping()
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }

        if(vm.filtersSelected.currentHolding.groupSelected.length == 0) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        } else {
           vm.filterList.forEach(function(filter) {
             if (vm.selectedFilter === filter.key) {
               filter.error = false;
             }
           });
        }
      }, onItemDeselect: function(event) {
        vm.defaultCHgroupSelection = false;
        vm.defaultCurrentHoldingGroup = false;
        if (event.id === "ALL") {
          vm.filtersSelected.currentHolding.group = [];
          vm.filtersSelected.currentHolding.groupSelected = [];
          vm.previousSelection = vm.selectionMadeCurrentHolding.currentHoldingGroup;
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filterCurrentHolding.selectionKeysGroup = vm.selectionMadeCurrentHolding.currentHoldingGroup;
          vm.filtersSelected.currentHolding.schemesSelected = [];
        } else {
          vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
          vm.filtersSelected.currentHolding.group = vm.filtersSelected.currentHolding.group.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.currentHolding.groupSelected = vm.filtersSelected.currentHolding.group.map(function (ele) {
            vm.selectionMadeCurrentHolding.currentHoldingGroup.push(ele.id);
            return ele.id;
          });
          vm.filterCurrentHolding.selectionKeysGroup = vm.selectionMadeCurrentHolding.currentHoldingGroup;
          vm.filtersSelected.currentHolding.schemesSelected = [];
        }

        if(event.id == "ALL") {
          vm.filtersSelected.currentHolding.schemes = [];
          vm.filtersSelected.currentHolding.schemesSelected = [];
        } else {
          LoaderService.showLoader();
          vm.setCurrentHoldingGrouping()
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }

        if(vm.filtersSelected.currentHolding.groupSelected.length == 0) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        } else {
           vm.filterList.forEach(function(filter) {
             if (vm.selectedFilter === filter.key) {
               filter.error = false;
             }
           });
        }
      }
    };

    vm.selectSystematicSchemeType =  {

      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.systematicSchemeType.filter(function(plan) {
          return plan.value !== "ALL";
        });

        vm.systematicSchemeType.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.schemeTypeArraySystematic = schemeTypeArray;
          vm.selectionMadeSystematic.systematicCategory = [];
          vm.filtersSelected.systematicFilter.category = vm.schemeTypeArraySystematic;
          vm.filtersSelected.systematicFilter.categorySelected = ['ALL'];
          vm.selectionMadeSystematic.systematicCategory.push("ALL");
          vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;
          vm.systematicSchemeGroup = vm.allGroup;
          vm.selectSystematicGroupType.onItemSelect({id: 'ALL'});
        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.systematicFilter.category.length) {
          vm.schemeTypeArraySystematic = schemeTypeArray;
          vm.selectionMadeSystematic.systematicCategory = [];
          vm.filtersSelected.systematicFilter.category = vm.schemeTypeArraySystematic;
          vm.filtersSelected.systematicFilter.categorySelected = ['ALL'];
          vm.selectionMadeSystematic.systematicCategory.push("ALL");
          vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;
          vm.selectSystematicGroupType.onItemSelect({id: 'ALL'})
          vm.filtersSelected.systematicFilter.schemesSelected = ["ALL"];
          // vm.systematicSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          //vm.selectSystematicGroupType.onItemSelect({id: 'ALL'});
        } else {
          vm.selectionMadeSystematic.systematicCategory = [];
          vm.filtersSelected.systematicFilter.categorySelected = vm.filtersSelected.systematicFilter.category.map(function (ele) {
            vm.selectionMadeSystematic.systematicCategory.push(ele.id);
            return ele.id;
          });
          vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;
          vm.systematicSchemeGroup = [];
          //vm.selectionMadeInvestorType.investorTypeGroup = vm.previousSelection;
          LoaderService.showLoader();
          vm.setSystematicGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
          vm.systematicSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          //vm.selectionMadeSystematic.systematicGroup.push("ALL");
        }

        vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.systematicSchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                            key: elmn.schemeShortGroup,
                            value: elmn.schemeShortGroup,
                            checked: true
                            };

                            var obj2 = {
                              id : elmn.schemeShortGroup
                            }
                            vm.systematicSchemeGroup.push(obj)
                          }
                      }
                  })
               })
              if(vm.filtersSelected.systematicFilter.groupSelected[0] == 'ALL') {
                vm.selectSystematicGroupType.onItemSelect({id: 'ALL'})
              }
            }
        })
        vm.filtersSelected.systematicFilter.schemesSelected = [];
        LoaderService.showLoader();
        vm.setSystematicGrouping();
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
        if(vm.defaultSystematicGroupSet) {
          vm.selectSystematicGroupType.onItemSelect({id: 'ALL'})
        }
        vm.selectionMadeSystematic.systematicGroup = vm.filterSystematic.selectionKeysGroup
        if(vm.systematicSchemeGroup.length == 1) {
          vm.systematicSchemeGroup = [];
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filterSystematic.selectionKeysGroup = [];
        }

        for (var i = 0; i < vm.systematicSchemeGroup.length; i++) {
          for (var j = i + 1; j < vm.systematicSchemeGroup.length; j++) {
            if (vm.systematicSchemeGroup[i].key === vm.systematicSchemeGroup[j].key) {
              vm.systematicSchemeGroup.splice(i, 1);
            }
          }
        }

      }, onItemDeselect: function(event) {
        vm.defaultsystemicSchemeSet = false;
        if (event.id === "ALL") {
          vm.filtersSelected.systematicFilter.category = [];
          vm.filtersSelected.systematicFilter.categorySelected = [];
          vm.selectionMadeSystematic.systematicCategory = [];
          vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;
          vm.filtersSelected.systematicFilter.schemesSelected = []
          vm.filterSystematic.selectionKeysGroup = [];
          //vm.filtersSelected.systematicFilter.group = [];
        } else {
          vm.selectionMadeSystematic.systematicCategory = [];
          vm.filtersSelected.systematicFilter.category = vm.filtersSelected.systematicFilter.category.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.systematicFilter.categorySelected = vm.filtersSelected.systematicFilter.category.map(function (ele) {
            vm.selectionMadeSystematic.systematicCategory.push(ele.id);
            return ele.id;
          });
          vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;
          // vm.systematicSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          LoaderService.showLoader();
          vm.setSystematicGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }

        if(vm.filtersSelected.systematicFilter.categorySelected.length == 0) {
            vm.systematicSchemeGroup = [];
            vm.selectionMadeSystematic.systematicCategory = [];
             vm.filterSystematic.selectionKeys = [];
        } else {
          vm.systematicSchemeGroup = [];
          vm.systematicSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.systematicSchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                              key: elmn.schemeShortGroup,
                              value: elmn.schemeShortGroup,
                              checked: true
                            };

                            vm.systematicSchemeGroup.push(obj)
                            //vm.systematicSchemeGroup.onItemSelect({id: 'ALL'})
                          }
                      }
                  })
               })
              LoaderService.showLoader();
              vm.setSystematicGrouping();
              setTimeout(function() {
                LoaderService.hideLoader();
              }, 1500);
            }

        })
      }

      for (var i = 0; i < vm.systematicSchemeGroup.length; i++) {
        for (var j = i + 1; j < vm.systematicSchemeGroup.length; j++) {
          if (vm.systematicSchemeGroup[i].key === vm.systematicSchemeGroup[j].key) {
            vm.systematicSchemeGroup.splice(i, 1);
          }
        }
      }

      if(vm.ObjMap[event.id] && event.id !== 'ALL') {
        vm.ObjMap[event.id].forEach(function(el) {
          el.forEach(function(elmn) {

            if(vm.filtersSelected.systematicFilter.groupSelected.includes(elmn.schemeShortGroup)) {
              var index = vm.filtersSelected.systematicFilter.groupSelected.indexOf(elmn.schemeShortGroup)
              vm.filtersSelected.systematicFilter.groupSelected.splice(index,1)
            }
            vm.filtersSelected.systematicFilter.group.forEach(function(elm) {
              if(elm.id == elmn.schemeShortGroup) {
                var index = vm.filtersSelected.systematicFilter.group.indexOf(elm.id)
                vm.filtersSelected.systematicFilter.group.splice(index,1)
              }
            })

            if(vm.filterSystematic.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
              var index = vm.filterSystematic.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
              vm.filterSystematic.selectionKeysGroup.splice(index,1)
            }
          })
        })
      }

        var groupOptions = vm.systematicSchemeGroup.map(function(el) {
          return el.key
        })

        vm.selectionMadeSystematic.systematicGroup.forEach(function(el) {
        if(!groupOptions.includes(el)) {
          var index = vm.selectionMadeSystematic.systematicGroup.indexOf(el)
            vm.selectionMadeSystematic.systematicGroup.splice(index,1)
          }
        })
        vm.filtersSelected.systematicFilter.schemesSelected = [];
        LoaderService.showLoader();
        vm.setSystematicGrouping();

        if(vm.filtersSelected.systematicFilter.groupSelected[0] == 'ALL') {
          vm.selectSystematicGroupType.onItemSelect({id: 'ALL'})
        }

        setTimeout(function() {
         LoaderService.hideLoader();
        }, 1500);
      }
    };

    vm.selectSystematicGroupType = {
      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.systematicSchemeGroup.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.systematicSchemeGroup.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.systematicGroupTypeArray = schemeTypeArray;
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filtersSelected.systematicFilter.group = vm.systematicGroupTypeArray;
          vm.filtersSelected.systematicFilter.groupSelected = ['ALL'];
//          vm.filtersSelected.currentHolding.schemesSelected = ['ALL'];
          vm.selectionMadeSystematic.systematicGroup.push("ALL");
          vm.filterSystematic.selectionKeysGroup  = vm.selectionMadeSystematic.systematicGroup;
          //vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.systematicFilter.group.length) {
          vm.systematicGroupTypeArray = schemeTypeArray;
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filtersSelected.systematicFilter.group = vm.systematicGroupTypeArray;
          vm.filtersSelected.systematicFilter.groupSelected = ['ALL'];
          vm.selectionMadeSystematic.systematicGroup.push("ALL");
          vm.filterSystematic.selectionKeysGroup =  vm.selectionMadeSystematic.systematicGroup;
        } else {
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filtersSelected.systematicFilter.groupSelected = vm.filtersSelected.systematicFilter.group.map(function (ele) {
            vm.selectionMadeSystematic.systematicGroup.push(ele.id);
            return ele.id;
          });
          vm.filterSystematic.selectionKeysGroup = vm.selectionMadeSystematic.systematicGroup;
        }

        if(event.id == "ALL") {
            if(vm.filtersSelected.systematicFilter.options.length == 3) {
              vm.filtersSelected.systematicFilter.schemesSelected = [];
              vm.filtersSelected.systematicFilter.schemesSelected.push("ALL")
            } else {
              if(vm.filtersSelected.systematicFilter.categorySelected[0] !== 'ALL') {
                var schArr = [];
                vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
                  vm.filtersSelected.systematicFilter.groupSelected.forEach(function(group) {
                    vm.schemeTypearr.forEach(function(elm) {
                      if(el == elm && vm.ObjMap[el]) {
                        vm.ObjMap[el][0].forEach(function(element) {
                        schArr.push(element)
                        })
                      }
                    })
                  })
                 })

              vm.filtersSelected.systematicFilter.schemesSelected = [];
              schArr.forEach(function(el) {
                el.schemeGroupDetailsDTOList.forEach(function(elm) {
                  if(vm.filtersSelected.systematicFilter.options.length == 3) {
                    vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                  } else if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'Z') {
                    if(elm.investmentOption == "GROWTH") {
                      vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                    }
                  } else if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'Y') {
                    if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') {
                      vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                    }
                  } else if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'N') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') {
                        vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                      }
                  } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
                      vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                  } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] == 'Z' && vm.filtersSelected.systematicFilter.options[1] == 'Y') {
                    if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.investmentOption == "GROWTH") {
                      vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                    }
                  } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] == 'Z' && vm.filtersSelected.systematicFilter.options[1] == 'N') {
                    if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.investmentOption == "GROWTH") {
                      vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                    }
                  }
                })
              })
            }
           }
            LoaderService.showLoader();
            vm.setSystematicGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
        } else {
            LoaderService.showLoader();
            vm.setSystematicGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
          }

        if(vm.filtersSelected.systematicFilter.planTypes.length === 0 || vm.selectionMadeSystematic.systematicCategory.length===0 ||
          vm.filtersSelected.systematicFilter.options.length===0 || vm.filtersSelected.systematicFilter.groupSelected.length === 0 ||
          vm.systematicSchemeGroup.length === 0) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }

      }, onItemDeselect: function(event) {
        vm.defaultSystematicGroupSet = false;
        //vm.defaultCurrentHoldingGroup = false;
        if (event.id === "ALL") {
          vm.filtersSelected.systematicFilter.group = [];
          vm.filtersSelected.systematicFilter.groupSelected = [];
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filterSystematic.selectionKeysGroup = vm.selectionMadeSystematic.systematicGroup;
          vm.filtersSelected.systematicFilter.schemesSelected = [];
        } else {
          vm.selectionMadeSystematic.systematicGroup = [];
          vm.filtersSelected.systematicFilter.group = vm.filtersSelected.systematicFilter.group.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.systematicFilter.groupSelected = vm.filtersSelected.systematicFilter.group.map(function (ele) {
            vm.selectionMadeSystematic.systematicGroup.push(ele.id);
            return ele.id;
          });
          vm.filterSystematic.selectionKeysGroup = vm.selectionMadeSystematic.systematicGroup;
          vm.filtersSelected.systematicFilter.schemesSelected = [];
        }

        if(event.id == "ALL") {
          vm.filtersSelected.systematicFilter.schemes = [];
          vm.filtersSelected.systematicFilter.schemesSelected = [];
        } else {
            LoaderService.showLoader();
            vm.setSystematicGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
        }

        if(vm.filtersSelected.systematicFilter.planTypes.length === 0 || vm.selectionMadeSystematic.systematicCategory.length === 0 ||
          vm.filtersSelected.systematicFilter.options.length === 0 || vm.filtersSelected.systematicFilter.groupSelected.length === 0 ||
          vm.systematicSchemeGroup.length === 0 ) {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function(filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }
    };



    vm.selectInvestorActivitySchemeType =  {

      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.investorActivitySchemeType.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.investorActivitySchemeType.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.investorTypeArraySystematic = schemeTypeArray;
          vm.selectionMadeInvestorType.investorTypeCategory = [];
          vm.filtersSelected.investorActivity.category = vm.investorTypeArraySystematic;
          vm.filtersSelected.investorActivity.categorySelected = ['ALL'];
          vm.selectionMadeInvestorType.investorTypeCategory.push("ALL");
          vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;
          vm.filtersSelected.investorActivity.schemesSelected = ['ALL']
          vm.investorActivitySchemeGroup = vm.allGroup;
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'});

        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.investorActivity.category.length) {
          vm.investorSchemeTypeArray = schemeTypeArray;
          vm.selectionMadeInvestorType.investorTypeCategory = [];
          vm.filtersSelected.investorActivity.category = vm.investorSchemeTypeArray;
          vm.filtersSelected.investorActivity.categorySelected = ['ALL'];
          vm.selectionMadeInvestorType.investorTypeCategory.push("ALL");
          vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'})
          vm.filtersSelected.investorActivity.schemesSelected = ["ALL"];
          // vm.investorActivitySchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'});
        } else {
          vm.selectionMadeInvestorType.investorTypeCategory = [];
          vm.filtersSelected.investorActivity.categorySelected = vm.filtersSelected.investorActivity.category.map(function (ele) {
            vm.selectionMadeInvestorType.investorTypeCategory.push(ele.id);
            return ele.id;
          });
          vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;
          vm.investorActivitySchemeGroup = [];
          //vm.selectionMadeInvestorType.investorTypeGroup = vm.previousSelection;
          LoaderService.showLoader();
          vm.setInvestorActivityGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
          vm.investorActivitySchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
        }

        vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.investorActivitySchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                            key: elmn.schemeShortGroup,
                            value: elmn.schemeShortGroup,
                            checked: true
                            };
                            vm.investorActivitySchemeGroup.push(obj)
                          }
                      }
                  })
               })
            }
        })
        vm.filtersSelected.investorActivity.schemesSelected = [];
        LoaderService.showLoader();
        vm.setInvestorActivityGrouping();
        setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
        if(vm.defaultInvestorActivityGroupSet) {
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'})
        }
        vm.selectionMadeInvestorType.investorTypeGroup = vm.filterInvestorType.selectionKeysGroup
        if(vm.investorActivitySchemeGroup.length == 1) {
          vm.investorActivitySchemeGroup = [];
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filterInvestorType.selectionKeysGroup = [];
        }

       for (var i = 0; i < vm.investorActivitySchemeGroup.length; i++) {
         for (var j = i + 1; j < vm.investorActivitySchemeGroup.length; j++) {
           if (vm.investorActivitySchemeGroup[i].key === vm.investorActivitySchemeGroup[j].key) {
             vm.investorActivitySchemeGroup.splice(i, 1);
           }
         }
       }

      }, onItemDeselect: function(event) {
        vm.defaultInvestorActivitySchemeSet = false;
        if (event.id === "ALL") {
          vm.filtersSelected.investorActivity.category = [];
          vm.filtersSelected.investorActivity.categorySelected = [];
          vm.selectionMadeInvestorType.investorTypeCategory = [];
          vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;
          vm.filtersSelected.investorActivity.schemesSelected = []
          vm.filterInvestorType.selectionKeysGroup = [];
        } else {
          vm.selectionMadeInvestorType.investorTypeCategory = [];
          vm.filtersSelected.investorActivity.category = vm.filtersSelected.investorActivity.category.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.investorActivity.categorySelected = vm.filtersSelected.investorActivity.category.map(function (ele) {
            vm.selectionMadeInvestorType.investorTypeCategory.push(ele.id);
            return ele.id;
          });
          vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;
          // vm.investorActivitySchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          LoaderService.showLoader();
          vm.setInvestorActivityGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }
        if(vm.filtersSelected.investorActivity.categorySelected.length == 0) {
            vm.investorActivitySchemeGroup = [];
            vm.selectionMadeInvestorType.investorTypeGroup = [];
            vm.filterInvestorType.selectionKeys = [];
        } else {
          vm.investorActivitySchemeGroup = [];
          vm.investorActivitySchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
            if(el !== "ALL" && vm.ObjMap[el]) {
               vm.ObjMap[el].forEach(function(elm) {
                  elm.forEach(function(elmn) {
                      if(elmn.schemeShortGroup !== null) {
                          var index = vm.investorActivitySchemeGroup.indexOf(elmn.schemeShortGroup)
                          if(index <= -1) {
                            var obj = {
                              key: elmn.schemeShortGroup,
                              value: elmn.schemeShortGroup,
                              checked: true
                            };
                            vm.investorActivitySchemeGroup.push(obj)
                          }
                      }
                  })
               })
              LoaderService.showLoader();
              vm.setInvestorActivityGrouping();
              setTimeout(function() {
                LoaderService.hideLoader();
              }, 1500);
            }
        })
      }


       for (var i = 0; i < vm.investorActivitySchemeGroup.length; i++) {
         for (var j = i + 1; j < vm.investorActivitySchemeGroup.length; j++) {
           if (vm.investorActivitySchemeGroup[i].key === vm.investorActivitySchemeGroup[j].key) {
             vm.investorActivitySchemeGroup.splice(i, 1);
           }
         }
       }

      if(vm.ObjMap[event.id] && event.id !== 'ALL') {
      vm.ObjMap[event.id].forEach(function(el) {
        el.forEach(function(elmn) {
          if(vm.filtersSelected.investorActivity.groupSelected.includes(elmn.schemeShortGroup)) {
            var index = vm.filtersSelected.investorActivity.groupSelected.indexOf(elmn.schemeShortGroup)
            vm.filtersSelected.investorActivity.groupSelected.splice(index,1)
          }

          vm.filtersSelected.investorActivity.group.forEach(function(elm) {
            if(elm.id == elmn.schemeShortGroup) {
              var index = vm.filtersSelected.investorActivity.group.indexOf(elm.id)
              vm.filtersSelected.investorActivity.group.splice(index,1)
            }
          })

          if(vm.filterInvestorType.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
            var index = vm.filterInvestorType.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
              vm.filterInvestorType.selectionKeysGroup.splice(index,1)
            }
          })
        })
      }

      var groupOptions = vm.investorActivitySchemeGroup.map(function(el) {
        return el.key
      })

      vm.selectionMadeInvestorType.investorTypeGroup.forEach(function(el) {
          if(!groupOptions.includes(el)) {
            var index = vm.selectionMadeInvestorType.investorTypeGroup.indexOf(el)
            vm.selectionMadeInvestorType.investorTypeGroup.splice(index,1)
          }
        })
        vm.filtersSelected.investorActivity.schemesSelected = [];
        LoaderService.showLoader();
        vm.setInvestorActivityGrouping();


       if(vm.filtersSelected.investorActivity.groupSelected[0] == 'ALL') {
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'})
       }

       setTimeout(function() {
          LoaderService.hideLoader();
        }, 1500);
      }
    };

    vm.selectInvestorActivityGroupType = {
      onItemSelect: function(event) {
        var schemeTypeArray = [];
        var schemeTypeArrayExceptAll = vm.investorActivitySchemeGroup.filter(function(plan) {
          return plan.value !== "ALL";
        });
        vm.investorActivitySchemeGroup.forEach(function(type) {
          var obj = {
            id: type.value
          };
          schemeTypeArray.push(obj);
        });
        if (event.id === "ALL") {
          vm.investorActivityGroupTypeArray = schemeTypeArray;
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filtersSelected.investorActivity.group = vm.investorActivityGroupTypeArray;
          vm.filtersSelected.investorActivity.groupSelected = ['ALL'];
//          vm.filtersSelected.currentHolding.schemesSelected = ['ALL'];
          vm.selectionMadeInvestorType.investorTypeGroup.push("ALL");
          vm.filterInvestorType.selectionKeysGroup  = vm.selectionMadeInvestorType.investorTypeGroup;
          //vm.currHoldingSchemeGroup.unshift({"key":"ALL","value":"ALL","checked":true})
        } else if (schemeTypeArrayExceptAll.length === vm.filtersSelected.investorActivity.group.length) {
          vm.investorActivityGroupTypeArray = schemeTypeArray;
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filtersSelected.investorActivity.group = vm.investorActivityGroupTypeArray;
          vm.filtersSelected.investorActivity.groupSelected = ['ALL'];
          vm.selectionMadeInvestorType.investorTypeGroup.push("ALL");
          vm.filterInvestorType.selectionKeysGroup = vm.selectionMadeInvestorType.investorTypeGroup;
        } else {
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filtersSelected.investorActivity.groupSelected = vm.filtersSelected.investorActivity.group.map(function (ele) {
            vm.selectionMadeInvestorType.investorTypeGroup.push(ele.id);
            return ele.id;
          });
          vm.filterInvestorType.selectionKeysGroup = vm.selectionMadeInvestorType.investorTypeGroup;
        }

        if(event.id == "ALL") {
            if(vm.filtersSelected.investorActivity.options.length == 3) {
              vm.filtersSelected.investorActivity.schemesSelected = [];
              vm.filtersSelected.investorActivity.schemesSelected.push("ALL")
            } else {
              if(vm.filtersSelected.investorActivity.categorySelected[0] !== 'ALL') {
                var schArr = [];
                vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
                  vm.filtersSelected.investorActivity.groupSelected.forEach(function(group) {
                    vm.schemeTypearr.forEach(function(elm) {
                      if(el == elm && vm.ObjMap[el]) {
                        vm.ObjMap[el][0].forEach(function(element) {
                          schArr.push(element)
                        })
                      }
                    })
                  })
                })

                vm.filtersSelected.investorActivity.schemesSelected = [];
                schArr.forEach(function(el) {
                  el.schemeGroupDetailsDTOList.forEach(function(elm) {
                    if(vm.filtersSelected.investorActivity.options.length == 3) {
                      vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                    } else if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'Z') {
                      if(elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'Y') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') {
                        vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'N') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') {
                        vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
                      vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                    } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] == 'Z' && vm.filtersSelected.investorActivity.options[1] == 'Y') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                      }
                    } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] == 'Z' && vm.filtersSelected.investorActivity.options[1] == 'N') {
                      if(elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.investmentOption == "GROWTH") {
                        vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                      }
                    }
                  })
                })
              }
            }
            LoaderService.showLoader();
            vm.setInvestorActivityGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
        } else {
          LoaderService.showLoader();
          vm.setInvestorActivityGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }

        if(vm.filtersSelected.investorActivity.activityTypes.length === 0 || vm.selectionMadeInvestorType.investorTypeCategory.length===0 ||
          vm.filtersSelected.investorActivity.groupSelected.length === 0 || vm.investorActivitySchemeGroup.length === 0 ||
          vm.filtersSelected.investorActivity.options.length===0) {
          vm.filterList.forEach(function (filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function (filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }, onItemDeselect: function(event) {
        vm.defaultInvestorActivityGroupSet = false;
        //vm.defaultCurrentHoldingGroup = false;
        if (event.id === "ALL") {
          vm.filtersSelected.investorActivity.group = [];
          vm.filtersSelected.investorActivity.groupSelected = [];
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filterInvestorType.selectionKeysGroup = vm.selectionMadeInvestorType.investorTypeGroup;
          vm.filtersSelected.investorActivity.schemesSelected = [];
        } else {
          vm.selectionMadeInvestorType.investorTypeGroup = [];
          vm.filtersSelected.investorActivity.group = vm.filtersSelected.investorActivity.group.filter(function(plan) {
            return plan.id !== "ALL";
          });
          vm.filtersSelected.investorActivity.groupSelected = vm.filtersSelected.investorActivity.group.map(function (ele) {
            vm.selectionMadeInvestorType.investorTypeGroup.push(ele.id);
            return ele.id;
          });
          vm.filterInvestorType.selectionKeysGroup = vm.selectionMadeInvestorType.investorTypeGroup;
          vm.filtersSelected.investorActivity.schemesSelected = [];
        }

        if(event.id == "ALL") {
          vm.filtersSelected.investorActivity.schemes = [];
          vm.filtersSelected.investorActivity.schemesSelected = [];
        } else {
          LoaderService.showLoader();
          vm.setInvestorActivityGrouping();
          setTimeout(function() {
            LoaderService.hideLoader();
          }, 1500);
        }
        if(vm.filtersSelected.investorActivity.activityTypes.length === 0 || vm.selectionMadeInvestorType.investorTypeCategory.length===0 ||
          vm.filtersSelected.investorActivity.groupSelected.length === 0 || vm.investorActivitySchemeGroup.length === 0 ||
          vm.filtersSelected.investorActivity.options.length===0) {
          vm.filterList.forEach(function (filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = true;
            }
          });
        }
        else
        {
          vm.filterList.forEach(function (filter) {
            if (vm.selectedFilter === filter.key) {
              filter.error = false;
            }
          });
        }
      }
    };


    function applyFilters() {
      vm.filterApplied = angular.copy(vm.filtersSelected);
      vm.filterApplied.currentHolding.categories = vm.filterApplied.currentHolding.categorySelected;
      vm.filterApplied.currentHolding.schemes = vm.filterApplied.currentHolding.schemesSelected;
      delete vm.filterApplied.currentHolding.option;
      delete vm.filterApplied.currentHolding.schemesSelected;
      delete vm.filterApplied.currentHolding.categorySelected;
      delete vm.filterApplied.currentHolding.category;

      vm.filterApplied.investorActivity.categories = vm.filterApplied.investorActivity.categorySelected;
      vm.filterApplied.investorActivity.schemes = vm.filterApplied.investorActivity.schemesSelected;
      vm.filterApplied.investorActivity.activityTypes = vm.filterApplied.investorActivity.activityTypesSelected;
      vm.filterApplied.investorActivity.activityTypes = vm.filterApplied.investorActivity.activityTypes.map(function(ele){
        return ele.split(" ").join("");
      });
      delete vm.filterApplied.investorActivity.option;
      delete vm.filterApplied.investorActivity.activityTypesSelected;
      delete vm.filterApplied.investorActivity.schemesSelected;
      delete vm.filterApplied.investorActivity.categorySelected;
      delete vm.filterApplied.investorActivity.category;
      delete vm.filterApplied.investorActivity.group;
      delete vm.filterApplied.investorActivity.groupSelected;

      vm.filterApplied.systematicFilter.categories = vm.filterApplied.systematicFilter.categorySelected;
      vm.filterApplied.systematicFilter.schemes = vm.filterApplied.systematicFilter.schemesSelected;
      vm.filterApplied.systematicFilter.planTypes = vm.filterApplied.systematicFilter.planTypeSelected.map(function(ele){
        return ele.split(" ").join("");
      });
      delete vm.filterApplied.systematicFilter.option;
      delete vm.filterApplied.systematicFilter.planTypeSelected;
      delete vm.filterApplied.systematicFilter.schemesSelected;
      delete vm.filterApplied.investorSelectedSubType;
      delete vm.filterApplied.systematicFilter.categorySelected;
      delete vm.filterApplied.systematicFilter.category;
      delete vm.filterApplied.systematicFilter.group;
      delete vm.filterApplied.systematicFilter.groupSelected;
      delete vm.filterApplied.currentHolding.group;
      delete vm.filterApplied.currentHolding.groupSelected;
      vm.filterApplied.sortKey = "investorName";
      localStorage.setItem("filters", angular.toJson(vm.filterApplied));
      InvestorModel.setFilterPayload(vm.filterApplied);
      $scope.$broadcast('filterApplied', vm.filterApplied);
    }

    function getSchemes(schemeType) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          var schemes = resp.data.schemeList;
          schemes.map(function(scheme) {
            scheme.checked = false;
          });
          vm.currentHoldingSchemes = angular.copy(schemes);
          vm.systematicSchemes = angular.copy(schemes);
          vm.investorActivitySchemes = angular.copy(schemes);
          initiateFilterDefaultSelection();
        } else {
          vm.currentHoldingSchemes = [];
          vm.systematicSchemes = [];
          vm.investorActivitySchemes = [];
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.schemeType = null;
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'scheme',
        child1: 'list'
      }, null).$promise.then(success, error);
    }

    function updateSelectionCHscheme(option) {
      var schemeTypeArray = [];
      vm.currentHoldingSchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        schemeTypeArray.push(obj);
      });
      vm.selectionMadeCurrentHolding.currentHoldingCategory = [];
      vm.filtersSelected.currentHolding.category = vm.filtersSelected.currentHolding.category.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });

      vm.filtersSelected.currentHolding.categorySelected = vm.filtersSelected.currentHolding.category.map(function (ele) {
        vm.selectionMadeCurrentHolding.currentHoldingCategory.push(ele.id);
        return ele.id;
      });

      vm.filterCurrentHolding.selectionKeys = vm.selectionMadeCurrentHolding.currentHoldingCategory;

      if(vm.filtersSelected.currentHolding.categorySelected.length == 0) {
        vm.currHoldingSchemeGroup = [];
      } else {
        vm.currHoldingSchemeGroup = [{"key":"ALL","value":"ALL","checked":true}];
        vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
          if(el !== "ALL" && vm.ObjMap[el]) {
            vm.ObjMap[el].forEach(function(elm) {
              elm.forEach(function(elmn) {
                if(elmn.schemeShortGroup !== null) {
                  var index = vm.currHoldingSchemeGroup.indexOf(elmn.schemeShortGroup)
                  if(index <= -1) {
                    var obj = {
                      key: elmn.schemeShortGroup,
                      value: elmn.schemeShortGroup,
                      checked: true
                    };

                    vm.currHoldingSchemeGroup.push(obj)
                    //vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
                  }
                }
              })
            })
            LoaderService.showLoader();
            vm.setCurrentHoldingGrouping()
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
          }
        });
      }
      if(vm.ObjMap[option]) {
      vm.ObjMap[option].forEach(function(el) {
        el.forEach(function(elmn) {
          if(vm.filtersSelected.currentHolding.groupSelected.includes(elmn.schemeShortGroup)) {
            var index = vm.filtersSelected.currentHolding.groupSelected.indexOf(elmn.schemeShortGroup)
            vm.filtersSelected.currentHolding.groupSelected.splice(index,1)
          }
          vm.filtersSelected.currentHolding.group.forEach(function(elm) {
            if(elm.id == elmn.schemeShortGroup) {
              var index = vm.filtersSelected.currentHolding.groupSelected.indexOf(elm.id)
                vm.filtersSelected.currentHolding.group.splice(index,1)
              }
            })

            if(vm.filterCurrentHolding.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
              var index = vm.filterCurrentHolding.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
              vm.filterCurrentHolding.selectionKeysGroup.splice(index,1)
            }
        })
      })};

      var groupOptions = vm.currHoldingSchemeGroup.map(function(el) {
        return el.key
      })

      vm.selectionMadeCurrentHolding.currentHoldingGroup.forEach(function(el) {
        if(!groupOptions.includes(el)) {
          var index = vm.selectionMadeCurrentHolding.currentHoldingGroup.indexOf(el)
          vm.selectionMadeCurrentHolding.currentHoldingGroup.splice(index,1)
        }
      })
      vm.filtersSelected.currentHolding.schemesSelected = [];
      if(vm.filtersSelected.currentHolding.groupSelected[0] == 'ALL') {
        vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
      }
      LoaderService.showLoader();
      vm.setCurrentHoldingGrouping()
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }


    function updateSelectionCHgroup(option) {
      vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
      vm.filtersSelected.currentHolding.group = vm.filtersSelected.currentHolding.group.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });
      vm.filtersSelected.currentHolding.groupSelected = vm.filtersSelected.currentHolding.group.map(function (ele) {
        vm.selectionMadeCurrentHolding.currentHoldingGroup.push(ele.id);
        return ele.id;
      });
      vm.filterCurrentHolding.selectionKeysGroup = vm.selectionMadeCurrentHolding.currentHoldingGroup;
      vm.filtersSelected.currentHolding.schemesSelected = [];
      LoaderService.showLoader();
      vm.setCurrentHoldingGrouping()
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }

    function  updateSelectionSscheme(option) {
      var schemeTypeArray = [];
      vm.systematicSchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        schemeTypeArray.push(obj);
      });

      vm.selectionMadeSystematic.systematicCategory = [];
      vm.filtersSelected.systematicFilter.category = vm.filtersSelected.systematicFilter.category.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });

      vm.filtersSelected.systematicFilter.categorySelected = vm.filtersSelected.systematicFilter.category.map(function (ele) {
        vm.selectionMadeSystematic.systematicCategory.push(ele.id);
          return ele.id;
      });
      vm.filterSystematic.selectionKeys = vm.selectionMadeSystematic.systematicCategory;

      if(vm.filtersSelected.systematicFilter.categorySelected.length == 0) {
        vm.systematicSchemeGroup = [];
        vm.selectionMadeSystematic.systematicGroup = [];
        vm.filterSystematic.selectionKeys = [];
      } else {
          vm.systematicSchemeGroup = [{"key":"ALL","value":"ALL","checked":true}];
          vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
          if(el !== "ALL" && vm.ObjMap[el]) {
            vm.ObjMap[el].forEach(function(elm) {
              elm.forEach(function(elmn) {
                if(elmn.schemeShortGroup !== null) {
                  var index = vm.systematicSchemeGroup.indexOf(elmn.schemeShortGroup)
                  if(index <= -1) {
                    var obj = {
                      key: elmn.schemeShortGroup,
                      value: elmn.schemeShortGroup,
                      checked: true
                    };

                    vm.systematicSchemeGroup.push(obj)

                  }
                }
              })
            })
            LoaderService.showLoader();
            vm.setSystematicGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
          }
        })
      }
      if(vm.ObjMap[option]) {
      vm.ObjMap[option].forEach(function(el) {
        el.forEach(function(elmn) {
          if(vm.filtersSelected.systematicFilter.groupSelected.includes(elmn.schemeShortGroup)) {
            var index = vm.filtersSelected.systematicFilter.groupSelected.indexOf(elmn.schemeShortGroup)
            vm.filtersSelected.systematicFilter.groupSelected.splice(index,1)
          }
          vm.filtersSelected.systematicFilter.group.forEach(function(elm) {
            if(elm.id == elmn.schemeShortGroup) {
              var index = vm.filtersSelected.systematicFilter.groupSelected.indexOf(elm.id)
              vm.filtersSelected.systematicFilter.group.splice(index,1)
            }
          })

          if(vm.filterSystematic.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
            var index = vm.filterSystematic.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
            vm.filterSystematic.selectionKeysGroup.splice(index,1)
          }
        })
      })};

      var groupOptions = vm.systematicSchemeGroup.map(function(el) {
        return el.key
      });

      vm.selectionMadeSystematic.systematicGroup.forEach(function(el) {
        if(!groupOptions.includes(el)) {
          var index = vm.selectionMadeSystematic.systematicGroup.indexOf(el)
          vm.selectionMadeSystematic.systematicGroup.splice(index,1)
        }
      });
      vm.filtersSelected.systematicFilter.schemesSelected = [];
      if(vm.filtersSelected.systematicFilter.groupSelected[0] == 'ALL') {
        vm.selectSystematicGroupType.onItemSelect({id: 'ALL'})
      }
      LoaderService.showLoader();
      vm.setSystematicGrouping();
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);

    }

    function updateSelectionSystematicgroup(option) {
      vm.selectionMadeSystematic.systematicGroup = [];
      vm.filtersSelected.systematicFilter.group = vm.filtersSelected.systematicFilter.group.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });
      vm.filtersSelected.systematicFilter.groupSelected = vm.filtersSelected.systematicFilter.group.map(function (ele) {
        vm.selectionMadeSystematic.systematicGroup.push(ele.id);
        return ele.id;
      });
      vm.filterSystematic.selectionKeysGroup = vm.selectionMadeSystematic.systematicGroup;
      vm.filtersSelected.systematicFilter.schemesSelected = [];
      LoaderService.showLoader();
      vm.setSystematicGrouping();
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }

    function updateSelectionITscheme(option) {
      var schemeTypeArray = [];
      vm.investorActivitySchemeType.forEach(function(type) {
        var obj = {
          id: type.value
        };
        schemeTypeArray.push(obj);
      });
      vm.selectionMadeInvestorType.investorTypeCategory = [];
      vm.filtersSelected.investorActivity.category = vm.filtersSelected.investorActivity.category.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });
      vm.filtersSelected.investorActivity.categorySelected = vm.filtersSelected.investorActivity.category.map(function (ele) {
        vm.selectionMadeInvestorType.investorTypeCategory.push(ele.id);
        return ele.id;
      });
      vm.filterInvestorType.selectionKeys = vm.selectionMadeInvestorType.investorTypeCategory;

      if(vm.filtersSelected.investorActivity.categorySelected.length == 0) {
        vm.investorActivitySchemeGroup = [];
        vm.selectionMadeInvestorType.investorTypeGroup = [];
        vm.filterInvestorType.selectionKeys = [];
      } else {
          vm.investorActivitySchemeGroup = [{"key":"ALL","value":"ALL","checked":true}];
          vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
          if(el !== "ALL" && vm.ObjMap[el]) {
            vm.ObjMap[el].forEach(function(elm) {
              elm.forEach(function(elmn) {
                if(elmn.schemeShortGroup !== null) {
                  var index = vm.investorActivitySchemeGroup.indexOf(elmn.schemeShortGroup)
                  if(index <= -1) {
                    var obj = {
                      key: elmn.schemeShortGroup,
                      value: elmn.schemeShortGroup,
                      checked: true
                    };

                    vm.investorActivitySchemeGroup.push(obj)
                    //vm.selectCurrentHoldingGroupType.onItemSelect({id: 'ALL'})
                  }
                }
              })
            })
            LoaderService.showLoader();
            vm.setInvestorActivityGrouping();
            setTimeout(function() {
              LoaderService.hideLoader();
            }, 1500);
          }
        })
      }
      if(vm.ObjMap[option]) {
      vm.ObjMap[option].forEach(function(el) {
        el.forEach(function(elmn) {
          if(vm.filtersSelected.investorActivity.groupSelected.includes(elmn.schemeShortGroup)) {
            var index = vm.filtersSelected.investorActivity.groupSelected.indexOf(elmn.schemeShortGroup)
            vm.filtersSelected.investorActivity.groupSelected.splice(index,1)
          }
          vm.filtersSelected.investorActivity.group.forEach(function(elm) {
            if(elm.id == elmn.schemeShortGroup) {
              var index = vm.filtersSelected.investorActivity.groupSelected.indexOf(elm.id)
                vm.filtersSelected.investorActivity.group.splice(index,1)
              }
            })

            if(vm.filterInvestorType.selectionKeysGroup.includes(elmn.schemeShortGroup)) {
              var index = vm.filterInvestorType.selectionKeysGroup.indexOf(elmn.schemeShortGroup)
              vm.filterInvestorType.selectionKeysGroup.splice(index,1)
            }
        })
      })}

       var groupOptions = vm.investorActivitySchemeGroup.map(function(el) {
            return el.key
        })

       vm.selectionMadeInvestorType.investorTypeGroup.forEach(function(el) {
        if(!groupOptions.includes(el)) {
          var index = vm.selectionMadeInvestorType.investorTypeGroup.indexOf(el)
          vm.selectionMadeInvestorType.investorTypeGroup.splice(index,1)
        }
       })
       vm.filtersSelected.investorActivity.schemesSelected = [];
        if(vm.filtersSelected.investorActivity.groupSelected[0] == 'ALL') {
          vm.selectInvestorActivityGroupType.onItemSelect({id: 'ALL'})
        }
       LoaderService.showLoader();
       vm.setInvestorActivityGrouping();
       setTimeout(function() {
        LoaderService.hideLoader();
       }, 1500);
    }


    function updateSelectionITgroup(option) {
      vm.selectionMadeInvestorType.investorTypeGroup = [];
      vm.filtersSelected.investorActivity.group = vm.filtersSelected.investorActivity.group.filter(function(plan) {
        return plan.id !== "ALL" && plan.id !== option;
      });
      vm.filtersSelected.investorActivity.groupSelected = vm.filtersSelected.investorActivity.group.map(function (ele) {
        vm.selectionMadeInvestorType.investorTypeGroup.push(ele.id);
        return ele.id;
      });
      vm.filterInvestorType.selectionKeysGroup = vm.selectionMadeInvestorType.investorTypeGroup;
      vm.filtersSelected.investorActivity.schemesSelected = [];
      LoaderService.showLoader();
      vm.setInvestorActivityGrouping();
      setTimeout(function() {
        LoaderService.hideLoader();
      }, 1500);
    }


    /*
    * function to fetch schemes data
    */
    function fetchSchemes(schemeType) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.data && resp.status){
          vm.ObjMap ={};

          // grouping data based on category
          resp.data.forEach(function(element) {
            var Key = element.schemeType;
            if(!vm.ObjMap[Key]) {
              vm.ObjMap[Key] = [];
            }

            vm.ObjMap[Key].push(
              element.schemeDetailsDtoList
            );
          });


         // setting all schemes as default schemes
          vm.schemeTypearr.forEach(function(el) {
            if(vm.ObjMap[el] && el !== "ALL") {
              vm.ObjMap[el].forEach(function(elm) {
                elm.forEach(function(elmn) {
                  if(elmn.schemeShortGroup !== null) {
                    var index = vm.allGroup.indexOf(elmn.schemeShortGroup)
                    if(index <= -1) {
                      var obj = {
                        key: elmn.schemeShortGroup,
                        value: elmn.schemeShortGroup,
                        checked: true
                      };
                      vm.allGroup.push(obj);
                    }
                  }
                })
              })
            }
          })
          vm.allGroup.unshift({"key":"ALL","value":"ALL","checked":true})
          initiateFilterDefaultSelection();
        }else{
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err)
      };
      LoaderService.showLoader();
      SchemeService.get({
        controller: 'regular',
        child1: 'active',
        child2: 'schemes',
        child3: schemeType
      }, null).$promise.then(success, error);
    }

    /*
    * function to group and set schemes as per category type , scheme group and investment options selected
    */
    function setCurrentHoldingGrouping(event) {
      var schArr = [];

      /*
      * if both category selected and group selected is all
      */
      if(vm.filtersSelected.currentHolding.groupSelected[0] == 'ALL' && vm.filtersSelected.currentHolding.categorySelected[0] == "ALL") {
        if(vm.filtersSelected.currentHolding.options.length !== 3) {
           vm.schemeTypearr.forEach(function(elm) {
            if(vm.ObjMap[elm]) {
                vm.ObjMap[elm][0].forEach(function(element) {
                schArr.push(element)
              })
            }
          })
        }
      }

      /*
      * if different category is selected and group selected is all
      */
      if(vm.filtersSelected.currentHolding.groupSelected[0] == 'ALL' && vm.filtersSelected.currentHolding.categorySelected[0] !== "ALL") {
        if(vm.filtersSelected.currentHolding.options.length !== 3) {
          vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  schArr.push(element)
                })
              }
            })
          })
        }
      }

      /*
      * if different category and group is selected
      */
      if(vm.filtersSelected.currentHolding.categorySelected.length !== 0 && vm.filtersSelected.currentHolding.categorySelected[0] !== "ALL" && vm.filtersSelected.currentHolding.groupSelected.length !== 0) {
        vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
          vm.filtersSelected.currentHolding.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  if(element.schemeShortGroup == group) {
                    schArr.push(element)
                }
              })
            }
          })
        })
       })
      }

      /*
      * if category selected is all and different group is selected
      */
      if(vm.filtersSelected.currentHolding.groupSelected[0] !== 'ALL' && vm.filtersSelected.currentHolding.categorySelected[0] == "ALL") {
        vm.filtersSelected.currentHolding.categorySelected.forEach(function(el) {
          vm.filtersSelected.currentHolding.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
                if(vm.ObjMap[elm]) {
                 vm.ObjMap[elm][0].forEach(function(element) {
                   if(element.schemeShortGroup == group) {
                     schArr.push(element)
                   }
                 })
                }
            })
          })
        })
      }


      if(vm.filtersSelected.currentHolding.schemesSelected[0] != 'ALL' && vm.filtersSelected.currentHolding.options.length !== 3) {
        vm.filtersSelected.currentHolding.schemesSelected = [];
      } else if(vm.filtersSelected.currentHolding.options.length == 3 && vm.filtersSelected.currentHolding.schemesSelected[0] !== 'ALL' && vm.filtersSelected.currentHolding.groupSelected[0] == "ALL") {
        vm.filtersSelected.currentHolding.schemesSelected = ['ALL'];
      }

      /*
      * setting schemes as per investment options selected
      */
      schArr.forEach(function(el) {
        el.schemeGroupDetailsDTOList.forEach(function(elm) {
          if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'Z') {
            if(elm.investmentOption == "GROWTH") {
              vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
              vm.clearAllOption();
            }
          } else if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y'))) {
                vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                vm.clearAllOption();
              }
          } else if(vm.filtersSelected.currentHolding.options.length == 1 && vm.filtersSelected.currentHolding.options[0] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N'))) {
                vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                vm.clearAllOption();
              }
          } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
              vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
              vm.clearAllOption();
          } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] == 'Z' && vm.filtersSelected.currentHolding.options[1] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                vm.clearAllOption();
              }
          } else if(vm.filtersSelected.currentHolding.options.length == 2 && vm.filtersSelected.currentHolding.options[0] == 'Z' && vm.filtersSelected.currentHolding.options[1] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                vm.clearAllOption();
              }
          } else if(vm.filtersSelected.currentHolding.options.length == 3 && vm.filtersSelected.currentHolding.groupSelected[0] !== "ALL") {
                vm.filtersSelected.currentHolding.schemesSelected.push(elm.schemeCode)
                vm.clearAllOption();
          } else if(vm.filtersSelected.currentHolding.options.length == 0) {
              vm.filtersSelected.currentHolding.schemesSelected = []
          }
        })
      })

      var cleanedArr = vm.filtersSelected.currentHolding.schemesSelected.filter(function(el,index){
        return  vm.filtersSelected.currentHolding.schemesSelected.indexOf(el) === index
      })

      vm.filtersSelected.currentHolding.schemesSelected = cleanedArr;
      if(vm.currHoldingSchemeGroup.length == 1) {
        vm.currHoldingSchemeGroup = [];
        vm.selectionMadeCurrentHolding.currentHoldingGroup = [];
        vm.filterCurrentHolding.selectionKeysGroup = [];
      }
    }


    function setInvestorActivityGrouping() {
      var schArr = [];

      /*
      * if both category selected and group selected is all
      */
      if(vm.filtersSelected.investorActivity.groupSelected[0] == 'ALL' && vm.filtersSelected.investorActivity.categorySelected[0] == "ALL") {
        if(vm.filtersSelected.investorActivity.options.length !== 3) {
           vm.schemeTypearr.forEach(function(elm) {
            if(vm.ObjMap[elm]) {
                vm.ObjMap[elm][0].forEach(function(element) {
                schArr.push(element)
              })
            }
          })
        }
      }

      /*
      * if different category is selected and group selected is all
      */
      if(vm.filtersSelected.investorActivity.groupSelected[0] == 'ALL' && vm.filtersSelected.investorActivity.categorySelected[0] !== "ALL") {
        if(vm.filtersSelected.investorActivity.options.length !== 3) {
          vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  schArr.push(element)
                })
              }
            })
          })
        }
      }

      /*
      * if different category and group is selected
      */
      if(vm.filtersSelected.investorActivity.categorySelected.length !== 0 && vm.filtersSelected.investorActivity.categorySelected[0] !== "ALL" && vm.filtersSelected.currentHolding.groupSelected.length !== 0) {
        vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
          vm.filtersSelected.investorActivity.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  if(element.schemeShortGroup == group) {
                    schArr.push(element)
                }
              })
            }
          })
        })
       })
      }

      /*
      * if category selected is all and different group is selected
      */
      if(vm.filtersSelected.investorActivity.groupSelected[0] !== 'ALL' && vm.filtersSelected.investorActivity.categorySelected[0] == "ALL") {
        vm.filtersSelected.investorActivity.categorySelected.forEach(function(el) {
          vm.filtersSelected.investorActivity.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
                if(vm.ObjMap[elm]) {
                 vm.ObjMap[elm][0].forEach(function(element) {
                   if(element.schemeShortGroup == group) {
                     schArr.push(element)
                 }
               })
            }
          })
        })
       })
      }

      if(vm.filtersSelected.investorActivity.schemesSelected[0] != 'ALL' && vm.filtersSelected.investorActivity.options.length !== 3) {
        vm.filtersSelected.investorActivity.schemesSelected = [];
      } else if(vm.filtersSelected.investorActivity.options.length == 3 && vm.filtersSelected.investorActivity.schemesSelected[0] !== 'ALL' && vm.filtersSelected.currentHolding.groupSelected[0] == "ALL") {
        vm.filtersSelected.investorActivity.schemesSelected = ['ALL'];
      }

      /*
      * setting schemes as per investment options selected
      */
      schArr.forEach(function(el) {
        el.schemeGroupDetailsDTOList.forEach(function(elm) {
          if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'Z') {
            if(elm.investmentOption == "GROWTH") {
              vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
              vm.clearAllOptionInvestor();
            }
          } else if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y'))) {
                vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionInvestor();
              }
          } else if(vm.filtersSelected.investorActivity.options.length == 1 && vm.filtersSelected.investorActivity.options[0] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N'))) {
                vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionInvestor();
              }
          } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
              vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
              vm.clearAllOptionInvestor();
          } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] == 'Z' && vm.filtersSelected.investorActivity.options[1] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionInvestor();
              }
          } else if(vm.filtersSelected.investorActivity.options.length == 2 && vm.filtersSelected.investorActivity.options[0] == 'Z' && vm.filtersSelected.investorActivity.options[1] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionInvestor();
              }
          } else if(vm.filtersSelected.investorActivity.options.length == 3 && vm.filtersSelected.investorActivity.groupSelected[0] !== "ALL") {
                vm.filtersSelected.investorActivity.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionInvestor();
          } else if(vm.filtersSelected.investorActivity.options.length == 0) {
              vm.filtersSelected.investorActivity.schemesSelected = []
          }
        })
      })

      var cleanedArr = vm.filtersSelected.investorActivity.schemesSelected.filter(function(el,index){
        return  vm.filtersSelected.investorActivity.schemesSelected.indexOf(el) === index

      })

      vm.filtersSelected.investorActivity.schemesSelected = cleanedArr;
      if(vm.investorActivitySchemeGroup.length == 1) {
        vm.investorActivitySchemeGroup = [];
        vm.selectionMadeInvestorType.InvestorTypeGroup = [];
        vm.filterInvestorType.selectionKeysGroup = [];
      }

    }

    function setSystematicGrouping() {
      var schArr = [];

      /*
      * if both category selected and group selected is all
      */
      if(vm.filtersSelected.systematicFilter.groupSelected[0] == 'ALL' && vm.filtersSelected.systematicFilter.categorySelected[0] == "ALL") {
        if(vm.filtersSelected.systematicFilter.options.length !== 3) {
           vm.schemeTypearr.forEach(function(elm) {
            if(vm.ObjMap[elm]) {
                vm.ObjMap[elm][0].forEach(function(element) {
                schArr.push(element)
              })
            }
          })
        }
      }

      /*
      * if different category is selected and group selected is all
      */
      if(vm.filtersSelected.systematicFilter.groupSelected[0] == 'ALL' && vm.filtersSelected.systematicFilter.categorySelected[0] !== "ALL") {
        if(vm.filtersSelected.systematicFilter.options.length !== 3) {
          vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  schArr.push(element)
                })
              }
            })
          })
        }
      }

      /*
      * if different category and group is selected
      */
      if(vm.filtersSelected.systematicFilter.categorySelected.length !== 0 && vm.filtersSelected.systematicFilter.categorySelected[0] !== "ALL" && vm.filtersSelected.currentHolding.groupSelected.length !== 0) {
        vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
          vm.filtersSelected.systematicFilter.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
              if(el !=='ALL' && vm.ObjMap[el]) {
                vm.ObjMap[el][0].forEach(function(element) {
                  if(element.schemeShortGroup == group) {
                    schArr.push(element)
                }
              })
            }
          })
        })
       })
      }

      /*
      * if category selected is all and different group is selected
      */
      if(vm.filtersSelected.systematicFilter.groupSelected[0] !== 'ALL' && vm.filtersSelected.systematicFilter.categorySelected[0] == "ALL") {
        vm.filtersSelected.systematicFilter.categorySelected.forEach(function(el) {
          vm.filtersSelected.systematicFilter.groupSelected.forEach(function(group) {
            vm.schemeTypearr.forEach(function(elm) {
                if(vm.ObjMap[elm]) {
                 vm.ObjMap[elm][0].forEach(function(element) {
                   if(element.schemeShortGroup == group) {
                     schArr.push(element)
                 }
               })
            }
          })
        })
       })
      }



      if(vm.filtersSelected.systematicFilter.schemesSelected[0] != 'ALL' && vm.filtersSelected.systematicFilter.options.length !== 3) {
        vm.filtersSelected.systematicFilter.schemesSelected = [];
      } else if(vm.filtersSelected.systematicFilter.options.length == 3 && vm.filtersSelected.systematicFilter.schemesSelected[0] !== 'ALL' && vm.filtersSelected.systematicFilter.groupSelected[0] == "ALL") {
        vm.filtersSelected.systematicFilter.schemesSelected = ['ALL'];
      }

      /*
      * setting schemes as per investment options selected
      */
      schArr.forEach(function(el) {
        el.schemeGroupDetailsDTOList.forEach(function(elm) {
          if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'Z') {
            if(elm.investmentOption == "GROWTH") {
              vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
              vm.clearAllOptionSystematic();
            }
          } else if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y'))) {
                vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionSystematic();
              }
          } else if(vm.filtersSelected.systematicFilter.options.length == 1 && vm.filtersSelected.systematicFilter.options[0] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N') || (elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N'))) {
                vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionSystematic();
              }
          } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] != 'Z' && elm.investmentOption !== "GROWTH") {
              vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
              vm.clearAllOptionSystematic();
          } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] == 'Z' && vm.filtersSelected.systematicFilter.options[1] == 'Y') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'Y' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('Y')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionSystematic();
              }
          } else if(vm.filtersSelected.systematicFilter.options.length == 2 && vm.filtersSelected.systematicFilter.options[0] == 'Z' && vm.filtersSelected.systematicFilter.options[1] == 'N') {
              if((elm.dividendOptions.length == 1 && elm.dividendOptions[0] == 'N' || elm.dividendOptions.length == 2 && elm.dividendOptions.includes('N')) || elm.investmentOption == "GROWTH") {
                vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionSystematic();
              }
          } else if(vm.filtersSelected.systematicFilter.options.length == 3 && vm.filtersSelected.systematicFilter.groupSelected[0] !== "ALL") {
                vm.filtersSelected.systematicFilter.schemesSelected.push(elm.schemeCode)
                vm.clearAllOptionSystematic();
          } else if(vm.filtersSelected.systematicFilter.options.length == 0) {
              vm.filtersSelected.systematicFilter.schemesSelected = []
          }
        })
      })

      var cleanedArr = vm.filtersSelected.systematicFilter.schemesSelected.filter(function(el,index){
        return  vm.filtersSelected.systematicFilter.schemesSelected.indexOf(el) === index
      })

      vm.filtersSelected.systematicFilter.schemesSelected = cleanedArr;
      if(vm.systematicSchemeGroup.length == 1) {
        vm.systematicSchemeGroup = [];
        vm.selectionMadeSystematic.systematicGroup = [];
        vm.filterSystematic.selectionKeysGroup = [];
      }
    }



    function clearAllOption() {
      var index = vm.filtersSelected.currentHolding.schemesSelected.indexOf('ALL')
      if(index > -1) {
        vm.filtersSelected.currentHolding.schemesSelected.splice(index,1)
      }
    }

    function clearAllOptionSystematic() {
      var index = vm.filtersSelected.systematicFilter.schemesSelected.indexOf('ALL')
      if(index > -1) {
        vm.filtersSelected.systematicFilter.schemesSelected.splice(index,1)
      }
    }

    function clearAllOptionInvestor() {
      var index = vm.filtersSelected.investorActivity.schemesSelected.indexOf('ALL')
      if(index > -1) {
        vm.filtersSelected.investorActivity.schemesSelected.splice(index,1)
      }
    }

    vm.searchList = function () {
      if (vm.isSearching) {
        return;
      }
      else if (vm.searchText.length > 3 || vm.searchText == '') {
        vm.isSearching = true;
        localStorage.setItem("searchValue", vm.searchText);
        //vm.initInvestorList(vm.selectedType, vm.selectedSubType);
        $scope.$broadcast('filterApplied', vm.filterApplied);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.handleFilterAction = function(status) {
      var elem = document.getElementsByTagName("footer")[0];
      if (status) {
        elem.classList.add("menu-expanded");
        elem.classList.remove("menu-collapsed");
      } else {
        elem.classList.add("menu-collapsed");
        elem.classList.remove("menu-expanded");
      }
    };

    function destroyInvestorFilter() {
      $timeout(function () {
        var elem = document.getElementsByTagName("footer")[0];
        elem.classList.remove("menu-expanded");
      },100);
    }


  }
})();

/**
 * Created by ttn on 13/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('RegisterEmandateController', registerEmandateController);

  /** @ngInject */
  function registerEmandateController($scope, $state, $window, $stateParams, LoaderService, UtilService, ModalService, DistributorGenericService, AppConstants, MessageService , dynamicData ,panAdharLinkingService) {
    var vm = this;
    vm.viewMode = 'days';
    vm.bankList = [];
    vm.formData = {};
    vm.emandateDetails, vm.authMode = {};
    vm.formData.startDate = null;
    vm.formData.endDate = null;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.dynamicNote = dynamicData.noteDTO.noteDTOMap.Note_Register_Emandate;
    vm.init = init();

    /*
    * Function responsible to handle initialisation action of controller
    * */
    function init() {
      $window.scrollTo(0,0);
      LoaderService.showLoader();
      vm.investorDetails = $stateParams.investorDetails || angular.fromJson($window.sessionStorage.getItem("investorDetails"));
      UtilService.fetchMandateValidations().then(function (resp) {
        vm.emandateDetails = resp.eOTM;
        vm.formData.amount = Math.floor(vm.emandateDetails.defaultMandateAmount);
        $window.NumToWord(vm.formData.amount, 'amountInwordsEmandate',vm.emandateWord);
        vm.emandateMaxYear = vm.emandateDetails.maxMandateDurationYears ? vm.emandateDetails.maxMandateDurationYears : vm.defaultMandateYearDate;
        vm.mandateInfo = vm.emandateDetails.mandateInfo;
        vm.minEndDateGapMandate = vm.emandateDetails.minEndDateGap;
        vm.mandateMaxString = vm.emandateDetails.maxAmountLimitInfo;
        fetchBankList();
      }).catch(function(resp) {
        MessageService.error(resp)
      });
    }

    function calculateStartDate() {
      var enabledDates = [];
      var startMinDateBiller = $window.moment(vm.emandateDetails.minStartDate, "DD-MMM-YYYY");
      var startMaxDate = $window.moment(vm.emandateDetails.maxStartDate, "DD-MMM-YYYY");
      var freq = startMaxDate.diff(startMinDateBiller, 'days');
      for (var i = 0; i <= freq; i++) {
        var isEnable = true;
        enabledDates.push(startMinDateBiller.clone().add(i, 'days'));
      }
      vm.startMaxDate = startMaxDate.add(1, 'days').clone();
      vm.startMinDateBiller = startMinDateBiller.clone();
      vm.enabledStartDatesList = enabledDates;
    }

    function updateEndDates(startDate) {
      var enabledEndDates = [];
      vm.formData.endDate = null;
      vm.minEndDate = startDate.add(1, 'year');
      vm.maxEndDate = $window.moment(vm.formData.startDate, "DD-MM-YYYY").add(vm.emandateMaxYear, "years").subtract(1, 'days');
      var freq = vm.maxEndDate.diff(vm.minEndDate, 'days');
      for (var i = 0; i <= freq; i++) {
        var isEnable = true;
        enabledEndDates.push(vm.minEndDate.clone().add(i, 'days'));
      }
      vm.enabledEndDatesList = enabledEndDates;
      vm.endViewDate = enabledEndDates[0].clone();
      vm.changeEndDate(angular.copy(enabledEndDates[enabledEndDates.length -1]));
    }

    /*------------------------------- Emandate UI action section ---------------------------------------*/
    /**
     * Function responsible to handle the change bank action
     */
    vm.changeBank = function() {
      if (vm.formData.bankInfo) {
        var selectedBank = vm.formData.bankInfo;
        vm.formData.authModeSelect = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes[0] : null;
        vm.authenticationMode = vm.formData.bankInfo ? vm.formData.bankInfo.authenticationModes: null;
        vm.authMode = angular.copy(vm.formData.authModeSelect);
      }
    };

    /**
     * Function responsible to reset all the filled value
     */
    vm.reset = function() {
      vm.formData = {};
      vm.formData.startDate = null;
      vm.formData.endDate = null;
      vm.isDefaultDateSelected = false;
    };

    /**
     * Function responsible to validate the amount entered
     */
    vm.checkAmountValidation = function() {
      if(vm.formData.amount < vm.emandateDetails.minAmountLimit){
        vm.amountLess = true;
      } else {
        vm.amountLess = false;
      }
      if(vm.formData.amount > vm.emandateDetails.maxAmountLimit){
        vm.amountMore = true;
      } else {
        vm.amountMore = false;
      }

      $window.NumToWord(vm.formData.amount, 'amountInwordsEmandate',vm.emandateWord);
    };

    vm.changeStartDate = function(date) {
      vm.formData.startDate = null;
      vm.formData.startDate = date ? date.clone() : null;
      vm.isDefaultDateSelected = false;
      if (date) {
        updateEndDates(date);
      }
    };

    vm.changeEndDate = function (date) {
      vm.formData.endDate = date ? date : null;
      vm.maxEndDate.diff(vm.minEndDate, 'days');
      if (vm.maxEndDate.diff(date, 'days') != 0 ) {
        vm.isDefaultDateSelected = false;
      }
    };

    vm.defaultEndDate = function() {
      if (vm.isDefaultDateSelected) {
        vm.formData.endDate = vm.maxEndDate;
      } else {
        vm.formData.endDate = null;
      }
    };

    /**
     * Function responsible to submit the entered data and initiate summary modal
     */
    vm.goToSummary = function() {
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          MessageService.success(resp.data.message);
          $state.go('main.dashboard');
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(res) {
        LoaderService.hideLoader();
        MessageService.error(res.message);
      };

      LoaderService.hideLoader();

      var successHandler = function(resp) {
        ModalService.transactionReviewModal({
          payload: createPayloadForSummary(),
          controller: 'emandate'
        }, success, error);
      }

      var errorHandler = function(resp) {

      }

      panAdharLinkingService.checkPanAdharStatus('', vm.investorDetails.folioNo, brokerCode).then(successHandler).catch(errorHandler);


    };

    function createPayloadForSummary() {
      var payload = {
        "accNumber": vm.formData.bankInfo.accountNumber,
        "accType": vm.formData.bankInfo.bankAcType,
        "accountType": vm.formData.bankInfo.accTypeDesc,
        "authenticationMode": vm.authMode.value,
        "authModeText": vm.authMode.text,
        "bankBranch": vm.formData.bankInfo.bankBranch,
        "bankCity": vm.formData.bankInfo.bankCity,
        "bankCode": vm.formData.bankInfo.bankCode,
        "bankName": vm.formData.bankInfo.bankNameOnly,
        "email": vm.investorDetails.emailId,
        "folioNumber": vm.investorDetails.folioNo,
        "ifscCode": vm.formData.bankInfo.ifscCode,
        "maxAmount": vm.formData.amount,
        "mobile": vm.investorDetails.mobileNo,
        "name": vm.investorDetails.investorName,
        "omEndDate": vm.formData.endDate.format("DD-MMM-YYYY"),
        "omStartDate": vm.formData.startDate.format("DD-MMM-YYYY"),
        "purpose": vm.emandateDetails.purpose,
        "fequency": vm.emandateDetails.frequency,
        "panNumber": vm.investorDetails.panNumber
      };
      return payload;
    }

    /*------------------------------- Emandate UI action section ends here -----------------------------*/

    /*------------------------------- Api call section start from here ---------------------------------*/
    /**
     * Function responsible to get all the bank
     */
    function fetchBankList() {
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.investorDetails.folioNo,
        "panNumber": vm.investorDetails.panNumber
      };
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.bannedInvestorFlag) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorDetails.investorId});
            ModalService.genericModal({
              text: resp.data.bannedInvestorMsg
            })
          } else {
            vm.bankList = resp.data.bankList;
            vm.emandateDetails.minStartDate = resp.data.minStartDate;
            vm.emandateDetails.maxStartDate = resp.data.maxStartDate;
            if (vm.bankList.length === 1) {
              vm.formData.bankInfo = vm.bankList[0];
              vm.formData.authModeSelect = vm.formData.bankInfo.authenticationModes[0];
              vm.authMode = vm.formData.authModeSelect;
            }
            calculateStartDate();
          }
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      DistributorGenericService.post({
        controller: "bank",
        child1: "list",
        child2: 'emandate'
      }, payload).$promise.then(success, failure);
    }

    /*------------------------------- Api call section ends here ---------------------------------------*/
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('CobmApprovalSummaryController', cobmApprovalSummaryController);

  /** @ngInject */
  function cobmApprovalSummaryController($state, $stateParams, ModalService,$rootScope,HDFC_API, LoaderService,$log, UtilService, TransactionService, $window, InvestorModel, InvestorsCommonService, InvestorsService, MessageService, DownloadPdfService, FileSaver, FileUploadService, AppConstants, InvestorCommonServiceVersion2, dynamicData) {
    var vm = this;
    var links = $stateParams.uniqueLink.split('_');
    vm.uniqueLink = links[0];
    if (links.length == 2) {
      vm.cancelLink = links[1];
    }
    vm.summaryType = 'COBM';
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.IFSC_REGEX = AppConstants.ifsc_regex;
    vm.chooseAFileNew = true;
    vm.chooseAFileOld = true;
    vm.mimeType = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];
    vm.chequeLeafUrl = '';
    vm.chequeLeafUrlOld = '';
    vm.pennyDropSuccess = false;
    vm.dynamicData = dynamicData;
    vm.tpv = tpv;
    vm.appConstants = AppConstants;
    vm.isEnabledOldChequeLeaf = false;
    vm.isEnabledNewChequeLeaf = false;
    vm.isPennydropRequired = false;
    vm.disabledAfterSuccess = false;
    vm.formData = InvestorModel.getAddToBankPayload();
    vm.fetchBankList = fetchBankList;
    vm.selectIFSC = selectIFSC;
    vm.validatePennyDrop = validatePennyDrop;
    vm.approveDeleteBank = approveDeleteBank;
    vm.approveCobm = approveCobm;
    vm.confirmCancelModaltoRejectDeleteBank = confirmCancelModaltoRejectDeleteBank;
    vm.copyPasteHandler = copyPasteHandler;

    var pennyDropEnablSelectedBank = false;
    vm.init = init;

    if (vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST) {
      vm.noteBankRestrict = vm.dynamicData.noteDTO.noteDTOMap.Note_ADD_NEWBANK_LIST.content;
    }

    init();
    function init() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }
      LoaderService.showLoader();
      var successOptModal = function (result) {
        console.log(result);

          vm.summaryDetails = result;
          vm.summaryDetails.pan = result.pan;
          vm.formData.folioCreationRequestCO.bankDetails.ifsccode = result.IFSCCode;
          vm.formData.folioCreationRequestCO.bankDetails.bankName = result.bankName;
          vm.formData.folioCreationRequestCO.bankDetails.bankCity = result.bankCity;
          vm.formData.folioCreationRequestCO.bankDetails.branchLocation = result.bankBranch;
          vm.formData.folioCreationRequestCO.bankDetails.accountNumber = result.accountNumber;
          vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = result.payoutMechanisms;
          vm.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber = '';
          if(result.bankBranch && result.bankBranch.length>40) vm.formData.folioCreationRequestCO.bankDetails.bankBranch = result.bankBranch.slice(0,40)
          else vm.formData.folioCreationRequestCO.bankDetails.bankBranch = result.bankBranch;

          vm.formData.folioCreationRequestCO.oldChequeLeafUrl = result.oldBankProofURL;
          vm.formData.folioCreationRequestCO.chequeLeafUrl = result.newBankProofURL;
          // vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = result.pennyDropValid;
          if (vm.summaryDetails.cobmAction == "MBMR") {
            vm.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber = '';
          }
          vm.formData.folioCreationRequestCO.bankDetails.payoutId = result.payoutId;

          checkMinorNRITaxStatusCode();
          fetchBankList();
          getPayoutMechanism();
          getAcccountType();

          if(vm.formData.folioCreationRequestCO.oldChequeLeafUrl){
            var fileUrl = vm.formData.folioCreationRequestCO.oldChequeLeafUrl;
            vm.fileTypeold = vm.formData.folioCreationRequestCO.oldChequeLeafUrl.substr(vm.formData.folioCreationRequestCO.oldChequeLeafUrl.lastIndexOf(".") + 1);
            if (fileUrl) {
              // var myFile = fileUrl.split('/');
              var myFile= fileUrl.split('/');
              vm.myFile = myFile[myFile.length - 1];
              // vm.chequeLeaf = myFile[myFile.length - 1];
              vm.oldChequeLeaf = vm.myFile;
              vm.isOldCheckLeaf = true;
            }
          }

          if(vm.formData.folioCreationRequestCO.chequeLeafUrl){
            var fileUrl = vm.formData.folioCreationRequestCO.chequeLeafUrl;
            vm.fileType = vm.formData.folioCreationRequestCO.chequeLeafUrl.substr(vm.formData.folioCreationRequestCO.chequeLeafUrl.lastIndexOf(".") + 1);
            if (fileUrl) {
              // var myFile = fileUrl.split('/');
              var myFile= fileUrl.split('/');
              vm.myFile = myFile[myFile.length - 1];
              // vm.chequeLeaf = myFile[myFile.length - 1];
              vm.chequeLeaf = vm.myFile;
              vm.isNewCheckLeaf = true;
            }
          }

        },
        errorOtpModal = function () {
          vm.summaryDetails = null;
        },
        success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            ModalService.otpForApprovalModal({
              backdrop: 'static',
              summaryType: vm.summaryType,
              uniqueLink: vm.uniqueLink,
              cancelInk : vm.cancelLink
            }, successOptModal, errorOtpModal);
          } else {
            MessageService.error(resp.message)
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      TransactionService.get({
        VERSION: version,
        controller: 'otp',
        uniqueLink: vm.uniqueLink
      }, null).$promise.then(success, error);

      vm.summaryDetails = $window.JSON.parse(localStorage.getItem('summaryDetails'));
    }

    function tpv(event) {
      event.preventDefault();
      ModalService.tpvModal({});
    }

    function fetchBankList() {
      LoaderService.showLoader();
      var success = function (res) {
        LoaderService.hideLoader();
        if (res.status && res.data) {
          vm.bankList = res.data.bankList || res.data;
        } else {
          vm.bankList = null;
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        vm.bankList = null;
        UtilService.errorHandler(err);
      };
      InvestorsCommonService.get({child1: 'rbi', child2: 'bankNames'}).$promise.then(success, error);

    }

    function getPayoutMechanism() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.payoutMechanismList = resp.data.payoutMechanisms;
            var payoutMechanism = vm.payoutMechanismList.filter(function (e) {
              return e.payoutCode == vm.summaryDetails.payoutMechanisms.payoutCode;
            });
            vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = payoutMechanism[0] && payoutMechanism[0].payoutCode ? payoutMechanism[0] : null;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Payout Machanism error >>>>', err);
        };
      InvestorCommonServiceVersion2.get({
        child1: 'cobm',
        child2: 'payout',
        child3: 'mechanism'
      }).$promise.then(success, error);

    }

    function getAcccountType() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            vm.bankTypeList = resp.data.bankAccountTypes;
            if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
              var sbAccount = vm.bankTypeList.filter(function (e) {
                return e.accountTypeCode == vm.summaryDetails.bankAccountTypes.bankAcType;
              })
              vm.formData.folioCreationRequestCO.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('Account type Errror>>>>', err);
        };
      InvestorsService.get({
        controller: 'bank',
        child1: 'account-type',
        transactionType:'list',
        child2: 'investor',
        child3: vm.summaryDetails.taxStatus
      }).$promise.then(success, error);
    }

    function selectIFSC() {
      var successModal = function(data){
        vm.formData.folioCreationRequestCO.bankDetails.ifsccode= data.ifscCode;
        vm.formData.folioCreationRequestCO.bankDetails.bankName = data.bankName;
        vm.formData.folioCreationRequestCO.bankDetails.bankCity = data.branchCity;
        vm.formData.folioCreationRequestCO.bankDetails.branchLocation = data.branch;
        vm.formData.folioCreationRequestCO.bankDetails.accountNumber = '';
        vm.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber = '';
        vm.formData.folioCreationRequestCO.bankDetails.payoutId = data.payoutId;
        if (vm.bankTypeList.length && vm.bankTypeList.length > 0) {
          var sbAccount = vm.bankTypeList.filter(function (e) {
            return e.accountTypeCode == "SB";
          })
          vm.formData.folioCreationRequestCO.bankDetails.accountType = sbAccount[0] && sbAccount[0].accountType ? sbAccount[0]:null;
        }
        if(vm.payoutMechanismList && vm.payoutMechanismList.length){
          var payoutMechanism = vm.payoutMechanismList.filter(function (e) {
            return e.payoutCode == "DC";
          });
          vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism = payoutMechanism[0] && payoutMechanism[0].payoutCode ? payoutMechanism[0] : null;
        }
        if(data.branch && data.branch.length>40) vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch.slice(0,40)
        else vm.formData.folioCreationRequestCO.bankDetails.bankBranch = data.branch;

        if (data.pennyDropEnabled && vm.summaryDetails.taxStatus === '01') {
          vm.isEnabledOldChequeLeaf = true;
          vm.isEnabledNewChequeLeaf = false;
          vm.isPennydropRequired = true;
        } else {
          vm.isEnabledOldChequeLeaf = true;
          vm.isEnabledNewChequeLeaf = true;
          vm.isPennydropRequired = false;
        }
        pennyDropEnablSelectedBank = vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid;
        resetCheckLeaf('new');
        vm.pennyDropSuccess = false;
      };
      var errorModal = function(e){
      };
      ModalService.IFSCSelectionModal({bankList : vm.bankList}, successModal, errorModal);
    }


    function validatePennyDrop() {
        var pennyDropValidatePayload = {
          beneficiaryIFSC:vm.formData.folioCreationRequestCO.bankDetails.ifsccode,
          benificiaryAccountNo:vm.formData.folioCreationRequestCO.bankDetails.accountNumber,
          benificiaryName:vm.summaryDetails.accountHolderName,
          arncode: vm.summaryDetails.arnCode,
          panNo: vm.summaryDetails.pan,
          secretLink: vm.uniqueLink,
          distributorInitiate: true,
          cobmFlow : true
        };
        var success = function (resp) {
            if (resp.status && resp.data) {
              if(resp.data.valid === false) {
                MessageService.error(resp.data.message);
                vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = false;
                pennyDropEnablSelectedBank = true
                vm.pennyDropSuccess = false;
              }
              else {
                vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
                // vm.formData.bankDetails.accountHolderName = resp.data.name;
                vm.pennyDropSuccess = true;
              }
            } else {
              if(resp.popupEnabled) {
                ModalService.genericModal({
                  text: resp.message
                })
                vm.pennyDropSuccess = false;
              } else {
                MessageService.error(resp.message);
                vm.pennyDropSuccess = false;
              }
            }
            LoaderService.hideLoader();
          },
          error = function (err) {
            $log.info('Occupation Errror>>>>', err);
            LoaderService.hideLoader();
          };
      LoaderService.showLoader();
        InvestorsCommonService.post({
          child1: 'account',
          child2: 'validate',
          child3: 'pennyDrop'
        }, pennyDropValidatePayload).$promise.then(success, error);
    }

    vm.uploadFile = function (file,proofType) {
      if (file) {
        if (vm.mimeType.indexOf(file.type) === -1) {
          MessageService.error("File format not supported. Supported format are tif, tiff, jpg and jpeg'");
          resetCheckLeaf();
          return;
        }
        if (file.size <= 2000000) {
          vm.myFile = file;
          if(proofType == 'old'){
            vm.oldChequeLeaf = file.name;
            vm.isOldCheckLeaf = true;
          } else {
            vm.chequeLeaf = file.name;
            vm.isNewCheckLeaf = true;
          }
          var taxIdentifierNumber = vm.summaryDetails.pan;

          var modalSuccess = function () {
              var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/cobm/'+vm.summaryDetails.arnCode+'/'+taxIdentifierNumber+'/CHEQUE_LEAF';
              // var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION +'/investor/folio/add/document/upload/'+panNumber+'/CHEQUE_LEAF';
              // var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/folio/add/document/upload/' + panNumber + '/CHEQUE_LEAF/investor/' + InvestorModel.getHolderLinkid();
              LoaderService.showLoader();
              FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
                LoaderService.hideLoader();
                if (resp.status && resp.data) {
                  if(proofType == 'new') {
                    vm.formData.folioCreationRequestCO.chequeLeafUrl = resp.data.fileUrl;
                    vm.fileType= getFileType(file.type);
                  } else{
                    vm.formData.folioCreationRequestCO.oldChequeLeafUrl = resp.data.fileUrl;
                    vm.fileTypeold= getFileType(file.type);
                  }

                } else {
                  resetCheckLeaf();
                  MessageService.error(resp.message)
                }
              }, function () {
                resetCheckLeaf();
                LoaderService.hideLoader();
              });
            } ,
            modalError = function () {
              resetCheckLeaf(proofType);
            };

          ModalService.imagePreviewModal({file: file}, modalSuccess, modalError);
        }else{
          resetCheckLeaf();
          MessageService.error("File size should not be more than 2 MB.")
        }
      }
    };

    function resetCheckLeaf(proofType) {
      if(proofType == 'new') {
        vm.formData.folioCreationRequestCO.chequeLeafUrl = "";
        vm.formData.folioCreationRequestCO.chequeLeaf = "";
        vm.chequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
        angular.element("#uploadFileId").val("");
        vm.fileType = "";
      } else {
        vm.formData.folioCreationRequestCO.oldChequeLeafUrl = "";
        vm.formData.folioCreationRequestCO.oldChequeLeaf = "";
        vm.oldChequeLeaf = AppConstants.FILE.NO_FILE_CHOOSEN;
        angular.element("#uploadFileIdOld").val("");
        vm.fileTypeold = ''
      }


    }

    function getFileType(fileType) {
      return fileType.split('/')[1]
    }

    vm.openUploadedDoc = function(chequeLeaf,type) {
      if(type=='new'){
        if(angular.isUndefined(vm.formData.folioCreationRequestCO.chequeLeafUrl)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.formData.folioCreationRequestCO.chequeLeafUrl});
      } else {
        if(angular.isUndefined(vm.formData.folioCreationRequestCO.oldChequeLeafUrl)){return;}
        ModalService.imagePreviewModal({showOnly:true, file: vm.formData.folioCreationRequestCO.oldChequeLeafUrl});
      }

    };

    vm.downloadFile = function(url, fileType, proofType) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            var data = new Blob([resp.data], { type: 'application/'+fileType });
            FileSaver.saveAs(data, proofType+'.'+fileType);
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {};
      DownloadPdfService.download(payload, fileType, url).then(success, error);
    }

    vm.accFocus = function () {
      vm.accModelDirty = true;
      resetCheckLeaf('new');
      vm.pennyDropSuccess = false;
      if (pennyDropEnablSelectedBank) {
        vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid = true;
      }
    };

    function approveDeleteBank() {
      var success = function () {
        var successFolioApprove = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            // $state.go('approval.cobm.approved');
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }, errorFolioApprove = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
        LoaderService.showLoader();
        InvestorsCommonService.post({
          child1: 'cobm',
          child2: 'delete',
          child3: 'approve'
        }, fd).$promise.then(successFolioApprove, errorFolioApprove);
      }, dismiss = function () {

      };
      var msg = "Are you sure, you want to approve<br/> 'Deleting this Bank?'";
      ModalService.rejectionApprovalModal({msg: msg}, success, dismiss);
    }

    function approveCobm(fromState) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          ModalService.genericModal({
            text: resp.data.message
          })
          vm.disabledAfterSuccess = true;
        }
        else {
          MessageService.error(resp.message)
          vm.disabledAfterSuccess = false;
        }
      };
      var error = function (err) {
        LoaderService.hideLoader();
        $log.info(err);
        UtilService.errorHandler(err);
        vm.disabledAfterSuccess = false;
      };
      LoaderService.showLoader();
      var payload = {
        uniqueLink: vm.uniqueLink,
        accountHolderName: vm.summaryDetails.accountHolderName,
        accountNumber: vm.formData.folioCreationRequestCO.bankDetails.accountNumber,
        accountType: vm.formData.folioCreationRequestCO.bankDetails.accountType.accountTypeCode,
        bankBranch: vm.formData.folioCreationRequestCO.bankDetails.bankBranch,
        bankCity: vm.formData.folioCreationRequestCO.bankDetails.bankCity,
        bankName: vm.formData.folioCreationRequestCO.bankDetails.bankName,
        folioNumber: vm.summaryDetails.folioNumber,
        ifsccode: vm.formData.folioCreationRequestCO.bankDetails.ifsccode,
        makeDefaultBank: vm.summaryDetails.cobmAction == "AIPDBM"? true :false,
        newBankProofImage: null,
        newBankProofURL: vm.formData.folioCreationRequestCO.chequeLeafUrl? vm.formData.folioCreationRequestCO.chequeLeafUrl: null,
        oldBankProofImage: null,
        oldBankProofURL: vm.formData.folioCreationRequestCO.oldChequeLeafUrl ? vm.formData.folioCreationRequestCO.oldChequeLeafUrl: null,
        payoutMechanism: vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism && vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism.payoutCode ? vm.formData.folioCreationRequestCO.bankDetails.payoutMechanism.payoutCode: '',
        payoutId:vm.formData.folioCreationRequestCO.bankDetails.payoutId,
        pennyDropValid: vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid,
        approved: true,
        rejectedReason: "",
        arnCode: vm.summaryDetails.arnCode
      }
      if(fromState == 'reject'){
        payload.approved = false;
        payload.rejectedReason = vm.rejectedReason? vm.rejectedReason: '';
      }
      InvestorsCommonService.post({
        child1: 'cobm',
        child2: vm.summaryDetails.cobmAction,
        child3: 'bank',
        child4: 'confirm'
      }, payload).$promise.then(success, error);
    }

    function confirmCancelModaltoRejectDeleteBank() {
      if (!vm.uniqueLink || !vm.summaryType) {
        return;
      }

      var success = function (resp) {
          vm.rejectedReason = resp;
          vm.isApproved = false;
          vm.isActionPerformed = true;
          approveCobm('reject');
        },
        error = function (err) {
          vm.isActionPerformed = false;
          UtilService.errorHandler(err);
        };

      ModalService.rejectBankModal({
        uniqueLink: vm.uniqueLink,
        summaryType: vm.summaryDetails.summaryType
      }, success, error);
    }

    function copyPasteHandler(e) {
      var key = e.keyCode ? e.keyCode : e.which;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false);

      if (key == 86 && ctrl) {
        e.preventDefault();
      } else if (key == 67 && ctrl) {
        e.preventDefault();
      }
    }

    function checkMinorNRITaxStatusCode(){
      if (vm.summaryDetails.taxStatus === '01') {
        vm.isEnabledOldChequeLeaf = true;
        vm.isEnabledNewChequeLeaf = false;
        vm.isPennydropRequired = true;
      } else {
        vm.isEnabledOldChequeLeaf = true;
        vm.isEnabledNewChequeLeaf = true;
        vm.isPennydropRequired = false;
      }
      pennyDropEnablSelectedBank = vm.formData.folioCreationRequestCO.bankDetails.pennyDropValid;
    }

    vm.showCobmTermConditions = function () {
      ModalService.nonTransactionalTncModal({});
    };

  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .config(addInverstorRoute);

  /** @ngInject */
  function addInverstorRoute($stateProvider) {
    $stateProvider
      // .state('summaryApproval', {
      //   url: '/summaryApproval',
      //   templateUrl: 'app/investors/cobmApprovalSummary/cobmSummary.html',
      //   authenticate: false
      // })
      .state('cobmSummary', {
        url: '/summary/initiate/cobm/:uniqueLink?version',
        templateUrl: 'app/investors/cobmApprovalSummary/cobmSummary.html',
        controller: 'CobmApprovalSummaryController',
        controllerAs: 'CobmApprovalSummary',
        authenticate: false,
        loginType: 'D',
        resolve : { dynamicData: _fetchDynamicDataAddBank }
      })

  }

  /** @ngInject */
  function _checkValidHolder($stateParams, $q, MessageService, InvestorModel, InvestorsService, UtilService) {
    if (!$stateParams.uuid) {
      UtilService.errorHandler('Not a valid link');
      return;
    } else {
      var deferred = $q.defer(),
        success = function (resp) {
          if (resp.status && resp.data) {
            InvestorModel.setInvestorModel(resp.data);
            deferred.resolve(true);
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp.message);
          }
        }, error = function (err) {
          MessageService.error('An unauthorized access');
          deferred.reject(err);
        };
      InvestorsService.post({
        controller: 'new',
        child1: 'folio',
        child2: 'joint',
        child3: 'holder',
        child4: 'data'
      }, {linkId: $stateParams.uuid}).$promise.then(success, error);
      return deferred.promise;
    }
  }

  /** @ngInject */
  function _checkValidLink($stateParams, $q, MessageService, InvestorModel, InvestorsCommonService, UtilService) {
    var investorId = InvestorModel.getInvestorId();
    if (!$stateParams.uuid) {
      UtilService.errorHandler('Not a valid link');
      return;
    } else if (!investorId) {
      var deferred = $q.defer(),
        success = function (resp) {
          if (resp.status && resp.data) {
            var _id = resp.data.id;
            InvestorModel.setInvestorId(_id);
            deferred.resolve(true);
          } else {
            MessageService.error(resp.message);
            deferred.reject(resp.message);
          }
        }, error = function (err) {
          MessageService.error('An unauthorized access');
          deferred.reject(err);
        },
        payload = {
          id: $stateParams.uuid
        };
      InvestorsCommonService.post({
        child1: 'link',
        child2: 'status'
      }, payload).$promise.then(success, error);

      return deferred.promise;
    } else {
      UtilService.errorHandler();
      return;
    }
  }
  function _fetchDynamicDataAddBank(UtilService) {
    return UtilService.fetchDynamicData('ADD_NEW_BANK');
  }
})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('InvestorModel', investorModel);

  /** @ngInject */
  function investorModel() {

    var masterPayload = {
        "folioCreationRequestCO": {
          "holdMode": "SINGLE",
          "bankDetails": {
            "accountHolderName":"",
            "accountNumber": "",
            "accountType": "",
            "bankName": "",
            "bankBranch": "",
            "branchLocation": "",
            "ifsccode": "",
            "micrnumber": "",
            "verifyAccountNumber": "",
            "payoutMechanism": "",
            "mobileNumber":"",
            "email":"",
            "throughPennyDrop":true
          },
          "jointHolders": [],
          "nominees": [],
          "soleApplicantDetail": {
            "birthCity": "",
            "birthCountry": "",
            "minorName": "", //dummy Indrazeet Singh
            "dob": null, //dummy 31-Dec-1978,
            "email": "",
            "mobileNo": "",
            "minor": false, //dummy
            "fatcaAddressType": "",
            "grossAnnualIncome": '',
            "netWorth": '',
            "netWorthDate": "",
            "occupation": "",
            "panNumber": "", //dummy BDKPS1141N
            "payOutsideIndiaAddresses": [],
            "payTaxInIndia": true,
            "politicalStatus": "NONE",
            "taxStatusCode": ""
          },
          "nriFlag": null,
          "nomineeRegistrationCO":{
            "accountHoldingDeclaration":"NOMINATION_YES",
            "incapacitationDeclaration":{
              "percentage":'',
              "amount":'',
              "nomineeName": '',
              "nomineeNumber":''
            }
          },
          "incapacitationDeclarationNameList":null,
          "incapacitationNameList":[]
        },
        "sip":null,
        "lumpsum": {
          "amount": "",
          "dividendOption": "Y",
          "schemeCode": "",
          "isOptional":false
        },
        "toPanVerify": true
      },
      guardianDetailsPayload = {
        "basicDetails": {
          "birthCity": "",
          "birthCountry": "",
          "state":null,
          "name": "",
          "dob": null,
          "minor": false,
          "fatcaAddressType": "",
          "grossAnnualIncome": "",
          "netWorth": "",
          "netWorthDate": "",
          "occupation": "",
          "panNumber": "",
          "payOutsideIndiaAddresses": [],
          "payTaxInIndia": true,
          "politicalStatus": "NONE",
          "taxStatusCode": ""
        },
        "citizenship": "",
        "kycStatus": true,
        "relationship": ""
      },

      jointHolderMasterPayload = {
        "citizenship": "",
        "email": "",
        "jointHolderApplicantDetail": {
          "birthCity": "",
          "birthCountry": "",
          "dob": null,
          "fatcaAddressType": "",
          "grossAnnualIncome": "",
          "netWorth": "",
          "netWorthDate": "",
          "occupation": "",
          "panNumber": "",
          "payOutsideIndiaAddresses": [],
          "payTaxInIndia": true,
          "politicalStatus": "NONE",
          "taxStatusCode": ""
        },
        "jointHolderName": "",
        "KYCVerified": true,
        "nriFlag": null
      },
      nomineeMasterPayload = {
        "dob": "",
        "guardianName": "",
        "guardianPan":null,
        "guardianRelation":null,
        "percentage": "",
        "minor":false,
        "nomineeAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3":"",
          "city": "",
          "state":"",
          "country": "",
          "pinCode": ""
        },
        "guardianAddress": {
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3":"",
          "city": "",
          "state":"",
          "country": "",
          "pinCode": ""
        },
        "nomineeName": "",
        "nomineePan":"",
        "nomineePanInvalid":false,
        "nomineeRelation": "",
        "guardianPanInvalid":false,
        "verifiedPan":true,
        "soleAddressApplicable":false
      },
      payOutsideMasterPayload = {
        "countryName": "",
        "taxIdNumber": "",
        "taxIdType": ""
      },
      sip={
        "dividendOption": "Y",
        "frequency": "",
        "installmentAmount": "",
        "investmentOption": "",
        "numberOfInstallment": "",
        "schemeCode": "",
        "sipDate":"",
        "sipDay": "",
        "toDate": "",
        "isOptional":false
      },

      reviewData={
        taxStatusDescription:"",
        occupationDescription:"",
        incomeDescription:"",
        accountType:"",
        payoutMechanism: "",
        holders:[{},{}]
      },
      newInvestor = null,
      investorId = null,
      holderLinkId = null,
      soleApplicantDataChanged = false,
      nomineeDataChanged = false,
      bankDataChanged = false,
      folioCreationFromProfileAndToDo = false,
      documentChange=false,
      filterPayload = {},
      /*tabEnable={
       "tab1":true,
       "tab2":true,
       "tab3":true,
       "tab4":true,
       "tabJointHolderAddable":true,
       "tabGuardianDetailShow":true
       };*/
      tabEnable={
        "tab1":false,
        "tab2":false,
        "tab3":false,
        "tab4":false,
        "tabJointHolderAddable":false,
        "tabGuardianDetailShow":false
      },
      folioScreenApi = {
        "responseDataStore": {}
      },addBankPayload = {
        "folioCreationRequestCO": {
          "bankDetails": {
            "accountHolderName": "",
            "accountNumber": "",
            "accountType": "",
            "bankName": "",
            "bankBranch": "",
            "branchLocation": "",
            "ifsccode": "",
            "micrnumber": "",
            "verifyAccountNumber": "",
            "payoutMechanism": "",
            "mobileNumber": "",
            "email": "",
            "throughPennyDrop": true
          }
        },
      },
      folioScreen = {
        "appdetailsTab": false,
        "guardianDetailsTab": false,
        "jointholdersTab": false,
        "nomineeTab": false,
        "responseDataStorage": {}
      };

    function getTab() {
      return angular.copy(tabEnable);
    }

    function setTab(_tabEnable) {
      if(_tabEnable.tab1 != undefined){
        tabEnable.tab1=_tabEnable.tab1;
      }
      if(_tabEnable.tab2 != undefined){
        tabEnable.tab2=_tabEnable.tab2;
      }
      if(_tabEnable.tab3 != undefined){
        tabEnable.tab3=_tabEnable.tab3;
      }
      if(_tabEnable.tab4 != undefined){
        tabEnable.tab4=_tabEnable.tab4;
      }
      if(_tabEnable.tabJointHolderAddable != undefined){
        tabEnable.tabJointHolderAddable=_tabEnable.tabJointHolderAddable;
      }
      if(_tabEnable.tabGuardianDetailShow != undefined){
        tabEnable.tabGuardianDetailShow=_tabEnable.tabGuardianDetailShow;
      }
    }

    function resetTab() {
      tabEnable={"tab1":false,"tab2":false,"tab3":false};
    }

    function getSip() {
      return angular.copy(sip);
    }

    function setSip(_sip) {
      masterPayload.sip=_sip;
    }

    function getNewJointHolder() {
      return angular.copy(jointHolderMasterPayload);
    }

    function getNewNominee() {
      return angular.copy(nomineeMasterPayload);
    }

    function getNewGuardianDetails() {
      return angular.copy(guardianDetailsPayload);
    }

    function getNewPayOutsideModel() {
      return angular.copy(payOutsideMasterPayload);
    }

    function getNewInvestorModel() {
      return angular.copy(masterPayload);
    }

    function getInvestorModel() {
      return angular.copy(newInvestor);
    }
    function setInvestorModel(_newInvestor) {
      newInvestor = _newInvestor;
    }
    function setInvestorId(_investorId) {
      investorId = _investorId;
    }
    function getInvestorId() {
      return angular.copy(investorId);
    }
    function setSoleApplicantDataChanged(_soleApplicantDataChanged) {
      soleApplicantDataChanged = _soleApplicantDataChanged;
    }
    function setNomineeDataChanged(_nomineeDataChanged) {
      nomineeDataChanged = _nomineeDataChanged;
    }
    function setBankDataChanged(_bankDataChanged) {
      bankDataChanged = _bankDataChanged;
    }
    function getSoleApplicantDataChanged() {
      return soleApplicantDataChanged;
    }
    function getNomineeDataChanged() {
      return nomineeDataChanged;
    }
    function getBankDataChanged() {
      return bankDataChanged;
    }
    function setFolioCreationFromProfileAndToDo(_folioCreationFromProfileAndToDo) {
      folioCreationFromProfileAndToDo = _folioCreationFromProfileAndToDo;
    }
    function isFolioCreationFromProfileAndToDo() {
      return folioCreationFromProfileAndToDo;
    }
    function setDocumentChange(_documentChanged) {
      documentChange=_documentChanged
    }
    function  getDocumentChange() {
      return documentChange;
    }

    function setReviewModalData(data) {
      reviewData=data;
    }
    function getReviewModalData() {
      return angular.copy(reviewData);
    }
    function resetReviewModalData() {
      reviewData={
        taxStatusDescription:"",
        occupationDescription:"",
        incomeDescription:"",
        accountType:"",
        payoutMechanism: ""
      };
    }

    function resetInvestorModel() {
      newInvestor = null;
      investorId = null;
      soleApplicantDataChanged = false;
      nomineeDataChanged = false;
      bankDataChanged = false;
      folioCreationFromProfileAndToDo = false;
    }

    function setFilterPayload(payload) {
      filterPayload = payload;
    }

    function getFilterPayload() {
      return filterPayload
    }

    function _setHolderLinkId(id) {
      holderLinkId = id;
    }

    function _getHolderLinkId() {
      return holderLinkId;
    }

    function getInvestorResponse() {
      return angular.copy(folioScreenApi);
    }

    function setInvestorResponse(_folioScreenApi) {
      if(_folioScreenApi != undefined){
        folioScreenApi = _folioScreenApi
      }
    }

    function setAddToBankPayload(payload){
      addBankPayload = payload;
    }

    function getAddToBankPayload(){
      return addBankPayload;
    }

    function getInvestorFolioModal() {
      return angular.copy(folioScreen);
    }

    function setInvestorFolioModal(_folioScreen) {
      if(_folioScreen.appdetailsTab != undefined){
        folioScreen.appdetailsTab=_folioScreen.appdetailsTab;
      }
      if(_folioScreen.guardianDetailsTab != undefined){
        folioScreen.guardianDetailsTab = _folioScreen.guardianDetailsTab;
      }
      if(_folioScreen.jointholdersTab != undefined){
        folioScreen.jointholdersTab = _folioScreen.jointholdersTab;
      }
      if(_folioScreen.nomineeTab != undefined){
        folioScreen.nomineeTab = _folioScreen.nomineeTab;
      }
      if(_folioScreen.responseDataStorage != undefined){
        folioScreen.responseDataStorage = _folioScreen.responseDataStorage
      }
    }
    function resetFolioModalTab() {
      folioScreen = {
        "appdetailsTab":false,
        "guardianDetailsTab":false,
        "jointholdersTab":false,
        "nomineeTab": false,
        "responseDataStorage": {}
      };
    }

    return {
      getNewInvestorModel: getNewInvestorModel,
      getNewJointHolder: getNewJointHolder,
      getNewNominee: getNewNominee,
      getNewGuardianDetails : getNewGuardianDetails,
      getNewPayOutsideModel: getNewPayOutsideModel,
      getInvestorModel: getInvestorModel,
      setInvestorModel: setInvestorModel,
      getInvestorId: getInvestorId,
      setInvestorId: setInvestorId,
      resetInvestorModel: resetInvestorModel,
      getSip:getSip,
      setSip:setSip,
      getTab:getTab,
      setTab:setTab,
      resetTab:resetTab,
      setSoleApplicantDataChanged:setSoleApplicantDataChanged,
      getSoleApplicantDataChanged:getSoleApplicantDataChanged,
      setNomineeDataChanged:setNomineeDataChanged,
      getNomineeDataChanged:getNomineeDataChanged,
      setBankDataChanged:setBankDataChanged,
      getBankDataChanged:getBankDataChanged,
      setDocumentChange:setDocumentChange,
      getDocumentChange:getDocumentChange,
      isFolioCreationFromProfileAndToDo: isFolioCreationFromProfileAndToDo,
      setFolioCreationFromProfileAndToDo: setFolioCreationFromProfileAndToDo,
      setReviewModalData:setReviewModalData,
      getReviewModalData:getReviewModalData,
      resetReviewModalData:resetReviewModalData,
      setFilterPayload: setFilterPayload,
      getFilterPayload: getFilterPayload,
      setHolderlinkId: _setHolderLinkId,
      getHolderLinkid: _getHolderLinkId,
      getInvestorResponse: getInvestorResponse,
      setInvestorResponse: setInvestorResponse,
      setAddToBankPayload: setAddToBankPayload,
      getAddToBankPayload: getAddToBankPayload,
      getInvestorFolioModal: getInvestorFolioModal,
      setInvestorFolioModal: setInvestorFolioModal,
      resetFolioModalTab: resetFolioModalTab
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('investorFolioTab', investorFolioTab);

  /** @ngInject */
  function investorFolioTab(){
    return {
      template : '<ul class="mobile-hide nav nav-tabs"> ' +
      '<li ui-sref-active="active"><a ui-sref="main.investors.add.appdetails">Sole Applicant Details</a></li>' +
      '<li ui-sref-active="active">' +
      '<a ui-sref="main.investors.add.nominee" style="display:none;"></a>' +
      '<a ui-sref="main.investors.add.nominee" >Nominee Details</a>' +
      '</li>' +
      '<li ui-sref-active="active">' +
      '<a ui-sref="main.investors.add.jointholders" style="display:none;"></a>' +
      '<a  ui-sref="main.investors.add.jointholders"><i class="expand-icon"></i>Add Joint Holder</a>' +
      '</li>' +
      '</ul>'
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .config(addInverstorRoute);

  /** @ngInject */
  function addInverstorRoute($stateProvider) {
    $stateProvider
      .state('main.investors.add', {
        url: '/add',
        templateUrl: 'app/investors/add/add.html',
        controller: 'InvestorsAddController',
        controllerAs: 'InvestorsAdd',
        authenticate: false,
        //defaultRoute: '.appdetails',
        resolve : {
          dynamicData : _fetchDynamicDataCreateFolio
        }
      })
      .state('main.investors.add.holdmode', {
        url: '/hold-mode',
        templateUrl: 'app/investors/add/folio/add.holdmode.html',
        controller: 'InvestorsAddController',
        controllerAs: 'Holdmode',
        authenticate: false
      })
      .state('main.investors.add.appdetails', {
        url: '/app-details',
        templateUrl: 'app/investors/add/folio/add.app-details.html',
        controller: 'InvestorsAddController',
        controllerAs: 'AppDetails',
        authenticate: false
      })
      .state('main.investors.add.jointholders', {
        url: '/joint-holders',
        templateUrl: 'app/investors/add/folio/add.joint-holders.html',
        controller: 'InvestorsAddController',
        controllerAs: 'JointHolders',
        authenticate: false,
        resolve: {
          jhPANDetails: ['$q', '$state', '$timeout','$window', 'MessageService', 'InvestorModel', 'ModalService',
            function ($q, $state, $timeout,$window, MessageService, InvestorModel, ModalService) {
              var deferred = $q.defer(),
                model = angular.fromJson($window.sessionStorage.investorForm) || InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel(),
                successPanDetails = function (result) {
                  if (result.data && result.data.kycverified) {

                    /*Check repeated pan number*/
                    if (
                      model.folioCreationRequestCO.soleApplicantDetail.panNumber
                      && model.folioCreationRequestCO.soleApplicantDetail.panNumber != result.data.pan
                    ) {

                      var newModel = InvestorModel.getNewJointHolder();
                      model.folioCreationRequestCO.jointHolders[0] = newModel;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderName = result.data.name;
                      model.folioCreationRequestCO.jointHolders[0].email = result.data.email;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.panNumber = result.data.pan;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.minor = result.data.minor;
                      model.folioCreationRequestCO.jointHolders[0].mobileNo = result.data.mobileNoWithoutMask;
                      model.folioCreationRequestCO.jointHolders[0].nriFlag = !result.data.taxStatusResident;
                      InvestorModel.setInvestorModel(model);
                      $window.sessionStorage.investorForm = angular.toJson(model);
                      InvestorModel.setTab({tab3: true});
                      deferred.resolve();

                    } else {

                      MessageService.error("Valid PAN details required to add joint holder");
                      $timeout(function () {
                        $state.go('main.investors.add.appdetails');
                      });
                      deferred.reject();
                    }
                  }
                },
                errorPanDetails = function () {
                  // MessageService.error("Valid PAN details required to add joint holder");
                  $timeout(function () {
                    $state.go('main.investors.add.appdetails');
                  });
                  deferred.reject();
                };

              if (model.folioCreationRequestCO.jointHolders
                && model.folioCreationRequestCO.jointHolders.length == 0
              ) {
                var labelSetter = {
                  type: 'jointholders',
                  label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}
                };
                ModalService.checkPanJointHolder(labelSetter, successPanDetails, errorPanDetails);
              } else {
                deferred.resolve();
              }

              return deferred.promise;
            }]
        }
      })

      .state('main.investors.add.guardianDetails', {
        url: '/guardian-details',
        templateUrl: 'app/investors/add/folio/add.guardian-details.html',
        controller: 'InvestorsAddController',
        controllerAs: 'GuardianDetails',
        authenticate: false,
        resolve: {
          gdPANDetails: ['$q', '$state', 'MessageService', 'InvestorModel', 'ModalService', 'UtilService',
            function ($q, $state, MessageService, InvestorModel, ModalService, UtilService) {
              var deferred = $q.defer(),
                model = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel(),
                successPanDetails = function (result) {
                  if (result.status && result.data && result.data.kycverified) {
                    var guardianModel = InvestorModel.getNewGuardianDetails();
                    model.folioCreationRequestCO.guardianDetails = guardianModel;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.dob = result.data.dob;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber = result.data.pan;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.kycStatus = true;
                    InvestorModel.setInvestorModel(model);
                    InvestorModel.setTab({tab4: true});
                    deferred.resolve();
                  } else {
                    UtilService.errorHandler(result);
                    $state.go('main.investors.add.appdetails');
                    deferred.reject();
                  }
                },
                errorPanDetails = function (err) {
                  UtilService.errorHandler(err);
                  $state.go('main.investors.add.appdetails');
                  deferred.reject();
                };

              if (model.folioCreationRequestCO.guardianDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber
                && model.folioCreationRequestCO.guardianDetails.basicDetails.dob
              ) {
                deferred.resolve();
              }
              else {
                var labelSetter = {
                  type: 'guardianDetails',
                  label: {header: 'ADD GUARDIAN DETAILS', pan: 'PAN', dob: 'Guardian DOB'}
                }
                ModalService.checkPanModal(labelSetter, successPanDetails, errorPanDetails);
              }

              return deferred.promise;
            }]
        }
      })
      .state('main.investors.add.nominee', {
        url: '/nominee',
        templateUrl: 'app/investors/add/folio/add.nominee.html',
        controller: 'InvestorsAddController',
        controllerAs: 'Nominee',
        authenticate: false
      })
      .state('main.investors.add.scheme', {
        url: '/scheme',
        templateUrl: 'app/investors/add/scheme/add.investor.scheme.html',
        controller: 'InvestorsAddSchemeController',
        controllerAs: 'Scheme',
        authenticate: false
      })
      .state('main.investors.add.bankdetails', {
        url: '/bank-details?fromFolioReview',
        templateUrl: 'app/investors/add/payment/add.payment.html',
        controller: 'InvestorsAddPaymentController',
        controllerAs: 'Payment',
        authenticate: false,
        resolve : {
          dynamicData : _fetchDynamicDataCreateFolio
        }
      })
      .state('main.investors.review', {
        url: '/review',
        templateUrl: 'app/investors/add/review/add.review.html',
        controller: 'InvestorsAddReviewController',
        controllerAs: 'Review',
        authenticate: false
      })


      /** @ngInject */
      function _fetchDynamicDataCreateFolio(UtilService) {
        return UtilService.fetchDynamicData("FOLIO_CREATION")
      }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EcartReviewController', ecartReviewController);

  /** @ngInject */
  function ecartReviewController($stateParams, LoaderService,$window, TransactionInitiateModel, UtilService, ModalService, HDFC_API,
                                 AppConstants, $timeout, TransactionService, InvestorsService, MessageService,
                                 panAdharLinkingService, BillJunctionService,  $scope ,FetchDynamicDataEcart, InvestorCommonServiceVersion1 , $state) {
    var vm = this;
    vm.formData = TransactionInitiateModel.getPayload() || TransactionInitiateModel.getSipPurchaseDataModel();
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.investorUUID = $stateParams.uuid;
    vm.PAYMENT_MODE = angular.copy(AppConstants.PAYMENT_MODE);
    vm.SIP_PAYMENT_MODE = AppConstants.SIP_PAYMENT_MODE;
    vm.TRANSACTION_FORM_TYPE = AppConstants.TRANSACTION_FORM_TYPE;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.dataAfterInitiateCart = JSON.parse($window.sessionStorage.getItem('cartDetails'));
    vm.maxMandateDurationYears = (vm.dataAfterInitiateCart.sipSettings && vm.dataAfterInitiateCart.sipSettings.eOTM.maxMandateDurationYears) ? vm.dataAfterInitiateCart.sipSettings.eOTM.maxMandateDurationYears: vm.dataAfterInitiateCart.maxMandateDurationYears? vm.dataAfterInitiateCart.maxMandateDurationYears : AppConstants.EMANDATE_MAX_DURATION_YEARS;
    vm.cartItemList = [];
    vm.cartItemAfterInitiate = {};
    vm.cartDetails = {};
    vm.checkFolio = false;
    vm.hideOtmRadio = false;
    vm.selectedFrequency = 'OM';
    vm.SIP_FREQ_LIST = AppConstants.Dynamic_SIP_FREQ_LIST;
    vm.startDateValidation = false;
    vm.isEmailinValid = false;
    vm.isMobileinValid = false;
    vm.isEmailMobileinValid = false;
    vm.emandateDisplay = true;
    vm.showTerms = true;
    vm.modalDataPurchase = FetchDynamicDataEcart;
    vm.modalDataSip = FetchDynamicDataEcart;
    vm.cartDetails.cartItems = vm.cartItemList;
    vm.paymentNavURL = HDFC_API.PAYMENT_NAV_URL;
    vm.paymentNavUrl = function ($event) {
      $event.preventDefault();
      $window.open(vm.paymentNavURL);
    };
    vm.getEuinCodes = getEuinCodes;
    vm.fetchFolioList = fetchFolioList;
    vm.getOtmBankList = getOtmBankList;
    vm.getInvestorInfo = getInvestorInfo;
    vm.moveToPayment = moveToPayment;
    vm.utilService  = UtilService;
    vm.showPopupScreen = showPopupScreen;
    vm.removeCartItem = removeCartItem;
    vm.termsAndContitions = termsAndContitions;
    vm.getCartItems = getCartItems;
    vm.toCheckIsRetirementOrMinorScheme = toCheckIsRetirementOrMinorScheme;
    vm.dynamicNoteReview = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_Review;
    vm.dynamicNoteNetBanking = vm.modalDataPurchase.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.dynamicNoteStandard = vm.modalDataSip.noteDTO.noteDTOMap.Note_Sip_Ecart_Review;
    vm.dynamicNoteEotm = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_Review_eOTM;
    vm.dynamicNoteOtmSip = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_Review_OTM;
    vm.dynamicNoteEotmDebitCard = vm.modalDataSip.noteDTO.noteDTOMap.Note_SIP_Review_eOTM_Debit_Card;

    vm.dynamicNoteMixNetBanking = vm.modalDataSip.noteDTO.noteDTOMap.Note_Purchase_Net_Banking;
    vm.dynamicNoteMixOTM = vm.modalDataSip.noteDTO.noteDTOMap.Note_Mix_OTM_Review;

    vm.checkEcartItemValidations = checkEcartItemValidations;
    vm.cartError = false;
    vm.investmentArray = AppConstants.ECART_CART_ITEM_NUMBER;
    vm.validations = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.formData.isExceedingEmandateDate = false;
    vm.isInValidFolio = false;
    vm.emandateMinAmountLimit = null;
    vm.checkAmountValidationEmandate = checkAmountValidationEmandate;
    vm.amountLess = false;
    vm.amountMore = false;
    vm.isLessThanSipAmount = false;
    vm.sipDateLessEmandate = false;
    vm.changeEndDateEmandate = changeEndDateEmandate;
    vm.formData.emandateWord = {};
    vm.currentDate =  $window.moment(Date());
    vm.init = init();
    vm.maxItemAllowed = parseInt($window.sessionStorage.getItem('maximumItemAllowed'));

    function init(){
      getEuinCodes();
      getCartItems('initial');
      getInvestorInfo(function(resp){
        if (resp) {
          $timeout(function() {
            vm.changeFolio();
          }, 0);
        }
      })
    }

    function getEuinCodes() {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.euinList = resp.data.euinList;
          vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
          vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
        } else {
          vm.euinList = null;
        }
      }, error = function () {
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionService.get({VERSION: HDFC_API.VERSION, controller: 'getEuin'}).$promise.then(success, error);
    }

    vm.euinChanged = function () {
      var filterEuin = vm.euinList.filter(function (euin) {
        return euin.euinCode == vm.formData.euinCode;
      })[0]
      vm.formData.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinName = filterEuin ? filterEuin.euinName : '';
      vm.euinNameSelected = vm.formData.euinName;
    };

    function fetchFolioList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          // var isChildFolios = false;
          // var isRetirementFolios = false;
          // //checking children fund
          // vm.cartItemList.forEach(function(item,index){
          //   if(item.fundCode == "HDFCGF"){
          //     isChildFolios = true;
          //   }
          // });
          // //checking Retirement fund
          // vm.cartItemList.forEach(function(item,index){
          //   if(item.fundCode == "HDFCRETHDP" || item.fundCode == "HDFCRETEQP" || item.fundCode == "HDFCRETHEP"){
          //     isRetirementFolios = true;
          //   }
          // });
          //
          // if(isChildFolios && !isRetirementFolios) {
          //   var filteredFolios = resp.data.folioList.filter(function (folio) {
          //     return folio.minorFlag == true;
          //   });
          // } else if(!isChildFolios && isRetirementFolios){
          //   var filteredFolios = resp.data.folioList.filter(function (folio) {
          //     return folio.minorFlag == false;
          //   });
          // }
          // vm.folioList = filteredFolios ? filteredFolios: resp.data.folioList || [];
          vm.folioList = resp.data.folioList || [];
          // if (vm.cartDetails && vm.cartDetails.cartItems.length > 0 && vm.cartDetails.cartItems[0].folioNumber) {
          //   vm.folioNumber = vm.cartDetails.cartItems[0].folioNumber;
          // } else {
            var activeFolioList = vm.folioList.filter(function(folio){
              return folio.activeFlag === true;
            });
            if(vm.formData.folioNumber){
              vm.folioNumber = vm.formData.folioNumber;
            } else {
              vm.folioNumber = activeFolioList.length > 0 && activeFolioList[0].folioNumber ? activeFolioList[0].folioNumber : null;
            }
          // }
          vm.formData.folioNumber = vm.folioNumber;
          if(vm.formData.folioNumber){
            $timeout(function() {
              vm.changeFolio();
            }, 0);
          }
        } else {
          vm.folioList = null;
          vm.folioNumber = '';
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        vm.folioList = null;
        vm.folioNumber = '';
        UtilService.errorHandler(err);
      };

      InvestorsService.post({controller: 'folioList'}, {investorUUID: vm.investorUUID}).$promise.then(success, error);
    }


    vm.changeFolio = function () {
      if (!vm.formData.folioNumber) {
        vm.checkFolio=true;
        return;
      }
      vm.formData.folioNumber = vm.formData.folioNumber || vm.folioNumber;
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.hasFolioEmailId = !!resp.data.emailId;
          vm.emailId = resp.data.emailId;
          vm.mobileNumber = resp.data.mobileNumber;
          vm.investorInfo.name = resp.data && resp.data.folioHolderName ? resp.data.folioHolderName : vm.investorInfo.name;
          emailMobileValidation();
          vm.cartError = false;
          vm.cartDetails.errorExists = false;
          vm.cartDetails.message = '';
          if (vm.cartItemList && vm.cartItemList.length > 0) {
            vm.cartItemList.forEach(function(item) {
              item.errorExists = false;
              item.message = null;
            });
          }
          vm.getOtmBankList(function () {
            vm.getEmandateBankList(function () {
              setPaymentModes();
            });
          });
          toCheckIsRetirementOrMinorScheme();
        } else {
          vm.hasFolioEmailId = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.hasFolioEmailId = false;
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();

      var successHandler = function(resp) {
        var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
          return row.folioNumber == vm.formData.folioNumber
        })[0];
        vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;
        vm.selectedFolioData = selectedFolioObj;
        resetSubBrokerDetails();
        LoaderService.showLoader();
        InvestorsService.post({
          controller: 'folio',
          child1: 'contact-details'
        }, {
          folioNumber: vm.formData.folioNumber
        }).$promise.then(success, error);
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);
    };


    function getOtmBankList(cb) {// function to fetch otm registered bank w.r.t selected folio
      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.otmResp = resp.data;
            if (angular.isArray(resp.data.folioBankDetailsList) && resp.data.folioBankDetailsList.length > 0) {
              vm.otmBankList = resp.data.folioBankDetailsList;
              vm.hideOtmRadio = false;

            }
            else{
              vm.otmBankList  = [];
              vm.hideOtmRadio = true;
              vm.formData.paymentMode = vm.PAYMENT_MODE[0];
              vm.isOtmLimitLess = false;
            }
            cb(true);
          } else {
            vm.otmBankList = null;
            vm.hideOtmRadio = true;
            vm.formData.paymentMode = vm.PAYMENT_MODE[0];
            cb(false);
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.otmBankList = null;
          vm.hideOtmRadio = true;
          vm.formData.paymentMode = vm.PAYMENT_MODE[0];
          cb(false);
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'otm',
        child2: 'banks'
      }, {folioNumber: vm.formData.folioNumber,pan: vm.investorInfo.panNumber}).$promise.then(success, error);
    };

    function getInvestorInfo(cb) {
      var payload = {"investorUUID": vm.investorUUID};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          vm.corporateFlag = vm.investorInfo.corporateFlag;
          cb(true);
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }

    function checkTransactionType(){
      var tncArray = [];
      var investmentType = '';
      vm.cartDetails.cartItems.forEach(function (el, index) {

        if (el.sipOpted && el.purchaseOpted) {
          investmentType = 'SIPPURCHASE';
          return;
        }
        if (el.sipOpted && !el.purchaseOpted) {
          tncArray.push('SIP');
        }
        if (!el.sipOpted && el.purchaseOpted) {
          tncArray.push('PURCHASE');
        }
      });

      if (!investmentType) {
        var sipInstanceArr = tncArray.filter(function (el) {
          return el === 'SIP'
        });

        var purchaseInstanceArr = tncArray.filter(function (el) {
          return el === 'PURCHASE'
        });


        if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length >= 1) {
          investmentType = 'SIPPURCHASE';
        } else if (sipInstanceArr.length === 0 && purchaseInstanceArr.length >= 1) {
          investmentType = 'PURCHASE';
        } else if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length === 0) {
          investmentType = 'SIP';
        }

      }
      return investmentType;
    }

    function setPaymentModes(){
      if (vm.formData.investmentType) {
        if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
          if(vm.formData.schemeType && vm.formData.schemeType.toUpperCase() == 'LIQUID' || (vm.formData.schemeTypeLiquid))
          {
            vm.PAYMENT_MODE = [
              {key: 'WEB', value: 'Net Banking'}
            ];
          }
          else
          {
            vm.PAYMENT_MODE = [
              {key: 'WEB', value: 'Net Banking'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          }
        } else if(vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP){
          if(vm.selectedFrequency){
            vm.PAYMENT_MODE= [
              {key: 'EC',  value: 'Standing Instruction/Biller'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'},
              {key: 'HEM', value: 'Register E-mandate (eOTM)'}
            ];
          }
        } else {
          if((vm.formData.schemeType && vm.formData.schemeType.toUpperCase() == 'LIQUID') || (vm.formData.schemeTypeLiquid))
          {
            vm.PAYMENT_MODE = [
              {key: 'WEB', value: 'Net Banking/Biller'}
            ];
          } else {
            vm.PAYMENT_MODE = [
              {key: 'WEB', value: 'Net Banking/Biller'},
              {key: 'OTM', value: 'OTM(One Time Mandate)'}
            ];
          }
        }
      }
      vm.formData.paymentMode = vm.PAYMENT_MODE[0];
      // vm.PAYMENT_MODE[i].key.includes("HEM")
      if (angular.isArray(vm.otmBankList ) && vm.otmBankList.length == 0 ){
        vm.PAYMENT_MODE = vm.PAYMENT_MODE.filter(function(item,index){
          return item.key !== 'OTM'
        })
      }

      if (angular.isArray(vm.eMandateBankList ) && vm.eMandateBankList.length == 0 ){
        vm.PAYMENT_MODE = vm.PAYMENT_MODE.filter(function(item,index){
          return item.key !== 'HEM'
        })
      }
      if(vm.formData.isExceedingEmandateDate || vm.formData.minorFlag ){
        var isEmandate = vm.PAYMENT_MODE.find(function(el) {
          return el.key == 'HEM'
        });
        if(isEmandate && isEmandate.key == 'HEM'){
          var paymentIndex = vm.PAYMENT_MODE.findIndex(function(ele){
            return ele.key == vm.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM;
          });
          if (paymentIndex !== -1) {
            vm.PAYMENT_MODE.splice(paymentIndex, 1);
          }
        }
      }

      vm.otmLimitvalidation = false;
      vm.formData.otmBank=null;
      vm.endDateValidation = false;
      vm.formData.upiBank=null;
      vm.startDateValidation = false;
      vm.formData.eMandateBank = null;
      vm.authMode = null;
    }

    vm.changePaymentMode = function () { // function to set and check otm details on change of payment mode
      if (vm.formData.paymentMode && vm.formData.paymentMode.key === 'OTM') {
          vm.formData.otmBank=null;
          vm.changeOtmbank();
      }
      else {
        vm.otmLimitvalidation = false;
        vm.formData.otmBank=null;
        vm.endDateValidation = false;
        vm.formData.upiBank=null;
        vm.startDateValidation = false;
        vm.showEmandateError = false;
        vm.minAmountLimitError = false;
        if ((vm.eMandateBankList && ((vm.eMandateBankList.length > 1) || (vm.eMandateBankList.length === 0))) || !vm.eMandateBankList) {
          vm.formData.eMandateBank = null;
          vm.authMode = null;
        } else if (vm.eMandateBankList && vm.eMandateBankList.length === 1){
          vm.formData.eMandateBank = vm.eMandateBankList[0];
          vm.changeEMandateBank();
        }
      }
      vm.amountLess = false;
      vm.amountMore = false;
      vm.isLessThanSipAmount = false;
      vm.sipDateLessEmandate = false;
      if (vm.emandateValidationData) {
        vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
        vm.formData.emandateWord = {};
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
        checkAmountValidationEmandate();
      }

      if(vm.formData.paymentMode.key == 'HEM') {


        var successHandler = function(resp){
          vm.emandateValidationData = resp.eOTM;
          vm.maxMandateDurationYears = vm.emandateValidationData.maxMandateDurationYears || AppConstants.EMANDATE_MAX_DURATION_YEARS;
          vm.eMandateNoOfDays = vm.emandateValidationData.noOfDays;
          vm.eMandatemaxAmountLimit = vm.emandateValidationData.maxAmountLimit;
          vm.emandateMinAmountLimit = vm.emandateValidationData.minAmountLimit;
          vm.formData.emandateAmount = Math.floor(vm.emandateValidationData.defaultMandateAmount);
          vm.emandateMinStartDay = vm.emandateValidationData.minStartDays;
          vm.formData.emandateWord = {};
          $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
          checkAmountValidationEmandate();
          vm.mandateInfo = vm.emandateValidationData.mandateInfoBasket;
          vm.minEndDateGapMandate = vm.emandateValidationData.minEndDateGap;
          vm.mandateMaxString = vm.emandateValidationData.maxAmountLimitInfo;
          vm.formData.emandateDate = $window.moment().add(vm.emandateMinStartDay,'days');
          changeDateEmandate(vm.formData.emandateDate);
          updateEmandateEndDate();

          if (vm.formData.totalSipAmount && (vm.formData.totalSipAmount > vm.eMandateMaxAmount)) {
            vm.showEmandateError = true;
          } else {
            vm.showEmandateError = false;
          }
          if (vm.formData.totalSipAmount && (vm.formData.totalSipAmount < vm.emandateValidateData.minAmountLimit)) {
            vm.minAmountLimitError = true;
          } else {
            vm.minAmountLimitError = false;
          }

          if(vm.startEmandateDate && (moment(vm.startEmandateDate).isBefore(vm.emandateValidateData.minStartDate)) || vm.startEmandateDate && (moment(vm.startEmandateDate).isAfter(vm.emandateValidateData.maxStartDate))){
            vm.minStartDateLimitError = true;
          } else {
            vm.minStartDateLimitError = false;
          }
          if(vm.startEmandateDate && (moment(vm.startEmandateDate).isBefore(vm.emandateValidateData.minStartDate)) || vm.endEmandateDate && (!moment(vm.endEmandateDate).isSameOrBefore(vm.emandateValidateData.maxEndDate))){
            vm.maxEndDateLimitError = true;
          } else {
            vm.maxEndDateLimitError = false;
          }
        }

        UtilService.fetchMandateValidations().then(successHandler).catch(function(resp) {
          MessageService.error(resp);
        });

      }
    };

    vm.changeOtmbank = function () {
      var cartItemArr = [];
      if(!vm.formData.otmBank){
        return ;
      }
      vm.cartDetails.cartItems.forEach(function (el) {
        cartItemArr.push(el.installmentAmount);
        cartItemArr.push(el.amount);

      });

      vm.otmAmountLimitValidation(cartItemArr);
      vm.otmExpiryValidation();
      vm.otmStartValidation();
      // if((vm.formData.eMandateBank !== undefined && vm.formData.eMandateBank !==null)  || ( vm.formData.otmBank!== undefined && vm.formData.otmBank !== null)){
      //   if(vm.formData.minorFlag && !vm.formData.cgfFlag )
      //   {
      //     if( vm.formData.otmBank.minorBankFlag !== undefined){
      //       if(!vm.formData.otmBank.minorBankFlag){
      //         if(vm.dynamicDataMinorBank) {
      //           ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
      //         }
      //         vm.formData.otmBank=null;
      //       }
      //     }
      //   }
      // }
    };

    vm.otmAmountLimitValidation = function (cartItemArr) { // function to validate investment amount with otm limit
      var cartItemsAmount = cartItemArr;
      cartItemsAmount = cartItemsAmount.filter(function(item) {
        return item !== undefined && item !== null;
      });
      cartItemsAmount.sort(function(a, b){return a - b});
      var maxCartItem = cartItemsAmount[cartItemsAmount.length - 1];
      vm.otmBankLimit = vm.formData.otmBank && vm.formData.otmBank.maxAmount;
      if (vm.formData.investmentType && vm.otmBankLimit) {
        if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.PURCHASE) {
          vm.otmLimitvalidation = maxCartItem > vm.otmBankLimit? true: false;
        }
        else if (vm.formData.investmentType === vm.TRANSACTION_FORM_TYPE.SIP) {
          vm.otmLimitvalidation = maxCartItem > vm.otmBankLimit? true: false;
        }
        else if (vm.formData.investmentType === "SIPPURCHASE") {
          vm.otmLimitvalidation = maxCartItem > vm.otmBankLimit? true: false;
        }
      }
    };

    vm.otmExpiryValidation = function () { // function to validate investment end date  with otm expiry
      var yearArr = [];
      var otmStartDateError = [];
      var otmDateError = [];
      vm.cartDetails.cartItems.forEach(function (el) {
        yearArr.push({
          date : el.toDate,
          year : moment(el.toDate,'DD-MMM-YYYY').format('YYYY')
        });
        //Compare Dates
        if ($window.moment(vm.formData.otmBank.omExpiryDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(el.toDate, "DD-MMM-YYYY"))) {
          otmDateError.push(true);
        }
        else {
          otmDateError.push(false);
        }
      });

      if (otmDateError.includes(true)) {
        vm.endDateValidation = true;
      } else {
        vm.endDateValidation = false;
      }
    };

    vm.otmStartValidation = function () { // function to validate investment start date  with otm expiry
      var yearArr = [];
      var otmStartDateError = [];
      vm.cartDetails.cartItems.forEach(function (el) {
        yearArr.push({
          date : el.toDate,
          year : moment(el.toDate,'DD-MMM-YYYY').format('YYYY')
        });
        //Compare Dates
        if (vm.formData.investmentType !== 'PURCHASE' && el.sipDate && !($window.moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(el.sipDate, 'DD-MMM-YYYY')))){
          otmStartDateError.push(true);
        } else if (vm.formData.investmentType == 'PURCHASE' && vm.currentDate && !($window.moment(vm.formData.otmBank.omStartDate, 'DD-MMM-YYYY').isSameOrBefore($window.moment(vm.currentDate, 'DD-MMM-YYYY').format("DD-MMM-YYYY")))){
          otmStartDateError.push(true);
        }
        else{
          otmStartDateError.push(false);
        }
      });

      if (otmStartDateError.includes(true)) {
        vm.startDateValidation = true;
      } else {
        vm.startDateValidation = false;
      }
    };

    vm.getEmandateBankList = function (cb) {// function to fetch e-mandate registered bank w.r.t selected folio
      cb = cb || function () {
      };
      if (!vm.formData.folioNumber) {
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.emandateValidateData = resp.data;
            vm.isEMandateEnabled = resp.data.folioEmandateStatus;
            if ((angular.isArray(resp.data.bankList) && resp.data.bankList.length > 0) && vm.isEMandateEnabled) {
              vm.eMandateBankList = resp.data.bankList;
              vm.eMandateNoOfDays = resp.data.noOfDays;
              vm.eMandateMaxAmount = resp.data.maxAmountLimit;
              // vm.isEmandateEnabled = true;
            }
            else{
              vm.eMandateBankList  = [];
              // vm.isEmandateEnabled = false;
            }
          } else {
            vm.eMandateBankList = [];
            MessageService.error(resp.message);
          }
          cb(true);
        },
        error = function (err) {
          vm.eMandateBankList = null;
          vm.hideOtmRadio = true;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "trnxType": 'SIP',
        "liquidSchemeFlag": vm.formData.schemeTypeLiquid ? true : false
      }
      LoaderService.showLoader();
      BillJunctionService.post({VERSION: 'v2',
        controller: 'bank',
        child1: 'list',
        child2: 'emandate',
      }, payload ).$promise.then(success, error);
    };

    function setInitialFormData() {
      var liquidFlagArray = [];
      vm.cartDetails.cartItems.forEach(function(items) {
        liquidFlagArray.push(items.liquid);
      });
      vm.formData.schemeTypeLiquid = liquidFlagArray.includes(true);
      vm.cartDetails.cartItems.forEach(function (el) {
        if (el.cgfApplicable) {
          vm.formData.cgfFlag = true;
          return;
        } else {
          vm.formData.cgfFlag = false;
        }
      });
    }

    function emailMobileValidation(){
      if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
        if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isMobileinValid = true;
          vm.emandateDisplay = false;
        }
      }
      else if(vm.emailId === null || vm.emailId === '' || vm.emailId === undefined){
        if(vm.mobileNumber === null || vm.mobileNumber === '' || vm.mobileNumber === undefined){
          vm.isEmailMobileinValid = true;
          vm.emandateDisplay = false;
        }
        else {
          vm.isEmailinValid = true;
          vm.emandateDisplay = false;
        }
      } else {
        vm.isEmailinValid = false;
        vm.isMobileinValid = false;
        vm.isEmailMobileinValid = false;
        vm.emandateDisplay = true;
      }
    }

    vm.changeEMandateBank = function (){
      vm.authMode = vm.formData.eMandateBank && vm.formData.eMandateBank.authenticationModes ? vm.formData.eMandateBank.authenticationModes[0] : null;
      if(vm.formData.minorFlag && !vm.formData.cgfFlag && !vm.formData.eMandateBank.minorBankFlag)
      {
        if(vm.dynamicDataMinorBank) {
          ModalService.minorBankModal({dynamicDataPopup : vm.dynamicDataMinorBank});
        }
        vm.formData.eMandateBank=null;
      }
    };

    function getCartItems(action) {
      vm.dataAfterInitiateCart = JSON.parse($window.sessionStorage.getItem('cartDetails'));
      vm.totalAmount = 0;
      vm.formData.totalSipAmount = 0;
      vm.formData.totalPurchaseAmount = 0;
      if(vm.dataAfterInitiateCart.cartItems && vm.dataAfterInitiateCart.cartItems.length > 0 && vm.dataAfterInitiateCart.cartItems[0].folioNumber){
        vm.formData.folioNumber = vm.dataAfterInitiateCart.cartItems[0].folioNumber;
      }
      vm.cartItemList = vm.dataAfterInitiateCart.cartItems;
      vm.cartItemList.forEach(function(items) {
        if (items.purchaseOpted) {
          vm.totalAmount += items.amount
          vm.formData.totalPurchaseAmount += items.amount;
        }
        if (items.sipOpted) {
          vm.totalAmount += items.installmentAmount;
          vm.formData.totalSipAmount += items.installmentAmount;
        }
      });
      vm.cartDetails.cartItems = vm.cartItemList;
      vm.formData.investmentType = checkTransactionType();
      // if(action !== 'add' && action !== 'all') {
        fetchFolioList();
      // }
      setPaymentModes();
      setInitialFormData();
      vm.cartDetails.errorExists = '';
      vm.cartError = false;
      if(vm.cartDetails && vm.cartDetails.cartItems) {
        checkEmandateDateForNPCI(vm.cartDetails.cartItems);
      } else {
        vm.formData.isExceedingEmandateDate = false;
      }
    }

    function showPopupScreen(screen, item) {
      vm.investorData = setInvestorData();
      switch (screen) {
        case 'INVEST_THROUGH':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = true;
          vm.showSideAllFunds = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'CART_DETAILS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
          vm.showSideBarCart = true;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.itemToBeEdited = item;
          vm.isFromRviewScreen = true;
          vm.showAddCart = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'ALL_FUNDS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = true;
          vm.isFromRviewScreen = true;
          vm.showAddCart = true;
          $scope.$broadcast('updatedTitle');
          break;
      }
      expandSidebar();
    }

    function expandSidebar() {
      if (vm.cartItemList.totalLength === 0) {
        vm.showAddCart = true;
      }
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    $scope.$on('hidePostLoginSidebar',function (){
      vm.showSideBarCart = false;
      vm.showSideBarInvest = false;
      vm.showSideAllFunds = false;
      vm.showAddCart = false;
    });

    function setInvestorData() {
      var payload = {};
      payload = {
        folioNumber: vm.formData.folioNumber,
        brokerCode: vm.investThrough === 'DIRECT'? 'DIRECT' : vm.brokerCode,
        euinOpted: vm.euinNameSelected ? 'Y': 'N',
        euinCode: vm.formData.euinCode,
        euinName: vm.formData.euinName,
        minorFlag: vm.formData.minorFlag,
        brokerKey: null,
        brokerValue: null,
        newUser: false,
        invType: vm.formData.invType,
        investThroughDistributor: true,
        selectedFolioData: vm.selectedFolioData
      };
      return payload;
    }

    function removeCartItem(item) {
      var confirmSuccess = function () {
        vm.cartDetails.cartItems = vm.cartDetails.cartItems.filter(function(cartItem){
          return cartItem.cartItemId !== item.cartItemId;
        });
        $window.sessionStorage.setItem('cartDetails',JSON.stringify(vm.cartDetails));
        getCartItems('remove');
      } , confirmError = function () {};

      ModalService.confirmCancelModalEcart({text: "Are you sure you want to remove <strong>" + item.schemeName + "</strong> from the cart?"}, confirmSuccess, confirmError);
    }

    function checkChildAndRetirementFund(allSchemes){
      var countMinorScheme = [];
      var countRetiredScheme = [];
      allSchemes.forEach(function(item){
        countMinorScheme.push(item.cgfApplicable);
        countRetiredScheme.push(item.retirementApplicable);
      });
      for(var i=0; i< countMinorScheme.length;i++){
        for(var j=0; j< countRetiredScheme.length; j++){
          if((countMinorScheme[i] && countRetiredScheme[j]) == true){
            MessageService.error('Children’s Gift Fund & Retirement cannot be added together.');
            vm.isValidCartItem = true;
            return;
          } else {
            vm.isValidCartItem = false;
          }
        }
      }
    }


    vm.finishSipPurchase = function () {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.sKycStatus) {
              moveToPayment();
            }
            else {
              MessageService.error(resp.data.message);
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      var payload = {"panNumber": vm.investorInfo.panNumber, "folioNumber": vm.formData.folioNumber};
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'sKycStatus'
      }, payload).$promise.then(success, error);
    };

    function moveToPayment() {
      var payload = {

      };
      var additionalData = getAdditionalData();
      var success = function() {
        initiateCartTransaction();
      }, error = function () {

      };
      ModalService.transactionReviewModal({
        payload: payload, controller: 'ECART', additionalData: additionalData
      }, success, error);
    }

    function getAdditionalData() {
      var additionalData = {
        investorName: vm.investorInfo.name,
        panNumber: vm.investorInfo.panNumber,
        folioNumber: vm.formData.folioNumber,
        paymentMode: vm.formData.paymentMode,
        totalAmount: vm.totalAmount
      };
      if (vm.formData.paymentMode && vm.formData.paymentMode.key == 'OTM') {
        additionalData.otmBank = vm.formData.otmBank;
      }
      if(vm.formData.paymentMode && vm.formData.paymentMode.key == 'HEM') {
        additionalData.eMandateBank = vm.formData.eMandateBank.bankName.substr(0,vm.formData.eMandateBank.bankName.lastIndexOf('-'));
        additionalData.accountNumber = vm.formData.eMandateBank.accountNumber;
      }
      additionalData.emailId = vm.emailId;
      additionalData.mobileNumber = vm.mobileNumber;
      additionalData.coperateFlag = vm.investorInfo.corporateFlag;
      additionalData.startDate = findMinDate(vm.cartDetails.cartItems);
      additionalData.endDate = findMaxDate(vm.cartDetails.cartItems);
      additionalData.transactionType = vm.formData.investmentType;
      additionalData.installmentAmount = vm.totalAmount;
      additionalData.authenticationMode = vm.authMode;
      additionalData.mandateAmount = vm.formData.emandateAmount;
      additionalData.mandateStartDate = moment(vm.formData.emandateDate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
      additionalData.mandateEndDate = moment(vm.formData.endDateEmandate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
      // if(vm.formData.subBrokerARN){
      //   additionalData.subBrokerArn = vm.formData.subBrokerARN;
      // }
      // if(vm.formData.subBrokerCode){
      //   additionalData.subBrokerCode = vm.formData.subBrokerCode;
      // }
      return additionalData;
    }

    function findMinDate(items){
      var min_dt = items[0].sipDate,
        min_dtObj = new Date(items[0].sipDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.sipDate ) < min_dtObj) {
          min_dt = dt.sipDate;
          min_dtObj = new Date(dt.sipDate);
        }
      });
      return min_dt;
    }

    function findMaxDate(items) {
      var max_dt = items[0].toDate,
        max_dtObj = new Date(items[0].toDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.toDate ) > max_dtObj) {
          max_dt = dt.toDate;
          max_dtObj = new Date(dt.toDate);
        }
      });
      return max_dt;
    }

    function findMaxAmount(items){
      var max_amt = items[0].installmentAmount,
      max_amtObj = items[0].installmentAmount;
      items.forEach(function(amt, index) {
        if (amt.installmentAmount > max_amtObj) {
          max_amt = amt.installmentAmount;
          max_amtObj = amt.installmentAmount;
        }
      });
      return max_amt;
    }

    function termsAndContitions() {
      ModalService.termsAndConditionEcartModal({});
    }

    function checkEcartItemValidations() {
      LoaderService.showLoader();
      var payload = fetchFinalPayload();
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.errorExists) {
            vm.cartDetails.errorExists = resp.data.errorExists;
            vm.cartDetails.message = resp.data.message;
            vm.cartError = true;
            resp.data.cartItems.forEach(function (el, index) {
              if (el.errorExists) {
                vm.cartItemList[index].errorExists = el.errorExists;
                vm.cartItemList[index].message = el.message;
                vm.cartError = true;
                $window.scrollTo(0, 0);
              }
            });
          } else {
            vm.cartError = false;
            vm.finishSipPurchase();
          }
        } else {
          MessageService.error(resp.message);
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      InvestorCommonServiceVersion1.post({
        child2: 'cart',
        child3: 'validate',
      }, payload).$promise.then(success, error);
    }

    function fetchFinalPayload(finalCall) {
      var cartItems = angular.copy(vm.cartItemList);
      cartItems.forEach(function (el,index) {
        el.investorId = vm.investorUUID;
        el.folioNumber = vm.formData.folioNumber;
        el.euinName = vm.formData.euinName;
        el.euinCode = vm.formData.euinCode;
        el.euinOpted = vm.formData.euinCode ? 'Y': 'N';
        el.mandateAmount = vm.formData.emandateAmount;
        el.emandateStartDate = moment(vm.formData.emandateDate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
        el.emandateEndDate = moment(vm.formData.endDateEmandate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
      })

      var payload = {
        folioNumber : vm.formData.folioNumber,
        investorId : vm.investorUUID,
        cartItems : cartItems,
      }

      if (vm.formData.investmentType === 'SIP') {
        payload.paymentModeSip = vm.formData.paymentMode.key;
        delete payload.paymentOption;
      } else if (vm.formData.investmentType === 'PURCHASE') {
        if (vm.formData.paymentMode.value === 'Net Banking') {
          payload.paymentOption = 'NET_BANKING';
        } else  {
          payload.paymentOption = vm.formData.paymentMode.key;
        }
        delete payload.paymentModeSip;
      } else if (vm.formData.investmentType === 'SIPPURCHASE') {
        if (vm.formData.paymentMode.value === 'Net Banking/Biller') {
          payload.paymentOption = 'NET_BANKING';
          payload.paymentModeSip = 'EC';
        } else {
          payload.paymentOption = vm.formData.paymentMode.key;
          payload.paymentModeSip = vm.formData.paymentMode.key;
        }
      }

      if(vm.formData.paymentMode.key == 'OTM'){
        payload.payoutId = vm.formData.otmBank.payoutId;
        payload.omUmrn = vm.formData.otmBank.omUmrn;
      }

      if(vm.formData.paymentMode.key == 'HEM'){
        payload.accNo = vm.formData.eMandateBank.accountNumber;
        payload.accType = vm.formData.eMandateBank.bankAcType;
        payload.authenticationMode = vm.formData.eMandateBank.authenticationModes.value;
        payload.bankCity = vm.formData.eMandateBank.bankCity;
        payload.bankCode = vm.formData.eMandateBank.bankCode;
        payload.bankName = vm.formData.eMandateBank.bankName;
        payload.branchName = vm.formData.eMandateBank.bankBranch;
        payload.gateWayVendor = vm.formData.eMandateBank.gateWayVendor;
        payload.ifscCode = vm.formData.eMandateBank.ifscCode;
      }

      if(vm.formData.paymentMode.key === 'HEM') {
        payload.mandateAmount = vm.formData.emandateAmount;
        payload.emandateStartDate = moment(vm.formData.emandateDate, "DD-MMM-YYYY").format('DD-MMM-YYYY');
        payload.emandateEndDate = moment(vm.formData.endDateEmandate, "DD-MMM-YYYY").format('DD-MMM-YYYY');

        if (finalCall) {
          payload.authenticationMode = vm.authMode.value;
        }
      }

      return payload;
    }

    function initiateCartTransaction() {
      LoaderService.showLoader();
      var payload = fetchFinalPayload(true);
      if(payload.cartItems) {
        payload.cartItems.forEach(function (item) {
          if(vm.formData.subBrokerARN) {
            item.subBrokerArn = 'ARN-'+vm.formData.subBrokerARN;
          }
          if(vm.formData.subBrokerCode) {
            item.subBrokerCode = vm.formData.subBrokerCode;
          }
        })
      }

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var successSipModal = function () {
            $state.go('main.dashboard');
           }, errorSipModal = function () {
            $state.go('main.dashboard');
           }
          ModalService.initiateSuccessModal({
            transactionType: 'ECART',
            investorName: vm.investorInfo.name
          }, successSipModal, errorSipModal);
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      }

      InvestorCommonServiceVersion1.post({
        child2: 'cart',
        child3: 'initiate',
      }, payload).$promise.then(success, error);
    }

    function checkEmandateDateForNPCI(cartItems){

      vm.startEmandateDate = findMinDate(cartItems);
      vm.endEmandateDate = findMaxDate(cartItems);
      vm.emandateTotalAmount = findMaxAmount(cartItems);

      var emandateEndDate = $window.moment(vm.startEmandateDate,'DD-MMM-YYYY').add(vm.maxMandateDurationYears,'years');
      var selectedEndDate = $window.moment(vm.endEmandateDate,'DD-MMM-YYYY');
      var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
      vm.found = cartItems.some(function (ele){
        return ele.sipOpted == true
      });
      if (!endDateEmandateBoundExist && vm.found) {
        vm.formData.isExceedingEmandateDate = true;
      } else {
        vm.formData.isExceedingEmandateDate = false;
      }
      setPaymentModes();
    }

    function findMinDate(items){
      var min_dt = items[0].sipDate,
        min_dtObj = new Date(items[0].sipDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.sipDate ) < min_dtObj) {
          min_dt = dt.sipDate;
          min_dtObj = new Date(dt.sipDate);
        }
      });
      return min_dt;
    }

    function findMaxDate(items) {
      var max_dt = items[0].toDate,
        max_dtObj = new Date(items[0].toDate);
      items.forEach(function(dt, index) {
        if ( new Date( dt.toDate ) > max_dtObj) {
          max_dt = dt.toDate;
          max_dtObj = new Date(dt.toDate);
        }
      });
      return max_dt;
    }

    function findMaxAmount(items){
      var totalEmandateAmount = 0;
      items.forEach(function(amt, index) {
        totalEmandateAmount = totalEmandateAmount + amt.installmentAmount
      });
      return totalEmandateAmount
    }

    function updateEmandateEndDate() {

      if (!vm.formData.emandateDate) {
        return;
      }

      var enabledEndDates = [];
      vm.formData.endDateEmandate = '';
      if(vm.formData.emandateDate)
      {
        vm.minEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.minEndDateGapMandate, 'year');
        vm.minEndDateEmandate.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
        vm.maxEndDateEmandate = $window.moment(vm.formData.emandateDate, "DD-MMM-YYYY").add(vm.maxMandateDurationYears, 'years').subtract(1,'days');
      }

      var freq = vm.maxEndDateEmandate.diff(vm.minEndDateEmandate, 'days');
      for (var i = 0; i <= freq; i++) {
        enabledEndDates.push(vm.minEndDateEmandate.clone().add(i, 'days'));
      }
      vm.enabledEmandateEndDatesList = enabledEndDates;
      vm.endDateViewEmandate = enabledEndDates[0].clone();
      vm.formData.endDateEmandate =  $window.moment(vm.enabledEmandateEndDatesList[vm.enabledEmandateEndDatesList.length - 1], 'DD-MMM-YYYY');
    }


    function checkAmountValidationEmandate() {
      if (vm.formData.emandateAmount) {
        vm.amountLess = vm.formData.emandateAmount < vm.emandateMinAmountLimit ? true : false;
        vm.amountMore = vm.formData.emandateAmount > vm.eMandatemaxAmountLimit ? true : false;
        vm.isLessThanSipAmount =  vm.formData.emandateAmount < vm.totalAmount ? true : false;
        $window.NumToWord(vm.formData.emandateAmount, 'amountInwordsEmandate',vm.formData.emandateWord);
      } else {
        vm.formData.emandateWord = {};
      }
    }

    function changeEndDateEmandate(date) {
      vm.formData.endDateEmandate = date ? date : null;
      if (vm.formData.endDate) {
        var endDate = findMaxDate(vm.cartDetails.cartItems);
        vm.sipDateLessEmandate =  $window.moment(endDate, 'DD-MMM-YYYY').isAfter($window.moment(vm.formData.endDateEmandate, 'DD-MMM-YYYY')) ? true : false;
      }
    }

    function changeDateEmandate(date) {
      vm.formData.emandateDate = date ? date : null;
    }


    // $transitions.onStart({}, function ($event) {
    //   var result = document.getElementsByClassName("select-sipPurchaseForm");
    //   if(result.length > 0){
    //     var answer = confirm('You may have unsaved changes! Press ok to continue, or press cancel to go back and save your work.');
    //     if(!answer) {
    //       $event.preventDefault();
    //       return false;
    //     }
    //   }
    // });

    function toCheckIsRetirementOrMinorScheme(){
      vm.isChildScheme = false;
      vm.isRetirementScheme = false;
      //checking children fund
      vm.cartItemList.forEach(function(item,index){
        if(item.fundCode == "HDFCGF"){
          vm.isChildScheme = true;
        }
      });
      //checking Retirement fund
      vm.cartItemList.forEach(function(item,index){
        if(item.fundCode == "HDFCRETHDP" || item.fundCode == "HDFCRETEQP" || item.fundCode == "HDFCRETHEP"){
          vm.isRetirementScheme = true;
        }
      });

      var selectedFolioObj = vm.folioList && vm.folioList.filter(function (row) {
        return row.folioNumber == vm.formData.folioNumber
      })[0];
      vm.formData.minorFlag = selectedFolioObj && angular.isDefined(selectedFolioObj.minorFlag) ? selectedFolioObj.minorFlag : false;

      if(vm.isChildScheme && !vm.formData.minorFlag){
        vm.isInValidFolio = true;
      } else if(vm.isRetirementScheme && vm.formData.minorFlag){
        vm.isInValidFolio = true;
      } else {
        vm.isInValidFolio = false;
      }
    }

    vm.changeSubBrokerArn = function () {
      vm.formData.subBrokerCode = ''
      vm.formData.isSubarnSuccess = vm.formData.subBrokerARN ? true : false;
      vm.isCheckedTandC = false;
      //vm.formData.euin = '';
      vm.subBrokerName = '';
      if(!vm.formData.subBrokerARN){
        vm.subBrokerCodeError = '';
      }
    }

    vm.fetchEuinListSubBroker = function () {

      if (!vm.formData.subBrokerARN) {
        vm.subBrokerCodeError = '';
        vm.subBrokerName = '';
        vm.isSubarnSuccess = false;
        getEuinCodes();
        return;
      }
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.euinMasterList = resp.data.euinList;
            vm.euinList = vm.euinMasterList;
            vm.formData.euinCode = vm.euinList.length == 1 ? vm.euinList[0].euinCode : null;
            vm.euinNameSelected = vm.euinList.length == 1 ? vm.euinList[0].euinName : null;
            vm.subBrokerName = resp.data.distributorName;
            vm.subBrokerCodeError = '';
            vm.isSubarnSuccess = false;
            vm.isArnSuccess =false;
            // if (vm.localData) {
            //   var euinData = vm.euinMasterList.filter(function (value) {
            //     if (value.euinCode == vm.localData.Euin) { return value; }
            //   })[0];
            //   vm.selectEuin(euinData);
            // }
          } else {
            vm.subBrokerCodeError = resp.message;
            vm.isSubarnSuccess = true;
            vm.formData.euin = '';
            vm.euinList = null;
            MessageService.error(resp.message);
            vm.isArnSuccess =true;
          }
        },
        error = function () {
          LoaderService.hideLoader();
          vm.subBrokerCodeError = '';
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      TransactionService.get({
        VERSION: HDFC_API.VERSION,
        controller: 'getEuin',
        child2: 'ARN-' + vm.formData.subBrokerARN,
        isSubBroker: true
      }).$promise.then(success, error);
    }

    function resetSubBrokerDetails() {
      vm.formData.subBrokerName = '';
      vm.formData.subBrokerARN = '';
      vm.subBrokerCodeError = '';
      vm.formData.subBrokerCode = '';
      vm.fetchEuinListSubBroker();
    }




  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('EcartModel', ecartModel);

  /** @ngInject */
  function ecartModel() {
    var paymentpayload = {
      folioNumber : '',
      cartItemsInfo : [],
      investThrough : {},
      isMinor : false,
      transactionType: '',
      amount:'',
      emandateValidate: {}
    };

    function setPaymentPayload(folioNumber , _payload , investThrough , minor , tncType , amount , emandateValidateObject, brokerDetail, preLogin, totalAmount) {
      paymentpayload.folioNumber = folioNumber;
      paymentpayload.cartItemsInfo = angular.copy(_payload);
      paymentpayload.investThrough = angular.copy(investThrough);
      paymentpayload.isMinor = minor;
      paymentpayload.transactionType = tncType;
      paymentpayload.amount = amount;
      paymentpayload.emandateValidate = angular.copy(emandateValidateObject);
      paymentpayload.brokerDetailsPayload = brokerDetail;
      paymentpayload.preLogin = preLogin;
      paymentpayload.purchaseAmount = totalAmount;
    }

    function getPaymentPayload() {
      return angular.copy(paymentpayload);
    }

    return {
      setPayloadPayment : setPaymentPayload,
      getPayloadPayment : getPaymentPayload
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcPostLoginEcartSidebar', hdfcPostLoginEcartSidebarDirective);

  /*@ngInject*/
  function hdfcPostLoginEcartSidebarDirective($state, $window, AuthService, LoaderService, AppConstants, MessageService, UtilService, ModalService, TransactionService, EcartService, EcartModel , $rootScope , $stateParams, $timeout, CmsEcartService, $cookies) {
    return {
      restrict: 'EA',
      scope: {
        sideTitle: "=",
        euinDeclaration: "=",
        cartItem: "=?cartItem",
        investThrough: "=",
        updateInfo: "&",
        investorData: '=',
        closeAction : "&",
        showAddCart: '=',
        fromInitiateCart: '=',
        isFromReview: '=',
        fromEquityAsset: '=?'
      },
      templateUrl: 'app/ecart/directives/sidebar.directive.html',
      link: function ($scope, element, attrs) {
        var _this = $scope;
        _this.$on('updatedTitle', function() {
          init();
        });
        var initialAnimSkip = false;
        _this.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
        _this.formData = {};
        _this.investThroughFormData = {};
        _this.formAction = {};
        _this.investThroughFormData.isCheckedTandC = false;
        _this.sipWithFi = false;
        _this.appConstants = AppConstants;
        _this.transactionTypeList = [
          AppConstants.TRANSACTION_TYPES.SIP,
          AppConstants.TRANSACTION_TYPES.PURCHASE
        ];
        _this.transactionInFund = [];
        _this.amountSuggestion = [5000, 7000, 10000];
        _this.purchaseAmountSuggestion = [30000, 40000, 50000];
        _this.viewMode = "days";
        _this.investmentList = [];
        _this.suggestionList = [];
        _this.showingTrendingFunds = [];
        _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
        _this.filterValues = [];
        _this.investmentOptions = [];
        _this.moment = $window.moment;
        _this.formData.sipOpted = true;
        _this.formData.purchaseOpted = true;
        _this.formData.yearSelected = [];
        _this.allFundForm = {};
        _this.allFundForm.isRegular = false;
        _this.startDateError = false;
        _this.allFundForm.regularDirectError = null;
        _this.isEndDateFound = false;
        _this.collapse = collapse;
        _this.init = init;
        _this.changeThroughDistributor = changeThroughDistributor;
        _this.changeDistributorCode = changeDistributorCode;
        _this.searchDistributor = searchDistributor;
        _this.selectEuin = selectEuin;
        _this.searchDistributorByName = searchDistributorByName;
        _this.distributorListChanged = distributorListChanged;
        _this.changeSubBrokerArn = changeSubBrokerArn;
        _this.fetchEuinListSubBroker = fetchEuinListSubBroker;
        _this.setTandCVariable = setTandCVariable;
        _this.updateCartViaInvestThrough = updateCartViaInvestThrough;
        _this.filterEuinList = filterEuinList;
        _this.checkEnableEndDate = checkEnableEndDate;

        _this.addTransactionFields = addTransactionFields;
        _this.removeTransactionFromList = removeTransactionFromList;
        _this.utilService = UtilService;
        _this.allFormData = {};
        _this.allFormData.searchModel = null;
        _this.changeInstallmentAmount = changeInstallmentAmount;
        _this.changeStartDate = changeStartDate;
        _this.changeEndDate = changeEndDate;
        _this.fetchSchemeList = fetchSchemeList;
        _this.filterInSchemeList = filterInSchemeList;
        _this.showCagrValue = showCagrValue;
        _this.displayCagrValue = displayCagrValue;
        _this.openFilter = openFilter;
        _this.filterFunds = filterFunds;
        _this.changeFundsListing = changeFundsListing;
        _this.moveToCartDetails = moveToCartDetails;
        _this.searchRecords = searchRecords;

        _this.setSideBarState = setSideBarState;
        _this.redirectToSummary = redirectToSummary;
        _this.changeInvestmentOptions = changeInvestmentOptions;
        _this.inSchemeChanged = inSchemeChanged;
        _this.changeSelectedScheme = changeSelectedScheme;
        _this.changeTillPerpetuity = changeTillPerpetuity;
        _this.saveCartEdited = saveCartEdited;
        _this.sidebarOrReviewSaveCartEdited = sidebarOrReviewSaveCartEdited;
        _this.addToCart = addToCart;
        _this.sidebarOrReviewAddToCart = sidebarOrReviewAddToCart;
        _this.addTrendingFund = addTrendingFund;
        _this.formData.startDate = null;
        _this.formData.endDate = null;
        _this.enabledStartDates = [];
        _this.investorUUID = $stateParams.uuid;
        _this.isEdit = false;
        _this.editTransactionFromCart = editTransactionFromCart;
        _this.removeTransactionFromCart = removeTransactionFromCart;
        _this.getNote = '';
        _this.fetchDynamicDataEcart = fetchDynamicDataEcart;
        _this.investmentArray = AppConstants.ECART_CART_ITEM_NUMBER;
        _this.startDateFormat = 'DD-MMM-YYYY';
        _this.isExceedingEmandateDate = false;
        // _this.NPCINote = 'Register E-mandate payment mode shall not be available if overall duration of one or more SIP(s) in your cart is greater than 30 years.'


        init();

        function init() {
          //collapse();
          _this.sidebarTitle = _this.sideTitle;
          _this.setSideBarState();
        }

        function collapse(action) {
          _this.allFormData.searchModel = null;
          if (initialAnimSkip) {
            initialAnimSkip = false;
            collapseDone();
            element.addClass('sidebar-container-width-0');
            angular.element($window.document.body).removeClass('hide-scroll');
          } else {
            element.removeClass('collapse in').addClass('collapsing-width');
            element.addClass('sidebar-container-width-0');
            collapseDone();
            angular.element($window.document.body).removeClass('hide-scroll');
          }
          resetValues();
          _this.closeAction({action: action});
          $rootScope.$broadcast('hidePostLoginSidebar');
        }

        function collapseDone() {
          element.removeClass('collapsing-width');
          element.addClass('collapse');
        }


        function setSideBarState(state) {
          var state = state ? state :_this.sideTitle.replaceAll(" ", "_").replaceAll("-", "").toUpperCase();
          _this.sidebarSection = state;
          if (_this.sidebarSection === "INVEST_THROUGH") {
            _this.distributorMessage = _this.euinDeclaration.TNC_SIP_Through_Distributor;
            _this.riaMessage = _this.euinDeclaration.TNC_SIP_Review_Through_RIA;
            $scope.$watch('investThrough', function(value) {
              changeThroughDistributor(_this.investThrough);
            });
          } else if (_this.sidebarSection === 'ECART') {
            fetchInvestmentAdded();
            fetchSuggestion();
            _this.sidebarTitle = 'E-Cart';
          } else if(_this.sidebarSection === 'ALL_FUNDS') {
            _this.showAddCart = true;
            if(_this.fromEquityAsset){
              _this.cartItem = undefined;
            }
            fetchFunds();
            fetchFundsFilters();
            _this.sidebarTitle = 'All Funds';
          } else if (_this.sidebarSection === 'CART_DETAILS') {
            _this.sidebarTitle = 'Cart Details';
            fetchDynamicDataEcart(function(){
            if (_this.cartItem) {
              if(_this.isEdit){
                initializeData();
              } else {
                $scope.$watch('cartItem', function (value) {
                  _this.fundName = value.fundName;
                  _this.fundCode = value.fundCode;
                  initializeData();
                });
              }
            } else {
              initializeData();
            }
            });
          }
          angular.element(document.getElementById('scrollTo')).animate({scrollTop: 0}, 500);
        }

        function changeThroughDistributor(investThrough) {
          if (investThrough === 'DIRECT') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isDirect = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.subBrokerARN = null;
            _this.investThroughFormData.isEuin = false;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.isCheckedTandC = false;
            _this.investThroughFormData.riaBrokerName = null;
          } else if (investThrough === 'DISTRIBUTOR') {
            _this.investThroughFormData.isThroughDistributor = true;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = false;
            _this.investThroughFormData.isEuin = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.isCheckedTandC = false;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.riaBrokerName = null;
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.brokerCode !== 'DIRECT' && !_this.cartItem.brokerDetailsDTO.riaConsent) {
              _this.investThroughFormData.brokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.brokerCode.split('-')[1] : null;
              fetchEuinList();
              _this.investThroughFormData.subBrokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.subBrokerCode : null;
              _this.investThroughFormData.subBrokerName = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.subBrokerName : null;
              _this.investThroughFormData.subBrokerARN = _this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.subBrokerArn ? _this.cartItem.brokerDetailsDTO.subBrokerArn.split('-')[1] : null;
              if (_this.cartItem.brokerDetailsDTO.euinOpted === 'N' && _this.cartItem.brokerDetailsDTO.brokerCode !== 'DIRECT' ) {
                _this.investThroughFormData.isEuin = false;
                _this.investThroughFormData.isCheckedTandC = true;
              }
            } else {
              _this.investThroughFormData.brokerCode = _this.investorData.brokerCode ? _this.investorData.brokerCode.split('-')[1] : null;
              fetchEuinList();
              _this.investThroughFormData.subBrokerARN = _this.investorData.subBrokerARN ? _this.investorData.subBrokerARN.split('-')[1] : null;
              _this.investThroughFormData.subBrokerCode = _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode : null;
              _this.investThroughFormData.subBrokerName = _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode : null;
              if (_this.investorData.euinOpted === 'N' && _this.investorData.investThroughDistributor) {
                _this.investThroughFormData.isEuin = false;
                _this.investThroughFormData.isCheckedTandC = true;
              }
            }
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.euinCode) {
              selectEuin({
                euinNameCode: _this.cartItem.brokerDetailsDTO.euinName +'-'+ _this.cartItem.brokerDetailsDTO.euinCode
              });
            } else if (_this.investorData.euinName && _this.investorData.euinCode) {
              selectEuin({
                euinNameCode: _this.investorData.euinName +'-'+ _this.investorData.euinCode
              });
            }
          } else if (investThrough === 'RIA') {
            _this.investThroughFormData.isThroughDistributor = false;
            _this.investThroughFormData.isDirect = false;
            _this.investThroughFormData.isThroughRia = true;
            _this.investThroughFormData.euin = null;
            _this.investThroughFormData.subBrokerCode = null;
            _this.investThroughFormData.brokerCode = null;
            _this.investThroughFormData.subBrokerName = null;
            _this.investThroughFormData.isEuin = false;
            _this.investThroughFormData.subBrokerARN = null;
            _this.investThroughFormData.isCheckedTandC = false;
            if (_this.cartItem.brokerDetailsDTO && _this.cartItem.brokerDetailsDTO.investThroughRIA) {
              _this.investThroughFormData.riaBrokerCode = _this.cartItem.brokerDetailsDTO ? _this.cartItem.brokerDetailsDTO.brokerCode : null;
              _this.investThroughFormData.isCheckedTandC = _this.cartItem.brokerDetailsDTO.riaConsent;
              changeDistributorCode();
            } else if (_this.investorData && _this.investorData.investThroughRIA) {
              _this.investThroughFormData.riaBrokerCode = _this.investorData ? _this.investorData.brokerCode : null;
              _this.investThroughFormData.isCheckedTandC = _this.investorData ? _this.investorData.riaConsent: false;
              changeDistributorCode();
            }
            fetchEuinList();
          }

          if (!_this.investThroughFormData.isThroughDistributor) {
            _this.investThroughFormData.euin = {};
            _this.investThroughFormData.brokerCode = '';
            _this.investThroughFormData.brokerName = '';
            _this.euinList = null;
            _this.investThroughFormData.distributorARN = '';
            _this.investThroughFormData.distributorName = '';
            _this.investThroughFormData.subBrokerARN = '';
            //_this.investThroughFormData.isCheckedTandC = false;
            _this.isArnSuccess = true;
            _this.investThroughFormData.subBrokerCode = '';
            _this.isSelectedEuin = true;
            _this.subBrokerName = '';
          }
        }

        function changeDistributorCode() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          _this.investThroughFormData.distributorName = '';
          _this.euinList = null;
          _this.isArnSuccess = true;
          _this.riaCodeError = "";
        }

        function searchDistributor() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          fetchEuinList();
        }

        function fetchEuinList() {
          if (_this.investThroughFormData.isThroughDistributor) {
            if (!_this.investThroughFormData.brokerCode) {
              return;
            }
          } else if (_this.investThroughFormData.isThroughRia) {
            if (!_this.investThroughFormData.riaBrokerCode) {
              return;
            }
          }
          _this.investThroughFormData.brokerName = null;
          _this.investThroughFormData.riaBrokerName = null;
          _this.subBrokerCodeError = '';
          _this.euinData = {};
          _this.isArnSuccess = true;
          _this.distributorList = null;

          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.euinMasterList = resp.data.euinList;
              _this.euinList = _this.euinMasterList;
              _this.euinData = _this.investThroughFormData.euin ? _this.investThroughFormData.euin : {};
              _this.brokerCodeError = '';
              _this.riaCodeError = '';
              _this.isArnSuccess = false;
              if (_this.investThroughFormData.isThroughDistributor) {
                _this.investThroughFormData.brokerName = resp.data.distributorName;
              } else if (_this.investThroughFormData.isThroughRia) {
                _this.investThroughFormData.riaBrokerName = resp.data.distributorName;
              }
            } else {
              _this.euinList = null;
              if (_this.investThroughFormData.isThroughDistributor) {
                _this.brokerCodeError = resp.message;
              } else if (_this.investThroughFormData.isThroughRia) {
                _this.riaCodeError = resp.message;
                _this.investThroughFormData.isCheckedTandC = false;
                _this.investThroughFormData.isCheckedTandC = false;
              }
              //MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            _this.euinList = null;
          };
          LoaderService.showLoader();
          var path = {};
          if (_this.investThroughFormData.isThroughDistributor) {
            path  = {
              controller1: 'getEuin',
              controller2: 'ARN-' + _this.investThroughFormData.brokerCode
            };
          } else if (_this.investThroughFormData.isThroughRia) {
            path = {
              controller1: 'getEuin',
              controller2: _this.investThroughFormData.riaBrokerCode,
              riaOpted: _this.investThroughFormData.isThroughRia
            };
          }
          TransactionService.get(path).$promise.then(success, error);
        }

        function filterEuinList() {
          _this.investThroughFormData.euin = {};
          _this.isSelectedEuin = false ;
          if(_this.investThroughFormData.euinNameCode){
            if(_this.investThroughFormData.euinNameCode.length>=3){
              _this.euinList = UtilService.getFilteredList(_this.euinMasterList, 'euinNameCode', _this.investThroughFormData.euinNameCode);
            }
          }
          _this.euinList = _this.investThroughFormData.euinNameCode == '' || _this.investThroughFormData.euinNameCode == undefined || _this.investThroughFormData.euinNameCode.length<3 ? _this.euinMasterList : _this.euinList;
        }

        function selectEuin(data) {
          if (!data) {
            return;
          }
          _this.euinData = {};
          _this.investThroughFormData.euinNameCode = data.euinNameCode;
          _this.isSelectedEuin = _this.investThroughFormData.euinNameCode ? true : false;
        }

        function searchDistributorByName() {
          _this.investThroughFormData.brokerName = '';
          _this.investThroughFormData.distributorARN = '';
          _this.investThroughFormData.brokerCode = '';
          _this.brokerCodeError = '';
          _this.isArnSuccess = true;
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            _this.distributorList = null;
            _this.euinList = null;
            _this.investThroughFormData.euin = null;
            return;
          }
          fetchARNByName();
        }

        function fetchARNByName() {
          if ((!_this.investThroughFormData.distributorName) || (_this.investThroughFormData.distributorName && _this.investThroughFormData.distributorName.length < 3)) {
            return;
          }
          _this.investThroughFormData.distributorARN = '';
          _this.distributorList = null;
          _this.isArnSuccess = true;
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.distributorList = resp.data.distributorList;
              if (_this.distributorList.length == 0) {
                _this.investThroughFormData.euin = {};
                _this.investThroughFormData.isCheckedTandC = false;
              }
            } else {
              _this.distributorList = null;
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            _this.distributorList=null;
            UtilService.errorHandler(err);
          };

          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'getDistributor',
            controller2: _this.investThroughFormData.distributorName
          }).$promise.then(success, error);
        }

        function distributorListChanged(data) {
          if (!data) {
            return;
          } else {
            _this.brokerCodeError = '';
            _this.investThroughFormData.distributorARN = data.arnCode;
            _this.investThroughFormData.distributorName = data.name + ' - ' + data.arnCode;
            _this.showArnLabel = false;
            if (_this.investThroughFormData.distributorARN) {
              _this.isArnSuccess = false;
            }
            else {
              _this.isArnSuccess = true;
            }
            fetchEuinListThroughDistributor(_this.investThroughFormData.distributorARN);
          }

          function fetchEuinListThroughDistributor(arnCode) {
            if (!arnCode) {
              return;
            }
            _this.investThroughFormData.brokerName = '';
            var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.euinMasterList = resp.data.euinList;
                _this.euinList = _this.euinMasterList;
                _this.euinData = _this.investThroughFormData.euin;
              } else {
                _this.euinList = null;
              }
            },
            error = function () {
              LoaderService.hideLoader();
              _this.euinList = null;
            };

            LoaderService.showLoader();
            TransactionService.get({
              controller1: 'getEuin',
              controller2: arnCode
            }).$promise.then(success, error);
          }
        };

        function changeSubBrokerArn() {
          _this.investThroughFormData.subBrokerCode = '';
          _this.investThroughFormData.isSubarnSuccess = _this.investThroughFormData.subBrokerARN ? true : false;
          _this.investThroughFormData.isCheckedTandC = false;
          _this.subBrokerName = '';
        }

        function fetchEuinListSubBroker() {
          if (!_this.investThroughFormData.subBrokerARN) {
            _this.subBrokerCodeError = '';
            _this.subBrokerName = '';
            _this.isSubarnSuccess = false;
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
            fetchEuinList();
            return;
          }
          if(_this.investThroughFormData.brokerCode !== _this.investThroughFormData.subBrokerARN){
            _this.investThroughFormData.euin = {};
            _this.euinData = {};
          }
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.euinMasterList = resp.data.euinList;
              _this.euinList = _this.euinMasterList;
              for(var i = 0; i<_this.euinList.length; i++){
                if(_this.euinData.euinNameCode === _this.euinList[i].euinNameCode){
                  _this.investThroughFormData.euin = _this.euinList[i];
                  break;
                } else {
                  _this.investThroughFormData.euin = {};
                }
              }
              _this.euinData = _this.investThroughFormData.euin;
              _this.subBrokerName = resp.data.distributorName;
              _this.subBrokerCodeError = '';
              _this.isSubarnSuccess = false;
            } else {
              _this.euinList = null;
              _this.subBrokerCodeError = resp.message;
              _this.isSubarnSuccess = true;
              _this.investThroughFormData.euin = {};
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            _this.subBrokerCodeError = '';
          };

          LoaderService.showLoader();
          TransactionService.get({
            controller1: 'getEuin',
            controller2: 'ARN-' + _this.investThroughFormData.subBrokerARN,
            isSubBroker: _this.investThroughFormData.isThroughDistributor
          }).$promise.then(success, error);
        }

        function setTandCVariable() {
          _this.investThroughFormData.isCheckedTandC = _this.investThroughFormData.isCheckedTandC;
        }

        function updateCartViaInvestThrough() {
          var payload = getInvestThroughPayload();
          if (_this.cartItem && _this.cartItem.cartItems) {
            LoaderService.showLoader();
            var success = function(resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                _this.updateInfo(payload);
                collapse();
              } else {
                MessageService.error(resp.message);
              }
            }, error = function(err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
            EcartService.post2({
              child1: "cart",
              child2: "update",
              child3: "invest-through"
            }, payload).$promise.then(success, error);
          } else {
            _this.updateInfo({data: payload});
            collapse();
          }
        }

        function getInvestThroughPayload() {
          var payload = {
            "brokerDetailsDTO": {
              "directOpted": _this.investThroughFormData.isThroughDistributor ? false : true,
              "brokerCode": identifyBrokerCode(),
              "subBrokerCode": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.subBrokerCode ? _this.investThroughFormData.subBrokerCode : null,
              "subBrokerArn": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.subBrokerARN ? 'ARN-'+_this.investThroughFormData.subBrokerARN : null,
              "euinOpted": _this.investThroughFormData.isEuin ? 'Y' : 'N',
              "euinCode": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.isEuin ? _this.investThroughFormData.euinNameCode.split("-")[1] : null,
              "euinName": _this.investThroughFormData.isThroughDistributor && _this.investThroughFormData.isEuin ? _this.investThroughFormData.euinNameCode.split("-")[0] : null,
              "investThroughRIA": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.isThroughRia : false,
              "riaConsent": _this.investThroughFormData.isThroughRia ? _this.investThroughFormData.isCheckedTandC : false,
              "isEuin" : _this.investThroughFormData.isEuin ? _this.investThroughFormData.isEuin : false,
              investThroughDirect: _this.investThroughFormData.isDirect,
              investThroughDistributor: _this.investThroughFormData.isThroughDistributor
            }
          };
          if (_this.cartItem.folioNumber) {
           payload.cartItemListCo =  {
              "folioNumber": _this.cartItem.folioNumber,
              "cartItems": _this.cartItem.cartItems,
              "totalAmount": _this.cartItem.totalAmount
            };
          }
          return payload;
        }

        function identifyBrokerCode() {
          if (_this.investThroughFormData.isDirect) {
            return "DIRECT";
          } else if (_this.investThroughFormData.isThroughDistributor) {
            return _this.investThroughFormData.brokerCode ? 'ARN-'+_this.investThroughFormData.brokerCode : _this.investThroughFormData.distributorARN;
          } else if (_this.investThroughFormData.isThroughRia) {
            return _this.investThroughFormData.riaBrokerCode;
          }
        }

        /*---------------------------------------- CART DETAILS SECTION ----------------------------------------------*/
        function initializeData() {
          //_this.formData.inSchemeName = _this.cartItem && _this.cartItem.schemeName;
          _this.fundName = _this.fundName ? _this.fundName: _this.cartItem.fundName;
          _this.fundCode = _this.fundCode ? _this.fundCode: _this.cartItem.fundCode;
          _this.formData.schemeCode = _this.cartItem && _this.cartItem.schemeCode;
          _this.formData.cartItemId = _this.cartItem && _this.cartItem.cartItemId;
          if (!angular.isUndefined(_this.cartItem)) {
            _this.allFundForm.isRegular = identifyRegular();
          }
          if(_this.cartItem && !_this.cartItem.sipOpted) {
            _this.formData.sipOpted = false;
          }
          if (_this.cartItem && !_this.cartItem.purchaseOpted) {
            _this.formData.purchaseOpted = false;
          }
          if (_this.cartItem && _this.cartItem.brokerCode === 'DIRECT') {
            _this.formData.isDirectFund = true;
          }
          if ( _this.cartItem && _this.cartItem.sipDate) {
            _this.formData.startDate = moment(_this.cartItem.sipDate ,'DD-MMM-YYYY');
            _this.setFromData = true;
          } else {
            _this.setFromData = false;
          }
          fetchSchemeList();
        }

        function addTransactionFields(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = true;
            angular.element(document.getElementById('scrollTo')).animate({scrollTop: 0}, 500);
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = true;
          }
          if(_this.formData.sipOpted) {
            _this.formData.startDate = null;
            _this.formData.endDate = null;
            //_this.formData.installmentDisplayAmount = _this.cartItem && _this.cartItem.installmentAmount ? _this.cartItem.installmentAmount : _this.formData.installmentDisplayAmount ? _this.formData.installmentDisplayAmount : _this.sipValidation.sipDefaultAmount;
            _this.formData.installmentDisplayAmount = _this.formData.installmentAmount ? _this.formData.installmentAmount : _this.cartItem && _this.cartItem.installmentAmount ? _this.cartItem.installmentAmount : _this.sipValidation.sipDefaultAmount;
            changeInstallmentAmount('SIP');
          }
          if (_this.formData.purchaseOpted) {
            _this.formData.displayAmount = _this.formData.amount ? _this.formData.amount : _this.cartItem && _this.cartItem.amount ? _this.cartItem.amount : _this.purchaseValidation.defaultAmount;
            changeInstallmentAmount('PURCHASE');
          }
        }

        function removeTransactionFromList(transaction) {
          if (transaction === 'PURCHASE') {
            _this.formData.purchaseOpted = false;
            _this.formData.displayAmount = null;
          } else if (transaction === 'SIP') {
            _this.formData.sipOpted = false;
            _this.formData.installmentDisplayAmount = null;
            delete _this.formData.startDate;
            delete _this.formData.endDate;
            delete _this.formData.installmentAmount;
          }
        }

        /*
        *  scheme list methods defined here
        * */
        function fetchSchemeList() {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.maximumItemAllowed = resp.data.maximumItemAllowed;
              $window.sessionStorage.setItem('maximumItemAllowed', _this.maximumItemAllowed);
              _this.inSchemeList = resp.data.schemeDetails;
              _this.masterSchemeList = _this.inSchemeList;
              _this.fundName = resp.data.fundName;
              _this.fundCode = resp.data.fundCode;
              _this.maxMandateDurationYears = resp.data.sipSettings && resp.data.sipSettings.eOTM.maxMandateDurationYears;
              _this.NPCINote = _this.getNote.noteDTO.noteDTOMap.Note_NPCI_Info.content.replace('%@', _this.maxMandateDurationYears);
              if (_this.formData.schemeCode) {
                var schemeData = _this.inSchemeList.filter(function(scheme) {
                  return scheme.schemeCode === _this.formData.schemeCode;
                });
                if(schemeData && schemeData.length > 0) {
                  _this.inSchemeChanged(schemeData[0]);
                } else {
                  _this.formData.schemeCode = '';
                  _this.formData.schemeName = '';
                  _this.formData.sipOpted = true;
                  _this.formData.purchaseOpted = true;

                }
              } else {
                _this.inSchemeList.forEach(function(list, index) {
                  if(list.investmentOption === "GROWTH") {
                    _this.inSchemeChanged(list);
                  }
                });
              }
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          EcartService.post({
            child1: 'validate',
            child2: 'fund'
          }, {
            fundCode: _this.fundCode,
            directFund: !_this.allFundForm.isRegular
          }).$promise.then(success, error);
        }

        function filterInSchemeList() {
          _this.formData.schemeCode = '';
          _this.inSchemeList = UtilService.getFilteredList(_this.masterSchemeList, 'schemeName', _this.formData.schemeName);
        }

        function changeSelectedScheme() {
          if (_this.formData.schemeName) {
            var filteredList = UtilService.getFilteredList(_this.inSchemeList, 'schemeName', _this.formData.schemeName);
            inSchemeChanged(filteredList[0]);
          } else {
            _this.formData.schemeCode = null;
          }
        }

        function inSchemeChanged(schemeData) {
          if (!schemeData) {
            return;
          } else {
            _this.formData.schemeCode = schemeData.schemeCode;
            _this.formData.schemeName = schemeData.schemeName;
            _this.formData.schemeType = schemeData.schemeType;
            _this.formData.isDividend = schemeData.investmentOption && schemeData.investmentOption === 'DIVIDEND' ? true : false;
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            _this.schemeType = schemeData.schemeType;
            _this.investmentOptions = [];
            if (schemeData.dividendReinvestmentApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[0]);
            }
            if (schemeData.dividendPayoutApplicable) {
              _this.investmentOptions.push(AppConstants.IDCW_OPTIONS[1]);
            }
            if (_this.formData.isDividend) {
              if (_this.cartItem && _this.cartItem.dividendOption && (_this.cartItem.dividendOption == AppConstants.IDCW_OPTIONS[0].value || _this.cartItem.dividendOption == AppConstants.IDCW_OPTIONS[1].value)) {
                var dividendObject = _this.investmentOptions.find(function (el) {
                  return el.value === _this.cartItem.dividendOption;
                })
                _this.changeInvestmentOptions(dividendObject);
              } else {
                _this.changeInvestmentOptions(_this.investmentOptions[0]);
              }
            }
            _this.purchaseValidation = schemeData.purchaseValidation;
            _this.sipValidation = schemeData.sipValidation;
            if(_this.cartItem && !_this.cartItem.sipOpted) {
              _this.formData.sipOpted = false;
            } else {
              if (_this.sipValidation.sipEnabled === 'Y') {
                _this.formData.sipOpted = true;
              } else {
                _this.formData.sipOpted = false;
              }
            }
            if (_this.cartItem && !_this.cartItem.purchaseOpted) {
              _this.formData.purchaseOpted = false;
            } else {
              if (_this.purchaseValidation.webPurchaseEnabled === 'Y') {
                _this.formData.purchaseOpted = true;
              } else {
                _this.formData.purchaseOpted = false;
              }
            }
            if(_this.formData.sipOpted) {
              _this.formData.installmentDisplayAmount = _this.cartItem && _this.cartItem.installmentAmount ? _this.cartItem.installmentAmount : _this.sipValidation.sipDefaultAmount;
              changeInstallmentAmount('SIP');
            }
            if (_this.formData.purchaseOpted) {
              _this.formData.displayAmount = _this.cartItem && _this.cartItem.amount ? _this.cartItem.amount : _this.purchaseValidation.defaultAmount;
              changeInstallmentAmount('PURCHASE');
            }
          }
        }

        function changeInvestmentOptions(data) {
          if (!data) {
            return;
          }
          _this.formData.investmentOptionName = data.key;
          _this.formData.dividendOption = data.value;
        }

        /*
        *
        * Amount fields methods defined here
        *
        * */

        function changeInstallmentAmount(transaction,calledFromHtml) {
          if (transaction === 'PURCHASE') {
            var amountObj = UtilService.amountInComma(_this.formData.displayAmount);
            _this.formData.displayAmount = amountObj.amountInComma;
            _this.formData.amount = amountObj.amount;
            calculateValidations();
          } else if (transaction === 'SIP') {
            var amountObj = UtilService.amountInComma(_this.formData.installmentDisplayAmount);
            _this.formData.installmentDisplayAmount = amountObj.amountInComma;
            _this.formData.installmentAmount = amountObj.amount;
            calculateValidations();
            getDateValidation(function() {
              if (calledFromHtml) {
                _this.setFromData = false;
              }
              changeStartDate(_this.formData.startDate);
            });
          }
        }

        /*
        *
        * Date fields methods defined here
        *
        * */

        function changeStartDate(date) {
          if (_this.setFromData) {

            if(date !== false) {
              var diff = date.isSame(_this.formData.startDate);
            }

            if (!diff) {
              _this.setFromData = false;
            }
          }
          _this.formData.startDate = date ? date : null;
          _this.formData.day = _this.formData.startDate ? $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format('D') : '';
          _this.formData.endDate = null;
          // _this.startDateError = _this.formData.startDate && !_this.formData.startDate.isSameOrAfter(_this.enabledStartDates[_this.sipValidation.sipTDay]);
          _this.startDateError = _this.formData.startDate && _this.formData.startDate.isBefore(_this.startMinDateBiller);
          updateEndDates();
        }

        function changeEndDate(date) {
          if (date) {
            _this.formData.endDate = date ? date : null;
            if ($window.moment(_this.formData.endDate, "DD-MMM-YYYY").isSame($window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY"))) {
              _this.formData.isTillPerpetuity = true;
            } else {
              _this.formData.isTillPerpetuity = false;
            }
            var emandateEndDate = $window.moment(_this.formData.startDate,'DD-MMM-YYYY').add(_this.maxMandateDurationYears,'years');
            var selectedEndDate = $window.moment(_this.formData.endDate,'DD-MMM-YYYY');
            var endDateEmandateBoundExist = selectedEndDate.isBefore(emandateEndDate);
            if (!endDateEmandateBoundExist) {
              _this.isExceedingEmandateDate = true;
            } else {
              _this.isExceedingEmandateDate = false;
            }
          } else {
            _this.formData.endDate = date ? date : null;
            if(!_this.formData.endDate) {
              _this.formData.isTillPerpetuity = false;
            }
            _this.isExceedingEmandateDate = false;
          }
        }

        function getDateValidation(cb) {
          cb = cb || function () {
          };
          LoaderService.showLoader();
          var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              var currentDate = resp.data.currentDate || Date();
              var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
              var todayDate = $window.moment(Date.parse(parsedDate));
              var counter =0;
              _this.enabledStartDates = [];
              _this.nonBusinessDatess = resp.data.nonBuisnessDates;
              _this.startMinDateBiller = $window.moment(Date.parse(parsedDate)).add(_this.sipValidation.sipTDay, 'days'); // t+17 need to change it to dynamically variable.
              _this.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days');
              var startDate = todayDate.clone();
              var freq = _this.startMaxDate.diff(todayDate, 'days');
              for (var i = 0; i <= freq; i++) {
                var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
                var isEnable = true;
                // if(counter<5)
                // {
                //   angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                //     if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')===0){
                //       isEnable = false;
                //     }
                //   });
                // }
                if(isEnable){
                  _this.enabledStartDates.push(startDate.clone().add(i, 'days'));
                  counter++;
                }
              }
              // _this.enabledFirstStartDate = angular.copy(_this.enabledStartDates[0]);
              _this.formData.startDate =  _this.formData.startDate ?  _this.formData.startDate :_this.enabledStartDates[_this.sipValidation.sipTDay];
              cb();
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          EcartService.get({
            child1: 'nonBusinessDate',
            schemeCode: _this.formData.schemeCode //'AFWDQ'
          }).$promise.then(success, error);
        }

        function updateEndDates() {
          if (!_this.formData.startDate) {
            return;
          }
          var defaultEndDate = $window.moment((new Date()), "DD-MM-YYYY").add(99, 'years');
          var defaultMonths = null;
          var endDate = null;
          var enabledEndDates = [];
          var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber || 0;
          var i = 0;
          var frequency = {
            "name": "Monthly",
            "code": "OM",
            "duration": 1
          };
          var months = 0;
          endDate = _this.formData.startDate.clone();
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          var minInstallments = _this.validations && _this.validations.minInstallments && _this.validations.minInstallments || 0;
          _this.enabledEndDates = enabledEndDates.slice(minInstallments);
          _this.enabledEndDateView = angular.copy(_this.enabledEndDates[0]);
          if (_this.setFromData) {
            if ( _this.cartItem && _this.cartItem.toDate) {
              _this.formData.endDate = moment(_this.cartItem.toDate ,'DD-MMM-YYYY');

              var enabledEndDateMaxYear = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]).year();
              _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + enabledEndDateMaxYear;
              _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");


              var isBetween = (($window.moment(_this.tillPerpetuityEndDate).isBetween($window.moment(_this.enabledEndDates[0]), $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]))) || (_this.tillPerpetuityEndDate.isSame($window.moment(_this.enabledEndDates[0]))) || (_this.tillPerpetuityEndDate.isSame($window.moment(_this.enabledEndDates.length - 1))));

              if (!isBetween) {
                _this.tillPerpetuityEndDate .set('year', enabledEndDateMaxYear - 1);
              }

              if ($window.moment(_this.tillPerpetuityEndDate).year() > 2099) {
                _this.tillPerpetuityEndDate.set('year', 2099);
              }

            }
          } else {
            _this.formData.isTillPerpetuity = true;
            changeTillPerpetuity();
          }
          checkEnableEndDate();
        }

        function changeTillPerpetuity() {
          _this.frequency = {
            "name": "Monthly",
            "code": "OM",
            "duration": 1
          };
          if (_this.formData.isTillPerpetuity) {
             var enabledEndDateMaxYear = $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]).year();
            _this.tillPerpetuityEndDate = $window.moment(_this.formData.startDate).date() + '-' + ($window.moment(_this.formData.startDate).month() + 1) + '-' + enabledEndDateMaxYear;
            _this.tillPerpetuityEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MM-YYYY");
            var calculatedEndDate = $window.moment(_this.tillPerpetuityEndDate, "DD-MMM-YYYY");

            if (calculatedEndDate && (($window.moment(calculatedEndDate).isBetween($window.moment(_this.enabledEndDates[0]), $window.moment(_this.enabledEndDates[_this.enabledEndDates.length - 1]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates[0]))) || (calculatedEndDate.isSame($window.moment(_this.enabledEndDates.length - 1))))) {
              _this.formData.endDate = angular.copy(calculatedEndDate);
            } else {
              calculatedEndDate.set('year', enabledEndDateMaxYear - 1);
              if (!_this.moment(calculatedEndDate).isValid()) {
                var newday = _this.moment().date();
                var newMonth = _this.moment(_this.formData.startDate, 'DD-MMM-YYYY').month();
                var newEndDateCal = newday + '/'+ (newMonth + 1) +'/2099';
                var endDateCal = _this.moment(newEndDateCal, "DD-MM-YYYY");
                var initialStartDate = _this.formData.startDate.clone().day(1)
                endDateCal = initialStartDate.endOf(newMonth + 1).year(2099);
              }
              if(endDateCal){
                var defaultMonths = UtilService.getNumberOfMonths(_this.formData.startDate.clone().add(_this.frequency, 'months'), $window.moment(endDateCal));
                var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber || 0;
                var freq = freq || Math.floor(defaultMonths / _this.frequency.duration);
                var freq = _this.sipValidation && _this.sipValidation.monMaxInstallmentNumber ? freq - 1 : freq;
                var months = _this.frequency.duration * freq;
                _this.formData.endDate = _this.formData.startDate.clone().add(months, 'months');
                _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
              } else {
                _this.tillPerpetuityEndDate = angular.copy(calculatedEndDate);
                _this.formData.endDate = angular.copy(calculatedEndDate);
              }
            }

            if ($window.moment(_this.formData.endDate).year() > 2099) {
              _this.formData.endDate.set('year', 2099);
              _this.tillPerpetuityEndDate = angular.copy(_this.formData.endDate);
            }

          } else {
            _this.formData.endDate = null;
          }

          checkEnableEndDate();
        }

        function sidebarOrReviewSaveCartEdited(){
          if(_this.isFromReview){
            _this.dataAfterInitiateCart = JSON.parse($window.sessionStorage.getItem('cartDetails'));
            var payload = getUpdatePayload();
              _this.dataAfterInitiateCart.cartItems.forEach(function(item, index){
              if(item.cartItemId === payload.cartItemId){
                payload.fundCode = _this.dataAfterInitiateCart.cartItems[index].fundCode;
                payload.fundName = _this.dataAfterInitiateCart.cartItems[index].fundName;
                _this.dataAfterInitiateCart.cartItems[index] = payload;
              }
            });
            $window.sessionStorage.setItem('cartDetails',JSON.stringify(_this.dataAfterInitiateCart));
            _this.updateInfo();
            collapse();
          } else {
            saveCartEdited();
          }
        }
        function saveCartEdited() {

          LoaderService.showLoader();
          var payload = getUpdatePayload();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.updateInfo();
              // collapse();
              setSideBarState('ECART');
              resetValues();
            } else {
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          EcartService.post2({
            child1: 'cart',
            child2: 'update',
            child3: 'item'
          }, payload).$promise.then(success, error);
        }

        function sidebarOrReviewAddToCart(){
          if(_this.isFromReview){
            _this.dataAfterInitiateCart = JSON.parse($window.sessionStorage.getItem('cartDetails'));
            var payload = getPayload();
            checkChildAndRetirementFund(payload);
            var maximumItem = parseInt($window.sessionStorage.getItem('maximumItemAllowed'));
            if(!_this.isValidFundToAdd) {
              if (_this.dataAfterInitiateCart && _this.dataAfterInitiateCart.cartItems.length < maximumItem) {
                payload.fundCode = _this.fundCode;
                payload.fundName = _this.fundName;
                payload.schemeName = _this.formData.schemeName;
                _this.dataAfterInitiateCart.cartItems.forEach(function (item, i) {
                  payload.cartItemId = "TXNID" + (i + 1);
                });
                _this.dataAfterInitiateCart.cartItems.push(payload);
                $window.sessionStorage.setItem('cartDetails', JSON.stringify(_this.dataAfterInitiateCart));
                _this.updateInfo();
                collapse();
              } else {
                MessageService.error('You can not add more than ' + maximumItem +' investment items in the e-cart');
              }
            }
          } else {
            addToCart();
          }
        }

        function checkChildAndRetirementFund(payload){
          var countMinorScheme = [];
          var countRetiredScheme = [];
          if(_this.dataAfterInitiateCart){
            _this.dataAfterInitiateCart.cartItems.forEach(function(item,index){
              countMinorScheme.push(item.cgfApplicable);
              countRetiredScheme.push(item.retirementApplicable);
            })
          }
          countMinorScheme.push(payload.cgfApplicable);
          countRetiredScheme.push(payload.retirementApplicable);
          for(var i=0; i< countMinorScheme.length;i++){
            for(var j=0; j< countRetiredScheme.length; j++){
              if((countMinorScheme[i] && countRetiredScheme[j]) == true){
                MessageService.error('Children’s Gift Fund & Retirement Fund cannot be added together.');
                _this.isValidFundToAdd = true;
                return;
              }
              // else if((countRetiredScheme[j] == true && payload.minorFlag == true) || (countMinorScheme[i] == true && payload.minorFlag == false)){
              //   MessageService.error(payload.schemeName + " is not applicable for the selected scheme folio.");
              //   _this.isValidFundToAdd = true;
              //   return;
              // }
              else {
                _this.isValidFundToAdd = false;
              }
            }
          }
        }

        function addToCart() {
          var payload = getPayload();
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.updateInfo();
              MessageService.success(resp.data.message);
              // collapse('saved');
              setSideBarState('ECART');
              $rootScope.$broadcast('UpdateCart', {listUpdated: true});
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          }
          EcartService.post2({
            child1: 'cart',
            child2: 'add',
            child3: 'item'
          }, payload).$promise.then(success, error);
        }

        function getPayload() {
          if (_this.cartItem && _this.cartItem.addTocart && !_this.fromInitiateCart && !_this.fromEquityAsset) {
            var payload = _this.cartItem;
            payload.purchaseOpted = _this.formData.purchaseOpted;
            payload.sipOpted = _this.formData.sipOpted;
            payload.amount = _this.formData.amount;
            payload.dividendOption = _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.DIVIDEND_OPTIONS.GROWTH;
            payload.cgfApplicable =  _this.inSchemeList[0].cgfApplicable;
            payload.retirementApplicable = _this.inSchemeList[0].retirementApplicable;
            payload.frequency =  "OM";
            if (_this.cartItem.sipOpted) {
              payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.sipDay = _this.formData.day;
              payload.installmentAmount = _this.formData.installmentAmount;
            }
          } else {
            var payload = {
              "schemeCode": _this.formData.schemeCode,
              "amount": _this.formData.amount,
              "dividendOption": _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.DIVIDEND_OPTIONS.GROWTH,
              "brokerCode": _this.investorData && _this.investorData.brokerCode ? _this.investorData.brokerCode: 'DIRECT',
              "subBrokerCode": _this.investorData && _this.investorData.subBrokerCode ? _this.investorData.subBrokerCode: null,
              "subBrokerArn": _this.investorData && _this.investorData.subBrokerArn ? _this.investorData.subBrokerArn: null,
              "euinOpted": _this.investorData && _this.investorData.euinOpted ? _this.investorData.euinOpted: 'N',
              "euinCode": _this.investorData && _this.investorData.euinCode ? _this.investorData.euinCode: null,
              "euinName": _this.investorData && _this.investorData.euinName ? _this.investorData.euinName: null,
              "liquid": _this.schemeType === 'LIQUID' ? true: false,
              "folioNumber": _this.cartItem && _this.cartItem.folioNumber ? _this.cartItem.folioNumber: null,
              "cgfApplicable": _this.inSchemeList[0].cgfApplicable,
              "minorFlag": _this.investorData && _this.investorData.minorFlag ? _this.investorData.minorFlag: false,
              "riaConsent": _this.investorData && _this.investorData.riaConsent ? _this.investorData.riaConsent: false,
              "brokerKey": _this.investorData && _this.investorData.brokerKey ? _this.investorData.brokerKey: null,
              "brokerValue": _this.investorData && _this.investorData.brokerValue ? _this.investorData.brokerValue: null,
              "newUser": false,
              "invType": _this.investorData && _this.investorData.invType ? _this.investorData.invType: null,
              "purchaseOpted": _this.formData.purchaseOpted,
              "sipOpted": _this.formData.sipOpted,
              "frequency": "OM",
              "numberOfInstallment": $window.moment($window.moment(_this.formData.endDate, "DD-MMM-YYYY")).diff($window.moment(_this.formData.startDate, "DD-MMM-YYYY"),'months') + 1,
              "installmentAmount": _this.formData.installmentAmount,
              "investmentOption": _this.formData.isDividend ? 'DIVIDEND': 'GROWTH',
              "retirementApplicable": _this.inSchemeList[0].retirementApplicable,
              "schemeName": _this.formData.schemeName,
              "sipDay": _this.formData.day
            };

            if (_this.formData.sipOpted) {
              payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
              payload.sipDay = _this.formData.day;
            }
            if(_this.fromInitiateCart){
              payload.cartItemId = 'TXNID0';
              payload.fundCode = _this.fundCode;
            }
          }
          return payload;
        }

        function getUpdatePayload() {
          var payload = {};
          payload.cartItemId = _this.cartItem.cartItemId;
          payload.schemeCode = _this.formData.schemeCode;
          payload.schemeName = _this.formData.schemeName;
          payload.dividendOption = _this.formData.isDividend ? _this.formData.dividendOption : _this.appConstants.DIVIDEND_OPTIONS.GROWTH;
          payload.folioNumber = _this.cartItem && _this.cartItem.folioNumber ? _this.cartItem.folioNumber : null;
          payload.sipOpted = _this.formData.sipOpted;
          payload.purchaseOpted = _this.formData.purchaseOpted;
          payload.minorFlag = _this.investorData && _this.investorData.minorFlag? _this.investorData.minorFlag: false;
          payload.brokerCode = _this.investorData && _this.investorData.brokerCode;
          payload.installmentAmount = _this.formData.installmentAmount;
          payload.amount = _this.formData.amount;
          payload.invType = _this.investorData && _this.investorData.invType;
          payload.euinOpted = _this.investorData && _this.investorData.euinOpted ? _this.investorData.euinOpted: 'N';
          payload.frequency = "OM";
          payload.riaConsent = _this.investorData && _this.investorData.riaConsent ? _this.investorData.riaConsent: false;
          payload.liquid = _this.schemeType === 'LIQUID' ? true: false;
          if (_this.formData.sipOpted) {
            payload.sipDate = $window.moment(_this.formData.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.toDate = $window.moment(_this.formData.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
            payload.sipDay = _this.formData.day;
          }
          return payload;
        }

        function resetValues() {
          _this.formData = {};
          _this.investThroughFormData = {};
          _this.formData.sipOpted = true;
          _this.formData.purchaseOpted = true;
          _this.allFundForm.regularDirectError = null;
        }

        /*--------------------------------------- All funds section starts from here ---------------------------------*/
        function fetchFunds() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              _this.allFunds = resp.data.funds;
              _this.allFundForm.isRegular = true;
              filterDirectAndRegularFunds(function() {
                _this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
                // handleRiskRating(_this.funds);
                LoaderService.hideLoader();
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          CmsEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'detail'
          }).$promise.then(success, error);
        }

        function fetchFundsFilters() {
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              var filters = resp.data;
              _this.filterList = [];
              Object.keys(filters).forEach(function(filter) {
                var filterOptions = [];
                filters[filter].forEach(function(option) {
                  var filterOption = {
                    key: option,
                    value: option,
                    checked: false
                  };
                  filterOptions.push(filterOption);
                });
                var obj = {
                  filterName: titleCase(filter),
                  filterKey: filter.replaceAll(" ", "") === 'riskRating' ? 'riskReturnProfile' : filter.replaceAll(" ", "") === "fundCategories" || filter.replaceAll(" ", "") === "fundCategory" ? 'fundCategory' : filter.replaceAll(" ", ""),
                  filterOptions: filterOptions
                };
                _this.filterList.push(obj);
              });
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          CmsEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'filter',
            child5: 'option'
          }).$promise.then(success, error);
        }

        function displayCagrValue(fund) {
          if (_this.allFundForm.isRegular) {
            fund.regularCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.regularCagr = x.value;
              }
            });
          } else if (!_this.allFundForm.isRegular) {
            fund.directCagrReturns.forEach(function (x) {
              if(x.key === fund.selectedYear) {
                fund.directCagr = x.value;
              }
            });
          }
        }

        function openFilter() {
          //angular.element(document.getElementsByClassName('filter-row')).toggle();
          angular.element(document.getElementsByClassName('filter-row')).toggleClass('showSidebar');
        }

        function filterDirectAndRegularFunds(cb) {
          _this.regularFunds = [];
          _this.directFunds= [];
          _this.allFunds.forEach(function(funds) {
            funds.selectedYear = 'Since Inception';
            if (funds.regularScheme.length > 0) {
              var returnsArray = [];
              funds.regularCagrReturns = [];
              if (!angular.equals(funds.fundNavRegular) && !angular.equals(funds.fundNavRegular.annualisedreturns)) {
                if(funds.fundNavRegular.annualisedreturns) {
                  Object.keys(funds.fundNavRegular.annualisedreturns).forEach(function (key) {
                    if (key === '5') {
                      funds.regularCagr = funds.fundNavRegular.annualisedreturns[key];
                    }
                    var obj = {
                      key: key === 11 || key === '11' ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                      value: funds.fundNavRegular.annualisedreturns[key]
                    };
                    returnsArray.push(obj);
                  });
                }
              }
              funds.regularCagrReturns = returnsArray;
              _this.regularFunds.push(funds);
            }
            if(funds.directScheme.length > 0) {
              var returnsArray = [];
              funds.directCagrReturns = [];
              if (!angular.equals(funds.fundNavDirect, {}) && !angular.equals(funds.fundNavDirect.annualisedreturns, {})) {
                if(funds.fundNavDirect.annualisedreturns) {
                  Object.keys(funds.fundNavDirect.annualisedreturns).forEach(function (key) {
                    if (key === '5') {
                      funds.directCagr = funds.fundNavDirect.annualisedreturns[key];
                    }
                    var obj = {
                      key: key === "11" || key === 11 ? 'Since Inception' : key === 1 || key === '1' ? key + ' Year' : key + ' Years',
                      value: funds.fundNavDirect.annualisedreturns[key]
                    };
                    returnsArray.push(obj);
                  });
                }
              }
              funds.directCagrReturns = returnsArray;
              _this.directFunds.push(funds);
            }
          });
          cb();
        }

        function changeFundsListing() {
          /*_this.allFundForm.isRegular = !_this.allFundForm.isRegular;*/
          if (_this.investorData && _this.investorData.investThroughDistributor && !_this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through Distributor in your cart. Please select Regular fund to proceed.';
            _this.funds = [];
          } else if (_this.investorData && _this.investorData.investThroughDirect && _this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through Direct in your cart. Please select Direct fund to proceed.';
            _this.funds = [];
          } else if (_this.investorData && _this.investorData.investThroughRIA && _this.allFundForm.isRegular) {
            _this.allFundForm.regularDirectError = 'You have opted invest through RIA in your cart. Please select Direct fund to proceed.';
            _this.funds = [];
          } else {
            _this.allFundForm.regularDirectError = null;
            _this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
          }
          //_this.funds = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
          if(angular.element(document.getElementsByClassName('filter-row')).hasClass('showSidebar')) {
            angular.element(document.getElementsByClassName('filter-row')).removeClass('showSidebar');
            _this.filterList = angular.copy(AppConstants.ALL_FUNDS_FILTER);
            _this.filterValues = [];
            _this.filterList.forEach(function(list){
              list.filterOptions.forEach(function(option) {
                option.checked = false;
              });
            });
          }
        }

        function filterFunds(key, filterOptions) {
          _this.allFormData.searchModel = null;
          if (_this.allFundForm.regularDirectError === null) {
            var fundsToBeFiltered = _this.allFundForm.isRegular ? _this.regularFunds : _this.directFunds;
            filterOptions.forEach(function(option) {
              if (option.checked) {
                if (!_this.filterValues.includes(option.value)) {
                  _this.filterValues.push(option.value);
                }
              } else if (!option.checked && _this.filterValues.includes(option.value)) {
                var index = _this.filterValues.indexOf(option.value);
                if (index > -1) {
                  _this.filterValues.splice(index, 1);
                }
              }
            });
            if (_this.filterValues.length > 0) {
              if (key === 'timeHorizons') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.timeHorizon);
                });
              } else if (key === 'riskRatings') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds.riskReturnProfile[0]);
                });
              } else if (key === 'goalTypes') {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  if (funds.goalsType.length > 0) {
                    return isEqual(funds.goalsType, _this.filterValues);
                  }
                });
              } else {
                var filteredFunds = fundsToBeFiltered.filter(function(funds) {
                  return _this.filterValues.includes(funds[key][0]);
                });
              }
              _this.funds = filteredFunds;
              _this.selectFilterFund = filteredFunds;
            } else {
              _this.funds = fundsToBeFiltered;
              _this.selectFilterFund = filteredFunds;
            }
          }
        }

        function moveToCartDetails(fund) {
          if (_this.investorData && _this.investorData.selectedFolioData) {
            var data = fund;
            data.retirementFlag = data && data.regularScheme[0].retirementFlag;
            var showRetirementSchemeError = UtilService.checkForRetirementScheme(data, _this.investorData.selectedFolioData);
            if (showRetirementSchemeError) {
              MessageService.error(_this.investorData.selectedFolioData.retirementSchemeBlankDOBErrorMsg);
              return;
            }
          }
          _this.fundName = fund.fundName;
          _this.fundCode = fund.fundCode;
          setSideBarState('CART_DETAILS');
        }

        function searchRecords() {
          var fundsToBeFiltered =_this.selectFilterFund ? _this.selectFilterFund: _this.regularFunds;
          if (_this.allFormData.searchModel.length > 0) {
            var filteredFunds = fundsToBeFiltered.filter(function(fund) {
              return fund.fundName.toLowerCase().includes(_this.allFormData.searchModel.toLowerCase());
            });
            _this.funds = filteredFunds;
          } else {
            _this.funds = fundsToBeFiltered;
          }
        }

        /*--------------------------------------- ECART section starts from here -------------------------------------*/
        function fetchInvestmentAdded() {
          LoaderService.showLoader();
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              _this.cartDetails = resp.data;
              _this.maximumItemAllowed = _this.cartDetails.maximumItemAllowed;
              $window.sessionStorage.setItem('maximumItemAllowed', _this.maximumItemAllowed);
              // _this.investmentList = _this.cartDetails.cartItems;
              if(_this.cartDetails.cartItems){
                var sum = 0;
                _this.totalSum = sum;

                _this.cartDetails.cartItems.forEach(function (item,index) {
                  sum = sum + item.amount + item.installmentAmount;
                });

                _this.totalSum = sum;
              }
              $rootScope.$broadcast('UpdateCart', {listUpdated: true});
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          EcartService.get2({
            child1: 'cart',
            child2: 'item',
            child3: 'list'
          }).$promise.then(success, error);
        }

        function fetchSuggestion() {
          _this.formData.yearSelected = []
          LoaderService.showLoader();
          var success = function(resp) {
            if (resp.status && resp.data) {
              _this.suggestionList = resp.data.trending;
              if(_this.suggestionList) {
                _this.suggestionList.forEach(function (key, index) {
                  _this.formData.yearSelected[index] = "11";
                  showCagrValue(index);
                })
                // handleRiskRating(_this.suggestionList);
                $timeout(function () {
                  handleTrendingFund();
                }, 50);

              }

              LoaderService.hideLoader();
            } else {
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
          CmsEcartService.get({
            child1: 'new',
            child2: 'user',
            child3: 'fund',
            child4: 'trending'
          }).$promise.then(success, error);

        }

        // function handleRiskRating(suggestionListRating){
        //   _this.ratingArray = [];
        //   if(suggestionListRating) {
        //     suggestionListRating.forEach(function (risk,index) {
        //       if(risk.riskReturnProfile[0] && Array.isArray(risk.riskReturnProfile)){
        //         _this.ratingArray.push(risk.riskReturnProfile[0].replace('risk', '').trim());
        //       } else if(risk.riskReturnProfile && !Array.isArray(risk.riskReturnProfile)) {
        //         _this.ratingArray.push(risk.riskReturnProfile.replace('risk', '').trim());
        //       }
        //     })
        //   }
        // }
        function showCagrValue(index) {
          Object.keys(_this.suggestionList[index].annualisedReturns).forEach(function (x, i) {
            if(_this.formData.yearSelected && x === _this.formData.yearSelected[index]) {
              _this.suggestionList[index].cagrValue = _this.suggestionList[index].annualisedReturns[x];
            }
          });
        }

        function redirectToSummary() {
          var tncArray = [];
          _this.cartDetails.cartItems.forEach(function (el, index) {

            if (el.sipOpted && el.purchaseOpted) {
              _this.formData.tncType = 'SIPPURCHASE';
              return;
            } else if (el.sipOpted && !el.purchaseOpted) {
              tncArray.push('SIP');
            } else if (!el.sipOpted && el.purchaseOpted) {
              tncArray.push('PURCHASE');
            }
          });


          if (!_this.formData.tncType) {
            var sipInstanceArr = tncArray.filter(function (el) {
              return el === 'SIP';
            });

            var purchaseInstanceArr = tncArray.filter(function (el) {
              return el === 'PURCHASE';
            });


            if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length >= 1) {
              _this.formData.tncType = 'SIPPURCHASE';
            } else if (sipInstanceArr.length === 0 && purchaseInstanceArr.length >= 1) {
              _this.formData.tncType = 'PURCHASE';
            } else if (sipInstanceArr.length >= 1 && purchaseInstanceArr.length === 0) {
              _this.formData.tncType = 'SIP';
            }

          }
          EcartModel.setPayloadPayment(_this.investorData.folioNumber, _this.cartDetails.cartItems,
            _this.cartDetails.previousTransactionStatus, _this.cartDetails.minorFlag , _this.formData.tncType , _this.totalSum);
          $state.go("main.transactions.paymentPage");
        }

        function calculateValidations() {
          _this.validations = {};
          if(_this.sipValidation.additionalValidation && _this.sipValidation.additionalValidation.OM){
            var newValidation =  _this.sipValidation.additionalValidation.OM;
            for (var i = 0; i < newValidation.length; i++){
              var condition = _this.formData.installmentAmount < newValidation[i].min_amount_lower ||  _this.formData.installmentAmount <= newValidation[i].min_amount_upper
              if(!newValidation[i].min_amount_upper){
                var condition = true;
              }
              if(condition)
              {
                _this.validations.amountMultiples = newValidation[i].amt_multiples;
                _this.validations.maxAmount = newValidation[i].min_amount_upper;
                _this.validations.minAmount = newValidation[i].min_amount_lower;
                _this.validations.minInstallments = newValidation[i].min_installments;
                break;
              }
            }
          }
          _this.isMax = !!(_this.validations.maxAmount && _this.validations.maxAmount < _this.formData.installmentAmount);
          _this.isMin = !!(_this.validations.minAmount && _this.validations.minAmount > _this.formData.installmentAmount);
          _this.isMultiples = _this.validations.amountMultiples && _this.formData.installmentAmount && (_this.formData.installmentAmount % _this.validations.amountMultiples === 0) || false;

          if(_this.formData.installmentAmount >= 2000000){
            _this.amountExceeded = true;
          }else {
            _this.amountExceeded = false;
          }


          if (_this.purchaseValidation) {
            _this.isPurchaseMin = _this.purchaseValidation.minFirstPurchaseAmt > _this.formData.amount ;
            _this.purchaseMinAmount = _this.purchaseValidation.minFirstPurchaseAmt;
            _this.isMultiplesPurchase = _this.purchaseValidation.purchaseMultiple && _this.formData.amount  && (_this.formData.amount  % _this.purchaseValidation.purchaseMultiple === 0) || false;
            if(_this.formData.amount % 1 != 0){
              _this.isPurchaseAmountDecimal = true;
            }
            else{
              _this.isPurchaseAmountDecimal = false;
            }
          }
        }

        function titleCase(str) {
          str = str.split(/(?=[A-Z])/);
          for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
          }
          return str.join(' ');
        }

        function isEqual(a, b) {
          var arr = [];
          for (var i = 0; i < b.length; i++) {
            if (a.includes(b[i])) {
              arr.push(true);
            } else {
              arr.push(false);
            }
          }
          return arr.includes(true);
        }

        function identifyRegular() {
          if(_this.investorData && (_this.investorData.directOpted || _this.investorData.riaConsent)) {
            return false;
          } else {
            return true;
          }
        }

        function addTrendingFund(suggestedFund){
          if(_this.cartItem){
            _this.cartItem = undefined;
          }
          _this.formData.cartItemId = undefined;
          _this.formData.schemeCode = undefined;
          _this.formData.startDate = null;
          _this.formData.endDate = null;
          _this.suggestedFundData = suggestedFund;
          _this.fundName = suggestedFund.fundName;
          _this.fundCode = suggestedFund.fundCode;
          _this.showAddCart = true;
          _this.allFundForm.isRegular = true;
          setSideBarState('CART_DETAILS');
        }
        _this.scrollToTop = function () {
          angular.element(document.getElementById('scrollTo')).animate({scrollTop: 1500}, 500);
          return false;
        };


        _this.updateSideBar = function (transactionType) {
          if (transactionType) {
            $timeout(function () {
              search(transactionType);
            }, 50);
          }
          $rootScope.$emit('UpdateSideBar');
          if(_this.fromInitiateCart){
            var payload = getPayload();
            _this.cartDetails = {
              cartItems: [],
              maxMandateDurationYears: _this.maxMandateDurationYears
            };
            _this.cartDetails.cartItems.push(payload);
            $window.sessionStorage.setItem('cartDetails',JSON.stringify(_this.cartDetails));
          } else {
            $window.sessionStorage.setItem('cartDetails',JSON.stringify(_this.cartDetails));
          }

        };


        var search = function (transactionType) {
          var identifierData = AuthService.getToken();
          if (!identifierData || !identifierData.arnCode) {
            MessageService.error('Unable to get arnCode');
            $state.go('main.dashboard');
            return;
          }
          var success = function (investor) {
              if (investor && investor.uuid) {
                switch (transactionType) {
                  case 'Cart':
                    transactionType = 'E_CART';
                    break;
                }
                collapse('saved');
                var _state = 'main.cartReview';
                $state.go(_state,{
                  uuid: investor.uuid});
              } else {
                MessageService.error('Unable to get uuid of selected investor');
              }
            },
            error = function () {
              $state.go('main.dashboard');
            };
          // resetTransactionInitiateModel();
          if(_this.investorUUID && _this.showAddCart){
            collapse('saved');
            var _state = 'main.cartReview';
            $state.go(_state,{uuid: _this.investorUUID});
          } else {
            ModalService.searchInvestorModal({
              transactionType: transactionType,
              arnCode: identifierData.arnCode
            }, success, error);
          }
        };

        function editTransactionFromCart(screen, item) {
          _this.cartItem = {};
          _this.showSaveCart = true;
          _this.showAddCart = false;
          switch (screen) {
            case 'CART_DETAILS':
              _this.cartItem = item;
              _this.isEdit = true;
              _this.fundName = '';
              _this.fundCode = '';
              _this.fromEquityAsset = false;
              setSideBarState('CART_DETAILS');
              break;
          }
        }

        function removeTransactionFromCart(item) {
          var success = function(resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              // setSideBarState('ECART');
              _this.cartDetails = resp.data;
              _this.cartItemList = resp.data.cartItems ? resp.data.cartItems : [];
              if (_this.cartItemList) {
                _this.totalSum = _this.cartDetails.totalAmount + _this.cartDetails.totalInstallmentAmount;
              }
              $rootScope.$broadcast('UpdateCart', {listUpdated: true});
              handleTrendingFund();
            } else {
              _this.cartItem.cartItemList = [];
              MessageService.error(resp.message);
            }
          }, error = function(err) {
            _this.cartItem.cartItemList = [];
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };

          var confirmSuccess = function () {
            LoaderService.showLoader();
            EcartService.get2({
              child1: 'cart',
              child2: 'delete',
              child3: 'item',
              child4: item.cartItemId
            }).$promise.then(success, error);
          } , confirmError = function () {};

          ModalService.confirmCancelModalEcart({text: "Are you sure you want to remove <strong>" + item.schemeName + "</strong> from the cart?"}, confirmSuccess, confirmError);
        }

        function handleTrendingFund(){
          var tempFund = [];
          if(_this.cartDetails.total == 0) {
            _this.suggestionList.forEach(function(item,index){
              if(index < 3) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails.total == 1){
            _this.suggestionList.forEach(function(item,index){
              if(index < 2) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails.total == 2){
            _this.suggestionList.forEach(function(item,index){
              if(index < 1) {
                tempFund.push(item)
              }
            })
          } else if(_this.cartDetails.total == 3){
            _this.suggestionList.forEach(function(item,index){
              tempFund = [];
            })
          }
          _this.showingTrendingFunds = tempFund;
        }

        _this.autoDate = function(type){
          if(type=='startDate') {
            var oldlength = 0;
            if (_this.startDateString) {
              oldlength = _this.startDateString.length;
            }
            _this.startDateString = $("#startDateId").val();
            var newlength = _this.startDateString.length;
            if (_this.startDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }
            if (_this.startDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#startDateId").val(_this.startDateString + "-");
              }
            }

          } else if(type=='endDate'){
            var oldlength = 0;
            if (_this.endDateString) {
              oldlength = _this.endDateString.length;
            }
            _this.endDateString = $("#endDateId").val();
            var newlength = _this.endDateString.length;
            if (_this.endDateString.length == 2) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
            if (_this.endDateString.length == 6) {
              if ((newlength == (oldlength - 1)) || (newlength == oldlength)) {
              } else {
                $("#endDateId").val(_this.endDateString + "-");
              }
            }
          }
        }

        function checkEnableEndDate(){
          _this.isEndDateFound = false;
          if(_this.enabledEndDates) {
            _this.enabledEndDates.forEach(function (item) {
              if (item.isSame(_this.formData.endDate)) {
                _this.isEndDateFound = true;
              }
            })
          }
          if (_this.formData.endDate && $window.moment(_this.tillPerpetuityEndDate).year() < 2099) {
           _this.enabledDefaultYear = false;
          } else {
            _this.enabledDefaultYear = true;
          }
        }

        function fetchDynamicDataEcart(cb) {
          cb = cb || function () {
          }
          var successHandler = function(resp) {
            _this.getNote = resp;
            cb(true);
          }
          UtilService.fetchDynamicData("SIP_PURCHASE_E_CART").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
        }



      }
    }
  }
})();

/**
 * Created by ttn on 8/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('UppercrustController', uppercrustController);

  /** @ngInject */
  function uppercrustController($scope, $state, $window) {

    var vm = this;

    vm.uppercrustData = $window.JSON.parse(localStorage.getItem("uppercrustData"));

    if(!vm.uppercrustData){
      $state.go('main.distributorProfile');
    }
    $scope.$on("$destroy", function () {
      localStorage.removeItem("uppercrustData");
    });
  }
})();

/**
 * Created by ttn on 8/12/16.
 */

/**
 * Created by ttn on 28/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('DistributorProfileModal', distributorProfileModal);

  /** @ngInject */
  function distributorProfileModal() {

    var days = {0: 'Sun', 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat'};
    var months = {
      'Jan': 1,
      'Feb': 2,
      'Mar': 3,
      'Apr': 4,
      'May': 5,
      'Jun': 6,
      'Jul': 7,
      'Aug': 8,
      'Sep': 9,
      'Oct': 10,
      'Nov': 11,
      'Dec': 12
    };
    var monthsNum = {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    };

    function earnChartModel(data, type) {
      var tempArr = [];
      var arr = [];
      var i = 0;
      var tempObj = {};
      var max = 0;
      arr.push('EARNING');
      var obj = {
        columns: [],
        categories: [],
        lines: []
      };
      if (data && data.length) {
        if (type == 'WEEKLY') {
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            var date = new Date(data[i].xValue.split('/')[2], months[data[i].xValue.split('/')[1]] - 1, data[i].xValue.split('/')[0]);
            obj.categories.push(days[date.getDay()]);
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
        }
        else if (type == 'MONTHLY') {
          data.sort(function (a, b) {
            return a.xValue - b.xValue;
          });
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            obj.categories.push(data[i].xValue + ' week');
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
        }
        else if (type == 'YEARLY') {
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            if (data[i].xValue) {
              var yearArr = data[i].xValue.split('-');
              data[i].xValue = monthsNum[yearArr[0]] + "'" + yearArr[1].substr(2, yearArr[1].length);
            }
            obj.categories.push(data[i].xValue);
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
        }
      }
      return obj;
    }

    function growthChartModal(data, type) {
      var tempArr = [];
      var arr = [];
      var tempObj = {};
      var i = 0;
      var max = 0;
      arr.push('GROWTH');
      var obj = {
        columns: [],
        categories: [],
        lines: [],
        rotate: 0
      };
      if (data && data.length) {
        if (type == 'WEEKLY') {
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            var date = new Date(data[i].xValue.split('/')[2], months[data[i].xValue.split('/')[1]] - 1, data[i].xValue.split('/')[0]);
            obj.categories.push(days[date.getDay()]);
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
        }
        else if (type == 'MONTHLY') {
          data.sort(function (a, b) {
            return a.xValue - b.xValue;
          });
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            obj.categories.push(data[i].xValue + ' week');
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
        }
        else if (type == 'YEARLY') {
          for (i = 0; i < data.length; i++) {
            tempObj = {};
            tempObj.value = data[i].yValue;
            if (data[i].xValue) {
              var yearArr = data[i].xValue.split('-');
              data[i].xValue = monthsNum[yearArr[0]] + "'" + yearArr[1].substr(2, yearArr[1].length);
            }
            obj.categories.push(data[i].xValue);
            arr.push(data[i].yValue);
            tempArr.push(data[i].yValue);
            obj.lines.push(tempObj);
          }
          max = Math.max.apply(null, tempArr);
          if (max != 0) {
            obj.columns.push(arr);
          }
          obj.rotate = 0;
        }
      }
      return obj;
    }

    return {
      earnChartModel: earnChartModel,
      growthChartModal: growthChartModal
    }
  }
})();

/**
 * Created by ttn on 8/12/16.
 */


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DistributorProfileController', distributorProfileController);

  /** @ngInject */
  function distributorProfileController($timeout, $state, AppConstants, HDFC_API, $rootScope,UppercrustService, ModalService, MessageService, LoaderService, DistributorProfileService, DistributorProfileUploadService,DistributorProfileModal, UtilService, FileUploadService, FileUploadGeneric, AuthService,TransactionDynamicService) {

    var vm = this;
    vm.profileData = {};
    vm.profileImage = null;
    vm.logoImage = null;
    vm.AppConstants = AppConstants;
    // vm.profileData.profileImageUrl = vm.AppConstants.DEFAULT_PROFILE_IMAGE;
    vm.profileData.companyImageUrl = vm.AppConstants.DEFAULT_LOGO;
    vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
    vm.init = init;
    vm.uploadProfileImage = uploadProfileImage;
    vm.uploadLogoImage = uploadLogoImage;
    vm.changePassword = changePassword;
    vm.editNominee = editNominee;
    vm.deleteLogoAndProfileImage=deleteLogoAndProfileImage;
    vm.uppercrustDetails = uppercrustDetails;
    vm.redirectToUppercrust = redirectToUppercrust;
    vm.toggleMarketing = toggleMarketing;
    vm.updateDistributorBank = updateDistributorBank;
    vm.subscribed = true;

    function redirectToUppercrust() {
      $state.go('main.uppercrust');
    }

    function init() {
      profileDetails();
      // uppercrustDetails();
      rmVrmDetails();
    }
    function toggleMarketing() {

      if(!vm.subscribed) {
        vm.subscribed = true;
        var success = function (resp) {
          LoaderService.hideLoader();
          MessageService.success(resp.data.message);
        }, error = function (resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.data.message);
        };

        LoaderService.showLoader();
        DistributorProfileService.post({
          child1: 'marketing',
          child2: 'subscribe'
        }, {unSubscriptionReason:""}).$promise.then(success, error);
      }
      else{
        vm.subscribed = false;
        error = function () {
          vm.subscribedToggleFlag = true;
          vm.subscribed = true;
        };
        ModalService.subscribeToggleModal({folioNumber: vm.folioNo},success,error);
      }
    }
    function profileDetails() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.profileData = resp.data;
            vm.subscribed = (resp.data && resp.data.marketingSubscription);
            vm.subscribedToggleFlag = vm.subscribed;
            resp.data.profileImageUrl = resp.data.profileImageUrl ? resp.data.profileImageUrl : AppConstants.DEFAULT_PROFILE_IMAGE;
            resp.data.companyImageUrl = resp.data.companyImageUrl ? resp.data.companyImageUrl : AppConstants.DEFAULT_LOGO;
            $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.profileImageUrl});
            $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.companyImageUrl});
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      DistributorProfileService.post({controller: 'info'}, {}).$promise.then(success, error);
    }

    function uppercrustDetails() {

      var success = function (resp) {



          LoaderService.hideLoader();
          if (resp.status && resp.data) {

            /*resp.data = {
              "arnCode": "ARN-0411",
              "name": "Richa Tripathi",
              "location": "Jabalpur",
              "categoryA": {
                "offlineGrossSale": 34567,
                "offlinePoints": 98765,
                "onlineGrossSale": 45678,
                "onlinePoints": 56
              },
              "categoryB": {
                "offlineGrossSale": 50239.5,
                "offlinePoints": 561,
                "onlineGrossSale": 8702,
                "onlinePoints": 23
              },
              "categoryC": {
                "offlineGrossSale": 92837.3,
                "offlinePoints": 111,
                "onlineGrossSale": 983,
                "onlinePoints": 37
              },
              "totalGrossSales": 50239.5,
              "totalCatABCPoints": 0,
              "categoryDAAUM": -14459960.55,
              "categoryDPoints": 0,
              "equityAUM": 11105094.19,
              "equityAUMPoints": 6,
              "longTermDebtAUM": 3354866.36,
              "longTermDebtAUMPoints": 1,
              "totalAUMPoints": 7,
              "equityMarketShare": 27,
              "pointsBasedOnEquityMktShareAndWeightageForAUM": 0,
              "totalPoints": 0,
              "minimumGrossSalesMarketShare": 25,
              "netSalesForCATABC": -349300.09,
              "awardedBasedOnPoints" : "Not Qualified",
              "netSalesPercentage": -695.27,
              "qualificationCriteria": 25,
              "finalAwarded": "Not Qualified"
            };*/

            vm.uppercrustData = resp.data;

            localStorage.setItem('uppercrustData', angular.toJson(vm.uppercrustData));

          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);

        };
      LoaderService.showLoader();
      UppercrustService.get({controller: 'distributor',child1:'aum',child2 : 'points'}, {}).$promise.then(success, error);

    }

    function uploadProfileImage(file) {

      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var success = function (resp) {
              LoaderService.hideLoader();
              if (resp.status && resp.data) {
                vm.profileData.profileImageUrl = "";
                $timeout(function () {
                  vm.profileData.profileImageUrl = resp.data.uploadedLogoUrl;
                });
                $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: resp.data.uploadedLogoUrl});
              }
              else {
                MessageService.error(resp.message);
              }
            },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };

          if (file) {
            LoaderService.showLoader();
            var fd = new FormData();
            fd.append('file', file);
            DistributorProfileUploadService.post({
              controller: 'distributor',
              child1: 'uploadPhoto'
            }, fd).$promise.then(success, error);
          }
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }
    }

    function uploadLogoImage(file) {
      if (vm.mimeType.indexOf(file.type) == -1) {
        MessageService.error("Only image file is allowed");
        return;
      }
      if (file) {
        if (file.size <= 8000000) {
          var identifierData = AuthService.getToken();
          if (!identifierData || !identifierData.arnCode) {
            MessageService.error('Unable to get arnCode');
            return;
          }
          var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/uploadLogo';
          LoaderService.showLoader();
          FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoUrl});
              vm.profileData.companyImageUrl = "";
              $timeout(function () {
                vm.profileData.companyImageUrl = resp.data.uploadedLogoUrl;
              });
            } else {
              MessageService.error(resp.message)
            }
          }, function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          });
        }
        else {
          MessageService.error("File size should not be more than 8 MB.")
        }
      }
    }

    function deleteLogoAndProfileImage(photoType) {

      var success=function (resp) {
        if(resp.data.removed) {
          if(photoType=='PROFILE_PHOTO') {
            vm.profileData.profileImageUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
            $rootScope.$broadcast('UpdateProfileImage', {profilePhotoUrl: AppConstants.DEFAULT_PROFILE_IMAGE});
          }
          else if(photoType=='LOGO'){
            vm.profileData.companyImageUrl =  AppConstants.DEFAULT_LOGO;
            $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: AppConstants.DEFAULT_LOGO});
          }
        }
      },
      error=function () {};

      DistributorProfileService.post({
        controller: 'distributor',
        child1: 'image',
        child2:'remove'
      }, {"distriutorPhotoType":photoType}).$promise.then(success, error);
    }

    function changePassword() {
      var success = function (resp) {
        if (resp.data && resp.status) {
          MessageService.success(vm.AppConstants.ToastrMessage.RESET_PASSWORD.SUCCESS);
          logoutMe();
        } else {
          MessageService.error(resp.message);
        }
      };
      ModalService.changePasswordModal({}, success);
    }

    function editNominee() {
      var success = function (result) {
        if (result.status && result.data) {
          MessageService.success("Nominee Details Updated");
          profileDetails();
        } else {
          MessageService.error(result.message);
        }
      };
      ModalService.editNomineeModal(angular.copy(vm.profileData.nominee), success);
    }

    function logoutMe() {
      AuthService.logout().then(function () {
        $state.go('login');
      }, function (err) {
        $state.go('login');
        UtilService.errorHandler(err);
      });
    }

    function updateDistributorBank(){
      sessionStorage.setItem('distributorProfileInfo',angular.toJson(vm.profileData.kydInformation));
      $state.go("main.bankUpdate");
    }

    function rmVrmDetails() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.rmVrmDetails = resp.data;
          }else{
            vm.rmVrmDetails = '';
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      vm.arnCode = sessionStorage.getItem("brokerCodePanAdhar");
        TransactionDynamicService.get({
          VERSION:'v1',
          child1: 'rmvrm',
          child2: 'broker',
          child3: vm.arnCode
        }, null).$promise.then(success, error);
    }
  }
})();

/**
 * Created by ttn on 11/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('EmpanellmentModal', empanellmentModal);

  /** @ngInject */
  function empanellmentModal() {

    var empanellmentObj={
      arnCode:'',
      panNumber:'',
      validUpTo:'',
      otpNumber:'',
      name:'',
      relationShip:'',
      dob:'',
      gurdianName:'',
      gurdianAddress1:'',
      gurdianAddress2:'',
      postalCode:'',
      city:'',
      country:'',
      empanelmentToken:'',
      termaAndConditions:false,
      declaretionArray:[]
    };

    function getEmpanellmentModal() {
      return angular.copy(empanellmentObj);
    }

    function setEmpanellmentModal(val) {
      empanellmentObj=val;
    }

    return {
      getEmpanellmentModal:getEmpanellmentModal,
      setEmpanellmentModal:setEmpanellmentModal
    }

  }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DistributorEmpanellmentController', distributorEmpanellmentController);

  /** @ngInject */
  function distributorEmpanellmentController(UtilService,AuthService, $state, $timeout, ModalService, $stateParams, LoaderService, AppConstants, DistributorEmpanellmentService, DistributorGenericService, MessageService, EmpanellmentModal,toastr,toastrConfig, $scope, $window, $document) {

    var vm = this;

    vm.formData = {};
    vm.date = new Date();
    vm.defaultDate = null; //(new Date());
    vm.activeTab = {arn: false, otp: false, nominee: false, lineclass: 'step1'};
    vm.appConstants = AppConstants;
    vm.listOfBranch = null;
    vm.selectedState = null;
    vm.selectedBranch = null;
    vm.processFlag = false;
    vm.processFlagOtp = false;
    vm.verifyArnInfo = verifyArnInfo;
    vm.submitOtp = submitOtp;
    vm.submitNomineeDetails = submitNomineeDetails;
    vm.Init = Init;
    vm.changeStartDate = changeStartDate;
    vm.changeNomineeDob = changeNomineeDob;
    vm.resendOtp = resendOtp;
    vm.termsAndContitions = termsAndContitions;
    vm.changedDeclaretion = changedDeclaretion;
    vm.confirmCancel = confirmCancel;
    vm.contrast = contrast;
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.isCaptchaShown = true;
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;
    vm.gRecaptchaResponse = '';
    vm.count = 0;
    vm.dynamicInfo=dynamicInfo;
    vm.noteAmfiCircular=null;
    vm.notePreLogin=null;
    vm.goBack = goBack;
    vm.otpValIndex1 = '';
    vm.otpValIndex2 = '';
    vm.otpValIndex3 = '';
    vm.otpValIndex4 = '';
    vm.otpValIndex5 = '';
    vm.otpValIndex6 = '';
    vm.otpValChanged = otpValChanged;
    vm.submitAdditionalDetails = submitAdditionalDetails;
    vm.submitNomineeDetailsCheck = submitNomineeDetailsCheck;
    vm.changeState = changeState;
    vm.listOfBranchAddress = [];


    /**
     * @Desc: This function is used for verify and validate distributor ARN
     */
    function verifyArnInfo() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.formData.empanelmentToken = resp.data.empanelmentToken;
            vm.formData.contactDetailsMsg = resp.data.msg ? resp.data.msg : null;
            EmpanellmentModal.setEmpanellmentModal(vm.formData);
            sessionStorage.setItem(AppConstants.EMPANEL_TOKEN, encodeURI(JSON.stringify(EmpanellmentModal.getEmpanellmentModal())));
            $state.go('distributorempanellment.otp');
          }
          else {
            MessageService.error(resp.message);
            vm.isCaptchaShown = false;
            $timeout(function () {
              vm.isCaptchaShown = true;
            })
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isCaptchaShown = false;
          $timeout(function () {
            vm.isCaptchaShown = true;
          })
        };


      LoaderService.showLoader();
      var payload = {
        "arnCode": 'ARN-' + vm.formData.arnCode,
        "panNumber": vm.formData && vm.formData.panNumber ? AuthService.encryptRSA(angular.copy(vm.formData.panNumber)) : '',
        "gRecaptchaResponse" : vm.gRecaptchaResponse
    };
      DistributorEmpanellmentService.post2({controller: 'verifyARN'}, payload).$promise.then(success, error);
    }

    function submitOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            //vm.formData.empanelmentToken=resp.data.empanelmentToken;
            EmpanellmentModal.setEmpanellmentModal(vm.formData);
            $state.go('distributorempanellment.additionaldetails');
          } else {
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "arnCode": 'ARN-' + vm.formData.arnCode,
        "empanelmentToken": vm.formData.empanelmentToken,
        "otpNumber": vm.formData && vm.formData.otpNumber ? AuthService.encryptRSA(angular.copy(vm.formData.otpNumber.toString())) : ''
      };
      DistributorEmpanellmentService.post2({controller: 'verifyOTP'}, payload).$promise.then(success, error);
    }

    function resendOtp() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.processFlagOtp = true;
            vm.otpValIndex1 = '';
            vm.otpValIndex2 = '';
            vm.otpValIndex3 = '';
            vm.otpValIndex4 = '';
            vm.otpValIndex5 = '';
            vm.otpValIndex6 = '';
            toastrConfig.preventDuplicates = false;
            toastr.success(resp.message, '', {
              onHidden: function () {
                vm.processFlagOtp = false;
                toastrConfig.preventDuplicates = true;
              }
            });
            resetTimer();
          }
          else {
            vm.processFlagOtp = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlagOtp = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "arnCode": 'ARN-' + vm.formData.arnCode,
        "empanelmentToken": vm.formData.empanelmentToken,
        "panNumber": vm.formData && vm.formData.panNumber ? AuthService.encryptRSA(angular.copy(vm.formData.panNumber)) : '' ,
        "validUpTo": vm.formData.validUpTo
      };
      DistributorEmpanellmentService.post2({controller: 'reSendOTP'}, payload).$promise.then(success, error);
    }

    function submitNomineeDetails() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.formData.declaretionArray = [];
            EmpanellmentModal.setEmpanellmentModal(vm.formData);
            sessionStorage.setItem(AppConstants.EMPANEL_TOKEN, encodeURI(JSON.stringify(EmpanellmentModal.getEmpanellmentModal())));
            EmpanellmentDecleration();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "amcBranchId": vm.formData.selectedBranch,
        "arnCode": 'ARN-' + vm.formData.arnCode,
        "empanelmentToken": vm.formData.empanelmentToken,
        "relationShip": vm.formData.relationShip,
        "name": vm.formData.name,
        "city": vm.formData.city,
        "country": vm.formData.country,
        "dob": $window.moment(vm.formData.dob, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
        "gurdianAddress1": vm.formData.gurdianAddress1,
        "gurdianAddress2": vm.formData.gurdianAddress2,
        "gurdianName": vm.formData.gurdianName,
        "postalCode": vm.formData.postalCode
      };
      DistributorEmpanellmentService.post({controller: 'submit'}, payload).$promise.then(success, error);
    }

    function termsAndContitions() {
      ModalService.termConditionModal();
    }

    function Init() {
      vm.formData = EmpanellmentModal.getEmpanellmentModal();
      switch ($state.current.name) {
        case 'distributorempanellment.arn':
          vm.activeTab.arn = true;
          vm.activeTab.otp = false;
          vm.activeTab.nominee = false;
          vm.activeTab.lineclass = '';
          vm.defaultDate = vm.formData && vm.formData.validUpTo || null; //(new Date());
          vm.showDefault = vm.formData.validUpTo ? true : false;
          vm.formData = {};
          break;
        case 'distributorempanellment.otp':
          vm.activeTab.arn = false;
          vm.activeTab.otp = true;
          vm.activeTab.nominee = false;
          vm.activeTab.lineclass = 'step1';
          vm.defaultDate = vm.formData && vm.formData.dob || null; //(new Date());
          var data = decodeURI(sessionStorage.getItem(AppConstants.EMPANEL_TOKEN));
          vm.formData = angular.isDefined(data) ? JSON.parse(data):{};
          EmpanellmentModal.setEmpanellmentModal(vm.formData);
          bindEvent();
          break;
        case 'distributorempanellment.additionaldetails':
          var data = decodeURI(sessionStorage.getItem(AppConstants.EMPANEL_TOKEN));
          vm.formData = angular.isDefined(data) ? JSON.parse(data):{};
          EmpanellmentModal.setEmpanellmentModal(vm.formData);
          getBranchDetails();
          break;
        case 'distributorempanellment.nomineedetails':
          vm.activeTab.arn = false;
          vm.activeTab.otp = false;
          vm.activeTab.nominee = true;
          vm.activeTab.lineclass = 'step2';
          vm.defaultDate = vm.formData && vm.formData.dob || null; //(new Date());
          vm.showDefault = vm.formData.dob ? true : false;
          var data = decodeURI(sessionStorage.getItem(AppConstants.EMPANEL_TOKEN));
          vm.formData = angular.isDefined(data) ? JSON.parse(data):{};
          if(vm.formData && vm.formData.dob){
            vm.formData.dob = $window.moment(vm.formData.dob);
          }
          EmpanellmentModal.setEmpanellmentModal(vm.formData);
          vm.formData.dob = vm.formData && vm.formData.dob || null;
          getRelationShipList();
          break;
        case 'distributorempanellment.guardiandetails':
          vm.activeTab.arn = false;
          vm.activeTab.otp = false;
          vm.activeTab.nominee = true;
          vm.activeTab.lineclass = 'step3';
          break;
      }
      if($stateParams.removeData && $stateParams.removeData==='true') {
        vm.formData.arnCode = "";
        vm.formData.panNumber = "";
      }
      dynamicInfo()

    }

    /** color contrast */

    function contrast (){
      vm.contrastt = !vm.contrastt;
      if(vm.contrastt){
        document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }
    function changedFont(valType){
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 55% !important");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 65% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove('newBigFont');
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }

    function changeStartDate(date) {
      if (date) {
        vm.formData.validUpTo = date._i;
        vm.defaultDate = date._d;
      }
    }

    function changeNomineeDob(date) {
      if (date) {
        vm.formData.dob = date;
      }
      if (date && date._d) {
        var d1 = new Date();
        var d2 = new Date(date._d);
        vm.enableFields = (+new Date(d1 - d2).toISOString().slice(0, 4) - 1970) < 18;

        if(!vm.enableFields){
          if(vm.formData && vm.formData.gurdianName){
            delete vm.formData.gurdianName;
          }
          if(vm.formData && vm.formData.gurdianAddress1){
            delete vm.formData.gurdianAddress1;
          }
          if(vm.formData && vm.formData.gurdianAddress2){
            delete vm.formData.gurdianAddress2;
          }
          if(vm.formData && vm.formData.postalCode){
            delete vm.formData.postalCode;
          }
          if(vm.formData && vm.formData.city){
            delete vm.formData.city;
          }
          if(vm.formData && vm.formData.country){
            delete vm.formData.country;
          }
        }
      }
    }

    function changedDeclaretion() {
      vm.formData.declaretionArray = [];
      angular.forEach(vm.declaretionText, function (data) {
        if (data && data.selected) {
          vm.formData.declaretionArray.push(data.text);
        }
      });
    }

    function EmpanellmentDecleration() {
      var success = function () {
        empanellmentSuccess();
      };
      ModalService.empanellmentTandCModal({}, success);
    }

    function empanellmentSuccess() {
      var success = function () {
        $state.go('home');
      }, error = function () {
        $state.go('home');
      };
      ModalService.empanellSuccessModal({}, success, error);
    }

    function getRelationShipList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.relationList = resp.data.relationList;
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {
        "empanelmentToken": vm.formData.empanelmentToken
      };
      DistributorEmpanellmentService.post({controller: 'relationship'}, payload).$promise.then(success, error);
    }

    function getBranchDetails() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.listOfBranch = [];
            var listOfBranch = resp.data.listOfBranch;
            for (var i in listOfBranch) {
              var obj = {
                state: i,
                value: listOfBranch[i]
              };
              vm.listOfBranch.push(obj);
            }
            changeState();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      DistributorGenericService.post({
        controller: 'all',
        child1: 'branch',
        child2: 'details'
      }, {}).$promise.then(success, error);
    }

    function confirmCancel() {
      var success = null;
      switch ($state.current.name) {
        case 'distributorempanellment.arn':
          success = function () {
            $state.go('login')
          };
          ModalService.confirmCancelModal({}, success);
          break;
        case 'distributorempanellment.otp':
          success = function () {
            $state.go('distributorempanellment.arn',{removeData:true})
          };
          ModalService.confirmCancelModal({}, success);
          break;
        case 'distributorempanellment.nomineedetails':
          success = function () {
            $state.go('distributorempanellment.arn',{removeData:true})
          };
          break;
        case 'distributorempanellment.guardiandetails':
          success = function () {
            $state.go('distributorempanellment.arn',{removeData:true})
          };
          ModalService.confirmCancelModal({}, success);
          break;
      }
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }

    function dynamicInfo() {
      var successHandler = function(resp) {
        if(resp){
          vm.noteAmfiCircular=resp.noteDTO.noteDTOMap.Note_AMFI_Circular;
          vm.notePreLogin=resp.noteDTO.noteDTOMap.Note_Pre_Login;
        }
      }
      UtilService.fetchDynamicData("PRE_LOGIN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function goBack() {
      $window.history.back();
    }

    function otpValChanged(myvalue) {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();
      vm.formData.otpNumber = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.formData.otpNumber.toString().length;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    }

    function bindEvent() {
      $timeout(function() {
        var inputs = document.querySelectorAll(".input-code-container input");
        inputs.forEach(function(input, index) {
          input.addEventListener("paste", function(e) {
            var data = e.clipboardData.getData("text");
            var value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach(function(input, index) {
                input.value = value[index];
              });
            }
          });
        });
      });
    }

    function submitAdditionalDetails() {
      EmpanellmentModal.setEmpanellmentModal(vm.formData);
      sessionStorage.setItem(AppConstants.EMPANEL_TOKEN, encodeURI(JSON.stringify(EmpanellmentModal.getEmpanellmentModal())));
      $state.go('distributorempanellment.nomineedetails');
    }

    vm.autoDate = function(){
      var oldlength = 0 ;
      if(vm.dobString){
        oldlength = vm.dobString.length;
      }
      vm.dobString = $("#dobId").val();
      var newlength = vm.dobString.length;
      if( vm.dobString.length == 2){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
      if( vm.dobString.length == 5){
        if((newlength== (oldlength - 1)) || (newlength == oldlength)){
        } else{
          $("#dobId").val(vm.dobString+"-");
        }
      }
    }

    function submitNomineeDetailsCheck() {
      if(vm.formData && vm.formData.dob && ($window.moment().diff($window.moment(vm.formData.dob), 'years') > 18)){
        submitNomineeDetails();
      }else {
        EmpanellmentModal.setEmpanellmentModal(vm.formData);
        sessionStorage.setItem(AppConstants.EMPANEL_TOKEN, encodeURI(JSON.stringify(EmpanellmentModal.getEmpanellmentModal())));
        $state.go('distributorempanellment.guardiandetails');
      }
    }

    function changeState(selectedState) {
      if(selectedState) {
        vm.listOfBranchAddress = selectedState.value;
      } else if(vm.formData.selectedState) {
        vm.listOfBranchAddress = vm.formData.selectedState.value;
      }
    }

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .config(widgets);

  /** @ngInject */
  function widgets($stateProvider) {
    $stateProvider.state('login.widgets', {
      url: '',
      views: {
        "knowledgeCenter": {
          templateUrl: 'app/components/widgets/knowledge-center/knowledge-center.widget.html',
          controller: 'KnowledgeCenterWidget',
          controllerAs: 'KnowledgeCenterWidget',
        },
        "fundInFocus": {
          templateUrl: 'app/components/widgets/fund-in-focus/fund-in-focus.widget.html',
          controller: 'FundInFocusWidget',
          controllerAs: 'FundInFocus'
        },
        "quickSip": {
          templateUrl: 'app/components/widgets/quick-sip/quick-sip-widget.html',
          controller: 'QuickSipTileWidget',
          controllerAs: 'QuickSipTile'
        }
      },
      authenticate: false
    })
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcSidebar', hdfcSidebar);

  /** @ngInject */
  function hdfcSidebar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/sidebar/sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: sidebarController,
      controllerAs: 'Sidebar',
      bindToController: true
    });

    /** @ngInject */
    function sidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, $http, MessageService, UtilService, $window, AuthService, ModalService, AppConstants) {
      var vm = this;
      vm.HDFC_API = HDFC_API;
      vm.active = {};
      vm.sidebarActive = null;
      vm.productSubMenu = true;
      vm.knowledgeCenterSubMenu = true;
      vm.openCalculator = openCalculator;
      vm.bulkMenu = true;
      vm.statements = true;
      vm.HDFC_API = HDFC_API;
      vm.closeSidebar = closeSidebar;
      vm.isDarkModeEnable = false;
      vm.toggleMode = toggleMode;
      vm.contrast = contrast;
      vm.changedFont = changedFont;
      vm.NO_INVESTER_ADDED_MSG = AppConstants.NO_INVESTER_ADDED_MSG;

      // vm.redirectUrl = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;

      function openLeadmanagement() {
        var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;
        var newWin = $window.open("about:blank", 'newtab');
        newWin.document.write("<h2>Please wait while we fetch details....</h2>");
        $http.get(_link, {}, {
          headers: {}
        })
          .then(function (resp) {
            if (resp.status && resp.data) {
              // $window.open(resp.data, '_blank');
              newWin.location = resp.data;
            } else {
              newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
              MessageService.error(resp.message);
            }
          }, function (err) {
            newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
            UtilService.errorHandler(err);
          });
      }

      /*function openFinancialPlanning() {
        var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/distributor/fivenance/redirect';
        $http.post(_link, {fivenanceInvestorId: null}, {
          headers: {'Content-Type': 'application/json'}
        })
          .success(function (resp) {
            if (resp.status && resp.data) {
              $window.open(resp.data, '_blank');
            } else {
              MessageService.error(resp.message);
            }
          })
          .error(function (err) {
            UtilService.errorHandler(err);
          });
      }*/

      vm.initTab = function () {
        vm.count = UtilService.getCount();
        $timeout(function () {
          var baseState = null;
          if($state.current.name == "main.investors.statements"){
            baseState = "Statements"
          } else if($state.current.name == "contactUs"){
            baseState = $state.current.name;
          } else {
            baseState = $state.current.name.split('.')[1];
          }
          switch (baseState) {
            default:
              vm.active = {'-1': true};
              break;
            case 'dashboard':
              vm.active = {0: true};
              break;
            case 'transactions':
              vm.active = {1: true};
              break;
            case 'sipcorner':
              vm.active = {2: true};
              break;
            case 'investors':
              vm.active = {3: true};
              break;
            case 'Statements':
              vm.active = {41: true};
              break;
            case 'reports':
              vm.active = {42: true};
              break;
            case 'bulk':
              vm.active = {51: true};
              break;
            case 'siprenew':
              vm.active = {52: true};
              break;
            case 'schemecalculator':
              vm.active = {62: true};
              break;
            case 'contactUs':
              vm.active = {11: true};
              break;
          }
        }, 100);
        $rootScope.$broadcast('checkCurrentState');
      };

      vm.activateTab = function (tab) {
        vm.active = {};
        vm.active[tab] = true;
        if(tab == 41) {
          var identifier = AuthService.getToken();
          if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
            var successModal = function () {
              $state.go('main.newinvestor.kycverify');
            }, errorModal = function () {};
            ModalService.confirmCancelModal({Text: vm.NO_INVESTER_ADDED_MSG}, successModal, errorModal);
          } else {
            var success = function (investor) {
              if (investor && investor.uuid) {
                var _state = 'main.investors.statements';
                vm.statements = !!vm.statements;
                vm.bulkMenu = true;
                vm.productSubMenu = true;
                vm.knowledgeCenterSubMenu = true;
                $state.go(_state, {
                  investorId: investor.uuid
                });
              } else {
                MessageService.error('Unable to get uuid of selected investor');
              }
            }, error = function () {

            };
            ModalService.searchInvestorModal({
              arnCode: identifier.arnCode,
              statementSearch : true
            }, success, error);
          }
        }
        if($state.current.url == '/list')
        {
          $state.reload()
        }
        $rootScope.$broadcast('checkCurrentState');
        if(vm.active[4] || vm.active[41] || vm.active[42]){
          vm.statements = !!vm.statements;
          vm.bulkMenu = true;
          vm.productSubMenu = true;
          vm.knowledgeCenterSubMenu = true;
        }
        if(vm.active[5] || vm.active[51] || vm.active[52]){
          vm.bulkMenu = !!vm.bulkMenu;
          vm.statements = true;
          vm.productSubMenu = true;
          vm.knowledgeCenterSubMenu = true;
        }
        if(vm.active[6] || vm.active[61] || vm.active[62]){
          vm.productSubMenu = !!vm.productSubMenu;
          vm.bulkMenu = true;
          vm.statements = true;
          vm.knowledgeCenterSubMenu = true;
        }
        if(vm.active[7] || vm.active[71] || vm.active[72] || vm.active[73]){
          vm.knowledgeCenterSubMenu = !!vm.knowledgeCenterSubMenu;
          vm.bulkMenu = true;
          vm.statements = true;
          vm.productSubMenu = true;
        }

        if(vm.active[1] || vm.active[2] || vm.active[3] || vm.active[42] || vm.active[62]){
          var identifierData = AuthService.getToken();
          if (identifierData.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
            var successModalForSidebar = function () {
              $state.go('main.newinvestor.kycverify');
            }, errorModalForSidebar = function () {};
            ModalService.confirmCancelModal({Text: vm.NO_INVESTER_ADDED_MSG}, successModalForSidebar, errorModalForSidebar);
          } else {
            if(vm.active[1]){
              $state.go("main.transactions.recent");
            }else if(vm.active[2]){
              $state.go("main.sipcorner");
            }else if(vm.active[3]){
              $state.go("main.investors.list");
            }else if(vm.active[42]){
              $state.go("main.reports");
            }else if(vm.active[62]){
              $state.go("main.schemecalculator");
            }
          }
        }
      };

      $rootScope.$on('$locationChangeSuccess', function() {
        vm.initTab();
        vm.activateTab();
      });

      angular.element("#menuButton").click(function () {
        angular.element(".mobile-menu").addClass("expanded");
        angular.element(".main-section").css("overflow", "hidden");
        angular.element(".main-section").css("position", "static");
        angular.element(".mobile-header>.black-tint").fadeIn();
      });

      angular.element(".mobile-header>.black-tint").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");

        angular.element(".main-section").css("overflow", "none");
        angular.element(".main-section").css("position", "static");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-menu .mobile-nav ul > li").click(function () {
        angular.element(".mobile-menu").removeClass("expanded");
        angular.element(".mobile-header>.black-tint").fadeOut();
      });

      angular.element(".mobile-header .mobile-search").click(function () {
        angular.element(".mobile-search-bar").toggle();
      });

      var listener = $rootScope.$on('UpdateSideBar', vm.initTab);

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        if (angular.isFunction(listener)) {
          listener();
        }
      });

      function openCalculator(title, url) {
        ModalService.genericUiModal({
          title: title,
          url: url
        });
      }

      function closeSidebar() {
        document.getElementById('login-sidebar').style.removeProperty('display');
        angular.element(document.getElementsByClassName('login-affix side-nav')).removeClass('add-width');
      }


      /** color contrast */

      function contrast () {
        if(!vm.isDarkModeEnable){
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        }
        $rootScope.$broadcast('isChangeBackgroundOfDonut', !vm.isDarkModeEnable);
      }

      function changedFont(valType){
        UtilService.changedFont(valType);
        vm.count = UtilService.getCount();
        $rootScope.$broadcast('changeFontFromPostLoginMobileSidebar');
      }

      function toggleMode(){
        UtilService.toggleMode();
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        $rootScope.$broadcast('toggleModeUpdateFromMobileDashboardSidebar');
      }

      $rootScope.$on('toggleModeUpdateFromDashboard', function () {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        vm.count = UtilService.getCount();
      })

    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('oneClickHeader', oneClickHeader);

  /** @ngInject */
  function oneClickHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/one-click-header/one-click-header.html',
      scope: {
        creationDate: '=',
        isFromHdfcOneClick: '=?'
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });

    /** @ngInject */
    function headerController(AppConstants, $scope,$cookies, $window, UtilService, $rootScope, LoaderService, AuthService, MessageService, $stateParams) {
      var vm = this;
      vm.contrastt = true;
      vm.contrast= contrast;
      vm.showPopupScreen = showPopupScreen;
      vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
      vm.showAddEcart = false;
      vm.indexToNumberArray = AppConstants.ECART_CART_ITEM_NUMBER;
      vm.expandSidebar = expandSidebar;
      vm.showSideBarCart = false;
      vm.showSideBarInvest = false;
      vm.showSideAllFunds = false;
      vm.checkItemsInCart = checkItemsInCart;
      if($stateParams.x){
        vm.isFromHdfcOneClick = true;
      }
      if((!vm.isFromHdfcOneClick && localStorage.getItem('ecartItems')) || (vm.isFromHdfcOneClick && localStorage.getItem('ecartItemsForHDFC'))) {
        vm.cartDetails = vm.isFromHdfcOneClick? JSON.parse(localStorage.getItem('ecartItemsForHDFC')): JSON.parse(localStorage.getItem('ecartItems'));
      }
      vm.init = init;
      $scope.$on('CartCount', function(event,args) {
        vm.ecartCount = args;
      });
      init();
      function init(){
        if($stateParams.r || $stateParams.rm){
          vm.hideCartIcon = true;
        }
        if(vm.cartDetails) {
          vm.ecartCount = vm.cartDetails.cartItems.length;
        } else {
          vm.ecartCount = 0;
        }
      }
      /** color contrast */

      function contrast (){
        vm.contrastt = !vm.contrastt;
        if(vm.contrastt){
          document.getElementsByTagName("body")[0].classList.remove("oneClickContrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("oneClickContrastClass");
        }
      }

      function checkItemsInCart(){
        if(!vm.isFromHdfcOneClick && $cookies.get('broker_details') || vm.isFromHdfcOneClick && $cookies.get('broker_details_HDFC')){
          vm.brokerTypeFromCookies = vm.isFromHdfcOneClick? $cookies.get('broker_details_HDFC'): JSON.parse($cookies.get('broker_details'));
        }
        if(vm.ecartCount && vm.ecartCount > 0){
          showPopupScreen("ECART");

        } else {
          showPopupScreen("INVEST_THROUGH");
        }
        $rootScope.$broadcast('hideCartDetails')
        if(vm.brokerTypeFromCookies && vm.brokerTypeFromCookies.brokerType && vm.brokerTypeFromCookies.brokerType == 'RIA'){
          nonArnAuth();
        } else if(vm.brokerTypeFromCookies && vm.brokerTypeFromCookies.brokerType && vm.brokerTypeFromCookies.brokerType == 'MFD'){
          authARN();
        }
      }

      function showPopupScreen(screen) {
        switch (screen) {
          case 'INVEST_THROUGH':
            vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
            vm.investThrough = "DISTRIBUTOR";
            vm.showSideBarCart = false;
            vm.showSideBarInvest = true;
            vm.showSideAllFunds = false;
            vm.showAddEcart = false;
            $scope.$broadcast('updatedTitle');
            break;
          case 'CART_DETAILS':
            vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
            vm.showSideBarCart = true;
            vm.showSideBarInvest = false;
            vm.showSideAllFunds = false;
            vm.showAddEcart = false;
            $scope.$broadcast('updatedTitle');
            break;
          case 'ALL_FUNDS':
            vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
            vm.showSideBarCart = false;
            vm.showSideBarInvest = false;
            vm.showSideAllFunds = true;
            vm.showAddEcart = false;
            $scope.$broadcast('updatedTitle');
            break;
          case 'ECART':
            vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ECART;
            vm.showSideBarCart = false;
            vm.showSideBarInvest = false;
            vm.showSideAllFunds = false;
            vm.showAddEcart = true;
            $scope.$broadcast('updatedTitle');
            break;
        }
        expandSidebar();
      }

      function expandSidebar() {
        // if (vm.cartItem.totalLength === 0) {
        //   vm.showAddEcart = true;
        // }
        $window.scrollTo(0,0);
        UtilService.expandSideBar();
      }

      $scope.$on('showCartDetails', function(event,args){
        vm.itemToBeEdited = args.itemToBeEdited;
        vm.isFromOneClickScreen = args.isFromOneClickScreen;
        vm.isBrokerTypeChange = args.isBrokerTypeChange;
        showPopupScreen('CART_DETAILS');
      });

      $scope.$on('hidingSidebar',function (){
        vm.showSideBarCart = false;
        vm.showSideBarInvest = false;
        vm.showSideAllFunds = false;
        vm.showAddEcart = false;
      });

      function nonArnAuth(cb) {
        cb = cb || function () {
        };
        var successLogin = function (resp) {
          sessionStorage.setItem('arnAuth',true);
          LoaderService.hideLoader();

        },errorLogin = function(resp){
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
        var oauthpayload = {
          arnCode:'ARN-DIRECT',
          grant_type: 'password',
          panNumber: null,
          appType: 'W',
          type:'arn'
        };
        LoaderService.showLoader();
        cb(true)
        AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);


      }


      function authARN(cb) {
        cb = cb || function () {
        };
        var length = vm.brokerTypeFromCookies.brokerCode ? vm.brokerTypeFromCookies.brokerCode.length: 0;
        if(length>3)
        {
          var successLogin = function (resp) {
            sessionStorage.setItem('arnAuth',true);
            if(resp.access_token){
              LoaderService.hideLoader();
            }else{
              LoaderService.hideLoader();
              MessageService.error(resp.message);
            }
          },errorLogin = function(resp){
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
          var oauthpayload = {
            arnCode: 'ARN-'+vm.brokerTypeFromCookies.brokerCode,
            grant_type: 'password',
            panNumber: null,
            appType: 'W',
            type:'arn'
          };
          LoaderService.showLoader();
          cb(true)
          AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

        }
      }

      $scope.$on('showEcartWhenItemExist', function(event,args) {
        if(args == 'Cart Details' || args == 'All Funds' || args == 'Invest Through') {
          checkItemsInCart();
        }
      });

    }
  }
})
();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('oneClickFooter', oneClickFooter);

  /** @ngInject */
  function oneClickFooter() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/one-click-footer/one-click-footer.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Footer',
      bindToController: true
    });

    /** @ngInject */
    function headerController(HDFC_API) {
      var vm = this;
      vm.HDFC_API = HDFC_API;
      vm.login = HDFC_API.PROTOCOL + HDFC_API.PATH;
      vm.accordionFunc = accordionFunc;
      init();
      function init(){
        accordionFunc(0);
      }
      vm.isChecked = {}
      function accordionFunc (id){
        vm.isChecked = {}
        if($(".content"+id).is(":hidden")){
          $(".content").hide();
          $(".content"+id).slideDown();
          vm.isChecked[id] = true;
        }else{
          $(".content").hide();
          $(".content"+id).slideUp();
          if(id > 0) {
            vm.isChecked[id] = false;
          }
        }
      }

    }
  }
})
();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .directive('verticalProgressSidebar', verticalProgressSidebar);
  
    /** @ngInject */
    function verticalProgressSidebar() {
      var directive = {
        restrict: 'E',
        scope: {
          steps: '=',
          responsive: '='
        },
        controller: verticalProgressSidebarController,
        templateUrl: 'app/components/new-investor-progreesbar/investor-vertical-progress-sidebar.directive.html',
        link: link
      };
      return directive;
  
      function link($scope) {
        $scope.toggleListItems = function(index) {
          $scope.forms.steps.forEach(function(step) {
            step.stepActive = false;
          });
          $scope.forms.steps[index].stepActive = true;
          $scope.forms.steps[index].stepCompleted = false;
          if (index > 0) {
            $scope.forms.steps[index-1].stepCompleted = true;
          }
        };
      }
  
      /** @ngInject */
      function verticalProgressSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, AppConstants, UtilService) {
        $scope.forms = $scope.steps;
        $scope.redirectToState = function (details) {
          $state.go(details.state);
        };
      }
    }
  })();
  
(function () {
    'use strict';
    angular
    .module('hdfc-mf-distributor-web')
    .directive('horizontalProgressSidebar', horizontalProgressSidebar);
  
    /** @ngInject */
    function horizontalProgressSidebar() {
       function link($scope, $element) {
          $scope.toggleListItems = function(index) {
            $scope.forms.steps[index].stepActive = true;
            $scope.forms.steps[index - 1].stepCompleted = true;
          };
        }
        var directive = {
          restrict: 'E',
          scope: {
            steps: '='
          },
          controller: horizontalProgressSidebarController,
          templateUrl: 'app/components/new-investor-progreesbar/investor-horizontal-progress-sidebar.directive.html',
          link: link
        };
        return directive;
  
      /** @ngInject */
      function horizontalProgressSidebarController(HDFC_API, $timeout, $state, $rootScope, $scope, AppConstants, UtilService) {
        $scope.forms = $scope.steps;
      }
    }
  })();
  
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    });

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }
})();

/**
 * Created by ttn on 21/01/21.
 * Implement the following:
 * * CryptoJS for AES ecnryption and decryption.
 * * JSscript for RSA encryption and decryption.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('ApiInterceptor', apiInterceptor);

  /** @ngInject */
  function apiInterceptor($rootScope, $cookies, $window, $q, AppConstants, HDFC_API, FormatterService) {

    /*function to identify html template calls*/
    function isTemplateCall(config) {
      if (!config || !config.url) {
        return;
      }
      return config.url.lastIndexOf('.html') !== -1;
    }

    /*function to identify get call*/
    function isGetCall(config) {
      if (!config || !config.method) {
        return;
      }
      return config.method === 'GET';
    }

    /*function to check empty request body and content-type of calls*/
    function isRequestBodyEmpty(config) {
      if (!config || !config.data) {
        return;
      }
      return Object.keys(config.data).length !== 0;
    }

    /*function to check for content type*/
    function contentTypeCheck(config) {
      if (!config || !config.headers) {
        return;
      }
      return config.headers["Content-Type"] === "application/x-www-form-urlencoded";
    }

    function createAesRequestPayload(jsonRequiredToEncrypt) {
      var key =  $window.CryptoJS.lib.WordArray.random(128/8); //16bit
      var IV =  $window.CryptoJS.lib.WordArray.random(128/8); //8bit
      var aesEncrypted = $window.CryptoJS.AES.encrypt(angular.toJson(jsonRequiredToEncrypt), key, { iv: IV });
      var ivAndKey = $window.CryptoJS.enc.Base64.stringify(IV) + "|" + $window.CryptoJS.enc.Base64.stringify(key);
      return (FormatterService.getFormatter().encrypt(ivAndKey) + "|" + $window.CryptoJS.enc.Base64.stringify(aesEncrypted.ciphertext));
    }

    function readAesResponsePayload(header, data) {
      var iv = $window.CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
      var key = $window.CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
      var decryptJson = $window.CryptoJS.AES.decrypt({
        ciphertext: data
      }, key, {iv: iv});
      return decryptJson.toString($window.CryptoJS.enc.Utf8);
    }

    return {
      'request': function(config) {
        if (!isTemplateCall(config) && !isGetCall(config) && isRequestBodyEmpty(config) && !contentTypeCheck(config) && config.responseType !== "arraybuffer") {
          if (config.url && config.url.includes("res.cloudinary.com")) {
            delete config.headers['encrypted'];
          } else {
            config.headers['archived'] = 'enabled';
          }
          //config.data = btoa(JSON.stringify(config.data)); //for only base 64
          var aesEncryptedString = createAesRequestPayload(config.data);
          config.data = aesEncryptedString;
        }
        return config;
      },

      'requestError': function(rejection) {
        if (!isTemplateCall(rejection.config)) {
          return $q.reject(rejection);
        }
      },

      'response': function(response) {
        if (!isTemplateCall(response.config) && !isGetCall(response.config) && isRequestBodyEmpty(response.config)
          && !contentTypeCheck(response.config)) {
          //response.data = angular.fromJson(atob(response.data)); // for only base64
          if (response.config.responseType && response.config.responseType === "arraybuffer") {
            response.data = response.data;
          } else {
            var header = response.data.substring(0, response.data.lastIndexOf("|"));
            var data = $window.CryptoJS.enc.Base64.parse(response.data.substring(response.data.lastIndexOf("|")+1, response.data.length));
            var responseData = readAesResponsePayload(FormatterService.getFormatterHDFC().decrypt(header), data);
            response.data = angular.fromJson(responseData);
          }
          return response;
        } else {
          return response;
        }
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcHeader', hdfcHeader);

  /** @ngInject */
  function hdfcHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {
        creationDate: '='
      },
      controller: headerController,
      controllerAs: 'Header',
      bindToController: true
    });

    /** @ngInject */
    function headerController(HDFC_API, $rootScope, $timeout, $state, $window, UtilService, InvestorModel, InvestorsService, AuthService, $scope, ModalService, LoaderService, NotificationService, AppConstants, FileUploadService, MessageService, $document, $http, TransactionInitiateModel, InvestorsServiceVersion , InvestorServiceDynamicData , $cookies, EcartService) {
      var vm = this;
      vm.HDFC_API = HDFC_API;
      var listeners = {};
      var currentPopup = '';

      vm.popup = "navigation";
      vm.myFile = {};
      vm.searchResult = null;
      vm.selectedInvestor = null;
      vm.searchString = '';
      vm.isSearching = false;
      vm.AppConstants = AppConstants;
      vm.notificationCount = 0;
      vm.cartCount = 0;
      vm.latestNotificationList = null;
      vm.mimeType = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/bmp"];
      vm.isEnablePopups = false;
      vm.changedFont = changedFont;
      vm.fontSizeChange = fontSizeChange;
      vm.count = 0;
      vm.contrastt = true;
      vm.normalFontActive = true;
      vm.contrast= contrast;
      vm.openEcartSideBar = openEcartSideBar;

      vm.distributorName = "Swapnil";
      vm.profilePhotoUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
      vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      vm.toggleMode = toggleMode;

      var resetTransactionInitiateModel = function () {
        TransactionInitiateModel.setPurchasePayload(null);
        TransactionInitiateModel.setSipPayload(null);
        TransactionInitiateModel.setInvestorPayload(null);
      };

      vm.searchInvestorEnterOnly = function (isClicked) {
        $document.bind('keydown', function (e) {
          var key = e.keyCode ? e.keyCode : e.which;
          if (key == 13 && vm.searchString.length > 0) {
            $state.go('main.globalSearch', {searchString: vm.searchString});
            $timeout(function () {
              vm.searchResult = null;
              vm.searchString = '';
              angular.element("#searchresult").hide();
            }, 200);
          }
        });
        if (isClicked === 'onButtonClick') {
          $state.go('main.globalSearch', {searchString: vm.searchString});
        }
      };

      vm.openNotification = function (notification) {
        if (notification.clickable) {
          $state.go('main.leapacademy.pdf-articles');
        }
      };

      vm.searchInvestor = function (isClicked) {
        vm.closeFilter();
        $document.bind('keydown', function (e) {
          var key = e.keyCode ? e.keyCode : e.which;
          if (key == 13 && vm.searchString.length > 0) {
            $state.go('main.globalSearch', {searchString: vm.searchString});
            $timeout(function () {
              vm.searchResult = null;
              vm.searchString = '';
              angular.element("#searchresult").hide();
            }, 200);
          }
        });
        if (isClicked === 'onButtonClick') {
          $state.go('main.globalSearch', {searchString: vm.searchString});
        }

        var success = function (resp) {
            // resp = resp.data;
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.searchResult = resp.data && resp.data.searchResponse;
              for(var i=0;i<vm.searchResult.length; i++){
                var searchResultItem = vm.searchResult[i].result;
                var findIndex = searchResultItem.indexOf('-');
                vm.searchResult[i].investorName =searchResultItem.substring(0,findIndex);
                vm.searchResult[i].investorEmail = searchResultItem.substring(findIndex+1);
              }
            } else {
              vm.searchResult = null;
              !resp.status && MessageService.error(resp.message)
            }
          },
          error = function () {
            vm.searchResult = null;
            LoaderService.hideLoader();
            MessageService.error();
          };


        if (vm.isSearching || !vm.searchString || vm.searchString.length < 3) {
          return;
        }

        vm.searchResult = null;
        vm.selectedInvestor = null;
        vm.isSearching = true;

        $timeout(function () {
          vm.isSearching = false;
        }, 200);

        LoaderService.showLoader('.popup');
        /*
         var _path = HDFC_API.COMMON_SERVICE_URL + tokenData.arnCode + '/investor/search/' + vm.searchString;
         $http.get(_path).then(success, error);*/

        InvestorsService.post({
          //arnCode: tokenData.arnCode,//vm.modalData.arnCode,
          controller: 'search',
          child1: vm.searchString
        }, null).$promise.then(success, error);

      };

      vm.goToProfile = function (investor,index) {
        vm.selectedInvestor = investor;
        // vm.searchString = investor.result;

        LoaderService.showLoader();
        var taxIdentifier = vm.searchResult[index].panNumber;
        var success  = function(resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            if (resp.data.showPopup) {
              ModalService.optOutNomineeModalSearch({
                message: resp.data.popUpMessage,
                folioList : resp.data.folioList
              },function () {
                $timeout(function () {
                  vm.searchResult = null;
                  vm.searchString = '';
                  angular.element("#searchresult").hide();
                  $state.go('main.investors.profile.basicinfo', {investorId: vm.selectedInvestor.uuid});
                }, 200);
              } , function () {
                $timeout(function () {
                  vm.searchResult = null;
                  vm.searchString = '';
                  angular.element("#searchresult").hide();
                }, 200);
              });
            } else {
              $timeout(function () {
                vm.searchResult = null;
                vm.searchString = '';
                angular.element("#searchresult").hide();
                $state.go('main.investors.profile.basicinfo', {investorId: vm.selectedInvestor.uuid});
              }, 200);
            }
          }
        } , error = function(err) {
            LoaderService.hideLoader();
            MessageService.error(err.message);
        }

        InvestorServiceDynamicData.post({
          child1: 'profile',
          child2: 'check',
          child3: 'nominee',
          child4: 'details'
        }, {
          pan : taxIdentifier
        }).$promise.then(success, error);

      };

      var logoUpload = function () {
        ModalService.logoUploadModal();
      };

      var changePassword = function () {
        var success = function (result) {
          if (result.status) {
            MessageService.success(vm.AppConstants.ToastrMessage.RESET_PASSWORD.SUCCESS);
            vm.logoutMe();
          } else {
            MessageService.error(result.message);
            // vm.logoutMe();
          }
        }, error = function () {
          vm.logoutMe();
        };
        ModalService.changePasswordModal({backdrop: 'static', firstLogin: true}, success, error);
      };

      /*function showNotificationMsg() {
        // var msg = "A maintenance activity is ongoing at CAMS right now and will be completed at 2pm. You may experience issues within the application. If you do so try again after 30 minutes. Please do bear with us till the activity is completed. Thank you for your understanding.",
        var msg = "There is a back end activity at CAMS due to which there maybe data updation issues so please kindly bear with us.",
          success = function () {
          },
          error = function () {
          };
        ModalService.forgotPasswordDoneModal({message: msg}, success, error);
      }*/

      var search = function (transactionType) {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          $state.go('main.dashboard');
          return;
        }
        var success = function (investor) {
            if (investor && investor.uuid) {
              switch (transactionType) {
                case 'SIP or Purchase':
                  transactionType = 'SIP';
                  break;
                case 'Systematic Withdrawal Plan':
                  transactionType = 'SWP';
                  break;
                case 'Systematic Transfer Plan':
                  transactionType = 'STP';
                  break;
                case 'Redemption':
                  transactionType = 'Redeem';
                  break;
                case 'Switch':
                  transactionType = 'Switch';
                  break;
                case 'DTP':
                  transactionType = 'DTP';
                  break;
                case 'SWINGSTP':
                  transactionType = 'SWINGSTP';
                  break;
                case 'ChangeDividend':
                  transactionType = 'ChangeDividend';
                  break;
                case 'ROLLOVER':
                  transactionType = 'rollover';
                  break;
                case 'SMARTSWAP':
                  transactionType = 'SMARTSWAP';
                  break;
                case 'Instant Access Facility':
                  transactionType = 'instantRedeem';
                  break;
                case 'DREAMSIP':
                  transactionType = 'DREAMSIP';
                  break;
              }
              var _state = 'main.transactions.initiate.' + transactionType.toLowerCase();
              $state.go(_state, {
                uuid: investor.uuid,
                schemeCode: '',
                folioNumber: '',
                transactionType: '',
                transactionId: '',
                fromModify: '',
                frequency : '',
                amount : '',
                fromRenew : '',
                txnId : ''
              });
            } else {
              MessageService.error('Unable to get uuid of selected investor');
            }
          },
          error = function () {
            $state.go('main.dashboard');
          };
        resetTransactionInitiateModel();
        ModalService.searchInvestorModal({
          transactionType: transactionType,
          arnCode: identifierData.arnCode
        }, success, error);
      };
      if(localStorage.getItem('loginMethod')){
        var loginMethod = localStorage.getItem('loginMethod');
      }
      var isInitialLogin = function () {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          return;
        }
        var success = function (resp) {
          if (resp && resp.status && resp.data) {
            if (resp.data.firstTimeLogin && resp.data.firstPasswordChange) {
              vm.isEnablePopups = true;
              logoUpload();
            } else if (!resp.data.firstPasswordChange && loginMethod!='OTP') {
              vm.isEnablePopups = false;
              changePassword();
            } else {
              vm.isEnablePopups = true;
            }
            vm.lastLoginTime = $window.moment(resp.data.lastLoginTime).format("DD MMM YYYY | hh:mm:ss");

            // showNotificationMsg();

            if (!resp.data.uploadedLogoLocation) {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: AppConstants.DEFAULT_LOGO});

            } else {
              $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoLocation});
            }

            if (!resp.data.profilePhotoUrl) {
              vm.profilePhotoUrl = AppConstants.DEFAULT_PROFILE_IMAGE;
            } else {
              vm.profilePhotoUrl = resp.data.profilePhotoUrl;
            }
            vm.upperCrustAward = resp.data.upperCrustAward;

            $rootScope.$broadcast('UpdateProfileDetails', {
              distributorName: resp.data.distributorName,
              lastLoginTime: vm.lastLoginTime,
              firstTimeLogin: resp.data.firstTimeLogin
            });
          } else {
            vm.isEnablePopups = true;
            $rootScope.$broadcast('UpdateProfileDetails', {
              distributorName: 'User',
              lastLoginTime: '',
              firstTimeLogin: false
            });
            $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: AppConstants.DEFAULT_LOGO});
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
          vm.isEnablePopups = true;
        };
        AuthService.isInitialLogin(identifierData.arnCode).then(success, error);
      };

      /** color contrast */

      function contrast () {
        if(!vm.isDarkModeEnable){
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        }
        $rootScope.$broadcast('isChangeBackgroundOfDonut', vm.isDarkModeEnable);
      }

      function changedFont(valType){
        switch (valType) {
          case 'increment' : {
            if(vm.count<3){
              vm.count++;
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'decrement' : {
            if(vm.count>-3){
              vm.count--;
              vm.fontSizeChange(vm.count);
            }
          }
            break;
          case 'original' : {
            vm.count = 0;
            vm.fontSizeChange(vm.count);
          }
            break;
        }
      }
      function fontSizeChange(val){
        var elem = document.getElementsByTagName("body")[0];
        elem.classList.add("newBigFont");
        var ele = document.getElementsByClassName('newBigFont')[0];
        switch (val) {
          case -2 : {
            ele.setAttribute("style","font-size: 55% !important");
          }
            break;
          case -1 : {
            ele.setAttribute("style","font-size: 65% !important");
          }
            break;
          case 0 : {
            elem.removeAttribute('style');
            elem.classList.remove('newBigFont');
          }
            break;
          case 1 : {
            ele.setAttribute("style","font-size: 97% !important");
          }
            break;
          case 2 : {
            ele.setAttribute("style","font-size: 110% !important");
          }
            break;
        }
      }

      function getTotalNotificationCount() {
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status) {
              vm.notificationCount = resp.data;
            } else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        NotificationService.post({
          controller: 'totalNotificationCount'
        }, {}).$promise.then(success, error);
      }

      isInitialLogin();

      getTotalNotificationCount();

      getCartCount();

      vm.latestNotification = function (throughMenuClick,type) {
        vm.closeFilter();
        if (throughMenuClick) {
          $timeout(function () {
            var className = type?'mobile-header-notification-icon':'header-notification-icon';
            var ele = angular.element($window.document.getElementById(className)).parent('.dropdown');
            var hasClass = ele.hasClass('open');
            if (ele && hasClass) {
              getLatestNotification();
            }
          },10)
        } else {
          getLatestNotification();
        }
      };

      function getLatestNotification(){
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.latestNotificationList = resp.data.notificationList;

              if (vm.notificationCount !== 0) {
                var successR = function () {
                    vm.notificationCount = 0;
                  },
                  errorR = function () {
                  };
                NotificationService.post({
                  controller: 'read'
                }, {}).$promise.then(successR, errorR);
              }
            }
            else {
              MessageService.error(resp.message);
            }
          },
          error = function (err) {
            LoaderService.hideLoader();
            UtilService.errorHandler(err);
          };
        NotificationService.post({
          controller: 'latestNotification'
        }, {}).$promise.then(success, error);

      }

      vm.openLeadmanagement = function () {
        var newWin = $window.open("about:blank", 'newtab');
        newWin.document.write("<h2>Please wait while we fetch details....</h2>");
        newWin.location = 'http://www.salespanda.com/bizight-client/hdfc/delinked-page/delinked-page.html';
        /*var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/generateGatePass/' + HDFC_API.THIRD_PARTY_NAME;
        var newWin = $window.open("about:blank", 'newtab');
        newWin.document.write("<h2>Please wait while we fetch details....</h2>");

        $http.get(_link, {}, {
          headers: {}
        }).then(function (resp) {
            if (resp) {
              if (resp.status && resp.data) {
                // window.open(resp.data, '_blank');
                newWin.location = resp.data;
              } else {
                newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
                MessageService.error(resp.message);
              }
            }
          }, function (err) {
            newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
            UtilService.errorHandler(err);
          });*/
      };

      vm.logoutMe = function () {
        sessionStorage.removeItem('brokerCodePanAdhar');
        AuthService.logout().then(function () {
          $state.go('login');
        }, function () {
          $state.go('login');
        });
      };

      /*
       vm.widgetSelection = function () {
       ModalService.widgetStoreModal();
       };
       */

      vm.updatePopup = function (popup) {
        vm.popup = popup;
      };

      vm.updateSideBar = function (transactionType) {
        if (transactionType) {
          $timeout(function () {
            search(transactionType);
          }, 50);
        }
        $rootScope.$emit('UpdateSideBar');
      };

      vm.updateSideBarInvestor = function () {
        vm.closeFilter();
        $rootScope.$emit('UpdateSideBar');


        var successPanDetails = function (resp) {
          if (resp.data && resp.status && resp.data.kycverified) {
            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            // resp.data.minor = true;
            model.folioCreationRequestCO.soleApplicantDetail.name = resp.data.name;
            model.folioCreationRequestCO.soleApplicantDetail.dob = resp.data.dob;
            model.folioCreationRequestCO.soleApplicantDetail.panNumber = resp.data.pan;
            model.folioCreationRequestCO.soleApplicantDetail.minor = resp.data.minor;
            model.folioCreationRequestCO.soleApplicantDetail.email = resp.data.email?resp.data.email.trim():"";
            model.folioCreationRequestCO.soleApplicantDetail.mobileNo = resp.data.mobileNumber?resp.data.mobileNumber.trim():"";
            model.folioCreationRequestCO.soleApplicantDetail.ekycStatus = resp.data.ekycStatus?resp.data.ekycStatus:null;
            //resp.data.ekycStatus = "NOT_VERIFIED";
            InvestorModel.setInvestorModel(model);
            delete $window.sessionStorage.investorForm;
            $window.sessionStorage.investorForm = angular.toJson(model);
            // InvestorModel.setTab({
            //   "tab1": false,
            //   "tab2": false,
            //   "tab3": false,
            //   "tab4": false,
            //   "tabJointHolderAddable": false,
            //   "tabGuardianDetailShow": false
            // });
            // $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});
            if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.IN_PROGRESS) {
              $state.go('main.investors.add.holdmode', null, {reload: 'main.investors.add.holdmode'});
            } else if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.NOT_VERIFIED || resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.INCOMPLETE) {
              ModalService.kycInitiateModal({
                investorDetails: InvestorModel.getInvestorModel()
              }, initiateNextSteps, function(){});
            } else if (resp.data.ekycStatus === vm.AppConstants.KYC_STATUS.SUSPENDED) {
              ModalService.nonKycModal({
                'text': resp.data.message,
                'buttonText': 'OK'
              }, function() {}, function() {});
            } else {
              ModalService.nonKycModal({
                'text': 'Your KYC status is not verified, please update KYC with your current KRA through Point of Service of any KRA intermediary.',
                'buttonText': 'OK'
              }, function() {}, function(){});
            }
          } else {
            MessageService.error(resp.message || 'Either KYC verification is pending or name is missing.');
          }
        };
        var labelSetter = {type: 'addInvestor', label: {header: 'Add Investor', pan: 'PAN', dob: 'Investor DOB'}};
        // ModalService.checkPanModal(labelSetter, successPanDetails);
        $state.go('main.newinvestor.kycverify');
      };

      vm.skipPopup = function () {
        vm.popup = "";
      };

      vm.uploadFile = function (file) {
        if (file) {
          if (vm.mimeType.indexOf(file.type) == -1) {
            MessageService.error("Only image file is allowed");
            return;
          }

        //var tokenData = angular.fromJson($cookies.get('token_data'));
        var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/uploadLogo';
        LoaderService.showLoader();
        FileUploadService.uploadFileToUrl(file, _path).then(function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            $rootScope.$broadcast('UpdateLogoImage', {logoImgUrl: resp.data.uploadedLogoUrl});
          } else {
            MessageService.error(resp.message)
          }
        }, function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err)
        });
      }
    };


    vm.emptySearch = function () {
      $timeout(function () {
        vm.searchResult = null;
        vm.searchString = '';
        angular.element("#searchresult").hide();
        angular.element("#searchbox-header").focus();
      }, 200);
    };

      angular.element("#searchbox").blur(function () {
        $timeout(function () {
          vm.searchResult = null;
          vm.searchString = '';
          angular.element("#searchresult").hide();
        }, 200);
      });

      $document.bind('keydown', function (e) {
        var key = e.keyCode ? e.keyCode : e.which;
        if (!vm.isEnablePopups) {
          return;
        }
        switch (key) {
          case 37:
            currentPopup = vm.popup;
            if (currentPopup == 'add-investor') {
              vm.popup = 'initiate-transaction';
            }
            else if (currentPopup == 'initiate-transaction') {
              vm.popup = 'navigation';
            }
            break;
          case 39:
            currentPopup = vm.popup;
            if (currentPopup == 'navigation') {
              vm.popup = 'initiate-transaction';
            }
            else if (currentPopup == 'initiate-transaction') {
              vm.popup = 'add-investor';
            }
            break;
          case 27:
            vm.popup = '';
            break;
          case 13:
            vm.popup = '';
            break;
        }
        $scope.$digest();
        e.stopPropagation();
      });
      listeners['checkCurrentState'] = $scope.$on('checkCurrentState', function () {
        vm.sidebarActive = $state.current.name.split('.')[1];
      });
      listeners['UpdateLogoImage'] = $scope.$on('UpdateLogoImage', function (event, args) {
        vm.logoImgUrl = "";
        $timeout(function () {
          vm.logoImgUrl = args.logoImgUrl || AppConstants.DEFAULT_LOGO;
        });
      });
      listeners['UpdateProfileImage'] = $scope.$on('UpdateProfileImage', function (event, args) {
        vm.profilePhotoUrl = "";
        $timeout(function () {
          vm.profilePhotoUrl = args.profilePhotoUrl || AppConstants.DEFAULT_LOGO;
        });
      });
      listeners['UpdateProfileDetails'] = $scope.$on('UpdateProfileDetails', function (event, args) {
        vm.distributorName = args.distributorName;
        vm.firstTimeLogin = args.firstTimeLogin;
        if (args.lastLoginTime) {
          vm.lastLoginTime = args.lastLoginTime;
        }
      });

      $scope.$on("$destroy", function () {
        // Unbind angular event listeners
        for (var key in listeners) {
          if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
            listeners[key]();
          }
        }
      });

      /**
       * Function responsible to submit the investor ekyc modal form value
       */
      function initiateNextSteps(resp) {
        var investorData = InvestorModel.getInvestorModel();
        vm.investorDetails = resp;
        var payload = {
          investorName : resp.name,
          pan : investorData.folioCreationRequestCO.soleApplicantDetail.panNumber,
          email : resp.email,
          mobileNo : resp.mobile,
          dob : investorData.folioCreationRequestCO.soleApplicantDetail.dob,
          ekycStatus : investorData.folioCreationRequestCO.soleApplicantDetail.ekycStatus
        };
        InvestorsServiceVersion.post({
          child1 : 'save',
          child2 : 'investor',
          child3 : 'eKyc',
          child4 : 'details',
        }, payload).$promise.then(ekycValueSubmissionSuccess, ekycValueSubmissionError);
      }

      /**
       * function responsible to handle the success response of submitting investor form value
       * @param resp
       */
      function ekycValueSubmissionSuccess(resp) {
        var investorData = InvestorModel.getInvestorModel();
        if (resp.status) {
          ModalService.eKycModal({
            investorName: vm.investorDetails.name
          }, function() {}, function(){});
        }
      }

      /**
       * function responsible to handle the failure response of submitting investor form value
       * @param resp
       */
      function ekycValueSubmissionError(resp) {
        MessageService.error(resp.message);
      }

      vm.closeFilter = function() {
        angular.element(document.querySelector("#filterSideNav")).removeClass('halfWidth');
        angular.element(document.querySelector("#filterSideNav")).addClass('noWidth');
        angular.element(document.querySelector(".blur-area")).css('display', 'none');
        destroyInvestorFilter();
      }
      function destroyInvestorFilter() {
        var elem = document.getElementsByTagName("footer")[0];
        elem.classList.remove("menu-expanded");
      }

      function getCartCount() {
        var success = function (resp) {
          if (resp.status) {
            vm.cartCount = resp.data.total;
            // vm.cartCount = 2;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
        EcartService.get({
          child1: 'cart',
          child2: 'item',
          child3: 'count'
        }).$promise.then(success, error);
      }

      function openEcartSideBar() {
        if(vm.cartCount > 0){
          $rootScope.$broadcast('openEcart','openEcartDetails');
        } else {
          $rootScope.$broadcast('openEcart', 'openAllFundsScreen');
        }
      }

      listeners['UpdateCart'] = $scope.$on('UpdateCart', function (event, args) {
        if (args.listUpdated) {
          getCartCount();
        }
      });

      function toggleMode(){
        UtilService.toggleMode();
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      }
    }
  }
})
();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .filter('truncateDecimal', function() {
      return function(input, decimalPlaces) {
        // Parse the input as a float
        var floatValue = parseFloat(input);
        var truncatedValue = null;

        // Check if the input is a valid number
        if (!isNaN(floatValue)) {

          var splitPart = input.toString().split('.');

          var commaSepratedPart = splitPart[0];
          var fractionalPart = splitPart[1] ? splitPart[1].slice(0, decimalPlaces): '';

          var multiplier = Math.pow(10, decimalPlaces);

          if (fractionalPart * 1 === 0) {
            fractionalPart = fractionalPart / multiplier;
          }

          if(fractionalPart) {
            truncatedValue = commaSepratedPart + '.' + fractionalPart;
            truncatedValue = truncatedValue.replace(/(\.[0-9]*?)0+$/, '$1');
          } else {
            truncatedValue = commaSepratedPart;
          }

          return truncatedValue.toString();
        }

        // Return the original input if it's not a valid number
        return input;
      };
    });
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .filter('number2words', number2Words);

  /** @ngInject */

  function number2Words() {

    function isInteger(x) {
      return x % 1 === 0;
    }

    return function (value) {
      if (value && isInteger(value))
        return toWords(value);

      return value;
    };
  }


  var th = ['', 'thousand', 'million', 'billion', 'trillion'];
  var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];


  function toWords(s) {
    s = s.toString();
    s = s.replace(/[\, ]/g, '');
    if (s != parseFloat(s)) return 'not a number';
    var x = s.indexOf('.');
    if (x == -1) x = s.length;
    if (x > 15) return 'too big';
    var n = s.split('');
    var str = '';
    var sk = 0;
    var i = 0;
    for (i = 0; i < x; i++) {
      if ((x - i) % 3 == 2) {
        if (n[i] == '1') {
          str += tn[Number(n[i + 1])] + ' ';
          i++;
          sk = 1;
        }
        else if (n[i] != 0) {
          str += tw[n[i] - 2] + ' ';
          sk = 1;
        }
      }
      else if (n[i] != 0) {
        str += dg[n[i]] + ' ';
        if ((x - i) % 3 == 0) str += 'hundred ';
        sk = 1;
      }

      if ((x - i) % 3 == 1) {
        if (sk) str += th[(x - i - 1) / 3] + ' ';
        sk = 0;
      }
    }
    if (x != s.length) {
      var y = s.length;
      str += 'point ';
      for (i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
    }
    return str.replace(/\s+/g, ' ');
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .filter('unit', unitFilter)
    .filter('unitWithOutDecimalFilter', unitWithOutDecimalFilter)
    .filter('unitValue', unitValueFilter)
    .filter('valueByUnit', valueByUnitFilter)
    .filter('Percentage', percentage)
    .filter('frequency', frequencyFilter)
    .filter('dividendOption', dividendOptionFilter)
    .filter('schemetype', schemetypeFilter)
    .filter('investmentOption', investmentOptionFilter)
    .filter('removeCountry', removeCountryFilter)
    .filter('filterCity', filterCity)
    .filter('searchFor', searchForFilter)
    .filter('linebreak', linebreak)
    .filter('decimalFilter', decimalFilter)
    .filter('camelcase', camelcase)
    .filter('unitWithDecimal', unitWithDecimal);

  /** @ngInject */
  function unitFilter() {
    return function (input) {

      if (!input)
        return '0';

      var value = input.toString().split('.');
      var x = value[0], decimal = '', finalStr = '';

      if (value.length > 1) {
        decimal = value[1].substring(0, 2);
      } else {
        decimal = '00'
      }
      var lastThree = x.substring(x.length - 3);
      var otherNumbers = x.substring(0, x.length - 3);

      if (otherNumbers != '')
        lastThree = ',' + lastThree;

      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
      finalStr = res + '.' + decimal;

      return finalStr;
    }
  }

  function unitWithOutDecimalFilter() {
    return function (input) {

      if (!input)
        return '0';
      
      var isNegativeValue = (typeof(input) === 'number' && input<0) ? true :false;
      if(isNegativeValue){
        input = Math.abs(input);
      }
      var value = input.toString().split('.');
      var x = value[0], decimal = '', finalStr = '';

      if (value.length > 1) {
        decimal = value[1].substring(0, 2);
      }
      var lastThree = x.substring(x.length - 3);
      var otherNumbers = x.substring(0, x.length - 3);

      if (otherNumbers != '')
        lastThree = ',' + lastThree;

      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
      finalStr = res;
      if( decimal.length !== 0 ){
        finalStr = res + '.' + decimal;
      }
      if(isNegativeValue){
        finalStr = '-'+ finalStr;
      }

      return finalStr;
    }
  }

  function searchForFilter() {
    return function (arr, searchString) {
      if (!searchString) {
        return arr;
      }
      var result = [];
      searchString = searchString.toLowerCase();
      // Using the forEach helper method to loop through the array
      angular.forEach(arr, function (item) {
        if (item.scheme.toLowerCase().indexOf(searchString) !== -1) {
          result.push(item);
        }
      });
      return result;
    };
  }

  /** @ngInject */
  function unitValueFilter() {
    return function () {
      return '';
    }
  }

  /** @ngInject */
  function valueByUnitFilter() {
    return function (value,unit,decimalPoint) {
      value = value || 0;
      unit = unit || 'Crore';
      decimalPoint = decimalPoint || 0;
      switch(unit){
        case 'Lacs':
          return value?parseFloat(value/100000).toFixed(decimalPoint):0;
        case 'Crore':
          return value?parseFloat(value/10000000).toFixed(decimalPoint):0;

      }
    }
  }

  /** @ngInject */

  function percentage($filter) {
    return function (input, decimals) {
      return $filter('number')(input * 100, decimals) + '%';
    };
  }

  /** @ngInject */
  function frequencyFilter() {
    return function (input) {
      switch (input) {
        case 'D':
        case 'DZ':
          return 'Daily';
        case 'OW':
          return 'Weekly';
        case 'OM':
          return 'Monthly';
        case 'Q':
          return 'Quarterly';
        case 'H':
          return 'Half yearly';
        case 'Y':
          return 'Yearly';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function dividendOptionFilter() {
    return function (input) {
      switch (input) {
        case 'Y':
          return 'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option';
        case 'N':
          return 'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option';
        default :
          return '';
      }
    }
  }

  /** @ngInject */
  function investmentOptionFilter() {
    return function (input) {
      switch (input) {
        case 'GROWTH':
          return 'Growth';
        case 'DIVIDEND':
          return 'Income Distribution cum Capital Withdrawal (IDCW) Option';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function schemetypeFilter() {
    return function (input) {
      switch (input) {
        case 'F':
          return 'Fixed Amount';
        case 'V':
          return 'Capital Appreciation';
        default :
          return input;
      }
    }
  }

  /** @ngInject */
  function removeCountryFilter() {
    return function (input, country) {
      var _result = null;
      if (input && angular.isArray(input)) {
        _result = input.filter(function (item) {
          return item.countryName.toLowerCase() !== country.toLowerCase();
        })
      } else {
        _result = input;
      }
      return _result;
    }
  }

  /** @ngInject */
  function filterCity() {
    return function (input, city) {
      var _result = null;
      if (input && angular.isArray(input)) {
        _result = input.filter(function (item) {
          return item.cityName.toLowerCase().indexOf(city.toLowerCase()) !== -1;
        })
      } else {
        _result = input;
      }
      return _result;
    }
  }

  /** @ngInject */
  function linebreak() {
    return function (data, sepNumber) {
      sepNumber = sepNumber ? parseInt(sepNumber) : 0;
      if (!data || data.split(" ").length <= sepNumber) {
        return data;
      } else {
        var textArr = data.split(" ");
        if (textArr.length > sepNumber) {
          var text = [];
          for (var i = 0; i <= textArr.length; i = i + sepNumber) {
            text.push(textArr.slice(i, i + sepNumber).join(" "));
          }
          return text.join(" <br/> ");
        } else {
          return data;
        }
      }
    };
  }

  /** @ngInject */
  function decimalFilter() {
    return function (input) {
      var isNegative = false;
      if(!input)
        return '0';

      if(input<0){
        input = input.toString().slice(1);
        isNegative = true;
      }

      var value = input.toString().split('.');
      var x = value[0],decimal ='', finalStr = '';

      if(value.length > 1){
        decimal = value[1].substring(0, 2);
      }
      var lastThree = x.substring(x.length-3);
      var otherNumbers = x.substring(0,x.length-3);

      if(otherNumbers != '')
        lastThree = ',' + lastThree;

      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

      if(value.length > 1){
        finalStr = res+'.'+decimal;
      } else {
        finalStr = res;
      }
      return isNegative?"-"+finalStr:finalStr ;
    }
  }

  /** @ngInject */
  function camelcase() {
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
  }

  function unitWithDecimal() {
    return function (input) {
      var isNegative = false;
      if(!input)
        return '0';

      if(input<0){
        input = input.toString().slice(1);
        isNegative = true;
      }

      var value = input.toString().split('.');
      var x = value[0],decimal ='', finalStr = '';

      if(value.length > 1){
        decimal = value[1].substring(0, 4);
      }
      var lastThree = x.substring(x.length-3);
      var otherNumbers = x.substring(0,x.length-3);

      if(otherNumbers != '')
        lastThree = ',' + lastThree;

      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

      if(value.length > 1){
        finalStr = res+'.'+decimal;
      } else {
        finalStr = res;
      }
      return isNegative?"-"+finalStr:finalStr ;
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('hdfcFooter', hdfcFooter);

  /** @ngInject */
  function hdfcFooter() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
        creationDate: '='
      },
      controller: footerController,
      controllerAs: 'Footer',
      bindToController: true
    });

    /** @ngInject */
    function footerController() {
      var vm = this;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('tooltip', tooltip);

  /** @ngInject */
  function tooltip() {
    return {
      restrict: 'A',
      link: function(scope, element){
        // var $ = $window.jQuery;
        angular.element(element).hover(function(){
          // on mouseenter
          angular.element(element).tooltip('show');
        }, function(){
          // on mouseleave
          angular.element(element).tooltip('hide');
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('restrictSpecialCharcter', restrictSpecialCharcter);

  /** @ngInject */
  function restrictSpecialCharcter() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^A-Za-z0-9]/g, '');

          if(transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('checkStrength', checkStrength)
    .directive('passwordInText', passwordInText);

  /** @ngInject */
  function checkStrength() {
    return {
      replace: false,
      restrict: 'EACM',
      link: function (scope, iElement, iAttrs) {
        var strength = {
          colors: ['#F00', '#F90', '#FF0', '#46a040'],

          mesureStrength: function (p) {
            if (p) {
              var _force = 0;
              var _regex = /^(?=.*[@#$%_!])/g;

              var _lowerLetters = /[a-z]+/.test(p);
              var _upperLetters = /[A-Z]+/.test(p);
              var _numbers = /[0-9]+/.test(p);
              var _symbols = _regex.test(p);

              var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
              // var _passedMatches = $.grep(_flags, function (el) { return el === true; }).length;
              /*           switch(_passedMatches) {
               case 1:
               _force = 10;
               break;
               case 2:
               _force = 20;
               break;
               case 3:
               _force = 30;
               break;
               case 4:
               _force = 40;
               break;
               default:
               _force = 40;
               break;
               }*/

              // _force += 2 * p.length + ((p.length >= 7) ? 1 : 0);
              // _force += _passedMatches * 10;
              //
              // // penality (short password)
              // _force = (p.length <= 7) ? Math.min(_force, 10) : _force;
              //
              // // penality (poor variety of characters)
              // _force = (_passedMatches == 1) ? Math.min(_force, 10) : _force;
              // _force = (_passedMatches == 2) ? Math.min(_force, 20) : _force;
              // _force = (_passedMatches == 3) ? Math.min(_force, 40) : _force;

              for (var i = 0; i < _flags.length; i++) {
                if (_flags[i]) {
                  _force++;
                }
              }

              // if(_force===4){
              //   _force++;
              // }

              return _force*10;

            }
          },
          getColor: function (s) {
            var idx = 0;
            if (s <= 10) {
              idx = 0;
            }
            else if (s <= 20) {
              idx = 1;
            }
            else if (s <= 30) {
              idx = 2;
            }
            else if (s <= 40) {
              idx = 3;
            }
            else {
              idx = 4;
            }

            return {idx: idx + 1, col: this.colors[idx]};

          }
        };

        scope.$watch(iAttrs.checkStrength, function () {
          if (!scope.pw) {
            iElement.css({"display": "none"});
          } else {
            var c = strength.getColor(strength.mesureStrength(scope.pw));
            iElement.css({"display": "inline"});
            iElement.children('li')
              .css({"background": "#DDD"})
              .slice(0, c.idx)
              .css({"background": c.col});
          }
        });

      },
      template: '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>'
    };
  }

  /** @ngInject */
  function passwordInText(mask) {
    var password = function (value) {
      if (!value) { return ''; }
      return value.replace(/./g, '\u2022');
    };

    return {
      scope: { model: '=ngModel' },
      require: 'ngModel',
      link: function (scope, element, attributes, ngModel) {
        var parser = mask(password, ngModel);
        ngModel.$parsers.push(parser);
        scope.model = parser(scope.model);
      }
    };
  };

/* taken from http://embed.plnkr.co/z6xZws/*/
  angular
    .module('hdfc-mf-distributor-web')
    .factory('mask', function () {
      var mask = function (formatter, ngModel) {
        var model = '',
          view = '';
        return function (value) {
          if (value === view) { return model; }

          if (value && value.length > view.length) {
            model += value.slice(view.length - value.length);
          }
          if ( value.length < view.length) {
            model = model.substring(0, model.length-1);
          }

          view = formatter(model);
          ngModel.$setViewValue(view);
          ngModel.$render();

          return model;
        };
      };

      return mask;
    });

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('ngDropdownMultiselectDisabled', function($timeout) {
      return {
      restrict: 'A',
      link: function (scope, element, attr) {
        var $btn;
        $btn = element.find('button');
        $timeout(function() {
          return scope.$watch(attr.ngDropdownMultiselectDisabled, function(newVal) {
            return $btn.attr('disabled', newVal);
          });
        });
      }
  };
});
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('limitTo', limitTo);

  /** @ngInject */
  function limitTo() {
    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        var limit = parseInt(attrs.limitTo);
        angular.element(elem).on("keypress", function (e) {
          if (this.value.length == limit) e.preventDefault();
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('isNumber', isNumber)
    .directive('onlyAlphabets', onlyAlphabets);

  /** @ngInject */
  function isNumber() {
    return {
      require: 'ngModel',
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^0-9]/g, '');

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          return false;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }


  /** @ngInject */
  function onlyAlphabets() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, element, attrs, ngModel) {
        if (!ngModel) {
          return;
        }
        ngModel.$parsers.unshift(function (inputValue) {
          var alphabets = inputValue.split('').filter(function (s) {
            return (isALetter(s));
          }).join('');
          ngModel.$viewValue = alphabets;
          ngModel.$render();
          return alphabets;
        });
      }
    };

    function isALetter(charVal)
    {
      if( (charVal.toUpperCase() != charVal.toLowerCase()) || charVal === ' ' ) {
        return true;
      }
      else {
        return false;
      }
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('customDirective', ['$filter', '$document', '$compile', '$parse', function($filter, $document, $compile, $parse) {
      return {
        restrict: 'AE',
        scope: {
          selectedModel: '=',
          options: '=',
          extraSettings: '=',
          events: '=',
          searchFilter: '=?',
          translationTexts: '=',
          groupBy: '@',
          disabled: "="
        },
        template: function(element, attrs) {
          var checkboxes = attrs.checkboxes ? true : false;
          var groups = attrs.groupBy ? true : false;

          var template = '<div class="multiselect-parent btn-group dropdown-multiselect" ng-class="{open: open}">';
          template += '<button ng-disabled="disabled" type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}&nbsp;<span class="caret"></span></button>';
          template += '<ul class="dropdown-menu dropdown-menu-form" ng-if="open" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\', overflow: \'auto\' }" >';
          template += '<li ng-if="settings.showCheckAll && settings.selectionLimit !== 1"><a ng-keydown="keyDownLink($event)" data-ng-click="selectAll()" tabindex="-1" id="selectAll"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
          template += '<li ng-if="settings.showUncheckAll"><a ng-keydown="keyDownLink($event)" data-ng-click="deselectAll();" tabindex="-1" id="deselectAll"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
          template += '<li ng-if="settings.selectByGroups && ((settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll)" class="divider"></li>';
          template += '<li ng-if="settings.selectByGroups && ((settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll)" class="divider"></li>';
          template += '<li ng-repeat="currentGroup in settings.selectByGroups track by $index" ng-click="selectCurrentGroup(currentGroup)"><a ng-class="{\'dropdown-selected-group\': selectedGroup === currentGroup}" tabindex="-1">{{::texts.selectGroup}} {{::getGroupLabel(currentGroup)}}</a></li>';
          template += '<li ng-if="settings.selectByGroups && settings.showEnableSearchButton" class="divider"></li>';
          template += '<li ng-if="settings.showEnableSearchButton && settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click="toggleSearch($event);" tabindex="-1">{{texts.disableSearch}}</a></li>';
          template += '<li ng-if="settings.showEnableSearchButton && !settings.enableSearch"><a ng-keydown="keyDownLink($event); keyDownToggleSearch();" ng-click="toggleSearch($event);" tabindex="-1">{{texts.enableSearch}}</a></li>';
          template += '<li ng-if="(settings.showCheckAll && settings.selectionLimit > 0) || settings.showUncheckAll || settings.showEnableSearchButton" class="divider"></li>';
          template += '<li ng-if="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control searchField" ng-keydown="keyDownSearchDefault($event); keyDownSearch($event, input.searchFilter);" ng-style="{width: \'100%\'}" ng-model="input.searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
          template += '<li ng-if="settings.enableSearch" class="divider"></li>';

          if (groups) {
            template += '<li ng-repeat-start="option in orderedItems | filter:getFilter(input.searchFilter)" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupLabel(getPropertyForObject(option, settings.groupBy)) }}</li>';
            template += '<li ng-class="{\'active\': isChecked(getPropertyForObject(option,settings.idProp)) && settings.styleActive}" ng-repeat-end role="presentation">';
          } else {
            template += '<li ng-class="{\'active\': isChecked(getPropertyForObject(option,settings.idProp)) && settings.styleActive}" role="presentation" ng-repeat="option in options | filter:getFilter(input.searchFilter)">';
          }

          template += '<a ng-keydown="option.disabled || keyDownLink($event)" role="menuitem" class="option" tabindex="-1" ng-click="option.disabled || setSelectedItem(getPropertyForObject(option,settings.idProp), false, true)" ng-disabled="option.disabled">';

          if (checkboxes) {
            template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> <span mf-dropdown-static-include="{{settings.template}}"></div></label></span></a>';
          } else {
            template += '<span data-ng-class="{\'glyphicon glyphicon-ok\': isChecked(getPropertyForObject(option,settings.idProp))}"> </span> <span mf-dropdown-static-include="{{settings.template}}"></span></a>';
          }

          template += '</li>';

          template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
          template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

          template += '</ul>';
          template += '</div>';

          element.html(template);
        },
        link: function($scope, $element, $attrs) {
          var $dropdownTrigger = $element.children()[0];

          $scope.toggleDropdown = function() {
            $scope.open = !$scope.open;
            if ($scope.settings.keyboardControls) {
              if ($scope.open) {
                if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                  setTimeout(function() {
                    angular.element($element)[0].querySelector('.searchField').focus();
                  }, 0);
                } else {
                  setTimeout(function() {
                    angular.element($element)[0].querySelector('.option').focus();
                  }, 0);
                }
              }
            }
          };

          $scope.checkboxClick = function($event, id) {
            $scope.setSelectedItem(id, false, true);
            $event.stopImmediatePropagation();
          };

          $scope.externalEvents = {
            onItemSelect: angular.noop,
            onItemDeselect: angular.noop,
            onSelectAll: angular.noop,
            onDeselectAll: angular.noop,
            onInitDone: angular.noop,
            onMaxSelectionReached: angular.noop,
            onSelectionChanged: angular.noop
          };

          $scope.settings = {
            dynamicTitle: true,
            scrollable: false,
            scrollableHeight: '300px',
            closeOnBlur: true,
            displayProp: 'label',
            idProp: 'id',
            externalIdProp: 'id',
            enableSearch: false,
            selectionLimit: 0,
            showCheckAll: true,
            showUncheckAll: true,
            showEnableSearchButton: false,
            closeOnSelect: false,
            buttonClasses: 'btn btn-default',
            closeOnDeselect: false,
            groupBy: $attrs.groupBy || undefined,
            groupByTextProvider: null,
            smartButtonMaxItems: 0,
            smartButtonTextConverter: angular.noop,
            styleActive: false,
            keyboardControls: false,
            template: '{{getPropertyForObject(option, settings.displayProp)}}',
            searchField: '$'
          };

          $scope.texts = {
            checkAll: 'Check All',
            uncheckAll: 'Uncheck All',
            selectionCount: 'checked',
            selectionOf: '/',
            searchPlaceholder: 'Search...',
            buttonDefaultText: 'Select',
            dynamicButtonTextSuffix: 'checked',
            disableSearch: 'Disable search',
            enableSearch: 'Enable search',
            selectGroup: 'Select all:'
          };

          $scope.input = {
            searchFilter: $scope.searchFilter || ''
          };

          if (angular.isDefined($scope.settings.groupBy)) {
            $scope.$watch('options', function(newValue) {
              if (angular.isDefined(newValue)) {
                $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
              }
            });
          }

          $scope.$watch('selectedModel', function(newValue) {
            if (!Array.isArray(newValue)) {
              $scope.singleSelection = true;
            } else {
              $scope.singleSelection = false;
            }
          });

          $scope.selectCurrentGroup = function(currentGroup) {
            $scope.selectedModel.splice(0, $scope.selectedModel.length);
            if ($scope.orderedItems) {
              $scope.orderedItems.forEach(function(item) {
                if (item[$scope.groupBy] === currentGroup) {
                  $scope.setSelectedItem($scope.getPropertyForObject(item, $scope.settings.idProp), false, false)
                }
              });
            }
            $scope.externalEvents.onSelectionChanged();
          };

          angular.extend($scope.settings, $scope.extraSettings || []);
          angular.extend($scope.externalEvents, $scope.events || []);
          angular.extend($scope.texts, $scope.translationTexts);

          $scope.singleSelection = $scope.settings.selectionLimit === 1;

          function getFindObj(id) {
            var findObj = {};

            if ($scope.settings.externalIdProp === '') {
              findObj[$scope.settings.idProp] = id;
            } else {
              findObj[$scope.settings.externalIdProp] = id;
            }

            return findObj;
          }

          function clearObject(object) {
            for (var prop in object) {
              delete object[prop];
            }
          }

          if ($scope.singleSelection) {
            if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
              clearObject($scope.selectedModel);
            }
          }

          if ($scope.settings.closeOnBlur) {
            $document.on('click', function(e) {
              if ($scope.open) {
                var target = e.target.parentElement;
                var parentFound = false;

                while (angular.isDefined(target) && target !== null && !parentFound) {
                  if (!!target.className.split && contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                    if (target === $dropdownTrigger) {
                      parentFound = true;
                    }
                  }
                  target = target.parentElement;
                }

                if (!parentFound) {
                  $scope.$apply(function() {
                    $scope.open = false;
                  });
                }
              }
            });
          }

          $scope.getGroupLabel = function(groupValue) {
            if ($scope.settings.groupByTextProvider !== null) {
              return $scope.settings.groupByTextProvider(groupValue);
            }

            return groupValue;
          };

          $scope.getButtonText = function() {
            if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && Object.keys($scope.selectedModel).length > 0))) {
              if (angular.isFunction($scope.settings.smartButtonTextProvider)) {
                return $scope.settings.smartButtonTextProvider($scope.selectedModel);
              }


              if ($scope.settings.smartButtonMaxItems > 0) {
                var itemsText = [];



                angular.forEach($scope.options, function(optionItem) {
                  if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                    itemsText.push(converterResponse ? converterResponse : displayText);
                  }
                });

                if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                  itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                  itemsText.push('...');
                }

                return itemsText.join(', ');
              } else {
                var totalSelected;

//						            if ($scope.options.length === $scope.selectedModel.length){
//                           console.log("heres")
//                           itemsText = "All";
//                           return itemsText;
//                        }

                if ($scope.singleSelection) {
                  totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                } else {
                  totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                }

                if (totalSelected === 0) {
                  return $scope.texts.buttonDefaultText;
                } else if(totalSelected === 9){
                  return 'All' + ' ' + $scope.texts.dynamicButtonTextSuffix
                }else if(totalSelected === 8){
                  return 'All' + ' ' + $scope.texts.dynamicButtonTextSuffix
                }
                else {
                  return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                }
              }
            } else {
              return $scope.texts.buttonDefaultText;
            }
          };

          $scope.getPropertyForObject = function(object, property) {
            if (angular.isDefined(object) && object.hasOwnProperty(property)) {
              return object[property];
            }

            return '';
          };

          $scope.selectAll = function() {
            var searchResult;
            $scope.deselectAll(true);
            $scope.externalEvents.onSelectAll();

            searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
            angular.forEach(searchResult, function(value) {
              $scope.setSelectedItem(value[$scope.settings.idProp], true, false);
            });
            $scope.externalEvents.onSelectionChanged();
            $scope.selectedGroup = null;
          };

          $scope.deselectAll = function(dontSendEvent) {
            dontSendEvent = dontSendEvent || false;

            if (!dontSendEvent) {
              $scope.externalEvents.onDeselectAll();
            }

            if ($scope.singleSelection) {
              clearObject($scope.selectedModel);
            } else {
              $scope.selectedModel.splice(0, $scope.selectedModel.length);
            }
            if (!dontSendEvent) {
              $scope.externalEvents.onSelectionChanged();
            }
            $scope.selectedGroup = null;
          };

          $scope.setSelectedItem = function(id, dontRemove, fireSelectionChange) {
            var findObj = getFindObj(id);
            var finalObj = null;

            if ($scope.settings.externalIdProp === '') {
              finalObj = find($scope.options, findObj);
            } else {
              finalObj = findObj;
            }

            if ($scope.singleSelection) {
              clearObject($scope.selectedModel);
              angular.extend($scope.selectedModel, finalObj);
              $scope.externalEvents.onItemSelect(finalObj);
              if ($scope.settings.closeOnSelect || $scope.settings.closeOnDeselect) $scope.open = false;
            } else {
              dontRemove = dontRemove || false;

              var exists = findIndex($scope.selectedModel, findObj) !== -1;

              if (!dontRemove && exists) {
                $scope.selectedModel.splice(findIndex($scope.selectedModel, findObj), 1);
                $scope.externalEvents.onItemDeselect(findObj);
                if ($scope.settings.closeOnDeselect) $scope.open = false;
              } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                $scope.selectedModel.push(finalObj);
                $scope.externalEvents.onItemSelect(finalObj);
                if ($scope.settings.closeOnSelect) $scope.open = false;
                if ($scope.settings.selectionLimit > 0 && $scope.selectedModel.length === $scope.settings.selectionLimit) {
                  $scope.externalEvents.onMaxSelectionReached();
                }
              }
            }
            if (fireSelectionChange) {
              $scope.externalEvents.onSelectionChanged();
            }
            $scope.selectedGroup = null;
          };

          $scope.isChecked = function(id) {
            if ($scope.singleSelection) {
              return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
            }

            return findIndex($scope.selectedModel, getFindObj(id)) !== -1;
          };

          $scope.externalEvents.onInitDone();

          $scope.keyDownLink = function(event) {
            var sourceScope = angular.element(event.target).scope();
            var nextOption;
            var parent = event.target.parentNode;
            if (!$scope.settings.keyboardControls) {
              return;
            }
            if (event.keyCode === 13 || event.keyCode === 32) { // enter
              event.preventDefault();
              if (!!sourceScope.option) {
                $scope.setSelectedItem($scope.getPropertyForObject(sourceScope.option, $scope.settings.idProp), false, true);
              } else if (event.target.id === 'deselectAll') {
                $scope.deselectAll();
              } else if (event.target.id === 'selectAll') {
                $scope.selectAll();
              }
            } else if (event.keyCode === 38) { // up arrow
              event.preventDefault();
              if (!!parent.previousElementSibling) {
                nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
              }
              while (!nextOption && !!parent) {
                parent = parent.previousElementSibling;
                if (!!parent) {
                  nextOption = parent.querySelector('a') || parent.querySelector('input');
                }
              }
              if (!!nextOption) {
                nextOption.focus();
              }
            } else if (event.keyCode === 40) { // down arrow
              event.preventDefault();
              if (!!parent.nextElementSibling) {
                nextOption = parent.nextElementSibling.querySelector('a') || parent.nextElementSibling.querySelector('input');
              }
              while (!nextOption && !!parent) {
                parent = parent.nextElementSibling;
                if (!!parent) {
                  nextOption = parent.querySelector('a') || parent.querySelector('input');
                }
              }
              if (!!nextOption) {
                nextOption.focus();
              }
            } else if (event.keyCode === 27) {
              event.preventDefault();

              $scope.toggleDropdown();
            }
          };

          $scope.keyDownSearchDefault = function(event) {
            var parent = event.target.parentNode.parentNode;
            var nextOption;
            if (!$scope.settings.keyboardControls) {
              return;
            }
            if (event.keyCode === 9 || event.keyCode === 40) { //tab
              event.preventDefault();
              setTimeout(function() {
                angular.element($element)[0].querySelector('.option').focus();
              }, 0);
            } else if (event.keyCode === 38) {
              event.preventDefault();
              if (!!parent.previousElementSibling) {
                nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
              }
              while (!nextOption && !!parent) {
                parent = parent.previousElementSibling;
                if (!!parent) {
                  nextOption = parent.querySelector('a') || parent.querySelector('input');
                }
              }
              if (!!nextOption) {
                nextOption.focus();
              }
            } else if (event.keyCode === 27) {
              event.preventDefault();

              $scope.toggleDropdown();
            }
          };

          $scope.keyDownSearch = function(event, searchFilter) {
            var searchResult;
            if (!$scope.settings.keyboardControls) {
              return;
            }
            if (event.keyCode === 13) {
              if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                searchResult = $filter('filter')($scope.options, $scope.getFilter(searchFilter));
                if (searchResult.length === 1) {
                  $scope.setSelectedItem($scope.getPropertyForObject(searchResult[0], $scope.settings.idProp), false, true);
                }
              } else if ($scope.settings.enableSearch) {
                $scope.selectAll();
              }
            }
          };

          $scope.getFilter = function(searchFilter) {
            var filter = {};
            filter[$scope.settings.searchField] = searchFilter;
            return filter;
          };

          $scope.toggleSearch = function($event) {
            if ($event) {
              $event.stopPropagation();
            }
            $scope.settings.enableSearch = !$scope.settings.enableSearch;
            if (!$scope.settings.enableSearch) {
              $scope.input.searchFilter = '';
            }
          };

          $scope.keyDownToggleSearch = function() {
            if (!$scope.settings.keyboardControls) {
              return;
            }
            if (event.keyCode === 13) {
              $scope.toggleSearch();
              if ($scope.settings.enableSearch) {
                setTimeout(
                  function() {
                    angular.element($element)[0].querySelector('.searchField').focus();
                  }, 0
                );
              } else {
                angular.element($element)[0].querySelector('.option').focus();
              }
            }
          };
        }
      };
    }]);

  function contains(collection, target) {
    var containsTarget = false;
    collection.some(function(object) {
      if (object === target) {
        containsTarget = true;
        return true;
      }
    });
    return containsTarget;
  }

  function find(collection, properties) {
    var target;

    collection.some(function(object) {
      var hasAllSameProperties = true;
      Object.keys(properties).forEach(function(key) {
        if (object[key] !== properties[key]) {
          hasAllSameProperties = false;
        }
      });
      if (hasAllSameProperties) {
        target = object;
        return true
      }
    });

    return target;
  }

  function findIndex(collection, properties) {
    var index = -1;
    var counter = -1;

    collection.some(function(object) {
      var hasAllSameProperties = true;
      counter += 1;
      Object.keys(properties).forEach(function(key) {
        if (object[key] !== properties[key]) {
          hasAllSameProperties = false;
        }
      });
      if (hasAllSameProperties) {
        index = counter;
        return true
      }
    });

    return index;
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive("directive.mask", mask)
    .directive("directive.mask.limited", maskingSomeDigit);

  /** @ngInject */
  function mask($compile) {

    // Mask user input, similar to the way a password input type would
    // For example: transform abc123 into ******
    // Use this when you need to mask input, but without all the baggage that comes with the
    // 'password' input type (such as the browser offering to save the password for the user)
    //
    // ----- POSSIBLE USE CASE -----
    // CVC input field for a credit card
    //
    // ----- HOW IT WORKS -----
    // When the input field gains focus, it's cloned and the clone is changed to a 'password' type
    // The original input field is hidden at this point and the clone is shown
    // When the user types into the clone the real input field's model will be kept up to date
    // When the cloned input field loses focus, it's removed from the page and the original input
    // is shown. The model value is masked for display in this field using the $formatters

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function(scope, element, attributes, controller) {

      var maskedInputElement;

      var maskValue = function(value) {
        // replace all characters with the mask character
        return (value || "").replace(/[\S]/g, "\u2022");
      };

      var createMaskedInputElement = function() {
        if (! maskedInputElement || ! maskedInputElement.length) {
          maskedInputElement = element.clone(true);
          maskedInputElement.attr("type", "password"); // ensure the value is masked
          maskedInputElement.removeAttr("name"); // ensure the password save prompt won't show
          maskedInputElement.attr("ng-model");
          maskedInputElement.removeAttr("directive.mask"); // ensure an infinite loop of clones isn't created
          maskedInputElement.bind("blur", function() {
            element.removeClass("ng-hide");
            maskedInputElement.remove();
            maskedInputElement = null;
          });
          $compile(maskedInputElement)(scope);
          element.after(maskedInputElement);
        }
      };

      element.bind("focus", function() {
        createMaskedInputElement();
        element.addClass("ng-hide");
        maskedInputElement[0].focus();
        scope.modelDirty = true;
        controller.modelDirty = true;
      });

      controller.$formatters.push(function(value) {
        // ensure the displayed value is still masked when the clone is hidden
        return maskValue(value);
      });

    };

    return expose;
  }
  function maskingSomeDigit($compile) {

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    expose.link = function(scope, element, attributes, controller) {

      var maskedInputElement;

      var maskValue = function(value) {
        if(value) {
          var maskedLength = Math.max(0, value.length - 4);
          var maskedPart = "\u2022".repeat(maskedLength);
          return maskedPart + value.substring(maskedLength);
        }
        return ''
      };

      var createMaskedInputElement = function() {
        if (! maskedInputElement || ! maskedInputElement.length) {
          maskedInputElement = element.clone(true);
          maskedInputElement.attr("type", "password"); // ensure the value is masked
          maskedInputElement.removeAttr("name"); // ensure the password save prompt won't show
          maskedInputElement.attr("ng-model");
          maskedInputElement.removeAttr("directive.mask.limited"); // ensure an infinite loop of clones isn't created
          maskedInputElement.bind("blur", function() {
            element.removeClass("ng-hide");
            maskedInputElement.remove();
            maskedInputElement = null;
          });
          $compile(maskedInputElement)(scope);
          element.after(maskedInputElement);
        }
      };

      element.bind("focus", function() {
        createMaskedInputElement();
        element.addClass("ng-hide");
        maskedInputElement[0].focus();
        scope.modelDirty = true;
        controller.modelDirty = true;
      });

      controller.$formatters.push(function(value) {
        // ensure the displayed value is still masked when the clone is hidden
        return maskValue(value);
      });

    };

    return expose;
  }

/*
  angular.module("core.application.main")
    .directive("core.application.main.directive.mask",
      ["$compile",
        function($compile) {

          // Mask user input, similar to the way a password input type would
          // For example: transform abc123 into ******
          // Use this when you need to mask input, but without all the baggage that comes with the
          // 'password' input type (such as the browser offering to save the password for the user)
          //
          // ----- POSSIBLE USE CASE -----
          // CVC input field for a credit card
          //
          // ----- HOW IT WORKS -----
          // When the input field gains focus, it's cloned and the clone is changed to a 'password' type
          // The original input field is hidden at this point and the clone is shown
          // When the user types into the clone the real input field's model will be kept up to date
          // When the cloned input field loses focus, it's removed from the page and the original input
          // is shown. The model value is masked for display in this field using the $formatters

          var expose = {};
          expose.require = "ngModel";
          expose.restrict = "A";

          expose.link = function(scope, element, attributes, controller) {

            var maskedInputElement;

            var maskValue = function(value) {
              // replace all characters with the mask character
              return (value || "").replace(/[\S]/g, "\u2022");
            };

            var createMaskedInputElement = function() {
              if (! maskedInputElement || ! maskedInputElement.length) {
                maskedInputElement = element.clone(true);
                maskedInputElement.attr("type", "password"); // ensure the value is masked
                maskedInputElement.removeAttr("name"); // ensure the password save prompt won't show
                maskedInputElement.removeAttr("core.application.main.directive.mask"); // ensure an infinite loop of clones isn't created
                maskedInputElement.bind("blur", function() {
                  element.removeClass("ng-hide");
                  maskedInputElement.remove();
                  maskedInputElement = null;
                });
                $compile(maskedInputElement)(scope);
                element.after(maskedInputElement);
              }
            };

            element.bind("focus", function() {
              createMaskedInputElement();
              element.addClass("ng-hide");
              maskedInputElement[0].focus();
            });

            controller.$formatters.push(function(value) {
              // ensure the displayed value is still masked when the clone is hidden
              return maskValue(value);
            });

          };

          return expose;
        }
      ]);*/

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('ignoreMouseWheel', ignoreMouseWheel);

  /** @ngInject */
  function ignoreMouseWheel($rootScope) {
    return {
      restrict: 'A',
      link: function( scope, element, attrs ){
        element.bind('mousewheel', function ( event ) {
          element.blur();
        } );
        element.bind('keydown', function (evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && charCode!== 110 && charCode !== 190) {
            return false;
          }
          if(evt.shiftKey && ((charCode >= 48 && charCode <= 57) || (charCode > 96 && charCode < 105))){
            return false;
          }
          return true;
        })
      }
    }
  }


})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('httpSrc', httpSrc);

  /** @ngInject */
  function httpSrc($http) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var requestConfig = {
          method: 'Get',
          url: attrs.httpSrc,
          responseType: 'arraybuffer',
          cache: 'true'
        };

        $http(requestConfig)
          .then(function(response) {
            var arr = new Uint8Array(response.data);
            var raw = '';
            var i, j, subArray, chunk = 5000;
            for (i = 0, j = arr.length; i < j; i += chunk) {
              subArray = arr.subarray(i, i + chunk);
              raw += String.fromCharCode.apply(null, subArray);
            }
            var b64 = btoa(raw);
            attrs.$set('src', "data:image/jpeg;base64," + b64);
          });
      }
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('fileModelProfile', fileUploadProfileDirective);

  /** @ngInject */
  function fileUploadProfileDirective(){
    return {
      restrict: 'A',
        scope:{upload:'&'},
      link: function(scope, element, attr) {
        element.bind('change', function(){
          if(attr.serial){
            scope.upload( {file:element[0].files[0],serial:attr.serial});
          }else{
            scope.upload( {file:element[0].files[0]});
          }
        });
      }
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('fileModel', fileUploadDirective);

  /** @ngInject */
  function fileUploadDirective($parse,$window){
    return {
      restrict: 'A',
      scope:{upload:'&',canvasattr: '&'},
      link: function(scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
        element.bind('change', function(){
          scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
            if(element[0].files[0].type == 'image/jpeg') {
              var canvas = $window.document.createElement('canvas');
              canvas.style.visibility = 'hidden';
              var img = new Image();
              var reader = new FileReader();
              reader.onload = function (e) {
                if (attrs.targetimg) {
                  img.src = e.target.result;
                  img.onload = function () {
                    canvas.width = this.width;
                    canvas.height = this.height;
                    canvas.getContext('2d').drawImage(img, 0, 0);
                    canvas.toBlob(function (blob) {
                      var file = new File([blob], element[0].files[0].name, {
                        type: element[0].files[0].type,
                        lastModified: element[0].files[0].lastModifiedDate
                      });
                      scope.upload({file: file});
                    }, element[0].files[0].type, 0.2);
                  };
                  $window.jQuery('#' + attrs.targetimg).attr('src', e.target.result)
                    .width(250)
                    .height(190);
                }
              };
              reader.readAsDataURL(element[0].files[0]);
            }
            else{
              scope.upload({file: element[0].files[0]});
            }
          });
        });
      }
    };
  }

})();

/**
 * Created by ttn on 14/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('dropDown', fileUploadProfileDirective);

  /** @ngInject */
  function fileUploadProfileDirective($timeout) {
    return {
      restrict: 'EA',
      template: '<div ng-if="listData.length" class="suggestion box-shadow"  ng-keyup="handleKeyPress($event)"><ul id="list"><li ng-repeat="_data in listData' +
        ' track by $index"> <a href="" class="noClassEnabled" id={{$index}}  ng-click="selectData(_data)"> {{_data[displayKey]}}{{displayKeySecond?   " -   "+_data[displayKeySecond]:""}}</a></li></ul></div>',
      scope: {listData: '=', hdfcClick: '&', for: '@', displayKey: '@', model: '=', displayKeySecond: '@'},
      link: function (scope, element) {
        var _isSelectedData = false;
        var forEle = angular.element("#" + scope.for);
        var previous = '';

        var isNewData = function (listData) {
          var flag = false;
          if (angular.isArray(listData) && listData.length) {
            var _text = forEle.val();
            listData.forEach(function (item) {
              if (item[scope.displayKey].indexOf(_text) === -1) {
                flag = true;
              }
            });
          }

          return flag;
        };


        var active_id = 0;
        var old_id = 0;
        var Element = document.getElementById(active_id);
        if(Element) Element.focus();
        scope.handleKeyPress = function(Key) {
          old_id = active_id;
          switch (Key.keyCode) {
            case 40:
              active_id++;
              break;
            case 9:
              active_id++;
              break;
            case 38:
              active_id--;
              break;
          }
          if(active_id < 0) active_id = scope.listData.length;
          if(active_id > scope.listData.length) active_id = 0;
          if(document.getElementById(old_id)) {
            document.getElementById(old_id).blur();
          }
          if(active_id > 0) {
            document.getElementById(active_id - 1).focus();
          }
        }

        scope.selectData = function (data) {
          _isSelectedData = true;
          scope.hdfcClick({data: data});
          if(_isSelectedData){
            _isSelectedData = false;
            element.hide();
          }
        };


        element.hide();

        forEle.on('click', function (e) {
          if (e.target.tagName == 'INPUT') {
            e.stopPropagation();
            element.show();
            active_id = 0;
            old_id = 0;
            previous = e.target.name;
          }
        });

        forEle.focus(function() {
          element.show();
        })

        forEle.blur(function () {
          $timeout(function () {
            if(_isSelectedData){
              _isSelectedData = false;
              element.hide();
            }
          }, 200);
        });

        $(document).on('click', function (e) {
          if(e.target.name !== previous){
            element.hide();
            previous = '';
          }
        });

        scope.$watch(function (value) {
          return scope.listData;
        }, function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue) && isNewData(newValue)) {
            _isSelectedData = false;
          }
        });
      }
    };

  }

})();

/**
 * Created by ttn on 15/04/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('disableRightClick', disableRightClick);

  /** @ngInject */
  function disableRightClick() {
    return {
      restrict: "A",
      link: function (scope, elem) {
        angular.element(elem).on("contextmenu", function (e) {
          e.preventDefault();
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('dateRange', dateRangePicker)
    .directive('dateCalendar', dateCalendarPicker);

  /** @ngInject */
  function dateRangePicker($timeout) {
    return {
      scope: {dateDefault: '=', onDateChange: '=', dateMaxSpan:'=', dateMin:'=', dateMax:'='},
      restrict: 'EA',
      link: function (scope, element) {
        var opts = {
          locale: {
            fromLabel: 'Od', toLabel: 'Do', separator: ' -> ', format: 'DD-MMM-YYYY'
          },
          showDropdowns: true,
          autoApply: false,
          autoUpdateInput: true,
          maxDate: scope.dateMax ? scope.dateMax : new Date(),
          minDate: scope.dateMin ? scope.dateMin : new Date('01/01/1900'),
          maxSpan: scope.dateMaxSpan && {"days": scope.dateMaxSpan},
          opens:"center"
        };
        var isApplied = false;
        if (scope.dateDefault && scope.dateDefault.startDate && scope.dateDefault.endDate) {
          opts.startDate = scope.dateDefault.startDate;
          opts.endDate = scope.dateDefault.endDate;
          element.daterangepicker(opts);
        } else {
          element.daterangepicker(opts);
          element.val('');
        }

        element.on('apply.daterangepicker', function (ev, picker) {
          var _date = {
            startDate: picker.startDate,
            endDate: picker.endDate
          };
          scope.onDateChange(_date);
          isApplied = true;
        });

        element.on('hide.daterangepicker', function (ev, picker) {
          $timeout(function () {
            if (!isApplied && !scope.dateDefault.startDate && !scope.dateDefault.endDate) {
              picker.setEndDate(new Date());
              picker.setStartDate(new Date());
              picker.oldStartDate = null;
              picker.oldEndDate = null;
              isApplied = false;
              element.val('');
            }
          }, 0);
        });

        scope.$watch(function () {
          return scope.dateDefault
        }, function () {
          if (!scope.dateDefault || !scope.dateDefault.startDate || !scope.dateDefault.endDate) {
            var picker = element.data('daterangepicker');
            picker.setEndDate(new Date());
            picker.setStartDate(new Date());
            picker.oldStartDate = null;
            picker.oldEndDate = null;
            element.val('');
            isApplied = false;
          }
        }, true);
      }
    };
  }

  /** @ngInject */
  function dateCalendarPicker($timeout, moment , UtilService) {
    return {
      scope: {maxDate: '=', minDate: '=',viewDate: '=', dateDefault: '=', enable: '=', enabledDates: '=', onDateChange: '=' , enabledMonths: '=' , focusOn : '@'},
      restrict: 'EA',
      link: function (scope, element, attr) {
        var options = {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            viewMode: 'months',
            ignoreReadonly: true,
            defaultDate: '',
            minDate: new Date('01/01/1900'),
            //maxDate: new Date('01/01/2050'),
            viewDate: new Date()
          },
          isDateSent = false;
        if (attr.format) {
          options.format = attr.format;
        }
        if (attr.viewmode || scope.viewMode) {
          options.viewMode = attr.viewmode;
        }
        if (attr.maxdate || scope.maxDate) {
          options.maxDate = scope.maxDate || attr.maxdate;
        }

        if (scope.minDate) {
          options.minDate = scope.minDate;
        }

        if (scope.viewDate) {
          options.viewDate = scope.viewDate;
        }

        var updateView = function () {
          if (scope.dateDefault && attr.showdefault == 'true') {
            element.data('DateTimePicker').defaultDate(moment(scope.dateDefault));
          } else {
            element.data('DateTimePicker').date(scope.dateDefault);
          }

          if (scope.enabledDates) {
            element.data('DateTimePicker').enabledDates(scope.enabledDates);
          }

          if (scope.dateDefault && (scope.enabledDates || attr.showdefault == 'true')) {
            element.data('DateTimePicker').enable();
          }

          if (scope.enable == true) {
            element.data('DateTimePicker').enable();
          }
          if(scope.focusOn && scope.focusOn === UtilService.currentFocusedElement.get()) {
            angular.element('.' + scope.focusOn).focus();
          }
          if (scope.minDate) {
            element.data('DateTimePicker').minDate(scope.minDate);
          }
          if (scope.maxDate) {
            element.data('DateTimePicker').maxDate(scope.maxDate);
          }
          if (scope.viewDate) {
            element.data('DateTimePicker').viewDate(scope.viewDate);
          }
        };

        element.datetimepicker(options);
        updateView();
        element.on('dp.change', function (e) {
          if (isDateSent) {
            return;
          }
          isDateSent = true;
          scope.onDateChange(e.date);
          $timeout(function () {
            isDateSent = false;
          }, 0);
        });

        element.on('dp.hide', function () {
          element.removeClass('currentdatepicker');
          isDateSent = true;
          $timeout(function () {
            if (element.data('DateTimePicker')) {
              element.data('DateTimePicker').destroy();
            }
            element.datetimepicker(options);
            updateView();
            isDateSent = false;
          }, 0);
        });

        element.on('dp.show', function () {
          angular.element('.date-picker').removeClass('high-index-datetimepicker');
          element.addClass('currentdatepicker high-index-datetimepicker');
          if (!scope.dateDefault && !scope.enable) {
            element.data('DateTimePicker').disable();
          } else {
            element.data('DateTimePicker').enable();
          }
        });

        scope.$watch(function () {
          return scope.dateDefault;
        }, function () {
          updateView()
        }, false);

        scope.$watch(function () {
          return scope.minDate;
        }, function () {
          updateView();
        }, false);

        scope.$watch(function () {
          return scope.maxDate;
        }, function () {
          updateView();
        }, false);

        scope.$watch(function () {
          return scope.viewDate;
        }, function () {
          updateView();
        }, false);

        scope.$watch(function() {
          return scope.enabledDates;
        }, function () {
          updateView();
        });
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('customAutoFocus', customAutoFocus)

  /** @ngInject */
  function customAutoFocus($timeout) {
    return {
      restrict: 'A',
      link : function($scope, $element) {
        $timeout(function() {
          $element[0].focus();
        });
      }
    }
  }

})();

/*
* Directive for dynamic content , makes angular directives work
*/
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('dynamic', function($compile) {
      return {
        restrict: 'A',
        replace: true,
        link: function (scope, element, attrs) {
          scope.$watch(attrs.dynamic, function(html) {
            $compile(element.html(html).contents())(scope);
          });
        }
      };
    })
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('capitalize', capitalize)
    .directive('selectOnClick', selectOnClick);

  /** @ngInject */
  function capitalize() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if (capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        }
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  }

  /** @ngInject */
  function selectOnClick() {
    return {
      restrict: 'A',
      link: function (scope, element) {
        var focusedElement;
        element.on('click', function () {
          if (focusedElement != this) {
            this.select();
            focusedElement = this;
          }
        });
        element.on('blur', function () {
          focusedElement = null;
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('bulkUpload', bulkUploadDirective);

  /** @ngInject */
  function bulkUploadDirective() {
    return {
      require: "ngModel",
      restrict: 'A',
      link: function ($scope, el, attrs, ngModel) {
        el.bind('change', function (event) {
          ngModel.$setViewValue(event.target.files[0]);
          $scope.$apply();
        });

        $scope.$watch(function () {
          return ngModel.$viewValue;
        }, function (value) {
          if (!value) {
            el.val("");
          }
        });
      }
    };
  }
})();

/**
 * Created by ttn on 19/01/21.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('bankDropDown', bankDropDownDirective);

  /** @ngInject */
  function bankDropDownDirective($timeout) {
    return {
      restrict: 'EA',
      template: '<div class="suggestion box-shadow"  ng-keydown="handleKeyPress($event)"><ul id="list" ng-if="listData !== null || listData.length > 0">' +
        '<li ng-repeat="_data in listData track by $index" ng-click="selectData(_data)">' +
        '<span>{{_data[displayKey]}}</span> - <span easyassist-key="mask-element-2">{{_data[displayKeySecond]}}</li>' +
        '</ul><ul ng-if="listData === null || listData.length ===0"><li>No Bank Available</li></ul></div>',
      scope: {listData: '=', hdfcClick: '&', for: '@', displayKey: '@', model: '=', displayKeySecond: '@'},
      link: function (scope, element) {
        var _isSelectedData = false;
        var forEle = angular.element("#" + scope.for);
        var isNewData = function (listData) {
          var flag = false;
          if (angular.isArray(listData) && listData.length) {
            var _text = forEle.val();
            listData.forEach(function (item) {
              if (item[scope.displayKey].indexOf(_text) === -1) {
                flag = true;
              }
            });
          }

          return flag;
        };

        var active_id = '0';
        var Element = document.getElementById(active_id);
        if(Element) Element.focus();
        scope.handleKeyPress = function(Key) {
          var old_id = active_id;
          switch (Key.keyCode) {
            case 40:
              active_id++;
              break;
            case 38:
              active_id--;
              break;
          }
          if(active_id < 0) active_id = scope.listData.length-1;
          if(active_id > scope.listData.length-1) active_id = 0;
          document.getElementById(old_id).blur();
          document.getElementById(active_id).focus();
        }

        scope.selectData = function (data) {
          _isSelectedData = true;
          scope.model = data;
          scope.hdfcClick();
          if(_isSelectedData){
            _isSelectedData = false;
            element.hide();
          }
        };

        element.hide();

        forEle.click(function () {
          element.show();
        });

        forEle.focus(function() {
          element.show();
        })

        forEle.blur(function () {
          $timeout(function () {
            if (!_isSelectedData || !scope.model) {
              scope.hdfcClick({data: null});
            }
            if(!_isSelectedData){
              _isSelectedData = false;
              element.hide();
            }
          }, 500);
        });

        scope.$watch(function () {
          return scope.listData;
        }, function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue) && isNewData(newValue)) {
            _isSelectedData = false;
          }
        });
      }
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionApprovalController', transactionApprovalController);

  /** @ngInject */
  function transactionApprovalController(AgentService, ModalService, LoaderService, MessageService, AppConstants, toastr, AuthService, $state) {
    var vm = this;
    vm.isPagination = false;
    vm.PAGE_LIMITS = [10, 20];
    vm.isLoading = false;
    vm.currentPageTransitionList = 1;
    vm.pageLimitTransitionList = "10";
    vm.count = 0;
    vm.TRANSACTION_TYPES = AppConstants.TRANSACTION_TYPES.ALL;
    vm.selectedType = vm.TRANSACTION_TYPES[0];
    vm.init = init();

    var payload = {};
    payload.transactionType = [vm.selectedType.value];

    // get the data of transaction list
    function getTransactionList() {
      var success = function (resp) {
        if (resp.status && resp.data.otmEnabledInvestorTransactions) {
          LoaderService.hideLoader();
          vm.transactionListData = resp.data;
        }
        else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.data.message);
      };

      payload.pageIndex = vm.currentPageTransitionList - 1;
      payload.pageLimit = vm.pageLimitTransitionList;
      LoaderService.showLoader();
      AgentService.post({
        controller: 'get',
        child1: 'otm',
        child2: 'enabled',
        child3: 'transactions',
        child4: 'list'
      }, payload).$promise.then(success, error);  ///agent/login/impersonate?username=ARN-0411
    }

    function init() {
      if(angular.isUndefined(AuthService.getToken())) $state.go('agent.login');
      else getTransactionList();
    }
    // end of transaction list

    // update the list on change of its type
    vm.typeChanged = function () {
      if (vm.selectedType) {
        vm.currentPageTransitionList = 1;
        payload.pageIndex = vm.currentPageTransitionList - 1;
        payload.transactionType = [vm.selectedType.value];
        getTransactionList();
      }
    };

    // on pagination
    vm.searchDistributor = function () {
      //vm.currentPageTransitionList = 1;
      payload.pageIndex = vm.currentPageTransitionList - 1;
      getTransactionList();
    };

    // on approval and rejection
    vm.approval = function (transactionType, type, id) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if(resp.data.reject){
            var success = function () {
                MessageService.success('The selected transaction ' +transactionType + ' has been rejected');
                getTransactionList();
            },
              error = function () {
              };
            ModalService.confirmCancelModal({Text:'Are you sure you want to reject the transaction?'}, success, error);
          } else {
            var successConfirm = function () {
                getTransactionList();
              },
              errorConfirm = function () {
              };
            ModalService.confirmSuccessModal({Text:resp.data.message || 'The selected transaction ' +transactionType + ' has been approved'}, successConfirm, errorConfirm);
          }



        }else {
          MessageService.error(resp.message);
          getTransactionList();
        }
      },
      error = function (err) {
        LoaderService.hideLoader();
        getTransactionList();
        if (err && err.message) {
          var messages = err.message + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
          toastr.error(messages, '', {
            allowHtml: true,
            preventDuplicates: false,
            onHidden: function () {
              vm.loginProcessFlag = false;
            }
          });
        }
      };

      LoaderService.showLoader();
      if (type) {
        AgentService.post({
          controller: 'transaction',
          child1: type
        }, {'transactionId': id}).$promise.then(success, error);
      }

    };

    // pagination

    vm.pageLimitListChange = function (limit) {
      payload.pageLimit = limit;
      vm.currentPageTransitionList = 1;
      payload.pageIndex = vm.currentPageTransitionList - 1;
      getTransactionList();
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SuperadminController', superadminController);

  /** @ngInject */
  function superadminController(AgentService, $document, ModalService, $state, $scope, LoaderService, MessageService, $log, AuthService) {
    var vm = this;
    vm.getAgentList = getAgentList;
    vm.searchAgent = searchAgent;
    vm.deleteAgent = deleteAgent;
    vm.deleteConfirmation = deleteConfirmation;
    vm.resetPagination = resetPagination;

    vm.isPagination = false;
    vm.PAGE_LIMITS = [10, 20];
    vm.isLoading = false;
    vm.currentPageAgentList = "1";
    vm.pageLimitAgentList = "10";
    vm.count = 12;
    vm.payload = {

    };

    vm.init = function () {
      $state.go('agent.login');
    };

    function resetPagination() {
      vm.currentPageAgentList = 1;
      vm.payload.pageLimit = vm.PAGE_LIMITS[0];
      vm.isPagination = false;
    }

    function getAgentList() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          /*resp.data =
          {
            "agents"
          :
            [{
              "name": "vinod",
              "userId": "vinod",
              "mobileNumber": "9898989898",
              "pan": "IUIUI9999J",
              "role": "Agent"
            }, {
              "name": "Arvind",
              "userId": "arvind",
              "mobileNumber": "9898989898",
              "pan": "IIIII9999U",
              "role": "Agent"
            }, {
              "name": "someone",
              "userId": "some.one",
              "mobileNumber": "9743880348",
              "pan": "JHDJK3778F",
              "role": "Agent"
            }, {
              "name": "Kunal Kashyap",
              "userId": "kunal.kashyap",
              "mobileNumber": "9872362376",
              "pan": "OIEHJ9834J",
              "role": "Agent"
            }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },
              {
                "name": "Kunal Kashyap",
                "userId": "kunal.kashyap",
                "mobileNumber": "9872362376",
                "pan": "OIEHJ9834J",
                "role": "Agent"
              }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },
              {
                "name": "Kunal Kashyap",
                "userId": "kunal.kashyap",
                "mobileNumber": "9872362376",
                "pan": "OIEHJ9834J",
                "role": "Agent"
              }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },
              {
                "name": "Kunal Kashyap",
                "userId": "kunal.kashyap",
                "mobileNumber": "9872362376",
                "pan": "OIEHJ9834J",
                "role": "Agent"
              }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },
              {
                "name": "Kunal Kashyap",
                "userId": "kunal.kashyap",
                "mobileNumber": "9872362376",
                "pan": "OIEHJ9834J",
                "role": "Agent"
              }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },
              {
                "name": "Kunal Kashyap",
                "userId": "kunal.kashyap",
                "mobileNumber": "9872362376",
                "pan": "OIEHJ9834J",
                "role": "Agent"
              }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            },{
              "name": "Kunal Kashyap",
              "userId": "kunal.kashyap",
              "mobileNumber": "9872362376",
              "pan": "OIEHJ9834J",
              "role": "Agent"
            }, {
              "name": "Ankisha",
              "userId": "anki5",
              "mobileNumber": "9711628446",
              "pan": "BCUPG1267L",
              "role": "Agent"
            }]
          };*/

          LoaderService.hideLoader();
          vm.agentList = resp.data.agents;
          vm.count = resp.data.count;
          vm.isPagination = !!(vm.agentList && vm.agentList.length);
        }
        else {
          vm.agentList = null;
          vm.isLoading = false;
          vm.isPagination = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        vm.isPagination = false;
        MessageService.error(err);
      };

      LoaderService.showLoader();
      var payload = {
        pageIndex: vm.currentPageAgentList - 1,
        pageLimit: vm.pageLimitAgentList
      };

      AgentService.post({
        controller: 'list'
      }, payload).$promise.then(success, error);
    }

    function searchAgent() {
      if (vm.searchAgentByName) {
        var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader();
            vm.agentList = resp.data.searchResponse;
          }
          else {
            vm.portfolioData = null;
            vm.isLoading = false;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          vm.isPagination = false;
          MessageService.error(err.data.message);
        };

        LoaderService.showLoader();
        AgentService.post({
          controller: 'search',
          child1: vm.searchAgentByName
        }, {}).$promise.then(success, error);
      }

    }

    function deleteAgent(userId) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          //MessageService.success(resp.message);
          var successModal = function () {
            getAgentList();
          };
          ModalService.confirmSuccessModal({Text: "Agent deleted successfully."}, successModal);
        }
        else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();
      };

      LoaderService.showLoader();
      AgentService.post({
        controller: 'delete'
      }, {"userId": userId}).$promise.then(success, error);
    }

    function deleteConfirmation(userId) {
      var successModal = function () {
        deleteAgent(userId);
      }, errorModal = function () {

      };
      ModalService.confirmCancelModal({Text: "Are you sure, you want to delete this agent?"}, successModal, errorModal);
    }

    $document[0].addEventListener('keyup', getAgentOnEnter, false);

    function getAgentOnEnter() {
      if ($state.current.controller === 'SuperadminController' && event.which === 13) {
        resetPagination();
        searchAgent();
      } else {
        if($state.current.controller === 'SuperadminController' && !vm.searchAgentByName){
          resetPagination();
          getAgentList();
        }
      }
    }

    $scope.$on('$destroy', function () {
      $log.info('Destroy');
      $document[0].removeEventListener('keyup', getAgentOnEnter, false);
    })

    vm.pageLimitListChange = function () {
       getAgentList()
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentLoginController', agentLoginController);

  /** @ngInject */
  function agentLoginController($window, AppConstants,$state, HDFC_API, AuthService, ModalService, UtilService, toastr, MessageService) {
    var vm = this;

    vm.loginPayload = {
      userId: "",
      password: ""
    };
    vm.loginProcessFlag = false;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.RUNNING_MODE = AppConstants.RUNNING_MODE;
    vm.ENV = HDFC_API.ENV;

    vm.agentLogin = function () {

       var successLogin = function (result) {
        vm.loginProcessFlag = false;

        if (result.access_token && result.access_token != "") {
          var identifierData = AuthService.getToken();
          identifierData['firstTimeLogin'] = result.firstTimeLogin;
          // $cookies.put('token_data', angular.toJson(tokenData));
          AuthService.setToken(identifierData);
          if(result.role==='Super Admin'){
            $state.go('agent.home.superadmin');
          } else {
            (result.firstTimeLogin && result.role === 'Agent') ? $state.go('agent.changePassword') : $state.go('agent.home.distributor-list');
          }
        } else {
          if (result && result.message) {
            MessageService.error(result.message);
          }
        }
      },
        errorLogin = function (msg) {
          var messages;
         if (msg && msg.message) {
            messages = msg.message + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
            showLoginError(messages);
          }else if (msg && msg.data && msg.data.error_description) {
            messages = msg.data.error_description + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
            showLoginError(messages);

          } else {
            UtilService.errorHandler(msg);
          }
        }
      var patt = new RegExp(vm.appConstants.password_regex);
      var check = patt.test(vm.loginPayload.password);
      if (!check) {
        var msg = 'Seems like your present password contains one or more special characters that are disallowed according to the new security policy.' +
          ' Please update your password using the "forgot password" link.';
        ModalService.messagePasswordModal({Text:msg});
        return;
      }
      var payload = {
        userId: vm.loginPayload.userId,
        password: vm.loginPayload.password
      };

      vm.loginProcessFlag = true;
      AuthService.agentLogin(payload).then(successLogin, errorLogin);
    };

    function showLoginError(msg) {
      toastr.error(msg, '', {
        allowHtml: true,
        preventDuplicates: false,
        onHidden: function () {
          vm.loginProcessFlag = false;
        }
      });
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentHomeController', agentHomeController);

  /** @ngInject */
  function agentHomeController($state, AuthService, AgentSocketService) {
    var vm = this;
    vm.agentLogout = function () {
      AuthService.agentLogout().then(function () {
        $state.go('agent.login');
      }, function () {
        $state.go('agent.login');
      });
    };
    /*Socket start*/
    AgentSocketService.openSocket(function () {

    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentDistributorListController', agentDistributorListController);

  /** @ngInject */
  function agentDistributorListController(AgentService, AuthService, LoaderService, $document, $state,
                                          $scope, $log, MessageService, AgentSocketService,
                                          $window, $stateParams, HDFC_API, AppConstants , UtilService,$http) {
    var vm = this;
    vm.isPagination = false;
    vm.PAGE_LIMITS = [10, 20];
    vm.isLoading = false;
    // vm.currentPageDistributorList = "1";
    // vm.pageLimitDistributorList = "10";
    vm.searchByArn = "ARN-";
    vm.count = 0;
    vm.distributorData = [];
    vm.socketStatus = 'Online';// ($rootScope.socket && $rootScope.socket.readyState != 1 ) ? 'Offline' : 'Online';
    vm.proceedToDistributorHome = proceedToDistributorHome;
    vm.resetPagination = resetPagination;
    vm.agentAsDistributorLogout = agentAsDistributorLogout;
    vm.isSearch = false;
    vm.showSearch = false;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.isValidDistributorData = false;
    vm.agentRole = null;
    vm.errorMsg = null;
    vm.init = init;
    var payload = {};


    vm.init();

    vm.searchDistributor = function () {
      getDistributor(payload);
    };

    function init() {
      if(AuthService.getToken()){
        if (angular.isUndefined(vm.distributorData) || vm.distributorData.length == 0) {
          $window.sessionStorage.currentDistributorARN = '';
        }
        vm.agentRole =  AuthService.getToken().role;
        var tokenData = AuthService.getToken();
        tokenData['isDistributor'] = $state.current.name === 'agent.home.distributor-list' ? false: true;
        AuthService.setToken(tokenData);
        if(vm.distributorData.length)
          vm.isSearch=true;
      }else $state.go('agent.login');

      var successHandler = function(resp) {
        vm.DynamicDataAgent = resp.noteDTO.noteDTOMap.AGENT_LINKS;
      }

      UtilService.fetchDynamicData("AGENT_PORTAL").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });

    }

    function proceedToDistributorHome(arnNo, name) {
      var success = function (resp) {
        if (resp.status) {
          LoaderService.hideLoader();
          var identifierData = AuthService.getToken();
          identifierData['arnCode'] = arnNo;
          sessionStorage.setItem('brokerCodePanAdhar', arnNo);
          localStorage.setItem('distributorName', name);
          identifierData['isDistributor'] = resp.data.data.distributor;
          AuthService.setToken(identifierData);
          $state.go('agent.home.distributor-home');
        }
        else {
          MessageService.error(resp.message);
        }
      }, error = function () {
        LoaderService.hideLoader();
        MessageService.error(err);
      };

      LoaderService.showLoader();
      vm.encryptedArn = AuthService.encryptRSA(angular.copy(arnNo));
      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST_AGENT + HDFC_API.VERSION_AGENT +'/login/impersonate?arn=' + vm.encryptedArn;
      $http({
        method: 'get',
        url: _path,
        data: {}
      }).then(success, error);
      // AgentService.get({
      //   controller: 'login',
      //   child1: 'impersonate',
      //   child2: arnNo
      // }, {}).$promise.then(success, error);  ///agent/login/impersonate?username=ARN-0411
    }

    vm.pageLimitListChange = function (limit) {
      payload.pageLimit = limit;
      vm.currentPageDistributorList = 1;
      payload.pageIndex = vm.currentPageDistributorList - 1;
      vm.searchDistributor();
      //$window.document.getElementById('typeSelect').focus();
    };

    function resetPagination() {
      vm.currentPageDistributorList = 1;
      payload.pageLimit = vm.PAGE_LIMITS[0];
      vm.isPagination = false;
      vm.searchDistributorByName = null;
    }

    function agentAsDistributorLogout(arn) {
      // closeARNConnection(arn);
      vm.isSearch = false;
      vm.distributorData = [];
      vm.showSearch = false;
      vm.searchDistributorByName = null;
    }

    function closeARNConnection(arn) {
      var data = AuthService.getToken();

      function success(resp) {
        if (resp.status) {
          vm.isSearch = false;
          vm.distributorData = [];
          vm.showSearch = false;
          vm.searchDistributorByName = null;
          $window.sessionStorage.currentDistributorARN = '';
          // $rootScope.currentDistributorARN = '';
        } else {
          MessageService.error('Not able to switch distributor');
        }
      }

      function error() {
        MessageService.error();
      }

      AgentService.post({
        controller: 'caller',
        child1: 'call',
        child2: 'end'
      }, {agentId: data.userId, arnCode: arn}).$promise.then(success, error);

    }

    /*

        function distributorImpersonate() {
          var success = function (resp) {
            if (resp.status) {
              LoaderService.hideLoader();
              var tokenData = AuthService.getToken();
              tokenData['isDistributor'] = resp.data.distributor;
              // $cookies.put('token_data', angular.toJson(tokenData));
              AuthService.setToken(tokenData);
              $state.go('agent.home.distributor-list');
            }
            else {
              MessageService.error(resp.message);
            }
          }, error = function (err) {
            LoaderService.hideLoader();
            MessageService.error();
          };

          localStorage.removeItem('distributorName');
          LoaderService.showLoader();
          AgentService.get({
            controller: 'logout',
            child1: 'impersonate'
          }, {}).$promise.then(success, error);

        }
    */

    vm.searchDistributorByARN = function () {
      vm.isValidDistributorData = false;
      if (vm.searchDistributorByName) {
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.distributorData = resp.data.searchResponse || [];
            vm.count = resp.data.count;
            vm.isPagination = !!(vm.distributorData && vm.distributorData.length);
            vm.isSearch = true;
            vm.showSearch = true
          } else {
            vm.isValidDistributorData = true;
            vm.searchDistributorByName = null;
            vm.distributorData = [];
            vm.isPagination = false;
            vm.errorMsg = resp.message;
          }
          $log.info('resp', resp);
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
          vm.distributorData = [];
          vm.isPagination = false;
        };

        LoaderService.showLoader();
        vm.isLoading = true;
        var arnCode= 'ARN-'+vm.searchDistributorByName;
        // payload.arnCode = ;
        vm.isSearch = false;
        var payload = {
          arnCode: arnCode
        };
        AgentService.post({
          controller: 'search',
          child1: 'agent',
          child2: 'arn'
        }, payload).$promise.then(success, error);
      }
      else {
        vm.isSearch = true;
      }
    }

    function getDistributor(payload) {
      if (vm.searchDistributorByName) {

        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            vm.distributorData = resp.data.searchResponse || [];
            vm.count = resp.data.count;
            vm.isPagination = !!(vm.distributorData && vm.distributorData.length);
          } else {
            vm.distributorData = [];
            vm.isPagination = false;
            $window.sessionStorage.currentDistributorARN = '';
            // $rootScope.currentDistributorARN = '';
          }
          $log.info('resp', resp);
        }, error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
          vm.distributorData = [];
          vm.isPagination = false;
          $window.sessionStorage.currentDistributorARN = '';
          // $rootScope.currentDistributorARN = '';
        };

        LoaderService.showLoader();
        vm.isLoading = true;
        /*        payload.pageIndex = vm.currentPageDistributorList - 1;
                payload.pageLimit = vm.pageLimitDistributorList;*/
        payload.arnCodes = vm.searchDistributorList;
        AgentService.post({
          controller: 'distributor',
          child1: 'search',
          child2: 'multiple'//vm.searchByArn + vm.searchDistributorByName
        }, payload).$promise.then(success, error);
      }

    }

    $document[0].addEventListener('keyup', getDistributorOnEnter, false);

    function getDistributorOnEnter() {
      if ($state.current.controller === 'AgentDistributorListController' && event.which === 13) {
        vm.searchDistributor();
      }
    }

    /*
        $scope.$on('$destroy', function () {
          $log.info('Destroy');
          $document[0].removeEventListener('keyup', getDistributorOnEnter, false);
        })*/

    // AgentSocketService.openSocket.call(vm);
    // vm.ws = {};
    /*New socket start*/
    /*AgentSocketService.openSocket(function () {
      vm.socketStatus = 'Online';
      // $rootScope.isConnectionOpen = true;
      vm.ws = AgentSocketService.WebSocket();
    });*/
    /*
        AgentSocketService.onopen = function () {
        };*/

    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      if (vm.distributorData && vm.distributorData.length) {
        vm.distributorData = [];
        vm.searchByArn = '';
        vm.searchDistributorByName = 'DISCONNECT';
        $window.sessionStorage.currentDistributorARN = '';
        // $rootScope.currentDistributorARN = '';
        var message = 'Distributor Session has been expired';
        AgentSocketService.showDisconnedtPopUp(message, function () {
          AgentSocketService.impersonateLogout(args);
        });
      } else {
        vm.searchDistributor();
      }
    });

    listeners['UpdateSocketData'] = $scope.$on('UpdateSocketData', function (event, args) {
      var received_msg = args;
      if ((vm.distributorData && vm.distributorData.length)) {
        return;
      }
      if (received_msg.indexOf('ARN-') != -1) {
        vm.searchDistributorList = received_msg.split(',');
        vm.searchDistributorByName = received_msg.split('-')[1];
      } else {
        vm.searchDistributorByName = received_msg;
      }
      $window.sessionStorage.currentDistributorARN = 'ARN-' + vm.searchDistributorByName;
      // $rootScope.currentDistributorARN = 'ARN-' + vm.searchDistributorByName;
      vm.searchDistributor();
    });

    listeners['UpdateSocketClose'] = $scope.$on('UpdateSocketClose', function () {
      vm.socketStatus = 'Offline';
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
      $document[0].removeEventListener('keyup', getDistributorOnEnter, false);
    });

    /*vm.ws.onmessage = function (evt) {
      var received_msg = evt.data;
      console.log('Socket Response>>>>>>>>>', evt.data);

      if (received_msg.indexOf('Disconnect') != -1) {
        if (vm.distributorData && vm.distributorData.length) {
          var message = 'Distributor Session has been expired';
          AgentSocketService.showDisconnedtPopUp(message, function () {
            vm.distributorData = [];
            vm.searchByArn = '';
            vm.searchDistributorByName = 'DISCONNECT';
            $rootScope.currentDistributorARN = '';
          });

        } else {
          vm.distributorData = [];
          vm.searchByArn = '';
          vm.searchDistributorByName = 'DISCONNECT';
          $rootScope.currentDistributorARN = '';
          vm.searchDistributor();
        }

      } else {

        if (vm.distributorData && vm.distributorData.length) {
          return;
        }
        if (received_msg.indexOf('ARN-') != -1) {
          vm.searchDistributorList = received_msg.split(',');
          vm.searchDistributorByName = received_msg.split('-')[1];
        } else {
          vm.searchDistributorByName = received_msg;
        }

        $rootScope.currentDistributorARN = 'ARN-' + vm.searchDistributorByName;

        /!*if ($rootScope.$state.current.name != 'agent.home.distributor-list') {
          $rootScope.$state.go('agent.home.distributor-list', {arn: vm.searchDistributorByName});
        }*!/
        (typeof vm.searchDistributor == 'function') && vm.searchDistributor();
      }
    };

    // ws.onclose = function () {
    vm.ws.close = function () {
      vm.socketStatus = 'Offline';
      //MessageService.error('You are offline now');
      // $rootScope.isConnectionOpen = false;
    };*/

    /*New socket end */

    if ($stateParams.arn) {
      vm.searchDistributorByName = $stateParams.arn;
      $window.sessionStorage.currentDistributorARN = 'ARN-' + vm.searchDistributorByName;
      // $rootScope.currentDistributorARN = 'ARN-' + vm.searchDistributorByName;
      vm.searchDistributor();
    }

    if (HDFC_API.ENV == 'mock') {
      vm.searchDistributorByName = 'kunal.kashyap';
      vm.searchDistributor();
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentDistributorHomeController', agentDistributorHomeController);

  /** @ngInject */
  function agentDistributorHomeController(ModalService, AuthService, $state, $scope, $window, AgentService,
                                          TransactionInitiateModel, MessageService, AgentSocketService, HDFC_API, AppConstants) {
    var vm = this;
    var TR_TYPE = AppConstants.AGENT_TR_TYPE;
    var identifier = AuthService.getToken();
    vm.searchInvestor = searchInvestor;
    vm.distributorName = localStorage.getItem('distributorName') ? localStorage.getItem('distributorName') : '';
    vm.init = init;

    function init() {
      if(AuthService.getToken() && AuthService.getToken().arnCode){
        if (!$window.sessionStorage.currentDistributorARN) {
          var message = 'Distributor Session has been expired';
          AgentSocketService.showDisconnedtPopUp(message, function () {
            AgentSocketService.impersonateLogout();
          });
        }
      //   var success = function (resp) {
      //     if (resp.status && resp.data && Object.keys(resp.data).length !== 0) {
      //       showAgentDraft(resp.data);
      //     }
      //   }, error = function (err) {
      //     // showAgentDraft(err);
      //     MessageService.error(err.message || err);
      //   }
      //
      //   AgentService.get({
      //     controller: 'saved',
      //     child1: 'snap',
      //     child2: identifier.arnCode
      //   }).$promise.then(success, error);
      }else $state.go('agent.login');

    }

    function continueDraft(arg) {
      var params = {};
      params.transactionId = arg.transactionId;
      params.uuid = arg.investorUUID;//arg.investorUUID;=='22366342-4844-43e9-8c3b-a9ce2fcd7f12'
      params.transactionType = arg.transactionType.toUpperCase();
      switch (params.transactionType) {
        case TR_TYPE.SIP:
          $state.go('agent.home.transactions.initiate.sip', params);
          break;
        case TR_TYPE.PURCHASE:
          $state.go('agent.home.transactions.initiate.sip', params);
          break;
        case TR_TYPE.SWP:
          $state.go('agent.home.transactions.initiate.swp', params);
          break;
        case TR_TYPE.REDEMPTION:
          $state.go('agent.home.transactions.initiate.redeem', params);
          break;
        case TR_TYPE.SWITCH:
          $state.go('agent.home.transactions.initiate.switch', params);
          break;
        case TR_TYPE.DTP:
          $state.go('agent.home.transactions.initiate.dtp', params);
          break;
        case TR_TYPE.STP:
          $state.go('agent.home.transactions.initiate.stp', params);
          break;
        case TR_TYPE.STPSWING:
          $state.go('agent.home.transactions.initiate.swingstp', params);
          break;
        case TR_TYPE.STPFLEX:
          $state.go('agent.home.transactions.initiate.flexstp', params);
          break;
        case TR_TYPE.FLEXINDEX:
          $state.go('agent.home.transactions.initiate.flexindex', params);
          break;
      }
    }

    function discardDraft() {
      var successDiscard = function () {

      }, errorDiscard = function () {

      }

      AgentService.get({
        controller: 'discard',
        child1: 'draft',
        child2: identifier.arnCode
      }, {}).$promise.then(successDiscard, errorDiscard);
    }

    function showAgentDraft(arg) {
      arg = arg || {};
      arg.backdrop = false;
      var successModal = function (resp) {
        continueDraft(resp);
      }, errorModal = function (err) {
        discardDraft(err);
      };
      ModalService.showAgentDraft(arg, successModal, errorModal);
    }

    function searchInvestor(transactionType) {
      var identifierData = AuthService.getToken();
      var success = function (investor) {
          if (investor && investor.uuid) {
            switch (transactionType) {
              case 'SIP or Purchase':
                transactionType = 'SIP';
                break;
              case 'Systematic Withdrawal Plan':
                transactionType = 'SWP';
                break;
              case 'Systematic Transfer Plan':
                transactionType = 'STP';
                break;
              case 'Redemption':
                transactionType = 'Redeem';
                break;
              case 'Switch':
                transactionType = 'Switch';
                break;
              case 'DTP':
                transactionType = 'DTP';
                break;
              // case 'FLEXINDEX':
              //   transactionType = 'FLEXINDEX';
              //   break;
              case 'FLEXSTP':
                transactionType = 'FLEXSTP';
                break;
              case 'SWINGSTP':
                transactionType = 'SWINGSTP';
                break;
              case 'RollOver':
                transactionType = 'RollOver';
                break;
              case 'FLEXSIP':
                transactionType = 'FlexSip';
                break;
              case 'Instant Access Facility':
                transactionType = 'instantRedeem';
                break;
            }
            var _state = 'agent.home.transactions.initiate.' + transactionType.toLowerCase();
            $state.go(_state, {
              uuid: investor.uuid,
              schemeCode: '',
              folioNumber: '',
              transactionType: '',
              transactionId: ''
            });
          } else {
            MessageService.error('Unable to get uuid of selected investor');
          }
        },
        error = function () {
          //$state.go('agent.home.distributor-home');
        };
      resetTransactionInitiateModel();
      ModalService.searchInvestorModal({
        transactionType: transactionType,
        arnCode: identifierData.arnCode
      }, success, error);
    }

    var resetTransactionInitiateModel = function () {
      TransactionInitiateModel.setPurchasePayload(null);
      TransactionInitiateModel.setSipPayload(null);
      TransactionInitiateModel.setInvestorPayload(null);
    };
    /*vm.ws = {};
    /!*Socket start*!/
    AgentSocketService.openSocket(function () {
      // $rootScope.isConnectionOpen = true;
      vm.ws = AgentSocketService.WebSocket();
    });

    vm.ws.onmessage = function (evt) {
      var received_msg = evt.data;
      console.log('Distributor home Socket Response >>>>>>>>>',evt.data);

      if (received_msg.indexOf('Disconnect') != -1) {

        var message = 'Distributor Session has been expired';
        AgentSocketService.showDisconnedtPopUp(message,function () {
          AgentSocketService.impersonateLogout();
        });
      }
    };*/

    var listeners = {};
    listeners['UpdateSocketDisconnect'] = $scope.$on('UpdateSocketDisconnect', function (events, args) {
      var message = 'Distributor Session has been expired';
      AgentSocketService.showDisconnedtPopUp(message, function () {
        AgentSocketService.impersonateLogout(args);
      });
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SuperadminCreateUserController', superadminCreateUserController);

  /** @ngInject */
  function superadminCreateUserController(AppConstants, $state, AgentService, $log, LoaderService, MessageService, ModalService, AuthService  ) {

    var vm = this;
    vm.formData = {};

    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;
    vm.isMatching = true;
    vm.ROLES = ['Agent','Admin'] ;
    vm.errorMessage = "";

    vm.checkPattern = checkPattern;
    vm.register = register;
    vm.isAgentExist = isAgentExist;
    vm.isAgentAlreadyExist = false;
    vm.resetValues = resetValues;
    vm.init = init();
    function init () {
      $state.go('agent.login');
    };

    function checkPattern(pwd) {
      vm.formData.password = pwd; //
      //vm.isMatching = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%_!]).{8,12})/.test(vm.formData.password);
      //vm.isMatching = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,12}$/.test(vm.formData.password);
      vm.isMatching = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$_!@])[A-Za-z\d$@!_]{8,12}$/.test(vm.formData.password);

      if(vm.formData.password == null){
        vm.isRequired = true;
        vm.isMatching = true;
      } else{
        vm.isRequired = false;
      }
    }

    function register() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var success = function () {
              $state.go('agent.home.superadmin')
            };
            ModalService.agentCreateAgentSuccessModal({Text: resp.data.message, backdrop:'static'}, success);
            $log.info("show success modal now");
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function () {
          LoaderService.hideLoader();
          MessageService.error(AppConstants.ToastrMessage.FAILED);
        };
      var payload= {
        "name" : vm.formData.name,
        "userId" : vm.formData.userId,
        "mobileNumber" : vm.formData.contact,
        "pan" : vm.formData.pan,
        "password" : vm.formData.password,
        "confirmPassword" : vm.formData.confirmPassword,
        "role" : vm.formData.selectrole
      };
      LoaderService.showLoader();
      AgentService.post({
        controller: 'registration'
      }, payload).$promise.then(success, error);
    }
    // is agent already exist or not
    function isAgentExist() {
      vm.errorMessage = "";
      if (vm.formData.userId) {
        var success = function(response) {
            vm.isAgentAlreadyExist = response.data.isExist;
            vm.errorMessage = "User Id already exists";
          },
          error = function() {
            vm.isAgentAlreadyExist = false;
          };
        var payload= {
          "userId" : vm.formData.userId
        };
        AgentService.post({
          controller: 'is-exist'
        }, payload).$promise.then(success, error);
      }
    }
    // end

    function resetValues() {
      vm.isAgentAlreadyExist = false;
    }


  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ChangePasswordController', ChangePasswordController);

  /** @ngInject */
  function ChangePasswordController(AppConstants, $state, AgentService, ModalService, AuthService) {
    var vm = this;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.passwordMatch = false;
    vm.isPasswordMatchWithPattern = false;
    vm.changePasswordFormIsValid = true;
    vm.isMatching = AppConstants.password_regex;
    vm.init = init();
    function init () {
      $state.go('agent.login');
    };
    vm.agentLogin = function (form) {
      if (form.$valid && (form.password.$modelValue === form.changePassword.$modelValue)) {
          var payload = {
            "newPassword": form.password.$modelValue,
            "confirmNewPassword": form.changePassword.$modelValue
          };

        AgentService.post({
          controller: 'change-password'
        }, payload).$promise.then(successChangePassword, errorChangePassword);
      }

      function successChangePassword(resp) {
        if (resp.status) {
          var success = function () {
            var identifierData = AuthService.getToken();
            identifierData['firstTimeLogin'] = false;
            // $cookies.put('token_data', angular.toJson(tokenData));
            vm.setToken(identifierData);
            $state.go('agent.home.distributor-list')
          };
          ModalService.agentChangePasswordSuccessModal({Text: resp.data.statusDesc}, success);
        }
      }

      function errorChangePassword(error) {
        ModalService.agentChangePasswordSuccessModal({Text: error.data.statusDesc});
      }
    }

  }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('UnlockArnController', unlockArnController);

  /** @ngInject */
  function unlockArnController($window, $stateParams, $state, $timeout, AuthService, InvestorsCommonService,InvestorOtpVerifyService, AppConstants, LoaderService, MessageService, ModalService, HDFC_API,InvestorsService,UtilService,InvestorCommonServiceVersion2,toastr,toastrConfig, $scope, $document) {
    var vm = this;
    vm.otpVerificationPayload = {
      otpNumber: "",
      registrationRequestId: ''
    };
    vm.signupForm = {};
    vm.inputReset = false;
    vm.otpForm = {};
    vm.signupUser = {arnCode: "",emailAddress:null,mobileNumber:null};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;
    vm.processOTPFlag = false;
    vm.otpResendMessage = '';
    vm.errorMessage = '';
    vm.activeTab = {basic: false, otp: false, lineclass: 'step1'};
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.gRecaptchaResponse = '';
    vm.showCaptcha = true;
    vm.selectedField = 'mobile';
    vm.otpValIndex1 = '';
    vm.otpValIndex2 = '';
    vm.otpValIndex3 = '';
    vm.otpValIndex4 = '';
    vm.otpValIndex5 = '';
    vm.otpValIndex6 = '';
    vm.otpValChanged = otpValChanged;
    vm.goBack = goBack;
    vm.msg = $window.sessionStorage.getItem('msg');

    vm.changeFields = function () {
      vm.signupUser.mobileNumber = '';
      vm.signupUser.emailAddress = '';
    }


    vm.Init = function () {
      switch ($state.current.name) {
        case 'registration.main':
          vm.activeTab.basic = true;
          vm.activeTab.otp = false;
          vm.activeTab.lineclass = 'step1';
          break;
        case 'registration.otp':
          vm.activeTab.basic = true;
          vm.activeTab.otp = true;
          vm.activeTab.lineclass = 'step2';
          break;
        case 'registration.success':
          vm.activeTab.basic = true;
          vm.activeTab.otp = true;
          vm.activeTab.lineclass = 'step2';
          break;
      }
    };

    vm.resetValues = function () {
      vm.otpResendMessage = '';
      vm.errorMessage = '';
      vm.otpValIndex1 = '';
      vm.otpValIndex2 = '';
      vm.otpValIndex3 = '';
      vm.otpValIndex4 = '';
      vm.otpValIndex5 = '';
      vm.otpValIndex6 = '';
      vm.otpVerificationPayload.otpNumber = ''
      vm.otpCodeLength = 0;
    };

    vm.generateOtp = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            var secretLinkUnlockArn = resp.data&& resp.data.token?resp.data.token:'';
            $window.sessionStorage.setItem('token',secretLinkUnlockArn);
            $window.sessionStorage.setItem('msg', resp.data.msg);
            $state.go('unlockArn.otp');
            bindEvent();
          } else {
            MessageService.error(resp.message);
            vm.gRecaptchaResponse="";
            vm.showCaptcha = false;
            $timeout(function () {
              vm.showCaptcha = true;
            });
          }
          vm.processFlag = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
          vm.gRecaptchaResponse="";
          vm.showCaptcha = false;
          $timeout(function () {
            vm.showCaptcha = true;
          });
        },
        payload = {
          arnCode: 'ARN-' + vm.signupUser.arnCode
        };

      // if(vm.signupUser.emailAddress!=null && (vm.signupUser.emailAddress!==""))
      //   payload.emailAddress=vm.signupUser.emailAddress;

      // if(vm.signupUser.mobileNumber!=null && (vm.signupUser.mobileNumber!==""))
      //   payload.mobileNumber=vm.signupUser.mobileNumber;
      if(vm.signupUser && vm.signupUser.mobileNumber!=null && (vm.signupUser.mobileNumber!=="")){
        payload.mobileNumber = vm.signupUser.mobileNumber ? AuthService.encryptRSA(angular.copy(vm.signupUser.mobileNumber)) : '';
      }
      if(vm.signupUser && vm.signupUser.emailAddress!=null && (vm.signupUser.emailAddress!=="")){
        payload.emailAddress= vm.signupUser.emailAddress ? AuthService.encryptRSA(angular.copy(vm.signupUser.emailAddress)) : '';
      }
      vm.errorMessage = '';
      vm.processFlag = true;
      LoaderService.showLoader('.popup');
      InvestorCommonServiceVersion2.post2({
        child1: 'unlock',
        child2: 'arn',
        child3: 'request'

      }, payload).$promise.then(success, error);
    };

    vm.reGenerateOtp = function () {
      var success = function (resp) {
        if(resp.data.message === "SUCCESS") {
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.success('OTP sent again successfully.', '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
          resetTimer();
          vm.resetValues();
        }
        // vm.errorMessage = resp.data.message || AppConstants.ToastrMessage.FAILED;
        if(resp.data.message !="SUCCESS") {
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.data.message, '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
        }
      }, error = function (err) {
        vm.processOTPFlag = true;
        toastrConfig.preventDuplicates = false;
        toastr.error(err.message, '', {
          onHidden: function () {
            vm.processOTPFlag = false;
            toastrConfig.preventDuplicates = true;
          }
        });
      }
      vm.errorMessage = '';
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.otpResendMessage = '';
      // AuthService.reGenerateOtp($stateParams.registrationRequestId).then(success, error);
      var identifier = $window.sessionStorage.getItem('token');
      var url= HDFC_API.VERSION +'/unlock/arn/resend/otp';
      InvestorOtpVerifyService.verifyOtp(url,identifier).then(success, error);
    };

    vm.verifyOtp = function () {
      var success = function (resp) {
      resp = resp?resp.data:resp;
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          $state.go('unlockArn.success');
        } else {
          vm.processFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.message, '', {
            onHidden: function () {
              vm.processFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
          // vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
        }
        // vm.processFlag = false;
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        // vm.processFlag = false;
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
      };

      var otpPayload ={
        otp: vm.otpVerificationPayload.otpNumber ? AuthService.encryptRSA(angular.copy( vm.otpVerificationPayload.otpNumber.toString())) : ''
      }
      vm.otpVerificationPayload.otpNumber = vm.otpVerificationPayload.otpNumber.toString() + "";
      var identifier = $window.sessionStorage.getItem('token');
      var url= HDFC_API.VERSION +'/unlock/arn/otp/verify';
      InvestorOtpVerifyService.verifyOtp(url,identifier,otpPayload).then(success, error);
    };

    vm.confirmCancel = function () {
      var success = function () {
          $state.go('login');
      };
      ModalService.confirmCancelModal({}, success);
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }


    function otpValChanged(myvalue) {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();
      vm.otpVerificationPayload.otpNumber = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.otpVerificationPayload.otpNumber.toString().length;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next = next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev = prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev.focus();
              break;
            }
          }
        }
      }
    }

    function bindEvent() {
      $timeout(function() {
        var inputs = document.querySelectorAll(".input-code-container input");
        inputs.forEach(function(input, index) {
          input.addEventListener("paste", function(e) {
            var data = e.clipboardData.getData("text");
            var value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach(function(input, index) {
                input.value = value[index];
              });
            }
          });
        });
      });
    }

    function goBack() {
      $window.history.back();
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TransactionController', transactionController);

  /** @ngInject */
  function transactionController(HDFC_API, $window, $state,$rootScope, $stateParams, AuthService, $timeout, TransactionService, MessageService, LoaderService, AppConstants, moment, ModalService, UtilService, InvestorsCommonService) {
    var vm = this;

    vm.isLoading = false;
    vm.arnCode = '';
    vm.TRANSACTION_STATUSES = AppConstants.TRANSACTION_STATUSES;
    vm.STATUS_YEAR = AppConstants.STATUS_YEAR;
    vm.REMIND_SUCCESS_MESSAGE = AppConstants.REMIND_SUCCESS_MESSAGE;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.selectedYear = vm.STATUS_YEAR[0].key;



    vm.transactionList = null;
    vm.activeRecent = {"1":true};

    vm.isPagination = false;
    vm.totalTransactions = 0;
    vm.selectedType = null;
    vm.changeSelectedYear = changeSelectedYear;
    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }
    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'DESC',
      onoff: 'ALL',
      transactionNature: 'ALL',
      searchText: ''
    };
    vm.snapshotData = {
      allCount: 0,
      proposedCount:0,
      expiredCount: 0,
      pendingCount: 0,
      processedCount: 0,
      rejectedCount: 0,
      reversedCount: 0
    };
    vm.headerTooltip={
    Proposed:'Total no. of transactions been initiated for investors',
    Rejected:'Transactions rejected by investors',
    Expired:'Transactions not approved in time by an investor',
    Pending:'Transactions is being validated',
    Reversed:'Transactions cancelled',
    Processed:'Successfully completed transactions'
  };
    vm.aumData = null;
    // vm.dateFilter = {"startDate": $window.moment().subtract(1, 'months'), "endDate": $window.moment()};
    vm.currentPage = 1;
    vm.fromCount = 0;
    vm.toCount = 0;
    vm.searchText = '';
    vm.isSearching = false;
    vm.downloadReport = downloadReport;

    var listPayload = {
      fromDate: '',
      pageIndex: vm.currentPage,
      pageLimit: vm.selectedPageLimit,
      searchText: '',
      toDate: '',
      flowType: 'ALL',
      transactionNature: 'ALL',
      transactionStatus: vm.TRANSACTION_STATUSES[0].value.toUpperCase(),
      transactionType: ['ALL']
    };

    var snapshotPayload = {"sourceType": "ALL", "transactionNature": "ALL", "flowType": "ALL"};

    var resetDefaults = function () {
      vm.currentPage = 1;
      vm.fromCount = 0;
      vm.toCount = 0;
      vm.totalTransactions = 0;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.transactionList = null;
      vm.isPagination = false;
    };

    var reInitPayload = function () {
      vm.selectedType = vm.selectedType || ['ALL'];
      listPayload.pageIndex = vm.currentPage;
      listPayload.pageLimit = vm.selectedPageLimit;
      listPayload.transactionStatus = vm.selectedStatus.value.toUpperCase();
      listPayload.transactionType = vm.selectedType;
    };

    /*Multiselect code start*/
    vm.transactionModel = [];
    vm.transactionSettings = {displayProp: 'key', idProp: 'value', dynamicTitle: true};
    vm.transactionTranslationTexts = {buttonDefaultText: 'All Transaction'};
    vm.transactionEvents = {
      onSelectionChanged: function () {
        resetDefaults();
        var trType = vm.transactionModel.map(function (ele) {
          return ele.id;
        });
        vm.selectedType = trType;
        listPayload.transactionType = trType.length > 0 ? ((trType.length == vm.TRANSACTION_TYPES.length) ? ['ALL'] : trType) : ['ALL'];
        snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
        snapshotPayload.sourceType = vm.sortOrder.onoff;
        snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
        snapshotPayload.transactionType = listPayload.transactionType;
        snapshotPayload.fromDate = listPayload.fromDate;
        snapshotPayload.toDate = listPayload.toDate;
        transactionSnapshot(snapshotPayload);
        transactionSearch(listPayload);
      },
      onSelectAll: function () {
        vm.transactionTranslationTexts.buttonDefaultText = 'All Transaction';
      }
    };
    /*Multiselect code end*/
    vm.oversea_arn = $window.sessionStorage.getItem("oversea_arn") === "true" ? true: false;

    var updatePage = function () {
      vm.fromCount = ((vm.currentPage) * listPayload.pageLimit) + 1;
      vm.toCount = (vm.currentPage + 1) * listPayload.pageLimit;
      vm.toCount = (vm.toCount > vm.totalTransactions) ? vm.totalTransactions : vm.toCount;
    };

    var transactionSnapshot = function (snapshotPayload) {
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.snapshotData = resp.data;
          } else {
            vm.snapshotData = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.snapshotData = null;
          UtilService.errorHandler(err);
        };
      TransactionService.post({VERSION:'v3',controller: 'snapshot'}, snapshotPayload).$promise.then(success, error);
    };

    var transactionTotalAum = function () {
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.aumData = angular.equals({}, resp.data) ? {
              inFlowTransactionSum: {lumpsumAmount: {}, systematicAmount: {}},
              outFlowTransactionSum: {lumpsumAmount: {}, systematicAmount: {}}
            } : resp.data;
          vm.aumData.amountUnit = UtilService.getUnitSting(vm.aumData.totalTransactionSum);
          vm.aumData.transactionUnit = UtilService.getUnitSting(vm.aumData.totalTransactions);
          vm.aumData.inFlowTransactionSum.amountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.totalInFlowAmount);
          vm.aumData.inFlowTransactionSum.transactionUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.totalTransactions);
          vm.aumData.inFlowTransactionSum.lumpsumAmount.amountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.lumpsumAmount.totalLumpsumAmount);
          vm.aumData.inFlowTransactionSum.lumpsumAmount.onlineAmountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.lumpsumAmount.onlineLumpsumAmount);
          vm.aumData.inFlowTransactionSum.lumpsumAmount.offlineAmountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.lumpsumAmount.offlineLumpsumAmout);
          vm.aumData.inFlowTransactionSum.systematicAmount.amountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.systematicAmount.totalSystematicAmount);
          vm.aumData.inFlowTransactionSum.systematicAmount.onlineAmountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.systematicAmount.onlineSystematicAmount);
          vm.aumData.inFlowTransactionSum.systematicAmount.offlineAmountUnit = UtilService.getUnitSting(vm.aumData.inFlowTransactionSum.systematicAmount.offlineSystematicAmout);
          vm.aumData.outFlowTransactionSum.amountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.totalOutFlowAmount);
          vm.aumData.outFlowTransactionSum.transactionUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.totalTransactions);
          vm.aumData.outFlowTransactionSum.lumpsumAmount.amountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.lumpsumAmount.totalLumpsumAmount);
          vm.aumData.outFlowTransactionSum.lumpsumAmount.onlineAmountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.lumpsumAmount.onlineLumpsumAmount);
          vm.aumData.outFlowTransactionSum.lumpsumAmount.offlineAmountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.lumpsumAmount.offlineLumpsumAmout);
          vm.aumData.outFlowTransactionSum.systematicAmount.amountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.systematicAmount.totalSystematicAmount);
          vm.aumData.outFlowTransactionSum.systematicAmount.onlineAmountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.systematicAmount.onlineSystematicAmount);
          vm.aumData.outFlowTransactionSum.systematicAmount.offlineAmountUnit = UtilService.getUnitSting(vm.aumData.outFlowTransactionSum.systematicAmount.offlineSystematicAmout);
        } else {
          vm.aumData = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'total-aum'}, {}).$promise.then(success, error);
    };

    var transactionSearch = function (payload) {
      // if (!vm.arnCode) {
      //   MessageService.error('Invalid arnCode');
      //   return;
      // }

      var success = function (resp) {
          LoaderService.hideLoader('.allList');
          if (resp.data && resp.status) {
            vm.transactionList = resp.data.transactionList;
            vm.transactionList && vm.transactionList.forEach(function (item) {
              item.amountUnit = UtilService.getUnitSting(item.amount);
            });
            vm.totalTransactions = resp.data.totalTransactions;
            vm.isPagination = !!(vm.transactionList && vm.transactionList.length);
          } else {
            vm.transactionList = null;
            vm.totalTransactions = 0;
            vm.isPagination = false;
            // MessageService.error(resp.message);
          }
          updatePage();
          vm.isLoading = false;
          vm.sortOrder.searchText = '';
          angular.element('select').trigger("blur");
        },
        error = function (err) {
          LoaderService.hideLoader('.allList');
          vm.transactionList = null;
          vm.totalTransactions = 0;
          vm.isLoading = false;
          vm.isPagination = false;
          updatePage();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.allList');
      vm.isLoading = true;
      vm.sortOrder.sortValue = 'DESC';
      payload.sourceType = vm.sortOrder.onoff;
      payload.sortKey = vm.sortOrder.sortKey;
      payload.sortValue = vm.sortOrder.sortValue;
      payload.pageIndex = vm.currentPage - 1;
      payload.pageLimit = vm.selectedPageLimit;
      TransactionService.post({VERSION:'v3',controller: 'search'}, payload).$promise.then(success, error);
    };

    vm.transactionRecentSearch = function () {
      $window.scrollTo(0, 0);
      var success = function (resp) {
          LoaderService.hideLoader('.recentList');
          if (resp.data && resp.status) {
            vm.transactionRecentList = resp.data.transactionList ? resp.data.transactionList : resp.data;
          } else {
            vm.transactionRecentList = null;
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.recentList');
          vm.transactionRecentList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.recentList');
      vm.isLoading = true;
      InvestorsCommonService.get({child1:'recent', child2:'transaction'}).$promise.then(success, error);
    };


    vm.init = function () {
      $window.scrollTo(0, 0);
      switch ($state.current.name) {
        case 'main.transactions.recent':
          vm.activateTab(1);
          vm.transactionRecentSearch();
          break;
        case 'main.transactions.all':
        default :
          vm.TRANSACTION_TYPES = angular.copy(AppConstants.TRANSACTION_TYPES.ALL).splice(1, AppConstants.TRANSACTION_TYPES.ALL.length);
          listPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];

          vm.activateTab(2);
          vm.changeSelectedYear();
          break;
      }

      if ($stateParams.status) {
        vm.selectedStatus = vm.TRANSACTION_STATUSES.find(function (item) {
            return item.value.toUpperCase() === $stateParams.status.toUpperCase();
          }) || vm.TRANSACTION_STATUSES[0];
      } else {
        vm.selectedStatus = (vm.selectedStatus)?vm.selectedStatus : vm.TRANSACTION_STATUSES[0];
      }
      vm.selectedType = vm.selectedType || ['ALL'];
      listPayload.transactionType = vm.selectedType;
      listPayload.transactionStatus = vm.selectedStatus.value.toUpperCase();
      vm.changeSelectedYear();

      /*vm.selectedType = vm.selectedType || ['ALL'];
      listPayload.transactionType = vm.selectedType;
      listPayload.transactionStatus = vm.selectedStatus.value.toUpperCase();
      listPayload.sortValue = vm.sortOrder.sortValue;
      listPayload.sortKey = vm.sortOrder.sortKey;
      listPayload.sourceType = vm.sortOrder.onoff;
      listPayload.transactionNature = vm.sortOrder.transactionNature;*/

      /*snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      transactionSnapshot(snapshotPayload);*/
      transactionTotalAum();

    };

    function changeSelectedYear () {
      vm.isReset = false;
      var success = function (resp) {
          LoaderService.hideLoader('.allList');
          if (resp.data && resp.status) {
            switch (vm.selectedYear) {
              case 'current' : {
                listPayload.fromDate = resp.data.currentFinancialYear && resp.data.currentFinancialYear.fromDate;
                listPayload.toDate = resp.data.currentFinancialYear && resp.data.currentFinancialYear.toDate;
                vm.minDate = resp.data.currentFinancialYear && resp.data.currentFinancialYear.yearStartDate;
                vm.maxDate = resp.data.currentFinancialYear && resp.data.currentFinancialYear.yearEndDate;
                vm.dateFilter = {
                  'startDate' : $window.moment(listPayload.fromDate),
                  'endDate' : $window.moment(listPayload.toDate)
                }
              }
                break;
              case 'previous': {
                listPayload.fromDate = resp.data.previousFinancialYear && resp.data.previousFinancialYear.fromDate;
                listPayload.toDate =resp.data.previousFinancialYear && resp.data.previousFinancialYear.toDate;
                vm.minDate = resp.data.previousFinancialYear && resp.data.previousFinancialYear.yearStartDate;
                vm.maxDate = resp.data.previousFinancialYear && resp.data.previousFinancialYear.yearEndDate;
                vm.dateFilter = {
                  'startDate' : $window.moment(listPayload.fromDate),
                  'endDate' : $window.moment(listPayload.toDate)
                }
              }
                break;
              default: {
                listPayload.fromDate = $stateParams.fromDate ? $stateParams.fromDate.format('DD-MMM-YYYY') :resp.data.customDate && resp.data.customDate.fromDate;
                listPayload.toDate = $stateParams.toDate ? $stateParams.toDate.format('DD-MMM-YYYY') : resp.data.customDate && resp.data.customDate.toDate;
                vm.minDate = resp.data.customDate && resp.data.customDate.yearStartDate;
                vm.maxDate = resp.data.customDate && resp.data.customDate.yearEndDate;
                vm.dateFilter = {
                  'startDate' : $window.moment(listPayload.fromDate),
                  'endDate' : $window.moment(listPayload.toDate)
                }
              }
              break;
            }

            $window.setTimeout(function(){
              vm.isReset = true;
            },100);

            snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
            snapshotPayload.sourceType = vm.sortOrder.onoff;
            snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
            snapshotPayload.transactionType = listPayload.transactionType;
            snapshotPayload.fromDate = listPayload.fromDate;
            snapshotPayload.toDate = listPayload.toDate;
            transactionSnapshot(snapshotPayload);
            transactionSearch(listPayload);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader('.allList');
          vm.transactionRecentList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.allList');
      vm.isLoading = true;
      TransactionService.get({VERSION:'v3',controller: 'date'}).$promise.then(success, error);
    }

    vm.statusChanged = function (_status) {
      vm.currentPage=1;
      vm.selectedStatus = _status;
      vm.selectedType = vm.selectedType || ['ALL'];
      reInitPayload();
      snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
      snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      snapshotPayload.transactionType = listPayload.transactionType;
      snapshotPayload.fromDate = listPayload.fromDate;
      snapshotPayload.toDate = listPayload.toDate;
      transactionSnapshot(snapshotPayload);
      transactionSearch(listPayload);
    };

    vm.statusPage = function(){
      reInitPayload();
      transactionSearch(listPayload);
    }

    vm.activateTab = function (tab) {
      vm.activeRecent = {};
      $timeout(function(){
        vm.activeRecent[tab] = true;
      },10)
      $rootScope.$broadcast('checkCurrentState');
    }


    vm.typeChanged = function () {
      resetDefaults();
      listPayload.transactionType = vm.selectedType;
      transactionSearch(listPayload);
    };

    vm.limitChanged = function () {
      vm.currentPage = 1;
      listPayload.pageIndex = vm.currentPage;
      listPayload.pageLimit = vm.selectedPageLimit;
      transactionSearch(listPayload);
    };

    vm.filterByDate = function (dateFilter) {
      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          listPayload.fromDate = $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY');
          listPayload.toDate = $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY');
          transactionSearch(listPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        listPayload.fromDate = $window.moment(vm.dateFilter.startDate).format('DD-MMM-YYYY');;
        listPayload.toDate = $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY');;
        transactionSearch(listPayload);
      }
      snapshotPayload.flowType = AppConstants.TRANSACTION_FLOW_TYPES[0];
      snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      snapshotPayload.fromDate = listPayload.fromDate;
      snapshotPayload.toDate = listPayload.toDate;
      transactionSnapshot(snapshotPayload);
    };

    vm.filterByHeader = function () {
      resetDefaults();
      vm.sortOrder.sortValue = 'DESC';
      listPayload.sourceType = vm.sortOrder.onoff;
      listPayload.sortKey = vm.sortOrder.sortKey;
      listPayload.sortValue = vm.sortOrder.sortValue;
      transactionSearch(listPayload);
    };

    vm.filterByNature = function () {
      /*resetDefaults();
      snapshotPayload.sourceType = vm.sortOrder.onoff;
      snapshotPayload.transactionNature = vm.sortOrder.transactionNature;
      transactionSnapshot(snapshotPayload);

      listPayload.sourceType = vm.sortOrder.onoff;
      listPayload.transactionNature = vm.sortOrder.transactionNature;
      transactionSearch(listPayload);*/
    };

    vm.resetFilter = function () {
      resetDefaults();
      vm.dateFilter.startDate = null;
      vm.dateFilter.endDate = null;
      listPayload.fromDate = '';
      listPayload.toDate = '';
      vm.transactionModel = [];
      vm.selectedType = ["ALL"];
      listPayload.transactionType = vm.selectedType;
      listPayload.searchText = '';
    };

    vm.searchByText = function (e) {

      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        resetDefaults();
        listPayload.sortKey = "transactionDateTime";
        listPayload.sortValue = "ASC";
        listPayload.sourceType = "ALL";
        listPayload.transactionNature = "ALL";
        listPayload.searchText = vm.sortOrder.searchText;
        transactionSearch(listPayload);
      }
    };

    vm.showSummary = function (profile) {
      var payload = {
        folioNumber: profile.folioNumber,
        uuid: profile.uuid
      };
      ModalService.transactionSummaryModal({payload: payload});
    };

    vm.initiateTransaction = function (data) {
      switch (data.action) {
        case "REMIND":
          sendReminder(data);
          break;
        case "REINITIATE":
          prefilledReinitiate(data);
          break;

      }
    };

    var prefilledReinitiate = function(data) {
      function success() {
        getInvestorId(data);
      }

      function error() {
        vm.noPrefill = true;
        getInvestorId(data);
      }
      ModalService.confirmCancelModal({Text: "Do you want to proceed with pre-filled transaction details?"}, success, error);

    }

    var nonPrefilledReinitiate = function(data, investorId){
      switch (data.transactionType) {
        case 'SWITCH':
          $state.go('main.transactions.initiate.switch',{uuid : investorId});
          break;
        case 'SIP':
        case 'PURCHASE':
          $state.go('main.transactions.initiate.sip',{uuid : investorId});
          break;
        case 'STP':
          $state.go('main.transactions.initiate.stp',{uuid : investorId});
          break;
        case 'SWP':
          $state.go('main.transactions.initiate.swp',{uuid : investorId});
          break;
        case 'REDEMPTION':
          $state.go('main.transactions.initiate.redeem',{uuid : investorId});
          break;
      }
    }

    vm.searchList = function () {

      if (vm.isSearching) {
        return;
      }
      else if (vm.searchText.length > 3 || vm.searchText == '') {

        vm.isSearching = true;
        listPayload.searchText = vm.searchText;
        transactionSearch(listPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);

      }

    }
    function sendReminder(listData) {
      var success = function (resp) {
          if (resp && resp.status) {
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'remind'}, {
        transactionId: listData.uuid,
        type: listData.transactionType.toUpperCase()
      }).$promise.then(success, error);
    }

    function getInvestorId(val) {
      var success = function (resp) {
        if (resp.data && resp.status) {
          if(vm.noPrefill){
            nonPrefilledReinitiate(val,resp.data.investorId);
          }else{
          initiateTransactionType(resp.data, val.transactionType, val.uuid);
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'investor',
        'folioNumber': val.folioNumber
      }, {}).$promise.then(success, error);
    }

    function initiateTransactionType(investorId, transactionType, transactionId) {
      investorId = investorId.investorId?investorId.investorId:investorId;
      var status = vm.selectedStatus.value.toUpperCase();
      switch (transactionType) {
        case 'SWITCH':
          $state.go('main.transactions.initiate.switch', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId,
            status: status
          });
          break;
        case 'SIP':
        case 'PURCHASE':
          $state.go('main.transactions.initiate.sip', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId,
            status: status
          });
          break;
        case 'STP':
          $state.go('main.transactions.initiate.stp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId,
            status: status
          });
          break;
        case 'SWP':
          $state.go('main.transactions.initiate.swp', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId,
            status: status
          });
          break;
        case 'REDEMPTION':
          $state.go('main.transactions.initiate.redeem', {
            uuid: investorId,
            transactionType: transactionType,
            transactionId: transactionId,
            status: status
          });
          break;
      }
    }


    function downloadReport(fileName) {
      if(vm.totalTransactions===0) return;
      var payload = {
        "commonReportCO": {
          "generateType": "pdf"
        },
        "requestCO": listPayload
      }
      var downloadUrl = HDFC_API.VERSION + '/report/transaction';
      // var downloadUrl = '/v1/report/sip';
      ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName,payload:payload});
    }


  }
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipPause', SipPause);

  /** @ngInject */
  function SipPause($window, LoaderService, InvestorsService, MessageService, $state, ModalService, UtilService, moment, SchemeService, AppConstants) {
    var vm = this;
    vm.confirmPauseTransaction = confirmPauseTransaction;
    vm.isSipPauseStartDate = false;
    vm.changeStartDate=changeStartDate;
    vm.endDateChange = endDateChange;
    vm.updateDates=updateDates;
    vm.SipPauseEndDate = null;
    vm.SipActionHappened=false;
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    init();

    function init() {
      vm.summaryDetails = $window.JSON.parse(localStorage.getItem('summaryDetails'));
      vm.frequency = vm.summaryDetails.summary.frequency;
      updateDates();
      vm.noOfInstallmentList =[];
      for(var i = 0; i < vm.summaryDetails.maxInstallmentsPauseSip; i++){vm.noOfInstallmentList.push(i+1)}
      changeStartDate(null);
    }

    function updateDates() {
      vm.startMinDateBiller = vm.summaryDetails.nextInstallmentDate;
      localStorage.setItem("mindate", vm.startMinDateBiller);
      vm.startMaxDate = vm.summaryDetails.lastInstallmentDate;
      localStorage.setItem("date", vm.startMaxDate);
    }

    function confirmPauseTransaction() {

      var summaryDetails = $window.JSON.parse(localStorage.getItem('summaryDetails'));
      var sipFrequency = (summaryDetails.summary.frequency === 'Monthly' ? 'OM' : 'Q');
      if (summaryDetails) {
        var atrxnNo = summaryDetails.aTrxnNo;
        var folioNumber = summaryDetails.summary.folioNumber;
        var frequency = sipFrequency;
        var amount = summaryDetails.summary.amount;
        var schemeCode = summaryDetails.schemeCode;
        var installmentsPaused = (summaryDetails.summary.frequency === 'Quarterly' ? 3 : vm.noOfInstallment);
        var type = summaryDetails.summary.type;

      }
      var payload = {
        "amount": amount,
        "atrxnNo": atrxnNo,
        "folioNumber": folioNumber,
        "frequency": frequency,
        "schemeCode": schemeCode,
        "installmentsPaused": installmentsPaused,
        "pauseFromDate": localStorage.getItem("selDate"),
        "pauseToDate":  vm.SipPauseEndDate.clone().format("DD-MMM-YYYY"),
        "transactionType": type
      };
      var success = function (resp) {
          LoaderService.hideLoader('.loader');
          if (resp.data && resp.status) {
            ModalService.sipPauseConfirmation(resp);
            $state.go('main.sipcorner')
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.loader');
          MessageService.error(err.message);
          $state.go('main.systematicCorner');
        };
      LoaderService.showLoader('.loader');
      SchemeService.post({
        controller: 'initiate',
        type: 'pause',
        child1: 'sip'
      }, payload).$promise.then(success, error);
    }


    vm.changeInstallment = function () {

      if(localStorage.getItem("selDate")){
        changeStartDate(localStorage.getItem("selDate"))
      }
    };


    function changeStartDate(date) {
      vm.endDate = date;
      updateEndDates();
    }

    function updateEndDates() {
      var defaultEndDate = null;
      defaultEndDate = $window.moment(localStorage.getItem("date"), "DD-MMM-YYYY");
      var endDate = null;
      var enabledEndDates = [];
      var freq = 0;
      var i = 0;
      endDate = $window.moment(localStorage.getItem("mindate"), "DD-MMM-YYYY");

      freq = UtilService.getNumberOfMonths(endDate, defaultEndDate);
      if(vm.summaryDetails.summary.frequency === 'Monthly') {
        for (i = 0; i <= freq; i++) {
          enabledEndDates.push(endDate.clone().add(i, 'months'));
        }
      }
      else {
        for (i = 0; i <= freq; i+=3) {
          enabledEndDates.push(endDate.clone().add(i, 'months'));
        }}
      vm.maxEndDate = enabledEndDates[freq];
      vm.enabledEndDates = enabledEndDates;
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      updateInstallment();
      vm.isSipPauseStartDate = true;
    }

    function updateInstallment() {
      localStorage.setItem("selDate", $window.moment(vm.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY"));
      var selectedDate = localStorage.getItem("selDate");
      switch (vm.noOfInstallment) {
        case "1":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(1,'months').subtract(1,'days');
          vm.noInstallment = false;
          break;
        case "2":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(2,'months').subtract(1,'days');
          vm.noInstallment = false;
          break;
        case "3":
          vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(3,'months').subtract(1,'days');
          vm.noInstallment = false;
          break;
        default : vm.noInstallment = true;break;
      }
      if(vm.frequency != 'Monthly'){
        vm.SipPauseEndDate = $window.moment(selectedDate, "DD-MMM-YYYY").add(3,'months').subtract(1,'days');
        vm.noInstallment = false;
      }

      vm.SipActionHappened = ((vm.endDate === "null" || vm.endDate === null) ? false : true);
    }
    function endDateChange() {}
  }
  })();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipRenewController', SipRenewController);

  /** @ngInject */
  function SipRenewController($scope, $timeout, $state) {
    var vm = this;
    vm.tabs = [
      {key: 'Transaction', active: true, action: "main.siprenew.transaction"},
      {key: 'Status', active: false, action: "main.siprenew.status"}
    ];

    init();

    function init() {
      $timeout(function() {
        $state.go("main.siprenew.transaction");
      });
    }

    vm.redirectToTab = function(tabKey){
      if (tabKey === "Transaction") {
        vm.tabs[0].active = true;
        vm.tabs[1].active = false;
        $state.go("main.siprenew.transaction");
      } else {
        vm.tabs[0].active = false;
        vm.tabs[1].active = true;
        $state.go("main.siprenew.status");
      }
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SipCornerController', sipCornerController);

  /** @ngInject */
  function sipCornerController($window, HDFC_API, SipCornerService, DownloadReportsService, SipCornerVersionService, InvestorsService, TransactionService, ModalService, StoreInvestorModel, $state, $stateParams, $timeout, LoaderService, AppConstants, MessageService, UtilService, moment , cancel_nudge_data,panAdharLinkingService) {
    var vm = this;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.STATUS_YEAR = AppConstants.STATUS_YEAR;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.isLoading = false;
    vm.active = {0: true};
    vm.reportUrls = null;
    vm.systematicListData = null;
    // vm.STATUSTYPES = [{key: 'Status Type', value: 'ALL '}];
    vm.STATUSTYPES = [];
    vm.selectedYear = vm.STATUS_YEAR[0].key;
    vm.selectedStatusType = null;//vm.STATUSTYPES[0].value.trim();
    vm.dateFilter = {startDate: null, endDate: null};
    vm.isSearching = false;

    vm.totalSystematicListData = 0;
    vm.currentPageSystematicList = 1;
    //vm.pageLimitSystematicList = 25;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.viewMode = 'days';
    vm.startDate = "";
    vm.endDate = "";
    vm.responseDate = null;
    vm.cancelNudgeMessages = cancel_nudge_data;

    vm.reInitiateAction = function (investor) {
      var payload = {"investorUUID": investor.investorId};
      var success = function (resp) {
        if (resp.status && resp.data) {
            var state = 'main.transactions.initiate.' + (investor.type).toLowerCase();
            if(investor.isModify && (investor.type === "SIP" || investor.type === "SIP_TOP_UP")){
              investor.type = "SIP";
              if(investor.autoFrequency == "Business Days(BZ)"){
                investor.autoFrequency = "Daily";
              }
              sessionStorage.setItem('modifySipData', JSON.stringify(investor));
              $state.go('main.transactions.initiate.sip',{
                uuid : investor.investorId,
                fromModify : true
              });
            }else {
              $state.go(state, {
                uuid: investor.investorId,
                schemeCode: investor.schemeCode,
                transactionType: investor.type,
                txnId: investor.transactionID,
                folioNumber: investor.folioNumber,
                frequency: investor.autoFrequency,
                amount:investor.amount,
                fromRenew : true
              });
            }
         } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            })
          }
        }
      }, error = function (err) {
      };
      var successHandlerForPanAadhar = function(){
        LoaderService.hideLoader();
        InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      }, errorHandlerForPanAadhar = function(){
        return;
      };
      panAdharLinkingService.checkPanAdharStatus(investor.pan,investor.folioNumber,vm.brokerCode).then(successHandlerForPanAadhar).catch(errorHandlerForPanAadhar);
    };

    /*Multiselect code start*/
    vm.TRANSACTION_TYPES = vm.TRANSACTION_TYPES = angular.copy(AppConstants.SIP_TRANSACTION_TYPES);
    vm.transactionType = [];
    vm.transactionSettings = {displayProp: 'key', idProp: 'value', dynamicTitle: true};
    vm.transactionTranslationTexts = {buttonDefaultText: 'Transaction Type (All)'};
    vm.transactionEvents = {
      onSelectionChanged: function () {
        resetDefaults();
        var trType = vm.transactionType.map(function (ele) {
          return ele.id;
        });
        vm.selectedType = trType;
        /*listPayload.transactionType = trType.length > 0 ? ((trType.length == vm.TRANSACTION_TYPES.length) ? ['ALL'] : trType) : ['ALL'];
         transactionSearch(listPayload);*/
        reInitPayload();
        systematicPayload.transactionType = [];
        angular.forEach(vm.transactionType, function (trxnType) {
          systematicPayload.transactionType.push(trxnType.id);
        });
        vm.getSystematicList(systematicPayload);
      },
      onSelectAll: function () {
        vm.transactionTranslationTexts.buttonDefaultText = 'Transaction Type (All)';
      }
    };
    /*Multiselect code end*/

    var systematicPayload = {
      'app-type': 'W',
      'fromDate': '', //"dd-MMM-yyyy",
      'pageIndex': vm.currentPageSystematicList,
      'pageLimit': vm.selectedPageLimit,
      'searchText': vm.searchText,
      'statusType': 'ACTIVE',
      //"toDate": "" //"dd-MMM-yyyy",
      'sortKey': 'START_DATE',
      'sortValue': 'DESC',
      'version': 2
    };

    vm.sortOrder = {
      sortKey: 'transactionDateTime',
      sortValue: 'ASC',
      onoff: 'ALL',
      transactionNature: 'ALL',
      searchText: ''
    };

    vm.filterByHeader = filterByHeader;

    vm.init = function () {
      vm.brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      vm.getStatus();
      vm.fetchSystematicInvestorReportUrls();
    };

    vm.initSipCorner = function () {
      vm.getSystematicList(systematicPayload);
      vm.fetchSystematicInvestorReportUrls();
    };

    var resetDefaults = function () {
      vm.currentPageSystematicList = 1;
      vm.totalSystematicListData = 0;
      vm.selectedPageLimit = vm.PAGE_LIMITS[0];
      vm.systematicListData = null;
      vm.isPagination = false;
    };

    vm.limitChanged = function () {
      vm.currentPageSystematicList = 1;
      systematicPayload.pageIndex = vm.currentPageSystematicList;
      systematicPayload.pageLimit = vm.selectedPageLimit;
      vm.getSystematicList(systematicPayload);
    };

    function filterByHeader() {
      systematicPayload.sortKey = vm.sortOrder.sortKey;
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      systematicPayload.sortValue = vm.sortOrder.sortValue;
      vm.initSipCorner();

    }

    var reInitPayload = function () {
      //systematicPayload['app-type'] = 'W';
      systematicPayload.fromDate = vm.dateFilter.startDate ? $window.moment(vm.dateFilter.startDate, "DD-MMM-YYYY").format('DD-MMM-YYYY').toString() : '';
      systematicPayload.pageIndex = vm.currentPageSystematicList;
      systematicPayload.pageLimit = vm.selectedPageLimit;
      systematicPayload.statusType = angular.isDefined(vm.selectedStatusType) && vm.selectedStatusType != null ? (vm.selectedStatusType).toUpperCase() : 'ALL';
      systematicPayload.toDate = vm.dateFilter.endDate ? $window.moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
    };

    vm.filterByDate = function (dateFilter) {

      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          vm.getSystematicList(systematicPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        vm.getSystematicList(systematicPayload);
      }
    };

    vm.fetchSystematicInvestorReportUrls = function () {
      var success = function (resp) {
          resp = resp.data;
          if (resp.status && resp.data) {
            if (resp.data.reportDTO) {
              vm.reportUrls = resp.data.reportDTO;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      DownloadReportsService.fetchApiUrlForReports('sip', 'listing').then(success, error);
    };

    vm.downloadReport = function (downloadUrl, fileName) {
      ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName});
    };

    /*vm.downloadReportList = function (downloadUrl, fileName) {
     ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName});
     };*/

    vm.downloadReportList = function (fileName) {

      var payload = {
        "commonReportCO": {
          "generateType": "pdf"
        },
        "requestCO": systematicPayload
      };

      var downloadUrl = HDFC_API.VERSION + '/report/sip/download';
      ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName, payload: payload});
    }


    vm.getSystematicList = function (systematicPayload) {
      LoaderService.showLoader('.sipCorner');
      var success = function (resp) {
          if (resp.data && resp.status) {
            resp.data.sipdtoList && resp.data.sipdtoList.forEach(function (item) {
              //item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
              //item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
              item.amountUnit = UtilService.getUnitSting(item.amount);
            });
            vm.systematicListData = resp.data.sipdtoList;

            vm.systematicListData.forEach(function(el) { el.panAdharLinked = false ; el.ispanAdharLinkedChecked = false ;  })

            if (vm.systematicListData != null) {
              vm.investorId = vm.systematicListData.investorId;
            }
            vm.totalSystematicListData = resp.data.totalCount;
            vm.isPagination = !!(vm.systematicListData && vm.systematicListData.length);
          } else {
            vm.systematicListData = null;
            vm.totalSystematicListData = 0;
            vm.isPagination = false;
            // MessageService.error(resp.message);
          }
          LoaderService.hideLoader('.sipCorner');
          vm.isLoading = false;
          angular.element('select').trigger("blur");
        },
        error = function (err) {
          LoaderService.hideLoader('.sipCorner');
          vm.isLoading = false;
          vm.isPagination = false;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.sipCorner');
      vm.isLoading = true;
      systematicPayload.pageIndex = vm.currentPageSystematicList - 1;
      systematicPayload.pageLimit = vm.selectedPageLimit;
      systematicPayload.searchText = vm.searchText;
      SipCornerVersionService.post({}, systematicPayload).$promise.then(success, error);
    };

    vm.getStatus = function () {
      vm.isReset = false;
      LoaderService.showLoader('.sipCorner');
      var success = function (resp) {
          if (resp.status && resp.data) {
            LoaderService.hideLoader('.sipCorner');
            for (var i = 0; i < resp.data.statusType.length; i++) {
              var obj;
              if(resp.data.statusType[i].toUpperCase() === "EXPIRED"){
                obj = {
                  key: "EXPIRED",
                  value: "Completed"
                }
              } else {
                obj = {
                  key: resp.data.statusType[i].toUpperCase(),
                  value: resp.data.statusType[i]
                };
              }
              vm.STATUSTYPES.push(obj);
            }
            vm.selectedStatusType = "ACTIVE";
            systematicPayload.fromDate = "";
            systematicPayload.toDate = "";
            systematicPayload.statusType = $stateParams.status ? $stateParams.status.toUpperCase() : 'ACTIVE';
            systematicPayload.transactionType = $stateParams.transactionType ? [$stateParams.transactionType.toUpperCase(), "SIP_TOP_UP"] : [];
            vm.responseDate = $window.moment(resp.data.currentDate, "DD-MMM-YYYY");
            vm.endMaxDate = vm.responseDate.clone().add(1, "minutes");
            vm.startMaxDate = vm.responseDate.clone();
            vm.transactionType = $stateParams.transactionType ? [{id:$stateParams.transactionType.toUpperCase()}, {id: 'SIP_TOP_UP'}] : [];
            if ($stateParams.status && $stateParams.status != '' && $stateParams.status.toUpperCase() !== 'ACTIVE') {
              var today = moment(new Date);
              var date = today.clone().subtract(1, 'months').date(today.date());
              systematicPayload.fromDate = $window.moment(date).format('DD-MMM-YYYY');
              systematicPayload.toDate = $window.moment(new Date).format('DD-MMM-YYYY');
              vm.selectedStatusType = $stateParams.status ? $stateParams.status.toUpperCase() : 'ACTIVE';
              vm.dateFilter = {
                'startDate': $window.moment(systematicPayload.fromDate, "DD-MMM-YYYY"),
                'endDate': $window.moment(systematicPayload.toDate, "DD-MMM-YYYY")
              }
            } else if ($stateParams.status && $stateParams.status != '' && $stateParams.status.toUpperCase() === 'ACTIVE' && $stateParams.next) {
              var todayDate = moment(new Date);
              var toDate = todayDate.clone().add(1, 'months').date(todayDate.date());
              systematicPayload.fromDate = $window.moment(new Date).format('DD-MMM-YYYY');
              systematicPayload.toDate = $window.moment(toDate).format('DD-MMM-YYYY');
              vm.endMaxDate = $window.moment(toDate).clone().add(1, "minutes");
              vm.selectedStatusType = $stateParams.status ? $stateParams.status.toUpperCase() : 'ACTIVE';
              vm.dateFilter = {
                'startDate': $window.moment(systematicPayload.fromDate, "DD-MMM-YYYY"),
                'endDate': $window.moment(systematicPayload.toDate, "DD-MMM-YYYY")
              }
            }
            /*if (resp.data && resp.data.dateFilter) {
              if ($stateParams.status && $stateParams.status != '') {
                //var days = 6;
                //var date = moment().subtract(days * 1, 'days').toISOString().substring(0, 19) + 'Z';
                vm.transactionType = $stateParams.transactionType ? [{id:$stateParams.transactionType.toUpperCase()}] : 'All';
                vm.selectedStatusType = $stateParams.status ? $stateParams.status.toUpperCase() : 'ACTIVE';
              } else {
                //systematicPayload.fromDate = resp.data.dateFilter.customDate && resp.data.dateFilter.customDate.fromDate;
                //systematicPayload.toDate = resp.data.dateFilter.customDate && resp.data.dateFilter.customDate.toDate;
                vm.minDate = resp.data.dateFilter.customDate && resp.data.dateFilter.customDate.yearStartDate;
                vm.maxDate = resp.data.dateFilter.customDate && resp.data.dateFilter.customDate.yearEndDate;
              }
              vm.dateFilter = {
                'startDate': $window.moment(systematicPayload.fromDate),
                'endDate': $window.moment(systematicPayload.toDate)
              }
              $window.setTimeout(function () {
                vm.isReset = true;
              }, 10);
            }*/
            vm.isReset = true;
            vm.getSystematicList(systematicPayload);
          } else {
            LoaderService.hideLoader('.sipCorner');
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.sipCorner');
          UtilService.errorHandler(err);
        };
      SipCornerVersionService.get({controller: 'status'}).$promise.then(success, error);
    };

    vm.validateInvestor = function (transactionType, portfolioDetails) {
      var payload = {"investorUUID": portfolioDetails.investorId};
      LoaderService.showLoader('.sipCorner');
      var success = function (resp) {
        LoaderService.hideLoader('.sipCorner');
        if (resp.status && resp.data) {
          var investorInfo = resp.data;
          if (transactionType !== 'Redeem' && transactionType !== 'SWP') {
            vm.callPanService(investorInfo, transactionType, portfolioDetails);
          } else {
            vm.initiateTransaction(transactionType, portfolioDetails);
          }
        } else {
          MessageService.error(resp.message || "Investor's sole applicant details not found");
        }
      }, error = function (err) {
        LoaderService.hideLoader('.sipCorner');
        UtilService.errorHandler(err);
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    };

    vm.actionReceiver = function (actionType, portfolioDetails , actions) {
      if (actionType === "Cancel") {
        if(portfolioDetails.type == 'SIP' || portfolioDetails.type == 'SIP_TOP_UP') {
          var showPause = actions.includes('Pause');
          var msg = "Dear Member, Try out our Pause SIP feature. If you still want to Cancel the SIP click on Proceed",
            success = function (action) {
              switch (action) {
                case 'continueSip':
                  ModalService.genericModal({
                    text: AppConstants.CONTINUE_WITH_SIP_MESSAGE
                  });
                  break
                case 'modifySip':
                  var successHandler = function() {
                    LoaderService.hideLoader();
                    var success = function() {
                      portfolioDetails.isModify = true;
                      vm.reInitiateAction(portfolioDetails);
                    };

                    var cancel = function() {};

                    ModalService.confirmCancelModal({
                      Text:  vm.cancelNudgeMessages.popupDTO.popupDTOMap.SYSTEMATIC_MODIFY_MESSAGE.content,
                      confirmModifySip : true
                    },success, cancel);
                  }, errorHandler = function() {
                    LoaderService.hideLoader();
                    return;
                  };
                  LoaderService.showLoader();
                  panAdharLinkingService.checkPanAdharStatus(portfolioDetails.pan, portfolioDetails.folioNumber,vm.brokerCode).then(successHandler).catch(errorHandler);
                  break;
                case 'pauseSip':
                  pauseTransaction(portfolioDetails);
                  break;
                case 'cancelSip':
                  cancelSip(portfolioDetails);
                  break;
              }
              // vm.cancelThisTransaction(portfolioDetails);
            },
            error = function () {
            };
          ModalService.confirmCancelSystematicModal({Text: vm.cancelNudgeMessages.popupDTO.popupDTOMap, ButtonProceed: true , sipCancel : true , showPause : showPause , distributorName : portfolioDetails.distributorName}, success, error);
        } else if (portfolioDetails.type == 'DREAM SIP' || portfolioDetails.type == 'FLEXSIP') {
          var showPause = actions.includes('Pause');

          var success = function(action) {
            switch (action) {
              case 'pauseSip':
                pauseTransaction(portfolioDetails);
                break;
              case 'cancelSip':
                cancelSip(portfolioDetails);
                break;
            }
          } , error = function() {}

          if (showPause) {
            ModalService.confirmCancelSystematicModal({Text: vm.cancelNudgeMessages.popupDTO.popupDTOMap, ButtonProceed: true , sipCancel : true , showPause : showPause , distributorName : portfolioDetails.distributorName, otherFlow : true , tncType : 'DREAMSIP'}, success, error);
          } else {
            cancelSip(portfolioDetails);
          }
        } else{
          vm.cancelThisTransaction(portfolioDetails);
        }
      }
      if (actionType === "Renew") {
        var successHandler = function() {
          LoaderService.hideLoader();
          vm.reInitiateAction(portfolioDetails);
        }, errorHandler = function() {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAdharLinkingService.checkPanAdharStatus(portfolioDetails.pan, portfolioDetails.folioNumber,vm.brokerCode).then(successHandler).catch(errorHandler);
      }
      if(actionType === "Top-Up"){
        var successHandler = function() {
          LoaderService.hideLoader();
          vm.goToTopup(portfolioDetails);
        }, errorHandler = function() {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAdharLinkingService.checkPanAdharStatus(portfolioDetails.pan, portfolioDetails.folioNumber,vm.brokerCode).then(successHandler).catch(errorHandler);
      }
      if(actionType === "Pause"){
        pauseTransaction(portfolioDetails);
      }
      if (actionType === "Modify") {

        var successHandler = function() {
          LoaderService.hideLoader();
          var success = function() {
            portfolioDetails.isModify = true;
            vm.reInitiateAction(portfolioDetails);
          };
          var cancel = function() {};
          ModalService.confirmCancelModal({
            Text: vm.cancelNudgeMessages.popupDTO.popupDTOMap.SYSTEMATIC_MODIFY_MESSAGE.content,
            confirmModifySip : true
          },success, cancel);
        }, errorHandler = function() {
          LoaderService.hideLoader();
          return;
        };
        LoaderService.showLoader();
        panAdharLinkingService.checkPanAdharStatus(portfolioDetails.pan, portfolioDetails.folioNumber,vm.brokerCode).then(successHandler).catch(errorHandler);

      }

      if(actionType == 'Change Option'){
        var success = function () {
        //  alert("done");
        },
        error = function () {
        };
      ModalService.dreamSipChangeOptionModal(portfolioDetails, success, error);
      }
      if(actionType == 'Change Target Scheme'){
        var success = function () {
          // alert("done");
         },
         error = function () {
         };
       ModalService.changeTargetSchemeModal(portfolioDetails, success, error);
      }
    }

    function pauseTransaction(transactionRow) {
      var transactionType=sanitizedType(transactionRow.type);
      var payload = {
        transactionId: transactionRow.transactionID,
        transactionType: transactionType || transactionRow.type,
      }
      var success = function (resp) {
          LoaderService.hideLoader('.loader');
          if (resp.data && resp.statusCode) {
            vm.summaryReview = resp.data;
            localStorage.setItem('summaryDetails', $window.JSON.stringify(vm.summaryReview));
            $state.go('main.sipPause');
          }
          else {
            vm.summaryReview = null;
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
        },
        error = function (err) {
          vm.summaryReview = null;
          LoaderService.hideLoader('.loader');
          MessageService.error(err.message);
          $state.go('main.sipcorner');
        };
      LoaderService.showLoader('.loader');
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'pause',
        child2: 'summary'
      },payload).$promise.then(success, error);
    }

    vm.callPanService = function (investorInfo, transactionType, portfolioDetails) {
      LoaderService.showLoader('.sipCorner');
      var success = function (resp) {
        LoaderService.hideLoader('.sipCorner');
        if (resp.status && resp.data) {
          var taxIdentifierInfo = resp.data;
          if (investorInfo.minor && !investorInfo.gpanValid) {
            MessageService.error("Guardian's PAN is not verified for selected investor");
          } else if (!investorInfo.minor && !taxIdentifierInfo.verify) {
            MessageService.error("KYC verification is pending for selected investor");
          } else {
            vm.initiateTransaction(transactionType, portfolioDetails);
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('.sipCorner');
        UtilService.errorHandler(err);
      };
      InvestorsService.post({
        controller: 'pan',
        child1: 'verify'
      }, {
        pan: investorInfo.panNumber
      }).$promise.then(success, error);
    };

    vm.initiateTransaction = function (transactionType, portfolioDetails) {

      var data = {investorInfo: portfolioDetails, portfolioDetails: portfolioDetails, from: 'investor-portfolio'};
      StoreInvestorModel.setInvestorDetail(data);
      switch (transactionType) {
        case 'Switch' :
          $state.go('main.transactions.initiate.switch', {
            uuid: portfolioDetails.investorId,
            folioNumber: portfolioDetails.folioNumber,
            schemeCode: portfolioDetails.schemeCode
          });
          break;
        case 'SWP' :
          $state.go('main.transactions.initiate.swp', {
            uuid: portfolioDetails.investorId,
            folioNumber: portfolioDetails.folioNumber,
            schemeCode: portfolioDetails.schemeCode
          });
          break;
        case 'STP' :
          $state.go('main.transactions.initiate.stp', {
            uuid: portfolioDetails.investorId,
            folioNumber: portfolioDetails.folioNumber,
            schemeCode: portfolioDetails.schemeCode
          });
          break;
        case 'Redeem' :
          $state.go('main.transactions.initiate.redeem', {
            uuid: portfolioDetails.investorId,
            folioNumber: portfolioDetails.folioNumber,
            schemeCode: portfolioDetails.schemeCode
          });
          break;
      }
    };

    vm.changeStatusType = function () {
      resetDefaults();
      reInitPayload();
      vm.getSystematicList(systematicPayload);
    };

    vm.searchList = function () {

      if (!vm.isSearching && (vm.searchText.length > 3 || vm.searchText == '')) {
        vm.isSearching = true;
        vm.getSystematicList(systematicPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.investorDetails = function (_investor) {
      $state.go('main.investors.profile.portfolio', {investorId: _investor.investorId});
    };

    vm.cancelThisTransaction = function (transactionRow) {
      var success = function (resp) {
          LoaderService.hideLoader('.sipCorner');
          if (resp.status) {
            ModalService.systematicCancellation(resp);
          } else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
        },

        error = function (err) {
          LoaderService.hideLoader('.sipCorner');
          UtilService.errorHandler(err);
        }
      var transactionType=sanitizedType(transactionRow.type);
      var payload = {
          transactionId: transactionRow.transactionID,
          transactionType: transactionType||transactionRow.type,
          folioNumber: transactionRow.folioNumber,
          amount: transactionRow.amount,
          frequency: transactionRow.autoFrequency,
          schemeCode: transactionRow.schemeCode
        }

      LoaderService.showLoader('.sipCorner');
      TransactionService.post({
        VERSION: HDFC_API.VERSION,
        controller: 'systematic',
        child2: 'cancel'
      }, payload).$promise.then(success, error);
    }
    function sanitizedType(type){
      var trType;
      type = angular.copy(type);
      switch (type){
        case 'Flex STP':
          trType='STPFLEX';
          break;
        case 'Flex Index':
          trType = 'FLEXINDEX';
          break;
        case 'SMART SWAP':
          trType = 'SMART_SWAP';
          break;
        case 'SIP_TOP_UP':
          trType = 'SIP';
          break;
        case 'DREAM SIP':
          trType = 'DREAMSIP';
          break;
        default:
          trType=type;
      }
      return trType;
    }


    vm.goToTopup = function (transactionData) {
      $state.go('main.transactions.initiate.siptopup', {transactionData: transactionData});

    }

    /* Systematic corner start date and end date change function declared here*/
    vm.changeStartDate = function(date) {
      vm.dateFilter.startDate = date ? date: null;
      if (date) {
        calculateEndDate();
      }
      if (vm.dateFilter.startDate && systematicPayload.fromDate !== vm.dateFilter.startDate.format("DD-MMM-YYYY")) {
        reInitPayload();
        vm.getSystematicList(systematicPayload);
      }
    };

    vm.changeEndDate = function(date) {
      vm.dateFilter.endDate = date ? date: null;
      vm.startMaxDate = date ? date: vm.responseDate;
      if (!date) {
        vm.endMinDate = null;
      }
      if (vm.dateFilter.endDate && systematicPayload.toDate !== vm.dateFilter.endDate.format("DD-MMM-YYYY")) {
        reInitPayload();
        vm.getSystematicList(systematicPayload);
      }
    };

    /* Sip corner reset date filter function declared here*/
    vm.resetDateFilter = function() {
      vm.changeStartDate(null);
      vm.changeEndDate(null);
      reInitPayload();
      vm.viewDate = vm.startMaxDate.clone();
      vm.getSystematicList(systematicPayload);
    };

    function calculateEndDate() {
      if (!vm.dateFilter.endDate) {
        vm.dateFilter.endDate = vm.endMaxDate;
      }
      vm.endMinDate = vm.dateFilter.startDate;
      vm.enabledEndDatesList = [];
      var diff = vm.endMaxDate.diff(vm.dateFilter.startDate, 'days');
      for (var i = 0; i <= diff; i++) {
        var indexDate = vm.dateFilter.startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
        vm.enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
      }
    }

    function cancelSip(transactionRow) {

      var transactionType=sanitizedType(transactionRow.type);
      var cancelSummaryDetails = {
        transactionId: transactionRow.transactionID,
        transactionType: transactionType||transactionRow.type,
        folioNumber: transactionRow.folioNumber,
        amount: transactionRow.amount,
        frequency: transactionRow.autoFrequency,
        schemeCode: transactionRow.schemeCode,
        schemeName: transactionRow.schemeName,
        option: transactionRow.growth ? 'GROWTH' : 'Income Distribution cum Capital Withdrawal (IDCW)',
        IDCW_OPTION:	transactionRow.dividendReinvestmentApplicable ? 'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option' : 'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option',
        startDate :  transactionRow.startDate,
        endDate :  transactionRow.endDate,
        topUpDetails: transactionRow.topupDetails,
        paymentOption : transactionRow.paymentOption && transactionRow.paymentOption.length > 0 ? transactionRow.paymentOption : null,
        sipWithFirstInstallment : transactionRow.sipWithFirstInstallment ? transactionRow.sipWithFirstInstallment : false,
        sipWithFiData : transactionRow.firstInstallmentDetails ? transactionRow.firstInstallmentDetails : null
      }

      localStorage.setItem('summaryDetailsSipCancel', $window.JSON.stringify(cancelSummaryDetails));
      $state.go('main.sipCancel');


    }

    vm.checkPanAdharLinking = function(investor , index , actionLength) {
      var successHandler = function(resp) {
        vm.systematicListData[index].panAdharLinked = true;
        vm.systematicListData[index].ispanAdharLinkedChecked = true;
      }

      var errorHandler = function(resp) {
        vm.systematicListData[index].panAdharLinked = false;
        vm.systematicListData[index].ispanAdharLinkedChecked = true;
      }

      if(!vm.systematicListData[index].panAdharLinked && actionLength !== 0) {
       panAdharLinkingService.checkPanAdharStatus(investor.pan,investor.folioNumber,vm.brokerCode).then(successHandler).catch(errorHandler);
      }

    }


  }
})();

/**
 * Created by ttn on 26/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('SchemeCalculatorController', schemeCalculatorController);

  /** @ngInject */
  function schemeCalculatorController($window, UtilService, LoaderService, AuthService, $interval, $scope, MessageService) {

    var vm = this;
    vm.promise = null;
    vm.init = function () {
      var url = 'https://mfiframes.mutualfundsindia.com/hdfc_sip/HDFCSIP.aspx';
      angular.element('#DBox').attr('src', url);
      vm.promise = $interval(function () {
        var identifierData = AuthService.getToken();
        if (!identifierData || !identifierData.arnCode) {
          MessageService.error('Unable to get arnCode');
          return;
        }
        var success = function (resp) {
          if (!resp || !resp.status) {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          UtilService.errorHandler(err);
        };
        AuthService.isInitialLogin(identifierData.arnCode).then(success, error);
      }, 90000);

    };

    $scope.$on("$destroy", function () {
      $interval.cancel(vm.promise);
    });

    var iframe = $window.document.getElementById('DBox');
    var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      LoaderService.showLoader();
    // Check if loading is complete
    if (  iframeDoc.readyState  == 'complete' ) {
      LoaderService.hideLoader();
    }

    /*angular.element('#DBox').ready(function () {
      LoaderService.showLoader();
    });
    angular.element('#DBox').load(function () {
      LoaderService.hideLoader();
    });*/

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ResourcesCalculatorsController', resourcesCalculatorsController);

  /** @ngInject */
  function resourcesCalculatorsController() {
    var vm = this;
    vm.init = init;
    vm.openIframe = openIframe;
    vm.currCalculator = 'sip_calculator';


    function init() {
      openIframe('sip_calculator');
    }


    function openIframe(iframeType) {

      vm.currCalculator = iframeType;

      switch (iframeType){

        case 'sip_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-sip.aspx';
          break;

        case 'goalsip_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-goal-sip.aspx';
          break;

        case 'topupsip_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-topup-sip.aspx';
          break;

        case 'inflation_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-inflation.aspx';
          break;

        case 'presentvalue_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-present-value.aspx';
          break;

        case 'futurevalue_calculator':
          vm.iframeUrl = 'http://www.hdfcmfinvestwise.com/calculators/calculator-future-value.aspx';
          break;

      }

      angular.element('#iframeBox').attr('src',vm.iframeUrl);
    }


  }
})();

/**
 * Created by ttn on 28/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('ReportsModel', reportsModel);

  /** @ngInject */
  function reportsModel() {

    function investorChartModel(data) {

      var keyMap={'allInvestor':'Total Investors','cgfInvestor':'CGF Investors','minorInvestor':'Minor Investors'};

      //var obj={categories:[],columns:[],count:0,tickValue:[]};
      var obj={categories:[],columns:[]};
      var tempArr=[];
      for(var a in data){
        var arr=[];
        arr.push(keyMap[a]);
        if(data[a]) {
          for (var i = 0; i < data[a].length; i++) {
            if (obj.categories.indexOf(data[a][i].month) == -1) {
              obj.categories.push(data[a][i].month);
            }
            arr.push(data[a][i].count);
            tempArr.push(data[a][i].count);
          }
        }
        obj.columns.push(arr);
      }
     /* if(tempArr.length>0) {

        tempArr = tempArr.filter(function (item, pos, self) {
          return self.indexOf(item) == pos;
        });
        tempArr=tempArr.sort();
        var max = Math.max.apply(null, tempArr);
        max = parseInt(max);
        if(max>=9){
        max = max.toString();
        var tempnum = '1';
        for (i = 0; i < max.length; i++) {
          tempnum = tempnum + '0';
        }
        if (parseInt(tempnum) < parseInt(max)) {
          tempnum = parseInt(tempnum) * (parseInt(max.charAt(0)) + 1).toString();
        }

        var loopcount = 5;
        tempArr = [];
        for (var j = 0; j <= loopcount; j++) {
          tempArr.push((parseInt(tempnum) / 5) * j);
        }
      }
        obj.tickValue = tempArr;
        obj.count = tempArr.length;
      }
      */
      return obj;
    }

    function systematicInvestorChartModel(data) {
      var keyMap={'allSIPRegister':'Total SIP','sipExpired':'SIP Completed','sipCeased':'SIP Ceased'};

      //var obj={categories:[],columns:[],count:0,tickValue:[]};
      var obj={categories:[],columns:[]};
      var tempArr=[];
      for(var a in data) {
        var arr = [];
        arr.push(keyMap[a]);
        if(data[a]) {
        for (var i = 0; i < data[a].length; i++) {
          if (obj.categories.indexOf(data[a][i].month) == -1) {
            obj.categories.push(data[a][i].month);
          }
          arr.push(data[a][i].amount);
          tempArr.push(data[a][i].amount);
        }
      }
        obj.columns.push(arr);
      }

      // if(tempArr.length>0) {
      //   tempArr = tempArr.filter(function (item, pos, self) {
      //     return self.indexOf(item) == pos;
      //   });
      //   var max=Math.max.apply(null, tempArr);
      //   max=parseInt(max);
      //   max=max.toString();
      //   var tempnum='1';
      //   for(i=0;i<max.length-1;i++)
      //   {
      //     tempnum=tempnum+'0';
      //   }
      //   if(parseInt(tempnum)<parseInt(max)){
      //     var t=(parseInt(tempnum)*parseInt(max.charAt(0)))+(parseInt(tempnum)/10 * (parseInt(max.charAt(1)) + 1));
      //     if(t> parseInt(max)){
      //       tempnum=t;
      //     }
      //     else {
      //       tempnum = parseInt(tempnum) * (parseInt(max.charAt(0)) + 1).toString();
      //     }
      //   }
      //
      //   var loopcount=5;
      //   tempArr=[];
      //   for(var j=0;j<=loopcount;j++){
      //     tempArr.push((parseInt(tempnum)/5)*j);
      //   }
      //   obj.tickValue = tempArr;
      //   obj.count = tempArr.length;
      //
      // }
      return obj;
    }

    function lumpsumInvestorChartModel(data) {
      // var keyMap={'lumpsumAmount':'Net Sale Lumpsum Investment','maturedAmount':'Funds Mature'};
      var keyMap={'maturedAmount':'Funds Mature'};

      //var obj={categories:[],columns:[],count:0,tickValue:[]};
      var obj={categories:[],columns:[]};
      var tempArr=[];
      for(var a in data){
        var arr=[];
        arr.push(keyMap[a]);
        if(data[a]) {
          for (var i = 0; i < data[a].length; i++) {
            if (obj.categories.indexOf(data[a][i].month) == -1) {
              obj.categories.push(data[a][i].month);
            }
            arr.push(data[a][i].amount);
            tempArr.push(data[a][i].amount);
          }
        }
        obj.columns.push(arr);
      }
      // if(tempArr.length>0) {
      //   tempArr = tempArr.filter(function (item, pos, self) {
      //     return self.indexOf(item) == pos;
      //   });
      //   var max=Math.max.apply(null, tempArr);
      //   max=parseInt(max);
      //   max=max.toString();
      //   var tempnum='1';
      //   for(i=0;i<max.length-1;i++)
      //   {
      //     tempnum=tempnum+'0';
      //   }
      //   if(parseInt(tempnum)<parseInt(max)){
      //     var t=(parseInt(tempnum)*parseInt(max.charAt(0)))+(parseInt(tempnum)/10 * (parseInt(max.charAt(1)) + 1));
      //     if(t> parseInt(max)){
      //       tempnum=t;
      //     }
      //     else {
      //       tempnum = parseInt(tempnum) * (parseInt(max.charAt(0)) + 1).toString();
      //     }
      //   }
      //   var loopcount=5;
      //   tempArr=[];
      //   for(var j=0;j<=loopcount;j++){
      //     tempArr.push((parseInt(tempnum)/5)*j);
      //   }
      //   obj.tickValue = tempArr;
      //   obj.count = tempArr.length;
      // }
      return obj;

    }

    return {
      investorChartModel:investorChartModel,
      systematicInvestorChartModel:systematicInvestorChartModel,
      lumpsumInvestorChartModel:lumpsumInvestorChartModel
    }

  }
})();

/**
 * Created by ttn on 28/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ReportsController', reportsController);

  /** @ngInject */
  function reportsController($window, ModalService, MessageService, ReportsService, DownloadReportsService, ReportsModel, UtilService, LoaderService) {

    var vm = this;

    vm.hideCHart = false;
    vm.reportData = {
      ioToDate: '',
      ioFromDate: '',
      sioToDate: '',
      sioFromDate: '',
      lioToDate: '',
      lioFromDate: '',
      ioSelectedDate: '',
      sioSelectedDate: '',
      lioSelectedDate: '',
      dateList: [],
      ioReportUrls: '',
      sioReportUrls: '',
      lioReportUrls: ''
    };
    vm.downloadBrockerageReport = downloadBrockerageReport;
    vm.investorChart, vm.systematicInvestorChart, vm.lumpsumInvestorChart = {};
    
    $window.onresize = function () {
      vm.investorChart.resize();
      vm.systematicInvestorChart.resize();
      vm.lumpsumInvestorChart.resize();
    };


    function fetchInvestorReport() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var data = ReportsModel.investorChartModel(resp.data);
            data.bindto = '#investor-overview';
            data.pattern = ['#00c0f2', '#103880', '#2485bd'];
            data.xAxis = {text: ''};
            data.yAxis = {text: 'No. of Investors'};
            data.key = 'count';
            vm.investorChart = UtilService.getBarChart(data);
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      ReportsService.post({
        controller: 'investors'
      }, {fromDate: vm.reportData.ioFromDate, toDate: vm.reportData.ioToDate}).$promise.then(success, error);
    }

    function fetchSystematicInvestorReport() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var data = ReportsModel.systematicInvestorChartModel(resp.data);
            data.bindto = '#syatematic-investor-overview';
            data.pattern = ['#00c0f2', '#103880', '#2485bd'];
            data.xAxis = {text: ''};
            data.yAxis = {text: 'Amount'};
            data.key = 'money';
            vm.systematicInvestorChart = UtilService.getBarChart(data);
          }
          else {
            MessageService.error(resp.message);
          }

        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      ReportsService.post({
        controller: 'SIP'
      }, {fromDate: vm.reportData.sioFromDate, toDate: vm.reportData.sioToDate}).$promise.then(success, error);
    }

    function fetchLumpsumInvestorReport() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var maturedAmountData = resp.data.maturedAmount;
            if(maturedAmountData && maturedAmountData.length == 0){
              var data = ReportsModel.lumpsumInvestorChartModel([]);
              data.bindto = '#lumpsum-investor-overview';
              data.pattern = ['#00c0f2', '#103880'];
              data.xAxis = {text: ''};
              data.yAxis = {text: 'Amount'};
              data.key = 'money';
              vm.lumpsumInvestorChart = UtilService.getBarChart(data);
            }else{
              resp.data = {
                maturedAmount :maturedAmountData
              }
              var data = ReportsModel.lumpsumInvestorChartModel(resp.data);
              data.bindto = '#lumpsum-investor-overview';
              data.pattern = ['#00c0f2', '#103880'];
              data.xAxis = {text: ''};
              data.yAxis = {text: 'Amount'};
              data.key = 'money';
              vm.lumpsumInvestorChart = UtilService.getBarChart(data);
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      ReportsService.post({
        controller: 'lumpsum'
      }, {fromDate: vm.reportData.lioFromDate, toDate: vm.reportData.lioToDate}).$promise.then(success, error);

    }

    function fetchInvestorReportUrls() {
      var success = function (resp) {
          LoaderService.hideLoader();
          resp = resp.data || {};
          if (resp.status && resp.data) {
            if (resp.data.reportDTO) {
              vm.reportData.ioReportUrls = resp.data.reportDTO;
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      DownloadReportsService.fetchApiUrlForReports('investor', 'listing').then(success, error);
    }

    function fetchSystematicInvestorReportUrls() {
      var success = function (resp) {
          LoaderService.hideLoader();
          resp = resp.data || {};
          if (resp.status && resp.data) {
            if (resp.data.reportDTO) {
              vm.reportData.sioReportUrls = resp.data.reportDTO;
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      DownloadReportsService.fetchApiUrlForReports('sip', 'listing').then(success, error);
    }

    function fetchLumpsumInvestorReportUrls() {
      var success = function (resp) {
          LoaderService.hideLoader();
          resp = resp.data || {};
          if (resp.status && resp.data) {
            if (resp.data.reportDTO) {
              vm.reportData.lioReportUrls = resp.data.reportDTO;
            }
          }
          else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      DownloadReportsService.fetchApiUrlForReports('lumpsum', 'listing').then(success, error);
    }

    function fetchMonthList() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            if (resp.data.length) {
              resp.data = resp.data.reverse();
              vm.reportData.dateList = resp.data;
              vm.reportData.ioSelectedDate = resp.data[0];
              vm.reportData.sioSelectedDate = resp.data[0];
              vm.reportData.lioSelectedDate = resp.data[0];
              var date = resp.data[0].split('-');
              vm.reportData.ioToDate = date[1] + '-' + '03-01';
              vm.reportData.ioFromDate = date[0] + '-' + '04-01';
              vm.reportData.sioToDate = date[1] + '-' + '03-01';
              vm.reportData.sioFromDate = date[0] + '-' + '04-01';
              vm.reportData.lioToDate = date[1] + '-' + '03-01';
              vm.reportData.lioFromDate = date[0] + '-' + '04-01';
            }
            else {
              var now = new Date();
              vm.reportData.ioToDate = now.getFullYear() + '-' + '03-01';
              vm.reportData.ioFromDate = (now.getFullYear() - 1) + '-' + '04-01';
              vm.reportData.sioToDate = now.getFullYear() + '-' + '03-01';
              vm.reportData.sioFromDate = (now.getFullYear() - 1) + '-' + '04-01';
              vm.reportData.lioToDate = now.getFullYear() + '-' + '03-01';
              vm.reportData.lioFromDate = (now.getFullYear() - 1) + '-' + '04-01';
            }

            fetchInvestorReport();
            fetchSystematicInvestorReport();
            fetchLumpsumInvestorReport();
            fetchInvestorReportUrls();
            fetchSystematicInvestorReportUrls();
            fetchLumpsumInvestorReportUrls();
          }
          else {
            vm.reportData.dateList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      ReportsService.post({
        controller: 'financialYear'
      }, {}).$promise.then(success, error);

    }

    vm.init = function () {
      fetchMonthList();
    };

    vm.ioDateChanged = function () {
      if (vm.reportData.ioSelectedDate) {
        var date = vm.reportData.ioSelectedDate.split('-');
        vm.reportData.ioToDate = date[1] + '-' + '03-01';
        vm.reportData.ioFromDate = date[0] + '-' + '04-01';
        fetchInvestorReport();
      }
    };

    vm.sioDateChanged = function () {
      if (vm.reportData.sioSelectedDate) {
        var date = vm.reportData.sioSelectedDate.split('-');
        vm.reportData.sioToDate = date[1] + '-' + '03-01';
        vm.reportData.sioFromDate = date[0] + '-' + '04-01';
        fetchSystematicInvestorReport();
      }
    };

    vm.lioDateChanged = function () {
      if (vm.reportData.lioSelectedDate) {
        var date = vm.reportData.lioSelectedDate.split('-');
        vm.reportData.lioToDate = date[1] + '-' + '03-01';
        vm.reportData.lioFromDate = date[0] + '-' + '04-01';
        fetchLumpsumInvestorReport();
      }
    };

    vm.downloadReport = function (downloadUrl, fileName) {
      var payload;
      if (fileName === 'All Investors Report') {
        payload = {"commonReportCO":{"generateType":""},"requestCO":{"filters":{"fromDate":"","otmOption":"ALL","investorSubType":["ALL"],"investorType":"ALL","sortKey":"investorName","sortValue":"ASC","status":"","toDate":"","transactionNature":"ALL"}}}
        ModalService.sendFileDownloadModal({downloadUrl: downloadUrl, fileName: fileName, payload:payload});
      }else {
        ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName, payload:payload});
      }
    };

    function downloadBrockerageReport() {
      // MessageService.warning('This Page is under Maintenance');
      ModalService.brokerageDownloadModal({});
    }


  }
})();

/**
 * Created by ttn on 29/01/24.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('NewRegistrationModal', newRegistrationModal);

  /** @ngInject */
  function newRegistrationModal() {

    var registrationObj={
      contactInfoMsg : ''
    };

    function getRegistrationModal() {
      return angular.copy(registrationObj);
    }

    function setRegistrationModal(val) {
      registrationObj=val;
    }

    return {
      getRegistrationModal:getRegistrationModal,
      setRegistrationModal:setRegistrationModal
    }

  }
})();

/**
 * Created by ttn on 6/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('RegistrationController', registrationController);

  /** @ngInject */
  function registrationController($stateParams, $state, $timeout, AuthService, AppConstants, LoaderService, MessageService, ModalService,toastr,toastrConfig, $scope, UtilService, $window, $document, NewRegistrationModal) {
    var vm = this;
    vm.date = new Date();
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.myRecaptchaResponse = '';
    vm.otpVerificationPayload = {
      otpNumber: "",
      registrationRequestId: ''
    };
    vm.signupForm = {};
    vm.inputReset = false;
    vm.otpForm = {};
    vm.signupUser = {
      arnCode: "",
      bankAccountNumber: "",
      emailAddress: "",
      mobileNumber: ""
    };
    vm.termsAndConditions = false;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.processFlag = false;
    vm.processOTPFlag = false;
    vm.otpResendMessage = '';
    vm.errorMessage = '';
    // vm.termsAndContitions = termsAndContitions;
    vm.activeTab = {basic: false, otp: false, lineclass: 'step1'};
    vm.count = 0;
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.contrast = contrast;
    vm.dynamicInfo=dynamicInfo;
    vm.noteAmfiCircular=null;
    vm.notePreLogin=null;
    vm.goBack = goBack;
    vm.otpValIndex1 = '';
    vm.otpValIndex2 = '';
    vm.otpValIndex3 = '';
    vm.otpValIndex4 = '';
    vm.otpValIndex5 = '';
    vm.otpValIndex6 = '';
    vm.otpValChanged = otpValChanged;
    vm.formData = {};
    vm.showCaptcha = false;

    vm.Init = function () {
      dynamicInfo();
      switch ($state.current.name) {
        case 'registration.main':
          vm.activeTab.basic = true;
          vm.activeTab.otp = false;
          vm.activeTab.lineclass = 'step1';
          break;
        case 'registration.otp':
          vm.activeTab.basic = true;
          vm.activeTab.otp = true;
          vm.activeTab.lineclass = 'step2';
          vm.formData = NewRegistrationModal.getRegistrationModal();
          break;
        case 'registration.success':
          vm.activeTab.basic = true;
          vm.activeTab.otp = true;
          vm.activeTab.lineclass = 'step2';
          break;
      }
    };

    /** color contrast */

    function contrast (){
      vm.contrastt = !vm.contrastt;
      if(vm.contrastt){
        document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }
    function changedFont(valType){
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 55% !important");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 65% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove('newBigFont');
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }

    vm.resetValues = function () {
      vm.otpResendMessage = '';
      vm.errorMessage = '';
      vm.otpValIndex1 = '';
      vm.otpValIndex2 = '';
      vm.otpValIndex3 = '';
      vm.otpValIndex4 = '';
      vm.otpValIndex5 = '';
      vm.otpValIndex6 = '';
      vm.otpVerificationPayload.otpNumber = ''
      vm.otpCodeLength = 0;
    };

    vm.generateOtp = function () {
      var success = function (resp) {
          LoaderService.hideLoader('.popup');
          if (resp.status && resp.data) {
            vm.formData.contactInfoMsg = resp.data.msg ? resp.data.msg : null;
            NewRegistrationModal.setRegistrationModal(vm.formData);
            $state.go('registration.otp', {registrationRequestId: resp.data.registrationRequestId});
            bindEvent();
          } else {
            vm.processFlag = true;
            toastrConfig.preventDuplicates = false;
            toastr.error(resp.message, '', {
              onHidden: function () {
                vm.processFlag = false;
                toastrConfig.preventDuplicates = true;
              }
            });
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.popup');
          vm.processFlag = false;
          MessageService.error(err && err.message || AppConstants.ToastrMessage.FAILED);
          // vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        },
        payload = {
          arnCode: 'ARN-' + vm.signupUser.arnCode,
          bankAccountNumber: vm.signupUser && vm.signupUser.bankAccountNumber ? AuthService.encryptRSA(angular.copy(vm.signupUser.bankAccountNumber)) : "",
          emailAddress: vm.signupUser && vm.signupUser.emailAddress ? AuthService.encryptRSA(angular.copy(vm.signupUser.emailAddress)) : "",
          mobileNumber: vm.signupUser && vm.signupUser.mobileNumber ? AuthService.encryptRSA(angular.copy(vm.signupUser.mobileNumber)) : "" ,
          termsAndConditions: vm.termsAndConditions
        };
      if(vm.showCaptcha){
        payload.gRecaptchaResponse = vm.myRecaptchaResponse//vcRecaptchaService.getResponse()
      }

      vm.errorMessage = '';
      LoaderService.showLoader('.popup');
      AuthService.generateOtp(payload).then(success, error);
    };

    vm.reGenerateOtp = function () {
      var success = function (resp) {
        vm.processOTPFlag = false;
        if(resp.message === "SUCCESS") {
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.success('OTP sent again successfully.', '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
          resetTimer();
          vm.resetValues();
        }
        // vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
        if(resp.message !="SUCCESS") {
          vm.processOTPFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.message, '', {
            onHidden: function () {
              vm.processOTPFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
        }
      }, error = function (err) {
        // vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        vm.processOTPFlag = true;
        toastrConfig.preventDuplicates = false;
        toastr.error(err.message, '', {
          onHidden: function () {
            vm.processOTPFlag = false;
            toastrConfig.preventDuplicates = true;
          }
        });
      };
      vm.errorMessage = '';
      vm.inputReset = true;
      $timeout(function () {
        vm.inputReset = false;
      });
      vm.otpResendMessage = '';
      AuthService.reGenerateOtp($stateParams.registrationRequestId).then(success, error);
    };

    vm.verifyOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader('.popup');
        if (resp.status && resp.data) {
          $state.go('registration.success');
        } else {
          vm.processFlag = true;
          toastrConfig.preventDuplicates = false;
          toastr.error(resp.message, '', {
            onHidden: function () {
              vm.processFlag = false;
              toastrConfig.preventDuplicates = true;
            }
          });
        }
      }, error = function (err) {
        LoaderService.hideLoader('.popup');
        vm.processFlag = true;
        toastrConfig.preventDuplicates = false;
        toastr.error(err.message, '', {
          onHidden: function () {
            vm.processFlag = false;
            toastrConfig.preventDuplicates = true;
          }
        });
      };
      vm.otpVerificationPayload.otpNumber = vm.otpVerificationPayload.otpNumber.toString() + "";
      vm.otpVerificationPayload.registrationRequestId = $stateParams.registrationRequestId;
      var verifyOtp = {
        otpNumber : vm.otpVerificationPayload && vm.otpVerificationPayload.otpNumber ? AuthService.encryptRSA(angular.copy(vm.otpVerificationPayload.otpNumber.toString())) : '',
        registrationRequestId :vm.otpVerificationPayload.registrationRequestId ? vm.otpVerificationPayload.registrationRequestId : ''
      }
      delete vm.otpVerificationPayload.__proto__;
      vm.errorMessage = '';
      AuthService.verifyEncryptOtp(verifyOtp).then(success, error);
    };

    vm.termsAndContitions = function () {
      ModalService.termConditionModal();
    };

    vm.confirmCancel = function (from) {
      var success = function () {
        if (from === 'otp') {
          $state.go('registration.main')
        } else {
          $state.go('login')
        }
      };
      ModalService.confirmCancelModal({}, success);
    }

    function resetTimer() {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
    }
    function dynamicInfo() {
      var successHandler = function(resp) {
        if(resp){
          vm.noteAmfiCircular=resp.noteDTO.noteDTOMap.Note_AMFI_Circular;
          vm.notePreLogin=resp.noteDTO.noteDTOMap.Note_Pre_Login;
        }
      }
      UtilService.fetchDynamicData("PRE_LOGIN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function otpValChanged() {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();
      vm.otpVerificationPayload.otpNumber = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.otpVerificationPayload.otpNumber.toString().length;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next && next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next = next.nextElementSibling;
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev && prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev = prev.previousElementSibling;
              prev.focus();
              break;
            }
          }
        }
      }
    }

    function bindEvent() {
      $timeout(function() {
        var inputs = document.querySelectorAll(".input-code-container input");
        inputs.forEach(function(input, index) {
          input.addEventListener("paste", function(e) {
            var data = e.clipboardData.getData("text");
            var value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach(function(input, index) {
                input.value = value[index];
              });
            }
          });
        });
      });
    }

    function goBack() {
      $window.history.back();
    }
  }

})();

/**
 * Created by ttn on 27/12/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NotificationController', notificationController);

  /** @ngInject */
  function notificationController(LoaderService, NotificationService, MessageService, ModalService, UtilService) {

    var vm = this;

    vm.notificationData = {};
    vm.init = init;

    var months = {
      'Jan': 0,
      'Feb': 1,
      'Mar': 2,
      'Apr': 3,
      'May': 4,
      'Jun': 5,
      'Jul': 6,
      'Aug': 7,
      'Sep': 8,
      'Oct': 9,
      'Nov': 10,
      'Dec': 11
    };

    function sortEvent(arr) {
      var today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setHours(0);
      today.setMilliseconds(0);
      var todayDate = today.getTime();
      var lastSevenDays = ((new Date()).getTime()) - (7 * 24 * 60 * 60 * 1000);
      var notificatioArr = {today: [], lastsevendays: [], history: []};
      arr.filter(function (item) {
        var dateArr = item.createdDate.split(' ');
        var dateMonthArr = dateArr[0].split('-');
        var date = new Date(parseInt(dateMonthArr[2]), parseInt(months[dateMonthArr[1]]), parseInt(dateMonthArr[0]), 0, 0, 0, 0);
        item.timestamp = date.getTime();
        if (item.timestamp == todayDate) {
          notificatioArr.today.push(item);
        }
        else if (item.timestamp < todayDate && item.timestamp >= lastSevenDays) {
          notificatioArr.lastsevendays.push(item);
        }
        else {
          notificatioArr.history.push(item);
        }
        return item;
      });
      return notificatioArr;
    }

    function init() {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.notificationData = sortEvent(resp.data.notificationList);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      NotificationService.post({
        controller: 'allNotification'
      }, {}).$promise.then(success, error);
    }

    vm.notificationDetails = function (notification) {
      ModalService.notificationDetailModal(notification);
    };

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('OtmListController', otmListController);

  /** @ngInject */
  function otmListController(AuthService, MessageService, LoaderService, $window, UtilService, ModalService, InvestorsService) {
    var vm = this;
    vm.PAGE_LIMITS = [10,15];
    vm.totalUnregisteredListData = 0;
    vm.currentPage = 1;
    vm.pageLimit = 10;
    vm.isLoading = false;
    vm.downloadForm = downloadForm;

    vm.getUnregisteredInvestorsList = getUnregisteredInvestorsList;
    vm.openFolioDetails= openFolioDetails;

    vm.init = function () {
      getUnregisteredInvestorsList()
    };

    function getUnregisteredInvestorsList() {
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
      }

      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.unregisteredInvestorsListData = resp.data.investorList;
            vm.totalUnregisteredListData = vm.unregisteredInvestorsListData.length;
            vm.isPagination = !!(vm.unregisteredInvestorsListData && vm.unregisteredInvestorsListData.length);
          } else {
            vm.unregisteredInvestorsListData = null;
            vm.totalUnregisteredListData = 0;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
          vm.isLoading = false;
          // vm.sortOrder.searchText = '';
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPagination = false;
        };

      var unregisteredInvestorsListPayload = {
        pageIndex: vm.currentPage - 1,
        pageLimit: vm.pageLimit
      };
      InvestorsService.post(
        {
          controller: 'list',
          child1: 'otm',
          child2: 'unregistered'
      }, unregisteredInvestorsListPayload).$promise.then(success, error);
    }

    function openFolioDetails(folio) {
      var success=function () {

      }, error = function () {

      };
      ModalService.nonOtmFolioDetailsModal({folio:folio}, success, error)
    }

    function downloadForm() {
      $window.open('https://files.hdfcfund.com/s3fs-public/2018-04/OTM_Mandate_Editable_Jan2017_24012017.pdf');
    }

  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .config(newInverstorRoute);
    /** @ngInject */
    function newInverstorRoute($stateProvider) {
      // MAIN-ROUTE
      $stateProvider 
      .state('newinvestorApprove.folio', {
        url:'/folio/:uuid',
        templateUrl: 'app/new-investor-approve/folio/folio.html',
        controller: '',
        controllerAs: ''
      })
      .state('newinvestorApprove.folio.soleApplicant', {
        url:'/soleApplicant?contact',
        templateUrl: 'app/new-investor-approve/folio/folio.html',
        controller: 'FolioController',
        controllerAs: 'Folio'
      })
      .state('newinvestorApprove.folio.income', {
        url:'/income',
        templateUrl: 'app/new-investor-approve/folio/income/income.html',
        controller: 'IncomeController',
        controllerAs: 'Income'
      })
      .state('newinvestorApprove.folio.bank', {
        url:'/bank?contact',
        templateUrl: 'app/new-investor-approve/folio/bank/bank.html',
        controller: 'BanksController',
        controllerAs: 'Banks'
      })
      .state('newinvestorApprove.folio.nominee', {
        url:'/nominee',
        templateUrl: 'app/new-investor-approve/folio/nominee/nominee.html',
        controller: 'NomineeController',
        controllerAs: 'Nominee'
      })
      .state('newinvestorApprove.folio.summary', {
        url:'/summary?contact',
        templateUrl: 'app/new-investor-approve/folio/summary/summary.html',
        controller: 'SummaryController',
        controllerAs: 'Summary'
      })
      .state('newinvestorApprove.folio.reject', {
        url:'/reject',
        templateUrl: 'app/new-investor-approve/folio/summary/reject.html',
      }) 
      .state('newinvestorApprove.folio.JointHolderDetails', {
        url:'/JointHolder',
        templateUrl: 'app/new-investor-approve/folio/holder-details/holder-details.html',
        controller: 'JointHolderController',
        controllerAs: 'JointHolder'
      })
      .state('newinvestorApprove.transaction', {
        url:'/transaction/:uuid/payment',
        templateUrl: 'app/new-investor-approve/payment/new-investor-payment.html',
        controller: 'NewInvestorPaymentController',
        controllerAs: 'NewInvestorPayment'
      })


    }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NewInvestorApproveController', NewInvestorApproveController);

  /** @ngInject */
  function NewInvestorApproveController($state, HDFC_API, ModalService, UtilService, LoaderService, FolioApproval, $stateParams, $rootScope, MessageService,InvestorModel,$window,FolioApprovalUpdateContact) {
    var vm = this;
    vm.init = init;
    vm.isContactUpdate = $stateParams.contact;

    vm.init();
    function init() {
      $rootScope.myState = $state.current.url;
      vm.uuid = $stateParams.uuid;
      vm.uniqueLink = vm.uuid;
      sessionStorage.setItem('unicLinkID',vm.uniqueLink);
      sessionStorage.setItem('newJourney','NewInvestorJourney');
     if($rootScope.myState != '/holder'){
      if($rootScope.myState == '/soleApplicant'|| $rootScope.myState == '/summary' || $rootScope.myState == '/bank' || $rootScope.myState == '/reject' || $rootScope.myState == '/soleApplicant?contact' || $rootScope.myState == '/bank?contact' || $rootScope.myState == '/summary?contact'){
        if (vm.uuid) {
          var success = function (resp) {
            if (resp.status && resp.data) {
              LoaderService.hideLoader();
              initiateOtpModal(resp.data);
            } else {
              MessageService.error(resp.message)
            }
          },
            error = function (err) {
              LoaderService.hideLoader();
              UtilService.errorHandler(err);
            };
            var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
            sessionStorage.removeItem('folioBank');
            LoaderService.showLoader();
          if (vm.isContactUpdate) {
            FolioApprovalUpdateContact.get({
              VERSION: version,
              controller: 'otp',
              child2: vm.uniqueLink,
              child3: true
            }, null).$promise.then(success, error);
          } else {
            FolioApproval.get({
              VERSION: version,
              controller: 'otp',
              child2: vm.uniqueLink,
              child3: true
            }, null).$promise.then(success, error);
          }
        }
      }
     }
    }
    function initiateOtpModal(data) {
      vm.folioCreationProcess = sessionStorage.getItem('folioCreationProcess');
      vm.folioDetails = JSON.parse(sessionStorage.getItem('folioDetails'));
      vm.folioNumber = localStorage.getItem('folioNumber');
      if(vm.folioCreationProcess == 'Completed' && vm.folioNumber && vm.folioDetails.folioWithoutTransaction == 'N'){
        $window.location.href = HDFC_API.PROTOCOL + HDFC_API.PATH + "/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
        // $window.location.href ="http://localhost:3000/newinvestorApprove" + "/transaction/" + $stateParams.uuid + "/payment";
      }
      var successOtpModal = function(resp) {
        sessionStorage.setItem('folioDetails', JSON.stringify(resp));
        vm.isLoaded = true;
        InvestorModel.setHolderlinkId(resp.holderLinkId);
        InvestorModel.setInvestorId(resp.id);
        if (vm.isContactUpdate) {
          $state.go('newinvestorApprove.folio.bank', {
            contact : true
          });
        } else {
          $state.go('newinvestorApprove.folio.bank');
        }
      }, errorOtpModal = function(resp) {
        MessageService.error(resp.message);
      };

      var modalData = {
        uniqueLink: vm.uniqueLink,
        type: 'soleApplicant'
      }

      if (vm.isContactUpdate) {
        modalData.contactUpdate = vm.isContactUpdate,
        modalData.updateContactMessage1 = data.otpSentMsg,
        modalData.updateContactMessage2 = data.otpSentMsg2,
        modalData.uniqueLink1 = data.secretLink,
        modalData.uniqueLink2 = data.secretLink2
      }

      ModalService.folioCreationOtpModal(modalData, successOtpModal, errorOtpModal);
    }
  }
})();

(function () {
    'use strict';
    angular
      .module('hdfc-mf-distributor-web')
      .config(newInverstorRoute);
    /** @ngInject */
    function newInverstorRoute($stateProvider) {
      // MAIN-ROUTE
      $stateProvider
      .state('main.newinvestor.kycverify', {
        url:'/kycverify',
        templateUrl: 'app/new-investor/kyc-verification/kyc-verification.html',
        controller: 'KycVerificationController',
        controllerAs: 'KycVerification'
      })
      .state('main.newinvestor.folioCreation', {
        url:'/folioCreation',
        templateUrl: 'app/new-investor/folio-creation/folio-creation.html',
        controller: 'NewFolioCreationController',
        controllerAs: 'NewFolioCreation'
      })
      .state('main.newinvestor.investmentDetails', {
        url:'/investmentDetails',
        templateUrl: 'app/new-investor/investment-detail/investment-detail.html',
        controller: 'InvestmentDetailController',
        controllerAs: 'InvestmentDetail'
      })
      .state('main.newinvestor.investmentDetails.select-scheme', {
        url:'/select-scheme',
        templateUrl: 'app/new-investor/investment-detail/scheme-details/scheme-investment-goal.html',
        controller: 'SchemeInvestmentController',
        controllerAs: 'SchemeInvestment'
      })
      // MAINROUTE END
      .state('main.newinvestor.folioCreation.folioDetails', {
        url:'/folio-basic-details',
        templateUrl: 'app/new-investor/folio-creation/folio-basic-details/folio-basic-details.html',
        controller: 'FolioBasicDetailsController',
        controllerAs: 'FolioBasicDetails',
      })
      .state('main.newinvestor.folioCreation.folioMinorDetails', {
        url:'/folio-basic-minor-details',
        templateUrl: 'app/new-investor/folio-creation/folio-basic-minor/folio-basic-minor.html',
        controller: 'FolioBasicMinorDetailsController',
        controllerAs: 'FolioBasicMinorDetails',
      })
      .state('main.newinvestor.folioCreation.folioIncomeDetails', {
        url:'/folio-income-details',
        templateUrl: 'app/new-investor/folio-creation/folio-income-details/folio-income-details.html',
        controller: 'FolioIncomeDetailsController',
        controllerAs: 'FolioIncomeDetails',
      })
      .state('main.newinvestor.folioCreation.folioNomineeDetails', {
        url:'/folio-nominee-details',
        templateUrl: 'app/new-investor/folio-creation/folio-nominee-details/folio-nominee-details.html',
        controller: 'FolioNomineeDetailsController',
        controllerAs: 'FolioNomineeDetails',
      })
      .state('main.newinvestor.folioCreation.guardianMinorDetails', {
        url:'/folio-guardian-minor-details',
        templateUrl: 'app/new-investor/folio-creation/folio-basic-minor-guardian/folio-basic-minor-guardian.html',
        controller: 'FolioMinorGuardianDetailsController',
        controllerAs: 'FolioMinorGuardianDetails'
      })
      .state('main.newinvestor.folioCreation.folioSummaryDetails', {
        url:'/folio-Summary-details',
        templateUrl: 'app/new-investor/folio-creation/summary/summary-page.html',
        controller: 'SummaryPageController',
        controllerAs: 'SummaryPage',
      })
      .state('main.newinvestor.folioCreation.bankdetails', {
        url:'/bankdetails',
        templateUrl: 'app/new-investor/folio-creation/bank-details/bank-details.html',
        controller: 'BankDetailsController',
        controllerAs: 'BankDetails'
      })
      .state('main.newinvestor.folioCreation.jointholder', {
        url:'/jointholder',
        templateUrl: 'app/new-investor/folio-creation/folio-holder-details/folio-holder-details.html',
        controller: 'FolioJointHolderDetailsController',
        controllerAs: 'FolioJointHolderDetails'
      })
      .state('main.newinvestor.investmentDetails.amount', {
        url:'/amount-detail',
        templateUrl: 'app/new-investor/investment-detail/amount-details/amount-details.html',
        controller: 'AmountDetailsController',
        controllerAs: 'AmountDetails'
      })
      .state('main.newinvestor.investmentDetails.investmentMode', {
        url:'/Investment-mode',
        templateUrl: 'app/new-investor/investment-detail/investment-mode/investment-mode.html',
        controller: 'InvestmentModeController',
        controllerAs: 'InvestmentMode'
      })
      .state('main.newinvestor.investmentDetails.select-scheme.scheme', {
        url:'/choose-scheme',
        templateUrl: 'app/new-investor/investment-detail/scheme-details/select-scheme/select-scheme.html',
        controller: 'SelectSchemeController',
        controllerAs: 'SelectScheme'
      })
      .state('main.newinvestor.investmentDetails.select-scheme.goal', {
        url:'/investment-goal',
        templateUrl: 'app/new-investor/investment-detail/scheme-details/investment-goal/investment-goal.html',
        controller: 'InvestmentGoalController',
        controllerAs: 'InvestmentGoal'
      })
    }
  })();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('NewInvestorController', newInvestorController);

  /** @ngInject */
  function newInvestorController($state,AppConstants, $rootScope, AuthService, LoaderService, InvestorServiceDynamicData,dynamicData,$window) {
    var vm = this;
    vm.dynamicData = dynamicData;
    vm.init = init;
    vm.init();
    vm.backStateList = AppConstants.BACK_ROUTE;
    vm.folioBackStat = AppConstants.BACK_ROUTE2;
    vm.folioBackStateAnyor = AppConstants.BACK_ROUTE3;
    vm.folioBackStateMinor = AppConstants.BACK_ROUTE4;
    $rootScope.showSidebar = true;
    function init() {
       $rootScope.myState = $state.current.url;
       if($rootScope.myState == '/kycverify'){
        localStorage.removeItem("skipInvestmentDetails");
       }
       var skipInvestmentDetails = localStorage.getItem("skipInvestmentDetails");
       if(skipInvestmentDetails && $rootScope.myState != '/kycverify'){
        $rootScope.testObj = {
          steps: [{
            step: 1,
            name: "KYC Verification",
            expanded: true,
            stepActive: false,
            investorName: '',
            panNumber: '',
            stepCompleted: true
          },
          {
            step: 2,
            name: "Folio Creation",
            expanded: true,
            stepActive: true,
            stepCompleted: false
          }]
        }
       }else{
      if(dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info) {
        vm.dynamicDataForTaxStatus = dynamicData.noteDTO.noteDTOMap.Note_Tax_Status_Info.content;
      }
        $rootScope.testObj = {
          steps: [{
            step: 1,
            name: "KYC Verification",
            expanded: true,
            stepActive: true,
            investorName: '',
            panNumber: '',
            stepCompleted: false
          }, {
            step: 2,
            name: "Investment Details",
            expanded: true,
            stepActive: false,
            schemeName: '',
            frequency: '',
            schemeInfo: {
              amount: null,
              investmentType: ''
            },
            stepCompleted: false
          },
          {
            step: 3,
            name: "Folio Creation",
            expanded: true,
            stepActive: false,
            stepCompleted: false
          }]
        }
        }

    }

    $rootScope.folioBackButton = function () {
      sessionStorage.setItem("investorIsBackButtonClick", true);
      var backData = sessionStorage.getItem('folioStateData');
      if ($state.current.url == "/folio-basic-details" || $state.current.url == "/folio-basic-minor-details") {
        sessionStorage.setItem('folioStateData', 'BACK_ROUTE');
        $state.go('main.newinvestor.investmentDetails.amount');
      } else {
        switch (backData) {
          case 'BACK_ROUTE':
            // Investment details
            vm.backStateList.forEach(function (item, Length) {
              if ($state.current.url == item.url && $state.current.url != "/schemedetails") {
                $state.go(vm.backStateList[Length - 1].state);
              }
              $rootScope.currentstate = $state.current.url;
            });
            break;
          case 'BACK_ROUTE2':
            // self single
            vm.folioBackStat.forEach(function (item, Length) {
              if ($state.current.url == item.url && $state.current.url != "/folio-basic-details") {
                $state.go(vm.folioBackStat[Length - 1].state);
              }
              $rootScope.currentstate = $state.current.url;
            });
            break;
          case 'BACK_ROUTE3':
            // any or survivor
            vm.folioBackStateAnyor.forEach(function (item, Length) {
              if ($state.current.url == item.url && $state.current.url != "/folio-basic-details") {
                $state.go(vm.folioBackStateAnyor[Length - 1].state);
              }
              $rootScope.currentstate = $state.current.url;
            });
            break;
          case 'BACK_ROUTE4':
            // minor
            vm.folioBackStateMinor.forEach(function (item, Length) {
              if ($state.current.url == item.url && $state.current.url != "/folio-basic-minor-details") {
                $state.go(vm.folioBackStateMinor[Length - 1].state);
              }
              $rootScope.currentstate = $state.current.url;
            });
            break;
          default:

        }
      }
    }
    $rootScope.updateSideBarSteps = function(){
      var uContext = JSON.parse($window.sessionStorage.getItem("verifyObj"));
      $rootScope.testObj = {
        steps: [{
          step: 1,
          name: "KYC Verification",
          expanded: true,
          stepActive: false,
          investorName: uContext.name,
          panNumber: uContext.pan,
          stepCompleted: true
        },
        {
          step: 2,
          name: "Folio Creation",
          expanded: true,
          stepActive: true,
          stepCompleted: false
        }]
      }
      setTimeout(function(){
        $rootScope.showSidebar = true;
      },50);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MobileController', mobileController);

  function mobileController() {
    var vm = this;
  }
})();

/**
 * Created by ttn on 14/07/20.
 */
(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MandateRegistrationController', mandateRegistrationController);

  /** @ngInject */
  function mandateRegistrationController ($stateParams, $state, LoaderService, $timeout, $sce, BrowserService, $window, HDFC_API, $rootScope, UtilService, MessageService, ModalService, TransactionService, AppConstants , dynamicData , DistributorGenericService) {
    var vm  = this;
    vm.uniqueLink = $stateParams.uniqueLink;
    vm.ekycData = {};
    vm.formData = {};
    vm.authModeSelect = {};
    vm.actionUrl = "";
    vm.isLoaded = false;
    vm.date = new Date();
    vm.ischecked = false;
    vm.ischeckedAgain = false;
    vm.transactionStatus = false;
    vm.init = init();
    vm.dynamicNoteEmandate = dynamicData.noteDTO.noteDTOMap.Note_Register_Emandate_SmartLink;
    vm.changeBank = changeBank;
    /*
    * function responsible for initialising all variable on component init.
    */
    function init() {
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      if (!vm.uniqueLink) {
        return;
      }
      /*
      * condition to check the user navigator agent
      * if user navigator agent not match with the supported browser than redirect to browser support page.
      */
      if (BrowserService.browserDetector()) {
        return;
      }

      LoaderService.showLoader();
      vm.uniqueLink = $stateParams.uniqueLink;
      vm.summaryType = "E-MANDATE";
      performActionOnInitiation();
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General_EMANDATE && vm.termsConditionData.TNC_General_EMANDATE.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });
    }

    /**
     * Function responsible to request for OTP and generate OTP modal
     */
    function performActionOnInitiation() {
      LoaderService.hideLoader(); //temp changes
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          initiateOTPModal();
        } else {
          MessageService.error(resp.message)
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      TransactionService.get({
        VERSION: version,
        controller: 'otp',
        uniqueLink: vm.uniqueLink
      }, null).$promise.then(success, error);
    }

    function initiateOTPModal() {
      var success = function(response) {
        vm.isLoaded = true;
        setEmandateFormValues(response);
      }, failure = function(resp) {
        MessageService.error(resp.message)
      };
      ModalService.otpForApprovalModal({
        backdrop: 'static',
        summaryType: vm.summaryType,
        uniqueLink: vm.uniqueLink
      }, success, failure);
    }

    function setEmandateFormValues(response) {
      vm.emandateData = response;
      fetchBankList();
    }

    vm.showTermsAndCondition = function(type) {
      if (type === 'first') {
        ModalService.termsAndConditionsEMandateModal({});
      } else {
        ModalService.termConditionModal({});
      }
    };

    vm.viewLater = function() {
      var success = function () {
        vm.isActionPerformed = true;
        ModalService.genericSuccessModal({
          text: AppConstants.VIEW_LATER_SUCCESS
        });
      },
      error = function (msg) {
        $log.info(msg)
      };
      var msg = {};
      msg.Text = 'You can view this transaction request later to process it further';
      ModalService.confirmCancelModal(msg, success, error);
    };

    vm.initiateSummary = function(status) {
      if (status === 'reject') {
        vm.transactionStatus = false;
        vm.rejectReason = "";
        var successReject = function(resp) {
          vm.rejectReason = resp;
          performSubmission();
        }, rejectFailure = function() {
        };
        ModalService.rejectTransactionModal({
          uniqueLink: vm.uniqueLink,
          summaryType: vm.summaryType
        }, successReject, rejectFailure);
      } else if (status === 'approve') {
        vm.transactionStatus = true;
        performSubmission();
        /*var approveSuccess = function(resp) {
          if (resp) {

          }
        }, approveFailure = function() {
        }
        ModalService.confirmMandateModal({
          bankName: vm.emandateData.bankName
        }, approveSuccess, approveFailure);*/
      }
    };

    function performSubmission() {
      LoaderService.showLoader();
      var payload = createPayloadForSubmission();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          if (!vm.transactionStatus) { //to check whether user has initiated reject request.
            MessageService.success(response.data.message);
            vm.isActionPerformed = true;
          } else {
            handleEmandateSuccessResponse(response.data.message);
          }
        } else {
          if(response.popupEnabled) {
            ModalService.genericModal({
              text: response.message
            });
          } else {
            MessageService.error(response.message);
          }
        }
      }, error = function(response) {
        LoaderService.hideLoader();
        MessageService.error(response.message);
      };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      TransactionService.post({
        VERSION: version,
        controller: 'otp',
        child2: 'emandate',
        child3: 'action',
        uniqueLink: vm.uniqueLink
      }, payload).$promise.then(success, error);
    }

    function createPayloadForSubmission() {
      var payload = {
        "accNumber": vm.formData.bankInfo.accountNumber,
        "approved": vm.transactionStatus,
        "authenticationMode": vm.authModeSelect.value,
        "bankName": vm.formData.bankInfo.bankName,
        "brokerCode": vm.emandateData.brokerCode,
        "brokerName": vm.emandateData.brokerName,
        "maxAmount": vm.emandateData.maxAmount,
        "omEndDate": vm.emandateData.omEndDate,
        "omStartDate": vm.emandateData.omStartDate,
        "orderId": vm.emandateData.orderId,
        "rejectionReason": vm.rejectReason ? vm.rejectReason : '',
      };
      return payload;
    }

    function handleEmandateSuccessResponse(data) {
      if (!data) {
        MessageService.error();
        return;
      }
      $window.location.href="https://www.billdesk.in/billpay/APIEMandateController?action=APIEMandateHDFCOTMReg&msg="+data;
    }

    /**
     * Function responsible to get all the bank
     */
    function fetchBankList() {
      LoaderService.showLoader();
      var payload = {
        "folioNumber": vm.emandateData.folioNumber,
        "panNumber": vm.emandateData.panNumber
      };
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          if (resp.data.bannedInvestorFlag) {
            // $state.go('main.investors.profile.basicinfo',{investorId: vm.investorDetails.investorId});
            ModalService.genericModal({
              text: resp.data.bannedInvestorMsg
            })
          } else {
            vm.bankList = resp.data.bankList;
            vm.formData.bankInfo = vm.bankList.find(function (el) {
                return el.accountNumber === vm.emandateData.accNumber
            })

            if (vm.formData.bankInfo) {
              vm.authModes = vm.formData.bankInfo.authenticationModes;
              if (vm.emandateData.authMode) {
                vm.authModeSelect = vm.authModes.find(function (el) {
                  return el.code === vm.emandateData.authMode.code
                })
              }
            } else {
              if (vm.bankList.length === 1) {
                vm.formData.bankInfo = vm.bankList[0];
                vm.authModes = vm.formData.bankInfo.authenticationModes;
                vm.authModeSelect = vm.authModes[0];
              }
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      }, failure = function(resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };
      DistributorGenericService.post({
        controller: "bank",
        child1: "list",
        child2: 'emandate'
      }, payload).$promise.then(success, failure);
    }

    /**
     * Function responsible to handle the change bank action
     */
    function changeBank() {
      if (vm.formData.bankInfo) {
        vm.authModes = vm.formData.bankInfo.authenticationModes;
        vm.authModeSelect = vm.authModes[0];
      }
    };
  }
})();


(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MaintainanceController', maintainanceController);

  function maintainanceController($state) {
    $state.go('login');
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('MainController', mainController);

  /** @ngInject */
  function mainController($scope, $rootScope, $state, AuthService, $timeout, $window, UtilService, AppConstants,HDFC_API) {
    var vm = this;
    vm.HDFC_API=HDFC_API;
    var removeListeners = {}, isRefreshing = false;

    $scope.date = new Date();
    vm.isLoggedIn = false;
    vm.init = init;
    init();
    function init() {
      var identifier = AuthService.getToken();
      if (identifier && identifier.access_token) {
        vm.isLoggedIn = true;
      } else {
        vm.isLoggedIn = false;
      }
    }

    var resetFlag = function () {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    removeListeners["404"] = $rootScope.$on("404", function () {
      $state.go('404');
    });

    removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function (data) {
      if (isRefreshing) {
        return;
      }
      isRefreshing = true;
      var identifier = AuthService.getToken();//$cookies.get('token_data');
      if (!identifier || (data && data.error_description && data.error_description.indexOf('Invalid refresh token') > -1)) {
        resetFlag();
        AuthService.clearCookie();
        $state.go('login');
        return;
      }
      try {
        identifier = angular.fromJson(identifier);
      } catch (e) {
        identifier = '';
      }

      if (identifier && identifier.refresh_token) {
        AuthService.getRefreshToken(identifier).then(function () {
          resetFlag();
          $state.go('login');
        }, function () {
          resetFlag();
          $state.go('login');
        });
      } else {
        resetFlag();
        AuthService.clearCookie();
        $state.go('login');
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in removeListeners) {
        if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
          removeListeners[key]();
        }
      }
    });
    var listner = $rootScope.$on('openEcart', openSidebar);
    function openSidebar(screen,show) {
      if(show == "openEcartDetails"){
        showPopupScreen('ECART');
      } else if(show == "openAllFundsScreen"){
        showPopupScreen('ALL_FUNDS');
      }

    }

    function showPopupScreen(screen, item) {
      //vm.investorData = setInvestorData();
      switch (screen) {
        case 'INVEST_THROUGH':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = true;
          vm.showSideAllFunds = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'CART_DETAILS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
          vm.showSideBarCart = true;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.itemToBeEdited = item;
          vm.showAddCart = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'ALL_FUNDS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = true;
          vm.showAddCart = true;
          $scope.$broadcast('updatedTitle');
          break;
        case 'ECART':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ECART;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.showAddCart = false;
          vm.showSideBarEcart = true;
          $scope.$broadcast('updatedTitle');
          break;
      }
      expandSidebar();
    }

    function expandSidebar() {
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    $scope.$on('hidePostLoginSidebar',function (){
      vm.showSideBarCart = false;
      vm.showSideBarInvest = false;
      vm.showSideAllFunds = false;
      vm.showAddCart = false;
      vm.showSideBarEcart = false;
    });

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .directive('loginHeader', loginHeader);

  /** @ngInject */
  function loginHeader() {
    return ({
      restrict: 'E',
      templateUrl: 'app/components/header/headers/login-header.html',
      scope: {
        creationDate: '='
      },
      controller: loginController,
      controllerAs: 'vm',
      bindToController: true
    });

    /** @ngInject */
    function loginController(moment, $rootScope, $state, UtilService) {
      var vm = this;
      vm.contrast = contrast;
      vm.count = 0;
      vm.changedFont = changedFont;
      vm.date = new Date();
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
      /** color contrast */
      vm.toggleSidebar = toggleSidebar;
      vm.isDarkModeEnable = false;
      vm.toggleMode = toggleMode;
      vm.init = init;

      function changedFont(valType){
        UtilService.changedFont(valType);
        vm.count = UtilService.getCount();
      }

      function toggleSidebar() {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        vm.count = UtilService.getCount();
        angular.element(document.getElementById('login-sidebar')).toggle();
        angular.element(document.getElementsByClassName('login-affix side-nav')).toggleClass('add-width');
        $(window).resize(function() {
          document.getElementById('login-sidebar').style.removeProperty('display');
          angular.element(document.getElementsByClassName('login-affix side-nav')).removeClass('add-width');
        });
        $rootScope.$broadcast('toggleModeValueUpdate');
      }

      function contrast () {
        if(!vm.isDarkModeEnable){
          document.getElementsByTagName("body")[0].classList.remove("contrastClass");
        } else {
          document.getElementsByTagName("body")[0].classList.add("contrastClass");
        }
        $rootScope.$broadcast('isChangeBackgroundOfDonut', !vm.isDarkModeEnable);
      }

      function toggleMode(){
        UtilService.toggleMode();
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
      }

      function init() {
        vm.isDarkModeEnable = UtilService.isDarkModeEnabled();
        vm.count = UtilService.getCount();
        vm.isLogginState = $state.current.name === "login" ?  true : false;
      }
      vm.init();
      $rootScope.$on('toggleModeValueUpdateFromMobileSidebar', function () {
        vm.init();
      });
      $rootScope.$on('changeFontFromPreLoginMobileSidebar', function () {
        vm.init();
      });
      $rootScope.$on('changeFontPostLoginFromDesktopHeader', function () {
        vm.init();
      })
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($timeout, AuthService, ModalService,LoaderService, HDFC_API, toastr, $state, $window, $scope,
                           AppConstants, MessageService, UtilService, deviceDetector, $stateParams, $http, $sce, MetaTagService, $document, DistributorGenericServiceV2) {
    var vm = this;
    vm.resetCaptcha = false;
    vm.loginPayload = {
      arnCode: "",
      password: ""
    };
    vm.gRecaptchaResponse = '';
    vm.loginForm = {};
    vm.date = new Date();
    vm.loginUsingOtpFlag = false;
    vm.generateOtpFlag = true;
    vm.showOtpField = false;
    vm.loginProcessFlag = false;
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.RUNNING_MODE = AppConstants.RUNNING_MODE;
    vm.ENV = HDFC_API.ENV;
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.footerDate = new Date();
    vm.tipost = '';
    if(localStorage.getItem('loginMethod')){
      localStorage.removeItem('loginMethod');
    }
    var loginMethod = "ThroughPassword";
    var singleUseURL;
    vm.loginViaOtp = loginViaOtp;
    vm.loginViaPassword = loginViaPassword;
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.count = 0;
    vm.contrast = contrast;
    vm.showCaptcha = false;
    vm.isMactive = $stateParams.isMactive==="true"?true:null;
    vm.dynamicInfo=dynamicInfo;
    vm.noteAmfiCircular=null;
    vm.notePreLogin=null;
    vm.imageUrls = [
      {
        image: 'assets/images/logos/banner-background.svg',
        text: 'Get started with HDFC Mutual Fund online!',
        id: 1
      },
      {
        image: 'assets/images/logos/banner-background.svg',
        text: 'Get started with HDFC Mutual Fund online!',
        id: 2
      },
      {
        image: 'assets/images/logos/banner-background.svg',
        text: 'Get started with HDFC Mutual Fund online!',
        id: 3
      }
    ];
    vm.otpValIndex1 = '';
    vm.otpValIndex2 = '';
    vm.otpValIndex3 = '';
    vm.otpValIndex4 = '';
    vm.otpValIndex5 = '';
    vm.otpValIndex6 = '';
    vm.otpValChanged = otpValChanged;
    vm.verifyCodeOtp = '';
    vm.isEnable = AppConstants.ENABLE_EUIN;
    vm.euinPayload = {};
    vm.submitLogin = submitLogin;
    vm.passwordType = 'password';
    vm.showPasswordFlag = false;
    vm.showPassword = showPassword;
    vm.fetchCaptchaCount = fetchCaptchaCount;

    var successLogin = function (result) {
      LoaderService.hideLoader('.loader.main');
      // if(vm.loginPayload && vm.loginPayload.password){
      //   vm.loginPayload.password = '';
      // }
        vm.loginProcessFlag = false;
        if (result.access_token && result.access_token != "") {
          identifyOverseaArn();
          $state.go('home');
        } else {
          if (result && result.message) {
            MessageService.error(result.message);
          }
          if(vm.showCaptcha){
            vm.gRecaptchaResponse = "";
            vm.resetCaptcha=true;
            $timeout(function () {
              vm.resetCaptcha=false;
            });
            fetchCaptchaCount();
          }
        }
      },
      errorLogin = function (msg) {
        LoaderService.hideLoader('.loader.main');
        /*if(vm.loginPayload && vm.loginPayload.password){
          vm.loginPayload.password = '';
          $('#passwordId').focus();
        }*/
        vm.loginProcessFlag = false;
        vm.gRecaptchaResponse = "";
        vm.resetCaptcha=true;
        $timeout(function () {
          vm.resetCaptcha=false;
        });
        if(msg.message === 'Password Expired'){
          var payload = {arn : vm.loginPayload.arnCode, errMsg : msg.message};
          ModalService.changePasswordModal(payload);
        }

        if (msg && msg.message) {
          var messages = msg.message + '<span class="' + parseInt(new Date().getTime()) + '"></span>';
          toastr.error(messages, '', {
            allowHtml: true,
            preventDuplicates: false,
            onHidden: function () {
              vm.loginProcessFlag = false;
            }
          });
        } else {
          UtilService.errorHandler(msg);
        }
        fetchCaptchaCount();
      },
      successSignUpDone = function () {
        $state.go('login');
      },
      errorSignUpDone = function (msg) {
        MessageService.success(msg);
      },
      successOtpVerification = function (result) {
        ModalService.signUpDoneModal(result, successSignUpDone, errorSignUpDone);
      },
      errorOtpVerification = function (err) {
        UtilService.errorHandler(err);
      },
      successSignUp = function (result) {
        result = result.data ? result.data : result;
        result.backdrop = 'static';
        ModalService.otpVerificationModal(result, successOtpVerification, errorOtpVerification);
      },
      errorSignUp = function (err) {
        $window.document.getElementById('arnCodeId').focus();
        $window.document.getElementById('arnCodeId').blur();
        UtilService.errorHandler(err);
      },
      successForgotPassword = function (result) {
        ModalService.forgotPasswordDoneModal(result);
      },
      errorForgotPassword = function () {
        $window.document.getElementById('arnCodeId').focus();
        $window.document.getElementById('arnCodeId').blur();
      };

    init();

    function init() {
      $window.scrollTo(0,0);
      if(angular.isDefined($stateParams.a)){
        try {
          var action = $window.decodeURIComponent(escape($window.atob($stateParams.a?$stateParams.a:null)))
        }catch (e) {
          action = null;
        }

        if(action === "disable-arn"){
          vm.showCaptcha = false;
        }
      }

      MetaTagService.setMetaTags();
      dynamicInfo();
      $scope.$on('fundSelected', function(value, argument) {
        vm.schemeCode = argument;
      });
      if (vm.loginPayload.arnCode) {
        fetchCaptchaCount();
      }
    }

    /** color contrast */

    function contrast (){
      vm.contrastt = !vm.contrastt;
      if(vm.contrastt){
        document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }

    function changedFont(valType){
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 55% !important");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 65% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove('newBigFont');
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }

    function loginViaOtp() {
      (vm.loginUsingOtpFlag === false) && (vm.myRecaptchaResponse = '');
      vm.loginUsingOtpFlag = true;
      vm.generateOtpFlag = true;
      vm.showResendBtn=false;
      vm.showOtpField = false;
      vm.loginPayload.otp='';
      vm.sentOtpRespMsg = '';
      loginMethod = "OTP";
      vm.gRecaptchaResponse = vm.gRecaptchaResponse ? vm.gRecaptchaResponse : '';
      localStorage.setItem('loginMethod',loginMethod)
    }

    function loginViaPassword() {
      (vm.loginUsingOtpFlag === false) && (vm.myRecaptchaResponse = '');
      vm.loginUsingOtpFlag = false;
      vm.generateOtpFlag = true;
      vm.showOtpField = false;
      vm.sentOtpRespMsg = '';
      vm.gRecaptchaResponse = vm.gRecaptchaResponse ? vm.gRecaptchaResponse : '';
      loginMethod = "ThroughPassword"
    }

    vm.generateOtp = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.sentOtpRespMsg = resp.data.message;
          singleUseURL = resp.data.secretLink;
          vm.showOtpField = true;
          vm.generateOtpFlag = true;
          $timeout(function () {
            vm.resetCaptcha = true;
          });
          resetOtpInputFields();
          fetchCaptchaCount();
          bindEvent();
        } else {
          vm.showOtpField = false;
          $timeout(function () {
            vm.resetCaptcha = false;
          });
          fetchCaptchaCount();
          MessageService.error(resp.message);
        }
      },
      error = function (err) {
        vm.showOtpField = false;
        $timeout(function () {
          vm.resetCaptcha = false;
        });
        LoaderService.hideLoader();
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
        fetchCaptchaCount();
      };
      var payload = {};
      if(loginMethod === 'ThroughPassword' && vm.loginPayload && vm.loginPayload.password){
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          password: AuthService.encryptRSA(angular.copy(vm.loginPayload.password))
        };
      } else if(loginMethod === 'OTP') {
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          pan: AuthService.encryptRSA(angular.copy(vm.loginPayload.pan))
        };
      }

      if(vm.showCaptcha){
        payload.gRecaptchaResponse = vm.gRecaptchaResponse;
      }

      vm.errorMessage = '';
      vm.processFlag = true;
      LoaderService.showLoader();
      AuthService.generateOtp(payload, 'fromLogin').then(success, error);
    };

    var resetTimer = function () {
      $scope.$broadcast('timer-add-cd-seconds', vm.appConstants.RESEND_OTP_COUNTER);
      $timeout(function () {
        vm.otpResendMessage = '';
      },29000)
    }
    vm.reGenerateOtp = function () {

      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            singleUseURL = resp.data.secretLink;
            vm.loginPayload.otp = "";
            vm.generateOtpFlag = false;
            resetTimer();
            resetOtpInputFields();
          } else {
            MessageService.error(resp.message);
          }
        vm.otpResendMessage = 'OTP resent successfully. Please provide a valid OTP.';
        vm.errorMessage = resp.message || AppConstants.ToastrMessage.FAILED;
      }, error = function (err) {
          LoaderService.hideLoader();
        vm.errorMessage = err && err.message || AppConstants.ToastrMessage.FAILED;
          MessageService.error(vm.errorMessage);
      };
      var payload = {};
      if(loginMethod === 'ThroughPassword' && vm.loginPayload && vm.loginPayload.password){
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          password: AuthService.encryptRSA(angular.copy(vm.loginPayload.password)),
          secretLink : singleUseURL
        };
      } else if(loginMethod === 'OTP') {
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          pan: AuthService.encryptRSA(angular.copy(vm.loginPayload.pan)),
          secretLink : singleUseURL
        };
      }
      if(vm.showCaptcha){
        payload.gRecaptchaResponse = vm.gRecaptchaResponse;
      }
      vm.errorMessage = '';
      vm.processOTPFlag = true;
      vm.otpResendMessage = '';
      LoaderService.showLoader();
      AuthService.reGenerateOtp( null ,payload,'fromLogin').then(success, error);
    };


    vm.registerUser = function () {
      ModalService.signUpModal({}, successSignUp, errorSignUp);
    };

    vm.reset = function () {
      vm.loginPayload.password = '';
      vm.gRecaptchaResponse = '';
      vm.showCaptcha = false;
    };

    vm.reSendOTPPreAction = function(){
      vm.sentOtpRespMsg = '';
      vm.showOtpField=false;
      vm.showResendBtn=true;
      vm.myRecaptchaResponse='';
    }

    vm.forgotPassword = function () {
      // ModalService.forgotPasswordModal({}, successForgotPassword, errorForgotPassword);
      $state.go('forgotPassword')
    };

    vm.login = function () {
      if(loginMethod === 'ThroughPassword') {

        if(vm.loginPayload.password.length < 8){
          var msg = 'Minimum Length of Password is 8';
          ModalService.messagePasswordModal({Text:msg});
          return;
        }

        var patt = new RegExp(vm.appConstants.password_regex);
        var check = patt.test(vm.loginPayload.password);
        if (!check) {
          var msg = 'Seems like your present password contains one or more special characters that are disallowed according to the new security policy.' +
            ' Please update your password using the "forgot password" link.';
          ModalService.messagePasswordModal({Text:msg});
          return;
        }
      }
      var payload = {};
      if(loginMethod === 'ThroughPassword' && vm.loginPayload && vm.loginPayload.password){
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          password: vm.loginPayload && vm.loginPayload.otp ?  AuthService.encryptRSA(angular.copy(vm.loginPayload.otp.toString())) : ''
        }
      }
      else if(loginMethod === 'OTP') {
        payload = {
          arnCode: 'ARN-' + vm.loginPayload.arnCode,
          password: vm.loginPayload && vm.loginPayload.otp ?  AuthService.encryptRSA(angular.copy(vm.loginPayload.otp.toString())) : '',
          pan:vm.loginPayload && vm.loginPayload.pan ?  AuthService.encryptRSA(angular.copy(vm.loginPayload.pan)) : ''
        };
      }
      if(vm.gRecaptchaResponse){
        payload.gRecaptchaResponse = vm.gRecaptchaResponse;
      }

      vm.loginProcessFlag = true;
      $timeout(function() {
        LoaderService.showLoader('.loader.main');
        AuthService.login(payload,loginMethod, singleUseURL, vm.schemeCode).then(successLogin, errorLogin);
      });
    };
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;

    vm.widgetSelection = function () {
      $state.go('distributorempanellment.arn');
    };

    vm.browserForceUpdate = browserForceUpdate;
    vm.browserForceUpdate();
    function browserForceUpdate() {
      if (deviceDetector.browser == 'chrome' && parseInt(deviceDetector.browser_version, 10) < 60) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
      }

      else if (deviceDetector.browser == 'firefox' && parseInt(deviceDetector.browser_version, 10) < 50) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
      }

      else if (deviceDetector.browser == 'ms-edge' && parseInt(deviceDetector.browser_version, 10) < 16) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
      }

      else if (deviceDetector.browser == 'ie') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
      }
    }

    vm.getMaintenanceContent = function () {
      var _path = vm.appConstants.MAINTENANCE_CONTENT_URL,
        success = function (resp) {
          if(resp.status===200){
            if(resp.data && resp.data.data && resp.data.data.body){
              vm.mContent = $sce.trustAsHtml(resp.data.data.body);
            }
          }
        }, error = function () {};
      $http.get(_path).then(success, error);
    };

    /*
    * Oversea ARN identification and UI updates.
    * Responsible for identifying ARN and
    * */
    function identifyOverseaArn() {
      if (vm.appConstants.OVERSEA_ARN_REGEX.test(vm.loginPayload.arnCode)) {
        $window.sessionStorage.setItem("oversea_arn", true);
      } else {
        $window.sessionStorage.setItem("oversea_arn", false);
      }
    }
    function dynamicInfo() {
      var successHandler = function(resp) {
        if(resp){
          vm.noteAmfiCircular=resp.noteDTO.noteDTOMap.Note_AMFI_Circular;
          vm.notePreLogin=resp.noteDTO.noteDTOMap.Note_Pre_Login;
          vm.imageUrls = [];
          if (resp.imageDTO.imageDTOMap.Image_Pre_login) {
            var imageArray = JSON.parse(resp.imageDTO.imageDTOMap.Image_Pre_login.contentPath);
            if (imageArray.length > 0) {
              imageArray.forEach(function(image) {
                var obj = {
                  image: image,
                }
                vm.imageUrls.push(obj);
              });
              $timeout(function() {
                $('#banner').carousel();
              });
            }
          }
        }
      }
      UtilService.fetchDynamicData("PRE_LOGIN").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    function bindEvent() {
      $timeout(function() {
        var inputs = document.querySelectorAll(".input-code-container input");
        inputs.forEach(function(input, index) {
          input.addEventListener("paste", function(e) {
            var data = e.clipboardData.getData("text");
            var value = data.split("");
            if (value.length === inputs.length) {
              inputs.forEach(function(input, index) {
                input.value = value[index];
              });
            }
          });
        });
      });
    }

    /*
    * This function handled all single otp digit
    * */
    function otpValChanged(myvalue) {
      var num1 = angular.element($document[0].querySelector('#otp-number-input-1')).val();
      var num2 = angular.element($document[0].querySelector('#otp-number-input-2')).val();
      var num3 = angular.element($document[0].querySelector('#otp-number-input-3')).val();
      var num4 = angular.element($document[0].querySelector('#otp-number-input-4')).val();
      var num5 = angular.element($document[0].querySelector('#otp-number-input-5')).val();
      var num6 = angular.element($document[0].querySelector('#otp-number-input-6')).val();
      vm.loginPayload.otp = parseInt(num1 + num2 + num3 + num4 + num5 + num6);
      vm.otpCodeLength = vm.loginPayload.otp.toString().length;
      var container = document.getElementsByClassName("input-code")[0];
      container.onkeyup = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;

        if (myLength >= maxLength) {
          var next = target;
          while (next && next.nextElementSibling) {
            if (next == null)
              break;
            if (next.tagName.toLowerCase() == "input") {
              next = next.nextElementSibling;
              next.focus();
              break;
            }
          }
        } else if (myLength < maxLength) {
          var prev = target;
          while (prev && prev.previousElementSibling) {
            if (prev == null)
              break

            if (prev.tagName.toLowerCase() == "input") {
              prev = prev.previousElementSibling;
              prev.focus();
              break;
            }
          }
        }
      }
    }

    function submitLogin() {
      if(!vm.showOtpField && vm.generateOtpFlag) {
        vm.generateOtp();
      } else {
        vm.login();
      }
    }

    function resetOtpInputFields(){
      vm.otpValIndex1 = '';
      vm.otpValIndex2 = '';
      vm.otpValIndex3 = '';
      vm.otpValIndex4 = '';
      vm.otpValIndex5 = '';
      vm.otpValIndex6 = '';
      vm.otpCodeLength = vm.loginPayload && vm.loginPayload.otp ? vm.loginPayload.otp.toString().length: null;
    }

    function showPassword() {
      if (vm.showPasswordFlag) {
        vm.passwordType = 'password';
        vm.showPasswordFlag = false;
      } else {
        vm.passwordType = 'text';
        vm.showPasswordFlag = true;
      }
    }

    function fetchCaptchaCount() {
      LoaderService.showLoader();
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var unsuccessfulLoginAttemptCount = !resp.data.unsuccessfulLoginAttemptCount ? 0 : resp.data.unsuccessfulLoginAttemptCount;
          if (unsuccessfulLoginAttemptCount >= 3) {
            if (resp.data.locked || resp.data.blocked) {
              vm.showCaptcha = false;
            } else {
              vm.showCaptcha = true;
            }
          } else {
            vm.showCaptcha = false;
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var payload = {
        arnCode: 'ARN-' + vm.loginPayload.arnCode
      };
      DistributorGenericServiceV2.post({
        controller: 'unsuccessful',
        child1: 'login',
        child2: 'attempt',
        child3: 'count'
      }, payload).$promise.then(success, error);
    }

  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('LeapAcademyController', leapAcademyController);

  /** @ngInject */
  function leapAcademyController($log,LeapAcademyService, $state, AppConstants, LoaderService, MessageService, ModalService, DownloadPdfService, UtilService, moment, FileSaver, Blob) {
    var vm = this;
    vm.init = init;
    vm.getTrainingClassesData = getTrainingClassesData;
    vm.getPdfArticles = getPdfArticles;
    vm.limitChangedTC = limitChangedTC;
    vm.registerTC = registerTC;
    vm.getAgenda = getAgenda;
    vm.showVideo = showVideo;
    vm.downloadPdf = downloadPdf;
    vm.trainingClassesList = null;
    vm.pdfArticles = null;
    vm.isPaginationTC = false;
    vm.isPaginationPA = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.isLoading = false;
    vm.dateFilter = {startDate: null, endDate: null};

    vm.currentPageTC = 1;
    vm.currentPagePA = 1;
    vm.selectedPageLimitTC = vm.PAGE_LIMITS[0];
    vm.selectedPageLimitPA = vm.PAGE_LIMITS[0];
    vm.totalTrainingClassesData = 0;
    var trainingClassesPayload = {
      fromDate: "", //"dd-MMM-yyyy",
      toDate: "", //"dd-MMM-yyyy",
      pageIndex: vm.currentPageTC,
      pageLimit: vm.selectedPageLimitTC
    };

    var pdfArticlesPayload = {
      pageIndex: vm.currentPagePA,
      pageLimit: vm.selectedPageLimitPA
    };

    // vm.init();

    function init() {
      switch ($state.current.name) {
        case 'main.leapacademy.training-classes':
          vm.getTrainingClassesData(trainingClassesPayload);
          break;
        case 'main.leapacademy.pdf-articles':
          vm.getPdfArticles(pdfArticlesPayload);
          break;
      }
    }

    function limitChangedTC() {
      vm.currentPageTC = 1;
      trainingClassesPayload.pageIndex = vm.currentPageTC;
      trainingClassesPayload.pageLimit = vm.selectedPageLimitTC;
      vm.getTrainingClassesData(trainingClassesPayload);
    }
/*
    function limitChangedPA() {
      vm.currentPagePA = 1;
      pdfArticlesPayload.pageIndex = vm.currentPagePA;
      pdfArticlesPayload.pageLimit = vm.selectedPageLimitPA;
      vm.getPdfArticles(pdfArticlesPayload);
    };*/

    var resetDefaults = function () {
      vm.currentPageTC = 1;
      vm.totalTrainingClassesData = 0;
      vm.selectedPageLimitTC = vm.PAGE_LIMITS[0];
      vm.trainingClassesList = null;
      vm.isPaginationTC = false;
    };

    var reInitPayload = function () {
      trainingClassesPayload.fromDate = vm.dateFilter.startDate ? moment(vm.dateFilter.startDate).format('DD-MMM-YYYY').toString() : '';
      trainingClassesPayload.toDate = vm.dateFilter.endDate ? moment(vm.dateFilter.endDate).format('DD-MMM-YYYY').toString() : '';
      trainingClassesPayload.pageIndex = vm.currentPageTC;
      trainingClassesPayload.pageLimit = vm.selectedPageLimitTC;
    };

    vm.filterByDate = function (dateFilter) {

      if (dateFilter.startDate && dateFilter.endDate) {
        resetDefaults();
        if (new Date(dateFilter.startDate.toString()) == "Invalid Date") {
          MessageService.error('invalid start date');
        } else if (new Date(dateFilter.endDate.toString()) == "Invalid Date") {
          MessageService.error('invalid end date');
        } else if (+new Date(dateFilter.startDate.toString()) > +new Date(dateFilter.endDate.toString())) {
          MessageService.error('start date should not be greater than end date');
        } else {
          vm.dateFilter.startDate = dateFilter.startDate;
          vm.dateFilter.endDate = dateFilter.endDate;
          reInitPayload();
          vm.getTrainingClassesData(trainingClassesPayload);
        }
      } else {
        vm.dateFilter.startDate = dateFilter.startDate;
        vm.dateFilter.endDate = dateFilter.endDate;
        reInitPayload();
        vm.getTrainingClassesData(trainingClassesPayload);
      }
    };

    function downloadPdf(articles) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data) {
            /*var file = new Blob([resp.data], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);
            var link = $window.document.createElement("a");
            link.target = '_blank';
            link.download = articles.articleName;
            link.href = fileURL;

            $window.document.body.appendChild(link);
            link.style = "display: none";
            link.click();
            $window.document.body.removeChild(link);*/

            var data = new Blob([resp.data], { type: 'application/pdf' });
            FileSaver.saveAs(data, articles.articleName +'.pdf');
          } else {
            MessageService.error('No Data Available');
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      var payload = {articleId: articles.id};
      // DownloadReportsService.downloadFile(vm.modalData.downloadUrl,payload).then(success, error);
      DownloadPdfService.downloadFile(payload).then(success, error);
    }

    function getPdfArticles(pdfArticlesPayload) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.pdfArticles = resp.data.pdfArticles;
            vm.totalPdfArticles = resp.data.totalCount;
            vm.isPaginationPA = !!(vm.pdfArticles && vm.pdfArticles.length);
          } else {
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPaginationPA = false;
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      pdfArticlesPayload.pageIndex = vm.currentPagePA - 1;
      pdfArticlesPayload.pageLimit = vm.selectedPageLimitPA;
      LeapAcademyService.post({
        controller: 'leapacademy',
        child1: 'articles'
      }, pdfArticlesPayload).$promise.then(success, error);
    }

    function getTrainingClassesData(trainingClassesPayload) {
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            vm.trainingClassesList = resp.data.trainingClassesList;
            vm.totalTrainingClassesData = resp.data.totalCount;
            vm.isPaginationTC = !!(vm.trainingClassesList && vm.trainingClassesList.length);
          } else {
            MessageService.error(resp.message);
          }
          vm.isLoading = false;
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPaginationTC = false;
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      trainingClassesPayload.pageIndex = vm.currentPageTC - 1;
      trainingClassesPayload.pageLimit = vm.selectedPageLimitTC;
      LeapAcademyService.post({
        controller: 'leapacademy',
        child1: 'training',
        child2: 'classes'
      }, trainingClassesPayload).$promise.then(success, error);
    }

    function registerTC(data) {
      var success = function () {
        getTrainingClassesData(trainingClassesPayload);
      };
      ModalService.leapAcademyRegisterModal({name: 'registerModal', data: data}, success);
    }

    function getAgenda(data) {
      ModalService.leapAcademyAgendaModal({name: 'agendaModal', data: data});
    }

    function showVideo(url) {
      var success = function () {
        },
        error = function () {
        };
      ModalService.leapAcademyVideoModal({url: url}, success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('InvestorsController', investorsController);

  /** @ngInject */
  function investorsController(HDFC_API, InvestorsService, AuthService, $state, $stateParams, $timeout, LoaderService, AppConstants, MessageService, DownloadReportsService, ModalService, UtilService, $scope, $location, InvestorModel,InvestorServiceDynamicData,$window) {
    var vm = this;
    vm.isPagination = false;
    vm.date = new Date();
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.isLoading = false;
    vm.active = {0: true};
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.INVESTOR_INVESTORLIST_OTM_TYPE = AppConstants.INVESTOR_INVESTORLIST_OTM_TYPE;
    vm.TYPE = angular.copy(AppConstants.INVESTOR_INVESTORLIST_TYPE).splice(1, AppConstants.INVESTOR_INVESTORLIST_TYPE.length);
    vm.SUB_TYPE = angular.copy(AppConstants.INVESTOR_INVESTORLIST_SUB_TYPE).splice(1, AppConstants.INVESTOR_INVESTORLIST_SUB_TYPE.length);
    vm.selectedType = 'ALL';
    vm.selectedOTMType = vm.INVESTOR_INVESTORLIST_OTM_TYPE[0].value;
    vm.selectedSubType = ['ALL'];
    vm.isSearching = false;

    vm.totalInvestorsListData = 0;
    vm.currentPageInvestorsList = 1;
    vm.pageLimitInvestorsList = 25;

    vm.multiSettings = {displayProp: 'key', idProp: 'value', dynamicTitle: true};
    vm.subTypeTranslationTexts = {buttonDefaultText: 'Investor Sub Type (All)'};
    vm.typeTranslationTexts = {buttonDefaultText: 'Investor Type (All)'};
    vm.subTypeModel = [];
    vm.typeModel = [];
    vm.isCheck = false;
    vm.isPageNumber = false;
    vm.newinvestorAscendingOrder = false
    vm.analysisType = $state.params.analysisType ? $state.params.analysisType : '';
    if(vm.analysisType){
      if(vm.analysisType == "pending-list"){
        vm.tabs = [
          {key: 'Pending', active: false, action: "main.investors.list.pending"}
        ];
      }else{
        vm.tabs = [
          {key: 'Individual', active: true, action: "main.investors.list.individual"},
          {key: 'Non-Individual', active: false, action: "main.investors.list.non-individual"}
        ];
      }
    }else{
      vm.tabs = [
        {key: 'Individual', active: true, action: "main.investors.list.individual"},
        {key: 'Non-Individual', active: false, action: "main.investors.list.non-individual"},
        {key: 'Pending', active: false, action: "main.investors.list.pending"}
      ];
    }
    vm.defaultTab = "Individual"

    var identifierData = AuthService.getToken();
    if(identifierData && identifierData.loginType){
      vm.loginType = identifierData.loginType;
    }

    vm.sortOrder = {
      sortKey: 'investorName',
      sortValue: 'ASC',
      searchText: ''
    };
    vm.filterApplied = angular.fromJson(localStorage.getItem("filters"));

    $scope.$on('isPageNumber',function (event,value) {
      vm.isPageNumber = value;
    });
    $scope.$on('isCheck',function (event,value){
      vm.isCheck = value;
    })
    $scope.$on('filterApplied', function (event, value) {
      vm.filterApplied = value;
      vm.initInvestorList();
    });



    vm.initInvestorList = function (selectedType, selectedSubType) {
      var investorTyp = $state.current.url.replace('/','')
      LoaderService.showLoader();
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
      }

      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
          if (resp.data && resp.status) {
            resp.data.investorList && resp.data.investorList.forEach(function (item) {
              item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
              item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
            });
            vm.investorsListData = resp.data.investorList;
            vm.totalInvestorsListData = resp.data.totalCount;
            vm.isPagination = !!(vm.investorsListData && vm.investorsListData.length);
          } else {
            vm.investorsListData = null;
            vm.totalInvestorsListData = 0;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
          vm.isLoading = false;
          // vm.sortOrder.searchText = '';
          angular.element('select').trigger("blur");
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPagination = false;
        };
      vm.selectedType = selectedType ? selectedType : (angular.isDefined($stateParams.type) ? [($stateParams.type).toUpperCase()] : 'ALL');
      vm.analysisType = $state.params.analysisType ? $state.params.analysisType : '';
      vm.selectedSubType = selectedSubType ? selectedSubType : ['ALL'];

      if($scope.$parent.InvestorsList && $scope.$parent.InvestorsList.tabs[0].active) {
        vm.indivitualListingSearchText = localStorage.getItem("searchValue");
        if((vm.currentPageInvestorsList - 1 > 0 && vm.isCheck) || vm.isPageNumber || vm.indivitualListingSearchText) {
          var investorListPayload = {
            arnCode: identifierData.arnCode,
            //appType: 'W',
            filters: vm.filterApplied,
            pageLimit: vm.pageLimitInvestorsList,
            pageIndex: 0,
            searchText: vm.indivitualListingSearchText
          };
          vm.filterApplied.sortValue = vm.sortOrder.sortValue;
          vm.filterApplied.sortKey = vm.sortOrder.sortKey;
          vm.isCheck = false;
          vm.isPageNumber = false;
          vm.currentPageInvestorsList = 1;
        }else {
          var investorListPayload = {
            arnCode: identifierData.arnCode,
            //appType: 'W',
            filters: vm.filterApplied,
            pageLimit: vm.pageLimitInvestorsList,
            pageIndex: vm.currentPageInvestorsList - 1,
            searchText: vm.indivitualListingSearchText
          };
          vm.filterApplied.sortValue = vm.sortOrder.sortValue;
          vm.filterApplied.sortKey = vm.sortOrder.sortKey;
          vm.isCheck = false;
        }
      } else if($scope.$parent.InvestorsList && $scope.$parent.InvestorsList.tabs[1].active) {
       var investorListPayload = {
         arnCode: identifierData.arnCode,
         appType: 'W',
         filters: {
           fromDate: "",
           otmOption:vm.selectedOTMType,
           investorType: vm.selectedType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           investorSubType: vm.selectedSubType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           status: "",
           toDate: "", //"dd-MMM-yyyy",
           transactionNature: "ALL",  //vm.transactionNature //
           sortKey: vm.sortOrder.sortKey,
           sortValue: vm.sortOrder.sortValue

         },
         corporateFlag:true,
         pageIndex: vm.sortOrder.searchText==='' ? vm.currentPageInvestorsList - 1 : 0,
         pageLimit: vm.pageLimitInvestorsList,
         searchText: vm.sortOrder.searchText
       };
      }else if($scope.$parent.InvestorsList && $scope.$parent.InvestorsList.tabs[2].active) {
        vm.initInvestorPendingList();
            return;
      }
      if(vm.analysisType){
      investorListPayload.filters.todaysAnanlysisOption = vm.analysisType;
      }
      InvestorsService.post({controller: 'list'}, investorListPayload).$promise.then(success, error);

      fetchInvestorReportUrls();
    };

    vm.searchList = function () {
      if (vm.isSearching) {
        return;
      }
      else if (vm.sortOrder.searchText.length > 3 || vm.sortOrder.searchText == '') {
        vm.isSearching = true;
        vm.initInvestorList(vm.selectedType, vm.selectedSubType);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.typeChanged = function () {
      vm.initInvestorList(vm.selectedType, vm.selectedSubType);
    };

    vm.filterByHeader = function () {
      // vm.sortOrder.searchText = '';
      vm.sortOrder.sortValue = (vm.sortOrder.sortValue == 'ASC') ? 'DESC' : 'ASC';
      vm.analysisType ? vm.initInvestorAnalysisList() : vm.initInvestorList()
    };
    vm.searchByText = function (e) {
      vm.sortOrder.sortKey = 'investorName';
      vm.sortOrder.sortValue = 'ASC';
      var key = e.keyCode ? e.keyCode : e.which;
      if (key == 13) {
        vm.initInvestorList();
      }
    };

    vm.investorDetails = function (_investor) {
      $state.go('main.investors.profile.portfolio', {investorId: _investor.investorId});
    };

    vm.investorInitiateTransaction = function (_investor, transactionType) {
      switch (transactionType) {
        case 'SIP' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'Switch' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'SWP' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'STP' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'Redeem' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'DTP' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'FLEXINDEX' :
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'FLEXSTP':
          vm.validateInvestor(_investor, transactionType);
          break;
        case 'SMART_SWAP':
          vm.validateInvestor(_investor, transactionType);
          break;
      }
    };

    vm.validateInvestor = function (_investor, transactionType) {
      LoaderService.showLoader();
      var payload = {"investorUUID": _investor.investorId};

      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

          var investorInfo = resp.data;

          if (false && !resp.data.dob) { // dob check made disabled

            var success = function () {

              if (transactionType !== 'Redeem' && transactionType !== 'SWP') {
                vm.callPanService(investorInfo, _investor, transactionType);
              } else {
                switch (transactionType) {
                  case 'SWP' :
                    $state.go('main.transactions.initiate.swp', {uuid: _investor.investorId});
                    break;
                  case 'Redeem' :
                    $state.go('main.transactions.initiate.redeem', {uuid: _investor.investorId});
                    break;
                }
              }
            }, error = function () {

            }

            ModalService.updateDBInvestorModal({
              transactionType: transactionType,
              isUpdateInfo: true,
              uuid: _investor.investorId
            }, success, error);
          }else{{

            if (transactionType !== 'Redeem' && transactionType !== 'SWP') {
              vm.callPanService(investorInfo, _investor, transactionType);
            } else {
              switch (transactionType) {
                case 'SWP' :
                  $state.go('main.transactions.initiate.swp', {uuid: _investor.investorId});
                  break;
                case 'Redeem' :
                  $state.go('main.transactions.initiate.redeem', {uuid: _investor.investorId});
                  break;
              }
            }
          }
        }


        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text:resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
        LoaderService.hideLoader();
      };
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    };

    vm.callPanService = function (investorInfo, _investor, transactionType) {
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {

          var taxIdentifierInfo = resp.data;
          if (investorInfo.minor && !investorInfo.gpanValid) {
            MessageService.error("Guardian's PAN is not verified for selected investor");
          } else if (!investorInfo.minor && !taxIdentifierInfo.verify) {
            MessageService.error("KYC verification is pending for selected investor");
          } else {
            switch (transactionType) {
              case 'SIP' :
                $state.go('main.transactions.initiate.sip', {uuid: _investor.investorId});
                break;
              case 'Switch' :
                $state.go('main.transactions.initiate.switch', {uuid: _investor.investorId});
                break;
              case 'STP' :
                $state.go('main.transactions.initiate.stp', {uuid: _investor.investorId});
                break;
              case 'DTP' :
                $state.go('main.transactions.initiate.dtp', {uuid: _investor.investorId});
                break;
              case 'FLEXINDEX' :
                $state.go('main.transactions.initiate.flexindex', {uuid: _investor.investorId});
                break;
              case 'FLEXSTP' :
                $state.go('main.transactions.initiate.flexstp', {uuid: _investor.investorId});
                break;
              case 'SWINGSTP' :
                $state.go('main.transactions.initiate.swingstp', {uuid: _investor.investorId});
                break;
              case 'SMART_SWAP' :
                $state.go('main.transactions.initiate.smartswap', {uuid: _investor.investorId});
                break;
              case 'FLEXSIP' :
                $state.go('main.transactions.initiate.flexsip', {uuid: _investor.investorId});
                break;
              case 'INSTANT_REDEMPTION' :
                $state.go('main.transactions.initiate.instantredeem', {uuid: _investor.investorId});
                break;
              case 'DREAMSIP' :
                $state.go('main.transactions.initiate.dreamsip', {uuid: _investor.investorId});
                break;
            }
          }
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      LoaderService.showLoader();
      InvestorsService.post({
        controller: 'pan',
        child1: 'verify'
      }, {
        pan: investorInfo.panNumber
      }).$promise.then(success, error);
    };

    vm.downloadReport = function (downloadUrl, fileName) {
      ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName});
    };


    function fetchInvestorReportUrls() {
      var success = function (resp) {
          if (resp.status && resp.data) {
            if (resp.data.data && resp.data.data.reportDTO) {
              vm.ioReportUrls = resp.data.data.reportDTO;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      DownloadReportsService.fetchApiUrlForReports('investor', 'listing').then(success, error);
    }


    /*Multiselect code start*/
    vm.changeEvents = {
      onSelectionChanged: function () {
        vm.selectedSubType = vm.subTypeModel.map(function (ele) {
          return ele.id;
        });
        vm.selectedSubType = (vm.selectedSubType.length > 0)
          ? (vm.selectedSubType.length == vm.SUB_TYPE.length ? ['ALL'] : vm.selectedSubType)
          : ['ALL'];
        vm.selectedType = vm.typeModel.map(function (ele) {
          return ele.id;
        })[0];
        vm.selectedType = (vm.selectedType && vm.selectedType.length > 0)
          ? (vm.typeModel.length == vm.TYPE.length ? 'ALL' : vm.selectedType)
          : 'ALL';
        vm.initInvestorList(vm.selectedType, vm.selectedSubType);
      }
    };

    /*Multiselect code end*/

    vm.downloadReportList = function(fileName) {
      vm.individualListingSearchText = localStorage.getItem("searchValue");
      var type = $location.absUrl().split('/')[5];
      if(type === 'individuals') {
        vm.filterApplied = InvestorModel.getFilterPayload();
        var payload = {
          "commonReportCO": {
            "generateType": "pdf"
          },
          "requestCO": {
            "filters": vm.filterApplied,
            "pageIndex": vm.currentPageInvestorsList - 1,
            "pageLimit": vm.pageLimitInvestorsList,
            "searchText": vm.individualListingSearchText,
            "corporateFlag":false
          }
        };
        vm.filterApplied.sortValue = vm.sortOrder.sortValue;
        vm.filterApplied.status = '';
        vm.filterApplied.toDate= '';
        vm.filterApplied.transactionNature = 'ALL';
      }else if(type == 'non-individuals'){
        var payload = {
          "commonReportCO": {
            "generateType": "pdf"
          },
          "requestCO": {
            "filters": {
              "fromDate": "",
              "otmOption": vm.selectedOTMType,
              "investorSubType": vm.selectedSubType,
              "investorType": vm.selectedType,
              "sortKey": vm.sortOrder.sortKey,
              "sortValue": vm.sortOrder.sortValue,
              "status": "",
              "toDate": "",
              "transactionNature": "ALL"
            },
            "pageIndex": vm.currentPageInvestorsList - 1,
            "pageLimit": vm.pageLimitInvestorsList,
            "searchText": vm.sortOrder.searchText,
            "corporateFlag":true
          }
        };
      }else if(vm.defaultTab === "Individual"){
        var payload = {
          "commonReportCO": {
            "generateType": "pdf"
          },
          "requestCO": {
            "filters": {
              "fromDate": "",
              "otmOption": vm.selectedOTMType,
              "investorSubType": vm.selectedSubType,
              "investorType": vm.selectedType,
              "sortKey": vm.sortOrder.sortKey,
              "sortValue": vm.sortOrder.sortValue,
              "status": "",
              "toDate": "",
              "transactionNature": "ALL",
              'todaysAnanlysisOption' : vm.analysisType
            },
            "pageIndex": vm.currentPageInvestorsList - 1,
            "pageLimit": vm.pageLimitInvestorsList,
            "searchText": vm.sortOrder.searchText,
            "corporateFlag":false
          }
        };
      }else if(vm.defaultTab === "Non-Individual"){
        var payload = {
          "commonReportCO": {
            "generateType": "pdf"
          },
          "requestCO": {
            "filters": {
              "fromDate": "",
              "otmOption": vm.selectedOTMType,
              "investorSubType": vm.selectedSubType,
              "investorType": vm.selectedType,
              "sortKey": vm.sortOrder.sortKey,
              "sortValue": vm.sortOrder.sortValue,
              "status": "",
              "toDate": "",
              "transactionNature": "ALL",
              'todaysAnanlysisOption' : vm.analysisType
            },
            "pageIndex": vm.currentPageInvestorsList - 1,
            "pageLimit": vm.pageLimitInvestorsList,
            "searchText": vm.sortOrder.searchText,
            "corporateFlag":true
          }
        };
      }else if(vm.defaultTab === "Pending"){
        var payload = {
          "commonReportCO": {
            "generateType": "pdf"
          },
          "requestCO": {
            "filters": {
              "fromDate": "",
              "otmOption": vm.selectedOTMType,
              "investorSubType": vm.selectedSubType,
              "investorType": vm.selectedType,
              "sortKey": vm.sortOrder.sortKey,
              "sortValue": vm.sortOrder.sortValue,
              "status": "",
              "toDate": "",
              "transactionNature": "ALL",
              'todaysAnanlysisOption' : vm.analysisType
            },
            "pageIndex": vm.currentPageInvestorsList - 1,
            "pageLimit": vm.pageLimitInvestorsList,
            "searchText": vm.sortOrder.searchText,
            "corporateFlag":false,
            "pending":true
          }
        };
      }

      var downloadUrl = HDFC_API.VERSION + '/report/investor/email';
      // var downloadUrl = '/v1/report/sip';
      ModalService.sendFileDownloadModal({downloadUrl: downloadUrl, fileName: fileName,payload:payload});
    }

    vm.initInvestorAnalysisList = function () {
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
       }

      LoaderService.showLoader();
      vm.isLoading = true;
      var success = function (resp) {
        if (resp.data && resp.status) {
          resp.data.investorList && resp.data.investorList.forEach(function (item) {
          item.purchaseValueUnit = UtilService.getUnitSting(item.purchaseValue);
          item.currentValueUnit = UtilService.getUnitSting(item.currentValue);
          });
          vm.investorsListData = resp.data.investorList;
          vm.totalInvestorsListData = resp.data.totalCount;
          vm.isPagination = !!(vm.investorsListData && vm.investorsListData.length);
        } else {
          vm.investorsListData = null;
          vm.totalInvestorsListData = 0;
          vm.isPagination = false;
          MessageService.error(resp.message);
        }
        LoaderService.hideLoader();
        vm.isLoading = false;
        // vm.sortOrder.searchText = '';
        angular.element('select').trigger("blur");
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.isLoading = false;
        vm.isPagination = false;
      };

      vm.analysisType = $state.params.analysisType ? $state.params.analysisType : '';
      if(vm.defaultTab === "Individual") {
        var investorListPayload = {
         arnCode: identifierData.arnCode,
         appType: 'W',
         filters: {
           fromDate: "",
           otmOption:vm.selectedOTMType,
           investorType: vm.selectedType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           investorSubType: vm.selectedSubType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           status: "",
           toDate: "", //"dd-MMM-yyyy",
           transactionNature: "ALL",  //vm.transactionNature //
           sortKey: vm.sortOrder.sortKey,
           sortValue: vm.sortOrder.sortValue
         },
         pageIndex: vm.sortOrder.searchText==='' ? vm.currentPageInvestorsList - 1 : 0,
         pageLimit: vm.pageLimitInvestorsList,
         searchText: vm.sortOrder.searchText
       }
      } else if(vm.defaultTab === "Non-Individual") {
        var investorListPayload = {
         arnCode: identifierData.arnCode,
         appType: 'W',
         filters: {
           fromDate: "",
           otmOption:vm.selectedOTMType,
           investorType: vm.selectedType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           investorSubType: vm.selectedSubType,//$stateParams.type?angular.uppercase($stateParams.type):'ALL';
           status: "",
           toDate: "", //"dd-MMM-yyyy",
           transactionNature: "ALL",  //vm.transactionNature //
           sortKey: vm.sortOrder.sortKey,
           sortValue: vm.sortOrder.sortValue
         },
         corporateFlag:true,
         pageIndex: vm.sortOrder.searchText==='' ? vm.currentPageInvestorsList - 1 : 0,
         pageLimit: vm.pageLimitInvestorsList,
         searchText: vm.sortOrder.searchText
       }

      } else{
        vm.initInvestorPendingList();
        return;
      }

      investorListPayload.filters.todaysAnanlysisOption = vm.analysisType;
    if(investorListPayload.filters && investorListPayload.filters.todaysAnanlysisOption == "pending-list"){
      vm.defaultTab = "Pending";
        if(vm.analysisType == "pending-list"){
          vm.tabs[0].active = true;
        }else{
          vm.tabs[0].active = false;
          vm.tabs[1].active = false;
          vm.tabs[2].active = true;
        }
        vm.initInvestorPendingList() ;
        LoaderService.hideLoader();
    }else{
      InvestorsService.post({controller: 'list'}, investorListPayload).$promise.then(success, error);
    }

      fetchInvestorReportUrls();
    };
    vm.initInvestorPendingList = function () {
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
       }
      vm.isLoading = true;
      var success = function (resp) {
        if (resp.data && resp.status) {
          vm.masterData = resp.data;
          vm.investorsListData = [];
          vm.changeMasterData = [];
          vm.totalInvestorsListData = resp.data.length;
          vm.isPagination = !!(vm.masterData && vm.masterData.length);
          // vm.masterData.forEach(function (value){
          //   if(value){
          //     var tdate = new Date(value.dob);
          //     var s = $window.moment(tdate).format("DD-MM-YYYY");
          //     value.dob = s;
          //     vm.changeMasterData.push(value);
          //   }
          // });
          vm.currentPageInvestorsList = 1;
          vm.selectpage();
        } else {
          vm.investorsListData = null;
          vm.totalInvestorsListData = 0;
          vm.isPagination = false;
          MessageService.error(resp.message);
          vm.masterData = []
        }
        LoaderService.hideLoader();
        vm.isLoading = false;
        angular.element('select').trigger("blur");
      },
      error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.isLoading = false;
        vm.isPagination = false;
        vm.masterData = []
      };
      LoaderService.showLoader();
      InvestorServiceDynamicData.post({child1: 'distributorNewInvestor',child2:'pendingList',child3 :'brokerCode'},{arnCode:identifierData.arnCode, key:'test', order : 'test'}).$promise.then(success, error);
    };
    vm.redirectToTab = function(tabKey){
      if (tabKey === "Individual") {
        vm.defaultTab = tabKey
        vm.tabs[0].active = true;
        vm.tabs[1].active = false;
        vm.tabs[2].active = false;
        vm.initInvestorAnalysisList()
      } else if(tabKey === "Non-Individual") {
        vm.defaultTab = tabKey
        vm.tabs[0].active = false;
        vm.tabs[1].active = true;
        vm.tabs[2].active = false;
        vm.initInvestorAnalysisList()
      }else if(tabKey === "Pending") {
        vm.defaultTab = tabKey
        if(vm.analysisType == "pending-list"){
          vm.tabs[0].active = true;
        }else{
          vm.tabs[0].active = false;
          vm.tabs[1].active = false;
          vm.tabs[2].active = true;
        }
        vm.initInvestorPendingList() ;
      }else{
        vm.defaultTab = tabKey
        vm.tabs[0].active = false;
        vm.tabs[1].active = false;
        vm.tabs[2].active = true;
        vm.initInvestorPendingList();
      }
    };

    vm.editNewInvestor = function(investordata){
      investordata.isFromPendingApproval = true;
      sessionStorage.setItem('checkInvestorStatus', JSON.stringify(investordata));
      $state.go('main.newinvestor.kycverify');
    }
    vm.filterByNewInvestorData = function (key) {
      vm.newinvestorAscendingOrder = !vm.newinvestorAscendingOrder
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        return;
      }
    vm.isLoading = true;
    var success = function (resp) {
      if (resp.data && resp.status) {
        vm.masterData = resp.data;
        vm.investorsListData = [];
        vm.changeMasterData = [];
        vm.totalInvestorsListData = resp.data.length;
        vm.isPagination = !!(vm.masterData && vm.masterData.length);
        // vm.masterData.forEach(function (value){
        //   if(value){
        //     var tdate = new Date(value.dob);
        //     var s = $window.moment(tdate).format("DD-MM-YYYY");
        //     value.dob = s;
        //     vm.changeMasterData.push(value);
        //   }
        // });
        vm.currentPageInvestorsList = 1;
        vm.selectpage();
      } else {
        vm.investorsListData = null;
        vm.totalInvestorsListData = 0;
        vm.isPagination = false;
        MessageService.error(resp.message);
        vm.masterData = []
      }
      LoaderService.hideLoader();
      vm.isLoading = false;
      angular.element('select').trigger("blur");
    },
    error = function (err) {
      LoaderService.hideLoader();
      UtilService.errorHandler(err);
      vm.isLoading = false;
      vm.isPagination = false;
      vm.masterData = []
    };
    vm.payload ={
    arnCode : identifierData.arnCode,
    key:key
    }
    if(vm.newinvestorAscendingOrder){
      vm.payload.order = 'ASC';
    }else{
      vm.payload.order = 'DESC';
    }
    LoaderService.showLoader();
    InvestorServiceDynamicData.post({child1: 'distributorNewInvestor',child2:'pendingList',child3 :'brokerCode'},vm.payload).$promise.then(success, error);
    }
    vm.searchInvestor = function(){
      vm.tempNameData = [];
      if(vm.sortOrder.searchText){
        vm.sortletters =vm.sortOrder.searchText.toUpperCase();
        vm.masterData.forEach(function (value){
          if(value){
            vm.investorNames= value.name.toUpperCase();
           if(vm.investorNames.includes(vm.sortletters)){
              vm.tempNameData.push(value);
           }
          }
        });
        vm.investorsListData = vm.tempNameData;
      }else{
        vm.investorsListData =  vm.masterData;
      }
    }

    vm.selectpage = function () {
      var pageCount = vm.currentPageInvestorsList - 1;
      vm.startValue = vm.pageLimitInvestorsList * pageCount;
      vm.endValue = vm.pageLimitInvestorsList * vm.currentPageInvestorsList - 1;
      if(vm.endValue > vm.masterData.length){
        vm.endValue = vm.masterData.length;
      }
      vm.investorsListData = [];
      for(var i=vm.startValue;i<= vm.endValue;i++){
        vm.investorsListData.push(vm.masterData[i]);
      }
    };

  }
})();

/**
 * Created by sandeepchhapola on 19/11/16.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('HomeController', homeController);

  /** @ngInject */
  function homeController(AuthService, LoaderService, $interval, $state, investorProfile) {
    var vm = this;
    vm.showContinue = false;
    vm.investorProfile = investorProfile;
    vm.moveToDashboard = moveToDashboard;

/*

    var token = AuthService.getToken();
    $window.distrubutorLogoutPath = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/logout';
    $window.sessionStorage.logoutVar = 'Bearer ' + token.access_token;

    $window.addEventListener('beforeunload', function (e) {
      var message = 'Warning! Save pending...';
      e = e || window.event;
      if (e) {
        e.returnValue = message;
      }
      return message;
    });

    $window.addEventListener('unload', function (e) {
      try {

        if (window.opener.title == undefined) {
          console.log("This page is reloaded");
        }
      } catch (err) {
        // if (window.validNavigation == 1) {
        var xhr = new XMLHttpRequest();
        xhr.open('post', window.distrubutorLogoutPath, false);
        xhr.setRequestHeader('Authorization', window.sessionStorage.logoutVar);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.state === 200) {
            console.log(xhr.response);
          }
        };
        xhr.send();
        // }
      }
    });
*/


    function moveToDashboard() {
      $state.go('main.dashboard');
    }

    var intervalPromise = $interval(function () {
      LoaderService.hideLoader('#loginLoader');
      $interval.cancel(intervalPromise);
      $state.go('main.dashboard');
    }, 120000);

    var goToDashboard = function () {
      if (vm.investorProfile&&vm.investorProfile.firstTimeLogin) {
        vm.showContinue = true;
      } else {
        LoaderService.hideLoader('#loginLoader');
        $state.go('main.dashboard');
      }
    };

    var init = function () {
      var identifierData = AuthService.getToken();
      if (identifierData && identifierData.arnCode) {
        AuthService.callCommonServiceUrl({arnCode: identifierData.arnCode}).then(function () {
          $interval.cancel(intervalPromise);
          identifierData.distributorType = vm.investorProfile.distributorType;
          AuthService.setToken(identifierData);
          goToDashboard();
        }, function () {
          identifierData.distributorType = vm.investorProfile.distributorType;
          AuthService.setToken(identifierData);
          $interval.cancel(intervalPromise);
          goToDashboard();
        });
      } else {
        identifierData.distributorType = vm.investorProfile.distributorType;
        AuthService.setToken(identifierData);
        $interval.cancel(intervalPromise);
        goToDashboard();
      }
    };

    //This code is added for testin commonservice of uat environment and will be removed very soon
    vm.init = function () {
      if (vm.investorProfile && !vm.investorProfile.firstTimeLogin) {
        LoaderService.showLoader('#loginLoader');
      }
      init();
    };

  }
})();

 (function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('GolbalSearchController', golbalSearchController);

  function golbalSearchController(HDFC_API, UtilService, AppConstants, $state, LoaderService, MessageService, $stateParams, $timeout, $http, InvestorServiceDynamicData, ModalService, $window) {
    var vm = this;
    vm.searchResult = null;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.isLoading = false;
    vm.searchResult = null;

    vm.count = 0;
    vm.currentPage = 1;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.searchPayload = {
      count: vm.count,
      pageIndex: vm.currentPage,
      pageLimit: vm.selectedPageLimit
    };
    vm.searchString = $stateParams.searchString;
    vm.isSearching = false;

    vm.init = function () {
      vm.getSearchList(vm.searchPayload);
    };

    vm.investorDetails = function (result) {
      vm.goToProfile(result);
    };

    vm.limitChanged = function () {
      vm.currentPage = 1;
      vm.searchPayload.pageIndex = vm.currentPage;
      vm.searchPayload.pageLimit = vm.selectedPageLimit;
      vm.getSearchList(vm.searchPayload);
    };

    vm.getSearchList = function (searchPayload) {
      var success = function (resp) {
          resp = resp.data;
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.searchResult = resp.data.searchResponse;
            vm.count = resp.data.count;
            vm.isPagination = !!(vm.searchResult && vm.searchResult.length);
          } else {
            vm.searchResult = null;
            vm.count = 0;
            vm.isPagination = false;
            !resp.status && MessageService.error(resp.message)
          }
          LoaderService.hideLoader();
          vm.isLoading = false;
          angular.element('#searchbox').trigger("blur");
        },
        error = function (err) {
          vm.searchResult = null;
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
          vm.isLoading = false;
          vm.isPagination = false;
        };
      if (vm.isSearching || !vm.searchString || vm.searchString.length < 1) {
        return;
      }

      vm.searchResult = null;
      vm.isSearching = true;
      LoaderService.showLoader();
      vm.isLoading = true;
      searchPayload.pageIndex = vm.currentPage - 1;
      searchPayload.pageLimit = vm.selectedPageLimit;
      searchPayload.count = vm.count;
      $timeout(function () {
        vm.isSearching = false;
      }, 200);

      LoaderService.showLoader('.popup');

      var _path = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/investor/search/' + vm.searchString;
      $http.post(_path, searchPayload, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(success, error);
    }

    vm.goToProfile = function (result) {
      LoaderService.showLoader();
      var taxIdentifier = result.panNumber;
      var success  = function(resp) {
        LoaderService.hideLoader();
        if (resp.data && resp.status) {
          if (resp.data.showPopup) {
            ModalService.optOutNomineeModalSearch({
              message: resp.data.popUpMessage,
              folioList : resp.data.folioList
            },function () {
              $timeout(function () {
                $window.scrollTo(0,0);
                $state.go('main.investors.profile.basicinfo', {investorId: result.uuid});
              }, 200);
            } , function () {
              $timeout(function () {
                $window.scrollTo(0,0);
                $state.go('main.investors.profile.portfolio', {investorId: result.uuid});
              }, 200);
            });
          } else {
            $timeout(function () {
              $window.scrollTo(0,0);
              $state.go('main.investors.profile.portfolio', {investorId: result.uuid});
            }, 200);
          }
        }
      } , error = function(err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
      }
      InvestorServiceDynamicData.post({
        child1: 'profile',
        child2: 'check',
        child3: 'nominee',
        child4: 'details'
      }, {
        pan : taxIdentifier
      }).$promise.then(success, error);

    };
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ForgotPasswordController', forgotPasswordController);

  /** @ngInject */
  function forgotPasswordController($timeout, AuthService, AppConstants,MessageService,ModalService, $window) {
    var vm = this;
    vm.forgotPasswordForm = {};
    vm.appConstants = AppConstants;
    vm.validateData = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.publicKey = AppConstants.CAPTCHA_PUB_KEY;//'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX';
    vm.forgotPasswordPayload = {arnCode: '',pan: ''};
    vm.showCaptcha = true;
    vm.goBack = goBack;

    vm.processFlag = false;
    vm.forgotPassword = function () {
      var success = function (resp) {
          vm.processFlag = false;
          if (resp.status) {
            // $uibModalInstance.close(resp);
            ModalService.forgotPasswordDoneModal(resp);
          } else {
            vm.wrongARNmsg = resp.message;

            vm.showCaptcha = false;
            vm.gRecaptchaResponse = "";
            $timeout(function () {
              vm.showCaptcha = true;
            });
            MessageService.error(vm.wrongARNmsg);
          }
        },
        error = function () {
          vm.processFlag = false;
          vm.wrongARNmsg = AppConstants.ToastrMessage.FAILED;
          vm.showCaptcha = false;
          vm.gRecaptchaResponse = "";
          $timeout(function () {
            vm.showCaptcha = true;
          });
          MessageService.error(vm.wrongARNmsg);
        };
      var payload = {};
      payload.arnCode = 'ARN-' + vm.forgotPasswordPayload.arnCode;
      payload.gRecaptchaResponse = vm.gRecaptchaResponse;
      payload.pan =vm.forgotPasswordPayload && vm.forgotPasswordPayload.pan ? AuthService.encryptRSA(angular.copy(vm.forgotPasswordPayload.pan)) : '';
      vm.processFlag = true;
      AuthService.forgotPassword(payload).then(success, error);
    };

    // vm.closeModal = function () {
    //   $uibModalInstance.close('sent an email successfully');
    // };

    // vm.dismissModal = function () {
    //   $uibModalInstance.dismiss("cancel");
    // };
    vm.clearModal = function () {
      vm.wrongARNmsg = "";
    }

    function goBack() {
      $window.history.back();
    }
  }

})();

/**
 * Created by ttn on 28/11/16.
 */

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FinancialPlanningToolController', financialPlanningToolController);

  /** @ngInject */
  function financialPlanningToolController(UtilService, HDFC_API, $http, AppConstants, MessageService, LoaderService, $window, moment, $timeout) {

    var vm = this;
    vm.financialPlanningList = [];
    vm.newPlanning = false;
    vm.tab = "ALL";
    vm.searchText = '';
    vm.currentPage = 0;
    vm.selectedPageLimit = 25;
    vm.fivenanceInvestorId = null;
    vm.isLoading = false;
    vm.tabindex = 0;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.totalCount = 0;
    vm.showList = true;

    vm.startPlanning = startPlanning;
    vm.getPlanningList = getPlanningList;
    vm.limitChanged = limitChanged;
    vm.tabChange = tabChange;
    vm.init = init;
    vm.downloadReport = downloadReport;


    function startPlanning(fivenanceInvestorId) {
      var newWin = $window.open("about:blank", '_blank');
      newWin.document.write("<h2>Please wait while we fetch details....</h2>");
      vm.fivenanceInvestorId = fivenanceInvestorId ? fivenanceInvestorId : null;
      var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/fivenance/redirect';
      var success = function (resp) {
          if (resp.status && resp.data) {
            var url = resp.data && resp.data.data ? $window.encodeURI(resp.data.data) : $window.encodeURI(resp.data);
            newWin.location = url;
          } else {
            newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          newWin.document.write("<h2>Something went wrong, Please try again.</h2>");
          UtilService.errorHandler(err);
        }
      $http.post(_link,{fivenanceInvestorId: vm.fivenanceInvestorId}, {
        headers: {'Content-Type': 'application/json'}
      }).then(success, error);


      /*$http.post(_link, {fivenanceInvestorId: vm.fivenanceInvestorId}, {
        headers: {'Content-Type': 'application/json'}
      })*/

    }

    function getPlanningList() {
      vm.isLoading = true;
      LoaderService.showLoader();
      var payload = {
        "pageIndex": vm.currentPage,
        "pageLimit": vm.selectedPageLimit,
        "searchText": vm.searchText,
        "tab": vm.tab
      };
      var _link = HDFC_API.PROTOCOL + HDFC_API.HOST + HDFC_API.VERSION + '/fivenance/investors';
      var success = function (resp) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          resp.data = resp.data.data?resp.data.data:resp.data;
          if (resp.status && resp.data) {
            vm.financialPlanningList = resp.data.investorsList || [];
            vm.totalCount = resp.data.count;
            for (var i in vm.financialPlanningList) {
              vm.lastUpdatedDate = vm.financialPlanningList[i].lastUpdated;
              var date = moment.utc(vm.lastUpdatedDate).format('DD-MMM-YYYY HH:mm:ss');
              var stillUtc = moment.utc(date).toDate();
              var local = moment(stillUtc).local().format('DD-MMM-YYYY HH:mm:ss');
              vm.financialPlanningList[i].lastUpdated = local;
            }
            if (vm.tab == "ALL" && vm.financialPlanningList.length == 0) {
              vm.newPlanning = true;
              vm.showList = false;
            }
            else {
              vm.newPlanning = false;
              vm.showList = true;
            }
            vm.isPagination = vm.financialPlanningList && vm.financialPlanningList.length > 0 ? true : false;
          } else {
            MessageService.error(resp.message);
            vm.newPlanning = true;
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          UtilService.errorHandler(err);
        }
      $http.post(_link,payload, {
        headers: {'Content-Type': 'application/json'}
      }).then(success, error);


    }

    function init() {
      vm.currentPage = 0;
      vm.selectedPageLimit = 25;
      getPlanningList();
    }

    function tabChange(tabVal) {
      vm.tab = tabVal;
      switch (tabVal) {
        case "ALL":
          vm.tabindex = 0;
          break;
        case "EXISTING":
          vm.tabindex = 1;
          break;
        case "PROSPECT":
          vm.tabindex = 2;
          break;
      }
      vm.totalCount = 0;
      vm.currentPage = 0;
      getPlanningList();
    }

    function limitChanged() {
      vm.currentPage = 0;
      getPlanningList();
    }

    function downloadReport(reportLink) {
      $window.open(reportLink, '_blank');
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FeedbackController', feedbackController);

  function feedbackController(FeedbackService, MessageService, $state, $log, LoaderService, ModalService, AppConstants) {
    var vm = this;
    vm.formData = {
      feedback: 'IMPROVEMENT',
      feedbackArea: ""
    };
    vm.changeFeedback = changeFeedback;
    vm.submitFeedback = submitFeedback;
    vm.confirmCancel = confirmCancel;
    vm.special_Char = new RegExp(/[#$%^+\=\[\];\\|<>\/]+/);
    vm.formInputChange = formInputChange;
    vm.constant = AppConstants;

    function changeFeedback() {
      vm.formData.feedbackArea = "";
    }

    function submitFeedback() {
      var payload={
        "category": vm.formData.feedback,
        "suggestion": vm.formData.feedbackArea
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.data && resp.status) {
            var success = function () {
                vm.formData = {
                  feedback: 'IMPROVEMENT',
                  feedbackArea: ""
                };
              };
            var failure = function() {
              vm.formData = {
                feedback: 'IMPROVEMENT',
                feedbackArea: ""
              };
            };
            ModalService.feedbackModal({}, success, failure);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          $log.info('error: ', err);
          LoaderService.hideLoader();
          MessageService.error();
        };
      LoaderService.showLoader();
      FeedbackService.post({controller: 'save'}, payload).$promise.then(success, error);
    }

    function confirmCancel() {
      var success = function () {
          $state.go('main.dashboard')
        };
      ModalService.confirmCancelModal({}, success);
    }

    function formInputChange() {
      if (vm.formData.feedbackArea) {
        vm.isInValid = vm.special_Char.test(vm.formData.feedbackArea);
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('FaqController', faqController);

  function faqController(UtilService) {
    var vm = this;
    vm.date = new Date();
    vm.count = 0;
    vm.changedFont = changedFont;
    vm.fontSizeChange = fontSizeChange;
    vm.contrast = contrast;
    init();

    function init() {
      var successHandler = function(resp) {
        vm.DynamicDataFaq = resp.faqDTO.faqDTOMap.FAQ_Content;
      }

      UtilService.fetchDynamicData("FAQ").then(successHandler).catch(function(resp) {
        MessageService.error(resp);
      });
    }

    angular.element(window).scroll(function () {
      var vm = this;
      if (angular.element(vm).scrollTop() > 500) {
        angular.element('.scroll-top').fadeIn();
      } else {
        angular.element('.scroll-top').fadeOut();
      }
    });

    vm.scroll = function (id) {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView();
    }
//Click event to scroll to top
    vm.scrollToTop = function () {
      angular.element('html, body').animate({scrollTop: 0}, 500);
      return false;
    };

    /** color contrast */

    function contrast (){
      vm.contrastt = !vm.contrastt;
      if(vm.contrastt){
        document.getElementsByTagName("body")[0].classList.add("contrastClass");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("contrastClass");
      }
    }
    function changedFont(valType){
      switch (valType) {
        case 'increment' : {
          if(vm.count<3){
            vm.count++;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'decrement' : {
          if(vm.count>-3){
            vm.count--;
            vm.fontSizeChange(vm.count);
          }
        }
          break;
        case 'original' : {
          vm.count = 0;
          vm.fontSizeChange(vm.count);
        }
          break;
      }
    }
    function fontSizeChange(val){
      var elem = document.getElementsByTagName("body")[0];
      elem.classList.add("newBigFont");
      var ele = document.getElementsByClassName('newBigFont')[0];
      switch (val) {
        case -2 : {
          ele.setAttribute("style","font-size: 55% !important");
        }
          break;
        case -1 : {
          ele.setAttribute("style","font-size: 65% !important");
        }
          break;
        case 0 : {
          elem.removeAttribute('style');
          elem.classList.remove('newBigFont');
        }
          break;
        case 1 : {
          ele.setAttribute("style","font-size: 97% !important");
        }
          break;
        case 2 : {
          ele.setAttribute("style","font-size: 110% !important");
        }
          break;
      }
    }

  }
})();

/**
 * Created by ttn on 18/12/23.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EuinDetailsController', euinDetailsController);

  /** @ngInject */
  function euinDetailsController($timeout, LoaderService, AppConstants, MessageService, UtilService, DashboardServiceV3) {
    var vm = this;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.STATUS_YEAR = AppConstants.STATUS_YEAR;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.isLoading = false;
    vm.euinDetailsListData = [];
    vm.selectedYear = vm.STATUS_YEAR[0].key;
    vm.isSearching = false;

    vm.totaleuinDetailsListData = 0;
    vm.currentPageEuinList = 1;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.EUIN_DETAILS_DROPDOWN_VALUES= [
      {key: 'MONTHLY', value: 'Current Month'},
      {key: 'QUARTERLY', value: 'Current Quarter'},
      {key: 'YEARLY', value: 'Current FY'}
    ];
    vm.selectedTimePeriodForEuinDetails = vm.EUIN_DETAILS_DROPDOWN_VALUES[0];

    var euinDetailsPayload = {
      'pageIndex': vm.currentPageEuinList,
      'pageLimit': vm.selectedPageLimit,
      'grossPeriod': vm.selectedTimePeriodForEuinDetails,
      'searchText': vm.searchText
    };
    vm.getUnit = getUnit;

    vm.init = function () {
      vm.getEuinDetailsListData(euinDetailsPayload);
    };

    vm.getEuinDetailsListData = function (euinDetailsPayload) {
      LoaderService.showLoader();
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.euinDetailsListData = resp.data.euinGrossSalesDTOList;

            vm.totaleuinDetailsListData = resp.data.totalCount;
            vm.isPagination = !!(vm.euinDetailsListData && vm.euinDetailsListData.length);
          } else {
            vm.euinDetailsListData = [];
            vm.totaleuinDetailsListData = 0;
            vm.isPagination = false;
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader();
          vm.isLoading = false;
          angular.element('select').trigger("blur");
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.isLoading = false;
          vm.isPagination = false;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      vm.isLoading = true;
      euinDetailsPayload.pageIndex = vm.currentPageEuinList - 1;
      euinDetailsPayload.pageLimit = vm.selectedPageLimit;
      euinDetailsPayload.searchText = vm.searchText;
      euinDetailsPayload.grossPeriod = vm.selectedTimePeriodForEuinDetails.key
      DashboardServiceV3.post({
        child1: 'dashboard',
        child2: 'euin',
        child3: 'gross_sales'
      }, euinDetailsPayload).$promise.then(success, error);
    };

    vm.searchList = function () {

      if (!vm.isSearching && (vm.searchText.length > 3 || vm.searchText == '')) {
        vm.isSearching = true;
        vm.getEuinDetailsListData(euinDetailsPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.changeEuinTimePeriod = function() {
      vm.getEuinDetailsListData(euinDetailsPayload)
    }

    vm.initEuinDetails = function () {
      vm.getEuinDetailsListData(euinDetailsPayload);
    };

    function getUnit(value) {
      return UtilService.getUnitSting(value);
    }

  }
})();

/**
 * Created by ttn on 31/08/23.
 */
(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EquityAssetController', equityAssetController);

  /** @ngInject */
  function equityAssetController($window, ModalService, $state, $timeout, LoaderService, AppConstants, MessageService, UtilService ,AuthService, DashboardServiceV3, $stateParams) {
    var vm = this;
    vm.isPagination = false;
    vm.PAGE_LIMITS = AppConstants.PAGE_LIMITS;
    vm.VALIDATE_DATA = AppConstants.ToastrMessage.VALIDATE_DATA;
    vm.isLoading = false;
    vm.active = {0: true};
    vm.systematicListData = null;
    vm.isSearching = false;

    vm.totalAssetDataList = 0;
    vm.currentPageSystematicList = 1;
    vm.selectedPageLimit = vm.PAGE_LIMITS[0];
    vm.selectedAsset = $stateParams.selectedAUM ? $stateParams.selectedAUM == "Liquid" ? "CASH" : $stateParams.selectedAUM.toUpperCase() : null;
    vm.assetDropdownList = {};
    if(vm.selectedAsset) {
      sessionStorage.setItem('assetType', vm.selectedAsset);
    } else {
      vm.selectedAsset = sessionStorage.getItem('assetType');
    }

    var assetPayload = {
      'assetType': vm.selectedAsset,
      'pageIndex': vm.currentPageSystematicList,
      'pageLimit': vm.selectedPageLimit,
      'searchText': vm.searchText
    };

    vm.sidebarTitle = 'CART_DETAILS';
    vm.showEcartModel = false;
    vm.addToEcart = addToEcart;
    vm.closeAction = closeAction;
    vm.showAddCart = true;

    vm.init = function () {
      $window.scrollTo(0, 0);
      vm.fetchAssetDropdown();
      vm.getAseetListData(assetPayload);
    };

    vm.getAseetListData = function (assetPayload, assetTypeChanged) {
      LoaderService.showLoader('.EquityAsset');
      var success = function (resp) {
          if (resp.data && resp.status) {
            LoaderService.hideLoader('.EquityAsset')
            vm.assetCompleteData = resp.data;
            vm.totalCount = vm.assetCompleteData && vm.assetCompleteData.totalCount ? angular.copy(vm.assetCompleteData.totalCount) : null;
            vm.assetListData = resp.data.topSchemesList ? resp.data.topSchemesList : [];
            vm.totalAssetDataList = resp.data.topSchemesList.length;
            vm.isPagination = !!(vm.assetListData && vm.assetListData.length);
            vm.fromText = ((vm.currentPageSystematicList - 1) * vm.selectedPageLimit) + 1; //((currentPage -1) * itemsPerPage) + 1
            vm.toText = vm.currentPageSystematicList * vm.selectedPageLimit < vm.totalCount ? vm.currentPageSystematicList * vm.selectedPageLimit: vm.totalCount;
          } else {
            vm.systematicListData = null;
            vm.assetListData = [];
            vm.totalAssetDataList = 0;
            vm.isPagination = false;
            // MessageService.error(resp.message);
          }
          LoaderService.hideLoader('.EquityAsset');
          vm.isLoading = false;
          angular.element('select').trigger("blur");
        },
        error = function (err) {
          LoaderService.hideLoader('.EquityAsset');
          vm.isLoading = false;
          vm.isPagination = false;
          vm.systematicListData = null;
          vm.assetListData = [];
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.EquityAsset');
      vm.isLoading = true;
      if(!assetTypeChanged) assetPayload.pageIndex = vm.currentPageSystematicList - 1;
      DashboardServiceV3.post({
        child1: 'dashboard',
        child2: 'assetType',
        child3: 'schemeList'
      }, assetPayload).$promise.then(success, error);
    };

    vm.searchList = function () {

      if (!vm.isSearching && (vm.searchText.length > 3 || vm.searchText == '')) {
        vm.isSearching = true;
        assetPayload.searchText = vm.searchText;
        vm.getAseetListData(assetPayload);
        $timeout(function () {
          vm.isSearching = false;
        }, 300);
      }
    };

    vm.transactNow = function (data) {
      var success = function(type){
        if(type){
          vm.search(type, data);
        }
      }, error = function(){};
      ModalService.getTransactionTypeModal({Text : "Select transaction type you want to initiate"}, success, error);
    };

    vm.search = function (transactionType, data) {
      var identifierData = AuthService.getToken();
      if (!identifierData || !identifierData.arnCode) {
        MessageService.error('Unable to get arnCode');
        $state.go('main.dashboard');
        return;
      }
      var success = function (investor) {
          if (investor && investor.uuid) {
            var _state = 'main.transactions.initiate.sip';
            $state.go(_state, {
              uuid: investor.uuid,
              schemeCode: data.schemeCode,
              folioNumber: '',
              transactionType: transactionType.toUpperCase(),
              transactionId: '',
              fromModify: ''
            });
          } else {
            MessageService.error('Unable to get uuid of selected investor');
          }
        },
        error = function () {};
      ModalService.searchInvestorModal({
        transactionType: transactionType,
        arnCode: identifierData.arnCode
      }, success, error);
    };

    vm.fetchAssetDropdown = function () {
      var success = function(resp){
        if(resp && resp.data){
          vm.assetDropdownList = resp.data.assetClassList;
        }else {
          vm.assetDropdownList = {};
        }
      }, error = function (err){
        MessageService.error(err.message);
        vm.assetDropdownList = {};
      };
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'assetType',
        child3: 'list'
      }).$promise.then(success, error)
    };

    vm.initEquityAsset = function (assetTypeChanged) {
      if(assetTypeChanged) {
        sessionStorage.setItem('assetType', vm.selectedAsset);
        vm.searchText = null;
        assetPayload = {
          'assetType': vm.selectedAsset,
          'pageIndex': 0,
          'pageLimit': vm.selectedPageLimit,
          'searchText': vm.searchText
        }
      }

      vm.getAseetListData(assetPayload, assetTypeChanged);
    };

    function addToEcart(transaction) {
      var payload = {
        fundCode :  transaction.fundCode,
        schemeCode: transaction.schemeCode,
        purchaseOpted: true ,
        sipOpted : true,
        addTocart : true
      };
      vm.ecartData = payload;
      vm.showEcartModel = true;
      vm.isFromEquityAsset = true;
      vm.showAddCart = true;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function closeAction(action) {
      vm.showEcartModel = false;
      if (action === 'saved') {
        $state.reload();
      }
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('EkycController', ekycController);

  /** @ngInject */
  function ekycController($stateParams, LoaderService, $timeout, $sce, deviceDetector, $window, EkycService, HDFC_API, $rootScope, UtilService, MessageService, ModalService) {
    var vm = this;
    vm.uniqueLink = $stateParams.uniqueLink;
    vm.ekycData = {};
    vm.formData = {};
    vm.actionUrl = "";
    vm.isLoaded = false;
    vm.init = init();

    /*
    * function responsible for initialising all variable on component init.
    */
    function init() {
      var popUp = $window.open("http://www.google.com", "popup_tester", "width=1,height=1,left=0,top=0");
      if (popUp == null || typeof(popUp) == 'undefined') {
        vm.isActionPerformed = false;
        alert('Please disable your pop-up blocker then submit the form.');
        return;
      }
      else {
        popUp.close();
      }
      if (!vm.uniqueLink) {
        return;
      }
      /*
      * condition to check the user navigator agent
      * if user navigator agent not match with the supported browser than redirect to browser support page.
      */
      if (browserForceUpdate()) {
        return;
      }
      LoaderService.showLoader();
      vm.uniqueLink = $stateParams.uniqueLink;
      vm.summaryType = "ekyc";
      performActionOnInitiation();
    }

    /* ---------------------------------------ekyc action section start from here--------------------------------------------------*/

    vm.handleProceedAction = function() {
      LoaderService.showLoader();
      $timeout(function () {
        angular.element('#ekycForm').submit();
      }, 100);
    };

    /**
     * Function responsible to request for OTP and generate OTP modal
     */
    function performActionOnInitiation() {
      var success = function(resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          initiateOTPModal();
        } else {
          MessageService.error(resp.message)
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      var version = $rootScope.apiVersion ? ($rootScope.apiVersion) : HDFC_API.VERSION;
      EkycService.get({
        VERSION: version,
        controller: 'ekyc',
        child2: 'otp',
        uniqueLink: vm.uniqueLink
      }, null).$promise.then(success, error);
    }

    /**
     *
     * Function responsible to show OTP modal
     *
     */
    function initiateOTPModal() {
      var success = function(response) {
        vm.isLoaded = true;
        setEkycFormValues(response.encryptedResponse);
      }, failure = function(resp) {
        MessageService.error(resp.message)
      };
      ModalService.otpForApprovalModal({
        backdrop: 'static',
        initiatedFrom: 'ekyc',
        summaryType: vm.summaryType,
        uniqueLink: vm.uniqueLink
      }, success, failure);
    }

    /**
     * function responsible to set the ekyc form value which needs to be submitted to CAMS
     */
    function setEkycFormValues(ekycData) {
      vm.ekycData = ekycData;
      vm.actionUrl = $sce.trustAsResourceUrl(vm.ekycData.camsUrl);
      vm.formData = {
        url : vm.ekycData.url,
        sess_id : vm.ekycData.sess_id,
        ekyctype : vm.ekycData.ekyctype,
        plkyc_type : vm.ekycData.plkyc_type,
        kyc_data : vm.ekycData.kyc_data
      };
    }

    /*
    * function responsile to check the user agent(browser)
    * */
    function browserForceUpdate() {
      if (deviceDetector.browser == 'chrome' && parseInt(deviceDetector.browser_version, 10) < 60) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'firefox' && parseInt(deviceDetector.browser_version, 10) < 50) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'ms-edge' && parseInt(deviceDetector.browser_version, 10) < 16) {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }

      else if (deviceDetector.browser == 'ie') {
        $timeout(function(){
          $state.go('browserUpdate')
        },0);
        return true;
      }
      return false;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DeeplinkController', deeplinkController);

  /** @ngInject */
  function deeplinkController($stateParams, $window, deviceDetector, LoaderService, $state, HDFC_API) {
    var vm = this;
    vm.HDFC_API = HDFC_API;
    vm.deviceDetector = deviceDetector;
    vm.appStoreLink = "https://apps.apple.com/in/app/hdfc-mf-online-partners/id1335989019";
    vm.playStoreLink = "https://play.google.com/store/apps/details?id=com.hdfc.mf&hl=en_IN";

    vm.init = function() {
      vm.transactionType = $stateParams.type;
      identifyUserAgent();
    }

    function identifyUserAgent() {
      var os = vm.deviceDetector.os;
      if (os.toUpperCase() === "IOS") {
        LoaderService.showLoader();
        $window.location.href = vm.appStoreLink;
        $state.go('login');
      } else if (os.toUpperCase() === 'ANDROID') {
        LoaderService.showLoader();
        $window.location.href = vm.playStoreLink;
        $state.go('login');
      } else {
        $state.go('login');
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('TodosController', todosController);

  /** @ngInject */
  function todosController(UtilService, DashboardService, AppConstants, ModalService, MessageService, TransactionService, LoaderService, HDFC_API) {
    var vm = this;
    vm.init = init;
    vm.fetchTodosList = fetchTodosList;
    //vm.getTaskString  = getTaskString;
    vm.checkPendingDoneItems = checkPendingDoneItems;
    vm.checkPendingDoneItemsAll = checkPendingDoneItemsAll;
    vm.checkBirthdayDoneItems = checkBirthdayDoneItems;
    vm.checkBirthdayDoneItemsAll = checkBirthdayDoneItemsAll;
    vm.increasePendingLimit = increasePendingLimit;
    vm.decreasePendingLimit=decreasePendingLimit;
    vm.increaseBirthdayLimit = increaseBirthdayLimit;
    vm.decreaseBirthdayLimit=decreaseBirthdayLimit;

    vm.wishSomeone = wishSomeone;
    vm.birthdayQuantity = 5;
    vm.pendingQuantity = 5;
    vm.REMIND_SUCCESS_MESSAGE = AppConstants.REMIND_SUCCESS_MESSAGE;
    vm.SELF_DECLARATION = AppConstants.SELF_DECLARATION_ACTION;
    vm.birthdayList = [];
    vm.pendingTransactionList = [];
    vm.completedTodoList = null;
    vm.birthdayCount = null;
    vm.pendingTransactionCount = null;
    vm.pendingTodoTaskId = null;
    vm.completedItemDescription = null;
    vm.completedDate = null;
    vm.completedArray = [];
    vm.pendingTodoList = [];
    vm.pendingCount = 0;
    vm.sendReminder = sendReminder;
    //vm.taskStr = "";

    function init() {
      vm.fetchTodosList();
      // vm.getTaskString(vm.pendingCount);
    }

    function increasePendingLimit() {
      vm.pendingQuantity = vm.pendingQuantity + 5;
    }
    function decreasePendingLimit() {
      vm.pendingQuantity = vm.pendingQuantity - 5;
    }

    function increaseBirthdayLimit() {
      vm.birthdayQuantity = vm.birthdayQuantity + 5;
    }
    function decreaseBirthdayLimit() {
      vm.birthdayQuantity = vm.birthdayQuantity - 5;
    }



    function checkBirthdayDoneItemsAll(task) {
      var success = function (resp) {
          vm.doneAllBirthday = false;
          vm.birthdayList.map(function (ele) {ele.done = false;})
          if (resp.data && resp.status) {
            fetchTodosList()
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.birthdayList.map(function (ele) {ele.done = false;})
          vm.doneAllBirthday = false;
          UtilService.errorHandler(err);
        }, payload = {};

      payload.taskIdList = task.map(function (ele) {
          return ele.taskId;
        });

      vm.birthdayList.map(function (ele) {ele.done = true;});//select all checkbox

      var confirmSuccess = function () {
        DashboardService.post({
          controller: 'markAllComplete'
        }, payload).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
        vm.doneAllBirthday = false;
      vm.birthdayList.map(function (ele) {ele.done = false;})
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }

    function checkBirthdayDoneItems(task, index) {
      var success = function (resp) {
          vm.doneAllBirthday = false;
          if (resp.data && resp.status) {
            vm.completedDate = resp.data.completedDate;
            vm.completedItemDescription = resp.data.itemDescription;
            (index > -1) && vm.birthdayList.splice(index, 1);
            vm.birthdayCount = vm.birthdayCount - 1;
            vm.completedTodoList.push(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.doneAllBirthday = false;
          UtilService.errorHandler(err);
        }, payload = {};

      if (index < 0) {
        payload.taskList = task.map(function (ele) {
          return ele.taskId;
        });
      } else {
        payload.taskId = task.taskId;
      }

      var confirmSuccess = function () {
        DashboardService.post({
          controller: index < 0 ? 'markAllComplete' : 'markComplete'
        }, payload).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }

    function checkPendingDoneItems(task, index) {
      var success = function (resp) {
          vm.doneAllPending = false;
          if (resp.data && resp.status) {
            vm.completedDate = resp.data.completedDate;
            vm.completedItemDescription = resp.data.itemDescription;
            (index > -1) && vm.pendingTransactionList.splice(index, 1);
            vm.pendingTransactionCount = vm.pendingTransactionCount - 1;
            vm.completedTodoList.push(resp.data);
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.doneAllPending = false;
          UtilService.errorHandler(err);
        }, payload = {};

      if (index < 0) {
        payload.taskList = task.map(function (ele) {
            return ele.taskId;
        });
      } else {
        payload.taskId = task.taskId;
      }

      var confirmSuccess = function () {
        DashboardService.post({
          controller: index < 0 ? 'markAllComplete' : 'markComplete'
        }, payload).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }

    function checkPendingDoneItemsAll(task) {
      var success = function (resp) {
        vm.doneAllPending = false;
        vm.pendingTransactionList.map(function (ele) {ele.done = false;});
          if (resp.data && resp.status) {
            fetchTodosList();
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
        vm.pendingTransactionList.map(function (ele) {ele.done = false;});
        vm.doneAllPending = false;
          UtilService.errorHandler(err);
        }, payload = {};

        payload.taskIdList = task.map(function (ele) {
              return ele.taskId;
        });
        payload.taskIdList = payload.taskIdList.filter(function( element ) {
          return element !== undefined;
        });
      vm.pendingTransactionList.map(function (ele) {ele.done = true;});
      var confirmSuccess = function () {
        DashboardService.post({
          controller: 'markAllComplete'
        }, payload).$promise.then(success, error);
      };
      var confirmError = function () {
        task.done = false;
        vm.doneAllPending = false;
        vm.pendingTransactionList.map(function (ele) {ele.done = false;});
      };
      ModalService.confirmCancelModal({Text: 'Are you sure you have completed the task ?'}, confirmSuccess, confirmError);
    }

    /* function getTaskString(pendingCount) {
     vm.taskStr = pendingCount==0 || pendingCount==1  ? "Task" : "Tasks";
     }*/

    function wishSomeone(pending) {
      var success = function (res) {
        if (res.status) {
          MessageService.success(res.message);
        } else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      DashboardService.post({
        controller: 'investor',
        child1: 'birthDayWish'
      }, {'taskId': pending.taskId}).$promise.then(success, error);

    }

    function sendReminder(transactionId) {
      if(transactionId.itemAction === vm.SELF_DECLARATION) {
        ModalService.initialLogin(transactionId.itemDescription);
        return;
      }
      var success = function (resp) {
          if (resp && resp.status) {
            // var name = (listData && listData.name)?'for '+listData.name.toUpperCase():'';
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
          }
          else {
            if(resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
          LoaderService.hideLoader();
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader();
        };
      LoaderService.showLoader();
      TransactionService.post({VERSION:HDFC_API.VERSION,controller: 'remind'}, {
        transactionId: transactionId,
        type: null
      }).$promise.then(success, error);
    }

    function fetchTodosList() {

      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.birthdayList = resp.data.birthdayList;
            vm.pendingTransactionList = resp.data.pendingTransactionList;
            vm.birthdayCount = resp.data.birthdayCount;
            vm.completedTodoList = resp.data.completedTodoList;
            vm.pendingTransactionCount = resp.data.pendingTransactionCount;
            vm.pendingTodoList.push(vm.birthdayList);
            vm.pendingTodoList.push(vm.pendingTransactionList);
            vm.pendingCount = vm.birthdayCount + vm.pendingTransactionCount;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      DashboardService.post({
        controller: 'todos',
        child1: 'all'
      }, {}).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('DashboardController', dashboardController);

  /** @ngInject */
  function dashboardController($scope, $timeout, $window, $state, InvestorModel, InvestorsService, InvestorsCommonService, TransactionService, LoaderService, ModalService, DashboardService, $filter, AppConstants, UtilService, MessageService, HDFC_API, AuthService, FundService, DashboardServiceV3, panAdharLinkingService) {
    var c3 = $window.c3 || {};
    var vm = this;
    vm.transactionSnapshot = transactionSnapshot;
    vm.toDos = toDos;
    vm.assetsUnderMgt = assetsUnderMgt;
    vm.leadsOverview = leadsOverview;
    vm.getMarketData = getMarketData;
    vm.investerTransaction = investerTransaction;
    vm.changeStatus = changeStatus;
    vm.changeLeadsOverviewStatusChannel = changeLeadsOverviewStatusChannel;
    vm.changeLeadsOverviewStatusInvestment = changeLeadsOverviewStatusInvestment;
    vm.getDistributorWidgets = getDistributorWidgets;
    vm.setSnapShot = setSnapShot;
    vm.setAssets = setAssets;
    vm.getUnit = getUnit;
    vm.getAutoSuggestion = getAutoSuggestion;
    vm.init = init;
    vm.sendReminder = sendReminder;
    vm.widgetSelection = widgetSelection;
    vm.updateWidgets = updateWidgets;
    vm.openCampaign = openCampaign;
    vm.viewStatus = viewStatus;
    // vm.nonOtmCount = nonOtmCount;
    vm.hideNonOtmModal = hideNonOtmModal;
    vm.WIDGETS_ID = AppConstants.WIDGETS_ID;
    vm.SELF_DECLARATION = AppConstants.SELF_DECLARATION_ACTION;
    vm.INVESTMENT_OVERVIEW_DEFAULT_DATA = AppConstants.INVESTMENT_OVERVIEW_DEFAULT_DATA;
    vm.DASHBOARD_TRXN_TYPES = angular.copy(AppConstants.DASHBOARD_TRANSACTION_TYPES);
    vm.REMIND_SUCCESS_MESSAGE = AppConstants.REMIND_SUCCESS_MESSAGE;
    vm.snapshotData = null;
    vm.toDosData = null;
    vm.todaysAUMAmount = {};
    vm.yesterdaySales = {};
    vm.salesChangePercentage = null;
    vm.totalPendingCount = null;
    vm.pendingList = [];
    vm.birthdayList = [];
    vm.campaignList = [];
    vm.sourceType = 'ALL';
    vm.productComparison = "";
    vm.leadsOverviewStatus = true;
    vm.snapshotTimeSelector = 'today';
    vm.assetsTimeSelector = 'today';
    vm.assetsUnderMgtSelected = -1;
    vm.autoSuggestionData = null;
    vm.channelData = null;
    vm.channelPercentagesList = null;
    vm.leadCountsDateWise = null;
    var moment = $window.moment || {};
    vm.yesterdayActive = true;
    vm.wishSomeone = wishSomeone;
    vm.updateFolioAction = updateFolioAction;
    vm.transactionId = null;
    vm.draggedPayload = null;
    vm.cancelDragEdit = cancelDragEdit;
    vm.applyDragEdit = applyDragEdit;
    vm.nonOtmPopupClosed = localStorage.getItem('nonOtmPopupClosed') || false;
    vm.redirectTo = redirectTo;
    vm.setOverviewActiveTab = setOverviewActiveTab;
    vm.activeInvestement = true;
    vm.quickLinkList = [];
    //vm.DASHBOARD_TRXN_TYPES = ["1 Year", "3 Years", "5 Years", "Since Inception"];
    vm.transactionListData = [];
    vm.totalTransactionListData = 0;
    vm.isInvestorTransactionPagination = true;
    vm.pageLimitTransactionListData = 5;
    vm.currentPageTransactionListData = 1;
    vm.defaultOption = "Since Inception";
    vm.activeTab = {};
    vm.selectedTab = selectedTab;
    vm.TRANSACTION_STATUSES = AppConstants.TRANSACTION_STATUSES;
    vm.changeYearForSipOverview = changeYearForSipOverview;
    vm.imageUrls = [
      "../../assets/images/MFD-infographic.jpg",
      "../../assets/images/RIA Banner.jpg",
      "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
    ];
    vm.redirectUrl = "https://www.hdfcfund.com/";
    vm.totalFundInFocusList = 0;
    vm.modifiedRiskProfile = [];
    vm.allFundInFocusData = [];
    vm.selectedPageLimit = 2;
    vm.isPagination = false;
    vm.currentPageFundList = 1;
    vm.selectSchemeForFund = selectSchemeForFund;
    vm.selectedScheme = [];
    vm.redirectToEquityAsset = redirectToEquityAsset;
    vm.isChangeBackgroundColorOfDonut = false;
    vm.alertAndUpdateData = [];
    vm.checkBtnAction = checkBtnAction;
    vm.showInfoModal = showInfoModal;
    vm.sipOverviewData = {};
    vm.allTranasctionStatus = {};
    vm.TRANSACTION_DROPDOWN_VALUES = [
      {key: 'LAST_7_DAYS', value: 'Last 7 Days'},
      {key: 'LAST_15_DAYS', value: 'Last 15 Days'},
      {key: 'ONE_MONTH', value: 'Last 1 Month'}
    ];
    vm.EUIN_DETAILS_DROPDOWN_VALUES = [
      {key: 'MONTHLY', value: 'Current Month'},
      {key: 'QUARTERLY', value: 'Current Quarter'},
      {key: 'YEARLY', value: 'Current FY'}
    ];
    vm.selectedTransactionOverview = vm.TRANSACTION_DROPDOWN_VALUES[2];
    vm.selectedTimePeriodForEuinDetails = vm.EUIN_DETAILS_DROPDOWN_VALUES[0];
    vm.euinDetailsList = [];
    vm.changeTimePeriod = changeTimePeriod;
    vm.selectedTimePeriodForAum = null;
    vm.rightSideWidgetList = [];
    vm.leftSideWidgetList = [];
    vm.bannerList = [];
    vm.knowledgeCenterList = [];
    vm.selectedTransactionStatusType = null;
    vm.currentPageTransactionList = 1;
    vm.initiateTransactionList = initiateTransactionList;
    vm.transactionList = [
      {name: 'SIP', action: 'SIP', iconClass: 'sip-icons'},
      {name: 'Purchase', action: 'PURCHASE', iconClass: 'purchase-icons'},
      {name: 'Add Investor', action: 'ADD_INVESTOR', iconClass: 'add-investor-icons'}
    ];
    vm.transFormedAllTranasctionStatus = [
      {name: 'Proposed', count: 0},
      {name: 'Processed', count: 0},
      {name: 'Pending', count: 0},
      {name: 'Rejected', count: 0},
      {name: 'Expired', count: 0},
      {name: 'Reversed', count: 0}
    ];
    vm.NO_INVESTER_ADDED_MSG = AppConstants.NO_INVESTER_ADDED_MSG;
    vm.performAction = performAction;
    vm.quickLinkAction = quickLinkAction;
    vm.selectTransaction = selectTransaction;
    vm.openCalculator = openCalculator;
    vm.isEmptyObject = isEmptyObject;
    vm.bannerRedirection = bannerRedirection;
    vm.init();

    function init() {
      $window.scrollTo(0,0);
      vm.getDistributorWidgets();
      $scope.$on('isChangeBackgroundOfDonut', function (args, isBackgroundChange) {
          isBackgroundChange ? vm.isChangeBackgroundColorOfDonut = false : vm.isChangeBackgroundColorOfDonut = true;
          fetchInvestmentData();
      });
      vm.draggedPayload = null;
      var successHandler = function (resp) {
        if (AuthService.getToken() && resp.popupDTO.popupDTOMap.Popup_Home) {
          (localStorage.getItem('isWelcomeMessageShown') === null) && showSomeMessage();
        }
      }

      UtilService.fetchDynamicData("HOME_SCREEN").then(successHandler).catch(function (resp) {
        MessageService.error(resp);
      });
      var identifier = AuthService.getToken();
      // getFundInFocusData();
      vm.distributorType = identifier.distributorType;
      if (identifier.investInFund) {
        var success = function (investor) {
          if (investor && investor.uuid) {
            identifier.investInFund = false;
            AuthService.setToken(identifier);
            var _state = 'main.transactions.initiate.sip';
            $state.go(_state, {
              uuid: investor.uuid,
              schemeCode: identifier.schemeCode,
              folioNumber: '',
              transactionType: '',
              transactionId: '',
              fromModify: ''
            });
          }
        }, error = function () {
          identifier.investInFund = false;
          AuthService.setToken(identifier);
          $state.go('main.dashboard');
        };
        if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
          $state.go('main.newinvestor.kycverify');
          return;
        } else {
          ModalService.searchInvestorModal({
            transactionType: 'SIP or Purchase',
            arnCode: identifier.arnCode
          }, success, error);
        }
      }
      userGreeting();
    }

    function changeStatus(sourceType) {
      vm.sourceType = sourceType ? sourceType : 'Offline';
      vm.transactionSnapshot();
    }

    function changeLeadsOverviewStatusChannel() {
      // vm.leadsOverviewStatus = true;
      var success = function (resp) {
          if (resp.data && resp.status) {
            vm.channelData = resp.data;
            leadsOverview(vm.channelData);
          } else {
            MessageService.error(resp.message);
          }
          LoaderService.hideLoader('.leads-loading');
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader('.leads-loading');
        };

      // LoaderService.showLoader('.leads-loading');
      // DashboardService.post({
      //   controller: 'channel',
      //   child1: 'leads',
      //   child2: 'overview'
      // }, {}).$promise.then(success, error);
    }

    function changeLeadsOverviewStatusInvestment() {
      var investmentPercentageList, investmentWiseLeadCountsList, investmentTypeList, i,
        tempArr;
      vm.leadsOverviewStatus = false;
      var success = function (resp) {
          if (resp.data && resp.status) {

            investmentPercentageList = resp.data.investmentPercentageList;
            investmentWiseLeadCountsList = resp.data.investmentWiseLeadCountsList;
            investmentTypeList = [];
            for (i in investmentPercentageList) {
              tempArr = [];
              tempArr.push(investmentPercentageList[i].investmentType);
              tempArr.push(investmentPercentageList[i].totalLeadCount);
              investmentTypeList.push(tempArr);
            }

            var lineFinalData = [], axisData = {};
            var lineData = sanitizeLineChartData(investmentWiseLeadCountsList);
            axisData = lineData.axisData || {};
            lineFinalData = lineData.lineFinalData || [];

            $timeout(function () {
              c3.generate({
                bindto: '#piechart-leads',
                size: {height: 250, width: 250},
                color: {pattern: ["#65d256", "#47923c", "#255f2f"]},
                data: {
                  columns: investmentTypeList,
                  type: 'pie',
                  empty: {
                    label: {
                      text: "No Data Available"
                    }
                  }
                }
              });
              vm.leadOverviewLineChart = c3.generate({
                bindto: '#linechart-leads',
                padding: {bottom: 20},
                size: {height: 250, width: 250},
                color: {pattern: ["#65d256", "#47923c", "#255f2f"]},
                data: {
                  xs: axisData,
                  columns: lineFinalData,
                  empty: {
                    label: {
                      text: "No Data Available"
                    }
                  }
                },
                axis: {
                  x: {
                    type: 'category' // this needed to load string x value
                  }
                },
                legend: {show: false}
              });
            });
          }
          LoaderService.hideLoader('.leads-loading');
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader('.leads-loading');
        };
      LoaderService.showLoader('.leads-loading');
      DashboardService.post({
        controller: 'investment',
        child1: 'leads',
        child2: 'overview'
      }, {}).$promise.then(success, error);
    }

    function sanitizeLineChartData(lineDataList) {

      var investorTypeList = [], axisData = {}, axisDataArray = [], lineDataArray = [];
      lineDataList = lineDataList || [];

      angular.forEach(lineDataList, function (val) {
        if (investorTypeList.indexOf(val.type) < 0) {
          investorTypeList.push(val.type);
        }
      });
      angular.forEach(investorTypeList, function (val, key) {
        axisData[val] = key.toString();
        axisDataArray.push([key.toString()]);
        lineDataArray.push([val, 0, 0, 0, 0, 0, 0, 0]);
      });

      for (var i = 0; i < 7; ++i) {
        var dateLabel = moment().subtract(i, 'days').format('DD-MMM-YYYY').toString();
        for (var k = 0; k < axisDataArray.length; k++) {
          axisDataArray[k].push(dateLabel);
        }
      }

      angular.forEach(lineDataList, function (leadList) {

        angular.forEach(axisDataArray[0], function (valDate, keyDate) {

          angular.forEach(lineDataArray, function (valInn, keyInn) {

            if (leadList.entryDate == valDate && leadList.type == valInn[0]) {
              lineDataArray[keyInn][keyDate] = leadList.count;
            }
          })
        })
      });
      var result = {}, lineFinalData = [];
      result.axisData = axisData;
      result.lineFinalData = lineFinalData.concat(axisDataArray, lineDataArray);
      return result;
    }

    function setSnapShot(timeSelector) {
      switch (timeSelector) {
        /* case 'today':
         vm.yesterdayActive = false;
         vm.lastWeekActive = false;
         vm.lastMonthActive = false;
         vm.snapshotTimeModel = setEndDate(0);
         break;*/
        case 'yesterday':
          vm.yesterdayActive = true;
          vm.lastWeekActive = false;
          vm.lastMonthActive = false;
          vm.snapshotTimeModel = setEndDate(1);
          break;
        case 'lastWeek':
          vm.yesterdayActive = false;
          vm.lastWeekActive = true;
          vm.lastMonthActive = false;
          vm.snapshotTimeModel = setEndDate(7);
          break;
        case 'lastMonth':
          vm.yesterdayActive = false;
          vm.lastWeekActive = false;
          vm.lastMonthActive = true;
          vm.snapshotTimeModel = setEndDate(30);
          break;
        default:
          vm.yesterdayActive = false;
          vm.snapshotTimeModel = setEndDate(0);
          break;
      }
      transactionSnapshot(vm.snapshotTimeModel);
    }

    function setAssets() {
      switch (vm.assetsTimeSelector) {
        case 'today':
          vm.assetsTimeModel = setEndDate(0);
          break;
        case 'yesterday':
          vm.assetsTimeModel = setEndDate(1);
          break;
        case 'lastWeek':
          vm.assetsTimeModel = setEndDate(7);
          break;
        case 'lastMonth':
          vm.assetsTimeModel = setEndDate(30);
          break;
        default:
          vm.assetsTimeModel = setEndDate(0);
          break;
      }
      assetsUnderMgt(vm.assetsTimeModel);
    }

    vm.round = round;

    function round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    function transactionSnapshot() {
      var payload = {
        "fromDate": "",
        "toDate": vm.snapshotTimeModel //'2016-11-29T00:38:20Z'
      };
      LoaderService.showLoader('.transsnap');
      var success = function (resp) {
          LoaderService.hideLoader('.transsnap');
          if (resp.data && resp.status) {
            vm.snapshotData = angular.equals({}, resp.data) ? {inFlowData: {}, outFlowData: {}} : resp.data;
            (vm.snapshotData.inFlowData) && (vm.snapshotData.inFlowData.totalInFlowAmount = angular.isDefined(vm.snapshotData.inFlowData) ? round(vm.snapshotData.inFlowData.totalInFlowAmount, 2) : '');
            (vm.snapshotData.outFlowData) && (vm.snapshotData.outFlowData.totalOutFlowAmount = angular.isDefined(vm.snapshotData.outFlowData) ? round(vm.snapshotData.outFlowData.totalOutFlowAmount, 2) : '');
            (vm.snapshotData.inFlowData) && (vm.snapshotData.inFlowData.amountUnit = (vm.snapshotData.inFlowData) ? UtilService.getUnitSting(vm.snapshotData.inFlowData.totalInFlowAmount) : '');
            (vm.snapshotData.inFlowData) && (vm.snapshotData.inFlowData.transactionUnit = (vm.snapshotData.inFlowData) ? UtilService.getUnitSting(vm.snapshotData.inFlowData.totalTransactions) : '');
            (vm.snapshotData.outFlowData) && (vm.snapshotData.outFlowData.amountUnit = (vm.snapshotData.outFlowData) ? UtilService.getUnitSting(vm.snapshotData.outFlowData.totalOutFlowAmount) : '');
            (vm.snapshotData.outFlowData) && (vm.snapshotData.outFlowData.transactionUnit = (vm.snapshotData.outFlowData) ? UtilService.getUnitSting(vm.snapshotData.outFlowData.totalTransactions) : '');
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.transsnap');
          UtilService.errorHandler(err);
        };
      DashboardService.post({
        controller: 'transactions',
        child1: vm.sourceType,
        child2: 'snapshot'
      }, payload).$promise.then(success, error);
    }

    function toDos() {

      var success = function (resp) {
          LoaderService.hideLoader('.todos-loader');
          if (resp.data && resp.status) {
            vm.totalPendingCount = (resp.data.pendingCount * 1 + resp.data.birthdayCount * 1 + resp.data.pendingFolioCount * 1) ? (resp.data.pendingCount * 1 + resp.data.birthdayCount * 1 + resp.data.pendingFolioCount * 1) : 0;
            vm.pendingList = resp.data.pendingList;
            vm.birthdayList = resp.data.birthdayList;
            vm.pendingFolioList = resp.data.pendingFolioList;
            // vm.campaignList = resp.data.campaignList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.todos-loader');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.todos-loader');
      DashboardService.post({
        controller: 'todos'
      }, {}).$promise.then(success, error);
    }

    function sendReminder(transactionId) {
      if (transactionId.itemAction === vm.SELF_DECLARATION) {
        ModalService.initialLogin(transactionId.itemDescription);
        return;
      }
      var success = function (resp) {
          if (resp && resp.status) {
            // var name = (listData && listData.name)?'for '+listData.name.toUpperCase():'';
            MessageService.success(vm.REMIND_SUCCESS_MESSAGE);
          } else {
            if (resp.popupEnabled) {
              ModalService.genericModal({
                text: resp.message
              })
            } else {
              MessageService.error(resp.message);
            }
          }
          LoaderService.hideLoader('.todos-loader');
        },
        error = function (err) {
          UtilService.errorHandler(err);
          LoaderService.hideLoader('.todos-loader');
        };
      LoaderService.showLoader('.todos-loader');
      TransactionService.post({VERSION: HDFC_API.VERSION, controller: 'remind'}, {
        transactionId: transactionId,
        type: null
      }).$promise.then(success, error);
    }

    vm.assetsUnderMgtTotal = {};

    function assetsUnderMgt() {
      var success = function (resp) {
          var graphData = [];
          LoaderService.hideLoader('.assetmng-loader');
          if (resp.data && resp.status) {
            vm.assetsUnderMgtData = resp.data.aumAndSchemesStatsList || [];
            vm.assetsUnderMgtData.forEach(function (val, key) {
              for (var i in val.topSchemesList) {
                val.topSchemesList[i].totalAmount = round(val.topSchemesList[i].totalAmount, 2);
              }
              // if (vm.assetsUnderMgtData[key].aumType !== 'Total') {
              var tmp = [];
              var aumType = val.aumType[0].toUpperCase() + val.aumType.slice(1).toLowerCase();
              val.amount = round(val.amount, 2);
              vm.assetsUnderMgtData[key].aumType = aumType;
              tmp.push(aumType);
              if (aumType == 'Total' && val.percentage == 100) {
                val.percentage = 0;
              }
              tmp.push(val.percentage);
              graphData.push(tmp);
              // } else {
              vm.assetsUnderMgtTotal = val;
              // }
            });
            vm.donutTitle = '';
            $timeout(function () {
              var _unit = UtilService.getUnitSting(vm.assetsUnderMgtTotal.amount);
              vm.donutTitle = '₹ ' + $filter('unit')(vm.assetsUnderMgtTotal.amount, _unit) + " " + _unit;
              vm.assetChart = c3.generate({
                bindto: '#donutchart-asset',
                donut: {
                  width: 39,
                  title: '' //vm.donutTitle
                },
                padding: {top: 40},
                size: {height: 250, width: 290}, color: {pattern: ["#00c0f2", "#103880", "#2485bd", "#4d7dbd"]},
                data: {
                  columns: [],
                  type: 'donut',
                  onclick: function (d) { //d=>object i=>path
                    $scope.$apply(function () {
                      vm.assetsUnderMgtSelected = d.index;
                      // vm.donutTitle = '₹ ' + $filter('unit')(vm.assetsUnderMgtData[vm.assetsUnderMgtSelected].amount, _unit) + " " + _unit;
                      //angular.element('.c3-chart-arcs-title').text(vm.donutTitle);
                    })
                  }
                },
                legend: {
                  item: {
                    onclick: function (d) {
                      var value;
                      //var tempData=angular.copy(graphData);

                      for (var i = 0; i < graphData.length; i++) {
                        if (graphData[i][0] == d) {
                          value = (d == "Total") ? -1 : i;
                        }

                        // if(d=='Total') {
                        //   if (tempData[i][0] == 'Total') {
                        //     tempData[i][1] = 100;
                        //   }
                        //   else {
                        //     tempData[i][1] = 0;
                        //   }
                        // }
                      }
                      $scope.$apply(function () {
                        vm.assetsUnderMgtSelected = value;
                      });

                      // vm.assetChart.load({columns: tempData});

                    },
                    onmouseover: function () {
                    },
                    onmouseout: function () {
                    }
                  }
                }
              });
              vm.assetChart.load({columns: []});
              vm.assetChart.load({columns: graphData});
              angular.element('.c3-target-Total').css({display: 'none'});
              angular.element($window.document.querySelector('.c3-chart-arcs-title')).on('click', function () {
                $scope.$apply(function () {
                  vm.assetsUnderMgtSelected = -1;
                })
              });
            })
          } else {
            vm.assetsUnderMgtData = [];
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.assetmng-loader');
          vm.assetsUnderMgtData = [];
          UtilService.errorHandler(err);
        };

      LoaderService.showLoader('.assetmng-loader');
      var payload = {
        fromDate: "",
        toDate: vm.assetsTimeModel //"2016-11-29T00:38:20Z"
      }
      DashboardService.post({
        controller: 'aumAndSchemes',
        child1: 'stats'
      }, payload).$promise.then(success, error);

    }

    function leadsOverview(channelData) {

      var channelPercentagesList = channelData.channelPercentagesList;
      var leadCountsDateWise = channelData.leadCountsDateWise;
      var channelTypeList = [];
      for (var i in channelPercentagesList) {
        var tempArr = [];
        tempArr.push(channelPercentagesList[i].channelType);
        tempArr.push(channelPercentagesList[i].totalLeadCount);
        channelTypeList.push(tempArr);
      }

      var lineFinalData = [], axisData = {};
      var lineData = sanitizeLineChartData(leadCountsDateWise, 'type');
      axisData = lineData.axisData || {};
      lineFinalData = lineData.lineFinalData || [];

      $timeout(function () {
        c3.generate({
          bindto: '#piechart-leads',
          size: {height: 250, width: 250},
          color: {pattern: ["#00c0f2", "#2485bd", "#103880"]},
          data: {
            columns: channelTypeList,
            type: 'pie',
            empty: {
              label: {
                text: "No Data Available"
              }
            }
          },
          legend: {
            item: {
              onclick: function () {
              }
            }
          }
        });

        vm.leadOverviewLineChart = c3.generate({
          bindto: '#linechart-leads',
          padding: {bottom: 20},
          size: {height: 250, width: 250},
          color: {pattern: ["#00c0f2", "#2485bd", "#103880"]},
          data: {
            xs: axisData/*{'Email': 'x1','Sms': 'x2','Whatsapp': 'x3'}*/,
            /*columns: [
             ['x1', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
             ['x2', 'Mon1', 'Tue1', 'Wed1', 'Thu1', 'Fri1', 'Sat1'],
             ['x3', 'Mon2', 'Tue2', 'Wed2', 'Thu2', 'Fri2', 'Sat2'],
             ['Email', 30, 200, 100, 400, 150, 250, 200],
             ['Sms', 20, 180, 240, 100, 190, 50, 120],
             ['Whatsapp', 80, 120, 140, 10, 290, 60, 200]
             ]*/
            columns: lineFinalData,
            empty: {
              label: {
                text: "No Data Available"
              }
            }
          },
          axis: {
            x: {
              type: 'category' // this needed to load string x value
            }
          },
          legend: {show: false}
        });
      });

    }

    function getMarketData() {
      var success = function (resp) {
          if (resp.data && resp.status) {
            if (resp.data.marketTrendResponseDTO) {
              vm.marketTrendData = resp.data.marketTrendResponseDTO;
            }
            if (resp.data.aumAndSalesResponseDTO) {
              vm.marketData = resp.data.aumAndSalesResponseDTO;
              vm.todaysAUMAmount.amount = resp.data.aumAndSalesResponseDTO.todaysAUMAmount;
              vm.todaysAUMAmount.amountUnit = UtilService.getUnitSting(resp.data.aumAndSalesResponseDTO.todaysAUMAmount);
              vm.yesterdaySales.amount = resp.data.aumAndSalesResponseDTO.yesterdaySales;
              vm.yesterdaySales.amountUnit = UtilService.getUnitSting(resp.data.aumAndSalesResponseDTO.yesterdaySales);
              vm.salesChangePercentage = resp.data.aumAndSalesResponseDTO.salesChangePercentage;
            }
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          UtilService.errorHandler(err);
        };
      DashboardService.post({controller: 'market', 'child1': 'data'}, {}).$promise.then(success, error);
    }

    function investerTransaction() {
      var success = function (resp) {
          LoaderService.hideLoader('.invst-loading');
          if (resp.data && resp.status) {
            vm.investerTrData = resp.data;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.invst-loading');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.invst-loading');
      DashboardService.post({
        controller: 'investors',
        child1: 'transactions',
        child2: 'counts'
      }, {}).$promise.then(success, error);
    }

    function setEndDate(days) {
      // return moment().subtract(days * 1, 'days').toISOString().substring(0, 19) + 'Z';
      return moment().subtract(days * 1, 'days').format('DD-MMM-YYYY').toString();
    }

    function getUnit(value) {
      return UtilService.getUnitSting(value);
    }

    function wishSomeone(bday) {
      var success = function (res) {
        if (res.status) {
          MessageService.success(res.message);
        } else {
          MessageService.error(res.message);
        }
      };
      var error = function (err) {
        UtilService.errorHandler(err);
      };

      DashboardService.post({
        controller: 'investor',
        child1: 'birthDayWish'
      }, {'taskId': bday.taskId}).$promise.then(success, error);

    }

    function openCampaign(camp) {
      if (camp.engaged) {
        return;
      }
      var success = function (resp) {
        if (resp.data && resp.status) {
          MessageService.success('Your Campaign Run Successfully.');
          getCampaignList();
          /*var successConfirm = function () {
          },errorConfirm = function () {

          };
          ModalService.widgetCampaignModalSuccess(resp, successConfirm, errorConfirm);*/
        } else {
          MessageService.error(resp.message);
        }
      }, error = function () {
      };
      var data = {};
      data.tag = camp.tag;
      data.campaignId = camp.salesPandaCampaignId || 0;
      data.campaignTitle = camp.title || '';
      ModalService.widgetCampaignModal(data, success, error);
    }

    function viewStatus(camp) {
      if (!camp.engaged) {
        return;
      }
      $window.open(camp.campaignUrl, '_blank');
    }

    function updateFolioAction(item, flag) {
      if (flag == 'Update') {

        var success = function (resp) {
          if (resp.status) {

            InvestorModel.resetInvestorModel();
            var model = InvestorModel.getNewInvestorModel();
            model.folioCreationRequestCO = resp.data;
            model.folioCreationRequestCO.uuid = item.taskId;
            InvestorModel.setInvestorModel(model);
            InvestorModel.setFolioCreationFromProfileAndToDo(true);
            InvestorModel.setTab({
              "tab1": false,
              "tab2": false,
              "tab3": false,
              "tab4": false,
              "tabJointHolderAddable": false,
              "tabGuardianDetailShow": false
            });
            $state.go('main.investors.add.appdetails', null, {reload: 'main.investors.add.appdetails'});

          } else {
            MessageService.error(resp.message);
          }
        };
        var error = function (err) {
          UtilService.errorHandler(err);
        };
        InvestorsService.post({
          controller: 'new',
          child1: 'folio',
          child2: 'data'
        }, {id: item.transactionId}).$promise.then(success, error);

      } else if (flag == 'Resend') {
        var successLink = function (resp) {
            if (resp && resp.status) {
              MessageService.success(resp.data.message);
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader('.todos-loader');
          },
          errorLink = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader('.todos-loader');
          };
        LoaderService.showLoader('.todos-loader');
        var payload = {
          linkId: item.folioCreationId,
          todoId: item.taskId
        };
        InvestorsCommonService.post({
          child1: 'link',
          child2: 'resend'
        }, payload).$promise.then(successLink, errorLink);


      } else if (flag == 'Reject') {
        var successDismiss = function (resp) {
            if (resp && resp.status) {
              MessageService.success(resp.data.message);
            } else {
              MessageService.error(resp.message);
            }
            LoaderService.hideLoader('.todos-loader');
          },
          errorDismiss = function (err) {
            UtilService.errorHandler(err);
            LoaderService.hideLoader('.todos-loader');
          };
        LoaderService.showLoader('.todos-loader');
        var payloadDismiss = {
          linkId: item.folioCreationId,
          todoId: item.taskId
        };

        InvestorsCommonService.post({
          child1: 'link',
          child2: 'dismiss'
        }, payloadDismiss).$promise.then(successDismiss, errorDismiss);
      }

    }

    function getAutoSuggestion() {
      var success = function (resp) {
          LoaderService.hideLoader('.analysis-loader');
          if (resp.data && resp.status) {
            vm.autoSuggestionData = resp.data.autoSuggestion;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.analysis-loader');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.analysis-loader');
      DashboardService.post({
        controller: 'autoSuggestion'
      }, {}).$promise.then(success, error);
    }

    function getCampaignList() {
      var success = function (resp) {
          LoaderService.hideLoader('.digi-loader');
          if (resp.data && resp.status) {
            vm.campaignList = resp.data.campaignList;
          } else {
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.digi-loader');
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader('.digi-loader');
      DashboardService.get({
        controller: 'active',
        child1: 'campaign',
        child2: 'list'
      }, {}).$promise.then(success, error);
    }

    function getDistributorWidgets() {
      var success = function (resp) {
          LoaderService.hideLoader('.dash-loader');
          if (resp.data && resp.status) {
            vm.distributorWidgetsList = resp.data.widgetList;
            if (vm.distributorWidgetsList.length > 0) {
              vm.distributorWidgetsList.forEach(function (el) {
                if (el.position % 2 === 0) {
                  vm.rightSideWidgetList.push(el);
                } else {
                  vm.leftSideWidgetList.push(el);
                }
              });

            }
            vm.widgetsIdList = vm.distributorWidgetsList.map(function (ele) {
              return ele.widgetId;
            });
            angular.forEach(vm.distributorWidgetsList, function (value, key) {
              value.col = (key * 1) % 6;
              value.sizeX = 3;
              value.sizeY = 2;
              switch (value.widgetId) {
                case vm.WIDGETS_ID.AUM:
                  // vm.WIDGETS_ID.ASSETS_ORDER = value.position;
                  $timeout(function () {
                    fetchAumData();
                  });
                  break;
                case vm.WIDGETS_ID.BANNER:
                  // vm.WIDGETS_ID.INVESTORS_ORDER = value.position;
                  $timeout(function () {
                    fetchDynamicContent();
                  });
                  break;
                case vm.WIDGETS_ID.INVESTMENT_OVERVIEW:
                  // vm.WIDGETS_ID.INVESTORS_ORDER = value.position;
                  $timeout(function () {
                    vm.investmentOverViewConfiguration = value.configuration;
                    fetchInvesmentOverview();
                    fetchGrossSalesData();
                  });
                  break;
                case vm.WIDGETS_ID.KNOWLEDGE_CENTER:
                  // vm.WIDGETS_ID.INVESTORS_ORDER = value.position;
                  $timeout(function () {
                    // fetchDynamicContent();
                    fetchKnowledegeCenterData();
                  });
                  break;
                case vm.WIDGETS_ID.EUIN_DETAILS:
                  // vm.WIDGETS_ID.INVESTORS_ORDER = value.position;
                  $timeout(function () {
                    vm.euinDetailsConfiguration = value.configuration;
                    fetchEuinDetails()
                  });
                  break;
                case vm.WIDGETS_ID.SIP_OVERVIEW:
                  // vm.WIDGETS_ID.LEADS_ORDER = value.position;
                  $timeout(function () {
                    vm.sipOverViewConfiguration = value.configuration;
                    fetchSipOverviewData();
                  });
                  break;
                case vm.WIDGETS_ID.TRANSACTION_SNAPSHOT:
                  // vm.WIDGETS_ID.LEADS_ORDER = value.position;
                  $timeout(function () {
                    changeTimePeriod('TRANSACTION_OVERVIEW', vm.selectedTransactionOverview);
                    fetchTransactionCount()
                  });
                  break;
                case vm.WIDGETS_ID.QUICK_LINKS:
                  // vm.WIDGETS_ID.MARKET_ORDER = value.position;
                  //vm.getMarketData();
                  $timeout(function () {
                    fetchQuickLinks()
                  });
                  break;
                case vm.WIDGETS_ID.ALERT_AND_UPDATES:
                  // vm.WIDGETS_ID.SNAPSHOT_ORDER = value.position;
                  $timeout(function () {
                    fetchAlertAndUpdateData()
                  });
                  break;
                case vm.WIDGETS_ID.CONNEKT:
                  // vm.WIDGETS_ID.TODO_ORDER = value.position;
                  $timeout(function () {
                    //vm.initConnekt();
                  });
                  break;
                case vm.WIDGETS_ID.TO_DO:
                  $timeout(function () {
                    toDos();
                  });
                  break;
                default:

              }
            });
            vm.gridsterOpts.maxRows = vm.distributorWidgetsList.length + 1;
            //setRestWidgetsOrder();
          } else {
            MessageService.error(resp.message);
            vm.distributorWidgetsList = [];
          }
        },
        error = function (err) {
          LoaderService.hideLoader('.dash-loader');
          UtilService.errorHandler(err);
          vm.distributorWidgetsList = [];
        };
      LoaderService.showLoader('.dash-loader');
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'distributorWidgets'
      }).$promise.then(success, error);
    }

    /*function setRestWidgetsOrder() {

     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.ASSETS) < 0) {
     vm.WIDGETS_ID.ASSETS_ORDER = 0;
     }
     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.INVESTORS) < 0) {
     vm.WIDGETS_ID.INVESTORS_ORDER = 0;
     }
     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.LEADS) < 0) {
     vm.WIDGETS_ID.LEADS_ORDER = 0;
     }
     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.MARKET) < 0) {
     vm.WIDGETS_ID.MARKET_ORDER = 0;
     }
     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.SNAPSHOT) < 0) {
     vm.WIDGETS_ID.SNAPSHOT_ORDER = 0;
     }
     if (vm.widgetsIdList.indexOf(vm.WIDGETS_ID.TODO) < 0) {
     vm.WIDGETS_ID.TODO_ORDER = 0;
     }
     }*/

    function widgetSelection() {
      ModalService.widgetStoreModal();
    }

    function updateWidgets(widgetList) {
      var success = function (resp) {
        if (!resp.status) {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      DashboardService.post({
        controller: 'widgets',
        child1: 'alignments'
      }, {widgetList: widgetList}).$promise.then(success, error);
    }

    vm.gridsterOpts = {
      resizable: {enabled: false},
      rowHeight: '205',
      // colWidth: '290',
      sparse: true,
      pushing: false,
      maxSizeX: 3,
      swapping: true,// whether or not to have items of the same size switch places instead of pushing down if they are the same size
      draggable: {
        enabled: true, // whether dragging items is supported
        handle: '.drag-icon', // optional selector for drag handle
        stop: function (event, $element, widget) {// optional callback fired when item is finished dragging
          if (widget.col == 1) {
            widget.col = 0;
          }
          if (widget.col == 2) {
            widget.col = 3;
          }
          var dragged = angular.copy($filter('orderBy')(vm.distributorWidgetsList, 'row'));
          var rowLength = 0, final = [], payload = [];
          angular.forEach(dragged, function (value) {
            (rowLength < value.row) && (rowLength = value.row);
          });
          for (var i = 0; i <= rowLength; i++) {
            var slice = dragged.filter(function (ele) {
              return ele.row == i;
            });
            var arr3 = $filter('orderBy')(slice, 'col');
            final = final.concat(arr3);
          }
          angular.forEach(final, function (value, key) {
            var tmp = {};
            tmp.position = (key * 1) + 1;
            tmp.widgetId = value.widgetId;
            payload.push(tmp);
          });
          vm.draggedPayload = payload;
          // updateWidgets(payload);
        }
      }
    };

    var listeners = {};

    listeners['UpdateDashboard'] = $scope.$on('UpdateDashboard', function (event, args) {
      if (args.listUpdated) {
        vm.init();
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in listeners) {
        if (listeners.hasOwnProperty(key) && angular.isFunction(listeners[key])) {
          listeners[key]();
        }
      }
    });

    function cancelDragEdit() {
      var success = function () {
        $state.go('main.dashboard');
      }, error = function () {
      };
      ModalService.confirmCancelModal({Text: 'Do you want to exit this page ?'}, success, error);
    }

    function applyDragEdit() {
      if (vm.draggedPayload) {
        LoaderService.showLoader();
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status) {
            var success = function () {
              $state.go('main.dashboard');
            }, error = function () {
              // MessageService.error(err);
            };
            ModalService.editDashboardSuccessModal({}, success, error);


          } else {
            MessageService.error(resp.message);
          }
        }, error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };

        angular.forEach(vm.draggedPayload, function (val) {
          switch (val.widgetId) {
            case vm.WIDGETS_ID.SNAPSHOT:
              vm.WIDGETS_ID.SNAPSHOT_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.TODO:
              vm.WIDGETS_ID.TODO_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.ASSETS:
              vm.WIDGETS_ID.ASSETS_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.MARKET:
              vm.WIDGETS_ID.MARKET_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.LEADS:
              vm.WIDGETS_ID.LEADS_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.INVESTORS:
              vm.WIDGETS_ID.INVESTORS_ORDER = val.position;
              break;
            case vm.WIDGETS_ID.DIGITAL:
              vm.WIDGETS_ID.DIGITAL_ORDER = val.position;
              break;
          }
        });

        DashboardService.post({
          controller: 'widgets',
          child1: 'alignments'
        }, {widgetList: vm.draggedPayload}).$promise.then(success, error);

      }
    }


    function hideNonOtmModal() {
      vm.nonOtmPopupClosed = true;
      localStorage.setItem('nonOtmPopupClosed', vm.nonOtmPopupClosed);
      angular.element('.non-otm-notification').hide();
    }

    vm.downloadReport = function (downloadUrl, fileName) {
      ModalService.fileDownloadModal({downloadUrl: downloadUrl, fileName: fileName});
    };

    /**
     * function responsible to show cut-off modal on login
     */
    function showSomeMessage() {
      var successModal = function () {
          localStorage.setItem('isWelcomeMessageShown', "true");
        },
        errorModal = function () {
        };
      ModalService.cutOffModalLogin({firstLogin: true}, successModal, errorModal);
    }


    /**
     * function responsible for link redirection
     */

    function quickLinkAction(item) {
      var identifier = AuthService.getToken();
      if (item.label === "EXPLORE_FUNDS") {
        openCalculator('Explore Funds', item.link);
      } else {
        var success = function (investor) {
          if (investor && investor.uuid) {
            var _state = '';
            if(item.label ==='STATEMENTS') {
              _state = 'main.investors.statements';
            } else if (item.label === "NON_FINANCIAL_TRANSACTIONS") {
              _state = 'main.investors.profile.basicinfo'
            }
            $state.go(_state, {
              investorId: investor.uuid
            });
          } else {
            MessageService.error('Unable to get uuid of selected investor');
          }
        }, error = function () {
        };
        if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
          var successModal = function () {
            $state.go('main.newinvestor.kycverify');
          }, errorModal = function () {};
          ModalService.confirmCancelModal({Text: vm.NO_INVESTER_ADDED_MSG}, successModal, errorModal);
        } else {
          if(item.label === "INVESTORS"){
            $state.go(item.link);
          }else {
            ModalService.searchInvestorModal({
              arnCode: identifier.arnCode,
              statementSearch : true,
              isStatement: item.label.toLowerCase() === 'statements' ? true : false,
            }, success, error);
          }
        }
      }
    }

    function redirectTo(url, redirectToOther, openNewTab) {
      if(redirectToOther && !openNewTab){
        $window.location.href = url;
      }else if(redirectToOther && openNewTab){
        $window.open(url, '_blank')
      }else {
        if(url === "main.transactions.all"){
          $state.go(url, {status: vm.selectedTransactionStatusType, fromDate: vm.fromDate, toDate: vm.currentDate});
        }else{
          $state.go(url);
        }
      }
    }

    /**
     * function responsible for setting overview tab active section
     */

    function setOverviewActiveTab(activeVal) {
      if (activeVal === 'inv') {
        vm.activeInvestement = true;
      } else {
        vm.activeInvestement = false;
      }
    }

    /**
     * function responsible for fetching Investment overview data
     */

    function fetchInvestmentData() {
      LoaderService.showLoader('.investment-overview-loader');
      $timeout(function () {
        Highcharts.chart('', {
          chart: {
            type: 'variablepie',
            renderTo: 'chart-container',
            backgroundColor: vm.isChangeBackgroundColorOfDonut ? '#1F2326' : '#fff',
            // events: {
            //   load: function () {
            //     var points = this.series[0].points;
            //     points.forEach(function (p) {
            //       if (p.connector) {
            //         p.connector.attr({
            //           'stroke-dasharray': "4, 4"
            //         });
            //       }
            //     });
            //   }
            // }
          },
          plotOptions: {
            variablepie: {
              borderWidth: 0,
              slicedOffset: 0,
              dataLabels: {
                enabled: false,
                connectorWidth: 1,
                connectorPadding: 5,
                connectorColor: '#ccc',
                connectorDashStyle: 'dot',
                style: {
                  fontSize: '18px',
                  textOutline: '1px contrast', // Set the text outline
                  dashStyle: 'dot' // Set the connector line dash style
                },
                formatter: function () {
                  // Get the index of the current data point
                  var index = this.point.index;
                  // Define an array of colors
                  var colors = ['#174D8D', '#EDAC6A', '#49AEA7']; // Add more colors as needed
                  // Set the color of the data label based on the index
                  var color = colors[index % colors.length];
                  // Return the formatted data label with the color
                  return '<span style="color: ' + color + '">' + this.point.name + '</span>';
                }
              }
            }
          },
          title: {
            text: '',
            align: 'left'
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>'
          },
          series: [{
            innerSize: '60%',
            zMin: 0,
            name: 'countries',
            borderRadius: 0,
            data: getSeriesData(),
            pointPadding: 0,
            groupPadding: 0,
            showInLegend: true
          }],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                legend: {
                  enabled: true,
                  itemStyle: {
                    color: !vm.isChangeBackgroundColorOfDonut ? '#1F2326' : '#fff'// Set text color based on dark or light mode
                  },
                  itemHoverStyle: {
                    color: !vm.isChangeBackgroundColorOfDonut ? '#1F2326' : '#fff' // hover color, same as normal
                  }
                }
              }
            }]
          }
        });
        vm.equityPercGross = 0;
        vm.liquidPercGross = 0;
        vm.debitPercGross = 0;
        LoaderService.hideLoader('.investment-overview-loader');
      }, 1000)
    }

    function changeYearForSipOverview() {
      if (vm.selectedSipOverview) {
        console.log(vm.selectedSipOverview);
      }
    }

    function selectedTab(type, count) {
      vm.selectedTransactionStatusType = type;
      vm.totalShowingTransactionCount = count;
      vm.activeTab = {};
      initTab(type);
    }

    function initTab(type) {
      switch (type) {
        case "Proposed" :
          vm.activeTab = {0: true};
          break;
        case "Processed" :
          vm.activeTab = {1: true};
          break;
        case "Pending" :
          vm.activeTab = {2: true};
          break;
        case "Rejected" :
          vm.activeTab = {3: true};
          break;
        case "Expired" :
          vm.activeTab = {4: true};
          break;
        case "Reversed" :
          vm.activeTab = {5: true};
          break;
        default :
      }
    }

    /* function responsible for getting trending funds */

    function getFundInFocusData() {
      LoaderService.showLoader('fund-and-focus-loader');
      var success = function (resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader('fund-and-focus-loader')
          vm.allFundInFocusData = resp.data.trending;

          if (vm.allFundInFocusData) {
            vm.totalFundInFocusList = vm.allFundInFocusData.length;
            handleRiskProfile(vm.allFundInFocusData);
          }

          vm.isPagination = vm.allFundInFocusData && vm.allFundInFocusData.length;
        } else {
          LoaderService.hideLoader('fund-and-focus-loader');
          vm.allFundInFocusData = [];
          vm.totalFundInFocusList = 0;
          vm.isPagination = false;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        LoaderService.hideLoader('fund-and-focus-loader');
        UtilService.errorHandler(err);
        vm.allFundInFocusData = [];
        vm.totalFundInFocusList = 0;
        vm.isPagination = false;
      };
      FundService.get({
        child1: 'new',
        child2: 'user',
        child3: 'fund',
        child4: 'trending'
      }).$promise.then(success, error);
    }

    /* function responsible for handling risk profile */

    function handleRiskProfile(allFundsList) {
      vm.modifiedRiskProfile = [];
      allFundsList.forEach(function (risk) {
        if (risk.riskReturnProfile) {
          vm.modifiedRiskProfile.push(risk.riskReturnProfile.replace('risk', '').trim());
        }
      })
    }

    function selectSchemeForFund() {
    }

    function redirectToEquityAsset(aumType, amount) {
      if(amount && amount !== "NA"){
        $state.go('main.equityAsset', {
          selectedAUM: aumType
        });
      }
    }

    function fetchAlertAndUpdateData() {
      var success = function (resp) {
        LoaderService.hideLoader('.alert-update-loader');
        if (resp && resp.data) {
          vm.alertAndUpdateData = resp.data.content;
        } else {
          LoaderService.hideLoader('.alert-update-loader');
          vm.alertAndUpdateData = []
        }
      }, error = function (err) {
        LoaderService.hideLoader('.alert-update-loader');
        MessageService.error(err.message);
        vm.alertAndUpdateData = [];
      };
      LoaderService.showLoader('.alert-update-loader');
      DashboardServiceV3.post({
        child1: 'dashboard',
        child2: 'alerts'
      }, null).$promise.then(success, error)
    }

    function fetchQuickLinks() {
      var success = function (resp) {
        LoaderService.hideLoader('.quick-link-loader');
        if (resp && resp.data) {
          vm.quickLinkList = resp.data.quickLinkMap;
        } else {
          LoaderService.hideLoader('.quick-link-loader');
          vm.quickLinkList = []
        }
      }, error = function (err) {
        LoaderService.hideLoader('.quick-link-loader');
        MessageService.error(err.message);
        vm.quickLinkList = []
      };
      LoaderService.showLoader('.quick-link-loader');
      DashboardServiceV3.post2({
        child1: 'dashboard',
        child2: 'quick',
        child3: 'link'
      }, null).$promise.then(success, error)
    }

    function fetchGrossSalesData() {
      var success = function (resp) {
        LoaderService.hideLoader('.investment-overview-loader');
        if (resp && resp.data) {
          vm.grossSalesData = resp.data;
        } else {
          LoaderService.hideLoader('.investment-overview-loader');
          vm.grossSalesData = {}
          vm.grossSalesNotAvailable = true;
          vm.defaultMessageForGrossSale = resp.message
        }
      }, error = function (err) {
        LoaderService.hideLoader('.investment-overview-loader');
        MessageService.error(err.message);
        vm.grossSalesData = {}
      };
      LoaderService.showLoader('.investment-overview-loader');
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'gross_sales'
      }).$promise.then(success, error)
    }

    function fetchSipOverviewData() {
      var success = function (resp) {
        LoaderService.hideLoader('.sip-overview-loader');
        if (resp && resp.data) {
          vm.sipOverviewData = resp.data;
          vm.isSipOverviewDataEpmty = isEmpty(vm.sipOverviewData);
        } else {
          LoaderService.hideLoader('.sip-overview-loader');
          vm.sipOverviewData = {}
        }
      }, error = function (err) {
        LoaderService.hideLoader('.sip-overview-loader');
        MessageService.error(err.message);
        vm.sipOverviewData = {}
      };
      LoaderService.showLoader('.sip-overview-loader');
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'sip',
        child3: 'stats'
      }).$promise.then(success, error)
    }

    /* function responsible for transaction status count */

    function fetchTransactionCount() {
      var success = function (resp) {
        LoaderService.hideLoader('.transaction-overview-loader');
        if (resp && resp.data) {
          vm.allTransactionsStatus = resp.data.allTransactionsStatus;
          for (var i = 0; i < vm.transFormedAllTranasctionStatus.length; i++) {
            var status = vm.transFormedAllTranasctionStatus[i];
            var propertyName = status.name.toLowerCase() + 'Count';

            if (vm.allTransactionsStatus.hasOwnProperty(propertyName)) {
              status.count = vm.allTransactionsStatus[propertyName];
            }
          }
          vm.showSeletedStatus = null;
          if(vm.selectedTransactionStatusType){
            vm.transFormedAllTranasctionStatus.forEach(function (transaction) {
              if(transaction.name == vm.selectedTransactionStatusType){
                vm.showSeletedStatus = transaction;
              }
            })
          }else {
            vm.showSeletedStatus = vm.transFormedAllTranasctionStatus[0];
          }
          selectedTab(vm.showSeletedStatus.name, vm.showSeletedStatus.count);
          fetchTransactionList();
        } else {
          LoaderService.hideLoader('.transaction-overview-loader');
          vm.allTranasctionStatus = {}
        }
      }, error = function (err) {
        LoaderService.hideLoader('.transaction-overview-loader');
        MessageService.error(err.message);
        vm.allTranasctionStatus = {}
      };
      var payload = {
        dropdownOption: vm.selectedTransactionOverview.key
      };
      LoaderService.showLoader('.transaction-overview-loader');
      DashboardService.post({
        controller: 'transactions',
        child1: 'ALL',
        child2: 'snapshot'
      }, payload).$promise.then(success, error)
    }

    /* function responsible for fetching euin details */
    function fetchEuinDetails() {
      var success = function (resp) {
        LoaderService.hideLoader('.euin-loader');
        if (resp && resp.data) {
          vm.euinDetailsList = resp.data.euinGrossSalesDTOList;
        } else {
          LoaderService.hideLoader('.euin-loader');
          vm.euinDetailsList = [];
        }
      }, error = function (err) {
        LoaderService.hideLoader('.euin-loader');
        MessageService.error(err.message);
        vm.euinDetailsList = []
      };
      var payload = {
        pageIndex: 0,
        pageLimit: 5,
        grossPeriod: vm.selectedTimePeriodForEuinDetails.key,
        searchText: null
      };
      LoaderService.showLoader('.euin-loader');
      DashboardServiceV3.post({
        child1: 'dashboard',
        child2: 'euin',
        child3: 'gross_sales'
      }, payload).$promise.then(success, error)
    }

    /* function responsible for fetching AUM data */
    function fetchAumData() {
      var success = function (resp) {
        LoaderService.hideLoader('.aum-loader');
        if (resp && resp.data) {
          vm.aumData = resp.data;
          vm.selectedValueForAUM = resp.data.selectedOption;
          vm.aumDropdownList = resp.data.dropdownOptionList;
          for (var i = 0; i < vm.aumDropdownList.length; i++) {
            if (vm.aumDropdownList[i].value === vm.selectedValueForAUM) {
              vm.selectedTimePeriodForAum = vm.aumDropdownList[i];
              break; // Exit the loop once the object is found
            }
          }
        } else {
          LoaderService.hideLoader('.aum-loader');
          vm.aumData = {};
          vm.aumDropdownList = []
        }
      }, error = function (err) {
        LoaderService.hideLoader('.aum-loader');
        MessageService.error(err.message);
        vm.aumData = {};
        vm.euinDetailsList = []
      };
      var payload = {
        dropdownOption: vm.selectedTimePeriodForAum ? vm.selectedTimePeriodForAum.key : null
      };
      LoaderService.showLoader('.aum-loader');
      DashboardServiceV3.post({
        child1: 'dashboard',
        child2: 'aum',
        child3: 'overview'
      }, vm.selectedTimePeriodForAum ? payload : null).$promise.then(success, error)
    }

    /* function responsible for fetching Investment Overview data */
    function fetchInvesmentOverview() {
      var success = function (resp) {
        LoaderService.hideLoader('.investment-overview-loader');
        if (resp && resp.data) {
          vm.investmentOverviewData = resp.data.aumAndSchemesStatsList;
          if (vm.investmentOverviewData) {
            vm.investmentObjectAumPercentageObject = {};

            for (var i = 0; i < vm.investmentOverviewData.length; i++) {
              var obj = vm.investmentOverviewData[i];
              vm.investmentObjectAumPercentageObject[obj.aumType] = obj.percentage;
            }
            fetchInvestmentData()
          }
        } else {
          LoaderService.hideLoader('.investment-overview-loader');
          vm.investmentOverviewData = [];
        }
      }, error = function (err) {
        LoaderService.hideLoader('.investment-overview-loader');
        MessageService.error(err.message);
        vm.investmentOverviewData = [];
      };
      LoaderService.showLoader('.investment-overview-loader');
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'investment',
        child3: 'overview'
      }).$promise.then(success, error)
    }

    function checkBtnAction(btnData) {
      if (btnData) {
        if (btnData.actionType == "DOWNLOAD" && btnData.download) {
          $window.open(btnData.link, "_blank");
        } else if (btnData.actionType == "MODIFY_SIP") {
          $state.go(btnData.link, {
            status: vm.DASHBOARD_TRXN_TYPES.ACTIVE,
            transactionType: vm.DASHBOARD_TRXN_TYPES.SIP
          });
        } else if (btnData.actionType == "ADD_NOMINEE") {
          var identifier = AuthService.getToken();
          var success = function (investor) {
            if (investor && investor.uuid) {
              var _state = 'main.investors.profile.basicinfo';
              $state.go(_state, {
                investorId: investor.uuid
              });
            } else {
              MessageService.error('Unable to get uuid of selected investor');
            }
          }, error = function () {
          };
          if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
            var successModalForSidebar = function () {
              $state.go('main.newinvestor.kycverify');
            }, errorModalForSidebar = function () {};
            ModalService.confirmCancelModal({Text: vm.NO_INVESTER_ADDED_MSG}, successModalForSidebar, errorModalForSidebar);
          } else {
            ModalService.searchInvestorModal({
              arnCode: identifier.arnCode,
              statementSearch : true
            }, success, error);
          }
        } else {
          $window.open(btnData.link, "_blank");
        }
      }
    }

    function showInfoModal(title, content, date, image) {
      var successhandler = function () {
        console.log("success");
      }, errorHandler = function () {
        console.log("error");
      };
      ModalService.alertAndUpdateInfoModal({
        title: title,
        content: content,
        date: date,
        image: image
      }, successhandler, errorHandler);
    }

    function changeTimePeriod(widgetName, value) {
      if (widgetName == 'AUM') {
        vm.selectedTimePeriodForAum = value;
        fetchAumData();
      } else if (widgetName == 'EUIN') {
        vm.selectedTimePeriodForEuinDetails = value;
        fetchEuinDetails();
      } else if (widgetName == 'TRANSACTION_OVERVIEW') {
        vm.selectedTransactionOverview = value;
        vm.fromDate = null;
        vm.currentDate = moment();
        var cloneCurrentDate = vm.currentDate.clone();
        if (vm.selectedTransactionOverview) {
          if (vm.selectedTransactionOverview.key == "LAST_7_DAYS") {
            vm.fromDate = moment(cloneCurrentDate.subtract(7, 'days'));
          } else if (vm.selectedTransactionOverview.key == "LAST_15_DAYS") {
            vm.fromDate = moment(cloneCurrentDate.subtract(15, 'days'));
          } else {
            vm.fromDate = moment(cloneCurrentDate.subtract(1, 'month'));
          }
        }
        fetchTransactionCount();
      }
    }

    function isEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    }

    function fetchDynamicContent() {
      var successHandler = function (resp) {
        if (resp) {
          if (resp.bannerDTO && resp.bannerDTO.bannerItemDTOList.length > 0) {
            vm.bannerList = resp.bannerDTO.bannerItemDTOList;
            $timeout(function() {
              $('#bannerCarousel').carousel();
            });
          }
          // if (resp.imageDTO && resp.imageDTO.knowledgeCenterList.length > 0) {
          //   vm.knowledgeCenterList = resp.imageDTO.knowledgeCenterList;
          // }
        }
      };
      UtilService.fetchDynamicData('DASHBOARD').then(successHandler).catch(function (resp) {
        MessageService.error(resp);
      });
    }

    function initiateTransactionList() {
      fetchTransactionList();
    }

    /* function responsible for fetching Transaction list data */
    function fetchTransactionList() {
      var success = function (resp) {
        LoaderService.hideLoader('.transaction-overview-loader');
        if (resp && resp.data) {
          vm.totalTransactionListData = resp.data.totalTransactions;
          vm.totalShowingTransactionCount = resp.data.totalTransactions;
          vm.transactionListData = resp.data.transactionList;
          vm.isInvestorTransactionPagination = !!(vm.transactionListData && vm.transactionListData.length);
          vm.fromText = ((vm.currentPageTransactionListData - 1) * vm.pageLimitTransactionListData) + 1; //((currentPage -1) * itemsPerPage) + 1
          vm.toText = vm.currentPageTransactionListData * vm.pageLimitTransactionListData < vm.totalShowingTransactionCount ? vm.currentPageTransactionListData * vm.pageLimitTransactionListData: vm.totalShowingTransactionCount;
          vm.transactionListData.forEach(function(list) {
            if(list.action.length > 0) {
              list.selectTransaction = selectTransaction;
              list.actionSelected = list.action[0];
            }
          });
        } else {
          LoaderService.hideLoader();
          vm.transactionListData = [];
          vm.totalTransactionListData = 0;
          vm.isInvestorTransactionPagination = false;
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        MessageService.error(err.message);
        vm.transactionListData = [];
        vm.isInvestorTransactionPagination = false;
      };
      var statusPayload = {
        "fromDate": vm.fromDate.format('DD-MMM-YYYY'),
        'pageIndex': vm.currentPageTransactionListData - 1,
        'pageLimit': 5,
        'searchText': '',
        "toDate": vm.currentDate.format('DD-MMM-YYYY'),
        "flowType": "ALL",
        "transactionNature": "ALL",
        "transactionStatus": vm.selectedTransactionStatusType ? vm.selectedTransactionStatusType.toUpperCase() : null,
        "transactionType": [
          "ALL"
        ],
        "sourceType": "ALL",
        "sortKey": "transactionDateTime",
        "sortValue": "DESC",
        "apiVersion": 2
      };
      LoaderService.showLoader('.transaction-overview-loader');
      DashboardServiceV3.post({
        child1: 'transaction',
        child2: 'search'
      }, statusPayload).$promise.then(success, error)
    }

    /*
    * Funcation to perform transaction action as per the user selection
    * */
    function performAction(action) {
      var identifier = AuthService.getToken();
      var success = function (investor) {
        if (investor && investor.uuid) {
          $state.go('main.transactions.initiate.sip', {
            uuid: investor.uuid,
            schemeCode: '',
            folioNumber: '',
            transactionType: action,
            transactionId: '',
            fromModify: ''
          });
        }
      }, error = function() {}
      if (action == 'ADD_INVESTOR') {
        $state.go('main.newinvestor.kycverify');
      } else {
        if (identifier.distributorType === AppConstants.NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR) {
          $state.go('main.newinvestor.kycverify');
          return;
        } else {
          ModalService.searchInvestorModal({
            transactionType: action,
            arnCode: identifier.arnCode
          }, success, error);
        }
      }
    }

    /*
    * function responsible to set welcome greeting
    * */
    function userGreeting() {
      var d = new Date();
      var time = d.getHours();
      if(time>=6 && time<12) {
        vm.greetings = 'Good Morning';
      } else if(time>=12 && time<18) {
        vm.greetings = 'Good Afternoon';
      } else {
        vm.greetings = 'Good Evening';
      }
      vm.distributorName = sessionStorage.getItem('distributorName');
      $scope.$on('distributorName', function (event, args) {
        vm.distributorName = "";
        $timeout(function () {
          vm.distributorName = args.distributorName
        });
      });
    }

    /*
    * Function responsible to handle sip over action
    * param: data, action
    * data: transaction data
    * */
    function selectTransaction(data) {
      data.transactionID = data.transactionId;
      switch (data.actionSelected.toUpperCase()) {
        case "RENEW":
          reInitiateAction(data);
          break;
        case "REINITIATE":
          getInvestorId(data);
          break;
        case "SIP TOP-UP":
          goToTopup(data);
          break;
        case "MODIFY SIP":
          var successHandler = function(resp) {
            if(resp){
              vm.cancelNudgeMessages = resp;
              var success = function() {
                data.isModify = true;
                reInitiateAction(data);
              };
              var cancel = function() {}
              ModalService.confirmCancelModal({
                Text: vm.cancelNudgeMessages.popupDTO.popupDTOMap.SYSTEMATIC_MODIFY_MESSAGE.content,
                confirmModifySip : true
              },success,cancel);
            }
          };

          UtilService.fetchDynamicData("MODIFY_SYSTEMATIC_CORNER").then(successHandler).catch(function(resp) {
            MessageService.error(resp);
          });
          break;
        case "TOP-UP":
          goToTopup(data);
          break;
      }
    }

    function getInvestorId(val) {
      var success = function (resp) {
        if (resp.data && resp.status) {
          initiateTransactionType(resp.data, val);
        } else {
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        UtilService.errorHandler(err);
      };
      TransactionService.post({
        VERSION:HDFC_API.VERSION,
        controller: 'investor',
        'folioNumber': val.folioNumber
      }, {}).$promise.then(success, error);
    }

    function initiateTransactionType(investorId, val) {
      investorId = investorId.investorId?investorId.investorId:investorId;
      var status = vm.selectedTransactionStatusType.toUpperCase();
      switch (val.transactionType) {
        case 'SWITCH':
          $state.go('main.transactions.initiate.switch', {
            uuid: investorId,
            transactionType: val.transactionType,
            transactionId: val.transactionId,
            status: status
          });
          break;
        case 'SIP':
        case 'PURCHASE':
          $state.go('main.transactions.initiate.sip', {
            uuid: investorId,
            transactionType: val.transactionType,
            transactionId: val.transactionId,
            schemeCode: val.schemeCode,
            amount: val.amount,
            status: status,
            fromDash: true
          });
          break;
        case 'STP':
          $state.go('main.transactions.initiate.stp', {
            uuid: investorId,
            transactionType: val.transactionType,
            transactionId: val.transactionId,
            status: status
          });
          break;
        case 'SWP':
          $state.go('main.transactions.initiate.swp', {
            uuid: investorId,
            transactionType: val.transactionType,
            transactionId: val.transactionId,
            status: status
          });
          break;
        case 'REDEMPTION':
          $state.go('main.transactions.initiate.redeem', {
            uuid: investorId,
            transactionType: val.transactionType,
            transactionId: val.transactionId,
            status: status
          });
          break;
      }
    }

    function reInitiateAction(investor) {
      var payload = {"investorUUID": investor.investorId};
      var success = function (resp) {
        if (resp.status && resp.data) {
          var state = 'main.transactions.initiate.' + (investor.transactionType).toLowerCase();
          if(investor.isModify && (investor.transactionType === "SIP" || investor.transactionType === "SIP_TOP_UP")){
            investor.type = "SIP";
            if(investor.frequency == "Business Days(BZ)"){
              investor.autoFrequency = "Daily";
            }else {
              investor.autoFrequency = investor.frequency;
            }
            investor.schemeName = investor.scheme;
            sessionStorage.setItem('modifySipData', JSON.stringify(investor));
            $state.go('main.transactions.initiate.sip',{
              uuid : investor.investorId,
              fromModify : true
            });
          }else {
            $state.go(state, {
              uuid: investor.investorId,
              schemeCode: investor.schemeCode,
              transactionType: investor.transactionType,
              txnId: investor.transactionID,
              folioNumber: investor.folioNumber,
              frequency: investor.frequency,
              amount:investor.amount,
              fromRenew : true
            });
          }
        } else {
          if(resp.popupEnabled) {
            ModalService.genericModal({
              text: resp.message
            })
          }
        }
      }, error = function (err) {
      };
      var successHandlerForPanAadhar = function(){
        LoaderService.hideLoader();
        InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
      }, errorHandlerForPanAadhar = function(){
        return;
      };
      panAdharLinkingService.checkPanAdharStatus(investor.pan, investor.folioNumber, vm.brokerCode).then(successHandlerForPanAadhar).catch(errorHandlerForPanAadhar);
    }

    function goToTopup(transactionData) {
      if(transactionData && transactionData.transactionType == "PURCHASE"){
        getInvestorId(transactionData);
      }else {
        transactionData.autoFrequency = transactionData.frequency;
        $state.go('main.transactions.initiate.siptopup', {transactionData: transactionData});
      }
    }

    function openCalculator(title, url) {
      ModalService.genericUiModal({
        title: title,
        url: url
      });
    }

    function getSeriesData() {
      var array = [];
      if (vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Equity){
        array.push({
          name: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Equity ? vm.investmentObjectAumPercentageObject.Equity && UtilService.getCommaSeperatedWithFloatValue(vm.investmentObjectAumPercentageObject.Equity, 2) + '%' + '<br>' + 'Equity' : '',
          y: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Equity ? vm.investmentObjectAumPercentageObject.Equity : 0,
          z: 45,
          color: {
            linearGradient: {
              x1: 1,
              y1: 1,
              x2: 0,
              y2: 1
            },
            stops: [
              [0.0155, '#00215C'],
              [0.3024, '#174D8D'],
              [0.8103, '#1397B6']
            ]
          }
        });
      }
      if(vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Debt){
        array.push({
          name: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Debt ? vm.investmentObjectAumPercentageObject.Debt && UtilService.getCommaSeperatedWithFloatValue(vm.investmentObjectAumPercentageObject.Debt, 2) + '%' + '<br>' + 'Debt' : '',
          y: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Debt ? vm.investmentObjectAumPercentageObject.Debt : 0,
          z: 35,
          color: {
            linearGradient: {
              x1: 1,
              y1: 0,
              x2: 0,
              y2: 0
            },
            stops: [
              [0.0018, '#EBAE70'],
              [0.8751, '#F9942C']
            ]
          }
        });
      }
      if(vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Liquid){
        array.push({
          name: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Liquid ? vm.investmentObjectAumPercentageObject.Liquid && UtilService.getCommaSeperatedWithFloatValue(vm.investmentObjectAumPercentageObject.Liquid, 2) + '%' + '<br>' + 'Liquid' : '',
          y: vm.investmentObjectAumPercentageObject && vm.investmentObjectAumPercentageObject.Liquid ? vm.investmentObjectAumPercentageObject.Liquid : 0,
          z: 15,
          color: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, '#42A49C'],
              [1, '#66DDD3']
            ]
          }
        });
      }
      return array;
    }

    function isEmptyObject(obj) {
      return angular.equals({}, obj);
    }

    function bannerRedirection(item){
      if (item && item.redirectURL) {
        $window.open(item.redirectURL, '_blank');
      }
    }

    function fetchKnowledegeCenterData() {
      LoaderService.showLoader();
      var success = function(response) {
        LoaderService.hideLoader();
        if (response.status && response.data) {
          vm.knowledgeCenterList = response.data.knowledgeCenterList;
          vm.knowledgeCenterList.forEach(function(data) {
            if (data.header.toLowerCase() === "factsheets") {
              data.index = 1;
            } else if (data.header.toLowerCase() === "leaflets") {
              data.index = 2;
            } else {
              data.index = 3;
            }
          });
        } else {
          vm.knowledgeCenterList = [];
          MessageService.error(response.message);
        }
      }, error = function(err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
      };
      DashboardServiceV3.get({
        child1: 'dashboard',
        child2: 'knowledgeCenter'
      }).$promise.then(success, error);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ContactUsController', contactUsController);

  function contactUsController(AuthService, $window, dynamicContactUsData) {
    var vm = this;
    vm.goBack = goBack;
    vm.dynamicContactUsData = dynamicContactUsData.contactUsDTO;
    vm.contactUsListData = vm.dynamicContactUsData && vm.dynamicContactUsData.contactUsList ? vm.dynamicContactUsData.contactUsList : [];
    vm.isLoggedIn = false;

    vm.init = init();
    function init() {
      var identifier = AuthService.getToken();
      if (identifier && identifier.access_token) {
        vm.isLoggedIn = true;
      } else {
        vm.isLoggedIn = false;
      }
    }

    function goBack() {
      $window.history.back();
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ChangeDividendController', changeDividendController);

  function changeDividendController(ChangeDividendService , InvestorsService ,AuthService, MessageService, $state, $stateParams , LoaderService, ModalService , UtilService , dynamicData,panAdharLinkingService) {
    var vm = this;
    vm.investorUUID = $stateParams.uuid;
    vm.formData={
      folioNumber : '',
      outSchemeObj : '',
      dividendOption : '',
      isCheckedTandC : ''
    };

    vm.fetchFolioList = fetchFolioList;
    vm.getDetails = getDetails;
    vm.getInvestorInfo = getInvestorInfo;
    vm.dynamicNote = dynamicData.noteDTO.noteDTOMap.Note_ICDW;
    vm.showTerms = true;
    vm.showTermConditions = showTermConditions;

    vm.init = function () {
      getInvestorInfo(function() {
        if($stateParams){
          preFilled();
        }
        fetchFolioList();
      });
      var successHandler = function(resp) {
        vm.termsConditionData = resp.termAndConditionDTO.termAndConditionDTOMap;
        vm.termsConditionData.TNC_General && vm.termsConditionData.TNC_General.content ?  vm.showTerms = true : vm.showTerms = false
      }

      UtilService.fetchDynamicData("TNC_GENERAL").then(successHandler).catch(function(resp) {
         MessageService.error(resp);
      });
    };

    function preFilled(){
      vm.formData.folioNumber = $stateParams.folioNumber;
      vm.folioChanged();
    }

    function getInvestorInfo(cb) {
      cb = cb || function () {};
      var payload = {"investorUUID": vm.investorUUID};
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.investorInfo = resp.data;
          cb();
        } else {
          vm.investorInfo = null;
          if(resp.popupEnabled) {
            $state.go('main.investors.profile.basicinfo',{investorId: vm.investorUUID});
            ModalService.genericModal({
              text: resp.message
            })
          } else {
            MessageService.error(resp.message);
          }
        }
      }, error = function (err) {
        LoaderService.hideLoader();
        UtilService.errorHandler(err);
        vm.investorInfo = null;
      };
      LoaderService.showLoader();
      InvestorsService.post({controller: 'info'}, payload).$promise.then(success, error);
    }



    function fetchFolioList() {
      var payload = {
        "investorUUID": vm.investorUUID,
        "folioTrxnType": "CDO"
      };
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            var folioListData = resp.data.folioList || [];
            var folioList = [];
            Object.keys(folioListData).forEach(function (key) {
              var obj = Object.assign({key: key}, folioListData[key]);
              folioList.push(angular.copy(obj));
            });
            vm.folioList = folioList.length ? folioList : null;
          } else {
            vm.folioList = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          vm.folioList = null;
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      // ChangeDividendService.get({ investorUUID  : vm.investorUUID}).$promise.then(success, error);
      // ChangeDividendService.get({
      //   child1:'v2' ,
      //   child2:'nft' ,
      //   child3 : 'folio' ,
      //   child4: 'list' ,
      //   child5: vm.investorUUID}).$promise.then(success, error);
      InvestorsService.post({controller: 'folioList'},payload).$promise.then(success, error);
    }


    // function fetchFolioList() {
    //   var success = function (resp) {
    //       LoaderService.hideLoader();
    //       if (resp.status && resp.data) {
    //         var folioList = resp.data.folioMap
    //         vm.folioList = folioList.length ? folioList : null;
    //       } else {
    //         vm.folioList = null;
    //         MessageService.error(resp.message);
    //       }
    //     },
    //     error = function (err) {
    //       LoaderService.hideLoader();
    //       vm.folioList = null;
    //       UtilService.errorHandler(err);
    //     };
    //   LoaderService.showLoader();
    //   // ChangeDividendService.get({ investorUUID  : vm.investorUUID}).$promise.then(success, error);
    //   ChangeDividendService.get({
    //     child1:'v2' ,
    //     child2:'nft' ,
    //     child3 : 'folio' ,
    //     child4: 'list' ,
    //     child5: vm.investorUUID}).$promise.then(success, error);
    // }

    vm.folioChanged = function () {
      if (!vm.formData.folioNumber) {
        vm.formData = {};
        return;
      }
      var brokerCode = sessionStorage.getItem("brokerCodePanAdhar");
      var successHandler = function(resp) {
        getDetails()
      }

      var errorHandler = function(resp) {
        vm.formData.folioNumber = null;
      }

      panAdharLinkingService.checkPanAdharStatus(vm.investorInfo.panNumber,vm.formData.folioNumber,brokerCode).then(successHandler).catch(errorHandler);

    };

    function getDetails() {
      if (!vm.formData.folioNumber) {
        return;
      }
      vm.details = null;
      vm.isCheckedTandC = '';
      var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.details = resp.data.reinvestSchemeDTOs || [];
            vm.details.map(function(item, ind){
              item.index = ind;
            });
            if($stateParams && $stateParams.schemeCode){
              var schemeCode = $stateParams.schemeCode;
              vm.selected = vm.details.filter(function (el) {
                return el.schemeCode == schemeCode;
              });

              vm.formData.outSchemeObj = vm.selected[0];
              vm.outSchemeChanged();
            }
          } else {
            vm.details = null;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          LoaderService.hideLoader();
          UtilService.errorHandler(err);
        };
      LoaderService.showLoader();
      ChangeDividendService.get({
        child1: 'v2',
        child2: 'nft',
        child3: vm.formData.folioNumber,
        child4: vm.investorUUID,
        child5: 'scheme',
        child6: 'reinvest'
      }).$promise.then(success, error);
    }

    vm.outSchemeChanged = function () {
      if(vm.formData.outSchemeObj) {
        if (vm.formData.outSchemeObj.reinvest === 'Y') {
          vm.reInvest = 'Reinvest';
          vm.formData.dividendOption = 'Payout';
        } else {
          vm.reInvest = 'Payout';
          vm.formData.dividendOption = 'Reinvest'
        }
      }
    };

    vm.submitChangeDividend = function () {
      var payload = {
        "folioNumber": vm.formData.folioNumber,
        "schemeCode": vm.formData.outSchemeObj.schemeCode,
        "schemeName": vm.formData.outSchemeObj.schemeName,
        "investorName" : vm.investorInfo.name,
        "formType":"CHANGE_DIVIDEND_OPTION",
        "type":"CHANGE_DIVIDEND_OPTION",
        "reInvestOption" : vm.formData.dividendOption
      };


      var successSTPModal = function () {
          vm.isSubmitted = false;
          var _statusType = $stateParams.status;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.distributor-home")
          } else{
            _statusType?$state.go('main.transactions.all',{status:_statusType}):$state.go('main.dashboard');
          }
        },
        errorSTPModal = function () {
          vm.isSubmitted = false;
          var identifier = AuthService.getToken();
          if (identifier && identifier.loginType == 'A'){
            $state.go("agent.distributor-home")
          } else{
            $state.go('main.dashboard');
          }
        },
        success = function (resp) {
          if (resp.status && resp.data) {
            ModalService.initiateSuccessModal({
              transactionType: 'Change Dividend Option',
              investorName: vm.investorInfo.name
            }, successSTPModal, errorSTPModal)
          } else {
            vm.isSubmitted = false;
            MessageService.error(resp.message);
          }
        },
        error = function (err) {
          vm.isSubmitted = false;
          UtilService.errorHandler(err);
        };

      ModalService.transactionReviewModal({payload: payload, controller: 'cdiv'}, success, error);
    }

    function showTermConditions() {
      ModalService.termConditionModal({});
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('BrowserUpdateController', browserUpdateController);

  function browserUpdateController(deviceDetector) {

    var vm = this;
    vm.deviceDetector=deviceDetector;

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AgentController', agentController);

  /** @ngInject */
  function agentController($log, $scope, $rootScope, $state, AuthService, $timeout) {
    var vm = this;
    vm.init = init();
    function init() {
      if(!AuthService.getToken()) $state.go('agent.login');
    }
    var removeListeners = {}, isRefreshing = false;
    $scope.date = new Date();
    var resetFlag = function () {
      $timeout(function () {
        isRefreshing = false;
      }, 2000);
    };

    removeListeners["404"] = $rootScope.$on("404", function () {
      $state.go('404');
    });

    removeListeners["UpdateRefreshToken"] = $rootScope.$on("UpdateRefreshToken", function (data) {
      if (isRefreshing) {
        return;
      }
      isRefreshing = true;
      var identifier = AuthService.getToken();//$cookies.get('token_data');
      if (!identifier || (data && data.error_description && data.error_description.indexOf('Invalid refresh token') > -1)) {
        resetFlag();
        AuthService.clearCookie();
        sessionStorage.clear();
        $state.go('agent.login');
        return;
      }

      try {
        identifier = angular.fromJson(identifier);
      } catch (e) {
        identifier = '';
      }

      if (identifier && identifier.refresh_token) {
        AuthService.getRefreshToken(identifier).then(function () {
          resetFlag();
          sessionStorage.clear();
          $state.go('agent.login');
        }, function () {
          resetFlag();
          sessionStorage.clear();
          $state.go('agent.login');
        });
      } else {
        resetFlag();
        AuthService.clearCookie();
        sessionStorage.clear();
        $state.go('agent.login');
      }
    });

    $scope.$on("$destroy", function () {
      // Unbind angular event listeners
      for (var key in removeListeners) {
        if (removeListeners.hasOwnProperty(key) && angular.isFunction(removeListeners[key])) {
          removeListeners[key]();
        }
      }
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ArnHardcodedController', arnHardcodedController);

  function arnHardcodedController(AuthService,UtilService,$http,$stateParams,$window,AppConstants,LoaderService,MessageService,TransactionArnService,$timeout,ModalService,HDFC_API,$scope) {
    var vm = this;
    vm.form = {
      arn: null,
      euin: null
    };
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PAYMENT_OPTIONS = {
      EC: 'EC',
      SI: 'SI',
      OTM: 'OTM',
      EM: 'EM',
      //DEBIT: 'DEBIT',
      RTGS: 'RTGS',
      NETBANKING: 'NETBANKING',
      HDFC: 'HDFC',
      UPI: 'UPI',
      EMANDATE: 'E-mandate'
    }
    vm.form.linkType = "MFD";
    vm.form.sublinkType = "Direct";
    vm.form.transactionType = "PURCHASE";
    vm.form.frequency = "OM";
    vm.WeekFrequency = true;
    vm.form.paymentOption = "EC";
    vm.viewMode = 'days';
    vm.days ='days';
    vm.form.startDate = "";
    vm.form.endDate = "";
    vm.enabledStartDates = null;
    vm.ShowSubBrokerArn = true;
    vm.frequencyList = [
      { "name": "Monthly","code": "OM","duration": 1 },
      { "name": "Quarterly","code": "Q","duration": 3},
      { "name": "Half Yearly","code": "H","duration": 6},
      { "name": "Yearly","code": "Y", "duration": 12 },
      { "name": "Daily","code": "BZ", "duration": 1 },
      { "name": "Weekly","code": "OW", "duration": 7 }
    ];
    vm.daysList = AppConstants.WEEKS_LIST;
    // "../../assets/images/HDFC ARN Hardcoding Banner 1.png",
    var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    if(isMobile){
      vm.imageUrls = [
        "../../assets/images/arnmobilebanner/MFD-mb.jpg",
        "../../assets/images/arnmobilebanner/RIA-mb.jpg",
        "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg",
      ];
    }else{
      vm.imageUrls = [
        "../../assets/images/MFD-infographic.jpg",
        "../../assets/images/RIA Banner.jpg",
        "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
      ];
    }

    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.form.employeeCode = null;
    vm.subBrokerARN = null;
    vm.investmentARN = null;
    vm.distributorName = null;
    vm.subBrokerCode = null;
    vm.subBrokerName = null;
    vm.form.euin = {};
    vm.hardcodedArn = false;
    vm.fromBack = false;
    vm.init = init();
    vm.auth = auth;
    vm.valid = true
    vm.nonArnAuth = nonArnAuth;
    vm.schemeType = schemeType;
    vm.isCheckMultiple = false;
    var appWidn = angular.element($window);
    appWidn.bind('resize',function(){
        isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

        if(isMobile){
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/MFD-mb.jpg",
            "../../assets/images/arnmobilebanner/RIA-mb.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg",
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/MFD-infographic.jpg",
            "../../assets/images/RIA Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }

        if($stateParams.rm){
          if (isMobile) {
            vm.imageUrls = [
              "../../assets/images/arnmobilebanner/HDFC-ARN-mb-rm.jpg",
              "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
            ];
          }else{
            vm.imageUrls = [
              "../../assets/images/RM Banner.jpg",
              "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
            ];
          }
        }
        if($stateParams.r){
          if(isMobile){
            vm.imageUrls = [
               "../../assets/images/arnmobilebanner/RIA-mb.jpg",
               "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
             ];
           }else{
             vm.imageUrls = [
               "../../assets/images/RIA Banner.jpg",
               "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
             ];
           }
        }
        $scope.$apply();
    });
    function init() {
      if($stateParams.x){
        vm.imageUrls = [
          "../../assets/images/HDFC ARN Hardcoding Banner 1.png",
          "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
        ];
        // vm.hdfcuser=true;
        vm.hardcodedArn = true;
        vm.form.arn = $window.atob($stateParams.x)
        vm.form.linkType = 'MFD';
        auth();
        vm.ShowSubBrokerArn = false;
        vm.onlyHdfcUser = true;
      }
      if($stateParams.r){
        vm.hardcodedArn = true;
        vm.form.linkType = 'RIA';
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if(isMobile){
         vm.imageUrls = [
            "../../assets/images/arnmobilebanner/RIA-mb.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RIA Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
        if($stateParams.r == "true"){
        }else{
          vm.form.ria = $window.atob($stateParams.r)
          nonArnAuth();
        }
      }
      if($stateParams.rm){
        vm.hardcodedArn = true;
        vm.form.linkType = 'RM';
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if(isMobile){
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/HDFC-ARN-mb-rm.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RM Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
        if($stateParams.rm == "true"){
        }else{
        vm.form.employeeCode = $window.atob($stateParams.rm)
        nonArnAuth();
        }
      }
      if(HDFC_API.ENV == 'beta' || HDFC_API.ENV == 'prod'){
        hideChatIcon();
      }
    }
  function hideChatIcon(){
    $timeout(function(){
      var uiViewElement = angular.element(document.querySelector('body > .widget-visible'));
      if(uiViewElement[0]){
        uiViewElement.removeAttr('class');
      }else{
        hideChatIcon();
      }
    },1000);
  }

vm.validation = function(){
  if(vm.form.linkType == "MFD"){
  if(vm.form.arn){
    vm.valid = false;
  }else{
    vm.valid = true;
  }
  if(vm.form.arn){
    if(vm.subBrokerARN){
      vm.valid = false;
    }
  }
  }
  if(vm.form.linkType == "RM"){
    if(vm.form.sublinkType == "Direct"){
     if(vm.form.employeeCode){
        vm.valid = false;
        nonArnAuth();
      }else{
        vm.valid = true;
      }
    }else  if(vm.form.sublinkType == "Distributor"){
      if(vm.form.arn && vm.form.employeeCode){
        vm.valid = false;
      }else{
        vm.valid = true;
      }
    }
  }
  if(vm.form.linkType == "RIA"){
    if(vm.form.ria && vm.form.riaName){
      vm.valid = false;
    }else{
      vm.valid = true;
    }
  }
}

function schemeType(type){
  vm.valid = true;
  vm.form.InSchemeName = "";
  vm.form.amount = "";
  vm.form.transactionType = "PURCHASE";
  vm.form.startDate = "";
  vm.form.endDate = "";
  vm.form.frequency = "OM";
  if($stateParams.rm){
    if($stateParams.rm == "true"){
      vm.form.employeeCode = null;
    }
  }else{
    vm.form.employeeCode = null;
  }
  vm.url = null;
  if(type=="Direct")
 {
  nonArnAuth();
  vm.form.sublinkType = "Direct"
  vm.ShowSubBrokerArn = false;
}
if(type=="Distributor")
{
 vm.form.sublinkType = "Distributor"
 vm.ShowSubBrokerArn = true;
}
if(type=="RIA")
{
//  nonArnAuth();
}
}


function nonArnAuth() {
     var successLogin = function (resp) {
      sessionStorage.setItem('arnAuth',true);
      vm.isThroughDistributor = false;
      LoaderService.hideLoader();
      vm.investmentType(vm.form.transactionType);
      if(vm.form.ria){
        vm.verifyRIA();
      }
      if(vm.form.InSchemeCode){
        vm.fetchValidations(vm.form.InSchemeCode);
      }
      if(vm.fromModel){
        vm.schemeListModal();
        vm.fromModel = false;
      }
    },errorLogin = function(resp){
      LoaderService.hideLoader();
      MessageService.error(resp.message);
    }
    var oauthpayload = {
      arnCode:'ARN-DIRECT',
      grant_type: 'password',
      panNumber: null,
      appType: 'W',
      type:'arn'
    };
    LoaderService.showLoader();
    AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);


  }

  function auth() {
    var length = vm.form.arn?vm.form.arn.length:0;
    if(length>3)
    {
       var successLogin = function (resp) {
       if(resp.access_token){
        sessionStorage.setItem('arnAuth',true);
        LoaderService.hideLoader();
        fetchEuinList();
        if(vm.form.linkType == "MFD" && vm.form.arn == '0005'){
          vm.showUTM = true;
        }else{
          vm.showUTM = false;
        }
        vm.investmentType(vm.form.transactionType);
        if(vm.fromModel){
          vm.schemeListModal();
          vm.fromModel = false;
        }
      }else{
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      },errorLogin = function(resp){
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      var oauthpayload = {
        arnCode:'ARN-'+vm.form.arn,
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type:'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

    }
    }
    vm.authARN = function() {
      var length = vm.form.arn?vm.form.arn.length:0;
      vm.subBrokerName = null;
      vm.subBrokerCode = null;
      if(length>3)
      {
        vm.subBrokerARN = null;
         var successLogin = function (resp) {
          if(resp.access_token){
            sessionStorage.setItem('arnAuth',true);
            LoaderService.hideLoader();
            vm.isThroughDistributor = true;
            if(vm.form.linkType == "MFD" && vm.form.arn == '0005'){
              vm.showUTM = true;
            }else{
              vm.showUTM = false;
            }
            vm.validation();
            fetchEuinList();
            vm.investmentType(vm.form.transactionType);
          }else{
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },errorLogin = function(resp){
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
        var oauthpayload = {
          arnCode:'ARN-'+vm.form.arn,
          grant_type: 'password',
          panNumber: null,
          appType: 'W',
          type:'arn'
        };
        LoaderService.showLoader();
        AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

      }
      }
      vm.distributorImage = null;
      vm.distributorName = null;
    function fetchEuinList() {
      vm.euinList = [];
      vm.getDistributerProfile();
      // var success = function (resp) {
      //   if (resp.status && resp.data) {
      //     vm.distributorName = resp.data.distributorName;
      //       vm.euinList =  resp.data.euinList.sort( function( a, b ) {
      //       return a.euinName < b.euinName ? -1 : a.euinName > b.euinName ? 1 : 0;
      //     });

      //     var temp1 = vm.euinList;
      //     vm.euinList = [];
      //     vm.euinMasterList = [];
      //     vm.euinList.push(
      //       {
      //         "euinCode": "",
      //         "euinName": "Select Euin",
      //         "euinNameCode": "Select Euin"
      //       });
      //       vm.euinMasterList.push(
      //         {
      //           "euinCode": "",
      //           "euinName": "Select Euin",
      //           "euinNameCode": "Select Euin"
      //         });
      //       temp1.forEach(function(element){
      //         vm.euinList.push(element);
      //       });

      //     // vm.euinMasterList = resp.data.euinList;
      //     resp.data.euinList.forEach(function(element){
      //       vm.euinMasterList.push(element);
      //     });
      //     vm.getDistributerProfile()
      //     LoaderService.hideLoader();
      //   } else {
      //     LoaderService.hideLoader();
      //     vm.euinList = null;
      //     MessageService.error(resp.message);
      //   }
      // },
      //   error = function (err) {
      //     if(err.data.error == 'invalid_token'){
      //       vm.fromBack = true;
      //       if(vm.form.arn){
      //         auth();
      //       }else{
      //         nonArnAuth();
      //       }
      //       return;
      //     }
      //     LoaderService.hideLoader();
      //     vm.euinList = null;
      //     if(!$stateParams.x){
      //       vm.resetValue(vm.form.linkType);
      //     }
      //     // UtilService.errorHandler(err);
      //   };

      // LoaderService.showLoader();
      // var path = {
      //   controller1: 'getEuin',
      //   controller2: 'ARN-'+vm.form.arn
      // };
      // TransactionArnService.get(path).$promise.then(success, error);
    }
    vm.getDistributerProfile = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        $(".shcemeInputBox" ).focus();
        $(".shcemeInputBox" ).blur();
        $(".dropDwn").hide();
        if (resp.status && resp.data) {
          vm.distributorImage = resp.data.imageName;
          vm.distributorName = resp.data.distributorName;
          if(vm.form.euin){
            if(vm.form.euin.euinCode){
              vm.selectEuin(vm.form.euin);
            }else{
              vm.selectEuin(vm.euinList[0]);
            }
          }else{
            vm.selectEuin(vm.euinList[0]);
          }
        } else {
          vm.euinList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        if(err.data.error == 'invalid_token'){
          vm.fromBack = true;
          if(vm.form.arn){
            auth();
          }else{
            nonArnAuth();
          }
          return;
        }
        MessageService.error(err.data.message);
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionArnService.get({
        controller1: "getDistributorProfile",
        controller2: "ARN-" + vm.form.arn,
      }).$promise.then(success, error);
    }
    vm.fetchEuinListSubBroker = function() {
      vm.euinList = [];
      if(!vm.subBrokerARN){
        vm.subBrokerCode = null;
        fetchEuinList();
      }
      vm.validation();
      var length = vm.subBrokerARN?vm.subBrokerARN.length:0
      vm.form.euin.euinCode = null;
    if(length> 2){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.subBrokerName = resp.data.distributorName;
          var temp1 = resp.data.euinList;
          vm.euinList = [];
          vm.euinMasterList = [];
          vm.euinList.push(
            {
              "euinCode": "",
              "euinName": "Select Euin",
              "euinNameCode": "Select Euin"
            });
            vm.euinMasterList.push(
              {
                "euinCode": "",
                "euinName": "Select Euin",
                "euinNameCode": "Select Euin"
              });
            temp1.forEach(function(element){
              vm.euinList.push(element);
            });
            resp.data.euinList.forEach(function(element){
              vm.euinMasterList.push(element);
            });
        } else {
          LoaderService.hideLoader();
          vm.euinList = null;
          vm.subBrokerARN = null;
          MessageService.error(resp.message);
        }
      },
        error = function () {
          LoaderService.hideLoader();
          vm.euinList = null;
          //UtilService.errorHandler(err);
        };

      LoaderService.showLoader();
      var path = {
        controller1: 'getEuin',
        controller2: 'ARN-'+vm.subBrokerARN ,
        isSubBroker: true
      };
      TransactionArnService.get(path).$promise.then(success, error);
    }
    }
    vm.url = "";
    vm.submitArn = function () {
        var success = function (resp) {
          LoaderService.hideLoader();
          if(resp.url){
            vm.url = resp.url;
          vm.goDown();
          }else{
            MessageService.error(resp.message);
          }
        },error = function (resp) {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        };

        if(vm.form.linkType == "MFD"){
          vm.dataPayload = {
            arnCode:"ARN-"+vm.form.arn,
            euin:vm.form.euin.euinCode,
            key:vm.form.linkType,
            schemeCode:vm.form.InSchemeCode,
            transactionType:vm.form.transactionType,
            amount:vm.form.amount
          };
          if(vm.subBrokerARN == undefined || vm.subBrokerARN == null){
            vm.dataPayload.subBrokerArn = "";
          }
          if(vm.subBrokerARN){
            vm.dataPayload.subBrokerArn = "ARN-"+vm.subBrokerARN;
            vm.dataPayload.subBrokerCode = vm.subBrokerCode;
          }

          if(vm.form.euin.euinCode){
            vm.dataPayload.euin = vm.form.euin.euinCode;
          }else{
            delete vm.dataPayload['euin'];
          }
          if(vm.form.transactionType == "SIP"){
            if(vm.form.InSchemeCode){
            vm.dataPayload.frequency = vm.form.frequency;
            vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
            vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") :'';
            }
          }
          if(vm.form.transactionType == "PURCHASE SCHEDULER"){
            vm.dataPayload.transactionType = "PURCHASE_SCHEDULER";
            if(vm.form.InSchemeCode){
              vm.dataPayload.scheduleFrequency = vm.form.frequency;
              vm.dataPayload.schedulerStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
              vm.dataPayload.schedulerEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") :'';
              vm.dataPayload.dividendOption = vm.form.DividendOption;
            }
            if(vm.form.frequency == 'WK'){
              vm.dataPayload.scheduleFrequency = 'W';
            }
          }
        }else if(vm.form.linkType == "RIA"){
          vm.dataPayload = {
            riaCode : vm.form.ria,
            key:vm.form.linkType,
            arnCode:"ARN-DIRECT",

            schemeCode:vm.form.InSchemeCode,
            transactionType:vm.form.transactionType,
            amount:vm.form.amount
          };
          if(vm.form.transactionType == "SIP"){
            if(vm.form.InSchemeCode){
            vm.dataPayload.frequency = vm.form.frequency;
            vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
            vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
            }
          }
        }else if(vm.form.linkType == "RM"){
          if(vm.form.sublinkType == "Direct"){
            vm.dataPayload = {
              empCode:vm.form.employeeCode.toUpperCase(),
              key:"E_CODE",
              arnCode:"ARN-DIRECT",
              ecodeKey: "Direct",
              schemeCode:vm.form.InSchemeCode,
              transactionType:vm.form.transactionType,
              amount:vm.form.amount
            };
            if(vm.form.transactionType == "SIP"){
              if(vm.form.InSchemeCode){
                vm.dataPayload.frequency = vm.form.frequency;
                vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
                vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
              }
            }
          }else if(vm.form.sublinkType == "Distributor"){
            vm.dataPayload = {
              arnCode:'ARN-'+vm.form.arn,
              empCode:vm.form.employeeCode.toUpperCase(),
              key:"E_CODE",
              ecodeKey: "Regular",
              schemeCode:vm.form.InSchemeCode,
              transactionType:vm.form.transactionType,
              amount:vm.form.amount
            }
            if(vm.subBrokerARN){
              vm.dataPayload.subBrokerArn = 'ARN-'+vm.subBrokerARN;
              vm.dataPayload.subBrokerCode = vm.subBrokerCode;
            }
            if(vm.form.euin.euinCode){
              vm.dataPayload.euin = "E"+vm.form.euin.euinCode;
            }else{
              delete vm.dataPayload['euin'];
            }
            if(vm.form.transactionType == "SIP"){
              if(vm.form.InSchemeCode){
              vm.dataPayload.frequency = vm.form.frequency;
              vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
              vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
              }
            }
        }else{
          MessageService.error("Plase select all reqired inputs.");
        }
       }else{
        MessageService.error("Plase select all reqired inputs.");
        }
      LoaderService.showLoader();
        // TransactionArnService.post({controller1: "getShortLink",},vm.dataPayload).$promise.then(success, error);
        vm.dataPayload.utmSource = vm.form.utmsource ? vm.form.utmsource : '' ;
        vm.dataPayload.utmMedium = vm.form.utmmedium ? vm.form.utmmedium : '';
        if(vm.form.transactionType == "SWITCH"){
          vm.dataPayload.dividendOption = vm.form.DividendOption;
        }
        if(vm.dataPayload){
          vm.dataPayload.mfdFlowName = 'EMPLOYEE';
          TransactionArnService.post({controller1: "getShortUrl",},vm.dataPayload).$promise.then(success, error);
        }else{
          MessageService.error("Something went wrong");
        }
    }
    vm.resetValue = function(type){
      vm.form.arn =null;
      vm.form.euin = {};
      vm.form.riaCode = null;
      vm.form.riaName = null;
      vm.form.employeeCode = null;
      vm.subBrokerARN = null;
      vm.investmentARN = null;
      vm.distributorName = null;
      vm.subBrokerCode = null;
      vm.subBrokerName = null;
      vm.valid =true;
      vm.euinList = null;
      vm.isThroughDistributor = false;
      vm.arnChanged();
      if(type == 'RIA'){
        vm.schemeType('RIA')
      }

      vm.form.transactionType = "PURCHASE";
      vm.form.amount = "",
      vm.form.frequency = "OM";
      vm.form.startDate = null;
      vm.form.endDate = null;
      vm.form.InSchemeCode = "";
      vm.form.InSchemeName = "";
      vm.form.schemeType = "";
    }
    vm.isCheckedTandC = false;
    vm.changeSubBrokerArn = function () {
      vm.validation();
      vm.isCheckedTandC = false;
      vm.subBrokerName = '';
    }
    vm.selectEuin = function(data){
      if(data == null){
        vm.form.euin.euinCode = '';
      }else{
        $(".dropdown-content").hide();
        vm.form.euin = data;
        vm.validation()
      }

    }
    vm.filterEuinList = function () {
    if(vm.form.euin.euinCode){
      $("#euin").css("text-transform", "uppercase");
    }else{
      $("#euin").css("text-transform", "capitalize");
    }

      if(vm.form.euin.euinCode){
          vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.form.euin.euinCode);
      }
      vm.euinList = vm.form.euin.euinCode == '' || vm.form.euin.euinCode == undefined ? vm.euinMasterList : vm.euinList;
    };

    vm.verifyRIA = function() {
     if(vm.form.ria.length == 12){
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.riaCodeError = "";
          vm.form.riaName = resp.data.distributorName;
          vm.validation()
        } else {
          LoaderService.hideLoader();
          vm.riaCodeError = resp.message;
          vm.form.ria = "";
          MessageService.error(resp.message);
        }
      },error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.data.message);
      };

      LoaderService.showLoader();
      var path = {
        controller1: 'getEuin',
        controller2: vm.form.ria,
        riaOpted: true
      };
      TransactionArnService.get(path).$promise.then(success, error);
    }
    }

    vm.showArn = false;
   vm.subnote = function(){
    vm.showArn = true;
    $(".arnNote").css("top", "12%")
    $(".subnote").css("top", "-12%");
    $(".subBrokerArn").focus();
   }
   vm.subnote1 = function(){
     vm.validation();
    if($(".subBrokerArn").val()){
      $(".subBrokerCode").focus();
      $(".subnote1").css("top", "-12%");
    }else{
    }
  }
vm.arnChanged = function(){
  vm.distributorName = null;
  vm.euinList = null;
  vm.form.euin.euinCode = null;
  vm.distributorImage = null;
  vm.url = null;
}
vm.investmentType = function(val){
  vm.SchemeList = [];
  if(!vm.fromBack){
    vm.form.InSchemeCode = "";
    vm.form.InSchemeName = "";
    vm.form.schemeType = "";
  }
  vm.purchaseValidations = null;
  vm.form.InvestmentOption = "";
  vm.form.amount = "";
  $window.NumToWord(vm.form.amount, 'DisplayWordsTaxAmount');
  vm.form.transactionType = val;
      var success = function (resp) {
        LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.SchemeList = resp.data.schemeList;
            vm.MasterSchemeList = vm.SchemeList;
            // vm.purchaseInSchemeList = UtilService.getFilteredList(vm.SchemeList);
            // cb();
            // if (vm.arnHardcodedData) {
            //   if (vm.arnHardcodedData.schemeGroupCode) {
            //     schemeGroupCodeList(vm.vm.SchemeList , "purchase")
            //   }
            // }
            if(vm.form.InSchemeName && vm.form.InSchemeCode){
              vm.fetchValidations(vm.form.InSchemeCode);
            }
          } else {
            vm.SchemeList = null;
            MessageService.error(resp.message);
          }
          vm.fromBack = false;
      },error = function (err) {
          if(err.data.error == 'invalid_token'){
            vm.fromBack = true;
            if(vm.form.arn){
              auth();
            }else{
              nonArnAuth();
            }
            return;
          }
        vm.SchemeList = null;
        UtilService.errorHandler(err);
      };
  LoaderService.showLoader();
  if(vm.form.arn){
    vm.isThroughDistributor = true;
  }else{
    vm.isThroughDistributor = false;
  }

  if(vm.form.transactionType == "SIP"){
    TransactionArnService.get({
      controller1: 'scheme',
      controller2: 'ALL',
      controller3: 'sipenabled',
      controller4: false,
      controller5: vm.isThroughDistributor
    }, null).$promise.then(success, error);
  }else if(vm.form.transactionType == "PURCHASE" || vm.form.transactionType == "PURCHASE SCHEDULER"){
    TransactionArnService.get({
      controller1: 'scheme',
      controller2: 'ALL',
      controller3: 'purchaseenabled',
      controller4: false,
      controller5: vm.isThroughDistributor
    }, null).$promise.then(success, error);
  }else if(vm.form.transactionType == "REDEMPTION"){
    TransactionArnService.get({
      controller1: 'scheme',
      controller2: 'ALL',
      controller3: 'redemptionenabled',
      controller4: false,
      controller5: vm.isThroughDistributor
    }, null).$promise.then(success, error);
  }else{
    TransactionArnService.get({
      controller1: 'scheme',
      controller2: 'ALL',
      controller3: 'switchenabled',
      controller4: false,
      controller5: vm.isThroughDistributor
    }, null).$promise.then(success, error);
  }
}
vm.filterInSchemeList = function () {
  vm.SchemeList2 = [];
  vm.SchemeList2 = UtilService.getFilteredList(vm.MasterSchemeList, 'scheme', vm.form.InSchemeName);
  vm.SchemeList = [];
  vm.SchemeList = vm.SchemeList2;
  if(!vm.form.InSchemeName || vm.SchemeList2.length == 0){
    vm.form.amount = "";
  }
};
vm.purchaseInSchemeChanged = function (data) {
  if (data) {
    vm.form.InSchemeCode = data.schemeCode;
    vm.form.InSchemeName = data.scheme;
    vm.form.schemeType = data.schemeType;
    vm.fetchValidations(vm.form.InSchemeCode);
    vm.SchemeList = vm.MasterSchemeList;
    if (vm.form.transactionType === 'SWITCH' || vm.form.transactionType === 'PURCHASE SCHEDULER') {
      vm.form.InvestmentOption = AppConstants.TRANSACTION.GROWTH;
      if(data.dividendPayoutApplicable || data.dividendReinvestmentApplicable){
        if(data.dividendPayoutApplicable == "Y" && data.dividendReinvestmentApplicable == "N"){
          vm.form.DividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
          vm.form.InvestmentOption = AppConstants.TRANSACTION.DIVIDEND;
        }else if(data.dividendPayoutApplicable == "N" && data.dividendReinvestmentApplicable == "Y"){
          vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
          vm.form.InvestmentOption = AppConstants.TRANSACTION.DIVIDEND;
        }else if(data.dividendReinvestmentApplicable == "Y" && data.dividendPayoutApplicable == "Y"){
          vm.form.InvestmentOption = AppConstants.TRANSACTION.DIVIDEND;
          vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
        }else{
          vm.form.InvestmentOption = AppConstants.TRANSACTION.GROWTH;
          vm.form.DividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
        }
      }
    }
  }else{
    return;
  }
  vm.form.amount = '';
};
vm.fetchValidations = function(schemeCode) {
  vm.purchaseValidations = null;
  var success = function (resp) {
      if (resp.status && resp.data) {
        vm.purchaseValidations = resp.data;
        if(vm.purchaseValidations.amountArray && vm.purchaseValidations.amountArray.length > 0){
          vm.form.amount = vm.purchaseValidations.amountArray[0];
          vm.additionalSipData = resp.data.additionalValidation.OM;
          vm.setAmount(vm.form.amount);
        }
        if(vm.form.transactionType == "PURCHASE" || vm.form.transactionType == "PURCHASE SCHEDULER"){
          vm.form.amount = vm.purchaseValidations.minFirstPurchaseAmt;
          vm.setAmount(vm.form.amount);
          vm.validatePurchaseAmount();
        }
        vm.form.InvestmentOption = vm.purchaseValidations.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.form.InvestmentOption !== AppConstants.TRANSACTION.GROWTH && vm.form.InvestmentOption || AppConstants.TRANSACTION.DIVIDEND);
        if (vm.purchaseValidations.isGrowth) {
          vm.form.DividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
        } else {

          if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false) {
            vm.form.DividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
          } else if (vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
          } else if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
            vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
          }

        }
      }else{
          MessageService.error(resp.message);
      }
      vm.fromBack = false;
    },error = function (err) {
      if(err.data.error == 'invalid_token'){
        vm.fromBack = true;
        if(vm.form.arn){
          auth();
        }else{
          nonArnAuth();
        }
        return;
      }
      MessageService.error(err.error);
    };

    if(vm.form.transactionType == "SIP"){
      var path = {
        controller1: 'schemeValidation',
        controller2: 'sip',
        controller3: vm.form.InSchemeCode
      };
      TransactionArnService.get1(path).$promise.then(success, error);
    }else{
      var data = {
      schemeCode: vm.form.InSchemeCode
      };
      TransactionArnService.post4({
      controller1: 'schemeValidation',
      controller2: 'purchase'
      }, data).$promise.then(success, error);
    }
}
vm.setFrequency = function(frequency){
  vm.form.frequency = frequency;
  if(vm.form.frequency == 'OW'){
    vm.WeekFrequency = false;
  }else{
    vm.WeekFrequency = true;
  }
  vm.form.startDate = null;
  vm.form.endDate = null;
  vm.changeEndDate(false);
  vm.changeEndDate(null);
  if(vm.form.transactionType == "PURCHASE SCHEDULER"){
  }else{
    vm.extractValidationObject(vm.purchaseValidations);
    vm.validateAmount();
  }
}
vm.setAmount = function(amount){
  vm.form.amount = amount;
  $window.NumToWord(vm.form.amount, 'DisplayWordsTaxAmount');
  if(vm.form.amount){
    if(vm.form.transactionType == "SIP"){
      vm.extractValidationObject(vm.purchaseValidations);
      vm.validateAmount();
    }else{
      vm.validatePurchaseAmount();
      if(vm.form.transactionType == "PURCHASE SCHEDULER"){
        vm.validatePurchesSchedularCalender();
      }
    }
  }
}
vm.validateAmount = function(){
  if (vm.additionalSipData) {
    vm.isMax = vm.validations.maxAmount && vm.validations.maxAmount < vm.form.amount;
    vm.isMin = vm.validations.minAmount && vm.validations.minAmount > vm.form.amount;
    vm.isMultiples = vm.validations.amountMultiples && vm.form.amount && (vm.form.amount % vm.validations.amountMultiples === 0) || false;
    if(vm.form.amount && !vm.isMin && (vm.validations.amountMultiples && !vm.isMultiples)){
      vm.isCheckMultiple = true;
    }else{
      vm.isCheckMultiple = false;
    }

    var newValidation = vm.additionalSipData;
    for (var i = 0; i < newValidation.length; i++) {
      var condition = vm.form.amount < newValidation[i].min_amount_lower || vm.form.amount <= newValidation[i].min_amount_upper
      if (!newValidation[i].min_amount_upper) {
        var condition = true;
      }
      if (condition) {
        vm.validations.amountMultiples = newValidation[i].amt_multiples;
        vm.validations.maxAmount = newValidation[i].min_amount_upper;
        vm.validations.minAmount = newValidation[i].min_amount_lower;
        vm.validations.minInstallments = newValidation[i].min_installments;
        break;
      }
    }
  }

}
vm.validatePurchaseAmount = function(){
  if(vm.purchaseValidations && vm.purchaseValidations.validationType == 'PURCHASE'){
    vm.validations.minAmount = vm.purchaseValidations.minFirstPurchaseAmt;
    vm.validations.amountMultiples = vm.purchaseValidations.purchaseMultiple;
    vm.isMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.form.amount;
    vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.form.amount && (vm.form.amount % vm.purchaseValidations.purchaseMultiple === 0) || false;
    if(vm.form.amount && !vm.isMin && (vm.validations.amountMultiples && !vm.isMultiples)){
      vm.isCheckMultiple = true;
    }else{
      vm.isCheckMultiple = false;
    }
  }
}
vm.setPaymentOption = function(paymentOption){
  vm.form.paymentOption = paymentOption;
}
vm.validations = {
  amountMultiples : "",
  maxInstallments : "",
  minInstallments : "",
  minAmount : "",
  maxAmount : "",

}
vm.extractValidationObject = function(validationsData) {
  if (!validationsData || !vm.form.frequency) {
    return;
  }

  vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
  vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
  vm.validations.minInstallments = vm.validations.minInstallments || 0;
  vm.validations.minAmount = vm.validations.minAmount || 0;
  vm.validations.maxAmount = vm.validations.maxAmount || 0;

  switch (vm.form.frequency) {
    case 'BZ':
      vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
      if (validationsData.additionalValidation.BZ) {
        vm.additionalSipData = validationsData.additionalValidation.BZ;
        vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
      }
      getDateValidation();
      break;
    case 'OW':
      vm.validations.maxInstallments = validationsData.weeklyMinInstallmentNumber;
      if (validationsData.additionalValidation.OW) {
        vm.additionalSipData = validationsData.additionalValidation.OW;
        vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
      }
      getDateValidation();
      break;
    case 'Q':
      vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
      vm.validations.topupMinAmt = validationsData.topupMinAmt;
      vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
      vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
      vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
      if (validationsData.additionalValidation.Q) {
        vm.additionalSipData = validationsData.additionalValidation.Q;
        vm.validations.minAmount = validationsData.additionalValidation.Q[0].min_amount_lower;
      }
      getDateValidation();
      break;
    case 'OM':
      vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
      vm.validations.topupMinAmt = validationsData.topupMinAmt;
      vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
      vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
      vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
      if (validationsData.additionalValidation.OM) {
        vm.additionalSipData = validationsData.additionalValidation.OM;
        vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
      }
      getDateValidation();
      break;
    case 'H':
      vm.additionalSipData = validationsData.additionalValidation.H;
      vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
      getDateValidation();
      break;
    case 'Y':
      vm.additionalSipData = validationsData.additionalValidation.Y;
      vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
      getDateValidation();
      break;
  }
}

vm.changeStartDate = function (date) {
  LoaderService.showLoader();
  vm.form.startDate = date ? date : null;
  vm.form.day = vm.form.startDate ? vm.form.startDate.format('D') : '';
  vm.form.endDate = null;
  vm.changeEndDate(null);
  if( vm.form.transactionType == "PURCHASE SCHEDULER"){
    vm.updatePurchaseSchedulerEndDate();
  }else{
    updateEndDates();
  }
  LoaderService.hideLoader();
};

function updateEndDates() {
  if (!vm.form.startDate) {
    return;
  }


  var defaultEndDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
  //var defaultEndDate = new Date(2036, 12, 31);
  var defaultMonths = null;
  var endDate = null;
  vm.enabledEndDates = [];
  var freq = vm.validations && vm.validations.maxInstallments || 0;
  var i = 0;
  var frequency = vm.frequencyList.find(function (f) {
    return f.code === vm.form.frequency;
  }) || {};


  switch (vm.form.frequency) {
    case 'BZ':
      var days = 0;
      vm.enabledEndDates = [];
      endDate = vm.form.startDate.clone();//.add(minInstallments, 'days');
      defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
      var days = UtilService.getMonthsCount(vm.form.startDate.clone(), defaultEndDate);
      freq = ((defaultMonths * 30) / frequency.duration) + days;
      for (i = 0; i < freq; i++) {
        days = frequency.duration * i;
        vm.enabledEndDates.push(endDate.clone().add(days, 'days'));
      }
      // vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      // vm.minEndDate = vm.form.endDate ? vm.form.endDate : angular.copy(vm.enabledEndDates[vm.minInstallments]);
      break;
    case 'OW':
      var days = 0;
      var enabledEndDates = [];
      defaultEndDate = new Date("12/31/2099");
      freq = UtilService.getNumberOfWeeks(vm.form.startDate.toDate(), defaultEndDate);
      for (i = 0; i <= freq; i++) {
        days = frequency.duration * i;
        enabledEndDates.push(vm.form.startDate.clone().add(days, 'days'));
      }
      vm.enabledEndDates = enabledEndDates;
      vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.minEndDate = vm.form.endDate ? vm.form.endDate : angular.copy(vm.enabledEndDates[vm.minInstallments]);
      break;
      // case 'H':
      //   var months = 0;
      //   vm.enabledEndDates = [];
      //   var endDate = vm.form.startDate.clone().add(frequency, 'months');
      //   defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
      //   freq = freq || (defaultMonths / frequency.duration);
      //   for (i = 0; i < freq; i++) {
      //     months = frequency.duration * i;
      //     vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
      //   }
      //   vm.minEndDate = endDate;
      //   return;
      //   break;
      //   case 'Y':
      //   var months = 0;
      //   vm.enabledEndDates = [];
      //   var endDate = vm.form.startDate.clone().add(frequency, 'months');
      //   defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
      //   freq = freq || (defaultMonths / frequency.duration);
      //   for (i = 0; i < freq; i++) {
      //     months = frequency.duration * i;
      //     vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
      //   }
      //   vm.minEndDate = endDate;
      //   return;
      //   break;
        // case 'Q':
        // var months = 0;
        // vm.enabledEndDates = [];
        // var endDate = vm.form.startDate.clone().add(frequency, 'months');
        // defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
        // freq = freq || (defaultMonths / frequency.duration);
        // for (i = 0; i < freq; i++) {
        //   months = frequency.duration * i;
        //   vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
        // }
        // vm.minEndDate = endDate;
        // return;
        // break;
    default:
      var months = 0;
      vm.enabledEndDates = [];
      endDate = vm.form.startDate.clone().add(frequency, 'months');
      defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
      freq = freq || (defaultMonths / frequency.duration);
      for (i = 0; i < freq; i++) {
        months = frequency.duration * i;
        vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
      }
      break;
  }
  vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
  vm.enabledEndDates = vm.enabledEndDates.slice(vm.minInstallments);

  vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
  vm.minEndDate = vm.form.endDate ? vm.form.endDate : angular.copy(vm.enabledEndDates[0]);
}
vm.updateDatesForWeekly = function() {
  var indexDates = $window.moment();
  var businessDays = [];
  var count = 1;
  //calculating non business days
  for (var i = 1; i <= 90; i++) {
  var indexDate = $window.moment().add(i, 'days').format("DD-MMM-YYYY");
  var isEnable = true;
  if (count <= 5) {
    angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
      if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
        isEnable = false;
      }
    });
   }

   if(isEnable){
     businessDays.push($window.moment().add(i, 'days'));
       count++;
     }
   }
   //setting the 5th day as part of T+5
   var currentDay = businessDays[4];
   currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
   var enabledStartDates = [];
   var _day = vm.daysList.find(function (d) {
     return d === vm.form.weeklyDay;
   }) || {};
   for (var i = 0; i < 90; i++) {
     var _date = currentDay.clone().add(i, 'days');
      if (_date.format('dddd').toLowerCase() === _day.toLowerCase()) {
       enabledStartDates.push(_date.clone());
     }
   }
   vm.enabledStartDates = angular.copy(enabledStartDates);
   vm.form.startDate = null;
   vm.form.startDate = vm.enabledStartDates[0];
   updateEndDates();
}
vm.checkPurchaseValidations = function () {
  vm.maxAmount = vm.token.maxAmount;
  if (vm.purchaseValidations) {
    if (!vm.purchaseValidations.addlPurchase) {
      vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.form.purchaseAmount;
      vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
    } else {
      vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.form.purchaseAmount;
      vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
    }
    vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.form.purchaseAmount && (vm.form.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;
    if(vm.form.purchaseAmount%1 != 0){
      vm.isPurchaseAmountDecimal = true;
    }
    else{
      vm.isPurchaseAmountDecimal = false;
    }
  }
};

function getDateValidation() {
  vm.enabledOTMStartDatesList = [];
  vm.enabledStartDates = [];
  var success = function (resp) {
    LoaderService.hideLoader();
    if (resp.status && resp.data) {
      var currentDate = resp.data.currentDate || Date();
      vm.daysList = resp.data.listOfDays;
      var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
      var todayDate = $window.moment(Date.parse(parsedDate));
      var counter = 0;
      vm.nonBusinessDatess = resp.data.nonBuisnessDates;
      if (vm.form.paymentOption === vm.PAYMENT_OPTIONS.EMANDATE) {
        vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
      } else if (vm.form.paymentOption === vm.PAYMENT_OPTIONS.EC) {
        if(vm.form.frequency == "OW" || vm.form.frequency == "BZ"){
          vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(5, 'days');
        }else{
          vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(vm.purchaseValidations.sipTDay, 'days');
        }
      } else {
        vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(11, 'days');
      }
      vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
      var startDate = todayDate.clone();
      var freq = vm.startMaxDate.diff(todayDate, 'days');
      for (var i = 0; i <= freq; i++) {
        var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
        var isEnable = true;
        if (counter < 5) {
          angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
            if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') === 0) {
              isEnable = false;
            }
          });
        }
        if (isEnable) {
          vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
          counter++;
        }
      }
      if(vm.form.frequency=="BZ"){
        vm.enabledMINStartDates = vm.enabledOTMStartDatesList[5];
        updateDatesForDaily();
      }
    } else {
      LoaderService.hideLoader();
      MessageService.error(resp.message);
    }
  },error = function (err) {

      LoaderService.hideLoader();
      MessageService.error(err);
    };

      LoaderService.showLoader();
      TransactionArnService.get({
        controller1: 'nonBusinessDate',
        schemeCode: vm.form.InSchemeCode
        }).$promise.then(success, error);
}
vm.changeEndDate = function(enddate){
  vm.form.endDate = enddate;
  var t = $window.moment(new Date("12/31/2099")).format('DD/MM/YYYY');
  var tempEndDate = $window.moment(new Date(enddate)).format('DD/MM/YYYY');
  if(tempEndDate == t){
    vm.form.isTillPerpetuity = true;
  }else{
    vm.form.isTillPerpetuity = false;
  }
}
function updateDatesForDaily() {
  var currentDay = $window.moment().add(3, 'days');
  currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
  var enabledStartDates = [currentDay.clone()];
  for (var i = 1; i <= 12; i++) {
    var _date = currentDay.clone().add(i, 'days');
    enabledStartDates.push(_date.clone());
  }
  vm.enabledStartDates = angular.copy(enabledStartDates);
  vm.form.startDate = vm.enabledStartDates[0];
  vm.form.day = +(vm.form.startDate.format('DD'));
}

vm.schemeListModal = function () {
  var successSchemeList = function (result) {
    vm.selectedOptionalScheme = result;
    var data = {
      dividendPayoutApplicable: vm.selectedOptionalScheme.dividendPayoutApplicable,
      dividendReinvestmentApplicable: vm.selectedOptionalScheme.dividendReinvestmentApplicable,
      investmentOption: vm.selectedOptionalScheme.investmentOption,
      nfoEnabled: vm.selectedOptionalScheme.nfoEnabled,
      scheme: vm.selectedOptionalScheme.scheme,
      schemeCode: vm.selectedOptionalScheme.schemeCode,
      schemeType: vm.selectedOptionalScheme.schemeType
    }
    vm.purchaseInSchemeChanged(data);
  },
  errorSchemeList = function (result) {
    if(result){
      if(result.fromBack){
      vm.fromBack = true;
      vm.fromModel = true;
      if(vm.form.arn){
        auth();
      }else{
        nonArnAuth();
      }
      return;
      }
    }
    vm.SchemeList = vm.MasterSchemeList;
    vm.form.InSchemeCode = "";
    vm.form.InSchemeName = "";
    vm.form.schemeType = "";
    vm.form.amount = "";
  };
  var  enabledScheme = "";
  if(vm.form.transactionType == "SIP"){
    enabledScheme ="sipenabled";
  }else if(vm.form.transactionType == "PURCHASE"){
    enabledScheme ="purchaseenabled";
  }else if(vm.form.transactionType == "REDEMPTION") {
    enabledScheme ="redemptionenabled";
  }else{
    enabledScheme ="switchenabled";
  }
  if(vm.form.transactionType == "PURCHASE SCHEDULER"){
    ModalService.purchaseSchedulerRecomendationModal({
    }, successSchemeList, errorSchemeList);
  }else{
    ModalService.schemeListModal({
      enabledScheme: enabledScheme,
      isMinor: false,
      isARN: true,
      isThroughDistributor: vm.isThroughDistributor,
      keyFrom: "harnHardcoded"
    }, successSchemeList, errorSchemeList);
  }

};


vm.changeTillPerpetuityFlag = function () {
  if (vm.form.isTillPerpetuity) {
    vm.form.endDate = moment("12/31/2099");
  }else{
    vm.form.endDate = undefined;
  }

};

vm.goDown = function(){
  window.scrollBy(0,180);
}

vm.callRIA = function(){
  nonArnAuth();
}
// vm.setDefaultEuin2 = function(){
//   $(".suggestion").css("visibility","visible");
// }
vm.setEuin = function(){
  var v = $(".rmInput")
  v.on("click",function(event){
    event.stopPropagation();
  })

}
vm.hideSchemeDropDown = function(){
  var sh = $(".shcemeInputBox")
  sh.on("click",function(event){
    event.stopPropagation();
    event.preventDefault();
  })
}

angular.element(document).ready(function(){
  $(".dropdownTrigger").on("click",function(event){
    event.stopPropagation();
  })
  $(".shcemeInputBox").on("click",function(event){
    event.stopPropagation();
    event.preventDefault();
  })
  $(document).on("click",function(){
    $(".dropDwn").hide();
    $(".dropdown-content").hide();
  })
})


vm.myFunction = function(){
  $(".dropdown-content").show();
}

vm.myFunction3 = function(event){
 if(event){
 event.stopPropagation();
 event.preventDefault();
 }
 $(".dropdown-content").show();
}

  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('ArnHardcodedNewController', arnHardcodedNewController);

  function arnHardcodedNewController(AuthService,UtilService,$http,$stateParams,$window,AppConstants,LoaderService,MessageService,TransactionArnService,$timeout,ModalService,HDFC_API,$scope, $cookies, $rootScope) {
    var vm = this;
    vm.form = {
      arn: null,
      euin: null,
      euinSelected : "true"
    };
    vm.VALIDATE_DATA = angular.copy(AppConstants.ToastrMessage.VALIDATE_DATA);
    vm.PAYMENT_OPTIONS = {
      EC: 'EC',
      SI: 'SI',
      OTM: 'OTM',
      EM: 'EM',
      //DEBIT: 'DEBIT',
      RTGS: 'RTGS',
      NETBANKING: 'NETBANKING',
      HDFC: 'HDFC',
      UPI: 'UPI',
      EMANDATE: 'E-mandate'
    }
    vm.form.linkType = "MFD";
    vm.enabledViewEndDate = null;
    vm.form.sublinkType = "Direct";
    vm.form.transactionType = "PURCHASE";
    vm.form.frequency = "OM";
    vm.WeekFrequency = true;
    vm.form.paymentOption = "EC";
    vm.viewMode = 'days';
    vm.days ='days';
    vm.form.startDate = "";
    vm.form.endDate = "";
    vm.enabledStartDates = null;
    vm.ShowSubBrokerArn = true;
    vm.hdfcOneClick = false;
    vm.frequencyList = [
      { "name": "Monthly","code": "OM","duration": 1 },
      { "name": "Quarterly","code": "Q","duration": 3},
      { "name": "Half Yearly","code": "H","duration": 6},
      { "name": "Yearly","code": "Y", "duration": 12 },
      { "name": "Daily","code": "BZ", "duration": 1 },
      { "name": "Weekly","code": "OW", "duration": 7 }
    ];
    vm.daysList = AppConstants.WEEKS_LIST;
    // "../../assets/images/HDFC ARN Hardcoding Banner 1.png",
    var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    if(isMobile){
      vm.imageUrls = [
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_One_Click_Link.jpg",
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_MFD.jpg",
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_RIA.jpg"
      ];
    }else{
      vm.imageUrls = [
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_One_Click_Link.jpg",
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_MFD.jpg",
        "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_RIA.jpg"
      ];
    }

    if(document){
      if(window.frameElement){
        vm.hideFooter = true;
        document.getElementById("oneClickMainpage").style.marginTop = "0px";
      }else{
        vm.hideFooter = false;
      }
    }
    vm.form.employeeCode = null;
    vm.subBrokerARN = null;
    vm.investmentARN = null;
    vm.distributorName = null;
    vm.subBrokerCode = null;
    vm.subBrokerName = null;
    vm.form.euin = {};
    vm.hardcodedArn = false;
    vm.fromBack = false;
    vm.hideAddToCartButton = false;
    vm.init = init();
    vm.auth = auth;
    vm.valid = true
    vm.nonArnAuth = nonArnAuth;
    vm.schemeType = schemeType;
    vm.isCheckMultiple = false;
    vm.isFromOneClickScreen = false;
    vm.TRANSACTIONS_CONST = angular.copy(AppConstants.TRANSACTION);
    vm.DIVIDEND_OPTIONS = AppConstants.DIVIDEND_OPTIONS;
    vm.selfEuin = false;
    vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
    //code for Sidebar pop up
    vm.showPopupScreen = showPopupScreen;
    vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
    vm.showAddEcart = false;
    vm.indexToNumberArray = AppConstants.ECART_CART_ITEM_NUMBER;
    vm.expandSidebar = expandSidebar;
    vm.addTocart = addTocart;
    vm.showSideBarCart = false;
    vm.showSideBarInvest = false;
    vm.showSideAllFunds = false;

    var appWidn = angular.element($window);
    appWidn.bind('resize',function(){
      isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

      if(isMobile){
        vm.imageUrls = [
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_One_Click_Link.jpg",
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_MFD.jpg",
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_RIA.jpg"
        ];
      }else{
        vm.imageUrls = [
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_One_Click_Link.jpg",
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_MFD.jpg",
          "../../assets/images/one-click-banner/one-click-banner-large/HDFC_One_Click_Banners_link_For_RIA.jpg"
        ];
      }

      if($stateParams.rm){
        if (isMobile) {
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/HDFC-ARN-mb-rm.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RM Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
      }
      if($stateParams.r){
        if(isMobile){
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/RIA-mb.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RIA Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
      }
      if($stateParams.x){
        vm.imageUrls = [
          "../../assets/images/HDFC ARN Hardcoding Banner 1.png",
          "../../assets/images/HDFC ARN Hardcoding Banner 3.png",
        ];
      }
      $scope.$apply();
    });
    function init() {
      vm.sipFIwithHDFCbank = false;
      if($stateParams.x){
        vm.imageUrls = [
          "../../assets/images/HDFC ARN Hardcoding Banner 1.png",
          "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
        ];
        // vm.hdfcuser=true;
        vm.hardcodedArn = true;
        vm.form.arn = $window.atob($stateParams.x)
        vm.form.linkType = 'MFD';
        auth();
        vm.hdfcOneClick = true;
        vm.ShowSubBrokerArn = false;
        vm.onlyHdfcUserOneClick = true;
        vm.hideAddToCartButton = false;
      }
      if($stateParams.r){
        vm.hardcodedArn = true;
        vm.form.linkType = 'RIA';
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if(isMobile){
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/RIA-mb.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RIA Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
        if($stateParams.r == "true"){
        }else{
          vm.form.ria = $window.atob($stateParams.r)
          nonArnAuth();
        }
        vm.hideAddToCartButton = true;
      }
      if($stateParams.rm){
        vm.hardcodedArn = true;
        vm.form.linkType = 'RM';
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if(isMobile){
          vm.imageUrls = [
            "../../assets/images/arnmobilebanner/HDFC-ARN-mb-rm.jpg",
            "../../assets/images/arnmobilebanner/HDFC-ARN-benefits.jpg"
          ];
        }else{
          vm.imageUrls = [
            "../../assets/images/RM Banner.jpg",
            "../../assets/images/HDFC ARN Hardcoding Banner 3.png"
          ];
        }
        if($stateParams.rm == "true"){
        }else{
          vm.form.employeeCode = $window.atob($stateParams.rm)
          nonArnAuth();
        }
        vm.hideAddToCartButton = true;
      }
      if(HDFC_API.ENV == 'beta' || HDFC_API.ENV == 'prod'){
        hideChatIcon();
      }
    }
    function hideChatIcon(){
      $timeout(function(){
        var uiViewElement = angular.element(document.querySelector('body > .widget-visible'));
        if(uiViewElement[0]){
          uiViewElement.removeAttr('class');
        }else{
          hideChatIcon();
        }
      },1000);
    }

    vm.validation = function(){
      if(vm.form.linkType == "MFD"){
        if(vm.form.arn){
          vm.valid = false;
        }else{
          vm.valid = true;
        }
        if(vm.form.arn){
          if(vm.subBrokerARN){
            vm.valid = false;
          }
        }
      }
      if(vm.form.linkType == "RM"){
        if(vm.form.sublinkType == "Direct"){
          if(vm.form.employeeCode){
            vm.valid = false;
            nonArnAuth();
          }else{
            vm.valid = true;
          }
        }else  if(vm.form.sublinkType == "Distributor"){
          if(vm.form.arn && vm.form.employeeCode){
            vm.valid = false;
          }else{
            vm.valid = true;
          }
        }
      }
      if(vm.form.linkType == "RIA"){
        if(vm.form.ria && vm.form.riaName){
          vm.valid = false;
        }else{
          vm.valid = true;
        }
      }
    }

    function schemeType(type){
      vm.valid = true;
      vm.form.InSchemeName = "";
      vm.form.amount = "";
      vm.form.displayAmount = "";
      vm.form.transactionType = "PURCHASE";
      vm.form.startDate = "";
      vm.form.endDate = "";
      vm.form.frequency = "OM";
      if($stateParams.rm){
        if($stateParams.rm == "true"){
          vm.form.employeeCode = null;
        }
      }else{
        vm.form.employeeCode = null;
      }
      vm.url = null;
      if(type=="Direct")
      {
        nonArnAuth();
        vm.form.sublinkType = "Direct"
        vm.ShowSubBrokerArn = false;
      }
      if(type=="Distributor")
      {
        vm.form.sublinkType = "Distributor"
        vm.ShowSubBrokerArn = true;
      }
      if(type=="RIA")
      {
//  nonArnAuth();
      }
    }


    function nonArnAuth() {
      var successLogin = function (resp) {
        sessionStorage.setItem('arnAuth',true);
        vm.isThroughDistributor = false;
        LoaderService.hideLoader();
        vm.investmentType(vm.form.transactionType);
        if(vm.form.ria){
          vm.verifyRIA();
        }
        if(vm.form.InSchemeCode){
          vm.fetchValidations(vm.form.InSchemeCode);
        }
        if(vm.fromModel){
          vm.schemeListModal();
          vm.fromModel = false;
        }
      },errorLogin = function(resp){
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      }
      var oauthpayload = {
        arnCode:'ARN-DIRECT',
        grant_type: 'password',
        panNumber: null,
        appType: 'W',
        type:'arn'
      };
      LoaderService.showLoader();
      AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);


    }

    function auth() {
      var length = vm.form.arn?vm.form.arn.length:0;
      if(length>3)
      {
        var successLogin = function (resp) {
          if(resp.access_token){
            sessionStorage.setItem('arnAuth',true);
            LoaderService.hideLoader();
            fetchEuinList();
            vm.investmentType(vm.form.transactionType);
            if(vm.fromModel){
              vm.schemeListModal();
              vm.fromModel = false;
            }
          }else{
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },errorLogin = function(resp){
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
        var oauthpayload = {
          arnCode:'ARN-'+vm.form.arn,
          grant_type: 'password',
          panNumber: null,
          appType: 'W',
          type:'arn'
        };
        LoaderService.showLoader();
        AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

      }
    }
    vm.authARN = function() {
      var length = vm.form.arn?vm.form.arn.length:0;
      vm.subBrokerName = null;
      vm.subBrokerCode = null;
      if(length>3)
      {
        vm.subBrokerARN = null;
        var successLogin = function (resp) {
          if(resp.access_token){
            sessionStorage.setItem('arnAuth',true);
            LoaderService.hideLoader();
            vm.isThroughDistributor = true;
            vm.validation();
            fetchEuinList();
            vm.investmentType(vm.form.transactionType);
          }else{
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },errorLogin = function(resp){
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
        var oauthpayload = {
          arnCode:'ARN-'+vm.form.arn,
          grant_type: 'password',
          panNumber: null,
          appType: 'W',
          type:'arn'
        };
        LoaderService.showLoader();
        AuthService.InstantLogin(oauthpayload).then(successLogin, errorLogin);

      }
    }
    vm.distributorImage = null;
    vm.distributorName = null;
    function fetchEuinList() {
      vm.euinList = [];
     vm.getDistributerProfile();
    //   var success = function (resp) {
    //       if (resp.status && resp.data) {
    //         vm.distributorName = resp.data.distributorName;
    //         vm.euinList =  resp.data.euinList.sort( function( a, b ) {
    //           return a.euinName < b.euinName ? -1 : a.euinName > b.euinName ? 1 : 0;
    //         });

    //         var temp1 = vm.euinList;
    //         vm.euinList = [];
    //         vm.euinMasterList = [];
    //         vm.euinList.push(
    //           {
    //             "euinCode": "",
    //             "euinName": "Select Euin",
    //             "euinNameCode": "Select Euin"
    //           });
    //         vm.euinMasterList.push(
    //           {
    //             "euinCode": "",
    //             "euinName": "Select Euin",
    //             "euinNameCode": "Select Euin"
    //           });
    //         temp1.forEach(function(element){
    //           vm.euinList.push(element);
    //         });

    //         // vm.euinMasterList = resp.data.euinList;
    //         resp.data.euinList.forEach(function(element){
    //           vm.euinMasterList.push(element);
    //         });
    //         vm.getDistributerProfile()
    //         LoaderService.hideLoader();
    //       } else {
    //         LoaderService.hideLoader();
    //         vm.euinList = null;
    //         MessageService.error(resp.message);
    //       }
    //     },
    //     error = function () {
    //       LoaderService.hideLoader();
    //       vm.euinList = null;
    //       vm.resetValue(vm.form.linkType);
    //       //UtilService.errorHandler(err);
    //     };

    //   LoaderService.showLoader();
    //   var path = {
    //     controller1: 'getEuin',
    //     controller2: 'ARN-'+vm.form.arn
    //   };
    //   TransactionArnService.get(path).$promise.then(success, error);
    }
    vm.getDistributerProfile = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        $(".shcemeInputBox" ).focus();
        $(".shcemeInputBox" ).blur();
        $(".dropDwn").hide();
        if (resp.status && resp.data) {
          vm.distributorImage = resp.data.imageName;
          vm.distributorName = resp.data.distributorName;
          if(vm.form.euin){
            if(vm.form.euin.euinCode){
              vm.selectEuin(vm.form.euin);
            }else{
              vm.selectEuin(vm.form.euin);
            }
          }else{
            vm.selectEuin(vm.form.euin);
          }
        } else {
          vm.euinList = null;
          MessageService.error(resp.message);
        }
      }, error = function (err) {
        MessageService.error(err);
        LoaderService.hideLoader();
        vm.euinList = null;
      };
      LoaderService.showLoader();
      TransactionArnService.get({
        controller1: "getDistributorProfile",
        controller2: "ARN-" + vm.form.arn,
      }).$promise.then(success, error);
    }
    vm.fetchEuinListSubBroker = function() {
      vm.euinList = [];
      if(!vm.subBrokerARN){
        vm.subBrokerCode = null;
        fetchEuinList();
      }
      vm.validation();
      var length = vm.subBrokerARN?vm.subBrokerARN.length:0
      vm.form.euin.euinCode = null;
      if(length> 2){
        var success = function (resp) {
            LoaderService.hideLoader();
            if (resp.status && resp.data) {
              vm.subBrokerName = resp.data.distributorName;
              var temp1 = resp.data.euinList;
              vm.euinList = [];
              vm.euinMasterList = [];
              vm.euinList.push(
                {
                  "euinCode": "",
                  "euinName": "Select Euin",
                  "euinNameCode": "Select Euin"
                });
              vm.euinMasterList.push(
                {
                  "euinCode": "",
                  "euinName": "Select Euin",
                  "euinNameCode": "Select Euin"
                });
              temp1.forEach(function(element){
                vm.euinList.push(element);
              });
              resp.data.euinList.forEach(function(element){
                vm.euinMasterList.push(element);
              });
            } else {
              LoaderService.hideLoader();
              vm.euinList = null;
              vm.subBrokerARN = null;
              MessageService.error(resp.message);
            }
          },
          error = function () {
            LoaderService.hideLoader();
            vm.euinList = null;
            //UtilService.errorHandler(err);
          };

        LoaderService.showLoader();
        var path = {
          controller1: 'getEuin',
          controller2: 'ARN-'+vm.subBrokerARN ,
          isSubBroker: true
        };
        TransactionArnService.get(path).$promise.then(success, error);
      }
    }
    vm.url = "";
    vm.submitArn = function () {
      var success = function (resp) {
        LoaderService.hideLoader();
        if(resp.url){
          vm.url = resp.url;
          vm.goDown();
        }else{
          MessageService.error(resp.message);
        }
      },error = function (resp) {
        LoaderService.hideLoader();
        MessageService.error(resp.message);
      };

      if(vm.form.linkType == "MFD"){
        vm.dataPayload = {
          arnCode:"ARN-"+vm.form.arn,
          euin:"E"+vm.form.euin.euinCode,
          key:vm.form.linkType,
          schemeCode:vm.form.InSchemeCode,
          transactionType:vm.form.transactionType,
          amount:vm.form.amount
        };
        if(vm.subBrokerARN == undefined || vm.subBrokerARN == null){
          vm.dataPayload.subBrokerArn = "";
        }
        if(vm.subBrokerARN){
          vm.dataPayload.subBrokerArn = "ARN-"+vm.subBrokerARN;
          vm.dataPayload.subBrokerCode = vm.subBrokerCode;
        }

        if(vm.form.euin.euinCode && vm.form.euinSelected === "true"){
          vm.dataPayload.euin = "E"+vm.form.euin.euinCode;
        }else{
          delete vm.dataPayload['euin'];
        }
        if(vm.form.transactionType == "SIP"){
          if(vm.form.InSchemeCode){
            vm.dataPayload.frequency = vm.form.frequency;
            vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
            vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") :'';
          }
        }
        vm.dataPayload.dividendOption = vm.form.DividendOption;
        if(vm.form.transactionType == "PURCHASE SCHEDULER"){
          vm.dataPayload.transactionType = "PURCHASE_SCHEDULER";
          if(vm.form.InSchemeCode){
            vm.dataPayload.scheduleFrequency = vm.form.frequency;
            vm.dataPayload.schedulerStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
            vm.dataPayload.schedulerEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") :'';
            vm.dataPayload.dividendOption = vm.form.DividendOption;
          }
          if(vm.form.frequency == 'WK'){
            vm.dataPayload.scheduleFrequency = 'W';
          }
        }
        if(vm.hdfcOneClick){
          vm.dataPayload.utmSource = vm.form.utmsource ? vm.form.utmsource : '' ;
          vm.dataPayload.utmMedium = vm.form.utmmedium ? vm.form.utmmedium : '';
        }
      }else if(vm.form.linkType == "RIA"){
        vm.dataPayload = {
          riaCode : vm.form.ria,
          key:vm.form.linkType,
          arnCode:"ARN-DIRECT",

          schemeCode:vm.form.InSchemeCode,
          transactionType:vm.form.transactionType,
          amount:vm.form.amount
        };
        if(vm.form.transactionType == "SIP"){
          if(vm.form.InSchemeCode){
            vm.dataPayload.frequency = vm.form.frequency;
            vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
            vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
          }
        }
        vm.dataPayload.dividendOption = vm.form.DividendOption;
      }else if(vm.form.linkType == "RM"){
        if(vm.form.sublinkType == "Direct"){
          vm.dataPayload = {
            empCode:vm.form.employeeCode.toUpperCase(),
            key:"E_CODE",
            arnCode:"ARN-DIRECT",
            ecodeKey: "Direct",
            schemeCode:vm.form.InSchemeCode,
            transactionType:vm.form.transactionType,
            amount:vm.form.amount
          };
          if(vm.form.transactionType == "SIP"){
            if(vm.form.InSchemeCode){
              vm.dataPayload.frequency = vm.form.frequency;
              vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
              vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
            }
          }
          vm.dataPayload.dividendOption = vm.form.DividendOption;
        }else if(vm.form.sublinkType == "Distributor"){
          vm.dataPayload = {
            arnCode:'ARN-'+vm.form.arn,
            empCode:vm.form.employeeCode.toUpperCase(),
            key:"E_CODE",
            ecodeKey: "Regular",
            schemeCode:vm.form.InSchemeCode,
            transactionType:vm.form.transactionType,
            amount:vm.form.amount
          }
          if(vm.subBrokerARN){
            vm.dataPayload.subBrokerArn = 'ARN-'+vm.subBrokerARN;
            vm.dataPayload.subBrokerCode = vm.subBrokerCode;
          }
          if(vm.form.euin.euinCode && vm.form.euinSelected === "true"){
            vm.dataPayload.euin = "E"+vm.form.euin.euinCode;
          }else{
            delete vm.dataPayload['euin'];
          }
          if(vm.form.transactionType == "SIP"){
            if(vm.form.InSchemeCode){
              vm.dataPayload.frequency = vm.form.frequency;
              vm.dataPayload.sipStartDate = vm.form.startDate ? vm.form.startDate.format("YYYY-MM-DD") : '';
              vm.dataPayload.sipEndDate = vm.form.endDate ? vm.form.endDate.format("YYYY-MM-DD") : '';
            }
          }
          vm.dataPayload.dividendOption = vm.form.DividendOption;
        }else{
          MessageService.error("Plase select all reqired inputs.");
        }
      }else{
        MessageService.error("Plase select all reqired inputs.");
      }
      LoaderService.showLoader();
      // TransactionArnService.post({controller1: "getShortLink",},vm.dataPayload).$promise.then(success, error);
      if(vm.dataPayload){
        if($stateParams.x){
          vm.dataPayload.hdfcBank = true;
          vm.dataPayload.mfdFlowName = 'HDFC_ONE_CLICK';
        } else if ($stateParams.rm) {
          vm.dataPayload.mfdFlowName = 'EMPLOYEE';
        } else {
          vm.dataPayload.mfdFlowName = 'ONE_CLICK';
        }
        TransactionArnService.post({controller1: "getShortUrl",},vm.dataPayload).$promise.then(success, error);
      }else{
        MessageService.error("Something went wrong");
      }
    }
    vm.resetValue = function(type){
      vm.form.arn =null;
      vm.form.euin = {};
      vm.form.riaCode = null;
      vm.form.riaName = null;
      vm.form.employeeCode = null;
      vm.subBrokerARN = null;
      vm.investmentARN = null;
      vm.distributorName = null;
      vm.subBrokerCode = null;
      vm.subBrokerName = null;
      vm.valid =true;
      vm.euinList = null;
      vm.isThroughDistributor = false;
      vm.form.ria = null;
      vm.arnChanged();
      if(type == 'RIA'){
        vm.schemeType('RIA')
      }

      vm.form.transactionType = "PURCHASE";
      vm.form.amount = "",
        vm.form.frequency = "OM";
      vm.setFrequency('OM');
      vm.form.startDate = null;
      vm.form.endDate = null;
      vm.form.InSchemeCode = "";
      vm.form.InSchemeName = "";
      vm.form.schemeType = "";
      vm.form.isTillPerpetuity = false;
    }
    vm.isCheckedTandC = false;
    vm.changeSubBrokerArn = function () {
      vm.validation();
      vm.isCheckedTandC = false;
      vm.subBrokerName = '';
    }
    vm.selectEuin = function(data){
      if(data == null){
      }else{
        vm.form.euin = data;
        vm.validation()
      }

    }
    vm.filterEuinList = function () {
      if(vm.form.euin.euinCode){
        $("#euin").css("text-transform", "uppercase");
      }else{
        $("#euin").css("text-transform", "capitalize");
      }

      if(vm.form.euin.euinCode){
        vm.euinList = UtilService.getFilteredList(vm.euinMasterList, 'euinNameCode', vm.form.euin.euinCode);
      }
      vm.euinList = vm.form.euin.euinCode == '' || vm.form.euin.euinCode == undefined ? vm.euinMasterList : vm.euinList;
    };

    vm.verifyRIA = function() {
      if(vm.form.ria.length == 12){
        var success = function (resp) {
          LoaderService.hideLoader();
          if (resp.status && resp.data) {
            vm.riaCodeError = "";
            vm.form.riaName = resp.data.distributorName;
            vm.validation()
          } else {
            LoaderService.hideLoader();
            vm.riaCodeError = resp.message;
            vm.form.ria = "";
            MessageService.error(resp.message);
          }
        },error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err.data.message);
        };

        LoaderService.showLoader();
        var path = {
          controller1: 'getEuin',
          controller2: vm.form.ria,
          riaOpted: true
        };
        TransactionArnService.get(path).$promise.then(success, error);
      }
    }

    vm.showArn = false;
    vm.subnote = function(){
      vm.showArn = true;
      $(".arnNote").css("top", "12%")
      $(".subnote").css("top", "-12%");
      $(".subBrokerArn").focus();
    }
    vm.subnote1 = function(){
      vm.validation();
      if($(".subBrokerArn").val()){
        $(".subBrokerCode").focus();
        $(".subnote1").css("top", "-12%");
      }else{
      }
    }
    vm.arnChanged = function(){
      vm.distributorName = null;
      vm.euinList = null;
      vm.form.euin.euinCode = null;
      vm.distributorImage = null;
      vm.url = null;
    }
    vm.investmentType = function(val){
      vm.SchemeList = [];
      if(!vm.fromBack){
        vm.form.InSchemeCode = "";
        vm.form.InSchemeName = "";
        vm.form.schemeType = "";
        vm.form.fundCode = "";
      }
      vm.enabledMINStartDates = "";
      vm.form.endDate = "";
      vm.form.startDate = "";
      vm.purchaseValidations = null;
      vm.form.amount = "";
      vm.form.displayAmount = "";
      vm.form.DividendOption = "";
      vm.form.InvestmentOption = "";
      vm.url = "";
      $window.NumToWord(vm.form.amount, 'DisplayWordsTaxAmount');
      vm.form.transactionType = val;
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          vm.SchemeList = resp.data.schemeList;
          vm.MasterSchemeList = vm.SchemeList;
          // vm.purchaseInSchemeList = UtilService.getFilteredList(vm.SchemeList);
          // cb();
          // if (vm.arnHardcodedData) {
          //   if (vm.arnHardcodedData.schemeGroupCode) {
          //     schemeGroupCodeList(vm.vm.SchemeList , "purchase")
          //   }
          // }
          if(vm.form.InSchemeName && vm.form.InSchemeCode){
            vm.fetchValidations(vm.form.InSchemeCode);
          }
        } else {
          vm.SchemeList = null;
          MessageService.error(resp.message);
        }
        vm.fromBack = false;
      },error = function (err) {
        if(err.data.error == 'invalid_token'){
          vm.fromBack = true;
          if(vm.form.arn){
            auth();
          }else{
            nonArnAuth();
          }
          return;
        }
        vm.SchemeList = null;
        UtilService.errorHandler(err);
        MessageService.error(err.data.error);
      };
      LoaderService.showLoader();
      if(vm.form.arn){
        vm.isThroughDistributor = true;
      }else{
        vm.isThroughDistributor = false;
      }

      if(val == 'PURCHASE SCHEDULER' && $stateParams.x){
        if(AppConstants.HDFC_WITH_DIRECT_ARN){
          vm.restrictARN = true;
          vm.isThroughDistributor = false;
        }else{
          vm.restrictARN = false;
          vm.isThroughDistributor = true;
        }
      }else{
        vm.restrictARN = false;
      }
      if(vm.form.transactionType == "SIP"){
        TransactionArnService.get({
          controller1: 'scheme',
          controller2: 'ALL',
          controller3: 'sipenabled',
          controller4: false,
          controller5: vm.isThroughDistributor
        }, null).$promise.then(success, error);
      } else if(vm.form.transactionType == "SWITCH") {
        TransactionArnService.get({
          controller1: 'scheme',
          controller2: 'ALL',
          controller3: 'switchenabled',
          controller4: false,
          controller5: vm.isThroughDistributor
        }, null).$promise.then(success, error);
      }else if(vm.form.transactionType == "REDEMPTION") {
        TransactionArnService.get({
          controller1: 'scheme',
          controller2: 'ALL',
          controller3: 'redemptionenabled',
          controller4: false,
          controller5: vm.isThroughDistributor
        }, null).$promise.then(success, error);
      } else{
        TransactionArnService.get({
          controller1: 'scheme',
          controller2: 'ALL',
          controller3: 'purchaseenabled',
          controller4: false,
          controller5: vm.isThroughDistributor
        }, null).$promise.then(success, error);
      }
    }
    vm.filterInSchemeList = function () {
      vm.SchemeList2 = [];
      vm.SchemeList2 = UtilService.getFilteredList(vm.MasterSchemeList, 'scheme', vm.form.InSchemeName);
      vm.SchemeList = [];
      vm.SchemeList = vm.SchemeList2;
      if(!vm.form.InSchemeName || vm.SchemeList2.length == 0){
        vm.form.amount = "";
        vm.form.displayAmount = "";
      }
    };
    vm.InSchemeChanged = function (data) {
      if (data) {
        vm.form.InSchemeCode = data.schemeCode;
        vm.form.InSchemeName = data.scheme;
        vm.form.schemeType = data.schemeType;
        vm.form.minorFlag = data.minorFlag;
        vm.form.fundCode = data.fundCode;
        vm.fetchValidations(vm.form.InSchemeCode);
        vm.SchemeList = vm.MasterSchemeList;

        if (vm.form.transactionType === 'SWITCH') {
          vm.form.InvestmentOption = AppConstants.TRANSACTION.DIVIDEND;
          if(data.dividendPayoutApplicable || data.dividendReinvestmentApplicable){
            if(data.dividendPayoutApplicable == "true" && data.dividendReinvestmentApplicable == "false"){
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
            }else if(data.dividendPayoutApplicable == "false" && data.dividendReinvestmentApplicable == "true"){
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            }else if(data.dividendReinvestmentApplicable == "true" && data.dividendPayoutApplicable == "true"){
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            }else{
              vm.form.InvestmentOption = AppConstants.TRANSACTION.GROWTH;
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
            }
          }
        }

      }else{
        return;
      }
      vm.form.amount = '';
    };
    vm.fetchValidations = function(schemeCode) {
      vm.purchaseValidations = null;
      var success = function (resp) {
        if (resp.status && resp.data) {
          vm.purchaseValidations = resp.data;
          if(vm.form.transactionType == "SIP") {
            vm.extractValidationObject(vm.purchaseValidations);
          }
          if(vm.purchaseValidations.amountArray && vm.purchaseValidations.amountArray.length > 0){
            vm.purchaseValidations.amountArray.forEach(function (amount,index) {
              var displayWord = parseInt(amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              vm.purchaseValidations.amountArray[index] = {
                value : amount,
                displayAmount : displayWord
              }
            })
            vm.form.amount = vm.purchaseValidations.amountArray[0].value;
            vm.additionalSipData = resp.data.additionalValidation && resp.data.additionalValidation.OM;
            vm.setAmount(vm.form.amount);
          } else {
            vm.purchaseValidations.amountArray = angular.copy(AppConstants.SIP_WITH_FI.SUGGESTED_AMOUNT);
            vm.purchaseValidations.amountArray.forEach(function (amount,index) {
              var displayWord = parseInt(amount.toString().replaceAll(",", "")).toLocaleString('en-IN');
              vm.purchaseValidations.amountArray[index] = {
                value : amount,
                displayAmount : displayWord
              }
            })

            vm.form.amount = vm.purchaseValidations.amountArray[0].value;
            vm.additionalSipData = resp.data.additionalValidation && resp.data.additionalValidation.OM;
            vm.setAmount(vm.form.amount);
          }
          vm.form.InvestmentOption = vm.purchaseValidations.isGrowth ? AppConstants.TRANSACTION.GROWTH : (vm.form.InvestmentOption !== AppConstants.TRANSACTION.GROWTH && vm.form.InvestmentOption || AppConstants.TRANSACTION.DIVIDEND);
          if (vm.purchaseValidations.isGrowth) {
            vm.form.DividendOption = vm.DIVIDEND_OPTIONS.GROWTH;
          } else {

            if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === false) {
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.PAYOUT;
            } else if (vm.purchaseValidations.dividendPayoutApplicable === false && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            } else if (vm.purchaseValidations.dividendPayoutApplicable === true && vm.purchaseValidations.dividendReinvestmentApplicable === true) {
              vm.form.DividendOption = vm.DIVIDEND_OPTIONS.REINVEST;
            }

          }
          if(vm.form.transactionType == "PURCHASE"){
            vm.form.amount = vm.purchaseValidations.amountArray[1].value;
            vm.setAmount(vm.form.amount);
            vm.validatePurchaseAmount();
          }
        }else{
          MessageService.error(resp.message);
        }
        vm.fromBack = false;
      },error = function (err) {
        if(err.data.error == 'invalid_token'){
          vm.fromBack = true;
          if(vm.form.arn){
            auth();
          }else{
            nonArnAuth();
          }
          return;
        }
        MessageService.error(err);
      };

      if(vm.form.transactionType == "SIP"){
        var path = {
          controller1: 'schemeValidation',
          controller2: 'sip',
          controller3: vm.form.InSchemeCode
        };
        TransactionArnService.get1(path).$promise.then(success, error);
      }else if(vm.form.transactionType == "PURCHASE" || vm.form.transactionType == "PURCHASE SCHEDULER"){
        var data = {
          schemeCode: vm.form.InSchemeCode
        };
        TransactionArnService.post4({
          controller1: 'schemeValidation',
          controller2: 'purchase'
        }, data).$promise.then(success, error);
      }
    }
    vm.setFrequency = function(frequency){
      vm.form.frequency = frequency;
      if(vm.form.frequency == 'OW'){
        vm.WeekFrequency = false;
      }else{
        vm.WeekFrequency = true;
      }
      vm.form.startDate = null;
      vm.form.endDate = null;
      vm.form.isTillPerpetuity = false;
      vm.form.weeklyDay = null;
      vm.minEndDate = null;
      if(vm.form.transactionType == "PURCHASE SCHEDULER"){
        vm.validatePurchaseAmount();
      }else{
        vm.extractValidationObject(vm.purchaseValidations);
        vm.validateAmount();
      }
    }

    vm.setAmount = function(amount){
      if (!amount) {
        return;
      }
      var amountObj = UtilService.amountInCommaARN(amount);
      vm.form.displayAmount = amountObj.amountInComma;
      vm.form.amount = amountObj.amount;
      // vm.form.amount = amount;
      $window.NumToWord(vm.form.amount, 'DisplayWordsTaxAmount');
      if(vm.form.amount){
        if(vm.form.transactionType == "SIP"){
          // vm.extractValidationObject(vm.purchaseValidations);
          vm.validateAmount();
        }else{
          vm.validatePurchaseAmount();
          if(vm.form.transactionType == "PURCHASE SCHEDULER"){
            vm.validatePurchesSchedularCalender();
          }
        }
      }
    }
    vm.validateAmount = function(){
      if (vm.additionalSipData) {
        vm.isMax = vm.validations.maxAmount && vm.validations.maxAmount < vm.form.amount;
        vm.isMin = vm.validations.minAmount && vm.validations.minAmount > vm.form.amount;
        vm.isMultiples = vm.validations.amountMultiples && vm.form.amount && (vm.form.amount % vm.validations.amountMultiples === 0) || false;
        if(vm.form.amount && !vm.isMin && (vm.validations.amountMultiples && !vm.isMultiples)){
          vm.isCheckMultiple = true;
        }else{
          vm.isCheckMultiple = false;
        }

        var newValidation = vm.additionalSipData;
        for (var i = 0; i < newValidation.length; i++) {
          var condition = vm.form.amount < newValidation[i].min_amount_lower || vm.form.amount <= newValidation[i].min_amount_upper
          if (!newValidation[i].min_amount_upper) {
            var condition = true;
          }
          if (condition) {
            vm.validations.amountMultiples = newValidation[i].amt_multiples;
            vm.validations.maxAmount = newValidation[i].min_amount_upper;
            vm.validations.minAmount = newValidation[i].min_amount_lower;
            vm.validations.minInstallments = newValidation[i].min_installments;
            break;
          }
        }
      }
      if(vm.form.amount >= 2000000){
        vm.amountExceeded = true;
      }else {
        vm.amountExceeded = false;
      }

    }
    vm.validatePurchaseAmount = function(){
      if(vm.purchaseValidations && vm.purchaseValidations.validationType == 'PURCHASE'){
        vm.validations.minAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        vm.validations.amountMultiples = vm.purchaseValidations.purchaseMultiple;
        vm.isMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.form.amount;
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.form.amount && (vm.form.amount % vm.purchaseValidations.purchaseMultiple === 0) || false;
        if(vm.form.amount && !vm.isMin && (vm.validations.amountMultiples && !vm.isMultiples)){
          vm.isCheckMultiple = true;
        }else{
          vm.isCheckMultiple = false;
        }
      }
    }
    vm.setPaymentOption = function(paymentOption){
      vm.form.paymentOption = paymentOption;
    }
    vm.validations = {
      amountMultiples : "",
      maxInstallments : "",
      minInstallments : "",
      minAmount : "",
      maxAmount : "",

    }
    vm.extractValidationObject = function(validationsData) {
      if (!validationsData || !vm.form.frequency) {
        return;
      }

      vm.validations.amountMultiples = vm.validations.amountMultiples || 1;
      vm.validations.maxInstallments = vm.validations.maxInstallments || 0;
      vm.validations.minInstallments = vm.validations.minInstallments || 0;
      vm.validations.minAmount = vm.validations.minAmount || 0;
      vm.validations.maxAmount = vm.validations.maxAmount || 0;

      switch (vm.form.frequency) {
        case 'BZ':
          vm.validations.maxInstallments = validationsData.dailyMaxInstallmentNumber;
          if (validationsData.additionalValidation.BZ) {
            vm.additionalSipData = validationsData.additionalValidation.BZ;
            vm.validations.minAmount = validationsData.additionalValidation.BZ[0].min_amount_lower;
          }
          getDateValidation();
          break;
        case 'OW':
          vm.validations.maxInstallments = validationsData.weeklyMinInstallmentNumber;
          if (validationsData.additionalValidation.OW) {
            vm.additionalSipData = validationsData.additionalValidation.OW;
            vm.validations.minAmount = validationsData.additionalValidation.OW[0].min_amount_lower;
          }
          getDateValidation();
          break;
        case 'Q':
          vm.validations.maxInstallments = validationsData.quarterlyMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if (validationsData.additionalValidation.Q) {
            vm.additionalSipData = validationsData.additionalValidation.Q;
            vm.validations.minAmount = validationsData.additionalValidation.Q[0].min_amount_lower;
          }
          getDateValidation();
          break;
        case 'OM':
          vm.validations.maxInstallments = validationsData.monMaxInstallmentNumber;
          vm.validations.topupMinAmt = validationsData.topupMinAmt;
          vm.validations.topupAmtMultples = validationsData.topupAmtMultples;
          vm.validations.topupMinPercentage = validationsData.topupMinPercentage;
          vm.validations.topupPercentageMultples = validationsData.topupPercentageMultples;
          if (validationsData.additionalValidation.OM) {
            vm.additionalSipData = validationsData.additionalValidation.OM;
            vm.validations.minAmount = validationsData.additionalValidation.OM[0].min_amount_lower;
          }
          getDateValidation();
          break;
        case 'H':
          vm.additionalSipData = validationsData.additionalValidation.H;
          vm.validations.minAmount = validationsData.additionalValidation.H[0].min_amount_lower;
          getDateValidation();
          break;
        case 'Y':
          vm.additionalSipData = validationsData.additionalValidation.Y;
          vm.validations.minAmount = validationsData.additionalValidation.Y[0].min_amount_lower;
          getDateValidation();
          break;
      }
    }

    vm.changeStartDate = function (date) {
      LoaderService.showLoader();
      vm.form.startDate = date ? date : null;
      vm.form.day = vm.form.startDate ? vm.form.startDate.format('D') : '';
      vm.form.endDate = null;
      if( vm.form.transactionType == "PURCHASE SCHEDULER"){
        vm.updatePurchaseSchedulerEndDate();
      }else{
        updateEndDates();
      }
      LoaderService.hideLoader();
    };

    function updateEndDates() {
      if (!vm.form.startDate) {
        return;
      }


      var defaultEndDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
      //var defaultEndDate = new Date(2036, 12, 31);
      var defaultMonths = null;
      var endDate = null;
      vm.enabledEndDates = [];
      vm.enabledViewEndDate = null;
      var freq = vm.validations && vm.validations.maxInstallments || 0;
      var i = 0;
      var frequency = vm.frequencyList.find(function (f) {
        return f.code === vm.form.frequency;
      }) || {};


      switch (vm.form.frequency) {
        case 'BZ':
          var days = 0;
          vm.enabledEndDates = [];
          vm.enabledViewEndDate = null;
          endDate = vm.form.startDate.clone();//.add(minInstallments, 'days');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          var days = UtilService.getMonthsCount(vm.form.startDate.clone(), defaultEndDate);
          freq = ((defaultMonths * 30) / frequency.duration) + days;
          for (i = 0; i < freq; i++) {
            days = frequency.duration * i;
            vm.enabledEndDates.push(endDate.clone().add(days, 'days'));
          }
          // vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
          // vm.minEndDate = vm.form.endDate ? vm.form.endDate : angular.copy(vm.enabledEndDates[vm.minInstallments]);
          break;
        case 'OW':
          var days = 0;
          var enabledEndDates = [];
          defaultEndDate = new Date("12/31/2099");
          freq = UtilService.getNumberOfWeeks(vm.form.startDate.toDate(), defaultEndDate);
          for (i = 0; i <= freq; i++) {
            days = frequency.duration * i;
            enabledEndDates.push(vm.form.startDate.clone().add(days, 'days'));
          }
          vm.enabledEndDates = enabledEndDates;
          vm.enabledViewEndDate = vm.enabledEndDates.length > 0 ? angular.copy(vm.enabledEndDates[0]) : null;
          // vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
          // vm.minEndDate = angular.copy(vm.enabledEndDates[vm.minInstallments]);
          break;
        // case 'H':
        //   var months = 0;
        //   vm.enabledEndDates = [];
        //   var endDate = vm.form.startDate.clone().add(frequency, 'months');
        //   defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
        //   freq = freq || (defaultMonths / frequency.duration);
        //   for (i = 0; i < freq; i++) {
        //     months = frequency.duration * i;
        //     vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
        //   }
        //   vm.minEndDate = endDate;
        //   return;
        //   break;
        //   case 'Y':
        //   var months = 0;
        //   vm.enabledEndDates = [];
        //   var endDate = vm.form.startDate.clone().add(frequency, 'months');
        //   defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
        //   freq = freq || (defaultMonths / frequency.duration);
        //   for (i = 0; i < freq; i++) {
        //     months = frequency.duration * i;
        //     vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
        //   }
        //   vm.minEndDate = endDate;
        //   return;
        //   break;
        // case 'Q':
        // var months = 0;
        // vm.enabledEndDates = [];
        // var endDate = vm.form.startDate.clone().add(frequency, 'months');
        // defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
        // freq = freq || (defaultMonths / frequency.duration);
        // for (i = 0; i < freq; i++) {
        //   months = frequency.duration * i;
        //   vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
        // }
        // vm.minEndDate = endDate;
        // return;
        // break;
        default:
          var months = 0;
          vm.enabledEndDates = [];
          vm.enabledViewEndDate = null;
          endDate = vm.form.startDate.clone().add(frequency, 'months');
          defaultMonths = UtilService.getNumberOfMonths(endDate, $window.moment(defaultEndDate));
          freq = freq || (defaultMonths / frequency.duration);
          for (i = 0; i < freq; i++) {
            months = frequency.duration * i;
            vm.enabledEndDates.push(endDate.clone().add(months, 'months'));
          }
          break;
      }
      vm.minInstallments = vm.validations && vm.validations.minInstallments && (vm.validations.minInstallments - 1) || 0;
      vm.enabledEndDates = vm.enabledEndDates.slice(vm.minInstallments);
      vm.enabledViewEndDate = vm.enabledEndDates.length > 0 ? angular.copy(vm.enabledEndDates[0]) : null;
      vm.enabledEndDateView = angular.copy(vm.enabledEndDates[0]);
      vm.minEndDate = angular.copy(vm.enabledEndDates[0]);
    }
    vm.updateDatesForWeekly = function() {
      var indexDates = $window.moment();
      var businessDays = [];
      var count = 1;
      //calculating non business days
      for (var i = 1; i <= 90; i++) {
        var indexDate = $window.moment().add(i, 'days').format("DD-MMM-YYYY");
        var isEnable = true;
        if (count <= 5) {
          angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
            if($window.moment(value,"DD-MMM-YYYY").diff(indexDate,'days')==0){
              isEnable = false;
            }
          });
        }

        if(isEnable){
          businessDays.push($window.moment().add(i, 'days'));
          count++;
        }
      }
      //setting the 5th day as part of T+5
      var currentDay = businessDays[4];
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [];
      var _day = vm.daysList.find(function (d) {
        return d === vm.form.weeklyDay;
      }) || {};
      for (var i = 0; i < 90; i++) {
        var _date = currentDay.clone().add(i, 'days');
        if (_date.format('dddd').toLowerCase() === _day.toLowerCase()) {
          enabledStartDates.push(_date.clone());
        }
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      vm.form.startDate = null;
      vm.form.startDate = vm.enabledStartDates[0];
      updateEndDates();
    }
    vm.checkPurchaseValidations = function () {
      vm.maxAmount = vm.token.maxAmount;
      if (vm.purchaseValidations) {
        if (!vm.purchaseValidations.addlPurchase) {
          vm.isPurchaseMin = vm.purchaseValidations.minFirstPurchaseAmt > vm.form.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minFirstPurchaseAmt;
        } else {
          vm.isPurchaseMin = vm.purchaseValidations.minAddlPurchaseAmt > vm.form.purchaseAmount;
          vm.purchaseMinAmount = vm.purchaseValidations.minAddlPurchaseAmt;
        }
        vm.isMultiples = vm.purchaseValidations.purchaseMultiple && vm.form.purchaseAmount && (vm.form.purchaseAmount % vm.purchaseValidations.purchaseMultiple === 0) || false;
        if(vm.form.purchaseAmount%1 != 0){
          vm.isPurchaseAmountDecimal = true;
        }
        else{
          vm.isPurchaseAmountDecimal = false;
        }
      }
    };

    function getDateValidation() {
      vm.enabledOTMStartDatesList = [];
      vm.enabledStartDates = [];
      var success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          var currentDate = resp.data.currentDate || Date();
          vm.daysList = resp.data.listOfDays;
          var parsedDate = $window.moment(currentDate, "DD-MMM-YYYY");
          var todayDate = $window.moment(Date.parse(parsedDate));
          var counter = 0;
          vm.nonBusinessDatess = resp.data.nonBuisnessDates;
          if (vm.form.paymentOption === vm.PAYMENT_OPTIONS.EMANDATE) {
            vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(vm.eMandatenoOfDays, 'days');
          } else if (vm.form.paymentOption === vm.PAYMENT_OPTIONS.EC) {
            if(vm.form.frequency == "OW" || vm.form.frequency == "BZ"){
              vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(5, 'days');
            }else{
              vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(vm.purchaseValidations.sipTDay, 'days');
            }
          } else {
            vm.enabledMINStartDates = $window.moment(Date.parse(parsedDate)).add(11, 'days');
          }
          vm.startMaxDate = $window.moment(Date.parse(parsedDate)).add(90, 'days').add(1, 'minutes');
          var startDate = todayDate.clone();
          var freq = vm.startMaxDate.diff(todayDate, 'days');
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            if (counter < 5) {
              angular.isArray(resp.data.nonBuisnessDates) && resp.data.nonBuisnessDates.forEach(function (value) {
                if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') === 0) {
                  isEnable = false;
                }
              });
            }
            if (isEnable) {
              vm.enabledOTMStartDatesList.push(startDate.clone().add(i, 'days'));
              counter++;
            }
          }
          if(vm.form.frequency=="BZ"){
            vm.enabledMINStartDates = vm.enabledOTMStartDatesList[5];
            updateDatesForDaily();
          }
        } else {
          LoaderService.hideLoader();
          MessageService.error(resp.message);
        }
      },error = function (err) {

        LoaderService.hideLoader();
        MessageService.error(err);
      };

      LoaderService.showLoader();
      TransactionArnService.get({
        controller1: 'nonBusinessDate',
        schemeCode: vm.form.InSchemeCode
      }).$promise.then(success, error);
    }
    vm.changeEndDate = function(enddate){
      vm.form.endDate = enddate ? enddate : null;
      var t = $window.moment(new Date("12/31/2099")).format('DD/MM/YYYY');
      var tempEndDate = $window.moment(new Date(enddate)).format('DD/MM/YYYY');
      if(tempEndDate == t){
        vm.form.isTillPerpetuity = true;
      }else{
        vm.form.isTillPerpetuity = false;
        if(new Date($window.moment(vm.form.endDate)).getFullYear() == 2099){
          vm.form.isTillPerpetuity = true;
        }
      }
    }
    function updateDatesForDaily() {
      var currentDay = $window.moment().add(3, 'days');
      currentDay.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0});
      var enabledStartDates = [currentDay.clone()];
      for (var i = 1; i <= 12; i++) {
        var _date = currentDay.clone().add(i, 'days');
        enabledStartDates.push(_date.clone());
      }
      vm.enabledStartDates = angular.copy(enabledStartDates);
      // vm.form.startDate = vm.enabledStartDates[0];
      vm.form.day = +(vm.form.startDate.format('DD'));
    }

    vm.schemeListModal = function () {
      var successSchemeList = function (result) {
          vm.selectedOptionalScheme = result;
          var data = {
            nfoEnabled: vm.selectedOptionalScheme.nfoEnabled,
            scheme: vm.selectedOptionalScheme.scheme,
            schemeCode: vm.selectedOptionalScheme.schemeCode,
            schemeType: vm.selectedOptionalScheme.schemeType,
            fundCode: vm.selectedOptionalScheme.fundCode
          }

          vm.InSchemeChanged(data);

        },
        errorSchemeList = function (result) {
          if(result){
            if(result.fromBack){
              vm.fromBack = true;
              vm.fromModel = true;
              if(vm.form.arn){
                auth();
              }else{
                nonArnAuth();
              }
              return;
            }
          }
          vm.SchemeList = vm.MasterSchemeList;
          vm.form.InSchemeCode = "";
          vm.form.InSchemeName = "";
          vm.form.schemeType = "";
          vm.form.amount = "";
          vm.form.displayAmount = "";
        }
      var  enabledScheme = "";
      if(vm.form.transactionType == "SIP"){
        enabledScheme ="sipenabled";
      } else if(vm.form.transactionType == "SWITCH") {
        enabledScheme ="switchenabled";
      } else if(vm.form.transactionType == "REDEMPTION") {
        enabledScheme ="redemptionenabled";
      }else{
        enabledScheme ="purchaseenabled";
      }
      if(vm.form.transactionType == "PURCHASE SCHEDULER"){
        if(AppConstants.HDFC_WITH_DIRECT_ARN){
          var val = "DIRECT";
        }else{
          var val = vm.form.arn;
        }
        ModalService.purchaseSchedulerRecomendationModal({
          "transactionType":"PURCHASE SCHEDULER",
          "ARN":val
        }, successSchemeList, errorSchemeList);
      } else if(vm.hdfcOneClick && vm.form.transactionType == "SIP" || vm.hdfcOneClick && vm.form.transactionType == "PURCHASE"){
        ModalService.schemeInFundListModal({
          enabledScheme: enabledScheme,
          isMinor: false,
          isARN: true,
          isThroughDistributor: vm.isThroughDistributor,
          keyFrom: "harnHardcoded"
        }, successSchemeList, errorSchemeList);
      }else{
       ModalService.schemeListModal({
        enabledScheme: enabledScheme,
        isMinor: false,
        isARN: true,
        isThroughDistributor: vm.isThroughDistributor,
        keyFrom: "harnHardcoded"
        }, successSchemeList, errorSchemeList);
      }
    };


    vm.changeTillPerpetuityFlag = function () {
      vm.form.endDate = null;
      if (vm.form.isTillPerpetuity) {
        vm.form.endDate = moment("12/31/2099");
        if(vm.form.transactionType == "PURCHASE SCHEDULER"){
          vm.setDec2099Date();
        }
      }
    };

    vm.goDown = function(){
      window.scrollBy(0,180);
    }

    vm.callRIA = function(){
      nonArnAuth();
    }
// vm.setDefaultEuin2 = function(){
//   $(".suggestion").css("visibility","visible");
// }
    vm.setEuin = function(){
      var v = $(".rmInput")
      v.on("click",function(event){
        event.stopPropagation();
      })

    }
    vm.hideSchemeDropDown = function(){
      var sh = $(".shcemeInputBox")
      sh.on("click",function(event){
        event.stopPropagation();
        event.preventDefault();
      })
    }

    angular.element(document).ready(function(){
      $(".dropdownTrigger").on("click",function(event){
        event.stopPropagation();
      })
      $(".shcemeInputBox").on("click",function(event){
        event.stopPropagation();
        event.preventDefault();
      })
      $(document).on("click",function(){
        $(".dropDwn").hide();
      })
    })


    vm.changedEuinDeclaration = function () {
      if (vm.form.euinSelected === "true") {
        vm.showGreenTick = false;
      }else {
        vm.form.euinSelected = "false";
        vm.showGreenTick = true;
        /*var successEuin = function(resp){
            vm.form.euinSelected = "false";
            vm.showGreenTick = true;
          },
          errorEuin = function (err){
            vm.form.euinSelected = "true";
            vm.showGreenTick = false;
          }
        ModalService.euinDeclarationOneClickModal({},successEuin, errorEuin);*/
      }
    }


    vm.messageCopied = function () {
      MessageService.success("Link Copied");
    }

    function showPopupScreen(screen) {
      switch (screen) {
        case 'INVEST_THROUGH':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.INVEST_THROUGH;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = true;
          vm.showSideAllFunds = false;
          vm.showAddEcart = false;
          $scope.$broadcast('updatedTitle');
          break;
        case 'CART_DETAILS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.CART_DETAILS;
          vm.showSideBarCart = true;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = false;
          vm.showAddEcart = false;
          $rootScope.$broadcast('updatedTitle');
          break;
        case 'ALL_FUNDS':
          vm.sidebarTitle = AppConstants.CART_DETAILS_SECTION.ALL_FUNDS;
          vm.showSideBarCart = false;
          vm.showSideBarInvest = false;
          vm.showSideAllFunds = true;
          vm.showAddEcart = false;
          $scope.$broadcast('updatedTitle');
          break;
      }
      expandSidebar();
    }

    function expandSidebar() {
      if (vm.form.itemToBeEdited === 0) {
        vm.showSideBarCart = false;
      }
      // vm.showAddEcart = false;
      $window.scrollTo(0,0);
      UtilService.expandSideBar();
    }

    function addTocart(){
      if((!vm.onlyHdfcUserOneClick && localStorage.getItem('ecartItems')) || (vm.onlyHdfcUserOneClick && localStorage.getItem('ecartItemsForHDFC'))) {
        var cartItemExist = vm.onlyHdfcUserOneClick ? JSON.parse(localStorage.getItem('ecartItemsForHDFC')) : JSON.parse(localStorage.getItem('ecartItems'));
      }
      if((!vm.onlyHdfcUserOneClick && cartItemExist && cartItemExist.cartItems && cartItemExist.cartItems.length> 0 && $cookies.get('broker_details')) || (vm.onlyHdfcUserOneClick && cartItemExist && cartItemExist.cartItems && cartItemExist.cartItems.length> 0 && $cookies.get('broker_details_HDFC'))) {
        var oldCookies = vm.onlyHdfcUserOneClick ? JSON.parse($cookies.get('broker_details_HDFC')) : JSON.parse($cookies.get('broker_details'));
        if (oldCookies.brokerType == vm.form.linkType) {
          if ((vm.form.linkType === 'MFD' && (oldCookies.brokerCode !== vm.form.arn)) || (vm.form.linkType === 'RIA') && (oldCookies.riaBrokerCode !== vm.form.ria)) {
            ModalService.confirmCancelModal({
              Text: "You already have your cart created. Do you wish to update your cart?"
            },function () {
              var payload = getPayload();
              var brokerPayload = getInvestThroughPayload();
              vm.form.itemToBeEdited = payload;
              vm.isFromOneClickScreen = true;
              vm.dataFromOneClickScreen = {
                itemToBeEdited: vm.form.itemToBeEdited,
                isFromOneClickScreen: vm.isFromOneClickScreen
              }
              vm.dataFromOneClickScreen.isBrokerTypeChange = true;
              vm.isFromHdfcOneClick = vm.onlyHdfcUserOneClick;
              if(vm.onlyHdfcUserOneClick){
                $cookies.put('broker_details_HDFC', angular.toJson(brokerPayload));
              } else {
                $cookies.put('broker_details', angular.toJson(brokerPayload));
              }
              $rootScope.$broadcast('showCartDetails', vm.dataFromOneClickScreen);
              vm.onlyHdfcUserOneClick ? localStorage.removeItem('ecartItemsForHDFC'): localStorage.removeItem('ecartItems');
              $rootScope.$broadcast("CartCount", 0);

            },function () {

            })
          } else {
            var payload = getPayload();
            var brokerPayload = getInvestThroughPayload();
            vm.form.itemToBeEdited = payload;
            vm.isFromOneClickScreen = true;
            vm.dataFromOneClickScreen = {
              itemToBeEdited: vm.form.itemToBeEdited,
              isFromOneClickScreen: vm.isFromOneClickScreen
            }

            vm.dataFromOneClickScreen.isBrokerTypeChange = false;
            vm.isFromHdfcOneClick = vm.onlyHdfcUserOneClick;
            if((!vm.onlyHdfcUserOneClick && $cookies.get('broker_details')) || (vm.onlyHdfcUserOneClick && $cookies.get('broker_details_HDFC'))) {
              var oldCookies = vm.onlyHdfcUserOneClick ? JSON.parse($cookies.get('broker_details_HDFC')): JSON.parse($cookies.get('broker_details'));
              if (oldCookies.brokerType !== vm.form.linkType) {
                vm.dataFromOneClickScreen.isBrokerTypeChange = true;
              }
            }

            if(vm.onlyHdfcUserOneClick){
              $cookies.put('broker_details_HDFC', angular.toJson(brokerPayload));
            } else {
              $cookies.put('broker_details', angular.toJson(brokerPayload));
            }
            $rootScope.$broadcast('showCartDetails', vm.dataFromOneClickScreen);
          }
        } else if (oldCookies.brokerType !== vm.form.linkType) {
          ModalService.confirmCancelModal({
            Text: "You already have your cart created. Do you wish to update your cart?"
          },function () {
            var payload = getPayload();
            var brokerPayload = getInvestThroughPayload();
            vm.form.itemToBeEdited = payload;
            vm.isFromOneClickScreen = true;
            vm.dataFromOneClickScreen = {
              itemToBeEdited: vm.form.itemToBeEdited,
              isFromOneClickScreen: vm.isFromOneClickScreen
            }
            vm.dataFromOneClickScreen.isBrokerTypeChange = true;
            vm.isFromHdfcOneClick = vm.onlyHdfcUserOneClick;
            if(vm.onlyHdfcUserOneClick){
              $cookies.put('broker_details_HDFC', angular.toJson(brokerPayload));
            } else {
              $cookies.put('broker_details', angular.toJson(brokerPayload));
            }
            $rootScope.$broadcast('showCartDetails', vm.dataFromOneClickScreen);
            vm.onlyHdfcUserOneClick? JSON.parse(localStorage.getItem('ecartItemsForHDFC')) : localStorage.removeItem('ecartItems');
            $rootScope.$broadcast("CartCount", 0);

          },function () {

          })
        }
      } else {
        var payload = getPayload();
        var brokerPayload = getInvestThroughPayload();
        vm.form.itemToBeEdited = payload;
        vm.isFromOneClickScreen = true;
        vm.dataFromOneClickScreen = {
          itemToBeEdited: vm.form.itemToBeEdited,
          isFromOneClickScreen: vm.isFromOneClickScreen
        }
        vm.isFromHdfcOneClick = vm.onlyHdfcUserOneClick;
        if((!vm.onlyHdfcUserOneClick && $cookies.get('broker_details')) || (vm.onlyHdfcUserOneClick && $cookies.get('broker_details_HDFC'))) {
          var oldCookies = vm.onlyHdfcUserOneClick? JSON.parse($cookies.get('broker_details_HDFC')) : JSON.parse($cookies.get('broker_details'));
          if (oldCookies.brokerType !== vm.form.linkType) {
            vm.dataFromOneClickScreen.isBrokerTypeChange = true;
          }
        }
        if(vm.onlyHdfcUserOneClick){
          $cookies.put('broker_details_HDFC', angular.toJson(brokerPayload));
        } else {
          $cookies.put('broker_details', angular.toJson(brokerPayload));
        }

        // showPopupScreen('CART_DETAILS');
        $rootScope.$broadcast('showCartDetails', vm.dataFromOneClickScreen);
      }
    }

    function getPayload() {
      if(vm.form.transactionType == 'SIP'){
        vm.sipOpted = true;
        vm.purchaseOpted = false;
      } else if(vm.form.transactionType == "PURCHASE"){
        vm.sipOpted = false;
        vm.purchaseOpted = true;
      }
      var payload = {
        "schemeCode": vm.form.InSchemeCode,
        "schemeName" : vm.form.InSchemeName,
        "amount": vm.form.amount,
        "dividendOption": vm.form.DividendOption ? vm.form.DividendOption : AppConstants.DIVIDEND_OPTIONS.GROWTH,
        "liquid": vm.form.schemeType === 'LIQUID' ? true: false,
        "folioNumber": vm.investorData && vm.investorData.folioNumber ? vm.investorData.folioNumber: null,
        "cgfApplicable": false,
        "minorFlag": vm.form.minorFlag ? vm.form.minorFlag: false,
        "newUser": false,
        "purchaseOpted": vm.purchaseOpted,
        "sipOpted": vm.sipOpted,
        "frequency": "OM",
        "sipDay": vm.form.day,
        "numberOfInstallment": $window.moment($window.moment(vm.form.endDate, "DD-MMM-YYYY")).diff($window.moment(vm.form.startDate, "DD-MMM-YYYY"),'months') + 1,
        "installmentAmount": vm.form.amount,
        "investmentOption": vm.form.DividendOption ? 'DIVIDEND': 'GROWTH',
        "fundName": vm.form.fundName ? vm.form.fundName: null,
        "fundCode": vm.form.fundCode ? vm.form.fundCode : null
      };
      if (vm.sipOpted) {
        payload.sipDate = $window.moment(vm.form.startDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
        payload.toDate = $window.moment(vm.form.endDate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
      }
      return payload;
    }

    function getInvestThroughPayload() {
      var payload = {
        "brokerType": vm.form.linkType ? vm.form.linkType: null,
        "brokerCode": vm.form.arn ? vm.form.arn: null,
        "subBrokerCode": vm.subBrokerCode ? vm.subBrokerCode: null,
        "subBrokerArn": vm.subBrokerARN ? "ARN-"+vm.subBrokerARN: null,
        "euinOpted": vm.form.euinSelected === false ? "N" : 'Y',
        "euinCode": vm.form.euin.euinNameCode ? vm.form.euin.euinNameCode: null,
        "brokerName": vm.distributorName ? vm.distributorName : null,
      };
      if(vm.form.linkType == 'RIA'){
        payload.riaBrokerCode = vm.form.ria;
        payload.riaBrokerName = vm.form.riaName
      }
      if(vm.onlyHdfcUserOneClick){
        payload.utmsource = vm.form.utmsource? vm.form.utmsource: '';
        payload.utmmedium = vm.form.utmmedium? vm.form.utmmedium: '';
      }
      return payload;
    }

    // $rootScope.$on('hideCartDetailsScreen', function(){
    //   vm.showSideBarCart = false;
    // })
    $rootScope.$on('hideCartDetails', function (){
      vm.showSideBarCart = false;
    })


    vm.validatePurchesSchedularCalender = function(){
      vm.calculateStartDate();
    }
    vm.calculateStartDate = function() {
      var success = function (resp) {
        if (resp.status && resp.data) {
          LoaderService.hideLoader();
          vm.nonBusinessDatess = resp.data.nonBuisnessDates;
          var enabledOTMStartDatesList = [];
          var currentDate = $window.moment().add(1, 'days');
          var startMaxDate = $window.moment().clone().add(30, 'days');
          var startDate = currentDate.clone();
          var freq = startMaxDate.diff($window.moment(), 'days');
          for (var i = 0; i <= freq; i++) {
            var indexDate = startDate.clone().add(i, 'days').format("DD-MMM-YYYY");
            var isEnable = true;
            // angular.isArray(vm.nonBusinessDatess) && vm.nonBusinessDatess.forEach(function (value) {
            //   if ($window.moment(value, "DD-MMM-YYYY").diff(indexDate, 'days') == 0) {
            //     isEnable = false;
            //   }
            // });
            if (isEnable) {
              enabledOTMStartDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
            }
          }
          vm.enabledMINStartDates = angular.copy(enabledOTMStartDatesList[0]);
          vm.startMaxDate = startMaxDate;
          vm.enabledOTMStartDatesList = enabledOTMStartDatesList;
          }else {
            LoaderService.hideLoader();
            MessageService.error(resp.message);
          }
        },error = function (err) {
          LoaderService.hideLoader();
          MessageService.error(err);
      };
      LoaderService.showLoader();
      TransactionArnService.get({
        controller1: 'nonBusinessDate',
        schemeCode: vm.form.InSchemeCode
      }).$promise.then(success, error);
    }
    vm.updatePurchaseSchedulerEndDate = function(){
      var enabledEndDatesList = [];
      var currentDate = $window.moment();
      vm.endMinDate = currentDate;
      var endDate = currentDate.clone().add(99, 'years');
      // var endDate = $window.moment((new Date()), "DD-MMM-YYYY").add(99, 'years');
      vm.endMaxDate = endDate;
      var frequencyDate = vm.form.startDate ? vm.form.startDate : $window.moment();
      var freq = 0;
      var i = 0;
      if (vm.form.frequency === 'WK') {
          freq = endDate.diff(frequencyDate, 'days');
          for (i = 7; i <= freq; i+=7) {
              var indexDate = frequencyDate.clone().add(i, 'days').format("DD-MMM-YYYY");
              if ($window.moment(indexDate, "DD-MMM-YYYY").diff(frequencyDate, 'days') >= 7) {
                  enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
              }
          }
      } else if (vm.form.frequency === 'OM') {
          freq = endDate.diff(currentDate, 'months');
          for (i = 1; i <= freq; i++) {
              var indexDate = frequencyDate.clone().add(i, 'months');
              var diff = $window.moment(indexDate.format("DD-MMM-YYYY")).diff(endDate.format("DD-MMM-YYYY"), "days");
              if (diff <= 0) {
                  enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
              }
          }
      } else if (vm.form.frequency === 'FN') {
          freq = endDate.diff(currentDate, 'days');
          for (i = 15; i <= freq; i+=15) {
              var indexDate = frequencyDate.clone().add(i, 'days');
              var diff = $window.moment(indexDate.format("DD-MMM-YYYY")).diff(endDate.format("DD-MMM-YYYY"), "days");
              if (diff <= 0) {
                  enabledEndDatesList.push($window.moment(indexDate, "DD-MMM-YYYY"));
              }
          }
      }
      vm.form.endDate = "";
      if(vm.form.frequency == 'OM'){
        vm.minEndDate = angular.copy(enabledEndDatesList[0]);
      }
      if(vm.form.frequency == 'FN'){
        vm.minEndDate = angular.copy(enabledEndDatesList[2]);
      }
      if(vm.form.frequency == 'WK'){
        vm.minEndDate = angular.copy(enabledEndDatesList[2]);
      }
      vm.enabledEndDateView = $window.moment(enabledEndDatesList[0], "DD-MMM-YYYY");
      vm.enabledEndDates = enabledEndDatesList;
      vm.enabledViewEndDate = vm.enabledEndDates.length > 0 ? angular.copy(vm.enabledEndDates[0]) : null;
      vm.form.isTillPerpetuity = true;
      vm.changeTillPerpetuityFlag();
    }
    vm.startDateValidate = function () {
      var invalidEndDate = true;
      if(vm.form.frequency != 'OW'){
        if(vm.form.startDate && $window.moment((new Date(vm.form.startDate)), "DD-MM-YYYY")){
          vm.enabledOTMStartDatesList.forEach(function (value) {
            if($window.moment(value).format("DD-MM-YYYY") == $window.moment(vm.form.startDate).format("DD-MM-YYYY")){
              invalidEndDate = false;
            }
          });
          if(invalidEndDate){
            vm.form.startDate = null;
            vm.form.endDate = null;
            vm.form.isTillPerpetuity = false;
          }
        }
      }else{
        if(vm.form.startDate && $window.moment((new Date(vm.form.startDate)), "DD-MM-YYYY")){
          vm.enabledStartDates.forEach(function (value) {
            if($window.moment(value).format("DD-MM-YYYY") == $window.moment(vm.form.startDate).format("DD-MM-YYYY")){
              invalidEndDate = false;
            }
          });
          if(invalidEndDate){
            vm.form.startDate = null;
            vm.form.endDate = null;
            vm.form.isTillPerpetuity = false;
          }
        }
      }

    }
    vm.endDateValidate = function () {
      var invalidEndDate = true;
      if(vm.form.endDate && $window.moment((new Date(vm.form.endDate)), "DD-MM-YYYY")){
        vm.enabledEndDates.forEach(function (value) {
          if($window.moment(value).format("DD-MM-YYYY") == $window.moment(vm.form.endDate).format("DD-MM-YYYY")){
            invalidEndDate = false;
          }
        });
        if(invalidEndDate){
          vm.form.endDate = null;
          vm.form.isTillPerpetuity = false;
        }
      }
    }
    vm.setDec2099Date = function (){
      var ar = [];
      vm.enabledEndDates.forEach(function(el){
        var one = el.format("DD-MM-YYYY");
        var two = one.split("-");
        if(two[1] == 12 && two[2] == '2099'){
          ar.push(two[0]);
        }
      });
      if(vm.form.startDate){
        vm.form.endDate = moment("12/"+ar[ar.length - 1]+"/2099");
        vm.form.isTillPerpetuity = true;
      }else{
        vm.form.endDate = null;
        vm.form.isTillPerpetuity = false;
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .controller('AdminController', adminController);

  function adminController(AuthService, $state) {
    var vm = this;
    vm.init = init();
    function init() {
       $state.go('agent.login');
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .run(runBlock)
    .run(function ($state, $rootScope) {
      $rootScope.$state = $state;
    })
    //  .run(runTawkChatScript);
    /*.run(paynimoLoadScript);*/

  /** @ngInject */
  function runBlock($state, $window, $rootScope, $uibModalStack, $document, $timeout, AuthService, LoaderService, AppConstants ,MetaTagService,$transitions,HDFC_API, UtilService) {
    var allowNav = false;
    var checkNav = false;
    var restrictedState = ['faq',
  'agent','agent.login','agent.changePassword','agent.home','agent.home.distributor-list','agent.home.superadmin','agent.home.createUser','agent.home.distributor-home','agent.home.transactions','agent.home.transactions.initiate','agent.home.transactions.initiate.switch','agent.home.transactions.initiate.redeem','agent.home.transactions.initiate.stp','agent.home.transactions.initiate.flexstp','agent.home.transactions.initiate.swingstp', 'agent.home.transactions.initiate.swp','agent.home.transactions.initiate.sip','agent.home.transactions.initiate.dtp','agent.home.transactions.initiate.flexindex','agent.home.transactions.initiate.rollover','agent.home.rolloverView','agent.home.investors','agent.home.investors.add','agent.home.investors.add.holdmode','agent.home.investors.add.appdetails','agent.home.investors.add.jointholders','agent.home.investors.add.guardianDetails',
  'agent.home.investors.add.nominee','agent.home.investors.add.scheme','agent.home.investors.add.bankdetails','agent.home.investors.review','agent.home.investors.statements','agent.home.investors.basicinfo','agent.home.transactionApproval','initiatesummary','emandate','ekyc','arnHardcoded','arnHardcodedR','arnHardcodedRM'];
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, from) {
      $uibModalStack.dismissAll();
      LoaderService.hideLoader();

      if (!$state.current.name && toState.defaultRoute) {
        event.preventDefault();
        $state.go(toState.name + toState.defaultRoute);
        return;
      }
      AuthService.isLoggedIn().then(function (loggedIn) {
        if (toState.authenticate && !loggedIn  && !sessionStorage.isLoggedIn) {
          event.preventDefault();
          AuthService.logout().then(function () {
            // $cookies.remove('token_data');
            AuthService.clearCookie();
            if(toState.loginType=='A'){
              $state.go('agent.login')
            } else {
              $state.go('login');
            }
          }, function () {
            // $cookies.remove('token_data');
            AuthService.clearCookie();
            if(toState.loginType=='A'){
              $state.go('agent.login')
            } else {
              $state.go('login');
            }
          });
        }
        if (loggedIn) {

          var identifier = AuthService.getToken();
          if(toState.loginType && (toState.loginType !== identifier.loginType)){
            event.preventDefault();
            $rootScope.$emit('404');
            $timeout(function () {
            $state.go('404');
            })
          }

          AuthService.getCurrentUser().then(function (user) {
            if (toState.roles && !(toState.roles.indexOf(user.role) > -1)) {
              $rootScope.$emit('404')
            }
          }, function () {
            $rootScope.$emit('404');
          })
        }
      });
      _restrictRoutes(toState, from, AuthService, $state, $timeout);
    });

    var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      allowNav = checkNav;
      checkNav = true;
      $rootScope.$previousState = fromState;
      $rootScope.$emit('UpdateSideBar');
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
    });

    var stateChangeError = $rootScope.$on('$stateChangeError', function (evt, to, toParams, from, fromParams, error) {
      if (error && error.redirectTo) {
        $state.go(error.redirectTo);
      }
    })

    var locationChangeStart = $rootScope.$on('$locationChangeStart', function (event) {
      // Prevent the browser default action (Going back)
      if (checkNav) {
        if (!allowNav) {
          event.preventDefault();
        } else {
          allowNav = false;
        }
      }
      if($state.current.name == "login") {
        var top = $uibModalStack.getTop();
        if (top) {
          $uibModalStack.dismiss(top.key);
          event.preventDefault();
        }
      }
    });

    $window.NumToWord = function (inputNumber, outputControl,model) {


      var afterDecimal = '', str = '';
      var num = inputNumber.toString().replace(/[\, ]/g, '');
      var x = num.indexOf('.');
      if (x !== -1) {
        str = num.split('.')[0];
        str = num.length > 0 ? str : '';
        afterDecimal = num.split('.')[1];
      } else {
        str = num;
      }

      if (str.length < 14) {
        var aboveCrore = "", aboveCroreWord = "";
        var belowCrore = "", belowCroreWord = "", finalResult = '';
        if (str.length > 7) {
          aboveCrore = str.substring(0, str.length - 7);
          belowCrore = str.substring(aboveCrore.length);
          aboveCroreWord = inWordUpToLack(aboveCrore) ? inWordUpToLack(aboveCrore) + ' Crore ' : '';
          belowCroreWord = inWordUpToLack(belowCrore);
        } else {
          belowCroreWord = inWordUpToLack(str);
        }

        if (aboveCroreWord || belowCroreWord) {
          finalResult = aboveCroreWord + belowCroreWord;
          if (finalResult != " One") {
            finalResult = finalResult + ' Rupees ';
          } else {
            finalResult = finalResult + ' Rupee ';
          }
        } else {
          finalResult = '';
        }
        finalResult += afterDecimalWord(afterDecimal);
        finalResult = finalResult ? finalResult + ' Only' : '';
      } else {
        finalResult = 'Too long';
      }
      if (document.getElementById(outputControl)) {
        document.getElementById(outputControl).innerHTML = finalResult;
      } else if (model) {
        model.amountInWords = finalResult;
      }
    };

    function afterDecimalWord(afterDecimal) {
      var afterDecimalWord = '';
      if (afterDecimal.length > 0 && afterDecimal.length <= 2) {
        afterDecimalWord = ' and ' + inWordUpToLack(afterDecimal) + ' Paise ';
      } else if (afterDecimal.length > 0 && afterDecimal.length > 2) {
        afterDecimalWord = ' and ' + inWordUpToLack(afterDecimal.substring(0, 2)) + ' Paise ';
      }
      return afterDecimalWord;
    }

    function inWordUpToLack(inputNumber) {

      var str = new String(inputNumber)
      var splt = str.split("");
      var rev = splt.reverse();
      var once = ['Zero', ' One', ' Two', ' Three', ' Four', ' Five', ' Six', ' Seven', ' Eight', ' Nine'];
      var twos = ['Ten', ' Eleven', ' Twelve', ' Thirteen', ' Fourteen', ' Fifteen', ' Sixteen', ' Seventeen', ' Eighteen', ' Nineteen'];
      var tens = ['', 'Ten', ' Twenty', ' Thirty', ' Forty', ' Fifty', ' Sixty', ' Seventy', ' Eighty', ' Ninety'];

      var numLength = rev.length;
      var word = new Array();
      var j = 0;

      for (var i = 0; i < numLength; i++) {
        switch (i) {

          case 0:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = '' + once[rev[i]];
            }
            word[j] = word[j];
            break;

          case 1:
            aboveTens();
            break;

          case 2:
            if (rev[i] == 0) {
              word[j] = '';
            }
            else if ((rev[i - 1] == 0) || (rev[i - 2] == 0)) {
              word[j] = once[rev[i]] + " Hundred ";
            }
            else {
              word[j] = once[rev[i]] + " Hundred ";
            }
            break;

          case 3:
            if (rev[i] == 0 || rev[i + 1] == 1) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if ((rev[i + 1] != 0) || (rev[i] > 0)) {
              word[j] = word[j] + " Thousand";
            }
            break;


          case 4:
            aboveTens();
            break;

          case 5:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if (rev[i + 1] !== '0' || rev[i] > '0') {
              word[j] = word[j] + " Lakh";
            }

            break;

          case 6:
            aboveTens();
            break;

          case 7:
            if ((rev[i] == 0) || (rev[i + 1] == 1)) {
              word[j] = '';
            }
            else {
              word[j] = once[rev[i]];
            }
            if (rev[i + 1] !== '0' || rev[i] > '0') {
              word[j] = word[j] + " Crore";
            }
            break;

          case 8:
            aboveTens();
            break;

          //            This is optional.

          //            case 9:
          //                if ((rev[i] == 0) || (rev[i + 1] == 1)) {
          //                    word[j] = '';
          //                }
          //                else {
          //                    word[j] = once[rev[i]];
          //                }
          //                if (rev[i + 1] !== '0' || rev[i] > '0') {
          //                    word[j] = word[j] + " Arab";
          //                }
          //                break;

          //            case 10:
          //                aboveTens();
          //                break;

          default:
            break;
        }
        j++;
      }

      function aboveTens() {
        if (rev[i] == 0) {
          word[j] = '';
        }
        else if (rev[i] == 1) {
          word[j] = twos[rev[i - 1]];
        }
        else {
          word[j] = tens[rev[i]];
        }
      }

      word.reverse();
      var finalOutput = '';
      for ( i = 0; i < numLength; i++) {
        finalOutput = finalOutput + word[i];
      }

      return finalOutput;
    }

    $rootScope.$on("$destroy", function () {
      stateChangeStart();
      stateChangeSuccess();
      stateChangeError();
      locationChangeStart();
    });


    /*Transitions service injected to identify the current state*/
    $transitions.onSuccess({}, function(transition) {
      var uiViewElement = angular.element(document.querySelector('body > .height100'));
      var toState = transition.to().name;
      if (toState !== "login") {
        MetaTagService.clearTags();
      }
    if (HDFC_API.ENV != 'dev' && HDFC_API.ENV != 'qa' && HDFC_API.ENV != 'development') {
      if (!restrictedState.includes(toState)) {
        uiViewElement.removeAttr('id');
        if($('#allincall-script').length == 0) {
          MetaTagService.addScriptTag();
        }
      } else {
        uiViewElement.attr('id',"easyassist_block_page");
        MetaTagService.removeScriptTag();
      }
    }
    $window.scrollTo(0,0);

    });

    smartech('create', 'ADGMOT35CHFLVDHBJNIG50K96BHPP5I34ISULH5H9GBV9GQN62M0','tin');
    smartech('register', UtilService.genericConverter(HDFC_API.NSI));
    smartech('identify', '');
  }

  /* @ngInject*/
  // function runTawkChatScript($ocLazyLoad, $state, $timeout, HDFC_API) {
  //   if (HDFC_API.ENV == 'prod' || HDFC_API.ENV == 'beta') {
  //     $timeout(function () {
  //       if ($state && $state.current && $state.current.controllerAs !== 'InitiateSummary' && $state.current.loginType != 'A') {
  //         var Tawk_API = Tawk_API || {};
  //         (function () {
  //           var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
  //           s1.async = true;
  //           s1.src = 'https://embed.tawk.to/58736a7f12631a1069102431/default';
  //           s1.charset = 'UTF-8';
  //           s1.setAttribute('crossorigin', '*');
  //           s0.parentNode.insertBefore(s1, s0);
  //         })();
  //       }
  //     },1000);
  //   } else if(HDFC_API.ENV == 'maintenance') {
  //     $ocLazyLoad.load('https://cx.camsonline.com/unfyd-webchat-hdfc/smarttalk.js');
  //   }
  // }

  /* @ngInject*/
/*  function paynimoLoadScript($ocLazyLoad, HDFC_API) {
    if (HDFC_API.ENV == 'prod' || HDFC_API.ENV == 'beta') {
      /!*$ocLazyLoad.load('https://www.paynimo.com/Paynimocheckout/client/lib/jquery.min.js');
      $ocLazyLoad.load('https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js');*!/
      var a = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){" +
        "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o)," +
        "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})" +
        "(window,document,'script','https://www.google-analytics.com/analytics.js','ga');" +
        "ga('create', 'UA-93011684-1', 'auto');ga('send', 'pageview');";
      eval(a);
    } else {
      /!*$ocLazyLoad.load('https://www.tecprocesssolution.com/proto/P2M/client/lib/jquery.min.js');
      $ocLazyLoad.load('https://www.tecprocesssolution.com/proto/P2M/server/lib/checkout.js');*!/
    }
  }*/


  function _restrictRoutes (toState, fromState, AuthService, $state, $timeout) {
    var identifierData = AuthService.getToken(),
      restrictDistributorUrlArr = ['distributor-list', 'transaction-approval'],
      restrictSuperAdminUrl = ['superadmin', 'create-user'],
      isDistributorUrlsArr = ['transactions', 'distributor-home', 'statement', 'investors'],
      isDistributor = ((identifierData && identifierData.isDistributor) ? true : false),
      isUrlExist = false,
      defaultState = undefined;

    // if its a super admin
    if (identifierData && identifierData.role === 'Super Admin') {
      isUrlExist = checkUrlExist(restrictSuperAdminUrl, toState.templateUrl);
      defaultState = 'agent.superadmin';
    }

    // if its is not a distributor
    if (identifierData && identifierData.role === 'Agent' && !isDistributor && !identifierData.firstTimeLogin) {
      isUrlExist = checkUrlExist(restrictDistributorUrlArr, toState.templateUrl);
      defaultState = 'agent.home.distributor-list';
    }

    if (identifierData && identifierData.role === 'Agent' && isDistributor &&  !identifierData.firstTimeLogin) {
      isUrlExist = checkUrlExist(isDistributorUrlsArr, toState.templateUrl);
      defaultState = 'agent.home.distributor-home';
    }

    if (identifierData && identifierData.firstTimeLogin) {
      isUrlExist = false;
      defaultState = "agent.changePassword";
    }

    if ((isUrlExist === false) && (defaultState && defaultState !== toState.name) && Boolean(sessionStorage.isLoggedIn) && (toState.loginType === 'A')) {
      $timeout(function () {
        $state.go(defaultState);
      })
    }

  }

  function checkUrlExist(restrictUrlArr, path) {
    var i = 0, length = restrictUrlArr.length - 1, isExist = false;
    for (; i <= length; i++) {
      if (path.search(restrictUrlArr[i]) !== -1) {
        isExist = true;
        break;
      }
    }
    return isExist;
  }

})();

(function () {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .factory('AuthInterceptor', authInterceptor)
    .config(routerConfig);

  /** @ngInject */
  function authInterceptor($rootScope, AppConstants, $cookies, $q, $window) {
    var CryptoJS = $window.CryptoJS;
    function isTemplateCall(config) {
      if (!config || !config.url) {
        return;
      }
      return config.url.lastIndexOf('.html') !== -1;
    }

    return {
      request: function (config) {
        if (!isTemplateCall(config)) {
          // Adding Authorization token in every API request.0
          if (config && config.url && config.url.indexOf('oauth/token') > -1) {
            if (config.data.grant_type === "password") {
              $cookies.remove(AppConstants.IDENTIFIER);
              // AuthService.removeTokenCookies();
            }
            return config;
          }

          var ciphertext = $cookies.get(AppConstants.IDENTIFIER);
          /*Decrypt*/
          if (ciphertext) {
            var bytes = CryptoJS.AES.decrypt(ciphertext.toString(), AppConstants.IDENTIFIER);
            var identifier = $window.JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          }
          /*var token = $cookies.get('token_data');
          //var loginType = token.loginType? token.loginType : 'D';
          try {
            token = angular.fromJson(token);
          } catch (e) {
            $log.info('Json parse exception', e);
            token = '';
          }*/
          //var token = AuthService.getToken();
          if (identifier && identifier.access_token) {
            if(config.url && config.url.includes("res.cloudinary.com")){
              delete config.headers['Authorization'];
            }else{
              config.headers['Authorization'] = 'Bearer ' + identifier.access_token;
            };
          }
        }
        return config;
      },

      response: function (response) {
        return response;
      },

      responseError: function (response) {
        if (!isTemplateCall(response.config)) {
          if (response.status === 401) {
            $rootScope.$emit('UpdateRefreshToken');
          }
        }
        return $q.reject(response);
      }
    };
  }

  /** @ngInject */
  function routerConfig($httpProvider, $locationProvider, $sceDelegateProvider, $stateProvider, $urlRouterProvider) {

    $httpProvider.interceptors.push('AuthInterceptor');
    $httpProvider.interceptors.push('ApiInterceptor');
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain.  Notice the difference between * and **.
      'http://hdfc-dev-distributor.tothenew.com/**'
    ]);
    $urlRouterProvider.otherwise('/');
    $stateProvider
      .state('login', {
        url: '/?a&isMactive',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'Login',
        resolve: {
          isLoggedIn: _isLoggedIn
        }
      })
      .state('404', {
        url: '/404',
        templateUrl: '404.html'
      })

      .state('browserUpdate', {
        url: '/Update-browser',
        templateUrl: 'app/browser-update/browser-update.html',
        controller: 'BrowserUpdateController',
        controllerAs: 'BrowserUpdate'
      })

      .state('home', {
        url: '/home',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'Home',
        authenticate: true,
        loginType: 'D',
        resolve: {
          investorProfile: _myProfile
        }
      })
      .state('main', {
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'Main',
        authenticate: true,
        loginType: 'D',
        defaultRoute: '.dashboard'
      })
      .state('main.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'Dashboard',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.dashboardEdit', {
        url: '/dashboard/edit',
        templateUrl: 'app/dashboard/edit.dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'Dashboard',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.todos', {
        url: '/dashboard/todos',
        templateUrl: 'app/dashboard/todos.html',
        controller: 'TodosController',
        controllerAs: 'Todos',
        authenticate: true,
        loginType: 'D'
      })
      .state('admin', {
        url: '/admin',
        templateUrl: 'app/admin/admin.html',
        controller: 'AdminController',
        controllerAs: 'Admin',
        authenticate: false,
        loginType: 'D'
      })
      .state('main.transactions', {
        url: '/transactions',
        templateUrl: 'app/transactions/transactions.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        defaultRoute: '.list',
        loginType: 'D'
      })
      // .state('main.transactions.list', {
      //   url: '/list',
      //   templateUrl: 'app/transactions/list/transactions-list.html',
      //   controller: 'TransactionController',
      //   controllerAs: 'Transaction',
      //   authenticate: true,
      //   defaultRoute: '.all',
      //   loginType: 'D'
      // })
      .state('main.transactions.recent', {
        url: '/recent',
        templateUrl: 'app/transactions/list/recent/transaction-recent.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.all', {
        url: '/all?status',
        templateUrl: 'app/transactions/list/all/transaction-all.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        loginType: 'D',
        params: {
          status: null,
          fromDate: null,
          toDate: null
        }
      })
      .state('main.transactions.list.inflow', {
        url: '/inflow',
        templateUrl: 'app/transactions/list/inflow/transaction-inflow.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.list.outflow', {
        url: '/outflow',
        templateUrl: 'app/transactions/list/outflow/transaction-outflow.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate', {
        url: '/initiate',
        templateUrl: 'app/transactions/initiate/initiate-transaction.html',
        controller: 'InitiateTransactionController',
        controllerAs: 'InitiateTransaction',
        authenticate: true,
        defaultRoute: '.sip',
        loginType: 'D'
      })
      .state('main.transactions.initiate.smartswap', {
        url: '/:uuid/smartswap?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/smart-swap/smart-swap.html',
        controller: 'SmartSwapController',
        controllerAs: 'SmartSwap',
        authenticate: true,
        defaultRoute: '.folio',
        loginType: 'D'
      })
      .state('main.transactions.initiate.dreamsip', {
        url: '/:uuid/dream-sip',
        templateUrl: 'app/transactions/initiate/dream-sip/dream-sip.html',
        controller: 'DreamSipController',
        controllerAs: 'DreamSip',
        authenticate: true,
        defaultRoute: '.folio',
        loginType: 'D'
      }).state('main.transactions.initiate.sip', {
        url: '/:uuid/sip?schemeCode&folioNumber&transactionType&transactionId&status&txnId&frequency&amount?fromModify?fromRenew?fromDash?fromQuickSip',
        templateUrl: 'app/transactions/initiate/sip/sip_purchase.html',
        controller: 'InitiateTransactionSipPurchaseController',
        controllerAs: 'InitiateTransactionSipPurchase',
        authenticate: true,
        defaultRoute: '.folio',
        loginType: 'D',
        resolve : {
          dynamicDataPurchase : _fetchDynamicDataPurchase,
          dynamicDataSip : _fetchDynamicDataSip
        }
      })
      .state('main.transactions.initiate.sip.folio', {
        url: '/folio',
        templateUrl: 'app/transactions/initiate/sip/folio/create-folio.html',
        controller: 'InitiateTransactionSipController',
        controllerAs: 'InitiateTransactionSip',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.sip.scheme', {
        url: '/addscheme',
        templateUrl: 'app/transactions/initiate/sip/addscheme/add-scheme.html',
        controller: 'InitiateTransactionSipController',
        controllerAs: 'InitiateTransactionSip',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.sip.payment', {
        url: '/payment',
        templateUrl: 'app/transactions/initiate/sip/paymentmethod/payment-method.html',
        controller: 'InitiateTransactionSipController',
        controllerAs: 'InitiateTransactionSip',
        authenticate: true
      })
      .state('main.transactions.initiate.switch', {
        url: '/:uuid/switch?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/switch/switch.html',
        controller: 'InitiateTransactionSwitchController',
        controllerAs: 'InitiateTransactionSwitch',
        authenticate: true,
        loginType: 'D',
        resolve: {
          DynamicData : _fetchDynamicDataSwitch
        }
      })
      .state('main.transactions.initiate.swp', {
        url: '/:uuid/swp?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/swp/swp.html',
        controller: 'InitiateTransactionSwpController',
        controllerAs: 'InitiateTransactionSwp',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.stp', {
        url: '/:uuid/stp?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/stp/stp.html',
        controller: 'InitiateTransactionStpController',
        controllerAs: 'InitiateTransactionStp',
        authenticate: true,
        loginType: 'D',
        resolve: {
          DynamicData : _fetchDynamicDataStp
        }
      })
      .state('main.transactions.initiate.redeem', {
        url: '/:uuid/redeem?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/redeem/redeem.html',
        controller: 'InitiateTransactionRedeemController',
        controllerAs: 'InitiateTransactionRedeem',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.rollover', {
        url: '/:uuid/rollover?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/roll-over/rollover.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.dtp', {
        url: '/:uuid/tip?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/dtp/dtp.html',
        controller: 'DtpController',
        controllerAs: 'InitiateTransactionDtp',
        authenticate: true,
        loginType: 'D',
        resolve: {
          DynamicData : _fetchDynamicDataDtp
        }

      })
      .state('main.transactions.initiate.flexstp', {
        url: '/:uuid/flexstp?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/flexstp/flexstp.html',
        controller: 'InitiateTransactionFlexStpController',
        controllerAs: 'InitiateTransactionFlexStp',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.transactions.initiate.swingstp', {
        url: '/:uuid/swingstp?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/swingstp/swingstp.html',
        controller: 'InitiateTransactionSwingStpController',
        controllerAs: 'InitiateTransactionSwingStp',
        authenticate: true
      })
      .state('main.transactions.initiate.flexindex', {
        url: '/:uuid/flexindex?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/flexindex/flexindex.html',
        controller: 'InitiateTransactionFlexIndexController',
        controllerAs: 'FlexIndex',
        authenticate: true,
        loginType: 'D'
      })

      .state('main.transactions.initiate.siptopup', {
        url: '/siptopup',
        templateUrl: 'app/transactions/initiate/sip-topup/sip-topup.html',
        controller: 'InitiateTransactionSipTopupController',
        controllerAs: 'SipTopup',
        authenticate: false,
        loginType: 'D',
        params: {
          transactionData: null
        }
      })

      .state('main.transactions.initiate.flexsip', {
        url: '/:uuid/flexsip?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/flexsip/flexsip.html',
        controller: 'InitiateTransactionFlexSipController',
        controllerAs: 'InitiateTransactionFlexSip',
        authenticate: true,
        loginType: 'D',
        resolve : {
          dynamicDataSip : _fetchDynamicDataFlexSip
        }
      })

      .state('resetpassword', {
        url: '/resetpassword?arnCode&secretKey',
        templateUrl: 'app/components/modal/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'ResetPassword',
        authenticate: false,
        loginType: 'D'
      })
      .state('main.investors', {
        url: '/investors',
        templateUrl: 'app/investors/investors.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'D',
        defaultRoute: '.list'
      })
      .state('main.investors.list', {
        url: '/list',
        templateUrl: 'app/investors/list/investors-list.html',
        controller: 'InvestorsListController',
        controllerAs: 'InvestorsList',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.list.individual', {
        url: '/individuals',
        templateUrl: 'app/investors/list/types/individuals/individuals-investors-list.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.list.non-individual', {
        url: '/non-individuals',
        templateUrl: 'app/investors/list/types/non-individuals/non-individuals-investors-list.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.list.pending', {
        url: '/pending',
        templateUrl: 'app/investors/list/types/pending/pending-investors-list.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.analysisType', {
        url: '/analysis/:analysisType',
        templateUrl: 'app/investors/list/analysis/analysis-investors-list.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'D'
      })
      // .state('main.investors.list.all', {
      //   url: '/all',
      //   templateUrl: 'app/investors/list/all/investors-list-all.html',
      //   controller: 'InvestorsController',
      //   controllerAs: 'Investors',
      //   authenticate: true
      // })
      // .state('main.investors.list.sip', {
      //   url: '/sip',
      //   templateUrl: 'app/investors/list/sip/investors-list-sip.html',
      //   controller: 'InvestorsController',
      //   controllerAs: 'Investors',
      //   authenticate: true
      // })
      // .state('main.investors.list.lumpsum', {
      //   url: '/lumpsum',
      //   templateUrl: 'app/investors/list/lumpsum/investors-list-lumpsum.html',
      //   controller: 'InvestorsController',
      //   controllerAs: 'Investors',
      //   authenticate: true
      // })
      .state('main.investors.profile', {
        url: '/profile/:investorId',
        templateUrl: 'app/investors/profile/investor-profile.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'D',
        defaultRoute: '.portfolio',
        resolve: {
          investorProfile: _investorProfile
        }
      })
      .state('main.investors.profile.basicinfo', {
        url: '/info',
        templateUrl: 'app/investors/profile/basicinfo/basic-info.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.updateIFSC', {
        url: '/profile/updateIFSC/:folioNumber',
        templateUrl: 'app/investors/profile/modifyBank/updateIFSC/updateIFSC.html',
        controller: 'UpdateIFSCController',
        controllerAs: 'UpdateIFSC',
        authenticate: true
      })
      .state('main.investors.changeBank', {
        url: '/profile/:investorId/changeBank',
        templateUrl: 'app/investors/profile/modifyBank/changeBank/changeBank.html',
        controller: 'ChangeBankController',
        controllerAs: 'ChangeBank',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.addNewBank', {
        url: '/profile/:investorId/addNewBank',
        templateUrl: 'app/investors/profile/modifyBank/addBank/addBank.html',
        controller: 'AddBankController',
        controllerAs: 'AddBank',
        authenticate: true,
        resolve : { dynamicData: _fetchDynamicDataAddBank }
      })
      .state('main.investors.cobmStatus', {
        url: '/profile/:investorId/cobmStatus',
        templateUrl: 'app/investors/profile/modifyBank/cobmStatus/cobmStatus.html',
        controller: 'CobmStatusController',
        controllerAs: 'CobmStatus',
        authenticate: true
      })
      .state('main.investors.changeMultipleBank', {
        url: '/profile/:investorId/changeMultipleBank',
        templateUrl: 'app/investors/profile/modifyBank/changeMultipleBank/changeMultipleBank.html',
        controller: 'AddBankController',
        controllerAs: 'AddBank',
        authenticate: true
      })
      .state('main.investors.profile.portfolio', {
        url: '/portfolio',
        templateUrl: 'app/investors/profile/portfolio/portfolio.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.profile.transactions', {
        url: '/transactions',
        templateUrl: 'app/investors/profile/transactions/transactions.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.profile.financialgoals', {
        url: '/financialgoals',
        templateUrl: 'app/investors/profile/financialgoals/financial-goals.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.investors.statements', {
        url: '/statements/:investorId',
        templateUrl: 'app/investors/profile/statement/statement.html',
        controller: 'StatementsController',
        controllerAs: 'Statements',
        authenticate: true,
        loginType: 'D',
        resolve: {
          investorProfile: _investorProfile
        }
      })
      .state('holder', {
        url: '/initiate/summary/holder-approval/:uuid?version',
        templateUrl: 'app/investors/summary/folioApproval/holderApproval/holder-smartlink.html',
        controller: 'HolderApprovalController',
        controllerAs: 'HolderApproval',
        authenticate: false,
        loginType: 'D',
        resolve : {
          dynamicData : _fetchDynamicDataSip
        }
      })
      .state('soleApplicant', {
        url: '/initiate/summary/soleApplicant-approval/:uuid?version?contact',
        templateUrl: 'app/investors/summary/folioApproval/soleApplicant-summary.html',
        controller: 'SoleApplicantSummary',
        controllerAs: 'FolioApprovalParent',
        authenticate: false,
        loginType: 'D',
        resolve : {
          dynamicData : _fetchDynamicDataSip
        }
      })
      .state('soleApplicant.folio', {
        url: '/soleApplicant',
        templateUrl: 'app/investors/summary/folioApproval/soleApplicant.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApproval',
        authenticate: false
      })
      .state('soleApplicant.jointHolders', {
        url: '/jointHolders',
        templateUrl: 'app/investors/summary/folioApproval/jointHolders.html',
        controller: 'FolioApprovalController',
        controllerAs: 'FolioApproval',
        authenticate: false
      })
      .state('soleApplicant.nominee', {
        url: '/nominee',
        templateUrl: 'app/investors/summary/folioApproval/nominee.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Nominee',
        authenticate: false
      })
      .state('soleApplicant.bankDetails', {
        url: '/bankDetails',
        templateUrl: 'app/investors/summary/folioApproval/bankDetails.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Payment',
        authenticate: false
      })
      .state('soleApplicant.approved', {
        url: '/approved/camsMessage?&camsMessage',
        templateUrl: 'app/investors/summary/folioApproval/approved.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Approved',
        authenticate: false
      })
      .state('soleApplicant.rejected', {
        url: '/rejected',
        templateUrl: 'app/investors/summary/folioApproval/rejected.html',
        controller: 'FolioApprovalController',
        controllerAs: 'Rejected',
        authenticate: false
      })
      .state('initiatesummary', {
        url: '/initiate/summary/:summaryType/:uniqueLink?version&UAP&sebi_reg',
        templateUrl: 'app/transactions/initiate/summary/summary.html',
        controller: 'InitiateSummaryController',
        controllerAs: 'InitiateSummary',
        authenticate: false,
        loginType: 'D',
        resolve : {
          dynamicData : _fetchDynamicDataSip
        }
      })
      .state('manual', {
        url: '/manual?q',
        templateUrl: 'app/transactions/initiate/summary/transactionFail/fail-transaction.html',
        controller: 'TransactionFailController',
        controllerAs: 'TransactionFail',
        authenticate: false
      })
      .state('payment-billdesk', {
        url: '/payment/billdesk/summary?msg',
        templateUrl: 'app/transactions/initiate/summary/payment/payment.billdesk.html',
        controller: 'PaymentBillDeskController',
        controllerAs: 'PaymentBillDesk',
        authenticate: false
      })
      /*.state('payment-paynimo', {
        url: '/payment/paynimo/summary?txthdnMsg&txthdntpslmrctcd',
        templateUrl: 'app/transactions/initiate/summary/payment/payment.paynimo.html',
        controller: 'PaymentPaynimoController',
        controllerAs: 'PaymentPaynimo',
        authenticate: false
      })*/
      .state('payment-billjunction', {
        url: '/payment/billjunction/summary?msg',
        templateUrl: 'app/transactions/initiate/summary/payment/payment.billjunction.html',
        controller: 'PaymentBillJunctionController',
        controllerAs: 'PaymentBillJunction',
        authenticate: false
      })
      .state('main.reports', {
        url: '/reports',
        templateUrl: 'app/reports/reports.html',
        controller: 'ReportsController',
        controllerAs: 'Reports',
        authenticate: true,
        loginType: 'D'
      })
      /*.state('main.financialtool', { // disable in HDFCKAN-772
        url: '/financial-tool',
        templateUrl: 'app/financialPlanningTool/financial-planning-tool.html',
        controller: 'FinancialPlanningToolController',
        controllerAs: 'FinancialPlanningTool',
        // defaultRoute: '.initiate',
        authenticate: true,
        loginType: 'D'
      })*/
      .state('main.schemecalculator', {
        url: '/scheme-calculator',
        templateUrl: 'app/schemeCalculator/schemeCalculator.html',
        controller: 'SchemeCalculatorController',
        controllerAs: 'SchemeCalculator',
        authenticate: true,
        loginType: 'D'
      })


      .state('main.resourcesCalculators', {
        url: '/resourcesCalculators',
        templateUrl: 'app/resourcesNcalculators/resourcesNcalculators.html',
        controller: 'ResourcesCalculatorsController',
        controllerAs: 'ResourcesCalculators',
        authenticate: true,
        defaultRoute: '.calculators',
        loginType: 'D'
      })

      .state('main.resourcesCalculators.resources', {
        url: '/resources',
        templateUrl: 'app/resourcesNcalculators/resources/resources.html',
        controller: 'ResourcesCalculatorsController',
        controllerAs: 'ResourcesCalculators',
        authenticate: true,
        loginType: 'D'
      })


      .state('main.resourcesCalculators.calculators', {
        url: '/calculators',
        templateUrl: 'app/resourcesNcalculators/calculators/calculators.html',
        controller: 'ResourcesCalculatorsController',
        controllerAs: 'ResourcesCalculators',
        authenticate: true,
        loginType: 'D'
      })

      // .state('main.financialtool.initiate', {
      //   url: '/initiate',
      //   templateUrl: 'app/financialPlanningTool/financial-planning-initiate.html',
      //   controller: 'FinancialPlanningToolController',
      //   controllerAs: 'FinancialPlanningTool',
      //   authenticate: false
      // })
      // .state('main.financialtool.list', {
      //   url: '/list',
      //   templateUrl: 'app/financialPlanningTool/financial-planning-list.html',
      //   controller: 'FinancialPlanningToolController',
      //   controllerAs: 'FinancialPlanningTool',
      //   authenticate: false
      // })
      .state('main.sipcorner', {
        url: '/sipcorner?status&transactionType&next',
        templateUrl: 'app/sip-corner/sip-corner.html',
        controller: 'SipCornerController',
        controllerAs: 'SipCorner',
        authenticate: true,
        loginType: 'D',
        resolve : {
           cancel_nudge_data : _fetchDynamicDataSystematic
        }
      })

      .state('main.sipPause', {
        url: '/sip-pause',
        templateUrl: 'app/sipPause/sipPause.html',
        controller: 'SipPause',
        controllerAs: 'SipPause',
        authenticate: true
      })

      .state('main.sipCancel', {
        url: '/sip-cancel',
        templateUrl: 'app/transactions/initiate/sip-cancel/sip-cancel.html',
        controller: 'SipCancel',
        controllerAs: 'SipCancel',
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataCancel
        }
      })

      .state('main.fmp', {
        url: '/funds-maturing',
        templateUrl: 'app/purchase-corner/funds-maturing/funds-maturing.html',
        controller: 'FundsMaturingController',
        controllerAs: 'FundsMaturing',
        authenticate: true
      })
      .state('main.fmatured', {
        url: '/funds-matured',
        templateUrl: 'app/purchase-corner/funds-matured/funds-matured.html',
        controller: 'FundsMaturedController',
        controllerAs: 'FundsMatured',
        authenticate: true
      })

      .state('distributorempanellment', {
        url: '/distributor-empanelment',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        defaultRoute: '.arn',
        loginType: 'D'
      })
      .state('distributorempanellment.arn', {
        url: '/arn?removeData',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-arn.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('distributorempanellment.nomineedetails', {
        url: '/nominee-details',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-nomineedetails.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('distributorempanellment.otp', {
        url: '/otp',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-otp.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('distributorempanellment.additionaldetails', {
        url: '/additional-details',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-additional-details.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('distributorempanellment.guardiandetails', {
        url: '/guardian-details',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-guardiandetails.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('distributorempanellment.success', {
        url: '/success',
        templateUrl: 'app/distributor/empanellment/distributor-empanellment-success.html',
        controller: 'DistributorEmpanellmentController',
        controllerAs: 'DistributorEmpanellment',
        authenticate: false,
        loginType: 'D'
      })
      .state('main.distributorProfile', {
        url: '/distributor-profile',
        templateUrl: 'app/distributor/profile/profile.html',
        controller: 'DistributorProfileController',
        controllerAs: 'DistributorProfile',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.bankUpdate', {
        url: '/distributor/bank-update',
        templateUrl: 'app/distributor/profile/bank-update/bank-update.html',
        controller: 'DistributorBankUpdateController',
        controllerAs: 'DistributorBankUpdate',
        authenticate: true,
        loginType: 'D',
        resolve: {
          dynamicData: _fetchDynamicDistributorDataBank
        }
      })
      .state('main.leapacademy', {
        url: '/leapacademy',
        templateUrl: 'app/leap-academy/leap-academy.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true,
        loginType: 'D',
        defaultRoute: '.pdf-articles'
      })
      .state('main.globalSearch', {
        url: '/search-result/:searchString',
        templateUrl: 'app/globalSearch/search-result.html',
        controller: 'GolbalSearchController',
        controllerAs: 'GlobalSearch',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.leapacademy.training-classes', {
        url: '/training-classes',
        templateUrl: 'app/leap-academy/training-classes/training-classes.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.leapacademy.pdf-articles', {
        url: '/pdf-articles',
        templateUrl: 'app/leap-academy/pdf-articles/pdf-articles.html',
        controller: 'LeapAcademyController',
        controllerAs: 'LeapAcademy',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.notifications', {
        url: '/notifications',
        templateUrl: 'app/notifications/notifications.html',
        controller: 'NotificationController',
        controllerAs: 'Notification',
        authenticate: true,
        loginType: 'D'
      })

      .state('main.faq', {
        url: '/faq',
        templateUrl: 'app/faq/faq.section.html',
        controller: 'FaqController',
        controllerAs: 'Faq',
        authenticate: true,
        loginType: 'D'
      })

      .state('faq', {
        url: '/faqs',
        templateUrl: 'app/faq/faq.html',
        controller: 'FaqController',
        controllerAs: 'Faq',
        authenticate: false,
        loginType: 'D'
      })

      .state('maintainance', {
        url: '/maintainance',
        templateUrl: 'app/maintainance/maintainance.html',
        controller: 'MaintainanceController',
        controllerAs: 'Maintainance',
        authenticate: false
      })

      //TODO: routes for registration new
      .state('registration', {
        url: '/registration',
        templateUrl: 'app/registration/registration.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false,
        loginType: 'D',
        defaultRoute: '.main'
      })
      .state('registration.main', {
        url: '/main',
        templateUrl: 'app/registration/registration.main.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false,
        loginType: 'D'
      })
      .state('registration.otp', {
        url: '/otp/:registrationRequestId',
        templateUrl: 'app/registration/registration.otp.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })
      .state('registration.success', {
        url: '/success',
        templateUrl: 'app/registration/registration.success.html',
        controller: 'RegistrationController',
        controllerAs: 'Registration',
        authenticate: false
      })

      //TODO: routes for unlock ARN
      .state('unlockArn', {
        url: '/unlock-arn',
        templateUrl: 'app/unlock-arn/unlockArn.html',
        controller: 'UnlockArnController',
        controllerAs: 'UnlockArn',
        authenticate: false,
        loginType: 'D',
        defaultRoute: '.main'
      })

      .state('unlockArn.main', {
        url: '/main',
        templateUrl: 'app/unlock-arn/unlockArn.main.html',
        controller: 'UnlockArnController',
        controllerAs: 'UnlockArn',
        authenticate: false,
        loginType: 'D'
      })
      .state('unlockArn.otp', {
        url: '/otp',
        templateUrl: 'app/unlock-arn/unlockArn.otp.html',
        controller: 'UnlockArnController',
        controllerAs: 'UnlockArn',
        authenticate: false
      })
      .state('unlockArn.success', {
        url: '/success',
        templateUrl: 'app/unlock-arn/unlockArn.success.html',
        controller: 'UnlockArnController',
        controllerAs: 'UnlockArn',
        authenticate: false
      })

      //----TODO: end of routes for unlock ARN----


      .state('transactionsuccess', {
        url: '/transaction-success',
        templateUrl: 'app/transactions/initiate/summary/transactionFail/transaction.success.html',
        authenticate: false
      })
      .state('transactionconfirmation', {
        url: '/transaction-confirmation',
        templateUrl: 'app/transactions/initiate/summary/transactionFail/transaction.confirmation.html',
        authenticate: false
      })

      .state('main.feedback', {
        url: '/feedback',
        templateUrl: 'app/feedback/feedback.html',
        controller: 'FeedbackController',
        controllerAs: 'Feedback',
        authenticate: false,
        loginType: 'D'
      })

      .state('main.transactions.initiate.changedividend', {
        url: '/:uuid/change-IDCW?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/changeDividend/changeDividend.html',
        controller: 'ChangeDividendController',
        controllerAs: 'ChangeDividend',
        authenticate: false,
        loginType: 'D',
        resolve : {
          dynamicData : _fetchDynamicDataChangeICDW
        }
      })

      .state('main.uppercrust', {
        url: '/uppercrust',
        templateUrl: 'app/distributor/uppercrust/uppercrust.html',
        controller: 'UppercrustController',
        controllerAs: 'Uppercrust',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.rollover', {
        url: '/:uuid/rollover',
        params: {
          schemeData: null
        },
        templateUrl: 'app/transactions/initiate/roll-over/rollover.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        loginType: 'D',
        authenticate: false
      })
      .state('main.rolloverView', {
        url: '/:uuid/rollover-view?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/roll-over/rollover-view.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        loginType: 'D',
        authenticate: false
      })
      .state('main.newinvestor', {
        url: '/newinvestor',
        templateUrl: 'app/new-investor/new-investor.html',
        controller: 'NewInvestorController',
        controllerAs: 'NewInvestor',
        loginType: 'D',
        resolve : {
          dynamicData : _fetchDynamicDataCreateFolioNew
        }
      })
      .state('newinvestorApprove', {
        url: '/newinvestorApprove',
        templateUrl: 'app/new-investor-approve/new-investor-approve.html',
        controller: 'NewInvestorApproveController',
        controllerAs: 'NewInvestorApprove',
        authenticate: false
      })
      .state('arnHardcoded', {
        url: '/arn-hardcoded',
        templateUrl: 'app/arn-hardcoded/arn-hardcoded-new.html',
        controller: 'ArnHardcodedNewController',
        controllerAs: 'ArnHardcoded',
      })
      .state('arnHardcodedX', {
        url: '/arn-hardcoded?x',
        templateUrl: 'app/arn-hardcoded/arn-hardcoded-new.html',
        controller: 'ArnHardcodedNewController',
        controllerAs: 'ArnHardcoded',
      })
      .state('arnHardcodedR', {
        url: '/arn-hardcoded?r',
        templateUrl: 'app/arn-hardcoded/arn-hardcoded-new.html',
        controller: 'ArnHardcodedNewController',
        controllerAs: 'ArnHardcoded',
      })
      .state('arnHardcodedRM', {
        url: '/arn-hardcoded?rm',
        templateUrl: 'app/arn-hardcoded/arn-hardcoded.html',
        controller: 'ArnHardcodedController',
        controllerAs: 'ArnHardcoded',
      })

      //  routes for agent
      // ----------------------

      .state('agent', {
        url: '/agent',
        templateUrl: 'app/agent/agent.html',
        controller: 'AgentController',
        controllerAs: 'Agent',
        authenticate: false,
        loginType: 'A',
        defaultRoute: '.login'
      })
      .state('agent.login', {
        url: '/login',
        templateUrl: 'app/agent/login/agent-login.html',
        controller: 'AgentLoginController',
        controllerAs: 'AgentLogin',
        authenticate: false,
        loginType: 'A',
        resolve: {
          isAgentLoggedIn: _isAgentLoggedIn
        }
      })
      .state('agent.changePassword', {
        url: '/change-password',
        templateUrl: 'app/agent/change-password/change-password.html',
        controller: 'ChangePasswordController',
        controllerAs: 'ChangeAgentPassword',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home', {
        templateUrl: 'app/agent/home/agent-home.html',
        controller: 'AgentHomeController',
        controllerAs: 'AgentHome',
        authenticate: true,
        loginType: 'A',
        defaultRoute: '.distributor-list'
      })

      .state('agent.home.distributor-list', {
        url: '/distributor-list',
        templateUrl: 'app/agent/distributor-list/agent-distributor-list.html',
        controller: 'AgentDistributorListController',
        controllerAs: 'AgentDistributorList',
        authenticate: true,
        loginType: 'A',
        params: {
          arn: null
        }
      })

      .state('agent.home.superadmin', {
        url: '/superadmin',
        templateUrl: 'app/agent/superadmin/superadmin.html',
        controller: 'SuperadminController',
        controllerAs: 'Superadmin',
        authenticate: true,
        loginType: 'A'
      })

      .state('agent.home.createUser', {
        url: '/create-user',
        templateUrl: 'app/agent/create-user/create-user.html',
        controller: 'SuperadminCreateUserController',
        controllerAs: 'SuperadminCreateUser',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.distributor-home', {
        url: '/distributor-home',
        templateUrl: 'app/agent/distributor-home/distributor-home.html',
        controller: 'AgentDistributorHomeController',
        controllerAs: 'AgentDistributorHome',
        authenticate: true,
        loginType: 'A',
        resolve: {isDistributorInAgent: _isDistributorInAgent}
      })
      .state('main.otmlist', {
        url: '/non-otmUsers',
        templateUrl: 'app/non-otmUsers/list.html',
        controller: 'OtmListController',
        controllerAs: 'OtmList',
        authenticate: false
      })
      .state('agent.home.transactions', {
        url: '/transactions',
        templateUrl: 'app/transactions/transactions.html',
        controller: 'TransactionController',
        controllerAs: 'Transaction',
        authenticate: true,
        loginType: 'A',
        resolve: {isDistributorInAgent: _isDistributorInAgent}
      })
      .state('agent.home.transactions.initiate', {
        url: '/initiate',
        templateUrl: 'app/transactions/initiate/initiate-transaction.html',
        controller: 'InitiateTransactionController',
        controllerAs: 'InitiateTransaction',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.transactions.initiate.switch', {
        url: '/:uuid/switch?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/switch/switch.html',
        controller: 'InitiateTransactionSwitchController',
        controllerAs: 'InitiateTransactionSwitch',
        authenticate: true,
        loginType: 'A',
        resolve: {
          DynamicData : _fetchDynamicDataSwitch
        }
      })
      .state('agent.home.transactions.initiate.redeem', {
        url: '/:uuid/redeem?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/redeem/redeem.html',
        controller: 'InitiateTransactionRedeemController',
        controllerAs: 'InitiateTransactionRedeem',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.transactions.initiate.stp', {
        url: '/:uuid/stp?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/stp/stp.html',
        controller: 'InitiateTransactionStpController',
        controllerAs: 'InitiateTransactionStp',
        authenticate: true,
        loginType: 'A',
        resolve: {
          DynamicData : _fetchDynamicDataStp
        }
      })
      .state('agent.home.transactions.initiate.flexstp', {
        url: '/:uuid/flexstp?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/flexstp/flexstp.html',
        controller: 'InitiateTransactionFlexStpController',
        controllerAs: 'InitiateTransactionFlexStp',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.transactions.initiate.swingstp', {
        url: '/:uuid/swingstp?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/swingstp/swingstp.html',
        controller: 'InitiateTransactionSwingStpController',
        controllerAs: 'InitiateTransactionSwingStp',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.transactions.initiate.swp', {
        url: '/:uuid/swp?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/swp/swp.html',
        controller: 'InitiateTransactionSwpController',
        controllerAs: 'InitiateTransactionSwp',
        authenticate: true,
        loginType: 'A'
      })

      .state('agent.home.transactions.initiate.sip', {
        url: '/:uuid/sip?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/sip/sip_purchase.html',
        controller: 'InitiateTransactionSipPurchaseController',
        controllerAs: 'InitiateTransactionSipPurchase',
        authenticate: true,
        loginType: 'A',
        resolve : {
          dynamicDataPurchase : _fetchDynamicDataPurchase,
          dynamicDataSip : _fetchDynamicDataSip
        }
      })

      .state('agent.home.transactions.initiate.dtp', {
        url: '/:uuid/dtp?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/dtp/dtp.html',
        controller: 'DtpController',
        controllerAs: 'InitiateTransactionDtp',
        authenticate: true,
        loginType: 'A',
        resolve: {
          DynamicData : _fetchDynamicDataDtp
        }
      })

      .state('agent.home.transactions.initiate.flexindex', {
        url: '/:uuid/flexindex?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/flexindex/flexindex.html',
        controller: 'InitiateTransactionFlexIndexController',
        controllerAs: 'FlexIndex',
        authenticate: true,
        loginType: 'A'
      })

      .state('agent.home.transactions.initiate.rollover', {
        url: '/:uuid/rollover?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/roll-over/rollover.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        loginType: 'A',
        authenticate: false
      })

      .state('agent.home.transactions.initiate.flexsip', {
        url: '/:uuid/flexsip?schemeCode&folioNumber&transactionType&transactionId&status',
        templateUrl: 'app/transactions/initiate/flexsip/flexsip.html',
        controller: 'InitiateTransactionFlexSipController',
        controllerAs: 'InitiateTransactionFlexSip',
        authenticate: true,
        loginType: 'A',
        resolve : {
          dynamicDataSip : _fetchDynamicDataFlexSip
        }
      })

      .state('agent.home.rolloverView', {
        url: '/:uuid/rolloverView?schemeCode&&folioNumber&&transactionType&&transactionId&&status',
        templateUrl: 'app/transactions/initiate/roll-over/rollover-view.html',
        controller: 'RolloverController',
        controllerAs: 'Rollover',
        loginType: 'A',
        authenticate: false
      })


      .state('agent.home.investors', {
        url: '/investors',
        templateUrl: 'app/investors/investors.html',
        controller: 'InvestorsController',
        controllerAs: 'Investors',
        authenticate: true,
        loginType: 'A'
      })
      .state('agent.home.investors.add', {
        url: '/add',
        templateUrl: 'app/investors/add/add.html',
        controller: 'InvestorsAddController',
        controllerAs: 'InvestorsAdd',
        authenticate: false,
        loginType: 'A'
        //defaultRoute: '.appdetails',
      })
      .state('agent.home.investors.add.holdmode', {
        url: '/hold-mode',
        templateUrl: 'app/investors/add/folio/add.holdmode.html',
        controller: 'InvestorsAddController',
        controllerAs: 'Holdmode',
        authenticate: false,
        loginType: 'A'
      })
      .state('agent.home.investors.add.appdetails', {
        url: '/app-details',
        templateUrl: 'app/investors/add/folio/add.app-details.html',
        controller: 'InvestorsAddController',
        controllerAs: 'AppDetails',
        authenticate: false,
        loginType: 'A'
      })
      .state('agent.home.investors.add.jointholders', {
        url: '/joint-holders',
        templateUrl: 'app/investors/add/folio/add.joint-holders.html',
        controller: 'InvestorsAddController',
        controllerAs: 'JointHolders',
        authenticate: false,
        loginType: 'A',
        resolve: {
          jhPANDetails: ['$q', '$state', '$timeout', 'MessageService', 'InvestorModel', 'ModalService',
            function ($q, $state, $timeout, MessageService, InvestorModel, ModalService) {
              var deferred = $q.defer(),
                model = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel(),
                successPanDetails = function (result) {
                  if (result.data && result.data.kycverified) {

                    /*Check repeated pan number*/
                    if (
                      model.folioCreationRequestCO.soleApplicantDetail.panNumber
                      && model.folioCreationRequestCO.soleApplicantDetail.panNumber != result.data.pan
                    ) {

                      var newModel = InvestorModel.getNewJointHolder();
                      model.folioCreationRequestCO.jointHolders[0] = newModel;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderName = result.data.name;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.panNumber = result.data.pan;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.dob = result.data.dob;
                      model.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.minor = result.data.minor;
                      InvestorModel.setInvestorModel(model);
                      InvestorModel.setTab({tab3: true});
                      deferred.resolve();

                    } else {

                      MessageService.error("Valid PAN details required to add joint holder");
                      $timeout(function () {
                        $state.go('main.investors.add.appdetails');
                      });
                      deferred.reject();
                    }
                  }
                },
                errorPanDetails = function () {
                  MessageService.error("Valid PAN details required to add joint holder");
                  $timeout(function () {
                    $state.go('main.investors.add.appdetails');
                  });
                  deferred.reject();
                };

              if (model.folioCreationRequestCO.jointHolders
                && model.folioCreationRequestCO.jointHolders.length == 0
              ) {
                var labelSetter = {
                  type: 'jointholders',
                  label: {header: 'ADD JOINT HOLDER', pan: 'PAN', dob: 'Joint Holder DOB'}
                };
                ModalService.checkPanModal(labelSetter, successPanDetails, errorPanDetails);
              } else {
                deferred.resolve();
              }

              return deferred.promise;
            }]
        }
      })

      .state('agent.home.investors.add.guardianDetails', {
        url: '/guardian-details',
        templateUrl: 'app/investors/add/folio/add.guardian-details.html',
        controller: 'InvestorsAddController',
        controllerAs: 'GuardianDetails',
        authenticate: false,
        loginType: 'A',
        resolve: {
          gdPANDetails: ['$q', '$state', 'MessageService', 'InvestorModel', 'ModalService', 'UtilService',
            function ($q, $state, MessageService, InvestorModel, ModalService, UtilService) {
              var deferred = $q.defer(),
                model = InvestorModel.getInvestorModel() || InvestorModel.getNewInvestorModel(),
                successPanDetails = function (result) {
                  if (result.status && result.data && result.data.kycverified) {
                    var guardianModel = InvestorModel.getNewGuardianDetails();
                    model.folioCreationRequestCO.guardianDetails = guardianModel;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.dob = result.data.dob;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber = result.data.pan;
                    model.folioCreationRequestCO.guardianDetails.basicDetails.kycStatus = true;
                    InvestorModel.setInvestorModel(model);
                    InvestorModel.setTab({tab4: true});
                    deferred.resolve();
                  } else {
                    UtilService.errorHandler(result);
                    $state.go('main.investors.add.appdetails');
                    deferred.reject();
                  }
                },
                errorPanDetails = function (err) {
                  UtilService.errorHandler(err);
                  $state.go('main.investors.add.appdetails');
                  deferred.reject();
                };

              if (model.folioCreationRequestCO.guardianDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails
                && model.folioCreationRequestCO.guardianDetails.basicDetails.panNumber
                && model.folioCreationRequestCO.guardianDetails.basicDetails.dob
              ) {
                deferred.resolve();
              }
              else {
                var labelSetter = {
                  type: 'guardianDetails',
                  label: {header: 'ADD GUARDIAN DETAILS', pan: 'PAN', dob: 'Guardian DOB'}
                }
                ModalService.checkPanModal(labelSetter, successPanDetails, errorPanDetails);
              }

              return deferred.promise;
            }]
        }
      })
      .state('agent.home.investors.add.nominee', {
        url: '/nominee',
        templateUrl: 'app/investors/add/folio/add.nominee.html',
        controller: 'InvestorsAddController',
        controllerAs: 'Nominee',
        authenticate: false,
        loginType: 'A'
      })
      .state('agent.home.investors.add.scheme', {
        url: '/scheme',
        templateUrl: 'app/investors/add/scheme/add.investor.scheme.html',
        controller: 'InvestorsAddSchemeController',
        controllerAs: 'Scheme',
        authenticate: false,
        loginType: 'A'
      })
      .state('agent.home.investors.add.bankdetails', {
        url: '/bank-details',
        templateUrl: 'app/investors/add/payment/add.payment.html',
        controller: 'InvestorsAddPaymentController',
        controllerAs: 'Payment',
        authenticate: false,
        loginType: 'A',
        resolve : {
          dynamicData : _fetchDynamicDataCreateFolio
        }
      })
      .state('agent.home.investors.review', {
        url: '/review',
        templateUrl: 'app/investors/add/review/add.review.html',
        controller: 'InvestorsAddReviewController',
        controllerAs: 'Review',
        authenticate: false,
        loginType: 'A'
      })
      .state('agent.home.investors.statements', {
        url: '/statements/:investorId?&from',
        templateUrl: 'app/investors/profile/statement/statement.html',
        controller: 'StatementsController',
        controllerAs: 'Statements',
        authenticate: true,
        loginType: 'A',
        resolve: {
          investorProfile: _investorProfile
        }
      })
      .state('agent.home.investors.basicinfo',{
        url:'/info/:investorId?&from',
        templateUrl: 'app/agent/investor-update-contact/basic-info.html',
        controller: 'InvestorsProfileController',
        controllerAs: 'InvestorProfile',
        authenticate: true,
        loginType: 'A',
        resolve: {
          investorProfile: _investorProfile
        }
      })
      .state('agent.home.transactionApproval', {
        url: '/transaction-approval',
        templateUrl: 'app/agent/transaction-approval/transaction-approval.html',
        controller: 'TransactionApprovalController',
        controllerAs: 'TransactionApproval',
        authenticate: false,
        loginType: 'A'
      })
      .state('mobile', {
        url: '/mobile',
        templateUrl: 'app/mobile/mobile.html',
        controller: 'MobileController',
        controllerAs: 'Mobile',
        authenticate: false,
        resolve : {
          dynamicData :  _fetchDynamicDataTerms
        }
      })

      .state('mobile.tnc', {
        url: '/:tncType',
        templateUrl: 'app/mobile/tnc/mobile.tnc.html',
        controller: 'MobileTncController',
        controllerAs: 'Modal',
        authenticate: false
      })

      .state('mobile.faq', {
        url: '/faq',
        templateUrl: 'app/mobile/faq/faq.html',
        controller: 'MobileFaqController',
        controllerAs: 'Faq',
        authenticate: false
      })
      .state('mobile.tpv', {
        url: '/tpv',
        templateUrl: 'app/mobile/tpv/tpv.html',
        controller: 'TpvController',
        controllerAs: 'MobileTpv',
        authenticate: false
      })
      .state('ekyc', {
        url: '/initiate/ekyc/:uniqueLink?version',
        templateUrl: 'app/ekyc/ekyc.html',
        controller: 'EkycController',
        controllerAs: 'EKYCController',
        authenticate: false
      })
      .state('main.investors.emandate', {
        url: '/register-emandate',
        templateUrl: 'app/investors/emandate/registerEmandate.html',
        controller: 'RegisterEmandateController',
        controllerAs: 'RegisterEmandate',
        authenticate: true,
        params: {
          investorDetails: null
        },
        resolve : {
          dynamicData : _fetchDynamicDataEmandate
        }
      })
      .state('emandate', {
        url: '/initiate/summary/e-mandate/:uniqueLink?version',
        templateUrl: 'app/mandateRegistration/mandate-registration.html',
        controller: 'MandateRegistrationController',
        controllerAs: 'MandateRegister',
        authenticate: false,
        resolve : {
          dynamicData : _fetchDynamicDataEmandate
        }
      })
      .state('main.bulk', {
        url: '/bulk',
        templateUrl: 'app/transactions/initiate/bulk-transaction/bulk-transaction.html',
        controller: 'BulkTransactionController',
        controllerAs: 'BulkTransaction',
        authenticate: true
      })
      .state('main.bulk.initiate', {
        url: '/initiate',
        templateUrl: 'app/transactions/initiate/bulk-transaction/initiate/bulk-initiate.html',
        controller: 'BulkInitiateController',
        controllerAs: 'BulkInitiate',
        authenticate: true,
        resolve : {
          dynamicData : _fetchDynamicDataBulkInitiate
        }
      })
      .state('main.bulk.status', {
        url: '/status',
        templateUrl: 'app/transactions/initiate/bulk-transaction/view-status/bulk-status.html',
        controller: 'BulkStatusController',
        controllerAs: 'BulkStatus',
        authenticate: true
      })
      .state('main.siprenew', {
        url: '/siprenew',
        templateUrl: 'app/sip-renew/sip-renew.html',
        controller: 'SipRenewController',
        controllerAs: 'SipRenew',
        authenticate: true
      })
      .state('main.siprenew.transaction', {
        url: '/transaction',
        templateUrl: 'app/sip-renew/transaction/sip-renew-transaction.html',
        controller: 'SipRenewTransactionController',
        controllerAs: 'SipRenewTransaction',
        authenticate: true
      })
      .state('main.siprenew.status', {
        url: '/status',
        templateUrl: 'app/sip-renew/status/sip-renew-status.html',
        controller: 'SipRenewStatusController',
        controllerAs: 'SipRenewStatus',
        authenticate: true
      })
      .state('main.investors.nomineeOptout', {
        url: '/profile/:investorId/:folioNo/optOutNomination',
        templateUrl: 'app/investors/profile/optOutNominee/optOutNominee.html',
        controller: 'OptOutNomineeController',
        controllerAs: 'OptoutNominee',
        authenticate: true,
        loginType: 'D',
        resolve: {
          dynamicData : _fetchDynamicDataCreateFolio
        }
      })

      .state('main.transactions.initiate.instantredeem', {
        url: '/:uuid/instantAccessFacility',
        templateUrl: 'app/transactions/initiate/instant-redemption/instant-redemption.html',
        controller: 'InitiateTransactionInstantRedeemController',
        controllerAs: 'InitiateTransactionInstantRedeem',
        authenticate: true,
        loginType: 'D',
        resolve: {
          DynamicDataReview : _fetchDynamicDataIAF
        }
      })

      .state('agent.home.transactions.initiate.instantredeem', {
        url: '/:uuid/instantAccessFacility',
        templateUrl: 'app/transactions/initiate/instant-redemption/instant-redemption.html',
        controller: 'InitiateTransactionInstantRedeemController',
        controllerAs: 'InitiateTransactionInstantRedeem',
        authenticate: true,
        loginType: 'D',
        resolve: {
          DynamicDataReview : _fetchDynamicDataIAF
        }
      })
      .state('forgotPassword', {
        url: '/forgotPassword',
        templateUrl: 'app/forgotPassword/forgotPassword.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'Forgot',
      })

      .state('main.equityAsset', {
        url: '/equityAsset',
        templateUrl: 'app/equityAsset/equityAsset.html',
        controller: 'EquityAssetController',
        controllerAs: 'EquityAsset',
        authenticate: true,
        loginType: 'D',
        params: {
          selectedAUM: null
        }
      })
      .state('main.euinDetails', {
        url: '/euinDetails',
        templateUrl: 'app/euinDetails/euinDetails.html',
        controller: 'EuinDetailsController',
        controllerAs: 'EuinDetails',
        authenticate: true,
        loginType: 'D'
      })
      .state('main.contactUs', {
        url: '/contact-us',
        templateUrl: 'app/contact-us/contact-us.html',
        controller: 'ContactUsController',
        controllerAs: 'ContactUs',
        authenticate: false,
        resolve : {
          dynamicContactUsData : _fetchDynamicContactUsData
        }
      })

      .state('main.cartReview', {
        url: '/review/:uuid',
        templateUrl: 'app/ecart/review/ecart.review.html',
        controller: 'EcartReviewController',
        controllerAs: 'EcartReview',
        authenticate: true,
        resolve : {
          FetchDynamicDataEcart : _fetchDynamicDataEcart
        }
      })
      .state('deeplinks', {
        url: '/deeplinks/:type',
        templateUrl: 'app/deeplinks/deeplinks.html',
        controller: 'DeeplinkController',
        controllerAs: 'Deeplink',
        authenticate: false
      })

  }

  /** @ngInject */
  function _isLoggedIn($q, $state, AuthService, $timeout) {
    var arnAuth = JSON.parse(sessionStorage.getItem('arnAuth'));
    if(arnAuth){
      AuthService.clearCookie();
      sessionStorage.clear();
      sessionStorage.removeItem('arnAuth');
    }
    var deferred = $q.defer();
    var identifier = AuthService.getToken();
    if (identifier && identifier.access_token) {
      if (identifier.loginType == 'A') {
        if (identifier.role == 'Super Admin') {
          $timeout(function () {
            $state.go('agent.superadmin');
          }, 0);
        } else {
          $timeout(function () {
            $state.go('agent.home.distributor-list');
          }, 0);
        }
      } else {
        $timeout(function () {
          $state.go('main.dashboard');
        }, 0);

      }
      deferred.resolve(true);
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _isDistributorInAgent($q, $state, AuthService, $timeout) {
    var deferred = $q.defer();
    var identifier = AuthService.getToken();
    if (identifier && identifier.access_token) {
      if (identifier.loginType == 'A' && identifier.isDistributor != true) {
        $timeout(function () {
          $state.go('agent.home.distributor-list');
        }, 0);
      }
      deferred.resolve(true);
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _investorProfile($q, $timeout, $state, $stateParams, MessageService, InvestorsService, LoaderService) {
    var deferred = $q.defer(),
      success = function (resp) {
        LoaderService.hideLoader();
        if (resp.status && resp.data) {
          deferred.resolve(resp.data);
        } else {
          deferred.reject();
          MessageService.error(resp.message);
          $timeout(function () {
            if(!$stateParams.from && $stateParams.from !== 'agent') {
              $state.go('main.investors.list');
            }
          }, 0);
        }
      },
      error = function () {
        LoaderService.hideLoader();
        deferred.reject();
        $timeout(function () {
          $state.go('main.investors.list');
        }, 0);
      };
    LoaderService.showLoader();
    InvestorsService.post({controller: 'profile'}, {
      "appType": "W",
      "investorUUID": $stateParams.investorId
    }).$promise.then(success, error);
    return deferred.promise;
  }

  /** @ngInject */
  function _myProfile($q, AuthService, ModalService) {
    var deferred = $q.defer();
    var identifierData = AuthService.getToken();
    var success = function (resp) {
        if (resp && resp.status && resp.data) {
          if(resp.data && resp.data.selfCertificateFlag){
            ModalService.initialLogin(resp.data.selfCertificateMsg);
          }
          deferred.resolve(resp.data);
        } else {
          deferred.resolve(null);
        }
      },
      error = function () {
        deferred.resolve(null);
      };
    if (!identifierData || !identifierData.arnCode) {
      deferred.resolve(null);
    } else {
      AuthService.isInitialLogin(identifierData.arnCode).then(success, error);
    }
    return deferred.promise;
  }

  /** @ngInject */
  function _isAgentLoggedIn($q, $state, AuthService, $timeout) {
    var deferred = $q.defer();
    /*token = $cookies.get('token_data');
  try {
    token = angular.fromJson(token);
  } catch (e) {
    $log.info('Json parse exception', e);
    token = '';
  }*/
    var identifier = AuthService.getToken();
    if (identifier && identifier.access_token) {
      $timeout(function () {
        if (identifier.role == 'Super Admin') {
          $state.go('agent.superadmin')
        } else {
          $state.go('agent.home.distributor-list');
        }
      }, 0);
      deferred.resolve(true);
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  }

  /** @ngInject *//*
  function isSuperAdminLoggedIn($q, $state, AuthService, $timeout) {
    var deferred = $q.defer();
    var token = AuthService.getToken();
    if (token && token.access_token) {
      $timeout(function () {
        $state.go('agent.superadmin');
      }, 0);
      deferred.resolve(true);
    } else {
      deferred.resolve(false);
    }
    return deferred.promise;
  }


  /** @ngInject */
  function _fetchDynamicDataPurchase(UtilService) {
    return UtilService.fetchDynamicData("PURCHASE_SCREEN")
  }

  /** @ngInject */
  function _fetchDynamicDataSip(UtilService) {
    return UtilService.fetchDynamicData("SIP_SCREEN")
  }

  /** @ngInject */
  function _fetchDynamicDataSwitch(UtilService) {
    return UtilService.fetchDynamicData("SWITCH_SCREEN")
  }

   /** @ngInject */
   function _fetchDynamicDataRollover(UtilService) {
     return UtilService.fetchDynamicData("ROLLOVER")
   }

   /** @ngInject */
   function _fetchDynamicDataChangeICDW(UtilService) {
     return UtilService.fetchDynamicData("CHANGE_IDCW_OPTION")
   }

   /** @ngInject */
   function _fetchDynamicDataBulkInitiate(UtilService) {
     return UtilService.fetchDynamicData("BULK_TRANSACTION")
   }

    /** @ngInject */
    function _fetchDynamicDataEmandate(UtilService) {
      return UtilService.fetchDynamicData("REGISTER_EMANDATE_SCREEN")
    }

    /** @ngInject */
    function _fetchDynamicDataCreateFolio(UtilService) {
      return UtilService.fetchDynamicData("FOLIO_CREATION")
    }

    /** @ngInject */
    function _fetchDynamicDataTerms(UtilService) {
      return UtilService.fetchDynamicData("TNC_GENERAL")
    }

    /** @ngInject */
    function _fetchDynamicDataStp(UtilService) {
      return UtilService.fetchDynamicData("STP_SCREEN")
    }

    /** @ngInject */
    function _fetchDynamicDataDtp(UtilService) {
      return UtilService.fetchDynamicData("TIP_SCREEN")
    }

    /** @ngInject */
      function _fetchDynamicDataFlexSip(UtilService) {
        return UtilService.fetchDynamicData("FLEX_SIP_SCREEN")
    }

  /** @ngInject */
  function _fetchDynamicDataSystematic(UtilService) {
    return UtilService.fetchDynamicData("MODIFY_SYSTEMATIC_CORNER")
  }

    /** @ngInject */
    function _fetchDynamicDataIAF(UtilService) {
      return UtilService.fetchDynamicData('IAF_REVIEW');
    }

  /** @ngInject */
  function _fetchDynamicDataEcart(UtilService) {
    return UtilService.fetchDynamicData("SIP_PURCHASE_E_CART");
  }

  /** @ngInject */
  function _fetchDynamicDataCancel(UtilService) {
    return UtilService.fetchDynamicData('SIP_CANCELLATION_SCREEN');
  }

  function _fetchDynamicDataAddBank(UtilService) {
    return UtilService.fetchDynamicData('ADD_NEW_BANK');
  }

  /** @ngInject */
  function _fetchDynamicContactUsData(UtilService) {
    return UtilService.fetchDynamicData('CONTACT_US');
  }

  function _fetchDynamicDistributorDataBank(UtilService) {
    return UtilService.fetchDynamicData('UPDATE_DISTRIBUTOR_BANK');
  }


  /** @ngInject */
  function _fetchDynamicDataCreateFolioNew(UtilService) {
    return UtilService.fetchDynamicData("NEW_INVESTOR_JOURNEY")
  }

})();

(function () {
'use strict';
 angular.module("hdfc-mf-distributor-web")

.constant("HDFC_API", {
	"PROTOCOL": "https://",
	"OAUTH_HOST": "api.hdfcfund.com/authorization/",
	"HOST": "api.hdfcfund.com/distributor/",
	"HOST_AGENT": "api.hdfcfund.com/agent/",
	"VERSION": "v2",
	"VERSION_AGENT": "v1",
	"THIRD_PARTY_NAME": "sales-panda",
	"ENV": "prod",
	"BILLDESK_PAYLOAD_STRING": "HDFCFUND|{{uniqueLink}}|NA|{{amount}}|{{bankCode}}|NA|NA|INR|DIRECT|R|hdfcfund|NA|NA|F|NA|NA|NA|NA|NA|NA|NA|{{callbackUrl}}",
	"BILLDESK_PURCHASE_URL": "https://www.billdesk.com/pgidsk/PGIMerchantRequestHandler",
	"PAYMENT_NAV_URL": "https://www.hdfcfund.com/information/payment-mode-information",
	"ALL_IN_CALL": "https://hdfcamc-partnerportal.allincall.in/static/EasyAssistApp/js/easy-assist-v6.js?key=3286d9ff-ffab-4777-b46c-1f6d052fc0ae",
	"HDFC_CONFIG_ENDPOINT": "MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKX8ucv6DDtzTUO3NWYnFvyavpvhVNCGwQ8tZFXgtpRmvGieo/fD5oq7F8u0uldJDvERNDJbZV5r7xmvsb0ZuzOC7Bp9XGPSDRtd7CF0K8oz83YWMlrt30pBpBGtfGBWyoGO7H/HFpqhryCiQMKJdfWw0m3+oHPAuSdbq8F0SjXDAgMBAAECgYEAkkrw8i8a0tbnlTQG81amctJsBnUNzI/H3fmSwgHAyYDWs5qGR1u4eDM3YMmTplR0v9D64Rsed57HaCsqitD/5JFZKbVESIIn0St06Scw537+eK1z8rLL4tNY3wG931ekY27fEupqAjoRr6G2jWc24bIwCLgCbvL44NP759qCuOkCQQDyt8V3eUMrwMhvII0Jc6lXi3zz7Yv4sdiUjhV2ZPj8zfrPJxfknF0crHmrl4l9kGN53dtPL3wNm4K/Rrp4KAKvAkEArxIJX/AR9JSB5eiaQyZMIIyVWvX7z68lOf7e11wK58hLU870EYYsSZKLbyr2P1+zh7aK1yN24nSR329ivo1TLQJACEM3RqzrG3cxm47ZHkRAtIk8FLW2eR3cyJnZozEmxLxiWGD1UEP+a3Z3od7DwHGE4WYrDBQKvg/YMJjAykxaYwJBAJEagvioc0ljmXKkYs+LO4ey3cvhm8+cXF+AVtTq7gMEaSLSokqwCZ8FPlpqomUOfi/a5aLBOzUg5xLpME+9tRUCQQDAsgApPlR0w9IfWYZ82rfc0w7uqfUIi9ZDfJSKF7X+cTLWNQXQVcisb7nA6JN6jd8ES+DmU8u5nfmcJ3RELZMT",
	"PATH": "distributor.hdfcfund.com",
	"TNC_OF_APPROVAL": "https://www.hdfcfund.com/information/terms-transactions-distributors",
	"IHOST": "api.hdfcfund.com/investor/",
	"HOST_CMS": "api.hdfcfund.com/cms-integration/",
	"BILLDESK_URL_ECART": "https://www.billdesk.in/billpay/APIEMandateController?action=APIEMandateHDFCOTMReg&msg=",
	"WEBSITE_LINK": "https://hdfcfund.com/",
	"NSI": "EeMNA3+kP45Izrbuu4553J76IlRlNrgkQIV9B6ktSlD2hd8QxBiU22WOBu8w2mDkz8jmwJC96yr8m9kE2v1bI4yUJjfw62rZB3tDO4zOTEleZcSvgyMlRHiaysN3PXIDyXeMgJE8SnVwQYq7BvXJzXfyD94eALJeFaZMzdOeZDE=",
	"VERSION_3": "v3"
})

; 
})();
/* global moment:false */
(function () {
  'use strict';
  angular.module('hdfc-mf-distributor-web')
    .constant('moment', moment)
    .constant("AppConstants", {
      ToastrMessage: {
        VALIDATE_DATA: {
          'BLANK_EMAIL_FIELD': 'Email should not be blank',
          'BLANK_PASSWORD_FIELD': 'Your Password is Incorrect.',
          'ARN_FIELD': 'Please enter valid ARN',
          'MOBILE_FIELD': 'Please enter valid Mobile Number',
          'MOBILE_ISD': 'Please enter valid Mobile Number including ISD code (eg +91XXXXXXXXXX)',
          'EMAIL_FIELD': 'Please enter a valid Email ID',
          'ADDRESS1_REQUIRED': 'Address Line1 is required',
          'ADDRESS2_REQUIRED': 'Address Line2 is required',
          'PINCODE_REQUIRED': 'Pin code is required',
          'STATE_REQUIRED': 'State is required',
          'SELECT_COUNTRY': 'Please select a country',
          'PASSWORD_FIELD': 'Please enter a valid Password',
          'VISA_FIELD': 'Please enter a valid Visa Card Number',
          'MASTER_FIELD': 'Please enter a valid Master Card Number',
          'ACCOUNT_NUMBER_FIELD': 'Please enter valid account number',
          'ACCOUNT_HOLDER_REQUIRED': 'Account Holder name is required',
          'IFSC_CODE_FIELD': 'Please enter valid ifsc code number',
          //'IFSC_CODE_REGEX': 'Please enter 11 alphanumeric characters',
          'IFSC_CODE_REGEX': 'Please enter 11 alphanumeric characters, fifth character must be 0(zero).',
          'MICR_NUMBER_FIELD': 'Please enter valid MICR number',
          'MICR_NUMBER_RANGE': 'Please enter 9 digits valid MICR number',
          'OTP_FIELD': 'Please enter valid OTP',
          'PAN_FIELD': 'Please enter 10 digits valid PAN',
          'ARN_REQUIRED': 'ARN is required.',
          'BANK_ACCOUNT_REQUIRED': 'Bank Account Number is required.',
          'EMAIL_REQUIRED': 'Email ID is required.',
          'MOBILE_REQUIRED': 'Mobile Number is required.',
          'PASSWORD_REQUIRED': 'Password is required.',
          'PASSWORD_MIN': 'Minimum Length of Password should be 8.',
          'OTP_REQUIRED': 'OTP is required.',
          'REASON_REQUIRED': 'Reason is required.',
          'CONFIRM_PASSWORD_REQUIRED': 'Confirm Password is required.',
          'PASSWORD_MATCH': 'Passwords should be same.',
          'FOLIO_REQUIRED': 'Folio Number is required.',
          'FOLIO_EMAIL': 'Email is not found for this folio',
          'SCHEME_REQUIRED': 'Scheme is required',
          'FREQUENCY_REQUIRED': 'Frequency is required',
          'PERCENT_REQUIRED': 'Percentage is required',
          'INSTALLMENT_REQUIRED': 'Installments is required',
          'AMOUNT_REQUIRED': 'Amount is required',
          'PAYOUT_MECH_REQUIRED': 'Payout mechanism is required',
          'ACCOUNT_NUMBER_REQUIRED': 'Account Number is required',
          //'ACCOUNT_NUMBER_RANGE': 'Account Number should be minimum 9 digit and maximum 25 digit',
          'ACCOUNT_NUMBER_RANGE': 'Account Number should be minimum 9 digits',
          'ACCOUNT_NUMBER_RANGE_MIN': 'Account Number should be minimum 9 digits',
          'ACCOUNT_NUMBER_RANGE_MAX': 'Account Number should be maximum 20 digits',
          //'SAME_ACCOUNT_NUMBER_RANGE': 'Account Number should be minimum 9 digit and same',
          'SAME_ACCOUNT_NUMBER_RANGE': 'Account Number should be same',
          'DIGITS_ONLY': 'Text should be digits only',
          'MICR_NUMBER_REQUIRED': 'MICR Number is required',
          'IFSC_CODE_REQUIRED': 'IFSC Code is required',
          'BANK_REFERENCE_NUMBER_REQUIRED': 'Bank Reference Number is required',
          'BANK_REFERENCE_NUMBER_SAME': 'Bank Reference Number should be same',
          'EXPIRY_MONTH_REQUIRED': 'Expiry Month is required',
          'EXPIRY_YEAR_REQUIRED': 'Expiry Year is required',
          'BANK_NAME_REQUIRED': 'Bank Name is required',
          'CARD_NUMBER_REQUIRED': 'Card Number is required',
          'CARD_HOLDERS_NAME_REQUIRED': 'Card Holder' + "'" + 's Name is required',
          'BRANCH_LOCATION_REQUIRED': 'Bank Location is required',
          'BRANCH_CITY_REQUIRED': 'Bank City is required',
          'BRANCH_NAME_REQUIRED': 'Bank Name is required',
          'ACCOUNT_TYPE_REQUIRED': 'Account Type is required',
          'UTR_REQUIRED': 'UTR is required',
          'SAME_UTR_REQUIRED': 'UTR number should be same',
          'NOMINEE_NAME_REQUIRED': 'Nominee Name is required',
          'NOMINEE_RELATION_REQUIRED':'Relationship with Applicant is required',
          'NOMINEE_DOB_REQUIRED':'DOB is required',
          'NOMINEE_ADDRESSLINE1_REQUIRED':'Address field is required',
          'NOMINEE_COUNTRY_REQUIRED':'Country name is required',
          'NOMINEE_CITY_REQUIRED':'City name is required',
          'NOMINEE_ZIP_REQUIRED':'Zip code is required',
          'NOMINEE_NAMEGUARDIAN_REQUIRED':'Guardian name is required',
          'NOMINEE_TEXT_ONLY': 'Nominee Name should contain characters only',
          'MINIMUM_AMOUNT': 'Minimum amount should be ',
          'MAX_AMOUNT': 'Exceeding available free amount',
          'IS_MULTIPLES': 'Please provide multiples of given amount',
          'MINIMUM_UNIT': 'Minimum units should be ',
          'MAX_UNIT': 'Exceeding available free units',
          'DAY_REQUIRED': 'Day is required',
          'UNITS_INVALID': 'Invalid number of units',
          'UNITS_REQUIRED': 'Number of unit is required',
          'SIPAMOUNT_INVALID': 'Invalid sip amount',
          'SIPAMOUNT_REQUIRED': 'Sip is required',
          'BLANK_BANK_INFO': 'Please Select a bank first',
          'TRANSACTION_APPROVED': 'You have approved transaction successfully',
          'DOC_UPLOADED': 'Document uploaded successfully. You can proceed to fill next form.',
          'TRANSACTION_REJECTED': 'You have rejected transaction successfully.',
          'BLANK_OUT_SCHEME': 'PLease select an out scheme first',
          'BLANK_IN_SCHEME': 'PLease select an in scheme first',
          'PAN_REQUIRED': 'PAN is required',
          'NOMINEE_DOB': 'Nominee DOB is required',
          'GUARDIAN_NAME': 'Guardian name is required',
          'MINOR_NAME': 'Minor name is required',
          'MINOR_VALID_NAME': 'Please enter a valid name.',
          'MINOR_DOB': 'Minor dob is required',
          'DOB_FIELD': 'Please enter valid DOB (Eg. 01-JAN-1990)',
          'DOB_FIELD_MM': 'Please enter valid DOB (Eg. 01-01-1990)',
          'GENDER_REQUIRED': 'Gender is required',
          'NOMINEE_NAME': 'Nominee name is required',
          'ADDRESS_LINE1': 'Address line1 is required',
          'ADDRESS_LINE2': 'Address line2 is required',
          'ZIP_CODE': 'Zip code is required',
          'CITY': 'City name is required',
          'COUNTRY': 'Country name is required',
          'TAX_STATUS': 'Tax status is required',
          'GROSS_ANNUAL_INCOME': 'Gross annual income is required',
          'INVALID_AMOUNT': 'Not a valid amount',
          'OCCUPATION': 'Occupation is required',
          'NET_WORTH': 'Networth is required',
          'NET_WORTH_DATE': 'Networth date is required',
          'TAX_ID_TYPE': 'taxId type date is required',
          'TAX_ID_NUMBER': 'taxId number date is required',
          'ADDRESS_TYPE': 'Address type is required',
          'NOMINEE_PROPORTION': 'Please make sure nominee proportion is absolute number and their sum is 100',
          'NOMINEE_PROPORTION_REQUIRED': 'Nominee proportion is required',
          'NOMINEE_RELATIONSHIP': 'Relationship is required',
          'INVESTOR_HOLD_STATUS': 'Please select hold mode',
          'CVV_REQUIRED': 'CVV is required',
          'CVV_FIELD': 'Please enter valid CVV number',
          'INVESTOR_EMAIL_MISSING': 'Investor email address not present.',
          'PASSWORD_INVALID_CHAR': 'Password has ilegal character.',
          'EUIN_REQUIRED': 'EUIN is required',
          'USER_ID_REQUIRED': 'User Id is required',
          'USER_ID_FIELD': 'Please enter valid User ID',
          'NAME_REQUIRED': 'Name is required',
          'TRANSACTION_CANCELATION':'Your cancellation request submitted successfully',
          'FORM_SAVE_FAILED': 'Not able to save form changes.',
          'VIRTUAL_ADDRESS_REQUIRED': 'Virtual Payment Address is required (eg. abc@xyz)',
          'SAVING_ACCOUNT':'SAVING ACCOUNT',
          'SAVING_ACCOUNT_CODE':'SB',
          'BLANK_AUTH_MODE_INFO': 'Please select authentication mode',
          'INVALID_EMAIL_EMANDATE': 'Please add email ID in the folio before proceeding with e-mandate registration. If you have already requested to add email ID, then wait for it to be updated in your folio.',
          'INVALID_MOBILE_EMANDATE': 'Please add mobile number in the folio before proceeding with e-mandate registration. If you have already requested to add mobile number, then wait for it to be updated in your folio.',
          'INVALID_EMAIL_MOBILE_EMANDATE': 'Please add email ID and mobile number in the folio before proceeding with e-mandate registration. If you have already requested to add email ID and mobile number, then wait for it to be updated in your folio.',
          'NO_OF_INSTALLMENT_REQUIRED': 'Number of Installment is required',
          'MONTH_REQUIRED': 'Month is required',
          'ARN_NO_REQUIRED': 'ARN Number is required',
          'INVESTOR_NAME_REQUIRED': 'Investor name is required',
          'INVALID_PAN': 'Please enter valid PAN',
          'MANDATE_REQUIRED': 'Please add email ID and mobile number in folio before registering e-mandate.',
          'MANDATE_EMAIL_REQUIRED': 'Please add email ID in folio before registering e-mandate.',
          'MANDATE_MOBILE_REQUIRED': 'Please add mobile number in folio before registering e-mandate.',
          'NO_VALID_PAYMENT_MODE': 'No valid payment mode available to proceed.',
          'EMAIL_BELONGS_TO' : 'Select email belongs to',
          'MOBILE_BELONGS_TO' : 'Select mobile belongs to',
          "CANCEL_NOMINATION": 'Please note, by cancelling nomination for the folio there would not be any transfer of units to nominee in case of death of unit holder. If you stll want to go ahead with cancellation of nomination, then please agree to the below Terms and Conditions by ticking the checkbox.',
          "PROPORTION_PERCENTAGE": 'Sum of percentage proportion of all nominees should be equal to 100%',
          "OFFLINE_NOMINEE_FORM":"To update nominee details for folios with mode of holding as 'Anyone or Survivor' or 'Joint', kindly submit offline form available here: ",
          'PROPORTION_NOT_ZERO': 'Proportion of nominee can not be zero',
          "PAN_UNIQUE":'Pan should be unique',
          "PAN_VALID":'Enter a valid Pan',
          "UNIQUE_NOMINEE_PAN" : "PAN is already added as a Nominee",
          "NOMINEE_SAME_INVESTOR" : "You cannot add yourself as Nominee",
          "GUARDIAN_SAME_NOMINEE" : 'Guardian PAN cannot be same as Nominee Pan',
          "GUARDIAN_TEXT_ONLY" : 'Guardian Name should contain characters only',
          'TENURE_EMPTY' : 'Please Select Tenure',
          "GUARDIAN_PAN_REQUIRED" : 'Guardian Pan is Required',
          "AMOUNT_EXCEEDED" : "This is a high value registration, we request you to contact (hello@hdfcfund.com) for assistance to complete your registration",
          'BANK_BRANCH_REQUIRED': 'Bank Branch is required',
          "DOB_MINOR" : "Entered DOB should not be less than 18 years",
          'MAX_AMOUNT_VALIDATION_ECART': 'Transaction amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed.',
          "EMANDATE_DATE_EXCEED_ERROR" : 'SIP end date cannot be more than E-mandate end date.',
          "EMANDATE_MIN_ERROR": 'Amount of e-mandate cannot be less than ₹',
          "EMANDATE_MAX_ERROR": 'Amount of e-mandate cannot be greater than ₹',
          "EMANDATE_SIP_AMOUNT_ERROR": 'Mandate amount cannot be less than SIP entered amount.',
          "MANDATE_DATE_EXCEED_ERROR": 'E-mandate end date cannot be less than SIP end date.',
          "MANDATE_DATE_EXCEED_ERROR_TENURE" : 'E-mandate End Date cannot be less than SIP End Date. Kindly change E-mandate End Date.',
          "EMANDATE_MIN_ERROR_FLEX_SIP": 'Mandate amount cannot be less than twice the SIP amount for Flex SIP registration.',
          'CHILD_ADD_FUND': "Children's Gift Fund cannot be added for this folio.Please change the folio.",
          'RETIREMENT_ADD_FUND': 'Retirement Fund cannot be added for this folio.Please change the folio.',
          "MANDATE_AMOUNT_REQUIRED" : "Mandate amount is required.",
          'BROKER_REQUIRED': 'Broker code is required',
          'SUB_BROKER_REQUIRED': 'Sub Broker code is required',
          'DISTRIBUTOR_REQUIRED': 'Distributor name is required',
          'BROKER_VALID': 'Broker code is not valid',
          'RIA_REQUIRED': 'RIA code is required.',
          'RIA_INVALID': 'Please enter valid 12 character RIA code.',
          'MAX_LENGTH_CITY_OF_BIRTH': 'City of Birth should be maximum 35 characters.',
          'DATE_REQUIRED': 'Please select date.',
          'NET_WORTH_REQUIRED': 'Please enter net worth',
          "UPDATE_CONTACT_EDIT_ERROR" : "You can edit only one contact information at a time.",
          'FILL_FOLIO_DETAILS': 'Would you like to pre-fill your folio detail from existing folio?',
          "RELATIONSHIP_WITH_APPLICANT_OTHER": 'Relation with Applicant is required',
          "RELATIONSHIP_WITH_APPLICANT_OTHER_VALID": "Please enter valid relation",
          "PERSONAL_IDENTIFIER_REQUIRED": "Please select personal identifier of nominee.",
          "NOMINEE_EMAIL_SAME_AS_INVESTOR": "Nominee’s email ID  cannot be the same as the investor’s. Please provide a different ID.",
          "NOMINEE_MOBILE_SAME_AS_INVESTOR": "Nominee’s mobile no. cannot be the same as the investor’s. Please provide a different number.",
          "DRIVING_LICENSE_REQUIRED": "Nominee Driving License No. is required.",
          "AADHAAR_REQUIRED": "Nominee Aadhaar No. is required.",
          "AADHAAR_INVALID": "Please enter valid last four digits number of nominee's Aadhaar.",
          "NOMINEE_PAN_SAME_AS_INVESTOR": "Nominee’s Pan no. cannot be the same as the investor’s. Please provide a different Pan number.",
          "DRIVING_LICENSE_ALREADY_EXIST": "Driver License no. is already added as a nominee.",
          "PAN_NUMBER_ALREADY_EXIST": "Pan no. is already added as a nominee.",
          "AADHAAR_ALREADY_EXIST": "Aadhaar no. is already added as a nominee.",
          "PAN_VALID_ERROR":"Please enter valid PAN.",
          "VALID_DRIVING_LICENCE": "Please enter valid driving license no.",
          "NOMINEE_PAN_REQUIRED": "Nominee PAN is required",
          "PASSPORT_REQUIRED": "Please enter valid passport number.",
          "PASSPORT_ALREADY_EXIST": "Passport number is already added as a nominee.",
        },
        FORGET_PASSWORD: {
          'SUCCESS': 'An Email has sent successfully on your email id.'
        },
        RESET_PASSWORD: {
          'SUCCESS': 'Password changed successfully.',
          'MISSMATCH': 'Password not matched.'
        },
        USER_LOGIN: {
          'SUCCESS': 'Loggin successful.',
          'FAILED': 'Your ARN or Password combo was incorrect.'
        },
        USER_LOGOUT: {
          'SUCCESS': 'Logout successful.',
          'FAILED': 'Your ARN or Password combo was incorrect.'
        },
        PAYMENT_FAILED: 'Sorry, We are not able to process your request at this time. Please try again.',
        FAILED: 'Something went wrong. Please try again later.',
        SUCCESS: 'Your information has been submitted successfully.'
      },
      email_regex: /^[a-zA-Z0-9](?!.*\.\.)+[a-zA-Z0-9._%+-]{1,256}@[a-zA-Z0-9.-]{1,64}\.[a-zA-Z]{1,25}$/i,
      password_regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!_])([a-zA-Z0-9@$!_]){8,15}$/,
      arn_regex: /^[A-Z0-9]{1,10}$/,
      mobile_regex: /^\+91[1-9]{1}\d{9}$/,
      mobile_regex_num_only: /^[0-9]{10}$/,
      mobile_regex_new: /^(?:\+|\+1|\+\d+|(?!(\d)\1+$)\d+)$/,
      dob_regex: /^(\d{1,2})-(\d{1,2})-(\d{4})$/,
      visa_regex: /^4/,
      master_regex: /^5[1-5]/,
      ifsc_regex: /^[A-Za-z]{4}[0][a-zA-Z0-9]{6}$/,
      ifsc_regex2: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/,
      ifsc_regex1:/^[A-Za-z]{4}\d{7}$/,
      upi_virtual_addr_regex: /^[a-zA-Z0-9.-]+@[a-zA-Z0-9]+$/,
      UTR_REGEX: /^([a-zA-Z0-9]*)$/,
      otp_regex:/^[0-9]{6}$/,
      valid_string_regex: /^[a-zA-Z\s]*$/,
      valid_dl_regex: /^[a-zA-Z0-9!@#$%^&*]+$/,
      valid_4_digit_aadhar_regex: /^\d{4}$/,
      DEFAULT_LOGO: '/assets/images/logo-placeholder.png',
      DEFAULT_PROFILE_IMAGE: '/assets/images/profile_default_image.png',
      APPROVAL_MODE:{SMS:'SMS',Online:'Online'},
      RELATIONS: {OTHER:'Other'},
      LIQUID:'LIQUID',
      SUMMARY_EXPIRY_MONTH: [
        {key: '01', value: '01'},
        {key: '02', value: '02'},
        {key: '03', value: '03'},
        {key: '04', value: '04'},
        {key: '05', value: '05'},
        {key: '06', value: '06'},
        {key: '07', value: '07'},
        {key: '08', value: '08'},
        {key: '09', value: '09'},
        {key: '10', value: '10'},
        {key: '11', value: '11'},
        {key: '12', value: '12'}
      ],
      SUMMARY_EXPIRY_YEAR: [
        {key: '2017', value: '2017'},
        {key: '2018', value: '2018'},
        {key: '2019', value: '2019'},
        {key: '2020', value: '2020'},
        {key: '2021', value: '2021'},
        {key: '2022', value: '2022'},
        {key: '2023', value: '2022'},
        {key: '2024', value: '2024'},
        {key: '2025', value: '2025'},
        {key: '2026', value: '2026'},
        {key: '2027', value: '2027'},
        {key: '2028', value: '2028'},
        {key: '2029', value: '2029'},
        {key: '2030', value: '2030'}
      ],
      roles: {
        ADMIN: 'admin'
      },
      SIP_TRANSACTION_TYPES: [
        {key: 'SIP', value: 'SIP'},
        {key: 'Flex SIP' , value: 'FLEXSIP'},
        {key: 'SIP with Top up' , value: 'SIP_TOP_UP'},
        {key: 'SWP', value: 'SWP'},
        {key: 'STP', value: 'STP'},
        {key: 'Flex STP', value: 'Flex STP'},
        {key: 'Swing STP', value: 'Swing STP'},
        {key: 'TIP', value: 'DTP'},
        {key: 'Flex Index', value: 'Flex Index'},
        {key: 'SMART SWAP', value: 'SMART SWAP'},
        {key: 'DREAM SIP', value: 'DREAM SIP'}
      ],
      PAYMENT_MODE: [
        {key: 'WEB', value: 'Net Banking'},
        {key: 'HDFC',value: "HDFC Bank's Fund Transfer"},
        {key: 'RTGS',value: 'NEFT/RTGS'},
        {key: 'UPI',value: 'UPI'}
        //{key: 'OTM', value: 'OTM(One Time Mandate)'},
      ],
      TRANSACTION_STATUSES: [
        // {key: 'Transaction Status', value: 'All'},
        {key: 'Processed', value: 'Processed'},
        {key: 'Proposed', value: 'Proposed'},
        {key: 'Pending', value: 'Pending'},
        {key: 'Rejected', value: 'Rejected'},
        {key: 'Expired', value: 'Expired'},
        {key: 'Reversed', value: 'Reversed'}
      ],
      // new investor back state manage
      BACK_ROUTE: [
        { url: "/choose-scheme", state: "main.newinvestor.investmentDetails.select-scheme.scheme" },
        { url: "/Investment-mode", state: "main.newinvestor.investmentDetails.investmentMode" },
        { url: "/amount-detail", state: "main.newinvestor.investmentDetails.amount" }
      ],
      BACK_ROUTE2: [
        { url: "/folio-basic-details", state: "main.newinvestor.folioCreation.folioDetails" },
        { url: "/folio-income-details", state: "main.newinvestor.folioCreation.folioIncomeDetails" },
        { url: "/folio-nominee-details", state: "main.newinvestor.folioCreation.folioNomineeDetails" },
        { url: "/bankdetails", state: "main.newinvestor.folioCreation.bankdetails" }
      ],
      BACK_ROUTE3: [
        { url: "/folio-basic-details", state: "main.newinvestor.folioCreation.folioDetails" },
        { url: "/folio-income-details", state: "main.newinvestor.folioCreation.folioIncomeDetails" },
        { url: "/jointholder", state: "main.newinvestor.folioCreation.jointholder" },
        { url: "/folio-nominee-details", state: "main.newinvestor.folioCreation.folioNomineeDetails" },
        { url: "/bankdetails", state: "main.newinvestor.folioCreation.bankdetails" }
      ],
      BACK_ROUTE4: [
        { url: "/folio-basic-minor-details", state: "main.newinvestor.folioCreation.folioMinorDetails" },
        { url: "/folio-guardian-minor-details", state: "main.newinvestor.folioCreation.guardianMinorDetails" },
        { url: "/bankdetails", state: "main.newinvestor.folioCreation.bankdetails" }
      ],
      STATUS_YEAR: [
        {key: 'custom', value: 'Period: Custom'}
        /*{key: 'current', value: 'Current Financial Year'},
        {key: 'previous', value: 'Previous Financial Year'}*/
      ],
      TRANSACTION_TYPES: {
        INFLOW: [
          {key: 'Transaction Type (All)', value: 'ALL'},
          {key: 'SIP', value: 'SIP'},
          {key: 'STP', value: 'STP'},
          {key: 'PURCHASE', value: 'PURCHASE'},
          {key: 'SWITCH IN', value: 'SWITCH_IN'}
        ],
        OUTFLOW: [
          {key: 'Transaction Type (All)', value: 'ALL'},
          {key: 'STP', value: 'STP'},
          {key: 'SWP', value: 'SWP'},
          {key: 'REDEMPTION', value: 'REDEMPTION'},
          {key: 'SWITCH OUT', value: 'SWITCH_OUT'}
        ],
        ALL: [
          {key: 'All', value: 'ALL'},
          {key: 'SIP', value: 'SIP'},
          {key: 'Flex SIP' , value: 'FLEXSIP'},
          {key: 'STP', value: 'STP'},
          {key: 'SWP', value: 'SWP'},
          {key: 'TIP', value: 'DTP'},
          {key: 'Redemption', value: 'REDEMPTION'},
          {key: 'Purchase', value: 'PURCHASE'},
          {key: 'Switch', value: 'SWITCH'},
          {key: 'Switch In', value: 'SWITCH_IN'},
          {key: 'Switch Out', value: 'SWITCH_OUT'},
          // {key: 'STP Index', value: 'STPINDEX'},
          // {key: 'STP Swing', value: 'STPSWING'},
          {key: 'STP Flex', value: 'STPFLEX'},
          {key: 'Flex Index', value: 'FLEXINDEX'}
        ]
      },
      PAGE_LIMITS: [25, 50],
      TRANSACTION_FLOW_TYPES: ['ALL', 'INFLOW', 'OUTFLOW'],
      TRANSACTION_NATURES: ['ALL', 'LUMPSUM', 'SYSTEMATIC'],
      INVESTOR_FLOW_TYPE: ['ALL', 'LUMPSUM', 'SYSTEMATIC'],
      INVESTOR_PROFILE_TYPES: ['PORTFOLIO', 'TRANSACTIONS', 'INFO', 'FINANCIALGOLAS'],
      INVESTOR_TRANSACTION_MODE: [{key: 'Mode (All)', value: 'ALL'}, {key: 'Online', value: 'ON'}, {
        key: 'Offline',
        value: 'OFF'
      }],
      INVESTOR_TRANSACTION_NATURE: [{key: 'Investment Type (All)', value: 'ALL'}, {
        key: 'Lumpsum',
        value: 'LUMPSUM'
      }, {key: 'Systematic', value: 'SYSTEMATIC'}],
      INVESTOR_TRANSACTION_TYPE: [
        {key: 'Transaction Type (All)', value: 'ALL'},
        {key: 'SIP', value: 'SIP'},
        {key: 'Flex SIP' , value: 'FLEXSIP'},
        {key: 'STP', value: 'STP'},
        {key: 'SWP', value: 'SWP'},
        {key: 'TIP', value: 'DTP'},
        {key: 'Redemption', value: 'REDEMPTION'},
        {key: 'Purchase', value: 'PURCHASE'},
        {key: 'Switch In', value: 'SWITCH_IN'},
        {key: 'Switch Out', value: 'SWITCH_OUT'},
        {key: 'SMART SWAP', value: 'SMART_SWAP'}],
      INVESTOR_TRANSACTION_STATUS: [{key: 'Status (All)', value: 'ALL'},
        {key: 'Processed', value: 'PROCESSED'},
        {key: 'Pending', value: 'PENDING'},
        {key: 'Rejected', value: 'REJECTED'},
        // {key: 'Expired', value: 'EXPIRED'}
        {key: 'Reversed', value: 'REVERSED'}],
      INVESTOR_INVESTORLIST_TYPE: [
        {key: 'Investor Type (All)', value: 'ALL'},
        {key: 'Active', value: 'ACTIVE'},
        {key: 'Dormant', value: 'DORMANT'}
      ],
      INVESTOR_INVESTORLIST_OTM_TYPE: [
        {key: 'OTM (All)', value: 'ALL'},
        {key: 'Yes', value: 'AVAILABLE'},
        {key: 'No', value: 'NOT_AVAILABLE'}
      ],
      INVESTOR_INVESTORLIST_SUB_TYPE: [
        {key: 'Investor Sub Type (All)', value: 'ALL'},
        {key: 'CGF', value: 'CGF'},
        {key: 'Minor', value: 'MINOR'},
        {key: 'Others', value: 'OTHERS'}
      ],
      INVESTOR_POLITICAL_STATUS: {POLITICAL: 'POLITICAL', RELATED: 'POLITICALLY_RELATED', NONE: 'NONE'},
      INVESTOR_HOLD_MODE: {SINGLE: 'SINGLE', AOS: 'ANY_OR_SURVIVOR'},
      INVESTOR_HOLD_STATUS: [{key: 'SINGLE', value: 'Single'}, {key: 'ANYONE', value: 'Any One'}, {
        key: 'JOINT_HOLDER',
        value: 'Joint Holder'
      }],
      INVESTOR_ACC_TYPE: [{accountTypeCode: 'CA', accountType: 'Current Account'}, {
        accountTypeCode: 'CC',
        accountType: 'Cash Credit'
      },
        {accountTypeCode: 'HYP', accountType: 'HYP'}, {accountTypeCode: 'SB', accountType: 'Saving Account'}],
      FREQUENCY_LIST_FOR_FIXED_AMOUNT: [{key: 'OM', value: 'Monthly', monthfreq: 1}, {
        key: 'Q',
        value: 'Quarterly',
        monthfreq: 3
      }, {key: 'H', value: 'Half Yearly', monthfreq: 6}],
      FREQUENCY_LIST_FOR_CAPITAL_APPRECIATION: [{key: 'Q', value: 'Quarterly', monthfreq: 3}, {
        key: 'H',
        value: 'Half Yearly',
        monthfreq: 6
      }],
      STP_FREQ_LIST_FOR_CAPITAL: [
        {key: 'OM', value: 'Monthly', monthfreq: 1},
        {key: 'Q', value: 'Quarterly', monthfreq: 3}
      ],
      STP_FREQ_LIST_FOR_FIXED: [
        {key: 'DZ', value: 'Daily', dayfreq: 1},
        {key: 'OW', value: 'Weekly', dayfreq: 7},
        {key: 'OM', value: 'Monthly', monthfreq: 1},
        {key: 'Q', value: 'Quarterly', monthfreq: 3}
      ],
      SWP_FREQ_LIST_FOR_CAPITAL: [
        {key: 'Q', value: 'Quarterly', monthfreq: 3},
        {key: 'H', value: 'Half Yearly', monthfreq: 6},
        {key: 'Y', value: 'Yearly', monthfreq: 12}
      ],
      SWP_FREQ_LIST_FOR_FIXED: [
        {key: 'OM', value: 'Monthly', monthfreq: 1},
        {key: 'Q', value: 'Quarterly', monthfreq: 3},
        {key: 'H', value: 'Half Yearly', monthfreq: 6},
        {key: 'Y', value: 'Yearly', monthfreq: 12}
      ],
      SIP_FREQ_LIST: [
        {key: 'OM', value: 'Monthly', monthfreq: 1},
        {key: 'Q', value: 'Quarterly', monthfreq: 3},
        {key: 'OW', value: 'Weekly', dayfreq: 7},
        {key: 'BZ', value: 'Daily', dayfreq: 1}
      ],
      Dynamic_SIP_FREQ_LIST: [
        {code: 'OM', value: 'Monthly', duration: 1},
      ],
      Dynamic_BULK_SIP_FREQ_LIST: [
        {name:'Daily',code:'BZ',duration:1},
        {name:'Half Yearly',code:'H',duration:6},
        {name:'Monthly',code:'OM',duration:1},
        {name:'Quarterly',code:'Q',duration:3},
        {name:'Yearly',code:'Y',duration:12},
      ],
      BULK_SIP_FREQ_LIST: [
        {key: 'OM', value: 'Monthly', monthfreq: 1},
        {key: 'Q', value: 'Quarterly', monthfreq: 3},
        {key: 'BZ', value: 'Daily', dayfreq: 1}
      ],
      DAYS_LIST: [{name: 1, value: 1}, {name: 5, value: 5}, {name: 10, value: 10}, {name: 15, value: 15}, {
        name: 20,
        value: 20
      }, {name: 25, value: 25}],
      SIP_DAYS_LIST: [{name:1,value:1},{name:2,value:2},{name:3,value:3},{name:4,value:4},{name:5,value:5},{name:6,value:6},
        {name:7,value:7},{name:8,value:8},{name: 9,value: 9},{name:10,value:10},{name:11,value:11},
        {name:12,value:12},{name:13,value:13},{name:14,value:14},{name:15,value:15},{name:16,value:16},
        {name:17,value:17},{name:18,value:18},{name:19,value:19},{name:20,value:20},{name:21,value:21},
        {name:22,value:22},{name:23,value:23},{name:24,value:24},{name:25,value:25},{name:26,value:26},{name:27,value:27},
        {name:28,value:28}],
      SIP_END_DATE_OPTIONS: {
        SELECT_END_DATE: 0,
        NO_OF_INSTALLMENT: 1,
        DEFAULT_END_DATE: 2
      },
      WEEKS_LIST: [
        {name: 'Monday', value: 2}, {name: 'Tuesday', value: 3},
        {name: 'Wednesday', value: 4}, {name: 'Thursday', value: 5}, {name: 'Friday', value: 6}
      ],
      OPTION_LIST:[
        {key: 'OPTA', value: 'Option A'},
          {key: 'OPTB', value: 'Option B'}
      ],
      TRANSACTION: {
        GROWTH: 'GROWTH',
        DIVIDEND: 'DIVIDEND',
        REINVEST: 'Y',
        PAYOUT: 'N',
        FIXED_AMOUNT: 'F',
        CAPITAL_APPRECIATION: 'V',
        AMOUNT_TYPE:{amount:'AMOUNT',units:'UNITS',all_units:'ALL_UNITS'},
        PAYMENT_OPTIONS: {
          EC: 'EC',
          SI : 'SI',
          OTM: 'OTM',
          RTGS: 'RTGS',
          NETBANKING: 'NETBANKING',
          HDFC: 'HDFC',
          UPI: 'UPI',
          HEM: 'HEM'
        },
        DESCRIPTIONS: {
          F: 'Fixed Amount',
          V: 'Capital Appreciation',
          Z: 'Growth',
          Y: 'Re-invest',
          N: 'Payout',
          EC: 'Standing Instructions',
          OTM: 'OTM (One Time Mandate)',
          //DEBIT: 'Debit Card',
          RTGS: 'NEFT/RTGS',
          NETBANKING: 'Net Banking',
          HDFC: 'HDFC Fund Transfer',
          UPI: 'IMPS/UPI',
          FREQ: {
            DZ: 'Daily',
            OW: 'Weekly',
            OM: 'Monthly',
            Q: 'Quarterly',
            H: 'Half Yearly',
            Y: 'Yearly'
          },
          WEEK_DAYS: {
            '2': 'Monday',
            '3': 'Tuesday',
            '4': 'Wednesday',
            '5': 'Thursday',
            '6': 'Friday'
          }
        }
      },
      INVESTMENT_OPTIONS: {
        GROWTH: 'GROWTH',
        DIVIDEND: 'DIVIDEND'
      },
      DIVIDEND_OPTIONS: {
        GROWTH: 'Z',
        REINVEST: 'Y',
        PAYOUT: 'N'
      },
      EUIN_OPTED:{
        'YES': 'Y',
        'NO': 'N'
      },
      NEW_INVESTOR_JOURNY: [
        { "name": "Monthly","code": "OM","duration": 1 },
        { "name": "Quarterly","code": "Q","duration": 3},
        { "name": "Half Yearly","code": "H","duration": 6},
        { "name": "Yearly","code": "Y", "duration": 12 }
      ],
      TRANSACTION_FORM_TYPE: {
        STP: 'STP',
        SIP: 'SIP',
        PURCHASE: 'PURCHASE',
        SWITCH: 'SWITCH',
        REDEMPTION: 'REDEMPTION',
        SWP: 'SWP'
      },
      AGENT_TR_TYPE: {
        SIP: 'SIP',
        PURCHASE: 'PURCHASE',
        SWITCH: 'SWITCH',
        REDEMPTION: 'REDEMPTION',
        SWP: 'SWP',
        DTP: 'DTP',
        STP: 'STP',
        STPSWING: 'STPSWING',
        STPFLEX: 'STPFLEX',
        FLEXINDEX: 'FLEXINDEX'
      },
      WIDGETS_ID: {
        // SNAPSHOT: "18116620-b616-11e6-80f5-76304dec7eb7", SNAPSHOT_NAME: 'Transactions Snapshot', SNAPSHOT_ORDER: 1,
        // TODO: "493616ec-b6d4-11e6-80f5-76304dec7eb7", TODO_NAME: 'To Do List', TODO_ORDER: 2,
        // ASSETS: "1af23b20-b6d5-11e6-80f5-76304dec7eb7", ASSETS_NAME: 'Total AUM', ASSETS_ORDER: 3,
        // MARKET: "3a9da34c-b6d5-11e6-80f5-76304dec7eb7", MARKET_NAME: 'Live Market Trends', MARKET_ORDER: 4,
        // LEADS: "8b8eb03e-b6d5-11e6-80f5-76304dec7eb7", LEADS_NAME: 'Lead Management', LEADS_ORDER: 5,
        // INVESTORS: "fa09326e-b6d5-11e6-80f5-76304dec7eb7", INVESTORS_NAME: 'Investment Overview', INVESTORS_ORDER: 6,
        // DIGITAL: "cb98ed42-4240-4925-b67a-88bbd9456b66", DIGITAL_NAME: 'Digital Marketing Campaign', DIGITAL_ORDER: 7,
        // KEYINVESTORLIST: "cb98ed42-4240-4925-b67a-88bbd9456b77", KEY_INVESTOR_NAME: 'Key Investor List', KEY_INVESTOR_ORDER: 8
        AUM: '6a965617-9dc7-4816-8686-62b476383d36', AUM_NAME: 'AUM Overview',
        BANNER: 'e138d420-d8d6-41c3-b24b-467ce9cf6489', BANNER_NAME: 'Banner',
        INVESTMENT_OVERVIEW: '4142d3f1-c861-4542-a8a8-fbc3505da60b', INVESTMENT_OVERVIEW_NAME: 'Investment Overview',
        KNOWLEDGE_CENTER: 'c3cf75a6-7c9e-4928-a369-c0aed66958bc', KNOWLEDGE_CENTER_NAME: 'Knowledge Center',
        EUIN_DETAILS: '1691c6fc-0bc5-4406-a2c7-dda8c5f05257', EUIN_DETAILS_NAME: 'Euin Details',
        SIP_OVERVIEW: '9f230e22-90bc-4bae-93d3-13556dfb1cd9', SIP_OVERVIEW_NAME: 'Sip Overview',
        TRANSACTION_SNAPSHOT: 'd48cb42b-6a52-45ea-9116-1ed952feda39', TRANSACTION_SNAPSHOT_NAME: 'Transaction Snapshot',
        QUICK_LINKS: '57bffc2a-bb06-4c31-947c-ee90600071b0', QUICK_LINKS_NAME: 'Quick Links',
        ALERT_AND_UPDATES: '950bdc79-2a7d-4bd0-ab02-e2ca0d1a97af', ALERT_AND_UPDATES_NAME: 'Alert & Updates',
        CONNEKT: '15a0b5a7-5090-417f-95ff-45e973465167', CONNEKT_NAME: 'Connekt',
        FUND_IN_FOCUS: 'b75e0c34-a603-429a-9ff0-4595fb8e0157', FUND_IN_FOCUS_NAME: 'Fund in focus',
        TO_DO: '163c2da7-045f-4448-bfb1-6d075858315e', TO_DO_NAME: 'To Do',
        QUICK_SIP : '540d9fcb-bd94-4e61-803e-f5eea4d43374',
      },
      REMIND_SUCCESS_MESSAGE: 'Remind notification has been sent successfully.',
      INVESTOR_PROFILE_OTHER_ACTIONS: [
        {key: 'capitalGainStatement', value: 'Capital Gain'},
        {key: 'exitLoadStatement', value: 'Exit Load'},
        {key: 'accountStatement', value: 'Account Statement'}
      ],
      SCHEME_ENDING_TYPES: {
        OPEN: 'OPEN',
        CLOSED: 'CLOSED'
      },
      DASHBOARD_TRANSACTION_TYPES : {
        CANCELLED:'Cancelled',
        CEASED:'Ceased',
        EXPIRED:'Expired',
        INSTALLMENTMISSED:'Installment Missed',
        SIP:'SIP',
        ACTIVE: 'Active'
      },
      RUNNING_MODE:{
        MAINTENANCE:'maintenance',
        UP:'up'
      },
      DOWNLOAD_TYPES: {
        PDF: 'pdf',
        EXCEl: 'xls'
      },
      IDENTIFIER:'+TgK8UUnAebCkA==',
      INSTA_IDENTIFIER: '+RsM2BBmBrcZrX##',
      CONFIG_ENDPOINT:'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCl/LnL+gw7c01DtzVmJxb8mr6b4VTQhsEPLWRV4LaUZrxonqP3w+aKuxfLtLpXSQ7xETQyW2Vea+8Zr7G9GbszguwafVxj0g0bXewhdCvKM/N2FjJa7d9KQaQRrXxgVsqBjux/xxaaoa8gokDCiXX1sNJt/qBzwLknW6vBdEo1wwIDAQAB',
      COOKIE_CONFIG: {
        path: "",
        secure: true
      },
      CAPTCHA_PUB_KEY:'6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX',
      SELF_DECLARATION_ACTION:'selfDeclarePendingAction',
      MAINTENANCE_CONTENT_URL:"https://cms.hdfcfund.com/en/hdfc/api/v1/maintenancePage/dp",
      FILE: {
        NO_FILE_CHOOSEN: "No File Choosen"
      },
      KYC_STATUS: {
        IN_PROGRESS: "IN_PROGRESS",
        VERIFIED: "VERIFIED",
        NOT_VERIFIED: "NOT_VERIFIED",
        INCOMPLETE: "INCOMPLETE",
        REJECTED: "REJECTED",
        ON_HOLD: "HOLD",
        SUSPENDED: "SUSPENDED",
        NOT_VALIDATED: "NOT_VALIDATED"
      },
      META_TAGS: {
        LOGIN_DESCRIPTION: "Register and Login easily to HDFC Mutual Fund distributor desk. Being an MF Online Partner you get benefits such as paperless transactions, managing and growing customers online, business reports and effective sales tools to accelerate your business.",
        LOGIN_TITLE: "Welcome to HDFC Mutual Fund - MF Online Partners - Distributor Desk",
        KEYWORDS: "hdfc mutual fund distributor login, hdfc distributor login, hdfc mf partner login, hdfc distributor, hdfc partner portal"
      },
      RAZORPAY_CRADENTIALS: {
        'merchantLogoUrl': 'https://investor.hdfcfund.com/mfonline/images/logo.gif'
      },
      NAV_APPLICABILITY_MESSAGE: "Approved text needs to be added on the Banner",
      NAV_APPLICABILITY_NOTE: "For purchase /switch-in request received within cut-off time on a Business Day, irrespective of the amount, the below NAV shall apply:" +
        "<div>For all Scheme(s) except liquid funds - NAV of the day on which the funds are available for utilization.</div>" +
        "<div>For liquid funds - NAV of the day prior to the Business Day on which the funds are available for utilization.</div>" +
        "For more information <a href='https://www.hdfcfund.com/information/uniform-nav-applicability' target='_blank' class='faq-link'>click here</a>.",
      OVERSEA_ARN_REGEX: /^[SD|OD].[0-9]{1,10}$/,
      BULK_ALL_TRANSACTION_INVALID: "All the transactions are invalid. Please check the records and try again with new transaction.",
      RESEND_OTP_COUNTER: 60, //applicable for only HMF-11260 list shared
      SWAP_NOTE: " It takes 10 working days for the cancellation to be effective. Thus, if a SMART SWAP is due within 10 working days from the date of cancellation, that transaction will be processed.",
      SIP_RENEW_STATUS: [
        {key: 'Proposed', value: 'Proposed'},
        {key: 'Rejected', value: 'Rejected'},
        {key: 'Expired', value: 'Expired'},
        {key: 'Processed', value: 'Processed'}
      ],
      VIEW_LATER_SUCCESS: "View Later request submitted successfully.",
      SIP_WITH_FI: {
        SUGGESTED_AMOUNT: [5000, 10000, 15000],
        PAYMENT_MODE: [
          {key: 'OTM', value: 'OTM(One Time Mandate)'},
          {key: 'WEB', value: 'Net Banking'}
        ]
      },
      RTGS_MESSAGE: "Have you transferred funds from registered bank account:",
      TPV_NOTES: [
        { note: "IFSC update may take time to reflect in your bank details", id: 'tpv_note_ifsc'} ,
        { note: "Your transaction shall be validated at RTA, whereby, if your name in bank account used for payment and name in folio does not match and RTA is unable to verify due to lack of proof submission, allotment of units will be delayed/withheld/transaction will be considered as NIGO. Units allotted if any, will be refunded in case if AMC / RTA could not verify the source of funds proof for the said transaction, as mandated by SEBI vide its circular dated: 04-Oct-2021.",
          id : 'tpv_note_message'
        }
      ],

      TRAN_TYPE_FOR_2FA : {
        SIP: 'SIP',
        PURCHASE: 'PURCHASE',
        STP: 'STP',
        SWITCH: 'SWITCH',
        REDEMPTION: 'REDEMPTION',
        SWP: 'SWP',
        SMART_SWAP : 'SMART_SWAP',
        STP_FLEX : 'STPFLEX',
        STP_SWING: 'STPSWING',
        SIP_TOPUP: 'SIP_TOPUP',
        E_CART: 'E_CART',
        COBM: 'COBM',
        DTP: 'DTP'
      },
      NRI_STATUS_CODES: ['11','21','24','26','28','42','27'],
      Bank_Statement:"Name, Debit Bank Account No. and UTR number should be visible on the Bank Statement. Max file size should be less than or equal to 3 MB. File format/extension should be tiff, tif, pdf, jpg and jpeg.",
      FEEDBACK_FORM_ERR0R: " Message should not contain special characters - # , $ , % , ^ , + , \\ , = , ; , | , <> , / ",
      INVESTOR_LIST_FILTER: {
        FILTER_LIST: [
          {name: 'Eligibility', key: 'ELIGIBILITY', active: true, error:false},
          {name: 'Investor Type', key: 'INVESTOR_TYPE', active: false, error:false},
          {name: 'OTM Registered', key: 'OTM_REGISTERED', active: false, error:false},
          {name: 'Current Holding', key: 'CURRENT_HOLDING', active: false, error:false},
          {name: "Systematic Investment's", key: 'SYSTEMATIC_INVESTMENT', active: false, error:false},
          {name: "Investor Activity", key: 'INVESTOR_ACTIVITY', active: false, error:false}
        ],
        ELIGIBILITY_FILTER: [
          {key: 'All', filterKey: 'ALL', value: "ALL"},
          {key: 'Eligible', filterKey: 'Eligible', value: "YES"},
          {key: 'Not Eligible', filterKey: 'Not Eligible', value: "NO"}
        ],
        INVESTOR_TYPE: [
          {key: 'All', filterKey: "All Investors", value: "ALL"},
          {key: 'Dormant', filterKey: "Dormant Investors", value: "DORMANT"},
          {key: 'Active', filterKey: "Active Investors", value: "ACTIVE"}
        ],
        INVESTOR_SUB_TYPE: [
          {key: 'CGF', filterKey: 'CGF Investors', value: "CGF"},
          {key: 'Minor', filterKey: 'Minor Investors', value: "MINOR"},
          {key: 'Others', filterKey: 'Other Investors', value: "OTHERS"}
        ],
        OTM_FILTER: [
          {key: 'All', filterKey: 'All', value: 'ALL'},
          {key: 'Yes', filterKey: 'Yes', value: 'AVAILABLE'},
          {key: 'No', filterKey: 'No', value: 'NOT_AVAILABLE'}
        ],
        CURRENT_HOLDING_FILTER: [
          {key: 'All', filterKey: 'All', value: 'ALL'},
          {key: 'Have Holding', filterKey: 'Have Holding', value: 'true'},
          {key: 'Have No Holding', filterKey: 'Have No Holding', value: 'false'}
        ],
        CURRENT_HOLDING_OPTIONS_FILTER: [
          {key: 'Growth', filterKey: 'Growth', identifier: 'growth', value: 'Z'},
          {key: 'IDCW Payout', filterKey: 'IDCW Payout', identifier: 'payout', value: 'N'},
          {key: 'IDCW Reinvest', filterKey: 'IDCW Reinvest', identifier: 'reInvest', value: 'Y'}
        ],
        SYSTEMATIC_PLAN_FILTER: [
          {key: 'All', filterKey: "All", value: 'ALL'},
          {key: 'Have An Active', filterKey: "Have An Active", value: 'true'},
          {key: 'Have No Active', filterKey: "Have No Active", value: 'false'}
        ],
        SYSTEMATIC_PLAN_TYPE: [
          {key: "All", filterKey: "All", value: "ALL"},
          {key: "SIP", filterKey: "SIP", value: "SIP"},
          {key: "Flex SIP", filterKey: "FLEX SIP", value: "FLEX SIP"},
          {key: "STP", filterKey: "STP", value: "STP"},
          {key: "SWP", filterKey: "SWP", value: "SWP"},
          {key: "Flex STP", filterKey: "Flex STP", value: "FLEX STP"},
          {key: "Flex Index", filterKey: "Flex Index", value: "FLEX INDEX"},
          {key: "TIP", filterKey: "TIP", value: "DTP"},
          {key: "SWING STP", filterKey: "SWING STP", value: "SWING STP"},
          {key: "SMART SWAP", filterKey: "SMART SWAP", value: "SMART SWAP"}
        ],
        SYSTEMATIC_PLAN_OPTIONS_FILTER: [
          {key: 'Growth', filterKey: "Growth", identifier: 'growth', value: 'Z'},
          {key: 'IDCW Payout', filterKey: "IDCW Payout", identifier: 'payout', value: 'N'},
          {key: 'IDCW Reinvest', filterKey: "IDCW Reinvest", identifier: 'reInvest', value: 'Y'}
        ],
        INVESTOR_ACTIVITY_FILTER: [
          {key: 'All', filterKey: "All", value: 'ALL'},
          {key: 'Have', filterKey: "Have", value: 'true'},
          {key: 'Have Not', filterKey: "Have Not", value: 'false'}
        ],
        INVESTOR_ACTIVITY_TYPE: [
          {key: "All", filterKey: "All", value: "ALL"},
          {key: "Purchase", filterKey: "Purchase", value: "PURCHASE"},
          {key: "Switch", filterKey: "Switch", value: "SWITCH"},
          {key: "Redemption", filterKey: " Redemption", value: "REDEMPTION"},
          {key: "SIP", filterKey: "SIP", value: "SIP"},
          {key: "Flex SIP", filterKey: "FLEX SIP", value: "FLEX SIP"},
          {key: "TIP", filterKey: "TIP", value: "DTP"},
          {key: "SWP", filterKey: "SWP", value: "SWP"},
          {key: "STP", filterKey: "STP", value: "STP"}
        ],
        INVESTOR_OPTIONS_FILTER: [
          {key: 'Growth', filterKey: "Growth", identifier: 'growth', value: 'Z'},
          {key: 'IDCW Payout', filterKey: "IDCW Payout", identifier: 'payout', value: 'N'},
          {key: 'IDCW Reinvest', filterKey: "IDCW Reinvest", identifier: 'reInvest', value: 'Y'}
        ],
        DURATION: [
          {key: "1 month", filterKey: "1 month", value: "MONTH1"},
          {key: "2 month", filterKey: "2 month", value: "MONTH2"},
          {key: "3 month", filterKey: "3 month", value: "MONTH3"},
          {key: "6 month", filterKey: "6 month", value: "MONTH6"},
          {key: "1 year", filterKey: "1 year", value: "YEAR1"},
          {key: "2 year", filterKey: "2 year", value: "YEAR2"},
          {key: "3 year", filterKey: "3 year", value: "YEAR3"},
          {key: "This financial year", filterKey: "This financial year", value: "CURRFINANCIALYEAR"}
        ]
      },
      SET_TOP_UP_PERCENTAGE_VIEW : false,
      FLEXSIP_NO_PAYMENT_MODE_ERROR : "OTM is mandatory to proceed with Flex SIP Transaction. There is no OTM in the Selected folio." ,
      SUGGESTED_AMOUNT_FLEX_SIP: [5000, 10000, 15000],
      FLEX_SIP_PAYMENT_MODES: {
        PAYMENT_MODES_NON_SIP_FI : [
          {key: 'OTM', value: 'OTM(One Time Mandate)'},
          {key: 'HEM', value: 'Register E-mandate (eOTM)'}
        ] ,
        PAYMENT_MODES_SIP_FI : [
          {key: 'OTM', value: 'OTM(One Time Mandate)'}
        ]
      },
      CONTINUE_WITH_SIP_MESSAGE : "Staying invested for long term helps you reap maximum benefits from your investments.",
      MOBILE_BELONGS_ERROR : 'Select Mobile No. Belongs To',
      EMAIL_BELONGS_ERROR : 'Select Email Belongs To',
      TAX_STATUS_NOMINEE : ['01','11','13','21','24'],
      EMANDATE_MAX_DURATION_YEARS: 99,
      UPDATE_CONTACT_ERROR_FILL : "Kindly add missing contact detail to proceed with folio creation.",
      UPDATE_CONTACT_ERROR_BOTH : "To proceed with Folio creation both contact details of investor are mandatory. Kindly update missing contact detail by getting in touch with our ISC or CAMS to update CKYC.",
      CART_DETAILS_SECTION: {
        CART_DETAILS: 'Cart Details',
        INVEST_THROUGH: 'Invest Through',
        ECART: 'E-Cart',
        ALL_FUNDS: 'All Funds',
        BROKER_THROUGH: 'Broker Type'
      },
      ALL_FUNDS_FILTER: [
        {
          filterName: "Fund Category", filterKey: 'fundCategory', filterOptions: [
            {key: 'Diversified Equity', value: 'Diversified Equity', checked: false},
            {key: 'Index', value: 'Index', checked: false},
            {key: 'Thematic/Sectoral Equity', value: 'Thematic/Sectoral Equity', checked: false},
            {key: 'Equity Linked Savings Scheme (ELSS)', value: 'Equity Linked Savings Scheme (ELSS)', checked: false},
            {key: 'Hybrid', value: 'Hybrid', checked: false},
            {key: 'Solution Oriented', value: 'Solution Oriented', checked: false},
            {key: 'Theme Based Debt', value: 'Theme Based Debt', checked: false},
            {key: 'Duration Based Debt', value: 'Duration Based Debt', checked: false},
            {key: 'ETF', value: 'ETF', checked: false},
            {key: 'Fund of Funds', value: 'Fund of Funds', checked: false}
          ]
        }, {
          filterName: "Time Horizon", filterKey: 'timeHorizon', filterOptions: [
            {key: 'Short Term (1 year)', value: 'Short Term (1 year)', checked: false},
            {key: 'Medium Term ( 1-3 year)', value: 'Medium Term ( 1-3 year)', checked: false},
            {key: 'Long Term (3 year +)', value: 'Long Term (3 year +)', checked: false}
          ]
        }, {
          filterName: "Goals", filterKey: 'goals', filterOptions: [
            {key: 'Wealth Creation', value: 'Wealth Creation', checked: false},
            {key: 'Tax Saving', value: 'Tax Saving', checked: false},
            {key: 'Children’s Fund', value: 'Children’s Fund', checked: false},
            {key: 'Retirement Planning', value: 'Retirement Planning', checked: false},
            {key: 'Income Solutions', value: 'Income Solutions', checked: false}
          ]
        }, {
          filterName: "Risk Rating", filterKey: 'riskReturnProfile', filterOptions: [
            {key: 'Low', value: 'Low risk', checked: false},
            {key: 'Low to Moderate', value: 'Low to Moderate', checked: false},
            {key: 'Moderate', value: 'Moderate', checked: false},
            {key: 'Moderate to High', value: 'Moderately high', checked: false},
            {key: 'High', value: 'High Risk', checked: false},
            {key: 'Very High', value: 'Very High', checked: false}
          ]
        }
      ],
      ECART_CART_ITEM_NUMBER : ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'],
      IDCW_OPTIONS: [
        {key: 'Re-investment', value: "Y"},
        {key: 'Payout', value: "N"}
      ],
      DISTRIBUTOR_SELECTION: {
        EXISTING_DISTRIBUTOR: "EXISTING",
        NEW_DISTRIBUTOR: "NEW",
        RELATIVELY_NEW_DISTRIBUTOR: "RELATIVELY_NEW",
      },
      ENABLE_EUIN: false,
      EMPANEL_TOKEN: '+EsM2BBmBrcZr88',
      NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR: "NEWLY_EMPANEL_AND_REGISTER_DISTRIBUTOR",
      INVESTMENT_OVERVIEW_DEFAULT_DATA : [
        {aumType: 'Equity', amount: 'NA'},
        {aumType: 'Liquid', amount: 'NA'},
        {aumType: 'Debt', amount: 'NA'}
      ],
      NO_INVESTER_ADDED_MSG: "No investors are added under your ARN. Do you wish to add investor?",
      HDFC_WITH_DIRECT_ARN: false,
      RISK_METER : [
        { key : "Low",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Low.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Low.png"
        },
        {
          key : "Low to Moderate",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderately+Low.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Low-Moderate.png"
        },
        {
          key : "Moderate",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderate.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Moderate.png"
        },
        {
          key : "Moderately High",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/Moderately+High.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Moderately-High.png"
        },
        {
          key : "High",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/high.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/High.png"
        },
        {
          key : "Very High",
          icon:"https://files.hdfcfund.com/CampaignImages/New+website+images+26122022/Riskometer/very+high.jpg",
          img:"https://files.hdfcfund.com/s3fs-public/new-website-images/Riskometer/Very-High.png"
        }
      ],
      TAX_STATUS_INDIVIDUAL: {
        RESIDENT_INDIVIDUAL: "Resident Individual ",
        NON_RESIDENT_INDIVIDUAL: "Non-Resident Individual"
      },
      Tax_STATUS_NOTE:{
        TAX_NOTE: "TAX STATUS field cannot be edited. To make changes remove the holder details and re-add the investor with correct tax status"
      },
      MINOR_NRI_STATUS_CODES: ['21','11','02','24','28','26','27','42'],
    });
})();

(function() {
  'use strict';
  angular
    .module('hdfc-mf-distributor-web')
    .config(config)
    .config(tooltipConfig);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 9000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  /** @ngInject */
  function tooltipConfig(tooltipsConfProvider) {
    tooltipsConfProvider.configure({
      'smart':true,
      'size':'large',
      'speed': 'slow',
      'tooltipTemplateUrlCache': true
    });
  }
})();

angular.module("hdfc-mf-distributor-web").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.html","<header class=\"container-fluid common affix admin-header\"><div class=pull-left><span class=\"logo cursor-pointer\"><img src=../../../assets/images/logo-main.png></span><p class=black-bg>MF Online Admin</p></div><div class=\"pull-right right-panel\"><p>Welcome<br>VishwaJeet</p><span class=user-card><span class=user-small-pic><img ng-src={{Header.profilePhotoUrl}}></span></span><p class=logout><a href=\"\"><i class=power-icon></i>Logout</a></p></div></header><div class=\"admin main-section\"><div class=container-fluid><div class=col-md-2><aside class=side-nav><ul class=list-group><li ng-class=\"{\'active-link\':Sidebar.active[5]}\" ng-click=Sidebar.activateTab(5) ui-sref=main.leapacademy.training-classes><span class=\"leap-sidebar-icon default-icon\"></span> <span class=nav-link>Leap Academy</span></li><li ng-class=\"{\'active-link\':Sidebar.active[6]}\" ng-click=Sidebar.activateTab(6)><span class=\"lead-sidebar-icon default-icon\"></span> <span class=nav-link>Notifications</span></li></ul></aside></div><div class=\"col-md-10 tab-section\"><h3>Leap Academy</h3><ul class=\"list-inline admin-tabs\"><li><a href=#training-class-data class=active>Training Class</a></li><li><a href=#>PDF Articles</a></li></ul><div id=training-class-data><form autocomplete=off method=post><div class=row><div class=col-md-12><div class=col-md-6><div class=\"input-select input-normal\"><input type=text name=className ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCity required capitalize=\"\" class=\"ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched\" aria-invalid=true> <span class=highlight></span> <span class=bar></span><label>Name of The Class</label></div></div><div class=col-md-6><div class=\"input-select input-normal\"><input type=text name=ownersName ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCity required capitalize=\"\" class=\"ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched\" aria-invalid=true> <span class=highlight></span> <span class=bar></span><label>Class Owner\'s Name</label></div></div></div></div><div class=row><div class=col-md-12><div class=col-md-3><div class=\"input-select selectfield input-normal selectfield\"><label>Start Time</label><select class=\"browser-default custom-select\" name=startTime><option value=\"\" selected>Hh : Mm</option><option label=\"FOREIGN NATIONAL RESIDENT IN INDIA\" value=string:35>FOREIGN NATIONAL RESIDENT IN INDIA</option></select></div></div><div class=col-md-3><div class=\"input-select selectfield input-normal selectfield\"><label>End Time</label><select class=\"browser-default custom-select\" name=startTime><option value=\"\" selected>Hh : Mm</option><option label=\"FOREIGN NATIONAL RESIDENT IN INDIA\" value=string:35>FOREIGN NATIONAL RESIDENT IN INDIA</option></select></div></div><div class=col-md-6><div class=\"input-normal ng-scope mg8\"><input type=text name=Date date-calendar=\"\" format=DD-MMM-YYYY> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label>Date (dd/mm/yyyy)</label></div></div></div></div><div class=row><div class=col-md-12><div class=col-md-5><div class=\"input-select input-normal\"><input type=text name=birthCity class=\"ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched\" aria-invalid=true> <span class=highlight></span> <span class=bar></span> <i class=search-icon></i><label>Location</label></div></div></div></div><div class=row><div class=\"col-md-12 upload-thumbnail\"><a href=\"\" class=text-blue><strong>+ Upload Class Thumbnail <span><small>(Optional)</small></span></strong></a></div></div><hr><div class=row><div class=col-md-12><div class=\"form-footer form-content\"><button class=\"btn btn-negative-action\" ng-click=AppDetails.cancelTransaction()>Reset</button> <button class=\"btn btn-primary-action\" ng-disabled=\"AppDetails.soleApplicantForm.$invalid\n              ||(!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate &amp;&amp; !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\" disabled>Submit</button></div></div></div></form></div></div><div class=\"col-md-10 tab-section\"><h3>Notifications</h3><div><form autocomplete=off method=post><div class=row><div class=col-md-12><textarea rows=4 cols=100></textarea></div></div><hr><div class=row><div class=col-md-12><div class=\"form-footer form-content\"><button class=\"btn btn-primary-action\" disabled>Send</button></div></div></div></form></div></div></div><!--<div class=\"container-fluid\">\n      <div class=\"common not-mobile\" ng-init=\"Sidebar.initTab()\">\n          <aside class=\"affix side-nav\">\n              <ul class=\"list-group\">\n                  <li ng-class=\"{\'active-link\':Sidebar.active[5]}\" ng-click=\"Sidebar.activateTab(5)\" ui-sref=\"main.leapacademy.training-classes\">\n                      <span class=\"leap-sidebar-icon default-icon\"></span>\n                      <span class=\"leap-sidebar-active-icon active-icon\"></span>\n                      <span class=\"nav-link\">Leap Academy</span>\n                  </li>\n                  <li ng-class=\"{\'active-link\':Sidebar.active[6]}\" ng-click=\"Sidebar.activateTab(6)\">\n                      <span class=\"lead-sidebar-icon default-icon\"></span>\n                      <span class=\"lead-sidebar-active-icon active-icon\"></span>\n                      <span class=\"nav-link\">Lead Management</span>\n                  </li>\n              </ul>\n          </aside>\n      </div>\n      <div class=\"admin-content\">\n          <h3>Leap Academy</h3>\n      </div>\n  </div>--></div>");
$templateCache.put("app/agent/agent.html","<agent-header ng-if=\"$state.current.name!=\'agent.login\' && $state.current.name!=\'agent.changePassword\'\"></agent-header><agent-sidebar ng-if=\"($state.current.name!=\'agent.rollover\' || $state.current.name!=\'agent.rolloverView\')\n && $state.current.name!=\'agent.home.superadmin\' && $state.current.name!=\'agent.home.createUser\' && $state.current.name != \'agent.login\'\"></agent-sidebar><ui-view></ui-view><div ng-include=\"\'app/agent/components/footer/footer.html\'\"></div>");
$templateCache.put("app/arn-hardcoded/arn-hardcoded-new.html","<one-click-header class=one-click-header is-hide-footer=ArnHardcoded.hideFooter is-from-hdfc-one-click=ArnHardcoded.onlyHdfcUserOneClick></one-click-header><section class=arn-hardcoded-main id=oneClickMainpage><div class=heading><h3><span>One Click</span> Facility</h3></div><div class=form-container><div class=row><div class=col-md-12><div id=bannerCarousel class=\"carousel slide\" data-ride=carousel><ol class=carousel-indicators><li data-target=#bannerCarousel ng-repeat=\"image in ArnHardcoded.imageUrls\" data-slide-to={{$index}} ng-class=\"{\'active\': $first}\"></li></ol><!-- Wrapper for slides --><div class=carousel-inner><div class=\"item height100\" ng-repeat=\"image in ArnHardcoded.imageUrls\" ng-class=\"{\'active\': $first}\"><img src={{image}} ng-if=!image.url></div></div></div></div></div><div class=form-section><form autocomplete=off name=arnhardcodedform novalidate><!-- Radio nav --><div class=\"form-group form-group-main\"><div class=radio-selection-section><div class=row ng-hide=ArnHardcoded.hardcodedArn><label class=form-label>Broker Type</label><div class=radio-block style=\"margin-right: 30px\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.linkType name=linkType id=mfd ng-change=ArnHardcoded.resetValue() value=MFD> <span class=check></span></span><label for=mfd>MFD</label></div><div class=radio-block style=\"margin-right: 30px\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.linkType name=linkType id=ria ng-change=\"ArnHardcoded.resetValue(\'RIA\')\" value=RIA> <span class=check></span></span><label for=ria>RIA</label></div><!-- <div  ng-hide=\"ArnHardcoded.hardcodedArn\">\n                <input type=\"radio\" ng-model=\"ArnHardcoded.form.linkType\" name=\"linkType\" id=\"rm\" value=\"RM\">\n                <label for=\"rm\" ng-click=\"ArnHardcoded.resetValue()\">RM</label>\n              </div> --></div></div></div><!-- MFD --><div class=\"form-group form-group-main\" ng-if=\"ArnHardcoded.form.linkType == \'MFD\'\" ng-class=\"{error:ArnHardcoded.form.arn.$dirty && ArnHardcoded.form.arn.$invalid && ArnHardcoded.form.arn.$touched}\"><div class=\"form-input-section row\" ng-hide=ArnHardcoded.restrictARN><div class=\"col-md-3 set-full-width-responsive-tablet\"><label class=form-label>Enter Broker Code<span class=\"req text-red\">*</span></label></div><div class=\"col-md-4 col-xs-12\"><div><div ng-class=\"{\'anything-disabled\':ArnHardcoded.hardcodedArn == true}\"><div class=form-text><input class=\"set-input-padding-arn-rupee input-field field-arn\" type=text id=arn name=arn ng-model=ArnHardcoded.form.arn maxlength=6 minlength=4 ng-blur=ArnHardcoded.authARN() style=\"border: none; font-size: 18px\" ng-change=ArnHardcoded.arnChanged()><label for=arn class=static-value>ARN</label></div></div><!-- <div ng-if=\"ArnHardcoded.distributorName\">\n                  <p class=\"arn-name\">Distributor Name - {{ArnHardcoded.distributorName}}</p>\n                </div> --></div></div></div><div class=\"form-input-section row\" ng-if=!ArnHardcoded.hdfcOneClick><div class=\"col-md-4 set-full-width-responsive-tablet\"><label class=form-label>Sub Broker ARN</label></div><div class=\"col-md-4 col-xs-12 sub-broker\"><div ng-if=ArnHardcoded.ShowSubBrokerArn><div ng-class=\"{\'anything-disabled\': !ArnHardcoded.form.arn}\" ng-class={error:(arnhardcodedform.subBrokerARN.$dirty&&arnhardcodedform.subBrokerARN.$invalid)}><div class=form-text><input type=text class=\"subBrokerArn set-input-padding-arn-rupee input-field field-arn\" name=subBrokerARN id=subBrokerARN ng-model=ArnHardcoded.subBrokerARN ng-change=ArnHardcoded.changeSubBrokerArn() ng-blur=ArnHardcoded.fetchEuinListSubBroker() ng-required=\"ArnHardcoded.subBrokerName && ArnHardcoded.distributorName \" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false><label for=arn class=static-value>ARN</label></div><span class=highlight></span> <span class=bar></span> <span class=error-input style=\"position: absolute\" ng-if=\"arnhardcodedform.subBrokerARN.$dirty && arnhardcodedform.subBrokerARN.$error.pattern\" style=\"left: 15px;padding: 2px 0px 0px 0px\">Enter valid Sub Broker ARN</span></div><div ng-if=ArnHardcoded.subBrokerName style=\"margin-top: 10px;position:absolute\"><p class=sub-broker>Sub Broker Name : {{ArnHardcoded.subBrokerName}}</p></div></div></div><div class=\"col-md-4 col-xs-12 sub-broker-code\"><div ng-class=\"{error:arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$invalid , \'anything-disabled\': !ArnHardcoded.subBrokerARN}\"><input class=\"input-field set-input-padding\" type=text class=subBrokerCode name=subBrokerCode id=subBrokerCode ng-model=ArnHardcoded.subBrokerCode autocomplete=off ng-blur=ArnHardcoded.validation() ng-disabled=!ArnHardcoded.subBrokerARN ng-required=ArnHardcoded.subBrokerARN restrict-special-charcter ng-trim=false placeholder=\"Sub Broker Code\"> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$error.required ng-bind=arnhardcodedform.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=\"radio-selection-section radio-inputs euin-section\" ng-hide=ArnHardcoded.restrictARN style=height:120px><!-- Radio nav euin--><div class=row style=\"padding-left: 0px\"><div class=col-md-2><div class=radio-block style=\"width: 137px\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.euinSelected name=euin id=euinSelected ng-change=ArnHardcoded.changedEuinDeclaration() value=true> <span class=check></span></span><label for=mfd>Enter EUIN</label></div></div><div class=col-md-2><div class=radio-block style=\"margin-right: 0px\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.euinSelected name=euin id=euinDeclaration ng-change=ArnHardcoded.changedEuinDeclaration() value=false> <span class=check></span></span><label id=declaration for=ria>EUIN Declaration<!--<span ng-if=\"ArnHardcoded.showGreenTick\" class=\"green-tick\"></span>--></label></div></div><div class=\"radio-block col-md-4 col-xs-12 euin-selection\" ng-if=\"ArnHardcoded.form.euinSelected === \'true\'\"><div class=\"input-select input-normal\" style=\"text-transform: uppercase\" ng-class=\"{error:ArnHardcoded.form.euin.$dirty && ArnHardcoded.form.euin.$invalid}\"><div class=form-text><input type=text class=\"arnInput dropdownTrigger subBrokerArn euinPadding input-field field-arn\" name=euin id=euindropdown ng-change=ArnHardcoded.filterEuinList() tabindex=5 ng-model=ArnHardcoded.form.euin.euinCode ng-pattern=/^[0-9]+$/ autocomplete=off><p for=arn class=euin-prefix>E</p></div><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"(ArnHardcoded.form.euin.$dirty && ArnHardcoded.form.euin.$error.required)\" ng-bind=ArnHardcoded.VALIDATE_DATA.EUIN_REQUIRED></span><!-- <drop-down\n                    class=\"dropDwn\"\n                    list-data=\"ArnHardcoded.euinList\"\n                    display-key=\"euinName\"\n                    display-key-second=\"euinCode\"\n                    hdfc-click=\"ArnHardcoded.selectEuin(data)\"\n                    model=\"ArnHardcoded.form.euin\"\n                    for=\"euindropdown\">\n                  </drop-down> --></div><span class=error-input ng-show=\"arnhardcodedform.euin.$dirty && arnhardcodedform.euin.$error.pattern\" style=\"margin-top: 8px\">Only Number Value allowed</span></div></div></div></div><!-- RIA --><div class=\"form-group form-group-main\" ng-if=\"ArnHardcoded.form.linkType == \'RIA\'\"><div class=\"form-input-section row\"><div class=\"col-md-3 set-full-width-responsive-tablet\"><label class=form-label>Enter RIA Code<span class=\"req text-red\">*</span></label></div><div class=\"col-md-4 col-xs-12\"><div><div class=ria-input-field><div><input type=text name=riaCode class=\"input-field set-input-padding\" ng-model=ArnHardcoded.form.ria autocomplete=off maxlength=12 ng-blur=ArnHardcoded.callRIA() ng-pattern=/^[A-Z0-9]{12}/ ng-required=!ArnHardcoded.form.ria ng-change=ArnHardcoded.validation() capitalize required placeholder=\"RIA Code\"><!--                    <label for=\"arn\" class=\"static-value\">INA</label>--></div></div><div style=\"margin-top: 10px\"><span class=error-input ng-show=\"(arnhardcodedform.ria.$dirty && arnhardcodedform.ria.$invalid &&arnhardcodedform.riaCode.$error.required)\" ng-bind=ArnHardcoded.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(arnhardcodedform.$dirty && arnhardcodedform.ria.$invalid &&arnhardcodedform.ria.$error.pattern)\" ng-bind=ArnHardcoded.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"ArnHardcoded.riaCodeError !== \'\' && !arnhardcodedform.ria.$invalid\" ng-bind=ArnHardcoded.riaCodeError></span></div></div></div></div><div class=\"form-input-section row\"><div class=\"col-md-3 set-full-width-responsive-tablet hide-formobile\"><label class=form-label><span class=\"req text-red\"></span></label></div><div class=\"col-md-4 col-xs-12\"><div><div><div class=form-text ng-class=\"{\'anything-disabled\': !ArnHardcoded.form.riaName}\"><input type=text name=rianame class=\"set-input-padding-arn-rupee input-field field-arn remove-padding-RIA\" ng-model=ArnHardcoded.form.riaName ng-disabled=true placeholder=\"RIA Name\"></div></div></div></div></div><!--<div class=\"euinDecCheck row\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                  <span class=\"checkbox\">\n                    <div class=\"checkDec\">\n                      <input type=\"checkbox\" ng-model=\"ArnHardcoded.selfEuin\" name=\"selfEuin\"/>\n                      <span class=\"icon-checkbox\"></span>\n                      <span class=\"checkbox-text\" href=\"javaScript:void(0)\">I/We hereby consent for providing transactions data feed, portfolio readings, NAV, etc in respect of my/our transactions under Direct Plan to the Registered Investment Advisor (RIA) recorded against the transaction, if applicable. </span>\n                    </div>\n                  </span>\n              </div>\n            </div>\n          </div>--></div><!-- UTM --><div class=\"form-input-section row\" ng-if=ArnHardcoded.hdfcOneClick><div class=\"col-md-3 set-full-width-responsive-tablet\"><label class=form-label>UTM</label></div><div class=\"col-md-4 col-xs-12 scheme-selection\"><div class=\"input-select input-normal\"><input type=text class=\"arnInput input-field\" name=utmsource id=utmsource ng-change=\"\" ng-model=ArnHardcoded.form.utmsource onpaste=\"return false\" ondrop=\"return false\" autocomplete=off placeholder=\"UTM Source (Optional)\"></div></div><div class=\"col-md-4 col-xs-12 scheme-selection\"><div class=\"input-select input-normal\"><input type=text class=\"arnInput input-field\" name=utmmedium id=utmmedium ng-change=\"\" ng-model=ArnHardcoded.form.utmmedium onpaste=\"return false\" ondrop=\"return false\" autocomplete=off placeholder=\"UTM Medium (Optional)\"></div></div></div><div class=\"form-group form-group-main\" ng-if=\"ArnHardcoded.form.arn || ArnHardcoded.form.riaName || ArnHardcoded.form.employeeCode\" style=\"padding-top: 15px\"><!-- Radio nav Transaction--><div class=row><div class=col-md-3><label class=tTitle>Transaction Type</label></div><div class=col-md-9><div class=\"radio-selection-section radio-inputs tncType radioButtonsGrid\"><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.investmentType(\'PURCHASE\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=purchase value=PURCHASE> <span class=check></span></span><label for=mfd>Purchase</label></div><div class=radio-block><span class=radio><input type=radio type=radio ng-change=\"ArnHardcoded.investmentType(\'SIP\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=sip value=SIP> <span class=check></span></span><label for=ria>SIP</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.investmentType(\'SWITCH\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=switch value=SWITCH> <span class=check></span></span><label for=mfd>Switch</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.investmentType(\'REDEMPTION\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=REDEMPTION value=REDEMPTION> <span class=check></span></span><label for=mfd>Redemption</label></div><div class=radio-block ng-if=ArnHardcoded.hdfcOneClick><span class=radio><input type=radio ng-change=\"ArnHardcoded.investmentType(\'PURCHASE SCHEDULER\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=PURCHASE_SCHEDULER value=\"PURCHASE SCHEDULER\"> <span class=check></span></span><label for=PURCHASE_SCHEDULER>Scheduled Purchase</label></div></div></div></div><!-- select scheme --><div class=\"form-input-section row select-scheme\"><div ng-if=\"ArnHardcoded.form.transactionType !== \'SWITCH\'\" class=\"col-md-3 set-full-width-responsive-tablet\"><label class=form-label>Select Scheme</label></div><div ng-if=\"ArnHardcoded.form.transactionType === \'SWITCH\'\" class=\"col-md-4 set-full-width-responsive-tablet\"><label class=form-label>Select Switch In Scheme</label></div><div class=\"col-md-4 col-xs-12 scheme-selection\"><div class=\"input-select input-normal\" ng-class={error:arnhardcodedform.pInScheme1.$invalid}><input type=text class=\"arnInput shcemeInputBox\" name=pInScheme1 id=pInScheme1 ng-change=ArnHardcoded.filterInSchemeList() ng-model=ArnHardcoded.form.InSchemeName tabindex=2 onpaste=\"return false\" ondrop=\"return false\" ng-click=ArnHardcoded.hideSchemeDropDown() autocomplete=off capitalize placeholder=\"Enter scheme name\"> <span class=error-input ng-show=ArnHardcoded.arnhardcodedform.pInScheme1.$error.required ng-bind=ArnHardcoded.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=ArnHardcoded.SchemeList class=dropDwn display-key=scheme hdfc-click=ArnHardcoded.InSchemeChanged(data) ng-model=ArnHardcoded.form.InSchemeCode for=pInScheme1></drop-down></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"schemeModal input-field set-input-padding cursor-pointer\" ng-click=ArnHardcoded.schemeListModal() ng-if=\"ArnHardcoded.form.transactionType != \'PURCHASE SCHEDULER\' \"><i class=list-icon></i> {{ArnHardcoded.onlyHdfcUserOneClick ? \'View All Schemes\': \'Select from List\'}}</div><div class=\"schemeModal input-field set-input-padding cursor-pointer\" ng-click=ArnHardcoded.schemeListModal() ng-if=\"ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\'\"><i class=list-icon></i>View All Schemes</div></div></div><!-- select dividend option --><div class=\"radio-selection-section dividend-radio\" ng-if=\"ArnHardcoded.form.InSchemeName && ArnHardcoded.form.InvestmentOption === ArnHardcoded.TRANSACTIONS_CONST.DIVIDEND\"><div class=row><div class=radio-block ng-class=\"{\'anything-disabled\': ArnHardcoded.purchaseValidations.dividendReinvestmentApplicable === false}\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.DividendOption name=pDividendOption id=pDividendOptionY ng-value=ArnHardcoded.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"ArnHardcoded.purchaseValidations.dividendReinvestmentApplicable === false\"> <span class=check></span></span><label for=mfd>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=radio-block ng-class=\"{\'anything-disabled\': ArnHardcoded.purchaseValidations.dividendPayoutApplicable === false}\"><span class=radio><input type=radio ng-model=ArnHardcoded.form.DividendOption name=pDividendOption id=pDividendOptionN ng-value=ArnHardcoded.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"ArnHardcoded.purchaseValidations.dividendPayoutApplicable === false\"> <span class=check></span></span><label for=mfd>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div><!-- Installment Frequency --><div class=\"radio-selection-section radio-inputs radio-frequency\" ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' && ArnHardcoded.form.InSchemeName\"><div class=row><label class=\"form-label label-tncType\">Select Frequency</label><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'BZ\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=BZ value=BZ> <span class=check></span></span><label for=BZ>Daily</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'OW\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=OW value=OW> <span class=check></span></span><label for=OW>Weekly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'OM\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=OM value=OM> <span class=check></span></span><label for=OM>Monthly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'Q\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=Q value=Q> <span class=check></span></span><label for=Q>Quarterly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'H\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=H value=H> <span class=check></span></span><label for=H>Half Yearly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'Y\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=Y value=Y> <span class=check></span></span><label for=Y>Yearly</label></div></div></div><!-- amount --><div ng-if=\"ArnHardcoded.form.InSchemeName && ArnHardcoded.form.transactionType !== \'SWITCH\' && ArnHardcoded.form.InSchemeCode && ArnHardcoded.form.transactionType !== \'REDEMPTION\'\" class=\"form-input-section row amount-container\"><div class=\"col-md-3 set-full-width-responsive-tablet\"><label class=form-label>Amount</label></div><div class=\"col-md-4 col-xs-12\"><div class=form-text><input style=\"padding-left: 50px\" type=text class=\"arnInput set-input-padding-arn-rupee input-field\" name=amount id=amount ng-model=ArnHardcoded.form.displayAmount ng-change=ArnHardcoded.setAmount(ArnHardcoded.form.displayAmount) ng-blur=ArnHardcoded.checkAmountValidation() maxlength=15 onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\" autocomplete=off restrict-special-charcter ignore-mouse-wheel ng-trim=false><label for=amount class=static-value>₹</label></div><div ng-if=\"ArnHardcoded.form.amount !== 0\" class=amt-words ng-class=\"{\'marginTop\':ArnHardcoded.amountExceeded}\"><span>Amount in words : </span><span id=DisplayWordsTaxAmount></span></div></div><div class=col-md-4><div class=amt-arr ng-if=ArnHardcoded.purchaseValidations.amountArray class=\"col-md-12 col-sm-12 flex-wrap\"><button class=amtBtn ng-repeat=\"x in ArnHardcoded.purchaseValidations.amountArray\" ng-class=\"{btnActive: ArnHardcoded.form.amount === x.value}\" ng-click=ArnHardcoded.setAmount(x.value)>₹ {{x.displayAmount}}</button></div></div></div><!-- Error Messages--><div class=\"error-msg pos-top\" ng-if=\"ArnHardcoded.form.transactionType !== \'SWITCH\'\"><!-- <span ng-If=\"arnhardcodedform.amount.$dirty && arnhardcodedform.amount.$error.required\" class=\"error-input\">\n              &nbsp;&nbsp; Amount is required</span><br> --> <span ng-if=\"(ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin)\" class=error-input>Minimum amount should be &#8377; {{ArnHardcoded.validations.minAmount|unit}} </span><!-- <span ng-if=\"ArnHardcoded.form.amount && ArnHardcoded.isMax\" class=\"error-input\">Maximum amount should be\n                &#8377; {{ArnHardcoded.validations.maxAmount|unit}}</span><br> --><!-- ng-If=\"ArnHardcoded.form.transactionType ==\'PURCHASE\' && ArnHardcoded.validations.amountMultiples && !ArnHardcoded.isMin\" --> <span ng-if=\"ArnHardcoded.form.amount && !ArnHardcoded.isMin && (ArnHardcoded.validations.amountMultiples && !ArnHardcoded.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{ArnHardcoded.validations.amountMultiples|unit}}</span> <span ng-show=ArnHardcoded.amountExceeded class=error-input ng-bind=ArnHardcoded.VALIDATE_DATA.AMOUNT_EXCEEDED style=\"margin-top: 0px\"></span><br></div><!-- Purchase Scheduler Installment Frequency --><div class=\"radio-selection-section radio-inputs radio-frequency\" ng-if=\"ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' && ArnHardcoded.form.InSchemeName\"><div class=row><label class=\"form-label label-tncType\">Select Frequency</label><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'OM\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=OM value=OM> <span class=check></span></span><label for=OM>Monthly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'FN\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=FN value=FN> <span class=check></span></span><label for=FN>Fortnightly</label></div><div class=radio-block><span class=radio><input type=radio ng-change=\"ArnHardcoded.setFrequency(\'WK\')\" ng-model=ArnHardcoded.form.frequency name=frequency id=WK value=WK> <span class=check></span></span><label for=WK>Weekly</label></div></div></div><!-- Start Date --><div ng-if=ArnHardcoded.form.InSchemeName ng-class=\"{\'date-selector\' : ArnHardcoded.form.frequency != \'OW\', \'date-selector-weekly\' : ArnHardcoded.form.frequency == \'OW\'}\" class=\"form-input-section row\" style=\"margin-top: 20px\" ng-show=\"(ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\') && ArnHardcoded.form.InSchemeCode\"><div class=col-md-3></div><div ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' \" class=\"col-md-4 col-xs-12\" style=\"margin-top: 25px\"><div style=\"margin-bottom: 10px\" class=form-group ng-if=\"ArnHardcoded.form.frequency == \'OW\' \"><div class=select-field ng-class=\"{error:arnhardcodedform.day.$dirty &amp;&amp; arnhardcodedform.day.$invalid}\"><select name=day ng-model=ArnHardcoded.form.weeklyDay ng-change=ArnHardcoded.updateDatesForWeekly() ng-options=\"day as day for day in ArnHardcoded.daysList\" ng-init=\"ArnHardcoded.form.weeklyDay=ArnHardcoded.form.weeklyDay?ArnHardcoded.form.weeklyDay: null\" class=\"ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched\" style=\"border: none\" aria-invalid=false><option value=\"\">Select Day</option></select><span class=\"error-input ng-binding ng-hide\" ng-show=\"ArnHardcoded.tForm.day.$dirty &amp;&amp; ArnHardcoded.tForm.day.$error.required\" ng-bind=ArnHardcoded.VALIDATE_DATA.DAY_REQUIRED aria-hidden=true>Day is required</span></div></div><div ng-if=\"ArnHardcoded.form.frequency != \'OW\' \" class=\"input-group date date-picker transaction-cal date-input\" ng-class=\"{error:arnhardcodedform.startDate.$dirty && arnhardcodedform.startDate.$invalid}\" date-calendar format=DD-MM-YYYY data-viewmode={{ArnHardcoded.viewMode}} data-date-default=ArnHardcoded.form.startDate data-enabled-dates=ArnHardcoded.enabledOTMStartDatesList data-min-date=ArnHardcoded.enabledMINStartDates data-max-date=ArnHardcoded.startMaxDate data-on-date-change=ArnHardcoded.changeStartDate data-enable=true id=StartDate style=\"position: relative\"><input type=text name=startDate ng-blur=ArnHardcoded.startDateValidate() placeholder=\"Start Date - DD-MM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=arnhardcodedform.startDate.$error.required ng-bind=ArnHardcoded.VALIDATE_DATA.START_DATE_REQUIRED></span></div><div ng-hide=ArnHardcoded.WeekFrequency><div class=\"input-group date date-picker transaction-cal date-input\" date-calendar data-date-default=ArnHardcoded.form.startDate data-enabled-dates=ArnHardcoded.enabledStartDates data-min-date=ArnHardcoded.enabledMINStartDates data-max-date=ArnHardcoded.startMaxDate data-on-date-change=ArnHardcoded.changeStartDate format=DD-MM-YYYY id=weeklyStartDate data-enable=true style=\"position: relative\"><input type=text name=startDate id=startDate ng-blur=ArnHardcoded.startDateValidate() placeholder=\"Start Date - DD-MM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><!-- End Date --><div ng-if=ArnHardcoded.form.InSchemeName ng-class=\"{\'date-selector\' : ArnHardcoded.form.frequency != \'OW\', \'date-selector-weekly\' : ArnHardcoded.form.frequency == \'OW\'}\" class=\"form-input-section row\" ng-show=\"(ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\') && ArnHardcoded.form.InSchemeCode\"><div class=col-md-3></div><div ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\'\" class=\"col-md-4 col-xs-12\"><div ng-if=\"ArnHardcoded.form.frequency != \'OW\' \" class=\"input-group date date-picker transaction-cal date-input\" ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\" date-calendar format=DD-MM-YYYY data-viewmode=months data-date-default=ArnHardcoded.form.endDate data-on-date-change=ArnHardcoded.changeEndDate data-enabled-dates=ArnHardcoded.enabledEndDates data-min-date=ArnHardcoded.minEndDate data-enable=true data-view-date=ArnHardcoded.enabledViewEndDate showdefault=false id=endDate-EC><input type=text name=endDate id=endDate ng-blur=ArnHardcoded.endDateValidate() autocomplete=off placeholder=\"End Date - DD-MM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"ArnHardcodedForm.endDate.$dirty && ArnHardcodedForm.endDate.$error.required\" ng-bind=ArnHardcoded.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=ArnHardcoded.isOTMEndDate ng-bind=ArnHardcoded.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div><div ng-if=\"ArnHardcoded.form.frequency == \'OW\' \" class=\"input-group date date-picker transaction-cal date-input\" ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\" date-calendar data-enable=true data-viewmode=months data-format=DD-MM-YYYY data-date-default=ArnHardcoded.form.endDate data-enabled-dates=ArnHardcoded.enabledEndDates data-min-date=ArnHardcoded.minEndDate data-on-date-change=ArnHardcoded.changeEndDate data-view-date=ArnHardcoded.enabledViewEndDate showdefault=false id=weeklyEndDate><input type=text name=selectEndDate autocomplete=off placeholder=\"End Date - DD-MM-YYYY\" ng-blur=ArnHardcoded.endDateValidate() style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><!--            <div class=\"col-md-4 checkboxDate\">--><!--                <input type=\"checkbox\" class=\"nomineeCheckbox col-xs-12 col-md-1\" name=\"defaultdate\" id=\"defaultdate\"--><!--                       ng-model=\"ArnHardcoded.form.isTillPerpetuity\" ng-change=\"ArnHardcoded.changeTillPerpetuityFlag()\">--><!--                <p class=\"confirmationnote col-xs-12 col-md-7\" for=\"defaultdate\"> Default date shall be Dec-2099</p>--><!--            </div>--><div class=\"euinDecCheck row\"><div class=row ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\"><div class=col-md-12><span class=checkbox><div class=\"checkDec mob-w\"><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-disabled=!ArnHardcoded.form.startDate ng-model=ArnHardcoded.form.isTillPerpetuity ng-change=ArnHardcoded.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> <span class=checkbox-text href=javaScript:void(0) for=defaultdate>Default End Date Dec-2099</span></div></span></div></div></div></div></div><!-- submit btn --><div style=\"margin-bottom: 40px\" class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' && ArnHardcoded.form.linkType != \'MFD\'\" ng-show=\"ArnHardcoded.form.sublinkType || ArnHardcoded.form.linkType == \'RIA\'\"><div class=col-md-12><div class=\"btnContainer quick-login-button\"><input id=submitLogin1 type=submit ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple}\" ng-disabled=\"arnhardcodedform.$invalid ||\n                    !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple || ArnHardcoded.amountExceeded\" class=btn-generate value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()> <input id=submitLogin1 type=submit ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple}\" ng-disabled=\"arnhardcodedform.$invalid ||  !ArnHardcoded.form.InSchemeCode || ArnHardcoded.form.InSchemeCode == \'\' || !ArnHardcoded.form.displayAmount || !ArnHardcoded.form.InSchemeName || ArnHardcoded.form.InSchemeName == \'\' ||\n                     !ArnHardcoded.form.startDate || ArnHardcoded.form.startDate == \'\' ||  !ArnHardcoded.form.endDate || ArnHardcoded.form.endDate == \'\' ||\n                    !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple || ArnHardcoded.form.frequency != \'OM\' || ArnHardcoded.amountExceeded || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' || ArnHardcoded.form.firstInstallment == \'true\'\" class=btn-generate ng-if=!ArnHardcoded.hideAddToCartButton value=\"Add to Cart\" ng-click=ArnHardcoded.addTocart()></div></div></div><div style=\"margin-bottom: 40px\" class=row ng-if=\"ArnHardcoded.form.transactionType != \'SIP\'  && ArnHardcoded.form.linkType != \'MFD\'\" ng-show=\"ArnHardcoded.form.sublinkType || ArnHardcoded.form.linkType == \'RIA\'\"><div class=col-md-12><div class=\"btnContainer quick-login-button\"><input ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) ||  ArnHardcoded.isCheckMultiple}\" id=submitLogin1 type=submit ng-disabled=\"arnhardcodedform.$invalid || ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple\" class=btn-generate value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()> <input ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) ||  ArnHardcoded.isCheckMultiple}\" id=submitLogin1 type=submit ng-disabled=\"arnhardcodedform.$invalid || ArnHardcoded.valid ||  !ArnHardcoded.form.InSchemeCode || ArnHardcoded.form.InSchemeCode == \'\'  || !ArnHardcoded.form.displayAmount || !ArnHardcoded.form.InSchemeName || ArnHardcoded.form.InSchemeName == \'\' ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\'\" class=btn-generate ng-if=\"ArnHardcoded.form.transactionType !== \'SWITCH\' && !ArnHardcoded.hideAddToCartButton && ArnHardcoded.form.transactionType !== \'REDEMPTION\' && ArnHardcoded.form.transactionType !== \'PURCHASE SCHEDULER\'\" value=\"Add to Cart\" ng-click=ArnHardcoded.addTocart()></div></div></div><div style=\"margin-bottom: 40px\" class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' && ArnHardcoded.form.linkType == \'MFD\'\"><div class=col-md-12><div class=\"btnContainer quick-login-button\" style=\"min-height: 10px;text-align: center;margin: 5px 0px 20px 0px; justify-content: center;display: flex\"><input id=submitLogin1 type=submit ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType }\" ng-disabled=\"arnhardcodedform.$invalid ||\n                    !ArnHardcoded.form.transactionType || ArnHardcoded.isCheckMultiple\" class=btn-generate value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()> <input id=submitLogin1 type=submit ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple}\" ng-disabled=\"arnhardcodedform.$invalid ||  !ArnHardcoded.form.InSchemeCode || ArnHardcoded.form.InSchemeCode == \'\'  || !ArnHardcoded.form.displayAmount || !ArnHardcoded.form.InSchemeName || ArnHardcoded.form.InSchemeName == \'\' ||\n                     !ArnHardcoded.form.startDate || ArnHardcoded.form.startDate == \'\' ||  !ArnHardcoded.form.endDate || ArnHardcoded.form.endDate == \'\' ||\n                    !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple || ArnHardcoded.form.frequency != \'OM\' || ArnHardcoded.amountExceeded || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' || ArnHardcoded.form.firstInstallment == \'true\'\" class=btn-generate value=\"Add to Cart\" ng-click=ArnHardcoded.addTocart() ng-if=!ArnHardcoded.hideAddToCartButton></div></div></div><div style=\"margin-bottom: 40px\" class=row ng-if=\"ArnHardcoded.form.transactionType != \'SIP\' && ArnHardcoded.form.linkType == \'MFD\' && ArnHardcoded.form.transactionType != \'SIP_TOPUP\'\"><div class=col-md-12><div class=\"btnContainer quick-login-button\"><input ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType }\" id=submitLogin1 type=submit ng-disabled=\"arnhardcodedform.$invalid || ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType\" class=btn-generate value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()> <input ng-class=\"{\'anything-disabled\' : ArnHardcoded.valid ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) ||  ArnHardcoded.isCheckMultiple}\" id=submitLogin1 type=submit ng-disabled=\"arnhardcodedform.$invalid || ArnHardcoded.valid || !ArnHardcoded.form.InSchemeCode || ArnHardcoded.form.InSchemeCode == \'\'  || !ArnHardcoded.form.displayAmount || !ArnHardcoded.form.InSchemeName || ArnHardcoded.form.InSchemeName == \'\' ||\n                     !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || (ArnHardcoded.form.amount === 0 && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\'\" class=btn-generate ng-if=\"ArnHardcoded.form.transactionType !== \'SWITCH\' && !ArnHardcoded.hideAddToCartButton && ArnHardcoded.form.transactionType !== \'REDEMPTION\' && ArnHardcoded.form.transactionType !== \'PURCHASE SCHEDULER\'\" value=\"Add to Cart\" ng-click=ArnHardcoded.addTocart()></div></div></div><!--|| (ArnHardcoded.form.linkType == \'RIA\' && !ArnHardcoded.selfEuin)--><!--|| (ArnHardcoded.form.linkType == \'RIA\' && !ArnHardcoded.selfEuin)--></form><div class=\"container-fluid text-start link-box\" ng-show=ArnHardcoded.url><div class=\"row text-center link-container\"><div class=\"col-xs-9 col-sm-9 col-md-9 url\"><p id=myInput>{{ArnHardcoded.url}}</p></div><div class=\"col-xs-3 col-sm-3 col-md-3 p-2 btn-link-container\" onclick=\"CopyToClipboard(\'myInput\')\" ng-click=ArnHardcoded.messageCopied()><button class=btn-link>Copy Link</button></div></div></div></div></div></section><one-click-footer ng-hide=ArnHardcoded.hideFooter></one-click-footer><script>function CopyToClipboard(id) {\n    var r = document.createRange();\n    r.selectNode(document.getElementById(\'myInput\'));\n    window.getSelection().removeAllRanges();\n    window.getSelection().addRange(r);\n    document.execCommand(\'copy\');\n    window.getSelection().removeAllRanges();\n  }</script><section ng-if=ArnHardcoded.showSideBarCart><div class=content-area><div class=row><div class=col-md-12><div class=\"post-login ecart-journey\"><div class=\"ecart-journey main-section-ecart\"><div class=sidebar-container id=sidebarContainer ng-if=ArnHardcoded.showSideBarCart hdfc-ecart-sidebar side-title=ArnHardcoded.sidebarTitle cart-item-from-click=ArnHardcoded.form.itemToBeEdited from-one-click-screen=ArnHardcoded.isFromOneClickScreen></div></div></div></div></div></div></section><style>.marginTop{\n    margin-top: 0px !important;\n  }\n  .tTitle{\n    font-family: \"Inter\";\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n    color: #333333;\n    margin-top: 2px;\n  }\n  .radioButtonsGrid{\n    padding-top:0px !important;\n    display: grid;\n    grid-template-columns: auto auto auto;\n  }\n  @media screen and (max-width:550px) {\n    .radioButtonsGrid{\n    display: grid;\n    grid-template-columns: auto;\n  }\n  }\n  .euin-prefix{\n    position: absolute;\n    left: 20px;\n    font-family: \"Mona Sans\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    top: 19px;\n    color: #555555;\n  }\n  .euinPadding{\n    padding: 5px 5px 5px 33px !important;\n  }</style>");
$templateCache.put("app/arn-hardcoded/arn-hardcoded.html","<div class=mainArn><div style=\"display: flex;justify-content: center;align-items: center;padding-top: 100px\"><div style=\"width: 80%\"><div class=\"row topDetails\"><div ng-if=ArnHardcoded.distributorImage><img src={{ArnHardcoded.distributorImage}} alt=\"\" srcset=\"\" style=\"width: 180px; margin: 15px 0px 15px 10px\"></div><div style=\"margin:auto;width: 70%; font-size:large\"><h5 style=\"color: #ffffff\">One Click Link Generation Facility</h5></div></div><div class=\"row secondDiv\"><div class=col-md-7 style=\"margin-bottom: 62px\"><!-- Carousel Start --><div id=bannerCarousel class=\"carousel slide\" data-ride=carousel><ol class=carousel-indicators><li data-target=#bannerCarousel ng-repeat=\"image in ArnHardcoded.imageUrls\" data-slide-to={{$index}} ng-class=\"{\'active\': $first}\"></li></ol><!-- Wrapper for slides --><div class=carousel-inner style=\"border-radius: 30px\"><div class=\"item height100\" ng-repeat=\"image in ArnHardcoded.imageUrls\" ng-class=\"{\'active\': $first}\"><img src={{image}} ng-if=!image.url></div></div></div></div><div class=col-md-5 style=\"padding: 0px\"><div style=\"margin-top: 10%\"><form autocomplete=off name=arnhardcodedform novalidate ng-submit=ArnHardcoded.submitArn()><!-- Radio nav --><div class=row style=\"display:flex;justify-content: center\" ng-hide=ArnHardcoded.hardcodedArn><div style=\"padding: 0px 20px 0px 0px\" ng-hide=ArnHardcoded.hardcodedArn><input type=radio ng-model=ArnHardcoded.form.linkType name=linkType id=mfd value=MFD><label for=mfd ng-click=ArnHardcoded.resetValue()>MFD</label></div><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-model=ArnHardcoded.form.linkType name=linkType id=ria value=RIA><label for=ria ng-click=\"ArnHardcoded.resetValue(\'RIA\')\">RIA</label></div><!-- <div  ng-hide=\"ArnHardcoded.hardcodedArn\">\n                  <input type=\"radio\" ng-model=\"ArnHardcoded.form.linkType\" name=\"linkType\" id=\"rm\" value=\"RM\">\n                  <label for=\"rm\" ng-click=\"ArnHardcoded.resetValue()\">RM</label>\n                </div> --></div><!-- MFD --><div class=form-group ng-if=\"ArnHardcoded.form.linkType == \'MFD\'\" style=\"padding: 10px 10px 10px 5px\" ng-class=\"{error:ArnHardcoded.form.arn.$dirty && ArnHardcoded.form.arn.$invalid && ArnHardcoded.form.arn.$touched}\"><div style=\"border-bottom: 1px solid gray;display: flex;justify-content: center;\n\n                align-items: center;\n\n                width: 84%;\n\n                margin: auto\" ng-class=\"{\'anything-disabled\':ArnHardcoded.hardcodedArn == true}\"><span style=\"font-size: 18px\">ARN -</span> <input type=text name=arn ng-model=ArnHardcoded.form.arn maxlength=6 minlength=4 ng-blur=ArnHardcoded.authARN() style=\"border: none;width: 90px; font-size: 18px\" ng-change=ArnHardcoded.arnChanged()></div><div style=\"margin-top: 10px;text-align: center\"><p style=\"font-weight: bold;font-size: 18px\">Distributor Name - {{ArnHardcoded.distributorName}}</p></div><div class=\"subbrokerarn row\" ng-if=ArnHardcoded.ShowSubBrokerArn><br><br><br><div class=\"row col-xs-12 col-sm-6 col-md-6\"><div class=\"input-normal float-label col-xs-12 col-sm-12 col-md-12\" style=\"position: relative\" ng-class={error:(arnhardcodedform.subBrokerARN.$dirty&&arnhardcodedform.subBrokerARN.$invalid)}><input type=text class=subBrokerArn name=subBrokerARN id=subBrokerARN ng-model=ArnHardcoded.subBrokerARN ng-change=ArnHardcoded.changeSubBrokerArn() ng-blur=ArnHardcoded.fetchEuinListSubBroker() ng-required=\"ArnHardcoded.investmentARN || ArnHardcoded.distributorName \" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false ng-disabled=!ArnHardcoded.form.arn> <span class=highlight></span> <span class=bar></span><label class=placeholder-label>Sub Broker ARN</label><p class=info-primary ng-if=ArnHardcoded.subBrokerName>Sub Broker Name:{{ArnHardcoded.subBrokerName}}</p><span class=error-input ng-if=\"arnhardcodedform.subBrokerARN.$dirty && arnhardcodedform.subBrokerARN.$error.pattern\" style=\"left: 15px;padding: 2px 0px 0px 0px\">Enter valid Sub Broker ARN</span></div></div><div class=\"row col-xs-12 col-sm-6 col-md-6\" style=\"margin-left: 0px\"><div class=\"input-normal float-label col-xs-12 col-sm-12 col-md-12\" style=\"position: relative\" ng-class={error:arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$invalid}><input type=text class=subBrokerCode name=subBrokerCode id=subBrokerCode ng-model=ArnHardcoded.subBrokerCode autocomplete=off ng-blur=ArnHardcoded.validation() ng-disabled=!ArnHardcoded.subBrokerARN ng-required=ArnHardcoded.subBrokerARN restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label class=placeholder-label>Sub Broker Code</label><span class=error-input ng-show=arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$error.required ng-bind=arnhardcodedform.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!-- Sub Broket Details End --></div><div class=\"dropdown input-select input-normal selectfield\"><input type=text class=shcemeInputBox ng-model=ArnHardcoded.form.euin.euinCode placeholder=EUIN(optional) ng-click=ArnHardcoded.myFunction() id=myEuin onkeyup=filterFunction() style=\"text-transform: uppercase;text-align: center\"><div id=myDropdown class=dropdown-content><a ng-repeat=\"euin in ArnHardcoded.euinList track by $index\" ng-click=\"ArnHardcoded.selectEuin(euin) \" style=\"text-transform: uppercase;font-size: 14px !important;color: #3f3c3c !important;cursor: pointer\">{{euin.euinNameCode}}</a></div></div><!-- <div class=\"input-select input-normal selectfield\" style=\"margin-top: 10px; width: 85%;margin-left: auto; margin-right: auto;text-transform: uppercase;\"\n                  ng-class=\"{error:ArnHardcoded.form.euin.$dirty && ArnHardcoded.form.euin.$invalid}\">\n                  <input type=\"text\" class=\"arnInput dropdownTrigger\" name=\"euin\" id=\"euin\"\n                    ng-change=\"ArnHardcoded.filterEuinList()\"\n                    tabindex=\"5\"\n                    ng-model=\"ArnHardcoded.form.euin.euinCode\"\n                    autocomplete=\"off\" placeholder=\"EUIN(optional)\">\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n\n                  <span class=\"error-input\"\n                    ng-show=\"(ArnHardcoded.form.euin.$dirty && ArnHardcoded.form.euin.$error.required)\"\n                    ng-bind=\"ArnHardcoded.VALIDATE_DATA.EUIN_REQUIRED\"></span>\n                  <drop-down\n                  class=\"dropDwn\"\n                    list-data=\"ArnHardcoded.euinList\"\n                    display-key=\"euinName\"\n                    display-key-second=\"euinCode\"\n                    hdfc-click=\"ArnHardcoded.selectEuin(data)\"\n                    model=\"ArnHardcoded.form.euin\"\n                    for=\"euin\">\n                  </drop-down>\n                </div> --></div><!-- RIA --><div class=form-group ng-if=\"ArnHardcoded.form.linkType == \'RIA\'\" style=\"display: flex;justify-content: center;flex-direction: column;align-items: center; margin: 15px 0px 30px 0px\"><div class=input-controls style=\"margin-top: 25px;width: 100%\"><input type=text name=riaCode class=arnInput ng-model=ArnHardcoded.form.ria autocomplete=off maxlength=12 ng-blur=ArnHardcoded.callRIA() ng-pattern=/^[A-Z0-9]{12}/ ng-required=!ArnHardcoded.form.ria placeholder=\"RIA Code *\" ng-change=ArnHardcoded.validation() capitalize required><br><span class=error-input ng-show=\"(arnhardcodedform.ria.$dirty && arnhardcodedform.ria.$invalid &&arnhardcodedform.riaCode.$error.required)\" ng-bind=ArnHardcoded.VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(arnhardcodedform.$dirty && arnhardcodedform.ria.$invalid &&arnhardcodedform.ria.$error.pattern)\" ng-bind=ArnHardcoded.VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"ArnHardcoded.riaCodeError !== \'\' && !arnhardcodedform.ria.$invalid\" ng-bind=ArnHardcoded.riaCodeError></span></div><div class=input-controls style=\"margin-top: 40px;width: 100%\"><input type=text name=rianame class=arnInput ng-model=ArnHardcoded.form.riaName placeholder=\"RIA Name\" ng-disabled=true></div></div><!-- RM --><div class=form-group ng-if=\"ArnHardcoded.form.linkType == \'RM\'\" style=\"padding: 25px 0px 5px 5px\"><!-- <div style=\"font-size: 16px;line-height: 26px;\">\n                <input type=\"radio\" ng-model=\"ArnHardcoded.form.sublinkType\" name=\"sublink\" id=\"direct\" value=\"Direct\">\n                <p  for=\"direct\" ng-click=\"ArnHardcoded.schemeType(\'Direct\')\"><strong>For Direct Scheme</strong></p>\n                <p ng-click=\"ArnHardcoded.schemeType(\'Distributor\')\"><strong>For Regular Scheme</strong></p>\n               </div> --><div style=\"display:flex;justify-content: center\"><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-model=ArnHardcoded.form.sublinkType name=sublink id=direct value=Direct><label for=direct ng-click=\"ArnHardcoded.schemeType(\'Direct\')\">For Direct Scheme</label></div><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-model=ArnHardcoded.form.sublinkType name=sublink id=regular value=Distributor><label for=regular ng-click=\"ArnHardcoded.schemeType(\'Distributor\')\">For Regular Scheme</label></div></div><div class=input-controls style=\"margin-top: 20px\" ng-if=\"ArnHardcoded.form.sublinkType == \'Direct\'\"><input type=text class=empInput name=employeeCode id=euemployeeCode style=\"text-transform: uppercase\" ng-model=ArnHardcoded.form.employeeCode autocomplete=off placeholder=\"Employee Code *\" ng-blur=ArnHardcoded.validation() maxlength=30 required><br><span class=error-input ng-show=\"(arnhardcodedform.employeeCode.$dirty && arnhardcodedform.employeeCode.$error.required)\">Employee code required.</span></div><div class=\"form-group row\" style=\"margin-top: 20px;text-align: center\" ng-if=\"ArnHardcoded.form.sublinkType == \'Distributor\'\"><div class=\"col-xs-10 col-md-6\" style=padding:0px><div style=\"font-size: 16px;margin-top: 30px\"><span style=\"font-size: 16px\">ARN -</span> <input type=text name=arn ng-model=ArnHardcoded.form.arn maxlength=6 minlength=4 ng-blur=ArnHardcoded.authARN() style=\"border: none; border-bottom: 1px solid black;width:75%; font-size: 18px\" ng-change=\"(ArnHardcoded.arnChanged() || ArnHardcoded.validation())\" required><br><span class=error-input ng-show=\"(arnhardcodedform.arn.$dirty && arnhardcodedform.arn.$error.required)\">ARN code required.</span></div></div><div class=\"col-xs-10 col-md-12\" ng-if=ArnHardcoded.ShowSubBrokerArn style=\"padding: 0px\"><div class=\"subbrokerarn row\"><br><br><br><div class=\"row col-xs-12 col-sm-6 col-md-6\" style=\"margin-left: -30px\"><div class=\"input-normal float-label col-xs-12 col-sm-12 col-md-12\" style=\"position: relative\" ng-class={error:(arnhardcodedform.subBrokerARN.$dirty&&arnhardcodedform.subBrokerARN.$invalid)}><input type=text class=subBrokerArn name=subBrokerARN id=subBrokerARN ng-model=ArnHardcoded.subBrokerARN ng-change=ArnHardcoded.changeSubBrokerArn() ng-blur=ArnHardcoded.fetchEuinListSubBroker() ng-required=\"ArnHardcoded.investmentARN || ArnHardcoded.distributorName \" maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false ng-disabled=!ArnHardcoded.form.arn> <span class=highlight></span> <span class=bar></span><label class=placeholder-label>Sub Broker ARN</label><p class=info-primary ng-if=ArnHardcoded.subBrokerName>Sub Broker Name:{{ArnHardcoded.subBrokerName}}</p><span class=error-input ng-show=\"(arnhardcodedform.subBrokerARN.$dirty && arnhardcodedform.subBrokerARN.$invalid && arnhardcodedform.subBrokerARN.$error.pattern)\" ng-bind=ArnHardcoded.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"ArnHardcoded.subBrokerCodeError != \'\'&& !arnhardcodedform.subBrokerARN.$error.pattern\" ng-bind=ArnHardcoded.subBrokerCodeError></span> <span class=error-input ng-if=\"arnhardcodedform.subBrokerARN.$dirty && arnhardcodedform.subBrokerARN.$error.pattern\" style=\"padding: 2px 0px 0px 0px\">Enter valid Sub Broker ARN</span></div></div><div class=\"row col-xs-12 col-sm-6 col-md-6\" style=\"margin-left: -30px\"><div class=\"input-normal float-label col-xs-12 col-sm-12 col-md-12\" style=\"position: relative\" ng-class={error:arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$invalid}><input type=text class=subBrokerCode name=subBrokerCode id=subBrokerCode ng-model=ArnHardcoded.subBrokerCode autocomplete=off ng-blur=ArnHardcoded.validation() ng-disabled=!ArnHardcoded.subBrokerARN ng-required=ArnHardcoded.subBrokerARN restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label class=placeholder-label>Sub Broker Code</label><span class=error-input ng-show=arnhardcodedform.subBrokerCode.$dirty&&arnhardcodedform.subBrokerCode.$error.required ng-bind=arnhardcodedform.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!-- Sub Broket Details End --></div></div><div class=\"col-xs-10 col-md-5\" style=padding:0px><p class=\"col-md-12 col-sm-12\" style=\"font-weight: bold;text-align: left\">Enter EUIN(Optional)</p><div class=\"dropdown input-select input-normal\" style=\"margin: 0px; padding: 0px; text-align: left\"><input type=text class=\"arnInput rmInput ng-pristine ng-untouched ng-valid ng-not-empty\" style=\"font-size: larger;text-align: left !important;padding-left: 32px\" ng-model=ArnHardcoded.form.euin.euinCode ng-click=ArnHardcoded.myFunction3($event) id=myEuin name=myEuin onkeyup=filterFunction() style=\"text-transform: uppercase;text-align: center\" ng-pattern=/^[0-9]+$/ ><p for=arn class=euin-prefix>E</p><span class=error-input ng-show=\"arnhardcodedform.myEuin.$dirty && arnhardcodedform.myEuin.$error.pattern\" style=\"margin-top: 8px\">Only Number Value allowed</span><!-- <div  id=\"myDropdown\" class=\"dropdown-content\">\n                          <a ng-repeat=\"euin in ArnHardcoded.euinList track by $index\" ng-click=\"ArnHardcoded.selectEuin(euin) \" style=\"text-transform: uppercase;font-size: 14px !important;color: #3f3c3c !important;cursor: pointer;\"> {{euin.euinNameCode}}</a>\n                      </div> --></div></div><div class=\"col-xs-10 col-md-5 sm-paddingtop\" style=\"padding-right: 0\"><p class=\"col-md-12 col-sm-12\" style=\"font-weight: bold;text-align: left\">Employee Code *</p><div style=\"margin-top: 30px\"><input type=text class=\"smallInput employeeCode\" name=employeeCode id=euemployeeCode ng-model=ArnHardcoded.form.employeeCode autocomplete=off style=\"font-size: 15px;text-transform: uppercase\" maxlength=30 ng-change=ArnHardcoded.validation() ng-blur=ArnHardcoded.validation() required><br><span class=error-input ng-show=\"(arnhardcodedform.employeeCode.$dirty && arnhardcodedform.employeeCode.$error.required)\">Employee code required.</span></div></div></div></div><!-- UTM fileds start--><div class=row style=\"margin-top: -30px;padding-bottom: 30px\" ng-if=ArnHardcoded.showUTM><div class=\"col-md-6 col-sm-12\"><div class=\"col-md-12 col-sm-12\"><p style=\"font-weight: bold;padding-top: 10px\">UTM source</p></div><div class=\"col-md-12 col-sm-12\" style=\"display:flex;justify-content: flex-start\"><input type=text class=arnInput name=utmsource id=utmsource ng-model=ArnHardcoded.form.utmsource placeholder=(Optional) ng-change=\"\"></div></div><div class=\"col-md-6 col-sm-12\"><div class=\"col-md-12 col-sm-12\"><p style=\"font-weight: bold;padding-top: 10px\">UTM medium</p></div><div class=\"col-md-12 col-sm-12\" style=\"display:flex;justify-content: flex-start\"><input type=text class=arnInput name=utmmedium id=utmmedium ng-model=ArnHardcoded.form.utmmedium placeholder=(Optional) ng-change=\"\"></div></div></div><!-- UTM fileds end--><!-- Scheme selection --><div class=form-group ng-if=\"ArnHardcoded.form.arn || ArnHardcoded.form.riaName || ArnHardcoded.form.employeeCode\" style=\"padding: 10px 10px 10px 5px\"><!-- PURCHASE/SIP --><div style=\"display:flex;justify-content: center\"><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-click=\"ArnHardcoded.investmentType(\'PURCHASE\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=purchase value=PURCHASE><label for=purchase style=\"cursor: pointer\">PURCHASE</label></div><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-click=\"ArnHardcoded.investmentType(\'SIP\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=sip value=SIP><label for=sip style=\"cursor: pointer\">SIP</label></div><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-click=\"ArnHardcoded.investmentType(\'SWITCH\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=switch value=SWITCH><label for=switch style=\"cursor: pointer\">Switch</label></div><div style=\"padding: 0px 20px 0px 0px\"><input type=radio ng-click=\"ArnHardcoded.investmentType(\'REDEMPTION\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=redemption value=REDEMPTION><label for=redemption style=\"cursor: pointer\">Redemption</label></div><div style=\"padding: 0px 20px 0px 0px\" ng-if=ArnHardcoded.onlyHdfcUser><input type=radio ng-click=\"ArnHardcoded.investmentType(\'PURCHASE SCHEDULER\')\" ng-model=ArnHardcoded.form.transactionType name=investmentType id=PURCHASE_SCHEDULER value=\"PURCHASE SCHEDULER\"><label for=PURCHASE_SCHEDULER style=\"cursor: pointer\">Scheduled Purchase</label></div></div><!-- select scheme --><div class=row><p class=\"col-md-12 col-sm-12\" style=\"font-weight: bold\">Select a Scheme</p><div class=\"col-md-7 col-sm-6\"><div ng-class={error:arnhardcodedform.pInScheme1.$invalid}><input type=text class=\"arnInput shcemeInputBox\" name=pInScheme1 id=pInScheme1 ng-change=ArnHardcoded.filterInSchemeList() ng-model=ArnHardcoded.form.InSchemeName tabindex=2 onpaste=\"return false\" ondrop=\"return false\" ng-click=ArnHardcoded.hideSchemeDropDown() autocomplete=off capitalize> <span class=error-input ng-show=ArnHardcoded.arnhardcodedform.pInScheme1.$error.required ng-bind=ArnHardcoded.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=ArnHardcoded.SchemeList class=dropDwn display-key=scheme hdfc-click=ArnHardcoded.purchaseInSchemeChanged(data) ng-model=ArnHardcoded.form.InSchemeCode for=pInScheme1></drop-down></div></div><div class=\"col-md-5 col-sm-6\" ng-hide=\"ArnHardcoded.arnHardcodedData.schemeGroupCode || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' \"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=ArnHardcoded.schemeListModal()><i class=list-icon></i> Select from List</span></div><div class=\"col-md-5 col-sm-6\" ng-show=\"ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' \"><span class=\"btn-primary-action common-btn-padding\" ng-click=ArnHardcoded.schemeListModal()>View All Schemes</span></div></div><br><!-- Installment Frequency --><div class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' && ArnHardcoded.form.InSchemeName\"><div class=\"col-md-12 col-sm-12\"><p style=\"font-weight: bold\">Installment Frequency</p></div><br><br><div class=\"col-md-12 col-sm-12 flex-wrap\" style=\"display:flex;justify-content: flex-start\"><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=BZ value=BZ><label class=d-flex style=font-size:12px for=BZ ng-click=\"ArnHardcoded.setFrequency(\'BZ\')\">Daily</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=OW value=OW><label class=d-flex style=font-size:12px for=OW ng-click=\"ArnHardcoded.setFrequency(\'OW\')\">Weekly</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=OM value=OM><label class=d-flex style=font-size:12px for=OM ng-click=\"ArnHardcoded.setFrequency(\'OM\')\">Monthly</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=Q value=Q><label class=d-flex style=font-size:12px for=Q ng-click=\"ArnHardcoded.setFrequency(\'Q\')\">Quarterly</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=H value=H><label class=d-flex style=font-size:12px for=H ng-click=\"ArnHardcoded.setFrequency(\'H\')\">Half Yearly</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=Y value=Y><label class=d-flex style=font-size:12px for=Y ng-click=\"ArnHardcoded.setFrequency(\'Y\')\">Yearly</label></div></div></div><br><!-- Amount --><div class=row ng-if=\"(ArnHardcoded.form.transactionType == \'PURCHASE\' || ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\') && ArnHardcoded.form.InSchemeCode \"><div class=\"col-md-12 col-sm-12\"><p style=\"font-weight: bold\">Amount</p></div><div class=\"col-md-12 col-sm-12\" style=\"display:flex;justify-content: flex-start\"><input type=text class=arnInput name=amount id=amount ng-model=ArnHardcoded.form.amount ng-change=ArnHardcoded.setAmount(ArnHardcoded.form.amount) ng-blur=ArnHardcoded.checkAmountValidation() maxlength=10 onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\" ng-pattern=/^[0-9]{1,10}$/ autocomplete=off restrict-special-charcter ignore-mouse-wheel ng-trim=false required></div><div><!-- <span ng-If=\"arnhardcodedform.amount.$dirty && arnhardcodedform.amount.$error.required\" class=\"error-input\">\n      &nbsp;&nbsp; Amount is required</span><br> --> <span ng-if=\"ArnHardcoded.form.amount && ArnHardcoded.isMin\" class=error-input>Minimum amount should be &#8377; {{ArnHardcoded.validations.minAmount|unit}}</span><br><!-- <span ng-if=\"ArnHardcoded.form.amount && ArnHardcoded.isMax\" class=\"error-input\">Maximum amount should be\n        &#8377; {{ArnHardcoded.validations.maxAmount|unit}}</span><br> --><!-- ng-If=\"ArnHardcoded.form.transactionType ==\'PURCHASE\' && ArnHardcoded.validations.amountMultiples && !ArnHardcoded.isMin\" --> <span ng-if=\"ArnHardcoded.form.amount && !ArnHardcoded.isMin && (ArnHardcoded.validations.amountMultiples && !ArnHardcoded.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{ArnHardcoded.validations.amountMultiples|unit}}</span> <span></span></div><div class=\"col-md-12 col-sm-12\"><span>Amount in words : </span><span id=DisplayWordsTaxAmount></span></div><div ng-if=ArnHardcoded.purchaseValidations.amountArray class=\"col-md-12 col-sm-12 flex-wrap\" style=\"display:flex;justify-content: flex-start\"><button class=amtBtn ng-repeat=\"x in ArnHardcoded.purchaseValidations.amountArray\" ng-click=ArnHardcoded.setAmount(x)><img src=../../assets/images/icons/rupee-white.png style=\"width: 8px\"> {{x}}</button></div></div><br><!-- select dividend option --><div class=\"radio-selection-section dividend-radio\" ng-if=\"(ArnHardcoded.form.transactionType == \'SWITCH\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' ) && ArnHardcoded.form.InSchemeName && ArnHardcoded.form.InvestmentOption === ArnHardcoded.TRANSACTIONS_CONST.DIVIDEND\"><div style=padding:10px ng-class=\"{\'anything-disabled\': ArnHardcoded.purchaseValidations.dividendReinvestmentApplicable === false}\"><input type=radio ng-model=ArnHardcoded.form.DividendOption name=pDividendOption id=pDividendOptionY ng-value=ArnHardcoded.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"ArnHardcoded.purchaseValidations.dividendReinvestmentApplicable === false\"><label for=pDividendOptionY style=\"cursor: pointer\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div style=padding:10px ng-class=\"{\'anything-disabled\': ArnHardcoded.purchaseValidations.dividendPayoutApplicable === false}\"><input type=radio ng-model=ArnHardcoded.form.DividendOption name=pDividendOption id=pDividendOptionN ng-value=ArnHardcoded.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"ArnHardcoded.purchaseValidations.dividendPayoutApplicable === false\"><label for=pDividendOptionN style=\"cursor: pointer\">Payout of Income Distribution cum Capital Withdrawal (IDCW)Option</label></div></div><!-- PURCHASE SCHEDULER FREQUENCY --><div class=row ng-if=\"ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' && ArnHardcoded.form.InSchemeName\"><div class=\"col-md-12 col-sm-12\"><p style=\"font-weight: bold\">Purchase Frequency</p></div><br><br><div class=\"col-md-12 col-sm-12 flex-wrap\" style=\"display:flex;justify-content: flex-start\"><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=OM value=OM><label class=d-flex style=font-size:12px for=OM ng-click=\"ArnHardcoded.setFrequency(\'OM\')\">Monthly</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=FN value=FN><label class=d-flex style=font-size:12px for=FN ng-click=\"ArnHardcoded.setFrequency(\'FN\')\">Fortnight</label></div><div class=vertical-padding><input type=radio ng-model=ArnHardcoded.form.frequency name=frequency id=WK value=WK><label class=d-flex style=font-size:12px for=WK ng-click=\"ArnHardcoded.setFrequency(\'WK\')\">Weekly</label></div></div></div><br><!-- Payment Option --><!-- <div class=\"row\">\n  <div class=\"col-md-12 col-sm-12\">\n    <p>Payment Option</p>\n  </div>\n</div> --><br><!-- <div class=\"row\">\n    <div class=\"col-md-6 col-sm-12\">\n        <input type=\"radio\" ng-model=\"ArnHardcoded.form.paymentOption\" name=\"paymentOption\" id=\"EC\" value=\"EC\">\n        <label class=\"d-flex\" style=\"font-size:12px;\" for=\"EC\" ng-click=\"ArnHardcoded.setPaymentOption(\'EC\')\">Standing Instruction/Biller</label>\n    </div>\n    <div class=\"col-md-6 col-sm-12\">\n        <input type=\"radio\" ng-model=\"ArnHardcoded.form.paymentOption\" name=\"paymentOption\" id=\"OTM\" value=\"OTM\">\n        <label class=\"d-flex\" style=\"font-size:12px;\" for=\"OTM\" ng-click=\"ArnHardcoded.setPaymentOption(\'OTM\')\">Register E-mandate(eOTM)</label>\n    </div>\n</div> --><!-- Installment date --><div ng-hide=!ArnHardcoded.form.InSchemeCode><!-- Start Date --><div class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\' || ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\' \"><div class=\"col-md-12 col-sm-12\" ng-hide=\"ArnHardcoded.form.transactionType == \'PURCHASE SCHEDULER\'\"><p style=\"font-weight: bold\">Installment Date Details</p></div><div class=col-md-12><div class=\"row form-group\" ng-if=\"ArnHardcoded.form.frequency == \'OW\' && ArnHardcoded.form.transactionType == \'SIP\' \"><p class=ng-scope>Select Day</p><div class=\"col-md-8 selectfield\" ng-class=\"{error:arnhardcodedform.day.$dirty &amp;&amp; arnhardcodedform.day.$invalid}\" style=\"border-bottom: 1px solid\"><select name=day ng-model=ArnHardcoded.form.weeklyDay ng-change=ArnHardcoded.updateDatesForWeekly() ng-options=\"day as day for day in ArnHardcoded.daysList\" ng-init=\"ArnHardcoded.form.weeklyDay=ArnHardcoded.form.weeklyDay?ArnHardcoded.form.weeklyDay: null\" required class=\"ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched\" style=\"border: none\" aria-invalid=false><option value=\"\">Select Day</option></select><span class=\"error-input ng-binding ng-hide\" ng-show=\"ArnHardcoded.tForm.day.$dirty &amp;&amp; ArnHardcoded.tForm.day.$error.required\" ng-bind=ArnHardcoded.VALIDATE_DATA.DAY_REQUIRED aria-hidden=true>Day is required</span></div></div><div ng-if=\"ArnHardcoded.form.frequency != \'OW\' \" class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:arnhardcodedform.startDate.$dirty && arnhardcodedform.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{ArnHardcoded.viewMode}} data-date-default=ArnHardcoded.form.startDate data-enabled-dates=ArnHardcoded.enabledOTMStartDatesList data-min-date=ArnHardcoded.enabledMINStartDates data-max-date=ArnHardcoded.startMaxDate data-on-date-change=ArnHardcoded.changeStartDate data-enable=true id=StartDate style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=arnhardcodedform.startDate.$error.required ng-bind=ArnHardcoded.VALIDATE_DATA.START_DATE_REQUIRED></span></div><div ng-hide=ArnHardcoded.WeekFrequency><div class=\"verify-acc input-group date date date-picker transaction-cal\" date-calendar data-date-default=ArnHardcoded.form.startDate data-enabled-dates=ArnHardcoded.enabledStartDates data-min-date=ArnHardcoded.enabledMINStartDates data-max-date=ArnHardcoded.startMaxDate data-on-date-change=ArnHardcoded.changeStartDate format=DD-MMM-YYYY id=weeklyStartDate data-enable=true style=\"position: relative\"><input type=text name=startDate id=startDate placeholder=\"Start Date - DD-MMM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><br><!-- 1 --><div class=row ng-show=\"ArnHardcoded.form.transactionType==\'PURCHASE SCHEDULER\'\"><div class=col-md-12><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=ArnHardcoded.form.endDate data-on-date-change=ArnHardcoded.changeEndDate data-enabled-dates=ArnHardcoded.enabledEndDates data-min-date=ArnHardcoded.minEndDate data-enable=true id=endDate-EC><input type=text name=endDate id=endDate ng-model=ArnHardcoded.form.endDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" required style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"ArnHardcodedForm.endDate.$dirty && ArnHardcodedForm.endDate.$error.required\" ng-bind=ArnHardcoded.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=ArnHardcoded.isOTMEndDate ng-bind=ArnHardcoded.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div></div><!-- 2 --><!-- End Date --><div class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\'\"><div class=col-md-12><div ng-if=\"ArnHardcoded.form.frequency != \'OW\' \" class=\"input-group date date-picker transaction-cal\" ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\" date-calendar format=DD-MMM-YYYY data-viewmode=months data-date-default=ArnHardcoded.form.endDate data-on-date-change=ArnHardcoded.changeEndDate data-enabled-dates=ArnHardcoded.enabledEndDates data-min-date=ArnHardcoded.minEndDate data-enable=true id=endDate-EC><input type=text name=endDate id=endDate ng-model=ArnHardcoded.form.endDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" required style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"ArnHardcodedForm.endDate.$dirty && ArnHardcodedForm.endDate.$error.required\" ng-bind=ArnHardcoded.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=ArnHardcoded.isOTMEndDate ng-bind=ArnHardcoded.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div><div ng-if=\"ArnHardcoded.form.frequency == \'OW\' \" class=\"input-group date date-picker transaction-cal\" ng-class=\"{\'anything-disabled\':!ArnHardcoded.form.startDate}\" date-calendar data-enable=true data-viewmode=months data-format=DD-MMM-YYYY data-date-default=ArnHardcoded.form.endDate data-enabled-dates=ArnHardcoded.enabledEndDates data-min-date=ArnHardcoded.minEndDate data-on-date-change=ArnHardcoded.changeEndDate data-view-date=ArnHardcoded.enabledEndDates[0] showdefault=false id=weeklyEndDate><input type=text name=selectEndDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" ng-model=ArnHardcoded.form.endDate style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: none\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div><div><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-model=ArnHardcoded.form.isTillPerpetuity ng-change=ArnHardcoded.changeTillPerpetuityFlag()><p class=\"confirmationnote col-xs-12 col-md-7\" for=defaultdate style=\"font-size: 13px;font-weight: bold;width: auto\">Default date shall be Dec-2099</p></div></div></div><br><div ng-show=\"ArnHardcoded.form.transactionType==\'PURCHASE SCHEDULER\'\"><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-model=ArnHardcoded.form.isTillPerpetuity ng-change=ArnHardcoded.changeTillPerpetuityFlag()><p class=\"confirmationnote col-xs-12 col-md-7\" for=defaultdate style=\"font-size: 13px;font-weight: bold;width: auto\">Default date shall be Dec-2099</p></div></div><!-- end --></div></form></div><!-- submit btn --><div class=row ng-if=\"ArnHardcoded.form.transactionType == \'SIP\'\" ng-show=\"ArnHardcoded.form.sublinkType || ArnHardcoded.form.linkType == \'MFD\'|| ArnHardcoded.form.linkType == \'RIA\'\"><div class=col-md-1></div><div class=col-md-10><div class=\"btnContainer quick-login-button\" style=\"min-height: 10px;text-align: center;margin: 5px 0px 20px 0px; justify-content: center;display: flex\"><input id=submitLogin1 type=submit ng-disabled=\"ArnHardcoded.valid ||\n                    !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple \" class=\"btn btn-block loginBtn loginBtnNewTheme\" style=\"background: #FD5C5E\" value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()></div></div><div class=col-md-1></div></div><!-- submit btn --><div class=row ng-if=\"ArnHardcoded.form.transactionType != \'SIP\'\" ng-show=\"ArnHardcoded.form.sublinkType || ArnHardcoded.form.linkType == \'MFD\'|| ArnHardcoded.form.linkType == \'RIA\'\"><div class=col-md-1></div><div class=col-md-10><div class=\"btnContainer quick-login-button\" style=\"min-height: 10px;text-align: center;margin: 5px 0px 20px 0px; justify-content: center;display: flex\"><input id=submitLogin1 type=submit ng-disabled=\"ArnHardcoded.valid ||\n                    !ArnHardcoded.form.transactionType || (ArnHardcoded.form.amount && ArnHardcoded.isMin) || ArnHardcoded.isCheckMultiple\" class=\"btn btn-block loginBtn loginBtnNewTheme\" style=\"background: #FD5C5E\" value=\"Generate Link\" ng-click=ArnHardcoded.submitArn()></div></div><div class=col-md-1></div></div><!-- For HDFC Bank BUtton --><!-- <div class=\"row\" ng-If=\"ArnHardcoded.hdfcuser\"\n              ng-show =\"ArnHardcoded.form.sublinkType || ArnHardcoded.form.linkType == \'MFD\'\" >\n                <div class=\"col-md-1\"></div>\n                <div class=\"col-md-10\">\n                  <div class=\"btnContainer quick-login-button\"\n                    style=\"min-height: 10px;text-align: center;margin: 5px 0px 20px 0px; justify-content: center;display: flex;\">\n                    <input id=\"submitLogin1\" type=\"submit\"\n                    ng-disabled=\"!ArnHardcoded.form.arn\"\n                      class=\"btn btn-block loginBtn loginBtnNewTheme\" style=\" background: #FD5C5E;\"\n                      value=\"Generate Link\" ng-click=\"ArnHardcoded.submitArn()\">\n                  </div>\n                </div>\n                <div class=\"col-md-1\"></div>\n              </div> --></div></div></div></div><br><div class=\"container-fluid text-start link-box\" ng-show=ArnHardcoded.url><div class=row style=\"margin-bottom: 20px\"><p>ARN Hardcoded Link (For sharing with your investors on SMS, WhatsApp and Email)</p></div><div class=\"row text-center\" style=\"border: 1px solid;box-shadow:0px 2px 14px rgb(18 66 101 / 30%);height: auto;padding:10px;border-radius: 15px;background-color: white;margin-bottom: 20px\"><div class=\"col-xs-9 col-sm-9 col-md-9\" style=\"text-align: start\"><p id=myInput style=\"pointer-events: none;font-weight: bold; color: black\">{{ArnHardcoded.url}}</p></div><div class=\"col-xs-3 col-sm-3 col-md-3 p-2\" style=\"text-align: end\"><button class=btn-link onclick=\"CopyToClipboard(\'myInput\')\">Copy Link</button></div></div></div></div><footer class=\"main-footer login-footer\" style=margin-top:0px><div class=\"row footerRow\"><div class=\"col-md-3 bottom-footer\" style=\"padding-left: 30px; height: 68px; background: transparent\"><img src=../../assets/images/logo-main.png alt=\"\" srcset=\"\" style=\"padding: 3px\"></div><div class=\"col-md-7 bottom-footer\" style=\"height: 68px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent\"><p style=\"font-weight: 500;color: black\">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY</p></div></div></footer><script>function CopyToClipboard(id) {\n    var r = document.createRange();\n    r.selectNode(document.getElementById(\'myInput\'));\n    window.getSelection().removeAllRanges();\n    window.getSelection().addRange(r);\n    document.execCommand(\'copy\');\n    window.getSelection().removeAllRanges();\n  }</script><style>*{\n    font-family: \"monasans-bold\", Open Sans, sans-serif;\n  }\n  .topDetails{\n    background-color: #0c4c87;\n    display: flex;\n    height: 70px;\n    justify-content: flex-start;\n    text-align: center;\n    align-items: center;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    box-shadow: 0px 1px 6px 0px grey;\n  }\n  .row {\n    margin-left: 0px;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .d-flex:before {\n    content: \"\";\n    border: none;\n    display: inline-block;\n    background: #166bb9;\n    width: 15px;\n    height: 15px;\n    margin: 0px 5px 0px 3px;\n    border-radius: 50%;\n  }\n  .d-flex::after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    left: 8px;\n    top: 13px;\n    margin: -8px 20px;\n    margin-left: 0;\n    border-radius: 50%;\n  }\n  .amtBtn{\n    width: 100px;\n    margin: 3px 10px;\n    border-radius: 4px;\n    background: #2485bd;\n    border: 1px solid #2485bd;\n    color: #fff;\n    padding: 10px 45px;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n  }\n  .date-picker{\n    border-bottom: 1px solid;\n  }\n  .input-group-addon{\n    background: white;\n    border: none;\n  }\n  .input-controls {\n    text-align: center;\n  }\n\n  .mainArn {\n    background-image: url(\'../../assets/images/newinvestorbg2.png\');\n    background-position-y: bottom;\n    background-repeat: no-repeat;\n    background-size: inherit;\n    background-color: #f4fcff;\n    opacity: 0.9;\n    height: 100%;\n    padding-bottom: 190px;\n  }\n.link-box{\n  padding: 5px 150px 20px 158px; font-size: medium; font-weight: bold;\n}\n  .carousel {\n    height: 100% !important;\n    margin-top: 2%;\n  }\n\n  .carousel-indicators {\n    top: 106%;\n  }\n\n  .glyphicon-chevron-left {\n    color: red;\n  }\n\n  .glyphicon-chevron-right {\n    color: red;\n  }\n\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -70%;\n  }\n\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -70%;\n  }\n\n  .carousel-inner {\n    height: 95%;\n  }\n\n  .loginBtn {\n    padding: 2% 3%;\n  }\n\n  .carousel-indicators li {\n    display: inline-block;\n    width: 15px;\n    height: 15px;\n    margin-right: 5px;\n    margin-left: 5px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #5a84ac;\n    border-radius: 10px;\n  }\n\n  .carousel-indicators .active {\n    width: 15px;\n    height: 15px;\n    margin-right: 5px;\n    margin-left: 5px;\n    background-color: #0c4c87;\n  }\n\n  .note {\n    font-weight: bolder;\n    color: white;\n    padding: 20px;\n  }\n\n  .subnote,\n  .subnote1 {\n    position: absolute;\n    top: 30%;\n    left: 12%;\n    cursor: default;\n    font-weight: bold;\n  }\n\n  .info-primary {\n    font-size: 11px;\n    color: blue;\n  }\n\n  .secondDiv {\n    background-color: white;\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    height: auto;\n    box-shadow: 0px 2px 14px rgb(18 66 101 / 30%);\n    padding: 10px 10px 10px 10px;\n    margin-bottom: 30px;\n  }\n\n  .subbrokerarn {\n    margin: 0px 0px 0px 0px;\n  }\n\n  .arnInput {\n    width: 84%;\n    border: none;\n    border-bottom: 1px solid gray;\n    text-align: center;\n    font-size: 18px;\n    padding: 0px 0px 5px 0px;\n  }\n\n  .empInput {\n    width: 80%;\n    border: none;\n    border-bottom: 1px solid gray;\n    font-size: 16px;\n    padding: 0px 0px 5px 0px;\n  }\n\n  .smallInput {\n    width: 98%;\n    border: none;\n    border-bottom: 1px solid gray;\n    font-size: 12px;\n    padding: 0px 0px 5px 0px;\n    margin: 0px 0px 0px -10px;\n  }\n.dwidth{\n  width: 80%;\n}\n  input[type=\"radio\"] {\n    display: none;\n  }\n\n  label {\n    position: relative;\n  }\n\n\n  label::before {\n    content: \"\";\n    border: none;\n    display: inline-block;\n    background: #166bb9;\n    width: 15px;\n    height: 15px;\n    margin: -4px 20px;\n    margin-left: 0;\n    border-radius: 50%;\n  }\n\n  label::after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    left: 5px;\n    top: 9px;\n    margin: -8px 20px;\n    margin-left: 0;\n    border-radius: 50%;\n    transition: all 0.4s;\n  }\n\n  input[type=\"radio\"]:checked+label::after {\n    background: white;\n  }\n\n  input[type=\"radio\"]:checked+label::before {\n    border: 10px solid #166bb9;\n  }\n\n  input[type=submit].btn-block {\n    width: 70%;\n    border-radius: 40px;\n    font-size: 18px;\n  }\n\n  @media (min-width: 1200px) {\n    .container {\n      width: 1080px;\n    }\n  }\n\n  @media (max-width: 600px) {\n    .link-box{\n  padding: 5px 20px 20px 20px; font-size: 12px;\n}\n.dwidth{\n  width: 90%;\n}\n  }\n  .btnContainer .loginBtn {\n  background: #004c8a;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  padding: 3% 3%;\n  color: #fff;\n  border-radius: 5px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: 1px;\n\n}\n*:focus {\n    text-decoration: none !important;\n    border: solid 1px white !important;\n    border: none;\n}\n.suggestion{\n  min-height: 100px;\n  max-height: 250px;\n  overflow: scroll;\n}\n.suggestion > ul > li {\npadding: 5px;\n}\n@media screen and (max-width:550px) {\n  .flex-wrap{\n    flex-wrap: wrap;\n  }\n  .vertical-padding{\n    padding: 3px 0px;\n  }\n}\n.input-normal .placeholder-label{\n    font-size: 14px;\n    font-weight: bold !important;\n    position: absolute;\n    pointer-events: none;\n    left: 5px;\n    top: 12px;\n    color: #584c4c !important;\n    margin: 0px 0px 0px -20px;\n}\n.float-label label::before{\n  background: none !important;\n}\n.float-label .ng-dirty.ng-not-empty ~ label, .input-normal .ng-not-empty ~ label {\n    top: -12px;\n    font-size: 14px;\n    color: #584c4c;\n}\n.float-label input[disabled] ~ label{\n  color: #584c4c !important;\n}\n\n.dropdown {\n    width: 94%;\n    padding: 0px 0px 0px 20px;\n    border-bottom: 1 px solid black;\n    position: relative;\n    display: inline-block;\n  }\n\n  .dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #ffff;\n    min-width: 230px;\n    max-height: 300px;\n    overflow: auto;\n    border: 1px solid #ddd;\n    z-index: 1;\n  }\n\n  .dropdown-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n  }\n\n  .dropdown a:hover {\n      cursor: pointer;\n      background: #f5f5f5;\n      color: #166bb9;\n    }\n\n    .euin-prefix{\n    position: absolute;\n    left: 20px;\n    font-family: \"Mona Sans\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    top: 8px;\n    color: #555555;\n  }\n  .euinPadding{\n    padding: 5px 5px 5px 33px !important;\n  }\n@media screen and (max-width:991px) {\n.sm-paddingtop{\npadding-top: 20px;\n}\n}</style><script>function filterFunction() {\n    var input, filter, ul, li, a, i;\n    input = document.getElementById(\"myEuin\");\n    filter = input.value.toUpperCase();\n    div = document.getElementById(\"myDropdown\");\n    a = div.getElementsByTagName(\"a\");\n    for (i = 0; i < a.length; i++) {\n      txtValue = a[i].textContent || a[i].innerText;\n      if (txtValue.toUpperCase().indexOf(filter) > -1) {\n        a[i].style.display = \"\";\n      } else {\n        a[i].style.display = \"none\";\n      }\n    }\n  }</script>");
$templateCache.put("app/browser-update/browser-update.html","<header class=\"header header1 container-fluid update-browser-header\"><div class=\"row main-head\"><div class=col-md-12><img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></div></div></header><div class=update-browser><!------ Browser isn\'t supported ------><h1 class=heading ng-hide=\"BrowserUpdate.deviceDetector.browser == \'ie\'\">This version of {{BrowserUpdate.deviceDetector.browser}} is not supported.</h1><h1 class=heading ng-show=\"BrowserUpdate.deviceDetector.browser == \'ie\'\">Microsoft Explorer is not supported.</h1><ul class=\"list-group col-md-6 col-md-offset-3\"><li class=list-group-item ng-if=\"BrowserUpdate.deviceDetector.browser == \'chrome\'\"><a target=_blank href=\"https://support.google.com/chrome/answer/95414?co=GENIE.Platform%3DDesktop&hl=en\">Click here to update your Google Chrome.</a></li><li class=list-group-item ng-if=\"BrowserUpdate.deviceDetector.browser == \'firefox\'\"><a target=_blank href=https://support.mozilla.org/en-US/kb/update-firefox-latest-version>Click here to update your Mozilla Firefox.</a></li><li class=list-group-item ng-if=\"BrowserUpdate.deviceDetector.browser == \'ms-edge\'\"><a target=_blank href=https://www.microsoft.com/en-in/windows/microsoft-edge>Click here to update your Microsoft Edge.</a></li></ul><h3 class=\"col-md-8 col-md-offset-2\" ng-if=\"BrowserUpdate.deviceDetector.browser == \'ie\'\">Please use Google Chrome, Mozilla Firefox, Safari or Microsoft Edge.</h3></div>");
$templateCache.put("app/changeDividend/changeDividend.html","<div class=\"main-section changeDividend\" ng-init=ChangeDividend.init()><div class=content-area><div class=content-head><h3>Change IDCW Option</h3></div><div class=content-body><form name=dividendForm autocomplete=off><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Select Scheme</strong></label><div class=form-group><div class=selectfield ng-class={error:dividendForm.folio.$dirty&&dividendForm.folio.$invalid}><select class=\"browser-default custom-select\" name=folio ng-change=ChangeDividend.folioChanged() ng-model=ChangeDividend.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in ChangeDividend.folioList\" ng-init=\"ChangeDividend.formData.folioNumber = ChangeDividend.formData.folioNumber ? ChangeDividend.formData.folioNumber : null\" required><option value=\"\">Select Folio</option></select><span ng-show=\"dividendForm.folio.$dirty && dividendForm.folio.$invalid\"><span class=error-input ng-show=dividendForm.folio.$error.required ng-bind=ChangeDividend.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div><div ng-class=\"{error:dividendForm.outScheme.$dirty && dividendForm.outScheme.$invalid}\" class=selectfield><select name=outScheme class=\"browser-default custom-select\" ng-model=ChangeDividend.formData.outSchemeObj ng-change=ChangeDividend.outSchemeChanged() ng-options=\"_scheme as _scheme.schemeName for _scheme in ChangeDividend.details track by _scheme.schemeCode\" ng-init=\"ChangeDividend.formData.outSchemeObj = ChangeDividend.formData.outSchemeObj ? ChangeDividend.formData.outSchemeObj : null\" required><option value=\"\" selected>Select Scheme</option></select><span ng-show=\"dividendForm.outScheme.$dirty && dividendForm.outScheme.$invalid\"><span class=error-input ng-show=dividendForm.outScheme.$error.required ng-bind=ChangeDividend.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div></div><div><p ng-if=ChangeDividend.formData.outSchemeObj class=\"text-info form-group\">(Currently Chosen IDCW option: <span ng-bind=\"ChangeDividend.reInvest == \'Reinvest\' ? \'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\' : \'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\" class=bold style=color:#000000>Payout/Reinvest</span>)</p></div><div class=form-group ng-class=\"{\'anything-disabled\': !ChangeDividend.formData.outSchemeObj}\"><label><strong>Choose Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div class=\"up-space radio-flex-div\"><span class=radio-block ng-class=\"{\'anything-disabled\': ChangeDividend.reInvest==\'Reinvest\'}\"><span class=\"radio radio-flex-span\"><input type=radio id=pReinvest1 ng-model=ChangeDividend.formData.dividendOption name=dividendOption value=Reinvest ng-change=ChangeDividend.selectDividendOption() ng-disabled=\"ChangeDividend.reInvest==\'Reinvest\'\"> <span class=check></span></span><label class=radio-flex-label>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></span><span class=radio-block ng-class=\"{\'anything-disabled\': ChangeDividend.reInvest==\'Payout\'}\"><span class=\"radio radio-flex-span\"><input type=radio ng-model=ChangeDividend.formData.dividendOption name=dividendOption value=Payout ng-change=ChangeDividend.selectDividendOption() ng-disabled=\"ChangeDividend.reInvest==\'Payout\'\"> <span class=check></span></span><label class=radio-flex-label>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></span></div></div><!--dynamic note ICDW--><ng-bind-html dynamic=ChangeDividend.dynamicNote.content></ng-bind-html><div class=\"row form-footer\"><div class=col-md-9 ng-show=ChangeDividend.showTerms><p class=strong>Terms &amp; Conditions</p><span class=checkbox><input type=checkbox ng-model=ChangeDividend.isCheckedTandC> <span class=icon-checkbox></span> <span class=\"checkbox-text tnc\">I have read and understood <a ng-click=ChangeDividend.showTermConditions() href=javaScript:void(0) class=changeDividendTerms>Terms &amp; Conditions</a> of Investment</span></span></div><div class=col-md-3><button class=\"btn btn-primary-action pull-right common-btn-padding\" ng-disabled=\"!ChangeDividend.isCheckedTandC || dividendForm.$invalid\" ng-click=ChangeDividend.submitChangeDividend()>Submit</button></div></div></form></div></div></div>");
$templateCache.put("app/contact-us/contact-us.html","<login-header ng-if=!ContactUs.isLoggedIn></login-header><!--<hdfc-dashboard-headers ng-if=\"ContactUs.isLoggedIn\"></hdfc-dashboard-headers>--><hdfc-login-sidebar ng-if=!ContactUs.isLoggedIn></hdfc-login-sidebar><!--<hdfc-sidebar ng-if=\"ContactUs.isLoggedIn\"></hdfc-sidebar>--><div class=contact-us><div class=all-content-wrapper><div class=upper-head-rectangle><div class=default-hide ng-click=ContactUs.goBack()></div><div class=\"title set-font-family-inter set-font-weight-700\">Contact Us</div><div class=no-use></div></div><div class=\"container content-section\"><div class=\"row display-flex\"><div class=\"col-xs-12 col-md-6\" ng-repeat=\"contactData in ContactUs.contactUsListData\"><div class=\"card height100\"><div class=card-header><div ng-class=\"{\'call-img\': contactData.cardType === \'Call\', \'email-img\': contactData.cardType === \'Email\', \'whatsapp-img\': contactData.cardType === \'Whatsapp\', \'location-img\': contactData.cardType === \'Locate\'}\"></div><label class=\"set-font-weight-700 set-font-family-inter\">{{contactData.cardTitle}}</label></div><div class=separator></div><div class=\"card-body set-font-family-monasans set-font-weight-500\" ng-if=\"contactData.cardType === \'Call\'\">{{contactData.description}} <a href=tel:{{contactData.mobile}}>{{contactData.mobile}}</a></div><div class=\"card-body set-font-family-monasans set-font-weight-500\" ng-if=\"contactData.cardType === \'Email\'\">{{contactData.description}} <a href=mailto:{{contactData.email}}>{{contactData.email}}</a></div><div class=\"card-body set-font-family-monasans set-font-weight-500\" ng-if=\"contactData.cardType === \'Whatsapp\'\">{{contactData.description}} <a href=\"https://api.whatsapp.com/send/?phone={{contactData.mobile}}&amp;text=Hi&amp;app_absent=0\" target=_blank>{{contactData.mobile}}</a></div><div class=\"card-body set-font-family-monasans set-font-weight-500\" ng-if=\"contactData.cardType === \'Locate\'\"><ng-bind-html dynamic=contactData.description></ng-bind-html></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"dashboard main-section\"><!--<div class=\"loader dash-loader\" style=\"position: absolute;top:120px;left:70px;\"><span class=\"loading\"></span></div>--><div class=container-fluid><div class=row><div ng-include=\"\'app/dashboard/distributor-dashboard-widgets/existing-distributor-widget.html\'\"></div></div></div></div>");
$templateCache.put("app/dashboard/edit.dashboard.html","<div class=\"dashboard main-section edit-dashboard\" style=\"position: relative\"><div class=edit-overlay></div><div class=container-fluid><div class=\"form-content text-center\"><p style=\"margin-bottom: 10px\">Do you wish to save the widget reordering changes?</p><button class=\"btn btn-secondary-action\" ng-click=Dashboard.cancelDragEdit();>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=!Dashboard.draggedPayload ng-click=Dashboard.applyDragEdit();>Apply</button></div><div class=row gridster=Dashboard.gridsterOpts><div gridster-item=data ng-repeat=\"data in Dashboard.distributorWidgetsList\"><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SNAPSHOT\"><div class=\"dash-card drag-it trans-snap\"><div class=\"loader transsnap\" style=position:absolute><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Transaction Snapshot</p><div class=pull-right><div class=switch><span ng-if=\"Dashboard.sourceType == \'Online\'\" class=on>Online</span> <span ng-if=\"Dashboard.sourceType == \'Offline\'\" ng-click=\"Dashboard.changeStatus(\'Online\');\">Online</span> <span ng-if=\"Dashboard.sourceType==\'Offline\'\" class=on>Offline</span> <span ng-if=\"Dashboard.sourceType==\'Online\'\" ng-click=\"Dashboard.changeStatus(\'Offline\');\">Offline</span></div></div></div><div class=card-body><div class=\"col-md-12 text-center clearfix\"><div class=\"col-xs-12 period-filter\"><span ng-click=\"Dashboard.setSnapShot(\'yesterday\')\" ng-class=\"{active: Dashboard.yesterdayActive}\">Yesterday</span> <span ng-click=\"Dashboard.setSnapShot(\'lastWeek\')\" ng-class=\"{active: Dashboard.lastWeekActive}\">Last Week</span> <span ng-click=\"Dashboard.setSnapShot(\'lastMonth\')\" ng-class=\"{active: Dashboard.lastMonthActive}\">Last Month</span></div><div class=\"col-md-6 col-xs-11 outcard cursor-pointer\" ui-sref=main.transactions.list.inflow><div class=flow-card><div class=col-xs-2><i class=arrow-down-icon></i></div><div class=\"col-xs-10 text-left\"><p>Inflow</p><div><span class=ng-binding ng-class=\"{\'trim\':Dashboard.snapshotData.inFlowData.totalInFlowAmount.toFixed(2).toString().length>12}\"><i class=rupee-med-icon></i> {{Dashboard.snapshotData.inFlowData.totalInFlowAmount|unit:Dashboard.snapshotData.inFlowData.amountUnit}} <span class=ng-binding>{{Dashboard.snapshotData.inFlowData.amountUnit|unitValue}}</span></span></div><p class=ng-binding>{{Dashboard.snapshotData.inFlowData.totalTransactions}}<!--|unit:Dashboard.snapshotData.inFlowData.transactionUnit--><span><!--{{Dashboard.snapshotData.inFlowData.transactionUnit|unitValue}}--> Transactions</span></p></div></div></div><div class=\"col-md-6 col-xs-11 outcard cursor-pointer\"><div class=flow-card ui-sref=main.transactions.list.outflow><div class=col-xs-2><i class=arrow-up-icon></i></div><div class=\"col-xs-10 text-left\"><p>Outflow</p><div><span class=ng-binding><i class=rupee-med-icon></i> {{Dashboard.snapshotData.outFlowData.totalOutFlowAmount|unit:Dashboard.snapshotData.outFlowData.amountUnit}} <span class=ng-binding>{{Dashboard.snapshotData.outFlowData.amountUnit|unitValue}}</span></span></div><p class=ng-binding>{{Dashboard.snapshotData.outFlowData.totalTransactions}}<!--|unit:Dashboard.snapshotData.outFlowData.transactionUnit--><span><!--{{Dashboard.snapshotData.outFlowData.transactionUnit|unitValue}}--> Transactions</span></p></div></div></div><div class=\"col-md-12 text-center mid-text\"><span>Status</span></div><div class=\"col-md-offset-1 statuses col-md-10 col-sm-4 col-sm-offset-4\"><span class=col-md-4><div class=\"pending-box cursor-pointer text-uppercase\" ui-sref=\"main.transactions.all({status:\'proposed\'})\"><span>{{Dashboard.snapshotData.allTransactionsStatus.proposedCount}}</span> Proposed</div></span><span class=col-md-4><div class=\"expired-box cursor-pointer text-uppercase\" ui-sref=\"main.transactions.all({status:\'expired\'})\"><span>{{Dashboard.snapshotData.allTransactionsStatus.expiredCount}}</span> Expired</div></span><span class=col-md-4><div class=\"reversed-box cursor-pointer text-uppercase\" ui-sref=\"main.transactions.all({status:\'reversed\'})\"><span>{{Dashboard.snapshotData.allTransactionsStatus.reversedCount}}</span> Reversed</div></span></div></div></div></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TODO\"><div class=\"dash-card drag-it todos\"><div class=\"loader todos-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>To-Do List <span class=count>{{Dashboard.totalPendingCount}}</span></p><div class=\"pull-right text-blue cursor-pointer\" ui-sref=main.todos>View All <i class=chevron-blue-icon></i></div></div><div class=card-body><ul class=todo-list ng-if=\"Dashboard.pendingList.length || Dashboard.birthdayList.length\"><li class=\"list-group-item group-head\" ng-if=Dashboard.pendingList.length><span>Pending Transactions</span></li><li class=list-group-item ng-repeat=\"data in Dashboard.pendingList\"><span ng-bind=data.itemDescription>Someone wants something</span> <span ng-click=Dashboard.sendReminder(data.transactionId) class=text-center ng-bind=data.itemAction></span></li><li class=\"list-group-item group-head\" ng-if=Dashboard.birthdayList.length><span>Birthday Alerts</span></li><li class=list-group-item ng-repeat=\"bday in Dashboard.birthdayList\"><span ng-bind=bday.itemDescription></span> <span class=text-center ng-bind=bday.itemAction ng-click=Dashboard.wishSomeone(bday)></span></li></ul><div class=if-error ng-if=\"Dashboard.totalPendingCount == 0\"><i class=smile-icon></i><p>Yippee!!! You have no pending work items!!!</p></div></div></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\"><div class=\"dash-card drag-it assetmng\"><div class=\"loader assetmng-loader\" style=\"position: absolute\"><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Assets Under Management</p></div><div ng-if=\"Dashboard.assetsUnderMgtData.length == 0\" class=card-body><div class=if-error>No Data Available</div></div><div ng-if=\"Dashboard.assetsUnderMgtData.length > 0\" class=card-body><div class=col-md-6 id=donutchart-asset></div><div ng-if=\"Dashboard.assetsUnderMgtSelected == -1\" class=col-md-6><h2 ng-bind=Dashboard.assetsUnderMgtTotal.aumType>Equity</h2><p><i class=rupee-med-icon></i> <span><span ng-bind=Dashboard.assetsUnderMgtTotal.amount|unit:Dashboard.getUnit(Dashboard.assetsUnderMgtTotal.amount)>5.5</span> <small ng-bind=Dashboard.getUnit(Dashboard.assetsUnderMgtTotal.amount)|unitValue></small></span></p><div class=\"row scheme-table\"><table class=table><thead><tr><th>Top <span ng-bind=Dashboard.assetsUnderMgtTotal.topSchemesList.length></span> Schemes</th><th>Amount (INR)</th></tr></thead><tbody><tr ng-repeat=\"data in Dashboard.assetsUnderMgtTotal.topSchemesList\"><td ng-bind=data.schemeName></td><td class=text-blue><span ng-bind=data.totalAmount|unit:Dashboard.getUnit(data.totalAmount)>1000</span> <span ng-bind=Dashboard.getUnit(data.totalAmount)|unitValue></span></td></tr></tbody></table></div></div><div ng-if=\"Dashboard.assetsUnderMgtSelected > -1\" class=col-md-6><h2 ng-bind=Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].aumType>Equity</h2><p><i class=rupee-med-icon></i> <span><span ng-bind=Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].amount|unit:Dashboard.getUnit(Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].amount)>5.5</span> <small ng-bind=Dashboard.getUnit(Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].amount|unitValue)></small></span></p><div class=\"row scheme-table\"><table class=table><thead><tr><th>Top <span ng-bind=Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].topSchemesList.length></span> Schemes</th><th>Amount (INR)</th></tr></thead><tbody><tr ng-repeat=\"data in Dashboard.assetsUnderMgtData[Dashboard.assetsUnderMgtSelected].topSchemesList\"><td ng-bind=data.schemeName></td><td class=text-blue><span ng-bind=data.totalAmount|unit:Dashboard.getUnit(data.totalAmount)></span> <span ng-bind=Dashboard.getUnit(data.totalAmount)|unitValue></span></td></tr></tbody></table></div></div></div></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.MARKET\"><!--todo : DONOT REMOVE THIS--><!-- <div class=\"dash-card-small todayAnalysis clearfix\">\n            <i class=\"drag-icon\"></i>\n            <div class=\"head container-fluid\">\n              <p class=\"pull-left\">\n                Today’s Analysis\n              </p>\n            </div>\n            <div class=\"card-body\" ng-if=\"Dashboard.autoSuggestionData.length\">\n              <div class=\"col-md-12\" ng-repeat=\"data in Dashboard.autoSuggestionData\">\n                <p>{{data.key}}</p>\n                <p>{{data.value}}</p>\n              </div>\n            </div>\n            <div class=\"card-body analysis-msg\" ng-if=\"Dashboard.autoSuggestionData.length==0\">\n              <div class=\"col-md-12\">\n                <p>We don\'t have any analysis for today. Please check tomorrow.</p>\n              </div>\n            </div>\n          </div>--><!----^^^^^----todo : DONOT REMOVE THIS-------><div class=\"dash-card-small drag-it clearfix\"><i class=drag-icon></i><div class=\"card-half stock-card nse-card\"><p><span class=nse-icon></span></p><div><p ng-bind=Dashboard.marketTrendData.nseRate.currentRate>27,930.21</p><p ng-class=\"{\'stock-down\':Dashboard.marketTrendData.nseRate.percentageRateChange<0,\'stock-up\':Dashboard.marketTrendData.nseRate.percentageRateChange>=0}\"><i class=stock-up-icon ng-if=\"Dashboard.marketTrendData.nseRate.rateChange>=0\"></i> <i class=stock-down-icon ng-if=\"Dashboard.marketTrendData.nseRate.rateChange<0\"></i> <span><span ng-bind=Dashboard.marketTrendData.nseRate.rateChange>14.31</span> (<span ng-bind=Dashboard.marketTrendData.nseRate.percentageRateChange?Dashboard.marketTrendData.nseRate.percentageRateChange:0>0.05%</span>%)</span></p></div><hr></div><div class=\"card-half stock-card bse-card\"><hr><p><span class=bse-icon></span></p><div><p ng-bind=Dashboard.marketTrendData.bseRate.currentRate>27,930.21</p><p ng-class=\"{\'stock-down\':Dashboard.marketTrendData.nseRate.percentageRateChange<0,\'stock-up\':Dashboard.marketTrendData.nseRate.percentageRateChange>=0}\"><i class=stock-up-icon ng-if=\"Dashboard.marketTrendData.bseRate.rateChange>=0\"></i> <i class=stock-down-icon ng-if=\"Dashboard.marketTrendData.bseRate.rateChange<0\"></i> <span><span ng-bind=Dashboard.marketTrendData.bseRate.rateChange></span> (<span ng-bind=Dashboard.marketTrendData.bseRate.percentageRateChange?Dashboard.marketTrendData.bseRate.percentageRateChange:0></span>%)</span></p></div></div></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.KEYINVESTORLIST\"><!--todo : DONOT REMOVE THIS--><div class=\"dash-card todos drag-it clearfix\"><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Key Investor List</p><!--<p class=\"pull-left\">--><!--Digital Marketing Campaigns--><!--</p>--></div><div class=card-body><!--<ul class=\"todo-list\">--><!--<li class=\"list-group-item group-head\">--><!--<span class=\"cursor-default\">Campaigns</span>--><!--</li>--><!--<li class=\"list-group-item\" ng-repeat=\"camp in Dashboard.campaignList\">--><!--<span>{{camp.title}}</span>--><!--<span ng-if=\"!camp.engaged\" ng-click=\"Dashboard.openCampaign(camp)\">Run</span>--><!--<span ng-if=\"camp.engaged\"><a target=\"_blank\" ng-href=\"{{camp.campaignUrl}}\">Status</a></span>--><!--</li>--><!--</ul>--><ul class=todo-list><!--<li class=\"list-group-item group-head\">--><!--<span class=\"cursor-default\">Key Investor List</span>--><!--</li>--><li class=list-group-item><a href=\"\" class=download-link title=\"Download All Investor Report\" ng-click=\"Dashboard.downloadReport(\'v1/report/all/investor\',\'All-Investors\')\"><i class=download-blue-icon></i> All Investors</a></li><li class=list-group-item><a href=\"\" class=download-link title=\"Download No ELSS Scheme\" ng-click=\"Dashboard.downloadReport(\'v1/report/elss/non\',\'No-Investment-in-ELSS-Schemes\')\"><i class=download-blue-icon></i> No Investment in ELSS Schemes</a></li><li class=list-group-item><a href=\"\" class=download-link title=\"Download Non Active SIP\" ng-click=\"Dashboard.downloadReport(\'v1/report/sip/non\',\'No-Active-SIP\')\"><i class=download-blue-icon></i> No Active SIP</a></li></ul></div></div><!--<div class=\"card-body analysis-msg\" ng-if=\"Dashboard.autoSuggestionData.length==0\">\n            <div class=\"col-md-12\">\n              <p>We don\'t have any analysis for today. Please check tomorrow.</p>\n            </div>\n          </div>--></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.DIGITAL\"><!--todo : DONOT REMOVE THIS--><div class=\"dash-card todos drag-it clearfix\"><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Digital Marketing Campaigns</p></div><div class=card-body><ul class=todo-list><!--<li class=\"list-group-item group-head\">--><!--<span class=\"cursor-default\">Campaigns</span>--><!--</li>--><li class=\"list-group-item campaign\" ng-repeat=\"camp in Dashboard.campaignList\"><span class=heading title={{camp.title}}>{{camp.title}}</span><div class=campaign-content><img ng-src={{camp.imageUrl}} alt=image src=\"\"> <span title={{camp.description}} ng-bind=camp.description></span></div><div class=campaign-button><a class=button ng-class={active:!camp.engaged} href=javascript:void(0) ng-click=Dashboard.openCampaign(camp)>Run Campaign</a> <a class=button ng-class={active:camp.engaged} href=javascript:void(0) ng-click=Dashboard.viewStatus(camp)>View Stats</a></div></li><!--<li class=\"list-group-item\" ng-repeat=\"camp in Dashboard.campaignList\">--><!--<span>{{camp.title}}</span>--><!--<span ng-if=\"!camp.engaged\" ng-click=\"Dashboard.openCampaign(camp)\">Run</span>--><!--<span ng-if=\"camp.engaged\"><a target=\"_blank\" ng-href=\"{{camp.campaignUrl}}\">Status</a></span>--><!--</li>--></ul><!--<ul class=\"todo-list\">--><!--<li class=\"list-group-item group-head\">--><!--<span class=\"cursor-default\">Key Investor List</span>--><!--</li>--><!--<li class=\"list-group-item\">--><!--<a href=\"\" class=\"download-link\"--><!--title=\"Download All Investor Report\"--><!--ng-click=\"Dashboard.downloadReport(\'v1/report/all/investor\',\'All-Investors\')\">--><!--<i class=\"download-blue-icon\"></i>--><!--All Investors--><!--</a>--><!--</li>--><!--<li class=\"list-group-item\">--><!--<a href=\"\" class=\"download-link\"--><!--title=\"Download No ELSS Scheme\"--><!--ng-click=\"Dashboard.downloadReport(\'v1/report/elss/non\',\'No-Investment-in-ELSS-Schemes\')\">--><!--<i class=\"download-blue-icon\"></i>--><!--No Investment in ELSS Schemes--><!--</a>--><!--</li>--><!--<li class=\"list-group-item\">--><!--<a href=\"\" class=\"download-link\"--><!--title=\"Download Non Active SIP\"--><!--ng-click=\"Dashboard.downloadReport(\'v1/report/sip/non\',\'No-Active-SIP\')\">--><!--<i class=\"download-blue-icon\"></i>--><!--No Active SIP--><!--</a>--><!--</li>--><!--</ul>--></div></div><!--<div class=\"card-body analysis-msg\" ng-if=\"Dashboard.autoSuggestionData.length==0\">\n            <div class=\"col-md-12\">\n              <p>We don\'t have any analysis for today. Please check tomorrow.</p>\n            </div>\n          </div>--></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.LEADS\"><div class=\"dash-card drag-it leadsmng\"><div class=\"loader leads-loading\" style=position:absolute><span class=loading></span></div><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Leads Overview</p><div class=pull-right><div class=switch><span ng-class=\"{\'on\': Dashboard.leadsOverviewStatus}\" ng-click=\"Dashboard.changeLeadsOverviewStatusChannel();Dashboard.leadHeading=\'Channels\'\">Channels</span> <span ng-class=\"{\'on\': !Dashboard.leadsOverviewStatus}\" ng-click=\"Dashboard.changeLeadsOverviewStatusInvestment();Dashboard.leadHeading=\'Scheme type\'\">Scheme type</span></div></div></div><div class=card-body><div class=\"col-md-6 channels\"><span ng-bind=\"Dashboard.leadHeading?Dashboard.leadHeading:\'Channels\'\">Channels</span><div class=pie-chart id=piechart-leads></div></div><div class=\"col-md-6 prospect\"><span>Prospect Comparison</span><div class=line-chart id=linechart-leads></div></div></div></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTORS\"><div class=\"dash-card drag-it extras\"><i class=drag-icon></i><div class=\"head container-fluid\"><p class=pull-left>Additional Investor Information</p></div><div class=card-body><div class=\"head-tag text-uppercase\"><span>SIP</span></div><div class=\"col-md-6 data-crumb cursor-pointer\" ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.CANCELLED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.sipCounts.sipsCancelled.count>324</div><div class=col-xs-9><div>Cancelled</div><div ng-bind=Dashboard.investerTrData.sipCounts.sipsCancelled.timePeriod>In last 15 days</div></div></div><div class=\"col-md-6 data-crumb cursor-pointer\" ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.CEASED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.sipCounts.sipsCeased.count>20</div><div class=col-xs-9><div>Ceased</div><div ng-bind=Dashboard.investerTrData.sipCounts.sipsCeased.timePeriod>In last 15 days</div></div></div><div class=\"col-md-6 data-crumb cursor-pointer\" ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.EXPIRED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.sipCounts.sipsExpired.count>30</div><div class=col-xs-9><div>Expired</div><div ng-bind=Dashboard.investerTrData.sipCounts.sipsExpired.timePeriod>In last 15 days</div></div></div><div class=\"col-md-6 data-crumb cursor-pointer\" ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.INSTALLMENTMISSED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.sipCounts.sipsInstallmentMissed.count>267</div><div class=col-xs-9><div>Instalment missed</div><div ng-bind=Dashboard.investerTrData.sipCounts.sipsInstallmentMissed.timePeriod>in 15 days</div></div></div><div class=\"head-tag text-uppercase\"><span>Lumpsum</span></div><div class=\"col-md-6 data-crumb\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.lumsumCounts.fundsRollingOver.count>8</div><div class=col-xs-9><div>Funds Maturing</div><div ng-bind=Dashboard.investerTrData.lumsumCounts.fundsRollingOver.timePeriod>in last 7 days</div></div></div><div class=\"col-md-6 data-crumb\"><div class=\"col-xs-3 text-blue\" ng-bind=Dashboard.investerTrData.lumsumCounts.fundsRolledOver.count>12</div><div class=col-xs-9><div>Funds Matured</div><div ng-bind=Dashboard.investerTrData.lumsumCounts.fundsRolledOver.timePeriod>In last 15 days</div></div></div></div></div></div></div></div><div ng-click=Dashboard.widgetSelection() class=order-dashcards><i class=edit2-icon></i> Widgets Store</div></div></div>");
$templateCache.put("app/dashboard/todos.html","<div class=\"todos main-section\" ng-init=Todos.init();><div class=content-header><h3 class=page-title>To-Do\'s</h3><ul class=list-inline><li><a ui-sref=main.dashboard href=/dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>To-Do List</li></ul></div><div class=\"col-md-8 todos-card\"><div class=row><ul class=todo-list ng-if=Todos.birthdayList.length><li class=\"list-group-item group-head\"><p><span class=checkbox><input type=checkbox id=Todos-doneAllBirthday ng-model=Todos.doneAllBirthday ng-change=Todos.checkBirthdayDoneItemsAll(Todos.birthdayList);> <span class=icon-checkbox></span> </span><span for=Todos-doneAllBirthday>Birthday Alerts</span></p></li><li class=list-group-item ng-repeat=\"pending in Todos.birthdayList | limitTo:Todos.birthdayQuantity\"><span class=checkbox><input type=checkbox ng-model=pending.done ng-change=Todos.checkBirthdayDoneItems(pending,$index);> <span class=icon-checkbox></span> </span><span ng-bind=pending.itemDescription></span><!--<span class=\"text-center\"><button class=\"btn btn-secondary-action\" ng-bind=\"pending.itemAction\"></button></span>--> <span class=text-center ng-bind=pending.itemAction ng-click=Todos.wishSomeone(pending)></span></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.birthdayCount>Todos.birthdayQuantity && Todos.birthdayCount>=5\"><p>More <i class=expand-icon ng-click=Todos.increaseBirthdayLimit();></i></p></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.birthdayCount<Todos.birthdayQuantity && Todos.birthdayCount>=5\"><p>Less <i class=\"collapse-icon cursor-pointer\" ng-click=Todos.decreaseBirthdayLimit();></i></p></li></ul><ul class=todo-list ng-if=Todos.pendingTransactionList.length><li class=\"list-group-item group-head\"><span class=checkbox ng-if=\"Todos.pendingTransactionList.length > 1 && pending.itemAction !== Todos.SELF_DECLARATION\"><input type=checkbox id=Todos-doneAllPending ng-model=Todos.doneAllPending ng-change=Todos.checkPendingDoneItemsAll(Todos.pendingTransactionList);> <span class=icon-checkbox></span> </span><span for=Todos-doneAllPending>Pending Transaction</span><p></p></li><li class=\"list-group-item todo-remind\" ng-repeat=\"pending in Todos.pendingTransactionList | limitTo:Todos.pendingQuantity\"><span class=checkbox><input type=checkbox ng-model=pending.done ng-change=\"Todos.checkPendingDoneItems(pending, $index);\"> <span class=icon-checkbox ng-if=\"pending.itemAction !== Todos.SELF_DECLARATION\"></span> </span><!--          <span ng-bind=\"pending.itemDescription\"></span>--> <span ng-bind=pending.itemDescription ng-class=\"{\'self\':pending.itemAction === Todos.SELF_DECLARATION}\" ng-click=\"pending.itemAction === Todos.SELF_DECLARATION && Todos.sendReminder(pending)\"></span><!--<span class=\"text-center\"><button class=\"btn btn-secondary-action\" ng-bind=\"pending.itemAction\"></button></span>--> <span class=text-center ng-click=\"!pending.validFlag || Todos.sendReminder(pending.transactionId)\" ng-class=\"{\'disabled\':!pending.validFlag}\" ng-bind=pending.itemAction ng-if=\"pending.itemAction !== Todos.SELF_DECLARATION\"></span></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.pendingTransactionCount>Todos.pendingQuantity && Todos.pendingTransactionCount>=5\"><p>More <i class=\"expand-icon cursor-pointer\" ng-click=Todos.increasePendingLimit();></i></p></li><li class=\"list-group-item group-bottom\" ng-if=\"Todos.pendingTransactionCount<Todos.pendingQuantity && Todos.pendingTransactionCount>=5\"><p>Less <i class=\"collapse-icon cursor-pointer\" ng-click=Todos.decreasePendingLimit();></i></p></li></ul><div class=if-error ng-if=\"Todos.birthdayCount == 0 && Todos.pendingTransactionCount == 0\"><i class=smile-icon></i><p>Yippee!!! You have no pending work items!!!</p></div></div></div><div class=col-md-4 ng-if=Todos.completedTodoList.length><div class=completed-tasks><div class=head>Completed Tasks</div><div class=task ng-repeat=\"completed in Todos.completedTodoList\"><p ng-bind=completed.itemDescription></p><p><span ng-if=Todos.completedArray.length>Completed on </span>{{completed.completedDate}}</p></div></div></div></div>");
$templateCache.put("app/deeplinks/deeplinks.html","<header class=deeplink-header><div class=container-one-click><div><a href=https://www.hdfcfund.com/ target=_blank><img src=assets/images/logo-main.png alt=HDFC class=logo></a></div></div></header><div ng-init=Deeplink.init() class=\"deeplink-container height100\"><section><div><span>Download the APP</span></div><div><div class=social-container-index><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&amp;hl=en_IN\" target=_blank><img src=assets/images/google-play.png> </a><a href=https://apps.apple.com/in/app/hdfc-mf-online-investors/id1380088205 target=_blank><img src=assets/images/app-store.svg></a></div></div></section></div><footer class=deeplink-footer><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Investors.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer><style>.deeplink-header {\n    box-shadow: 0 10px 30px rgba(0, 0, 0, .05);\n  }\n  .deeplink-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 768px;\n    margin: auto;\n    height: 450px;\n  }\n  .deeplink-container > section {\n    width: 100%;\n  }\n  .deeplink-container > section > div:first-of-type {\n    text-align: center;\n    font-size: 32px;\n    font-weight: 500;\n    font-family: Poppins;\n    line-height: 16px;\n    padding-bottom: 25px;\n  }\n  .deeplink-container > section > div > .social-container-index {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .deeplink-container > section > div > .social-container-index > a {\n    width: 50%;\n    text-align: center;\n  }\n  .deeplink-container > section > div > .social-container-index > a > img {\n    width: 75%;\n  }\n  .deeplink-footer {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    background: #e7ebee;\n    color: #b6b6b6;\n    overflow: hidden;\n    font-size: 14px;\n    padding: 0px !important;\n  }\n  .flex-style {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }</style>");
$templateCache.put("app/ekyc/ekyc.html","<div class=ekyc-smartlink-container ng-if=EKYCController.isLoaded><login-header></login-header><div><section class=ekyc-wrapper><div class=container><div class=row><div class=col-12><h1 class=ekycHeading>eKYC using Aadhaar</h1><div class=ekycHeadingUnderline></div></div></div><div class=row><div class=col-12><div class=ekycText>Thank you for choosing HDFC Mutual Fund as your investment partner. You can now complete your KYC formalities online in a seamless and convenient manner using your Aadhaar.</div><div class=ekycMainSection><h4 class=\"ekycHeading headingItalic paddingOfFirstInstruction\">Instructions for completing eKYC using Aadhaar:</h4><ul class=\"instructionEKYC lineHeightInstruction\"><li>Enter Mobile number and Email ID and validate the same with One-time password (OTP) sent.</li><li>Enter PAN, validate with KRA system, validate Online with Income Tax database through NSDL.</li><li>Upload PAN card copy (for upload to CKYC).</li><li>Validate your Aadhaar using One-time Password(OTP) through UIDAI Website</li><li>eSign the completed KYC form with an OTP and upload to CAMS eKYC portal.</li></ul><p class=note-ekyc><span>NOTE:</span> On clicking \'Proceed\' button, you shall be redirected to an external application of CAMS Limited for completing your eKYC process.</p><p class=ekycFaqLink><a href=https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/faq/ekyc-faq.pdf target=_blank>Click here</a> for FAQs on eKYC using Aadhaar</p></div><div class=ekycButtonSection><button ng-click=EKYCController.handleProceedAction() class=\"btn btn-primary-action\">Proceed</button></div></div></div></div></section><form autocomplete=off name=ekycForm id=ekycForm method=POST enctype=multipart/form-data action={{EKYCController.actionUrl}}><input id=url type=hidden name=url ng-value=EKYCController.formData.url> <input id=sess_id type=hidden name=sess_id ng-value=EKYCController.formData.sess_id> <input id=ekyctype type=hidden name=ekyctype ng-value=EKYCController.formData.ekyctype> <input id=Plkyc_type type=hidden name=Plkyc_type ng-value=EKYCController.formData.plkyc_type> <input id=kyc_data type=hidden name=kyc_data ng-value=EKYCController.formData.kyc_data></form></div></div>");
$templateCache.put("app/email-templates/abc.html","<!DOCTYPE html><html lang=en><head><meta charset=UTF-8><title>Document</title><style>h1{\n			padding: 30px;\n			background: blue;\n			color: red;\n		}\n		p{\n			padding: 30px;\n			color: green;\n			margin-top: 30px;\n		}</style></head><body><section><h1>hello world</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid nemo at sunt nobis incidunt ipsam temporibus vel possimus impedit eaque vero fugiat qui, voluptate sapiente illo ad ratione consequuntur! Accusantium.</p></section></body></html>");
$templateCache.put("app/equityAsset/equityAsset.html","<div class=equity-asset ng-init=EquityAsset.init()><div class=\"loader EquityAsset\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your data...</span></div><div class=\"upper-head-rectangle d-flex justify-content-space-between\"><div class=\"title set-font-family-monasans set-font-weight-700\">Asset Under Management</div><div class=\"asset-value-allocation-wrapper d-flex\"><div class=\"asset-rect d-flex\"><div class=\"head set-font-family-inter set-font-weight-500 set-color-gray-primary\">Asset Value</div><div class=\"value set-font-family-inter set-font-weight-700 set-color-black-primary\" tooltip-placement=top-left uib-tooltip=\"{{\'₹\'+EquityAsset.assetCompleteData.amount | truncateDecimal : 2 | unitWithDecimal:EquityAsset.assetCompleteData.amount}}\">₹{{EquityAsset.assetCompleteData.amount | truncateDecimal : 2| unitWithDecimal:EquityAsset.assetCompleteData.amount}}</div></div><div class=\"asset-rect d-flex\"><div class=\"head set-font-family-inter set-font-weight-500 set-color-gray-primary\">Allocation</div><div class=\"value set-font-family-inter set-font-weight-700 set-color-black-primary\" tooltip-placement=top-left uib-tooltip=\"{{EquityAsset.assetCompleteData.percentage  | truncateDecimal : 2 | unitWithDecimal: EquityAsset.assetCompleteData.percentage}}%\">{{EquityAsset.assetCompleteData.percentage | truncateDecimal : 2| unitWithDecimal:EquityAsset.assetCompleteData.percentage}}%</div></div></div></div><div class=investors-listing><div id=all class=\"tab-pane fade in active\"><div class=\"search-data-and-filter-wrapper d-flex justify-content-space-between\"><div class=\"search-bar-wrapper d-flex\"><img src=../../assets/images/icons/search.png> <input type=search placeholder=\"Search Scheme\" ng-model=EquityAsset.searchText ng-change=EquityAsset.searchList(); select-on-click class=\"blank-input set-color-gray-black set-font-family-inter set-font-weight-500\"></div><fieldset class=fieldset-modified><!--          <div ng-dropdown-multiselect=\"\" options=\"EquityAsset.TRANSACTION_TYPES\" id=\"transactTypeSIP\"--><!--               selected-model=\"EquityAsset.transactionType\" events=\"EquityAsset.transactionEvents\"--><!--               extra-settings=\"EquityAsset.transactionSettings\" translation-texts=\"EquityAsset.transactionTranslationTexts\"--><!--               class=\"multiselect\">--><!--          </div>--><select class=custom-select ng-model=EquityAsset.selectedAsset ng-init=\"EquityAsset.selectedAsset = EquityAsset.selectedAsset ? EquityAsset.selectedAsset : null\" ng-change=EquityAsset.initEquityAsset(true)><option value=\"\" disabled>Select an option</option><option ng-repeat=\"(key, value) in EquityAsset.assetDropdownList\" value={{value}}>{{key}}</option></select><legend class=\"set-font-family-inter set-font-weight-500\">Scheme Type</legend></fieldset></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"EquityAsset.sortOrder.sortKey=\'NAME\';\" class=\"set-font-family-inter set-font-weight-500 set-color-gray-primary\">Scheme Name</th><th ng-click=\"EquityAsset.sortOrder.sortKey=\'AUM\';\" class=\"set-font-family-inter set-font-weight-500 set-color-gray-primary\">AUM</th><th ng-click=\"EquityAsset.sortOrder.sortKey=\'SCHEME_NAME\';\" class=\"set-font-family-inter set-font-weight-500 set-color-gray-primary\"><span>NAV</span></th><th ng-click=\"EquityAsset.sortOrder.sortKey=\'END_DATE\';\" class=\"set-font-family-inter set-font-weight-500 set-color-gray-primary\">Action</th></tr></thead><tbody><tr ng-if=EquityAsset.assetListData ng-repeat=\"investor in EquityAsset.assetListData\" class=data-tr><td data-th=\"Scheme Name\" class=\"ng-binding textAlignnSIP set-font-family-inter set-font-weight-600 set-color-primary-blue col-md-5\" role=button tabindex=0>{{investor.schemeName}}<br></td><td data-th=AUM class=\"textAlignnSIP set-font-family-inter set-font-weight-500 set-color-black-primary col-md-2\">₹{{investor.totalAmount | truncateDecimal : 2 | unitWithDecimal:investor.totalAmount}}</td><td data-th=Nav class=\"textAlignnSIP set-font-family-inter set-font-weight-500 set-color-black-primary col-md-2\">₹{{investor.currentNav | truncateDecimal : 4 | unitWithDecimal:investor.currentNav}}<div class=\"nav-date set-font-family-inter set-font-weight-500 set-color-gray-primary\">As on {{investor.currentNavDate}}</div></td><td data-th=Action class=\"textAlignnSIP col-md-3\"><div class=\"btn-wrapper d-flex\"><button class=\"btn btn-new-primary-action\" ng-click=EquityAsset.transactNow(investor)>Invest Now</button> <span class=cart-img ng-click=EquityAsset.addToEcart(investor)></span></div></td></tr><tr class=text-center ng-if=\"EquityAsset.assetListData.length == 0\"><td colspan=12>No Record found</td></tr></tbody></table><div class=\"mobile-responsive row\"><div class=\"main-wrapper container\"><div class=\"content-wrapper container\" ng-repeat=\"investor in EquityAsset.assetListData\"><div class=\"col-xs-10 col-sm-10 scheme-name-wrapper\"><div class=\"label-header set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Scheme Name</div><div class=\"scheme-name set-font-family-monasans set-font-weight-600 set-color-black-primary\">{{investor.schemeName}}</div></div><div class=\"col-xs-2 col-sm-2\"><span class=cart-mobile-icon ng-click=EquityAsset.addToEcart(investor)></span></div><div class=\"col-xs-6 aum-wrapper\"><div class=\"label-header set-font-family-monasans set-font-weight-400 set-color-gray-primary\">AUM</div><div class=\"aum set-font-family-monasans set-font-weight-600 set-color-black-primary\">₹{{investor.totalAmount | truncateDecimal : 2 | unitWithDecimal:investor.totalAmount}}</div></div><div class=col-xs-6><div class=\"label-header set-font-family-monasans set-font-weight-400 set-color-gray-primary\">NAV as on {{investor.currentNavDate}}</div><div class=\"nav set-font-family-monasans set-font-weight-600 set-color-black-primary\">₹{{investor.currentNav | truncateDecimal : 4 | unitWithDecimal:investor.currentNav}}</div></div><div class=\"col-xs-12 btn-wrapper\"><button class=\"btn btn-new-primary-action\" ng-click=EquityAsset.transactNow(investor)>Invest Now</button></div></div><div class=text-center ng-if=\"EquityAsset.assetListData.length == 0\">No record found</div></div></div><div ng-if=EquityAsset.isPagination class=\"pagination-wrapper no-overflow\"><ul uib-pagination total-items=EquityAsset.totalCount ng-model=EquityAsset.currentPageSystematicList max-size=5 items-per-page=EquityAsset.selectedPageLimit class=pagination boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=EquityAsset.initEquityAsset() rotate=false></ul><div><span>Showing</span> <span>{{EquityAsset.fromText}}-{{EquityAsset.toText}}</span> <span>of</span> <span class=t-black>{{EquityAsset.totalCount}}</span></div></div></div></div><div class=\"post-login-ecart-journey main-section-ecart\" ng-if=EquityAsset.showEcartModel><div class=sidebar-container id=sidebarContainer hdfc-post-login-ecart-sidebar side-title=EquityAsset.sidebarTitle cart-item=EquityAsset.ecartData show-add-cart=EquityAsset.showAddCart from-equity-asset=EquityAsset.isFromEquityAsset close-action=EquityAsset.closeAction(action)></div></div></div>");
$templateCache.put("app/euinDetails/euinDetails.html","<div class=euin-detais-main-container ng-init=EuinDetails.init()><div class=main-container><div class=title-container><div class=\"title set-font-family-inter set-font-weight-700 set-color-primary-blue\">EUIN Details</div></div><div class=content-container><div class=\"search-container d-flex justify-content-space-between\"><div class=\"search-bar-wrapper d-flex\"><img src=../../assets/images/icons/search.png> <input type=search placeholder=\"Search by Name, EUIN\" ng-model=EuinDetails.searchText ng-change=EuinDetails.searchList(); select-on-click class=\"blank-input set-color-gray-black set-font-family-inter set-font-weight-500\"></div><div class=dropdown-wrapper><select class=custom-select-small ng-model=EuinDetails.selectedTimePeriodForEuinDetails ng-options=\"item as item.value for item in EuinDetails.EUIN_DETAILS_DROPDOWN_VALUES\" ng-init=\"EuinDetails.selectedTimePeriodForEuinDetails = EuinDetails.EUIN_DETAILS_DROPDOWN_VALUES[0]\" ng-change=EuinDetails.changeEuinTimePeriod()></select></div></div><div class=row ng-repeat=\"data in EuinDetails.euinDetailsListData\"><div class=\"content-wrapper col-md-12\"><div class=\"name-wrapper col-md-6 col-sm-5 col-xs-12\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">Name</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">{{data.euinName}}</div></div><div class=\"euin-wrapper col-md-4 col-sm-4 col-xs-8\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">EUIN</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">{{data.euinCode}}</div></div><div class=\"sale-wrapper col-md-2 col-sm-3 col-xs-4\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">Gross Sale</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">₹{{data.grossSales|unitWithOutDecimalFilter:EuinDetails.getUnit(data.grossSales)}}</div></div></div></div><div ng-if=\"EuinDetails.euinDetailsListData.length == 0\" class=\"d-flex justify-content-center\">No record found</div></div><div class=\"pagination d-flex justify-content-center\"><div ng-if=EuinDetails.isPagination class=\"pagination-wrapper no-overflow\"><ul uib-pagination total-items=EuinDetails.totaleuinDetailsListData ng-model=EuinDetails.currentPageEuinList max-size=5 items-per-page=EquityAsset.selectedPageLimit class=pagination boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=EuinDetails.initEuinDetails() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/faq/faq.html","<div class=distributor-empanellment><header class=header><div class=head-contrast><ul><li ng-click=\"Faq.changedFont(\'increment\')\" title=\"Increase font size\" role=button tabindex=0>A+</li><li ng-click=\"Faq.changedFont(\'original\')\" title=\"Reset font size\" role=button tabindex=0>A</li><li ng-click=\"Faq.changedFont(\'decrement\')\" title=\"Decrease font-size\" role=button tabindex=0>A-</li><li ng-click=Faq.contrast() title=\"High Contrast\" class=contrast-box role=button tabindex=0><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left header-main-logo\"> <img src=assets/images/logo.png alt=HDFC class=\"logo pull-left header-mfpartner-logo\"><div class=\"pull-right right-panel\"><div class=faq><a href=javascript:void(0) ui-sref=login class=header-tab><span class=\"block header-font-size\">Home</span></a></div></div></header><div ng-include=\"\'app/faq/faq.section.html\'\"></div></div>");
$templateCache.put("app/faq/faq.section.html","<!--dynamic data faq--><ng-bind-html dynamic=Faq.DynamicDataFaq.content></ng-bind-html>");
$templateCache.put("app/feedback/feedback.html","<div class=\"main-section feedback\"><div class=content-area><div class=content-head><h3>We value your feedback and comments</h3><p>Please do share your views below. It will help us serve you better in your Digital Journey.</p></div><div class=content-body><form autocomplete=off name=feedbackForm novalidate ng-submit=Feedback.submitFeedback()><div class=row><div class=col-md-1>Subject :</div><div class=col-md-11><div class=feedback-radio><input type=radio name=feedback ng-model=Feedback.formData.feedback id=improvement ng-change=Feedback.changeFeedback() value=IMPROVEMENT><label for=improvement>Improvement</label></div><div class=feedback-radio><input type=radio name=feedback ng-model=Feedback.formData.feedback id=newFeature ng-change=Feedback.changeFeedback() value=NEW_FEATURE><label for=newFeature>New Feature</label></div><div class=feedback-radio><input type=radio name=feedback ng-model=Feedback.formData.feedback id=others ng-change=Feedback.changeFeedback() value=OTHERS><label for=others>Others</label></div></div></div><div class=row><div class=col-md-1>Message :</div><div class=col-md-11><textarea ng-model=Feedback.formData.feedbackArea placeholder=\"Please type your message here...\" maxlength=300 ng-change=Feedback.formInputChange()></textarea><p class=error-input ng-if=\"Feedback.formData.feedbackArea && Feedback.isInValid\" style=\"padding: 10px 0px\" ng-bind=Feedback.constant.FEEDBACK_FORM_ERR0R></p><span class=limits>Remaining characters {{300-(Feedback.formData.feedbackArea.length)}}</span><p><button type=button ng-click=Feedback.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button type=submit class=\"btn btn-primary-action\" ng-disabled=\"!Feedback.formData.feedbackArea || (Feedback.formData.feedbackArea && Feedback.isInValid)\">Submit</button></p></div></div></form></div></div></div>");
$templateCache.put("app/financialPlanningTool/financial-planning-initiate.html","<div class=\"financial-planning main-section\" ng-if=FinancialPlanningTool.newPlanning><div class=\"clearfix mgb20\"><h3 class=\"page-title pull-left\">Financial Planning</h3><button class=\"pull-right btn btn-primary-action\" type=button ng-click=FinancialPlanningTool.startPlanning()>Plan Investment</button></div><section class=content><div class=row><div class=col-md-12><div class=box><h2>You have not used the <span>Financial Planning</span> for any Investors</h2><span><i class=calculator-icon></i></span><p><a href=javascript:void(0) ng-click=FinancialPlanningTool.startPlanning()>Start Planning now <i class=forward-arrow-icon></i></a></p></div></div></div></section></div>");
$templateCache.put("app/financialPlanningTool/financial-planning-list.html","<div class=\"financial-planning-tool main-section\" ng-if=!FinancialPlanningTool.newPlanning><div class=\"clearfix mgb20\"><h3 class=\"page-title pull-left\">Financial Planning</h3><div class=pull-right><small>New Investors*</small> <button class=\"btn btn-primary-action\" type=button ng-click=FinancialPlanningTool.startPlanning()>Plan Investment</button></div></div><section class=content><div class=row><div class=col-md-12><div class=box><div class=\"sort-options text-center\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==0}\" ng-click=\"FinancialPlanningTool.tabChange(\'ALL\')\">All</button> <button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==1}\" ng-click=\"FinancialPlanningTool.tabChange(\'EXISTING\')\">Existing Investors</button> <button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==2}\" ng-click=\"FinancialPlanningTool.tabChange(\'PROSPECT\')\">Prospect Investors</button></div></div>{{FinancialPlanningTool.financialPlanningList}}<div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name</th><th>Mobile No</th><th>Email ID</th><th>PAN No</th><th>Last Updated</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in  FinancialPlanningTool.financialPlanningList\"><td>{{item.investorName}}</td><td>{{item.mobileNumber}}</td><td>{{item.emailId}}</td><td>{{item.panNumber}}</td><td>{{item.lastUpdated}}</td><td data-th=Action ng-if=\"item.action.length==1\"><button type=button class=\"btn btn-purple-alt\" ng-click=FinancialPlanningTool.startPlanning(item.fivenanceInvestorId)>{{item.action[0]}}</button></td><td data-th=Action ng-if=\"item.action.length==2\"><button type=button class=\"btn btn-purple-alt btn-report\" ng-click=FinancialPlanningTool.downloadReport(item.reportLink)><i class=pdf-icon></i>{{item.action[0]}}</button> <button type=button class=\"btn btn-purple-alt btn-replan\" ng-click=FinancialPlanningTool.startPlanning(item.fivenanceInvestorId)>{{item.action[1]}}</button></td></tr><tr ng-if=\"FinancialPlanningTool.financialPlanningList.length==0 && !FinancialPlanningTool.isLoading\"><td colspan=8>No Record found</td></tr></tbody></table><div ng-if=FinancialPlanningTool.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"FinancialPlanningTool.totalCount <= FinancialPlanningTool.PAGE_LIMITS[0]\" ng-bind=FinancialPlanningTool.totalCount></span><select ng-if=\"FinancialPlanningTool.totalCount > FinancialPlanningTool.PAGE_LIMITS[0]\" ng-change=FinancialPlanningTool.limitChanged() ng-model=FinancialPlanningTool.selectedPageLimit ng-options=\"_limit as _limit for _limit in FinancialPlanningTool.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black>{{FinancialPlanningTool.totalCount}}</span></div><ul uib-pagination total-items=FinancialPlanningTool.totalCount ng-model=FinancialPlanningTool.currentPage max-size=5 items-per-page=FinancialPlanningTool.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=FinancialPlanningTool.getPlanningList() rotate=false></ul></div></div></div></div></div></section></div>");
$templateCache.put("app/financialPlanningTool/financial-planning-tool.html","<div ng-init=FinancialPlanningTool.init()><div class=\"financial-planning main-section\" ng-if=FinancialPlanningTool.newPlanning><div class=\"clearfix mgb20\"><h3 class=\"page-title pull-left\">Financial Planning</h3><button class=\"pull-right btn btn-primary-action\" type=button ng-click=FinancialPlanningTool.startPlanning()>Plan Investment</button></div><section class=content><div class=row><div class=col-md-12><div class=box><h2>You have not used the <span>Financial Planning</span> for any Investors</h2><span><i class=calculator-icon></i></span><p><a href=javascript:void(0) ng-click=FinancialPlanningTool.startPlanning()>Start Planning now <i class=forward-arrow-icon></i></a></p></div></div></div></section></div><div class=\"financial-planning-tool main-section\" ng-if=\"!FinancialPlanningTool.newPlanning && FinancialPlanningTool.showList\"><div class=\"clearfix mgb20\"><h3 class=\"page-title pull-left\">Financial Planning</h3><div class=pull-right><small>New Investors*</small> <button class=\"btn btn-primary-action\" type=button ng-click=FinancialPlanningTool.startPlanning()>Plan Investment</button></div></div><section class=content><div class=row><div class=col-md-12><div class=box><div class=\"sort-options text-center\"><div class=btn-group><button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==0}\" ng-click=\"FinancialPlanningTool.tabChange(\'ALL\')\">All</button> <button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==1}\" ng-click=\"FinancialPlanningTool.tabChange(\'EXISTING\')\">Existing Investors</button> <button type=button class=\"btn btn-default\" ng-class=\"{active:FinancialPlanningTool.tabindex==2}\" ng-click=\"FinancialPlanningTool.tabChange(\'PROSPECT\')\">Prospect Investors</button></div></div><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name</th><th>Mobile No</th><th>Email ID</th><th>PAN No</th><th>Last Updated</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in  FinancialPlanningTool.financialPlanningList\"><td>{{item.investorName}}</td><td>{{item.mobileNumber}}</td><td>{{item.emailId}}</td><td>{{item.panNumber}}</td><td>{{item.lastUpdated}}</td><td data-th=Action ng-if=\"item.action.length==1\"><button type=button class=\"btn btn-purple-alt\" ng-click=FinancialPlanningTool.startPlanning(item.fivenanceInvestorId)>{{item.action[0]}}</button></td><td data-th=Action ng-if=\"item.action.length==2\"><button type=button class=\"btn btn-purple-alt btn-report\" ng-click=FinancialPlanningTool.downloadReport(item.reportLink)><i class=pdf-icon></i>{{item.action[0]}}</button> <button type=button class=\"btn btn-purple-alt btn-replan\" ng-click=FinancialPlanningTool.startPlanning(item.fivenanceInvestorId)>{{item.action[1]}}</button></td></tr><tr ng-if=\"FinancialPlanningTool.financialPlanningList.length==0 && !FinancialPlanningTool.isLoading\"><td colspan=8>No Record found</td></tr></tbody></table><div ng-if=FinancialPlanningTool.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"FinancialPlanningTool.totalCount <= FinancialPlanningTool.PAGE_LIMITS[0]\" ng-bind=FinancialPlanningTool.totalCount></span><select ng-if=\"FinancialPlanningTool.totalCount > FinancialPlanningTool.PAGE_LIMITS[0]\" ng-change=FinancialPlanningTool.limitChanged() ng-model=FinancialPlanningTool.selectedPageLimit ng-options=\"_limit as _limit for _limit in FinancialPlanningTool.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black>{{FinancialPlanningTool.totalCount}}</span></div><ul uib-pagination total-items=FinancialPlanningTool.totalCount ng-model=FinancialPlanningTool.currentPage max-size=5 items-per-page=FinancialPlanningTool.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=FinancialPlanningTool.getPlanningList() rotate=false></ul></div></div></div></div></div></section></div></div>");
$templateCache.put("app/forgotPassword/forgotPassword.html","<login-header></login-header><hdfc-login-sidebar></hdfc-login-sidebar><div class=\"container-fluid forgot-password-container\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=Forgot.goBack();><i class=back-icon></i></a></div><div class=forgot-form-container><form autocomplete=off name=Forgot.forgotPasswordForm ng-submit=Forgot.forgotPassword() novalidate><h2 class=info>Forgot <span class=partner-blue>Password?</span></h2><div class=input-normal ng-class=\"{error:Forgot.forgotPasswordForm.arnCode.$dirty && Forgot.forgotPasswordForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input name=arnCode ng-model=Forgot.forgotPasswordPayload.arnCode ng-change=Forgot.clearModal(); type=text capitalize maxlength=10 placeholder=ARN ng-pattern=Forgot.appConstants.arn_regex required class=arn-no> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span> <span ng-show=\"Forgot.forgotPasswordForm.arnCode.$dirty && Forgot.forgotPasswordForm.arnCode.$invalid\"><span ng-if=\"(Forgot.forgotPasswordForm.arnCode.$error.required) || (Forgot.forgotPasswordForm.arnCode.$error.pattern && Forgot.forgotPasswordForm.arnCode.$invalid )\" class=ng-hide>{{Forgot.wrongARNmsg}}</span> <span class=error-input ng-show=Forgot.forgotPasswordForm.arnCode.$error.required ng-bind=Forgot.validateData.ARN_REQUIRED></span> <span class=error-input ng-show=\"Forgot.forgotPasswordForm.arnCode.$error.pattern && Forgot.forgotPasswordForm.arnCode.$invalid \" class=help-block>{{ Forgot.validateData.ARN_FIELD }} </span></span><br><span><span class=error-input ng-bind=Forgot.wrongARNmsg style=\"color: #d42113\"></span></span></div><div class=input-normal ng-class=\"{error:Forgot.forgotPasswordForm.pan.$dirty && Forgot.forgotPasswordForm.pan.$invalid && Forgot.forgotPasswordForm.pan.$touched}\"><label>PAN<span class=req>*</span></label><input type=text name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Forgot.forgotPasswordPayload.pan placeholder=\"Enter PAN\" capitalize required autocomplete=off> <span ng-messages=Forgot.forgotPasswordForm.pan.$error ng-show=\"Forgot.forgotPasswordForm.pan.$dirty && Forgot.forgotPasswordForm.pan.$invalid\"><span class=error-input ng-message=required ng-bind=Forgot.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Forgot.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Forgot.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Forgot.validateData.PAN_FIELD></span> </span><br></div><!--<div ng-if=\"Forgot.showCaptcha\">\n              <div class=\"input-normal\" vc-recaptcha key=\"Forgot.publicKey\" ng-model=\"Forgot.gRecaptchaResponse\"></div>\n            </div>--><div class=form-action-container><button type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=Forgot.goBack();>Back</button> <button class=\"btn btn-primary-action btn-block\" ng-disabled=\"Forgot.forgotPasswordForm.$invalid || Forgot.processFlag\">Submit</button></div></form></div></div></div></div></div><hdfc-footer></hdfc-footer>");
$templateCache.put("app/globalSearch/search-result.html","<div class=\"search-results main-section\" ng-init=GlobalSearch.init()><p class=search-count>Total {{GlobalSearch.count}} Search Results</p><div class=row><div class=col-md-12><div class=result-head><h5><strong>Investors</strong></h5></div><div class=result-body><div class=result-block ng-repeat=\"result in GlobalSearch.searchResult\"><p class=text-blue><span ng-click=GlobalSearch.investorDetails(result)>{{result.name}}</span></p><table class=\"table borderless\"><tr><td>Email:</td><td>{{result.email}}</td></tr><tr><td>Mobile:</td><td>{{result.mobileNumber}}</td></tr><tr><td>PAN:</td><td>{{result.panNumber}}</td></tr></table></div><div class=\"text-center no-record\" ng-if=\"!(GlobalSearch.count >0) && !GlobalSearch.isLoading\">No Record found</div></div><div ng-if=GlobalSearch.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"GlobalSearch.count <= GlobalSearch.PAGE_LIMITS[0]\" ng-bind=GlobalSearch.count></span><select ng-if=\"GlobalSearch.count > GlobalSearch.PAGE_LIMITS[0]\" ng-change=GlobalSearch.limitChanged() ng-model=GlobalSearch.selectedPageLimit ng-options=\"_limit as _limit for _limit in GlobalSearch.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=GlobalSearch.count></span></div><ul uib-pagination total-items=GlobalSearch.count ng-model=GlobalSearch.currentPage max-size=5 items-per-page=GlobalSearch.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=GlobalSearch.init() rotate=false></ul></div></div><!--...............................................................--><!--   DO NOT DELETE THIS CODE -------- TO BE DONE IN NEXT PHASE     --><!--...............................................................--><!--<div class=\"col-md-6\">--><!--<div class=\"result-head\">--><!--<h5><strong>Transactions</strong></h5>--><!--</div>--><!--<div class=\"result-body\">--><!--<div class=\"result-block\">--><!--<p class=\"text-blue\">Sumit Kumar</p>--><!--<table class=\"table borderless\">--><!--<tr>--><!--<td>Email:</td>--><!--<td>abc@abc.com</td>--><!--</tr>--><!--<tr>--><!--<td>Mobile:</td>--><!--<td>+91 39204492832</td>--><!--</tr>--><!--<tr>--><!--<td>PAN:</td>--><!--<td>ARPO109393</td>--><!--</tr>--><!--<tr>--><!--<td>Status:</td>--><!--<td class=\"green\">Processed</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<hr />--><!--<div class=\"result-block\">--><!--<p class=\"text-blue\">Sumit Kumar</p>--><!--<table class=\"table borderless\">--><!--<tr>--><!--<td>Email:</td>--><!--<td>abc@abc.com</td>--><!--</tr>--><!--<tr>--><!--<td>Mobile:</td>--><!--<td>+91 39204492832</td>--><!--</tr>--><!--<tr>--><!--<td>PAN:</td>--><!--<td>ARPO109393</td>--><!--</tr>--><!--<tr>--><!--<td>Status:</td>--><!--<td class=\"red\">Rejected</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<hr />--><!--<div class=\"result-block\">--><!--<p class=\"text-blue\">Sumit Kumar</p>--><!--<table class=\"table borderless\">--><!--<tr>--><!--<td>Email:</td>--><!--<td>abc@abc.com</td>--><!--</tr>--><!--<tr>--><!--<td>Mobile:</td>--><!--<td>+91 39204492832</td>--><!--</tr>--><!--<tr>--><!--<td>PAN:</td>--><!--<td>ARPO109393</td>--><!--</tr>--><!--<tr>--><!--<td>Status:</td>--><!--<td class=\"green\">Processed</td>--><!--</tr>--><!--</table>--><!--</div>--><!--<hr />--><!--<div class=\"result-block\">--><!--<p class=\"text-blue\">Sumit Kumar</p>--><!--<table class=\"table borderless\">--><!--<tr>--><!--<td>Email:</td>--><!--<td>abc@abc.com</td>--><!--</tr>--><!--<tr>--><!--<td>Mobile:</td>--><!--<td>+91 39204492832</td>--><!--</tr>--><!--<tr>--><!--<td>PAN:</td>--><!--<td>ARPO109393</td>--><!--</tr>--><!--<tr>--><!--<td>Status:</td>--><!--<td class=\"green\">Processed</td>--><!--</tr>--><!--</table>--><!--</div>--><!--</div>--><!--</div>--></div></div>");
$templateCache.put("app/home/home.html","<div ng-init=Home.init()><section class=\"main-loader distributor-empanellment\" style=\"display: block\" ng-if=Home.investorProfile.firstTimeLogin><header class=header><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></header><p class=blacktintLoad></p><div class=loader-box style=\"width: 45%\"><div class=video><iframe width=570 height=315 src=\"https://www.youtube.com/embed/lzc6qc8Gf-g?autoplay=1\" frameborder=0 allowfullscreen></iframe><p ng-if=!Home.showContinue>Please wait while we fetch your details.</p><img ng-if=!Home.showContinue src=../assets/images/loader_web.gif alt=loader class=loader-gif><p ng-if=Home.showContinue>Your details are ready.</p><span class=text-blue style=\"position: relative;top:10px;font-size:16px;font-weight: bold\" ng-if=Home.showContinue ng-click=Home.moveToDashboard()>Continue <i style=top:4px class=arrow-short-right-icon></i></span></div></div></section><div class=\"main-loader distributor-empanellment\" id=loginLoader><header class=header><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></header><p class=blacktintLoad></p><div class=loader-box><div class=loader-box-content><img src=../assets/images/logo-main.png alt=HDFC> <img src=../assets/images/logo.png alt=\"Partner\'s Logo\"><h3>Welcome {{Home.investorProfile?Home.investorProfile.distributorName:\'Distributor\'}}!</h3><p>Please wait while we fetch your details.</p><!--<span class=\"outbar\">--><!--<span class=\"progress-bar innerbar progress-bar-striped active\" role=\"progressbar\">--><!--</span>--><!--</span>--> <img src=../assets/images/loader_web.gif alt=loader class=loader-gif></div></div></div></div>");
$templateCache.put("app/investors/inestors-creation.html","<div class=\"investors-creation main-section\"><div class=content-wrapper><section class=content-header><h2 class=text-uppercase>Investor</h2><ol class=breadcrumb><li><a href=# class=text-blue>Dashboard</a></li><li class=active>Add Investor</li></ol></section><section class=content><div class=row><div class=col-md-12><div class=box><div class=\"box-header bottom-bar\"><h1 class=\"box-title text-blue\">Investor - <strong>Aakash Sharma</strong> <small class=kyc-check>(KYC Verified)</small></h1><h3 class=text-blue>Pan Number - <strong class=text-uppercase>AAGPQ3608N</strong></h3></div><div class=box-body><div class=row><!--Form Progress Bar--><div class=container><div class=\"row bs-wizard\"><div class=\"col-xs-3 col-xs-offset-1 bs-wizard-step active\"><!--active--><div class=progress><div class=progress-bar></div></div><a href=# class=bs-wizard-dot></a><div class=\"bs-wizard-info text-center\">Create Folio</div></div><div class=\"col-xs-3 bs-wizard-step disabled\"><!--disabled--><div class=progress><div class=progress-bar></div></div><a href=# class=bs-wizard-dot></a><div class=\"bs-wizard-info text-center\">Add Scheme</div></div><div class=\"col-xs-3 bs-wizard-step disabled\"><!--disabled--><div class=progress><div class=progress-bar></div></div><a href=# class=bs-wizard-dot></a><div class=\"bs-wizard-info text-center\">Select Payment Mode</div></div></div></div></div><div class=row><h4>Additional Details of sole applicant</h4><div class=col-md-6><select><option>Tax Status</option></select><select><option>Gross Annual Income</option></select></div><div class=col-md-6><select><option>Occupation</option></select><input type=text value=\"Net worth(in Rs.)\"> <input type=date value=\"As on DD/MM/YYYY\"> <small>(Not older than 1yr)</small></div></div><div class=row><h4>Please select this investor’s political exposure</h4><form autocomplete=off><div class=radio><label><input type=radio name=optradio>Investor is politically exposed person.</label></div><div class=radio><label><input type=radio name=optradio>Investor is related to a politically exposed person.</label></div><div class=radio><label><input type=radio name=optradio>None of the above.</label></div></form></div><div class=row><h4>FATCA or CRS information</h4><select><option>Address Type</option></select><h4>Does the investor pay or file tax other than India?</h4><label><input type=radio name=optradio>Yes</label><label><input type=radio name=optradio>No</label><span>Tax Residency Country 1</span><i class=delete-icon></i><span>Remove</span><div class=col-md-6><select><i class=search-icon></i><option>Name of country</option></select><select><option>Select Tax ID type</option></select></div><div class=col-md-6><select><i class=search-icon></i><option>City of birth</option></select><input type=text value=\"Tax ID number\"></div><span>Tax Residency Country 2</span><div class=delete><i class=delete-icon></i> <span>Remove</span></div><div class=col-md-6><select><i class=search-icon></i><option>Name of country</option></select><select><option>Select Tax ID type</option></select></div><div class=col-md-6><select><i class=search-icon></i><option>City of birth</option></select><input type=text value=\"Tax ID number\"></div><p><i class=blue-plus-icon></i> <span>Add another tax residency country</span></p></div></div></div></div></div></section></div></div>");
$templateCache.put("app/investors/investors.html","<agent-sidebar ng-if=\"Investors.loginType==\'A\'\"></agent-sidebar><div class=\"main-section investors clearfix\" id=investors ng-class=\"{\'transaction-screens--agent\' : Investors.loginType == \'A\'}\"><div ui-view></div></div>");
$templateCache.put("app/leap-academy/leap-academy.html","<div class=\"leap-academy main-section\"><div class=\"clearfix top-head\"><h3 class=\"page-title pull-left\">Leap Academy</h3><a ng-click=LeapAcademy.showVideo(); target=_blank class=\"pull-right cursor-pointer\"><i class=video-icon></i>How Leap Academy Works?</a></div><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.leapacademy.training-classes>Training Classes</a></li><li ui-sref-active=active><a ui-sref=main.leapacademy.pdf-articles>Articles</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/login/login.html","<div ng-if=\"Login.ENV != Login.RUNNING_MODE.MAINTENANCE && Login.isMactive != true\"><login-header></login-header><hdfc-login-sidebar></hdfc-login-sidebar><div class=\"login-section container-fluid\"><div class=\"row row-flex carousel-and-login-wrapper\"><div class=\"col-sm-12 col-md-6 carousel-main-wrapper\"><div class=\"banner-container height100\"><div id=banner class=\"carousel slide height100\" data-ride=carousel><!-- Indicators --><ol class=carousel-indicators><li data-target=#banner data-slide-to={{$index}} ng-class=\"{\'active\': $index === 0}\" ng-repeat=\"image in Login.imageUrls track by $index\"></li></ol><!-- Wrapper for slides --><div class=carousel-inner role=listbox><div class=\"item height100\" ng-repeat=\"image in Login.imageUrls track by $index\" ng-class=\"{\'active\': $index === 0}\"><a href={{image.redirectUrl}} class=height100 ng-if=image.redirectUrl><img src={{image.image}} alt=image.text></a><div style=background-image:url({{image.image}}) class=\"height100 dynamic-carousel-img\" ng-if=\"!image.redirectUrl && image.image\"></div><div class=\"carousel-caption height100\">{{image.text}}</div></div></div><!-- Controls --><!--<a class=\"left carousel-control\" href=\"#banner\" role=\"button\" data-slide=\"prev\">\n              <span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span>\n              <span class=\"sr-only\">Previous</span>\n            </a>\n            <a class=\"right carousel-control\" href=\"#banner\" role=\"button\" data-slide=\"next\">\n              <span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span>\n              <span class=\"sr-only\">Next</span>\n            </a>--></div></div></div><div class=\"col-sm-12 col-md-6\" id=login-section><div class=\"container-fluid form-container\"><div class=\"col-md-12 form-section\"><div class=form-section-header><ul class=\"nav nav-pills nav-justified\" role=tablist><li role=presentation class=active><a href=#MFD aria-controls=MFD role=tab data-toggle=tab>MFD</a></li><li role=presentation ng-if=Login.isEnable><a href=#EUIN aria-controls=EUIN role=tab data-toggle=tab>EUIN</a></li></ul></div><div class=tab-content><div role=tabpanel class=\"tab-pane active\" id=MFD><div class=head><h3 class=cursor-pointer ng-class={active:!Login.loginUsingOtpFlag} ng-click=Login.loginViaPassword()>Login with Password</h3><h3 class=cursor-pointer ng-class={active:Login.loginUsingOtpFlag} ng-click=Login.loginViaOtp()>Login with PAN</h3></div><form autocomplete=off name=Login.loginForm autocomplete=false ng-submit=Login.submitLogin() novalidate><div class=row ng-if=!Login.showOtpField><div class=col-md-12><div class=input-normal ng-class=\"{error:Login.loginForm.arnCode.$dirty && Login.loginForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input name=arnCode ng-model=Login.loginPayload.arnCode type=text id=arnCodeId class=arn-no capitalize maxlength=10 ng-pattern=Login.appConstants.arn_regex ng-change=Login.reset() placeholder=ARN ng-blur=Login.fetchCaptchaCount() required><!--<span class=\"arn\">ARN -</span>--> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span> <span ng-show=\"Login.loginForm.arnCode.$dirty && Login.loginForm.arnCode.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.arnCode.$error.required ng-bind=Login.validateData.ARN_REQUIRED></span> <span class=\"error-input help-block text-left\" ng-show=\"Login.loginForm.arnCode.$error.pattern && Login.loginForm.arnCode.$invalid\"></span> </span><span class=info-primary ng-if=Login.loginUsingOtpFlag ng-bind=Login.sentOtpRespMsg></span></div><div class=\"col-md-6 unlock-arn-wrapper\"><span class=\"pull-left secondary-action\"><a href=javascript:void(0) ui-sref=unlockArn.main>Unlock ARN</a></span></div></div></div><!--                  <div class=\"row\" ng-if=\"!Login.showOtpField\">--><!--                    <div class=\"col-md-12\">--><!--                      <span class=\"pull-left secondary-action\">--><!--                        <a href=\"javascript:void(0)\" ui-sref=\"unlockArn.main\">Unlock ARN</a>--><!--                      </span>--><!--                    </div>--><!--                  </div>--><div class=row ng-if=!Login.showOtpField><div class=col-md-12><div class=input-normal ng-if=!Login.loginUsingOtpFlag ng-class=\"{error:Login.loginForm.password.$dirty && Login.loginForm.password.$invalid}\"><label>Password<span class=req>*</span></label><input id=passwordId name=password type={{Login.passwordType}} placeholder=\"Enter Password\" ng-model=Login.loginPayload.password required autocomplete=off easyassist-key=mask-element><div class=input-controls><span class=inputTxt><span class=password-toggle><img src=../../../assets/images/showPass-blue.svg ng-if=\"Login.passwordType !== \'password\'\" ng-click=Login.showPassword() alt=open-eye> <img src=../../../assets/images/blind-blue.svg ng-if=\"Login.passwordType === \'password\'\" ng-click=Login.showPassword() alt=close-eye></span></span></div><span class=highlight></span> <span class=bar></span> <span ng-show=\"Login.loginForm.password.$dirty && Login.loginForm.password.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div><div style=margin-bottom:30px class=input-normal ng-if=Login.loginUsingOtpFlag ng-class=\"{error:Login.loginForm.pan.$dirty && Login.loginForm.pan.$invalid}\"><label>PAN<span class=req>*</span></label><input id=panId name=pan placeholder=\"Enter PAN\" type=text ng-model=Login.loginPayload.pan capitalize maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ required autocomplete=off easyassist-key=mask-element> <span ng-show=\"Login.loginForm.pan.$dirty && Login.loginForm.pan.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.pan.$error.required ng-bind=Login.validateData.PAN_REQUIRED></span> <span class=\"error-input text-left\" ng-show=Login.loginForm.pan.$error.minlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=\"error-input text-left\" ng-show=Login.loginForm.pan.$error.maxlength ng-bind=Login.validateData.PAN_FIELD></span> <span class=\"error-input text-left\" ng-show=Login.loginForm.pan.$error.pattern ng-bind=Login.validateData.PAN_FIELD></span></span></div><div class=\"col-md-6 forgot-pass-wrapper\" ng-if=\"!Login.loginUsingOtpFlag && !Login.showOtpField\"><span class=\"pull-left secondary-action\"><a href=javascript:void(0) ng-click=Login.forgotPassword()>Forgot Password?</a></span></div></div></div><!--                  <div class=\"row\" ng-if=\"!Login.loginUsingOtpFlag && !Login.showOtpField\">--><!--                    <div class=\"col-md-12\">--><!--                      <span class=\"pull-left secondary-action\">--><!--                          <a href=\"javascript:void(0)\" ng-click=\"Login.forgotPassword()\">Forgot Password?</a>--><!--                      </span>--><!--                    </div>--><!--                  </div>--><div class=row ng-if=Login.showOtpField><div class=col-md-12><div class=form-heading-section><p class=form-heading>Enter One-time Password (OTP)</p><p class=sub-heading>{{Login.sentOtpRespMsg}}</p></div><div class=\"input-normal input-code\" ng-if=Login.showOtpField ng-class=\"{error:Login.loginForm.otpNumber.$dirty && Login.loginForm.otpNumber.$invalid}\"><label>Enter OTP<span class=req>*</span></label><div class=input-code-container><input type=tel id=otp-number-input-1 class=otp-number-input minlength=1 maxlength=1 tabindex=1 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex1 is-number custom-auto-focus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=otp-number-input minlength=1 maxlength=1 tabindex=2 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=otp-number-input minlength=1 maxlength=1 tabindex=3 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=otp-number-input minlength=1 maxlength=1 tabindex=4 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=otp-number-input minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=otp-number-input minlength=1 maxlength=1 tabindex=6 autocomplete=off ng-change=Login.otpValChanged(this) ng-model=Login.otpValIndex6 is-number easyassist-key=mask-element></div><div class=forgot><timer countdown=Login.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd><span class=link-text>Enable Resend OTP</span> in <span class=counter-text>{{countdown}} seconds</span> </span><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Login.reGenerateOtp(); class=\"forgot-pwd resend-otp-txt\">Resend OTP</a></timer></div><span ng-show=\"Login.loginForm.otpNumber.$dirty && Login.loginForm.otpNumber.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.otpNumber.$error.required ng-bind=Login.validateData.OTP_REQUIRED></span> <span class=info-primary style=left:13% ng-if=Login.loginUsingOtpFlag ng-bind=Login.otpResendMessage></span></span></div></div></div><div class=row><div class=col-md-12><!--<div style=\"margin-top:10px;\" class=\"form-group re_cap\" ng-if=\"(Login.showOtpField && Login.generateOtpFlag) && !Login.resetCaptcha && Login.showCaptcha\">\n                        <div vc-recaptcha key=\"Login.publicKey\" ng-model=\"Login.gRecaptchaResponse\"></div>\n                      </div>--><div style=margin-top:10px class=\"form-group re_cap\" ng-if=\"(!Login.showOtpField && Login.generateOtpFlag) && !Login.resetCaptcha && Login.showCaptcha\"><div vc-recaptcha key=Login.publicKey ng-model=Login.gRecaptchaResponse></div></div></div></div><div class=row><div class=col-md-12><div class=form-action><input id=submitLogin type=submit ng-if=\"Login.showOtpField === false && Login.loginUsingOtpFlag === false\" ng-disabled=\"Login.loginForm.$invalid || Login.loginProcessFlag\" class=\"btn btn-primary-action btn-block\" value=\"Send OTP\"> <input type=submit ng-if=\"Login.showOtpField === false && Login.loginUsingOtpFlag\" class=\"btn btn-primary-action btn-block\" ng-disabled=\"Login.loginForm.$invalid \" value=\"Send OTP\"> <input id=submitLogin-1 type=submit ng-if=\"Login.showOtpField === true\" ng-disabled=\"Login.loginForm.$invalid || !Login.showOtpField || Login.loginProcessFlag || Login.otpCodeLength !== 6\" class=\"btn btn-primary-action btn-block\" value=\"Verify OTP\"></div><div class=sub-action>Don’t have account yet? <a href=javascript:void(0) ui-sref=registration.main>Register Now</a></div></div></div><div class=row><div class=col-md-12><div class=seperator><hr></div></div></div><div class=row><div class=col-md-12><div class=\"form-action empanel-action-wrapper\"><button type=button class=\"btn btn-secondary-action\" id=homepage_empanel-now ng-click=Login.widgetSelection()>Get Empanelled</button></div></div></div></form></div><div role=tabpanel class=tab-pane id=EUIN><form autocomplete=off name=Login.loginEuinForm autocomplete=false ng-submit=Login.login() novalidate><div class=row><div class=col-md-6><div class=input-normal ng-class=\"{error:Login.loginForm.arnCode.$dirty && Login.loginForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input no-focus name=arnCode ng-model=Login.euinPayload.arnCode type=text id=arnCodeId class=arn-no capitalize maxlength=10 ng-pattern=Login.appConstants.arn_regex ng-change=Login.reset() placeholder=ARN required><!--<span class=\"arn\">ARN -</span>--> <span ng-show=\"Login.loginForm.arnCode.$dirty && Login.loginForm.arnCode.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.arnCode.$error.required ng-bind=Login.validateData.ARN_REQUIRED></span> <span class=\"error-input help-block text-left\" ng-show=\"Login.loginForm.arnCode.$error.pattern && Login.loginForm.arnCode.$invalid\"></span> </span><span class=info-primary ng-if=Login.loginUsingOtpFlag ng-bind=Login.sentOtpRespMsg></span></div></div><div class=col-md-6><div class=input-normal ng-class=\"{error:Login.loginForm.euinCode.$dirty && Login.loginForm.euinCode.$invalid}\"><label>EUIN<span class=req>*</span></label><input no-focus name=euinCode ng-model=Login.euinPayload.euinCode type=text id=euinCodeId class=arn-no capitalize maxlength=10 ng-change=Login.reset() placeholder=EUIN required><!--<span class=\"arn\">ARN -</span>--> <span ng-show=\"Login.loginForm.arnCode.$dirty && Login.loginForm.arnCode.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.arnCode.$error.required ng-bind=Login.validateData.ARN_REQUIRED></span> <span class=\"error-input help-block text-left\" ng-show=\"Login.loginForm.euinCode.$error.pattern && Login.loginForm.euinCode.$invalid\"></span> </span><span class=info-primary ng-if=Login.loginUsingOtpFlag ng-bind=Login.sentOtpRespMsg></span></div></div></div><div class=row><div class=col-md-12><div class=input-normal ng-class=\"{error:Login.loginForm.empCode.$dirty && Login.loginForm.empCode.$invalid}\"><label>Employee Code<span class=req>*</span></label><input name=empCode type=text ng-model=Login.euinPayload.empCode required autocomplete=off easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Login.loginForm.empCode.$dirty && Login.loginForm.empCode.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.empCode.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-12><div class=input-normal ng-class=\"{error:Login.loginForm.password.$dirty && Login.loginForm.password.$invalid}\"><label>Password <span class=req>*</span></label><input id=passwordId name=password type=password ng-model=Login.euinPayload.password required autocomplete=off easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Login.loginForm.password.$dirty && Login.loginForm.password.$invalid\"><span class=\"error-input text-left\" ng-show=Login.loginForm.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div></div></div><div class=row ng-if=\"!Login.loginUsingOtpFlag && !Login.showOtpField\"><div class=col-md-12><span class=\"pull-left secondary-action\"><a href=javascript:void(0) ng-click=Login.forgotPassword()>Forgot Password?</a></span></div></div><div class=row><div class=col-md-12><div class=form-action><input id=submitLogin type=submit ng-if=\"Login.loginUsingOtpFlag === false\" ng-disabled=\"Login.loginForm.$invalid || Login.loginProcessFlag\" class=\"btn btn-primary-action btn-block\" value=Login></div></div></div></form></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=widget-container ng-controller=\"KnowledgeCenterWidget as KnowledgeCenterWidget\"><div ng-include=\"\'app/components/widgets/knowledge-center/knowledge-center.widget.html\'\"></div></div><div class=widget-container ng-controller=\"FundInFocusWidget as FundInFocus\"><div ng-include=\"\'app/components/widgets/fund-in-focus/fund-in-focus.widget.html\'\"></div></div></div></div></div><hdfc-footer></hdfc-footer></div><div ng-if=\"Login.ENV == Login.RUNNING_MODE.MAINTENANCE || Login.isMactive===true\"><div ng-include=\"\'app/maintainance/maintainance.html\'\"></div></div><style>.cursor-pointer{margin-bottom: 7px !important}\n.margin_bot{margin-bottom:20px}\n.input-normal.error .error-input.error-input {\n  text-align: left;\n}\n.footerpadding p {\n  padding: 5px;\n}\n@media only screen and (min-width: 992px) and (max-width: 1134px) {\n  .info-primary{\n    bottom:-56px !important;\n  }\n}</style>");
$templateCache.put("app/main/main.html","<hdfc-dashboard-headers ng-if=Main.isLoggedIn></hdfc-dashboard-headers><hdfc-sidebar></hdfc-sidebar><section><div ui-view></div><div class=\"post-login-ecart-journey main-section-ecart\"><div class=sidebar-container id=sidebarContainer ng-if=Main.showSideBarInvest hdfc-post-login-ecart-sidebar side-title=Main.sidebarTitle investor-data=Main.investorData invest-through=Main.investThrough cart-item=Main.cartDetails euin-declaration=Main.dynamicDataSipPurchaseReview update-info=\"Main.fetchCartItems(\'invest\', data)\"></div><div class=sidebar-container id=sidebarContainer ng-if=\"Main.showSideBarCart && Main.cartItem.cartItemList && Main.cartItem.totalLength > 0\" hdfc-post-login-ecart-sidebar side-title=Main.sidebarTitle investor-data=Main.investorData cart-item=Main.itemToBeEdited euin-declaration=Main.dynamicDataSipPurchaseReview show-add-cart=Main.showAddCart update-info=\"Main.fetchCartItems(\'add\')\"></div><div class=sidebar-container id=sidebarContainer ng-if=Main.showSideAllFunds hdfc-post-login-ecart-sidebar side-title=Main.sidebarTitle investor-data=Main.investorData euin-declaration=Main.dynamicDataSipPurchaseReview show-add-cart=Main.showAddCart update-info=\"Main.fetchCartItems(\'all\')\"></div><div class=sidebar-container id=sidebarContainer ng-if=Main.showSideBarEcart hdfc-post-login-ecart-sidebar side-title=Main.sidebarTitle investor-data=Main.investorData euin-declaration=Main.dynamicDataSipPurchaseReview show-add-cart=Main.showAddCart update-info=\"Main.fetchCartItems(\'all\')\"></div></div><hdfc-footer></hdfc-footer></section>");
$templateCache.put("app/maintainance/maintainance.html","<div class=distributor-empanellment ng-init=Login.getMaintenanceContent()><header class=header><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"></header><div class=\"maintainance-wrapper text-center\" ng-if=!Login.mContent><i class=maintainance-icon></i><p>Due to scheduled maintenance activity, MFOnline Partners portal and mobile app will not be accessible for the next few hours.</p><!--<p>We sincerely apologize for the Inconvenience. We will be operational as soon as possible.</p>--><p style=\"line-height: 4;font-weight: bold\">In the Interim, please use our all new Chat Bot <img style=\"max-width: 150px;height:30px;position: relative;top: 10px;margin:0px\" src=assets/images/chat.gif alt=chat-bot> for all your investment needs.</p></div><div class=\"maintainance-wrapper text-center\" ng-if=Login.mContent ng-bind-html=Login.mContent></div><footer class=\"main-footer login-footer\"><div class=row><div class=\"col-md-12 bottom-footer\"><p class=text-center><span>For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version)</span></p></div></div><div class=\"row top-footer\"><div class=\"col-md-4 col-sm-7 col-xs-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Login.footerDate | date :\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div><div class=\"col-md-4 col-sm-7 col-xs-12 pull-left flex-style customer-service\">Avail our Call Centre Facility.<br>Call us on 1800-267-9944 to initiate transactions for your investors<br>Monday to Friday - 09:30am to 05:30pm<br>Saturday - 09:30am to 01:00pm (Except 2nd and 4th Saturday)<br></div><div class=\"col-md-4 col-sm-5 col-xs-12 pull-right footer-info\"><div class=\"col-md-3 flex-style\"><div class=hdfc-mutualfund><img src=assets/images/hdfc-mutualfund.png alt=\"HDFC Mutual Fund\" class=\"footer-logo1 pull-left\"></div><div class=app-store><a href=\"https://itunes.apple.com/in/app/mfonline-partners/id1335989019?mt=8\" target=_blank><svg id=livetype xmlns=http://www.w3.org/2000/svg width=60 height=22 margin-top=5 viewBox=\"0 0 119.66407 40\"><g><g><g><path d=M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z style=\"fill: #a6a6a6\"></path><path d=M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z></path></g><g id=_Group_ data-name=\"<Group>\"><g id=_Group_2 data-name=\"<Group>\"><g id=_Group_3 data-name=\"<Group>\"><path id=_Path_ data-name=\"<Path>\" d=M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z style=\"fill: #fff\"></path><path id=_Path_2 data-name=\"<Path>\" d=M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z style=\"fill: #fff\"></path></g></g><g><path d=M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z style=\"fill: #fff\"></path><path d=M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z style=\"fill: #fff\"></path><path d=M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z style=\"fill: #fff\"></path><path d=M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z style=\"fill: #fff\"></path><path d=M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z style=\"fill: #fff\"></path><path d=M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z style=\"fill: #fff\"></path><path d=M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z style=\"fill: #fff\"></path><path d=M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z style=\"fill: #fff\"></path></g></g></g><g id=_Group_4 data-name=\"<Group>\"><g><path d=M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z style=\"fill: #fff\"></path><path d=M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z style=\"fill: #fff\"></path><path d=M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z style=\"fill: #fff\"></path><path d=M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"></path><path d=M59.09377,8.437h.88867v6.26074h-.88867Z style=\"fill: #fff\"></path><path d=M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z style=\"fill: #fff\"></path><path d=M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z style=\"fill: #fff\"></path><path d=M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z style=\"fill: #fff\"></path><path d=M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z style=\"fill: #fff\"></path><path d=M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"></path><path d=M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z style=\"fill: #fff\"></path><path d=M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z style=\"fill: #fff\"></path><path d=M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z style=\"fill: #fff\"></path></g></g></g></svg> </a><a href=\"https://play.google.com/store/apps/details?id=com.hdfc.mf&hl=en_US\" target=_blank><img src=assets/images/google-play-badge.png alt=\"Google Play\" class=\"footer-logo1 pull-left\"></a></div></div><span class=col-md-9 style=\"padding-left: 25px\"><span class=text-blue>MF Online Partner Support Desk</span><p>Monday - Friday : 9:00 AM - 6:00 PM</p><!--<p>Saturday : 9:00 AM - 1:00 PM</p> --></span></div></div></footer></div><style>div.maintainance-wrapper {\n    min-height:75vh;\n    padding-top:25px;\n    line-height: 1.3;\n    font-size: 1em;\n    font-weight: 400;\n  }\n  p{\n    font-size: 1em;\n    font-weight: 400;\n  }</style>");
$templateCache.put("app/mandateRegistration/mandate-registration.html","<div class=email-view ng-if=MandateRegister.isLoaded><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-emandate><div class=content-header><h5 class=text-capitalize>Review E-mandate Registration Details</h5></div><div class=content-body><div class=email-block><div class=row><div class=col-xs-3>Bank</div><div class=col-xs-1><span>:</span></div><div class=\"col-md-4 col-xs-7\" style=\"margin-bottom: 0px\"><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in MandateRegister.bankList\" ng-model=MandateRegister.formData.bankInfo ng-change=MandateRegister.changeBank()><option value=\"\" selected>Select Bank</option></select></div></div></div><div class=row><div class=col-xs-3>Account Number</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\">{{MandateRegister.formData.bankInfo.accountNumber}}</div></div><div class=row><div class=col-xs-3>Amount</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\">{{MandateRegister.emandateData.maxAmount}}</div></div><div class=row><div class=col-xs-3>Frequency</div><div class=col-xs-1><span>:</span></div><div class=col-xs-4>{{MandateRegister.emandateData.frequency}}</div></div><div class=row><div class=col-xs-3>Start Date</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-3\">{{MandateRegister.emandateData.omStartDate}}</div></div><div class=row><div class=col-xs-3>End Date</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-3\">{{MandateRegister.emandateData.omEndDate}}</div></div><div class=row><div class=col-xs-3>Purpose of E-mandate</div><div class=col-xs-1><span>:</span></div><div class=col-xs-4>{{MandateRegister.emandateData.purpose}}</div></div><div class=row><div class=col-xs-3>Authentication Mode</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\"><div class=selectfield><select name=authenticationMode class=\"authModeDropdown custom-select\" ng-model=MandateRegister.authModeSelect ng-options=\"authMode.text for authMode in MandateRegister.authModes\" required><option value=\"\" selected>{{(MandateRegister.authModes && !MandateRegister.authModes.length) ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select></div></div></div><div class=row><ng-bind-html dynamic=MandateRegister.dynamicNoteEmandate.content></ng-bind-html></div><div class=row><div class=col-md-12><div class=\"terms-condition form-group first\" ng-show=MandateRegister.showTerms><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=MandateRegister.ischecked ng-change=\"MandateRegister.alterTermsAndCondition(\'first\');\" required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\">I have read and understood <a ng-click=\"MandateRegister.showTermsAndCondition(\'first\');\" href=javascript:void(0)>Terms & condition</a> of e-mandate (eOTM) registration.</label></div><div class=\"terms-condition form-group\"><span class=checkbox><input id=declaration-2 type=checkbox name=declartaion ng-model=MandateRegister.ischeckedAgain ng-change=\"MandateRegister.alterTermsAndCondition(\'second\');\" required> <span class=icon-checkbox></span></span><label for=declaration-2 class=\"checkbox-text tnc\">I hereby confirm that the information furnished above is true and correct to the best of my knowledge and belief <a ng-click=\"MandateRegister.showTermsAndCondition(\'second\');\" href=javascript:void(0)>Terms & condition</a>.</label></div></div></div></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{MandateRegister.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-if=!MandateRegister.isActionPerformed><button type=button class=\"btn btn-negative-action\" ng-click=MandateRegister.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-click=\"MandateRegister.initiateSummary(\'reject\')\">Reject</button> <button type=submit class=\"btn btn-primary-action\" ng-disabled=\" !MandateRegister.ischecked || !MandateRegister.ischeckedAgain || !MandateRegister.authModeSelect\" ng-click=\"MandateRegister.initiateSummary(\'approve\')\">Approve Transaction</button></div></section></div>");
$templateCache.put("app/mobile/mobile.html","<div ui-view></div>");
$templateCache.put("app/new-investor/new-investor.html","<div class=\"new-investors clearfix\" id=investors><div class=row style=\"width: 100%\"><div class=\"sidebarHeight col-xs-12 col-sm-3 col-md-3\" ng-if=\"myState != \'/NewInvestorPayment\' \"><div class=progressBar><div class=row style=\"margin: auto\"><div class=\"sidebarContent col-md-12\"><div class=progress-nav style=\"margin-top: 1%\"><vertical-progress-sidebar steps=testObj ng-if=showSidebar responsive=false></vertical-progress-sidebar><vertical-progress-sidebar steps=testObj ng-if=showSidebar responsive=true></vertical-progress-sidebar></div></div></div></div></div><div class=\"container-responsive col-xs-12 col-sm-9 col-md-9\"><div ui-view></div></div></div></div><style>.sidebarHeight {\n    height: 100% !important;\n  }\n\n  .sidebarContent {\n    padding: 70px 0px 0px 5px;\n  }\n\n  @media screen and (max-width: 767px) {\n    .new-investors {\n      margin-left: 0;\n    }\n\n    .sidebarHeight {\n      height: auto !important;\n    }\n\n    .sidebarContent {\n      padding: 0px 0px 0px 0px !important;\n    }\n  }</style>");
$templateCache.put("app/new-investor-approve/new-investor-approve.html","<div class=\"new-investors-approve row clearfix\" id=investors><!-- <div class=\"progressBar col-xs-12 col-sm-2 col-md-2\" ng-if=\"myState != \'/NewInvestorPayment\'\">\n      <div class=\"row height100\">\n        <div class=\"col-md-12 height100\">\n          <div class=\"progress-nav\" style=\"margin-top: 35%;\">\n            <vertical-progress-sidebar steps=\"testObj\" responsive=\"false\"></vertical-progress-sidebar>\n            <vertical-progress-sidebar steps=\"testObj\" responsive=\"true\"></vertical-progress-sidebar>\n          </div>\n        </div>\n      </div>\n    </div> --><div class=\"col-xs-12 col-md-12 col-sm-12 container-responsive\"><div ui-view></div></div></div>");
$templateCache.put("app/non-otmUsers/list.html","<div class=\"main-section non-otm-list investors\" ng-init=OtmList.init()><div class=\"clearfix top-head\"><h3 class=\"page-title pull-left\">OTM Not Registered Investors <span ng-if=OtmList.unregisteredInvestorsListData.length>(</span>{{OtmList.unregisteredInvestorsListData.length}}<span ng-if=OtmList.unregisteredInvestorsListData.length>)</span></h3><div class=\"sort-data pull-right\"><span class=download-with-tooltip ng-click=OtmList.downloadForm()><i class=download-blue-icon></i></span></div></div><div class=\"tab-content investors-listing\"><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name</th><th>PAN</th><th>Folio No</th></tr></thead><tbody><tr ng-repeat=\"list in OtmList.unregisteredInvestorsListData\" ng-if=\"OtmList.unregisteredInvestorsListData.length>0\"><td data-th=\"Investor Name\" class=ng-binding role=button tabindex=0>{{list.investorName}}</td><td data-th=PAN>{{list.panNumber}}</td><td data-th=\"Folio No\"><span ng-repeat=\"folio in list.otmUnregistererdFolios\" class=\"btn-small btn-secondary-action\" ng-click=OtmList.openFolioDetails(folio)>{{folio.folioNumber}}</span></td></tr><tr ng-if=\"OtmList.unregisteredInvestorsListData.length==0\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=OtmList.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"OtmList.totalUnregisteredListData <= OtmList.PAGE_LIMITS[0]\" ng-bind=OtmList.totalUnregisteredListData></span><select ng-if=\"OtmList.totalUnregisteredListData > OtmList.PAGE_LIMITS[0]\" ng-change=OtmList.init() ng-model=OtmList.pageLimit ng-options=\"_limit as _limit for _limit in OtmList.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=OtmList.totalUnregisteredListData></span></div><ul uib-pagination total-items=OtmList.totalUnregisteredListData ng-model=OtmList.currentPage max-size=5 items-per-page=OtmList.pageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=OtmList.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/notifications/notifications.html","<div class=\"notifications main-section\" ng-init=Notification.init()><h3 class=page-title>Notifications</h3><div class=notify-block ng-if=Notification.notificationData.today.length><p>Today</p><ul><li ng-repeat=\"notification in Notification.notificationData.today\" ng-click=Notification.notificationDetails(notification)>{{notification.title}}</li></ul></div><div class=notify-block ng-if=Notification.notificationData.lastsevendays.length><p>Last 7 Days</p><ul><li ng-repeat=\"notification in Notification.notificationData.lastsevendays\" ng-click=Notification.notificationDetails(notification)>{{notification.title}}</li></ul></div><div class=notify-block ng-if=Notification.notificationData.history.length><p>History</p><ul><li ng-repeat=\"notification in Notification.notificationData.history\" ng-click=Notification.notificationDetails(notification)>{{notification.title}}</li></ul></div></div>");
$templateCache.put("app/registration/registration.html","<div class=\"distributor-empanellment registration\" ng-init=Registration.Init()><login-header></login-header><hdfc-login-sidebar></hdfc-login-sidebar><div ui-view></div></div><hdfc-footer></hdfc-footer>");
$templateCache.put("app/registration/registration.main.html","<div class=\"container-fluid registration-main-container\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-registration-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=registration-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=Registration.goBack();><i class=back-icon></i></a></div><div class=registration-form-container><form autocomplete=off name=Registration.signupForm ng-submit=Registration.generateOtp() novalidate><h2 class=info>New User <span class=info-head-color>Registration</span></h2><div class=input-normal ng-class=\"{error:Registration.signupForm.arnCode.$dirty && Registration.signupForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input ng-model=Registration.signupUser.arnCode type=text maxlength=10 name=arnCode ng-pattern=Registration.appConstants.arn_regex required class=arn-no autocomplete=off placeholder=ARN> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span> <span ng-show=\"Registration.signupForm.arnCode.$dirty && Registration.signupForm.arnCode.$invalid\"><span class=error-input ng-show=Registration.signupForm.arnCode.$error.required ng-bind=Registration.validateData.ARN_REQUIRED></span> <span class=error-input ng-show=\"Registration.signupForm.arnCode.$error.pattern && Registration.signupForm.arnCode.$invalid \" class=help-block>{{ Registration.validateData.ARN_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Registration.signupForm.bankAccountNumber.$dirty && Registration.signupForm.bankAccountNumber.$invalid}\"><label>Bank Account Number<span class=req>*</span></label><input type=text ng-model=Registration.signupUser.bankAccountNumber name=bankAccountNumber placeholder=\"Enter Bank Account Number\" required minlength=9 maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" autocomplete=off easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Registration.signupForm.bankAccountNumber.$dirty && Registration.signupForm.bankAccountNumber.$invalid\"><span class=error-input ng-show=Registration.signupForm.bankAccountNumber.$error.required ng-bind=Registration.validateData.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=Registration.signupForm.bankAccountNumber.$error.minlength>{{ Registration.validateData.ACCOUNT_NUMBER_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Registration.signupForm.emailAddress.$dirty && Registration.signupForm.emailAddress.$invalid}\"><label>Email ID<span class=req>*</span></label><input type=email easyassist-key=mask-element ng-model=Registration.signupUser.emailAddress ng-pattern=Registration.appConstants.email_regex maxlength=150 name=emailAddress required autocomplete=off placeholder=\"Enter Email ID\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Registration.signupForm.emailAddress.$dirty && Registration.signupForm.emailAddress.$invalid\"><span class=error-input ng-show=Registration.signupForm.emailAddress.$error.required ng-bind=Registration.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=Registration.signupForm.emailAddress.$error.pattern>{{ Registration.validateData.EMAIL_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Registration.signupForm.mobileNumber.$dirty && Registration.signupForm.mobileNumber.$invalid}\"><label>Mobile Number<span class=req>*</span></label><input type=text easyassist-key=mask-element name=mobileNumber id=mobileNumberId ng-blur=Registration.goToNextEle() ng-model=Registration.signupUser.mobileNumber ng-pattern=Registration.appConstants.mobile_regex_num_only required maxlength=10 autocomplete=off placeholder=\"Enter Mobile Number\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Registration.signupForm.mobileNumber.$dirty && Registration.signupForm.mobileNumber.$invalid\"><span class=error-input ng-show=Registration.signupForm.mobileNumber.$error.required ng-bind=Registration.validateData.MOBILE_REQUIRED></span> <span class=error-input ng-show=Registration.signupForm.mobileNumber.$error.maxlength>{{ Registration.validateData.MOBILE_FIELD }}</span> <span class=error-input ng-show=\"Registration.signupForm.mobileNumber.$error.pattern && Registration.signupForm.mobileNumber.$invalid\" class=help-block>{{ Registration.validateData.MOBILE_FIELD }}</span></span></div><div class=form-group ng-if=Registration.showCaptcha><div vc-recaptcha key=Registration.publicKey ng-model=Registration.myRecaptchaResponse></div></div><span class=error ng-if=Registration.errorMessage><span class=\"error-message help-block\">{{ Registration.errorMessage }}</span></span><div class=\"form-group terms-condition-regis-wrapper\"><span class=checkbox><input type=checkbox ng-model=Registration.termsAndConditions name=Registration.signupForm.termsandconditions required> <span class=icon-checkbox></span> </span><span>I have read &amp; agree to the <a href=javascript:void(0) ng-click=Registration.termsAndContitions()><b>Terms &amp; Conditions</b></a></span></div><div class=form-action-container><button type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=Registration.confirmCancel()>Back</button> <button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=\"Registration.signupForm.$invalid || Registration.processFlag\">Get OTP</button></div></form></div></div></div></div></div>");
$templateCache.put("app/registration/registration.otp.html","<div class=\"Otp-section container-fluid\" ng-init=Registration.Init()><div class=\"row row-flex\"><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=registration-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=Registration.goBack();><i class=back-icon></i></a></div><div class=registration-form-container><form autocomplete=off name=Registration.otpForm ng-submit=Registration.verifyOtp() autocomplete=off novalidate><h2 class=info>Enter <span class=info-head-color>One-time Password (OTP)</span></h2><p class=sub-heading>{{Registration.formData.contactInfoMsg}}</p><p class=sub-heading>OTP is valid for <span class=time-period-span>15 minutes.</span></p><div class=\"input-normal input-code\" ng-class=\"{error:Registration.otpForm.otpNumber.$dirty && Registration.otpForm.otpNumber.$invalid}\"><label class=visible-xs>Enter OTP<span class=req>*</span></label><div class=input-code-container><input type=tel id=otp-number-input-1 class=otp-number-input minlength=1 maxlength=1 tabindex=1 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex1 is-number custom-auto-focus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=otp-number-input minlength=1 maxlength=1 tabindex=2 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=otp-number-input minlength=1 maxlength=1 tabindex=3 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=otp-number-input minlength=1 maxlength=1 tabindex=4 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=otp-number-input minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=otp-number-input minlength=1 maxlength=1 tabindex=6 autocomplete=off ng-change=Registration.otpValChanged(this) ng-model=Registration.otpValIndex6 is-number easyassist-key=mask-element></div><div class=forgot><timer countdown=Registration.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd><span class=link-text>Didn\'t receive a code? Don\'t worry. </span><span class=counter-text>Retry in {{countdown}} seconds</span> </span><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=Registration.reGenerateOtp() class=forgot-pwd>Resend OTP</a></timer></div><span ng-show=\"Registration.otpForm.otpNumber.$dirty && Registration.otpForm.otpNumber.$invalid\"><span class=\"error-input text-left\" ng-show=Registration.otpForm.otpNumber.$error.required ng-bind=Registration.validateData.OTP_REQUIRED></span> <span class=info-primary style=left:13% ng-if=Registration.loginUsingOtpFlag ng-bind=Registration.otpResendMessage></span></span></div><div class=row><div class=col-md-12><div class=\"form-action form-action-container\"><button type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=Registration.goBack();>Back</button> <input type=submit class=\"btn btn-primary-action btn-block\" type=submit ng-disabled=\"Registration.otpForm.$invalid || Registration.processFlag || Registration.otpCodeLength !== 6\" value=Verify></div></div></div></form></div></div></div></div></div><script>// const $inp = $(\".otp-number-input\");\n  $(\".otp-number-input\").on({\n    paste(ev) { // Handle Pasting\n\n      const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n      // Allow numbers only\n      if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n      // Split string to Array or characters\n      const s = [...clip];\n      // Populate inputs. Focus last input.\n      $(\".otp-number-input\").val(i => s[i]).eq(5).focus();\n    },\n  });</script>");
$templateCache.put("app/registration/registration.success.html","<div class=container><div class=\"col-xs-12 col-sm-12 form-wrapper regis-success-container\"><div class=content-container><div class=back-img-div><div class=success-msg><div class=success-tick-wrapper><img src=assets/images/icons/success-white-tick.svg alt=success-tick></div><div class=head>Request Submitted</div></div></div><div class=\"info text-center\">Thanks for verifying your account with OTP.<br>An email has been sent to your registered email ID with temporary password.</div><form autocomplete=off><button ui-sref=login class=\"btn btn-primary-action btn-block\">Okay</button></form></div></div></div>");
$templateCache.put("app/reports/reports.html","<div class=\"reports main-section\"><div class=container-fluid ng-init=Reports.init()><h3 class=page-title>Reports</h3><div class=\"download dropdown pull-right\"><button class=\"btn btn-download btn-primary-action\" ng-click=Reports.downloadBrockerageReport()><i class=\"download-white-icon icon\"></i>Send Brokerage Reports</button></div><div class=row><div class=col-md-12><div class=reports-card><div class=\"head container-fluid\"><p class=pull-left>Investors Overview</p></div><div class=body><div class=\"col-md-12 col-sm-12 col-xs-12\"><select ng-change=Reports.ioDateChanged() ng-model=Reports.reportData.ioSelectedDate ng-options=\"_type as (\'FY \'+_type) for _type in Reports.reportData.dateList\" ng-value=_type><option value=\"\" ng-if=\"Reports.reportData.dateList.length==0\" selected>Select Year</option></select></div><div class=\"col-md-9 col-sm-7 col-xs-12 graph-block\" id=investor-overview></div><div class=\"col-md-3 col-sm-4 col-xs-12 pull-right investor-common-list\"><ul><li ng-repeat=\"(key, value) in Reports.reportData.ioReportUrls\" ng-click=Reports.downloadReport(key,value)>{{value}}</li></ul></div></div></div></div><div class=col-md-12><div class=reports-card><div class=\"head container-fluid\"><p class=pull-left>Systematic Investments Overview</p></div><div class=body><div class=\"col-md-12 col-sm-12 col-xs-12\"><select ng-change=Reports.sioDateChanged() ng-model=Reports.reportData.sioSelectedDate ng-options=\"_type as (\'FY \'+_type) for _type in Reports.reportData.dateList\" ng-value=_type><option value=\"\" ng-if=\"Reports.reportData.dateList.length==0\" selected>Select Year</option></select></div><div class=\"col-md-9 col-sm-7 col-xs-12 graph-block\" id=syatematic-investor-overview></div><div class=\"col-md-3 col-sm-4 col-xs-12 pull-right investor-common-list\"><ul><li ng-repeat=\"(key,value) in Reports.reportData.sioReportUrls\" ng-click=Reports.downloadReport(key,value)>{{value}}</li></ul></div></div></div></div><div class=col-md-12><div class=reports-card><div class=\"head container-fluid\"><p class=pull-left>Lumpsum Investments Overview</p></div><div class=body><div class=\"col-md-12 col-sm-12 col-xs-12\"><select ng-change=Reports.lioDateChanged() ng-model=Reports.reportData.lioSelectedDate ng-options=\"_type as (\'FY \'+_type) for _type in Reports.reportData.dateList\" ng-value=_type><option value=\"\" ng-if=\"Reports.reportData.dateList.length==0\" selected>Select Year</option></select></div><div class=\"col-md-9 col-sm-7 col-xs-12 graph-block\" id=lumpsum-investor-overview></div><div class=\"col-md-3 col-sm-4 col-xs-12 pull-right investor-common-list\"><ul><li ng-repeat=\"(key,value) in Reports.reportData.lioReportUrls\" ng-click=Reports.downloadReport(key,value)>{{value}}</li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/resourcesNcalculators/resourcesNcalculators.html","<div class=\"leap-academy main-section\" ng-init=ResourcesCalculators.init()><!--<ul class=\"nav nav-tabs\">\n    <li ui-sref-active=\"active\"><a ui-sref=\"main.resourcesCalculators.calculators\">Calculators</a></li>\n    <li ui-sref-active=\"active\"><a ui-sref=\"main.resourcesCalculators.resources\">Resources</a></li>\n  </ul>--><div ui-view></div></div>");
$templateCache.put("app/schemeCalculator/schemeCalculator.html","<div class=\"financial-planning main-section\" ng-init=SchemeCalculator.init()><h3 class=page-title>Scheme Calculator</h3><section class=content><iframe name=DBox id=DBox src=\"\" frameborder=0 style=\"width:100%;height:600px;overflow: hidden\"></iframe></section></div>");
$templateCache.put("app/sip-corner/sip-corner.html","<div class=\"investors sip-corner main-section\" ng-init=SipCorner.init()><div class=\"loader sipCorner\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your data...</span></div><h3 class=page-title>Systematic Corner</h3><div class=\"download dropdown pull-right\"><!--<button class=\"btn btn-download dropdown-toggle btn-primary-action\" data-toggle=\"dropdown\"><i--><!--class=\"download-white-icon \"></i>Download reports--><!--</button>--><ul class=dropdown-menu><li ng-repeat=\"(key, value) in SipCorner.reportUrls\" ng-click=SipCorner.downloadReport(key,value)>{{value}}</li></ul></div><div class=\"tab-content investors-listing\"><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row sip-corner-filter\"><div class=search-bar><i class=search-icon></i> <input type=search placeholder=\"Search Pan Number, Investor Name, Scheme\" ng-model=SipCorner.searchText ng-change=SipCorner.searchList(); select-on-click class=blank-input></div><div style=\"float: right\" class=downnloadIconSIP><span class=\"download-with-tooltip downloadButtonSIP\" ng-click=\"SipCorner.downloadReportList(\'sip-corner-list\');\" ng-class=\"{\'anything-disabled\': SipCorner.totalSystematicListData === 0}\"><img tooltips tooltip-template=\"Download Report\" src=../../../assets/images/ic-download-1.svg alt=Download></span></div><div style=\"float: right\"><select class=\"browser-default custom-select\" id=statusTypeMob ng-change=SipCorner.changeStatusType(); ng-model=SipCorner.selectedStatusType ng-init=SipCorner.selectedStatusType ng-options=\"_statustype.key as _statustype.value for _statustype in SipCorner.STATUSTYPES\"><option value=\"\" selected>Status Type</option></select></div><div style=\"float: right\"><span ng-dropdown-multiselect=\"\" options=SipCorner.TRANSACTION_TYPES id=transactTypeSIP selected-model=SipCorner.transactionType events=SipCorner.transactionEvents extra-settings=SipCorner.transactionSettings translation-texts=SipCorner.transactionTranslationTexts class=sip-multiselect></span></div><div ng-if=SipCorner.isReset style=\"margin-left: 5px\" class=sip-start-date><!--<input date-range=\"\" on-date-change=\"SipCorner.filterByDate\" placeholder=\"From Date -> To Date\"\n                 date-min=\"SipCorner.minDate\" date-max=\"SipCorner.maxDate\" date-max-span=\"59\"\n                 date-default=\"SipCorner.dateFilter\" class=\"date-picker transactSIPdate\" type=\"text\">--><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{SipCorner.viewMode}} data-date-default=SipCorner.dateFilter.startDate data-enabled-dates=SipCorner.enabledStartDatesList data-min-date=SipCorner.startMinDate data-max-date=SipCorner.startMaxDate data-on-date-change=SipCorner.changeStartDate data-view-date=SipCorner.viewDate id=startDate-sip data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=error-input ng-show=SipCorner.tForm.startDate.$error.required ng-bind=SipCorner.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div ng-if=SipCorner.isReset class=sip-end-date ng-class=\"{\'anything-disabled\': !SipCorner.dateFilter.startDate}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{SipCorner.viewMode}} data-date-default=SipCorner.dateFilter.endDate data-enabled-dates=SipCorner.enabledEndDatesList data-min-date=SipCorner.endMinDate data-max-date=SipCorner.endMaxDate data-on-date-change=SipCorner.changeEndDate id=endDate-sip data-enable=true style=\"position: relative\"><input type=text name=endDate placeholder=\"End Date\" ng-disabled=!SipCorner.dateFilter.startDate readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=reset-date-filter ng-if=SipCorner.isReset><span ng-click=SipCorner.resetDateFilter();><img src=assets/images/refresh.png tooltips tooltip-template=\"Reset Date\"></span></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"SipCorner.sortOrder.sortKey=\'NAME\';SipCorner.filterByHeader()\">Investor<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"SipCorner.sortOrder.sortKey=\'SCHEME_NAME\';SipCorner.filterByHeader()\"><span>Scheme</span><div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"SipCorner.sortOrder.sortKey=\'START_DATE\';SipCorner.filterByHeader()\">Start Date<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"SipCorner.sortOrder.sortKey=\'END_DATE\';SipCorner.filterByHeader()\">End Date<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"SipCorner.sortOrder.sortKey=\'PAUSE_START_DATE\';SipCorner.filterByHeader()\">Pause Start Date<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"SipCorner.sortOrder.sortKey=\'PAUSE_END_DATE\';SipCorner.filterByHeader()\">Pause End Date<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Installment Date</th><!--<th>Frequency</th>--><th ng-click=\"SipCorner.sortOrder.sortKey=\'INSTALLMENT\';SipCorner.filterByHeader()\">Installment<br>(IN RS)<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><!--<th>Installment <br/> (Paid/Total)</th>--><th>Action</th></tr></thead><tbody><tr ng-if=SipCorner.systematicListData ng-repeat=\"investor in SipCorner.systematicListData\"><td data-th=\"Investor Name\" ng-click=SipCorner.investorDetails(investor) class=\"ng-binding textAlignnSIP\" role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a><br><span ng-if=investor.pan>(</span> <small easyassist-key=mask-element>{{ investor.pan }}</small> <span ng-if=investor.pan>)</span></td><td data-th=\"Scheme Name\" class=textAlignnSIP>{{investor.schemeName}}<br><span>Type : </span><span ng-if=\"investor.type != \'FLEXSIP\' && investor.type != \'SIP_TOP_UP\'\">{{ investor.type == \'DTP\' ? \'TIP\' : investor.type }} </span><span ng-if=\"investor.type == \'FLEXSIP\'\">Flex SIP </span><span ng-if=\"investor.type == \'SIP_TOP_UP\'\">SIP with Top up</span><br><span ng-if=\"investor.type == \'DREAM SIP\' \">Option : </span><span ng-if=\"investor.type == \'DREAM SIP\' \">{{investor.option}}</span><br><span ng-if=\"investor.type == \'DREAM SIP\' && investor.option== \'B\' \">Target Scheme : </span><span ng-if=\"investor.type == \'DREAM SIP\' && investor.option== \'B\' \">{{investor.targetSchemeName}}</span></td><td data-th=\"Start Date\" class=textAlignnSIP>{{investor.startDate}}</td><td data-th=\"End Date\" class=textAlignnSIP>{{investor.endDate}}</td><td data-th=\"Pause Start Date\">{{investor.pauseFromDate ? investor.pauseFromDate : \'N/A\'}}</td><td data-th=\"Pause End Date\">{{investor.pauseToDate ? investor.pauseToDate : \'N/A\' }}</td><td data-th=\"Sip Date\" class=textAlignnSIP>{{investor.sipDate}} <span ng-if=!investor.sipDate>---</span></td><!--<td data-th=\"Frequency\">{{investor.autoFrequency}}</td>--><td data-th=Amount class=textAlignnSIP><span ng-if=\"investor.amount && investor.amount > 0\">{{investor.amount|unitWithOutDecimalFilter:investor.amountUnit}}{{investor.installmentUnit|unitValue}}<p>({{investor.autoFrequency}})</p></span><span ng-if=\"investor.amount <= 0\">--</span></td><!--<td data-th=\"Installment Paid/Total\">{{investor.paidInstallment}} <span\n              ng-if=\"investor.paidInstallment || investor.paidInstallment ==0 && investor.totalInstallment\">/</span>{{investor.totalInstallment}}\n            </td>--><td data-th=Action><button type=button class=dropdown ng-if=\"investor.reInitiate && investor.autoFrequency !== \'One Shot\' && investor.type !== \'SMART SWAP\'\" ng-class=\"{\'disable-button\':!investor.validFolio || !investor.corporateFolioValid}\" ng-click=SipCorner.reInitiateAction(investor) ng-disabled=\"!investor.validFolio || !investor.corporateFolioValid\">Renew <span ng-if=!investor.validFolio style=\"display: initial !important\" class=\"base-tooltip portfolio-tooltip\" data-html=true data-toggle=tooltip tooltip data-placement=top title=\"Transactions cannot be done for this folio\"></span></button><!--\n                            <button ng-click=\"SipCorner.cancelThisTransaction(investor)\">Cancel</button>--> <button class=dropdown ng-if=!investor.reInitiate ng-class=\"{\'anything-disabled\': (!investor.action.length)}\"><span style=\"display: block\" class=dropdown-toggle data-toggle=dropdown>Action</span><ul class=dropdown-menu><li class=list-group-item ng-repeat=\"action in investor.action\" ng-hide=\"investor.type == \'DREAM SIP\' && (action == \'Modify\' || action == \'Top-Up\')\" ng-click=\"SipCorner.actionReceiver(action, investor , investor.action)\" role=button tabindex=0>{{action}}</li></ul></button></td></tr><tr class=text-center ng-if=\"!(SipCorner.totalSystematicListData >0) && !SipCorner.isLoading\"><td colspan=12>No Record found</td></tr></tbody></table><div ng-if=SipCorner.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"SipCorner.totalSystematicListData <= SipCorner.PAGE_LIMITS[0]\" ng-bind=SipCorner.totalSystematicListData></span><select ng-if=\"SipCorner.totalSystematicListData > SipCorner.PAGE_LIMITS[0]\" ng-change=SipCorner.limitChanged() ng-model=SipCorner.selectedPageLimit ng-options=\"_limit as _limit for _limit in SipCorner.PAGE_LIMITS\"></select><span>of</span> <span class=t-black ng-bind=SipCorner.totalSystematicListData></span></div><ul uib-pagination total-items=SipCorner.totalSystematicListData ng-model=SipCorner.currentPageSystematicList max-size=5 items-per-page=SipCorner.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=SipCorner.initSipCorner() rotate=false></ul></div></div></div></div></div>");
$templateCache.put("app/sip-renew/sip-renew.html","<div class=\"transaction sip-renew main-section\" ng-init=SipRenew.init()><div class=\"loader siprenew\"><span class=loading></span></div><h3 class=page-title>Bulk SIP Re-New</h3><ul class=\"nav nav-tabs transactions\"><li ng-repeat=\"tab in SipRenew.tabs\" ng-class=\"{\'active-link\': tab.active}\"><a href=javascript:void(0); ng-click=SipRenew.redirectToTab(tab.key)>{{tab.key}}</a></li></ul><div class=\"tab-content sip-renew-listing\"><div ui-view></div></div></div>");
$templateCache.put("app/sipPause/sipPause.html","<div class=\"main-section summary\" ng-init=SipPause.init()><p class=page-title>Pause <span ng-if=\"SipPause.summaryDetails.summary.type == \'DREAMSIP\' \">DREAM</span> SIP Details</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=SipPause.summaryDetails.summary.folioNumber><td class=label-color>Folio Number</td><td>:</td><td>{{SipPause.summaryDetails.summary.folioNumber}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.mode><td class=label-color>SIP Mode</td><td>:</td><td>{{SipPause.summaryDetails.summary.mode}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.camsTransactionNumber><td class=label-color>CAMS Transaction Number</td><td>:</td><td>{{SipPause.summaryDetails.summary.camsTransactionNumber}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.schemeName><td class=label-color>Scheme Name</td><td>:</td><td>{{SipPause.summaryDetails.summary.schemeName}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.fromDate><td class=label-color>SIP From Date</td><td>:</td><td>{{SipPause.summaryDetails.summary.fromDate}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.toDate><td class=label-color>SIP To Date</td><td>:</td><td>{{SipPause.summaryDetails.summary.toDate}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.noOfInstallment><td class=label-color>Number of Installments</td><td>:</td><td>{{SipPause.summaryDetails.summary.noOfInstallment}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.frequency><td class=label-color>SIP Frequency</td><td>:</td><td>{{SipPause.summaryDetails.summary.frequency}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.amount><td class=label-color>Installment Amount(INR)</td><td>:</td><td><i class=rupee-grey-icon style=top:2px></i>{{SipPause.summaryDetails.summary.amount}}</td></tr><tr ng-if=SipPause.summaryDetails.summary.distributor><td class=label-color>Distributor Code/Name</td><td>:</td><td>{{SipPause.summaryDetails.summary.distributor}}</td></tr><tr ng-if=\"SipPause.summaryDetails.summary.frequency===\'Monthly\'\"><td class=label-color>Number Of Installment To Be Paused</td><td>:</td><td><select ng-model=SipPause.noOfInstallment name=installment ng-change=SipPause.changeInstallment() style=\"background: white\"><option value=\"\" selected>Select Number Of Installment</option><option ng-repeat=\"item in SipPause.noOfInstallmentList\" ng-init=\"SipPause.noOfInstallment = SipPause.noOfInstallment ? SipPause.noOfInstallment :null\">{{item}}</option></select><div><span class=error-input-pause ng-if=\"SipPause.noInstallment && SipPause.endDate\" ng-bind=SipPause.VALIDATE_DATA.NO_OF_INSTALLMENT_REQUIRED></span></div></td></tr><td class=label-color>Pause SIP Start Date</td><td>:</td><td><div class=\"row borderline\"><div class=\"col-md-10 row\" style=\"margin: 0\"><div ng-if=!Transaction.isReseting><div style=\"padding: 0;margin: 0\" class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=SipPause.endDate data-enabled-dates=SipPause.enabledEndDates data-view-date=SipPause.enabledEndDateView data-min-date=SipPause.enabledEndDates[0] data-max-date=SipPause.maxEndDate data-on-date-change=SipPause.changeStartDate data-enable=true id=endDate-OTM ng-class=\"{ \'div-disabled\': SipPause.noInstallment}\" showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder=\"Start Date - DD-MMM-YYYY\" style=font-size:14px readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=Transaction.formData.endDate>Start Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=Transaction.isOTMEndDate ng-bind=Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div></div></div></td><tr><td class=label-color>Pause SIP End Date</td><td>:</td><td><div class=\"col-md-9 row\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=\"padding: 0;margin: 0\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-date-default=SipPause.SipPauseEndDate id=startDate-OTM data-enable=true data-on-date-change=SipPause.endDateChange style=\"position: relative\"><input type=text name=startDate placeholder=\"End Date - DD-MMM-YYYY\" style=font-size:14px readonly><label ng-if=Transaction.formData.startDate>End Date - DD-MMM-YYYY</label></div></div></td></tr></table></div><div class=\"imp-info col-md-12\"><strong>Important:</strong><p><i class=dot></i> <span>It takes 15 working days for the pause to be effective. Thus, if a SIP installment is due within 15 working days from the date of pause, that installment will be processed and your bank account will be debited for that SIP installment.</span></p></div></div><div class=content-foot><div><a href=\"\" ui-sref=main.sipcorner class=\"cursor-pointer text-primary back-pause\"><i class=back-arrow-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ng-click=SipPause.confirmPauseTransaction() ng-disabled=\"SipPause.noInstallment || !SipPause.SipActionHappened\">Confirm</button></div></div></div></div>");
$templateCache.put("app/unlock-arn/unlockArn.html","<div class=\"distributor-empanellment registration\" ng-init=UnlockArn.Init()><!--  <header class=\"header\">--><!--    <img src=\"assets/images/logo-main.png\" alt=\"HDFC\" class=\"logo-main pull-left\"/>--><!--    <img src=\"assets/images/logo.png\" alt=\"HDFC\" class=\"logo pull-left\"/>--><!--    <div class=\"pull-right only-desktop\">--><!--      <i class=\"faq-icon\"></i>--><!--      <a ui-sref=\"faq\"><p class=\"white\">FAQ</p></a>--><!--    </div>--><!--  </header>--><!--  <section class=\"content-wrapper col-xs-12 col-sm-10\">--><!--    <div class=\"col-xs-12 col-sm-6 registration-left\">--><!--      <h3>Unlock ARN</h3>--><!--      <p>Fill in the details to unlock your ARN.</p>--><!--    </div>--><login-header></login-header><hdfc-login-sidebar></hdfc-login-sidebar><div ui-view></div><hdfc-footer></hdfc-footer><!--  </section>--></div>");
$templateCache.put("app/unlock-arn/unlockArn.main.html","<!--<div class=\"col-xs-12 col-sm-5 form-wrapper\" style=\"padding-top: 10%;\">--><!--  <form autocomplete=\"off\" name=\"UnlockArn.unlockArnForm\" ng-submit=\"UnlockArn.generateOtp()\" novalidate>--><!--    <div class=\"input-normal\"--><!--         ng-class=\"{error:UnlockArn.unlockArnForm.arnCode.$dirty && UnlockArn.unlockArnForm.arnCode.$invalid}\">--><!--      <input ng-model=\"UnlockArn.signupUser.arnCode\" type=\"text\" maxlength=\"10\" name=\"arnCode\"--><!--             ng-pattern=\"UnlockArn.appConstants.arn_regex\"  capitalize required class=\"arn-no\" autocomplete=\"off\">--><!--      <span class=\"highlight\"></span>--><!--      <span class=\"bar\"></span>--><!--      <span class=\"arn\">ARN -</span>--><!--      <label>ARN</label>--><!--      <span ng-show=\"UnlockArn.unlockArnForm.arnCode.$dirty && UnlockArn.unlockArnForm.arnCode.$invalid\">--><!--            <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.arnCode.$error.required\"--><!--                  ng-bind=\"UnlockArn.validateData.ARN_REQUIRED\"></span>--><!--            <span class=\"error-input\"--><!--                  ng-show=\"UnlockArn.unlockArnForm.arnCode.$error.pattern && UnlockArn.unlockArnForm.arnCode.$invalid \"--><!--                  class=\"help-block\">--><!--              {{ UnlockArn.validateData.ARN_FIELD }}--><!--              </span>--><!--        </span>--><!--    </div>--><!--    <p class=\"provide-details\">Enter your registered Email ID or Mobile No to get OTP :</p>--><!--    <br>--><!--    <div class=\"radio-textbox clearfix\">--><!--      <div class=\"radio-block\">--><!--              <span class=\"radio\">--><!--                <input value=\"email\" ng-change=\"UnlockArn.changeFields()\" ng-model=\"UnlockArn.selectedField\" type=\"radio\" name=\"forgetFolio\" checked/>--><!--                <span class=\"check\"></span>--><!--              </span>--><!--      </div>--><!--      <div class=\"input-normal radio-input\" ng-class=\"{error:UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid}\">--><!--        <input type=\"email\" class=\"\" no-focus name=\"email\" ng-pattern=\"UnlockArn.pattern.email_regex\"--><!--               ng-model=\"UnlockArn.signupUser.emailAddress\" ng-disabled=\"UnlockArn.selectedField !== \'email\'\"--><!--               maxlength=\"150\"--><!--               ng-required=\"UnlockArn.selectedField === \'email\'\" easyassist-key=\"mask-element\">--><!--        <span class=\"highlight\"></span>--><!--        <span class=\"bar\"></span>--><!--        <label>Email ID</label>--><!--        <span--><!--          ng-show=\"UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid && UnlockArn.unlockArnForm.email.$touched\">--><!--                <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.email.$error.required\"--><!--                      ng-bind=\"UnlockArn.validateData.KYC_VERIFIED_EMAIL\"></span>--><!--                <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.email.$error.pattern\"--><!--                      class=\"help-block\" ng-bind=\"UnlockArn.validateData.EMAIL_FIELD\">--><!--                </span>--><!--              </span>--><!--      </div>--><!--    </div>--><!--    <div class=\"radio-textbox clearfix\">--><!--      <div class=\"radio-block\">--><!--              <span class=\"radio\">--><!--                <input ng-change=\"UnlockArn.changeFields()\" value=\"mobile\" ng-model=\"UnlockArn.selectedField\" name=\"forgetFolio\" type=\"radio\"/>--><!--                <span class=\"check\"></span>--><!--              </span>--><!--      </div>--><!--      <div class=\"input-normal radio-input\" style=\"margin-bottom: 40px;\" ng-class=\"{error:UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid}\">--><!--        <input type=\"tel\" easyassist-key=\"mask-element\" class=\"\" no-focus name=\"phone\" ng-pattern=\"UnlockArn.pattern.mobile_regex\"  maxlength=\"13\"--><!--               ng-model=\"UnlockArn.signupUser.mobileNumber\" ng-disabled=\"UnlockArn.selectedField !== \'mobile\'\" ng-required=\"UnlockArn.selectedField === \'mobile\'\">--><!--        <span class=\"highlight\"></span>--><!--        <span class=\"bar\"></span>--><!--        <label>Mobile Number</label>--><!--        <span ng-show=\"UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.phone.$error.pattern\"--><!--                      class=\"help-block\" ng-bind=\"UnlockArn.validateData.MOBILE_ISD\">--><!--                </span>--><!--              </span>--><!--      </div>--><!--    </div>--><!--    <div class=\"input-normal\" ng-if=\"UnlockArn.showCaptcha\">--><!--      <div vc-recaptcha key=\"UnlockArn.publicKey\" ng-model=\"UnlockArn.gRecaptchaResponse\"></div>--><!--    </div>--><!--    <span class=\"error\" ng-if=\"UnlockArn.errorMessage\">--><!--        <span class=\"error-message help-block\">{{ UnlockArn.errorMessage }}</span>--><!--      </span>--><!--    <button type=\"submit\" class=\"btn btn-primary-action btn-block\"--><!--            ng-disabled=\"UnlockArn.unlockArnForm.$invalid || UnlockArn.processFlag\">Submit--><!--    </button>--><!--    <button type=\"button\" class=\"btn btn-secondary-action btn-block\" ng-click=\"UnlockArn.confirmCancel()\">Cancel--><!--    </button>--><!--  </form>--><!--</div>--><div class=\"container-fluid forgot-password-container\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=UnlockArn.goBack();><i class=back-icon></i></a></div><div class=forgot-form-container><form autocomplete=off autofocus name=UnlockArn.unlockArnForm ng-submit=UnlockArn.generateOtp() novalidate><h2 class=info>Unlock <span class=partner-blue>ARN</span></h2><div class=input-normal ng-class=\"{error:UnlockArn.unlockArnForm.arnCode.$dirty && UnlockArn.unlockArnForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input ng-model=UnlockArn.signupUser.arnCode type=text maxlength=10 name=arnCode ng-pattern=UnlockArn.appConstants.arn_regex placeholder=ARN capitalize required class=arn-no autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span> <span ng-show=\"UnlockArn.unlockArnForm.arnCode.$dirty && UnlockArn.unlockArnForm.arnCode.$invalid\"><span class=error-input ng-show=UnlockArn.unlockArnForm.arnCode.$error.required ng-bind=UnlockArn.validateData.ARN_REQUIRED></span> <span class=error-input ng-show=\"UnlockArn.unlockArnForm.arnCode.$error.pattern && UnlockArn.unlockArnForm.arnCode.$invalid \" class=help-block>{{ UnlockArn.validateData.ARN_FIELD }}</span></span></div><p class=provide-details>Enter Your Registered Email ID or Mobile Number<span class=req>*</span></p><br><!--              <div class=\"radio-textbox clearfix\">--><!--                <div class=\"radio-block\">--><!--                        <span class=\"radio\">--><!--                          <input value=\"email\" ng-change=\"UnlockArn.changeFields()\" ng-model=\"UnlockArn.selectedField\" type=\"radio\" name=\"forgetFolio\" checked/>--><!--                          <span class=\"check\"></span>--><!--                        </span>--><!--                </div>--><!--                <div class=\"input-normal radio-input\" ng-class=\"{error:UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid}\">--><!--                  <input type=\"email\" class=\"\" no-focus name=\"email\" ng-pattern=\"UnlockArn.pattern.email_regex\"--><!--                         ng-model=\"UnlockArn.signupUser.emailAddress\" ng-disabled=\"UnlockArn.selectedField !== \'email\'\"--><!--                         maxlength=\"150\"--><!--                         ng-required=\"UnlockArn.selectedField === \'email\'\" easyassist-key=\"mask-element\">--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <label>Email ID</label>--><!--                  <span--><!--                    ng-show=\"UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid && UnlockArn.unlockArnForm.email.$touched\">--><!--                          <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.email.$error.required\"--><!--                                ng-bind=\"UnlockArn.validateData.KYC_VERIFIED_EMAIL\"></span>--><!--                          <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.email.$error.pattern\"--><!--                                class=\"help-block\" ng-bind=\"UnlockArn.validateData.EMAIL_FIELD\">--><!--                          </span>--><!--                        </span>--><!--                </div>--><!--              </div>--><!--              <div class=\"radio-textbox clearfix\">--><!--                <div class=\"radio-block\">--><!--                        <span class=\"radio\">--><!--                          <input ng-change=\"UnlockArn.changeFields()\" value=\"mobile\" ng-model=\"UnlockArn.selectedField\" name=\"forgetFolio\" type=\"radio\"/>--><!--                          <span class=\"check\"></span>--><!--                        </span>--><!--                </div>--><!--                <div class=\"input-normal radio-input\" style=\"margin-bottom: 40px;\" ng-class=\"{error:UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid}\">--><!--                  <input type=\"tel\" easyassist-key=\"mask-element\" class=\"\" no-focus name=\"phone\" ng-pattern=\"UnlockArn.pattern.mobile_regex\"  maxlength=\"13\"--><!--                         ng-model=\"UnlockArn.signupUser.mobileNumber\" ng-disabled=\"UnlockArn.selectedField !== \'mobile\'\" ng-required=\"UnlockArn.selectedField === \'mobile\'\">--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <label>Mobile Number</label>--><!--                  <span ng-show=\"UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid\">--><!--                          <span class=\"error-input\" ng-show=\"UnlockArn.unlockArnForm.phone.$error.pattern\"--><!--                                class=\"help-block\" ng-bind=\"UnlockArn.validateData.MOBILE_ISD\">--><!--                          </span>--><!--                        </span>--><!--                </div>--><!--              </div>--><!--              <div class=\"input-normal\" ng-if=\"UnlockArn.showCaptcha\">--><!--                <div vc-recaptcha key=\"UnlockArn.publicKey\" ng-model=\"UnlockArn.gRecaptchaResponse\"></div>--><!--              </div>--><div class=\"radio-btn clearfix\"><div class=radio-block><span class=radio><input value=email ng-change=UnlockArn.changeFields() ng-model=UnlockArn.selectedField type=radio name=forgetFolio> <span class=check></span></span><div class=label-block><span class=radio-label>Email ID</span></div><span class=radio><input ng-change=UnlockArn.changeFields() value=mobile ng-model=UnlockArn.selectedField name=forgetFolio type=radio ng-checked=\"UnlockArn.selectedField === \'mobile\'\"> <span class=check></span></span><div class=label-block><span class=radio-label>Mobile Number</span></div></div></div><div class=\"input-normal radio-input\" ng-if=\"UnlockArn.selectedField == \'email\'\" ng-class=\"{error:UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid}\"><input type=email no-focus name=email placeholder=\"Enter Email ID\" ng-pattern=UnlockArn.appConstants.email_regex ng-model=UnlockArn.signupUser.emailAddress ng-disabled=\"UnlockArn.selectedField !== \'email\'\" maxlength=150 ng-required=\"UnlockArn.selectedField === \'email\'\" easyassist-key=mask-element> <span class=highlight></span> <span class=bar></span> <span ng-show=\"UnlockArn.unlockArnForm.email.$dirty && UnlockArn.unlockArnForm.email.$invalid && UnlockArn.unlockArnForm.email.$touched\"><span class=error-input ng-show=UnlockArn.unlockArnForm.email.$error.required ng-bind=UnlockArn.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=UnlockArn.unlockArnForm.email.$error.pattern class=help-block ng-bind=UnlockArn.validateData.EMAIL_FIELD></span></span></div><div class=\"input-normal radio-input\" style=\"margin-bottom: 40px\" ng-if=\"UnlockArn.selectedField == \'mobile\'\" ng-class=\"{error:UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid}\"><input type=tel easyassist-key=mask-element placeholder=\"Enter Mobile Number\" no-focus name=phone ng-pattern=UnlockArn.appConstants.mobile_regex maxlength=13 ng-model=UnlockArn.signupUser.mobileNumber ng-disabled=\"UnlockArn.selectedField !== \'mobile\'\" ng-required=\"UnlockArn.selectedField === \'mobile\'\"> <span class=highlight></span> <span class=bar></span> <span ng-show=\"UnlockArn.unlockArnForm.phone.$dirty && UnlockArn.unlockArnForm.phone.$invalid\"><span class=error-input ng-show=UnlockArn.unlockArnForm.phone.$error.pattern class=help-block ng-bind=UnlockArn.validateData.MOBILE_ISD></span></span></div><span class=error ng-if=UnlockArn.errorMessage><span class=\"error-message help-block\">{{ UnlockArn.errorMessage }}</span> </span><!--<div class=\"input-normal\" ng-if=\"UnlockArn.showCaptcha\">\n                <div vc-recaptcha key=\"UnlockArn.publicKey\" ng-model=\"UnlockArn.gRecaptchaResponse\"></div>\n              </div>--><div class=form-action-container><input type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=UnlockArn.goBack(); value=Back> <button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=\"UnlockArn.unlockArnForm.$invalid || UnlockArn.processFlag || !UnlockArn.selectedField\">Get OTP</button></div><!--              <button type=\"button\" class=\"btn btn-secondary-action btn-block\" ng-click=\"UnlockArn.confirmCancel()\">Cancel--><!--              </button>--></form></div></div></div></div></div>");
$templateCache.put("app/unlock-arn/unlockArn.otp.html","<!--<div class=\"col-xs-12 col-sm-5 form-wrapper\">--><!--  <form autocomplete=\"off\" name=\"UnlockArn.otpForm\" ng-submit=\"UnlockArn.verifyOtp()\" autocomplete=\"off\" novalidate>--><!--    <h3 class=\"otpverified\"><i class=\"success-icon\"></i><span> ARN Verified</span></h3>--><!--    <p class=\"otp-notify\">We have sent you an OTP.<br>Please enter the same to verify your account.</p>--><!--    <div class=\"input-normal\" ng-class=\"{error:UnlockArn.otpForm.otpNumber.$dirty && UnlockArn.otpForm.otpNumber.$invalid}\">--><!--      <input ng-pattern=\"UnlockArn.appConstants.otp_regex\" ng-model=\"UnlockArn.otpVerificationPayload.otpNumber\" easyassist-key=\"mask-element\" ng-if=\"!UnlockArn.inputReset\"  ng-click=\"UnlockArn.resetValues()\" type=\"text\" minlength=\"6\" maxlength=\"6\" name=\"otpNumber\" autocomplete=\"off\" required>--><!--      <span class=\"highlight\"></span>--><!--      <span class=\"bar\"></span>--><!--      <span class=\"forgot\">--><!--&lt;!&ndash;        <span ng-if=\"UnlockArn.otpResendMessage\" style=\"color: #1bb898\">{{UnlockArn.otpResendMessage}}</span>&ndash;&gt;--><!--&lt;!&ndash;        <span class=\"error\" ng-if=\"UnlockArn.errorMessage!=\'SUCCESS\' && !UnlockArn.otpForm.otpNumber.$error.required\">&ndash;&gt;--><!--&lt;!&ndash;        <span class=\"error-message help-block\">{{ UnlockArn.errorMessage }}</span>&ndash;&gt;--><!--&lt;!&ndash;      </span>&ndash;&gt;--><!--        <timer countdown=\"UnlockArn.appConstants.RESEND_OTP_COUNTER\" interval=\"1000\" >--><!--         <span ng-show=\"countdown > 0\" style=\"position: absolute;top: 45px;right: 0px;\" class=\"forgot-pwd\">Enable Resend OTP in {{countdown}}s</span>--><!--         <a href=\"javascript:void(0);\" ng-show=\"countdown ==0\" ng-click=\"UnlockArn.reGenerateOtp()\" ng-class=\"{anchorDisable:UnlockArn.processOTPFlag}\"--><!--            class=\"resend-otp cursor-pointer\">Resend OTP</a>--><!--        </timer>--><!--      </span>--><!--      <label>Enter OTP</label>--><!--					<span ng-show=\"UnlockArn.otpForm.otpNumber.$dirty && UnlockArn.otpForm.otpNumber.$invalid\">--><!--						<span class=\"error-input\" ng-show=\"UnlockArn.otpForm.otpNumber.$error.required\" ng-bind=\"UnlockArn.appConstants.ToastrMessage.VALIDATE_DATA.OTP_REQUIRED\"></span>--><!--						<span class=\"error-input\" ng-show=\"UnlockArn.otpForm.otpNumber.$error.maxlength\">{{ UnlockArn.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>--><!--						<span class=\"error-input\" ng-show=\"UnlockArn.otpForm.otpNumber.$error.minlength\">{{ UnlockArn.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>--><!--            <span class=\"error-input\" ng-show=\"UnlockArn.otpForm.otpNumber.$error.pattern\">{{ UnlockArn.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>--><!--					</span>--><!--    </div>--><!--    <button type=\"submit\" class=\"btn btn-primary-action btn-block mg40 mgtop\" ng-disabled=\"UnlockArn.otpForm.$invalid || UnlockArn.processFlag\">Submit</button>--><!--    <button type=\"button\" class=\"btn btn-secondary-action btn-block\" ng-click=\"UnlockArn.confirmCancel(\'otp\')\">Cancel</button>--><!--  </form>--><!--</div>--><div class=\"Otp-section container-fluid\"><div class=\"row row-flex\"><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=UnlockArn.goBack();><i class=back-icon></i></a></div><div class=forgot-form-container><form autocomplete=off name=UnlockArn.otpForm ng-submit=UnlockArn.verifyOtp() autocomplete=off novalidate><h2 class=info>Enter <span class=partner-blue>Verification Code</span></h2><p class=sub-heading>{{UnlockArn.msg}}</p><div class=\"input-normal input-code\" ng-class=\"{error:UnlockArn.otpForm.otpNumber.$dirty && UnlockArn.otpForm.otpNumber.$invalid}\"><label class=visible-xs>Enter OTP<span class=req>*</span></label><div class=input-code-container><input type=tel id=otp-number-input-1 class=otp-number-input minlength=1 maxlength=1 tabindex=1 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex1 is-number custom-auto-focus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=otp-number-input minlength=1 maxlength=1 tabindex=2 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=otp-number-input minlength=1 maxlength=1 tabindex=3 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=otp-number-input minlength=1 maxlength=1 tabindex=4 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=otp-number-input minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=otp-number-input minlength=1 maxlength=1 tabindex=6 autocomplete=off ng-change=UnlockArn.otpValChanged(this) ng-model=UnlockArn.otpValIndex6 is-number easyassist-key=mask-element></div><div class=forgot><timer countdown=UnlockArn.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd><span class=link-text>Didn\'t receive a code? Don\'t worry. </span><span class=counter-text>Retry in {{countdown}} seconds</span> </span><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=UnlockArn.reGenerateOtp() class=forgot-pwd>Resend OTP</a></timer></div><span ng-show=\"UnlockArn.otpForm.otpNumber.$dirty && UnlockArn.otpForm.otpNumber.$invalid\"><span class=\"error-input text-left\" ng-show=UnlockArn.otpForm.otpNumber.$error.required ng-bind=UnlockArn.validateData.OTP_REQUIRED></span> <span class=info-primary style=left:13% ng-if=UnlockArn.loginUsingOtpFlag ng-bind=UnlockArn.otpResendMessage></span></span></div><div class=row><div class=col-md-12><div class=\"form-action form-action-container\"><button type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=UnlockArn.goBack();>Back</button> <input type=submit class=\"btn btn-primary-action btn-block\" type=submit ng-disabled=\"UnlockArn.otpForm.$invalid || UnlockArn.processFlag || UnlockArn.otpCodeLength !== 6\" value=Submit></div></div></div></form></div></div><!--<div class=\"container-fluid form-container\">\n      <div class=\"col-md-11 form-section\">\n        <div class=\"tab-content\">\n          <div role=\"tabpanel\" class=\"tab-pane active\" id=\"MFD\">\n\n          </div>\n        </div>\n      </div>\n    </div>--></div></div></div><script>// const $inp = $(\".otp-number-input\");\n  $(\".otp-number-input\").on({\n    paste(ev) { // Handle Pasting\n\n      const clip = ev.originalEvent.clipboardData.getData(\'text\').trim();\n      // Allow numbers only\n      if (!/\\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here\n      // Split string to Array or characters\n      const s = [...clip];\n      // Populate inputs. Focus last input.\n      $(\".otp-number-input\").val(i => s[i]).eq(5).focus();\n    },\n  });</script>");
$templateCache.put("app/unlock-arn/unlockArn.success.html","<div class=container><div class=\"col-xs-12 col-sm-12 form-wrapper unlockarn-success-container\"><div class=content-container><div class=back-img-div><div class=success-msg>Submitted Successfully</div></div><div class=\"info text-center\">Thanks for verifying your account with OTP.<br>An email has been sent to your registered email ID with temporary password.</div><form autocomplete=off><button type=button ui-sref=login class=\"btn btn-primary-action btn-block\">Proceed to Login</button></form></div></div></div><!--\n<div class=\"container-fluid forgot-password-container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-5 col-md-5\">\n      <img class=\"bg-forgot-image\" src=\"assets/images/bg-forgot.png\" class=\"height100 ng-scope\" width=\"100%\">\n    </div>\n    <div class=\"col-xs-12 col-sm-7 col-md-7\">\n      <div id=\"forgotPassModal\" class=\"forgot-container\">\n&lt;!&ndash;        <div class=\"\">&ndash;&gt;\n            <p class=\"text-center\">\n              Thanks for verifying your account with OTP.<br/>\n              An email has been sent to your registered email ID with temporary password.\n            </p>\n          <form autocomplete=\"off\">\n            <button ui-sref=\"login\" class=\"btn btn-primary-action btn-block\">Proceed to Login</button>\n          </form>\n&lt;!&ndash;        </div>&ndash;&gt;\n\n      </div>\n\n    </div>\n  </div>\n</div>-->");
$templateCache.put("app/transactions/transactions.html","<agent-sidebar ng-if=\"Transaction.loginType==\'A\'\"></agent-sidebar><div ui-view></div>");
$templateCache.put("app/agent/change-password/change-password.html","<section class=\"agent-login clearfix\"><div class=\"col-md-6 side-image\"></div><div class=col-md-6><p class=\"text-right faq-link\"><i class=faq-blue-icon></i> FAQ</p><div class=agent-login-form><h4>CHANGE PASSWORD</h4><p>In order to proceed further, we recommend to change your default password.</p><form autocomplete=off name=changePasswordForm ng-submit=ChangeAgentPassword.agentLogin(changePasswordForm) novalidate><div class=input-normal ng-class=\"{error: (changePasswordForm.password.$dirty && changePasswordForm.password.$invalid) || (changePasswordForm.password.$dirty && !ChangeAgentPassword.isPasswordMatchWithPattern)}\" tooltips tooltip-template=\"Password should contain minimum 8 & maximum 15 characters, atleast one capital letter, one small letter, one number and one special character($@!_)\" tooltip-show-trigger=focusin , tooltip-show-trigger=focusout tooltip-side=left><input id=passwordId class=passwordId tabindex=2 name=password type=password ng-model=pw minlength=8 maxlength=15 required ng-focus=Login.removeReadOnly() autocomplete=off stopcopypaste ng-change=\"ChangeAgentPassword.isPasswordMatchWithPattern = ChangeAgentPassword.isMatching.test(pw); ChangeAgentPassword.changePasswordFormIsValid = !(pw && pw === ChangeAgentPassword.userForm.confirmPassword); ChangeAgentPassword.passwordMatch = !ChangeAgentPassword.changePasswordFormIsValid\"> <span class=highlight></span> <span class=bar></span> <i class=lock-icon></i><label>New Password</label><span ng-show=\"changePasswordForm.password.$dirty && changePasswordForm.password.$invalid\"><span class=error-input ng-show=changePasswordForm.password.$error.required ng-bind=ChangeAgentPassword.validateData.PASSWORD_REQUIRED></span> </span><span class=error-input ng-show=\"changePasswordForm.password.$dirty && !changePasswordForm.password.$invalid && !ChangeAgentPassword.isPasswordMatchWithPattern\" ng-bind=ChangeAgentPassword.validateData.PASSWORD_FIELD></span><ul id=strength check-strength=pw></ul></div><div class=input-normal ng-class=\"{error: (changePasswordForm.changePassword.$dirty && changePasswordForm.changePassword.$invalid) || (changePasswordForm.changePassword.$dirty && !ChangeAgentPassword.passwordMatch)}\"><input class=passwordId tabindex=2 name=changePassword type=password ng-model=ChangeAgentPassword.userForm.confirmPassword required ng-focus=Login.removeReadOnly() autocomplete=off stopcopypaste ng-change=\"ChangeAgentPassword.passwordMatch = ((ChangeAgentPassword.userForm.confirmPassword === pw) && ChangeAgentPassword.userForm.confirmPassword !== \'\'); (ChangeAgentPassword.passwordMatch && !changePasswordForm.$invalid && ChangeAgentPassword.isPasswordMatchWithPattern) ?  ChangeAgentPassword.changePasswordFormIsValid = false : ChangeAgentPassword.changePasswordFormIsValid = true\"> <span class=highlight></span> <span class=bar></span> <i class=lock-icon></i><label>Confirm New Password</label><span ng-show=\"changePasswordForm.changePassword.$dirty && changePasswordForm.changePassword.$invalid\"><span class=error-input ng-show=changePasswordForm.changePassword.$error.required ng-bind=ChangeAgentPassword.validateData.CONFIRM_PASSWORD_REQUIRED></span> </span><span class=error-input ng-show=\"changePasswordForm.changePassword.$dirty && !changePasswordForm.changePassword.$invalid && !ChangeAgentPassword.passwordMatch\" ng-bind=ChangeAgentPassword.validateData.PASSWORD_MATCH></span></div><input id=submitLogin tabindex=3 type=submit ng-disabled=ChangeAgentPassword.changePasswordFormIsValid class=\"btn btn-primary-action btn-block btn-login\" value=\"Change Password\"></form></div></div></section>");
$templateCache.put("app/agent/create-user/create-user.html","<agent-header></agent-header><section class=\"main-section--superadmin create-user\"><h4 class=page-title>Create New Agent</h4><div class=col-md-7><div class=agent-create-form><form autocomplete=off name=agentSignupForm ng-submit=SuperadminCreateUser.register() novalidate><div class=row><div class=col-sm-6><div class=input-normal ng-class=\"{error:agentSignupForm.name.$dirty && agentSignupForm.name.$invalid}\"><input autofocus name=name ng-model=SuperadminCreateUser.formData.name autocomplete=off type=text id=name required> <span class=highlight></span> <span class=bar></span><label>Agent Name</label><span class=error-input ng-messages=agentSignupForm.name.$error ng-show=\"agentSignupForm.name.$dirty && agentSignupForm.name.$invalid\"><span class=error-input ng-message=required ng-bind=SuperadminCreateUser.validateData.NAME_REQUIRED></span></span></div></div><div class=col-sm-6><div class=input-normal ng-class=\"{error:agentSignupForm.userId.$dirty && agentSignupForm.userId.$invalid || SuperadminCreateUser.isAgentAlreadyExist}\"><input autofocus name=userId ng-model=SuperadminCreateUser.formData.userId ng-blur=SuperadminCreateUser.isAgentExist() ng-change=\"SuperadminCreateUser.isAgentAlreadyExist=false\" autocomplete=off type=text required> <span class=highlight></span> <span class=bar></span><label>Agent User ID</label><span class=error-input ng-messages=agentSignupForm.userId.$error ng-show=agentSignupForm.userId.$dirty><span class=error-input ng-message=required ng-bind=SuperadminCreateUser.validateData.USER_ID_REQUIRED></span> <span class=error-input ng-message=pattern ng-bind=SuperadminCreateUser.validateData.USER_ID_FIELD></span> </span><span class=error-input ng-if=SuperadminCreateUser.isAgentAlreadyExist ng-bind=SuperadminCreateUser.errorMessage></span></div></div></div><div class=row><div class=col-sm-6><div class=input-normal ng-class=\"{error:agentSignupForm.contact.$dirty && agentSignupForm.contact.$invalid}\"><input autofocus is-number name=contact ng-model=SuperadminCreateUser.formData.contact minlength=10 maxlength=10 ng-pattern=SuperadminCreateUser.appConstants.mobile_regex autocomplete=off type=text required> <span class=highlight></span> <span class=bar></span><label>Mobile Number</label><span class=error-input ng-messages=agentSignupForm.contact.$error ng-show=agentSignupForm.contact.$dirty><span ng-message=required ng-bind=SuperadminCreateUser.validateData.MOBILE_REQUIRED></span> <span ng-message=pattern ng-bind=SuperadminCreateUser.validateData.MOBILE_ISD></span> <span ng-message=minlength ng-bind=SuperadminCreateUser.validateData.MOBILE_FIELD></span> <span ng-message=maxlength ng-bind=SuperadminCreateUser.validateData.MOBILE_FIELD></span></span></div></div><div class=col-sm-6><div class=input-normal ng-class=\"{error:agentSignupForm.pan.$dirty && agentSignupForm.pan.$invalid}\"><input type=text name=pan maxlength=10 minlength=10 ng-model=SuperadminCreateUser.formData.pan ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ capitalize required> <span class=error-input ng-messages=agentSignupForm.pan.$error ng-show=\"agentSignupForm.pan.$dirty && agentSignupForm.pan.$invalid\"><span ng-message=required ng-bind=SuperadminCreateUser.validateData.PAN_REQUIRED></span> <span ng-message=pattern ng-bind=SuperadminCreateUser.validateData.PAN_FIELD></span> <span ng-message=minlength ng-bind=SuperadminCreateUser.validateData.PAN_FIELD></span> <span ng-message=maxlength ng-bind=SuperadminCreateUser.validateData.PAN_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>PAN<span class=req>*</span></label></div></div></div><div class=row><div class=col-sm-6><div class=\"input-normal password-field\" ng-class=\"{error:agentSignupForm.password.$dirty && agentSignupForm.password.$invalid || SuperadminCreateUser.isRequired || !SuperadminCreateUser.isMatching}\" tooltips tooltip-template=\"Password should contain minimum 8 & maximum 15 characters, atleast one capital letter, one small letter, one number and one special character($@!_)\" tooltip-show-trigger=focusin , tooltip-show-trigger=focusout tooltip-side=left><input type=password ng-model=pw name=password id=pwId minlength=8 maxlength=15 ng-change=SuperadminCreateUser.checkPattern(pw) autocomplete=off required> <span class=error-input ng-if=SuperadminCreateUser.isRequired ng-bind=SuperadminCreateUser.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-if=!SuperadminCreateUser.isMatching ng-bind=SuperadminCreateUser.validateData.PASSWORD_FIELD></span> <span class=highlight></span> <span class=bar></span><label>Password</label><ul id=strength check-strength=pw></ul></div></div><div class=col-sm-6><div class=input-normal ng-class=\"{error:agentSignupForm.confirmPassword.$dirty && agentSignupForm.confirmPassword.$invalid}\"><input type=password ng-model=SuperadminCreateUser.formData.confirmPassword name=confirmPassword ng-pattern=SuperadminCreateUser.formData.password required autocomplete=off> <span ng-show=agentSignupForm.confirmPassword.$dirty><span class=error-input ng-show=agentSignupForm.confirmPassword.$error.required ng-bind=SuperadminCreateUser.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=agentSignupForm.confirmPassword.$error.pattern>{{ SuperadminCreateUser.validateData.PASSWORD_MATCH }}</span> </span><span class=highlight></span> <span class=bar></span><label>Confirm Password</label></div></div></div><div class=row><div class=col-sm-12><input id=submitLogin type=submit ng-disabled=\"SuperadminCreateUser.isAgentAlreadyExist || agentSignupForm.$invalid || SuperadminCreateUser.processFlag || !SuperadminCreateUser.isMatching\" class=\"btn btn-primary-action btn-login\" value=\"Create New Agent\"> <button class=\"btn btn-secondary-action\" style=\"vertical-align: bottom\" ui-sref=agent.superadmin>Back</button></div></div></form></div></div></section>");
$templateCache.put("app/agent/distributor-home/distributor-home.html","<agent-header></agent-header><agent-sidebar></agent-sidebar><section class=\"main-section--agent distributor-home\" ng-init=AgentDistributorHome.init();><ol class=breadcrumb><li><i class=blue-home-icon></i></li><li>Distributor</li><li>{{AgentDistributorHome.distributorName}}</li></ol><div class=page-title><h4>Initiate Transaction</h4><p>You can initiate transaction on behalf of the distributor.</p></div><div class=transaction-tabs><span ng-click=\"AgentDistributorHome.searchInvestor(\'SIP or Purchase\')\">SIP or Purchase<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'FLEXSIP\')\">Flex SIP<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'Switch\')\">Switch<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'Systematic Withdrawal Plan\')\">SWP<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'Systematic Transfer Plan\')\">STP<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'Redemption\')\">Redeem<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'Instant Access Facility\')\">Instant Access Facility<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'DTP\')\">TIP<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'FlexIndex\')\">Flex Index<i class=arrow-proceed-blue-icon></i></span> <span ng-click=\"AgentDistributorHome.searchInvestor(\'FlexSTP\')\">Flex STP<i class=arrow-proceed-blue-icon></i></span><!-- commented at FD-1823<span ng-click=\"AgentDistributorHome.searchInvestor(\'SwingSTP\')\">Swing STP<i class=\"arrow-proceed-blue-icon\"></i></span>--> <span ng-click=\"AgentDistributorHome.searchInvestor(\'RollOver\')\">Roll Over<i class=arrow-proceed-blue-icon></i></span></div></section>");
$templateCache.put("app/agent/distributor-list/agent-distributor-list.html","<agent-header></agent-header><agent-sidebar></agent-sidebar><section class=\"main-section--agent distributor-list clearfix\"><!-- ng-init=\"Modal.searchDistributor();\"--><div class=page-title>Welcome (You are {{AgentDistributorList.socketStatus}} <span ng-if=\"AgentDistributorList.socketStatus == \'Online\'\" class=connection-status-online></span> <span ng-if=\"AgentDistributorList.socketStatus == \'Offline\'\" class=connection-status-offline></span>)</div><div ng-if=false><div class=page-title>Search Distributor</div><div class=total-distributors ng-if=AgentDistributorList.distributorData.length>Total Distributors: <strong ng-bind=AgentDistributorList.count></strong></div></div><div class=action-bar ng-if=\" !AgentDistributorList.showSearch\"><div class=search-filter><strong>Search By ARN: </strong><!--      <span class=\"radio-block\">--><!--        <span class=\"radio\">--><!--          <input type=\"radio\" name=\"searchByArn\" value=\"ARN-\" ng-model=\"AgentDistributorList.searchByArn\" ng-click=\"AgentDistributorList.resetPagination()\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <label>ARN</label>--><!--       </span>--><!--      <span class=\"radio-block\">--><!--        <span class=\"radio\">--><!--          <input type=\"radio\" name=\"searchByArn\" value=\"\" ng-model=\"AgentDistributorList.searchByArn\" ng-click=\"AgentDistributorList.resetPagination()\"/>--><!--          <span class=\"check\"></span>--><!--        </span>--><!--        <label>Mobile Number</label>--><!--       </span>--></div><form><div class=search-bar><input type=text name=searchDistributor placeholder=\"Search Distributor by ARN\" capitalize pattern=[A-Z0-9]{1,10} title=\"Only Capital Apha numeric allowed.\" ng-model=AgentDistributorList.searchDistributorByName> <button class=search-btn ng-click=AgentDistributorList.searchDistributorByARN()><i class=search-white-icon></i></button></div></form><div style=\"margin-left: 7px;color: red\" class=error-input><span ng-if=\"AgentDistributorList.isSearch && !AgentDistributorList.searchDistributorByName\">{{ AgentDistributorList.validateData.ARN_NO_REQUIRED}}</span></div><div style=\"margin-left: 7px;color: red\" class=error-input><span ng-if=\"AgentDistributorList.isValidDistributorData && !AgentDistributorList.searchDistributorByName\">{{ AgentDistributorList.errorMsg}}</span></div></div><div class=table-responsive><table class=\"table table-bordered\" ng-if=AgentDistributorList.distributorData.length><thead><tr><th>Distributor Name</th><th>Distributor ARN Number</th><th>Mobile</th><th>Email ID</th><th>Status</th><th></th></tr></thead><tbody><tr ng-repeat=\"data in AgentDistributorList.distributorData\"><td>{{data.name}}</td><td>{{data.arnNumber}}</td><td>{{data.mobileNumber}}</td><td class=text-primary>{{data.email}}</td><td><p class=active-user>Agent-Active</p></td><td class=text-primary><span style=\"display: block\" ng-click=\"AgentDistributorList.proceedToDistributorHome(data.arnNumber, data.name);\">Proceed <i class=proceed-right-icon></i></span> <span ng-click=AgentDistributorList.agentAsDistributorLogout(data.arnNumber)>Dismiss</span></td></tr><tr ng-if=!AgentDistributorList.distributorData.length><td colspan=6 class=text-center>No Distributors Found !!</td></tr></tbody></table></div><div class=\"col-md-12 pagination\" ng-if=\"AgentDistributorList.isPagination && false\"><div class=total-data><span>Showing &nbsp</span><select ng-if=\"AgentDistributorList.count>=10\" ng-change=AgentDistributorList.pageLimitListChange(AgentDistributorList.pageLimitDistributorList) ng-model=AgentDistributorList.pageLimitDistributorList><option ng-repeat=\"value in AgentDistributorList.PAGE_LIMITS\" value={{value}}>{{value}}</option></select><span ng-if=\"AgentDistributorList.count<10\">{{AgentDistributorList.count}}</span> <span>of</span> <span class=t-black>{{AgentDistributorList.count}}</span></div><ul uib-pagination total-items=AgentDistributorList.count ng-model=AgentDistributorList.currentPageDistributorList max-size=5 items-per-page=AgentDistributorList.pageLimitDistributorList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=AgentDistributorList.searchDistributor() rotate=false></ul></div><!--dynamic data agent portal--><ng-bind-html dynamic=AgentDistributorList.DynamicDataAgent.content></ng-bind-html></section>");
$templateCache.put("app/agent/home/agent-home.html","<div ui-view></div>");
$templateCache.put("app/agent/investor-update-contact/basic-info.html","<section class=investors-profile><div class=tab-content ng-init=InvestorProfile.init()><div id=basic-info class=\"tab-pane fade in active\"><div class=\"clearfix bg-grey folio-header\"><p class=pull-left>Folio Details</p><!--<i class=\"edit-icon\"></i>--></div><div ng-if=\" InvestorProfile.folioListData\"><div class=folio-numbers ng-if=InvestorProfile.folioListData.length ng-init=InvestorProfile.folioDetails(InvestorProfile.folioListData[0],0)><!--<span class=\"active\">678945</span>--><ol class=list-inline><!-- TODO:Angular first li should have \"btn-secondary-action\" class --><li class=cursor-pointer ng-repeat=\"folio in InvestorProfile.folioListData track by $index\" ng-click=InvestorProfile.folioDetails(folio,$index) ng-class=\"{active:InvestorProfile.folioIndex==$index}\">{{folio.folioNo}}</li></ol></div><table class=table-data><tr><td>Name</td><td>:</td><td>{{InvestorProfile.folioDetailsData.name}}</td></tr></table><update-folio-email curr-email=InvestorProfile.folioDetailsData.email folio-number=InvestorProfile.selectedFolio.folioNo curr-mobile-number=InvestorProfile.folioDetailsData.mobileNumber c-flag=InvestorProfile.coperateFlag can-edit=InvestorProfile.canEdit contact-updated=InvestorProfile.isContactUpdateAllowed contact-updated-error=InvestorProfile.updateContactRestrictMessage></update-folio-email><update-folio-mobile curr-mobile-number=InvestorProfile.folioDetailsData.mobileNumber folio-number=InvestorProfile.selectedFolio.folioNo curr-email=InvestorProfile.folioDetailsData.email c-flag=InvestorProfile.coperateFlag can-edit=InvestorProfile.canEdit contact-updated=InvestorProfile.isContactUpdateAllowed contact-updated-error=InvestorProfile.updateContactRestrictMessage></update-folio-mobile><table class=table-data><tbody><!--<tr ng-if=\"InvestorProfile.folioDetailsData.email\">\n            <td>Email ID</td>\n            <td> :</td>\n            <td ng-if=\"!InvestorProfile.isEdit\">{{InvestorProfile.folioDetailsData.email}}\n              <i class=\"edit2-icon\" ng-click=\"InvestorProfile.makeEdit();\"></i>\n            </td>\n          </tr>\n          <tr ng-if=\"InvestorProfile.folioDetailsData.mobileNumber\">\n            <td>Mobile No</td>\n            <td> :</td>\n            <td ng-if=\"!InvestorProfile.isEdit\">{{InvestorProfile.folioDetailsData.mobileNumber}}\n              <i class=\"edit2-icon\" ng-click=\"InvestorProfile.makeEdit();\"></i>\n            </td>\n          </tr>--><tr><td>Address</td><td>:</td><td>{{InvestorProfile.folioDetailsData.address}}</td></tr><tr><td>Payout Method</td><td>:</td><td class=text-uppercase>{{InvestorProfile.folioDetailsData.payoutMethod}}</td></tr><tr><td>Bank Account</td><td>:</td><td>{{InvestorProfile.folioDetailsData.bankAccountNumber}}</td></tr><tr><td>Aadhar Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.investorAadharStatus||\'Not Available\'}}</td></tr><tr><td>Tax Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.folioTaxStatus||\'Not Available\'}}</td></tr></tbody></table><table class=table-data ng-if=\"(InvestorProfile.folioDetailsData.guardianDetails | json) != \'{}\'\"><tr><td><h6>Guardian Details</h6></td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.name><td>Name</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.name}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.pan><td>PAN</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.pan}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.relation><td>Relationship</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.relation}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.dob><td>Date of birth</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.dob}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.kyc><td>KYC Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.kyc}}</td></tr><tr><td>Aadhar Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.aadharStatus||\'Not Available\'}}</td></tr><tr><td>Aadhar Linked</td><td>:</td><td>{{InvestorProfile.folioDetailsData.guardianDetails.aadharLinked||\'Not Available\'}}</td></tr></table></div></div></div></section>");
$templateCache.put("app/agent/login/agent-login.html","<section class=\"agent-login clearfix\"><div class=\"col-md-6 side-image\"></div><div class=\"col-md-6 set-width\"><h4 class=\"text-right faq-link\"><i class=faq-blue-icon></i> <a href=/faqs>FAQ</a></h4><div class=agent-login-form><h4>AGENT LOGIN</h4><form autocomplete=off name=agentLoginForm ng-submit=AgentLogin.agentLogin() novalidate><div class=input-normal ng-class=\"{error:agentLoginForm.userId.$dirty && agentLoginForm.userId.$invalid}\"><input no-focus tabindex=1 name=userId ng-model=AgentLogin.loginPayload.userId type=text id=userId ng-change=Login.reset() required stopcopypaste autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=user-icon></i><label>User ID</label><span ng-show=\"agentLoginForm.userId.$dirty && agentLoginForm.userId.$invalid\"><span class=error-input ng-show=agentLoginForm.userId.$error.required ng-bind=Login.validateData.USER_ID_REQUIRED></span></span></div><div class=input-normal ng-class=\"{error: (agentLoginForm.password.$dirty && agentLoginForm.password.$invalid)}\"><input id=passwordId class=passwordId tabindex=2 name=password type=password ng-model=AgentLogin.loginPayload.password required ng-focus=Login.removeReadOnly() autocomplete=off stopcopypaste> <i class=lock-icon></i><label>Password</label><span ng-show=\"agentLoginForm.password.$dirty && agentLoginForm.password.$invalid\"><span class=error-input ng-show=agentLoginForm.password.$error.required ng-bind=Login.validateData.PASSWORD_REQUIRED></span></span></div><input id=submitLogin tabindex=3 type=submit ng-disabled=\"agentLoginForm.$invalid || agentLogin.loginProcessFlag\" class=\"btn btn-primary-action btn-block btn-login\" value=Login></form></div></div></section>");
$templateCache.put("app/agent/superadmin/superadmin.html","<section class=\"main-section--superadmin distributor-list clearfix\" ng-init=Superadmin.init()><div class=page-title>Registered Agents</div><div class=\"action-bar clearfix\"><div class=\"search-bar pull-left\"><input type=text name=searchDistributor placeholder=\"Search Agent By Name, User Id\" ng-model=Superadmin.searchAgentByName> <button class=search-btn ng-click=Superadmin.searchAgent()><i class=search-white-icon></i></button></div><button class=\"btn btn-primary-action pull-right\" ui-sref=agent.home.createUser>+ Create New User</button></div><table class=\"table table-bordered\" ng-if=\"Superadmin.agentList.length || (Superadmin.agentList.length === 0)\"><thead><tr><th>Agent Name</th><th>Agent Mobile</th><th>PAN Number</th><th>User ID</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"agents in Superadmin.agentList\" ng-if=\"Superadmin.agentList.length > 0\"><td ng-bind=agents.name>Naeem Sonu</td><td ng-bind=agents.mobileNumber>+91 98189 47600</td><td ng-bind=\"agents.pan || agents.panNumber\">AAGPQ3101U</td><td ng-bind=\"agents.userId || agents.id\">Naeem.Sonu</td><td class=text-danger ng-click=\"Superadmin.deleteConfirmation(agents.userId || agents.id)\"><i class=delete-icon></i> Delete User</td></tr><tr ng-if=\"Superadmin.agentList.length === 0\"><td colspan=6 class=text-center>No Distributors Found !!</td></tr></tbody></table><div class=\"col-md-12 pagination\" ng-if=Superadmin.isPagination><div class=total-data><span>Showing &nbsp</span><select ng-if=\"Superadmin.count>=10\" ng-change=Superadmin.getAgentList() ng-model=Superadmin.pageLimitAgentList><option ng-repeat=\"value in Superadmin.PAGE_LIMITS\" value={{value}}>{{value}}</option></select><span ng-if=\"Superadmin.count<10\">{{Superadmin.count}}</span> <span>of</span> <span class=t-black>{{Superadmin.count}}</span></div><ul uib-pagination total-items=Superadmin.count ng-model=Superadmin.currentPageAgentList max-size=5 items-per-page=Superadmin.pageLimitAgentList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Superadmin.pageLimitListChange() rotate=false></ul></div></section>");
$templateCache.put("app/agent/transaction-approval/transaction-approval.html","<agent-header></agent-header><agent-sidebar></agent-sidebar><section class=\"main-section--agent distributor-list distributor-home clearfix\"><ol class=breadcrumb><li><i class=blue-home-icon></i></li><li>Distributor</li><!--    <li>Transaction Approval</li>--></ol><div class=\"bottom-flow row\"><div class=\"total-distributors col-sm-5 pull-left\" ng-if=TransactionApproval.transactionListData>Total Transactions: <strong ng-bind=TransactionApproval.transactionListData.count></strong></div><div class=filters-group><select ng-change=TransactionApproval.typeChanged() ng-model=TransactionApproval.selectedType ng-options=\"_type.key for _type in TransactionApproval.TRANSACTION_TYPES\"></select></div></div><table class=\"table table-bordered\"><thead><tr><th>Date</th><th>Investor Name</th><th>Scheme</th><th>Folio No</th><th>Distributor</th><th>Transaction Type</th><th>Amount(in Rs)</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"list in TransactionApproval.transactionListData.otmEnabledInvestorTransactions\" ng-if=\"TransactionApproval.transactionListData.otmEnabledInvestorTransactions.length > 0\"><td>{{list.time}}</td><td>{{list.investorName}} <span style=\"display: block\">{{list.investorMobileNo}}</span></td><td>{{list.schemeName}} <span ng-if=list.targetSchemeName>-> {{list.targetSchemeName}}</span></td><td class=text-primary>{{list.folioNumber}}</td><th>{{list.distributorName}} <span style=\"display: block\">{{list.arnCode}}</span></th><td>{{list.transactionType}}</td><td><span ng-if=list.amount>{{list.amount | currency:\"Rs.\"}}</span> <span ng-if=list.unit>{{list.unit}} Unit</span></td><td><select class=\"btn btn-default\" ng-model=list.action ng-change=\"TransactionApproval.approval(list.transactionType, list.action, list.transactionId)\"><option value=\"\" selected>Take action</option><option value=approve>Approve</option><option value=reject>Reject</option></select></td></tr><tr ng-if=\"TransactionApproval.transactionListData.otmEnabledInvestorTransactions.length == 0\"><td colspan=8 class=text-center>No Distributors Found !!</td></tr></tbody></table><div class=\"col-md-12 pagination\" ng-if=\"TransactionApproval.transactionListData.count > 10\"><div class=total-data><span>Showing &nbsp</span><select ng-if=\"TransactionApproval.transactionListData.count>=10\" ng-change=TransactionApproval.pageLimitListChange(TransactionApproval.pageLimitTransitionList) ng-model=TransactionApproval.pageLimitTransitionList><option ng-repeat=\"value in TransactionApproval.PAGE_LIMITS\" value={{value}}>{{value}}</option></select><span ng-if=\"TransactionApproval.transactionListData.count<10\">{{TransactionApproval.transactionListData.count}}</span> <span>of</span> <span class=t-black>{{TransactionApproval.transactionListData.count}}</span></div><ul uib-pagination total-items=TransactionApproval.transactionListData.count ng-model=TransactionApproval.currentPageTransitionList max-size=5 items-per-page=TransactionApproval.pageLimitTransitionList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=TransactionApproval.searchDistributor() rotate=false></ul></div></section>");
$templateCache.put("app/components/footer/footer.html","<div class=\"vissionsec container-fluid\"><div class=row><div class=\"col-12 d-flex justify-content-center bluebg\"><p class=px-4>Mission: To be the wealth creator for every Indian</p></div><div class=\"col-12 d-flex justify-content-center redbg\"><p class=px-4>Vision: To be the most respected asset manager in the world</p></div></div></div><section class=subFooter><div class=container><div class=\"row justify-content-center\"><div class=\"col-xs-12 col-md-11\"><div class=d-flex><div class=\"me-auto visible-xs\"><div><p class=\"p_sec mb-3\">Follow Us</p><ul class=\"d-flex ps-0\"><li><a href=https://twitter.com/hdfcmf target=_blank><img src=/assets/images/one-click-img/twitter.svg alt=\"\"></a></li><li><a href=https://www.facebook.com/hdfcmutualfund target=_blank><img src=/assets/images/one-click-img/facebook.svg alt=\"\"></a></li><li><a href=https://www.instagram.com/hdfcmf target=_blank><img src=/assets/images/one-click-img/Instagram.svg alt=\"\"></a></li><li><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ target=_blank><img src=/assets/images/one-click-img/linkedin.svg alt=\"\"></a></li><li><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A target=_blank><img src=/assets/images/one-click-img/youtube.svg alt=\"\"></a></li></ul></div></div><div class=me-auto><div class=footercontact><p class=\"p_sec mb-3\">Contact us</p><div><p class=\"mb-3 callcls\"><img src=assets/images/logos/footer/call.svg class=me-2 width=20 height=20 alt=mail> <a href=tel:18002679944>1800-267-9944</a></p><p><a href=mailto:mfonlinefeedback@hdfcfund.com class=mb-3><img src=assets/images/logos/footer/mail.svg class=me-2 width=20 height=20 alt=call>mfonlinefeedback@hdfcfund.com</a></p><p><a href=\"https://api.whatsapp.com/send/?phone=8270682706&amp;text=Hi&amp;app_absent=0\" class=mb-3 target=_blank><img src=assets/images/logos/footer/whatsapp.svg class=me-2 width=20 height=20 alt=call>Say Hi on WhatsApp: 8270682706</a></p><p><a href=https://www.hdfcfund.com/contact-us/visit-us class=mb-3 target=_blank><img src=assets/images/logos/footer/location.svg class=me-2 width=20 height=20 alt=call>Click here to locate us</a></p></div></div></div><div class=\"me-auto hidden-xs\"><div><p class=\"p_sec mb-3\">Follow Us</p><ul class=\"d-flex ps-0\"><li><a href=https://twitter.com/hdfcmf target=_blank><img src=/assets/images/one-click-img/twitter.svg alt=\"\"></a></li><li><a href=https://www.facebook.com/hdfcmutualfund target=_blank><img src=/assets/images/one-click-img/facebook.svg alt=\"\"></a></li><li><a href=https://www.instagram.com/hdfcmf target=_blank><img src=/assets/images/one-click-img/Instagram.svg alt=\"\"></a></li><li><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ target=_blank><img src=/assets/images/one-click-img/linkedin.svg alt=\"\"></a></li><li><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A target=_blank><img src=/assets/images/one-click-img/youtube.svg alt=\"\"></a></li></ul></div></div><div class=\"social_icons d-flex\"><div class=\"d-none d-md-block me-5\"><p class=\"p_sec mb-3\">Download our app</p><ul class=\"d-flex ps-0\"><li><a href=https://onelink.to/wqj8sx target=_blank><img src=assets/images/parentOnlinePartners.png width=62 height=62 alt=\"\"></a></li><!--<li><a href=\"https://onelink.to/e6hkna\"><img src=\"assets/images/hdfc-mutualfund.jpg\" width=\"62\" height=\"62\" alt=\"\"></a></li>--></ul><p class=\"mt-3 psize\">Available on Android &amp; IOS</p></div></div></div></div></div></div></section><div class=\"app-icon-wrapper d-block d-md-none my-4 plainRow mob-view-one\"><p class=\"fw-bold text-center mb-3\">Download our apps</p><ul class=\"d-flex ps-0 justify-content-center\"><!--<li><a href=\"https://onelink.to/e6hkna\"><img src=\"assets/images/hdfc-mutualfund.jpg\" alt=\"\"></a></li>--><li><a href=https://onelink.to/wqj8sx target=_blank class=ms-3><img src=assets/images/parentOnlinePartners.png alt=\"\"></a></li></ul><p class=\"fw-bold text-center mt-3\">Available on Android &amp; iOS</p></div><footer class=plainRow><div class=container><!--    <div class=\"d-md-none d-block\"></div>--><!--<div class=\"row justify-content-center\">\n      <div class=\"col-md-11\">\n        <div class=\"d-none d-md-block\" id=\"darkThemeAnchor\">\n          <div class=\"row\">\n            <div class=\"col-md-3\">\n              <ul class=\"pages_list\">\n                <a href=\"\"><p class=\"p_promary mb-3\">ABOUT US</p></a>\n                <li><a href=\"https://hdfcfund.com/about-us/corporate/overview\" target=\"_blank\">Corporate Profile</a></li>\n                <li><a href=\"https://hdfcfund.com/about-us/why-hdfc\" target=\"_blank\">Investment Philosophy</a></li>\n                <li><a href=\"https://hdfcfund.com/about-us/financial/annual-reports\" target=\"_blank\">Financial Information</a></li>\n                <li><a href=\"https://hdfcfund.com/about-us/governance/codes-policies\" target=\"_blank\">Corporate Governance</a></li>\n                <li><a href=\"https://hdfcfund.com/about-us/media-center/news\" target=\"_blank\">Media Center</a></li>\n                <li><a href=\"https://hdfcfund.com/information/amc-shareholder\" target=\"_blank\">AMC Shareholder</a></li>\n              </ul>\n            </div>\n            <div class=\"col-md-3\">\n              <ul class=\"pages_list\">\n                <p class=\"p_promary mb-3\">DOWNLOADS </p>\n                <li><a href=\"https://hdfcfund.com/distributor-desk/forms\" target=\"_blank\">Forms</a></li>\n                <li><a href=\"https://hdfcfund.com/investor-desk/product-literature/kim\" target=\"_blank\">Product Information</a></li>\n                <li><a href=\"https://hdfcfund.com/investor-desk/downloads/downloads\" target=\"_blank\">Factsheet</a></li>\n                <li><a href=\"https://hdfcfund.com/investor-desk/market-update/documents\" target=\"_blank\">Market Updates</a></li>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">Policy Updates</a></li>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">Investing Insights</a></li>\n                <li><a href=\"https://hdfcfund.com/statutory-disclosure/annual-reports\" target=\"_blank\">Scheme Annual Report</a></li>\n                <li><a href=\"https://hdfcfund.com/statutory-disclosure/scheme-performance\" target=\"_blank\">Scheme Performance Summary</a></li>\n                <li><a href=\"https://hdfcfund.com/investor-desk/downloads/downloads\" target=\"_blank\">Addendum &amp; Notices</a></li>\n              </ul>\n            </div>\n            <div class=\"col-md-3\">\n              <ul class=\"pages_list\">\n                <a href=\"https://hdfcfund.com/distributor-desk/onboard\" target=\"_blank\"><p class=\"p_promary mb-3\">DISTRIBUTORS</p></a>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">Online Empanelment</a></li>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">Login</a></li><li><a href=\"/distributor-desk/forms\">Forms</a></li>\n                <li><a href=\"/information/central-know-your-customers-ckyc\" target=\"_blank\">Investor KYC</a></li>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">Go Digital</a></li>\n                <li><a href=\"https://hdfcfund.com/distributor-desk/information\" target=\"_blank\">Information</a></li>\n              </ul>\n            </div>\n            <div class=\"col-md-3\">\n              <ul class=\"pages_list\">\n                <a href=\"https://hdfcfund.com/\" target=\"_blank\"><p class=\"p_promary mb-3\">IMPORTANT LINKS</p></a>\n                <li><a href=\"https://hdfcfund.com/wealthspectrum/app/login\" target=\"_blank\">PMS</a></li>\n                <li><a href=\"https://hdfcfund.com/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports\" target=\"_blank\">TER</a></li>\n                <li><a href=\"https://hdfcfund.com/statutory-disclosure\" target=\"_blank\">Statutory Disclosures</a></li>\n                <li><a href=\"https://hdfcfund.com/statutory-disclosure/portfolio/monthly-portfolio\" target=\"_blank\">Monthly &amp; Fortnightly Scheme Portfolio</a></li>\n                <li><a href=\"https://hdfcfund.com/careers\" target=\"_blank\">Careers</a></li>\n                <li><a href=\"https://hdfcfund.com/\" target=\"_blank\">FAQ\'s</a></li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>--><div class=\"portal-footer secoundryFooter\"><div class=mx1150><div class=groupWebsiteLinks><ul class=\"d-flex flex-wrap justify-content-center\"><p class=groupwebsite>HDFC Group Websites:</p><li><a href=https://www.hdfcbank.com/ target=_blank class=fs14>HDFC Bank</a></li><li><a href=https://www.hdfclife.com/ target=_blank class=fs14>HDFC Life</a></li><li><a href=https://www.hdfcpension.com/ target=_blank class=fs14>HDFC Pension</a></li><li><a href=https://www.hdfcergo.com/ target=_blank class=fs14>HDFC Ergo</a></li><li><a href=https://www.hdfcsales.com/ target=_blank class=fs14>HDFC Sales</a></li><li><a href=https://www.hdfccredila.com/ target=_blank class=fs14>HDFC Credila</a></li><!--<li><a href=\"https://www.hdfcpropertyfund.com/\" target=\"_blank\" class=\"fs14\">HDFC Property Fund</a></li>--><li><a href=https://www.htparekhfoundation.com/ target=_blank class=fs14>HT Parekh Foundation</a></li><li><a href=https://www.thehdfcschool.com/ target=_blank class=fs14>HDFC EDU</a></li></ul></div><div class=\"justify-content-center mt-2 mt-md-0 groupWebsiteLinks\"><ul class=\"d-flex flex-wrap justify-content-center\"><li><a href=https://hdfcfund.com/privacy-policy target=_blank class=fs14>Privacy Policy</a></li><li><a href=https://hdfcfund.com/disclaimer target=_blank class=fs14>Disclaimer</a></li><li><a href=https://hdfcfund.com/sitemap target=_blank class=fs14>Sitemap</a></li></ul></div></div></div><p class=\"text-center pt-2\">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY</p><p class=copyRight>Copyright 2023</p></div></footer>");
$templateCache.put("app/components/header/header.html","<div class=head-contrast><ul><li ng-click=\"Header.changedFont(\'increment\')\" title=\"Increase font size\">A+</li><li ng-click=\"Header.changedFont(\'original\')\" title=\"Reset font size\">A</li><li ng-click=\"Header.changedFont(\'decrement\')\" title=\"Decrease font size\">A-</li><li ng-click=Header.contrast() title=\"High Contrast\" class=contrast-box><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><header class=\"container-fluid common affix not-mobile\"><div><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/logo.png> </span><span class=dist-logo><input type=file accept=.jpeg,.jpg,.png file-model-profile=Header.myFile upload=Header.uploadFile(file)> <img http-src={{Header.logoImgUrl}} ng-if=Header.logoImgUrl alt=Logo></span></div><div class=\"search-bar clearfix\"><input type=search id=searchbox-header ng-model=Header.searchString autocomplete=off ng-change=Header.searchInvestor() placeholder=\"Search Name, Folio Number, Mobile Number, Email Id, PAN.\" class=blank-input> <button ng-if=Header.searchResult&&Header.searchResult.length class=btn-cross ng-click=Header.emptySearch();><i class=times-icon></i></button> <button class=btn-search><i class=search-white-icon></i></button><div id=searchresult-div class=suggestion ng-if=Header.searchResult&&Header.searchResult.length><ul><li ng-repeat=\"data in Header.searchResult track by $index\" ng-click=Header.goToProfile(data,$index)>{{data.investorName}} -<p easyassist-key=mask-element>{{data.investorEmail}}</p></li></ul></div><!--<input type=\"search\" id=\"searchbox\" ng-model=\"Header.searchString\" autocomplete=\"off\"\n           placeholder=\"Search Name, Folio Number, Mobile Number, Email Id, PAN.\"\n           class=\"blank-input\" ng-keydown=\"Header.searchInvestor()\"/>\n    <button class=\" btn-search\" ng-disabled=\"Header.searchString.length<1\" ng-click=\"Header.searchInvestor(\'onButtonClick\')\"><i class=\"search-white-icon\"></i></button>--></div><div class=\"pull-right right-panel\"><div><span class=dropdown><a href=javascript:void(0) ng-click=Header.closeFilter() class=\"dropdown-toggle icon-box cursor-pointer\" data-toggle=dropdown><span class=initiate-transaction-icon></span> <span class=block>Initiate Transaction</span></a><ul class=\"dropdown-menu initiate-trans\"><li>Initiate Transactions for</li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SIP or Purchase\')\">SIP or Purchase</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXSIP\')\">Flex SIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Switch\')\">Switch</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Withdrawal Plan\')\">SWP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Transfer Plan\')\">STP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Redemption\')\">Redeem</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Instant Access Facility\')\">Instant Access Facility</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DTP\')\">TIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXINDEX\')\">Flex Index</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXSTP\')\">Flex STP</a></li><!--<li ng-click=\"Header.updateSideBarAgent(\'SWINGSTP\')\">Swing STP</li> commented at FD-1823--><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'ROLLOVER\')\">Roll Over</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'ChangeDividend\')\">Change IDCW Option</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SMARTSWAP\')\">SMART SWAP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DREAMSIP\')\">DREAM SIP</a></li></ul></span></div><div><a href=javascript:void(0) class=\"icon-box cursor-pointer\" ng-click=Header.updateSideBarInvestor() data-toggle=dropdown><span class=new-investor-icon></span> <span class=block>Add Investor</span></a></div><div><span class=dropdown><a href=javascript:void(0) class=icon-box data-toggle=dropdown ng-click=Header.openEcartSideBar(true)><i class=cart-icon></i> <span class=count ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</span></a></span></div><div><span class=dropdown><a href=javascript:void(0) class=icon-box id=header-notification-icon data-toggle=dropdown ng-click=Header.latestNotification(true)><i class=\"notification-icon dropdown-toggle\"></i> <span class=count ng-if=\"Header.notificationCount>0\">{{Header.notificationCount}}</span></a><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\"><a href=javascript:void(0)>{{notification.title}}</a><span class=block-style ng-if=notification.clickable ng-click=Header.openNotification(notification)><a href=#>Click to know more</a> </span></li><!--<li ng-repeat=\"notification in Header.latestNotificationList\" ng-click=\"Header.openNotification()\">{{notification.title}}<span class=\"block-style\"><a href=\"#\">Click to know more</a> </span> </li>--><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length><a href=javascript:void(0)>View All</a></li></ul></span></div><div class=no-border><span class=\"dropdown user-card\"><a href=javascript:void(0) ng-click=Header.closeFilter() class=\"user-small-pic dropdown-toggle\" data-toggle=dropdown><img http-src={{Header.profilePhotoUrl}} ng-if=Header.profilePhotoUrl><!--<i class=\"{{Header.upperCrustAward.toLowerCase().trim().replace(\' \',\'-\')}}\"></i>--></a><ul class=\"dropdown-menu initiate-trans\"><li>Hi {{Header.distributorName}}<br><small>Last Login: {{Header.lastLoginTime}}</small></li><li><a ui-sref=main.distributorProfile>My Profile</a></li><li><!--ng-if=\"Header.sidebarActive==\'dashboard\'\"--><!--<a ng-click=\"Header.widgetSelection()\"> Customize Dashboard </a>--> <a ui-sref=main.dashboardEdit>Customize Dashboard</a></li><li ng-click=Header.logoutMe()><a href=javascript:void(0)>Sign-out</a></li></ul></span></div></div><!--  <div class=\"low-head\">--><!--    <a href=\"https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf\" target=\"blank\">New cut off time</a>--><!--  </div>--></header><header class=\"mobile-header container-fluid common affix\"><div class=part-left ng-click=Header.closeFilter()><i class=menu-icon id=menuButton></i> <span class=mobile-search><i class=search-white-icon></i></span><div class=mobile-search-bar><input type=search id=searchbox ng-model=Header.searchString autocomplete=off ng-change=Header.searchInvestor() placeholder=\"Search Name, Folio Number, Mobile Number, Email Id, PAN.\" class=blank-input><div id=searchresult class=suggestion ng-if=Header.searchResult&&Header.searchResult.length><ul><li ng-repeat=\"data in Header.searchResult track by $index\" ng-click=\"Header.goToProfile(data, $index)\">{{data.result}}</li></ul></div></div></div><div class=mobile-notification><span class=dropdown><i class=\"notification-icon dropdown-toggle\" id=mobile-header-notification-icon data-toggle=dropdown ng-click=\"Header.latestNotification(true,\'mobile\')\"></i> <span ng-if=\"Header.notificationCount>0\" class=count ng-click=\"Header.latestNotification(true,\'mobile\')\">{{Header.notificationCount}}</span><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}</li><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length>View All</li></ul></span></div><div class=pull-right><span class=\"dropdown icon-box pull-right\" ng-click=Header.closeFilter()><i class=\"initiate-transaction-icon dropdown-toggle\" data-toggle=dropdown></i><ul class=\"dropdown-menu initiate-trans\"><li>Initiate Transactions for</li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SIP or Purchase\')\">SIP or Purchase</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXSIP\')\">Flex SIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Switch\')\">Switch</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Withdrawal Plan\')\">SWP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Transfer Plan\')\">STP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Redemption\')\">Redeem</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DTP\')\">TIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'ChangeDividend\')\">Change IDCW Option</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SMARTSWAP\')\">SMART SWAP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DREAMSIP\')\">DREAM SIP</a></li></ul><i class=new-investor-icon ng-click=Header.updateSideBarInvestor()></i> <a href=javascript:void(0) class=\"icon-box mobile-cart-icon\" ng-click=Header.openEcartSideBar(true)><i class=cart-icon></i> <span class=\"count mobile-item\" ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</span></a></span></div><div class=black-tint></div><!--  <div class=\"low-head\">--><!--    <a href=\"https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf\" target=\"blank\">New cut off time</a>--><!--  </div>--></header><div class=black-tint ng-class=\"{menu:Header.popup===\'navigation\'}\" ng-if=\"Header.isEnablePopups && Header.popup && Header.firstTimeLogin\"><div class=\"walkthrough-popup navigation\" ng-if=\"Header.popup===\'navigation\'\"><div class=head><h5>Navigation Panel</h5></div><div class=body><p>This is your Navigation Panel. Move cursor over the panel to explore various options.</p></div><div class=foot><span ng-click=Header.skipPopup();>Skip</span> <span class=pull-right ng-click=\"Header.updatePopup(\'initiate-transaction\')\">Next <i class=arrow-short-right-icon></i></span></div></div><div class=\"walkthrough-popup add-investor\" ng-if=\"Header.popup===\'add-investor\'\"><div class=head><h5>Add New Investor</h5></div><div class=body><p>Select this option to Add New Investor.</p></div><div class=foot><span ng-click=Header.skipPopup();Header.widgetSelection()>Done</span></div></div><div class=\"walkthrough-popup initiate-transaction\" ng-if=\"Header.popup===\'initiate-transaction\'\"><div class=head><h5>Initiate Transaction</h5></div><div class=body><p>Select this option to Initiate Transactions for your clients.</p></div><div class=foot><span ng-click=Header.skipPopup();>Skip</span> <span class=pull-right ng-click=\"Header.updatePopup(\'add-investor\')\">Next <i class=arrow-short-right-icon></i></span></div></div></div><aside class=mobile-menu style=\"overflow: scroll\"><div class=\"affix stick-top\"><div class=head><img class=logo-mobile src=../../../assets/images/logo.png><h6>Distributor Portal</h6></div><div class=dist-logo><img http-src={{Header.logoImgUrl}}></div><div class=middle ui-sref=main.distributorProfile><span class=user-pic><img http-src={{Header.profilePhotoUrl}} ng-if=Header.profilePhotoUrl alt=Image></span><h6>{{Header.distributorName}}</h6><p class=logout ng-click=Header.logoutMe()><i class=power-icon></i> Log-Out</p></div></div><nav><aside class=mobile-nav><ul class=list-group><li ui-sref=main.dashboard><span class=\"dashboard-sidebar-icon default-icon\"></span> <span class=\"dashboard-sidebar-active-icon active-icon\"></span> <span class=nav-link>Dashboard</span></li><li ui-sref=main.transactions.recent><span class=\"transaction-sidebar-icon default-icon\"></span> <span class=\"transaction-sidebar-active-icon active-icon\"></span> <span class=nav-link>Transactions</span></li><li ui-sref=main.bulk.initiate><span class=\"transaction-sidebar-icon bulk-transaction default-icon\"></span> <span class=\"transaction-sidebar-active-icon bulk-transaction active-icon\"></span> <span class=nav-link>Bulk Transactions</span></li><li ui-sref=main.investors.list><span class=\"investor-sidebar-icon default-icon\"></span> <span class=\"investor-sidebar-active-icon active-icon\"></span> <span class=nav-link>Investors</span></li><li ui-sref=main.sipcorner><span class=\"sip-sidebar-icon default-icon\"></span> <span class=\"sip-sidebar-active-icon active-icon\"></span> <span class=nav-link>Systematic Investment</span></li><li ui-sref=main.siprenew.transaction><span class=\"renew-icon default-icon\"></span> <span class=\"renew-active-icon active-icon\"></span> <span class=nav-link>Bulk SIP Re-New</span></li><li ui-sref=main.reports><span class=\"reports-sidebar-icon default-icon\"></span> <span class=\"reports-sidebar-active-icon active-icon\"></span> <span class=nav-link>Reports</span></li><!--<li ui-sref=\"main.leapacademy\">\n          <span class=\"leap-sidebar-icon default-icon\"></span>\n          <span class=\"leap-sidebar-active-icon active-icon\"></span>\n          <span class=\"nav-link\">Leap Academy</span>\n        </li>\n        <li ng-click=\"Header.openLeadmanagement()\">\n          <span class=\"lead-sidebar-icon default-icon\"></span>\n          <span class=\"lead-sidebar-active-icon active-icon\"></span>\n          <span class=\"nav-link\">Digital Marketing</span>\n        </li>--><!--<li  ui-sref=\"main.financialtool\">\n          <span class=\"financial-planner-sidebar-icon default-icon\"></span>\n          <span class=\"financial-planner-sidebar-active-icon active-icon\"></span>\n          <span class=\"nav-link\">Financial Planning</span>\n        </li>--><li ui-sref=main.resourcesCalculators.calculators><span class=\"financial-sidebar-icon default-icon\"></span> <span class=\"financial-sidebar-active-icon active-icon\"></span> <span class=nav-link>Resources</span></li><li><span class=\"website-sidebar-icon default-icon\"></span> <span class=\"website-sidebar-active-icon active-icon\"></span> <a class=\"nav-link linkToWebpage\" href={{Header.HDFC_API.WEBSITE_LINK}} target=_blank>HDFC Fund Website</a></li><li ui-sref=main.feedback><span class=\"feedback-sidebar-icon default-icon\"></span> <span class=\"feedback-sidebar-active-icon active-icon\"></span> <span class=nav-link>Feedback</span></li></ul></aside></nav></aside><style>header.common .search-bar button.btn-cross{\n    height: 36px;\n    vertical-align: bottom;\n    border: none;\n    display: inline-block;\n    background: rgba(255, 255, 255, 0.4);\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    margin-left: -40px;\n  }</style>");
$templateCache.put("app/components/header/login-header.html","<header class=\"header container-fluid\"><div class=head-contrast><ul><li ng-click=\"vm.changedFont(\'increment\')\" title=\"Increase font size\">A+</li><li ng-click=\"vm.changedFont(\'original\')\" title=\"Reset font size\">A</li><li ng-click=\"vm.changedFont(\'decrement\')\" title=\"Decrease font-size\">A-</li><li ng-click=vm.contrast() title=\"High Contrast\" class=contrast-box><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><div class=\"row main-head\"><div class=col-md-12><!--<img src=\"assets/images/logo-main.png\" alt=\"HDFC\" class=\"logo-main pull-left\"/>--> <img src=assets/images/logo.png alt=HDFC class=\"logo pull-left\"> <a ui-sref=faq class=\"pull-right only-desktop\" href=javascript:void(0)><i class=faq-icon></i><h4>FAQ</h4></a></div></div><div class=\"row nav-list\"><div class=\"col-sm-6 col-md-3\"><i class=\"pull-left investor-icon\"></i><p data-toggle=modal data-target=#widgetModal>Do paperless transactions</p></div><div class=\"col-sm-6 col-md-3\"><i class=\"pull-left transaction-icon\"></i><p>Manage and grow your customers online</p></div><div class=\"col-sm-6 col-md-3\"><i class=\"pull-left manage-icon\"></i><p>Access all business reports at a click</p></div><div class=\"col-sm-6 col-md-3\"><i class=\"pull-left mf-icon\"></i><p>Accelerate your business using effective sales tools</p></div></div><!--  <div class=\"row low-head\">--><!--    <a href=\"https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf\" target=\"blank\">New cut off time</a>--><!--  </div>--></header>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/components/new-investor-progreesbar/investor-horizontal-progress-sidebar.directive.html","<div class=stepper-horizontal-container><div class=stepper-horizontal><div class=step ng-repeat=\"step in forms.steps track by $index\"><div class=step-heading ng-class=\"{\'active\': step.stepActive, \'step-completed\': step.stepCompleted}\" style=\"display: flex;justify-content: flex-start;align-items: center\"><!-- ng-click=\"toggleListItems($index)\" --><div ng-if=!step.stepCompleted class=circle></div><div ng-if=step.stepCompleted class=circle><strong>&#10003;</strong></div><div class=step-title>{{step.name}}</div><!-- <hr ng-if=\"!$last\" /> --><div class=hr ng-if=!$last></div></div></div></div><div class=stepper-horizontal-responsive><ul class=\"step steps-5\"><li ng-repeat=\"step in forms.steps track by $index\" style=\"background: #5bd\"><div class=innerDiv><div ng-if=!step.stepCompleted class=circle></div><div ng-if=step.stepCompleted class=circle><strong>&#10003;</strong></div><div class=nameofstep><label>{{step.name}}</label></div></div></li></ul></div></div>");
$templateCache.put("app/components/new-investor-progreesbar/investor-vertical-progress-sidebar.directive.html","<div class=\"stepper progress-sidebar-container\" ng-if=!responsive><h6 style=\"margin: 0px 0px 25px 20px\">New to HDFC<br>Mutual Fund</h6><div class=step1 ng-repeat=\"step in forms.steps\"><div class=step-heading ng-class=\"{\'active\': step.stepActive && !step.stepCompleted, \'step-completed\': step.stepCompleted && !step.stepActive}\"><!-- ng-click=\"toggleListItems($index);redirectToState(step);\" --><div class=steps-details><div ng-if=!step.stepCompleted class=circle>{{step.step}}</div><div ng-if=step.stepCompleted class=circle style=color:white><strong>&#10003;</strong></div><div class=title>{{step.name}}</div></div><div uib-collapse=!step.expanded><div class=body><div class=details><div ng-if=step.investorName>{{step.investorName.toUpperCase()}}</div><div ng-if=step.panNumber>{{step.panNumber.toUpperCase()}}</div><div ng-if=step.schemeName>{{step.schemeName}}</div><div ng-if=\"step.schemeInfo.amount || step.frequency || step.schemeInfo.investmentType\">&#8377;{{step.schemeInfo.amount}} {{step.frequency}} ({{step.schemeInfo.investmentType}})</div></div></div></div></div><div class=line ng-class=\"{\'active-line\':step.stepActive,\'step-completed-line\': step.stepCompleted}\" ng-hide=\"step.step >=forms.steps.length\"></div></div></div><div class=progress-vertical-responsive ng-if=responsive><div class=step-responsive ng-repeat=\"step in forms.steps track by $index\"><div><!-- ng-click=\"toggleListItems($index)\" --><div class=stepper-responsive ng-class=\"{\'stepper-responsive-active\':step.stepActive,\'stepper-responsive-step-completed\':step.stepCompleted}\" style=\"margin: 5px\"><div ng-if=!step.stepCompleted class=circle-responsive ng-class=\"{\'stepper-line\': !$last}\">{{step.step}}</div><div ng-if=step.stepCompleted class=circle-responsive ng-class=\"{\'stepper-line\': !$last}\" style=color:white><strong>&#10003;</strong></div><div>{{step.name}}</div></div></div></div></div>");
$templateCache.put("app/components/one-click-footer/one-click-footer.html","<section class=subFooter><div class=container><div class=\"row justify-content-center\"><div class=col-md-11><div class=d-flex><div class=me-auto><div><p class=\"p_sec mb-3\">Follow Us</p><ul class=\"d-flex ps-0\"><li><a href=https://twitter.com/hdfcmf><img src=/assets/images/one-click-img/twitterLogo.png alt=\"\" width=32px height=33px></a></li><li><a href=https://www.facebook.com/hdfcmutualfund><img src=/assets/images/one-click-img/facebook.svg alt=\"\"></a></li><li><a href=https://www.instagram.com/hdfcmf><img src=/assets/images/one-click-img/Instagram.svg alt=\"\"></a></li><li><a href=https://www.linkedin.com/company/hdfc-mutual-fund/ ><img src=/assets/images/one-click-img/linkedin.svg alt=\"\"></a></li><li><a href=https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A><img src=/assets/images/one-click-img/youtube.svg alt=\"\"></a></li></ul></div></div><div class=\"social_icons d-flex\"><div class=\"d-none d-md-block me-5\"><p class=\"p_sec mb-3\">Download our app</p><ul class=\"d-flex ps-0\"><li><a href=https://onelink.to/wqj8sx><img src=assets/images/hdfc-mutualfund.png width=62 height=62 alt=\"\"></a></li><li><a href=https://onelink.to/e6hkna><img src=assets/images/hdfc-mutualfund.jpg width=62 height=62 alt=\"\"></a></li></ul><p class=\"mt-3 psize\">Available on Android &amp; IOS</p></div></div></div></div></div></div></section><section class=\"sub-footer-mobile d-md-none\" id=darkThemeAnchor><div class=container><div><div class=accordion><div class=accPanel><div class=heading ng-class=\"{\'accordion-item-header\': !Footer.isChecked[1], \'accordion-item-header2\' : Footer.isChecked[1]}\" ng-click=Footer.accordionFunc(1)>ABOUT US</div><div class=\"content content1\"><div class=accordion-body><ul><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-profile/hdfc-mf-at-a-glance target=_blank>Corporate Profile</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-profile/what-sets-us-apart target=_blank>Investment Philosophy</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/financial-information/annual-reports target=_blank>Financial Information</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-governance/code-policy target=_blank>Corporate Governance</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/media-center target=_blank>Media Center</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/financial-information/annual-reports target=_blank>AMC Shareholder</a></li></ul></div></div></div><div class=accPanel><div class=heading ng-class=\"{\'accordion-item-header\': !Footer.isChecked[2], \'accordion-item-header2\' : Footer.isChecked[2]}\" ng-click=Footer.accordionFunc(2)>DOWNLOADS</div><div class=\"content content2\"><div class=accordion-body><ul><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/form-disclosures/forms target=_blank>Forms</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/fund-documents/kim target=_blank>Product Information</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/factsheets target=_blank>Factsheet</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/market-update/documents target=_blank>Market Updates</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}knowledge-stack target=_blank>Investing Insights</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/annual-reports target=_blank>Scheme Annual Report</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/scheme-performance target=_blank>Scheme Performance Summary</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/form-disclosures/addenda-notices target=_blank>Addendum &amp; Notices</a></li></ul></div></div></div><div class=accPanel><div class=heading ng-class=\"{\'accordion-item-header\': !Footer.isChecked[3], \'accordion-item-header2\' : Footer.isChecked[3]}\" ng-click=Footer.accordionFunc(3)>DISTRIBUTORS</div><div class=\"content content3\"><div class=accordion-body><ul><li><a href={{Footer.login}}/distributor-empanelment/arn target=_blank>Online Empanelment</a></li><li><a href={{Footer.login}} target=_blank>Login</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/forms-disclosure/forms target=_blank>Forms</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/faqs-kyc-process-change target=_blank>Investor KYC</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/onboard-digitally/why-online target=_blank>Go Digital</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/forms-disclosure/disclosures target=_blank>Information</a></li></ul></div></div></div><div class=accPanel><div class=heading ng-class=\"{\'accordion-item-header\': !Footer.isChecked[4], \'accordion-item-header2\' : Footer.isChecked[4]}\" ng-click=Footer.accordionFunc(4)>IMPORTANT LINKS</div><div class=\"content content4\"><div class=accordion-body><ul><li><a href=https://www.hdfcfund.com/wealthspectrum/app/login target=_blank>PMS</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports target=_blank>TER</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure target=_blank>Statutory Disclosures</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/portfolio/monthly-portfolio target=_blank>Monthly &amp; Fortnightly Scheme Portfolio</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}careers target=_blank>Careers</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/faqs target=_blank>FAQ\'s</a></li></ul></div></div></div></div></div></div></section><div class=\"d-block d-md-none my-4 plainRow mob-view-one\"><p class=\"fw-bold text-center mb-3\">Download our apps</p><ul class=\"d-flex ps-0 justify-content-center\"><li><a href=https://onelink.to/e6hkna><img src=assets/images/hdfc-mutualfund.jpg alt=\"\"></a></li><li><a href=https://onelink.to/wqj8sx class=ms-3><img src=assets/images/hdfc-mutualfund.png alt=\"\"></a></li></ul><p class=\"fw-bold text-center mt-3\">Available on Android &amp; iOS</p></div><footer class=plainRow><div class=container><!--    <div class=\"d-md-none d-block\"></div>--><div class=\"row justify-content-center\"><div class=col-md-11><div class=\"d-none d-md-block\" id=darkThemeAnchor><div class=row><div class=col-md-3><ul class=pages_list><a href=\"\"><p class=\"p_promary mb-3\">ABOUT US</p></a><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-profile/hdfc-mf-at-a-glance target=_blank>Corporate Profile</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-profile/what-sets-us-apart target=_blank>Investment Philosophy</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/financial-information/annual-reports target=_blank>Financial Information</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/corporate-governance/code-policy target=_blank>Corporate Governance</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/media-center target=_blank>Media Center</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}about-us/financial-information/annual-reports target=_blank>AMC Shareholder</a></li></ul></div><div class=col-md-3><ul class=pages_list><p class=\"p_promary mb-3\">DOWNLOADS</p><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/form-disclosures/forms target=_blank>Forms</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/fund-documents/kim target=_blank>Product Information</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/factsheets target=_blank>Factsheet</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/market-update/documents target=_blank>Market Updates</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}knowledge-stack target=_blank>Investing Insights</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/annual-reports target=_blank>Scheme Annual Report</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/scheme-performance target=_blank>Scheme Performance Summary</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/form-disclosures/addenda-notices target=_blank>Addendum &amp; Notices</a></li></ul></div><div class=col-md-3><ul class=pages_list><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/onboard-digitally/login target=_blank><p class=\"p_promary mb-3\">DISTRIBUTORS</p></a><li><a href={{Footer.login}}/distributor-empanelment/arn target=_blank>Online Empanelment</a></li><li><a href={{Footer.login}} target=_blank>Login</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/forms-disclosure/forms target=_blank>Forms</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}investor-services/faqs-kyc-process-change target=_blank>Investor KYC</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/onboard-digitally/why-online target=_blank>Go Digital</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/forms-disclosure/disclosures target=_blank>Information</a></li></ul></div><div class=col-md-3><ul class=pages_list><a href=\"\"><p class=\"p_promary mb-3\">IMPORTANT LINKS</p></a><li><a href=https://www.hdfcfund.com/wealthspectrum/app/login target=_blank>PMS</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports target=_blank>TER</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure target=_blank>Statutory Disclosures</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}statutory-disclosure/portfolio/monthly-portfolio target=_blank>Monthly &amp; Fortnightly Scheme Portfolio</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}careers target=_blank>Careers</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}distributor-corner/faqs target=_blank>FAQ\'s</a></li></ul></div></div></div></div></div><div class=secoundryFooter><div class=mx1150><div class=groupWebsiteLinks><ul class=\"d-flex flex-wrap justify-content-center\"><p class=groupwebsite>HDFC Group Websites:</p><li><a href=https://www.hdfcbank.com/ target=_blank class=fs14>HDFC Bank</a></li><li><a href=https://www.hdfclife.com/ target=_blank class=fs14>HDFC Life</a></li><li><a href=https://www.hdfcpension.com/ target=_blank class=fs14>HDFC Pension</a></li><li><a href=https://www.hdfcergo.com/ target=_blank class=fs14>HDFC Ergo</a></li><li><a href=https://www.hdfcsales.com/ target=_blank class=fs14>HDFC Sales</a></li><li><a href=https://www.hdfccredila.com/ target=_blank class=fs14>HDFC Credila</a></li><li><a href=https://www.hdfcpropertyfund.com/ target=_blank class=fs14>HDFC Property Fund</a></li><li><a href=https://www.htparekhfoundation.com/ target=_blank class=fs14>HT Parekh Foundation</a></li><li><a href=https://www.thehdfcschool.com/ target=_blank class=fs14>HDFC EDU</a></li></ul></div><div class=\"justify-content-center mt-2 mt-md-0 groupWebsiteLinks\"><ul class=\"d-flex flex-wrap justify-content-center\"><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}privacy-policy target=_blank class=fs14>Privacy Policy</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}disclaimer target=_blank class=fs14>Disclaimer</a></li><li><a href={{Footer.HDFC_API.WEBSITE_LINK}}sitemap target=_blank class=fs14>Sitemap</a></li></ul></div></div></div><p class=\"text-center pt-2\">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY</p><p class=copyRight>Copyright 2023</p></div></footer>");
$templateCache.put("app/components/one-click-header/one-click-header.html","<header ng-hide=Header.isHideFooter><div class=container-one-click><div><img src=../../../assets/images/logo-main.png alt=HDFC class=logo></div><div class=\"row distributor-nominee ecart-alignment\"><div class=subscribe-toggle><ul class=subscribe-toggle-panel><li><span class=\"toggle-login-text pd5\">Dark</span></li><li class=align-toggle><div class=login-form-switch><label class=\"switch-toggle-slider slider-toggle\"><input type=checkbox ng-model=Header.contrastt ng-click=Header.contrast() class=\"box checkbox-slide\" title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text>Light</span></li></ul></div><div class=shopping-cart ng-if=!Header.hideCartIcon><a ng-click=Header.checkItemsInCart() class=cart-action><p class=cart-notification>{{Header.ecartCount}}</p><img src=../../../assets/images/one-click-img/shopping-cart.svg alt=ecart></a></div></div></div></header><section><div class=content-area><div class=row><div class=col-md-12><div class=\"post-login ecart-journey\"><div class=\"ecart-journey main-section-ecart\"><div class=sidebar-container id=sidebarContainer ng-if=Header.showSideBarInvest hdfc-ecart-sidebar side-title=Header.sidebarTitle invest-through=Header.investThrough only-hdfc-user-one-click=Header.isFromHdfcOneClick></div><div class=sidebar-container id=sidebarContainer ng-if=Header.showSideBarCart hdfc-ecart-sidebar side-title=Header.sidebarTitle cart-item-from-click=Header.itemToBeEdited from-one-click-screen=Header.isFromOneClickScreen is-broker-type-change=Header.isBrokerTypeChange only-hdfc-user-one-click=Header.isFromHdfcOneClick></div><div class=sidebar-container id=sidebarContainer ng-if=\"Header.showSideAllFunds && Header.cartItem.cartItemList && Header.cartItem.totalLength > 0\" hdfc-ecart-sidebar side-title=Ecart.sidebarTitle euin-declaration=Ecart.dynamicDataSipPurchaseReview only-hdfc-user-one-click=Header.isFromHdfcOneClick></div><div class=sidebar-container id=sidebarContainer ng-if=Header.showAddEcart hdfc-ecart-sidebar side-title=Header.sidebarTitle only-hdfc-user-one-click=Header.isFromHdfcOneClick></div></div></div></div></div></div></section>");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"common not-mobile\" id=login-sidebar ng-init=Sidebar.initTab()><aside class=\"login-affix side-nav side-nav-dashboard\"><div class=\"not-desktop side-head-contrast\"><div class=\"col-xs-6 toggle-action\"><ul class=togglePanel><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': Sidebar.isDarkModeEnable}\">Light</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=Sidebar.isDarkModeEnable ng-change=\"Sidebar.contrast(); Sidebar.toggleMode()\" class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !Sidebar.isDarkModeEnable}\">Dark</span></li></ul></div><div class=\"col-xs-1 separator\"></div><ul class=col-xs-5><li ng-click=\"Sidebar.changedFont(\'decrement\')\" title=\"Decrease font size\" ng-class=\"{\'active\': Sidebar.count > -3 && Sidebar.count < 0}\">A-</li><li ng-click=\"Sidebar.changedFont(\'original\')\" title=\"Reset font size\" ng-class=\"{\'active\': Sidebar.count === 0}\">A</li><li ng-click=\"Sidebar.changedFont(\'increment\')\" title=\"Increase font size\" ng-class=\"{\'active\': Sidebar.count > 0 && Sidebar.count < 3}\">A+</li></ul></div><ul class=list-group><li ng-class=\"{\'active-link\':Sidebar.active[0]}\" class=dashboard-sidebar-li><a href=javascript:void(0) ui-sref=main.dashboard ng-click=Sidebar.activateTab(0)><span class=\"dashboard-sidebar-icon dashboard-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Dashboard</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[1]}\" class=transaction-sidebar-li><a href=javascript:void(0) ng-click=Sidebar.activateTab(1)><span class=\"transaction-sidebar-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Transactions</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[2]}\" class=systematic-corner-li><a href=javascript:void(0) ng-click=Sidebar.activateTab(2)><span class=\"sip-sidebar-icon systematic-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Systematic Corner</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[3]}\" class=investors-sidebar-li><a href=javascript:void(0) ng-click=Sidebar.activateTab(3)><span class=\"investor-sidebar-icon investor-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Investors</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[4]}\" class=statement-and-reports-li><a ng-click=\"Sidebar.statements = !Sidebar.statements; Sidebar.activateTab(4)\" aria-expanded={{!Sidebar.statements}}><span class=\"statement-sidebar-icon investor-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Statements & Reports</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.statements id=statements><li ng-class=\"{\'active-link\':Sidebar.active[41]}\" class=statement-sidebar-nested-li><a ng-click=Sidebar.activateTab(41)><span class=\"statement-sidebar-icon-nested sub-default-icon\"></span> <span class=nav-sub-links>Statements</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[42]}\" class=reports-sidebar-li><a ng-click=Sidebar.activateTab(42);><span class=\"report-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Reports</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[5]}\" class=bulk-sidebar-li><a ng-click=\"Sidebar.bulkMenu = !Sidebar.bulkMenu; Sidebar.activateTab(5)\" aria-expanded={{!Sidebar.bulkMenu}}><span class=\"bulk-sidebar-icon sidebar-common-img-property default-icon\"></span> <span class=nav-links>Bulk Transactions</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.bulkMenu id=bulkMenu><li ng-class=\"{\'active-link\':Sidebar.active[51]}\" ui-sref=main.bulk.initiate class=bulk-transaction-li><a ng-click=Sidebar.activateTab(51) ui-sref=main.bulk.initiate><span class=\"bulk-sidebar-icon-nested sub-default-icon\"></span> <span class=nav-sub-links>Bulk Transaction</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[52]}\" ui-sref=main.siprenew.transaction class=bulksip-renew-li><a ng-click=Sidebar.activateTab(52); ui-sref=main.siprenew.transaction><span class=\"bulksip-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Bulk SIP Renew</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[6]}\" class=product-sidebar-li><a ng-click=\"Sidebar.productSubMenu = !Sidebar.productSubMenu; Sidebar.activateTab(6)\" aria-expanded={{!Sidebar.productSubMenu}}><span class=\"product-sidebar-icon default-icon\"></span> <span class=nav-links>Products & Solutions</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.productSubMenu id=productSubMenu><li ng-class=\"{\'active-link\':Sidebar.active[61]}\" class=explore-funds-sidebar-li><a ng-click=\"Sidebar.openCalculator(\'Explore Funds\', Sidebar.HDFC_API.WEBSITE_LINK+\'explore/mutual-funds\')\"><span class=\"explore-funds-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Explore Funds</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[62]}\" class=calculator-sidebar-li><a ng-click=Sidebar.activateTab(62);><span class=\"calculator-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Calculator</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[7]}\" class=knowledge-center-sidebar-li><a ng-click=\"Sidebar.knowledgeCenterSubMenu = !Sidebar.knowledgeCenterSubMenu; Sidebar.activateTab(7)\" aria-expanded={{!Sidebar.knowledgeCenterSubMenu}}><span class=\"knowledge-center-sidebar-icon default-icon\"></span> <span class=nav-links>Knowledge Centre</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.knowledgeCenterSubMenu id=knowledgeCenterSubMenu><li ng-class=\"{\'active-link\':Sidebar.active[71]}\" class=factsheet-sidebar-li><a ng-click=\"Sidebar.activateTab(71); Sidebar.openCalculator(\'Factsheets\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/factsheets\')\"><span class=\"factsheet-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Factsheets</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[72]}\" class=leaflets-sidebar-li><a ng-click=\"Sidebar.activateTab(72); Sidebar.openCalculator(\'Leaflets\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/fund-literature/leaflets\')\"><span class=\"leaflets-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Leaflets</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[73]}\" class=product-presentation-sidebar-li><a ng-click=\"Sidebar.activateTab(73); Sidebar.openCalculator(\'Product Presentation\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/fund-literature/presentation\')\"><span class=\"product-presentation-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Product Presentation</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[8]}\" class=distributor-corner-li><a ng-click=\"Sidebar.activateTab(8); Sidebar.openCalculator(\'Distributor Corner\', Sidebar.HDFC_API.WEBSITE_LINK + \'distributor-corner\')\"><span class=\"distributor-corner-icon default-icon\"></span> <span class=nav-links>Distributor Corner</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[9]}\" class=feedback-sidebar-li><a ng-click=Sidebar.activateTab(9); ui-sref=main.feedback><span class=\"feedback-sidebar-icon default-icon\"></span> <span class=nav-links>Feedback</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[10]}\" class=about-sidebar-li><a ng-click=\"Sidebar.activateTab(10); Sidebar.openCalculator(\'About Us\', Sidebar.HDFC_API.WEBSITE_LINK + \'about-us\')\"><span class=\"about-sidebar-icon default-icon\"></span> <span class=nav-links>About Us</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[11]}\" class=contact-sidebar-li><a ng-click=Sidebar.activateTab(11) ui-sref=main.contactUs><span class=\"contact-sidebar-icon default-icon\"></span> <span class=nav-links>Contact Us</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[12]}\" class=\"visible-xs faq-sidebar-li\"><a ui-sref=faq ng-click=Sidebar.activateTab(12)><span class=\"sidebar-faq-icons default-icon\"></span> <span class=nav-links>FAQ\'s</span></a></li></ul></aside><div class=mobile-sidebar-left-space ng-click=Sidebar.closeSidebar()></div></div><!--\n<div class=\"common not-mobile\" ng-init=\"Sidebar.initTab()\">\n  <aside class=\"affix side-nav\">\n    <ul class=\"list-group\">\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[0]}\" ui-sref=\"main.dashboard\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(0)\" ui-sref=\"main.dashboard\">\n          <span class=\"dashboard-sidebar-icon dashboard-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"dashboard-sidebar-active-icon dashboard-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Dashboard</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[1]}\" ui-sref=\"main.transactions.recent\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(1)\"\n           ui-sref=\"main.transactions.recent\">\n          <span class=\"transaction-sidebar-icon invest-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"transaction-sidebar-active-icon invest-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Transactions</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[3]}\" ui-sref=\"main.sipcorner\">\n        <a href=\"javascript:void(0)\"  ng-click=\"Sidebar.activateTab(3)\" ui-sref=\"main.sipcorner\">\n          <span class=\"sip-sidebar-icon systematic-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"sip-sidebar-active-icon systematic-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Systematic Corner</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[2]}\" ui-sref=\"main.investors.list\">\n        <a href=\"javascript:void(0)\"  ng-click=\"Sidebar.activateTab(2)\" ui-sref=\"main.investors.list\">\n          <span class=\"investor-sidebar-icon investor-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"investor-sidebar-active-icon investor-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Investors</span>\n      </li>\n\n&lt;!&ndash;      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[12]}\" ui-sref=\"main.bulk.initiate\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(12)\"\n           ui-sref=\"main.bulk.initiate\">\n          <span class=\"transaction-sidebar-icon bulk-transaction sidebar-common-img-property default-icon\"></span>\n          <span class=\"transaction-sidebar-active-icon bulk-transaction sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Bulk Transactions</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[13]}\" ui-sref=\"main.siprenew.transaction\">\n        <a href=\"javascript:void(0)\"  ng-click=\"Sidebar.activateTab(13)\" ui-sref=\"main.siprenew.transaction\">\n          <span class=\"renew-icon bulk-transaction-renew sidebar-common-img-property default-icon\"></span>\n          <span class=\"renew-active-icon bulk-transaction-renew sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Bulk SIP Re-New</span>\n      </li>&ndash;&gt;\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[4]}\" ui-sref=\"main.reports\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(4)\" ui-sref=\"main.reports\">\n          <span class=\"reports-sidebar-icon report-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"reports-sidebar-active-icon report-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Reports</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[8]}\" ui-sref=\"main.schemecalculator\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(8)\">\n          <span class=\"financial-sidebar-icon web-hand sidebar-common-img-property default-icon\"></span>\n          <span class=\"financial-sidebar-active-icon web-hand sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Scheme Calculator</span>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[9]}\">\n        <a href=\"{{Sidebar.HDFC_API.WEBSITE_LINK}}\" target=\"_blank\" ng-click=\"Sidebar.activateTab(9)\">\n          <span class=\"website-sidebar-icon web-icon sidebar-common-img-property default-icon\"></span>\n          <span class=\"website-sidebar-active-icon web-icon sidebar-common-img-property active-icon\"></span></a>\n        <a href=\"{{Sidebar.HDFC_API.WEBSITE_LINK}}\" target=\"_blank\" tabindex=\"-1\" class=\"nav-link\">HDFC Fund Website</a>\n      </li>\n\n      <li class=\"empty-container\"></li>\n      <li ng-class=\"{\'active-link\':Sidebar.active[10]}\" ui-sref=\"main.feedback\">\n        <a href=\"javascript:void(0)\" ng-click=\"Sidebar.activateTab(10)\">\n          <span class=\"feedback-sidebar-icon feedback-icon sidebar-common-img-property  default-icon\"></span>\n          <span class=\"feedback-sidebar-active-icon feedback-icon sidebar-common-img-property active-icon\"></span></a>\n        <span class=\"nav-link\">Feedback</span>\n      </li>\n\n\n&lt;!&ndash;      <li ng-class=\"{\'active-link\':Sidebar.active[5]}\" ui-sref=\"main.leapacademy.training-classes\">&ndash;&gt;\n&lt;!&ndash;        <a href=\"javascript:void(0)\"  ng-click=\"Sidebar.activateTab(5)\" ui-sref=\"main.leapacademy.training-classes\">&ndash;&gt;\n&lt;!&ndash;          <span class=\"leap-sidebar-icon default-icon\"></span>&ndash;&gt;\n&lt;!&ndash;          <span class=\"leap-sidebar-active-icon active-icon\"></span></a>&ndash;&gt;\n&lt;!&ndash;        <span class=\"nav-link\">Leap Academy</span>&ndash;&gt;\n&lt;!&ndash;      </li>&ndash;&gt;\n&lt;!&ndash;      <li ng-class=\"{\'active-link\':Sidebar.active[6]}\" ng-click=\"Sidebar.activateTab(6)\">&ndash;&gt;\n&lt;!&ndash;        <a ng-click=\"Sidebar.activateTab(6)\">&ndash;&gt;\n&lt;!&ndash;          <span class=\"lead-sidebar-icon default-icon\"></span>&ndash;&gt;\n&lt;!&ndash;          <span class=\"lead-sidebar-active-icon active-icon\"></span></a>&ndash;&gt;\n&lt;!&ndash;        <span class=\"nav-link\">Digital Marketing</span>&ndash;&gt;\n&lt;!&ndash;      </li>&ndash;&gt;\n      &lt;!&ndash;<li ng-class=\"{\'active-link\':Sidebar.active[7]}\" ui-sref=\"main.financialtool\">\n        <a href=\"javascript:void(0)\"  ng-click=\"Sidebar.activateTab(7)\">\n        <span class=\"financial-planner-sidebar-icon default-icon\"></span>\n        <span class=\"financial-planner-sidebar-active-icon active-icon\"></span></a>\n        <span class=\"nav-link\">Financial Planning</span>\n      </li>&ndash;&gt;\n\n\n      &lt;!&ndash;<li ng-class=\"{\'active-link\':Sidebar.active[11]}\" ng-click=\"Sidebar.activateTab(11)\" ui-sref=\"main.otmlist\">\n        <span class=\"feedback-sidebar-icon default-icon\"></span>\n        <span class=\"feedback-sidebar-active-icon active-icon\"></span>\n        <span class=\"nav-link\">Non-OTM Investors</span>\n      </li>&ndash;&gt;\n    </ul>\n  </aside>\n</div>\n-->");
$templateCache.put("app/dashboard/distributor-dashboard-widgets/existing-distributor-widget.html","<div class=col-md-12><div><div class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/greetings.html\'\"></div></div></div></div><div class=col-md-6><div><div class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/transaction.widget.html\'\"></div></div></div><div ng-repeat=\"data in Dashboard.leftSideWidgetList\"><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.AUM\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/AUM-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.BANNER\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/banner-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTMENT_OVERVIEW\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/investment-overview-gross-income.widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.KNOWLEDGE_CENTER\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/knowledge-centre-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.EUIN_DETAILS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/euin-details.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SIP_OVERVIEW\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/sip-overview-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TRANSACTION_SNAPSHOT\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/transaction-overview-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICK_LINKS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/quick-link-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ALERT_AND_UPDATES\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/alert-and-updates-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.CONNEKT\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/connekt-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TO_DO\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/todo-widget.html\'\"></div></div><!-- quick sip widget container starts here  --><div class=\"col-md-12 set-padding-widget\"><div class=widget-container ng-controller=\"QuickSipTileWidget as QuickSipTile\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICK_SIP\"><div ng-include=\"\'app/components/widgets/quick-sip/quick-sip.widget.html\'\"></div></div></div><!-- quick sip widget container ends here  --></div></div><div class=col-md-6><div ng-repeat=\"data in Dashboard.rightSideWidgetList\"><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.AUM\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/AUM-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.BANNER\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/banner-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.INVESTMENT_OVERVIEW\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/investment-overview-gross-income.widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.KNOWLEDGE_CENTER\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/knowledge-centre-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.EUIN_DETAILS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/euin-details.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.SIP_OVERVIEW\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/sip-overview-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TRANSACTION_SNAPSHOT\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/transaction-overview-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICK_LINKS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/quick-link-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ALERT_AND_UPDATES\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/alert-and-updates-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.CONNEKT\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/connekt-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.TO_DO\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/todo-widget.html\'\"></div></div><!-- quick sip widget container starts here  --><div class=\"col-md-12 set-padding-widget\"><div class=widget-container ng-controller=\"QuickSipTileWidget as QuickSipTile\" ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.QUICK_SIP\"><div ng-include=\"\'app/components/widgets/quick-sip/quick-sip.widget.html\'\"></div></div></div><!-- quick sip widget container ends here  --></div></div><div class=col-md-12><div ng-repeat=\"allWidget in Dashboard.distributorWidgetsList\"><div class=widget-container ng-controller=\"FundInFocusWidget as FundInFocus\" ng-if=\"allWidget.widgetId == Dashboard.WIDGETS_ID.FUND_IN_FOCUS\"><div ng-include=\"\'app/components/widgets/fund-in-focus/fund-in-focus.widget.html\'\"></div></div></div></div>");
$templateCache.put("app/dashboard/distributor-dashboard-widgets/new-distributor-widgets.html","<div class=col-md-6><div ng-repeat=\"data in Dashboard.distributorWidgetsList\"><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/addInvestor-or-transaction-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/fund-in-focus-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/knowledge-centre-widget.html\'\"></div></div><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/connekt-widget.html\'\"></div></div></div></div><div class=col-md-6><div ng-repeat=\"data in Dashboard.distributorWidgetsList\"><div ng-if=\"data.widgetId == Dashboard.WIDGETS_ID.ASSETS\" class=\"col-md-12 set-padding-widget\"><div ng-include=\"\'app/dashboard/widgets/calculator-widget.html\'\"></div></div></div></div>");
$templateCache.put("app/dashboard/distributor-dashboard-widgets/relatively-new-distributor-widget.html","");
$templateCache.put("app/dashboard/widgets/AUM-widget.html","<div class=aum-widget-container><div class=\"loader aum-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=aum-widget-primary><p class=\"label-primary-larger set-font-family-inter set-color-white-light set-font-weight-500 aum-head\">Assets Under Management (AUM)</p><p class=\"big-label set-color-white-primary set-font-family-monasans set-font-weight-700\"><i ng-if=!Dashboard.isEmptyObject(Dashboard.aumData)>₹</i> <span><span easyassist-key=mask-element ng-if=!Dashboard.isEmptyObject(Dashboard.aumData) ng-bind=\"Dashboard.aumData.totalAum | truncateDecimal: 2 | unitWithDecimal: Dashboard.aumData.totalAum\"></span> <span ng-if=Dashboard.isEmptyObject(Dashboard.aumData)>NA</span></span></p><p class=\"label-primary-large set-font-family-inter set-color-white-light set-font-weight-500 aum-date\" ng-if=Dashboard.aumData.date>As on {{Dashboard.aumData.date}}</p><img class=aum-square src=../../../assets/images/dashboard/widgets-icons/aum-square-bg.png></div><div class=aum-widget-secondary><div class=\"col-md-4 col-sm-5 col-xs-5\"><label class=\"label-primary-small set-font-family-inter set-color-gray-primary set-font-weight-500\">Change From</label><div class=\"dropdown aum-dropdown\"><a class=value-wrapper href=javascript:void(0) data-toggle=dropdown>{{Dashboard.selectedTimePeriodForAum.value}} <img src=../../../assets/images/logos/drop-arrow-red.svg alt=down></a><ul class=dropdown-menu><li class=list-group-item ng-repeat=\"item in Dashboard.aumDropdownList\" ng-click=\"Dashboard.changeTimePeriod(\'AUM\', item)\">{{item.value}}<div class=separator></div></li></ul></div></div><div class=\"col-md-8 col-sm-7 col-xs-7 text-center aum-change-amt-and-percentage\"><div><span ng-if=!Dashboard.isEmptyObject(Dashboard.aumData) ng-class=\"{\'aum-in-downward\' : Dashboard.aumData.changeAmount < 0, \'up-green\': Dashboard.aumData.changeAmount > 0}\"></span> <span ng-if=!Dashboard.isEmptyObject(Dashboard.aumData) class=\"widget-amount-secondary set-color-green set-font-family-inter set-font-weight-700\" ng-class=\"{\'aum-in-red\' : Dashboard.aumData.changeAmount < 0, \'aum-in-black\': Dashboard.aumData.changeAmount == 0}\">₹{{Dashboard.aumData.changeAmount | truncateDecimal: 2 | unitWithDecimal: Dashboard.aumData.changeAmount}}</span> <span ng-if=Dashboard.isEmptyObject(Dashboard.aumData) class=\"widget-amount-secondary default-na-value set-font-family-inter set-font-weight-700 aum-in-black\">NA</span></div><div ng-if=!Dashboard.isEmptyObject(Dashboard.aumData) class=\"aum-absoute-amt text-center set-color-green set-font-family-inter set-font-weight-700\" ng-class=\"{\'aum-in-red\' : Dashboard.aumData.changeAmount < 0, \'aum-in-black\': Dashboard.aumData.changeAmount == 0}\">(Absolute : {{Dashboard.aumData.changePercentage | truncateDecimal: 2 | unitWithDecimal: Dashboard.aumData.changePercentage}}%)</div></div></div></div>");
$templateCache.put("app/dashboard/widgets/addInvestor-or-transaction-widget.html","<section class=addInvestor-or-transaction-widget-section><div class=content-wrapper><p class=\"set-font-weight-500 head-title set-font-family-inter\">Grow, Run & Amplify your business with us via</p><div class=btn-wrapper><button class=\"btn btn-new-primary-action\">Add Investor</button> <button class=\"btn btn-new-primary-action\">Transact Now</button></div></div></section>");
$templateCache.put("app/dashboard/widgets/alert-and-updates-widget.html","<div class=alert-updates-main-container><div class=\"loader alert-update-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head><span>Alerts & Updates</span></div></div><div class=all-content-wrapper><div class=content-main-container><div class=outer-container-wrapper><div class=main-content-wrapper ng-repeat=\"data in Dashboard.alertAndUpdateData track by $index\"><div class=desc-main-container ng-click=\"Dashboard.showInfoModal(data.headers, data.content, data.date, data.image)\"><div class=\"title-head set-font-family-inter set-font-weight-500 set-color-black-light\">{{data.headers.length > 155 ? (data.headers | limitTo:155) + \'...\' : data.headers}}</div><div class=\"date-desc set-font-family-monasans set-color-gray-primary set-font-weight-600\" ng-if=\"data.date && data.headers !== \'Modify SIP\' && data.headers !== \'Update Nomination\'\">as on {{data.date}}</div></div><hr><div class=btn-wrapper><div ng-repeat=\"btnData in data.actions.cta\"><button class=btn-new-primary-action ng-class=\"{\'btn-new-primary-action\' : btnData.name == \'Review\', \'btn-dark\': btnData.name == \'View Details\' || btnData.name == \'Download Now\'}\" ng-click=\"Dashboard.checkBtnAction(btnData, data.headers, data.content, data.date)\">{{btnData.name}}</button></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/widgets/banner-widget.html","<section class=dashboard-banner-section><div class=\"loader banner-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=row><div class=col-md-12><div class=\"col-sm-12 col-md-12r imgUrl-wrapper\" ng-if=\"Dashboard.bannerList.length == 0\"><!--rendered if we don\'t have data to show--> <img src=assets/images/staticBannerImage.jpg alt=defaultImage class=staticImgUrl></div><div class=carousel-inner ng-if=\"Dashboard.bannerList && Dashboard.bannerList.length == 1\"><div class=\"item height100\" ng-repeat=\"image in Dashboard.bannerList\" ng-class=\"{\'active\': $first}\" ng-click=Dashboard.bannerRedirection(image)><img src={{image.images}}><div class=btn-container ng-if=\"image.actions.length > 0\"><div class=btn-wrapper ng-repeat=\"btndata in image.actions\"><button class=\"btn btn-new-primary-action\" ng-click=\"Dashboard.redirectTo(btndata.url, true, true)\" ng-if=btndata.name>{{btndata.name}}</button></div></div></div></div><div id=bannerCarousel class=\"carousel slide\" data-ride=carousel ng-if=\"Dashboard.bannerList.length > 1\"><ol class=carousel-indicators><li data-target=#bannerCarousel ng-repeat=\"image in Dashboard.bannerList\" data-slide-to={{$index}} ng-class=\"{\'active\': $first}\"></li></ol><!-- Wrapper for slides --><div class=carousel-inner><div class=\"item height100\" ng-repeat=\"image in Dashboard.bannerList\" ng-class=\"{\'active\': $first}\" ng-click=Dashboard.bannerRedirection(image)><img src={{image.images}}><div class=btn-container ng-if=\"image.actions.length > 0\"><div class=btn-wrapper ng-repeat=\"btndata in image.actions\"><button class=\"btn btn-new-primary-action\" ng-click=\"Dashboard.redirectTo(btndata.url, true, true)\" ng-if=btndata.name>{{btndata.name}}</button></div></div></div></div></div></div></div></section>");
$templateCache.put("app/dashboard/widgets/calculator-widget.html","<section class=calculator-section><div class=\"d-flex content-wrapper\"><div class=title-main-container><div class=title-info-head>Calculator</div></div><div class=\"d-flex main-content\"><div class=\"d-flex img-and-title-wrapper\"><div class=\"d-flex content\"><img src=../../../assets/images/dashboard/widgets-icons/calculator.svg><div class=\"title set-font-family-inter set-font-weight-700 set-color-gray-black\">SIP Calculator</div></div></div><div class=\"d-flex img-and-title-wrapper\"><div class=\"d-flex content\"><img src=../../../assets/images/dashboard/widgets-icons/calculator.svg><div class=\"title set-font-family-inter set-font-weight-700 set-color-gray-black\">SIP Calculator</div></div></div><div class=\"d-flex img-and-title-wrapper\"><div class=\"d-flex content\"><img src=../../../assets/images/dashboard/widgets-icons/calculator.svg><div class=\"title set-font-family-inter set-font-weight-700 set-color-gray-black\">SIP Calculator</div></div></div></div></div></section>");
$templateCache.put("app/dashboard/widgets/connekt-widget.html","<section class=connekt-widget-section ng-init=Dashboard.initConnekt()><div class=cube-img-div></div><div class=main-container><div class=content><div class=\"heading-title set-font-family-inter set-font-weight-700\">Connekt</div><p class=\"para-head set-font-weight-400\">Download co-branded banners to promote your business. Fast and free.</p><div class=action ng-click=\"Dashboard.redirectTo(\'https://onelink.to/mubjc9\', true, true)\"><p class=\"para-head set-font-family-inter set-font-weight-600\">Try Now</p><div class=arrow-wrapper><img src=../../../assets/images/dashboard/widgets-icons/red-right-dark.svg> <img src=../../../assets/images/dashboard/widgets-icons/red-right-light.svg> <img src=../../../assets/images/dashboard/widgets-icons/red-right-lighter.svg></div></div></div></div><div class=ellipse-img></div></section>");
$templateCache.put("app/dashboard/widgets/euin-details.html","<section class=euin-details-section><div class=\"loader euin-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=top-content-wrapper><div class=\"col-md-10 col-sm-9 euin-details-and-dropdown-wrapper\"><div class=\"euin-head-wrapper set-font-family-inter set-font-weight-700\"><span>EUIN Details</span> <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=top title={{Dashboard.euinDetailsConfiguration.tooltipMsg}}></i></div><div><div class=\"dropdown euin-dropdown\"><a class=value-wrapper href=javascript:void(0) data-toggle=dropdown>{{Dashboard.selectedTimePeriodForEuinDetails.value}} <img src=../../../assets/images/logos/drop-arrow-red.svg alt=down></a><ul class=dropdown-menu><li class=list-group-item ng-repeat=\"item in Dashboard.EUIN_DETAILS_DROPDOWN_VALUES\" ng-click=\"Dashboard.changeTimePeriod(\'EUIN\', item)\">{{item.value}}<div class=separator></div></li></ul></div></div></div><div class=\"col-md-2 view-all-div set-font-weight-500 set-font-family-inter set-color-primary-blue col-md-3\" ui-sref=main.euinDetails>View All <img src=../assets/images/icons/red-greater-than-arrow.svg></div></div><div class=main-content-wrapper><div class=row ng-repeat=\"item in Dashboard.euinDetailsList\"><div class=\"content-wrapper col-md-12\"><div class=\"name-wrapper col-md-6 col-sm-6 col-xs-12\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">Name</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">{{item.euinName}}</div></div><div class=\"euin-wrapper col-md-4 col-sm-4 col-xs-8\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">EUIN</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">{{item.euinCode}}</div></div><div class=\"sale-wrapper col-md-2 col-sm-2 col-xs-4\"><div class=\"label-text set-font-family-monasans set-font-weight-400\">Gross Sale</div><div class=\"label-content set-font-family-monasans set-font-weight-600\">₹{{item.grossSales | truncateDecimal: 2 | unitWithDecimal:item.grossSales}}</div></div></div></div><div ng-if=\"Dashboard.euinDetailsList.length == 0\" class=\"d-flex justify-content-center no-data-available\">EUIN Gross Sale not available</div></div></section>");
$templateCache.put("app/dashboard/widgets/fund-in-focus-widget.html","<section class=fund-in-focus-section><div class=\"loader fund-and-focus-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head>Fund in Focus</div><div class=\"view-all-div d-flex set-color-primary-blue set-font-family-inter set-font-weight-500\">View All <img src=../../../assets/images/icons/red-greater-than-arrow.svg></div></div><div class=\"card-outer-container d-flex justify-content-center\"><div class=\"col-md-6 card-wrapper\" ng-repeat=\"fundsList in Dashboard.allFundInFocusData.slice(((Dashboard.currentPageFundList-1)*Dashboard.selectedPageLimit), ((Dashboard.currentPageFundList)*Dashboard.selectedPageLimit)) track by $index\"><form name=fundAndFocusName autocomplete=off novalidate><div class=outer-wrapper><div class=\"card-content-wrapper d-flex\"><div class=\"fund-heading-wrapper d-flex\"><div class=\"fund-title set-font-family-inter set-font-weight-700 set-color-black-primary\">{{fundsList.fundName}}</div><!--            <div class=\"fund-info set-font-family-monasans set-font-weight-400 set-color-gray-primary\">__+ Investors have invested in this fund.</div>--></div><hr><div class=\"d-flex nav-and-risk-wrapper\"><div class=\"nav-wrapper d-flex\"><div class=\"nav-date set-font-family-monasans set-font-weight-400 set-color-gray-primary\">NAV (as of {{fundsList.navDateTimestamp}})</div><div class=\"nav-unit set-font-family-inter set-font-weight-700 set-color-black-primary\">{{fundsList.navAmount.toFixed(2)}}</div></div><div class=\"risk-wrapper d-flex\"><div class=\"risk-title set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Risk Rating</div><div class=\"risk-measure set-font-family-inter set-font-weight-700 set-color-black-primary\"><img src=assets/images/icons/riskometer/moderate1.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'Moderate\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'Moderately low\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'Moderately high\'\"> <img src=assets/images/icons/riskometer/low.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'Low\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'Very High\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{fundsList.riskReturnProfile}} ng-if=\"Dashboard.modifiedRiskProfile[$index] === \'High\'\"> {{fundsList.riskReturnProfile}}</div></div></div><div class=\"benchmark-info-wrapper d-flex\"><div class=\"benchmark-title set-font-family-monasans set-font-weight-600 set-color-black-primary\">Benchmark for Fund:</div><div class=\"benchmark-info set-font-family-monasans set-font-weight-400 set-color-black-primary\">{{fundsList.benchmarkForFund[0] ? fundsList.benchmarkForFund[0] : \'No Data Available\'}}</div></div><div class=select-scheme-wrapper><label class=\"set-font-family-monasans set-font-weight-600 set-color-black-primary\">Select a scheme</label><select class=\"custom-select label-primary-large set-font-family-inter set-font-weight-500 set-color-black-primary\" ng-model=Dashboard.selectedScheme[$index] ng-change=Dashboard.selectSchemeForFund() ng-options=\"_type.schemeName for _type in fundsList.regularSchemes\" required></select></div></div><div class=\"btn-wrapper d-flex\"><button class=\"add-to-cart-btn set-font-family-inter set-font-weight-700 set-color-black-primary\" ng-disabled=fundAndFocusName.$invalid>Add to Cart</button> <button class=\"invest-now-btn set-font-family-inter set-font-weight-700\" ng-disabled=fundAndFocusName.$invalid>Invest Now</button></div></div></form></div></div><div class=\"pagination-wrapper d-flex\" ng-if=Dashboard.isPagination><ul uib-pagination total-items=Dashboard.totalFundInFocusList ng-model=Dashboard.currentPageFundList max-size=3 items-per-page=Dashboard.selectedPageLimit class=pagination boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; rotate=false></ul></div></section>");
$templateCache.put("app/dashboard/widgets/greetings.html","<div class=row><div class=col-md-12><div class=welcome-text><h3>{{Dashboard.greetings}}, <span>{{Dashboard.distributorName}}</span></h3></div></div></div>");
$templateCache.put("app/dashboard/widgets/insights-widget.html","<div class=insights-container><div class=insight-background></div><div class=insight-main-content><p class=insight-title-main>Invest with ease</p><p class=insight-title-secondary>Explore our schemes with better returns.</p><div class=insight-img><a class=redirect-link>Invest now</a><div><img src=../../../assets/images/dashboard/widgets-icons/red-right-dark.svg> <img src=../../../assets/images/dashboard/widgets-icons/red-right-light.svg> <img src=../../../assets/images/dashboard/widgets-icons/red-right-lighter.svg></div></div></div><div class=insight-secondary-background><img src=../../../assets/images/dashboard/widgets-icons/insights-background-secondary.svg></div></div>");
$templateCache.put("app/dashboard/widgets/investment-overview-gross-income.widget.html","<div class=overview-container ng-init=\"Dashboard.setOverviewActiveTab(\'inv\')\"><div class=\"loader investment-overview-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=btn-container><button ng-class=\"{activeBtn: Dashboard.activeInvestement}\" class=\"label-primary-large set-font-family-inter set-font-weight-600 set-color-gray-primary\" ng-click=\"Dashboard.setOverviewActiveTab(\'inv\')\">Investment Overview</button> <button ng-class=\"{activeBtn: !Dashboard.activeInvestement}\" class=\"label-primary-large set-font-family-inter set-font-family-inter set-font-weight-600 set-color-gray-primary\" ng-click=\"Dashboard.setOverviewActiveTab(\'gross\')\">Yesterday’s Gross Sales</button></div><div ng-show=Dashboard.activeInvestement><p class=\"label-primary-large set-font-family-inter set-font-weight-500 investment-label\">Find out your investment across asset classes</p><div class=\"investment-overview-container row\"><div class=\"donut-container col-md-7 col-xs-12 col-sm-12\"><div id=chart-container></div></div><div class=\"col-md-5 col-xs-12 col-sm-12 aum-type-wrapper\"><div ng-if=\"Dashboard.investmentOverviewData && Dashboard.investmentOverviewData.length > 0\" class=\"overview-card equity\" ng-click=\"Dashboard.redirectToEquityAsset(investmentData.aumType, investmentData.amount)\" ng-repeat=\"investmentData in Dashboard.investmentOverviewData\" ng-class=\"{\'equity\': investmentData.aumType == \'Equity\', \'liquid\': investmentData.aumType == \'Liquid\', \'debt\': investmentData.aumType == \'Debt\'}\"><div class=label-and-value-wrapper><span class=\"label-primary-large set-font-family-inter set-color-gray-primary set-font-weight-400\">{{investmentData.aumType}} </span><span class=\"value-wrapper label-primary-large set-font-family-inter set-color-black-primary set-font-weight-700\" tooltip-placement=top-left uib-tooltip=\"{{\'₹\'+ investmentData.amount| truncateDecimal: 2 |unitWithDecimal:investmentData.amount}}\">₹{{investmentData.amount| truncateDecimal: 2 | unitWithDecimal:investmentData.amount}}</span></div><div class=arrow-action-wrapper ng-if=investmentData.amount><div class=black-arrow></div></div></div><div ng-if=\"Dashboard.investmentOverviewData.length == 0\" class=\"overview-card equity\" ng-click=\"Dashboard.redirectToEquityAsset(investmentData.aumType, investmentData.amount)\" ng-repeat=\"investmentData in Dashboard.INVESTMENT_OVERVIEW_DEFAULT_DATA\" ng-class=\"{\'equity\': investmentData.aumType == \'Equity\', \'liquid\': investmentData.aumType == \'Liquid\', \'debt\': investmentData.aumType == \'Debt\'}\"><div class=label-and-value-wrapper><span class=\"label-primary-large set-font-family-inter set-color-gray-primary set-font-weight-400\">{{investmentData.aumType}} </span><span class=\"value-wrapper label-primary-large set-font-family-inter set-color-black-primary set-font-weight-700\">{{investmentData.amount}}</span></div></div></div></div></div><div class=gross-annual-container ng-show=!Dashboard.activeInvestement ng-class=\"{\'data-not-available\' : Dashboard.grossSalesNotAvailable}\"><div ng-if=!Dashboard.grossSalesNotAvailable><div class=gross-sale-amount-container><div class=gross-amount><img src=../../../assets/images/dashboard/widgets-icons/revenue.svg> <span class=\"big-label set-font-family-inter set-color-black-light set-font-weight-700\">₹{{Dashboard.grossSalesData.totalSales | truncateDecimal: 2 | unitWithDecimal:Dashboard.grossSalesData.totalSales}}</span></div><div class=\"amt-info label-primary-large set-font-family-monasans set-font-weight-400\">As on {{Dashboard.grossSalesData.date}}</div></div><div class=gross-detail-container><div class=\"col-sm-6 col-md-6 channel-hdfc channel-content\"><span class=\"channel label-primary-small set-font-weight-600 set-color-white-primary set-font-family-monasans\">MFOnline Partners</span> <span class=\"channel-amount label-primary-larger set-font-family-inter set-font-weight-700 set-color-white-primary\" tooltip-placement=top-left uib-tooltip=\"₹{{Dashboard.grossSalesData.hdfcPartnerSale | truncateDecimal: 2 | unitWithDecimal:Dashboard.grossSalesData.hdfcPartnerSale}}\">₹{{Dashboard.grossSalesData.hdfcPartnerSale | truncateDecimal: 2 | unitWithDecimal:Dashboard.grossSalesData.hdfcPartnerSale}}</span></div><div class=side-border></div><div class=\"col-sm-6 col-md-6 channel-other channel-content\"><span class=\"channel label-primary-small set-font-weight-600 set-color-white-primary set-font-family-monasans\">Other Channels <a href=javascript:void(0) class=base-tooltip data-html=true tooltip data-toggle=tooltip data-placement=bottom title={{Dashboard.investmentOverViewConfiguration.tooltipMsg}}>&#9432;</a> </span><span class=\"channel-amount label-primary-larger set-font-weight-700 set-font-weight-700 set-color-white-primary\" tooltip-placement=top-left uib-tooltip=\"₹{{Dashboard.grossSalesData.otherPartnerSale | truncateDecimal: 2 |unitWithDecimal:Dashboard.grossSalesData.otherPartnerSale}}\">₹{{Dashboard.grossSalesData.otherPartnerSale | truncateDecimal: 2 | unitWithDecimal:Dashboard.grossSalesData.otherPartnerSale}}</span></div></div><div class=progress-bar-container><div><div class=gross-perc-info><span class=\"set-font-weight-600 set-font-family-monasans label-primary-large\">Equity Funds</span> <span class=\"perc set-font-weight-700 set-font-family-inter set-color-black-light\">{{Dashboard.grossSalesData.equitySalePercentage | truncateDecimal: 2 | unitWithDecimal: Dashboard.grossSalesData.equitySalePercentage}} %</span></div><div class=progress-bar-outer><div ng-style=\"{width: Dashboard.grossSalesData.equitySalePercentage ? Dashboard.grossSalesData.equitySalePercentage + \'%\' : 0}\" class=progress-bar-inner></div></div></div><div><div class=gross-perc-info><span class=\"set-font-weight-600 set-font-family-monasans label-primary-large\">Debt Funds</span> <span class=\"perc set-font-weight-700 set-font-family-inter set-color-black-light\">{{Dashboard.grossSalesData.debtSalePercentage | truncateDecimal: 2 | unitWithDecimal: Dashboard.grossSalesData.debtSalePercentage}} %</span></div><div class=progress-bar-outer><div ng-style=\"{width: Dashboard.grossSalesData.debtSalePercentage ? Dashboard.grossSalesData.debtSalePercentage + \'%\' : 0}\" class=progress-bar-inner></div></div></div><div><div class=gross-perc-info><span class=\"set-font-weight-600 set-font-family-monasans label-primary-large\">Liquid Funds</span> <span class=\"perc set-font-weight-700 set-font-family-inter set-color-black-light\">{{Dashboard.grossSalesData.liquidSalePercentage | truncateDecimal: 2 | unitWithDecimal: Dashboard.grossSalesData.liquidSalePercentage}} %</span></div><div class=progress-bar-outer><div ng-style=\"{width: Dashboard.grossSalesData.liquidSalePercentage ? Dashboard.grossSalesData.liquidSalePercentage + \'%\' : 0}\" class=progress-bar-inner></div></div></div></div></div><div ng-if=Dashboard.grossSalesNotAvailable class=\"text-center set-font-weight-600 set-font-family-inter\">{{Dashboard.defaultMessageForGrossSale}}</div></div></div>");
$templateCache.put("app/dashboard/widgets/knowledge-centre-widget.html","<section class=knowledge-centre-section><div class=\"loader knowledge-centre-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head>Knowledge Centre</div></div><div class=all-content-wrapper><div ng-if=\"Dashboard.knowledgeCenterList.length > 0\" class=content-wrapper ng-repeat=\"item in Dashboard.knowledgeCenterList | orderBy: \'index\'\"><div class=title-head-wrapper><div class=\"head-text set-font-familt-inter set-font-weight-500\">{{item.header}}</div><div class=\"set-font-weight-500 set-font-family-monasans set-color-primary-blue\"><a href=javascript:void(0) ng-click=\"Dashboard.openCalculator(item.header, item.headerUrl)\" class=view-all-div>View All <img src=../assets/images/icons/red-greater-than-arrow.svg></a></div></div><div class=action-and-content-wrapper ng-click=\"window.open(item.redirectUrl, \'_blank\')\"><a ng-href={{item.redirectUrl}} target=_blank class=d-flex><div class=img-wrapper><img src={{item.contentPath}} class=img-div></div><!--          <ng-bind-html dynamic=\"item.content\" class=\"knowledge-widget-dynamic-content\"></ng-bind-html>--><div class=knowledge-widget-dynamic-content><div class=head-wrapper><div class=\"main-head-title set-font-family-inter set-font-weight-700\">{{item.content}}</div><p class=\"set-font-weight-500 set-font-family-monasans\">Know More</p></div></div></a></div></div><div ng-if=\"Dashboard.knowledgeCenterList.length == 0\" class=text-center>No data available</div></div></section><style>.view-all-div{\n    font-size: 1rem !important;\n  }</style>");
$templateCache.put("app/dashboard/widgets/quick-link-widget.html","<div class=quick-links-container><div class=\"loader quick-link-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head><span>Quick Links</span></div></div><div class=card-section><div class=link-wrapper><div class=\"all-content-wrapper quick-link-card-container col-lg-3 col-md-6 col-xs-6\" ng-repeat=\"item in Dashboard.quickLinkList\"><div class=main-content-wrapper ng-click=Dashboard.quickLinkAction(item)><div class=quick-link-img><!--            <img src=\"{{list.image_url}}\" />--><div ng-class=\"{\'non-fin-trans\': item.label == \'NON_FINANCIAL_TRANSACTIONS\', \'statement\': item.label == \'STATEMENTS\', \'investors\': item.label == \'INVESTORS\', \'explore-funds\': item.label == \'EXPLORE_FUNDS\'}\"></div></div><div class=quick-link-separator></div><div class=quick-link-url><a class=\"redirect-link set-font-weight-600 set-font-family-inter set-color-gray-black\">{{item.name}}</a></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/widgets/sip-overview-widget.html","<div class=sip-overview-widget-main-container><div class=\"loader sip-overview-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head><span>SIP Overview</span> <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=top title={{Dashboard.sipOverViewConfiguration.tooltipMsg}}></i></div></div><div class=all-content-wrapper ng-if=!Dashboard.isSipOverviewDataEpmty><div class=upper-content-wrapper><div class=active-sip ng-if=Dashboard.sipOverviewData.sipsActive><div class=title-and-count-wrapper><div class=\"title set-font-family-monasans set-font-weight-700 set-blue-color\">Active SIPs</div><div class=count-wrapper><div class=\"count-head set-font-family-monasans set-font-weight-400 set-color-black-light\">Count : {{Dashboard.sipOverviewData.sipsActive.count | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsActive.count}}</div><div class=\"count-no set-font-family-monasans set-color-black-light set-font-weight-700\">₹{{Dashboard.sipOverviewData.sipsActive.amount | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsActive.amount}}</div></div></div><div class=btn-wrapper ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.ACTIVE, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><button class=\"set-font-family-inter set-font-weight-600\">Review</button></div></div><div class=completing-sip><div class=sip-expiring-details-main-container><div class=main-content-wrapper ng-if=Dashboard.sipOverviewData.sipsToBeExpired ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.ACTIVE, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP, next:true})\"><div class=main-container><div class=text-wrapper><div class=\"count-box set-font-weight-700 set-font-family-monasans\">{{Dashboard.sipOverviewData.sipsToBeExpired.count | truncateDecimal: 2 | unitWithDecimal: Dashboard.sipOverviewData.sipsToBeExpired.count}}</div><div class=\"head-div set-font-weight-500 set-font-family-inter set-color-black-primary\">SIPs completing in next one month</div></div><span class=\"glyphicon glyphicon-chevron-right\"></span></div></div><div class=main-content-wrapper ng-if=Dashboard.sipOverviewData.sipsExpired ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.EXPIRED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=main-container><div class=text-wrapper><div class=\"count-box set-font-weight-700 set-font-family-monasans\">{{Dashboard.sipOverviewData.sipsExpired.count | truncateDecimal: 2 | unitWithDecimal: Dashboard.sipOverviewData.sipsExpired.count}}</div><div class=\"head-div set-font-weight-500 set-font-family-inter set-color-black-primary\">SIPs completed in last one month</div></div><span class=\"glyphicon glyphicon-chevron-right\"></span></div></div></div></div></div><div class=below-content-wrapper><div class=ceased ng-if=Dashboard.sipOverviewData.sipsCeased ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.CEASED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=title-wrapper><div class=\"title set-font-family-monasans set-font-weight-700\">Ceased</div><div class=chevron-right-black></div></div><div class=count-wrapper><div class=\"title set-font-family-monasans set-font-weight-400 set-color-black-light\">Count : {{Dashboard.sipOverviewData.sipsCeased.count | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsCeased.count}}</div><div class=\"count set-font-family-monasans set-font-weight-700 set-color-black-light\">₹{{Dashboard.sipOverviewData.sipsCeased.amount | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsCeased.amount}}</div></div></div><div class=cancelled ng-if=Dashboard.sipOverviewData.sipsCancelled ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.CANCELLED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=title-wrapper><div class=\"title set-font-family-monasans set-font-weight-700\">Cancelled</div><div class=chevron-right-black></div></div><div class=count-wrapper><div class=\"title set-font-family-monasans set-font-weight-400 set-color-black-light\">Count : {{Dashboard.sipOverviewData.sipsCancelled.count | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsCancelled.count}}</div><div class=\"count set-font-family-monasans set-font-weight-700 set-color-black-light\">₹{{Dashboard.sipOverviewData.sipsCancelled.amount | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsCancelled.amount}}</div></div></div><div class=completed ui-sref=\"main.sipcorner({status:Dashboard.DASHBOARD_TRXN_TYPES.EXPIRED, transactionType:Dashboard.DASHBOARD_TRXN_TYPES.SIP})\"><div class=title-wrapper ng-if=Dashboard.sipOverviewData.sipsExpired><div class=\"title set-font-family-monasans set-font-weight-700 set-color-green\">Completed</div><div class=chevron-right-black></div></div><div class=count-wrapper><div class=\"title set-font-family-monasans set-font-weight-400 set-color-black-light\">Count : {{Dashboard.sipOverviewData.sipsExpired.count | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsExpired.count}}</div><div class=\"count set-font-family-monasans set-font-weight-700 set-color-black-light\">₹{{Dashboard.sipOverviewData.sipsExpired.amount | truncateDecimal: 2 | unitWithDecimal:Dashboard.sipOverviewData.sipsExpired.amount}}</div></div></div></div></div><div ng-if=Dashboard.isSipOverviewDataEpmty class=text-center>No data found</div></div>");
$templateCache.put("app/dashboard/widgets/todo-widget.html","<div class=todos-widget><div class=\"loader todos-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=head><p class=\"pull-left set-font-family-inter set-font-weight-700\">To-Do List <span class=count>{{Dashboard.totalPendingCount}}</span></p><a href=javascript:void(0) class=\"pull-right view-all-div cursor-pointer set-font-family-inter set-font-weight-500\" ng-if=\"Dashboard.totalPendingCount != 0\" ui-sref=main.todos>View All <img src=../assets/images/icons/red-greater-than-arrow.svg></a></div><div class=content-wrapper><ul class=list-item-ul ng-if=\"Dashboard.pendingList.length || Dashboard.birthdayList.length || Dashboard.pendingFolioList.length\"><li class=\"list-item-li group-head common-css\" ng-if=Dashboard.pendingList.length><span class=cursor-default>Pending Transactions</span></li><li class=\"list-item-li todo-remind\" ng-repeat=\"data in Dashboard.pendingList\"><span ng-bind=data.itemDescription ng-class=\"{\'self\':data.itemAction === Dashboard.SELF_DECLARATION}\" ng-click=\"data.itemAction === Dashboard.SELF_DECLARATION && Dashboard.sendReminder(data)\">Someone wants something</span> <span ng-click=\"!data.validFlag || Dashboard.sendReminder(data.transactionId)\" ng-class=\"{\'disabled\':!data.validFlag}\" class=\"text-center blue-action\" ng-if=\"data.itemAction !== Dashboard.SELF_DECLARATION\" ng-bind=data.itemAction></span></li><li class=\"list-item-li group-head common-css\" ng-if=Dashboard.birthdayList.length><span class=\"cursor-default blue-action\">Birthday Alerts</span></li><li class=list-item-li ng-repeat=\"bday in Dashboard.birthdayList\"><span ng-bind=bday.itemDescription></span> <span class=\"text-center blue-action\" ng-bind=bday.itemAction ng-click=Dashboard.wishSomeone(bday)></span></li><li class=\"list-item-li group-head common-css\" ng-if=Dashboard.pendingFolioList.length><span class=cursor-default>Folio Action</span></li><li class=list-item-li ng-repeat=\"data in Dashboard.pendingFolioList\"><span ng-bind=data.itemDescription></span> <span ng-if=\"data.itemAction == \'Update\'\" class=\"text-center blue-action\" ng-bind=data.itemAction ng-click=\"Dashboard.updateFolioAction(data,\'Update\')\"></span> <span ng-if=\"data.itemAction == \'Resend\'\" class=folio-action-group><span class=\"text-center resend-btn\" ng-bind=data.itemAction ng-click=\"Dashboard.updateFolioAction(data,\'Resend\')\"></span> <span class=\"text-center blue-action\" ng-bind=data.itemActionSecond ng-click=\"Dashboard.updateFolioAction(data,\'Reject\')\"></span></span></li><li class=\"list-item-li group-head common-css\"><span class=\"text-center pending-folios-redirect\" ui-sref=\"main.investors.analysisType({analysisType:\'pending-list\'})\">Pending Folio Creation</span></li></ul><div class=if-error ng-if=\"Dashboard.totalPendingCount == 0\"><i class=smile-icon></i><p>Yippee!!! You have no pending work items!!!</p></div></div></div>");
$templateCache.put("app/dashboard/widgets/transaction-overview-widget.html","<div class=transaction-overview-section><div class=\"loader transaction-overview-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head><span>Transaction Overview</span></div><div class=select-dropdown-container><div class=select-option-div><div class=\"dropdown transaction-overview-dropdown\"><a class=value-wrapper href=javascript:void(0) data-toggle=dropdown>{{Dashboard.selectedTransactionOverview.value}} <img src=../../../assets/images/logos/drop-arrow-red.svg alt=down></a><ul class=dropdown-menu><li class=list-group-item ng-repeat=\"item in Dashboard.TRANSACTION_DROPDOWN_VALUES\" ng-click=\"Dashboard.changeTimePeriod(\'TRANSACTION_OVERVIEW\', item)\">{{item.value}}<div class=separator></div></li></ul></div></div><div class=\"view-all-div set-font-weight-500 set-font-family-inter set-color-primary-blue\" ng-click=\"Dashboard.redirectTo(\'main.transactions.all\')\">View All <img src=../assets/images/icons/red-greater-than-arrow.svg></div></div></div><div class=title-main-container-mobile><div class=title-info-head><div class=\"title set-font-family-inter set-font-weight-700 set-color-primary-blue\">Transaction Overview</div><div class=\"view-all-div set-font-weight-500 set-font-family-inter set-color-primary-blue\" ng-click=\"Dashboard.redirectTo(\'main.transactions.all\')\">View All <img src=../assets/images/icons/red-greater-than-arrow.svg></div></div><div class=select-dropdown-container><div class=select-option-div><div class=\"dropdown transaction-overview-dropdown\"><a class=value-wrapper href=javascript:void(0) data-toggle=dropdown>{{Dashboard.selectedTransactionOverview.value}} <img src=../../../assets/images/logos/drop-arrow-red.svg alt=down></a><ul class=dropdown-menu><li class=list-group-item ng-repeat=\"item in Dashboard.TRANSACTION_DROPDOWN_VALUES\" ng-click=\"Dashboard.changeTimePeriod(\'TRANSACTION_OVERVIEW\', item)\">{{item.value}}<div class=separator></div></li></ul></div></div></div></div><div class=transactions-status><div class=outer-container-wrapper><div class=transaction-status-container ng-repeat=\"item in Dashboard.transFormedAllTranasctionStatus track by $index\" ng-click=\"Dashboard.selectedTab(item.name, item.count); Dashboard.initiateTransactionList()\" ng-class=\"{\n           \'active-transaction-status\' : Dashboard.activeTab[$index],\n           \'active-processed-trans\': item.name === \'Processed\' && Dashboard.activeTab[$index],\n           \'active-proposed-trans\': item.name === \'Proposed\' && Dashboard.activeTab[$index],\n           \'active-pending-trans\': item.name === \'Pending\' && Dashboard.activeTab[$index],\n           \'active-rejected-trans\': item.name === \'Rejected\' && Dashboard.activeTab[$index],\n           \'active-expired-trans\': item.name === \'Expired\' && Dashboard.activeTab[$index],\n           \'active-reversed-trans\': item.name === \'Reversed\' && Dashboard.activeTab[$index]}\"><div class=\"count-div set-font-family-inter set-font-weight-700\">{{item.count}}</div><div class=\"status-title set-font-family-inter set-font-weight-500\">{{item.name}}</div><div class=dynamic></div></div></div></div><div class=\"list data-grid transaction-overview-table\"><table class=\"table table-striped table-responsive rwd-table\" style=\"margin-top: 0px\"><thead><tr class=\"set-font-family-inter set-font-weight-500\"><th class=col-md-1>Investor Name</th><th class=col-md-4>Scheme Name</th><th class=col-md-1>Type</th><th class=col-md-2>Amount</th><th class=\"col-md-2 text-center\">Action</th></tr></thead><tbody><tr ng-if=Dashboard.transactionListData ng-repeat=\"transactiondata in Dashboard.transactionListData\"><td data-th=\"Investor Number\">{{transactiondata.name}}</td><td data-th=\"Scheme Name\">{{transactiondata.scheme}}</td><td data-th=Type>{{transactiondata.transactionType}}</td><!--<a href=\"javaScript:void(0);\" ng-click=\"InvestorProfile.showSummary(transactiondata)\">{{transactiondata.investmentType}}</a>--><td data-th=Amount class=amount><i class=rupee-icon></i> {{transactiondata.amount | truncateDecimal: 2 | unitWithDecimal:transactiondata.amountUnit}}{{transactiondata.amountUnit | truncateDecimal: 2 | unitValue}}</td><td data-th=Action ng-if=\"transactiondata.action && transactiondata.action.length !== 0\"><div class=\"btn-more dropdown drop-select-trans\"><select class=custom-select ng-if=\"transactiondata.action!==undefined && transactiondata.folioNumber && transactiondata.action.length!==0\" ng-model=transactiondata.actionSelected ng-options=\"item as item for item in transactiondata.action\"></select><!--<button ng-if=\"transactiondata.action!==undefined && transactiondata.folioNumber && transactiondata.action.length!==0\" class=\"btn-primary-action dropdown-toggle\" data-toggle=\"dropdown\" style=\"width: 77px\"> {{Transaction.topUpLabel || Transaction.top_Up_label}} <i class=\"arrow-white-down-icon\"></i> </button>\n              <ul class=\"dropdown-menu\">\n&lt;!&ndash;                 <li>{{Transaction.topUpLabel || Transaction.top_Up_label}}  <i class=\"arrow-blue-down-icon\"></i></li>&ndash;&gt;\n               <li class=\"list-group-item\" ng-click=\"Dashboard.selectTransaction(data,action)\" ng-repeat=\"action in transactiondata.action\">\n                 {{action}}  <i class=\"arrow-right-icon pull-right\"></i>\n               </li>\n              </ul>--><div class=proceed-arrow ng-click=Dashboard.selectTransaction(transactiondata)></div></div></td><td data-th=Action ng-if=\"!transactiondata.action || transactiondata.action.length == 0\" style=\"text-align: center\">--</td></tr><tr ng-if=\"Dashboard.transactionListData.length == 0\"><td class=text-center colspan=6>No Record found</td></tr></tbody></table></div><div class=\"transaction-overview-mobile container\"><div class=\"outer-wrapper row\" ng-repeat=\"transactiondata in Dashboard.transactionListData\"><div class=\"margin-custom col-xs-12\"><div class=\"label-name set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Scheme</div><div class=\"content-value set-font-family-monasans set-font-weight-700 set-color-black-primary\">{{transactiondata.scheme}}</div></div><div class=col-xs-6><div class=\"label-name set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Investor Name</div><div class=\"content-value set-font-family-monasans set-font-weight-700 set-color-black-primary\">{{transactiondata.name}}</div></div><div class=col-xs-6><div class=\"label-name set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Type</div><div class=\"content-value margin-custom set-font-family-monasans set-font-weight-700 set-color-black-primary\">{{transactiondata.transactionType}}</div></div><div class=col-xs-6><div class=\"label-name set-font-family-monasans set-font-weight-400 set-color-gray-primary\">Amount</div><div class=\"content-value set-font-family-monasans set-font-weight-700 set-color-black-primary\">₹{{transactiondata.amount | truncateDecimal: 2 | unitWithDecimal: transactiondata.amount}}</div></div><div class=col-xs-6><div class=\"btn-more dropdown drop-select-trans\"><select class=custom-select ng-if=\"transactiondata.action!==undefined && transactiondata.folioNumber && transactiondata.action.length!==0\" ng-model=transactiondata.actionSelected ng-options=\"item as item for item in transactiondata.action\" ng-change=\"transactiondata.selectTransaction(\'AUM\')\"></select><!--<button ng-if=\"transactiondata.action!==undefined && transactiondata.folioNumber && transactiondata.action.length!==0\" class=\"btn-primary-action dropdown-toggle\" data-toggle=\"dropdown\" style=\"width: 77px\"> {{Transaction.topUpLabel || Transaction.top_Up_label}} <i class=\"arrow-white-down-icon\"></i> </button>\n          <ul class=\"dropdown-menu\">\n            &lt;!&ndash;                 <li>{{Transaction.topUpLabel || Transaction.top_Up_label}}  <i class=\"arrow-blue-down-icon\"></i></li>&ndash;&gt;\n            <li class=\"list-group-item\" ng-click=\"Dashboard.selectTransaction(data,action)\" ng-repeat=\"action in transactiondata.action\">\n              {{action}}  <i class=\"arrow-right-icon pull-right\"></i>\n            </li>\n          </ul>--><div ng-if=\"transactiondata.action && transactiondata.action.length > 0\" class=proceed-arrow ng-click=Dashboard.selectTransaction(transactiondata)></div></div></div></div><div class=text-center ng-if=\"Dashboard.transactionListData.length == 0\">No record found</div></div><div ng-if=Dashboard.isInvestorTransactionPagination class=\"pagination-wrapper no-overflow\"><ul uib-pagination total-items=Dashboard.totalShowingTransactionCount ng-model=Dashboard.currentPageTransactionListData max-size=5 items-per-page=Dashboard.pageLimitTransactionListData class=pagination boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Dashboard.initiateTransactionList() rotate=false></ul><div><span>Showing</span> <span>{{Dashboard.fromText}}-{{Dashboard.toText}}</span><!--        <select ng-if=\"InvestorProfile.totalTransactionListData > InvestorProfile.PAGE_LIMITS[0]\"--><!--                ng-change=\"InvestorProfile.init()\"--><!--                ng-model=\"InvestorProfile.pageLimitTransactionListData\"--><!--                ng-options=\"_limit as _limit for _limit in InvestorProfile.PAGE_LIMITS\">--><!--        </select>--> <span>of</span> <span class=t-black ng-bind=Dashboard.totalShowingTransactionCount></span></div></div></div>");
$templateCache.put("app/dashboard/widgets/transaction.widget.html","<div class=transaction-widget><ul class=transact-list><li ng-repeat=\"transact in Dashboard.transactionList\"><button ng-click=Dashboard.performAction(transact.action)><i class={{transact.iconClass}}></i> <span>{{transact.name}}</span></button></li></ul></div>");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-additional-details.html","<div class=\"container-fluid forgot-password-container emapnel-additional-details-section\" ng-init=DistributorEmpanellment.Init()><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-grow.svg class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=DistributorEmpanellment.goBack()><i class=back-icon></i></a></div><div class=\"forgot-form-container empanel-additonal-details-form-container\"><form autocomplete=off name=DistributorEmpanellment.additionalForm autocomplete=off novalidate ng-submit=DistributorEmpanellment.submitAdditionalDetails()><h2 class=info>Additional <span class=partner-blue>Details</span></h2><div class=input-normal><label>Select AMC Branch<span class=req>*</span></label><select class=\"select-box custom-select\" name=DistributorEmpanellment.additionalForm.state ng-model=DistributorEmpanellment.formData.selectedState ng-change=DistributorEmpanellment.changeState(DistributorEmpanellment.formData.selectedState) ng-options=\"branch as branch.state for branch in DistributorEmpanellment.listOfBranch track by branch.state\" required><option value=\"\">Select State</option></select></div><div class=input-normal><label>Branch Address<span class=req>*</span></label><select class=\"select-box custom-select\" name=DistributorEmpanellment.additionalForm.branch ng-model=DistributorEmpanellment.formData.selectedBranch ng-options=\"branch.id as branch.name for branch in DistributorEmpanellment.listOfBranchAddress\" required><option value=\"\">Select Branch</option></select></div><div class=form-action-container><input type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=DistributorEmpanellment.goBack(); value=Back> <button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=DistributorEmpanellment.additionalForm.$invalid>Continue</button></div></form></div></div></div></div></div>");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-arn.html","<div class=\"container-fluid forgot-password-container\" ng-init=DistributorEmpanellment.Init()><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-forgot.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=DistributorEmpanellment.goBack()><i class=back-icon></i></a></div><div class=forgot-form-container><form autocomplete=off name=arnVerifyForm novalidate ng-submit=DistributorEmpanellment.verifyArnInfo()><h2 class=info>Distributor <span class=partner-blue>Empanelment</span></h2><div class=input-normal ng-class=\"{error:arnVerifyForm.arnCode.$dirty && arnVerifyForm.arnCode.$invalid}\"><label>ARN<span class=req>*</span></label><input ng-model=DistributorEmpanellment.formData.arnCode placeholder=ARN type=text maxlength=10 name=arnCode ng-pattern=DistributorEmpanellment.appConstants.arn_regex capitalize class=arn-no autocomplete=off autofocus required> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span> <span ng-show=\"arnVerifyForm.arnCode.$dirty && arnVerifyForm.arnCode.$invalid\"><span class=error-input ng-show=arnVerifyForm.arnCode.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ARN_REQUIRED></span> <span class=error-input ng-show=\"arnVerifyForm.arnCode.$error.pattern && arnVerifyForm.arnCode.$invalid \" class=help-block>{{ DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ARN_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:arnVerifyForm.panNumber.$dirty && arnVerifyForm.panNumber.$invalid}\"><label>PAN<span class=req>*</span></label><input type=text easyassist-key=mask-element name=panNumber ng-model=DistributorEmpanellment.formData.panNumber ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ maxlength=10 minlength=10 placeholder=\"Enter PAN\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"arnVerifyForm.panNumber.$dirty && arnVerifyForm.panNumber.$invalid\"><span class=error-input ng-show=arnVerifyForm.panNumber.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.PAN_REQUIRED></span> <span class=error-input ng-show=arnVerifyForm.panNumber.$error.maxlength>{{ Modal.validateData.MOBILE_FIELD }}</span> <span class=error-input ng-show=arnVerifyForm.panNumber.$error.pattern ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.PAN_FIELD></span></span></div><div class=form-action-container><input type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=DistributorEmpanellment.goBack(); value=Back> <button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=arnVerifyForm.$invalid>Verify</button></div></form></div></div></div></div></div><!--<div class=\"col-xs-12 col-sm-6 form-wrapper\" ng-init=\"DistributorEmpanellment.Init()\">\n    <form autocomplete=\"off\" name=\"DistributorEmpanellment.ArnVerifyForm\" autocomplete=\"off\" novalidate>\n      <div>\n        <div class=\"ui-progress payment\"  ng-class=\"DistributorEmpanellment.activeTab.lineclass\" >\n          <span class=\"create-folio cursor-pointer\"  ng-class=\"{active:DistributorEmpanellment.activeTab.arn}\" data-text=\"ARN Info\">&nbsp;</span>\n          <span class=\"add-scheme  cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.otp}\" data-text=\"OTP\">&nbsp;</span>\n          <span class=\"select-payment-mode cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.nominee}\" data-text=\"Additional Details\">&nbsp;</span>\n        </div>\n      </div>\n      <div class=\"input-normal\" ng-class=\"{error:DistributorEmpanellment.ArnVerifyForm.arnCode.$dirty && DistributorEmpanellment.ArnVerifyForm.arnCode.$invalid}\">\n        <input ng-model=\"DistributorEmpanellment.formData.arnCode\" type=\"text\" maxlength=\"10\" name=\"arnCode\" ng-pattern=\"DistributorEmpanellment.appConstants.arn_regex\" capitalize class=\"arn-no\" autocomplete=\"off\" required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <span class=\"arn\">ARN -</span>\n        <label>ARN</label>\n					<span ng-show=\"DistributorEmpanellment.ArnVerifyForm.arnCode.$dirty && DistributorEmpanellment.ArnVerifyForm.arnCode.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.ArnVerifyForm.arnCode.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ARN_REQUIRED\"></span>\n						<span class=\"error-input\"\n                  ng-show=\"DistributorEmpanellment.ArnVerifyForm.arnCode.$error.pattern && DistributorEmpanellment.ArnVerifyForm.arnCode.$invalid \"\n                  class=\"help-block\">\n							{{ DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ARN_FIELD }}\n						</span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-class=\"{error:DistributorEmpanellment.ArnVerifyForm.panNumber.$dirty && DistributorEmpanellment.ArnVerifyForm.panNumber.$invalid}\">\n        <input type=\"text\" easyassist-key=\"mask-element\" name=\"panNumber\" ng-model=\"DistributorEmpanellment.formData.panNumber\"\n               ng-pattern=\"/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/\"\n               maxlength=\"10\" minlength=\"10\"\n               required autocomplete=\"off\" capitalize>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>PAN</label>\n					<span ng-show=\"DistributorEmpanellment.ArnVerifyForm.panNumber.$dirty && DistributorEmpanellment.ArnVerifyForm.panNumber.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.ArnVerifyForm.panNumber.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.PAN_REQUIRED\"></span>\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.ArnVerifyForm.panNumber.$error.maxlength\">{{ Modal.validateData.MOBILE_FIELD }}</span>\n					<span class=\"error-input\" ng-show=\"DistributorEmpanellment.ArnVerifyForm.panNumber.$error.pattern\"\n                ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.PAN_FIELD\"></span>\n          </span>\n      </div>\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.isCaptchaShown\">\n        <div vc-recaptcha key=\"DistributorEmpanellment.publicKey\" ng-model=\"DistributorEmpanellment.gRecaptchaResponse\"></div>\n      </div>\n      <button type=\"button\" class=\"btn btn-primary-action btn-block mg40\" ng-disabled=\"DistributorEmpanellment.ArnVerifyForm.$invalid\" ng-click=\"DistributorEmpanellment.verifyArnInfo()\">Verify</button>\n      <button type=\"button\" class=\"btn btn-secondary-action btn-block\" ng-click = \"DistributorEmpanellment.confirmCancel();\" >Cancel</button>\n    </form>\n\n  </div>-->");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-guardiandetails.html","<div class=\"container-fluid forgot-password-container empanel-nominee-details\" ng-init=DistributorEmpanellment.Init()><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-grow.svg class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=DistributorEmpanellment.goBack()><i class=back-icon></i></a></div><div class=\"forgot-form-container empanel-nominee-details-form\"><form autocomplete=off name=DistributorEmpanellment.nomineeForm autocomplete=off novalidate ng-submit=DistributorEmpanellment.submitNomineeDetails()><h2 class=info>Enter <span class=partner-blue>Nominee details</span></h2><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid}\"><label>Guardian Name<span class=req>*</span></label><input ng-model=DistributorEmpanellment.formData.gurdianName type=text name=guardianName placeholder=\"Enter Guardian Name\" easyassist-key=mask-element autocomplete=off required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.guardianName.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.GUARDIAN_NAME></span></span></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid}\"><label>Guardian Address Line 1<span class=req>*</span></label><input ng-model=DistributorEmpanellment.formData.gurdianAddress1 placeholder=\"Enter Address Line 1\" easyassist-key=mask-element type=text name=addressLine1 autocomplete=off required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.addressLine1.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE1></span></span></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid}\"><label>Guardian Address Line 2<span class=req>*</span></label><input ng-model=DistributorEmpanellment.formData.gurdianAddress2 placeholder=\"Enter Address Line 2\" easyassist-key=mask-element type=text name=addressLine2 autocomplete=off required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.addressLine2.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE2></span></span></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid}\"><label>Zip/Postal Code<span class=req>*</span></label><input easyassist-key=mask-element ng-model=DistributorEmpanellment.formData.postalCode placeholder=\"Enter Zip/Postal Code\" type=text name=zipCode autocomplete=off is-number ng-maxlength=6 limit-to=6 minlength=6 maxlength=6 required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.zipCode.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ZIP_CODE></span></span></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid}\"><label>City<span class=req>*</span></label><input easyassist-key=mask-element ng-model=DistributorEmpanellment.formData.city placeholder=\"Enter City\" type=text name=city autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.city.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.CITY></span></span></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid}\"><label>Country<span class=req>*</span></label><input easyassist-key=mask-element placeholder=\"Enter Country\" ng-model=DistributorEmpanellment.formData.country type=text name=country autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.country.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.COUNTRY></span></span></div><div class=form-action-container><input type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=DistributorEmpanellment.goBack(); value=Back> <button type=submit class=\"btn btn-primary-action btn-block mg40\" ng-disabled=DistributorEmpanellment.nomineeForm.$invalid>Submit</button></div></form></div></div></div></div></div>");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-nomineedetails.html","<div class=\"container-fluid forgot-password-container empanel-nominee-details\" ng-init=DistributorEmpanellment.Init()><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-grow.svg class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=DistributorEmpanellment.goBack()><i class=back-icon></i></a></div><div class=\"forgot-form-container empanel-nominee-details-form\"><form autocomplete=off name=DistributorEmpanellment.nomineeForm autocomplete=off novalidate ng-submit=DistributorEmpanellment.submitNomineeDetailsCheck()><h2 class=info>Enter <span class=partner-blue>Nominee details</span></h2><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.nomineeName.$dirty &&\n                DistributorEmpanellment.nomineeForm.nomineeName.$invalid}\"><label>Nominee Name<span class=req>*</span></label><input easyassist-key=mask-element placeholder=\"Enter Name\" ng-model=DistributorEmpanellment.formData.name type=text name=nomineeName maxlength=60 autocomplete=off required> <span class=highlight></span> <span class=bar></span> <span ng-show=\"DistributorEmpanellment.nomineeForm.nomineeName.$dirty && DistributorEmpanellment.nomineeForm.nomineeName.$invalid\"><span class=error-input ng-show=DistributorEmpanellment.nomineeForm.nomineeName.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.NOMINEE_NAME_REQUIRED></span></span></div><div class=input-normal><label>Relation<span class=req>*</span></label><select easyassist-key=mask-element class=select-box ng-model=DistributorEmpanellment.formData.relationShip ng-options=\"relation.value as relation.key for relation in DistributorEmpanellment.relationList\" required><option value=\"\">Relationship with Nominee</option></select></div><div class=input-normal ng-class=\"{error:DistributorEmpanellment.nomineeForm.nomineeDob.$dirty && DistributorEmpanellment.nomineeForm.nomineeDob.$invalid}\"><label>Date of Birth<span class=req>*</span></label><input type=text class=date easyassist-key=mask-element ng-model=DistributorEmpanellment.formData.dob name=nomineeDob date-calendar format=\"DD MMM YYYY\" data-enable=true data-viewmode=days data-date-default=DistributorEmpanellment.formData.dob data-on-date-change=DistributorEmpanellment.changeNomineeDob maxdate=now required autocomplete=off data-showdefault=false id=nomineeDob placeholder=\"Enter DOB\" autocomplete=off readonly><!--<span class=\"input-group-addon\">\n                   <span class=\"glyphicon glyphicon-calendar\"></span>\n              </span>--> <span class=highlight></span> <span class=bar></span></div><!--            <div class=\"input-normal\"  ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid}\">--><!--              <label>Guardian Name<span class=\"req\">*</span></label>--><!--              <input ng-model=\"DistributorEmpanellment.formData.gurdianName\" type=\"text\" name=\"guardianName\" placeholder=\"Enter Guardian Name\" easyassist-key=\"mask-element\" autocomplete=\"off\" required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.guardianName.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.GUARDIAN_NAME\"></span>--><!--              </span>--><!--            </div>--><!--            <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid}\">--><!--              <label>Guardian Address Line 1<span class=\"req\">*</span></label>--><!--              <input ng-model=\"DistributorEmpanellment.formData.gurdianAddress1\" placeholder=\"Enter Address Line 1\" easyassist-key=\"mask-element\" type=\"text\" name=\"addressLine1\" autocomplete=\"off\" capitalize required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.addressLine1.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE1\"></span>--><!--              </span>--><!--            </div>--><!--            <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid}\">--><!--              <label>Guardian Address Line 2<span class=\"req\">*</span></label>--><!--              <input ng-model=\"DistributorEmpanellment.formData.gurdianAddress2\" placeholder=\"Enter Address Line 2\" easyassist-key=\"mask-element\" type=\"text\" name=\"addressLine2\" autocomplete=\"off\" capitalize required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.addressLine2.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE2\"></span>--><!--              </span>--><!--            </div>--><!--            <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid}\">--><!--              <label>Zip/Postal Code<span class=\"req\">*</span></label>--><!--              <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.postalCode\" placeholder=\"Enter Zip/Postal Code\" type=\"text\" name=\"zipCode\" autocomplete=\"off\" is-number ng-maxlength=\"6\" limit-to=\"6\" minlength=\"6\" maxlength=\"6\"required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.zipCode.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ZIP_CODE\"></span>--><!--              </span>--><!--            </div>--><!--            <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid}\">--><!--              <label>City<span class=\"req\">*</span></label>--><!--              <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.city\" placeholder=\"Enter City\" type=\"text\" name=\"city\" autocomplete=\"off\" capitalize required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.city.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.CITY\"></span>--><!--              </span>--><!--            </div>--><!--            <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid}\">--><!--              <label>Country<span class=\"req\">*</span></label>--><!--              <input easyassist-key=\"mask-element\"placeholder=\"Enter Country\"  ng-model=\"DistributorEmpanellment.formData.country\" type=\"text\" name=\"country\" autocomplete=\"off\" capitalize required>--><!--              <span class=\"highlight\"></span>--><!--              <span class=\"bar\"></span>--><!--              <span ng-show=\"DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid\">--><!--                <span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.country.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.COUNTRY\"></span>--><!--              </span>--><!--            </div>--><div class=form-action-container><input type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=DistributorEmpanellment.goBack(); value=Back> <button type=submit class=\"btn btn-primary-action btn-block mg40\" ng-disabled=DistributorEmpanellment.nomineeForm.$invalid>{{!DistributorEmpanellment.enableFields && DistributorEmpanellment.formData.dob ? \'Submit\' : \'Continue\'}}</button></div></form></div></div></div></div></div><!--<div class=\"col-xs-12 col-sm-6 form-wrapper\" ng-init=\"DistributorEmpanellment.Init()\">\n  <form autocomplete=\"off\" name=\"DistributorEmpanellment.nomineeForm\" autocomplete=\"off\" novalidate>\n    <div>\n      <div class=\"ui-progress payment\"  ng-class=\"DistributorEmpanellment.activeTab.lineclass\" >\n        <span class=\"create-folio cursor-pointer\"  ng-class=\"{active:DistributorEmpanellment.activeTab.arn}\" data-text=\"ARN Info\">&nbsp;</span>\n        <span class=\"add-scheme cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.otp}\" data-text=\"OTP\">&nbsp;</span>\n        <span class=\"select-payment-mode cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.nominee}\" data-text=\"Additional Details\">&nbsp;</span>\n      </div>\n    </div>\n\n    <div>\n      <p class=\"mg30\"><strong>Select AMC Branch</strong></p>\n      <select class=\"select-box\" ng-model=\"DistributorEmpanellment.selectedState\" ng-options=\"branch.value as branch.state for branch in DistributorEmpanellment.listOfBranch\">\n        <option value=\"\">Select State</option>\n      </select>\n      <select class=\"select-box\" name=\"DistributorEmpanellment.nomineeForm.branch\" ng-model=\"DistributorEmpanellment.selectedBranch\" ng-options=\"branch.id as branch.name for branch in DistributorEmpanellment.selectedState\">\n        <option value=\"\">Select Branch</option>\n      </select>\n    </div>\n\n    <div>\n      <p class=\"mg30 mgt40\"><strong>Enter Nominee Details</strong></p>\n      <div class=\"input-normal\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.nomineeName.$dirty && DistributorEmpanellment.nomineeForm.nomineeName.$invalid}\">\n        <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.name\" type=\"text\" name=\"nomineeName\" maxlength=\"60\" autocomplete=\"off\" required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Nominee Name</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.nomineeName.$dirty && DistributorEmpanellment.nomineeForm.nomineeName.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.nomineeName.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ARN_REQUIRED\"></span>\n					</span>\n      </div>\n\n      <select easyassist-key=\"mask-element\" class=\"select-box\" ng-model=\"DistributorEmpanellment.formData.relationShip\" ng-options=\"relation.value as relation.key for relation in DistributorEmpanellment.relationList\">\n        <option value=\"\">Relationship with Nominee</option>\n      </select>\n\n      &lt;!&ndash;<div class=\"input-normal\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.nomineeDob.$dirty && DistributorEmpanellment.nomineeForm.nomineeDob.$invalid}\">&ndash;&gt;\n        &lt;!&ndash;<input type=\"text\" name=\"nomineeDob\" id=\"nomineeDob\" maxdate=\'now\' showdefault=\"{{\'\'+!!DistributorEmpanellment.formData.dob}}\" date-calendar\n        date-default=\"DistributorEmpanellment.defaultDate\" format=\"DD-MMM-YYYY\" viewmode=\'days\'\n        data-on-date-change=\"DistributorEmpanellment.changeNomineeDob\" required autocomplete=\"off\">&ndash;&gt;\n        &lt;!&ndash;<span class=\"highlight\"></span>&ndash;&gt;\n        &lt;!&ndash;<span class=\"bar\"></span>&ndash;&gt;\n        &lt;!&ndash;<label>Nominee DOB</label>&ndash;&gt;\n        &lt;!&ndash;<span><i class=\"calendar-icon\"></i></span>&ndash;&gt;\n        &lt;!&ndash;<span ng-show=\"DistributorEmpanellment.nomineeForm.nomineeDob.$dirty && DistributorEmpanellment.nomineeForm.nomineeDob.$invalid\">&ndash;&gt;\n						&lt;!&ndash;<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.nomineeDob.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.NOMINEE_DOB\"></span>&ndash;&gt;\n          &lt;!&ndash;</span>&ndash;&gt;\n      &lt;!&ndash;</div>&ndash;&gt;\n\n\n\n      <div class=\"input-normal\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.nomineeDob.$dirty && DistributorEmpanellment.nomineeForm.nomineeDob.$invalid}\" >\n        <div class=\"input-normal verify-acc input-group date date-picker\"\n             name=\"nomineeDob\"\n             date-calendar\n             format=\"DD-MMM-YYYY\"\n             data-enable=\"true\"\n             data-viewmode=\"days\"\n             data-date-default=\"DistributorEmpanellment.defaultDate\"\n             data-on-date-change=\"DistributorEmpanellment.changeNomineeDob\"\n             maxdate=\'now\'\n             required\n             autocomplete=\"off\"\n             data-showdefault=\"false\"\n             id=\"nomineeDob\">\n          <input type=\'text\' easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.dob\" autocomplete=\"off\" class=\"form-control\" placeholder=\"Nominee DOB - DD/MM/YYYY\"\n                 readonly/>\n          <span class=\"input-group-addon\">\n                     <span class=\"glyphicon glyphicon-calendar\"></span>\n                </span>\n          <span class=\"highlight\"></span>\n          <span class=\"bar\"></span>\n        </div>\n      </div>\n\n\n\n\n\n\n\n      <div class=\"input-normal\"  ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid}\">\n        <input ng-model=\"DistributorEmpanellment.formData.gurdianName\" type=\"text\" name=\"guardianName\" easyassist-key=\"mask-element\" autocomplete=\"off\" required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Guardian Name</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.guardianName.$dirty && DistributorEmpanellment.nomineeForm.guardianName.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.guardianName.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.GUARDIAN_NAME\"></span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid}\">\n        <input ng-model=\"DistributorEmpanellment.formData.gurdianAddress1\" easyassist-key=\"mask-element\" type=\"text\" name=\"addressLine1\" autocomplete=\"off\" capitalize required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Guardian address Line 1</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine1.$dirty && DistributorEmpanellment.nomineeForm.addressLine1.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.addressLine1.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE1\"></span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid}\">\n        <input ng-model=\"DistributorEmpanellment.formData.gurdianAddress2\" easyassist-key=\"mask-element\" type=\"text\" name=\"addressLine2\" autocomplete=\"off\" capitalize required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Guardian address Line 2</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.addressLine2.$dirty && DistributorEmpanellment.nomineeForm.addressLine2.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.addressLine2.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ADDRESS_LINE2\"></span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid}\">\n        <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.postalCode\" type=\"text\" name=\"zipCode\" autocomplete=\"off\" required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Zip/Postal Code</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.zipCode.$dirty && DistributorEmpanellment.nomineeForm.zipCode.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.zipCode.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.ZIP_CODE\"></span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid}\">\n        <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.city\" type=\"text\" name=\"city\" autocomplete=\"off\" capitalize required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>City</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.city.$dirty && DistributorEmpanellment.nomineeForm.city.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.city.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.CITY\"></span>\n					</span>\n      </div>\n\n      <div class=\"input-normal\" ng-if=\"DistributorEmpanellment.enableFields\" ng-class=\"{error:DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid}\">\n        <input easyassist-key=\"mask-element\" ng-model=\"DistributorEmpanellment.formData.country\" type=\"text\" name=\"country\" autocomplete=\"off\" capitalize required>\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Country</label>\n        <span ng-show=\"DistributorEmpanellment.nomineeForm.country.$dirty && DistributorEmpanellment.nomineeForm.country.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.nomineeForm.country.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.COUNTRY\"></span>\n					</span>\n      </div>\n    </div>\n\n    <button type=\"button\" class=\"btn btn-primary-action btn-block mg40\" ng-disabled=\"DistributorEmpanellment.nomineeForm.$invalid\" ng-click=\"DistributorEmpanellment.submitNomineeDetails()\">Submit</button>\n    <button type=\"button\" class=\"btn btn-secondary-action btn-block\"  ng-click = \"DistributorEmpanellment.confirmCancel();\">Cancel</button>\n  </form>\n\n</div>-->");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-otp.html","<div class=\"Otp-section container-fluid\" ng-init=DistributorEmpanellment.Init()><div class=\"row row-flex\"><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-reset.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div class=\"back-button-container hidden-xs\"><a href=javascript:void(0) ng-click=DistributorEmpanellment.goBack();><i class=back-icon></i></a></div><div class=forgot-form-container><form autocomplete=off name=DistributorEmpanellment.otpForm autocomplete=off novalidate ng-submit=DistributorEmpanellment.submitOtp()><h2 class=info>Enter <span class=partner-blue>One-time Password (OTP)</span></h2><p class=sub-heading>{{DistributorEmpanellment.formData.contactDetailsMsg}}</p><p class=sub-heading>OTP is valid for <span class=partner-blue>15 minutes.</span></p><div class=\"input-normal input-code empanel-input-otp-wrapper\" ng-class=\"{error:DistributorEmpanellment.otpForm.otpNumber.$dirty && DistributorEmpanellment.otpForm.otpNumber.$invalid}\"><label class=visible-xs>Enter OTP<span class=req>*</span></label><div class=input-code-container><input type=tel id=otp-number-input-1 class=\"otp-number-input empanel-otp-input\" minlength=1 maxlength=1 tabindex=1 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex1 is-number custom-auto-focus easyassist-key=mask-element> <input type=tel id=otp-number-input-2 class=\"otp-number-input empanel-otp-input\" minlength=1 maxlength=1 tabindex=2 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex2 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-3 class=\"otp-number-input empanel-otp-input\" minlength=1 maxlength=1 tabindex=3 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex3 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-4 class=\"otp-number-input empanel-otp-input\" minlength=1 maxlength=1 tabindex=4 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex4 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-5 class=\"otp-number-input empanel-otp-input\" minlength=1 tabindex=5 maxlength=1 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex5 is-number easyassist-key=mask-element> <input type=tel id=otp-number-input-6 class=\"otp-number-input empanel-otp-input\" minlength=1 maxlength=1 tabindex=6 autocomplete=off ng-change=DistributorEmpanellment.otpValChanged(this) ng-model=DistributorEmpanellment.otpValIndex6 is-number easyassist-key=mask-element></div><div class=forgot><timer countdown=DistributorEmpanellment.appConstants.RESEND_OTP_COUNTER interval=1000><span ng-show=\"countdown > 0\" class=forgot-pwd><span class=link-text>Didn\'t receive OTP? Don\'t worry. <span class=brand>Enable Resend OTP</span> in </span><span class=counter-text>{{countdown}} seconds</span> </span><a href=javascript:void(0); ng-show=\"countdown ==0\" ng-click=DistributorEmpanellment.resendOtp() class=forgot-pwd>Resend OTP</a></timer></div><span ng-show=\"DistributorEmpanellment.otpForm.otpNumber.$dirty && DistributorEmpanellment.otpForm.otpNumber.$invalid\"><span class=\"error-input text-left\" ng-show=DistributorEmpanellment.otpForm.otpNumber.$error.required ng-bind=DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.OTP_REQUIRED></span><!--<span class=\"info-primary\" style=\"left:13%;\" ng-if=\"DistributorEmpanellment.loginUsingOtpFlag\"\n                      ng-bind=\"DistributorEmpanellment.otpResendMessage\"></span>--></span></div><div class=row><div class=col-md-12><div class=\"form-action form-action-container\"><button type=button class=\"btn btn-secondary-action btn-block visible-xs\" ng-click=DistributorEmpanellment.goBack();>Back</button> <input type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=\"DistributorEmpanellment.otpForm.$invalid || DistributorEmpanellment.processFlag || DistributorEmpanellment.otpCodeLength !== 6\" value=Verify></div></div></div></form></div></div></div></div></div><!--\n<div class=\"col-xs-12 col-sm-6 form-wrapper\" ng-init=\"DistributorEmpanellment.Init()\">\n  <form autocomplete=\"off\" name=\"DistributorEmpanellment.otpForm\" autocomplete=\"off\" novalidate>\n    <div>\n      <div class=\"ui-progress payment\"  ng-class=\"DistributorEmpanellment.activeTab.lineclass\" >\n        <span class=\"create-folio cursor-pointer\"  ng-class=\"{active:DistributorEmpanellment.activeTab.arn}\" data-text=\"ARN Info\">&nbsp;</span>\n        <span class=\"add-scheme cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.otp}\" data-text=\"OTP\">&nbsp;</span>\n        <span class=\"select-payment-mode cursor-pointer\" ng-class=\"{active:DistributorEmpanellment.activeTab.nominee}\" data-text=\"Additional Details\">&nbsp;</span>\n      </div>\n    </div>\n    <h3 class=\"otpverified\"><i class=\"success-icon\"></i><span> ARN Verified</span></h3>\n    <p class=\"otp-notify\">We have sent you an OTP on your registered KYD Mobile No.<br>Please enter the code to verify your account.</p>\n    <div class=\"input-normal enter-otp\" ng-class=\"{error:DistributorEmpanellment.otpForm.otpNumber.$dirty && DistributorEmpanellment.otpForm.otpNumber.$invalid}\">\n      <input ng-pattern=\"DistributorEmpanellment.appConstants.otp_regex\" ng-model=\"DistributorEmpanellment.formData.otpNumber\" easyassist-key=\"mask-element\" type=\"text\" minlength=\"6\" maxlength=\"6\" name=\"otpNumber\" autocomplete=\"off\" required>\n      <span class=\"highlight\"></span>\n      <span class=\"bar\"></span>\n      <span class=\"forgot\">\n        <timer countdown=\"DistributorEmpanellment.appConstants.RESEND_OTP_COUNTER\" interval=\"1000\" >\n         <span ng-show=\"countdown > 0\" style=\"position: absolute;top: 45px;right: 0px;\" class=\"forgot-pwd\">Enable Resend OTP in {{countdown}}s</span>\n         <a href=\"javascript:void(0);\" ng-show=\"countdown ==0\" ng-click=\"DistributorEmpanellment.resendOtp()\" class=\"resend-otp\"\n            ng-class=\"{anchorDisable:DistributorEmpanellment.processFlagOtp}\">Resend OTP</a>\n        </timer>\n      </span>\n      <label>Enter OTP</label>\n					<span ng-show=\"DistributorEmpanellment.otpForm.otpNumber.$dirty && DistributorEmpanellment.otpForm.otpNumber.$invalid\">\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.otpForm.otpNumber.$error.required\" ng-bind=\"DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.OTP_REQUIRED\"></span>\n						<span class=\"error-input\" ng-show=\"DistributorEmpanellment.otpForm.otpNumber.$error.maxlength\">{{ DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>\n            <span class=\"error-input\" ng-show=\"DistributorEmpanellment.otpForm.otpNumber.$error.pattern\">{{ DistributorEmpanellment.appConstants.ToastrMessage.VALIDATE_DATA.OTP_FIELD }}</span>\n					</span>\n    </div>\n    <button type=\"button\" class=\"btn btn-primary-action btn-block mg40\" ng-disabled=\"DistributorEmpanellment.otpForm.$invalid || DistributorEmpanellment.processFlag\" ng-click=\"DistributorEmpanellment.submitOtp()\">Submit</button>\n    <button type=\"button\" class=\"btn btn-secondary-action btn-block\" ng-click = \"DistributorEmpanellment.confirmCancel();\">Cancel</button>\n  </form>\n</div>\n\n-->");
$templateCache.put("app/distributor/empanellment/distributor-empanellment-success.html","<div class=container><div class=\"col-xs-12 col-sm-12 form-wrapper empanel-success-container\"><div class=content-container><div class=back-img-div><div class=success-msg><div class=success-tick-wrapper><img src=assets/images/icons/success-white-tick.svg alt=success-tick></div><div class=head>Request Submitted</div></div></div><div class=\"info text-center\">Thank you for showing interest in HDFC Mutual Fund. You will be notified about your empanelment status on your KYD registered Email & Mobile No.</div><form autocomplete=off><button type=button ui-sref=login class=\"btn btn-primary-action btn-block\">Okay</button></form></div></div></div>");
$templateCache.put("app/distributor/empanellment/distributor-empanellment.html","<div class=distributor-empanellment ng-init=DistributorEmpanellment.Init()><!--<header class=\"header\">\n    <div class=\"head-contrast\">\n      <ul>\n        <li ng-click=\"DistributorEmpanellment.changedFont(\'increment\')\" title=\"Increase font size\" role=\"button\" tabindex=\"0\">A+</li>\n        <li ng-click=\"DistributorEmpanellment.changedFont(\'original\')\" title=\"Reset font size\" role=\"button\" tabindex=\"0\">A</li>\n        <li ng-click=\"DistributorEmpanellment.changedFont(\'decrement\')\" title=\"Decrease font-size\" role=\"button\" tabindex=\"0\">A-</li>\n        <li ng-click=\"DistributorEmpanellment.contrast()\" title=\"High Contrast\" class=\"contrast-box\" role=\"button\" tabindex=\"0\"><span class=\"glyphicon glyphicon-adjust\"></span></li>\n      </ul>\n    </div>\n		<img src=\"assets/images/logo-main.png\" alt=\"HDFC\" class=\"logo-main pull-left header-main-logo\"/>\n		<img src=\"assets/images/logo.png\" alt=\"HDFC\" class=\"logo pull-left header-mfpartner-logo\" ui-sref=\"login\"/>\n    <div class=\"pull-right right-panel\">\n      <div>\n        <a href=\"javascript:void(0)\" ui-sref=\"login\" class=\"header-tab\">\n          <span class=\"block header-font-size\">Home</span></a>\n      </div>\n      <div>\n        <a href=\"javascript:void(0)\" ui-sref=\"faq\" class=\"header-tab\">\n          <span class=\"block header-font-size\">FAQs</span></a>\n      </div>\n    </div>\n	</header>\n  <section class=\"container content-wrapper col-xs-12 col-sm-11\">\n    <div class=\"col-xs-12 col-sm-6 empanelment-left\">\n      <h3>Distributor Empanelment</h3>\n      <p>Become our partner and manage your business more effectively and efficiently.</p>\n      <span><img src=\"../../../assets/images/empanelment.png\" class=\"img-responsive\" alt=\"Empanelment\" /></span>\n    </div>\n  <div ui-view></div>\n  </section>\n\n  <footer class=\"main-footer login-footer\">\n    <div class=\"row footerRow\">\n      <div class=\"col-md-12 bottom-footer\">\n        <p class=\"text-center\"><span>For best experience use Chrome (version 60 and above), Firefox (version 50 and above), Safari(Latest version), Microsoft Edge(Latest version)</span></p>\n      </div>\n\n      <div class=\"dynamic-Pad\">\n        <ng-bind-html dynamic=\"DistributorEmpanellment.notePreLogin.content\"></ng-bind-html>\n      </div>\n      <div class=\"dynamic-Pad\">\n        <ng-bind-html dynamic=\"DistributorEmpanellment.noteAmfiCircular.content\"></ng-bind-html>\n      </div>\n    </div>\n    <div class=\"row top-footer\">\n      <div class=\"col-md-4 col-sm-7 col-xs-12 pull-left flex-style assetmanage\">\n        <img src=\"assets/images/logo-main.png\" alt=\"HDFC\" class=\"logo-main pull-left\"/>\n        <span>{{DistributorEmpanellment.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span>\n      </div>\n\n      <div class=\"col-md-4 col-sm-5 col-xs-12 pull-right footer-info\">\n        <div class=\"col-md-3 flex-style appIconContainer\">\n          <div class=\"hdfc-mutualfund\">\n            <img src=\"assets/images/hdfc-mutualfund.png\" alt=\"HDFC Mutual Fund\" class=\"footer-logo1 pull-left\"></div>\n          <div class=\"app-store\"><a href=\"https://itunes.apple.com/in/app/mfonline-partners/id1335989019?mt=8\" target=\"_blank\"><svg id=\"livetype\" xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"22\" margin-top=\"5\" viewBox=\"0 0 119.66407 40\"><g><g><g><path d=\"M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z\" style=\"fill: #a6a6a6\"></path><path d=\"M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z\"></path></g><g id=\"_Group_\" data-name=\"<Group>\"><g id=\"_Group_2\" data-name=\"<Group>\"><g id=\"_Group_3\" data-name=\"<Group>\"><path id=\"_Path_\" data-name=\"<Path>\" d=\"M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z\" style=\"fill: #fff\"></path><path id=\"_Path_2\" data-name=\"<Path>\" d=\"M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z\" style=\"fill: #fff\"></path></g></g><g><path d=\"M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z\" style=\"fill: #fff\"></path><path d=\"M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z\" style=\"fill: #fff\"></path><path d=\"M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z\" style=\"fill: #fff\"></path><path d=\"M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z\" style=\"fill: #fff\"></path><path d=\"M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z\" style=\"fill: #fff\"></path><path d=\"M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z\" style=\"fill: #fff\"></path><path d=\"M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z\" style=\"fill: #fff\"></path><path d=\"M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z\" style=\"fill: #fff\"></path></g></g></g><g id=\"_Group_4\" data-name=\"<Group>\"><g><path d=\"M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z\" style=\"fill: #fff\"></path><path d=\"M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z\" style=\"fill: #fff\"></path><path d=\"M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z\" style=\"fill: #fff\"></path><path d=\"M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z\" style=\"fill: #fff\"></path><path d=\"M59.09377,8.437h.88867v6.26074h-.88867Z\" style=\"fill: #fff\"></path><path d=\"M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z\" style=\"fill: #fff\"></path><path d=\"M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z\" style=\"fill: #fff\"></path><path d=\"M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z\" style=\"fill: #fff\"></path><path d=\"M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z\" style=\"fill: #fff\"></path><path d=\"M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z\" style=\"fill: #fff\"></path><path d=\"M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z\" style=\"fill: #fff\"></path><path d=\"M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z\" style=\"fill: #fff\"></path><path d=\"M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z\" style=\"fill: #fff\"></path></g></g></g></svg> </a>\n            <a href=\"https://play.google.com/store/apps/details?id=com.hdfc.mf&hl=en_US\" target=\"_blank\"><img src=\"assets/images/google-play-badge.png\" alt=\"Google Play\" class=\"footer-logo1 pull-left\"></a></div></div>\n\n        <span class=\"col-md-9\" style=\"padding-left: 25px;\">\n      <span class=\"text-blue\">MF Online Partner Support Desk</span>\n      <p>Monday - Friday : 9:00 AM - 6:00 PM</p>\n          &lt;!&ndash;<p>Saturday : 9:00 AM - 1:00 PM</p> &ndash;&gt;\n    </span>\n      </div>\n    </div>\n  </footer>--><login-header></login-header><hdfc-login-sidebar></hdfc-login-sidebar><div ui-view></div><hdfc-footer></hdfc-footer></div>");
$templateCache.put("app/distributor/profile/profile.html","<section class=\"main-section distributor-profile\" ng-init=DistributorProfile.init()><div class=content-header><h5 class=text-uppercase>Distributor Profile</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard</a></li><li><span class=breadcrumb-icon></span></li><li>My Profile</li></ul></div><div class=container-fluid><div class=row><div class=col-md-8><div class=\"row distributor-nominee\"><div class=\"col-md-3 nominee-pic\"><div class=distributor-img><img http-src={{DistributorProfile.profileData.profileImageUrl}} ng-if=DistributorProfile.profileData.profileImageUrl><!--<i class=\"profile-top-icon {{DistributorProfile.profileData.upperCrustPoints.awarded.toLowerCase().trim().replace(\' \',\'-\')}}\"></i>--> <i class=close-icon ng-click=\"DistributorProfile.deleteLogoAndProfileImage(\'PROFILE_PHOTO\')\"></i><div class=\"camera cursor-pointer\"><input type=file accept=.jpeg,.jpg,.png file-model-profile=DistributorProfile.profileImage upload=DistributorProfile.uploadProfileImage(file) id=camera-click><label for=camera-click class=camera-label></label><i class=camera-icon></i> <span class=text>Update your photo</span></div></div><div class=distributor-logo><i class=\"close-icon logoCloseIcon\" ng-click=\"DistributorProfile.deleteLogoAndProfileImage(\'LOGO\')\"></i> <img http-src={{DistributorProfile.profileData.companyImageUrl}} ng-if=DistributorProfile.profileData.companyImageUrl><div class=\"camera cursor-pointer\"><input type=file accept=.jpeg,.jpg,.png file-model-profile=DistributorProfile.logoImage upload=DistributorProfile.uploadLogoImage(file) id=camera-click-logo><label for=camera-click-logo class=camera-label>Update Logo</label><i class=camera-icon></i></div></div></div><div class=\"col-md-8 nominee-info\"><h3>{{DistributorProfile.profileData.kydInformation.name}}</h3><!--<p class=\"text-uppercase\">Upper Crust Points</p>\n            <p class=\"num\">\n              {{DistributorProfile.profileData.upperCrustPoints.totalPoints}}</p>\n            (<span >as on {{DistributorProfile.profileData.upperCrustPoints.tillDate}} </span>\n            <span ng-hide=\"DistributorProfile.profileData.upperCrustPoints.awarded.toUpperCase().trim() == \'NOT QUALIFIED\'\">and awarded as\n                {{DistributorProfile.profileData.upperCrustPoints.awarded}}</span>)--><!-- <a ng-click=\"DistributorProfile.redirectToUppercrust()\" style=\"cursor:pointer;\">View Details</a>--><table class=\"table borderless\"><tr><td>Nominee Name:</td><td easyassist-key=mask-element ng-if=DistributorProfile.profileData.nominee.name ng-bind=DistributorProfile.profileData.nominee.name></td><td ng-if=!DistributorProfile.profileData.nominee.name>NA</td></tr><tr><td>Nominee Relationship:</td><td easyassist-key=mask-element ng-bind=DistributorProfile.profileData.nominee.relationship ng-if=DistributorProfile.profileData.nominee.relationship></td><td ng-if=!DistributorProfile.profileData.nominee.relationship>NA</td></tr><tr><td>Nominee DOB:</td><td easyassist-key=mask-element ng-bind=DistributorProfile.profileData.nominee.dob ng-if=DistributorProfile.profileData.nominee.dob></td><td ng-if=!DistributorProfile.profileData.nominee.dob>NA</td></tr></table><div class=edit-nominee><!--<span ng-click=\"DistributorProfile.editNominee()\">\n              <i class=\"edit2-icon\"></i>\n              <span class=\"text-blue cursor-pointer\">Edit Nominee</span>\n            </span>--> <span ng-click=DistributorProfile.changePassword();><i class=password-icon></i> <span class=\"text-blue cursor-pointer\">Change Password</span></span></div></div></div><div class=\"row distributor-nominee\" ng-if=DistributorProfile.profileData.kydInformation.mobileNumber><div class=subscribe-toggle><p class=\"strong pull-left marketing-label marketing-padding marketing-heading\">Marketing SMS Communication:</p><ul class=subscribe-toggle-panel><li><span class=toggle-login-text>Unsubscribe</span></li><li class=align-toggle><div class=login-form-switch><label class=switch-toggle-slider><input type=checkbox ng-model=DistributorProfile.subscribedToggleFlag ng-click=DistributorProfile.toggleMarketing() class=\"box checkbox-slide\" title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text>Subscribe</span></li></ul><p class=\"marketing-padding marketing-label note-align\">(Note: Change in subscription may take up to 5 working days to take effect)</p></div></div><div class=\"row distributor-nominee mb-4\"><div class=marketing-padding><h3 class=\"rm-heading mb-2\" style=\"text-decoration: underline;font-size: 1.1em !important\">Relationship Manager Information</h3><div class=\"rm-padding mb-2\"><p class=rm-heading ng-if=\"DistributorProfile.rmVrmDetails && (DistributorProfile.rmVrmDetails.vrmName || DistributorProfile.rmVrmDetails.vrmEmail || DistributorProfile.rmVrmDetails.vrmPhnNo)\">EDGE Relationship Manager</p><p class=rm-subtext ng-if=DistributorProfile.rmVrmDetails.vrmName>{{DistributorProfile.rmVrmDetails.vrmName}}</p><p class=rm-subtext ng-if=DistributorProfile.rmVrmDetails.vrmEmail><a href=mailto:{{DistributorProfile.rmVrmDetails.vrmEmail}} class=rm-subtext style=\"text-decoration: underline !important\">{{DistributorProfile.rmVrmDetails.vrmEmail}}</a></p><p class=rm-subtext ng-if=DistributorProfile.rmVrmDetails.vrmPhnNo>{{DistributorProfile.rmVrmDetails.vrmPhnNo}}</p></div><div class=\"rm-padding mb-2\"><p class=rm-heading ng-if=\"DistributorProfile.rmVrmDetails && (DistributorProfile.rmVrmDetails.rmName || DistributorProfile.rmVrmDetails.emailId)\">Branch Relationship Manager</p><p class=rm-subtext ng-if=DistributorProfile.rmVrmDetails.rmName>{{DistributorProfile.rmVrmDetails.rmName}}</p><p class=rm-subtext ng-if=DistributorProfile.rmVrmDetails.emailId><a href=mailto:{{DistributorProfile.rmVrmDetails.emailId}} class=rm-subtext style=\"text-decoration: underline !important\">{{DistributorProfile.rmVrmDetails.emailId}}</a></p></div><div class=\"rm-padding mb-2 mappedsection\"><p ng-if=\"DistributorProfile.rmVrmDetails && DistributorProfile.rmVrmDetails.businessCenter\"><span class=rm-heading>Mapped Branch </span><span class=rm-subtext>{{DistributorProfile.rmVrmDetails.businessCenter}}</span></p><p><span class=rm-heading>Contact Us </span><span class=rm-subtext>1800-267-9944</span></p></div></div></div></div><div class=\"col-md-4 distributor-info\"><div class=kyd-information><p>KYD INFORMATION</p><table class=\"table borderless\"><tr><td>Name :</td><td>{{DistributorProfile.profileData.kydInformation.name?DistributorProfile.profileData.kydInformation.name:\'NA\'}}</td></tr><tr><td>ARN :</td><td>{{DistributorProfile.profileData.kydInformation.arnCode?DistributorProfile.profileData.kydInformation.arnCode:\'NA\'}}</td></tr><tr><td>ARN Validity :</td><td ng-if=\"DistributorProfile.profileData.kydInformation.validStartDate || DistributorProfile.profileData.kydInformation.validEndDate\">{{DistributorProfile.profileData.kydInformation.validStartDate}} to {{DistributorProfile.profileData.kydInformation.validEndDate}}</td><td ng-if=\"!DistributorProfile.profileData.kydInformation.validStartDate && !DistributorProfile.profileData.kydInformation.validEndDate\">NA</td></tr><tr><td>PAN :</td><td easyassist-key=mask-element ng-bind=DistributorProfile.profileData.kydInformation.panNumber ng-if=DistributorProfile.profileData.kydInformation.panNumber></td><td ng-if=!DistributorProfile.profileData.kydInformation.panNumber>NA</td></tr><tr><td>Mobile :</td><td easyassist-key=mask-element ng-bind=\"DistributorProfile.profileData.kydInformation.mobileNumber \" ng-if=DistributorProfile.profileData.kydInformation.mobileNumber></td><td ng-if=!DistributorProfile.profileData.kydInformation.mobileNumber>NA</td></tr><tr><td>Email ID :</td><td easyassist-key=mask-element ng-bind=DistributorProfile.profileData.kydInformation.email ng-if=DistributorProfile.profileData.kydInformation.email></td><td ng-if=!DistributorProfile.profileData.kydInformation.email>NA</td></tr><tr><td>KYD Status :</td><td ng-if=DistributorProfile.profileData.kydInformation.kydStatus>Done <i class=verified-icon></i></td></tr></table></div><div class=bank-details><div><p>BANK DETAILS</p><a class=update-text ng-click=DistributorProfile.updateDistributorBank()>Update</a></div><table class=\"table borderless\"><tr><td>Account Type :</td><td>{{DistributorProfile.profileData.bankDetails.accountType?DistributorProfile.profileData.bankDetails.accountType:\'NA\'}}</td></tr><tr><td>Account Number :</td><td easyassist-key=mask-element ng-bind=DistributorProfile.profileData.bankDetails.accountNumber ng-if=DistributorProfile.profileData.bankDetails.accountNumber></td><td ng-if=!DistributorProfile.profileData.bankDetails.accountNumber>NA</td></tr><tr><td>IFSC Code :</td><td>{{DistributorProfile.profileData.bankDetails.ifsccode?DistributorProfile.profileData.bankDetails.ifsccode:\'NA\'}}</td></tr><tr><td>Bank Name :</td><td>{{DistributorProfile.profileData.bankDetails.bankName?DistributorProfile.profileData.bankDetails.bankName:\'NA\'}}</td></tr><tr><td>Branch Location :</td><td>{{DistributorProfile.profileData.bankDetails.branchLocation?DistributorProfile.profileData.bankDetails.branchLocation:\'NA\'}}</td></tr><tr><td>Brokerage Payout :</td><td>{{DistributorProfile.profileData.bankDetails.brokeragePayout?DistributorProfile.profileData.bankDetails.brokeragePayout:\'NA\'}}</td></tr></table></div></div></div></div></section><style>.mb-2{\n    margin-bottom: 5px;\n  }\n  .mb-4{\n    margin-bottom: 10px;\n  }\n  .rm-subtext{\n    font-size:1em !important;\n    padding: 3px 0px;\n  }\n  .rm-heading{\n    padding: 9px 0px 0px 0px;\n    font-size:1em;\n    color:#103880;\n    font-weight: 700;\n  }\n  .mappedsection p{\n   padding: 9px 0px;\n  }</style>");
$templateCache.put("app/distributor/uppercrust/uppercrust.html","<section class=\"main-section uppercrust\"><div class=content-header><h5 class=text-uppercase>Uppercrust</h5></div><div class=content-body><div class=\"gross-sales-container marginTop-10\"><div class=row><div class=\"col-sm-12 marginBottom-10\"><span class=heading>Gross Sales</span> <span class=\"pull-right as-on-date\">As on: <span>{{Uppercrust.uppercrustData.asOnDate}}</span></span></div></div><div class=row><div class=\"table-combined marginLeft-15\"><div class=col-75-width><div class=\"sales-table table-responsive\"><table class=\"table table-customise category-wise-sales-and-points\"><thead><tr><th class=right-border colspan=2><a href=\"/schemeListingByCategory/v1/list?schemeCategory=A\" target=_blank>Scheme Category A</a></th><th class=right-border colspan=2><a href=\"/schemeListingByCategory/v1/list?schemeCategory=B\" target=_blank>Scheme Category B</a></th><th colspan=2><a href=\"/schemeListingByCategory/v1/list?schemeCategory=C\" target=_blank>Scheme Category C</a></th></tr></thead><tbody><tr><td>Online Gross Sales</td><td class=right-border>Points</td><td>Online Gross Sales</td><td class=right-border>Points</td><td>Online Gross Sales</td><td>Points</td></tr><tr><td class=numeric-value>{{Uppercrust.uppercrustData.categoryA.onlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=\"numeric-value right-border\">{{Uppercrust.uppercrustData.categoryA.onlinePoints}}</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryA.onlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=\"numeric-value right-border\">{{Uppercrust.uppercrustData.categoryB.onlinePoints}}</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryC.onlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryC.onlinePoints}}</td></tr><tr><td>Offline Gross Sales</td><td class=right-border>Points</td><td>Offline Gross Sales</td><td class=right-border>Points</td><td>Offline Gross Sales</td><td>Points</td></tr><tr><td class=numeric-value>{{Uppercrust.uppercrustData.categoryA.offlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=\"numeric-value right-border\">{{Uppercrust.uppercrustData.categoryA.offlinePoints}}</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryB.offlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=\"numeric-value right-border\">{{Uppercrust.uppercrustData.categoryB.offlinePoints}}</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryC.offlineGrossSale|valueByUnit:\'Crore\':2}} Cr.</td><td class=numeric-value>{{Uppercrust.uppercrustData.categoryC.offlinePoints}}</td></tr></tbody></table></div></div><div class=col-25-width><div class=\"total-gross-table table-responsive\"><table class=\"table table-customise2\"><tbody><tr><td>Total Gross Sales</td></tr><tr><td class=\"numeric-value padTop-0\">{{Uppercrust.uppercrustData.totalGrossSales|valueByUnit:\'Crore\':2}} Cr.</td></tr><tr><td class=padTop-20>CAT A,B,C Points</td></tr><tr><td class=\"numeric-value padTop-0 padBot-28\">{{Uppercrust.uppercrustData.totalCatABCPoints}}</td></tr></tbody></table></div></div></div><div class=\"right-side-box marginLeft-25\"><div class=\"category-d table-responsive\"><table class=\"table table-customise3 category-wise-sales-and-points\"><thead><tr><th><a href=\"/schemeListingByCategory/v1/list?schemeCategory=D\" target=_blank>Category D</a><br><span class=heading-subtext>( IAAUM : Mar 17 vs FY17-18 )</span></th></tr></thead><tbody><tr><td>{{Uppercrust.uppercrustData.categoryDAAUM|valueByUnit:\'Crore\':2}} Cr.</td></tr></tbody><thead><tr><th><a href=\"/schemeListingByCategory/v1/list?schemeCategory=D\" target=_blank>Category D</a></th></tr></thead><tbody><tr><td>{{Uppercrust.uppercrustData.categoryDPoints}}</td></tr></tbody></table></div></div></div></div><div class=\"aum-points-wrapper marginTop-20\"><div class=row><div class=\"col-sm-12 marginBottom-10\"><span class=heading>AUM Points</span> <span class=date-field>(Based On: 31-Mar-2017)</span></div></div><div class=row><div class=\"aum-table-box table-responsive marginLeft-15\"><table class=\"table table-aum-customise\"><thead><tr><th>Equity AUM</th><th>Equity AUM Points</th><th>LTD AUM</th><th>LTD AUM Points</th><th>Total AUM Points</th><th>Equity Mkt Share<br>{{Uppercrust.uppercrustData.marketShareProcessMonth?\'(\'+Uppercrust.uppercrustData.marketShareProcessMonth+\')\':\"\"}} {{}}</th><th class=no-right-border>Points Based on Equity Mkt Share<br>&amp; weightage for the AUM</th></tr></thead><tbody><tr><td>{{Uppercrust.uppercrustData.equityAUM|valueByUnit:\'Crore\':2}} Cr.</td><td>{{Uppercrust.uppercrustData.equityAUMPoints}}</td><td>{{Uppercrust.uppercrustData.longTermDebtAUM|valueByUnit:\'Crore\':2}} Cr.</td><td>{{Uppercrust.uppercrustData.longTermDebtAUMPoints}}</td><td>{{Uppercrust.uppercrustData.totalAUMPoints}}</td><td>{{Uppercrust.uppercrustData.equityMarketShare}}%</td><td class=no-right-border>{{Uppercrust.uppercrustData.pointsBasedOnEquityMktShareAndWeightageForAUM}}</td></tr></tbody></table></div><div class=\"right-side-box-aum-points marginLeft-25\"><div class=\"category-d table-responsive\"><table class=\"table table-aum-customise2\"><thead><tr><th>Total Points</th></tr></thead><tbody><tr><td>{{Uppercrust.uppercrustData.totalPoints}}</td></tr></tbody><thead><tr><th class=award-text>Awarded based on Points</th></tr></thead><tbody><tr><td class=bold-black ng-bind=Uppercrust.uppercrustData.awardedBasedOnPoints></td></tr></tbody></table></div></div></div></div><div class=\"aum-points-wrapper2 marginTop-20\"><div class=row><div class=\"single-table-row marginLeft-15 marginRight-15\"><table class=\"table single-table-customise\"><thead><tr><th>Minimum Gross Sales Market Share</th><th>Awarded<br><span>(After Gross Sales Market Share Criteria)</span></th><th>Net Sales for CAT A B C</th><th>Net Sales %</th><th class=no-border-right>Qualification Criteria<br><span>Net Sales to Gross Sales Ratio of &gt;={{Uppercrust.uppercrustData.qualificationCriteria}}%</span></th></tr></thead><tbody><tr><td>{{Uppercrust.uppercrustData.minimumGrossSalesMarketShare}}%</td><td>{{Uppercrust.uppercrustData.finalAwarded}}</td><td>{{Uppercrust.uppercrustData.netSalesForCATABC|valueByUnit:\'Crore\':2}} Cr.</td><td>{{Uppercrust.uppercrustData.netSalesPercentage}}%</td><td class=no-border-right>{{Uppercrust.uppercrustData.qualificationCriteriaResult}}</td></tr></tbody></table></div></div></div><div class=row><div class=\"col-sm-offset-4 col-sm-4\"><div class=\"final-award-box marginTop-10\"><h3>Final Award</h3><span>After Net Sales &amp; Gross Sales Market Share Criteria</span><h2 ng-bind=Uppercrust.uppercrustData.finalAwarded>Not Qualified</h2><h6 class=guidelines>#As per prevailing AMFI guidelines.</h6></div></div></div></div></section>");
$templateCache.put("app/ecart/directives/all.funds.html","<div class=\"container-fluid all-funds\"><div class=row><div class=\"col-md-12 mobile-padding\"><form><div class=row><div class=col-md-12><div class=header-container><div class=row><div class=col-md-12><div class=search><input ng-disabled=\"allFundForm.regularDirectError !== null\" type=text ng-model=allFormData.searchModel ng-change=searchRecords() class=form-control placeholder=Search aria-label=Search aria-describedby=basic-addon2> <button class=btn-sm><img src=/assets/images/icons/icon-search-white.png></button></div></div></div><div class=row><div class=\"col-xs-8 col-md-6\"></div><div class=\"col-xs-4 col-md-6\"><div class=\"filter-action pull-right\"><button class=btn-sm ng-click=openFilter() ng-disabled=allFundForm.regularDirectError><img src=/assets/images//filter-red.svg> Filter</button></div></div><div class=\"col-xs-12 col-md-10\"><span class=bank-error-msg>{{allFundForm.regularDirectError}}</span></div></div></div></div></div><div class=\"row middle-box\" ng-if=\"!funds || funds.length == 0\">No Data Found</div><div class=row ng-repeat=\"fund in funds track by $index\"><div class=col-md-12><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-header><div class=row><div class=col-md-12><div class=investment-details>{{fund.fundName}}</div></div></div></div><div class=card-body><div class=row><div class=col-md-12><div class=fund-details><div class=blue ng-if=\"fund.fundCategory.length > 0 && fund.fundCategory[0] !=\'\'\">{{fund.fundCategory[0]}}</div><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low risk\' || fund.riskReturnProfile == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low to Moderate Risk\'|| fund.riskReturnProfile == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderate Risk\' || fund.riskReturnProfile == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderately High Risk\' || fund.riskReturnProfile == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'High Risk\' || fund.riskReturnProfile == \'High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Very High Risk\' || fund.riskReturnProfile == \'Very High Risk\'\"><div class=blue>{{fund.riskReturnProfile[0]}}</div></div><div class=\"blue-background white\" ng-if=fund.investorInvested>{{fund.investorInvested}}</div></div></div></div><div class=row><div class=\"col-xs-8 col-md-8\"><div class=investment-label ng-if=allFundForm.isRegular>NAV <span ng-if=fund.fundNavRegular.nav_date[11]>as on {{fund.fundNavRegular.nav_date[11]}}</span></div><div class=investment-label ng-if=!allFundForm.isRegular>NAV <span ng-if=fund.fundNavDirect.nav_date[11]>as on {{fund.fundNavDirect.nav_date[11]}}</span></div></div><div class=\"col-xs-4 col-md-4\"><div class=\"nav-amount pull-right\" ng-if=allFundForm.isRegular>&#8377{{fund.fundNavRegular.nav_amount[11] ? utilService.getCommaSeperatedWithFloatValue(fund.fundNavRegular.nav_amount[11],4): 0}}</div><div class=\"nav-amount pull-right\" ng-if=!allFundForm.isRegular>&#8377{{fund.fundNavDirect.nav_amount ? utilService.getCommaSeperatedWithFloatValue(fund.fundNavDirect.nav_amount[11],4): 0}}</div></div></div><!--                      <hr>--><!--                      <div class=\"row\" ng-if=\"allFundForm.isRegular && fund.regularCagrReturns.length > 0\">--><!--                        <div class=\"col-xs-8 col-md-8\">--><!--                          <div class=\"row\">--><!--                            <div class=\"col-xs-3 col-md-3\">--><!--                              <div class=\"investment-label\">--><!--                                CAGR--><!--                              </div>--><!--                            </div>--><!--                            <div class=\"col-xs-9 col-md-8\">--><!--                              <div class=\"cagr-select\">--><!--                                <select--><!--                                  class=\"custom-select\"--><!--                                  id=\"regular-{{$index}}\"--><!--                                  tooltip-placement=\"top\" uib-tooltip=\"{{fund.selectedYear}}\"--><!--                                  ng-model = \"fund.selectedYear\"--><!--                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.regularCagrReturns\"--><!--                                  ng-change=\"displayCagrValue(fund)\"--><!--                                ></select>--><!--                              </div>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                        <div class=\"col-xs-4 col-md-4\">--><!--                          <div class=\"cagr-percent pull-right\">--><!--                            {{fund.regularCagr}}%--><!--                          </div>--><!--                        </div>--><!--                      </div>--><!--                      <div class=\"row\" ng-if=\"!allFundForm.isRegular && fund.directCagrReturns.length > 0\">--><!--                        <div class=\"col-xs-8 col-md-8\">--><!--                          <div class=\"row\">--><!--                            <div class=\"col-xs-3 col-md-3\">--><!--                              <div class=\"investment-label\">--><!--                                CAGR--><!--                              </div>--><!--                            </div>--><!--                            <div class=\"col-xs-9 col-md-8\">--><!--                              <div class=\"cagr-select\">--><!--                                <select--><!--                                  class=\"custom-select\"--><!--                                  id=\"direct-{{$index}}\"--><!--                                  tooltip-placement=\"top\" uib-tooltip=\"{{fund.selectedYear}}\"--><!--                                  ng-model = \"fund.selectedYear\"--><!--                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.directCagrReturns\"--><!--                                  ng-change=\"displayCagrValue(fund)\"--><!--                                ></select>--><!--                              </div>--><!--                            </div>--><!--                          </div>--><!--                        </div>--><!--                        <div class=\"col-xs-4 col-md-4\">--><!--                          <div class=\"cagr-percent pull-right\">--><!--                            {{fund.directCagr}}%--><!--                          </div>--><!--                        </div>--><!--                      </div>--></div><div class=card-footer><div class=row><div class=col-md-12><div class=card-action><!--<button class=\"btn btn-secondary\">Details</button>--> <button class=\"btn btn-primary\" ng-click=moveToCartDetails(fund)>Add to cart</button></div></div></div></div></div></div></div></div></div></div></form></div></div></div><div class=\"row filter-row\"><div class=col-md-12><div class=row><div class=\"col-xs-3 col-md-4 height100 backdrop\"></div><div class=\"col-xs-9 col-md-8 height100 content-col\"><section class=\"sidebar-content-section height100\"><div class=\"row height100\"><div class=col-md-12><div class=row><div class=col-md-12><div class=filter-header><h1>Filters</h1><a class=cancel-cta ng-click=openFilter()><i class=times-icon></i></a></div></div></div><div class=\"row filter-scroll\"><div class=col-md-12><div ng-repeat=\"filter in filterList\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><uib-accordion-heading>{{filter.filterName}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><div class=checkbox ng-repeat=\"option in filter.filterOptions\"><input ng-model=option.checked type=checkbox ng-change=\"filterFunds(filter.filterKey, filter.filterOptions)\"> <i class=icon-checkbox></i><div class=option-name>{{option.key}}</div></div></div></uib-accordion></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/ecart/directives/cart-details.html","<div class=\"container-fluid cart-details-container\"><div class=row><div class=col-md-12><label class=label-black>You’re investing in {{fundName}}</label></div></div><div class=row><div class=col-md-12><form name=tform><div class=row><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><input type=text name=sInScheme1 id=sInScheme1 ng-change=filterInSchemeList() ng-model=formData.schemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required><label>Select a Plan Option</label><span class=error-input ng-show=\"tForm.sInScheme1.$dirty && tForm.sInScheme1.$error.required\" ng-bind=VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=inSchemeList display-key=schemeName hdfc-click=inSchemeChanged(data) model=formData.schemeCode for=sInScheme1></drop-down><!--<select class=\"custom-select select-scheme-list\" name=\"sInScheme1\" id=\"sInScheme1\"\n                        ng-model=\"formData.schemeName\"\n                        ng-change=\"changeSelectedScheme()\"\n                        ng-options=\"scheme.schemeName as scheme.schemeName for scheme in inSchemeList\">\n                  <option value=\"\">Select a Plan Option</option>\n                </select>--></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.isDividend\"><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><input type=text id=investment name=investment ng-model=formData.investmentOptionName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required><label>Select IDCW Option</label><span class=error-input ng-show=\"tForm.investment.$dirty && tForm.investment.$error.required\" ng-bind=VALIDATE_DATA.INVESTMENT_OPTIONS_REQUIRED></span><drop-down list-data=investmentOptions display-key=key hdfc-click=changeInvestmentOptions(data) model=formData.dividendOption for=investment></drop-down></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\'\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">Purchase Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-click=\"removeTransactionFromList(\'PURCHASE\')\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' ) && (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount class=input-border maxlength=16 ng-maxlength=16 placeholder=₹ ng-model=formData.displayAmount ng-change=\"changeInstallmentAmount(\'PURCHASE\')\" required><!--                          <span class=\"field-info\"> Minimum amount should be {{purchaseMinAmount}} </span>--><div><span ng-if=\"formData.amount && isPurchaseMin\" class=\"error-input purchase-amount-error\">Minimum amount should be {{purchaseMinAmount}} </span><span ng-if=\"formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{ purchaseValidation.purchaseMultiple|decimalFilter}}<span ng-if=\"formData.amount % 1 != 0\">,</span> </span><span ng-if=\"formData.amount % 1 != 0\" class=\"error-input purchase-amount-error\" ng-class=\"{errorDown: formData.amount && isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in purchaseValidation.amountArray\" ng-click=\"formData.displayAmount=amount; changeInstallmentAmount(\'PURCHASE\')\"><img src=../../assets/images/icons/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">SIP Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-click=\"removeTransactionFromList(\'SIP\')\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' )&& (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount class=input-border placeholder=₹ ng-model=formData.installmentDisplayAmount ng-change=\"changeInstallmentAmount(\'SIP\',true)\" required><!--                          <span class=\"field-info\"> Minimum amount should be {{sipValidation.monMinAmt}} </span>--><div><span ng-if=\"formData.installmentAmount && isMin\" class=error-input>Minimum amount should be &#8377; {{validations.minAmount}} </span><span ng-if=\"formData.installmentAmount && isMax\" class=error-input>Maximum amount should be &#8377; {{Transaction.validations.maxAmount}}</span> <span ng-if=\"formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{validations.amountMultiples|decimalFilter}} </span><span ng-show=\"formData.installmentAmount && amountExceeded\" class=error-input ng-bind=VALIDATE_DATA.AMOUNT_EXCEEDED></span></div><div class=fi-consent ng-if=sipWithFi><div class=checkbox><input ng-model=Summary.isCheckedTandC type=checkbox> <i class=checkmark></i> <span class=checkbox-text>Wish to pay First installment with your SIP Registration</span></div></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in sipValidation.amountArray\" ng-click=\"formData.installmentDisplayAmount=amount; changeInstallmentAmount(\'SIP\',true)\"><img src=../../assets/images/icons/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div><div class=\"row increase-padding\"><div class=col-md-12><div class=input-field-card><div class=input-normal><label>SIP Start Date (SIP Frequency - Monthly)</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.startDate.$dirty && tForm.startDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-format={{startDateFormat}} data-date-default=formData.startDate data-enabled-dates=enabledStartDates data-min-date=startMinDateBiller data-max-date=startMaxDate data-on-date-change=changeStartDate data-view-date=enabledStartDates[0] data-enable=true style=\"position: relative\"><input id=startDateId type=text name=startDate placeholder=\"SIP Start Date - DD-MMM-YYYY\" ng-keyup=\"autoDate(\'startDate\')\" required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><div class=start-date-error><span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span></div></div></div></div><div class=row><div class=col-md-12><div class=input-field-card><div class=input-normal><label>SIP End Date</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.endDate.$dirty && tForm.endDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-format={{startDateFormat}} data-date-default=formData.endDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-view-date=enabledEndDateView data-min-date=enabledEndDates[0] data-enable=true id=endDate showdefault=false><input id=endDateId type=text name=endDate placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-keyup=\"autoDate(\'endDate\')\" ng-blur=checkEnableEndDate() required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><span class=error-input ng-if=\"!isEndDateFound && formData.endDate\">Invalid Date</span></div><div class=fi-consent><div class=\"checkbox dis-flex checkbox-width\" ng-class=\"{\'anything-disabled\': !formData.startDate || !enabledDefaultYear}\"><input ng-model=formData.isTillPerpetuity ng-change=changeTillPerpetuity() type=checkbox ng-disabled=\"!formData.startDate || !enabledDefaultYear\"> <i class=checkmark></i> <span class=checkbox-text>Default to Year, 2099</span></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"!formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\'\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'PURCHASE\');\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add Purchase Transaction</div></a></div></div><div class=row ng-if=\"!formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'SIP\');\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add SIP Transaction</div></a></div></div><div class=row ng-if=\"isExceedingEmandateDate && formData.sipOpted\"><div class=\"col-xs-12 npciNote\"><!--dynamic note for emandate Ristriction--><ng-bind-html dynamic=NPCINote></ng-bind-html></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=sidebarOrReviewAddToCart() ng-if=\"(showAddCart && !fromInitiateCart) || fromEquityAsset\">Add to Cart</button> <button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=sidebarOrReviewSaveCartEdited() ng-if=\"!showAddCart && !fromInitiateCart\">Save</button> <button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=\"updateSideBar(\'Cart\');scrollToTop();\" ng-if=\"fromInitiateCart && !fromEquityAsset\">Initiate Cart</button></div></div></form></div></div></div>");
$templateCache.put("app/ecart/directives/ecart.details.html","<div class=\"container-fluid ecart-details\"><div class=row><div class=\"col-md-12 mobile-padding\"><form style=\"margin-top: 0px\"><div class=row ng-repeat=\"investment in cartDetails.cartItems track by $index\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-7 col-md-8\"><span class=\"review-table-data blue\">{{investmentArray[$index]}} Investment</span></div><div class=\"col-xs-5 col-md-4\"><div class=section-action><a class=\"red link-action link-action-edit\" ng-click=\"editTransactionFromCart(\'CART_DETAILS\',investment)\">Edit</a> <a class=\"red link-action\" ng-click=removeTransactionFromCart(investment)>Remove</a></div></div></div><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=\"col-xs-8 col-md-12\"><div class=investment-label>Scheme Name</div><div class=investment-details>{{investment.schemeName}}</div></div><!--                        <div class=\"col-xs-4 col-md-6\">--><!--                          <div class=\"investment-label\">--><!--                            CAGR--><!--                          </div>--><!--                          <div class=\"investment-details\">--><!--                            {{investment.CAGR}}%--><!--                          </div>--><!--                        </div>--></div><hr><div class=row><div class=\"col-xs-6 col-md-6\"><div class=investment-label>Investment Type</div><div class=investment-details><!--                            {{investment.investmentType}}--> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.sipOpted && investment.purchaseOpted\">SIP + Purchase</span> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.sipOpted && !investment.purchaseOpted\">SIP</span> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.purchaseOpted && !investment.sipOpted\">Purchase</span></div></div><div class=\"col-xs-6 col-md-6 amount-label\"><div class=investment-label>Amount</div><div class=investment-details tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.installmentAmount)}}\" ng-if=\"investment.sipOpted && !investment.purchaseOpted\">{{\'₹\' + utilService.getCommaSeperatedString(investment.installmentAmount)}}</div><div class=investment-details tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.amount)}}\" ng-if=\"investment.purchaseOpted && !investment.sipOpted\">{{\'₹\' + utilService.getCommaSeperatedString(investment.amount)}}</div><div class=investment-details tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.amount + investment.installmentAmount)}}\" ng-if=\"investment.sipOpted && investment.purchaseOpted\">{{\'₹\' + utilService.getCommaSeperatedString((investment.amount + investment.installmentAmount))}}</div></div></div></div></div></div></div></div></div></div><div class=row ng-repeat=\"suggestion in showingTrendingFunds track by $index\" ng-if=\"!cartDetails.cartItems || cartDetails.cartItems.length < 3\"><div class=col-md-12><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=col-md-12><div class=suggestion-label ng-click=addTrendingFund(suggestion)>Would you like to add <i class=red>{{suggestion.fundName}}</i> to your cart?</div></div></div><hr><div class=row><div class=\"col-xs-12 col-md-12\"><div class=\"row display-flex riskometer\"><!--                            <div class=\"col-xs-6 col-md-6\">--><!--                              <div class=\"investment-label\">--><!--                                CAGR--><!--                              </div>--><!--                              <div class=\"investment-details\">--><!--                                {{suggestion.cagrValue}}%--><!--                              </div>--><!--                            </div>--><!--                            <div class=\"col-xs-6 col-md-6\">--><!--                              <div class=\"cagr-select\">--><!--                                <select--><!--                                  name=\"cagr-{{$index}}\"--><!--                                  class=\"custom-select\"--><!--                                  ng-model = \"formData.yearSelected[$index]\"--><!--                                  ng-options=\"key as (key == \'11\'? \'Since Inception\' :key == \'1\'? key + \' \' +\'Year\': key + \' \' +\'Years\') for (key,value) in suggestion.annualisedReturns\"--><!--                                  ng-change=\"showCagrValue($index)\"--><!--                                  ng-init=\"formData.yearSelected = formData.yearSelected? formData.yearSelected: null\"--><!--                                ></select>--><!--                              </div>--><!--                            </div>--><div class=\"col-xs-6 col-md-12\"><div class=investment-label>Risk Rating</div><div class=investment-details><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Low risk\' || suggestion.riskReturnProfile == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Low to Moderate Risk\'|| suggestion.riskReturnProfile == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Moderate Risk\' || suggestion.riskReturnProfile == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Moderately High Risk\' || suggestion.riskReturnProfile == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'High Risk\' || suggestion.riskReturnProfile == \'High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Very High Risk\' || suggestion.riskReturnProfile == \'Very High Risk\'\"><div class=blue>{{suggestion.riskReturnProfile}}</div></div><div class=\"blue-background white\" ng-if=suggestion.investorInvested>{{suggestion.investorInvested}}</div></div></div></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"!cartDetails.cartItems || cartDetails.cartItems.length < maximumItemAllowed\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-12 col-md-12\"><div class=card><div class=row><div class=col-md-12><div class=addmore-fund-section><a class=\"available-transactions link-action\" ng-click=\"setSideBarState(\'ALL_FUNDS\')\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label black\">Add More Funds</div></a><div class=sub-heading>You can add maximum {{ maximumItemAllowed | number2words}}items to the cart</div></div></div></div></div></div></div></div></div></div><div class=row><div class=\"col-md-12 text-center\"><div class=action-container><button class=btn-primary ng-click=\"updateSideBar(\'Cart\');scrollToTop();\" ng-disabled=\"!cartDetails.cartItems || cartDetails.cartItems.length == 0\">Initiate Cart</button></div></div></div></form></div></div></div>");
$templateCache.put("app/ecart/directives/invest-through.html","<div class=\"container-fluid invest-through-container\"><div class=row><div class=\"col-md-12 mobile-padding\"><form name=tForm novalidate autocomplete=off><div class=row><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isDirect ng-click=\"changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughDistributor ng-click=\"changeThroughDistributor(\'DISTRIBUTOR\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughRia ng-click=\"changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>ARN</label><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=investThroughFormData.brokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ > <span class=highlight></span> <span class=bar></span><p ng-if=investThroughFormData.brokerName class=info-primary>Distributor Name: {{investThroughFormData.brokerName}}</p><span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid &&tForm.brokerCode.$error.required) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid && tForm.brokerCode.$error.pattern) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"brokerCodeError !== \'\' && !tForm.brokerCode.$invalid\" ng-bind=brokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-md-12 text-center\"><label class=label-black>OR</label></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.distributorName.$dirty&&tForm.distributorName.$invalid)}><label>Search Distributor</label><input type=text name=distributorName id=distributorName ng-model=investThroughFormData.distributorName ng-change=searchDistributorByName() autocomplete=off ng-required=!investThroughFormData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><drop-down list-data=distributorList display-key=name display-key-second=arnCode hdfc-click=distributorListChanged(data) model=investThroughFormData.distributorARN for=distributorName></drop-down></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.subBrokerARN.$dirty&&tForm.subBrokerARN.$invalid)}><label>Search Broker ARN</label><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=investThroughFormData.subBrokerARN ng-change=changeSubBrokerArn() ng-blur=fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><p ng-if=subBrokerName class=info-primary>Sub Broker Name: {{subBrokerName}}</p><span class=error-input ng-show=\"(tForm.subBrokerARN.$dirty && tForm.subBrokerARN.$invalid && tForm.subBrokerARN.$error.pattern)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"subBrokerCodeError != \'\'&& !tForm.subBrokerARN.$error.pattern\" ng-bind=subBrokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.brokerCode.$dirty&&tForm.brokerCode.$invalid)}><label>Sub Broker Code</label><input type=text name=subBrokerCode id=subBrokerCode ng-model=investThroughFormData.subBrokerCode autocomplete=off ng-disabled=\"!investThroughFormData.subBrokerARN || subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.subBrokerCode.$dirty&&tForm.subBrokerCode.$error.required ng-bind=VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.isCheckedTandC=false\" ng-init=\"isSelectedEuin = false;\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.euinNameCode=\'\';filterEuinList();isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></div></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === true && investThroughFormData.isThroughDistributor\"><div class=\"col-sm-12 col-md-9\"><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.euin.$dirty&&tForm.euin.$invalid}><label>Select Euin</label><input type=text name=euin id=euin ng-model=investThroughFormData.euinNameCode ng-change=filterEuinList() ng-required=\"(investThroughFormData.brokerCode || investThroughFormData.distributorName) && !investThroughFormData.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=(tForm.euin.$dirty&&tForm.euin.$error.required) ng-bind=VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=euinList display-key=euinName display-key-second=euinCode hdfc-click=selectEuin(data) model=investThroughFormData.euin for=euin></list-drop-down></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === false && investThroughFormData.isThroughDistributor\" ng-hide=!distributorMessage><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=investThroughFormData.isEuin ng-required=\"(investThroughFormData.brokerCode || !isArnSuccess) && !investThroughFormData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=distributorMessage.content></ng-bind-html></div></div></div><!------------------------- RIA section starts from here------------------><div class=row ng-if=investThroughFormData.isThroughRia><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>RIA Code</label><input type=text name=riaCode id=riaCode ng-model=investThroughFormData.riaBrokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span><p ng-if=\"investThroughFormData.riaBrokerCode && investThroughFormData.riaBrokerName\" class=info-primary>RIA Name: {{investThroughFormData.riaBrokerName}}</p><span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.required)\" ng-bind=VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.pattern)\" ng-bind=VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"riaCodeError !== \'\' && !tForm.riaCode.$invalid\" ng-bind=riaCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughRia><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=\"!investThroughFormData.riaBrokerCode || riaCodeError !== \'\'\" ng-change=setTandCVariable(); ng-required=investThroughFormData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=riaMessage.content></ng-bind-html></div></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-if=!investThroughFormData.isThroughDistributor ng-disabled=\"investThroughFormData.isThroughRia && (!investThroughFormData.riaBrokerCode || !investThroughFormData.isCheckedTandC)\" ng-click=updateCartViaInvestThrough()>Save</button> <button class=btn-primary ng-if=investThroughFormData.isThroughDistributor ng-disabled=\"(!investThroughFormData.brokerCode && !investThroughFormData.distributorName) || (investThroughFormData.isEuin && !investThroughFormData.euinNameCode)\n              || (!investThroughFormData.isEuin && !investThroughFormData.isCheckedTandC) || (investThroughFormData.isEuin === true && !isSelectedEuin)\" ng-click=updateCartViaInvestThrough()>Save</button></div></div></form></div></div></div>");
$templateCache.put("app/ecart/directives/sidebar.directive.html","<div class=\"col-sm-6 col-md-8 height100 backdrop\"></div><div class=\"col-sm-6 col-md-4 height100 content-col\" id=scrollTo ng-init=init()><section class=sidebar-content-section><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=header-section><a class=cancel-cta ng-click=collapse()><img src=assets/images/icons/cross-circle.svg alt=collapse></a><h3>{{sidebarTitle}}</h3></div><div class=body-section><div data-ng-switch=sidebarSection><div data-ng-switch-when=CART_DETAILS><div data-ng-include=\"\'app/ecart/directives/cart-details.html\'\"></div></div><div data-ng-switch-when=INVEST_THROUGH><div data-ng-include=\"\'app/ecart/directives/invest-through.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/ecart/directives/ecart.details.html\'\"></div></div><div data-ng-switch-when=ALL_FUNDS><div data-ng-include=\"\'app/ecart/directives/all.funds.html\'\"></div></div></div></div></div></div></div></div></section></div>");
$templateCache.put("app/ecart/review/ecart.review.html","<div class=\"main-section initiate\" id=initiate ng-class=\"{\'transaction-screens--agent\' : InitiateTransaction.loginType == \'A\'}\"><div class=head-with-investor-name><h2 class=heading-web><i class=red>E-Cart</i> Summary</h2><h2 class=heading-mobile><span class=red>E-</span><span>Cart</span></h2><p><i class=investor-name>For: {{EcartReview.investorInfo.name | camelcase}}</i></p></div><section class=\"initiate-transition sip-purchase\"><div class=post-login-ecart-journey><div class=\"content review-bg-color\"><form autocomplete=off class=select-sipPurchaseForm name=sipPurchaseForm novalidate><section class=\"sub-header folio-section-wrapper\"><div class=\"col-sm-12 col-md-8 folio-selection set-display-flex align-content\"><label class=label-black>Folio No : <span class=error-input>*</span></label><div class=folio-select><select class=custom-select name=folio id=_first ng-model=EcartReview.formData.folioNumber ng-change=EcartReview.changeFolio(true) ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in EcartReview.folioList\" ng-init=\"EcartReview.formData.folioNumber = EcartReview.formData.folioNumber ? EcartReview.formData.folioNumber: null\" required><option value=\"\">Select Folio</option></select><div class=error-input ng-if=\"EcartReview.folioList && EcartReview.folioList.length == 0\">No Folio Found.</div></div><span class=error-input style=\"margin-left: 0px\" ng-if=\"EcartReview.isInValidFolio && EcartReview.isChildScheme\" ng-bind=EcartReview.VALIDATE_DATA.CHILD_ADD_FUND></span> <span class=error-input style=\"margin-left: 0px\" ng-if=\"EcartReview.isInValidFolio && EcartReview.isRetirementScheme\" ng-bind=EcartReview.VALIDATE_DATA.RETIREMENT_ADD_FUND></span></div></section><section class=main-container><div class=\"folio-invest-through row\"><div class=\"col-md-12 folio-selection-container\"><div class=\"row set-display-flex\"><div class=\"col-sm-12 col-md-4 sub-broker-arn-wrapper\"><label class=label-black>Sub Broker ARN :</label><div class=input-normal ng-class={error:(tForm.subBrokerARN.$dirty&amp;&amp;tForm.subBrokerARN.$invalid)}><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=EcartReview.formData.subBrokerARN ng-change=EcartReview.changeSubBrokerArn() ng-blur=EcartReview.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><p ng-if=EcartReview.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{EcartReview.subBrokerName}}</p><span class=error-input ng-if=\"sipPurchaseForm.subBrokerARN.$dirty && sipPurchaseForm.subBrokerARN.$invalid && sipPurchaseForm.subBrokerARN.$error.pattern\">{{EcartReview.VALIDATE_DATA.BROKER_VALID}}</span> <span class=error-input ng-show=\"EcartReview.subBrokerCodeError != \'\'\" ng-bind=EcartReview.subBrokerCodeError></span></div></div><div class=\"col-sm-12 col-md-4 sub-broker-arn-wrapper\"><label class=label-black>Sub Broker Code :</label><div class=input-normal ng-class=\"{error:EcartReview.sipPurchaseForm.subBrokerCode.$dirty && EcartReview.sipPurchaseForm.subBrokerCode.$invalid}\"><input type=text name=subBrokerCode id=subBrokerCode ng-model=EcartReview.formData.subBrokerCode autocomplete=off ng-disabled=\"!EcartReview.formData.subBrokerARN || EcartReview.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"sipPurchaseForm.subBrokerCode.$dirty && sipPurchaseForm.subBrokerCode.$error.required\" ng-bind=EcartReview.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><div class=\"col-sm-12 col-md-4 folio-selection set-display-flex align-content\"><label class=label-black>EUIN : <span class=error-input>*</span></label><select class=custom-select name=folio id=_second ng-change=EcartReview.euinChanged() ng-model=EcartReview.formData.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in EcartReview.euinList\" required><option value=\"\" selected>Select EUIN</option></select></div></div><div class=row ng-if=EcartReview.formData.folioError><div class=\"col-sm-6 col-md-5\"><span class=bank-error-msg style=\"margin-bottom: 0px;margin-top: 5px;font-size: 14px;margin-left: 22%\">{{EcartReview.formData.folioError}}</span></div></div></div></div><hr><div class=review-section><div class=no-data ng-if=\"(EcartReview.cartItemList.length==0)\"><p class=strong style=\"text-align: center;font-size: 20px;padding: 2%\">No items added to your e-cart</p></div><!--review header--><div class=row ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row background-header-content-main background-blue\"><div class=col-md-6><span class=header-content>Scheme Name</span></div><div class=col-md-4><span class=header-content>Investment Type</span></div><div class=col-md-2><span class=header-content>Amount</span></div></div></div></div><!--review cards--><div class=\"row item-row\" ng-repeat=\"item in EcartReview.cartItemList track by $index\" ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row investement-type\"><div class=\"col-md-6 col-xs-7\"><span class=\"review-table-data blue\">{{EcartReview.investmentArray[$index]}} Investment</span></div><div class=col-md-4></div><div class=\"col-md-2 col-xs-5 edit-responsive\"><span class=\"edit-btn red\" ng-click=\"EcartReview.showPopupScreen(\'CART_DETAILS\', item)\">Edit</span> <span class=\"edit-btn red\" ng-click=EcartReview.removeCartItem(item)>Remove</span></div></div></div><div class=\"col-md-12 card-container\"><div class=\"row card-ui\"><div class=\"col-md-6 col-sm-10 col-xs-12\"><span class=responsive-title>Scheme Name</span> <span class=\"review-table-data black\">{{item.schemeName}}</span></div><div class=\"col-md-6 col-xs-12 col-sm-12\"><hr></div><div class=\"col-md-4 col-sm-9 col-xs-8\"><span class=responsive-title>Investment Type</span> <span class=\"review-table-data d-block black\" ng-if=item.sipOpted>SIP</span> <span class=\"review-table-data d-block black\" ng-if=item.purchaseOpted>Purchase</span></div><div class=\"col-md-2 col-sm-3 col-xs-4\"><span class=\"responsive-title amount\">Amount</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.installmentAmount)}}\" ng-if=item.sipOpted>{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.installmentAmount)}}</span> <span class=\"review-table-data d-block black amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.amount)}}\" ng-if=item.purchaseOpted>{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(item.amount)}}</span></div><!--error message for particular item--><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=item.errorExists><span class=bank-error-msg>{{item.message}}</span></div></div></div></div><!--review footer summary --><div class=row style=\"margin-top: 40px\" ng-if=\"EcartReview.cartItemList && EcartReview.cartItemList.length > 0\"><div class=col-md-12><div class=\"row background-header-content-secondary background-blue\"><div class=col-md-6><span class=header-content></span></div><div class=\"col-md-4 col-sm-9 col-xs-8\"><span class=header-content>Total Amount</span></div><div class=\"col-md-2 col-sm-3 col-xs-4\"><span class=\"header-content amount\" tooltip-placement=top-left uib-tooltip=\"{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(EcartReview.totalAmount)}}\">{{\'₹ \' + EcartReview.utilService.getCommaSeperatedString(EcartReview.totalAmount)}}</span></div></div></div></div><div class=row style=\"margin-top: 40px\"><div class=col-md-12 style=\"padding: 0px\"><div class=row><div class=col-md-6></div><div class=col-md-4></div><div class=\"col-md-2 col-xs-12\" ng-if=\"EcartReview.cartItemList.length < EcartReview.maxItemAllowed\"><a class=\"red add-more\" ng-click=\"EcartReview.showPopupScreen(\'ALL_FUNDS\')\" ng-if=\"EcartReview.cartItemList.length === 0 || EcartReview.cartItemList.length\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add More</div></a></div></div></div></div><div class=notes-accordion><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteReview.content></ng-bind-html></div></uib-accordion></div><div class=row ng-if=\"(EcartReview.PAYMENT_MODE && EcartReview.PAYMENT_MODE.length > 0) && EcartReview.cartItemList.length > 0\"><div class=col-md-12><h4>Payment Mode Selection</h4></div></div><div class=row ng-if=\"EcartReview.PAYMENT_MODE && EcartReview.PAYMENT_MODE.length == 0\"><div class=col-md-12><h4 class=error-input>No valid payment mode available to proceed with SIP transaction</h4></div></div><div class=row ng-if=\"EcartReview.PAYMENT_MODE && EcartReview.cartItemList.length > 0\"><div class=\"col-md-8 pay-mode width100\"><div><div class=radio-block ng-repeat=\"payMode in EcartReview.PAYMENT_MODE\"><span class=radio><input type=radio id={{payMode.value}} ng-change=EcartReview.changePaymentMode() ng-model=EcartReview.formData.paymentMode ng-value=payMode name=paymentMode required> <span class=check></span></span><label for={{payMode.value}}>{{payMode.value}}</label></div><!--upi bank list selection--><!--              <div class=\"row\">--><!--                <div class=\"col-md-4\">--><!--                  <div class=\"input-select input-normal selectfield\"--><!--                       ng-if=\"EcartReview.formData.paymentMode.key === \'UPI\'\">--><!--                    <select class=\"browser-default custom-select\" name=\"upiBank\"--><!--                            ng-model=\"EcartReview.formData.upiBank\"--><!--                            ng-change=\"EcartReview.changeUpiBank()\"--><!--                            ng-options=\"item as (item.bankName) for item in EcartReview.upiBankList\"--><!--                            ng-required=\"EcartReview.formData.paymentMode.key === \'UPI\'\">--><!--                      <option value=\"\" selected>Select UPI Bank - Account Number</option>--><!--                    </select>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--error message for upi tpv--><!--              <p class=\"text-red error-msg-tpv\" ng-if=\"EcartReview.formData.upiBank.tpvEnableFlag==\'N\'\">--><!--                Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br/>--><!--                Please select other payment mode or add a TPV enabled bank in your folio. <a--><!--                ng-click=\"EcartReview.tpv($event)\" href=\"javaScript:void(0)\">Click here</a> to view the TPV enabled banks.--><!--              </p>--></div><div class=row><div class=col-md-4><div class=input-normal ng-if=\"EcartReview.formData.paymentMode.key === \'OTM\'\" ng-class=\"{error: (sipPurchaseForm.otmBank.$invalid && sipPurchaseForm.otmBank.$dirty)  || EcartReview.otmLimitvalidation || EcartReview.endDateValidation}\"><input type=text name=bank id=otmBank class=custom-select ng-model=EcartReview.formData.otmBank.bankName ng-change=EcartReview.changeOtmbank() ng-init=\"EcartReview.formData.otmBank = EcartReview.formData.otmBank ? EcartReview.formData.otmBank : null\" placeholder=\"Select OTM Bank - Account Number\" autocomplete=off ng-required=\"EcartReview.formData.paymentMode.key === \'OTM\'\" only-alphabets required> <span class=highlight></span> <span class=bar></span><bank-drop-down list-data=EcartReview.otmBankList display-key=bankName display-key-second=bankAcNo hdfc-click=EcartReview.changeOtmbank() model=EcartReview.formData.otmBank for=otmBank></bank-drop-down><span ng-show=\"sipPurchaseForm.otmBank.$dirty && sipPurchaseForm.otmBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.otmBank.$error.required ng-bind=EcartReview.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=col-md-12><table class=\"table borderless\" ng-if=\"EcartReview.formData.paymentMode.key === \'OTM\' &&\n                          EcartReview.formData.otmBank\n                          && EcartReview.otmBankList.length\"><tr><td>Account No</td><td style=width:1%>:</td><td easyassist-key=mask-element>{{EcartReview.formData.otmBank.bankAcNo}}</td></tr><tr><td>OTM UMRN No</td><td style=width:1%>:</td><td>{{EcartReview.formData.otmBank.omUmrn}}</td></tr><tr><td>OTM Bank Name</td><td style=width:1%>:</td><td>{{EcartReview.formData.otmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td style=width:1%>:</td><td>{{EcartReview.formData.otmBank.omStartDate}} <span class=\"error-input error-size\" ng-if=\"EcartReview.startDateValidation && EcartReview.formData.investmentType == \'SIP\'\">Cannot initiate payment using selected OTM. You can initiate payment for sip transaction on or after OTM start date which is, {{EcartReview.formData.otmBank.omStartDate}} </span><span ng-if=\"EcartReview.startDateValidation && EcartReview.formData.investmentType == \'PURCHASE\'\" class=\"error-input error-size\">Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or after OTM start date which is, {{EcartReview.formData.otmBank.omStartDate}} </span><span class=\"error-input error-size\" ng-if=\"EcartReview.startDateValidation && EcartReview.formData.investmentType == \'SIPPURCHASE\'\">Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or after OTM start date which is, {{EcartReview.formData.otmBank.omStartDate}}</span></td></tr><tr><td>OTM Maturity Date</td><td style=width:1%>:</td><td>{{EcartReview.formData.otmBank.omExpiryDate}} <span class=\"error-input error-size\" ng-if=\"EcartReview.endDateValidation  && EcartReview.formData.investmentType == \'SIP\'\">Cannot initiate payment using selected OTM. You can initiate payment for sip transaction on or before OTM expiry date which is, {{EcartReview.formData.otmBank.omExpiryDate}} </span><span ng-if=\"EcartReview.endDateValidation  && EcartReview.formData.investmentType == \'PURCHASE\'\" class=\"error-input error-size\">Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or before OTM expiry date which is, {{EcartReview.formData.otmBank.omExpiryDate}} </span><span ng-if=\"EcartReview.endDateValidation  && EcartReview.formData.investmentType == \'SIPPURCHASE\'\" class=\"error-input error-size\">Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or before OTM expiry date which is, {{EcartReview.formData.otmBank.omExpiryDate}}</span></td></tr><tr><td>OTM Instruction Type:</td><td style=width:1%>:</td><td>{{EcartReview.formData.otmBank.otmFrequencyName ? EcartReview.formData.otmBank.otmFrequencyName : EcartReview.formData.otmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td style=width:1%>:</td><td><i class=rupee-icon ng-if=EcartReview.formData.otmBank.maxAmount></i>{{EcartReview.formData.otmBank.maxAmount}} <span ng-if=EcartReview.otmLimitvalidation class=\"error-input error-size\" ng-bind=EcartReview.VALIDATE_DATA.MAX_AMOUNT_VALIDATION_ECART></span></td></tr></table></div></div></div></div><!-- Emandate started--><div class=emandate-section ng-if=\"EcartReview.formData.paymentMode.key === \'HEM\' && EcartReview.emandateDisplay && EcartReview.eMandateBankList.length > 0 && !EcartReview.formData.minorFlag && EcartReview.emandateValidationData\"><div class=row><div class=\"col-md-3 label-emandate\">Select Bank</div><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error: (sipPurchaseForm.eMandateBank.$invalid && sipPurchaseForm.eMandateBank.$dirty)}\"><input type=text name=bank id=bank class=custom-select ng-model=EcartReview.formData.eMandateBank.bankNameOnly ng-change=EcartReview.changeEMandateBank() ng-init=\"EcartReview.formData.eMandateBank = EcartReview.formData.eMandateBank ? EcartReview.formData.eMandateBank : null\" autocomplete=off ng-required=\"EcartReview.formData.paymentMode.key === \'HEM\'\" placeholder=\"Select Bank\" only-alphabets required readonly> <span class=highlight></span> <span class=bar></span><bank-drop-down list-data=EcartReview.eMandateBankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=EcartReview.changeEMandateBank() model=EcartReview.formData.eMandateBank for=bank></bank-drop-down><span ng-show=\"sipPurchaseForm.eMandateBank.$dirty && sipPurchaseForm.eMandateBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.eMandateBank.$error.required ng-bind=EcartReview.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Authentication Mode</div><div class=\"col-sm-12 col-md-4\"><div class=input-normal ng-class=\"{error: (sipPurchaseForm.authMode.$invalid && sipPurchaseForm.authMode.$dirty)}\"><select style=\"width: 100% !important\" class=custom-select name=authMode ng-model=EcartReview.authMode ng-options=\"item.text for item in EcartReview.formData.eMandateBank.authenticationModes\" ng-required=\"EcartReview.formData.paymentMode.key === \'HEM\'\"><option value=\"\" selected>Select Authentication mode</option></select><span ng-show=\"sipPurchaseForm.authMode.$dirty && sipPurchaseForm.authMode.$invalid\"><span class=error-input ng-show=sipPurchaseForm.authMode.$error.required ng-bind=EcartReview.validations.BLANK_AUTH_MODE_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Amount</div><div class=col-md-4><div class=\"input-normal icon-input\" ng-class=\"{error:(EcartReview.tForm.eAmount.$invalid && EcartReview.tForm.eAmount.$dirty),\'has-data\':EcartReview.formData.emandateAmount}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=EcartReview.formData.emandateAmount ng-change=EcartReview.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=EcartReview.formData.emandateAmount><p id=amountInwordsEmandate>{{EcartReview.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                    <span class=\"text-success\">--><!--                          Maximum allowed for e-mandate is ₹ {{EcartReview.mandateMaxString}}.--><!--                    </span>--><div class=error-input ng-show=\"EcartReview.amountLess && EcartReview.formData.emandateAmount\">{{EcartReview.validations.EMANDATE_MIN_ERROR + EcartReview.emandateMinAmountLimit}}.</div><div class=error-input ng-show=EcartReview.amountMore>{{EcartReview.validations.EMANDATE_MAX_ERROR + EcartReview.mandateMaxString}}.</div><div class=error-input ng-show=\"!EcartReview.amountLess && EcartReview.isLessThanSipAmount\" ng-bind=EcartReview.validations.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!EcartReview.formData.emandateAmount ng-bind=EcartReview.validations.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Start Date</div><div class=\"col-md-4 anything-disabled\" ng-if=!EcartReview.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{EcartReview.viewMode}} data-date-default=EcartReview.formData.emandateDate id=emandateStartDate data-enable=true data-on-date-change=EcartReview.changeDateEmandate style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=\"row mandateDates\"><div class=\"col-md-3 label-emandate\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{EcartReview.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-md-4\"><div ng-class=\"{\'anything-disabled\': !EcartReview.formData.emandateDate}\"><div class=form-group ng-if=!EcartReview.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:EcartReview.tForm.endDateEmandate.$dirty && EcartReview.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=EcartReview.formData.endDateEmandate data-enabled-dates=EcartReview.enabledEmandateEndDatesList data-view-date=EcartReview.enabledEndDateView data-max-date=EcartReview.maxEndDateEmandate data-min-date=EcartReview.minEndDateEmandate data-on-date-change=EcartReview.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"EcartReview.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px\" class=error-input ng-show=\"EcartReview.formData.paymentMode.key === \'HEM\' && EcartReview.sipDateLessEmandate\" ng-bind=EcartReview.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div></div><!--            <div class=\"row\" ng-if=\"EcartReview.formData.paymentMode.key === \'HEM\' && EcartReview.emandateDisplay && EcartReview.eMandateBankList.length > 0\">--><!--              <div class=\"col-md-3\" ng-if=\"!(EcartReview.formData.minorFlag)\">--><!--                <div class=\"input-normal\"--><!--                     ng-class=\"{error: (sipPurchaseForm.eMandateBank.$invalid && sipPurchaseForm.eMandateBank.$dirty)}\">--><!--                  <input type=\"text\" name=\"bank\" id=\"bank\" class=\"custom-select\"--><!--                         ng-model=\"EcartReview.formData.eMandateBank.bankNameOnly\"--><!--                         ng-change=\"EcartReview.changeEMandateBank()\"--><!--                         ng-init=\"EcartReview.formData.eMandateBank = EcartReview.formData.eMandateBank ? EcartReview.formData.eMandateBank : null\"--><!--                         autocomplete=\"off\" ng-required=\"EcartReview.formData.paymentMode.key === \'HEM\'\"--><!--                         ng-disabled=\"EcartReview.showEmandateError || EcartReview.minAmountLimitError\"--><!--                         placeholder=\"Select Bank\" only-alphabets required >--><!--                  <span class=\"highlight\"></span>--><!--                  <span class=\"bar\"></span>--><!--                  <bank-drop-down--><!--                    list-data=\"EcartReview.eMandateBankList\"--><!--                    display-key=\"bankNameOnly\"--><!--                    display-key-second=\"accountNumber\"--><!--                    hdfc-click=\"EcartReview.changeEMandateBank()\"--><!--                    model=\"EcartReview.formData.eMandateBank\"--><!--                    for=\"bank\">--><!--                  </bank-drop-down>--><!--                  <span--><!--                    ng-show=\"sipPurchaseForm.eMandateBank.$dirty && sipPurchaseForm.eMandateBank.$invalid\">--><!--                          <span class=\"error-input\"--><!--                                ng-show=\"sipPurchaseForm.eMandateBank.$error.required\"--><!--                                ng-bind=\"EcartReview.validations.BLANK_BANK_INFO\"></span>--><!--                          </span>--><!--                </div>--><!--              </div>--><!--            </div>--><div ng-if=\"(EcartReview.isEmailinValid || EcartReview.isEmailMobileinValid || EcartReview.isMobileinValid) && (EcartReview.formData.paymentMode.key === \'HEM\')\" style=width:55%><span class=error-input ng-show=EcartReview.isMobileinValid ng-bind=EcartReview.validations.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=EcartReview.isEmailinValid ng-bind=EcartReview.validations.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=EcartReview.isEmailMobileinValid ng-bind=EcartReview.validations.INVALID_EMAIL_MOBILE_EMANDATE></span></div><!--            <div ng-if=\"!(EcartReview.formData.minorFlag)\">--><!--              <div class=\"row row-hem\" ng-if=\"EcartReview.formData.paymentMode.key === \'HEM\' && EcartReview.emandateDisplay && EcartReview.eMandateBankList.length > 0\">--><!--                <div class=\"col-xs-12 col-sm-12 col-md-2 pay-mode\" ><strong>Authentication mode</strong></div>--><!--                <div class=\"col-xs-12 col-sm-12 col-md-3\">--><!--                  <div class=\"input-normal\" ng-class=\"{error: (sipPurchaseForm.authMode.$invalid && sipPurchaseForm.authMode.$dirty)}\">--><!--                    <select class=\"custom-select\" name=\"authMode\"--><!--                            ng-model=\"EcartReview.authMode\"--><!--                            ng-options=\"item.text for item in EcartReview.formData.eMandateBank.authenticationModes\"--><!--                            ng-required=\"EcartReview.formData.paymentMode.key === \'HEM\'\">--><!--                      <option value=\"\" selected>Select Authentication mode</option>--><!--                    </select>--><!--                    <span ng-show=\"sipPurchaseForm.authMode.$dirty && sipPurchaseForm.authMode.$invalid\">--><!--                            <span class=\"error-input\"--><!--                                  ng-show=\"sipPurchaseForm.authMode.$error.required\"--><!--                                  ng-bind=\"EcartReview.validations.BLANK_AUTH_MODE_INFO\"></span>--><!--                            </span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"col-md-12\" ng-if=\"EcartReview.showEmandateError\">--><!--                  <span class=\"error-input\">SIP Amount cannot be greater than Rs. {{EcartReview.emandateValidateData.maxAmountLimitInfo}} for Emandate payment mode</span>--><!--                </div>--><!--                <div class=\"col-md-12\" ng-if=\"EcartReview.minAmountLimitError\">--><!--                  <span class=\"error-input\">SIP Amount cannot be less than Rs.{{EcartReview.emandateValidateData.minAmountLimit}} for Emandate payment mode</span>--><!--                </div>--><!--                <div class=\"col-md-12\" ng-if=\"EcartReview.minStartDateLimitError\">--><!--                  <span class=\"error-input\">start date cannot be earlier than Mandate start date</span>--><!--                </div>--><!--                <div class=\"col-md-12\" ng-if=\"EcartReview.maxEndDateLimitError\">--><!--                  <span class=\"error-input\">Mandate end date cannot be earlier than mandate start date</span>--><!--                </div>--><!--              </div>--><!--            </div>--><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'WEB\' && EcartReview.formData.investmentType !== \'SIPPURCHASE\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteNetBanking.content></ng-bind-html></div></uib-accordion></div><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'EC\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteStandard.content></ng-bind-html></div></uib-accordion></div><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'OTM\' && EcartReview.formData.investmentType !== \'SIPPURCHASE\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteOtmSip.content></ng-bind-html></div></uib-accordion></div><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'HEM\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteEotm.content ng-if=\"EcartReview.authMode.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=EcartReview.dynamicNoteEotmDebitCard.content ng-if=\"EcartReview.authMode.value === \'DEBIT_CARD\'\"></ng-bind-html></div></uib-accordion></div><!--Dynamic for mix--><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'WEB\' && EcartReview.formData.investmentType == \'SIPPURCHASE\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteMixNetBanking.content></ng-bind-html></div></uib-accordion></div><div class=notes-accordion ng-if=\"EcartReview.formData.paymentMode.key == \'OTM\' && EcartReview.formData.investmentType == \'SIPPURCHASE\'\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><!--dynamic note netbanking--><uib-accordion-heading>Please Note: <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><ng-bind-html dynamic=EcartReview.dynamicNoteMixOTM.content></ng-bind-html></div></uib-accordion></div><div class=tc-block ng-show=\"EcartReview.showTerms && EcartReview.cartItemList.length > 0\"><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=EcartReview.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=EcartReview.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-md-12 text-center\"><!--error message for cart --> <span ng-if=EcartReview.cartDetails.errorExists class=bank-error-msg style=\"text-align: center\">{{EcartReview.cartDetails.message}}</span> <button class=btn-primary ng-disabled=\"EcartReview.cartItemList.length == 0 || EcartReview.cartError || sipPurchaseForm.$invalid || (EcartReview.isEmailinValid || EcartReview.isEmailMobileinValid || EcartReview.isMobileinValid) && (EcartReview.formData.paymentMode.key === \'HEM\') || EcartReview.endDateValidation || EcartReview.startDateValidation || EcartReview.isInValidFolio || EcartReview.amountLess || EcartReview.amountMore || EcartReview.isLessThanSipAmount || EcartReview.sipDateLessEmandate\" ng-click=EcartReview.checkEcartItemValidations()><!--|| !EcartReview.kycVerifiedFlag--> Proceed</button></div></div></div></section></form></div><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideBarInvest hdfc-post-login-ecart-sidebar side-title=EcartReview.sidebarTitle invest-through=EcartReview.investThrough investor-data=EcartReview.investorData cart-item=EcartReview.cartDetails euin-declaration=EcartReview.dynamicDataSipPurchaseReview update-info=\"EcartReview.fetchCartItemList(\'invest\', data)\"></div><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideBarCart hdfc-post-login-ecart-sidebar side-title=EcartReview.sidebarTitle investor-data=EcartReview.investorData cart-item=EcartReview.itemToBeEdited is-from-review=EcartReview.isFromRviewScreen euin-declaration=EcartReview.dynamicDataSipPurchaseReview show-add-cart=EcartReview.showAddCart update-info=\"EcartReview.getCartItems(\'add\')\"></div><div class=sidebar-container id=sidebarContainer ng-if=EcartReview.showSideAllFunds hdfc-post-login-ecart-sidebar side-title=EcartReview.sidebarTitle investor-data=EcartReview.investorData is-from-review=EcartReview.isFromRviewScreen euin-declaration=EcartReview.dynamicDataSipPurchaseReview show-add-cart=EcartReview.showAddCart update-info=\"EcartReview.getCartItems(\'all\')\"></div></div><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"EcartReview.expandSidebar()\">Toggle collapse Horizontally</button>\n  <hr>--></section></div>");
$templateCache.put("app/investors/add/add.html","<div class=investors-new ng-init=InvestorsAdd.init();><!-- InvestorsAdd.checkPanDetails(); --><div class=content-header><p class=small-text>New Folio Creation</p><h5><span ng-bind=InvestorsAdd.headerDetails.name></span><p>(KYC Verified)</p><span class=separator>&nbsp;| &nbsp;</span> <span>PAN : <strong easyassist-key=mask-element ng-bind=InvestorsAdd.headerDetails.pan></strong></span></h5><div ng-if=InvestorsAdd.headerDetails.reason class=rejection-reason><p><strong>Reason for Rejection: </strong><span ng-bind=InvestorsAdd.headerDetails.reason>The form filled has some errors in Nominee details.</span></p></div></div><div class=box-main><div class=ui-progress ng-class=\"{\'step1\':$state.current.name==\'main.investors.add.appdetails\',\'step2\':$state.current.name==\'main.investors.add.nominee\',\'step3\':$state.current.name==\'main.investors.add.bankdetails\'}\"><span id=modeId class=\"holding-mode text-uppercase\" ng-class=\"{\'active\':\'main.investors.add.holdmode\',\'done\':$state.current.name==\'main.investors.add.appdetails\'\n            || $state.current.name==\'main.investors.add.jointholders\'\n            || $state.current.name==\'main.investors.add.nominee\'\n            || $state.current.name==\'main.investors.add.bankdetails\'\n            }\" data-text=\"Mode of Holding\">&nbsp;</span> <span ng-if=\"InvestorsAdd.headerDetails.holdmode !== InvestorsAdd.CONST.INVESTOR_HOLD_MODE.AOS\" id=folioId class=\"create-folio text-uppercase\" ng-class=\"{\'active\':$state.current.name==\'main.investors.add.appdetails\',\'done\':$state.current.name==\'main.investors.add.bankdetails\' || $state.current.name==\'main.investors.add.nominee\' || $state.current.name==\'main.investors.add.jointholders\'}\" data-text=\"Sole Applicant\">&nbsp;</span> <span ng-if=\"InvestorsAdd.headerDetails.holdmode !== InvestorsAdd.CONST.INVESTOR_HOLD_MODE.AOS\" id=nomineeId class=\"add-nominee text-uppercase\" ng-if=!isMinor ng-class=\"{\'active\':$state.current.name==\'main.investors.add.nominee\',\'done\':$state.current.name==\'main.investors.add.bankdetails\'}\" data-text=\"Add Nominee\">&nbsp;</span> <span ng-if=\"InvestorsAdd.headerDetails.holdmode === InvestorsAdd.CONST.INVESTOR_HOLD_MODE.AOS\" id=folioId class=\"create-folio text-uppercase\" ng-class=\"{\'active\':$state.current.name==\'main.investors.add.appdetails\',\'done\':$state.current.name==\'main.investors.add.bankdetails\' || $state.current.name==\'main.investors.add.nominee\' || $state.current.name==\'main.investors.add.jointholders\'}\" data-text=\"Sole Applicant\" style=\"left: 25%\">&nbsp;</span> <span ng-if=\"InvestorsAdd.headerDetails.holdmode === InvestorsAdd.CONST.INVESTOR_HOLD_MODE.AOS\" id=holderId class=\"joint-holder text-uppercase\" ng-class=\"{\'active\':$state.current.name==\'main.investors.add.jointholders\',\'done\':$state.current.name==\'main.investors.add.bankdetails\' || $state.current.name==\'main.investors.add.nominee\'}\" data-text=\"Joint Holders\" style=\"left: 50%;display: inline\">&nbsp;</span> <span ng-if=\"InvestorsAdd.headerDetails.holdmode === InvestorsAdd.CONST.INVESTOR_HOLD_MODE.AOS\" id=nomineeId class=\"add-nominee text-uppercase\" ng-if=!isMinor ng-class=\"{\'active\':$state.current.name==\'main.investors.add.nominee\',\'done\':$state.current.name==\'main.investors.add.bankdetails\'}\" data-text=\"Add Nominee\" style=\"left: 75%\">&nbsp;</span> <span id=schemeId class=\"add-scheme text-uppercase\" ng-class=\"{\'active\':$state.current.name==\'main.investors.add.bankdetails\'}\" data-text=\"Bank Details\">&nbsp;</span></div><div ui-view></div></div></div>");
$templateCache.put("app/investors/cobmApprovalSummary/cobmSummary.html","<!--<hdfc-header></hdfc-header>--><header class=\"container-fluid summary-header affix\" ng-if=CobmApprovalSummary.summaryDetails><div><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/logo.png href=/dashboard></span></div></header>><!--<ui-view></ui-view>--><div class=email-view ng-if=CobmApprovalSummary.summaryDetails><div data-ng-switch=CobmApprovalSummary.summaryDetails.cobmAction><div data-ng-switch-when=AIPR><div data-ng-include=\"\'app/investors/cobmApprovalSummary/newCobmApproval/addBank.html\'\"></div></div><div data-ng-switch-when=AIPDBM><div data-ng-include=\"\'app/investors/cobmApprovalSummary/newCobmApproval/addBank.html\'\"></div></div></div><div data-ng-switch=CobmApprovalSummary.summaryDetails.cobmAction><div data-ng-switch-when=AIPC><div data-ng-include=\"\'app/investors/cobmApprovalSummary/newCobmApproval/deleteBank.html\'\"></div></div></div><div data-ng-switch=CobmApprovalSummary.summaryDetails.cobmAction><div data-ng-switch-when=MBMR><div data-ng-include=\"\'app/investors/cobmApprovalSummary/newCobmApproval/changeBank.html\'\"></div></div></div></div><footer class=\"summary-footer main-footer summary-footer-cobm\" ng-if=CobmApprovalSummary.summaryDetails><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Investors.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer>");
$templateCache.put("app/investors/emandate/registerEmandate.html","<section class=emandate-section ng-init=RegisterEmandate.init();><div class=\"mandate-heading paddng-bottom-mandate\"><h5>E-Mandate Registration</h5></div><div class=mandate-section><div class=container><div class=row><div class=col-xs-12><div class=row><div class=col-xs-3>Folio Number</div><div class=col-xs-1><span>:</span></div><div class=col-xs-6>{{RegisterEmandate.investorDetails.folioNo}}</div></div><div class=row><div class=\"col-xs-12 col-md-9\"><h6>Investor Details</h6></div></div><div class=row><div class=col-xs-3>Investor Name</div><div class=col-xs-1><span>:</span></div><div class=col-xs-6>{{RegisterEmandate.investorDetails.investorName}}</div></div><div class=row><div class=col-xs-3>Email ID</div><div class=col-xs-1><span>:</span></div><div class=col-xs-6 easyassist-key=mask-element>{{RegisterEmandate.investorDetails.emailId ? RegisterEmandate.investorDetails.emailId : \'Not available\'}}</div></div><div class=row><div class=col-xs-3>Mobile Number</div><div class=col-xs-1><span>:</span></div><div class=col-xs-6 easyassist-key=mask-element>{{RegisterEmandate.investorDetails.mobileNo ? RegisterEmandate.investorDetails.mobileNo : \"Not available\"}}</div></div><div class=\"row emandate-details\"><div class=\"col-xs-12 col-md-9\"><h6>E-mandate Details</h6></div></div><div class=row><div class=col-xs-3>Bank Name & Account Number</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\"><div class=\"input-select input-normal selectfield transaction-cal\" style=\"margin-bottom: 0px\"><input type=text name=bank id=ebank ng-model=RegisterEmandate.formData.bankInfo.bankNameOnly ng-change=RegisterEmandate.changeBank() autocomplete=off ng-required=!RegisterEmandate.bankInfo only-alphabets readonly> <span class=highlight></span> <span class=bar></span><label ng-if=!RegisterEmandate.formData.bankInfo.bankNameOnly>Select Bank</label><span class=error-input ng-show=\"bankForm.bank.$touched && bankForm.bank.$error.required\" ng-bind=RegisterEmandate.VALIDATE_DATA.BLANK_BANK_INFO></span><bank-drop-down list-data=RegisterEmandate.bankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=RegisterEmandate.changeBank() model=RegisterEmandate.formData.bankInfo for=ebank></bank-drop-down></div></div></div><div class=row><div class=col-xs-3>Account Type</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\">{{RegisterEmandate.formData.bankInfo.accTypeDesc}}</div></div><div class=row><div class=col-xs-3>Amount</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\"><input type=number ignore-mouse-wheel name=Amount ng-maxlength=10 limit-to=10 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=RegisterEmandate.formData.amount ng-change=RegisterEmandate.checkAmountValidation() class=amount-input><div class=amtWords><p style=\"font-size: 12px\" id=amountInwordsEmandate>{{RegisterEmandate.emandateWord.amountInWords}} (In Words)</p></div><div class=text-success>Maximum allowed for e-mandate is ₹ {{RegisterEmandate.mandateMaxString}}.</div><div class=error-input ng-show=RegisterEmandate.amountLess>{{RegisterEmandate.VALIDATE_DATA.EMANDATE_MIN_ERROR + RegisterEmandate.emandateDetails.minAmountLimit}}.</div><div class=error-input ng-show=RegisterEmandate.amountMore>{{RegisterEmandate.VALIDATE_DATA.EMANDATE_MAX_ERROR + RegisterEmandate.mandateMaxString}}.</div></div></div><div class=row><div class=col-xs-3>Start Date</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-3\"><div class=date-container-start><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-format=DD-MMM-YYYY data-viewmode={{RegisterEmandate.viewMode}} data-date-default=RegisterEmandate.formData.startDate data-enabled-dates=RegisterEmandate.enabledStartDatesList data-min-date=RegisterEmandate.startMinDateBiller data-max-date=RegisterEmandate.startMaxDate data-on-date-change=RegisterEmandate.changeStartDate data-view-date=InitiateTransactionSwp.enabledStartDatesList[0] data-enable=true id=mandateStartDate><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=row><div class=col-xs-3>End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{RegisterEmandate.mandateInfo}} tooltip-side=right></i></div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-3\"><div class=date-container-end ng-class=\"{\'anything-disabled\': !RegisterEmandate.formData.startDate }\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-format=DD-MMM-YYYY data-viewmode={{RegisterEmandate.viewMode}} data-date-default=RegisterEmandate.formData.endDate data-enabled-dates=RegisterEmandate.enabledEndDatesList data-min-date=RegisterEmandate.minEndDate data-max-date=RegisterEmandate.maxEndDate data-on-date-change=RegisterEmandate.changeEndDate data-view-date=RegisterEmandate.endViewDate data-enable=true><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div><!--<div class=\"col-xs-7 col-md-3\">\n              <div class=\"default-date mandateDefaultDate\" ng-class=\"{\'anything-disabled\': !RegisterEmandate.formData.startDate }\">\n                <span class=\"checkbox\" style=\"bottom: -3px;\">\n                  <input type=\"checkbox\" id=\"defaultDate\" ng-disabled=\"!RegisterEmandate.formData.startDate\" ng-change=\"RegisterEmandate.defaultEndDate()\" ng-model=\"RegisterEmandate.isDefaultDateSelected\">\n                  <span class=\"icon-checkbox\"></span>\n                </span>\n                <label for=\"defaultDate\" style=\"margin-left: 5px;\">Until Cancelled</label>\n              </div>\n            </div>--></div><div class=row><div class=col-xs-3>Frequency</div><div class=col-xs-1><span>:</span></div><div class=col-xs-4>{{RegisterEmandate.emandateDetails.frequency}}</div></div><div class=row><div class=col-xs-3>Authentication Mode</div><div class=col-xs-1><span>:</span></div><div class=\"col-xs-7 col-md-4\"><div class=selectfield style=\"margin-bottom: 0px\"><select name=authenticationMode class=\"authModeDropdown custom-select\" ng-model=RegisterEmandate.formData.authModeSelect ng-options=\"authMode.text for authMode in RegisterEmandate.formData.bankInfo.authenticationModes\" ng-init=\"RegisterEmandate.formData.authModeSelect=RegisterEmandate.formData.authModeSelect?RegisterEmandate.formData.authModeSelect: null\" ng-change=\"RegisterEmandate.authMode = RegisterEmandate.formData.authModeSelect;\" required><option value=\"\" selected>{{(RegisterEmandate.authenticationModes && !RegisterEmandate.authenticationModes.length) ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select></div></div></div><div class=row><div class=col-xs-3>Purpose of E-mandate</div><div class=col-xs-1><span>:</span></div><div class=col-xs-4>{{RegisterEmandate.emandateDetails.purpose}}</div></div></div></div><div class=row><div class=col-xs-12><!--dynamic note for emandate registeration--><ng-bind-html dynamic=RegisterEmandate.dynamicNote.content></ng-bind-html></div></div><div class=row><div class=\"col-xs-12 mandate-action-col\"><div class=\"button-section-mandate align-right-mandate\"><button ng-click=RegisterEmandate.reset() class=\"btn btn-negative-action\">Reset</button> <button ng-disabled=\"!RegisterEmandate.formData.bankInfo ||\n              !RegisterEmandate.formData.startDate ||\n              !RegisterEmandate.formData.endDate ||\n              !RegisterEmandate.formData.amount ||\n              RegisterEmandate.amountLess ||\n              RegisterEmandate.amountMore ||\n              !RegisterEmandate.formData.authModeSelect\" ng-click=RegisterEmandate.goToSummary() class=\"btn btn-primary-action\">Continue</button></div></div></div></div></div></section>");
$templateCache.put("app/investors/list/investors-list.html","<div class=\"investors transaction investors-listing-container\"><!-- Investor page sidebar--><div class=blur-area></div><div id=filterSideNav class=\"filterSidenav noWidth\" ng-if=InvestorsList.tabs[0].active><div class=\"row header-row\"><div class=\"col-xs-6 col-md-6\"><div class=filter-sidebar-title><img src=assets/images/icons/filter-button.png alt=filter-button> <span>Filter</span></div></div><div class=\"col-xs-6 col-md-6 cancel-action\"><i class=times-icon ng-click=InvestorsList.closeNav()></i></div></div><div class=\"row hidden-xs\"><div class=col-md-12><div class=filters-selected ng-class=\"{\'filter-selected-border\':!InvestorsList.borderHide}\"><span ng-repeat=\"selection in InvestorsList.filterSelectionList.selectionKeys\" ng-if=\"InvestorsList.selectionMade[selection].length > 0\"><div ng-if=\"selection == \'eligibility\' && !InvestorsList.defaultEligiblitySet\"><p class=selectionType><span ng-if=\"selection == \'eligibility\'\">Eligibility :</span></p></div><div ng-if=\"(selection == \'investorType\' || selection == \'investorSubType\')\"><p class=selectionType ng-if=\"selection == \'investorType\' && !InvestorsList.defaultInvestorTypeSet\"><span>Investor Type :</span></p><p class=selectionType ng-if=\"selection == \'investorSubType\'\"><span>Investor Sub Type :</span></p></div><div ng-if=\"selection == \'otmOption\' && !InvestorsList.defaultOtmSet\"><p class=selectionType><span ng-if=\"selection == \'otmOption\'\">OTM Registered :</span></p></div><div ng-if=\"selection == \'currentHoldingState\' && !InvestorsList.defaultcurrentHoldingSet || selection == \'currentHoldingOptions\' && (!InvestorsList.defaultcurrentHoldingSet && !InvestorsList.defaultCurrentHoldingOption)\"><p class=selectionType><span ng-if=\"selection == \'currentHoldingState\'\">Current Holding :</span> <span ng-if=\"selection == \'currentHoldingOptions\'\">Current Holding Option :</span></p></div><div ng-if=\"selection == \'systematicActiveState\' && !InvestorsList.defaultsystemicSet || selection == \'systematicPlanType\' && (!InvestorsList.defaultsystemicSet && !InvestorsList.defaultsystemicPlanSet) ||\n             selection == \'systematicOptions\' && (!InvestorsList.defaultsystemicSet && !InvestorsList.defaultsystemicOptionSet)\"><p class=selectionType><span ng-if=\"selection == \'systematicActiveState\'\">Systematic Investment\'s :</span> <span ng-if=\"selection == \'systematicPlanType\'\">Systematic Investment\'s Plan Type :</span> <span ng-if=\"selection == \'systematicOptions\'\">Systematic Investment\'s Option :</span></p></div><div ng-if=\"selection == \'investorActivityHave\' && !InvestorsList.defaultInvestorActivity ||\n            selection == \'investorActivityType\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityPlan) ||\n            selection == \'investorsActivityOptions\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityOptionSet) ||\n            selection == \'investorActivityDuration\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityDurationSet)\"><p class=selectionType><span ng-if=\"selection == \'investorActivityHave\'\">Investor Activity :</span> <span ng-if=\"selection == \'investorActivityType\'\">Transaction Type :</span> <span ng-if=\"selection == \'investorsActivityOptions\'\">Investor Activity Option :</span> <span ng-if=\"selection == \'investorActivityDuration\'\">Investor Activity Duration :</span></p></div><div ng-repeat=\"option in InvestorsList.selectionMade[selection] track by $index\"><p ng-if=\"selection == \'eligibility\' && !InvestorsList.defaultEligiblitySet\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'investorType\' && !InvestorsList.defaultInvestorTypeSet\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"(selection == \'investorSubType\')\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'otmOption\' && !InvestorsList.defaultOtmSet\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'currentHoldingState\' && !InvestorsList.defaultcurrentHoldingSet\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'currentHoldingOptions\' && (!InvestorsList.defaultcurrentHoldingSet && !InvestorsList.defaultCurrentHoldingOption)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'systematicActiveState\' && !InvestorsList.defaultsystemicSet\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'systematicPlanType\' && (!InvestorsList.defaultsystemicSet && !InvestorsList.defaultsystemicPlanSet)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'systematicOptions\' && (!InvestorsList.defaultsystemicSet && !InvestorsList.defaultsystemicOptionSet)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'investorActivityHave\' && !InvestorsList.defaultInvestorActivity\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'investorActivityType\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityPlan)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'investorsActivityOptions\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityOptionSet)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p><p ng-if=\"selection == \'investorActivityDuration\' && (!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityDurationSet)\"><span>{{option}}</span> <span><i class=cancel-icon ng-click=\"InvestorsList.filterSelectionList.changeEvent(selection, option)\"></i></span></p></div></span></div></div></div><div class=\"row hidden-xs\"><div class=col-md-12><div class=available-filters><ul class=filter-options><li ng-repeat=\"options in InvestorsList.filterList\" ng-click=InvestorsList.selectFilter(options) ng-class=\"{\'active\': options.active}\" style=\"display: flex; justify-content: space-between\" class=filter><span>{{options.name}}</span> <span style=\"color:red; padding: 0px 5px; border: 1px solid red; border-radius: 25%\" ng-if=\"options.key==\'CURRENT_HOLDING\' && InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0\n                    || options.key==\'CURRENT_HOLDING\' && InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0\n                    || options.key==\'CURRENT_HOLDING\' && InvestorsList.currHoldingSchemeGroup.length == 0\n                    || options.key==\'CURRENT_HOLDING\' && InvestorsList.filtersSelected.currentHolding.options.length == 0 \">i</span> <span style=\"color:red; padding: 0px 5px; border: 1px solid red; border-radius: 25%\" ng-if=\"options.key==\'SYSTEMATIC_INVESTMENT\' && InvestorsList.filtersSelected.systematicFilter.planTypes.length == 0\n                    || options.key==\'SYSTEMATIC_INVESTMENT\' && InvestorsList.selectionMadeSystematic.systematicCategory.length == 0\n                    || options.key==\'SYSTEMATIC_INVESTMENT\' && InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0\n                    || options.key==\'SYSTEMATIC_INVESTMENT\' && InvestorsList.systematicSchemeGroup.length == 0\n                    || options.key==\'SYSTEMATIC_INVESTMENT\' && InvestorsList.filtersSelected.systematicFilter.options.length == 0\">i</span> <span style=\"color:red; padding: 0px 5px ; border: 1px solid red; border-radius: 25%\" ng-if=\"options.key==\'INVESTOR_ACTIVITY\' && InvestorsList.filtersSelected.investorActivity.activityTypes.length == 0\n                    || options.key==\'INVESTOR_ACTIVITY\' && InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0\n                    || options.key==\'INVESTOR_ACTIVITY\' && InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0\n                    || options.key==\'INVESTOR_ACTIVITY\' && InvestorsList.investorActivitySchemeGroup.length == 0\n                    || options.key==\'INVESTOR_ACTIVITY\' && InvestorsList.filtersSelected.investorActivity.options.length == 0\">i</span></li></ul><div class=filter-details><div ng-if=\"InvestorsList.selectedFilter === \'ELIGIBILITY\'\" class=details><div class=filter-title>Filter with eligibility to approve transaction</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"eligible in InvestorsList.investorFilter.ELIGIBILITY_FILTER\"><span class=radio><input type=radio id={{eligible.key}} ng-change=InvestorsList.changeEligibility(eligible) ng-model=InvestorsList.filtersSelected.eligibility ng-value=eligible.value required> <span class=check></span></span><label for={{eligible.key}}>{{eligible.key}}</label></div></div></div><div ng-if=\"InvestorsList.selectedFilter === \'INVESTOR_TYPE\'\" class=details><div class=filter-title>Filter by investor type</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"investor in InvestorsList.investorFilter.INVESTOR_TYPE\"><span class=radio><input type=radio id={{investor.key}} ng-change=InvestorsList.changeInvestorType(investor) ng-model=InvestorsList.filtersSelected.investorType ng-value=investor.value required> <span class=check></span></span><label for={{investor.key}}>{{investor.key}}</label></div></div><div class=filter-sub-title>Investor Sub Type</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"subInvestor in InvestorsList.investorFilter.INVESTOR_SUB_TYPE\"><input type=checkbox ng-change=InvestorsList.changeInvestorSubType() ng-model=InvestorsList.filtersSelected.investorSelectedSubType[subInvestor.key] ng-value=subInvestor.value required> <span class=icon-checkbox></span> <span class=checkbox-text>{{subInvestor.key}}</span></span></div></div><div ng-if=\"InvestorsList.selectedFilter === \'OTM_REGISTERED\'\" class=details><div class=filter-title>Have an OTM registered</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"otm in InvestorsList.investorFilter.OTM_FILTER\"><span class=radio><input type=radio id={{otm.key}} ng-change=InvestorsList.changeOtmRegistered(otm) ng-model=InvestorsList.filtersSelected.otmOption ng-value=otm.value required> <span class=check></span></span><label for={{otm.key}}>{{otm.key}}</label></div></div></div><div ng-if=\"InvestorsList.selectedFilter === \'CURRENT_HOLDING\'\" class=details><div class=filter-title>Filter by current holding</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.CURRENT_HOLDING_FILTER\"><span class=radio><input type=radio id={{holding.key}} ng-change=InvestorsList.changeHoldingState(holding) ng-model=InvestorsList.filtersSelected.currentHolding.holdingState ng-value=holding.value required> <span class=check></span></span><label for={{holding.key}}>{{holding.key}}</label></div></div><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.currentHoldingSchemeType selected-model=InvestorsList.filtersSelected.currentHolding.category events=InvestorsList.selectCurrentHoldingSchemeType extra-settings=InvestorsList.currentHoldingFilterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultcurrentHoldingSet class=multiselectInvestorList></span><div class=\"row hidden-xs\" style=\"margin-left: -25px; width: 400px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory track by $index\"><p ng-if=\"!InvestorsList.defaultcurrentHoldingSet && !InvestorsList.defaultCurrentHoldingScheme && option !==\'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterCurrentHolding.changeEventSchemeType(option)></i></span></p></div><span style=\"color:red;display: inline-block; margin-top:10px\" ng-if=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0\">Please select at least one category type</span></span></div></div></div></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections style=\"display: inline\"><div class=multiselectInvestorList style=\"margin-left: 30px\"><span custom-directive=\"\" options=InvestorsList.currHoldingSchemeGroup selected-model=InvestorsList.filtersSelected.currentHolding.group events=InvestorsList.selectCurrentHoldingGroupType extra-settings=InvestorsList.currentHoldingFilterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultcurrentHoldingSet class=\"multiselectInvestorList chGroup\"></span><div class=\"row hidden-xs\" style=\"margin-left: -25px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeCurrentHolding.currentHoldingGroup track by $index\" style=\"margin-top: 10px\"><p ng-if=\"!InvestorsList.defaultcurrentHoldingSet && !InvestorsList.defaultCurrentHoldingGroup && InvestorsList.filtersSelected.currentHolding.category.length > 0 && option !==\'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterCurrentHolding.changeEventGroupType(option)></i></span></p></div><span style=color:red ng-if=\"((InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 || InvestorsList.currHoldingSchemeGroup.length == 0) && InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0) || InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 && !(InvestorsList.currHoldingSchemeGroup.length == 0)\">Please select at least one scheme type </span><span style=color:red ng-if=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length > 0 && InvestorsList.currHoldingSchemeGroup.length == 0\">No Schemes are available</span></span></div></div></div></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.CURRENT_HOLDING_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeOptionsSelected(); ng-model=InvestorsList.filtersSelected.currentHolding.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultcurrentHoldingSet class=disable-checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.currentHolding.options.length == 0\">Please select at least one Option Type</p></div><div ng-if=\"InvestorsList.selectedFilter === \'SYSTEMATIC_INVESTMENT\'\" class=details><div class=filter-title>Filter by systematic plan</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"systematic in InvestorsList.investorFilter.SYSTEMATIC_PLAN_FILTER\"><span class=radio><input type=radio id={{systematic.key}} ng-change=InvestorsList.changeSystematicFilter(systematic) ng-model=InvestorsList.filtersSelected.systematicFilter.active ng-value=systematic.value required> <span class=check></span></span><label for={{systematic.key}}>{{systematic.key}}</label></div></div><div class=filter-sub-title>Select Plan Type</div><div class=filter-sub-sections><div custom-directive=\"\" options=InvestorsList.investorFilter.SYSTEMATIC_PLAN_TYPE selected-model=InvestorsList.filtersSelected.systematicFilter.planTypes events=InvestorsList.planTypeChangeEvent extra-settings=InvestorsList.filterMultiSettings translation-texts=InvestorsList.schemeTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=multiselectInvestorList></div></div><p style=\"color:red; margin-left: 30px; margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.systematicFilter.planTypes.length == 0\">Please select at least one plan type</p><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.systematicSchemeType selected-model=InvestorsList.filtersSelected.systematicFilter.category events=InvestorsList.selectSystematicSchemeType extra-settings=InvestorsList.filterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=multiselectInvestorList></span><div class=\"row hidden-xs\" style=\"margin-left:-25px; width: 400px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeSystematic.systematicCategory track by $index\"><p ng-if=\"!InvestorsList.defaultsystemicSet && !InvestorsList.defaultsystemicSchemeSet && option !== \'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterSystematic.changeEventSchemeType(option)></i></span></p></div><span style=\"color:red; display: inline-block; margin-top:10px\" ng-if=\"InvestorsList.selectionMadeSystematic.systematicCategory.length == 0\">Please select at least one category type</span></span></div></div></div></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections style=\"display: inline\"><div class=multiselectInvestorList style=\"margin-left: 30px\"><span custom-directive=\"\" options=InvestorsList.systematicSchemeGroup selected-model=InvestorsList.filtersSelected.systematicFilter.group events=InvestorsList.selectSystematicGroupType extra-settings=InvestorsList.filterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=\"multiselectInvestorList chGroup\"></span><div class=\"row hidden-xs\" style=\"margin-left: -25px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeSystematic.systematicGroup track by $index\" style=\"margin-top: 10px\"><p ng-if=\"!InvestorsList.defaultsystemicSet && !InvestorsList.defaultSystematicGroupSet && InvestorsList.filtersSelected.systematicFilter.category.length > 0 && option !== \'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterSystematic.changeEventGroupType(option)></i></span></p></div><span style=color:red ng-if=\"((InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 || InvestorsList.systematicSchemeGroup.length == 0) && InvestorsList.selectionMadeSystematic.systematicCategory.length == 0) || InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 && !(InvestorsList.systematicSchemeGroup.length == 0)\">Please select at least one scheme type </span><span style=color:red ng-if=\"InvestorsList.selectionMadeSystematic.systematicCategory.length > 0 && InvestorsList.systematicSchemeGroup.length == 0\">No Schemes are available</span></span></div></div></div></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.SYSTEMATIC_PLAN_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeSystematicOptions() ng-model=InvestorsList.filtersSelected.systematicFilter.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultsystemicSet class=disable-checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.systematicFilter.options.length == 0\">Please select at least one Option Type</p></div><div ng-if=\"InvestorsList.selectedFilter === \'INVESTOR_ACTIVITY\'\" class=details><div class=filter-title>Filter by recent activity of investor(s)</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"activity in InvestorsList.investorFilter.INVESTOR_ACTIVITY_FILTER\"><span class=radio><input type=radio id={{activity.key}} ng-change=InvestorsList.changeInvestorActivity(activity) ng-model=InvestorsList.filtersSelected.investorActivity.have ng-value=activity.value required> <span class=check></span></span><label for={{activity.key}}>{{activity.key}}</label></div></div><div class=filter-sub-title>Select Type of Activity</div><div class=filter-sub-sections><span custom-directive=\"\" options=InvestorsList.investorFilter.INVESTOR_ACTIVITY_TYPE selected-model=InvestorsList.filtersSelected.investorActivity.activityTypes events=InvestorsList.changeInvestorActivityType extra-settings=InvestorsList.filterMultiSettings checkboxes=true translation-texts=InvestorsList.schemeTranslationTexts ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity class=multiselectInvestorList></span></div><p style=\"color:red; margin-left: 30px; margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.investorActivity.activityTypes.length == 0\">Please select at least one plan type</p><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.investorActivitySchemeType selected-model=InvestorsList.filtersSelected.investorActivity.category events=InvestorsList.selectInvestorActivitySchemeType extra-settings=InvestorsList.investorFilterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity class=multiselectInvestorList></span><div class=\"row hidden-xs\" style=\"margin-left:-25px; width: 400px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeInvestorType.investorTypeCategory track by $index\"><p ng-if=\"!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivitySchemeSet && option !== \'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterInvestorType.changeEventSchemeType(option)></i></span></p></div><span style=\"color:red; display: inline-block; margin-top:10px\" ng-if=\"InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0\">Please select at least one category type</span></span></div></div></div></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections style=\"display: inline\"><div class=multiselectInvestorList style=\"margin-left: 30px\"><span custom-directive=\"\" options=InvestorsList.investorActivitySchemeGroup selected-model=InvestorsList.filtersSelected.investorActivity.group events=InvestorsList.selectInvestorActivityGroupType extra-settings=InvestorsList.investorFilterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity class=\"multiselectInvestorList chGroup\"></span><div class=\"row hidden-xs\" style=\"margin-left: -25px\"><div class=col-md-12><div class=filters-selected><span><div ng-repeat=\"option in InvestorsList.selectionMadeInvestorType.investorTypeGroup track by $index\" style=\"margin-top: 10px\"><p ng-if=\"!InvestorsList.defaultInvestorActivity && !InvestorsList.defaultInvestorActivityGroupSet && InvestorsList.filtersSelected.investorActivity.category.length > 0 && option !==\'ALL\'\"><span>{{option}}</span> <span ng-if=\"option !== \'ALL\'\"><i class=cancel-icon ng-click=InvestorsList.filterInvestorType.changeEventGroupType(option)></i></span></p></div><span style=color:red ng-if=\"((InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 || InvestorsList.investorActivitySchemeGroup.length == 0) && InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0 ) || InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 && !(InvestorsList.investorActivitySchemeGroup.length == 0)\">Please select at least one scheme type </span><span style=color:red ng-if=\"InvestorsList.selectionMadeInvestorType.investorTypeCategory.length > 0 && InvestorsList.investorActivitySchemeGroup.length == 0\">No Schemes are available</span></span></div></div></div></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.INVESTOR_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeInvestorActivityOptions() ng-model=InvestorsList.filtersSelected.investorActivity.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultInvestorActivity class=disable-checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.investorActivity.options.length == 0\">Please select at least one Option Type</p><div class=filter-sub-title>Duration</div><div class=filter-sub-sections><select class=multiselectInvestorList ng-change=InvestorsList.changeInvestorDuration() ng-model=InvestorsList.filtersSelected.investorActivity.duration ng-options=\"duration.value as duration.key for duration in InvestorsList.investorFilter.DURATION\" ng-disabled=InvestorsList.defaultInvestorActivity required></select></div></div></div></div></div></div><div class=\"row visible-xs\"><div class=\"col-md-12 mobile-filter\"><div class=panel-group id=accordion><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'ELIGIBILITY\'}\" ng-click=\"InvestorsList.selectFilter({name: \'Eligibility\', key: \'ELIGIBILITY\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse1 aria-expanded=\"{{InvestorsList.selectedFilter === \'ELIGIBILITY\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>Eligibility<div>{{InvestorsList.selectionMade.eligibility.length}}</div></h4></div></a><div id=collapse1 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'ELIGIBILITY\'}\" aria-expanded=\"{{InvestorsList.selectedFilter === \'ELIGIBILITY\' ? true : false}}\"><div class=panel-body><div class=details><div class=filter-title>Filter with eligibility to approve transaction</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"eligible in InvestorsList.investorFilter.ELIGIBILITY_FILTER\"><span class=radio><input type=radio ng-model=InvestorsList.filtersSelected.eligibility ng-change=InvestorsList.changeEligibility(eligible) ng-value=eligible.value required> <span class=check></span></span><label for={{eligible.key}}>{{eligible.key}}</label></div></div></div></div></div></div><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'INVESTOR_TYPE\'}\" ng-click=\"InvestorsList.selectFilter({name: \'Investor Type\', key: \'INVESTOR_TYPE\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse2 aria-expanded=\"{{InvestorsList.selectedFilter === \'INVESTOR_TYPE\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>Investor Type<div>{{InvestorsList.selectionMade.investorType.length + InvestorsList.selectionMade.investorSubType.length}}</div></h4></div></a><div id=collapse2 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'INVESTOR_TYPE\'}\" aria-expanded=\"{{InvestorsList.selectedFilter === \'INVESTOR_TYPE\' ? true : false}}\"><div class=panel-body><div class=details><div class=filter-title>Filter by investor type</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"investor in InvestorsList.investorFilter.INVESTOR_TYPE\"><span class=radio><input type=radio ng-change=InvestorsList.changeInvestorType(investor) ng-model=InvestorsList.filtersSelected.investorType ng-value=investor.value required> <span class=check></span></span><label for={{investor.key}}>{{investor.key}}</label></div></div><div class=filter-sub-title>Investor Sub Type</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"subInvestor in InvestorsList.investorFilter.INVESTOR_SUB_TYPE\"><input type=checkbox ng-change=InvestorsList.changeInvestorSubType() ng-model=InvestorsList.filtersSelected.investorSelectedSubType[subInvestor.key] ng-value=subInvestor.value required> <span class=icon-checkbox></span> <span class=checkbox-text>{{subInvestor.key}}</span></span></div></div></div></div></div><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'OTM_REGISTERED\'}\" ng-click=\"InvestorsList.selectFilter({name: \'OTM Registered\', key: \'OTM_REGISTERED\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse3 aria-expanded=\"{{InvestorsList.selectedFilter === \'OTM_REGISTERED\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>OTM Registered<div>{{InvestorsList.selectionMade.otmOption.length}}</div></h4></div></a><div id=collapse3 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'OTM_REGISTERED\'}\" aria-expanded=\"{{InvestorsList.selectedFilter === \'OTM_REGISTERED\' ? true : false}}\"><div class=panel-body><div class=details><div class=filter-title>Have an OTM registered</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"otm in InvestorsList.investorFilter.OTM_FILTER\"><span class=radio><input type=radio ng-change=InvestorsList.changeOtmRegistered(otm) ng-model=InvestorsList.filtersSelected.otmOption ng-value=otm.value required> <span class=check></span></span><label for={{otm.key}}>{{otm.key}}</label></div></div></div></div></div></div><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'CURRENT_HOLDING\'}\" ng-click=\"InvestorsList.selectFilter({name: \'Current Holding\', key: \'CURRENT_HOLDING\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse4 aria-expanded=\"{{InvestorsList.selectedFilter === \'CURRENT_HOLDING\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>Current Holding<div>{{ InvestorsList.selectionMade.currentHoldingState.length + InvestorsList.filtersSelected.currentHolding.groupSelected.length + InvestorsList.selectionMade.currentHoldingOptions.length + InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length }}</div><span style=\"color:red; padding: 0px 5px ; border: 1px solid red; border-radius: 25%; position: absolute; right: 45px\" ng-if=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0 || InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 || InvestorsList.currHoldingSchemeGroup.length == 0 || InvestorsList.filtersSelected.currentHolding.options.length == 0\">i</span></h4></div></a><div id=collapse4 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'CURRENT_HOLDING\'}\" aria-expanded=\"{{InvestorsList.selectedFilter === \'CURRENT_HOLDING\' ? true : false}}\"><div class=panel-body><div class=details><div class=filter-title>Filter by current holding</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.CURRENT_HOLDING_FILTER\"><span class=radio><input type=radio ng-change=InvestorsList.changeHoldingState(holding) ng-model=InvestorsList.filtersSelected.currentHolding.holdingState ng-value=holding.value required> <span class=check></span></span><label for={{holding.key}}>{{holding.key}}</label></div></div><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.currentHoldingSchemeType selected-model=InvestorsList.filtersSelected.currentHolding.category events=InvestorsList.selectCurrentHoldingSchemeType extra-settings=InvestorsList.currentHoldingFilterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultcurrentHoldingSet class=multiselectInvestorList></span><p style=color:red ng-if=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0\">Please select at least one category type</p></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.currHoldingSchemeGroup selected-model=InvestorsList.filtersSelected.currentHolding.group events=InvestorsList.selectCurrentHoldingGroupType extra-settings=InvestorsList.currentHoldingFilterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultcurrentHoldingSet class=\"multiselectInvestorList chGroup\"></span><p style=color:red ng-if=\"((InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 || InvestorsList.currHoldingSchemeGroup.length == 0) && InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0) || InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 && !(InvestorsList.currHoldingSchemeGroup.length == 0)\">Please select at least one scheme type</p><p style=color:red ng-if=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length > 0 && InvestorsList.currHoldingSchemeGroup.length == 0\">No Schemes are available</p></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.CURRENT_HOLDING_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeOptionsSelected(); ng-model=InvestorsList.filtersSelected.currentHolding.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultcurrentHoldingSet> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.currentHolding.options.length == 0\">Please select at least one Option Type</p></div></div></div></div><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'SYSTEMATIC_INVESTMENT\'}\" ng-click=\"InvestorsList.selectFilter({name: \'Systematic Investment\', key: \'SYSTEMATIC_INVESTMENT\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse5 aria-expanded=\"{{InvestorsList.selectedFilter === \'SYSTEMATIC_INVESTMENT\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>Systematic Investment\'s<div>{{ InvestorsList.selectionMade.systematicActiveState.length + InvestorsList.selectionMade.systematicPlanType.length + InvestorsList.filtersSelected.systematicFilter.groupSelected.length + InvestorsList.selectionMade.systematicOptions.length + InvestorsList.selectionMadeSystematic.systematicCategory.length }}</div><span style=\"color:red; padding: 0px 5px ; border: 1px solid red; border-radius: 25%; position: absolute; right: 45px\" ng-if=\"InvestorsList.filtersSelected.systematicFilter.planTypes.length == 0 || InvestorsList.selectionMadeSystematic.systematicCategory.length == 0 || InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 || InvestorsList.systematicSchemeGroup.length == 0 || InvestorsList.filtersSelected.systematicFilter.options.length == 0\">i</span></h4></div></a><div id=collapse5 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'SYSTEMATIC_INVESTMENT\'}\"><div class=panel-body><div class=details><div class=filter-title>Filter by systematic plan</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"systematic in InvestorsList.investorFilter.SYSTEMATIC_PLAN_FILTER\"><span class=radio><input type=radio ng-change=InvestorsList.changeSystematicFilter(systematic) ng-model=InvestorsList.filtersSelected.systematicFilter.active ng-value=systematic.value required> <span class=check></span></span><label for={{systematic.key}}>{{systematic.key}}</label></div></div><div class=filter-sub-title>Select Plan Type</div><div class=filter-sub-sections><span custom-directive=\"\" options=InvestorsList.investorFilter.SYSTEMATIC_PLAN_TYPE selected-model=InvestorsList.filtersSelected.systematicFilter.planTypes events=InvestorsList.planTypeChangeEvent extra-settings=InvestorsList.filterMultiSettings translation-texts=InvestorsList.schemeTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=\"multiselectInvestorList chGroup\"></span></div><p style=\"color:red; margin-left: 30px; margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.systematicFilter.planTypes.length == 0\">Please select at least one plan type</p><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.systematicSchemeType selected-model=InvestorsList.filtersSelected.systematicFilter.category events=InvestorsList.selectSystematicSchemeType extra-settings=InvestorsList.filterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=multiselectInvestorList></span><p style=color:red ng-if=\"InvestorsList.selectionMadeSystematic.systematicCategory.length == 0\">Please select at least one category type</p></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.systematicSchemeGroup selected-model=InvestorsList.filtersSelected.systematicFilter.group events=InvestorsList.selectSystematicGroupType extra-settings=InvestorsList.filterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultsystemicSet class=\"multiselectInvestorList chGroup\"></span><p style=color:red ng-if=\"((InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 || InvestorsList.systematicSchemeGroup.length == 0) && InvestorsList.selectionMadeSystematic.systematicCategory.length == 0) || InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 && !(InvestorsList.systematicSchemeGroup.length == 0)\">Please select at least one scheme type</p><p style=color:red ng-if=\"InvestorsList.selectionMadeSystematic.systematicCategory.length > 0 && InvestorsList.systematicSchemeGroup.length == 0\">No Schemes are available</p></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.SYSTEMATIC_PLAN_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeSystematicOptions() ng-model=InvestorsList.filtersSelected.systematicFilter.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultsystemicSet> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.systematicFilter.options.length == 0\">Please select at least one Option Type</p></div></div></div></div><div class=\"panel panel-default\"><a class=accordion-toggle ng-class=\"{\'collapsed\': InvestorsList.selectedFilter !== \'INVESTOR_ACTIVITY\'}\" ng-click=\"InvestorsList.selectFilter({name: \'Investor Activity\', key: \'INVESTOR_ACTIVITY\', active: true})\" data-toggle=collapse data-parent=#accordion href=#collapse6 aria-expanded=\"{{InvestorsList.selectedFilter === \'INVESTOR_ACTIVITY\' ? true : false}}\"><div class=panel-heading><h4 class=panel-title>Investor Activity<div>{{ InvestorsList.selectionMade.investorActivityHave.length + InvestorsList.selectionMade.investorActivityType.length + InvestorsList.filtersSelected.investorActivity.groupSelected.length + InvestorsList.selectionMade.investorsActivityOptions.length + InvestorsList.selectionMade.investorActivityDuration.length + InvestorsList.selectionMadeInvestorType.investorTypeCategory.length }}</div><span style=\"color:red; padding: 0px 5px ; border: 1px solid red; border-radius: 25%; position: absolute; right: 45px\" ng-if=\"InvestorsList.filtersSelected.investorActivity.activityTypes.length == 0 || InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0 || InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 || InvestorsList.investorActivitySchemeGroup.length == 0 || InvestorsList.filtersSelected.investorActivity.options.length == 0\">i</span></h4></div></a><div id=collapse6 class=\"panel-collapse collapse\" ng-class=\"{\'in\': InvestorsList.selectedFilter === \'INVESTOR_ACTIVITY\'}\" aria-expanded=\"{{InvestorsList.selectedFilter === \'INVESTOR_ACTIVITY\' ? true : false}}\"><div class=panel-body><div class=details><div class=filter-title>Filter by recent activity of Investor(s)</div><div class=filter-sections><div class=\"radio-block eligibility-radio\" ng-repeat=\"activity in InvestorsList.investorFilter.INVESTOR_ACTIVITY_FILTER\"><span class=radio><input type=radio ng-change=InvestorsList.changeInvestorActivity(activity) ng-model=InvestorsList.filtersSelected.investorActivity.have ng-value=activity.value required> <span class=check></span></span><label for={{activity.key}}>{{activity.key}}</label></div></div><div class=filter-sub-title>Select Type of Activity</div><div class=filter-sub-sections><span custom-directive=\"\" options=InvestorsList.investorFilter.INVESTOR_ACTIVITY_TYPE selected-model=InvestorsList.filtersSelected.investorActivity.activityTypes events=InvestorsList.changeInvestorActivityType extra-settings=InvestorsList.filterMultiSettings translation-texts=InvestorsList.schemeTranslationTexts ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity checkboxes=true class=\"multiselectInvestorList ia\"></span></div><p style=\"color:red; margin-left: 30px; margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.investorActivity.activityTypes.length == 0\">Please select at least one plan type</p><div class=filter-sub-title>Select Category Type</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.investorActivitySchemeType selected-model=InvestorsList.filtersSelected.investorActivity.category events=InvestorsList.selectInvestorActivitySchemeType extra-settings=InvestorsList.investorFilterMultiSettingsTypes translation-texts=InvestorsList.categoryTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity class=multiselectInvestorList></span><p style=color:red ng-if=\"InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0\">Please select at least one category type</p></div></div><div class=filter-sub-title>Select Scheme</div><div class=filter-sub-sections><div class=multiselectInvestorList><span custom-directive=\"\" options=InvestorsList.investorActivitySchemeGroup selected-model=InvestorsList.filtersSelected.investorActivity.group events=InvestorsList.selectInvestorActivityGroupType extra-settings=InvestorsList.investorFilterMultiSettingsGroup translation-texts=InvestorsList.groupTranslationTexts checkboxes=true ng-dropdown-multiselect-disabled=InvestorsList.defaultInvestorActivity class=\"multiselectInvestorList chGroup\"></span><p style=color:red ng-if=\"((InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 || InvestorsList.investorActivitySchemeGroup.length == 0) && InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0 ) || InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 && !(InvestorsList.investorActivitySchemeGroup.length == 0)\">Please select at least one scheme type</p><p style=color:red ng-if=\"InvestorsList.selectionMadeInvestorType.investorTypeCategory.length > 0 && InvestorsList.investorActivitySchemeGroup.length == 0\">No Schemes are available</p></div></div><div class=filter-sub-title>Select an Option</div><div class=filter-sub-sections><span class=\"checkbox eligibility-radio\" ng-repeat=\"holding in InvestorsList.investorFilter.INVESTOR_OPTIONS_FILTER\"><input type=checkbox ng-change=InvestorsList.changeInvestorActivityOptions() ng-model=InvestorsList.filtersSelected.investorActivity.option[holding.identifier] ng-value=holding.value ng-disabled=InvestorsList.defaultInvestorActivity> <span class=icon-checkbox></span> <span class=checkbox-text>{{ holding.key }}</span></span></div><p style=\"color: red; margin-left: 30px;margin-bottom: 20px\" ng-if=\"InvestorsList.filtersSelected.investorActivity.options.length == 0\">Please select at least one Option Type</p><div class=filter-sub-title>Duration</div><div class=filter-sub-sections><select class=multiselectInvestorList ng-change=InvestorsList.changeInvestorDuration() ng-model=InvestorsList.filtersSelected.investorActivity.duration ng-options=\"duration.value as duration.key for duration in InvestorsList.investorFilter.DURATION\" ng-disabled=InvestorsList.defaultInvestorActivity required></select></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><span class=\"pull-right filter-buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" style=\"font-size: 14px !important\" ng-click=\"InvestorsList.resetPage(); InvestorsList.initiateFilterDefaultSelection()\">RESET</a> <button class=\"btn btn-primary-action\" ng-disabled=\"InvestorsList.selectionMadeCurrentHolding.currentHoldingCategory.length == 0 || InvestorsList.filtersSelected.currentHolding.groupSelected.length == 0 || InvestorsList.filtersSelected.currentHolding.options.length == 0 || InvestorsList.currHoldingSchemeGroup.length == 0 || InvestorsList.selectionMadeSystematic.systematicCategory.length == 0 || InvestorsList.selectionMadeInvestorType.investorTypeCategory.length == 0 || InvestorsList.filtersSelected.investorActivity.options.length == 0 || InvestorsList.filtersSelected.investorActivity.groupSelected.length == 0 || InvestorsList.investorActivitySchemeGroup.length == 0 || InvestorsList.filtersSelected.investorActivity.activityTypes.length == 0 || InvestorsList.filtersSelected.systematicFilter.options.length == 0 || InvestorsList.filtersSelected.systematicFilter.groupSelected.length == 0 || InvestorsList.systematicSchemeGroup.length == 0 || InvestorsList.filtersSelected.systematicFilter.planTypes.length == 0\" ng-click=\"InvestorsList.checkPageFilter();InvestorsList.applyFilters();InvestorsList.closeNav(); \">APPLY</button></span></div></div></div><div class=\"search-data row\"><div class=col-md-4><h3 class=\"page-title inline-block-styling\">Investors</h3></div><div class=col-md-8 ng-if=InvestorsList.tabs[0].active><div class=investors-menu><div class=search-bar><i class=search-icon></i> <input type=search class=\"investorFilter ng-pristine ng-untouched ng-valid ng-empty\" placeholder=\"Search Investor Name\" ng-model=InvestorsList.searchText ng-change=InvestorsList.searchList(); select-on-click=\"\" aria-invalid=false></div><span class=\"download-with-tooltip investor_tooltip\" ng-click=\"Investors.downloadReportList(\'Invester-list\');\"><i tooltips tooltip-template=\"Email Report\" class=white-up-icon alt=Download></i> </span><span class=filter-action ng-click=InvestorsList.openNav();><img src=assets/images/icons/filter-button.png alt=filter-button> Filter</span></div></div></div><div class=\"download dropdown pull-right\" ng-if=InvestorsList.analysisType><button class=\"btn btn-download dropdown-toggle btn-primary-action\" data-toggle=dropdown ng-click=\"InvestorsList.downloadReportList(\'Invester-list\');\"><i class=white-up-icon></i>Download reports</button><ul class=dropdown-menu><li ng-repeat=\"(key, value) in InvestorsList.ioReportUrls\" ng-click=InvestorsList.downloadReport(key,value)>{{value}}</li></ul></div><div class=\"tab-content investors-listing\"><ul class=\"nav nav-tabs transactions\"><li ng-repeat=\"tab in InvestorsList.tabs\" ng-class=\"{\'active-link\': tab.active}\"><a href=javascript:void(0); ng-click=InvestorsList.redirectToTab(tab.key)>{{tab.key}}</a></li></ul><div class=tab-content><div class=\"download dropdown pull-right\" ng-if=InvestorsList.analysisType><button class=\"btn btn-download dropdown-toggle btn-primary-action\" data-toggle=dropdown ng-click=\"InvestorsList.downloadReportList(\'Invester-list\');\"><i class=white-up-icon></i>Download reports</button><ul class=dropdown-menu><li ng-repeat=\"(key, value) in InvestorsList.ioReportUrls\" ng-click=InvestorsList.downloadReport(key,value)>{{value}}</li></ul></div><div ui-view></div></div></div></div><style>.checkbox {\n    padding-top: 10px;\n  }\n\n  .chGroup .dropdown-menu .checkbox span {\n    word-break : normal !important;\n  }\n\n  .chGroup .checkbox label, .radio label {\n    padding-left: 5px;\n  }\n\n  .chGroup .dropdown-menu .checkbox span {\n     width: auto !important;\n  }\n\n  .icon-checkbox{\n    padding-right: 20px;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .dropdown-menu {\n      left : 0px;\n      width: fit-content;\n    }\n\n    .dropdown-menu .divider {\n      margin-bottom : 25px;\n    }\n\n    .checkbox {\n      padding-top : 0px;\n    }\n\n    .investors .investors .filterSidenav .mobile-filter .panel-body .details .filter-sections .multiselect-parent .dropdown-menu li > a, .investors .investors .filterSidenav .mobile-filter .panel-body .details .filter-sub-sections .multiselect-parent .dropdown-menu li > a {\n      padding: 30px 5px 0px 5px !important;\n    }\n\n  }</style><style>.drp {\n    height: 38px !important;\n    line-height: 31px;\n    padding: 10px 10px !important;\n    text-align: center;\n    font-size: 14px;\n    border-radius: 4px;\n    background: #fff;\n    border: 1px solid #ccc;\n    text-decoration: none !important;\n    font-size: 14px;\n  }\n\n  .op button{\n    padding: 7px;\n    width: 170px;\n\n  }</style>");
$templateCache.put("app/investors/profile/investor-profile.html","<section class=investors-profile><!--<div class=\"loader popup investors-profile\"><span class=\"loading\"></span></div>--><div class=\"clearfix profile-header\"><div class=pull-left><h6 ng-bind=InvestorProfile.investorsProfileData.name></h6><ul class=list-inline><li ng-if=\"InvestorProfile.breadCrumbLabel != \'/sipcorner\'\"><a href=javaScript:void(0) ui-sref=main.investors.list>Investors </a></li><li ng-if=\"InvestorProfile.breadCrumbLabel == \'/sipcorner\'\"><a href=javaScript:void(0) ui-sref=main.sipcorner>Systematic Investments </a></li><li><span class=breadcrumb-icon></span></li><li>Investor Details</li></ul></div><div class=\"pull-right profileButtonContainer\"><div class=\"dropdown profile-dropdown\" style=margin-right:4px><button class=\"btn btn-primary-action profileButton dropdown-toggle icon-box cursor-pointer\" data-toggle=dropdown><span class=initiate-transaction-icon></span> <span class=block>Initiate Transaction</span></button><ul class=dropdown-menu><li>Initiate Transactions for</li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'SIP or Purchase\')\">SIP or Purchase</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'FLEXSIP\')\">Flex SIP</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'Switch\')\">Switch</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'Systematic Withdrawal Plan\')\">SWP</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'Systematic Transfer Plan\')\">STP</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'Redemption\')\">Redeem</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'Instant_Redemption\')\">Instant Access Facility</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'DTP\')\">TIP</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'FLEXINDEX\')\">Flex Index</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'FLEXSTP\')\">Flex STP</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'ROLLOVER\')\">Roll Over</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'ChangeDividend\')\">Change IDCW Option</a></li><li><a href=javascript:void(0) ng-click=\"InvestorProfile.updateSideBar(\'SMART_SWAP\')\">SMART SWAP</a></li></ul></div><button class=\"btn btn-primary-action profileButton\" ng-disabled=\"(InvestorProfile.investorsProfileData.PAN == \'N/A\')\" ng-if=!InvestorProfile.corporateFlag ng-click=InvestorProfile.createNewFolio()>Create New Folio</button> <button class=\"btn btn-primary-action profileButton\" ng-click=InvestorProfile.sendStatement()>Generate Statement</button></div></div><ul class=\"nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.investors.profile.portfolio>Portfolio</a></li><li ui-sref-active=active><a ui-sref=main.investors.profile.transactions>Transactions</a></li><li ui-sref-active=active><a ui-sref=main.investors.profile.basicinfo>Basic info</a></li><!--<li ui-sref-active=\"active\"><a ui-sref=\"main.investors.profile.financialgoals\">Financial Goals</a></li>--></ul><div ui-view></div></section>");
$templateCache.put("app/investors/summary/summary.html","<!--<hdfc-header></hdfc-header>--><header class=\"container-fluid summary-header affix\"><div><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/logo.png href=/dashboard></span></div></header>><ui-view></ui-view><footer class=\"summary-footer main-footer\"><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Investors.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer>");
$templateCache.put("app/leap-academy/pdf-articles/pdf-articles.html","<div class=tab-content ng-init=LeapAcademy.init()><div id=pdf-articles class=\"tab-pane fade in active\"><div class=\"search-data row\"><!--<div class=\"col-md-8 col-xs-12 col-sm-7\">\n          <i class=\"search-icon\"></i>\n          <input type=\"text\" placeholder=\"Search Trainings, Location, Date etc.\" class=\"search-bar\">\n        </div>--><div class=\"col-md-4 col-xs-12 col-sm-4 pull-right sort-by\"><div class=\"sort-data pull-right\"><!--Put datepicker over here--><!--<select class=\"pull-right sort-options\">\n              <option label=\"Sort By\" value=\"\" selected=\"selected\">Sort By</option>\n              <option label=\"Option 1\" value=\"\">Option 1</option>\n              <option label=\"Option 2\" value=\"\">Option 2</option>\n              <option label=\"Option 3\" value=\"\">Option 3</option>\n              <option label=\"Option 4\" value=\"\">Option 4</option>\n            </select>--></div></div></div><div class=data><div class=\"row body-content articleContainer\" ng-repeat=\"articles in LeapAcademy.pdfArticles\"><div class=\"col-md-12 col-center\"><div class=col-md-3><img ng-if=\"articles.fileType==\'PDF\'\" ng-src=\"{{articles.thumbnailUrl.trim()||\'assets/images/pdf.png\'}}\" alt=thumbnail> <img ng-if=\"articles.fileType==\'VIDEO\'\" ng-src=\"{{articles.thumbnailUrl.trim()||\'assets/images/video.png\'}}\" alt=thumbnail></div><div class=\"col-md-6 leap-data\"><div><h5 class=\"text-blue session-heading\"><strong>{{articles.articleName}}</strong></h5><p><small>by {{articles.author}}</small></p><p class=fact><small>{{articles.text}}</small></p></div></div><div class=\"col-md-3 text-right\"><button class=\"btn btn-secondary-action\" ng-if=\"articles.fileType==\'PDF\'\" ng-click=LeapAcademy.downloadPdf(articles)><i class=download2-icon></i>Download PDF</button> <button class=\"btn btn-secondary-action btn-video\" ng-if=\"articles.fileType==\'VIDEO\'\" ng-click=LeapAcademy.showVideo(articles.url)>Watch Video</button></div></div></div><hr><div class=\"text-center pd20\" ng-if=\"!(LeapAcademy.totalPdfArticles) && !LeapAcademy.isLoading\">No Record found</div><!--Pagination Goes here--></div></div></div>");
$templateCache.put("app/leap-academy/training-classes/training-classes.html","<div class=tab-content ng-init=LeapAcademy.init()><div id=training-classes class=\"tab-pane fade in active\"><div class=\"search-data row\"><!--<div class=\"col-md-8 col-xs-12 col-sm-7\">\n          <i class=\"search-icon\"></i>\n          <input type=\"text\" placeholder=\"Search Trainings, Location, Date etc.\" class=\"search-bar\">\n        </div>--><div class=\"col-md-4 col-xs-12 col-sm-4 pull-right sort-by\"><div class=\"sort-data pull-right\"><!--Put datepicker over here--><!--            <input date-range on-date-change=\"LeapAcademy.filterByDate\" placeholder=\"From Date -> To Date\"\n                   date-default=\"LeapAcademy.dateFilter\" class=\"date-picker\" type=\"text\"/>--></div></div></div><div class=data><div class=\"row body-content\" ng-repeat=\"data in LeapAcademy.trainingClassesList\"><div class=\"col-md-12 col-center\"><div class=col-md-3><img ng-src={{data.thumbnailUrl}} alt=\"\" class=img-responsive></div><div class=\"col-md-6 leap-data\"><div><a class=\"text-blue session-heading\" ng-click=LeapAcademy.getAgenda(data); href=\"\"><strong>{{data.name}}</strong></a><p><small>by {{data.owner}}</small></p><div class=venue><span class=mobile-block><i class=calendar-icon></i> <span>{{data.date}}</span> </span><span class=mobile-block><i class=clock-icon></i> <span>{{data.startTime}} to {{data.endTime}}</span> </span><span class=mobile-block><i class=location-icon></i> <span>{{data.location}}</span></span></div><!-- <p class=\"available-seats\"><small>{{data.seatsAvailable}} seats available</small></p>--></div></div><div class=\"col-md-3 text-right\"><button class=\"btn btn-secondary-action\" ng-disabled=data.isRegistered ng-click=LeapAcademy.registerTC(data);>Register Now</button></div></div></div><div class=\"text-center pd20\" ng-if=\"!(LeapAcademy.totalTrainingClassesData) && !LeapAcademy.isLoading\">No training classes are planned at your branch.</div><!--  Pagination Goes here\n        -----------------------------><div ng-if=LeapAcademy.isPaginationTC class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"LeapAcademy.totalTrainingClassesData <= LeapAcademy.PAGE_LIMITS[0]\" ng-bind=LeapAcademy.totalTrainingClassesData></span><select ng-if=\"LeapAcademy.totalTrainingClassesData > LeapAcademy.PAGE_LIMITS[0]\" ng-change=LeapAcademy.limitChangedTC() ng-model=LeapAcademy.selectedPageLimitTC ng-options=\"_limit as _limit for _limit in LeapAcademy.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=LeapAcademy.totalTrainingClassesData></span></div><ul uib-pagination total-items=LeapAcademy.totalTrainingClassesData ng-model=LeapAcademy.currentPageTC max-size=5 items-per-page=LeapAcademy.selectedPageLimitTC class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=LeapAcademy.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/mobile/faq/faq.html","<!--dynamic data faq--><ng-bind-html dynamic=Faq.DynamicDataFaq.content></ng-bind-html>");
$templateCache.put("app/mobile/tnc/mobile.tnc.html","<div class=modal-content id=tnc ng-init=Modal.init()><div data-ng-switch=Modal.transactionType><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionSip.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General_SIP\"></div></div><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=STP><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=Flex_STP><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=FLEX_INDEX><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/components/modal/termcondition/termsAndConditionSmartSwap.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General_SMART_SWAP\"></div></div><div data-ng-switch-when=SIP_E_MANDATE><div data-ng-include=\"\'app/components/modal/termcondition/termconditionEMandate.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General_EMANDATE\"></div></div><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=FLEXSIP><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionFlexSip.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General_FlEX_SIP\"></div></div><div data-ng-switch-when=SIP_MODIFY_OTM><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionSipModifyOtm.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.MODIFY_TNC_OTM\"></div></div><div data-ng-switch-when=INSTANT_REDEMPTION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/components/modal/termcondition/termAndConditionEcart.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General_Ecart\"></div></div><div data-ng-switch-when=DISTRIBUTOR_COBM><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_General\"></div></div><div data-ng-switch-when=COBM><div data-ng-include=\"\'app/components/modal/termcondition/termcondition-addBank.modal.html\'\" ng-init=\"TermsCondition = Modal.dynamicTerms.TNC_COBM\"></div></div></div></div>");
$templateCache.put("app/mobile/tpv/tpv.html","<!DOCTYPE html><html><head><meta http-equiv=content-type content=\"text/html; charset=UTF-8\"><style>table,th,td{\n      border:1px solid black;\n      border-collapse: collapse;\n      text-align: center;\n      padding: 3px;\n    }\n    table tr th{\n      font-weight: 700;\n      padding: 15px;\n    }</style></head><body><div style=\"padding: 6px\"><table style=\"width: 100%\"><tbody><tr bgcolor=103880 style=color:#fff><th width=25%>S.No</th><th width=75%>Bank Name</th></tr><tr><td>1.</td><td>Andhra Bank</td></tr><tr><td>2.</td><td>AXIS Bank LTD</td></tr><tr><td>3.</td><td>BANK OF INDIA</td></tr><tr><td>4.</td><td>Bank of Baroda</td></tr><tr></tr><tr><td>5.</td><td>Bank of Maharashtra</td></tr><tr><td>6.</td><td>Canara Bank</td></tr><tr><td>7.</td><td>Central Bank of India</td></tr><tr><td>8.</td><td>City Union Bank</td></tr><tr><td>9.</td><td>Corporation Bank</td></tr><tr><td>10.</td><td>DENA Bank</td></tr><tr><td>11.</td><td>HDFC Bank Ltd</td></tr><tr><td>12.</td><td>ICICI Bank</td></tr><tr><td>13.</td><td>IDBI Bank</td></tr><tr><td>14.</td><td>IndusInd Bank</td></tr><tr><td>15.</td><td>Indian Overseas Bank</td></tr><tr><td>16.</td><td>Karur Vysya Bank</td></tr><tr><td>17.</td><td>Karnataka Bank</td></tr><tr><td>18.</td><td>Kotak Mahindra Bank</td></tr><tr><td>19.</td><td>Lakshmi Vilas Bank</td></tr><tr><td>20.</td><td>Punjab National Bank</td></tr><tr><td>21.</td><td>State Bank of India</td></tr><tr><td>22.</td><td>Syndicate Bank</td></tr><tr><td>23.</td><td>South Indian Bank</td></tr><tr><td>24.</td><td>Standard Chartered Bank</td></tr><td>25.</td><td>Union Bank of India</td><tr><td>26.</td><td>YES Bank Ltd</td></tr></tbody></table></div></body></html>");
$templateCache.put("app/new-investor/folio-creation/folio-creation.html","<div class=container-fluid ng-init=NewFolioCreation.init()><div class=\"kyc-form-container row\"><div class=col-xs-12><div class=\"form-page-header row\" style=\"margin: 0px 0px 0px -50px\" ng-if=\"myState != \'/folio-Summary-details\'\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;background-color: transparent;padding-right: 0px\"><img ng-click=folioBackButton() ng-hide=\"((myState ==\'/folio-basic-details\' || myState == \'/folio-basic-minor-details\') && NewFolioCreation.skipInvestmentDetails)\" src=../../../assets/images/back-button.svg alt=\"\" style=\"width: 19px;height: 13px;margin: 0px 10px 0px 0px\"><h4 class=mainStep2 style=\"white-space: nowrap\" ng-if=!NewFolioCreation.skipInvestmentDetails>Step 3</h4><h4 class=mainStep2 style=\"white-space: nowrap\" ng-if=NewFolioCreation.skipInvestmentDetails>Step 2</h4></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;align-items: center\"><p class=mainTitile ng-if=\"myState ==\'/folio-basic-details\' || myState == \'/folio-basic-minor-details\' \">Please provide basic details to help us build your folio!</p><p class=mainTitile ng-if=\"myState ==\'/folio-income-details\'\">Great Going!Help us with income details</p><p class=mainTitile ng-if=\"myState ==\'/folio-guardian-minor-details\'\">Great Going!Help us with guardian details</p><p class=mainTitile ng-if=\"myState ==\'/jointholder\' && !NewFolioCreation.showholderdetails\">Great Going!Help us with Unit/First Holder details!</p><p class=mainTitile ng-if=\"myState ==\'/jointholder\' && NewFolioCreation.showholderdetails && !NewFolioCreation.addholder.steps[2].isactive\">Add Holder</p><p class=mainTitile ng-if=\"myState ==\'/jointholder\' && NewFolioCreation.showholderdetails && NewFolioCreation.addholder.steps[2].isactive\">Please provide holder\'s details</p><p class=mainTitile ng-if=\"myState == \'/folio-nominee-details\' \">You are almost there!</p><p class=mainTitile ng-if=\"myState == \'/bankdetails\' \">Add bank Details!</p></div></div><div class=\"form-page-container row\"><div class=col-xs-12 style=\"align-items: flex-start\"><div ng-if=\"myState != \'/folio-Summary-details\'\"><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Self\' && folioBasicDetail.folioHoldingMode == \'SINGLE\'\" steps=stepperThird></horizontal-progress-sidebar><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Minor\'\" steps=stepperForMinor></horizontal-progress-sidebar><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Self\' && folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\'\" steps=stepperForAnyoneSurvivor></horizontal-progress-sidebar></div><div ui-view></div></div></div></div></div></div><style>@media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small {\n      width: 163px !important;\n    }\n\n    .stepper-horizontal-responsive .step li {\n      z-index: 5;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2) {\n      z-index: 4;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3) {\n      z-index: 3;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4) {\n      z-index: 2;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5) {\n      z-index: 1;\n    }\n  }</style>");
$templateCache.put("app/new-investor/investment-detail/investment-detail.html","<div class=container-fluid ng-init=InvestmentDetail.init()><div class=\"kyc-form-container row\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;background-color: transparent;padding-right: 0px\"><img ng-click=logoutBtn() src=../../../assets/images/back-button.svg alt=\"\"><h4 class=mainStep2 style=\"white-space: nowrap\">Step 2</h4></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;align-items: center;padding-left: 5px\"><!-- <p>{{currentstate}}</p> --><!-- <p ng-if=\"stepperSecondary.steps[0].stepCompleted == false\" >Select a scheme based on your requirements and start investing!</p> --><p class=mainTitile ng-if=\"currentstate == \'/choose-scheme\' || currentstate == \'/investment-goal\' \">Select a scheme based on your requirements and start investing!</p><!-- <p ng-if=\"stepperSecondary.steps[1].stepActive == true && stepperSecondary.steps[1].stepCompleted == false \">Help us with your investment details!</p> --><p class=mainTitile ng-if=\"currentstate == \'/Investment-mode\'\">Help us with your investment details!</p><!-- <p ng-if=\"stepperSecondary.steps[2].stepActive == true || stepperSecondary.steps[3].stepActive == true \">Last few questions on investment details!</p> --><p class=mainTitile ng-if=\"currentstate == \'/amount-detail\' \">Last few questions on investment details!</p><!-- <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[1].stepActive == true && stepperSecondary.steps[1].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved1</button>\n          <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[2].stepActive == true && stepperSecondary.steps[2].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved2</button>\n          <button type=\"button\" \n          ng-if=\" stepperSecondary.steps[3].stepActive == true && stepperSecondary.steps[3].stepCompleted == false \"\n          style=\"background-color: white;border-radius: 10px;width: 100px;border: 1px solid blue;\">Saved3</button> --></div><div class=\"form-page-container row\"><div class=col-xs-12 style=\"align-items: flex-start\"><div><horizontal-progress-sidebar steps=stepperSecondary></horizontal-progress-sidebar><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Minor\'\" steps=FolioDetails.stepperForMinor></horizontal-progress-sidebar></div><horizontal-progress-sidebar ng-if=\"folioBasicDetail.folioForUser == \'Self\' && folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\'\" steps=FolioDetails.stepperForAnyoneSurvivor></horizontal-progress-sidebar><div ui-view></div></div></div></div></div></div><style>@media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small {\n      width: 163px !important;\n    }\n\n    .stepper-horizontal-responsive .step li {\n      z-index: 5;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2) {\n      z-index: 4;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3) {\n      z-index: 3;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4) {\n      z-index: 2;\n    }\n\n    .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5) {\n      z-index: 1;\n    }\n  }</style>");
$templateCache.put("app/new-investor/kyc-verification/kyc-verification.html","<div class=container-fluid><div class=\"kyc-form-container row\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h4 class=mainStep2>Step 1</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p class=mainTitile style=\"padding: 15px 0 0 0\">Verify KYC status to start your investment journey with us!</p></div></div><div class=\"form-page-container row\"><div class=col-xs-12><form class=verification-form autocomplete=off name=signupForm ng-submit=KycVerification.verifyDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-8\"><div class=tax-status-container><label class=s-label>Tax Status</label><div class=tax-field-container><div class=flex-check><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=KycVerification.formData.taxStatusResident><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{KycVerification.AppConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=flex-check><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=KycVerification.formData.taxStatusResident><label for=tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{KycVerification.AppConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div><div class=col-md-3></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=pan-input-container><label id=panevent ng-click=KycVerification.getModal() style=\"display: none\">Click</label><label for=pan class=s-label>PAN</label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=KycVerification.formData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=KycVerification.resetValues() ng-blur=KycVerification.checkPanVerification() placeholder=\"e.g. PGHPD4532M\" autofocus capitalize required> <span ng-show=\"signupForm.pan.$dirty && signupForm.pan.$invalid\"><span class=error-input ng-show=signupForm.pan.$error.required ng-bind=KycVerification.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=signupForm.pan.$error.maxlength ng-bind=KycVerification.validateData.PAN_FIELD></span> <span class=error-input ng-show=signupForm.pan.$error.pattern ng-bind=KycVerification.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=KycVerification.panMessage ng-bind=KycVerification.panMessage></span></div></div><div class=col-md-3></div><div class=\"col-xs-12 col-md-4 hidden-xs\"><!--                <div class=\"warning1\">--><!--                  <img src=\"../../../assets/images/icons/light-bulb.png\" style=\"width: 25px;height: 25px;\">--><!--                  <div class=\"wardiv\">Applicant\'s age should be 18 years or above</div>--><!--                </div>--></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=dob-input-container><label for=dobId class=s-label>Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{KycVerification.viewMode}} data-date-default=KycVerification.formData.dob data-on-date-change=KycVerification.changeStartDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 336px;\n                    height: 40px;\n                    border-radius: 5px;\n                    border: 1px solid #B8C6D1; margin-bottom: 0px\"><input class=newinvestor-dob tabindex=2 id=dobId name=dob type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=KycVerification.autoDate() required style=\"border: none;font-size: 14px\"> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png></span></div><span class=error-input ng-if=KycVerification.dateErrorMessage ng-bind=KycVerification.dateErrorMessage></span></div></div></div><!-- Start us/canada yes not --><!--<div style=\"display: flex;justify-content: flex-start;\">\n  <input class=\"nomineeCheckbox\"\n    type=\"checkbox\"\n    id=\"confirmfoliocreate\"\n    name=\"confirmfoliocreate\"\n    ng-click=\"KycVerification.getconformation()\"\n    ng-checked=\"KycVerification.conformation == \'US_CANADA\'\">\n  <label for=\"confirmfoliocreate\" class=\"confirmationnote\" style=\"font-size: 12px;\">\n    &nbsp;</label><label style=\"margin-top: 5px;\">I am a US Person/Resident of Canada.</label>\n</div>--><div style=\"display: flex;justify-content: flex-start\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate1 name=confirmfoliocreate1 ng-click=KycVerification.getconformation1() ng-checked=\"KycVerification.conformation == \'NOT_US_CANADA\'\"><label for=confirmfoliocreate1 class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">I am not a US Person/Resident of Canada.</label></div><!-- End us/canada yes not --><!-- <div style=\"display: flex;justify-content: flex-start;\">\n              <input class=\"nomineeCheckbox\" type=\"checkbox\" id=\"confirmfoliocreate\" name=\"confirmfoliocreate\"\n                ng-click=\"KycVerification.getconformation()\" ng-checked=\"KycVerification.conformation\">\n              <label for=\"confirmfoliocreate\" class=\"confirmationnote\" style=\"font-size: 13px;\">\n                &nbsp;</label><label style=\"margin-top: 5px;\"> I have read and accepted the\n              <span ng-click=\"KycVerification.termandCondition()\"\n              style=\"font-size: 13px;color: blue;margin-top: 6px;\">\n                Terms & Conditions</span></label>\n            </div> --><div class=kyc-verify><button tabindex=3 type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"signupForm.pan.$invalid ||\n                !KycVerification.formData.dob ||\n                 KycVerification.panMessage\n                || KycVerification.processFlag || !KycVerification.conformation\">VERIFY</button></div></form></div></div></div></div></div><style>@media only screen\nand (min-device-width : 768px)\nand (max-device-width : 768px) {\n  .kyc-verify{\n    width: 163px !important;\n  }\n  .hidden-xs{\n    width: 78%;\n  }\n}</style>");
$templateCache.put("app/new-investor-approve/folio/folio.html","<div ui-view></div>");
$templateCache.put("app/new-investor-approve/payment/new-investor-payment.html","<!-- <button tabindex=\"3\" type=\"submit\" class=\" btn-new-journey-color hdfc-blue-cta-small\"\nng-click=\"NewInvestorPayment.openModel()\">VERIFY</button>\n\n<button tabindex=\"3\" type=\"submit\" class=\" btn-new-journey-color hdfc-blue-cta-small\"\nng-click=\"NewInvestorPayment.getNormalSIPBank()\">GET bank</button> --><div class=payment style=\"display: inline\"><br><br><!-- FOR SIP WITH NO 1st INSTALLMENT --><div class=main ng-if=\"NewInvestorPayment.onlySipInvestment && !NewInvestorPayment.showSummary\" style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div style=\"padding: 50px;margin: inherit\" class=main-padding><div style=\"padding: 10px\"><p style=\"font-weight: bold;margin-left: 10px\">Investment Summary</p><br></div><div class=\"seocndrow row\" style=\"padding: 10px\"><div class=\"col-xs-12 col-md-6 informationData\"><!-- folio number --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Folio Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><br><!-- Transaction --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Transaction Type</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentType}}</p></div></div><br><!-- Scheme Name --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Fund Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.fundName}}</p></div></div><br><!-- Investment Option --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><p class=font-weight-bold>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- IDWC --><div class=row ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=\"col-xs-5 col-md-5\"><p>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p class=font-weight-bold>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p class=font-weight-bold>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- Amount --><div class=row><div class=\"col-xs-5 col-md-5\"><p>Amount</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> {{NewInvestorPayment.formData.amount |unitWithOutDecimalFilter:NewInvestorPayment.formData.amount}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment Start Date</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.installmentStartDate}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Investment End Date</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.installmentEndDate}}</p></div></div><br></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=\"col-xs-5 col-md-5\"><p>Frequency</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-size: 14px;color: #000000\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'OM\'\">Monthly</p><p style=\"font-size: 14px;color: #000000\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Q\'\">Quaterly</p><p style=\"font-size: 14px;color: #000000\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'H\'\">Half Yearly</p><p style=\"font-size: 14px;color: #000000\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Y\'\">Yearly</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Bank Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"color: #000000;font-size: 14px;word-break: break-all\">{{NewInvestorPayment.formData.bankInfo.bankNameOnly}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Email</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"color: #000000;font-size: 14px;word-break: break-all\">{{NewInvestorPayment.formData.emailId}}</p></div></div><br><div class=row><div class=\"col-xs-5 col-md-5\"><p>Mobile Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p style=\"font-size: 14px;color: #000000\">{{NewInvestorPayment.formData.mobileNo}}</p></div></div><br></div></div><p style=\"font-weight: bold;margin-left: 10px;padding: 10px\">Transaction acknowledgement email and SMS will be sent to email ID and mobile number registered in the folio shown above.</p><br><div class=lessPadding><div class=tc-block><h6>Terms & Conditions</h6><div style=\"margin: 20px 0px 0px 0px\"><div class=checkbox><input id=isCheckedTandC ng-model=NewInvestorPayment.onlySipSummary type=checkbox> <i class=icon-checkbox></i></div><span for=isCheckedTandC class=checkbox-text style=\"padding-left: 8px\">I have read and understood <a href={{NewInvestorPayment.tncURL}} target=_blank>Terms & Conditions</a> of Investment</span></div></div><div class=\"col-xs-12 col-md-12 centeredButton\"><input type=hidden id=hfReq><div><button ng-disabled=!NewInvestorPayment.onlySipSummary||!NewInvestorPayment.formData ng-click=NewInvestorPayment.submitSipForm() class=\"btn-primary-action-pay btn pull-right\" style=\"border-radius: 40PX\">COMPLETE TRANSACTION</button></div></div></div></div></div><!-- Manual instuction --><div class=main ng-if=\"NewInvestorPayment.onlySipInvestment && NewInvestorPayment.showSummary\" style=\"background-color: white;box-shadow: -1px 1px 5px 1px lightgrey\"><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto;padding: 15px 0px 30px 0px\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font-size: large; font-weight: bold;color: #0d41a1;margin: 15px 0px 0px 0px\">Transaction Completed Successfully!</p></div><div class=row style=\"margin-top: 50px;width: 98%\"><div class=\"boxdiv col-md-12\" style=\"border: 1px solid gray;border-radius: 8px;padding: 10px;margin-left: 5%;width: 96%\"><div class=\"sipsecondd!NewInvestorPayment.confirmation || !NewInvestorPayment.formData.paymentInfo.bankName || !NewInvestorPayment.formData.paymentInfo.accountNumber || NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\'\"><p style=\"font-weight: 600\">SIP Registration Summary</p><br><br><div class=row><div class=col-md-6><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">SIP Registration Number</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\">{{NewInvestorPayment.srnNo}}</p></div></div><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">Bank Name</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.bankInfo.bankNameOnly}}</p></div></div><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">Source Fund Name</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.schemeName}}</p></div></div><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">Investment Option</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p style=\"font-weight: 500\">{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><p style=\"font-weight: 500\">Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><!-- IDWC --><div class=\"row p-short\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">Income Distribution cum Capital Withdrawal (IDCW) Option</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p style=\"font-weight: 500\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p style=\"font-weight: 500\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br></div><div class=\"col-sm-12 col-xs-12 col-md-6\"><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">SIP Installment Amount</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\"><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> {{NewInvestorPayment.formData.amount|unitWithOutDecimalFilter:NewInvestorPayment.formData.amount}}</p></div></div><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">SIP Frequency</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'OM\'\">Monthly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Q\'\">Quarterly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'H\'\">Half Yearly</p><p style=\"font-weight: 500\" ng-if=\"NewInvestorPayment.formData.installmentFrequency == \'Y\'\">Yearly</p></div></div><div class=\"row p-short\"><div class=\"col-sm-7 col-xs-7 col-md-7 padding-min-sipNormal\">Transaction Initiate Date</div><div class=\"col-sm-1 col-xs-1 col-md-1 padding-min-sipNormal\">:</div><div class=\"col-sm-4 col-xs-4 col-md-4 padding-min-sipNormal\"><p style=\"font-weight: 500\">{{NewInvestorPayment.SIPtransactionInitiateDate}}</p></div></div></div></div></div></div></div><br><div style=\"padding: 30px 0px 10px 40px\" ng-if=\"NewInvestorPayment.formData && !NewInvestorPayment.formData.sipFI && NewInvestorPayment.formData.topUpEnable\"><p style=\"padding: 10px 0px 10px 0px;font-weight: 600;font-size: 12px\">SIP Top up Details</p><div class=row><div class=col-md-2><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'OM\'\">SIP Top up Frequency : Monthly</p><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'Y\'\">SIP Top up Frequency : Yearly</p><p style=\"font-size: 11px\" ng-if=\"NewInvestorPayment.formData.topUpDetails.frequency == \'H\'\">SIP Top up Frequency : Half Yearly</p></div><div class=col-md-5><p style=\"font-size: 11px\">SIP Top up Cap Amount/SIP Top up Cap Month & Year : {{NewInvestorPayment.formData.topUpDetails.capAmount ? NewInvestorPayment.formData.topUpDetails.capAmount: NewInvestorPayment.formData.topUpDetails.capMonthYear}}</p></div><div class=col-md-5><p style=\"font-size: 11px\">SIP Top up Cap Amount/SIP Top up Percentage : {{NewInvestorPayment.formData.topUpDetails.amount ? NewInvestorPayment.formData.topUpDetails.amount : NewInvestorPayment.formData.topUpDetails.percentage}}.00</p></div></div></div><br><div class=text-center><!-- <button style=\"padding: 10px 25px 10px 25px;\n                        border: none;\n                        height: 40px;\n                        box-shadow: 0px 1px 10px 0 rgb(17 17 19 / 25%);\n                        color: #fff;\n                        background-color: #FF8486;\n                        border-radius: 40px;\" ng-click=\"NewInvestorPayment.gotoprofile()\"> Proceed with\n        Registration</button> --></div><!-- SIP top up details --><br><br></div><!-- summary for RTGS / HDFC --><div class=main ng-if=NewInvestorPayment.showTransactionSummaryForRTGSorHDFC style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><div class=col-md-6 style=\"padding: 30px;border-right: 1px solid #B8C6D1\"><div class=row style=\"padding: 10px\"><div class=\"col-xs-5 col-sm-5 col-md-5 padding-min\"><p>Folio Number</p></div><div class=\"col-xs-1 col-sm-1 col-md-1 padding-min\"><p>:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 padding-min\"><p>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><div class=row style=\"padding: 10px\"><div class=\"col-xs-5 col-sm-5 col-md-5 padding-min\"><p>CAMS Reference No.</p></div><div class=\"col-xs-1 col-sm-1 col-md-1 padding-min\"><p>:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 padding-min\"><p>{{NewInvestorPayment.transactionDetails.camsReferenceNumber}}</p></div></div><div class=row style=\"padding: 10px\"><div class=\"col-xs-5 col-sm-5 col-md-5 padding-min\"><p>Transaction Type</p></div><div class=\"col-xs-1 col-sm-1 col-md-1 padding-min\"><p>:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 padding-min\"><p>{{NewInvestorPayment.formData.investmentType}}</p></div></div><div class=row style=\"padding: 10px\"><div class=\"col-xs-5 col-sm-5 col-md-5 padding-min\"><p>Fund Name</p></div><div class=\"col-xs-1 col-sm-1 col-md-1 padding-min\"><p>:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 padding-min\"><p>{{NewInvestorPayment.formData.fundName}}</p></div></div><div class=row style=\"padding: 10px\"><div class=\"col-xs-5 col-sm-5 col-md-5 padding-min\"><p>Amount</p></div><div class=\"col-xs-1 col-sm-1 col-md-1 padding-min\"><p>:</p></div><div class=\"col-xs-6 col-sm-6 col-md-6 padding-min\"><p><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> {{NewInvestorPayment.formData.amount |unitWithOutDecimalFilter:NewInvestorPayment.formData.amount}}</p></div></div></div><div class=col-md-6 style=\"padding: 30px\"><div style=\"display: flex;\n                            justify-content: center;\n                            flex-direction: column;\n                            align-items: center;\n                            margin: 50px 0px 0px 0px\"><img src=../../../assets/images/icons/verified.png alt=\"\" srcset=\"\"><p style=\"padding: 10px;color: darkgreen\">Transaction Completed Successfully</p><!-- <p style=\"padding: 10px;color: #244b8c;font-weight: bold;\" ng-click=\"NewInvestorPayment.gotoprofile()\">\n            Register user ID</p> --></div></div></div></div><!-- SIP 1st Installment or Purchase --><div class=main ng-if=\"!NewInvestorPayment.onlySipInvestment  && !NewInvestorPayment.showTransactionSummaryForRTGSorHDFC\" style=\"box-shadow: -1px 1px 5px 1px lightgrey\"><div class=row><div class=\"note col-sm-12 col-md-12\" style=\"margin: auto\"><img src=../../../assets/images/congratulation.png alt=\"\" style=\"height: 50px; margin-top: 5px\"><p style=\"font: normal normal 600 18px/30px Poppins;\n                            letter-spacing: 0px;\n                            color: #000000\">Congratulations {{NewInvestorPayment.userName}}!</p><br><p style=\"font: normal normal normal 16px/30px Poppins;\n                            letter-spacing: 0px;\n                            color: #000000\">Complete your first payment to start investing!</p></div></div><br><br><!--  --><div class=\"seocndrow row\"><div class=\"col-xs-12 col-md-5 informationData\"><p style=\"font-weight: bold\">Investment Summary</p><br><!-- folio number --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Folio Number</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.folioNumber}}</p></div></div><br><!-- Transaction --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Transaction Type</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentType}}</p></div></div><br><!-- Scheme Name --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Fund Name</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold>{{NewInvestorPayment.formData.fundName}}</p></div></div><br><!-- Investment Option --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Investment Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'GROWTH\' \"><p class=font-weight-bold>{{NewInvestorPayment.formData.investmentOption}}</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\' \"><p class=font-weight-bold>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- IDWC --><div class=row ng-if=\"NewInvestorPayment.formData.investmentOption.toUpperCase() == \'DIVIDEND\'\"><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'Y\' \"><p class=font-weight-bold>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div><div class=\"col-xs-5 col-md-6\" ng-if=\"NewInvestorPayment.formData.dividendOption == \'N\' \"><p class=font-weight-bold>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</p></div></div><br><!-- Amount --><div class=row><div class=\"col-xs-5 col-md-5\"><p class=summaryKey>Amount</p></div><div class=\"col-xs-1 col-md-1\"><p>:</p></div><div class=\"col-xs-5 col-md-6\"><p class=font-weight-bold><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> {{NewInvestorPayment.formData.amount |unitWithOutDecimalFilter:NewInvestorPayment.formData.amount}}</p></div></div><br></div><div class=\"col-xs-12 col-md-7 paymentmodeData\"><p class=paymentmodetitle>Payment Mode</p><br><div class=\"bankCard row\"><div class=\"desktopMode col-xs-12 col-md-4\"><div ng-attr-class=\"{{(NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' || NewInvestorPayment.formData.purchasePaymentOption == \'WEB\') ? \'menu2 row\' : \'menu row\'}}\" style=\"border-top-left-radius: 10px\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'NETBANKING\')\" ng-attr-class=\"{{ (NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\'|| NewInvestorPayment.formData.purchasePaymentOption == \'WEB\') ? \'c-pink\' : \'c-blue\'}}\">Net Banking</p></div></div><div ng-if=!NewInvestorPayment.sipFirstInstallmentVisible ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' ? \'menu2 row\' : \'menu row\'}}\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'RTGS\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' ? \'c-pink\' : \'c-blue\'}}\">NEFT/RTGS</p></div></div><div ng-if=!NewInvestorPayment.sipFirstInstallmentVisible ng-attr-class=\"{{NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'menu2 row\' : \'menu row\'}}\" style=\"border-bottom-left-radius: 10px;border-bottom: none\"><div class=\"col-sm-12 col-md-12\"><p ng-click=\"NewInvestorPayment.getPaymenMode(\'UPI\')\" ng-attr-class=\"{{ NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' ? \'c-pink\' : \'c-blue\'}}\">UPI</p></div></div></div><!-- for mobile --><div class=\"mobileMode col-xs-12 col-md-8\"><p style=\"font-size: 18px;font-weight: bold;line-height: 26px;margin-bottom: 14px\">Select payment option to make your first investment</p><p style=\"font-size: 18px;font-weight: bold;line-height: 26px;margin-bottom: 14px\">Payment Mode</p><form name=getGetPaymentMode><select class=\"form-control selectNormal width100\" name=paymentMode id=paymentMode ng-model=NewInvestorPayment.formData.purchasePaymentOption style=\"margin-top: 10px;margin-bottom: 10px\" ng-change=NewInvestorPayment.getPaymenMode(NewInvestorPayment.formData.purchasePaymentOption)><option ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' || NewInvestorPayment.formData.purchasePaymentOption == \'WEB\'\" value=NETBANKING>Net Banking</option><option ng-if=!NewInvestorPayment.sipFirstInstallmentVisible ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' \" value=RTGS>NEFT/RTGS</option><option ng-if=!NewInvestorPayment.sipFirstInstallmentVisible ng-selected=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\' \" value=UPI>UPI</option></select></form></div><div class=\"col-xs-12 col-md-8\"><!-- Net Banking --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' || NewInvestorPayment.formData.purchasePaymentOption == \'WEB\'\" style=\"margin-bottom: 20px\"><p style=\"margin: 20px 0px 5px -8px;font: normal normal bold 11px/14px Poppins;\n                                        letter-spacing: 0px;\n                                        color: #000000;\n                                        opacity: 1\">Select Bank</p><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid}><input type=\"text inputPayment\" class=form-control name=bank id=bank ng-model=NewInvestorPayment.formData.paymentInfo.bankName autocomplete=off ng-required=!NewInvestorPayment.formData.paymentInfo only-alphabets style=\"border: none;border: 1px solid gray;height: 40px;border-radius: 5px\"> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=NewInvestorPayment.netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=NewInvestorPayment.changeBank() model=NewInvestorPayment.formData.paymentInfo for=bank></bank-drop-down></div></div><!-- NEFT/RTGS --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\'\"><div><br><p>{{NewInvestorPayment.PATTERN.RTGS_MESSAGE}}</p><br><div style=\"display: flex\" class=neft-form-switch><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': NewInvestorPayment.rtgsBankTogg}\">Yes</span><label class=switch style=\"max-width: 100%\"><input type=checkbox ng-model=NewInvestorPayment.rtgsBankTogg ng-click=NewInvestorPayment.selectRtgsBank() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label><span style=\"margin-left: 10px; margin-right: 10px\" class=toggle-login-text ng-class=\"{\'login-active-tab\': !NewInvestorPayment.rtgsBankTogg}\">No</span></div></div><form name=rtgsFormData1><div class=\"input-select input-normal selectfield marginBottom\" ng-class={error:rtgsFormData.bank.$dirty&&tForm.bank.$invalid} ng-if=NewInvestorPayment.rtgsBankTogg><p style=\"font-weight: bold;margin: 10px\">Select Bank</p><input type=text class=\"form-control inputPayment select-input-rtgs\" name=bank id=bank ng-model=NewInvestorPayment.formData.paymentInfo.bankNameWithAccountNumber autocomplete=off ng-required=!NewInvestorPayment.formData.paymentInfo only-alphabets> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=rtgsFormData.bank.$dirty&&rtgsFormData.bank.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_REQUIRED></span><bank-drop-down list-data=NewInvestorPayment.netBankingAndUPIList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=NewInvestorPayment.changeBank() model=NewInvestorPayment.bankInfo for=bank></bank-drop-down></div><!-- Account Type --><!--                <div class=\"row\" ng-If=\"!NewInvestorPayment.formData.paymentInfo.bankAcType\">--><!--                  <div class=\"col-xs-12 col-md-12\">--><!--                    <p class=\"investmentTitle\">Account Type</p>--><!--                  </div>--><!--                  <div class=\"col-xs-12 col-md-12\">--><!--                    <select id=\"accountType\" name=\"accountType\" class=\"form-control selectNormal\"--><!--                      ng-model=\"NewInvestorPayment.formData.paymentInfo.accType\" required>--><!--                      <option value selected=\"selected\">Select</option>--><!--                      <option ng-repeat=\"value in NewInvestorPayment.bankAccountType\"--><!--                        ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\"--><!--                        value=\"{{value.accountTypeCode}}\">{{value.accountType}}</option>--><!--                    </select>--><!--                  </div>--><!--                </div>--><!-- IFSC/NEFT Code --><!--                <div class=\"row\" ng-If=\"!NewInvestorPayment.formData.paymentInfo.ifscCode\">--><!--                  <div class=\"col-md-12\">--><!--                    <p class=\"paymentTitle\">IFSC/NEFT Code</p>--><!--                  </div>--><!--                  <div class=\"col-md-12\">--><!--                    <input type=\"text\" class=\"form-control inputPayment\"--><!--                      ng-model=\"NewInvestorPayment.formData.paymentInfo.ifscCode\" name=\"ifscCode\" required--><!--                      ng-pattern=\"NewInvestorPayment.IFSC_REGEX\" capitalize>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.required\"--><!--                      ng-bind=\"NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_FIELD\"></span>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.pattern\"--><!--                      ng-bind=\"NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_REGEX\"></span>--><!--                  </div>--><!--                </div>--><!--                <div class=\"row\">--><!--                  <div class=\"col-md-6\">--><!--                    <p class=\"paymentTitle\">UTR Number</p>--><!--                    <input type=\"text\" class=\"form-control inputPayment\" name=\"utrNumber\"--><!--                      ng-model=\"NewInvestorPayment.formData.paymentInfo.utrNumber\"--><!--                      ng-pattern=\"NewInvestorPayment.PATTERN.UTR_REGEX\" ng-maxlength=\"255\" required>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData1.utrNumber.$dirty&&rtgsFormData1.utrNumber.$error.required\"--><!--                      ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData1.utrNumber.$dirty&&rtgsFormData1.utrNumber.$error.pattern\"--><!--                      class=\"help-block\" ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_RANGE\"></span>--><!--                    <span class=\"error-input\" ng-show=\"rtgsForm.utrNumber.$dirty&&rtgsForm.utrNumber.$error.maxlength\"--><!--                      class=\"help-block\" ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_INVALID\"></span>--><!--                  </div>--><!--                  <div class=\"col-md-6\">--><!--                    <p class=\"paymentTitle\">Vefity UTR Number</p>--><!--                    <input type=\"text\" class=\"form-control inputPayment\" name=\"verifyUtrNumber\"--><!--                      ng-model=\"NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\"--><!--                      ng-pattern=\"NewInvestorPayment.formData.paymentInfo.utrNumber\" required>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData1.verifyUtrNumber.$dirty&&rtgsFormData1.verifyUtrNumber.$error.required\"--><!--                      ng-bind=\"NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED\"></span>--><!--                    <span class=\"error-input\"--><!--                      ng-show=\"rtgsFormData1.verifyUtrNumber.$dirty&&rtgsFormData1.verifyUtrNumber.$error.pattern\"--><!--                      ng-bind=\"NewInvestorPayment.VALIDATE_DATA.SAME_UTR_REQUIRED\"></span>--><!--                  </div>--><!--                </div>--><br><br></form><form name=rtgsFormData><!-- bank name --><div ng-init=NewInvestorPayment.setFormDataForNeft(rtgsFormData) ng-hide=\" (NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' && NewInvestorPayment.rtgsBankTogg && !NewInvestorPayment.bankInfo)\"><div class=row><div class=col-md-12><p class=paymentTitle>Bank name</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.bankName name=bankName only-alphabets required ng-readonly=NewInvestorPayment.rtgsBankTogg> <span class=error-input ng-show=\"rtgsFormData.bankName.$dirty && rtgsFormData.bankName.$error.required\" ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_NAME_REQUIRED></span></div></div><!-- Branch name --><div class=row><div class=col-md-12><p class=paymentTitle>Branch City</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.branchName only-alphabets name=bankBranch required ng-readonly=NewInvestorPayment.rtgsBankTogg> <span class=error-input ng-show=rtgsFormData.bankBranch.$dirty&&rtgsFormData.bankBranch.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_BRANCH_REQUIRED></span></div></div><!-- Account Number/ Verify Account Number --><div class=row><div ng-class=\"{\'col-md-12\' : NewInvestorPayment.rtgsBankTogg, \'col-md-6\' : !NewInvestorPayment.rtgsBankTogg}\"><p class=paymentTitle>Account Number</p><input type=text autocomplete=false class=\"form-control inputPayment\" ng-if=NewInvestorPayment.rtgsBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event) ng-readonly=NewInvestorPayment.rtgsBankTogg> <input type=password autocomplete=false class=\"form-control inputPayment\" ng-if=!NewInvestorPayment.rtgsBankTogg ng-model=NewInvestorPayment.formData.paymentInfo.accNo name=bankAcNo required maxlength=20 minlength=\"\" onkeypress=\"(event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-keydown=NewInvestorPayment.copyPasteHandler($event)> <span class=error-input ng-show=rtgsFormData.bankAcNo.$dirty&&rtgsFormData.bankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.bankAcNo.$dirty&&rtgsFormData.bankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span></div><div class=col-md-6 ng-if=!NewInvestorPayment.rtgsBankTogg><p class=paymentTitle>Verify Account Number</p><input type=text class=\"form-control inputPayment\" ng-keydown=Payment.copyPasteHandler($event) name=verifyBankAcNo maxlength=20 required ng-model=NewInvestorPayment.formData.paymentInfo.verifyBankAcNo ng-pattern=NewInvestorPayment.formData.paymentInfo.accNo onkeypress=\"(event.charCode >= 48 && event.charCode <= 57)\"> <span class=error-input ng-show=rtgsFormData.verifyBankAcNo.$dirty&&rtgsFormData.verifyBankAcNo.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=!rtgsFormData.verifyBankAcNo.$error.required&&rtgsFormData.verifyBankAcNo.$error.maxlength ng-bind=NewInvestorPayment.VALIDATE_DATA.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=!rtgsFormData.verifyBankAcNo.$error.required&&!rtgsFormData.verifyBankAcNo.$error.maxlength&&rtgsFormData.verifyBankAcNo.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_ACCOUNT_NUMBER_RANGE></span></div></div><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=paymentTitle>Account Type</p></div><div class=\"col-xs-12 col-md-12\"><select id=accountType name=accountType class=\"form-control selectNormal Selectwidth100\" ng-model=NewInvestorPayment.formData.paymentInfo.accType required ng-disabled=\"NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.isAccTypeFieldDisabled\"><option value selected>Select</option><option ng-repeat=\"value in NewInvestorPayment.bankAccountType\" ng-selected=\"NewInvestorPayment.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- IFSC/NEFT Code --><div class=row><div class=col-md-12><p class=paymentTitle>IFSC/NEFT Code</p></div><div class=col-md-12><input type=text class=\"form-control inputPayment\" ng-model=NewInvestorPayment.formData.paymentInfo.ifscCode name=ifscCode required ng-pattern=NewInvestorPayment.IFSC_REGEX capitalize ng-readonly=\"NewInvestorPayment.rtgsBankTogg && NewInvestorPayment.formData.paymentInfo.ifscCode\"> <span class=error-input ng-show=rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_FIELD></span> <span class=error-input ng-show=rtgsFormData.ifscCode.$dirty&&rtgsFormData.ifscCode.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.IFSC_CODE_REGEX></span></div></div><!-- UTR Number/ Verify UTR Number --><div class=row><div class=col-md-6><p class=paymentTitle>UTR Number</p><input type=text class=\"form-control inputPayment\" name=utrNumber ng-model=NewInvestorPayment.formData.paymentInfo.utrNumber ng-pattern=NewInvestorPayment.PATTERN.UTR_REGEX ng-maxlength=255 required> <span class=error-input ng-show=rtgsFormData.utrNumber.$dirty&&rtgsFormData.utrNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.utrNumber.$dirty&&rtgsFormData.utrNumber.$error.pattern class=help-block ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_RANGE></span> <span class=error-input ng-show=rtgsForm.utrNumber.$dirty&&rtgsForm.utrNumber.$error.maxlength class=help-block ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_INVALID></span></div><div class=col-md-6><p class=paymentTitle>Verify UTR Number</p><input type=text class=\"form-control inputPayment\" name=verifyUtrNumber ng-model=NewInvestorPayment.formData.paymentInfo.verifyUtrNumber ng-pattern=NewInvestorPayment.formData.paymentInfo.utrNumber required> <span class=error-input ng-show=rtgsFormData.verifyUtrNumber.$dirty&&rtgsFormData.verifyUtrNumber.$error.required ng-bind=NewInvestorPayment.VALIDATE_DATA.UTR_REQUIRED></span> <span class=error-input ng-show=rtgsFormData.verifyUtrNumber.$dirty&&rtgsFormData.verifyUtrNumber.$error.pattern ng-bind=NewInvestorPayment.VALIDATE_DATA.SAME_UTR_REQUIRED></span></div></div><!-- chequesleaf --><!-- <div class=\"row\">\n                  <div class=\"col-xs-12 col-sm-6 col-md-6\">\n                    <label for=\"chequesleafImage\" class=\"new-investor-chequeleaf-label\" style=\"text-align: right;\n                padding: 10px;\n                padding-left: 35px;\n                margin-top: 15px;\n                background-color: lightgray;\n                border-radius: 25px;\n                cursor: pointer;\n                background-size: 28px;\n                background-position-x: 5px;\n                background-position-y: 3px;\n                background-repeat: no-repeat;\n                font-size: 13px;\n                width: 100%;\n                background-image: url(../../../../assets/images/new-investor/uploadIcon.png);\">\n                      Upload Bank Statement\n                    </label>\n                    </label>\n                    <input type=\"file\" name=\"chequesleafImage\" id=\"chequesleafImage\"\n                      accept=\"image/tiff,image/tif,image/jpeg,image/jpg,application/pdf\" file-model-profile=\"Preview Uploaded Doc\"\n                      ng-model=\"NewInvestorPayment.formData.paymentInfo.chequeLeaf\"\n                      upload=\"NewInvestorPayment.bankUploadChequeLeafFile(file)\" style=\"display: none;visibility: none;\"\n                      required>\n\n                  </div>\n                  <div class=\"col-xs-12  col-sm-6 col-md-6\">\n                    <p ng-if=\"NewInvestorPayment.bankchequeLeafUrl && NewInvestorPayment.fileType!=\'pdf\' && NewInvestorPayment.fileType != \'tiff\'\" ng-click=\"NewInvestorPayment.openUploadedDoc()\"\n                      style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px; font-size: 13px\">\n                      Show Image</p>\n                    <p\n                      ng-if=\"NewInvestorPayment.bankchequeLeafUrl && (NewInvestorPayment.fileType ==\'pdf\' || NewInvestorPayment.fileType == \'tiff\')\"\n                      ng-click=\"NewInvestorPayment.downloadPdfFile(NewInvestorPayment.bankchequeLeafUrl,NewInvestorPayment.fileType)\"\n                      style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 15px;\">\n                      Download <span style=\"text-transform: capitalize\">{{NewInvestorPayment.fileType}}</span></p>\n                  </div>\n                </div> --><br></div></form></div><!-- UPI --><div ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\'\"><form name=upiPaymentForm ng-submit=NewInvestorPayment.verifyUPI()><p class=paymentTitle>Select UPI bank</p><select class=\"form-control selectNormal width100\" name=bank ng-disabled=!NewInvestorPayment.upiPaymet ng-model=NewInvestorPayment.formData.paymentInfo.bank ng-options=\"bank as bank.bankName for bank in NewInvestorPayment.netBankingAndUPIList\" ng-change=NewInvestorPayment.selectedUpiBank() easyassist-key=mask-element required><option value=\"\" easyassist-key=mask-element selected>Select bank</option></select><p class=paymentTitle>Virtual Payment Address(UPI ID)</p><input type=text ng-model=NewInvestorPayment.formData.paymentInfo.virtualAddress name=virtualAddress class=\"form-control inputPayment\" ng-pattern=NewInvestorPayment.PATTERN.upi_virtual_addr_regex ng-change=\"NewInvestorPayment.verifyUPIResp={}\" required ng-readonly=\"NewInvestorPayment.isUPIVerified && NewInvestorPayment.verifyUPIResp.valid === true\" easyassist-key=mask-element> <span class=error-input ng-show=\"upiPaymentForm.virtualAddress.$dirty &&\n                                                (upiPaymentForm.virtualAddress.$error.required ||upiPaymentForm.virtualAddress.$error.pattern)\" ng-bind=NewInvestorPayment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"!upiPaymentForm.virtualAddress.$invalid\n                                         &&  (!NewInvestorPayment.isUPIVerified && NewInvestorPayment.verifyUPIResp.valid === false)\" ng-bind=NewInvestorPayment.VALIDATE_DATA.UPI_ACCOUNT_NUMBER_NOT_VERIFIED></span><br><button blur-on-click class=btn-new-journey-color style=\"border-radius: 30px\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption==\'UPI\' && !NewInvestorPayment.isUPIVerified\" class=btn ng-disabled=\"!NewInvestorPayment.formData.paymentInfo.virtualAddress ||\n                                                (!NewInvestorPayment.bankInfo.minorBankFlag && NewInvestorPayment.checkForMinorBankListCondition())\" ng-click=NewInvestorPayment.verifyUPI()>Verify</button><div ng-if=NewInvestorPayment.showUPIStatus><div class=\"verify-vpa verify-ack-padding\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption==\'UPI\' && NewInvestorPayment.isUPIVerified == true\"><p><strong>Verified <i class=verify-small-icon></i></strong></p><span>Name: {{NewInvestorPayment.name}}</span></div></div></form></div></div></div></div></div><div class=\"row noteForTpv\" ng-if=\"(NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' || NewInvestorPayment.formData.purchasePaymentOption == \'WEB\') && NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\' \"><div class=\"col-sm-1 col-md-3\"></div><div class=\"col-sm-11 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=\"text-red error-msg-tpv\" style=\"font-size: 13px\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=NewInvestorPayment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p></div></div><br><!-- Declaration --><br><div class=row><div class=\"col-sm-1 col-md-2\"></div><div class=\"col-sm-11 col-md-10\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><input class=nomineeCheckbox type=checkbox name=paymentDeclairation id=paymentDeclairation ng-click=NewInvestorPayment.getconfirmation() ng-checked=NewInvestorPayment.confirmation style=\"margin-bottom: 5px;margin-right: 5px\"><label for=paymentDeclairation class=confirmationnote style=\"margin-left: 30px\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the account holders.</label></div></div><div class=\"paymentBtn centeredButton\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'NETBANKING\' || NewInvestorPayment.formData.purchasePaymentOption == \'WEB\'\" ng-click=NewInvestorPayment.purchaseSubmitForm() style=\"margin-left: 40px;width: 180px !important;margin-bottom: 15px\" ng-disabled=\"!NewInvestorPayment.confirmation || !NewInvestorPayment.formData.paymentInfo.bankName ||\n                            !NewInvestorPayment.formData.paymentInfo.accountNumber ||\n                            NewInvestorPayment.formData.paymentInfo.tpvEnableFlag == \'N\'\">CONTINUE TO PAY</button> <button class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\'\" ng-click=NewInvestorPayment.purchaseSubmitForm() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                            !NewInvestorPayment.formData.paymentInfo.bankName ||\n                            !NewInvestorPayment.formData.paymentInfo.branchName ||\n                            !NewInvestorPayment.formData.paymentInfo.accNo ||\n                            !NewInvestorPayment.formData.paymentInfo.accType ||\n                            (!NewInvestorPayment.rtgsBankTogg && !NewInvestorPayment.formData.paymentInfo.verifyBankAcNo) ||\n                            !NewInvestorPayment.formData.paymentInfo.ifscCode ||\n                            !NewInvestorPayment.formData.paymentInfo.utrNumber ||\n                            !NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\" style=\"width: 180px;margin-bottom: 15px\">CONTINUE TO PAY</button><!--      <button class=\"btn-new-journey-color hdfc-blue-cta-small\"--><!--        ng-If=\"NewInvestorPayment.formData.purchasePaymentOption == \'RTGS\' && !NewInvestorPayment.rtgsBankTogg\"--><!--        ng-click=\"NewInvestorPayment.purchaseSubmitForm()\" ng-disabled=\"!NewInvestorPayment.confirmation ||--><!--                            !NewInvestorPayment.formData.paymentInfo.bankName ||--><!--                            !NewInvestorPayment.formData.paymentInfo.utrNumber ||--><!--                            !NewInvestorPayment.formData.paymentInfo.verifyUtrNumber\"--><!--        style=\"width: 180px;margin-bottom: 15px;\">--><!--        CONTINUE TO PAY</button>--> <button class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=\"NewInvestorPayment.formData.purchasePaymentOption == \'UPI\'\" ng-click=NewInvestorPayment.purchaseSubmitForm() ng-disabled=\"!NewInvestorPayment.confirmation ||\n                            !NewInvestorPayment.formData.paymentInfo.virtualAddress ||\n                            !NewInvestorPayment.verifyUPIResp.valid ||\n                            !NewInvestorPayment.formData.paymentInfo.bank\" style=\"width: 180px;margin-bottom: 15px\">CONTINUE TO PAY</button></div></div><br><br></div><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{NewInvestorPayment.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=NewInvestorPayment.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=NewInvestorPayment.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=NewInvestorPayment.billdeskPayload.msg></form><style>.sipseconddiv {\n    padding: 30px 0px 10px 30px;\n  }\n\n  .p-short {\n    padding: 5px 0px 5px 0px;\n  }\n\n  .inputPayment {\n    height: 34px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #B8C6D1;\n    border-radius: 5px;\n  }\n\n  #switch {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n\n  .switchlablePay {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 29px;\n    height: 16px;\n    background: #5ceb57;\n    display: block;\n    border-radius: 50px;\n    position: relative;\n  }\n\n  .switchlablePay:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked+.switchlablePay {\n    background: #5ceb57;\n  }\n\n  input:checked+.switchlablePay:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n\n  .switchlablePay:active:after {\n    width: 10px;\n  }\n\n  .f-bold {\n    font-weight: 600;\n    color: #000000;\n  }\n\n  .c-pink {\n    font: normal normal 600 12px/19px Poppins;\n    letter-spacing: 0px;\n    color: #FF8486;\n    opacity: 1;\n  }\n\n  .c-blue {\n    font: normal normal medium 12px/19px Poppins;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    opacity: 1;\n  }\n\n  .summaryKey {\n    font: normal normal medium 12px/19px Poppins;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    opacity: 1;\n  }\n\n  .modal-body1 {\n    margin: auto;\n    padding: 50px;\n    width: 60%;\n    border-radius: 10px;\n    background: white;\n    box-shadow: -1px 1px 5px 1px lightgrey;\n  }\n\n  p {\n    color: #000000;\n  }\n\n  li {\n    padding: 5px;\n  }\n\n  .d-padding {\n    padding: 10px 0px 10px 0px;\n  }\n\n  .lessPadding {\n    padding: 10px 10px 10px 20px;\n  }\n\n  @media screen and (max-width: 600px) {\n    .sipseconddiv {\n      padding: 10px 0px 10px 15px;\n    }\n\n    .boxdiv {\n      margin-left: 15px;\n    }\n\n    .modal-body1 {\n      width: 100%;\n    }\n\n    .lessPadding {\n      padding: 0px;\n    }\n\n    .btn-primary-action-pay {\n      padding: 10px 10px 10px 10px;\n      border-color: transparent;\n      background-color: #FF8486;\n      color: white;\n\n    }\n  }\n\n  .hdfc-blue-cta-small {\n    background-color: #FF8486;\n    color: white;\n  }\n\n  .btn-primary-action-pay {\n    color: white;\n    border-color: transparent;\n    background-color: #FF8486;\n\n  }\n\n  .hdfc-blue-cta-small:disabled {\n    background-color: #FF8486;\n    color: white;\n  }\n\n  .btn-primary-action-pay:disabled {\n    border-color: transparent;\n    background-color: #fdbdbe;\n  }\n  @media screen and (max-width: 767px) {\n    .new-investors-approve .width100{\n      width: 100% !important;\n    }\n    .centeredButton{\n      display: flex !important;\n      justify-content: center !important;\n    }\n    .main-padding{\n    padding:10px !important;\n  }\n  .main-padding .informationData{\n    display: block !important;\n  }\n  }\n  @media screen and (max-width: 1170px) {\n    .new-investors-approve .Selectwidth100{\n      width: 100% !important;\n    }\n  }\n  @media screen and (max-width: 991px) {\n  .new-investors-approve .payment .main .seocndrow .informationData{\n    border-right: none;\n  }\n  .checkbox{\n    bottom:0px;\n  }\n  .centeredButton{\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n  }\n}\n@media screen and (max-width: 487px) {\n  .neft-form-switch .slider{\n    top: 63px !important;\n  }\n  .padding-min{\n    padding:4px !important\n  }\n  .padding-min-sipNormal{\n    padding:10px !important\n  }\n  .boxdiv{\n    width: 100% !important;\n  }\n  }\n  .ricon{\n   width:7px\n  }</style>");
$templateCache.put("app/purchase-corner/funds-matured/funds-matured.html","<div class=\"investors sip-corner main-section\" ng-init=FundsMatured.init()><h3 class=page-title>FMP Schemes</h3><div class=\"download dropdown pull-right\"><ul class=dropdown-menu><li ng-repeat=\"(key, value) in FundsMatured.reportUrls\" ng-click=FundsMatured.downloadReport(key,value)>{{value}}</li></ul></div><div class=\"tab-content investors-listing\"><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row sip-corner-filter\"><div class=\"col-md-5 search-bar\"><i class=search-icon></i> <input type=search placeholder=\"Search Folio Number, Investor Name, Scheme\" ng-model=FundsMatured.searchText ng-change=FundsMatured.searchList(); select-on-click class=blank-input></div><!-- <span class=\"download-with-tooltip\" ng-click=\"SipCorner.downloadReportList(\'sip-corner-list\');\">\n        <img tooltips tooltip-template=\"Download Report\" src=\"../../../assets/images/ic-download.svg\" alt=\"Download\"/>\n      </span>--><div class=filters-group><input date-range=\"\" on-date-change=FundsMatured.filterByDate placeholder=\"From Date -> To Date\" date-default=FundsMatured.dateFilter class=\"date-picker ng-isolate-scope\" type=text></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"FundsMatured.sortOrder.sortKey=\'investorName\';FundsMatured.filterByHeader()\">Investor Name</th><th ng-click=\"FundsMatured.sortOrder.sortKey=\'folioNumber\';FundsMatured.filterByHeader()\">FOLIO</th><th ng-click=\"FundsMatured.sortOrder.sortKey=\'schemeName\';FundsMatured.filterByHeader()\">SCHEME</th><th ng-click=\"FundsMatured.sortOrder.sortKey=\'transactionDateTime\';FundsMatured.filterByHeader()\"><span>DATE</span></th><!-- <th ng-click=\"SipCorner.sortOrder.sortKey=\'START_DATE\';SipCorner.filterByHeader()\">INVESTMENT TYPE</th>--><th ng-click=\"FundsMatured.sortOrder.sortKey=\'transactionType\';FundsMatured.filterByHeader()\">TRANSACTION TYPE</th><th ng-click=\"FundsMatured.sortOrder.sortKey=\'amount\';FundsMatured.filterByHeader()\">Amount (IN RS)</th></tr></thead><tbody><tr ng-if=\"FundsMatured.fundsMaturedList.length>0\" ng-repeat=\"list in FundsMatured.fundsMaturedList\"><td ng-bind=list.name>7687399</td><td ng-bind=list.folioNumber>21-12-2007</td><td ng-bind=list.scheme>Growth</td><td ng-bind=list.date>Switch</td><td ng-bind=list.transactionType>20,873</td><td>{{list.amount | unit:amount}}</td></tr><tr ng-if=\"FundsMatured.fundsMaturedList.length==0 && !FundsMatured.isLoading\"><td colspan=8 class=text-center>No Record found</td></tr></tbody></table><div ng-if=FundsMatured.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"FundsMatured.totalFundsMaturedList <= FundsMatured.PAGE_LIMITS[0]\" ng-bind=FundsMatured.totalFundsMaturedList></span><select ng-if=\"FundsMatured.totalFundsMaturedList > FundsMatured.PAGE_LIMITS[0]\" ng-change=FundsMatured.limitChanged() ng-model=FundsMatured.selectedPageLimit ng-options=\"_limit as _limit for _limit in FundsMatured.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=FundsMatured.totalFundsMaturedList></span></div><ul uib-pagination total-items=FundsMatured.totalFundsMaturedList ng-model=FundsMatured.currentPage max-size=5 items-per-page=FundsMatured.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=FundsMatured.init() rotate=false></ul></div></div></div></div></div>");
$templateCache.put("app/purchase-corner/funds-maturing/funds-maturing.html","<div class=\"investors sip-corner main-section\" ng-init=FundsMaturing.init()><h3 class=page-title>FMP Schemes</h3><div class=\"download dropdown pull-right\"><ul class=dropdown-menu><li ng-repeat=\"(key, value) in FundsMaturing.reportUrls\" ng-click=FundsMaturing.downloadReport(key,value)>{{value}}</li></ul></div><div class=\"tab-content investors-listing\"><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row sip-corner-filter\"><div class=\"col-md-5 search-bar\"><i class=search-icon></i> <input type=search placeholder=\"Search Folio Number, Investor Name, Scheme\" ng-model=FundsMaturing.searchText ng-change=FundsMaturing.searchList(); select-on-click class=blank-input></div><!-- <span class=\"download-with-tooltip\" ng-click=\"SipCorner.downloadReportList(\'sip-corner-list\');\">\n        <img tooltips tooltip-template=\"Download Report\" src=\"../../../assets/images/ic-download.svg\" alt=\"Download\"/>\n      </span>--><div class=filters-group><input date-range=\"\" on-date-change=FundsMaturing.filterByDate placeholder=\"From Date -> To Date\" date-default=FundsMaturing.dateFilter class=\"date-picker ng-isolate-scope\" type=text></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'investorName\';FundsMaturing.filterByHeader()\">Investor Name</th><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'folioNumber\';FundsMaturing.filterByHeader()\">FOLIO</th><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'schemeName\';FundsMaturing.filterByHeader()\">SCHEME</th><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'transactionDateTime\';FundsMaturing.filterByHeader()\"><span>DATE</span></th><!-- <th ng-click=\"SipCorner.sortOrder.sortKey=\'START_DATE\';SipCorner.filterByHeader()\">INVESTMENT TYPE</th>--><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'transactionType\';FundsMaturing.filterByHeader()\">TRANSACTION TYPE</th><th ng-click=\"FundsMaturing.sortOrder.sortKey=\'amount\';FundsMaturing.filterByHeader()\">Amount (IN RS)</th></tr></thead><tbody><tr ng-if=\"FundsMaturing.fundsMaturingList.length>0\" ng-repeat=\"list in FundsMaturing.fundsMaturingList\"><td ng-bind=list.name>7687399</td><td ng-bind=list.folioNumber>21-12-2007</td><td ng-bind=list.scheme>Growth</td><td ng-bind=list.date>Switch</td><td ng-bind=list.transactionType>20,873</td><td>{{list.amount | unit:amount}}</td></tr><tr ng-if=\"FundsMaturing.fundsMaturingList.length==0 && !FundsMaturing.isLoading\"><td colspan=8 class=text-center>No Record found</td></tr></tbody></table><div ng-if=FundsMaturing.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"FundsMaturing.totalFundsMaturingList <= FundsMaturing.PAGE_LIMITS[0]\" ng-bind=FundsMaturing.totalFundsMaturingList></span><select ng-if=\"FundsMaturing.totalFundsMaturingList > FundsMaturing.PAGE_LIMITS[0]\" ng-change=FundsMaturing.limitChanged() ng-model=FundsMaturing.selectedPageLimit ng-options=\"_limit as _limit for _limit in FundsMaturing.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black ng-bind=FundsMaturing.totalFundsMaturingList></span></div><ul uib-pagination total-items=FundsMaturing.totalFundsMaturingList ng-model=FundsMaturing.currentPage max-size=5 items-per-page=FundsMaturing.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=FundsMaturing.init() rotate=false></ul></div></div></div></div></div>");
$templateCache.put("app/resourcesNcalculators/calculators/calculators.html","<div class=\"tab-content resources\" ng-init=ResourcesCalculators.init()><section class=\"content clearfix\"><div class=content-head><h6 class=text-blue>Calculators</h6><p>Please access all the calculators of your choice here</p></div><div class=\"content-body clearfix\"><div class=col-md-5><ul class=iframe-list><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'sip_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'sip_calculator\')\"><div class=pull-left><p>SIP Calculator</p><div>Find the future value of your monthly/quarterly SIP investment</div></div><div class=\"pull-right calculatorButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate </strong><i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'goalsip_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'goalsip_calculator\')\"><div class=pull-left><p>Goal SIP Calculator</p><div>Determine the monthly SIP investments you need to make to reach a particular goal</div></div><div class=\"pull-right calculatorButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate</strong> <i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'topupsip_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'topupsip_calculator\')\"><div class=pull-left><p>Top-Up SIP Calculator</p><div>Calculate the future value of your SIP investments if you top-up the amount every year.</div></div><div class=\"pull-right calculatorButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate</strong> <i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'inflation_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'inflation_calculator\')\"><div class=pull-left><p>Inflation Calculator</p><div>Calculate the impact of inflation on your money. Find out how much you will need in the future to meet your current expenses whilst keeping up with the inflation rate.</div></div><div class=\"pull-right inflatButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate</strong> <i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'presentvalue_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'presentvalue_calculator\')\"><div class=pull-left><p>Present Value Calculator</p><div>Calculate the Present Value of an amount in the Future, given a specified rate of return.</div></div><div class=\"pull-right calculatorButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate</strong> <i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li><li class=\"clearfix cursor-pointer\" ng-class=\"{\'activeIframe\' : ResourcesCalculators.currCalculator == \'futurevalue_calculator\'}\" ng-click=\"ResourcesCalculators.openIframe(\'futurevalue_calculator\')\"><div class=pull-left><p>Future Value Calculator</p><div>Calculate the Future Value of an amount today, given a specified rate of interest.</div></div><div class=\"pull-right calculatorButton\"><strong class=\"text-blue calculateButtonResounce\">Calculate</strong> <i class=\"forward-arrow-icon calculateButtonResounce\"></i></div></li></ul></div><div class=col-md-7><iframe id=iframeBox frameborder=0 style=\"width:100%;height:800px;overflow: hidden\"></iframe></div></div></section></div>");
$templateCache.put("app/resourcesNcalculators/resources/resources.html","<div class=\"tab-content resources\" ng-init=ResourcesCalculators.init()><section class=\"content clearfix\"><div class=content-head><h6 class=text-blue>Resources</h6><p>Please access all the resources of your choice here</p></div><div class=\"content-body clearfix\"><ul class=pdf-list><li class=clearfix><div class=col-md-3><img ng-src=\"{{articles.thumbnailUrl.trim()||\'assets/images/pdf.png\'}}\" alt=thumbnail></div><div class=col-md-6><p class=text-blue><strong>PDF Name</strong></p><p>By Admin</p></div><div class=col-md-3><button class=\"btn-default btn\">Download PDF</button></div></li><li class=clearfix><div class=col-md-3><img ng-src=\"{{articles.thumbnailUrl.trim()||\'assets/images/pdf.png\'}}\" alt=thumbnail></div><div class=col-md-6><p class=text-blue><strong>PDF Name</strong></p><p>By Admin</p></div><div class=col-md-3><button class=\"btn-default btn\">Download PDF</button></div></li></ul></div></section></div>");
$templateCache.put("app/services/modal/modal-popup.html","<div data-ng-switch=Modal.view><div data-ng-switch-when=SIGN_UP><div data-ng-include=\"\'app/components/modal/signup/signup.modal.html\'\"></div></div><div data-ng-switch-when=OTP_VERIFICATION><div data-ng-include=\"\'app/components/modal/signup/otp-verification.modal.html\'\"></div></div><div data-ng-switch-when=SIGN_UP_DONE><div data-ng-include=\"\'app/components/modal/signup/signup-done.modal.html\'\"></div></div><div data-ng-switch-when=FORGOT_PASSWORD><div data-ng-include=\"\'app/components/modal/forgotPassword/forgotPassword.modal.html\'\"></div></div><div data-ng-switch-when=FORGOT_PASSWORD_DONE><div data-ng-include=\"\'app/components/modal/forgotPassword/forgotPasswordSuccess.modal.html\'\"></div></div><div data-ng-switch-when=RESET_PASSWORD><div data-ng-include=\"\'app/components/modal/resetPassword/resetPassword.modal.html\'\"></div></div><div data-ng-switch-when=RESET_PASSWORD_DONE><div data-ng-include=\"\'app/components/modal/resetPassword/resetPasswordSuccess.modal.html\'\"></div></div><div data-ng-switch-when=PASSWORD_MSG><div data-ng-include=\"\'app/components/modal/resetPassword/message.modal.html\'\"></div></div><div data-ng-switch-when=LOGO_UPLOAD><div data-ng-include=\"\'app/components/modal/logoUpload/logoUpload.modal.html\'\"></div></div><div data-ng-switch-when=LOGO_UPLOAD_HEADER><div data-ng-include=\"\'app/components/modal/logoUpload/logoUploadAtHeader.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SUMMARY><div data-ng-include=\"\'app/components/modal/transactionSummary/transactionSummary.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_REVIEW><div data-ng-include=\"\'app/components/modal/transactionReview/transactionReview.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_INIT_SEARCH><div data-ng-include=\"\'app/components/modal/searchInvestor/searchInvestor.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_INIT_UPDATE_DB><div data-ng-include=\"\'app/components/modal/searchInvestor/investorUpdateDB.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SCHEME_LIST><div data-ng-include=\"\'app/components/modal/schemeList/schemeList.model.html\'\"></div></div><div data-ng-switch-when=INITATE_SUCCESS><div data-ng-include=\"\'app/components/modal/initiateTransaction/success.modal.html\'\"></div></div><div data-ng-switch-when=OTP_FOR_APPROVAL><div data-ng-include=\"\'app/components/modal/initiateTransaction/otp-verification.modal.html\'\"></div></div><div data-ng-switch-when=INITATE_REJECTION><div data-ng-include=\"\'app/components/modal/initiateTransaction/rejectTransaction.modal.html\'\"></div></div><div data-ng-switch-when=WIDGET_SELECTION><div data-ng-include=\"\'app/components/modal/widgetStore/widgetSelection.modal.html\'\"></div></div><div data-ng-switch-when=CHEANGE_PASSWORD><div data-ng-include=\"\'app/components/modal/resetPassword/changePassword.modal.html\'\"></div></div><div data-ng-switch-when=EDIT_NOMINEE><div data-ng-include=\"\'app/components/modal/editNominee/editNominee.modal.html\'\"></div></div><div data-ng-switch-when=SUCCESS_INVESTOR><div data-ng-include=\"\'app/components/modal/addInvestor/success-investor.modal.html\'\"></div></div><div data-ng-switch-when=CHECK_PAN_JOINT_HOLDER><div data-ng-include=\"\'app/components/modal/addInvestor/pan-verification-joint-holder.modal.html\'\"></div></div><div data-ng-switch-when=CHECK_PAN><div data-ng-include=\"\'app/components/modal/addInvestor/pan-verification.modal.html\'\"></div></div><div data-ng-switch-when=FILE_DOWNLOAD><div data-ng-include=\"\'app/components/modal/fileDownload/fileDownload.modal.html\'\"></div></div><div data-ng-switch-when=SEND_FILE_DOWNLOAD><div data-ng-include=\"\'app/components/modal/fileDownload/sendFileDownload.modal.html\'\"></div></div><div data-ng-switch-when=BROCKERAGE_REPORT_DOWNLOAD><div data-ng-include=\"\'app/components/modal/fileDownload/brockerageReport.modal.html\'\"></div></div><div data-ng-switch-when=BANK_MAKE_PAYMENT><div data-ng-include=\"\'app/components/modal/bankDetails/bank-payment-makepayment.modal.html\'\"></div></div><div data-ng-switch-when=BANK_PAYMENT_SUMMERY><div data-ng-include=\"\'app/components/modal/bankDetails/bank-payment-summery.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION_E_MANDATE><div data-ng-include=\"\'app/components/modal/termcondition/termconditionEMandate.modal.html\'\"></div></div><div data-ng-switch-when=TPV_MODAL><div data-ng-include=\"\'app/components/modal/tpv/tpv.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION_SUMMARY><div data-ng-include=\"\'app/components/modal/termcondition/termcondition-summary.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION_INIT_TRAN><div data-ng-include=\"\'app/components/modal/termcondition/termcondition-init-transaction.modal.html\'\"></div></div><div data-ng-switch-when=EMPANELLMENT_TANDC_MODAL><div data-ng-include=\"\'app/components/modal/distributorEmpanellment/EmpanellmentTAndC.modal.html\'\"></div></div><div data-ng-switch-when=EMPANELLMENT_SUCCESS_MODAL><div data-ng-include=\"\'app/components/modal/distributorEmpanellment/EmpanellmentSuccess.modal.html\'\"></div></div><div data-ng-switch-when=PROCEED_LOGIN><div data-ng-include=\"\'app/components/modal/bankDetails/preceedtologin.modal.html\'\"></div></div><div data-ng-switch-when=LEAPACADEMY_REGISTER><div data-ng-include=\"\'app/components/modal/leapAcademyRegister/leapacademy-register.modal.html\'\"></div></div><div data-ng-switch-when=LEAPACADEMY_AGENDA><div data-ng-include=\"\'app/components/modal/leapAcademyRegister/leapacademy-agenda.modal.html\'\"></div></div><div data-ng-switch-when=LEAPACADEMY_VIDEO><div data-ng-include=\"\'app/components/modal/leapAcademyRegister/leapacademy-video.modal.html\'\"></div></div><div data-ng-switch-when=LEAPACADEMY_SUCCESS><div data-ng-include=\"\'app/components/modal/leapAcademyRegister/leapacademy-success.modal.html\'\"></div></div><div data-ng-switch-when=NOTIFICATION_DETAILS><div data-ng-include=\"\'app/components/modal/notification/notification.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_SUCCESS><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-success.modal.html\'\"></div></div><div data-ng-switch-when=INVESTOR_STATEMENT><div data-ng-include=\"\'app/components/modal/investorStatement/investorStatement.modal.html\'\"></div></div><div data-ng-switch-when=UPDATE_INVESTOR><div data-ng-include=\"\'app/components/modal/updateInvestor/update-investor.modal.html\'\"></div></div><div data-ng-switch-when=FEEDBACK_SUCCESS><div data-ng-include=\"\'app/components/modal/feedback/feedback.modal.html\'\"></div></div><div data-ng-switch-when=DASHBOARD_EDIT_SUCCESS><div data-ng-include=\"\'app/components/modal/editDashboard/success.edit.html\'\"></div></div><div data-ng-switch-when=INVESTMENT_SUCCESS><div data-ng-include=\"\'app/components/modal/investorApproval/investmentSuccess.modal.html\'\"></div></div><div data-ng-switch-when=REJECTION_REASON><div data-ng-include=\"\'app/components/modal/investorApproval/rejectionReason.modal.html\'\"></div></div><div data-ng-switch-when=REJECTION_APPROVAL><div data-ng-include=\"\'app/components/modal/investorApproval/rejectionApproval.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_WARNING><div data-ng-include=\"\'app/components/modal/transactionWarning/transaction-warning.modal.html\'\"></div></div><div data-ng-switch-when=SUCCESS_MESSAGE><div data-ng-include=\"\'app/components/modal/successMessage/success.modal.html\'\"></div></div><div data-ng-switch-when=NON_OTM_FOLIO_DETAILS><div data-ng-include=\"\'app/components/modal/nonOtm/nonOtm.modal.html\'\"></div></div><div data-ng-switch-when=CREATE_AGENT_SUCCESSFUL><div data-ng-include=\"\'app/components/modal/agentCreateUserSuccess/agent-createUser.modal.html\'\"></div></div><div data-ng-switch-when=AGENT_MSG_TEMPLATE><div data-ng-include=\"\'app/components/modal/agentCreateUserSuccess/agent-message.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_AGENT_PASSWORD_SUCCESSFUL><div data-ng-include=\"\'app/components/modal/agentChangePasswordSuccess/agent-changePasswordSuccess.modal.html\'\"></div></div><div data-ng-switch-when=AGENT_DRAFT><div data-ng-include=\"\'app/components/modal/agentDraft/agent-draft.modal.html\'\"></div></div><div data-ng-switch-when=ROLL_OVER_OVERVIEW><div data-ng-include=\"\'app/components/modal/rollOver/rollOverOverview.modal.html\'\"></div></div><div data-ng-switch-when=IMAGE_PREVIEW><div data-ng-include=\"\'app/components/modal/imagePreview/imagePreview.modal.html\'\"></div></div><div data-ng-switch-when=SELECT_ACCOUNT_NO><div data-ng-include=\"\'app/components/modal/selectAccount/selectAccount.modal.html\'\"></div></div><div data-ng-switch-when=ADD_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/addSuccess.modal.html\'\"></div></div><div data-ng-switch-when=DELETE_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/deleteBank.modal.html\'\"></div></div><div data-ng-switch-when=DELETE_BANK_SUCCESS><div data-ng-include=\"\'app/components/modal/modifyBank/deleteSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_BANK_SUCCESS><div data-ng-include=\"\'app/components/modal/modifyBank/changeSuccess.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_DEFAULT_BANK><div data-ng-include=\"\'app/components/modal/modifyBank/changeDefaultBank.modal.html\'\"></div></div><div data-ng-switch-when=WIDGET_CAMPAIGN><div data-ng-include=\"\'app/components/modal/widgetCampaign/widgetCampaign.modal.html\'\"></div></div><div data-ng-switch-when=SYSTEMATIC_CANCELLATION_SUCCESS><div data-ng-include=\"\'app/components/modal/systematicCancellation/cancellationSuccess.modal.html\'\"></div></div><div data-ng-switch-when=SIP_PAUSE_CONFIRMATION_SUCCESS><div data-ng-include=\"\'app/components/modal/sipPauseConfirmation/sipPauseConfirmation.modal.html\'\"></div></div><div data-ng-switch-when=INITIAL_LOGIN><div data-ng-include=\"\'app/components/modal/initialLogin/success.modal.html\'\"></div></div><div data-ng-switch-when=IFSC_SELECTION><div data-ng-include=\"\'app/components/modal/IFSCSelection/ifsc-selection.modal.html\'\"></div></div><div data-ng-switch-when=CUT_OFF><div data-ng-include=\"\'app/components/modal/confirmCancel/cut-off.modal.html\'\"></div></div><div data-ng-switch-when=PURCHASE_LIQUID><div data-ng-include=\"\'app/components/modal/confirmCancel/purchaseLiquid.modal.html\'\"></div></div><div data-ng-switch-when=MINOR_BANK_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.bank.html\'\"></div></div><div data-ng-switch-when=MINOR_SIP_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.sip.modal.html\'\"></div></div><div data-ng-switch-when=MINOR_PURCHASE_MODAL><div data-ng-include=\"\'app/components/modal/popups/minor.purchase.modal.html\'\"></div></div><div data-ng-switch-when=REGISTER_EMANDATE><div data-ng-include=\"\'app/components/modal/initiateTransaction/registerEMandate.modal.html\'\"></div></div><div data-ng-switch-when=CUT_OFF_LOGIN><div data-ng-include=\"\'app/components/modal/cutOffLogin/cut-off-login.modal.html\'\"></div></div><div data-ng-switch-when=NON_KYC><div data-ng-include=\"\'app/components/modal/kyc/nonKyc/nonKyc.modal.html\'\"></div></div><div data-ng-switch-when=KYC_INITIATE><div data-ng-include=\"\'app/components/modal/kyc/kycInitiate/kycInitiate.modal.html\'\"></div></div><div data-ng-switch-when=KYC_MAIL_SUCCESS><div data-ng-include=\"\'app/components/modal/kyc/ekyc/kyc.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_MANDATE><div data-ng-include=\"\'app/components/modal/emandate/cancelMandate.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_MANDATE><div data-ng-include=\"\'app/components/modal/emandate/confirmMandate.modal.html\'\"></div></div><div data-ng-switch-when=NFO_ENABLED><div data-ng-include=\"\'app/components/modal/nfoEnabled/nfoEnabled.modal.html\'\"></div></div><div data-ng-switch-when=GENERIC_MODAL><div data-ng-include=\"\'app/components/modal/genericModal/generic.modal.html\'\"></div></div><div data-ng-switch-when=OTP_CONFIRM><div data-ng-include=\"\'app/components/modal/otp/otp.modal.html\'\"></div></div><div data-ng-switch-when=SUBSCRIBE_TOGGLE_MODAL><div data-ng-include=\"\'app/components/modal/subscribeToggle/subscribeToggle.modal.html\'\"></div></div><div data-ng-switch-when=SIP_TNC><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionSip.modal.html\'\"></div></div><div data-ng-switch-when=BULK_SUCCESS><div data-ng-include=\"\'app/components/modal/initiateTransaction/bulk-success.modal.html\'\"></div></div><div data-ng-switch-when=NFO_POINT_NOTES><div data-ng-include=\"\'app/components/modal/nfoTransactionNotes/nfoTransactionNotes.modal.html\'\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/components/modal/termcondition/termsAndConditionSmartSwap.modal.html\'\"></div></div><div data-ng-switch-when=GENERIC_SUCCESS_MODAL><div data-ng-include=\"\'app/components/modal/genericModal/generic.success.modal.html\'\"></div></div><div data-ng-switch-when=ADD_NOMINEE><div data-ng-include=\"\'app/components/modal/addNominee/addUpdateNominee.modal.html\'\"></div></div><div data-ng-switch-when=CANCEL_NOMINEE><div data-ng-include=\"\'app/components/modal/cancelNominee/cancelNominee.modal.html\'\"></div></div><div data-ng-switch-when=OFFLINE_NOMINEE_FORM><div data-ng-include=\"\'app/components/modal/offlineNominee/offlineNomineeForm.modal.html\'\"></div></div><div data-ng-switch-when=IFSC_SELECTION_NEW_JOURNEY><div data-ng-include=\"\'app/components/modal/IFSCSelectionNewJourney/ifsc-selection-new-journey.modal.html\'\"></div></div><div data-ng-switch-when=ADD_JOINT_HOLDER><div data-ng-include=\"\'app/components/modal/addJointHolder/addJointHolder.modal.html\'\"></div></div><div data-ng-switch-when=NEW_INVESTOR_DIRECTION><div data-ng-include=\"\'app/components/modal/newInvestorDirection/newInvestorDirection.modal.html\'\"></div></div><div data-ng-switch-when=ADD_DAYS><div data-ng-include=\"\'app/components/modal/addDaysModal/addDays.modal.html\'\"></div></div><div data-ng-switch-when=NEW_INVESTOR_OTP_VERIFY><div data-ng-include=\"\'app/components/modal/newInvestorOtpVerify/newInvestorOtpVerify.modal.html\'\"></div></div><div data-ng-switch-when=NEW_JOURNEY_FOLIO_SWITCH><div data-ng-include=\"\'app/components/modal/newjourneyfolioswitch/newJourneyFolioSwitch.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_CREATION_OTP_MODAL><div data-ng-include=\"\'app/components/modal/folioCreation/folioCreation.otp.modal.html\'\"></div></div><div data-ng-switch-when=SHOW_MESSAGE><div data-ng-include=\"\'app/components/modal/showExitLoadMessage/showExitLoadMessage.html\'\"></div></div><div data-ng-switch-when=STAY_INVESTED><div data-ng-include=\"\'app/components/modal/showExitLoadMessage/stayInvested.modal.html\'\"></div></div><div data-ng-switch-when=FLEX_SIP_TNC><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionFlexSip.modal.html\'\"></div></div><div data-ng-switch-when=EUIN_DECLARATION_ONE_CLICK_MODAL><div data-ng-include=\"\'app/components/modal/euinDeclarationOneClick/euin-declaration-one-click.modal.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL_SYSTEMATIC><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel-systematic.modal.html\'\"></div></div><div data-ng-switch-when=SIP_TNC_MODIFY_OTM><div data-ng-include=\"\'app/components/modal/termcondition/transaction-tnc/termsAndConditionSipModifyOtm.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_SUCCESS><div data-ng-include=\"\'app/components/modal/folioSuccess/folioSuccess.modal.html\'\"></div></div><div data-ng-switch-when=NEW_JOURNEY_FOLIO_CONDITION><div data-ng-include=\"\'app/components/modal/newjourneyfoliocondition/newjourneyfoliocondition.modal.html\'\"></div></div><div data-ng-switch-when=DREAM_SIP_CHANGE_OPTION><div data-ng-include=\"\'app/components/modal/dreamSip/changeOption.modal.html\'\"></div></div><div data-ng-switch-when=CHANGE_TARGET_SCHEME><div data-ng-include=\"\'app/components/modal/dreamSip/changeTargetScheme.modal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_DREAM_SCHEME_LIST><div data-ng-include=\"\'app/components/modal/dreamSchemeList/dreamSchemeList.model.html\'\"></div></div><div data-ng-switch-when=Dream_Sip_Tenure><div data-ng-include=\"\'app/components/modal/dreamSipTenure/dream.sip.tenure.modal.html\'\"></div></div><div data-ng-switch-when=OPT_OUT_NOMINEE_MODAL><div data-ng-include=\"\'app/components/modal/optOutModal/optOutNominee.modal.html\'\"></div></div><div data-ng-switch-when=OPT_OUT_NOMINEE_SEARCH_MODAL><div data-ng-include=\"\'app/components/modal/optOutModal/optOutSearchNominee.html\'\"></div></div><div data-ng-switch-when=CONFIRM_CANCEL_ECART><div data-ng-include=\"\'app/components/modal/confirmCancel/confirm-cancel-ecart.modal.html\'\"></div></div><div data-ng-switch-when=TERM_CONDITION_E_CART><div data-ng-include=\"\'app/components/modal/termcondition/termAndConditionEcart.modal.html\'\"></div></div><div data-ng-switch-when=NUDGE_REASONS><div data-ng-include=\"\'app/components/modal/nudgeReasons/nudgeReasons.modal.html\'\"></div></div><div data-ng-switch-when=INVESTORLINKSTATUS><div data-ng-include=\"\'app/components/modal/investorLinkStatus/investorLinkStatus.modal.html\'\"></div></div><div data-ng-switch-when=GET_TRANSACTION_TYPE><div data-ng-include=\"\'app/components/modal/confirmCancel/transactSipOrPurchase.modal.html\'\"></div></div><div data-ng-switch-when=GENERIC_UI_MODAL><div data-ng-include=\"\'app/components/modal/generic-ui-modal/generic-ui.modal.html\'\"></div></div><div data-ng-switch-when=ALERT_AND_UPDATE_INFO><div data-ng-include=\"\'app/components/modal/alertAndUpdateInfo/alertAndUpdateInfo.modal.html\'\"></div></div><div data-ng-switch-when=PURCHASE_SCHEDULER_RECOMENDATION_MODAL><div data-ng-include=\"\'app/components/modal/purchaseSchedulerRecomendation/purchaseSchedulerRecomendationModal.html\'\"></div></div><div data-ng-switch-when=TRANSACTION_SCHEME_FUND_LIST><div data-ng-include=\"\'app/components/modal/schemeInFundList/schemeInFundList.modal.html\'\"></div></div><div data-ng-switch-when=NEW_JOURNEY_FOLIO_SELECT><div data-ng-include=\"\'app/components/modal/newjourneyfolioselection/newJourneyFolioSelection.modal.html\'\"></div></div><div data-ng-switch-when=NON_TRANSACTIONAL_TERM_CONDITION><div data-ng-include=\"\'app/components/modal/termcondition/termcondition-addBank.modal.html\'\"></div></div><div data-ng-switch-when=REJECT_BANK_SUCCESS><div data-ng-include=\"\'app/components/modal/modifyBank/rejectTransaction.modal.html\'\"></div></div><div data-ng-switch-when=FOLIO_CHOICE_MODAL><div data-ng-include=\"\'app/components/modal/folio-choice/folio-choice.modal.html\'\"></div></div><div data-ng-switch-when=SELECT_FOLIO><div data-ng-include=\"\'app/components/modal/select-folio/select.folio.modal.html\'\"></div></div></div>");
$templateCache.put("app/sip-renew/status/sip-renew-status.html","<div><div class=filtered-transactions><div ng-if=SipRenewStatus.isReset><input date-range=\"\" on-date-change=SipRenewStatus.filterByDate placeholder=\"From Date -> To Date\" date-min=SipRenewStatus.minDate date-max=SipRenewStatus.maxDate date-max-span=59 date-default=SipRenewStatus.dateFilter class=date-picker type=text></div></div><div class=\"list data-grid\"><div class=middle-flow><div class=status-filter><div class=\"col-md-3 col-sm-4 col-xs-6\" ng-repeat=\"_status in SipRenewStatus.SIP_RENEW_STATUS track by $index\"><span class=\"inline-block allTransactionsTabs\" ng-click=SipRenewStatus.statusChanged(_status);><div class=\"filter cursor-pointer {{_status.value.toLowerCase()}}\" ng-class=\"{\'active-filter\':SipRenewStatus.selectedStatus.value===_status.value}\" tooltips tooltip-template={{SipRenewStatus.headerTooltip[_status.value]}}><p>{{_status.value === \'Processed\' ? \'Approved\' : _status.value}}</p><p>{{SipRenewStatus.snapshotData[_status.value.toLowerCase()+\'Count\'] | number : 0 }}</p><span class=bar></span></div></span></div></div></div></div><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Transaction Type</th><th>Investor Name</th><th>Folio Number</th><th>Scheme</th><th>Amount</th><th>Transaction Processing Date</th><th>Remarks</th></tr></thead><tbody><tr ng-if=SipRenewStatus.transactionList ng-repeat=\"transaction in SipRenewStatus.transactionList\"><td data-th=\"Transaction Type\">{{transaction.transactionType}}</td><td data-th=\"Investor Name\"><div>{{transaction.name}}</div><span ng-if=transaction.panNumber>(</span><span ng-if=transaction.panNumber>{{ SipRenewStatus.panDecrypterService(transaction.panNumber) }}</span><span ng-if=transaction.panNumber>)</span></td><td data-th=\"Folio Number\">{{transaction.folioNumber}}</td><td data-th=Scheme>{{transaction.scheme}}</td><td data-th=Amount style=\"white-space: nowrap\"><i class=rupee-icon></i> {{transaction.amount|unitWithOutDecimalFilter:transaction.amountUnit}}{{transaction.amountUnit|unitValue}}</td><td data-th=Date>{{transaction.date}}</td><td data-th=Remarks><span><span ng-if=\"transaction.remarks.length > 40\">{{transaction.remarks.substring(0, 40)}} ... <a role=button ng-click=SipRenewStatus.showMore(transaction.remarks)>More</a> </span><span ng-if=\"transaction.remarks.length <= 40\">{{transaction.remarks}}</span></span></td></tr><tr ng-if=\"SipRenewStatus.transactionList.length === 0 && !SipRenewStatus.isLoading\"><td colspan=7 class=text-center>No Record found</td></tr></tbody></table><div ng-if=SipRenewStatus.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"SipRenewStatus.totalSystematicListData <= SipRenewStatus.PAGE_LIMITS[0]\">{{SipRenewStatus.totalSystematicListData}} of {{SipRenewStatus.totalSystematicListData}}</span><select ng-if=\"SipRenewStatus.totalSystematicListData > SipRenewStatus.PAGE_LIMITS[0]\" ng-change=SipRenewStatus.limitChanged() ng-model=SipRenewStatus.selectedPageLimit class=renew-pagination ng-options=\"_limit as _limit for _limit in SipRenewStatus.PAGE_LIMITS\"></select><span ng-if=\"SipRenewStatus.totalSystematicListData > SipRenewStatus.PAGE_LIMITS[0]\">of {{SipRenewStatus.totalSystematicListData}}</span></div><ul uib-pagination total-items=SipRenewStatus.totalSystematicListData ng-model=SipRenewStatus.currentPageSystematicList max-size=5 items-per-page=SipRenewStatus.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=SipRenewStatus.initSipSearch() rotate=false></ul></div></div></div>");
$templateCache.put("app/sip-renew/transaction/sip-renew-transaction.html","<div><div class=\"search-data row sip-renew-filter\"><div class=\"col-sm-12 col-md-6\"><div class=search-bar><i class=search-icon></i> <input type=search placeholder=\"Search Pan Number, Investor Name, Scheme\" ng-model=SipRenewTransaction.searchText ng-change=SipRenewTransaction.searchList(); select-on-click class=blank-input></div></div><div class=\"col-sm-12 col-md-6\"><div class=sip-start-date><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{SipRenewTransaction.viewMode}} data-date-default=SipRenewTransaction.dateFilter.startDate data-enabled-dates=SipRenewTransaction.enabledStartDatesList data-min-date=SipRenewTransaction.startMinDate data-max-date=SipRenewTransaction.startMaxDate data-on-date-change=SipRenewTransaction.changeFilterStartDate data-view-date=SipRenewTransaction.viewDate id=startDate-sip data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=error-input ng-show=SipRenewTransaction.tForm.startDate.$error.required ng-bind=SipRenewTransaction.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=sip-end-date ng-class=\"{\'anything-disabled\': !SipRenewTransaction.dateFilter.startDate}\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{SipRenewTransaction.viewMode}} data-date-default=SipRenewTransaction.dateFilter.endDate data-enabled-dates=SipRenewTransaction.enabledEndDatesList data-min-date=SipRenewTransaction.endMinDate data-max-date=SipRenewTransaction.endMaxDate data-on-date-change=SipRenewTransaction.changeFilterEndDate id=endDate-sip data-enable=true style=\"position: relative\"><input type=text name=endDate placeholder=\"End Date\" ng-disabled=!SipRenewTransaction.dateFilter.startDate readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=reset-date-filter><span ng-click=SipRenewTransaction.resetDateFilter();><img src=assets/images/refresh.png tooltips tooltip-template=\"Reset Date\"></span></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table sip-renew-table\"><thead><tr><th><span>Investor</span></th><th><span>Scheme</span></th><th><span>Frequency</span></th><th><span>SIP First Installment</span></th><th><span>Payment Mode for SIP Registration</span></th><!--<th><span>Payment Mode for First Installment of SIP</span></th>--><th><span>Amount</span></th><th><span>From Date</span></th><th><span>To Date</span></th><th><span></span> <span class=checkbox><input type=checkbox name=selectForRenew ng-change=\"SipRenewTransaction.addToSelectedList(\'ADD_ALL_CURRENT\', SipRenewTransaction.checked)\" ng-disabled=!SipRenewTransaction.enableSelectAll ng-model=SipRenewTransaction.checked required> <span class=icon-checkbox></span></span></th></tr></thead><tbody><tr ng-if=\"SipRenewTransaction.transactionList.length > 0\" ng-repeat=\"renewList in SipRenewTransaction.transactionList track by $index\" ng-form=sipRenewForm-{{$index}}><td><div>{{renewList.name}}</div><span ng-if=renewList.pan>(</span><span ng-if=renewList.pan easyassist-key=mask-element>{{ renewList.pan }}</span><span ng-if=renewList.pan>)</span><div class=kyc-error ng-if=!renewList.kycVerificationSuccess>{{renewList.kycVerificationMessage}}</div></td><td>{{renewList.schemeName}}</td><td>{{renewList.autoFrequency}}</td><td><ul class=installmentTogglePanel><li><span class=toggle-text>Yes</span></li><li class=align-toggle><div class=login-form-switch><label class=switch-toggle-slider><input type=checkbox ng-model=renewList.sipWithFirstInstallment ng-change=SipRenewTransaction.changeFirstInstallment(renewList) class=\"box checkbox-slide\" title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text>No</span></li></ul></td><td><select class=\"browser-default custom-select\" ng-change=renewList.changePaymentMethod() ng-disabled=!renewList.kycVerificationSuccess ng-model=renewList.paymentModeSelected ng-options=\"mode as mode.value for mode in renewList.paymentOption\" required><option value=\"\" selected>Select Payment Mode</option></select><div class=error-input ng-if=!renewList.paymentOption>{{SipRenewTransaction.contants.ToastrMessage.VALIDATE_DATA.NO_VALID_PAYMENT_MODE}}</div></td><td for=amount><div class=input-normal><input type=text ignore-mouse-wheel onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" name=amount onkeyup=\"NumToWord(this.value,\'topupAmntInWords\')\" ng-model=renewList.amount ng-change=SipRenewTransaction.validateAmount(renewList) ng-disabled=!renewList.kycVerificationSuccess autocomplete=off maxlength=12 required> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=\"renewList.amount < renewList.minAmount\" class=error-input>{{\'Minimum amount should be \'+ renewList.minAmount}} </span><span ng-if=\"sipRenewForm-[$index].amount.$invalid && sipRenewForm-[$index].amount.$error.number\" class=error-input>{{SipRenewTransaction.VALIDATE_DATA.INVALID_AMOUNT}} </span><span ng-if=\"!renewList.isMinAmount && renewList.amountMultiple && !renewList.amountExceeded\" class=error-input>Please Provide In Multiples Of &#x20B9;{{renewList.minAmountMultiple}} </span><span ng-if=\"renewList.amount && renewList.amountExceeded\" class=error-input>{{SipRenewTransaction.VALIDATE_DATA.AMOUNT_EXCEEDED.substring(0, 33)}} ...<a role=button ng-click=SipRenewTransaction.showAmtExceedMsg()>More</a></span></div></td><td for=from-date><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{\'anything-disabled\': !renewList.kycVerificationSuccess || !renewList.paymentModeSelected}\" date-calendar data-enable=true data-showdefault=false data-viewmode={{SipRenewTransaction.viewMode}} data-date-default=renewList.startViewDate data-min-date=renewList.minViewDate data-enabled-dates=renewList.enabledStartDates data-on-date-change=renewList.changeStartDate format=DD-MMM-YYYY style=\"position: relative\" id=fromDate><input id=start-{{$index}} name=date type=text autocomplete=off required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><label>SIP Start Date<span class=req>*</span></label></div></td><td for=to-date><div class=\"input-select input-normal input-group date date-picker transaction-cal\" ng-class=\"{\'anything-disabled\': !renewList.kycVerificationSuccess || !renewList.paymentModeSelected}\" date-calendar data-enable=true data-showdefault=false data-viewmode={{SipRenewTransaction.viewMode}} data-date-default=renewList.endViewDate data-min-date=renewList.minEndDate data-max-date=renewList.maxEndDate data-on-date-change=renewList.changeEndDate data-enabled-dates=renewList.enabledEndDates data-view-date=renewList.viewDate format=DD-MMM-YYYY style=\"position: relative\" id=toDate><input name=dob type=text autocomplete=off required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span> <span class=highlight></span> <span class=bar></span><label>SIP End Date<span class=req>*</span></label></div></td><td><span class=checkbox><input id=tcCheckbox type=checkbox name=selectForRenew-{{$index}} ng-change=\"SipRenewTransaction.addToSelectedList(renewList, renewList.selected)\" ng-disabled=\"(!renewList.kycVerificationSuccess || !renewList.amount || ((renewList.amount < renewList.minAmount) || (!renewList.isMinAmount && renewList.amountMultiple))\n                || !renewList.startViewDate || !renewList.endViewDate || !renewList.paymentModeSelected) || renewList.amountExceeded\" ng-model=renewList.selected required> <span class=icon-checkbox></span></span></td></tr><tr ng-if=\"SipRenewTransaction.transactionList.length == 0\"><td colspan=7 class=text-center>No Record found</td></tr></tbody></table><div ng-if=SipRenewTransaction.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"SipRenewTransaction.totalSystematicListData <= SipRenewTransaction.PAGE_LIMITS[0]\">{{SipRenewTransaction.totalSystematicListData}} of {{SipRenewTransaction.totalSystematicListData}}</span><select ng-if=\"SipRenewTransaction.totalSystematicListData > SipRenewTransaction.PAGE_LIMITS[0]\" ng-change=SipRenewTransaction.limitChanged() ng-model=SipRenewTransaction.selectedPageLimit ng-options=\"_limit as _limit for _limit in SipRenewTransaction.PAGE_LIMITS\" class=renew-pagination></select><span ng-if=\"SipRenewTransaction.totalSystematicListData > SipRenewTransaction.PAGE_LIMITS[0]\">of {{SipRenewTransaction.totalSystematicListData}}</span></div><ul uib-pagination total-items=SipRenewTransaction.totalSystematicListData ng-model=SipRenewTransaction.currentPageSystematicList max-size=5 items-per-page=SipRenewTransaction.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=SipRenewTransaction.reInitSipRenew() rotate=false></ul></div><div class=tc-block ng-if=\"SipRenewTransaction.transactionList.length != 0 && SipRenewTransaction.showTerms\"><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=SipRenewTransaction.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=SipRenewTransaction.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"form-footer form-content\" ng-if=\"SipRenewTransaction.transactionList.length != 0\"><span class=buttons-block><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=SipRenewTransaction.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-disabled=\"!SipRenewTransaction.isCheckedTandC || SipRenewTransaction.transactionListSelected.length == 0\" ng-click=SipRenewTransaction.submitRenewTransactions()>Send for Approval</button></span></div></div></div>");
$templateCache.put("app/transactions/initiate/initiate-transaction.html","<div class=\"main-section initiate\" id=initiate ng-class=\"{\'transaction-screens--agent\' : InitiateTransaction.loginType == \'A\'}\"><div ui-view=\"\"></div></div>");
$templateCache.put("app/transactions/list/transactions-list.html","<!--<div class=\"transaction main-section\">--><!--&lt;!&ndash;<h3 class=\"page-title\">Transactions</h3>&ndash;&gt;--><!--&lt;!&ndash;<ul class=\"nav nav-tabs\">&ndash;&gt;--><!--&lt;!&ndash;<li ui-sref-active=\"active\"><a ui-sref=\"main.transactions.list.all\">All</a></li>&ndash;&gt;--><!--&lt;!&ndash;<li ui-sref-active=\"active\"><a ui-sref=\"main.transactions.list.inflow\">Inflow</a></li>&ndash;&gt;--><!--&lt;!&ndash;<li ui-sref-active=\"active\"><a ui-sref=\"main.transactions.list.outflow\">Outflow</a></li>&ndash;&gt;--><!--&lt;!&ndash;</ul>&ndash;&gt;--><!--<ul class=\"nav nav-tabs transactions\">--><!--<li ng-class=\"{\'active-link\':Transaction.activeRecent[1]}\" ui-sref=\"main.transactions.recent\"  ng-click=\"Transaction.activateTab(1)\">--><!--Recent--><!--</li>--><!--<li ng-class=\"{\'active-link\':Transaction.activeRecent[2]}\" ui-sref=\"main.transactions.all\" ng-click=\"Transaction.activateTab(2)\">--><!--All</li>--><!--</ul>--><!--<div ui-view></div>--> <!--</div>-->");
$templateCache.put("app/agent/components/footer/footer.html","<footer class=\"container-fluid agent-footer\"><div class=row><div class=\"col-md-6 flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"footer-logo pull-left\"><p class=agent-footer-left>{{date | date :\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"col-md-6 text-right agent-footer-right text-blue\"><a href=/faqs><span>FAQs</span></a><div class=\"col-md-3 flex-style\"><div class=hdfc-mutualfund><img src=assets/images/hdfc-mutualfund.png alt=\"HDFC Mutual Fund\" class=\"footer-logo1 pull-left\"></div><div class=app-store><a href=\"https://itunes.apple.com/us/app/mfonline-investors/id1380088205?mt=8\" target=_blank><svg id=livetype xmlns=http://www.w3.org/2000/svg width=60 height=22 margin-top=5 viewBox=\"0 0 119.66407 40\"><g><g><g><path d=M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z style=\"fill: #a6a6a6\"></path><path d=M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z></path></g><g id=_Group_ data-name=\"<Group>\"><g id=_Group_2 data-name=\"<Group>\"><g id=_Group_3 data-name=\"<Group>\"><path id=_Path_ data-name=\"<Path>\" d=M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z style=\"fill: #fff\"></path><path id=_Path_2 data-name=\"<Path>\" d=M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z style=\"fill: #fff\"></path></g></g><g><path d=M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z style=\"fill: #fff\"></path><path d=M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z style=\"fill: #fff\"></path><path d=M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z style=\"fill: #fff\"></path><path d=M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z style=\"fill: #fff\"></path><path d=M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z style=\"fill: #fff\"></path><path d=M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z style=\"fill: #fff\"></path><path d=M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z style=\"fill: #fff\"></path><path d=M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z style=\"fill: #fff\"></path></g></g></g><g id=_Group_4 data-name=\"<Group>\"><g><path d=M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z style=\"fill: #fff\"></path><path d=M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z style=\"fill: #fff\"></path><path d=M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z style=\"fill: #fff\"></path><path d=M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"></path><path d=M59.09377,8.437h.88867v6.26074h-.88867Z style=\"fill: #fff\"></path><path d=M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z style=\"fill: #fff\"></path><path d=M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z style=\"fill: #fff\"></path><path d=M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z style=\"fill: #fff\"></path><path d=M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z style=\"fill: #fff\"></path><path d=M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z style=\"fill: #fff\"></path><path d=M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z style=\"fill: #fff\"></path><path d=M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z style=\"fill: #fff\"></path><path d=M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z style=\"fill: #fff\"></path></g></g></g></svg> </a><a href=\"https://play.google.com/store/apps/details?id=com.hdfcfund.investor&amp;hl=en_IN\" target=_blank><img src=assets/images/google-play-badge.png alt=\"Google Play\" class=\"footer-logo1 pull-left\"></a></div></div><span class=col-md-9 style=\"padding-left: 25px\">Customer Care: 18002679944<p class=text-right>(Toll Free)</p></span></div></div><div class=\"row best-view\"><p><strong>Site Best Viewed At</strong>: 1360 x 840 resolution in I.E 11 or above, Mozilla 50 or above, Google Chrome 15 or above, Safari 5.0 +</p></div></footer>");
$templateCache.put("app/agent/components/header/header.html","<div class=head-contrast><ul><li ng-click=\"Header.changedFont(\'increment\')\" title=\"Increase font size\">A+</li><li ng-click=\"Header.changedFont(\'original\')\" title=\"Reset font size\">A</li><li ng-click=\"Header.changedFont(\'decrement\')\" title=\"Decrease font size\">A-</li><li ng-click=Header.contrast() title=\"High Contrast\" class=contrast-box><span class=\"glyphicon glyphicon-adjust\"></span></li></ul></div><header class=\"container-fluid agent-header common affix not-mobile\"><div><span class=logo><img src=../../../assets/images/logo-main.png> </span><span class=agent-name>{{$root.role}}</span></div><div class=\"pull-right right-panel\"><div ng-if=\"$root.role===\'Agent\' && $root.isDistributor\"><a href=Header.impersonateLogout() class=home-con ng-click=Header.impersonateLogout()><i class=home-icon></i></a></div><!--    <div ng-if=\"$root.role===\'Agent\' && $root.isDistributor\">--><!--      <span class=\"dropdown\">--><!--        <a href=\"javascript:void(0)\" class=\"dropdown-toggle icon-box cursor-pointer\" data-toggle=\"dropdown\">--><!--          <span class=\"initiate-transaction-icon\"></span>--><!--          <span class=\"block\">Initiate Transaction</span></a>--><!--        <ul class=\"dropdown-menu initiate-trans\">--><!--          <li>Initiate Transactions for</li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'SIP or Purchase\')\">SIP or Purchase</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'Switch\')\">Switch</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'Systematic Withdrawal Plan\')\">SWP</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'Systematic Transfer Plan\')\">STP</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'Redemption\')\">Redeem</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'DTP\')\">DTP</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'FLEXINDEX\')\">Flex Index</a></li>--><!--          <li><a href=\"javascript:void(0)\" ng-click=\"Header.updateSideBar(\'FLEXSTP\')\">Flex STP</a></li>--><!--          &lt;!&ndash;<li ng-click=\"Header.updateSideBarAgent(\'SWINGSTP\')\">Swing STP</li> commented at FD-1823&ndash;&gt;--><!--          <li><a href=\"javascript:void(0)\" ui-sref=\"main.rolloverView\" role=\"button\">Roll Over</a></li>--><!--        </ul>--><!--      </span>--><!--    </div>--><div ng-if=\"$root.role===\'Agent\'\"><span class=dropdown><a href=javascript:void(0); class=icon-box data-toggle=dropdown ng-click=Header.latestNotification()><i class=\"notification-icon dropdown-toggle\"></i> <span class=count ng-if=\"Header.notificationCount>0\" ng-click=Header.latestNotification()>{{Header.notificationCount}}</span></a><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<span class=block-style ng-if=notification.clickable ng-click=Header.openNotification(notification)><a href=#>Click to know more</a> </span></li><!--<li ng-repeat=\"notification in Header.latestNotificationList\" ng-click=\"Header.openNotification()\">{{notification.title}}<span class=\"block-style\"><a href=\"#\">Click to know more</a> </span> </li>--><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length>View All</li></ul></span></div><div class=logged-info><p><span>Logged in as:</span> <span>{{$root.agentName}}</span></p><p><span>Last Login:</span> <span>{{$root.lastLoginDate}}</span></p><!-- <span my-current-time=\"Header.format\"></span>   inside <p>--></div><div ng-if=\"$root.role===\'Agent\' && $root.isDistributor\" ng-click=Header.impersonateAgentLogout() class=\"no-border superadmin-logout\">LOGOUT <i class=power-icon></i></div><div ng-if=!$root.isDistributor class=\"no-border superadmin-logout\" ng-click=Header.agentLogout()>LOGOUT <i class=power-icon></i></div></div></header><!-- Agent Header Mobile --><header class=\"mobile-header common container-fluid affix\"><div class=part-left ng-click=Header.loadSidebar()><i class=menu-icon id=menuButton></i></div><div class=mobile-notification><span class=dropdown><a href=javascript:void(0); data-toggle=dropdown ng-click=Header.latestNotification()><i class=\"notification-icon dropdown-toggle\"></i> <span class=count ng-if=\"Header.notificationCount>0\" ng-click=Header.latestNotification()>{{Header.notificationCount}}</span></a><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\">{{notification.title}}<span class=block-style ng-if=notification.clickable ng-click=Header.openNotification(notification)><a href=#>Click to know more</a> </span></li><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length>View All</li></ul></span></div><div ng-if=\"$root.role===\'Agent\' && $root.isDistributor\"><a href=Header.impersonateLogout() class=home-con ng-click=Header.impersonateLogout()><i class=home-icon></i></a></div><div class=pull-right><div ng-if=\"$root.role===\'Agent\' && $root.isDistributor\" ng-click=Header.impersonateAgentLogout() class=\"no-border superadmin-logout\" style=\"color: white\">LOGOUT <i class=power-icon></i></div><div ng-if=!$root.isDistributor class=\"no-border superadmin-logout\" ng-click=Header.agentLogout() style=\"color: white\">LOGOUT <i class=power-icon></i></div></div><div class=black-tint ng-click=Header.sidebarBlackTint()></div><aside class=mobile-menu style=\"overflow: scroll; background-color: white\"><div class=\"affix stick-top text-center border-right-0\" style=\"background-color: white\"><div class=\"head border-right-0\"><img class=logo-mobile src=../../../assets/images/logo-main.png><h3 style=\"color: black\">{{$root.role}}</h3></div></div><!--    sidebar menu--><nav><aside class=\"mobile-nav nav-agent\"><ul ng-if=!$root.isDistributor><li ui-sref=agent.home.distributor-list ng-click=Header.removeSidebarList()><span class=nav-link>DISTRIBUTORS</span></li></ul><ul ng-if=$root.isDistributor><li ng-click=\"Header.searchInvestor(\'statements\'); Header.removeSidebarList()\"><span class=nav-link>STATEMENTS</span></li><li ng-click=\"Header.searchInvestor(\'update-contact\')\"><span class=nav-link>UPDATE CONTACT</span></li></ul></aside></nav></aside></header>");
$templateCache.put("app/agent/components/sidebar/sidebar.html","<aside class=agent-sidebar ng-init=AgentSidebar.initTab()><ul ng-if=!AgentSidebar.isDistributor><li ng-class=\"{\'active\':AgentSidebar.active[0]}\" ng-click=AgentSidebar.activateTab(0) ui-sref=agent.home.distributor-list><span class=nav-link>Distributors</span></li><!--    <li ng-class=\"{\'active\':AgentSidebar.active[1]}\" ui-sref=\"agent.home.transactionApproval\"> &lt;!&ndash;ng-click=\"AgentSidebar.activateTab(1)\" ui-sref=\"\"&ndash;&gt;--><!--      <span class=\"nav-link\">Transaction Approval</span>--><!--    </li>--></ul><ul ng-if=AgentSidebar.isDistributor><li ng-click=\"AgentSidebar.searchInvestor(\'statements\')\"><!--ng-click=\"AgentSidebar.activateTab(1)\" ui-sref=\"\"--> <span class=nav-link>Statements</span></li><li ng-click=\"AgentSidebar.searchInvestor(\'update-contact\')\"><!--ng-click=\"AgentSidebar.activateTab(1)\" ui-sref=\"\"--> <span class=nav-link>Update Contact</span></li></ul><!--  <ul ng-if=\"AgentSidebar.isDistributor\">--><!--    <li ng-click=\"AgentSidebar.updateSideBarInvestor()\" > &lt;!&ndash;ng-click=\"AgentSidebar.activateTab(1)\" ui-sref=\"\"&ndash;&gt;--><!--      <span class=\"nav-link\">Add Investor</span>--><!--    </li>--><!--  </ul>--></aside>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/all.funds.html","<div class=\"container-fluid all-funds\"><div class=row><div class=\"col-md-12 mobile-padding\"><form><div class=row><div class=col-md-12><div class=header-container><div class=row><div class=col-md-12><div class=search><input type=text ng-model=allFormData.searchModel ng-change=searchRecords() class=form-control placeholder=Search aria-label=Search aria-describedby=basic-addon2> <button class=btn-sm><img src=/assets/images/icons/icon-search-white.png></button></div></div></div><div class=row><div class=\"col-xs-8 col-md-6\"><div class=radio ng-if=false><ul><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': isRegular}\">Direct</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=isRegular ng-change=changeFundsListing() class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !isRegular}\">Regular</span></li></ul></div></div><div class=\"col-xs-4 col-md-6\"><div class=\"filter-action pull-right\"><button class=btn-sm ng-click=openFilter()><img src=/assets/images/filter-red.svg> Filter</button></div></div></div></div></div></div><div class=row ng-repeat=\"fund in funds track by $index\"><div class=\"col-md-12 rel-recommend\"><p class=recommend ng-if=\"isFromHdfcOneClick && fund.recommended\">Recommended</p><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-header><div class=row><div class=col-md-12><div class=investment-details>{{fund.fundName}}</div></div></div></div><div class=card-body><div class=row><div class=col-md-12><div class=fund-details><div class=blue ng-if=\"fund.fundCategory.length > 0 && fund.fundCategory[0] !=\'\'\">{{fund.fundCategory[0]}}</div><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low risk\' || fund.riskReturnProfile == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Low to Moderate Risk\'|| fund.riskReturnProfile == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderate Risk\' || fund.riskReturnProfile == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Moderately High Risk\' || fund.riskReturnProfile == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'High Risk\' || fund.riskReturnProfile == \'High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{fund.riskReturnProfile[0]}} ng-if=\"fund.riskReturnProfile[0] == \'Very High Risk\' || fund.riskReturnProfile == \'Very High Risk\'\"><div class=blue>{{isFromHdfcOneClick?fund.riskReturnProfile[0]: fund.riskReturnProfile[0]}}</div></div><div class=\"blue-background white\" ng-if=fund.investorInvested>{{fund.investorInvested}}</div></div></div></div><div class=\"row inception-align\"><div class=\"col-xs-8 col-md-6\"><div class=investment-label ng-if=isRegular>NAV as on <span ng-if=fund.fundNavRegular.nav_date[11]>{{fund.fundNavRegular.nav_date[11]}}</span></div><div class=investment-label ng-if=!isRegular>NAV as on <span ng-if=fund.fundNavDirect.nav_date[11]>{{fund.fundNavDirect.nav_date[11]}}</span></div></div><div class=\"col-xs-4 col-md-6\"><div class=\"nav-amount pull-right\" ng-if=!isRegular>&#8377{{fund.fundNavRegular.nav_amount[11] ? utilService.getCommaSeperatedWithFloatValue(fund.fundNavRegular.nav_amount[11]): 0}}</div><div class=\"nav-amount pull-right\" ng-if=isRegular>&#8377{{fund.fundNavDirect.nav_amount[11]? utilService.getCommaSeperatedWithFloatValue(fund.fundNavDirect.nav_amount[11]): 0}}</div></div></div><!--<hr>\n                      <div class=\"row\" ng-if=\"isRegular && fund.regularCagrReturns.length > 0\">\n                        <div class=\"col-xs-6 col-md-6\">\n                          <div class=\"row\">\n                            <div class=\"col-xs-4 col-md-6\">\n                              <div class=\"investment-label\">\n                                CAGR\n                              </div>\n                            </div>\n                            <div class=\"col-xs-8 col-md-6\">\n                              <div class=\"cagr-select\">\n                                <select\n                                  class=\"custom-select\"\n                                  tooltip-placement=\"top\" uib-tooltip=\"{{fund.selectedYear}}\"\n                                  ng-model = \"fund.selectedYear\"\n                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.regularCagrReturns\"\n                                  ng-change=\"displayCagrValue(fund)\"\n                                ></select>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-xs-6 col-md-6\">\n                          <div class=\"cagr-percent pull-right\">\n                            {{fund.regularCagr}}%\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"row\" ng-if=\"!isRegular && fund.directCagrReturns.length > 0\">\n                        <div class=\"col-xs-8 col-md-8\">\n                          <div class=\"row\">\n                            <div class=\"col-xs-3 col-md-3\">\n                              <div class=\"investment-label\">\n                                CAGR\n                              </div>\n                            </div>\n                            <div class=\"col-xs-9 col-md-8\">\n                              <div class=\"cagr-select\">\n                                <select\n                                  class=\"custom-select\"\n                                  ng-model = \"fund.selectedYear\"\n                                  ng-options=\"cagrReturn.key as cagrReturn.key for cagrReturn in fund.directCagrReturns\"\n                                  ng-change=\"displayCagrValue(fund)\"\n                                ></select>\n                              </div>\n                            </div>\n                          </div>\n                        </div>\n                        <div class=\"col-xs-4 col-md-4\">\n                          <div class=\"cagr-percent pull-right\">\n                            {{fund.directCagr}}%\n                          </div>\n                        </div>\n                      </div>--></div><div class=card-footer><div class=row><div class=col-md-12><div class=card-action><!--<button class=\"btn btn-secondary\">Details</button>--> <button class=\"btn btn-primary\" ng-click=moveToCartDetails(fund)>Add to cart</button></div></div></div></div></div></div></div></div></div></div></form></div></div></div><div class=\"row filter-row\"><div class=col-md-12><div class=row><div class=\"col-xs-3 col-md-4 height100 backdrop\"></div><div class=\"col-xs-9 col-md-8 height100 content-col\"><section class=\"sidebar-content-section height100\"><div class=\"row height100\"><div class=col-md-12><div class=row><div class=col-md-12><div class=filter-header><h1>Filters</h1><a class=cancel-cta ng-click=openFilter()><i class=times-icon></i></a></div></div></div><div class=row><div class=col-md-12><div ng-repeat=\"filter in filterList\"><uib-accordion><div uib-accordion-group class=panel-default is-open=true><uib-accordion-heading>{{filter.filterName}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-up\': status.open, \'glyphicon-chevron-down\': !status.open}\"></i></uib-accordion-heading><div class=checkbox ng-repeat=\"option in filter.filterOptions\" ng-if=\"option.key !== \'Children Fund\'\"><input ng-model=option.checked type=checkbox ng-change=\"filterFunds(filter.filterKey, filter.filterOptions)\"> <i class=icon-checkbox></i><div class=option-name>{{option.key}}</div></div></div></uib-accordion></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/brokerTypeThrough.html","<div class=\"container-fluid invest-through-container\"><div class=row><div class=\"col-md-12 mobile-padding\"><form name=tForm novalidate autocomplete=off><div class=row ng-if=!isFromHdfcOneClick><div class=col-md-12><label class=select-label>Select Broker Type</label></div></div><div class=row ng-if=!isFromHdfcOneClick><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughDistributor ng-click=\"changeThroughDistributor(\'DISTRIBUTOR\')\"> <span class=check></span> </span><span class=radio-label>MFD</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughRia ng-click=\"changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.brokerCode.$dirty&&tForm.brokerCode.$invalid)}><label>ARN <span class=asterisk-error ng-if=!investThroughFormData.distributorName>*</span></label><div ng-class=\"{\'anything-disabled\':isFromHdfcOneClick}\"><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=investThroughFormData.brokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=authARN(); ng-required=!investThroughFormData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ ></div><span class=highlight></span> <span class=bar></span><!-- <p ng-if=\"investThroughFormData.brokerName\" class=\"info-primary\">Distributor Name:\n                {{investThroughFormData.brokerName}}</p> --> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid &&tForm.brokerCode.$error.required) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid && tForm.brokerCode.$error.pattern) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"brokerCodeError !== \'\' && !tForm.brokerCode.$invalid\" ng-bind=brokerCodeError></span></div></div></div><div class=row ng-if=\"investThroughFormData.isThroughDistributor && !isFromHdfcOneClick\"><div class=\"col-md-12 text-center\"><label class=label-black>OR</label></div></div><div class=row ng-if=\"investThroughFormData.isThroughDistributor && !isFromHdfcOneClick\"><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.distributorName.$dirty&&tForm.distributorName.$invalid)}><label>Search Distributor <span class=asterisk-error ng-if=!investThroughFormData.brokerCode>*</span></label><input type=text name=distributorName id=distributorName ng-model=investThroughFormData.distributorName ng-change=searchDistributorByName() autocomplete=off ng-required=!investThroughFormData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><drop-down list-data=distributorList display-key=name display-key-second=arnCode hdfc-click=distributorListChanged(data) model=investThroughFormData.distributorARN for=distributorName></drop-down></div></div></div><div class=row ng-if=\"investThroughFormData.isThroughDistributor && !isFromHdfcOneClick\"><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.subBrokerARN.$dirty&&tForm.subBrokerARN.$invalid)}><label>Sub Broker ARN</label><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=investThroughFormData.subBrokerARN ng-change=changeSubBrokerArn() ng-blur=fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ placeholder=ARN autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><p ng-if=subBrokerName class=info-primary>Sub Broker Name: {{subBrokerName}}</p><span class=error-input ng-show=\"(tForm.subBrokerARN.$dirty && tForm.subBrokerARN.$invalid && tForm.subBrokerARN.$error.pattern)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"subBrokerCodeError != \'\'&& !tForm.subBrokerARN.$error.pattern\" ng-bind=subBrokerCodeError></span></div></div></div><div class=row ng-if=\"investThroughFormData.isThroughDistributor && !isFromHdfcOneClick\"><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.subBrokerCode.$dirty&&tForm.subBrokerCode.$invalid)}><label>Sub Broker Code <span class=asterisk-error ng-if=investThroughFormData.subBrokerARN>*</span></label><input type=text name=subBrokerCode id=subBrokerCode ng-model=investThroughFormData.subBrokerCode autocomplete=off ng-disabled=\"!investThroughFormData.subBrokerARN || subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false ng-required=investThroughFormData.subBrokerARN> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.subBrokerCode.$dirty&&tForm.subBrokerCode.$error.required ng-bind=VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.euinNameCode=\'\';filterEuinList();isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></div></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === true && investThroughFormData.isThroughDistributor\"><div class=\"col-sm-12 col-md-9\"><label class=select-label>Enter EUIN</label><div class=\"input-select input-normal\" ng-class={error:tForm.euin.$dirty&&tForm.euin.$invalid}><input type=text name=euindropdown id=euindropdown class=euinPadding ng-model=investThroughFormData.euinNameCode ng-change=filterEuinList() ng-pattern=/^[0-9]+$/ autocomplete=off><p for=arn class=euin-prefix style=\"top: 16px !important\">E</p><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=(tForm.euin.$dirty&&tForm.euin.$error.required) ng-bind=VALIDATE_DATA.EUIN_REQUIRED></span><!-- <drop-down\n                list-data=\"euinList\"\n                display-key=\"euinName\"\n                display-key-second=\"euinCode\"\n                hdfc-click=\"selectEuin(data)\"\n                model=\"investThroughFormData.euin\"\n                for=\"euindropdown\">\n              </drop-down> --></div><span class=error-input ng-show=\"tForm.euindropdown.$dirty && tForm.euindropdown.$error.pattern\" style=\"margin-top: 8px\">Only Number Value allowed</span><!-- <span class=\"error-input\" ng-if=\"tForm.euindropdown.$dirty && euinList && euinList.length == 0\">No EUIN Available</span> --></div></div><div class=row ng-if=\"investThroughFormData.isThroughDistributor && isFromHdfcOneClick\"><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.utmsource.$dirty&&tForm.utmsource.$invalid)}><label>UTM (Optional)</label><input type=text name=utmsource id=utmsource ng-model=investThroughFormData.utmsource autocomplete=off placeholder=\"UTM Source\"> <span class=highlight></span> <span class=bar></span></div></div></div><div class=row><div class=\"col-sm-12 col-md-9\" ng-if=isFromHdfcOneClick><div class=input-normal ng-class={error:(tForm.utmsource.$dirty&&tForm.utmsource.$invalid)}><input type=text name=utmmedium id=utmmedium ng-model=investThroughFormData.utmmedium placeholder=\"UTM Medium\" autocomplete=off> <span class=highlight></span> <span class=bar></span></div></div></div><!--        <div class=\"row\" ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === false && investThroughFormData.isThroughDistributor\" ng-hide=\"!distributorMessage\">--><!--          <div class=\"col-md-12\">--><!--            <div class=\"checkbox\">--><!--              <input ng-model=\"investThroughFormData.isCheckedTandC\" type=\"checkbox\"--><!--                     ng-disabled=\"investThroughFormData.isEuin\"--><!--                     ng-required=\"(investThroughFormData.brokerCode || !isArnSuccess) && !investThroughFormData.isEuin\"/>--><!--              <i class=\"icon-checkbox\"></i>--><!--              <ng-bind-html--><!--                class=\"bind-html\"--><!--                ng-bind-html = \"distributorMessage.content\"--><!--              ></ng-bind-html>--><!--            </div>--><!--          </div>--><!--        </div>--><!------------------------- RIA section starts from here------------------><div class=row ng-if=investThroughFormData.isThroughRia><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>RIA Code <span class=asterisk-error>*</span></label><input type=text name=riaCode id=riaCode ng-model=investThroughFormData.riaBrokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=nonArnAuth(); ng-required=!investThroughFormData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.required)\" ng-bind=VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.pattern)\" ng-bind=VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"riaCodeError !== \'\' && !tForm.riaCode.$invalid\" ng-bind=riaCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughRia><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>RIA Name</label><input type=text name=riaName ng-model=investThroughFormData.riaBrokerName ng-disabled=true capitalize ng-class=\"{\'anything-disabled\': !investThroughFormData.riaBrokerName}\"> <span class=highlight></span> <span class=bar></span></div></div></div><!--        <div class=\"row\" ng-if=\"investThroughFormData.isThroughRia\">--><!--          <div class=\"col-md-12\">--><!--            <div class=\"checkbox\">--><!--              <input ng-model=\"investThroughFormData.isCheckedTandC\" type=\"checkbox\"--><!--                     ng-disabled=\"!investThroughFormData.riaBrokerCode || riaCodeError !== \'\'\"--><!--                     ng-change=\"setTandCVariable();\"--><!--                     ng-required=\"investThroughFormData.riaBrokerCode\"/>--><!--              <i class=\"icon-checkbox\"></i>--><!--              <ng-bind-html--><!--                class=\"bind-html\"--><!--                ng-bind-html = \"riaMessage.content\"--><!--              ></ng-bind-html>--><!--            </div>--><!--          </div>--><!--        </div>--><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-if=!investThroughFormData.isThroughDistributor ng-disabled=\"tForm.$invalid || (riaCodeError !== \'\' && !tForm.riaCode.$invalid) || investThroughFormData.isThroughRia && (!investThroughFormData.riaBrokerCode)\" ng-click=\"updateCartViaInvestThrough(\'RIA\')\">Save</button> <button class=btn-primary ng-if=investThroughFormData.isThroughDistributor ng-disabled=\"tForm.$invalid || !investThroughFormData.brokerCode && !investThroughFormData.distributorName || investThroughFormData.subBrokerARN && (investThroughFormData.subBrokerARN && !investThroughFormData.subBrokerCode) || !arnNotEmpanneled\" ng-click=\"updateCartViaInvestThrough(\'MFD\')\">Save</button></div></div></form></div></div></div><style>.error > input{\n    border-bottom: 1px solid #d92018 !important;\n  }\n  .euin-prefix{\n    position: absolute;\n    left: 20px;\n    font-family: \"Mona Sans\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    color: #555555;\n  }\n  .euinPadding{\n    padding: 5px 5px 5px 33px !important;\n  }</style>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/cart-details.html","<div class=\"container-fluid cart-details-container\"><div class=row><div class=col-md-12><label class=label-black>You’re investing in {{fundName}}</label></div></div><div class=row><div class=col-md-12><form name=tform><div class=row><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><label>Select a Plan Option</label><input type=text name=sInScheme1 id=sInScheme1 class=select-icon ng-model=formData.schemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required> <span class=error-input ng-show=\"tForm.sInScheme1.$dirty && tForm.sInScheme1.$error.required\" ng-bind=VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=inSchemeList display-key=schemeName hdfc-click=\"inSchemeChanged(data, true)\" model=formData.schemeCode for=sInScheme1></drop-down></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.isDividend\"><div class=col-md-12><div class=input-field-card><div class=\"input-normal input-select\"><label>Select IDCW Option</label><input type=text id=investment name=investment class=select-icon ng-model=formData.investmentOptionName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required> <span class=error-input ng-show=\"tForm.investment.$dirty && tForm.investment.$error.required\" ng-bind=VALIDATE_DATA.INVESTMENT_OPTIONS_REQUIRED></span><drop-down list-data=investmentOptions display-key=key hdfc-click=changeInvestmentOptions(data) model=formData.dividendOption for=investment></drop-down></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\'\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">Purchase Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' ) && (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\" ng-click=\"removeTransactionFromList(\'PURCHASE\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount ng-model=formData.displayAmount ng-change=\"changeInstallmentAmount(\'PURCHASE\', true)\" maxlength=16 ng-maxlength=16 required><div><span ng-if=\"formData.amount && isPurchaseMin || isPurchaseMin\" class=\"error-input purchase-amount-error\">Minimum amount should be &#8377{{purchaseMinAmount}} </span><span ng-if=\"formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)\" class=\"error-input purchase-amount-error\">Please provide amount in multiples of &#8377;{{purchaseValidation.purchaseMultiple|unit}}<span ng-if=\"formData.amount % 1 != 0\">,</span> </span><span ng-if=\"formData.amount % 1 != 0\" class=\"error-input purchase-amount-error\" ng-class=\"{errorDown: formData.amount && isPurchaseMin}\">{{\"Amount can\'t be decimal\"}}</span></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in purchaseValidation.amountArray\" ng-click=\"formData.displayAmount=amount; changeInstallmentAmount(\'PURCHASE\', true)\"><img src=../../assets/images/icons/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><div class=\"cart-container transactions\"><div class=row><div class=\"col-xs-9 col-md-8\"><div class=\"section-title pull-left\">SIP Transaction</div></div><div class=\"col-xs-3 col-md-4\"><div class=section-action><a class=\"red link-action\" ng-if=\"(formData.schemeCode && formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\' )&& (formData.schemeCode && formData.sipOpted && sipValidation.sipEnabled === \'Y\')\" ng-click=\"removeTransactionFromList(\'SIP\')\">Remove</a></div></div></div><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=card><div class=card-body><label>Investment Amount</label><input type=text name=amount ng-model=formData.installmentDisplayAmount ng-change=\"changeInstallmentAmount(\'SIP\', true)\" required><div><span ng-if=\"formData.installmentAmount && isMin || isMin\" class=error-input>Minimum amount should be &#8377; {{validations.minAmount}} </span><span ng-if=\"formData.installmentAmount && isMax\" class=error-input>Maximum amount should be &#8377; {{Transaction.validations.maxAmount}}</span> <span ng-if=\"formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{validations.amountMultiples|unit}} </span><span ng-show=\"formData.installmentAmount && amountExceeded\" class=error-input ng-bind=VALIDATE_DATA.AMOUNT_EXCEEDED></span></div><div class=fi-consent ng-if=sipWithFi><div class=checkbox><input ng-model=Summary.isCheckedTandC type=checkbox> <i class=checkmark></i> <span class=checkbox-text>Wish to pay First installment with your SIP Registration</span></div></div><div class=amount-button-container><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in sipValidation.amountArray\" ng-click=\"formData.installmentDisplayAmount=amount; changeInstallmentAmount(\'SIP\', true)\"><img src=../../assets/images/icons/rupee-indian.svg>{{utilService.getCommaSeperatedString(amount)}}</button></div></div></div></div></div><div class=\"row increase-padding\"><div class=col-md-12><div class=input-field-card><div class=input-normal style=\"text-align: left\"><label>SIP Start Date (SIP Frequency - Monthly)</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.startDate.$dirty && tForm.startDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.startDate data-enabled-dates=enabledStartDates data-format={{startDateFormat}} data-min-date=startMinDateBiller data-max-date=startMaxDate data-on-date-change=changeStartDate data-view-date=enabledStartDates[0] data-enable=true style=\"position: relative\"><input id=startDateId type=text name=startDate placeholder=\"SIP Start Date - DD-MMM-YYYY\" ng-keyup=\"autoDate(\'startDate\')\" required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><div class=start-date-error><span class=\"error-input purchase-amount-error\" ng-if=\"formData.startDate && startDateError\">SIP Start Date is not valid. Please choose another date.</span></div></div></div></div><div class=row><div class=col-md-12><div class=input-field-card><div class=input-normal style=\"text-align: left\"><label>SIP End Date</label><div class=\"input-group date date-picker transaction-cal\" ng-class=\"{error:tForm.endDate.$dirty && tForm.endDate.$invalid}\" date-calendar data-viewmode={{viewMode}} data-date-default=formData.endDate data-on-date-change=changeEndDate data-enabled-dates=enabledEndDates data-format={{startDateFormat}} data-view-date=enabledEndDateView data-min-date=enabledEndDates[0] data-enable=true id=endDate showdefault=false><input id=endDateId type=text name=endDate placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-keyup=\"autoDate(\'endDate\')\" ng-blur=checkEnableEndDate() required> <span class=\"input-group-addon calender-container\"><span class=glyphicon-calendar-blue></span></span></div></div><span class=error-input ng-if=\"!isEndDateFound && formData.endDate\">Invalid Date</span></div><div class=fi-consent><div class=\"checkbox checkbox-width\" ng-class=\"{\'anything-disabled\': !formData.startDate || !enabledDefaultYear}\"><input ng-model=formData.isTillPerpetuity ng-change=changeTillPerpetuity() type=checkbox ng-disabled=\"!formData.startDate || !enabledDefaultYear\"> <i class=checkmark></i> <span class=checkbox-text>Default to Year, 2099</span></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"!formData.purchaseOpted && purchaseValidation.webPurchaseEnabled === \'Y\'\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'PURCHASE\');\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add Purchase Transaction</div></a></div></div><div class=row ng-if=\"!formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=col-md-12><a class=\"available-transactions link-action\" ng-click=\"addTransactionFields(\'SIP\');\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label red\">Add SIP Transaction</div></a></div></div><div class=row ng-if=\"isExceedingEmandateDate && formData.sipOpted && sipValidation.sipEnabled === \'Y\'\"><div class=\"col-xs-12 npciNote\"><!--dynamic note for emandate Ristriction--><ng-bind-html dynamic=NPCINote></ng-bind-html></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=addToCart() ng-if=\"!showSaveCart && !fromOneClickScreen\">Add to Cart</button> <button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=saveCartEdited() ng-if=\"showSaveCart && !fromOneClickScreen\">Save</button> <button class=btn-primary ng-disabled=\"tform.$invalid || (isMin) || (isMax) || (isPurchaseMin) || (formData.installmentAmount && amountExceeded) || (formData.installmentAmount && !isMax && !isMin && (validations.amountMultiples && !isMultiples) && !amountExceeded) || (formData.installmentAmount && isMax) || (formData.amount && !isPurchaseMin && (purchaseValidation.purchaseMultiple && !isMultiplesPurchase)) || (formData.amount && formData.amount % 1 != 0) || (!formData.purchaseOpted && !formData.sipOpted) || (formData.sipOpted && (!formData.endDate || !formData.startDate || startDateError)) || (formData.sipOpted && !isEndDateFound)\" ng-click=saveCartFromOneClick() ng-if=fromOneClickScreen>Save</button></div></div></form></div></div></div><style>.select-icon{\n    background-image: url(\"/assets/images/icons/red-down-icon.svg\") !important;\n    background-repeat: no-repeat;\n    background-position-x: 100%;\n    background-position-y: 50%;\n    background-color: transparent;\n    text-overflow: ellipsis;\n    padding: 5% 15% 5% 0;\n    cursor: pointer;\n  }</style>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/ecart.details.html","<div class=\"container-fluid ecart-details\"><div class=row><div class=\"col-md-12 mobile-padding\"><form style=\"margin-top: 0px\"><div class=row style=\"padding-top: 0px\"><div class=col-md-12 ng-if=\"brokerTypeFromCookies.brokerType == \'MFD\'\"><div class=cart-container><div class=row><div class=\"col-xs-7 col-md-12\"><div class=input-normal><label class=distributor-label>ARN</label><a class=arn_ria_edit ng-click=editBrokerType()>Edit</a> <input type=text class=arn-no name=brokerCode id=brokerCode ng-model=investThroughFormData.brokerCode autocomplete=off ng-required=!investThroughFormData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ readonly style=\"padding: 5px 5px 5px 67px\"> <span class=highlight></span> <span class=bar></span> <span for=brokerCode class=static-value-sidebar>ARN -</span><p ng-if=investThroughFormData.brokerName class=info-primary>{{investThroughFormData.brokerName}}</p><span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid &&tForm.brokerCode.$error.required) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid && tForm.brokerCode.$error.pattern) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"brokerCodeError !== \'\' && !tForm.brokerCode.$invalid\" ng-bind=brokerCodeError></span></div></div></div></div></div><div class=col-md-12 ng-if=\"brokerTypeFromCookies.brokerType == \'RIA\'\"><div class=cart-container><div class=row><div class=\"col-xs-7 col-md-12\"><div class=input-normal><label class=distributor-label>RIA Code</label><a class=arn_ria_edit ng-click=editBrokerType()>Edit</a> <input type=text name=riaCode id=riaCode ng-model=investThroughFormData.riaBrokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize readonly> <span class=highlight></span> <span class=bar></span><p ng-if=investThroughFormData.riaBrokerName class=info-primary>{{investThroughFormData.riaBrokerName}}</p><span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.required)\" ng-bind=VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.pattern)\" ng-bind=VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"riaCodeError !== \'\' && !tForm.riaCode.$invalid\" ng-bind=riaCodeError></span></div></div></div></div></div></div><div class=row ng-repeat=\"investment in investmentList track by $index\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-7 col-md-8\"><span class=\"review-table-data blue\">{{investmentArray[$index]}} Investment</span></div><div class=\"col-xs-5 col-md-4\"><div class=section-action><a class=\"red link-action link-action-edit\" ng-click=\"editTransactionFromCart(\'CART_DETAILS\',investment)\">Edit</a> <a class=\"red link-action\" ng-click=removeTransactionFromCart(investment.cartItemId)>Remove</a></div></div></div><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=\"col-xs-8 col-md-12\"><div class=investment-label>Scheme Name</div><div class=investment-details>{{investment.schemeName}}</div></div><!--                        <div class=\"col-xs-4 col-md-6\">--><!--                          <div class=\"investment-label\">--><!--                            CAGR--><!--                          </div>--><!--                          <div class=\"investment-details\">--><!--                            {{investment.CAGR}}%--><!--                          </div>--><!--                        </div>--></div><hr><div class=row><div class=\"col-xs-6 col-md-6\"><div class=investment-label>Investment Type</div><div class=investment-details><!--                            {{investment.investmentType}}--> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.sipOpted && investment.purchaseOpted\">SIP + Purchase</span> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.sipOpted && !investment.purchaseOpted\">SIP</span> <span class=\"review-table-data d-block black ng-scope\" ng-if=\"investment.purchaseOpted && !investment.sipOpted\">Purchase</span></div></div><div class=\"col-xs-6 col-md-6 amount-label\"><div class=investment-label>Amount</div><div class=investment-details ng-if=\"investment.sipOpted && !investment.purchaseOpted\"><span class=tool-text tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.installmentAmount)}}\">{{\'₹\' + utilService.getCommaSeperatedString(investment.installmentAmount)}}</span></div><div class=investment-details ng-if=\"investment.purchaseOpted && !investment.sipOpted\"><span class=tool-text tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.amount)}}\">{{\'₹\' + utilService.getCommaSeperatedString(investment.amount)}}</span></div><div class=investment-details ng-if=\"investment.sipOpted && investment.purchaseOpted\"><span class=tool-text tooltip-placement=top-left uib-tooltip=\"{{\'₹\' + utilService.getCommaSeperatedString(investment.amount + investment.installmentAmount)}}\">{{\'₹\' + utilService.getCommaSeperatedString((investment.amount + investment.installmentAmount))}}</span></div></div></div></div></div></div></div></div></div></div><div class=row ng-repeat=\"suggestion in showingTrendingFunds track by $index\" ng-if=\"investmentList.length < 3\"><div class=col-md-12><div class=cart-container><div class=row><div class=col-md-12><div class=card><div class=card-body><div class=row><div class=col-md-12><div class=suggestion-label ng-click=addTrendingFund(suggestion)>Would you like to add <i class=red>{{suggestion.fundName}}</i> to your cart?</div></div></div><hr><div class=row><div class=\"col-xs-12 col-md-12\"><div class=\"row display-flex riskometer\"><!--                            <div class=\"col-xs-6 col-md-6\">--><!--                              <div class=\"investment-label\">--><!--                                CAGR--><!--                              </div>--><!--                              <div class=\"investment-details\">--><!--                                {{suggestion.cagrValue}}%--><!--                              </div>--><!--                            </div>--><!--                            <div class=\"col-xs-6 col-md-6\">--><!--                              <div class=\"cagr-select\">--><!--                                <select--><!--                                  name=\"cagr-{{$index}}\"--><!--                                  class=\"custom-select\"--><!--                                  ng-model = \"formData.yearSelected[$index]\"--><!--                                  ng-options=\"key as (key == \'11\'? \'Since Inception\' :key == \'1\'? key + \' \' +\'Year\': key + \' \' +\'Years\') for (key,value) in suggestion.annualisedReturns\"--><!--                                  ng-change=\"showCagrValue($index)\"--><!--                                  ng-init=\"formData.yearSelected = formData.yearSelected? formData.yearSelected: null\"--><!--                                ></select>--><!--                              </div>--><!--                            </div>--><div class=\"col-xs-6 col-md-12\"><div class=investment-label>Risk Rating</div><div class=investment-details><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Low risk\' || suggestion.riskReturnProfile == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Low to Moderate Risk\'|| suggestion.riskReturnProfile == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Moderate Risk\' || suggestion.riskReturnProfile == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Moderately High Risk\' || suggestion.riskReturnProfile == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'High Risk\' || suggestion.riskReturnProfile == \'High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{suggestion.riskReturnProfile}} ng-if=\"suggestion.riskReturnProfile == \'Very High Risk\' || suggestion.riskReturnProfile == \'Very High Risk\'\"><div class=blue>{{suggestion.riskReturnProfile}}</div></div><div class=\"blue-background white\" ng-if=suggestion.investorInvested>{{suggestion.investorInvested}}</div></div></div></div></div></div></div></div></div></div></div></div></div><div class=row ng-if=\"investmentList.length < maximumItemAllowed\"><div class=col-md-12><div class=cart-container><div class=row><div class=\"col-xs-12 col-md-12\"><div class=card><div class=row><div class=col-md-12><div class=addmore-fund-section><a class=\"available-transactions link-action\" ng-click=\"setSideBarState(\'ALL_FUNDS\')\"><div><img src=assets/images/icons/circle-add.svg alt=add></div><div class=\"label black\" ng-if=\"investmentList.length > 0\">Add More Funds</div><div class=\"label black\" ng-if=\"investmentList.length == 0\">Add Funds</div></a><div class=sub-heading>You can add maximum {{maximumItemAllowed | number2words}} items to the cart</div></div></div></div></div></div></div></div></div></div><div class=row><div class=\"col-md-12 text-center\"><div class=action-container><button ng-disabled=\"hideGenerateLinkButton || addToCartItem.cartItems.length < 1 || url\" class=btn-primary ng-click=generateLink();scrollToTop();>Generate Link</button></div></div></div></form><div class=\"container-fluid text-start\" ng-show=url style=\"margin-top: 32px;color: #6F6F6F\"><div class=row><p>ARN<span ng-if=!isFromHdfcOneClick>/RIA</span> Hardcoded Link<br>(For sharing with your investors on SMS, WhatsApp and Email)</p></div></div><div class=\"container-fluid text-start link-box\" ng-show=url><div class=\"row text-center link-container\"><div class=\"col-xs-9 col-sm-9 col-md-9 url\" style=\"position: relative\"><!--            <p id=\"myInput\">{{url}}</p>--><p id=myInput>{{urlArray[0]+\"com/\"}}</p><p id=myInput>{{urlArray[1]}}</p></div><div class=\"col-xs-3 col-sm-3 col-md-3 p-2 btn-link-container\" ng-click=copyToClipboard(url)><button class=btn-link>Copy Link</button></div></div></div></div></div></div><script>function CopyToClipboard(id) {\n    var r = document.createRange();\n    r.selectNode(document.getElementById(\'myInput\'));\n    window.getSelection().removeAllRanges();\n    window.getSelection().addRange(r);\n    document.execCommand(\'copy\');\n    window.getSelection().removeAllRanges();\n    // window.scrollTo(0,document.body.scrollHeight);\n    // window.scrollTo(0, 500);\n  }</script>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/invest-through.html","<div class=\"container-fluid invest-through-container\"><div class=row><div class=\"col-md-12 mobile-padding\"><form name=tForm novalidate autocomplete=off><div class=row><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isDirect ng-click=\"changeThroughDistributor(\'DIRECT\')\"> <span class=check></span> </span><span class=radio-label>Direct</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughDistributor ng-click=\"changeThroughDistributor(\'ARN\')\"> <span class=check></span> </span><span class=radio-label>Distributor</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=throughDistributor ng-value=true ng-model=investThroughFormData.isThroughRia ng-click=\"changeThroughDistributor(\'RIA\')\"> <span class=check></span> </span><span class=radio-label>RIA</span></div></div></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>ARN</label><input type=text class=arn-no name=brokerCode id=brokerCode ng-model=investThroughFormData.brokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=10 ng-pattern=/^[0-9]{4,10}$/ > <span class=highlight></span> <span class=bar></span><p ng-if=investThroughFormData.brokerName class=info-primary>Distributor Name: {{investThroughFormData.brokerName}}</p><span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid &&tForm.brokerCode.$error.required) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_REQUIRED></span> <span class=error-input ng-show=\"(tForm.brokerCode.$dirty && tForm.brokerCode.$invalid && tForm.brokerCode.$error.pattern) && (!investThroughFormData.distributorName)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"brokerCodeError !== \'\' && !tForm.brokerCode.$invalid\" ng-bind=brokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-md-12 text-center\"><label class=label-black>OR</label></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.distributorName.$dirty&&tForm.distributorName.$invalid)}><label>Search Distributor</label><input type=text name=distributorName id=distributorName ng-model=investThroughFormData.distributorName ng-change=searchDistributorByName() autocomplete=off ng-required=!investThroughFormData.brokerCode only-alphabets> <span class=highlight></span> <span class=bar></span><drop-down list-data=distributorList display-key=name display-key-second=arnCode hdfc-click=distributorListChanged(data) model=investThroughFormData.distributorARN for=distributorName></drop-down></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.subBrokerARN.$dirty&&tForm.subBrokerARN.$invalid)}><label>Search Broker ARN</label><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=investThroughFormData.subBrokerARN ng-change=changeSubBrokerArn() ng-blur=fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{4,10}$/ autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><p ng-if=subBrokerName class=info-primary>Sub Broker Name: {{subBrokerName}}</p><span class=error-input ng-show=\"(tForm.subBrokerARN.$dirty && tForm.subBrokerARN.$invalid && tForm.subBrokerARN.$error.pattern)\" ng-bind=VALIDATE_DATA.BROKER_VALID></span> <span class=error-input ng-show=\"subBrokerCodeError != \'\'&& !tForm.subBrokerARN.$error.pattern\" ng-bind=subBrokerCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=\"col-sm-12 col-md-9\"><div class=input-normal ng-class={error:(tForm.brokerCode.$dirty&&tForm.brokerCode.$invalid)}><label>Sub Broker Code</label><input type=text name=subBrokerCode id=subBrokerCode ng-model=investThroughFormData.subBrokerCode autocomplete=off ng-disabled=\"!investThroughFormData.subBrokerARN || subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=tForm.subBrokerCode.$dirty&&tForm.subBrokerCode.$error.required ng-bind=VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughDistributor><div class=col-md-12><div class=radio-block-container><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=true ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.isCheckedTandC=false\" required> <span class=check></span> </span><span class=radio-label>EUIN</span></div></div><div><div class=radio-block><span class=radio><input type=radio name=euinCheck ng-value=false ng-model=investThroughFormData.isEuin ng-click=\"investThroughFormData.euinNameCode=\'\';filterEuinList();isSelectedEuin=true;\"> <span class=check></span> </span><span class=radio-label>EUIN Declaration</span></div></div></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === true && investThroughFormData.isThroughDistributor\"><div class=\"col-sm-12 col-md-9\"><div class=\"input-select input-normal selectfield\" ng-class={error:tForm.euin.$dirty&&tForm.euin.$invalid}><label>Select Euin</label><input type=text name=euin id=euin ng-model=investThroughFormData.euinNameCode ng-change=filterEuinList() ng-required=\"(investThroughFormData.brokerCode || investThroughFormData.distributorName) && !investThroughFormData.isCheckedTandC\" autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"(tForm.euin.$dirty&&tForm.euin.$error.required) || !isSelectedEuin\" ng-bind=VALIDATE_DATA.EUIN_REQUIRED></span><list-drop-down list-data=euinList display-key=euinName display-key-second=euinCode hdfc-click=selectEuin(data) model=investThroughFormData.euin for=euin></list-drop-down></div></div></div><div class=row ng-if=\"investThroughFormData.isEuin != null && investThroughFormData.isEuin === false && investThroughFormData.isThroughDistributor\" ng-hide=!distributorMessage><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=investThroughFormData.isEuin ng-required=\"(investThroughFormData.brokerCode || !isArnSuccess) && !investThroughFormData.isEuin\"> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=distributorMessage.content></ng-bind-html></div></div></div><!------------------------- RIA section starts from here------------------><div class=row ng-if=investThroughFormData.isThroughRia><div class=\"col-sm-12 col-md-9\"><div class=input-normal><label>RIA Code</label><input type=text name=riaCode id=riaCode ng-model=investThroughFormData.riaBrokerCode ng-change=changeDistributorCode() autocomplete=off ng-blur=searchDistributor(); ng-required=!investThroughFormData.distributorARN maxlength=12 ng-pattern=/^[A-Z0-9]{12}/ capitalize> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.required)\" ng-bind=VALIDATE_DATA.RIA_REQUIRED></span> <span class=error-input ng-show=\"(tForm.riaCode.$dirty && tForm.riaCode.$invalid &&tForm.riaCode.$error.pattern)\" ng-bind=VALIDATE_DATA.RIA_INVALID></span> <span class=error-input ng-show=\"riaCodeError !== \'\' && !tForm.riaCode.$invalid\" ng-bind=riaCodeError></span></div></div></div><div class=row ng-if=investThroughFormData.isThroughRia><div class=col-md-12><div class=checkbox><input ng-model=investThroughFormData.isCheckedTandC type=checkbox ng-disabled=\"!investThroughFormData.riaBrokerCode || riaCodeError !== \'\'\" ng-change=setTandCVariable(); ng-required=investThroughFormData.riaBrokerCode> <i class=icon-checkbox></i><ng-bind-html class=bind-html ng-bind-html=riaMessage.content></ng-bind-html></div></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=btn-primary ng-if=!investThroughFormData.isThroughDistributor ng-disabled=\"investThroughFormData.isThroughRia && (!investThroughFormData.riaBrokerCode || !investThroughFormData.isCheckedTandC)\" ng-click=updateCartViaInvestThrough()>Save</button> <button class=btn-primary ng-if=investThroughFormData.isThroughDistributor ng-disabled=\"!investThroughFormData.brokerCode || (investThroughFormData.isEuin && !investThroughFormData.euinNameCode)\n              || (!investThroughFormData.isEuin && !investThroughFormData.isCheckedTandC)\" ng-click=updateCartViaInvestThrough()>Save</button></div></div></form></div></div></div>");
$templateCache.put("app/arn-hardcoded/e-cart/directives/sidebar.directive.html","<div class=\"col-sm-6 col-md-8 height100 backdrop backdrop-desktop-size\"></div><div class=\"col-sm-6 col-md-4 height100 content-col content-desktop-size\" id=scrollTo ng-init=init()><section class=sidebar-content-section><div class=row><div class=col-md-12><div class=row><div class=col-md-12><div class=header-section><a class=cancel-cta ng-click=collapse()><img src=/assets/images/icons/cross-circle.svg alt=collapse></a><h3>{{sidebarTitle == \'Invest Through\' ? \'Broker Type\' : sidebarTitle}}</h3></div><div class=body-section><div data-ng-switch=sidebarSection><div data-ng-switch-when=CART_DETAILS><div data-ng-include=\"\'app/arn-hardcoded/e-cart/directives/cart-details.html\'\"></div></div><div data-ng-switch-when=INVEST_THROUGH><div data-ng-include=\"\'app/arn-hardcoded/e-cart/directives/brokerTypeThrough.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/arn-hardcoded/e-cart/directives/ecart.details.html\'\"></div></div><div data-ng-switch-when=ALL_FUNDS><div data-ng-include=\"\'app/arn-hardcoded/e-cart/directives/all.funds.html\'\"></div></div></div></div></div></div></div></div></section></div>");
$templateCache.put("app/components/header/headers/dashboard-header.html","<header class=\"container-fluid common affix not-mobile\"><div class=main-header-container><div class=left-section><div class=pull-left><a href=javascript:void(0) id=sidebarCollapse class=visible-xs ng-click=Header.toggleSidebar();><img src=assets/images/logos/navbar-btn.svg alt=navbar> </a><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/dashboard/hdfcmf-logo.svg> </span><!--<span class=\"logo cursor-pointer\"><img ui-sref=\"main.dashboard\" src=\"../../../assets/images/dashboard/partner-logo.svg\"/> </span>--></div><div class=\"search pull-left hidden-xs hidden-sm hidden-md\"><i class=search-icon></i> <input type=search id=searchbox-header ng-model=Header.searchString autocomplete=off ng-change=Header.searchInvestor() class=form-control placeholder=\"Search Name, Folio Number, Mobile Number.\" aria-label=Search aria-describedby=basic-addon2> <button ng-if=\"Header.searchString && Header.searchString.length >= 3\" class=btn-cross ng-click=Header.emptySearch();><i class=times-icon></i></button><div id=searchresult-div class=suggestion ng-if=\"Header.searchResult && Header.searchResult.length\"><ul><li ng-repeat=\"data in Header.searchResult track by $index\" ng-click=Header.goToProfile(data,$index)>{{data.investorName}} -<p easyassist-key=mask-element>{{data.investorEmail}}</p></li></ul></div></div></div><div class=right-section><div class=\"pull-right right-panel\"><!--<div class=\"add-investor-wrapper\">\n          <a href=\"javascript:void(0)\" class=\"onboard-investor cursor-pointer\" ng-click=\"Header.updateSideBarInvestor()\" data-toggle=\"dropdown\">\n            <span class=\"block\">Add Investor</span></a>\n        </div>--><div class=transact-btn-wrapper><span class=\"dropdown transact-now\"><a href=javascript:void(0) ng-click=Header.closeFilter() class=\"dropdown-toggle icon-box cursor-pointer\" data-toggle=dropdown><span class=block>Transact</span> <img src=../../../assets/images/dashboard/icons/transaction-now-down.svg alt=down></a><ul class=\"dropdown-menu initiate-trans\"><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SIP\')\"><i class=sip-icon></i>SIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Purchase\')\"><i class=purchase-icon></i>Purchase</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXSIP\')\"><i class=flex-stp-icon></i>Flex SIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Switch\')\"><i class=switch-icon></i>Switch</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Withdrawal Plan\')\"><i class=swp-icon></i>SWP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Systematic Transfer Plan\')\"><i class=stp-icon></i>STP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Redemption\')\"><i class=redeem-icon></i>Redeem</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'Instant Access Facility\')\"><i class=iaf-icon></i>Instant Access Facility</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DTP\')\"><i class=tip-icon></i>TIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXINDEX\')\"><i class=flex-index-icon></i>Flex Index</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'FLEXSTP\')\"><i class=flex-stp-icon></i>Flex STP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'ROLLOVER\')\"><i class=rollover-icon></i>Roll Over</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'ChangeDividend\')\"><i class=change-idcw-icon></i>Change IDCW Option</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'SMARTSWAP\')\"><i class=smartswap-icon></i>SMART SWAP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'DREAMSIP\')\"><i class=dream-sip-icon></i>Dream SIP</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'BULK_TRANSACTIONS\')\"><i class=bulk-transaction-icon></i>Bulk Transactions</a></li><li><a href=javascript:void(0) ng-click=\"Header.updateSideBar(\'BULK_SIP\')\"><i class=bulk-sip-icon></i>Bulk SIP Renew</a></li><!--&lt;!&ndash;<li ng-click=\"Header.updateSideBarAgent(\'SWINGSTP\')\">Swing STP</li> commented at FD-1823&ndash;&gt;--></ul></span></div><div class=\"notification-wrapper hide-notification-mobile\"><span class=dropdown><a href=javascript:void(0) class=icon-box id=header-notification-icon data-toggle=dropdown ng-click=Header.latestNotification(true)><i class=notification-img></i> <span class=count ng-if=\"Header.notificationCount>0\">{{Header.notificationCount}}</span></a><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\"><a href=javascript:void(0)>{{notification.title}}</a><span class=block-style ng-if=notification.clickable ng-click=Header.openNotification(notification)><a href=#>Click to know more</a> </span></li><!--<li ng-repeat=\"notification in Header.latestNotificationList\" ng-click=\"Header.openNotification()\">{{notification.title}}<span class=\"block-style\"><a href=\"#\">Click to know more</a> </span> </li>--><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length><a href=javascript:void(0)>View All</a></li></ul></span></div><div class=\"search-icon-wrapper visible-xs visible-sm visible-md\" ng-click=Header.showSearchMobile()><a href=javascript:void(0) class=icon-box data-toggle=dropdown><i class=search-img></i></a></div><div class=\"notification-wrapper visible-xs visible-sm show-mobile-notification\" style=\"display: none\"><span class=dropdown><a href=javascript:void(0) class=icon-box id=header-notification-icon data-toggle=dropdown ng-click=Header.latestNotification(true)><i class=notification-img></i> <span class=count ng-if=\"Header.notificationCount>0\">{{Header.notificationCount}}</span></a><ul class=\"dropdown-menu notifications\"><li ng-repeat=\"notification in Header.latestNotificationList\"><a href=javascript:void(0)>{{notification.title}}</a><span class=block-style ng-if=notification.clickable ng-click=Header.openNotification(notification)><a href=#>Click to know more</a> </span></li><!--<li ng-repeat=\"notification in Header.latestNotificationList\" ng-click=\"Header.openNotification()\">{{notification.title}}<span class=\"block-style\"><a href=\"#\">Click to know more</a> </span> </li>--><li ng-if=!Header.latestNotificationList.length>You currently do not have any notifications</li><li ui-sref=main.notifications ng-if=Header.latestNotificationList.length><a href=javascript:void(0)>View All</a></li></ul></span></div><div class=cart-icon-wrapper><a href=javascript:void(0) class=icon-box ng-click=Header.openEcartSideBar(true)><i class=cart-img></i> <span class=count ng-if=\"Header.cartCount>0\">{{Header.cartCount}}</span></a></div><div class=\"faq-icon-wrapper hidden-xs\"><a ui-sref=faq class=\"pull-right faq\" href=javascript:void(0)><h4>FAQs</h4><i class=faq-icons></i></a></div><!--<div class=\"home-icon-wrapper\">\n          <a href=\"javascript:void(0)\" ui-sref=\"main.dashboard\">\n            <div class=\"home-img\"></div>\n          </a>\n        </div>--><div class=head-contrast><div class=wrapper><div class=toggle-action><ul class=togglePanel><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': Header.isDarkModeEnable}\">Light</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=Header.isDarkModeEnable ng-change=\"Header.contrast(); Header.toggleMode()\" class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !Header.isDarkModeEnable}\">Dark</span></li></ul></div><div class=separator></div><ul class=font-resize-ul><li ng-click=\"Header.changedFont(\'decrement\')\" title=\"Decrease font size\" ng-class=\"{\'active\': Header.count > -3 && Header.count < 0}\">A-</li><li ng-click=\"Header.changedFont(\'original\')\" title=\"Reset font size\" ng-class=\"{\'active\': Header.count === 0}\">A</li><li ng-click=\"Header.changedFont(\'increment\')\" title=\"Increase font size\" ng-class=\"{\'active\': Header.count > 0 && Header.count < 3}\">A+</li></ul></div></div><div class=\"no-border user-profile-section\"><span class=\"dropdown user-card\"><a href=javascript:void(0) ng-click=Header.closeFilter() class=\"user-small-pic dropdown-toggle\" data-toggle=dropdown><img http-src={{Header.profilePhotoUrl}} ng-if=Header.profilePhotoUrl> <span class=\"hidden-xs hidden-md\">{{Header.distributorName.split(\' \')[0]}}...</span> <img src=../../../assets/images/logos/drop-arrow-red.svg alt=down class=hidden-xs><!--<i class=\"{{Header.upperCrustAward.toLowerCase().trim().replace(\' \',\'-\')}}\"></i>--></a><ul class=\"dropdown-menu initiate-trans\"><li><img http-src={{Header.profilePhotoUrl}} ng-if=Header.profilePhotoUrl><label>Hello, <span class=red-text>{{Header.distributorName}}</span></label><br><small>Last Login - {{Header.lastLoginTime}}</small></li><li><a ui-sref=main.distributorProfile><i class=profile-icon></i> Profile</a></li><!--<li>\n                <a ui-sref=\"main.dashboardEdit\"> Customize Dashboard </a>\n              </li>--><li ng-click=Header.logoutMe()><a href=javascript:void(0)><i class=logout-icon></i> Sign-out</a></li></ul></span></div></div></div></div><div class=\"search search-mobile\" ng-if=Header.showSearch><i class=search-icon></i> <input type=search id=searchboxMobile ng-model=Header.searchString autocomplete=off ng-keydown=Header.searchInvestor() class=form-control placeholder=\"Search Name, Folio Number, Mobile Number..\" aria-label=Search aria-describedby=basic-addon2><div id=searchresult-div class=suggestion ng-if=\"Header.searchResult && Header.searchResult.length\"><ul><li ng-repeat=\"data in Header.searchResult track by $index\" ng-click=Header.goToProfile(data,$index)>{{data.investorName}} -<p easyassist-key=mask-element>{{data.investorEmail}}</p></li></ul></div></div></header><style>header.common .search-bar button.btn-cross{\n    height: 36px;\n    vertical-align: bottom;\n    border: none;\n    display: inline-block;\n    background: rgba(255, 255, 255, 0.4);\n    border-top-right-radius: 3px;\n    border-bottom-right-radius: 3px;\n    margin-left: -40px;\n  }</style>");
$templateCache.put("app/components/header/headers/login-header.html","<header class=\"headers container-fluid\"><div class=\"row main-head row-flex\"><div class=\"col-md-6 col-xl-8\"><div class=\"logo-section pull-left\"><a href=javascript:void(0) id=sidebarCollapse class=visible-xs ng-click=vm.toggleSidebar();><img src=assets/images/logos/navbar-btn.svg alt=navbar> </a><img src=assets/images/logos/hdfc-logo.svg alt=HDFC class=logo ui-sref=login></div></div><div class=\"col-md-2 col-xl-2\"><a ui-sref=faq class=\"pull-right faq\" href=javascript:void(0)><h4>FAQs</h4><i class=faq-icons></i></a></div><div class=\"col-md-4 col-xl-2 head-contrast-login-desktop\"><div class=toggle-action><ul class=togglePanel><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': vm.isDarkModeEnable}\">Light</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=vm.isDarkModeEnable ng-change=\"vm.contrast(); vm.toggleMode()\" class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !vm.isDarkModeEnable}\">Dark</span></li></ul></div><div class=separator></div><ul><li ng-click=\"vm.changedFont(\'decrement\')\" title=\"Decrease font size\" ng-class=\"{\'active\': vm.count > -3 && vm.count < 0}\">A-</li><li ng-click=\"vm.changedFont(\'original\')\" title=\"Reset font size\" ng-class=\"{\'active\': vm.count === 0}\">A</li><li ng-click=\"vm.changedFont(\'increment\')\" title=\"Increase font size\" ng-class=\"{\'active\': vm.count > 0 && vm.count < 3}\">A+</li></ul></div></div></header>");
$templateCache.put("app/components/modal/IFSCSelection/ifsc-selection.modal.html","<div class=modal-content id=ifsc-modal ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ></i>--><div class=\"modal-header modal-before-none\"><h4>IFSC Search</h4><button type=button class=close aria-label=Close ng-click=Modal.error()><span aria-hidden=true>&times;</span></button></div><div class=modal-body><form name=IFSCForm novalidate><div class=row><div class=col-md-5><div class=\"input-select input-normal\" ng-class=\"{error:IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid}\" ng-if=Modal.showFieldifsc><input type=text ng-model=Modal.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=Modal.IFSC_REGEX capitalize required ng-change=Modal.clearBankField()> <span class=highlight></span> <span class=bar></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid\"><!--\n              <span class=\"error-input\" ng-show=\"IFSCForm.ifsccode.$error.required\" ng-bind=\"Modal.APP_CONSTANT.IFSC_CODE_FIELD\"></span>\n--> <span class=error-input ng-show=IFSCForm.ifsccode.$error.pattern ng-bind=Modal.APP_CONSTANT.IFSC_CODE_REGEX></span></span></div></div></div><p class=form-raw-content>OR</p><br><div class=row><div class=col-md-5><div class=selectfield ng-class=\"{error:IFSCForm.bankName.$dirty && IFSCForm.bankName.$invalid}\" ng-if=Modal.showFieldbank><select class=select-box name=bankName ng-model=Modal.bankName ng-init=null ng-change=Modal.bankChange() ng-options=\"bank.bankName as bank.bankName for bank in Modal.bankList\" required><option value=\"\" selected>Bank Name</option></select><!--<label>Bank Name</label>--> <span class=\"req text-red\">*</span><!--<span class=\"error-input\" ng-messages=\"IFSCForm.bankName.$error\" ng-show=\"IFSCForm.bankName.$dirty\">\n                  <span ng-message=\"required\" ng-bind=\"Modal.APP_CONSTANT.BANK_NAME_REQUIRED\"></span>\n                  </span>--></div></div><div class=col-md-5><div class=selectfield ng-if=Modal.showFieldbank><select class=select-box name=city ng-model=Modal.cityName ng-options=\"city as city for city in Modal.cityList\" required ng-disabled=Modal.disabledCity><option value=\"\" selected>Select City</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-if=\"Modal.cityList && !Modal.cityList.length\" ng-bind=Modal.APP_CONSTANT.IFSC_MODAL_CITY_BLANK></span></div></div></div><div class=button-ali><div class=m-top><button class=\"btn btn-primary-action common-btn-padding border-button-form\" ng-click=Modal.searchIFSC() value=Search ng-disabled=\"!(Modal.ifsccode || (Modal.bankName && Modal.cityName))\" style=\"width: 155px\">Search</button></div><div class=m-top><button class=\"btn btn-primary-action common-btn-padding border-button-form\" ng-click=Modal.clearForm() value=Search ng-disabled=\"!(Modal.ifsccode || Modal.bankName || Modal.cityName)\" style=\"width: 155px\">Clear</button></div></div></form><div class=ifscModalDataDiv ng-if=\"Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><table class=\"table table-striped table-responsive rwd-table\" style=\"overflow-x: auto\"><thead><tr><th>Bank Name</th><th>Branch City</th><th>IFSC Code</th><th>Branch Location</th><th>State</th></tr></thead><tbody><tr ng-repeat=\"item in Modal.IFSCsearchResult\"><td data-th=\"Bank Name\" class=bank_name-ifsc_modal><input type=radio name=switch-radio1 ng-model=Modal.selectdIFSC checked value=0 ng-value=item> {{item.bankName}}</td><td data-th=\"Branch City\">{{item.branchCity}}</td><td data-th=\"IFSC Code\">{{item.ifscCode}}</td><td data-th=\"Branch Location\">{{item.branchLocation}}</td><td data-th=State>{{item.state}}</td></tr></tbody></table><div class=\"form-footer form-content\"><button class=\"btn btn-primary-action common-btn-padding border-button-form\" ng-click=Modal.submitIFSC() value=Select ng-disabled=!Modal.selectdIFSC>Select</button></div></div><div ng-if=\"Modal.searchIFSCCLicked && !Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><p class=no-result-ifsc>No Result Found</p></div></div></div><style>.m-top{\n    margin-top: 10px;\n  }\n  .button-ali{\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    flex-direction: row;\n  }\n   @media only screen and (max-width: 450px) {\n    .button-ali{\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }</style>");
$templateCache.put("app/components/modal/IFSCSelectionNewJourney/ifsc-selection-new-journey.modal.html","<div class=modal-content id=ifsc-modal ng-init=Modal.init() style=\"width: 107%\"><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ></i>--><div class=\"modal-head modal-before-none\" style=\"padding: 20px;\n    border-bottom: 1px groove #d0c8c8\"><h3>Search IFSC</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form name=IFSCForm novalidate><div class=row><div class=\"col-xs-12 col-sm-6 col-md-2\"><input type=radio name=forIfsc id=ifsc ng-checked=\"Modal.modeofifscsearch == \'IFSC\'\" ng-click=\"Modal.getIfscSerchMode(\'IFSC\')\"><label for=ifsc style=\"margin-bottom: 15px\">IFSC</label></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><input type=radio name=forIfsc id=bankcityname ng-checked=\"Modal.modeofifscsearch == \'BANKNAME\'\" ng-click=\"Modal.getIfscSerchMode(\'BANKNAME\')\"><label for=bankcityname>Bank Name & City</label></div></div><br><br><!-- IFSC --><div class=row ng-if=\"Modal.modeofifscsearch == \'IFSC\'\"><div class=col-md-5><p style=\"font-size: 10px;font-weight: bold\">Enter IFSC Code</p></div><div class=col-md-8><div class=\"input-select input-normal\" ng-if=Modal.showFieldifsc ng-class=\"{error:IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid}\"><input type=text class=form-control ng-model=Modal.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-pattern=Modal.IFSC_REGEX capitalize required autofocus ng-change=Modal.clearBankField() style=\"border: 1px solid gray;\n                border-radius: 8px;\n                height: 40px\"> <span ng-show=\"IFSCForm.ifsccode.$dirty && IFSCForm.ifsccode.$invalid\"><span class=error-input ng-show=IFSCForm.ifsccode.$error.pattern ng-bind=Modal.APP_CONSTANT.IFSC_CODE_REGEX></span></span></div></div><div class=col-md-2><button class=\"btn btn-primary-action common-btn-padding\" ng-click=Modal.searchIFSC() value=Search ng-disabled=!Modal.ifsccode style=\"background-color: #244b8c;color: white\">Search</button></div></div><!-- BANK NAME --><div class=row ng-if=\"Modal.modeofifscsearch == \'BANKNAME\'\"><div class=col-md-4><p style=\"font-weight: bold;margin-bottom: 2px\">Bank Name</p><div class=selectfield ng-class=\"{error:IFSCForm.bankName.$dirty && IFSCForm.bankName.$invalid}\" ng-if=Modal.showFieldbank><select class=\"select-box selectNormal\" name=bankName ng-model=Modal.bankName ng-init=null ng-change=Modal.bankChange() ng-options=\"bank.bankName as bank.bankName for bank in Modal.bankList\" required style=\"border: 1px solid #9f9f9f;border-radius: 5px\"><option value selected>Bank Name</option></select></div></div><div class=col-md-4><p style=\"font-weight: bold;margin-bottom: 2px\">City Name</p><div class=selectfield><select class=\"select-box selectNormal\" name=city ng-model=Modal.cityName ng-options=\"city as city for city in Modal.cityList\" required ng-disabled=!Modal.bankName ng-class={enable:Modal.bankName} style=\"border: 1px solid #9f9f9f;border-radius: 5px\"><option value selected>Select City</option></select><span class=error-input ng-if=\"Modal.cityList && !Modal.cityList.length\" ng-bind=Modal.APP_CONSTANT.IFSC_MODAL_CITY_BLANK></span></div></div><div class=col-md-2><br><button class=\"btn btn-primary-action common-btn-padding\" ng-click=Modal.searchIFSC() value=Search ng-disabled=\"!Modal.bankName || !Modal.cityName\" style=\"background-color: #244b8c;color: white; margin-top: 10px\">Search</button></div></div></form><!-- Show data --><div class=ifscModalDataDiv ng-if=\"Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><table class=\"table table-responsive rwd-table\" style=\"overflow-x: auto\"><thead><tr><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">Bank Name</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">IFSC Code</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">State</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">City</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\">Branch Location</th><th style=\"color: #607283;font-size: 12px;font-weight: 500;text-transform: none\"></th></tr></thead><tbody><tr ng-repeat=\"item in Modal.IFSCsearchResult\"><td data-th=\"Bank Name\" class=alignBankNameIfsc><!-- <input type=\"radio\" name=\"switch-radio1\" ng-model=\"Modal.selectdIFSC\" checked=\"\" value=\"0\" ng-value=\"item\" > --> {{item.bankName}}</td><td data-th=\"IFSC Code\">{{item.ifscCode}}</td><td data-th=State>{{item.state}}</td><td data-th=\"Branch City\">{{item.branchCity}}</td><td data-th=\"Branch Location\">{{item.branchLocation}}</td><td><p ng-click=Modal.submitIFSC(item) value=Select style=\"width: 100px;color: #244b8c;background-color: white;border: 1px solid #244b8c;height: 30px;border-radius: 15px;padding: 2px;text-align: center\">SELECT</p></td></tr></tbody></table><div class=\"form-footer form-content margin-ifsc-modal-footer\"></div></div><div ng-if=\"Modal.searchIFSCCLicked && !Modal.IFSCsearchResult.length && (Modal.ifsccode || (Modal.bankName && Modal.cityName))\"><p class=no-result-ifsc>No Result Found</p></div></div></div><style>input[type=\"radio\"] {\n              display: none;\n          }\n  \n          label {\n              position: relative;\n          }\n  \n  \n          label::before {\n              content: \"\";\n              border: 1px solid #222;\n              display: inline-block;\n              width: 25px;\n              height: 25px;\n              margin: -8px 20px;\n              margin-left: 0;\n              border-radius: 50%;\n          }\n          label::after {\n              content: \"\";\n              display: inline-block;\n              position: absolute;\n              width: 15px;\n              height: 15px;\n              left: 5px;\n              top: 8px;\n              margin: -8px 20px;\n              margin-left: 0;\n              border-radius: 50%;\n              transition: all 0.4s;\n          }\n          input[type=\"radio\"]:checked+label::after {\n              background: #ff8486;\n          }\n          input[type=\"radio\"]:checked+label::before {\n              border: 1px solid #ff8486;\n          }</style>");
$templateCache.put("app/components/modal/addDaysModal/addDays.modal.html","<div class=thirdholderPopup><div class=head style=\"margin: 15px\"><p style=\"padding-top: 15px;\n    font-size: 22px\"><b>Update Sip Dates</b></p><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=body style=\"margin: 12px;border-top-style: double;border-color: black;border-width: thin; padding-top: 15px\"><div class=container-flui><div class=row><div class=col-md-1></div><div class=\"col-xs-12 col-md-3\"><div class=pan-input-container><label class=s-label><b>Scheme Name :</b></label></div></div><div class=\"col-xs-12 col-md-7\"><div>{{Modal.modalData.sipName}}</div></div></div><div class=row><div class=col-md-1></div><div class=\"col-xs-12 col-md-3\"><div class=pan-input-container><label class=s-label><b>Amount :</b></label></div></div><div class=\"col-xs-12 col-md-7\"><div>{{Modal.modalData.amount}}</div></div></div><div class=row><div class=col-md-1></div><div class=\"col-xs-12 col-md-3\"><div class=pan-input-container><label class=s-label><b>Frequency :</b></label></div></div><div class=\"col-xs-12 col-md-7\"><div>{{Modal.modalData.frequency}}</div></div></div><div class=row><div class=col-md-1></div><div class=\"col-xs-12 col-md-3\"><div class=pan-input-container><label class=s-label><b>Start Date :</b></label></div></div><div class=\"col-xs-12 col-md-7\"><div class=col-md-7 style=padding-left:0px><!-- && Modal.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal ng-isolate-scope\" date-calendar=\"\" data-enable=true style=\"margin-bottom: 10px!important\" data-viewmode=\"\" data-format=DD-MMM-YYYY data-date-default=Modal.formData.startDate data-enabled-dates=Modal.enabledBillerStartDatesList data-min-date=Modal.startMinDateBiller data-max-date=Modal.startMaxDate data-on-date-change=Modal.changeStartDate id=startDate-biller><!--data-min-date=\"Modal.minStartDate\"--><!--data-max-date=\"Modal.maxStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"SIP Start date - DD-MMM-YYYY\" ng-model=Modal.formData.startDate required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div><div class=row><div class=col-md-1></div><div class=\"col-xs-12 col-md-3\"><div class=pan-input-container><label class=s-label><b>End Date :</b></label></div></div><div class=\"col-xs-12 col-md-7\"><div class=col-md-7 style=padding-left:0px><!-- && InitiateTransactionSipPurchase.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{Modal.startDateFormat}} data-enabled-dates=Modal.enabledEndDates style=\"margin-bottom: 10px!important\" data-date-default=Modal.formData.endDate data-min-date=Modal.minEndDate data-on-date-change=Modal.changeEndDate data-view-date=Modal.enabledEndDates[0] showdefault=false id=endDate-Biller><!----> <input type=text name=selectEndDate ng-disabled=Modal.isTillPerpetuity autocomplete=off class=form-control placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-model=Modal.formData.endDate required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div></div><div class=row style=\"padding: 20px\"><div class=col-md-1></div><div class=\"col-xs-6 col-md-3\"><button tabindex=3 type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" style=\"width: 92px;float: right;\n        height: 32px;\n        border-radius: 14px;\n        font-size: 14px;\n        border-color: transparent\">cancel</button></div><div class=\"col-xs-6 col-md-3\"><button tabindex=3 type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" style=\"width: 92px;\n        height: 32px;\n        border-radius: 14px;\n        font-size: 14px;\n        border-color: transparent\" ng-disabled=!Modal.formData.endDate>submit</button></div></div></div></div>");
$templateCache.put("app/components/modal/addInvestor/pan-verification-add-investor.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Add Investor</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.verificationForm ng-submit=Modal.verifyDetails() autocomplete=off novalidate><div class=\"input-select input-normal\" ng-class=\"{error:Modal.pan.$dirty && Modal.pan.$invalid}\"><input type=text easyassist-key=mask-element name=pan maxlength=10 minlength=10 ng-model=Modal.formData.pan required capitalize> <span style=color:red ng-show=\"Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid\"><span class=error-input ng-show=Modal.verificationForm.pan.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>PAN</label></div><div class=\"input-select input-normal\"><input type=text easyassist-key=mask-element date-calendar data-showdefault=true date-default=Modal.defaultDate format=DD-MMM-YYYY viewmode=days maxdate=now data-on-date-change=Modal.changeStartDate required> <span class=highlight></span> <span class=bar></span><label>Investor DOB</label><input easyassist-key=mask-element type=hidden ng-model=Modal.formData.dob required></div><button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=Modal.verificationForm.$invalid>Verify</button></form></div></div>");
$templateCache.put("app/components/modal/addInvestor/pan-verification-joint-holder.modal.html","<!-- Otp verification--><div class=modal-content id=addInvestor ng-init=Modal.defaultSetDate();><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title ng-bind=Modal.modalData.label.header>Add Joint Holder</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body nriHolderPopup\"><form class=verification-form autocomplete=off name=Modal.verificationForm novalidate><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-status-container><label class=s-label>Tax Status</label><div class=tax-field-container><div class=\"flex-check input-label\"><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=Modal.formData.taxStatusResident style=\"font-size: 12px\"><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{Modal.appconstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=\"flex-check input-label\"><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=Modal.formData.taxStatusResident style=\"font-size: 12px\"><label for=tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{Modal.appconstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div><div class=col-md-3></div></div><div class=\"input-select input-normal\" ng-class=\"{error:(Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid) || Modal.isPanBannedCountryInvalid || Modal.panAdharMessage}\"><input type=text easyassist-key=mask-element name=pan maxlength=10 minlength=10 ng-model=Modal.formData.pan ng-change=Modal.changePAN() ng-readonly=\"Modal.emailVerify===true||Modal.otpVerify === true\" capitalize required> <span ng-show=\"Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid\"><span class=error-input ng-show=Modal.verificationForm.pan.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=pAdharError ng-show=Modal.isPanAdharInvalid><span class=error-input ng-show=Modal.isPanAdharInvalid ng-bind-html=Modal.panAdharMessage></span> </span><!--PAN OF JOIN HOLDER ERROR MESSAGE FOR BANNED COUNTRY--> <span class=pAdharError ng-show=Modal.isPanBannedCountryInvalid><span class=error-input ng-show=Modal.isPanBannedCountryInvalid ng-bind-html=Modal.bannedCountryMessage></span> </span><span class=highlight></span> <span class=bar></span><label>{{Modal.modalData.label.pan}}<span class=req>*</span></label></div><div ng-if=\"Modal.emailVerify===true||Modal.otpVerify === true\" class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.email.$dirty && Modal.verificationForm.email.$invalid}\"><input type=email easyassist-key=mask-element name=email ng-model=Modal.formData.email ng-readonly=\"Modal.otpVerify === true\" ng-pattern=Modal.appConstants.email_regex maxlength=150 required> <span ng-show=\"Modal.verificationForm.email.$dirty && Modal.verificationForm.email.$invalid\"><span class=error-input ng-show=Modal.verificationForm.email.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.email.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>Email<span class=req>*</span></label></div><div ng-if=\"Modal.otpVerify === true\" class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.otp.$dirty && Modal.verificationForm.otp.$invalid}\"><input type=text easyassist-key=mask-element minlength=6 maxlength=6 name=otp ng-change=\"Modal.OTPResendMsg=\'\';Modal.wrongMsg=\'\'\" ng-model=Modal.formData.otp required> <span ng-show=\"Modal.verificationForm.otp.$dirty && Modal.verificationForm.otp.$invalid\"><span class=error-input ng-show=Modal.verificationForm.otp.$error.minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.otp.$error.maxlength ng-bind=Modal.validateData.OTP_FIELD></span> </span><span ng-if=!Modal.OTPResendMsg style=color:#46a040 class=\"common-error submit-success ng-binding\" ng-bind=Modal.emailMsg></span> <span style=color:#46a040 class=\"common-error submit-success\" ng-bind=Modal.OTPResendMsg></span> <span class=highlight></span> <span class=bar></span><label>OTP<span class=req>*</span></label><!--OTP RESEND BUTTON--> <span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.reGenerateOtp() class=forgot-pwd>Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\" style=\"margin-top: 0 !important\">Enable Resend OTP in {{countdown}}s</a></timer></span></div><button type=button ng-if=Modal.panVerify class=\"btn btn-primary-action btn-block\" ng-click=Modal.verifyPAN() ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify PAN</button> <button type=button ng-if=Modal.emailVerify class=\"btn btn-primary-action btn-block\" ng-click=Modal.verifyEmail() ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify Email</button> <button type=button ng-if=Modal.otpVerify class=\"btn btn-primary-action btn-block\" ng-click=Modal.verifyOTP() ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify OTP</button><div ng-class=\"{\'common-error\':Modal.wrongMsg != \'\'}\"><span ng-show=\"Modal.wrongMsg != \'\'\" ng-bind=Modal.wrongMsg></span></div></form></div></div><style>.pAdharError a {\n    font-size: 12px !important;\n    text-decoration: underline !important;\n  }</style>");
$templateCache.put("app/components/modal/addInvestor/pan-verification.modal.html","<!-- Otp verification--><div class=modal-content id=addInvestor ng-init=Modal.defaultSetDate();><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title ng-bind=Modal.modalData.label.header>Add Joint Holder</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.verificationForm autocomplete=off ng-submit=Modal.verifyDetails() novalidate><div class=\"input-select input-normal\" ng-class=\"{error:Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid}\"><input type=text easyassist-key=mask-element name=pan maxlength=10 minlength=10 ng-model=Modal.formData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ capitalize required> <span ng-show=\"Modal.verificationForm.pan.$dirty && Modal.verificationForm.pan.$invalid\"><span class=error-input ng-show=Modal.verificationForm.pan.$error.minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=\"Modal.verificationForm.pan.$error.pattern && !Modal.verificationForm.pan.$error.minlength\" ng-bind=Modal.validateData.INVALID_PAN></span> <span class=error-input ng-show=Modal.verificationForm.pan.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> </span><span class=highlight></span> <span class=bar></span><label>{{Modal.modalData.label.pan}}<span class=req>*</span></label></div><!--input-select input-normal input-group date date-picker--><div ng-if=Modal.modalData.label.dob class=\"input-select input-normal input-group date date-picker\" date-calendar data-showdefault={{Modal.isShowDefault}} data-viewmode={{Modal.viewMode}} data-date-default=Modal.defaultDate data-on-date-change=Modal.changeStartDate data-max-date=Modal.maxDefaultDOB format=DD-MMM-YYYY id=endDate><input id=dobId name=dob easyassist-key=mask-element type=text onfocus=focusChange() autocomplete=on required> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><!-- maxdate=\'now\' --> <input type=hidden easyassist-key=mask-element name=panDob ng-model=Modal.formData.dob required> <span class=highlight></span> <span class=bar></span><label>{{Modal.modalData.label.dob}}(DD-MMM-YYYY)<span class=req>*</span></label><br></div><button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=\"Modal.verificationForm.$invalid || Modal.wrongMsg != \'\'\">Verify</button><div ng-class=\"{\'common-error\':Modal.wrongMsg != \'\'}\"><span ng-show=\"Modal.wrongMsg != \'\'\" ng-bind=Modal.wrongMsg></span></div></form><script>function focusChange() {\n        var myEl = angular.element(document.querySelector(\'#dobId\'));\n        myEl.addClass(\'hasvalue\');\n      }</script></div></div>");
$templateCache.put("app/components/modal/addInvestor/success-investor.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsgs><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body><div ng-if=\"Modal.modalData.task != \'newINvestor\' \"><p class=go-green ng-bind=Modal.modalData.message></p><p class=go-green ng-if=\"Modal.modalData.folioResponse.status === true\">Folio has been successfully created. Your folio number is {{Modal.modalData.folioResponse.folioNumber}}.</p><p ng-if=Modal.modalData.lumpsumTransaction.status class=go-green>Lumpsum transaction successfully initiated and sent for the investor approval.</p><p ng-if=\"Modal.modalData.lumpsumTransaction.status === false\" class=go-red>Lumpsum transaction failed. Initiate transaction again.</p><p ng-if=\"Modal.modalData.sipTransaction.status === true\" class=go-green>SIP transaction successfully initiated and sent for the investor approval.</p><!--sip == null => no display; if sip == false => display error message--><p ng-if=\"Modal.modalData.sipTransaction.status === false\" class=go-red>SIP transaction transaction failed. Initiate transaction again.</p></div><div ng-if=\"Modal.modalData.task == \'newINvestor\' \"><p class=go-green>Prospect folio for <span>{{Modal.modalData.name}}</span> has been created and sent for approval</p></div><button ng-if=!Modal.modalData.folioResponse.status type=submit ng-click=Modal.continue() class=\"btn btn-primary-action\">OK</button> <button ng-if=Modal.modalData.folioResponse.status type=submit ui-sref=main.dashboard class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/addJointHolder/addJointHolder.modal.html","<div class=\"thirdholderPopup nriHolderPopup\"><div class=head><p><b>Add Third Holder</b></p><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=body><form class=verification-form autocomplete=off name=holderPanVerificationForm style=\"padding:40px; text-align: left\" ng-submit=Modal.submit() novalidate><div class=row><div class=\"col-xs-12 col-md-12\"><div class=tax-status-container><label class=s-label>Tax Status</label><div class=tax-field-container><div class=flex-check><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=Modal.formData.taxStatusResident style=\"font-size: 12px\" ng-change=Modal.changedRiNriTaxStatus()><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=flex-check><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=Modal.formData.taxStatusResident style=\"font-size: 12px\" ng-change=Modal.changedRiNriTaxStatus()><label for=tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{Modal.appConstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div><div class=col-md-3></div></div><!-- PAN input --><div class=row style=\"margin-top: 8px;\n            text-align: left\"><div class=\"col-xs-12 col-sm-8 col-lg-10 col-md-10\"><div class=pan-input-container><label for=pan><b>PAN</b></label><input class=form-control id=pan style=\"height: 40px; margin-top: 12px\" tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=Modal.holderData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=Modal.resetValues() ng-blur=Modal.checkPanEmailExist() capitalize required> <span ng-show=\"holderPanVerificationForm.pan.$dirty && holderPanVerificationForm.pan.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.pan.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.pattern ng-bind=Modal.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=Modal.panMessage ng-bind=Modal.panMessage></span></div></div></div><br><!-- Eamil Add --><div ng-if=Modal.showEmail class=\"input-select input-normal\"><div class=row style=\"margin-top: 20px;\n          text-align: left\"><div class=\"col-xs-12 col-md-8\"><p><b>Email</b></p></div><div class=\"col-xs-12 col-sm-8 col-lg-10 col-md-10\" style=\"margin-top: 12px\" ng-class=\"{\'anything-disabled\':Modal.showOtp}\"><div style=\"display: flex;align-items: center\"><input type=email name=email ng-model=Modal.holderData.email required style=\"border-radius: 4px;\n                border: 1px solid #242424\" ng-pattern=Modal.appConstants.email_regex></div><span ng-show=\"holderPanVerificationForm.email.$dirty && holderPanVerificationForm.email.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.email.$error.required ng-bind=Modal.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.email.$error.pattern ng-bind=Modal.validateData.EMAIL_FIELD></span></span><p ng-if=Modal.emailDetails.message>{{Modal.emailDetails.message}} <span>{{Modal.holderData.mobileNumber}}</span></p></div><div class=\"col-xs-8 col-sm-8 col-lg-10 col-md-10\" ng-class=\"{\'anything-disabled\':Modal.showOtp}\"><button type=button class=btn-holder ng-disabled=!Modal.holderData.email style=\"margin: 12px\" ng-click=Modal.AddEmailToHolderPan()>Add Email</button></div></div></div><!-- OTP --><div ng-if=Modal.showOtp><div><div class=row style=\"margin-top: 20px;\n            text-align: left\"><div class=\"col-xs-12 col-md-8\"><p><b>Verify OTP</b></p></div><div class=\"col-xs-8 col-sm-8 col-lg-10 col-md-10\" style=\"margin-top: 12px\"><input class=form-control type=text minlength=6 maxlength=6 name=otp ng-model=Modal.Otp required style=\"border-radius: 4px;border: 1px solid rgb(36, 36, 36);height: 41px\"> <span class=error-input ng-show=holderPanVerificationForm.otp.$error.minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.otp.$error.maxlength ng-bind=Modal.validateData.OTP_FIELD></span></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><button type=button class=btn-holder ng-click=Modal.verifyOtp() style=\"margin: 12px\" ng-disabled=!Modal.Otp>Verify</button></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.reGenerateOtp() class=\"resendBtn btn-holder forgot-pwd\" style=\"margin: 12px\">Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\">Enable Resend OTP in {{countdown}}s</a></timer></span></div></div></div></div><br><!-- Verify Button --><div class=kyc-verify style=\"padding-bottom: 40px;display: flex;justify-content: space-evenly\"><button tabindex=3 style=\"width: 35%;height: 42px\" type=submit class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-disabled=\"holderPanVerificationForm.pan.$invalid ||\n      !Modal.processFlag ||\n      !Modal.AllowedJointHolder\" ng-click=Modal.verifyOrAddHolder3()>VERIFY</button><br></div></form></div></div><style>.modal-content {\n      width: 460px;\n    }\n\n    b {\n      font-weight: bold;\n    }\n\n    @media screen and (max-width: 750px) {\n      .modal-content {\n        width: 90%;\n        margin-left: 5%;\n        margin-right: 5%;\n      }\n    }\n    @media only screen and (max-width: 1000px ){\n    .btn-primary-action-pay {\n      width: 150px !important;\n    }\n  }\n    .hdfc-blue-cta-small:disabled{\n      background-color: #FF8486;\n          color: white;\n  }\n    .btn-primary-action-pay {\n           width: 163px;\n           height: 35px;\n           border-color: transparent;\n           background-color: #FF8486;\n          border-radius: 50px !important;\n            line-height: 1.4 !important;\n             color: #ffffff;\n          padding: 6px 25px !important;\n          padding: 10px 10px 10px 10px;\n      border-radius: 45px;\n      margin-left: 5px;\n       }\n\n.btn-holder:disabled {\nbackground-color: #8db1ce;\n}\n\n.btn-holder {\n  margin-top: 10px;\n  background-color: #004c8a;\n  color: white;\n  border: none;\n  width: 120px ;\n  border-radius: 20px;\n  height: 25px;\n}\n.resendBtn{\ntext-align: center;\n  margin: 12px;\n  padding: 5px 18px;\n  color: white !important;\n  border: none;\n  border-radius: 20px;\n  display: block;\n  font-size: 13px !important;\n}\n.resendBtn:focus,.resendBtn:hover{\n  text-decoration: none !important;\n  color: white !important;\n}</style>");
$templateCache.put("app/components/modal/addNominee/addUpdateNominee.modal.html","<div class=\"modal-content add-update-modal-padding\" ng-init=Modal.folioDetailsData><div class=modal-header><h4 class=modal-title>Add/Update Nominee (For Units in Non-Demat Form)</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper ng-scope nominee-modal-body\"><div class=\"modal-heading-title nommineetitle\">Nominee Details <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip ng-if=Modal.showNomineeUpdate data-placement={{Main.tooltipClass}} title=\"SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n            states that, in case of Joint Account/Folio: <br>\n            1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n              Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n              inherit the assets as owners.<br>\n            2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n            3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder\"></i></div><p class=consent-text>I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</p><div class=nominee-main-content><form autocomplete=off name=updateNomineeForm class=modal-form-body><div class=\"form-content nomineeContent\" style=\"max-height: 400px; overflow-y: auto\"><table class=\"table table-nominee\"><thead class=nominee-main-title-contain><tr class=nominee-main-title><th>&nbsp;</th><th class=nominee-main-title>Name</th><th class=nominee-main-title>Proportion<span> (Should not be greater than 100%)</span></th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"nominee in Modal.folioData.nominees\"><td class=\"col-md-2 text-black nominee-name-label\">{{Modal.enum[$index]}} Nominee</td><td class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:updateNomineeForm[\'firstName-\'+$index].$dirty && updateNomineeForm[\'firstName-\'+$index].$invalid}\"><input type=text name=firstName-{{$index}} id=firstName-{{$index}} ng-pattern=/^[a-zA-Z\\s\\.]+$/ ng-model=nominee.firstName class=nominee-name-input ng-change=\"Modal.changeNomineeName($index, nominee.firstName)\" ng-maxlength=40 limit-to=40 maxlength=40 required autocomplete=off> <span class=req>*</span> <span class=highlight></span> <span class=bar></span> <span ng-show=\"updateNomineeForm[\'firstName-\'+$index].$dirty && updateNomineeForm[\'firstName-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'firstName-\'+$index].$error.required\" ng-bind=Modal.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=\"updateNomineeForm[\'firstName-\'+$index].$error.pattern\" ng-bind=Modal.validateData.NOMINEE_TEXT_ONLY></span></span></div></td><td class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:updateNomineeForm[\'proportion-\'+$index].$dirty && updateNomineeForm[\'proportion-\'+$index].$invalid}\"><input type=number ignore-mouse-wheel max=100 min=1 name=proportion-{{$index}} class=nominee-name-input ng-model=nominee.percentage ng-change=Modal.calculatePercentage() ng-max=\"Modal.nomineePropertion[\'max-\'+$index]\" ng-min=\"Modal.nomineePropertion[\'min-\'+$index]\" ng-keydown=Modal.checkDecimal($event) ng-paste=Modal.onPaste($event) required>% <span class=req>*</span><!--is-number--> <span class=highlight></span> <span class=bar></span><!--<label>Name<span ng-if=\"nomineeData.nomineeNameList\" class=\"req\">*</span></label>--> <span ng-show=\"updateNomineeForm[\'proportion-\'+$index].$dirty && updateNomineeForm[\'proportion-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeForm[\'proportion-\'+$index].$error.required\" ng-bind=Modal.validateData.NOMINEE_PROPORTION_REQUIRED></span> </span><span class=error-input ng-show=\"updateNomineeForm[\'proportion-\'+$index].$error.max\" ng-bind=Modal.validateData.NOMINEE_PROPORTION></span> <span class=error-input ng-if=\"nominee.percentage == 0\" ng-show=\"updateNomineeForm[\'proportion-\'+$index].$dirty\" ng-bind=Modal.validateData.PROPORTION_NOT_ZERO></span></div></td><td class=col-md-2 ng-if=\"Modal.folioData.nominees.length > 1 || Modal.isPrefillNomineeDataExist\"><i class=delete-icon ng-click=Modal.deleteNominee($index)></i></td></tr><tr><td></td><td class=\"col-md-12 proportion-warn\" id=warning-for-proportion colspan=2>{{Modal.percentage_msg}}</td></tr></tbody></table></div><div ng-disabled=true class=\"pull-right add-another-nominee-desktop\" role=button ng-if=\"Modal.showAddNominee && (Modal.folioData.nominees.length<Modal.maxNominee)\"><a href=javascript:void(0) ng-click=Modal.addNominee(); class=text-blue><strong>+ Add Another Nominee</strong></a></div></form><form autocomplete=off name=updateNomineeFormBottom id=updateNomineeFormBottom class=modal-form-body><div class=\"tab-container form-content\"><ul class=\"mobile-hide nav nav-tabs nominee-list-names\" ng-class=\"{\'update-width\': !(Modal.showAddNominee && (Modal.folioData.nominees.length<10))}\"><li role=button tabindex={{$index}} ng-repeat=\"nominee in Modal.folioData.nominees\" ng-click=\"Modal.setActiveTab($index,nominee.nomineePan, nominee.guardianPan, nominee.drivingLicense, nominee.aadharCard, nominee.passport)\" ng-class=\"{\'active\':Modal.activeTab === $index}\">{{Modal.enum[$index]}} Nominee Details</li></ul><div ng-disabled=true class=\"pull-right add-another-nominee\" role=button ng-if=\"Modal.showAddNominee && (Modal.folioData.nominees.length<Modal.maxNominee)\"><a href=javascript:void(0) ng-click=Modal.addNominee(); class=text-blue><strong>+ Add Another Nominee</strong></a></div></div><div class=add-nominee-details><div ng-repeat=\"nominee in Modal.folioData.nominees\" ng-show=\"Modal.activeTab===$index\"><div class=form-content><div class=mgb15></div><div class=minor-checkbox-wrapper><div class=\"checkbox opting-out\"><input type=checkbox ng-model=nominee.minor ng-click=Modal.changeNomineeIsMinor($index)> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee Is Minor</span></div></div><div class=row><div class=\"nominee-name-detail nominee-name-head\"><span ng-class=\"{\'empty\':nominee.firstName===\'\'}\" class=name ng-bind=nominee.firstName></span></div><div class=\"nominee-name-detail nominee-proportion\"><span ng-class=\"{\'empty\':nominee.firstName===\'\'}\" class=name ng-bind=nominee.percentage></span></div></div><div class=\"row nominee-form-upper-row\"><div class=col-md-4><div class=input-normal ng-if=nominee.minor><input type=text id=nomineeDOBId-{{$index}} date-calendar class=nominee-name-input date-default=nominee.dateOfBirth format=DD-MMM-YYYY showdefault=true viewmode=days maxdate=now data-min-date=Modal.dataMinDate1 data-max-date=Modal.dataMaxDate1 data-on-date-change=Modal.nomineeChangeDob name=dob-{{$index}} data-enable=true ng-bind=nominee.dateOfBirth ng-model=nominee.dateOfBirth autocomplete=off> <i class=\"calendar-icon calendar-nominee\"></i> <span class=highlight></span> <span class=bar></span><label ng-class=\"{doblabelnominee: nominee.dateOfBirth}\">DOB - DD/MMM/YYYY <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'dob-\'+$index].$dirty && updateNomineeFormBottom[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'dob-\'+$index].$error.required\" ng-bind=Modal.validateData.NOMINEE_DOB_REQUIRED></span></span></div><div class=input-normal ng-if=!nominee.minor><input type=text id=nomineeDOBId-{{$index}} date-calendar class=nominee-name-input date-default=nominee.dateOfBirth format=DD-MMM-YYYY showdefault=true viewmode=days maxdate=now data-min-date=Modal.dataMinDate data-max-date=Modal.dataMaxDate data-on-date-change=Modal.nomineeChangeDob name=dob-{{$index}} data-enable=true ng-bind=nominee.dateOfBirth ng-model=nominee.dateOfBirth autocomplete=off> <i class=\"calendar-icon calendar-nominee\"></i> <span class=highlight></span> <span class=bar></span><label ng-class=\"{doblabelnominee: nominee.dateOfBirth}\">DOB - DD/MMM/YYYY</label><span ng-show=\"updateNomineeFormBottom[\'dob-\'+$index].$dirty && updateNomineeFormBottom[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'dob-\'+$index].$error.required\" ng-bind=Modal.validateData.NOMINEE_DOB_REQUIRED></span></span></div></div><div class=col-md-4 style=\"margin-top: -10px\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:updateNomineeFormBottom[\'nomineeRelation-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeRelation-\'+$index].$invalid}\"><select name=relation-{{$index}} class=custom-select ng-model=nominee.relation ng-init=\"nominee.relation = nominee.relation ? nominee.relation : null\" ng-options=\"_type.value as _type.relationDesc for _type in Modal.relationList\" ng-change=Modal.changeRelationshipWithApplicant($index) required><option value=\"\" selected>Relationship with Applicant</option></select><label ng-if=nominee.relation style=\"display: block\" class=margin-top-label>Relationship with Applicant</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeFormBottom[\'relation-\'+$index].$dirty && updateNomineeFormBottom[\'relation-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'relation-\'+$index].$error.required\">{{Modal.validateData.NOMINEE_RELATIONSHIP}}</span></span></div></div><!--                <div class=\"col-md-4\" ng-if=\"Modal.showNomineeUpdate && nominee.relation === \'OTHERS\'\" style=\"clear: both\">--><!--                  <div class=\"input-normal\" ng-class=\"{error:updateNomineeFormBottom[\'otherRelation-\'+$index].$dirty && updateNomineeFormBottom[\'otherRelation-\'+$index].$invalid}\">--><!--                    <input type=\"text\" maxlength=\"50\" limit-to=\"50\"--><!--                           name=\"otherRelation-{{$index}}\" autocomplete=\"off\"--><!--                           ng-model=\"nominee.otherRelation\"--><!--                           ng-change=\"\"--><!--                           ng-required=\"nominee.relation\"--><!--                           ng-pattern=\"Modal.appConstants.valid_string_regex\"--><!--                           >--><!--                    <label>Others (Please Specify) <span class=\"req text-red\">*</span></label>--><!--                    <span ng-show=\"updateNomineeFormBottom[\'otherRelation-\'+$index].$dirty && updateNomineeFormBottom[\'otherRelation-\'+$index].$invalid\">--><!--                      <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'otherRelation-\'+$index].$error.required\">{{Modal.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER}}</span>--><!--                      <span class=\"error-input\"--><!--                            ng-show=\"updateNomineeFormBottom[\'otherRelation-\'+$index].$error.pattern\"--><!--                            ng-bind=\"Modal.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER_VALID\">--><!--                      </span>--><!--                    </span>--><!--                  </div>--><!--                </div>--><div class=col-md-4 ng-style=\"{clear: nominee.relation !== \'OTHERS\' ? \'both\' : \'none\'}\" ng-if=Modal.showNomineeUpdate><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'nomineeEmail-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeEmail-\'+$index].$invalid}\"><input type=text maxlength=254 ng-maxlength=254 limit-to=254 name=nomineeEmail-{{$index}} autocomplete=off ng-model=nominee.emailId ng-pattern=Modal.appConstants.email_regex ng-change=Modal.changeEmailId($index,nominee.emailId) required><label>Nominee Email ID<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'nomineeEmail-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeEmail-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineeEmail-\'+$index].$error.required\">{{Modal.validateData.EMAIL_REQUIRED}}</span> <span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineeEmail-\'+$index].$error.pattern\" ng-bind=Modal.validateData.EMAIL_FIELD></span> </span><span ng-show=\"updateNomineeFormBottom[\'nomineeEmail-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeEmail-\'+$index].$valid\"><span class=error-input ng-show=nominee.emailIdInvalid ng-bind=Modal.validateData.NOMINEE_EMAIL_SAME_AS_INVESTOR></span></span></div></div><div class=col-md-4 ng-style=\"{clear: nominee.relation == \'OTHERS\' ? \'both\' : \'none\'}\" ng-if=Modal.showNomineeUpdate><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$invalid}\"><input type=text name=nomineeMobileNo-{{$index}} autocomplete=off capitalize ng-model=nominee.mobileNumber ng-pattern=Modal.appConstants.mobile_regex_new minlength=1 maxlength=15 required><label>Nominee Mobile No.<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$error.required\">{{Modal.validateData.MOBILE_REQUIRED}}</span> <span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$error.pattern\" ng-bind=Modal.validateData.MOBILE_FIELD></span> </span><span ng-show=\"updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeMobileNo-\'+$index].$valid\"><span class=error-input ng-show=\"Modal.folioData && Modal.folioData.mobileNumber && (Modal.folioData.mobileNumber === nominee.mobileNumber)\" ng-bind=Modal.validateData.NOMINEE_MOBILE_SAME_AS_INVESTOR></span></span></div></div><div class=col-md-4 style=\"margin-top: -10px\" ng-style=\"{clear: nominee.relation !== \'OTHERS\' ? \'both\' : \'none\'}\" ng-if=Modal.showNomineeUpdate><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:updateNomineeFormBottom[\'identityProofType-\'+$index].$dirty && updateNomineeFormBottom[\'identityProofType-\'+$index].$invalid}\"><select name=identityProofType-{{$index}} class=custom-select ng-model=nominee.identityProofType ng-init=\"nominee.identityProofType = nominee.identityProofType ? nominee.identityProofType : null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in nominee.identityProofList\" ng-change=\"Modal.changeNomineeIdentityProof($index, nominee.relation)\" required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><label ng-if=nominee.identityProofType style=\"display: block\" class=margin-top-label>Select Personal Identifier of Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeFormBottom[\'identityProofType-\'+$index].$dirty && updateNomineeFormBottom[\'identityProofType-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'identityProofType-\'+$index].$error.required\">{{Modal.validateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><div class=col-md-4 ng-if=\"Modal.showNomineeUpdate && nominee.identityProofType === \'DRIVING_LICENSE\'\" ng-style=\"{clear: nominee.relation == \'OTHERS\' ? \'both\' : \'none\'}\"><div class=input-normal ng-class=\"{error: updateNomineeFormBottom[\'drivingLicense-\'+$index].$dirty && updateNomineeFormBottom[\'drivingLicense-\'+$index].$invalid}\"><input type=text ng-bind=nominee.drivingLicense ng-model=nominee.drivingLicense name=drivingLicense-{{$index}} ng-change=Modal.changeDrivingLicense($index,nominee.drivingLicense); maxlength=35 autocomplete=off required capitalize><label>Nominee Driving License No. <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'drivingLicense-\'+$index].$dirty && updateNomineeFormBottom[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'drivingLicense-\'+$index].$error.required || updateNomineeFormBottom[\'drivingLicense-\'+$index].$error.pattern\">{{Modal.validateData.VALID_DRIVING_LICENCE}} </span></span><span class=error-input ng-if=\"nominee.nomineeDLInvalid && nominee.drivingLicense\" ng-bind=Modal.errorMessageDLIdentity></span></div></div><div class=col-md-4 ng-if=\"Modal.showNomineeUpdate && nominee.identityProofType === \'AADHAR_CARD\'\" ng-style=\"{clear: nominee.relation == \'OTHERS\' ? \'both\' : \'none\'}\"><div class=input-normal ng-class=\"{error: updateNomineeFormBottom[\'aadharCard-\'+$index].$dirty && updateNomineeFormBottom[\'aadharCard-\'+$index].$invalid}\"><input type=text style=\"padding-left: 130px\" ng-bind=nominee.aadharCard ng-model=nominee.aadharCard name=aadharCard-{{$index}} maxlength=4 limit-to=4 ng-pattern=Modal.appConstants.valid_4_digit_aadhar_regex ng-change=Modal.changeAadharCard($index,nominee.aadharCard); autocomplete=off required capitalize><label>Nominee Aadhaar No.<span class=\"req text-red\">*</span></label><span class=arn style=\"top: 14px\">XXXX XXXX </span><span ng-show=\"updateNomineeFormBottom[\'aadharCard-\'+$index].$dirty && updateNomineeFormBottom[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'aadharCard-\'+$index].$error.pattern || updateNomineeFormBottom[\'aadharCard-\'+$index].$error.required\">{{Modal.validateData.AADHAAR_INVALID}} </span></span><span class=error-input ng-if=\"nominee.nomineeAadharInvalid && nominee.aadharCard\" ng-bind=Modal.errorMessageDLIdentity></span></div></div><div class=col-md-4 ng-if=\"(Modal.showNomineeUpdate && nominee.identityProofType === \'PAN_CARD\') || !Modal.showNomineeUpdate\" ng-style=\"{clear: nominee.relation == \'OTHERS\' || !Modal.showNomineeUpdate ? \'both\' : \'none\'}\"><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'nomineePan-\'+$index].$dirty && updateNomineeFormBottom[\'nomineePan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=nomineePan-{{$index}} autocomplete=off capitalize ng-model=nominee.nomineePan ng-required=Modal.showNomineeUpdate ng-change=\"Modal.checkPanValidation($index,nominee.nomineePan, nominee.guardianPan); Modal.buttonHandler()\" ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ><label ng-if=!Modal.showNomineeUpdate>PAN Of Nominee</label><label ng-if=Modal.showNomineeUpdate>Nominee PAN <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'nomineePan-\'+$index].$dirty && updateNomineeFormBottom[\'nomineePan-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineePan-\'+$index].$error.pattern\" ng-bind=Modal.validateData.INVALID_PAN></span> <span class=error-input ng-show=\"updateNomineeFormBottom[\'nomineePan-\'+$index].$error.required\">{{Modal.validateData.NOMINEE_PAN_REQUIRED}} </span></span><span class=error-input ng-if=\"nominee.nomineePanInvalid && nominee.nomineePan\" ng-bind=Modal.errorMessage></span></div></div><div class=col-md-4 ng-if=\"Modal.showNomineeUpdate && nominee.identityProofType === \'PASSPORT\'\" ng-style=\"{clear: nominee.relation == \'OTHERS\' ? \'both\' : \'none\'}\"><div class=input-normal ng-class=\"{error: updateNomineeFormBottom[\'passport-\'+$index].$dirty && updateNomineeFormBottom[\'passport-\'+$index].$invalid}\"><input type=text ng-bind=nominee.passport ng-model=nominee.passport name=passport-{{$index}} ng-change=Modal.changePassport($index,nominee.passport); maxlength=35 autocomplete=off required capitalize><label>Nominee Passport <span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'passport-\'+$index].$dirty && updateNomineeFormBottom[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'passport-\'+$index].$error.required\">{{Modal.validateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-if=\"nominee.nomineePassportInvalid && nominee.passport\" ng-bind=Modal.errorMessagePassportIdentity></span></div></div></div><!--              <div class=\"row\">--><!--                <div class=\"col-md-4\">--><!--                  <div class=\"input-normal\" ng-class=\"{error:updateNomineeFormBottom[\'nomineePan-\'+$index].$dirty && updateNomineeFormBottom[\'nomineePan-\'+$index].$invalid}\">--><!--                    <input type=\"text\" maxlength=\"10\" ng-maxlength=\"10\" limit-to=\"10\"--><!--                           name=\"nomineePan-{{$index}}\" autocomplete=\"off\" capitalize--><!--                           ng-model=\"nominee.nomineePan\"--><!--                           ng-change=\"Modal.checkPanValidation($index,nominee.nomineePan, nominee.guardianPan); Modal.buttonHandler()\"--><!--                           ng-pattern=\"/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/\">--><!--                    <label>PAN Of Nominee </label>--><!--                    <span--><!--                      ng-show=\"updateNomineeFormBottom[\'nomineePan-\'+$index].$dirty && updateNomineeFormBottom[\'nomineePan-\'+$index].$invalid\">--><!--                        <span class=\"error-input\"--><!--                              ng-bind=\"Modal.validateData.INVALID_PAN\">--><!--                        </span>--><!--                    </span>--><!--                    <span class=\"error-input\"--><!--                          ng-if=\"nominee.nomineePanInvalid && nominee.nomineePan\"--><!--                          ng-bind=\"Modal.errorMessage\">--><!--                    </span>--><!--                  </div>--><!--                </div>--><!--              </div>--></div><!-- Guardian Details UI Added --><div ng-if=nominee.minor><div class=\"row mgt20\"><div class=col-md-4><p><strong>Guardian Detail\'s</strong></p><div class=\"input-normal m-top-head\" ng-class=\"{error:updateNomineeFormBottom[\'guardian-\'+$index].$dirty && updateNomineeFormBottom[\'guardian-\'+$index].$invalid}\"><input type=text ng-model=nominee.guardian ng-bind=nominee.guardian name=guardian-{{$index}} ng-pattern=/^[a-zA-Z\\s\\.]+$/ ng-maxlength=40 limit-to=40 ng-change=Modal.changeGuardianName() maxlength=40 ng-init=\"nominee.guardian = nominee.guardian ? nominee.guardian : null\" capitalize required> <span class=highlight></span> <span class=bar></span><label>Guardian Name<span class=\"req text-red\">*</span></label><span ng-show=\"updateNomineeFormBottom[\'guardian-\'+$index].$dirty && updateNomineeFormBottom[\'guardian-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'guardian-\'+$index].$error.required\">{{Modal.validateData.GUARDIAN_NAME}}</span> <span class=error-input ng-show=\"updateNomineeFormBottom[\'guardian-\'+$index].$error.pattern\" ng-bind=Modal.validateData.GUARDIAN_TEXT_ONLY></span></span></div></div><div class=col-md-4 style=\"padding-top: 14px\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:updateNomineeFormBottom[\'nomineeRelation-\'+$index].$dirty && updateNomineeFormBottom[\'nomineeRelation-\'+$index].$invalid}\"><select name=guardianRelation-{{$index}} class=custom-select ng-model=nominee.guardianRelation ng-init=\"nominee.guardianRelation = nominee.guardianRelation ? nominee.guardianRelation : null\" ng-options=\"_type.value as _type.relationDesc for _type in Modal.guardianRelationList\" required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><label ng-if=nominee.guardianRelation style=\"display: block\" class=margin-top-label>Guardian\'s Relationship with Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"updateNomineeFormBottom[\'guardianRelation-\'+$index].$dirty && updateNomineeFormBottom[\'guardianRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'guardianRelation-\'+$index].$error.required\">{{Modal.validateData.NOMINEE_RELATIONSHIP}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'guardianPan-\'+$index].$dirty && updateNomineeFormBottom[\'guardianPan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=guardianPan-{{$index}} autocomplete=off capitalize ng-model=nominee.guardianPan ng-init=\"nominee.guardianPan = nominee.guardianPan ? nominee.guardianPan : null\" ng-change=\"Modal.checkUniqueGuardianPan($index, nominee.guardianPan, true)\" ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ><label>PAN Of Guardian</label><span ng-show=\"updateNomineeFormBottom[\'guardianPan-\'+$index].$dirty && updateNomineeFormBottom[\'guardianPan-\'+$index].$invalid\"><span class=error-input ng-bind=Modal.validateData.INVALID_PAN></span> </span><span class=error-input ng-if=\"(nominee.guardianPanInvalid || !nominee.verifyPan ) && nominee.guardianPan\" ng-bind=Modal.errorMessageForGuardianField></span></div></div></div></div><!-- Guardian Details Ui Ended --><p><strong>Address Details of Nominee</strong></p><div><div class=\"row m-top-head\"><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'addressLine1-\'+$index].$dirty && updateNomineeFormBottom[\'addressLine1-\'+$index].$invalid}\"><input type=text ng-model=nominee.nomineeAddress1 ng-bind=nominee.nomineeAddress1 name=addressLine1-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 capitalize ng-required=Modal.showNomineeUpdate><label>Address Line 1 <span class=\"req text-red\" ng-if=Modal.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeFormBottom[\'addressLine1-\'+$index].$dirty && updateNomineeFormBottom[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'addressLine1-\'+$index].$error.required\">{{Modal.validateData.ADDRESS1_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'addressLine2-\'+$index].$dirty && updateNomineeFormBottom[\'addressLine2-\'+$index].$invalid}\"><input type=text ng-model=nominee.nomineeAddress2 ng-bind=nominee.nomineeAddress2 name=addressLine2-{{$index}} ng-maxlength=60 limit-to=60 maxlength=60 capitalize><label>Address Line 2</label><!--                    <span ng-show=\"updateNomineeFormBottom[\'addressLine2-\'+$index].$dirty && updateNomineeFormBottom[\'addressLine2-\'+$index].$invalid\">--><!--                  <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'addressLine2-\'+$index].$error.required\">--><!--                    {{Modal.validateData.ADDRESS2_REQUIRED}}--><!--                  </span>--><!--                </span>--></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:updateNomineeFormBottom[\'country-\'+$index].$dirty && updateNomineeFormBottom[\'country-\'+$index].$invalid}\"><select name=country-{{$index}} ng-init=\"nominee.countryCode = nominee.countryCode ? nominee.countryCode : null\" ng-model=nominee.countryCode class=\"browser-default custom-select\" ng-options=\"_country.countryCode as _country.countryName for _country in Modal.countryList\" ng-change=Modal.changeSelectedCountry($index,nominee.countryCode) ng-required=Modal.showNomineeUpdate><option value=\"\" selected>Name of country</option></select><label ng-if=nominee.countryCode style=\"display: block\" class=margin-top-label>Name of country</label><span class=\"req text-red\" ng-if=Modal.showNomineeUpdate>*</span> <span ng-show=\"updateNomineeFormBottom[\'country-\'+$index].$dirty && updateNomineeFormBottom[\'country-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'country-\'+$index].$error.required\">{{Modal.validateData.SELECT_COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:updateNomineeFormBottom[\'state-\'+$index].$dirty && updateNomineeFormBottom[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-model=nominee.stateCode ng-options=\"_state.stateCode as _state.stateName for _state in Modal.stateList\" ng-change=Modal.changeState($index,nominee.stateCode) ng-disabled=\"nominee.countryCode != \'IN\'\" class=custom-select ng-required=Modal.showNomineeUpdate><option value=\"\" selected>Select State</option></select><label ng-if=nominee.stateCode style=\"display: block\" class=margin-top-label>STATE</label><span class=\"req text-red\" ng-if=Modal.showNomineeUpdate>*</span> <span ng-show=\"updateNomineeFormBottom[\'state-\'+$index].$dirty && updateNomineeFormBottom[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'state-\'+$index].$error.required\">{{Modal.validateData.STATE_REQUIRED}}</span></span></div></div></div><div class=row><div class=col-md-4 style=\"margin-top: 2px\"><div class=\"input-normal citynomineeinput\" ng-class=\"{error:updateNomineeFormBottom[\'city-\'+$index].$dirty && updateNomineeFormBottom[\'city-\'+$index].$invalid}\"><input type=text name=city-{{$index}} ng-bind=nominee.city ng-model=nominee.city ng-maxlength=35 limit-to=35 maxlength=35 only-alphabets capitalize ng-required=Modal.showNomineeUpdate><label>City <span class=\"req text-red\" ng-if=Modal.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeFormBottom[\'city-\'+$index].$dirty && updateNomineeFormBottom[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'city-\'+$index].$error.required\">{{Modal.validateData.CITY}}</span></span></div></div><div class=\"col-md-4 mgt9\"><div class=input-normal ng-class=\"{error:updateNomineeFormBottom[\'pinCode-\'+$index].$dirty && updateNomineeFormBottom[\'pinCode-\'+$index].$invalid}\"><input type=text ng-model=nominee.postalCode name=pinCode-{{$index}} is-number ng-maxlength=6 limit-to=6 minlength=6 maxlength=6 ng-required=Modal.showNomineeUpdate> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code <span class=\"req text-red\" ng-if=Modal.showNomineeUpdate>*</span></label><span ng-show=\"updateNomineeFormBottom[\'pinCode-\'+$index].$dirty && updateNomineeFormBottom[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"updateNomineeFormBottom[\'pinCode-\'+$index].$error.required\">{{Modal.validateData.PINCODE_REQUIRED}}</span></span></div></div></div></div></div><!-- Statement Declaration sections --><div class=statement-declaration ng-if=Modal.showNomineeUpdate><p class=section-title>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p><div class=declaration-content><div class=row><div class=col-md-12><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div><div class=\"radio-block flex-radio\"><div class=row style=\"margin-bottom: 10px\"><div class=col-md-4><span class=radio style=\"bottom: 0px\"><input type=radio ng-model=Modal.folioData.nomination ng-change=Modal.setStatement() name=nomineeName id=nomineeName autocomplete=off ng-value=true> <span class=check></span></span><label>Nomination: Yes</label></div></div><div class=row><div class=col-md-4><span class=radio style=\"bottom: 0px\"><input type=radio ng-model=Modal.folioData.nomination ng-change=Modal.setStatement() name=nomination id=nomination autocomplete=off ng-value=false> <span class=check></span></span><label>Nomination: No</label></div></div></div></div></div></div><!--<div class=\"statement-declaration\" ng-if=\"Modal.showNomineeUpdate && Modal.folioData.holdingStatus === \'SINGLE\'\">\n            <p class=\"section-title\">Incapacitation Declaration (Optional)\n              <i class=\"tooltip-info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"\n                 data-placement=\"{{Main.tooltipClass}}\"\n                 title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n              </i>\n            </p>\n            <div class=\"declaration-content\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <span>I hereby authorize\n                      <select class=\"browser-default custom-select\" name=\"selectNomineeName\" easyassist-key=\"mask-element\"\n                              ng-model=\"Modal.incapacitationDeclarationNameList\"\n                              ng-init=\"Modal.incapacitationDeclarationNameList=Modal.incapacitationDeclarationNameList? Modal.incapacitationDeclarationNameList:null\"\n                              ng-options=\"nomineeList as nomineeList.nomineeCode disable when (nomineeList.activeFlag) for nomineeList in Modal.incapacitationNameList track by nomineeList.nomineeCode\"\n                              ng-change = \"Modal.changeSelectedName(Modal.incapacitationDeclarationNameList)\"\n                              ng-disabled=\"!Modal.hasNomineeName()\"\n                      >\n                        <option value=\"\" selected>Select Nominee Name</option>\n                      </select>{{nominee.minor}}\n                      (nominee number <input type=\"text\" ng-model=\"Modal.folioData.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number readonly/>)\n                      to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                      <input type=\"text\" ng-model=\"Modal.folioData.incapacitationDeclaration.percentage\" name=\"percentage\" is-number maxlength=\"3\"\n                             ng-required=\"Modal.incapacitationDeclarationNameList && !Modal.folioData.incapacitationDeclaration.amount\" ng-pattern=\"/^(100|[1-9]?[0-9])$/\"\n                             ng-disabled=\"Modal.folioData.incapacitationDeclaration.amount || !Modal.incapacitationDeclarationNameList\"\n                             ng-change=\"Modal.changePercentageOrAmount(\'percentage\')\"\n                      >\n                      % of assets in the account / folio or Rs.\n                      <input type=\"text\" ng-model=\"Modal.folioData.incapacitationDeclaration.amount\" name=\"allowedAmount\" ng-pattern=\"/^[1-9]\\d*$/\"\n                             is-number maxlength=\"20\" ng-disabled = \"Modal.folioData.incapacitationDeclaration.percentage || !Modal.incapacitationDeclarationNameList\"\n                             ng-change=\"Modal.changePercentageOrAmount(\'amount\')\"\n                             ng-required=\"Modal.incapacitationDeclarationNameList && !Modal.folioData.incapacitationDeclaration.percentage\"\n                      >.\n                    </span>\n                  <span ng-show=\"updateNomineeFormBottom[\'percentage\'].$dirty && updateNomineeFormBottom[\'percentage\'].$invalid || (updateNomineeFormBottom[\'allowedAmount\'].$dirty && updateNomineeFormBottom[\'allowedAmount\'].$invalid)\">\n                      <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'allowedAmount\'].$error.pattern\">\n                        Amount/percentage cannot be less than 1.\n                      </span>\n                      <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'percentage\'].$error.pattern && Modal.folioData.incapacitationDeclaration.percentage < 1\">\n                        Amount/percentage cannot be less than 1.\n                      </span>\n                      <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'percentage\'].$error.pattern && Modal.folioData.incapacitationDeclaration.percentage > 100\">\n                        Percentage cannot be more than 100%.\n                      </span>\n                    </span>\n                  <span ng-show=\"(updateNomineeFormBottom[\'percentage\'].$dirty && updateNomineeFormBottom[\'percentage\'].$invalid) || (updateNomineeFormBottom[\'allowedAmount\'].$dirty && updateNomineeFormBottom[\'allowedAmount\'].$invalid)\">\n                      <span class=\"error-input\" ng-show=\"updateNomineeFormBottom[\'percentage\'].$error.required || updateNomineeFormBottom[\'allowedAmount\'].$error.required\">\n                        Please enter the percentage or Rs. that can be encashed by the nominee.\n                      </span>\n                    </span>\n                </div>\n              </div>\n            </div>\n          </div>--></div></form></div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.nomineeUpdate() ng-disabled=\"updateNomineeForm.$invalid || updateNomineeFormBottom.$invalid  || Modal.buttonHandler() || Modal.totalPercentage != \'100\' || Modal.percentage_msg != \'\' || Modal.isPercentageValid || Modal.validateAllDOB || Modal.nomineeAadharInvalid || Modal.nomineeDLInvalid || !Modal.emailIdValid\">Send For Approval</button><!--      ng-disabled=\"updateNomineeForm.$invalid || Modal.totalPercentage != \'100\' || Modal.percentage_msg!= \'\'\" || updateNomineeFormBottom.$invalid--></div></div></div>");
$templateCache.put("app/components/modal/agentChangePasswordSuccess/agent-changePasswordSuccess.modal.html","<!-- Sign up Completed--><div class=modal-content id=initiateTransactionMsg><div class=modal-body><i class=success-icon></i><h6>Password Changed Successfully</h6><p>{{Modal.modalData.Text}}</p><br><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/agentCreateUserSuccess/agent-createUser.modal.html","<!-- Sign up Completed--><div class=modal-content id=initiateTransactionMsg><div class=modal-body><i class=success-icon></i><h6>Created Successfully</h6><p>{{Modal.modalData.Text}}</p><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/agentCreateUserSuccess/agent-message.modal.html","<!-- Sign up Completed--><div class=modal-content id=initiateTransactionMsg><div class=modal-body><i class=success-icon></i><p>{{Modal.modalData.text}}</p><div ng-if=!Modal.modalData.saveEnable><button ng-click=Modal.dismissModal() class=\"btn btn-primary-action\">Exit</button></div><div ng-if=Modal.modalData.saveEnable><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Save & Exit</button> <button ng-click=Modal.dismissModal() class=\"btn btn-primary-action\">Exit</button></div></div></div>");
$templateCache.put("app/components/modal/agentDraft/agent-draft.modal.html","<div class=modal-content id=transSum><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Drafted Transaction Details</h4></div><div class=modal-body><table class=\"table borderless\"><tr><td>Transaction Type:</td><td ng-bind=Modal.modalData.transactionType></td></tr><tr><td>Folio Number:</td><td ng-bind=Modal.modalData.folioNumber></td></tr><tr><td>{{Modal.modalData.transactionType==\'PURCHASE\'?\'Scheme\':\'Source Scheme\'}}:</td><td ng-bind=Modal.modalData.sourceSchemeName></td></tr><tr ng-if=Modal.modalData.targetSchemeName><td>Target Scheme:</td><td ng-bind=Modal.modalData.targetSchemeName></td></tr><tr><td></td><td></td></tr><tr><td align=center colspan=2><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Continue</button> <button ng-click=Modal.dismissModal() class=\"btn btn-primary-action\">Discard</button></td></tr></table></div></div>");
$templateCache.put("app/components/modal/agentRegistrationSuccess/agent-registration.modal.html","<!-- Sign up Completed--><div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><i class=success-icon></i><h6>Created Successfully</h6><p>You have successfully added Naeem Sonu as an Agent.</p><button type=submit ng-click=Modal.continue() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/alertAndUpdateInfo/alertAndUpdateInfo.modal.html","<div class=\"modal-content alert-update-modal-container\"><div class=modal-body><div class=cross-icon-right><img src=../../../../assets/images/icons/close-icon.png alt=cross-icon ng-click=Modal.closeModal()></div><div class=image-wrapper ng-if=Modal.modalData.image><img ng-src={{Modal.modalData.image}} alt=back-img></div><div class=title-wrapper><div class=title>{{ Modal.modalData.title }}</div></div><div class=date ng-if=\"Modal.modalData.date && Modal.modalData.title !== \'Modify SIP\' && Modal.modalData.title !== \'Update Nomination\'\">as on {{Modal.modalData.date}}</div><div class=content ng-bind-html=Modal.modalData.content></div></div></div>");
$templateCache.put("app/components/modal/bankDetails/bank-payment-makepayment.modal.html","<div class=modal-content id=makePayment ng-init=Modal.init()><div class=modal-header><h4 class=modal-title>Make Payment</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div><table class=\"table borderless\"><tr><td>Scheme Name:</td><td>{{Modal.modalData.schemeName}}</td></tr><tr><td>Investment Type:</td><td>{{Modal.modalData.summaryType}}</td></tr><tr><td>Investment Amount:</td><td>{{Modal.modalData.amount}}</td></tr><tr><td>Investment Start Date:</td><td>{{Modal.modalData.startDate}}</td></tr></table></div><hr><form autocomplete=off action=\"\" role=\"\" method=\"\" autocomplete=off name=Modal.bankPaymentForm><p><strong>Select bank for making Payment</strong></p><div class=row><div class=col-md-12><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-model=Modal.bankdata><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in Modal.bankList\" value={{bank}}>{{bank.bankName}}</option></select></div></div></div></form></div><form autocomplete=off name=billdeskPayForm autocomplete=off id=billdeskPayForm method=POST action=https://www.billdesk.com/pgidsk/PGIMerchantRequestHandler><input type=hidden name=msg ng-value=Modal.billDeskpayload id=msg> <input id=hidRequestId type=hidden name=hidRequestId value=PGIME1000> <input id=hidOperation type=hidden name=hidOperation value=ME100></form><div class=modal-footer><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-primary-action\" ng-click=Modal.makePayment()>Continue to Pay</span></div></div></div></div>");
$templateCache.put("app/components/modal/bankDetails/bank-payment-summery.modal.html","<div class=modal-content id=paymentSummary><div class=modal-header><h4 class=modal-title>Payment Summary</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p>Thankyou for making Payment. The details are as follows :</p><table class=\"table borderless\"><tr><td>Bill No. :</td><td>12345</td></tr><tr><td>Name of Bank :</td><td>ICICI Bank</td></tr><tr><td>Scheme Name :</td><td>HDFC Tax Saver Fund</td></tr><tr><td>Investment Type :</td><td>Lumpsum</td></tr><tr><td>Investment Amount :</td><td>50,000</td></tr><tr><td>Investment Start Date :</td><td>24/12/2016</td></tr></table></div><div class=modal-footer><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-primary-action\" ng-click=Modal.paymentSummery()>Ok</span></div></div></div></div>");
$templateCache.put("app/components/modal/bankDetails/preceedtologin.modal.html","<div class=modal-content><div class=modal-body><i class=times-icon ng-click=Modal.dismissModal();></i><p class=\"info text-center\">Thanks for verifying your account with OTP.<br>An email has been sent to your registered email ID with temporary password.</p><form autocomplete=off autocomplete=off><button ui-sref=login class=\"btn btn-primary-action btn-block\">Proceed to Login</button></form></div></div>");
$templateCache.put("app/components/modal/bankDetails/success.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper\"><i class=times-icon ng-click=Modal.dismissModal();></i><h3 class=submit-success><i class=success-icon></i><p>Submission Successful</p></h3><p class=submit-success-notify>Thank you for showing interest in HDFC Mutual Fund.<br>You will be notified about your empanelment status on your KYD registered Email and Mobile no.</p><button type=button ng-click=Modal.dismissModal(); class=\"btn btn-primary-action btn-center mg40\">Ok</button></div></div>");
$templateCache.put("app/components/modal/cancelNominee/cancelNominee.modal.html","<div class=modal-content id=transSum><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><div class=text-left>Are you sure, you want to cancel nomination for the folio {{Modal.modalData.folio}}?</div><div class=cancelModalText><span class=cancelModalNote>Note:</span> By cancelling nomination for the folio, there would not be any transfer of units to nominee in case of death of unit holder</div><div class=button-modal-section><div class=\"text-center dispin\"><button class=\"btn btn-primary-action cancelNomineeButton\" ng-click=Modal.cancelNominee()>Send For Approval</button></div><div class=\"text-center dispin\"><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Cancel</button></div></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel-ecart.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation ecart-remove-modal\"><div class=text-center><p ng-bind-html=Modal.data.text style=\"font-size: 14px !important\"></p></div><br><br><div class=text-center><button class=\"btn-ecart btn-primary-action\" ng-click=Modal.closeModal()>Yes</button> <button class=\"btn-ecart btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>No</button></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel-systematic.modal.html","<div class=modal-content><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=sip-cancel-header ng-if=Modal.data.sipCancel><p>Hi {{Modal.data.distributorName}},</p><p>{{Modal.modifyPopupHeaderMessage}}</p></div><div class=cancel-systematic-section ng-class=\"{\'set-height_auto\' : !Modal.buttonPause || !Modal.buttonModify}\"><!--systematic modify container--><div class=\"cancel-systematic-content modify-section-padding\" ng-class=\"{\'set-full-width\' : !Modal.buttonPause}\" ng-if=Modal.buttonModify><p>{{Modal.modalData.SYSTEMATIC_NUDGE_MODIFY.content}}</p><button ng-if=\"Modal.buttonPause && Modal.buttonModify\" style=\"align-self: center\" class=\"btn btn-primary-action set-margin-btn btn-mobile-padding\" ng-click=Modal.modifySip()>Modify SIP</button><div ng-if=\"!Modal.buttonPause && Modal.buttonModify\" class=btn-single-section><button class=\"btn btn-primary-action set-margin-btn btn-padding-single-section\" ng-click=Modal.modifySip()>Modify SIP</button> <button class=\"btn btn-secondary-action set-margin-btn\" ng-click=Modal.cancelSip() ng-if=Modal.buttonProceed autofocus>Proceed with cancellation</button></div></div><!--horizontal line--><div class=seperator ng-if=\"Modal.buttonPause && Modal.buttonModify\"></div><!--systematic pause container--><div class=cancel-systematic-content ng-if=\"Modal.buttonPause && !Modal.data.otherFlow\"><p>{{Modal.modalData.SYSTEMATIC_NUDGE_PAUSE.content}}</p><button ng-if=\"Modal.buttonPause && Modal.buttonModify\" style=\"align-self: center\" class=\"btn btn-primary-action set-margin-btn btn-mobile-padding\" ng-click=Modal.redirectToPause()>Pause SIP</button><div ng-if=\"Modal.buttonPause && !Modal.buttonModify\" class=btn-single-section><button style=\"align-self: center\" class=\"btn btn-primary-action set-margin-btn btn-padding-single-section\" ng-click=Modal.redirectToPause()>Pause SIP</button> <button class=\"btn btn-secondary-action set-margin-btn\" ng-click=Modal.cancelSip() ng-if=Modal.buttonProceed autofocus>Proceed with cancellation</button></div></div><!--systematic pause container other flow--><div class=\"cancel-systematic-content cancel-systematic-content-others\" ng-if=\"Modal.buttonPause && Modal.data.otherFlow && Modal.data.tncType ===\'DREAMSIP\'\"><p>{{Modal.modalData.SYSTEMATIC_NUDGE_PAUSE_DREAMSIP.content}}</p><div ng-if=\"Modal.buttonPause && !Modal.buttonModify\" class=btn-single-section><button style=\"align-self: center;padding: 8px 70px !important\" class=\"btn btn-primary-action set-margin-btn btn-padding-single-section\" ng-click=Modal.redirectToPause()>Pause DREAM SIP</button> <button class=\"btn btn-secondary-action set-margin-btn\" style=\"padding: 8px 70px !important\" ng-click=Modal.cancelSip() ng-if=Modal.buttonProceed autofocus>Proceed with cancellation</button></div></div></div><!--systematic cancel container--><div class=text-center ng-if=\"Modal.buttonPause && Modal.buttonModify\"><button class=\"btn btn-secondary-action set-margin-btn\" ng-click=Modal.cancelSip() ng-if=Modal.buttonProceed autofocus>Proceed with cancellation</button></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/confirm-cancel.modal.html","<div class=modal-content><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center ng-if=!Modal.modalData.Text>{{ Modal.modalData }}</div><div class=text-center ng-if=Modal.modalData.Text>{{ Modal.modalData.Text }}</div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal() ng-if=!Modal.buttonProceed ng-disabled=\"(Modal.formData.folioCreationRequestCO.addNomineeLater && Modal.forFolioCreation) || Modal.isOptOut\">Yes</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal() ng-if=!Modal.buttonCancel ng-disabled=\"(Modal.formData.folioCreationRequestCO.addNomineeLater && Modal.forFolioCreation)\" ng-show=\"!Modal.modalData.buttonText || (Modal.modalData.fromFolioCreation && Modal.formData.folioCreationRequestCO.addNomineeLater && Modal.buttonCancel)\">No</button> <button class=\"btn btn-secondary-action\" autofocus ng-show=\"Modal.modalData.Text && Modal.modalData.buttonText && !Modal.buttonCancel\" ng-click=Modal.displayOptOutMsg() ng-if=!Modal.buttonCancel ng-disabled=\"Modal.formData.folioCreationRequestCO.addNomineeLater || Modal.isOptOut\">No</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal() ng-if=Modal.buttonProceed>Proceed</button> <button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal() ng-if=Modal.buttonCancel>Cancel</button></div><div ng-if=Modal.modalData.fromFolioCreation><div class=old-folio-creation><div class=checkbox><input type=checkbox ng-if=Modal.formData.folioCreationRequestCO.addNomineeLater ng-model=Modal.formData.folioCreationRequestCO.addNomineeLater name=isOptOut> <input type=checkbox ng-if=!Modal.formData.folioCreationRequestCO.addNomineeLater ng-model=Modal.isOptOut name=isOptOut> <span class=icon-checkbox></span> <span class=checkbox-text>I hereby declare to opting out of nomination</span></div></div><div ng-if=\"Modal.formData.folioCreationRequestCO.addNomineeLater || Modal.isOptOut\" class=\"point-to-note text-left note-on-mobile\"><ng-bind-html dynamic=Modal.isOptOutDec></ng-bind-html></div><div class=\"text-center mt-20\"><button class=\"btn btn-primary-action\" ng-click=\"Modal.dismissModal(\'ok\')\" ng-if=\"(Modal.modalData.buttonText && Modal.formData.folioCreationRequestCO.addNomineeLater) || Modal.isOptOut\">{{Modal.modalData.buttonText}}</button></div></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/confirm-success.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>{{ Modal.modalData }}</div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Ok</button></div></div></div>");
$templateCache.put("app/components/modal/confirmCancel/cut-off.modal.html","<!--dynamic data cutoff--><ng-bind-html dynamic=Modal.cutOffDynamicData.content></ng-bind-html>");
$templateCache.put("app/components/modal/confirmCancel/purchaseLiquid.modal.html","<!-- Scheme List--><div class=modal-content id=disclaimerModal><div class=\"loader popup\"><span class=loading></span></div><h5 class=text-center>Important Information</h5><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body><div>Change in uniform cut-off timing for applicability of NAV for Liquid Schemes / Plans. Please <u class=\"cursor-pointer text-blue\" ng-click=Modal.openLink()>Click here </u>to view Addendum.</div><div class=imp-info><p><i class=dot></i> <span>Please note that the Net Asset Value (NAV) applicability depends on <strong><u>the entire amount of subscription / purchase as per the application is credited to the bank account of the respective Liquid Schemes / Plans before the cutoff time i.e. available for utilization before the cut-off time.</u></strong></span></p><p><i class=dot></i> <span>There could be a time lag between the amount of subscription being debited to your bank account and the subsequent credit into the respective schemes bank account. HDFC Asset Management Company Limited or its bankers or its service providers will not be liable for the delay and consequent pricing of units.</span></p></div><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--> <button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/confirmCancel/transactSipOrPurchase.modal.html","<div class=\"modal-content transactSipOrPurchase-modal\"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>{{ Modal.modalData }}</div><br><br><div class=btn-wrapper><button class=\"btn btn-new-primary-action\" ng-click=\"Modal.getTransactionType(\'purchase\')\">Purchase</button> <button class=\"btn btn-new-primary-action\" ng-click=\"Modal.getTransactionType(\'sip\')\">SIP</button></div></div></div>");
$templateCache.put("app/components/modal/cutOffLogin/cut-off-login.modal.html","<!--dynamic data cutoff--><ng-bind-html dynamic=Modal.DynamicDataFirstLogin.content></ng-bind-html>");
$templateCache.put("app/components/modal/distributorEmpanellment/EmpanellmentSuccess.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper\"><i class=times-icon ng-click=Modal.dismissModal();></i><h3 class=submit-success><i class=success-icon></i><p>Submission Successful</p></h3><p class=submit-success-notify>Thank you for showing interest in HDFC Mutual Fund.<br>You will be notified about your empanelment status on your KYD registered Email and Mobile no.</p><button type=button ng-click=Modal.dismissModal(); class=\"btn btn-primary-action btn-center mg40\" ui-sref=home>Ok</button></div></div>");
$templateCache.put("app/components/modal/distributorEmpanellment/EmpanellmentTAndC.modal.html","<div ng-if=!Modal.showTermNConditions class=\"modal-content empanelment-modal\" ng-init=Modal.init()><div class=modal-header><h4 class=modal-title>Confirmation</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><p class=declare-state><strong>I hereby declare and confirm</strong></p><form autocomplete=off action=\"\" autocomplete=off><ul><li ng-repeat=\"data in Modal.modalData\"><span class=checkbox><input type=checkbox ng-model=data.selected ng-value=data.key ng-change=Modal.changedSelection()> <span class=icon-checkbox></span> <span class=checkbox-text>{{data.value}}</span></span></li></ul><div class=mandatory-tnc><p class=mandate-head>Mandatory Declarations<span class=req>*</span></p><ul><li><span class=checkbox><input type=checkbox ng-model=Modal.declerationTextAgreementModel ng-value=Modal.declerationTextAgreement.key> <span class=icon-checkbox></span> <span class=checkbox-text>{{ Modal.declerationTextAgreement.value }}</span></span></li><li class=empanelment-confirmation-tnc><span class=checkbox><input type=checkbox ng-model=Modal.declerationTextTnCModel ng-value=Modal.declerationTextTnC.key> <span class=icon-checkbox></span> <span class=checkbox-text>{{ Modal.declerationTextTnC.value }} <a href=javascript:void(0) ng-click=Modal.termsAndConditions()>Terms and Conditions.</a></span></span></li></ul></div><div class=\"text-center error-empanelment\" ng-show=\"!Modal.declerationTextAgreementModel && Modal.declerationTextTnCModel\"><p>You cannot proceed for Empanellment, Thank you for your interest.<br>Please get in touch with your nearest branch for empanellment or update your KYD bank details.</p></div><button type=button ng-show=\"(!Modal.declerationTextAgreementModel && !Modal.declerationTextTnCModel )\" class=\"btn btn-primary-action btn-success mg40\" ng-click=Modal.declerationConfirm() ng-disabled=true>Confirm Now</button> <button type=button ng-show=Modal.declerationTextAgreementModel class=\"btn btn-primary-action btn-success mg40\" ng-click=Modal.declerationConfirm() ng-disabled=\"(!Modal.declerationTextTnCModel && !Modal.isProcessing) || Modal.formData.declaretionArray.length==0\">Confirm Now</button> <button type=button ng-show=\"Modal.declerationTextTnCModel && !Modal.declerationTextAgreementModel\" class=\"btn btn-primary-action btn-success mg40\" ng-click=Modal.declerationExit()>Exit</button></form></div></div><div class=modal-content id=termsCondition ng-if=Modal.showTermNConditions><div class=modal-header><h4 class=modal-title>TERMS AND CONDITIONS</h4><i class=times-icon ng-click=\"Modal.showTermNConditions=false;\"></i></div><div class=modal-body><h6 class=text-center>TERMS AND CONDITIONS FOR EMPANELMENT</h6><ol class=numb-list><li>The statements made/information provided by the distributor in the Distributor Empanelment Form (\'Form\') and the declaration made therein read with these terms and conditions (\"Terms and Conditions\") shall be the basis of the contract between HDFC Asset Management Company Ltd (AMC) and the distributor and the distributor agrees to be legally bound by the same.</li><li>The appointment as the distributor will be at the sole discretion of the AMC and will be subject to written confirmation by AMC. The agency of the distributor will commence on the date stated in the appointment letter issued by AMC.</li><li>In case of application by non-individuals, a certified true copy of the relevant resolution authorizing to undertake the activities of distribution of mutual fund units or a letter from the Chairman/MD/ CEO/Authorised Persons confirming that the Organization has been authorized to undertake distribution of mutual funds along with a certified true copy of the Memorandum and Articles of Association/Bye-laws/Partnership Deed /Trust Deed /Society Registration Documents and Certificate of Registration and list of Authorised Signatories should be submitted.</li></ol><h6 class=margin-none>DECLARATION</h6><ol class=numb-list><li>The distributor agrees to abide by these Terms and Conditions and rules in force and the changes in the Terms and Conditions from time to time relating to the agency.</li><li>The distributor agrees to carry out such directions and HDFC Asset Management Company Limited (AMC) may from time to time, issue instructions in this regard.</li><li>The distributor agrees to read and understand the Offer Document and any addendum /notice issued thereto of the respective scheme(s) carefully and explain the market risks, investment risks, investment objectives, and the special features of the schemes to the investors. The distributor must not make any representation concerning Units or the Mutual Fund except those contained in the Offer Document of the respective scheme(s), the Key Information Memorandum containing Application Forms and printed information issued by the AMC as information supplemental to such documents.</li><li>The distributor agrees to use only such latest Offer Documents, Key Information Memorandum containing applications forms and advertising material provided by AMC and the distributor shall not design his/her own advertisement of the Scheme(s) of HDFC Mutual Fund unless it has obtained prior approval in writing from the AMC.</li><li>The distributor agrees that he/she will not use any unethical means to sell, market or induce any investor to buy units of schemes of HDFC Mutual Fund.</li><li>The distributor agrees he/she will not rebate/pass on the commission/brokerage to investors and shall not attract/induce investors through temptation of rebate or by offering gifts, benefits which are extraneous to the schemes of HDFC Mutual Fund .</li><li>The distributor shall not receive cash on behalf of the AMC. The distributor is not authorized to issue any receipt for cash and demand drafts received along with the application form(s) on behalf of the AMC.</li><li>The distributor hereby agrees to comply with the provisions of the Securities and Exchange Board of India (Mutual Funds), Regulations, 1996 as amended from time to time with specific focus on regulations /guidelines on advertisements/sales literature and comply with and adhere to the Code of Conduct and best practices prescribed for the intermediaries of Mutual Fund by Association of Mutual Fund of India (AMFI) The distributor shall also comply with circulars and adhere to guidelines issued by the Association of Mutual Funds of India (AMFI) and SEBI from time to time.</li><li>The distributor shall provide self certification in the prescribed format certifying compliance with the provisions of the extant SEBI/Mutual guidelines/circulars, adherence to the Code of Conduct as prescribed by SEBI/AMFI for intermediaries of Mutual Fund and fulfilling the minimum prescribed criteria regarding the number of investors and average assets under management at the end of every financial year to the AMC. If the said self certification is not provided, then the brokerage will be suspended till the time of receipt of the certificate.</li><li>All distributors, personnel, sub-agents and representatives of the distributor engaged in sales and marketing of the units of the Schemes of HDFC Mutual Fund should be certified and registered with AMFI and should hold a valid AMFI Certificate as required by SEBI. Further, the distributor shall on request by the AMC /HDFC Mutual Fund / Trustee at any time and from time to time, provide a declaration to the above effect. In addition, the AMC/ HDFC Mutual Fund/Trustee shall have the right to obtain copies of AMFI Certificates of all personnel, sub-agent(s) and representative(s) of the distributor engaged in sales and marketing of the Units of the Schemes of the HDFC Mutual Fund and they shall forthwith be required to furnish the same.</li><li>The distributor shall immediately notify the AMC in writing if any of its personnel or any other person engaged by the distributor has committed any act amounting to moral turpitude, financial irregularities or has been arrested by the police or has been relieved from the services/employment of the distributor. Upon receipt of such notice from the distributor, the AMC may suspend further business and payout of the commissions, etc. as it deems fit in the case.</li><li>The distributor shall ensure that his/her personnel/representatives shall at all times conduct themselves within the parameters of these Terms and Conditions and comply with and adhere to all applicable laws as specified in Clause (11) hereinabove and shall not commit or permit the commission of any offence; and in the event of any offence being committed, the distributor shall be liable for all consequences thereof; and the AMC shall not be directly or vicariously liable for the same.</li><li>The distributor hereby agrees if he /she appoints any sub-agent(s) or any representative(s) directly or indirectly, then in that case the distributor will be responsible for all the acts of the sub-agent(s)/representative(s) to AMC and to third parties.</li><li>a) Applicable to individual distributors-An individual distributor shall have at least 12 investors with the AMC, within one year of empanelment alternatively, furnish an undertaking stating that the individual distributor has serviced at least 25 investors across all mutual funds, this undertaking would form part of his /her annual self certification as specified in clause 12 hereinabove. b) Applicable to non-individual distributors-within one year of empanelment, if 75% or more of the gross funds mobilized are from associates, then furnish an undertaking stating that the non-individual distributor had serviced at least 200 investors other than associates and /or employees of the said associate during the said period. This undertaking would form part of his /her annual self-certification as specified in clause 12 hereinabove. c) Corporate distributors obtaining empanelment with AMC is required to have at least 100 investors from non-associates within one year of empanelment or have average assets under management of at least Rs. 1 crore with the AMC which are not from associates (being subsidiary and holding companies) within the period of one year of empanelment.</li><li>The limits prescribed above in sub-clause (a), (b) and (c) shall be liable to changes as per the circulars /recommendation(s) issued by AMFI/ SEBI from time to time. INDEMNITY</li><li>The distributor declares and covenants with the AMC, to defend indemnify and hold the AMC and its affiliates, promoters, successors in interest and permitted assigns harmless from and against all claims, damages or assertions of liability of any kind or nature resulting from: a. Any breach of term, covenants and conditions or other provisions hereof, or offer documents (s) or any actions or omissions thereunder; b. Any failure to comply with all applicable legislation, statutes, ordinances, regulations, administrative rulings or requirement of law; c. The misfeasance, malfeasance or fraudulent acts of the personnel/ representative(s) of the distributor; and d. Any and all actions, suits, proceedings, assessments, settlement, arbitration judgments, cost and expenses, including attorneys\' fees, resulting from any of the matters set forth above.</li><li>The distributor shall also indemnify and hold harmless the AMC, Trustee and/or the HDFC Mutual Fund from and against any and all direct and indirect costs, charges, claims, losses, expenses, damages, liabilities, awards, judgments, fines and actions of any nature whatsoever which the AMC, Trustee and/or HDFC Mutual Fund may incur/suffer due to a) the sub-agent(s) of the distributor making any representations, which are not based on information, documentation and/or literature provided by AMC/Trustee/ HDFC Mutual Fund as applicable; (b) any wrongful, dishonest, criminal, fraudulent act or willful misconduct or gross negligence of the sub-agent (s)/representative(s).</li></ol><h6 class=margin-none>BROKERAGE/COMMISSION</h6><ol class=numb-list><li>The distributor fulfilling the empanelment criteria as per the Code of Conduct and best practices for intermediary prescribed by SEBI and AMFI shall be entitled to receive brokerage for all business brought/ funds mobilized by them for AMC till the subsistence of the agency except on the investments made in his/her own name. The brokerage will be paid to the distributor at the rates(s) prescribed by the AMC. Provided, however, that the rate (s) are subject to revision at the discretion of the AMC from time to time and the distributor shall be bound by such changes. The commission/brokerage so paid to the distributor shall be inclusive of any cost, charges and expenses incurred by the distributor in connection with the agency and shall be paid to the distributor only after deductions of the requisite taxes at the applicable rate(s) in force.</li><li>The distributor shall not have any claim against the AMC / HDFC Mutual Fund/ Trustee for any loss incurred by him/ her as not anticipated and arising out of any revision in the rate(s) of the commission/brokerage for business brought/funds mobilized.</li><li>To avail the facility of Direct Credit of brokerage payment, the distributor is required to enclose a copy of a cancelled cheque leaf for the records of AMC. AMC reserves the right to pay brokerage/commission by cheque/demand draft even if the distributor has opted for a direct credit of brokerage.</li><li>In case of non-compliance of any of the Terms and Conditions mentioned herein and non- compliance of SEBI/AMFI guidelines, the AMC may suspend further business and pay-out of the commissions etc. until the same is complied with.</li><li>In case of termination of the agency as per clauses (28) and (30) mentioned herein below, the AMC shall not pay any trail commission after the termination of the agency of the distributor for the all business brought /funds mobilized by them for AMC before the termination of the agency.</li></ol><h6 class=margin-none>PRINCIPAL TO PRINCIPAL</h6><ol class=numb-list><li>These Terms and Conditions are on a principal-to-principal basis and do not create and shall not be deemed to create any employer-employee relationship between the AMC and the distributor and/or its personnel/representative(s). The distributor and/or its personnel/representative(s) shall not be entitled to, by act, word, deed or otherwise, make any statement on behalf of the AMC or in any manner bind the AMC or hold out or represent that the distributor is representing or acting as distributor of the AMC, except as expressly provided in these Terms and Conditions or otherwise in writing.</li><li>The activities of the distributor and its personnel/representative(s) shall not be construed to be activities of the AMC. Save and except as may be expressly permitted by the AMC, the distributor and its personnel/representative(s) shall not at any time use the name, mark or logo of the HDFC Mutual Fund/ AMC in any sales or marketing publication or advertisement, or in any other manner without prior written consent of the AMC.</li></ol><h6 class=margin-none>TERMINATION</h6><ol class=numb-list><li>The appointment of the distributor shall be liable to be terminated by the AMC forthwith: a. if he /she is found to be a minor or adjudicated as an insolvent or found to be of unsound mind by a court of competent jurisdiction; b. if in course of any judicial proceeding it is found that he/she has knowingly participated in or connived at any fraud, dishonesty or misrepresentation, financial irregularities against the AMC or any Unit holder of HDFC Mutual Fund c. if the AMC is satisfied that any statement made in the Form was false or misleading or calculated to mislead; d. if he/she acts in any other manner prejudicial to the interest of the AMC/HDFC Mutual Fund; and e. if he /she does not comply with all applicable legislation, statutes, ordinances, regulations administrative rulings or requirement of law. f. noncompliance of any of the clauses of the Terms and Conditions specified herein and the changes made to the Terms and Conditions from time to time.</li><li>In addition to what is stated in the preceding paragraphs, the AMC shall have the right to terminate the appointment of the distributor at any time by giving him/her 10 days notice without assigning any reason thereof. The distributor may also terminate the agency at any time by giving 10 days notice to the AMC.</li><li>The agency shall stand automatically terminated without any notice from the AMC / Mutual Fund upon disqualification or withdrawal of Regulatory /Government approval to act in the capacity contemplated herein. Upon any termination, the distributor shall forthwith handover all documents, papers and material pertaining to AMC/ HDFC Mutual Fund and /or belonging to AMC/ HDFC Mutual Fund to the AMC.</li></ol><h6 class=margin-none>NOMINATION FACILITY</h6><ol class=numb-list><li>The AMC offers nomination facility to distributor to enable the nominee to receive trail commissions on the business done before the demise of distributor holding ARN provided the distributor has complied with the Terms and Conditions mentioned herein above</li><li>In respect of all disputes arising under this empanelment, the courts in Mumbai alone shall have jurisdiction</li></ol><h6 class=text-center>TERMS OF USE FOR DISTRIBUTORS FOR ACCESSING HDFCMFONLINE FOR DISTTRIBUTORS</h6><p>HDFC Mutual Fund (<strong>“HDFC MF”</strong>)/HDFC Asset Management Company Limited (“HDFC AMC”) (jointly hereinafter referred to as “<strong>we</strong>”, “<strong>us</strong>”, or “<strong>our</strong>”) maintains HDFCMFOnline for Distributors as a part of our continued efforts to provide better facilities to the Distributors empanelled with us.</p><p>This page advises every person who visits HDFCMFOnline for Distributors (hereinafter referred to as “<strong>distributor(s)</strong>” “<strong>User,</strong>” “<strong>you,</strong>” or “<strong>your</strong>”) of the terms and conditions (“<strong>Terms</strong>”) of your use and access of HDFCMFOnline for Distributors (also referred to as “HDFCMFOnline”). The Users are requested to read these Terms carefully before they start using HDFCMFOnline. By accessing, browsing and/or using HDFCMFOnline and associated websites, online properties, tools, and links (collectively, the “<strong>Portal</strong>”), you acknowledge that you have read, understood and agreed to be bound by these Terms, without any limitation or qualification, and to comply with all applicable laws and regulations. If any of the points in these terms of usage /disclaimer notice are found to be unenforceable under applicable law that will have no bearing on the enforceability of the rest of the terms of usage/disclaimer notice. These Terms must be read in conjunction with our Privacy Policy and the Terms of Use of our website available on - http://www.hdfcfund.com. We may stipulate additional terms and conditions specific to certain facilities made available on the Portal, and any User availing of such facilities shall be bound by such terms and conditions in addition to the Terms laid down herein. If the User does not intend to be legally bound by these Terms, please refrain from using this Portal.</p><p>We reserve the right to modify the Terms on this Portal at any time, and any User continuing to use the website thereafter shall be bound by the revised Terms.</p><h6 class=margin-none>Services</h6><p>The services offered under this Portal are to facilitate the distributors to perform their obligations and services towards our investors more efficiently and to effectively distribute the offerings of HDFC AMC/HDFC MF.</p><p>This Portal inter alia provides information to distributor(s) about their AUM, information pertaining to all their clients who are investors of HDFC MF, and updated information about new offerings of HDFC AMC/HDFC MF. The Portal also enables the distributor to initiate transactions on behalf of their clients.</p><h6 class=margin-none>Portal Access and Security</h6><p>The Portal can be accessed only by those Distributors who have registered themselves with us and have been issued valid login credentials to access the Portal.</p><p>You are responsible for managing your account access, password, and any other information that you may provide for logging into the Portal and as a part of the Portal security features. You must have a valid username and password for purposes of accessing the Portal. It is your responsibility to treat such information as confidential, and to protect against disclosure to third parties. You would be solely responsible for any and all activities that occur under your account. You agree to notify us immediately of any unauthorized use of the Portal or any other breach of security whatsoever that you may be aware of.</p><p>We shall not be liable for any loss that you may incur as a result of an unauthorized third party using your passwords or accounts, either with or without your knowledge.</p><p>As this is an electronic service, access cannot always be guaranteed due to external factors beyond our control. Whilst we endeavour to ensure that the Portal is available without any interruptions, we do not guarantee that the access to or use of this Portal, its contents, services or any part thereof will be uninterrupted or error free or that the Portal or the server that makes it available will be free of viruses or other harmful components.</p><p>The Website and its features may be expanded, limited or modified at any time to meet the needs of its Users, or for technical or other reasons, without advance notice or reason. We reserve the right to change, modify, suspend, add, remove, or restrict access to the Portal or part of it at our sole discretion, without prior notice. We may also in our sole discretion, and at any time, discontinue providing, temporarily or permanently, any or the entire Portal, without notice.</p><p>While we will make all reasonable efforts to ensure that industry standard, accessible formats are used for the materials posted on the Portal, we cannot guarantee the compatibility of such materials with your own computer software. To access some of the content or features of the Portal or its Services, Users may need to enhance or update the hardware or software in their computer systems. The Users are responsible for making all requisite arrangements necessary for their access to the Portal, and we shall not be liable for any failure of the User to access the website or any services, partially or fully, whether due to the User\'s system, the internet network or any other cause whatsoever.</p><p>We do not guarantee that files available for downloading through the Portal will be free of infection or viruses or other code that may have contaminating or destructive properties. The User is responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for integrity, security and accuracy of data input and output, and for maintaining a means external to the Portal for the reconstruction of any lost data. HDFC MF, HDFC AMC, HDFC Trustee Company Limited, or affiliates’ or group companies or any other connected persons, including, but not limited to, the directors, sponsors, officers, or employees assumes no responsibility for any damages to, viruses that may infect, or services, repairs or corrections that must be performed, on your computer or other property on account of accessing or using this Portal.</p><h6 class=margin-none>Use of Portal</h6><p>The Portal and the contents thereof are for the sole use of the distributors empanelled with us, to whom access to the Portal is given by us. Your use of the Portal should not bring our name, our reputation or our products into disrepute.</p><p>All copyrights and other intellectual property rights in the materials on the Website belong to us. While accessing the Website, the Users are deemed to have acknowledged our copyright and other proprietary rights where they exist in any material provided. User acknowledges that, by using the Portal, it will not gain any ownership interest in the Portal. User further acknowledges and agrees that all title and rights in and to any third party content that is incorporated into the Portal is the property of the respective content owners and may be protected by applicable patent, copyright, trademark or other intellectual property laws.</p><p>We own and hold all rights, license, title, and interest, to the Portal and all the information and data available on the Portal and we grant to the User a limited license to access, view, download, print and share certain materials posted on the Portal solely for the purpose of enhancing the services that you provide to our investors and for facilitating your performance of your obligations as a distributor empanelled with us more efficiently. The User agrees not to reproduce, duplicate, copy, alter, modify, transmit, create derivative works of, publish, sublicense, distribute, circulate, disassemble, decompile, reverse engineer or re-sell the Portal or any part of the Portal. The User shall not misuse the information relating to investors of HDFC MF available on the Portal and shall use such data or information only for any service-related activities for the investors such as processing instructions, responding to service requests, resolve any investor grievances, etc. The User agrees that it shall not take any actions, whether intentional or unintentional, that may circumvent, disable, damage or impair the Portal’s ability to function, or allow or assist any third party to do so. The User agrees not to access, without authority, or interfere with, damage or disrupt: a) any part of the Portal; b) any equipment or network on which the Portal is stored; c) any software used in the provision of the Portal; or d) any equipment or network or software owned or used by any third party.</p><p>This Portal or the contents thereof or any facility available under the Portal, including the facility available to the distributors to send email to the investors of HDFC MF, shall not be construed as an offer or a solicitation of an offer by us to buy and/or sell any products/units of HDFC Mutual Funds to any person whomsoever. AMC accepts no liability for any email or communication sent by distributors from the Portal or for the consequences of any actions taken by any person on the basis of such email or communication or information provided. The distributor shall solely be responsible for any liability arising out of such email or communication.</p><p>The Portal is controlled and operated by HDFC AMC from its offices in India. We make no representation that materials in the Portal are appropriate or available for use in other locations, and access to them from territories where their contents are unlawful is prohibited. If you choose to access the Portal from other locations, you shall do so on your own initiative and you would be responsible for compliance with applicable local laws and regulations.</p><h6 class=margin-none>Third Party Sites</h6><p>For the convenience of the Users, this Portal may provide links to other websites and resources controlled by parties other than HDFC MF/HDFC AMC (each a \"Third Party Site\"). We have not reviewed any of these Third Party Sites or contents thereof prior to posting the same on our Portal. We are not responsible for and do not endorse or accept any responsibility for the availability, contents, products, services or use of any Third Party Site, any website accessed from a Third Party Site or any changes or updates to such sites. We make no guarantee about the content or quality of the products or services provided by such websites. We are providing these links to the User only as a convenience, and the inclusion of any link does not imply endorsement by us of the Third Party Site, nor does it imply that we sponsor, are affiliated or associated with, guarantee, or are legally authorized to use any trade name, registered trademark, logo, legal or official seal, or copyrighted symbol that may be reflected in the links.</p><p>The information available on Third Party Sites may have certain restrictions on its use or distribution, which differ from the Terms applicable to this Portal. Prior to accessing the contents of such Third Party Sites, Users are advised to review the terms of use and privacy policies applicable to such websites. The User acknowledges that they bear all risks associated with access to and use of content provided on a Third Party Site and agree that we are not responsible for any loss or damage of any sort that any User may incur from dealing with a third party.</p><h6 class=margin-none>Accuracy of Information</h6><p>We have taken due care and caution in compilation of data for its Portal. All reasonable care has been taken to ensure that the information contained herein is not misleading or untrue at the time of publication. However, we make no long standing commitment as to its accuracy or completeness. The licenses for the tools/calculators provided on the Portal are held by HDFC AMC and are intended solely to illustrate certain financial planning ideas and concepts and may not reflect actual results due to factors beyond the scope of such tools/calculators.</p><p>No representation, warranty or undertaking is given by us that the information available on this Portal or the results emanating from any tools/calculators provided on the Portal is accurate, complete, comprehensive, or up to date, and no liability is accepted by us for such information. In particular, we shall not be obliged to keep the contents of the Portal updated, or remove any outdated information from this Portal or to expressly mark it as outdated. In no event will HDFC MF/HDFC AMC be liable, financially or otherwise, to any person for any direct, indirect, special or consequential damages arising out of any use of the information contained on this Portal, including, without limitation, any lost profits, business interruption, or otherwise.</p><h6 class=margin-none>No Warranty</h6><p>HDFC MF/HDFC AMC makes no warranty that: (a) the Portal or the contents thereof will meet their requirements; (b) the Portal or the contents thereof will be available on an uninterrupted, timely, secure or error-free basis; (c) the results/statements/data/information that may be obtained from the use of the Portal or any materials offered through the Portal or applications, will be accurate or reliable; and (d) the quality of any Services or information obtained by the User through the Portal will meet their expectations.</p><h6 class=margin-none>Liability</h6><p>We do not accept any liability whether for costs, expenses, loss or damage and whether direct, indirect or consequential and whether economic or otherwise arising from the giving of access to our Portal or from the services and/or facilities provided in the Portal. Use of the Portal and the services/facilities on the Portal is entirely at your own risk.</p><h6 class=margin-none>Termination</h6><p>You are permitted to access the Portal solely on account of you being empanelled with us as a distributor. We may terminate your rights of access to our Portal and the facilities/services provided on the Portal at any time, at our sole discretion, without any notice thereof. Access will be terminated on termination of your Distribution Agreement with us. Termination may also occur if we discover that you have been in breach of these terms and conditions, or for any other reason considered appropriate by us. On termination you will delete all the materials and all copies of the same from your computers and confirm to us that this has been done and you will have no further right to use them for any purpose whatsoever.</p><h6 class=margin-none>Compliance with laws</h6><p>The User undertakes to comply and be bound by all applicable laws and statutory requirements in India. Any dispute arising out of the use of this Portal and/or any of the services/facilities offered through the Portal shall be subject to the non-exclusive jurisdiction of the Courts in Mumbai, India.</p></div></div>");
$templateCache.put("app/components/modal/dreamSchemeList/dreamSchemeList.model.html","<!-- Scheme List--><div class=modal-content id=schemeList ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title style=\"margin: 10px;\n    padding-top: 12px\">Scheme List</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index==0}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=Modal.filterSchemes(schemeType)><a data-toggle=tab>{{schemeType}}</a></li></ul><input ng-if=\"Modal.schemeList.length !=0\" type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\"> <span class=no-scheme ng-if=\"Modal.schemeList.length===0\" style=\"margin: 20px\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\" ng-if=Modal.schemeList.length><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemeList|searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/changeOption.modal.html","<div class=modal-content id=forgot-success><div class=modal-header><h4 class=modal-title>Change Option</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content ng-if=\"Modal.modalData.optionType == \'Option A\'\"><h6 class=text-center style=\"line-height: 1.5\">Please select Target scheme if you wish to change Dream SIP Option from A to B</h6><br><form autocomplete=off class=sipPurchase-form name=sipPurchaseForm novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><!-- <div class=\"col-md-3 form-grid\">\n                <div class=\"install-freq frequency\">\n                  <p><strong>Select Option</strong></p>\n                  <div class=\"radio-block\" ng-repeat=\"option in Modal.optionList\">\n                    <span class=\"radio\">\n                      <input type=\"radio\" id=\"{{option.key+\'1\'}}\" ng-model=\"Modal.optionType\"\n                        ng-value=\"option.value\" name=\"option\" ng-change=\"Modal.changeOptionType()\" />\n                      <span class=\"check\"></span>\n                    </span>\n                    <label>{{option.value}}</label>\n                  </div>\n                </div>\n              </div> --><div><div class=form-group><div class=\"input-select input-normal\"><input type=text name=targetScheme id=targetScheme ng-change=Modal.filterSipSchemeList() ng-model=Modal.targetSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><drop-down list-data=Modal.targetSchemeList display-key=scheme hdfc-click=Modal.targetSchemeChanged(data) model=Modal.targetSchemeCode for=targetScheme></drop-down></div></div></div></div></div></div></form><div class=row><div class=col-md-12><div class=point-to-note-tpv style=margin-top:10px>Note:<br><ul><li>Option A - Source and Target scheme of SIP and SWAP shall remain same.</li><li>Option B - Source and Target scheme of SIP and SWAP shall be different.</li><li>Your request to change Dream SIP Option may take up to 5 business days.</li></ul></div></div></div></div><div class=content ng-if=\"Modal.modalData.optionType == \'Option B\'\"><!-- <h6 class=\"text-center\">New Target Scheme in your Dream SIP shall be </h6></br></br>\n      <h3 class=\"text-center\"> {{Modal.modalData.schemeName}}</h3></br></br> --><h6 class=text-center>Do you wish to change Dream SIP Option from B to A?</h6><br><div class=row><div class=col-md-12><div class=point-to-note-tpv style=margin-top:10px>Please Note:<br><ul><li>Option A - Source and Target scheme of SIP and SWAP shall remain same.</li><li>Option B - Source and Target scheme of SIP and SWAP shall be different.</li><li>Your request to change Dream SIP Option may take up to 5 business days.</li></ul></div></div></div></div><br><div><div style=\"display: flex;justify-content: space-evenly;align-items: center\"><div><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>Cancel</button></div><div ng-if=\"Modal.modalData.optionType == \'Option A\'\"><button class=\"btn btn-primary-action\" ng-disabled=!Modal.targetSchemeCode ng-click=Modal.continue()>Send for Approval</button></div><div ng-if=\"Modal.modalData.optionType == \'Option B\'\"><button class=\"btn btn-primary-action\" ng-click=Modal.continue()>Send for Approval</button></div></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/changeTargetScheme.modal.html","<div class=modal-content id=forgot-success ng-init=Modal.fetchTargetScheme()><div class=modal-header><h4 class=modal-title>Change Target Scheme</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div class=content ng-if=\"Modal.modalData.optionType == \'Option B\'\"><form autocomplete=off class=sipPurchase-form name=sipPurchaseForm novalidate><div class=\"normal-wrap clearfix\"><div class=sip-form-box><div class=row><div><div class=form-group><div class=\"input-select input-normal\"><input type=text name=targetScheme id=targetScheme ng-change=Modal.filterSipSchemeList() ng-model=Modal.targetSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><drop-down list-data=Modal.targetSchemeList display-key=scheme hdfc-click=Modal.targetSchemeChanged(data) model=Modal.targetSchemeCode for=targetScheme></drop-down></div></div></div></div></div></div></form></div><div><div class=point-to-note-tpv style=\"padding: 7px !important\">Note:</div><div class=point-to-note-tpv style=\"padding: 7px !important\"><ul><li>Your request to change Dream SIP Target Scheme may take up to 5 business days.</li></ul></div></div><br><div><div style=\"display: flex;justify-content: space-evenly;align-items: center\"><div><button class=\"btn btn-secondary-action\" autofocus ng-click=Modal.dismissModal()>Cancel</button></div><div ng-if=\"Modal.modalData.optionType == \'Option B\'\"><button class=\"btn btn-primary-action\" ng-disabled=!Modal.targetSchemeCode ng-click=Modal.continue()>Send for Approval</button></div></div></div></div></div>");
$templateCache.put("app/components/modal/dreamSip/pointToNote.modal.html","<div class=modal-content id=disclaimerPopups><div class=modal-header style=\"background: aliceblue\"><h4 class=modal-title>Dream SIP - Points To Note</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div style=\"margin: 20px\"><div><ol style=\"line-height: normal\"><li>1. Dream SIP for your investor shall be registered in a new folio.</li><li>2. New Dream SIP folio for your investor shall be created using details of existing folio {{}}.</li><li>3. You may review and update details of new folio to be created for your investor on next screen before registering Dream SIP.</li><li>4. New folio created for Dream SIP shall not be available for lumpsum purchase, SIP and Switch transactions. you may continue to place redemption transaction in Dream SIP folio including SWAP on behalf of your investor. However, subsequent SWAP after completion of SIP tenure shall not get triggered and Dream SIP shall get converted into normal SIP and Continue until it\'s tenure.</li></ol></div><br><div><button class=\"btn btn-primary-action btn-center\" style=\"margin-right: auto\" ng-click=Modal.continue()>Continue</button></div></div><br></div>");
$templateCache.put("app/components/modal/dreamSipTenure/dream.sip.tenure.modal.html","<!-- Scheme List--><div class=modal-content id=schemeList style=\"padding: 5px\"><div class=\"loader popup\"><span class=loading></span></div><div class=modal-head><h3 class=modal-title><b>SIP Tenure</b></h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>SIP Tenure</th><th>Monthly SWAP Installments</th></tr></thead><tbody><tr ng-repeat=\"data in Modal.modalData\"><td>{{data.value}} Years</td><td>{{data.multiple}} <span ng-if=\"(data.multiple % 1) === 0\">.0</span> times monthly SIP installments</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/modal/editDashboard/success.edit.html","<div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><i class=success-icon></i><p>Changes have been saved successfully.</p><button type=submit ui-sref=main.dashboard ng-click=Modal.dismissModal(); class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/editNominee/editNominee.modal.html","<!--   Reset Password ----><div class=modal-content id=editNominee><div class=modal-header><h4 class=modal-title>Edit Nominee</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.nomineeForm autocomplete=off ng-submit=Modal.editNominee() novalidate><div class=input-normal><input type=text name=nomineeName ng-model=Modal.modalData.name autocomplete=off maxlength=60 ng-change=\"Modal.confirmErr=\'\'\" required capitalize> <span class=highlight></span> <span class=bar></span><label>Nominee Name</label></div><div class=input-normal><input type=text name=relationship ng-model=Modal.modalData.relationship autocomplete=off maxlength=20 ng-change=\"Modal.confirmErr=\'\'\" required capitalize> <span class=highlight></span> <span class=bar></span><label>Relationship</label></div><div class=\"input-normal calendar-input\"><input type=text name=nomineeDob id=nomineeDob date-calendar date-default=Modal.defaultDate format=DD-MMM-YYYY viewmode=days maxdate=now showdefault=true data-on-date-change=Modal.changeNomineeDob autocomplete=off required> <span class=highlight></span> <span class=bar></span><label class=editNominee-dob>Nominee DOB</label><i class=calendar-icon></i><!--<span ng-show=\"Modal.nomineeForm.nomineeDob.$dirty && Modal.nomineeForm.nomineeDob.$invalid\">--><!--<span class=\"error-input\" ng-show=\"Modal.nomineeForm.nomineeDob.$error.pattern\">{{ Modal.validateData.DOB_FIELD }}</span>--><!--</span>--></div><button type=submit class=\"btn btn-block btn-primary-action\" ng-disabled=Modal.processFlag>Submit</button><div class=error-msg ng-bind=Modal.confirmErr></div></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/emandate/cancelMandate.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><ng-bind-html dynamic=Modal.modalData.dynamicData.Note_Cancel_Emandate.content></ng-bind-html></div>");
$templateCache.put("app/components/modal/emandate/confirmMandate.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope confirm-mandate\"><div class=text-center><p>To register your e-mandate (eOTM), you would be redirected to the {{Modal.modalData.bankName}} internet banking login page. E-mandate (eOTM) registration and bank charges may apply depending on selected bank.</p><br><p>Do you wish to proceed?</p></div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.submitAction()>OK</button> <button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Cancel</button></div></div></div>");
$templateCache.put("app/components/modal/euinDeclarationOneClick/euin-declaration-one-click.modal.html","<div class=\"modal-content euinDeclarationOneClick\"><i class=times-icon ng-click=Modal.dismissModal();>X</i><div class=modal-body><p class=label-euin>EUIN Declaration</p><p class=desc-euin>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</p><div class=euin-btn><button type=submit ng-click=\"Modal.closeModal(\'success\')\" class=\"btn btn-secondary-action\">OKAY</button></div></div></div>");
$templateCache.put("app/components/modal/feedback/feedback.modal.html","<div class=modal-content id=feedbackModal><div class=modal-body><i class=times-icon ng-click=Modal.dismissModal();></i><form><div class=text-center><i class=success-icon></i></div><p class=text-center>Your feedback has been submitted successfully.</p><div class=text-center><button class=\"btn-primary-action btn\" ng-click=Modal.closeModal();>OK</button></div></form></div></div>");
$templateCache.put("app/components/modal/fileDownload/brockerageReport.modal.html","<!--   Reset Password ----><div class=modal-content id=downloadFile ng-init=Modal.setDatePickerCSS();><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>SELECT THE PERIOD</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"padding-top: 20px\"><form autocomplete=off name=reportDownload novalidate><div class=form-group><div class=\"input-normal text-center\" style=margin-bottom:43px><p class=alert-info style=\"line-height: 35px;font-size: 1.3em\">Please select the date range of last three months.</p></div><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" style=\"margin-bottom: 43px\"><input date-range-picker id=daterange1 name=dateRange placeholder=\"Pick From Date -> To Date\" class=\"form-control date-picker\" type=text min=Modal.minDate max=Modal.maxDate ng-model=Modal.date options=\"{locale: {format: \'DD-MMM-YYYY\'}}\" ng-required=true readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><!-- <div class=\"help-block\" ng-messages=\"reportDownload.dateRange.$error\">\n              <p ng-message=\"min\">Start date is too far in the past.</p>\n              <p ng-message=\"max\">End date is too far in the future.</p>\n              <p ng-message=\"required\">Range is required.</p>\n            </div>--></div><!--\n          <div class=\"input-normal verify-acc input-group date date-picker transaction-cal\"\n               date-calendar\n               data-enable=\"true\"\n               data-viewmode=\"days\"\n               data-date-default=\"Modal.fromdate\"\n               data-max-date=\"Modal.today\"\n               data-on-date-change=\"Modal.changeFromDate\"\n               data-format=\"DD-MMM-YYYY\"\n               id=\"fromDate\">\n            <input type=\'text\' id=\"fromdateId\" autocomplete=\"off\" class=\"form-control\"\n                   placeholder=\"From Date - DD-MMM-YYYY\" readonly/>\n            <span class=\"input-group-addon\">\n                     <span class=\"glyphicon glyphicon-calendar\"></span>\n                </span>\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n          </div>--></div><!--<div class=\"form-group\" ng-if=\"Modal.dateFlag\">\n        <div class=\"input-normal\">\n          <div class=\"input-normal verify-acc input-group date date-picker transaction-cal\"\n               date-calendar\n               data-enable=\"true\"\n               data-viewmode=\"days\"\n               data-date-default=\"Modal.todate\"\n               data-min-date=\"Modal.fromdate\"\n               data-max-date=\"Modal.today\"\n               data-on-date-change=\"Modal.changeToDate\"\n               data-format=\"DD-MMM-YYYY\"\n               id=\"todate\">\n            <input type=\'text\' id=\"todateId\" autocomplete=\"off\" class=\"form-control\" placeholder=\"To Date - DD-MMM-YYYY\"\n                   readonly/>\n            <span class=\"input-group-addon\">\n                     <span class=\"glyphicon glyphicon-calendar\"></span>\n                </span>\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n          </div>\n        </div>\n      </div>--><!--<div class=\"form-group text-center\">\n              <span class=\"radio-block\">\n                <span class=\"radio\">\n                  <input type=\"radio\" id=\"pdfFile\" name=\"fileType\" ng-model=\"Modal.filetype\" value=\"pdf\" required/>\n                  <span class=\"check\"></span>\n                </span>\n                <label for=\"excelFile\">PDF</label>\n              </span>\n        <span class=\"radio-block\">\n                <span class=\"radio\">\n                  <input type=\"radio\" id=\"excelFile\" name=\"fileType\" ng-model=\"Modal.filetype\" value=\"xls\" required/>\n                  <span class=\"check\"></span>\n                </span>\n                <label for=\"pdfFile\">EXCEL</label>\n              </span>\n      </div>--> <button class=\"btn-primary-action btn btn-block\" ng-disabled=\"Modal.processFlow|| Modal.date.startDate==null\" ng-click=Modal.brokerageReportDownload()>Send</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/fileDownload/fileDownload.modal.html","<!--   Reset Password ----><div class=modal-content id=downloadFile><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>SELECT THE REPORT FORMAT</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off autocomplete=off><div class=\"form-group text-center\"><span class=radio-block><span class=radio><input type=radio id=pdfFile name=fileType ng-model=Modal.filetype ng-value=Modal.DOWNLOAD_TYPES.PDF> <span class=check></span></span><label for=pdfFile>PDF</label></span><span class=radio-block><span class=radio><input type=radio id=excelFile name=fileType ng-model=Modal.filetype ng-value=Modal.DOWNLOAD_TYPES.EXCEl> <span class=check></span></span><label for=excelFile>EXCEL</label></span></div><button class=\"btn-primary-action btn btn-block\" ng-disabled=Modal.processFlow ng-click=Modal.download()>Download</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/fileDownload/sendFileDownload.modal.html","<!--   Reset Password ----><div class=modal-content id=downloadFile><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>SELECT THE REPORT FORMAT</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off autocomplete=off><div class=\"form-group text-center\"><span class=radio-block><span class=radio><input type=radio id=pdfFile name=fileType ng-model=Modal.filetype ng-value=Modal.DOWNLOAD_TYPES.PDF> <span class=check></span></span><label for=pdfFile>PDF</label></span><span class=radio-block><span class=radio><input type=radio id=excelFile name=fileType ng-model=Modal.filetype ng-value=Modal.DOWNLOAD_TYPES.EXCEl> <span class=check></span></span><label for=excelFile>EXCEL</label></span></div><button class=\"btn-primary-action btn btn-block\" ng-disabled=Modal.processFlow ng-click=Modal.sendReport()>Send</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/folioCreation/folioCreation.otp.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Investor Verification</h4><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=\"modal-body folio-creation-modal\"><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmTransaction() novalidate><p class=info ng-if=!Modal.showContactUpdateUI>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><p ng-if=Modal.showContactUpdateUI class=\"info-contact fw-bold\">For improved security, we have sent two One-time Passwords (OTPs) before you review folio creation and contact details update request initiated by your Mutual Fund Distributor (MFD).</p><div ng-if=\"Modal.modalData.type === \'soleApplicant\' || Modal.modalData.type === \'holder\'\" class=\"group input-normal dob-calender\" ng-class=\"{error:Modal.dateErrorMessage || Modal.ageErrorMessage || Modal.otpForm.dob.$dirty && Modal.otpForm.dob.$invalid}\"><div class=\"password-input-container input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Modal.viewMode}} data-date-default=Modal.nomineePayload.dob data-on-date-change=Modal.changeStartDate maxdate=now format=DD-MM-YYYY style=\"width: 100%;\n                        height: 40px;\n                        border-radius: 5px\"><input tabindex=2 id=dobId name=dob type=text autocomplete=off ng-keyup=Modal.autoDate() required ng-model=Modal.dob ng-change=Modal.varifyDate()><label for=dobId>Enter Date of Birth<span class=req>*</span></label><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=error-input ng-if=Modal.dateErrorMessage ng-bind=Modal.dateErrorMessage></span> <span class=error-input ng-if=Modal.ageErrorMessage ng-bind=Modal.ageErrorMessage></span></div></div><p ng-if=Modal.showContactUpdateUI class=\"info-contact error-input fw-bold\">OTP 1 is sent to your existing contact details (email ID & mobile number) present in your KYC, while OTP 2 is sent on your new contact detail to be updated.</p><div ng-if=!Modal.showContactUpdateUI class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP<span class=req>*</span></label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span> </span><!--        <div style=\"padding-top: 10px;\" ng-show=\"Modal.isOtpValid\">--><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=javascript:void(0) ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><!-- Otp verification Update Contact--><div ng-if=Modal.showContactUpdateUI><div class=\"input-group input-normal\" style=\"width: 100%; margin-top: 10px;margin-bottom: 20px\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=Modal.formData.otpNumber name=otpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>OTP 1<span class=req>*</span></label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.otpForm.otpNumber.$error ng-show=Modal.otpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p style=\"padding: 12px 0\" ng-if=Modal.modalData.updateContactMessage1>{{Modal.modalData.updateContactMessage1}}</p></div><div class=\"input-group input-normal\" style=\"width: 100%; margin-top: 10px;margin-bottom: 20px\" ng-class=\"{error:Modal.otpForm.newOtpNumber.$dirty && Modal.otpForm.newOtpNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=Modal.formData.newOtpNumber name=newOtpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>OTP 2<span class=req>*</span></label><span class=error-input style=\"position: initial !important\" ng-messages=Modal.otpForm.newOtpNumber.$error ng-show=Modal.otpForm.newOtpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p style=\"padding: 13px 0\" ng-if=Modal.modalData.updateContactMessage2>{{Modal.modalData.updateContactMessage2}}</p><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=forgot-pwd style=\"transform: translateY(-12px)\">Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\" style=\"transform: translateY(25px)\">Enable Resend OTP in {{countdown}}s</a></timer></span></div><span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></div><!-- End of Otp verification Update Contact--><div><button type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.isOtpValid\" class=\"btn btn-primary-action btn-block\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/folio-choice/folio-choice.modal.html","<div class=\"modal-content folio-detail-modal\"><div class=modal-head><h3>Create New Folio</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p>{{Modal.modalData.text}}</p><div class=\"modal-multiple-actions text-center\"><button ng-disabled=\"\" class=\"btn btn-primary-action\" ng-click=\"Modal.closeModal(\'SELECT_NEW\')\"><i>Yes, Select Folio</i></button> <button class=\"btn btn-secondary-action\" ng-click=\"Modal.closeModal(\'no\')\">No, Create New</button></div></div></div>");
$templateCache.put("app/components/modal/folioSuccess/folioSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=folio-success><!-- <i class=\"times-icon\" ng-click=\"Modal.dismissModal(\'close\');\"></i> --><div class=modal-body><div class=\"clearfix folio-num text-center\"><i class=verify-icon></i><br><span>Successfully Created</span><br><span class=text-small>Folio No. {{Modal.modalData.folioNumber}}</span><br><p>A new folio has been successfully created & saved</p><p ng-hide=\"Modal.folioDetails.folioWithoutTransaction == \'Y\'\">You can now proceed to payment</p><button class=\"btn btn-primary-action\" ng-click=Modal.pay(); ng-hide=\"Modal.folioDetails.folioWithoutTransaction == \'Y\'\">Make payment</button></div></div></div>");
$templateCache.put("app/components/modal/forgotPassword/forgotPassword.modal.html","<!--   Reset Password ----><div class=modal-content id=forgotPassModal><div class=modal-header><h4 class=modal-title>Forgot Password</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body style=\"padding:30px 15px 50px 15px\"><form autocomplete=off name=Modal.forgotPasswordForm ng-submit=Modal.forgotPassword() novalidate><p class=info>Please provide your ARN number to proceed to<br>change your password.</p><div class=input-normal ng-class=\"{error:Modal.forgotPasswordForm.arnCode.$dirty && Modal.forgotPasswordForm.arnCode.$invalid}\"><input name=arnCode ng-model=Modal.forgotPasswordPayload.arnCode ng-change=Modal.clearModal(); type=text class=arn-no capitalize maxlength=10 ng-pattern=Modal.appConstants.arn_regex required> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>ARN</label><span ng-show=\"Modal.forgotPasswordForm.arnCode.$dirty && Modal.forgotPasswordForm.arnCode.$invalid\"><span ng-if=\"(Modal.forgotPasswordForm.arnCode.$error.required) || (Modal.forgotPasswordForm.arnCode.$error.pattern && Modal.forgotPasswordForm.arnCode.$invalid )\" class=ng-hide>{{Modal.wrongARNmsg}}</span> <span class=error-input ng-show=Modal.forgotPasswordForm.arnCode.$error.required ng-bind=Modal.validateData.ARN_REQUIRED></span> <span class=error-input ng-show=\"Modal.forgotPasswordForm.arnCode.$error.pattern && Modal.forgotPasswordForm.arnCode.$invalid \" class=help-block>{{ Modal.validateData.ARN_FIELD }} </span></span><br><span><span class=error-input ng-bind=Modal.wrongARNmsg style=\"color: #d42113\"></span></span></div><div class=input-normal ng-class=\"{error:Modal.forgotPasswordForm.pan.$dirty && Modal.forgotPasswordForm.pan.$invalid && Modal.forgotPasswordForm.pan.$touched}\"><input type=text name=pan maxlength=10 minlength=10 ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ ng-model=Modal.forgotPasswordPayload.pan capitalize required autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=lock-icon></i><label>PAN</label><span ng-messages=Modal.forgotPasswordForm.pan.$error ng-show=\"Modal.forgotPasswordForm.pan.$dirty && Modal.forgotPasswordForm.pan.$invalid\"><span class=error-input ng-message=required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span class=error-input ng-message=minlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-message=maxlength ng-bind=Modal.validateData.PAN_FIELD></span> <span class=error-input ng-message=pattern ng-bind=Modal.validateData.PAN_FIELD></span></span></div><div ng-if=Modal.showCaptcha><div class=input-normal vc-recaptcha key=Modal.publicKey ng-model=Modal.gRecaptchaResponse></div></div><button class=\"btn btn-primary-action btn-block\" ng-disabled=\"Modal.forgotPasswordForm.$invalid || Modal.processFlag\">Submit</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/forgotPassword/forgotPasswordSuccess.modal.html","<!--   Reset Password ----><div class=modal-content id=forgotPassSucc><h4 class=modal-title></h4><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><form autocomplete=off autocomplete=off><p class=info><span ng-bind-html=Modal.modalData.message></span><!--A link to change your password has been sent to your email ID <br/>--><br></p><button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/generic-ui-modal/generic-ui.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=modal-header><h4 class=modal-title>{{Modal.modalData.title}}</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><section class=content><iframe name=DBox id=DBox src={{Modal.iframeUrl}} frameborder=0 style=\"width:95%;height:500px;overflow: hidden\"></iframe></section></div></div>");
$templateCache.put("app/components/modal/genericModal/generic.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=modal-body><p ng-if=Modal.modalData.panErrorText ng-bind-html=Modal.modalData.panErrorText class=panAdhar></p><p ng-if=\"!Modal.modalData.isFromBulk && !Modal.modalData.panErrorText\" ng-bind-html=Modal.modalData.text></p><p ng-if=\"Modal.modalData.isFromBulk && !Modal.modalData.panErrorText && !Modal.modalData.isPanAdharPopup\" class=bulk-error-details>{{Modal.modalData.text}}</p><p ng-if=\"Modal.modalData.isFromBulk && !Modal.modalData.panErrorText && Modal.modalData.isPanAdharPopup\" ng-bind-html=Modal.modalData.text style=\"word-break: break-word\" class=\"bulk-error-details panAdharBulk\"></p><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></div><style>.panAdhar a{\n    text-decoration: underline !important;\n    font-size: 12px !important;\n  }\n\n  .panAdharBulk a {\n    text-decoration: underline !important;\n    font-size: 14px !important;\n  }</style>");
$templateCache.put("app/components/modal/genericModal/generic.success.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=modal-body><div class=text-center>{{ Modal.modalData.text }}</div><br><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/imagePreview/imagePreview.modal.html","<!-- Scheme List--><div class=modal-content id=imagePreview ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div class=\"image-preview text-center\" ng-if=Modal.modalData.showOnly><img http-src={{Modal.filepreview}} class=img-responsive ng-if=\"Modal.filepreview && Modal.modalData.file\" style=margin:auto></div><div class=\"image-preview text-center\" ng-if=!Modal.modalData.showOnly><img ng-if=Modal.supportedFileType ng-src={{Modal.filepreview}} class=img-responsive ng-show=Modal.filepreview style=margin:auto><div ng-if=!Modal.supportedFileType>Preview not Supported for {{Modal.fileType}} files.</div></div></div><div class=modal-footer ng-show=Modal.modalData.showOnly style=text-align:center><!--<button class=\"btn btn-secondary-action\" ng-click=\"Modal.dismissModal()\">Cancel</button>--> <button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">OK</button></div><div class=modal-footer ng-hide=Modal.modalData.showOnly><button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Upload</button></div></div>");
$templateCache.put("app/components/modal/initialLogin/success.modal.html","<div class=modal-content id=declarationMessage><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title ng-bind=Modal.modalData style=\"text-transform: none\">Your Self Declaration Certificate is Pending for FY 2015-16 and FY 2017-18.</h4><!--    <i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body style=\"padding-top: 15px; padding-bottom: 30px\"><!--    <h6 ng-bind=\"Modal.modalData\">Your Self Declaration Certificate is Pending for FY 2015-16 and FY 2017-18.</h6>--><p style=\"text-align: justify;padding-top: 0px\">As per AMFI circular number AMFI/CIR-18/2019-20 dated July 04, 2019, the annual Distributor Self Certification should be submitted within 3 months from the end of each Financial Year (.i.e. June 30), failing which the accrued commission would then subsequently be withheld. Additionally, a grace period of 6 months (upto December 31) will be provided for submission of the Distributor Self Certification, failing which the withheld commission would stand forfeited for non-compliance. Kindly submit your Distributor Self Certification at the nearest CAMS office or HDFC ISC at the earliest (before 31st Dec 2019) to comply to the above circular</p><button type=submit ng-click=Modal.continue() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/bulk-success.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><i class=success-icon></i><h6>Submitted successfully</h6><p>You have successfully initiated a {{Modal.modalData.transactionType}} bulk transaction.</p><button type=submit ng-click=Modal.continue() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/otp-verification.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Investor Verification</h4><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmTransaction() novalidate><p class=\"info info-upi\" ng-if=Modal.modalData.showMessageForUPI>Mandate registered via UPI autopay, shall get registered with start date as today\'s date.</p><p class=info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div class=\"group input-normal\" ng-if=Modal.transactionType><input type=text name=panNumber ng-model=Modal.panNumber ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ maxlength=10 minlength=10 required autocomplete=off capitalize><label>Enter PAN Number<span class=req>*</span></label><span ng-if=\"Modal.otpForm.panNumber.$dirty && Modal.otpForm.panNumber.$invalid\"><span class=error-input><span ng-show=Modal.otpForm.panNumber.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span ng-show=\"Modal.otpForm.panNumber.$invalid && Modal.otpForm.panNumber.$viewValue\" ng-bind=Modal.validateData.INVALID_PAN></span></span></span></div><div ng-if=\"Modal.modalData.summaryType === \'NOMINEEOPTOUT\' || Modal.modalData.summaryType === \'NOMINEEADDUPDATE\'\" class=\"group input-normal dob-calender\" ng-class=\"{error:Modal.dateErrorMessage || Modal.ageErrorMessage || Modal.otpForm.dob.$dirty && Modal.otpForm.dob.$invalid}\"><div class=\"password-input-container input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Modal.viewMode}} data-date-default=Modal.nomineePayload.dob data-on-date-change=Modal.changeStartDate maxdate=now format=DD-MM-YYYY style=\"width: 100%;\n                        height: 40px;\n                        border-radius: 5px\"><input tabindex=2 id=dobId name=dob type=text autocomplete=off ng-keyup=Modal.autoDate() required ng-model=Modal.dob ng-change=Modal.varifyDate()><label for=dobId>Enter Date of Birth<span class=req>*</span></label><span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=error-input ng-if=Modal.dateErrorMessage ng-bind=Modal.dateErrorMessage></span> <span class=error-input ng-if=Modal.ageErrorMessage ng-bind=Modal.ageErrorMessage></span></div></div><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP<span class=req>*</span></label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\" ng-show=Modal.isOtpValid><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=javascript:void(0) ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><button type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.isOtpValid\" class=\"btn btn-primary-action btn-block\">Submit</button></form></div></div><style>@media only screen and (min-width: 360px) and (max-width: 767px) {\n  #toast-container{\n    z-index: 1000000 !important;\n  }\n}</style>");
$templateCache.put("app/components/modal/initiateTransaction/registerEMandate.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><p style=\"padding: 0;text-align: left\" ng-if=\"Modal.modalData.authMode !== \'DEBIT_CARD\'\">To register e-mandate investor would be redirected to Net Banking login page. A debit of Rs 1/- may be carried out to your investor\'s account for registration depending on selected bank.<br></p><p style=\"padding: 5px 0 20px 0;text-align: left\" ng-if=\"Modal.modalData.authMode !== \'DEBIT_CARD\'\">Do you wish to proceed?</p><p style=\"padding: 5px 0 20px 0;text-align: center\" ng-if=\"Modal.modalData.authMode === \'DEBIT_CARD\'\">Do you wish to proceed?</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button> <button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>Cancel</button></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/rejectTransaction.modal.html","<!-- Reject Transaction--><div class=modal-content id=rejectTransaction><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><h6>Please specify reason for Rejection</h6><form name=Modal.rejectionForm ng-submit=Modal.rejectTransaction() novalidate><div class=\"group input-normal\" ng-class=\"{error:Modal.rejectionForm.comments.$dirty && Modal.rejectionForm.comments.$invalid}\"><textarea id=comments rows=5 ng-model=Modal.comments name=comments placeholder=\"Enter reason...\" required></textarea><span ng-show=\"Modal.rejectionForm.comments.$dirty && Modal.rejectionForm.comments.$invalid\"><span class=error-input ng-show=Modal.rejectionForm.comments.$error.required ng-bind=Modal.validateData.REASON_REQUIRED></span></span></div><button type=submit ng-disabled=Modal.rejectionForm.$invalid class=\"btn btn-primary-action\">Submit</button><!--  <button type=\"submit\" ng-click=\"Modal.rejectTransaction()\" class=\"btn btn-primary-action\">Submit</button>--></form></div></div>");
$templateCache.put("app/components/modal/initiateTransaction/success.modal.html","<div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><i class=success-icon></i><h6>Submitted successfully</h6><p ng-if=\"Modal.modalData.transactionType != \'Change Dividend Option\' && Modal.modalData.transactionType != \'DTP\' && Modal.modalData.transactionType != \'BULK_SIP\' && !Modal.modalData.isFromQuickSip\">You have successfully initiated a {{Modal.modalData.transactionType}} transaction for<br>{{Modal.modalData.investorName}}.</p><p ng-if=\"Modal.modalData.transactionType != \'Change Dividend Option\' && Modal.modalData.transactionType == \'DTP\'\">You have successfully initiated a TIP transaction for<br>{{Modal.modalData.investorName}}.</p><p ng-if=\"Modal.modalData.transactionType == \'Change Dividend Option\'\">You have successfully initiated Change IDCW Option transaction for<br>{{Modal.modalData.investorName}}.</p><p ng-if=\"Modal.modalData.transactionType == \'BULK_SIP\'\">You have successfully initiated Bulk SIP transaction.</p><p ng-if=Modal.modalData.isFromQuickSip>SIP for the selected folio have been successfully sent to the investor for their approval.</p><button type=submit ng-click=Modal.continue() class=\"btn btn-primary-action\">OK</button></div></div>");
$templateCache.put("app/components/modal/investorApproval/investmentSuccess.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper\"><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><h3 class=submit-success><i class=success-icon></i><span>Done</span></h3><p class=submit-success-notify>You have successfully intiated the investment.<br>Thanks for investing with HDFC MFOnline.</p><!-- Folio Approval--TODO: DO NOT DELETE--><!--<h3 class=\"submit-success\"><i class=\"success-icon\"></i><p>Submission Successful</p></h3>--><!--<p class=\"submit-success-notify\">You have details used in the FOLIO creation and same<br/> will be used for future investment</p>--> <button type=button class=\"btn btn-primary-action btn-center mg40\">Ok</button></div></div>");
$templateCache.put("app/components/modal/investorApproval/rejectionApproval.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper rejection-approval\"><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><p class=submit-success-notify ng-bind-html=Modal.modalData.msg>Are you sure, you want to reject<br>\'Folio Creation?\'</p><!--\n    <p class=\"submit-success-notify\">Are you sure, you want to approve<br/>\n      \'Lumpsum Investment?\'</p>--><!-- Folio Rejection--TODO: DO NOT DELETE--><!--<p class=\"submit-success-notify\">Are you sure, you want to reject<br/>--><!--\'Folio Creation?\'</p>--><!--<p class=\"submit-success-notify\">Are you sure, you want to approve<br/>--><!--\'Folio Creation?\'</p>--><div class=clearfix><button type=button class=\"btn btn-secondary-action pull-left mg40\" ng-click=Modal.dismissModal();>No</button> <button type=button class=\"btn btn-primary-action pull-right mg40\" ng-click=Modal.closeModal();>Yes</button></div></div></div>");
$templateCache.put("app/components/modal/investorApproval/rejectionReason.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper rejection-reason\"><i class=times-icon ng-click=Modal.dismissModal();></i><h3 class=align-left>Reason for rejection</h3><div class=input-normal><input autocomplete=off type=text name=reason ng-model=Modal.formData.reason required> <span class=highlight></span> <span class=bar></span><label ng-if=\"Modal.modalData.type!=\'folioRejection\'\">Please write the reason for rejecting investment..</label><label ng-if=\"Modal.modalData.type==\'folioRejection\'\">Please write the reason for rejecting folio..</label><label ng-if=\"Modal.modalData.type==\'bankRejection\'\">Please write the reason for rejecting..</label><!-- Folio Approval--TODO: DO NOT DELETE--><!--<label>Please write the reason for rejectiong folio...</label>--> <span class=support-text>This will be shared with your distributor to help you better</span></div><button type=button class=\"btn btn-primary-action btn-center mg40\" ng-disabled=!Modal.formData.reason ng-click=Modal.closeModal();>Ok</button></div></div>");
$templateCache.put("app/components/modal/investorLinkStatus/investorLinkStatus.modal.html","<div class=modal-content><div class=modal-header><h4 class=modal-title>Warning!!</h4><!-- <i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i> --></div><div class=modal-body><h5 class=maintxt>A duplicate prospect folio link with the same investor already initiated. Do you want to continue ?</h5></div><div class=modal-footer style=text-align:center><button class=\"btn btn-primary-action\" ng-click=Modal.yes()>Yes</button> <button class=\"btn btn-secondary-action\" ng-click=Modal.no()>No</button></div></div><style>.maintxt{\n    font-size: 1rem;\n}</style>");
$templateCache.put("app/components/modal/investorStatement/investorStatement.modal.html","<!-- Sign up Completed--><div ng-if=!Modal.successFlag class=modal-content id=sendStatement ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><h4 class=modal-title>Generate Statement</h4><form autocomplete=off autocomplete=off name=statementForm ng-submit=Modal.sendStatement() novalidate><p><strong>Select Folio</strong></p><i class=times-icon ng-click=Modal.dismissModal();></i><div class=row><div class=\"col-md-12 folios\"><span class=radio-block ng-repeat=\"folio in Modal.folioList\"><span class=radio><input type=radio id=folio-{{$index}} name=selectFolioType class=\"ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=Modal.selectedFolioNo ng-value=folio.folioNo aria-invalid=false required> <span class=check></span></span><label for=folio-{{$index}}>Folio #{{folio.folioNo}}</label></span></div></div><div class=row><div class=col-md-12><p><strong>Select Statement</strong>{{Modal.buttons[Modal.statement].value}}</p><div class=statements ng-repeat=\"button in Modal.buttons\"><span class=radio-block><span class=radio><input type=radio id=capital-gain-{{$index}} name=statement-button ng-model=Modal.statement ng-value=button.key required> <span class=check></span></span><label for=capital-gain-{{$index}} ng-bind=button.value></label></span></div></div></div><hr><div class=form-footer><button type=submit ng-disabled=statementForm.$invalid class=\"btn btn-primary-action pull-right\">Send</button> <button type=button ng-disabled=statementForm.$invalid ng-if=\"Modal.statement==\'accountStatement\'\" class=\"btn btn-primary-action pull-right mgr10\" ng-click=Modal.downloadReport()>Download</button></div></form></div></div><div ng-if=Modal.successFlag class=modal-content id=sendStatementSuccess ng-init=Modal.init()><div class=\"modal-body statement-success\"><p class=\"text-center sent-success\"><i class=success-icon></i>Sent Successfully</p><p class=text-center ng-bind=Modal.successMessage></p><hr><div class=form-footer><button class=\"btn btn-primary-action pull-right\" ng-click=Modal.dismissModal();>Ok</button></div></div></div>");
$templateCache.put("app/components/modal/leapAcademyRegister/leapacademy-agenda.modal.html","<div class=modal-content><div class=modal-header><h4 class=modal-title>{{Modal.name}}</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation session-details\"><p ng-bind-html=Modal.agenda></p></div></div>");
$templateCache.put("app/components/modal/leapAcademyRegister/leapacademy-register.modal.html","<div class=modal-content id=registerLeap><div class=modal-header><h4 class=modal-title>Register</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper ng-scope\"><h5>Do you want to confirm your registration for {{Modal.name}} ?</h5><button class=\"btn btn-primary-action\" ng-click=Modal.registerTrainingClass();>Yes</button> <button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal();>No</button></div></div>");
$templateCache.put("app/components/modal/leapAcademyRegister/leapacademy-success.modal.html","<div class=modal-content id=registerLeap><div class=modal-header><h4 class=modal-title>Register</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=\"modal-body form-wrapper ng-scope\"><h5>Your request for registration has been sent to your registerd branch.</h5></div></div>");
$templateCache.put("app/components/modal/leapAcademyRegister/leapacademy-video.modal.html","<div class=modal-content id=leapVideo><div class=\"modal-body form-wrapper ng-scope\"><i class=times-icon ng-click=Modal.dismissModal();></i><!--<video controls=\"true\">\n      <source src=\"https://www.youtube.com/watch?v=y3UH2gAhwPI&html5=True\" type=\"video/mp4\">\n      &lt;!&ndash;<source src=\"https://youtu.be/od0FVqbnh9c\" type=\"video/mp4\">&ndash;&gt;\n      Your browser does not support the video tag.\n    </video>--><iframe width=570 height=315 ng-src={{Modal.modalData.url}} frameborder=0 allowfullscreen></iframe></div></div>");
$templateCache.put("app/components/modal/logoUpload/logoUpload.modal.html","<!--   Modals welcome\n    -------------------------><div class=modal-content id=welcomeModal ng-init=Modal.init();><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><i class=times-icon ng-click=Modal.dismissModal(); role=button tabindex=0></i><h1>Welcome to HDFC MFOnline - Partners.</h1><p class=info>An empowering platform piloting all your investor’s related investments<br>efficiently. Upload your brand logo till we prepare your dashboard.</p><!--<droplet-upload-single ng-model=\"interface\"></droplet-upload-single>--><div class=logo-upload><img id=showingImgId ng-if=Modal.myFile class=logo-uploaded> <span class=upload-img-icon></span><p>Drag and drop your logo here to upload<br>or</p><span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.png file-model=Modal.myFile targetimg=showingImgId> <span class=\"btn btn-secondary-action\">Browse..</span><div class=upload-preview><img src=\"\"></div></span></div><p class=text-center>only .png file are allowed as logo upload.</p></div><div class=modal-footer><h5 class=\"col-md-3 col-md-offset-4\" tabindex=1 ng-click=Modal.dismissModal()>Skip this for now</h5><h5 class=pull-right ng-click=Modal.uploadFile() ng-if=Modal.myFile>Next <span class=arrow-short-right-icon></span></h5><h5 class=\"pull-right t-grey\" ng-if=!Modal.myFile>Next</h5></div></div><style>#showingImgId+span.upload-img-icon{\n        opacity:0;}</style><!--   Modals welcome\n---------------------^^^^^---->");
$templateCache.put("app/components/modal/modifyBank/addSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><div class=modal-body><!--    <i class=\"times-icon\" ng-click=\"Modal.dismissModal();\" ng-if=\"Modal.modalData.fromUpdateBankDistributor\"></i>--> <i class=times-icon ng-click=Modal.dismissModal(); ui-sref=\"main.investors.profile.basicinfo({investorId : Modal.investorId})\" ng-if=!Modal.modalData.fromUpdateBankDistributor></i><div class=text-center><i class=verify-icon></i></div><p ng-if=!Modal.modalData.fromUpdateBankDistributor>{{Modal.modalData.responseData.message}}</p><p class=bold ng-if=Modal.modalData.fromUpdateBankDistributor>{{Modal.modalData.responseData}}</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/modifyBank/changeDefaultBank.modal.html","<div class=\"modal-content deleteBank\" id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-head><strong>Change Default Bank</strong></div><div class=modal-body><p>Folio No: <span class=blackIt>{{Modal.folioId}}</span></p><div ng-repeat=\"banks in Modal.bankDetails\"><div class=radio-block ng-if=!banks.defaultBank><span class=radio><input name=changeDefaultCheck ng-model=Modal.selectedModifyBank ng-value=banks ng-change=Modal.changeModifyDefaultBank(banks) type=radio> <span class=check></span> </span><span class=radio-label>{{banks.bankName}} <span class=info-primary>({{banks.accountNumber}})</span><!--<span ng-if=\"Modal.selectedDefault === $index\" class=\"info-primary\">(Default)</span> --></span></div></div><!--<div class=\"col-md-12\">\n      <div class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\"/>\n            <span class=\"check\"></span>\n          </span>\n        <span class=\"radio-label\">Bank 2</span>\n      </div>\n    </div>\n    <div class=\"col-md-12\">\n      <div class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\"/>\n            <span class=\"check\"></span>\n          </span>\n        <span class=\"radio-label\">Bank 3</span>\n      </div>\n    </div>--><div class=text-center><button class=\"btn btn-secondary-action\" ng-click=Modal.closeModal()>Cancel</button> <button ng-disabled=!Modal.selectedModifyBank class=\"btn btn-primary-action\" ng-click=Modal.submitModifyDefaultBank()>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/changeSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><div class=modal-body><div class=text-center><i class=verify-icon></i></div><p>{{Modal.modalData.changeModifyResponse.message}}</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/modifyBank/deleteBank.modal.html","<div class=\"modal-content deleteBank\" id=initiateTransactionMsg><div class=\"loader deleteBank-loader\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-head><h3>Delete Bank</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p>Folio No: <span class=blackIt>{{Modal.folioId}}</span></p><div ng-repeat=\"banks in Modal.bankDetails\"><div class=radio-block ng-if=!banks.defaultBank><!-- ng-class=\"{\'anything-disabled\':$index === 0}\" --> <span class=radio><input name=deleteBankCheck ng-value=banks type=radio ng-model=Modal.selectedDeleteBank ng-change=Modal.changeDeleteBank(banks)> <span class=check></span> </span><span class=radio-label>{{banks.bankName}}<label easyassist-key=mask-element>({{banks.accountNumber}})</label></span><!--<span ng-if=\"$index === 0\" class=\"info-primary\"> (Default) </span>--></div></div><div class=\"row form-grid upload-some\"><p><strong>Upload Default Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of default bank to validate bank details.\"></i> </strong></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"Modal.fileType === \'tif\' || Modal.fileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"Modal.downloadFile(Modal.deleteBank.payload.chequeLeaf,Modal.fileType,\'chequeLeaf\')\">Download</a></span><div class=pos-delete><span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=Modal.myFile targetimg=showingImgId upload=Modal.uploadFile(file)><label for=uploadFileId class=\"btn-upload btn-secondary-action choose-label\">{{Modal.fileType ?\'Change\':\'CHOOSE FILE\'}}</label></span><span class=no-file-chosen ng-if=!Modal.deleteBank.payload.chequeLeaf>No File Chosen</span></div><span class=\"file-name text-blue\" ng-if=\"Modal.fileType == \'jpg\' ||  Modal.fileType == \'jpeg\'\" ng-click=\"Modal.openUploadedDoc(Modal.deleteBank.payload.chequeLeaf,\'new\')\">{{Modal.chequeLeaf}}</span></div></div></div><p class=\"error-msg message-margin\">Please upload the cheque leaf on behalf of your investor. In case not available, your investor should be able to upload the same on the system generated smart link and you may proceed to initiate a bank deletion request for your investor.</p><p class=error-msg>You can delete default bank only by making another bank as default for this folio.</p><p></p><div class=\"modal-multiple-action text-center\"><button type=button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>Cancel</button> <button ng-disabled=\"!Modal.selectedDeleteBank || Modal.chooseAFile\" class=\"btn btn-primary-action\" ng-click=Modal.submitDeleteBank()>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/modifyBank/deleteSuccess.modal.html","<div class=\"modal-content modifyBank\" id=initiateTransactionMsg><div class=modal-body><i class=times-icon ng-click=Modal.dismissModal();></i><div class=text-center><i class=verify-icon></i></div><p>{{Modal.modalData.deleteMessage.message}}</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/modifyBank/rejectTransaction.modal.html","<!-- Reject Transaction--><div class=modal-content id=rejectTransaction><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><h6>Please specify reason for Rejection</h6><form name=Modal.rejectionForm ng-submit=Modal.rejectConfirm() novalidate><div class=\"group input-normal\" ng-class=\"{error:Modal.rejectionForm.comments.$dirty && Modal.rejectionForm.comments.$invalid}\"><textarea id=comments rows=5 ng-model=Modal.comments name=comments placeholder=\"Enter reason...\" required></textarea><span ng-show=\"Modal.rejectionForm.comments.$dirty && Modal.rejectionForm.comments.$invalid\"><span class=error-input ng-show=Modal.rejectionForm.comments.$error.required ng-bind=Modal.validateData.REASON_REQUIRED></span></span></div><button type=submit ng-disabled=Modal.rejectionForm.$invalid class=\"btn btn-primary-action\">Submit</button></form></div></div>");
$templateCache.put("app/components/modal/newInvestorDirection/newInvestorDirection.modal.html","<div class=modal-content id=disclaimerPopups><h5>Important Information</h5><div class=modal-body><div style=\"width: 100%\" class=selections><div><input type=radio name=switch-radio1 ng-model=Modal.selectAction value=0> <span>Create New folio</span></div><div ng-if=\"Modal.modalData.userStatus == \'EXISTING\'\"><p style=\"color: red\"></p></div><div ng-if=\"Modal.modalData.userStatus == \'NEW\'\"><input type=radio name=switch-radio1 ng-model=Modal.selectAction value=1> <span>Folio request with Transaction</span></div></div><div style=\"display: flex;padding: 35px\"><button class=\"btn btn-primary-action btn-center\" ng-if=\"Modal.modalData.userStatus == \'NEW\'\" ng-click=Modal.closeModal()>Ok</button> <button class=\"btn btn-primary-action btn-center\" ng-if=\"Modal.modalData.userStatus == \'EXISTING\'\" ng-click=Modal.closeModal()>Proceed</button> <button class=\"btn btn-primary-action btn-center\" ng-if=\"Modal.modalData.userStatus == \'EXISTING\'\" ng-click=Modal.closeModal()>Cancel</button></div></div></div>");
$templateCache.put("app/components/modal/newInvestorOtpVerify/newInvestorOtpVerify.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Investor OTP Verification</h4><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body><form autocomplete=off name=Modal.otpForm autocomplete=off ng-submit=Modal.confirmTransaction() novalidate><p class=info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div class=\"group input-normal\" ng-if=Modal.transactionType><input type=text name=panNumber ng-model=Modal.panNumber ng-pattern=/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/ maxlength=10 minlength=10 required autocomplete=off capitalize><label>Enter PAN Number<span class=req>*</span></label><span ng-if=\"Modal.otpForm.panNumber.$dirty && Modal.otpForm.panNumber.$invalid\"><span class=error-input><span ng-show=Modal.otpForm.panNumber.$error.required ng-bind=Modal.validateData.PAN_REQUIRED></span> <span ng-show=\"Modal.otpForm.panNumber.$invalid && Modal.otpForm.panNumber.$viewValue\" ng-bind=Modal.validateData.INVALID_PAN></span></span></span></div><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-pattern=Modal.appConstants.otp_regex ng-model=Modal.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Enter OTP<span class=req>*</span></label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.pattern>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\" ng-show=Modal.isOtpValid><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=javascript:void(0) ng-click=Modal.resendOtp() class=pull-right ng-disabled=Modal.isProcessing>Resend OTP</a> <a ng-show=\"countdown > 0\" style=\"float:right;font-size: 12px !important\">Enable Resend OTP in {{countdown}}s</a></timer></div></div><button type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.isProcessing || !Modal.isOtpValid\" class=\"btn btn-primary-action btn-block\">Submit</button></form></div></div>");
$templateCache.put("app/components/modal/newjourneyfoliocondition/newjourneyfoliocondition.modal.html","<div class=modal-content><div class=modal-body><div class=\"clearfix folio-num text-center\"><div><div class=row ng-if=\"Modal.modalData.investorType == \'oldUser\'\"><div class=\"col-md-12 mb-3\" style=padding:20px><p class=\"investmentTitle col-md-12\">Do you want to create Additional Folio?</p></div><br><button class=btn-new-journey-color ng-click=Modal.searchInvestor();>OK</button> <button class=btn-new-journey-color ng-click=Modal.closeModal();>Cancel</button></div></div><div><!-- <div class=\"row\" ng-if=\"Modal.modalData.investorType == \'newUser\'\">\n          <div class=\"col-md-12\" style=\"padding:20px;\">\n            <div class=\"radio-block col-md-6\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"onlyFolioReguest\" ng-model=\"Modal.foliotype\" ng-value=\"false\"\n                  name=\"onlyFolioReguest\" required>\n                <span class=\"check\"></span>\n              </span>\n              <label for=\"onlyFolioReguest\" style=\"top:-14px;\">Only Folio Request</label>\n            </div>\n            <div class=\"radio-block col-md-6\">\n              <span class=\"radio\">\n                <input type=\"radio\" id=\"foliowithtransaction\" ng-model=\"Modal.foliotype\" ng-value=\"true\"\n                  name=\"foliowithtransaction\" required />\n                <span class=\"check\"></span>\n              </span>\n              <label for=\"foliowithtransaction\" style=\"top:-14px;\">Send Folio Request with Transaction</label>\n            </div>\n          </div>\n          <button class=\" btn-new-journey-color\" ng-click=\"Modal.folioTypeData();\">OK</button>\n          <button class=\" btn-new-journey-color\" ng-click=\"Modal.closeModal();\">Cancel</button>\n        </div> --></div></div></div></div><style>.btn-new-journey-color {\n    width: 163px;\n    height: 35px;\n    border-color: transparent;\n    background-color: #FF8486;\n    border-radius: 15px;\n  }</style>");
$templateCache.put("app/components/modal/newjourneyfolioselection/newJourneyFolioSelection.modal.html","<div class=modal-content id=register-done><div class=modal-header><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off><ng-bind-html dynamic=Modal.modalData.message.content></ng-bind-html></form></div></div><style>.d-flex-center{\n      display:flex;\n      justify-content: center;\n    }\n    .modal-content .modal-header:before{\n      background-color: transparent;\n    }\n    .modal-header{\n      border-bottom: none;\n    }\n    .modal-content .modal-body{\n      padding: 20px 15px;\n    }</style>");
$templateCache.put("app/components/modal/newjourneyfolioswitch/newJourneyFolioSwitch.modal.html","<div class=popup ng-if=!Modal.modalData.kycStatusMisMatched><div class=popupIcon><img src=../../../../assets/images/note-icon.svg></div><div class=popupNote><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You have unsaved changes which will lead to</p><p class=f-w-100>loss of information provided.</p><p class=f-w-100>Are you sure you want to proceed?</p></div><div class=btnDiv><button class=popupBtn type=button ng-click=Modal.dismissModal()>No</button> <button class=popupBtn type=button ng-click=Modal.closeModal()>Yes</button></div></div><div class=popup ng-if=Modal.modalData.kycStatusMisMatched><div class=\"popupIcon popupIconView\"><img src=../../../../assets/images/note-icon.svg></div><div class=popupNote><p style=\"font-weight: bold\">Please note:</p><p class=f-w-100>You already have a saved request to create a folio with<br>{{Modal.modalData.nriTaxStatus}} tax status.</p><p class=f-w-100>Click \"Yes\" to proceed further or click \"No\" to be</p><p class=f-w-100>redirected to the drop journey</p></div><div class=btnDiv><button class=popupBtn type=button ng-click=Modal.closeModal()>Yes</button> <button class=popupBtn type=button ng-click=Modal.dismissModal()>No</button></div></div><style>.popup{\n      /* border-radius: 20px; */\n      background: rgb(255 255 255);\n      box-shadow: 0px 2px 14px rgb(18 66 101 / 30%);\n      color: black;\n      top: -90px;\n      left: 0;\n       display: flex;\n      justify-content: center;\n      align-items: center;flex-direction: column;\n    }\n    .btnDiv{\n      width: 50%;\n      padding: 30px;\n      display: flex;\n      justify-content: space-evenly;\n      align-items: center;\n    }\n    .popupBtn{\n        width: 100px !important;\n        border-radius: 15px;\n        height: 30px;\n        color: white;\n        border: none;\n        background: #244b8c;\n    }\n    .popupIcon{\n      /* height: 100px; */\n      /* width: 100px; */\n      margin-top: 50px;\n      /* margin-bottom: 20px; */\n    }\n    .popupIconView {\n      height: 100px;\n      width: 100px;\n      margin-top: 50px;\n      margin-bottom: 20px;\n    }\n    .f-w-100{\n      font-weight: 100;\n    }\n    .popupNote{\n      margin: 20px;\n      width: 390px;\n      line-height: 26px;\n      font-size: 16px;\n      display: flex;\n      justify-content: center;\n      font-family: \"Open Sans\", sans-serif;\n      color: rgb(68 68 68);\n      align-items: center;\n      text-align: center;\n      flex-direction: column;\n    }</style>");
$templateCache.put("app/components/modal/nfoEnabled/nfoEnabled.modal.html","<div class=modal-content id=disclaimerPopups><h5>Important Information</h5><div class=modal-body><div class=imp-info style=\"width: 100%\"><p>{{Modal.modalData.message}}</p></div><button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/nfoTransactionNotes/nfoTransactionNotes.modal.html","<div class=modal-content id=disclaimerPopups><h5>Important Information</h5><div class=modal-body><div class=transaction-notes><div class=tab-body><div class=\"point-to-note imp-info\" style=\"width: 100% !important\"><p><i class=dot></i> <span>STP during NFO would be available only under FSTP option. The first installment for STP application received for monthly / quarterly frequency would be processed on the allotment date irrespective of the transfer date opted by the investor. However, subsequent transfers would be processed on the date opted by the investor.<br>In respect of STP instalments for daily and weekly frequencies falling upto the NFO allotment date, STP-out will be processed as per the Applicable NAV of Transferor Scheme on the relevant instalment dates. However, STP-into the new scheme will be processed on the NFO allotment date.<br>The STP installments under Daily and Weekly frequencies falling between the NFO allotment date and scheme re-opening date, will be processed on the scheme re-opening date at applicable NAVs of Transferor and Transferee Scheme.</span></p><p><i class=dot></i> <span>Applications received under FSTP during NFO would be accepted only upto 1 day prior to NFO closure date. For applications submitted on the last day of the NFO, the STP would commence post reopening of scheme, on the installment date chosen by the investor.</span></p><p><i class=dot></i> <span>HDFC Mutual Fund/ AMC may from time to time add/ alter/ amend the rules for processing STP applications during NFO. HDFC Mutual Fund/ AMC has the right to process applications received during the NFO in a manner it may deem fit and has the right to reject any application.</span></p></div></div></div><button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/nonOtm/nonOtm.modal.html","<div class=modal-content id=transSum><div class=modal-header><h4 class=modal-title>Folio No: <strong>{{Modal.folioNumber}}</strong></h4></div><div class=modal-body><table class=\"table borderless\"><tr><td>Email:</td><td>{{Modal.email||\'--\'}}</td></tr><tr><td>Phone:</td><td>{{Modal.mobileNumber||\'--\'}}</td></tr><tr><td>Name:</td><td>{{Modal.folioHolderName||\'--\'}}</td></tr></table><div class=text-center><button class=\"btn-primary-action btn\" ng-click=Modal.closeModal();>OK</button></div></div></div>");
$templateCache.put("app/components/modal/notification/notification.modal.html","<div class=modal-content ng-init=Modal.init()><div class=modal-header><h4 class=modal-title>Notification Details</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table borderless\"><tr><td>Created Date :</td><td>{{Modal.notificationDetails.createdDate}}</td></tr><tr><td>Title :</td><td>{{Modal.notificationDetails.title}}</td></tr><tr><td>Description :</td><td>{{Modal.notificationDetails.description}}</td></tr></table></div></div>");
$templateCache.put("app/components/modal/nudgeReasons/nudgeReasons.modal.html","<div class=\"modal-content modal-nudge-reasons\" ng-if=\"Modal.reasonsList.length > 0\"><div class=\"modal-body form-wrapper ng-scope\"><div><span class=bold>{{Modal.modalData.Text}}</span> <i class=times-icon ng-click=Modal.dismissModal();></i></div><br><div class=\"form-group nudge-popup\" ng-if=Modal.showSipNudge><div class=radio-block style=\"display: block; margin-bottom: 0.5rem\" ng-repeat=\"reasons in Modal.reasonsList\"><span class=radio><input type=radio name=nudgeReason ng-value=reasons.reasonCode ng-model=Modal.nudgeReasonCode ng-change=Modal.nudgeReasonChange(reasons)> <span class=check></span> </span><span class=radio-label>{{reasons.reasonDetail}}</span></div></div><div ng-if=\"Modal.nudgeReason === \'Others\'\"><textarea name=nudgeOtherReason style=\"width: 100%; resize: none\" rows=4 placeholder={{Modal.placeHolderText}} ng-model=Modal.nudgeOtherReason ng-attr-maxlength={{Modal.maxLength}}></textarea></div><br><br><div class=\"modal-multiple-action text-center\"><button class=\"btn btn-primary-action\" ng-disabled=\"!Modal.nudgeReason || (Modal.nudgeReason ===\'Others\' && !Modal.nudgeOtherReason)\" ng-click=Modal.initiateCancel($event) ng-if=Modal.modalData.buttonProceed>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/offlineNominee/offlineNomineeForm.modal.html","<div class=modal-content><div class=\"modal-body form-wrapper ng-scope\"><div class=offline-nominee-modal><div class=offline-form-msg>{{Modal.modalData.message}} <a href=https://files.hdfcfund.com/s3fs-public/2020-07/MF-Nomination%20Form.pdf target=_blank style=\"color: blue\">Click here</a></div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.dismissModal()>OK</button></div></div></div></div>");
$templateCache.put("app/components/modal/optOutModal/optOutNominee.modal.html","<div class=modal-content id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p ng-bind-html=Modal.modalData.text></p><button type=submit ng-click=Modal.closeModal() class=\"btn btn-primary-action\" style=\"background: #1b4b86\">{{Modal.modalData.ctaText}}</button></div></div>");
$templateCache.put("app/components/modal/optOutModal/optOutSearchNominee.html","<div class=\"modal-content opt-outNominee\" id=initiateTransactionMsg><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-header><h4 class=modal-title>Important Notification</h4><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i></div><div class=modal-body><p class=imp-msg><ng-bind-html dynamic=Modal.modalData.message></ng-bind-html></p><!--<p>Please nominate or opt-out of nomination for following folios.</p>--><div class=dashboard><div class=\"list scheme-table\" ng-class=\"{\'overflow-height\' : Modal.modalData.folioList.length > 2}\"><table class=\"table table-bordered\"><thead><tr><th class=text-center>SRN</th><th class=text-center>Folio</th></tr></thead><tbody><tr ng-repeat=\"folio in Modal.modalData.folioList track by $index\"><td>{{$index + 1}}</td><td>{{folio}}</td></tr></tbody></table></div></div><br><button id=continueBtn class=\"btn btn-primary-action btn-center vim\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/otp/otp.modal.html","<!-- Otp verification--><div class=modal-content id=confirm-otp><div class=\"modal-body clearfix\"><i class=times-icon ng-click=Modal.dismissModal();></i><form autocomplete=off name=modalOtpForm ng-submit=Modal.verifyOtp() novalidate><p class=text-center style=\"margin-bottom: 25px\">{{Modal.modalData.respMessage || \'We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.\'}}<br></p><div class=\"input-group input-normal\" style=\"width: 100%; margin-top: 10px;margin-bottom: 20px\" ng-class=\"{error:modalOtpForm.otpNumber.$dirty && modalOtpForm.otpNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=Modal.formData.otpNumber name=otpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP 1</label><span class=error-input style=\"position: initial !important\" ng-messages=modalOtpForm.otpNumber.$error ng-show=modalOtpForm.otpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p ng-if=Modal.modalData.newEmailId style=\"padding: 12px 0\">OTP 1 sent to your registered email ID (<span easyassist-key=mask-element ng-if=Modal.modalData.currEmail>{{ Modal.modalData.currEmail }} </span><span ng-if=\" !Modal.modalData.currEmail\">Not Available</span>) and mobile number (<span easyassist-key=mask-element ng-if=Modal.modalData.currMobileNumber>{{Modal.modalData.currMobileNumber}} </span><span ng-if=!Modal.modalData.currMobileNumber>Not Available</span>).</p><p ng-if=Modal.modalData.newMobileNumber style=\"padding: 12px 0\">OTP 1 sent to your registered email ID <span easyassist-key=mask-element ng-if=Modal.modalData.currEmail>({{ Modal.modalData.currEmail}} )</span> <span ng-if=!Modal.modalData.currEmail>(Not Available)</span> and mobile number (<span easyassist-key=mask-element ng-if=Modal.modalData.currMobileNumber>{{Modal.modalData.currMobileNumber}} </span><span ng-if=!Modal.modalData.currMobileNumber>Not Available</span>).</p></div><div class=\"input-group input-normal\" style=\"width: 100%; margin-top: 10px;margin-bottom: 20px\" ng-class=\"{error:modalOtpForm.newOtpNumber.$dirty && modalOtpForm.newOtpNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=Modal.formData.newOtpNumber name=newOtpNumber is-number ng-change=Modal.resetValues() required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP 2</label><span class=error-input style=\"position: initial !important\" ng-messages=modalOtpForm.newOtpNumber.$error ng-show=modalOtpForm.newOtpNumber.$dirty><span ng-message=required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span ng-message=minlength ng-bind=Modal.validateData.OTP_FIELD></span> <span ng-message=maxlength ng-bind=Modal.validateData.OTP_FIELD></span></span><p ng-if=Modal.modalData.newEmailId style=\"padding: 13px 0\">OTP 2 sent to new email ID (<span easyassist-key=mask-element>{{Modal.modalData.newEmailId}}</span>) entered.</p><p ng-if=Modal.modalData.newMobileNumber style=\"padding: 13px 0\">OTP 2 sent to new mobile number (<span easyassist-key=mask-element>{{Modal.modalData.newMobileNumber}}</span>) entered.</p><span class=forgot><timer countdown=Modal.appConstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=Modal.resendOtp() class=forgot-pwd style=\"transform: translateY(-12px)\">Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\" style=\"transform: translateY(25px)\">Enable Resend OTP in {{countdown}}s</a></timer></span></div><div class=text-center><button type=submit ng-disabled=\"modalOtpForm.$invalid || Modal.processFlag || Modal.errorMessage\" class=\"btn btn-primary-action\">Submit</button></div><!--<div ng-if=\"Modal.otpResendMessage\" class=\"form-group text-center text-blue\" style=\" margin-top:20px;\">{{Modal.otpResendMessage}}</div>--> <span class=error ng-if=Modal.errorMessage><span class=error-all-message>{{ Modal.errorMessage }}</span></span></form></div></div><style>.input-normal label {\n    transition: all 0.2s ease !important;\n  }\n  .modal-body .input-normal .ng-not-empty ~ label, .ng-empty ~ label {\n    font-size: 12px !important;\n  }\n  .forgot timer a {\n    float: right;\n    font-size: 12px !important;\n    padding: 0 !important;\n  }</style>");
$templateCache.put("app/components/modal/popups/minor.bank.html","<!--dynamic data minor bank modal--><ng-bind-html ng-if=Modal.modalData.dynamicDataPopup.Popup_MINOR_BANK dynamic=Modal.modalData.dynamicDataPopup.Popup_MINOR_BANK.content></ng-bind-html><!--dynamic data minor bank modal FLEX SIP --><ng-bind-html ng-if=Modal.modalData.dynamicDataPopup.FLEX_Popup_MINOR_BANK dynamic=Modal.modalData.dynamicDataPopup.FLEX_Popup_MINOR_BANK.content></ng-bind-html>");
$templateCache.put("app/components/modal/popups/minor.purchase.modal.html","<!--dynamic data minor purchase modal--><ng-bind-html dynamic=Modal.modalData.dynamicDataPopup.content></ng-bind-html>");
$templateCache.put("app/components/modal/popups/minor.sip.modal.html","<!--dynamic data minor sip modal--><div class=minor-popup><ng-bind-html dynamic=Modal.modalData.dynamicDataPopup.content></ng-bind-html></div>");
$templateCache.put("app/components/modal/purchaseSchedulerRecomendation/purchaseSchedulerRecomendationModal.html","<div class=modal-content><div style=\"background-color: #F3F9FF;padding: 12px; border-radius: 15px\"><div style=\"display: flex;justify-content: space-between\"><p class=mt7><b>All Schemes</b></p><div style=\"display: flex;justify-content: space-between\"><p class=mt7>Scheme Category</p><select class=select-cnt ng-model=Modal.schemeCategory ng-change=Modal.changeSchemeCategory()><option value=\"\" selected>Category</option><option ng-repeat=\"list in Modal.CategoryList\" ng-if=\"list && list !=null && list !=\'\' && list != \'undefined\'\" value={{list}}>{{list}}</option></select><img src=../../../../assets/images/icons/times.png ng-click=Modal.dismissModal(); alt=\"\" srcset=\"\" style=\"height: 15px;margin-top: 7px\"></div></div></div><br><div><div class=row style=\"margin-left: 0px\"><div class=\"col-md-8 col-sm-10\" style=\"padding: 0px 0px\"><input class=\"form-control search-fund\" type=text name=searchscheam id=searchscheam placeholder=&nbsp;&nbsp;&nbsp;Search... ng-model=Modal.filterwithname ng-change=Modal.changewithFilterName() style=\"height: 40px;width: 80%\"></div></div></div><br><div><div class=row ng-repeat=\"fundData in Modal.recFund\" style=\"border-bottom: 1px solid gray;margin: 0px 0px 15px 0px;padding: 10px 0px 15px 0px\"><div class=col-md-3><div><p class=rec>Recommended</p><p><b>{{fundData.fundName}}</b></p></div></div><div class=col-md-3><p>Select scheme</p><!-- <select class=\"selectController\" ng-model=\"Modal.schemeData\" ng-change=\"Modal.changeScheme(fundData.fundCode)\"> --><!-- <option value=\"\">Select scheme</option>\n                    <option ng-repeat=\"scheme in fundData.schemes\" value=\"{{scheme}}\">{{scheme.scheme}}</option> --><select class=selectController name=schemeCategory ng-model=fundData.schemeData ng-options=\"scheme.schemeName for scheme in fundData.schemes\" ng-change=Modal.changeScheme(fundData.fundCode,fundData.schemeData)><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-md-2 navtab\"><p>NAV ({{fundData.navDateTimestamp}})</p><p style=\"margin-top: 10px\"><b>{{fundData.navValue}}</b></p></div><div class=col-md-2 style=\"padding-right: 0px\"><p>Riskometer <img class=base-tooltip src=../../../../assets/images/info-icon.svg style=\"height: 15px\" tooltip data-html=true data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<img src=\'{{fundData.riskmeter}}\'>\"></p><div style=\"display: flex\"><img src={{fundData.riskicon}} style=\"width: 25px\"><p style=\"margin-top: 5px\"><b>{{fundData.risk}}</b></p></div></div><div class=col-md-2><input type=button class=investButton ng-disabled=!fundData.selected value=\"Invest Now\" ng-click=Modal.investnow(fundData.schemeData)></div><hr></div><div class=row ng-repeat=\"fundData in Modal.otherFund\" style=\"border-bottom: 1px solid gray;margin: 0px 0px 15px 0px;padding: 10px 0px 15px 0px\"><div class=col-md-3><div><p><b>{{fundData.fundName}}</b></p></div></div><div class=col-md-3><p>Select scheme</p><!-- <select class=\"selectController\" ng-model=\"Modal.schemeData\" ng-change=\"Modal.changeScheme(fundData.fundCode)\"> --><!-- <option value=\"\">Select scheme</option>\n                    <option ng-repeat=\"scheme in fundData.schemes\" value=\"{{scheme}}\">{{scheme.scheme}}</option> --><select class=selectController name=schemeCategory ng-model=fundData.schemeData ng-options=\"scheme.schemeName for scheme in fundData.schemes\" ng-change=Modal.changeScheme(fundData.fundCode,fundData.schemeData)><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-md-2 navtab\"><p>NAV ({{fundData.navDateTimestamp}})</p><p style=\"margin-top: 10px\"><b>{{fundData.navValue}}</b></p></div><div class=col-md-2 style=\"padding-right: 0px\"><p>Riskometer <img class=base-tooltip src=../../../../assets/images/info-icon.svg style=\"height: 15px\" tooltip data-html=true data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<img src=\'{{fundData.riskmeter}}\'>\"></p><div style=\"display: flex\"><img src={{fundData.riskicon}} style=\"width: 25px\"><p style=\"margin-top: 5px\"><b>{{fundData.risk}}</b></p></div></div><div class=col-md-2><input type=button class=investButton ng-disabled=!fundData.selected value=\"Invest Now\" ng-click=Modal.investnow(fundData.schemeData)></div><hr></div><h5 ng-if=\"Modal.recFund.length == 0 && Modal.otherFund.length == 0\" style=\"color: red;margin-left: 30%;padding: 10px 0px 15px 0px\">Records Not Found!</h5></div></div><style>.modal-content {\n        border-radius: 15px;\n    }\n\n    .search-fund {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        background-image: url(\"/assets/images/icons/search.png\");\n        background-size: 5px;\n        background-repeat: no-repeat;\n        background-position-x: 2%;\n        background-position-y: 13px;\n        background-size: 13px;\n    }\n\n    .form-control {\n        padding: 6px 30px;\n        margin-left: 15px;\n    }\n    .selectController{\n        width: 100% !important;\n        height: 35px;\n        margin: 0px 15px 0px 0px;\n        border-radius: 7px;\n    }\n    .select-cnt {\n        width: 125px !important;\n        height: 30px;\n        margin: 0px 15px 0px 15px;\n        border-radius: 15px;\n        text-align: center;\n        background: linear-gradient(0deg, #F7F9FA, #F7F9FA),\n        linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));\n        border: 1px solid #e6e6e6;\n        text-align: left;\n    }\n\n    .mt7 {\n        margin-top: 7px;\n    }\n    .investButton{\n        height: 35px;\n        padding: 0px 24px 0px 24px;\n        border-radius: 8px;\n        background: #1B4B86;\n        color: white;\n        border: none;\n    }\n    button[disabled], html input[disabled] {\n        background: #8c8dc45c;\n        cursor: default;\n    }\n    .rec{\n        width: 140px;\n        text-align: center;\n        padding: 5px;\n        margin-bottom: 10px;\n        border-radius: 5px;\n        background: #4EAE8033;\n        color: #088b4ccf;\n;\n    }\n    .navtab{\n        padding: 0px;\n    }\n    @media screen and (max-width:550px) {\n        .navtab{\n            padding: 15px;\n        }\n    }</style>");
$templateCache.put("app/components/modal/resetPassword/changePassword.modal.html","<!--   Reset Password ----><div class=modal-content id=changePasswrdModal><div class=modal-header><h4 class=modal-title>Change Password</h4><i ng-hide=Modal.modalData.firstLogin class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.changeForm ng-submit=Modal.changePassword() novalidate><p class=\"text-center text-danger\" ng-if=\"Modal.passwordExpireMsg && Modal.passwordExpireMsg === \'Password Expired\'\">Your Password has been expired. Please change your password in the form below.</p><br><ul class=info-card><li>1) Password should be between 8 to 15 character.</li><li>2) Atleast one special character @, $, _, !</li><li>3) Atleast one Upper case letter.</li><li>4) Atleast one lower case letter.</li><li>5) Atleast one number.</li></ul><!-- <div class=\"input-normal\" ng-class=\"{error:Modal.changeForm.oldPassword.$touched && Modal.changeForm.oldPassword.$dirty && Modal.changeForm.oldPassword.$invalid}\">\n        <input name=\"oldPassword\" ng-model=\"Modal.changePasswordPayload.oldPassword\" ng-pattern=\"Modal.appConstants.password_regex\" maxlength=\"12\" type=\"password\" required autocomplete=\"off\" ng-keydown=\"Modal.copyPasteHandler($event)\">\n        <span class=\"highlight\"></span>\n        <span class=\"bar\"></span>\n        <label>Old Password</label>\n          <span ng-show=\"Modal.changeForm.oldPassword.$touched && Modal.changeForm.oldPassword.$dirty && Modal.changeForm.oldPassword.$invalid\">\n            <span class=\"error-input\" ng-show=\"Modal.changeForm.oldPassword.$error.required\" ng-bind=\"Modal.validateData.PASSWORD_REQUIRED\"></span>\n            <span class=\"error-input\" ng-show=\"Modal.changeForm.oldPassword.$error.pattern\">{{ Modal.validateData.PASSWORD_FIELD }}</span>\n            <span class=\"error-input\" ng-show=\"Modal.changeForm.oldPassword.$error.maxlength\">{{ Modal.validateData.PASSWORD_FIELD }}</span>\n          </span>\n      </div>--><div class=input-normal ng-class=\"{error:Modal.changeForm.newPassword.$touched && Modal.changeForm.newPassword.$dirty && Modal.changeForm.newPassword.$invalid}\"><input id=newPassword name=newPassword ng-model=Modal.changePasswordPayload.newPassword ng-pattern=Modal.appConstants.password_regex minlength=8 maxlength=15 type=password required autocomplete=off ng-keydown=Modal.copyPasteHandler($event) ng-change=Modal.ontextChane()> <span class=highlight></span> <span class=bar></span><label>New Password</label><span ng-show=\"Modal.changeForm.newPassword.$touched && Modal.changeForm.newPassword.$dirty && Modal.changeForm.newPassword.$invalid\"><span class=error-input ng-show=Modal.changeForm.newPassword.$error.required ng-bind=Modal.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-show=Modal.changeForm.newPassword.$error.pattern>{{ Modal.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=Modal.changeForm.newPassword.$error.maxlength>{{ Modal.validateData.PASSWORD_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Modal.changeForm.confirmPassword.$touched && Modal.changeForm.confirmPassword.$dirty && Modal.changeForm.confirmPassword.$invalid||Modal.confirmErr}\"><input name=confirmPassword ng-model=Modal.changePasswordPayload.confirmPassword type=password ng-pattern=Modal.appConstants.password_regex minlength=8 maxlength=15 required autocomplete=off ng-keydown=Modal.copyPasteHandler($event) ng-change=Modal.ontextChane()> <span class=highlight></span> <span class=bar></span><label>Confirm Password</label><span ng-show=\"Modal.changeForm.confirmPassword.$touched && Modal.changeForm.confirmPassword.$dirty && Modal.changeForm.confirmPassword.$invalid\"><span class=error-input ng-show=Modal.changeForm.confirmPassword.$error.required ng-bind=Modal.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=Modal.changeForm.confirmPassword.$error.maxlength>{{ Modal.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=Modal.changeForm.confirmPassword.$error.pattern>{{ Modal.validateData.PASSWORD_FIELD }}</span></span></div><div ng-if=Modal.confirmErr class=\"input-normal error\" style=\"text-align: center;position: static;margin-bottom: 35px\"><span class=error-input style=\"position: static\" ng-bind=Modal.confirmErr></span></div><button ng-disabled=\"changeForm.$invalid || Modal.processFlag\" class=\"btn btn-block btn-primary-action\">Submit</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/resetPassword/message.modal.html","<div class=modal-content><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><div class=text-center>{{ Modal.modalData }}</div><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Ok</button></div></div></div>");
$templateCache.put("app/components/modal/resetPassword/resetPassword.html","<login-header></login-header><div class=\"container-fluid forgot-password-container\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5\"><img class=bg-forgot-image src=assets/images/bg-reset.png class=\"height100 ng-scope\" width=100%></div><div class=\"col-xs-12 col-sm-7 col-md-7\"><div id=forgotPassModal class=forgot-container><div></div><div class=forgot-form-container><form autocomplete=off name=ResetPassword.resetForm autocomplete=off ng-submit=ResetPassword.resetPassword() novalidate><h2 class=info>Create <span class=partner-blue>New Password</span></h2><!--                <ul class=\"info-card\">--><!--                  <li>1) Password should be between 8 to 15 character.</li>--><!--                  <li>2) Atleast one special character @, $, _, !</li>--><!--                  <li>3) Atleast one Upper case letter.</li>--><!--                  <li>4) Atleast one lower case letter.</li>--><!--                  <li>5) Atleast one number.</li>--><!--                </ul>--><div class=input-normal ng-class=\"{error:ResetPassword.resetForm.newPassword.$dirty && ResetPassword.resetForm.newPassword.$invalid}\"><label>New Password<span class=req>*</span></label><i class=\"tooltip-info-icon base-tooltip\" tooltip-placement=right uib-tooltip-html=\"\'<ul><li>1) Password should be between 8 to 15 character.</li><li>2) Atleast one special character @, $, _, !</li><li>3) Atleast one Upper case letter.</li><li>4) Atleast one lower case letter.</li><li>5) Atleast one number.</li></ul>\'\"></i> <input name=newPassword ng-model=ResetPassword.resetPasswordPayload.newPassword placeholder=\"Enter New Password\" ng-pattern=ResetPassword.appConstants.password_regex minlength=8 maxlength=15 type={{ResetPassword.passwordType}} required autocomplete=off ng-trim=false><div class=input-controls><span class=inputTxt><span class=password-toggle><img src=../../../assets/images/showPass-blue.svg ng-if=\"ResetPassword.passwordType !== \'password\'\" ng-click=\"ResetPassword.showPassword(\'newPassword\')\"> <img src=../../../assets/images/blind-blue.svg ng-if=\"ResetPassword.passwordType === \'password\'\" ng-click=\"ResetPassword.showPassword(\'newPassword\')\"></span></span></div><span class=highlight></span> <span class=bar></span> <span ng-show=\"ResetPassword.resetForm.newPassword.$dirty && ResetPassword.resetForm.newPassword.$invalid\"><span class=error-input ng-show=ResetPassword.resetForm.newPassword.$error.required ng-bind=ResetPassword.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-show=ResetPassword.resetForm.newPassword.$error.maxlength>{{ ResetPassword.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=ResetPassword.resetForm.newPassword.$error.minlength>{{ ResetPassword.validateData.PASSWORD_MIN }}</span> <span class=error-input ng-show=\"ResetPassword.resetForm.newPassword.$error.pattern && !ResetPassword.resetForm.newPassword.$error.minlength\">{{ ResetPassword.validateData.PASSWORD_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:ResetPassword.resetForm.confirmPassword.$touched && ResetPassword.resetForm.confirmPassword.$dirty && ResetPassword.resetForm.confirmPassword.$invalid}\"><label>Confirm Password<span class=req>*</span></label><input name=confirmPassword ng-model=ResetPassword.resetPasswordPayload.confirmPassword placeholder=\"Re-Enter New Password\" type={{ResetPassword.confirmPasswordType}} ng-pattern=ResetPassword.appConstants.password_regex maxlength=15 required autocomplete=off ng-change=ResetPassword.updateErrorMsg() ng-trim=false><div class=input-controls><span class=inputTxt><span class=password-toggle><img src=../../../assets/images/showPass-blue.svg ng-if=\"ResetPassword.confirmPasswordType !== \'password\'\" ng-click=\"ResetPassword.showPassword(\'confirmPassword\')\"> <img src=../../../assets/images/blind-blue.svg ng-if=\"ResetPassword.confirmPasswordType === \'password\'\" ng-click=\"ResetPassword.showPassword(\'confirmPassword\')\"></span></span></div><span class=highlight></span> <span class=bar></span> <span ng-show=\"ResetPassword.resetForm.confirmPassword.$dirty && ResetPassword.resetForm.confirmPassword.$invalid\"><span class=error-input ng-show=ResetPassword.resetForm.confirmPassword.$error.required ng-bind=ResetPassword.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=ResetPassword.resetForm.confirmPassword.$error.maxlength>{{ ResetPassword.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=ResetPassword.resetForm.confirmPassword.$error.pattern>{{ ResetPassword.validateData.PASSWORD_FIELD }}</span> </span><span class=error-input ng-show=ResetPassword.confirmErr>{{ ResetPassword.confirmErr }}</span></div><div class=form-action-container><button ng-disabled=\"ResetPassword.resetForm.$invalid || ResetPassword.processFlag\" class=\"btn btn-block btn-primary-action\">Submit</button></div></form></div></div></div></div></div>");
$templateCache.put("app/components/modal/resetPassword/resetPassword.modal.html","<!--   Reset Password ----><div class=modal-content><div class=modal-header><h4 class=modal-title>Reset Password</h4></div><div class=modal-body><form autocomplete=off name=Modal.resetForm autocomplete=off ng-submit=Modal.resetPassword() novalidate><ul class=info-card><li>1) Password should be between 8 to 15 character.</li><li>2) Atleast one special character @, $, _, !</li><li>3) Atleast one Upper case letter.</li><li>4) Atleast one lower case letter.</li><li>5) Atleast one number.</li></ul><div class=input-normal ng-class=\"{error:Modal.resetForm.newPassword.$dirty && Modal.resetForm.newPassword.$invalid}\"><input name=newPassword ng-model=Modal.resetPasswordPayload.newPassword ng-pattern=Modal.appConstants.password_regex minlength=8 maxlength=15 type=password required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>New Password</label><span ng-show=\"Modal.resetForm.newPassword.$dirty && Modal.resetForm.newPassword.$invalid\"><span class=error-input ng-show=Modal.resetForm.newPassword.$error.required ng-bind=Modal.validateData.PASSWORD_REQUIRED></span> <span class=error-input ng-show=Modal.resetForm.newPassword.$error.maxlength>{{ Modal.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=Modal.resetForm.newPassword.$error.minlength>{{ Modal.validateData.PASSWORD_MIN }}</span> <span class=error-input ng-show=\"Modal.resetForm.newPassword.$error.pattern && !Modal.resetForm.newPassword.$error.minlength\">{{ Modal.validateData.PASSWORD_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Modal.resetForm.confirmPassword.$touched && Modal.resetForm.confirmPassword.$dirty && Modal.resetForm.confirmPassword.$invalid}\"><input name=confirmPassword ng-model=Modal.resetPasswordPayload.confirmPassword type=password ng-pattern=Modal.appConstants.password_regex maxlength=15 required autocomplete=off ng-change=Modal.updateErrorMsg()> <span class=highlight></span> <span class=bar></span><label>Confirm Password</label><span ng-show=\"Modal.resetForm.confirmPassword.$touched && Modal.resetForm.confirmPassword.$dirty && Modal.resetForm.confirmPassword.$invalid\"><span class=error-input ng-show=Modal.resetForm.confirmPassword.$error.required ng-bind=Modal.validateData.CONFIRM_PASSWORD_REQUIRED></span> <span class=error-input ng-show=Modal.resetForm.confirmPassword.$error.maxlength>{{ Modal.validateData.PASSWORD_FIELD }}</span> <span class=error-input ng-show=Modal.resetForm.confirmPassword.$error.pattern>{{ Modal.validateData.PASSWORD_FIELD }}</span> </span><span class=error-message ng-show=Modal.confirmErr>{{ Modal.confirmErr }}</span></div><button ng-disabled=\"Modal.resetForm.$invalid || Modal.processFlag\" class=\"btn btn-block btn-primary-action\">Submit</button></form></div></div><!--   Reset Password ---->");
$templateCache.put("app/components/modal/resetPassword/resetPasswordSuccess.modal.html","<!-- Sign up Completed--><div class=modal-content id=signUp-done><div class=modal-header><h4 class=modal-title>Reset Password Confirmation</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p class=info>You have succesfully changed your password. Please continue to login<br>to your account.</p><form autocomplete=off><button ng-click=Modal.closeModal() class=\"btn btn-block btn-primary-action\">Proceed to Login</button></form></div></div>");
$templateCache.put("app/components/modal/rollOver/changeDividendSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=changeDividend-success><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><p class=text-center><i class=verify-icon></i></p><p class=\"text-center changeDividend-message\">Your IDCW change request for <span class=strong>\"HDFC Banking & PSU Debt\"</span><br>has been successfully sent</p><button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverConfirm.modal.html","<div class=modal-content id=changeDividend-popUp><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><div class=\"text-center want-dividend\"><p>Do you want to make the Roll Over Request?</p></div><div class=important-change><p class=imp-head>Important:</p><p class=imp-des>Thank you for being an eco-friendly investor.A copy of the roll over request has ben emailed to you. Please do not print this page unless absolutely necessary.<br><br>Actual unit balance avaiable to switch/redeem/roll over may be lower than total balance because of any lien(s) marked against your units, any recently purchased / Switch in units where the credit status is not established, investments in ELSS(Open ended schemes with 3 year lock-in), or any other reason.</p></div><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.submitForm()>Confirm</button></div></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverOverview.modal.html","<div class=modal-content id=rollOverview><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"modal-body ng-scope\"><strong ng-if=\"item.type == \'cancelled\'\">Roll Over Cancellation Summary </strong><strong ng-if=\"item.type != \'cancelled\'\">Roll Over Summary</strong><table class=\"table borderless\"><tbody><tr><td>Transaction Number</td><td>:</td><td>{{Modal.modalData && Modal.modalData.cams_ref_no}}</td></tr><tr><td>Folio Number</td><td>:</td><td>{{Modal.modalData && Modal.modalData.folio_no}}</td></tr><tr><td>Source Scheme</td><td>:</td><td>{{Modal.modalData && Modal.modalData.schemeName}}</td></tr><tr><td>Status</td><td>:</td><td>{{(Modal.modalData && Modal.modalData.type == \"cancelled\") ? \"Cancelled\" : Modal.modalData.msg_current_status}}</td></tr><tr><td>Transaction Date</td><!--msg_created_time--><td>:</td><td>{{Modal.modalData && Modal.modalData.msg_created_time}}</td></tr><tr ng-if=\"(Modal.modalData && Modal.modalData.mode == \'unit\')\"><td>Units</td><td>:</td><td>{{Modal.modalData && Modal.modalData.amountOrUnits|unit:Modal.modalData && Modal.modalData.unitValue}} {{Modal.modalData && Modal.modalData.unitValue|unitValue}}<span ng-if=\"(Modal.modalData && Modal.modalData.amountOrUnits !=\'NA\')\"> Units</span></td></tr><tr ng-if=\"(Modal.modalData && Modal.modalData.mode == \'amount\')\"><td>Amount</td><td>:</td><td><i ng-if=\"(Modal.modalData && Modal.modalData.amountOrUnits !=\'NA\')\" class=rupee-black-icon></i>{{Modal.modalData && Modal.modalData.amountOrUnits|unit:Modal.modalData && Modal.modalData.unitValue}} {{Modal.modalData && Modal.modalData.unitValue|unitValue}}</td></tr><!--<tr>\n        <td>Client IP Address</td>\n        <td>:</td>\n        <td>171.28.5.172</td>\n      </tr>--></tbody></table></div></div>");
$templateCache.put("app/components/modal/rollOver/rollOverSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=initiateTransactionMsg><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><div><i class=verify-icon></i></div><p>Your Roll Over request for <strong>“{{Modal.modalData}}”</strong><br>has been successfully sent</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/schemeInFundList/schemeInFundList.modal.html","<!-- Scheme List--><div class=\"modal-content schemeInFundList\" ng-init=Modal.init() ng-if=!Modal.isCheckedFromArnHardcoded><div class=\"loader popup\"><span class=loading></span></div><div class=\"container-fluid header-container\"><i class=\"times-icon modal-cross-icon\" ng-click=Modal.dismissModal();></i><div class=\"row modal-header-view\"><div class=\"col-md-6 scheme-label\">All Schemes</div><div class=\"col-md-6 header-content\"><div class=select-scheme><p>Scheme Category</p></div><div><select class=\"browser-default custom-select\" name=schemeCategory ng-model=Modal.selectedschemeCategory ng-options=\"schemeCategoryList for schemeCategoryList in Modal.schemeCategoryList\" ng-change=Modal.changeSchemeCategory() required><option value=\"\" selected>Category</option></select></div></div></div></div><div class=\"container-fluid search-field\"><div class=row><div class=\"col-md-4 pos-search\"><input class=\"form-control search-fund\" type=text name=searchscheam id=searchscheam placeholder=\"&nbsp;&nbsp;&nbsp;Search by fund name\" ng-model=Modal.filterwithname ng-change=Modal.changewithFilterName() style=\"height: 40px\"> <i class=\"times-icon search-cross-icon\" ng-if=Modal.filterwithname ng-click=Modal.clearSearch()></i></div></div></div><form name=tform><div class=\"container-fluid body-container\"><h5 ng-if=\"Modal.selectedschemeCategoryDetails.length == 0\" class=empty-record>Records Not Found!</h5><div class=\"row flex-container\" ng-repeat=\"fund in Modal.selectedschemeCategoryDetails track by $index\" ng-if=\"fund.fundCode !== \'HDFCGF\'\"><div class=\"col-md-3 scheme-name-container mb-5\"><p class=recommend ng-if=fund.recommended>Recommended</p><p>{{fund.fundName}}</p></div><div class=\"col-md-3 mb-5\"><span class=label-color-view>Select Scheme</span><div class=input-field-card><div><select ng-model=fund.selectedScheme ng-options=\" item.schemeName for item in fund.regularSchemes\" ng-selected=\"fund.selectedScheme.schemeCode == value.schemeCode\" ng-disabled=Modal.distributorDetails.schemeCode><option value=\"\" selected>Select Scheme</option></select></div></div></div><div class=\"col-md-2 col-sm-6 col-xs-6 mb-5\"><p class=label-color-view>NAV (as of {{fund.fundNavRegular.nav_date[11] ? fund.fundNavRegular.nav_date[11]: \'NA\'}})</p><p class=nav-amount>{{fund.fundNavRegular.nav_amount[11]? Modal.utilService.getCommaSeperatedWithFloatValue(fund.fundNavRegular.nav_amount[11]): \'NA\'}}</p></div><div class=\"col-md-2 col-sm-6 col-xs-6 riskometer-view mb-5\"><div class=icon-select><p class=label-color-view>Riskometer</p><i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'Moderate\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderate.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'Moderately low risk\' || fund.riskReturnProfile === \'Low to Moderate Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderately-low.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'Moderately high\' || fund.riskReturnProfile === \'Moderately High Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderately-high.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'Low risk\' || fund.riskReturnProfile === \'Low\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/low.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'Very High Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/very-high.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"fund.riskReturnProfile === \'High Risk\' || fund.riskReturnProfile === \'High\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/high.png/>\'\"></i></div><div class=fund-details><div class=riskmeter><img src=assets/images/icons/riskometer/low.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile == \'Low risk\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile == \'Low to Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile == \'Moderate Risk\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile == \'Moderately High Risk\'\"> <img src=assets/images/icons/riskometer/high.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile == \'High Risk\'\"> <img src=assets/images/icons/riskometer/very-high.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Very High Risk\'\"> <img src=assets/images/icons/riskometer/moderate1.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Moderate\'\"> <img src=assets/images/icons/riskometer/moderately-high.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Moderately high\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Moderately low\'\"> <img src=assets/images/icons/riskometer/low.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Low\'\"> <img src=assets/images/icons/riskometer/moderately-low.svg alt={{fund.riskReturnProfile}} ng-if=\"fund.riskReturnProfile === \'Low to Moderate\'\"><div class=blue>{{fund.riskReturnProfile}}</div></div></div></div><div class=\"col-md-2 col-xs-12 col-sm-12 mb-5\"><button class=\"btn-primary btn-invest-color\" ng-disabled=!fund.selectedScheme ng-click=Modal.getScheme(fund)>Invest Now</button></div></div></div></form></div>");
$templateCache.put("app/components/modal/schemeList/schemeList.model.html","<!-- Scheme List--><div class=modal-content id=schemeList ng-init=Modal.init() ng-if=!Modal.isCheckedFromArnHardcoded><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-header><h4 class=modal-title>Scheme List</h4><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><!--<li class=\"active\"><a data-toggle=\"tab\" href=\"#All\">All</a></li>--><!--<li><a data-toggle=\"tab\" href=\"#Debt\">Debt</a></li>--><li ng-class=\"{active:$index==0}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=Modal.fetchSchemes(schemeType)><a data-toggle=tab>{{schemeType}}</a></li></ul><input type=search id=searchbox ng-model=Modal.searchString autocomplete=off placeholder=\"Search Scheme\" class=\"blank-input scheme-search\" ng-keydown=Header.searchInvestor() ng-if=\"Modal.schemesList.length !=0\"> <span class=no-scheme ng-if=\"Modal.schemesList.length===0\">No Scheme Found For The Category</span><div class=\"tab-content tab-type-2-content\"><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemesList | searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul><ul></ul></div></div></div></div><!-- Scheme List From ARN Hardcorded--><div class=\"modal-content arnSchemeListModal\" ng-init=Modal.init() ng-if=Modal.isCheckedFromArnHardcoded><div class=\"loader popup\"><span class=loading></span></div><div><i class=times-icon ng-click=Modal.dismissModal();>X</i></div><div class=modal-body><ul class=\"nav nav-tabs tab-type-2\"><li ng-class=\"{active:$index==0}\" ng-repeat=\"schemeType in Modal.schemeTypeList\" ng-click=Modal.fetchSchemes(schemeType)><a data-toggle=tab>{{schemeType}}</a></li></ul><div class=\"tab-content tab-type-2-content\"><div id=All class=\"tab-pane fade in active\"><ul><li ng-repeat=\"scheme in Modal.schemesList | searchFor:Modal.searchString\" ng-click=Modal.selectScheme(scheme)>{{scheme.scheme}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/modal/searchInvestor/investorUpdateDB.modal.html","<!-- Sign up Completed--><div class=modal-content id=transSum><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-header><h4 class=modal-title>initiate {{Modal.modalData.transactionType}}</h4><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--></div><div class=modal-body><form autocomplete=off name=Modal.searchInvestorForm class=common-search novalidate><div ng-if=Modal.isUpdateInfo><div class=\"input-normal input-group date date-picker\" format=DD-MMM-YYYY data-enable=true maxdate=now date-calendar data-viewmode=days data-date-default=Modal.investorDob data-on-date-change=Modal.changeInvestorDob id=investorDob ng-class={error:Modal.errorMessageDOB}><input type=text name=investorDob autocomplete=off class=form-control required readonly placeholder=\"dob - DD/MM/YYYY\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"Modal.searchInvestorForm.investorDob.$dirty && Modal.searchInvestorForm.investorDob.$invalid\"><span class=error-input ng-show=Modal.searchInvestorForm.investorDob.$error.required>Please enter dob</span> </span><span ng-if=Modal.errorMessageDOB><span class=error-input ng-bind=Modal.errorMessageDOB></span></span></div></div><div><span ng-bind=Modal.errorMessage></span></div><button id=updateBob class=\"btn btn-primary-action btn-block vim\" ng-keypress=\"($event.charCode==13)?Modal.continue():return\" ng-disabled=\"!Modal.investorDob || Modal.errorMessageDOB\" ng-click=Modal.updateInvestorDB()>Update</button></form></div></div>");
$templateCache.put("app/components/modal/searchInvestor/searchInvestor.modal.html","<!-- Sign up Completed--><div class=modal-content id=transSum><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-header><h4 class=modal-title ng-if=Modal.modalData.transactionType>initiate {{Modal.title}}</h4><h4 class=modal-title ng-if=Modal.modalData.statementSearch>Search Investor</h4><h4 class=modal-title ng-if=Modal.modalData.investorSearch>Choose Your Investor</h4></div><div class=modal-body><form autocomplete=off name=Modal.searchInvestorForm class=common-search novalidate><div class=input-normal ng-class=\"{error:Modal.searchInvestorForm.searchString.$dirty && Modal.searchInvestorForm.searchString.$invalid}\"><input id=search-box type=text easyassist-key=mask-element autofocus ng-model=Modal.searchString name=emailAddress required autocomplete=off ng-change=Modal.searchTimeBetweenKeypress()> <span class=highlight></span> <span class=bar></span><label>Search for Name, Folio, PAN or Mobile</label><br><span ng-show=\"Modal.searchInvestorForm.searchString.$dirty && Modal.searchInvestorForm.searchString.$invalid\"><span class=error-input ng-show=Modal.searchInvestorForm.searchString.$error.required>Please enter value to search</span> </span><span class=error-message ng-show=Modal.errorMessage>{{Modal.errorMessage}}</span><div id=search-result class=suggestion ng-if=Modal.searchResult&&Modal.searchResult.length><ul><li ng-repeat=\"data in Modal.searchResult track by $index\" ng-click=Modal.setInvestor(data,$index)>{{data.result1}} - <span easyassist-key=mask-element>{{data.result2}} </span></li></ul></div><div class=opt-outNominee ng-if=Modal.showMessage><p class=imp-msg><ng-bind-html dynamic=Modal.nomineeMessage></ng-bind-html></p><!--<p>Please nominate or opt-out of nomination for following folios.</p>--><div class=dashboard><div class=\"list scheme-table\" ng-class=\"{\'overflow-height\' : Modal.folioList.length > 2}\"><table class=\"table table-bordered\"><thead><tr><th class=text-center>SRN</th><th class=text-center>Folio</th></tr></thead><tbody><tr ng-repeat=\"folio in Modal.folioList track by $index\"><td>{{$index + 1}}</td><td>{{folio}}</td></tr></tbody></table></div></div></div></div><div ng-if=Modal.isUpdateInfo><div class=\"input-normal input-group date date-picker\" format=DD-MMM-YYYY data-enable=true maxdate=now date-calendar data-viewmode=days data-date-default=Modal.investorDob data-on-date-change=Modal.changeInvestorDob id=investorDob><input type=text name=investorDob autocomplete=off class=form-control required readonly placeholder=\"dob - DD/MM/YYYY\"> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"Modal.searchInvestorForm.investorDob.$dirty && Modal.searchInvestorForm.investorDob.$invalid\"><span class=error-input ng-show=Modal.searchInvestorForm.investorDob.$error.required>Please enter dob</span></span></div></div><button id=updateBob class=\"btn btn-primary-action btn-center vim\" ng-keypress=\"($event.charCode==13)?Modal.continue():return\" ng-disabled=Modal.errorMessage&&!Modal.investorDob ng-if=Modal.isUpdateInfo ng-click=Modal.updateSoleInfo()>Update</button> <button id=continueBtn class=\"btn btn-primary-action btn-center vim\" ng-keypress=\"($event.charCode==13)?Modal.continue():return\" ng-disabled=\"Modal.errorMessage||Modal.isSubmitted \" ng-if=!Modal.isUpdateInfo&&(!Modal.searchInvestorForm.$invalid&&Modal.selectedInvestor) ng-click=Modal.continue()>Continue</button></form></div></div>");
$templateCache.put("app/components/modal/select-folio/select.folio.modal.html","<div class=\"modal-content select-folio-modal\" id=initiateTransactionMsg><div class=modal-head><h3>Investment Details</h3><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form name=folioForm><div class=select-folio-container><div class=row><div class=col-md-12><p class=title>Select Folio</p><div ng-class=\"{error:folioForm.folio.$dirty && folioForm.folio.$invalid}\"><select name=folio id=_first ng-change=Modal.folioChanged() ng-model=Modal.formData.folioNumber class=\"selectNormal select-folio-list\" ng-options=\"folio.folioNo as folio.folioNo  for folio in Modal.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio Number</option></select><span class=error-input ng-show=\"folioForm.folio.$dirty && folioForm.folio.$invalid && folioForm.folio.$error.required\" ng-bind=Modal.VALIDATE_DATA.FOLIO_REQUIRED></span> <span class=error-input ng-show=Modal.kycVerifiedFlag ng-bind=Modal.kycMessage></span> <span class=error-input ng-show=!Modal.folioList ng-bind=Modal.VALIDATE_DATA.BASKET_NO_FOLIO></span></div></div></div></div><div class=folio-submit><button type=submit ng-disabled=folioForm.$invalid ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Submit</button></div></form></div></div>");
$templateCache.put("app/components/modal/selectAccount/selectAccount.modal.html","<!-- Sign up Completed--><div class=modal-content id=initiateTransactionMsg style=\"color: black;>\n  <div class=\"><div class=modal-body><h6>Select Account No.</h6><div class=form-group><form name=accountNoForm><div class=selectfield><label>Select Account No</label><select class=\"browser-default custom-select\" name=accountNo ng-init=\"Modal.formData.accountNo = Modal.bankAccounts[0]\" ng-options=\"_account for _account in Modal.bankAccounts\" ng-model=Modal.formData.accountNo required></select></div><br><button ng-click=Modal.closeModal() ng-disabled=!Modal.formData.accountNo class=\"btn btn-primary-action\">Submit</button></form></div></div></div>");
$templateCache.put("app/components/modal/showExitLoadMessage/showExitLoadMessage.html","<div class=modal-content id=showExitLoadMsg><div class=modal-body><div style=\"line-height: 1.5\"><p class=padding30 ng-bind-html=Modal.modalData.message></p></div><br><div class=showExitLoad-actionBtn><button ng-click=Modal.closeModal() class=\"btn btn-secondary-action redeem-btn\">YES, REDEEM</button> <button ng-click=Modal.dismissModal() class=\"btn btn-primary-action stayInvested-btn\">NO, STAY INVESTED</button></div></div></div>");
$templateCache.put("app/components/modal/showExitLoadMessage/stayInvested.modal.html","<div class=modal-content id=stayInvestedMsg><div class=\"loader popup\"><span class=loading></span></div><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><div><i class=verify-icon></i> <span>{{Modal.modalData.msg}}</span></div></div></div>");
$templateCache.put("app/components/modal/signup/otp-verification.modal.html","<!-- Otp verification--><div class=modal-content id=signUp-otp><div class=modal-header><h4 class=modal-title>Distributor Verfication</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=Modal.otpForm ng-submit=Modal.verifyOtp() novalidate><p class=info>An OTP has been sent to your Registered Email Id/Mobile Number.<br>Please enter the OTP to verify.</p><div class=\"group input-normal\" ng-class=\"{error:Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid}\"><input type=text ng-model=Modal.otpVerificationPayload.otpNumber name=otpNumber required minlength=6 maxlength=6 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter OTP</label><span ng-show=\"Modal.otpForm.otpNumber.$dirty && Modal.otpForm.otpNumber.$invalid\"><span class=error-input ng-show=Modal.otpForm.otpNumber.$error.required ng-bind=Modal.validateData.OTP_REQUIRED></span> <span class=error-input ng-show=Modal.otpForm.otpNumber.$error.maxlength>{{ Modal.validateData.OTP_FIELD }}</span></span><div style=\"padding-top: 10px\"><span ng-bind=Modal.otpResendMessage style=\"color: #1bb898\">OTP sent</span> <a href=javascript:void(0) ng-click=Modal.reGenerateOtp() class=pull-right ng-disabled=Modal.processOTPFlag>Resend OTP</a></div></div><span class=error ng-if=\"Modal.errorMessage!=\'SUCCESS\'\"><span class=\"error-input help-block\">{{ Modal.errorMessage }}</span> </span><button type=submit ng-disabled=\"Modal.otpForm.$invalid || Modal.processFlag\" class=\"btn btn-primary-action btn-block\">Submit</button></form></div></div>");
$templateCache.put("app/components/modal/signup/signup-done.modal.html","<!-- Sign up Completed--><div class=modal-content id=signUp-done><div class=modal-header><h4 class=modal-title>Distributor Signup Confirmation</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><p class=info>Thanks for verifying your account with OTP.<br>An email has been sent to your registered email ID with temporary password.</p><form autocomplete=off><button ng-click=Modal.closeModal() class=\"btn btn-primary-action btn-block\">Proceed to Login</button></form></div></div>");
$templateCache.put("app/components/modal/signup/signup.modal.html","<!--   Modals Sign Up\n    -------------------------><div class=modal-content id=signUp-form><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Distributor Signup</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><!-- Sign Up Form--><form autocomplete=off name=Modal.signupForm ng-submit=Modal.generateOtp() novalidate><div class=input-normal ng-class=\"{error:Modal.signupForm.arnCode.$dirty && Modal.signupForm.arnCode.$invalid}\"><input ng-model=Modal.signupUser.arnCode type=text maxlength=10 name=arnCode ng-pattern=Modal.appConstants.arn_regex required class=arn-no autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><label>ARN</label><span ng-show=\"Modal.signupForm.arnCode.$dirty && Modal.signupForm.arnCode.$invalid\"><span class=error-input ng-show=Modal.signupForm.arnCode.$error.required ng-bind=Modal.validateData.ARN_REQUIRED></span> <span class=error-input ng-show=\"Modal.signupForm.arnCode.$error.pattern && Modal.signupForm.arnCode.$invalid \" class=help-block>{{ Modal.validateData.ARN_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Modal.signupForm.bankAccountNumber.$dirty && Modal.signupForm.bankAccountNumber.$invalid}\"><input type=text ng-model=Modal.signupUser.bankAccountNumber name=bankAccountNumber required minlength=9 maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Bank Account Number</label><span ng-show=\"Modal.signupForm.bankAccountNumber.$dirty && Modal.signupForm.bankAccountNumber.$invalid\"><span class=error-input ng-show=Modal.signupForm.bankAccountNumber.$error.required ng-bind=Modal.validateData.BANK_ACCOUNT_REQUIRED></span> <span class=error-input ng-show=Modal.signupForm.bankAccountNumber.$error.minlength>{{ Modal.validateData.ACCOUNT_NUMBER_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Modal.signupForm.emailAddress.$dirty && Modal.signupForm.emailAddress.$invalid}\"><input type=email ng-model=Modal.signupUser.emailAddress ng-pattern=Modal.appConstants.email_regex name=emailAddress maxlength=150 required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Email ID</label><span ng-show=\"Modal.signupForm.emailAddress.$dirty && Modal.signupForm.emailAddress.$invalid\"><span class=error-input ng-show=Modal.signupForm.emailAddress.$error.required ng-bind=Modal.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=Modal.signupForm.emailAddress.$error.pattern>{{ Modal.validateData.EMAIL_FIELD }}</span></span></div><div class=input-normal ng-class=\"{error:Modal.signupForm.mobileNumber.$dirty && Modal.signupForm.mobileNumber.$invalid}\"><input type=text name=mobileNumber id=mobileNumberId ng-blur=Modal.goToNextEle() ng-model=Modal.signupUser.mobileNumber ng-pattern=Modal.appConstants.arn_regex required maxlength=10 autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Mobile Number</label><span ng-show=\"Modal.signupForm.mobileNumber.$dirty && Modal.signupForm.mobileNumber.$invalid\"><span class=error-input ng-show=Modal.signupForm.mobileNumber.$error.required ng-bind=Modal.validateData.MOBILE_REQUIRED></span> <span class=error-input ng-show=Modal.signupForm.mobileNumber.$error.maxlength>{{ Modal.validateData.MOBILE_FIELD }}</span> <span class=error-input ng-show=\"Modal.signupForm.mobileNumber.$error.pattern && Modal.signupForm.mobileNumber.$invalid\" class=help-block>{{ Modal.validateData.MOBILE_FIELD }}</span></span></div><div class=form-group><!--<div id=\"html_element\"></div>--><!--<div vc-recaptcha key=\"6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX\" ></div>--><div vc-recaptcha key=Modal.publicKey ng-model=Modal.myRecaptchaResponse></div></div><span class=error ng-if=Modal.errorMessage><span class=\"error-input help-block\">{{ Modal.errorMessage }}</span> </span><button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=\"Modal.signupForm.$invalid || Modal.processFlag\">Submit</button></form></div></div>");
$templateCache.put("app/components/modal/sipPauseConfirmation/sipPauseConfirmation.modal.html","<div class=modal-content id=forgot-success><div class=modal-body><p class=\"siptext-center padding30\" style=\"margin-left: 52px\">{{Modal.modalData.data.trnxActionMsg?Modal.modalData.data.trnxActionMsg:\'Your SIP Pause request has been successfully forwarded to investor.\'}}</p><button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/subscribeToggle/subscribeToggle.modal.html","<div class=\"modal-content subscribe-modal\"><i class=times-icon ng-click=Modal.dismissModal();></i><div class=\"loader popup\"><span class=loading></span></div><div class=modal-body><div class=\"textarea-subscribe marketing-label marketing-popup-heading\">Could you please provide your reason for opting out of HDFC MFOnline Partners promotional notifications</div><textarea ng-model=Modal.reasonForOptingOut placeholder=\"Enter reason...\" cols=65 rows=10 style=\"margin-top: 30px;margin-bottom: 30px;padding: 5px;resize:none;width: 91%;margin-left: 5%\"></textarea><div class=modalbutton><button type=submit class=\"btn btn-primary-action\" ng-click=Modal.confirmUnsubscribe()>Submit</button></div></div></div>");
$templateCache.put("app/components/modal/successMessage/success.modal.html","<!-- Scheme List--><div class=modal-content id=forgot-success><div class=\"loader popup\"><span class=loading></span></div><!--<i class=\"times-icon\" ng-click=\"Modal.dismissModal();\"></i>--><div class=modal-body><i class=success-icon style=\"margin: 0 auto;display: block\"></i><p class=\"text-center padding30\">{{Modal.modalData.message?Modal.modalData.message:\'Successfully updated.\'}}</p><!--Forgot pwd--><!--<p class=\"text-center\">A link to reset your password has been sent to your registered email ID xyz@xyz.com</p>--> <button ng-hide=Modal.modalData.hideOKButton class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/systematicCancellation/cancellationSuccess.modal.html","<!-- Scheme List--><div class=modal-content id=forgot-success><div class=modal-body><p class=\"text-center padding30\">{{Modal.modalData.data.trnxActionMsg?Modal.modalData.data.trnxActionMsg:\'Your cancellation request has been successfully forwarded to investor\'}}</p><button class=\"btn btn-primary-action btn-center\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/termcondition/termAndConditionEcart.modal.html","<!--dynamic terms and condition sip and purchase--><ng-bind-html dynamic=Modal.dynamicTermsEcart.content></ng-bind-html><!--mobile terms and condition for sip & purchase--><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.modal-body {\n    padding: 45px !important;\n  }\n\n  .bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }\n  .nuture-order-list {\n    list-style-type: decimal;\n    padding-left: 35px;\n    margin-bottom: 30px;\n  }\n  .nuture-order-list > li {\n    padding: 5px 0;\n  }\n  .nuture-clauses p {\n    margin-bottom: 20px !important;\n    line-height: 1.3;\n  }\n  .nuture-tnc a{\n    text-decoration: underline !important;\n    font-size: 14px !important;\n    color: #337ab7 !important;\n  }\n\n  .bold-numeric-list ul > li {\n    list-style-type: circle;\n  }\n\n  .bold-numeric-list ul > li:before {\n    content: none;\n  }\n\n  .nuture-tnc {\n    border-top: 2px dashed #888;\n    padding-top: 40px;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/termcondition-addBank.modal.html","<!--dynamic terms and condition COBM--><ng-bind-html dynamic=Modal.dynamicTermsAddToBank.content></ng-bind-html><!--mobile terms and condition  --><ng-bind-html dynamic=TermsCondition.content></ng-bind-html>");
$templateCache.put("app/components/modal/termcondition/termcondition-init-transaction.modal.html","<div class=modal-content id=termsCondition><div class=modal-header><h4 class=modal-title>TERMS AND CONDITIONS</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><h6 class=text-center>TERMS AND CONDITIONS FOR DISTRIBUTORS TRANSACTING THROUGH HDFCMFOnline for Distributors</h6><p>By accepting these terms and conditions, the distributor confirms to have read, understood, and accepted its contents. Accepting these terms and conditions is a pre-requisite to execute transactions through <strong>HDFCMFOnline for Distributors.</strong></p><p>HDFC Asset Management Company Limited (hereinafter referred to as ”<strong>HDFC AMC</strong>”) maintains the HDFCMFOnline for Distributors (hereinafter referred to as “HDFCMFOnline”), which provides various facilities to distributors, including execution of purchase/redemption/switches/systematic transactions online on behalf of Investors/Unit Holders after necessary validation and authorization from the Investor/Unit Holders.</p><p>The Terms and Conditions to be complied with by Distributors for availing of the facility for executing transactions under HDFCMFOnline are detailed below:</p><ol class=alpha-list><li>I agree and understand that this facility shall be governed by these Terms and Conditions as stated hereinafter, which shall be acting in addition to the terms, conditions, and disclaimers as available on the website - www.hdfcfund.com and as available in the various schemes of HDFC Mutual Fund (Schemes) related documents, including but not limited to the Scheme Information Document (SID)/ Statement of Additional Information (SAI)/ Key Information Memorandum (KIM)/ Various addendums to the schemes/ application forms etc., and the terms and conditions in connection with my empanelment with HDFC AMC. It shall be deemed that I have reviewed these Terms and Conditions, the terms of use of the website, and the scheme related documents carefully prior to execution of transactions using HDFCMFOnline. I also agree to the exclusion and limitation of liability in the terms of use and accept them as reasonable.</li><li>I acknowledge that HDFC AMC reserve the right to add/remove/amend/modify all/few of the facilities/functionalities of HDFCMFOnline and /or modify/amend these Terms and Conditions at any time HDFC AMC feels appropriate, without the need to inform me of the same in advance, and I shall be deemed to have accepted such modifications for ensuring continuous usage of HDFCMFOnline. If I disagree with any of the Terms and Conditions herein or in the terms of use /disclaimer notice, I may not execute transactions on behalf of Investors/Unit Holders or use any of the facilities provided under HDFCMFOnline. Prior to accessing HDFCMFOnline, I shall be deemed to have unequivocally agreed to be bound by these Terms and Conditions.</li><li>HDFC AMC does not offer any guarantee relating to HDFCMFOnline, its programming, or other errors. It also does not guarantee that the use of HDFCMFOnline will not be subject to any malfunctions, or that it can be used in any location or it will be uninterrupted.</li><li>I shall use the facilities available on HDFCMFOnline carefully only for the purpose for which such facilities is provided. Any usage of the facility including execution of transactions using HDFCMFOnline shall be subject to my compliance with all applicable laws and regulations, including Information Technology Act, 2002, and regulations, including the regulations issued by SEBI, AMFI, and RBI and any other relevant authority as the case may be. It shall be my sole responsibility to ensure that my usage of HDFCMFOnline is in conformity with all applicable laws and regulations in my jurisdiction.</li><li>As a pre-condition for availing of the facilities offered under HDFCMFOnline, I acknowledge and agree that:<ol class=numb-list><li>I have been empanelled as a distributor with HDFC AMC and all the terms and conditions in connection with empanelment has been fully complied with</li><li>I have submitted all documents required in connection with KYD Process and I am KYD compliant.</li><li>I have my email ID and mobile number registered with HDFC AMC</li><li>I am/have been a distributor for the folio with respect to which transaction is being executed through HDFCMFOnline.</li><li>I confirm that the Investor has updated the email ID and mobile number in his/her folio.</li><li>I have received adequate authorisation from the Investor for availing of the facility of execution of transactions through HDFCMFOnline and shall ensure that every transaction initiated by me on behalf of the Investor will be with prior knowledge and approval of the Investor.</li><li>I understand that I can initiate transactions only in those folios where the tax status of the Investor is of an Individual / HUF / Sole Proprietor / Minor and that the mode of holding is Single /Anyone or survivor.</li><li>I understand that an extract of the transaction initiated by me on HDFCMFOnline shall be sent to the respective Investor(s) for their acceptance and that the transaction will not be processed if the same is rejected by the Investor or the validity of such transaction has expired.</li><li>Payment for a transaction shall be made by the Investor through a payment gateway and HDFC AMC/HDFC MF/Authorized Registrar will not be liable for any failures in the link or for any fraud (either at the payment gateway&#39;s end and/or the bank&#39;s end) that could take place at the time of making payment. A transaction shall be deemed to be completed only upon receipt of a written confirmation in that regard from HDFC AMC/HDFC MF/Authorised Registrar and not otherwise.</li><li>I am aware that if the investor desires to transact through the, HDFCMFOnline the Investor should be:<ul class=dash-list><li>An eligible Investor as per the SID/SAI</li>I am aware of the Internet risks pertaining to online transactions including the transactions initiated on HDFCMFOnline and have accordingly informed the Investor.<li>An Individual / HUF / Sole Proprietor / Minor and whose mode of holding should be `Single /Anyone or survivor’ and Email ID/mobile number duly registered with HDFC AMC in the folio(s) ;and</li><li>KYC compliant</li></ul></li><li>I am aware of the Internet risks pertaining to online transactions including the transactions initiated on HDFCMFOnline and have accordingly informed the Investor.</li><li>In case of any technical fault/error or any failure of the service providers viz. payment gateway and/or the bank or failure in telecommunication network or any error in any software or hardware systems or for any other reason whatsoever pursuant to authorisation of a purchase transaction(s) by the Investor in such events, the transaction(s)will be processed by the HDFC AMC at the applicable NAV subject to receipt of credit of the subscription amount in the collection bank account of the Scheme(s) . If Schemes’ bank account does not receive the subscription amount, then in such cases even though servers of HDFC AMC/RTA has received the transaction details, the transaction will still be treated as cancelled.</li><li>I will not initiate any transaction/ use any facility offered under HDFCMFOnline in breach of these Terms and Conditions or any other restriction or requirement of use as may be specified on the website or with a fraudulent or malicious intent or without prior approval of the Investor or for any illegal or improper purpose.</li><li>All correspondence/communication in respect of transactions initiated on HDFCMFOnline will be sent by the HDFC AMC/Authorised Registrar to me on my registered email and/or mobile number</li><li>I understand that for the purpose of applicability of NAV, the time stamp considered will be that of when the transaction details are received in the servers of the HDFC AMC/RTA along with credit in the collection bank account of the Schemes pursuant to the authorisation by the Investor.</li><li>I am aware of the NAV applicability, cut off time in case of business day and non- business days and shall ensure that the Investor is also aware of the same. (Click here to read about the NAV applicability).</li><li>I am aware that once I initiate a transaction, a link would be sent to the investor for authorization of the transaction which will be valid for only 48 hours effective from the time the transaction is initiated by me. In case, the transaction is not authorised within 48 hours by the Investor, the link will automatically become invalid.</li><li>The grant of the facility to transact using HDFCMFOnline to me is not transferable / assignable under any circumstances and shall be used only by me.</li><li>HDFC AMC may offer the facilities under HDFCMFOnline only to those who have complied with the formalities specified by HDFC AMC in this regard. I agree that in order to be eligible for HDFCMFOnline, I would need to be a current internet user or have access to the internet and have knowledge of how the internet works and comply with the pre-requisite requirements.</li><li>I confirm that HDFC AMC shall not be liable for any damages, losses (direct and/or indirect) whatsoever, due to disruption or non-availability of the services/facility(s) under HDFCMFOnline due to technical fault/error or any failure of the service provider or failure in telecommunication network any error in any software or hardware systems</li><li>I understand that there will be no obligation on HDFC AMC to support all the versions of any software. I agree that I shall be responsible for upgrading my software, hardware and the operating system at my cost from time to time so as to be compatible with that of HDFC AMC. HDFC AMC shall be at liberty to change, vary or upgrade its software, hardware; operating systems etc from time to time and shall be under no obligation to support the software, hardware, or operating systems.</li><li>I hereby acknowledge that HDFC AMC reserves the right to reject any transaction through HDFCMFOnline, if in the reasonable opinion of HDFC AMC, any of the pre- requisites for transacting on HDFCMFOnline have not been complied with either by me or by the Investor on whose behalf the transaction is proposed to be executed and that the same will not be disputed either by me or the Investor(s).</li><li>I hereby agree that the transaction initiated by me will be for on behalf of investors who are eligible Investors under the SID/SAI of the Schemes.</li></ol></li><li>I hereby agree to indemnify HDFC AMC for all liabilities, losses, damages and expenses which the HDFC AMC may sustain or incur either directly or indirectly as a result of:<ol class=numb-list><li>Fraud, malice, or dishonesty on my part in execution of transactions on behalf of Investors/Unit Holders on HDFCMFOnline.</li><li>Non-compliance with the Terms and Conditions set out herein, including the terms in connection with obtaining authorisation from Investor/Unit Holder for transacting on their behalf on HDFCMFOnline.</li><li>Incorrect/erroneous information provided by me whilst filling up requisite details for execution of transactions on HDFCMFOnline.</li><li>Any negligence or mistake or misconduct on my part.</li></ol></li><li>I acknowledge that HDFC AMC shall under no circumstances be held liable to me or to the Investor if services under HDFCMFOnline is not available in the desired manner for reasons including but not limited to natural calamity, floods, fire and other natural disasters, legal restraints, faults in telecommunication network or Internet or network failure, software or hardware error or any other reason beyond the control of HDFC AMC. HDFC AMC shall under no circumstances be liable for any damages whatsoever whether such damages are direct, indirect, incidental, consequential and irrespective of whether any claim is based on loss of revenue, investment, production, goodwill, profit, interruption of business or any other loss or any character or nature whatsoever and whether sustained by me or any Investor..</li><li>I acknowledge that the software underlying HDFCMFOnline as well as other internet related software, which are required for accessing HDFCMFOnline, is the legal property of HDFC AMC/respective vendors. The permission given by HDFC AMC to access HDFCMFOnline will not convey any proprietary or ownership rights in the above software. I hereby agree that I will not attempt to modify, translate, disassemble, decompile or reverse engineer the software underlying HDFCMFOnline or create any derivative product based on the software. I further agree not to use the name, logo or mark of HDFC AMC/HDFC Mutual Fund (or any logo or mark similar thereto), and any related patent, trademarks and service marks applications, design rights, copyrights, and all or any similar or equivalent rights arising or subsisting in any country in the world.</li><li>These Terms and Conditions and/or the use of the facilities provided through HDFCMFOnline shall be governed by the laws of the India. The distributor and HDFC AMC agree to submit to the exclusive jurisdiction of the courts in Mumbai as regards any claims or matters arising under these Terms and Conditions. HDFC AMC accepts no liability whatsoever, direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere fact that HDFCMFOnline can be accessed through internet by the distributor in a country other than India shall not be interpreted to imply that the laws of the said country govern these Terms and Conditions and/or the use of HDFCMFOnline.</li></ol></div></div>");
$templateCache.put("app/components/modal/termcondition/termcondition-summary.modal.html","<div class=modal-content id=termsCondition><div class=modal-header><h4 class=modal-title>TERMS AND CONDITIONS</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><h6 class=text-center>TERMS AND CONDITIONS FOR TRANSACTIONS INITIATED THROUGH HDFCMFOnline for Distributors BY THE DISTRIBUTORS</h6><p>By accepting these terms and conditions, the Investor confirms to have read, understood, and accepted its contents. Accepting these terms and conditions is a pre-requisite to execute transactions through <strong>HDFCMFOnline for Distributors.</strong></p><p>HDFC Asset Management Company Limited (hereinafter referred to as <strong>”HDFC AMC”</strong>) maintains the <strong>HDFCMFOnline for Distributors.</strong> (hereinafter referred to as “<strong>HDFCMFOnline</strong>”), which provides various facilities to distributors, including execution of purchase/redemption/switches/systematic transactions online on behalf of Investors/Unit Holders after necessary validation and authorization from the Investor/Unit Holders.</p><p>The Terms and Conditions to be complied with by the Investors for availing of the facility for executing transactions under HDFCMFOnline are detailed below:</p><ol class=numb-list><li>I/we acknowledge that my/our usage of the facilities under HDFCMFOnline for Distributors shall be subject to the Terms and Conditions of usage as laid down by HDFC AMC in connection therewith, and I/we hereby confirm that I/we have read and understood and agree to comply with and be bound by the same.</li><li>I/we hereby authorise the aforementioned distributor, to initiate purchase/redemption/switch/systematic transactions online on my/our behalf through HDFCMFOnline for Distributors, subject to appropriate validation/approval from me.</li><li>I/we agree to provide to HDFC Mutual Fund/HDFC AMC such further information as would be required in connection with my registration for HDFCMFOnline for Distributors.<br><br>Upon my/our acceptance of any transaction initiated by the distributor on my/our behalf, it shall be deemed that the transaction is fully verified and treated as if the transactions have been made by me /us. HDFC AMC shall thereafter be authorised to process the transaction and I/we agree to be bound by the same.</li><li>I/we will also inform HDFC Mutual Fund/HDFC Asset Management Company Limited, about any changes in my/our contact details promptly.</li><li>As a pre-condition for availing of the facilities offered under HDFCMFOnline, I acknowledge and agree that:<ol class=numb-list><li>I/We am/are an individual unit holder(s) or a Karta of an HUF; and is/are KYC complaint</li><li>In my/our folio, the mode of holding is “Single” or “Either or Survivor”.</li><li>My/ our mobile number and Email Address are updated in the Folio/s for availing this facility. I/we further agree that in the event any of the above information is incomplete in the Folio/s, the transaction request initiated by the Distributor will be cancelled;</li><li>The details submitted hereinabove are true and correct and belong to the me/us;</li><li>I/we am/are aware of the risks involved including the following in the transacting using this facility and further agree to bear the consequences of the same, if any:<ol class=dash-list><li>If any third person obtains access to my email ID and/or mobile number, such third party would be able to transact/provide electronic instructions to HDFC AMC. Whilst HDFC AMC shall aim to provide security to prevent any unauthorized access, there cannot be any guarantee from such internet frauds, hacking and other actions, which could affect the electronic instructions to HDFC AMC;</li></ol></li><li>I/we have read and understood the terms and conditions applicable to the facility and confirm that I/we shall be bound by the same. Detailed Terms and Conditions are available at the Investor Service Centres or on the Website <a href={{Modal.HDFC_API.WEBSITE_LINK}}>www.hdfcfund.com</a></li><li>I/we are aware that the distributor who has initiated this transaction has been a distributor for the folio with respect to which transaction is being authorised through HDFCMFOnline</li><li>I/we have authorised this transaction with prior knowledge and information provided by the Distributor and the approval has been given by me/us to my/ our distributor.</li><li>I understand that an extract of the transaction authorized by me on HDFCMFOnline shall be sent to the respective distributor.</li><li>Payment for a transaction shall be made by me/us through a payment gateway and HDFC AMC/HDFC MF/Authorized Registrar will not be liable for any failures in the link or for any fraud (either at the payment gateway\'s end and/or the bank\'s end) that could take place at the time of making payment. A transaction shall be construed to be completed only upon receipt of a written confirmation in that regard from HDFC AMC/HDFC MF/Authorised Registrar and not otherwise.</li><li>I am aware of the Internet risks pertaining to the online transactions including the HDFCMFOnline</li><li>In case of any technical fault/error or any failure of the service providers viz. payment gateway and/or the bank or failure in telecommunication network or any error in any software or hardware systems or for any other reason whatsoever pursuant to authorisation by the Investor / Unit holder in such events, the transaction will be processed by the HDFC AMC subject to the credit of the subscription amount in collection bank account of the scheme. If HDFC AMC does not receive the subscription amount, the transaction will be treated as cancelled.</li><li>I will not authorise any transaction on HDFCMFOnline in breach of these Terms and Conditions or any other restriction or requirement of use as may be specified on the website or with a fraudulent or malicious intent or for any illegal or improper purpose.</li><li>All correspondence/communication in respect of transactions initiated on HDFCMFOnline will be sent by the HDFC AMC/Authorised Registrar to me on my/our registered email and/or mobile number</li><li>I/we understand that for the purpose of applicability of NAV, the time stamp considered will be that of when the transaction details are received in the servers of the HDFC AMC/RTA along with credit in the collection bank account of the Schemes pursuant to the authorisation by me/us.</li><li>I am aware that the once the distributor initiates the transaction, the link for authorization of the transaction would be for only 48 hours. In case, the transaction is not authorised within 48 hours, the link will automatically become invalid.</li><li>The grant of the facility to authorise transactions using HDFCMFOnline to me/us is not transferable/assignable under any circumstances and shall be used only by me/us.</li><li>I confirm that HDFC AMC shall not be liable for any damages, losses (direct and/or indirect) whatsoever, due to disruption or non-availability of the services/facility(s) under HDFCMFOnline due to technical fault/error or any failure of the service provider or failure in telecommunication network any error in any software or hardware systems</li><li>HDFC AMC may offer the facilities under HDFCMFOnline only to those who have complied with the formalities specified by HDFC AMC in this regard. I agree that in order to be eligible for HDFCMFOnline, I would need to be a current internet user or have access to the internet and have knowledge of how the internet works.</li><li>I understand that there will be no obligation on HDFC AMC to support all the versions of any software. I agree that I shall be responsible for upgrading my software, hardware and the operating system at my cost from time to time so as to be compatible with that of HDFC AMC. HDFC AMC shall be at liberty to change, vary or upgrade its software, hardware, operating systems etc from time to time and shall be under no obligation to support the software, hardware, or operating systems</li><li>I hereby acknowledge that HDFC AMC reserves the right to reject any transaction through HDFCMFOnline, if in the reasonable opinion of HDFC AMC; any of the pre-requisites for transacting on HDFCMFOnline have not been complied with either by me/us or by the distributor who has initiated the transaction on my/our behalf.</li><li>I hereby agree to indemnify HDFC AMC for all liabilities, losses, damages and expenses which the HDFC AMC may sustain or incur either directly or indirectly as a result of:<ul class=dash-list><li>Fraud, malice, or dishonesty on my part in execution of transactions on behalf of Investors/Unit Holders on HDFCMFOnline</li><li>Non-compliance with the Terms and Conditions set out herein, including the terms in connection with obtaining authorisation from Investor/Unit Holder for transacting on their behalf on HDFCMFOnline</li><li>Incorrect/erroneous information provided by me whilst filling up requisite details for execution of transactions on HDFCMFOnline</li><li>Any negligence or mistake or misconduct on my part;</li></ul></li><li>I acknowledge that HDFC AMC shall under no circumstances be held liable to me/us or to the distributor if services under HDFCMFOnline is not available in the desired manner for reasons including but not limited to natural calamity, floods, fire and other natural disasters, legal restraints, faults in telecommunication network or Internet or network failure, software or hardware error or any other reason beyond the control of HDFC AMC. HDFC AMC shall under no circumstances be liable for any damages whatsoever whether such damages are direct, indirect, incidental, consequential and irrespective of whether any claim is based on loss of revenue, investment, production, goodwill, profit, interruption of business or any other loss or any character or nature whatsoever and whether sustained by me/us or any distributor.</li><li>I acknowledge that the software underlying HDFCMFOnline as well as other internet related software, which are required for accessing HDFCMFOnline, is the legal property of HDFC AMC/respective vendors. The permission given by HDFC AMC to access HDFCMFOnline will not convey any proprietary or ownership rights in the above software. I hereby agree that I will not attempt to modify, translate, disassemble, decompile or reverse engineer the software underlying HDFCMFOnline or create any derivative product based on the software. I further agree not to use the name, logo or mark of HDFC AMC/HDFC Mutual Fund (or any logo or mark similar thereto), and any related patent, trademarks and service marks applications, design rights, copyrights, and all or any similar or equivalent rights arising or subsisting in any country in the world.</li><li>These Terms and Conditions and/or the use of the services/facilities provided through HDFCMFOnline shall be governed by the laws of the India and shall be in addition to the existing terms and conditions for online Investors. The distributor and HDFC AMC agree to submit to the exclusive jurisdiction of the courts in Mumbai as regards any claims or matters arising under these Terms and Conditions. HDFC AMC accepts no liability whatsoever, direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere fact that HDFCMFOnline can be accessed through internet by the distributor in a country other than India shall not be interpreted to imply that the laws of the said country govern these Terms and Conditions and/or the use of HDFCMFOnline.</li></ol></li></ol><ol class=alpha-list><li>I hereby agree to indemnify HDFC AMC for all liabilities, losses, damages and expenses which the HDFC AMC may sustain or incur either directly or indirectly as a result of:<ol class=numb-list><li>Fraud, malice, or dishonesty on my part in execution of transactions on behalf of Investors/Unit Holders on HDFCMFOnline</li><li>Non-compliance with the Terms and Conditions set out herein, including the terms in connection with obtaining authorisation from Investor/Unit Holder for transacting on their behalf on HDFCMFOnline</li><li>Incorrect/erroneous information provided by me whilst filling up requisite details for execution of transactions on HDFCMFOnline</li><li>Any negligence or mistake or misconduct on my part;</li></ol></li><li>I acknowledge that HDFC AMC shall under no circumstances be held liable to me or to the distributor if services under HDFCMFOnline is not available in the desired manner for reasons including but not limited to natural calamity, floods, fire and other natural disasters, legal restraints, faults in telecommunication network or Internet or network failure, software or hardware error or any other reason beyond the control of HDFC AMC. HDFC AMC shall under no circumstances be liable for any damages whatsoever whether such damages are direct, indirect, incidental, consequential and irrespective of whether any claim is based on loss of revenue, investment, production, goodwill, profit, interruption of business or any other loss or any character or nature whatsoever and whether sustained by me or any Investor..</li><li>I acknowledge that the software underlying HDFCMFOnline as well as other internet related software, which are required for accessing HDFCMFOnline are the legal property of HDFC AMC/respective vendors. The permission given by HDFC AMC to access HDFCMFOnline will not convey any proprietary or ownership rights in the above software. I hereby agree that I will not attempt to modify, translate, disassemble, decompile or reverse engineer the software underlying HDFCMFOnline or create any derivative product based on the software. I further agree not to use the name, logo or mark of HDFC AMC/HDFC Mutual Fund (or any logo or mark similar thereto), and any related patent, trademarks and service marks applications, design rights, copyrights, and all or any similar or equivalent rights arising or subsisting in any country in the world.</li><li>These Terms and Conditions and/or the use of the facilities provided through HDFCMFOnline shall be governed by the laws of the India. The distributor and HDFC AMC agree to submit to the exclusive jurisdiction of the courts in Mumbai as regards any claims or matters arising under these Terms and Conditions. HDFC AMC accepts no liability whatsoever, direct or indirect, for non-compliance with the laws of any country other than the Republic of India. The mere fact that HDFCMFOnline can be accessed through internet by the distributor in a country other than India shall not be interpreted to imply that the laws of the said country govern these Terms and Conditions and/or the use of HDFCMFOnline.</li></ol></div></div>");
$templateCache.put("app/components/modal/termcondition/termcondition.modal.html","<!--dynamic terms and condition general --><ng-bind-html dynamic=Modal.dynamicTermsCondition.content></ng-bind-html><!--mobile terms and condition general--><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/termconditionEMandate.modal.html","<!--dynamic data emandate--><ng-bind-html dynamic=Modal.dynamicTermsEmandate.content></ng-bind-html><!--mobile terms and condition for emandate --><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }\n  .noTextCapital{\n    text-transform: unset !important;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/termsAndConditionSmartSwap.modal.html","<ng-bind-html dynamic=Modal.dynamicTermsSmartSwap.content></ng-bind-html><!--mobile terms and condition for smart swap --><ng-bind-html dynamic=TermsCondition.content></ng-bind-html>");
$templateCache.put("app/components/modal/tpv/tpv.modal.html","<div class=modal-content id=tpv-modal><div class=modal-header><h4 class=modal-title>TPV Enabled Bank</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><tpv></tpv></div></div>");
$templateCache.put("app/components/modal/transactionReview/changedividend.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.payload.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><tr><td>Type:</td><td>Change IDCW Option</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.payload.schemeName></td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateChangeDividend() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/dream-sip.review.html","<table class=dream-table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.additionalData.folioNumber></td></tr><tr><td>Email Id:</td><td ng-bind=Modal.modalData.additionalData.emailID></td></tr><tr><td>Phone No:</td><td ng-bind=Modal.modalData.additionalData.phoneNo></td></tr><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><table class=\"seperator-table dream-table\"><tr><td colspan=2><hr></td></tr></table><table class=dream-table><tr><td>Type:</td><td>Dream SIP</td></tr><tr><td>Dream SIP Option:</td><td ng-if=\"Modal.modalData.additionalData.sipOptions == \'Option A\' \">Option A (SIP - SWAP)</td><td ng-if=\"Modal.modalData.additionalData.sipOptions == \'Option B\' \">Option B (SIP - SWITCH - SWAP)</td></tr><tr><td ng-if=\"Modal.modalData.additionalData.sipOptions == \'Option A\' \">Scheme Name:</td><td ng-if=\"Modal.modalData.additionalData.sipOptions == \'Option B\' \">Source Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.inSipScheme></td></tr><tr ng-if=Modal.modalData.additionalData.targetSipScheme><td>Target Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.targetSipScheme></td></tr><tr><td>Frequency:</td><td ng-if=\"Modal.modalData.additionalData.sipFrequency == \'OM\' \">Monthly</td></tr><tr><td>SIP Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr><td>SWAP Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.swapInstallmentAmount}}</td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr><td>End Date:</td><td ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr><td>SIP Period (in years):</td><td ng-bind=Modal.modalData.additionalData.sipTenure></td></tr><tr><td>Investment Option:</td><td ng-if=!Modal.modalData.additionalData.dividendOption>GROWTH</td><td ng-if=Modal.modalData.additionalData.dividendOption>DIVIDENT</td></tr><tr ng-if=Modal.modalData.additionalData.dividendOption><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-if=\"Modal.modalData.additionalData.dividendOption == \'Y\' \">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</td><td ng-if=\"Modal.modalData.additionalData.dividendOption == \'N\' \">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</td></tr><tr><td>Payment Option:</td><td ng-if=\"Modal.modalData.additionalData.paymentOption == \'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Modal.modalData.additionalData.paymentOption == \'OTM\'\">OTM (One Time Mandate</td><td ng-if=\"Modal.modalData.additionalData.paymentOption == \'HEM\'\">Register E-mandate (eOTM)</td><td ng-if=\"Modal.modalData.additionalData.paymentOption == \'UPI\'\">UPI Autopay</td></tr><tr ng-if=Modal.modalData.additionalData.topupDetails><td>SIP Top-up Details:</td></tr><tr ng-if=Modal.modalData.additionalData.topupDetails.amount><td>SIP Top-up amount:</td><td ng-bind=Modal.modalData.additionalData.topupDetails.amount></td></tr><tr ng-if=Modal.modalData.additionalData.topupDetails.percentage><td>SIP Top-up Percentage:</td><td ng-bind=Modal.modalData.additionalData.topupDetails.percentage></td></tr><tr ng-if=Modal.modalData.additionalData.topupDetails.capAmount><td>SIP Top-up CAP amount:</td><td ng-bind=Modal.modalData.additionalData.topupDetails.capAmount></td></tr><tr ng-if=Modal.modalData.additionalData.topupDetails.capMonthYear><td>SIP Top-up CAP Month Year:</td><td ng-bind=Modal.modalData.additionalData.topupDetails.capMonthYear></td></tr></table><hr><table class=dream-table ng-if=\"Modal.modalData.additionalData.paymentOption == \'HEM\'\"><tr><td>Emandate Bank details:</td></tr><tr><td>Bank Name:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.bankName></td></tr><tr><td>Account Number:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.accountNumber></td></tr><tr><td>IFSC Code:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.ifscCode></td></tr><tr><td>Account Type:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.bankAcType></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.mandateAmount}}</td></tr><tr></tr><tr><td>Bank City:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.bankCity></td></tr><tr><td>Authentication Mode:</td><td ng-bind=Modal.modalData.additionalData.authenticationMode.text></td></tr><tr><td>Mandate Start Date:</td><td ng-bind=Modal.modalData.additionalData.mandateStartDate></td></tr><tr><td>Mandate End Date:</td><td ng-bind=Modal.modalData.additionalData.mandateEndDate></td></tr></table><hr><table class=dream-table ng-if=\"Modal.modalData.additionalData.paymentOption == \'OTM\'\"><tr><td>OTM Bank Name:</td><td ng-bind=Modal.modalData.additionalData.bankInfo.bankName></td></tr><tr></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div><style>.dream-table{\n      width: 100%;\n    }\n    @media (max-width:425px){\n      .review-modal .modal-body table tr td:first-child{\n        width: auto;\n      }\n    }</style>");
$templateCache.put("app/components/modal/transactionReview/dtp.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><!-- <tr>\n    <td>Email ID:</td>\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=Modal.modalData.payload.folioNumber curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=Modal.modalData.payload.folioNumber curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin-top: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><hr><table><tr><td>Type:</td><td>Transfer IDCW Plan</td></tr><tr><td>Existing Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Transferring Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetSchemeName></td></tr><tr><td>Investment Option:</td><td>{{Modal.modalData.payload.investmentOption == \'DIVIDEND\'? \'Income Distribution cum Capital Withdrawal (IDCW) Option\' : Modal.modalData.payload.investmentOption}}</td></tr><tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr><!--<tr>\n    <td>Installment Frequency: </td>\n    <td ng-bind=\"Modal.modalData.additionalData.frequency\"></td>\n  </tr>--><!--<tr>\n    <td>Amount: </td>\n    <td><i class=\"rupee-grey-icon\"></i>{{Modal.modalData.payload.amount}}</td>\n  </tr>--></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/ecart.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr ng-if=Modal.modalData.additionalData.folioNumber><td>Folio No:</td><td ng-bind=Modal.modalData.additionalData.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><!--<table style=\"margin-top: 0px\">--><!--  <tr ng-if=\"Modal.modalData.additionalData.euinCode\">--><!--    <td>EUIN Code:</td>--><!--    <td>{{Modal.modalData.additionalData.euinCode}}</td>--><!--  </tr>--><!--  <tr ng-if=\"Modal.modalData.additionalData.euinName\">--><!--    <td>EUIN Name:</td>--><!--    <td>{{Modal.modalData.additionalData.euinName}}</td>--><!--  </tr>--><!--  <tr ng-if=\"Modal.modalData.additionalData.subBrokerArn\">--><!--    <td>Sub Broker ARN:</td>--><!--    <td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td>--><!--  </tr>--><!--  <tr ng-if=\"Modal.modalData.additionalData.subBrokerCode\">--><!--    <td>Sub Broker Code:</td>--><!--    <td>{{Modal.modalData.additionalData.subBrokerCode}}</td>--><!--  </tr>--><!--</table>--><table class=ecart-review-table><tr><td colspan=2><hr></td></tr><tr><td>Transaction:</td><td>Cart ({{Modal.modalData.additionalData.transactionType == \'SIPPURCHASE\' ? \'SIP + PURCHASE\' : Modal.modalData.additionalData.transactionType}})</td></tr><tr><td>Total Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.utilService.getCommaSeperatedString(Modal.modalData.additionalData.totalAmount)}}</td></tr><tr ng-if=Modal.modalData.additionalData.dividendOption><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-bind=\"Modal.modalData.additionalData.dividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr><tr><td>Payment Mode:</td><td>{{Modal.modalData.additionalData.paymentMode.value}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\"><td>OTM Bank Name:</td><td>{{Modal.modalData.additionalData.otmBank.bankName}}</td></tr></table><table class=seperator-table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\"><tr><td colspan=2><hr></td></tr></table><table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\" class=emandate-registration-table><tr><td colspan=2>Emandate Registration Details</td></tr><tr><td>Bank Name:</td><td ng-bind=\"Modal.modalData.additionalData.eMandateBank.substr(0, t.lastIndexOf(\'-\'))\"></td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.additionalData.accountNumber></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.utilService.getCommaSeperatedString(Modal.modalData.additionalData.mandateAmount)}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr><td>Authentication Mode:</td><td ng-bind=Modal.modalData.additionalData.authenticationMode.text></td></tr><tr><td>Mandate Start Date:</td><td ng-bind=Modal.modalData.additionalData.mandateStartDate></td></tr><tr><td>Mandate End Date:</td><td ng-bind=Modal.modalData.additionalData.mandateEndDate></td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/emandate.review.html","<table class=\"table borderless emandate-review\"><tr><td>Investor Name</td><td>:</td><td ng-bind=Modal.modalData.payload.name></td></tr><tr><td>Folio No</td><td>:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><tr><td>Email ID</td><td>:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.payload.email></td></tr><tr><td>Mobile No</td><td>:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.payload.mobile></td></tr></table><table class=\"table borderless emandate-review\"><tr><td colspan=2><hr></td></tr><tr><td colspan=3><div>Emandate Registration Details</div></td></tr><tr><td>Bank Name</td><td>:</td><td ng-bind=Modal.modalData.payload.bankName></td></tr><tr><td>Account Type</td><td>:</td><td ng-bind=Modal.modalData.payload.accountType></td></tr><tr><td>Account Number</td><td>:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.payload.accNumber></td></tr><tr><td>Amount</td><td>:</td><td ng-bind=Modal.modalData.payload.maxAmount></td></tr><tr><td>Frequency</td><td>:</td><td ng-bind=Modal.modalData.payload.fequency></td></tr><tr><td>Authentication Mode</td><td>:</td><td>{{Modal.modalData.payload.authModeText}}</td></tr><tr><td>Mandate Start Date</td><td>:</td><td ng-bind=Modal.modalData.payload.omStartDate></td></tr><tr><td>Mandate End Date</td><td>:</td><td ng-bind=Modal.modalData.payload.omEndDate></td></tr><tr><td>Purpose of Mandate</td><td>:</td><td ng-bind=Modal.modalData.payload.purpose></td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateEmandateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/flexindex.review.html","<div class=col-md-6><table class=\"table borderless\"><tr><td>Distributor ARN:</td><td ng-bind=Modal.modalData.payload.brokerCode></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr><tr><td>Transaction Type:</td><td ng-bind=Modal.modalData.payload.formType></td></tr><tr><td>Source Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Target Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetScheme></td></tr><!--<tr>--><!--<td>Investment Option: </td>--><!--<td>N/A</td>--><!--</tr>--><tr><td>Amount:</td><td ng-bind=Modal.modalData.payload.amountForRegistration></td></tr></table></div><div class=col-md-6><table class=\"table borderless\"><tr><td>Investment Mode:</td><td>{{Modal.modalData.payload.investmentMode==\'F\'?\'Fixed\':\'Flexible\'}}</td></tr></table><table class=\"flex-table table\"><thead><tr><th>{{Modal.modalData.payload.investmentMode==\'F\'?\'Fixed\':\'Flexible\'}} Installments</th><th>Stages of Switch Execution<br><span style=color:#737373>S&P BSE SENSEX Levels</span></th></tr></thead><tbody><tr><td>{{Modal.modalData.payload.switchExecutionDetails.firstSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(I) </span>{{Modal.modalData.payload.switchExecutionDetails.firstSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Modal.modalData.payload.switchExecutionDetails.secondSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(II) </span>{{Modal.modalData.payload.switchExecutionDetails.secondSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Modal.modalData.payload.switchExecutionDetails.thirdSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(III) </span>{{Modal.modalData.payload.switchExecutionDetails.thirdSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{Modal.modalData.payload.switchExecutionDetails.fourthSwitchExecutionEntry.switchPercentage}}%</td><td><span class=grey-text>(IV) </span>{{Modal.modalData.payload.switchExecutionDetails.fourthSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr></tbody></table></div><hr class=full-width><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/flexsip.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr ng-if=Modal.modalData.additionalData.folioNumber><td>Folio No:</td><td ng-bind=Modal.modalData.additionalData.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><table ng-if=Modal.modalData.additionalData.sipScheme><tr><td colspan=2 style=\"padding-bottom: 20px\"><hr></td></tr><tr><td>Type:</td><td>Flex SIP</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.sipScheme></td></tr><tr ng-if=Modal.modalData.additionalData.dividendOption><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-bind=\"Modal.modalData.additionalData.dividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr><td>Installment Frequency:</td><td ng-bind=Modal.modalData.additionalData.sipFrequency></td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr><td>Flex SIP Tenure:</td><td>{{Modal.modalData.additionalData.tenureDuration}} years</td></tr><tr><td>End Date:</td><td ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr><td>Payment Mode:</td><td>{{Modal.modalData.additionalData.paymentMode.value === \'Register E-mandate (eOTM)\' ? \'E-mandate\' : Modal.modalData.additionalData.paymentMode.value}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\"><td>OTM Bank Name:</td><td>{{Modal.modalData.additionalData.otmBank.bankName}}</td></tr></table><table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\" class=emandate-registration-table><thead><tr><td colspan=2 style=\"padding-bottom: 20px\"><hr></td></tr></thead><tr><td colspan=2>Emandate Registration Details</td></tr><tr><td>Bank Name:</td><td ng-bind=\"Modal.modalData.additionalData.eMandateBank.substr(0, t.lastIndexOf(\'-\'))\"></td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.additionalData.accountNumber></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.mandateAmount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr><td>Authentication Mode:</td><td>{{Modal.modalData.additionalData.authenticationMode.text}}</td></tr><tr><td>Mandate Start Date:</td><td ng-bind=Modal.modalData.additionalData.mandateStartDate></td></tr><tr><td>Mandate End Date:</td><td ng-bind=Modal.modalData.additionalData.mandateEndDate></td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table><table ng-if=Modal.modalData.additionalData.sipFirstInstallment style=\"width: 100%\"><tr><td colspan=2 style=\"padding-bottom: 20px\"><hr></td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>Flex SIP First Installment :</td><td>{{Modal.modalData.additionalData.sipFirstInstallment ? \'Yes\': \'No\'}}</td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>Flex SIP First Installment Amount :</td><td><i style=\"top: 3px\" class=rupee-grey-icon></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td style=\"padding: 10px\">Payment Mode for First Installment of Flex SIP:</td><td>{{Modal.modalData.additionalData.fiPaymentMode.value}}</td></tr></table><hr><div class=\"clearfix flex-sip-btn\" style=\"margin-top: 20px\"><button type=submit ng-click=Modal.initiateTransactionFlexSip() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/flexstp.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr></table><!--  <tr>\n    <td>Email ID:</td>\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>--><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin-top: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><hr><table><tr><td>Transaction Type:</td><td>Flex Systematic Transfer Plan</td></tr><tr><td>Transfer from Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Transfer to Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetSchemeName></td></tr><tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr><tr><td>Frequency:</td><td ng-bind=Modal.modalData.additionalData.frequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.frequency!==\'Daily\'\"><td>Stp Day:</td><td ng-bind=Modal.modalData.additionalData.stpDay></td></tr><tr ng-if=Modal.modalData.additionalData.startDate><td>Start Date:</td><td ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr ng-if=Modal.modalData.additionalData.endDate><td>End Date:</td><td ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr ng-if=Modal.modalData.additionalData.amount><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.amount}}</td></tr><tr ng-if=Modal.modalData.additionalData.installments><td>No. of Installments:</td><td>{{Modal.modalData.additionalData.installments}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/instantRedemption.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table><tr><td>Type:</td><td>Instant Access Facility</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.schemeName></td></tr><tr ng-if=Modal.modalData.payload.amount><td>Amount:</td><td><i ng-if=\"Modal.modalData.payload.amount > 0\" class=rupee-grey-icon></i>{{(Modal.modalData.payload.amount > 0)?Modal.modalData.payload.amount:\'NA\'}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateInstantRedeemTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/modifysip.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr ng-if=Modal.modalData.additionalData.folioNumber><td>Folio No:</td><td ng-bind=Modal.modalData.additionalData.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><table style=\"margin-top: 0\" class=seperator-table ng-if=Modal.modalData.additionalData.sipScheme><tr><td>Type:</td><td>SYSTEMATIC INVESTMENT PLAN</td></tr></table><table ng-if=\"Modal.modalData.additionalData.purchaseScheme && Modal.modalData.additionalData.checkedNfoAutoSwitch\"><tr><td>Auto Switch On Maturity:</td><td ng-bind=\"Modal.modalData.additionalData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr><td>Auto Switch scheme:</td><td ng-bind=Modal.modalData.additionalData.purchaseSchemeToSwitchIn></td></tr><tr ng-if=\"Modal.modalData.additionalData.switchSchemeInvestmentOption==\'DIVIDEND\'\"><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Modal.modalData.additionalData.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr></table><div class=modify-sip-review-container><table class=table-left ng-if=Modal.modalData.additionalData.sipScheme><tr><td colspan=2 class=modify-header>Cancelled details:</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.unmodifiedData.schemeName></td></tr><tr><td>Option:</td><td ng-bind=\"Modal.modalData.unmodifiedData.growth ? \'Growth\' : \'IDCW\'\"></td></tr><tr ng-if=\"!Modal.modalData.unmodifiedData.growth && Modal.modalData.unmodifiedData.dividendOption\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-if=\"Modal.modalData.unmodifiedData.dividendOption == \'Y\'\">Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</td><td ng-if=\"Modal.modalData.unmodifiedData.dividendOption == \'N\'\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</td></tr><tr><td>Installment Frequency:</td><td ng-bind=Modal.modalData.unmodifiedData.autoFrequency></td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.autoFrequency === \'Weekly\'\"><td>SIP Day:</td><td ng-bind=Modal.modalData.unmodifiedData.weeklyDay></td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.unmodifiedData.startDate></td></tr><tr><td>End Date:</td><td ng-bind=Modal.modalData.unmodifiedData.endDate></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.unmodifiedData.amount}}</td></tr><tr><td>Payment Mode for SIP Registration:</td><td ng-if=\"Modal.modalData.unmodifiedData.paymentOption && Modal.modalData.unmodifiedData.paymentOption[0].code === \'HEM\'\">Register E-mandate (eOTM)</td><td ng-if=\"Modal.modalData.unmodifiedData.paymentOption && Modal.modalData.unmodifiedData.paymentOption[0].code === \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"Modal.modalData.unmodifiedData.paymentOption && Modal.modalData.unmodifiedData.paymentOption[0].code === \'EC\'\">Standing Instruction/Biller</td><td ng-if=\"Modal.modalData.unmodifiedData.paymentOption && Modal.modalData.unmodifiedData.paymentOption[0].code === \'UPI\'\">UPI Auto Pay</td><td ng-if=\"!Modal.modalData.unmodifiedData.paymentOption || Modal.modalData.unmodifiedData.paymentOption.length == 0\">UPI Auto Pay</td></tr><!--    <tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\">--><!--      <td>OTM Bank Name:</td>--><!--      <td>{{Modal.modalData.additionalData.otmBank.bankName}}</td>--><!--    </tr>--><tr ng-if=\"Modal.modalData.unmodifiedData.paymentOption && (Modal.modalData.unmodifiedData.paymentOption[0].code == \'OTM\' || Modal.modalData.unmodifiedData.paymentOption[0].code === \'HEM\')\"><td>Bank Name :</td><td>{{Modal.modalData.unmodifiedData.folioBankDetails.bankName}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.paymentOption && (Modal.modalData.unmodifiedData.paymentOption[0].code == \'OTM\' || Modal.modalData.unmodifiedData.paymentOption[0].code === \'HEM\')\"><td>Bank Account No :</td><td>{{Modal.modalData.unmodifiedData.folioBankDetails.bankAcNo}}</td></tr><tr ng-if=Modal.modalData.unmodifiedData.topupDetails><td>SIP Topup Enabled :</td><td>{{Modal.modalData.unmodifiedData.topupDetails ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.topupDetails && Modal.modalData.unmodifiedData.topupDetails.amount\"><td>SIP Topup Amount :</td><td><i class=rupee-grey-icon></i> {{Modal.modalData.unmodifiedData.topupDetails.amount}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.topupDetails && Modal.modalData.unmodifiedData.topupDetails.percentage\"><td>SIP Topup Percentage :</td><td>{{Modal.modalData.unmodifiedData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.topupDetails && Modal.modalData.unmodifiedData.topupDetails.frequency\"><td>SIP Topup Frequency :</td><td ng-if=\"Modal.modalData.unmodifiedData.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"Modal.modalData.unmodifiedData.topupDetails.frequency === \'H\'\">Half Yearly</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.topupDetails && Modal.modalData.unmodifiedData.topupDetails.capAmount\"><td>SIP Topup Cap Amount :</td><td><i class=rupee-grey-icon></i> {{Modal.modalData.unmodifiedData.topupDetails.capAmount}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.sipTopupEnabled && Modal.modalData.unmodifiedData.topupDetails.capMonthYear\"><td>SIP Topup Cap Month/Year :</td><td>{{Modal.modalData.unmodifiedData.topupDetails.capMonthYear}}</td></tr><tr><td>SIP First Installment :</td><td>{{Modal.modalData.unmodifiedData.sipWithFirstInstallment ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.sipWithFirstInstallment && Modal.modalData.unmodifiedData.firstInstallmentDetails\"><td>SIP First Installment Amount :</td><td>{{Modal.modalData.unmodifiedData.firstInstallmentDetails.amount}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.sipWithFirstInstallment && Modal.modalData.unmodifiedData.firstInstallmentDetails\"><td>Payment Mode for First Installment of SIP :</td><td ng-class=\"{modified : Modal.modifiedPaymentModeSI}\" ng-if=\"Modal.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == \'OTM\'\">OTM(One Time Mandate)</td><td ng-class=\"{modified : Modal.modifiedPaymentModeSI}\" ng-if=\"Modal.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == \'WEB\'\">Net Banking</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.firstInstallmentDetails && Modal.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == \'OTM\'\"><td>Bank Name :</td><td>{{Modal.modalData.unmodifiedData.firstInstallmentDetails.bankName}}</td></tr><tr ng-if=\"Modal.modalData.unmodifiedData.firstInstallmentDetails && Modal.modalData.unmodifiedData.firstInstallmentDetails.paymentMode == \'OTM\'\"><td>Bank Account No :</td><td>{{Modal.modalData.unmodifiedData.firstInstallmentDetails.bankAccNo}}</td></tr></table><div class=vertical-line></div><table class=table-right ng-if=Modal.modalData.additionalData.sipScheme><tr><td colspan=2 class=modify-header>Modified details:</td></tr><tr><td>Scheme Name:</td><td ng-class=\"{modified : Modal.modifiedScheme}\" ng-bind=Modal.modalData.additionalData.sipScheme></td></tr><tr><td>Option:</td><td ng-class=\"{modified : Modal.modifiedDividend}\" ng-bind=\"Modal.modalData.additionalData.growth ? \'Growth\' : \'IDCW\'\"></td></tr><tr ng-if=\"!Modal.modalData.additionalData.growth && Modal.modalData.additionalData.dividendOption\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-class=\"{modified : Modal.modifiedDividendSelection}\" ng-bind=\"Modal.modalData.additionalData.dividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr><tr><td>Installment Frequency:</td><td ng-class=\"{modified : Modal.modifiedFrequency}\" ng-bind=Modal.modalData.additionalData.sipFrequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.sipFrequency === \'Weekly\'\"><td>SIP Day:</td><td ng-class=\"{modified : Modal.modifiedFrequency}\" ng-bind=Modal.modalData.additionalData.weeklyDay></td></tr><tr><td>Start Date:</td><td ng-class=\"{modified : Modal.modifiedStartDate}\" ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr><td>End Date:</td><td ng-class=\"{modified : Modal.modifiedEndDate}\" ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr><td>Amount:</td><td ng-class=\"{modified : Modal.modifiedAmount}\"><i ng-class=\"{\'rupee-grey-icon\' : !Modal.modifiedAmount,\'rupee-green-icon\' : Modal.modifiedAmount,\'set-vertical-align\': Modal.modifiedAmount}\"></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr><td>Payment Mode for SIP Registration:</td><td ng-if=\"Modal.modalData.additionalData.paymentMode.value === \'Register E-mandate (eOTM)\'\" ng-class=\"{modified : Modal.modifiedPaymentMode}\">Register E-mandate (eOTM)</td><td ng-if=\"Modal.modalData.additionalData.paymentMode.value === \'OTM(One Time Mandate)\'\" ng-class=\"{modified : Modal.modifiedPaymentMode}\">OTM(One Time Mandate)</td><td ng-if=\"Modal.modalData.additionalData.paymentMode.value === \'Standing Instruction/Biller\'\" ng-class=\"{modified : Modal.modifiedPaymentMode}\">Standing Instruction/Biller</td><td ng-if=\"Modal.modalData.additionalData.paymentMode.value === \'UPI Autopay\'\" ng-class=\"{modified : Modal.modifiedPaymentMode}\">UPI Auto Pay</td></tr><!--    <tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\">--><!--      <td>OTM Bank Name:</td>--><!--      <td>{{Modal.modalData.additionalData.otmBank.bankName}}</td>--><!--    </tr>--><tr ng-if=\"Modal.modalData.additionalData.paymentMode && (Modal.modalData.additionalData.paymentMode.key == \'OTM\' || Modal.modalData.additionalData.paymentMode.key === \'HEM\') || (Modal.modalData.unmodifiedData.paymentOption.length == 0 && Modal.modalData.additionalData.paymentMode && (Modal.modalData.additionalData.paymentMode.key == \'OTM\' || Modal.modalData.additionalData.paymentMode.key === \'HEM\'))\"><td>Bank Name :</td><td ng-class=\"{modified : Modal.modifiedBankName}\" ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\">{{Modal.modalData.additionalData.otmBank.bankName}}</td><td ng-class=\"{modified : Modal.modifiedBankName}\" ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'HEM\'\">{{Modal.modalData.additionalData.eMandateBank}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.paymentMode && (Modal.modalData.additionalData.paymentMode.key == \'OTM\' || Modal.modalData.additionalData.paymentMode.key === \'HEM\') || (Modal.modalData.unmodifiedData.paymentOption.length == 0 && Modal.modalData.additionalData.paymentMode && (Modal.modalData.additionalData.paymentMode.key == \'OTM\' || Modal.modalData.additionalData.paymentMode.key === \'HEM\'))\"><td>Bank Account No :</td><td ng-class=\"{modified : Modal.modifiedBankAccountNo}\" ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'OTM\'\">{{Modal.modalData.additionalData.otmBank.bankAcNo}}</td><td ng-class=\"{modified : Modal.modifiedBankAccountNo}\" ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\">{{Modal.modalData.additionalData.accountNumber}}</td></tr><tr ng-if=\"(Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.paymentMode.key !== \'HEM\') || (Modal.modalData.unmodifiedData.topupDetails && Modal.modalData.additionalData.sipTopupEnabled == false)\"><td>SIP Topup Enabled :</td><td ng-class=\"{modified : Modal.modifiedSipTopUpEnabled || Modal.modifiedTopup}\">{{Modal.modalData.additionalData.sipTopupEnabled ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.amount && Modal.modalData.additionalData.paymentMode.key !== \'HEM\'\"><td>SIP Topup Amount :</td><td ng-class=\"{modified : Modal.modifiedTopup || Modal.modifiedTopupAmount}\"><i ng-class=\"{\'rupee-grey-icon\' :  !Modal.modifiedTopup && !Modal.modifiedTopupAmount,\'rupee-green-icon\' : Modal.modifiedTopup || Modal.modifiedTopupAmount,\'set-vertical-align\' : Modal.modifiedTopup || Modal.modifiedTopupAmount}\"></i> {{Modal.modalData.additionalData.topupDetails.amount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.percentage && Modal.modalData.additionalData.paymentMode.key !== \'HEM\'\"><td>SIP Topup Percentage :</td><td ng-class=\"{modified : Modal.modifiedTopup ||  Modal.modifiedTopupPercentage}\">{{Modal.modalData.additionalData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.frequency && Modal.modalData.additionalData.paymentMode.key !== \'HEM\'\"><td>SIP Topup Frequency :</td><td ng-class=\"{modified : Modal.modifiedTopup ||  Modal.modifiedTopupFrequency}\" ng-if=\"Modal.modalData.additionalData.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-class=\"{modified : Modal.modifiedTopup ||  Modal.modifiedTopupFrequency}\" ng-if=\"Modal.modalData.additionalData.topupDetails.frequency === \'H\'\">Half Yearly</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.capAmount && Modal.modalData.additionalData.paymentMode.key !== \'HEM\'\"><td>SIP Topup Cap Amount :</td><td ng-class=\"{modified : Modal.modifiedTopup ||  Modal.modifiedTopupCapAmount}\"><i ng-class=\"{\'rupee-grey-icon\' : !Modal.modifiedTopup && !Modal.modifiedTopupCapAmount,\'rupee-green-icon\' : Modal.modifiedTopup || Modal.modifiedTopupCapAmount, \'set-vertical-align\' : Modal.modifiedTopup || Modal.modifiedTopupCapAmount}\"></i> {{Modal.modalData.additionalData.topupDetails.capAmount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.capMonthYear && Modal.modalData.additionalData.paymentMode.key !== \'HEM\'\"><td>SIP Topup Cap Month/Year :</td><td ng-class=\"{modified : Modal.modifiedTopup ||  Modal.modifiedTopupCapMonth}\">{{Modal.topupCapMonthYear}}</td></tr><tr><td>SIP First Installment :</td><td ng-class=\"{modified : Modal.modifedSipWithFiDetails}\">{{Modal.modalData.additionalData.sipFirstInstallment ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>SIP First Installment Amount :</td><td ng-class=\"{modified :  Modal.modifiedAmount || Modal.modifedSipWithFiDetails}\"><i ng-class=\"{\'rupee-green-icon\' : Modal.modifiedAmount || Modal.modifedSipWithFiDetails,\'set-vertical-align\': Modal.modifiedAmount || Modal.modifedSipWithFiDetails}\"></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipFirstInstallment && Modal.modalData.additionalData.fiPaymentMode\"><td>Payment Mode for First Installment of SIP :</td><td ng-class=\"{modified : Modal.modifedSipWithFiDetails || Modal.modifiedPaymentModeSI}\" ng-if=\"Modal.modalData.additionalData.fiPaymentMode.value == \'OTM(One Time Mandate)\'\">OTM(One Time Mandate)</td><td ng-class=\"{modified : Modal.modifedSipWithFiDetails || Modal.modifiedPaymentModeSI}\" ng-if=\"Modal.modalData.additionalData.fiPaymentMode.value == \'Net Banking\'\">Net Banking</td></tr><tr ng-if=\"Modal.modalData.additionalData.fiPaymentMode && Modal.modalData.additionalData.fiPaymentMode.key == \'OTM\'\"><td>Bank Name :</td><td ng-class=\"{modified : Modal.modifiedFiOtmBankName ||  Modal.modifiedFIbank}\">{{Modal.modalData.additionalData.fiOtmBankName}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.fiPaymentMode && Modal.modalData.additionalData.fiPaymentMode.key == \'OTM\'\"><td>Bank Account No :</td><td ng-class=\"{modified : Modal.modifiedFiOtmAccNo || Modal.modifiedFIbank}\">{{Modal.modalData.additionalData.fiOtmAccNo}}</td></tr></table></div><table class=seperator-table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\"><tr><td colspan=2><hr></td></tr></table><table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\" class=emandate-registration-table><tr><td colspan=2>Emandate Registration Details</td></tr><tr><td>Bank Name:</td><td ng-bind=\"Modal.modalData.additionalData.eMandateBank.substr(0, t.lastIndexOf(\'-\'))\"></td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.additionalData.accountNumber></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.mandateAmount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr><td>Authentication Mode:</td><td>{{Modal.modalData.additionalData.authenticationMode.text}}</td></tr><tr><td>Mandate Start Date:</td><td ng-bind=Modal.modalData.additionalData.mandateStartDate></td></tr><tr><td>Mandate End Date:</td><td ng-bind=Modal.modalData.additionalData.mandateEndDate></td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table><hr><div class=\"clearfix approval-btn-block\"><button type=submit ng-click=Modal.initiateTransactionSipModify() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div><style>.set-vertical-align {\n    vertical-align: middle !important;\n  }</style>");
$templateCache.put("app/components/modal/transactionReview/redemption.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr></table><!--<tr>\n    <td>Email ID:</td>\n    &lt;!&ndash;<td ng-bind=\"Modal.modalData.additionalData.emailId\"></td>&ndash;&gt;\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table><tr><td>Type:</td><td>Redemption</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.schemeName></td></tr><tr ng-if=Modal.modalData.payload.amount><td>Amount:</td><td><i ng-if=\"Modal.modalData.payload.amount > 0\" class=rupee-grey-icon></i>{{(Modal.modalData.payload.amount > 0)?Modal.modalData.payload.amount:\'NA\'}}</td></tr><!--  <tr ng-if=\"Modal.modalData.payload.units\">--><!--    <td>No of Units: </td>--><!--    <td>{{(Modal.modalData.payload.units > 0)? Modal.modalData.payload.units:\'NA\'}}</td>--><!--  </tr>--><tr ng-if=\"Modal.modalData.payload.transactionMode == \'UNITS\'\"><td>No of Units:</td><td>{{(Modal.modalData.payload.units > 0)? Modal.modalData.payload.units:\'NA\'}}</td></tr><tr ng-if=\"Modal.modalData.payload.transactionMode == \'ALL_UNITS\'\"><td>No of Units:</td><td>All Free Units</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/rollover.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.payload.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><tr><td>Type:</td><td>Roll Over</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.payload.schemeName></td></tr><tr ng-if=Modal.modalData.payload.email><td>Email:</td><td ng-bind=Modal.modalData.payload.email></td></tr><tr ng-if=Modal.modalData.payload.mobile><td>Mobile:</td><td ng-bind=Modal.modalData.payload.mobile></td></tr><tr><td>No of Units:</td><td>All Units</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransactionRollover() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/sip.purchase.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName ng-class=\"{\'quick-sip-label-euin-empty\': Modal.isFromQuickSip && !Modal.modalData.additionalData.oversea_arn}\"></td></tr><tr ng-if=Modal.modalData.additionalData.folioNumber><td>Folio No:</td><td ng-bind=Modal.modalData.additionalData.folioNumber ng-class=\"{\'quick-sip-label-euin-empty-style-2\': Modal.isFromQuickSip && !Modal.modalData.additionalData.oversea_arn}\"></td></tr><!-- euin selection dropdown for quick sip if arn is not over sea --><tr ng-if=\"Modal.isFromQuickSip && !Modal.modalData.additionalData.oversea_arn\" class=quick-sip-euin-container><td>EUIN:</td><td><div class=\"input-euin input-euin-quick-sip\"><div class=\"input-select input-normal selectfield select-euin drop-arrow\"><select class=\"browser-default custom-select arrow-adjust-css\" name=selectEuin ng-change=Modal.euinChanged() ng-model=Modal.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in Modal.euinList\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=\"req text-red\">*</span></div></div></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><table ng-if=Modal.modalData.additionalData.purchaseScheme><tr><td colspan=2><hr></td></tr><tr><td>Type:</td><td>Purchase</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.purchaseScheme></td></tr><tr ng-if=Modal.modalData.additionalData.dividendOption><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-bind=\"Modal.modalData.additionalData.dividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.purchaseAmount}}</td></tr><tr><td>Payment Mode:</td><td>{{Modal.modalData.additionalData.paymentMode.value}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\"><td>OTM Bank Name:</td><td>{{Modal.modalData.additionalData.otmBank.bankName}}</td></tr></table><table ng-if=\"Modal.modalData.additionalData.purchaseScheme && Modal.modalData.additionalData.checkedNfoAutoSwitch\"><tr><td>Auto Switch On Maturity:</td><td ng-bind=\"Modal.modalData.additionalData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr><td>Auto Switch scheme:</td><td ng-bind=Modal.modalData.additionalData.purchaseSchemeToSwitchIn></td></tr><tr ng-if=\"Modal.modalData.additionalData.switchSchemeInvestmentOption==\'DIVIDEND\'\"><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Modal.modalData.additionalData.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr></table><table class=seperator-table ng-if=Modal.modalData.additionalData.sipScheme><tr><td colspan=2><hr></td></tr></table><table ng-if=Modal.modalData.additionalData.sipScheme><tr><td>Type:</td><td>SYSTEMATIC INVESTMENT PLAN</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.sipScheme></td></tr><tr ng-if=Modal.modalData.additionalData.dividendOption><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td ng-bind=\"Modal.modalData.additionalData.dividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'\"></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr><td>Installment Frequency:</td><td ng-bind=Modal.modalData.additionalData.sipFrequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.sipFrequency === \'Weekly\'\"><td>SIP Day:</td><td ng-bind=Modal.modalData.additionalData.weeklyDay></td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr><td>End Date:</td><td ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr><td>Payment Mode for SIP Registration:</td><td>{{Modal.modalData.additionalData.paymentMode.value === \'Register E-mandate (eOTM)\' ? \'E-mandate\' : Modal.modalData.additionalData.paymentMode.value}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.paymentMode.key == \'OTM\'\"><td>OTM Bank Name:</td><td>{{Modal.modalData.additionalData.otmBank.bankName}}</td></tr></table><table class=seperator-table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\"><tr><td colspan=2><hr></td></tr></table><table ng-if=\"Modal.modalData.additionalData.paymentMode.key === \'HEM\'\" class=emandate-registration-table><tr><td colspan=2>Emandate Registration Details</td></tr><tr><td>Bank Name:</td><td ng-bind=\"Modal.modalData.additionalData.eMandateBank.substr(0, t.lastIndexOf(\'-\'))\"></td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element ng-bind=Modal.modalData.additionalData.accountNumber></td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.mandateAmount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr><td>Authentication Mode:</td><td>{{Modal.modalData.additionalData.authenticationMode.text}}</td></tr><tr><td>Mandate Start Date:</td><td ng-bind=Modal.modalData.additionalData.mandateStartDate></td></tr><tr><td>Mandate End Date:</td><td ng-bind=Modal.modalData.additionalData.mandateEndDate></td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table><table class=seperator-table ng-if=Modal.modalData.additionalData.sipFirstInstallment><thead><tr><td colspan=2><hr></td></tr></thead></table><table ng-if=Modal.modalData.additionalData.sipFirstInstallment><tbody><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>SIP First Installment :</td><td>{{Modal.modalData.additionalData.sipFirstInstallment ? \'Yes\': \'No\'}}</td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>SIP First Installment Amount :</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.installmentAmount}}</td></tr><tr ng-if=Modal.modalData.additionalData.sipFirstInstallment><td>Payment Mode for First Installment of SIP:</td><td>{{Modal.modalData.additionalData.fiPaymentMode.value}}</td></tr></tbody></table><table class=seperator-table ng-if=Modal.modalData.additionalData.sipTopupEnabled><thead><tr><td colspan=2><hr></td></tr></thead></table><table><tbody><tr ng-if=Modal.modalData.additionalData.sipTopupEnabled><td>SIP Topup Enabled :</td><td>Yes</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.amount\"><td>SIP Topup Amount :</td><td><i class=rupee-grey-icon></i> {{Modal.modalData.additionalData.topupDetails.amount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.percentage\"><td>SIP Topup Percentage :</td><td>{{Modal.modalData.additionalData.topupDetails.percentage}}%</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.frequency\"><td>SIP Topup Frequency :</td><td ng-if=\"Modal.modalData.additionalData.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"Modal.modalData.additionalData.topupDetails.frequency === \'H\'\">Half Yearly</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.capAmount\"><td>SIP Topup Cap Amount :</td><td><i class=rupee-grey-icon></i> {{Modal.modalData.additionalData.topupDetails.capAmount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.sipTopupEnabled && Modal.modalData.additionalData.topupDetails.capMonthYear\"><td>SIP Topup Cap Month/Year :</td><td>{{Modal.topupCapMonthYear}}</td></tr></tbody></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() ng-disabled=\"Modal.disableButton || (Modal.isFromQuickSip && !Modal.modalData.additionalData.oversea_arn && !Modal.euinCode)\" class=\"btn btn-primary-action pull-right\">Send for Approval</button><!--  <button ng-if=\"Modal.modalData.additionalData.fromQuickSip && !Modal.modalData.additionalData.fromSipPage\" ng-click=\"Modal.editQuickSip()\" class=\"btn btn-secondary-action pull-right\" style=\"margin-right: 20px\">--><!--    Edit--><!--  </button>--></div>");
$templateCache.put("app/components/modal/transactionReview/smartswap.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=Modal.modalData.payload.folioNumber curr-mobile-number=Modal.modalData.additionalData.mobileNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=Modal.modalData.payload.folioNumber curr-email=Modal.modalData.additionalData.emailId c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table><tr><td>Type:</td><td>SMART SWAP</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.schemeName></td></tr><!--<tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\">\n    <td>Dividend Option: </td>\n    <td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-Invest\':\'Payout\'}}</td>\n  </tr>--><tr><td>Installment Frequency:</td><td ng-bind=Modal.T_CONST.DESCRIPTIONS.FREQ[Modal.modalData.payload.frequency]></td></tr><tr><td>% Percentage (per annum):</td><td>{{Modal.modalData.payload.percentage}}</td></tr><tr><td>SMART SWAP Day:</td><td ng-bind=Modal.modalData.additionalData.swpDay></td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.payload.startDate></td></tr><tr ng-if=\"Modal.modalData.payload.swpType===\'F\'\"><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.payload.amount}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/stp.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><!--<tr>\n    <td>Email ID:</td>\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=\"Modal.modalData.payload.folioNumber || Modal.modalData.additionalData.folioNumber\" curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin-top: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><hr><table><tr><td>Type:</td><td>Systematic Transfer Plan</td></tr><tr><td>Existing Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Transferring Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetSchemeName></td></tr><tr><td>Investment Option:</td><td>{{Modal.modalData.payload.stpType===\'F\'?\'Fixed Amount\':\'Capital Appreciation\'}}</td></tr><tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr><tr><td>Installment Frequency:</td><td ng-bind=Modal.modalData.additionalData.frequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.frequency!==\'Daily\'\"><td>STP Day:</td><td ng-bind=Modal.modalData.additionalData.stpDay></td></tr><tr ng-if=Modal.modalData.payload.startDate><td>Start Date:</td><td ng-bind=Modal.modalData.payload.startDate></td></tr><tr ng-if=Modal.modalData.payload.endDate><td>End Date:</td><td ng-bind=Modal.modalData.payload.endDate></td></tr><tr ng-if=\"Modal.modalData.payload.stpType!=\'V\'\"><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.payload.amount}}</td></tr><tr ng-if=\"Modal.modalData.additionalData.frequency ==\'Daily\' || Modal.modalData.additionalData.frequency ==\'Weekly\'\"><td>No of Installments:</td><td>{{Modal.modalData.payload.noOfInstallments}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/swingstp.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=Modal.modalData.payload.folioNumber curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=Modal.modalData.payload.folioNumber curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><!--<tr>\n    <td>Email ID:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.emailId\"></td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--><table><tr><td>Transaction Type:</td><td>Swing Systematic Transfer Plan</td></tr><tr><td>Transfer from Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Transfer to Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetSchemeName></td></tr><tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\"><td>IDCW Option:</td><td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-Invest\':\'Payout\'}}</td></tr><tr><td>Frequency:</td><td ng-bind=Modal.modalData.additionalData.frequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.frequency!==\'Daily\'\"><td>Stp Day:</td><td ng-bind=Modal.modalData.additionalData.stpDay></td></tr><tr ng-if=Modal.modalData.additionalData.startDate><td>Start Date:</td><td ng-bind=Modal.modalData.additionalData.startDate></td></tr><tr ng-if=Modal.modalData.additionalData.endDate><td>End Date:</td><td ng-bind=Modal.modalData.additionalData.endDate></td></tr><tr ng-if=Modal.modalData.additionalData.amount><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.additionalData.amount}}</td></tr><tr ng-if=Modal.modalData.additionalData.installments><td>No. of Installments:</td><td>{{Modal.modalData.additionalData.installments}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/switch.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><!--<tr>\n    <td>Email ID:</td>\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=Modal.modalData.payload.folioNumber curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=Modal.modalData.payload.folioNumber curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table style=\"margin-top: 0px\"><tr ng-if=Modal.modalData.additionalData.euinCode><td>EUIN Code:</td><td>{{Modal.modalData.additionalData.euinCode}}</td></tr><tr ng-if=Modal.modalData.additionalData.euinName><td>EUIN Name:</td><td>{{Modal.modalData.additionalData.euinName}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerArn><td>Sub Broker ARN:</td><td>{{\'ARN-\'+Modal.modalData.additionalData.subBrokerArn}}</td></tr><tr ng-if=Modal.modalData.additionalData.subBrokerCode><td>Sub Broker Code:</td><td>{{Modal.modalData.additionalData.subBrokerCode}}</td></tr></table><hr><table><tr><td>Type:</td><td>Switch</td></tr><tr><td>Existing Scheme:</td><td ng-bind=Modal.modalData.additionalData.sourceSchemeName></td></tr><tr><td>Transferring Scheme:</td><td ng-bind=Modal.modalData.additionalData.targetSchemeName></td></tr><tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr><tr ng-if=Modal.modalData.payload.amount><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.payload.amount}}</td></tr><tr ng-if=\"Modal.modalData.payload.transactionMode == \'UNITS\'\"><td>No of Units:</td><td ng-bind=Modal.modalData.payload.units></td></tr><tr ng-if=\"Modal.modalData.payload.transactionMode == \'ALL_UNITS\'\"><td>No of Units:</td><td>All Free Units</td></tr><tr ng-if=Modal.modalData.additionalData.checkedNfoAutoSwitch><td>Auto Switch On Maturity:</td><td ng-bind=\"Modal.modalData.additionalData.checkedNfoAutoSwitch?\'Yes\':\'No\'\"></td></tr><tr ng-if=Modal.modalData.additionalData.checkedNfoAutoSwitch><td>Auto Switch scheme:</td><td ng-bind=Modal.modalData.additionalData.autoSchemeToSwitchIn></td></tr><tr ng-if=\"Modal.modalData.additionalData.checkedNfoAutoSwitch && Modal.modalData.additionalData.switchSchemeInvestmentOption==\'DIVIDEND\'\"><td>Auto Switch Scheme IDCW Option:</td><td ng-bind=\"Modal.modalData.additionalData.autoSwitchSchemeDividendOption==\'Y\'?\'Re-Invest\':\'Payout\'\"></td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/swp.review.html","<table><tr><td>Investor Name:</td><td ng-bind=Modal.modalData.additionalData.investorName></td></tr><tr><td>Folio No:</td><td ng-bind=Modal.modalData.payload.folioNumber></td></tr><!-- <tr>\n    <td>Email ID:</td>\n    <td ng-if=\"!Modal.isEdit\">\n      <span ng-bind=\"Modal.modalData.additionalData.emailId\"></span>\n      <i class=\"edit2-icon\" ng-click=\"Modal.isEdit=true;Modal.newEmailId=Modal.modalData.additionalData.emailId;\"></i>\n    </td>\n    <td ng-if=\"Modal.isEdit\">\n      <form autocomplete=\"off\" name=\"changeEmail\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"Modal.newEmailId\" placeholder=\"Enter New Email\" ng-pattern=\"Modal.AppConstants.email_regex\"/>\n        <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Send OTP\"\n               ng-disabled=\"Modal.newEmailId==Modal.modalData.additionalData.emailId || changeEmail.email.$error.pattern\"\n               ng-click=\"Modal.sendOTP()\">\n        <input type=\"button\" class=\"btn-small btn-secondary-action\" value=\"Cancel\" ng-click=\"Modal.isEdit=false;Modal.isOTPSent=false;Modal.emailOTP=\'\'\">\n    </td>\n  </tr>\n  <tr  ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">OTP has been sent to the mentioned Email-ID. Please enter the OTP below.</td>\n  </tr>\n  <tr ng-if=\"Modal.isOTPSent\">\n    <td colspan=\"2\">\n      <input type=\"number\" placeholder=\"Enter OTP\" ng-model=\"Modal.emailOTP\"/>\n      <input type=\"button\" class=\"btn-small btn-primary-action\" value=\"Confirm\"\n             ng-disabled=\"Modal.emailOTP == undefined||Modal.emailOTP.toString().split(\'\').length!==6\"\n             ng-click=\"Modal.verifyOTP();\">\n    </td>\n  </tr>\n  <tr>\n    <td>Mobile No:</td>\n    <td ng-bind=\"Modal.modalData.additionalData.mobileNumber\"></td>\n  </tr>--></table><update-summary-email curr-email=Modal.modalData.additionalData.emailId folio-number=Modal.modalData.payload.folioNumber curr-mobile-number=Modal.modalData.additionalData.mobileNumber investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-email><update-summary-mobile curr-mobile-number=Modal.modalData.additionalData.mobileNumber folio-number=Modal.modalData.payload.folioNumber curr-email=Modal.modalData.additionalData.emailId investor-pan=Modal.modalData.additionalData.panNumber c-flag=Modal.modalData.additionalData.coperateFlag></update-summary-mobile><table><tr><td>Type:</td><td>Systematic Withdrawal Plan</td></tr><tr><td>Scheme Name:</td><td ng-bind=Modal.modalData.additionalData.schemeName></td></tr><tr><td>Investment Option:</td><td>{{Modal.modalData.payload.swpType===\'F\'?\'Fixed Amount\':\'Capital Appreciation\'}}</td></tr><!--<tr ng-if=\"Modal.modalData.payload.dividendOption!==\'Z\'\">\n    <td>Dividend Option: </td>\n    <td>{{Modal.modalData.payload.dividendOption===\'Y\'?\'Re-Invest\':\'Payout\'}}</td>\n  </tr>--><tr><td>Installment Frequency:</td><td ng-bind=Modal.modalData.additionalData.frequency></td></tr><tr ng-if=\"Modal.modalData.additionalData.frequency!==\'Daily\'\"><td>Swp Day:</td><td ng-bind=Modal.modalData.additionalData.swpDay></td></tr><tr><td>Start Date:</td><td ng-bind=Modal.modalData.payload.startDate></td></tr><tr><td>End Date:</td><td ng-bind=Modal.modalData.payload.toDate></td></tr><tr ng-if=\"Modal.modalData.payload.swpType===\'F\'\"><td>Amount:</td><td><i class=rupee-grey-icon></i>{{Modal.modalData.payload.amount}}</td></tr></table><hr><div class=clearfix><button type=submit ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action pull-right\">Send for Approval</button></div>");
$templateCache.put("app/components/modal/transactionReview/transactionReview.modal.html","<!-- Sign up Completed--><div class=\"modal-content review-modal\"><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title><i class=edit2-icon tooltip data-toggle=tooltip data-placement=top title=\"Edit SIP Details.\" style=\"margin-right: 10px\" ng-if=Modal.modalData.additionalData.fromQuickSip ng-click=Modal.editQuickSip()></i><!--      <span ng-if=\"Modal.modalData.additionalData.fromQuickSip\" ng-click=\"Modal.editQuickSip()\" class=\"glyphicon glyphicon-chevron-left back-btn-quickSip\"></span>--> Review Transaction Summary</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><div data-ng-switch=Modal.modalData.controller><div data-ng-switch-when=add><div data-ng-include=\"\'app/components/modal/transactionReview/sip.purchase.review.html\'\"></div></div><div data-ng-switch-when=many><div data-ng-include=\"\'app/components/modal/transactionReview/sip.purchase.review.html\'\" class=sip-review></div></div><div data-ng-switch-when=swp><div data-ng-include=\"\'app/components/modal/transactionReview/swp.review.html\'\"></div></div><div data-ng-switch-when=switch><div data-ng-include=\"\'app/components/modal/transactionReview/switch.review.html\'\"></div></div><div data-ng-switch-when=stp><div data-ng-include=\"\'app/components/modal/transactionReview/stp.review.html\'\"></div></div><div data-ng-switch-when=flexstp><div data-ng-include=\"\'app/components/modal/transactionReview/flexstp.review.html\'\"></div></div><div data-ng-switch-when=redemption><div data-ng-include=\"\'app/components/modal/transactionReview/redemption.review.html\'\"></div></div><div data-ng-switch-when=dtp><div data-ng-include=\"\'app/components/modal/transactionReview/dtp.review.html\'\"></div></div><div data-ng-switch-when=flexindex><div data-ng-include=\"\'app/components/modal/transactionReview/flexindex.review.html\'\"></div></div><div data-ng-switch-when=swingstp><div data-ng-include=\"\'app/components/modal/transactionReview/swingstp.review.html\'\"></div></div><div data-ng-switch-when=rollover><div data-ng-include=\"\'app/components/modal/transactionReview/rollover.review.html\'\"></div></div><div data-ng-switch-when=cdiv><div data-ng-include=\"\'app/components/modal/transactionReview/changedividend.review.html\'\"></div></div><div data-ng-switch-when=emandate><div data-ng-include=\"\'app/components/modal/transactionReview/emandate.review.html\'\"></div></div><div data-ng-switch-when=smart_swap><div data-ng-include=\"\'app/components/modal/transactionReview/smartswap.review.html\'\"></div></div><div data-ng-switch-when=flexsip><div data-ng-include=\"\'app/components/modal/transactionReview/flexsip.review.html\'\"></div></div><div data-ng-switch-when=sip_modify><div data-ng-include=\"\'app/components/modal/transactionReview/modifysip.review.html\'\" class=sip-review></div></div><div data-ng-switch-when=instant_redemption><div data-ng-include=\"\'app/components/modal/transactionReview/instantRedemption.review.html\'\"></div></div><div data-ng-switch-when=dream_sip><div data-ng-include=\"\'app/components/modal/transactionReview/dream-sip.review.html\'\"></div></div><div data-ng-switch-when=ECART><div data-ng-include=\"\'app/components/modal/transactionReview/ecart.review.html\'\"></div></div></div></div></div>");
$templateCache.put("app/components/modal/transactionSummary/transactionSummary.modal.html","<!-- Sign up Completed--><div class=modal-content id=transSum ng-init=Modal.init()><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Investor Info</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><table class=\"table borderless\"><tr><td>Investor Name</td><td>{{Modal.transactionSummary.investorName||\'--\'}}</td></tr><tr><td>Folio Number</td><td>{{Modal.transactionSummary.folioNumber||\'--\'}}</td></tr><tr><td>Primary Bank Account</td><td>{{Modal.transactionSummary.primaryBankName||\'--\'}}</td></tr></table></div><div class=modal-header><h4 class=modal-title>Transaction Info</h4></div><div class=modal-body><table class=\"table borderless\"><tr ng-if=\"Modal.transactionSummary.type !== \'FLEXSIP\'\"><td>Transaction Type</td><td>{{Modal.transactionSummary.type||\'--\'}}</td></tr><tr ng-if=\"Modal.transactionSummary.type === \'FLEXSIP\'\"><td>Transaction Type</td><td>Flex SIP</td></tr><tr><td>Status</td><td>{{Modal.transactionSummary.status||\'--\'}}</td></tr><tr><td>Scheme</td><td>{{Modal.transactionSummary.schemeName||\'--\'}}</td></tr><tr><td>Plan</td><td>{{Modal.transactionSummary.plan||\'--\'}}</td></tr><tr><td>Option</td><td>{{Modal.transactionSummary.option||\'--\'}}</td></tr><tr><td>Amount</td><td><i class=rupee-icon></i>{{(Modal.transactionSummary.amount|unit)||\'--\'}}</td></tr><tr><td>Proposed on</td><td>{{Modal.transactionSummary.transactionDate ||\'--\'}}</td></tr><tr ng-if=\"Modal.transactionSummary.status === \'EXPIRED\'\"><td>Expired on</td><td><!--{{Modal.transactionSummary.expiredOn&&Modal.moment(Modal.transactionSummary.expiredOn).format(\'DD/MM/YYYY\')||\'&#45;&#45;\'}}--> {{Modal.transactionSummary.expiredOn ||\'--\'}}<!--{{Modal.transactionSummary.expiredOn&&Modal.moment(Modal.transactionSummary.expiredOn).format(\'DD/MM/YYYY\')||\'&#45;&#45;\'}}--></td></tr><tr><td align=center colspan=2><!--action could be REMIND or REINITIATE --> <button type=submit ng-if=Modal.transactionSummary.action ng-click=Modal.initiateTransaction() class=\"btn btn-primary-action\">{{Modal.transactionSummary.action}}</button></td></tr></table></div></div>");
$templateCache.put("app/components/modal/transactionWarning/transaction-warning.modal.html","<div class=modal-content><div class=modal-header><h4 class=modal-title>Warning!!</h4><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i></div><div class=\"modal-body form-wrapper ng-scope empanelment-confirmation\"><h6 class=text-center>{{ Modal.modalData }}</h6><br><br><div class=text-center><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>Yes</button> <button class=\"btn btn-secondary-action\" ng-click=Modal.dismissModal()>No</button></div></div></div>");
$templateCache.put("app/components/modal/updateInvestor/update-investor.modal.html","<!-- Otp verification--><div class=modal-content id=updateInvestor><div class=\"loader popup\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Update Info</h4><i class=times-icon ng-click=Modal.dismissModal();></i></div><div class=modal-body><form autocomplete=off name=updateForm ng-submit=Modal.updateInfo() novalidate><div class=\"input-normal input-group date date-picker\" date-calendar data-enable=true data-viewmode=days data-date-default=Modal.investordob data-on-date-change=Modal.changeDob data-max-date=now format=DD-MMM-YYYY id=dob><input id=dobId name=dob type=text autocomplete=off required> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span> <span class=highlight></span> <span class=bar></span><label>Investor dob<span class=req>*</span></label><br><span ng-if=updateForm.dob.$dirty&&updateForm.dob.$invalid class=error-message>Please enter a valid date</span></div><button type=submit class=\"btn btn-primary-action btn-block\" ng-disabled=Modal.updateForm.$invalid>Update</button><div ng-class=\"{\'common-error\':Modal.wrongMsg}\"><span ng-show=Modal.wrongMsg ng-bind=Modal.wrongMsg></span></div></form></div></div>");
$templateCache.put("app/components/modal/widgetCampaign/widgetCampaign.modal.html","<div class=modal-content id=campaignModal ng-init=Modal.init();><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Investor List</h4><i class=times-icon ng-click=\"Modal.dismissModal(\'close\');\"></i></div><!--<div class=\"tagline text-primary text-center\">Pick investors for the campaign\n    <b><span ng-bind=\"Modal.modalData.campaignTitle\"></span></b>\n  </div>--><div class=modal-body><div class=clearfix><div class=col-md-3 style=text-align:center;line-height:30px>Selected List<!--<input type=\"search\" class=\"search-input\" ng-model=\"Modal.name\"--><!--placeholder=\"Search by investor name\"  select-on-click/>--></div><div class=col-md-4><select class=filter-list ng-model=Modal.filter ng-options=\"data.value for data in Modal.investorFilterList\" ng-change=Modal.getInvestorList()></select></div><div ng-if=\"Modal.investorTotalList.length > 0\" class=\"col-md-5 text-right\" style=text-align:center;line-height:30px>Number of investors who can be contacted digitally via email: <b>{{Modal.investorTotalList.length || 0 }} out of {{Modal.totalCount}}</b></div></div><!--<div class=\"list data-grid\" style=\"overflow:auto;max-height:300px;\">--><!--<table class=\"table\">--><!--<thead>--><!--<tr>--><!--<th>--><!--&lt;!&ndash;<span class=\"checkbox\"  ng-hide=\"Modal.name\">--><!--<input type=\"checkbox\" ng-model=\"Modal.toggleCheckAll\" ng-click=\"Modal.toggleSelection()\"--><!--title=\"Select to toggle selection\"/>--><!--<span class=\"icon-checkbox\"></span>--><!--</span>&ndash;&gt;#--><!--</th>--><!--<th>Investor Name</th>--><!--<th>PAN</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"investor in Modal.investorTotalList | filter: Modal.name\">--><!--<td data-th=\"investorId\" >{{$index+1}}.--><!--&lt;!&ndash;<span class=\"checkbox\">--><!--<input type=\"checkbox\" checklist-model=\"Modal.formData.investorList\"--><!--checklist-value=\"investor.investorId\"/>--><!--<span class=\"icon-checkbox\"></span>--><!--</span>&ndash;&gt;--><!--</td>--><!--<td data-th=\"Investor Name\" ng-bind=\"investor.name\">Aarti Agrawal</td>--><!--<td data-th=\"PAN\" ng-bind=\"investor.pan\">CLWPS6991P</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--></div><div class=modal-footer><button class=\"btn btn-primary-action\" ng-disabled=\"Modal.investorTotalList == undefined || Modal.investorTotalList.length<1\" ng-click=Modal.submitCampaignInvestorList();>Submit</button></div></div>");
$templateCache.put("app/components/modal/widgetStore/widgetSelection.modal.html","<!-- Widget Selection\n--------------------------><div class=modal-content id=widgetSore ng-init=Modal.init();><div class=\"loader widget\" style=\"position: absolute\"><span class=loading></span></div><div class=modal-header><h4 class=modal-title>Widget store</h4><div class=selected-count><span>{{Modal.selectedCounter}}</span> Widgets Selected Out of <span ng-bind=Modal.widgetList.length>6</span></div></div><div class=tagline>List of all the widgets that will appear on your dashboard screen. You can De-Select/ Select any widget you want to Add or Remove.</div><div class=modal-body><div class=\"col-md-4 col-sm-6\" ng-repeat=\"widgetData in Modal.widgetList\"><div class=widget-box ng-class=\"{\'active-widget\':widgetData.selected}\"><div class=widget-type><img ng-src={{widgetData.imageUrl}}><!--<img src=\"../../../../assets/images/widget-store/aum.png\"/>--></div><input type=checkbox ng-model=widgetData.selected ng-change=Modal.selectedCount();> <span class=\"select-bar text-center\"><div class=active-border></div><span class=circ></span> <i class=green-tick-icon></i> <span class=text ng-if=!widgetData.selected>Select</span> <span class=text ng-if=widgetData.selected>Selected</span></span></div><div class=\"text-center widget-label\">{{widgetData.widgetName}}</div></div></div><div class=modal-footer><button class=\"btn btn-primary-action\" ng-click=Modal.submitWidgetList();>Done</button></div></div>");
$templateCache.put("app/components/sidebar/login-sidebar/login-sidebar.html","<div class=\"common not-mobile\" id=login-sidebar ng-init=Sidebar.initTab()><aside class=\"login-affix side-nav\"><div class=\"not-desktop side-head-contrast\"><div class=\"col-xs-6 toggle-action\"><ul class=togglePanel><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': !Sidebar.isDarkModeEnable}\">Light</span></li><li><div class=form-switch><label class=switch><input type=checkbox ng-model=Sidebar.isDarkModeEnable ng-change=\"Sidebar.contrast(); Sidebar.toggleMode()\" class=box title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'login-active-tab\': Sidebar.isDarkModeEnable}\">Dark</span></li></ul></div><div class=\"col-xs-1 separator\"></div><ul class=col-xs-5><li ng-click=\"Sidebar.changedFont(\'decrement\')\" title=\"Decrease font size\" ng-class=\"{\'active\': Sidebar.count > -3 && Sidebar.count < 0}\">A-</li><li ng-click=\"Sidebar.changedFont(\'original\')\" title=\"Reset font size\" ng-class=\"{\'active\': Sidebar.count === 0}\">A</li><li ng-click=\"Sidebar.changedFont(\'increment\')\" title=\"Increase font size\" ng-class=\"{\'active\': Sidebar.count > 0 && Sidebar.count < 3}\">A+</li></ul></div><ul class=list-group><li ng-class=\"{\'active-link\':Sidebar.active[0]}\" class=login-sidebar-li><a href=javascript:void(0) ui-sref=login ng-click=Sidebar.activateTab(0)><span class=\"login-sidebar-icon default-icon\"></span> <span class=nav-links>Login</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[1]}\" class=empanel-sidebar-li><a href=javascript:void(0) ui-sref=distributorempanellment.arn ng-click=Sidebar.activateTab(1)><span class=\"empanel-sidebar-icon default-icon\"></span> <span class=nav-links>Empanel</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[2]}\" class=register-sidebar-li><a href=javascript:void(0) ui-sref=registration.main ng-click=Sidebar.activateTab(2)><span class=\"register-sidebar-icon default-icon\"></span> <span class=nav-links>Register</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[3]}\" class=product-sidebar-li><a ng-click=\"Sidebar.productSubMenu = !Sidebar.productSubMenu; Sidebar.activateTab(3)\" aria-expanded={{!Sidebar.productSubMenu}}><span class=\"product-sidebar-icon default-icon\"></span> <span class=nav-links>Products & Solutions</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.productSubMenu id=productSubMenu><li ng-click=Sidebar.activateTab(31) ng-class=\"{\'active-link\':Sidebar.active[31]}\" class=explore-funds-sidebar-li><a ng-click=\"Sidebar.openCalculator(\'Explore Funds\', Sidebar.HDFC_API.WEBSITE_LINK+\'explore/mutual-funds\')\"><span class=\"explore-funds-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Explore Funds</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[32]}\" class=calculator-sidebar-li><a ng-click=\"Sidebar.activateTab(32); Sidebar.openCalculator(\'Scheme Calculator\', \'https://mfiframes.mutualfundsindia.com/hdfc_sip/HDFCSIP.aspx\')\"><span class=\"calculator-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Calculator</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[4]}\" class=knowledge-center-sidebar-li><a ng-click=\"Sidebar.knowledgeCenterSubMenu = !Sidebar.knowledgeCenterSubMenu; Sidebar.activateTab(4)\" aria-expanded={{!Sidebar.knowledgeCenterSubMenu}}><span class=\"knowledge-center-sidebar-icon default-icon\"></span> <span class=nav-links>Knowledge Centre</span></a><ul class=\"collapse list-unstyled\" uib-collapse=Sidebar.knowledgeCenterSubMenu id=knowledgeCenterSubMenu><li ng-class=\"{\'active-link\':Sidebar.active[41]}\" class=factsheet-sidebar-li><a ng-click=\"Sidebar.activateTab(41); Sidebar.openCalculator(\'Factsheets\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/factsheets\')\"><span class=\"factsheet-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Factsheets</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[42]}\" class=leaflets-sidebar-li><a ng-click=\"Sidebar.activateTab(42); Sidebar.openCalculator(\'Leaflets\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/fund-literature/leaflets\')\"><span class=\"leaflets-sidebar-icon sub-default-icon\"></span> <span class=nav-sub-links>Leaflets</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[43]}\" class=product-presentation-sidebar-li><a ng-click=\"Sidebar.activateTab(43); Sidebar.openCalculator(\'Product Presentation\', Sidebar.HDFC_API.WEBSITE_LINK + \'investor-services/fund-literature/presentation\')\"><span class=\"product-presentation-sidebar-icon sub-default-icon\"></span> <span class=nav-links>Product Presentation</span></a></li></ul></li><li ng-class=\"{\'active-link\':Sidebar.active[5]}\" class=distributor-corner-li><a ng-click=\"Sidebar.activateTab(5); Sidebar.openCalculator(\'Distributor Corner\', Sidebar.HDFC_API.WEBSITE_LINK + \'distributor-corner\')\"><span class=\"distributor-corner-icon default-icon\"></span> <span class=nav-links>Distributor Corner</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[6]}\" class=about-sidebar-li><a ng-click=\"Sidebar.activateTab(6); Sidebar.openCalculator(\'About Us\', Sidebar.HDFC_API.WEBSITE_LINK + \'about-us\')\"><span class=\"about-sidebar-icon default-icon\"></span> <span class=nav-links>About Us</span></a></li><li ng-class=\"{\'active-link\':Sidebar.active[7]}\" class=contact-sidebar-li ui-sref=contactUs><a href=javascript:void(0) ng-click=Sidebar.activateTab(7) ui-sref=main.contactUs><span class=\"contact-sidebar-icon default-icon\"></span> <span class=nav-links>Contact Us</span></a></li></ul></aside><div class=mobile-sidebar-left-space ng-click=Sidebar.closeSidebar()></div></div>");
$templateCache.put("app/components/widgets/fund-in-focus/fund-in-focus.widget.html","<div class=container-fluid><div class=row><div class=col-md-12><div class=widgets><div class=widget-header><h2>{{FundInFocus.shownHeadingForFunds}}</h2></div><div class=widget-body><div class=row><div class=\"col-sm-12 col-md-12\" ng-if=\"FundInFocus.fundInFocus.length > 0\"><div class=carousel-container><div class=funds-carousel><div class=carousel-item ng-repeat=\"item in FundInFocus.fundInFocus track by $index\"><div class=\"panel panel-default fund-in-focus-panel\"><div class=panel-heading><div class=row><div class=col-md-11><div class=\"default-padding fund-name-heading\"><label>{{item.fundName}}</label></div></div><div class=col-md-2 ng-if=item.tag><div class=default-padding><p>{{item.tag}}</p></div></div><div class=col-md-2 ng-if=item.cart><div class=default-padding><p>{{item.tag}}</p></div></div></div></div><div class=panel-body><div class=row><div class=\"col-md-12 return-col\"><div class=default-padding><p>Returns</p></div><ul class=returns-action><li ng-repeat=\"returns in item.updAnnualisedReturns\"><a href=javascript:void(0) class=\"{{item.selectedOption.id == returns.key ? \'active\' : \'\'}}\" ng-click=\"FundInFocus.onOptionChange(item, returns.key, returns.value, $index)\">{{returns.key}} <span ng-if=\"returns.key !== \'Since Inception\'\">{{ returns.key == 1 ? \'year\' : \' years\'}}</span></a></li></ul></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=default-padding><p>CAGR</p></div><div class=returns-value ng-class=\"{\'cagr-in-green\': item.selectedOption.annualisedReturns && item.selectedOption.annualisedReturns > 0, \'cagr-in-red\': item.selectedOption.annualisedReturns && item.selectedOption.annualisedReturns < 0}\">{{item.selectedOption.annualisedReturns ? (item.selectedOption.annualisedReturns | truncateDecimal: 2 | unitWithDecimal: item.selectedOption.annualisedReturns)+\'%\' : \'NA\'}}<div ng-class=\"{\'show-up-green-arrow\': item.selectedOption.annualisedReturns && item.selectedOption.annualisedReturns > 0, \'show-red-down-arrow\': item.selectedOption.annualisedReturns && item.selectedOption.annualisedReturns < 0}\"></div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"default-padding pull-right clearfix\"><p>Benchmark Returns</p></div><div class=\"returns-value pull-right clearfix\">{{item.selectedOption.benchmarkReturn ? (item.selectedOption.benchmarkReturn | truncateDecimal: 2 | unitWithDecimal:item.selectedOption.benchmarkReturn)+\'%\' : \'NA\'}}</div></div></div><div class=\"row nav-and-risk-row\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"default-padding nav-date\" ng-if=!FundInFocus.isObjectType(item.navDateTimestamp)><p>NAV <span ng-if=item.navDateTimestamp>(as of {{item.navDateTimestamp}})</span></p></div><div class=\"default-padding nav-date\" ng-if=FundInFocus.isObjectType(item.navDateTimestamp)><p>NAV <span ng-if=item.selectedOption.navDateTimestamp>(as of {{item.selectedOption.navDateTimestamp}})</span></p></div><div class=returns-value ng-if=!FundInFocus.isObjectType(item.navAmount)>{{item.navAmount ? \'₹\' + (item.navAmount | truncateDecimal:4 | unitWithDecimal:item.navAmount) : \'NA\'}}</div><div class=returns-value ng-if=FundInFocus.isObjectType(item.navAmount)>{{item.selectedOption.navAmount ? \'₹\' + (item.selectedOption.navAmount | truncateDecimal:4 | unitWithDecimal:item.navAmount) : \'NA\'}}</div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"default-padding pull-right clearfix riskometer-fund-in-focus-img-wrapper\"><p>Riskometer <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'Moderate\' || item.riskReturnProfile === \'Moderate Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderate.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'Moderately low risk\' || item.riskReturnProfile === \'Low to Moderate Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderately-low.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'Moderately high\' || item.riskReturnProfile === \'Moderately High Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/moderately-high.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'Low risk\' || item.riskReturnProfile === \'Low\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/low.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'Very High\' || item.riskReturnProfile === \'Very High Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/very-high.png/>\'\"></i> <i class=\"tooltip-info-icon base-tooltip\" ng-if=\"item.riskReturnProfile === \'High risk\' || item.riskReturnProfile === \'High\' || item.riskReturnProfile === \'High Risk\'\" tooltip-placement=left uib-tooltip-html=\"\'<img src=/assets/images/logos/riskmeter-info/high.png/>\'\"></i></p></div><div class=\"returns-value pull-right clearfix\"><div class=riskmeter><img src=assets/images/logos/riskometer/moderate1.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'Moderate\' || item.riskReturnProfile === \'Moderate Risk\'\"> <img src=assets/images/logos/riskometer/moderately-low.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'Moderately low risk\' || item.riskReturnProfile === \'Low to Moderate Risk\'\"> <img src=assets/images/logos/riskometer/moderately-high.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'Moderately high\' || item.riskReturnProfile === \'Moderately High Risk\'\"> <img src=assets/images/logos/riskometer/low.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'Low risk\' || item.riskReturnProfile === \'Low\'\"> <img src=assets/images/logos/riskometer/very-high.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'Very High\' || item.riskReturnProfile === \'Very High Risk\'\"> <img src=assets/images/logos/riskometer/high.svg alt={{item.riskReturnProfile}} ng-if=\"item.riskReturnProfile === \'High risk\' || item.riskReturnProfile === \'High\' || item.riskReturnProfile === \'High Risk\'\"><div class=blue>{{item.riskReturnProfile}}</div></div></div></div></div><div class=\"row benchmark-row\"><div class=col-md-12><div class=\"default-padding benchmark\">Benchmark for Fund: <strong>{{item.benchmarkForFund[0] ? item.benchmarkForFund[0] : \'NA\'}}</strong></div></div></div><div class=row><div class=col-md-12><div class=select_box><select ng-if=item.regularSchemes class=\"fund-select select-scheme-list\" name=sInScheme1 id=sInScheme1 ng-model=item.schemeCode ng-options=\"scheme.schemeCode as scheme.schemeName for scheme in item.regularSchemes\"><option value=\"\">Select a Plan Option</option></select><select ng-if=item.regularScheme class=\"fund-select select-scheme-list\" name=sInScheme1 id=sInScheme1 ng-model=item.schemeCode ng-options=\"scheme.schemeCode as scheme.schemeName for scheme in item.regularScheme\"><option value=\"\">Select a Plan Option</option></select></div></div></div></div><div class=panel-footer><div class=footer-action><a ng-click=\"FundInFocus.openCalculator(item.fundName, FundInFocus.websiteLink + \'explore/mutual-funds/\' + item.suggestedUrl + \'/regular\')\">Know More</a> <a href=javascript:void(0) ng-click=item.proccedToLogin(item.schemeCode);>Invest Now</a></div></div></div></div></div></div></div><div class=\"col-sm-12 col-md-12\" ng-if=\"FundInFocus.fundInFocus.length === 0\"><p style=\"margin-top: 0px\" class=nodata><strong>No data available</strong></p></div></div></div><div class=widget-footer><div class=widget-actions><a class=\"btn btn-secondary-action\" ng-click=\"FundInFocus.openCalculator(\'Product & Solutions\', FundInFocus.websiteLink + \'explore/mutual-funds\')\">View All Schemes</a></div></div></div></div></div></div>");
$templateCache.put("app/components/widgets/knowledge-center/knowledge-center.widget.html","<div class=\"container-fluid knowledge-center-prelogin-widget\"><div class=row><div class=\"col-md-12 mobile-centre-only\"><div class=widgets><div class=\"widget-header mobile-widget-header-only\"><h2>Knowledge Centre</h2></div><div class=widget-body><div class=\"row desktop-view-knowledge-centre\"><div class=main-card-container ng-repeat=\"center in KnowledgeCenterWidget.widgetData | orderBy: \'index\'\" ng-if=\"KnowledgeCenterWidget.widgetData.length > 0\"><div class=widget-card><div class=card-header><div><label>{{center.header}}</label></div><div><a href=javascript:void(0) ng-click=\"KnowledgeCenterWidget.openCalculator(center.header, center.headerUrl)\">View All <i class=forward-arrow></i></a></div></div><div class=card-body ng-click=KnowledgeCenterWidget.performAction(center.redirectUrl)><div><img ng-src={{center.contentPath}} alt={{center.header}}></div></div><div class=card-action ng-click=KnowledgeCenterWidget.performAction(center.redirectUrl)><div><label>{{center.content}}</label></div><div><span>Know More</span></div><!--                  <ng-bind-html dynamic=\"center.content\"></ng-bind-html>--></div></div></div><div class=\"col-sm-12 col-md-12\" ng-if=\"KnowledgeCenterWidget.widgetData.length === 0\"><p style=\"margin-top: 0px\" class=nodata><strong>No data available</strong></p></div></div><div class=mobile-view-knowledge-centre><div class=main-container ng-repeat=\"knowledgeCenter in KnowledgeCenterWidget.widgetData | orderBy: \'index\'\"><div class=all-content-wrapper><div class=top-navigation-wrapper><div class=head-title>{{knowledgeCenter.header}}</div><div class=view-head-with-action><a href=javascript:void(0) class=view-all-div ng-click=\"KnowledgeCenterWidget.openCalculator(knowledgeCenter.header, knowledgeCenter.headerUrl)\">View All <img src=../../../../assets/images/icons/red-greater-than-arrow.svg></a></div></div><div class=img-and-action-wrapper ng-click=KnowledgeCenterWidget.performAction(knowledgeCenter.redirectUrl)><div class=img-wrapper><img ng-src={{knowledgeCenter.contentPath}} alt={{knowledgeCenter.header}}></div><div class=action-wrapper><!--                    <ng-bind-html dynamic=\"knowledgeCenter.content\"></ng-bind-html>--><div><label>{{knowledgeCenter.content}}</label></div><div><span>Know More</span></div></div></div></div></div><div class=\"col-sm-12 col-md-12\" ng-if=\"KnowledgeCenterWidget.widgetData.length === 0\"><p style=\"margin-top: 0px\" class=nodata><strong>No data available</strong></p></div></div></div></div></div></div></div>");
$templateCache.put("app/components/widgets/quick-sip/quick-sip.widget.html","<section class=\"quick-sip-widget quickSip\" ng-init=QuickSipTile.init()><div class=\"loader quickSipTileLoader\" style=\"position: absolute\"><span class=loading></span></div><div class=title-main-container><div class=title-info-head><span>Quick SIP</span></div></div><!-- scheme list view ui start here --><div class=row><div class=col-md-12><div class=select_box><div class=\"input-select input-normal\"><input type=text name=sipScheme id=sipScheme class=fund-select ng-change=QuickSipTile.filterSipSchemeList($event) ng-model=QuickSipTile.formData.inSchemeName ng-focus=QuickSipTile.filterSipSchemeList($event) autocomplete=off required> <span class=highlight></span> <span class=bar></span><label class=\"set-font-weight-500 set-font-weight-500\">Select Scheme</label><drop-down list-data=QuickSipTile.sipSchemeList display-key=scheme hdfc-click=QuickSipTile.selectSipScheme(data) model=QuickSipTile.formData.inSchemeCode for=sipScheme></drop-down></div></div></div></div><!-- scheme list view ui end here --><!-- quick sip widget proceed button starts here --><div class=row><div class=col-md-12><div class=btn-container><button ng-class=\"{\'anything-disabled\': !QuickSipTile.formData.inSchemeCode}\" class=\"btn-primary-action btn-dark\" ng-disabled=!QuickSipTile.formData.inSchemeCode ng-click=QuickSipTile.searchInvestor()>Proceed</button></div></div></div><!-- quick sip widget proceed button ends here --></section>");
$templateCache.put("app/distributor/profile/bank-update/bank-update.html","<section class=\"main-section distributor-profile\" ng-init=DistributorBankUpdate.init()><div class=\"content-header title-header\"><h5>Change of Bank Details</h5></div><div class=container-fluid><div class=row><div class=col-md-12><div class=\"row distributor-bank-update\"><div class=col-md-12><div class=form-box><form autocomplete=off name=DistributorBankUpdate.bankForm novalidate><label class=add-bank-details>Provide New Bank Details</label><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:DistributorBankUpdate.bankForm.ifsccode.$dirty && DistributorBankUpdate.bankForm.ifsccode.$invalid}\"><input type=text ng-model=DistributorBankUpdate.formData.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=DistributorBankUpdate.IFSC_REGEX capitalize ng-change=DistributorBankUpdate.clearBankField() ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode} required ng-disabled=!DistributorBankUpdate.formData.bankDetails.ifsccode ng-class={enable:DistributorBankUpdate.formData.bankDetails.ifsccode} ng-readonly=DistributorBankUpdate.formData.bankDetails.ifsccode> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=DistributorBankUpdate.selectIFSC()></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"DistributorBankUpdate.bankForm.ifsccode.$dirty && DistributorBankUpdate.bankForm.ifsccode.$invalid\"><span class=error-input ng-show=DistributorBankUpdate.bankForm.ifsccode.$error.required ng-bind=DistributorBankUpdate.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=DistributorBankUpdate.bankForm.ifsccode.$error.pattern ng-bind=DistributorBankUpdate.validateData.IFSC_CODE_REGEX></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:DistributorBankUpdate.bankForm.bankName.$dirty && DistributorBankUpdate.bankForm.bankName.$invalid}\"><input type=text ng-model=DistributorBankUpdate.formData.bankDetails.bankName name=bankName required ng-disabled=!DistributorBankUpdate.formData.bankDetails.bankName ng-class={enable:DistributorBankUpdate.formData.bankDetails.bankName} ng-readonly=DistributorBankUpdate.formData.bankDetails.bankName> <span ng-show=\"DistributorBankUpdate.bankForm.bankName.$dirty && DistributorBankUpdate.bankForm.bankName.$invalid\"><span class=error-input ng-show=DistributorBankUpdate.bankForm.bankName.$error.required ng-bind=DistributorBankUpdate.validateData.BANK_NAME_REQUIRED></span></span><label>Bank Name<span class=req>*</span></label></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:DistributorBankUpdate.bankForm.bankBranch.$dirty && DistributorBankUpdate.bankForm.bankBranch.$invalid}\"><input type=text ng-model=DistributorBankUpdate.formData.bankDetails.bankBranch name=bankBranch required autocomplete=off capitalize maxlength=40 ng-disabled=!DistributorBankUpdate.formData.bankDetails.ifsccode ng-class={enable:DistributorBankUpdate.formData.bankDetails.bankBranch} ng-readonly=DistributorBankUpdate.formData.bankDetails.bankBranch> <span class=highlight disabled></span> <span class=bar></span><label>Bank Branch<span class=req>*</span></label><span ng-show=\"DistributorBankUpdate.bankForm.bankBranch.$dirty && DistributorBankUpdate.bankForm.bankBranch.$invalid\"><span class=error-input ng-show=DistributorBankUpdate.bankForm.bankBranch.$error.required ng-bind=DistributorBankUpdate.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=selectfield ng-class=\"{error:DistributorBankUpdate.bankForm.accountType.$dirty && DistributorBankUpdate.bankForm.accountType.$invalid}\"><select class=\"select-box custom-select selectCustomMob\" name=accountType ng-model=DistributorBankUpdate.formData.bankDetails.accountType ng-options=\"_type as _type.accountType for _type in DistributorBankUpdate.bankTypeList\" required ng-disabled=!DistributorBankUpdate.formData.bankDetails.ifsccode ng-class={disablefield:!DistributorBankUpdate.formData.bankDetails.ifsccode} ng-init=\"DistributorBankUpdate.formData.bankDetails.accountType=DistributorBankUpdate.formData.bankDetails.accountType?DistributorBankUpdate.formData.bankDetails.accountType:null\"><option value=\"\" selected>Account Type</option></select><span ng-show=\"DistributorBankUpdate.bankForm.accountType.$dirty && DistributorBankUpdate.bankForm.accountType.$invalid\"><span class=error-input ng-show=DistributorBankUpdate.bankForm.accountType.$error.required ng-bind=DistributorBankUpdate.validateData.ACCOUNT_TYPE_REQUIRED></span> </span><span class=req>*</span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:(DistributorBankUpdate.accModelDirty &&\n                          (!DistributorBankUpdate.formData.bankDetails.accountNumber.split(\'\').length || DistributorBankUpdate.formData.bankDetails.accountNumber.split(\'\').length<1))}\"><input type=text easyassist-key=mask-element ng-model=DistributorBankUpdate.formData.bankDetails.accountNumber maxlength=20 name=accountNumber required autocomplete=off directive.mask ng-change=\"DistributorBankUpdate.accFocus();DistributorBankUpdate.restrictAccountAsAlpha(DistributorBankUpdate.formData.bankDetails.accountNumber,\'AccountNum\');\" ng-keydown=DistributorBankUpdate.copyPasteHandler($event) capitalize ng-disabled=!DistributorBankUpdate.formData.bankDetails.ifsccode ng-class={enable:DistributorBankUpdate.formData.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=DistributorBankUpdate.accModelDirty><span class=error-input ng-show=DistributorBankUpdate.bankForm.accountNumber.$error.required ng-bind=DistributorBankUpdate.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(DistributorBankUpdate.formData.bankDetails.accountNumber.split(\'\').length !=0 && DistributorBankUpdate.formData.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=DistributorBankUpdate.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:DistributorBankUpdate.bankForm.verifyAccountNumber.$dirty && DistributorBankUpdate.bankForm.verifyAccountNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=DistributorBankUpdate.formData.bankDetails.verifyAccountNumber maxlength=20 limit-to=20 ng-maxlength=20 name=verifyAccountNumber required autocomplete=off ng-change=\"DistributorBankUpdate.restrictAccountAsAlpha(DistributorBankUpdate.formData.bankDetails.verifyAccountNumber,\'verifyAc\')\" capitalize ng-disabled=!DistributorBankUpdate.formData.bankDetails.ifsccode ng-class={enable:DistributorBankUpdate.formData.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"DistributorBankUpdate.bankForm.verifyAccountNumber.$dirty && DistributorBankUpdate.bankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=\"DistributorBankUpdate.bankForm.verifyAccountNumber.$error.maxlength && !DistributorBankUpdate.bankForm.verifyAccountNumber.$error.required\" ng-bind=DistributorBankUpdate.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"DistributorBankUpdate.bankForm.verifyAccountNumber.$error.pattern && !DistributorBankUpdate.bankForm.verifyAccountNumber.$error.maxlength && !DistributorBankUpdate.bankForm.verifyAccountNumber.$error.required\" ng-bind=DistributorBankUpdate.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div></div><div class=row ng-if=DistributorBankUpdate.note style=\"padding-bottom: 12px;padding-top: 20px\"><div class=col-md-12><ng-bind-html dynamic=DistributorBankUpdate.note></ng-bind-html></div></div><div class=\"row form-grid\" ng-show=\"DistributorBankUpdate.formData.bankDetails.pennyDropValid === false\"><p><strong>Upload New Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Account Number and Name should be printed on the face of cheque.Max file size should be less than or equal to 3 MB.File format should be tiff, jpg, jpeg, png and pdf extension.\"></i> </strong></p><div class=col-md-6><div class=\"form-group file-align\"><span class=\"file-name text-blue\" ng-if=\"DistributorBankUpdate.fileType === \'tif\' || DistributorBankUpdate.fileType === \'tiff\' || DistributorBankUpdate.fileType === \'pdf\'\"><a href=javascript:void(0) ng-click=\"DistributorBankUpdate.downloadFile(DistributorBankUpdate.formData.chequeLeafUrl,DistributorBankUpdate.fileType,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"DistributorBankUpdate.fileType == \'jpg\' ||  DistributorBankUpdate.fileType == \'jpeg\' || DistributorBankUpdate.fileType == \'png\'\" ng-click=DistributorBankUpdate.openUploadedDoc(DistributorBankUpdate.formData.chequeLeafUrl)>{{DistributorBankUpdate.chequeLeaf}}</span> <span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff,.png,.pdf file-model=DistributorBankUpdate.myFile targetimg=showingImgId upload=DistributorBankUpdate.uploadFile(file) ng-required=\"DistributorBankUpdate.chequeLeaf !==\'\'\"><label for=uploadFileId class=\"btn-upload btn-secondary-action\">{{DistributorBankUpdate.fileType ?\'Change\':\'Choose File\'}}</label></span><span ng-if=DistributorBankUpdate.chooseAFileNew>No File Chosen</span></div></div></div><ng-bind-html dynamic=DistributorBankUpdate.dynamicNoteValidate.content></ng-bind-html><div class=\"row form-grid\"><div class=col-md-12><div class=\"tc-block declaration\"><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=DistributorBankUpdate.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i><p class=checkbox-text>I have read and understood <a ng-click=DistributorBankUpdate.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</p></div></div></div></div></div><div class=break-line></div><div class=\"row form-grid\" ng-if=DistributorBankUpdate.bank_Update_Declaration><div class=col-md-12><div class=\"tc-block declaration\"><h6>Declaration</h6><div><div class=checkbox><div><input name=isCheckedDeclaration ng-model=DistributorBankUpdate.isCheckedDeclaration type=checkbox required> <i class=icon-checkbox></i></div><div><p class=checkbox-text>{{DistributorBankUpdate.bank_Update_Declaration}}</p></div></div></div></div></div></div><div class=\"form-footer form-content clearfix\"><div class=\"pull-left back\"><a href=javascript:void(0) class=btn-back ng-click=DistributorBankUpdate.goBack()><i class=back-arrow-icon></i>Back</a></div><div class=\"pull-right flex-style\"><button type=button class=\"btn btn-secondary-action btn-next\" ng-click=DistributorBankUpdate.cancelTransaction();>Cancel</button> <button type=button ng-disabled=\"DistributorBankUpdate.bankForm.$invalid || DistributorBankUpdate.bankForm.verifyAccountNumber.$invalid\" class=\"btn btn-primary-action btn-next\" ng-if=\"DistributorBankUpdate.enabledSubmitButton == true\" ng-click=DistributorBankUpdate.validatePennyDrop()>Validate</button> <button type=button ng-disabled=\"DistributorBankUpdate.bankForm.$invalid || DistributorBankUpdate.bankForm.verifyAccountNumber.$invalid || (DistributorBankUpdate.formData.bankDetails.pennyDropValid == false && !DistributorBankUpdate.formData.chequeLeafUrl)\" ng-if=\"DistributorBankUpdate.enabledSubmitButton == false\" class=\"btn btn-primary-action btn-next\" ng-click=DistributorBankUpdate.submitBankForm();>Submit</button></div></div></form></div></div></div></div></div></div></section>");
$templateCache.put("app/investors/add/folio/add.app-details.html","<div class=tab-content ng-init=AppDetails.init();><!-- --><div class=\"loader popup\"><span class=loading></span></div><button class=\"mobile-show mobile-accordion clearfix\"><a data-toggle=tab href=#applicant-details><strong>Sole Applicant Details</strong><i class=\"accordian-arrow-down-icon pull-right\"></i></a></button><div id=applicant-details class=\"tab-pane fade in active\"><form autocomplete=off name=AppDetails.soleApplicantForm ng-submit=AppDetails.submitApplicantDetails() novalidate><div class=form-content><div class=row><p style=\"padding-bottom: 20px\"><strong>Contact Details</strong></p><div ng-if=\"(!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email && AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo)\n              || (!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo && AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email)\"><p class=update-contact-warning>{{AppDetails.CONST.UPDATE_CONTACT_ERROR_FILL}}</p></div><div ng-if=\"!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo && !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email\"><p class=update-contact-warning>{{AppDetails.CONST.UPDATE_CONTACT_ERROR_BOTH}}</p></div><div class=\"col-md-6 email-block\"><update-new-folio-email pan=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.panNumber dob=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor===true?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob:AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.dob\" curr-email=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email curr-mobile-number={{AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo}} update-contact-info=\"AppDetails.updateContactInfo(\'email\')\" show-edit=AppDetails.showEditEmail flow-type=folio-creation-post-login kyc-email=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.oldemail hide-ui-fnc=\"AppDetails.hideUiFnc(\'mobile\')\" hide-ui=AppDetails.hideEditEmail show-ui-fnc=\"AppDetails.showUiFnc(\'mobile\')\"></update-new-folio-email></div><div class=\"col-md-6 email-block\"><update-new-folio-mobile pan=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.panNumber dob=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor===true?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.guardianDob:AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.dob\" curr-mobile-number=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo curr-email={{AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email}} update-contact-info=\"AppDetails.updateContactInfo(\'mobile\')\" show-edit=AppDetails.showEditMobile flow-type=folio-creation-post-login kyc-mobile=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.oldmobileNo hide-ui-fnc=\"AppDetails.hideUiFnc(\'email\')\" hide-ui=AppDetails.hideEditMobile show-ui-fnc=\"AppDetails.showUiFnc(\'email\')\"></update-new-folio-mobile></div></div></div><div ng-class=\"{\'anything-disabled\' : !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.email || !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo}\"><div class=form-content style=\"margin-top: -26px\"><div class=row ng-if=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor><div class=\"form-label mr20 mrb20 col-md-12\"><strong>Minor’s Details</strong></div><div class=\"col-md-4 select-pdt10\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:AppDetails.soleApplicantForm.gender.$dirty && AppDetails.soleApplicantForm.gender.$invalid}\"><select class=\"browser-default custom-select\" name=gender ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.gender ng-init=\"AppDetails.gender= AppDetails.gender ? AppDetails.gender: null\" ng-options=\"data.key as data.value for data in AppDetails.genderList\" required><option value=\"\" selected>Gender</option></select><label ng-if=AppDetails.gender>Gender</label><span ng-show=\"AppDetails.soleApplicantForm.gender.$dirty && AppDetails.soleApplicantForm.gender.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.gender.$error.required ng-bind=AppDetails.validateData.GENDER_REQUIRED></span> </span><span class=\"req text-red\">*</span></div></div><div class=col-md-4><div class=\"input-normal mgt13\" ng-class=\"{error:AppDetails.soleApplicantForm.minorName.$dirty && AppDetails.soleApplicantForm.minorName.$invalid}\"><input type=text name=minorName ng-maxlength=40 limit-to=40 maxlength=40 ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minorName ng-pattern=pattern.name_regex required> <span class=highlight></span> <span class=bar></span><label>Minor\'s Name<span class=\"req text-red\">*</span></label><span ng-show=\"AppDetails.soleApplicantForm.minorName.$dirty && AppDetails.soleApplicantForm.minorName.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.minorName.$error.required ng-bind=AppDetails.validateData.MINOR_NAME></span> <span class=error-input ng-show=\"AppDetails.soleApplicantForm.minorName.$error.pattern && !AppDetails.soleApplicantForm.minorName.$error.required\" ng-bind=AppDetails.validateData.MINOR_VALID_NAME></span></span></div></div><div class=col-md-4><div class=\"input-normal mgt13\" style=\"position: relative\" ng-class=\"{error:AppDetails.soleApplicantForm.dob.$dirty && AppDetails.soleApplicantForm.dob.$invalid}\"><input type=text name=minorDob id=minorDobId easyassist-key=mask-element date-calendar date-default=AppDetails.defaultDob format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=AppDetails.minDateMinor data-on-date-change=AppDetails.changeMinorDob showdefault=\"{{\'\'+!!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.dob}}\" required> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon style=z-index:9></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--><label style=\"z-index: 9\">DD-MMM-YYYY <span class=\"req text-red\">*</span></label><span ng-show=\"AppDetails.soleApplicantForm.dob.$dirty && AppDetails.soleApplicantForm.dob.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.dob.$error.required>{{AppDetails.validateData.MINOR_DOB}}</span></span></div></div></div><div class=\"row mrg20\" ng-if=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor><div class=col-md-4><p class=pdl0><strong>Upload Minor\'s Age Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Max file size should be less than or equal to 2 MB. File format should be tiff, tif, jpg and jpeg extension.\"></i> </strong><span class=req>*</span></p><div class=\"form-group mgt15\"><span class=upload-button><input id=minorAgeProof type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=AppDetails.minorAgeProof targetimg=showingImgId upload=AppDetails.uploadFile(file)><label for=minorAgeProof class=\"btn-upload btn-secondary-action\">{{AppDetails.minorAgeProof?\'Change\':\'Choose File\'}}</label></span><span class=\"file-name text-blue\" ng-if=\"AppDetails.formData.minorAgeProofFileType === \'tif\' || AppDetails.formData.minorAgeProofFileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"AppDetails.downloadFile(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof,AppDetails.formData.minorAgeProofFileType,\'minorAgeProof\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"AppDetails.formData.minorAgeProofFileType == \'jpg\' ||  AppDetails.formData.minorAgeProofFileType == \'jpeg\'\" ng-click=AppDetails.openUploadedDoc(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof)>{{AppDetails.formData.minorAgeProofName}}</span></div></div></div><div class=\"row mrg20\" ng-if=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor><div class=col-md-4><p class=pdl0><strong>Guardian:</strong></p></div></div><div class=\"row mrg20\" ng-if=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor><div class=col-md-4><div class=\"input-normal selectfield input-normal\" ng-class=\"{error:AppDetails.soleApplicantForm.minorRelationship.$dirty && AppDetails.soleApplicantForm.minorRelationship.$invalid}\"><select class=\"browser-default custom-select\" name=minorRelationship ng-model=AppDetails.formData.folioCreationRequestCO.guardianDetails.relationship ng-options=\"relationship.value as relationship.name for relationship in AppDetails.minorRelationshipsList\" easyassist-key=mask-element required><option value=\"\" selected>Relationship With Minor</option></select><span class=highlight></span> <span class=bar></span> <span class=\"req text-red\">*</span></div><span ng-show=\"AppDetails.soleApplicantForm.minorRelationship.$dirty && AppDetails.soleApplicantForm.minorRelationship.$invalid\"><span class=\"error-input error error-message\" ng-show=AppDetails.soleApplicantForm.minorRelationship.$error.required>Please select Relationship</span></span></div><div class=col-md-4><p class=pdl0><strong>Upload Relation Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Max file size should be less than or equal to 2 MB. File format should be tiff, tif, jpg and jpeg extension.\"></i></strong></p><div class=\"form-group mgt15\"><span class=upload-button><input ng-disabled=\"AppDetails.formData.folioCreationRequestCO.guardianDetails.relationship==null\" ng-class=\"{\'disabled-upload\': AppDetails.formData.folioCreationRequestCO.guardianDetails.relationship==null}\" id=uploadGurdianAgeProof type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=AppDetails.minorGaurdianAgeProof targetimg=showingImgId upload=AppDetails.uploadGuardianProofFile(file)><label for=uploadGurdianAgeProof class=\"btn-upload btn-secondary-action\">{{AppDetails.formData.minorGaurdianAgeProof?\'Change\':\'Choose File\'}}</label></span><span class=\"file-name text-blue\" ng-if=\"AppDetails.formData.guardianProofFileType === \'tif\' || AppDetails.formData.guardianProofFileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"AppDetails.downloadFile(AppDetails.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl,AppDetails.formData.guardianProofFileType,\'guardianProof\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"AppDetails.formData.guardianProofFileType == \'jpg\' ||  AppDetails.formData.guardianProofFileType == \'jpeg\'\" ng-click=AppDetails.openUploadedDoc(AppDetails.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl)>{{AppDetails.formData.minorGaurdianFileName}}</span></div></div></div><div class=\"row mrg20\"><p><strong>Tax Status</strong></p><div class=col-md-4><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:AppDetails.soleApplicantForm.taxStatusCode.$dirty && AppDetails.soleApplicantForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in AppDetails.taxStatusList\" ng-change=AppDetails.changedTaxStatus() ng-disabled=\"AppDetails.formData.folioCreationRequestCO.nriFlag == false\" easyassist-key=mask-element required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"AppDetails.soleApplicantForm.taxStatusCode.$dirty && AppDetails.soleApplicantForm.taxStatusCode.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.taxStatusCode.$error.required ng-bind=AppDetails.validateData.TAX_STATUS></span> </span><span class=req>*</span></div></div></div><div class=\"row mrg20\"><p><strong>{{AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor?\"Guardian\'s Income Details\":\"Income Details\"}}</strong></p><div class=col-md-4><div class=\"input-select selectfield input-normal selectfield mgt20\" ng-class=\"{error:AppDetails.soleApplicantForm.occupation.$dirty && AppDetails.soleApplicantForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in AppDetails.occupationList\" ng-init=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.occupation=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.occupation?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.occupation:null\" ng-change=AppDetails.setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><span ng-show=\"AppDetails.soleApplicantForm.occupation.$dirty && AppDetails.soleApplicantForm.occupation.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.occupation.$error.required ng-bind=AppDetails.validateData.OCCUPATION></span> </span><span class=req>*</span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:AppDetails.soleApplicantForm.grossAnnualIncome.$dirty\n                 && AppDetails.soleApplicantForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=\"AppDetails.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome ng-init=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome:null\" ng-options=\"_type.incomeCode as _type.incomeDescription for _type in AppDetails.incomeSlabList\" ng-required=\"!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth)\n                      &&!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\" ng-change=AppDetails.setAnnualIncome() ng-disabled=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth || AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate\" easyassist-key=mask-element><option value=\"\" selected>Gross Annual Income</option></select><span ng-show=\"AppDetails.soleApplicantForm.grossAnnualIncome.$dirty && AppDetails.soleApplicantForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.grossAnnualIncome.$error.required ng-bind=AppDetails.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=AppDetails.soleApplicantForm.grossAnnualIncome.$error.number ng-bind=AppDetails.validateData.INVALID_AMOUNT></span> </span><span ng-if=\"!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth)\n                      &&!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\" class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=\"col-md-1 text-center AddDetailsLabel\">OR</div><div class=col-md-3><div class=\"input-normal mgt13\" ng-class=\"{error:AppDetails.soleApplicantForm.netWorth.$dirty\n                 && AppDetails.soleApplicantForm.netWorth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel name=netWorth class=pd20 ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth ng-required=!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome) ng-disabled=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\"> <span ng-show=\"AppDetails.soleApplicantForm.netWorth.$dirty && AppDetails.soleApplicantForm.netWorth.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.netWorth.$error.number ng-bind=AppDetails.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=AppDetails.soleApplicantForm.netWorth.$error.required ng-bind=AppDetails.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Net worth (in Rs.) <span ng-if=\"!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\n                ||(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\" class=req>*</span></label></div><div class=form-group><label id=DisplayWordsTaxAmount>{{AppDetails.amountInWords}} (In Words)</label></div></div><div class=col-md-4><div class=\"input-select input-normal input-group date date-picker mgt13\" ng-class=\"{error : AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth\n                   && !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate\n                   }\"><input type=text name=netWorthDate id=soleNetWorthDate2 date-calendar date-default=AppDetails.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=AppDetails.minDate showdefault=\"{{\'\'+!!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate}}\" data-on-date-change=AppDetails.changeStartDate required ng-disabled=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon style=z-index:9></i> <i class=times-icon ng-click=AppDetails.resetNetWorthDate() style=\"z-index: 9\"></i><label class=data-label style=\"z-index: 9\">As on DD/MM/YYYY <span ng-if=\"!(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\n                ||(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth)\" class=req>*</span></label></div><span ng-show=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth\n                   && !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate\"><span class=error-input>{{AppDetails.validateData.DATE_REQUIRED}}</span><br></span><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div><hr><div class=form-content><p><strong>{{AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor?\"Guardian\'s Politically Exposed Person (PEP) Status\":\"Politically Exposed Person (PEP) Status\"}}</strong></p><div class=radio-block><span class=\"radio mg20\"><input type=radio id=politicalStatus1 name=politicalStatus ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus ng-value=AppDetails.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus ng-value=AppDetails.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus ng-value=AppDetails.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not Applicable.</label></div></div><hr><div class=form-content><p><strong>{{AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor?\"Guardian\'s FATCA or CRS information\":\"FATCA or CRS information\"}}<i class=tooltip-info-icon title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i></strong></p><div class=\"row pdt10\"><div class=col-md-4><div class=selectfield ng-class=\"{error:AppDetails.soleApplicantForm.fatcaAddressType.$dirty && AppDetails.soleApplicantForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType ng-options=\"_type as _type.addressDescription for _type in AppDetails.addressDescriptions track by _type.addressDescription\" ng-init=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType:null\" easyassist-key=mask-element required><option value=\"\" selected>Address Type</option></select><span ng-show=\"AppDetails.soleApplicantForm.fatcaAddressType.$dirty && AppDetails.soleApplicantForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.fatcaAddressType.$error.required ng-bind=AppDetails.validateData.ADDRESS_TYPE></span> </span><span class=req>*</span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" style=\"margin-top: 15px\" ng-class=\"{error:AppDetails.soleApplicantForm.birthCountry.$dirty && AppDetails.soleApplicantForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry ng-options=\"country as country.countryName for country in AppDetails.countryList track by country.countryCode\" ng-init=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry?AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry:null\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"AppDetails.soleApplicantForm.birthCountry.$dirty && AppDetails.soleApplicantForm.birthCountry.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.birthCountry.$error.required>{{AppDetails.validateData.COUNTRY}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:AppDetails.soleApplicantForm.birthCity.$dirty && AppDetails.soleApplicantForm.birthCity.$invalid}\"><input type=text name=birthCity ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.birthCity easyassist-key=mask-element ng-pattern=\"/^[a-zA-Z ]+$/\" required capitalize ng-maxlength=35> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><span ng-show=\"AppDetails.soleApplicantForm.birthCity.$dirty && AppDetails.soleApplicantForm.birthCity.$invalid\"><span class=error-input ng-show=AppDetails.soleApplicantForm.birthCity.$error.required>{{AppDetails.validateData.CITY}}</span> <span class=error-input ng-show=AppDetails.soleApplicantForm.birthCity.$error.maxlength>{{AppDetails.validateData.MAX_LENGTH_CITY_OF_BIRTH}}</span></span></div></div></div></div><div class=\"row tax-res\"></div><div class=\"form-content inves-pay\"><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=AppDetails.fileTaxAction() ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-change=AppDetails.fileTaxAction() ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-if=!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payTaxInIndia><div ng-repeat=\"data in AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses\"><div class=\"row mrg20\"><p class=pdb0><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=AppDetails.deleteTaxResidency($index)><i class=delete-icon></i></span></p><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:AppDetails[\'birthCountry-\'+$index].$dirty && AppDetailsAppDetails[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[$index].country ng-options=\"country as country.countryName for country in AppDetails.countryList track by country.countryCode|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"AppDetails[\'birthCountry-\'+$index].$dirty && AppDetails[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"AppDetails[\'birthCountry-\'+$index].$error.required\">{{AppDetails.validateData.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:AppDetails[\'taxIdType-\'+$index].$dirty && AppDetailsAppDetails[\'taxIdType-\'+$index].$invalid}\"><!--<input type=\"text\" name=\"taxIdType-{{$index}}\"--><!--ng-model=\"AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdType\"--><!--required capitalize>--><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdType ng-options=\"taxidtype as taxidtype.value for taxidtype in AppDetails.taxIdTypeList track by taxidtype.key\" easyassist-key=mask-element required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span><!--<span class=\"highlight\"></span>--><!--<span class=\"bar\"></span>--><!--<label>Tax ID Type<span class=\"req\">*</span></label>--></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal\"><input type=text name=taxIdNumber-{{$index}} ng-model=AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdNumber maxlength=20 easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label></div></div></div><div class=\"col-md-12 add-another-tax-res\"><a ng-show=\"((AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length)*1<3)\n              && (AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length)*1 == ($index*1+1)\" href=\"\" class=text-blue ng-click=AppDetails.addMoreTaxResidency()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div></div><hr><div class=\"form-footer form-content\"><div class=\"pull-left back\"><a class=btn-back ng-if=\"AppDetails.loginType === \'A\'\" ui-sref=agent.home.investors.add.holdmode><i class=back-arrow-icon></i>Back</a> <a class=btn-back ng-if=\"AppDetails.loginType !== \'A\'\" ui-sref=main.investors.add.holdmode><i class=back-arrow-icon></i>Back</a></div><button class=\"btn btn-negative-action\" type=button ng-click=AppDetails.cancelTransaction()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"AppDetails.soleApplicantForm.$invalid\n              ||(!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate && !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\n              ||(AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorth && !AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate) || (AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minor && (!AppDetails.formData.folioCreationRequestCO.soleApplicantDetail.minorAgeProof || !AppDetails.formData.folioCreationRequestCO.guardianDetails.guardianRelationshipProofUrl))\">Continue</button></div></div></form></div></div><style>.update-contact-warning{\n    width: 100%;\n    display: inline-block;\n    background-color: #fef1f2;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n    text-align: center;\n    font-size: 12px;\n    padding: 2px;\n    position: relative;\n    top: 0px;\n    margin-right: 12px;\n  }</style>");
$templateCache.put("app/investors/add/folio/add.guardian-details.html","<!--<investor-folio-tab control=\"GuardianDetails\"></investor-folio-tab>--><ul class=\"mobile-hide nav nav-tabs\"><li ui-sref-active=active><a ui-sref=main.investors.add.appdetails>Sole Applicant Details</a></li><li ui-sref-active=active ng-if=GuardianDetails.tabEnable.tabGuardianDetailShow><a ng-if=!GuardianDetails.tabEnable.tab4>Guardian Details</a> <a ui-sref=main.investors.add.guardianDetails ng-if=GuardianDetails.tabEnable.tab4><strong>Guardian Details</strong></a></li><li ui-sref-active=active><a ng-if=Nominee.tabEnable.tab2 ui-sref=main.investors.add.nominee href=javaScript:void(0);><i class=expand-icon></i>Add Nominee Information</a></li><!--<li ui-sref-active=\"active\">\n    <a ui-sref=\"main.investors.add.jointholders\" ng-if=\"GuardianDetails.tabEnable.tab3\">Add Joint Holder</a>\n  </li>--></ul><div class=tab-content ng-init=GuardianDetails.init();><!--<span class=\"add-joint-holder pull-right\" ng-if=\"!GuardianDetails.tabEnable.tab3\"\n        ng-click=\"GuardianDetails.addJointHolderTab()\">+ Add Joint Holder </span>--> <button class=\"mobile-show mobile-accordion clearfix\"><a data-toggle=tab href=#applicant-details>Guardian\'s Details<i class=\"accordian-arrow-down-icon pull-right\"></i></a></button><div id=applicant-details class=\"tab-pane fade in active\"><form autocomplete=off name=GuardianDetails.gaurdianDetailsForm ng-submit=GuardianDetails.submitGuardianDetails() novalidate><div class=form-content><p><strong>Gaurdian\'s Details</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.taxStatusCode.$dirty && GuardianDetails.gaurdianDetailsForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in GuardianDetails.taxStatusList\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.taxStatusCode.$dirty && GuardianDetails.gaurdianDetailsForm.taxStatusCode.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.taxStatusCode.$error.required ng-bind=GuardianDetails.validateData.TAX_STATUS></span> </span><span class=req>*</span></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$dirty\n                 && GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in GuardianDetails.incomeSlabList\" ng-required=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\n                      && !(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\"><option value=\"\" selected>Gross Annual Income</option></select><span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\n                      &&!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span> <span ng-show=\"GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$dirty\n                && GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$error.required ng-bind=GuardianDetails.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.grossAnnualIncome.$error.number ng-bind=GuardianDetails.validateData.INVALID_AMOUNT></span> </span><span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.occupation.$dirty && GuardianDetails.gaurdianDetailsForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in GuardianDetails.occupationList\" required><option value=\"\" selected>Occupation</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.occupation.$dirty && GuardianDetails.gaurdianDetailsForm.occupation.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.occupation.$error.required ng-bind=GuardianDetails.validateData.OCCUPATION></span> </span><span class=req>*</span></div><div class=\"row net-worth-main\"><div class=\"col-md-6 net-worth-inner\"><div class=input-normal ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.netWorth.$dirty\n                 && GuardianDetails.gaurdianDetailsForm.netWorth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel name=netWorth class=pd20 ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth ng-required=!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)> <span ng-show=\"GuardianDetails.gaurdianDetailsForm.netWorth.$dirty && GuardianDetails.gaurdianDetailsForm.netWorth.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.netWorth.$error.number ng-bind=GuardianDetails.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.netWorth.$error.required ng-bind=GuardianDetails.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span><label>Net worth (in Rs.) <span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span></label></div></div><div class=\"col-md-6 net-worth-inner\" ng-if=GuardianDetails.resetNetWorthDateFlag><div class=input-normal ng-class=\"{error : GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth\n                   && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate\n                   }\"><input type=text name=netWorthDate id=guardianDetailsNetWorthDate date-calendar date-default=GuardianDetails.defaultDateNetWorthDate showdefault=\"{{\'\'+!!GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate}}\" format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=GuardianDetails.minDate data-on-date-change=GuardianDetails.changeNetWorthDate required readonly> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i> <i class=times-icon ng-click=GuardianDetails.resetNetWorthDateG();></i><label>As on DD/MM/YYYY <span ng-if=\"!(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth)\" class=req>*</span></label></div></div></div></div></div></div><hr><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio id=politicalStatus1 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.<span class=req>*</span></label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.politicalStatus ng-value=GuardianDetails.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>None of the above<span class=req>*</span></label></div></div><hr><div class=form-content><p><strong>FATCA or CRS information</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$dirty && GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in GuardianDetails.addressDescriptions\" required><option value=\"\" selected>Address Type</option></select><span ng-show=\"GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$dirty && GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=GuardianDetails.gaurdianDetailsForm.fatcaAddressType.$error.required ng-bind=GuardianDetails.validateData.ADDRESS_TYPE></span> </span><span class=req>*</span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails.birthCountry.$dirty && GuardianDetails.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCountry ng-options=\"country.countryName as country.countryName for country in GuardianDetails.countryList\" required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"GuardianDetails.birthCountry.$dirty && GuardianDetails.birthCountry.$invalid\"><span class=error-input ng-show=GuardianDetails.birthCountry.$error.required>{{GuardianDetails.validations.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less\" ng-class=\"{error:GuardianDetails.birthCity.$dirty && GuardianDetails.birthCity.$invalid}\"><input type=text name=birthCity ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.birthCity ng-pattern=\"/^[a-zA-Z ]+$/\" required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label></div></div></div></div><div class=\"row tax-res\"></div><div class=\"form-content inves-pay\"><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-change=GuardianDetails.fileTaxActionGuardianDetails() ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-change=GuardianDetails.fileTaxActionGuardianDetails() ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span><div ng-show=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payTaxInIndia><div class=\"row tax-res\" ng-repeat=\"data in GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=GuardianDetails.deleteTaxResidencyGD($index)><i class=delete-icon></i></span></p><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:GuardianDetails[\'birthCountry-\'+$index].$dirty && GuardianDetailsGuardianDetails[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryName as country.countryName for country in GuardianDetails.countryList|removeCountry:\'india\'\" required><option value=\"\" selected>Name of Country</option></select><span class=req>*</span> <span ng-show=\"GuardianDetails[\'birthCountry-\'+$index].$dirty && GuardianDetails[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"GuardianDetails[\'birthCountry-\'+$index].$error.required\">{{GuardianDetails.validations.COUNTRY}}</span></span></div><!--\n              <div class=\"input-select input-normal\"\n              >\n                <input type=\"text\" name=\"countryName-{{$index}}\"\n                       ng-model=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName\"\n                >\n                <span class=\"highlight\"></span>\n                <span class=\"bar\"></span>\n                <label>Name of country<span class=\"req\">*</span></label>\n              </div>--><div class=\"input-select input-normal\"><input type=text name=taxIdType-{{$index}} ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID Type<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal\"><input type=text name=taxIdNumber-{{$index}} ng-model=GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label></div></div><div ng-show=\"GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName &&\nGuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber &&\nGuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType\"><a ng-show=\"(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.length)*1<4 &&\n(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.payOutsideIndiaAddresses.length)*1 == ($index*1+1)\" href=\"\" class=text-blue ng-click=GuardianDetails.addMoreTaxResidencyGD()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-negative-action\" ng-click=GuardianDetails.cancelTransaction()>Cancel</button> <button class=\"btn btn-primary-action\" ng-disabled=\"GuardianDetails.gaurdianDetailsForm.$invalid\n              ||(!GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.grossAnnualIncome)\n              ||(GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorth && !GuardianDetails.formData.folioCreationRequestCO.guardianDetails.basicDetails.netWorthDate)\n            \">Continue</button></div></form></div></div>");
$templateCache.put("app/investors/add/folio/add.holdmode.html","<div class=tab-content ng-init=Holdmode.init();><!-- ng-init=\"Holdmode.init();\"--><div id=applicant-details class=\"tab-pane fade in active\"><form autocomplete=off name=HoldModeForm novalidate><div class=form-content><p><strong>Folio Creation:</strong></p><div class=radio-block><span class=radio-block><span class=\"radio mg20\"><input type=radio id=selefId name=isMinor ng-model=Holdmode.formData.folioCreationRequestCO.soleApplicantDetail.minor ng-change=Holdmode.setMinorFlag() ng-value=false required> <span class=check></span></span><label for=selefId>Self</label></span><span class=\"holdMode-label radio-block\"><span class=radio><input type=radio id=minorId name=isMinor ng-model=Holdmode.formData.folioCreationRequestCO.soleApplicantDetail.minor ng-change=Holdmode.setMinorFlag() ng-value=true required> <span class=check></span></span><label for=minorId>Minor</label></span></div></div><div class=form-content><p><strong>Select mode of holding</strong></p><div class=radio-block><span class=\"radio mg20\"><input type=radio id=single name=single ng-model=Holdmode.formData.folioCreationRequestCO.holdMode ng-value=Holdmode.CONST.INVESTOR_HOLD_MODE.SINGLE ng-change=Holdmode.setHoldmode() required> <span class=check></span></span><label for=single>Single</label></div><div class=radio-block ng-class=\"{\'anything-disabled\': Holdmode.formData.folioCreationRequestCO.soleApplicantDetail.minor}\"><span class=radio><input type=radio id=aos name=aos ng-model=Holdmode.formData.folioCreationRequestCO.holdMode ng-value=Holdmode.CONST.INVESTOR_HOLD_MODE.AOS ng-change=Holdmode.setHoldmode() ng-disabled=Holdmode.formData.folioCreationRequestCO.soleApplicantDetail.minor required> <span class=check></span></span><label for=aos>Anyone or Survivor</label></div></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-negative-action\" type=button ng-click=Holdmode.cancelTransaction()>Cancel</button> <button class=\"btn btn-primary-action\" type=button ng-disabled=\"HoldModeForm.$invalid || (Holdmode.formData.folioCreationRequestCO.holdMode !== Holdmode.CONST.INVESTOR_HOLD_MODE.SINGLE)\n          &&\n          (Holdmode.formData.folioCreationRequestCO.holdMode !== Holdmode.CONST.INVESTOR_HOLD_MODE.AOS)\" ng-click=Holdmode.submitHoldmode();>Continue</button></div></form></div></div>");
$templateCache.put("app/investors/add/folio/add.joint-holders.html","<div class=box-body ng-init=JointHolders.init();><div class=tab-content><div id=add-nominee><div class=\"clearfix add-nominee-head\"><h3 class=pull-left>Holders Details</h3><!--<div class=\"pull-right checkbox\">\n          <input type=\"checkbox\"\n                 ng-model=\"JointHolders.formData.folioCreationRequestCO.addNomineeLater\"\n                 ng-click=\"JointHolders.checkAddNominee()\">\n          <span class=\"icon-checkbox\"></span>\n          <span class=\"checkbox-text\">Add Nominee Later</span>\n        </div>--></div><div class=\"nominee-forms clearfix\"><div class=form-content><table class=\"table table-nominee hide-mobile\"><thead><tr><th>&nbsp;</th><th>Name</th><th>PAN</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"holderData in JointHolders.formData.folioCreationRequestCO.jointHolders\"><td class=\"col-md-2 text-black\">{{JointHolders.enum[$index+1]}} Holder</td><td class=col-md-4><div class=\"input-select input-normal\"><input type=text name=jointHolderName-{{$index}} id=jointHolderName-{{$index}} ng-model=holderData.jointHolderName autocomplete=off capitalize readonly> <span class=highlight></span> <span class=bar></span></div></td><td class=col-md-4><div class=\"col-md-3 input-select input-normal\"><input type=text easyassist-key=mask-element name=panNumber-{{$index}} ng-model=holderData.jointHolderApplicantDetail.panNumber readonly> <span class=highlight></span> <span class=bar></span></div></td><td class=col-md-2><i class=delete-icon ng-click=JointHolders.deleteCurrentJointHolder($index)></i></td></tr></tbody></table></div><form autocomplete=off class=col-md-12 name=JointHolders.jointHolderForm ng-submit=JointHolders.submitJointHolder() novalidate><div class=\"tab-container form-content\"><ul class=\"mobile-hide nav nav-tabs\"><li role=button tabindex={{$index}} ng-repeat=\"holder in JointHolders.formData.folioCreationRequestCO.jointHolders\" ng-click=JointHolders.switchHolder($index) ng-class=\"{\'active\':JointHolders.currentJointHolder === $index}\">{{JointHolders.enum[$index+1]}} Holder</li></ul><div class=\"pull-right add-another-nominee\" role=button><!--ng-disabled=\"true\"--> <strong ng-show=\"JointHolders.formData.folioCreationRequestCO.jointHolders.length>2\" ng-click=JointHolders.showMessage()>+ Add Another Holder</strong> <a href=javascript:void(0) ng-if=\"JointHolders.formData.folioCreationRequestCO.jointHolders.length<=1\" ng-click=JointHolders.addMoreJointHolder() class=text-blue><strong>+ Add Another Holder</strong></a></div></div><div class=add-nominee-details ng-repeat=\"holder in JointHolders.formData.folioCreationRequestCO.jointHolders\"><div class=form-content ng-show=\"JointHolders.currentJointHolder === $index\"><div><p style=\"padding-bottom: 20px\"><strong>Contact Details</strong></p><div class=\"col-md-6 email-block\" style=\"padding-bottom: 20px\"><strong>Email ID :</strong><strong easyassist-key=mask-element>{{JointHolders.formData.folioCreationRequestCO.jointHolders[$index].email ? JointHolders.formData.folioCreationRequestCO.jointHolders[$index].email : \'Not available\'}}</strong><p></p></div><div class=\"col-md-6 email-block\" style=\"padding-bottom: 20px\"><p><strong>Mobile No :</strong><strong easyassist-key=mask-element>{{JointHolders.formData.folioCreationRequestCO.jointHolders[$index].mobileNo ? JointHolders.formData.folioCreationRequestCO.jointHolders[$index].mobileNo : \'Not available\'}}</strong></p></div></div><div ng-if=\"!JointHolders.formData.folioCreationRequestCO.jointHolders[$index].email\n&& !JointHolders.formData.folioCreationRequestCO.jointHolders[$index].mobileNo\"><p class=text-red>To proceed with Folio creation contact details of Joint holder are mandatory. Kindly get in touch with our ISC or CAMS to update CKYC.</p></div></div><div class=clearfix ng-show=\"JointHolders.currentJointHolder === $index\"><div class=form-content><p><strong>Income Details</strong></p><div class=\"row mrg20\"><!--<p><strong>Tax Status</strong></p>--><div class=col-md-4><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm.taxStatusCode.$dirty && JointHolders.jointHolderForm.taxStatusCode.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=taxStatusCode-{{$index}} ng-model=holder.jointHolderApplicantDetail.taxStatusCode ng-init=\"holder.jointHolderApplicantDetail.taxStatusCode=holder.jointHolderApplicantDetail.taxStatusCode?holder.jointHolderApplicantDetail.taxStatusCode:null\" ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in JointHolders.taxStatusList[$index]\" ng-change=JointHolders.changedTaxStatus() easyassist-key=mask-element ng-disabled=\"holder.nriFlag == false\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"JointHolders.jointHolderForm.taxStatusCode.$dirty && JointHolders.jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.taxStatusCode.$error.required ng-bind=JointHolders.validateData.TAX_STATUS></span> </span><span class=req>*</span></div></div></div><div class=row ng-if=JointHolders.dynamicDataForTaxStatus><div class=col-md-10><div class=\"col-xs-12 col-md-12 trans-ackn\"><span class=icon-info-sign></span><p class=tax-note>{{JointHolders.dynamicDataForTaxStatus}}</p></div></div></div><div class=\"row mrg20\"><div class=col-md-4><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm.occupation.$dirty && JointHolders.jointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=occupation-{{$index}} ng-model=holder.jointHolderApplicantDetail.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in JointHolders.occupationList\" ng-change=JointHolders.setOccuValidation() ng-init=\"holder.jointHolderApplicantDetail.occupation=holder.jointHolderApplicantDetail.occupation?holder.jointHolderApplicantDetail.occupation:null\" easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><span ng-show=\"JointHolders.jointHolderForm.occupation.$dirty && JointHolders.jointHolderForm.occupation.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.occupation.$error.required ng-bind=JointHolders.validateData.OCCUPATION></span> </span><span class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Occupation<span class=req>*</span></label></div></div></div><div class=\"row mrg20\"><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm.grossAnnualIncome.$dirty && JointHolders.jointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome-{{$index}} ng-click=\"JointHolders.setOptionalEmptyJH(\'GrossAnnualIncome\')\" ng-model=holder.jointHolderApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in JointHolders.incomeSlabList\" ng-required=\"!(holder.jointHolderApplicantDetail.netWorth)\n                              &&!(holder.jointHolderApplicantDetail.netWorthDate)\" ng-change=JointHolders.setAnnualIncome() ng-init=\"holder.jointHolderApplicantDetail.grossAnnualIncome=holder.jointHolderApplicantDetail.grossAnnualIncome?holder.jointHolderApplicantDetail.grossAnnualIncome:null\" ng-disabled=holder.jointHolderApplicantDetail.netWorth easyassist-key=mask-element><option value=\"\" selected>Gross Annual Income</option></select><!--<input type=\"number\" name=\"grossAnnualIncome\"\n                             ng-model=\"holder.jointHolderApplicantDetail.grossAnnualIncome\"\n                             required>--> <span ng-show=\"JointHolders.jointHolderForm.grossAnnualIncome.$dirty && JointHolders.jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.grossAnnualIncome.$error.required ng-bind=JointHolders.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=JointHolders.jointHolderForm.grossAnnualIncome.$error.number ng-bind=JointHolders.validateData.INVALID_AMOUNT></span> </span><span class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income<span class=req>*</span></label></div></div><div class=\"col-md-1 text-center\" style=\"top: 30px\">OR</div><div class=col-md-3><div class=input-normal ng-class=\"{error:JointHolders.jointHolderForm[\'netWorth-\'+$index].$dirty\n                           && JointHolders.jointHolderForm[\'netWorth-\'+$index].$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel name=netWorth-{{$index}} class=pd20 ng-model=holder.jointHolderApplicantDetail.netWorth ng-required=!(holder.jointHolderApplicantDetail.grossAnnualIncome) ng-disabled=holder.jointHolderApplicantDetail.grossAnnualIncome> <span ng-show=\"JointHolders.jointHolderForm[\'netWorth-\'+$index].$dirty\n                           && JointHolders.jointHolderForm[\'netWorth-\'+$index].$invalid\"><span class=error-input ng-show=\"JointHolders.jointHolderForm[\'netWorth-\'+$index].$error.number\" ng-bind=JointHolders.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=\"JointHolders.jointHolderForm[\'netWorth-\'+$index].$error.required\" ng-bind=JointHolders.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span><label>Net worth (in Rs.)<span class=req>*</span></label><span ng-show=\"JointHolders.jointHolderForm.occupation.$dirty && JointHolders.jointHolderForm.occupation.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.occupation.$error.required ng-bind=JointHolders.validateData.FOLIO_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"input-select input-normal input-group date date-picker mgt13\" ng-class=\"{error : holder.jointHolderApplicantDetail.netWorth && !holder.jointHolderApplicantDetail.netWorthDate}\"><input type=text name=netWorthDate-{{$index}} id=soleNetWorthDate2 date-calendar data-enable=true date-default=JointHolders.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=JointHolders.minDate data-on-date-change=JointHolders.changeStartDateJointHolder ng-disabled=holder.jointHolderApplicantDetail.grossAnnualIncome showdefault=\"\'true\'\" required> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><!--<i class=\"times-icon\" ng-click=\"JointHolders.resetNetWorthDate()\"></i>--><label>As on DD/MM/YYYY <span ng-if=\"!(holder.jointHolderApplicantDetail.grossAnnualIncome)\n                ||(holder.jointHolderApplicantDetail.netWorth)\" class=req>*</span></label><span ng-show=\"holder.jointHolderApplicantDetail.netWorth && !holder.jointHolderApplicantDetail.netWorthDate\"><span class=error-input>{{JointHolders.validateData.DATE_REQUIRED}}</span></span></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div><hr class=\"form-group clearfix\"><div class=\"row col-md-12 form-group\"><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=\"radio mg20\"><input type=radio id=politicalStatus-1-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.jointHolderApplicantDetail.politicalStatus ng-value=JointHolders.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus-1-{{$index}}>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus-2-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.jointHolderApplicantDetail.politicalStatus ng-value=JointHolders.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus-2-{{$index}}>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus-3-{{$index}} name=politicalStatus-{{$index}} ng-model=holder.jointHolderApplicantDetail.politicalStatus ng-value=JointHolders.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus-3-{{$index}}>None of the above.</label></div></div></div><div class=\"row col-md-12 form-group\"><div class=form-content><p><strong>FATCA or CRS information</strong></p><div class=\"row pdt10\"><div class=col-md-4><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm.occupation.$dirty && JointHolders.jointHolderForm.occupation.$invalid}\"><!--<label>Tax Status</label>--><select class=\"browser-default custom-select\" name=fatcaAddressType-{{$index}} ng-model=holder.jointHolderApplicantDetail.fatcaAddressType ng-init=\"holder.jointHolderApplicantDetail.fatcaAddressType=holder.jointHolderApplicantDetail.fatcaAddressType?holder.jointHolderApplicantDetail.fatcaAddressType:null\" ng-options=\"_type as _type.addressDescription for _type in JointHolders.addressDescriptions track by _type.addressDescription\" easyassist-key=mask-element required><option value=\"\" selected>Address Type</option></select><span ng-show=\"JointHolders.jointHolderForm.fatcaAddressType.$dirty && JointHolders.jointHolderForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.fatcaAddressType.$error.required ng-bind=JointHolders.validateData.FOLIO_REQUIRED></span> </span><span class=req>*</span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm.birthCountry.$dirty && JointHolders.jointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-{{$index}} ng-model=holder.jointHolderApplicantDetail.birthCountry ng-init=\"holder.jointHolderApplicantDetail.birthCountry=holder.jointHolderApplicantDetail.birthCountry?holder.jointHolderApplicantDetail.birthCountry:null\" ng-options=\"country.countryName as country.countryName for country in JointHolders.countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"JointHolders.jointHolderForm.birthCountry.$dirty && JointHolders.jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=JointHolders.jointHolderForm.birthCountry.$error.required>{{JointHolders.jointHolderForm.validations.COUNTRY}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less\" ng-class=\"{error:JointHolders.jointHolderForm[\'birthCity-\'+$index].$dirty && JointHolders.jointHolderForm[\'birthCity-\'+$index].$invalid}\"><input type=text name=birthCity-{{$index}} ng-model=holder.jointHolderApplicantDetail.birthCity easyassist-key=mask-element required capitalize ng-maxlength=35> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><span ng-show=\"JointHolders.jointHolderForm[\'birthCity-\'+$index].$dirty && JointHolders.jointHolderForm[\'birthCity-\'+$index].$invalid\"><span class=error-input ng-show=\"JointHolders.jointHolderForm[\'birthCity-\'+$index].$error.required\">{{JointHolders.validateData.CITY}}</span> <span class=error-input ng-show=\"JointHolders.jointHolderForm[\'birthCity-\'+$index].$error.maxlength\">{{JointHolders.validateData.MAX_LENGTH_CITY_OF_BIRTH}}</span></span></div></div></div></div></div><div class=\"form-content inves-pay\"><p><strong>Does the investor pay or file tax other than India?</strong></p><span class=\"radio-block col-md-1\"><span class=radio><input type=radio id=payTaxInIndiaYes-{{$index}} name=payTaxInIndia-{{$index}} ng-change=JointHolders.fileTaxActionJointHolder($index) ng-model=holder.jointHolderApplicantDetail.payTaxInIndia ng-value=false> <span class=check></span></span><label style=top:-14px for=payTaxInIndiaYes-{{$index}}>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo-{{$index}} name=payTaxInIndia-{{$index}} ng-change=JointHolders.fileTaxActionJointHolder($index) ng-model=holder.jointHolderApplicantDetail.payTaxInIndia ng-value=true> <span class=check></span></span><label style=top:-14px for=payTaxInIndiaNo-{{$index}}>No</label></span><div ng-show=!holder.jointHolderApplicantDetail.payTaxInIndia><div class=tax-res ng-repeat=\"payoutdata in holder.jointHolderApplicantDetail.payOutsideIndiaAddresses\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=\"JointHolders.deleteTaxResidencyJointHolder(JointHolders.parentIndex, $index)\"><i class=delete-icon></i></span></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:JointHolders.jointHolderForm[\'birthCountry-\'+$index].$dirty && JointHolders.jointHolderForm[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=payoutdata.countryName ng-options=\"country.countryName as country.countryName for country in JointHolders.countryList|removeCountry:\'india\'\" easyassist-key=mask-element required><option value=\"\" selected>Name of Country</option></select><span class=req>*</span> <span ng-show=\"JointHolders.jointHolderForm[\'birthCountry-\'+$index].$dirty && JointHolders.jointHolderForm[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"JointHolders.jointHolderForm[\'birthCountry-\'+$index].$error.required\">{{JointHolders.validations.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:AppDetails[\'taxIdType-\'+$index].$dirty && AppDetailsAppDetails[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=payoutdata.taxIdType ng-options=\"taxidtype as taxidtype.value for taxidtype in JointHolders.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Tax ID Type</option></select></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal\"><input type=text name=taxIdNumber-{{$index}} maxlength=20 ng-model=payoutdata.taxIdNumber easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label></div></div></div><div class=\"col-md-12 add-another-tax-res\" ng-show=\"payoutdata.countryName &&\n                      payoutdata.taxIdNumber &&\n                      payoutdata.taxIdType\"><a ng-show=\"(holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length)*1<3\n                    && (holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length)*1 == ($index*1+1)\" href=\"\" class=text-blue ng-click=JointHolders.addMoreTaxResidencyJointHolder()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div></div><hr></div></div><hr><div class=\"form-footer form-content clearfix\"><!--<button class=\"btn btn-negative-action\" ng-click=\"JointHolders.goPrevious(\'soleApplicant\')\">Previous</button>--><!--<p class=\"text-danger error-submission\" ng-bind=\"JointHolders.validationMsg\"></p>--><div class=\"pull-left back\"><!--<a class=\"btn-back\" ui-sref=\"main.investors.add.appdetails\"><i class=\"back-arrow-icon\"></i>Back</a>--> <a class=btn-back ng-if=\"JointHolders.loginType === \'A\'\" ui-sref=agent.home.investors.add.appdetails><i class=back-arrow-icon></i>Back</a> <a class=btn-back ng-if=\"JointHolders.loginType !== \'A\'\" ui-sref=main.investors.add.appdetails><i class=back-arrow-icon></i>Back</a></div><div class=\"pull-right flex-style\"><button type=button class=\"btn btn-negative-action\" ng-click=JointHolders.cancelTransaction();>Cancel</button> <button type=submit class=\"btn btn-primary-action btn-next\" ng-disabled=\"JointHolders.jointHolderForm.$invalid || JointHolders.notValid2ndHolder || (JointHolders.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorth && !JointHolders.formData.folioCreationRequestCO.jointHolders[0].jointHolderApplicantDetail.netWorthDate)\">Continue</button></div></div></form></div></div></div></div>");
$templateCache.put("app/investors/add/folio/add.nominee.html","<div class=box-body ng-init=Nominee.init();><div class=tab-content><div id=add-nominee><div class=\"clearfix add-nominee-head\"><h3 class=pull-left ng-hide=Nominee.formData.folioCreationRequestCO.addNomineeLater>Nominee Details</h3><i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !Nominee.formData.folioCreationRequestCO.addNomineeLater\" data-placement={{Main.tooltipClass}} title=\"SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n            states that, in case of Joint Account/Folio: <br>\n            1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n              Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n              inherit the assets as owners.<br>\n            2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n            3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder\"></i><!--<p class=\"pull-right text-blue\"><i class=\"expand-icon\"></i> Add Joint Holder--><!--<small>(Optional)</small>--><!--</p>--><div class=\"pull-right checkbox opting-out\"><input type=checkbox ng-model=Nominee.formData.folioCreationRequestCO.addNomineeLater ng-click=Nominee.checkAddNominee()> <span class=icon-checkbox></span> <span class=checkbox-text>I hereby declare to opting out of nomination</span></div><h3 class=consent-text style=\"padding-left: 0px\" ng-if=!Nominee.formData.folioCreationRequestCO.addNomineeLater>I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</h3></div><div class=nominee-forms><!--ng-repeat=\"nomineeData in Nominee.formData.folioCreationRequestCO.nominees\"\n           ng-if=\"$index == Nominee.currentNominee\"--><form ng-if=!Nominee.formData.folioCreationRequestCO.addNomineeLater autocomplete=off name=Nominee.nomineeFormUpper ng-submit=Nominee.submitNominee() novalidate><div class=form-content ng-class=\"{\'nominee-scroll-y\':Nominee.formData.folioCreationRequestCO.nominees.length > 3}\"><table class=\"table table-nominee\"><thead><tr><th>&nbsp;</th><th>Name</th><th>Proportion</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"data in Nominee.formData.folioCreationRequestCO.nominees\"><td class=\"col-md-2 col-xs-4 text-black\">{{Nominee.enum[$index]}} Nominee</td><td class=\"col-md-4 col-xs-3\"><div class=\"input-select input-normal\" ng-class=\"{error:Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$dirty && Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid}\"><input type=text name=nomineeNameList-{{$index}} id=nomineeNameList-{{$index}} ng-pattern=/^[a-zA-Z\\s\\.]+$/ ng-model=data.nomineeName ng-change=\"Nominee.changeNomineeName($index, data.nomineeName)\" maxlength=40 easyassist-key=mask-element required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><!--<label>Name</label>--> <span ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$dirty && Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid\"><span class=error-input ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$error.pattern\" ng-bind=Nominee.validateData.NOMINEE_TEXT_ONLY></span></span></div></td><td class=\"col-md-4 col-xs-3\"><div class=\"col-md-3 input-select input-normal\" ng-class=\"{error:Nominee.nomineeFormUpper[\'proportion-\'+$index].$dirty && Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid}\"><input type=number ignore-mouse-wheel name=proportion-{{$index}} ng-model=data.percentage ng-change=Nominee.onChangePercentage($index) ng-max=\"Nominee.nomineePropertion[\'max-\'+$index]\" ng-min=\"Nominee.nomineePropertion[\'min\']\" ng-model-options=\"{updateOn: \'default\' , allowInvalid:\'true\'}\" easyassist-key=mask-element ng-keydown=Nominee.checkDecimal($event) ng-paste=Nominee.onPaste($event) required><!--is-number--> <span class=input-side-symbol>%</span> <span class=highlight></span> <span class=bar></span> <span class=\"error-input nominee-error\" ng-if=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.min\" ng-bind=Nominee.validateData.PROPORTION_NOT_ZERO></span><!--<span class=\"text-support\"><i class=\"tooltip-info-icon\"></i>Proportion should not be greater than 100%</span>--> <span ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$dirty && Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid\"><span class=\"error-input nominee-error\" ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_PROPORTION_REQUIRED></span> </span><span class=\"error-input nominee-error\" ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.max\" ng-bind=Nominee.validateData.NOMINEE_PROPORTION></span></div></td><td class=\"col-md-2 col-xs-2 icon-delete\" ng-if=\"$index>0\"><i class=delete-icon ng-click=Nominee.deleteCurrentNominee($index)></i></td></tr></tbody></table><!--ritika design changes dont delete--><!--<div class=\"hide-desktop\">\n              <ul class=\"nav nav-pills nominee-tabs\">\n                <li class=\"active\"><a href=\"#\">First</a></li>\n                <li><a href=\"#\">Second</a></li>\n                <li><a href=\"#\">Third</a></li>\n              </ul>\n              <div class=\"mobile-nominee-fields\">\n                <div class=\"input-select input-normal\"\n                     ng-class=\"{error:Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid}\">\n                  <input type=\"text\" name=\"nomineeNameList-{{$index}}\" id=\"nomineeNameList-{{$index}}\"\n                         ng-model=\"data.nomineeName\"\n                         required\n                         autocomplete=\"off\" capitalize>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Name</label>\n                  <span\n                    ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$dirty && Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid\">\n                        <span class=\"error-input\"\n                              ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$error.required\"\n                              ng-bind=\"Nominee.validateData.NOMINEE_NAME_REQUIRED\"></span>\n                      </span>\n                </div>\n                <div class=\"input-select input-normal\"\n                     ng-class=\"{error:Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid}\">\n                  <input type=\"number\" name=\"proportion-{{$index}}\"\n                         ng-model=\"data.percentage\"\n                         ng-change=\"Nominee.onChangePercentage($index)\"\n                         ng-max=\"Nominee.nomineePropertion[\'max-\'+$index]\"\n                         ng-min=\"Nominee.nomineePropertion[\'min-\'+$index]\"\n                         required>&lt;!&ndash;is-number&ndash;&gt;\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Proportion</label>\n                  <span class=\"text-support\"><i class=\"tooltip-info-icon\"></i>Proportion should not be greater than 100%</span>\n                  <span\n                    ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$dirty && Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid\">\n                      <span class=\"error-input\" ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.required\"\n                            ng-bind=\"Nominee.validateData.NOMINEE_PROPORTION_REQUIRED\"></span>\n                    </span>\n                  <span class=\"error-input\" ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.max\"\n                        ng-bind=\"Nominee.validateData.NOMINEE_PROPORTION\"></span>\n                  </span>\n                </div>\n                <span class=\"delete-text\"><i class=\"delete-icon\" ng-click=\"Nominee.deleteCurrentNominee($index)\"></i>Delete This Nominee</span>\n              </div>\n            </div>--><div ng-disabled=true class=\"pull-right add-another-nominee-desktop\" role=button ng-if=\"!Nominee.formData.folioCreationRequestCO.showNomineeUpdate && (Nominee.formData.folioCreationRequestCO.nominees.length<Nominee.allowedNomineeLength) || Nominee.formData.folioCreationRequestCO.showNomineeUpdate && (Nominee.showAddNomineeLink && Nominee.formData.folioCreationRequestCO.nominees.length<Nominee.allowedNomineeLength)\"><strong ng-show=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" ng-click=Nominee.showMessage()>+ Add Another Nominee</strong> <a ng-hide=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" href=javascript:void(0) ng-click=Nominee.addMoreNominee(); class=text-blue><strong>+ Add Another Nominee</strong></a></div></div></form><form autocomplete=off name=nomineeForm ng-submit=Nominee.submitNominee() novalidate><div class=row ng-if=Nominee.formData.folioCreationRequestCO.addNomineeLater><div class=\"col-md-12 mark-default opt-out-align\"><div class=checkbox style=\"padding-right: 10px\"><input type=checkbox ng-model=Nominee.formData.folioCreationRequestCO.addOptOut required> <i class=icon-checkbox></i></div><div class=checkbox-text><ng-bind-html dynamic=Nominee.dynamicDataForOptOutDec></ng-bind-html></div></div></div><div ng-if=!Nominee.formData.folioCreationRequestCO.addNomineeLater class=\"tab-container form-content\"><ul class=\"nav nav-tabs nominee-tab-container\" ng-class=\"{\'update-width\': Nominee.formData.folioCreationRequestCO.showNomineeUpdate && (Nominee.formData.folioCreationRequestCO.nominees.length < Nominee.allowedNomineeLength)}\"><li role=button tabindex={{$index}} ng-repeat=\"nomineeData in Nominee.formData.folioCreationRequestCO.nominees\" ng-click=\"Nominee.switchNominee($index,nomineeData.nomineePan,nomineeData.guardianPan,nomineeData.drivingLicense,nomineeData.aadharCard, nomineeData.passport)\" ng-class=\"{\'active\':Nominee.currentNominee === $index}\">{{Nominee.enum[$index]}} Nominee</li></ul><div ng-disabled=true class=\"pull-right add-another-nominee\" role=button ng-if=\"!Nominee.formData.folioCreationRequestCO.showNomineeUpdate && (Nominee.formData.folioCreationRequestCO.nominees.length<Nominee.allowedNomineeLength) || Nominee.formData.folioCreationRequestCO.showNomineeUpdate && (Nominee.showAddNomineeLink && Nominee.formData.folioCreationRequestCO.nominees.length<Nominee.allowedNomineeLength)\"><strong ng-show=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" ng-click=Nominee.showMessage()>+ Add Another Nominee</strong> <a ng-hide=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" href=javascript:void(0) ng-click=Nominee.addMoreNominee(); class=text-blue><strong>+ Add Another Nominee</strong></a></div></div><div ng-if=!Nominee.formData.folioCreationRequestCO.addNomineeLater class=add-nominee-details ng-repeat=\"nomineeData in Nominee.formData.folioCreationRequestCO.nominees\"><div ng-show=\"Nominee.currentNominee === $index\"><div class=form-content><p><strong>Personal Details of Nominee</strong></p><div><div class=\"checkbox opting-out\"><input type=checkbox ng-model=nomineeData.minor ng-click=Nominee.changeNomineeIsMinor($index);> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee Is Minor</span></div></div><br><div class=\"row flex-nominee-detail\"><div class=\"col-md-4 col-xs-12\"><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm[\'nomineeName-\'+$index].$dirty && nomineeForm[\'nomineeName-\'+$index].$invalid}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.nomineeName name=nomineeName-{{$index}} id=nomineeName-{{$index}} ng-change=\"Nominee.changeNomineeName($index, nomineeData.nomineeName)\" ng-required=nomineeData.nomineeName autocomplete=off maxlength=40 capitalize required> <span class=highlight></span> <span class=bar></span><label>Name<span ng-if=nomineeData.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm[\'nomineeName-\'+$index].$dirty && nomineeForm[\'nomineeName-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeName-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAME_REQUIRED></span></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=!Nominee.formData.folioCreationRequestCO.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=nomineePan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.nomineePan ng-change=Nominee.checkDuplicateNomineePan($index,nomineeData.nomineePan,nomineeData.guardianPan); ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ > <span ng-show=\"nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID></span> <span class=error-input ng-if=\"nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Nominee</label><span class=error-input ng-if=\"nomineeData.nomineePanInvalid && nomineeData.nomineePan\" ng-bind=Nominee.errorMessage></span></div></div><div class=\"col-md-4 col-xs-12\"><div class=input-normal><input type=text style=\"z-index: 0 !important\" id=nomineeDOBId-{{$index}} date-calendar data-enable=true ng-if=nomineeData.minor date-default=Nominee.defaultDateNominee ng-model=Nominee.defaultDateNominee format=DD-MMM-YYYY showdefault=\"\'true\'\" viewmode=days maxdate=now data-on-date-change=Nominee.changeStartDateNominee data-min-date=Nominee.isMinordataMinDate data-max-date=Nominee.isMinordataMaxDate name=dob-{{$index}} autocomplete=off> <input type=text style=\"z-index: 0 !important\" id=nomineeDOBId-{{$index}} date-calendar data-enable=true ng-if=!nomineeData.minor date-default=Nominee.defaultDateNominee ng-model=Nominee.defaultDateNominee format=DD-MMM-YYYY showdefault=\"\'true\'\" viewmode=days maxdate=now data-on-date-change=Nominee.changeStartDateNominee data-min-date=Nominee.dataMinDate data-max-date=Nominee.dataMaxDate name=dob-{{$index}} autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label class=dob-add-nominee style=\"z-index: 0\">DOB - DD/MMM/YYYY<span ng-if=\"nomineeData.nomineeName && nomineeData.minor\" class=req>*</span></label><span ng-show=\"nomineeForm[\'dob-\'+$index].$dirty && nomineeForm[\'dob-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'dob-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_DOB_REQUIRED></span></span></div></div><!--                </div>--><!--              <div class=\"row d-flex flex-wrap\">--><div class=\"col-md-4 col-xs-12\"><div class=\"input-select input-normal selectfield select-data mgt7\" ng-class=\"{error:nomineeForm[\'nomineeRelation-\'+$index].$dirty && nomineeForm[\'nomineeRelation-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=nomineeRelation-{{$index}} easyassist-key=mask-element ng-model=nomineeData.nomineeRelation ng-init=\"nomineeData.nomineeRelation=nomineeData.nomineeRelation?nomineeData.nomineeRelation:null\" ng-options=\"relationship.value as relationship.relationDesc for relationship in Nominee.relationshipsList\" ng-change=\"Nominee.changeNomineeRelation(nomineeData.nomineeRelation, $index)\" required><option value=\"\" selected>Relationship with Applicant</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeRelation class=ng-scope>Relationship with Applicant</label><span ng-if=nomineeData.nomineeName class=req>*</span> <span ng-show=\"nomineeForm[\'nomineeRelation-\'+$index].$dirty && nomineeForm[\'nomineeRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeRelation-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_RELATION_REQUIRED></span> </span><!--<span ng-if=\"nomineeData.nomineeName\" class=\"req\">*</span>--></div></div><!--                <div class=\"col-md-4 col-xs-12\" ng-if=\"nomineeData.nomineeRelation == \'OTHERS\' && Nominee.formData.folioCreationRequestCO.showNomineeUpdate\">--><!--                  <div class=\"input-normal\" ng-class=\"{error:nomineeForm[\'nomineeOtherRelation-\'+$index].$dirty && nomineeForm[\'nomineeOtherRelation-\'+$index].$invalid}\">--><!--                    <input type=\"text\"--><!--                           name=\"nomineeOtherRelation-{{$index}}\" autocomplete=\"off\"--><!--                           ng-model=\"nomineeData.nomineeOtherRelation\" ng-maxlength=\"50\" limit-to=\"50\" maxlength=\"50\" only-alphabets--><!--                           ng-required=\"nomineeData.nomineeRelation == \'OTHERS\' && Nominee.formData.folioCreationRequestCO.showNomineeUpdate\"--><!--                    >--><!--                    <span--><!--                      ng-show=\"nomineeForm[\'nomineeOtherRelation-\'+$index].$dirty && nomineeForm[\'nomineeOtherRelation-\'+$index].$invalid\">--><!--                  <span class=\"error-input\" ng-if=\"nomineeForm[\'nomineeOtherRelation-\'+$index].$error.required\"--><!--                        ng-bind=\"Nominee.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER\"></span>--><!--                  </span>--><!--                    <label class=\"dob-add-nominee\" style=\"z-index: 0\">Others (please specify) <span ng-if=\"nomineeData.nomineeRelation == \'OTHERS\'\" class=\"req\">*</span></label>--><!--                  </div>--><!--                </div>--><!--    Nominee Email   --><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineeEmail-\'+$index].$dirty && nomineeForm[\'nomineeEmail-\'+$index].$invalid}\"><input type=email name=nomineeEmail-{{$index}} autocomplete=off ng-model=nomineeData.emailId ng-pattern=Nominee.CONST.email_regex ng-change=\"Nominee.changeEmailId($index ,nomineeData.emailId)\" maxlength=256 ng-maxlength=256 limit-to=256 autocomplete=off ng-required=Nominee.formData.folioCreationRequestCO.showNomineeUpdate> <span ng-show=\"nomineeForm[\'nomineeEmail-\'+$index].$dirty && nomineeForm[\'nomineeEmail-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineeEmail-\'+$index].$error.required\" ng-bind=Nominee.validateData.EMAIL_FIELD></span> <span class=error-input ng-if=\"nomineeForm[\'nomineeEmail-\'+$index].$error.required\" ng-bind=Nominee.validateData.EMAIL_REQUIRED></span> </span><span class=error-input ng-show=\"!nomineeForm[\'nomineeEmail-\'+$index].$invalid && Nominee.formData.folioCreationRequestCO.nominees[$index].emailIdInvalid\">{{Nominee.errorMessageEmail}}</span><label class=dob-add-nominee style=\"z-index: 0\">Nominee Email ID <span ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate class=req>*</span></label></div></div><!--Nominee Mobile Number--><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineeMobile-\'+$index].$dirty && nomineeForm[\'nomineeMobile-\'+$index].$invalid}\"><input type=text name=nomineeMobile-{{$index}} autocomplete=off ng-model=nomineeData.mobileNumber ng-change=\"Nominee.changeMobileNumber($index, nomineeData.mobileNumber)\" autocomplete=off ng-pattern=Nominee.CONST.mobile_regex_new minlength=1 maxlength=15 required> <span ng-show=\"nomineeForm[\'nomineeMobile-\'+$index].$dirty && nomineeForm[\'nomineeMobile-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineeMobile-\'+$index].$error.required\" ng-bind=Nominee.validateData.MOBILE_FIELD></span> <span class=error-input ng-if=\"nomineeForm[\'nomineeMobile-\'+$index].$error.required\" ng-bind=Nominee.validateData.MOBILE_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">Nominee Mobile No. <span ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate class=req>*</span></label></div></div><!--    personal Identifier     --><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate><div class=\"input-select input-normal selectfield select-data mgt7\" ng-class=\"{error:nomineeForm[\'nomineeIdentityProof-\'+$index].$dirty && nomineeForm[\'nomineeIdentityProof-\'+$index].$invalid}\"><select name=nomineeIdentityProof-{{$index}} class=custom-select ng-model=nomineeData.identityProofType ng-init=\"nomineeData.identityProofType = nomineeData.identityProofType ? nomineeData.identityProofType : null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in nomineeData.identityProofList\" ng-change=Nominee.changeNomineeIdentityProof($index,nomineeData.identityProofType) required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><label ng-if=nominee.relation style=\"display: block\" class=margin-top-label>Personal Identifier of Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"nomineeForm[\'nomineeIdentityProof-\'+$index].$dirty && nomineeForm[\'nomineeIdentityProof-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeIdentityProof-\'+$index].$error.required\">{{Nominee.validateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && nomineeData.identityProofType === \'PAN_CARD\'\"><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=nomineePan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.nomineePan ng-change=Nominee.checkDuplicateNomineePan($index,nomineeData.nomineePan,nomineeData.guardianPan); ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ maxlength=10 ng-maxlength=10 limit-to=10 required> <span ng-show=\"nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID_ERROR></span> <span class=error-input ng-if=\"nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Nominee <span class=\"req text-red\">*</span></label><span class=error-input ng-if=\"nomineeData.nomineePanInvalid && nomineeData.nomineePan\" ng-bind=Nominee.errorMessage></span><!--                      <span class=\"error-input\" ng-show=\"!nomineeForm[\'nomineePan-\'+$index].$invalid && Nominee.isDuplicate\">--><!--                        {{Nominee.errorMessagePanIdentity}}--><!--                      </span>--></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && nomineeData.identityProofType === \'DRIVING_LICENSE\'\"><div class=\"input-normal input-other\" ng-class=\"{error: nomineeForm[\'drivingLicense-\'+$index].$dirty && nomineeForm[\'drivingLicense-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.drivingLicense ng-model=nomineeData.drivingLicense name=drivingLicense-{{$index}} ng-change=Nominee.changeDrivingLicense($index,nomineeData.drivingLicense); maxlength=35 ng-maxlength=35 limit-to=35 autocomplete=off required><label>Nominee Driving License No. <span class=\"req text-red\">*</span></label><span ng-show=\"nomineeForm[\'drivingLicense-\'+$index].$dirty && nomineeForm[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'drivingLicense-\'+$index].$error.required || nomineeForm[\'drivingLicense-\'+$index].$error.pattern\">{{Nominee.validateData.VALID_DRIVING_LICENCE}} </span></span><span class=error-input ng-if=\"nomineeData.nomineeDLInvalid && nomineeData.drivingLicense\" ng-bind=Nominee.errorMessageDLIdentity></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && nomineeData.identityProofType === \'AADHAR_CARD\'\"><div class=\"input-normal input-other aadhaar-pd\" ng-class=\"{error: nomineeForm[\'aadharCard-\'+$index].$dirty && nomineeForm[\'aadharCard-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.aadharCard ng-model=nomineeData.aadharCard name=aadharCard-{{$index}} ng-change=Nominee.changeAadharCard($index,nomineeData.aadharCard); maxlength=4 ng-maxlength=4 limit-to=4 ng-pattern=Nominee.CONST.valid_4_digit_aadhar_regex autocomplete=off capitalize required><label>Nominee Aadhaar No.<span class=\"req text-red\">*</span></label><span class=arn style=\"top:13px;color: grey;font-size: large\">XXXX XXXX </span><span ng-show=\"nomineeForm[\'aadharCard-\'+$index].$dirty && nomineeForm[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'aadharCard-\'+$index].$error.pattern || nomineeForm[\'aadharCard-\'+$index].$error.required\">{{Nominee.validateData.AADHAAR_INVALID}} </span></span><!--                      <span class=\"error-input\" ng-show=\"!nomineeForm[\'aadharCard-\'+$index].$invalid && Nominee.isDuplicate\">--><!--                        {{Nominee.errorMessageAadharIdentity}}--><!--                      </span>--> <span class=error-input ng-if=\"nomineeData.nomineeAadharInvalid && nomineeData.aadharCard\" ng-bind=Nominee.errorMessageDLIdentity></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && nomineeData.identityProofType === \'PASSPORT\'\"><div class=\"input-normal input-other\" ng-class=\"{error: nomineeForm[\'passport-\'+$index].$dirty && nomineeForm[\'passport-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.passport ng-model=nomineeData.passport name=passport-{{$index}} ng-change=Nominee.changePassport($index,nomineeData.passport); maxlength=35 ng-maxlength=35 limit-to=35 autocomplete=off required><label>Nominee Passport<span class=\"req text-red\">*</span></label><span ng-show=\"nomineeForm[\'passport-\'+$index].$dirty && nomineeForm[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'passport-\'+$index].$error.required\">{{Nominee.validateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-if=\"nomineeData.nomineePassportInvalid && nomineeData.passport\" ng-bind=Nominee.errorMessagePassportIdentity></span></div></div></div></div><!--<div class=\"form-content\">\n                <div class=\"row\">\n                  <div class=\"col-md-4\">\n                    <span class=\"checkbox\">\n                      <input type=\"checkbox\" ng-model=\"nomineeData.soleAddressApplicable\"\n                             name=\"soleAddressApplicable-{{$index}}\"\n                             id=\"soleAddressApplicable-{{$index}}\"\n                             autocomplete=\"off\">\n              <span class=\"icon-checkbox\"></span>\n            </span>\n                    <label style=\"bottom:5px;position:relative\">Address Same As Investor&lt;!&ndash;<span ng-if=\"nomineeData.nomineeName\" class=\"req\">*</span>&ndash;&gt;</label>\n                  </div>\n                </div>\n              </div> --><div class=form-content ng-if=!nomineeData.minor ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p><strong>Address Details of Nominee</strong></p><div class=\"row mgb20\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text ng-model=nomineeData.nomineeAddress.addressLine1 easyassist-key=mask-element name=addressLine1-{{$index}} autocomplete=off capitalize ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"> <span class=highlight></span> <span class=bar></span><label>Address Line 1<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'addressLine1-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ADDRESSLINE1_REQUIRED></span></span></div></div><div class=col-md-4><div class=input-normal><input type=text ng-model=nomineeData.nomineeAddress.addressLine2 easyassist-key=mask-element name=addressLine2-{{$index}} autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div></div><div class=\"col-md-4 select-country\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'country-\'+$index].$dirty && nomineeForm[\'country-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=country-{{$index}} ng-model=nomineeData.nomineeAddress.country ng-init=\"nomineeData.nomineeAddress.country=nomineeData.nomineeAddress.country?nomineeData.nomineeAddress.country:null\" ng-options=\"country.countryCode as country.countryName for country in Nominee.countryList\" ng-change=Nominee.changeNomineeSelectedCountry($index,nomineeData.nomineeAddress.country) ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" easyassist-key=mask-element><option value=\"\" selected>Country of Birth</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeAddress.country>Country of Birth</label><!--                      <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span> <span ng-show=\"nomineeForm[\'country-\'+$index].$dirty && nomineeForm[\'country-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'country-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_COUNTRY_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 select-country\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-model=nomineeData.nomineeAddress.state ng-options=\"_state.stateCode as _state.stateName for _state in Nominee.stateList\" ng-init=\"nomineeData.nomineeAddress.state=nomineeData.nomineeAddress.state?nomineeData.nomineeAddress.state:null\" ng-disabled=\"nomineeData.nomineeAddress.country != \'IN\'\" class=custom-select ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Select State</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeAddress.state>STATE</label><!--                      <span class=\"req text-red\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span> <span ng-show=\"nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'state-\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.city ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'city-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"input-normal mgt13\" ng-class=\"{error:nomineeForm[\'pinCode-\'+$index].$dirty && nomineeForm[\'pinCode-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.pinCode name=pinCode-{{$index}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" maxlength=6 minlength=6 autocomplete=off is-number ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'pinCode-\'+$index].$dirty && nomineeForm[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'pinCode-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ZIP_REQUIRED></span></span></div></div></div></div><div class=form-content ng-if=nomineeData.minor><!--<h6><strong>Nominee is minor so please fill guardian detail</strong></h6><br/>--><p><strong>Details of Nominee’s guardian</strong></p><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianName-\'+$index].$dirty && nomineeForm[\'guardianName-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.guardianName name=guardianName-{{$index}} autocomplete=off ng-pattern=/^[a-zA-Z\\s\\.]+$/ required capitalize> <span class=highlight></span> <span class=bar></span><label>Name of the guardian <span class=req>*</span></label><span ng-show=\"nomineeForm[\'guardianName-\'+$index].$dirty && nomineeForm[\'guardianName-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianName-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAMEGUARDIAN_REQUIRED></span> <span class=error-input ng-show=\"nomineeForm[\'guardianName-\'+$index].$error.pattern\" ng-bind=Nominee.validateData.GUARDIAN_TEXT_ONLY></span></span></div></div><div class=\"col-md-4 select-country\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'guardianRelation-\'+$index].$dirty && nomineeForm[\'guardianRelation-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=custom-select name=guardianRelation-{{$index}} ng-model=nomineeData.guardianRelation ng-init=\"nomineeData.guardianRelation=nomineeData.guardianRelation?nomineeData.guardianRelation:null\" ng-options=\"relationship.value as relationship.relationDesc for relationship in Nominee.guardianRelationShipList\" required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><span class=req>*</span><label style=\"display: block\" ng-if=nomineeData.guardianRelation>Guardian\'s Relationship with Nominee</label><span ng-show=\"nomineeForm[\'guardianRelation-\'+$index].$dirty && nomineeForm[\'guardianRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianRelation-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_RELATIONSHIP></span></span></div><div class=input-normal ng-if=\"(nomineeData.guardianRelation===Nominee.CONST.RELATIONS.OTHER)\"><input type=text ng-model=Nominee.guardianRelationOther name=addressLine2-0 only-alphabets maxlength=40 ng-change=Nominee.guardianRelationOther autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Other Relationship(Kindly specify)<span ng-if=nomineeData.guardianName class=req>*</span></label></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianPan-\'+$index].$dirty && nomineeForm[\'guardianPan-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=guardianPan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.guardianPan ng-change=Nominee.checkUniqueGuardianPan($index,nomineeData.guardianPan,true); ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ > <span ng-show=\"nomineeForm[\'guardianPan-\'+$index].$dirty && nomineeForm[\'guardianPan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'guardianPan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID></span> <span class=error-input ng-if=\"nomineeForm[\'guardianPan-\'+$index].$error.required\" ng-bind=Nominee.validateData.GUARDIAN_PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Guardian<!--                        <span class=\"req\">*</span>--></label><span class=error-input ng-if=\"(nomineeData.guardianPanInvalid || !nomineeData.verifiedPan) && nomineeData.guardianPan\" ng-bind=Nominee.errorMessageGuardian></span></div></div></div><div ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p><strong>Address Details of Nominee’s guardian</strong></p><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianAddress1-\'+$index].$dirty && nomineeForm[\'guardianAddress1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element name=guardianAddress1-{{$index}} ng-model=nomineeData.guardianAddress.addressLine1 autocomplete=off ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line1<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'guardianAddress1-\'+$index].$dirty && nomineeForm[\'guardianAddress1-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianAddress1-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ADDRESSLINE1_REQUIRED></span></span></div></div><div class=col-md-4><div class=input-normal><input type=text easyassist-key=mask-element name=guardianAddress2-{{$index}} ng-model=nomineeData.guardianAddress.addressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line2</label></div></div><div class=\"col-md-4 select-country\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'guardianCountry-\'+$index].$dirty && nomineeForm[\'guardianCountry-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=guardianCountry-{{$index}} ng-model=nomineeData.guardianAddress.country easyassist-key=mask-element ng-change=Nominee.changeSelectedCountry($index,nomineeData.guardianAddress.country) ng-options=\"country.countryCode as country.countryName for country in Nominee.countryList\" ng-init=\"nomineeData.guardianAddress.country=nomineeData.guardianAddress.country?nomineeData.guardianAddress.country:null\" ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Country of Birth</option></select><label style=\"display: block\" ng-if=nomineeData.guardianAddress.country>Country of Birth</label><!--                      <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span> <span ng-show=\"nomineeForm[\'guardianCountry-\'+$index].$dirty && nomineeForm[\'guardianCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianCountry-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_COUNTRY_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-4 select-country\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-model=nomineeData.guardianAddress.state ng-options=\"_state.stateCode as _state.stateName for _state in Nominee.stateList\" ng-disabled=\"nomineeData.guardianAddress.country != \'IN\'\" ng-init=\"nomineeData.guardianAddress.state=nomineeData.guardianAddress.state?nomineeData.guardianAddress.state:null\" class=custom-select ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Select State</option></select><label style=\"display: block\" ng-if=nomineeData.guardianAddress.state>STATE</label><!--                      <span   ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req text-red\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span> <span ng-show=\"nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'state-\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"nomineeData.guardianAddress.country===\'India\'\" ng-class=\"{error:nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=guardianCity-{{$index}} ng-model=nomineeData.guardianAddress.city easyassist-key=mask-element ng-options=\"city.cityName as city.cityName for city in Nominee.cityList\" ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>City of Birth <span ng-if=!nomineeData.soleAddressApplicable class=req>*</span></option></select><span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span> <span ng-show=\"nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianCity-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_CITY_REQUIRED></span></span></div><div class=\"input-select input-normal mr-less mgt13\" ng-if=\"nomineeData.guardianAddress.country != \'India\'\" ng-class=\"{error:nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=guardianCity-{{$index}} easyassist-key=mask-element ng-model=nomineeData.guardianAddress.city ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianCity-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"input-normal mgt13\" ng-class=\"{error:nomineeForm[\'guardinaPinCode-\'+$index].$dirty && nomineeForm[\'guardinaPinCode-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=guardinaPinCode-{{$index}} easyassist-key=mask-element ng-model=nomineeData.guardianAddress.pinCode minlength=6 maxlength=6 ng-required=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" autocomplete=off onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<!--                        <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !nomineeData.soleAddressApplicable\" class=req>*</span></label><span ng-show=\"nomineeForm[\'guardinaPinCode-\'+$index].$dirty && nomineeForm[\'guardinaPinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardinaPinCode-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ZIP_REQUIRED></span></span></div></div></div></div></div></div></div><div ng-if=!Nominee.formData.folioCreationRequestCO.addNomineeLater class=add-nominee-details><div><div class=\"form-content nominee-statement\" ng-if=Nominee.formData.folioCreationRequestCO.showNomineeUpdate><div class=row><div class=col-md-12><p><strong>Statement of Holding (Account Statement) Declaration <span class=req>*</span></strong></p><p class=text-black>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</p><div><div class=\"radio-block flex-radio\"><div class=row><div class=col-md-4><span class=radio><input type=radio ng-model=Nominee.formData.folioCreationRequestCO.nomination ng-change=Nominee.setStatement() name=nomineeName id=nomineeName autocomplete=off ng-value=true> <span class=check></span></span><label>Nomination: Yes</label></div></div><div class=row><div class=col-md-4><span class=radio><input type=radio ng-model=Nominee.formData.folioCreationRequestCO.nomination ng-change=Nominee.setStatement() name=nomination id=nomination autocomplete=off ng-value=false> <span class=check></span></span><label>Nomination: No</label></div></div></div></div></div></div></div><!--<div class=\"statement-declaration\"  ng-if=\"Nominee.formData.folioCreationRequestCO.showNomineeUpdate && Nominee.formData.folioCreationRequestCO.holdMode !== \'ANY_OR_SURVIVOR\'\">\n                <p class=\"section-title\">Incapacitation Declaration (Optional)\n                  <i class=\"tooltip-info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"\n                     data-placement=\"{{Main.tooltipClass}}\"\n                     title=\'<div>\n                      SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                      a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                      b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                      c) change such mandate any number of times without any restriction. <br/>\n                    </div>\'>\n                  </i>\n                </p>\n                <div class=\"declaration-content\">\n                  <div class=\"row\">\n                    <div class=\"col-md-12 pdLeft35\">\n                <span>I hereby authorize\n                  <select class=\"browser-default custom-select\" name=\"selectNomineeName\" easyassist-key=\"mask-element\"\n                          ng-model=\"Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList\"\n                          ng-init=\"Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList=Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList? Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList:null\"\n                          ng-options=\"nominee as nominee.nomineeCode disable when (nominee.activeFlag) for nominee in Nominee.formData.folioCreationRequestCO.incapacitationNameList track by nominee.nomineeCode\"\n                          ng-change = \"Nominee.changeSelectedName(Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList)\"\n                          ng-disabled=\"!Nominee.hasNomineeName()\"\n                  >\n                    <option value=\"\" selected>Select Nominee Name</option>\n                  </select>\n                  (nominee number <input type=\"text\" ng-model=\"Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number readonly/>)\n                  to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up\n                  to <input type=\"text\" ng-model=\"Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage\" name=\"percentage\" is-number maxlength=\"3\"\n                            ng-required=\"Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList && !Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-pattern=\"/^(100|[1-9]?[0-9])$/\"\n                            ng-disabled=\"Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount || !Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList\"\n                            ng-change=\"Nominee.changePercentageOrAmount(\'percentage\')\"\n                  >% of assets in the account / folio\n                  or Rs. <input type=\"text\" ng-model=\"Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount\" name=\"allowedAmount\" ng-pattern=\"/^[1-9]\\d*$/\"\n                                is-number maxlength=\"20\" ng-disabled = \"Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage || !Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList\"\n                                ng-change=\"Nominee.changePercentageOrAmount(\'amount\')\"\n                                ng-required=\"Nominee.formData.folioCreationRequestCO.incapacitationDeclarationNameList && !Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage\">.\n                </span>\n\n                      &lt;!&ndash; Error shown&ndash;&gt;\n                      <span ng-show=\"nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid\">\n                        <span class=\"error-input\" ng-show=\"nomineeForm[\'allowedAmount\'].$error.pattern\">\n                        Amount/percentage cannot be less than 1.\n                      </span>\n                        <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage < 1\">\n                          Amount/percentage cannot be less than 1.\n                        </span>\n                        <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && Nominee.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage > 100\">\n                          Percentage cannot be more than 100%.\n                        </span>\n                      </span>\n                      <span ng-show=\"(nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'allowedAmount\'].$dirty && nomineeForm[\'allowedAmount\'].$invalid)\">\n                        <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.required || nomineeForm[\'allowedAmount\'].$error.required\">\n                          Please enter the percentage or Rs. that can be encashed by the nominee.\n                        </span>\n                      </span>\n                    </div>\n                  </div>\n                </div>\n              </div>--></div></div><hr><div class=\"form-footer form-content clearfix\"><!--<button class=\"btn btn-negative-action\" ng-click=\"Nominee.goPrevious(\'soleApplicant\')\">Previous</button>--><p class=\"text-danger error-submission\" ng-if=\"nomineeForm.$invalid && !Nominee.formData.folioCreationRequestCO.addNomineeLater\" ng-bind=Nominee.validationMsg></p><div class=\"pull-left back\"><!--<a class=\"btn-back\" ui-sref=\"main.investors.add.appdetails\"><i class=\"back-arrow-icon\"></i>Back</a>--> <a class=btn-back ng-click=Nominee.goToAppDetails()><i class=back-arrow-icon></i>Back</a></div><div class=\"pull-right flex-style\"><button type=button class=\"btn btn-negative-action\" ng-click=Nominee.cancelTransaction();>Cancel</button> <button type=submit class=\"btn btn-primary-action btn-next\" ng-disabled=\"Nominee.nomineeFormUpper.$invalid||nomineeForm.$invalid || Nominee.buttonEnable() || Nominee.ispanValid || Nominee.dobRequired || (Nominee.formData.folioCreationRequestCO.showNomineeUpdate && !Nominee.emailIdValid && !Nominee.formData.folioCreationRequestCO.addNomineeLater)\">Continue</button></div></div></form></div></div></div></div>");
$templateCache.put("app/investors/add/payment/add.payment.html","<div ng-init=Payment.init();><div class=tab-content><div id=bank-info><div class=form-box><form autocomplete=off name=Payment.paymentForm novalidate><label ng-if=!Payment.formData.folioCreationRequestCO.soleApplicantDetail.minor class=add-bank-details>Add Bank Details for - {{Payment.formData.folioCreationRequestCO.soleApplicantDetail.name}}<i class=tooltip-info-icon></i> <small>(This Bank is for IDCW Payout and Redemption purposes.)</small></label><label ng-if=Payment.formData.folioCreationRequestCO.soleApplicantDetail.minor class=add-bank-details>Account Details <small>(This Bank is for IDCW Payout and Redemption purposes.)</small></label><!--          <div class=\"col-md-12 form-group minor-type-acc\" ng-if=\"Payment.formData.folioCreationRequestCO.soleApplicantDetail.minor\">--><!--              <span class=\"radio-block\" style=\"margin-right: 80px\">--><!--                <span class=\"radio\" >--><!--                  <input type=\"radio\" name=\"bankOptions\" value=\"MINOR\"--><!--                         ng-model=\"Payment.formData.folioCreationRequestCO.bankDetails.bankHolderType\"--><!--                  />--><!--                  <span class=\"check\"></span>--><!--                </span>--><!--                <label>Account held by Minor</label>--><!--              </span>--><!--              <span class=\"radio-block\">--><!--                <span class=\"radio\">--><!--                  <input type=\"radio\" name=\"bankOptions\" value=\"INVESTOR\"--><!--                         ng-model=\"Payment.formData.folioCreationRequestCO.bankDetails.bankHolderType\"--><!--                  />--><!--                  <span class=\"check\"></span>--><!--                </span>--><!--                <label>Account held by Investor <span class=\"small-grey-text\">(in the capacity of the guardian)</span></label>--><!--              </span>--><!--          </div>--><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.ifsccode.$dirty && Payment.paymentForm.ifsccode.$invalid}\"><input type=text ng-model=Payment.formData.folioCreationRequestCO.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize ng-change=Payment.clearBankField() ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode} required ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-readonly=Payment.formData.folioCreationRequestCO.bankDetails.ifsccode> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=Payment.selectIFSC()></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"Payment.paymentForm.ifsccode.$dirty && Payment.paymentForm.ifsccode.$invalid\"><span class=error-input ng-show=Payment.paymentForm.ifsccode.$error.required ng-bind=Payment.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=Payment.paymentForm.ifsccode.$error.pattern ng-bind=Payment.validateData.IFSC_CODE_REGEX></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.bankName.$dirty && Payment.paymentForm.bankName.$invalid}\"><input type=text ng-model=Payment.formData.folioCreationRequestCO.bankDetails.bankName name=bankName required ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.bankName ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.bankName} ng-readonly=Payment.formData.folioCreationRequestCO.bankDetails.bankName> <span ng-show=\"Payment.paymentForm.bankName.$dirty && Payment.paymentForm.bankName.$invalid\"><span class=error-input ng-show=Payment.paymentForm.bankName.$error.required ng-bind=Payment.validateData.BANK_NAME_REQUIRED></span></span><label>Bank Name<span class=req>*</span></label></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield ng-class=\"{error:Payment.paymentForm.accountType.$dirty && Payment.paymentForm.accountType.$invalid}\"><select class=\"select-box custom-select selectCustomMob\" name=accountType ng-model=Payment.formData.folioCreationRequestCO.bankDetails.accountType ng-options=\"_type as _type.accountType for _type in Payment.bankTypeList\" ng-change=Payment.setAccountType() required ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"Payment.formData.folioCreationRequestCO.bankDetails.accountType=Payment.formData.folioCreationRequestCO.bankDetails.accountType?Payment.formData.folioCreationRequestCO.bankDetails.accountType:null\"><option value=\"\" selected>Account Type</option></select><span ng-show=\"Payment.paymentForm.accountType.$dirty && Payment.paymentForm.accountType.$invalid\"><span class=error-input ng-show=Payment.paymentForm.accountType.$error.required ng-bind=Payment.validateData.ACCOUNT_TYPE_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.branchLocation.$dirty && Payment.paymentForm.branchLocation.$invalid}\"><input type=text ng-model=Payment.formData.folioCreationRequestCO.bankDetails.branchLocation name=branchLocation required autocomplete=off capitalize maxlength=40 ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.branchLocation} ng-readonly=Payment.formData.folioCreationRequestCO.bankDetails.branchLocation> <span class=highlight disabled></span> <span class=bar></span><label>Branch Location<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.branchLocation.$dirty && Payment.paymentForm.branchLocation.$invalid\"><span class=error-input ng-show=Payment.paymentForm.branchLocation.$error.required ng-bind=Payment.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.bankBranch.$dirty && Payment.paymentForm.bankBranch.$invalid}\"><input type=text ng-model=Payment.formData.folioCreationRequestCO.bankDetails.bankCity name=bankBranch required autocomplete=off capitalize only-alphabets ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.bankCity} ng-readonly=Payment.formData.folioCreationRequestCO.bankDetails.bankCity> <span class=highlight></span> <span class=bar></span><label>Branch City<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.bankBranch.$dirty && Payment.paymentForm.bankBranch.$invalid\"><span class=error-input ng-show=Payment.paymentForm.bankBranch.$error.required ng-bind=Payment.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield ng-class=\"{error:Payment.paymentForm.payoutMechanism.$dirty && Payment.paymentForm.payoutMechanism.$invalid}\"><select class=\"select-box custom-select selectCustomMob\" name=payoutMechanism ng-model=Payment.payoutMechanism ng-options=\"_type as _type.payoutDescription for _type in Payment.payoutMechanismList\" ng-change=Payment.setPayoutMechanism() required ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"Payment.payoutMechanism=Payment.payoutMechanism?Payment.payoutMechanism:null\"><option value=\"\" selected>Payout Mechanism</option></select><span ng-show=\"Payment.paymentForm.payoutMechanism.$dirty && Payment.paymentForm.payoutMechanism.$invalid\"><span class=error-input ng-show=Payment.paymentForm.payoutMechanism.$error.required ng-bind=Payment.validateData.PAYOUT_MECH_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:(Payment.accModelDirty &&\n                 (!Payment.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length || Payment.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1))}\"><input type=text easyassist-key=mask-element ng-model=Payment.formData.folioCreationRequestCO.bankDetails.accountNumber maxlength=20 name=accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off directive.mask ng-change=Payment.accFocus(); ng-keydown=Payment.copyPasteHandler($event) capitalize ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=Payment.accModelDirty><span class=error-input ng-show=Payment.paymentForm.accountNumber.$error.required ng-bind=Payment.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(Payment.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length !=0 && Payment.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=Payment.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.verifyAccountNumber.$dirty && Payment.paymentForm.verifyAccountNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=Payment.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber maxlength=20 limit-to=20 ng-maxlength=20 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=Payment.formData.folioCreationRequestCO.bankDetails.accountNumber required autocomplete=off ng-keydown=Payment.copyPasteHandler($event) capitalize ng-disabled=!Payment.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:Payment.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.verifyAccountNumber.$dirty && Payment.paymentForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=\"Payment.paymentForm.verifyAccountNumber.$error.maxlength && !Payment.paymentForm.verifyAccountNumber.$error.required\" ng-bind=Payment.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"Payment.paymentForm.verifyAccountNumber.$error.pattern && !Payment.paymentForm.verifyAccountNumber.$error.maxlength && !Payment.paymentForm.verifyAccountNumber.$error.required\" ng-bind=Payment.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div></div><ng-bind-html dynamic=Payment.dynamicNoteList.content></ng-bind-html><div class=\"row form-grid\" ng-show=\"Payment.formData.folioCreationRequestCO.bankDetails.pennyDropValid === false\"><p><strong>Upload Cheque Leaf <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Account Number and Name should be printed the face of cheque.Max file size should be less than or equal to 2 MB.File format should be tiff, tif, jpg and jpeg extension.\"></i> </strong></p><div class=col-md-6><div class=form-group><span class=\"file-name text-blue\" ng-if=\"Payment.fileType === \'tif\' || Payment.fileType === \'tiff\'\"><a href=javascript:void(0) ng-click=\"Payment.downloadFile(Payment.formData.folioCreationRequestCO.chequeLeafUrl,Payment.fileType,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\'\" ng-click=Payment.openUploadedDoc(Payment.formData.folioCreationRequestCO.chequeLeafUrl)>{{Payment.chequeLeaf}}</span> <span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=Payment.myFile targetimg=showingImgId upload=Payment.uploadFile(file) ng-required=\"Payment.chequeLeaf !==\'\'\"><label for=uploadFileId class=\"btn-upload btn-secondary-action\">{{Payment.fileType ?\'Change\':\'upload leaf\'}}</label></span></div></div></div><!--dynamic note bank validate--><ng-bind-html dynamic=Payment.dynamicNoteValidate.content></ng-bind-html><div class=\"form-footer form-content clearfix\"><div class=\"pull-left back\" ng-if=!Payment.formData.folioCreationRequestCO.soleApplicantDetail.minor><a href=javascript:void(0) ng-show=Payment.formData.folioCreationRequestCO.addNomineeLater class=btn-back ng-click=Payment.goToAppDetails()><i class=back-arrow-icon></i>Back</a> <a href=javascript:void(0) ng-hide=Payment.formData.folioCreationRequestCO.addNomineeLater class=btn-back ng-click=Payment.goToNominee()><i class=back-arrow-icon></i>Back</a></div><div class=\"pull-left back\" ng-if=Payment.formData.folioCreationRequestCO.soleApplicantDetail.minor><a href=javascript:void(0) class=btn-back ng-click=Payment.goToAppDetails()><i class=back-arrow-icon></i>Back</a></div><div class=\"pull-right flex-style\"><button type=button class=\"btn btn-negative-action\" ng-click=Payment.cancelTransaction();>Cancel</button> <button type=button ng-disabled=Payment.paymentForm.$invalid ng-if=!Payment.formData.folioCreationRequestCO.bankDetails.pennyDropValid class=\"btn btn-primary-action btn-next\" ng-click=Payment.reviewTransaction();>Review</button> <button type=button ng-disabled=Payment.paymentForm.$invalid class=\"btn btn-primary-action btn-next\" ng-if=Payment.formData.folioCreationRequestCO.bankDetails.pennyDropValid ng-click=Payment.validatePennyDrop()>Validate</button></div></div></form></div></div></div></div>");
$templateCache.put("app/investors/add/review/add.review.html","<div class=box-body id=review-folio-minor ng-init=Review.init()><form autocomplete=off class=review-minor-form><h3 class=page-title><small>Review Folio Creation</small></h3><h4>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.name}} | <span class=pan>PAN :</span><span easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.panNumber}}</span></h4><section class=minor-details ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><div class=\"box-head clearfix\"><p class=pull-left><strong>Minor Details</strong></p><i class=\"pull-right edit-icon\" ng-click=Review.editSoleApplicantForm()></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=col-md-4><table class=table><tr><td><span><strong>Name:</strong></span> &nbsp; <strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.minorName}}</strong></td></tr><!--<tr>\n                <td><span><strong>PAN:</strong></span> &nbsp; <strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.panNumber?Review.formData.folioCreationRequestCO.soleApplicantDetail.panNumber:\'Not Provided\'}}</strong></td>\n              </tr>--><tr><td><span><strong>DOB:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.dob}}</strong></td></tr></table></div><div class=\"col-md-4 attachment\"><p><span><strong>DOB Proof:</strong></span></p><div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">{{Review.minorAgeProofFilename}}</span></div></div></div></div></section><section class=guardian-details><div class=\"box-head clearfix\"><p class=pull-left ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><strong>Guardian Details</strong></p><p class=pull-left ng-if=!Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><strong>Sole Applicant Details</strong></p><i class=\"pull-right edit-icon\" ng-click=Review.editSoleApplicantForm()></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=\"col-md-4 bordered\"><h5 class=text-blue ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>Guardian’s Income Details</h5><h5 class=text-blue ng-if=!Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>Income Details</h5><table class=table><tr><td><span><strong>Email:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.email}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo><td><span><strong>Mobile Number:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.mobileNo}}</strong></td></tr><tr><td><span><strong>Tax Status:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.reviewModalData.taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.reviewModalData.occupationDescription}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{Review.reviewModalData.incomeDescription}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.netWorth><td><span><strong>Net Worth:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.netWorth}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate><td><span><strong>Net Worth Date:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.netWorthDate}}</strong></td></tr><tr><td class=\"<!--pdt20-->\"><span><strong>Political Exposed Person Status:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus?Review.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus:\'Not Applicable\'}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><td class=pdb20><span><strong>Relationship with Minor:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.guardianDetails.relationship}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><td class=attachment><span class=proof><strong>Relationship Proof:</strong></span> &nbsp;<div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">{{Review.relationshipProofFilename}}</span></div></td></tr></table></div><div class=\"col-md-4 bordered\"><h5 class=text-blue ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>Guardian’s FATCA &amp; CSR information</h5><h5 class=text-blue ng-if=!Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>FATCA &amp; CSR information</h5><table class=table><tr><td><span><strong>Country of Birth: </strong></span>&nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.birthCountry.countryName}}</strong></td></tr><tr><td><span><strong>City of Birth:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.birthCity}}</strong></td></tr><tr><td><span><strong>Address Type:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType.addressDescription}}</strong></td></tr></table></div><div class=col-md-4><h5 class=text-blue ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>Guardian’s Tax Details</h5><h5 class=text-blue ng-if=!Review.formData.folioCreationRequestCO.soleApplicantDetail.minor>Tax Details</h5><table class=table ng-repeat=\"payOutsideIndiaAddresses in Review.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses\" ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length><tr><td><span><strong>Name of Country{{$index+1}}: </strong></span>&nbsp; <strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.country.countryName}}</strong></td></tr><tr><td><span><strong>Tax ID Type{{$index+1}}:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.taxIdType.value}}</strong></td></tr><tr><td><span><strong>Tax ID Number{{$index+1}}:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.taxIdNumber}}</strong></td></tr></table><table ng-if=\"Review.formData.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length==0\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=guardian-details ng-if=\"Review.formData.folioCreationRequestCO.jointHolders.length>0\"><div class=\"box-head clearfix\"><p class=pull-left><strong>Holders Details</strong></p><i class=\"pull-right edit-icon\" ng-click=Review.editJointHolderForm()></i></div><div class=box-body ng-repeat=\"holder in Review.formData.folioCreationRequestCO.jointHolders\"><div class=\"box-details clearfix\"><div class=col-md-4><strong>Holders Name:</strong> {{holder.jointHolderName}}</div></div><div class=\"box-details clearfix\"><div class=\"col-md-3 bordered\"><h5 class=text-blue>Income Details</h5><table class=table><tr><td><span><strong>Tax Status:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.reviewModalData.holders[$index].taxStatusDescription}}</strong></td></tr><tr><td><span><strong>Occupation:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.reviewModalData.holders[$index].occupationDescription}}</strong></td></tr><tr ng-if=holder.jointHolderApplicantDetail.grossAnnualIncome><td><span><strong>Gross Annual Income:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{Review.reviewModalData.holders[$index].incomeDescription}}</strong></td></tr><tr ng-if=holder.jointHolderApplicantDetail.netWorth><td><span><strong>Net Worth:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{holder.jointHolderApplicantDetail.netWorth}}</strong></td></tr><tr><td class=pdt20><span><strong>Political Exposed Person Status?:</strong></span> &nbsp;<strong>{{holder.jointHolderApplicantDetail.politicalStatus?holder.jointHolderApplicantDetail.politicalStatus:\'Not Applicable\'}}</strong></td></tr></table></div><div class=\"col-md-3 bordered\"><h5 class=text-blue>FATCA &amp; CSR information</h5><table class=table><tr><td><span><strong>Country of Birth: </strong></span>&nbsp; <strong easyassist-key=mask-element>{{holder.jointHolderApplicantDetail.birthCountry}}</strong></td></tr><tr><td><span><strong>City of Birth:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{holder.jointHolderApplicantDetail.birthCity}}</strong></td></tr><tr><td><span><strong>Address Type:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{holder.jointHolderApplicantDetail.fatcaAddressType.addressDescription}}</strong></td></tr></table></div><div class=\"col-md-3 bordered\"><h5 class=text-blue>Tax Details</h5><table class=table ng-repeat=\"payOutsideIndiaAddresses in holder.jointHolderApplicantDetail.payOutsideIndiaAddresses\" ng-if=holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length><tr><td><span><strong>Name of Country{{$index+1}}: </strong></span>&nbsp; <strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.countryName}}</strong></td></tr><tr><td><span><strong>Tax ID Type{{$index+1}}:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.taxIdType.value}}</strong></td></tr><tr><td><span><strong>Tax ID Number{{$index+1}}:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{payOutsideIndiaAddresses.taxIdNumber}}</strong></td></tr></table><table ng-if=\"holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length==0\"><tr><td><span><strong>Tax Details Not Available</strong></span></td></tr></table></div><div class=col-md-3><h5 class=text-blue>Contact Details</h5><table class=table ng-if=Review.formData.folioCreationRequestCO.jointHolders.length><tr><td><span><strong>Email: </strong></span>&nbsp; <strong easyassist-key=mask-element>{{holder.email}}</strong></td></tr><tr><td><span><strong>Mobile: </strong></span>&nbsp;<strong easyassist-key=mask-element>{{holder.mobileNo}}</strong></td></tr></table><table ng-if=\"Review.formData.folioCreationRequestCO.jointHolders.length==0\"><tr><td><span><strong>Contact Details Not Available</strong></span></td></tr></table></div></div></div></section><section class=minor-details ng-if=Review.formData.folioCreationRequestCO.nominees.length><div class=\"box-head clearfix\"><p class=pull-left><strong>Nominee Details</strong></p><i class=\"pull-right edit-icon\" ng-click=Review.editNomineeApplicantForm()></i></div><div class=box-body><div class=\"box-details clearfix\" ng-class=\"{\'scroll-nominee\': Review.formData.folioCreationRequestCO.nominees.length > 3}\"><div class=\"col-md-4 nominee-flex\" ng-repeat=\"nominee in Review.formData.folioCreationRequestCO.nominees\"><h6 class=text-blue>Nominee {{$index+1}} Detail</h6><table class=table><tr><td><span><strong>Nominee Name:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeName}}</strong></td></tr><tr ng-if=nominee.emailId><td><span><strong>Nominee Email ID:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.emailId?nominee.emailId:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=nominee.mobileNumber><td><span><strong>Nominee Mobile No.:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.mobileNumber?nominee.mobileNumber:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=nominee.nomineePan><td><span><strong>Nominee Pan:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineePan?nominee.nomineePan:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=nominee.drivingLicense><td><span><strong>Nominee Driving License :</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.drivingLicense?nominee.drivingLicense:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=nominee.aadharCard><td><span><strong>Nominee Aadhaar :</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.aadharCard ? \'XXXX XXXX \' + nominee.aadharCard:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=nominee.passport><td><span><strong>Nominee Passport :</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.passport}}</strong></td></tr><tr><td><span><strong>Nominee Relation:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeRelation}}</strong></td></tr><tr ng-if=\"nominee.nomineeRelation === \'OTHERS\'\"><td><span><strong>Others:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeOtherRelation}}</strong></td></tr><tr ng-if=nominee.dob><td><span><strong>Nominee Dob:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.dob}}</strong></td></tr><tr ng-if=nominee.minor><td><span><strong>The Nominee is Minor:</strong></span> &nbsp; <input type=checkbox ng-model=nominee.minor disabled></td></tr><tr><td><span><strong>Nominee Percentage:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.percentage}}</strong></td></tr><tr ng-if=!nominee.minor><td><span><strong>The Nominee is Minor:</strong></span> &nbsp; <input type=checkbox ng-model=nominee.minor disabled></td></tr><tr ng-if=nominee.soleAddressApplicable><td><span><strong>Address Details:</strong></span> &nbsp; <strong>Same As Investor</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine1:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine1}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine2:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine2}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee AddressLine3:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.addressLine3}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s City:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.city}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.country && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s Country:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.countryName}}</strong></td></tr><tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.soleAddressApplicable && !nominee.minor\"><td><span><strong>Nominee\'s PinCode:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.nomineeAddress.pinCode}}</strong></td></tr><tr><td ng-if=\"nominee.guardianName && !nominee.soleAddressApplicable && nominee.minor\"><span><strong easyassist-key=mask-element>Guardian Name:</strong></span> &nbsp; <strong>{{nominee.guardianName}}</strong></td></tr><tr><td ng-if=\"!nominee.soleAddressApplicable && nominee.minor\"><span><strong easyassist-key=mask-element>Guardian Pan:</strong></span> &nbsp; <strong>{{nominee.guardianPan?nominee.guardianPan:\"NOT AVAILABLE\"}}</strong></td></tr><tr><td ng-if=\"nominee.guardianRelation && !nominee.soleAddressApplicable && nominee.minor\"><span><strong easyassist-key=mask-element>Guardian Relation with Nominee:</strong></span> &nbsp; <strong>{{nominee.guardianRelation?nominee.guardianRelation:\"NOT AVAILABLE\"}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine1:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.addressLine1}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine2:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.addressLine2}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3 && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s AddressLine3:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.addressLine3}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s City:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.city}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.country && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s Country:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.countryName}}</strong></td></tr><tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && !nominee.soleAddressApplicable && nominee.minor\"><td><span><strong>Guardian\'s PinCode:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{nominee.guardianAddress.pinCode}}</strong></td></tr></table></div></div><div class=box-body><div class=\"box-details clearfix\"><div class=col-md-4 ng-if=Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeName><h6 class=text-blue>Incapacitation Details</h6><table class=table><tr><td><span><strong>Nominee Name:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeName}}</strong></td></tr><tr><td><span><strong>Nominee Number:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber}}</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage><td><span><strong>Percentage:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.percentage}}%</strong></td></tr><tr ng-if=Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount><td><span><strong>Amount:</strong></span> &nbsp; <strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.nomineeRegistrationCO.incapacitationDeclaration.amount}}</strong></td></tr></table></div><div class=col-md-4><h6 class=text-blue>Statement of Holding:</h6><table class=table><tr ng-if=Review.formData.folioCreationRequestCO.nomination><td><span><strong></strong></span> &nbsp; <strong easyassist-key=mask-element>Nomination: Yes</strong></td></tr><tr ng-if=!Review.formData.folioCreationRequestCO.nomination><td><span><strong></strong></span> &nbsp; <strong easyassist-key=mask-element>Nomination: No</strong></td></tr></table></div></div></div></div></section><section class=bank-details-self><div class=\"box-head clearfix\"><p class=pull-left><strong>{{Review.formData.folioCreationRequestCO.soleApplicantDetail.minor ?\"Bank Details Guardian/Minor\":\"Bank Details Self\"}} </strong></p><i class=\"pull-right edit-icon\" ng-click=Review.editBankDetailsForm()></i></div><div class=box-body><div class=\"box-details clearfix\"><div class=col-md-4><table class=table><tr><td><span><strong>Bank Name:</strong></span> &nbsp; <strong>{{Review.formData.folioCreationRequestCO.bankDetails.bankName}}</strong></td></tr><tr><td><span><strong>Account Type:</strong></span> &nbsp; <strong>{{Review.reviewModalData.accountType ? Review.reviewModalData.accountType : Review.formData.folioCreationRequestCO.bankDetails.accountType.accountType}}</strong></td></tr><tr><td><span><strong>Payout Mechanism:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.bankDetails.payoutMechanism.payoutDescription}}</strong></td></tr><tr><td><span><strong>Account Number:</strong></span> &nbsp;<strong easyassist-key=mask-element>{{Review.formData.folioCreationRequestCO.bankDetails.accountNumber}}</strong></td></tr><tr><td><span><strong>IFSC No:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.bankDetails.ifsccode}}</strong></td></tr><tr><td><span><strong>Branch Location:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.bankDetails.branchLocation}}</strong></td></tr><tr><td><span><strong>Branch City:</strong></span> &nbsp;<strong>{{Review.formData.folioCreationRequestCO.bankDetails.bankCity}}</strong></td></tr></table></div><div class=\"col-md-4 attachment\"><p><span><strong>Cheque Leaf Image:</strong></span></p><div class=form-group><span class=upload-button><label><i class=ic-img-icon></i></label></span><span class=\"file-name text-blue\">{{Review.chequeLeafFilename}}</span></div></div><div class=col-md-12 ng-if=Review.formData.folioCreationRequestCO.soleApplicantDetail.minor><table class=table><tbody><tr><td><strong>Note:</strong> &nbsp; <strong class=ng-binding>Nominee details are not applicable for folios where tax status is minor.</strong></td></tr></tbody></table></div></div></div></section></form><div class=\"email-block clearfix\"><div class=\"email-block-button send-approval pull-right\"><span ng-click=Review.sendForApproval() class=\"btn btn-primary-action\">Send for Approval</span></div></div></div>");
$templateCache.put("app/investors/add/scheme/add.investor.scheme.html","<div class=add-scheme ng-init=Scheme.init()><div class=form-box><form autocomplete=off name=sipForm ng-submit=Scheme.submitScheme(); novalidate><div class=form-row><div class=col-md-4><label class=euin><strong>EUIN No.</strong></label><div class=\"input-select input-normal selectfield req-customised\" ng-class=\"{error:sipForm.euin.$dirty && sipForm.euin.$invalid}\"><select class=\"browser-default custom-select\" name=euin ng-model=Scheme.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in Scheme.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=req>*</span> <span ng-show=\"sipForm.euin.$dirty && sipForm.euin.$invalid\"><span class=error-input ng-show=sipForm.euin.$error.required ng-bind=Scheme.validateData.EUIN_REQUIRED></span></span></div></div></div><div class=form-row><label>Add a Scheme for - {{Scheme.formData.folioCreationRequestCO.soleApplicantDetail.name}}</label><div class=col-md-12><div class=form-group><label>Select Investment Type</label><div><span class=radio-block><span class=radio><input type=radio id=purchase name=investmentType ng-model=Scheme.investmentType ng-click=Scheme.changeInvestmentType() ng-value=Scheme.TRANSACTION_FORM_TYPE.PURCHASE> <span class=check></span></span><label for=purchase>Lumpsum</label></span><span class=radio-block><span class=radio><input type=radio id=sip name=investmentType ng-model=Scheme.investmentType ng-click=Scheme.changeInvestmentType() ng-value=Scheme.TRANSACTION_FORM_TYPE.SIP> <span class=check></span></span><label for=sip>Systematic Plan</label></span></div></div></div></div><div class=lumpsump-section ng-if=\"Scheme.investmentType === Scheme.TRANSACTION_FORM_TYPE.PURCHASE\"><div class=form-row><div class=\"row row-styling\"><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=purchaseScheme id=purchaseScheme ng-change=Scheme.filterPurchaseSchemeList() ng-model=Scheme.purchaseScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme<span class=req>*</span></label><drop-down list-data=Scheme.purchaseSchemeList display-key=scheme hdfc-click=Scheme.selectPurchaseScheme(data) model=Scheme.formData.lumpsum.schemeCode for=purchaseScheme></drop-down></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class=\"{error:(sipForm.lumpsumAmount.$dirty && sipForm.lumpsumAmount.$invalid)||!!((Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount))}\"><input type=number ignore-mouse-wheel name=lumpsumAmount ng-change=\"Scheme.changePurchaseAmount();sipForm.$invalid=(Scheme.isMinPurchaseAmount||sipForm.lumpsumAmount.$invalid)\" ng-class=\"{error:(Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount)}\" onkeyup=\"NumToWord(this.value,\'divDisplayWords67\')\" ng-model=Scheme.formData.lumpsum.amount required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount<span class=req>*</span></label><span ng-if=\"Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount\" class=error-input>{{\'Minimum amount should be \'+ Scheme.purchaseValidations.minFirstPurchaseAmt}}</span></div></div><div ng-if=Scheme.formData.lumpsum.amount><span>(In Words)&nbsp;</span><div id=divDisplayWords67></div></div></div></div><div class=\"row row-styling\"><div class=\"col-md-1 col-xs-2\"><span class=scheme-or>or</span></div><div class=col-md-4><a ng-click=Scheme.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=\"row row-styling\"><div class=install-freq ng-if=\"Scheme.purchaseValidations && !Scheme.purchaseValidations.isGrowth\"><label><strong>Choose IDCW option</strong></label><div><span class=radio-block><span class=radio><input ng-disabled=\"Scheme.purchaseValidations.endingType === Scheme.ENDING_TYPES.CLOSED\" type=radio id=reinvestP111 ng-model=Scheme.formData.lumpsum.dividendOption ng-value=Scheme.DIVIDEND_OPTIONS.REINVEST name=dividendOption> <span class=check></span></span><label for=reinvestP111>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=payoutP111 ng-value=Scheme.DIVIDEND_OPTIONS.PAYOUT ng-model=Scheme.formData.lumpsum.dividendOption name=dividendOption> <span class=check></span></span><label for=payoutP111>Payout</label></span></div></div></div><div class=\"row row-styling\"><div class=form-group><div ng-if=!Scheme.isSipOptional class=\"text-blue add-systematic-scheme\"><span ng-click=Scheme.setOptionalScheme(Scheme.TRANSACTION_FORM_TYPE.SIP)><span>+ &nbsp;&nbsp;&nbsp; Add Systematic Scheme</span> <span>(Optional)</span></span></div><div ng-if=Scheme.isSipOptional class=\"text-blue add-systematic-scheme\"><span ng-click=Scheme.removeOptionalScheme(Scheme.TRANSACTION_FORM_TYPE.SIP)><span>+ &nbsp;&nbsp;&nbsp; Remove Systematic Scheme</span> <span>(Optional)</span></span></div></div></div></div><div class=form-row ng-if=Scheme.isSipOptional><label class=mgb0><strong>Add SIP Scheme</strong></label><div class=\"row row-styling\"><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipSchemeOp id=sipSchemeOp1 ng-change=Scheme.filterSipSchemeList() ng-model=Scheme.sipScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme<span class=req>*</span></label><drop-down list-data=Scheme.sipSchemeList display-key=scheme hdfc-click=Scheme.selectSipScheme(data) model=Scheme.formData.sip.schemeCode for=sipSchemeOp1></drop-down></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class=\"{error:(sipForm.sipAmount.$dirty && sipForm.sipAmount.$invalid)||!!(Scheme.sipValidations.monMinAmt > Scheme.formData.sip.installmentAmount)}\"><input type=number ignore-mouse-wheel name=sipAmount ng-model=Scheme.formData.sip.installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords164\')\" required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount<span class=req>*</span></label><span ng-if=\"sipForm.sipAmount.$valid && Scheme.sipValidations.monMinAmt > Scheme.formData.sip.installmentAmount\" class=error-input>{{\'Minimum amount should be \'+ Scheme.sipValidations.monMinAmt}}</span></div></div><div ng-if=Scheme.formData.sip.installmentAmount><span>(In Words)&nbsp;</span><div id=divDisplayWords164></div></div></div></div><div class=\"row row-styling\"><div class=\"col-md-1 col-xs-2\"><span class=scheme-or>or</span></div><div class=col-md-4><a ng-click=Scheme.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=\"row row-styling mgt20\"><div class=\"form-grid col-md-4\"><label><strong>Installment Date</strong></label><div class=form-group><div class=selectfield><label>Select Day</label><select class=\"browser-default custom-select\" name=day ng-model=Scheme.sipDay ng-options=\"day.name for day in Scheme.daysList\" ng-value=day ng-change=Scheme.changeDay() required><option value=\"\" selected>Select Day</option></select><span class=req>*</span></div></div></div><div class=\"form-grid col-md-4\"><label>&nbsp;</label><div class=form-group><div class=input-normal><div class=\"input-normal mgt27 verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Scheme.viewMode}} data-enabled-dates=Scheme.enabledStartDates data-date-default=Scheme.startDate data-min-date=Scheme.startDate data-on-date-change=Scheme.changeStartDate id=startDateOp><input type=text class=\"form-control schemeDurationDate\" placeholder=\"SIP Start Date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><span class=checkbox style=\"bottom: -3px\"><input type=checkbox ng-model=Scheme.isTillPerpetuity ng-change=Scheme.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span>Default</span></div><div class=form-group ng-if=!Scheme.isResetting><div class=\"input-normal mgt27 verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Scheme.viewMode}} data-enabled-dates=Scheme.enabledEndDates data-date-default=Scheme.endDate data-min-date=Scheme.endDate data-on-date-change=Scheme.changeEndDate id=endDateOp><input type=text ng-disabled=Scheme.isTillPerpetuity class=\"form-control schemeDurationDate\" placeholder=\"SIP End Date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div><div class=\"row row-styling mgt20\"><div class=\"col-md-12 form-grid\"><div class=form-group ng-if=\"Scheme.sipValidations && !Scheme.sipValidations.isGrowth\"><label><strong>Choose IDCW Option<span class=req>*</span></strong></label><div><span class=radio-block><span class=radio><input type=radio id=reinvestPurchaseSIP ng-model=Scheme.formData.sip.dividendOption ng-value=Scheme.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"Scheme.sipValidations.endingType===Scheme.ENDING_TYPES.CLOSED\" name=dividendOptionPurchaseSIP> <span class=check></span></span><label for=reinvestPurchaseSIP>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=payoutPurchaseSIP ng-model=Scheme.formData.sip.dividendOption ng-value=Scheme.DIVIDEND_OPTIONS.PAYOUT name=dividendOptionPurchaseSIP> <span class=check></span></span><label for=payoutPurchaseSIP>Payout</label></span></div></div></div></div><div class=\"row row-styling\"><div class=\"form-grid col-md-12\"><div class=form-group><label class=mgt30><strong>Installment Frequency<span class=req>*</span></strong></label><div><span class=radio-block ng-repeat=\"freq in Scheme.SIP_FREQ_LIST\"><span class=radio><input type=radio id=\"{{freq.value+\'1\'}}\" ng-model=Scheme.selectedFrequency ng-change=Scheme.changeFrequency() ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.value}}>{{freq.value}}</label></span></div></div></div></div></div><div class=\"form-footer form-content form-buttons\"><span class=pull-right><button class=\"btn btn-negative-action\" ng-click=Scheme.cancelTransaction()>Cancel</button> <a class=\"btn btn-secondary-action\" ng-click=Scheme.goBack()>Back</a> <input type=submit class=\"btn btn-primary-action\" ng-disabled=\"sipForm.$invalid||Scheme.euinObj==null\" value=\"Initiate Transaction\"></span></div></div><div class=sip-section ng-if=\"Scheme.investmentType===Scheme.TRANSACTION_FORM_TYPE.SIP\"><div class=form-row><div class=\"row row-styling\"><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme id=sipScheme222 ng-change=Scheme.filterSipSchemeList() ng-model=Scheme.sipScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme<span class=req>*</span></label><drop-down list-data=Scheme.sipSchemeList display-key=scheme hdfc-click=Scheme.selectSipScheme(data) model=Scheme.formData.sip.schemeCode for=sipScheme222></drop-down></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class=\"{error:(sipForm.installmentAmount.$dirty && sipForm.installmentAmount.$invalid)||!!(Scheme.sipValidations.monMinAmt>Scheme.formData.sip.installmentAmount)}\"><input type=number ignore-mouse-wheel name=installmentAmount ng-change=Scheme.changeSipAmount() onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" onkeyup=\"NumToWord(this.value,\'divDisplayWords350\')\" ng-class=\"{error:(Scheme.isMinSipAmount && Scheme.formData.sip.installmentAmount)}\" ng-model=Scheme.formData.sip.installmentAmount required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount<span class=req>*</span></label><span ng-if=\"sipForm.installmentAmount.$valid && Scheme.sipValidations.minAmount>Scheme.formData.sip.installmentAmount\" class=error-input>{{\'Minimum amount should be \'+ Scheme.sipValidations.minAmount}}</span></div></div><div ng-if=Scheme.formData.sip.installmentAmount><span>(In Words)&nbsp;</span><div id=divDisplayWords350></div></div></div></div><div class=\"row row-styling\"><div class=\"col-md-1 col-xs-2\"><span class=scheme-or>or</span></div><div class=col-md-4><a ng-click=Scheme.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=\"row row-styling mgt20\"><div class=\"form-grid col-md-4\"><label><strong>Installment Date</strong></label><div class=form-group><div class=selectfield><label>Select Day</label><select class=\"browser-default custom-select\" name=day ng-model=Scheme.sipDay ng-options=\"day.name for day in Scheme.daysList\" ng-value=day ng-change=Scheme.changeDay() required><option value=\"\" selected>Select Day</option></select><span class=req>*</span></div></div></div><div class=\"form-grid col-md-4\"><label>&nbsp;</label><div class=form-group><div class=input-normal><div class=\"input-normal mgt27 verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Scheme.viewMode}} data-enabled-dates=Scheme.enabledStartDates data-date-default=Scheme.startDate data-min-date=Scheme.startDate data-on-date-change=Scheme.changeStartDate id=startDate22><input type=text class=\"form-control schemeDurationDate\" placeholder=\"SIP Start date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div><div class=col-md-4><div class=form-group><span class=checkbox style=\"bottom: -3px\"><input type=checkbox ng-model=Scheme.isTillPerpetuity ng-change=Scheme.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span>Default</span></div><div class=form-group ng-if=!Scheme.isResetting><div class=\"input-normal mgt27 verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{Scheme.viewMode}} data-enabled-dates=Scheme.enabledEndDates data-date-default=Scheme.endDate data-min-date=Scheme.endDate data-on-date-change=Scheme.changeEndDate id=endDate22><input type=text ng-disabled=!Scheme.isTillPerpetuity class=\"form-control schemeDurationDate\" placeholder=\"SIP End date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div><div class=\"row row-styling mgt20\"><div class=\"form-grid col-md-12\"><div class=form-group><div class=install-freq ng-if=\"Scheme.sipValidations && !Scheme.sipValidations.isGrowth\"><label><strong>Choose IDCW option</strong></label><div><span class=radio-block><span class=radio><input type=radio id=reinvestP11 ng-model=Scheme.formData.lumpsum.dividendOption ng-disabled=\"Scheme.sipValidations.endingType===Scheme.ENDING_TYPES.CLOSED\" ng-value=Scheme.DIVIDEND_OPTIONS.REINVEST name=dividendOption> <span class=check></span></span><label for=reinvestP11>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=payoutP11 ng-value=Scheme.DIVIDEND_OPTIONS.PAYOUT ng-model=Scheme.formData.lumpsum.dividendOption name=dividendOption> <span class=check></span></span><label for=payoutP11>Payout</label></span></div></div></div></div></div><div class=\"row row-styling\"><div class=\"form-grid col-md-12\"><div class=form-group><div class=install-freq><p><strong>Installment Frequency<span class=req>*</span></strong></p><span class=radio-block ng-repeat=\"freq in Scheme.SIP_FREQ_LIST\"><span class=radio><input type=radio id={{freq.value}} ng-change=Scheme.changeFrequency() ng-model=Scheme.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.value}}>{{freq.value}}</label></span></div></div></div></div><div class=\"row row-styling\"><div class=form-group><div ng-if=!Scheme.isPurchaseOptional class=\"text-blue add-systematic-scheme\"><span ng-click=Scheme.setOptionalScheme(Scheme.TRANSACTION_FORM_TYPE.PURCHASE)><span>+ &nbsp;&nbsp;&nbsp; Add Lumpsum Scheme</span> <span>(Optional)</span></span></div><div ng-if=Scheme.isPurchaseOptional class=\"text-blue add-systematic-scheme\"><span ng-click=Scheme.removeOptionalScheme(Scheme.TRANSACTION_FORM_TYPE.PURCHASE)><span>+ &nbsp;&nbsp;&nbsp; Remove Lumpsum Scheme</span> <span>(Optional)</span></span></div></div></div></div><div class=form-row ng-if=Scheme.isPurchaseOptional><label class=mgb0><strong>Add Lumpsum Scheme</strong></label><div class=\"row row-styling\"><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=purchaseScheme id=purchaseScheme11 ng-change=Scheme.filterPurchaseSchemeList() ng-model=Scheme.purchaseScheme required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=Scheme.purchaseSchemeList display-key=scheme hdfc-click=Scheme.selectPurchaseScheme(data) model=Scheme.formData.lumpsum.schemeCode for=purchaseScheme11></drop-down><span class=req>*</span></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class=\"{error:(sipForm.lumpsumAmount.$dirty && sipForm.lumpsumAmount.$invalid)||!!((Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount))}\"><input type=number ignore-mouse-wheel name=lumpsumAmount ng-change=\"Scheme.changePurchaseAmount();sipForm.$invalid=(Scheme.isMinPurchaseAmount||sipForm.lumpsumAmount.$invalid)\" ng-class=\"{error:(Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount)}\" onkeyup=\"NumToWord(this.value,\'divDisplayWords532\')\" ng-model=Scheme.formData.lumpsum.amount required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount<span class=req>*</span></label><span ng-if=\"Scheme.isMinPurchaseAmount && Scheme.formData.lumpsum.amount\" class=error-input>{{\'Minimum amount should be \'+ Scheme.purchaseValidations.minFirstPurchaseAmt}}</span></div></div><div ng-if=Scheme.formData.lumpsum.amount><span>(In Words)&nbsp;</span><div id=divDisplayWords532></div></div></div></div><div class=\"row row-styling\"><div class=\"form-grid col-md-1 col-xs-2\"><span class=scheme-or>or</span></div><div class=col-md-4><a ng-click=Scheme.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=\"row row-styling mgt20\"><div class=\"form-grid col-md-12\"><div class=form-group><div class=install-freq ng-if=\"Scheme.purchaseValidations && !Scheme.purchaseValidations.isGrowth\"><label><strong>Choose IDCW option</strong></label><div><span class=radio-block><span class=radio><input type=radio id=reinvestP1112 ng-model=Scheme.formData.lumpsum.dividendOption ng-disabled=\"Scheme.purchaseValidations.endingType===Scheme.ENDING_TYPES.CLOSED\" ng-value=Scheme.DIVIDEND_OPTIONS.REINVEST name=dividendOption> <span class=check></span></span><label for=reinvestP1112>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=payoutP112 ng-value=Scheme.DIVIDEND_OPTIONS.PAYOUT ng-model=Scheme.formData.lumpsum.dividendOption name=dividendOption> <span class=check></span></span><label for=payoutP112>Payout</label></span></div></div></div></div></div></div><div class=\"form-footer form-content form-buttons\"><span class=pull-right><button class=\"btn btn-negative-action\" ng-click=Scheme.cancelTransaction()>Cancel</button> <a class=\"btn btn-secondary-action\" ng-click=Scheme.goBack()>Back</a> <input type=submit class=\"btn btn-primary-action\" ng-disabled=\"sipForm.$invalid||Scheme.euinObj==null\" value=\"Initiate Transaction\"></span></div></div></form></div></div>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/addBank.html","<form class=\"main-section clearfix modifyBank modify-bank-summary\" name=AddBankForm><h3 class=page-title><small>Add Bank</small><br><span ng-bind=CobmApprovalSummary.summaryDetails.accountHolderName>Investor Name</span></h3><div class=content-area><div class=col-md-12><div class=row><p class=\"col-md-4 form-title\"><strong>Provide New Bank Details</strong></p></div></div><div class=col-md-12><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid}\"><input type=text ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=CobmApprovalSummary.IFSC_REGEX capitalize ng-change=CobmApprovalSummary.clearBankField() ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode} required ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-readonly=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search search-icon-add\" ng-click=CobmApprovalSummary.selectIFSC()></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid\"><span class=error-input ng-show=AddBankForm.ifsccode.$error.required ng-bind=CobmApprovalSummary.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=AddBankForm.ifsccode.$error.pattern ng-bind=CobmApprovalSummary.validateData.IFSC_CODE_REGEX></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid}\"><input type=text ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName name=bankName required ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName} ng-readonly=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName> <span ng-show=\"AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid\"><span class=error-input ng-show=AddBankForm.bankName.$error.required ng-bind=CobmApprovalSummary.validateData.BANK_NAME_REQUIRED></span></span><label>Bank Name<span class=req>*</span></label></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield ng-class=\"{error:AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid}\" style=margin-top:0px><select class=\"select-box custom-select selectCustomMob\" name=accountType ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType ng-options=\"_type as _type.accountType for _type in CobmApprovalSummary.bankTypeList\" ng-change=CobmApprovalSummary.setAccountType() required ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType?CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType:null\" style=margin-top:1px><option value=\"\" selected>Account Type</option></select><span ng-show=\"AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid\"><span class=error-input ng-show=AddBankForm.accountType.$error.required ng-bind=CobmApprovalSummary.validateData.ACCOUNT_TYPE_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid}\"><input type=text ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.branchLocation name=branchLocation required autocomplete=off capitalize maxlength=40 ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.branchLocation}> <span class=highlight disabled></span> <span class=bar></span><label>Branch Location<span class=req>*</span></label><span ng-show=\"AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid\"><span class=error-input ng-show=AddBankForm.branchLocation.$error.required ng-bind=CobmApprovalSummary.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.bankBranch.$dirty && AddBankForm.bankBranch.$invalid}\"><input type=text ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankBranch name=bankBranch required autocomplete=off capitalize only-alphabets ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankBranch}> <span class=highlight></span> <span class=bar></span><label>Branch City<span class=req>*</span></label><span ng-show=\"AddBankForm.bankBranch.$dirty && AddBankForm.bankBranch.$invalid\"><span class=error-input ng-show=AddBankForm.bankBranch.$error.required ng-bind=CobmApprovalSummary.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield style=\"margin-top: 0px\" ng-class=\"{error:AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid}\"><select class=\"select-box custom-select selectCustomMob\" name=payoutMechanism style=\"margin-top: 2px\" ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism ng-options=\"_type as _type.payoutDescription for _type in CobmApprovalSummary.payoutMechanismList\" ng-change=CobmApprovalSummary.setPayoutMechanism() required ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism?CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism:null\"><option value=\"\" selected>Payout Mechanism</option></select><span ng-show=\"AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid\"><span class=error-input ng-show=AddBankForm.payoutMechanism.$error.required ng-bind=CobmApprovalSummary.validateData.PAYOUT_MECH_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:(CobmApprovalSummary.accModelDirty &&\n                 (!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length || CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1))}\"><input type=text easyassist-key=mask-element ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber maxlength=20 name=accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off directive.mask.limited ng-change=CobmApprovalSummary.accFocus(); ng-keydown=CobmApprovalSummary.copyPasteHandler($event) capitalize ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=CobmApprovalSummary.accModelDirty><span class=error-input ng-show=AddBankForm.accountNumber.$error.required ng-bind=CobmApprovalSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length !=0 && CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=CobmApprovalSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber maxlength=20 limit-to=20 ng-maxlength=20 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber required autocomplete=off ng-keydown=CobmApprovalSummary.copyPasteHandler($event) capitalize ng-disabled=!CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\" ng-bind=CobmApprovalSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.pattern && !AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\" ng-bind=CobmApprovalSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><button ng-if=CobmApprovalSummary.isPennydropRequired class=\"btn btn-primary-action common-btn-padding\" ng-click=CobmApprovalSummary.validatePennyDrop() ng-disabled=\"AddBankForm.$invalid || CobmApprovalSummary.disabledAfterSuccess\">Validate</button></div></div><div class=row style=\"padding-bottom: 12px\"><div class=col-md-12><ng-bind-html dynamic=CobmApprovalSummary.noteBankRestrict></ng-bind-html></div></div><div class=\"row form-grid upload-some\" ng-if=\"(CobmApprovalSummary.isEnabledOldChequeLeaf && CobmApprovalSummary.pennyDropSuccess) || CobmApprovalSummary.isEnabledNewChequeLeaf\"><p><strong>Upload Default Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of default bank to validate bank details.\"></i> </strong></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileTypeold === \'tif\' || CobmApprovalSummary.fileTypeold === \'tiff\') && CobmApprovalSummary.oldChequeLeaf\"><a href=javascript:void(0) ng-click=\"CobmApprovalSummary.downloadFile(CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl,CobmApprovalSummary.fileTypeold,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileTypeold == \'jpg\' ||  CobmApprovalSummary.fileTypeold == \'jpeg\') && CobmApprovalSummary.oldChequeLeaf\" ng-click=\"CobmApprovalSummary.openUploadedDoc(CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl,\'old\')\">{{CobmApprovalSummary.oldChequeLeaf}}</span> <span class=upload-button><input id=uploadFileIdOld type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=CobmApprovalSummary.myFile targetimg=showingImgId upload=\"CobmApprovalSummary.uploadFile(file,\'old\')\"><label for=uploadFileIdOld class=\"btn-upload btn-secondary-action choose-label\">{{CobmApprovalSummary.fileTypeold && CobmApprovalSummary.oldChequeLeaf ?\'CHANGE\':\'CHOOSE FILE\'}}</label></span></div></div></div><div class=\"row form-grid upload-some\" ng-if=CobmApprovalSummary.isEnabledNewChequeLeaf><p><strong>Upload New Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of new bank to validate bank details.\"></i> </strong></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileType === \'tif\' || CobmApprovalSummary.fileType === \'tiff\') && CobmApprovalSummary.isNewCheckLeaf\"><a href=javascript:void(0) ng-click=\"CobmApprovalSummary.downloadFile(CobmApprovalSummary.formData.folioCreationRequestCO.chequeLeafUrl,CobmApprovalSummary.fileType,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileType == \'jpg\' ||  CobmApprovalSummary.fileType == \'jpeg\') && CobmApprovalSummary.isNewCheckLeaf\" ng-click=\"CobmApprovalSummary.openUploadedDoc(CobmApprovalSummary.formData.folioCreationRequestCO.chequeLeafUrl,\'new\')\">{{CobmApprovalSummary.chequeLeaf}}</span> <span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=CobmApprovalSummary.myFile targetimg=showingImgId upload=\"CobmApprovalSummary.uploadFile(file,\'new\')\"><label for=uploadFileId class=\"btn-upload btn-secondary-action choose-label\">{{CobmApprovalSummary.fileType && CobmApprovalSummary.isNewCheckLeaf ?\'CHANGE\':\'CHOOSE FILE\'}}</label></span></div></div></div><div class=tc-block><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=CobmApprovalSummary.isCheckedCobmTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I hereby agree to have read, understood and accept the <a ng-click=CobmApprovalSummary.showCobmTermConditions() href=javaScript:void(0)>Terms & Conditions</a> for investments in HDFC Mutual Fund.</span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=pull-right><input type=button value=Reject ng-click=CobmApprovalSummary.confirmCancelModaltoRejectDeleteBank() ng-disabled=CobmApprovalSummary.disabledAfterSuccess class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Submit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !CobmApprovalSummary.isCheckedCobmTandC || CobmApprovalSummary.disabledAfterSuccess || CobmApprovalSummary.isEnabledOldChequeLeaf && !CobmApprovalSummary.isEnabledNewChequeLeaf && !(CobmApprovalSummary.pennyDropSuccess && CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl) || !CobmApprovalSummary.isPennydropRequired && !(CobmApprovalSummary.isEnabledNewChequeLeaf && CobmApprovalSummary.isEnabledOldChequeLeaf && CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl && CobmApprovalSummary.formData.folioCreationRequestCO.chequeLeafUrl)\" ng-click=CobmApprovalSummary.approveCobm()></span></div></div></form>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/approved.html","<div class=\"box-body approved-folio\" ng-init=Approved.init();><p><i class=success-tick-icon></i><span>Submission Successful</span><br>The details submitted will be used for investment made under the selected folio</p></div>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/changeBank.html","<form class=\"main-section clearfix modifyBank modify-bank-summary\" name=AddBankForm><h5 class=screen-title>Change Bank</h5><div class=folio-addbank-cobm><strong>Folio : </strong><span>{{CobmApprovalSummary.summaryDetails.folioNumber}}</span></div><div class=folio-addbank-cobm><ul><li><strong>ARN :</strong> <span ng-bind=\"CobmApprovalSummary.summaryDetails.arnCode.split(\'-\')[1]\"></span></li></ul></div><div class=folio-addbank-cobm><ul><li><strong>Name :</strong> <span ng-bind=CobmApprovalSummary.summaryDetails.accountHolderName></span></li></ul></div><div class=content-area><div class=col-md-12><div class=\"row email-view\"><section style=padding:0px><div class=content-body><div class=email-block style=\"box-shadow: none;margin-top:0px;padding-left:15px;padding-top:0px\"><p class=email-block-header>Bank Details</p><table class=\"table borderless\" style=\"margin-top: 1.143em\"><tbody><tr><td>Bank Name</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName || \'NA\'}}</td></tr><tr><td>Account Type</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType.accountType || \'NA\'}}</td></tr><tr><td>Account Number</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber || \'NA\'\">Saving</td></tr><tr><td>Branch Name</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankBranch || \'NA\'\"></td></tr><tr><td>Branch Location</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankCity || \'NA\'\">Saket, New Delhi</td></tr><tr><td>IFSC</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode || \'NA\'}}</td></tr><tr><td>Payout Mechanism</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism.payoutDescription || \'NA\'}}</td></tr></tbody></table></div></div></section></div></div><div class=\"form-footer col-md-12\"><span class=pull-right><input type=button value=Reject ng-click=CobmApprovalSummary.confirmCancelModaltoRejectDeleteBank() ng-disabled=CobmApprovalSummary.disabledAfterSuccess class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Approve class=\"btn btn-primary-action common-btn-padding\" ng-disabled=CobmApprovalSummary.disabledAfterSuccess ng-click=CobmApprovalSummary.approveCobm()></span></div></div></form>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/deleteBank.html","<form class=\"main-section clearfix modifyBank modify-bank-summary\" name=AddBankForm><h5 class=screen-title>Delete Bank</h5><div class=folio-addbank-cobm><strong>Folio : </strong><span>{{CobmApprovalSummary.summaryDetails.folioNumber}}</span></div><div class=folio-addbank-cobm><ul><li><strong>ARN :</strong> <span ng-bind=\"CobmApprovalSummary.summaryDetails.arnCode.split(\'-\')[1]\"></span></li></ul></div><div class=folio-addbank-cobm><ul><li><strong>Name :</strong> <span ng-bind=CobmApprovalSummary.summaryDetails.accountHolderName></span></li></ul></div><div class=content-area><div class=col-md-12><div class=\"row email-view\"><section style=padding:0px><div class=content-body><div class=email-block style=\"box-shadow: none;margin-top:0px;padding-left:15px;padding-top:0px\"><p class=email-block-header>Bank Details</p><table class=\"table borderless\" style=\"margin-top: 1.143em\"><tbody><tr><td>Bank Name</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankName || \'NA\'}}</td></tr><tr><td>Account Type</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountType.accountType || \'NA\'}}</td></tr><tr><td>Account Number</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.accountNumber || \'NA\'\">Saving</td></tr><tr><td>Branch Name</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankBranch || \'NA\'\"></td></tr><tr><td>Branch Location</td><td>:</td><td ng-bind=\"CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.bankCity || \'NA\'\">Saket, New Delhi</td></tr><tr><td>IFSC</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.ifsccode || \'NA\'}}</td></tr><tr><td>Payout Mechanism</td><td>:</td><td>{{CobmApprovalSummary.formData.folioCreationRequestCO.bankDetails.payoutMechanism.payoutDescription || \'NA\'}}</td></tr></tbody></table></div></div></section></div><div class=\"row form-grid upload-some\"><p><strong>Upload Default Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of default bank to validate bank details.\"></i> </strong></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileTypeold === \'tif\' || CobmApprovalSummary.fileTypeold === \'tiff\') && CobmApprovalSummary.oldChequeLeaf\"><a href=javascript:void(0) ng-click=\"CobmApprovalSummary.downloadFile(CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl,CobmApprovalSummary.fileTypeold,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"(CobmApprovalSummary.fileTypeold == \'jpg\' ||  CobmApprovalSummary.fileTypeold == \'jpeg\') && CobmApprovalSummary.oldChequeLeaf\" ng-click=\"CobmApprovalSummary.openUploadedDoc(CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl,\'old\')\">{{CobmApprovalSummary.oldChequeLeaf}}</span> <span class=upload-button><input id=uploadFileIdOld type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=CobmApprovalSummary.myFile targetimg=showingImgId upload=\"CobmApprovalSummary.uploadFile(file,\'old\')\"><label for=uploadFileIdOld class=\"btn-upload btn-secondary-action choose-label\">{{CobmApprovalSummary.fileTypeold && CobmApprovalSummary.oldChequeLeaf ?\'CHANGE\':\'CHOOSE FILE\'}}</label></span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=pull-right><input type=button value=Reject ng-click=CobmApprovalSummary.confirmCancelModaltoRejectDeleteBank() ng-disabled=CobmApprovalSummary.disabledAfterSuccess class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Approve class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !CobmApprovalSummary.formData.folioCreationRequestCO.oldChequeLeafUrl || CobmApprovalSummary.disabledAfterSuccess\" ng-click=CobmApprovalSummary.approveCobm()></span></div></div></form>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/index.cobm.html","<div class=\"approval main-section\"><!--<h3 class=\"page-title\"><small>COBM Approval</small><br/><span ng-bind=\"FolioApprovalParent.headerDetails.name\">Investor Name</span></h3>--><!--  <h5 class=\"screen-title\">Add New Bank</h5>\n  <p class=\"breadcrumbs\">\n    <span class=\"text-primary cursor-pointer\" ui-sref=\"main.profile.folioDetails\">Folio Details </span><i\n    class=\"breadcrumb-icon\"></i><span> Add Bank</span>\n  </p>\n\n  <div class=\"folio-addbank\">\n    <strong>Folio : </strong>\n    <span>{{AddBank.folioNumberToDisplay}}</span>\n  </div>--><div class=box-main><div class=form-box style=margin-top:0px><!--<div class=\"box-head\">\n        <ul>\n          <li><strong>Distributor Name:</strong> <span ng-bind=\"FolioApprovalParent.headerDetails.distributorName\">Distributor Name</span></li>\n          <li><strong>ARN:</strong> <span ng-bind=\"FolioApprovalParent.headerDetails.distributorArn\"></span></li>\n        </ul>\n      </div>--><ui-view></ui-view></div></div></div>");
$templateCache.put("app/investors/cobmApprovalSummary/newCobmApproval/rejected.html","<div class=\"box-body rejected-folio\" ng-init=Rejected.init();><p><i class=success-tick-icon></i><span>Rejected</span><br>You have rejected the adding bank process.</p></div>");
$templateCache.put("app/investors/list/all/investors-list-all.html","<div class=\"tab-content investors-listing\" ng-init=\"Investors.initInvestorList(\'ALL\')\"><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row\"><div class=col-md-8><i class=search-icon></i> <input type=text placeholder=\"Search Investors, Scheme Name, Folio No\"></div><div class=col-md-4><div class=\"sort-data pull-right\"><!--Put datepicker over here--><select class=pull-right ng-change=Investors.typeChanged() ng-model=Investors.selectedType ng-options=\"_type.value as _type.key for _type in Investors.TYPE\" ng-value=_type.value></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Cost Value<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Market Value<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Action<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN>{{investor.pan}}</td><td data-th=\"Date Of Birth\">{{investor.dob}}</td><td data-th=\"Cost Value\" align=right><i class=rupee-icon></i>{{investor.purchaseValue}}</td><td data-th=\"Market Value\" align=right><i class=rupee-icon></i>{{investor.currentValue}}</td><td data-th=Action><span class=select-wrapper>Initiate Transaction</span></td></tr><tr ng-if=\"!(Investors.investorsListData.length >0) && !Investor.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/investors/list/analysis/analysis-investors-list.html","<div><h3 class=\"page-title inline-block-styling\">Investors</h3><div class=\"download dropdown pull-right\" ng-if=\"Investors.analysisType != \'pending-list\'\"><button class=\"btn btn-download dropdown-toggle btn-primary-action\" ng-click=\"Investors.downloadReportList(\'Invester-list\');\"><i class=white-up-icon></i>Download reports</button><ul class=dropdown-menu><li ng-repeat=\"(key, value) in Investors.ioReportUrls\" ng-click=Investors.downloadReport(key,value)>{{value}}</li></ul></div><ul class=\"nav nav-tabs transactions\"><li ng-repeat=\"tab in Investors.tabs\" ng-class=\"{\'active\': tab.key == Investors.defaultTab}\"><a style=font-weight:bold href=javascript:void(0); ng-click=Investors.redirectToTab(tab.key)>{{tab.key}}</a></li></ul><div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorAnalysisList()><div id=all class=\"tab-pane fade in active\"><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"Investors.sortOrder.sortKey=\'investorName\';Investors.filterByHeader()\">Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'PAN\';Investors.filterByHeader()\">PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'DOB\';Investors.filterByHeader()\">Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th class=text-center>Action</th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN><span ng-if=\"Investors.defaultTab == \'Pending\'\">{{investor.panNumber}}</span> <span ng-if=\"Investors.defaultTab != \'Pending\'\">{{investor.pan}}</span></td><td data-th=\"Date Of Birth\">{{investor.dob}}</td><td data-th=Action class=text-center ng-if=\"Investors.defaultTab != \'Pending\'\"><span class=\"dropdown select-wrapper without-before text-left investorActionMob\"><div class=dropdown-toggle data-toggle=dropdown>Initiate Transaction<i class=drop-arrow-blue-icon></i></div><ul class=dropdown-menu><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SIP\')\" role=button tabindex=0>SIP or Purchase</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSIP\')\" role=button tabindex=0>Flex SIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Switch\')\" role=button tabindex=0>Switch</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SWP\')\" role=button tabindex=0>SWP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'STP\')\" role=button tabindex=0>STP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Redeem\')\" role=button tabindex=0>Redeem</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'DTP\')\" role=button tabindex=0>TIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXINDEX\')\" role=button tabindex=0>Flex Index</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSTP\')\" role=button tabindex=0>Flex STP</li><!--<li class=\"list-group-item\" ng-click=\"Investors.validateInvestor(investor, \'SWINGSTP\')\"\n                      role=\"button\" tabindex=\"0\">Swing STP</li>  commented at FD-1823--><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SMART_SWAP\')\" role=button tabindex=0>SMART SWAP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'DREAMSIP\')\" role=button tabindex=0>DREAM SIP</li></ul></span></td><td data-th=Action class=text-center ng-if=\"Investors.defaultTab == \'Pending\'\"><span class=\"dropdown select-wrapper without-before text-left investorActionMob centeredtxt\" ng-if=\"investor.status == \'Edit\'\" ng-click=Investors.editNewInvestor(investor)>Edit & Send for approval </span><span class=\"dropdown select-wrapper without-before text-left investorActionMob centeredtxt\" ng-if=\"investor.status == \'Pending\'\" style=\"width: 170px\">Investor Approval Pending </span><span class=\"dropdown select-wrapper without-before text-left investorActionMob centeredtxt\" ng-click=Investors.editNewInvestor(investor) ng-if=\"investor.status == \'Expired\' || investor.status == \'Rejected\' \">Edit & Re-send Request</span></td></tr><tr class=text-center ng-if=\"!(Investors.investorsListData.length >0) && !Investor.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div></div><style>.investors .investors-listing .list .table tr td .centeredtxt{\n    padding-left: 9px;\n  }</style>");
$templateCache.put("app/investors/list/lumpsum/investors-list-lumpsum.html","<div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorList()><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row\"><div class=col-md-8><i class=search-icon></i> <input type=text placeholder=\"Search Investors, Scheme Name, Folio No\"></div><div class=col-md-4><div class=\"sort-data pull-right\"><!--Put datepicker over here--><select class=pull-right><option>Status</option></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Cost Value<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Market Value<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th>Action<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN>{{investor.pan}}</td><td data-th=\"Date Of Birth\">{{investor.dob}}</td><td data-th=\"Cost Value\" align=right><i class=rupee-icon></i>{{investor.purchaseValue}}</td><td data-th=\"Market Value\" align=right><i class=rupee-icon></i>{{investor.currentValue}}</td><td data-th=Action><span class=select-wrapper>Initiate Transaction</span></td></tr><tr ng-if=\"!(Investors.investorsListData.length>0) && !Investors.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/investors/list/sip/investors-list-sip.html","<div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorList()><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row\"><div class=col-md-8><i class=search-icon></i> <input type=text placeholder=\"Search Investors, Scheme Name, Folio No\"></div><div class=col-md-4><div class=\"sort-data pull-right\"><!--Put datepicker over here--><select class=pull-right><option>Status</option></select><select class=pull-right><option>Investor Type</option></select></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Investor Name</th><th>PAN</th><th>Date Of Birth</th><th>Cost Value</th><th>Market Value</th><th>Action</th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN>{{investor.pan}}</td><td data-th=\"Date Of Birth\">{{investor.dob}}</td><td data-th=\"Cost Value\" align=right><i class=rupee-icon></i>{{investor.purchaseValue}}</td><td data-th=\"Market Value\" align=right><i class=rupee-icon></i>{{investor.currentValue}}</td><td data-th=Action><span class=select-wrapper>Initiate Transaction</span></td></tr><tr ng-if=\"!(Investors.investorsListData.length>0) && !Investors.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/investors/profile/basicinfo/basic-info.html","<div class=tab-content ng-init=InvestorProfile.init()><div id=basic-info class=\"tab-pane fade in active\"><div><table class=table-data><tbody><tr><td>Name</td><td>:</td><td>{{InvestorProfile.investorsProfileData.name}}</td></tr><tr><td>PAN</td><td>:</td><!-- DODO:Icon pending --><td easyassist-key=mask-element>{{InvestorProfile.investorsProfileData.PAN}}<i class=verified-icon ng-if=InvestorProfile.investorsProfileData.PANVerified></i></td></tr><tr><td>KYC Status</td><td>:</td><!-- DODO:Icon pending --><td>{{InvestorProfile.investorsProfileData.KYCStatus}} <i class=verified-icon ng-if=InvestorProfile.investorsProfileData.KYCVerified></i></td></tr><tr><td>Date of Birth</td><td>:</td><!-- TODO:Anguler pending --><td><span easyassist-key=mask-element>{{InvestorProfile.investorsProfileData.dateOfBirth}}</span><span class=cake-icon ng-if=InvestorProfile.isBirthday(InvestorProfile.investorsProfileData.dateOfBirth)></span> <button class=\"btn-secondary-action wish-btn\" ng-click=InvestorProfile.wishSomeone(InvestorProfile.investorsProfileData) ng-if=InvestorProfile.isBirthday(InvestorProfile.investorsProfileData.dateOfBirth)>Wish</button></td></tr><!--  <tr>\n          <td>Tax Status</td>\n          <td> :</td>\n          <td>{{InvestorProfile.investorsProfileData.taxStatus}}</td>\n        </tr>--><!--<tr>\n          <td>FATCA</td>\n          <td> :</td>\n          &lt;!&ndash; TODO:Anguler pending &ndash;&gt;\n          <td>Not Available</td>\n        </tr>--></tbody></table><div class=view-details><div class=collapse id=viewAdditionalDetails><div><table class=table-data><tbody><tr><td>Occupational Details</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.investorsProfileData.addtionalDetails.occupationalDetails}}</td></tr><tr><td>Gross Annual Income</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.investorsProfileData.addtionalDetails.grossAnnualIncome}}</td></tr><tr><td easyassist-key=mask-element>Net Worth (in Rs.)</td><td>:</td><td>{{InvestorProfile.investorsProfileData.addtionalDetails.netWorth}}</td></tr><tr><td>Bank Account Number</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.investorsProfileData.addtionalDetails.bankAccount}}</td></tr><tr><td>Pay or file tax other than India?</td><td>:</td><td>{{InvestorProfile.investorsProfileData.addtionalDetails.payTaxOutsideIndia}}</td></tr><tr><td>Whatsapp Transaction Notification</td><td>:</td><td class=td-flex><span class=span-flex ng-class=\"{\'anything-disabled\': InvestorProfile.isDisabled}\"><span class=\"toggle-login-text td-item\">Unsubscribe</span><div class=\"login-form-switch td-item\"><label class=switch-toggle-slider><input type=checkbox ng-model=InvestorProfile.subscribedToggleFlag ng-click=InvestorProfile.toggleWhatsapp() class=\"box checkbox-slide\" title=\"High Contrast\"> <span class=\"slider round\"></span></label></div><span class=\"toggle-login-text td-item\">Subscribe</span> </span><span class=td-item ng-if=InvestorProfile.isDisabled><i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=auto title=\"Investor Mobile number  details needs to updated  for them to  avail  What’s  App Transaction Notification service\"></i></span></td></tr></tbody></table></div></div><i class=expand-icon></i> <a class=add-detail role=button data-toggle=collapse href=#viewAdditionalDetails aria-expanded=false aria-controls=viewAdditionalDetails>View Additional Details</a></div></div><div class=\"clearfix bg-grey folio-header\"><p class=pull-left>RUD</p></div><div class=pd30><table class=table-data><thead><tr><th class=text-black><strong>Scheme Name</strong></th><th class=text-black><strong>Unclaimed Amount/ RUD</strong></th></tr></thead><tbody><tr ng-repeat=\"investments in InvestorProfile.folioDetailsData.investments\"><td>{{investments.schemeName}}</td><td><a href=javascript:void(0) ng-click=InvestorProfile.viewRudDetails(investments,$index)>{{InvestorProfile.rudAmountList[$index].amount?InvestorProfile.rudAmountList[$index].amount:\'View\'}}</a></td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=pull-left>Folio Details</p><!--<i class=\"edit-icon\"></i>--></div><div ng-if=\" InvestorProfile.folioListData\"><div class=folio-numbers ng-if=InvestorProfile.folioListData.length ng-init=InvestorProfile.folioDetails(InvestorProfile.folioListData[0],0)><!--<span class=\"active\">678945</span>--><ol class=list-inline><!-- TODO:Angular first li should have \"btn-secondary-action\" class --><li class=cursor-pointer ng-repeat=\"folio in InvestorProfile.folioListData track by $index\" ng-click=InvestorProfile.folioDetails(folio,$index) ng-class=\"{active:InvestorProfile.folioIndex==$index}\">{{folio.folioNo}}</li></ol></div><table class=table-data><tr><td>Name</td><td>:</td><td>{{InvestorProfile.folioDetailsData.name}}</td></tr></table><update-folio-email curr-email=InvestorProfile.folioDetailsData.email folio-number=InvestorProfile.selectedFolio.folioNo curr-mobile-number=InvestorProfile.folioDetailsData.mobileNumber investor-pan=InvestorProfile.investorsProfileData.PAN c-flag=InvestorProfile.coperateFlag can-edit=InvestorProfile.canEdit contact-updated=InvestorProfile.isContactUpdateAllowed contact-updated-error=InvestorProfile.updateContactRestrictMessage></update-folio-email><update-folio-mobile curr-mobile-number=InvestorProfile.folioDetailsData.mobileNumber folio-number=InvestorProfile.selectedFolio.folioNo curr-email=InvestorProfile.folioDetailsData.email investor-pan=InvestorProfile.investorsProfileData.PAN c-flag=InvestorProfile.coperateFlag can-edit=InvestorProfile.canEdit contact-updated=InvestorProfile.isContactUpdateAllowed contact-updated-error=InvestorProfile.updateContactRestrictMessage></update-folio-mobile><table class=table-data><tbody><!--<tr ng-if=\"InvestorProfile.folioDetailsData.email\">\n          <td>Email ID</td>\n          <td> :</td>\n          <td ng-if=\"!InvestorProfile.isEdit\">{{InvestorProfile.folioDetailsData.email}}\n            <i class=\"edit2-icon\" ng-click=\"InvestorProfile.makeEdit();\"></i>\n          </td>\n        </tr>\n        <tr ng-if=\"InvestorProfile.folioDetailsData.mobileNumber\">\n          <td>Mobile No</td>\n          <td> :</td>\n          <td ng-if=\"!InvestorProfile.isEdit\">{{InvestorProfile.folioDetailsData.mobileNumber}}\n            <i class=\"edit2-icon\" ng-click=\"InvestorProfile.makeEdit();\"></i>\n          </td>\n        </tr>--><tr><td>Address</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.address}}</td></tr><tr><td>Payout Method</td><td>:</td><td class=text-uppercase>{{InvestorProfile.folioDetailsData.payoutMethod}}</td></tr><tr><td>Bank Account</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.bankAccountNumber}}</td></tr><tr><td>Aadhar Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.investorAadharStatus||\'Not Available\'}}</td></tr><tr><td>Tax Status</td><td>:</td><td>{{InvestorProfile.folioDetailsData.folioTaxStatus||\'Not Available\'}}</td></tr></tbody></table><table class=table-data ng-if=\"(InvestorProfile.folioDetailsData.guardianDetails | json) != \'{}\'\"><tr><td><h6>Guardian Details</h6></td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.name><td>Name</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.guardianDetails.name}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.pan><td>PAN</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.guardianDetails.pan}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.relation><td>Relationship</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.guardianDetails.relation}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.dob><td>Date of birth</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.guardianDetails.dob}}</td></tr><tr ng-if=InvestorProfile.folioDetailsData.guardianDetails.kyc><td>KYC Status</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.folioDetailsData.guardianDetails.kyc}}</td></tr><tr><td>Aadhar Status</td><td>:</td><td easyassist-key=mask-element ng-bind=\"InvestorProfile.folioDetailsData.guardianDetails.aadharStatus || \'NA\' \"></td></tr><tr><td>Aadhar Linked</td><td>:</td><td easyassist-key=mask-element ng-bind=\"InvestorProfile.folioDetailsData.guardianDetails.aadharLinked || \'NA\' \"></td></tr></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"text-uppercase pull-left\">Payout Bank Details</p><div class=emandate-action ng-if=InvestorProfile.folioDetailsData.cobmEnabled><span ng-if=\"InvestorProfile.folioDetailsData.bankDetails.length<5\"><a ng-click=InvestorProfile.redirectToAddBank()>Add New Bank</a></span></div></div><div ng-if=InvestorProfile.folioDetailsData.bankDetails><div class=folio-numbers ng-if=InvestorProfile.folioDetailsData.bankDetails.length><ol class=list-inline><li ng-repeat=\"bank in InvestorProfile.folioDetailsData.bankDetails\" ng-class=\"{active :InvestorProfile.currentBankIndx == $index}\" ng-click=InvestorProfile.showBankDetails(bank,$index)><span ng-if=InvestorProfile.folioDetailsData.bankDetails>{{$index+1}}.</span> <span>{{bank.bankName}} <span ng-if=bank.defaultBank class=info-primary>(Default)</span></span></li></ol></div><table class=table-data><tbody><tr><td>Account Type</td><td>:</td><td>{{InvestorProfile.bankDetails.accountType || \'NA\'}}</td></tr><tr><td>Account Number</td><td>:</td><!--<td ng-bind=\"Profile.soleApplicant.folioList[Profile.currentFolioIndx].bankAcc\">0001298768RTGS/NEFT</td>--><td easyassist-key=mask-element ng-bind=\"InvestorProfile.bankDetails.accountNumber || \'NA\'\">Saving</td></tr><tr><td>Branch Name</td><td>:</td><td ng-bind=\"InvestorProfile.bankDetails.branchName || \'NA\'\"></td></tr><tr><td>Branch Location</td><td>:</td><td ng-bind=\"InvestorProfile.bankDetails.branchCity || \'NA\'\">Saket, New Delhi</td></tr><tr><td>IFSC</td><td>:</td><td>{{InvestorProfile.bankDetails.ifscCode}}<!--<span ng-click=\"InvestorProfile.redirectIFSCUpdate()\"\n                                                             class=\"btn btn-secondary-action\">Update</span>--></td></tr><tr><td>Payout Mechanism</td><td>:</td><td>{{InvestorProfile.bankDetails.payoutMethod}}<!--<select ng-if=\"InvestorProfile.changePayoutSwitch\" ng-model=\"InvestorProfile.newPayoutMethod\"\n                    ng-options=\"_type.payoutCode as _type.payoutDescription for _type in InvestorProfile.payoutMechanismList\">\n              <option value=\"\" selected>Payout Mechanism</option>\n              &lt;!&ndash;<option ng-repeat=\"payout in Profile.payoutMechanismList\" value=\"{{payout.payoutCode}}\">{{payout.payoutDescription}}</option>&ndash;&gt;\n            </select>\n            <span ng-if=\"InvestorProfile.changePayoutSwitch\" ng-click=\"InvestorProfile.UpdatePayoutMethod()\"\n                  class=\"btn btn-secondary-action\">Change</span>\n            <span ng-if=\"InvestorProfile.changePayoutSwitch\" ng-click=\"InvestorProfile.payoutSwitch()\" class=\"btn btn-secondary-action\">Cancel</span>\n            <span ng-if=\"!InvestorProfile.changePayoutSwitch\" ng-click=\"InvestorProfile.payoutSwitch()\"\n                  class=\"btn btn-secondary-action\">Change</span>--></td></tr><tr><td>MICR Number</td><td>:</td><td ng-bind=\"InvestorProfile.bankDetails.micrnumber || \'NA\'\"></td></tr><tr ng-if=InvestorProfile.folioDetailsData.cobmEnabled><td>Can be deleted?</td><td>:</td><td ng-show=\"!InvestorProfile.bankDetails.defaultBank && InvestorProfile.folioDetailsData.cobmEnabled && InvestorProfile.folioDetailsData.bankDetails.length>1\"><span>Yes</span> <button ng-click=InvestorProfile.deleteBank() class=\"btn btn-secondary-action\">Click to Delete Bank</button></td><td ng-show=\"(InvestorProfile.bankDetails.defaultBank  && InvestorProfile.folioDetailsData.cobmEnabled) || (InvestorProfile.folioDetailsData.bankDetails.length===1)\"><span>NA</span> <i ng-show=InvestorProfile.bankDetails.defaultBank class=\"info-icon base-tooltip\" tooltip=\"\" data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Default Bank can not be deleted.\" data-original-title=\"Default Bank can not be deleted.\"></i></td></tr><tr ng-if=InvestorProfile.folioDetailsData.cobmEnabled><td>Can be a default bank?</td><td>:</td><td ng-show=\"!InvestorProfile.bankDetails.defaultBank && InvestorProfile.folioDetailsData.bankDetails.length>1\"><span>Yes</span> <button ng-click=InvestorProfile.changeDefaultBank() class=\"btn btn-secondary-action\">Click to Make Default Bank</button></td><td ng-show=\"InvestorProfile.bankDetails.defaultBank || (InvestorProfile.folioDetailsData.bankDetails.length===1)\"><span>NA</span> <i ng-show=InvestorProfile.bankDetails.defaultBank class=\"info-icon base-tooltip\" tooltip=\"\" data-bs-toggle=tooltip data-bs-placement=right data-bs-title=\"Already is a default bank.\" data-original-title=\"Already is a default bank.\"></i></td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"text-uppercase pull-left\">OTM Details</p><div class=emandate-action ng-if=\"InvestorProfile.folioDetailsData && InvestorProfile.folioDetailsData.emandateEnabled\"><span ng-if=\"InvestorProfile.folioDetailsData.otmList.length === 0 && !InvestorProfile.coperateFlag\"><a ng-click=InvestorProfile.redirectToEmandateRegister()>Register E-mandate (eOTM)</a></span> <span ng-if=\"InvestorProfile.folioDetailsData.otmList.length > 0 && !InvestorProfile.coperateFlag\"><a ng-click=InvestorProfile.redirectToEmandateRegister()>Register New E-mandate (eOTM)</a></span> <span ng-if=\"InvestorProfile.folioDetailsData.otmList.length > 0 && !InvestorProfile.coperateFlag\"><a ng-click=InvestorProfile.cancelMandate()>Cancel Mandate</a></span></div></div><div><div class=folio-numbers ng-if=InvestorProfile.folioDetailsData.otmList.length><ol class=list-inline><li ng-repeat=\"bank in InvestorProfile.folioDetailsData.otmList\" ng-class=\"{active :InvestorProfile.currentOtmBankIndx == $index}\" ng-click=InvestorProfile.showOtmBankDetails(bank,$index)><span ng-if=InvestorProfile.folioDetailsData.otmList>{{$index+1}}.</span> <span>{{bank.bankName}}</span></li></ol></div><table class=table-data><tbody><tr><td>Bank Name</td><td>:</td><td>{{InvestorProfile.otmBankDetails.bankName}}</td></tr><tr><td>Account Type</td><td>:</td><td>{{InvestorProfile.otmBankDetails.accountType}}</td></tr><tr><td>Bank Account Number</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.otmBankDetails.accountNumber}}</td></tr><tr><td>Registration Date</td><td>:</td><td>{{InvestorProfile.otmBankDetails.registrationDate ? InvestorProfile.otmBankDetails.registrationDate : \'NA\'}}</td></tr><tr><td>OTM Start Date</td><td>:</td><td class=text-uppercase>{{InvestorProfile.otmBankDetails.startDate}}</td></tr><tr><td>OTM Expiry Date</td><td>:</td><td class=text-uppercase>{{InvestorProfile.otmBankDetails.expiredDate}}</td></tr><tr><td>OTM Amount</td><td>:</td><td>{{InvestorProfile.otmBankDetails.maxAmount}}</td></tr><tr><td>OTM Status</td><td>:</td><td>{{InvestorProfile.otmBankDetails.otmStatus || \'NA\'}}</td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"text-uppercase pull-left\">CAMS OTM Details</p></div><div><div class=folio-numbers ng-if=InvestorProfile.folioDetailsData.camsOTM.length><ol class=list-inline><li ng-repeat=\"bank in InvestorProfile.folioDetailsData.camsOTM\" ng-class=\"{active :InvestorProfile.currentCotmBankIndx == $index}\" ng-click=InvestorProfile.showCotmBankDetails(bank,$index)><span ng-if=InvestorProfile.folioDetailsData.camsOTM>{{$index+1}}.</span> <span>{{bank.bankName}}</span></li></ol></div><table class=table-data><tbody><tr><td>Bank Name</td><td>:</td><td>{{InvestorProfile.cotmBankDetails.bankName}}</td></tr><tr><td>Account Type</td><td>:</td><td>{{InvestorProfile.cotmBankDetails.accountType}}</td></tr><tr><td>Bank Account Number</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.cotmBankDetails.accountNumber}}</td></tr><tr><td>OTM Start Date</td><td>:</td><td class=text-uppercase>{{InvestorProfile.cotmBankDetails.startDate}}</td></tr><tr><td>OTM Expiry Date</td><td>:</td><td class=text-uppercase>{{InvestorProfile.cotmBankDetails.expiredDate}}</td></tr><tr><td>OTM Amount</td><td>:</td><td><i class=rupee-icon ng-if=InvestorProfile.cotmBankDetails.maxAmount></i>{{InvestorProfile.cotmBankDetails.maxAmount}}</td></tr><tr><td>UMR number</td><td>:</td><td>{{InvestorProfile.cotmBankDetails.omUmrn||\'NA\'}}</td></tr></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=\"text-uppercase pull-left\">Joint Holders</p></div><div class=\"pd30 joint-holder\"><ul class=\"pd30 list-inline tab-type2\"><li ng-repeat=\"jointholder in InvestorProfile.folioDetailsData.jointHolders\" ng-click=InvestorProfile.showJointHolderDetails(jointholder,$index) ng-class=\"{active:InvestorProfile.jointholderIndex==$index}\">{{jointholder.firstName}}</li></ul><table class=table-data><tbody><tr><td>PAN</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.jointHolderDetails.panNumber}}<i class=verified-icon ng-if=InvestorProfile.jointHolderDetails.panverified></i></td></tr><tr><td>KYC Status</td><td>:</td><td>{{InvestorProfile.jointHolderDetails.kycstatus}}<i class=verified-icon ng-if=InvestorProfile.jointHolderDetails.kycverified></i></td></tr><tr><td>Date of Birth</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.jointHolderDetails.dateOfBirth}}</td></tr><tr><td>Tax Status</td><td>:</td><td class=text-uppercase>{{InvestorProfile.jointHolderDetails.taxStatus}}</td></tr><tr><td>Aadhar Status</td><td>:</td><td>{{InvestorProfile.jointHolderDetails.aadharStatus||\'Not Available\'}}</td></tr><!--<tr>\n          <td>FATCA</td>\n          <td> :</td>\n          <td>{{InvestorProfile.jointHolderDetails.fatca}}</td>\n        </tr>--></tbody></table></div><div class=\"clearfix bg-grey folio-header\"><p class=pull-left><span class=text-uppercase>Nominees</span> <span style=\"margin-left: 10px\" class=anything-disabled ng-if=InvestorProfile.folioDetailsData.optedOutNominee>(Opted-out of Nomination)</span></p><div class=cancel-action><span ng-if=InvestorProfile.folioDetailsData.addUpdateNominee><a ng-click=InvestorProfile.addNominee()>Add/Update Nominee </a></span><!--        <span ng-if=\"(InvestorProfile.folioDetailsData.modeOfHolding.toLowerCase().split(\' \').join(\'\') == \'anyorsurvivor\'--><!--            || InvestorProfile.folioDetailsData.modeOfHolding.toLowerCase().split(\' \').join(\'\') == \'jointholder\')--><!--            &&--><!--            (InvestorProfile.folioDetailsData.folioTaxStatusCode == \'01\' || InvestorProfile.folioDetailsData.folioTaxStatusCode == \'11\' ||--><!--                InvestorProfile.folioDetailsData.folioTaxStatusCode == \'21\' || InvestorProfile.folioDetailsData.folioTaxStatusCode == \'24\')\"><a ng-click=\"InvestorProfile.offlineNomineeForm()\">Add/Update Nominee</a></span>--> <span ng-if=\"InvestorProfile.folioDetailsData.cancelNomination && InvestorProfile.folioDetailsData.nominees.length!=0\"><a ng-click=InvestorProfile.cancelNominee()>Cancel Nomination</a></span> <span style=\"margin-left: 10px\" ng-if=InvestorProfile.folioDetailsData.optOutNominee><a ng-click=InvestorProfile.redirectToOptOutNomination()>Opt-out of Nomination</a></span></div></div><div class=pd30><ul class=\"pd30 list-inline tab-type2\" ng-if=InvestorProfile.folioDetailsData.nominees><li ng-repeat=\"nominee in InvestorProfile.folioDetailsData.nominees\" ng-click=InvestorProfile.showNomineeDetails(nominee,$index) ng-class=\"{active:InvestorProfile.nomineeIndex==$index}\">{{nominee.firstName}}</li></ul><table class=table-data><tbody ng-if=InvestorProfile.folioDetailsData.nominees><tr><td>Relation with the investor</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.nomineeDetails.relation ? InvestorProfile.nomineeDetails.relation : \"Not Available\"}}</td></tr><tr><td>Nominee Address</td><td>:</td><td easyassist-key=mask-element><span>{{InvestorProfile.nomineeDetails.nomineeAddress1 ? InvestorProfile.nomineeDetails.nomineeAddress1 : \'NA\'}}</span> <span ng-if=InvestorProfile.nomineeDetails.nomineeAddress2>, </span><span>{{InvestorProfile.nomineeDetails.nomineeAddress2}} </span><span ng-if=InvestorProfile.nomineeDetails.nomineeAddress3>, </span><span>{{InvestorProfile.nomineeDetails.nomineeAddress3}} </span><span ng-if=InvestorProfile.nomineeDetails.city>, {{InvestorProfile.nomineeDetails.city}} , </span><span ng-if=InvestorProfile.nomineeDetails.state>{{InvestorProfile.nomineeDetails.state}} , </span><span ng-if=InvestorProfile.nomineeDetails.country>{{InvestorProfile.nomineeDetails.country}} , </span><span ng-if=InvestorProfile.nomineeDetails.postalCode>{{InvestorProfile.nomineeDetails.postalCode}}</span></td></tr><tr><td>Percent Allocation</td><td>:</td><td easyassist-key=mask-element>{{InvestorProfile.nomineeDetails.percentage ? InvestorProfile.nomineeDetails.percentage : \"Not Available\"}} <span ng-if=InvestorProfile.nomineeDetails.percentage>% </span></td></tr><tr ng-if=InvestorProfile.nomineeDetails.isMinor><td>Date of Birth</td><td>:</td><td ng-class=\"{\'text-uppercase\': InvestorProfile.nomineeDetails.dateOfBirth}\" easyassist-key=mask-element>{{InvestorProfile.nomineeDetails.dateOfBirth ? InvestorProfile.nomineeDetails.dateOfBirth : \"Not Available\"}}</td></tr><tr ng-if=InvestorProfile.nomineeDetails.guardian><td>Guardian Details</td><td>:</td><td>{{InvestorProfile.nomineeDetails.guardian}}</td></tr><tr ng-if=\"InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active && InvestorProfile.nomineeDetails.emailId\"><td>Nominee Email Id</td><td>:</td><td easyassist-key=mask-element ng-bind=\"InvestorProfile.nomineeDetails.emailId || \'NA\'\"></td></tr><tr ng-if=\"InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active && InvestorProfile.nomineeDetails.mobileNumber\"><td>Nominee Mobile No.</td><td>:</td><td easyassist-key=mask-element ng-bind=\"InvestorProfile.nomineeDetails.mobileNumber || \'NA\'\"></td></tr><tr ng-if=\"InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active && InvestorProfile.nomineeDetails.identityProofType\"><td>Nominee Personal Identifier</td><td>:</td><td easyassist-key=mask-element ng-bind=\"InvestorProfile.nomineeDetails.identityProofNumber || \'NA\'\"></td></tr><tr ng-if=\"InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active && InvestorProfile.nomineeDetails.identityProofNumber\"><td ng-if=\"InvestorProfile.nomineeDetails.identityProofType === \'AADHAR_CARD\'\">Nominee Aadhar Card</td><td ng-if=\"InvestorProfile.nomineeDetails.identityProofType === \'DRIVING_LICENSE\'\">Nominee Driving License</td><td ng-if=\"InvestorProfile.nomineeDetails.identityProofType === \'PAN_CARD\'\">Nominee Pan</td><td ng-if=\"InvestorProfile.nomineeDetails.identityProofType === \'OTHERS\'\">Nominee Others Identity</td><td>:</td><td ng-if=InvestorProfile.nomineeDetails.identityProofNumber><span easyassist-key=mask-element>{{InvestorProfile.nomineeDetails.identityProofNumber}}</span></td><td ng-if=!InvestorProfile.nomineeDetails.identityProofNumber>Not Available</td></tr><tr ng-if=!InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active><td>PAN of Nominee</td><td>:</td><td>{{InvestorProfile.nomineeDetails.panNumber ? InvestorProfile.nomineeDetails.panNumber : \"Not Available\"}}</td></tr><tr ng-if=\"InvestorProfile.nomineeDetails.isMinor == \'T\'\"><td>Guardian Name</td><td>:</td><td>{{InvestorProfile.nomineeDetails.guardianName ? InvestorProfile.nomineeDetails.guardianName : \"Not Available\"}}</td></tr><tr ng-if=\"InvestorProfile.nomineeDetails.isMinor == \'T\'\"><td>PAN of Guardian</td><td>:</td><td>{{InvestorProfile.nomineeDetails.guardianPanNumber ? InvestorProfile.nomineeDetails.guardianPanNumber : \"Not Available\"}}</td></tr><tr ng-if=\"InvestorProfile.nomineeDetails.isMinor == \'T\'\"><td>Guardian’s Relationship with Nominee</td><td>:</td><td>{{InvestorProfile.nomineeDetails.guardianRelationWithNominee ? InvestorProfile.nomineeDetails.guardianRelationWithNominee : \"Not Available\"}}</td></tr></tbody></table><table class=table-data ng-if=\"InvestorProfile.folioDetailsData.sebiNomineeRegulatory01650Active && InvestorProfile.folioDetailsData.accountHoldingDeclaration\"><tbody><tr><td><strong>Statement of Holding</strong></td></tr><tr><td>{{InvestorProfile.folioDetailsData.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\': \'Nomination: No\'}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/investors/profile/financialgoals/financial-goals.html","<!--<div class=\"tab-content\" ng-init=\"InvestorProfile.init()\">--><!--<div>Financial Goals</div>--> <!--</div>-->");
$templateCache.put("app/investors/profile/optOutNominee/optOutNominee.html","<h5 class=screen-title>Opt-out of Nomination</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=\"main.investors.profile.basicinfo({investorId : OptoutNominee.investorId})\">Folio Details </span><i class=breadcrumb-icon></i><span style=\"color: #103880\"> Opt-out of Nomination</span></p><div class=folio-OptoutNominee style=\"margin-top: 10px\"><strong>Folio : </strong><span>{{OptoutNominee.folioNo}}</span></div><section class=main-section-nomineeoptout><div class=main-container><div class=\"row note-wrapper\"><div class=\"col-md-12 mark-default opt-out-align\"><div class=checkbox style=\"padding-right: 10px\"><input type=checkbox ng-model=OptoutNominee.TnC required> <i class=icon-checkbox></i></div><div class=checkbox-text><!--<div class=\"checkbox-text\"></div>--> <span><!--I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units held\n         in my / our folio listed below and understand the issues involved in non appointment of nominee(s) and\n         further am/are aware that in case of death of all the account holder(s), my / our legal heirs would need\n         to submit all the requisite documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund folio.--><ng-bind-html dynamic=OptoutNominee.dynamicDataForOptOutDec></ng-bind-html></span></div></div></div><hr><div class=\"form-footer form-content clearfix btn-wrapper\"><div class=\"pull-left back\"><a class=btn-back ng-click=OptoutNominee.goToBack()><i class=back-arrow-icon></i> Previous</a></div><div class=\"pull-right flex-style\"><button type=button class=\"btn btn-negative-action\" ng-click=OptoutNominee.goToBack()>Cancel</button> <button type=submit class=\"btn btn-primary-action btn-next\" ng-disabled=!OptoutNominee.TnC disabled ng-click=OptoutNominee.optOutNomination()>Continue</button></div></div></div></section>");
$templateCache.put("app/investors/profile/portfolio/portfolio.html","<div class=\"portfolio tab-content\" ng-init=InvestorProfile.init(true)><div id=portfolio class=tab-pane style=\"display: block\"><div class=top-flow><div class=flow-card><span class=\"value text-uppercase\">Cost Value</span> <span class=lead><i class=blue-rupee-icon></i> <small easyassist-key=mask-element>{{InvestorProfile.constantData.totalPurchaseValue|unitWithOutDecimalFilter:InvestorProfile.purchaseValueCountUnit}} {{InvestorProfile.purchaseValueCountUnit|unitValue}}</small></span></div><div class=flow-card><span class=\"value text-uppercase\">Market Value</span> <span class=lead><i class=blue-rupee-icon></i> <small easyassist-key=mask-element>{{InvestorProfile.constantData.totalCurrentValue|unitWithOutDecimalFilter:InvestorProfile.currentValueCountUnit}} {{InvestorProfile.currentValueCountUnit|unitValue}}</small></span></div></div><div class=\"search-data row\"><div class=col-md-9><i class=search-icon></i> <input type=search placeholder=\"Search Scheme, Folio No\" ng-model=InvestorProfile.searchText ng-change=InvestorProfile.searchList(); select-on-click class=blank-input></div><div class=col-md-3><div class=\"sort-data pull-right\"><span ng-dropdown-multiselect=\"\" options=InvestorProfile.SCHEMETYPES selected-model=InvestorProfile.schemeTypeModel events=InvestorProfile.schemeEvents extra-settings=InvestorProfile.multiSettings translation-texts=InvestorProfile.schemeTranslationTexts></span></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Scheme</th><th>Scheme type</th><th>Folio Number</th><!--<th>XIRR</th>--><th>Cost Value</th><th>Market Value</th><th>XIRR</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-if=InvestorProfile.investorsPortfolioData ng-repeat=\"portfolioDTO in InvestorProfile.investorsPortfolioData\"><td data-th=Scheme ng-bind-html=portfolioDTO.scheme|linebreak:8></td><td data-th=\"Scheme type\">{{portfolioDTO.type}}</td><td data-th=\"Folio Number\">{{portfolioDTO.folioNumber}}</td><!--<td data-th=\"IRR\">{{portfolioDTO.irr | number:2}} %</td>--><td data-th=\"Cost Value\" easyassist-key=mask-element><i class=rupee-icon></i> {{portfolioDTO.purchaseValue|unitWithOutDecimalFilter:portfolioDTO.purchaseValueUnit}}{{portfolioDTO.purchaseValueUnit|unitValue}}</td><td data-th=\"Market Value\" easyassist-key=mask-element><i class=rupee-icon></i> {{portfolioDTO.currentValue|unitWithOutDecimalFilter:portfolioDTO.currentValueUnit}}{{portfolioDTO.currentValueUnit|unitValue}}</td><td data-th=Xirr ng-if=\"portfolioDTO.schemeXirr !=null\">{{portfolioDTO.schemeXirr| number:2}}%</td><td data-th=Xirr ng-if=\"portfolioDTO.schemeXirr == null\">--</td><td data-th=Status><a href=javaScript:void(0)>{{portfolioDTO.status||\'--\'}}</a></td><td data-th=Action><span class=btn-more ng-class=\"{\'disable-button\':!portfolioDTO.validFolio}\"><span class=\"dropdown btn-lft\"><span class=\"dropdown-toggle focus\" ng-class=\"{\'disabled\':!portfolioDTO.validFolio}\" data-toggle=dropdown><a href=javascript:void(0)>Initiate Transaction</a><i class=drop-arrow-blue-icon></i> <span ng-if=\"portfolioDTO.validFolio===false\" style=\"display: initial !important\" class=\"base-tooltip portfolio-tooltip\" data-html=true data-toggle=tooltip tooltip data-placement=top title=\"Transactions cannot be done for this folio\"></span></span><ul class=dropdown-menu tabindex=1><li class=list-group-item ng-repeat=\"action in portfolioDTO.action\" ng-click=\"InvestorProfile.validateInvestor(action, portfolioDTO)\" role=button tabindex={{$index}}><a href=javascript:void(0); ng-bind=\"action == \'DTP\' ? \'TIP\' : action == \'Change Dividend Option\' ? \'Change IDCW Option\' : action\"></a></li></ul></span><!--<span class=\"dropdown btn-rgt\">--><!--<span class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"more-icon\"></i></span>--><!--<ul class=\"dropdown-menu\">--><!--<li ng-class=\"$index==0 && \'with-header\'\" ng-style=\"$index==0 && { \'cursor\':\'default\' }\" ng-style=\"$index==0 && {\'color\':\'yellow\': \'blue\'}\" class=\"list-group-item\" ng-repeat=\"report in InvestorProfile.otherActions\"--><!--ng-click=\"InvestorProfile.sendReport(report, portfolioDTO)\" role=\"button\" tabindex=\"0\">--><!--{{report.value}}--><!--</li>--><!--</ul>--><!--</span>--></span></td></tr><tr ng-if=(!InvestorProfile.investorsPortfolioData)&&!InvestorProfile.isLoading><td colspan=8>No Record found</td></tr></tbody></table><div ng-if=InvestorProfile.isInvestorPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"InvestorProfile.totalInvestorsPortfolioData <= InvestorProfile.PAGE_LIMITS[0]\" ng-bind=InvestorProfile.totalInvestorsPortfolioData></span><select ng-if=\"InvestorProfile.totalInvestorsPortfolioData > InvestorProfile.PAGE_LIMITS[0]\" ng-change=InvestorProfile.init() ng-model=InvestorProfile.pageLimitInvestorsPortfolio ng-options=\"_limit as _limit for _limit in InvestorProfile.PAGE_LIMITS\"></select><span>of</span> <span class=t-black ng-bind=InvestorProfile.totalInvestorsPortfolioData>205</span></div><ul uib-pagination total-items=InvestorProfile.totalInvestorsPortfolioData ng-model=InvestorProfile.currentPageInvestorsPortfolio max-size=5 items-per-page=InvestorProfile.pageLimitInvestorsPortfolio class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=InvestorProfile.init(false) rotate=false></ul></div></div></div></div>");
$templateCache.put("app/investors/profile/statement/statement.html","<div class=statements ng-init=Statements.init()><h3 class=page-title>Statements</h3><div class=content-area><div class=tabheads><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'classic\'}\" ng-click=\"Statements.changeSelectedTab(\'classic\')\">Account Statement</div><div id=_capital class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'capital\'}\" ng-click=\"Statements.changeSelectedTab(\'capital\')\">Capital Gain Statement</div><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'balance\'}\" ng-click=\"Statements.changeSelectedTab(\'balance\')\">Balance Confirmation Report</div><div class=tabhead ng-class=\"{\'active-tab\':Statements.selectedTab==\'exitLoad\'}\" ng-click=\"Statements.changeSelectedTab(\'exitLoad\')\">Exit Load Statement</div></div><div class=tab-body id=classicStatements ng-if=\"Statements.selectedTab==\'classic\'\"><form name=tForm><div class=\"row form-group\"><div class=col-md-6><a target=_blank href={{Statements.HDFC_API.WEBSITE_LINK}}investorcorner/requesting-a-statement>Download Reports in other than English language.</a></div></div><div class=\"row form-group\"><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio class=\"browser-default custom-select\" ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.statementActiveFolio) for folio in Statements.folioList\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\"><div class=col-md-3 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=selectfield ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid}\"><select class=\"browser-default custom-select\" name=scheme ng-if=!Statements.formData.folioNumber><option value=\"\">Select Scheme</option></select><select class=\"browser-default custom-select\" name=scheme ng-if=Statements.formData.folioNumber ng-change=Statements.schemeChanged(Statements.formData.scheme) ng-model=Statements.formData.scheme ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Statements.schemeList\" required></select><label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label><span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid\"><span class=error-input ng-show=tForm.scheme.$error.required ng-bind=Statements.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"row form-group\"><p class=\"form-group col-md-12\"><strong>Statement Options</strong></p><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.FULL ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PREVIOUS ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.CURRENT ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.STATEMENT_OPTIONS.PERIOD ng-click=Statements.statementOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div><div class=\"row form-group\" ng-if=\"Statements.formData.statementOption==\'P\'\"><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeStartDate maxdate=now format=DD-MMM-YYYY id=startDateClassic ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-md-1 text-center mid-text\">To</div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.enabledEndDates data-on-date-change=Statements.changeEndDate min=Statements.formData.minEndDate data-format=DD-MMM-YYYY max=now data-showdefault=false id=endDateClassic1 ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"form-footer col-md-12\"><button type=button class=\"btn btn-secondary-action\" ng-click=Statements.goToProfile()>Cancel</button> <button ng-if=\"Statements.selectedTab==\'classic\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.generateStatement(\'classic\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'classic\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'P\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.downloadStatement(\'classic\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=capitalStatements ng-if=\"Statements.selectedTab==\'capital\'\"><form name=tForm><div class=\"row form-group\"><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio class=\"browser-default custom-select\" ng-change=Statements.folioChanged() ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.statementActiveFolio) for folio in Statements.folioList\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\"><p class=\"form-group col-md-12\"><strong>Statement Options</strong></p><div class=col-md-2 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.FULL ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Full Statement</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.CURRENT ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Current F.Y</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.PREVIOUS ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Previous F.Y</span></div></div><div class=col-md-2><div class=radio-block><span class=radio><input type=radio name=statementOption ng-model=Statements.formData.statementOption ng-value=Statements.CAPITAL_GAIN_STATEMENT_OPTION.PERIOD ng-click=Statements.transferOptionChanged();> <span class=check></span> </span><span class=radio-label>Period</span></div></div></div><div class=\"row form-group\" ng-if=\"Statements.formData.statementOption==\'SD\'\"><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.startDate data-on-date-change=Statements.changeCaptailGainStartDate data-max-date=Statements.startMaxDate format=DD-MMM-YYYY id=startDateCapital ng-class={error:Statements.tForm.startDate.$invalid}><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.startDate.$error.required ng-bind=Statements.VALIDATE_DATA.START_DATE_REQUIRED></span></div></div><div class=\"col-md-1 text-center mid-text\">To</div><div class=col-md-3><div class=\"input-select input-normal input-group date date-picker Statements-cal\" date-calendar data-enable=true data-viewmode={{Statements.viewMode}} data-date-default=Statements.formData.endDate data-enabled-dates=Statements.capitalGainEnabledEndDates data-on-date-change=Statements.changeEndDate min=Statements.formData.minEndDate data-format=DD-MMM-YYYY data-max-date=Statements.endMaxDate data-showdefault=false id=endDateCapital ng-class={error:Statements.tForm.endDate.$invalid}><input type=text name=endDate placeholder=\"End Date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=Statements.tForm.endDate.$error.required ng-bind=Statements.VALIDATE_DATA.END_DATE_REQUIRED></span></div></div></div><div class=\"form-footer col-md-12\"><button type=button class=\"btn btn-secondary-action\" ng-click=Statements.goToProfile()>Cancel</button> <button ng-if=\"Statements.selectedTab==\'capital\'\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'SD\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.generateStatement(\'capital\')\" class=\"btn btn-primary-action\">Email</button> <button ng-if=\"Statements.selectedTab==\'capital\' && Statements.formData.statementOption !== Statements.CAPITAL_GAIN_STATEMENT_OPTION.FULL\" ng-disabled=\"tForm.$invalid||(Statements.formData.statementOption==\'SD\' && (!Statements.formData.startDate || !Statements.formData.endDate))\" ng-click=\"Statements.downloadStatement(\'capital\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=balanceStatements ng-if=\"Statements.selectedTab==\'balance\'\"><form name=tForm><div class=\"row form-group\"><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio class=\"browser-default custom-select\" ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.statementActiveFolio) for folio in Statements.folioList\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\"><div class=col-md-3 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=selectfield ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber}\"><select name=scheme class=\"browser-default custom-select\" ng-change=Statements.schemeChanged(Statements.formData.scheme) ng-model=Statements.formData.scheme ng-options=\"_scheme.schemeName for _scheme in Statements.schemeList track by _scheme.schemeCode\" required><option value=\"\">Select Scheme</option></select><label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label><span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber\"><span class=error-input ng-show=tForm.scheme.$error.required ng-bind=Statements.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"form-footer col-md-12\"><button type=button class=\"btn btn-secondary-action\" ng-click=Statements.goToProfile()>Cancel</button> <button ng-if=\"Statements.selectedTab==\'balance\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.generateStatement(\'balance\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'balance\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.downloadStatement(\'balance\')\" class=\"btn btn-primary-action\">Download</button></div></form></div><div class=tab-body id=exitLoadStatements ng-if=\"Statements.selectedTab==\'exitLoad\'\"><form name=tForm><div class=\"row form-group\"><div class=col-md-3><div class=selectfield ng-class=\"{error:tForm.folio.$dirty && tForm.folio.$invalid}\"><select name=folio class=\"browser-default custom-select\" ng-change=Statements.folioChanged(Statements.formData.folioNumber) ng-model=Statements.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.statementActiveFolio) for folio in Statements.folioList\" required><option value=\"\">Folio Number</option></select><label ng-if=Statements.formData.folioNumber>Folio Number</label><span ng-show=\"tForm.folio.$dirty && tForm.folio.$invalid\"><span class=error-input ng-show=tForm.folio.$error.required ng-bind=Statements.VALIDATE_DATA.FOLIO_REQUIRED></span></span></div></div></div><div class=\"row form-group\"><div class=col-md-3 ng-class=\"{\'anything-disabled\': !Statements.formData.folioNumber}\"><div class=selectfield ng-class=\"{error:tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber}\"><select name=scheme class=\"browser-default custom-select\" ng-change=Statements.schemeChanged(Statements.formData.scheme) ng-model=Statements.formData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Statements.schemeList\" required><option value=\"\">Select Scheme</option></select><label ng-if=\"Statements.formData.folioNumber && Statements.formData.scheme\">Select Scheme</label><span ng-show=\"tForm.scheme.$dirty && tForm.scheme.$invalid && Statements.formData.folioNumber\"><span class=error-input ng-show=tForm.scheme.$error.required ng-bind=Statements.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"form-footer col-md-12\"><button type=button class=\"btn btn-secondary-action\" ng-click=Statements.goToProfile()>Cancel</button> <button ng-if=\"Statements.selectedTab==\'exitLoad\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.generateStatement(\'exitLoad\')\" class=\"btn btn-primary-action\">Send</button> <button ng-if=\"Statements.selectedTab==\'exitLoad\'\" ng-disabled=\"tForm.$invalid \" ng-click=\"Statements.downloadStatement(\'exitLoad\')\" class=\"btn btn-primary-action\">Download</button></div></form></div></div></div>");
$templateCache.put("app/investors/profile/transactions/transactions.html","<div class=tab-content ng-init=InvestorProfile.init()><div id=transactions class=tab-pane style=\"display: block\"><div class=\"search-data row\"><div class=col-md-12><div class=col-md-5><i class=search-icon></i> <input type=search placeholder=\"Search Scheme, Folio No\" ng-model=InvestorProfile.sortOrder.searchText ng-change=InvestorProfile.searchByText(); select-on-click class=\"blank-input search-transaction\"></div><div class=\"sort-data filters-group pull-right\" ng-if=InvestorProfile.isReset><input date-range on-date-change=InvestorProfile.filterByDate placeholder=\"From Date -> To Date\" date-default=InvestorProfile.dateFilter date-max-span=59 class=\"form-control date-picker\" type=text><!--<select ng-change=\"InvestorProfile.modeChanged()\" ng-model=\"InvestorProfile.selectedMode\"\n                  ng-options=\"_mode.value as _mode.key for _mode in InvestorProfile.MODE\" ng-value=\"_mode.value\">\n          </select>\n          <select ng-change=\"InvestorProfile.statusChanged()\" ng-model=\"InvestorProfile.selectedStatus\"\n                  ng-options=\"_status.value as _status.key for _status in InvestorProfile.STATUS\"\n                  ng-value=\"_status.value\">\n          </select>--><!--<span ng-dropdown-multiselect=\"\"--><!--options=\"InvestorProfile.MODE\"--><!--selected-model=\"InvestorProfile.modeModel\"--><!--events=\"InvestorProfile.modeEvents\"--><!--extra-settings=\"InvestorProfile.multiSettings\"--><!--translation-texts=\"InvestorProfile.modeTranslationTexts\"--><!--&gt;</span>--> <span class=btn-more><span class=\"dropdown btn-lft\"><span class=\"dropdown-toggle focus\" data-toggle=dropdown>Status : {{InvestorProfile.selectedStatus[0]}}<i class=drop-arrow-blue-icon></i></span><ul class=dropdown-menu tabindex=1><li class=list-group-item ng-repeat=\"data in InvestorProfile.STATUS\" role=button tabindex={{$index}}><a href=javascript:void(0); ng-click=InvestorProfile.onSelectionStatus(data.key) ng-bind=data.key></a></li></ul></span></span><!--<span ng-dropdown-multiselect=\"\"--><!--options=\"InvestorProfile.STATUS\"--><!--selected-model=\"InvestorProfile.statusModel\"--><!--events=\"InvestorProfile.statusEvents\"--><!--extra-settings=\"InvestorProfile.multiSettings\"--><!--translation-texts=\"InvestorProfile.statusTranslationTexts\"--><!--&gt;</span>--> <span ng-dropdown-multiselect=\"\" options=InvestorProfile.TYPE selected-model=InvestorProfile.transactionModel events=InvestorProfile.transactionEvents extra-settings=InvestorProfile.multiSettings translation-texts=InvestorProfile.transactionTranslationTexts></span></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\" style=\"margin-top: 0px\"><thead><tr><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'transactionType\';InvestorProfile.filterByHeader()\">Transaction Type<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'schemeName\';InvestorProfile.filterByHeader()\">Scheme<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'folioNumber\';InvestorProfile.filterByHeader()\">Folio Number<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'transactionDateTime\';InvestorProfile.filterByHeader()\">Date<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'amount\';InvestorProfile.filterByHeader()\">Amount<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"InvestorProfile.sortOrder.searchText=\'\';InvestorProfile.sortOrder.sortKey=\'status\';InvestorProfile.filterByHeader()\">Status<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th class=text-center>Action</th></tr></thead><tbody><tr ng-if=InvestorProfile.transactionListData ng-repeat=\"transactiondata in InvestorProfile.transactionListData\"><td data-th=\"Transaction Type\">{{transactiondata.transactionType}}</td><!--<a href=\"javaScript:void(0);\" ng-click=\"InvestorProfile.showSummary(transactiondata)\">{{transactiondata.investmentType}}</a>--><td data-th=Scheme>{{transactiondata.scheme}}</td><td data-th=\"Folio Number\">{{transactiondata.folioNumber}}</td><td data-th=Date>{{transactiondata.date}}</td><td data-th=Amount><i class=rupee-icon></i> {{transactiondata.amount|unitWithOutDecimalFilter:transactiondata.amountUnit}}{{transactiondata.amountUnit|unitValue}}</td><td data-th=Status><span class=\"{{transactiondata.transactionStatus.toLowerCase()+\'-text\'}}\">{{transactiondata.transactionStatus}}</span></td><td data-th=Action ng-if=transactiondata.action><span class=\"btn btn-secondary-action btn-small-action\" ng-click=InvestorProfile.initiateTransaction(transactiondata)>{{transactiondata.action}}</span></td><td data-th=Action ng-if=!transactiondata.action>--</td></tr><tr ng-if=\"!InvestorProfile.transactionListData && !InvestorProfile.isLoading\"><td class=text-center colspan=6>No Record found</td></tr></tbody></table><div ng-if=InvestorProfile.isInvestorTransactionPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"InvestorProfile.totalTransactionListData <= InvestorProfile.PAGE_LIMITS[0]\" ng-bind=InvestorProfile.totalTransactionListData></span><select ng-if=\"InvestorProfile.totalTransactionListData > InvestorProfile.PAGE_LIMITS[0]\" ng-change=InvestorProfile.init() ng-model=InvestorProfile.pageLimitTransactionListData ng-options=\"_limit as _limit for _limit in InvestorProfile.PAGE_LIMITS\"></select><span>of</span> <span class=t-black ng-bind=InvestorProfile.totalTransactionListData></span></div><ul uib-pagination total-items=InvestorProfile.totalTransactionListData ng-model=InvestorProfile.currentPageTransactionListData max-size=5 items-per-page=InvestorProfile.pageLimitTransactionListData class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=InvestorProfile.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/investors/summary/cobmApproval/addBank.html","<form class=\"main-section clearfix modifyBank\" name=AddBankForm ng-init=CobmApproval.init()><h5 class=screen-title>Add New Bank</h5><!--<p class=\"breadcrumbs\">\n    <span class=\"text-primary cursor-pointer\" ui-sref=\"main.profile.folioDetails\">Folio Details </span><i\n    class=\"breadcrumb-icon\"></i><span> Add Bank</span>\n  </p>--><div class=folio-addbank><strong>Folio : </strong><span>{{CobmApproval.formData.folioNumber}}</span></div><div class=box-head><ul><!--<li><strong>Distributor Name:</strong> <span ng-bind=\"CobmApproval.formData.distributorName\">Distributor Name</span></li>--><li><strong>ARN:</strong> <span ng-bind=\"CobmApproval.formData.arnCode.split(\'-\')[1]\"></span></li></ul></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=input-normal><input type=text ng-model=CobmApproval.formData.bankName name=bankName autocomplete=off readonly> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><!--<select class=\"browser-default custom-select\" name=\"bankName\"\n                    ng-model=\"CobmApproval.selectedBank\" ng-change=\"CobmApproval.changeBank()\" required>\n              <option value=\"\" selected>Bank Name</option>\n              <option ng-repeat=\"banks in CobmApproval.bankList\" value=\"{{banks}}\">{{banks.bankName}}</option>\n            </select>\n            <span class=\"req text-red\">*</span>\n          <span class=\"error-input\" ng-messages=\"AddBankForm.bankName.$error\"\n                ng-show=\"AddBankForm.bankName.$dirty\">\n                <span ng-message=\"required\" ng-bind=\"CobmApproval.validateData.BANK_NAME_REQUIRED\"></span>\n                </span>--></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal><input type=text ng-model=CobmApproval.formData.bankAccountTypes.bankAcDesc name=accountType autocomplete=off readonly> <span class=highlight></span> <span class=bar></span><label>Account Type</label><!--<select class=\"browser-default custom-select\" name=\"accountType\"\n                    ng-model=\"CobmApproval.formData.accountType\"\n                    ng-options=\"_type.accountTypeCode as _type.accountType for _type in CobmApproval.bankTypeList\"\n                    required>\n              <option value=\"\" selected>Account Type\n              </option>\n            </select>\n            <span class=\"req text-red\">*</span>\n          <span class=\"error-input\" ng-messages=\"AddBankForm.accountType.$error\"\n                ng-show=\"AddBankForm.accountType.$dirty\">\n                <span ng-message=\"required\" ng-bind=\"CobmApproval.validateData.ACCOUNT_TYPE_REQUIRED\"></span>\n                </span>--></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:AddBankForm.micrnumber.$dirty && AddBankForm.micrnumber.$invalid}\"><input type=text ng-model=CobmApproval.formData.micrnumber ng-maxlength=9 limit-to=9 ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=AddBankForm.micrnumber.$error ng-show=AddBankForm.micrnumber.$dirty><span ng-message=required ng-bind=CobmApproval.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=CobmApproval.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=CobmApproval.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=CobmApproval.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=input-normal><input type=text ng-model=CobmApproval.formData.payoutMechanisms.payoutDesc name=payoutMechanism autocomplete=off readonly> <span class=highlight></span> <span class=bar></span><label>Payout Mechanism</label><!--<select class=\"browser-default custom-select\" name=\"payoutMechanism\"\n                    ng-model=\"CobmApproval.formData.payoutMechanism\"\n                    ng-disabled=\"CobmApproval.formData.RGTSCode==\'HDF\'\"\n                    ng-options=\"_type.payoutCode as _type.payoutDescription for _type in CobmApproval.payoutMechanismList\"\n                    required>\n              <option value=\"\" selected>Payout Mechanism</option>\n            </select>\n            <span class=\"req text-red\">*</span>\n          <span class=\"error-input\" ng-messages=\"AddBankForm.payoutMechanism.$error\"\n                ng-show=\"AddBankForm.payoutMechanism.$dirty\">\n          <span ng-message=\"required\" ng-bind=\"CobmApproval.validateData.PAYOUT_MECH_REQUIRED\"></span>\n      </span>--></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(CobmApproval.accModelDirty &&\n                 (!CobmApproval.formData.accountNumber.split(\'\').length || CobmApproval.formData.accountNumber.split(\'\').length<9 || CobmApproval.formData.accountNumber.split(\'\').length>20))}\"><input type=text ng-model=CobmApproval.formData.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=20 name=accountNumber required autocomplete=off directive.mask ng-change=CobmApproval.accFocus(); capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=CobmApproval.accModelDirty><span class=error-input ng-show=\"CobmApproval.formData.accountNumber.split(\'\').length==0\" ng-bind=CobmApproval.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(CobmApproval.formData.accountNumber.split(\'\').length<9)\" ng-bind=CobmApproval.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=\"(!CobmApproval.formData.accountNumber.split(\'\').length || CobmApproval.formData.accountNumber.split(\'\').length>20)\" ng-bind=CobmApproval.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=CobmApproval.verifyAccountNumber maxlength=20 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=CobmApproval.formData.accountNumber required autocomplete=off ng-keydown=CobmApproval.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=AddBankForm.verifyAccountNumber.$error.required ng-bind=CobmApproval.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=CobmApproval.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.pattern\n            && !AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\">{{CobmApproval.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid}\"><input type=text ng-model=CobmApproval.formData.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=CobmApproval.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid\"><span class=error-input ng-show=AddBankForm.ifsccode.$error.required ng-bind=CobmApproval.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=AddBankForm.ifsccode.$error.pattern ng-bind=CobmApproval.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid}\"><input type=text ng-model=CobmApproval.formData.bankBranch only-alphabets name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid\"><span class=error-input ng-show=AddBankForm.branchLocation.$error.required ng-bind=CobmApproval.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:AddBankForm.branchCity.$dirty && AddBankForm.branchCity.$invalid}\"><input type=text ng-model=CobmApproval.formData.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.branchCity.$dirty && CobmApproval.branchCity.$invalid\"><span class=error-input ng-show=AddBankForm.branchCity.$error.required ng-bind=CobmApproval.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of old bank to validate bank details.\"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{CobmApproval.oldBankName}}</span></p><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=CobmApproval.chequeLeafOld enctype=multipart/form-data upload=\"CobmApproval.uploadChequeLeafFileOld(file,\'add\')\" ng-model=CobmApproval.bankDetails.chequeLeafOld><div class=file-upload><button>Choose File</button> <span ng-if=CobmApproval.chooseAFileOld>No File Chosen</span> <span ng-click=CobmApproval.openUploadedDocOld()>{{CobmApproval.chequeLeafOld}}</span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload New Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=CobmApproval.chequeLeafNew upload=\"CobmApproval.uploadChequeLeafFile(file,\'add\')\" ng-model=CobmApproval.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=CobmApproval.chooseAFileNew>No File Chosen</span> <span ng-click=CobmApproval.openUploadedDoc()>{{CobmApproval.chequeLeaf}}</span></div></div></div><div class=row><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox ng-model=CobmApproval.formData.makeDefaultBank> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div></div><div class=\"form-footer col-md-12\"><!--<span class=\"pull-left back\" ng-click=\"CobmApproval.back()\"><i class=\"back-arrow-icon\"></i>Back</span>--> <span class=pull-right><input type=button value=Reject ng-click=CobmApproval.confirmCancelModaltoReject() class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Approve class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !CobmApproval.chequeLeaf || !CobmApproval.chequeLeafOld\" ng-click=CobmApproval.approveAddBank()></span></div></div></form><!--\n|| !CobmApproval.chequeLeafUrl-->");
$templateCache.put("app/investors/summary/cobmApproval/approved.html","<div class=\"box-body approved-folio\" ng-init=Approved.init();><p><i class=success-tick-icon></i><span>Submission Successful</span><br>The details submitted will be used for investment made under the selected folio</p></div>");
$templateCache.put("app/investors/summary/cobmApproval/changeBank.html","<form class=\"main-section clearfix modifyBank\" name=modifyBank ng-init=ChangeBank.init()><h5 class=screen-title>Change Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Folio Details </span><i class=breadcrumb-icon></i><span> Modify Bank</span></p><div class=folio-addbank><strong>Folio : </strong><span>{{ChangeBank.folioNumberToDisplay}}</span></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.bankName.$dirty && modifyBank.bankName.$invalid}\"><select class=select-box name=bankName ng-model=ChangeBank.selectedBank ng-change=ChangeBank.changeBank() required><option value=\"\" selected>Bank Name</option><option ng-repeat=\"banks in ChangeBank.bankList\" value={{banks}}>{{banks.bankName}}</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.bankName.$error ng-show=modifyBank.bankName.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=selectfield ng-class=\"{error:modifyBank.accountType.$dirty && modifyBank.accountType.$invalid}\"><select class=select-box name=accountType ng-model=ChangeBank.payload.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in ChangeBank.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.accountType.$error ng-show=modifyBank.accountType.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:modifyBank.micrnumber.$dirty && modifyBank.micrnumber.$invalid}\"><input type=text ng-model=ChangeBank.payload.micrnumber ng-maxlength=9 limit-to=9 ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=modifyBank.micrnumber.$error ng-show=modifyBank.micrnumber.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=ChangeBank.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.payoutMechanism.$dirty && modifyBank.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=ChangeBank.payload.payoutMechanism ng-disabled=\"ChangeBank.payload.RGTSCode==\'HDF\'\" ng-options=\"_type.payoutCode as _type.payoutDescription for _type in ChangeBank.payoutMechanismList\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.payoutMechanism.$error ng-show=modifyBank.payoutMechanism.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(ChangeBank.accModelDirty &&\n                 (!ChangeBank.payload.accountNumber.split(\'\').length || ChangeBank.payload.accountNumber.split(\'\').length>9|| ChangeBank.payload.accountNumber.split(\'\').length>20))}\"><input type=text ng-model=ChangeBank.payload.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=20 name=accountNumber limit-to=20 required autocomplete=off directive.mask ng-change=BankDetails.accFocus() capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=ChangeBank.accModelDirty><span class=error-input ng-show=\"ChangeBank.payload.accountNumber.split(\'\').length==0\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"ChangeBank.payload.accountNumber.split(\'\').length<9\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=\"(!ChangeBank.payload.bankDetails.accountNumber.split(\'\').length || ChangeBank.payload.bankDetails.accountNumber.split(\'\').length>20)\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid}\"><input type=text ng-model=ChangeBank.verifyAccountNumber maxlength=20 name=verifyAccountNumber limit-to=20 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=ChangeBank.payload.accountNumber required autocomplete=off ng-keydown=ChangeBank.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid\"><span class=error-input ng-show=modifyBank.verifyAccountNumber.$error.required ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\" ng-bind=ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.pattern\n            && !modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\">{{ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid}\"><input type=text ng-model=ChangeBank.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=ChangeBank.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid\"><span class=error-input ng-show=modifyBank.ifsccode.$error.required ng-bind=ChangeBank.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=modifyBank.ifsccode.$error.pattern ng-bind=ChangeBank.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankBranch only-alphabets name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid\"><span class=error-input ng-show=modifyBank.branchLocation.$error.required ng-bind=ChangeBank.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchCity.$dirty && modifyBank.branchCity.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchCity.$dirty && modifyBank.branchCity  .$invalid\"><span class=error-input ng-show=modifyBank.branchCity.$error.required ng-bind=ChangeBank.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload New Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafNew upload=ChangeBank.uploadChequeLeafFile(file) ng-model=ChangeBank.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileNew>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDoc()>{{ChangeBank.bankDetails.chequeLeaf}}</span></div></div></div><!-- <div class=\"row border-bottom\">\n        <div class=\"col-md-12 mark-default\">\n        <div class=\"checkbox\">\n          <input type=\"checkbox\"/>\n          <i class=\"icon-checkbox\"></i>\n          <span class=\"checkbox-text\">Make it a default bank for this folio </span>\n        </div>\n        </div>\n      </div>--><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of old bank to validate bank details. \"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{ChangeBank.oldBankName}}</span></p><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafOld upload=ChangeBank.uploadChequeLeafFileOld(file) ng-model=ChangeBank.bankDetails.chequeLeafOld><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileOld>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDocOld()>{{ChangeBank.bankDetails.chequeLeafOld}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=\"pull-left back\" ng-click=ChangeBank.back()><i class=arrow-blue-back-icon></i>Back</span> <span class=pull-right><input type=button value=Cancel class=\"btn btn-secondary-action common-btn-padding\" ng-click=ChangeBank.back()> <input type=submit value=Sumbit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"modifyBank.$invalid || !ChangeBank.bankDetails.chequeLeaf || !ChangeBank.bankDetails.chequeLeafOld\" ng-click=ChangeBank.changeBankSubmit()></span></div></div></form>");
$templateCache.put("app/investors/summary/cobmApproval/deleteBank.html","<form class=\"main-section clearfix modifyBank\" name=AddBankForm ng-init=CobmApproval.init()><h5 class=screen-title>Delete Bank</h5><div class=folio-addbank><strong>Folio : </strong><span>{{CobmApproval.formData.folioNumber}}</span></div><div class=box-head><ul><!--<li><strong>Distributor Name:</strong> <span ng-bind=\"CobmApproval.formData.distributorName\">Distributor Name</span></li>--><li><strong>ARN:</strong> <span ng-bind=\"CobmApproval.formData.arnCode.split(\'-\')[1]\"></span></li></ul></div><div class=content-area><!--<p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p>--><div class=col-md-12><div class=\"row email-view\"><section style=padding:0px><div class=content-body><div class=email-block style=\"box-shadow: none;margin-top:0px;padding-left:15px;padding-top:0px\"><p class=email-block-header>Bank Details</p><table class=\"table borderless\" style=\"margin-top: 1.143em\"><tbody><tr><td>Bank Name</td><td>:</td><td>{{CobmApproval.formData.bankName || \'NA\'}}</td></tr><tr><td>Account Type</td><td>:</td><td>{{CobmApproval.formData.accountType || \'NA\'}}</td></tr><tr><td>Account Number</td><td>:</td><td ng-bind=\"CobmApproval.formData.accountNumber || \'NA\'\">Saving</td></tr><tr><td>Branch Name</td><td>:</td><td ng-bind=\"CobmApproval.formData.bankBranch || \'NA\'\"></td></tr><tr><td>Branch Location</td><td>:</td><td ng-bind=\"CobmApproval.formData.bankCity || \'NA\'\">Saket, New Delhi</td></tr><tr><td>IFSC</td><td>:</td><td>{{CobmApproval.formData.ifsccode || \'NA\'}}</td></tr><tr><td>Payout Mechanism</td><td>:</td><td>{{CobmApproval.formData.payoutMechanism || \'NA\'}}</td></tr><tr><td>MICR Number</td><td>:</td><td ng-bind=\"CobmApproval.formData.micrnumber || \'NA\'\"></td></tr></tbody></table></div></div></section></div><div class=\"row upload-some\"><span class=leaf-label>Upload Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of the bank to validate bank details.\"></i> </span><!--<p class=\"upload-data\">\n          <span class=\"grey-text\">Bank Name : </span><span>{{CobmApproval.oldBankName}}</span>\n        </p>--><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=CobmApproval.chequeLeaf enctype=multipart/form-data upload=\"CobmApproval.uploadChequeLeafFileDelete(file,\'add\')\" ng-model=CobmApproval.formData.oldBankProofURL><div class=file-upload><button>Choose File</button> <span ng-if=CobmApproval.chooseAFile>No File Chosen</span> <span ng-click=CobmApproval.openUploadedDocOld()>{{CobmApproval.chequeLeaf}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><!--<span class=\"pull-left back\" ng-click=\"CobmApproval.back()\"><i class=\"back-arrow-icon\"></i>Back</span>--> <span class=pull-right><input type=button value=Reject ng-click=CobmApproval.confirmCancelModaltoRejectDeleteBank() class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Approve class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !CobmApproval.chequeLeaf\" ng-click=CobmApproval.approveDeleteBank()></span></div></div></form>");
$templateCache.put("app/investors/summary/cobmApproval/index.cobm.html","<div class=\"approval main-section\"><!--<h3 class=\"page-title\"><small>COBM Approval</small><br/><span ng-bind=\"FolioApprovalParent.headerDetails.name\">Investor Name</span></h3>--><!--  <h5 class=\"screen-title\">Add New Bank</h5>\n  <p class=\"breadcrumbs\">\n    <span class=\"text-primary cursor-pointer\" ui-sref=\"main.profile.folioDetails\">Folio Details </span><i\n    class=\"breadcrumb-icon\"></i><span> Add Bank</span>\n  </p>\n\n  <div class=\"folio-addbank\">\n    <strong>Folio : </strong>\n    <span>{{AddBank.folioNumberToDisplay}}</span>\n  </div>--><div class=box-main><div class=form-box style=margin-top:0px><!--<div class=\"box-head\">\n        <ul>\n          <li><strong>Distributor Name:</strong> <span ng-bind=\"FolioApprovalParent.headerDetails.distributorName\">Distributor Name</span></li>\n          <li><strong>ARN:</strong> <span ng-bind=\"FolioApprovalParent.headerDetails.distributorArn\"></span></li>\n        </ul>\n      </div>--><ui-view></ui-view></div></div></div>");
$templateCache.put("app/investors/summary/cobmApproval/rejected.html","<div class=\"box-body rejected-folio\" ng-init=Rejected.init();><p><i class=success-tick-icon></i><span>Rejected</span><br>You have rejected the adding bank process.</p></div>");
$templateCache.put("app/investors/summary/cobmApproval/soleApplicant.html","<div class=\"box-body folio-approval-investor\" ng-init=FolioApproval.init();><form autocomplete=off name=FolioApproval.soleApplicantForm ng-submit=FolioApproval.submitApplicantDetails() novalidate><h3 ng-if=!FolioApproval.formData.soleApplicantDetail.minor>Sole Applicant Details</h3><h3 ng-if=FolioApproval.formData.soleApplicantDetail.minor>Folio Creation: <span class=text-black>Minor</span></h3><div class=\"sole-applicant folio-approval\"><!-- <div class=\"form-content\">\n\n          <div class=\"row\">\n            <div class=\"col-md-2 col-sm-4 auto-width\">\n              <p><strong>Folio Creation:</strong></p>\n            </div>\n            <div class=\"col-md-4\">\n              <span class=\"radio-block\">\n          <span class=\"radio\">\n            <input type=\"radio\" id=\"self\" name=\"selfminor\"\n                   ng-model=\"FolioApproval.formData.soleApplicantDetail.minor\"\n                   ng-value=\"false\" ng-disabled=\"true\"/>\n            <span class=\"check\"></span>\n          </span>\n          <label for=\"self\">Self</label>\n        </span>\n              <span class=\"radio-block\">\n            <span class=\"radio\">\n              <input type=\"radio\" id=\"minor\" name=\"selfminor\"\n                     ng-model=\"FolioApproval.formData.soleApplicantDetail.minor\"\n                     ng-value=\"true\" ng-disabled=\"true\"/>\n              <span class=\"check\"></span>\n            </span>\n            <label for=\"minor\">Minor</label>\n        </span>\n            </div>\n          </div>\n\n          <div name=\"minor-fields\" ng-if=\"FolioApproval.formData.soleApplicantDetail.minor\" class=\"folio-create mrg20\">\n            <div class=\"row\">\n              <div class=\"col-md-3 pos-relative\">\n                <label class=\"customized-label\" ng-if=\"FolioApproval.formData.soleApplicantDetail.gender\">Gender</label>\n                <div class=\"input-normal selectfield input-normal mgt5\" ng-class=\"{error:FolioApproval.soleApplicantForm.minorGender.$dirty && FolioApproval.soleApplicantForm.minorGender.$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"minorGender\"\n                          ng-model=\"FolioApproval.formData.soleApplicantDetail.gender\"\n                          ng-options=\"_gender.key as _gender.value for _gender in FolioApproval.genderList\"\n                          required>\n                    <option value=\"\" selected>Gender</option>\n                  </select>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <span class=\"req text-red\">*</span>\n                </div>\n                <span ng-show=\"FolioApproval.soleApplicantForm.minorGender.$dirty && FolioApproval.soleApplicantForm.minorGender.$invalid\">\n                   <span class=\"error-input error\" ng-show=\"FolioApproval.soleApplicantForm.minorGender.$error.required\">Please select Gender</span>\n                </span>\n              </div>\n              <div class=\"col-md-3 col-md-offset-1\">\n                <div class=\"input-normal\" ng-class=\"{error:FolioApproval.soleApplicantForm.minorName.$dirty && FolioApproval.soleApplicantForm.minorName.$invalid}\">\n                  <input type=\"text\" name=\"minorName\" ng-model=\"FolioApproval.formData.soleApplicantDetail.name\" required>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <label>Minor\'s Name</label>\n                </div>\n                <span ng-show=\"FolioApproval.soleApplicantForm.minorName.$dirty && FolioApproval.soleApplicantForm.minorName.$invalid\">\n                <span class=\"error-input error\" ng-show=\"FolioApproval.soleApplicantForm.minorName.$error.required\" ng-bind=\"FolioApproval.validateData.MINOR_NAME\"></span>\n                </span>\n              </div>\n              <div class=\"col-md-3 col-md-offset-1\">\n                <div class=\"input-normal calendar\" style=\"position: relative;\"\n                     ng-class=\"{error:FolioApproval.soleApplicantForm.dob.$dirty && FolioApproval.soleApplicantForm.dob.$invalid}\">\n                  <input type=\"text\"\n                         name=\"dob\"\n                         date-calendar\n                         format=\"DD-MMM-YYYY\"\n                         viewmode=\'days\'\n                         showdefault=\"\'true\'\"\n                         date-default=\"FolioApproval.defaultDob\"\n                         maxdate=\"now\"\n                         data-min-date=\"FolioApproval.minDateMinor\"\n                         data-on-date-change=\"FolioApproval.changeMinorDob\"\n                         ng-model=\"FolioApproval.formData.soleApplicantDetail.dob\"\n                         data-enable=\"true\"\n                         required>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <i class=\"calendar-input-icon\"></i>\n                  <label>Date of Birth</label>\n                  <span ng-show=\"FolioApproval.soleApplicantForm.dob.$dirty && FolioApproval.soleApplicantForm.dob.$invalid\">\n                  <span class=\"error-input\" ng-show=\"FolioApproval.soleApplicantForm.dob.$error.required\">{{FolioApproval.validateData.NET_WORTH_DATE}}</span>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div name=\"minor-fields\" ng-if=\"FolioApproval.formData.soleApplicantDetail.minor\" class=\"folio-create\">\n            <div class=\"row\">\n              <div class=\"col-md-3\">\n                <p><strong>Upload Nominee’s Age Proof<i class=\"tooltip-info-icon\"></i></strong></p>\n                <div class=\"form-group\">\n                   <span class=\"upload-button\">\n                     <input id=\"uploadFileId\" type=\"file\"  focus-me=\"shouldBeOpen\" value=\"Browse..\" accept=\".jpeg,.jpg,.png\" file-model=\"FolioApproval.minorAgeProof\" targetimg=\"showingImgId\" upload=\"FolioApproval.uploadFileAgeProof(file)\">\n                     <label for=\"uploadFileId\" class=\"btn-upload btn-secondary-action\">{{AppDetails.minorAgeProof?\'Change\':\'Choose File\'}}</label>\n                  </span>\n                  <span class=\"file-name text-blue\"><a href=\"{{FolioApproval.formData.soleApplicantDetail.minorAgeProof}}\" target=\"_blank\">{{FolioApproval.minorAgeProof}}</a></span>\n                </div>\n              </div>\n              <div class=\"col-md-3 col-md-offset-1\">\n                <p><strong>Gaurdian Name :</strong></p>\n                <span class=\"gaurdian-name\">{{FolioApproval.formData.investorPanDetails.name}}</span>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-md-3 pos-relative\">\n                <label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.guardianDetails.relationship\">Relationship With Minor</label>\n                <div class=\"input-normal selectfield input-normal\" ng-class=\"{error:FolioApproval.soleApplicantForm.minorRelationship.$dirty && FolioApproval.soleApplicantForm.minorRelationship.$invalid}\">\n                  <select class=\"browser-default custom-select\" name=\"minorRelationship\"\n                          ng-model=\"FolioApproval.formData.guardianDetails.relationship\"\n                          ng-options=\"relationship for relationship in FolioApproval.relationshipsList\"\n                          required>\n                    <option value=\"\" selected>Relationship With Minor</option>\n                  </select>\n                  <span class=\"highlight\"></span>\n                  <span class=\"bar\"></span>\n                  <span class=\"req text-red\">*</span>\n                </div>\n                <span ng-show=\"FolioApproval.soleApplicantForm.minorRelationship.$dirty && FolioApproval.soleApplicantForm.minorRelationship.$invalid\">\n              <span class=\"error-input error\" ng-show=\"FolioApproval.soleApplicantForm.minorRelationship.$error.required\">Please select Relationship</span>\n            </span>\n              </div>\n\n              <div class=\"col-md-3 col-md-offset-1 upload-block\">\n                <p><strong>Upload Relation Proof<i class=\"tooltip-info-icon\"></i></strong></p>\n                <div class=\"form-group\">\n              <span class=\"upload-button\">\n                   <input id=\"uploadGurdianAgeProof\" type=\"file\"  focus-me=\"shouldBeOpen\" value=\"Browse..\" accept=\".jpeg,.jpg,.png\" file-model=\"FolioApproval.minorGaurdianAgeProof\" targetimg=\"showingImgId\" upload=\"FolioApproval.uploadGuardianProofFile(file)\">\n                   <label for=\"uploadGurdianAgeProof\" class=\"btn-upload btn-secondary-action\">{{FolioApproval.minorGaurdianAgeProof?\'Change\':\'Choose File\'}}</label>\n				        </span>\n                  <span class=\"file-name text-blue\"><a href=\"{{FolioApproval.formData.guardianDetails.guardianRelationshipProofUrl}}\" target=\"_blank\">{{FolioApproval.minorGaurdianFileName}}</a></span>\n                </div>\n\n              </div>\n\n            </div>\n          </div>\n        </div>--><div class=form-content><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s Income Details\":\"Income Details\"}}</strong></p><div class=row><div class=\"col-md-3 pos-relative\"><label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.soleApplicantDetail.taxStatusCode || FolioApproval.formData.guardianDetails.basicDetails.taxStatusCode\">Tax Status</label><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.taxStatusCode.$dirty && FolioApproval.soleApplicantForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=taxStatusCode ng-model=FolioApproval.formData.soleApplicantDetail.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in FolioApproval.taxStatusList\" required><option value=\"\" selected>Tax Status</option></select><select class=\"browser-default custom-select\" ng-if=FolioApproval.formData.soleApplicantDetail.minor name=taxStatusCode ng-model=FolioApproval.formData.guardianDetails.basicDetails.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in FolioApproval.taxStatusList\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"FolioApproval.soleApplicantForm.taxStatusCode.$dirty && FolioApproval.soleApplicantForm.taxStatusCode.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.taxStatusCode.$error.required ng-bind=FolioApproval.validateData.TAX_STATUS></span></span></div></div><div class=\"col-md-3 col-md-offset-1 pos-relative\"><label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.soleApplicantDetail.occupation || FolioApproval.formData.guardianDetails.basicDetails.occupation\">Occupation</label><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.occupation.$dirty && FolioApproval.soleApplicantForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=occupation ng-model=FolioApproval.formData.soleApplicantDetail.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in FolioApproval.occupationList\" ng-change=FolioApproval.setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><select class=\"browser-default custom-select\" ng-if=FolioApproval.formData.soleApplicantDetail.minor name=occupation ng-model=FolioApproval.formData.guardianDetails.basicDetails.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in FolioApproval.occupationList\" ng-change=FolioApproval.setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><span ng-show=\"FolioApproval.soleApplicantForm.occupation.$dirty && FolioApproval.soleApplicantForm.occupation.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.occupation.$error.required ng-bind=FolioApproval.validateData.OCCUPATION></span></span></div></div></div><div class=row><div class=\"col-md-3 pos-relative\"><label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.soleApplicantDetail.grossAnnualIncome || FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome\">Gross Annual Income</label><div class=\"input-select input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.grossAnnualIncome.$dirty\n                 && FolioApproval.soleApplicantForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=grossAnnualIncome ng-click=\"FolioApproval.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioApproval.incomeSlabList\" easyassist-key=mask-element ng-required=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate)\" ng-disabled=FolioApproval.formData.soleApplicantDetail.netWorth><option value=\"\" selected>Gross Annual Income</option></select><select class=\"browser-default custom-select\" ng-if=FolioApproval.formData.soleApplicantDetail.minor name=grossAnnualIncome ng-click=\"FolioApproval.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioApproval.incomeSlabList\" easyassist-key=mask-element ng-required=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate)\" ng-disabled=FolioApproval.formData.soleApplicantDetail.netWorth><option value=\"\" selected>Gross Annual Income</option></select><span ng-show=\"FolioApproval.soleApplicantForm.grossAnnualIncome.$dirty && FolioApproval.soleApplicantForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.grossAnnualIncome.$error.required ng-bind=FolioApproval.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=FolioApproval.soleApplicantForm.grossAnnualIncome.$error.number ng-bind=FolioApproval.validateData.INVALID_AMOUNT></span> </span><span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate) && !FolioApproval.formData.soleApplicantDetail.minor\" class=req>*</span> <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate) && FolioApproval.formData.soleApplicantDetail.minor\" class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt18\" ng-class=\"{error:FolioApproval.soleApplicantForm.netWorth.$dirty\n                 && FolioApproval.soleApplicantForm.netWorth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=netWorth class=pd20 ng-model=FolioApproval.formData.soleApplicantDetail.netWorth ng-required=!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome) ng-disabled=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome> <input type=number easyassist-key=mask-element ignore-mouse-wheel ng-if=FolioApproval.formData.soleApplicantDetail.minor name=netWorth class=pd20 ng-model=FolioApproval.formData.guardianDetails.basicDetails.netWorth ng-required=!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome) ng-disabled=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome> <span ng-show=\"FolioApproval.soleApplicantForm.netWorth.$dirty && FolioApproval.soleApplicantForm.netWorth.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.netWorth.$error.number ng-bind=FolioApproval.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=FolioApproval.soleApplicantForm.netWorth.$error.required ng-bind=FolioApproval.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Net worth (in Rs.) <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome) && !FolioApproval.formData.soleApplicantDetail.minor\n                ||(FolioApproval.formData.soleApplicantDetail.netWorthDate)\" class=req>*</span> <span ng-if=\"!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome) && FolioApproval.formData.soleApplicantDetail.minor\n                ||(FolioApproval.formData.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span></label></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-select input-normal input-group date date-picker mgt18\" ng-class=\"{error : FolioApproval.formData.soleApplicantDetail.netWorth\n                   && !FolioApproval.formData.soleApplicantDetail.netWorthDate\n                   }\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor><input type=text easyassist-key=mask-element name=netWorthDate id=soleNetWorthDate2 date-calendar date-default=FolioApproval.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=FolioApproval.minDate showdefault=\"{{\'\'+!!FolioApproval.formData.soleApplicantDetail.netWorthDate}}\" data-on-date-change=FolioApproval.changeStartDate required ng-disabled=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label>As on DD/MM/YYYY <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome)\n                ||(FolioApproval.formData.soleApplicantDetail.netWorth)\" class=req>*</span></label></div><!--<span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span>--><div class=\"input-select input-normal input-group date date-picker mgt18\" ng-class=\"{error : FolioApproval.formData.guardianDetails.basicDetails.netWorth\n                   && !FolioApproval.formData.guardianDetails.basicDetails.netWorthDate\n                   }\" ng-if=FolioApproval.formData.soleApplicantDetail.minor><input type=text easyassist-key=mask-element name=netWorthDate id=soleNetWorthDate2 date-calendar date-default=FolioApproval.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=FolioApproval.minDate showdefault=\"{{\'\'+!!FolioApproval.formData.guardianDetails.basicDetails.netWorthDate}}\" data-on-date-change=FolioApproval.changeStartDate required ng-disabled=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label>As on DD/MM/YYYY <span ng-if=\"!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(FolioApproval.formData.guardianDetails.basicDetails.netWorth)\" class=req>*</span></label></div></div></div></div><div class=form-content><p><strong ng-if=!FolioApproval.formData.soleApplicantDetail.minor>Politically Exposed Person (PEP) Status</strong><strong ng-if=FolioApproval.formData.soleApplicantDetail.minor>Guardian\'s Politically Exposed Person (PEP) Status</strong></p><div class=row><div class=col-md-6><div class=radio-block><span class=\"radio mg20\"><input type=radio id=politicalStatus1 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus1 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.RELATED ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus2 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.RELATED ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.NONE ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus3 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.NONE ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus3>Not Applicable.</label></div></div></div></div><div class=form-content><div class=\"row pdt10\"><div class=\"col-md-3 pos-relative\"><label class=\"customized-label custom-top top25\" ng-if=\"FolioApproval.formData.soleApplicantDetail.fatcaAddressType || FolioApproval.formData.guardianDetails.basicDetails.fatcaAddressType\">Address Type</label><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s FATCA or CRS information\":\"FATCA or CRS information\"}}</strong></p><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in FolioApproval.addressDescriptions\" easyassist-key=mask-element required><option value=\"\" selected>Address Type</option></select><select class=\"browser-default custom-select\" name=fatcaAddressType ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in FolioApproval.addressDescriptions\" easyassist-key=mask-element required><option value=\"\" selected>Address Type</option></select><span ng-show=\"FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.fatcaAddressType.$error.required ng-bind=FolioApproval.validateData.ADDRESS_TYPE></span></span></div></div><div class=\"col-md-3 col-md-offset-1 pos-relative\"><label class=\"customized-label custom-top top25\" ng-if=\"FolioApproval.formData.soleApplicantDetail.birthCountry || FolioApproval.formData.guardianDetails.basicDetails.birthCountry\">Country of Birth</label><div class=\"input-select input-normal selectfield\" style=\"margin-top: 25px\" ng-class=\"{error:FolioApproval.soleApplicantForm.birthCountry.$dirty && FolioApproval.soleApplicantForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.birthCountry ng-options=\"country.countryName as country.countryName for country in FolioApproval.countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><select class=\"browser-default custom-select\" name=birthCountry ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.birthCountry ng-options=\"country.countryName as country.countryName for country in FolioApproval.countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"FolioApproval.soleApplicantForm.birthCountry.$dirty && FolioApproval.soleApplicantForm.birthCountry.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.birthCountry.$error.required>{{AppDetails.validateData.COUNTRY}}</span></span></div></div></div><div class=\"row pdt20\"><div class=col-md-3><div class=\"input-select input-normal\" ng-class=\"{error:FolioApproval.soleApplicantForm.birthCity.$dirty && FolioApproval.soleApplicantForm.birthCity.$invalid}\"><input type=text name=birthCity ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.birthCity easyassist-key=mask-element required capitalize> <input type=text name=birthCity ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.birthCity easyassist-key=mask-element required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><span ng-show=\"FolioApproval.soleApplicantForm.birthCity.$dirty && FolioApproval.soleApplicantForm.birthCity.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.birthCity.$error.required>{{FolioApproval.validateData.CITY}}</span></span></div></div></div></div><div class=\"form-content inves-pay\"><div class=row><div class=col-md-6><p>Does the investor pay or file tax other than India?</p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.soleApplicantDetail.payTaxInIndia ng-value=false> <input type=radio id=payTaxInIndiaYes ng-if=FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.soleApplicantDetail.payTaxInIndia ng-value=true> <input type=radio id=payTaxInIndiaNo ng-if=FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span></div></div></div><div class=form-content><div class=row><div class=col-md-12><div ng-if=\"!FolioApproval.formData.soleApplicantDetail.payTaxInIndia && !FolioApproval.formData.soleApplicantDetail.minor\"><div class=tax-res ng-repeat=\"data in FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=FolioApproval.deleteTaxResidency($index)><i class=delete-icon></i></span></p><div class=row><div class=col-md-3><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryName as country.countryName for country in FolioApproval.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"FolioApproval[\'birthCountry-\'+$index].$error.required\">{{FolioApproval.validateData.COUNTRY}}</span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'taxIdType-\'+$index].$dirty && FolioApproval[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdType ng-options=\"taxidtype.key as taxidtype.value for taxidtype in FolioApproval.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span></div></div></div><div class=row><div class=col-md-3><div class=\"input-select input-normal mgt18\"><input type=text name=taxIdNumber-{{$index}} easyassist-key=mask-element ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdNumber required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number</label></div></div></div></div></div><div ng-if=\"!FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia && FolioApproval.formData.soleApplicantDetail.minor\"><div class=tax-res ng-repeat=\"data in FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses\"><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s Tax Residency Country\":\"Tax Residency Country\"}}</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=FolioApproval.deleteTaxResidencyGD($index)><i class=delete-icon></i></span></p><div class=row><div class=col-md-3><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryName as country.countryName for country in FolioApproval.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"FolioApproval[\'birthCountry-\'+$index].$error.required\">{{FolioApproval.validateData.COUNTRY}}</span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'taxIdType-\'+$index].$dirty && FolioApproval[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} easyassist-key=mask-element ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType ng-options=\"taxidtype.key as taxidtype.value for taxidtype in FolioApproval.taxIdTypeList\" required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span></div></div></div><div class=row><div class=col-md-3><div class=\"input-select input-normal mgt18\"><input type=text name=taxIdNumber-{{$index}} easyassist-key=mask-element ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number</label></div></div></div></div></div></div></div><div class=row ng-if=\"!FolioApproval.formData.soleApplicantDetail.payTaxInIndia && !FolioApproval.formData.soleApplicantDetail.minor\"><div class=\"col-md-12 add-another-tax-res\"><a href=\"\" class=text-blue ng-click=FolioApproval.addMoreTaxResidency()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><div class=row ng-if=\"!FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia && FolioApproval.formData.soleApplicantDetail.minor\"><div class=\"col-md-12 add-another-tax-res\"><a href=\"\" class=text-blue ng-click=FolioApproval.addMoreTaxResidencyGD()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div><div class=\"form-footer form-content\"><button type=button class=\"btn btn-negative-action\" ng-click=FolioApproval.confirmCancelModaltoReject()>Reject Folio</button> <button class=\"btn btn-primary-action\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-disabled=\"FolioApproval.soleApplicantForm.$invalid\n              ||(!FolioApproval.formData.soleApplicantDetail.netWorthDate && !FolioApproval.formData.soleApplicantDetail.grossAnnualIncome)\n              ||(FolioApproval.formData.soleApplicantDetail.netWorth && !FolioApproval.formData.soleApplicantDetail.netWorthDate)\">Next</button> <button class=\"btn btn-primary-action\" ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-disabled=\"FolioApproval.soleApplicantForm.$invalid\n              ||(!FolioApproval.formData.guardianDetails.basicDetails.netWorthDate && !FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome)\n              ||(FolioApproval.formData.guardianDetails.basicDetails.netWorth && !FolioApproval.formData.guardianDetails.basicDetails.netWorthDate)\">Next</button></div></div></form></div>");
$templateCache.put("app/investors/summary/folioApproval/approved.html","<div class=\"box-body approved-folio\" ng-init=Approved.init();><p><i class=success-tick-icon></i><span>Submission Successful</span><br>The details mentioned in the FOLIO creation will be used for investment made under this folio<br><span ng-bind-html=Approved.camsMessage></span></p><!--Folio--><!--<p><i class=\"success-tick-icon\"></i><span>Submission Successful</span><br/>--><!--You have successfully initiated the investment. Thanks for investing with HDFC MFOnline.</p>--></div>");
$templateCache.put("app/investors/summary/folioApproval/bankDetails.html","<div class=\"box-body folio-approval-investor\" ng-init=Payment.init();><form autocomplete=off name=Payment.paymentForm ng-submit=Payment.approveFolioSubmit() novalidate><h3>Bank Details</h3><div class=\"folio-approval bank-info\"><div class=\"row form-grid\"><p><strong>Add Bank Details for {{Payment.investorName}}</strong><i class=tooltip-info-icon></i> <small>(This Bank is for IDCW Payout and Redemption purposes.)</small></p><!--        <div class=\"col-md-12 form-group minor-type-acc\" ng-if=\"Payment.formData.soleApplicantDetail.minor\">--><!--              <span class=\"radio-block\">--><!--                <span class=\"radio\" >--><!--                  <input type=\"radio\" name=\"bankOptions\" value=\"MINOR\"--><!--                         ng-model=\"Payment.formData.bankDetails.bankHolderType\"--><!--                  />--><!--                  <span class=\"check\"></span>--><!--                </span>--><!--                <label>Account held by Minor</label>--><!--              </span>--><!--          <span class=\"radio-block\">--><!--                <span class=\"radio\">--><!--                  <input type=\"radio\" name=\"bankOptions\" value=\"INVESTOR\"--><!--                         ng-model=\"Payment.formData.bankDetails.bankHolderType\"--><!--                  />--><!--                  <span class=\"check\"></span>--><!--                </span>--><!--                <label>Account held by Investor <span class=\"small-grey-text\">(in the capacity of the guardian)</span></label>--><!--              </span>--><!--        </div>--><div class=\"col-md-4 pos-relative\"><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.ifsccode.$dirty && Payment.paymentForm.ifsccode.$invalid}\"><input type=text ng-model=Payment.formData.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=Payment.IFSC_REGEX capitalize required ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode} ng-disabled=!Payment.formData.bankDetails.ifsccode ng-class={enable:Payment.formData.bankDetails.ifsccode} ng-readonly=Payment.formData.bankDetails.ifsccode> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search\" ng-click=Payment.selectIFSC()></span><label ng-class={ifscBlank:!Payment.paymentForm.ifsccode}>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"Payment.paymentForm.ifsccode.$dirty && Payment.paymentForm.ifsccode.$invalid\"><span class=error-input ng-show=Payment.paymentForm.ifsccode.$error.required ng-bind=Payment.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=Payment.paymentForm.ifsccode.$error.pattern ng-bind=Payment.validateData.IFSC_CODE_REGEX></span></span></div></div></div><div class=\"col-md-4 pos-relative\"><!--<label class=\"customized-label custom-top\" ng-if=\"Payment.formData.bankDetails.bankName\">Bank Name</label>--><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.bankName.$dirty && Payment.paymentForm.bankName.$invalid}\"><input type=text ng-model=Payment.formData.bankDetails.bankName name=bankName required ng-disabled=!Payment.formData.bankDetails.bankName ng-class={enable:Payment.formData.bankDetails.bankName} ng-readonly=Payment.formData.bankDetails.bankName> <span ng-show=\"Payment.paymentForm.bankName.$dirty && Payment.paymentForm.bankName.$invalid\"><span class=error-input ng-show=Payment.paymentForm.bankName.$error.required ng-bind=Payment.validateData.BANK_NAME_REQUIRED></span></span><label>Bank Name <span class=req>*</span></label></div></div></div><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top\" ng-if=Payment.formData.bankDetails.accountType>Account Type</label><div class=form-group><div class=selectfield ng-class=\"{error:Payment.paymentForm.accountType.$dirty && Payment.paymentForm.accountType.$invalid}\"><select class=\"custom-select select-box\" name=accountType ng-model=Payment.formData.bankDetails.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in Payment.bankTypeList\" required ng-disabled=!Payment.formData.bankDetails.ifsccode ng-class={disablefield:!Payment.formData.bankDetails.ifsccode}><option value=\"\" selected>Account Type</option></select><span ng-show=\"Payment.paymentForm.accountType.$dirty && Payment.paymentForm.accountType.$invalid\"><span class=error-input ng-show=Payment.paymentForm.accountType.$error.required ng-bind=Payment.validateData.ACCOUNT_TYPE_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.branchLocation.$dirty && Payment.paymentForm.branchLocation.$invalid}\"><input type=text ng-model=Payment.formData.bankDetails.branchLocation name=branchLocation required autocomplete=off capitalize ng-disabled=!Payment.formData.bankDetails.ifsccode maxlength=40 ng-class={enable:Payment.formData.bankDetails.branchLocation} ng-readonly=Payment.formData.bankDetails.bankBranch> <span class=highlight></span> <span class=bar></span><label>Branch Location<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.branchLocation.$dirty && Payment.paymentForm.branchLocation.$invalid\"><span class=error-input ng-show=Payment.paymentForm.branchLocation.$error.required ng-bind=Payment.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.bankBranch.$dirty && Payment.paymentForm.bankBranch.$invalid}\"><input type=text ng-model=Payment.formData.bankDetails.bankCity name=bankBranch required autocomplete=off capitalize only-alphabets ng-class={enable:Payment.formData.bankDetails.bankCity} ng-disabled=!Payment.formData.bankDetails.ifsccode ng-readonly=Payment.formData.bankDetails.branchLocation> <span class=highlight></span> <span class=bar></span><label>Branch City<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.bankBranch.$dirty && Payment.paymentForm.bankBranch.$invalid\"><span class=error-input ng-show=Payment.paymentForm.bankBranch.$error.required ng-bind=Payment.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top\" ng-if=Payment.formData.bankDetails.payoutMechanism>Payout Mechanism</label><div class=form-group><div class=selectfield ng-class=\"{error:Payment.paymentForm.payoutMechanism.$dirty && Payment.paymentForm.payoutMechanism.$invalid}\"><select class=\"custom-select select-box\" name=payoutMechanism ng-model=Payment.formData.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in Payment.payoutMechanismList\" required ng-disabled=!Payment.formData.bankDetails.ifsccode ng-class={disablefield:!Payment.formData.bankDetails.ifsccode}><option value=\"\" selected>Payout Mechanism</option></select><span ng-show=\"Payment.paymentForm.payoutMechanism.$dirty && Payment.paymentForm.payoutMechanism.$invalid\"><span class=error-input ng-show=Payment.paymentForm.payoutMechanism.$error.required ng-bind=Payment.validateData.PAYOUT_MECH_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:(Payment.accModelDirty &&\n               (!Payment.formData.bankDetails.accountNumber.split(\'\').length || Payment.formData.bankDetails.accountNumber.split(\'\').length<1))}\"><input type=text ng-model=Payment.formData.bankDetails.accountNumber maxlength=20 name=accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off directive.mask ng-change=Payment.accFocus(); ng-keydown=Payment.copyPasteHandler($event) capitalize ng-disabled=!Payment.formData.bankDetails.ifsccode ng-class={enable:Payment.formData.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=Payment.accModelDirty><span class=error-input ng-show=Payment.paymentForm.accountNumber.$error.required ng-bind=Payment.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(Payment.formData.bankDetails.accountNumber.split(\'\').length !=0 && Payment.formData.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=Payment.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:Payment.paymentForm.verifyAccountNumber.$dirty && Payment.paymentForm.verifyAccountNumber.$invalid}\"><input type=text id=verifyAccountNumber ng-model=Payment.formData.bankDetails.verifyAccountNumber minlength=1 maxlength=20 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=Payment.formData.bankDetails.accountNumber required autocomplete=off ng-keydown=Payment.copyPasteHandler($event) capitalize ng-disabled=!Payment.formData.bankDetails.ifsccode ng-class={enable:Payment.formData.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"Payment.paymentForm.verifyAccountNumber.$dirty && Payment.paymentForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=Payment.paymentForm.verifyAccountNumber.$error.required ng-bind=Payment.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"Payment.paymentForm.verifyAccountNumber.$error.minlength && !Payment.paymentForm.verifyAccountNumber.$error.required\" ng-bind=Payment.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"Payment.paymentForm.verifyAccountNumber.$error.pattern\n          && !Payment.paymentForm.verifyAccountNumber.$error.minlength && !Payment.paymentForm.verifyAccountNumber.$error.required\">{{Payment.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div></div><div ng-if=\"(Payment.formData.bankDetails.pennyDropValid === true ) && Payment.formData.soleApplicantDetail.taxStatusCode === \'01\'\" class=point-to-note>Please Note:<br><ul><li>We shall credit your bank account with Rs 1/- for IMPS verification to check third party validations</li><li>In case of any mismatch the AMC shall be liable for locking further transaction in th folio until proof of correct bank details are provided and verified by AMC</li><li>The list of banks available for registration in the folio has been restricted to only those banks which provide Third Party Verification(TPV) facility. <a ng-click=Payment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</li></ul></div><div class=\"row form-grid\" ng-if=\"Payment.formData.bankDetails.pennyDropValid === false || Payment.formData.soleApplicantDetail.taxStatusCode != \'01\'\"><p><strong>Upload Cheque Leaf <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Account Number and Name should be printed the face of cheque.Max file size should be less than or equal to 2 MB.File format should be tiff, tif, jpg and jpeg extension.\"></i> </strong></p><div class=col-md-6><div class=form-group><span class=\"file-name text-blue\" ng-if=\"Payment.formData.chequeLeafUrl && (Payment.fileType === \'tif\' || Payment.fileType === \'tiff\')\"><a href=javascript:void(0) ng-click=\"Payment.downloadFile(Payment.formData.chequeLeafUrl,Payment.fileType,\'CHEQUE_LEAF\')\">Download</a> </span><span ng-if=\"Payment.formData.chequeLeafUrl && (Payment.fileType == \'jpg\' ||  Payment.fileType == \'jpeg\')\" class=\"file-name text-blue\" ng-click=\"Payment.openUploadedDoc(Payment.formData.chequeLeafUrl,\'CHEQUE_LEAF\')\">{{Payment.chequeLeaf}}</span> <span class=\"upload-button cheque-leaf\"><input id=uploadFileId name=uploadFile type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=Payment.myFile targetimg=showingImgId upload=Payment.uploadFile(file) ng-model=Payment.myFile required><label for=uploadFileId class=\"btn-upload btn-secondary-action\">{{Payment.myFile?\'Change\':\'upload leaf\'}}</label><span class=req>*</span></span></div></div></div><div ng-if=\"Payment.formData.soleApplicantDetail.minor && !Payment.formData.bankDetails.pennyDropValid\" class=point-to-note-tpv>Please Note:<br><ul><li>The list of banks available for registration in the folio has been restricted to only those banks which provide Third Party Verification(TPV) facility. <a ng-click=Payment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</li><li>Nominee details are not applicable for folios where tax status is minor.</li></ul></div><div ng-if=\"!Payment.formData.soleApplicantDetail.minor && !Payment.formData.bankDetails.pennyDropValid\" class=point-to-note-tpv>Please Note:<br><ul><li>The list of banks available for registration in the folio has been restricted to only those banks which provide Third Party Verification(TPV) facility. <a ng-click=Payment.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</li></ul></div><div class=row><div class=col-md-12><div class=\"terms-condition form-group first\" style=\"padding: 20px 0px 0px 40px\"><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=Payment.ischecked required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\" style=\"padding: 20px 0px\">I hereby agree to have read, understood and accept the <a href={{Payment.HDFC_API.WEBSITE_LINK}}information/terms-folio-creation-distributors target=_blank>Terms & condition</a> for investments in HDFC Mutual Fund.</label></div></div></div><div class=\"form-footer form-content clearfix\"><div class=pull-left ng-if=\"Payment.stateForRedirection !== \'soleApplicant.bankDetails\'\"><a class=btn-back ui-sref=\"{{Payment.formData.soleApplicantDetail.minor?\'approval.folio.soleApplicant\':\'approval.folio.nominee\'}}\"><i class=back-arrow-icon></i>Back</a></div><div class=pull-left ng-if=\"Payment.stateForRedirection == \'soleApplicant.bankDetails\'\"><a class=btn-back ui-sref=\"{{Payment.formData.soleApplicantDetail.minor?\'soleApplicant.folio\':\'soleApplicant.nominee\'}}\"><i class=back-arrow-icon></i>Back</a></div><div class=pul-right><button type=button class=\"btn btn-negative-action\" ng-click=Payment.confirmCancelModaltoReject();>Reject Folio</button> <button type=button class=\"btn btn-primary-action btn-next\" ng-show=\"!Payment.formData.chequeLeafUrl && Payment.formData.bankDetails.pennyDropValid && (Payment.formData.soleApplicantDetail.taxStatusCode === \'01\')\" ng-disabled=\"Payment.paymentForm.$invalid || !Payment.ischecked\" ng-click=Payment.validatePennyDrop()>Validate</button> <button type=submit class=\"btn btn-primary-action\" ng-disabled=\"Payment.paymentForm.$invalid || !Payment.formData.chequeLeafUrl ||  !Payment.ischecked\" ng-if=\"Payment.formData.soleApplicantDetail.taxStatusCode != \'01\' || !Payment.formData.bankDetails.pennyDropValid || Payment.formData.chequeLeafUrl\">Approve Folio</button></div></div></div></form></div>");
$templateCache.put("app/investors/summary/folioApproval/index.folioApproval.html","<div class=\"approval main-section\"><h3 class=page-title><small>Folio Creation</small><br><span ng-bind=FolioApprovalParent.headerDetails.name>Investor Name</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li><strong>Distributor Name:</strong> <span ng-bind=FolioApprovalParent.headerDetails.distributorName>Distributor Name</span></li><li><strong>ARN:</strong> <span ng-bind=FolioApprovalParent.headerDetails.distributorArn></span></li></ul></div><ui-view></ui-view></div></div></div>");
$templateCache.put("app/investors/summary/folioApproval/jointHolders.html","<div class=\"box-body folio-approval-investor\" ng-init=FolioApproval.init();><div class=\"clearfix nominee-head\"><h3 class=pull-left>Joint Holders Details</h3></div><div class=\"nominee folio-approval\"><div class=form-content><table class=\"table table-nominee\"><thead><tr><th>&nbsp;</th><th>Name</th><th>PAN</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"data in FolioApproval.jointHolders\"><td class=\"col-md-2 text-black\">{{FolioApproval.enum[$index+1]}} Holder</td><td class=col-md-4><div class=\"input-select input-normal\"><input type=text ng-model=data.jointHolderName capitalize readonly> <span class=highlight></span> <span class=bar></span></div></td><td class=col-md-4><div class=\"col-md-3 input-select input-normal\"><input type=text ng-model=data.jointHolderApplicantDetail.panNumber capitalize readonly> <span class=highlight></span> <span class=bar></span></div></td></tr></tbody></table></div><div class=\"form-footer form-content clearfix\"><div class=pull-left><a class=btn-back ui-sref=\"{{FolioApproval.stateForRedirection == \'soleApplicant.jointHolders\' ? \'soleApplicant.folio\' : \'approval.folio.soleApplicant\'}}\"><i class=back-arrow-icon></i>Back</a></div><div class=pul-right><button type=button class=\"btn btn-negative-action\" ng-click=FolioApproval.confirmCancelModaltoReject();>Reject Folio</button> <button class=\"btn btn-primary-action\" ng-click=FolioApproval.submitJointHolders()>Next</button></div></div></div></div>");
$templateCache.put("app/investors/summary/folioApproval/nominee.html","<div class=\"box-body folio-approval-investor\" ng-init=Nominee.init();><div class=\"clearfix nominee-head nominee-flex\"><h3 class=pull-left ng-hide=Nominee.formData.addNomineeLater>Nominee Details <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip ng-if=\"Nominee.formData.showNomineeUpdate && !Nominee.formData.addNomineeLater\" data-placement={{Main.tooltipClass}} title=\"SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n            states that, in case of Joint Account/Folio: <br>\n            1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n              Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n              inherit the assets as owners.<br>\n            2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n            3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder\"></i></h3><div class=\"pull-right checkbox nominee-space-align add-nominee-later-resp nominee-pad\" ng-if=\" (Nominee.formData.nominees && Nominee.formData.nominees.length==0) || Nominee.showDeclaration\"><input type=checkbox ng-model=Nominee.formData.addNomineeLater ng-click=Nominee.checkAddNominee()> <span class=icon-checkbox></span> <span class=checkbox-text>I hereby declare to opting out of nomination</span></div></div><p class=consent-text style=\"padding: 0px 40px 0\" ng-if=!Nominee.formData.addNomineeLater>I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</p><div class=\"nominee folio-approval\"><!--ng-repeat=\"nomineeData in Nominee.formData.nominees\"\n         ng-if=\"$index == Nominee.currentNominee\"--><form ng-if=!Nominee.formData.addNomineeLater autocomplete=off name=Nominee.nomineeFormUpper novalidate><div class=form-content ng-class=\"{\'nominee-scroll-y\':Nominee.formData.nominees.length > 3}\"><table class=\"table table-nominee\"><thead><tr><th>&nbsp;</th><th>Name</th><th>Proportion</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"data in Nominee.formData.nominees\"><td class=\"col-md-2 text-black\">{{Nominee.enum[$index]}} Nominee</td><td class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$dirty && Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid}\"><input type=text name=nomineeNameList-{{$index}} id=nomineeNameList-{{$index}} ng-model=data.nomineeName ng-change=\"Nominee.changeNomineeName($index, data.nomineeName)\" ng-pattern=/^[a-zA-Z\\s\\.]+$/ required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span> <span ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$dirty && Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$invalid\"><span class=error-input ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=\"Nominee.nomineeFormUpper[\'nomineeNameList-\'+$index].$error.pattern\" ng-bind=Nominee.validateData.NOMINEE_TEXT_ONLY></span></span></div></td><td class=col-md-4><div class=\"col-md-3 input-select input-normal margin-bottom-error\" ng-class=\"{error:Nominee.nomineeFormUpper[\'proportion-\'+$index].$dirty && Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid}\"><input type=number ignore-mouse-wheel max=100 min=1 name=proportion-{{$index}} ng-model=data.percentage ng-change=Nominee.onChangePercentage($index) ng-max=\"Nominee.nomineePropertion[\'max-\'+$index]\" ng-min=\"Nominee.nomineePropertion[\'min\']\" ng-model-options=\"{updateOn: \'default\' , allowInvalid:\'true\'}\" ng-keydown=Nominee.checkDecimal($event) ng-paste=Nominee.onPaste($event) required><!--is-number--> <span class=input-side-symbol>%</span> <span class=highlight></span> <span class=bar></span> <span class=\"error-input nominee-error\" ng-if=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.min\" ng-bind=Nominee.validateData.PROPORTION_NOT_ZERO></span><!--<label>Name<span ng-if=\"nomineeData.nomineeNameList\" class=\"req\">*</span></label>--> <span ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$dirty && Nominee.nomineeFormUpper[\'proportion-\'+$index].$invalid\"><span class=error-input ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_PROPORTION_REQUIRED></span> </span><span class=\"error-input nominee-proportion-error\" ng-show=\"Nominee.nomineeFormUpper[\'proportion-\'+$index].$error.max\" ng-bind=Nominee.validateData.NOMINEE_PROPORTION></span></div></td><td class=col-md-2 ng-if=\"$index>0\"><i class=delete-icon ng-click=Nominee.deleteCurrentNominee($index)></i></td></tr></tbody></table><div ng-disabled=true class=\"pull-right add-another-nominee add-another-nominee-desktop\" role=button ng-if=\"!Nominee.showNomineeUpdate && (Nominee.formData.nominees.length<Nominee.allowedNomineeLength) || Nominee.showNomineeUpdate && (Nominee.showAddNomineeLink && Nominee.formData.nominees.length<Nominee.allowedNomineeLength)\"><strong ng-show=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" ng-click=Nominee.showMessage()>+ Add Another Nominee</strong> <a ng-hide=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" href=javascript:void(0) ng-click=Nominee.addMoreNominee(); class=\"text-blue add-nominee-resp\"><strong>+ Add Another Nominee</strong></a></div></div></form><form autocomplete=off name=nomineeForm ng-submit=Nominee.submitNominee() novalidate><div class=\"mark-default opt-out-align-smartlink\" ng-if=Nominee.formData.addNomineeLater><div class=\"checkbox mob-res\" style=\"padding-right: 10px\"><input type=checkbox ng-model=Nominee.formData.addOptOut required> <i class=icon-checkbox></i></div><div><ng-bind-html dynamic=Nominee.dynamicDataForOptOutDec></ng-bind-html></div></div><div ng-if=!Nominee.formData.addNomineeLater class=\"tab-container form-content\"><ul class=\"nav nav-tabs nominee-tab-container\" ng-class=\"{\'update-width\': Nominee.showNomineeUpdate && (Nominee.formData.nominees.length < Nominee.allowedNomineeLength)}\"><li role=button tabindex={{$index}} ng-repeat=\"nomineeData in Nominee.formData.nominees\" ng-click=\"Nominee.switchNominee($index,nomineeData.panNumber,nomineeData.guardianPanNumber,nomineeData.drivingLicense,nomineeData.aadharCard, nomineeData.passport)\" ng-class=\"{\'active\':Nominee.currentNominee === $index}\">{{Nominee.enum[$index]}} Nominee</li></ul><div ng-disabled=true class=\"pull-right add-another-nominee add-other-nominee\" role=button ng-if=\"!Nominee.showNomineeUpdate && (Nominee.formData.nominees.length<Nominee.allowedNomineeLength) || Nominee.showNomineeUpdate && (Nominee.showAddNomineeLink && Nominee.formData.nominees.length<Nominee.allowedNomineeLength)\"><strong ng-show=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" ng-click=Nominee.showMessage()>+ Add Another Nominee</strong> <a ng-hide=\"Nominee.nomineeFormUpper.$invalid ||nomineeForm.$invalid\" href=javascript:void(0) ng-click=Nominee.addMoreNominee(); class=\"text-blue add-nominee-resp\"><strong>+ Add Another Nominee</strong></a></div></div><div ng-if=!Nominee.formData.addNomineeLater class=add-nominee-details ng-repeat=\"nomineeData in Nominee.formData.nominees\"><div ng-show=\"Nominee.currentNominee === $index\"><div class=form-content><p><strong>Personal Details of Nominee</strong></p><div><div class=\"checkbox opting-out\"><input type=checkbox ng-model=nomineeData.minor ng-click=Nominee.changeNomineeIsMinor($index)> <span class=icon-checkbox></span> <span class=checkbox-text>The Nominee Is Minor</span></div></div><br><div class=\"row flex-nominee-detail\"><div class=\"col-md-4 col-xs-12\"><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm[\'nomineeName-\'+$index].$dirty && nomineeForm[\'nomineeName-\'+$index].$invalid}\"><input type=text ng-model=nomineeData.nomineeName name=nomineeName id=nomineeName-{{$index}} ng-change=\"Nominee.changeNomineeName($index, nomineeData.nomineeName)\" required autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Name<span ng-if=nomineeData.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm[\'nomineeName-\'+$index].$dirty && nomineeForm[\'nomineeName-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeName-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAME_REQUIRED></span></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=!Nominee.formData.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=nomineePan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.panNumber ng-change=Nominee.checkDuplicateNomineePan($index,nomineeData.panNumber,nomineeData.guardianPanNumber); ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ > <span ng-show=\"nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID></span> <span class=error-input ng-if=\"nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Nominee</label><span class=error-input ng-if=\"nomineeData.nomineePanInvalid && nomineeData.panNumber\" ng-bind=Nominee.errorMessage></span></div></div><div class=\"col-md-4 col-xs-12\"><div class=input-normal ng-if=nomineeData.minor><input type=text style=\"z-index: 0 !important\" id=nomineeDOBId-{{$index}} date-calendar data-enable=true date-default=Nominee.defaultDateNominee format=DD-MMM-YYYY data-min-date=Nominee.dataMinDate1 data-max-date=Nominee.dataMaxDate1 showdefault=\"\'true\'\" viewmode=days maxdate=now data-on-date-change=Nominee.changeStartDateNominee name=dob-{{$index}} autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label style=z-index:2>DOB - DD/MMM/YYYY</label><span ng-if=nomineeData.nomineeName class=req>*</span> <span ng-show=\"nomineeForm[\'nomineeDOBId-\'+$index].$dirty && nomineeForm[\'nomineeDOBId-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeDOBId-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_DOB_REQUIRED></span></span></div><div class=input-normal ng-if=!nomineeData.minor><input type=text style=\"z-index: 0 !important\" id=nomineeDOBId-{{$index}} date-calendar data-enable=true date-default=Nominee.defaultDateNominee format=DD-MMM-YYYY showdefault=\"\'true\'\" viewmode=days data-min-date=Nominee.dataMinDate data-max-date=Nominee.dataMaxDate maxdate=now data-on-date-change=Nominee.changeStartDateNominee name=dob-{{$index}} autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label style=z-index:2>DOB - DD/MMM/YYYY</label><span ng-show=\"nomineeForm[\'nomineeDOBId-\'+$index].$dirty && nomineeForm[\'nomineeDOBId-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeDOBId-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_DOB_REQUIRED></span></span></div></div><!--            </div>--><!--            <div class=\"row\">--><div class=\"col-md-4 col-xs-12\"><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'nomineeRelation-\'+$index].$dirty && nomineeForm[\'nomineeRelation-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=nomineeRelation-{{$index}} ng-model=nomineeData.nomineeRelation ng-init=\"nomineeData.nomineeRelation=nomineeData.nomineeRelation?nomineeData.nomineeRelation:null\" ng-options=\"relationship.value as relationship.relationDesc for relationship in Nominee.relationshipsList\" ng-change=\"Nominee.changeNomineeRelation(nomineeData.nomineeRelation, $index)\" required><option value=\"\" selected>Relationship with Applicant</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeRelation class=ng-scope>Relationship with Applicant</label><span ng-if=nomineeData.nomineeName class=req>*</span> <span ng-show=\"nomineeForm[\'nomineeRelation-\'+$index].$dirty && nomineeForm[\'nomineeRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeRelation-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_RELATION_REQUIRED></span></span></div></div><!-- Show Nominee Update started--><!--              <div class=\"col-md-4 col-xs-12\" ng-if=\"nomineeData.nomineeRelation == \'OTHERS\' && Nominee.formData.showNomineeUpdate\">--><!--                <div class=\"input-normal\" ng-class=\"{error:nomineeForm[\'nomineeOtherRelation-\'+$index].$dirty && nomineeForm[\'nomineeOtherRelation-\'+$index].$invalid}\">--><!--                  <input type=\"text\"--><!--                         name=\"nomineeOtherRelation-{{$index}}\" autocomplete=\"off\"--><!--                         ng-model=\"nomineeData.nomineeOtherRelation\" ng-maxlength=\"50\" limit-to=\"50\" maxlength=\"50\" only-alphabets--><!--                         ng-required=\"nomineeData.nomineeRelation == \'OTHERS\' && Nominee.formData.showNomineeUpdate\"--><!--                  >--><!--                  <span--><!--                    ng-show=\"nomineeForm[\'nomineeOtherRelation-\'+$index].$dirty && nomineeForm[\'nomineeOtherRelation-\'+$index].$invalid\">--><!--                  <span class=\"error-input\" ng-if=\"nomineeForm[\'nomineeOtherRelation-\'+$index].$error.required\"--><!--                        ng-bind=\"Nominee.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER\"></span>--><!--                  </span>--><!--                  <label class=\"dob-add-nominee\" style=\"z-index: 0\">Others (please specify) <span ng-if=\"nomineeData.nomineeRelation == \'OTHERS\'\" class=\"req\">*</span></label>--><!--                </div>--><!--              </div>--><!--    Nominee Email   --><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineeEmail-\'+$index].$dirty && nomineeForm[\'nomineeEmail-\'+$index].$invalid}\"><input type=email name=nomineeEmail-{{$index}} autocomplete=off ng-model=nomineeData.emailId ng-pattern=Nominee.CONST.email_regex ng-change=\"Nominee.changeEmailId($index ,nomineeData.emailId)\" maxlength=256 ng-maxlength=256 limit-to=256 autocomplete=off ng-required=Nominee.formData.showNomineeUpdate> <span ng-show=\"nomineeForm[\'nomineeEmail-\'+$index].$dirty && nomineeForm[\'nomineeEmail-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineeEmail-\'+$index].$error.required\" ng-bind=Nominee.validateData.EMAIL_FIELD></span> <span class=error-input ng-if=\"nomineeForm[\'nomineeEmail-\'+$index].$error.required\" ng-bind=Nominee.validateData.EMAIL_REQUIRED></span> </span><span class=error-input ng-show=\"!nomineeForm[\'nomineeEmail-\'+$index].$invalid && Nominee.formData.nominees[$index].emailIdInvalid\">{{Nominee.errorMessageEmail}}</span><label class=dob-add-nominee style=\"z-index: 0\">Nominee Email ID <span ng-if=Nominee.formData.showNomineeUpdate class=req>*</span></label></div></div><!--Nominee Mobile Number--><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.showNomineeUpdate><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineeMobile-\'+$index].$dirty && nomineeForm[\'nomineeMobile-\'+$index].$invalid}\"><input type=text name=nomineeMobile-{{$index}} autocomplete=off ng-model=nomineeData.mobileNumber ng-change=\"Nominee.changeMobileNumber($index, nomineeData.mobileNumber)\" autocomplete=off ng-pattern=Nominee.CONST.mobile_regex_new minlength=1 maxlength=15 required> <span ng-show=\"nomineeForm[\'nomineeMobile-\'+$index].$dirty && nomineeForm[\'nomineeMobile-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineeMobile-\'+$index].$error.required\" ng-bind=Nominee.validateData.MOBILE_FIELD></span> <span class=error-input ng-if=\"nomineeForm[\'nomineeMobile-\'+$index].$error.required\" ng-bind=Nominee.validateData.MOBILE_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">Nominee Mobile No. <span ng-if=Nominee.formData.showNomineeUpdate class=req>*</span></label></div></div><!--    personal Identifier     --><div class=\"col-md-4 col-xs-12\" ng-if=Nominee.formData.showNomineeUpdate><div class=\"input-select input-normal selectfield select-data mgt7\" ng-class=\"{error:nomineeForm[\'nomineeIdentityProof-\'+$index].$dirty && nomineeForm[\'nomineeIdentityProof-\'+$index].$invalid}\"><select name=nomineeIdentityProof-{{$index}} class=custom-select ng-model=nomineeData.identityProofType ng-init=\"nomineeData.identityProofType = nomineeData.identityProofType ? nomineeData.identityProofType : null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in nomineeData.identityProofList\" ng-change=Nominee.changeNomineeIdentityProof($index,nomineeData.identityProofType) required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><label ng-if=nominee.relation style=\"display: block\" class=margin-top-label>Personal Identifier of Nominee</label><span class=\"req text-red\">*</span> <span ng-show=\"nomineeForm[\'nomineeIdentityProof-\'+$index].$dirty && nomineeForm[\'nomineeIdentityProof-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'nomineeIdentityProof-\'+$index].$error.required\">{{Nominee.validateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.showNomineeUpdate && nomineeData.identityProofType === \'PAN_CARD\'\"><div class=input-normal ng-class=\"{error:nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=nomineePan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.nomineePan ng-change=Nominee.checkDuplicateNomineePan($index,nomineeData.nomineePan,nomineeData.guardianPan); ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ maxlength=10 ng-maxlength=10 limit-to=10 required> <span ng-show=\"nomineeForm[\'nomineePan-\'+$index].$dirty && nomineeForm[\'nomineePan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID_ERROR></span> <span class=error-input ng-if=\"nomineeForm[\'nomineePan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Nominee <span class=\"req text-red\">*</span></label><span class=error-input ng-if=\"nomineeData.nomineePanInvalid && nomineeData.nomineePan\" ng-bind=Nominee.errorMessage></span><!--                      <span class=\"error-input\" ng-show=\"!nomineeForm[\'nomineePan-\'+$index].$invalid && Nominee.isDuplicate\">--><!--                        {{Nominee.errorMessagePanIdentity}}--><!--                      </span>--></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.showNomineeUpdate && nomineeData.identityProofType === \'DRIVING_LICENSE\'\"><div class=\"input-normal input-other\" ng-class=\"{error: nomineeForm[\'drivingLicense-\'+$index].$dirty && nomineeForm[\'drivingLicense-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.drivingLicense ng-model=nomineeData.drivingLicense name=drivingLicense-{{$index}} ng-change=Nominee.changeDrivingLicense($index,nomineeData.drivingLicense); maxlength=35 ng-maxlength=35 limit-to=35 autocomplete=off required><label>Nominee Driving License No. <span class=\"req text-red\">*</span></label><span ng-show=\"nomineeForm[\'drivingLicense-\'+$index].$dirty && nomineeForm[\'drivingLicense-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'drivingLicense-\'+$index].$error.required || nomineeForm[\'drivingLicense-\'+$index].$error.pattern\">{{Nominee.validateData.VALID_DRIVING_LICENCE}} </span></span><span class=error-input ng-if=\"nomineeData.nomineeDLInvalid && nomineeData.drivingLicense\" ng-bind=Nominee.errorMessageDLIdentity></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.showNomineeUpdate && nomineeData.identityProofType === \'AADHAR_CARD\'\"><div class=\"input-normal input-other aadhaar-pd\" ng-class=\"{error: nomineeForm[\'aadharCard-\'+$index].$dirty && nomineeForm[\'aadharCard-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.aadharCard ng-model=nomineeData.aadharCard name=aadharCard-{{$index}} ng-change=Nominee.changeAadharCard($index,nomineeData.aadharCard); maxlength=4 ng-maxlength=4 limit-to=4 ng-pattern=Nominee.CONST.valid_4_digit_aadhar_regex autocomplete=off capitalize required><label>Nominee Aadhaar No.<span class=\"req text-red\">*</span></label><span class=arn style=\"top:13px;color: grey;font-size: large\">XXXX XXXX </span><span ng-show=\"nomineeForm[\'aadharCard-\'+$index].$dirty && nomineeForm[\'aadharCard-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'aadharCard-\'+$index].$error.pattern || nomineeForm[\'aadharCard-\'+$index].$error.required\">{{Nominee.validateData.AADHAAR_INVALID}} </span></span><!--                      <span class=\"error-input\" ng-show=\"!nomineeForm[\'aadharCard-\'+$index].$invalid && Nominee.isDuplicate\">--><!--                        {{Nominee.errorMessageAadharIdentity}}--><!--                      </span>--> <span class=error-input ng-if=\"nomineeData.nomineeAadharInvalid && nomineeData.aadharCard\" ng-bind=Nominee.errorMessageDLIdentity></span></div></div><div class=\"col-md-4 col-xs-12\" ng-if=\"Nominee.formData.showNomineeUpdate && nomineeData.identityProofType === \'PASSPORT\'\"><div class=\"input-normal input-other\" ng-class=\"{error: nomineeForm[\'passport-\'+$index].$dirty && nomineeForm[\'passport-\'+$index].$invalid}\"><input type=text ng-bind=nomineeData.passport ng-model=nomineeData.passport name=passport-{{$index}} ng-change=Nominee.changePassport($index,nomineeData.passport); maxlength=35 ng-maxlength=35 limit-to=35 autocomplete=off required><label>Nominee Passport<span class=\"req text-red\">*</span></label><span ng-show=\"nomineeForm[\'passport-\'+$index].$dirty && nomineeForm[\'passport-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'passport-\'+$index].$error.required\">{{Nominee.validateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-if=\"nomineeData.nomineePassportInvalid && nomineeData.passport\" ng-bind=Nominee.errorMessagePassportIdentity></span></div></div></div><div class=row><div class=\"col-md-4 mgb15\"></div></div></div><!--<div class=\"form-content\">\n            <div class=\"row\">\n              <div class=\"col-md-4\">\n                    <span class=\"checkbox nominee-checkbox\">\n                      <input type=\"checkbox\" ng-model=\"nomineeData.soleAddressApplicable\"\n                             name=\"soleAddressApplicable-{{$index}}\"\n                             id=\"soleAddressApplicable-{{$index}}\"\n                             autocomplete=\"off\">\n              <span class=\"icon-checkbox\"></span>\n            </span>\n                <label style=\"bottom:5px;position:relative\">Address Same As Investor</label>\n              </div>\n            </div>\n          </div>--><div class=form-content ng-if=!nomineeData.minor ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p><strong>Address Details of Nominee</strong></p><div class=\"row mgb20\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.addressLine1 name=addressLine1-{{$index}} autocomplete=off ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 1<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'addressLine1-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ADDRESSLINE1_REQUIRED></span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine2-\'+$index].$dirty && nomineeForm[\'addressLine2-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.addressLine2 name=addressLine2 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'country-\'+$index].$dirty && nomineeForm[\'country-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=country-{{$index}} ng-model=nomineeData.nomineeAddress.country ng-change=Nominee.changeNomineeSelectedCountry($index,nomineeData.nomineeAddress.country) ng-options=\"country.countryCode as country.countryName for country in Nominee.countryList\" ng-init=\"nomineeData.nomineeAddress.country=nomineeData.nomineeAddress.country?nomineeData.nomineeAddress.country:null\" ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" easyassist-key=mask-element><option value=\"\" selected>Country of Birth</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeAddress.country class=ng-scope>Country of Birth</label><!--                  <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span> <span ng-show=\"nomineeForm[\'country-\'+$index].$dirty && nomineeForm[\'country-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'country-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_COUNTRY_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-model=nomineeData.nomineeAddress.state ng-options=\"_state.stateCode as _state.stateName for _state in Nominee.stateList\" ng-init=\"nomineeData.nomineeAddress.state=nomineeData.nomineeAddress.state?nomineeData.nomineeAddress.state:null\" ng-disabled=\"nomineeData.nomineeAddress.country != \'IN\'\" class=custom-select ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Select State</option></select><label style=\"display: block\" ng-if=nomineeData.nomineeAddress.state>STATE</label><span class=\"req text-red\" ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span> <span ng-show=\"nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'state-\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.city ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'city-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_CITY_REQUIRED></span> </span><!--<div ng-if=\"nomineeData.nomineeAddress.country === \'India\'&&nomineeData.nomineeAddress.city&&Nominee.cityList.length\" class=\"suggestion box-shadow\">\n                    <ul><li ng-repeat=\"_data in Nominee.cityList|filterCity:nomineeData.nomineeAddress.city track by $index\" ng-click=\"Nominee.selectNomineeBirthCity(_data,nomineeData)\"> {{_data.cityName}}</li></ul>\n                  </div>--></div></div><div class=col-md-4><div class=\"input-normal mgt13\" ng-class=\"{error:nomineeForm[\'pinCode-\'+$index].$dirty && nomineeForm[\'pinCode-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.nomineeAddress.pinCode name=pinCode-{{$index}} autocomplete=off onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" maxlength=6 minlength=6 is-number ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\"> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'pinCode-\'+$index].$dirty && nomineeForm[\'pinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'pinCode-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ZIP_REQUIRED></span></span></div></div></div></div><div class=\"form-content nominee-review\" ng-if=nomineeData.minor><p><strong>Details of Nominee’s guardian</strong></p><div class=row style=margin-bottom:6px><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianName-\'+$index].$dirty && nomineeForm[\'guardianName-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element ng-model=nomineeData.guardianName name=guardianName-{{$index}} ng-pattern=/^[a-zA-Z\\s\\.]+$/ autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Name of the guardian<span class=req>*</span></label><span ng-show=\"nomineeForm[\'guardianName-\'+$index].$dirty && nomineeForm[\'guardianName-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianName-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_NAMEGUARDIAN_REQUIRED></span> <span class=error-input ng-show=\"nomineeForm[\'guardianName-\'+$index].$error.pattern\" ng-bind=Nominee.validateData.GUARDIAN_TEXT_ONLY></span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'guardianRelation-\'+$index].$dirty && nomineeForm[\'guardianRelation-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=custom-select name=guardianRelation-{{$index}} ng-model=nomineeData.guardianRelationWithNominee ng-init=\"nomineeData.guardianRelationWithNominee=nomineeData.guardianRelationWithNominee?nomineeData.guardianRelationWithNominee:null\" ng-options=\"relationship.value as relationship.relationDesc for relationship in Nominee.guardianRelationShipList\" required><option value=\"\" selected>Guardian\'s Relationship with Nominee</option></select><span class=req>*</span><label style=\"display: block\" ng-if=nomineeData.guardianRelationWithNominee>Guardian\'s Relationship with Nominee</label><span ng-show=\"nomineeForm[\'guardianRelation-\'+$index].$dirty && nomineeForm[\'guardianRelation-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianRelation-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_RELATIONSHIP></span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianPan-\'+$index].$dirty && nomineeForm[\'guardianPan-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text maxlength=10 ng-maxlength=10 limit-to=10 name=guardianPan-{{$index}} autocomplete=off capitalize ng-model=nomineeData.guardianPanNumber ng-change=Nominee.checkUniqueGuardianPan($index,nomineeData.guardianPanNumber,true) ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ > <span ng-show=\"nomineeForm[\'guardianPan-\'+$index].$dirty && nomineeForm[\'guardianPan-\'+$index].$invalid\"><span class=error-input ng-if=\"!nomineeForm[\'guardianPan-\'+$index].$error.required\" ng-bind=Nominee.validateData.PAN_VALID></span> <span class=error-input ng-if=\"nomineeForm[\'guardianPan-\'+$index].$error.required\" ng-bind=Nominee.validateData.GUARDIAN_PAN_REQUIRED></span></span><label class=dob-add-nominee style=\"z-index: 0\">PAN Of Guardian<!--                    <span class=\"req\">*</span>--></label><span class=error-input ng-if=\"(nomineeData.guardianPanInvalid || !nomineeData.verifiedPan) && nomineeData.guardianPanNumber\" ng-bind=Nominee.errorMessageGuardian></span></div></div></div><div ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p><strong>Address Details of Nominee’s guardian</strong></p><div class=row style=\"margin-bottom: 12px\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'guardianAddress1-\'+$index].$dirty && nomineeForm[\'guardianAddress1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element name=guardianAddress1-{{$index}} ng-model=nomineeData.guardianAddress.addressLine1 ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line1<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'guardianAddress1-\'+$index].$dirty && nomineeForm[\'guardianAddress1-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianAddress1-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ADDRESSLINE1_REQUIRED></span></span></div></div><div class=col-md-4><div class=input-normal><input type=text name=guardinaAddress1-{{$index}} easyassist-key=mask-element ng-model=nomineeData.guardianAddress.addressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line2</label></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'guardianCountry-\'+$index].$dirty && nomineeForm[\'guardianCountry-\'+$index].$invalid && nomineeData.nomineeName}\"><select class=\"browser-default custom-select\" name=guardianCountry-{{$index}} easyassist-key=mask-element ng-model=nomineeData.guardianAddress.country ng-change=Nominee.changeSelectedCountry($index,nomineeData.guardianAddress.country) ng-options=\"country.countryCode as country.countryName for country in Nominee.countryList\" ng-init=\"nomineeData.guardianAddress.country=nomineeData.guardianAddress.country?nomineeData.guardianAddress.country:null\" ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Country of Birth</option></select><label style=\"display: block\" ng-if=nomineeData.guardianAddress.country class=ng-scope>Country of Birth</label><!--                  <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span> <span ng-show=\"nomineeForm[\'guardianCountry-\'+$index].$dirty && nomineeForm[\'guardianCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianCountry-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_COUNTRY_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield select-data\" ng-class=\"{error:nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid}\"><select name=state-{{$index}} ng-model=nomineeData.guardianAddress.state ng-options=\"_state.stateCode as _state.stateName for _state in Nominee.stateList\" ng-disabled=\"nomineeData.guardianAddress.country != \'IN\'\" ng-init=\"nomineeData.guardianAddress.state=nomineeData.guardianAddress.state?nomineeData.guardianAddress.state:null\" class=custom-select ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\"><option value=\"\" selected>Select State</option></select><label style=\"display: block\" ng-if=nomineeData.guardianAddress.state>STATE</label><!--                  <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req text-red\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span> <span ng-show=\"nomineeForm[\'state-\'+$index].$dirty && nomineeForm[\'state-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'state-\'+$index].$error.required\">{{Nominee.validateData.STATE_REQUIRED}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13\" ng-class=\"{error:nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=guardianCity easyassist-key=mask-element ng-model=nomineeData.guardianAddress.city ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'guardianCity-\'+$index].$dirty && nomineeForm[\'guardianCity-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardianCity-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_CITY_REQUIRED></span></span></div></div><div class=col-md-4><div class=\"input-normal mgt13\" ng-class=\"{error:nomineeForm[\'guardinaPinCode-\'+$index].$dirty && nomineeForm[\'guardinaPinCode-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text easyassist-key=mask-element name=guardinaPinCode-{{$index}} ng-model=nomineeData.guardianAddress.pinCode minlength=6 maxlength=6 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\" autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<!--                    <span ng-if=\"!nomineeData.soleAddressApplicable\" class=\"req\">*</span>--> <span class=req ng-if=\"Nominee.formData.showNomineeUpdate && !nomineeData.soleAddressApplicable\">*</span></label><span ng-show=\"nomineeForm[\'guardinaPinCode-\'+$index].$dirty && nomineeForm[\'guardinaPinCode-\'+$index].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'guardinaPinCode-\'+$index].$error.required\" ng-bind=Nominee.validateData.NOMINEE_ZIP_REQUIRED></span></span></div></div></div></div></div></div></div><!--      --><div ng-if=!Nominee.formData.addNomineeLater class=add-nominee-details><div><div class=\"form-content nominee-statement\" ng-if=Nominee.formData.showNomineeUpdate><div class=row><div class=col-md-12><p><strong>Statement of Holding (Account Statement) Declaration <span class=req>*</span></strong></p><p class=text-black>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</p><div><div class=\"radio-block flex-radio\"><div class=row><div class=col-md-4><span class=radio><input type=radio ng-model=Nominee.formData.nomination ng-change=Nominee.setStatement() name=nomineeName id=nomineeName autocomplete=off ng-value=true required> <span class=check></span></span><label>Nomination: Yes</label></div></div><div class=row><div class=col-md-4><span class=radio><input type=radio ng-model=Nominee.formData.nomination ng-change=Nominee.setStatement() name=nomination id=nomination autocomplete=off ng-value=false> <span class=check></span></span><label>Nomination: No</label></div></div></div></div></div></div></div><!--<div class=\"form-content statement-declaration\"  ng-if=\"Nominee.formData.showNomineeUpdate && Nominee.formData.holdMode !== \'ANY_OR_SURVIVOR\'\">\n            <p class=\"section-title\">Incapacitation Declaration (Optional)\n              <i class=\"tooltip-info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"\n                 data-placement=\"{{Main.tooltipClass}}\"\n                 title=\'<div>\n                  SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                  a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                  b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                  c) change such mandate any number of times without any restriction. <br/>\n                </div>\'>\n              </i>\n            </p>\n            <div class=\"declaration-content\">\n              <div class=\"row\">\n                <div class=\"col-md-12 pdLeft35\">\n                <span>I hereby authorize\n                  <select class=\"browser-default custom-select\" name=\"selectNomineeName\" easyassist-key=\"mask-element\"\n                          ng-model=\"Nominee.formData.incapacitationDeclarationNameList\"\n                          ng-init=\"Nominee.formData.incapacitationDeclarationNameList=Nominee.formData.incapacitationDeclarationNameList? Nominee.formData.incapacitationDeclarationNameList:null\"\n                          ng-options=\"nominee as nominee.nomineeCode disable when (nominee.activeFlag) for nominee in Nominee.formData.incapacitationNameList track by nominee.nomineeCode\"\n                          ng-change = \"Nominee.changeSelectedName(Nominee.formData.incapacitationDeclarationNameList)\"\n                          ng-disabled=\"!Nominee.hasNomineeName()\"\n\n                  >\n                    <option value=\"\" selected>Select Nominee Name</option>\n                  </select>\n                  (nominee number <input type=\"text\" ng-model=\"Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number readonly/>)\n                  to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up\n                  to <input type=\"text\" ng-model=\"Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage\" name=\"percentage\" is-number maxlength=\"3\"\n                            ng-required=\"Nominee.formData.incapacitationDeclarationNameList && !Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-pattern=\"/^(100|[1-9]?[0-9])$/\"\n                            ng-disabled=\"Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.amount || !Nominee.formData.incapacitationDeclarationNameList\"\n                            ng-change=\"Nominee.changePercentageOrAmount(\'percentage\')\"\n                  >% of assets in the account / folio\n                  or Rs. <input type=\"text\" ng-model=\"Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.amount\" name=\"allowedAmount\" ng-pattern=\"/^[1-9]\\d*$/\"\n                                is-number maxlength=\"20\" ng-disabled = \"Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage || !Nominee.formData.incapacitationDeclarationNameList\"\n                                ng-change=\"Nominee.changePercentageOrAmount(\'amount\')\"\n                                ng-required=\"Nominee.formData.incapacitationDeclarationNameList && !Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage\">.\n                </span>\n\n                  &lt;!&ndash; Error shown&ndash;&gt;\n                  <span ng-show=\"nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid\">\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage < 1\">\n                    Amount/percentage cannot be less than 1.\n                  </span>\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && Nominee.formData.nomineeRegistrationCO.incapacitationDeclaration.percentage > 100\">\n                    Percentage cannot be more than 100%.\n                  </span>\n                </span>\n                  <span ng-show=\"(nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'allowedAmount\'].$dirty && nomineeForm[\'allowedAmount\'].$invalid)\">\n                  <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.required || nomineeForm[\'allowedAmount\'].$error.required\">\n                    Please enter the percentage or Rs. that can be encashed by the nominee.\n                  </span>\n                </span>\n                </div>\n              </div>\n            </div>\n          </div>--></div></div><div class=\"form-footer form-content clearfix\"><div class=pull-left><a class=btn-back ng-if=\"Nominee.formData.jointHolders.length>0\" ui-sref=\"{{Nominee.stateForRedirection == \'soleApplicant.nominee\' ? \'soleApplicant.jointHolders\' : \'approval.folio.jointHolders\'}}\"><i class=back-arrow-icon></i>Back</a> <a class=btn-back ng-if=\"!(Nominee.formData.jointHolders.length>0)\" ui-sref=\"{{Nominee.stateForRedirection == \'soleApplicant.nominee\' ? \'soleApplicant.folio\' :\'approval.folio.soleApplicant\'}}\"><i class=back-arrow-icon></i>Back</a></div><div class=pul-right><button type=button class=\"btn btn-negative-action\" ng-click=Nominee.confirmCancelModaltoReject();>Reject Folio</button> <button class=\"btn btn-primary-action\" ng-disabled=\"Nominee.nomineeFormUpper.$invalid||nomineeForm.$invalid || Nominee.buttonEnable() || Nominee.validateAllDOB || (Nominee.formData.showNomineeUpdate && !Nominee.emailIdValid && !Nominee.formData.addNomineeLater)\">Next</button></div></div></form></div></div>");
$templateCache.put("app/investors/summary/folioApproval/rejected.html","<div class=\"box-body rejected-folio\" ng-init=Rejected.init();><p><i class=success-tick-icon></i><span>Rejected</span><br>You have rejected the folio creation request</p><!--Folio--><!--<p><i class=\"success-tick-icon\"></i><span>Rejected</span><br/>--><!--You have rejected the FOLIO creation</p>--></div>");
$templateCache.put("app/investors/summary/folioApproval/soleApplicant-summary.html","<!--<hdfc-header></hdfc-header>--><header class=\"container-fluid summary-header affix\" ng-if=FolioApprovalParent.isLoaded><div><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/logo.png href=/dashboard></span></div></header><div class=\"approval main-section\" ng-if=FolioApprovalParent.isLoaded><h3 class=page-title><small>Folio Creation</small><br><span ng-bind=FolioApprovalParent.headerDetails.name>Investor Name</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li><strong>Distributor Name:</strong> <span ng-bind=FolioApprovalParent.headerDetails.distributorName>Distributor Name</span></li><li><strong>ARN:</strong> <span ng-bind=FolioApprovalParent.headerDetails.distributorArn></span></li></ul></div><ui-view></ui-view></div></div></div><footer class=\"summary-footer main-footer\" ng-if=FolioApprovalParent.isLoaded><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{Investors.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer>");
$templateCache.put("app/investors/summary/folioApproval/soleApplicant.html","<div class=\"box-body folio-approval-investor\" ng-init=FolioApproval.init();><form autocomplete=off name=FolioApproval.soleApplicantForm ng-submit=FolioApproval.submitApplicantDetails() novalidate><h3 ng-if=!FolioApproval.formData.soleApplicantDetail.minor>Sole Applicant Details</h3><h3 ng-if=FolioApproval.formData.soleApplicantDetail.minor>Folio Creation: <span class=text-black>Minor</span></h3><div class=\"sole-applicant folio-approval\"><div class=form-content><div class=row><div class=col-md-6><div><p><strong>Email ID :</strong><strong easyassist-key=mask-element>{{FolioApproval.formData.soleApplicantDetail.email}}</strong></p></div><div class=row style=\"margin-bottom: 12px\"><div class=\"col-md-12 mobile-view\"><span style=\"margin-right: 15px\"><strong>Email Id Belongs To</strong></span><select class=\"browser-default custom-select select-width\" name=emailBelongsTo ng-model=FolioApproval.formData.soleApplicantDetail.emailBelongsTo ng-init=\"FolioApproval.formData.soleApplicantDetail.emailBelongsTo = FolioApproval.formData.soleApplicantDetail.emailBelongsTo ? FolioApproval.formData.soleApplicantDetail.emailBelongsTo :null\" ng-options=\"email.familyCode as email.familyDescription for email in FolioApproval.emaillList\" required><option value=\"\" selected>Select Value</option></select></div></div></div><div class=col-md-6><div><p><strong>Mobile No :</strong><strong easyassist-key=mask-element> {{FolioApproval.formData.soleApplicantDetail.mobileNo}}</strong></p></div><div class=row style=\"margin-bottom: 12px\"><div class=\"col-md-12 mobile-view\"><span style=\"margin-right: 15px\"><strong>Mobile No. Belongs To</strong></span><select class=\"browser-default custom-select select-width\" name=mobileBelongsTo ng-model=FolioApproval.formData.soleApplicantDetail.mobileBelongsTo ng-init=\"FolioApproval.formData.soleApplicantDetail.mobileBelongsTo = FolioApproval.formData.soleApplicantDetail.mobileBelongsTo ? FolioApproval.formData.soleApplicantDetail.mobileBelongsTo :null\" ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in FolioApproval.mobileList\" required><option value=\"\" selected>Select Value</option></select></div></div></div></div><div class=row ng-if=FolioApproval.formData.soleApplicantDetail.minor><!--<div class=\"form-label mr20 mrb20 col-md-12\"><strong>Minor’s Details</strong></div>--><div class=\"col-md-4 select-pdt10\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.gender.$dirty && FolioApproval.soleApplicantForm.gender.$invalid}\"><select class=\"browser-default custom-select\" name=gender ng-model=FolioApproval.formData.soleApplicantDetail.gender ng-init=\"FolioApproval.gender= FolioApproval.gender ? FolioApproval.gender: null\" ng-options=\"data.key as data.value for data in FolioApproval.genderList\" required><option value=\"\" selected>Gender</option></select><label ng-if=FolioApproval.gender>Gender</label><span ng-show=\"FolioApproval.soleApplicantForm.gender.$dirty && FolioApproval.soleApplicantForm.gender.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.gender.$error.required ng-bind=FolioApproval.validateData.GENDER_REQUIRED></span> </span><span class=\"req text-red\">*</span></div></div><div class=col-md-4><div class=\"input-normal mgt18\" ng-class=\"{error:FolioApproval.soleApplicantForm.minorName.$dirty && FolioApproval.soleApplicantForm.minorName.$invalid}\"><input type=text name=minorName ng-maxlength=40 limit-to=40 maxlength=40 ng-model=FolioApproval.formData.soleApplicantDetail.name ng-pattern=pattern.name_regex required> <span class=highlight></span> <span class=bar></span><label>Minor\'s Name<span class=\"req text-red\">*</span></label></div><span ng-show=\"FolioApproval.soleApplicantForm.minorName.$dirty && FolioApproval.soleApplicantForm.minorName.$invalid\"><span class=\"error-input error\" ng-show=FolioApproval.soleApplicantForm.minorName.$error.required ng-bind=FolioApproval.validateData.MINOR_NAME></span> <span class=\"error-input error\" ng-show=\"FolioApproval.soleApplicantForm.minorName.$error.pattern && !FolioApproval.soleApplicantForm.minorName.$error.required\" ng-bind=FolioApproval.validateData.MINOR_VALID_NAME></span></span></div><div class=col-md-4><div class=\"input-normal mgt18\" style=\"position: relative\" ng-class=\"{error:FolioApproval.soleApplicantForm.dob.$dirty && FolioApproval.soleApplicantForm.dob.$invalid}\"><input type=text name=minorDob id=soleNetWorthDate22 date-calendar date-default=FolioApproval.defaultDob format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=FolioApproval.minDateMinor data-on-date-change=FolioApproval.changeMinorDob showdefault={{FolioApproval.formData.soleApplicantDetail.dob}} easyassist-key=mask-element required> <span class=highlight></span> <span class=bar></span> <i style=\"z-index: 9\" class=calendar-icon></i><!--<i class=\"times-icon\" ng-click=\"Nominee.resetNetWorthDate()\"></i>--><label style=\"z-index: 9\">DD-MMM-YYYY <span class=\"req text-red\">*</span></label><span ng-show=\"FolioApproval.soleApplicantForm.dob.$dirty && FolioApproval.soleApplicantForm.dob.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.dob.$error.required>{{FolioApproval.validateData.MINOR_DOB}}</span></span></div></div></div><div class=\"row mrg20\" ng-if=FolioApproval.formData.soleApplicantDetail.minor><div class=col-md-4><div class=\"input-normal selectfield input-normal\" ng-class=\"{error:FolioApproval.soleApplicantForm.minorRelationship.$dirty && FolioApproval.soleApplicantForm.minorRelationship.$invalid}\"><select class=\"browser-default custom-select\" name=minorRelationship ng-model=FolioApproval.formData.guardianDetails.relationship ng-options=\"relationship.value as relationship.name for relationship in FolioApproval.minorRelationshipsList\" required><option value=\"\" selected>Relationship With Minor</option></select><span class=highlight></span> <span class=bar></span> <span class=\"req text-red\">*</span></div><span ng-show=\"FolioApproval.soleApplicantForm.minorRelationship.$dirty && FolioApproval.soleApplicantForm.minorRelationship.$invalid\"><span class=\"error-input error error-message\" ng-show=FolioApproval.soleApplicantForm.minorRelationship.$error.required>Please select Relationship</span></span></div><div class=\"col-md-4 padding30\"><p class=pdl0><strong>Upload Relation Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title=\"Max file size should be less than or equal to 2 MB. File format should be jpg and jpeg extension.\"></i> </strong><span class=req>*</span></p><div class=\"form-group mgt15\"><span class=upload-button><input ng-disabled=\"FolioApproval.formData.guardianDetails.relationship==null\" ng-class=\"{\'disabled-upload\': FolioApproval.formData.guardianDetails.relationship==null}\" id=uploadGurdianAgeProof type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg file-model=FolioApproval.minorGaurdianAgeProof targetimg=showingImgId upload=FolioApproval.uploadGuardianProofFile(file)><label for=uploadGurdianAgeProof class=\"btn-upload btn-secondary-action\">{{FolioApproval.minorGaurdianAgeProof?\'Change\':\'Choose File\'}}</label></span><span ng-if=\"FolioApproval.formData.guardianDetails.guardianRelationshipProofUrl && (FolioApproval.guardianFileType !== \'tiff\' && FolioApproval.guardianFileType !== \'tif\')\" class=\"file-name text-blue\" ng-click=\"FolioApproval.openUploadedDoc(FolioApproval.formData.guardianDetails.guardianRelationshipProofUrl,\'GUARDIAN_PROOF\')\">{{FolioApproval.minorGaurdianFileName}}</span> <span ng-if=\"FolioApproval.formData.guardianDetails.guardianRelationshipProofUrl && (FolioApproval.guardianFileType === \'tiff\' || FolioApproval.guardianFileType === \'tif\')\" class=\"file-name text-blue\" ng-click=\"FolioApproval.downloadFile(FolioApproval.formData.guardianDetails.guardianRelationshipProofUrl, FolioApproval.guardianFileType, \'GUARDIAN_PROOF\')\">{{FolioApproval.minorGaurdianFileName}}</span></div></div><div class=\"col-md-4 padding30\"><p class=pdl0><strong>Upload Minor\'s Age Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=bottom title=\"Max file size should be less than or equal to 2 MB. File format should be jpg and jpeg extension.\"></i> </strong><span class=req>*</span></p><div class=\"form-group mgt15\"><span class=upload-button><input ng-class=\"{\'disabled-upload\': FolioApproval.formData.soleApplicantDetail.minorAgeProof==null}\" id=minorAgeProof type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg file-model=FolioApproval.minorAgeProof targetimg=showingImgId upload=FolioApproval.uploadFileAgeProof(file)><label for=minorAgeProof class=\"btn-upload btn-secondary-action\">{{FolioApproval.minorAgeProof?\'Change\':\'Choose File\'}}</label></span><span ng-if=\"FolioApproval.formData.soleApplicantDetail.minorAgeProof && (FolioApproval.minorFileType !== \'tiff\' && FolioApproval.minorFileType !== \'tif\')\" class=\"file-name text-blue\" ng-click=\"FolioApproval.openUploadedDoc(FolioApproval.formData.soleApplicantDetail.minorAgeProof,\'MINOR_PROOF\')\">{{FolioApproval.minorAgeProofName}}</span> <span ng-if=\"FolioApproval.formData.soleApplicantDetail.minorAgeProof && (FolioApproval.minorFileType === \'tiff\' || FolioApproval.minorFileType === \'tif\')\" class=\"file-name text-blue\" ng-click=\"FolioApproval.downloadFile(FolioApproval.formData.soleApplicantDetail.minorAgeProof, FolioApproval.minorFileType,\'MINOR_PROOF\')\">{{FolioApproval.minorAgeProofName}}</span></div></div></div><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s Income Details\":\"Income Details\"}}</strong></p><div class=row><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top\">Tax Status</label><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.taxStatusCode.$dirty && FolioApproval.soleApplicantForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" ng-model=FolioApproval.formData.soleApplicantDetail.taxStatusCode ng-disabled=\"FolioApproval.formData.nriFlag == false\" ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in FolioApproval.taxStatusList\" ng-change=FolioApproval.changedTaxStatus() easyassist-key=mask-element required><option value=\"\" selected>Tax Status</option></select><!--<select class=\"browser-default custom-select\" ng-if=\"FolioApproval.formData.soleApplicantDetail.minor\" name=\"taxStatusCode\"\n                        ng-model=\"FolioApproval.formData.guardianDetails.basicDetails.taxStatusCode\"\n                        ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in FolioApproval.taxStatusList\"\n                        ng-change=\"FolioApproval.changedTaxStatus()\" required>\n                  <option value=\"\" selected>Tax Status</option>\n                </select>--> <span ng-show=\"FolioApproval.soleApplicantForm.taxStatusCode.$dirty && FolioApproval.soleApplicantForm.taxStatusCode.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.taxStatusCode.$error.required ng-bind=FolioApproval.validateData.TAX_STATUS></span></span></div></div><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.soleApplicantDetail.occupation || FolioApproval.formData.guardianDetails.basicDetails.occupation\">Occupation</label><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.occupation.$dirty && FolioApproval.soleApplicantForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=occupation ng-model=FolioApproval.formData.soleApplicantDetail.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in FolioApproval.occupationList\" ng-change=FolioApproval.setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><select class=\"browser-default custom-select\" ng-if=FolioApproval.formData.soleApplicantDetail.minor name=occupation ng-model=FolioApproval.formData.guardianDetails.basicDetails.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in FolioApproval.occupationList\" ng-change=FolioApproval.setOccuValidation() easyassist-key=mask-element required><option value=\"\" selected>Occupation</option></select><span ng-show=\"FolioApproval.soleApplicantForm.occupation.$dirty && FolioApproval.soleApplicantForm.occupation.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.occupation.$error.required ng-bind=FolioApproval.validateData.OCCUPATION></span></span></div></div></div><div class=row><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top\" ng-if=\"FolioApproval.formData.soleApplicantDetail.grossAnnualIncome || FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome\">Gross Annual Income</label><div class=\"input-select input-normal selectfield\" ng-class=\"{error:FolioApproval.soleApplicantForm.grossAnnualIncome.$dirty\n                 && FolioApproval.soleApplicantForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=grossAnnualIncome ng-click=\"FolioApproval.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioApproval.incomeSlabList\" ng-required=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate)\" easyassist-key=mask-element ng-disabled=FolioApproval.formData.soleApplicantDetail.netWorth><option value=\"\" selected>Gross Annual Income</option></select><select class=\"browser-default custom-select\" ng-if=FolioApproval.formData.soleApplicantDetail.minor name=grossAnnualIncome ng-click=\"FolioApproval.setOptionalEmptyG(\'GrossAnnualIncome\')\" ng-model=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in FolioApproval.incomeSlabList\" ng-required=\"!(FolioApproval.formData.guardianDetails.basicDetails.netWorth)\n                        && !(FolioApproval.formData.guardianDetails.basicDetails.netWorthDate)\" easyassist-key=mask-element ng-disabled=FolioApproval.formData.guardianDetails.basicDetails.netWorth><option value=\"\" selected>Gross Annual Income</option></select><span ng-show=\"FolioApproval.soleApplicantForm.grossAnnualIncome.$dirty && FolioApproval.soleApplicantForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.grossAnnualIncome.$error.required ng-bind=FolioApproval.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=FolioApproval.soleApplicantForm.grossAnnualIncome.$error.number ng-bind=FolioApproval.validateData.INVALID_AMOUNT></span> </span><span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate) && !FolioApproval.formData.soleApplicantDetail.minor\" class=req>*</span> <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.netWorth)\n                      &&!(FolioApproval.formData.soleApplicantDetail.netWorthDate) && FolioApproval.formData.soleApplicantDetail.minor\" class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=col-md-4><div class=\"input-normal mgt18\" ng-class=\"{error:FolioApproval.soleApplicantForm.netWorth.$dirty\n                 && FolioApproval.soleApplicantForm.netWorth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=netWorth class=pd20 ng-model=FolioApproval.formData.soleApplicantDetail.netWorth ng-required=!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome) ng-disabled=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome onkeyup=\"NumToWord(this.value,\'ApprovalDisplayWordsTaxAmount\')\"> <input type=number easyassist-key=mask-element ignore-mouse-wheel ng-if=FolioApproval.formData.soleApplicantDetail.minor name=netWorth class=pd20 ng-model=FolioApproval.formData.guardianDetails.basicDetails.netWorth ng-required=!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome) ng-disabled=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome onkeyup=\"NumToWord(this.value,\'ApprovalDisplayWordsTaxAmount\')\"> <span ng-show=\"FolioApproval.soleApplicantForm.netWorth.$dirty && FolioApproval.soleApplicantForm.netWorth.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.netWorth.$error.number ng-bind=FolioApproval.validateData.INVALID_AMOUNT></span> <span class=error-input ng-show=FolioApproval.soleApplicantForm.netWorth.$error.required ng-bind=FolioApproval.validateData.NET_WORTH></span> </span><span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Net worth (in Rs.) <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome) && !FolioApproval.formData.soleApplicantDetail.minor\n                ||(FolioApproval.formData.soleApplicantDetail.netWorthDate)\" class=req>*</span> <span ng-if=\"!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome) && FolioApproval.formData.soleApplicantDetail.minor\n                ||(FolioApproval.formData.guardianDetails.basicDetails.netWorthDate)\" class=req>*</span></label></div><div class=form-group><label id=ApprovalDisplayWordsTaxAmount>{{FolioApproval.amountInWords}} (In Words)</label></div></div><div class=col-md-4><div class=\"input-select input-normal input-group date date-picker mgt18\" ng-class=\"{error : FolioApproval.formData.soleApplicantDetail.netWorth\n                   && !FolioApproval.formData.soleApplicantDetail.netWorthDate\n                   }\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor><input type=text name=netWorthDate id=soleNetWorthDate2 date-calendar date-default=FolioApproval.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=FolioApproval.minDate data-view-date=FolioApproval.formData.soleApplicantDetail.netWorthDate data-on-date-change=FolioApproval.changeStartDate ng-required=!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome) ng-disabled=FolioApproval.formData.soleApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label style=\"z-index: 9\">As on DD/MM/YYYY <span ng-if=\"!(FolioApproval.formData.soleApplicantDetail.grossAnnualIncome)\n                ||(FolioApproval.formData.soleApplicantDetail.netWorth)\" class=req>*</span></label><span ng-show=\"FolioApproval.formData.soleApplicantDetail.netWorth\n                   && !FolioApproval.formData.soleApplicantDetail.netWorthDate\"><span class=error-input>{{FolioApproval.validateData.DATE_REQUIRED}}</span></span></div><!--<span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span>--><div class=\"input-select input-normal input-group date date-picker mgt18\" ng-class=\"{error : FolioApproval.formData.guardianDetails.basicDetails.netWorth\n                   && !FolioApproval.formData.guardianDetails.basicDetails.netWorthDate\n                   }\" ng-if=FolioApproval.formData.soleApplicantDetail.minor><input type=text name=netWorthDate id=guardianDetailsNetWorthDate date-calendar date-default=FolioApproval.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=FolioApproval.minDate showdefault=\"{{\'\'+!!FolioApproval.formData.guardianDetails.basicDetails.netWorthDate}}\" data-on-date-change=FolioApproval.changeNetWorthDate required ng-disabled=FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label style=\"z-index: 9\">As on DD/MM/YYYY <span ng-if=\"!(FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome)\n                ||(FolioApproval.formData.guardianDetails.basicDetails.netWorth)\" class=req>*</span></label><span ng-show=\"FolioApproval.formData.guardianDetails.basicDetails.netWorth\n                           && !FolioApproval.formData.guardianDetails.basicDetails.netWorthDate\"><span class=error-input>{{FolioApproval.validateData.DATE_REQUIRED}}</span></span></div></div></div></div><div class=form-content><p><strong ng-if=!FolioApproval.formData.soleApplicantDetail.minor>Politically Exposed Person (PEP) Status</strong><strong ng-if=FolioApproval.formData.soleApplicantDetail.minor>Guardian\'s Politically Exposed Person (PEP) Status</strong></p><div class=row><div class=col-md-6><div class=radio-block><span class=\"radio mg20\"><input type=radio id=politicalStatus1 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus1 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.RELATED ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus2 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.RELATED ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus33 name=politicalStatus ng-model=FolioApproval.formData.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.NONE ng-if=!FolioApproval.formData.soleApplicantDetail.minor> <input type=radio id=politicalStatus3 name=politicalStatus ng-model=FolioApproval.formData.guardianDetails.basicDetails.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.NONE ng-if=FolioApproval.formData.soleApplicantDetail.minor> <span class=check></span></span><label for=politicalStatus3>Not Applicable.</label></div></div></div></div><div class=form-content><div class=\"row pdt10\"><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top top25\" ng-if=\"FolioApproval.formData.soleApplicantDetail.fatcaAddressType || FolioApproval.formData.guardianDetails.basicDetails.fatcaAddressType\">Address Type</label><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s FATCA or CRS information\":\"FATCA or CRS information\"}}</strong></p><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in FolioApproval.addressDescriptions\" required><option value=\"\" selected>Address Type</option></select><select class=\"browser-default custom-select\" name=fatcaAddressType ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in FolioApproval.addressDescriptions\" required><option value=\"\" selected>Address Type</option></select><span ng-show=\"FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.fatcaAddressType.$error.required ng-bind=FolioApproval.validateData.ADDRESS_TYPE></span></span></div></div><div class=\"col-md-4 pos-relative\"><label class=\"customized-label custom-top top25\" id=topCustomResp ng-if=\"FolioApproval.formData.soleApplicantDetail.birthCountry || FolioApproval.formData.guardianDetails.basicDetails.birthCountry\">Country of Birth</label><div class=\"input-select input-normal selectfield\" style=\"margin-top: 25px\" ng-class=\"{error:FolioApproval.soleApplicantForm.birthCountry.$dirty && FolioApproval.soleApplicantForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.birthCountry ng-options=\"country.countryCode as country.countryName for country in FolioApproval.countryList\" easyassist-key=mask-element required><option value=\"\" selected>Country of Birth</option></select><select class=\"browser-default custom-select\" name=birthCountry ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.birthCountry ng-options=\"country.countryCode as country.countryName for country in FolioApproval.countryList\" required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"FolioApproval.soleApplicantForm.birthCountry.$dirty && FolioApproval.soleApplicantForm.birthCountry.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.birthCountry.$error.required>{{FolioApproval.validateData.COUNTRY}}</span></span></div></div></div><div class=\"row pdt20\"><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:FolioApproval.soleApplicantForm.birthCity.$dirty && FolioApproval.soleApplicantForm.birthCity.$invalid}\"><input type=text easyassist-key=mask-element name=birthCity ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.soleApplicantDetail.birthCity required capitalize ng-maxlength=35> <input type=text easyassist-key=mask-element name=birthCity ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-model=FolioApproval.formData.guardianDetails.basicDetails.birthCity ng-pattern=\"/^[a-zA-Z ]+$/\" required capitalize ng-maxlength=35> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><span ng-show=\"FolioApproval.soleApplicantForm.birthCity.$dirty && FolioApproval.soleApplicantForm.birthCity.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.birthCity.$error.required>{{FolioApproval.validateData.CITY}}</span> <span class=error-input ng-show=FolioApproval.soleApplicantForm.birthCity.$error.maxlength>{{FolioApproval.validateData.MAX_LENGTH_CITY_OF_BIRTH}}</span></span></div></div></div></div><div class=\"form-content inves-pay\"><div class=row><div class=col-md-6><p>Does the investor pay or file tax other than India?</p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.soleApplicantDetail.payTaxInIndia ng-value=false> <input type=radio id=payTaxInIndiaYes ng-if=FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia ng-value=false> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo ng-if=!FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.soleApplicantDetail.payTaxInIndia ng-value=true> <input type=radio id=payTaxInIndiaNo ng-if=FolioApproval.formData.soleApplicantDetail.minor name=payTaxInIndia ng-change=FolioApproval.fileTaxAction() ng-model=FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia ng-value=true> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span></div></div></div><div class=form-content><div class=row><div class=col-md-12><div ng-if=\"!FolioApproval.formData.soleApplicantDetail.payTaxInIndia && !FolioApproval.formData.soleApplicantDetail.minor\"><div class=tax-res ng-repeat=\"data in FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=FolioApproval.deleteTaxResidency($index)><i class=delete-icon></i></span></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryCode as country.countryName for country in FolioApproval.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"FolioApproval[\'birthCountry-\'+$index].$error.required\">{{FolioApproval.validateData.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'taxIdType-\'+$index].$dirty && FolioApproval[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdType ng-options=\"taxidtype.key as taxidtype.value for taxidtype in FolioApproval.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mgt18\"><input type=text easyassist-key=mask-element name=taxIdNumber-{{$index}} ng-model=FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses[$index].taxIdNumber maxlength=20 required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number</label></div></div></div></div></div><div ng-if=\"!FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia && FolioApproval.formData.soleApplicantDetail.minor\"><div class=tax-res ng-repeat=\"data in FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses\"><p><strong>{{FolioApproval.formData.soleApplicantDetail.minor?\"Guardian\'s Tax Residency Country\":\"Tax Residency Country\"}}</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=FolioApproval.deleteTaxResidencyGD($index)><i class=delete-icon></i></span></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].countryName ng-options=\"country.countryCode as country.countryName for country in FolioApproval.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" easyassist-key=mask-element required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"FolioApproval[\'birthCountry-\'+$index].$dirty && FolioApproval[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"FolioApproval[\'birthCountry-\'+$index].$error.required\">{{FolioApproval.validateData.COUNTRY}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:FolioApproval[\'taxIdType-\'+$index].$dirty && FolioApproval[\'taxIdType-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdType ng-options=\"taxidtype.key as taxidtype.value for taxidtype in FolioApproval.taxIdTypeList\" easyassist-key=mask-element required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mgt18\"><input type=text easyassist-key=mask-element name=taxIdNumber-{{$index}} ng-model=FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses[$index].taxIdNumber maxlength=20 required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number</label></div></div></div></div></div></div></div><div class=row ng-if=\"!FolioApproval.formData.soleApplicantDetail.payTaxInIndia && !FolioApproval.formData.soleApplicantDetail.minor\"><div class=\"col-md-12 add-another-tax-res\"><a ng-show=\"((FolioApproval.formData.soleApplicantDetail.payOutsideIndiaAddresses.length)*1<3)\" href=\"\" class=text-blue ng-click=FolioApproval.addMoreTaxResidency()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><div class=row ng-if=\"!FolioApproval.formData.guardianDetails.basicDetails.payTaxInIndia && FolioApproval.formData.soleApplicantDetail.minor\"><div class=\"col-md-12 add-another-tax-res\"><a ng-show=\"((FolioApproval.formData.guardianDetails.basicDetails.payOutsideIndiaAddresses.length)*1<3)\" href=\"\" class=text-blue ng-click=FolioApproval.addMoreTaxResidencyGD()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div><div class=\"form-footer form-content\"><button type=button class=\"btn btn-negative-action\" ng-click=FolioApproval.confirmCancelModaltoReject()>Reject Folio</button> <button class=\"btn btn-primary-action\" ng-if=!FolioApproval.formData.soleApplicantDetail.minor ng-disabled=\"FolioApproval.soleApplicantForm.$invalid\n              ||(!FolioApproval.formData.soleApplicantDetail.netWorthDate && !FolioApproval.formData.soleApplicantDetail.grossAnnualIncome)\n              ||(FolioApproval.formData.soleApplicantDetail.netWorth && !FolioApproval.formData.soleApplicantDetail.netWorthDate)\">Next</button> <button class=\"btn btn-primary-action\" ng-if=FolioApproval.formData.soleApplicantDetail.minor ng-disabled=\"FolioApproval.soleApplicantForm.$invalid\n              ||(!FolioApproval.formData.guardianDetails.basicDetails.netWorthDate && !FolioApproval.formData.guardianDetails.basicDetails.grossAnnualIncome)\n              ||(FolioApproval.formData.guardianDetails.basicDetails.netWorth && !FolioApproval.formData.guardianDetails.basicDetails.netWorthDate)\">Next</button></div></div></form></div>");
$templateCache.put("app/new-investor/folio-creation/bank-details/bank-details.html","<div class=bankdetails ng-init=BankDetails.gettaxStatus()><div class=row><div class=\"col-xs-12 col-md-6\"><form name=bankDetailsForm id=bankDetailsForm ng-submit=BankDetails.submitBankAccountDetails()><!-- IFSC code --><div class=row><div class=\"col-xs-12 col-md-12\" style=\"display: flex;align-items: center;\n                    justify-content: space-between\"><p class=investmentTitle>IFSC Code</p><div class=alignifsctext style=\"display: flex;justify-content: space-between;align-items: center\" ng-click=BankDetails.selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=\"svg-icon search-icon\" aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg></a><p style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</p></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><input type=text class=\"form-control inputNormal\" name=ifsccode id=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-model=BankDetails.bankAccountDetailsForm.ifscCode ng-pattern=BankDetails.IFSC_REGEX capitalize required readonly style=\"background-color: #ffffff;width: 336px\"></div><div ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\" style=\"margin-left: 15px\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><br><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Type</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=BankDetails.bankAccountDetailsForm.accountType required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in BankDetails.bankAccountType\" ng-selected=\"BankDetails.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- payout Mechanism --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Payout Mechanism</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in BankDetails.payoutMechanismList\" ng-selected=\"BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism == value.payoutCode\" value={{value.payoutCode}}>{{value.payoutDescription}}</option></select></div></div><br><!-- Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=password class=\"form-control inputNormal\" name=bankaccountnumber id=bankaccountnumber minlength=1 ng-maxlength=20 autocomplete=off onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-model=BankDetails.bankAccountDetailsForm.accountNumber required style=\"width: 336px\"> <span ng-show=\"bankDetailsForm.bankaccountnumber.$dirty && bankDetailsForm.bankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.bankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.bankaccountnumber.$error.maxlength || bankDetailsForm.bankaccountnumber.$error.minlength\">Bank account number should be in range 1 to 20.</span></span></div></div><br><!-- verify Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Verify Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=text class=\"form-control inputNormal\" name=verifybankaccountnumber id=verifybankaccountnumber ng-minlength=1 ng-maxlength=20 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-model=BankDetails.bankAccountDetailsForm.accountNumberverify ng-change=BankDetails.matchAccountNumber() autocomplete=off ng-pattern=BankDetails.bankAccountDetailsForm.accountNumber required style=\"width: 336px\"> <span ng-show=\"bankDetailsForm.verifybankaccountnumber.$dirty && bankDetailsForm.verifybankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.verifybankaccountnumber.$error.maxlength || bankDetailsForm.verifybankaccountnumber.$error.minlength\">Bank account number should be in range 1 to 20.</span> <span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.pattern>Bank account number should be same.</span></span></div></div><br><!-- chequesleaf --><div class=row ng-if=BankDetails.showcheckLeaf><div class=\"col-xs-12 col-sm-12 col-md-12\"><a style=\"color: blue\">{{BankDetails.bankAccountDetailsForm.chequesleafImageUrl}}</a></div><div class=\"col-xs-12 col-sm-6 col-md-8\" style=\"padding: 10px 0px 15px 12px\"><label class=checkboxHidden for=chequesleafImage style=\"text-align: right;\n                    padding: 10px;\n                    padding-left: 35px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">Upload Cheque leaf</label><input type=file name=chequesleafImage id=chequesleafImage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=BankDetails.bankAccountDetailsForm.chequesleafImageUrl upload=BankDetails.bankUploadChequeLeafFile(file) style=\"display: none;visibility: none\" ng-click=BankDetails.clearFileSelection()></div><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=BankDetails.bankAccountDetailsForm.chequesleafImageUrl><p ng-click=BankDetails.openUploadedDoc() style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px\">Show Image</p></div></div><!-- Submit button --><div style=\"display: flex;justify-content: space-between\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=BankDetails.showcheckLeaf ng-click=BankDetails.submitWithCheckLeaf() ng-disabled=\"\n                            !BankDetails.bankAccountDetailsForm.ifscCode ||\n                            !BankDetails.bankAccountDetailsForm.accountType ||\n                            !BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !BankDetails.bankAccountDetailsForm.accountNumber ||\n                            !BankDetails.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button> <button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=!BankDetails.showcheckLeaf ng-disabled=\"\n                            !BankDetails.bankAccountDetailsForm.ifscCode ||\n                            !BankDetails.bankAccountDetailsForm.accountType ||\n                            !BankDetails.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !BankDetails.bankAccountDetailsForm.accountNumber ||\n                            !BankDetails.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button></div></form></div><div class=\"col-xs-12 col-md-6\"><div class=warning style=\"width: 250px;margin-top: 28px\" ng-if=!BankDetails.bankAccountDetailsForm.ifscCode><img src=../../../assets/images/icons/light-bulb.png style=\"width: 50px;height: 30px;margin: 10px 10px 0px 10px\"><div style=\"padding: 5px\"><br><p style=\"line-height: 20px;\n                    font-size: 12px;\n                    font-weight: 500\">Your bank account details will be used to credit or debit funds, credit dividends, among other things.</p><br><p style=\"line-height: 20px;\n                font-size: 12px;\n                font-weight: 500;margin-right: 6px\">Your details are absolutely safe with us and payment will only be done if you authorise us to make a payment.</p><br><br></div></div><div class=bankinfo ng-if=BankDetails.bankAccountDetailsForm.ifscCode style=\"background-color: white;border-radius: 8px;padding: 18px;width: 80%;margin-top: 28px\"><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Bank Name: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.bankName}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch City: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.bankCity}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch Location: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{BankDetails.bankAccountDetailsForm.branchLocation}}</span></p></div></div></div></div><style>.inputNormal{\n        width: 336px;\n        background-color: #ffffff;\n    }\n    .selectNormal{\n        width: 336px;\n    }\n    .alignifsctext {\n        margin-left: 243px; \n        position: absolute;\n    }\n    @media only screen and (max-width: 508px) { \n       .alignifsctext {   \n            margin-left: 210px;\n      } \n    }  \n    .checkboxHidden::before,.checkboxHidden::after{\n        display: none;\n    }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-basic-details/folio-basic-details.html","<div class=basicdetailsform ng-init=FolioBasicDetails.init()><br><!-- Selfmode --><div class=selffolio><form autocomplete=off name=folioSelfSingleBasicForm ng-submit=FolioBasicDetails.submitFolioSelfSingleBsicForm()><div class=row><div class=\"col-xs-12 col-md-6\"><p class=titleFatca>Create Folio For</p><div class=\"row btn-ss\" style=\"margin-left: 2px\"><p ng-click=\"FolioBasicDetails.chooseFolioFor(\'Self\')\" ng-attr-class=\"{{folioBasicDetail.folioForUser == \'Self\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Self</span></p><p ng-click=\"FolioBasicDetails.chooseFolioFor(\'Minor\')\" ng-attr-class=\"{{folioBasicDetail.folioForUser == \'Minor\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Minor</span></p></div></div></div><br><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Mode Of Holding</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.folioHoldingMode == \'SINGLE\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getholdingmode(\'SINGLE\')\"><span style=\"margin: auto\">Single</span></p><p ng-attr-class=\"{{folioBasicDetail.folioHoldingMode == \'ANY_OR_SURVIVOR\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getholdingmode(\'ANY_OR_SURVIVOR\')\"><span style=\"margin: auto\">Anyone or Survivor</span></p></div></div></div><br><!-- OTHER THAN INDIA --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1 style=\"margin: 15px 0px 10px -10px\">Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getTaxFileStatus(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{folioBasicDetail.fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getTaxFileStatus(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div><br><!-- FATCA QUESTIONS --><div ng-if=!folioBasicDetail.Fatca.taxPayIndia><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxPaycountry name=taxPaycountry ng-model=folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in FolioBasicDetails.filteredCountry\" ng-selected=\"folioBasicDetail.Fatca.fatcaTax1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"folioSelfSingleBasicForm.taxPaycountry.$dirty && !FolioBasicDetails.Fatca.fatcaTax1.taxPayingCountry\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxPaycountry.$error.required ng-bind=FolioBasicDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=folioBasicDetail.Fatca.fatcaTax1.taxIdType style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.taxIdType\" ng-selected=\"FolioBasicDetails.Fatca.fatcaTax1.taxIdType == value.key\" value={{value.key}}>{{value.value}}</option></select><span ng-show=\"folioSelfSingleBasicForm.taxIdType.$dirty && !FolioBasicDetails.Fatca.fatcaTax1.taxIdType\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxIdType.$error.required ng-bind=FolioBasicDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayingCity type=text name=taxpayingCity ng-model=folioBasicDetail.Fatca.fatcaTax1.taxPayingCity ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=\"/^[a-zA-Z ]+$/\" required> <span ng-show=\"folioSelfSingleBasicForm.taxpayingCity.$dirty && folioSelfSingleBasicForm.taxpayingCity.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxpayingCity.$error.required ng-bind=FolioBasicDetails.validateData.CITY></span> <span class=error-input ng-show=folioSelfSingleBasicForm.taxpayingCity.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-model=folioBasicDetail.Fatca.fatcaTax1.taxId ng-maxlength=20 limit-to=20 maxlength=20 required> <span ng-show=\"folioSelfSingleBasicForm.taxId.$dirty && folioSelfSingleBasicForm.taxId.$invalid\"><span class=error-input ng-show=folioSelfSingleBasicForm.taxId.$error.required ng-bind=FolioBasicDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><br><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1 style=\"margin-top: 0px\">Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=btn-l><p ng-attr-class=\"{{folioBasicDetail.userPEPStatus == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getPEPStatus(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{folioBasicDetail.userPEPStatus == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioBasicDetails.getPEPStatus(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div><br><div class=row style=\"margin: 15px 0px 0px 0px\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=folioSelfSingleBasicForm.$error.required type=submit>CONTINUE</button></div></form></div></div><style>.btnDiv{\n    width: 50%;\n    padding: 30px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n  }\n  .popupBtn{\n      width: 100px !important;\n      border-radius: 15px;\n      height: 30px;\n      color: white;\n      border: none;\n      background: #244b8c;\n  }\n  .popupIcon{\n    height: 100px;\n    width: 100px;\n    margin-top: 50px;\n    /* margin-bottom: 20px; */\n  }\n  .f-w-100{\n    font-weight: 100;\n  }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-basic-minor/folio-basic-minor.html","<div class=minorFormdata><div><form autocomplete=off name=minorBasicForm ng-submit=FolioBasicMinorDetails.submitMinorBsicDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-6\"><p class=titleFatca>Create Folio For</p><div class=\"row btn-ss\" style=\"margin-left: 2px\"><p ng-click=\"FolioBasicMinorDetails.chooseFolioFor(\'Self\')\" ng-attr-class=\"{{folioBasicMinorDetail.folioForUser == \'Self\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Self</span></p><p ng-click=\"FolioBasicMinorDetails.chooseFolioFor(\'Minor\')\" ng-attr-class=\"{{folioBasicMinorDetail.folioForUser == \'Minor\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Minor</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Minor\'s Name</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=minorsname type=text n name=minorsname ng-model=FolioBasicMinorDetails.minorFormData.minorsFullName ng-pattern=\"/^[a-zA-Z ]+$/\" style=\"width: 336px\" ng-maxlength=40 limit-to=40 maxlength=40 autofocus required> <span ng-show=\"minorBasicForm.minorsname.$dirty && minorBasicForm.minorsname.$invalid\"><span class=error-input ng-show=minorBasicForm.minorsname.$error.required ng-bind=FolioBasicMinorDetails.validateData.MINOR_NAME></span> <span class=error-input ng-show=minorBasicForm.minorsname.$error.pattern>Number not allowed in minor name!</span></span></div></div><div class=\"dobrow row\"><div class=\"minordob col-xs-12 col-md-5\"><div class=dob-input-container><label class=titleFatca for=dobId style=\"margin-bottom: -10px\">Date of Birth</label><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioBasicMinorDetails.viewMode}} data-date-default=FolioBasicMinorDetails.minorFormData.dob data-on-date-change=FolioBasicMinorDetails.getMinordob maxdate=now format=DD-MMM-YYYY id=endDate style=\"margin-bottom: -5px;z-index: 999;width: 336px\"><input class=newinvestor-dob id=dobId name=dob type=text autocomplete=off placeholder=dd-mmm-yyyy ng-keyup=FolioBasicMinorDetails.autoDate() required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span class=error-input ng-if=FolioBasicMinorDetails.dateErrorMessage ng-bind=FolioBasicMinorDetails.dateErrorMessage></span> <span class=error-input ng-if=FolioBasicMinorDetails.MINOR_DOB_ERROR>Applicant\'s age should be less than 18 years</span></div></div></div><!-- <div class=\"col-xs-12 col-md-5 hidden-xs\">\n            <div class=\"warning\">\n              <img src=\"../../../assets/images/icons/light-bulb.png\">\n              <div>Applicant\'s age should be 18 years or above</div>\n            </div>\n          </div> --></div><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Minor\'s Gender</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=gender name=gender ng-model=FolioBasicMinorDetails.minorFormData.gender required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"gData in FolioBasicMinorDetails.genderObj\" ng-selected=\"FolioBasicMinorDetails.minorFormData.gender == gData.value\" value={{gData.value}}>{{gData.name}}</option></select><span ng-show=\"minorBasicForm.gender.$dirty && !FolioBasicMinorDetails.minorFormData.gender\"><span class=error-input ng-show=minorBasicForm.gender.$error.required ng-bind=FolioBasicMinorDetails.validateData.GENDER_REQUIRED></span></span></div></div><div class=row><div class=\"col-xs-12 col-md-8\" style=\"display: flex;justify-content: flex-start;flex-direction: row;margin-bottom: 2px;align-items: center\"><p class=titleFatca>Minor\'s Age Proof</p><i class=\"blue-info-icon base-tooltip\" tooltip data-html=true data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Valid DOB Proof</u></br>Below is the list of Valid DOB Proof</br>\n                            <ul style=\'color:black\'><li>Birth certificate</li><li>School leaving certificate/ Mark sheet issued by Higher Secondary Board of respective states, ICSE, CBSE etc.</li>\n                            <li>Passport</li><li>Any other suitable proof evidencing the date of birth of the minor</li></ul>Max File size should be less than or equal to 2 MB.\n                              File format should be tif, tiff, jpg and jpeg extension.\"></i></div><div class=\"col-xs-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><div class=\"minorageproofdiv row\" style=\"width: 100%\"><!-- <div class=\"col-xs-12 col-md-5\">\n                <select class=\"selectNormal\" id=\"minorsageproof\" name=\"minorsageproof\"\n                  ng-model=\"FolioBasicMinorDetails.minorFormData.ageproofType\"\n                  required style=\"height: 40px;width: 336px;\">\n                  <option value selected=\"selected\">Select</option>\n                  <option ng-repeat=\"value in FolioBasicMinorDetails.minorAgeProofType\"\n                    ng-selected=\"FolioBasicMinorDetails.minorFormData.ageproofType == value.proofTypeDesc\"\n                    value=\"{{value.proofTypeDesc}}\">{{value.proofTypeDesc}}</option>\n                </select>\n                <span ng-show=\"minorBasicForm.minorsageproof.$dirty && !FolioBasicMinorDetails.minorFormData.ageproofType\">\n                  <span class=\"error-input\" ng-show=\"minorBasicForm.minorsageproof.$error.required\">Minors ageproof\n                    required!</span>\n                </span>\n              </div> --><div class=\"col-xs-12 col-sm-6 col-md-6\"><label for=minorageproofimage style=\"text-align: center;\n                padding: 10px;\n                padding: 10px 40px 10px 40px;\n                background-color: lightgray;\n                border-radius: 25px;\n                background-size: 30px;\n                cursor: pointer;\n                background-position-x: 5px;\n                background-position-y: 3px;\n                background-repeat: no-repeat;\n                background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">upload proof</label><input type=file name=minorageproofimage id=minorageproofimage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=FolioBasicMinorDetails.minorFormData.ageproofimageurl upload=FolioBasicMinorDetails.getMinorAgeProofImage(file) style=\"display: none;visibility: none\" required></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioBasicMinorDetails.minorFormData.ageproofimageName><p style=\"color: blue;font-size: 9px\" ng-click=FolioBasicMinorDetails.showImage()>{{FolioBasicMinorDetails.minorFormData.ageproofimageName}}</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><p class=titleFatca>Tax Status</p><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioBasicMinorDetails.minorFormData.taxstatus ng-disabled=!FolioBasicMinorDetails.nriTaxStatus required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in FolioBasicMinorDetails.taxStatus\" ng-selected=\"FolioBasicMinorDetails.minorFormData.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}} selected>{{value.taxStatusDescription}}</option></select><span ng-show=\"minorBasicForm.taxstatus.$dirty && !FolioBasicMinorDetails.minorFormData.taxstatus\"><span class=error-input ng-show=minorBasicForm.taxstatus.$error.required ng-bind=FolioBasicMinorDetails.validateData.TAX_STATUS></span></span></div></div><br><div><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"minorBasicForm.minorsname.$error.required ||\n             minorBasicForm.minorsname.$error.pattern ||\n             FolioBasicMinorDetails.MINOR_DOB_ERROR ||\n            !FolioBasicMinorDetails.minorFormData.dob ||\n            !FolioBasicMinorDetails.minorFormData.gender ||\n            !FolioBasicMinorDetails.minorFormData.taxstatus ||\n            !FolioBasicMinorDetails.minorFormData.ageproofimageurl\">CONTINUE</button></div></form></div></div><style>.minorFormdata{\n    position: relative;\n  }\n  .titleFatca {\n    margin: 5px 0px 5px 0px;\n  }\n\n\n  .btnDiv {\n    width: 50%;\n    padding: 30px;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n  }\n\n  .popupBtn {\n    width: 100px !important;\n    border-radius: 15px;\n    height: 30px;\n    color: white;\n    border: none;\n    background: #244b8c;\n  }\n\n  .popupIcon {\n    height: 100px;\n    width: 100px;\n    margin-top: 50px;\n    /* margin-bottom: 20px; */\n  }\n\n  .f-w-100 {\n    font-weight: 100;\n  }\n\n\n  @media screen and (max-width: 860px) {\n    .minorageproofdiv {\n      margin-left: -15px;\n    }\n\n    .btnDiv {\n      width: 80%;\n    }\n\n\n\n  }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-basic-minor-guardian/folio-basic-minor-guardian.html","<div><form autocomplete=off name=minorFormGuardian ng-submit=FolioMinorGuardianDetails.submitMinorGuardianDetails() novalidate><div class=row><div class=\"col-xs-12 col-md-5\"><p class=titleFatca>Contact Details</p></div><div class=\"form-content credentialNote col-md-12\" ng-if=\"(!FolioMinorGuardianDetails.guardianEmailId && FolioMinorGuardianDetails.guardianMobileNo) || (FolioMinorGuardianDetails.guardianEmailId && !FolioMinorGuardianDetails.guardianMobileNo)\"><label>{{FolioMinorGuardianDetails.AppConstants.UPDATE_CONTACT_ERROR_FILL}}</label></div><div class=\"form-content credentialNote col-md-12\" ng-if=\"!FolioMinorGuardianDetails.guardianEmailId && !FolioMinorGuardianDetails.guardianMobileNo\"><label>{{FolioMinorGuardianDetails.AppConstants.UPDATE_CONTACT_ERROR_BOTH}}</label></div></div><div class=row><div class=\"col-md-6 email-block\" style=\"margin-top: 30px\"><update-new-folio-email pan=FolioMinorGuardianDetails.pan dob=FolioMinorGuardianDetails.userDob curr-email=FolioMinorGuardianDetails.guardianEmailId curr-mobile-number={{FolioMinorGuardianDetails.guardianMobileNo}} update-contact-info=\"FolioMinorGuardianDetails.updateContactInfo(\'email\')\" show-edit=FolioMinorGuardianDetails.showEditEmail flow-type=new-investor kyc-email=FolioMinorGuardianDetails.oldGuardianEmailId hide-ui-fnc=\"FolioMinorGuardianDetails.hideUiFnc(\'mobile\')\" hide-ui=FolioMinorGuardianDetails.hideEditEmail show-ui-fnc=\"FolioMinorGuardianDetails.showUiFnc(\'mobile\')\"></update-new-folio-email></div><div class=\"col-md-6 email-block\" style=\"margin-top: 30px\"><update-new-folio-mobile pan=FolioMinorGuardianDetails.pan dob=FolioMinorGuardianDetails.userDob curr-mobile-number=FolioMinorGuardianDetails.guardianMobileNo curr-email={{FolioMinorGuardianDetails.guardianEmailId}} update-contact-info=\"FolioMinorGuardianDetails.updateContactInfo(\'mobile\')\" show-edit=FolioMinorGuardianDetails.showEditMobile flow-type=new-investor kyc-mobile=FolioMinorGuardianDetails.oldGuardianMobileNo hide-ui-fnc=\"FolioMinorGuardianDetails.hideUiFnc(\'email\')\" hide-ui=FolioMinorGuardianDetails.hideEditMobile show-ui-fnc=\"FolioMinorGuardianDetails.showUiFnc(\'email\')\"></update-new-folio-mobile></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-6 belongsToContainerWeb\" style=\"display: inline-flex\" ng-if=FolioMinorGuardianDetails.guardianEmailId><div style=\"flex-shrink: 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong><span class=\"req text-red\">*</span> :</label></div><div style=\"display: inline-block; margin-left: 5px\" ng-class=\"{error:minorFormGuardian.emailBelongsTo.$dirty && minorFormGuardian.emailBelongsTo.$invalid}\"><select class=contactBelongSelect id=emailBelongsTo name=emailBelongsTo ng-model=FolioMinorGuardianDetails.holders.emailBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray;margin-top: 8px;margin-left: 0px; appearance: auto\" required><option value selected>Select Value</option><option ng-repeat=\"value in FolioMinorGuardianDetails.belongToListEmail\" ng-selected=\"FolioMinorGuardianDetails.holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><p><span ng-show=minorFormGuardian.emailBelongsTo.$dirty><span class=error-input ng-show=minorFormGuardian.emailBelongsTo.$error.required>Please select option</span></span></p></div></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!FolioMinorGuardianDetails.guardianEmailId></div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=FolioMinorGuardianDetails.guardianMobileNo><div style=\"flex-shrink: 0\"><label style=\"margin-top: 22px; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div style=\"display: inline-block\" ng-class=\"{error:minorFormGuardian.mobileBelongsTo.$dirty && minorFormGuardian.mobileBelongsTo.$invalid}\"><select class=\"contactBelongSelect browser-default\" id=mobileBelongsTo name=mobileBelongsTo ng-model=FolioMinorGuardianDetails.holders.mobileBelongsTo ng-init=\"FolioMinorGuardianDetails.holders.mobileBelongsTo = FolioMinorGuardianDetails.holders.mobileBelongsTo ? FolioMinorGuardianDetails.holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in FolioMinorGuardianDetails.belongToListMobile\" ng-selected=\"FolioMinorGuardianDetails.holders.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;border: 1px solid gray;margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value=\"\" selected>Select Value</option></select><br><span ng-show=\"minorFormGuardian.mobileBelongsTo.$dirty &&  minorFormGuardian.mobileBelongsTo.$invalid\"><span class=error-input ng-show=minorFormGuardian.mobileBelongsTo.$error.required>Please select option</span></span></div></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!FolioMinorGuardianDetails.guardianMobileNo></div></div><!-- Relation --><div class=row style=\"margin-top: 20px\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Guardian\'s Relationship</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=minorGuardianRelationship name=minorGuardianRelationship ng-model=FolioMinorGuardianDetails.minorFormGuardianData.relation required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"x in FolioMinorGuardianDetails.relationshipList\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.relation == x.value\" value={{x.value}}>{{x.name}}</option></select><span ng-show=\"minorFormGuardian.minorGuardianRelationship.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.relation\"><span class=error-input ng-show=minorFormGuardian.minorGuardianRelationship.$error.required>Relationship is required</span></span></div></div><br><!-- Relation proof --><div class=row><div class=\"col-xs-12 col-md-8\" style=\"display: flex;justify-content: flex-start;flex-direction: row;margin-bottom: 2px;text-align: center;align-items: center\"><p class=titleFatca>Guardian Relationship Proof</p><i class=\"blue-info-icon base-tooltip\" tooltip data-html=true data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<u style=\'font-size:14px;font-weight:bold\'>View List of Relationship Proof</u></br>\n                          In case of a natural parent, documents evidencing the relationship of the natural parent with the minor,\n                          if the same is not available as part of the documents mentioned above, should be submitted. In case of court appointed legal guardian, supporting documentary evidence (notarized court order) should be provided.\n                          </br>Max file size should be less than or equal to 2 MB. </br>File format should be tif, tiff, jpg and jpeg extension.\"></i></div><div class=\"col-xs-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><div class=\"minorageproofdiv row\" style=\"width: 100%\"><!-- <div class=\"col-xs-12 col-md-5\">\n                        <select class=\"selectNormal\" id=\"minorRelationshipType\" name=\"minorRelationshipType\"\n                            ng-model=\"FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType\"\n                            required style=\"width: 336px;height: 40px;\">\n                            <option value selected=\"selected\">Select</option>\n                            <option ng-repeat=\"value in FolioMinorGuardianDetails.relationProofType\"\n                                ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType == value.proofTypeDesc\"\n                                value=\"{{value.proofTypeDesc}}\">{{value.proofTypeDesc}}</option>\n                        </select>\n                        <span\n                            ng-show=\"minorFormGuardian.minorRelationshipType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofType\">\n                            <span class=\"error-input\" ng-show=\"minorFormGuardian.minorRelationshipType.$error.required\">\n                                Minors Relationship proof required!</span>\n                        </span>\n                    </div> --><div class=\"col-xs-12 col-md-3\"><label for=guardianrelationproofimage style=\"text-align: right;\n              padding: 10px;\n              padding-left: 41px;\n              background-color: lightgray;\n              border-radius: 25px;\n              background-size: 30px;\n              cursor: pointer;\n              background-position-x: 5px;\n              background-position-y: 3px;\n              background-repeat: no-repeat;\n              background-image: url(../../../../assets/images/new-investor/uploadIcon.png)\">upload proof</label><input type=file name=guardianrelationproofimage id=guardianrelationproofimage accept=\"image/jpeg, image/jpg, image/tif, image/tiff\" file-model-profile=\"Preview Uploaded Doc\" ng-model=FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimageurl upload=FolioMinorGuardianDetails.getGuardianRelationProofImage(file) style=\"display: none;visibility: none\" required><!-- onchange=\"angular.element(this).scope().FolioMinorGuardianDetails.getGuardianRelationProofImage(this.files)\" --></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename><p style=\"color: blue;font-size: 9px\" ng-click=FolioMinorGuardianDetails.showImage()>{{FolioMinorGuardianDetails.minorFormGuardianData.guardianrelationproofimagename}}</p></div></div></div></div><br><!--  Occupation--><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=FolioMinorGuardianDetails.minorFormGuardianData.occupation required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.investorOccupations\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"minorFormGuardian.occupation.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.occupation\"><span class=error-input ng-show=minorFormGuardian.occupation.$error.required ng-bind=FolioMinorGuardianDetails.validateData.OCCUPATION></span></span></div></div><br><!-- Income --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 5px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row\"><p class=grossanualincome>Gross Annual Income</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioMinorGuardianDetails.networthcall() ng-checked=FolioMinorGuardianDetails.networth><label class=switchlableG for=switch ng-checked=FolioMinorGuardianDetails.networth style=\"margin-right: 10px;margin-top: 8px;position: relative;top: -9px\">Toggle</label><span style=\"font-weight: 600\">Net Worth</span></div></div></div><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!FolioMinorGuardianDetails.networth><select class=selectNormal id=guardianAnnualincome name=guardianAnnualincome ng-model=FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome style=\"margin-left: 0px;width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.incomeSlabList\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"minorFormGuardian.guardianAnnualincome.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncome\"><span class=error-input ng-show=minorFormGuardian.guardianAnnualincome.$error.required ng-bind=FolioMinorGuardianDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=FolioMinorGuardianDetails.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=FolioMinorGuardianDetails.minorFormGuardianData.networth onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\" required> <span ng-show=\"minorFormGuardian.annualincome1.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.networth\"><span class=error-input ng-show=minorFormGuardian.annualincome1.$error.required ng-bind=FolioMinorGuardianDetails.validateData.GROSS_ANNUAL_INCOME></span></span><div class=\"col-md-12 col-sm-12\"><span>Amount in words : </span><span id=DisplayWordsTaxAmount></span></div></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioMinorGuardianDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 50px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioMinorGuardianDetails.viewMode}} data-date-default=FolioMinorGuardianDetails.minorFormGuardianData.grossAnnualIncomeDate data-on-date-change=FolioMinorGuardianDetails.grossAnnualIncomeDate maxdate=now format=DD-MM-YYYY id=endDate style=\"width: 336px\"><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off placeholder=dd-mm-yyyy ng-keyup=FolioMinorGuardianDetails.autoDate() required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioMinorGuardianDetails.dateErrorMessage ng-bind=FolioMinorGuardianDetails.dateErrorMessage></span></div></div></div></div></div><br><!-- FATAC --><div class=row style=\"margin-left: 2px;\n      display: flex;justify-content: flex-start;flex-direction: row;align-items: center;text-align: center\"><p class=titleFatca>FATCA & CRS related question.</p><i class=\"blue-info-icon base-tooltip\" tooltip data-html=true data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"The below information is required for all applicants(s) / guardians. Is also applicant(s) / guardian’s country of birth / citizenship / Nationality / TAX residency other than India?\"></i></div><!-- Countri --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=fatcacountry name=fatcacountry ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.countries\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"minorFormGuardian.fatcacountry.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.Countrie\"><span class=error-input ng-show=minorFormGuardian.fatcacountry.$error.required ng-bind=FolioMinorGuardianDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><!-- address type --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"x in NewFolioCreation.addressType\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"minorFormGuardian.addressType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.addressType\"><span class=error-input ng-show=minorFormGuardian.addressType.$error.required ng-bind=FolioMinorGuardianDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><br><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=fatcaTaxpayingCity type=text name=fatcaTaxpayingCity ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.City ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 336px\"> <span ng-show=\"minorFormGuardian.fatcaTaxpayingCity.$dirty && minorFormGuardian.fatcaTaxpayingCity.$invalid\"><span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.required ng-bind=FolioMinorGuardianDetails.validateData.CITY></span> <span class=error-input ng-show=minorFormGuardian.fatcaTaxpayingCity.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><!-- do you pay or file tax. --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\" style=\"padding: 0px 0px 0px 0px;margin-left: 2px\"><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getTaxFileStatusForGuardian(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getTaxFileStatusForGuardian(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><!-- FATCA1 --><div ng-if=!FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPayIndian><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.filteredCountry\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"minorFormGuardian.country.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCountry\"><span class=error-input ng-show=minorFormGuardian.country.$error.required ng-bind=FolioMinorGuardianDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType required style=\"width: 336px;height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.taxIdType\" ng-selected=\"FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType == value.key\" value={{value.key}}>{{value.value}}</option></select><span ng-show=\"minorFormGuardian.taxIdType.$dirty && !FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxIdType\"><span class=error-input ng-show=minorFormGuardian.taxIdType.$error.required ng-bind=FolioMinorGuardianDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayingCity type=text name=taxpayingCity ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" autofocus required style=\"width: 336px\" ng-maxlength=35 limit-to=35 maxlength=35> <span ng-show=\"minorFormGuardian.taxpayingCity.$dirty && minorFormGuardian.taxpayingCity.$invalid\"><span class=error-input ng-show=minorFormGuardian.taxpayingCity.$error.required ng-bind=FolioMinorGuardianDetails.validateData.CITY></span> <span class=error-input ng-show=minorFormGuardian.taxpayingCity.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-model=FolioMinorGuardianDetails.minorFormGuardianData.Fatca.taxPay1.taxId required style=\"width: 336px\" ng-maxlength=20 limit-to=20 maxlength=20> <span ng-show=\"minorFormGuardian.taxId.$dirty && minorFormGuardian.taxId.$invalid\"><span class=error-input ng-show=minorFormGuardian.taxId.$error.required ng-bind=FolioMinorGuardianDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><!-- Political status --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\" style=\"padding: 0px 0px 0px 0px;margin-left: 2px\"><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.userPEPStatusForGuardian == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getPEPStatusForGuardian(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioMinorGuardianDetails.minorFormGuardianData.userPEPStatusForGuardian == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioMinorGuardianDetails.getPEPStatusForGuardian(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><br><p class=error>{{FolioMinorGuardianDetails.errorMsg}}</p><div><button ng-if=\"FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'No\'\" class=\"btn btn-primary-action-pay\" type=submit ng-disabled=\"minorFormGuardian.$error.required || FolioMinorGuardianDetails.notolderthan1year || !FolioMinorGuardianDetails.guardianEmailId || !FolioMinorGuardianDetails.guardianMobileNo\">CONTINUE</button> <button ng-if=\"FolioMinorGuardianDetails.minorFormGuardianData.fileTaxOtherIndian == \'Yes\'\" class=\"btn btn-primary-action-pay\" type=submit ng-disabled=\"minorFormGuardian.$error.required || FolioMinorGuardianDetails.notolderthan1year || !FolioMinorGuardianDetails.guardianEmailId || !FolioMinorGuardianDetails.guardianMobileNo\">CONTINUE</button></div></form></div><style>.switchlableG{\n        margin-right: 10px;\n        width: 29px;\n        height: 16px;\n        background: #5CEB57 0% 0% no-repeat padding-box;\n        border-radius: 37px;\n        opacity: 1;\n        cursor: pointer;\n        text-indent: -9999px;\n        display: block;\n        position: relative;\n    }\n    @media only screen and (max-width: 1000px ){\n    .btn-primary-action-pay {\n      width: 150px !important;\n    }\n  }\n    .btn-primary-action-pay {\n           width: 163px;\n           height: 35px;\n           border-color: transparent;\n           background-color: #FF8486;\n          border-radius: 50px !important;\n            line-height: 1.4 !important;\n             color: #ffffff;\n          padding: 6px 25px !important;\n          padding: 10px 10px 10px 10px;\n      border-radius: 45px;\n      margin-left: 5px;\n       }\n    .switchlableG:after {\n      content: \"\";\n      position: absolute;\n      top: 3px;\n      left: 5px;\n      width: 10px;\n      height: 10px;\n      background: #fff;\n      border-radius: 50px;\n    }\n\n    input:checked+.switchlableG {\n      background: #5ceb57;\n    }\n\n    input:checked+.switchlableG:after {\n      left: calc(100% - 5px);\n      transform: translateX(-100%);\n    }\n\n    .switchlableG:active:after {\n      width: 15px;\n    }\n\n\n    @media only screen and (max-width: 375px) {\n      .minorageproofdiv {\n        margin-left: -15px;\n      }\n\n  }\n\n    .email-block td:first-child {\n      font-weight: bold;\n    }\n\n    .email-block td span {\n      padding: 5px 0px 5px 5px;\n    }\n\n    .credentialNote{\n      padding:15px;\n      background: linen;\n      border-radius: 8px;\n      margin-top: 12px;\n      font-weight: 500;\n      text-align: center;\n    }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-income-details/folio-income-details.html","<div class=incomedetails><br><form id=folioIncomeFormData name=folioIncomeFormData ng-submit=FolioIncomeDetails.submitFolioIncomeForm()><div class=form-content style=\"margin-bottom: 20px\"><label><strong>Contact Details</strong></label><div class=\"form-content credentialNote\" ng-if=\"(!FolioIncomeDetails.soleApplicantEmail && FolioIncomeDetails.soleApplicantMobile) || (FolioIncomeDetails.soleApplicantEmail && !FolioIncomeDetails.soleApplicantMobile)\"><label>{{FolioIncomeDetails.AppConstants.UPDATE_CONTACT_ERROR_FILL}}</label></div><div class=\"form-content credentialNote col-md-12\" ng-if=\"!FolioIncomeDetails.soleApplicantEmail && !FolioIncomeDetails.soleApplicantMobile\"><label>{{FolioIncomeDetails.AppConstants.UPDATE_CONTACT_ERROR_BOTH}}</label></div><div class=row><div class=\"col-md-6 email-block\" style=\"margin-top: 30px\"><update-new-folio-email pan=FolioIncomeDetails.pan dob=FolioIncomeDetails.userDob curr-email=FolioIncomeDetails.soleApplicantEmail curr-mobile-number={{FolioIncomeDetails.soleApplicantMobile}} update-contact-info=\"FolioIncomeDetails.updateContactInfo(\'email\')\" show-edit=FolioIncomeDetails.showEditEmail flow-type=new-investor kyc-email=FolioIncomeDetails.oldSoleApplicantEmail hide-ui-fnc=\"FolioIncomeDetails.hideUiFnc(\'mobile\')\" hide-ui=FolioIncomeDetails.hideEditEmail show-ui-fnc=\"FolioIncomeDetails.showUiFnc(\'mobile\')\"></update-new-folio-email></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n                style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"FolioIncomeDetails.soleApplicantEmail\">\n                <div style=\"flex-shrink : 0;\">\n                    <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                        : </label>\n                </div>\n                <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                    ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                    <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                        ng-model=\"holders.emailBelongsTo\"\n                        ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                        ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                        <option value=\"\" selected>Select Value</option>\n                    </select>\n                    <span class=\"req text-red\">*</span>\n                </div>\n            </div>\n     --><div class=\"col-md-6 email-block\" style=\"margin-top: 30px\"><update-new-folio-mobile pan=FolioIncomeDetails.pan dob=FolioIncomeDetails.userDob curr-mobile-number=FolioIncomeDetails.soleApplicantMobile curr-email={{FolioIncomeDetails.soleApplicantEmail}} update-contact-info=\"FolioIncomeDetails.updateContactInfo(\'mobile\')\" show-edit=FolioIncomeDetails.showEditMobile flow-type=new-investor kyc-mobile=FolioIncomeDetails.oldSoleApplicantMobile hide-ui-fnc=\"FolioIncomeDetails.hideUiFnc(\'email\')\" hide-ui=FolioIncomeDetails.hideEditMobile show-ui-fnc=\"FolioIncomeDetails.showUiFnc(\'email\')\"></update-new-folio-mobile></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-6 belongsToContainerWeb\" style=\"display: inline-flex\" ng-if=FolioIncomeDetails.soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To <span class=\"req text-red\">* </span>:</strong></label></div><div style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:folioIncomeFormData.emailBelongsTo.$dirty && folioIncomeFormData.emailBelongsTo.$invalid}\"><!-- <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 130px;    margin-top: 8px;\"\n                        ng-model=\"FolioIncomeDetails.holders.emailBelongsTo\"\n                        ng-init=\"FolioIncomeDetails.holders.emailBelongsTo = FolioIncomeDetails.holders.emailBelongsTo ? FolioIncomeDetails.holders.emailBelongsTo: null\"\n                        ng-options=\"data.familyCode as data.familyDescription for data in FolioIncomeDetails.belongToListEmail\" required>\n                        <option value=\"\" selected>Select Value</option>\n                    </select> --><select class=contactBelongSelect id=emailBelongsTo name=emailBelongsTo ng-model=FolioIncomeDetails.holders.emailBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value selected>Select Value</option><option ng-repeat=\"value in FolioIncomeDetails.belongToListEmail\" ng-selected=\"FolioIncomeDetails.holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.emailBelongsTo.$dirty \"><span class=error-input ng-show=folioIncomeFormData.emailBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!FolioIncomeDetails.soleApplicantEmail></div><div class=\"col-md-6 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=FolioIncomeDetails.soleApplicantMobile><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To<span class=\"req text-red\">*</span> :</strong></label></div><div style=\"display: inline-block\" ng-class=\"{error:folioIncomeFormData.mobileBelongsTo.$dirty && folioIncomeFormData.mobileBelongsTo.$invalid}\"><select class=\"contactBelongSelect browser-default\" id=mobileBelongsTo name=mobileBelongsTo ng-model=FolioIncomeDetails.holders.mobileBelongsTo ng-init=\"FolioIncomeDetails.holders.mobileBelongsTo = FolioIncomeDetails.holders.mobileBelongsTo ? FolioIncomeDetails.holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in FolioIncomeDetails.belongToListMobile\" ng-selected=\"FolioIncomeDetails.holders.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;border: 1px solid gray; margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value=\"\" selected>Select Value</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.mobileBelongsTo.$dirty &&  folioIncomeFormData.mobileBelongsTo.$invalid\"><span class=error-input ng-show=folioIncomeFormData.mobileBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!FolioIncomeDetails.soleApplicantMobile></div></div></div><!-- tax status --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Status <span class=\"req text-red\">*</span></p></div><br><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioIncomeDetails.folioIncomeForm.taxstatus ng-disabled=\"FolioIncomeDetails.nriTaxStatus == false\" style=\"height: 40px;border-radius: 5px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.taxStatusData\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select></div><span ng-show=\"folioIncomeFormData.taxstatus.$dirty && !FolioIncomeDetails.folioIncomeForm.taxstatus\"><span class=error-input ng-show=folioIncomeFormData.taxstatus.$error.required ng-bind=FolioIncomeDetails.validateData.TAX_STATUS></span></span></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation <span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=FolioIncomeDetails.folioIncomeForm.occupation style=\"height: 40px;border-radius: 5px;width: 336px\" required><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.investorOccupations\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"folioIncomeFormData.occupation.$dirty && !FolioIncomeDetails.folioIncomeForm.occupation\"><span class=error-input ng-show=folioIncomeFormData.occupation.$error.required ng-bind=FolioIncomeDetails.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 3px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=grossanualincome>Gross Annual Income <span class=\"req text-red\" ng-if=!FolioIncomeDetails.networth>*</span></p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioIncomeDetails.networthcall() ng-checked=FolioIncomeDetails.networth><label class=switchlableINcome for=switch ng-checked=FolioIncomeDetails.networth style=\"margin-right: 10px;margin-top: 8px;position: relative;top: -4px\"></label><span class=titleFatca style=\"margin : 0px !important\">Net Worth <span class=\"req text-red\" ng-if=FolioIncomeDetails.networth>*</span></span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!FolioIncomeDetails.networth><select class=selectNormal id=annualincome name=annualincome ng-model=FolioIncomeDetails.folioIncomeForm.annualincome style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\" required><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.incomeSlabList\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.annualincome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"folioIncomeFormData.annualincome.$dirty && !FolioIncomeDetails.folioIncomeForm.grossAnnualIncome\"><span class=error-input ng-show=folioIncomeFormData.annualincome.$error.required ng-bind=FolioIncomeDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=FolioIncomeDetails.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=FolioIncomeDetails.folioIncomeForm.networth onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\" required> <span ng-show=\"folioIncomeFormData.annualincome1.$dirty && !FolioIncomeDetails.folioIncomeForm.networth\"><span class=error-input ng-show=folioIncomeFormData.annualincome1.$error.required ng-bind=FolioIncomeDetails.validateData.GROSS_ANNUAL_INCOME></span></span><div class=\"col-md-12 col-sm-12\"><span>Amount in words : </span><span id=DisplayWordsTaxAmount></span></div></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioIncomeDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioIncomeDetails.viewMode}} data-date-default=FolioIncomeDetails.folioIncomeForm.grossAnnualIncomeDate data-on-date-change=FolioIncomeDetails.getGrossAnnualIncomeDate maxdate=now data-min-date=FolioIncomeDetails.minDate format=DD-MM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId ng-keyup=FolioIncomeDetails.autoDate() name=grossAnnualIncomeDate type=text autocomplete=off placeholder=\"As on dd-mm-yyyy\" required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioIncomeDetails.dateErrorMessage ng-bind=FolioIncomeDetails.dateErrorMessage></span></div></div></div></div></div><p class=titleFatca>FATCA & CRS related question.</p><!-- Country --><div class=\"row absulatepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country <span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.countrie style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\"><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"value in NewFolioCreation.countries\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.Fatca.countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div><div class=\"note-banner col-xs-12 col-md-7 noterelativepostion\"><div class=warning><img src=../../../assets/images/icons/light-bulb.png style=\"height: 50px;width: 50px;margin-top: 25px;padding: 10px\"><div class=wardiv>FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard) declaration was prepared by finacial institutions company with the Central Board of Direct taxes (CBDT) rules.</div></div></div></div><!-- address type --><div class=\"row relativepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type <span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.addressType style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\"><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"x in NewFolioCreation.addressType\" ng-selected=\"FolioIncomeDetails.folioIncomeForm.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"folioIncomeForm.addressType.$dirty && !FolioIncomeDetails.folioIncomeForm.Fatca.addressType\"><span class=error-input ng-show=folioIncomeForm.addressType.$error.required ng-bind=FolioIncomeDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><br><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City <span class=\"req text-red\">*</span></p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City ng-maxlength=35 limit-to=35 maxlength=35 name=City ng-model=FolioIncomeDetails.folioIncomeForm.Fatca.city ng-pattern=\"/^[a-zA-Z ]+$/\" required> <span ng-show=\"folioIncomeFormData.City.$dirty && folioIncomeFormData.City.$invalid\"><span class=error-input ng-show=folioIncomeFormData.City.$error.required ng-bind=FolioIncomeDetails.validateData.CITY></span> <span class=error-input ng-show=folioIncomeFormData.City.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><br><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"folioIncomeFormData.$error.required  || !FolioIncomeDetails.holders.emailBelongsTo || !FolioIncomeDetails.holders.mobileBelongsTo || folioIncomeFormData.City.$invalid\n        || !FolioIncomeDetails.soleApplicantEmail || !FolioIncomeDetails.soleApplicantMobile\">CONTINUE</button><!-- <button\n        class=\"btn hdfc-blue-cta-small\"\n        type=\"submit\">CONTINUE</button> --></form></div><style>.contactBelongSelect{\n      -webkit-appearance: none;\n    -moz-appearance: none;\n    height: 40px;\n    background: white !important;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill=\'gray\' height=\'24\' viewBox=\'0 0 24 24\' width=\'24\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/><path d=\'M0 0h24v24H0z\' fill=\'none\'/></svg>\");\n    background-repeat: no-repeat;\n    background-position-x: 100%;\n    background-position-y: 11px;\n    border: 1px solid #B8C6D1;\n    border-radius: 5px;\n    padding-left: 15px !important;\n    opacity: 1;\n    width: 180px !important;\n    }\n      @media screen and (min-width: 1285px) {\n      .relativepostion{\n          position: relative;\n          margin-top: 90px;\n      }\n      .absulatepostion{\n           position: absolute;\n      }\n    }\n    @media screen and (max-width: 1285px) {\n      .noterelativepostion{\n\n         width: 100%;\n           }\n    }\n\n    .credentialNote{\n      padding:15px;\n      background: linen;\n      border-radius: 8px;\n      margin-top: 12px;\n      font-weight: 500;\n      text-align: center;\n    }\n    .grossanualincome{\n      width: 154px !important;\n    }\n\n    .email-block td:first-child {\n      font-weight: bold;\n    }\n\n    .email-block td span {\n      padding: 5px 0px 5px 5px;\n    }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-holder-details/folio-holder-details.html","<div class=holderdetails style=\"position: relative\"><!-- step 1 --><div class=panverify ng-if=addholder.steps[0].isactive><form class=verification-form autocomplete=off name=holderPanVerificationForm ng-submit=FolioJointHolderDetails.verifyOrAddHolder2() novalidate><div class=row><div class=\"col-xs-12 col-md-8\"><div class=tax-status-container><label class=s-label>Tax Status</label><div class=tax-field-container><div class=\"flex-check input-label\"><input class=nomineeCheckbox type=radio id=resident-tax-status name=tax-status ng-value=true ng-model=FolioJointHolderDetails.holderData.taxStatusResident ng-change=FolioJointHolderDetails.changedRiNriTaxStatus()><label for=resident-tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{FolioJointHolderDetails.appconstants.TAX_STATUS_INDIVIDUAL.RESIDENT_INDIVIDUAL}}</label></div><div class=\"flex-check input-label\"><input class=nomineeCheckbox type=radio id=tax-status name=tax-status ng-value=false ng-model=FolioJointHolderDetails.holderData.taxStatusResident ng-change=FolioJointHolderDetails.changedRiNriTaxStatus()><label for=tax-status class=confirmationnote style=\"font-size: 12px\">&nbsp;</label><label style=\"margin-top: 5px\">{{FolioJointHolderDetails.appconstants.TAX_STATUS_INDIVIDUAL.NON_RESIDENT_INDIVIDUAL}}</label></div></div></div></div><div class=col-md-3></div></div><!-- PAN input --><div class=row><div class=\"col-xs-12 col-md-5\"><div class=pan-input-container><label for=pan>PAN</label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=FolioJointHolderDetails.holderData.pan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-change=FolioJointHolderDetails.resetValues() ng-blur=FolioJointHolderDetails.checkPanEmailExist() capitalize required style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n            border: 1px solid #B8C6D1;\n            border-radius: 5px;\n            height: 40px;\n            opacity: 1\"><br><span ng-show=\"holderPanVerificationForm.pan.$dirty && holderPanVerificationForm.pan.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.pan.$error.required ng-bind=FolioJointHolderDetails.validateData.PAN_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.maxlength ng-bind=FolioJointHolderDetails.validateData.PAN_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.pan.$error.pattern ng-bind=FolioJointHolderDetails.validateData.PAN_FIELD></span> </span><span class=error-input ng-if=FolioJointHolderDetails.panMessage ng-bind-html=FolioJointHolderDetails.panMessage></span></div></div><div class=\"col-xs-12 col-md-5\"><!-- <p style=\"color: red;font-weight: bold;\">{{FolioJointHolderDetails.wrongMsg}}</p> --></div></div><br><!-- Eamil Add --><div ng-if=FolioJointHolderDetails.showEmail class=\"input-select input-normal\"><div class=row><div class=\"col-xs-12 col-md-8\"><p>Email</p></div><div class=\"col-xs-12 col-md-5\" ng-class=\"{\'anything-disabled\':FolioJointHolderDetails.showOtp}\"><div style=\"display: flex;align-items: center\"><input class=\"form-control inputNormal\" type=email name=email ng-model=FolioJointHolderDetails.holderData.email required ng-pattern=FolioJointHolderDetails.appconstants.email_regex></div><span ng-show=\"holderPanVerificationForm.email.$dirty && holderPanVerificationForm.email.$invalid\"><span class=error-input ng-show=holderPanVerificationForm.email.$error.required ng-bind=FolioJointHolderDetails.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=holderPanVerificationForm.email.$error.pattern ng-bind=FolioJointHolderDetails.validateData.EMAIL_FIELD></span></span><p ng-if=FolioJointHolderDetails.emailDetails.message>{{FolioJointHolderDetails.emailDetails.message}} <span>{{FolioJointHolderDetails.holderData.mobileNumber}}</span></p></div><div class=\"col-xs-12 col-md-5\" ng-class=\"{\'anything-disabled\':FolioJointHolderDetails.showOtp}\"><button type=button class=btn-holder ng-disabled=!FolioJointHolderDetails.holderData.email ng-click=FolioJointHolderDetails.AddEmailToHolderPan()>Add Email</button></div></div></div><!-- OTP --><div ng-if=FolioJointHolderDetails.showOtp><div><div class=row><div class=\"col-xs-12 col-md-8\"><p>Verify OTP</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text minlength=6 maxlength=6 name=otp ng-model=FolioJointHolderDetails.Otp required> <span class=error-input ng-show=holderPanVerificationForm.otp.$error.minlength ng-bind=FolioJointHolderDetails.validateData.OTP_FIELD></span> <span class=error-input ng-show=holderPanVerificationForm.otp.$error.maxlength ng-bind=FolioJointHolderDetails.validateData.OTP_FIELD></span></div><div class=\"col-xs-12 col-md-2\"><button type=button class=btn-holder ng-click=FolioJointHolderDetails.verifyOtp() ng-disabled=!FolioJointHolderDetails.Otp>Verify</button></div><div class=\"col-xs-12 col-md-3\"><span class=forgot><timer countdown=FolioJointHolderDetails.appconstants.RESEND_OTP_COUNTER interval=1000><a ng-show=\"countdown === 0\" href=\"\" ng-click=FolioJointHolderDetails.reGenerateOtp() class=\"resendBtn btn-holder forgot-pwd\" style=\"margin: 12px\">Resend OTP</a> <a ng-show=\"countdown > 0\" ng-class=\"{\'forgot-pwd-disabled\': countdown > 0}\">Enable Resend OTP in {{countdown}}s</a></timer></span></div></div></div></div><br><!-- Verify Button --><div class=kyc-verify><button tabindex=3 type=submit class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-disabled=\"holderPanVerificationForm.pan.$invalid ||\n            !FolioJointHolderDetails.processFlag ||\n            !FolioJointHolderDetails.AllowedJointHolder\">VERIFY</button></div></form></div><!-- Step 2 --><div ng-if=addholder.steps[1].isactive><div ng-if=FolioJointHolderDetails.holders[0].pan><div ng-repeat=\"x in FolioJointHolderDetails.holders track by $index\"><p ng-if=\"vm.holderLength == 1\" style=\"font-weight: bold;margin-top: 15px;margin-bottom: 15px;border-left: 3px;border-left:3px solid darkblue\">&nbsp; Second Holder</p><p ng-if=\"vm.holderLength == 2\" style=\"font-weight: bold;margin-top: 15px;margin-bottom: 15px;border-left: 3px;border-left:3px solid darkblue\">&nbsp; Third Holder</p><div style=\"display: flex;justify-content: flex-start;flex-direction: row;width: 60%;margin-bottom: 30px\"><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Name</p><input class=\"form-control inputNormal\" type=text value={{x.jointHolderName}} readonly style=\"background-color: white;width: 95%\"></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">PAN</p><input class=\"form-control inputNormal\" type=text value={{x.pan}} readonly style=\"background-color: white;width: 95%\"></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Email</p><input class=\"form-control inputNormal\" type=text value={{x.email}} readonly style=\"background-color: white;width: 95%\"></div><div><p style=\"margin-top: 10px;margin-bottom: 10px;font-weight: bold\">Mobile</p><input class=\"form-control inputNormal\" type=text value={{x.mobileNumber}} readonly style=\"background-color: white;width: 95%\"></div><div style=\"display: flex;justify-content: flex-start;align-items: center;cursor: pointer;\n            margin-top: 30px;\n            margin-left: 10px\" ng-click=FolioJointHolderDetails.deleteHolder($index)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></div></div></div><div><button ng-if=FolioJointHolderDetails.stopaddholder class=\"btn addAnotherButton\" ng-click=FolioJointHolderDetails.addthirdholderinfolio()>ADD ANOTHER HOLDER</button> <button class=\"btn hdfc-blue-cta-small btn-primary-action-pay\" ng-click=FolioJointHolderDetails.holdernext()>CONTINUE</button></div></div></div><!-- Step 3 --><div class=holderform3 ng-if=addholder.steps[2].isactive><div class=row><div class=\"nomineetab col-sm-4 col-md-4\"><p ng-attr-class=\"{{ FolioJointHolderDetails.holderTab == 0 ? \'holder-count border-b-3\' : \'holder-count\'}}\" ng-click=FolioJointHolderDetails.getholdersdata(0)>Second Holder</p><div class=delete-icon-holder ng-click=FolioJointHolderDetails.deleteHolder(0)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></div><p ng-if=\"FolioJointHolderDetails.holderCount == 2\" ng-attr-class=\"{{ FolioJointHolderDetails.holderTab == 1 ? \'holder-count border-b-3\' : \'holder-count\'}}\" ng-click=FolioJointHolderDetails.getholdersdata(1)>Third holder</p><div class=delete-icon-holder ng-if=\"FolioJointHolderDetails.holderCount == 2\" ng-click=FolioJointHolderDetails.deleteHolder(1)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></div></div></div><div style=\"width: 100%;background-color: white;border-radius: 5px;padding: 11px;margin-top: 25px\"><p>Name :&nbsp;<span style=\"font-weight: bold\">{{FolioJointHolderDetails.jointHolderDetails.jointHolderName}}</span></p><br><p>PAN :&nbsp; <span style=\"font-weight: bold\">{{FolioJointHolderDetails.jointHolderDetails.pan}}</span></p></div><div style=\"width: 100%;border-radius: 5px;margin-top: 15px\"><div class=row><div class=col-md-6><p><span style=\"font-weight: bold\">Email</span> :&nbsp;{{FolioJointHolderDetails.jointHolderDetails.email}}</p></div><div class=col-md-6><p><span style=\"font-weight: bold\">Mobile </span>:&nbsp;{{FolioJointHolderDetails.jointHolderDetails.mobileNumber}}</p></div></div><br class=spaceBR><div class=row><div class=col-md-6><div class=row><div class=col-md-5><p style=\"margin-top: 20px;font-weight: bold\">Email Id Belongs To:</p></div><div class=col-md-7><select class=contactBelongSelect id=emailBelongsTo name=emailBelongsTo ng-model=FolioJointHolderDetails.jointHolderDetails.emailBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value selected>Select Value</option><option ng-repeat=\"value in FolioJointHolderDetails.belongToListEmail\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select></div></div></div><div class=col-md-6><div class=row><div class=col-md-6><p style=\"margin-top: 20px;font-weight: bold\">Mobile No. Belongs To:</p></div><div class=col-md-6><select class=contactBelongSelect id=mobileBelongsTo name=mobileBelongsTo ng-model=FolioJointHolderDetails.jointHolderDetails.mobileBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value selected>Select Value</option><option ng-repeat=\"value in FolioJointHolderDetails.belongToListEmail\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.mobileBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select></div></div></div></div></div><!-- address --><form id=jointHolderForm name=jointHolderForm ng-submit=FolioJointHolderDetails.submithHolderIncomeDetails(FolioJointHolderDetails.holderTab)><div ng-if=FolioJointHolderDetails.showSameHOlderDetail style=\"width: 50%;padding: 5px; display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=\"inputquestion titleFatca\">Applicant Details</p>&nbsp; <input class=nomineeCheckbox type=checkbox name=address id=address><!-- ng-model=\"FolioJointHolderDetails.sameFirstHoderDetails\" --><label class=confirmationnote ng-click=FolioJointHolderDetails.addFirstHolderData() for=address style=\"margin-left: 10px;font-size: 14px\">Same as first holder</label></div><!-- tax status --><div class=row><div class=\"col-xs-12 col-sm-8 col-md-8\"><p class=titleFatca>Tax Status</p></div><br><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=FolioJointHolderDetails.jointHolderDetails.taxStatusCode style=\"height: 40px\" ng-change=\"FolioJointHolderDetails.taxStatusChanged(FolioJointHolderDetails.jointHolderDetails.taxStatusCode, FolioJointHolderDetails.holderTab)\" ng-disabled=\"FolioJointHolderDetails.jointHolderDetails.nriFlag == false\" required><option value selected>Select</option><option ng-repeat=\"value in FolioJointHolderDetails.taxStatusData\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.taxStatusCode == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select><span ng-show=\"jointHolderForm.taxstatus.$dirty && !FolioJointHolderDetails.jointHolderDetails.taxstatus\"><span class=error-input ng-show=jointHolderForm.taxstatus.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_STATUS></span></span></div><div class=\"note-banner col-xs-12 col-md-7 noterelativepostion\" ng-if=NewInvestor.dynamicDataForTaxStatus><div class=\"warning tax-status-ackn\"><span class=icon-info-sign></span><div class=\"wardiv noteText\"><p>{{NewInvestor.dynamicDataForTaxStatus}}</p></div></div></div></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=FolioJointHolderDetails.jointHolderDetails.occupationCode style=\"height: 40px\" required><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.investorOccupations\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.occupationCode == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"jointHolderForm.occupation.$dirty && !FolioJointHolderDetails.jointHolderDetails.occupationCode\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=FolioJointHolderDetails.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 5px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row\"><p class=grossanualincome>Gross Annual Income</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=FolioJointHolderDetails.networthcall() ng-checked=FolioJointHolderDetails.networth><label class=switchlableHolder for=switch ng-checked=FolioJointHolderDetails.networth style=\"margin-right: 10px;margin-top: 3px\"></label><span class=titleFatca style=\"margin : 0px !important\">Net Worth</span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!FolioJointHolderDetails.networth><select class=selectNormal id=annualincome1 name=annualincome1 ng-model=FolioJointHolderDetails.jointHolderDetails.grossAnnualIncome style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.incomeSlabList\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"jointHolderForm.annualincome1.$dirty && !FolioJointHolderDetails.jointHolderDetails.gross1\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=FolioJointHolderDetails.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=FolioJointHolderDetails.networth><input type=\"number inputNormal\" class=form-control id=annualincome1 name=annualincome1 ng-model=FolioJointHolderDetails.jointHolderDetails.netWorth onkeyup=\"NumToWord(this.value,\'DisplayWordsTaxAmount\')\" required style=\"height: 40px\"> <span ng-show=\"jointHolderForm.annualincome1.$dirty && !FolioJointHolderDetails.jointHolderDetails.netWorth\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=FolioJointHolderDetails.validateData.GROSS_ANNUAL_INCOME></span></span><div class=\"col-md-12 col-sm-12\"><span>Amount in words : </span><span id=DisplayWordsTaxAmount></span></div></div><div class=\"col-xs-12 col-md-4\" ng-if=FolioJointHolderDetails.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{FolioJointHolderDetails.viewMode}} data-date-default=FolioJointHolderDetails.jointHolderDetails.netWorthDate data-on-date-change=FolioJointHolderDetails.getGrossAnnualIncomeDateOfHolder maxdate=now data-min-date=FolioJointHolderDetails.minDate format=DD-MMM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off ng-keyup=FolioJointHolderDetails.autoDate() placeholder=\"As on dd-mmm-yyyy\" required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=FolioJointHolderDetails.dateErrorMessage ng-bind=FolioJointHolderDetails.dateErrorMessage></span></div></div></div></div></div><p class=titleFatca style=\"padding-top: 25px\">FATCA & CRS related question.</p><!-- Country --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthCountry style=\"height: 40px\" required><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.countries\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div><!-- <div class=\"col-sm-7 col-md-7\">\n            <div class=\"warning\">\n              <img src=\"../../../assets/images/icons/light-bulb.png\" style=\"height: 20%;width: 20%;\">\n              <div class=\"wardiv\">FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard)\n                declaration was prepared by finacial institutions company with the Central Board of Direct taxes\n                (CBDT) rules.</div>\n            </div>\n          </div> --></div><!-- address type --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType style=\"height: 40px\" required><option value selected>Select</option><option ng-repeat=\"x in NewFolioCreation.addressType\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"jointHolderDetails.addressType.$dirty && !FolioJointHolderDetails.jointHolderDetails.fatcaDetail.addressType\"><span class=error-input ng-show=jointHolderDetails.addressType.$error.required ng-bind=FolioJointHolderDetails.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City name=City ng-maxlength=35 limit-to=35 maxlength=35 ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.birthPlace ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 322px\"> <span ng-show=\"jointHolderForm.City.$dirty && jointHolderForm.City.$invalid\"><span class=error-input ng-show=jointHolderForm.City.$error.required ng-bind=FolioJointHolderDetails.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.City.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><!-- do you pay or file tax. --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getTaxFileStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getTaxFileStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><br><!-- FATCA1 --><div ng-if=!FolioJointHolderDetails.jointHolderDetails.fatcaDetail.payTaxInIndia><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.filteredCountry\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><span ng-show=\"jointHolderForm.country.$dirty && !FolioJointHolderDetails.jointHolderFormData.fatcaDetail.fatcaTax1.taxPayingCountry\"><span class=error-input ng-show=jointHolderForm.country.$error.required ng-bind=FolioJointHolderDetails.validateData.SELECT_COUNTRY></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.taxIdType\" ng-selected=\"FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType == value.key\" value={{value.key}}>{{value.value}}</option></select><span ng-show=\"jointHolderForm.taxIdType.$dirty && !FolioJointHolderDetails.jointHolderFormData.fatcaDetail.fatcaTax1.taxIdType\"><span class=error-input ng-show=jointHolderForm.taxIdType.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayCity type=text name=taxpayCity ng-maxlength=35 limit-to=35 maxlength=35 ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 332px\"> <span ng-show=\"jointHolderForm.taxpayCity.$dirty && jointHolderForm.taxpayCity.$invalid\"><span class=error-input ng-show=jointHolderForm.taxpayCity.$error.required ng-bind=FolioJointHolderDetails.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.taxpayCity.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-maxlength=20 limit-to=20 maxlength=20 ng-model=FolioJointHolderDetails.jointHolderDetails.fatcaDetail.fatcaTax1.taxId required style=\"width: 332px\"> <span ng-show=\"jointHolderForm.taxId.$dirty && jointHolderForm.taxId.$invalid\"><span class=error-input ng-show=jointHolderForm.taxId.$error.required ng-bind=FolioJointHolderDetails.validateData.TAX_ID_NUMBER></span></span></div></div></div><!-- Political status --><div class=row style=\"margin: 0\"><div class=\"col-xs-12 col-md-12\"><p class=title1>Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_politicalStatus == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getPEPStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{FolioJointHolderDetails.jointHolderTaxDetails_politicalStatus == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"FolioJointHolderDetails.getPEPStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><div style=\"display: flex;flex-direction: row\"><button class=\"btn-new-journey-color btn-primary-action-pay hdfc-blue-cta-small\" type=submit ng-if=!FolioJointHolderDetails.nextFlag ng-disabled=\"jointHolderForm.$error.required || FolioJointHolderDetails.notolderthan1year || jointHolderForm.City.$invalid || !FolioJointHolderDetails.jointHolderDetails.emailBelongsTo || !FolioJointHolderDetails.jointHolderDetails.mobileBelongsTo\">CONTINUE</button> &nbsp;&nbsp;&nbsp;&nbsp;<!-- <button class=\"btn-new-journey-color btn-primary-action-pay hdfc-blue-cta-small\" ng-If=\"FolioJointHolderDetails.nextFlag\"\n          ng-click=\"FolioJointHolderDetails.submitHolder()\" type=\"button\">NEXT</button> --></div></form></div></div><style>#switch {\n              height: 0;\n              width: 0;\n              visibility: hidden;\n            }\n\n            .switchlableHolder {\n              margin-right: 10px;\n              width: 29px;\n              height: 16px;\n              background: #5CEB57 0% 0% no-repeat padding-box;\n              border-radius: 37px;\n              opacity: 1;\n              cursor: pointer;\n              text-indent: -9999px;\n              display: block;\n              position: relative;\n            }\n\n            .switchlableHolder:after {\n              content: \"\";\n              position: absolute;\n              top: 3px;\n              left: 5px;\n              width: 10px;\n              height: 10px;\n              background: #fff;\n              border-radius: 50px;\n            }\n\n            input:checked+.switchlableHolder {\n              background: #5ceb57;\n            }\n\n            input:checked+.switchlableHolder:after {\n              left: calc(100% - 5px);\n              transform: translateX(-100%);\n            }\n\n            .switchlableHolder:active:after {\n              width: 10px;\n              height: 10px;\n            }\n\n    .thirdholderPopup {\n    /* position: absolute; */\n    top: 25%;\n    left: auto;\n    border-radius: 15px;\n    z-index: 1000;\n    /* width: 500px; */\n    height: auto;\n    background-color: white;\n\n\n  }\n  .thirdholderPopup .body\n      form {\n        text-align: center;\n        align-items: center;\n\n      }\n      .thirdholderPopup .body\n      form  .form-control {\n          border: 1px solid gray;\n        }\n  .thirdholderPopup .head {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background-color: #eaf5ff;\n      border-top-left-radius: 15px;\n      border-top-right-radius: 15px;\n      height: 42px;\n\n    }\n    .thirdholderPopup .head p {\n        padding: 20px;\n      }\n    .addAnotherButton{\n      background-color: white;\n          border: 1px solid #ff8486;\n          color: #ff8486;\n          width: 300px;\n          border-radius: 25px;\n          margin-right: 20px;\n    }\n    @media screen and (max-width: 850px) {\n\n      .addAnotherButton{\n        width: 300px !important;\n      }\n    }\n    .btn-primary-action-pay {    color: white;\n        border-color: transparent;\n        background-color: #FF8486;\n\n     }\n     .hdfc-blue-cta-small:disabled{\n        background-color: #FF8486;\n        color: white;\n    }\n    @media only screen and (max-width: 1000px ){\n  .btn-primary-action-pay {\n    width: 150px !important;\n  }\n}\n  .hdfc-blue-cta-small:disabled{\n    background-color: #FF8486;\n        color: white;\n}\n  .btn-primary-action-pay {\n         width: 163px;\n         height: 35px;\n         border-color: transparent;\n         background-color: #FF8486;\n        border-radius: 50px !important;\n          line-height: 1.4 !important;\n           color: #ffffff;\n        padding: 6px 25px !important;\n        padding: 10px 10px 10px 10px;\n    border-radius: 45px;\n    margin-left: 5px;\n     }\n\n     .btn-holder:disabled {\nbackground-color: #8db1ce;\n}\n\n.btn-holder {\n  margin-top: 10px;\n  background-color: #004c8a;\n  color: white;\n  border: none;\n  width: 120px ;\n  border-radius: 20px;\n  height: 25px;\n}\n.resendBtn{\ntext-align: center;\n  margin: 12px;\n  padding: 5px 18px;\n  color: white !important;\n  border: none;\n  border-radius: 20px;\n  display: block;\n  font-size: 13px !important;\n}\n.resendBtn:focus,.resendBtn:hover{\n  text-decoration: none !important;\n  color: white !important;\n}\n.contactDiv{\n  display: flex;\n  align-items: center;\n}\n.spaceBR{\n  display: block;\n}\n@media screen and (max-width: 991px) {\n.contactBelongSelect{\n  width: 336px !important;\n}\n.spaceBR{\n  display: none;\n}\n}</style>");
$templateCache.put("app/new-investor/folio-creation/summary/summary-page.html","<div ng-init=SummaryPage.init()><div class=row style=\"margin-top: 15px\"><div class=col-xs-12><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: baseline\"><img ng-click=SummaryPage.gotoBankPage() src=../../../assets/images/icons8-left-arrow-96.png alt=\"\" srcset=\"\" style=\"width: 20px;padding-top: 3px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: column\"><p class=reviewFolioPage style=\"color: #244c8a;font-weight: 600;font-size: 22px\">Review Folio Details</p><p class=userName>{{SummaryPage.userData.panHolderName}}</p></div><p id=callModal ng-click=SummaryPage.getModal() style=\"display: none\"></p></div></div></div></div><div style=\"margin-left: 15px\"><!-- single self --><horizontal-progress-sidebar ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'SINGLE\' \" steps=SummaryPage.stepperThird></horizontal-progress-sidebar><!-- any or survior self --><horizontal-progress-sidebar ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'ANY_OR_SURVIVOR\' \" steps=SummaryPage.stepperForAnyoneSurvivor></horizontal-progress-sidebar><!-- minor --><horizontal-progress-sidebar ng-if=\"SummaryPage.folioDetails.minor && SummaryPage.folioDetails.holdmode == \'SINGLE\' \" steps=SummaryPage.stepperForMinor></horizontal-progress-sidebar></div><div><div class=modal-body style=\"margin-left: 15px\"><div class=row ng-if=!SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"form-content col-sm-12 col-md-12 col-lg-12\"><label><strong>Contact Details</strong></label><div class=row><div class=col-md-5 style=\"margin-right: 40px\" ng-if=SummaryPage.soleApplicantEmail><label style=\"margin-top: 30px;word-break: break-all\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{SummaryPage.soleApplicantEmail}}</label></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n                    style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"SummaryPage.soleApplicantEmail\">\n                    <div style=\"flex-shrink : 0;\">\n                        <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                            : </label>\n                    </div>\n                    <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                        ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                        <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                            ng-model=\"holders.emailBelongsTo\"\n                            ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                            ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                            <option value=\"\" selected>Select Value</option>\n                        </select>\n                        <span class=\"req text-red\">*</span>\n                    </div>\n                </div>\n         --><div class=\"col-md-5 mLabel\" ng-if=SummaryPage.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{SummaryPage.soleApplicantMobile}}</label></div><div class=col-md-5 ng-if=!SummaryPage.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=SummaryPage.soleApplicantEmail><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> : {{SummaryPage.belongToListEmail}}</label></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantEmail></div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=SummaryPage.soleApplicantMobile><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To </strong>: {{SummaryPage.belongToListMobile}}</label></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!SummaryPage.soleApplicantMobile></div></div></div></div><!-- sole details --><div class=row ng-if=!SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Sole Applicant Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotofolioBasic() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4 border-right\"><div class=row><p class=col-md-12 style=\"color: #497eac\">Income Details</p></div><div class=\"row m-top padding-x\"><div class=col-md-6><p>Tax Status</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p>\n                    </div> --></div><div class=\"row m-top padding-x\"><div class=col-md-6><p>Occupation</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.occupationData.occupationDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.occupationData.occupationDescription}}</p>\n                    </div> --></div><div class=\"row m-top padding-x\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6 style=\"line-height:normal;padding-top: 5px\">Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.grossIncomeData.incomeDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top padding-x\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6>Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth}} --><p></p></div><div class=\"row m-top padding-x\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorth><p class=col-md-6>Net Worth date</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorthDate readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 border-right\"><div class=row><p class=col-md-12 style=\"color: #497eac\">FATCA and CRS Details</p></div><div class=\"row m-top padding-x\"><div class=col-md-6><p>Country of Birth</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.countryData.countryName readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{SummaryPage.countryData.countryName}}</p>\n                    </div> --></div><div class=\"row m-top padding-x\"><p class=col-md-6>City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.birthPlace readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.birthPlace}}</p> --></div><div class=\"row m-top padding-x\"><p class=col-md-6>Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.addressType readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.addressType}}</p> --></div></div><div class=\"col-xs-12 col-sm-7 col-md-4\"><div class=row><p class=col-md-12 style=\"color: #497eac\">Tax Details</p></div><div class=row ng-if=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=\"ml-15 col-md-12\" style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountryDescription readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountryDescription}}\n                    </p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Paying City</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity}}</p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.selfDetail.fatca.payTaxInIndia><p class=col-md-6>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.taxIdDetails.value readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.taxIdDetails.description}}</p> --></div></div></div><!-- minor data --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"color: #244b8c; font-weight: bold;font-size: 15px\">Minor Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorBasic() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.firstName readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.firstName}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth}}</p> --></div></div><!-- <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                <div class=\"row m-top\">\n                    <p class=\"col-md-6\">DOB Proof</p>\n                    <input class=\"col-md-6 bg-white\" type=\"text\" ng-model=\"SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorProofType\" readonly>\n                    <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorProofType}}</p>\n                </div>\n            </div> --></div><!-- Minor income details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p style=\"color: #244b8c\">Guardian\'s Income Details</p></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6>Tax Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Occupation</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.occupationData.occupationDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.occupationData.occupationDescription}}</p> --></div><div class=\"row m-top\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.grossIncomeData.incomeDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth Date</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6>Political Exposed Person Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus == \'NONE\' ? \'Not Applicable\' : SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus\" readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus == \'NONE\' ? \'Not Applicable\' : SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Relationship with Minor</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.relation readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.relation}}</p> --></div><!-- <div class=\"row m-top\">\n                    <p class=\"col-md-6\">Relationship Proof</p>\n                    <input class=\"col-md-6 bg-white\" type=\"text\" ng-model=\"SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorRelationshipProofType\" readonly>\n                    <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.minorRelationshipProofType}}</p>\n                </div> --></div></div><!-- Guardian\'s FATCA and CRS details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s FATCA and CRS information</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Country of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.countryData.countryName readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.countryData.countryName}}</p> --></div></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.birthPlace}}</p> --></div></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.addressType readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.addressType}}</p> --></div></div></div><!-- Guardian\'s tax details --><div class=row ng-if=SummaryPage.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Tax Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoMinorGuardian() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia><p class=ml-15 style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=!SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.payTaxInIndia><div class=\"row m-top\"><p class=col-md-3>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountryDescription readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountryDescription}} --><p></p></div><div class=\"row m-top\"><p class=col-md-3>Tax Paying City</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCity readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCity}}\n                    </p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{SummaryPage.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.taxIdDetails.value readonly><!-- <p class=\"col-md-3 bg-white\">{{SummaryPage.taxIdDetails.description}}</p> --></div></div></div><br><!-- Holder details --><div class=row ng-if=\"!SummaryPage.folioDetails.minor && SummaryPage.jointHoldersData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Holder Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoHolderPage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-repeat=\"x in SummaryPage.jointHoldersData track by $index\"><!-- <p class=\"col-xs-12 col-sm-12 col-md-12\" style=\"font-weight: bold;\">Joint Holder {{$index + 1}} </p> --><div class=\"row m-top\"><p class=col-md-2>Holder\'s Name</p><p class=\"col-md-2 bg-white\">{{x.firstName}} {{x.lastName}}</p></div></div></div><!-- holder other details --><!-- <div class=\"row\" ng-If=\"!SummaryPage.folioDetails.minor && SummaryPage.jointHoldersData.length > 0\"\n            style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;\">\n            <div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;\">\n                <p style=\"font-weight: bold;font-size: 15px;\">Holder Other Details</p>\n                <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"SummaryPage.gotoHolderPage()\"\n                    style=\"height: 15px;cursor: pointer;\">\n            </div>\n            <div class=\"row\" ng-repeat=\"x in SummaryPage.jointHoldersData track by $index\">\n                <div class=\"row m-top\" style=\"margin-left: 15px;\">\n                    <p class=\"col-md-2\" style=\"color:#497eac;\n                    \">Holder\'s Name {{$index + 1}}</p>\n                    <p class=\"col-md-2 bg-white\">{{x.firstName}} {{x.lastName}}</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Income Details</p>\n                    </div>\n\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Tax Status</p>\n                        <p class=\"col-md-6 bg-white\">{{x.taxStatusDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Occupation</p>\n                        <p class=\"col-md-6 bg-white\">{{x.occupationDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"!x.netWorth\">\n                        <p class=\"col-md-6\">Gross Annual Income</p>\n                        <p class=\"col-md-6 bg-white\">{{SummaryPage.holderIncomdeslab[$index].incomeDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorth}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth Date</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorthDate}}</p>\n                    </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-12 col-md-4\">\n                <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                    <p style=\"color: #497eac;\">FATCA and CRS Details</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Country of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{SummaryPage.countryList[$index].countryName}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">City of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.birthPlace}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Address of type</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.addressType}}</p>\n                </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Tax Details</p>\n                    </div>\n                    <div ng-If=\"SummaryPage.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <p>Tax Details not available</p>\n                    </div>\n\n                    <div ng-If=\"!SummaryPage.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying Country</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCountryDescription}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying City</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCity}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Id</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxId}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax ID type</p>\n                            <p class=\"col-md-6 bg-white\">{{SummaryPage.taxIdTypeList[$index].description}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> --><!-- Nominee details --><div class=row ng-if=\"SummaryPage.nomineeData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Nominee Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoNomineePage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col nominee-details-summary-wrapper\"><div class=\"col-xs-12 col-sm-6 col-md-4 nominee-details\" ng-repeat=\"x in SummaryPage.nomineeData track by $index\"><div class=\"row m-top\"><p class=col-md-12 style=\"font-size: 14px; color: #497eac\">Nominee {{$index + 1}} Details</p></div><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeName}}</p> --></div><div class=\"row m-top\" ng-if=x.emailId><p class=col-md-6>Nominee Email ID</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.emailId readonly></div><div class=\"row m-top\" ng-if=x.emailId><p class=col-md-6>Nominee Mobile No</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.mobileNumber readonly></div><div class=\"row m-top\" ng-if=\"x.panNumber && !Summary.showNomineeUpdate\"><p class=col-md-6>Nominee PAN</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.panNumber readonly></div><div class=\"row m-top\" ng-if=SummaryPage.showNomineeUpdate><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType === \'PAN_CARD\'\">Nominee PAN</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'AADHAR_CARD\'\">Nominee Aadhaar</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'DRIVING_LICENSE\'\">Nominee Driving License</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'PASSPORT\'\">Nominee Passport</p><input ng-if=\"x.identityProofType && x.identityProofType !==\'AADHAR_CARD\'\" class=\"col-md-6 bg-white\" type=text ng-model=x.identityProofNumber readonly> <input ng-if=\"x.identityProofType && x.identityProofType ===\'AADHAR_CARD\'\" class=\"col-md-6 bg-white\" type=text ng-model=\"\'XXXX XXXX \' + x.identityProofNumber\" readonly></div><div class=\"row m-top\"><p class=col-md-6>Nominee Relation</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeRelation readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeRelation}}</p> --></div><div class=\"row m-top\" ng-if=x.dob><p class=col-md-6>Nominee DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.dob readonly><!-- <p class=\"col-md-6 bg-white\">{{x.dob}}</p> --></div><div class=\"row m-top\" ng-if=x.minor><p class=col-md-6>The Nominee is Minor</p><input type=checkbox ng-model=x.minor disabled></div><div class=\"row m-top\"><p class=col-md-6>Nominee Percentage</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.percentage readonly><!-- <p class=\"col-md-6 bg-white\">{{x.percentage}}</p> --></div><div class=\"row m-top\" ng-if=!x.minor><p class=col-md-6>The Nominee is Minor</p><input type=checkbox ng-model=x.minor disabled></div><div class=\"row m-top\" ng-if=x.guardianName><p class=col-md-6>Guardian\'s Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.guardianName}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.guardianRelationshipWithNominee[$index].relationDesc><p class=col-md-6>Guardian\'s Relationship</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.guardianRelationshipWithNominee[$index].relationDesc readonly></div><div class=\"row m-top\" ng-if=SummaryPage.addressLine1[$index]><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Address Line1</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Address Line1</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.addressLine1[$index] readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.addressLine1[$index]}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.addressLine2[$index]><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Address Line2</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Address Line2</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.addressLine2[$index] readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.addressLine2[$index]}}</p> --></div><div class=\"row m-top\" ng-if=SummaryPage.nomineeCountry[$index].countryName><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s Country</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.nomineeCountry[$index].countryName readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.nomineeCountry[$index].countryName}}</p> --></div><div class=\"row m-top\" ng-if=\"x.nomineeAddress.city || x.guardianAddress.city\"><p class=col-md-6 ng-if=SummaryPage.gAddress[$index]>Guardian\'s City</p><p class=col-md-6 ng-if=!SummaryPage.gAddress[$index]>Nominee\'s City</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"x.nomineeAddress.city ? x.nomineeAddress.city : x.guardianAddress.city\" readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.city ? x.nomineeAddress.city : x.guardianAddress.city }}</p> --></div><div class=\"row m-top\" ng-if=x.nomineeAddress.pinCode><p class=col-md-6>Nominee PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeAddress.pinCode readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.pinCode}}</p> --></div><div class=\"row m-top\" ng-if=x.guardianAddress.pinCode><p class=col-md-6>Guardian\'s PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianAddress.pinCode readonly><!-- <p class=\"col-md-6 bg-white\">{{x.guardianAddress.pinCode}}</p> --></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"padding-left: 0px; margin-top: 15px\"><div class=col-md-4 ng-if=SummaryPage.incapacitationDeclaration><p style=\"font-weight: bold;font-size: 15px\">Incapacitation Details</p><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.incapacitationDeclaration.nomineeName readonly></div><div class=\"row m-top\"><p class=col-md-6>Nominee Number</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.incapacitationDeclaration.nomineeNumber readonly></div><div class=\"row m-top\" ng-if=SummaryPage.incapacitationDeclaration.percentage><p class=col-md-6>Percentage</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"SummaryPage.incapacitationDeclaration.percentage ? SummaryPage.incapacitationDeclaration.percentage + \'%\' : \'OT AVAILABLE\'\" readonly></div><div class=\"row m-top\" ng-if=SummaryPage.incapacitationDeclaration.amount><p class=col-md-6>Amount</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.incapacitationDeclaration.amount readonly></div></div><div class=\"col-md-4 statement-dec-summary\" ng-if=SummaryPage.accountHoldingDeclaration><p style=\"font-weight: bold;font-size: 15px\">Statement of Holding</p><div class=\"row m-top\"><p class=col-md-12>{{SummaryPage.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\' : \'Nomination: No\'}}</p></div></div></div></div><!-- bank details  --><div class=row style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Bank Details</p><img src=../../../assets/images/icons/edit.png ng-click=SummaryPage.gotoBankPage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Bank Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.bankName readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankName}}</p> --></div><div class=\"row m-top\"><p class=\"col-md-6 m-top\">Account Type</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.bank.accountType readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.bank.accountType}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Payout Mechanism</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.payoutDescriptionData.payoutDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.payoutDescriptionData.payoutDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Account Number</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.accountNumber readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.accountNumber}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>IFSC Code</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.ifsccode readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.ifsccode}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch Location</p><textarea class=\"col-md-6 bg-white textAreaSize\" rows=4 type=text style=\"height: 72PX;resize:none\" ng-model=SummaryPage.folioDetails.bankDetails.bankBranch readonly> </textarea><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankBranch}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch City</p><input class=\"col-md-6 bg-white\" type=text ng-model=SummaryPage.folioDetails.bankDetails.bankCity readonly><!-- <p class=\"col-md-6 bg-white\">{{SummaryPage.folioDetails.bankDetails.bankCity}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Cheque leaf Image</p><div class=\"col-md-6 bg-white minbg\" style=\"display: flex;justify-content: space-between;align-items: center\"><p class=ml-15 style=\"font-weight: 100;line-height: 12px\">Cheque leaf Image</p><img src=../../../../assets/images/icons/ic-img.png ng-click=SummaryPage.openUploadedDoc(SummaryPage.folioDetails.bankDetails.chequeLeaf) alt=\"\" style=\"height: 15px\"></div></div></div></div></div><div class=\"modal-footer center-aligned\"><!-- <button class=\"btn btn-primary-action\" style=\"border-radius: 40px;\" ng-click=\"SummaryPage.backpage()\"> Back\n        </button> --> <button class=btn style=\"border-radius: 40px; padding: 0px;border: none; padding-left: 25px;padding-right: 25px;height: 35px; background-color: #ff5153;color:white\" ng-click=SummaryPage.createNewFolio()>Send For Approval</button></div></div></div><style>p {\n        font-size: 12px;\n        font-weight: 600;\n        font-family: \"monasans-bold\", sans-serif !important;\n    }\n\n    .m-left-0 {\n        margin-left: 0px;\n    }\n\n    .m-top {\n        margin-top: 5px;\n    }\n    input{\n        font-size: 14px;\n        font-weight: 400;\n        font-family: \"monasans-bold\", sans-serif !important;\n        color: #444444;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    }\n    .bg-white {\n        font-family: \"monasans-bold\", sans-serif !important;\n        color: #444444;\n        background-color: white;\n        font-size: 13px;\n        text-align: start;\n        border-radius: 6px;\n        padding: 0px;\n        margin: 0px;\n        font-weight: 100;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n        height: 30px;\n        border: 1px solid lightgray;\n        padding-left: 5px;\n    }\n    .userName{\n        font-family: \"Mona Sans\",sans-serif;\n        font-weight: bold;\n        text-transform: uppercase;\n        font-size: 15px;\n        padding-top: 10px;\n    }\n\n    .nominee-details-summary-wrapper {\n      display: flex;\n      width: 100%;\n      overflow-x: auto;\n      padding-bottom: 15px;\n    }\n\n    .nominee-details-summary-wrapper > .nominee-details {\n      flex: 0 0 auto;\n    }\n\n    @media screen and (max-width: 990px) {\n    .minbg{\n        width: 177px;\n    }\n    p{\n        margin-left: -15px;\n    }\n    .ml-15{\n        margin-left: 0px;\n    }\n  }\n\n\n  @media only screen and (max-device-width : 1008px) {\n    .reviewFolioPage{\n    margin-left: 5px;\n    }\n  }\n  @media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small{\n      width: 163px !important;\n    }\n    .btn{\n        width: 163px;\n    }\n  .stepper-horizontal-responsive .step li {\n       z-index: 5;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2){\n    z-index: 4;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3){\n    z-index: 3;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4){\n    z-index: 2;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5){\n    z-index: 1;\n  }\n}\n.padding-x{\n    padding-right: 10px;\n}\n.border-right{\n    border-right: 1px solid #ccc;\n}\n@media only screen and (max-device-width : 960px) {\n    .border-right{\n    border-right:none;\n}\n  }</style>");
$templateCache.put("app/new-investor/investment-detail/amount-details/amount-details.html","<div class=container-fluid ng-init=AmountDetails.init()><form class=verification-form autocomplete=off id=amountDetailsForm name=amountDetailsForm ng-if=\"AmountDetails.PaymentModePurchse ==\'SIP\'\" novalidate><!-- amount --><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Amount</p></div><div class=\"form-group col-xs-12 col-md-6 input-normal\" ng-class=\"{error:amountDetailsForm.anAmount.$dirty && amountDetailsForm.anAmount.$invalid}\" style=\"margin-bottom: 5px\"><div class=\"input-icons w-336\"><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> <input class=\"form-control input-border-line\" type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" id=amt ignore-mouse-wheel name=anAmount ng-model=AmountDetails.formData.amount ng-maxlength=13 ng-change=AmountDetails.checkSipValidations(); autofocus required style=\"height: 40px;width: 336px;padding: 0px 0px 0px 28px\"></div><span class=error-input ng-show=\"(amountDetailsForm.anAmount.$dirty && amountDetailsForm.anAmount.$error.required)\">&nbsp;&nbsp; Amount is required</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.isMin\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.validations.minAmount|unit}}</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.isMax\" class=error-input>Maximum amount should be &#8377; {{AmountDetails.validations.maxAmount|unit}}</span> <span ng-if=\"AmountDetails.formData.amount && !AmountDetails.isMax && !AmountDetails.isMin && (AmountDetails.validations.amountMultiples && !AmountDetails.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{AmountDetails.validations.amountMultiples|unit}}</span><br><span class=error-input ng-if=amountDetailsForm.anAmount.$error.maxlength>Please input valid amount!</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.amountExceeded\" class=error-input>{{AmountDetails.VALIDATE_DATA.AMOUNT_EXCEEDED.substring(0, 33)}} ... <a role=button ng-click=AmountDetails.showAmtExceedMsg()>More</a> </span><span><div class=row style=\"margin-top: 10px\"><div class=\"maxDiv col-xs-4 col-md-4 mt-2\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\"><button class=amountBtn style=\"border:1px solid #b7b7b7\" type=button ng-click=AmountDetails.getAmount(false,arrayAmount)>&#8377;{{arrayAmount}}</button></div></div></span></div><!-- <div class=\"col-xs-12 col-md-4\" >\n        <div class=\"warning\">\n          <img src=\"../../../assets/images/icons/light-bulb.png\">\n          <div><br>Minimum investment amount is 5000</div>\n        </div>\n      </div> --></div><div class=row><div class=\"col-xs-12 col-md-4 mt-2\"><label id=newJournyDivDisplayWords>{{AmountDetails.amountInWords}}</label><span ng-if=AmountDetails.formData.amount>(In Words)</span></div></div><!-- <div class=\"row\">\n      <div class=\"col-xs-4 col-md-1\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\">\n        <button class=\"amountBtn\" style=\"border:1px solid #b7b7b7\" type=\"button\"\n          ng-click=\"AmountDetails.getAmount(arrayAmount)\">&#8377;{{arrayAmount}}</button>\n      </div>\n    </div> --><br><br><!-- installment --><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Installment Frequency</p></div><div class=\"col-xs-12 col-md-10\"><div class=\"row extrawidth\" style=\"margin-left: 2px\"><p ng-click=\"AmountDetails.changeFrequency(AmountDetails.frequencyData[0], true)\" ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Monthly\' ? \'btn-active1 first-btn m-btn1 col-xs-3 col-md-2\' : \'btn-deactive1 m-btn1 first-btn col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Monthly</span></p><p ng-click=\"AmountDetails.changeFrequency(AmountDetails.frequencyData[1], true)\" ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Quarterly\' ? \'btn-active1 m-btn2 col-xs-3 col-md-2\' : \'btn-deactive1 m-btn2 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Quarterly</span></p><p ng-click=\"AmountDetails.changeFrequency(AmountDetails.frequencyData[2], true)\" ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Half Yearly\' ? \'btn-active1 m-btn3 col-xs-3 col-md-2\' : \'btn-deactive1  m-btn3 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Half Yearly</span></p><p ng-click=\"AmountDetails.changeFrequency(AmountDetails.frequencyData[3], true)\" ng-attr-class=\"{{AmountDetails.SelectedFrequency.name == \'Yearly\' ? \'btn-active1 last-btn m-btn4 col-xs-3 col-md-2\' : \'btn-deactive1 last-btn m-btn4 col-xs-3 col-md-2\' }}\"><span style=\"margin: auto;font-weight: 500\" role=button>Yearly</span></p></div></div></div><br><!-- IDCW --><div class=radio-block ng-if=\"AmountDetails.formData.investmentOption.toUpperCase() != \'GROWTH\' \" style=\"margin-bottom: 20px\"><p class=investmentTitle>Investment option</p><div class=radio-block><span class=radio><input type=radio id=reInvest name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=Y> <span class=check></span></span><label>&nbsp; Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label><br><span class=radio><input type=radio id=Payout name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=N> <span class=check></span></span><label>&nbsp; Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div><!-- IDCW END --><!-- <div class=\"row\">\n        <div class=\"col-xs-12 col-md-7\">\n          <p class=\"investmentTitle\">Payment Options</p>\n          <div class=\"col-md-12 row form-group\" ng-if=\"AmountDetails.formData.frequency!=\'BZ\'\">\n            <div class=\"radio-block\" ng-repeat=\"_option in AmountDetails.paymentOptions \">\n              <span class=\"radio\" ng-if=\"!(!AmountDetails.isOTMEnabled && _option==\'OTM\')\">\n                <input type=\"radio\" id=\"paymentOption{{_option}}\" ng-value=\"_option\" name=\"paymentOption\"\n                  ng-change=\"AmountDetails.changedPaymentOption()\" ng-model=\"AmountDetails.formData.sipPaymentOption\" />\n                <span class=\"check\"></span>\n              </span>\n              <span class=\"radio-label\">{{AmountDetails.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span>\n            </div>\n          </div>\n        </div>\n      </div> --><!-- <div class=\"col-md-8 point-to-note imp-info\" style=\"margin: 10px 0 9px;padding: 15px;\n      border-radius: 6px;\">\n      Please Note: <br><br>\n      <p>\n      <ul style=\"color: black\">\n        <li><span>To know more about various payment options along with their efficiency for the purpose of NAV\n            Applicability -<a ng-click=\'AmountDetails.paymentNavUrl()\' href=\'javascript:void(0)\'\n              class=\"nav-faq-link\">Click here</a>\n          </span></li>\n        <li><span>CAMS OTM(COTM) is not available for with first installment facility</span></li>\n      </ul>\n      </p>\n    </div> --><div class=row ng-if=AmountDetails.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP><div class=col-md-12><div><ng-bind-html dynamic=AmountDetails.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP.content></ng-bind-html></div></div></div><br><!-- Select Bank End--><div class=row><!-- <div class=\"col-md-6\">\n          <div>\n            <p class=\"investmentTitle\">Select Bank</p>\n          </div>\n          <div class=\"selectfield\" ng-class=\"{error:amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$invalid}\">\n            <select class=\"\" name=\"bank\" ng-disabled=\"false\" class=\"getbank\" id=\"selectbank\"\n              ng-model=\"AmountDetails.formData.bankInfo\"\n              ng-options=\"bank.bankName for bank in AmountDetails.bankList track by bank.bankCode\"\n              ng-change=\"AmountDetails.changeBank()\"\n              ng-init=\"AmountDetails.formData.bankInfo = AmountDetails.formData.bankInfo ? AmountDetails.formData.bankInfo : null\"\n              required>\n            </select>\n\n            <span class=\"error-input\"\n              ng-show=\"amountDetailsForm.bank.$dirty && amountDetailsForm.bank.$error.required && !AmountDetails.formData.bankName\"\n              ng-bind=\"AmountDetails.VALIDATE_DATA.BANK_REQUIRED\"></span>\n          </div>\n        </div> --><div class=col-md-12 style=\"margin-bottom: 12px\"><div class=\"col-md-6 p-0 w-auto\" style=\"margin-top: 10px\"><label class=form-label style=\"font-weight: bold\">Do you wish to pay First installment with your SIP Registration:</label></div><div class=\"radio-block first-installment-radio col-md-2\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=AmountDetails.sipFirstInstallment ng-change=AmountDetails.changeFirstInstallment(true) ng-value=true> <span class=check></span> </span><span class=radio-label><label>Yes</label></span></div><div class=\"radio-block first-installment-radio col-md-2\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=AmountDetails.sipFirstInstallment ng-change=AmountDetails.changeFirstInstallment(false) ng-value=false> <span class=check></span> </span><span class=radio-label><label>No</label></span></div></div><br><!-- payment option start--><div class=row><div class=col-md-12><p class=\"investmentTitle col-md-12\">Payment Option</p><div class=\"radio-block col-md-12\" ng-repeat=\"payOption in AmountDetails.paymentOptions\"><span class=radio><input type=radio id={{payOption.value}} ng-model=AmountDetails.formData.sipPaymentOption ng-value=payOption name=paymentOption required> <span class=check></span></span><label for={{payOption}}>{{AmountDetails.PaymentOptionDescription[payOption]}}</label></div></div></div><!-- payment option end --><!-- payment selection mode start --><div class=row ng-if=AmountDetails.sipFirstInstallment><div class=col-md-12><p class=\"investmentTitle col-md-12\">Payment Mode Selection</p><div class=radio-block ng-repeat=\"paymentMode in AmountDetails.PAYMENT_MODE\"><div class=\"col-md-3 col-3 col-sm-12 col-lg-3\"><span class=radio><input type=radio id={{paymentMode.value}} ng-change=AmountDetails.changepaymentMode() ng-model=AmountDetails.formData.paymentMode ng-value=paymentMode.key name=paymentMode required> <span class=check></span></span><label for={{paymentMode.value}}>{{paymentMode.value}}</label></div></div></div></div><!-- payment mode end --></div><!-- Start Dates --><div class=row><div class=col-md-6><p class=investmentTitle>Start Date :</p><div class=\"w-336 verify-acc input-group date date date-picker transaction-cal\" ng-class=\"{error:amountDetailsForm.startDate.$dirty && amountDetailsForm.startDate.$invalid}\" date-calendar data-viewmode={{AmountDetails.viewMode}} data-date-default=AmountDetails.formData.startDate data-enabled-dates=AmountDetails.enabledStartDates data-min-date=AmountDetails.startMinDateOTM data-max-date=AmountDetails.startMaxDate data-on-date-change=AmountDetails.changeStartDate format=DD-MMM-YYYY id=weeklyStartDate data-enable=true style=\"position: relative\"><input type=text name=startDate id=startDate placeholder=\"Start Date - DD-MMM-YYYY\" style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #B8C6D1;border-radius: 5px\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span></span><label ng-if=AmountDetails.amountDetailsForm.startDate>Start Date - DD-MMM-YYYY</label><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=amountDetailsForm.startDate.$error.required ng-bind=AmountDetails.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=amountDetailsForm.isOTMStartDate ng-bind=\"AmountDetails.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + AmountDetails.bankInfo.omStartDate\"></span></div></div></div><div class=row><div class=col-md-6><p class=investmentTitle style=\"margin:10px 0px 5px 0px\">End Date :</p><div ng-class=\"{\'anything-disabled\': AmountDetails.formData.isTillPerpetuity}\" class=\"w-336 verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:amountDetailsForm.endDate.$dirty && amountDetailsForm.endDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=AmountDetails.formData.endDate data-on-date-change=AmountDetails.changeEndDate data-enabled-dates=AmountDetails.enabledEndDates data-view-date=AmountDetails.enabledEndDateView data-min-date=AmountDetails.enabledEndDates[0] ng-disabled=AmountDetails.formData.startDate data-enable=true id=weeklyEndDate showdefault=false><input type=text name=endDate id=endDate ng-keyup=AmountDetails.autoDate2() autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" required style=\"width: 100%;height: 40px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #B8C6D1;border-radius: 5px\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><!-- <label ng-if=\"AmountDetails.formData.endDate\">End Date - DD-MMM-YYYY</label> --> <span class=bar></span> <span class=error-input ng-show=\"amountDetailsForm.endDate.$dirty && amountDetailsForm.endDate.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=AmountDetails.isOTMEndDate ng-bind=AmountDetails.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div><div><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=defaultdate id=defaultdate ng-checked=AmountDetails.formData.isTillPerpetuity ng-click=AmountDetails.changeTillPerpetuityFlag(null,true)><label class=\"confirmationnote col-xs-12 col-md-7\" for=defaultdate ng-checked=AmountDetails.formData.isTillPerpetuity style=\"font-size: 13px;font-weight: bold;width: auto;  margin-top: 20px\">Choose Default End Date, which is 2099</label></div></div></div><!-- End Dates --><div class=row ng-if=\"AmountDetails.formData.showTopUpBlock && !AmountDetails.sipFirstInstallment\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><label class=\"form-label less\" style=\"font-weight: bold;font-size: 12px\">SIP Top-up Details</label></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=!AmountDetails.isReseting><div class=row><input type=checkbox class=\"nomineeCheckbox col-xs-12 col-md-1\" name=sipToptup id=sipToptup ng-checked=AmountDetails.formData.sipTopupEnabled ng-click=AmountDetails.changeSipTopupSelected()><label class=\"confirmationnote col-xs-12 col-md-7\" for=sipToptup ng-checked=AmountDetails.formData.sipTopupEnabled style=\"margin: 15px;font-size: 12px; font-weight: 600\">SIP Top-up</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=AmountDetails.formData.sipTopupEnabled style=\"padding: 0px\"><div ng-class=\"{\'anything-disabled\': !AmountDetails.formData.sipTopupSelected }\" class=col-md-12><div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Amount :</p><div class=\"input-normal icon-input\" ng-class=\"{error:(AmountDetails.tForm.topupAmount.$invalid && AmountDetails.tForm.topupAmount.$dirty),\'has-data\':AmountDetails.formData.topupDetails.amount}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=topupAmount ng-model=AmountDetails.formData.topupDetails.amount ng-maxlength=13 ng-disabled=AmountDetails.formData.topupDetails.percentage ng-change=AmountDetails.checkSipValidations(true);AmountDetails.getTopupFrequencyList(); onkeyup=\"NumToWord(this.value,\'divDisplayInWords\')\" ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.percentage && !AmountDetails.formData.topupDetails.amount) || !AmountDetails.formData.topupDetails.percentage)\" style=\"padding: 0px 0px 0px 30px; border: none;border: 1px solid gray;border-radius: 5px;height: 40px;width: 100%\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon style=\"position: absolute;top: 30%;left: 8px\"></i> <span class=error-input ng-show=\"AmountDetails.tForm.topupAmount.$dirty && AmountDetails.tForm.topupAmount.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"AmountDetails.formData.topupDetails.amount && AmountDetails.isTopupMinAmt\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.validations.topupMinAmt|unit}}</span> <span class=error-input ng-if=amountDetailsForm.topupAmount.$error.maxlength>Please input valid amount!</span> <span ng-if=\"AmountDetails.formData.topupDetails.amount  && !AmountDetails.isTopupMinAmt && (AmountDetails.validations.topupAmtMultples&&!AmountDetails.isTopUpMultiples)\" class=error-input>Please provide In multiples of &#8377; {{AmountDetails.validations.topupAmtMultples|unit}}</span></div></div><div class=\"col-sm-2 col-md-1 or-part text-center topUpdiv10\" ng-if=AmountDetails.showTopUpPercentage>OR</div><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\" ng-if=AmountDetails.showTopUpPercentage><p class=investmentTitle>Percentage (%) :</p><div class=input-normal ng-class=\"{error:(AmountDetails.tForm.topupPercentage.$invalid && AmountDetails.tForm.topupPercentage.$dirty),\'has-data\':AmountDetails.formData.topupPercentage}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=topupPercentage ng-model=AmountDetails.formData.topupDetails.percentage ng-disabled=AmountDetails.formData.topupDetails.amount ng-change=AmountDetails.checkSipValidations();AmountDetails.getTopupFrequencyList();AmountDetails.changeTopUpFreq() ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.percentage && !AmountDetails.formData.topupDetails.amount) || !AmountDetails.formData.topupDetails.amount)\" style=\"width: 100%;\n                    height: 40px;\n                border: none;border-radius: 5px;border: 1px solid gray\"> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"AmountDetails.tForm.topupPercentage.$dirty && AmountDetails.tForm.topupPercentage.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.PERCENT_REQUIRED></span> <span ng-if=\"AmountDetails.formData.topupDetails.percentage && AmountDetails.isTopupMinPerc\" class=error-input>Minimum percentage should be {{AmountDetails.validations.topupMinPercentage|unit}}%</span> <span ng-if=\"AmountDetails.formData.topupDetails.percentage && !AmountDetails.isTopupMinPerc && (AmountDetails.validations.topupPercentageMultples&&!AmountDetails.isTopupPercMultiples)\" class=error-input>Please provide in multiple of {{AmountDetails.validations.topupPercentageMultples|unit}}%</span></div></div></div><div class=row><div class=col-md-12><label class=\"form-label less\" style=\"font-weight: 600;margin-bottom: 5px\">Frequency</label></div></div><div class=row><div class=\"col-md-5 form-group\"><div class=radio-block ng-repeat=\"freq in AmountDetails.topupFrequencyList\" style=\"display: flex;align-items: center\"><span class=radio><input type=radio ng-model=AmountDetails.formData.topupDetails.frequency ng-value=freq.key name=topupFrequency ng-change=AmountDetails.changeTopUpFreq()> <span class=check></span></span><p class=radio-label style=margin-left:7px>{{freq.value}}</p></div></div></div><div class=row><div class=col-md-12><label class=\"form-label less\" style=\"font-weight: bold;margin: 5px 0px 5px 0px\">SIP Top-up CAP</label></div></div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Amount :</p><div class=\"input-normal icon-input\" ng-class=\"{error:(AmountDetails.tForm.capAmount.$invalid && AmountDetails.tForm.capAmount.$dirty && AmountDetails.isminCapAmount),\'has-data\':AmountDetails.formData.capAmount}\"><input class=\"form-control input-border-line\" type=number ignore-mouse-wheel name=capAmount ng-model=AmountDetails.formData.topupDetails.capAmount ng-maxlength=13 ng-disabled=AmountDetails.formData.topupDetails.capMonthYear onkeyup=\"NumToWord(this.value,\'capAmntDisplayInWords\')\" ng-change=AmountDetails.capAmountChanged(); ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) || !AmountDetails.formData.topupDetails.capMonthYear)\" style=\"padding: 0px 0px 0px 30px; border: none;border: 1px solid gray;border-radius: 5px;height: 40px;width: 100%\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon style=\"position: absolute;top: 30%;left: 8px\"></i> <span class=error-input ng-show=\"AmountDetails.tForm.capAmount.$dirty && AmountDetails.tForm.capAmount.$error.required\" ng-bind=AmountDetails.VALIDATE_DATA.AMOUNT_REQUIRED></span><br><span class=error-input ng-if=amountDetailsForm.capAmount.$error.maxlength>Please input valid amount!</span> <span ng-if=\"AmountDetails.formData.topupDetails.capAmount && AmountDetails.isminCapAmount\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.minCapAmount}}</span></div></div><div class=\"col-sm-2 col-md-1 or-part text-center topUpdiv10\">OR</div><div class=\"col-xs-12 col-sm-5 col-md-4 topUpdiv30\"><p class=investmentTitle>Cap Month Year - MMM-YYYY :</p><div><div class=selectfield><select class=\"browser-default custom-select\" name=capDates ng-disabled=AmountDetails.formData.topupDetails.capAmount ng-options=\"_dates for _dates in AmountDetails.capDates\" ng-model=AmountDetails.formData.topupDetails.capMonthYear ng-init=\"AmountDetails.formData.topupDetails.capMonthYear=AmountDetails.formData.topupDetails.capMonthYear?AmountDetails.formData.topupDetails.capMonthYear: null\" ng-required=\"AmountDetails.formData.sipTopupEnabled && ((!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) || !AmountDetails.formData.topupDetails.capAmount)\" style=\"background: white;border: none;border: 1px solid;border-radius: 5px;height: 40px; width: 100%\"><option value=\"\">Cap Month Year - MMM-YYYY</option></select></div></div></div></div></div></div></div></div><div class=row><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=AmountDetails.formData.sipTopupEnabled ng-disabled=\"amountDetailsForm.anAmount.$invalid ||\n       !AmountDetails.formData.startDate ||\n       !AmountDetails.formData.endDate  ||\n       !AmountDetails.formData.sipTopupEnabled ||\n       AmountDetails.isminCapAmount||\n       (!AmountDetails.formData.topupDetails.capAmount && !AmountDetails.formData.topupDetails.capMonthYear) ||\n       (!AmountDetails.formData.topupDetails.amount &&  !AmountDetails.formData.topupDetails.percentage) || AmountDetails.isMin || AmountDetails.amountExceeded || !AmountDetails.formData.sipPaymentOption\" ng-click=AmountDetails.next1()>CONTINUE</button></div><div class=row><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=!AmountDetails.formData.sipTopupEnabled ng-disabled=\"amountDetailsForm.anAmount.$invalid ||\n       !AmountDetails.formData.startDate ||\n       !AmountDetails.formData.endDate || AmountDetails.formData.sipTopupEnabled || AmountDetails.isMin || AmountDetails.amountExceeded || !AmountDetails.formData.sipPaymentOption\" ng-click=AmountDetails.next1()>CONTINUE</button></div></form><form class=verification-form autocomplete=off id=purchseamountDetailsForm name=purchseamountDetailsForm ng-if=\"AmountDetails.PaymentModePurchse ==\'PURCHASE\'\"><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Amount</p></div><div class=\"col-xs-12 col-md-6 input-normal\" ng-class=\"{error:purchseamountDetailsForm.anAmount.$dirty && purchseamountDetailsForm.anAmount.$invalid}\" style=\"margin-bottom: 5px\"><div class=\"input-icons w-336\"><img class=ricon src=assets/images/icons/rupee-grey.png alt=\"\" srcset=\"\" style=\"padding: 0 0 0 0\"> <input class=\"form-control input-border-line w-336\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" type=number name=anAmount id=amt onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel ng-model=AmountDetails.formData.amount ng-maxlength=13 ng-change=AmountDetails.checkPurchseAmountValidations(); autofocus required style=\"height: 40px;padding: 0px 0px 0px 30px\"></div><span class=error-input ng-show=\"(purchseamountDetailsForm.anAmount.$dirty && purchseamountDetailsForm.anAmount.$error.required)\">&nbsp;&nbsp; Amount is required</span> <span ng-if=\"AmountDetails.formData.amount && AmountDetails.ispurchseMinAmount\" class=error-input>Minimum amount should be &#8377; {{AmountDetails.purchseSchemeValidationData.minFirstPurchaseAmt}}</span><br><span class=error-input ng-if=purchseamountDetailsForm.anAmount.$error.maxlength>Please input valid amount!</span> <span><div class=row style=\"margin-top: 10px\"><div class=\"maxDiv col-xs-4 col-md-4 mt-2\" ng-repeat=\"arrayAmount in AmountDetails.formData.amountArray\"><button class=amountBtn style=\"border:1px solid #b7b7b7\" type=button ng-click=AmountDetails.getAmount(false,arrayAmount)>&#8377;{{arrayAmount}}</button></div></div></span></div></div><div class=row><div class=\"col-xs-12 col-md-4 mt-2\"><label id=newJournyPurchaseDivDisplayWords>{{AmountDetails.amountInWords}}</label><span ng-if=AmountDetails.formData.amount>(In Words)</span></div></div><br><!-- payment selection mode --><div ng-if=AmountDetails.PAYMENT_MODE><p class=investmentTitle>Payment Mode Selection</p><div class=row><div class=radio-block ng-repeat=\"paymentMode in AmountDetails.PAYMENT_MODE\"><div class=\"col-md-3 col-3 col-sm-12 col-lg-3\"><span class=radio><input type=radio id={{paymentMode.value}} ng-change=AmountDetails.changepaymentMode() ng-model=AmountDetails.formData.paymentMode ng-value=paymentMode.key name=paymentMode required> <span class=check></span></span><label for={{paymentMode.value}}>{{paymentMode.value}}</label></div></div></div></div><!-- IDCW --><div class=radio-block ng-if=\"AmountDetails.formData.investmentOption.toUpperCase() != \'GROWTH\' \" style=\"margin-bottom: 20px\"><p class=investmentTitle>Investment option</p><div class=radio-block><div style=\"display: flex;align-items: center\"><div class=radio><input type=radio id=reInvest name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=Y> <span class=check></span></div><span>&nbsp; Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</span></div><br><div style=\"display: flex;align-items: center\"><div class=radio><input type=radio id=Payout name=idcw ng-change=\"\" ng-model=AmountDetails.dividenInevstmentOption value=N> <span class=check></span></div><span>&nbsp; Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</span></div></div></div><!-- Dynamic section --><div class=row ng-if=AmountDetails.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_Purchase_NJ><div class=col-md-12><div><ng-bind-html dynamic=AmountDetails.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_Purchase_NJ.content></ng-bind-html></div></div></div><br><!-- IDCW END --><div class=row style=\"margin: 0\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"purchseamountDetailsForm.anAmount.$invalid ||\n       AmountDetails.ispurchseMinAmount || !AmountDetails.purchseSchemeValidationData.minFirstPurchaseAmt || !AmountDetails.formData.paymentMode\" ng-click=AmountDetails.next1()>INVEST</button></div></form></div><style>.W15 {\n    width: 15% !important;\n  }\n\n  .radio-block label {\n    position: relative;\n    top: -14px;\n    left: 7px;\n  }\n\n  .w-336 {\n    width: 336px;\n  }\n\n  .input-icons {\n    position: relative;\n  }\n\n  .input-icons>img {\n    position: absolute;\n    top: 35%;\n    left: 15px;\n  }\n\n  .maxDiv {\n    width: 70px;\n  }\n\n  @media only screen and (max-width: 768px) {\n    .selectfield {\n      width: 100%;\n    }\n\n    .maxDiv {\n      width: 100px;\n    }\n\n    .topUpdiv30 {\n      width: 80%;\n    }\n\n    .topUpdiv10 {\n      margin-bottom: 18px;\n      width: 80%;\n    }\n  }\n\n  @media only screen and (min-width: 768px) {\n    .topUpdiv30 {\n      width: 40%;\n    }\n\n    .topUpdiv10 {\n      margin-top: 35px;\n      width: 5%;\n    }\n  }\n  .error-input{\n    display: block;\n    top:0px;\n    position: static !important;\n  }\n  .new-investors .kyc-form-container .form-page-container .nomineeCheckbox + .confirmationnote:before{\n    padding: 2px 5px 3px 4px;\n    font-size: 9px;\n\n  }\n  .p-0{\n    padding: 0px;\n  }\n  .w-auto{\n    width: auto;\n  }</style>");
$templateCache.put("app/new-investor/folio-creation/folio-nominee-details/folio-nominee-details.html","<div class=nomineedetails ng-init=FolioNomineeDetails.init()><form id=nomineeForm name=nomineeForm ng-submit=FolioNomineeDetails.submitNomineeData() novalidate><br><p class=title1 style=\"margin: 0px 0px 0px -10px\">Do you wish to opt out of nomination?</p><br><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"row btn-yesno\" style=\"width: 336px\"><!--            <p ng-click=\"FolioNomineeDetails.addnomineedata(0)\"--><!--              ng-attr-class=\"{{FolioNomineeDetails.addnominee && \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' || \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\">--><!--              <span ng-click=\"FolioNomineeDetails.addnomineedata()\" style=\"margin: auto;\">Yes</span>--><!--            </p>--><!--            <p ng-click=\"FolioNomineeDetails.addnomineedata(1)\"--><!--              ng-attr-class=\"{{FolioNomineeDetails.addnominee && \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' || \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\'  }}\">--><!--              <span ng-click=\"FolioNomineeDetails.addnomineedata(1)\" style=\"margin: auto;\">No</span>--><!--            </p>--><p ng-click=FolioNomineeDetails.addnomineedata(0) ng-attr-class=\"{{FolioNomineeDetails.addnominee && \' btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' || \' btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span ng-click=FolioNomineeDetails.addnomineedata(0) style=\"margin: auto\">Yes</span></p><p ng-click=FolioNomineeDetails.addnomineedata(1) ng-attr-class=\"{{FolioNomineeDetails.addnominee && \' btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' || \' btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\'  }}\"><span ng-click=FolioNomineeDetails.addnomineedata(1) style=\"margin: auto\">No</span></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div ng-if=FolioNomineeDetails.addnominee style=\"width: 269px;\n          height: 64px;\n          /* UI Properties */\n          background: #FFFBE3 0% 0% no-repeat padding-box;\n          border: 1px solid #EAE7D5;\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          border-radius: 6px;\n          opacity: 1\"><img src=../../../assets/images/icons/light-bulb.png style=\"width: 22px;\n            height: 22px;margin: 10px\"><p style=\"width: 219px;\n            height: 39px;\n            /* UI Properties */\n            text-align: left;\n            font: normal normal normal 12px/20px Poppins;\n            letter-spacing: 0px;\n            color: #000000\">you can add upto {{FolioNomineeDetails.nomineeLimit}} nominees. The total proportion should be 100%.</p></div></div></div><div ng-if=FolioNomineeDetails.addnominee><div class=row><div class=\"col-sm-6 col-md-12\"><p style=\"font-size: 14px\"><strong>Nominee Details</strong> <i class=\"tooltip-info-icon base-tooltip\" ng-if=FolioNomineeDetails.showNomineeUpdate data-html=true tooltip data-toggle=tooltip data-bs-placement=right title=\"<div>\n                  SEBI Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650, dated January 10, 2025\n                  states that, in case of Joint Account/Folio: <br>\n                  1. In case of “Demise of one or more joint holder(s)” event: Transmission of\n                    Account/Folio to: Surviving holder(s) through name deletion, The surviving holder(s) shall\n                    inherit the assets as owners.<br>\n                  2. In case of “Demise of all joint holders simultaneously – having nominee” event: Transmission of Account/Folio to: Nominee.<br>\n                  3. In case of “Demise of all joint holders simultaneously – not having nominee event: Transmission of Account /Folio to: Legal heir(s) of the youngest holder.\n                </div>\" style=\"top: 3px\"></i></p></div><div class=\"col-sm-6 col-md-12\"><span style=\"line-height: 1.5\">I/We hereby nominate the following person(s) who shall receive all the assets held in my / our account / folio in the event of my / our demise, as trustee and on behalf of my/our legal heir(s).</span></div><div class=\"nomineetab col-sm-12 col-md-12\"><!--            <p ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == 0 ? \'nomineecount b-b2\' : \'nomineecount\'}}\"--><!--              ng-If=\"FolioNomineeDetails.numberofnominees == 0 || FolioNomineeDetails.numberofnominees == 1 || FolioNomineeDetails.numberofnominees == 2 || FolioNomineeDetails.numberofnominees == 3 || FolioNomineeDetails.numberofnominees == 4 || FolioNomineeDetails.numberofnominees == 5 || FolioNomineeDetails.numberofnominees == 6 || FolioNomineeDetails.numberofnominees == 7 || FolioNomineeDetails.numberofnominees == 8 || FolioNomineeDetails.numberofnominees == 9\"--><!--              ng-click=\"FolioNomineeDetails.currentNominee(0)\">First Nominee</p>--><!--            <p ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == 1 ? \'nomineecount b-b2\' : \'nomineecount\'}}\"--><!--              ng-If=\"FolioNomineeDetails.shownextSteps1\" ng-click=\"FolioNomineeDetails.currentNominee(1)\">Second Nominee--><!--            </p>--><!--            <p ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == 2 ? \'nomineecount b-b2\' : \'nomineecount\'}}\"--><!--              ng-If=\"FolioNomineeDetails.shownextSteps2\" ng-click=\"FolioNomineeDetails.currentNominee(2)\">--><!--              Third Nominee</p>--><br><p ng-if=\"FolioNomineeDetails.nominees.length === 0\" ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == 0 ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-click=\"FolioNomineeDetails.currentNominee(FolioNomineeDetails.currentNomineeValue , true, FolioNomineeDetails.nominees[0].drivingLicense, FolioNomineeDetails.nominees[0].aadharCard, FolioNomineeDetails.nominees[0].passport)\">{{FolioNomineeDetails.enum[FolioNomineeDetails.currentNomineeValue]}} Nominee</p><p ng-repeat=\"nominee in FolioNomineeDetails.nominees track by $index\" ng-if=\"FolioNomineeDetails.nominees.length > 0\" ng-attr-class=\"{{FolioNomineeDetails.currentNomineeValue == $index ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-click=\"FolioNomineeDetails.currentNominee($index , true, FolioNomineeDetails.nominees[$index].drivingLicense, FolioNomineeDetails.nominees[$index].aadharCard, FolioNomineeDetails.nominees[$index].passport)\">{{FolioNomineeDetails.enum[$index]}} Nominee</p></div></div><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Name <span class=Red>*</span></p><input class=\"form-control inputNormal\" type=text name=nomineename id=nomineename autocomplete=off ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeName ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 95%\" ng-change=FolioNomineeDetails.setincapcitationList() ng-maxlength=40 limit-to=40 maxlength=40> <span ng-show=\"nomineeForm.nomineename.$dirty && nomineeForm.nomineename.$invalid\"><span class=error-input ng-show=nomineeForm.nomineename.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=nomineeForm.nomineename.$error.pattern>Number not allowed in name!</span></span></div><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Share Percentage <span class=Red>*</span></p><input class=\"form-control percentage\" type=text name=sharepercent id=sharepercent ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].percentage ng-pattern=/^[0-9]+$/ minlength=1 maxlength=3 style=\"width: 95%\" ng-blur=FolioNomineeDetails.updatePercentage()> <span ng-show=\"nomineeForm.sharepercent.$dirty && nomineeForm.sharepercent.$invalid\"><span class=error-input ng-show=nomineeForm.sharepercent.$error.required ng-bind=FolioNomineeDetails.validateData.PERCENT_REQUIRED></span> <span class=error-input ng-show=nomineeForm.sharepercent.$error.pattern>Text not allowed in percentage!</span></span></div></div></div><div class=\"col-sm-6 col-md-6\" ng-if=FolioNomineeDetails.showDeleteBtn><div class=delete-icon style=\"display: flex;justify-content: flex-start;align-items: center;cursor: pointer\" ng-click=FolioNomineeDetails.deleteNominee(FolioNomineeDetails.currentNomineeValue) ng-hide=\"FolioNomineeDetails.nominees.length == 1\"><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"></div></div></div><br><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><div class=checkbox><input type=checkbox ng-change=FolioNomineeDetails.changeFolioMinor() ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].minor> <i class=icon-checkbox></i> <span class=checkbox-text>The Nominee is Minor</span></div></div></div><br><!-- DOB --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"padding: 0px\">Date of Birth <span class=Red ng-if=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].minor>*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=dob-input-container style=\"height: 45px;width: 100%\" ng-if=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].minor><div class=\"input-select verify-acc input-normal input-group date date-picker dateInputReg\" style=\"width: 100%\" date-calendar data-enable=true data-viewmode={{FolioNomineeDetails.viewMode}} data-date-default=FolioNomineeDetails.currentNomineedob data-on-date-change=FolioNomineeDetails.getNomineeDob data-min-date=FolioNomineeDetails.dataMinDate data-max-date=FolioNomineeDetails.dataMaxDate maxdate=now format=DD-MMM-YYYY><input class=newinvestor-dob tabindex=2 id=nomineedob name=nomineedob type=text autocomplete=off ng-keyup=FolioNomineeDetails.autoDate() placeholder=dd-mmm-yyyy style=\"border-radius: 5px\" readonly> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 20px\"> </span><span ng-show=\"nomineeForm.nomineedob.$dirty && nomineeForm.nomineedob.$invalid\"><span class=error-input ng-if=FolioNomineeDetails.dateErrorMessage ng-bind=FolioNomineeDetails.dateErrorMessage></span></span></div><br></div><div class=dob-input-container style=\"height: 45px; width: 100%\" ng-if=!FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].minor><div class=\"input-select verify-acc input-normal input-group date date-picker dateInputReg\" style=\"width: 100%\" date-calendar data-enable=true data-viewmode={{FolioNomineeDetails.viewMode}} data-date-default=FolioNomineeDetails.currentNomineedob data-on-date-change=FolioNomineeDetails.getNomineeDob data-min-date=FolioNomineeDetails.dataMinDate1 data-max-date=FolioNomineeDetails.dataMaxDate1 maxdate=now format=DD-MMM-YYYY><input class=newinvestor-dob tabindex=2 id=nomineedob name=nomineedob type=text autocomplete=off ng-keyup=FolioNomineeDetails.autoDate() placeholder=dd-mmm-yyyy style=\"border-radius: 5px\" readonly> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 20px\"> </span><span ng-show=\"nomineeForm.nomineedob.$dirty && nomineeForm.nomineedob.$invalid\"><span class=error-input ng-if=FolioNomineeDetails.dateErrorMessage ng-bind=FolioNomineeDetails.dateErrorMessage></span></span></div><br></div></div></div><br><br><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Relationship <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=nomineeRelationship name=nomineeRelationship ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeRelation required style=\"height: 40px;width: 100% !important\"><option value selected>Select</option><option ng-repeat=\"x in FolioNomineeDetails.applicantRelationShip\" ng-selected=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!--Other Relation INPUT FIELD STARTS HERE--><!--        <div class=\" form-control-group row\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeRelation=== \'OTHERS\'\">--><!--          <div class=\"col-sm-12 col-md-12\">--><!--            <p class=\"titleFatca\">Others (Please Specify)<span class=\"req text-red\">*</span></p>--><!--          </div>--><!--          <div class=\"col-sm-6 col-md-6\">--><!--            <input class=\"form-control\" type=\"text\"--><!--                   ng-model=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].otherRelation\"--><!--                   name=\"otherRelation\"--><!--                   maxlength=\"254\"--><!--                   autocomplete=\"off\" required>--><!--            <span ng-show=\"nomineeForm[\'otherRelation\'].$dirty && nomineeForm[\'otherRelation\'].$invalid\">--><!--              <span class=\"error-input\" ng-show=\"nomineeForm[\'otherRelation\'].$error.pattern\">--><!--                {{FolioNomineeDetails.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER_VALID}}--><!--              </span>--><!--                <span class=\"error-input\" ng-show=\"nomineeForm[\'otherRelation\'].$error.required\">--><!--                {{FolioNomineeDetails.validateData.RELATIONSHIP_WITH_APPLICANT_OTHER}}--><!--              </span>--><!--            </span>--><!--          </div>--><!--        </div><br>--><!--Other Relation INPUT FIELD ENDS HERE--><!--NOMINEE EMAIL INPUT FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Email ID<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-pattern=FolioNomineeDetails.CONST.email_regex ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].emailId name=emailId maxlength=254 ng-change=\"FolioNomineeDetails.changeEmailId(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].emailId)\" autocomplete=off required> <span ng-show=\"nomineeForm[\'emailId\'].$dirty && nomineeForm[\'emailId\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'emailId\'].$error.pattern\">{{FolioNomineeDetails.validateData.EMAIL_FIELD}} </span><span class=error-input ng-show=\"nomineeForm[\'emailId\'].$error.required\">{{FolioNomineeDetails.validateData.EMAIL_REQUIRED}} </span></span><span><span class=error-input ng-show=\"!nomineeForm[\'emailId\'].$invalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].emailIdInvalid\">{{FolioNomineeDetails.errorMessageEmail}}</span></span></div></div><br><!--NOMINEE EMAIL INPUT FIELD ENDS HERE--><!--NOMINEE MOBILE INPUT FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Mobile No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].mobileNumber name=mobile minlength=1 maxlength=15 ng-pattern=FolioNomineeDetails.CONST.mobile_regex_new ng-change=\"FolioNomineeDetails.changeMobileNumber(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].mobile)\" autocomplete=off required> <span ng-show=\"nomineeForm[\'mobile\'].$dirty && nomineeForm[\'mobile\'].$invalid\"><span class=error-input ng-show=\"nomineeForm[\'mobile\'].$error.pattern\">{{FolioNomineeDetails.validateData.MOBILE_FIELD}} </span><span class=error-input ng-show=\"nomineeForm[\'mobile\'].$error.required\">{{FolioNomineeDetails.validateData.MOBILE_REQUIRED}} </span></span><span ng-show=\"!nomineeForm[\'mobile\'].$invalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].mobileInvalid\"><span class=error-input>{{FolioNomineeDetails.errorMessageMobile}}</span></span></div></div><br><!--NOMINEE MOBILE INPUT FIELD ENDS HERE--><!--NOMINEE IDENTIFIER FIELD STARTS HERE--><div class=\"form-control-group row mb-3\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Select Personal Identifier of Nominee <span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=personalIdentifier name=personalIdentifier ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType ng-init=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType = FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType ? FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType : null\" ng-options=\"_type.identityProofType as _type.identityProof for _type in FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofList\" ng-change=\"FolioNomineeDetails.changeNomineeIdentityProof(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType)\" easyassist-key=mask-element style=\"width: 100% !important\" required><option value=\"\" selected>Select Personal Identifier of Nominee</option></select><div ng-show=\"nomineeForm.personalIdentifier.$dirty && nomineeForm.personalIdentifier.$invalid\"><span class=error-input ng-show=nomineeForm.personalIdentifier.$error.required>{{FolioNomineeDetails.validateData.PERSONAL_IDENTIFIER_REQUIRED}}</span></div></div></div><!--NOMINEE IDENTIFIER FIELD ENDS HERE--><!--NOMINEE License FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType === \'DRIVING_LICENSE\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Driving License No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-bind=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].drivingLicense ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].drivingLicense name=drivingLicense maxlength=35 ng-change=\"FolioNomineeDetails.changeDrivingLicense(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].drivingLicense)\" autocomplete=off required capitalize> <span ng-show=\"nomineeForm.drivingLicense.$dirty && nomineeForm.drivingLicense.$invalid\"><span class=error-input ng-show=nomineeForm.drivingLicense.$error.required>{{FolioNomineeDetails.validateData.DRIVING_LICENSE_REQUIRED}} </span><span class=error-input ng-show=nomineeForm.drivingLicense.$error.pattern>{{FolioNomineeDetails.validateData.VALID_DRIVING_LICENCE}} </span></span><span class=error-input ng-if=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeDLInvalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].drivingLicense\" ng-bind=FolioNomineeDetails.errorMessageDLIdentity></span></div></div><!--NOMINEE License INPUT FIELD ENDS HERE--><!--NOMINEE AADHAAR FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType === \'AADHAR_CARD\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Aadhaar No.<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control input-aadhar-investor\" type=text class=aadhar-field ng-bind=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].aadharCard ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].aadharCard name=aadharCard maxlength=4 ng-pattern=FolioNomineeDetails.CONST.valid_4_digit_aadhar_regex ng-change=\"FolioNomineeDetails.changeAadharCard(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].aadharCard)\" autocomplete=off required capitalize> <span class=\"arn aadhar-investor\">XXXX XXXX </span><span ng-show=\"nomineeForm.aadharCard.$dirty && nomineeForm.aadharCard.$invalid\"><span class=error-input ng-show=nomineeForm.aadharCard.$error.pattern>{{FolioNomineeDetails.validateData.AADHAAR_INVALID}} </span><span class=error-input ng-show=nomineeForm.aadharCard.$error.required>{{FolioNomineeDetails.validateData.AADHAAR_REQUIRED}} </span></span><!--                      <span class=\"error-input\" ng-show=\"!nomineeForm[\'aadharCard-\'+$index].$invalid && Nominee.isDuplicate\">--><!--                        {{Nominee.errorMessageAadharIdentity}}--><!--                      </span>--><!--<span class=\"error-input\"\n                ng-if=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAadharInvalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].aadharCard\"\n                ng-bind=\"FolioNomineeDetails.errorMessageDLIdentity\">\n            </span>--></div></div><!--NOMINEE AADHAAR INPUT FIELD ENDS HERE--><!--NOMINEE PASSPORT FIELD STARTS HERE--><div class=\"form-control-group row\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType === \'PASSPORT\'\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee Passport<span class=\"req text-red\">*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=form-control type=text ng-bind=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].passport ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].passport name=passport maxlength=35 ng-change=\"FolioNomineeDetails.changePassport(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].passport)\" autocomplete=off required capitalize> <span ng-show=\"nomineeForm.passport.$dirty && nomineeForm.passport.$invalid\"><span class=error-input ng-show=nomineeForm.passport.$error.required>{{FolioNomineeDetails.validateData.PASSPORT_REQUIRED}} </span></span><span class=error-input ng-if=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineePassportInvalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].passport\" ng-bind=FolioNomineeDetails.errorMessagePassportIdentity></span></div></div><!--NOMINEE PASPORT INPUT FIELD ENDS HERE--><!-- PAN --><div class=\"form-control-group row\" ng-if=\"!FolioNomineeDetails.showNomineeUpdate || (FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].identityProofType === \'PAN_CARD\')\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee PAN<span class=\"req text-red\" ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=nomineepan tabindex=1 type=text name=nomineepan maxlength=10 minlength=10 ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].panNumber ng-pattern=/^[A-Z]{5}[0-9]{4}[A-Z]$/ ng-required=FolioNomineeDetails.showNomineeUpdate ng-change=\"FolioNomineeDetails.changeNomineePan(FolioNomineeDetails.currentNomineeValue, FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].panNumber)\" capitalize style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n          border: 1px solid #B8C6D1;\n          border-radius: 5px;\n          height: 40px;\n          opacity: 1\" ng-blur=FolioNomineeDetails.checkPan()><br><span ng-show=\"nomineeForm.nomineepan.$dirty && nomineeForm.nomineepan.$invalid\"><span class=error-input ng-show=nomineeForm.nomineepan.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_PAN_REQUIRED style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.nomineepan.$error.maxlength ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.nomineepan.$error.pattern ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> </span><span class=error-input ng-if=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineePanInvalid && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].panNumber\" ng-bind=FolioNomineeDetails.errorMessagePanIdentity></span></div></div></div><div ng-if=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].minor><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Name <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=guardianName id=guardianName ng-maxlength=40 limit-to=40 maxlength=40 ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].guardianName ng-blur=FolioNomineeDetails.checkProceedValidation() style=\"width: 100%\"></div></div><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Relationship <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=guardianRelation name=guardianRelation ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].guardianRelationWithNominee ng-change=FolioNomineeDetails.checkProceedValidation() required style=\"height: 40px;width: 100% !important\"><option value selected>Select</option><option ng-repeat=\"x in FolioNomineeDetails.guardianRelationshipList\" ng-selected=\"FolioNomineeDetails.guardianRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!-- PAN --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian PAN <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].guardianPanNumber ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-blur=FolioNomineeDetails.checkProceedValidation() capitalize style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n                  border: 1px solid #B8C6D1;\n                  border-radius: 5px;\n                  height: 40px;\n                  width: 100%;\n                  opacity: 1\"><br><span ng-show=\"nomineeForm.pan.$dirty && nomineeForm.pan.$invalid\"><span class=error-input ng-show=nomineeForm.pan.$error.maxlength ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.pan.$error.pattern ng-bind=FolioNomineeDetails.validateData.PAN_FIELD style=\"color: red\"></span></span></div></div></div></div><!-- address --><!-- <div class=\"row\">\n          <p class=\"inputquestion titleFatca col-xs-12 col-md-2\">Address Details</p>&nbsp;\n          <input type=\"checkbox\" class=\"nomineeCheckbox col-xs-12 col-md-1\" name=\"address\" id=\"address\"\n            ng-model=\"FolioNomineeDetails.addAddress\" ng-click=\"FolioNomineeDetails.addNomineeNewAddress()\"\n            ng-checked=\"FolioNomineeDetails.addAddress\">\n          <label class=\"confirmationnote col-xs-12 col-md-7\" for=\"address\" ng-checked=\"FolioNomineeDetails.addAddress\"\n            style=\"font-size: 13px;font-weight: bold;\">Same as applicant address</label>\n        </div><br> --><!-- Address Line 1 --><div class=address><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"font-size: 14px\">Address Details :</p></div><div class=\"col-sm-6 col-md-6\"></div></div><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 1 <span class=Red ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine1 id=addressLine1 ng-maxlength=60 limit-to=60 maxlength=60 ng-required=FolioNomineeDetails.showNomineeUpdate ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.addressLine1 style=\"width: 100%\"> <span ng-show=\"nomineeForm.addressLine1.$dirty && nomineeForm.addressLine1.$invalid\"><span class=error-input ng-show=nomineeForm.addressLine1.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_ADDRESSLINE1_REQUIRED style=\"color: red\"></span></span></div></div><br><!-- Address Line 2 --><div class=address><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 2</p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine2 id=addressLine2 ng-maxlength=60 limit-to=60 maxlength=60 ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.addressLine2 style=\"width: 100%\"></div></div><br><!-- country --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Country <span class=Red ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=country name=country ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.country style=\"height: 40px;width: 100% !important\" ng-change=FolioNomineeDetails.setState() ng-required=FolioNomineeDetails.showNomineeUpdate><option value selected>Select</option><option ng-repeat=\"value in NewFolioCreation.countries\" ng-selected=\"FolioNomineeDetails.country == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select><div ng-show=\"nomineeForm.country.$dirty && nomineeForm.country.$invalid\"><span class=error-input ng-show=nomineeForm.country.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_COUNTRY_REQUIRED style=\"color: red\"></span></div></div></div><br><!-- state --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>State <span class=Red ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=state name=state ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.state ng-disabled=\"FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.country && FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.country != \'IN\'\" style=\"height: 40px;width: 100% !important\" ng-required=FolioNomineeDetails.showNomineeUpdate><option value selected>Select</option><option ng-repeat=\"value in FolioNomineeDetails.stateList\" ng-selected=\"FolioNomineeDetails.state == value.stateCode\" value={{value.stateCode}}>{{value.stateName}}</option></select><div ng-show=\"nomineeForm.state.$dirty && nomineeForm.state.$invalid\"><span class=error-input ng-show=nomineeForm.state.$error.required ng-bind=FolioNomineeDetails.validateData.STATE_REQUIRED style=\"color: red\"></span></div></div></div><br><!-- city/zipcode --><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row style=\"margin-left: 2px\"><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">City <span class=Red ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.city name=city id=city minlength=3 ng-maxlength=35 limit-to=35 maxlength=35 ng-pattern=\"/^[a-zA-Z ]+$/\" style=\"width: 95%\" required><br><span class=\"col-sm-12 col-md-12 space-0\" ng-show=\"nomineeForm.city.$dirty && nomineeForm.city.$invalid\"><span class=error-input ng-show=nomineeForm.city.$error.required ng-bind=FolioNomineeDetails.validateData.CITY></span> <span class=error-input ng-show=nomineeForm.city.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">Zip Code <span class=Red ng-if=FolioNomineeDetails.showNomineeUpdate>*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text ng-model=FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeAddress.pinCode name=zipcode id=zipcode ng-pattern=/^[0-9]+$/ ng-required=FolioNomineeDetails.showNomineeUpdate minlength=6 maxlength=6 style=\"width: 95%\"><br><span class=error-input ng-show=nomineeForm.zipcode.$error.minlength>zipcode length is less!</span> <span class=error-input ng-show=nomineeForm.zipcode.$error.maxlength>zipcode length is high!</span> <span class=\"col-sm-12 col-md-12\" ng-show=\"nomineeForm.zipcode.$dirty && nomineeForm.zipcode.$invalid\"><span class=error-input ng-show=nomineeForm.zipcode.$error.required ng-bind=FolioNomineeDetails.validateData.NOMINEE_ZIP_REQUIRED></span> <span class=error-input ng-show=nomineeForm.zipcode.$error.pattern>Text not allowed in zipcode!</span></span></div></div></div></div></div><br></div></div><!--NOMINEE STATEMENT DECLARATION FIELD STARTS HERE--><div class=\"statement-declaration row mb-4\" ng-if=FolioNomineeDetails.showNomineeUpdate><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p></div><div class=\"col-sm-12 col-md-12\"><div class=declaration-content><div class=row><div class=\"col-md-12 mb-4\"><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div class=row><div class=\"col-md-12 form-group\"><div class=radio-block style=\"display: flex;align-items: center\"><span class=radio><input ng-model=FolioNomineeDetails.nomination type=radio ng-change=FolioNomineeDetails.setStatement(); ng-value=true> <span class=check></span></span><label style=\"margin-top: 8px;margin-left: 8px\">Nomination: Yes</label></div></div><div class=\"col-md-12 form-group\"><div class=radio-block style=\"display: flex;align-items: center\"><span class=radio><input ng-model=FolioNomineeDetails.nomination type=radio ng-change=FolioNomineeDetails.setStatement(); ng-value=false> <i class=check></i></span><label style=\"margin-top: 8px;margin-left: 8px\">Nomination: No</label></div></div></div></div></div></div><!--NOMINEE STATEMENT DECLARATION FIELD ENDS HERE--><!--NOMINEE Incapacitation DECLARATION FIELD STARTS HERE--><!--<div class=\"statement-declaration row mb-4\" ng-if=\"FolioNomineeDetails.showNomineeUpdate && FolioNomineeDetails.holdeMode !==\'ANY_OR_SURVIVOR\'\">\n\n          <div class=\"col-sm-12 col-md-12\">\n            <p class=\"titleFatca\">Incapacitation Declaration (Optional)\n\n              <i class=\"tooltip-info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"\n                 data-placement=\"{{Main.tooltipClass}}\"\n                 title=\'<div>\n                SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                c) change such mandate any number of times without any restriction. <br/>\n              </div>\'>\n              </i>\n\n            </p>\n          </div>\n\n          <div class=\"col-sm-12 col-md-12\">\n            <div class=\"declaration-content\">\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                <span>I hereby authorize\n                  <select name=\"incapcitationNominee\"\n                          ng-model=\"FolioNomineeDetails.incapcitationNomineeIndex\"\n                          ng-change=\"FolioNomineeDetails.selectedNominee()\"\n                          ng-options=\"data.value as data.key disable when (data.isMinor) for data  in FolioNomineeDetails.incapcitationList\"\n                          ng-disabled=\"!FolioNomineeDetails.hasNomineeName()\"\n                  >\n                    <option value=\"\" selected>Select Nominee Name</option>\n                  </select>\n                (nominee number <input readonly type=\"text\" ng-model=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" name=\"nomineeNumber\" is-number maxlength=\"6\">) to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to\n                  <input type=\"text\" ng-disabled=\"!FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" ng-pattern=\"/^(100|[1-9][0-9]?)$/\"  ng-required=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && !FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-model=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage\" ng-change=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.amount = null\" name=\"percentage\" is-number maxlength=\"3\">% of assets in the account / folio or Rs.\n                  <input type=\"text\" ng-disabled=\"!FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber\" ng-pattern=\"/^[1-9]\\d*$/\" ng-model=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.amount\" ng-required=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && !FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage\" name=\"claimAmount\" ng-change=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage = null\" is-number maxlength=\"20\">.\n                </span>\n                </div>\n                <div class=\"col-md-12\">\n                  <span ng-show=\"(FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'claimAmount\'].$dirty && nomineeForm[\'claimAmount\'].$invalid)\">\n                    <span class=\"error-input\" ng-show=\"nomineeForm[\'claimAmount\'].$error.pattern\">\n                      Amount/percentage cannot be less than 1.\n                    </span>\n                    <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage < 1\">\n                      Amount/percentage cannot be less than 1.\n                    </span>\n                    <span class=\"error-input\" ng-show=\"nomineeForm[\'percentage\'].$error.pattern && FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.percentage > 100\">\n                      Percentage cannot be more than 100%.\n                    </span>\n                    </span>\n\n                  <span ng-show=\"FolioNomineeDetails.nomineeRegistrationCO.incapacitationDeclaration.nomineeNumber && ((nomineeForm[\'percentage\'].$dirty && nomineeForm[\'percentage\'].$invalid) || (nomineeForm[\'claimAmount\'].$dirty && nomineeForm[\'claimAmount\'].$invalid))\">\n                    <span class=\"error-input\" ng-show=\"(nomineeForm[\'percentage\'].$error.required) || (nomineeForm[\'claimAmount\'].$error.required)\">\n                      Please enter the percentage or Rs. that can be encashed by the nominee.\n                    </span>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n\n        </div>--><!--NOMINEE Incapacitation DECLARATION FIELD ENDS HERE--><div style=\"display: flex\"><div ng-if=FolioNomineeDetails.extraNomineeVar><button type=button ng-click=FolioNomineeDetails.addExtraNomineeFun() style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486\">ADD ANOTHER NOMINEE</button> <button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"nomineeForm.pan.$invalid || !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeName ||\n\n            !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].percentage ||\n            FolioNomineeDetails.validateDOB ||\n                        !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeRelation ||\n                        FolioNomineeDetails.buttonEnable() ||\n                        !FolioNomineeDetails.proceed || (FolioNomineeDetails.showNomineeUpdate && !FolioNomineeDetails.emailIdValid)\">CONTINUE</button></div><div ng-if=!FolioNomineeDetails.extraNomineeVar><div><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"nomineeForm.pan.$invalid || !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeName ||\n                !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].percentage ||\n                FolioNomineeDetails.validateDOB ||\n                !FolioNomineeDetails.nominees[FolioNomineeDetails.currentNomineeValue].nomineeRelation ||\n                !FolioNomineeDetails.proceed ||\n                FolioNomineeDetails.buttonEnable() || (FolioNomineeDetails.showNomineeUpdate && !FolioNomineeDetails.emailIdValid)\n              \" ng-click=FolioNomineeDetails.addnewnominee(nomineeForm)>CONTINUE</button></div></div></div><br><!-- end address --><!-- end nominee yes --></div><div ng-if=!FolioNomineeDetails.addnominee style=\"margin-left: -15px\"><!-- Confirmation note --><div class=row><div class=\"col-sm-10 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate name=confirmfoliocreate ng-click=FolioNomineeDetails.getconformation() ng-checked=FolioNomineeDetails.conformation><label for=confirmfoliocreate class=confirmationnote ng-checked=FolioNomineeDetails.conformation style=\"font-size: 13px\">&nbsp;<!--I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my mutual fund units\n              held in my / our folio listed below and understand the issues involved in non appointment of\n              nominee(s) and further am/are aware that in case of death of all the account holder(s), my / our legal\n              heirs would need to submit all the requisite documents issued by Court or other such competent\n              authority, based on the value of assets held in the mutual fund folio.--><ng-bind-html dynamic=FolioNomineeDetails.dynamicDataNomineeOptOut.content></ng-bind-html></label></div></div><!-- Confirmation note --><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=!FolioNomineeDetails.conformation>CONTINUE</button></div></form></div><style>.percentage {\n      height: 40px;\n      border: 1px solid gray;\n      background-repeat: no-repeat;\n      background-position-y: 14px;\n      background-position-x: 36px;\n      background-size: 11px;\n      background-image: url(\"assets//images/percent.svg\");\n    }\n    .error-input{\n      color: red;\n      padding-bottom: 10px;\n    }\n\n    @media screen and (max-width: 750px) {\n      .minorageproofdiv {\n        margin-left: -15px;\n      }\n    }\n\n    .Red{\n      color: red !important;\n    }\n  .space-0{\n    padding: 0;\n    margin: 0;\n  }\n  .percentage{\n    height: 40px;\n    border: 1px solid gray;\n    background-repeat: no-repeat;\n    background-position-y: 14px;\n    background-position-x: 36px;\n    background-size: 11px;\n    background-image: url(assets/images/percent.svg);\n  }\n  .delete-icon:focus,.delete-icon:hover{\n    border: none;\n  }\n  #nomineeForm input,#nomineeForm select {\n    color: #000 !important;\n  }</style>");
$templateCache.put("app/new-investor/investment-detail/scheme-details/scheme-investment-goal.html","<div class=\"portfolio clearfix\" ng-init=SchemeInvestment.init()><ul style=\"display: flex;justify-content: start;flex-direction: row;padding: 3px;border-bottom: 1px solid gray\"><li ui-sref-active=activeMode class=mobile-f-size style=\"background-color: transparent;margin-bottom: -3px;height: inherit;margin-left: -3px;padding: 5px;\n      width: 180px;display: flex;justify-content: center\"><a ui-sref=main.newinvestor.investmentDetails.select-scheme.goal>Investment Goal</a></li><li ui-sref-active=activeMode class=mobile-f-size style=\"background-color: transparent;margin-left: 50px;margin-bottom: -3px;height: inherit;padding: 5px;\n      width: 200px;display: flex;justify-content: center\"><a ui-sref=main.newinvestor.investmentDetails.select-scheme.scheme>Select your scheme</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/new-investor-approve/folio/bank/bank.html","<div class=bankdetails><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><h1><u>Folio creation Approval</u></h1><div class=row style=\"padding: 22px 0px 15px 0px\"><div class=\"col-xs-12 col-md-6\"><p><b>Unit Holder Name : </b><span>{{Banks.folioDetails.investorPanDetails.name}}</span></p></div><div class=\"col-xs-12 col-md-6\"><p><b>PAN : </b><span>{{Banks.folioDetails.investorPanDetails.pan}}</span></p></div></div><div class=row style=\"padding: 22px 0px 15px 0px\"><div class=\"col-xs-12 col-md-6\"><p><b>Distributor Name : </b><span>{{Banks.folioDetails.distributorName}}</span></p></div><div class=\"col-xs-12 col-md-6\"><p><b>Distributor ARN : </b><span>{{Banks.folioDetails.arnCode}}</span></p></div></div><div class=row style=\"padding: 22px 0px 15px 0px\" ng-if=\"Banks.folioDetails.subBrokerArn || Banks.folioDetails.subBrokerCode\"><div class=\"col-xs-12 col-md-6\" ng-if=Banks.folioDetails.subBrokerArn><p><b>Sub Broker ARN : </b><span>{{Banks.folioDetails.subBrokerArn}}</span></p></div><div class=\"col-xs-12 col-md-6\" ng-if=Banks.folioDetails.subBrokerCode><p><b>Sub Broker Code : </b><span>{{Banks.folioDetails.subBrokerCode}}</span></p></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><form name=bankDetailsForm id=bankDetailsForm ng-submit=Banks.submitBankAccountDetails()><!-- IFSC code --><div class=row><div class=\"col-xs-12 col-md-12\" style=\"display: flex;align-items: center;\n                    justify-content: space-between\"><p class=investmentTitle>IFSC Code</p><div class=alignifsctext style=\"display: flex;justify-content: space-between;align-items: center\" ng-click=Banks.selectIFSC()><a style=\"height: 15px;width: 20px\"><svg class=\"svg-icon search-icon\" aria-labelledby=\"title desc\" role=img viewBox=\"0 0 19.9 19.7\"><title id=title>Search Icon</title><desc id=desc>A magnifying glass icon.</desc><g class=search-path fill=none stroke=#669ddf><path stroke-linecap=square stroke-width=3 d=\"M18.5 18.3l-5.4-5.4\"/><circle stroke-width=2 cx=8 cy=8 r=7 /></g></svg></a><p style=\"color: #669ddf;font-size: 12px\">SEARCH IFSC</p></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><input type=text class=\"form-control inputNormal\" name=ifsccode id=ifsccode autocomplete=off maxlength=11 minlength=11 ng-maxlength=11 limit-to=11 ng-model=Banks.bankAccountDetailsForm.ifscCode ng-pattern=Banks.IFSC_REGEX capitalize required readonly style=\"background-color: #ffffff;width: 336px\"></div><div ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\" style=\"margin-left: 15px\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern>Please enter 11 alphanumeric characters, Fifth character must be 0(zero).</span></div></div><br><!-- Account Type --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Type</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=Banks.bankAccountDetailsForm.accountType required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in Banks.bankAccountType\" ng-selected=\"Banks.bankAccountDetailsForm.accountType == value.accountTypeCode\" value={{value.accountTypeCode}}>{{value.accountType}}</option></select></div></div><br><!-- payout Mechanism --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Payout Mechanism</p></div><div class=\"col-xs-12 col-md-12\"><select class=selectNormal id=accountType name=accountType ng-model=Banks.bankAccountDetailsForm.bankDetails.payoutMechanism required style=\"height: 40px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in Banks.payoutMechanismList\" ng-selected=\"Banks.bankAccountDetailsForm.bankDetails.payoutMechanism == value.payoutCode\" value={{value.payoutCode}}>{{value.payoutDescription}}</option></select></div></div><br><!-- Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=password class=\"form-control inputNormal\" name=bankaccountnumber id=bankaccountnumber minlength=9 ng-maxlength=20 autocomplete=off ng-model=Banks.bankAccountDetailsForm.accountNumber required style=\"width: 336px\" ng-change=Banks.editAccountNumber()> <span ng-show=\"bankDetailsForm.bankaccountnumber.$dirty && bankDetailsForm.bankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.bankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.bankaccountnumber.$error.maxlength || bankDetailsForm.bankaccountnumber.$error.minlength\">Bank account number should be in range 9 to 20.</span></span></div></div><br><!-- verify Account Number --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=investmentTitle>Verify Account Number</p></div><div class=\"col-xs-12 col-md-12\"><input type=text class=\"form-control inputNormal\" name=verifybankaccountnumber id=verifybankaccountnumber ng-minlength=9 ng-maxlength=20 ng-model=Banks.bankAccountDetailsForm.accountNumberverify ng-change=Banks.matchAccountNumber() autocomplete=off ng-pattern=Banks.bankAccountDetailsForm.accountNumber required style=\"width: 336px\"> <span ng-show=\"bankDetailsForm.verifybankaccountnumber.$dirty && bankDetailsForm.verifybankaccountnumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.required>Bank Account Number required!</span> <span class=error-input ng-show=\"bankDetailsForm.verifybankaccountnumber.$error.maxlength || bankDetailsForm.verifybankaccountnumber.$error.minlength\">Bank account number should be in range 9 to 20.</span> <span class=error-input ng-show=bankDetailsForm.verifybankaccountnumber.$error.pattern>Bank account number should be same.</span></span></div></div><br><!-- chequesleaf --><div class=row ng-if=Banks.showcheckLeaf><div class=\"col-xs-12 col-sm-12 col-md-12\"><a style=\"color: blue\">{{Banks.bankAccountDetailsForm.chequesleafImageUrl}}</a></div><div class=\"col-xs-12 col-sm-6 col-md-8 buttonSpacesRes\" style=\"padding: 10px 0px 15px 12px\"><label for=chequesleafImage style=\"text-align: right;\n                    padding:10px 11px 10px 36px;\n                    background-color: lightgray;\n                    border-radius: 25px;\n                    cursor: pointer;\n                    background-size: 28px;\n                    background-position-x: 5px;\n                    background-position-y: 3px;\n                    background-repeat: no-repeat;\n                    background-image: url(../../../../assets/images/icons/uploadIcon.png)\">Upload Cheque leaf</label><input type=file name=chequesleafImage id=chequesleafImage accept=image/tiff,image/tif,image/jpeg,image/jpg file-model-profile=\"Preview Uploaded Doc\" ng-model=Banks.bankAccountDetailsForm.chequesleafImageUrl upload=Banks.bankUploadChequeLeafFile(file) style=\"display: none;visibility: none\" ng-click=Banks.clearFileSelection() required></div><div class=\"col-xs-12 col-sm-6 col-md-4 buttonSpacesRes\"><p ng-if=Banks.bankAccountDetailsForm.chequesleafImageUrl ng-click=Banks.openUploadedDoc() style=\"background-color: #669ddf;border-radius: 15px;padding: 10px;width: 160px;text-align: center;margin-top: 5px\">Show Image</p></div></div><!-- Submit button --><div><div class=\"col-xs-12 col-sm-6 col-md-8 buttonSpacesResTop\" style=\"padding: 10px 0px 15px 0px\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-click=Banks.rejectTransaction()>Reject</button></div><div class=\"col-xs-12 col-sm-6 col-md-4 buttonSpaceRes\" style=\"padding-top: 10px\"><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-if=Banks.showcheckLeaf ng-click=Banks.submitWithCheckLeaf() ng-disabled=\"!Banks.bankAccountDetailsForm.chequesleafImageUrl ||\n                            !Banks.bankAccountDetailsForm.ifscCode ||\n                            !Banks.bankAccountDetailsForm.accountType ||\n                            !Banks.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !Banks.bankAccountDetailsForm.accountNumber ||\n                            !Banks.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button> <button type=submit class=\"btn-new-journey-color hdfc-blue-cta-small\" ng-if=!Banks.showcheckLeaf ng-disabled=\"\n                            !Banks.bankAccountDetailsForm.ifscCode ||\n                            !Banks.bankAccountDetailsForm.accountType ||\n                            !Banks.bankAccountDetailsForm.bankDetails.payoutMechanism ||\n                            !Banks.bankAccountDetailsForm.accountNumber ||\n                            !Banks.bankAccountDetailsForm.accountNumberverify\">CONTINUE</button></div></div></form></div><div class=\"col-xs-12 col-md-6\"><div class=warning style=\"width: 250px;margin-top: 28px\" ng-if=!Banks.bankAccountDetailsForm.ifscCode><img src=../../../assets/images/icons/light-bulb.png style=\"width: 30px;height: 30px;margin: 10px 10px 0px 10px\"><div style=\"padding: 5px\"><br><p style=\"line-height: 20px;\n                    font-size: 12px;\n                    font-weight: 500\">Your bank account details will be used to credit or debit funds, credit dividends, among other things.</p><br><p style=\"line-height: 20px;\n                font-size: 12px;\n                font-weight: 500;margin-right: 6px\">Your details are absolutely safe with us and payment will only be done if you authorise us to make a payment.</p><br><br></div></div><div class=bankinfo ng-if=Banks.bankAccountDetailsForm.ifscCode style=\"background-color: white;border-radius: 8px;padding: 18px;width: 80%;margin-top: 28px\"><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Bank Name: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{Banks.bankAccountDetailsForm.bankName}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch City: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{Banks.bankAccountDetailsForm.bankCity}}</span></p><br><p style=\"font-size:12px;letter-spacing: 0px;color: #7E8F95\">Branch Location: <span style=\"font-weight: 600;font-size: 12px;color: #000000\">&nbsp;{{Banks.bankAccountDetailsForm.branchLocation}}</span></p></div></div></div></div><style>.warning {\n        background: #fefbe3;\n        display: flex;\n        border-radius: 5px;\n    }\n\n    .inputNormal {\n        width: 336px;\n        background-color: #ffffff;\n    }\n\n    .selectNormal {\n        width: 336px;\n    }\n\n    .alignifsctext {\n        margin-left: 243px;\n        position: absolute;\n    }\n\n    @media only screen and (max-width: 508px) {\n        .alignifsctext {\n            margin-left: 210px;\n        }\n    }\n    @media only screen and (max-width: 768px) {\n       .buttonSpaceRes{\n        padding-left: 0px !important;\n       }\n       .buttonSpacesRes{\n        padding:10px 0px 10px 15px !important;\n       }\n       .buttonSpacesResTop{\n        padding-top:10px !important;\n        padding-bottom:10px !important;\n       }\n       .new-investors-approve .inputNormal{\n        width: 100% !important;\n       }\n       .new-investors-approve .selectNormal{\n        width: 100% !important;\n       }\n       .alignifsctext {\n            position: relative;\n        }\n    }</style>");
$templateCache.put("app/new-investor/investment-detail/investment-mode/investment-mode.html","<div class=container-fluid ng-init=InvestmentMode.setGetDraftData()><form id=investmentModeform class=investmentModeform name=investmentModeform ng-submit=InvestmentMode.next()><div class=row style=\"width: max-content\"><br><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>Investment Type</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"row btn-m\" style=\"margin-left: 2px;width: 344px\"><p ng-click=\"InvestmentMode.investmentValidation.sipEnabled ? InvestmentMode.chooseInvestmentType(\'SIP\') : InvestmentMode.disableAlertSIPLumbsum(\'SIP\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestmentType == \'SIP\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">SIP</span></p><p ng-click=\"InvestmentMode.investmentValidation.purchaseEnabled ? InvestmentMode.chooseInvestmentType(\'PURCHASE\') : InvestmentMode.disableAlertSIPLumbsum(\'PURCHASE\')\" ng-attr-class=\"{{InvestmentMode.SelectedInvestmentType == \'PURCHASE\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\' : \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span style=\"margin: auto;font-weight: 500\">Lumpsum</span></p></div></div><div class=\"col-xs-12 col-md-4 hidden-xs\"><div class=warning1><img src=../../../assets/images/icons/light-bulb.png style=\"height: 25px;width: 25px\"><div><br>Under SIPs,you invest a small amount regularly</div></div></div></div><br><div><div class=row><div class=\"input-normal col-xs-12 col-md-6 sub-broker-arn-wrapper\"><p class=investmentTitle>Sub Broker ARN</p><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InvestmentMode.subBrokerARN ng-change=InvestmentMode.changeSubBrokerArn() ng-blur=InvestmentMode.fetchEuinListSubBroker() maxlength=10 ng-pattern=/^[0-9]{1,10}$/ autocomplete=off restrict-special-charcter ng-trim=false style=\"height: 40px;border-radius: 5px; border: 1px solid gray; font-size: 14px\"> <span class=highlight></span> <span class=bar></span> <span class=arn1 style=\"margin-left: 15px\">ARN -</span><p class=info-primary ng-if=InvestmentMode.subBrokerName>Sub Broker Name: {{InvestmentMode.subBrokerName}}</p><span class=error-input style=\"color: red\" ng-show=\"(investmentModeform.subBrokerARN.$dirty && investmentModeform.subBrokerARN.$invalid && investmentModeform.subBrokerARN.$error.pattern)\" ng-bind=InvestmentMode.VALIDATE_DATA.BROKER_VALID></span> <span class=error-input style=\"color: red\" ng-show=\"InvestmentMode.subBrokerCodeError != \'\'&& !investmentModeform.subBrokerARN.$error.pattern\" ng-bind=InvestmentMode.subBrokerCodeError></span></div></div><div class=row><div class=\"input-normal col-xs-12 col-md-6 sub-broker-code-wrapper\"><p class=investmentTitle>Sub Broker Code</p><input type=text name=subBrokerCode id=subBrokerCode ng-model=InvestmentMode.subBrokerCode autocomplete=off ng-disabled=\"!InvestmentMode.subBrokerARN || InvestmentMode.subBrokerCodeError !=\'\'\" ng-blur=InvestmentMode.checksubbrokercode() restrict-special-charcter ng-trim=false style=\"height: 40px;border-radius: 5px; border: 1px solid gray; font-size: 14px\"> <span class=highlight></span> <span class=bar></span> <span class=error-input style=\"color: red\" ng-show=investmentModeform.subBrokerCode.$dirty&&investmentModeform.subBrokerCode.$error.required ng-bind=investmentModeform.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div><!-- Sub Broket Details End --><div class=row><div class=\"col-xs-12 col-md-7\"><p class=investmentTitle>EUIN</p></div></div><br><div class=row><div class=\"input-normal col-xs-12 col-md-6\"><select class=selectNormal id=euin name=euin ng-model=InvestmentMode.euinData.euinCode ng-change=InvestmentMode.selectEuin(InvestmentMode.euinData.euinCode) style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\"><option value selected>Select EUIN</option><option ng-repeat=\"value in InvestmentMode.investmentEUNIList\" ng-selected=\"InvestmentMode.euinData.euinCode == value.euinCode\" value={{value.euinCode}}>{{value.euinName}} {{value.euinCode}}</option></select></div></div></div><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"!InvestmentMode.euinData.euinName || !InvestmentMode.euinData.euinCode || investmentModeform.$invalid || InvestmentMode.subBrokerCodeError\" ng-click=InvestmentMode.next()>CONTINUE</button></form></div><style>.warning1 {\n    margin-top: 20px;\n    background: #fefbe3;\n    display: flex;\n    border-radius: 5px;\n  }\n\n\n  .wardiv {\n    padding: 4% 4% 4% 0;\n    font-size: 12px;\n    line-height: 1.6;\n  }\n\n  .main {\n    margin-left: 50px;\n    width: 90vw;\n    margin-bottom: 2%;\n    height: auto;\n    top: 45%;\n    background-color: #fff;\n    border-radius: 10px;\n  }\n\n  .nomineeCheckbox+.confirmationnote {\n    display: block;\n    margin: 0.2em;\n    cursor: pointer;\n    padding: 0.2em;\n  }\n\n  .nomineeCheckbox {\n    display: none;\n  }\n\n  .nomineeCheckbox+.confirmationnote:before {\n    content: \"\\2714\";\n    border: 0.1em solid #000;\n    border-radius: 5px;\n    font-size: 8px;\n    padding-left: 3px;\n    padding-top: 1px;\n    padding-right: 3px;\n    padding-bottom: 1px;\n    margin-right: 0.2em;\n    vertical-align: bottom;\n    color: transparent;\n    transition: .2s;\n  }\n\n  .nomineeCheckbox:checked+.confirmationnote:before {\n    background-color: #38e574;\n    color: #fff;\n    border: 0.1em solid #38e574;\n  }\n\n  .input-normal input,\n  .input-normal input[ng-required] {\n    width: 336px;\n  }\n\n  .new-investors .kyc-form-container .form-page-container .col-xs-12 select {\n    width: 336px;\n  }\n\n  .arn1 {\n    position: absolute;\n    top: 12px;\n    left: 6px;\n    font-size: 14px !important;\n    color: #242424 !important;\n    display: block;\n  }\n\n  .switchlable1 {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 29px;\n    height: 16px;\n    background: #5ceb57;\n    display: block;\n    border-radius: 50px;\n    position: relative;\n  }\n\n\n  .switchlable1 {\n    margin-right: 10px;\n    width: 29px;\n    height: 16px;\n    background: #5CEB57 0% 0% no-repeat padding-box;\n    border-radius: 37px;\n    opacity: 1;\n    cursor: pointer;\n    text-indent: -9999px;\n    display: block;\n    position: relative;\n  }\n\n  .switchlable1:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked+.switchlable1 {\n    background: #5ceb57;\n  }\n\n  input:checked+.switchlable1:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n\n  .switchlable1:active:after {\n    width: 10px;\n  }\n\n  @media only screen and (max-width: 400px) {\n    .container-fluid {\n      padding: 0px;\n      margin: 0px;\n    }\n  }</style>");
$templateCache.put("app/new-investor-approve/folio/holder-details/holder-details.html","<div class=holderdetails style=\"position: relative\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><h1><u>Folio creation Approval</u></h1><div class=row style=\"padding: 22px 0px 15px 0px\"><div class=\"col-xs-12 col-md-6\"><p><b>Unit Holder Name : </b><span>&nbsp; {{JointHolder.folioDetails.investorPanDetails.name}}</span></p></div><div class=\"col-xs-12 col-md-6\"><p><b>PAN : </b><span>&nbsp; {{JointHolder.folioDetails.investorPanDetails.pan}}</span></p></div><div class=\"col-xs-12 col-md-6\"><p><b>Holder Name : </b><span>&nbsp; {{JointHolder.folioDetails.jointHolders[0].jointHolderName}}</span></p></div><div class=\"col-xs-12 col-md-6\"><p><b>PAN : </b><span>&nbsp; {{JointHolder.folioDetails.jointHolders[0].jointHolderApplicantDetail.panNumber}}</span></p></div></div></div></div><div><h4>Joint holder details</h4><div class=holderform3><div style=\"width: 300px;background-color: white;border-radius: 5px;padding: 11px;margin-top: 25px\"><p>Name :&nbsp;<span style=\"font-weight: bold\">{{JointHolder.folioDetails.jointHolders[0].jointHolderName}}</span></p><br><p>PAN :&nbsp; <span style=\"font-weight: bold\">{{JointHolder.folioDetails.jointHolders[0].jointHolderApplicantDetail.panNumber}}</span></p></div><br><!-- address --><!-- ng-submit=\"JointHolder.submithHolderIncomeDetails(JointHolder.holderTab)\" --><form id=jointHolderForm name=jointHolderForm><div class=row style=\"background-color: white;border-radius: 5px;padding: 11px;margin-top: 25px\"><p style=\"margin-top: 0px !important\"><strong>Contact Details</strong></p><div class=col-md-5 style=\"margin-right: 40px; margin-top: 20px\"><label><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{JointHolder.folioDetails.jointHolders[0].email?JointHolder.folioDetails.jointHolders[0].email:\"Not Available\"}}</label><div><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px;padding: 0px\"><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:jointHolderForm.emailBelongsTo.$dirty && jointHolderForm.emailBelongsTo.$invalid}\"><select id=emailBelongsTo name=emailBelongsTo class=\"browser-default custom-select\" ng-model=JointHolder.jointHolderDetails.emailDeclaration style=\"height: 40px;border-radius: 5px;width: 180px !important;border: 1px solid gray;margin-left: 0px;margin-top:-5px\" ng-required=JointHolder.folioDetails.jointHolders[0].email ng-disabled=!JointHolder.folioDetails.jointHolders[0].email><option value selected>Select Value</option><option ng-repeat=\"value in JointHolder.belongToListEmail\" ng-selected=\"JointHolder.jointHolderDetails.emailDeclaration == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><span ng-show=\"jointHolderForm.emailBelongsTo.$dirty \"><span class=error-input ng-show=jointHolderForm.emailBelongsTo.$error.required>Please select option</span></span></div></div></div></div><div class=col-md-5 style=\"margin-right: 40px; margin-top: 20px\"><label><strong>Mobile</strong> <span class=\"req text-red\">*</span> : {{JointHolder.folioDetails.jointHolders[0].mobileNo ? JointHolder.folioDetails.jointHolders[0].mobileNo : \"Not Available\"}}</label><div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\"><div style=\"flex-shrink : 0;padding: 0px\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:jointHolderForm.mobileBelongsTo.$dirty && jointHolderForm.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" id=mobileBelongsTo name=mobileBelongsTo ng-model=JointHolder.jointHolderDetails.mobileDeclaration ng-init=\"JointHolder.jointHolderDetails.mobileDeclaration = JointHolder.jointHolderDetails.mobileDeclaration ? JointHolder.jointHolderDetails.mobileDeclaration : null\" ng-options=\"data.familyCode as data.familyDescription for data in JointHolder.belongToListMobile\" ng-selected=\"JointHolder.jointHolderDetails.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;width: 180px !important;border: 1px solid gray;margin-left: 0px;margin-top:-5px\" ng-required=JointHolder.folioDetails.jointHolders[0].mobileNo ng-disabled=!JointHolder.folioDetails.jointHolders[0].mobileNo><option value=\"\" selected>Select Value</option></select><span ng-show=\"jointHolderForm.mobileBelongsTo.$dirty &&  jointHolderForm.mobileBelongsTo.$invalid\"><span class=error-input ng-show=jointHolderForm.mobileBelongsTo.$error.required>Please select option</span></span></div></div></div></div></div><!-- tax status --><div class=row><div class=\"col-xs-12 col-sm-8 col-md-8\"><p class=titleFatca>Tax Status</p></div><br><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=JointHolder.jointHolderDetails.taxStatusCode ng-disabled=\"JointHolder.folioDetails.jointHolders[0].nriFlag == false\" style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in JointHolder.taxStatusData\" ng-selected=\"JointHolder.jointHolderDetails.taxStatusCode == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select></div><span ng-show=\"jointHolderForm.taxstatus.$dirty && !JointHolder.jointHolderDetails.taxstatus\"><span class=error-input ng-show=jointHolderForm.taxstatus.$error.required ng-bind=JointHolder.validateData.TAX_STATUS></span></span></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=JointHolder.jointHolderDetails.occupationCode style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in JointHolder.investorOccupations\" ng-selected=\"JointHolder.jointHolderDetails.occupationCode == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"jointHolderForm.occupation.$dirty && !JointHolder.jointHolderDetails.occupationCode\"><span class=error-input ng-show=jointHolderForm.occupation.$error.required ng-bind=JointHolder.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 5px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row\"><p class=grossanualincome>Gross Annual Income</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=JointHolder.networthcall() ng-checked=JointHolder.networth><label class=switchlableHolder for=switch ng-checked=JointHolder.networth style=\"margin-right: 10px;top: 0\"></label><span style=\"font-weight: 600\">Net Worth</span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!JointHolder.networth><select class=selectNormal id=annualincome1 name=annualincome1 ng-model=JointHolder.jointHolderDetails.grossAnnualIncome style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in JointHolder.incomeSlabList\" ng-selected=\"JointHolder.jointHolderDetails.grossAnnualIncome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"jointHolderForm.annualincome1.$dirty && !JointHolder.jointHolderDetails.gross1\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=JointHolder.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=JointHolder.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=JointHolder.jointHolderDetails.netWorth required style=\"height: 40px\"> <span ng-show=\"jointHolderForm.annualincome1.$dirty && !JointHolder.jointHolderDetails.netWorth\"><span class=error-input ng-show=jointHolderForm.annualincome1.$error.required ng-bind=JointHolder.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-4\" ng-if=JointHolder.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{JointHolder.viewMode}} data-date-default=JointHolder.jointHolderDetails.netWorthDate data-on-date-change=JointHolder.getGrossAnnualIncomeDateOfHolder maxdate=now format=DD-MMM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId name=grossAnnualIncomeDate type=text autocomplete=off ng-keyup=JointHolder.autoDate() placeholder=\"As on dd-mm-yyyy\" required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=JointHolder.dateErrorMessage ng-bind=JointHolder.dateErrorMessage></span></div></div></div></div></div><p class=titleFatca style=\"padding-top: 25px\">FATCA & CRS related question.</p><!-- Country --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=JointHolder.jointHolderDetails.fatcaDetail.birthCountry style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in JointHolder.countries\" ng-selected=\"JointHolder.jointHolderDetails.fatcaDetail.birthCountry == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div></div><!-- address type --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=JointHolder.jointHolderDetails.fatcaDetail.addressType style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"x in JointHolder.addressType\" ng-selected=\"JointHolder.jointHolderDetails.fatcaDetail.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"JointHolder.addressType.$dirty && !JointHolder.jointHolderDetails.fatcaDetail.addressType\"><span class=error-input ng-show=JointHolder.addressType.$error.required ng-bind=JointHolder.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City name=City ng-model=JointHolder.jointHolderDetails.fatcaDetail.birthPlace ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 322px\"> <span ng-show=\"jointHolderForm.City.$dirty && jointHolderForm.City.$invalid\"><span class=error-input ng-show=jointHolderForm.City.$error.required ng-bind=JointHolder.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.City.$error.pattern>Number not allowed in minor name!</span></span></div></div><!-- do you pay or file tax. --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=titleFatca>Do you pay or file tax in a country other than India?</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{JointHolder.jointHolderTaxDetails_fileTaxOtherIndian == \'Yes\' ? \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"JointHolder.getTaxFileStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{JointHolder.jointHolderTaxDetails_fileTaxOtherIndian == \'No\' ? \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"JointHolder.getTaxFileStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><br><!-- FATCA1 --><div ng-if=!JointHolder.jointHolderDetails.fatcaDetail.payTaxInIndia><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying Country</p></div><div class=\"col-xs-12 col-md-5\"><!-- <select class=\"selectNormal\" id=\"country\" name=\"country\"\n              ng-model=\"JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry\" style=\"height: 40px;\">\n              <option value selected=\"selected\">Select</option>\n              <option ng-repeat=\"value in JointHolder.countries\"\n                ng-selected=\"JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCountry == value.countryCode\"\n                value=\"{{value.countryCode}}\">{{value.countryName}}</option>\n            </select>\n            <span\n              ng-show=\"jointHolderForm.country.$dirty && !JointHolder.jointHolderFormData.fatcaDetail.fatcaTax1.taxPayingCountry\">\n              <span class=\"error-input\" ng-show=\"jointHolderForm.country.$error.required\"\n                ng-bind=\"JointHolder.validateData.SELECT_COUNTRY\"></span>\n            </span> --> <input class=\"form-control inputNormal\" type=text id=country name=country ng-model=JointHolder.taxOutsidePayCountry.countryName ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 322px\"> <span ng-show=\"jointHolderForm.country.$dirty && jointHolderForm.country.$invalid\"><span class=error-input ng-show=jointHolderForm.country.$error.required ng-bind=JointHolder.validateData.country></span> <span class=error-input ng-show=jointHolderForm.country.$error.pattern>Number not allowed in country name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID Type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxIdType name=taxIdType ng-model=JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType style=\"height: 40px\"><option value selected>Select</option><option ng-repeat=\"value in JointHolder.taxIdType\" ng-selected=\"JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxIdType == value.key\" value={{value.key}}>{{value.value}}</option></select><span ng-show=\"jointHolderForm.taxIdType.$dirty && !JointHolder.jointHolderFormData.fatcaDetail.fatcaTax1.taxIdType\"><span class=error-input ng-show=jointHolderForm.taxIdType.$error.required ng-bind=JointHolder.validateData.TAX_ID_TYPE></span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Paying City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxpayCity type=text name=taxpayCity ng-model=JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxPayingCity ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 332px\"> <span ng-show=\"jointHolderForm.taxpayCity.$dirty && jointHolderForm.taxpayCity.$invalid\"><span class=error-input ng-show=jointHolderForm.taxpayCity.$error.required ng-bind=JointHolder.validateData.CITY></span> <span class=error-input ng-show=jointHolderForm.taxpayCity.$error.pattern>Number not allowed in Tax Paying City name!</span></span></div></div><br><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax ID</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" id=taxId type=text name=taxId ng-maxlength=20 limit-to=20 maxlength=20 ng-model=JointHolder.jointHolderDetails.fatcaDetail.fatcaTax1.taxId required style=\"width: 332px\"> <span ng-show=\"jointHolderForm.taxId.$dirty && jointHolderForm.taxId.$invalid\"><span class=error-input ng-show=jointHolderForm.taxId.$error.required ng-bind=JointHolder.validateData.TAX_ID_NUMBER></span></span></div></div></div><!-- Political status --><div class=row><div class=\"col-xs-12 col-md-12\"><p class=titleFatca>Politicaly Exposed Person(PEP) status</p></div><br><div class=\"col-xs-12 col-md-12\"><div class=\"row btn-l\"><div class=\"col-xs-12 col-md-5 btn-l\"><p ng-attr-class=\"{{JointHolder.jointHolderTaxDetails_politicalStatus == \'Yes\' ? \'btn-active1 col-xs-6 first-btn  col-md-6 col-sm-6\':\'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"JointHolder.getPEPStatusForJointHolder(\'Yes\')\"><span style=\"margin: auto\">Yes</span></p><p ng-attr-class=\"{{JointHolder.jointHolderTaxDetails_politicalStatus == \'No\' ? \'btn-active1 col-xs-6 last-btn  col-md-6 col-sm-6\':\'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' }}\" ng-click=\"JointHolder.getPEPStatusForJointHolder(\'No\')\"><span style=\"margin: auto\">No</span></p></div></div></div></div><br><div style=\"display: flex;flex-direction: row\"><button type=button class=\"btn-new-journey-color btn-primary-action-pay hdfc-blue-cta-small\" ng-click=JointHolder.reject()>Reject</button> &nbsp;&nbsp;&nbsp;&nbsp; <button type=button class=\"btn-new-journey-color btn-primary-action-pay hdfc-blue-cta-small\" ng-disabled=\"jointHolderForm.$error.required || JointHolder.notolderthan1year\" ng-click=JointHolder.approve()>Approve</button></div></form></div></div><style>#switch {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n\n  .switchlableHolder {\n    margin-right: 10px;\n    width: 29px;\n    height: 16px;\n    background: #5CEB57 0% 0% no-repeat padding-box;\n    border-radius: 37px;\n    opacity: 1;\n    cursor: pointer;\n    text-indent: -9999px;\n    display: block;\n    position: relative;\n  }\n\n  .switchlableHolder:after {\n    content: \"\";\n    position: absolute;\n    top: 3px;\n    left: 5px;\n    width: 10px;\n    height: 10px;\n    background: #fff;\n    border-radius: 50px;\n  }\n\n  input:checked+.switchlableHolder {\n    background: #5ceb57;\n  }\n\n  input:checked+.switchlableHolder:after {\n    left: calc(100% - 5px);\n    transform: translateX(-100%);\n  }\n\n  .switchlableHolder:active:after {\n    width: 10px;\n    height: 10px;\n  }\n\n  .thirdholderPopup {\n    /* position: absolute; */\n    top: 25%;\n    left: auto;\n    border-radius: 15px;\n    z-index: 1000;\n    /* width: 500px; */\n    height: auto;\n    background-color: white;\n\n\n  }\n\n  .thirdholderPopup .body form {\n    text-align: center;\n    align-items: center;\n\n  }\n\n  .thirdholderPopup .body form .form-control {\n    border: 1px solid gray;\n  }\n\n  .thirdholderPopup .head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #eaf5ff;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    height: 42px;\n\n  }\n\n  .thirdholderPopup .head p {\n    padding: 20px;\n  }\n\n  .addAnotherButton {\n    background-color: white;\n    border: 1px solid #ff8486;\n    color: #ff8486;\n    width: 300px;\n    border-radius: 25px;\n    margin-right: 20px;\n  }\n\n  .btn-active1 {\n    height: 44px;\n    box-shadow: 0px 1px 6px #ffb7b8;\n    background-color: #FF8486;\n    font-size: 12px;\n    color: white;\n    display: flex;\n    align-items: center;\n  }\n\n  .btn-deactive1 {\n    height: 44px;\n    display: flex;\n    background-color: white;\n    align-items: center;\n    border: 1px solid rgb(158, 155, 155);\n  }\n\n  .btn-deactive1 span {\n    font-size: 12px;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    font-weight: 600;\n    font-family: \'Poppins\';\n  }\n\n  .first-btn {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n\n  .last-btn {\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n\n  @media screen and (max-width: 850px) {\n\n    .addAnotherButton {\n      width: 300px !important;\n    }\n  }\n\n  .btn-primary-action-pay {\n    color: white;\n    border-color: transparent;\n    background-color: #FF8486;\n\n  }\n\n  .hdfc-blue-cta-small:disabled {\n    background-color: #FF8486;\n    color: white;\n  }\n\n  @media only screen and (max-width: 1000px) {\n    .btn-primary-action-pay {\n      width: 150px !important;\n    }\n  }\n\n  .hdfc-blue-cta-small:disabled {\n    background-color: #FF8486;\n    color: white;\n  }\n\n  .btn-primary-action-pay {\n    width: 163px;\n    height: 35px;\n    border-color: transparent;\n    background-color: #FF8486;\n    border-radius: 50px !important;\n    line-height: 1.4 !important;\n    color: #ffffff;\n    padding: 6px 25px !important;\n    padding: 10px 10px 10px 10px;\n    border-radius: 45px;\n    margin-left: 5px;\n  }</style></div>");
$templateCache.put("app/new-investor-approve/folio/nominee/nominee.html","<div class=nomineedetails ng-init=Nominee.init()><form id=nomineeForm name=nomineeForm ng-submit=Nominee.submitNomineeData() novalidate><br><p class=title1 style=\"margin: 0px 0px 0px -10px\">Do you want to add nominee?</p><br><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"row btn-yesno\" style=\"width: 336px\"><p ng-click=Nominee.addnomineedata(1) ng-attr-class=\"{{Nominee.addnominee && \'btn-active1 first-btn col-xs-6 col-md-6 col-sm-6\' || \'btn-deactive1 first-btn col-xs-6 col-md-6 col-sm-6\' }}\"><span ng-click=Nominee.addnomineedata(1) style=\"margin: auto\">Yes</span></p><p ng-click=Nominee.addnomineedata(0) ng-attr-class=\"{{Nominee.addnominee && \'btn-deactive1 last-btn col-xs-6 col-md-6 col-sm-6\' || \'btn-active1 last-btn col-xs-6 col-md-6 col-sm-6\'  }}\"><span ng-click=Nominee.addnomineedata(0) style=\"margin: auto\">No</span></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><div ng-if=Nominee.addnominee style=\"width: 269px;\n          height: 64px;\n          /* UI Properties */\n          background: #FFFBE3 0% 0% no-repeat padding-box;\n          border: 1px solid #EAE7D5;\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          border-radius: 6px;\n          opacity: 1\"><img src=../../../assets/images/icons/light-bulb.png style=\"width: 22px;\n            height: 22px;margin: 10px\"><p style=\"width: 219px;\n            height: 39px;\n            /* UI Properties */\n            text-align: left;\n            font: normal normal normal 12px/20px Poppins;\n            letter-spacing: 0px;\n            color: #000000\">you can add upto 3 nominees. The total proportion should be 100%.</p></div></div></div><div ng-if=Nominee.addnominee><div class=row><div class=\"nomineetab col-sm-6 col-md-6\"><p ng-attr-class=\"{{Nominee.currentNomineeValue == 0 ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-if=\"Nominee.numberofnominees == 0 || Nominee.numberofnominees == 1 || Nominee.numberofnominees == 2 || Nominee.numberofnominees == 3\" ng-click=Nominee.currentNominee(0)>First Nominee</p><p ng-attr-class=\"{{Nominee.currentNomineeValue == 1 ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-if=Nominee.shownextSteps1 ng-click=Nominee.currentNominee(1)>Second Nominee</p><p ng-attr-class=\"{{Nominee.currentNomineeValue == 2 ? \'nomineecount b-b2\' : \'nomineecount\'}}\" ng-if=Nominee.shownextSteps2 ng-click=Nominee.currentNominee(2)>Third Nominee</p></div></div><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Name {{Nominee.nomineeDetails.nomineeName}}</p><input class=\"form-control inputNormal\" type=text name=nomineename id=nomineename ng-model=Nominee.nomineeDetails.nomineeName ng-pattern=\"/^[a-zA-Z ]+$/\" required style=\"width: 95%\"> <span ng-show=\"nomineeForm.nomineename.$dirty && nomineeForm.nomineename.$invalid\"><span class=error-input ng-show=nomineeForm.nomineename.$error.required ng-bind=Nominee.validateData.NOMINEE_NAME_REQUIRED></span> <span class=error-input ng-show=nomineeForm.nomineename.$error.pattern>Number not allowed in name!</span></span></div><div class=\"col-sm-6 col-md-6\"><p class=titleFatca>Share Percent</p><input class=\"form-control percentage\" type=text name=sharepercent id=sharepercent ng-model=Nominee.nomineeDetails.percentage ng-pattern=/^[0-9]+$/ minlength=1 maxlength=3 style=\"width: 95%\"> <span ng-show=\"nomineeForm.sharepercent.$dirty && nomineeForm.sharepercent.$invalid\"><span class=error-input ng-show=nomineeForm.sharepercent.$error.required ng-bind=Nominee.validateData.PERCENT_REQUIRED></span> <span class=error-input ng-show=nomineeForm.sharepercent.$error.pattern>Text not allowed in percentage!</span></span></div></div></div><div class=\"col-sm-6 col-md-6\" ng-if=Nominee.showDeleteBtn><div style=\"display: flex;justify-content: flex-start;align-items: center;cursor: pointer\" ng-click=Nominee.deleteNominee(Nominee.currentNomineeValue)><img src=../../../../../assets/images/icons/delete-red.png alt=\"\" srcset=\"\"><p style=\"color: red\">Delete nominee</p></div></div></div><br><!-- DOB --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"padding: 0px\">Date of Birth</p></div><div class=\"col-sm-6 col-md-6\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Nominee.viewMode}} data-date-default=Nominee.nomineeDetails.dob data-on-date-change=Nominee.getNomineeDob maxdate=now format=DD-MMM-YYYY><input class=newinvestor-dob tabindex=2 id=nomineedob name=nomineedob type=text autocomplete=off ng-keyup=Nominee.autoDate() placeholder=dd-mm-yyyy required style=\"border-radius: 5px\"> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png style=\"width: 20px\"> </span><span ng-show=\"nomineeForm.nomineedob.$dirty && nomineeForm.nomineedob.$invalid\"><span class=error-input ng-if=Nominee.dateErrorMessage ng-bind=Nominee.dateErrorMessage></span></span></div><br></div></div></div><br><br><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Relationship</p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=nomineeRelationship name=nomineeRelationship ng-model=Nominee.nomineeDetails.nomineeRelation required style=\"height: 40px;width: 100%\"><option value selected>Select</option><option ng-repeat=\"x in Nominee.applicantRelationShip\" ng-selected=\"Nominee.nomineeDetails.nomineeRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!-- PAN --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Nominee PAN</p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=nomineepan tabindex=1 type=text name=nomineepan maxlength=10 minlength=10 ng-model=Nominee.nomineePan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ capitalize style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n          border: 1px solid #B8C6D1;\n          border-radius: 5px;\n          height: 40px;\n          opacity: 1\"><br><span ng-show=\"nomineeForm.nomineepan.$dirty && nomineeForm.nomineepan.$invalid\"><span class=error-input ng-show=nomineeForm.nomineepan.$error.maxlength ng-bind=Nominee.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.nomineepan.$error.pattern ng-bind=Nominee.validateData.PAN_FIELD style=\"color: red\"></span></span></div></div></div><div ng-if=Nominee.nomineeMinor><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Name</p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=guardianName id=guardianName ng-model=Nominee.guardianName ng-blur=Nominee.checkgNmae() style=\"width: 100%\"></div></div><!-- Relation --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian Relationship</p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=guardianRelation name=guardianRelation ng-model=Nominee.guardianRelation ng-change=Nominee.checkGRelation() required style=\"height: 40px;width: 100%\"><option value selected>Select</option><option ng-repeat=\"x in Nominee.guardianRelationshipList\" ng-selected=\"Nominee.guardianRelation == x.value\" value={{x.value}}>{{x.relationDesc}}</option></select></div></div><br><!-- PAN --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Guardian PAN</p></div><div class=\"col-sm-6 col-md-6\"><div class=pan-input-container><label for=pan></label><input class=form-control id=pan tabindex=1 type=text name=pan maxlength=10 minlength=10 ng-model=Nominee.guardianPan ng-pattern=/^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/ ng-blur=Nominee.checkpan() capitalize style=\"background: #FFFFFF 0% 0% no-repeat padding-box;\n                  border: 1px solid #B8C6D1;\n                  border-radius: 5px;\n                  height: 40px;\n                  width: 100%;\n                  opacity: 1\"><br><span ng-show=\"nomineeForm.pan.$dirty && nomineeForm.pan.$invalid\"><span class=error-input ng-show=nomineeForm.pan.$error.maxlength ng-bind=Nominee.validateData.PAN_FIELD style=\"color: red\"></span> <span class=error-input ng-show=nomineeForm.pan.$error.pattern ng-bind=Nominee.validateData.PAN_FIELD style=\"color: red\"></span></span></div></div></div></div><!-- address --><!-- <div class=\"row\">\n          <p class=\"inputquestion titleFatca col-xs-12 col-md-2\">Address Details</p>&nbsp;\n          <input type=\"checkbox\" class=\"nomineeCheckbox col-xs-12 col-md-1\" name=\"address\" id=\"address\"\n            ng-model=\"Nominee.addAddress\" ng-click=\"Nominee.addNomineeNewAddress()\"\n            ng-checked=\"Nominee.addAddress\">\n          <label class=\"confirmationnote col-xs-12 col-md-7\" for=\"address\" ng-checked=\"Nominee.addAddress\"\n            style=\"font-size: 13px;font-weight: bold;\">Same as applicant address</label>\n        </div><br> --><!-- Address Line 1 --><div class=address><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca style=\"font-size: 14px\">Address Details :</p></div><div class=\"col-sm-6 col-md-6\"></div></div><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 1 <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine1 id=addressLine1 ng-model=Nominee.addressLine1 style=\"width: 100%\"></div></div><br><!-- Address Line 2 --><div class=address><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Address Line 2 <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><input class=\"form-control inputNormal\" type=text name=addressLine2 id=addressLine2 ng-model=Nominee.addressLine2 style=\"width: 100%\"></div></div><br><!-- country --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>Country <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=country name=country ng-model=Nominee.country style=\"height: 40px;width: 100%\" ng-change=Nominee.setState()><option value selected>Select</option><option ng-repeat=\"value in Nominee.countries\" ng-selected=\"Nominee.country == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div></div><br><!-- state --><div class=\"form-control-group row\"><div class=\"col-sm-12 col-md-12\"><p class=titleFatca>State <span class=Red>*</span></p></div><div class=\"col-sm-6 col-md-6\"><select class=selectNormal id=state name=state ng-model=Nominee.state ng-disabled=\"Nominee.country != \'IN\' \" style=\"height: 40px;width: 100%\"><option value selected>Select</option><option value=OTHER>OTHER</option><option ng-repeat=\"value in Nominee.stateList\" ng-selected=\"Nominee.state == value.stateCode\" value={{value.stateCode}}>{{value.stateName}}</option></select></div></div><br><!-- city/zipcode --><div class=row><div class=\"col-sm-6 col-md-6\"><div class=row style=\"margin-left: 2px\"><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">City <span class=Red>*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text ng-model=Nominee.city name=city id=city minlength=3 ng-pattern=\"/^[a-zA-Z ]+$/\" style=\"width: 95%\" required><br><span class=\"col-sm-12 col-md-12\" ng-show=\"nomineeForm.city.$dirty && nomineeForm.city.$invalid\"><span class=error-input ng-show=nomineeForm.city.$error.required ng-bind=Nominee.validateData.CITY></span> <span class=error-input ng-show=nomineeForm.city.$error.pattern>Numbers are not allowed in the city field</span></span></div></div><div class=\"col-sm-12 col-md-6\"><div class=row><p class=\"titleFatca col-sm-12 col-md-12\" style=\"margin-left: -15px\">Zip Code <span class=Red>*</span></p><input class=\"form-control inputNormal col-sm-12 col-md-12\" type=text ng-model=Nominee.pinCode name=zipcode id=zipcode ng-pattern=/^[0-9]+$/ minlength=6 maxlength=6 style=\"width: 95%\"><br><span class=error-input ng-show=nomineeForm.zipcode.$error.minlength>zipcode length is less!</span> <span class=error-input ng-show=nomineeForm.zipcode.$error.maxlength>zipcode length is high!</span> <span class=\"col-sm-12 col-md-12\" ng-show=\"nomineeForm.zipcode.$dirty && nomineeForm.zipcode.$invalid\"><span class=error-input ng-show=nomineeForm.zipcode.$error.pattern>Text not allowed in zipcode!</span></span></div></div></div></div></div><br></div></div><div style=\"display: flex\"><div ng-if=Nominee.extraNomineeVar><button type=button ng-click=Nominee.addExtraNomineeFun() style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486\">ADD ANOTHER NOMINEE</button> <button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit>CONTINUE</button></div><div ng-if=!Nominee.extraNomineeVar><div><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=button ng-disabled=\"nomineeForm.pan.$invalid || !Nominee.nomineeDetails.nomineeName ||\n\n    !Nominee.nomineeDetails.percentage ||\n                !Nominee.nomineeDetails.nomineeRelation ||\n                !Nominee.addressLine1 ||\n                !Nominee.addressLine2 ||\n                !Nominee.city ||\n                !Nominee.pinCode ||\n                !Nominee.proceed\" ng-click=Nominee.addnewnominee(nomineeForm)>CONTINUE</button></div><!-- <div ng-If=\"Nominee.addAddress\"> --><!-- <button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=\"button\"\n              ng-disabled=\"!Nominee.nomineeDetails.nomineeName ||\n          !Nominee.nomineeDetails.percentage ||\n          !Nominee.nomineeDetails.nomineeRelation ||\n          !Nominee.proceed\"\n                ng-click=\"Nominee.addnewnominee(nomineeForm)\">CONTINUE</button> --><!-- </div> --></div></div><br><!-- <div\n        ng-If=\"Nominee.numberofnominees > 0 && Nominee.addAddress\" style=\"display: flex;\">\n          <button type=\"button\"\n          ng-If=\"(Nominee.shownextSteps1 || Nominee.shownextSteps2) && Nominee.addanotherNominee\"\n          ng-click=\"Nominee.addnewnominee(nomineeForm)\"\n          ng-disabled=\"!Nominee.nomineeDetails.nomineeName ||\n          !Nominee.nomineeDetails.percentage ||\n          !Nominee.nomineeDetails.nomineeRelation\"\n            style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486;\">\n            ADD ANOTHER NOMINEE\n          </button>\n          &nbsp;&nbsp;\n          <button class=\"btn hdfc-blue-cta-small\"\n            type=\"submit\">CONTINUE</button>\n        </div> --><!-- <div ng-If=\"Nominee.numberofnominees > 0 && !Nominee.addAddress\" style=\"display: flex;\">\n          <button type=\"button\"\n          ng-If=\"(Nominee.shownextSteps1 || Nominee.shownextSteps2) && Nominee.addanotherNominee\"\n          ng-click=\"Nominee.addnewnominee(nomineeForm)\"\n          ng-disabled=\"!Nominee.nomineeDetails.nomineeName ||\n          !Nominee.nomineeDetails.percentage ||\n          !Nominee.nomineeDetails.nomineeRelation ||\n          !Nominee.addressLine1 ||\n          !Nominee.addressLine2 ||\n          !Nominee.city ||\n          !Nominee.pinCode\"\n            style=\"border-radius: 18px;background-color: white;width: 233px;text-align: center;padding: 10px;border: 1px solid #ff8486;color: #ff8486;\">\n            ADD ANOTHER NOMINEE\n          </button>\n          &nbsp;&nbsp;\n          <button class=\"btn hdfc-blue-cta-small\"\n            type=\"submit\">CONTINUE</button>\n        </div> --><!-- end address --><!-- end nominee yes --></div><div ng-if=!Nominee.addnominee style=\"margin-left: -15px\"><!-- Confirmation note --><div class=row><div class=\"col-sm-10 col-md-9\" style=\"display: flex;justify-content: flex-start;flex-direction: row\"><input class=nomineeCheckbox type=checkbox id=confirmfoliocreate name=confirmfoliocreate ng-click=Nominee.getconformation() ng-checked=Nominee.conformation><label for=confirmfoliocreate class=confirmationnote ng-checked=Nominee.conformation style=\"font-size: 13px\">&nbsp;I/we hereby confirm that I/we do not wish to exercise the right of nomination in respect of units subscribed/purchased by me/us through this folio.</label></div></div><!-- Confirmation note --><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=!Nominee.conformation>CONTINUE</button></div></form></div><style>.nomineetab {\n    border-bottom: 1px solid gray;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: row;\n    padding: 0;\n    margin-left: 15px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n\n  .b-b2 {\n    border-bottom: 2px solid rgb(39, 39, 235);\n  }\n\n  .nomineecount {\n    margin-right: 25px;\n    font-size: 12px;\n  }\n\n  .btn-yesno {\n    width: 336px;\n    height: 40px;\n    background-color: whitesmoke;\n    border-radius: 5px;\n  }\n\n  .btn-active1 {\n    height: 44px;\n    box-shadow: 0px 1px 6px #ffb7b8;\n    background-color: #FF8486;\n    font-size: 12px;\n    color: white;\n    display: flex;\n    align-items: center;\n  }\n\n  .btn-deactive1 {\n    height: 44px;\n    display: flex;\n    background-color: white;\n    align-items: center;\n    border: 1px solid rgb(158, 155, 155);\n  }\n\n  .btn-deactive1 span {\n    font-size: 12px;\n    letter-spacing: 0px;\n    color: #7E8F95;\n    font-weight: 600;\n    font-family: \'Poppins\';\n  }\n\n  .nomineedetails{\n    height: 100vh;\n  }\n  .first-btn {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n\n  .last-btn {\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n\n  .percentage {\n    height: 40px;\n    border: 1px solid gray;\n    background-repeat: no-repeat;\n    background-position-y: 14px;\n    background-position-x: 36px;\n    background-size: 11px;\n    background-image: url(\"assets//images/percent.svg\");\n  }\n\n  .error-input {\n    color: red;\n    padding-bottom: 10px;\n  }\n\n  @media screen and (max-width: 750px) {\n    .minorageproofdiv {\n      margin-left: -15px;\n    }\n  }\n\n  .Red {\n    color: red !important;\n  }</style>");
$templateCache.put("app/new-investor-approve/folio/summary/reject.html","<div style=\"overflow: hidden\"><div class=\"box-body rejected-folio center-aligned\"><p><i class=success-tick-icon></i><span>Rejected</span><br>Folio creation and Transaction request has been rejected.</p></div></div><style>.center-aligned{\n  height: 80vh;\n  width: 80vw;\n  padding: 0 !important;\n}\n\n.center-aligned p{\n  height: auto;\n  width:auto;\n  left: 45%;\n  top: 40%;\n  bottom: auto;\n  right: auto !important;\n  padding: 0 !important;\n}</style>");
$templateCache.put("app/new-investor-approve/folio/summary/summary.html","<div class=row><div class=\"col-sm-12 col-md-12 col-lg-12 col-xs-12\"><div class=row style=\"margin-top: 15px\"><div class=col-xs-12 style=\"margin-left: 15px\"><div class=\"form-page-header row\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: baseline\"><div style=\"display: flex;justify-content: flex-start;flex-direction: column\"><p class=reviewFolioPage style=\"color: #244c8a;font-weight: 600;font-size: 22px\">Review Folio Details</p><p class=userName style=\"padding: 10px 0px\"><b>{{Summary.UserData.panHolderName}}</b></p><p class=userName><b>Distributor Name : </b><span>{{Summary.folioDetails.distributorName}} &nbsp; &nbsp; <b>Distributor ARN : </b>{{Summary.folioDetails.arnCode}}</span></p></div><p id=callModal ng-click=Summary.getModal() style=\"display: none\"></p></div></div></div></div><div><div class=modal-body style=\"margin-left: 15px\"><form name=summarycontact><div class=row style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px\"><div class=form-content><label><strong>Contact Details</strong></label><div class=row><div class=col-md-5 style=\"margin-right: 40px\" ng-if=Summary.soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email ID</strong> <span class=\"req text-red\">*</span> : {{Summary.soleApplicantEmail}}</label></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Summary.soleApplicantEmail><label style=\"margin-top: 30px\"><strong>Email ID</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n                    style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"Summary.soleApplicantEmail\">\n                    <div style=\"flex-shrink : 0;\">\n                        <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                            : </label>\n                    </div>\n                    <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                        ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                        <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                            ng-model=\"holders.emailBelongsTo\"\n                            ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                            ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                            <option value=\"\" selected>Select Value</option>\n                        </select>\n                        <span class=\"req text-red\">*</span>\n                    </div>\n                </div>\n         --><div class=\"col-md-5 mLabel\" ng-if=Summary.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{Summary.soleApplicantMobile}}</label></div><div class=col-md-5 ng-if=!Summary.soleApplicantMobile><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=Summary.soleApplicantEmail><div class=flexNormal style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> :</label></div><div style=\"display: inline-block; margin-left: 5px\" ng-class=\"{error:summarycontact.emailBelongsTo.$dirty && summarycontact.emailBelongsTo.$invalid}\"><select class=contactBelongSelect id=emailBelongsTo name=emailBelongsTo ng-model=Summary.belongToListEmail style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray;margin-top: 8px;margin-left: 0px; appearance: auto\" required><option value selected>Select Value</option><option ng-repeat=\"value in Summary.emailBelongsToList\" ng-selected=\"Summary.belongToListEmail == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><br><span ng-show=summarycontact.emailBelongsTo.$dirty><span class=error-input ng-show=summarycontact.emailBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Summary.soleApplicantEmail></div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=Summary.soleApplicantMobile><div class=flexNormal style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> :</label></div><div style=\"display: inline-block\" ng-class=\"{error:summarycontact.mobileBelongsTo.$dirty && summarycontact.mobileBelongsTo.$invalid}\"><select class=\"contactBelongSelect browser-default\" id=mobileBelongsTo name=mobileBelongsTo ng-model=Summary.belongToListMobile ng-init=\"Summary.belongToListMobile = Summary.belongToListMobile ? Summary.belongToListMobile : null\" ng-options=\"data.familyCode as data.familyDescription for data in Summary.mobileBelongsToList\" ng-selected=\"Summary.belongToListMobile == data.familyCode\" style=\"height: 40px;border-radius: 5px;border: 1px solid gray;margin-top: 8px;margin-left: 0px;appearance: auto\" required><option value=\"\" selected>Select Value</option></select><br><span ng-show=\"summarycontact.mobileBelongsTo.$dirty &&  summarycontact.mobileBelongsTo.$invalid\"><span class=error-input ng-show=summarycontact.mobileBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Summary.soleApplicantMobile></div></div></div></div></form><!-- sole details --><div class=\"row PaddingResp\" ng-if=!Summary.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12 titleResponsive\" style=\"display: flex;justify-content: space-between;padding-left:10px\"><p style=\"font-weight: bold;font-size: 15px\">Sole Applicant Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotofolioBasic()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-6 col-md-4 border-right\"><div class=row><p class=\"col-md-12 p-0\" style=\"color: #497eac\">Income Details</p></div><div class=\"row m-top\"><div class=\"col-md-6 p-0\"><p>Tax Status</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxStatusDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{Summary.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p>\n                    </div> --></div><div class=\"row m-top\"><div class=\"col-md-6 p-0\"><p>Occupation</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.occupationData.occupationDescription readonly><!-- <div class=\"col-md-6 bg-white\">\n                        <p style=\"font-weight: 100;\">{{Summary.occupationData.occupationDescription}}</p>\n                    </div> --></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.netWorth><p class=\"col-md-6 p-0\">Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.grossIncomeData.incomeDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top\" ng-if=Summary.folioDetails.soleApplicantDetail.netWorth><p class=\"col-md-6 p-0\">Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.netWorth readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.soleApplicantDetail.selfDetail.netWorth}} --><p></p></div><div class=\"row m-top\" ng-if=Summary.folioDetails.soleApplicantDetail.netWorth><p class=\"col-md-6 p-0\">Net Worth date</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.netWorthDate readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.selfDetail.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 border-right\"><div class=row><p class=\"col-md-12 p-0\" style=\"color: #497eac\">FATCA and CRS Details</p></div><div class=\"row m-top\"><div class=\"col-md-6 p-0\"><p>Country of Birth</p></div><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.countryData.countryName readonly></div><div class=\"row m-top\"><p class=\"col-md-6 p-0\">City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.birthPlace readonly></div><div class=\"row m-top\"><p class=\"col-md-6 p-0\">Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.addressType readonly></div></div><div class=\"col-xs-12 col-sm-7 col-md-4\"><div class=row><p class=col-md-12 style=\"color: #497eac\">Tax Details</p></div><div class=row ng-if=Summary.folioDetails.soleApplicantDetail.payTaxInIndia><p class=ml-15 style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.payTaxInIndia><p class=col-md-6>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxCountry.countryName readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCountryDescription}}\n                    </p> --></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.payTaxInIndia><p class=col-md-6>Tax Paying City</p><p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.payOutsideIndiaAddresses[0].taxPayingCity readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxPayingCity}}</p> --></p></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.payTaxInIndia><p class=col-md-6>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.payOutsideIndiaAddresses[0].taxIdNumber readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.selfDetail.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.payTaxInIndia><p class=col-md-6>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxPayIdType.value readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.taxIdDetails.description}}</p> --></div></div></div><!-- minor data --><div class=\"row PaddingResp\" ng-if=Summary.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"color: #244b8c; font-weight: bold;font-size: 15px\">Minor Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoMinorBasic()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.personalDetail.firstName readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.personalDetail.firstName}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.personalDetail.dateOfBirth}}</p> --></div></div><!-- <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                <div class=\"row m-top\">\n                    <p class=\"col-md-6\">DOB Proof</p>\n                    <input class=\"col-md-6 bg-white\" type=\"text\" ng-model=\"Summary.folioDetails.soleApplicantDetail.minorDetail.minorProofType\" readonly>\n                </div>\n            </div> --></div><!-- Minor income details --><div class=\"row PaddingResp\" ng-if=Summary.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoMinorGuardian()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><p style=\"color: #244b8c\">Guardian\'s Income Details</p></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6>Tax Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxStatusDescription readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.personalDetail.taxStatusDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Occupation</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.occupationData.occupationDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.occupationData.occupationDescription}}</p> --></div><div class=\"row m-top\" ng-if=!Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Gross Annual Income</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.grossIncomeData.incomeDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.grossIncomeData.incomeDescription}}</p> --></div><div class=\"row m-top\" ng-if=Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth}}</p> --></div><div class=\"row m-top\" ng-if=Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorth><p class=col-md-6>Net Worth Date</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.netWorthDate}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-5\"><div class=\"row m-top\"><p class=col-md-6 style=\"line-height: normal\">Political Exposed Person Status</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.guardianDetails.politicalStatus readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus == \'NONE\' ? \'Not Applicable\' : Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.politicalStatus}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Relationship with Minor</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.relation readonly><!-- <p class=\"col-md-6 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.relation}}</p> --></div><!-- <div class=\"row m-top\">\n                    <p class=\"col-md-6\">Relationship Proof</p>\n                    <input class=\"col-md-6 bg-white\" type=\"text\" ng-model=\"Summary.folioDetails.soleApplicantDetail.minorDetail.minorRelationshipProofType\" readonly>\n                </div> --></div></div><!-- Guardian\'s FATCA and CRS details --><div class=\"row PaddingResp\" ng-if=Summary.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s FATCA and CRS information</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoMinorGuardian()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Country of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.countryData.countryName readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><div class=\"row m-top\"><p class=col-md-6>City of Birth</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.birthPlace readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Address of type</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.soleApplicantDetail.addressType readonly></div></div></div><!-- Guardian\'s tax details --><div class=\"row PaddingResp\" ng-if=Summary.folioDetails.minor style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Guardian\'s Tax Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoMinorGuardian()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=Summary.UserData.guardianDetails.basicDetails.payTaxInIndia><p class=ml-15 style=\"font-weight: bold;color: #244b8c\">Tax Details not available</p></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=!Summary.UserData.guardianDetails.basicDetails.payTaxInIndia><div class=\"row m-top\"><p class=col-md-3>Tax Paying Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxCountry.countryName readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCountryDescription}} --><p></p></div><div class=\"row m-top\"><p class=col-md-3>Tax Paying City</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0].taxPayingCity readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxPayingCity}}\n                    </p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax Id</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.guardianDetails.basicDetails.payOutsideIndiaAddresses[0].taxIdNumber readonly><!-- <p class=\"col-md-3 bg-white\">\n                        {{Summary.folioDetails.soleApplicantDetail.minorDetail.guardian.fatca.fatcaTax1.taxId}}</p> --></div><div class=\"row m-top\"><p class=col-md-3>Tax ID type</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.taxPayIdType.value readonly><!-- <p class=\"col-md-3 bg-white\">{{Summary.taxIdDetails.description}}</p> --></div></div></div><br><!-- Holder details --><div class=\"row PaddingResp\" ng-if=\"!Summary.folioDetails.minor && Summary.jointHoldersData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Holder Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoHolderPage()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col-xs-12 col-sm-12 col-md-12\" ng-repeat=\"x in Summary.jointHoldersData track by $index\"><!-- <p class=\"col-xs-12 col-sm-12 col-md-12\" style=\"font-weight: bold;\">Joint Holder {{$index + 1}} </p> --><div class=\"row m-top\"><p class=col-md-2>Holder\'s Name</p><p class=\"col-md-3 bg-white\">{{x.jointHolderName}}</p></div></div></div><!-- holder other details --><!-- <div class=\"row\" ng-If=\"!Summary.folioDetails.minor && Summary.jointHoldersData.length > 0\"\n            style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;\">\n            <div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between;\">\n                <p style=\"font-weight: bold;font-size: 15px;\">Holder Other Details</p>\n                <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoHolderPage()\"\n                    style=\"height: 15px;cursor: pointer;\">\n            </div>\n            <div class=\"row\" ng-repeat=\"x in Summary.jointHoldersData track by $index\">\n                <div class=\"row m-top\" style=\"margin-left: 15px;\">\n                    <p class=\"col-md-2\" style=\"color:#497eac;\n                    \">Holder\'s Name {{$index + 1}}</p>\n                    <p class=\"col-md-2 bg-white\">{{x.firstName}} {{x.lastName}}</p>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Income Details</p>\n                    </div>\n\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Tax Status</p>\n                        <p class=\"col-md-6 bg-white\">{{x.taxStatusDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\">\n                        <p class=\"col-md-6\">Occupation</p>\n                        <p class=\"col-md-6 bg-white\">{{x.occupationDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"!x.netWorth\">\n                        <p class=\"col-md-6\">Gross Annual Income</p>\n                        <p class=\"col-md-6 bg-white\">{{Summary.holderIncomdeslab[$index].incomeDescription}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorth}}</p>\n                    </div>\n                    <div class=\"row m-top m-left-0\" ng-If=\"x.netWorth\">\n                        <p class=\"col-md-6\">Net Worth Date</p>\n                        <p class=\"col-md-6 bg-white\">{{x.netWorthDate}}</p>\n                    </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-12 col-md-4\">\n                <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                    <p style=\"color: #497eac;\">FATCA and CRS Details</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Country of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{Summary.countryList[$index].countryName}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">City of Birth</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.birthPlace}}</p>\n                </div>\n                <div class=\"row m-top m-left-0\">\n                    <p class=\"col-md-6\">Address of type</p>\n                    <p class=\"col-md-6 bg-white\">{{x.fatcaDetail.addressType}}</p>\n                </div>\n                </div>\n\n                <div class=\"col-xs-12 col-sm-6 col-md-4\">\n                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                        <p style=\"color: #497eac;\">Tax Details</p>\n                    </div>\n                    <div ng-If=\"Summary.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <p>Tax Details not available</p>\n                    </div>\n\n                    <div ng-If=\"!Summary.jointHoldersData[$index].fatcaDetail.payTaxInIndia\">\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying Country</p>\n                            <p class=\"col-md-6 bg-white\">{{Summary.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCountryDescription}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Paying City</p>\n                            <p class=\"col-md-6 bg-white\">{{Summary.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxPayingCity}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax Id</p>\n                            <p class=\"col-md-6 bg-white\">{{Summary.jointHoldersData[$index].fatcaDetail.fatcaTax1.taxId}}</p>\n                        </div>\n                        <div class=\"row m-top m-left-0\">\n                            <p class=\"col-md-6\">Tax ID type</p>\n                            <p class=\"col-md-6 bg-white\">{{Summary.taxIdTypeList[$index].description}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> --><!-- Nominee details --><div class=\"row PaddingResp\" ng-if=\"Summary.nomineeData.length > 0\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Nominee Details</p><!-- <img src=\"../../../assets/images/icons/edit.png\" ng-click=\"Summary.gotoNomineePage()\"\n                    style=\"height: 15px;cursor: pointer;\"> --></div><div class=\"col nominee-details-summary-wrapper\"><div class=\"col-xs-12 col-sm-6 col-md-4 nominee-details\" ng-repeat=\"x in Summary.nomineeData track by $index\"><div class=\"row m-top\"><p class=col-md-12 style=\"font-size: 14px; color: #497eac\">Nominee {{$index + 1}} Details</p></div><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeName}}</p> --></div><div class=\"row m-top\" ng-if=x.emailId><p class=col-md-6>Nominee Email ID</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.emailId readonly></div><div class=\"row m-top\" ng-if=x.emailId><p class=col-md-6>Nominee Mobile No</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.mobileNumber readonly></div><div class=\"row m-top\" ng-if=\"x.panNumber && !Summary.showNomineeUpdate\"><p class=col-md-6>Nominee PAN</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.panNumber readonly></div><div class=\"row m-top\" ng-if=Summary.showNomineeUpdate><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType === \'PAN_CARD\'\">Nominee PAN</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'AADHAR_CARD\'\">Nominee Aadhaar</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'DRIVING_LICENSE\'\">Nominee Driving License</p><p class=col-md-6 ng-if=\"x.identityProofType && x.identityProofType ===\'PASSPORT\'\">Nominee Passport</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.identityProofNumber readonly></div><div class=\"row m-top\"><p class=col-md-6>Nominee Relation</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeRelation readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeRelation}}</p> --></div><div class=\"row m-top\" ng-if=x.dob><p class=col-md-6>Nominee DOB</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.dob readonly><!-- <p class=\"col-md-6 bg-white\">{{x.dob}}</p> --></div><div class=\"row m-top\" ng-if=x.minor><p class=col-md-6>The Nominee is Minor</p><input type=checkbox ng-model=x.minor disabled></div><div class=\"row m-top\"><p class=col-md-6>Nominee Percentage</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.percentage readonly><!-- <p class=\"col-md-6 bg-white\">{{x.percentage}}</p> --></div><div class=\"row m-top\" ng-if=!x.minor><p class=col-md-6>The Nominee is Minor</p><input type=checkbox ng-model=x.minor disabled></div><div class=\"row m-top\" ng-if=x.guardianName><p class=col-md-6>Guardian\'s Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianName readonly><!-- <p class=\"col-md-6 bg-white\">{{x.guardianName}}</p> --></div><div class=\"row m-top\" ng-if=Summary.guardianRelationshipWithNominee[$index].relationDesc><p class=col-md-6>Guardian\'s Relationship</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.guardianRelationshipWithNominee[$index].relationDesc readonly></div><div class=\"row m-top\" ng-if=Summary.addressLine1[$index]><p class=col-md-6 ng-if=Summary.gAddress[$index]>Guardian\'s Address Line1</p><p class=col-md-6 ng-if=!Summary.gAddress[$index]>Nominee\'s Address Line1</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.addressLine1[$index] readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.addressLine1[$index]}}</p> --></div><div class=\"row m-top\" ng-if=Summary.addressLine2[$index]><p class=col-md-6 ng-if=Summary.gAddress[$index]>Guardian\'s Address Line2</p><p class=col-md-6 ng-if=!Summary.gAddress[$index]>Nominee\'s Address Line2</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.addressLine2[$index] readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.addressLine2[$index]}}</p> --></div><div class=\"row m-top\" ng-if=Summary.nomineeCountry[$index].countryName><p class=col-md-6 ng-if=Summary.gAddress[$index]>Guardian\'s Country</p><p class=col-md-6 ng-if=!Summary.gAddress[$index]>Nominee\'s Country</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.nomineeCountry[$index].countryName readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.nomineeCountry[$index].countryName}}</p> --></div><div class=\"row m-top\" ng-if=\"x.nomineeAddress.city || x.guardianAddress.city\"><p class=col-md-6 ng-if=Summary.gAddress[$index]>Guardian\'s City</p><p class=col-md-6 ng-if=!Summary.gAddress[$index]>Nominee\'s City</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"x.nomineeAddress.city ? x.nomineeAddress.city : x.guardianAddress.city\" readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.city ? x.nomineeAddress.city : x.guardianAddress.city }}</p> --></div><div class=\"row m-top\" ng-if=x.nomineeAddress.pinCode><p class=col-md-6>Nominee PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.nomineeAddress.pinCode readonly><!-- <p class=\"col-md-6 bg-white\">{{x.nomineeAddress.pinCode}}</p> --></div><div class=\"row m-top\" ng-if=x.guardianAddress.pinCode><p class=col-md-6>Guardian\'s PinCode</p><input class=\"col-md-6 bg-white\" type=text ng-model=x.guardianAddress.pinCode readonly><!-- <p class=\"col-md-6 bg-white\">{{x.guardianAddress.pinCode}}</p> --></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"padding-left: 0px; margin-top: 15px\"><div class=col-md-4 ng-if=Summary.incapacitationDeclaration><p style=\"font-weight: bold;font-size: 15px\">Incapacitation Details</p><div class=\"row m-top\"><p class=col-md-6>Nominee Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.incapacitationDeclaration.nomineeName readonly></div><div class=\"row m-top\"><p class=col-md-6>Nominee Number</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.incapacitationDeclaration.nomineeNumber readonly></div><div class=\"row m-top\" ng-if=Summary.incapacitationDeclaration.percentage><p class=col-md-6>Percentage</p><input class=\"col-md-6 bg-white\" type=text ng-model=\"Summary.incapacitationDeclaration.percentage ? Summary.incapacitationDeclaration.percentage + \'%\' : \'OT AVAILABLE\'\" readonly></div><div class=\"row m-top\" ng-if=Summary.incapacitationDeclaration.amount><p class=col-md-6>Amount</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.incapacitationDeclaration.amount readonly></div></div><div class=\"col-md-4 statement-dec-summary\" ng-if=Summary.accountHoldingDeclaration><p style=\"font-weight: bold;font-size: 15px\">Statement of Holding</p><div class=\"row m-top\"><p class=col-md-6>{{Summary.accountHoldingDeclaration === \'NOMINATION_YES\' ? \'Nomination: Yes\' : \'Nomination: No\'}}</p></div></div></div></div><!-- bank details  --><div class=\"row PaddingResp\" style=\"background: #d8e9f9;padding: 10px;margin-bottom: 15px;border-radius: 10px;padding-left: 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"display: flex;justify-content: space-between\"><p style=\"font-weight: bold;font-size: 15px\">Bank Details</p><img src=../../../assets/images/icons/edit.png ng-click=Summary.gotoBankPage() style=\"height: 15px;cursor: pointer\"></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>Bank Name</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.bankDetails.bankName readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.bankDetails.bankName}}</p> --></div><div class=\"row m-top\"><p class=\"col-md-6 m-top\">Account Type</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.bank.accountType readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.bank.accountType}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Payout Mechanism</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.payoutDescriptionData.payoutDescription readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.payoutDescriptionData.payoutDescription}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Account Number</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.bankDetails.accountNumber readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.bankDetails.accountNumber}}</p> --></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row m-top\"><p class=col-md-6>IFSC Code</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.bankDetails.ifsccode readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.bankDetails.ifsccode}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch Location</p><textarea class=\"col-md-6 bg-white textAreaSize\" rows=4 type=text style=\"height: 72PX;resize:none\" ng-model=Summary.folioDetails.bankDetails.bankBranch readonly> </textarea><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.bankDetails.bankBranch}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Branch City</p><input class=\"col-md-6 bg-white\" type=text ng-model=Summary.folioDetails.bankDetails.bankCity readonly><!-- <p class=\"col-md-6 bg-white\">{{Summary.folioDetails.bankDetails.bankCity}}</p> --></div><div class=\"row m-top\"><p class=col-md-6>Cheque leaf Image</p><div class=\"col-md-6 bg-white minbg\" style=\"display: flex;justify-content: space-between;align-items: center;padding: 8px\"><p class=ml-15 style=\"font-weight: 100;line-height: 12px\">Cheque leaf Image</p><img src=../../../../assets/images/icons/ic-img.png ng-click=Summary.openUploadedDoc(Summary.folioDetails.bankDetails.chequeLeaf) alt=\"\" style=\"height: 15px\"></div></div></div></div></div><div class=\"modal-footer center-aligned\"><button class=btn style=\"border-radius: 40px; padding: 0px;border: none; padding-left: 25px;padding-right: 25px;height: 35px; background-color: #ff5153;color:white\" ng-click=Summary.rejectTransaction()>Reject</button> <button class=btn style=\"border-radius: 40px; padding: 0px;border: none; padding-left: 25px;padding-right: 25px;height: 35px; background-color: #ff5153;color:white\" ng-click=Summary.createNewFolio() ng-disabled=summarycontact.$error.required>Approve</button></div></div></div></div><style>p {\n        line-height: 15px;\n        font-size: 12px;\n        font-weight: 600;\n        font-family: \"monasans-bold\", sans-serif !important;\n    }\n\n    .m-left-0 {\n        margin-left: 0px;\n    }\n\n    .m-top {\n        margin-top: 5px;\n    }\n    input{\n        font-size: 14px;\n        font-weight: 400;\n        font-family: \"monasans-bold\", sans-serif !important;\n        color: #444444;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    }\n    .bg-white {\n        font-family: \"monasans-bold\", sans-serif !important;\n        color: #444444;\n        background-color: white;\n        font-size: 13px;\n        text-align: start;\n        border-radius: 6px;\n        padding: 0px;\n        margin: 0px;\n        font-weight: 100;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n        height: 30px;\n        border: 1px solid lightgray;\n        padding-left: 5px;\n    }\n    .userName{\n        font-family: \"Mona Sans\",sans-serif;\n  font-weight: 400;\n  opacity: 0.7;\n  font-size: 15px;\n    }\n\n    .nominee-details-summary-wrapper {\n      display: flex;\n      width: 100%;\n      overflow-x: auto;\n      padding-bottom: 15px;\n    }\n\n    .nominee-details-summary-wrapper > .nominee-details {\n      flex: 0 0 auto;\n    }\n\n    @media screen and (max-width: 990px) {\n    .minbg{\n        width: 177px;\n    }\n    p{\n        margin-left: -15px;\n    }\n    .ml-15{\n        margin-left: 0px;\n    }\n    .PaddingResp{\n        padding-left:8px !important;\n    }\n  }\n\n\n  @media only screen and (max-device-width : 1008px) {\n    .reviewFolioPage{\n    margin-left: 5px;\n    }\n  }\n  @media only screen and (min-device-width : 768px) and (max-device-width : 768px) {\n    .hdfc-blue-cta-small{\n      width: 163px !important;\n    }\n    .btn{\n        width: 163px;\n    }\n  .stepper-horizontal-responsive .step li {\n       z-index: 5;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(2){\n    z-index: 4;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(3){\n    z-index: 3;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(4){\n    z-index: 2;\n  }\n  .stepper-horizontal-container .stepper-horizontal-responsive .step li:nth-child(5){\n    z-index: 1;\n  }\n}\n.border-right{\n    border-right: 1px solid #ccc;\n    padding-left: 10px;\n}\n@media only screen and (max-device-width : 960px) {\n    .border-right{\n    border-right:none;\n}\n  }\n  .border-right .row{\n    margin: 4px 3px 4px 0px;\n  }\n  @media only screen and (max-width: 768px) {\n    .userName{\n        margin-left: 5px;\n    }\n    .p-0{\n    padding: auto !important;\n    }\n    .border-right{\n    padding-left: 0px;\n    }\n    .flexNormal{\n        flex-shrink: 1 !important;\n    }\n  }\n  @media only screen and (min-device-width : 990px) {\n   .p-0{\n    padding: 0px;\n    }\n  }\n@media only screen and (min-device-width : 767px) and (max-device-width : 988px) {\n    .titleResponsive{\n        padding-left: 22px !important;\n    }\n  }</style>");
$templateCache.put("app/transactions/initiate/bulk-transaction/bulk-transaction.html","<section class=\"transaction main-section bulk-transaction\"><div class=\"loader allList\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your data...</span></div><h3 class=page-title>Bulk Transactions</h3><ul class=\"nav nav-tabs transactions\"><li ng-repeat=\"tab in BulkTransaction.tabs\" ng-class=\"{\'active-link\': tab.active}\"><a href=javascript:void(0); ng-click=BulkTransaction.redirectToTab(tab.key)>{{tab.key}}</a></li></ul><div class=tab-content><div ui-view></div></div></section>");
$templateCache.put("app/transactions/initiate/dream-sip/dream-sip.html","<section class=\"initiate-transition sip-purchase\" ng-init=DreamSip.init()><div class=content-header><h5>Dream SIP</h5><h5>Transaction for: {{DreamSip.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Dream SIP</li></ul></div><div class=content><form autocomplete=off class=sipPurchase-form name=dreamSipForm novalidate><div class=\"top-wrap proceed-options\"><div class=flex-style><div class=topBarMargin><div class=form-group><label>Existing Folio No:</label><div class=selectfield ng-class=\"{error:(DreamSip.hasFolioEmailId == false)||(dreamSipForm.folio.$dirty && dreamSipForm.folio.$invalid)}\"><label>Select</label><select class=\"browser-default custom-select select-folio-list\" name=folio ng-model=DreamSip.formData.folioNumber ng-change=DreamSip.folioChanged() ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in DreamSip.folioList\" ng-init=\"DreamSip.formData.folioNumber=DreamSip.formData.folioNumber?DreamSip.formData.folioNumber: null\" required><option value=\"\">Select Folio</option></select><span ng-show=\"dreamSipForm.folio.$dirty && dreamSipForm.folio.$invalid\"><span class=error-input ng-show=dreamSipForm.folio.$error.required ng-bind=DreamSip.validations.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=\"DreamSip.hasFolioEmailId == false\" ng-bind=DreamSip.validations.FOLIO_EMAIL></span></div></div></div><div class=topBarMargin><p class=orSipOption>OR</p></div><div class=topBarMargin ng-click=DreamSip.newFolioClickAction();><label class=\"text-blue cursor-pointer\"><strong>Proceed with a New Folio</strong></label></div></div></div><div ng-class=\"{\'anything-disabled\': (!DreamSip.formData.folioNumber||(DreamSip.hasFolioEmailId == false)) }\"><div class=\"normal-wrap clearfix\" style=\"padding-bottom: 10px;padding-top: 0px\"><div class=choose-type><table class=\"table table-custom-sub-fields\"><tr><td>Sub Broker ARN</td><td>:</td><td colspan=2 class=sub-broker-arn><div class=col-md-10><div class=input-normal><input type=text class=arn-no name=subBrokerARNDesk id=subBrokerARN ng-model=DreamSip.formData.subBrokerARN ng-change=DreamSip.changeSubBrokerArn() ng-blur=DreamSip.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label class=\"sub-broker-arn-label\">Sub Broker ARN</label>--><p ng-if=DreamSip.subBrokerName class=info-primary>Sub Broker Name: {{DreamSip.subBrokerName}}</p><span class=error-input ng-if=\"dreamSipForm.subBrokerARNDesk.$dirty && dreamSipForm.subBrokerARNDesk.$invalid && dreamSipForm.subBrokerARNDesk.$error.pattern\">{{DreamSip.VALIDATE_DATA.BROKER_VALID}}</span> <span class=error-input ng-show=\"DreamSip.subBrokerCodeError != \'\' && !dreamSipForm.subBrokerARNDesk.$invalid && DreamSip.formData.subBrokerARN\" ng-bind=DreamSip.subBrokerCodeError></span></div></div></td><td>Sub Broker Code</td><td>:</td><td colspan=2 class=sub-broker-code><div class=col-md-10><div class=input-normal ng-class={error:DreamSip.dreamSipForm.subBrokerCode.$dirty&&DreamSip.dreamSipForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=DreamSip.formData.subBrokerCode autocomplete=off ng-disabled=\"!DreamSip.formData.subBrokerARN || DreamSip.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=DreamSip.dreamSipForm.subBrokerCode.$dirty&&DreamSip.dreamSipForm.subBrokerCode.$error.required ng-bind=DreamSip.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-custom-sub-fields-mobile\"><tr><td>Sub Broker ARN</td><td>:</td><td class=sub-broker-arn><div class=col-sm-12><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=DreamSip.formData.subBrokerARN ng-change=DreamSip.changeSubBrokerArn() ng-blur=DreamSip.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label>Sub Broker ARN</label>--><p ng-if=DreamSip.subBrokerName class=info-primary>Sub Broker Name: {{DreamSip.subBrokerName}}</p><span class=error-input ng-if=\"dreamSipForm.subBrokerARN.$dirty && dreamSipForm.subBrokerARN.$invalid && dreamSipForm.subBrokerARN.$error.pattern\">{{DreamSip.VALIDATE_DATA.BROKER_VALID}}</span> <span class=error-input ng-show=\"DreamSip.subBrokerCodeError != \'\' && !dreamSipForm.subBrokerARN.$invalid && DreamSip.formData.subBrokerARN\" ng-bind=DreamSip.subBrokerCodeError></span></div></div></td></tr><tr><td>Sub Broker Code</td><td>:</td><td class=sub-broker-code><div class=col-sm-12><div class=input-normal ng-class={error:DreamSip.dreamSipForm.subBrokerCode.$dirty&&DreamSip.dreamSipForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=DreamSip.formData.subBrokerCode autocomplete=off ng-disabled=\"!DreamSip.formData.subBrokerARN || DreamSip.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=DreamSip.dreamSipForm.subBrokerCode.$dirty&&DreamSip.dreamSipForm.subBrokerCode.$error.required ng-bind=DreamSip.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-sipPurchase\"><!-- <tr>\n                <td>Investor Name</td>\n                <td>:</td>\n                <td></td>\n              </tr> --><tr ng-if=!DreamSip.oversea_arn><td>EUIN</td><td>:</td><td><div class=\"col-md-4 col-sm-6 input-euin\"><div class=\"input-select input-normal selectfield select-euin drop-arrow\"><select class=\"browser-default custom-select\" name=selectEuin ng-change=DreamSip.euinChanged() ng-model=DreamSip.formData.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in DreamSip.euinList\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=\"req text-red\">*</span></div></div></td></tr></table></div></div><div class=\"normal-wrap sm-wrapper\" style=\"padding-top: 0px\"><div class=sip-form-box><div class=\"row align-row\"><div class=\"col-md-4 col-lg-4 col-sm-4\"><label class=main-subheading>Select Option</label><div class=\"row pt-25\"><div class=\"col-md-4 col-lg-4 col-sm-6\"><div class=radio-block><span class=radio><input type=radio class=radio id=option1 ng-model=DreamSip.formData.option name=Option value=\"Option A\" ng-change=DreamSip.changeOption(DreamSip.formData.option)> <span class=check></span></span><label class=radio-label>Option A</label></div></div><div class=\"col-md-4 col-lg-4 col-sm-12\"><div class=radio-block><span class=radio><input type=radio class=radio id=option2 ng-model=DreamSip.formData.option name=Option value=\"Option B\" ng-change=DreamSip.changeOption(DreamSip.formData.option) required> <span class=check></span></span><label class=radio-label>Option B</label></div></div></div></div><div class=\"col-md-8 col-lg-8 col-sm-6\"><div class=\"point-to-note imp-info ng-scope\" style=\"margin: 0px 0 10px\">Please Note:<br><br><p><i class=dot></i> <span>Click to download <a ng-click=\"DreamSip.openDreamDocumentFile(\'https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/HDFC+Dream+SIP+-+Presentation.pdf\')\" href=javascript:void(0) class=nav-faq-link><b>Dream SIP Presentation</b></a> and <a ng-click=\"DreamSip.openDreamDocumentFile(\'https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/s3fs-public/HDFC+Dream+SIP+-+FAQs.pdf\')\" href=javascript:void(0) class=nav-faq-link><b>Dream SIP FAQs</b></a>.</span></p><p><i class=dot></i> <span>Under Option A - SIP and SWAP shall trigger in the same scheme.</span></p><p><i class=dot></i> <span>Under Option B - SIP shall be registered in source sheme, while SWAP shall get triggered in Target scheme after switching entire units from source to Target scheme.</span></p></div></div></div></div><div class=\"row pt-25\"><div class=\"col-md-12 col-lg-12 col-sm-12\"><label class=\"form-label less main-subheading\">Add Scheme</label></div></div><div class=\"row pt-25\"><div class=\"col-md-3 col-sm-6 col-lg-3\"><div class=\"input-select input-normal\"><input type=text name=sInScheme1 id=sInScheme1 ng-model=DreamSip.formData.inSchemeName ng-change=DreamSip.filterInSchemeList() onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required> <span class=highlight></span> <span class=bar></span><label ng-if=\"DreamSip.formData.option == \'Option A\'\">Select a Scheme</label><label ng-if=\"DreamSip.formData.option == \'Option B\'\">Select Source Scheme</label><span class=error-input ng-show=\"dreamSipForm.sInScheme1.$dirty && dreamSipForm.sInScheme1.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=DreamSip.inSchemeList display-key=scheme hdfc-click=\"DreamSip.inSchemeChanged(data, \'sip\')\" model=DreamSip.formData.inSchemeCode for=sInScheme1></drop-down><p class=info-primary>{{DreamSip.formData.inSchemeName}}</p></div></div><div ng-if=!DreamSip.formData.dynamicData.readOnly class=\"col-md-offset-1 col-md-4 scheme-invoke\" style=\"margin: unset\"><span>OR</span> <span class=\"text-primary cursor-pointer\" ng-click=DreamSip.schemeListModal()><i class=list-icon></i> Select from List</span></div></div><div class=row ng-if=\"DreamSip.formData.option == \'Option B\'\"><div class=\"col-md-3 col-sm-6 col-lg-3\"><div class=\"input-select input-normal\"><input type=text name=tagetScheme id=tagetScheme ng-change=DreamSip.filterTargetSchemeList() ng-model=DreamSip.formData.targetSchemeName onpaste=\"return false\" ondrop=\"return false\" autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>Select Target Scheme</label><span class=error-input ng-show=\"dreamSipForm.tagetScheme.$dirty && dreamSipForm.tagetScheme.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=DreamSip.targetSchemeList display-key=scheme hdfc-click=\"DreamSip.targetSchemeChanged(data, \'sip\')\" model=DreamSip.formData.targetSchemecode for=tagetScheme></drop-down><p class=info-primary>{{DreamSip.formData.targetSchemeName}}</p></div></div></div><div class=\"row pt-25\"><div class=\"col-md-12 col-lg-12 col-xs-12\"><label class=\"form-label less main-subheading\">Installment Frequency</label></div><div class=\"col-md-6 col-sm-6 col-lg-6\"><div class=form-group><div class=radio-block><span class=radio><input type=radio id=frq1 ng-model=DreamSip.formData.frequency value=OM name=installmentFrequency required> <span class=check></span></span><label class=radio-label>Monthly</label></div></div></div></div><div class=\"row pt-25\"><div class=\"col-md-12 col-lg-12 col-xs-12\"><label class=\"form-label less main-subheading\">Select SIP Period (in years)</label></div><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=selectfield><select class=\"browser-default custom-select select-box\" name=sipPeriod ng-model=DreamSip.formData.sipPeriod ng-change=\"DreamSip.checkSipValidations(); DreamSip.handleMandatePaymentOption();\" ng-options=\"sipPeriod.value as (sipPeriod.value + \' years\')  for sipPeriod in DreamSip.sipPeriodArray\" required style=\"margin: 0px !important\"></select></div></div></div><br><br><div class=row><div class=\"col-md-4 col-lg-4 col-sm-6\"><div class=input-normal ng-class=\"{error:((DreamSip.isMinSipAmount && DreamSip.formData.installmentAmount)\n                        || (!DreamSip.isMinSipAmount && DreamSip.formData.installmentAmount && (DreamSip.sipValidations.amountMultiples&&!DreamSip.isMultiples))\n                        ||(DreamSip.isOtmLimitLess && DreamSip.formData.installmentAmount))}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel ng-change=DreamSip.checkSipValidations() name=installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords392\')\" ng-model=DreamSip.formData.installmentAmount autocomplete=off ng-model-options=\"{debounce: 100}\" required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>SIP Amount</label><span class=error-input ng-if=\"DreamSip.isOtmLimitLess && dreamSipForm.installmentAmount.$valid &&\n                !DreamSip.isMinSipAmount\">{{\'Amount should not be greater than OTM Limit(\'+ DreamSip.otmBankLimit+\')\'}} </span><span class=error-input ng-show=\"dreamSipForm.installmentAmount.$dirty && dreamSipForm.installmentAmount.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span class=amount-error ng-if=\"(DreamSip.isMinSipAmount && DreamSip.formData.installmentAmount)\" class=error-input>{{\'Minimum amount should be &#8377; \'+ DreamSip.validations.minAmount}} </span><span class=amount-error ng-if=DreamSip.amountExceeded class=error-input>This is a high value registration, we request you to contact (hello@hdfcfund.com) for assistance to complete your registration. </span><span class=amount-error ng-if=\"( DreamSip.formData.paymentMode.key === \'HEM\' && DreamSip.isEmandateMaxLimit && DreamSip.formData.installmentAmount)\" class=error-input>{{\'SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode\'}} </span><span ng-if=\"dreamSipForm.installmentAmount.$invalid && dreamSipForm.installmentAmount.$error.number\" class=error-input>{{DreamSip.VALIDATE_DATA.INVALID_AMOUNT}} </span><span ng-if=\"dreamSipForm.installmentAmount.$valid && !DreamSip.isMinSipAmount &&\n                    (DreamSip.validations.amountMultiples&&!DreamSip.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{DreamSip.validations.amountMultiples|unit}}</span><div class=amount-in-words><span id=divDisplayWords392></span> <span>(In Words)&nbsp;</span></div></div></div><div class=\"col-sm-offset-3 amount-button-container\" ng-if=DreamSip.formData.inSchemeCode><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in DreamSip.sipFirstInstallmentAmount\" ng-click=\"DreamSip.formData.installmentAmount=amount;\"><img src=../../assets/images/icons/rupee-white.png>{{amount}}</button></div></div><div class=\"row align-row\"><div class=\"col-md-4 col-lg-4 col-sm-12\"><div class=\"input-normal icon-input\" ng-class=\"{error:(dreamSipForm.swapAmount.$invalid && dreamSipForm.swapAmount.$dirty),\'has-data\':DreamSip.formData.swapAmount}\"><input type=number ignore-mouse-wheel name=swapAmount ng-model=DreamSip.formData.swapAmount ng-change=DreamSip.checkSwapValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords1\')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required> <span class=highlight></span> <span class=bar></span><label>SWAP Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=\"dreamSipForm.swapAmount.$dirty && dreamSipForm.swapAmount.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span ng-if=\"DreamSip.formData.swapAmount && DreamSip.isSwapMin\" class=error-input>Minimum amount should be &#8377; {{DreamSip.validations.swpValidationDTO.monMinAmt|unit}}</span> <span ng-if=\"DreamSip.formData.swapAmount && DreamSip.isSwapMax \" class=error-input>Maximum amount should be &#8377; {{DreamSip.maxSwapAmount|unit}}</span> <span ng-if=\"DreamSip.formData.swapAmount && !DreamSip.isSwapMax && !DreamSip.isSwapMin && (DreamSip.validations.amountMultiples&&!DreamSip.isSwapMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{DreamSip.validations.swpValidationDTO.monAmtMultiples|unit}}</span><div><span id=divDisplayWords1></span><span>(In Words)</span></div></div></div><div class=col-md-8><div class=\"point-to-note imp-info ng-scope\" style=\"margin: 0px 0 10px\">Please Note:<br><br><p><i class=dot></i> <span>SWAP Amount Cannot be greater than pre-defined amount set for each sip period. <a ng-click=DreamSip.DreamSipTenure() href=javaScript:void(0) style=\"color: blue\">click here</a> to know maximum SWAP amount allowed for each sip period.</span></p></div></div></div><div class=row ng-if=\"DreamSip.validations.investmentOption == DreamSip.TRANSACTIONS_CONST.DIVIDEND\"><div class=\"col-md-12 col-lg-12 col-sm-12\"><label class=\"form-label less main-subheading\">Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=row style=\"margin-left: 15px\"><div class=\"col-md-12 form-group\" ng-class=\"{\'radio-disabled\':DreamSip.validations.isEnabled==\'N\'}\" style=\"padding: 0\" ng-if=\"DreamSip.validations.investmentOption == DreamSip.TRANSACTIONS_CONST.DIVIDEND\"><div class=radio-block ng-repeat=\"_option in DreamSip.devidendOptions\"><span class=radio><input type=radio id=sDividendOption{{_option}} ng-value=_option name=sDividendOption ng-model=DreamSip.formData.sipDividendOption required> <span class=check></span></span><label class=radio-label>{{DreamSip.DIVIDEND_DESCRIPTIONS[_option]}}</label></div></div></div></div><div class=\"row form-group\" ng-if=\"DreamSip.isSchemeTypeELSS && DreamSip.validations.investmentOption == DreamSip.TRANSACTIONS_CONST.DIVIDEND\"><div class=info-primary>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option is not applicable for ELSS</div></div><div class=\"row pt-25\" ng-if=DreamSip.SIP_Installment_disable><div class=\"col-md-6 col-lg-6 col-sm-12\"><div class=\"install-freq frequency sip-fi\"><label class=main-subheading>Do you wish to pay First Installment with your SIP Registration:</label><div class=radio-block><span class=radio><input type=radio name=sipFirstInstallment ng-model=DreamSip.formData.sipFirstInstallment ng-change=DreamSip.changeFirstInstallment(true) ng-value=true> <span class=check></span></span><label>Yes</label></div><div class=radio-block><span class=radio><input type=radio name=sipFirstInstallment ng-model=DreamSip.formData.sipFirstInstallment ng-change=DreamSip.changeFirstInstallment(false) ng-value=false> <span class=check></span></span><label>No</label></div></div></div></div><div class=pt-25><p class=main-subheading>Payment Options</p><p ng-if=\"DreamSip.PAYMENT_MODE.length==0\" class=\"payment-error-message no_payment_text\"><strong>No valid payment mode available to proceed with SIP transaction</strong></p><div class=radio-block><div class=paymentOption><!--                <div class=\"form-group\" ng-if=\"DreamSip.ECbankList\">--><!--                  <div class=\"radio-block\">--><!--                    <span class=\"radio\">--><!--                      <input type=\"radio\" id=\"\" name=\"paymentOption\" ng-model=\"DreamSip.formData.sipPaymentOption\" ng-change=\"DreamSip.changePaymentOption()\" value=\"EC\" />--><!--                      <span class=\"check\"></span>--><!--                    </span>--><!--                    <label class=\"radio-label\">Standing Instruction/Biller</label>--><!--                  </div>--><!--                </div>--><div class=\"marR-25 form-group\" ng-if=DreamSip.isUPIEnabled><div class=radio-block><span class=radio><input type=radio name=paymentOption ng-model=DreamSip.formData.sipPaymentOption ng-change=DreamSip.changePaymentOption() value=UPI> <span class=check></span></span><label class=radio-label>UPI Autopay</label></div></div><div class=\"marR-25 form-group\" ng-if=DreamSip.isOTMEnabled><div class=radio-block><span class=radio><input type=radio name=paymentOption ng-model=DreamSip.formData.sipPaymentOption ng-change=DreamSip.changePaymentOption() value=OTM> <span class=check></span></span><label class=radio-label>OTM (One Time Mandate)</label></div></div><div class=\"marR-25 form-group\" ng-if=\"DreamSip.isEMandateEnabled && !DreamSip.formData.sipFirstInstallment\"><div class=radio-block><span class=radio><input type=radio name=paymentOption ng-model=DreamSip.formData.sipPaymentOption ng-change=DreamSip.changePaymentOption() value=HEM> <span class=check></span></span><label class=radio-label>Register Emandate(eOTM)</label></div></div><div class=\"marR-25 form-group\" ng-if=DreamSip.ECbankList><div class=radio-block><span class=radio><input type=radio name=paymentOption ng-model=DreamSip.formData.sipPaymentOption ng-change=DreamSip.changePaymentOption() value=EC> <span class=check></span></span><label class=radio-label>Standing Instruction/Biller</label></div></div><div class=\"col-md-3 form-group\"></div></div><div class=row ng-if=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_DreamSIP><div class=col-md-12><div><ng-bind-html dynamic=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_Review_DreamSIP.content></ng-bind-html></div></div></div><br><div class=row ng-if=\"DreamSip.formData.sipPaymentOption == \'EC\' && DreamSip.formData.sipFirstInstallment\"><div class=col-md-12><p class=main-subheading>Payment Mode Selection for First Installment of Dream SIP</p></div><div class=row style=\"margin-left: 0px\"><div class=\"col-md-3 form-group\"><div class=radio-block><span class=radio><input type=radio name=paymentMode ng-model=DreamSip.formData.sipPaymentMode ng-change=DreamSip.changePaymentMode() value=COTM> <span class=check></span></span><label class=radio-label>OTM(One Time Mandate)</label></div></div><div class=\"col-md-3 form-group\"><div class=radio-block><span class=radio><input type=radio name=paymentMode ng-model=DreamSip.formData.sipPaymentMode ng-change=DreamSip.changePaymentMode() value=NETBANKING> <span class=check></span></span><label class=radio-label>Net Banking</label></div></div></div></div><!-- Bank detals --><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption == \'EC\' && DreamSip.formData.sipPaymentMode==\'COTM\' \"><div class=row><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=selectfield ng-class=\"{error:dreamSipForm.bank.$dirty && dreamSipForm.bank.$invalid}\"><select class=select-noborder name=bank ng-disabled=false ng-model=DreamSip.formData.cOtmBankInfo ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.COTMBANKLIST\" value={{bank}}>{{bank.bankName}} {{bank.bankAcNo}}</option></select><label>Select Bank</label><span class=error-input ng-show=\"dreamSipForm.bank.$dirty && dreamSipForm.bank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div><!-- ///////////////////////change  --></div></div></div><!-- OTM --><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption == \'OTM\' \"><div class=row><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=selectfield ng-class=\"{error:dreamSipForm.bank.$dirty && dreamSipForm.bank.$invalid}\"><select class=select-noborder name=bank ng-disabled=false ng-model=DreamSip.formData.otmBank ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.OTMbankList\" value={{bank}}>{{bank.bankName}} {{bank.bankAcNo}}</option></select><label>Select Bank</label><span class=error-input ng-show=\"dreamSipForm.bank.$dirty && dreamSipForm.bank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div><!-- ///////////////////////change tooooooooooo --></div></div><div class=row ng-if=\"DreamSip.formData.sipPaymentOption == \'OTM\' &&  DreamSip.formData.otmBank\"><div class=\"col-md-6 col-lg-6 col-sm-10\"><table class=\"table borderless\"><tr><td>OTM Bank Name</td><td>: {{DreamSip.formData.bankInfo.bankName}}</td></tr><tr><td>OTM Start Date</td><td>: {{DreamSip.formData.bankInfo.omStartDate}}</td></tr><tr><td>OTM Maturity Date</td><td>: {{DreamSip.formData.bankInfo.omExpiryDate}}</td></tr><tr><td>OTM Instruction Type</td><td>: {{DreamSip.formData.bankInfo.otmFrequencyName ? DreamSip.formData.bankInfo.otmFrequencyName : DreamSip.formData.bankInfo.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td>: <i class=rupee-icon ng-if=DreamSip.formData.bankInfo.maxAmount></i>{{DreamSip.formData.bankInfo.maxAmount}}<p ng-if=\"DreamSip.formData.bankInfo.maxAmount < DreamSip.formData.installmentAmount\" class=error-input>SIP amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed</p></td></tr></table></div></div></div><!-- HEM --><div class=\"borderline emandate-section\" ng-if=\"DreamSip.formData.sipPaymentOption == \'HEM\' &&  DreamSip.emandateUpiData\"><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Select Bank</div><div class=col-md-3><div class=\"input-select input-normal selectfield\" style=\"margin-top: 0\" ng-class=\"{error:dreamSipForm.bank.$dirty && dreamSipForm.bank.$invalid}\"><select class=select-noborder name=bank ng-disabled=false ng-model=DreamSip.formData.eMandateBank ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.EMbankList\" value={{bank}}>{{bank.bankName}}</option></select><span class=error-input ng-show=\"dreamSipForm.bank.$dirty && dreamSipForm.bank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div><div class=row><span class=error-input ng-show=DreamSip.isMobileinValid ng-bind=DreamSip.validations.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=DreamSip.isEmailinValid ng-bind=DreamSip.validations.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=DreamSip.isEmailMobileinValid ng-bind=DreamSip.validations.INVALID_EMAIL_MOBILE_EMANDATE></span></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Authentication Mode</div><div class=col-md-3><div class=\"selectfield input-normal\" style=\"margin-top: 0\"><select name=authenticationMode class=\"authModeDropdown custom-select\" ng-model=DreamSip.formData.authModeSelect ng-change=DreamSip.getAuthModeSelect() ng-options=\"authMode.text for authMode in DreamSip.formData.bankInfo.authenticationModes\" ng-init=\"DreamSip.formData.authModeSelect=DreamSip.formData.authModeSelect?DreamSip.formData.authModeSelect: null\" required><option value=\"\" selected>{{(DreamSip.authenticationModes && !DreamSip.authenticationModes.length) ?\'No Authentication Mode Available\':\'Select Authentication Mode\'}}</option></select></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate Amount</div><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(DreamSip.tForm.eAmount.$invalid && DreamSip.tForm.eAmount.$dirty),\'has-data\':DreamSip.formData.emandateAmount}\"><input class=input-min type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=DreamSip.formData.emandateAmount ng-change=DreamSip.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=DreamSip.formData.emandateAmount><p id=amountInwordsEmandate>{{DreamSip.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                      <span class=\"text-success\">--><!--                        Maximum allowed for e-mandate is ₹ {{DreamSip.mandateMaxString}}.--><!--                      </span>--><div class=error-input ng-show=\"DreamSip.amountLess && DreamSip.formData.emandateAmount\">{{DreamSip.VALIDATE_DATA.EMANDATE_MIN_ERROR + DreamSip.emandateMinAmountLimit}}.</div><div class=error-input ng-show=DreamSip.amountMore>{{DreamSip.VALIDATE_DATA.EMANDATE_MAX_ERROR + DreamSip.mandateMaxString}}.</div><div class=error-input ng-show=\"!DreamSip.amountLess && DreamSip.isLessThanSipAmount\" ng-bind=DreamSip.VALIDATE_DATA.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!DreamSip.formData.emandateAmount ng-bind=DreamSip.VALIDATE_DATA.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div class=row><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate Start Date</div><div class=\"col-md-3 anything-disabled\" ng-if=!DreamSip.isReseting><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{DreamSip.viewMode}} data-date-default=DreamSip.formData.emandateDate id=emandateStartDate data-enable=true style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=\"row mandateDates\"><div class=\"col-md-3 set-font-weight-bold label-emandate-dream-sip\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{DreamSip.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !DreamSip.formData.emandateDate}\"><div class=form-group ng-if=!DreamSip.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal eEndDate\" ng-class=\"{error:DreamSip.tForm.endDateEmandate.$dirty && DreamSip.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=DreamSip.formData.endDateEmandate data-enabled-dates=DreamSip.enabledEmandateEndDatesList data-view-date=DreamSip.enabledEndDateView data-min-date=DreamSip.enabledEmandateEndDatesList[0] data-on-date-change=DreamSip.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"DreamSip.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off id=endDateManddate placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input style=\"position: absolute\" ng-show=DreamSip.sipDateLessEmandate ng-bind=DreamSip.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><ng-bind-html dynamic=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_eOTM.content ng-if=\"DreamSip.formData.authModeSelect.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=DreamSip.DynamicDataSipPurchaseReview.noteDTO.noteDTOMap.Note_SIP_eOTM_Debit_Card.content ng-if=\"DreamSip.formData.authModeSelect.value === \'DEBIT_CARD\'\"></ng-bind-html></div><!--UPI--><div class=borderline ng-if=\"DreamSip.formData.sipPaymentOption == \'UPI\'\"><div class=row><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=selectfield ng-class=\"{error:dreamSipForm.upiBbank.$dirty && dreamSipForm.upiBbank.$invalid}\"><select class=select-noborder name=upiBbank ng-disabled=false ng-model=DreamSip.formData.upiBankInfo ng-change=DreamSip.changeBank() required><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in DreamSip.upiBankList\" value={{bank}}>{{bank.bankName}} {{bank.bankAcNo}}</option></select><label>Select Bank</label><span class=error-input ng-show=\"dreamSipForm.upiBbank.$dirty && dreamSipForm.upiBbank.$error.required && !DreamSip.formData.bankName\" ng-bind=DreamSip.VALIDATE_DATA.BANK_REQUIRED></span></div></div></div></div></div></div><div ng-if=\"DreamSip.formData.sipPaymentOption == \'UPI\'\"><!--dynamic content for UPI--><ng-bind-html dynamic=DreamSip.dynamicNoteSIPUPI.content></ng-bind-html></div><div class=\"row pt-25\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><label class=\"form-label less main-subheading\">Installment Date Details</label></div></div><div class=\"row pt-25\"><div class=\"col-md-12 col-lg-12 col-sm-12\"><label ng-if=DreamSip.formData.startDate>Start Date - DD-MMM-YYYY</label></div><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:dreamSipForm.startDate.$dirty && dreamSipForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode={{DreamSip.viewMode}} data-date-default=DreamSip.formData.startDate data-enabled-dates=DreamSip.enabledBillerStartDatesList data-min-date=DreamSip.startMinDateBiller data-max-date=DreamSip.startMaxDate data-on-date-change=DreamSip.changeStartDate id=StartDate data-enable=true style=\"position: relative\"><input type=text name=startDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly required> <span class=\"input-group-addon input-group-addon-date\"><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=dreamSipForm.startDate.$error.required ng-bind=DreamSip.VALIDATE_DATA.START_DATE_REQUIRED></span> <span class=error-input ng-show=DreamSip.isOTMStartDate ng-bind=\"DreamSip.VALIDATE_DATA.DATE_SIP_VALIDATION_ERROR + \' \' + DreamSip.formData.bankInfo.omStartDate\"></span></div></div></div><div class=\"row borderline\" ng-class=\"{\'anything-disabled\': DreamSip.formData.folioNumber }\"><div class=sip-dates><div class=\"col-md-12 col-lg-12 col-sm-12\"><label ng-if=DreamSip.formData.endDate>End Date - DD-MMM-YYYY</label></div><div class=\"col-md-3 col-lg-3 col-sm-6\"><div class=form-group><div class=\"input-normal verify-acc input-group date date-picker Transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=DreamSip.formData.endDate data-on-date-change=DreamSip.changeEndDate data-enabled-dates=DreamSip.enabledEndDates data-view-date=DreamSip.enabledEndDateView data-min-date=DreamSip.startMinDateBiller data-enable=true id=EndDate showdefault=false readonly><input type=text name=endDate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly required> <span class=\"input-group-addon input-group-addon-date\"><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"dreamSipForm.day.$dirty && dreamSipForm.day.$error.required\" ng-bind=DreamSip.VALIDATE_DATA.END_DATE_REQUIRED></span> <span class=error-input ng-show=DreamSip.isOTMEndDate ng-bind=DreamSip.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div><p class=error-input ng-if=DreamSip.endDateValidation>Selected end date is greater than OTM expiry date.</p></div></div></div></div><div class=\"row form-grid pt-25\" ng-if=DreamSip.sip_topup_details><div class=col-md-12><p class=main-subheading>SIP Top-up Details</p></div></div><div class=\"row pt-25\" style=\"padding: 30px 15px\" ng-if=DreamSip.sip_topup_details><div class=\"col-md-12 row form-group\" ng-if=!DreamSip.isReseting><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=sipToptup ng-model=DreamSip.formData.sipTopupSelected ng-change=DreamSip.changeSipTopupSelected()> <span class=icon-checkbox></span> </span>&nbsp;<label>SIP Top-up</label></div></div><div class=\"row borderline\" ng-if=DreamSip.sip_topup_details><div ng-class=\"{\'anything-disabled\': !DreamSip.formData.sipTopupSelected }\" class=col-md-12><div class=\"col-md-12 row\"><div class=\"row form-group\"><div class=col-md-3><div class=input-normal><input type=number ignore-mouse-wheel ng-change=DreamSip.changeTopupAmount(dreamSipForm) name=topupAmount onkeyup=\"NumToWord(this.value,\'topupAmntInWords\')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-disabled=\"[undefined,\'\',null].indexOf(DreamSip.formData.topupDetails.percentage)===-1\" ng-model=DreamSip.formData.topupDetails.amount autocomplete=off> <i class=rupee-grey-icon></i><label class=topUpLabelCss>Amount</label><p ng-if=\"DreamSip.isTopupMinAmt && dreamSipForm.topupAmount.$dirty && !DreamSip.formData.topupDetails.percentage\" class=error-input>Minimum TopUp amount should be &#8377;{{DreamSip.validations.topupMinAmt}}</p><p class=error-input ng-if=\"!DreamSip.isTopUpMultiples && dreamSipForm.topupAmount.$dirty && !DreamSip.isTopupMinAmt\">Please provide In multiples of &#8377; {{DreamSip.validations.topupAmtMultples + \'.\'}}</p><p class=error-input ng-if=dreamSipForm.topupAmount.$error.number>{{DreamSip.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</p><div ng-if=DreamSip.formData.topupDetails.amount class=amount-in-words><p id=topupAmntInWords></p><span>(In Words)&nbsp;</span></div></div></div><div class=\"col-md-1 form-grid text-center\" ng-show=DreamSip.AppConstants.SET_TOP_UP_PERCENTAGE_VIEW>OR</div><div class=col-md-3 ng-show=DreamSip.AppConstants.SET_TOP_UP_PERCENTAGE_VIEW><div class=input-normal><input type=number ignore-mouse-wheel ng-change=\"DreamSip.changeTopupPercentage(dreamSipForm); DreamSip.getTopupFrequencyList()\" name=topupPercentage onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-disabled=\"[undefined,\'\',null].indexOf(DreamSip.formData.topupDetails.amount) === -1\" ng-model=DreamSip.formData.topupDetails.percentage autocomplete=off ng-required=\"(!DreamSip.formData.topupDetails.amount && DreamSip.sipTopupSelected)\"><label class=topUpLabelCss>Percentage (%)</label><p class=error-input ng-if=\"DreamSip.isTopupMinPerc && dreamSipForm.topupPercentage.$dirty && !DreamSip.formData.topupDetails.amount\">{{\'Minimum percentage should be \'+ DreamSip.validations.topupMinPercentage+\'%.\'}}</p><p class=error-input ng-if=\"!DreamSip.isTopupPercMultiples && dreamSipForm.topupPercentage.$dirty && !DreamSip.isTopupMinPerc && !DreamSip.formData.topupDetails.amount\">{{\'Please provide in multiples of \'+ DreamSip.validations.topupPercentageMultples+\'%.\'}}</p><p class=error-input ng-if=\"dreamSipForm.topupPercentage.$invalid && dreamSipForm.topupPercentage.$error.number\">{{DreamSip.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</p></div></div></div><div class=row><div class=col-md-6><div class=install-freq><p class=main-subheading>Frequency</p></div></div></div><div class=\"row pt-25\"><div class=col-md-12><label class=\"form-label less\">SIP Top-up CAP</label></div></div><div class=\"row pt-25\"><div class=col-md-3><div class=input-normal ng-class=\"{error:(([undefined,\'\',null].indexOf(DreamSip.formData.topupDetails.capAmount) === -1\n                    && DreamSip.formData.topupDetails.capAmount <1) || (DreamSip.isminCapAmount))}\"><input type=number ignore-mouse-wheel name=capAmount onkeyup=\"NumToWord(this.value,\'capAmntInWords\')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=DreamSip.formData.topupDetails.capAmount ng-change=DreamSip.capAmountChanged() ng-disabled=DreamSip.formData.topupDetails.capMonthYear autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label class=topUpLabelCss>Cap Amount</label><span class=error-input ng-if=\"DreamSip.formData.topupDetails.capAmount <1\">{{DreamSip.validations.INVALID_AMOUNT+\'.\'}}</span> <span class=error-input ng-if=\"DreamSip.isminCapAmount && dreamSipForm.capAmount.$dirty\">Minimum CAP amount should &#8377;{{DreamSip.minCapAmount+\'.\'}}</span></div><div ng-if=DreamSip.formData.topupDetails.capAmount class=amount-in-words><div id=capAmntInWords style=\"padding-bottom: 15px\"></div><span>(In Words)&nbsp;</span></div></div><div class=\"col-md-1 form-grid text-center\">OR</div><div class=row><div class=col-md-3><div class=selectfield style=\"margin-top: 7px\" ng-class=\"{\'anything-disabled\': DreamSip.formData.topupDetails.capAmount }\"><select class=\"browser-default custom-select\" name=capDates ng-disabled=DreamSip.formData.topupDetails.capAmount ng-options=\"_dates for _dates in DreamSip.capDates\" ng-change=DreamSip.valiadtTopUpdata() ng-model=DreamSip.formData.topupDetails.capMonthYear ng-required=\"(!DreamSip.formData.topupDetails.capAmount && DreamSip.sipTopupSelected)\"><option value=\"\">Cap Month Year - MM/YYYY</option></select></div></div></div></div></div></div></div><div class=\"row form-footer form-content\" style=\"margin-top: 0px;padding: 10px 0px 0px 0px\"><span class=\"pull-right buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=DreamSip.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-disabled=\"\n                !DreamSip.formData.folioNumber ||\n                !DreamSip.formData.euinCode ||\n                !DreamSip.formData.option ||\n                DreamSip.validateSchemeRequrementData ||\n                !DreamSip.formData.sipPeriod ||\n                !DreamSip.formData.startDate ||\n                !DreamSip.formData.endDate ||\n                DreamSip.inValidInstallmentAmount ||\n                !DreamSip.formData.swapAmount ||\n                DreamSip.isMinSipAmount ||\n                DreamSip.isSwapMax ||\n                DreamSip.isMinSipAmount ||\n                !DreamSip.isMultiples ||\n                DreamSip.isSwapMin ||\n                DreamSip.isSwapMax ||\n                !DreamSip.isSwapMultiples ||\n                !DreamSip.formData.sipPaymentOption ||\n                DreamSip.bankProcced ||\n                !DreamSip.validPaymentOption ||\n                DreamSip.validTopUpData ||\n                (DreamSip.formData.sipPaymentOption === \'HEM\' && (DreamSip.amountLess || DreamSip.amountMore || DreamSip.isLessThanSipAmount || DreamSip.sipDateLessEmandate || !DreamSip.formData.emandateAmount)) || DreamSip.showRetirementSchemeError || dreamSipForm.subBrokerARNDesk.$invalid || dreamSipForm.subBrokerARN.$invalid || (DreamSip.formData.sipPaymentOption === \'UPI\' && !DreamSip.formData.upiBankInfo)\" ng-click=DreamSip.finishPurchase()>Proceed to Transact</button></span></div></div></div></form></div></section><style>input[readonly] ~ label {\n    top: -19px;\n    left: -160%;\n}\n.input-normal .ng-dirty.ng-not-empty ~ .topUpLabelCss, .input-normal .ng-not-empty ~ .topUpLabelCss{\n    top: -50px;\n    font-size: 14px;\n    color: #9f9f9f;\n  }\n  .netbanking_notification {\n    position: absolute;\n    font-size: 12px;\n    color: #d92018;\n    left: 15px;\n    top: 70px;\n  }\n\n  .initiate-transition span.amount-error {\n    top: 102%;\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n    color: #d92018;\n  }\n\n  .pt-25 {\n    padding-top: 15px;\n  }\n\n  .no-margin {\n    margin: 0px !important;\n  }\n\n  .input-normal.icon-input i {\n    display: none;\n    left: 5px;\n    position: absolute;\n    top: 12px;\n  }\n\n  .input-group-addon-date {\n    background: none !important;\n    border-top: 0px;\n    border-right: 0px;\n    border-left: 0px;\n    border-bottom: 1px solid #555;\n  }\n\n  .radio-block label {\n    top: -15px;\n  }\n\n  .align-row {\n    display: flex;\n    align-items: center;\n  }\n\n  .main-subheading {\n    font-size: 15px;\n    font-weight: bold;\n  }\n\n  .input-normal .rupee-grey-icon {\n    float: right;\n    bottom: 20px;\n  }\n\n  .select-noborder {\n    border-top: 0px;\n    border-left: 0px;\n    border-right: 0px;\n  }\n\n  .paymentOption{\n    display: flex;\n    flex-direction: row;\n  }\n  .marR-25{\n    margin: 0px 0px 0px 25px;\n  }\n  @media (max-width: 767px) {\n    /* input[readonly] ~ label {\n      top: -19px;\n      left: -160%;\n    } */\n    .align-row {\n      display: block;\n    }\n\n    .sip-purchase .install-freq.sip-fi {\n      display: block;\n    }\n\n    .sip-purchase .sipPurchase-form .normal-wrap {\n      padding: 30px 25px;\n    }\n\n    .paymentOption{\n      display: flex;\n      flex-direction: column;\n    }\n    .marR-25{\n      margin: 0px 0px 0px 0px;\n    }\n  }\n  .initiate-transition {\n      margin: -30px 0px 0px 0px;\n    }\n    .topBarMargin{\n      margin: 0px 60px 0px 0px;\n    }\n    .bottom-footer{\n      width: 100%;\n    }\n  @media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .main-section {\n      padding: 143px 10px 50px 91px;\n    }\n    .topBarMargin{\n      margin: 0px 60px 0px 10px;\n    }\n  }</style>");
$templateCache.put("app/transactions/initiate/dtp/dtp.html","<section class=\"initiate-transition dtp\" ng-init=InitiateTransactionDtp.init()><div class=content-header><h5>Transaction for {{InitiateTransactionDtp.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Transfer IDCW Plan</li></ul></div><div class=content><form autocomplete=off name=InitiateTransactionDtp.dtpForm ng-keypress=InitiateTransactionDtp.handleEnter($event) novalidate><div class=top-wrap ng-if=!InitiateTransactionDtp.oversea_arn><div class=row><div class=col-md-4><label>Sub Broker ARN</label><div class=form-group><div><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionDtp.formData.subBrokerARN ng-change=InitiateTransactionDtp.changeSubBrokerArn() ng-blur=InitiateTransactionDtp.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><p ng-if=InitiateTransactionDtp.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{InitiateTransactionDtp.subBrokerName}}</p><span class=error-input ng-if=\"InitiateTransactionDtp.dtpForm.subBrokerARN.$dirty && InitiateTransactionDtp.dtpForm.subBrokerARN.$invalid && InitiateTransactionDtp.dtpForm.subBrokerARN.$error.pattern\">{{InitiateTransactionDtp.validateData.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionDtp.subBrokerCodeError != \'\'\" ng-bind=InitiateTransactionDtp.subBrokerCodeError></span></div></div></div></div><div class=col-md-1></div><div class=col-md-4><label>Sub Broker Code<span class=req ng-if=InitiateTransactionDtp.formData.subBrokerARN></span></label><div class=form-group><div><div class=input-normal ng-class={error:InitiateTransactionDtp.dtpForm.subBrokerCode.$dirty&&InitiateTransactionDtp.dtpForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionDtp.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionDtp.formData.subBrokerARN || InitiateTransactionDtp.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionDtp.dtpForm.subBrokerCode.$dirty&&InitiateTransactionDtp.dtpForm.subBrokerCode.$error.required ng-bind=InitiateTransactionDtp.validateData.SUB_BROKER_REQUIRED></span></div></div></div></div></div><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionDtp.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionDtp.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Scheme for Transfer IDCW Plan</label><div class=form-group><div class=selectfield ng-class=\"{error:(InitiateTransactionDtp.hasFolioEmailId == false)||(InitiateTransactionDtp.dtpForm.folioNumber.$dirty && InitiateTransactionDtp.dtpForm.folioNumber.$invalid)}\"><label>Select Folio</label><select class=\"browser-default custom-select\" ng-change=InitiateTransactionDtp.changeFolio() ng-model=InitiateTransactionDtp.formData.folioNumber name=folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in InitiateTransactionDtp.folioList\" required><option value=\"\">Select Folio</option></select><span class=req>*</span> <span ng-show=\"InitiateTransactionDtp.dtpForm.folioNumber.$dirty && InitiateTransactionDtp.dtpForm.folioNumber.$invalid\"><span class=error-input ng-show=InitiateTransactionDtp.dtpForm.folioNumber.$error.required ng-bind=InitiateTransactionDtp.TRANSACTIONS_CONST.ToastrMessage.VALIDATE_DATA.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateTransactionDtp.hasFolioEmailId == false\" ng-bind=InitiateTransactionDtp.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionDtp.dtpForm.outScheme.$dirty && InitiateTransactionDtp.dtpForm.outScheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=InitiateTransactionDtp.outSchemeChanged() ng-model=InitiateTransactionDtp.formData.outSchemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in InitiateTransactionDtp.outSchemeList\" required><option value=\"\" selected>Select a Scheme</option></select><span class=req>*</span> <span ng-show=\"InitiateTransactionDtp.dtpForm.outScheme.$dirty && InitiateTransactionDtp.dtpForm.outScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionDtp.dtpForm.outScheme.$error.required ng-bind=InitiateTransactionDtp.TRANSACTIONS_CONST.ToastrMessage.VALIDATE_DATA.SCHEME_REQUIRED></span></span></div></div></div><div class=\"col-md-4 form-grid\"><label>Scheme to Transfer In</label><div class=\"form-group transfer-scheme\"><div class=\"input-select selectfield input-normal\" ng-class=\"{error:InitiateTransactionDtp.dtpForm.inScheme.$dirty && InitiateTransactionDtp.dtpForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-change=InitiateTransactionDtp.filterInSchemeList() ng-model=InitiateTransactionDtp.formData.inSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span class=req>*</span> <span ng-show=\"InitiateTransactionDtp.dtpForm.inScheme.$dirty && InitiateTransactionDtp.dtpForm.inScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionDtp.dtpForm.inScheme.$error.required ng-bind=InitiateTransactionDtp.TRANSACTIONS_CONST.ToastrMessage.VALIDATE_DATA.SCHEME_REQUIRED></span> </span><span class=error-input ng-show=InitiateTransactionDtp.tForm.inScheme.$error.required ng-bind=InitiateTransactionDtp.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=InitiateTransactionDtp.inSchemeList display-key=scheme hdfc-click=InitiateTransactionDtp.inSchemeChanged(data) model=InitiateTransactionDtp.formData.inSchemeCode for=inScheme></drop-down><span><span class=error-input></span> </span><!--<i class=\"input-dd-normal-icon\"></i>--><!--<i class=\"input-dd-active-icon\"></i>--></div></div><div class=form-group>or <span class=scheme-list ng-click=InitiateTransactionDtp.getSchemesList()><i class=list-icon></i><a>Select from list</a></span></div><div class=form-group ng-if=\"InitiateTransactionDtp.validationsData.investmentOption==InitiateTransactionDtp.transactionConstants.DIVIDEND\"><label><strong>Select Income Distribution cum Capital Withdrawal (IDCW) Option</strong></label><div class=radio-flex-div ng-class=\"{error:InitiateTransactionDtp.dtpForm.dividentOption.$dirty && InitiateTransactionDtp.dtpForm.dividentOption.$invalid}\"><span class=\"radio-block radio-flex\" ng-repeat=\"dtpDevidendOption in InitiateTransactionDtp.dtpDevidendOptions\" ng-class=\"{\'anything-disabled\': (dtpDevidendOption==InitiateTransactionDtp.transactionConstants.REINVEST && InitiateTransactionDtp.validationsData.dividendReinvestmentApplicable === false)\n                    ||(dtpDevidendOption==InitiateTransactionDtp.transactionConstants.PAYOUT&& InitiateTransactionDtp.validationsData.dividendPayoutApplicable === false)}\"><span class=\"radio radio-flex-span\"><input type=radio id=dividentOptionReinvest{{$index}} ng-value=dtpDevidendOption name=dividentOption ng-model=InitiateTransactionDtp.formData.dividentOption ng-disabled=\"(dtpDevidendOption==InitiateTransactionDtp.transactionConstants.REINVEST&& InitiateTransactionSwitch.validationsData.dividendReinvestmentApplicable === false)\n                           ||(dtpDevidendOption==InitiateTransactionDtp.transactionConstants.PAYOUT&& InitiateTransactionSwitch.validationsData.dividendPayoutApplicable === false)\"> <span class=check></span></span><label class=radio-flex-label for=dividentOptionReinvest{{$index}}>{{dtpDevidendOption==InitiateTransactionDtp.transactionConstants.REINVEST?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</label></span></div></div></div><div class=\"col-md-12 tc-block\" style=padding-left:34px ng-show=InitiateTransactionDtp.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionDtp.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionDtp.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=col-md-12><ng-bind-html dynamic=InitiateTransactionDtp.dynamicNote.Note_Review_TIP.content></ng-bind-html></div><div class=\"col-md-12 form-footer form-content\"><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionDtp.formData.inSchemeName\"\n                  ng-click=\"InitiateTransactionDtp.saveForm()\">Save</button>--> <button ng-click=InitiateTransactionDtp.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-click=InitiateTransactionDtp.submitFirst() class=\"btn btn-primary-action\" ng-disabled=\"InitiateTransactionDtp.dtpForm.$invalid || !InitiateTransactionDtp.isCheckedTandC || InitiateTransactionDtp.showRetirementSchemeError\">Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/flex/flex.html","<section class=\"initiate-transition flex-index\" ng-init=InitiateTransactionSwitch.init()><div class=content-header><h5>Transaction for {{InitiateTransactionSwitch.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Flex Index</li></ul></div><div class=content><form autocomplete=off name=InitiateTransactionSwitch.switchForm ng-keypress=InitiateTransactionSwitch.handleEnter($event) novalidate><div class=top-wrap><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionSwitch.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionSwitch.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=input-normal><input type=text name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-keydown=\"$event.which === 13 && Transaction.searchDistributor()\" ng-required=Transaction.isRequired&&Transaction.formData.isThroughDistributor> <span class=highlight></span> <span class=bar></span><label>ARN</label><span class=error-input ng-show=fForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span></div></div><div class=col-md-4><div class=input-normal><input type=text name=euin id=euin ng-model=Transaction.formData.euin autocomplete=off> <span class=highlight></span> <span class=bar></span><label>EUIN (Optional)</label></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Source Scheme</label><div class=selectfield ng-class={error:Transaction.tForm.folio.$invalid}><select class=\"browser-default custom-select\" name=folio ng-change=Transaction.folioChanged() ng-model=Transaction.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in Transaction.folioList\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" ng-required=Transaction.isRequired><option value=\"\">Select Folio</option></select><label ng-if=Transaction.formData.folioNumber>Select Folio</label><span class=error-input ng-show=Transaction.tForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=selectfield ng-class={error:Transaction.tForm.outScheme.$invalid}><label ng-if=Transaction.formData.outSchemeCode>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=Transaction.outSchemeChanged() ng-model=Transaction.formData.outSchemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Transaction.outSchemeList\" ng-required=Transaction.isRequired><option value=\"\" selected>Select a Scheme</option></select><span class=error-input ng-show=Transaction.tForm.outScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span></div><div class=divident-option><p>Divident Option : <span class=text-black><strong>Growth</strong></span></p></div><!--<div class=\"value-snippet\" ng-if=\"Transaction.unitsDetails\">--><!--<div>--><!--<p class=\"text-uppercase\">Total Market Value</p>--><!--<span class=\"left-val\"> {{Transaction.unitsDetails.totalCurrentValueUnits|unit}} Units </span>--><!--<span><i class=\"rupee-blue-icon\"></i> {{Transaction.unitsDetails.totalCurrentValueAmount|unit}}</span>--><!--</div>--><!--<div class=\"red-snip\">--><!--<p class=\"text-uppercase\">Locked Value</p>--><!--<span class=\"left-val\"> {{Transaction.unitsDetails.lockedValueUnits|unit}} Units </span>--><!--<span><i class=\"rupee-red-icon\"></i> {{Transaction.unitsDetails.lockedValueAmount|unit}}</span>--><!--</div>--><!--<div class=\"green-snip\">--><!--<p class=\"text-uppercase\">Free Value</p>--><!--<span class=\"left-val\"> {{Transaction.unitsDetails.freeValueUnits|unit}} Units </span>--><!--<span><i class=\"rupee-green-icon\"></i> {{Transaction.unitsDetails.freeValueAmount|unit}}</span>--><!--</div>--><!--</div>--></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-md-4 form-grid\"><label>Select Target Scheme</label><div class=\"input-select input-normal\" ng-class={error:Transaction.tForm.inScheme.$invalid}><input type=text name=inScheme id=inScheme ng-change=Transaction.filterInSchemeList() ng-model=Transaction.formData.inSchemeName autocomplete=off ng-required=Transaction.isRequired capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span class=error-input ng-show=Transaction.tForm.inScheme.$error.required ng-bind=Transaction.VALIDATE_DATA.SCHEME_REQUIRED></span><drop-down list-data=Transaction.inSchemeList display-key=scheme hdfc-click=Transaction.inSchemeChanged(data) model=Transaction.formData.inSchemeCode for=inScheme></drop-down><div class=text-support>(Only Growth Schemes)</div></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=Transaction.schemeListModal()>Select from list</span></p></div><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\" ng-if=\"Transaction.validations.investmentOption===Transaction.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><label>Select IDCW option</label><div class=radio-block ng-repeat=\"_option in Transaction.devidendOptions\"><span class=radio><input type=radio id=dividendOption{{$index}} ng-value=_option ng-disabled=\"_option==Transaction.TRANSACTIONS_CONST.DIVIDEND_OPTIONS.REINVEST&& Transaction.validations.endingType === Transaction.TRANSACTIONS_CONST.SCHEME_ENDING_TYPE.CLOSED\" name=dividendOption ng-model=Transaction.formData.dividendOption> <span class=check></span> </span><span class=radio-label>{{Transaction.TRANSACTIONS_CONST.DESCRIPTIONS[_option]}}</span></div></div><div class=\"input-normal icon-input\" ng-class=\"{error:Transaction.tForm.amount.$invalid,\'has-data\':Transaction.formData.amount}\"><input type=number ignore-mouse-wheel min={{Transaction.validations.minAmount}} max={{Transaction.unitsDetails.freeValueAmount}} name=amount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-change=Transaction.checkValidations() ng-model=Transaction.formData.amount class=pd20 ng-required=Transaction.isRequired> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=Transaction.tForm.amount.$error.required ng-bind=Transaction.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span class=error-input ng-show=Transaction.tForm.amount.$error.min>{{ Transaction.VALIDATE_DATA.MINIMUM_AMOUNT }} &#8377; {{Transaction.validations.minAmount}}</span> <span class=error-input ng-show=Transaction.tForm.amount.$error.max>{{ Transaction.VALIDATE_DATA.MAX_AMOUNT }}</span> <span class=error-input ng-show=Transaction.tForm.amount.$dirty&&!vm.isMin&&!Transaction.isMultiples>Please Provide In Multiples Of &#8377; {{Transaction.validations.amountMultiples}}</span><div class=text-support>(&#8377; 20000 Min Amount & in multiples of 1,000 thereafter)</div></div><div ng-if=\"Transaction.formData.amountType==\'amount\'\" class=form-group><label id=divDisplayWords>(In Words)</label></div></div><div ng-class=\"{\'anything-disabled\': !Transaction.formData.folioNumber }\" class=\"col-md-4 form-grid\"><label>Select Investment Mode</label><div class=form-group ng-class=\"{\'radio-disabled\':(Transaction.validations.isEnabled==\'N\')}\"><div class=radio-block><span class=radio><input type=radio id=amount name=amountType value=Fixed ng-model=Transaction.specificProperties.investmentMode ng-change=\"Transaction.helper.investModeChanged(\'Fixed\')\"> <span class=check></span> </span><span class=radio-label>Fixed</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=Flexible ng-model=Transaction.specificProperties.investmentMode ng-change=\"Transaction.helper.investModeChanged(\'Flexible\')\"> <span class=check></span> </span><span class=radio-label>Flexible</span></div></div><div class=flex-table style=\"display: none\"><table class=borderless><tr><td>{{Transaction.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(I)</i></div></td></tr><tr><td>25%</td><td><div class=\"input-normal icon-input\"><input type=text> <i>(II)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(III)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(IV)</i></div></td></tr><tr><td>100%</td></tr></table></div><div class=flex-table><table class=borderless><tr><td>{{Transaction.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td><div class=\"input-normal left-input\"><input ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" type=text placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment1\')\" ng-model=Transaction.specificProperties.investmentModeData.installment1> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage1\')\" ng-model=Transaction.specificProperties.investmentModeData.stage1> <i>(I)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment2\')\" ng-model=Transaction.specificProperties.investmentModeData.installment2> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=\"input-normal icon-input\"><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage2\')\" ng-model=Transaction.specificProperties.investmentModeData.stage2> <i>(II)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment3\')\" ng-model=Transaction.specificProperties.investmentModeData.installment3> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage3\')\" ng-model=Transaction.specificProperties.investmentModeData.stage3> <i>(III)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"Transaction.helper.installmentValueChanged(\'installment4\')\" ng-model=Transaction.specificProperties.investmentModeData.installment4> <span ng-if=\"Transaction.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"Transaction.helper.stageValueChanged(\'stage4\')\" ng-model=Transaction.specificProperties.investmentModeData.stage4> <i>(IV)</i></div></td></tr><tr ng-if=\"Transaction.specificProperties.investmentMode!=\'Fixed\'\"><td class=text-support>(Percentages should be equal to 100)</td></tr></table></div><p class=error-input style=\"margin:10px 0px\" ng-show=\"!Transaction.specificProperties.validations.stage1 ||\n!Transaction.specificProperties.validations.stage2 || !Transaction.specificProperties.validations.stage3\n|| !Transaction.specificProperties.validations.stage4\">Stage amount should be multiples of hundred</p><p class=error-input style=\"margin:10px 0px\" ng-show=\"!Transaction.specificProperties.validations.installment1 ||\n!Transaction.specificProperties.validations.installment2 || !Transaction.specificProperties.validations.installment3\n|| !Transaction.specificProperties.validations.installment4\">Installment % should be of two digit</p><p class=error-input style=\"margin:10px 0px 20px 0px\" ng-show=\"Transaction.specificProperties.investmentMode!=\'Fixed\' && !Transaction.specificProperties.validations.installmentsSumHundred\">All Installments sum should be 100</p><div class=input-normal><div class=estimate-block ng-if=\"Transaction.tForm.$valid&&((Transaction.formData.units&&Transaction.validations.minUnits<=Transaction.formData.units)\n                    ||(Transaction.formData.amount&&Transaction.validations.minAmount<=Transaction.formData.amount))\"><a href=javascript:void(0) ng-click=Transaction.downloadReport(Transaction.formData.folioNumber,Transaction.formData.outSchemeCode)><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-md-12 form-footer form-content flex-style\"><button type=button ng-click=InitiateTransactionSwitch.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionSwitch.hasFolioEmailId||InitiateTransactionSwitch.isSubmitted||!InitiateTransactionSwitch.switchForm.$valid\n            ||((InitiateTransactionSwitch.formData.all_units&&InitiateTransactionSwitch.validations.minUnits>InitiateTransactionSwitch.formData.all_units&&InitiateTransactionSwitch.validations.maxUnits<InitiateTransactionSwitch.formData.all_units)\n            ||(InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validations.minUnits>InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validations.maxUnits<InitiateTransactionSwitch.formData.units)\n            ||(InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validations.minAmount>InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validations.maxAmount<InitiateTransactionSwitch.formData.switchAmount)) || !InitiateTransactionSwitch.unitsDetails.totalCurrentValueUnits\" class=\"btn btn-primary-action\" ng-click=InitiateTransactionSwitch.submitForm()>Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/flexindex/flexindex.html","<section class=\"initiate-transition flex-index\" ng-init=FlexIndex.init()><div class=content-header><h5>Transaction for {{FlexIndex.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Flex Index</li></ul></div><div class=content><form autocomplete=off name=FlexIndex.tForm ng-keypress=FlexIndex.handleEnter($event) novalidate><div class=top-wrap ng-if=!FlexIndex.oversea_arn><div class=row><div class=col-md-4><label>Sub Broker ARN</label><div class=form-group><div><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=FlexIndex.formData.subBrokerARN ng-change=FlexIndex.changeSubBrokerArn() ng-blur=FlexIndex.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><p ng-if=FlexIndex.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{FlexIndex.subBrokerName}}</p><span class=error-input ng-if=\"FlexIndex.tForm.subBrokerARN.$dirty && FlexIndex.tForm.subBrokerARN.$invalid && FlexIndex.tForm.subBrokerARN.$error.pattern\">{{FlexIndex.validateData.BROKER_VALID}}</span> <span class=error-input ng-show=\"FlexIndex.subBrokerCodeError != \'\' && !FlexIndex.tForm.subBrokerARN.$invalid && FlexIndex.formData.subBrokerARN\" ng-bind=FlexIndex.subBrokerCodeError></span></div></div></div></div><div class=col-md-1></div><div class=col-md-4><label>Sub Broker Code<span class=req ng-if=FlexIndex.formData.subBrokerARN></span></label><div class=form-group><div><div class=input-normal ng-class={error:FlexIndex.tForm.subBrokerCode.$dirty&&FlexIndex.tForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=FlexIndex.formData.subBrokerCode autocomplete=off ng-disabled=\"!FlexIndex.formData.subBrokerARN || FlexIndex.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=FlexIndex.tForm.subBrokerCode.$dirty&&FlexIndex.tForm.subBrokerCode.$error.required ng-bind=FlexIndex.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div></div></div><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=FlexIndex.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in FlexIndex.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div></div><div class=\"normal-wrap form-box\" ng-disabled=FlexIndex.isFormDisable><div class=\"col-md-4 form-grid\"><label>Select Source Scheme</label><div class=selectfield ng-class=\"{error:FlexIndex.tForm.folio.$dirty && FlexIndex.tForm.folio.$invalid}\"><select class=\"browser-default custom-select\" name=folio ng-change=FlexIndex.changeFolio() ng-model=FlexIndex.formData.folioNumber ng-options=\"folio.folioNo as folio.folioNo disable when (!folio.activeFlag) for folio in FlexIndex.folioListData\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=FlexIndex.formData.folioNumber>Select Folio</label><span class=error-input ng-show=FlexIndex.tForm.folio.$error.required ng-bind=FlexIndex.VALIDATE_DATA.FOLIO_REQUIRED></span></div><div ng-class=\"{\'anything-disabled\': !FlexIndex.formData.folioNumber }\" class=selectfield ng-class=\"{error:FlexIndex.tForm.scheme.$dirty && FlexIndex.tForm.scheme.$invalid}\"><label ng-if=FlexIndex.formData.schemeCode>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=FlexIndex.fetchUnitDetails() ng-model=FlexIndex.formData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in FlexIndex.schemeList\" required><option value=\"\" selected>Select a Scheme</option></select><span class=error-input ng-show=FlexIndex.tForm.scheme.$error.required ng-bind=FlexIndex.VALIDATE_DATA.SCHEME_REQUIRED></span></div><div class=value-snippet ng-if=FlexIndex.unitsDetails><div><p class=text-uppercase>Total Market Value</p><span class=left-val easyassist-key=mask-element>{{FlexIndex.unitsDetails.totalCurrentValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{FlexIndex.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{FlexIndex.unitsDetails.lockedValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{FlexIndex.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value</p><span class=left-val easyassist-key=mask-element>{{FlexIndex.unitsDetails.freeValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{FlexIndex.unitsDetails.freeValueAmount|unit}}</span></div></div></div><div ng-class=\"{\'anything-disabled\': !FlexIndex.formData.folioNumber }\" class=\"col-md-4 form-grid\"><label>Select Target Scheme</label><div class=\"input-select input-normal\" ng-class=\"{error:FlexIndex.tForm.inScheme.$dirty && FlexIndex.tForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-model=FlexIndex.selectedInScheme ng-change=FlexIndex.filterInSchemeList() ng-blur=FlexIndex.checkValidScheme() autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span class=error-input ng-show=\"FlexIndex.tForm.inScheme.$dirty && FlexIndex.tForm.inScheme.$error.required\" ng-bind=FlexIndex.validateData.SCHEME_REQUIRED></span><drop-down list-data=FlexIndex.filteredinSchemeList display-key=scheme hdfc-click=FlexIndex.inSchemeChanged(data) model=FlexIndex.formData.inSchemeCode for=inScheme></drop-down></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=FlexIndex.schemeListModal()>Select from list</span></p></div><div class=\"input-normal icon-input enter-amount\" ng-disabled=!FlexIndex.formData.schemeCode ng-class=\"{error:FlexIndex.tForm.amount.$dirty && FlexIndex.tForm.amount.$invalid,\'has-data\':FlexIndex.formData.amount}\"><input type=number ignore-mouse-wheel min=\"{{FlexIndex.validations.minAmount }}\" name=amount ng-disabled=!FlexIndex.formData.schemeCode ng-change=FlexIndex.checkValidations() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-model=FlexIndex.formData.amount class=pd20 ng-required=FlexIndex.isRequired> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span class=error-input ng-show=FlexIndex.tForm.amount.$error.required ng-bind=FlexIndex.VALIDATE_DATA.AMOUNT_REQUIRED></span> <span class=error-input ng-show=FlexIndex.tForm.amount.$error.min>{{ FlexIndex.validateData.MINIMUM_AMOUNT }} greater than &#8377; {{FlexIndex.validations.minAmount}}</span><!--<span class=\"error-input\" ng-show=\"FlexIndex.tForm.amount.$error.max\">{{ FlexIndex.VALIDATE_DATA.MAX_AMOUNT }}</span>--> <span class=\"error-input error-message\" ng-show=\"FlexIndex.tForm.amount.$dirty && FlexIndex.isMin && !FlexIndex.isMultiples\">Please Provide In Multiples Of &#8377; {{FlexIndex.validations.multiples}}</span><div class=text-support>(&#8377; {{FlexIndex.validations.minAmount}} Min Amount & in multiples of {{FlexIndex.validations.multiples}} thereafter)</div></div><div class=form-group><label id=divDisplayWords>(In Words)</label></div></div><div ng-class=\"{\'anything-disabled\': !FlexIndex.formData.folioNumber }\" class=\"col-md-4 form-grid\"><label>Select Investment Mode</label><div class=form-group ng-class=\"{\'radio-disabled\':(FlexIndex.validations.isEnabled==\'N\')}\"><div class=radio-block><span class=radio><input type=radio id=amount name=amountType value=Fixed ng-model=FlexIndex.specificProperties.investmentMode ng-change=\"FlexIndex.investModeChanged(\'Fixed\')\"> <span class=check></span> </span><span class=radio-label>Fixed</span></div><div class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=Flexible ng-model=FlexIndex.specificProperties.investmentMode ng-change=\"FlexIndex.investModeChanged(\'Flexible\')\"> <span class=check></span> </span><span class=radio-label>Flexible</span></div></div><div class=flex-table style=\"display: none\"><table class=borderless><tr><td>{{FlexIndex.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(I)</i></div></td></tr><tr><td>25%</td><td><div class=\"input-normal icon-input\"><input type=text> <i>(II)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(III)</i></div></td></tr><tr><td>25%</td><td><div class=input-normal><input type=text> <i>(IV)</i></div></td></tr><tr><td>100%</td></tr></table></div><div class=flex-table><table class=borderless><tr><td>{{FlexIndex.specificProperties.investmentMode}}<br>Installments</td><td>Stages of Switch Execution <span class=grey-text>S&P BSE SENSEX Levels</span></td></tr><tr><td><div class=\"input-normal left-input\"><input ng-if=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\'\" type=text placeholder=\"Minimum 10%\" ng-change=\"FlexIndex.installmentValueChanged(\'installment1\')\" ng-model=FlexIndex.specificProperties.investmentModeData.installment1> <span ng-if=\"FlexIndex.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"FlexIndex.stageValueChanged(\'stage1\')\" ng-model=FlexIndex.specificProperties.investmentModeData.stage1> <i>(I)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"FlexIndex.installmentValueChanged(\'installment2\')\" ng-model=FlexIndex.specificProperties.investmentModeData.installment2> <span ng-if=\"FlexIndex.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=\"input-normal icon-input\"><input type=text ng-change=\"FlexIndex.stageValueChanged(\'stage2\')\" ng-model=FlexIndex.specificProperties.investmentModeData.stage2> <i>(II)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"FlexIndex.installmentValueChanged(\'installment3\')\" ng-model=FlexIndex.specificProperties.investmentModeData.installment3> <span ng-if=\"FlexIndex.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"FlexIndex.stageValueChanged(\'stage3\')\" ng-model=FlexIndex.specificProperties.investmentModeData.stage3> <i>(III)</i></div></td></tr><tr><td><div class=\"input-normal left-input\"><input type=text ng-if=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\'\" placeholder=\"Minimum 10%\" ng-change=\"FlexIndex.installmentValueChanged(\'installment4\')\" ng-model=FlexIndex.specificProperties.investmentModeData.installment4> <span ng-if=\"FlexIndex.specificProperties.investmentMode===\'Fixed\'\">25%</span></div></td><td><div class=input-normal><input type=text ng-change=\"FlexIndex.stageValueChanged(\'stage4\')\" ng-model=FlexIndex.specificProperties.investmentModeData.stage4> <i>(IV)</i></div></td></tr><tr ng-if=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\'\"><td class=text-support>(Percentages should be equal to 100)</td></tr></table></div><p class=\"error-input error-message customize-error\" style=\"margin:10px 0px\" ng-show=\"!FlexIndex.specificProperties.validations.stage1 ||\n                !FlexIndex.specificProperties.validations.stage2 || !FlexIndex.specificProperties.validations.stage3\n                || !FlexIndex.specificProperties.validations.stage4\">Stage amount should be multiples of hundred</p><p class=\"error-input error-message customize-error\" style=\"margin:10px 0px\" ng-show=\"!FlexIndex.specificProperties.validations.installment1 ||\n                !FlexIndex.specificProperties.validations.installment2 || !FlexIndex.specificProperties.validations.installment3\n                || !FlexIndex.specificProperties.validations.installment4\">Installment % should be of two digit</p><p class=\"error-input error-message customize-error\" style=\"margin:10px 0px 20px 0px\" ng-show=\"FlexIndex.specificProperties.investmentMode!=\'Fixed\' && !FlexIndex.specificProperties.validations.installmentsSumHundred\">All Installments sum should be 100</p><div class=input-normal><div class=estimate-block ng-if=\"FlexIndex.tForm.$valid&&((FlexIndex.formData.units&&FlexIndex.validations.minUnits<=FlexIndex.formData.units)\n                    ||(FlexIndex.formData.amount&&FlexIndex.validations.minAmount<=FlexIndex.formData.amount))\"><a href=javascript:void(0); ng-click=FlexIndex.downloadReport(FlexIndex.formData.folioNumber,FlexIndex.formData.schemeCode)><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-md-12 tc-block\" ng-show=FlexIndex.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=FlexIndex.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=FlexIndex.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content flex-style\"><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!FlexIndex.selectedInScheme\"\n                  ng-click=\"FlexIndex.saveForm()\">Save</button>--> <button type=button ng-click=FlexIndex.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!FlexIndex.isCheckedTandC ||!FlexIndex.tForm.$valid\n                  || (FlexIndex.validations.minAmount>FlexIndex.formData.units)\n                  || !FlexIndex.isMultiples || !FlexIndex.specificProperties.validations.installment1 ||\n                     !FlexIndex.specificProperties.validations.installment2 || !FlexIndex.specificProperties.validations.installment3\n                  || !FlexIndex.specificProperties.validations.installment4 ||!FlexIndex.specificProperties.validations.installmentsSumHundred\n                  || !FlexIndex.specificProperties.validations.stage1 ||\n                     !FlexIndex.specificProperties.validations.stage2 || !FlexIndex.specificProperties.validations.stage3\n                  || !FlexIndex.specificProperties.validations.stage4 || FlexIndex.showRetirementSchemeError\" class=\"btn btn-primary-action\" ng-click=FlexIndex.submitForm()>Initiate Transaction</button><!--< button--><!--ng-disabled=\"!FlexIndex.hasFolioEmailId||FlexIndex.isSubmitted||!FlexIndex.tForm.$valid--><!--||((FlexIndex.formData.all_units&&FlexIndex.validations.minUnits>FlexIndex.formData.all_units&&FlexIndex.validations.maxUnits<FlexIndex.formData.all_units)--><!--||(FlexIndex.formData.units&&FlexIndex.validations.minUnits>FlexIndex.formData.units&&FlexIndex.validations.maxUnits<FlexIndex.formData.units)--><!--||(FlexIndex.formData.switchAmount&&FlexIndex.validations.minAmount>FlexIndex.formData.switchAmount&&FlexIndex.validations.maxAmount<FlexIndex.formData.switchAmount)) || !FlexIndex.unitsDetails.totalCurrentValueUnits\"--><!--class=\"btn btn-primary-action\" ng-click=\"FlexIndex.submitForm()\">Initiate Transaction--><!--</button>--></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/flexsip/flexsip.html","<section class=\"initiate-transition sip-purchase flex-sip-main-screen\" ng-init=InitiateTransactionFlexSip.init()><div class=content-header><h5><span>FLEX:</span> SYSTEMATIC INVESTMENT PLAN REGISTRATION <i class=\"tooltip-info-icon base-tooltip\" tooltip=\"\" data-toggle=tooltip data-placement=\"\" data-original-title=\"Flex SIP is a facility whereby investors can invest at predetermined intervals in the\n                 eligible schemes of the Fund, higher amount(s) determined by a formula linked to\n                 value of investments, to take advantage of market movements.\"></i></h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transaction</li><li><span class=breadcrumb-icon></span></li><li>Flex SIP</li></ul></div><div class=content><form autocomplete=off class=sipPurchase-form name=flexSipForm novalidate><div class=\"top-wrap proceed-options\"><div class=\"row flex-style\"><div class=\"col-md-4 col-xs-12 col-sm-6 form-grid\"><div class=form-group><label>Existing Folio No:</label><div class=selectfield ng-class=\"{error:(InitiateTransactionFlexSip.hasFolioEmailId == false)||(flexSipForm.folio.$dirty && flexSipForm.folio.$invalid)}\"><label>Select</label><select class=\"browser-default custom-select select-folio-list\" name=folio ng-model=InitiateTransactionFlexSip.formData.folioNumber ng-change=InitiateTransactionFlexSip.changeFolio(true) ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in InitiateTransactionFlexSip.folioList\" required><option value=\"\" selected>Select Folio</option></select><span ng-show=\"flexSipForm.folio.$dirty && flexSipForm.folio.$invalid\"><span class=error-input ng-show=flexSipForm.folio.$error.required ng-bind=InitiateTransactionFlexSip.validations.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateTransactionFlexSip.hasFolioEmailId == false\" ng-bind=InitiateTransactionFlexSip.validations.FOLIO_EMAIL></span></div></div></div><div class=\"col-md-1 col-xs-12 col-sm-1 form-grid\" ng-if=\"InitiateTransactionFlexSip.loginType == \'D\' && !InitiateTransactionFlexSip.corporateFlag\"><p class=orSipOption>OR</p></div><div class=\"col-md-4 col-xs-12 col-sm-5\" ng-click=InitiateTransactionFlexSip.newFolioClickAction(); ng-if=\"InitiateTransactionFlexSip.loginType == \'D\' && !InitiateTransactionFlexSip.corporateFlag\"><label class=\"text-blue cursor-pointer\"><strong>Proceed with a New Folio</strong></label></div></div></div><div ng-class=\"{\'anything-disabled\': (!InitiateTransactionFlexSip.formData.folioNumber||(InitiateTransactionFlexSip.hasFolioEmailId == false)) }\"><div class=\"normal-wrap clearfix\"><div class=choose-type><table class=\"table table-custom-sub-fields\" ng-if=!InitiateTransactionFlexSip.oversea_arn><tr><td>Sub Broker ARN</td><td>:</td><td colspan=2 class=sub-broker-arn><div class=col-md-10><div class=input-normal><input type=text class=arn-no name=subBrokerARNDesk id=subBrokerARNS ng-model=InitiateTransactionFlexSip.formData.subBrokerARN ng-change=InitiateTransactionFlexSip.changeSubBrokerArn() ng-blur=InitiateTransactionFlexSip.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label class=\"sub-broker-arn-label\">Sub Broker ARN</label>--><p ng-if=InitiateTransactionFlexSip.subBrokerName class=info-primary>Sub Broker Name: {{InitiateTransactionFlexSip.subBrokerName}}</p><span class=error-input ng-if=\"flexSipForm.subBrokerARNDesk.$dirty && flexSipForm.subBrokerARNDesk.$invalid && flexSipForm.subBrokerARNDesk.$error.pattern\">{{InitiateTransactionFlexSip.validations.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionFlexSip.subBrokerCodeError != \'\' && !sipPurchaseForm.subBrokerARNDesk.$invalid && InitiateTransactionFlexSip.formData.subBrokerARN\" ng-bind=InitiateTransactionFlexSip.subBrokerCodeError></span></div></div></td><td>Sub Broker Code</td><td>:</td><td colspan=2 class=sub-broker-code><div class=col-md-10><div class=input-normal ng-class={error:flexSipForm.subBrokerCode.$dirty&&flexSipForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionFlexSip.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionFlexSip.formData.subBrokerARN || InitiateTransactionFlexSip.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=flexSipForm.subBrokerCode.$dirty&&flexSipForm.subBrokerCode.$error.required ng-bind=InitiateTransactionFlexSip.validations.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-custom-sub-fields-mobile\" ng-if=!InitiateTransactionFlexSip.oversea_arn><tr><td>Sub Broker ARN</td><td>:</td><td class=sub-broker-arn><div class=col-sm-12><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionFlexSip.formData.subBrokerARN ng-change=InitiateTransactionFlexSip.changeSubBrokerArn() ng-blur=InitiateTransactionFlexSip.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label>Sub Broker ARN</label>--><p ng-if=InitiateTransactionFlexSip.subBrokerName class=info-primary>Sub Broker Name: {{InitiateTransactionFlexSip.subBrokerName}}</p><span class=error-input ng-if=\"flexSipForm.subBrokerARN.$dirty && flexSipForm.subBrokerARN.$invalid && flexSipForm.subBrokerARN.$error.pattern\">{{InitiateTransactionFlexSip.validations.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionFlexSip.subBrokerCodeError != \'\'\" ng-bind=InitiateTransactionFlexSip.subBrokerCodeError></span></div></div></td></tr><tr><td>Sub Broker Code</td><td>:</td><td class=sub-broker-code><div class=col-sm-12><div class=input-normal ng-class={error:sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionFlexSip.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionFlexSip.formData.subBrokerARN || InitiateTransactionFlexSip.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$error.required ng-bind=InitiateTransactionFlexSip.validations.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-sipPurchase\"><tr ng-if=!InitiateTransactionFlexSip.oversea_arn><td>EUIN :</td><td>&nbsp;</td><td><div class=\"col-md-4 col-sm-6 input-euin\"><div class=\"input-select input-normal selectfield select-euin drop-arrow\"><select class=\"browser-default custom-select\" name=selectEuin ng-change=InitiateTransactionFlexSip.euinChanged() ng-model=InitiateTransactionFlexSip.formData.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in InitiateTransactionFlexSip.euinList\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=\"req text-red\">*</span></div></div></td></tr><tr ng-if=\"InitiateTransactionFlexSip.formData.euinOpted === InitiateTransactionFlexSip.EUIN_OPTED.NO && !InitiateTransactionFlexSip.oversea_arn\"><td>&nbsp;</td><td>&nbsp;</td><td><div class=\"col-md-12 self-declaration\"><span class=checkbox><input type=checkbox name=TandC value=true ng-model=InitiateTransactionFlexSip.TandC required> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr></table></div><div class=sip-form-box><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Add a SIP Scheme</strong></label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=sipScheme1 ng-change=InitiateTransactionFlexSip.filterSipSchemeList() ng-model=InitiateTransactionFlexSip.formData.inSchemeName autocomplete=off ng-paste=$event.preventDefault(); ondrop=\"return false\" required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionFlexSip.sipSchemeList display-key=scheme hdfc-click=InitiateTransactionFlexSip.selectFlexSipScheme(data) model=InitiateTransactionFlexSip.formData.inSchemeCode for=sipScheme1></drop-down></div></div></div><div class=\"col-md-1 form-grid mgt50 clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid mgt50 inline-style\"><a ng-click=InitiateTransactionFlexSip.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:((InitiateTransactionFlexSip.isMinSipAmount && InitiateTransactionFlexSip.formData.installmentAmount)\n                                || (!InitiateTransactionFlexSip.isMinSipAmount && InitiateTransactionFlexSip.formData.installmentAmount && (InitiateTransactionFlexSip.sipValidations.amountMultiples&&!InitiateTransactionFlexSip.isMultiples))\n                                ||(InitiateTransactionFlexSip.isOtmLimitLess && InitiateTransactionFlexSip.formData.installmentAmount))}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel ng-change=InitiateTransactionFlexSip.changeSipAmount(flexSipForm) name=installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords392\')\" ng-model=InitiateTransactionFlexSip.formData.installmentAmount autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>SIP Amount</label><span class=error-input ng-if=\"InitiateTransactionFlexSip.isOtmLimitLess && flexSipForm.installmentAmount.$valid &&\n                    !InitiateTransactionFlexSip.isMinSipAmount\">{{\'Amount should not be greater than OTM Limit(\'+ InitiateTransactionFlexSip.otmBankLimit+\')\'}} </span><span class=amount-error ng-if=\"(InitiateTransactionFlexSip.isMinSipAmount && InitiateTransactionFlexSip.formData.installmentAmount)\" class=error-input>{{\'Minimum amount should be &#8377; \'+ InitiateTransactionFlexSip.sipValidations.minAmount}} </span><span class=amount-error style=\"width: 500px\" ng-if=\"( InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' && InitiateTransactionFlexSip.isOTMMaxLimit && InitiateTransactionFlexSip.formData.installmentAmount)\" class=error-input>{{\'Flex SIP installment amount cannot exceed Rs. 1 Lakh\'}} </span><span class=amount-error style=\"width: 500px\" ng-if=\"( InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\' && InitiateTransactionFlexSip.isEmandateMaxLimit && InitiateTransactionFlexSip.formData.installmentAmount)\" class=error-input>{{\'Flex SIP installment amount cannot exceed Rs. 1 Lakh\'}} </span><span ng-if=\"flexSipForm.installmentAmount.$invalid && flexSipForm.installmentAmount.$error.number\" class=error-input>{{InitiateTransactionFlexSip.VALIDATE_DATA.INVALID_AMOUNT}} </span><span ng-if=\"flexSipForm.installmentAmount.$valid && !InitiateTransactionFlexSip.isMinSipAmount &&\n                          (InitiateTransactionFlexSip.sipValidations.amountMultiples&&!InitiateTransactionFlexSip.isMultiples)\" class=error-input>Please Provide In multiples of &#8377; {{InitiateTransactionFlexSip.sipValidations.amountMultiples|unit}}</span><div ng-if=InitiateTransactionFlexSip.formData.installmentAmount class=amount-in-words><span>(In Words)&nbsp;</span><div id=divDisplayWords392></div></div></div></div><div class=\"col-sm-offset-3 amount-button-container\" ng-if=InitiateTransactionFlexSip.formData.inSchemeCode><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in InitiateTransactionFlexSip.FlexsipSuggestedAmount\" ng-click=InitiateTransactionFlexSip.changeAmountSuggestion(amount)><img src=../../assets/images/icons/rupee-white.png>{{amount}}</button></div></div><!--            <div class=\"row\"--><!--                 ng-if=\"InitiateTransactionFlexSip.sipValidations && !InitiateTransactionFlexSip.sipValidations.isGrowth\">--><!--              <div class=\"col-md-12 form-grid\">--><!--                <div class=\"install-freq\">--><!--                  <p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p>--><!--                  <div class=\"col-md-6 radio-block radio-flex-div\"--><!--                       ng-class=\"{\'anything-disabled\': InitiateTransactionFlexSip.sipValidationsData.dividendReinvestmentApplicable === false}\">--><!--                  <span class=\"radio radio-flex-span radio-flex\">--><!--                     <input type=\"radio\" id=\"sReinvest\"--><!--                            ng-model=\"InitiateTransactionFlexSip.formData.dividendOption\"--><!--                            ng-value=\"InitiateTransactionFlexSip.DIVIDEND_OPTIONS.REINVEST\"--><!--                            ng-disabled=\"InitiateTransactionFlexSip.sipValidationsData.dividendReinvestmentApplicable === false\"--><!--                            name=\"sDividendOption\"/>--><!--                     <span class=\"check\"></span>--><!--                  </span>--><!--                    <label class=\"radio-flex-label\" for=\"sReinvest\" >Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label>--><!--                  </div>--><!--                  <div class=\"col-md-6 radio-block radio-flex-div\"--><!--                       ng-class=\"{\'anything-disabled\': InitiateTransactionFlexSip.sipValidationsData.dividendPayoutApplicable === false}\">--><!--                  <span class=\"radio radio-flex-span radio-flex\">--><!--                    <input type=\"radio\" id=\"sPayout\" ng-model=\"InitiateTransactionFlexSip.formData.dividendOption\"--><!--                           ng-value=\"InitiateTransactionFlexSip.DIVIDEND_OPTIONS.PAYOUT\"--><!--                           ng-disabled=\"InitiateTransactionFlexSip.sipValidationsData.dividendPayoutApplicable === false\"--><!--                           name=\"sDividendOption\"/>--><!--                    <span class=\"check\"></span>--><!--                  </span>--><!--                    <label class=\"radio-flex-label\" for=\"sPayout\">Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label>--><!--                  </div>--><!--                </div>--><!--              </div>--><!--            </div>--><div class=row ng-if=InitiateTransactionFlexSip.SIP_FREQ_LIST><div class=\"col-md-6 form-grid\" style=padding-top:24px><div class=\"install-freq frequency\"><p><strong>Installment Frequency</strong></p><div ng-if=InitiateTransactionFlexSip.selectedFrequency class=radio-block ng-repeat=\"freq in InitiateTransactionFlexSip.SIP_FREQ_LIST\"><span class=radio><input type=radio id={{freq.name}} ng-change=InitiateTransactionFlexSip.changeFrequency(flexSipForm) ng-model=InitiateTransactionFlexSip.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.name}}>{{freq.name}}</label><i class=\"tooltip-info-icon base-tooltip\" ng-if=\"freq.code === \'BZ\'\" tooltip data-toggle=tooltip data-placement=right title=\"Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented.\n                       SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP. Daily SIP end date can be only on a business day.\"></i></div></div></div></div><div class=row ng-if=InitiateTransactionFlexSip.formData.inSchemeName><div class=col-md-12><div class=\"install-freq frequency sip-fi flex-sip-wrap\"><label class=set-margin-30-resp><strong>Do you wish to pay First Installment with your SIP Registration:</strong></label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=InitiateTransactionFlexSip.formData.sipFirstInstallment ng-change=InitiateTransactionFlexSip.changeFirstInstallment(true) ng-value=true> <span class=check></span></span><label>Yes</label></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=InitiateTransactionFlexSip.formData.sipFirstInstallment ng-change=InitiateTransactionFlexSip.changeFirstInstallment(false) ng-value=false> <span class=check></span></span><label>No</label></div></div></div></div><!--SIP Payment start here--><div class=row><div class=\"col-md-8 pay-mode width100\"><div><p><strong>Payment Mode Selection</strong></p><p style=\"margin-top: 10px\" ng-if=\"InitiateTransactionFlexSip.PAYMENT_MODE.length==0\" class=\"payment-error-message no_payment_text\"><strong>{{InitiateTransactionFlexSip.NO_PAYMENT_MODE_ERROR}}</strong></p><div class=radio-block ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && payMode.value ===\'Register E-mandate (eOTM)\')\" ng-repeat=\"payMode in InitiateTransactionFlexSip.PAYMENT_MODE\"><span ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ===\'Standing Instruction/Biller\')\" class=radio><input type=radio id={{payMode.value}} ng-change=InitiateTransactionFlexSip.changePaymentMode() ng-model=InitiateTransactionFlexSip.formData.paymentMode ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') || !(InitiateTransactionFlexSip.formData.minorFlag && payMode.value ==\'Register E-mandate (eOTM)\')\" ng-value=payMode name=paymentMode required> <span class=check></span></span><label ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') \" for={{payMode.value}}>{{payMode.value}}</label><div ng-if=\"payMode.value == \'Net Banking\' && InitiateTransactionFlexSip.formData.paymentMode.value === \'Net Banking\'\"><div class=point-to-note-tpv>Please Note:<br><ul><li>Investor will be shown only the banks registered against the selected folio at the time of payment via Net Banking.</li><li>The list of banks available for registration in the folio has been restricted to only those banks which provide Third Party Verification(TPV) facility. <a ng-click=InitiateTransactionFlexSip.tpv() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</li></ul></div></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\'\" ng-class=\"{error: (flexSipForm.otmBank.$invalid && flexSipForm.otmBank.$dirty)\n                         || InitiateTransactionFlexSip.otmLimitvalidation\n                         || InitiateTransactionFlexSip.endDateValidation\n                         || (InitiateTransactionFlexSip.formData.otmBank\n                              && InitiateTransactionFlexSip.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionFlexSip.selectedFrequency.code === \'BZ\')}\"><input type=text name=bank id=otmBank ng-model=InitiateTransactionFlexSip.formData.otmBank.bankName ng-change=InitiateTransactionFlexSip.changeOtmbank() ng-init=\"InitiateTransactionFlexSip.formData.otmBank = InitiateTransactionFlexSip.formData.otmBank ? InitiateTransactionFlexSip.formData.otmBank : null\" autocomplete=off ng-required=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\'\" only-alphabets required> <span class=highlight></span> <span class=bar></span><label style=\"display: block\">Select Otm Bank - Account Number</label><bank-drop-down list-data=InitiateTransactionFlexSip.otmBankList display-key=bankName display-key-second=bankAcNo hdfc-click=InitiateTransactionFlexSip.changeOtmbank() model=InitiateTransactionFlexSip.formData.otmBank for=otmBank></bank-drop-down><span ng-show=\"flexSipForm.otmBank.$dirty && flexSipForm.otmBank.$invalid\"><span class=error-input ng-show=flexSipForm.otmBank.$error.required ng-bind=InitiateTransactionFlexSip.validations.BLANK_BANK_INFO></span></span></div></div></div></div><div class=\"col-md-8 width100\"><div class=\"borderline emandate-section\" ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\' && InitiateTransactionFlexSip.emandateDisplay && InitiateTransactionFlexSip.eMandateBankList.length > 0 && !(InitiateTransactionFlexSip.formData.minorFlag) && InitiateTransactionFlexSip.emandateObj\"><div class=row><div class=\"col-md-3 label-emandate-bank\">Select Bank</div><div class=col-md-3><div class=\"input-select input-normal selectfield\" ng-class=\"{error: (flexSipForm.eMandateBank.$invalid && flexSipForm.eMandateBank.$dirty)}\"><input type=text name=bank id=bank ng-model=InitiateTransactionFlexSip.formData.eMandateBank.bankNameOnly ng-change=InitiateTransactionFlexSip.changeEMandateBank() ng-init=\"InitiateTransactionFlexSip.formData.eMandateBank = InitiateTransactionFlexSip.formData.eMandateBank ? InitiateTransactionFlexSip.formData.eMandateBank : null\" autocomplete=off ng-required=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\'\" only-alphabets required readonly> <span class=highlight></span> <span class=bar></span><bank-drop-down list-data=InitiateTransactionFlexSip.eMandateBankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=InitiateTransactionFlexSip.changeEMandateBank() model=InitiateTransactionFlexSip.formData.eMandateBank for=bank></bank-drop-down><span ng-show=\"flexSipForm.eMandateBank.$dirty && flexSipForm.eMandateBank.$invalid\"><span class=error-input ng-show=flexSipForm.eMandateBank.$error.required ng-bind=InitiateTransactionFlexSip.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate-bank\">Authentication Mode</div><div class=col-md-3><div class=\"input-select input-normal selectfield\" ng-class=\"{error: (flexSipForm.authMode.$invalid && flexSipForm.authMode.$dirty && InitiateTransactionFlexSip.canshowAuthError && InitiateTransactionFlexSip.formData.eMandateBank)}\"><select class=\"browser-default custom-select\" name=authMode ng-model=InitiateTransactionFlexSip.authMode ng-options=\"item.text for item in InitiateTransactionFlexSip.formData.eMandateBank.authenticationModes\" ng-required=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\'\"><option value=\"\" selected>Select Authentication mode</option></select><span ng-show=\"flexSipForm.authMode.$dirty && flexSipForm.authMode.$invalid && !InitiateTransactionFlexSip.authMode && InitiateTransactionFlexSip.canshowAuthError && InitiateTransactionFlexSip.formData.eMandateBank\"><span class=error-input ng-show=flexSipForm.authMode.$error.required ng-bind=InitiateTransactionFlexSip.validations.BLANK_AUTH_MODE_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Amount</div><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateTransactionFlexSip.tForm.eAmount.$invalid && InitiateTransactionFlexSip.tForm.eAmount.$dirty),\'has-data\':InitiateTransactionFlexSip.formData.emandateAmount}\"><input class=input-min type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=InitiateTransactionFlexSip.formData.emandateAmount ng-change=InitiateTransactionFlexSip.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i style=\"top: 10px\" class=rupee-grey-icon></i><div class=amtWords ng-if=InitiateTransactionFlexSip.formData.emandateAmount><p id=amountInwordsEmandate>{{InitiateTransactionFlexSip.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                        <span class=\"text-success\">--><!--                          Maximum allowed for e-mandate is ₹ {{InitiateTransactionFlexSip.mandateMaxString}}.--><!--                        </span>--><div class=error-input ng-show=\"InitiateTransactionFlexSip.amountLess && !InitiateTransactionFlexSip.amountLessMin\">{{InitiateTransactionFlexSip.validations.EMANDATE_MIN_ERROR_FLEX_SIP}}</div><div class=error-input ng-show=InitiateTransactionFlexSip.amountLessMin>{{InitiateTransactionFlexSip.validations.EMANDATE_MIN_ERROR + InitiateTransactionFlexSip.emandateMinimumAmountLimit}}.</div><div class=error-input ng-show=InitiateTransactionFlexSip.amountMore>{{InitiateTransactionFlexSip.validations.EMANDATE_MAX_ERROR + InitiateTransactionFlexSip.mandateMaxString}}.</div><div class=error-input ng-show=\"!InitiateTransactionFlexSip.amountLess && !InitiateTransactionFlexSip.amountLessMin && InitiateTransactionFlexSip.isLessThanSipAmount\" ng-bind=InitiateTransactionFlexSip.validations.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!InitiateTransactionFlexSip.formData.emandateAmount ng-bind=InitiateTransactionFlexSip.validations.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Start Date</div><div class=\"col-md-3 anything-disabled\" ng-if=!InitiateTransactionFlexSip.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{InitiateTransactionFlexSip.viewMode}} data-date-default=InitiateTransactionFlexSip.formData.emandateDate id=emandateStartDate data-enable=true data-on-date-change=InitiateTransactionFlexSip.changeDateEmandate style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=\"row mandateDates\"><div class=\"col-md-3 label-emandate\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{InitiateTransactionFlexSip.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !InitiateTransactionFlexSip.formData.emandateDate}\"><div class=form-group ng-if=!InitiateTransactionFlexSip.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:InitiateTransactionFlexSip.tForm.endDateEmandate.$dirty && InitiateTransactionFlexSip.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateTransactionFlexSip.formData.endDateEmandate data-enabled-dates=InitiateTransactionFlexSip.enabledEmandateEndDatesList data-view-date=InitiateTransactionFlexSip.enabledEndDateView data-max-date=InitiateTransactionFlexSip.maxEndDateEmandate data-min-date=InitiateTransactionFlexSip.minEndDateEmandate data-on-date-change=InitiateTransactionFlexSip.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"InitiateTransactionFlexSip.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionFlexSip.sipDateLessEmandate ng-bind=InitiateTransactionFlexSip.validations.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div></div><div ng-if=\"(InitiateTransactionFlexSip.isEmailinValid || InitiateTransactionFlexSip.isEmailMobileinValid || InitiateTransactionFlexSip.isMobileinValid) && (InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\')\" style=width:55%><span class=error-input ng-show=InitiateTransactionFlexSip.isMobileinValid ng-bind=InitiateTransactionFlexSip.validations.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=InitiateTransactionFlexSip.isEmailinValid ng-bind=InitiateTransactionFlexSip.validations.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=InitiateTransactionFlexSip.isEmailMobileinValid ng-bind=InitiateTransactionFlexSip.validations.INVALID_EMAIL_MOBILE_EMANDATE></span></div><!--notes mandate--><div ng-if=!(InitiateTransactionFlexSip.formData.minorFlag)><div ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\' && InitiateTransactionFlexSip.emandateDisplay && InitiateTransactionFlexSip.eMandateBankList.length > 0\"><!--dynamic note for eotm--><ng-bind-html dynamic=InitiateTransactionFlexSip.dynamicNoteEotm.content ng-if=\"InitiateTransactionFlexSip.authMode.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=InitiateTransactionFlexSip.dynamicNoteEotmDebitCard.content ng-if=\"InitiateTransactionFlexSip.authMode.value === \'DEBIT_CARD\'\"></ng-bind-html></div></div><div class=row><div class=col-md-12><table class=\"table borderless\" ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' &&\n                      InitiateTransactionFlexSip.formData.otmBank\n                      && InitiateTransactionFlexSip.otmBankList.length\"><tr><td>OTM Bank Name</td><td>: {{InitiateTransactionFlexSip.formData.otmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td>: {{InitiateTransactionFlexSip.formData.otmBank.omStartDate}}</td></tr><tr><td>OTM Maturity Date</td><td>: {{InitiateTransactionFlexSip.formData.otmBank.omExpiryDate}}</td></tr><tr><td>OTM Instruction Type</td><td>: {{InitiateTransactionFlexSip.formData.otmBank.otmFrequencyName ? InitiateTransactionFlexSip.formData.otmBank.otmFrequencyName : InitiateTransactionFlexSip.formData.otmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td>: <i class=rupee-icon ng-if=InitiateTransactionFlexSip.formData.otmBank.maxAmount></i>{{InitiateTransactionFlexSip.formData.otmBank.maxAmount}} <span ng-if=InitiateTransactionFlexSip.otmLimitvalidation class=error-input>{{InitiateTransactionFlexSip.validationMessage}}</span></td></tr></table></div></div></div></div><!--SIP Payment end here--><div ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' && !InitiateTransactionFlexSip.formData.fiPaymentMode\"><!-- dynamic note for sip otm --><ng-bind-html dynamic=InitiateTransactionFlexSip.dynamicNoteOtmSip.content></ng-bind-html></div><!--SIP with FI payment starts from here --><div class=row ng-if=InitiateTransactionFlexSip.formData.sipFirstInstallment><div class=\"col-md-8 pay-mode width100\"><div><p><strong>Payment Mode Selection for First Installment of Flex SIP</strong></p><p style=\"margin-top: 10px\" ng-if=\"InitiateTransactionFlexSip.sipFirstInstallmentPaymentMode.length==0\" class=\"payment-error-message no_payment_text\"><strong>{{InitiateTransactionFlexSip.NO_PAYMENT_MODE_ERROR}}</strong></p><div class=radio-block ng-repeat=\"payMode in InitiateTransactionFlexSip.sipFirstInstallmentPaymentMode\"><span ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag &&\n                      !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ===\'Standing Instruction/Biller\')\" class=radio><input type=radio ng-model=InitiateTransactionFlexSip.formData.fiPaymentMode ng-change=InitiateTransactionFlexSip.changedFiPaymentMode() ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') || !(InitiateTransactionFlexSip.formData.minorFlag && payMode.value ==\'Register E-mandate (eOTM)\')\" ng-value=payMode name=fiPaymentMode required> <span class=check></span></span><label ng-if=\"!(InitiateTransactionFlexSip.formData.minorFlag && !InitiateTransactionFlexSip.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') \" for={{payMode.value}}>{{payMode.value}}</label></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionFlexSip.formData.fiPaymentMode.key === \'OTM\'\" ng-class=\"{error: (sipPurchaseForm.fiOtmBank.$invalid && sipPurchaseForm.fiOtmBank.$dirty)\n                         || InitiateTransactionFlexSip.otmLimitvalidation\n                         || InitiateTransactionFlexSip.endDateValidation\n                         || (InitiateTransactionFlexSip.formData.fiOtmBank\n                              && InitiateTransactionFlexSip.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionFlexSip.selectedFrequency.key === \'BZ\')}\"><select class=\"browser-default custom-select\" name=fiOtmBank ng-model=InitiateTransactionFlexSip.formData.fiOtmBank ng-change=InitiateTransactionFlexSip.changeOtmbank() ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateTransactionFlexSip.otmBankList\" ng-required=\"InitiateTransactionFlexSip.formData.fiPaymentMode.key === \'OTM\'\"><option value=\"\" selected>Select OTM Bank - Account Number</option></select><span ng-show=\"sipPurchaseForm.fiOtmBank.$dirty && sipPurchaseForm.fiOtmBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.fiOtmBank.$error.required ng-bind=InitiateTransactionFlexSip.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=col-md-12><table class=\"table borderless\" ng-if=\"InitiateTransactionFlexSip.formData.fiPaymentMode.key === \'OTM\' &&\n                      InitiateTransactionFlexSip.formData.fiOtmBank\n                      && InitiateTransactionFlexSip.otmBankList.length\"><tr><td>OTM Bank Name</td><td>: {{InitiateTransactionFlexSip.formData.fiOtmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td>: {{InitiateTransactionFlexSip.formData.fiOtmBank.omStartDate}}</td></tr><tr><td>OTM Maturity Date</td><td>: {{InitiateTransactionFlexSip.formData.fiOtmBank.omExpiryDate}}</td></tr><tr><td>OTM Instruction Type</td><td>: {{InitiateTransactionFlexSip.formData.fiOtmBank.otmFrequencyName ? InitiateTransactionFlexSip.formData.fiOtmBank.otmFrequencyName : InitiateTransactionFlexSip.formData.fiOtmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td>: <i class=rupee-icon ng-if=InitiateTransactionFlexSip.formData.fiOtmBank.maxAmount></i>{{InitiateTransactionFlexSip.formData.fiOtmBank.maxAmount}} <span ng-if=InitiateTransactionFlexSip.fiOtmLimitvalidation class=error-input><!--Otm account limit should be greater than or equal the investment amount.--> SIP amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed</span></td></tr></table></div></div></div></div><!--SIP with FI Payment end here--><div ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' && InitiateTransactionFlexSip.formData.fiPaymentMode.key === \'OTM\'  \"><!-- dynamic note for sip otm with sip with fi as otm --><ng-bind-html dynamic=InitiateTransactionFlexSip.dynamicNoteOTMOTM.content></ng-bind-html></div><div ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key != \'OTM\'\"><div class=row><p class=\"col-md-12 pay-mode\"><strong>Installment Date Details</strong></p><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionFlexSip.resetting><!-- && InitiateTransactionFlexSip.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode={{InitiateTransactionFlexSip.viewMode}} data-format={{InitiateTransactionFlexSip.startDateFormat}} data-date-default=InitiateTransactionFlexSip.formData.startDate data-enabled-dates=InitiateTransactionFlexSip.enabledBillerStartDatesList data-min-date=InitiateTransactionFlexSip.startMinDateBiller data-max-date=InitiateTransactionFlexSip.startMaxDate data-on-date-change=InitiateTransactionFlexSip.changeStartDate id=startDate-biller><input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"Flex SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div class=row ng-if=!InitiateTransactionFlexSip.resetting><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error: flexSipForm.tenure.$invalid && flexSipForm.tenure.$dirty}\"><label style=\"display: block; top: -10px;background: white\" ng-if=InitiateTransactionFlexSip.formData.tenure>Tenure</label><select class=\"browser-default custom-select\" name=tenure ng-model=InitiateTransactionFlexSip.formData.tenure ng-change=InitiateTransactionFlexSip.changeTenure() ng-options=\" duration.tenureValue as duration.tenureKey for duration in InitiateTransactionFlexSip.tenureDuration\" required><option value=\"\" selected>Select Tenure</option></select><span ng-show=\"flexSipForm.tenure.$dirty && flexSipForm.tenure.$invalid\"><span class=error-input ng-show=flexSipForm.tenure.$error.required ng-bind=InitiateTransactionFlexSip.validations.TENURE_EMPTY></span></span></div></div></div><!--For Sip End Date--><div class=row><div class=\"col-md-4 radio-values anything-disabled\" ng-if=!InitiateTransactionFlexSip.resetting><!-- && InitiateTransactionFlexSip.startDateFlag--><div style=\"width: 100%\" class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionFlexSip.startDateFormat}} data-enabled-dates=InitiateTransactionFlexSip.enabledEndDates data-date-default=InitiateTransactionFlexSip.formData.endDate data-min-date=InitiateTransactionFlexSip.minEndDate data-on-date-change=InitiateTransactionFlexSip.changeEndDate data-view-date=InitiateTransactionFlexSip.enabledEndDates[0] showdefault=false id=endDate-Biller><!----> <input type=text name=selectEndDate ng-disabled=InitiateTransactionFlexSip.isTillPerpetuity autocomplete=off class=form-control placeholder=\"Flex SIP End Date - DD-MMM-YYYY\" ng-model=InitiateTransactionFlexSip.formData.endDate required readonly style=\"cursor: not-allowed\"> <span class=highlight></span> <span class=bar></span></div></div></div></div><div ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\'\"><div class=row><p class=\"col-md-12 pay-mode\"><strong>Installment Date Details</strong></p><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionFlexSip.resetting><!--&& InitiateTransactionFlexSip.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal sipStartCal\" date-calendar data-enable=true data-viewmode={{InitiateTransactionFlexSip.viewMode}} data-format={{InitiateTransactionFlexSip.startDateFormat}} data-enabled-dates=InitiateTransactionFlexSip.enabledOTMStartDatesList data-date-default=InitiateTransactionFlexSip.formData.startDate data-min-date=InitiateTransactionFlexSip.startMinDateOTM data-max-date=InitiateTransactionFlexSip.startMaxDate data-on-date-change=InitiateTransactionFlexSip.changeStartDate id=startDate-otm><!--data-max-date=\"InitiateTransactionFlexSip.maxStartDate\"--><!--data-min-date=\"InitiateTransactionFlexSip.minStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"Flex SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-message-sip-start style=\"margin: 8px 0 0 -18px\" ng-show=InitiateTransactionFlexSip.startDateValidation ng-if=InitiateTransactionFlexSip.formData.otmBank>Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionFlexSip.formData.otmBank.omStartDate}}</span></div></div></div><div class=row ng-if=!InitiateTransactionFlexSip.resetting><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error: flexSipForm.tenure.$invalid && flexSipForm.tenure.$dirty}\"><label style=\"display: block; top: -10px; background: white\" ng-if=InitiateTransactionFlexSip.formData.tenure>Tenure</label><select class=\"browser-default custom-select\" name=tenure ng-model=InitiateTransactionFlexSip.formData.tenure ng-change=InitiateTransactionFlexSip.changeTenure() ng-options=\"duration.tenureValue as duration.tenureKey for duration in InitiateTransactionFlexSip.tenureDuration\" required><option value=\"\" selected>Select Tenure</option></select><span ng-show=\"flexSipForm.tenure.$dirty && flexSipForm.tenure.$invalid\"><span class=error-input ng-show=flexSipForm.tenure.$error.required ng-bind=InitiateTransactionFlexSip.validations.TENURE_EMPTY></span></span></div></div></div><!--For Sip End Date--><div class=row><div class=\"col-md-4 radio-values anything-disabled\" ng-if=!InitiateTransactionFlexSip.resetting><div style=\"width: 100%\" class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionFlexSip.startDateFormat}} data-enabled-dates=InitiateTransactionFlexSip.enabledEndDates data-date-default=InitiateTransactionFlexSip.formData.endDate data-min-date=InitiateTransactionFlexSip.minEndDate data-on-date-change=InitiateTransactionFlexSip.changeEndDate data-view-date=InitiateTransactionFlexSip.enabledEndDates[0] showdefault=false id=endDate><!----> <input type=text name=selectEndDate ng-disabled=InitiateTransactionFlexSip.isTillPerpetuity autocomplete=off class=form-control placeholder=\"Flex SIP End Date - DD-MMM-YYYY\" ng-model=InitiateTransactionFlexSip.formData.endDate required readonly style=\"cursor: not-allowed\"> <span class=highlight></span> <span class=bar></span> <span ng-if=\"InitiateTransactionFlexSip.endDateValidation && InitiateTransactionFlexSip.formData.endDate && InitiateTransactionFlexSip.formData.otmBank\" class=error-message-sip-end><!-- Otm end date should be on or before selected end date.--> Selected date is greater than OTM expiry date.</span></div></div></div></div><!--            <div class=\"row form-grid\" ng-if=\"InitiateTransactionFlexSip.showChequeLeaf\">--><!--              <p><strong>Upload Age Proof</strong></p>--><!--              <div class=\"col-md-6\">--><!--                <div class=\"form-group\">--><!--                  <input type=\"hidden\" name=\"chequeleaf\" ng-model=\"InitiateTransactionFlexSip.chequeLeaf\" required>--><!--                  <span class=\"file-name text-blue\">{{InitiateTransactionFlexSip.chequeLeaf}}</span>--><!--                  <span class=\"upload-button\">--><!--              <input id=\"uploadFileId\" type=\"file\" focus-me=\"shouldBeOpen\" value=\"Browse..\" accept=\".jpeg,.jpg,.png\"--><!--                     file-model=\"InitiateTransactionFlexSip.myFile\" targetimg=\"showingImgId\"--><!--                     upload=\"InitiateTransactionFlexSip.uploadFile(file)\" required>--><!--              <label for=\"uploadFileId\" class=\"btn-upload btn-secondary-action\">{{InitiateTransactionFlexSip.myFile?\'Change\':\'Upload Date of Birth Proof\'}}</label>--><!--				    </span>--><!--                </div>--><!--              </div>--><!--            </div>--></div><div class=tc-block ng-show=InitiateTransactionFlexSip.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionFlexSip.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionFlexSip.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><!--submit button for SIP--><div class=\"form-footer form-content\"><span class=\"pull-right buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=InitiateTransactionFlexSip.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key !== \'HEM\'\" ng-disabled=\"flexSipForm.$invalid || InitiateTransactionFlexSip.otmLimitvalidation\n                       || InitiateTransactionFlexSip.endDateValidation\n                       || InitiateTransactionFlexSip.startDateValidation\n                       || !(!!InitiateTransactionFlexSip.formData.startDate && !!InitiateTransactionFlexSip.formData.endDate)\n                       || (InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionFlexSip.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionFlexSip.selectedFrequency.code === \'BZ\')\n                              || (InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\' && InitiateTransactionFlexSip.isEmandateMaxLimit)\n                              || (InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' && InitiateTransactionFlexSip.isOTMMaxLimit)\n                              || InitiateTransactionFlexSip.invalidAmount || InitiateTransactionFlexSip.PAYMENT_MODE.length === 0 || InitiateTransactionFlexSip.showRetirementSchemeError\" ng-click=InitiateTransactionFlexSip.checkDuplicateTransaction()>Continue</button> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\'\" ng-disabled=\"flexSipForm.$invalid || InitiateTransactionFlexSip.otmLimitvalidation\n                       || InitiateTransactionFlexSip.endDateValidation\n                       || InitiateTransactionFlexSip.startDateValidation || InitiateTransactionFlexSip.isEmailinValid || InitiateTransactionFlexSip.isEmailMobileinValid || InitiateTransactionFlexSip.isMobileinValid\n                       || !(!!InitiateTransactionFlexSip.formData.startDate && !!InitiateTransactionFlexSip.formData.endDate)\n                       || (InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionFlexSip.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionFlexSip.selectedFrequency.code === \'BZ\')\n                              || (InitiateTransactionFlexSip.formData.paymentMode.key === \'HEM\' && InitiateTransactionFlexSip.isEmandateMaxLimit)\n                              || (InitiateTransactionFlexSip.formData.paymentMode.key === \'OTM\' && InitiateTransactionFlexSip.isOTMMaxLimit) || InitiateTransactionFlexSip.PAYMENT_MODE.length === 0 || InitiateTransactionFlexSip.invalidAmount || InitiateTransactionFlexSip.amountLess || InitiateTransactionFlexSip.amountMore || InitiateTransactionFlexSip.isLessThanSipAmount || InitiateTransactionFlexSip.sipDateLessEmandate || InitiateTransactionFlexSip.amountLessMin || InitiateTransactionFlexSip.showRetirementSchemeError\" ng-click=InitiateTransactionFlexSip.checkDuplicateTransaction()>Continue</button></span></div></div></div></form></div></section><style>.initiate-transition span.amount-error{\n    top: 102%;\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n    color: #d92018;\n  }\n\n  .emandate-section .label-emandate {\n    padding-top: 14px;\n  }\n\n  .emandate-section .label-emandate-bank {\n    padding-top: 30px;\n    font-weight: bold;\n  }\n\n  .emandate-section select, input {\n    font-size: 14px !important;\n  }</style>");
$templateCache.put("app/transactions/initiate/flexstp/flexstp.html","<section class=\"initiate-transition flex-stp\" ng-init=InitiateTransactionFlexStp.init()><div class=content-header><h5>Transaction for {{InitiateTransactionFlexStp.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Flex STP</li></ul></div><div class=content><form autocomplete=off name=InitiateTransactionFlexStp.FlexStpForm ng-keypress=InitiateTransactionFlexStp.handleEnter($event) novalidate><div class=top-wrap ng-if=!InitiateTransactionFlexStp.oversea_arn><div class=row><div class=col-md-4><label>Sub Broker ARN</label><div class=form-group><div><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionFlexStp.formData.subBrokerARN ng-change=InitiateTransactionFlexStp.changeSubBrokerArn() ng-blur=InitiateTransactionFlexStp.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><p ng-if=InitiateTransactionFlexStp.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{InitiateTransactionFlexStp.subBrokerName}}</p><span class=error-input ng-if=\"InitiateTransactionFlexStp.FlexStpForm.subBrokerARN.$dirty && InitiateTransactionFlexStp.FlexStpForm.subBrokerARN.$invalid && InitiateTransactionFlexStp.FlexStpForm.subBrokerARN.$error.pattern\">{{InitiateTransactionFlexStp.validateData.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionFlexStp.subBrokerCodeError != \'\' &&  !InitiateTransactionFlexStp.FlexStpForm.subBrokerARN.$invalid && InitiateTransactionFlexStp.formData.subBrokerARN\" ng-bind=InitiateTransactionFlexStp.subBrokerCodeError></span></div></div></div></div><div class=col-md-1></div><div class=col-md-4><label>Sub Broker Code<span class=req ng-if=InitiateTransactionFlexStp.formData.subBrokerARN></span></label><div class=form-group><div><div class=input-normal ng-class={error:InitiateTransactionFlexStp.FlexStpForm.subBrokerCode.$dirty&&InitiateTransactionFlexStp.FlexStpForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionFlexStp.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionFlexStp.formData.subBrokerARN || InitiateTransactionFlexStp.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionFlexStp.FlexStpForm.subBrokerCode.$dirty&&InitiateTransactionFlexStp.FlexStpForm.subBrokerCode.$error.required ng-bind=InitiateTransactionFlexStp.validateData.SUB_BROKER_REQUIRED></span></div></div></div></div></div><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionFlexStp.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionFlexStp.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Scheme for Transfer</label><div class=selectfield ng-class=\"{error:(InitiateTransactionFlexStp.hasFolioEmailId == false)||InitiateTransactionFlexStp.FlexStpForm.folio.$dirty && InitiateTransactionFlexStp.FlexStpForm.folio.$invalid}\"><select class=\"browser-default custom-select\" name=folio ng-change=InitiateTransactionFlexStp.changeFolio() ng-model=InitiateTransactionFlexStp.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in InitiateTransactionFlexStp.folioListData\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=InitiateTransactionFlexStp.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"InitiateTransactionFlexStp.FlexStpForm.folio.$dirty && InitiateTransactionFlexStp.FlexStpForm.folio.$error.required\" ng-bind=InitiateTransactionFlexStp.validateData.FOLIO_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionFlexStp.hasFolioEmailId == false\" ng-bind=InitiateTransactionFlexStp.validateData.FOLIO_EMAIL></span></div><div class=selectfield ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.outScheme.$dirty && InitiateTransactionFlexStp.FlexStpForm.outScheme.$invalid, \'anything-disabled\': !InitiateTransactionFlexStp.formData.folioNumber}\"><label ng-if=InitiateTransactionFlexStp.formData.outSchemeCode>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=InitiateTransactionFlexStp.fetchUnitDetails() ng-model=InitiateTransactionFlexStp.formData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in InitiateTransactionFlexStp.schemes\" required><option value=\"\" selected>Select a Scheme</option></select><span class=error-input ng-show=\"InitiateTransactionFlexStp.FlexStpForm.outScheme.$dirty && InitiateTransactionFlexStp.FlexStpForm.outScheme.$error.required\" ng-bind=InitiateTransactionFlexStp.validateData.SCHEME_REQUIRED></span></div><div class=value-snippet ng-if=InitiateTransactionFlexStp.formData.schemeCode><div><p class=text-uppercase>Total Market Value<i class=tooltip-info-icon></i></p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionFlexStp.unitsDetails.totalCurrentValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=blue-rupee-icon></i> {{InitiateTransactionFlexStp.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionFlexStp.unitsDetails.lockedValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{InitiateTransactionFlexStp.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value<i class=tooltip-info-icon></i></p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionFlexStp.unitsDetails.freeValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{InitiateTransactionFlexStp.unitsDetails.freeValueAmount|unit}}</span></div><p class=error-message>{{InitiateTransactionFlexStp.unitsDetails.message}}</p></div></div><div class=\"col-md-4 form-grid\" ng-class=\"{\'anything-disabled\': !InitiateTransactionFlexStp.formData.folioNumber || InitiateTransactionFlexStp.unitsDetails.message !=\'\'}\"><label>Scheme to Transfer in</label><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.inScheme.$dirty\n                                && InitiateTransactionFlexStp.FlexStpForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-model=InitiateTransactionFlexStp.selectedInScheme ng-change=InitiateTransactionFlexStp.filterInSchemeList() ng-blur=InitiateTransactionFlexStp.checkValidScheme() autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span class=error-input ng-show=\"InitiateTransactionFlexStp.FlexStpForm.inScheme.$dirty && InitiateTransactionFlexStp.FlexStpForm.inScheme.$error.required\" ng-bind=InitiateTransactionFlexStp.validateData.SCHEME_REQUIRED></span><drop-down list-data=InitiateTransactionFlexStp.filteredinSchemeList display-key=scheme hdfc-click=InitiateTransactionFlexStp.inSchemeChanged(data) model=InitiateTransactionFlexStp.formData.inSchemeCode for=inScheme></drop-down></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=InitiateTransactionFlexStp.getSchemesList()>Select from list</span></p></div><div class=form-group ng-if=\"InitiateTransactionFlexStp.validationsData.investmentOption===InitiateTransactionFlexStp.transactionConstants.DIVIDEND\"><label>Select Income Distribution cum Capital Withdrawal (IDCW) Option</label><div class=radio-flex-div><span class=\"radio-block radio-flex\" ng-repeat=\"stpDevidendOption in InitiateTransactionFlexStp.stpDevidendOptions\" ng-class=\"{\'anything-disabled\': (stpDevidendOption == InitiateTransactionFlexStp.transactionConstants.REINVEST && InitiateTransactionFlexStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionFlexStp.transactionConstants.PAYOUT  && InitiateTransactionFlexStp.validationsData.dividendPayoutApplicable === false)}\"><span class=\"radio radio-flex-span\"><input type=radio id=dividentOptionReinvest{{$index}} ng-value=stpDevidendOption name=dividentOption ng-model=InitiateTransactionFlexStp.formData.dividentOption ng-disabled=\"InitiateTransactionFlexStp.unitsDetails.message\n                            ||(stpDevidendOption == InitiateTransactionFlexStp.transactionConstants.REINVEST && InitiateTransactionFlexStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionFlexStp.transactionConstants.PAYOUT  && InitiateTransactionFlexStp.validationsData.dividendPayoutApplicable === false)\"> <span class=check></span></span><label class=radio-flex-label for=dividentOptionReinvest{{$index}}>{{stpDevidendOption==InitiateTransactionFlexStp.transactionConstants.REINVEST?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</label></span></div></div><div class=selectfield ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.frequency.$dirty && InitiateTransactionFlexStp.FlexStpForm.frequency.$invalid}\"><label>Select Frequency of Flex STP</label><select class=\"browser-default custom-select\" name=frequency ng-disabled=\"(InitiateTransactionFlexStp.validations.isEnabled == \'N\')||(!InitiateTransactionFlexStp.unitsDetails.freeValueUnits)\" ng-change=InitiateTransactionFlexStp.changeFrequency() ng-model=InitiateTransactionFlexStp.selectedFrequency ng-options=\"_frequency as _frequency.value for _frequency in InitiateTransactionFlexStp.frequencyList\" required><option value=\"\" selected>Select Frequency of Flex STP</option></select><span class=error-input ng-show=\"InitiateTransactionFlexStp.FlexStpForm.frequency.$dirty && InitiateTransactionFlexStp.FlexStpForm.frequency.$error.required\" ng-bind=InitiateTransactionFlexStp.validateData.FREQUENCY_REQUIRED></span></div><div class=form-group ng-if=\"InitiateTransactionFlexStp.fields.showDateOfTransfer && InitiateTransactionFlexStp.selectedFrequency\"><div class=selectfield ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.day.$dirty && InitiateTransactionFlexStp.FlexStpForm.day.$invalid}\"><label>Date of Transfer</label><select class=\"browser-default custom-select\" name=day ng-model=InitiateTransactionFlexStp.formData.stpDay ng-change=InitiateTransactionFlexStp.changeDay() ng-options=\"day.name for day in InitiateTransactionFlexStp.daysList\" required><option value=\"\" selected>{{(InitiateTransactionFlexStp.selectedFrequency.key==\'OW\')?\'Day of Transfer\':\'Date of Transfer\'}}</option></select><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"InitiateTransactionFlexStp.FlexStpForm.day.$dirty && InitiateTransactionFlexStp.FlexStpForm.day.$error.required\" ng-bind=InitiateTransactionFlexStp.validateData.DAY_REQUIRED></span></div></div><div ng-if=!InitiateTransactionFlexStp.isResetting><div ng-if=\"InitiateTransactionFlexStp.fields.showStartEndDate && InitiateTransactionFlexStp.selectedFrequency\" class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionFlexStp.startDateFormat}} data-viewmode={{InitiateTransactionFlexStp.viewMode}} data-enabled-dates=InitiateTransactionFlexStp.enabledStartDates data-date-default=InitiateTransactionFlexStp.formData.startDate data-min-date=InitiateTransactionFlexStp.minStartDate data-max-date=InitiateTransactionFlexStp.maxDateStart data-on-date-change=InitiateTransactionFlexStp.changeStartDate id=startDate ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.endDate.$dirty && InitiateTransactionFlexStp.FlexStpForm.startDate.$invalid}\"><input type=text name=startDate ng-required=InitiateTransactionFlexStp.isRequired placeholder=\"Installment Start Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionFlexStp.FlexStpForm.startDate.$error.required ng-bind=InitiateTransactionFlexStp.validateData.START_DATE_REQUIRED></span></div><div ng-if=\"InitiateTransactionFlexStp.fields.showStartEndDate && InitiateTransactionFlexStp.selectedFrequency\" class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionFlexStp.startDateFormat}} data-viewmode={{InitiateTransactionFlexStp.viewMode}} data-enabled-dates=InitiateTransactionFlexStp.enabledEndDates data-min-date=InitiateTransactionFlexStp.enabledEndDates[0] data-max-date=InitiateTransactionFlexStp.maxDateEnd data-date-default=InitiateTransactionFlexStp.endDate data-on-date-change=InitiateTransactionFlexStp.changeEndDate id=endDate focus-on=amount-field ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.endDate.$dirty && InitiateTransactionFlexStp.FlexStpForm.endDate.$invalid\n                  || (!InitiateTransactionFlexStp.endDate && InitiateTransactionFlexStp.fill_end_date != \'\')}\"><input type=text name=endDate ng-required=InitiateTransactionFlexStp.isRequired placeholder=\"Installment End Month - DD-MMM-YYYY\" ng-disabled=InitiateTransactionFlexStp.formData.installment readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionFlexStp.FlexStpForm.endDate.$error.required ng-bind=InitiateTransactionFlexStp.validateData.END_DATE_REQUIRED></span></div></div><div ng-if=InitiateTransactionFlexStp.fields.showInstallment><!--<div class=\"text-center form-group\" ng-if=\"InitiateTransactionFlexStp.showOrMessage\">OR</div>--><div class=input-normal ng-class=\"{error:InitiateTransactionFlexStp.FlexStpForm.installment.$dirty && InitiateTransactionFlexStp.FlexStpForm.installment.$invalid && !InitiateTransactionFlexStp.formData.endDate}\"><input name=installment type=number ignore-mouse-wheel ng-model=InitiateTransactionFlexStp.formData.installment ng-min=InitiateTransactionFlexStp.validations.minInstallments ng-change=InitiateTransactionFlexStp.changeInstallments() ng-disabled=InitiateTransactionFlexStp.formData.endDate required><label>No. of Installments</label><span ng-if=\"InitiateTransactionFlexStp.FlexStpForm.installment.$dirty && InitiateTransactionFlexStp.FlexStpForm.installment.$invalid\"></span> <span ng-show=\"InitiateTransactionFlexStp.FlexStpForm.installment.$dirty && InitiateTransactionFlexStp.FlexStpForm.installment.$error.required\" class=error-input>Installments is required</span> <span ng-show=\"InitiateTransactionFlexStp.FlexStpForm.installment.$dirty && InitiateTransactionFlexStp.FlexStpForm.installment.$error.min\" class=error-input>Minimum number of installments should be {{InitiateTransactionFlexStp.validations.minInstallments}}.</span> <span ng-show=\"(InitiateTransactionFlexStp.validations.maxInstallments > 0) &&\n                InitiateTransactionFlexStp.formData.installment > InitiateTransactionFlexStp.validations.maxInstallments\" class=error-input>Maximum number of installments should be {{InitiateTransactionFlexStp.validations.maxInstallments}}</span></div></div><div ng-if=!InitiateTransactionFlexStp.isResetting><span class=alert-warning ng-if=\"InitiateTransactionFlexStp.fill_end_date != \'\'\">{{InitiateTransactionFlexStp.fill_end_date}} <i ng-if=\"InitiateTransactionFlexStp.validations.minAmount > 500\" class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip title=\"If you are going to put your installment amount in between 500 to 999, please increase the no. of installment ( In this case, minimum no. of installment has to be 12).\"></i></span></div></div><div ng-class=\"{\'anything-disabled\': !InitiateTransactionFlexStp.formData.folioNumber || InitiateTransactionFlexStp.unitsDetails.message !=\'\'}\" class=\"col-md-4 form-grid\"><label>Systematic Transfer Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateTransactionFlexStp.FlexStpForm.amount.$dirty && InitiateTransactionFlexStp.FlexStpForm.amount.$invalid)||(InitiateTransactionFlexStp.formData.amount&&(InitiateTransactionStp.isMax||InitiateTransactionFlexStp.isMin||(!InitiateTransactionFlexStp.isMultiples&&InitiateTransactionFlexStp.validations.amountMultiples)))}\"><input type=number ignore-mouse-wheel name=amount class=amount-field ng-disabled=\"InitiateTransactionFlexStp.unitsDetails.message||!InitiateTransactionFlexStp.unitsDetails||!InitiateTransactionFlexStp.unitsDetails.freeValueAmount || !InitiateTransactionFlexStp.selectedFrequency || (InitiateTransactionFlexStp.unitsDetails.freeValueAmount<InitiateTransactionFlexStp.validations.minAmount)\" ng-model=InitiateTransactionFlexStp.formData.amount ng-change=\"InitiateTransactionFlexStp.amountChanged(\'amount-field\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-blur=InitiateTransactionFlexStp.blured() required> <span class=highlight></span> <span class=bar></span><label>Amount of Transfer per Installment</label><span class=text-support>(&#8377; {{InitiateTransactionFlexStp.validations.minAmount}} Minimum Amount)</span> <i class=rupee-grey-icon></i> <span class=error-input ng-if=\"InitiateTransactionFlexStp.FlexStpForm.amount.$dirty && InitiateTransactionFlexStp.FlexStpForm.amount.$invalid\">{{InitiateTransactionFlexStp.validateData.AMOUNT_REQUIRED}}</span> <span ng-if=\"InitiateTransactionFlexStp.FlexStpForm.amount.$valid && InitiateTransactionFlexStp.isMin\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionFlexStp.validations.minAmount}} </span><span ng-if=\"InitiateTransactionFlexStp.FlexStpForm.amount.$valid && InitiateTransactionFlexStp.isMax\" class=error-input>Maximum amount should be {{InitiateTransactionFlexStp.validations.maxAmount?InitiateTransactionFlexStp.validations.maxAmount:InitiateTransactionFlexStp.unitsDetails.freeValueAmount}} </span><span ng-if=InitiateTransactionFlexStp.FlexStpForm.amount.$valid&&!InitiateTransactionFlexStp.isMax&&!InitiateTransactionFlexStp.isMin&&InitiateTransactionFlexStp.validations.amountMultiples&&!InitiateTransactionFlexStp.isMultiples class=error-input>Please Provide In Multiples Of &#x20B9; {{InitiateTransactionFlexStp.validations.amountMultiples}}</span></div><div class=form-group ng-if=\"InitiateTransactionFlexStp.formData.transferOption !== InitiateTransactionFlexStp.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"><label id=divDisplayWords>(In Words)</label></div></div><div class=\"col-md-12 tc-block\" ng-show=InitiateTransactionFlexStp.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionFlexStp.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionFlexStp.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionFlexStp.selectedInScheme\"\n                  ng-click=\"InitiateTransactionFlexStp.saveForm()\">Save</button>--> <button ng-click=InitiateTransactionFlexStp.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionFlexStp.isCheckedTandC||!InitiateTransactionFlexStp.hasFolioEmailId ||\n          ((!InitiateTransactionFlexStp.formData.startDate || !InitiateTransactionFlexStp.formData.endDate) && InitiateTransactionFlexStp.selectedFrequency.key !==\'DZ\')\n          || (InitiateTransactionStp.selectedFrequency.key==\'DZ\' && !InitiateTransactionFlexStp.formData.startDate) ||\n          InitiateTransactionFlexStp.isSubmitted||InitiateTransactionFlexStp.FlexStpForm.$invalid||\n          (InitiateTransactionFlexStp.formData.amount&&(InitiateTransactionFlexStp.isMax||InitiateTransactionFlexStp.isMin||(!InitiateTransactionFlexStp.isMultiples&&InitiateTransactionFlexStp.validations.amountMultiples)))\n          || ((InitiateTransactionFlexStp.validations.maxInstallments > 0) && InitiateTransactionFlexStp.formData.installment > InitiateTransactionFlexStp.validations.maxInstallments) || InitiateTransactionFlexStp.showRetirementSchemeError\" ng-click=InitiateTransactionFlexStp.submitFirst() class=\"btn btn-primary-action\">Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/instant-redemption/instant-redemption.html","<section class=\"initiate-transition instant-redemption\" ng-init=InitiateTransactionInstantRedeem.init()><div class=content-header><h5>Transaction for {{InitiateTransactionInstantRedeem.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transaction</li><li><span class=breadcrumb-icon></span></li><li>Instant Access Facility</li></ul></div><div class=content><div class=form-box><form autocomplete=off name=InitiateTransactionInstantRedeem.redeemForm novalidate ng-keypress=InitiateTransactionInstantRedeem.handleEnter($event)><div><div class=\"col-md-4 form-grid\"><label>Select Scheme</label><div class=form-group><div class=selectfield ng-class={error:(InitiateTransactionInstantRedeem.redeemForm.folioNumber.$dirty&&InitiateTransactionInstantRedeem.redeemForm.folioNumber.$invalid)||!InitiateTransactionInstantRedeem.hasFolioEmailId}><label>Select Folio</label><select class=\"browser-default custom-select\" name=folioNumber ng-change=InitiateTransactionInstantRedeem.changeFolio() ng-model=InitiateTransactionInstantRedeem.formData.folioNumber required><option value=\"\" selected>Select Folio</option><option ng-repeat=\"_type in InitiateTransactionInstantRedeem.folioListData\" ng-class=\"{\'disabled-option\' : !_type.activeFlag}\" ng-model=InitiateTransactionInstantRedeem.formData.folioNumber ng-disabled=!_type.activeFlag ng-value=_type.folioNo>{{ _type.folioNo }}</option></select><span class=error-input ng-show=\"InitiateTransactionInstantRedeem.redeemForm.folioNumber.$dirty &&InitiateTransactionInstantRedeem.redeemForm.folioNumber.$error.required\" ng-bind=InitiateTransactionInstantRedeem.validateData.FOLIO_REQUIRED></span> <span class=error-input ng-show=!InitiateTransactionInstantRedeem.hasFolioEmailId ng-bind=InitiateTransactionInstantRedeem.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionInstantRedeem.redeemForm.scheme.$dirty && InitiateTransactionInstantRedeem.redeemForm.scheme.$invalid, \'anything-disabled\' : !InitiateTransactionInstantRedeem.formData.folioNumber}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=InitiateTransactionInstantRedeem.schemeChanged() ng-model=InitiateTransactionInstantRedeem.formData.scheme ng-options=\"_type as _type.schemeName for _type in InitiateTransactionInstantRedeem.schemes\" required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"InitiateTransactionInstantRedeem.redeemForm.scheme.$dirty && InitiateTransactionInstantRedeem.redeemForm.scheme.$invalid\"><span class=error-input ng-show=InitiateTransactionInstantRedeem.redeemForm.scheme.$error.required ng-bind=InitiateTransactionInstantRedeem.validateData.SCHEME_REQUIRED></span></span></div><p ng-if=InitiateTransactionInstantRedeem.schemeErrorMessage ng-bind=InitiateTransactionInstantRedeem.schemeErrorMessage></p></div><div class=value-snippet ng-if=\"InitiateTransactionInstantRedeem.formData.scheme && InitiateTransactionInstantRedeem.formData.scheme.maxAmount !==\'\' \"><div><p class=text-uppercase>Available for Instant Access Facility</p><span class=left-val>Amount </span><span easyassist-key=mask-element><i class=rupee-blue-icon></i> {{InitiateTransactionInstantRedeem.formData.scheme.maxAmount | number :2}}</span></div></div></div><div class=\"col-md-4 form-grid\"><label>Enter Amount Value</label><div class=form-group><!--Amount--><div><div class=\"input-normal enter-amount\" ng-class=\"{error:InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$dirty && InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$invalid, \'anything-disabled\' : !InitiateTransactionInstantRedeem.formData.folioNumber}\"><input type=number ignore-mouse-wheel onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" name=redeemAmount ng-change=InitiateTransactionInstantRedeem.checkInstantRedeemAmtValidation() ng-model=InitiateTransactionInstantRedeem.formData.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$dirty && InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$invalid\"><span class=error-input ng-show=InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$error.required ng-bind=InitiateTransactionInstantRedeem.validateData.AMOUNT_REQUIRED></span> </span><span class=error-input ng-if=\"InitiateTransactionInstantRedeem.isMin && !InitiateTransactionInstantRedeem.isMax\">Minimum amount should be &#8377; {{ InitiateTransactionInstantRedeem.minAmount }}</span> <span ng-if=\"InitiateTransactionInstantRedeem.formData.amount && InitiateTransactionInstantRedeem.isMax  && !InitiateTransactionInstantRedeem.isMin && InitiateTransactionInstantRedeem.formData.scheme\" class=error-input>You don\'t have sufficient balance to perform Instant access facility OR Your daily limit for Instant access facility is already utilized.</span></div></div><div style=padding-top:20px><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=form-group ng-if=\"(InitiateTransactionInstantRedeem.redeemForm.units && InitiateTransactionInstantRedeem.redeemForm.units.$valid)||InitiateTransactionInstantRedeem.redeemForm.all_units.$valid || (InitiateTransactionInstantRedeem.redeemForm.redeemAmount && InitiateTransactionInstantRedeem.redeemForm.redeemAmount.$valid)\"><div class=estimate-block><a href=javascript:void(0) ng-click=InitiateTransactionInstantRedeem.downloadReport(InitiateTransactionInstantRedeem.formData.folioNumber,InitiateTransactionInstantRedeem.formData.schemeCode)><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-md-4 form-grid\"><label>Select Bank For Payout</label><div class=form-group><div class=selectfield ng-class=\"{\'anything-disabled\' : !InitiateTransactionInstantRedeem.formData.folioNumber}\"><label>Select Bank For Instant Access Facility</label><select class=\"browser-default custom-select\" ng-model=InitiateTransactionInstantRedeem.formData.bank ng-options=\"_bank as _bank.bankName for _bank in InitiateTransactionInstantRedeem.bankList\" required><option value=\"\" selected>Select Bank For Instant Access Facility</option></select></div><p ng-if=InitiateTransactionInstantRedeem.bankErrorMessage ng-bind=InitiateTransactionInstantRedeem.bankErrorMessage></p></div><table class=\"table borderless\" ng-if=\"InitiateTransactionInstantRedeem.formData.bank && InitiateTransactionInstantRedeem.bankList.length\"><tr><td>Bank Name:</td><td>{{InitiateTransactionInstantRedeem.formData.bank.bankName | uppercase}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateTransactionInstantRedeem.formData.bank.accountNo}}</td></tr><tr><td>IFSC:</td><td>{{InitiateTransactionInstantRedeem.formData.bank.ifscCode}}</td></tr><tr ng-if=InitiateTransactionInstantRedeem.formData.bank.payoutDescription><td>Payout:</td><td>{{InitiateTransactionInstantRedeem.formData.bank.payoutDescription | uppercase}}</td></tr></table></div><ng-bind-html ng-bind-html=InitiateTransactionInstantRedeem.IAF_NOTES.content></ng-bind-html></div><div class=\"col-md-12 tc-block\" ng-show=InitiateTransactionInstantRedeem.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionInstantRedeem.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionInstantRedeem.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><button ng-click=InitiateTransactionInstantRedeem.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionInstantRedeem.isCheckedTandC || !InitiateTransactionInstantRedeem.hasFolioEmailId || InitiateTransactionInstantRedeem.redeemForm.$invalid || InitiateTransactionInstantRedeem.isMin || InitiateTransactionInstantRedeem.isMax\" class=\"btn btn-primary-action\" ng-click=InitiateTransactionInstantRedeem.submitFirst()>Initiate Transaction</button></div></form></div></div></section>");
$templateCache.put("app/transactions/initiate/redeem/redeem.html","<section class=\"initiate-transition redeem\" ng-init=InitiateTransactionRedeem.init()><div class=content-header><h5>Transaction for {{InitiateTransactionRedeem.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transaction</li><li><span class=breadcrumb-icon></span></li><li>Redemption Transaction</li></ul></div><div class=content><div class=form-box><form autocomplete=off name=InitiateTransactionRedeem.redeemForm novalidate ng-keypress=InitiateTransactionRedeem.handleEnter($event)><div class=\"col-md-4 form-grid\"><label>Select Scheme for Redemption</label><div class=form-group><div class=selectfield ng-class={error:(InitiateTransactionRedeem.redeemForm.folioNumber.$dirty&&InitiateTransactionRedeem.redeemForm.folioNumber.$invalid)||!InitiateTransactionRedeem.hasFolioEmailId}><label>Select Folio</label><select class=\"browser-default custom-select\" name=folioNumber ng-change=InitiateTransactionRedeem.changeFolio() ng-model=InitiateTransactionRedeem.formData.folioNumber required><option value=\"\" selected>Select Folio</option><option ng-repeat=\"_type in InitiateTransactionRedeem.folioListData\" ng-class=\"{\'disabled-option\' : !_type.activeFlag}\" ng-model=InitiateTransactionRedeem.formData.folioNumber ng-disabled=!_type.activeFlag ng-value=_type.folioNo>{{ _type.folioNo }}</option></select><span class=error-input ng-show=\"InitiateTransactionRedeem.redeemForm.folioNumber.$dirty &&InitiateTransactionRedeem.redeemForm.folioNumber.$error.required\" ng-bind=InitiateTransactionRedeem.validateData.FOLIO_REQUIRED></span> <span class=error-input ng-show=!InitiateTransactionRedeem.hasFolioEmailId ng-bind=InitiateTransactionRedeem.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionRedeem.redeemForm.scheme.$dirty && InitiateTransactionRedeem.redeemForm.scheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=InitiateTransactionRedeem.fetchUnitDetails();InitiateTransactionRedeem.fetchOutSchemeValidations() ng-model=InitiateTransactionRedeem.formData.schemeCode ng-options=\"_type.schemeCode as _type.schemeName for _type in InitiateTransactionRedeem.schemes\" ng-value=_type.schemeName required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"InitiateTransactionRedeem.redeemForm.scheme.$dirty && InitiateTransactionRedeem.redeemForm.scheme.$invalid\"><span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.scheme.$error.required ng-bind=InitiateTransactionRedeem.validateData.SCHEME_REQUIRED></span></span></div></div><div class=form-group ng-if=InitiateTransactionRedeem.unitsDetails><div class=\"value-box current-val\"><p>Total Current Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionRedeem.unitsDetails.totalCurrentValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionRedeem.unitsDetails.totalCurrentValueAmount |unit:InitiateTransactionRedeem.unitsDetails.totalCurrentValueAmountUnit}} {{InitiateTransactionRedeem.unitsDetails.totalCurrentValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box locked-val\"><p>Locked Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionRedeem.unitsDetails.lockedValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionRedeem.unitsDetails.lockedValueAmount|unit:InitiateTransactionRedeem.unitsDetails.lockedValueAmountUnit}} {{InitiateTransactionRedeem.unitsDetails.lockedValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box free-val\"><p>Free Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionRedeem.unitsDetails.freeValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionRedeem.unitsDetails.freeValueAmount|unit:InitiateTransactionRedeem.unitsDetails.freeValueAmountUnit}} {{InitiateTransactionRedeem.unitsDetails.freeValueAmountUnit|unitValue}}</span></p></div></div></div><div class=\"col-md-4 form-grid\"><label>Select Redemption Value</label><div class=form-group><div><span class=radio-block><span class=radio><input type=radio id=existingFolio name=amountType value=amount ng-model=InitiateTransactionRedeem.formData.amountType ng-disabled=!InitiateTransactionRedeem.unitsDetails ng-change=InitiateTransactionRedeem.changeAmountType()> <span class=check></span></span><label for=existingFolio>Amount</label></span><span class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=all_units ng-model=InitiateTransactionRedeem.formData.amountType ng-disabled=!InitiateTransactionRedeem.unitsDetails ng-change=InitiateTransactionRedeem.changeAmountType()> <span class=check></span></span><label for=allUnits>All Free Units</label></span><span class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType value=units ng-model=InitiateTransactionRedeem.formData.amountType ng-disabled=!InitiateTransactionRedeem.unitsDetails ng-change=InitiateTransactionRedeem.changeAmountType()> <span class=check></span></span><label for=noOfUnits>No. of Units</label></span></div></div><div class=form-group ng-if=\"InitiateTransactionRedeem.formData.amountType==\'amount\'\"><!--Amount--><div><div class=\"input-normal enter-amount\" ng-class=\"{error:InitiateTransactionRedeem.redeemForm.redeemAmount.$dirty && InitiateTransactionRedeem.redeemForm.redeemAmount.$invalid}\"><input type=number ignore-mouse-wheel ng-disabled=!InitiateTransactionRedeem.unitsDetails.freeValueAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" min={{InitiateTransactionRedeem.validations.minAmount}} max={{InitiateTransactionRedeem.unitsDetails.freeValueAmount}} name=redeemAmount ng-model=InitiateTransactionRedeem.formData.amount class=pd20 required> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InitiateTransactionRedeem.redeemForm.redeemAmount.$dirty && InitiateTransactionRedeem.redeemForm.redeemAmount.$invalid\"><span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.redeemAmount.$error.required ng-bind=InitiateTransactionRedeem.validateData.AMOUNT_REQUIRED></span> <span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.redeemAmount.$error.min>{{ InitiateTransactionRedeem.validateData.MINIMUM_AMOUNT }} {{InitiateTransactionRedeem.validations.minAmount}}</span> <span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.redeemAmount.$error.max>{{ InitiateTransactionRedeem.validateData.MAX_AMOUNT }}</span> </span><span style=\"color:#d92018;font-size: 12px\" class=error-input ng-show=\"InitiateTransactionRedeem.redeemForm.redeemAmount.$valid && InitiateTransactionRedeem.validations.amtMultiples &&\n                      ((InitiateTransactionRedeem.formData.amount%InitiateTransactionRedeem.validations.amtMultiples)!=0)\">Please Provide In Multiples Of &#x20B9; {{InitiateTransactionRedeem.validations.amtMultiples}}</span></div></div><div style=padding-top:20px><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=form-group ng-hide=true ng-if=\"InitiateTransactionRedeem.formData.amountType==\'all_units\'\"><!--All Units--><div><div class=unit-number><div class=input-normal><input type=number ignore-mouse-wheel name=all_units readonly ng-model=InitiateTransactionRedeem.formData.units value={{InitiateTransactionRedeem.unitsDetails.freeValueUnits}} required autocomplete=off> <span class=highlight></span> <span class=bar></span></div></div></div></div><div class=form-group ng-if=\"InitiateTransactionRedeem.formData.amountType==\'units\'\"><!--No. of Units--><div><div class=\"input-normal enter-amount\" ng-class=\"{error:InitiateTransactionRedeem.redeemForm.units.$dirty && InitiateTransactionRedeem.redeemForm.units.$invalid}\"><input type=number ignore-mouse-wheel min={{InitiateTransactionRedeem.validations.minUnits}} ng-disabled=!InitiateTransactionRedeem.unitsDetails.freeValueUnits max={{InitiateTransactionRedeem.unitsDetails.freeValueUnits}} name=units ng-model=InitiateTransactionRedeem.formData.units required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span ng-show=\"InitiateTransactionRedeem.redeemForm.units.$dirty && InitiateTransactionRedeem.redeemForm.units.$invalid\"><span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.units.$error.required ng-bind=InitiateTransactionRedeem.validateData.UNITS_REQUIRED></span> <span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.units.$error.min>{{ InitiateTransactionRedeem.validateData.MINIMUM_UNIT }}{{InitiateTransactionRedeem.validations.minUnits}}</span> <span class=error-input ng-show=InitiateTransactionRedeem.redeemForm.units.$error.max>{{ InitiateTransactionRedeem.validateData.MAX_UNIT }}</span></span></div></div></div><div class=form-group ng-if=\"(InitiateTransactionRedeem.redeemForm.units && InitiateTransactionRedeem.redeemForm.units.$valid)||InitiateTransactionRedeem.redeemForm.all_units.$valid || (InitiateTransactionRedeem.redeemForm.redeemAmount && InitiateTransactionRedeem.redeemForm.redeemAmount.$valid)\"><div class=estimate-block><a href=javascript:void(0) ng-click=InitiateTransactionRedeem.downloadReport(InitiateTransactionRedeem.formData.folioNumber,InitiateTransactionRedeem.formData.schemeCode)><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-md-12 tc-block\" ng-show=\"InitiateTransactionRedeem.formData.schemeCode && InitiateTransactionRedeem.inSchemeValidations.schemeType ===\'LIQUID\' && !InitiateTransactionRedeem.inSchemeName.toLowerCase().includes(\'hdfc overnight fund\')\"><span class=checkbox-text>Exit Load would be applicable as per SEBI Circular \"SEBI/HO/IMD/DF2/CIR/P/2019/101\" dated September 20, 2019. <a href=https://files.hdfcfund.com/s3fs-public/addenda-reports/319%20Applicability%20of%20NAV%20-%20November%2029%2C%202010.pdf target=_blank>Click here</a> to know more</span></div><div class=\"col-md-12 tc-block\" ng-show=InitiateTransactionRedeem.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionRedeem.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionRedeem.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><!--ng-disabled=\"!InitiateTransactionRedeem.formData.inSchemeName\"--><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionRedeem.formData.schemeCode || !InitiateTransactionRedeem.unitsDetails.freeValueUnits\"\n                    ng-click=\"InitiateTransactionRedeem.saveForm()\">Save</button>--> <button ng-click=InitiateTransactionRedeem.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionRedeem.isCheckedTandC || !InitiateTransactionRedeem.hasFolioEmailId||InitiateTransactionRedeem.isSubmitted||(InitiateTransactionRedeem.redeemForm.$invalid||\n                    (InitiateTransactionRedeem.formData.amount && InitiateTransactionRedeem.validations.amtMultiples &&\n                    (InitiateTransactionRedeem.formData.amount%InitiateTransactionRedeem.validations.amtMultiples)!=0))||!InitiateTransactionRedeem.unitsDetails.freeValueUnits\" class=\"btn btn-primary-action\" ng-click=InitiateTransactionRedeem.submitFirst()>Initiate Transaction</button></div></form></div></div></section>");
$templateCache.put("app/transactions/initiate/roll-over/rollOverReview.html","<div class=\"main-section rollover-review clearfix\"><div class=summary ng-init=Rollover.initAdd()><p class=page-title>REVIEW ROLL-OVER</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr><td>Folio No.</td><td>:</td><td>{{Rollover.formData.folioNumber}}</td></tr><tr><td>Transaction Type</td><td>:</td><td>ROLL OVER</td></tr><tr><td>Scheme Name</td><td>:</td><td>{{Rollover.formData.schemeName}}</td></tr><tr><td>Roll over mode</td><td>:</td><td>{{Rollover.ROLLOVER_MODE[Rollover.formData.amountType]}}</td></tr><tr ng-if=Rollover.formData.amount><td>Amount</td><td>:</td><td><i class=rupee-small-icon></i>{{(Rollover.formData.amount)?Rollover.formData.amount:\'N/A\'}}</td></tr><tr ng-if=\"Rollover.formData.amountType == \'NoOfUnits\'\"><td>No of units</td><td>:</td><td>{{(Rollover.formData.units)?Rollover.formData.units:\'N/A\'}}</td></tr><tr ng-if=\"Rollover.formData.amountType == \'AllUnits\'\"><td>All Free Units</td><td>:</td><td>Yes</td></tr></table></div></div><div class=row><div class=\"col-md-12 content-foot\"><div class=tc-block><div><div class=checkbox><input ng-model=Rollover.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=Summary.showTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div><span ng-click=Rollover.goToBack() class=\"cursor-pointer text-primary\"><i class=arrow-blue-back-icon></i>Back</span> <button ng-disabled=!Rollover.isCheckedTandC||!Rollover.formData ng-click=Rollover.rolloverConfirm(Rollover.saveRolloverRequest) class=\"btn-primary-action btn pull-right\">Complete Transaction</button></div></div></div></div></div></div>");
$templateCache.put("app/transactions/initiate/roll-over/rollover-view.html","<div class=\"main-section initiate-transaction rollover--folio-changes\" ng-class=\"{\'transaction-screens--agent\' : Rollover.loginType == \'A\'}\" ng-init=Rollover.init()><section class=rollover-view><p class=\"page-title text-uppercase\">Roll over</p><div class=\"content-area roll-availaible\"><form name=rollover autocomplete=off><ul><li><label class=\"pull-left text-primary RollOverFolioNo\">Folio No:</label><select name=folio class=select-folio ng-model=Rollover.formData.folioNumber ng-change=Rollover.folioChanged(Rollover.formData.folioNumber) ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in Rollover.folioList\" required><option value=\"\">Select Folio</option></select><select name=scheme class=select-scheme ng-change=Rollover.SchemeChanged(Rollover.formData.schemeData.schemeCode) ng-disabled=!Rollover.formData.folioNumber ng-model=Rollover.formData.schemeData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in Rollover.schemeList\" required><option value=\"\">Select Scheme</option></select><button id=registered_{{$index}} ng-disabled=\"!Rollover.formData.schemeData || !Rollover.formData.folioNumber\" class=\"btn-small btn-primary-action regBtn\" ng-click=Rollover.rolloverForm()>Register</button></li></ul></form></div><div class=\"content-area clearfix rolled-list\"><header class=clearfix><p>Roll Over Details</p><!--<div class=\"selectfield\">\n          <select name=\"folio\" required>\n            <option>Select Investors</option>\n            <option>Investor name SJKER3882H </option>\n          </select>\n        </div>--><div class=\"search-bar clearfix\"><input type=search id=searchbox ng-model=Rollover.searchString autocomplete=off placeholder=\"Search Name, Folio Number, Mobile Number, Email Id, PAN.\" ng-change=Rollover.searchInvestor() class=blank-input><!-- <button class=\" btn-search\" ng-click=\"Rollover.searchInvestor()\"><i class=\"search-white-icon\"></i></button>--><div id=searchresult class=suggestion ng-if=Rollover.searchResult&&Rollover.searchResult.length><ul><li ng-repeat=\"data in Rollover.searchResult\" ng-click=Rollover.showInvestors(data)>{{data.result}}</li></ul></div><!--<input type=\"search\" id=\"searchbox\" ng-model=\"Header.searchString\" autocomplete=\"off\"\n                 placeholder=\"Search Name, Folio Number, Mobile Number, Email Id, PAN.\"\n                 class=\"blank-input\" ng-keydown=\"Header.searchInvestor()\"/>\n          <button class=\" btn-search\" ng-disabled=\"Header.searchString.length<1\" ng-click=\"Header.searchInvestor(\'onButtonClick\')\"><i class=\"search-white-icon\"></i></button>--></div><div class=row ng-if=Rollover.showInvestorsFlag><div class=investorName><strong>Selected Investor : </strong>{{Rollover.investorDetails.value}}</div></div><div class=folio-tabs><div class=capsule-box><span ng-repeat=\"folioValue in Rollover.folioList track by $index\"><span class=\"capsule slide\" data={{$index+1}} ng-class=\"{\'active\': Rollover.selectedFolio == folioValue.folioNumber}\" ng-click=Rollover.getFolioData(folioValue.folioNumber)>{{folioValue.folioNumber}}</span></span></div></div></header><table class=\"table table-striped rwd-table\"><thead><tr><th>TRANSACTION NO</th><th>TRANSACTION TIME</th><!--msg_created_time--><th>SOURCE scheme</th><th>ROLL OVER MODE</th><th>AMOUNT/ UNITS</th><th>STATUS</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"val in Rollover.rolloverData track by $index \"><td>{{val.cams_ref_no}}</td><td>{{val.msg_created_time}}</td><td>{{val.schemeName}}</td><td>{{val.rolloverMode}}</td><td ng-if=\"val.mode == \'unit\'\">{{val.amountOrUnits|unit:val.unitValue}} {{val.unitValue|unitValue}}<span ng-if=\"val.amountOrUnits !=\'NA\'\"> Units</span></td><td ng-if=\"val.mode == \'amount\'\"><i ng-if=\"val.amountOrUnits !=\'NA\'\" class=rupee-black-icon></i>{{val.amountOrUnits|unit:val.unitValue}} {{val.unitValue|unitValue}}</td><td ng-if=\"val.type==\'cancelled\'\">{{val.type == \"cancelled\" ? \"Cancelled\" :val.msg_current_status}}</td><td ng-if=\"val.type==\'registered\'\">{{val.type == \"registered\" ? \"Registered\" :val.msg_current_status}}</td><td data-th=Action><span class=\"btn-more dropdown\"><button class=\"btn-secondary-action dropdown-toggle\" data-toggle=dropdown>Actions <i class=arrow-blue-down-icon></i></button><ul class=dropdown-menu><li>Actions <i class=arrow-blue-down-icon></i></li><li class=list-group-item ng-click=Rollover.rolloverDetail(val)>Details <i class=\"arrow-right-icon pull-right\"></i></li><!--<li ng-show=\"val.type == \'registered\'\" class=\"list-group-item\" ng-click=\"Rollover.cancelRolloverRequest(val)\">\n                  Cancel  <i class=\"arrow-right-icon pull-right\"></i>\n                </li>--></ul></span></td></tr></tbody><tbody><tr ng-if=\"(!Rollover.rolloverData || !Rollover.rolloverData.length) && !Rollover.isLoading\"><td class=text-center colspan=7>There are no schemes currently open for Roll Over under this folio</td></tr></tbody></table><!--dynamic notes rollover--><ng-bind-html dynamic=Rollover.dynamicNotes.content></ng-bind-html></div><!--<div class=\"end-pagination\" ng-if=\"Rollover.isPagination\">\n      <div class=\"total-data pagination\">\n        <span>Showing</span>\n<span ng-if=\"Rollover.totalrolloverData <= Rollover.PAGE_LIMITS[0]\"\n      ng-bind=\"Rollover.totalrolloverData\"></span>\n        <select ng-if=\"Rollover.totalrolloverData > Rollover.PAGE_LIMITS[0]\"\n                ng-change=\"Rollover.init()\"\n                ng-model=\"Rollover.pageLimitRollover\"\n                ng-options=\"_limit as _limit for _limit in Rollover.PAGE_LIMITS\" ng-value=\"_limit\">\n        </select>\n        <span>of</span>\n        <span class=\"t-black\" ng-bind=\"Rollover.totalrolloverData\">205</span>\n      </div>\n      <ul\n              uib-pagination\n              total-items=\"Rollover.totalrolloverData\"\n              ng-model=\"Rollover.currentPageRollover\"\n              max-size=\"5\"\n              items-per-page=\"Rollover.pageLimitRollover\"\n              class=\"pagination-sm pull-right pagination\"\n              boundary-link-numbers=\"true\"\n              previous-text=\"&lsaquo;\"\n              next-text=\"&rsaquo;\"\n              ng-change=\"Rollover.init()\"\n              rotate=\"false\">\n\n      </ul>\n    </div>--></section></div>");
$templateCache.put("app/transactions/initiate/roll-over/rollover.html","<div class=\"main-section initiate-transaction\" ng-class=\"{\'transaction-screens--agent\' : Rollover.loginType == \'A\'}\" ng-init=Rollover.initAdd()><section class=rollover-form><p class=\"page-title text-uppercase\">roll over</p><div class=content-area><form autocomplete=off class=row name=Rollover.tForm novalidate><p>Select Scheme for Roll Over</p><div class=row><div class=\"col-md-4 border-btm\"><table class=\"borderless table\"><tr><td>Selected Folio</td><td>:</td><td>{{Rollover.schemeData && Rollover.schemeData.folioNumber}}</td></tr><tr><td>Selected Scheme</td><td>:</td><td class=relative>{{Rollover.schemeData && Rollover.schemeData.schemeName}}<div class=rollover-scheme><div class=total-scheme><p class=text-uppercase>Total</p><p><span>Amount : </span><span>&#8377 {{Rollover.schemeData.totalAmount | unit: Rollover.totalAmountValue}}</span></p><p><span>Units : </span><span>{{Rollover.schemeData.totalUnits | unit: Rollover.totalUnitsValue}}</span></p><!--<p>{{Rollover.schemeData && Rollover.schemeData.totalUnits}} Units</p>--></div><div class=avail-rollover-unit><p class=text-uppercase>Available</p><p><span>Amount : </span><span>&#8377 {{Rollover.schemeData.freeAmount | unit: Rollover.freeAmountValue}}</span></p><p><span>Units : </span><span>{{Rollover.schemeData.freeUnits | unit: Rollover.freeUnitsValue}}</span></p><!--<p>{{Rollover.schemeData && Rollover.schemeData.freeUnits}} Units</p>--></div></div></td></tr></table></div></div><p>Select Roll Over Mode</p><div><span class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=AllUnits ng-init=\"Rollover.formData.amountType=\'AllUnits\'\" ng-model=Rollover.formData.amountType ng-change=Rollover.amountTypeChanged()> <span class=check></span></span><label>All Free units</label></span></div><div class=important-change><p class=imp-head>Important:</p><p class=imp-des>Actual unit balance available to switch/redeem maybe lower than total balance because of lien (s) marked against your unit, any recently purchased/switch in units where credit status is not established, investment in investments in ELSS (open ended scheme with 3 years locking), or any other valid reason.</p></div><div class=\"row form-footer\"><div class=\"col-md-8 text-left\"><!--<p class=\"strong\">Terms &amp; Conditions</p>\n            <span class=\"checkbox\">\n              <input type=\"checkbox\" ng-model=\"Rollover.formData.isChecked\" required/>\n              <span class=\"icon-checkbox\"></span>\n              <span class=\"checkbox-text tnc\">I have read and understood <a href=\"\">Terms &amp; Conditions</a> of Investment</span>\n            </span>--></div><div class=col-md-4><!--<button class=\" btn btn-secondary-action common-btn-padding\">Save</button>--><!--<button ng-disabled=\"!Rollover.tForm.$valid || Rollover.isInvalidForm\" class=\" btn btn-primary-action pull-right common-btn-padding\" ng-click=\"Rollover.rolloverConfirm(Rollover.saveRolloverRequest)\">Submit\n            </button>--> <button ng-disabled=\"!Rollover.tForm.$valid || Rollover.isInvalidForm\" class=\"btn btn-primary-action pull-right common-btn-padding\" ng-click=Rollover.initiateTransaction()>Initiate</button></div></div></form></div></section></div>");
$templateCache.put("app/transactions/initiate/sip/sip.html","<section class=\"initiate-transition sip\" ng-init=InitiateTransactionSip.init()><div class=content-header><h5>Transaction for {{InitiateTransactionSip.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Systematic Investment Plan/Purchase</li></ul></div><!--Form Progress Bar--><div class=progress-box><div class=\"ui-progress payment\" ng-class=pageFlag><span class=\"create-folio active cursor-pointer\" data-text=Folio>&nbsp;</span> <span class=\"add-scheme cursor-pointer\" ng-class=\"{active:pageFlag===\'scheme\'||pageFlag===\'payment\'}\" data-text=\"Add Scheme\">&nbsp;</span> <span class=\"select-payment-mode cursor-pointer\" ng-class=\"{active:pageFlag===\'payment\'}\" data-text=\"Bank Details\">&nbsp;</span></div></div><div class=content><div ui-view></div></div></section>");
$templateCache.put("app/transactions/initiate/sip/sip_purchase.html","<section class=\"initiate-transition sip-purchase\" ng-init=InitiateTransactionSipPurchase.init()><div class=content-header><h5>Transaction for: {{InitiateTransactionSipPurchase.investorInfo.name}}</h5></div><div class=content><form autocomplete=off class=sipPurchase-form name=sipPurchaseForm novalidate><div class=\"top-wrap proceed-options\"><div class=\"row flex-style\"><div class=\"col-md-4 col-xs-12 col-sm-6 form-grid\"><div class=form-group><label>Existing Folio No:</label><div class=selectfield ng-class=\"{error:(InitiateTransactionSipPurchase.hasFolioEmailId == false)||(sipPurchaseForm.folio.$dirty && sipPurchaseForm.folio.$invalid), \'anything-disabled\' : InitiateTransactionSipPurchase.modifySipData}\"><label>Select</label><select class=\"browser-default custom-select select-folio-list\" name=folio ng-model=InitiateTransactionSipPurchase.formData.folioNumber ng-change=InitiateTransactionSipPurchase.changeFolio(true) ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in InitiateTransactionSipPurchase.folioList\" required><option value=\"\" selected>Select Folio</option></select><span ng-show=\"sipPurchaseForm.folio.$dirty && sipPurchaseForm.folio.$invalid\"><span class=error-input ng-show=sipPurchaseForm.folio.$error.required ng-bind=InitiateTransactionSipPurchase.validations.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateTransactionSipPurchase.hasFolioEmailId == false\" ng-bind=InitiateTransactionSipPurchase.validations.FOLIO_EMAIL></span></div></div></div><div class=\"col-md-1 col-xs-12 col-sm-1 form-grid\" ng-if=\"InitiateTransactionSipPurchase.loginType == \'D\' && !InitiateTransactionSipPurchase.corporateFlag && !InitiateTransactionSipPurchase.isModifySip\"><p class=orSipOption>OR</p></div><div class=\"col-md-4 col-xs-12 col-sm-5\" ng-click=InitiateTransactionSipPurchase.newFolioClickAction(); ng-if=\"InitiateTransactionSipPurchase.loginType == \'D\' && !InitiateTransactionSipPurchase.corporateFlag && !InitiateTransactionSipPurchase.isModifySip\"><label class=\"text-blue cursor-pointer\"><strong>Proceed with a New Folio</strong></label></div></div></div><div ng-class=\"{\'anything-disabled\': (!InitiateTransactionSipPurchase.formData.folioNumber||(InitiateTransactionSipPurchase.hasFolioEmailId == false)) }\"><div class=\"normal-wrap clearfix\"><div class=choose-type><table class=\"table table-sipPurchase\"><tr><td>Investment Type</td><td>:</td><td><div class=radio-block ng-class=\"{\'anything-disabled\' : InitiateTransactionSipPurchase.modifySipData || InitiateTransactionSipPurchase.fromQuickSip}\"><span class=radio><input type=radio id=purchase name=investmentType ng-model=InitiateTransactionSipPurchase.formData.investmentType ng-value=InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.PURCHASE ng-change=InitiateTransactionSipPurchase.changeInvestmentType()> <span class=check></span></span><label for=purchase>Purchase</label></div><div class=radio-block><span class=radio><input type=radio id=sip name=investmentType ng-model=InitiateTransactionSipPurchase.formData.investmentType ng-value=InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.SIP ng-change=InitiateTransactionSipPurchase.changeInvestmentType()> <span class=check></span></span><label for=sip>SIP</label></div></td></tr></table><table class=\"table table-custom-sub-fields\" ng-if=!InitiateTransactionSipPurchase.oversea_arn><tr><td>Sub Broker ARN</td><td>:</td><td colspan=2 class=sub-broker-arn><div class=col-md-10><div class=input-normal><input type=text class=arn-no name=subBrokerARNDesk id=subBrokerARNS ng-model=InitiateTransactionSipPurchase.formData.subBrokerARN ng-change=InitiateTransactionSipPurchase.changeSubBrokerArn() ng-blur=InitiateTransactionSipPurchase.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label class=\"sub-broker-arn-label\">Sub Broker ARN</label>--><p ng-if=InitiateTransactionSipPurchase.subBrokerName class=info-primary>Sub Broker Name: {{InitiateTransactionSipPurchase.subBrokerName}}</p><span class=error-input ng-if=\"sipPurchaseForm.subBrokerARNDesk.$dirty && sipPurchaseForm.subBrokerARNDesk.$invalid && sipPurchaseForm.subBrokerARNDesk.$error.pattern\">{{InitiateTransactionSipPurchase.validations.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionSipPurchase.subBrokerCodeError != \'\' && !sipPurchaseForm.subBrokerARNDesk.$invalid && InitiateTransactionSipPurchase.formData.subBrokerARN\" ng-bind=InitiateTransactionSipPurchase.subBrokerCodeError></span></div></div></td><td>Sub Broker Code</td><td>:</td><td colspan=2 class=sub-broker-code><div class=col-md-10><div class=input-normal ng-class={error:sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionSipPurchase.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionSipPurchase.formData.subBrokerARN || InitiateTransactionSipPurchase.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$error.required ng-bind=InitiateTransactionSipPurchase.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-custom-sub-fields-mobile\" ng-if=!InitiateTransactionSipPurchase.oversea_arn><tr><td>Sub Broker ARN</td><td>:</td><td class=sub-broker-arn><div class=col-sm-12><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionSipPurchase.formData.subBrokerARN ng-change=InitiateTransactionSipPurchase.changeSubBrokerArn() ng-blur=InitiateTransactionSipPurchase.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                      <label>Sub Broker ARN</label>--><p ng-if=InitiateTransactionSipPurchase.subBrokerName class=info-primary>Sub Broker Name: {{InitiateTransactionSipPurchase.subBrokerName}}</p><span class=error-input ng-if=\"sipPurchaseForm.subBrokerARN.$dirty && sipPurchaseForm.subBrokerARN.$invalid && sipPurchaseForm.subBrokerARN.$error.pattern\">{{InitiateTransactionSipPurchase.validations.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionSipPurchase.subBrokerCodeError != \'\'\" ng-bind=InitiateTransactionSipPurchase.subBrokerCodeError></span></div></div></td></tr><tr><td>Sub Broker Code</td><td>:</td><td class=sub-broker-code><div class=col-sm-12><div class=input-normal ng-class={error:sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionSipPurchase.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionSipPurchase.formData.subBrokerARN || InitiateTransactionSipPurchase.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=sipPurchaseForm.subBrokerCode.$dirty&&sipPurchaseForm.subBrokerCode.$error.required ng-bind=InitiateTransactionSipPurchase.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-sipPurchase\"><tr ng-if=!InitiateTransactionSipPurchase.oversea_arn><td class=sip-purchase-euin>EUIN</td><td>:</td><td><div class=\"col-md-4 col-sm-6 input-euin\"><div class=\"input-select input-normal selectfield select-euin drop-arrow\"><select class=\"browser-default custom-select arrow-adjust-css\" name=selectEuin ng-change=InitiateTransactionSipPurchase.euinChanged() ng-model=InitiateTransactionSipPurchase.formData.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in InitiateTransactionSipPurchase.euinList\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=\"req text-red\">*</span></div></div></td></tr><tr ng-if=\"InitiateTransactionSipPurchase.formData.euinOpted === InitiateTransactionSipPurchase.EUIN_OPTED.NO && !InitiateTransactionSipPurchase.oversea_arn\"><td>&nbsp;</td><td>&nbsp;</td><td><div class=\"col-md-12 self-declaration\"><span class=checkbox><input type=checkbox name=TandC value=true ng-model=InitiateTransactionSipPurchase.TandC required> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr></table></div><div class=sip-form-box ng-if=\"InitiateTransactionSipPurchase.formData.investmentType===InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.SIP\"><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Add a SIP Scheme</strong></label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=sipScheme1 ng-change=InitiateTransactionSipPurchase.filterSipSchemeList() ng-model=InitiateTransactionSipPurchase.formData.inSchemeName autocomplete=off ng-paste=$event.preventDefault(); ondrop=\"return false\" required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSipPurchase.sipSchemeList display-key=scheme hdfc-click=InitiateTransactionSipPurchase.selectSipScheme(data) model=InitiateTransactionSipPurchase.formData.inSchemeCode for=sipScheme1></drop-down></div></div></div><div class=align-scheme-select-option><div class=\"col-md-1 form-grid mgt50 clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid mgt50 inline-style\"><a ng-click=InitiateTransactionSipPurchase.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:((InitiateTransactionSipPurchase.isMinSipAmount && InitiateTransactionSipPurchase.formData.installmentAmount)\n                                || (!InitiateTransactionSipPurchase.isMinSipAmount && InitiateTransactionSipPurchase.formData.installmentAmount && (InitiateTransactionSipPurchase.sipValidations.amountMultiples&&!InitiateTransactionSipPurchase.isMultiples))\n                                ||(InitiateTransactionSipPurchase.isOtmLimitLess && InitiateTransactionSipPurchase.formData.installmentAmount))}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel ng-change=\"InitiateTransactionSipPurchase.changeSipAmount(sipPurchaseForm, true); InitiateTransactionSipPurchase.checkUpiError();\" ng-model-options=\"{debounce: 100}\" name=installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords392\')\" ng-model=InitiateTransactionSipPurchase.formData.installmentAmount autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>SIP Amount</label><span class=error-input ng-if=\"InitiateTransactionSipPurchase.isOtmLimitLess && sipPurchaseForm.installmentAmount.$valid &&\n                    !InitiateTransactionSipPurchase.isMinSipAmount\">{{\'Amount should not be greater than OTM Limit(\'+ InitiateTransactionSipPurchase.otmBankLimit+\')\'}} </span><span class=amount-error ng-if=\"(InitiateTransactionSipPurchase.isMinSipAmount && InitiateTransactionSipPurchase.formData.installmentAmount)\" class=error-input>{{\'Minimum amount should be &#8377; \'+ InitiateTransactionSipPurchase.sipValidations.minAmount}} </span><!--                  <span class=\"amount-error\"--><!--                        ng-if=\"( InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.isEmandateMaxLimit && InitiateTransactionSipPurchase.formData.installmentAmount)\"--><!--                        class=\"error-input\">{{\'SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode\'}}--><!--                </span>--> <span ng-if=\"sipPurchaseForm.installmentAmount.$invalid && sipPurchaseForm.installmentAmount.$error.number\" class=error-input>{{InitiateTransactionSipPurchase.VALIDATE_DATA.INVALID_AMOUNT}} </span><span ng-if=\"sipPurchaseForm.installmentAmount.$dirty && sipPurchaseForm.installmentAmount.$error.required\" class=error-input>{{InitiateTransactionSipPurchase.validations.AMOUNT_REQUIRED}} </span><span ng-if=\"sipPurchaseForm.installmentAmount.$valid && !InitiateTransactionSipPurchase.isMinSipAmount &&\n                          (InitiateTransactionSipPurchase.sipValidations.amountMultiples&&!InitiateTransactionSipPurchase.isMultiples) && !InitiateTransactionSipPurchase.amountExceeded\" class=error-input>Please Provide In multiples of &#8377; {{InitiateTransactionSipPurchase.sipValidations.amountMultiples|unit}} </span><span class=amount-error ng-if=\"sipPurchaseForm.installmentAmount.$valid && InitiateTransactionSipPurchase.amountExceeded\">{{InitiateTransactionSipPurchase.validations.AMOUNT_EXCEEDED}}</span><div ng-if=InitiateTransactionSipPurchase.formData.installmentAmount class=amount-in-words><span>(In Words)&nbsp;</span><div id=divDisplayWords392></div></div></div></div><div class=\"col-sm-offset-3 amount-button-container\" ng-if=InitiateTransactionSipPurchase.formData.inSchemeCode ng-class=\"{\'incase-of-amtExceed\' : InitiateTransactionSipPurchase.amountExceeded}\"><button class=btn-sip-first-install-action type=button ng-repeat=\"amount in InitiateTransactionSipPurchase.sipFirstInstallmentAmount\" ng-click=\"InitiateTransactionSipPurchase.formData.installmentAmount=amount; InitiateTransactionSipPurchase.changeSipAmount(sipPurchaseForm, true); InitiateTransactionSipPurchase.checkUpiError();\"><div class=img-and-amt-block><img src=../../assets/images/icons/rupee-white.png>{{amount}}</div></button></div></div><div class=row ng-if=\"InitiateTransactionSipPurchase.sipValidations && !InitiateTransactionSipPurchase.sipValidations.isGrowth\"><div class=\"col-md-12 form-grid\"><div class=install-freq><p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p><div class=\"col-md-6 radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.sipValidationsData.dividendReinvestmentApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=sReinvest ng-model=InitiateTransactionSipPurchase.formData.dividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"InitiateTransactionSipPurchase.sipValidationsData.dividendReinvestmentApplicable === false\" name=sDividendOption> <span class=check></span></span><label class=radio-flex-label for=sReinvest>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=\"col-md-6 radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.sipValidationsData.dividendPayoutApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=sPayout ng-model=InitiateTransactionSipPurchase.formData.dividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"InitiateTransactionSipPurchase.sipValidationsData.dividendPayoutApplicable === false\" name=sDividendOption> <span class=check></span></span><label class=radio-flex-label for=sPayout>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div></div><div class=row><div class=\"col-md-6 form-grid\" style=padding-top:24px><div class=\"install-freq frequency\"><p><strong>Installment Frequency</strong></p><div ng-if=InitiateTransactionSipPurchase.selectedFrequency class=radio-block ng-repeat=\"freq in InitiateTransactionSipPurchase.SIP_FREQ_LIST\" ng-class=\"{\'anything-disabled\': freq.code === \'BZ\' && InitiateTransactionSipPurchase.hideOtmRadio}\"><span class=radio ng-if=freq.name><input type=radio id={{freq.name}} ng-change=\"InitiateTransactionSipPurchase.changeFrequency(sipPurchaseForm, \'fromHtml\'); InitiateTransactionSipPurchase.checkUpiError();\" ng-model=InitiateTransactionSipPurchase.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.name}}>{{freq.name}}</label><i class=\"tooltip-info-icon base-tooltip\" ng-if=\"freq.code === \'BZ\'\" tooltip data-toggle=tooltip data-placement=right title=\"Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented.\n                       SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP. Daily SIP end date can be only on a business day.\"></i></div></div></div></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.inSchemeName &&\n              InitiateTransactionSipPurchase.selectedFrequency.code !== \'BZ\'\"><div class=col-md-6><div class=\"install-freq frequency sip-fi\"><label><strong>Do you wish to pay First Installment with your SIP Registration:</strong></label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=InitiateTransactionSipPurchase.formData.sipFirstInstallment ng-change=\"InitiateTransactionSipPurchase.changeFirstInstallment(true); InitiateTransactionSipPurchase.checkUpiError();\" ng-value=true> <span class=check></span></span><label>Yes</label></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=InitiateTransactionSipPurchase.formData.sipFirstInstallment ng-change=\"InitiateTransactionSipPurchase.changeFirstInstallment(false); InitiateTransactionSipPurchase.checkUpiError();\" ng-value=false> <span class=check></span></span><label>No</label></div></div></div></div><!--SIP Payment start here--><div class=row><div class=\"col-md-8 pay-mode width100\"><div><p><strong>Payment Mode Selection for SIP Registration</strong></p><p ng-if=\"InitiateTransactionSipPurchase.PAYMENT_MODE.length==0\" class=\"payment-error-message no_payment_text\"><strong>No valid payment mode available to proceed with SIP transaction</strong></p><div class=radio-block ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && payMode.value ===\'Register E-mandate (eOTM)\')\" ng-repeat=\"payMode in InitiateTransactionSipPurchase.PAYMENT_MODE\"><span ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ===\'Standing Instruction/Biller\')\" class=radio><input type=radio id={{payMode.value}} ng-change=\"InitiateTransactionSipPurchase.changePaymentMode(); InitiateTransactionSipPurchase.checkUpiError();\" ng-model=InitiateTransactionSipPurchase.formData.paymentMode ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') || !(InitiateTransactionSipPurchase.formData.minorFlag && payMode.value ==\'Register E-mandate (eOTM)\')\" ng-value=payMode name=paymentMode required> <span class=check></span></span><label ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\')\" for={{payMode.value}}>{{payMode.value}}</label><div ng-if=\"payMode.value == \'Net Banking\' && InitiateTransactionSipPurchase.formData.paymentMode.value === \'Net Banking\'\"><div class=point-to-note-tpv>Please Note:<br><ul><li>Investor will be shown only the banks registered against the selected folio at the time of payment via Net Banking.</li><li>The list of banks available for registration in the folio has been restricted to only those banks which provide Third Party Verification(TPV) facility. <a ng-click=InitiateTransactionSipPurchase.tpv($event) href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</li></ul></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\'\"><select class=\"browser-default custom-select\" name=upiBank ng-model=InitiateTransactionSipPurchase.formData.upiBank ng-change=InitiateTransactionSipPurchase.changeUpiBank() ng-options=\"item as (item.bankName) for item in InitiateTransactionSipPurchase.upiBankListForSIP\" ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\'\" ng-init=\"InitiateTransactionSipPurchase.formData.upiBank = InitiateTransactionSipPurchase.formData.upiBank ? InitiateTransactionSipPurchase.formData.upiBank : null\"><option value=\"\" selected>Select UPI Bank - Account Number</option></select></div></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\" ng-class=\"{error: (sipPurchaseForm.otmBank.$invalid && sipPurchaseForm.otmBank.$dirty)\n                         || InitiateTransactionSipPurchase.otmLimitvalidation\n                         || InitiateTransactionSipPurchase.endDateValidation\n                         || (InitiateTransactionSipPurchase.formData.otmBank\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.code === \'BZ\')}\"><input type=text name=bank id=otmBank ng-model=InitiateTransactionSipPurchase.formData.otmBank.bankName ng-change=InitiateTransactionSipPurchase.changeOtmbank() ng-init=\"InitiateTransactionSipPurchase.formData.otmBank = InitiateTransactionSipPurchase.formData.otmBank ? InitiateTransactionSipPurchase.formData.otmBank : null\" autocomplete=off ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\" only-alphabets required> <span class=highlight></span> <span class=bar></span><label>Select Bank</label><bank-drop-down list-data=InitiateTransactionSipPurchase.otmBankList display-key=bankName display-key-second=bankAcNo hdfc-click=InitiateTransactionSipPurchase.changeOtmbank() model=InitiateTransactionSipPurchase.formData.otmBank for=otmBank></bank-drop-down><span ng-show=\"sipPurchaseForm.otmBank.$dirty && sipPurchaseForm.otmBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.otmBank.$error.required ng-bind=InitiateTransactionSipPurchase.validations.BLANK_BANK_INFO></span></span></div></div></div><!--SIP with FI payment starts from here --><div class=row ng-if=InitiateTransactionSipPurchase.formData.sipFirstInstallment><div class=\"col-md-8 pay-mode width100\"><div><p><strong>Payment Mode Selection for First Installment of SIP</strong></p><div class=radio-block ng-repeat=\"payMode in InitiateTransactionSipPurchase.sipFirstInstallmentPaymentMode\" ng-if=!InitiateTransactionSipPurchase.UpiSelectedFI><span ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag &&\n                      !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ===\'Standing Instruction/Biller\')\" class=radio><input type=radio ng-model=InitiateTransactionSipPurchase.formData.fiPaymentMode ng-change=InitiateTransactionSipPurchase.changedFiPaymentMode() ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') || !(InitiateTransactionSipPurchase.formData.minorFlag && payMode.value ==\'Register E-mandate (eOTM)\')\" ng-value=payMode name=fiPaymentMode required> <span class=check></span></span><label ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && payMode.value ==\'Standing Instruction/Biller\') \" for={{payMode.value}}>{{payMode.value}}</label></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'OTM\'\" ng-class=\"{error: (sipPurchaseForm.fiOtmBank.$invalid && sipPurchaseForm.fiOtmBank.$dirty)\n                         || InitiateTransactionSipPurchase.otmLimitvalidation\n                         || InitiateTransactionSipPurchase.endDateValidation\n                         || (InitiateTransactionSipPurchase.formData.fiOtmBank\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.key === \'BZ\')}\"><select class=\"browser-default custom-select\" name=fiOtmBank ng-model=InitiateTransactionSipPurchase.formData.fiOtmBank ng-change=InitiateTransactionSipPurchase.changeOtmbank() ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateTransactionSipPurchase.otmBankList\" ng-required=\"InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'OTM\'\"><option value=\"\" selected>Select OTM Bank - Account Number</option></select><span ng-show=\"sipPurchaseForm.fiOtmBank.$dirty && sipPurchaseForm.fiOtmBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.fiOtmBank.$error.required ng-bind=InitiateTransactionSipPurchase.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=col-md-6><table class=\"table borderless\" ng-if=\"InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'OTM\' &&\n                      InitiateTransactionSipPurchase.formData.fiOtmBank\n                      && InitiateTransactionSipPurchase.otmBankList.length\"><tr><td>OTM Bank Name</td><td>: {{InitiateTransactionSipPurchase.formData.fiOtmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td>: {{InitiateTransactionSipPurchase.formData.fiOtmBank.omStartDate}} <span class=error-input ng-show=\"InitiateTransactionSipPurchase.startDateValidationForFi && InitiateTransactionSipPurchase.formData.fiOtmBank && InitiateTransactionSipPurchase.formData.fiOtmBank.currentDate\" ng-if=InitiateTransactionSipPurchase.formData.fiOtmBank>Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.fiOtmBank.omStartDate}}</span></td></tr><tr><td>OTM Maturity Date</td><td>: {{InitiateTransactionSipPurchase.formData.fiOtmBank.omExpiryDate}} <span ng-if=\"InitiateTransactionSipPurchase.fiendDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.fiOtmBank\" class=error-input><!-- Otm end date should be on or before selected end date.--> Selected date is greater than OTM expiry date.</span></td></tr><tr><td>OTM Instruction Type</td><td>: {{InitiateTransactionSipPurchase.formData.fiOtmBank.otmFrequencyName ? InitiateTransactionSipPurchase.formData.fiOtmBank.otmFrequencyName : InitiateTransactionSipPurchase.formData.fiOtmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td>: <i class=rupee-icon ng-if=InitiateTransactionSipPurchase.formData.fiOtmBank.maxAmount></i>{{InitiateTransactionSipPurchase.formData.fiOtmBank.maxAmount}} <span ng-if=InitiateTransactionSipPurchase.fiOtmLimitvalidation class=error-input><!--Otm account limit should be greater than or equal the investment amount.--> SIP amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed</span></td></tr></table></div></div><div class=row><div class=col-md-4 ng-class=\"{\'anything-disabled\' : InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\'}\" ng-if=!InitiateTransactionSipPurchase.UpiSelectedFI><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'UPI\'\"><select class=\"browser-default custom-select\" name=upiBank ng-model=InitiateTransactionSipPurchase.formData.upiBank ng-change=InitiateTransactionSipPurchase.changeUpiBank() ng-options=\"item as (item.bankName) for item in InitiateTransactionSipPurchase.upiBankListForSIP\" ng-required=\"InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'UPI\'\" ng-init=\"InitiateTransactionSipPurchase.formData.upiBank = InitiateTransactionSipPurchase.formData.upiBank ? InitiateTransactionSipPurchase.formData.upiBank : null\"><option value=\"\" selected>Select UPI Bank - Account Number</option></select></div></div></div></div></div></div><!--SIP with FI Payment end here--></div><div ng-if=\"InitiateTransactionSipPurchase.formData.sipFirstInstallment && InitiateTransactionSipPurchase.UpiSelectedFI\"><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicDataForFIUPI.content></ng-bind-html></div><div class=row><div class=\"col-md-8 width100\"><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'EC\' && !InitiateTransactionSipPurchase.formData.fiPaymentMode\"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteStandard.content></ng-bind-html></div><div class=\"point-to-note-tpv-approval ng-scope\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key == \'OTM\' && !InitiateTransactionSipPurchase.formData.fiPaymentMode \"><!--dynamic content for OTM--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteOtmSip.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key == \'UPI\' && !InitiateTransactionSipPurchase.formData.fiPaymentMode \"><!--dynamic content for UPI--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteSIPUPI.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'EC\' && InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'OTM\'  \"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteSIOTM.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'EC\' && InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'WEB\'  \"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteSIWEB.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\' && InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'WEB\'  \"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteOTMWEB.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\' && InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'OTM\'  \"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteOTMOTM.content></ng-bind-html></div><div ng-if=\"(!InitiateTransactionSipPurchase.formData.paymentMode.key && InitiateTransactionSipPurchase.PAYMENT_MODE.length ==0) && !InitiateTransactionSipPurchase.formData.fiPaymentMode\"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteStandard.content></ng-bind-html></div><div ng-if=\"(!InitiateTransactionSipPurchase.formData.paymentMode.key && InitiateTransactionSipPurchase.PAYMENT_MODE.length ==0) && InitiateTransactionSipPurchase.formData.fiPaymentMode.key === \'WEB\'  \"><!--dynamic standard note for sip--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteSIWEB.content></ng-bind-html></div><div class=emandate-section ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.emandateDisplay && InitiateTransactionSipPurchase.eMandateBankList.length > 0 && !(InitiateTransactionSipPurchase.formData.minorFlag) && InitiateTransactionSipPurchase.emandateValidationData\"><div class=row><div class=\"col-md-3 label-emandate\">Select Bank</div><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error: (sipPurchaseForm.eMandateBank.$invalid && sipPurchaseForm.eMandateBank.$dirty)}\"><input type=text name=bank id=bank ng-model=InitiateTransactionSipPurchase.formData.eMandateBank.bankNameOnly ng-change=InitiateTransactionSipPurchase.changeEMandateBank() ng-init=\"InitiateTransactionSipPurchase.formData.eMandateBank = InitiateTransactionSipPurchase.formData.eMandateBank ? InitiateTransactionSipPurchase.formData.eMandateBank : null\" autocomplete=off ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\'\" only-alphabets required readonly> <span class=highlight></span> <span class=bar></span><label ng-if=!InitiateTransactionSipPurchase.formData.eMandateBank.bankNameOnly>Select Bank</label><bank-drop-down list-data=InitiateTransactionSipPurchase.eMandateBankList display-key=bankNameOnly display-key-second=accountNumber hdfc-click=InitiateTransactionSipPurchase.changeEMandateBank() model=InitiateTransactionSipPurchase.formData.eMandateBank for=bank></bank-drop-down><span ng-show=\"sipPurchaseForm.eMandateBank.$dirty && sipPurchaseForm.eMandateBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.eMandateBank.$error.required ng-bind=InitiateTransactionSipPurchase.validations.BLANK_BANK_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Authentication Mode</div><div class=\"col-sm-12 col-md-3\"><div class=\"input-select input-normal selectfield\" ng-class=\"{error: (sipPurchaseForm.authMode.$invalid && sipPurchaseForm.authMode.$dirty)}\"><select class=\"browser-default custom-select\" name=authMode ng-model=InitiateTransactionSipPurchase.authMode ng-options=\"item.text for item in InitiateTransactionSipPurchase.formData.eMandateBank.authenticationModes\" ng-change=InitiateTransactionSipPurchase.changeEotmNotes() ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\'\"><option value=\"\" selected>Select Authentication mode</option></select><span ng-show=\"sipPurchaseForm.authMode.$dirty && sipPurchaseForm.authMode.$invalid\"><span class=error-input ng-show=sipPurchaseForm.authMode.$error.required ng-bind=InitiateTransactionSipPurchase.validations.BLANK_AUTH_MODE_INFO></span></span></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Amount</div><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateTransactionSipPurchase.tForm.eAmount.$invalid && InitiateTransactionSipPurchase.tForm.eAmount.$dirty),\'has-data\':InitiateTransactionSipPurchase.formData.emandateAmount}\"><input class=input-min type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=InitiateTransactionSipPurchase.formData.emandateAmount ng-change=InitiateTransactionSipPurchase.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><div class=amtWords ng-if=InitiateTransactionSipPurchase.formData.emandateAmount><p id=amountInwordsEmandate>{{InitiateTransactionSipPurchase.formData.emandateWord.amountInWords}} (In Words)</p></div><!--                        <span class=\"text-success\">--><!--                          Maximum allowed for e-mandate is ₹ {{InitiateTransactionSipPurchase.mandateMaxString}}.--><!--                        </span>--><div class=error-input ng-show=\"InitiateTransactionSipPurchase.amountLess && InitiateTransactionSipPurchase.formData.emandateAmount\">{{InitiateTransactionSipPurchase.validations.EMANDATE_MIN_ERROR + InitiateTransactionSipPurchase.emandateMinAmountLimit}}.</div><div class=error-input ng-show=InitiateTransactionSipPurchase.amountMore>{{InitiateTransactionSipPurchase.validations.EMANDATE_MAX_ERROR + InitiateTransactionSipPurchase.mandateMaxString}}.</div><div class=error-input ng-show=\"!InitiateTransactionSipPurchase.amountLess && InitiateTransactionSipPurchase.isLessThanSipAmount\" ng-bind=InitiateTransactionSipPurchase.validations.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!InitiateTransactionSipPurchase.formData.emandateAmount ng-bind=InitiateTransactionSipPurchase.validations.MANDATE_AMOUNT_REQUIRED></div></div></div></div><div class=row><div class=\"col-md-3 label-emandate\">Mandate Start Date</div><div class=\"col-md-3 anything-disabled\" ng-if=!InitiateTransactionSipPurchase.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode={{InitiateTransactionSipPurchase.viewMode}} data-date-default=InitiateTransactionSipPurchase.formData.emandateDate id=emandateStartDate data-enable=true data-on-date-change=InitiateTransactionSipPurchase.changeDateEmandate style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><div class=\"row mandateDates\"><div class=\"col-md-3 label-emandate\">Mandate End Date <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{InitiateTransactionSipPurchase.mandateInfo}} tooltip-side=right></i></div><div class=\"sip-dates col-md-3\"><div ng-class=\"{\'anything-disabled\': !InitiateTransactionSipPurchase.formData.emandateDate}\"><div class=form-group ng-if=!InitiateTransactionSipPurchase.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:InitiateTransactionSipPurchase.tForm.endDateEmandate.$dirty && InitiateTransactionSipPurchase.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateTransactionSipPurchase.formData.endDateEmandate data-enabled-dates=InitiateTransactionSipPurchase.enabledEmandateEndDatesList data-view-date=InitiateTransactionSipPurchase.enabledEndDateView data-max-date=InitiateTransactionSipPurchase.maxEndDateEmandate data-min-date=InitiateTransactionSipPurchase.minEndDateEmandate data-on-date-change=InitiateTransactionSipPurchase.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><!-- data-min-date=\"InitiateTransactionSipPurchase.formData.minEndDate\"--> <input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div></div></div><div class=row><div class=\"col-sm-12 col-md-12\" ng-if=\"(InitiateTransactionSipPurchase.isEmailinValid || InitiateTransactionSipPurchase.isEmailMobileinValid || InitiateTransactionSipPurchase.isMobileinValid) && (InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\')\"><div style=width:55%><span class=error-input ng-show=InitiateTransactionSipPurchase.isMobileinValid ng-bind=InitiateTransactionSipPurchase.validations.INVALID_MOBILE_EMANDATE></span> <span class=error-input ng-show=InitiateTransactionSipPurchase.isEmailinValid ng-bind=InitiateTransactionSipPurchase.validations.INVALID_EMAIL_EMANDATE></span> <span class=error-input ng-show=InitiateTransactionSipPurchase.isEmailMobileinValid ng-bind=InitiateTransactionSipPurchase.validations.INVALID_EMAIL_MOBILE_EMANDATE></span></div></div></div><div ng-if=!(InitiateTransactionSipPurchase.formData.minorFlag)><!--note--><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.emandateDisplay && InitiateTransactionSipPurchase.eMandateBankList.length > 0\"><!--dynamic note for eotm--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteEotm.content></ng-bind-html></div></div><div class=row><div class=col-md-6><table class=\"table borderless\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\' &&\n                      InitiateTransactionSipPurchase.formData.otmBank\n                      && InitiateTransactionSipPurchase.otmBankList.length\"><tr><td>OTM Bank Name</td><td>: {{InitiateTransactionSipPurchase.formData.otmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td>: {{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}} <span class=error-input ng-show=\"InitiateTransactionSipPurchase.startDateValidation && InitiateTransactionSipPurchase.formData.startDate\" ng-if=InitiateTransactionSipPurchase.formData.otmBank>Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}}</span></td></tr><tr><td>OTM Maturity Date</td><td>: {{InitiateTransactionSipPurchase.formData.otmBank.omExpiryDate}} <span ng-if=\"InitiateTransactionSipPurchase.endDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.otmBank\" class=error-input><!-- Otm end date should be on or before selected end date.--> Selected date is greater than OTM expiry date.</span></td></tr><tr><td>OTM Instruction Type</td><td>: {{InitiateTransactionSipPurchase.formData.otmBank.otmFrequencyName ? InitiateTransactionSipPurchase.formData.otmBank.otmFrequencyName : InitiateTransactionSipPurchase.formData.otmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td>: <i class=rupee-icon ng-if=InitiateTransactionSipPurchase.formData.otmBank.maxAmount></i>{{InitiateTransactionSipPurchase.formData.otmBank.maxAmount}} <span ng-if=InitiateTransactionSipPurchase.otmLimitvalidation class=error-input><!--Otm account limit should be greater than or equal the investment amount.--> SIP amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed</span></td></tr></table></div></div></div></div><!--SIP Payment end here--><div ng-if=\"((InitiateTransactionSipPurchase.formData.paymentMode.key === InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.OTM) || (InitiateTransactionSipPurchase.formData.paymentMode.key===InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM) || (InitiateTransactionSipPurchase.formData.paymentMode.key===InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.EC) || (InitiateTransactionSipPurchase.formData.paymentMode.key===InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.UPI)) && InitiateTransactionSipPurchase.selectedFrequency.code === \'OW\'\"><div class=\"row form-group\"><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:InitiateTransactionSipPurchase.tForm.day.$dirty && InitiateTransactionSipPurchase.tForm.day.$invalid}\"><label ng-if=InitiateTransactionSipPurchase.formData.weeklyDay>Select Day</label><select class=custom-select name=day ng-model=InitiateTransactionSipPurchase.formData.weeklyDay ng-change=InitiateTransactionSipPurchase.changeDay() ng-options=\"day as day for day in InitiateTransactionSipPurchase.daysList\" ng-init=\"InitiateTransactionSipPurchase.formData.weeklyDay=InitiateTransactionSipPurchase.formData.weeklyDay?InitiateTransactionSipPurchase.formData.weeklyDay: null\" required><option value=\"\" selected>Select Day</option></select><span class=error-input ng-show=\"InitiateTransactionSipPurchase.tForm.day.$dirty && InitiateTransactionSipPurchase.tForm.day.$error.required\" ng-bind=InitiateTransactionSipPurchase.VALIDATE_DATA.DAY_REQUIRED></span></div></div></div><div class=row><div class=\"col-md-4 radio-values\" ng-class=\"{\'anything-disabled\':!InitiateTransactionSipPurchase.formData.weeklyDay || !InitiateTransactionSipPurchase.formData.inSchemeCode}\" ng-if=!InitiateTransactionSipPurchase.resetting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal sipStartCal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-enabled-dates=InitiateTransactionSipPurchase.enabledStartDates data-date-default=InitiateTransactionSipPurchase.formData.startDate data-min-date=InitiateTransactionSipPurchase.startMinDateOTM data-max-date=InitiateTransactionSipPurchase.startMaxDate data-on-date-change=InitiateTransactionSipPurchase.changeStartDate id=weeklyStartDate><!--data-max-date=\"InitiateTransactionSipPurchase.maxStartDate\"--><!--data-min-date=\"InitiateTransactionSipPurchase.minStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><!--                    <span class=\"error-message-sip-start\" style=\"margin: 8px 0 0 -18px;\" ng-show=\"InitiateTransactionSipPurchase.startDateValidation\" ng-if=\"InitiateTransactionSipPurchase.formData.otmBank\">--><!--                         Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}}--><!--                    </span>--></div></div></div><div class=row><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionSipPurchase.resetting ng-class=\"{\'anything-disabled\':!InitiateTransactionSipPurchase.formData.weeklyDay && !InitiateTransactionSipPurchase.formData.startDate}\"><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-enabled-dates=InitiateTransactionSipPurchase.enabledEndDates data-date-default=InitiateTransactionSipPurchase.formData.endDate data-max-date=\"InitiateTransactionSipPurchase.enabledEndDates[InitiateTransactionSipPurchase.enabledEndDates.length -1]\" data-view-date=InitiateTransactionSipPurchase.enabledEndDateView data-min-date=InitiateTransactionSipPurchase.minEndDateForWeekly data-on-date-change=InitiateTransactionSipPurchase.changeEndDate showdefault=false id=weeklyEndDate><input type=text name=selectEndDate ng-disabled=InitiateTransactionSipPurchase.isTillPerpetuity id=endDateCalenderWeekly autocomplete=off class=form-control placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-model=InitiateTransactionSipPurchase.formData.endDate required readonly> <span class=input-group-addon ng-click=InitiateTransactionSipPurchase.handleMandateCalender()><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><!--                    <span--><!--                      ng-if=\"InitiateTransactionSipPurchase.endDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.otmBank\"--><!--                      class=\"error-message-sip-end\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                        Selected date is greater than OTM expiry date.--><!--                      </span>--> <span style=\"word-spacing: -1px\" class=error-message-sip-end ng-show=\"InitiateTransactionSipPurchase.formData.paymentMode.key===InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM && InitiateTransactionSipPurchase.sipDateLessEmandate\" ng-bind=InitiateTransactionSipPurchase.validations.EMANDATE_DATE_EXCEED_ERROR></span></div></div><div class=\"col-md-1 form-grid text-center optional-or\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=text-uppercase>or</span></div><div class=\"col-md-4 form-grid\" ng-class=\"{\'anything-disabled\':!InitiateTransactionSipPurchase.formData.weeklyDay && !InitiateTransactionSipPurchase.formData.startDate}\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=weeklyDefaultDate name=endDateOption ng-model=InitiateTransactionSipPurchase.endDateSelectionOption ng-change=InitiateTransactionSipPurchase.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span class=default-date><strong>Choose Default End Date, which is 2099</strong></span></div></div></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key != \'OTM\' && InitiateTransactionSipPurchase.selectedFrequency.code !== \'OW\'  && (InitiateTransactionSipPurchase.formData.paymentMode.key != \'UPI\' && InitiateTransactionSipPurchase.selectedFrequency.code !== \'OW\')\" ng-class=\"{\'anything-disabled\' : !InitiateTransactionSipPurchase.formData.inSchemeCode}\"><div class=row><p class=\"col-md-12 pay-mode\"><strong>Installment Date Details</strong></p><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionSipPurchase.resetting><!-- && InitiateTransactionSipPurchase.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode={{InitiateTransactionSipPurchase.viewMode}} data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-date-default=InitiateTransactionSipPurchase.formData.startDate data-enabled-dates=InitiateTransactionSipPurchase.enabledBillerStartDatesList data-min-date=InitiateTransactionSipPurchase.startMinDateBiller data-max-date=InitiateTransactionSipPurchase.startMaxDate data-on-date-change=InitiateTransactionSipPurchase.changeStartDate id=startDate-biller><!--data-min-date=\"InitiateTransactionSipPurchase.minStartDate\"--><!--data-max-date=\"InitiateTransactionSipPurchase.maxStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><!--                    <span class=\"error-message-sip-start\" style=\"margin: 8px 0 0 -18px;\" ng-show=\"InitiateTransactionSipPurchase.startDateValidation\" ng-if=\"InitiateTransactionSipPurchase.formData.fiOtmBank\">--><!--                         Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.fiOtmBank.omStartDate}}--><!--                    </span>--></div></div></div><!--For Sip End Date--><div class=row><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionSipPurchase.resetting><!-- && InitiateTransactionSipPurchase.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-enabled-dates=InitiateTransactionSipPurchase.enabledEndDates data-date-default=InitiateTransactionSipPurchase.formData.endDate data-min-date=InitiateTransactionSipPurchase.minEndDate data-max-date=InitiateTransactionSipPurchase.maxEndDate data-view-date=InitiateTransactionSipPurchase.enabledEndDateView data-on-date-change=InitiateTransactionSipPurchase.changeEndDate showdefault=false id=endDate-Biller><!----> <input type=text name=selectEndDate ng-disabled=InitiateTransactionSipPurchase.isTillPerpetuity id=endDateCalender autocomplete=off class=form-control placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-model=InitiateTransactionSipPurchase.formData.endDate required readonly> <span class=input-group-addon ng-click=InitiateTransactionSipPurchase.handleMandateCalender()><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px\" class=error-message-sip-end ng-show=\"InitiateTransactionSipPurchase.formData.paymentMode.key===InitiateTransactionSipPurchase.TRANSACTIONS_CONST.PAYMENT_OPTIONS.HEM && InitiateTransactionSipPurchase.sipDateLessEmandate\" ng-bind=InitiateTransactionSipPurchase.validations.EMANDATE_DATE_EXCEED_ERROR></span><!--                    <span--><!--                      ng-if=\"InitiateTransactionSipPurchase.fiendDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.fiOtmBank\"--><!--                      class=\"error-message-sip-end\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                        Selected date is greater than OTM expiry date.--><!--                      </span>--></div></div><div class=\"col-md-1 form-grid text-center optional-or\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=text-uppercase>or</span></div><div class=\"col-md-4 form-grid\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=default-end-date name=endDateOption ng-model=InitiateTransactionSipPurchase.endDateSelectionOption ng-change=InitiateTransactionSipPurchase.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span class=default-date><strong>Choose Default End Date, which is 2099</strong></span></div></div></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'&& InitiateTransactionSipPurchase.selectedFrequency.code !== \'OW\' || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\' && InitiateTransactionSipPurchase.selectedFrequency.code !== \'OW\')\"><div class=row><p class=\"col-md-12 pay-mode\"><strong>Installment Date Details</strong></p><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionSipPurchase.resetting><!--&& InitiateTransactionSipPurchase.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal sipStartCal\" date-calendar data-enable=true data-viewmode={{InitiateTransactionSipPurchase.viewMode}} data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-enabled-dates=InitiateTransactionSipPurchase.enabledOTMStartDatesList data-date-default=InitiateTransactionSipPurchase.formData.startDate data-min-date=InitiateTransactionSipPurchase.startMinDateOTM data-max-date=InitiateTransactionSipPurchase.startMaxDate data-on-date-change=InitiateTransactionSipPurchase.changeStartDate id=startDate-otm><!--data-max-date=\"InitiateTransactionSipPurchase.maxStartDate\"--><!--data-min-date=\"InitiateTransactionSipPurchase.minStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><!--                    <span class=\"error-message-sip-start\" style=\"margin: 8px 0 0 -18px;\" ng-show=\"InitiateTransactionSipPurchase.startDateValidation\" ng-if=\"InitiateTransactionSipPurchase.formData.otmBank\">--><!--                         Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}}--><!--                    </span>--></div></div></div><!--For Sip End Date--><div class=row><div class=\"col-md-4 radio-values\" ng-if=!InitiateTransactionSipPurchase.resetting><!-- && InitiateTransactionSipPurchase.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionSipPurchase.startDateFormat}} data-enabled-dates=InitiateTransactionSipPurchase.enabledEndDates data-date-default=InitiateTransactionSipPurchase.formData.endDate data-min-date=InitiateTransactionSipPurchase.minEndDate data-max-date=InitiateTransactionSipPurchase.maxEndDate data-view-date=InitiateTransactionSipPurchase.enabledEndDateView data-on-date-change=InitiateTransactionSipPurchase.changeEndDate showdefault=false id=endDate><!----> <input type=text name=selectEndDate ng-disabled=InitiateTransactionSipPurchase.isTillPerpetuity autocomplete=off class=form-control placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-model=InitiateTransactionSipPurchase.formData.endDate required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span><!--                    <span--><!--                      ng-if=\"InitiateTransactionSipPurchase.endDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.otmBank\"--><!--                      class=\"error-message-sip-end\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                        Selected date is greater than OTM expiry date.--><!--                      </span>--><!--                    <span--><!--                      ng-if=\"InitiateTransactionSipPurchase.fiendDateValidation && InitiateTransactionSipPurchase.formData.endDate && InitiateTransactionSipPurchase.formData.fiOtmBank\"--><!--                      class=\"error-message-sip-end\">--><!--                        &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                        Selected date is greater than OTM expiry date.--><!--                      </span>--></div></div><div class=\"col-md-1 form-grid text-center optional-or\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=text-uppercase>or</span></div><div class=\"col-md-4 form-grid\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && InitiateTransactionSipPurchase.formData.paymentMode.key !== \'UPI\'\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=default-end-date-otm name=endDateOption ng-model=InitiateTransactionSipPurchase.endDateSelectionOption ng-change=InitiateTransactionSipPurchase.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span class=default-date><strong>Choose Default End Date, which is 2099</strong></span></div></div></div><style>.initiate-transition span.amount-error{\n    top: 102%;\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n    color: #d92018;\n  }</style><!--<div class=\"row form-grid\" ng-if=\"InitiateTransactionSipPurchase.showChequeLeaf\">\n              <p><strong>Upload Age Proof</strong></p>\n              <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                  <input type=\"hidden\" name=\"chequeleaf\" ng-model=\"InitiateTransactionSipPurchase.chequeLeaf\" required>\n                  <span class=\"file-name text-blue\">{{InitiateTransactionSipPurchase.chequeLeaf}}</span>\n\n                  <span class=\"upload-button\">\n              <input id=\"uploadFileId\" type=\"file\" focus-me=\"shouldBeOpen\" value=\"Browse..\" accept=\".jpeg,.jpg,.png\"\n                     file-model=\"InitiateTransactionSipPurchase.myFile\" targetimg=\"showingImgId\"\n                     upload=\"InitiateTransactionSipPurchase.uploadFile(file)\" required>\n              <label for=\"uploadFileId\" class=\"btn-upload btn-secondary-action\">{{InitiateTransactionSipPurchase.myFile?\'Change\':\'Upload Date of Birth Proof\'}}</label>\n				    </span>\n                </div>\n              </div>\n            </div>--><div ng-show=InitiateTransactionSipPurchase.topupQuarterCheck class=topup-info-block><p><i style=\"top:2px; margin-right:15px\" class=\"tooltip-info-icon icon\"></i> Sip Top-up cannot be done when Sip Frequency is quarterly and Sip months are less than 12.</p></div><div class=\"col-md-12 form-grid\" ng-if=\"InitiateTransactionSipPurchase.showTopUpBlock && InitiateTransactionSipPurchase.formData.paymentMode.key != \'HEM\'\" style=\"padding: 30px 20px 30px\"><div class=row><p><strong>SIP Top-up Details</strong></p></div><div class=row><div class=\"col-md-3 row form-group\" ng-if=!InitiateTransactionSipPurchase.isReseting><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=sipToptup ng-model=InitiateTransactionSipPurchase.formData.sipTopupSelected ng-change=\"InitiateTransactionSipPurchase.changeSipTopupSelected(); InitiateTransactionSipPurchase.changeTopUpDetails();\"> <span class=icon-checkbox></span> </span>&nbsp;<label>SIP Top-up</label></div></div><div class=\"row borderline\"><div ng-class=\"{\'anything-disabled\': !InitiateTransactionSipPurchase.sipTopupSelected }\" class=col-md-12><div class=\"col-md-12 row\"><div class=\"row form-group\"><div class=col-md-3><div class=input-normal ng-class=\"{error:([undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.amount) === -1 && (InitiateTransactionSipPurchase.isMinTopupAmount || !InitiateTransactionSipPurchase.isMultipleTopupAmount))}\"><input type=number ignore-mouse-wheel ng-change=\"InitiateTransactionSipPurchase.changeTopupAmount(sipPurchaseForm); InitiateTransactionSipPurchase.changeTopUpDetails();\" name=topupAmount onkeyup=\"NumToWord(this.value,\'topupAmntInWords\')\" ng-disabled=\"[undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.percentage)===-1\" ng-model=InitiateTransactionSipPurchase.formData.topupDetails.amount autocomplete=off ng-required=\"(!InitiateTransactionSipPurchase.formData.topupDetails.percentage && InitiateTransactionSipPurchase.sipTopupSelected)\"> <i class=rupee-grey-icon></i><label>Amount</label><span class=error-input ng-show=\"((!InitiateTransactionSipPurchase.formData.topupDetails.percentage && !InitiateTransactionSipPurchase.formData.topupDetails.amount) || !InitiateTransactionSipPurchase.formData.topupDetails.percentage) && InitiateTransactionSipPurchase.sipTopupSelected\"><span ng-if=\"InitiateTransactionSipPurchase.isMinTopupAmount && sipPurchaseForm.topupAmount.$valid\">{{\'Minimum amount should be &#8377;\'+ InitiateTransactionSipPurchase.sipValidations.minTopupAmount+\'.\'}} </span><span ng-if=\"!InitiateTransactionSipPurchase.isMultipleTopupAmount && sipPurchaseForm.topupAmount.$valid && !InitiateTransactionSipPurchase.isMinTopupAmount\">{{\'Please provide In multiples of &#8377;\'+ InitiateTransactionSipPurchase.sipValidations.topupAmountMultiples+\'.\'}} </span><span ng-if=\"sipPurchaseForm.topupDetails.amount.$invalid && sipPurchaseForm.topupDetails.amount.$error.number\">{{InitiateTransactionSipPurchase.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</span></span></div><div ng-if=InitiateTransactionSipPurchase.formData.topupDetails.amount class=amount-in-words style=\"margin-top: 20px\"><span>(In Words)&nbsp;</span><div id=topupAmntInWords></div></div></div><div class=\"col-md-1 form-grid text-center\" ng-if=InitiateTransactionSipPurchase.appConstants.SET_TOP_UP_PERCENTAGE_VIEW ng-show=!InitiateTransactionSipPurchase.hideTopupPercentage>OR</div><div class=col-md-3 ng-show=!InitiateTransactionSipPurchase.hideTopupPercentage ng-if=InitiateTransactionSipPurchase.appConstants.SET_TOP_UP_PERCENTAGE_VIEW><div class=input-normal ng-class=\"{error:(\n                             [undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.percentage) === -1\n                             && (InitiateTransactionSipPurchase.isMinTopupPercentage || !InitiateTransactionSipPurchase.isMultipleTopupPercentage))}\"><input type=number ignore-mouse-wheel ng-change=\"InitiateTransactionSipPurchase.changeTopupPercentage(sipPurchaseForm); InitiateTransactionSipPurchase.getTopupFrequencyList()\" name=topupPercentage ng-disabled=\"[undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.amount) === -1\" ng-model=InitiateTransactionSipPurchase.formData.topupDetails.percentage autocomplete=off ng-required=\"(!InitiateTransactionSipPurchase.formData.topupDetails.amount && InitiateTransactionSipPurchase.sipTopupSelected)\"><label>Percentage (%)</label><span class=error-input ng-show=\"((!InitiateTransactionSipPurchase.formData.topupDetails.amount && !InitiateTransactionSipPurchase.formData.topupDetails.percentage) || !InitiateTransactionSipPurchase.formData.topupDetails.amount) && InitiateTransactionSipPurchase.sipTopupSelected\"><span ng-if=\"InitiateTransactionSipPurchase.isMinTopupPercentage && sipPurchaseForm.topupPercentage.$valid\">{{\'Minimum percentage should be \'+ InitiateTransactionSipPurchase.sipValidations.topupMinPercentage+\'%.\'}} </span><span ng-if=\"!InitiateTransactionSipPurchase.isMultipleTopupPercentage && sipPurchaseForm.topupPercentage.$valid && !InitiateTransactionSipPurchase.isMinTopupPercentage\">{{\'Please provide in multiples of \'+ InitiateTransactionSipPurchase.sipValidations.topupPercentageMultiples+\'%.\'}} </span><span ng-if=\"sipPurchaseForm.topupPercentage.$invalid && sipPurchaseForm.topupPercentage.$error.number\">{{InitiateTransactionSipPurchase.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}}</span></span></div></div></div><div class=row><div class=col-md-6><div class=install-freq><p><strong>Topup Frequency</strong></p><div class=\"col-md-3 radio-block topup-freq\" ng-repeat=\"freq in InitiateTransactionSipPurchase.topupFrequencyList\"><span class=radio><input type=radio ng-model=InitiateTransactionSipPurchase.formData.topupDetails.frequency ng-change=\"InitiateTransactionSipPurchase.changeTopUpFreq(); InitiateTransactionSipPurchase.changeTopUpDetails();\" ng-value=freq.key name=topupFrequency> <span class=check></span></span><label>{{freq.value}}</label></div></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:(([undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.capAmount) === -1\n                        && (InitiateTransactionSipPurchase.formData.topupDetails.capAmount && InitiateTransactionSipPurchase.formData.topupDetails.capAmount <1)) || (InitiateTransactionSipPurchase.formData.topupDetails.capAmount && InitiateTransactionSipPurchase.isminCapAmount))}\"><input type=number ignore-mouse-wheel name=capAmount onkeyup=\"NumToWord(this.value,\'capAmntInWords\')\" ng-model=InitiateTransactionSipPurchase.formData.topupDetails.capAmount ng-change=\"InitiateTransactionSipPurchase.capAmountChanged(sipPurchaseForm); InitiateTransactionSipPurchase.changeTopUpDetails();\" ng-disabled=InitiateTransactionSipPurchase.formData.topupDetails.capMonthYear autocomplete=off> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Cap Amount</label><span class=error-input ng-show=\"([undefined,\'\',null].indexOf(InitiateTransactionSipPurchase.formData.topupDetails.capAmount) === -1) || (InitiateTransactionSipPurchase.isminCapAmount)\"><span ng-if=\"InitiateTransactionSipPurchase.formData.topupDetails.capAmount && InitiateTransactionSipPurchase.formData.topupDetails.capAmount <1\">{{InitiateTransactionSipPurchase.validations.INVALID_AMOUNT+\'.\'}} </span><span ng-if=\"InitiateTransactionSipPurchase.formData.topupDetails.capAmount && InitiateTransactionSipPurchase.isminCapAmount\">Minimum amount should &#8377;{{InitiateTransactionSipPurchase.minCapAmount+\'.\'}}</span></span></div><div ng-if=InitiateTransactionSipPurchase.formData.topupDetails.capAmount class=amount-in-words style=\"margin-top: 20px\"><span>(In Words)&nbsp;</span><div id=capAmntInWords style=\"padding-bottom: 15px\"></div></div></div><div class=\"col-md-1 form-grid text-center\">OR</div><div class=row><div class=col-md-3><div class=selectfield style=\"margin-top: 7px\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.formData.topupDetails.capAmount }\"><select class=\"browser-default custom-select\" name=capDates ng-disabled=InitiateTransactionSipPurchase.formData.topupDetails.capAmount ng-options=\"_dates for _dates in InitiateTransactionSipPurchase.capDates\" ng-model=InitiateTransactionSipPurchase.formData.topupDetails.capMonthYear ng-change=InitiateTransactionSipPurchase.changeTopUpDetails(); ng-required=\"(!InitiateTransactionSipPurchase.formData.topupDetails.capAmount && InitiateTransactionSipPurchase.sipTopupSelected)\"><option value=\"\">Cap Month Year - MM/YYYY</option></select></div></div></div></div></div></div></div></div></div><div class=purchase-form-box ng-if=\"InitiateTransactionSipPurchase.formData.investmentType===InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.PURCHASE\"><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Add a Purchase Scheme</strong></label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=pInScheme1 ng-change=InitiateTransactionSipPurchase.filterPurchaseInSchemeList() ng-model=InitiateTransactionSipPurchase.formData.inSchemeName autocomplete=off ng-paste=$event.preventDefault(); ondrop=\"return false\" required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSipPurchase.purchaseInSchemeList display-key=scheme hdfc-click=InitiateTransactionSipPurchase.purchaseInSchemeChanged(data) model=InitiateTransactionSipPurchase.formData.inSchemeCode for=pInScheme1></drop-down></div></div></div><div class=\"col-md-1 form-grid mgt50 clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid mgt50 inline-style\"><a ng-click=InitiateTransactionSipPurchase.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=row ng-if=\"InitiateTransactionSipPurchase.purchaseValidations && !InitiateTransactionSipPurchase.purchaseValidations.isGrowth\"><div class=\"col-md-12 form-grid\"><div class=install-freq><p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p><div class=\"col-md-6 radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.purchaseValidations.dividendReinvestmentApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=sReinvest ng-model=InitiateTransactionSipPurchase.formData.purchaseDividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"InitiateTransactionSipPurchase.purchaseValidations.dividendReinvestmentApplicable === false\" name=pDividendOption> <span class=check></span></span><label class=radio-flex-label for=sReinvest>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=\"col-md-6 radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.purchaseValidations.dividendPayoutApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=sPayout ng-model=InitiateTransactionSipPurchase.formData.purchaseDividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"InitiateTransactionSipPurchase.purchaseValidations.dividendPayoutApplicable === false\" name=pDividendOption> <span class=check></span></span><label class=radio-flex-label for=sPayout>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:(InitiateTransactionSipPurchase.isMinPurchaseAmount && InitiateTransactionSipPurchase.formData.purchaseAmount)\n                     || (!InitiateTransactionSipPurchase.isMultiples && InitiateTransactionSipPurchase.formData.purchaseAmount && InitiateTransactionSipPurchase.purchaseValidations.purchaseMultiple)}\"><input type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel ng-change=InitiateTransactionSipPurchase.changePurchaseAmount(sipPurchaseForm) name=purchaseAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords392\')\" ng-model=InitiateTransactionSipPurchase.formData.purchaseAmount ondrop=\"return false\" autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=\"InitiateTransactionSipPurchase.isMinPurchaseAmount && sipPurchaseForm.purchaseAmount.$valid\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSipPurchase.minAmountValidation}} </span><span ng-if=\"sipPurchaseForm.purchaseAmount.$invalid && sipPurchaseForm.purchaseAmount.$error.number\" class=error-input>{{InitiateTransactionSipPurchase.VALIDATE_DATA.INVALID_AMOUNT}} </span><span ng-if=\"sipPurchaseForm.purchaseAmount.$valid && !InitiateTransactionSipPurchase.isMinPurchaseAmount && InitiateTransactionSipPurchase.purchaseValidations.purchaseMultiple && !InitiateTransactionSipPurchase.isMultiples\" class=error-input>Please Provide In Multiples Of &#x20B9; {{InitiateTransactionSipPurchase.purchaseValidations.purchaseMultiple}}</span><div ng-if=InitiateTransactionSipPurchase.formData.purchaseAmount class=amount-in-words><span>(In Words)&nbsp;</span><div id=divDisplayWords392></div></div></div><!--<span class=\"text-support\">( In Multiples of 1000)</span>--></div></div><!--<div class=\"row form-grid\" ng-if=\"InitiateTransactionSipPurchase.showChequeLeaf\"\n                 ng-init=\"sipPurchaseForm.$invalid=true\">\n              <input type=\"hidden\" name=\"chequeleaf\" ng-model=\"InitiateTransactionSipPurchase.chequeLeaf\" required>\n              <p><strong>Upload Age Proof<span class=\"red\">*</span></strong></p>\n              <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                  <span class=\"file-name text-blue\">{{InitiateTransactionSipPurchase.chequeLeaf}}</span>\n\n                  <span class=\"upload-button\">\n              <input id=\"uploadFileId\" type=\"file\" focus-me=\"shouldBeOpen\" value=\"Browse..\" accept=\".jpeg,.jpg,.png\"\n                     file-model=\"InitiateTransactionSipPurchase.myFile\" targetimg=\"showingImgId\"\n                     upload=\"InitiateTransactionSipPurchase.uploadFile(file)\" required>\n                     upload=\"InitiateTransactionSipPurchase.uploadFile(file)\" required>\n              <label for=\"uploadFileId\" class=\"btn-upload btn-secondary-action\">{{InitiateTransactionSipPurchase.myFile?\'Change\':\'Upload Date of Birth Proof\'}}</label>\n				    </span>\n                </div>\n              </div>\n            </div>--><div class=\"tc-block form-group\" ng-if=InitiateTransactionSipPurchase.nfoEnabled><div class=checkbox><input name=isAutoSwitch ng-model=InitiateTransactionSipPurchase.formData.isAutoSwitch type=checkbox ng-change=InitiateTransactionSipPurchase.fetchSwitchInSchemes()> <i class=icon-checkbox></i> <span class=checkbox-text>Auto Switch on Maturity</span></div></div><div class=row ng-if=InitiateTransactionSipPurchase.formData.isAutoSwitch><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionSipPurchase.sipPurchaseForm.inScheme.$dirty && InitiateTransactionSipPurchase.sipPurchaseForm.inScheme.$invalid}\"><input type=text name=inScheme ng-model=InitiateTransactionSipPurchase.selectedInScheme ng-change=\"InitiateTransactionSipPurchase.isSelectedInScheme=(InitiateTransactionSipPurchase.selectedInScheme.length>0) ? false:true\" required autocomplete=off ng-blur=InitiateTransactionSipPurchase.checkValidScheme() capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name To Switch In</label><span ng-show=\"InitiateTransactionSipPurchase.sipPurchaseForm.inScheme.$dirty && InitiateTransactionSipPurchase.sipPurchaseForm.inScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionSipPurchase.sipPurchaseForm.inScheme.$error.required ng-bind=InitiateTransactionSipPurchase.message.SCHEME_REQUIRED></span></span><div class=\"suggestion box-shadow\" ng-hide=\"(InitiateTransactionSipPurchase.inSchemes|filter:{scheme:InitiateTransactionSipPurchase.selectedInScheme}).length == 0 || InitiateTransactionSipPurchase.isSelectedInScheme\"><ul><li ng-repeat=\"schemeData in InitiateTransactionSipPurchase.inSchemes | filter:{scheme:InitiateTransactionSipPurchase.selectedInScheme}\" ng-click=\"InitiateTransactionSipPurchase.selectedInScheme=schemeData.scheme;InitiateTransactionSipPurchase.isSelectedInScheme=true;InitiateTransactionSipPurchase.inSchemeChanged(schemeData);\">{{schemeData.scheme}}</li></ul></div></div></div></div><div class=\"col-md-1 form-grid clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid inline-style\"><a ng-click=InitiateTransactionSipPurchase.getAutoSwitchEnabledList() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.isAutoSwitch && (InitiateTransactionSipPurchase.inSchemeValidations && InitiateTransactionSipPurchase.inSchemeValidations.investmentOption !== \'GROWTH\')\"><div class=\"col-md-12 form-grid\"><div class=install-freq><p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p><div class=\"col-md-6 radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.sipValidationsData.dividendReinvestmentApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=swReinvest ng-model=InitiateTransactionSipPurchase.formData.autoSwitchSchemeDividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"InitiateTransactionSipPurchase.sipValidationsData.dividendReinvestmentApplicable === false\" name=swDividendOption> <span class=check></span></span><label class=radio-flex-label for=sReinvest>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=\"col-md-6 radio-block radio-block radio-flex-div\" ng-class=\"{\'anything-disabled\': InitiateTransactionSipPurchase.sipValidationsData.dividendPayoutApplicable === false}\"><span class=\"radio radio-flex-span radio-flex\"><input type=radio id=swPayout ng-model=InitiateTransactionSipPurchase.formData.autoSwitchSchemeDividendOption ng-value=InitiateTransactionSipPurchase.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"InitiateTransactionSipPurchase.sipValidationsData.dividendPayoutApplicable === false\" name=swDividendOption> <span class=check></span></span><label class=radio-flex-label for=sPayout>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div></div><div class=row><div class=\"col-md-8 pay-mode width100\"><div><p><strong>Payment Mode Selection</strong></p><div class=radio-block ng-repeat=\"payMode in InitiateTransactionSipPurchase.PAYMENT_MODE\"><span ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && (payMode.value ==\'NEFT/RTGS\' || payMode.value==\'HDFC Bank\\\'s Fund Transfer\'))\" class=radio><input type=radio id={{payMode.value}} ng-change=\"InitiateTransactionSipPurchase.changePaymentMode(); InitiateTransactionSipPurchase.checkUpiError();\" ng-model=InitiateTransactionSipPurchase.formData.paymentMode ng-value=payMode name=paymentMode required> <span class=check></span></span><label ng-if=\"!(InitiateTransactionSipPurchase.formData.minorFlag && !InitiateTransactionSipPurchase.formData.cgfFlag && (payMode.value ==\'NEFT/RTGS\' || payMode.value==\'HDFC Bank\\\'s Fund Transfer\'))\" for={{payMode.value}}>{{payMode.value}}</label></div><!--upi bank list selection--><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\'\"><select class=\"browser-default custom-select\" name=upiBank ng-model=InitiateTransactionSipPurchase.formData.upiBank ng-change=InitiateTransactionSipPurchase.changeUpiBank() ng-options=\"item as (item.bankName) for item in InitiateTransactionSipPurchase.upiBankList\" ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\'\" ng-init=\"InitiateTransactionSipPurchase.formData.upiBank = InitiateTransactionSipPurchase.formData.upiBank ? InitiateTransactionSipPurchase.formData.upiBank : null\"><option value=\"\" selected>Select UPI Bank - Account Number</option></select></div></div></div><!--error message for upi tpv--><p class=\"text-red error-msg-tpv\" ng-if=\"InitiateTransactionSipPurchase.formData.upiBank.tpvEnableFlag==\'N\'\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=InitiateTransactionSipPurchase.tpv($event) href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.value.toLowerCase() == \'net banking\'\"><!--dynamic note netbanking--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteNetBanking.content></ng-bind-html></div><div ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.value.toLowerCase() === \'upi\'\"><!--dynamic note upi--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteUpi.content></ng-bind-html></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HDFC\'\"><!--dynamic note Hdfc--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteHdfc.content></ng-bind-html></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'RTGS\'\"><!--dynamic note RTGS--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteNeft.content></ng-bind-html></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\'\"><div class=col-md-12><div class=point-to-note-tpv>Please Note:<br><ul><li><span ng-bind-html=InitiateTransactionSipPurchase.NAV_APPLICABILITY_NOTE class=nav-faq-link></span></li><li>To know more about various payment options along with their efficiency for the purpose of NAV applicability - <a class=nav-faq-link ng-click=InitiateTransactionSipPurchase.paymentNavUrl() href=javascript:void(0) style=\"font-size: 100% !important\">Click here</a></li></ul></div></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\" ng-class=\"{error: (sipPurchaseForm.otmBank.$invalid && sipPurchaseForm.otmBank.$dirty)  || InitiateTransactionSipPurchase.otmLimitvalidation || InitiateTransactionSipPurchase.endDateValidation}\"><input type=text name=bank id=otmBank ng-model=InitiateTransactionSipPurchase.formData.otmBank.bankName ng-change=InitiateTransactionSipPurchase.changeOtmbank() ng-init=\"InitiateTransactionSipPurchase.formData.otmBank = InitiateTransactionSipPurchase.formData.otmBank ? InitiateTransactionSipPurchase.formData.otmBank : null\" autocomplete=off ng-required=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\" only-alphabets required> <span class=highlight></span> <span class=bar></span><label style=\"display: block !important\">Select OTM Bank - Account Number</label><bank-drop-down list-data=InitiateTransactionSipPurchase.otmBankList display-key=bankName display-key-second=bankAcNo hdfc-click=InitiateTransactionSipPurchase.changeOtmbank() model=InitiateTransactionSipPurchase.formData.otmBank for=otmBank></bank-drop-down><span ng-show=\"sipPurchaseForm.otmBank.$dirty && sipPurchaseForm.otmBank.$invalid\"><span class=error-input ng-show=sipPurchaseForm.otmBank.$error.required ng-bind=InitiateTransactionSipPurchase.validations.BLANK_BANK_INFO></span> </span><span ng-if=\"InitiateTransactionSipPurchase.otmLimitvalidation && (sipPurchaseForm.purchaseAmount.$valid || sipPurchaseForm.installmentAmount.$valid)\" class=error-input><!--Otm account limit should be greater than or equal the investment amount.--> Transaction amount is greater than the OTM Limit set. </span><!--                      <span--><!--                        ng-if=\"InitiateTransactionSipPurchase.endDateValidation && sipPurchaseForm.otmBank.$valid\"--><!--                        class=\"error-input\">--><!--                   &lt;!&ndash; Otm end date should be on or before selected end date.&ndash;&gt;--><!--                      Selected date is greater than OTM expiry date.--><!--                </span>--></div></div></div><div class=row><div class=col-md-7><table class=\"table borderless\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\' &&\n                      InitiateTransactionSipPurchase.formData.otmBank\n                      && InitiateTransactionSipPurchase.otmBankList.length\"><tr><td>Account No</td><td style=width:1%>:</td><td easyassist-key=mask-element>{{InitiateTransactionSipPurchase.formData.otmBank.bankAcNo}}</td></tr><tr><td>OTM UMRN No</td><td style=width:1%>:</td><td>{{InitiateTransactionSipPurchase.formData.otmBank.omUmrn}}</td></tr><tr><td>OTM Bank Name</td><td style=width:1%>:</td><td>{{InitiateTransactionSipPurchase.formData.otmBank.bankName}}</td></tr><tr><td>OTM Start Date</td><td style=width:1%>:</td><td>{{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}} <span ng-if=InitiateTransactionSipPurchase.startDateValidationPurchase class=error-input><!-- Otm end date should be on or before selected end date.--> Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or after OTM start date which is, {{InitiateTransactionSipPurchase.formData.otmBank.omStartDate}}</span></td></tr><tr><td>OTM Maturity Date</td><td style=width:1%>:</td><td>{{InitiateTransactionSipPurchase.formData.otmBank.omExpiryDate}} <span ng-if=InitiateTransactionSipPurchase.endDateValidation class=error-input><!-- Otm end date should be on or before selected end date.--> Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or before OTM expiry date which is, {{InitiateTransactionSipPurchase.formData.otmBank.omExpiryDate}}</span></td></tr><tr><td>OTM Instruction Type:</td><td style=width:1%>:</td><td>{{InitiateTransactionSipPurchase.formData.otmBank.otmFrequencyName ? InitiateTransactionSipPurchase.formData.otmBank.otmFrequencyName : InitiateTransactionSipPurchase.formData.otmBank.otmFrequency}}</td></tr><tr><td>OTM Max Amount</td><td style=width:1%>:</td><td><i class=rupee-icon ng-if=InitiateTransactionSipPurchase.formData.otmBank.maxAmount></i>{{InitiateTransactionSipPurchase.formData.otmBank.maxAmount}} <span ng-if=\"InitiateTransactionSipPurchase.otmLimitvalidation && (sipPurchaseForm.purchaseAmount.$valid || sipPurchaseForm.installmentAmount.$valid)\" class=error-input><!--Otm account limit should be greater than or equal the investment amount.--> Purchase transaction amount is exceeding maximum OTM amount, please select another OTM or payment mode to proceed</span></td></tr></table></div></div><div class=row ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\"><!--                  <div class=\"col-md-12\">--><!--                    <div class=\"point-to-note-tpv\">--><!--                      Please Note: <br />--><!--                      <ul>--><!--                        <li><span ng-bind-html=\"InitiateTransactionSipPurchase.NAV_APPLICABILITY_NOTE\" class=\"nav-faq-link\"></span></li>--><!--                        <li>To know more about various payment options along with their efficiency for the purpose of NAV applicabilityss - <a class=\'nav-faq-link\' ng-click=\'InitiateTransactionSipPurchase.paymentNavUrl()\' href=\'javascript:void(0)\' style=\"font-size: 100% !important\">Click here</a></li>--><!--                      </ul>--><!--                    </div>--><!--                  </div>--><!--dynamic note for OTM--><ng-bind-html dynamic=InitiateTransactionSipPurchase.dynamicNoteOtm.content></ng-bind-html></div></div></div></div><div class=tc-block ng-show=InitiateTransactionSipPurchase.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionSipPurchase.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionSipPurchase.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><!--Submit button for PURCHASE--><div ng-if=\"InitiateTransactionSipPurchase.formData.investmentType != InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.SIP\" class=\"form-footer form-content\"><span class=\"pull-right buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSipPurchase.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionSipPurchase.loginType !== \'A\'\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation || InitiateTransactionSipPurchase.startDateValidationPurchase  || InitiateTransactionSipPurchase.endDateValidation\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.key === \'BZ\')\n                        || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\' && InitiateTransactionSipPurchase.formData.upiBank.tpvEnableFlag==\'N\') || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=InitiateTransactionSipPurchase.sipPurchaseAddToCart()>Add to E-cart</button> <button class=\"btn btn-primary-action\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation || InitiateTransactionSipPurchase.startDateValidationPurchase  || InitiateTransactionSipPurchase.endDateValidation\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.key === \'BZ\')\n                        || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'UPI\' && InitiateTransactionSipPurchase.formData.upiBank.tpvEnableFlag==\'N\') || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=InitiateTransactionSipPurchase.finishPurchaseFirst()>Continue</button></span></div><!--submit button for SIP--><div ng-if=\"InitiateTransactionSipPurchase.formData.investmentType == InitiateTransactionSipPurchase.TRANSACTION_FORM_TYPE.SIP\" class=\"form-footer form-content\"><span class=\"pull-right buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSipPurchase.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\' && !InitiateTransactionSipPurchase.formData.sipFirstInstallment && !InitiateTransactionSipPurchase.checkFromState.fromModify && !InitiateTransactionSipPurchase.checkFromState.fromRenew && InitiateTransactionSipPurchase.selectedFrequency.code == \'OM\' && !InitiateTransactionSipPurchase.formData.sipTopupSelected && !InitiateTransactionSipPurchase.fromQuickSip && InitiateTransactionSipPurchase.loginType !== \'A\'\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation\n                       || InitiateTransactionSipPurchase.endDateValidation\n                       || InitiateTransactionSipPurchase.startDateValidation\n                       || !(!!InitiateTransactionSipPurchase.formData.startDate && !!InitiateTransactionSipPurchase.formData.endDate)\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.code === \'BZ\')\n                              || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.isEmandateMaxLimit) || InitiateTransactionSipPurchase.invalidAmount\n                          || InitiateTransactionSipPurchase.formData.dividendOption == \'\'\n                          || !InitiateTransactionSipPurchase.formData.paymentMode || InitiateTransactionSipPurchase.fiOtmLimitvalidation || InitiateTransactionSipPurchase.fiendDateValidation || InitiateTransactionSipPurchase.amountExceeded || InitiateTransactionSipPurchase.panDetailsNotVerified || InitiateTransactionSipPurchase.disableBtnForModify || InitiateTransactionSipPurchase.topupDetailsInvalid || InitiateTransactionSipPurchase.startDateValidationForFi || InitiateTransactionSipPurchase.selectedFrequency.code !== \'OM\' || InitiateTransactionSipPurchase.formData.sipTopupSelected || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=\"InitiateTransactionSipPurchase.sipPurchaseAddToCart(\'sip\')\">Add to E-cart</button> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && !InitiateTransactionSipPurchase.checkFromState.fromModify && !InitiateTransactionSipPurchase.checkFromState.fromRenew && InitiateTransactionSipPurchase.selectedFrequency.code == \'OM\' && !InitiateTransactionSipPurchase.fromQuickSip && InitiateTransactionSipPurchase.loginType !== \'A\'\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation\n                       || InitiateTransactionSipPurchase.endDateValidation\n                       || InitiateTransactionSipPurchase.startDateValidation || InitiateTransactionSipPurchase.isEmailinValid || InitiateTransactionSipPurchase.isEmailMobileinValid || InitiateTransactionSipPurchase.isMobileinValid\n                       || !(!!InitiateTransactionSipPurchase.formData.startDate && !!InitiateTransactionSipPurchase.formData.endDate)\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.code === \'BZ\')\n                              || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.isEmandateMaxLimit) || InitiateTransactionSipPurchase.amountExceeded || InitiateTransactionSipPurchase.panDetailsNotVerified || InitiateTransactionSipPurchase.disableBtnForModify || InitiateTransactionSipPurchase.selectedFrequency.code !== \'OM\' || InitiateTransactionSipPurchase.formData.sipTopupSelected || (InitiateTransactionSipPurchase.amountLess || InitiateTransactionSipPurchase.amountMore || InitiateTransactionSipPurchase.isLessThanSipAmount || InitiateTransactionSipPurchase.sipDateLessEmandate) || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=\"InitiateTransactionSipPurchase.sipPurchaseAddToCart(\'sip\')\">Add to E-cart</button> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key !== \'HEM\'\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation\n                       || InitiateTransactionSipPurchase.endDateValidation\n                       || InitiateTransactionSipPurchase.startDateValidation\n                       || !(!!InitiateTransactionSipPurchase.formData.startDate && !!InitiateTransactionSipPurchase.formData.endDate)\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.code === \'BZ\')\n                              || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\' && InitiateTransactionSipPurchase.isEmandateMaxLimit) || InitiateTransactionSipPurchase.invalidAmount\n                          || InitiateTransactionSipPurchase.formData.dividendOption == \'\'\n                          || !InitiateTransactionSipPurchase.formData.paymentMode || InitiateTransactionSipPurchase.fiOtmLimitvalidation || InitiateTransactionSipPurchase.fiendDateValidation || InitiateTransactionSipPurchase.amountExceeded || InitiateTransactionSipPurchase.panDetailsNotVerified || InitiateTransactionSipPurchase.disableBtnForModify || InitiateTransactionSipPurchase.topupDetailsInvalid || InitiateTransactionSipPurchase.startDateValidationForFi || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=InitiateTransactionSipPurchase.finishPurchaseFirst()>Continue</button> <button class=\"btn btn-primary-action\" ng-if=\"InitiateTransactionSipPurchase.formData.paymentMode.key === \'HEM\'\" ng-disabled=\"sipPurchaseForm.$invalid || InitiateTransactionSipPurchase.otmLimitvalidation\n                       || InitiateTransactionSipPurchase.endDateValidation\n                       || InitiateTransactionSipPurchase.startDateValidation || InitiateTransactionSipPurchase.isEmailinValid || InitiateTransactionSipPurchase.isEmailMobileinValid || InitiateTransactionSipPurchase.isMobileinValid\n                       || !(!!InitiateTransactionSipPurchase.formData.startDate && !!InitiateTransactionSipPurchase.formData.endDate)\n                       || (InitiateTransactionSipPurchase.formData.paymentMode.key === \'OTM\'\n                              && InitiateTransactionSipPurchase.formData.otmBank.otmFrequency != \'AWP\'\n                              && InitiateTransactionSipPurchase.selectedFrequency.code === \'BZ\')\n                               || InitiateTransactionSipPurchase.amountExceeded || InitiateTransactionSipPurchase.panDetailsNotVerified || InitiateTransactionSipPurchase.disableBtnForModify || InitiateTransactionSipPurchase.amountLess || InitiateTransactionSipPurchase.amountMore || InitiateTransactionSipPurchase.isLessThanSipAmount || InitiateTransactionSipPurchase.sipDateLessEmandate || InitiateTransactionSipPurchase.showRetirementSchemeError\" ng-click=InitiateTransactionSipPurchase.finishPurchaseFirst()>Continue</button></span></div></div></div></form></div><div class=\"post-login-ecart-journey main-section-ecart\" ng-if=InitiateTransactionSipPurchase.showEcartModel><div class=sidebar-container id=sidebarContainer hdfc-post-login-ecart-sidebar side-title=InitiateTransactionSipPurchase.sidebarTitle investor-data=InitiateTransactionSipPurchase.investorData cart-item=InitiateTransactionSipPurchase.ecartData show-add-cart=InitiateTransactionSipPurchase.showAddCart from-initiate-cart=InitiateTransactionSipPurchase.isFromInitiateSipPurchase close-action=InitiateTransactionSipPurchase.closeAction(action)></div></div></section><style>.netbanking_notification{\n  position: absolute;\n    font-size: 12px;\n    color: #d92018;\n    left: 15px;\n    top: 70px;\n}</style>");
$templateCache.put("app/transactions/initiate/sip-cancel/sip-cancel.html","<div class=\"main-section summary\" ng-init=SipCancel.init()><p class=page-title>Cancelled {{SipCancel.tncType}} Details</p><div class=content-area><div class=row><div class=col-md-6><table class=\"table borderless\"><tr ng-if=SipCancel.summaryDetails.folioNumber><td class=label-color>Folio Number</td><td>:</td><td>{{SipCancel.summaryDetails.folioNumber}}</td></tr><tr ng-if=SipCancel.summaryDetails.schemeName><td class=label-color>Scheme Name</td><td>:</td><td>{{SipCancel.summaryDetails.schemeName}}</td></tr><tr ng-if=SipCancel.summaryDetails.option><td class=label-color>Scheme Option</td><td>:</td><td>{{SipCancel.summaryDetails.option}}</td></tr><tr ng-if=\"SipCancel.summaryDetails.IDCW_OPTION && SipCancel.option === \'Income Distribution cum Capital Withdrawal (IDCW)\'\"><td class=label-color>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>:</td><td>{{SipCancel.summaryDetails.IDCW_OPTION}}</td></tr><tr ng-if=SipCancel.summaryDetails.startDate><td class=label-color>Start Date</td><td>:</td><td>{{SipCancel.summaryDetails.startDate}}</td></tr><tr ng-if=SipCancel.summaryDetails.endDate><td class=label-color>End Date</td><td>:</td><td>{{SipCancel.summaryDetails.endDate}}</td></tr><tr ng-if=SipCancel.summaryDetails.frequency><td class=label-color>{{SipCancel.tncType}} Frequency</td><td>:</td><td>{{SipCancel.summaryDetails.frequency}}</td></tr><tr ng-if=SipCancel.summaryDetails.amount><td class=label-color>Installment Amount(INR)</td><td>:</td><td><i class=rupee-grey-icon style=top:2px></i>{{SipCancel.summaryDetails.amount}}</td></tr><tr ng-if=SipCancel.summaryDetails.paymentOption><td class=label-color>Payment Mode for {{SipCancel.tncType}} Registration</td><td>:</td><td ng-if=\"SipCancel.summaryDetails.paymentOption[0].code == \'EC\'\">Standing Instruction/Biller</td><td ng-if=\"SipCancel.summaryDetails.paymentOption[0].code == \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"SipCancel.summaryDetails.paymentOption[0].code == \'HEM\'\">Register E-mandate (eOTM)</td></tr><tr ng-if=\"SipCancel.summaryDetails.topUpDetails && SipCancel.summaryDetails.topUpDetails.amount\"><td class=label-color>{{SipCancel.tncType}} Topup Amount</td><td>:</td><td><i class=rupee-grey-icon style=top:2px></i>{{SipCancel.summaryDetails.topUpDetails.amount}}</td></tr><tr ng-if=\"SipCancel.summaryDetails.topUpDetails && SipCancel.summaryDetails.topUpDetails.frequency\"><td class=label-color>{{SipCancel.tncType}} Topup Frequency</td><td>:</td><td ng-if=\"SipCancel.summaryDetails.topUpDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"SipCancel.summaryDetails.topUpDetails.frequency === \'H\'\">Half Yearly</td></tr><tr ng-if=\"SipCancel.summaryDetails.topUpDetails && SipCancel.summaryDetails.topUpDetails.capAmount\"><td class=label-color>{{SipCancel.tncType}} Topup Cap Amount</td><td>:</td><td><i class=rupee-grey-icon style=top:2px></i>{{SipCancel.summaryDetails.topUpDetails.capAmount}}</td></tr><tr ng-if=\"SipCancel.summaryDetails.topUpDetails && SipCancel.summaryDetails.topUpDetails.capMonthYear\"><td class=label-color>{{SipCancel.tncType}} Topup Cap Month/Year</td><td>:</td><td>{{SipCancel.summaryDetails.topUpDetails.capMonthYear}}</td></tr><tr ng-if=SipCancel.summaryDetails.sipWithFirstInstallment><td class=label-color>{{SipCancel.tncType}} First Installment</td><td>:</td><td>{{SipCancel.summaryDetails.sipWithFirstInstallment ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=\"SipCancel.summaryDetails.sipWithFirstInstallment && SipCancel.summaryDetails.sipWithFiData\"><td class=label-color>{{SipCancel.tncType}} First Installment Amount</td><td>:</td><td>{{SipCancel.summaryDetails.sipWithFiData.amount}}</td></tr><tr ng-if=\"SipCancel.summaryDetails.sipWithFirstInstallment && SipCancel.summaryDetails.sipWithFiData\"><td class=label-color>Payment Mode for First Installment of {{SipCancel.tncType}}</td><td>:</td><td ng-if=\"SipCancel.summaryDetails.sipWithFiData.paymentMode == \'OTM\'\">OTM</td><td ng-if=\"SipCancel.summaryDetails.sipWithFiData.paymentMode == \'WEB\'\">Net Banking</td></tr></table></div><div class=col-md-12><ng-bind-html dynamic=SipCancel.NoteSipCancel.content></ng-bind-html></div></div><div class=content-foot><div><a href=\"\" ui-sref=main.sipcorner class=\"cursor-pointer text-primary back-pause\"><i class=back-arrow-icon></i>Back</a> <button class=\"btn-primary-action btn pull-right\" ng-click=SipCancel.showNudgeReasons()>Confirm</button></div></div></div></div>");
$templateCache.put("app/transactions/initiate/sip-topup/sip-topup.html","<section class=\"initiate-transition siptopup\" ng-init=SipTopup.init()><div class=content-header><h5>Transaction for {{SipTopup.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transaction</li><li><span class=breadcrumb-icon></span></li><li>Sip Topup</li></ul></div><div class=content><form autocomplete=off name=sipTopupForm novalidate><div class=\"normal-wrap form-box\"><div class=\"col-md-12 form-grid\"><div class=\"row borderline\"><div class=col-md-12><div class=\"col-md-12 row\"><div class=\"row form-group\"><div class=col-md-3><div class=input-normal ng-class=\"{error:(SipTopup.formData.topupDetails.amount && (SipTopup.isMinTopupAmount || !SipTopup.isMultipleTopupAmount))}\"><input type=number ignore-mouse-wheel ng-change=SipTopup.changeTopupAmount(sipTopupForm); name=topupAmount onkeyup=\"NumToWord(this.value,\'topupAmntInWords\')\" ng-disabled=SipTopup.formData.topupDetails.percentage ng-model=SipTopup.formData.topupDetails.amount autocomplete=off ng-required=\"(!SipTopup.formData.topupDetails.percentage && !SipTopup.formData.topupDetails.amount) || !SipTopup.formData.topupDetails.percentage\"> <i class=rupee-grey-icon></i><label>Amount</label><span class=error-input ng-if=\"(SipTopup.formData.topupDetails.amount && (SipTopup.isMinTopupAmount || !SipTopup.isMultipleTopupAmount))\"><span ng-if=\"SipTopup.isMinTopupAmount && sipTopupForm.topupAmount.$valid\">{{\'Minimum amount should be &#8377;\'+ SipTopup.sipValidationsData.topupMinAmt+\'.\'}} </span><span ng-if=\"(!SipTopup.isMultipleTopupAmount && sipTopupForm.topupAmount.$valid) && !(SipTopup.isMinTopupAmount && sipTopupForm.topupAmount.$valid) && !SipTopup.amountExceeded\">{{\'Please provide in multiples of &#8377;\'+ SipTopup.sipValidationsData.topupMinAmt+\'.\'}} </span><span ng-if=\"sipTopupForm.topupDetails.amount.$invalid && sipTopupForm.topupDetails.amount.$error.number\">{{SipTopup.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}} </span></span><span class=error-input ng-if=\"SipTopup.formData.topupDetails.amount && SipTopup.amountExceeded\">{{SipTopup.validateData.AMOUNT_EXCEEDED}}</span></div><div ng-if=SipTopup.formData.topupDetails.amount class=amount-in-words style=\"margin-top: 50px\"><span>(In Words)&nbsp;</span><div id=topupAmntInWords></div></div></div><div class=\"col-md-1 or-part text-center\" ng-if=SipTopup.appConstants.SET_TOP_UP_PERCENTAGE_VIEW>OR</div><div class=col-md-3 ng-if=SipTopup.appConstants.SET_TOP_UP_PERCENTAGE_VIEW><div class=input-normal ng-class=\"{error:(SipTopup.formData.topupDetails.percentage && (SipTopup.isMinTopupPercentage || !SipTopup.isMultipleTopupPercentage))}\"><input type=number ignore-mouse-wheel ng-change=\"SipTopup.changeTopupPercentage(sipTopupForm); SipTopup.getTopupFrequencyList()\" name=topupPercentage ng-disabled=SipTopup.formData.topupDetails.amount ng-model=SipTopup.formData.topupDetails.percentage ng-change=SipTopup.changeTopUpFreq() autocomplete=off ng-required=\"(!SipTopup.formData.topupDetails.amount && !SipTopup.formData.topupDetails.percentage) || !SipTopup.formData.topupDetails.amount\"><label>Percentage (%)</label><span class=error-input ng-if=\"(SipTopup.formData.topupDetails.percentage && (SipTopup.isMinTopupPercentage || !SipTopup.isMultipleTopupPercentage))\"><span ng-if=\"SipTopup.isMinTopupPercentage && sipTopupForm.topupPercentage.$valid\">{{\'Minimum percentage should be \'+ SipTopup.sipValidationsData.topupMinPercentage+\'%.\'}} </span><span ng-if=\"(!SipTopup.isMultipleTopupPercentage && sipTopupForm.topupPercentage.$valid) && !(SipTopup.isMinTopupPercentage && sipTopupForm.topupPercentage.$valid)\">{{\'Please provide in multiples of \'+ SipTopup.sipValidationsData.topupPercentageMultples+\'%.\'}} </span><span ng-if=\"sipTopupForm.topupPercentage.$invalid && sipTopupForm.topupPercentage.$error.number\">{{SipTopup.VALIDATE_DATA.INVALID_AMOUNT+\'.\'}} </span></span><span class=error-input ng-if=\"SipTopup.formData.topupDetails.percentage && SipTopup.formData.topupDetails.percentage > 100\">percentage proportion should not be greater than 100</span></div></div></div><div class=row><div class=col-md-6><div class=install-freq><p><strong>Installment Frequency</strong></p><span class=radio-block ng-repeat=\"freq in SipTopup.topupFrequencyList\"><span class=radio><input type=radio ng-model=SipTopup.formData.topupDetails.frequency ng-value=freq.key name=topupFrequency ng-change=SipTopup.changeTopUpFreq()> <span class=check></span></span><label>{{freq.value}}</label></span></div></div></div><div class=\"row form-group\"><div class=col-md-3><div class=input-normal ng-class=\"{error:(SipTopup.formData.topupDetails.capAmount && SipTopup.isminCapAmount)}\"><input type=number ignore-mouse-wheel name=capAmount onkeyup=\"NumToWord(this.value,\'capAmntInWords\')\" ng-model=SipTopup.formData.topupDetails.capAmount ng-disabled=SipTopup.formData.topupDetails.capMonthYear autocomplete=off ng-change=SipTopup.capAmountChanged(sipTopupForm) ng-required=\"(!SipTopup.formData.topupDetails.capAmount && !SipTopup.formData.topupDetails.capMonthYear) || !SipTopup.formData.topupDetails.capMonthYear\"> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Cap Amount</label><span class=error-input ng-if=\"SipTopup.formData.topupDetails.capAmount && SipTopup.isminCapAmount\"><span>{{\'Minimum amount should be &#8377;\'+ SipTopup.minCapAmount+\'\'}}</span></span><div ng-if=SipTopup.formData.topupDetails.capAmount class=amount-in-words><span>(In Words)&nbsp;</span><div id=capAmntInWords></div></div></div></div><div class=\"col-md-1 or-part text-center\">OR</div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{\'anything-disabled\': SipTopup.formData.topupDetails.capAmount }\"><select class=\"browser-default custom-select\" name=capDates ng-disabled=SipTopup.formData.topupDetails.capAmount ng-options=\"_dates for _dates in SipTopup.capDates\" ng-model=SipTopup.formData.topupDetails.capMonthYear ng-required=\"(!SipTopup.formData.topupDetails.capAmount && !SipTopup.formData.topupDetails.capMonthYear) || !SipTopup.formData.topupDetails.capAmount\"><option value=\"\">Cap Month Year - MM/YYYY</option></select></div></div></div></div></div></div></div></div><div class=\"col-md-12 form-footer form-content\"><button type=button ng-click=SipTopup.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"sipTopupForm.$invalid || (!SipTopup.formData.topupDetails.percentage && !SipTopup.isMultipleTopupAmount) || (!SipTopup.formData.topupDetails.percentage && SipTopup.isMinTopupAmount) || (!SipTopup.formData.topupDetails.amount && SipTopup.isMinTopupPercentage) || (!SipTopup.formData.topupDetails.amount && !SipTopup.isMultipleTopupPercentage) || (SipTopup.formData.topupDetails.percentage && SipTopup.formData.topupDetails.percentage > 100 ) || SipTopup.amountExceeded\" class=\"btn btn-primary-action\" ng-click=SipTopup.submitTopupForm()>Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/smart-swap/smart-swap.html","<section class=\"initiate-transition swp\" ng-init=SmartSwap.init()><div class=content-header><h5>Transaction for {{SmartSwap.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>SMART SWAP</li></ul></div><div class=content><div class=form-box><form autocomplete=off name=SmartSwap.SwpForm ng-keypress=SmartSwap.handleEnter($event) novalidate><div class=\"col-md-4 form-grid\"><label>Select Scheme for Withdrawal</label><div class=form-group><div class=selectfield ng-class={error:(SmartSwap.SwpForm.folioNumber.$touched&&SmartSwap.SwpForm.folioNumber.$dirty&&SmartSwap.SwpForm.folioNumber.$invalid)||!SmartSwap.hasFolioEmailId}><label>Select Folio</label><select class=\"browser-default custom-select\" name=folioNumber ng-change=SmartSwap.changeFolio() ng-model=SmartSwap.formData.folioNumber required><option value=\"\" selected>Select Folio</option><option ng-repeat=\"_type in SmartSwap.folioListData\" ng-class=\"{\'disabled-option\' : !_type.activeFlag}\" ng-model=SmartSwap.formData.folioNumber ng-disabled=!_type.activeFlag ng-value=_type.folioNo>{{ _type.folioNo }}</option></select><span ng-show=\"SmartSwap.SwpForm.folioNumber.$touched && SmartSwap.SwpForm.folioNumber.$dirty && SmartSwap.SwpForm.folioNumber.$invalid\"><span class=error-input ng-show=SmartSwap.SwpForm.folioNumber.$error.required ng-bind=SmartSwap.validateData.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=!SmartSwap.hasFolioEmailId ng-bind=SmartSwap.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:SmartSwap.SwpForm.scheme.$touched && SmartSwap.SwpForm.scheme.$dirty && SmartSwap.SwpForm.scheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=SmartSwap.fetchUnitDetails() ng-model=SmartSwap.formData.schemeCode ng-options=\"_type.schemeCode as _type.schemeName for _type in SmartSwap.schemes\" ng-value=_type.schemeName required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"SmartSwap.SwpForm.scheme.$touched && SmartSwap.SwpForm.scheme.$dirty && SmartSwap.SwpForm.scheme.$invalid && SmartSwap.schemes.length!==0\"><span class=error-input ng-show=SmartSwap.SwpForm.scheme.$error.required ng-bind=SmartSwap.validateData.SCHEME_REQUIRED></span> </span><span class=error-input style=\"position:relative; top: 10px\" ng-if=\"SmartSwap.schemes.length===0\">The fund / Scheme part of your portfolio are not applicable for SMART SWAP. Kindly <span ng-click=SmartSwap.termsAndContitions(); style=\"text-decoration: underline\" class=\"cursor-pointer text-primary\">Click Here</span> for details</span></div></div><div class=form-group ng-if=SmartSwap.unitsDetails><div class=\"value-box current-val\"><p>Total Current Value</p><p><span easyassist-key=mask-element>{{SmartSwap.unitsDetails.totalCurrentValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{SmartSwap.unitsDetails.totalCurrentValueAmount |unit:SmartSwap.unitsDetails.totalCurrentValueAmountUnit}} {{SmartSwap.unitsDetails.totalCurrentValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box locked-val\"><p>Locked Value</p><p><span easyassist-key=mask-element>{{SmartSwap.unitsDetails.lockedValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{SmartSwap.unitsDetails.lockedValueAmount|unit:SmartSwap.unitsDetails.lockedValueAmountUnit}} {{SmartSwap.unitsDetails.lockedValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box free-val\"><p class=marginTopSwp>Free Value</p><p><span class=rightborderSwp easyassist-key=mask-element>{{SmartSwap.unitsDetails.freeValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{SmartSwap.unitsDetails.freeValueAmount|unit:SmartSwap.unitsDetails.freeValueAmountUnit}} {{SmartSwap.unitsDetails.freeValueAmountUnit|unitValue}}</span></p><br><span ng-if=SmartSwap.isSchemeDisabled style=color:#d92018>This scheme is not enable for SMART SWAP</span></div></div></div><div class=\"col-md-4 form-grid\" ng-class=\"{\'anything-disabled\': !SmartSwap.formData.folioNumber || !SmartSwap.formData.schemeCode}\"><label>Select Withdrawal Options</label><div class=form-group><div class=selectfield ng-class=\"{error:SmartSwap.SwpForm.frequency.$dirty && SmartSwap.SwpForm.frequency.$invalid}\"><label>Select Frequency</label><select class=\"browser-default custom-select\" name=frequency ng-disabled=\"(SmartSwap.validationsData.swpEnabled == \'N\')\" ng-model=SmartSwap.formData.selectedFrequency ng-options=\"key for (key,value) in SmartSwap.frequencyList\" required><option value=\"\" selected>Select Frequency</option></select><span ng-show=\"SmartSwap.SwpForm.frequency.$dirty && SmartSwap.SwpForm.frequency.$invalid\"><span class=error-input ng-show=SmartSwap.SwpForm.frequency.$error.required ng-bind=SmartSwap.validateData.FREQUENCY_REQUIRED></span></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:SmartSwap.SwpForm.percentage.$dirty && SmartSwap.SwpForm.percentage.$invalid}\"><label ng-if=SmartSwap.formData.percentage>Select Percentage(per annum)</label><select class=\"browser-default custom-select\" name=percentage ng-model=SmartSwap.formData.percentage ng-options=\"percentage as percentage for percentage in SmartSwap.percentageList\" ng-init=\"SmartSwap.formData.percentage=SmartSwap.formData.percentage?SmartSwap.formData.percentage: null\" required><option value=\"\" selected>Select Percentage(per annum)</option></select><span ng-show=\"SmartSwap.SwpForm.percentage.$dirty && SmartSwap.SwpForm.percentage.$invalid\"><span class=error-input ng-show=SmartSwap.SwpForm.percentage.$error.required ng-bind=SmartSwap.validateData.PERCENT_REQUIRED></span></span></div></div><div ng-if=!SmartSwap.isReseting><div class=form-group><label class=dates>Start Date</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode={{SmartSwap.viewMode}} data-format={{SmartSwap.startDateFormat}} data-date-default=SmartSwap.startDate data-min-date=SmartSwap.startMinDate data-max-date=SmartSwap.startMaxDate data-on-date-change=SmartSwap.changeStartDate id=startDate><!--data-enabled-dates=\"SmartSwap.enabledStartDates\"--> <input type=text class=form-control placeholder=\"Start Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"SmartSwap.SwpForm.startMonth.$touched && SmartSwap.SwpForm.startMonth.$dirty && SmartSwap.SwpForm.startMonth.$invalid\"><span class=error-input ng-show=SmartSwap.SwpForm.startMonth.$error.required ng-bind=SmartSwap.validateData.FOLIO_REQUIRED></span></span></div></div></div></div><div class=\"col-md-4 form-grid\" ng-if=\"SmartSwap.formData.swpType !== SmartSwap.transactionConstants.CAPITAL_APPRECIATION\"><label>Select Withdrawal Amount</label><div class=form-group><div class=\"input-normal enter-amount\" ng-class=\"{error:(SmartSwap.SwpForm.amount.$touched && SmartSwap.SwpForm.amount.$dirty && SmartSwap.SwpForm.amount.$invalid)||(SmartSwap.formData.amount&&(SmartSwap.isMax||SmartSwap.isMin))}\"><input type=text ignore-mouse-wheel name=amount ng-disabled=\"!SmartSwap.unitsDetails || !SmartSwap.formData.selectedFrequency || !SmartSwap.formData.percentage || !SmartSwap.startDate\" ng-model=SmartSwap.formData.amount autocomplete=off maxlength=12 ng-change=SmartSwap.checkValidations() class=pd20 onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required> <span class=highlight></span> <span class=bar></span><label>SMART SWAP Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"SmartSwap.SwpForm.amount.$touched && SmartSwap.SwpForm.amount.$dirty && SmartSwap.SwpForm.amount.$invalid\"><span class=error-input ng-show=SmartSwap.SwpForm.amount.$error.required ng-bind=SmartSwap.validateData.AMOUNT_REQUIRED></span> </span><span ng-if=\"SmartSwap.SwpForm.amount.$valid && SmartSwap.isMin\" class=error-input>{{\'Minimum amount should be \'+ SmartSwap.validations.minAmount}} </span><span ng-if=\"SmartSwap.SwpForm.amount.$valid && SmartSwap.isMax\" class=error-input>Maximum amount should be {{SmartSwap.validations.maxAmount}}</span></div></div><div><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=\"col-md-12 tc-block\" ng-show=SmartSwap.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=SmartSwap.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=SmartSwap.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><button ng-click=SmartSwap.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!SmartSwap.isCheckedTandC || !SmartSwap.hasFolioEmailId||SmartSwap.SwpForm.$invalid\n          ||SmartSwap.isSubmitted||SmartSwap.isMax||SmartSwap.isMin\n          ||!SmartSwap.startDate\" ng-click=SmartSwap.submitFirst() class=\"btn btn-primary-action\">Initiate Transaction</button></div></form></div></div></section>");
$templateCache.put("app/transactions/initiate/stp/stp.html","<section class=\"initiate-transition stp no-overflow\" ng-init=InitiateTransactionStp.init()><div class=content-header><h5>Transaction for {{InitiateTransactionStp.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Systematic Transfer Plan</li></ul></div><div class=content><form autocomplete=off name=InitiateTransactionStp.stpForm ng-keypress=InitiateTransactionStp.handleEnter($event) novalidate><div class=top-wrap ng-if=!InitiateTransactionStp.oversea_arn><div class=row><div class=col-md-4><label>Sub Broker ARN</label><div class=form-group><div><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionStp.formData.subBrokerARN ng-change=InitiateTransactionStp.changeSubBrokerArn() ng-blur=InitiateTransactionStp.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><p ng-if=InitiateTransactionStp.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{InitiateTransactionStp.subBrokerName}}</p><span class=error-input ng-if=\"InitiateTransactionStp.stpForm.subBrokerARN.$dirty && InitiateTransactionStp.stpForm.subBrokerARN.$invalid && InitiateTransactionStp.stpForm.subBrokerARN.$error.pattern\">{{InitiateTransactionStp.validateData.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionStp.subBrokerCodeError != \'\' &&  !InitiateTransactionStp.stpForm.subBrokerARN.$invalid && InitiateTransactionStp.formData.subBrokerARN\" ng-bind=InitiateTransactionStp.subBrokerCodeError></span></div></div></div></div><div class=col-md-1></div><div class=col-md-4><label>Sub Broker Code<span class=req ng-if=InitiateTransactionStp.formData.subBrokerARN></span></label><div class=form-group><div><div class=input-normal ng-class={error:InitiateTransactionStp.stpForm.subBrokerCode.$dirty&&InitiateTransactionStp.stpForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionStp.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionStp.formData.subBrokerARN || InitiateTransactionStp.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionStp.stpForm.subBrokerCode.$dirty&&InitiateTransactionStp.stpForm.subBrokerCode.$error.required ng-bind=InitiateTransactionStp.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></div></div></div><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionStp.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionStp.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=input-normal><input type=text name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-keydown=\"$event.which === 13 && Transaction.searchDistributor()\" ng-required=Transaction.isRequired&&Transaction.formData.isThroughDistributor> <span class=highlight></span> <span class=bar></span><label>ARN</label><span class=error-input ng-show=fForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span></div></div><div class=col-md-4><div class=input-normal><input type=text name=euin id=euin ng-model=Transaction.formData.euin autocomplete=off> <span class=highlight></span> <span class=bar></span><label>EUIN (Optional)</label></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Scheme for Transfer</label><div class=form-group><div class=selectfield ng-class={error:!InitiateTransactionStp.hasFolioEmailId||(InitiateTransactionStp.stpForm.folioNumber.$dirty&&InitiateTransactionStp.stpForm.folioNumber.$invalid)}><label>Select Folio</label><select class=\"browser-default custom-select\" name=folioNumber ng-change=InitiateTransactionStp.changeFolio() ng-model=InitiateTransactionStp.formData.folioNumber ng-options=\"_type.folioNo as _type.folioNo disable when (!_type.activeFlag) for _type in InitiateTransactionStp.folioListData\" options-class=\"{\'disabled-option\' : !_type.activeFlag}\" required><option value=\"\">Select Folio</option></select><span ng-show=\"InitiateTransactionStp.stpForm.folioNumber.$dirty && InitiateTransactionStp.stpForm.folioNumber.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.folioNumber.$error.required ng-bind=InitiateTransactionStp.validateData.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=!InitiateTransactionStp.hasFolioEmailId ng-bind=InitiateTransactionStp.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionStp.stpForm.scheme.$dirty && InitiateTransactionStp.stpForm.scheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=InitiateTransactionStp.fetchUnitDetails() ng-model=InitiateTransactionStp.formData.schemeCode ng-options=\"_type.schemeCode as _type.schemeName for _type in InitiateTransactionStp.schemes\" ng-value=_type.schemeName required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"InitiateTransactionStp.stpForm.scheme.$dirty && InitiateTransactionStp.stpForm.scheme.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.scheme.$error.required ng-bind=InitiateTransactionStp.validateData.SCHEME_REQUIRED></span></span></div></div><div class=form-group ng-if=InitiateTransactionStp.unitsDetails><div class=\"value-box current-val\"><p>Total Current Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionStp.unitsDetails.totalCurrentValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionStp.unitsDetails.totalCurrentValueAmount |unit:InitiateTransactionStp.unitsDetails.totalCurrentValueAmountUnit}} {{InitiateTransactionStp.unitsDetails.totalCurrentValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box locked-val\"><p>Locked Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionStp.unitsDetails.lockedValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionStp.unitsDetails.lockedValueAmount|unit:InitiateTransactionStp.unitsDetails.lockedValueAmountUnit}} {{InitiateTransactionStp.unitsDetails.lockedValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box free-val\"><p>Free Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionStp.unitsDetails.freeValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionStp.unitsDetails.freeValueAmount|unit:InitiateTransactionStp.unitsDetails.freeValueAmountUnit}} {{InitiateTransactionStp.unitsDetails.freeValueAmountUnit|unitValue}}</span></p></div><div class=value-box ng-if=InitiateTransactionStp.unitsDetails.message><p>Note:</p><span style=padding-left:16px class=error-message>{{InitiateTransactionStp.unitsDetails.message}}</span></div></div></div><div class=\"col-md-4 form-grid\"><label>Scheme to Transfer in</label><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionStp.stpForm.inScheme.$dirty && InitiateTransactionStp.stpForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-model=InitiateTransactionStp.selectedInScheme ng-change=InitiateTransactionStp.filterInSchemeList() ng-disabled=InitiateTransactionStp.unitsDetails.message ng-blur=InitiateTransactionStp.checkValidScheme() autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span ng-show=\"InitiateTransactionStp.stpForm.inScheme.$dirty && InitiateTransactionStp.stpForm.inScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.inScheme.$error.required ng-bind=InitiateTransactionStp.validateData.SCHEME_REQUIRED></span></span><drop-down list-data=InitiateTransactionStp.filteredinSchemeList display-key=scheme hdfc-click=InitiateTransactionStp.inSchemeChanged(data) model=InitiateTransactionStp.formData.inSchemeCode for=inScheme></drop-down></div></div><div class=form-group><span>or </span><span class=scheme-list ng-click=InitiateTransactionStp.getSchemesList()><i class=list-icon></i><a>Select from list</a></span></div><div class=form-group ng-if=\"InitiateTransactionStp.validationsData.investmentOption===InitiateTransactionStp.transactionConstants.DIVIDEND\"><label>Select Income Distribution cum Capital Withdrawal (IDCW) Option</label><div class=radio-flex-div><span class=\"radio-block radio-flex\" ng-repeat=\"stpDevidendOption in InitiateTransactionStp.stpDevidendOptions\" ng-class=\"{\'anything-disabled\':(stpDevidendOption == InitiateTransactionStp.transactionConstants.REINVEST && InitiateTransactionStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionStp.transactionConstants.PAYOUT  && InitiateTransactionStp.validationsData.dividendPayoutApplicable === false)}\"><span class=\"radio radio-flex-span\"><input type=radio id=dividentOptionReinvest{{$index}} ng-value=stpDevidendOption name=dividentOption ng-model=InitiateTransactionStp.formData.dividentOption ng-disabled=\"InitiateTransactionStp.unitsDetails.message\n                            ||(stpDevidendOption == InitiateTransactionStp.transactionConstants.REINVEST  && InitiateTransactionStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionStp.transactionConstants.PAYOUT  && InitiateTransactionStp.validationsData.dividendPayoutApplicable === false)\"> <span class=check></span></span><label class=radio-flex-label for=dividentOptionReinvest{{$index}}>{{stpDevidendOption==InitiateTransactionStp.transactionConstants.REINVEST?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</label></span></div></div><div class=form-group><label>Select STP Type</label><div ng-if=!InitiateTransactionStp.isResetting><span class=radio-block><span class=radio><input ng-disabled=InitiateTransactionStp.unitsDetails.message type=radio id=fixedAmount name=stpType ng-model=InitiateTransactionStp.formData.stpType ng-value=InitiateTransactionStp.transactionConstants.FIXED_AMOUNT ng-click=InitiateTransactionStp.selectedStpType(InitiateTransactionStp.transactionConstants.FIXED_AMOUNT)> <span class=check></span></span><label for=fixedAmount>Fixed Amount</label></span><span ng-hide=\"InitiateTransactionStp.inSchemsType == \'NFO\'\" class=radio-block ng-if=\"InitiateTransactionStp.unitsDetails.investmentOption !== InitiateTransactionStp.transactionConstants.DIVIDEND\"><span class=radio><input type=radio id=capitalAppreciation name=stpType ng-disabled=InitiateTransactionStp.unitsDetails.message ng-model=InitiateTransactionStp.formData.stpType ng-value=InitiateTransactionStp.transactionConstants.CAPITAL_APPRECIATION ng-click=InitiateTransactionStp.selectedStpType(InitiateTransactionStp.transactionConstants.CAPITAL_APPRECIATION)> <span class=check></span></span><label for=capitalAppreciation>Capital Appreciation</label></span></div></div></div><div class=\"col-md-4 form-grid\"><label>Systematic Transfer Option</label><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionStp.stpForm.frequency.$dirty && InitiateTransactionStp.stpForm.frequency.$invalid}\"><label>Select Frequency</label><select ng-disabled=InitiateTransactionStp.unitsDetails.message class=\"browser-default custom-select\" name=frequency ng-change=InitiateTransactionStp.changeFrequency() ng-model=InitiateTransactionStp.selectedFrequency ng-options=\"_type.value for _type in InitiateTransactionStp.frequencyList\" required><option value=\"\" selected>Select Frequency</option></select><span ng-show=\"InitiateTransactionStp.stpForm.frequency.$dirty && InitiateTransactionStp.stpForm.frequency.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.frequency.$error.required ng-bind=InitiateTransactionStp.validateData.FREQUENCY_REQUIRED></span></span></div></div><div class=form-group ng-if=\"InitiateTransactionStp.displayWeekdays &&  InitiateTransactionStp.daysList\"><div class=selectfield ng-class=\"{error:InitiateTransactionStp.stpForm.day.$dirty && InitiateTransactionStp.stpForm.day.$invalid}\"><label>Select Day</label><select ng-disabled=InitiateTransactionStp.unitsDetails.message class=\"browser-default custom-select\" name=day ng-model=InitiateTransactionStp.formData.stpDay ng-options=\"day.name for day in InitiateTransactionStp.daysList\" ng-change=InitiateTransactionStp.changeDay() ng-value=day required><option value=\"\" selected>Select Day</option></select><span ng-show=\"InitiateTransactionStp.stpForm.day.$dirty && InitiateTransactionStp.stpForm.day.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.day.$error.required ng-bind=InitiateTransactionStp.validateData.DAY_REQUIRED></span></span></div></div><div ng-if=!InitiateTransactionStp.isResetting><div ng-if=InitiateTransactionStp.displayCalendar class=form-group><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionStp.startDateFormat}} data-viewmode={{InitiateTransactionStp.viewMode}} data-enabled-dates=InitiateTransactionStp.enabledStartDates data-date-default=InitiateTransactionStp.startDate data-min-date=InitiateTransactionStp.minDateStart data-max-date=InitiateTransactionStp.maxDateStart data-on-date-change=InitiateTransactionStp.changeStartDate id=startDate ng-class=\"{error:InitiateTransactionStp.stpForm.startMonth.$dirty && InitiateTransactionStp.stpForm.startMonth.$invalid}\"><input ng-disabled=InitiateTransactionStp.unitsDetails.message type=text class=form-control placeholder=\"Start Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"InitiateTransactionStp.stpForm.startMonth.$dirty && InitiateTransactionStp.stpForm.startMonth.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.startMonth.$error.required ng-bind=InitiateTransactionStp.validateData.FOLIO_REQUIRED></span></span></div></div><div class=form-group ng-if=\"InitiateTransactionStp.displayCalendar && !InitiateTransactionStp.isResetting\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionStp.startDateFormat}} data-viewmode={{InitiateTransactionStp.viewMode}} data-enabled-dates=InitiateTransactionStp.enabledEndDates data-date-default=InitiateTransactionStp.endDate data-min-date=InitiateTransactionStp.minEndDate data-max-date=InitiateTransactionStp.maxDateEnd data-on-date-change=InitiateTransactionStp.changeEndDate id=endDate focus-on=amount-field ng-class=\"{error:InitiateTransactionStp.stpForm.startMonth.$dirty && InitiateTransactionStp.stpForm.startMonth.$invalid\n                    || (!InitiateTransactionStp.endDate && InitiateTransactionStp.fill_end_date != \'\')}\"><input ng-disabled=InitiateTransactionStp.unitsDetails.message type=text class=form-control placeholder=\"End Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"(InitiateTransactionStp.stpForm.startMonth.$dirty && InitiateTransactionStp.stpForm.startMonth.$invalid)\n                  || (!InitiateTransactionStp.endDate && InitiateTransactionStp.fill_end_date != \'\')\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.startMonth.$error.required ng-bind=InitiateTransactionStp.validateData.FOLIO_REQUIRED></span> <span class=error-input ng-if=\"!InitiateTransactionStp.formData.endDate && InitiateTransactionStp.fill_end_date != \'\'\">{{InitiateTransactionStp.fill_end_date}}</span></span></div></div><span class=alert-warning ng-if=\"InitiateTransactionStp.fill_end_date != \'\' && InitiateTransactionStp.selectedFrequency.key != \'OW\'\">{{InitiateTransactionStp.fill_end_date}} <i ng-if=\"InitiateTransactionStp.validations.minAmount > 500 && InitiateTransactionStp.fill_end_date !=\'\'\" class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip title=\"If you are going to put your installment amount in between 500 to 999, please increase the no. of installment ( In this case, minimum no. of installment has to be 12).\"></i> </span><!--<div ng-if=\"InitiateTransactionStp.displayCalendar\" class=\"text-center form-group\">OR</div>--><div class=input-normal ng-if=\"!InitiateTransactionStp.displayCalendar  && InitiateTransactionStp.selectedFrequency.key == \'DZ\'\" ng-class=\"{error:(InitiateTransactionStp.stpForm.installment.$dirty && InitiateTransactionStp.stpForm.installment.$invalid)}\"><input type=number ignore-mouse-wheel name=installment ng-model=InitiateTransactionStp.formData.installment ng-min=InitiateTransactionStp.validationsData.dailyMinInstallmentNumber ng-blur=InitiateTransactionStp.changeInstallments() required><label>No. of Installments</label><span><span class=error-input ng-show=InitiateTransactionStp.stpForm.installment.$error.required ng-bind=InitiateTransactionStp.validateData.INSTALLMENT_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionStp.stpForm.installment.$error.min && !InitiateTransactionStp.stpForm.installment.$error.required\">Minimum installments should be {{InitiateTransactionStp.validationsData.dailyMinInstallmentNumber}}.</span> <span class=error-input ng-show=\"(InitiateTransactionStp.validations.maxInstallments > 0) &&\n                  InitiateTransactionStp.formData.installment > InitiateTransactionStp.validations.maxInstallments\">Maximum installments should be {{InitiateTransactionStp.validations.maxInstallments}}</span></span></div><div class=input-normal ng-if=\"!InitiateTransactionStp.displayCalendar && InitiateTransactionStp.selectedFrequency.key == \'OW\'\" ng-class=\"{error:(InitiateTransactionStp.stpForm.installment.$dirty && InitiateTransactionStp.stpForm.installment.$invalid)}\"><input type=number ignore-mouse-wheel name=installment ng-model=InitiateTransactionStp.formData.installment ng-min=InitiateTransactionStp.validationsData.weeklyMinInstallmentNumber ng-blur=InitiateTransactionStp.changeInstallments() required><label>No. of Installments</label><span><span class=error-input ng-show=InitiateTransactionStp.stpForm.installment.$error.required ng-bind=InitiateTransactionStp.validateData.INSTALLMENT_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionStp.stpForm.installment.$error.min && !InitiateTransactionStp.stpForm.installment.$error.required\">Minimum installments should be {{InitiateTransactionStp.validationsData.weeklyMinInstallmentNumber}}.</span> <span class=error-input ng-show=\"(InitiateTransactionStp.validations.maxInstallments > 0) &&\n                  InitiateTransactionStp.formData.installment > InitiateTransactionStp.validations.maxInstallments\">Maximum installments should be {{InitiateTransactionStp.validations.maxInstallments}}</span></span></div><div ng-if=\"InitiateTransactionStp.selectedFrequency.key == \'OW\'\"><span class=alert-warning ng-if=InitiateTransactionStp.formData.installment>{{InitiateTransactionStp.fill_end_date}} <i ng-if=\"InitiateTransactionStp.validations.minAmount > 500 && InitiateTransactionStp.fill_end_date !=\'\'\" class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip title=\"If you are going to put your installment amount in between 500 to 999, please increase the no. of installment ( In this case, minimum no. of installment has to be 12).\"></i></span></div><div ng-if=\"InitiateTransactionStp.formData.stpType!==InitiateTransactionStp.transactionConstants.CAPITAL_APPRECIATION\"><div class=form-group><div class=input-normal ng-class=\"{error:(InitiateTransactionStp.stpForm.stpAmount.$dirty && InitiateTransactionStp.stpForm.stpAmount.$invalid)||(InitiateTransactionStp.formData.amount&&(InitiateTransactionStp.isMax||InitiateTransactionStp.isMin||(!InitiateTransactionStp.isMultiples&&InitiateTransactionStp.validations.amountMultiples)))}\"><input type=number ignore-mouse-wheel name=stpAmount class=amount-field onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-disabled=\"InitiateTransactionStp.unitsDetails.message||!InitiateTransactionStp.unitsDetails||!InitiateTransactionStp.unitsDetails.freeValueAmount || !InitiateTransactionStp.selectedFrequency || (InitiateTransactionStp.unitsDetails.freeValueAmount<InitiateTransactionStp.validations.minAmount)\" ng-model=InitiateTransactionStp.formData.amount ng-change=\"InitiateTransactionStp.amountChanged(\'amount-field\')\" class=pd20 ng-blur=InitiateTransactionStp.blured() required> <span class=highlight></span> <span class=bar></span><label>STP Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InitiateTransactionStp.stpForm.stpAmount.$dirty && InitiateTransactionStp.stpForm.stpAmount.$invalid\"><span class=error-input ng-show=InitiateTransactionStp.stpForm.stpAmount.$error.required ng-bind=InitiateTransactionStp.validateData.AMOUNT_REQUIRED></span> </span><span ng-if=\"InitiateTransactionStp.stpForm.stpAmount.$valid && InitiateTransactionStp.isMin\" class=error-input>Minimum amount should be {{InitiateTransactionStp.validations.minAmount}} </span><span ng-if=\"InitiateTransactionStp.stpForm.stpAmount.$valid && InitiateTransactionStp.isMax\" class=error-input>Maximum amount should be {{InitiateTransactionStp.validations.maxAmount?InitiateTransactionStp.validations.maxAmount:InitiateTransactionStp.unitsDetails.freeValueAmount}} </span><span ng-if=InitiateTransactionStp.stpForm.stpAmount.$valid&&!InitiateTransactionStp.isMax&&!InitiateTransactionStp.isMin&&InitiateTransactionStp.validations.amountMultiples&&!InitiateTransactionStp.isMultiples class=error-input>Please Provide In Multiples Of &#x20B9; {{InitiateTransactionStp.validations.amountMultiples}}</span></div></div><div ng-if=InitiateTransactionStp.formData.amount><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div></div></div><div class=\"col-md-12 tc-block\" style=padding-left:34px ng-show=InitiateTransactionStp.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionStp.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionStp.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=col-md-12><ng-bind-html dynamic=InitiateTransactionStp.dynamicNote.Note_Review_STP.content></ng-bind-html></div><div class=\"col-md-12 form-footer form-content\"><button ng-click=InitiateTransactionStp.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button class=\"btn btn-primary-action\" ng-click=InitiateTransactionStp.submitFirst() ng-disabled=\"!InitiateTransactionStp.isCheckedTandC ||!InitiateTransactionStp.hasFolioEmailId||InitiateTransactionStp.isSubmitted||InitiateTransactionStp.stpForm.$invalid\n                  || ((!InitiateTransactionStp.endDate || !InitiateTransactionStp.startDate) && InitiateTransactionStp.selectedFrequency.value !=\'Daily\')\n                  ||(InitiateTransactionStp.formData.amount&&(InitiateTransactionStp.isMax||InitiateTransactionStp.isMin||(!InitiateTransactionStp.isMultiples&&InitiateTransactionStp.validations.amountMultiples)))\n                  || ((InitiateTransactionStp.validations.maxInstallments > 0) && InitiateTransactionStp.formData.installment > InitiateTransactionStp.validations.maxInstallments) || InitiateTransactionStp.showRetirementSchemeError\">Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/swingstp/swingstp.html","<section class=\"initiate-transition flex-stp\" ng-init=InitiateTransactionSwingStp.init()><div class=content-header><h5>Transaction for {{InitiateTransactionSwingStp.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Swing STP</li></ul></div><div class=content><form autocomplete=off name=InitiateTransactionSwingStp.FlexStpForm ng-keypress=InitiateTransactionSwingStp.handleEnter($event) novalidate><div class=top-wrap><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionSwingStp.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionSwingStp.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Scheme for Transfer</label><div class=selectfield ng-class=\"{error:(InitiateTransactionSwingStp.hasFolioEmailId == false)||InitiateTransactionSwingStp.FlexStpForm.folio.$dirty && InitiateTransactionSwingStp.FlexStpForm.folio.$invalid}\"><select class=\"browser-default custom-select\" name=folio ng-change=InitiateTransactionSwingStp.changeFolio() ng-model=InitiateTransactionSwingStp.formData.folioNumber ng-options=\"folio.folioNumber as folio.folioNumber disable when (!folio.activeFlag) for folio in InitiateTransactionSwingStp.folioListData\" options-class=\"{\'disabled-option\' : !folio.activeFlag}\" required><option value=\"\">Select Folio</option></select><label ng-if=InitiateTransactionSwingStp.formData.folioNumber>Select Folio</label><span class=error-input ng-show=\"InitiateTransactionSwingStp.FlexStpForm.folio.$dirty && InitiateTransactionSwingStp.FlexStpForm.folio.$error.required\" ng-bind=InitiateTransactionSwingStp.validateData.FOLIO_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionSwingStp.hasFolioEmailId == false\" ng-bind=InitiateTransactionSwingStp.validateData.FOLIO_EMAIL></span></div><div class=selectfield ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.outScheme.$dirty && InitiateTransactionSwingStp.FlexStpForm.outScheme.$invalid, \'anything-disabled\': !InitiateTransactionSwingStp.formData.folioNumber}\"><label ng-if=InitiateTransactionSwingStp.formData.outSchemeCode>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=InitiateTransactionSwingStp.fetchUnitDetails() ng-model=InitiateTransactionSwingStp.formData.schemeCode ng-options=\"_scheme.schemeCode as _scheme.schemeName for _scheme in InitiateTransactionSwingStp.schemes\" required><option value=\"\" selected>Select a Scheme</option></select><span class=error-input ng-show=\"InitiateTransactionSwingStp.FlexStpForm.outScheme.$dirty && InitiateTransactionSwingStp.FlexStpForm.outScheme.$error.required\" ng-bind=InitiateTransactionSwingStp.validateData.SCHEME_REQUIRED></span></div><div class=value-snippet ng-if=InitiateTransactionSwingStp.formData.schemeCode><div><p class=text-uppercase>Total Market Value<i class=tooltip-info-icon></i></p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionSwingStp.unitsDetails.totalCurrentValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=blue-rupee-icon></i> {{InitiateTransactionSwingStp.unitsDetails.totalCurrentValueAmount|unit}}</span></div><div class=red-snip><p class=text-uppercase>Locked Value</p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionSwingStp.unitsDetails.lockedValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-red-icon></i> {{InitiateTransactionSwingStp.unitsDetails.lockedValueAmount|unit}}</span></div><div class=green-snip><p class=text-uppercase>Free Value<i class=tooltip-info-icon></i></p><span class=left-val easyassist-key=mask-element>{{InitiateTransactionSwingStp.unitsDetails.freeValueUnits|unit}} Units </span><span easyassist-key=mask-element><i class=rupee-green-icon></i> {{InitiateTransactionSwingStp.unitsDetails.freeValueAmount|unit}}</span></div><p class=error-message>{{InitiateTransactionSwingStp.unitsDetails.message}}</p></div></div><div class=\"col-md-4 form-grid\" ng-class=\"{\'anything-disabled\': !InitiateTransactionSwingStp.formData.folioNumber || InitiateTransactionSwingStp.unitsDetails.message !=\'\'}\"><label>Scheme to Transfer in</label><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.inScheme.$dirty\n                                && InitiateTransactionSwingStp.FlexStpForm.inScheme.$invalid}\"><input type=text name=inScheme id=inScheme ng-model=InitiateTransactionSwingStp.selectedInScheme ng-change=\"InitiateTransactionSwingStp.isSelectedInScheme=(InitiateTransactionSwingStp.selectedInScheme.length>0) ? false:true\" ng-blur=InitiateTransactionSwingStp.checkValidScheme() autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span class=error-input ng-show=\"InitiateTransactionSwingStp.FlexStpForm.inScheme.$dirty && InitiateTransactionSwingStp.FlexStpForm.inScheme.$error.required\" ng-bind=InitiateTransactionSwingStp.validateData.SCHEME_REQUIRED></span><div class=\"suggestion box-shadow\" ng-hide=\"(InitiateTransactionSwingStp.allSchemesList|filter:{scheme:InitiateTransactionSwingStp.selectedInScheme}).length == 0 || InitiateTransactionSwingStp.isSelectedInScheme\"><ul><li ng-repeat=\"schemeData in InitiateTransactionSwingStp.allSchemesList | filter:{scheme:InitiateTransactionSwingStp.selectedInScheme}\" ng-click=InitiateTransactionSwingStp.inSchemeChanged(schemeData);>{{schemeData.scheme}}</li></ul></div></div><div class=\"form-group text-center\"><p>OR</p><br><p><i class=list-icon></i> <span class=\"text-primary cursor-pointer\" ng-click=InitiateTransactionSwingStp.getSchemesList()>Select from list</span></p></div><div class=form-group ng-if=\"InitiateTransactionSwingStp.validationsData.investmentOption===InitiateTransactionSwingStp.transactionConstants.DIVIDEND\"><label>Select IDCW option</label><div><span class=radio-block ng-repeat=\"stpDevidendOption in InitiateTransactionSwingStp.stpDevidendOptions\" ng-class=\"{\'anything-disabled\': InitiateTransactionSwingStp.unitsDetails.message\n                            ||(stpDevidendOption == InitiateTransactionSwingStp.transactionConstants.REINVEST && InitiateTransactionSwingStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionSwingStp.transactionConstants.PAYOUT  && InitiateTransactionSwingStp.validationsData.dividendPayoutApplicable === false)}\"><span class=radio><input type=radio id=dividentOptionReinvest{{$index}} ng-value=stpDevidendOption name=dividentOption ng-model=InitiateTransactionSwingStp.formData.dividentOption ng-disabled=\"InitiateTransactionSwingStp.unitsDetails.message\n                            ||(stpDevidendOption == InitiateTransactionSwingStp.transactionConstants.REINVEST && InitiateTransactionSwingStp.validationsData.dividendReinvestmentApplicable === false)\n                            ||(stpDevidendOption == InitiateTransactionSwingStp.transactionConstants.PAYOUT  && InitiateTransactionSwingStp.validationsData.dividendPayoutApplicable === false)\"> <span class=check></span></span><label for=dividentOptionReinvest{{$index}}>{{stpDevidendOption==InitiateTransactionSwingStp.transactionConstants.REINVEST?\'Re-invest\':\'Payout\'}}</label></span></div></div><div class=selectfield ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.frequency.$dirty && InitiateTransactionSwingStp.FlexStpForm.frequency.$invalid}\"><label>Select Frequency of Flex STP</label><select class=\"browser-default custom-select\" name=frequency ng-disabled=\"(InitiateTransactionSwingStp.validations.isEnabled == \'N\')||(!InitiateTransactionSwingStp.unitsDetails.freeValueUnits)\" ng-change=InitiateTransactionSwingStp.changeFrequency() ng-model=InitiateTransactionSwingStp.selectedFrequency ng-options=\"_frequency as _frequency.value for _frequency in InitiateTransactionSwingStp.frequencyList\" required><option value=\"\" selected>Select Frequency of Flex STP</option></select><span class=error-input ng-show=\"InitiateTransactionSwingStp.FlexStpForm.frequency.$dirty && InitiateTransactionSwingStp.FlexStpForm.frequency.$error.required\" ng-bind=InitiateTransactionSwingStp.validateData.FREQUENCY_REQUIRED></span></div><div class=form-group ng-if=\"InitiateTransactionSwingStp.fields.showDateOfTransfer && InitiateTransactionSwingStp.selectedFrequency\"><div class=selectfield ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.day.$dirty && InitiateTransactionSwingStp.FlexStpForm.day.$invalid}\"><label>Date of Transfer</label><select class=\"browser-default custom-select\" name=day ng-model=InitiateTransactionSwingStp.formData.stpDay ng-change=InitiateTransactionSwingStp.changeDay() ng-options=\"day.name for day in InitiateTransactionSwingStp.daysList\" required><option value=\"\" selected>{{(InitiateTransactionSwingStp.selectedFrequency.key==\'OW\')?\'Day of Transfer\':\'Date of Transfer\'}}</option></select><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"InitiateTransactionSwingStp.FlexStpForm.day.$dirty && InitiateTransactionSwingStp.FlexStpForm.day.$error.required\" ng-bind=InitiateTransactionSwingStp.validateData.DAY_REQUIRED></span></div></div><!--<div class=\"form-group\" ng-if=\"InitiateTransactionSwingStp.fields.showDayOfTransfer\">--><!--<div class=\"selectfield\"--><!--ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.day.$invalid}\">--><!--<label ng-if=\"InitiateTransactionSwingStp.formData.day\">Day of Transfer</label>--><!--<select class=\"browser-default custom-select\" name=\"day\"--><!--ng-model=\"InitiateTransactionSwingStp.formData.day\"--><!--ng-change=\"InitiateTransactionSwingStp.changeDay()\"--><!--ng-options=\"day.value as day.name for day in InitiateTransactionSwingStp.weekList\"--><!--ng-required=\"InitiateTransactionSwingStp.isRequired\">--><!--<option value=\"\" selected>Day of Transfer</option>--><!--</select>--><!--<span class=\"error-input\" ng-show=\"InitiateTransactionSwingStp.FlexStpForm.day.$error.required\"--><!--ng-bind=\"InitiateTransactionSwingStp.validateData.DAY_REQUIRED\"></span>--><!--</div>--><!--</div>--><!--<div class=\"form-group\">--><!--<div class=\"selectfield\"--><!--ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.day.$invalid}\">--><!--<label ng-if=\"InitiateTransactionSwingStp.formData.day\">Day of Transfer</label>--><!--<select class=\"browser-default custom-select\" name=\"day\"--><!--ng-model=\"InitiateTransactionSwingStp.formData.day\"--><!--ng-disabled=\"(InitiateTransactionSwingStp.validations.isEnabled == \'N\')||(!InitiateTransactionSwingStp.unitsDetails.freeValueUnits)\"--><!--ng-change=\"InitiateTransactionSwingStp.helper.changeDay()\"--><!--ng-options=\"day.value as day.name for day in InitiateTransactionSwingStp.weekList\"--><!--ng-required=\"InitiateTransactionSwingStp.isRequired\">--><!--<option value=\"\" selected>Day of Transfer</option>--><!--</select>--><!--<span class=\"error-input\" ng-show=\"InitiateTransactionSwingStp.FlexStpForm.day.$error.required\"--><!--ng-bind=\"InitiateTransactionSwingStp.validateData.DAY_REQUIRED\"></span>--><!--</div>--><!--</div>--><div ng-if=!InitiateTransactionSwingStp.isResetting><div ng-if=\"InitiateTransactionSwingStp.fields.showStartEndDate && InitiateTransactionSwingStp.selectedFrequency\" class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionSwingStp.startDateFormat}} data-viewmode={{InitiateTransactionSwingStp.viewMode}} data-enabled-dates=InitiateTransactionSwingStp.enabledStartDates data-date-default=InitiateTransactionSwingStp.formData.startDate data-min-date=InitiateTransactionSwingStp.minStartDate data-on-date-change=InitiateTransactionSwingStp.changeStartDate id=startDate ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.endDate.$dirty && InitiateTransactionSwingStp.FlexStpForm.startDate.$invalid}\"><input type=text name=startDate ng-required=InitiateTransactionSwingStp.isRequired placeholder=\"Start Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionSwingStp.FlexStpForm.startDate.$error.required ng-bind=InitiateTransactionSwingStp.validateData.START_DATE_REQUIRED></span></div><div ng-if=\"InitiateTransactionSwingStp.fields.showStartEndDate && InitiateTransactionSwingStp.selectedFrequency\" class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-format={{InitiateTransactionSwingStp.startDateFormat}} data-viewmode={{InitiateTransactionSwingStp.viewMode}} data-enabled-dates=InitiateTransactionSwingStp.enabledEndDates data-date-default=InitiateTransactionSwingStp.formData.endDate data-on-date-change=InitiateTransactionSwingStp.changeEndDate id=endDate focus-on=amount-field ng-class=\"{error:(InitiateTransactionSwingStp.FlexStpForm.endDate.$dirty && InitiateTransactionSwingStp.FlexStpForm.endDate.$invalid)\n                  || (!InitiateTransactionSwingStp.formData.endDate && InitiateTransactionSwingStp.fill_end_date != \'\') }\"><input type=text name=endDate ng-required=InitiateTransactionSwingStp.isRequired placeholder=\"End Month - DD-MMM-YYYY\" ng-disabled=InitiateTransactionSwingStp.formData.installment readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionSwingStp.FlexStpForm.endDate.$error.required ng-bind=InitiateTransactionSwingStp.validateData.END_DATE_REQUIRED></span> <span class=error-input ng-if=\"!InitiateTransactionSwingStp.formData.endDate && InitiateTransactionSwingStp.fill_end_date != \'\'\">{{InitiateTransactionSwingStp.fill_end_date}}</span></div></div><div ng-if=InitiateTransactionSwingStp.fields.showInstallment><!--<div class=\"text-center form-group\" ng-if=\"InitiateTransactionSwingStp.showOrMessage\">OR</div>--><div class=input-normal ng-class=\"{error:InitiateTransactionSwingStp.FlexStpForm.installment.$dirty && InitiateTransactionSwingStp.FlexStpForm.installment.$invalid && !InitiateTransactionSwingStp.formData.endDate}\"><input name=installment type=number ignore-mouse-wheel ng-model=InitiateTransactionSwingStp.formData.installment ng-min=InitiateTransactionSwingStp.validations.minInstallments ng-max=InitiateTransactionSwingStp.validations.maxInstallments ng-change=InitiateTransactionSwingStp.changeInstallments() ng-disabled=InitiateTransactionSwingStp.formData.endDate required><label>No. of Installments</label><span ng-if=\"InitiateTransactionSwingStp.FlexStpForm.installment.$dirty && InitiateTransactionSwingStp.FlexStpForm.installment.$invalid\"></span> <span ng-show=\"InitiateTransactionSwingStp.FlexStpForm.installment.$dirty && InitiateTransactionSwingStp.FlexStpForm.installment.$error.required\" class=error-input>Installments is required</span> <span ng-show=\"InitiateTransactionSwingStp.FlexStpForm.installment.$dirty && InitiateTransactionSwingStp.FlexStpForm.installment.$error.min\" class=error-input>Minimum number of installments should be {{InitiateTransactionSwingStp.validations.minInstallments}}</span> <span ng-show=\"InitiateTransactionSwingStp.FlexStpForm.installment.$dirty && InitiateTransactionSwingStp.FlexStpForm.installment.$error.max\" class=error-input>Maximum number of installments should be {{InitiateTransactionSwingStp.validations.maxInstallments}}</span></div></div></div><div ng-class=\"{\'anything-disabled\': !InitiateTransactionSwingStp.formData.folioNumber || InitiateTransactionSwingStp.unitsDetails.message !=\'\'}\" class=\"col-md-4 form-grid\"><label>Systematic Transfer Amount</label><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateTransactionSwingStp.FlexStpForm.amount.$dirty && InitiateTransactionSwingStp.FlexStpForm.amount.$invalid)||(InitiateTransactionSwingStp.formData.amount&&(InitiateTransactionSwingStp.isMax||InitiateTransactionSwingStp.isMin||(!InitiateTransactionSwingStp.isMultiples&&InitiateTransactionSwingStp.validations.amountMultiples)))}\"><input type=number ignore-mouse-wheel name=amount class=amount-field ng-disabled=\"InitiateTransactionSwingStp.unitsDetails.message||!InitiateTransactionSwingStp.unitsDetails||!InitiateTransactionSwingStp.unitsDetails.freeValueAmount || !InitiateTransactionSwingStp.selectedFrequency || (InitiateTransactionSwingStp.unitsDetails.freeValueAmount<InitiateTransactionSwingStp.validations.minAmount)\" ng-model=InitiateTransactionSwingStp.formData.amount ng-change=\"InitiateTransactionSwingStp.amountChanged(\'amount-field\')\" onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-blur=InitiateTransactionSwingStp.blured() required> <span class=highlight></span> <span class=bar></span><label>Amount of Transfer per Installment</label><span class=text-support>(&#8377; {{InitiateTransactionSwingStp.validations.minAmount}} Minimum Amount)</span> <i class=rupee-grey-icon></i> <span class=error-input ng-if=\"InitiateTransactionSwingStp.FlexStpForm.amount.$dirty && InitiateTransactionSwingStp.FlexStpForm.amount.$invalid\">{{InitiateTransactionSwingStp.validateData.AMOUNT_REQUIRED}}</span> <span ng-if=\"InitiateTransactionSwingStp.FlexStpForm.amount.$valid && InitiateTransactionSwingStp.isMin\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSwingStp.validations.minAmount}} </span><span ng-if=\"InitiateTransactionSwingStp.FlexStpForm.amount.$valid && InitiateTransactionSwingStp.isMax\" class=error-input>Maximum amount should be {{InitiateTransactionSwingStp.validations.maxAmount?InitiateTransactionSwingStp.validations.maxAmount:InitiateTransactionSwingStp.unitsDetails.freeValueAmount}} </span><span ng-if=InitiateTransactionSwingStp.FlexStpForm.amount.$valid&&!InitiateTransactionSwingStp.isMax&&!InitiateTransactionSwingStp.isMin&&InitiateTransactionSwingStp.validations.amountMultiples&&!InitiateTransactionSwingStp.isMultiples class=error-input>Please Provide In Multiples Of &#x20B9; {{InitiateTransactionSwingStp.validations.amountMultiples}}</span></div><!--ng-if=\"InitiateTransactionSwingStp.formData.transferOption !== InitiateTransactionSwingStp.TRANSACTIONS_CONST.TRANSFER_OPTIONS.CAPITAL_APPRECIATION\"--><div class=form-group ng-if=InitiateTransactionSwingStp.formData.amount><label>(In Words)</label><div id=divDisplayWords></div></div></div><div class=\"col-md-12 tc-block\"><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionSwingStp.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionSwingStp.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionSwingStp.selectedInScheme\"\n                  ng-click=\"InitiateTransactionSwingStp.saveForm()\">Save</button>--> <button ng-click=InitiateTransactionSwingStp.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionSwingStp.hasFolioEmailId|| ((!InitiateTransactionSwingStp.formData.startDate || !InitiateTransactionSwingStp.formData.endDate) && InitiateTransactionSwingStp.selectedFrequency.key !==\'DZ\') || InitiateTransactionSwingStp.isSubmitted||InitiateTransactionSwingStp.FlexStpForm.$invalid||(InitiateTransactionSwingStp.formData.amount&&(InitiateTransactionSwingStp.isMax||InitiateTransactionSwingStp.isMin||(!InitiateTransactionSwingStp.isMultiples&&InitiateTransactionSwingStp.validations.amountMultiples)))\" ng-click=InitiateTransactionSwingStp.submitFirst() class=\"btn btn-primary-action\">Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/switch/switch.html","<section class=\"initiate-transition switch\" ng-init=InitiateTransactionSwitch.init()><div class=content-header><h5>Transaction for {{InitiateTransactionSwitch.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transaction</li><li><span class=breadcrumb-icon></span></li><li>Switch Transaction</li></ul></div><div class=content><!--    <form autocomplete=\"off\" name=\"InitiateTransactionSwitch.switchForm\" novalidate>--><form autocomplete=off name=InitiateTransactionSwitch.switchForm ng-keypress=InitiateTransactionSwitch.handleEnter($event) novalidate><div class=top-wrap ng-if=!InitiateTransactionSwitch.oversea_arn><div class=row><div class=col-md-4><label>Sub Broker ARN</label><div class=form-group><div><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=InitiateTransactionSwitch.formData.subBrokerARN ng-change=InitiateTransactionSwitch.changeSubBrokerArn() ng-blur=InitiateTransactionSwitch.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><p ng-if=InitiateTransactionSwitch.subBrokerName class=\"info-primary sub-broker-name\">Sub Broker Name: {{InitiateTransactionSwitch.subBrokerName}}</p><span class=error-input ng-if=\"InitiateTransactionSwitch.switchForm.subBrokerARN.$dirty && InitiateTransactionSwitch.switchForm.subBrokerARN.$invalid && InitiateTransactionSwitch.switchForm.subBrokerARN.$error.pattern\">{{InitiateTransactionSwitch.validateData.BROKER_VALID}}</span> <span class=error-input ng-show=\"InitiateTransactionSwitch.subBrokerCodeError != \'\' &&  !InitiateTransactionSwitch.switchForm.subBrokerARN.$invalid && InitiateTransactionSwitch.formData.subBrokerARN\" ng-bind=InitiateTransactionSwitch.subBrokerCodeError></span></div></div></div></div><div class=col-md-1></div><div class=col-md-4><label>Sub Broker Code<span class=req ng-if=InitiateTransactionSwitch.formData.subBrokerARN></span></label><div class=form-group><div><div class=input-normal ng-class={error:InitiateTransactionSwitch.switchForm.subBrokerCode.$dirty&&InitiateTransactionSwitch.switchForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=InitiateTransactionSwitch.formData.subBrokerCode autocomplete=off ng-disabled=\"!InitiateTransactionSwitch.formData.subBrokerARN || InitiateTransactionSwitch.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=InitiateTransactionSwitch.switchForm.subBrokerCode.$dirty&&InitiateTransactionSwitch.switchForm.subBrokerCode.$error.required ng-bind=InitiateTransactionSwitch.validateData.SUB_BROKER_REQUIRED></span></div></div></div></div></div><div class=row><div class=\"col-md-4 form-grid\"><label>EUIN No.</label><div class=form-group><div class=selectfield><label>Select</label><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionSwitch.formData.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionSwitch.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=\"req text-red\">*</span></div></div></div></div><div class=row ng-if=Transaction.formData.isThroughDistributor><div class=col-md-4><div class=input-normal><input type=text name=brokerCode id=brokerCode ng-model=Transaction.formData.brokerCode ng-change=\"Transaction.formData.brokerName=\'\'\" autocomplete=off ng-keydown=\"$event.which === 13 && Transaction.searchDistributor()\" ng-required=Transaction.isRequired&&Transaction.formData.isThroughDistributor> <span class=highlight></span> <span class=bar></span><label>ARN</label><span class=error-input ng-show=fForm.folio.$error.required ng-bind=Transaction.VALIDATE_DATA.BROKER_REQUIRED></span></div></div><div class=col-md-4><div class=input-normal><input type=text name=euin id=euin ng-model=Transaction.formData.euin autocomplete=off> <span class=highlight></span> <span class=bar></span><label>EUIN (Optional)</label></div></div></div></div><div class=\"normal-wrap form-box\"><div class=\"col-md-4 form-grid\"><label>Select Scheme For Switch Out</label><div class=form-group><div class=selectfield ng-class=\"{error:(InitiateTransactionSwitch.switchForm.folio.$touched&&InitiateTransactionSwitch.switchForm.folio.$dirty && InitiateTransactionSwitch.switchForm.folio.$invalid)||!InitiateTransactionSwitch.hasFolioEmailId}\"><label>Select Folio</label><select class=\"browser-default custom-select\" name=folio ng-change=InitiateTransactionSwitch.changeFolio() ng-model=InitiateTransactionSwitch.formData.selectedFolioNo required><option value=\"\" selected>Select Folio</option><option ng-repeat=\"_type in InitiateTransactionSwitch.folioListData\" ng-class=\"{\'disabled-option\' : !_type.activeFlag}\" ng-model=InitiateTransactionSwitch.formData.selectedFolioNo ng-disabled=!_type.activeFlag ng-value=_type.folioNo>{{ _type.folioNo }}</option></select><span ng-show=\"InitiateTransactionSwitch.switchForm.folio.$touched && InitiateTransactionSwitch.switchForm.folio.$dirty && InitiateTransactionSwitch.switchForm.folio.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.folio.$error.required ng-bind=InitiateTransactionSwitch.message.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=!InitiateTransactionSwitch.hasFolioEmailId ng-bind=InitiateTransactionSwitch.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionSwitch.switchForm.outScheme.$touched && InitiateTransactionSwitch.switchForm.outScheme.$dirty && InitiateTransactionSwitch.switchForm.outScheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=outScheme ng-change=InitiateTransactionSwitch.outSchemeChanged() ng-model=InitiateTransactionSwitch.formData.selectedOutScheme ng-options=\"_type.schemeCode as _type.schemeName for _type in InitiateTransactionSwitch.outSchemes\" ng-value=_type.schemeName required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"InitiateTransactionSwitch.switchForm.outScheme.$touched && InitiateTransactionSwitch.switchForm.outScheme.$dirty && InitiateTransactionSwitch.switchForm.outScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.outScheme.$error.required ng-bind=InitiateTransactionSwitch.message.SCHEME_REQUIRED></span></span></div></div><div class=form-group ng-if=InitiateTransactionSwitch.unitsDetails><div class=\"value-box current-val\"><p>Total Current Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionSwitch.unitsDetails.totalCurrentValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwitch.unitsDetails.totalCurrentValueAmount |unit:InitiateTransactionSwitch.unitsDetails.totalCurrentValueAmountUnit}} {{InitiateTransactionSwitch.unitsDetails.totalCurrentValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box locked-val\"><p>Locked Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionSwitch.unitsDetails.lockedValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwitch.unitsDetails.lockedValueAmount|unit:InitiateTransactionSwitch.unitsDetails.lockedValueAmountUnit}} {{InitiateTransactionSwitch.unitsDetails.lockedValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box free-val\"><p>Free Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionSwitch.unitsDetails.freeValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwitch.unitsDetails.freeValueAmount|unit:InitiateTransactionSwitch.unitsDetails.freeValueAmountUnit}} {{InitiateTransactionSwitch.unitsDetails.freeValueAmountUnit|unitValue}}</span></p></div></div></div><div class=\"col-md-4 form-grid\"><label>Select Scheme For Switch In</label><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionSwitch.switchForm.inScheme.$dirty && InitiateTransactionSwitch.switchForm.inScheme.$invalid}\"><input type=text name=switchScheme1 id=switchScheme1 ng-model=InitiateTransactionSwitch.selectedInScheme ng-change=InitiateTransactionSwitch.filterInSchemeList() ng-disabled=InitiateTransactionSwitch.unitsDetails.isDisabled ng-blur=InitiateTransactionSwitch.checkValidScheme() autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name</label><span ng-show=\"InitiateTransactionSwitch.switchForm.inScheme.$dirty && InitiateTransactionSwitch.switchForm.inScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.inScheme.$error.required ng-bind=InitiateTransactionSwitch.message.SCHEME_REQUIRED></span></span><drop-down list-data=InitiateTransactionSwitch.filteredinSchemeList display-key=scheme hdfc-click=InitiateTransactionSwitch.inSchemeChanged(data) model=InitiateTransactionSwitch.formData.inSchemeCode for=switchScheme1></drop-down></div></div><div class=form-group>or <span class=scheme-list ng-click=InitiateTransactionSwitch.getSchemesList()><i class=list-icon></i><a>Select from list</a></span></div><div class=form-group ng-if=\"InitiateTransactionSwitch.inSchemeValidations.investmentOption===InitiateTransactionSwitch.CONST.DIVIDEND\"><label>Select Income Distribution cum Capital Withdrawal (IDCW) Option</label><div class=radio-flex-div><span class=\"radio-block radio-flex\" ng-repeat=\"switchdevidendoption in InitiateTransactionSwitch.switchDevidendOptions\" ng-class=\"{\'anything-disabled\': (switchdevidendoption==InitiateTransactionSwitch.CONST.REINVEST&& InitiateTransactionSwitch.inSchemeValidations.dividendReinvestmentApplicable === false)\n                    ||(switchdevidendoption==InitiateTransactionSwitch.CONST.PAYOUT&& InitiateTransactionSwitch.inSchemeValidations.dividendPayoutApplicable === false)}\"><span class=\"radio radio-flex-span\"><input type=radio id=dividentOptionReinvest{{$index}} ng-value=switchdevidendoption name=switchDividentOption ng-model=InitiateTransactionSwitch.formData.switchDividentOption ng-disabled=\"(switchdevidendoption==InitiateTransactionSwitch.CONST.REINVEST&& InitiateTransactionSwitch.inSchemeValidations.dividendReinvestmentApplicable === false)\n                    ||(switchdevidendoption==InitiateTransactionSwitch.CONST.PAYOUT&& InitiateTransactionSwitch.inSchemeValidations.dividendPayoutApplicable === false)\"> <span class=check></span></span><label class=radio-flex-label for=dividentOptionReinvest{{$index}}>{{switchdevidendoption==InitiateTransactionSwitch.CONST.REINVEST?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</label></span></div></div><div class=\"tc-block form-group\" ng-if=InitiateTransactionSwitch.nfoEnabled><div class=checkbox><input name=isAutoSwitch ng-model=InitiateTransactionSwitch.formData.isAutoSwitch type=checkbox ng-change=InitiateTransactionSwitch.fetchNfoEnabledSchemes()> <i class=icon-checkbox></i> <span class=checkbox-text>Auto Switch on Maturity</span></div></div><div class=row ng-if=InitiateTransactionSwitch.formData.isAutoSwitch><div class=col-md-12><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:InitiateTransactionSwitch.switchForm.switchInScheme.$dirty && InitiateTransactionSwitch.switchForm.switchInScheme.$invalid}\"><input type=text name=switchInScheme ng-model=InitiateTransactionSwitch.selectedAutoSwitchInScheme ng-change=\"InitiateTransactionSwitch.isSelectedSwitchInScheme=(InitiateTransactionSwitch.selectedAutoSwitchInScheme.length>0) ? false:true\" required autocomplete=off ng-blur=InitiateTransactionSwitch.checkValidSwitchInScheme() capitalize> <span class=highlight></span> <span class=bar></span><label>Select a Scheme Name To Switch In</label><span ng-show=\"InitiateTransactionSwitch.switchForm.switchInScheme.$dirty && InitiateTransactionSwitch.switchForm.switchInScheme.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.switchInScheme.$error.required ng-bind=InitiateTransactionSwitch.message.SCHEME_REQUIRED></span></span><div class=\"suggestion box-shadow\" ng-hide=\"(InitiateTransactionSwitch.autoSwitchInSchemes|filter:{scheme:InitiateTransactionSwitch.selectedAutoSwitchInScheme}).length == 0 || InitiateTransactionSwitch.isSelectedSwitchInScheme\"><ul><li ng-repeat=\"schemeData in InitiateTransactionSwitch.autoSwitchInSchemes | filter:{scheme:InitiateTransactionSwitch.selectedAutoSwitchInScheme}\" ng-click=\"InitiateTransactionSwitch.selectedAutoSwitchInScheme=schemeData.scheme;InitiateTransactionSwitch.selectedAutoSwitchInScheme=true;InitiateTransactionSwitch.switchInSchemeChanged(schemeData);\">{{schemeData.scheme}}</li></ul></div></div></div><div class=form-group ng-if=\"InitiateTransactionSwitch.switchInSchemeValidations.investmentOption===InitiateTransactionSwitch.CONST.DIVIDEND\"><label>Select Income Distribution cum Capital Withdrawal (IDCW) Option</label><div><span class=radio-block ng-repeat=\"switchdividendoption in InitiateTransactionSwitch.switchDevidendOptions\"><span class=radio><input type=radio id=dividentOptionReinvestsw{{$index}} ng-value=switchdividendoption ng-disabled=\"(switchdividendoption==InitiateTransactionSwitch.CONST.REINVEST&& InitiateTransactionSwitch.switchInSchemeValidations.endingType === InitiateTransactionSwitch.ENDING_TYPES.CLOSED && InitiateTransactionSwitch.selectedSwitchInSchemeType==\'ELSS\') || InitiateTransactionSwitch.selectedSwitchInSchemeType==\'ELSS\'\" name=switchDividendOption ng-model=InitiateTransactionSwitch.formData.autoSwitchSchemeDividendOption> <span class=check></span></span><label for=dividentOptionReinvestsw{{$index}}>{{switchdividendoption==InitiateTransactionSwitch.CONST.REINVEST?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</label></span></div></div></div><div class=\"col-md-1 clearfix inline-style\"><span>or</span></div><div class=inline-style><a ng-click=InitiateTransactionSwitch.getAutoSwitchEnabledList() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div></div><div class=\"col-md-4 form-grid\"><label>Select Switch Value</label><div class=form-group><label>Switch by</label><div ng-class=\"{\'radio-disabled\':(InitiateTransactionSwitch.inSchemeValidations.switchInUnitEnabled==\'N\')}\"><span class=radio-block><span class=radio><input type=radio id=existingFolio name=amountType value=amount ng-model=InitiateTransactionSwitch.formData.amountType ng-disabled=\"(!InitiateTransactionSwitch.unitsDetails)||(InitiateTransactionSwitch.inSchemeValidations.switchInUnitEnabled==\'N\')\" ng-change=\"InitiateTransactionSwitch.changeAmountType(\'amount\')\"> <span class=check></span></span><label for=existingFolio>Amount</label></span><span class=radio-block><span class=radio><input type=radio id=allUnits name=amountType value=all_units ng-model=InitiateTransactionSwitch.formData.amountType ng-disabled=\"(!InitiateTransactionSwitch.unitsDetails)||(InitiateTransactionSwitch.inSchemeValidations.switchInUnitEnabled==\'N\')\" ng-change=\"InitiateTransactionSwitch.changeAmountType(\'all_units\')\"> <span class=check></span></span><label for=allUnits>All Free Units</label></span><span class=radio-block><span class=radio><input type=radio id=noOfUnits name=amountType value=units ng-model=InitiateTransactionSwitch.formData.amountType ng-disabled=\"(!InitiateTransactionSwitch.unitsDetails)||(InitiateTransactionSwitch.inSchemeValidations.switchInUnitEnabled==\'N\')\" ng-change=\"InitiateTransactionSwitch.changeAmountType(\'units\')\"> <span class=check></span></span><label for=noOfUnits>No. of Units</label></span></div></div><div class=form-group ng-if=\"InitiateTransactionSwitch.formData.amountType==\'amount\'\"><!--Amount--><div><div class=\"input-normal enter-amount\" ng-class=\"{error:InitiateTransactionSwitch.switchForm.switchAmount.$dirty && InitiateTransactionSwitch.switchForm.switchAmount.$invalid}\"><input ng-if=!InitiateTransactionSwitch.isReseting type=number name=switchAmount class=pd20 ignore-mouse-wheel ng-disabled=\"(!InitiateTransactionSwitch.unitsDetails.freeValueAmount)||(InitiateTransactionSwitch.inSchemeValidations.switchInUnitEnabled==\'N\')\" min={{InitiateTransactionSwitch.validationsApi.minAmount}} max={{InitiateTransactionSwitch.validationsApi.maxAmount}} onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-model=InitiateTransactionSwitch.formData.switchAmount required><!--\n                       ng-change=\"InitiateTransactionSwitch.changePurchaseAmount(sipPurchaseForm)\"--> <span class=highlight></span> <span class=bar></span><label>Enter Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InitiateTransactionSwitch.switchForm.switchAmount.$dirty && InitiateTransactionSwitch.switchForm.switchAmount.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.switchAmount.$error.required ng-bind=InitiateTransactionSwitch.validateData.AMOUNT_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionSwitch.switchForm.switchAmount.$error.min && !InitiateTransactionSwitch.switchForm.switchAmount.$error.max\">{{InitiateTransactionSwitch.validateData.MINIMUM_AMOUNT}} {{InitiateTransactionSwitch.validationsApi.minAmount|unit}}</span> <span class=error-input ng-show=InitiateTransactionSwitch.switchForm.switchAmount.$error.max>{{InitiateTransactionSwitch.validateData.MAX_AMOUNT}} {{InitiateTransactionSwitch.validationsApi.maxAmount|unit}}</span></span></div></div><div style=\"padding-top: 20px\"><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=form-group ng-if=\"InitiateTransactionSwitch.formData.amountType==\'all_units\'\"><!--All Units--><div><div class=unit-number><div class=input-normal ng-class=\"{error:(InitiateTransactionSwitch.validationsApi.minUnits>InitiateTransactionSwitch.formData.all_units) || (InitiateTransactionSwitch.validationsApi.maxUnits<InitiateTransactionSwitch.formData.all_units)}\"><input type=number name=all_units ng-model=InitiateTransactionSwitch.formData.all_units readonly value={{InitiateTransactionSwitch.unitsDetails.freeValueUnits}} ignore-mouse-wheel autocomplete=off> <span class=highlight></span> <span class=bar></span> <span class=error-input ng-show=\"InitiateTransactionSwitch.validationsApi.minUnits>InitiateTransactionSwitch.formData.all_units\">{{ InitiateTransactionSwitch.validateData.MINIMUM_UNIT }} {{InitiateTransactionSwitch.validationsApi.minUnits|unit}}</span> <span class=error-input ng-show=\"InitiateTransactionSwitch.validationsApi.maxUnits<InitiateTransactionSwitch.formData.all_units\">{{ InitiateTransactionSwitch.validateData.MAX_UNIT }} {{InitiateTransactionSwitch.validationsApi.maxUnits|unit}}</span></div></div></div></div><div class=form-group ng-if=\"InitiateTransactionSwitch.formData.amountType==\'units\'\"><!--No. of Units--><div><div class=\"input-normal enter-amount\" ng-class=\"{error:InitiateTransactionSwitch.switchForm.units.$dirty && InitiateTransactionSwitch.switchForm.units.$invalid}\"><input ng-if=!InitiateTransactionSwitch.isReseting type=number ignore-mouse-wheel min={{InitiateTransactionSwitch.validationsApi.minUnits}} ng-disabled=!InitiateTransactionSwitch.unitsDetails.freeValueUnits max={{InitiateTransactionSwitch.validationsApi.maxUnits}} name=units ng-model=InitiateTransactionSwitch.formData.units required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Enter Units</label><span ng-show=\"InitiateTransactionSwitch.switchForm.units.$dirty && InitiateTransactionSwitch.switchForm.units.$invalid\"><span class=error-input ng-show=InitiateTransactionSwitch.switchForm.units.$error.required ng-bind=InitiateTransactionSwitch.validateData.UNITS_REQUIRED></span> <span class=error-input ng-show=\"InitiateTransactionSwitch.switchForm.units.$error.min && !InitiateTransactionSwitch.switchForm.units.$error.max\">{{ InitiateTransactionSwitch.validateData.MINIMUM_UNIT }} {{InitiateTransactionSwitch.validationsApi.minUnits}}</span><!--|unit--> <span class=error-input ng-show=InitiateTransactionSwitch.switchForm.units.$error.max>{{ InitiateTransactionSwitch.validateData.MAX_UNIT }} {{InitiateTransactionSwitch.validationsApi.maxUnits}}</span><!--|unit--></span></div></div></div><div class=form-group><div class=estimate-block ng-if=\"InitiateTransactionSwitch.switchForm.$valid&&((InitiateTransactionSwitch.formData.all_units&&InitiateTransactionSwitch.validationsApi.minUnits<=InitiateTransactionSwitch.formData.all_units&&InitiateTransactionSwitch.validationsApi.maxUnits>=InitiateTransactionSwitch.formData.all_units)\n                      ||(InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validationsApi.minUnits<=InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validationsApi.maxUnits>=InitiateTransactionSwitch.formData.minUnits)\n                      ||(InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validationsApi.minAmount<=InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validationsApi.maxAmount>=InitiateTransactionSwitch.formData.switchAmount))\"><a href=javascript:void(0) ng-click=\"InitiateTransactionSwitch.downloadReport(InitiateTransactionSwitch.formData.selectedFolioNo, InitiateTransactionSwitch.formData.selectedOutScheme)\"><strong>Estimated Exit Load</strong></a><div>This transaction may have exit load charges as per AMC guidelines for this scheme</div></div></div></div><div class=\"col-md-12 tc-block\" ng-show=InitiateTransactionSwitch.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionSwitch.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionSwitch.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=col-md-12><!--dynamic note switch --><ng-bind-html dynamic=InitiateTransactionSwitch.DynamicNote.content></ng-bind-html></div><div class=\"col-md-12 form-footer form-content\"><!----><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionSwitch.formData.selectedOutScheme\"\n                  ng-click=\"InitiateTransactionSwitch.saveForm()\">Save\n          </button>--> <button type=button ng-click=InitiateTransactionSwitch.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionSwitch.isCheckedTandC || !InitiateTransactionSwitch.hasFolioEmailId||InitiateTransactionSwitch.isSubmitted||!InitiateTransactionSwitch.switchForm.$valid\n            ||((InitiateTransactionSwitch.formData.all_units&&InitiateTransactionSwitch.validationsApi.minUnits>InitiateTransactionSwitch.formData.all_units||InitiateTransactionSwitch.validationsApi.maxUnits<InitiateTransactionSwitch.formData.all_units)\n            ||(InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validationsApi.minUnits>InitiateTransactionSwitch.formData.units&&InitiateTransactionSwitch.validationsApi.maxUnits<InitiateTransactionSwitch.formData.units)\n            ||(InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validationsApi.minAmount>InitiateTransactionSwitch.formData.switchAmount&&InitiateTransactionSwitch.validationsApi.maxAmount<InitiateTransactionSwitch.formData.switchAmount)) || !InitiateTransactionSwitch.unitsDetails.totalCurrentValueUnits || InitiateTransactionSwitch.showRetirementSchemeError\" class=\"btn btn-primary-action\" ng-click=InitiateTransactionSwitch.submitFormFirst()>Initiate Transaction</button></div></div></form></div></section>");
$templateCache.put("app/transactions/initiate/swp/swp.html","<section class=\"initiate-transition swp\" ng-init=InitiateTransactionSwp.init()><div class=content-header><h5>Transaction for {{InitiateTransactionSwp.investorInfo.name}}</h5><ul class=list-inline><li><a ui-sref=main.dashboard>Dashboard </a></li><li><span class=breadcrumb-icon></span></li><li>Initiate Transasction</li><li><span class=breadcrumb-icon></span></li><li>Systematic Withdrawal Plan (SWP)</li></ul></div><div class=content><div class=form-box><form autocomplete=off name=InitiateTransactionSwp.SwpForm ng-keypress=InitiateTransactionSwp.handleEnter($event) novalidate><div class=\"col-md-4 form-grid\"><label>Select Scheme for Withdrawal</label><div class=form-group><div class=selectfield ng-class={error:(InitiateTransactionSwp.SwpForm.folioNumber.$touched&&InitiateTransactionSwp.SwpForm.folioNumber.$dirty&&InitiateTransactionSwp.SwpForm.folioNumber.$invalid)||!InitiateTransactionSwp.hasFolioEmailId}><label>Select Folio</label><select class=\"browser-default custom-select\" name=folioNumber ng-change=InitiateTransactionSwp.changeFolio() ng-model=InitiateTransactionSwp.formData.folioNumber required><option value=\"\" selected>Select Folio</option><option ng-repeat=\"_type in InitiateTransactionSwp.folioListData\" ng-class=\"{\'disabled-option\' : !_type.activeFlag}\" ng-model=InitiateTransactionSwp.formData.folioNumber ng-disabled=!_type.activeFlag ng-value=_type.folioNo>{{ _type.folioNo }}</option></select><span ng-show=\"InitiateTransactionSwp.SwpForm.folioNumber.$touched && InitiateTransactionSwp.SwpForm.folioNumber.$dirty && InitiateTransactionSwp.SwpForm.folioNumber.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.folioNumber.$error.required ng-bind=InitiateTransactionSwp.validateData.FOLIO_REQUIRED></span> </span><span class=error-input ng-show=!InitiateTransactionSwp.hasFolioEmailId ng-bind=InitiateTransactionSwp.validateData.FOLIO_EMAIL></span></div></div><div class=form-group><label>Select SWP Type</label><div ng-class=\"{\'radio-disabled\': (InitiateTransactionSwp.validationsData.swpEnabled == \'N\')||(InitiateTransactionSwp.unitsDetails.freeValueUnits == 0)}\" ng-if=!InitiateTransactionSwp.isReseting><span class=radio-block><span class=radio><input type=radio id=fixedAmount name=swpType ng-model=InitiateTransactionSwp.formData.swpType ng-disabled=\"(InitiateTransactionSwp.validationsData.swpEnabled == \'N\')||(InitiateTransactionSwp.unitsDetails.freeValueUnits == 0)\" ng-value=InitiateTransactionSwp.transactionConstants.FIXED_AMOUNT ng-click=InitiateTransactionSwp.selectedSwpType(InitiateTransactionSwp.transactionConstants.FIXED_AMOUNT);> <span class=check></span></span><label for=fixedAmount>Fixed Amount</label></span><span class=radio-block ng-if=\"InitiateTransactionSwp.validationsData.investmentOption !== InitiateTransactionSwp.transactionConstants.DIVIDEND\"><span class=radio><input type=radio id=capitalAppreciation name=swpType ng-disabled=\"(InitiateTransactionSwp.validationsData.swpEnabled == \'N\')||(InitiateTransactionSwp.unitsDetails.freeValueUnits == 0)\" ng-model=InitiateTransactionSwp.formData.swpType ng-value=InitiateTransactionSwp.transactionConstants.CAPITAL_APPRECIATION ng-click=InitiateTransactionSwp.selectedSwpType(InitiateTransactionSwp.transactionConstants.CAPITAL_APPRECIATION);> <span class=check></span></span><label for=capitalAppreciation>Capital Appreciation</label></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionSwp.SwpForm.scheme.$touched && InitiateTransactionSwp.SwpForm.scheme.$dirty && InitiateTransactionSwp.SwpForm.scheme.$invalid}\"><label>Select a Scheme</label><select class=\"browser-default custom-select\" name=scheme ng-change=InitiateTransactionSwp.fetchUnitDetails() ng-model=InitiateTransactionSwp.formData.schemeCode ng-options=\"_type.schemeCode as _type.schemeName for _type in InitiateTransactionSwp.schemes\" ng-value=_type.schemeName required><option value=\"\" selected>Select a Scheme</option></select><span ng-show=\"InitiateTransactionSwp.SwpForm.scheme.$touched && InitiateTransactionSwp.SwpForm.scheme.$dirty && InitiateTransactionSwp.SwpForm.scheme.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.scheme.$error.required ng-bind=InitiateTransactionSwp.validateData.SCHEME_REQUIRED></span></span></div></div><div class=form-group ng-if=InitiateTransactionSwp.unitsDetails><div class=\"value-box current-val\"><p>Total Current Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionSwp.unitsDetails.totalCurrentValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwp.unitsDetails.totalCurrentValueAmount |unit:InitiateTransactionSwp.unitsDetails.totalCurrentValueAmountUnit}} {{InitiateTransactionSwp.unitsDetails.totalCurrentValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box locked-val\"><p>Locked Value</p><p><span easyassist-key=mask-element>{{InitiateTransactionSwp.unitsDetails.lockedValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwp.unitsDetails.lockedValueAmount|unit:InitiateTransactionSwp.unitsDetails.lockedValueAmountUnit}} {{InitiateTransactionSwp.unitsDetails.lockedValueAmountUnit|unitValue}}</span></p></div><div class=\"value-box free-val\"><p class=marginTopSwp>Free Value</p><p><span class=rightborderSwp easyassist-key=mask-element>{{InitiateTransactionSwp.unitsDetails.freeValueUnits}} Units</span> <span easyassist-key=mask-element>&#x20B9; {{InitiateTransactionSwp.unitsDetails.freeValueAmount|unit:InitiateTransactionSwp.unitsDetails.freeValueAmountUnit}} {{InitiateTransactionSwp.unitsDetails.freeValueAmountUnit|unitValue}}</span></p><br><span ng-if=InitiateTransactionSwp.isSchemeDisabled style=color:#d92018>This scheme is not enable for SWP</span></div></div></div><div class=\"col-md-4 form-grid\"><label>Select Withdrawal Options</label><div class=form-group><div class=selectfield ng-class=\"{error:InitiateTransactionSwp.SwpForm.frequency.$dirty && InitiateTransactionSwp.SwpForm.frequency.$invalid}\"><label>Select Frequency</label><select class=\"browser-default custom-select\" name=frequency ng-disabled=\"(InitiateTransactionSwp.validationsData.swpEnabled == \'N\')||(InitiateTransactionSwp.unitsDetails.freeValueUnits === 0 ||InitiateTransactionSwp.unitsDetails.freeValueAmount === 0 )\" ng-change=InitiateTransactionSwp.changeFrequency() ng-model=InitiateTransactionSwp.formData.selectedFrequency ng-options=\"_type.value for _type in InitiateTransactionSwp.frequencyList\" required><option value=\"\" selected>Select Frequency</option></select><span ng-show=\"InitiateTransactionSwp.SwpForm.frequency.$dirty && InitiateTransactionSwp.SwpForm.frequency.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.frequency.$error.required ng-bind=InitiateTransactionSwp.validateData.FREQUENCY_REQUIRED></span></span></div></div><div ng-if=!InitiateTransactionSwp.isReseting><div class=form-group><label class=dates>Start Date</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode={{InitiateTransactionSwp.viewMode}} data-format={{InitiateTransactionSwp.startDateFormat}} data-date-default=InitiateTransactionSwp.startDate data-min-date=InitiateTransactionSwp.startMinDate data-max-date=InitiateTransactionSwp.startMaxDate data-on-date-change=InitiateTransactionSwp.changeStartDate id=startDate><!--data-enabled-dates=\"InitiateTransactionSwp.enabledStartDates\"--> <input type=text class=form-control placeholder=\"Start Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"InitiateTransactionSwp.SwpForm.startMonth.$touched && InitiateTransactionSwp.SwpForm.startMonth.$dirty && InitiateTransactionSwp.SwpForm.startMonth.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.startMonth.$error.required ng-bind=InitiateTransactionSwp.validateData.FOLIO_REQUIRED></span></span></div></div><div class=form-group><label class=dates>End Date</label><div class=\"input-select input-normal input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{InitiateTransactionSwp.startDateFormat}} data-enabled-dates=InitiateTransactionSwp.enabledEndDates data-min-date=InitiateTransactionSwp.minEndDate data-max-date=InitiateTransactionSwp.maxEndDate data-date-default=InitiateTransactionSwp.endDate data-on-date-change=InitiateTransactionSwp.changeEndDate data-view-date=InitiateTransactionSwp.enabledEndDates[0] id=endDate><input type=text class=form-control placeholder=\"End Month - DD-MMM-YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span ng-show=\"InitiateTransactionSwp.SwpForm.endMonth.$touched && InitiateTransactionSwp.SwpForm.endMonth.$dirty && InitiateTransactionSwp.SwpForm.endMonth.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.endMonth.$error.required ng-bind=InitiateTransactionSwp.validateData.FOLIO_REQUIRED></span></span></div></div></div></div><div class=\"col-md-4 form-grid\" ng-if=\"InitiateTransactionSwp.formData.swpType !== InitiateTransactionSwp.transactionConstants.CAPITAL_APPRECIATION\"><label>Select Withdrawal Amount</label><div class=form-group><div class=\"input-normal enter-amount\" ng-class=\"{error:(InitiateTransactionSwp.SwpForm.swpAmount.$touched && InitiateTransactionSwp.SwpForm.swpAmount.$dirty && InitiateTransactionSwp.SwpForm.swpAmount.$invalid)||(InitiateTransactionSwp.formData.swpAmount&&(InitiateTransactionSwp.isMax||InitiateTransactionSwp.isMin||(InitiateTransactionSwp.validations.amountMultiples&&!InitiateTransactionSwp.isMultiples)))}\"><input type=number ignore-mouse-wheel name=swpAmount ng-disabled=\"!InitiateTransactionSwp.unitsDetails||!InitiateTransactionSwp.unitsDetails.freeValueAmount || !InitiateTransactionSwp.formData.selectedFrequency\" ng-model=InitiateTransactionSwp.formData.swpAmount ng-change=InitiateTransactionSwp.checkValidations() class=pd20 onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" required> <span class=highlight></span> <span class=bar></span><label>SWP Amount</label><i class=rupee-grey-icon></i> <span ng-show=\"InitiateTransactionSwp.SwpForm.swpAmount.$touched && InitiateTransactionSwp.SwpForm.swpAmount.$dirty && InitiateTransactionSwp.SwpForm.swpAmount.$invalid\"><span class=error-input ng-show=InitiateTransactionSwp.SwpForm.swpAmount.$error.required ng-bind=InitiateTransactionSwp.validateData.AMOUNT_REQUIRED></span> </span><span ng-if=\"InitiateTransactionSwp.SwpForm.swpAmount.$valid && InitiateTransactionSwp.isMin\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSwp.validations.minAmount}} </span><span ng-if=\"InitiateTransactionSwp.SwpForm.swpAmount.$valid && InitiateTransactionSwp.isMax\" class=error-input>Maximum amount should be {{InitiateTransactionSwp.validations.maxAmount}} </span><span ng-if=InitiateTransactionSwp.SwpForm.swpAmount.$valid&&!InitiateTransactionSwp.isMax&&!InitiateTransactionSwp.isMin&&(InitiateTransactionSwp.validations.amountMultiples&&!InitiateTransactionSwp.isMultiples) class=error-input>Please Provide In Multiples Of &#x20B9; {{InitiateTransactionSwp.validations.amountMultiples}}</span></div><!-- <p ng-if=\"InitiateTransactionSwp.validations.amountMultiples\"\n                class=\"text-purple support-text pull-right text-warn\">( In Multiples Of\n                &#x20B9; {{InitiateTransactionSwp.validations.amountMultiples}} ) </p>--></div><div><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=\"col-md-12 tc-block\" ng-show=InitiateTransactionSwp.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=InitiateTransactionSwp.isCheckedTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=InitiateTransactionSwp.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div><div class=\"col-md-12 form-footer form-content\"><!--<button class=\"btn btn-secondary-action\" ng-disabled=\"!InitiateTransactionSwp.formData.schemeCode\"\n                  ng-click=\"InitiateTransactionSwp.saveForm()\">Save</button>--> <button ng-click=InitiateTransactionSwp.confirmCancel(); class=\"btn btn-secondary-action\">Cancel</button> <button ng-disabled=\"!InitiateTransactionSwp.isCheckedTandC || !InitiateTransactionSwp.hasFolioEmailId||InitiateTransactionSwp.SwpForm.$invalid\n          ||InitiateTransactionSwp.isSubmitted||InitiateTransactionSwp.isMax||InitiateTransactionSwp.isMin\n          ||(InitiateTransactionSwp.validations.amountMultiples&&!InitiateTransactionSwp.isMultiples)\n          ||!InitiateTransactionSwp.startDate || !InitiateTransactionSwp.endDate\" ng-click=InitiateTransactionSwp.submitFirst() class=\"btn btn-primary-action\">Initiate Transaction</button></div></form></div></div></section>");
$templateCache.put("app/transactions/list/all/transaction-all.html","<section class=\"transaction main-section\"><div class=\"loader allList\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your data...</span></div><ul class=\"nav nav-tabs transactions\"><li><a href=javascript:void(0); ui-sref=main.transactions.recent>Recent</a></li><li class=active-link><a href=javascript:void(0); ui-sref=main.transactions.all>All</a></li></ul><div class=tab-content ng-init=Transaction.init()><!-- TODO new filter for All transactions --><div class=filtered-transactions><div class=in-row><span ng-dropdown-multiselect=\"\" options=Transaction.TRANSACTION_TYPES selected-model=Transaction.transactionModel events=Transaction.transactionEvents extra-settings=Transaction.transactionSettings translation-texts=Transaction.transactionTranslationTexts class=transaction-type></span></div><div class=in-row ng-if=Transaction.isReset><input date-range=\"\" on-date-change=Transaction.filterByDate placeholder=\"From Date -> To Date\" date-min=Transaction.minDate date-max=Transaction.maxDate date-max-span=59 date-default=Transaction.dateFilter class=date-picker type=text></div><div class=in-row><select class=\"browser-default custom-select\" ng-change=Transaction.changeSelectedYear(); ng-model=Transaction.selectedYear ng-options=\"_statustype.key as _statustype.value for _statustype in Transaction.STATUS_YEAR\"></select></div><button class=apply-btn ng-if=false>Apply</button> <button class=apply-btn ng-if=false ng-click=Transaction.resetFilter()>Reset</button></div><div id=all class=\"tab-pane fade in active\"><div class=middle-flow><div class=status-filter><div class=\"col-md-2 col-sm-4 col-xs-6\" ng-repeat=\"_status in Transaction.TRANSACTION_STATUSES track by $index\"><span class=\"inline-block allTransactionsTabs\" ng-click=\"Investors.downloadReportList(\'Invester-list\');\"><div class=\"filter cursor-pointer {{_status.value.toLowerCase()}}\" ng-click=Transaction.statusChanged(_status) ng-class=\"{\'active-filter\':Transaction.selectedStatus.value===_status.value}\" tooltips tooltip-template={{Transaction.headerTooltip[_status.value]}}><p>{{_status.value}}</p><p>{{Transaction.snapshotData[_status.value.toLowerCase()+\'Count\'] | number : 0 }}</p><span class=bar></span></div></span></div></div></div><div class=\"bottom-flow row\"><div class=\"col-md-3 col-sm-10 col-xs-10\"><i class=search-icon></i> <input type=search placeholder=\"Search Investors, Folio No\" ng-model=Transaction.searchText ng-change=Transaction.searchList(); select-on-click class=blank-input></div><div class=\"col-md-9 col-sm-2 col-xs-2\"><span class=download-with-tooltip ng-click=\"Transaction.downloadReport(\'transaction-list-all-type\');\" ng-class=\"{\'anything-disabled\': Transaction.totalTransactions === 0}\"><img tooltips tooltip-template=\"Download Report\" tooltip-side=top src=../../../assets/images/ic-download.svg alt=Download></span></div><!--<div class=\"filters-group\">\n\n\n          <button ng-if=\"false\" class=\"apply-btn\">Apply</button>\n          <button ng-if=\"false\" ng-click=\"Transaction.resetFilter()\">Reset</button>\n\n        </div>--><!--<div class=\"col-md-7\">\n          <div class=\"sort-data pull-right\">\n            <input date-range on-date-change=\"Transaction.filterByDate\" placeholder=\"From Date -> To Date\"\n                   date-default=\"Transaction.dateFilter\" class=\"date-picker\" type=\"text\"/>\n            <select class=\"pull-right\" ng-change=\"Transaction.typeChanged()\" ng-model=\"Transaction.selectedType\"\n                    ng-options=\"_type.key for _type in Transaction.TRANSACTION_TYPES\">\n            </select>\n          </div>\n        </div>--></div><!--<div class=\"border\"></div>--><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Transaction Type</th><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><!--<th>Status</th>--><th>Remarks</th><th>Action</th></tr></thead><tbody><tr ng-if=Transaction.transactionList ng-repeat=\"transaction in Transaction.transactionList\"><td ng-if=\"transaction.transactionType !== \'FLEXSIP\'\" data-th=\"Transaction Type\">{{transaction.transactionType == \'DTP\' ? \'TIP\' : transaction.transactionType}}<!--<span ng-if=\"!(transaction.transactionStatus == \'PROPOSED\' || transaction.transactionStatus == \'EXPIRED\' )\">\n                {{transaction.transactionType}}\n              </span>--><!--<span ng-if=\"(transaction.transactionStatus == \'PROPOSED\' || transaction.transactionStatus == \'EXPIRED\' )\">\n                <a href=\"javaScript:void(0);\" ng-click=\"Transaction.showSummary(transaction)\">{{transaction.transactionType}}</a>\n              </span>--></td><td ng-if=\"transaction.transactionType === \'FLEXSIP\'\" data-th=\"Transaction Type\">Flex SIP</td><td data-th=\"Investor Name\" ng-if=\"!(transaction.transactionStatus == \'PROPOSED\' || transaction.transactionStatus == \'EXPIRED\')\">{{transaction.name}}</td><td data-th=\"Investor Name\" ng-if=\"(transaction.transactionStatus == \'PROPOSED\' || transaction.transactionStatus == \'EXPIRED\')\" ng-click=Transaction.showSummary(transaction)>{{transaction.name}}</td><td data-th=\"Folio Number\">{{transaction.folioNumber}}</td><td data-th=Amount style=\"white-space: nowrap\"><i class=rupee-icon></i> {{transaction.amount|unitWithOutDecimalFilter:transaction.amountUnit}}{{transaction.amountUnit|unitValue}}</td><td data-th=Scheme>{{transaction.scheme}}</td><td data-th=Date>{{transaction.date}}</td><!--<td data-th=\"Status\"><span--><!--class=\"{{transaction.transactionStatus.toLowerCase()+\'-text\'}}\">{{transaction.transactionStatus}}</span>--><!--</td>--><td data-th=Remarks><a href=javascript:void(0); ng-if=transaction.remarks tooltip data-toggle=tooltip data-placement=left title={{transaction.remarks}}><i class=tooltip-info-icon></i></a><!--<span tooltips tooltip-template=\"{{transaction.remarks}}\" tooltip-side=\"top\" >{{ transaction.remarks | limitTo: 25 }}{{transaction.remarks.length > 25 ? \'...\' : \'\'}}</span>--></td><td data-th=Action><!--action could be REMIND or REINITIATE --> <button ng-if=transaction.action type=button class=\"btn btn-purple-alt\" ng-click=Transaction.initiateTransaction(transaction)>{{transaction.action||\'--\'}}</button> <span ng-if=!transaction.action>--</span></td></tr><tr ng-if=\"!Transaction.transactionList && !Transaction.isLoading\"><td colspan=8 class=text-center>No Record found</td></tr></tbody></table><div ng-if=Transaction.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Transaction.totalTransactions <= Transaction.PAGE_LIMITS[0]\" ng-bind=Transaction.totalTransactions></span><select ng-if=\"Transaction.totalTransactions > Transaction.PAGE_LIMITS[0]\" ng-change=Transaction.limitChanged() ng-model=Transaction.selectedPageLimit ng-options=\"_limit as _limit for _limit in Transaction.PAGE_LIMITS\"></select><span>of</span> <span class=t-black>{{Transaction.totalTransactions}}</span></div><ul uib-pagination total-items=Transaction.totalTransactions ng-model=Transaction.currentPage max-size=5 items-per-page=Transaction.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Transaction.statusPage() rotate=false></ul></div></div></div></div></section><style>tooltip.active:not(._force-hidden) tip{\n    z-index: 12;\n  }</style>");
$templateCache.put("app/transactions/list/inflow/transaction-inflow.html","<div class=tab-content ng-init=Transaction.init()><div id=inflow class=\"tab-pane fade in active\"><div class=top-flow><div class=col-md-3><i class=rupee-med-icon></i> <span class=lead>{{Transaction.aumData.inFlowTransactionSum.totalInFlowAmount|unit:Transaction.aumData.inFlowTransactionSum.amountUnit}} {{Transaction.aumData.inFlowTransactionSum.amountUnit|unitValue}}</span><!--<span>({{Transaction.aumData.inFlowTransactionSum.totalTransactions|unit:Transaction.aumData.inFlowTransactionSum.transactionUnit}}{{Transaction.aumData.inFlowTransactionSum.transactionUnit}} Trans)</span>--></div><div class=\"col-md-9 pull-up\"><div class=\"transaction-type-box cursor-pointer\"><div class=data-part ng-class=\"{active:Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'LUMPSUM\' ? \'ALL\':\'LUMPSUM\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\"><p class=text-uppercase>Lumpsum</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.totalLumpsumAmount|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.amountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.amountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\"><p class=text-uppercase>online</p><p><i class=rupee-grey-icon></i>{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineLumpsumAmount|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineAmountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineAmountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\"><p class=text-uppercase>offline</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineLumpsumAmout|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineAmountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineAmountUnit|unitValue}}</p></div></div><div class=\"transaction-type-box cursor-pointer\"><div class=data-part ng-class=\"{active:Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'SYSTEMATIC\' ? \'ALL\':\'SYSTEMATIC\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\"><p class=text-uppercase>systematic</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.inFlowTransactionSum.systematicAmount.totalSystematicAmount|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.amountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.systematicAmount.amountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\"><p class=text-uppercase>online</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineSystematicAmount|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineAmountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineAmountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\"><p class=text-uppercase>offline</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineSystematicAmout|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineAmountUnit}}&nbsp;{{Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineAmountUnit|unitValue}}</p></div></div></div><!--     <div class=\"row\">\n        <div class=\"col-md-4 col-sm-6 col-xs-12\">\n          <div class=\"transaction-type-box inflow\">\n            <div class=\"col-md-12 row\">\n              <div class=\"col-md-5 transaction-type\" ng-class=\"{active:Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'LUMPSUM\' ? \'ALL\':\'LUMPSUM\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\">\n                <p>Lumpsum</p>\n\n                <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                  <span>{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.totalLumpsumAmount|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.amountUnit}}{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.amountUnit}}</span>\n                </p>\n                <span class=\"bar\"></span>\n              </div>\n            </div>\n            <div class=\"col-md-5 transaction-type cursor-pointer\" ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\">\n              <p>Online</p>\n\n              <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                <span>{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineLumpsumAmount|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineAmountUnit}}{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.onlineAmountUnit}}</span>\n              </p>\n              <span class=\"bar\" ></span>\n            </div>\n            <div class=\"col-md-5 col-md-offset-2 transaction-type cursor-pointer\"  ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\">\n              <p>Offline</p>\n\n              <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                <span>{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineLumpsumAmout|unit:Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineAmountUnit}}{{Transaction.aumData.inFlowTransactionSum.lumpsumAmount.offlineAmountUnit}}</span>\n              </p>\n              <span class=\"bar\" ></span>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-4 col-sm-6 col-xs-12\">\n          <div class=\"transaction-type-box inflow\">\n            <div class=\"col-md-12 row\">\n              <div class=\"col-md-5 transaction-type\" ng-class=\"{active:Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'SYSTEMATIC\' ? \'ALL\':\'SYSTEMATIC\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\">\n                <p>Systematic</p>\n\n                <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                  <span>{{Transaction.aumData.inFlowTransactionSum.systematicAmount.totalSystematicAmount|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.amountUnit}}{{Transaction.aumData.inFlowTransactionSum.systematicAmount.amountUnit}}</span>\n                </p>\n                <span class=\"bar\" ></span>\n              </div>\n            </div>\n            <div class=\"col-md-5 transaction-type cursor-pointer\" ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\">\n              <p>Online</p>\n\n              <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                <span>{{Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineSystematicAmount|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineAmountUnit}}{{Transaction.aumData.inFlowTransactionSum.systematicAmount.onlineAmountUnit}}</span>\n              </p>\n              <span class=\"bar\"></span>\n            </div>\n            <div class=\"col-md-5 col-md-offset-2 transaction-type cursor-pointer\" ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\">\n              <p>Offline</p>\n\n              <p class=\"lead\"><i class=\"rupee-icon\"></i>\n                <span>{{Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineSystematicAmout|unit:Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineAmountUnit}}{{Transaction.aumData.inFlowTransactionSum.systematicAmount.offlineAmountUnit}}</span>\n              </p>\n              <span class=\"bar\" ></span>\n            </div>\n          </div>\n        </div>\n      </div>--></div><div class=middle-flow><div class=\"status-filter row\"><div class=\"col-md-2 col-sm-4 col-xs-6\" ng-repeat=\"_status in Transaction.TRANSACTION_STATUSES track by $index\"><div class=\"filter cursor-pointer {{_status.value.toLowerCase()}}\" ng-click=Transaction.statusChanged(_status) ng-class=\"{\'active-filter\':Transaction.selectedStatus.value===_status.value}\" tooltips tooltip-template={{Transaction.headerTooltip[_status.value]}}><p>{{_status.value}}</p><p>{{Transaction.snapshotData[_status.value.toLowerCase()+\'Count\'] | number : 0}}</p><span class=bar></span></div></div></div></div><div class=\"bottom-flow row\"><div class=col-md-5><i class=search-icon></i> <input type=search placeholder=\"Search Investors, Folio No\" ng-model=Transaction.searchText ng-change=Transaction.searchList(); select-on-click class=blank-input></div><span class=download-with-tooltip ng-click=\"Transaction.downloadReport(\'transaction-list-inflow-type\');\"><img tooltips tooltip-template=\"Download Report\" tooltip-side=top src=../../../assets/images/ic-download.svg alt=Download></span><div class=filters-group><input date-range on-date-change=Transaction.filterByDate placeholder=\"From Date -> To Date\" date-default=Transaction.dateFilter class=date-picker type=text><!--\n        <select ng-change=\"Transaction.typeChanged()\" ng-model=\"Transaction.selectedType\"\n                ng-options=\"_type.key for _type in Transaction.TRANSACTION_TYPES\">\n        </select>--> <span ng-dropdown-multiselect=\"\" options=Transaction.TRANSACTION_TYPES selected-model=Transaction.transactionModel events=Transaction.transactionEvents extra-settings=Transaction.transactionSettings translation-texts=Transaction.transactionTranslationTexts></span> <button ng-if=false class=apply-btn>Apply</button> <button ng-if=false class=reset-btn>Reset</button></div><!--<div class=\"col-md-7\">\n        <div class=\"sort-data pull-right\">\n          <input date-range on-date-change=\"Transaction.filterByDate\" placeholder=\"From Date -> To Date\"\n                 date-default=\"Transaction.dateFilter\" class=\"date-picker\" type=\"text\"/>\n          <select class=\"pull-right\" ng-change=\"Transaction.typeChanged()\" ng-model=\"Transaction.selectedType\"\n                  ng-options=\"_type.key for _type in Transaction.TRANSACTION_TYPES\">\n          </select>\n        </div>\n      </div>--></div><div class=border></div><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Transaction Type</th><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><th>Status</th><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'transactionType\';Transaction.filterByHeader()\">Transaction Type<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'investorName\';Transaction.filterByHeader()\">Investor Name<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'folioNumber\';Transaction.filterByHeader()\">Folio Number<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'amount\';Transaction.filterByHeader()\">Amount<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'schemeName\';Transaction.filterByHeader()\">Scheme<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'transactionDateTime\';Transaction.filterByHeader()\">Date<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'status\';Transaction.filterByHeader()\">Status<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div></th>--><th>Action</th></tr></thead><tbody><tr ng-if=Transaction.transactionList ng-repeat=\"transaction in Transaction.transactionList\"><td data-th=\"Transaction type\"><a href=javaScript:void(0); ng-click=Transaction.showSummary(transaction)>{{transaction.transactionType}}</a></td><td data-th=\"Investor Name\">{{transaction.name}}</td><td data-th=\"Folio Number\">{{transaction.folioNumber}}</td><td data-th=Amount><i class=rupee-icon></i>{{transaction.amount|unit:transaction.amountUnit}} {{transaction.amountUnit|unitValue}}</td><td data-th=Scheme>{{transaction.scheme}}</td><td data-th=Date>{{transaction.date}}</td><td data-th=Status><span class=\"{{transaction.transactionStatus.toLowerCase()+\'-text\'}}\">{{transaction.transactionStatus}}</span></td><td data-th=Action><!--action could be REMIND or REINITIATE --> <button ng-if=transaction.action type=button class=\"btn btn-purple-alt\" ng-click=Transaction.initiateTransaction(transaction)>{{transaction.action}}</button> <span ng-if=!transaction.action>--</span></td></tr><tr ng-if=\"!Transaction.transactionList && !Transaction.isLoading\"><td colspan=8 class=text-center>No Record found</td></tr></tbody></table><div ng-if=Transaction.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Transaction.totalTransactions <= Transaction.PAGE_LIMITS[0]\" ng-bind=Transaction.totalTransactions></span><select ng-if=\"Transaction.totalTransactions > Transaction.PAGE_LIMITS[0]\" ng-change=Transaction.limitChanged() ng-model=Transaction.selectedPageLimit ng-options=\"_limit as _limit for _limit in Transaction.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black>{{Transaction.totalTransactions}}</span></div><ul uib-pagination total-items=Transaction.totalTransactions ng-model=Transaction.currentPage max-size=5 items-per-page=Transaction.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Transaction.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/transactions/list/outflow/transaction-outflow.html","<div class=tab-content ng-init=Transaction.init()><div id=outflow class=\"tab-pane fade in active\"><div class=top-flow><div class=col-md-3><i class=rupee-med-icon></i> <span class=lead>{{Transaction.aumData.outFlowTransactionSum.totalOutFlowAmount|unit:Transaction.aumData.outFlowTransactionSum.amountUnit}} {{Transaction.aumData.outFlowTransactionSum.amountUnit|unitValue}}</span><!--<span>({{Transaction.aumData.outFlowTransactionSum.totalTransactions|unit:Transaction.aumData.outFlowTransactionSum.transactionUnit}}{{Transaction.aumData.outFlowTransactionSum.transactionUnit}} Trans)</span>--></div><div class=\"col-md-9 pull-up\"><div class=\"transaction-type-box cursor-pointer\"><div class=data-part ng-class=\"{active:Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'LUMPSUM\' ? \'ALL\':\'LUMPSUM\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\"><p class=text-uppercase>Lumpsum</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.totalLumpsumAmount|unit:Transaction.aumData.outFlowTransactionSum.lumpsumAmount.amountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.amountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\"><p class=text-uppercase>online</p><p><i class=rupee-grey-icon></i>{{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.onlineLumpsumAmount|unit:Transaction.aumData.outFlowTransactionSum.lumpsumAmount.onlineAmountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.onlineAmountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'LUMPSUM\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'LUMPSUM\';Transaction.filterByNature()\"><p class=text-uppercase>offline</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.offlineLumpsumAmout|unit:Transaction.aumData.outFlowTransactionSum.lumpsumAmount.offlineAmountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.lumpsumAmount.offlineAmountUnit|unitValue}}</p></div></div><div class=\"transaction-type-box cursor-pointer\"><div class=data-part ng-class=\"{active:Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.transactionNature=(Transaction.sortOrder.transactionNature==\'SYSTEMATIC\' ? \'ALL\':\'SYSTEMATIC\');Transaction.sortOrder.onoff=\'ALL\';Transaction.filterByNature()\"><p class=text-uppercase>systematic</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.outFlowTransactionSum.systematicAmount.totalSystematicAmount|unit:Transaction.aumData.outFlowTransactionSum.systematicAmount.amountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.systematicAmount.amountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'ON\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'ON\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\"><p class=text-uppercase>online</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.outFlowTransactionSum.systematicAmount.onlineSystematicAmount|unit:Transaction.aumData.outFlowTransactionSum.systematicAmount.onlineAmountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.systematicAmount.onlineAmountUnit|unitValue}}</p></div><div class=data-part ng-class=\"{active:Transaction.sortOrder.onoff==\'OFF\' && Transaction.sortOrder.transactionNature==\'SYSTEMATIC\'}\" ng-click=\"Transaction.sortOrder.onoff=\'OFF\';Transaction.sortOrder.transactionNature=\'SYSTEMATIC\';Transaction.filterByNature()\"><p class=text-uppercase>offline</p><p><i class=rupee-grey-icon></i> {{Transaction.aumData.outFlowTransactionSum.systematicAmount.offlineSystematicAmout|unit:Transaction.aumData.outFlowTransactionSum.systematicAmount.offlineAmountUnit}}&nbsp;{{Transaction.aumData.outFlowTransactionSum.systematicAmount.offlineAmountUnit|unitValue}}</p></div></div></div></div><div class=middle-flow><div class=\"status-filter row\"><div class=\"col-md-2 col-sm-4 col-xs-6\" ng-repeat=\"_status in Transaction.TRANSACTION_STATUSES track by $index\"><div class=\"filter cursor-pointer {{_status.value.toLowerCase()}}\" ng-click=Transaction.statusChanged(_status) ng-class=\"{\'active-filter\':Transaction.selectedStatus.value===_status.value}\" tooltips tooltip-template={{Transaction.headerTooltip[_status.value]}}><p>{{_status.value}}</p><p>{{Transaction.snapshotData[_status.value.toLowerCase()+\'Count\'] | number : 0}}</p><span class=bar></span></div></div></div></div><div class=\"bottom-flow row\"><div class=col-md-5><i class=search-icon></i> <input type=search placeholder=\"Search Investors, Folio No\" ng-model=Transaction.searchText ng-change=Transaction.searchList(); select-on-click class=blank-input></div><span class=download-with-tooltip ng-click=\"Transaction.downloadReport(\'transaction-list-outflow-type\');\"><img tooltips tooltip-template=\"Download Report\" tooltip-side=top src=../../../assets/images/ic-download.svg alt=Download></span><div class=filters-group><input date-range on-date-change=Transaction.filterByDate placeholder=\"From Date -> To Date\" date-default=Transaction.dateFilter class=date-picker type=text><!--\n        <select ng-change=\"Transaction.typeChanged()\" ng-model=\"Transaction.selectedType\"\n                ng-options=\"_type.key for _type in Transaction.TRANSACTION_TYPES\">\n        </select>--> <span ng-dropdown-multiselect=\"\" options=Transaction.TRANSACTION_TYPES selected-model=Transaction.transactionModel events=Transaction.transactionEvents extra-settings=Transaction.transactionSettings translation-texts=Transaction.transactionTranslationTexts></span> <button ng-if=false class=apply-btn>Apply</button> <button ng-if=false class=reset-btn>Reset</button></div><!--<div class=\"col-md-7\">\n        <div class=\"sort-data pull-right\">\n          <input date-range on-date-change=\"Transaction.filterByDate\" placeholder=\"From Date -> To Date\"\n                 date-default=\"Transaction.dateFilter\" class=\"date-picker\" type=\"text\"/>\n          <select class=\"pull-right\" ng-change=\"Transaction.typeChanged()\" ng-model=\"Transaction.selectedType\"\n                  ng-options=\"_type.key for _type in Transaction.TRANSACTION_TYPES\">\n          </select>\n        </div>\n      </div>--></div><div class=border></div><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Transaction Type</th><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><th>Status</th><th>Action</th><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'transactionType\';Transaction.filterByHeader()\">Transaction Type--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'investorName\';Transaction.filterByHeader()\">Investor Name--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'folioNumber\';Transaction.filterByHeader()\">Folio Number--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'amount\';Transaction.filterByHeader()\">Amount--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'schemeName\';Transaction.filterByHeader()\">Scheme--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'transactionDateTime\';Transaction.filterByHeader()\">Date--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th ng-click=\"Transaction.sortOrder.sortKey=\'status\';Transaction.filterByHeader()\">Status--><!--<div class=\"sort-arrow\"><i class=\"sort-up-icon\"></i><i class=\"sort-down-icon\"></i></div>--><!--</th>--><!--<th>Action</th>--></tr></thead><tbody><tr ng-if=Transaction.transactionList ng-repeat=\"transaction in Transaction.transactionList\"><td data-th=\"Transaction Type\"><a href=javaScript:void(0); ng-click=Transaction.showSummary(transaction)>{{transaction.transactionType}}</a></td><td data-th=\"Investor Name\">{{transaction.name}}</td><td data-th=\"Folio Number\">{{transaction.folioNumber}}</td><td data-th=Amount><i class=rupee-icon></i> {{transaction.amount|unit:transaction.amountUnit}}{{transaction.amountUnit|unitValue}}</td><td data-th=Scheme>{{transaction.scheme}}</td><td data-th=Date>{{transaction.date}}</td><td data-th=Status><span class=\"{{transaction.transactionStatus.toLowerCase()+\'-text\'}}\">{{transaction.transactionStatus}}</span></td><td data-th=Action><!--action could be REMIND or REINITIATE --> <button ng-if=transaction.action type=button class=\"btn btn-purple-alt\" ng-click=Transaction.initiateTransaction(transaction)>{{transaction.action}}</button> <span ng-if=!transaction.action>--</span></td></tr><tr ng-if=\"!Transaction.transactionList && !Transaction.isLoading\"><td colspan=8 class=text-center>No Record found</td></tr></tbody></table><div ng-if=Transaction.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Transaction.totalTransactions <= Transaction.PAGE_LIMITS[0]\" ng-bind=Transaction.totalTransactions></span><select ng-if=\"Transaction.totalTransactions > Transaction.PAGE_LIMITS[0]\" ng-change=Transaction.limitChanged() ng-model=Transaction.selectedPageLimit ng-options=\"_limit as _limit for _limit in Transaction.PAGE_LIMITS\" ng-value=_limit></select><span>of</span> <span class=t-black>{{Transaction.totalTransactions}}</span></div><ul uib-pagination total-items=Transaction.totalTransactions ng-model=Transaction.currentPage max-size=5 items-per-page=Transaction.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Transaction.init() rotate=false></ul></div></div></div></div>");
$templateCache.put("app/transactions/list/recent/transaction-recent.html","<section class=\"transaction main-section\"><div class=\"loader recentList\"><span class=loading></span> <span class=loading-text>Please wait while we are updating your data...</span></div><ul class=\"nav nav-tabs transactions\"><li class=active-link><a href=javascript:void(0); ui-sref=main.transactions.recent>Recent</a></li><li><a href=javascript:void(0); ui-sref=main.transactions.all>All</a></li></ul><div class=tab-content ng-init=Transaction.transactionRecentSearch()><div id=all class=\"tab-pane fade in active\"><div class=data-grid><table class=\"table table-striped table-responsive rwd-table\" style=\"margin-top: 0px\"><thead><tr><th>Transaction Type</th><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><th>Status</th><th>Remarks</th></tr></thead><tbody><tr ng-if=Transaction.transactionRecentList ng-repeat=\"transaction in Transaction.transactionRecentList\"><td data-th=\"Transaction Type\">{{transaction.transactionType == \'DTP\' ? \'TIP\' : transaction.transactionType}}</td><td data-th=\"Investor Name\">{{transaction.name}}</td><td data-th=\"Folio Number\">{{transaction.folioNumber}}</td><td data-th=Amount style=\"white-space: nowrap\"><i class=rupee-icon></i> {{transaction.amount|unitWithOutDecimalFilter:transaction.amountUnit}}{{transaction.amountUnit|unitValue}}</td><td data-th=Scheme>{{transaction.scheme}}</td><td data-th=Date>{{transaction.date}}</td><td data-th=Status><span class=\"{{transaction.transactionStatus.toLowerCase()+\'-text\'}}\">{{transaction.transactionStatus}}</span></td><td data-th=Remarks><a href=javascript:void(0); ng-if=transaction.remarks tooltip data-toggle=tooltip data-placement=left title={{transaction.remarks}}><i class=tooltip-info-icon></i></a></td></tr><tr ng-if=!Transaction.transactionRecentList.length><td colspan=8 style=\"text-align: center\">No record found.</td></tr></tbody></table></div></div></div></section>");
$templateCache.put("app/new-investor-approve/folio/income/income.html","<div class=incomedetails ng-init=Income.init()><br><form id=folioIncomeFormData name=folioIncomeFormData ng-submit=Income.submitFolioIncomeForm()><div class=form-content style=\"margin-bottom: 20px\"><label><strong>Contact Details</strong></label><div class=row><div class=col-md-5 style=\"margin-right: 40px\"><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : {{Income.folioDetails.soleApplicantDetail.email}}</label></div><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Income.folioDetails.soleApplicantDetail.email><label style=\"margin-top: 30px\"><strong>Email Id</strong> <span class=\"req text-red\">*</span> : Not available</label></div><!-- <div class=\"col-md-3 belongsToContainerMobile emailBelongsMobile\"\n                style=\"display: inline-flex;  margin-right: 40px;\" ng-if=\"Income.soleApplicantEmail\">\n                <div style=\"flex-shrink : 0;\">\n                    <label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span>\n                        : </label>\n                </div>\n                <div class=\"selectfield\" style=\"display: inline-block ; margin-left : 5px;\"\n                    ng-class=\"{error:soleApplicantForm.emailBelongsTo.$dirty && soleApplicantForm.emailBelongsTo.$invalid}\">\n                    <select class=\"browser-default custom-select\" name=\"emailBelongsTo\" style=\"width: 150px\"\n                        ng-model=\"holders.emailBelongsTo\"\n                        ng-init=\"holders.emailBelongsTo = holders.emailBelongsTo ? holders.emailBelongsTo: null\"\n                        ng-options=\"data.familyCode as data.familyDescription for data in belongToListEmail\" required>\n                        <option value=\"\" selected>Select Value</option>\n                    </select>\n                    <span class=\"req text-red\">*</span>\n                </div>\n            </div>\n     --><div class=\"col-md-5 mLabel\" ng-if=Income.folioDetails.soleApplicantDetail.mobileNo><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : {{Income.folioDetails.soleApplicantDetail.mobileNo}}</label></div><div class=col-md-5 ng-if=!Income.folioDetails.soleApplicantDetail.mobileNo><label style=\"margin-top: 30px\"><strong>Mobile No.</strong> <span class=\"req text-red\">*</span> : Not available</label></div></div><div class=row style=\"margin-top: 15px\"><div class=\"col-md-5 belongsToContainerWeb\" style=\"display: inline-flex;  margin-right: 40px\" ng-if=Income.folioDetails.soleApplicantDetail.email><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px\"><strong>Email Id Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block ; margin-left : 5px\" ng-class=\"{error:folioIncomeFormData.emailBelongsTo.$dirty && folioIncomeFormData.emailBelongsTo.$invalid}\"><select id=emailBelongsTo name=emailBelongsTo ng-model=Income.holders.emailBelongsTo style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" required><option value selected>Select Value</option><option ng-repeat=\"value in Income.belongToListEmail\" ng-selected=\"Income.holders.emailBelongsTo == value.familyCode\" value={{value.familyCode}}>{{value.familyDescription}}</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.emailBelongsTo.$dirty \"><span class=error-input ng-show=folioIncomeFormData.emailBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when email doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Income.folioDetails.soleApplicantDetail.email></div><div class=\"col-md-5 belongsToContainerMobile\" style=\"display: inline-flex\" ng-if=Income.folioDetails.soleApplicantDetail.mobileNo><div style=\"flex-shrink : 0\"><label style=\"margin-top: 22px ; margin-right: 5px\"><strong>Mobile No. Belongs To</strong> <span class=\"req text-red\">*</span> :</label></div><div class=selectfield style=\"display: inline-block\" ng-class=\"{error:folioIncomeFormData.mobileBelongsTo.$dirty && folioIncomeFormData.mobileBelongsTo.$invalid}\"><select class=\"browser-default custom-select\" id=mobileBelongsTo name=mobileBelongsTo ng-model=Income.holders.mobileBelongsTo ng-init=\"Income.holders.mobileBelongsTo = Income.holders.mobileBelongsTo ? Income.holders.mobileBelongsTo : null\" ng-options=\"data.familyCode as data.familyDescription for data in Income.belongToListMobile\" ng-selected=\"Income.holders.mobileBelongsTo == data.familyCode\" style=\"height: 40px;border-radius: 5px;width: 180px;border: 1px solid gray; margin-top: 8px;margin-left: 0px\" required><option value=\"\" selected>Select Value</option></select><!-- <span class=\"req text-red\">*</span> --> <span ng-show=\"folioIncomeFormData.mobileBelongsTo.$dirty &&  folioIncomeFormData.mobileBelongsTo.$invalid\"><span class=error-input ng-show=folioIncomeFormData.mobileBelongsTo.$error.required>Please select option</span></span></div></div><!--empty placeholder when mobile doesnt exist to maintain ui--><div class=col-md-5 style=\"margin-right: 40px\" ng-if=!Income.folioDetails.soleApplicantDetail.mobileNo></div></div></div><!-- tax status --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Tax Status</p></div><br><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=taxstatus name=taxstatus ng-model=Income.folioIncomeForm.taxstatus style=\"height: 40px;border-radius: 5px;width: 336px\"><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"value in Income.taxStatusData\" ng-selected=\"Income.folioIncomeForm.taxstatus == value.taxStatusCode\" value={{value.taxStatusCode}}>{{value.taxStatusDescription}}</option></select></div><span ng-show=\"folioIncomeFormData.taxstatus.$dirty && !Income.folioIncomeForm.taxstatus\"><span class=error-input ng-show=folioIncomeFormData.taxstatus.$error.required ng-bind=Income.validateData.TAX_STATUS></span></span></div><br><!-- Occupation --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Occupation</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=occupation name=occupation ng-model=Income.folioIncomeForm.occupation style=\"height: 40px;border-radius: 5px;width: 336px\"><option value selected>Select</option><option ng-repeat=\"value in Income.investorOccupations\" ng-selected=\"Income.folioIncomeForm.occupation == value.occupationCode\" value={{value.occupationCode}}>{{value.occupationDescription}}</option></select><span ng-show=\"folioIncomeFormData.occupation.$dirty && !Income.folioIncomeForm.occupation\"><span class=error-input ng-show=folioIncomeFormData.occupation.$error.required ng-bind=Income.validateData.OCCUPATION></span></span></div></div><br><!-- TOGGLE BUTTON --><div class=row><div class=\"col-xs-12 col-md-5\" style=\"margin-bottom: 3px\"><div style=\"display: flex;justify-content: flex-start;flex-direction: row;align-items: center\"><p class=grossanualincome>Gross Annual Income</p><input type=checkbox id=switch style=\"margin-right: 10px\" ng-click=Income.networthcall() ng-checked=Income.networth><label class=switchlable for=switch ng-checked=Income.networth style=\"margin-right: 10px\"></label><span class=titleFatca>Net Worth</span></div></div></div><br><!-- Annual Income --><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=!Income.networth><select class=selectNormal id=annualincome name=annualincome ng-model=Income.folioIncomeForm.annualincome style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\" required><option value selected>Select</option><option ng-repeat=\"value in Income.incomeSlabList\" ng-selected=\"Income.folioIncomeForm.annualincome == value.incomeCode\" value={{value.incomeCode}}>{{value.incomeDescription}}</option></select><span ng-show=\"folioIncomeFormData.annualincome.$dirty && !Income.folioIncomeForm.grossAnnualIncome\"><span class=error-input ng-show=folioIncomeFormData.annualincome.$error.required ng-bind=Income.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-5\" ng-if=Income.networth><input type=number class=\"form-control inputNormal\" id=annualincome1 name=annualincome1 ng-model=Income.folioIncomeForm.networth required> <span ng-show=\"folioIncomeFormData.annualincome1.$dirty && !Income.folioIncomeForm.networth\"><span class=error-input ng-show=folioIncomeFormData.annualincome1.$error.required ng-bind=Income.validateData.GROSS_ANNUAL_INCOME></span></span></div><div class=\"col-xs-12 col-md-4\" ng-if=Income.networth style=\"margin-top: -11px\"><div style=\"position: relative\"><div class=dob-input-container style=\"height: 45px\"><div class=\"input-select input-normal input-group date date-picker dateInputReg\" date-calendar data-enable=true data-viewmode={{Income.viewMode}} data-date-default=Income.folioIncomeForm.grossAnnualIncomeDate data-on-date-change=Income.getGrossAnnualIncomeDate maxdate=now format=DD-MM-YYYY id=endDate><input class=newinvestor-dob tabindex=2 id=grossAnnualIncomeDateId ng-keyup=Income.autoDate() name=grossAnnualIncomeDate type=text autocomplete=off placeholder=\"As on dd-mm-yyyy\" required> <span class=input-group-addon><img class=calender-icon-register src=../../assets/images/icons/dateIcon.png> </span><span>(Not older than 1 year)</span><br><span class=error-input ng-if=Income.dateErrorMessage ng-bind=Income.dateErrorMessage></span></div></div></div></div></div><p class=titleFatca>FATCA & CRS related question.</p><!-- Country --><div class=\"row absulatepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Country</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=country name=country ng-model=Income.folioIncomeForm.Fatca.countrie style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\"><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"value in Income.countries\" ng-selected=\"Income.folioIncomeForm.Fatca.countrie == value.countryCode\" value={{value.countryCode}}>{{value.countryName}}</option></select></div><div class=\"note-banner col-xs-12 col-md-7 noterelativepostion\"><div class=warning><img src=../../../assets/images/icons/light-bulb.png style=\"height: 50px;width: 50px;margin-top: 25px;padding: 10px\"><div class=wardiv>FATCA (Foreign Account tax Compliance Act) & CRS (Common Reporting Standard) declaration was prepared by finacial institutions company with the Central Board of Direct taxes (CBDT) rules.</div></div></div></div><!-- address type --><div class=\"row relativepostion\"><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>Address type</p></div><div class=\"col-xs-12 col-md-5\"><select class=selectNormal id=addressType name=addressType ng-model=Income.folioIncomeForm.Fatca.addressType style=\"height: 40px;border-radius: 5px;width: 336px;margin-left: 0px\"><!-- <option value selected=\"selected\">Select</option> --><option ng-repeat=\"x in Income.addressType\" ng-selected=\"Income.folioIncomeForm.Fatca.addressType == x.value\" value={{x.value}}>{{x.addressDescription}}</option></select><span ng-show=\"folioIncomeForm.addressType.$dirty && !Income.folioIncomeForm.Fatca.addressType\"><span class=error-input ng-show=folioIncomeForm.addressType.$error.required ng-bind=Income.validateData.FATCA_ADDRESS_TYPE_REQUIRED></span></span></div></div><br><!-- city --><div class=row><div class=\"col-xs-12 col-md-8\"><p class=titleFatca>City</p></div><div class=\"col-xs-12 col-md-5\"><input class=\"form-control inputNormal\" type=text id=City name=City ng-model=Income.folioIncomeForm.Fatca.city ng-pattern=\"/^[a-zA-Z ]+$/\" required> <span ng-show=\"folioIncomeFormData.City.$dirty && folioIncomeFormData.City.$invalid\"><span class=error-input ng-show=folioIncomeFormData.City.$error.required ng-bind=Income.validateData.CITY></span> <span class=error-input ng-show=folioIncomeFormData.City.$error.pattern>Number not allowed in minor name!</span></span></div></div><br><br><button class=\"btn-new-journey-color hdfc-blue-cta-small\" type=submit ng-disabled=\"folioIncomeFormData.$error.required  ||\n        !Income.folioDetails.soleApplicantDetail.email ||\n        !Income.folioDetails.soleApplicantDetail.mobileNo\">CONTINUE</button></form></div><style>.warning {\n    background: #fefbe3;\n    display: flex;\n    border-radius: 5px;\n  }\n\n  .wardiv {\n    padding: 4% 4% 4% 0;\n    font-size: 12px;\n    color: #000000;\n    opacity: 1;\n  }\n\n  @media screen and (min-width: 1285px) {\n    .relativepostion {\n      position: relative;\n      margin-top: 90px;\n    }\n\n    .absulatepostion {\n      position: absolute;\n    }\n  }\n\n  @media screen and (max-width: 1285px) {\n    .noterelativepostion {\n\n      width: 100%;\n    }\n  }\n\n  .credentialNote {\n    padding: 15px;\n    background: linen;\n    border-radius: 8px;\n    margin-top: 12px;\n    font-weight: 500;\n    text-align: center;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/bank-details.html","<div id=bank-details class=\"tab-pane fade in\" ng-init=InitiateSummary.initPaymentRequest()><div class=email-block><p class=email-block-header>Bank Details</p><table class=\"table borderless\"><tr><td>Bank Name:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankName}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcNo}}</td></tr><tr><td>Branch:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankBranch}}, {{InitiateSummary.summaryDetails.folioBankDetails.bankCity}}</td></tr><tr><td>IFSC Code:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.ifscCode}}</td></tr><tr><td>Transaction Mode:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcType}}</td></tr></table></div><hr><div ng-if=!InitiateSummary.isActionPerformed class=\"email-block buttons-block\"><!--<form autocomplete=\"off\" name=\'payForm\' ng-if=\"InitiateSummary.summaryType === InitiateSummary.TRANSACTION_FORM_TYPE.PURCHASE\"--><!--method=\'POST\' action=\'https://www.billdesk.com/pgidsk/PGIMerchantRequestHandler\'>--><!--<input type=\"hidden\" name=\"msg\" ng-value=\"InitiateSummary.billDeskpayload\" id=\"msg\"/>--><!--<input id=\"hidRequestId\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>--><!--<input id=\"hidOperation\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>--><!--<div class=\"email-block-button\">--><!--<span ng-click=\"InitiateSummary.rejectTransaction()\" class=\"btn btn-negative-action\">Reject Transaction</span>--><!--<input type=\"submit\" value=\"Pay\" class=\"btn btn-primary-action no-margin\">--><!--</div>--><!--</form>--><div class=email-block-button ng-if=\"InitiateSummary.summaryType === InitiateSummary.TRANSACTION_FORM_TYPE.PURCHASE\"><span ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span class=\"btn btn-primary-action no-margin\" ng-click=InitiateSummary.initBankPurchaseTransaction()>Pay</span></div><div class=email-block-button ng-if=\"InitiateSummary.summaryType === InitiateSummary.TRANSACTION_FORM_TYPE.SIP\"><span ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-click=InitiateSummary.approveTransaction() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></div>");
$templateCache.put("app/transactions/initiate/summary/ecs-bank-details.html","<!--<section class=\"summary-sip-bank\">--><!--<div class=\"content-header\">--><!--<button class=\"btn-back\"><i class=\"back-arrow-icon\"></i>Go Back &amp; Review Again</button>--><!--<h5 class=\"text-uppercase\"><span>Dear</span> Ranjan S. Shyam,</h5>--><!--<p>Tejas Consultancy Pvt. Ltd has initiated a transaction for you which requires your approval to proceed. </p>--><!--</div>--><div class=content-body><div class=\"form-group text-center\">Select Payment Options : <span class=radio-block><span class=radio><input type=radio id=Emandate name=paymentOption ng-model=InitiateSummary.paymentOption value={{InitiateSummary.paymentOptions[0]}} ng-change=InitiateSummary.paymentOptionChanged()> <span class=check></span></span><label for=Emandate>E-mandate</label></span><span class=radio-block><span class=radio><input type=radio id=standingInst name=paymentOption ng-model=InitiateSummary.paymentOption value={{InitiateSummary.paymentOptions[1]}} ng-change=InitiateSummary.paymentOptionChanged()> <span class=check></span></span><label for=standingInst>Standing Instruction</label></span></div><div class=email-block><p class=email-block-header>Please provide bank details for making payment</p><form autocomplete=off name=InitiateSummary.EcsBankForm ng-submit=InitiateSummary.approveEcsBankTransaction() novalidate><div class=form-content><p><strong>Bank Details</strong></p><br><div class=\"row bank-detail\"><div class=row><div class=col-md-5><div class=\"input-select input-normal\"><input type=text name=bankAcType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Account Type</label><!--<div class=\"suggestion box-shadow\" ng-if=\"false\">--><!--<ul>--><!--<li></li>--><!--</ul>--><!--</div>--></div></div></div><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.ecsBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number</label><span ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal verify-acc\" ng-class=\"{error:InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo minlength=9 ng-model=InitiateSummary.ecsBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number</label><span ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-readonly=InitiateSummary.ecsReadOnly ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code</label></div></div><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.ecsBankModal.bankName ng-readonly=InitiateSummary.editableBankName required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name</label><span ng-show=\"InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid}\"><input type=text name=bankBranch ng-model=InitiateSummary.ecsBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location</label><span ng-show=\"InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankBranch.$error.required ng-bind=InitiateSummary.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid}\"><input type=text name=bankCity ng-model=InitiateSummary.ecsBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch City</label><span ng-show=\"InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankCity.$error.required ng-bind=InitiateSummary.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div></div></div><input type=hidden id=hfReq><hr><div class=buttons-block><div class=email-block-button><button class=\"btn btn-negative-action\">Reject</button> <button class=\"btn btn-primary-action\" ng-disabled=InitiateSummary.EscBankForm.$invalid>Approve Transaction</button></div></div></form></div></div><!--</section>-->");
$templateCache.put("app/transactions/initiate/summary/folio-details.html","<div id=folio-details class=\"tab-pane fade in\"><ol class=list-inline><li ng-repeat=\"tab in InitiateSummary.applicantTabs\" ng-class={active:InitiateSummary.activeApplicantTab[$index]} ng-click=InitiateSummary.changeApplicant($index)>{{tab.title}}</li></ol><div class=email-block ng-if=InitiateSummary.isSoleApplicant id=sole-applicant><p class=email-block-header>{{InitiateSummary.activeApplicantTab.title}} Details</p><table class=\"table borderless\"><tr><td>Tax Status:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.taxStatus}}</td></tr><tr><td>Occupation:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.occupation}}</td></tr><tr><td>Gross Annual Income:</td><td><i class=rupee-icon></i> {{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.annualIncome}}</td></tr></table><p class=email-block-header>FATCA or CRS Details of Sole Applicant</p><table class=\"table borderless\"><tr><td>Address Type:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.addressType}}</td></tr><tr><td>Tax Payee other than India:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.taxPayeeOtherThanIndia}}</td></tr><tr><td>Country:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.country}}</td></tr><tr><td>City of Birth:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.cityOfBirth}}</td></tr><tr><td>Tax ID Type:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.taxIdType}}</td></tr><tr><td>Tax ID Number:</td><td>{{InitiateSummary.summaryDetails.folioDetails.soleApplicantDetails.taxIdNumber}}</td></tr></table><hr><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-negative-action\">Reject</span> <span class=\"btn btn-primary-action\">Approve Transaction</span></div></div></div><div class=email-block ng-if=InitiateSummary.isJointHolder id=joint-holder><p class=joint-holder-header>Joint Holder Name: <span>{{InitiateSummary.selectedJointHolder.jointHolderName}}</span></p><p class=joint-holder-header>Pan Number: <span>{{InitiateSummary.selectedJointHolder.panNumber}}</span></p><p class=email-block-header>{{InitiateSummary.activeApplicantTab.title}} Details</p><table class=\"table borderless\"><tr><td>Tax Status:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.taxStatus}}</td></tr><tr><td>Occupation:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.occupation}}</td></tr><tr><td>Gross Annual Income:</td><td><i class=rupee-icon></i> {{InitiateSummary.selectedJointHolder.jointHolderDetails.annualIncome}}</td></tr></table><p class=email-block-header>{{InitiateSummary.activeApplicantTab.title}} FATCA or CRS Details</p><table class=\"table borderless\"><tr><td>Address Type:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.addressType}}</td></tr><tr><td>Tax Payee other than India:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.taxPayeeOtherThanIndia}}</td></tr><tr><td>Country:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.country}}</td></tr><tr><td>City of Birth:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.cityOfBirth}}</td></tr><tr><td>Tax ID Type:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.taxIdType}}</td></tr><tr><td>Tax ID Number:</td><td>{{InitiateSummary.selectedJointHolder.jointHolderDetails.taxIdNumber}}</td></tr></table><hr><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-negative-action\">Reject</span> <span class=\"btn btn-primary-action\">Agree &amp; Continue</span></div></div></div><div class=email-block ng-if=InitiateSummary.isNominee id=nominee-1><p class=email-block-header>Personal Details of {{InitiateSummary.activeApplicantTab.title}}</p><table class=\"table borderless\"><tr><td>Name:</td><td>{{InitiateSummary.selectedNominee.name}}</td></tr><tr><td>Relationship:</td><td>{{InitiateSummary.selectedNominee.relationship}}</td></tr><tr><td>Proportion(in %):</td><td>100%</td></tr><tr><td>Date of Birth:</td><td>{{InitiateSummary.selectedNominee.dob}}</td></tr></table><p class=email-block-header>Address Details of {{InitiateSummary.activeApplicantTab.title}}</p><table class=\"table borderless\"><tr><td>Address Line 1:</td><td>E-24/1, Shalimar Garden</td></tr><tr><td>Address Line 2:</td><td>Abul Fazal Marg 2</td></tr><tr><td>ZIP / Postal Code:</td><td>110025</td></tr><tr><td>City:</td><td>New Delhi</td></tr><tr><td>Country:</td><td>India</td></tr><tr><td>Nominee is minor:</td><td>Yes</td></tr></table><p class=email-block-header>Address Details of Guardian</p><table class=\"table borderless\"><tr><td>Address Line 1:</td><td>E-24/1, Shalimar Garden</td></tr><tr><td>Address Line 2:</td><td>Abul Fazal Marg 2</td></tr><tr><td>ZIP / Postal Code:</td><td>110025</td></tr><tr><td>City:</td><td>New Delhi</td></tr><tr><td>Country:</td><td>India</td></tr></table><hr><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-negative-action\">Reject</span> <span class=\"btn btn-primary-action\">Agree &amp; Continue</span></div></div></div></div>");
$templateCache.put("app/transactions/initiate/summary/scheme-details.html","<div id=scheme-details class=\"tab-pane fade in\"><div class=email-block><p class=email-block-header>Scheme Details</p><table class=\"table borderless\"><tr><td>Name of Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Amount:</td><td><i class=rupee-icon></i>{{InitiateSummary.summaryDetails.amount|unit:InitiateSummary.summaryDetails.amountUnit}}{{InitiateSummary.summaryDetails.amountUnit|unitValue}}</td></tr><tr><td>Start Date:</td><td>{{InitiateSummary.summaryDetails.startDate}}</td></tr></table></div><hr><div class=\"email-block buttons-block\"><div class=email-block-button><span class=\"btn btn-negative-action\">Reject Transaction</span> <span class=\"btn btn-primary-action\">Agree &amp; Continue</span></div></div></div>");
$templateCache.put("app/transactions/initiate/summary/summary.addnominee.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><form autocomplete=off name=nomineeForm><section class=\"summary-sip add-update-nominee-section\"><div class=content-header><h5 class=text-capitalize>Add/Update Nominee (For Units in Non-Demat Form)</h5></div><div class=\"content-body form-wrapper\"><div class=email-block><div class=belongs-to-container><table><tr><td><p><strong>Email ID :<span class=req>*</span></strong></p></td><td><p><strong easyassist-key=mask-element>{{InitiateSummary.NomineeEmail ? InitiateSummary.NomineeEmail : \'Not Available\'}}</strong></p></td></tr><tr><td><p style=\"margin-right: 15px\"><strong>Email Id Belongs To<span class=req>*</span></strong></p></td><td><div><select style=\"padding: 10px 10px 10px 5px !important\" class=\"browser-default custom-select\" name=emailBelongsTo ng-model=InitiateSummary.emailBelongsTo ng-init=\"InitiateSummary.emailBelongsTo = InitiateSummary.summaryDetails.emailBelongsTo ? InitiateSummary.summaryDetails.emailBelongsTo :null\" ng-options=\"email.familyCode as email.familyDescription for email in InitiateSummary.emaillList\" ng-disabled=!InitiateSummary.NomineeEmail required><option value=\"\" selected>Select Value</option></select></div><div><span class=error-input ng-show=\"nomineeForm.emailBelongsTo.$error.required && nomineeForm.emailBelongsTo.$dirty\" ng-bind=InitiateSummary.appConstants.EMAIL_BELONGS_ERROR></span></div></td></tr></table><table><tr><td><p><strong>Mobile No :<span class=req>*</span></strong></p></td><td><p><strong easyassist-key=mask-element>{{InitiateSummary.NomineeMobile ? InitiateSummary.NomineeMobile : \'Not Available\'}}</strong></p></td></tr><tr><td><p style=\"margin-right: 15px\"><strong>Mobile No. Belongs To<span class=req>*</span></strong></p></td><td><div><select style=\"padding: 10px 10px 10px 5px !important\" class=\"browser-default custom-select\" name=mobileBelongsTo ng-model=InitiateSummary.mobileBelongsTo ng-init=\"InitiateSummary.mobileBelongsTo = InitiateSummary.summaryDetails.mobileBelongsTo ? InitiateSummary.summaryDetails.mobileBelongsTo :null\" ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in InitiateSummary.mobileList\" ng-disabled=!InitiateSummary.NomineeMobile required><option value=\"\" selected>Select Value</option></select></div><div><span class=error-input ng-show=\"nomineeForm.mobileBelongsTo.$error.required && nomineeForm.mobileBelongsTo.$dirty\" ng-bind=InitiateSummary.appConstants.MOBILE_BELONGS_ERROR></span></div></td></tr></table></div><br><div class=\"tab-container form-content\"><ul class=\"nav nav-tabs nominee-list-names\"><li role=button tabindex={{$index}} ng-repeat=\"nominee in InitiateSummary.summaryDetails.nomineeList\" ng-click=InitiateSummary.setActiveTab($index) ng-class=\"{\'active\':InitiateSummary.activeTab === $index}\" class=tab-nominee>{{InitiateSummary.enum[$index]}} Nominee Details</li></ul></div><div ng-repeat=\"nominee in InitiateSummary.summaryDetails.nomineeList\" ng-show=\"InitiateSummary.activeTab===$index\"><div class=\"row mt54\" style=\"margin-top: 12px !important\"><div class=col-md-12><div style=\"margin-bottom: 12px !important\"><input type=checkbox ng-model=nominee.minor style=\"width: 30px;\n                height: 20px\" disabled> <span class=checkbox-text>The Nominee Is Minor</span></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=name-{{$index}} ng-model=nominee.firstName required readonly><label>Name<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=proportion-{{$index}} ng-model=nominee.percentage required readonly><label>Proportion<span class=req>*</span></label></div></div><div class=\"col-md-4 clear-both\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeCountry-{{$index}} ng-model=nominee.dateOfBirth required readonly><label>DOB - DD/MMM/YYYY<span class=req ng-if=nominee.minor>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeRelation-{{$index}} ng-model=nominee.relation required readonly><label>Relationship<span class=req>*</span></label></div></div><!--            <div class=\"col-md-4\" ng-if=\"InitiateSummary.showRegulatoryChanges && nominee.relation === \'Others\'\" ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation === \'Others\'}\">--><!--              <div class=\"input-select input-normal mr-less mgt13 nominee-form-input\">--><!--                <input type=\"text\" name=\"nomineeRelationOther-{{$index}}\"--><!--                       ng-model=\"nominee.otherRelation\" required readonly/>--><!--                <label>Others<span class=\"req\">*</span></label>--><!--              </div>--><!--            </div>--><div class=col-md-4 ng-if=InitiateSummary.showRegulatoryChanges ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation !== \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=emailId-{{$index}} ng-model=nominee.emailId required readonly><label>Nominee Email ID<span class=req>*</span></label></div></div><div class=col-md-4 ng-if=InitiateSummary.showRegulatoryChanges ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation === \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=emailId-{{$index}} ng-model=nominee.mobileNumber required readonly><label>Nominee Mobile No.<span class=req>*</span></label></div></div><div class=col-md-4 ng-if=\"InitiateSummary.showRegulatoryChanges && nominee.identityProofType === \'AADHAR_CARD\'\" ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation !== \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=aadharCard-{{$index}} class=aadhar-input ng-model=nominee.identityProofNumber required readonly><label>Nominee Aadhaar No.<span class=req>*</span></label><span class=masked-aadhar>XXXX XXXX</span></div></div><div class=col-md-4 ng-if=\"InitiateSummary.showRegulatoryChanges && nominee.identityProofType === \'DRIVING_LICENSE\'\" ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation !== \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=drivingLicense-{{$index}} ng-model=nominee.identityProofNumber required readonly><label>Nominee Driving License No.<span class=req>*</span></label></div></div><div class=col-md-4 ng-if=!InitiateSummary.showRegulatoryChanges><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineePan-{{$index}} ng-model=nominee.panNumber required readonly><label>PAN of Nominee</label></div></div><div class=col-md-4 ng-if=\"InitiateSummary.showRegulatoryChanges && nominee.identityProofType === \'PAN_CARD\'\" ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation !== \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineePan-{{$index}} ng-model=nominee.identityProofNumber required readonly><label>Nominee PAN <span class=req>*</span></label></div></div><div class=col-md-4 ng-if=\"InitiateSummary.showRegulatoryChanges && nominee.identityProofType === \'PASSPORT\'\" ng-class=\"{\'clear-both\': InitiateSummary.showRegulatoryChanges && nominee.relation !== \'Others\'}\"><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=passport-{{$index}} ng-model=nominee.identityProofNumber required readonly><label>Nominee Passport<span class=req>*</span></label></div></div></div><div ng-if=nominee.guardianRelationWithNominee><p ng-if=nominee.guardianName><strong>Guardian Detail\'s</strong></p><div class=\"row mgt20\" ng-if=nominee.guardianName><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=guardianName-{{$index}} ng-model=nominee.guardianName required readonly><label>Guardian Name<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=guardianRelationWithNominee-{{$index}} ng-model=nominee.guardianRelationWithNominee required readonly><label>Guardian\'s Relationship with Nominee<span class=req>*</span></label></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=guardianPanNumber-{{$index}} ng-model=nominee.guardianPanNumber readonly><label>PAN of Guardian</label></div></div></div></div><div class=form-content ng-if=!nomineeData.minor ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p><strong>Address Details of Nominee</strong></p><div class=\"row mgt20\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text ng-model=nominee.nomineeAddress1 name=addressLine1-{{$index}} autocomplete=off ng-required=InitiateSummary.showRegulatoryChanges capitalize readonly><label>Address Line 1 <span class=req ng-if=InitiateSummary.showRegulatoryChanges>*</span></label></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine2-\'+$index].$dirty && nomineeForm[\'addressLine2-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text ng-model=nominee.nomineeAddress2 name=addressLine2-{{$index}} autocomplete=off capitalize readonly><label>Address Line 2<!--                    <span class=\"req\">*</span>--></label></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeCountry-{{$index}} ng-required=InitiateSummary.showRegulatoryChanges ng-model=nominee.country readonly><label>Country of Birth <span class=req ng-if=InitiateSummary.showRegulatoryChanges>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} ng-model=nominee.stateCode ng-required=InitiateSummary.showRegulatoryChanges capitalize readonly><label>State <span ng-if=InitiateSummary.showRegulatoryChanges class=req>*</span></label><!--<div ng-if=\"nomineeData.nomineeAddress.country === \'India\'&&nomineeData.nomineeAddress.city&&Nominee.cityList.length\" class=\"suggestion box-shadow\">\n                    <ul><li ng-repeat=\"_data in Nominee.cityList|filterCity:nomineeData.nomineeAddress.city track by $index\" ng-click=\"Nominee.selectNomineeBirthCity(_data,nomineeData)\"> {{_data.cityName}}</li></ul>\n                  </div>--></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13\" style=\"margin-top: 10px\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} ng-model=nominee.city ng-required=InitiateSummary.showRegulatoryChanges capitalize readonly><label>City of Birth <span ng-if=InitiateSummary.showRegulatoryChanges class=req>*</span></label><!--<div ng-if=\"nomineeData.nomineeAddress.country === \'India\'&&nomineeData.nomineeAddress.city&&Nominee.cityList.length\" class=\"suggestion box-shadow\">\n                    <ul><li ng-repeat=\"_data in Nominee.cityList|filterCity:nomineeData.nomineeAddress.city track by $index\" ng-click=\"Nominee.selectNomineeBirthCity(_data,nomineeData)\"> {{_data.cityName}}</li></ul>\n                  </div>--></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeZip-{{$index}} ng-required=InitiateSummary.showRegulatoryChanges ng-model=nominee.postalCode readonly><label>Zip / Postal Code <span class=\"req text-red\" ng-if=InitiateSummary.showRegulatoryChanges>*</span></label></div></div></div></div></div><!-- Statement Declaration sections --><div class=statement-declaration ng-if=\"InitiateSummary.showRegulatoryChanges && InitiateSummary.summaryDetails.accountHoldingDeclaration\"><p class=section-title>Statement of Holding(Account Statement) Declaration <span class=\"req text-red\">*</span></p><div class=declaration-content><div class=row><div class=col-md-12><span>I/ We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/ us by the AMC as follows; (please tick, as appropriate)</span></div></div><div><div class=\"radio-block flex-radio\"><div class=row style=\"margin-bottom: 10px\"><div class=col-md-4><span class=radio style=\"bottom: 0px\"><input type=radio ng-checked=\"InitiateSummary.summaryDetails.accountHoldingDeclaration === \'NOMINATION_YES\'\" name=nomineeName id=nomineeName autocomplete=off disabled ng-value=true> <span class=check></span></span><label>Nomination: Yes</label></div></div><div class=row><div class=col-md-4><span class=radio style=\"bottom: 0px\"><input type=radio ng-checked=\"InitiateSummary.summaryDetails.accountHoldingDeclaration === \'NOMINATION_NO\'\" name=nomination id=nomination autocomplete=off disabled ng-value=false> <span class=check></span></span><label>Nomination: No</label></div></div></div></div></div></div><div class=statement-declaration ng-if=\"InitiateSummary.showRegulatoryChanges && InitiateSummary.summaryDetails.incapacitationDeclaration\"><p class=section-title>Incapacitation Declaration (Optional) <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"<div>\n                  SEBI Circular: SEBI/HO/OIAE/OIAE_IAD-3/P/ON/2025/01650 dated January 10, 2025, 3.5 paragraph states, Nominee to act on behalf of incapacitated investors 3.5.1. The regulated entity shall provide the investors having single holding / account / folio, the option to: <br/>\n                  a) empower, any one of the nominees (excluding minor nominee) to operate the investor’s account / folio, if the investor is physical incapacitated, but still has the capacity to contract. <br/>\n                  b) specify either the percentage or absolute value of assets in the account/ folio that can be encashed by such nominee. <br/>\n                  c) change such mandate any number of times without any restriction. <br/>\n                </div>\"></i></p><div class=declaration-content><div class=row><div class=col-md-12><span>I hereby authorize <input type=text ng-model=InitiateSummary.summaryDetails.incapacitationDeclaration.nomineeName name=selectedNomineeName readonly> (nominee number <input type=text ng-model=InitiateSummary.summaryDetails.incapacitationDeclaration.nomineeNumber name=nomineeNumber is-number readonly>) to operate my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to <input type=text ng-model=InitiateSummary.summaryDetails.incapacitationDeclaration.percentage name=percentage is-number maxlength=3 ng-required=!InitiateSummary.summaryDetails.incapacitationDeclaration.amount ng-pattern=/^(100|[1-9]?[1-9])$/ ng-model-options=\"{ allowInvalid: true}\" ng-disabled=InitiateSummary.summaryDetails.incapacitationDeclaration.amount readonly>% of assets in the account / folio or Rs. <input type=text ng-model=InitiateSummary.summaryDetails.incapacitationDeclaration.amount name=allowedAmount is-number maxlength=20 ng-disabled=InitiateSummary.summaryDetails.incapacitationDeclaration.percentage ng-required=!InitiateSummary.summaryDetails.incapacitationDeclaration.percentage readonly>.</span></div></div></div></div></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-show=!InitiateSummary.isActionPerformed><button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.rejectNominee()>Reject</button> <button type=submit ng-disabled=\"!InitiateSummary.NomineeEmail || !InitiateSummary.emailBelongsTo || !InitiateSummary.NomineeMobile || !InitiateSummary.mobileBelongsTo\" class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveNominee()>Approve Transaction</button></div></section></form></div><style>.declaration{\n    width:100%;\n    float: left;\n    padding-left: 16px;\n  }\n  .declaration h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }\n  .terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.cancelTransaction.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a cancel transaction request for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Cancellation Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>Distributor Code:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionType !== \'FLEXSIP\'\"><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.transactionType === \"SMART_SWAP\" ? \"SMART SWAP\" : InitiateSummary.summaryDetails.transactionType}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionType === \'FLEXSIP\'\"><td>Transaction Type:</td><td>Flex SIP</td></tr></table></div><div class=email-block><!--<p class=\"email-block-header\">Scheme Transferring From</p>--><table class=\"table borderless\" ng-if=\"InitiateSummary.summaryDetails.transactionType !== \'SMART_SWAP\'\"><tr ng-if=InitiateSummary.summaryDetails.sipRegistrationNumber><td ng-if=\"InitiateSummary.summaryDetails.transactionType === \'FLEXSIP\'\">Flex SIP Registeration Number:</td><td ng-if=\"InitiateSummary.summaryDetails.transactionType !== \'FLEXSIP\'\">SIP Registeration Number:</td><td>{{InitiateSummary.summaryDetails.sipRegistrationNumber}}</td></tr><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>CAMS Transaction number:</td><td>{{InitiateSummary.summaryDetails.camsRefNo}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>From Date:</td><td>{{InitiateSummary.summaryDetails.startDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionType === \'FLEXSIP\'\"><td>Flex SIP Tenure :</td><td>{{InitiateSummary.tenureDiff}} years</td></tr><tr><td>To Date:</td><td>{{InitiateSummary.summaryDetails.endDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionType !== \'FLEXINDEX\'\"><td>Number of Installments:</td><td>{{InitiateSummary.summaryDetails.installments}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionType !== \'FLEXINDEX\'\"><td>Frequency:</td><td>{{InitiateSummary.summaryDetails.frequency}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.amount><td>Amount:</td><td><i ng-if=\"InitiateSummary.summaryDetails.amount > 0\" class=rupee-grey-icon></i>{{(InitiateSummary.summaryDetails.amount > 0)?InitiateSummary.summaryDetails.amount:\'NA\'}}</td></tr></table><table class=\"table borderless\" ng-if=\"InitiateSummary.summaryDetails.transactionType === \'SMART_SWAP\'\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Mode:</td><td>Online</td></tr><tr><td>CAMS Transaction number:</td><td>{{InitiateSummary.summaryDetails.camsRefNo}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.amount><td>SMART SWAP Amount:</td><td>{{InitiateSummary.summaryDetails.amount}}</td></tr><tr><td>Frequency:</td><td>{{InitiateSummary.summaryDetails.frequency|frequency}}</td></tr><tr><td>% Percentage (per annum):</td><td>{{InitiateSummary.summaryDetails.percentage}}</td></tr><tr><td>SMART SWAP Start Date:</td><td>{{InitiateSummary.summaryDetails.startDate}}</td></tr></table><div class=\"nav-applicability-note smart_swap_note\" ng-if=\"InitiateSummary.summaryDetails.transactionType === \'SMART_SWAP\'\"><div class=imp-info><strong>Important:</strong><p><i class=dot></i> <span ng-bind-html=InitiateSummary.appConstants.SWAP_NOTE class=nav-faq-link></span></p></div></div><div ng-if=\"InitiateSummary.summaryDetails.transactionType === \'SIP\' || InitiateSummary.summaryDetails.transactionType === \'DREAMSIP\' || InitiateSummary.summaryDetails.transactionType === \'FLEXSIP\'\"><div class=row><ng-bind-html dynamic=InitiateSummary.dynamicNoteSipCancel.content></ng-bind-html></div></div></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><!--<span ng-click=\"InitiateSummary.viewLater()\"\n              class=\"btn btn-negative-action\">View Later</span>--> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransactionForCANCELLATION() class=\"btn btn-negative-action\">Reject Cancellation</span> <span ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.showNudgeReasons() class=\"btn btn-primary-action\">Approve Cancellation</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.cancelnominee.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-sip><div class=content-header><h5 class=text-capitalize>Cancel Nominee</h5></div><div class=content-body><div class=email-block><div class=\"tab-container form-content\"><ul class=\"nav nav-tabs\"><li role=button tabindex={{$index}} ng-repeat=\"nominee in InitiateSummary.summaryDetails.nomineeList\" ng-click=InitiateSummary.setActiveTab($index) ng-class=\"{\'active\':InitiateSummary.activeTab === $index}\" class=tab-nominee>{{InitiateSummary.enum[$index]}} Nominee Details</li></ul></div><div ng-repeat=\"nominee in InitiateSummary.summaryDetails.nomineeList\" ng-show=\"InitiateSummary.activeTab===$index\"><div class=\"row mt54\"><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=name-{{$index}} ng-model=nominee.name required readonly><label>Name<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=proportion-{{$index}} ng-model=nominee.percentage required readonly><label>Proportion<span class=req>*</span></label></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeCountry-{{$index}} ng-model=nominee.dateOfBirth required readonly><label>DOB - DD/MMM/YYYY<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeRelation-{{$index}} ng-model=nominee.relation required readonly><label>Relationship<span class=req>*</span></label></div></div></div><div class=form-content ng-if=!nomineeData.minor ng-class=\"{\'anything-disabled\': nomineeData.soleAddressApplicable }\"><p ng-if=!nominee.guardian><strong>Address Details of Nominee</strong></p><p ng-if=nominee.guardian><strong>Address Details of Nominee\'s Guardian</strong></p><div class=\"row mgt20\" ng-if=nominee.guardian><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=guardianName-{{$index}} ng-model=nominee.guardian required readonly><label>Guardian Name<span class=req>*</span></label></div></div></div><div class=\"row mgt20\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine1-\'+$index].$dirty && nomineeForm[\'addressLine1-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text ng-model=nominee.address1 name=addressLine1-{{$index}} autocomplete=off ng-required=!nomineeData.soleAddressApplicable required capitalize readonly><label>Address Line 1<span class=req>*</span></label></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm[\'addressLine2-\'+$index].$dirty && nomineeForm[\'addressLine2-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text ng-model=nominee.address2 name=addressLine2-{{$index}} autocomplete=off required capitalize readonly><label>Address Line 2<span class=req>*</span></label></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13\" style=\"margin-top: 10px\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} ng-model=nominee.city ng-required=!nomineeData.soleAddressApplicable required capitalize readonly><label>City of Birth<span ng-if=!nomineeData.soleAddressApplicable class=req>*</span></label><!--<div ng-if=\"nomineeData.nomineeAddress.country === \'India\'&&nomineeData.nomineeAddress.city&&Nominee.cityList.length\" class=\"suggestion box-shadow\">\n                    <ul><li ng-repeat=\"_data in Nominee.cityList|filterCity:nomineeData.nomineeAddress.city track by $index\" ng-click=\"Nominee.selectNomineeBirthCity(_data,nomineeData)\"> {{_data.cityName}}</li></ul>\n                  </div>--></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\" ng-class=\"{error:nomineeForm[\'city-\'+$index].$dirty && nomineeForm[\'city-\'+$index].$invalid && nomineeData.nomineeName}\"><input type=text name=city-{{$index}} ng-model=nominee.stateCode ng-required=!nomineeData.soleAddressApplicable required capitalize readonly><label>State<span ng-if=!nomineeData.soleAddressApplicable class=req>*</span></label><!--<div ng-if=\"nomineeData.nomineeAddress.country === \'India\'&&nomineeData.nomineeAddress.city&&Nominee.cityList.length\" class=\"suggestion box-shadow\">\n                    <ul><li ng-repeat=\"_data in Nominee.cityList|filterCity:nomineeData.nomineeAddress.city track by $index\" ng-click=\"Nominee.selectNomineeBirthCity(_data,nomineeData)\"> {{_data.cityName}}</li></ul>\n                  </div>--></div></div></div><div class=row><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeCountry-{{$index}} ng-model=nominee.country required readonly><label>Country of Birth<span class=req>*</span></label></div></div><div class=col-md-4><div class=\"input-select input-normal mr-less mgt13 nominee-form-input\"><input type=text name=nomineeZip-{{$index}} ng-model=nominee.postalCode required readonly><label>Zip / Postal Code <span class=\"req text-red\">*</span></label></div></div></div><div class=\"point-to-note cancelNomineePoint\"><strong>Please note:</strong><br><ul><li>By cancelling nomination for the folio there would not be any transfer of units to nominee in case of death of unit holder.</li><li>If you still want to go ahead with cancellation of nomination, then please agree to the below Terms and Connditions by ticking the checkbox.</li></ul></div><div class=\"terms-condition form-group\"><div class=nomineeTermHeading><strong>Terms & Conditions</strong></div><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.nomineetermsAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I have read and understood <a href=javascript:void(0) ng-click=InitiateSummary.termsAndContitions()>Terms &amp; Conditions</a> of cancellation of nomination</label></div></div></div></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\"><button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.rejectNominee()>Reject</button> <button type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveNominee() ng-disabled=!InitiateSummary.nomineetermsAndConditions>Approve Transaction</button></div></section></div><style>.declaration{\n    width:100%;\n    float: left;\n    padding-left: 16px;\n  }\n  .declaration h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }\n  .terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.changeDividend.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear </span>{{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorName}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorName}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.arnCode}}</td></tr><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Existing Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td style=\"width: 25%\">Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.reInvestOption == \'Reinvest\' ? \'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\' : \'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=form-group><h6 style=padding-bottom:15px>Declaration :</h6><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label><ng-bind-html dynamic=InitiateSummary.dynamicNoteIDCW.content></ng-bind-html></div><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.approveTransactionForChangeDividend() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.changeOption.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear </span>{{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a change option request for your Dream SIP which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>Distributor Code :</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type :</td><td>Change Option</td></tr></table></div><div class=email-block><!-- <p class=\"email-block-header\">Transaction Details</p> --><form name=tForm><table class=\"table borderless\"><tr><td>SIP Registeration Number :</td><td>{{InitiateSummary.summaryDetails.sipRegistrationNumber}}</td></tr><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>CAMS Transaction Number:</td><td>{{InitiateSummary.summaryDetails.camsTransactionNumber}}</td></tr><tr><td>Source Scheme Name:</td><td>{{InitiateSummary.summaryDetails.sourceSchemeName}}</td></tr><tr><td>From Date:</td><td>{{InitiateSummary.summaryDetails.fromDate}}</td></tr><tr><td>To Date:</td><td>{{InitiateSummary.summaryDetails.toDate}}</td></tr><tr><td>Number of Installments :</td><td>{{InitiateSummary.summaryDetails.noOfInstallments}}</td></tr><tr><td>Frequency:</td><td>Monthly</td></tr><tr><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr><tr><td>Old Dream SIP Option:</td><td>Option {{InitiateSummary.summaryDetails.oldDreamsipOption}}</td></tr><tr><td>New Dream SIP Option:</td><td>Option {{InitiateSummary.summaryDetails.newDreamsipOption}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.newDreamsipOption == \'B\' \"><td>Target Scheme Name:</td><td>{{InitiateSummary.summaryDetails.targetSchemeName}}</td></tr></table></form></div><div class=email-block><div class=form-group><h6 style=padding-bottom:15px>Declaration :</h6><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><div class=email-block-button><!-- <span ng-click=\"InitiateSummary.viewLater()\" class=\"btn btn-negative-action\">View Later</span> --> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=!InitiateSummary.termaAndConditions ng-click=InitiateSummary.approveTransactionForChangeOption() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section><style>.radio-block label {\n        top: -13px;\n    }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.changeTargetScheme.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear </span>{{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a change target scheme request for your Dream SIP which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>Distributor Code :</td><td>{{InitiateSummary.summaryDetails.arnCode}}</td></tr><tr><td>Transaction Type :</td><td>Change Target Scheme</td></tr></table></div><div class=email-block><!-- <p class=\"email-block-header\">Transaction Details</p> --><form name=tForm><table class=\"table borderless\"><tr><td>SIP Registeration Number :</td><td>{{InitiateSummary.summaryDetails.sipRegistrationNumber}}</td></tr><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>CAMS Transaction Number:</td><td>{{InitiateSummary.summaryDetails.camsTransactionNumber}}</td></tr><tr><td>Source Scheme Name:</td><td>{{InitiateSummary.summaryDetails.sourceSchemeName}}</td></tr><tr><td>From Date:</td><td>{{InitiateSummary.summaryDetails.fromDate}}</td></tr><tr><td>To Date:</td><td>{{InitiateSummary.summaryDetails.toDate}}</td></tr><tr><td>Number of Installments :</td><td>{{InitiateSummary.summaryDetails.noOfInstallments}}</td></tr><tr><td>Frequency:</td><td>Monthly</td></tr><tr><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr><tr><td>Dream SIP Option:</td><td>Option {{InitiateSummary.summaryDetails.newDreamsipOption}}</td></tr><tr><td>Old Target Scheme Name:</td><td>{{InitiateSummary.summaryDetails.targetSchemeName}}</td></tr><tr><td>New Target Scheme Name:</td><td>{{InitiateSummary.summaryDetails.newTargetSchemeName}}</td></tr></table></form></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=form-group><h6 style=padding-bottom:15px>Declaration :</h6><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=!InitiateSummary.termaAndConditions ng-click=InitiateSummary.approveTransactionForChangeOption() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section><style>.radio-block label {\n        top: -13px;\n    }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.dreamSip.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-sip><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=content-body><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode\"><div class=content-body><div class=email-block><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.subBrokerArn><td>Sub Broker ARN:</td><td>{{InitiateSummary.summaryDetails.subBrokerArn}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.subBrokerCode><td>Sub Broker Code:</td><td>{{InitiateSummary.summaryDetails.subBrokerCode}}</td></tr></table></div></div></section><section><div class=content-body><div class=email-block><p class=email-block-header>Dream Sip Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Option:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Target Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Swap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>Dream SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.sipFrequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.sipFrequency==\'Weekly\'\"><td>Dream Sip period:</td><td>{{InitiateSummary.summaryDetails.weeklyDay}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>Dream SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.sipDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>Dream SIP End Date:</td><td>{{InitiateSummary.summaryDetails.sipEndDate}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>Dream SIP First Installment :</td><td>{{InitiateSummary.summaryDetails.sipWithFirstInstallment ? \'Yes\': \'No\'}}</td></tr><!-- <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">\n            <td>Dream SIP First Installment Amount :</td>\n            <td ng-if=\"!InitiateSummary.summaryDetails.bulkTransactionFlag\">&#8377; {{InitiateSummary.summaryDetails.firstInstallmentDetails.amount?InitiateSummary.summaryDetails.firstInstallmentDetails.amount:InitiateSummary.summaryDetails.amount}}</td>\n            <td ng-if=\"InitiateSummary.summaryDetails.bulkTransactionFlag\">&#8377; {{InitiateSummary.summaryDetails.amount}}</td>\n          </tr> --></table></div></div></section><section ng-if=InitiateSummary.summaryDetails.checkedNfoAutoSwitch><div class=content-body><div class=email-block><p class=email-block-header>Auto Switch Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Auto Switch On Maturity:</td><td>{{InitiateSummary.summaryDetails.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.autoSwitchScheme}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption!=\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div></div></section><section ng-if=InitiateSummary.summaryDetails.sipTopupEnabled><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupDetails.amount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.percentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.frequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupDetails.capMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\'\"><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupAmount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupPercentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupPercentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupFrequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupCapAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupCapMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.folioBankDetails.bankName &&\n    InitiateSummary.summaryDetails.folioBankDetails.bankAcNo && InitiateSummary.summaryDetails.folioBankDetails.bankBranch &&\n    InitiateSummary.summaryDetails.folioBankDetails.ifscCode\"><div class=content-body><div class=email-block><p class=email-block-header>Primary Bank Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankName><td>Bank Name:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankName}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankAcNo><td>Account Number:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcNo}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankBranch><td>Branch:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankBranch}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.ifscCode><td>IFSC Code:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.ifscCode}}</td></tr></table></div></div></section><!--\n  <retirement-fund-summary\n    holders=\"InitiateSummary.summaryDetails.holders\"\n    folionumber=\"InitiateSummary.summaryDetails.folioNumber\"\n    holdersform=\"InitiateSummary.holdersForm\"\n    ng-if=\"InitiateSummary.summaryDetails.holders.length>0\"\n  >\n  </retirement-fund-summary>--><!--\n  <section ng-if=\"InitiateSummary.summaryDetails.newFolio\">\n    <div class=\"content-body\">\n      <div class=\"email-block\">\n        <p class=\"email-block-header\">Upload Documents</p>\n\n        <p class=\"mrt red\">Document type : JPG or PNG only . Maximum file size : 1.5MB each</p>\n        <form autocomplete=\"off\" name=\"docUpload\" ng-submit=\"InitiateSummary.submitDoc()\" novalidate>\n          <table class=\"table borderless purchase-sip\">\n            <tr>\n              <td>Cheque Leaf :</td>\n              <td>\n                <input type=\"file\" name=\"chequeLeaf\" serial=\"1\" file-model-profile=\"InitiateSummary.doc.chequeLeaf\"\n                       upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img1}}</p>\n              </td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>DOB Proof :</td>\n              <td><input type=\"file\" name=\"minorProof\" serial=\"2\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                         accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.minorProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img2}}</p></td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>Guardian Proof :</td>\n              <td>\n                <input type=\"file\" name=\"guardianProof\" serial=\"3\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.guardianProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img3}}</p></td>\n            </tr>\n          </table>\n          <button ng-if=\"!InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 1\">Upload Files\n          </button>\n          <button ng-if=\"InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 3\">Upload Files\n          </button>\n        </form>\n      </div>\n    </div>\n  </section>\n--><section ng-if=\"InitiateSummary.summaryType==\'SIP\'|| InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\'\"><div class=content-body><div class=email-block><div><p class=email-block-header>Payment Options for SIP Registration</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionsSip\" ng-class=\"{\'anything-disabled\': InitiateSummary.summaryDetails.payMech !== option.key && !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled) || (option.key ===\'EC\' && InitiateSummary.siEnabled) || (option.key ===\'HEM\' && InitiateSummary.emandateEnabled))\"><span class=radio><input type=radio id={{option.key}} name=paymentOption value={{option.key}} ng-model=InitiateSummary.selectedPaymentOption ng-change=InitiateSummary.paymentOptionChanged()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div><!--Bank select for standing instructions--><p ng-if=\"InitiateSummary.selectedPaymentOption==\'EC\' && InitiateSummary.siEnabled\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'EC\' && InitiateSummary.siEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=InitiateSummary.changeBank() ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div></div></div><!---------------------------------------------------><!--Bank select for OTM banks--><p ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.otmBankData ng-change=InitiateSummary.changedOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option><!--<option ng-repeat=\"bank in InitiateSummary.otmBankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.otmLimitValidation && InitiateSummary.otmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.endDateValidation && InitiateSummary.otmBankData\">Selected date is greater than OTM expiry date.</span></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.bankList.length > 0)\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\"><div class=col-md-3><div class=selectfield ng-if=\"InitiateSummary.bankList.length > 0\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=\"InitiateSummary.authMode = InitiateSummary.bankdata; InitiateSummary.authModeSelect = InitiateSummary.authMode.authenticationModes[0];\n                              InitiateSummary.emPayoutId = InitiateSummary.bankdata.bankName\" ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null;\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div><!--            <span class=\"error-message emandate-error-message\"--><!--                  ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && InitiateSummary.isEmandateMaxLimit < InitiateSummary.amount && InitiateSummary.amount\"--><!--                  class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode--><!--            </span>--> <span class=\"error-message emandate-error-message\" ng-if=\"InitiateSummary.bankList.length === 0\">No Bank Available</span></div></div><p ng-if=\"InitiateSummary.summaryDetails.bulkTransactionFlag\n          && (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)\" class=payment-error-message><strong>No valid payment mode available to proceed with SIP transaction</strong></p><form autocomplete=off name=InitiateSummary.EcsBankForm class=clearfix ng-submit=InitiateSummary.approveEcsBankTransaction() novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOption != \'HEM\' && (InitiateSummary.isOtmEnabled || InitiateSummary.siEnabled)\"><div class=bank-detail style=\"margin-left: 15px\"><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.ecsBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\" style=\"margin-top: -10px\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType && InitiateSummary.selectedPaymentOption==\'OTM\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-init=\"InitiateSummary.ecsBankModal.bankAcType=InitiateSummary.ecsBankModal.bankAcType?InitiateSummary.ecsBankModal.bankAcType:null\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=col-md-3 ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.ifscCode && InitiateSummary.selectedPaymentOption==\'EC\'\"><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off ng-required=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$dirty&&InitiateSummary.EcsBankForm.ifscCode.$error.pattern ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.bankAcType && InitiateSummary.selectedPaymentOption==\'EC\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-init=\"InitiateSummary.ecsBankModal.bankAcType=InitiateSummary.ecsBankModal.bankAcType?InitiateSummary.ecsBankModal.bankAcType:null\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption != \'EC\' && (InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankBranch ng-model=InitiateSummary.ecsBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankBranch.$error.required ng-bind=InitiateSummary.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankCity ng-model=InitiateSummary.ecsBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankCity.$error.required ng-bind=InitiateSummary.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption != \'EC\'\"><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.ecsBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.ecsBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.ecsBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code</label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty&&InitiateSummary.EcsBankForm.ifscCode.$error.pattern ||InitiateSummary.EcsBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.ecsBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled ) \"><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.ecsBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.ecsBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled ) \"><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><input type=hidden id=hfReq></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && !InitiateSummary.emandateBankNotAvailable)\"><div><p class=email-block-header><u>Emandate Registration Details</u></p><table class=\"table borderless emandate-table\"><tr><td>Bank Name:</td><td>{{InitiateSummary.emPayoutId.substr(0, InitiateSummary.emPayoutId.lastIndexOf(\'-\'))}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.emPayoutId.slice(InitiateSummary.emPayoutId.lastIndexOf(\'-\') + 1)}}</td></tr><tr><td>Amount:</td><td><i class=rupee-grey-icon></i>{{InitiateSummary.amount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr><td>Start Date:</td><td>{{InitiateSummary.eMandateStartDate}}</td></tr><tr><td>End Date:</td><td>{{InitiateSummary.eMandateEndDate}}</td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr><tr><td>Authentication mode:</td><td><div class=row><div class=col-md-3><div class=selectfield><label>Authentication Mode</label><select class=\"browser-default custom-select\" name=bankName ng-model=InitiateSummary.authModeSelect ng-options=\"item.text for item in InitiateSummary.authMode.authenticationModes\" ng-required=\"InitiateSummary.selectedPaymentOption == \'HEM\'\" ng-change=\"InitiateSummary.authModeData=InitiateSummary.authModeSelect\" required><option value=\"\" selected>Select Authentication Mode</option></select><span class=req>*</span></div></div></div></td></tr></table></div><!--<div class=\"row\" ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\">\n              <div class=\"col-md-3\"></div>\n                <div class=\"col-md-3\">\n\n                </div>\n              </div>--></div></form><!------------------------------------------></div><!-- payment option for sip with first installment--><div ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails || (InitiateSummary.summaryDetails.bulkTransactionFlag && InitiateSummary.summaryDetails.sipWithFirstInstallment || InitiateSummary.summaryDetails.sipWithFirstInstallment)\"><p class=email-block-header>Payment Options for First Installment of SIP</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionForFirstInstallment\" ng-class=\"{\'anything-disabled\':(InitiateSummary.summaryDetails.firstInstallmentDetails?InitiateSummary.summaryDetails.firstInstallmentDetails.paymentMode !== option.key:\'\') &&\n               !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled) || (option.key ===\'WEB\'))\"><span class=radio><input type=radio id={{option.key}} name=paymentOptionForFi value={{option.key}} ng-model=InitiateSummary.selectedPaymentOptionForFI ng-change=InitiateSummary.paymentOptionChangedForFi()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div><p ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'WEB\'\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><div class=col-md-3><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankListForFi\" ng-model=InitiateSummary.fiBankdata ng-change=InitiateSummary.checkMinorBankFlag()><option value=\"\" selected>Select Bank</option><!--<option ng-repeat=\"bank in InitiateSummary.bankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select></div></div></div><div ng-if=\"InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><form autocomplete=off name=InitiateSummary.FInetbanking class=clearfix><div class=form-content><div class=bank-detail><p ng-if=\"InitiateSummary.fiBankdata && (!InitiateSummary.fiBankdata.ifscCode || !InitiateSummary.fiBankdata.bankAcType)\"><strong>Bank Details</strong></p><br><div class=row><div class=col-md-3 ng-if=\"InitiateSummary.fiBankdata && !InitiateSummary.fiBankdata.ifscCode\"><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.fibankData.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off ng-required=\"InitiateSummary.selectedPaymentOptionForFI !=\'OTM\'\" capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.FInetbanking.ifscCode.$dirty && InitiateSummary.FInetbanking.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.FInetbanking.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=InitiateSummary.FInetbanking.ifscCode.$dirty&&InitiateSummary.FInetbanking.ifscCode.$error.pattern ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.fiBankdata && !InitiateSummary.fiBankdata.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.FInetbanking.accountType.$dirty && InitiateSummary.FInetbanking.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.fibankData.accType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.fibankData.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.FInetbanking.accountType.$error ng-show=InitiateSummary.FInetbanking.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div></form></div></div><!-- otm bank selection for fi--><p ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.fiOtmBankData ng-change=InitiateSummary.changedFiOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiOtmLimitValidation && InitiateSummary.fiOtmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiEndDateValidation && InitiateSummary.fiOtmBankData\">Selected date is greater than OTM expiry date.</span></div></div></div><form autocomplete=off name=InitiateSummary.fiOtmBankForm class=clearfix novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOptionForFI ===\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=bank-detail><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankName.$dirty &&\n                          InitiateSummary.fiOtmBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.fiOtmBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankName.$dirty && InitiateSummary.fiOtmBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-5><div class=\"input-normal branch-loc\"><input type=text name=bankBranch ng-model=InitiateSummary.fiOtmBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\"><input type=text name=bankCity ng-model=InitiateSummary.fiOtmBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City</label></div></div></div><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankAcNo.$dirty && InitiateSummary.fiOtmBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.fiOtmBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$dirty &&\n                         InitiateSummary.fiOtmBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$error.minlength ||\n                            !InitiateSummary.fiOtmBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty &&\n                          InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.fiOtmBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.fiOtmBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty && InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=\"(InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.fiOtmBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code <span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty && InitiateSummary.fiOtmBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty&&InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern || InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.fiOtmBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.fiOtmBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.fiOtmBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-4 ng-if=\"InitiateSummary.fiOtmBankData && !InitiateSummary.fiOtmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.accountType.$dirty && InitiateSummary.fiOtmBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.fibankData.accType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.fibankData.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.fiOtmBankForm.accountType.$error ng-show=InitiateSummary.fiOtmBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></form><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && InitiateSummary.emandateEnabled\"><!--dynamic content for Emandate--><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandate.content ng-if=\"InitiateSummary.authModeSelect.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandateDebitCard.content ng-if=\"InitiateSummary.authModeSelect.value === \'DEBIT_CARD\'\"></ng-bind-html></div><div class=\"point-to-note-tpv-approval ng-scope\" ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && !InitiateSummary.selectedPaymentOptionForFI \"><!--dynamic content for OTM--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOtm.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && !InitiateSummary.selectedPaymentOptionForFI \"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteGeneral.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteSIWEB.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && InitiateSummary.selectedPaymentOptionForFI==\'OTM\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteSIOTM.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI==\'OTM\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOTMOTM.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI==\'WEB\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOTMWEB.content></ng-bind-html></div><div class=\"terms-condition form-group declaration\"><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=InitiateSummary.ischecked required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><hr><div class=\"terms-condition form-group\" ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\' && InitiateSummary.showTerms\"><span class=checkbox><input id=tcsCheckboxEMandate type=checkbox name=termsAndConditionsEMandate ng-model=InitiateSummary.termsAndConditionsEMandate required> <span class=icon-checkbox></span></span><label for=tcsCheckboxEMandate class=\"checkbox-text tnc\">I have read and understood <a href=javascript:void(0) ng-click=InitiateSummary.termsAndConditionsEMandateModal()>Terms &amp; Conditions</a> of e-mandate (eOTM)</label></div><hr><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{InitiateSummary.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=InitiateSummary.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=InitiateSummary.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=InitiateSummary.billdeskPayload.msg></form></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-if=\"(InitiateSummary.summaryType==\'SIP\' || InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\') && !InitiateSummary.isActionPerformed\"><!-- <button type=\"button\" class=\"btn btn-negative-action\" ng-click=\"InitiateSummary.viewLater()\">View Later</button> --> <button type=button class=\"btn btn-negative-action\" ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.rejectTransaction()>Reject</button> <button ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && InitiateSummary.selectedPaymentOption !=\'HEM\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.ecsBankModal.bankName\n              || ((InitiateSummary.selectedPaymentOption !==\'OTM\') && (!InitiateSummary.ecsBankModal.bankBranch || !InitiateSummary.ecsBankModal.bankCity))\n              ||  InitiateSummary.otmLimitValidation\n              ||  InitiateSummary.endDateValidation\n              || !InitiateSummary.ecsBankModal.bankAcNo || !InitiateSummary.ecsBankModal.verifyBankAcNo\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\n              ||  (InitiateSummary.summaryDetails.payMech === \'OTM\'\n                              && InitiateSummary.otmBankData.otmFrequency != \'AWP\'\n                              && InitiateSummary.summaryDetails.sipFrequency === \'Daily\') || (InitiateSummary.selectedPaymentOption ==\'OTM\' && !InitiateSummary.ecsBankModal.ifscCode) || !InitiateSummary.ecsBankModal.bankAcType || !InitiateSummary.ecsBankModal.ifscCode || (InitiateSummary.selectedPaymentOptionForFI==\'WEB\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiBankdata)\n              || (InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiOtmBankData) || InitiateSummary.FInetbanking.$invalid || InitiateSummary.fiOtmBankForm.$invalid || InitiateSummary.EcsBankForm.$invalid || InitiateSummary.fiEndDateValidation || InitiateSummary.fiOtmLimitValidation\">Approve Transaction</button> <button ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.bankdata || !InitiateSummary.authModeSelect\n              || !InitiateSummary.termaAndConditions || !InitiateSummary.termsAndConditionsEMandate\">Approve Transaction</button> <button ng-if=\"InitiateSummary.selectedPaymentOption ==\'EC\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.ecsBankModal.bankName\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\n              ||  (InitiateSummary.summaryDetails.payMech === \'OTM\'\n                              && InitiateSummary.otmBankData.otmFrequency != \'AWP\'\n                              && InitiateSummary.summaryDetails.sipFrequency === \'Daily\') || !InitiateSummary.ecsBankModal.bankAcType || (InitiateSummary.selectedPaymentOption ==\'EC\' && !InitiateSummary.ecsBankModal.ifscCode) || (InitiateSummary.selectedPaymentOptionForFI==\'WEB\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiBankdata)\n              || (InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiOtmBankData) || InitiateSummary.FInetbanking.$invalid || InitiateSummary.fiOtmBankForm.$invalid || InitiateSummary.fiEndDateValidation || InitiateSummary.fiOtmLimitValidation\">Approve Transaction</button><!--<button class=\"btn btn-primary-action\"  ng-click=\"InitiateSummary.approveTransaction()\" >Approve Transaction</button>--></div></section></div><style>.terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.dtp.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType == \'DTP\' ? \'TIP\' : InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr></table></div><div class=email-block ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode\"><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.subBrokerArn><td>Sub Broker ARN:</td><td>{{InitiateSummary.summaryDetails.subBrokerArn}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.subBrokerCode><td>Sub Broker Code:</td><td>{{InitiateSummary.summaryDetails.subBrokerCode}}</td></tr></table></div><div class=email-block><p class=email-block-header>Source Scheme</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Source Scheme Name:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr></table></div><div class=email-block><p class=email-block-header>Target Scheme</p><table class=\"table borderless\"><tr><td>Target Scheme Name:</td><td>{{InitiateSummary.summaryDetails.targetScheme.schemeName}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.targetScheme.investmentOption.toUpperCase() != InitiateSummary.appConstants.INVESTMENT_OPTIONS.GROWTH\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.targetScheme.dividendOption | dividendOption }}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><ng-bind-html dynamic=InitiateSummary.dynamicNoteDTP.content></ng-bind-html></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-click=InitiateSummary.approveTransactionForSWITCH_STP_DTP_REDEEM() ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.flexindex.html","<header class=\"container-fluid summary-header affix\"><div><span class=\"logo cursor-pointer\"><img ui-sref=main.dashboard src=../../../assets/images/logo.png href=/dashboard></span></div></header>><div class=\"approval main-section flex-index-summary-approval\"><h3 class=page-title><small>Investment for</small><br><span>{{InitiateSummary.summaryDetails.investorName}}</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li><strong>Distributor Name:</strong> <span>{{InitiateSummary.summaryDetails.distributorDetails.name}}</span></li><li><strong>ARN:</strong> <span ng-bind=InitiateSummary.summaryDetails.distributorDetails.arnNo></span></li><li ng-if=InitiateSummary.summaryDetails.subBrokerArn><strong>Sub Broker ARN:</strong> <span>{{InitiateSummary.summaryDetails.subBrokerArn}}</span></li><li ng-if=InitiateSummary.summaryDetails.subBrokerCode><strong>Sub Broker Code:</strong> <span>{{InitiateSummary.summaryDetails.subBrokerCode}}</span></li></ul></div><div class=\"box-body folio-approval-investor\"><form autocomplete=off name=FolioApproval.soleApplicantForm ng-submit=FolioApproval.submitApplicantDetails() novalidate><div class=\"sole-applicant folio-approval\"><!--ng-if=\"!InitiateSummary.summaryDetails.euinCode\"--><div class=form-content><label class=euin ng-if=\"!InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><strong>EUIN Option:</strong></label><div class=row ng-if=\"!InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin class=radio-label>EUIN</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration class=radio-label>Self Declaration</label></div></div></div><div class=row ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted === \'Y\' && !InitiateSummary.summaryDetails.euinCode)\"><div class=col-md-4><div class=\"input-select input-normal selectfield req-customised\" ng-class=\"{error:sipForm.euin.$dirty && sipForm.euin.$invalid}\"><select class=\"browser-default custom-select\" name=euin ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=req>*</span> <span ng-show=\"sipForm.euin.$dirty && sipForm.euin.$invalid\"><span class=error-input ng-show=sipForm.euin.$error.required ng-bind=Scheme.validateData.EUIN_REQUIRED></span></span></div></div></div><div class=row ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode)\"><div class=col-md-12><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></div></div><div class=form-content><p><strong>Flex Index Transaction</strong></p><div class=row><div class=col-md-4><table class=\"table borderless flex-table\"><tr><td>Folio No.:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Source Scheme:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr><td>Traget Scheme:</td><td>{{InitiateSummary.summaryDetails.targetScheme.schemeName}}</td></tr><tr><td>Amount:</td><td>{{InitiateSummary.summaryDetails.amount}}</td></tr><tr><td>Investment Mode:</td><td>{{InitiateSummary.summaryDetails.investmentMode === \"F\"?\"Fixed\":\"Flexible\"}}</td></tr></table><div class=instalment-details><p><strong>Installment Details</strong></p><table class=\"table table-striped borderless flex-table\"><tr><th>Fixed Installments</th><th>Stages of Switch Execution</th></tr><tr><td>{{InitiateSummary.summaryDetails. switchExecutionDetails.firstSwitchExecutionEntry.switchPercentage}}</td><td>(I){{InitiateSummary.summaryDetails. switchExecutionDetails.firstSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{InitiateSummary.summaryDetails. switchExecutionDetails.secondSwitchExecutionEntry.switchPercentage}}</td><td>(I){{InitiateSummary.summaryDetails. switchExecutionDetails.secondSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{InitiateSummary.summaryDetails. switchExecutionDetails.thirdSwitchExecutionEntry.switchPercentage}}</td><td>(I){{InitiateSummary.summaryDetails. switchExecutionDetails.thirdSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr><tr><td>{{InitiateSummary.summaryDetails. switchExecutionDetails.fourthSwitchExecutionEntry.switchPercentage}}</td><td>(I){{InitiateSummary.summaryDetails. switchExecutionDetails.fourthSwitchExecutionEntry.sensexLevelForSwitch}}</td></tr></table></div></div></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px;padding-top: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\" style=\"padding-top: 10px\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div></div><div class=\"form-footer form-content\"><div class=email-block-button><!--<span ng-click=\"InitiateSummary.viewLater()\" class=\"btn btn-negative-action\">View Later</span>--> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=\"InitiateSummary.isActionPerformed || FolioApproval.soleApplicantForm.$invalid || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.approveTransactionForSWITCH_STP_DTP_REDEEM() class=\"btn btn-primary-action\">Approve Transaction</span></div><!--<button type=\"button\"  class=\"btn btn-negative-action\" ng-click=\"FolioApproval.confirmCancelModaltoReject()\">Reject Folio</button>--><!--<button class=\"btn btn-primary-action\" ng-disabled=\"FolioApproval.soleApplicantForm.$invalid--><!--||(!FolioApproval.formData.soleApplicantDetail.netWorthDate && !FolioApproval.formData.soleApplicantDetail.grossAnnualIncome)--><!--||(FolioApproval.formData.soleApplicantDetail.netWorth && !FolioApproval.formData.soleApplicantDetail.netWorthDate)\">Approve Folio</button>--></div></div></form></div></div></div></div><footer class=\"summary-footer main-footer\"><div class=row><div class=\"col-md-12 pull-left flex-style\"><img src=assets/images/logo-main.png alt=HDFC class=\"logo-main pull-left\"> <span>{{InitiateSummary.date | date : \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</span></div></div></footer>");
$templateCache.put("app/transactions/initiate/summary/summary.flexsip.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-sip><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=content-body><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinCode)\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode)\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td>Flex SIP</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode\"><div class=content-body><div class=email-block><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.subBrokerArn><td>Sub Broker ARN:</td><td>{{InitiateSummary.summaryDetails.subBrokerArn}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.subBrokerCode><td>Sub Broker Code:</td><td>{{InitiateSummary.summaryDetails.subBrokerCode}}</td></tr></table></div></div></section><section><div class=content-body><div class=email-block><p class=email-block-header>Scheme Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr ng-if=\"InitiateSummary.selectedPaymentOption !==\'HEM\'\"><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\'\"><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr><td>Flex SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.sipFrequency}}</td></tr><tr><td>Flex SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.sipDate}}</td></tr><tr><td>Flex SIP Tenure :</td><td>{{InitiateSummary.tenureDiff}} years</td></tr><tr><td>Flex SIP End Date:</td><td>{{InitiateSummary.summaryDetails.sipEndDate}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>Flex SIP First Installment :</td><td>{{InitiateSummary.summaryDetails.sipWithFirstInstallment ? \'Yes\': \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>Flex SIP First Installment Amount :</td><td ng-if=!InitiateSummary.summaryDetails.bulkTransactionFlag>&#8377; {{InitiateSummary.summaryDetails.firstInstallmentDetails.amount?InitiateSummary.summaryDetails.firstInstallmentDetails.amount:InitiateSummary.summaryDetails.amount}}</td><td ng-if=InitiateSummary.summaryDetails.bulkTransactionFlag>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr></table></div></div></section><section ng-if=InitiateSummary.summaryDetails.checkedNfoAutoSwitch><div class=content-body><div class=email-block><p class=email-block-header>Auto Switch Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Auto Switch On Maturity:</td><td>{{InitiateSummary.summaryDetails.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.autoSwitchScheme}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption!=\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div></div></section><section ng-if=InitiateSummary.summaryDetails.sipTopupEnabled><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupDetails.amount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.percentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.frequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupDetails.capMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.folioBankDetails.bankName &&\n    InitiateSummary.summaryDetails.folioBankDetails.bankAcNo && InitiateSummary.summaryDetails.folioBankDetails.bankBranch &&\n    InitiateSummary.summaryDetails.folioBankDetails.ifscCode\"><div class=content-body><div class=email-block><p class=email-block-header>Primary Bank Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankName><td>Bank Name:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankName}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankAcNo><td>Account Number:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcNo}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankBranch><td>Branch:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankBranch}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.ifscCode><td>IFSC Code:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.ifscCode}}</td></tr></table></div></div></section><!--\n    <retirement-fund-summary\n      holders=\"InitiateSummary.summaryDetails.holders\"\n      folionumber=\"InitiateSummary.summaryDetails.folioNumber\"\n      holdersform=\"InitiateSummary.holdersForm\"\n      ng-if=\"InitiateSummary.summaryDetails.holders.length>0\"\n    >\n    </retirement-fund-summary>--><!--\n    <section ng-if=\"InitiateSummary.summaryDetails.newFolio\">\n      <div class=\"content-body\">\n        <div class=\"email-block\">\n          <p class=\"email-block-header\">Upload Documents</p>\n\n          <p class=\"mrt red\">Document type : JPG or PNG only . Maximum file size : 1.5MB each</p>\n          <form autocomplete=\"off\" name=\"docUpload\" ng-submit=\"InitiateSummary.submitDoc()\" novalidate>\n            <table class=\"table borderless purchase-sip\">\n              <tr>\n                <td>Cheque Leaf :</td>\n                <td>\n                  <input type=\"file\" name=\"chequeLeaf\" serial=\"1\" file-model-profile=\"InitiateSummary.doc.chequeLeaf\"\n                         upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                         accept=\".jpeg,.jpg,.png\" required/>\n                  <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img1}}</p>\n                </td>\n              </tr>\n              <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n                <td>DOB Proof :</td>\n                <td><input type=\"file\" name=\"minorProof\" serial=\"2\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                           accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.minorProof\" required/>\n                  <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img2}}</p></td>\n              </tr>\n              <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n                <td>Guardian Proof :</td>\n                <td>\n                  <input type=\"file\" name=\"guardianProof\" serial=\"3\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                         accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.guardianProof\" required/>\n                  <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img3}}</p></td>\n              </tr>\n            </table>\n            <button ng-if=\"!InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                    ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 1\">Upload Files\n            </button>\n            <button ng-if=\"InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                    ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 3\">Upload Files\n            </button>\n          </form>\n        </div>\n      </div>\n    </section>\n  --><section><div class=content-body><div class=email-block><!-- payment option for flex sip --><p class=email-block-header>Payment Options for Flex SIP Registration</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionsFlexSip\" ng-class=\"{\'anything-disabled\': InitiateSummary.summaryDetails.payMech !== option.key && !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled) || (option.key ===\'HEM\' && InitiateSummary.emandateEnabled))\"><span class=radio><input type=radio id={{option.key}} name=paymentOption value={{option.key}} ng-model=InitiateSummary.selectedPaymentOption ng-change=InitiateSummary.paymentOptionChanged()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div style=margin-left:0px class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.otmBankData ng-change=InitiateSummary.changedOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option><!--<option ng-repeat=\"bank in InitiateSummary.otmBankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.otmLimitValidation && InitiateSummary.otmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.endDateValidation && InitiateSummary.otmBankData\">Selected date is greater than OTM expiry date.</span></div></div></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\" class=emandate-section-summary><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.bankList.length > 0)\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\"><div class=col-md-3><div class=selectfield ng-if=\"InitiateSummary.bankList.length > 0\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=\"InitiateSummary.authMode = InitiateSummary.bankdata; InitiateSummary.authModeSelect = InitiateSummary.authMode.authenticationModes[0];\n                              InitiateSummary.emPayoutId = InitiateSummary.bankdata.bankName\" ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null;\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div><!--              <span class=\"error-message emandate-error-message\"--><!--                    ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && InitiateSummary.isEmandateMaxLimit < InitiateSummary.amount && InitiateSummary.amount\"--><!--                    class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode--><!--            </span>--> <span class=\"error-message emandate-error-message\" ng-if=\"InitiateSummary.bankList.length === 0\">No Bank Available</span></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.authModeSelect)\"><strong>Authentication Mode</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\"><div class=col-md-3><div class=selectfield><label>Authentication Mode</label><select class=\"browser-default custom-select\" name=bankName ng-model=InitiateSummary.authModeSelect ng-options=\"item.text for item in InitiateSummary.authMode.authenticationModes\" ng-required=\"InitiateSummary.selectedPaymentOption == \'HEM\'\" ng-change=\"InitiateSummary.authModeData=InitiateSummary.authModeSelect\" required><option value=\"\" selected>Select Authentication Mode</option></select><span class=req>*</span></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate Amount <span class=req>*</span></strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable\"><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateSummary.tForm.eAmount.$invalid && InitiateSummary.tForm.eAmount.$dirty),\'has-data\':InitiateSummary.summaryDetails.emandateAmount}\"><input class=input-min style=\"padding-left: 20px\" type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=InitiateSummary.summaryDetails.emandateAmount ng-change=InitiateSummary.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i style=top:-29px class=rupee-grey-icon></i><div class=amtWords ng-if=InitiateSummary.summaryDetails.emandateAmount><p id=amountInwordsEmandate>{{InitiateSummary.emandateWord.amountInWords}} (In Words)</p></div><!--                <span class=\"text-success\">--><!--                 Maximum allowed for e-mandate is ₹ {{InitiateSummary.mandateMaxString}}.--><!--              </span>--><div class=error-input ng-show=InitiateSummary.amountLess>{{InitiateSummary.validations.EMANDATE_MIN_ERROR + InitiateSummary.emandateMinAmountLimit}}.</div><div class=error-input ng-show=InitiateSummary.amountMore>{{InitiateSummary.validations.EMANDATE_MAX_ERROR + InitiateSummary.mandateMaxString}}.</div><div class=error-input ng-show=\"!InitiateSummary.amountLess && InitiateSummary.isLessThanSipAmount\" ng-bind=InitiateSummary.validations.EMANDATE_SIP_AMOUNT_ERROR></div></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate Start Date <span class=req>*</span></strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && InitiateSummary.emandateValidationData && !InitiateSummary.emandateBankNotAvailable)\"><div class=\"col-md-3 anything-disabled\" ng-if=!InitiateSummary.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateSummary.summaryDetails.emandateDate id=emandateStartDate data-enable=true data-on-date-change=InitiateSummary.changeDateEmandate style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate End Date <span class=req>*</span> <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{InitiateSummary.mandateInfo}} tooltip-side=right></i></strong></p><div class=\"row mandateDates\" ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && InitiateSummary.emandateValidationData && !InitiateSummary.emandateBankNotAvailable)\"><div class=col-md-3><div ng-class=\"{\'anything-disabled\': !InitiateSummary.summaryDetails.emandateDate}\"><div ng-if=!InitiateSummary.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:InitiateSummary.tForm.endDateEmandate.$dirty && InitiateSummary.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateSummary.summaryDetails.endDateEmandate data-enabled-dates=InitiateSummary.enabledEmandateEndDatesList data-view-date=InitiateSummary.enabledEndDateView data-max-date=InitiateSummary.maxEndDateEmandate data-min-date=InitiateSummary.minEndDateEmandate data-on-date-change=InitiateSummary.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" class=endDateMandateInput readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px; position: absolute; left: 0px; top: 45px\" class=error-input ng-show=InitiateSummary.sipDateLessEmandate ng-bind=InitiateSummary.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div></div><p ng-if=\"InitiateSummary.summaryDetails.bulkTransactionFlag\n          && (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)\" class=payment-error-message><strong>No valid payment mode available to proceed with Flex SIP transaction</strong></p><form autocomplete=off name=InitiateSummary.EcsBankForm class=clearfix ng-submit=InitiateSummary.approveEcsBankTransaction() novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOption != \'HEM\' && (InitiateSummary.isOtmEnabled || InitiateSummary.siEnabled)\"><div class=bank-detail style=\"margin-left: 15px\"><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.ecsBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\" style=\"margin-top: -10px\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType && InitiateSummary.selectedPaymentOption==\'OTM\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-init=\"InitiateSummary.ecsBankModal.bankAcType=InitiateSummary.ecsBankModal.bankAcType?InitiateSummary.ecsBankModal.bankAcType:null\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=InitiateSummary.isOtmEnabled><div class=col-md-5><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankBranch ng-model=InitiateSummary.ecsBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankBranch.$error.required ng-bind=InitiateSummary.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankCity ng-model=InitiateSummary.ecsBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankCity.$error.required ng-bind=InitiateSummary.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.ecsBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.ecsBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.ecsBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=InitiateSummary.isOtmEnabled><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code</label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty&&InitiateSummary.EcsBankForm.ifscCode.$error.pattern || InitiateSummary.EcsBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.ecsBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div><div class=row ng-if=InitiateSummary.isOtmEnabled><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.ecsBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.ecsBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div></div></div><input type=hidden id=hfReq><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && !InitiateSummary.emandateBankNotAvailable)\"><div><!--                <p class=\"email-block-header\"><u>Emandate Registration Details</u></p>--><table style=\"margin-top: 0px\" class=\"table borderless emandate-table\"><tr><td>Bank Name:</td><td>{{InitiateSummary.emPayoutId.substr(0, InitiateSummary.emPayoutId.lastIndexOf(\'-\'))}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.emPayoutId.slice(InitiateSummary.emPayoutId.lastIndexOf(\'-\') + 1)}}</td></tr><tr ng-if=\"InitiateSummary.amount && !InitiateSummary.takeMandateFields\"><td>Amount:</td><td><i class=rupee-grey-icon></i>{{InitiateSummary.amount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr ng-if=\"InitiateSummary.eMandateStartDate  && !InitiateSummary.takeMandateFields\"><td>Mandate Start Date:</td><td>{{InitiateSummary.eMandateStartDate}}</td></tr><tr ng-if=\"InitiateSummary.eMandateEndDate && !InitiateSummary.takeMandateFields\"><td>Mandate End Date:</td><td>{{InitiateSummary.eMandateEndDate}}</td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table></div><!--<div class=\"row\" ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\">\n                <div class=\"col-md-3\"></div>\n                  <div class=\"col-md-3\">\n\n                  </div>\n                </div>--></div></form><!-- payment option for sip with first installment--><div ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails || (InitiateSummary.summaryDetails.bulkTransactionFlag && InitiateSummary.summaryDetails.sipWithFirstInstallment || InitiateSummary.summaryDetails.sipWithFirstInstallment)\"><p class=email-block-header>Payment Options for 1st Installment of Flex SIP</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionForFirstInstallmentFlexSip\" ng-class=\"{\'anything-disabled\':(InitiateSummary.summaryDetails.firstInstallmentDetails?InitiateSummary.summaryDetails.firstInstallmentDetails.paymentMode !== option.key:\'\') &&\n               !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled))\"><span class=radio><input type=radio id={{option.key}} name=paymentOptionForFi value={{option.key}} ng-model=InitiateSummary.selectedPaymentOptionForFI ng-change=InitiateSummary.paymentOptionChangedForFi()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div></div><!-- otm bank selection for fi--><p ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.fiOtmBankData ng-change=InitiateSummary.changedFiOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiOtmLimitValidation && InitiateSummary.fiOtmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiEndDateValidation && InitiateSummary.fiOtmBankData\">Selected date is greater than OTM expiry date.</span></div></div></div><form autocomplete=off name=InitiateSummary.fiOtmBankForm class=clearfix novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOptionForFI ===\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=bank-detail><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankName.$dirty &&\n                          InitiateSummary.fiOtmBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.fiOtmBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankName.$dirty && InitiateSummary.fiOtmBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\" ng-if=\"InitiateSummary.isOtmEnabled && InitiateSummary.fiOtmBankData && !InitiateSummary.fiOtmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" style=\"margin-top: 6px\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.accountType.$dirty && InitiateSummary.fiOtmBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.fibankData.accType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.fibankData.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.fiOtmBankForm.accountType.$error ng-show=InitiateSummary.fiOtmBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-5><div class=\"input-normal branch-loc\"><input type=text name=bankBranch ng-model=InitiateSummary.fiOtmBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\"><input type=text name=bankCity ng-model=InitiateSummary.fiOtmBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City</label></div></div></div><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankAcNo.$dirty && InitiateSummary.fiOtmBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.fiOtmBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$dirty &&\n                         InitiateSummary.fiOtmBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$error.minlength ||\n                            !InitiateSummary.fiOtmBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty &&\n                          InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.fiOtmBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.fiOtmBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty && InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=\"(InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.fiOtmBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code <span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty && InitiateSummary.fiOtmBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty&&InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern || InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.fiOtmBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.fiOtmBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.fiOtmBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div></div></form><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && InitiateSummary.emandateEnabled\"><!--dynamic content for Emandate--><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandateFlexSip.content ng-if=\"InitiateSummary.authModeSelect.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandateFlexSipDebitCard.content ng-if=\"InitiateSummary.authModeSelect.value === \'DEBIT_CARD\'\"></ng-bind-html></div><div class=\"point-to-note-tpv-approval ng-scope\" ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI !==\'OTM\'\"><!--dynamic content for OTM--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOtmFlexSip.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI === \'OTM\'\"><!--dynamic content for OTM FIRST INSTALLMENT--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOTMOTMFlexSip.content></ng-bind-html></div><div class=\"terms-condition form-group declaration\"><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=InitiateSummary.ischecked required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><hr><div class=\"terms-condition form-group\" ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\' && InitiateSummary.showTerms\"><span class=checkbox><input id=tcsCheckboxEMandate type=checkbox name=termsAndConditionsEMandate ng-model=InitiateSummary.termsAndConditionsEMandate required> <span class=icon-checkbox></span></span><label for=tcsCheckboxEMandate class=\"checkbox-text tnc\">I have read and understood <a href=javascript:void(0) ng-click=InitiateSummary.termsAndConditionsEMandateModal()>Terms &amp; Conditions</a> of e-mandate (eOTM)</label></div></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-if=!InitiateSummary.isActionPerformed><button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.rejectTransaction()>Reject</button> <button ng-if=\"InitiateSummary.selectedPaymentOption !=\'HEM\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.ecsBankModal.bankName\n              || ((InitiateSummary.selectedPaymentOption !==\'OTM\') && (!InitiateSummary.ecsBankModal.bankBranch || !InitiateSummary.ecsBankModal.bankCity))\n              ||  InitiateSummary.otmLimitValidation\n              ||  InitiateSummary.endDateValidation\n              || !InitiateSummary.ecsBankModal.bankAcNo || !InitiateSummary.ecsBankModal.verifyBankAcNo\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\n              ||  (InitiateSummary.summaryDetails.payMech === \'OTM\'\n                              && InitiateSummary.otmBankData.otmFrequency != \'AWP\'\n                  ) || (InitiateSummary.selectedPaymentOption ==\'OTM\' && !InitiateSummary.ecsBankModal.ifscCode) || !InitiateSummary.ecsBankModal.bankAcType || !InitiateSummary.ecsBankModal.ifscCode\n              || (InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiOtmBankData) || InitiateSummary.fiOtmBankForm.$invalid || (InitiateSummary.summaryDetails.sipWithFirstInstallment && InitiateSummary.EcsBankForm.$invalid) || InitiateSummary.fiEndDateValidation || InitiateSummary.fiOtmLimitValidation\">Approve Transaction</button> <button ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.bankdata || !InitiateSummary.authModeSelect\n              || !InitiateSummary.termaAndConditions || !InitiateSummary.termsAndConditionsEMandate || InitiateSummary.isEmandateMaxLimit < InitiateSummary.amount || InitiateSummary.amountLess || InitiateSummary.amountMore || InitiateSummary.isLessThanSipAmount || InitiateSummary.sipDateLessEmandate\">Approve Transaction</button></div></section></div><style>.terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.html","<div class=email-view ng-init=InitiateSummary.init()><div ng-if=InitiateSummary.summaryDetails data-ng-switch=InitiateSummary.summaryDetails.summaryType><div data-ng-switch-when=STP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.stp.html\'\"></div></div><div data-ng-switch-when=FLEXINDEX><div data-ng-include=\"\'app/transactions/initiate/summary/summary.flexindex.html\'\"></div></div><div data-ng-switch-when=STPFLEX><div data-ng-include=\"\'app/transactions/initiate/summary/summary.stp.html\'\"></div></div><div data-ng-switch-when=STPSWING><div data-ng-include=\"\'app/transactions/initiate/summary/summary.stp.html\'\"></div></div><div data-ng-switch-when=SIP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.sip.html\'\"></div></div><div data-ng-switch-when=SIP_TOPUP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.sip.html\'\"></div></div><div data-ng-switch-when=SWP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.swp.html\'\"></div></div><div data-ng-switch-when=SMART_SWAP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.smart-swap.html\'\"></div></div><div data-ng-switch-when=REDEMPTION><div data-ng-include=\"\'app/transactions/initiate/summary/summary.redeem.html\'\"></div></div><div data-ng-switch-when=SWITCH><div data-ng-include=\"\'app/transactions/initiate/summary/summary.switch.html\'\"></div></div><div data-ng-switch-when=PURCHASE><div data-ng-include=\"\'app/transactions/initiate/summary/summary.purchase.html\'\"></div></div><div data-ng-switch-when=DTP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.dtp.html\'\"></div></div><div data-ng-switch-when=ROLLOVER><div data-ng-include=\"\'app/transactions/initiate/summary/summary.rollover.html\'\"></div></div><div data-ng-switch-when=FAIL><div data-ng-include=\"\'app/transactions/initiate/summary/fail-transaction.html\'\"></div></div><div data-ng-switch-when=SYSTEMATIC-CANCEL><div data-ng-include=\"\'app/transactions/initiate/summary/summary.cancelTransaction.html\'\"></div></div><div data-ng-switch-when=SYSTEMATIC-PAUSE><div data-ng-include=\"\'app/transactions/initiate/summary/summary.sipPause.html\'\"></div></div><div data-ng-switch-when=NOMINEEADDUPDATE><div data-ng-include=\"\'app/transactions/initiate/summary/summary.addnominee.html\'\"></div></div><div data-ng-switch-when=NOMINEECANCELLATION><div data-ng-include=\"\'app/transactions/initiate/summary/summary.cancelnominee.html\'\"></div></div><div data-ng-switch-when=CHANGE_DIVIDEND_OPTION><div data-ng-include=\"\'app/transactions/initiate/summary/summary.changeDividend.html\'\"></div></div><div data-ng-switch-when=FLEX_SIP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.flexsip.html\'\"></div></div><div data-ng-switch-when=DREAMSIP><div data-ng-include=\"\'app/transactions/initiate/summary/summary.dreamSip.html\'\"></div></div><div data-ng-switch-when=changeOption><div data-ng-include=\"\'app/transactions/initiate/summary/summary.changeOption.html\'\"></div></div><div data-ng-switch-when=changeTargetScheme><div data-ng-include=\"\'app/transactions/initiate/summary/summary.changeTargetScheme.html\'\"></div></div><div data-ng-switch-when=NOMINEEOPTOUT><div data-ng-include=\"\'app/transactions/initiate/summary/summary.nomineeOtpOut.html\'\"></div></div></div></div>");
$templateCache.put("app/transactions/initiate/summary/summary.nomineeOtpOut.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><form autocomplete=off name=nomineeForm><section class=summary-sip><div class=content-header><h5>Opt-out of Nomination</h5></div><div class=content-body><div class=email-block><div class=folio-OptoutNominee style=\"margin-top: 10px; margin-bottom: 20px\"><p style=\"font-weight: bold\">{{InitiateSummary.optOutMessage}}</p></div><div class=belongs-to-container><table><tr><td><p><strong>Email ID :<span class=req>*</span></strong></p></td><td><p><strong easyassist-key=mask-element>{{InitiateSummary.NomineeEmail ? InitiateSummary.NomineeEmail : \'Not Available\'}}</strong></p></td></tr><tr><td><p style=\"margin-right: 15px\"><strong>Email Id Belongs To<span class=req>*</span></strong></p></td><td><div><select style=\"padding: 10px 10px 10px 5px !important\" class=\"browser-default custom-select\" name=emailBelongsTo ng-model=InitiateSummary.emailBelongsTo ng-init=\"InitiateSummary.emailBelongsTo = InitiateSummary.summaryDetails.emailBelongsTo ? InitiateSummary.summaryDetails.emailBelongsTo :null\" ng-options=\"email.familyCode as email.familyDescription for email in InitiateSummary.emaillList\" ng-disabled=!InitiateSummary.NomineeEmail required><option value=\"\" selected>Select Value</option></select></div><div><span class=error-input ng-show=\"nomineeForm.emailBelongsTo.$error.required && nomineeForm.emailBelongsTo.$dirty\" ng-bind=InitiateSummary.appConstants.EMAIL_BELONGS_ERROR></span></div></td></tr></table><table><tr><td><p><strong>Mobile No :<span class=req>*</span></strong></p></td><td><p><strong easyassist-key=mask-element>{{InitiateSummary.NomineeMobile ? InitiateSummary.NomineeMobile : \'Not Available\'}}</strong></p></td></tr><tr><td><p style=\"margin-right: 15px\"><strong>Mobile No. Belongs To<span class=req>*</span></strong></p></td><td><div><select style=\"padding: 10px 10px 10px 5px !important\" class=\"browser-default custom-select\" name=mobileBelongsTo ng-model=InitiateSummary.mobileBelongsTo ng-init=\"InitiateSummary.mobileBelongsTo = InitiateSummary.summaryDetails.mobileBelongsTo ? InitiateSummary.summaryDetails.mobileBelongsTo :null\" ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in InitiateSummary.mobileList\" ng-disabled=!InitiateSummary.NomineeMobile required><option value=\"\" selected>Select Value</option></select></div><div><span class=error-input ng-show=\"nomineeForm.mobileBelongsTo.$error.required && nomineeForm.mobileBelongsTo.$dirty\" ng-bind=InitiateSummary.appConstants.MOBILE_BELONGS_ERROR></span></div></td></tr></table></div><div class=main-container><div class=\"row note-wrapper\" style=\"margin-top: 40px\"><div class=\"col-md-12 mark-default opt-out-align\"><div class=checkbox style=\"padding-right: 10px\"><input disabled type=checkbox required ng-model=InitiateSummary.TnC required> <i class=icon-checkbox></i></div><div class=checkbox-text><span><ng-bind-html dynamic=InitiateSummary.nomineeDynamicData.content></ng-bind-html><!--I/We hereby confirm that I/We do not wish to appoint any nominee(s) for my mutual fund units held in my/our folio listed below and understand the issues involved in non appointment of nominee(s) and further am/are aware that in case of death of all the account holder(s), my/our legal heirs would need to submit all the requisite documents issued by Court or other such competent authority, based on the value of assets held in the mutual fund folio.--></span></div></div></div></div></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-show=!InitiateSummary.isActionPerformed><button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.rejectNominee()>Reject</button> <button type=submit ng-disabled=\"!InitiateSummary.NomineeEmail || !InitiateSummary.emailBelongsTo || !InitiateSummary.NomineeMobile || !InitiateSummary.mobileBelongsTo\" class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveNominee()>Approve Transaction</button></div></section></form></div>");
$templateCache.put("app/transactions/initiate/summary/summary.purchase.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-sip><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=content-body ng-if=!InitiateSummary.isFromEcart><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\') && !InitiateSummary.oversea_arn\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div></div><div class=\"content-body email-block\" ng-if=InitiateSummary.isFromEcart><div class=\"row ecart-details-container\"><div class=col-md-6><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr></table></div><div class=col-md-6><p class=email-block-header>Transaction Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType == \'MIX\'? \'SIP + PURCHASE\': InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr><tr><td>Total Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.distributorDetails.transactionType == \'MIX\'? InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.totalSum): InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.summaryDetails.totalAmount)}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr></table></div></div></div></section><section ng-if=\"(InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode) || (InitiateSummary.summaryDetails && InitiateSummary.summaryDetails.cartItems && (InitiateSummary.summaryDetails.cartItems[0].subBrokerArn || InitiateSummary.summaryDetails.cartItems[0].subBrokerCode))\"><div class=content-body><div class=email-block><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.cartItems[0].subBrokerArn\"><td>Sub Broker ARN:</td><td ng-if=InitiateSummary.summaryDetails.subBrokerArn>{{InitiateSummary.summaryDetails.subBrokerArn}}</td><td ng-if=InitiateSummary.summaryDetails.cartItems[0].subBrokerArn>{{InitiateSummary.summaryDetails.cartItems[0].subBrokerArn}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.subBrokerCode || InitiateSummary.summaryDetails.cartItems[0].subBrokerCode\"><td>Sub Broker Code:</td><td ng-if=InitiateSummary.summaryDetails.subBrokerCode>{{InitiateSummary.summaryDetails.subBrokerCode}}</td><td ng-if=InitiateSummary.summaryDetails.cartItems[0].subBrokerCode>{{InitiateSummary.summaryDetails.cartItems[0].subBrokerCode}}</td></tr></table></div></div></section><section><div class=content-body ng-if=!InitiateSummary.isFromEcart><div class=email-block><p class=email-block-header>Scheme Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.sipFrequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.sipDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP End Date:</td><td>{{InitiateSummary.summaryDetails.sipEndDate}}</td></tr></table></div></div><!--    <div class=\"content-body\" ng-if=\"InitiateSummary.isFromEcart\">--><!--      <div class=\"email-block\">--><!--        <p class=\"email-block-header\">Purchase Transaction Details</p>--><!--        <div class=\"row ecart-details-container many-cart-scroll\">--><!--          <div class=\"col-md-3 ecart-web-view\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Scheme:</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Transaction Amount:</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--          <div class=\"col-md-3\" ng-repeat=\"cartItem in InitiateSummary.summaryDetails.cartItems\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Scheme:</td>--><!--                <td>{{cartItem.schemeName}}</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Transaction Amount:</td>--><!--                <td>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(cartItem.amount)}} {{InitiateSummary.summaryDetails.amountUnit}}</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--></section><!--  Ecart SIP --><!--  <section ng-if=\"InitiateSummary.isFromEcart && InitiateSummary.summaryDetails.distributorDetails.transactionType == \'MIX\'\">--><!--    <div class=\"content-body\">--><!--      <div class=\"email-block\">--><!--        <p class=\"email-block-header\">SIP Transaction Details</p>--><!--        <div class=\"row ecart-details-container many-cart-scroll\">--><!--          <div class=\"col-md-3 ecart-web-view\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Scheme:</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Transaction Amount:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-table-head-web\">SIP Frequency:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipFrequency==\'Weekly\'\">--><!--                <td class=\"ecart-table-head-web\">SIP Day:</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">SIP Start Date:</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">SIP End Date:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-table-head-web\">SIP First Installment :</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-table-head-web\">SIP First Installment Amount :</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--          <div class=\"col-md-3\" ng-repeat=\"cartItem in InitiateSummary.summaryDetails.cartItems\" ng-if=\"cartItem.sipOpted\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Scheme:</td>--><!--                <td>{{cartItem.schemeName}}</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Transaction Amount:</td>--><!--                <td>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(cartItem.installmentAmount)}} {{InitiateSummary.summaryDetails.amountUnit}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-mobile\">SIP Frequency:</td>--><!--                <td>{{cartItem.sipFrequency}}</td>--><!--              </tr>--><!--              <tr ng-if=\"cartItem.sipFrequency==\'Weekly\'\">--><!--                <td class=\"ecart-mobile\">SIP Day:</td>--><!--                <td>{{cartItem.weeklyDay}}</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-mobile\">SIP Start Date:</td>--><!--                <td>{{cartItem.sipDate}}</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-mobile\">SIP End Date:</td>--><!--                <td>{{cartItem.toDate}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-mobile\">SIP First Installment :</td>--><!--                <td>{{InitiateSummary.summaryDetails.sipWithFirstInstallment  ? \'Yes\': \'No\'}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-mobile\">SIP First Installment Amount :</td>--><!--                <td ng-if=\"!InitiateSummary.summaryDetails.bulkTransactionFlag\">&#8377; {{InitiateSummary.summaryDetails.firstInstallmentDetails.amount?InitiateSummary.summaryDetails.firstInstallmentDetails.amount:InitiateSummary.summaryDetails.amount}}</td>--><!--                <td ng-if=\"InitiateSummary.summaryDetails.bulkTransactionFlag\">&#8377; {{InitiateSummary.summaryDetails.amount}}</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </section>--><section class=transaction-details-section><div class=transaction-details ng-if=InitiateSummary.isFromEcart><div class=transaction-details-heading><p><span ng-if=\"InitiateSummary.ecartTransactionType===\'MIX\'\">Transactions Details</span> <span ng-if=\"InitiateSummary.ecartTransactionType===\'PURCHASE\' && InitiateSummary.ecartTransactionType!==\'MIX\'\">Purchase Transaction Details</span></p></div><div class=transaction-details-container ng-repeat=\"cartItem in InitiateSummary.summaryDetails.cartItems\"><div><p>{{cartItem.schemeName}}</p><p ng-if=cartItem.sipOpted>SIP Tenure : <span>{{cartItem.sipDate}} - </span><span>{{cartItem.toDate}}</span></p></div><div><p ng-if=cartItem.sipOpted>SIP</p><p ng-if=cartItem.purchaseOpted>PURCHASE</p></div><div><p ng-if=cartItem.sipOpted>{{cartItem.installmentRupee}}</p><p ng-if=cartItem.purchaseOpted>{{cartItem.rupees}}</p></div></div><div class=transaction-details-amount-container><div><p>Total Amount</p><p ng-if=\"InitiateSummary.ecartTransactionType===\'MIX\'\">Pay now amount <span>(Purchase transaction only)</span></p></div><div><p>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.summaryDetails.totalAmount + InitiateSummary.summaryDetails.totalInstallmentAmount)}}</p><p ng-if=\"InitiateSummary.ecartTransactionType===\'MIX\'\">&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.summaryDetails.totalAmount)}}</p></div></div></div></section><section ng-if=InitiateSummary.summaryDetails.checkedNfoAutoSwitch><div class=content-body><div class=email-block><p class=email-block-header>Auto Switch Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Auto Switch On Maturity:</td><td>{{InitiateSummary.summaryDetails.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.autoSwitchScheme}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption!=\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div></div></section><section ng-if=InitiateSummary.summaryDetails.sipTopupEnabled><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupDetails.amount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.percentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.frequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupDetails.capMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\'\"><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupAmount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupPercentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupPercentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupFrequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupCapAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupCapMonthYear}}</td></tr></table></div></div></section><section><div class=content-body><div class=email-block><p class=email-block-header>Primary Bank Details</p><table class=\"table borderless\"><tr><td>Bank Name:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankName}}</td></tr><tr><td>Account Number:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcNo}}</td></tr><tr><td>Branch:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankBranch}}</td></tr><tr><td>IFSC Code:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.ifscCode}}</td></tr></table></div></div></section><!-- <retirement-fund-summary\n    holders=\"InitiateSummary.summaryDetails.holders\"\n    folionumber=\"InitiateSummary.summaryDetails.folioNumber\"\n    holdersform=\"InitiateSummary.holdersForm\"\n    ng-if=\"InitiateSummary.summaryDetails.holders.length>0\"\n  >\n  </retirement-fund-summary>--><!-- <section ng-if=\"InitiateSummary.summaryDetails.newFolio\">\n    <div class=\"content-body\">\n      <div class=\"email-block\">\n        <p class=\"email-block-header\">Upload Documents</p>\n\n        <p class=\"mrt red\">Document type : JPG or PNG only . Maximum file size : 1.5MB each</p>\n        <form autocomplete=\"off\" name=\"docUpload\" ng-submit=\"InitiateSummary.submitDoc()\" novalidate>\n          <table class=\"table borderless purchase-sip\">\n            <tr>\n              <td>Cheque Leaf :</td>\n              <td>\n                <input type=\"file\" name=\"chequeLeaf\" serial=\"1\" file-model-profile=\"InitiateSummary.doc.chequeLeaf\"\n                       upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img1}}</p>\n              </td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>DOB Proof :</td>\n              <td><input type=\"file\" name=\"minorProof\" serial=\"2\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                         accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.minorProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img2}}</p></td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>Guardian Proof :</td>\n              <td>\n                <input type=\"file\" name=\"guardianProof\" serial=\"3\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.guardianProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img3}}</p></td>\n            </tr>\n          </table>\n          <button ng-if=\"!InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 1\">Upload Files\n          </button>\n          <button ng-if=\"InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 3\">Upload Files\n          </button>\n        </form>\n      </div>\n    </div>\n  </section>\n\n--><section ng-if=\"InitiateSummary.summaryType==\'PURCHASE\'\"><div class=content-body><div ng-if=\"InitiateSummary.summaryDetails.paymentGatewayResponse.paymentStatus !== \'SUCCESS\'\"><div class=\"email-block purchase-panel\" ng-if=InitiateSummary.summaryDetails.sentToPaymentGateway><!--<p ng-if=\"!InitiateSummary.isDocSubmitted\" class=\"overlay\"></p>--><!--PG timeout--><p class=email-block-header ng-if=!InitiateSummary.summaryDetails.paymentGatewayResponse.received>This purchase transaction was already attempted by you on {{InitiateSummary.summaryDetails.paymentGatewayPostDateTime}}, but we have not yet received confirmation of same from your bank. Please confirm if:</p><!--PG failure response--><p class=email-block-header ng-if=\"InitiateSummary.summaryDetails.paymentGatewayResponse.received && InitiateSummary.summaryDetails.paymentGatewayResponse.paymentStatus === \'FAILURE\' \">We have received failure response from payment gateway for the above purchase transaction earlier attempted by you. Please confirm if:</p><div class=\"form-group text-left payment-options\"><span class=radio-block ng-repeat=\"sentoptions in InitiateSummary.sentToPaymentGatewayOptions\"><span class=radio><input type=radio id={{sentoptions.key}} name=sentToPaymentGatewayOption value={{sentoptions.key}} ng-model=InitiateSummary.sentToPaymentGatewayOption ng-change=InitiateSummary.sentToPaymentGatewayOptionChanged()><!--ng-disabled=\"options.key==\'VISA\' || options.key==\'MASTERCARD\'\"--><!--<input type=\"radio\" id=\"{{options.key}}\" name=\"paymentOption\" value=\"{{options.key}}\" ng-model=\"InitiateSummary.selectedPaymentOption\" ng-change=\"InitiateSummary.paymentOptionChanged()\"/>--> <span class=check></span></span><label for={{sentoptions.key}}>{{sentoptions.value}}</label></span></div><p class=alert-info ng-if=\"InitiateSummary.sentToPaymentGatewayOption == \'AMOUNT_DEDUCTED\'\">Since you have received a confirmation from the bank that your account has been debited, but you have not received any purchase confirmation from our end; kindly do not initiate payment again. Your purchase transaction shall be processed at the applicable NAV when we receive the credit from your bank.</p><p class=alert-info ng-if=\"InitiateSummary.sentToPaymentGatewayOption == \'AMOUNT_NOT_DEDUCTED\'\">Since you have confirmed that your bank account has NOT been debited, kindly initiate payment again as the previous payment attempt by you was unsuccessful.</p></div></div><div class=\"email-block purchase-panel\" ng-if=\"InitiateSummary.sentToPaymentGatewayOption==\'AMOUNT_NOT_DEDUCTED\' || InitiateSummary.showNotSentToPaymentGatewayButton\"><!--<p ng-if=\"!InitiateSummary.isDocSubmitted\" class=\"overlay\"></p>--><p class=email-block-header>Payment Options</p><!--<div class=\"debit-pay-unavailable\">\n          <p>\n            Debit Card Payment Option is Discontinued.\n          </p>\n        </div>--><div class=\"form-group text-left payment-options\"><span class=radio-block ng-repeat=\"options in InitiateSummary.paymentOptionsPurchase\" ng-class=\"{\'anything-disabled\': InitiateSummary.summaryDetails.payMech !== options.key && InitiateSummary.isFromEcart}\" ng-if=\"!(InitiateSummary.summaryDetails.minorFolioFlag && !InitiateSummary.summaryDetails.cgfFlag && (options.value ==\'NEFT/RTGS\' || options.value==\'HDFC Bank\\\'s Fund Transfer\'))\" ng-class=\"{\'anything-disabled\': options.key===\'OTM\'&& InitiateSummary.isOTMdisabled}\"><span class=radio><input type=radio id={{options.key}} name=paymentOption value={{options.key}} ng-model=InitiateSummary.selectedPaymentOption ng-change=InitiateSummary.paymentOptionChanged() ng-disabled=\"options.key==\'VISA\' || options.key==\'MASTERCARD\'\n                         ||(options.key===\'OTM\'&& InitiateSummary.isOTMdisabled)\"><!--ng-disabled=\"options.key==\'VISA\' || options.key==\'MASTERCARD\'\"--><!--<input type=\"radio\" id=\"{{options.key}}\" name=\"paymentOption\" value=\"{{options.key}}\" ng-model=\"InitiateSummary.selectedPaymentOption\" ng-change=\"InitiateSummary.paymentOptionChanged()\"/>--> <span class=check></span></span><label for={{options.key}}>{{options.value}}</label></span></div>{{InitiateSummary.selectedPaymentOption.key}}<!--<p class=\"red desclaimer payment_notification\" ng-if=\"InitiateSummary.selectedPaymentOption == \'WEB\'\">\n            Payment is allowed only from the banks registered against the folio.\n        </p>--><!--dynamic content for net banking--><ng-bind-html ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType !== \'MIX\'\" dynamic=InitiateSummary.dynamicNoteNetBanking.content></ng-bind-html><ng-bind-html ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType == \'MIX\'\" dynamic=InitiateSummary.dynamicNoteMixNetBanking.content></ng-bind-html><!--dynamic content for rtgs note--><div class=point-to-note-tpv-approval ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\' && InitiateSummary.dynamicNoteNeft\"><!--dynamic content for RTGS--><ng-bind-html dynamic=InitiateSummary.dynamicNoteNeft.content></ng-bind-html></div><!--dynamic content for hdfc note--><div class=point-to-note-tpv-approval ng-if=\"InitiateSummary.selectedPaymentOption==\'HDFC\' && InitiateSummary.dynamicNoteHdfc\"><!--dynamic content for net banking--><ng-bind-html dynamic=InitiateSummary.dynamicNoteHdfc.content></ng-bind-html></div><!--dynamic content for otm note--><div class=point-to-note-tpv-approval ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.summaryDetails.distributorDetails.transactionType !== \'MIX\'\"><!--dynamic content for otm note--><ng-bind-html dynamic=InitiateSummary.dynamicNoteMixOTM.content></ng-bind-html></div><!--Dynamic content for mix otm--><div class=point-to-note-tpv-approval ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.dynamicNoteOtm && InitiateSummary.summaryDetails.distributorDetails.transactionType == \'MIX\'\"><!--dynamic content for otm note--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOtm.content></ng-bind-html></div><!--dynamic content for upi note--><div class=point-to-note-tpv-approval ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\' && InitiateSummary.dynamicNoteUpi\"><!--dynamic content for net banking--><ng-bind-html dynamic=InitiateSummary.dynamicNoteUpi.content></ng-bind-html></div><p class=\"red desclaimer payment_notification\" ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\' && InitiateSummary.dynamicNoteNeft\">The mode of payment is applicable only to those investors who have already transferred the subscription amount into our designated scheme account and now wish to submit the transaction online. HDFC AMC will not be responsible for any transfer of money done into a wrong account by the investor. Allotment of NAV is subject to realization of subscription amount into the designated scheme collection account number 00600350109922, Account Name: HDFC Mutual Fund RTGS A/c, RTGS Code HDFC0000060.</p><p ng-if=\"InitiateSummary.selectedPaymentOption==\'WEB\' || InitiateSummary.selectedPaymentOption==\'VISA\' || InitiateSummary.selectedPaymentOption==\'MASTERDEBITCARD\' ||\n           InitiateSummary.selectedPaymentOption==\'UPI\'\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'WEB\' || InitiateSummary.selectedPaymentOption==\'VISADEBITCARD\' || InitiateSummary.selectedPaymentOption==\'MASTERDEBITCARD\' ||\n            InitiateSummary.selectedPaymentOption==\'UPI\'\"><div class=col-md-3><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=InitiateSummary.checkMinorBankFlag()><option value=\"\" selected>Select Bank</option><!--<option ng-repeat=\"bank in InitiateSummary.bankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select></div></div><div class=col-md-8><form class=row autocomplete=off name=purchaseBankForm novalidate style=\"margin-top: 0px\"><div class=\"col-md-4 mob-res\" ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.ifscCode\" style=\"margin-top: 8px\"><div class=input-normal ng-class=\"{error:(purchaseBankForm.ifscCode.$dirty && purchaseBankForm.ifscCode.$invalid)}\"><input type=text name=ifscCode ng-model=InitiateSummary.purchaseBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span class=req>*</span></label><span ng-show=\"purchaseBankForm.ifscCode.$dirty && purchaseBankForm.ifscCode.$invalid\"><span class=error-input ng-show=purchaseBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=purchaseBankForm.ifscCode.$dirty&&purchaseBankForm.ifscCode.$error.pattern ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:purchaseBankForm.accountType.$dirty && purchaseBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.purchaseBankModal.purchasebankAcType ng-options=\"bank as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.purchaseBankModal.purchasebankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=purchaseBankForm.accountType.$error ng-show=purchaseBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></form></div><div class=col-md-3 ng-show=\"InitiateSummary.selectedPaymentOption ==\'UPI\' && InitiateSummary.bankdata\"><form autocomplete=off name=InitiateSummary.vaForm.purchaseBankForm novalidate style=\"margin-top: 8px\"><div class=\"row ng-scope\"><div class=col-md-12 ng-class=\"{\'mob-res\':InitiateSummary.bankdata.ifscCode}\"><div class=input-normal ng-class=\"{error:InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$dirty && InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$invalid}\"><input type=text name=virtualAddress ng-model=InitiateSummary.virtualAddress ng-pattern=InitiateSummary.appConstants.upi_virtual_addr_regex ng-change=InitiateSummary.virtualAddressChange() ng-readonly=\"InitiateSummary.isUPIVerified && InitiateSummary.verifyUPIResp.valid === true\" required> <span class=highlight></span> <span class=bar></span><label style=\"display: block;width: 100%\">Virtual Payment Address <span class=req>*</span> <i class=edit2-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"InitiateSummary.isUPIVerified && InitiateSummary.verifyUPIResp.valid === true\" ng-click=InitiateSummary.resetUpiForm()></i></label><span ng-show=\"InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$dirty && InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$invalid\"><span class=error-input ng-show=\"(InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$dirty) && (InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$error.required || InitiateSummary.vaForm.purchaseBankForm.virtualAddress.$error.pattern)\" ng-bind=InitiateSummary.validateData.VIRTUAL_ADDRESS_REQUIRED></span></span></div></div></div></form></div><div class=col-md-3 ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\' && !InitiateSummary.isUPIVerified && InitiateSummary.bankdata\"><div class=row><div class=col-md-12><button blur-on-click ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\' && !InitiateSummary.isUPIVerified\" class=\"btn btn-primary-action verify-btn\" ng-disabled=\"!InitiateSummary.virtualAddress || InitiateSummary.hideValidateMinor\" ng-click=InitiateSummary.verifyPaymentAddress()>Verify</button></div></div></div><div class=col-md-3 ng-if=\"InitiateSummary.isUPIVerified && InitiateSummary.bankdata && InitiateSummary.selectedPaymentOption == \'UPI\'\"><div class=row><div class=\"col-md-12 verify-vpa\"><p><strong>Verified</strong> <i class=verified-small-icon></i></p><span>Name: {{InitiateSummary.name}}</span></div></div></div><div class=col-md-12><p class=\"red desclaimer payment_notification\" ng-if=\"InitiateSummary.bankdata.tpvEnableFlag==\'N\'\" style=\"margin-top: 0px; margin-left: 0px\">Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br>Please select other payment mode or add a TPV enabled bank in your folio. <a ng-click=InitiateSummary.tpvModalOpen() href=javaScript:void(0)>Click here</a> to view the TPV enabled banks.</p><div class=\"red declaration\" style=\"margin-top: 15px\" ng-if=!InitiateSummary.bankList||!InitiateSummary.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank</span></div></div><div class=\"terms-condition form-group declaration\"><h6>Declaration :</h6><span class=checkbox><input id=declaration-top type=checkbox name=declartaiontop ng-model=InitiateSummary.ischecked> <span class=icon-checkbox></span></span><label for=declaration-top class=\"checkbox-text tnc\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div></div><div class=\"form-group text-left payment-options\" ng-if=\"InitiateSummary.selectedPaymentOption === \'DebitCreditCard\'\"><span class=radio-block><span class=radio><input type=radio id=visa name=cardOption value=visa ng-model=InitiateSummary.selectedCardType ng-change=InitiateSummary.cardTypeChanged() ng-disabled=\"options.key==\'VISA\' || options.key==\'MASTERCARD\'\"> <span class=check></span></span><label for=visa>Visa/ Master</label></span><span class=radio-block><span class=radio><input type=radio id=maestro name=cardOption value=maestro ng-model=InitiateSummary.selectedCardType ng-change=InitiateSummary.cardTypeChanged()> <span class=check></span></span><label for=maestro>Maestro</label></span></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'DebitCreditCard\'\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.cardBankList\" ng-model=InitiateSummary.cardBankData ng-change=InitiateSummary.changedCardBank()><option value=\"\" selected>Select Bank</option></select></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\'\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\'\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.otmBankData ng-change=InitiateSummary.changedOtmBank()><option value=\"\" selected>Select OTM Bank - Account Number</option><!--<option ng-repeat=\"bank in InitiateSummary.otmBankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select><span class=error-message style=\"margin: 8px 0 0 -18px\" ng-show=InitiateSummary.otmLimitValidation>Transaction amount is greater than the OTM Limit set. </span><span ng-show=InitiateSummary.startDateValidationPurchase><span class=error-input>Cannot initiate payment using selected OTM. You can initiate payment for purchase transaction on or after OTM start date which is, {{InitiateSummary.otmBankData.omStartDate}}</span></span></div></div><div ng-form=otmIfscAccount><div style=margin-top:5px class=\"col-md-4 col-md-offset-1\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:otmIfscAccount.accountType.$dirty && otmIfscAccount.accountType.$invalid}\" style=\"margin-top: 8px\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.purchaseBankModal.purchasebankAcType ng-options=\"bank as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.purchaseBankModal.purchasebankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=otmIfscAccount.accountType.$error ng-show=otmIfscAccount.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div><form autocomplete=off name=purchaseBankForm ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\'\" novalidate><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\'\"><div class=col-md-12><div class=row><div class=\"col-md-6 toogle-action-col\"><p><strong>{{InitiateSummary.appConstants.RTGS_MESSAGE}}</strong></p><ul class=togglePanel><li><span class=toggle-text ng-class=\"{\'bold-text\' : InitiateSummary.isNewPayment}\">Yes</span></li><li class=align-toggle><div class=login-form-switch><label class=switch-toggle-slider><input type=checkbox ng-model=InitiateSummary.isNewPayment ng-change=InitiateSummary.changeRtgsPayment() class=\"box checkbox-slide\" title=\"High Contrast\"> <span class=\"slider round\"></span></label></div></li><li><span class=toggle-login-text ng-class=\"{\'bold-text\' : !InitiateSummary.isNewPayment}\">No</span></li></ul></div></div><div class=row ng-if=InitiateSummary.isNewPayment><div class=col-md-4><p><strong>Select bank for making Payment</strong></p><div class=row><div class=col-md-12><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=InitiateSummary.checkMinorBankFlag()><option value=\"\" selected>Select Bank</option><!--<option ng-repeat=\"bank in InitiateSummary.bankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select></div></div><!-- <p class=\"red desclaimer payment_notification\" ng-if=\"InitiateSummary.bankdata.tpvEnableFlag==\'N\'\">\n                    Payment through selected bank is not allowed, since it does not provide Third Party Verification (TPV) facility.<br/>\n                    Please select other payment mode or add a TPV enabled bank in your folio. <a\n                    ng-click=\"InitiateSummary.tpvModalOpen()\" href=\"javaScript:void(0)\">Click here</a> to view the TPV enabled banks.\n                  </p> --><div class=\"red declaration\" style=\"margin-top: 15px\" ng-if=!InitiateSummary.bankList||!InitiateSummary.bankList.length><span>In case your registered bank is not displayed, please choose other payment mode or add another bank</span></div></div></div></div></div></div></form><form autocomplete=off name=InitiateSummary.purchaseBankForm ng-if=\"InitiateSummary.showBankFiels && InitiateSummary.selectedPaymentOption !== \'UPI\'\" novalidate><div class=form-content><div class=bank-detail><p ng-show=\"((InitiateSummary.selectedPaymentOption==\'RTGS\' || InitiateSummary.selectedPaymentOption==\'HDFC\' || InitiateSummary.selectedPaymentOption == \'OTM\') && !InitiateSummary.isNewPayment) || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><strong>Bank Details</strong></p><br><div class=row ng-show=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.bankName.$dirty && InitiateSummary.purchaseBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.purchaseBankModal.bankName ng-readonly=\"InitiateSummary.ecsReadOnly || InitiateSummary.isNewPayment\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.bankName.$dirty && InitiateSummary.purchaseBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row ng-show=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4><div class=\"input-normal branch-loc\" ng-class=\"{error:( InitiateSummary.selectedPaymentOption !== \'OTM\' && InitiateSummary.purchaseBankForm.bankBranch.$dirty && InitiateSummary.purchaseBankForm.bankBranch.$invalid)}\"><input type=text name=bankBranch ng-model=InitiateSummary.purchaseBankModal.bankBranch ng-readonly=\"InitiateSummary.ecsReadOnly || InitiateSummary.isNewPayment\" ng-required=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.selectedPaymentOption != \'OTM\' && InitiateSummary.purchaseBankForm.bankBranch.$dirty && InitiateSummary.purchaseBankForm.bankBranch.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.bankBranch.$error.required ng-bind=InitiateSummary.validateData.BANK_BRANCH_REQUIRED></span></span></div></div></div><div class=row ng-show=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.bankAcNo.$dirty && InitiateSummary.purchaseBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-if=InitiateSummary.isNewPayment ng-model=InitiateSummary.purchaseBankModal.bankAcNo ng-readonly=\"InitiateSummary.ecsReadOnly || InitiateSummary.isNewPayment\" onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <input type=password name=bankAcNo minlength=9 ng-if=!InitiateSummary.isNewPayment ng-model=InitiateSummary.purchaseBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.bankAcNo.$dirty && InitiateSummary.purchaseBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.purchaseBankForm.bankAcNo.$error.minlength || !InitiateSummary.purchaseBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-4 col-md-offset-1\" ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\' && !InitiateSummary.isNewPayment\"><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.verifyBankAcNo.$invalid && InitiateSummary.purchaseBankForm.verifyBankAcNo.$dirty}\"><input type=text ng-keydown=InitiateSummary.copyPasteHandler($event) name=verifyBankAcNo ng-minlength=9 required ng-model=InitiateSummary.purchaseBankModal.verifyBankAcNo ng-pattern=InitiateSummary.purchaseBankModal.bankAcNo onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57)\"> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.verifyBankAcNo.$dirty && InitiateSummary.purchaseBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyBankAcNo.$error.required>{{ InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyBankAcNo.$error.pattern>{{ InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE }}</span></span></div></div></div><div class=row ng-show=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4><div class=input-normal ng-class=\"{error:(InitiateSummary.selectedPaymentOption !=\'OTM\' && InitiateSummary.purchaseBankForm.ifscCode.$dirty && InitiateSummary.purchaseBankForm.ifscCode.$invalid)}\"><input type=text name=ifscCode ng-model=InitiateSummary.purchaseBankModal.ifscCode ng-readonly=\"InitiateSummary.isIFSCReadonly || (InitiateSummary.isNewPayment && InitiateSummary.purchaseBankModal && InitiateSummary.purchaseBankModal.ifscCode)\" ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off ng-required=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span class=error-input ng-show=\"InitiateSummary.purchaseBankForm.ifscCode.$dirty && InitiateSummary.purchaseBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span> <span ng-show=\"InitiateSummary.selectedPaymentOption !=\'OTM\' && InitiateSummary.purchaseBankForm.ifscCode.$dirty && InitiateSummary.purchaseBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.purchaseBankForm.ifscCode.$dirty && InitiateSummary.purchaseBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span> </span><span class=error-input ng-show=\"purchaseBankForm.ifscCode.$dirty && purchaseBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-4 col-md-offset-1\" style=\"margin-top: -8px\" ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\' || InitiateSummary.selectedPaymentOption==\'HDFC\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.purchaseBankForm.accountType.$dirty && InitiateSummary.purchaseBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.purchaseBankModal.purchasebankAcType ng-options=\"bank as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-disabled=\"InitiateSummary.isNewPayment && InitiateSummary.isAccFieldFilled\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.purchaseBankModal.purchasebankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.purchaseBankForm.accountType.$error ng-show=InitiateSummary.purchaseBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\'\"><div class=row ng-if=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && InitiateSummary.isNewPayment\"><div class=col-md-4><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.purchaseBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && InitiateSummary.isNewPayment\"><div class=col-md-4><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.purchaseBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && InitiateSummary.isNewPayment\"><div class=col-md-4><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.purchaseBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption!=\'VISA\' && InitiateSummary.selectedPaymentOption!=\'MASTERCARD\' && InitiateSummary.isNewPayment\"><div class=col-md-4><div class=input-normal><input type=text name=omStartDateForFi ng-model=InitiateSummary.otmBankData.omStartDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Start Date</label></div></div></div></div><div class=row ng-if=\"(InitiateSummary.selectedPaymentOption==\'HDFC\') && !InitiateSummary.isNewPayment  || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4 ng-if=\"InitiateSummary.selectedPaymentOption!=\'RTGS\'\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.purchaseBankForm.utr.$dirty && InitiateSummary.purchaseBankForm.utr.$invalid}\"><input type=text name=utr ng-model=InitiateSummary.purchaseBankModal.utr autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Reference Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.utr.$dirty && InitiateSummary.purchaseBankForm.utr.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.utr.$error.required>{{ InitiateSummary.validateData.BANK_REFERENCE_NUMBER_REQUIRED }}</span></span></div></div><div class=\"col-md-4 col-md-offset-1\" ng-if=\"InitiateSummary.selectedPaymentOption!=\'RTGS\'\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.purchaseBankForm.verifyUtr.$dirty && InitiateSummary.purchaseBankForm.verifyUtr.$invalid}\"><input type=text name=verifyUtr ng-model=InitiateSummary.purchaseBankModal.verifyUtr ng-pattern=InitiateSummary.purchaseBankModal.utr autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Confirm Bank reference Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.verifyUtr.$dirty && InitiateSummary.purchaseBankForm.verifyUtr.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyUtr.$error.required>{{ InitiateSummary.validateData.BANK_REFERENCE_NUMBER_REQUIRED }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyUtr.$error.pattern>{{ InitiateSummary.validateData.BANK_REFERENCE_NUMBER_SAME }}</span></span></div></div></div><div class=row ng-if=\" InitiateSummary.selectedPaymentOption !=\'OTM\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=\"col-md-4 upload-some smartLink-upload\" ng-if=\"InitiateSummary.selectedPaymentOption !=\'RTGS\'\"><span class=leaf-label>Upload Bank Statement <i class=\"tooltip-info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title={{InitiateSummary.appConstants.Bank_Statement}}></i> <span class=\"req text-red\">*</span> </span><!-- <div class=\"upload-leaf\" ng-if=\"InitiateSummary.selectedPaymentOption ==\'RTGS\'\">\n                      <input id=\"uploadCheckLeaf\" type=\"file\" name=\"pic\" accept=\"image/*, application/*\" file-model-profile=\"chequeLeaf\"\n                             upload=\"InitiateSummary.bankUploadChequeLeafFile(file)\" ng-model=\"InitiateSummary.purchaseBankModal.chequeLeaf\" required>\n                      <div style=\"display: flex; align-items: center\">\n                        <div class=\"file-upload\">\n                          <button>Choose File</button>\n                        </div>\n                        <div class=\"file-upload\">\n                          <span ng-if=\"InitiateSummary.chooseAFile\">No File Chosen</span>\n                          <span ng-if=\"InitiateSummary.fileType === \'tif\' || InitiateSummary.fileType === \'tiff\' || InitiateSummary.fileType === \'pdf\' \"><a href=\"javascript:void(0)\" ng-click=\"InitiateSummary.downloadPdfFile(InitiateSummary.bankchequeLeafUrl,InitiateSummary.fileType)\">Download</a></span>\n                          <span ng-if=\"InitiateSummary.fileType == \'jpg\' ||  InitiateSummary.fileType == \'jpeg\' \" ng-click=\"InitiateSummary.openUploadedDoc(InitiateSummary.purchaseBankModal.chequeLeaf)\">{{InitiateSummary.bankChequeLeaf}}</span>\n                        </div>\n                      </div>\n                    </div> --><div class=upload-leaf ng-if=\"InitiateSummary.selectedPaymentOption ==\'HDFC\'\"><input id=uploadCheckLeaf1 type=file name=pic1 accept=\"image/*, application/*\" file-model-profile=chequeLeaf upload=InitiateSummary.bankUploadChequeLeafFile(file) ng-model=InitiateSummary.purchaseBankModal.chequeLeaf required><div style=\"display: flex; align-items: center\"><div class=file-upload><button>Choose File</button></div><div class=file-upload><span ng-if=InitiateSummary.chooseAFile>No File Chosen</span> <span ng-if=\"InitiateSummary.fileType === \'tif\' || InitiateSummary.fileType === \'tiff\' || InitiateSummary.fileType === \'pdf\' \"><a href=javascript:void(0) ng-click=InitiateSummary.downloadPdfFile(InitiateSummary.bankchequeLeafUrl,InitiateSummary.fileType)>Download</a></span> <span ng-if=\"InitiateSummary.fileType == \'jpg\' ||  InitiateSummary.fileType == \'jpeg\'\" ng-click=InitiateSummary.openUploadedDoc(InitiateSummary.purchaseBankModal.chequeLeaf)>{{InitiateSummary.bankChequeLeaf}}</span></div></div></div><div style=\"font-size: 0.875em;color: #103880;padding: 10px 0\">{{InitiateSummary.fileName}}</div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'RTGS\' && !InitiateSummary.isNewPayment || (InitiateSummary.isNewPayment && InitiateSummary.bankdata)\"><div class=col-md-4><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.purchaseBankForm.utr.$dirty && InitiateSummary.purchaseBankForm.utr.$invalid}\"><input type=text name=utr ng-model=InitiateSummary.purchaseBankModal.utr autocomplete=off required capitalize ng-maxlength=255> <span class=highlight></span> <span class=bar></span><label>UTR Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.utr.$dirty && InitiateSummary.purchaseBankForm.utr.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.utr.$error.required>{{ InitiateSummary.validateData.UTR_REQUIRED }}</span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.purchaseBankForm.verifyUtr.$dirty && InitiateSummary.purchaseBankForm.verifyUtr.$invalid}\"><input type=text name=verifyUtr ng-model=InitiateSummary.purchaseBankModal.verifyUtr ng-pattern=InitiateSummary.purchaseBankModal.utr autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Confirm UTR Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.verifyUtr.$dirty && InitiateSummary.purchaseBankForm.verifyUtr.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyUtr.$error.required>{{ InitiateSummary.validateData.UTR_REQUIRED }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.verifyUtr.$error.pattern>{{ InitiateSummary.validateData.SAME_UTR_REQUIRED }}</span></span></div></div></div><div class=\"row form-grid\" ng-if=\"InitiateSummary.selectedPaymentOption==\'VISA\' || InitiateSummary.selectedPaymentOption==\'MASTERCARD\'\"><div class=col-md-3><div class=selectfield ng-class=\"{error:InitiateSummary.purchaseBankForm.bankName.$dirty && InitiateSummary.purchaseBankForm.bankName.$invalid}\"><label>Select Bank</label><select class=custom-select name=bankName ng-model=InitiateSummary.cardDetails.bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" required><option value=\"\" selected>Select Bank</option></select><span ng-show=\"InitiateSummary.purchaseBankForm.bankName.$dirty && InitiateSummary.purchaseBankForm.bankName.$invalid\"><span class=\"error-message select-error\" ng-show=InitiateSummary.purchaseBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'VISA\'\"><div class=col-md-4><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.cardNumberVisa.$dirty && InitiateSummary.purchaseBankForm.cardNumberVisa.$invalid}\"><input type=number ignore-mouse-wheel name=cardNumberVisa ng-model=InitiateSummary.cardDetails.cardNumberVisa ng-pattern=InitiateSummary.appConstants.visa_regex ng-readonly=\"InitiateSummary.ecsReadOnly \" maxlength=16 required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Card Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.cardNumberVisa.$dirty && InitiateSummary.purchaseBankForm.cardNumberVisa.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberVisa.$error.required ng-bind=InitiateSummary.validateData.CARD_NUMBER_REQUIRED></span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberVisa.$error.pattern>{{ InitiateSummary.validateData.VISA_FIELD }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberVisa.$error.maxlength>{{ InitiateSummary.validateData.VISA_FIELD }}</span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'MASTERCARD\'\"><div class=col-md-4><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.cardNumberMaster.$dirty && InitiateSummary.purchaseBankForm.cardNumberMaster.$invalid}\"><input type=number ignore-mouse-wheel name=cardNumberMaster ng-model=InitiateSummary.cardDetails.cardNumberMaster ng-pattern=InitiateSummary.appConstants.master_regex ng-readonly=InitiateSummary.ecsReadOnly maxlength=16 required autocomplete=off> <span class=highlight></span> <span class=bar></span><label>Card Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.cardNumberMaster.$dirty && InitiateSummary.purchaseBankForm.cardNumberMaster.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberMaster.$error.required ng-bind=InitiateSummary.validateData.CARD_NUMBER_REQUIRED></span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberMaster.$error.pattern>{{ InitiateSummary.validateData.MASTER_FIELD }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardNumberMaster.$error.maxlength>{{ InitiateSummary.validateData.MASTER_FIELD }}</span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'VISA\' || InitiateSummary.selectedPaymentOption==\'MASTERCARD\'\"><div class=col-md-4><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.cardHolderName.$dirty && InitiateSummary.purchaseBankForm.cardHolderName.$invalid}\"><input type=text name=cardHolderName ng-model=InitiateSummary.cardDetails.cardHolderName ng-readonly=InitiateSummary.ecsReadOnly required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Card Holder\'s Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.cardHolderName.$dirty && InitiateSummary.purchaseBankForm.cardHolderName.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.cardHolderName.$error.required ng-bind=InitiateSummary.validateData.CARD_HOLDERS_NAME_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'VISA\' || InitiateSummary.selectedPaymentOption==\'MASTERCARD\'\"><div class=col-md-2><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.cardExpiryMonth.$dirty && InitiateSummary.purchaseBankForm.cardExpiryMonth.$invalid}\"><div class=selectfield><select class=custom-select name=cardExpiryMonth ng-model=InitiateSummary.cardDetails.cardExpiryMonth ng-options=\"_expirymonth.key as _expirymonth.value for _expirymonth in InitiateSummary.CARD_EXPIRY_MONTH\" required><option value=\"\" selected>Card Expiry Month</option></select></div><span ng-show=\"InitiateSummary.purchaseBankForm.cardExpiryMonth.$dirty && InitiateSummary.purchaseBankForm.cardExpiryMonth.$invalid\"><span class=\"error-message select-error\" ng-show=InitiateSummary.purchaseBankForm.cardExpiryMonth.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=col-md-2><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.cardExpiryYear.$dirty && InitiateSummary.purchaseBankForm.cardExpiryYear.$invalid}\"><div class=selectfield><select class=custom-select name=cardExpiryYear ng-model=InitiateSummary.cardDetails.cardExpiryYear ng-options=\"_expiryyear.key as _expiryyear.value for _expiryyear in InitiateSummary.CARD_EXPIRY_YEAR\" required><option value=\"\" selected>Card Expiry Year</option></select></div><span ng-show=\"InitiateSummary.purchaseBankForm.cardExpiryYear.$dirty && InitiateSummary.purchaseBankForm.cardExpiryYear.$invalid\"><span class=\"error-message select-error\" ng-show=InitiateSummary.purchaseBankForm.cardExpiryYear.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'VISA\' || InitiateSummary.selectedPaymentOption==\'MASTERCARD\'\"><div class=col-md-2><div class=input-normal ng-class=\"{error:InitiateSummary.purchaseBankForm.CVV.$dirty && InitiateSummary.purchaseBankForm.CVV.$invalid}\"><input type=number ignore-mouse-wheel name=CVV ng-model=InitiateSummary.cardDetails.CVV ng-readonly=InitiateSummary.ecsReadOnly required autocomplete=off minlength=3 maxlength=4> <span class=highlight></span> <span class=bar></span><label>CVV Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.purchaseBankForm.CVV.$dirty && InitiateSummary.purchaseBankForm.CVV.$invalid\"><span class=error-input ng-show=InitiateSummary.purchaseBankForm.CVV.$error.required ng-bind=InitiateSummary.validateData.CVV_REQUIRED></span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.CVV.$error.minlength>{{ InitiateSummary.validateData.CVV_FIELD }}</span> <span class=error-input ng-show=InitiateSummary.purchaseBankForm.CVV.$error.maxlength>{{ InitiateSummary.validateData.CVV_FIELD }}</span></span></div></div></div></div></div><div class=\"terms-condition form-group\"><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=InitiateSummary.ischecked required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div></form><div class=form-group><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><hr><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{InitiateSummary.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=InitiateSummary.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=InitiateSummary.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=InitiateSummary.billdeskPayload.msg></form><!--<form autocomplete=\"off\" name=\'billdeskPayFormDebitOnly\' id=\"billdeskPayFormDebitOnly\" method=\'POST\'\n              action=\'https://www.billdesk.com/pgidsk/PGICommonGateway\'>\n          <input type=\"hidden\" name=\"msg\" class=\"msg\" ng-value=\"InitiateSummary.billDeskpayload\" id=\"msgDebitOnly\"/>\n          <input id=\"hidRequestIdDebitOnly\" type=\'hidden\' name=\'hidRequestId\' value=\"PGIME1000\"/>\n          <input id=\"hidOperationDebitOnly\" type=\'hidden\' name=\'hidOperation\' value=\"ME100\"/>\n        </form>--></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date: \'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-if=\"InitiateSummary.summaryType==\'PURCHASE\' && !InitiateSummary.isActionPerformed\"><button type=button ng-if=\"InitiateSummary.showNotSentToPaymentGatewayButton || (InitiateSummary.summaryDetails.sentToPaymentGateway && InitiateSummary.showAmountNotDeductedButton)\" class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-if=\"InitiateSummary.showNotSentToPaymentGatewayButton || (InitiateSummary.summaryDetails.sentToPaymentGateway && InitiateSummary.showAmountNotDeductedButton)\" ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction()>Reject</button> <button type=submit ng-if=\"InitiateSummary.showNotSentToPaymentGatewayButton || !InitiateSummary.summaryDetails.sentToPaymentGateway\" class=\"btn btn-primary-action\" ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions ||\n      ((InitiateSummary.selectedPaymentOption==\'WEB\' && !InitiateSummary.bankdata) || (InitiateSummary.selectedPaymentOption == \'WEB\' && InitiateSummary.bankdata && InitiateSummary.bankdata.tpvEnableFlag == \'N\') || InitiateSummary.selectedPaymentOption==\'VISADEBITCARD\' || InitiateSummary.selectedPaymentOption==\'MASTERDEBITCARD\'|| (InitiateSummary.selectedPaymentOption==\'DebitCreditCard\'&& !InitiateSummary.cardBankData))\n      || ((InitiateSummary.selectedPaymentOption==\'OTM\') && (InitiateSummary.otmLimitValidation || !InitiateSummary.purchaseBankModal.bankName || !InitiateSummary.purchaseBankModal.bankAcNo || InitiateSummary.startDateValidationPurchase)) || (InitiateSummary.selectedPaymentOption==\'OTM\' && (!InitiateSummary.otmBankData.ifscCode && !InitiateSummary.purchaseBankModal.ifscCode)) || (InitiateSummary.selectedPaymentOption==\'OTM\' && (!InitiateSummary.otmBankData.bankAcType && !InitiateSummary.purchaseBankModal.purchasebankAcType))\n      || (InitiateSummary.purchaseBankForm.$invalid) || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj || (InitiateSummary.selectedPaymentOption == \'WEB\' && InitiateSummary.bankdata && !InitiateSummary.bankdata.ifscCode)&&(!InitiateSummary.purchaseBankModal.ifscCode )) || (InitiateSummary.selectedPaymentOption == \'WEB\' && InitiateSummary.bankdata && !InitiateSummary.bankdata.bankAcType) && (!InitiateSummary.purchaseBankModal.purchasebankAcType) )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && InitiateSummary.bankdata.tpvEnableFlag==\'N\' )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && InitiateSummary.bankdata == null )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && !InitiateSummary.isUPIVerified )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && (!InitiateSummary.bankdata.bankAcType && !InitiateSummary.purchaseBankModal.purchasebankAcType)) ||(InitiateSummary.selectedPaymentOption == \'UPI\' && (!InitiateSummary.bankdata.ifscCode && !InitiateSummary.purchaseBankModal.ifscCode))\n      || (InitiateSummary.selectedPaymentOption==\'RTGS\' && InitiateSummary.isNewPayment && !InitiateSummary.bankdata)\n      || (InitiateSummary.selectedPaymentOption== \'RTGS\' && !InitiateSummary.isNewPayment && InitiateSummary.purchaseBankForm.$invalid)\n      || (InitiateSummary.selectedPaymentOption== \'HDFC\' && InitiateSummary.purchaseBankForm.$invalid)\" ng-click=InitiateSummary.approveTransaction()>Approve Transaction</button> <button type=submit ng-if=\"InitiateSummary.summaryDetails.sentToPaymentGateway && InitiateSummary.showAmountNotDeductedButton\" class=\"btn btn-primary-action\" ng-disabled=\" !InitiateSummary.ischecked ||InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions ||\n      ((InitiateSummary.selectedPaymentOption==\'WEB\' && !InitiateSummary.bankdata) || InitiateSummary.selectedPaymentOption==\'VISADEBITCARD\' || InitiateSummary.selectedPaymentOption==\'MASTERDEBITCARD\'|| (InitiateSummary.selectedPaymentOption==\'DebitCreditCard\'&& !InitiateSummary.cardBankData))\n      || ((InitiateSummary.selectedPaymentOption==\'OTM\') && (InitiateSummary.otmLimitValidation || !InitiateSummary.purchaseBankModal.bankName || !InitiateSummary.purchaseBankModal.bankAcNo || InitiateSummary.startDateValidationPurchase))\n      || ((InitiateSummary.selectedPaymentOption==\'RTGS\' || InitiateSummary.selectedPaymentOption==\'HDFC\') && (!InitiateSummary.purchaseBankModal.bankName || !InitiateSummary.purchaseBankModal.bankBranch || !InitiateSummary.purchaseBankModal.bankAcNo || !InitiateSummary.purchaseBankModal.utr || !InitiateSummary.purchaseBankModal.verifyUtr || !InitiateSummary.purchaseBankModal.ifscCode))\n      || (InitiateSummary.purchaseBankForm.$invalid) || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\" ng-click=InitiateSummary.approveTransaction()>Approve Transaction</button> <button type=submit ng-if=\"InitiateSummary.summaryDetails.sentToPaymentGateway && InitiateSummary.showAmountDeductedButton\" class=\"btn btn-primary-action\" ng-click=InitiateSummary.submitTransaction()>Submit</button></div></section></div><style>.declaration{\n    width:100%;\n    float: left;\n    padding-left: 16px;\n  }\n  .declaration h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }\n  .terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }\n\n  .verify-btn {\n    height:40px ;\n    margin-top: 10px;\n  }\n\n  @media only screen and (max-width:768px) {\n    .verify-btn {\n      width: 100%\n    }\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.redeem.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType == \'REDEMPTION\'\">{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td><td ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType == \'INSTANTACCESSFACILITY\'\">Instant Access Facility</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Redeeming From</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Existing Scheme:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType !== \'INSTANTACCESSFACILITY\'\"><td>Total Current Value:</td><td class=voilet easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit|unitValue}} )</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType !== \'INSTANTACCESSFACILITY\'\"><td>Total Locked Value:</td><td class=red easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit|unitValue}})</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType !== \'INSTANTACCESSFACILITY\'\"><td>Total Free Value:</td><td class=green easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit|unitValue}} )</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionMode!==\'ALL_UNITS\' && InitiateSummary.summaryDetails.transactionMode!==\'UNITS\'\"><td>Redeeming Amount:</td><td>&#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.withDrawalAmount|unit:InitiateSummary.summaryDetails.sourceScheme.withDrawalAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.withDrawalAmountUnit|unitValue}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionMode==\'ALL_UNITS\' || InitiateSummary.summaryDetails.transactionMode==\'UNITS\'\"><td>Redeeming Units:</td><td>{{InitiateSummary.summaryDetails.transactionMode ===\'ALL_UNITS\' ?\"All Free Units\" :InitiateSummary.summaryDetails.sourceScheme.withDrawalUnits}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sourceScheme.exitLoad><td>Exit Load:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.exitLoad}}</td></tr><tr></tr><tr ng-if=InitiateSummary.summaryDetails.sourceScheme.capitalGain><td>Capital Gain:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.capitalGain}}</td></tr></table><p ng-if=\"InitiateSummary.summaryDetails.sourceScheme.exitLoad || InitiateSummary.summaryDetails.sourceScheme.capitalGain\">**Note: Amount mentioned is approximate, actual amount may differ based on applicable NAV.</p></div><!--TODO: Not enough details to implement--><div class=\"email-block bank-data\"><p class=email-block-header>Bank Details</p><div class=row><div class=col-md-5><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" ng-model=InitiateSummary.selectedBank ng-options=\"_bank as (_bank.bankName +\'(\'+ _bank.bankAcNo +\')\') for _bank in InitiateSummary.summaryDetails.accountList\" ng-change=InitiateSummary.checkMinorBankFlag() required><option value=\"\" selected>Select Bank</option></select></div></div></div><table class=\"table borderless\" ng-if=InitiateSummary.selectedBank><tr><td>Bank Name:</td><td>{{InitiateSummary.selectedBank.bankName}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.selectedBank.bankAcNo}}</td></tr><tr><td>Branch:</td><td>{{InitiateSummary.selectedBank.bankBranch + \' \' + InitiateSummary.selectedBank.bankCity}}</td></tr><tr><td>IFSC Code:</td><td>{{(InitiateSummary.selectedBank.ifscCode?InitiateSummary.selectedBank.ifscCode:null)}}</td></tr><tr><td>Transaction Mode:</td><td>{{InitiateSummary.summaryDetails.transactionMode == \'ALL_UNITS\' ? \'All Units\' : InitiateSummary.summaryDetails.transactionMode}}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.selectedBank || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.approveTransactionForSWP_REDEMPTION() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.rollover.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div><div class=email-block><!--<p class=\"email-block-header\">Scheme Transferring From</p>--><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.amount><td>Amount:</td><td><i ng-if=\"InitiateSummary.summaryDetails.amount > 0\" class=rupee-grey-icon></i>{{(InitiateSummary.summaryDetails.amount > 0)?InitiateSummary.summaryDetails.amount:\'NA\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.units><td>No of Units:</td><td>{{(InitiateSummary.summaryDetails.units > 0)? InitiateSummary.summaryDetails.units:\'NA\'}}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransactionRollover() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.approveTransactionForROLLOVER() class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.sip.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section class=summary-sip><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=content-body ng-if=!InitiateSummary.isFromEcart><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td ng-if=!InitiateSummary.isDREAMSIP>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td><td ng-if=InitiateSummary.isDREAMSIP>DREAM SIP</td></tr></table></div></div><div class=\"content-body email-block\" ng-if=InitiateSummary.isFromEcart><div class=\"row ecart-details-container\"><div class=col-md-6><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated By:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.oversea_arn && (!InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode && (InitiateSummary.summaryDetails.summaryType !==\'SIP_TOPUP\'))\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr></table></div><div class=col-md-6><p class=email-block-header>Transaction Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr><tr><td>Total Amount:</td><td>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.summaryDetails.totalInstallmentAmount)}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr></table></div></div></div></section><section ng-if=\"(InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode) || (InitiateSummary.summaryDetails && InitiateSummary.summaryDetails.cartItems && (InitiateSummary.summaryDetails.cartItems[0].subBrokerArn || InitiateSummary.summaryDetails.cartItems[0].subBrokerCode))\"><div class=content-body><div class=email-block><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.cartItems[0].subBrokerArn\"><td>Sub Broker ARN:</td><td ng-if=InitiateSummary.summaryDetails.subBrokerArn>{{InitiateSummary.summaryDetails.subBrokerArn}}</td><td ng-if=InitiateSummary.summaryDetails.cartItems[0].subBrokerArn>{{InitiateSummary.summaryDetails.cartItems[0].subBrokerArn}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.subBrokerCode || InitiateSummary.summaryDetails.cartItems[0].subBrokerCode\"><td>Sub Broker Code:</td><td ng-if=InitiateSummary.summaryDetails.subBrokerCode>{{InitiateSummary.summaryDetails.subBrokerCode}}</td><td ng-if=InitiateSummary.summaryDetails.cartItems[0].subBrokerCode>{{InitiateSummary.summaryDetails.cartItems[0].subBrokerCode}}</td></tr></table></div></div></section><!--for ecart details--><!--  <section ng-if=\"!InitiateSummary.sipModifyEnabled && InitiateSummary.isFromEcart\">--><!--    <div class=\"content-body\">--><!--      <div class=\"email-block\">--><!--        <p class=\"email-block-header\">SIP Transaction Details</p>--><!--        <div class=\"row ecart-details-container many-cart-scroll\">--><!--          <div class=\"col-md-3 ecart-web-view\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Scheme:</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-table-head-web\">Transaction Amount:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-table-head-web\">SIP Frequency:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipFrequency==\'Weekly\'\">--><!--                <td class=\"ecart-table-head-web\">SIP Day:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-table-head-web\">SIP Start Date:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-table-head-web\">SIP End Date:</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-table-head-web\">SIP First Installment :</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment\">--><!--                <td class=\"ecart-table-head-web\">SIP First Installment Amount :</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--          <div class=\"col-md-3\" ng-repeat=\"cartItem in InitiateSummary.summaryDetails.cartItems\">--><!--            <table class=\"table borderless\">--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Scheme:</td>--><!--                <td>{{cartItem.schemeName}}</td>--><!--              </tr>--><!--              <tr>--><!--                <td class=\"ecart-mobile\">Transaction Amount:</td>--><!--                <td>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(cartItem.installmentAmount)}} {{InitiateSummary.summaryDetails.amountUnit}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-mobile\">SIP Frequency:</td>--><!--                <td>{{cartItem.frequency == \'OM\'? \'Monthly\': cartItem.frequency}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-mobile\">SIP Start Date:</td>--><!--                <td>{{cartItem.sipDate}}</td>--><!--              </tr>--><!--              <tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\">--><!--                <td class=\"ecart-mobile\">SIP End Date:</td>--><!--                <td>{{cartItem.toDate}}</td>--><!--              </tr>--><!--            </table>--><!--          </div>--><!--        </div>--><!--      </div>--><!--    </div>--><!--  </section>--><section class=transaction-details-section><div class=transaction-details ng-if=InitiateSummary.isFromEcart><div class=transaction-details-heading><p><span ng-if=\"InitiateSummary.ecartTransactionType===\'SIP\'\">SIP Transaction Details</span></p></div><div class=transaction-details-container ng-repeat=\"cartItem in InitiateSummary.summaryDetails.cartItems\"><div><p>{{cartItem.schemeName}}</p><p ng-if=cartItem.sipOpted>SIP Tenure : <span>{{cartItem.sipDate}} - </span><span>{{cartItem.toDate}}</span></p></div><div><p ng-if=cartItem.sipOpted>SIP</p></div><div><p ng-if=cartItem.sipOpted>{{cartItem.installmentRupee}}</p></div></div><div class=transaction-details-amount-container><div><p>Total Amount</p></div><div><p>&#8377; {{InitiateSummary.utilService.getCommaSeperatedString(InitiateSummary.summaryDetails.totalInstallmentAmount)}}</p></div></div></div></section><!--for sip details--><section ng-if=\"!InitiateSummary.sipModifyEnabled && !InitiateSummary.isFromEcart\"><div class=content-body><div class=email-block><p class=email-block-header>Scheme Details</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr ng-if=InitiateSummary.isDREAMSIP><td class=option>Option:</td><td ng-if=\"InitiateSummary.summaryDetails.option == \'A\' \">Option A (SIP - SWAP)</td><td ng-if=\"InitiateSummary.summaryDetails.option == \'B\' \">Option B (SIP - SWITCH - SWAP)</td></tr><tr><td ng-if=!InitiateSummary.isDREAMSIP>Scheme:</td><td ng-if=\"InitiateSummary.isDREAMSIP && InitiateSummary.summaryDetails.option == \'B\'\">Source Scheme Name:</td><td ng-if=\"InitiateSummary.isDREAMSIP && InitiateSummary.summaryDetails.option == \'A\'\">Scheme Name:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr ng-if=\"InitiateSummary.isDREAMSIP && InitiateSummary.summaryDetails.option == \'B\' \"><td>Target Scheme:</td><td>{{InitiateSummary.summaryDetails.targetSchemeName}}</td></tr><tr><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr ng-if=InitiateSummary.isDREAMSIP><td>Swap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.swapAmount}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.sipFrequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.sipFrequency==\'Weekly\'\"><td>SIP Day:</td><td>{{InitiateSummary.summaryDetails.weeklyDay}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.sipDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP End Date:</td><td>{{InitiateSummary.summaryDetails.sipEndDate}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>SIP First Installment :</td><td>{{InitiateSummary.summaryDetails.sipWithFirstInstallment ? \'Yes\': \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>SIP First Installment Amount :</td><td ng-if=!InitiateSummary.summaryDetails.bulkTransactionFlag>&#8377; {{InitiateSummary.summaryDetails.firstInstallmentDetails.amount?InitiateSummary.summaryDetails.firstInstallmentDetails.amount:InitiateSummary.summaryDetails.amount}}</td><td ng-if=InitiateSummary.summaryDetails.bulkTransactionFlag>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr></table></div></div></section><!--showing folio details--><section ng-if=\"InitiateSummary.sipModifyEnabled && !InitiateSummary.isFromEcart\"><div class=content-body><div class=email-block><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr></table></div></div></section><!--for sip modify details--><section ng-if=InitiateSummary.sipModifyEnabled><div class=content-body><div class=\"email-block modify-block\"><div class=modify-details><table class=\"table borderless table-left\"><tr><td colspan=2 class=modify-header>Cancelled details:</td></tr><tr><td>Scheme:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.schemeName}}</td></tr><tr><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.systematicCancelSummary.amount}} {{InitiateSummary.summaryDetails.systematicCancelSummary.amountUnit}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.frequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.frequency==\'Weekly\'\"><td>SIP Day:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.weeklyDay}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.startDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP End Date:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.endDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\' && InitiateSummary.summaryDetails.systematicCancelSummary.payMech\"><td>Payment Mode for SIP Registration:</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.payMech === \'HEM\'\">Register E-mandate (eOTM)</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.payMech === \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.payMech === \'EC\'\">Standing Instruction/Biller</td></tr><tr><td>SIP Topup Enabled:</td><td>{{InitiateSummary.cancelledTopupDetailsWerePresent ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.amount><td>SIP Topup Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.percentage><td>SIP Topup Percentage:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.frequency><td style=\"font-weight: 100\">SIP Topup Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.capAmount><td>SIP Topup Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.capMonthYear><td>SIP Topup Cap Date:</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.topupDetails.capMonthYear}}</td></tr><tr><td>SIP First Installment :</td><td>{{InitiateSummary.summaryDetails.systematicCancelSummary.sipWithFirstInstallment ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.sipWithFirstInstallment><td>SIP First Installment Amount :</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.systematicCancelSummary.sipWithFirstInstallment><td>Payment Mode for First Installment of SIP :</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.payMechForFi == \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"InitiateSummary.summaryDetails.systematicCancelSummary.payMechForFi == \'WEB\'\">Net Banking</td></tr></table><div class=vertical-line></div><table class=\"table borderless table-right\"><tr><td colspan=2 class=modify-header>Modified details:</td></tr><tr><td>Scheme:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>Transaction Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}} {{InitiateSummary.summaryDetails.amountUnit}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Frequency:</td><td>{{InitiateSummary.summaryDetails.sipFrequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.sipFrequency==\'Weekly\'\"><td>SIP Day:</td><td>{{InitiateSummary.summaryDetails.weeklyDay}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP Start Date:</td><td>{{InitiateSummary.summaryDetails.sipDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\'\"><td>SIP End Date:</td><td>{{InitiateSummary.summaryDetails.sipEndDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryType==\'SIP\' && InitiateSummary.summaryDetails.payMech\"><td>Payment Mode for SIP Registration:</td><td ng-if=\"InitiateSummary.summaryDetails.payMech === \'HEM\'\">Register E-mandate (eOTM)</td><td ng-if=\"InitiateSummary.summaryDetails.payMech === \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"InitiateSummary.summaryDetails.payMech === \'EC\'\">Standing Instruction/Biller</td><td ng-if=\"InitiateSummary.summaryDetails.payMech === \'UPI\'\">UPI Auto Pay</td></tr><tr><td>SIP Topup Enabled:</td><td>{{InitiateSummary.summaryDetails.sipTopupEnabled ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.amount><td>SIP Topup Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.percentage><td>SIP Topup Percentage:</td><td>{{InitiateSummary.summaryDetails.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.frequency><td style=\"font-weight: 100\">SIP Topup Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capAmount><td>SIP Topup Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capMonthYear><td>SIP Topup Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupDetails.capMonthYear}}</td></tr><tr><td>SIP First Installment :</td><td>{{InitiateSummary.summaryDetails.sipWithFirstInstallment ? \'Yes\' : \'No\'}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.sipWithFirstInstallment><td>SIP First Installment Amount :</td><td>&#8377; {{InitiateSummary.summaryDetails.amount}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.sipWithFirstInstallment && InitiateSummary.summaryDetails.firstInstallmentDetails\"><td>Payment Mode for First Installment of SIP :</td><td ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails.paymentMode == \'OTM\'\">OTM(One Time Mandate)</td><td ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails.paymentMode == \'WEB\'\">Net Banking</td></tr></table></div></div></div></section><section ng-if=InitiateSummary.summaryDetails.checkedNfoAutoSwitch><div class=content-body><div class=email-block><p class=email-block-header>Auto Switch Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Auto Switch On Maturity:</td><td>{{InitiateSummary.summaryDetails.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.autoSwitchScheme}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption!=\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.sipTopupEnabled && !InitiateSummary.sipModifyEnabled\"><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupDetails.amount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.amount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.percentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupDetails.percentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.frequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupDetails.frequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupDetails.capAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupDetails.capMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupDetails.capMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\'\"><div class=content-body><div class=email-block><p class=email-block-header>Sip Topup Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.topupAmount><td>Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupPercentage><td>Percentage:</td><td>{{InitiateSummary.summaryDetails.topupPercentage}}%</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupFrequency><td>Frequency:</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'Y\'\">Yearly</td><td ng-if=\"InitiateSummary.summaryDetails.topupFrequency === \'H\'\">Half-Yearly</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapAmount><td>Cap Amount:</td><td>&#8377; {{InitiateSummary.summaryDetails.topupCapAmount}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.topupCapMonthYear><td>Cap Date:</td><td>{{InitiateSummary.summaryDetails.topupCapMonthYear}}</td></tr></table></div></div></section><section ng-if=\"InitiateSummary.summaryDetails.folioBankDetails.bankName &&\n    InitiateSummary.summaryDetails.folioBankDetails.bankAcNo && InitiateSummary.summaryDetails.folioBankDetails.bankBranch &&\n    InitiateSummary.summaryDetails.folioBankDetails.ifscCode\"><div class=content-body><div class=email-block><p class=email-block-header>Primary Bank Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankName><td>Bank Name:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankName}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankAcNo><td>Account Number:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankAcNo}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.bankBranch><td>Branch:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.bankBranch}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.folioBankDetails.ifscCode><td>IFSC Code:</td><td>{{InitiateSummary.summaryDetails.folioBankDetails.ifscCode}}</td></tr></table></div></div></section><!--\n  <retirement-fund-summary\n    holders=\"InitiateSummary.summaryDetails.holders\"\n    folionumber=\"InitiateSummary.summaryDetails.folioNumber\"\n    holdersform=\"InitiateSummary.holdersForm\"\n    ng-if=\"InitiateSummary.summaryDetails.holders.length>0\"\n  >\n  </retirement-fund-summary>--><!--\n  <section ng-if=\"InitiateSummary.summaryDetails.newFolio\">\n    <div class=\"content-body\">\n      <div class=\"email-block\">\n        <p class=\"email-block-header\">Upload Documents</p>\n\n        <p class=\"mrt red\">Document type : JPG or PNG only . Maximum file size : 1.5MB each</p>\n        <form autocomplete=\"off\" name=\"docUpload\" ng-submit=\"InitiateSummary.submitDoc()\" novalidate>\n          <table class=\"table borderless purchase-sip\">\n            <tr>\n              <td>Cheque Leaf :</td>\n              <td>\n                <input type=\"file\" name=\"chequeLeaf\" serial=\"1\" file-model-profile=\"InitiateSummary.doc.chequeLeaf\"\n                       upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img1}}</p>\n              </td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>DOB Proof :</td>\n              <td><input type=\"file\" name=\"minorProof\" serial=\"2\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                         accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.minorProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img2}}</p></td>\n            </tr>\n            <tr ng-if=\"InitiateSummary.summaryDetails.minor\">\n              <td>Guardian Proof :</td>\n              <td>\n                <input type=\"file\" name=\"guardianProof\" serial=\"3\" upload=\"InitiateSummary.verifyDoc(file,serial)\"\n                       accept=\".jpeg,.jpg,.png\" file-model-profile=\"InitiateSummary.doc.guardianProof\" required/>\n                <p class=\"error-fileSize\">{{InitiateSummary.validImage.Img3}}</p></td>\n            </tr>\n          </table>\n          <button ng-if=\"!InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 1\">Upload Files\n          </button>\n          <button ng-if=\"InitiateSummary.summaryDetails.minor\" class=\"btn btn-primary-action pull-right\"\n                  ng-disabled=\"docUpload.$invalid || InitiateSummary.validLength.length < 3\">Upload Files\n          </button>\n        </form>\n      </div>\n    </div>\n  </section>\n--><section ng-if=\"InitiateSummary.summaryType==\'SIP\'|| InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\'\"><div class=content-body><div class=email-block><div><p class=email-block-header>Payment Options for SIP Registration</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionsSip\" ng-class=\"{\'anything-disabled\': InitiateSummary.summaryDetails.payMech !== option.key && !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled) || (option.key ===\'EC\' && InitiateSummary.siEnabled) || (option.key ===\'HEM\' && InitiateSummary.emandateEnabled) || (option.key ===\'UPI\' && InitiateSummary.upiEnabledForSIP))\"><span class=radio><input type=radio id={{option.key}} name=paymentOption value={{option.key}} ng-model=InitiateSummary.selectedPaymentOption ng-change=InitiateSummary.paymentOptionChanged()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div><!--Bank select for standing instructions--><p ng-if=\"InitiateSummary.selectedPaymentOption==\'EC\' && InitiateSummary.siEnabled\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'EC\' && InitiateSummary.siEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.ECbankList\" ng-model=InitiateSummary.bankdata ng-change=InitiateSummary.changeBank() ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div></div></div><!---------------------------------------------------><!--Bank select for OTM banks--><p ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.otmBankData ng-change=InitiateSummary.changedOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option><!--<option ng-repeat=\"bank in InitiateSummary.otmBankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.otmLimitValidation && InitiateSummary.otmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.endDateValidation && InitiateSummary.otmBankData\">Selected date is greater than OTM expiry date. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.startDateValidation && InitiateSummary.otmBankData\">Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateSummary.otmBankData.omStartDate}}</span></div></div></div><div class=emandate-section-summary><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.bankList.length > 0)\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\"><div class=col-md-3><div class=selectfield ng-if=\"InitiateSummary.bankList.length > 0\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=\"InitiateSummary.authMode = InitiateSummary.bankdata; InitiateSummary.authModeSelect = InitiateSummary.authMode.authenticationModes[0];\n                              InitiateSummary.emPayoutId = InitiateSummary.bankdata.bankName\" ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null;\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div><!--              <span class=\"error-message emandate-error-message\"--><!--                    ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && InitiateSummary.isEmandateMaxLimit < InitiateSummary.amount && InitiateSummary.amount\"--><!--                    class=\"error-input\">SIP Amount cannot be greater than Rs. 10 lakh for Emandate payment mode--><!--            </span>--> <span class=\"error-message emandate-error-message\" ng-if=\"InitiateSummary.bankList.length === 0\">No Bank Available</span></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.authModeSelect)\"><strong>Authentication Mode</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\"><div class=col-md-3><div class=selectfield><label>Authentication Mode</label><select class=\"browser-default custom-select\" name=bankName ng-model=InitiateSummary.authModeSelect ng-options=\"item.text for item in InitiateSummary.authMode.authenticationModes\" ng-required=\"InitiateSummary.selectedPaymentOption == \'HEM\'\" ng-change=\"InitiateSummary.authModeData=InitiateSummary.authModeSelect\" required><option value=\"\" selected>Select Authentication Mode</option></select><span class=req>*</span></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate Amount <span class=req>*</span></strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable\"><div class=col-md-3><div class=\"input-normal icon-input\" ng-class=\"{error:(InitiateSummary.tForm.eAmount.$invalid && InitiateSummary.tForm.eAmount.$dirty),\'has-data\':InitiateSummary.summaryDetails.emandateAmount}\"><input class=input-min style=\"padding-left: 20px\" type=number onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ignore-mouse-wheel name=eAmount ng-model=InitiateSummary.summaryDetails.emandateAmount ng-change=InitiateSummary.checkAmountValidationEmandate() ng-maxlength=10 limit-to=10 required> <span class=highlight></span> <span class=bar></span> <i style=top:-29px class=rupee-grey-icon></i><div class=amtWords ng-if=InitiateSummary.summaryDetails.emandateAmount><p id=amountInwordsEmandate>{{InitiateSummary.emandateWord.amountInWords}} (In Words)</p></div><!--                <span class=\"text-success\">--><!--                 Maximum allowed for e-mandate is ₹ {{InitiateSummary.mandateMaxString}}.--><!--              </span>--><div class=error-input ng-show=\"InitiateSummary.amountLess && InitiateSummary.summaryDetails.emandateAmount\">{{InitiateSummary.validations.EMANDATE_MIN_ERROR + InitiateSummary.emandateMinAmountLimit}}.</div><div class=error-input ng-show=InitiateSummary.amountMore>{{InitiateSummary.validations.EMANDATE_MAX_ERROR + InitiateSummary.mandateMaxString}}.</div><div class=error-input ng-show=\"!InitiateSummary.amountLess && InitiateSummary.isLessThanSipAmount\" ng-bind=InitiateSummary.validations.EMANDATE_SIP_AMOUNT_ERROR></div><div class=error-input ng-show=!InitiateSummary.summaryDetails.emandateAmount ng-bind=InitiateSummary.validations.MANDATE_AMOUNT_REQUIRED></div></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate Start Date <span class=req>*</span></strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && InitiateSummary.emandateValidationData && !InitiateSummary.emandateBankNotAvailable)\"><div class=\"col-md-3 anything-disabled\" ng-if=!InitiateSummary.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateSummary.summaryDetails.emandateDate id=emandateStartDate data-enable=true data-on-date-change=InitiateSummary.changeDateEmandate style=\"position: relative;width: 100%\"><input type=text name=emandateStartDate placeholder=\"Start Date - DD-MMM-YYYY\" readonly></div></div></div><p ng-if=\"InitiateSummary.selectedPaymentOption==\'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && !InitiateSummary.emandateBankNotAvailable)\"><strong>Mandate End Date <span class=req>*</span> <i class=\"info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=right title={{InitiateSummary.mandateInfo}} tooltip-side=right></i></strong></p><div class=\"row mandateDates\" ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && InitiateSummary.takeMandateFields && InitiateSummary.emandateValidationData && !InitiateSummary.emandateBankNotAvailable)\"><div class=col-md-3><div ng-class=\"{\'anything-disabled\': !InitiateSummary.summaryDetails.emandateDate}\"><div ng-if=!InitiateSummary.isReseting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{error:InitiateSummary.tForm.endDateEmandate.$dirty && InitiateSummary.tForm.endDateEmandate.$invalid}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateSummary.summaryDetails.endDateEmandate data-enabled-dates=InitiateSummary.enabledEmandateEndDatesList data-view-date=InitiateSummary.enabledEndDateView data-max-date=InitiateSummary.maxEndDateEmandate data-min-date=InitiateSummary.minEndDateEmandate data-on-date-change=InitiateSummary.changeEndDateEmandate data-enable=true id=endDateEmandate showdefault=false><input type=text name=endDateEmandate autocomplete=off placeholder=\"End Date - DD-MMM-YYYY\" class=endDateMandateInput readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span> <span style=\"word-spacing: -1px; position: absolute; left: 0px; top: 45px\" class=error-input ng-show=InitiateSummary.sipDateLessEmandate ng-bind=InitiateSummary.VALIDATE_DATA.MANDATE_DATE_EXCEED_ERROR_TENURE></span></div></div></div></div></div><!-- Bank select for UPI--><p ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\'\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOption == \'UPI\'\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.bankdata ng-change=InitiateSummary.changedUPIBank() ng-init=\"InitiateSummary.bankdata=InitiateSummary.bankdata?InitiateSummary.bankdata:null\" required><option value=\"\" selected>Select Bank</option></select><span class=req>*</span></div></div></div><p ng-if=\"InitiateSummary.summaryDetails.bulkTransactionFlag\n          && (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)\" class=payment-error-message><strong>No valid payment mode available to proceed with SIP transaction</strong></p><form autocomplete=off name=InitiateSummary.EcsBankForm class=clearfix ng-submit=InitiateSummary.approveEcsBankTransaction() novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOption != \'HEM\' && (InitiateSummary.isOtmEnabled || InitiateSummary.siEnabled)  && InitiateSummary.selectedPaymentOption != \'UPI\'\"><div class=bank-detail style=\"margin-left: 15px\"><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.ecsBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankName.$dirty && InitiateSummary.EcsBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\" style=\"margin-top: -10px\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType && InitiateSummary.selectedPaymentOption==\'OTM\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-init=\"InitiateSummary.ecsBankModal.bankAcType=InitiateSummary.ecsBankModal.bankAcType?InitiateSummary.ecsBankModal.bankAcType:null\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=col-md-3 ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.ifscCode && InitiateSummary.selectedPaymentOption==\'EC\'\"><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off ng-required=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$dirty&&InitiateSummary.EcsBankForm.ifscCode.$error.pattern ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.bankAcType && InitiateSummary.selectedPaymentOption==\'EC\'\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" ng-init=\"InitiateSummary.ecsBankModal.bankAcType=InitiateSummary.ecsBankModal.bankAcType?InitiateSummary.ecsBankModal.bankAcType:null\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption != \'EC\' && (InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankBranch ng-model=InitiateSummary.ecsBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankBranch.$dirty && InitiateSummary.EcsBankForm.bankBranch.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankBranch.$error.required ng-bind=InitiateSummary.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'}\"><input type=text name=bankCity ng-model=InitiateSummary.ecsBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City<span ng-if=\"InitiateSummary.selectedPaymentOption !==\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankCity.$dirty && InitiateSummary.EcsBankForm.bankCity.$invalid && InitiateSummary.selectedPaymentOption !==\'OTM\'\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankCity.$error.required ng-bind=InitiateSummary.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption != \'EC\'\"><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.ecsBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$dirty && InitiateSummary.EcsBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.bankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.ecsBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.ecsBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$dirty && InitiateSummary.EcsBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.EcsBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.EcsBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code</label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty&&InitiateSummary.EcsBankForm.ifscCode.$error.pattern ||InitiateSummary.EcsBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.ecsBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled ) \"><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.ecsBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.ecsBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled ) \"><div class=col-md-5><div class=input-normal><input type=text name=omStartDate ng-model=InitiateSummary.ecsBankModal.omStartDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Start Date</label></div></div></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && (InitiateSummary.isOtmEnabled ) \"><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.otmBankData && !InitiateSummary.otmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div><input type=hidden id=hfReq><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && (InitiateSummary.emandateEnabled && !InitiateSummary.emandateBankNotAvailable)\"><div><!--                <p class=\"email-block-header\"><u>Emandate Registration Details</u></p>--><table class=\"table borderless emandate-table\"><tr><td>Bank Name:</td><td>{{InitiateSummary.emPayoutId.substr(0, InitiateSummary.emPayoutId.lastIndexOf(\'-\'))}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.emPayoutId.slice(InitiateSummary.emPayoutId.lastIndexOf(\'-\') + 1)}}</td></tr><tr ng-if=\"InitiateSummary.amount && !InitiateSummary.takeMandateFields\"><td>Amount:</td><td><i class=rupee-grey-icon></i>{{InitiateSummary.amount}}</td></tr><tr><td>Frequency:</td><td>As and when presented</td></tr><tr ng-if=\"InitiateSummary.eMandateStartDate  && !InitiateSummary.takeMandateFields\"><td>Mandate Start Date:</td><td>{{InitiateSummary.eMandateStartDate}}</td></tr><tr ng-if=\"InitiateSummary.eMandateEndDate && !InitiateSummary.takeMandateFields\"><td>Mandate End Date:</td><td>{{InitiateSummary.eMandateEndDate}}</td></tr><tr><td>Purpose of mandate:</td><td>Mutual Fund Payment</td></tr></table></div><!--<div class=\"row\" ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\'\">\n                <div class=\"col-md-3\"></div>\n                  <div class=\"col-md-3\">\n\n                  </div>\n                </div>--></div><div class=row ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\'\"><div class=col-md-8 ng-if=\"!InitiateSummary.bankdata.ifscCode || !InitiateSummary.bankdata.bankAcType\"><div class=\"col-md-4 mob-res\" ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.ifscCode\" style=\"margin-top: 8px\"><div class=input-normal ng-class=\"{error:(InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid)}\"><input type=text name=ifscCode ng-model=InitiateSummary.ecsBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span class=req>*</span></label><span ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.EcsBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.EcsBankForm.ifscCode.$dirty && InitiateSummary.EcsBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-4 ng-if=\"InitiateSummary.bankdata && !InitiateSummary.bankdata.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.EcsBankForm.accountType.$dirty && InitiateSummary.EcsBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.ecsBankModal.bankAcType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.ecsBankModal.bankAcType style=\"display: block\">Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.EcsBankForm.accountType.$error ng-show=InitiateSummary.EcsBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div><div class=col-md-12><div class=col-md-3 ng-show=\"InitiateSummary.selectedPaymentOption ==\'UPI\' && InitiateSummary.bankdata\"><div class=\"row ng-scope\"><div class=col-md-12 ng-class=\"{\'mob-res\':InitiateSummary.bankdata.ifscCode}\"><div class=input-normal ng-class=\"{error:InitiateSummary.EcsBankForm.virtualAddress.$dirty && InitiateSummary.EcsBankForm.virtualAddress.$invalid}\"><input type=text name=virtualAddress ng-model=InitiateSummary.virtualAddress ng-pattern=InitiateSummary.appConstants.upi_virtual_addr_regex ng-change=InitiateSummary.virtualAddressChange() ng-readonly=\"InitiateSummary.isUPIVerified && InitiateSummary.verifyUPIResp.valid === true\" style=\"text-transform: lowercase\" required> <span class=highlight></span> <span class=bar></span><label style=\"display: block;width: 100%\">Virtual Payment Address <span class=req>*</span> <i class=edit2-icon style=\"position: absolute;right: 0px; top:16px; pointer-events: all; box-sizing: content-box\" ng-if=\"InitiateSummary.isUPIVerified && InitiateSummary.verifyUPIResp.valid === true\" ng-click=InitiateSummary.resetUpiForm()></i></label><span ng-show=\"InitiateSummary.EcsBankForm.virtualAddress.$dirty && InitiateSummary.EcsBankForm.virtualAddress.$invalid\"><span class=error-input ng-show=\"(InitiateSummary.EcsBankForm.virtualAddress.$dirty) && (InitiateSummary.EcsBankForm.virtualAddress.$error.required || InitiateSummary.EcsBankForm.virtualAddress.$error.pattern)\" ng-bind=InitiateSummary.validateData.VIRTUAL_ADDRESS_REQUIRED></span> </span><span class=error-input>{{InitiateSummary.errorMessage}}</span></div></div></div></div><div class=col-md-3 ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\' && !InitiateSummary.isUPIVerified && InitiateSummary.bankdata\"><div class=row><div class=col-md-12><button blur-on-click ng-if=\"InitiateSummary.selectedPaymentOption==\'UPI\' && !InitiateSummary.isUPIVerified\" class=\"btn btn-primary-action verify-btn\" ng-disabled=\"!InitiateSummary.virtualAddress || InitiateSummary.hideValidateMinor\" ng-click=InitiateSummary.verifyPaymentAddress()>Verify</button></div></div></div><div class=col-md-3 ng-if=\"InitiateSummary.isUPIVerified && InitiateSummary.bankdata && InitiateSummary.selectedPaymentOption == \'UPI\'\"><div class=row><div class=\"col-md-12 verify-vpa\"><p><strong>Verified</strong> <i class=verified-small-icon></i></p><span>Name: {{InitiateSummary.name}}</span></div></div></div></div></div></form></div><!------------------------------------------></div><div ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails && InitiateSummary.summaryDetails.sipWithFirstInstallment && InitiateSummary.selectedPaymentOption == \'UPI\'\" style=\"padding-top: 19px;display: flex;flex-direction: column;row-gap: 13px\"><p class=email-block-header>Payment Options for First Installment of SIP</p><ng-bind-html dynamic=InitiateSummary.dynamicDataForFIUPI.content></ng-bind-html></div><!-- payment option for sip with first installment--><div ng-if=\"InitiateSummary.summaryDetails.firstInstallmentDetails && InitiateSummary.selectedPaymentOption != \'UPI\' || (InitiateSummary.summaryDetails.bulkTransactionFlag && InitiateSummary.summaryDetails.sipWithFirstInstallment && InitiateSummary.selectedPaymentOption != \'UPI\' || InitiateSummary.summaryDetails.sipWithFirstInstallment && InitiateSummary.selectedPaymentOption != \'UPI\')\"><p class=email-block-header>Payment Options for First Installment of SIP</p><div class=\"form-group text-left payment-options\" ng-class=\"{\'no-payment-option\': (!InitiateSummary.emandateEnabled && !InitiateSummary.isOtmEnabled && !InitiateSummary.siEnabled)}\"><span class=radio-block ng-repeat=\"option in InitiateSummary.paymentOptionForFirstInstallment\" ng-class=\"{\'anything-disabled\':(InitiateSummary.summaryDetails.firstInstallmentDetails?InitiateSummary.summaryDetails.firstInstallmentDetails.paymentMode !== option.key:\'\') &&\n               !InitiateSummary.summaryDetails.bulkTransactionFlag}\" ng-if=\"((option.key ===\'OTM\' && InitiateSummary.isOtmEnabled) || (option.key ===\'WEB\') || (option.key ===\'UPI\' && InitiateSummary.upiEnabledForSIP))\"><span class=radio><input type=radio id={{option.key}} name=paymentOptionForFi value={{option.key}} ng-model=InitiateSummary.selectedPaymentOptionForFI ng-change=InitiateSummary.paymentOptionChangedForFi()> <span class=check></span></span><label for={{option.key}}>{{option.value}}</label></span></div><p ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'WEB\'\"><strong>Select bank for making Payment</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><div class=col-md-3><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankListForFi\" ng-model=InitiateSummary.fiBankdata ng-change=InitiateSummary.checkMinorBankFlag()><option value=\"\" selected>Select Bank</option><!--<option ng-repeat=\"bank in InitiateSummary.bankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select></div></div></div><div ng-if=\"InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><form autocomplete=off name=InitiateSummary.FInetbanking class=clearfix><div class=form-content><div class=bank-detail><p ng-if=\"InitiateSummary.fiBankdata && (!InitiateSummary.fiBankdata.ifscCode || !InitiateSummary.fiBankdata.bankAcType)\"><strong>Bank Details</strong></p><br><div class=row><div class=col-md-3 ng-if=\"InitiateSummary.fiBankdata && !InitiateSummary.fiBankdata.ifscCode\"><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.fibankData.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off ng-required=\"InitiateSummary.selectedPaymentOptionForFI !=\'OTM\'\" capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code<span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.FInetbanking.ifscCode.$dirty && InitiateSummary.FInetbanking.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.FInetbanking.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=InitiateSummary.FInetbanking.ifscCode.$dirty&&InitiateSummary.FInetbanking.ifscCode.$error.pattern ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=col-md-3 style=\"margin-top: -10px\" ng-if=\"InitiateSummary.fiBankdata && !InitiateSummary.fiBankdata.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.FInetbanking.accountType.$dirty && InitiateSummary.FInetbanking.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.fibankData.accType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.fibankData.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.FInetbanking.accountType.$error ng-show=InitiateSummary.FInetbanking.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></div></form></div></div><!-- otm bank selection for fi--><p ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><strong>Select bank for OTM</strong></p><div class=row ng-if=\"InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=col-md-3><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"item as (item.bankName+\' - \'+item.bankAcNo.substr(item.bankAcNo.length-4, item.bankAcNo.length-1)) for item in InitiateSummary.otmBankList track by item.omUmrn\" ng-model=InitiateSummary.fiOtmBankData ng-change=InitiateSummary.changedFiOtmBank()><option value=\"\" selected>Select Otm Bank - Account Number</option></select><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiOtmLimitValidation && InitiateSummary.fiOtmBankData\">Transaction amount is greater than the OTM Limit set. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.fiEndDateValidation && InitiateSummary.fiOtmBankData\">Selected date is greater than OTM expiry date. </span><span class=\"error-message otm-error-message\" ng-show=\"InitiateSummary.startDateValidationForFi && InitiateSummary.fiOtmBankData\">Cannot initiate payment using selected OTM. You can initiate payment for SIP transaction on or after OTM start date which is, {{InitiateSummary.fiOtmBankData.omStartDate}}</span></div></div></div><form autocomplete=off name=InitiateSummary.fiOtmBankForm class=clearfix novalidate><div class=form-content ng-if=\"InitiateSummary.selectedPaymentOptionForFI ===\'OTM\' && InitiateSummary.isOtmEnabled\"><div class=bank-detail><p><strong>Bank Details</strong></p><br><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankName.$dirty &&\n                          InitiateSummary.fiOtmBankForm.bankName.$invalid}\"><input type=text name=bankName ng-model=InitiateSummary.fiOtmBankModal.bankName ng-readonly=true required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankName.$dirty && InitiateSummary.fiOtmBankForm.bankName.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankName.$error.required ng-bind=InitiateSummary.validateData.BANK_NAME_REQUIRED></span></span></div></div></div><div class=row><div class=col-md-5><div class=\"input-normal branch-loc\"><input type=text name=bankBranch ng-model=InitiateSummary.fiOtmBankModal.bankBranch ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\"><input type=text name=bankCity ng-model=InitiateSummary.fiOtmBankModal.bankCity ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank City</label></div></div></div><div class=row><div class=col-md-5><div class=input-normal ng-class=\"{error:InitiateSummary.fiOtmBankForm.bankAcNo.$dirty && InitiateSummary.fiOtmBankForm.bankAcNo.$invalid}\"><input type=text name=bankAcNo minlength=9 ng-model=InitiateSummary.fiOtmBankModal.bankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$dirty &&\n                         InitiateSummary.fiOtmBankForm.bankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.bankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.bankAcNo.$error.minlength ||\n                            !InitiateSummary.fiOtmBankForm.bankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=\"input-normal branch-loc\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty &&\n                          InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid}\"><input type=text name=verifyBankAcNo ng-model=InitiateSummary.fiOtmBankModal.verifyBankAcNo ng-readonly=InitiateSummary.ecsReadOnly onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-pattern=InitiateSummary.fiOtmBankModal.bankAcNo required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Bank Account Number<span class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$dirty && InitiateSummary.fiOtmBankForm.verifyBankAcNo.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.minlength || !InitiateSummary.fiOtmBankForm.verifyBankAcNo.$error.required\" ng-bind=InitiateSummary.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=InitiateSummary.EcsBankForm.verifyBankAcNo.$error.pattern ng-bind=InitiateSummary.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=row ng-if=\"(InitiateSummary.isOtmEnabled )\"><div class=col-md-5><div class=input-normal><input type=text name=ifscCode ng-model=InitiateSummary.fiOtmBankModal.ifscCode ng-pattern=InitiateSummary.IFSC_REGEX maxlength=11 minlength=11 autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC/NEFT Code <span ng-if=\"InitiateSummary.selectedPaymentOption !=\'OTM\'\" class=req>*</span></label><span ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty && InitiateSummary.fiOtmBankForm.ifscCode.$invalid\"><span class=error-input ng-show=InitiateSummary.fiOtmBankForm.ifscCode.$error.required ng-bind=InitiateSummary.validateData.IFSC_CODE_REQUIRED></span> </span><span class=error-input ng-show=\"InitiateSummary.fiOtmBankForm.ifscCode.$dirty&&InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern || InitiateSummary.fiOtmBankForm.ifscCode.$error.pattern\" ng-bind=InitiateSummary.validateData.IFSC_CODE_REGEX></span></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omUmrn ng-model=InitiateSummary.fiOtmBankModal.omUmrn ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM UMRN Number</label></div></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-5><div class=input-normal><input type=text name=maxAmount ng-model=InitiateSummary.fiOtmBankModal.maxAmount ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Max Amount</label></div></div><div class=\"col-md-5 col-md-offset-1\"><div class=input-normal><input type=text name=omExpiryDate ng-model=InitiateSummary.fiOtmBankModal.omExpiryDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Expiry Date</label></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-5><div class=input-normal><input type=text name=omStartDateForFi ng-model=InitiateSummary.fiOtmBankModal.omStartDate ng-readonly=InitiateSummary.ecsReadOnly autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>OTM Start Date</label></div></div></div><div class=row ng-if=(InitiateSummary.isOtmEnabled)><div class=col-md-4 ng-if=\"InitiateSummary.fiOtmBankData && !InitiateSummary.fiOtmBankData.bankAcType\"><div class=\"selectfield selectionIcon\" ng-class=\"{error:InitiateSummary.fiOtmBankForm.accountType.$dirty && InitiateSummary.fiOtmBankForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateSummary.fibankData.accType ng-options=\"bank.accountTypeCode as bank.accountType for bank in InitiateSummary.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><label ng-if=InitiateSummary.fibankData.accType>Account Type</label><span class=\"req text-red\">*</span> <span class=error-input ng-messages=InitiateSummary.fiOtmBankForm.accountType.$error ng-show=InitiateSummary.fiOtmBankForm.accountType.$dirty><span ng-message=required ng-bind=InitiateSummary.VALIDATE_DATA.ACCOUNT_TYPE_REQUIRED></span></span></div></div></div></div></form><!-- UPI For FI --><div class=row ng-if=false ng-class=\"{\'anything-disabled\': InitiateSummary.selectedPaymentOptionForFI ==\'UPI\'}\"><div class=col-md-3><div class=selectfield style=\"margin-bottom: 0px\"><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-options=\"bank as bank.bankName for bank in InitiateSummary.bankList\" ng-model=InitiateSummary.fiBankdata ng-change=InitiateSummary.changedUPIBank()><option value=\"\" selected>Select Bank</option><!--<option ng-repeat=\"bank in InitiateSummary.bankList\" value=\"{{bank}}\">{{bank.bankName}}</option>--></select></div></div></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'HEM\' && InitiateSummary.emandateEnabled\"><!--dynamic content for Emandate--><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandate.content ng-if=\"InitiateSummary.authModeSelect.value !== \'DEBIT_CARD\'\"></ng-bind-html><ng-bind-html dynamic=InitiateSummary.dynamicNoteEmandateDebitCard.content ng-if=\"InitiateSummary.authModeSelect.value === \'DEBIT_CARD\'\"></ng-bind-html></div><div ng-if=\" (InitiateSummary.summaryDetails.distributorDetails.transactionType == \'SIP\' || InitiateSummary.summaryDetails.distributorDetails.transactionType == \'DREAMSIP\') && InitiateSummary.selectedPaymentOption == \'UPI\' && !InitiateSummary.selectedPaymentOptionForFI \"><!--dynamic content for UPI--><ng-bind-html dynamic=InitiateSummary.dynamicNoteSIPUPI.content></ng-bind-html></div><div class=\"point-to-note-tpv-approval ng-scope\" ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && !InitiateSummary.selectedPaymentOptionForFI \"><!--dynamic content for OTM--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOtm.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && !InitiateSummary.selectedPaymentOptionForFI \"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteGeneral.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && InitiateSummary.selectedPaymentOptionForFI ==\'WEB\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteSIWEB.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'EC\' && InitiateSummary.selectedPaymentOptionForFI==\'OTM\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteSIOTM.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI==\'OTM\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOTMOTM.content></ng-bind-html></div><div ng-if=\"InitiateSummary.selectedPaymentOption == \'OTM\' && InitiateSummary.selectedPaymentOptionForFI==\'WEB\'\"><!--dynamic content for Standard--><ng-bind-html dynamic=InitiateSummary.dynamicNoteOTMWEB.content></ng-bind-html></div><div class=\"terms-condition form-group declaration\"><h6>Declaration :</h6><span class=checkbox><input id=declaration type=checkbox name=declartaion ng-model=InitiateSummary.ischecked required> <span class=icon-checkbox></span></span><label for=declaration class=\"checkbox-text tnc\">I hereby declare that the funds transferred are from a bank account where the first/sole unit holder is one of the bank account holders.</label></div><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><hr><div class=\"terms-condition form-group\" ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\' && InitiateSummary.showTerms\"><span class=checkbox><input id=tcsCheckboxEMandate type=checkbox name=termsAndConditionsEMandate ng-model=InitiateSummary.termsAndConditionsEMandate required> <span class=icon-checkbox></span></span><label for=tcsCheckboxEMandate class=\"checkbox-text tnc\">I have read and understood <a href=javascript:void(0) ng-click=InitiateSummary.termsAndConditionsEMandateModal()>Terms &amp; Conditions</a> of e-mandate (eOTM)</label></div><hr><form autocomplete=off name=billdeskForm id=billdeskForm method=POST enctype=application/x-www-form-urlencoded action={{InitiateSummary.purchaseBillDeskUrl}}><input id=hidRequestId type=hidden name=hidRequestId ng-value=InitiateSummary.billdeskPayload.hidRequestId> <input id=hidOperation type=hidden name=hidOperation ng-value=InitiateSummary.billdeskPayload.hidOperation> <input id=msg type=hidden name=msg ng-value=InitiateSummary.billdeskPayload.msg></form></div></div></section><section class=buttons-block><div class=\"pull-left rights-reserved\"><p>{{InitiateSummary.date | date:\'yyyy\'}} HDFC Asset Management Company Ltd. All Rights Reserved</p></div><div class=\"email-block-button pull-right\" ng-if=\"(InitiateSummary.summaryType==\'SIP\' || InitiateSummary.summaryDetails.summaryType===\'SIP_TOPUP\') && !InitiateSummary.isActionPerformed\"><button type=button class=\"btn btn-negative-action\" ng-click=InitiateSummary.viewLater()>View Later</button> <button type=button class=\"btn btn-negative-action\" ng-disabled=\"InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\" ng-click=InitiateSummary.rejectTransaction()>Reject</button> <button ng-if=\"InitiateSummary.selectedPaymentOption !=\'EC\' && InitiateSummary.selectedPaymentOption !=\'HEM\' && InitiateSummary.selectedPaymentOption != \'UPI\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.ecsBankModal.bankName\n              || ((InitiateSummary.selectedPaymentOption !==\'OTM\') && (!InitiateSummary.ecsBankModal.bankBranch || !InitiateSummary.ecsBankModal.bankCity))\n              ||  InitiateSummary.otmLimitValidation\n              ||  InitiateSummary.endDateValidation\n              || !InitiateSummary.ecsBankModal.bankAcNo || !InitiateSummary.ecsBankModal.verifyBankAcNo\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\n              ||  (InitiateSummary.summaryDetails.payMech === \'OTM\'\n                              && InitiateSummary.otmBankData.otmFrequency != \'AWP\'\n                              && InitiateSummary.summaryDetails.sipFrequency === \'Daily\') || (InitiateSummary.selectedPaymentOption ==\'OTM\' && !InitiateSummary.ecsBankModal.ifscCode) || !InitiateSummary.ecsBankModal.bankAcType || !InitiateSummary.ecsBankModal.ifscCode || (InitiateSummary.selectedPaymentOptionForFI==\'WEB\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiBankdata)\n              || (InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiOtmBankData) || InitiateSummary.FInetbanking.$invalid || InitiateSummary.fiOtmBankForm.$invalid || InitiateSummary.EcsBankForm.$invalid || InitiateSummary.fiEndDateValidation || InitiateSummary.fiOtmLimitValidation || InitiateSummary.startDateValidation || InitiateSummary.startDateValidationForFi\">Approve Transaction</button> <button ng-if=\"InitiateSummary.selectedPaymentOption ==\'HEM\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.bankdata || !InitiateSummary.authModeSelect\n              || !InitiateSummary.termaAndConditions || !InitiateSummary.termsAndConditionsEMandate || (InitiateSummary.isEmandateMaxLimit < InitiateSummary.amount) || InitiateSummary.startDateValidation || InitiateSummary.startDateValidationForFi || InitiateSummary.fiOtmBankForm.$invalid || InitiateSummary.amountLess || InitiateSummary.amountMore || InitiateSummary.isLessThanSipAmount || InitiateSummary.sipDateLessEmandate\">Approve Transaction</button> <button ng-if=\"InitiateSummary.selectedPaymentOption ==\'EC\'\" type=submit class=\"btn btn-primary-action\" ng-click=InitiateSummary.approveTransaction() ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.ecsBankModal.bankName\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\n              ||  (InitiateSummary.summaryDetails.payMech === \'OTM\'\n                              && InitiateSummary.otmBankData.otmFrequency != \'AWP\'\n                              && InitiateSummary.summaryDetails.sipFrequency === \'Daily\') || !InitiateSummary.ecsBankModal.bankAcType || (InitiateSummary.selectedPaymentOption ==\'EC\' && !InitiateSummary.ecsBankModal.ifscCode) || (InitiateSummary.selectedPaymentOptionForFI==\'WEB\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiBankdata)\n              || (InitiateSummary.selectedPaymentOptionForFI==\'OTM\' && InitiateSummary.summaryDetails.sipWithFirstInstallment && !InitiateSummary.fiOtmBankData) || InitiateSummary.FInetbanking.$invalid || InitiateSummary.fiOtmBankForm.$invalid || InitiateSummary.fiEndDateValidation || InitiateSummary.fiOtmLimitValidation || InitiateSummary.startDateValidation || InitiateSummary.startDateValidationForFi\">Approve Transaction</button> <button type=submit ng-if=\"InitiateSummary.selectedPaymentOption == \'UPI\'\" class=\"btn btn-primary-action\" ng-disabled=\"!InitiateSummary.ischecked || InitiateSummary.isActionPerformed || !InitiateSummary.termaAndConditions\n      || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj && (!InitiateSummary.purchaseBankModal.ifscCode )))\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && InitiateSummary.bankdata == null )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && !InitiateSummary.isUPIVerified )\n      || (InitiateSummary.selectedPaymentOption == \'UPI\' && (InitiateSummary.ecsBankModal.bankAcType && !InitiateSummary.ecsBankModal.bankAcType)) ||(InitiateSummary.selectedPaymentOption == \'UPI\' && (!InitiateSummary.bankdata.ifscCode && !InitiateSummary.ecsBankModal.ifscCode))\" ng-click=InitiateSummary.approveTransaction()>Approve Transaction</button><!--<button class=\"btn btn-primary-action\"  ng-click=\"InitiateSummary.approveTransaction()\" >Approve Transaction</button>--></div></section></div><style>.terms-condition h6{\n    padding-bottom: 10px;\n    font-size: 14px;\n    text-decoration: underline;\n  }\n  .option{\n    padding-left: 0;\n    color: #242424;\n    font-size: 1em;\n    width: 15%;\n    padding-right: 1.2em;\n  }\n  @media only screen and (max-width: 767px){\n    .option{\n      width: 50%;\n    }\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/summary.sipPause.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a <span ng-if=\"InitiateSummary.summaryDetails.transactionType == \'DREAMSIP\' \">DREAM</span> SIP Pause request for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Cancellation Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>Distributor Code:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.transactionType}}</td></tr></table></div><div class=email-block><!--<p class=\"email-block-header\">Scheme Transferring From</p>--><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.sipRegistrationNumber><td>SIP Registeration Number:</td><td>{{InitiateSummary.summaryDetails.sipRegistrationNumber}}</td></tr><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.folioNumber}}</td></tr><tr><td>CAMS Transaction number:</td><td>{{InitiateSummary.summaryDetails.camsRefNo}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.schemeName}}</td></tr><tr><td>From Date:</td><td>{{InitiateSummary.summaryDetails.startDate}}</td></tr><tr><td>To Date:</td><td>{{InitiateSummary.summaryDetails.endDate}}</td></tr><tr><td>Number of Installments:</td><td>{{InitiateSummary.summaryDetails.installments}}</td></tr><tr><td>Frequency:</td><td>{{InitiateSummary.summaryDetails.frequency}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.amount><td>Amount:</td><td><i ng-if=\"InitiateSummary.summaryDetails.amount > 0\" class=rupee-grey-icon></i>{{(InitiateSummary.summaryDetails.amount > 0)?InitiateSummary.summaryDetails.amount:\'NA\'}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.frequency===\'Monthly\'\"><td>Number Of Installment To Be Paused:</td><td><select ng-model=InitiateSummary.noOfInstallment ng-click=InitiateSummary.changeInstallment() ng-class=\"{ \'div-disabled\': InitiateSummary.actionHappened}\"><option value=no-value>Select Number Of Installment</option><option ng-repeat=\"item in InitiateSummary.noOfInstallmentList\" ng-init=\"InitiateSummary.noOfInstallment = InitiateSummary.noOfInstallment ? InitiateSummary.noOfInstallment :InitiateSummary.summaryDetails.installmentsPaused\" selected>{{item}}</option></select></td></tr><td>Pause Start Date:</td><td><div class=\"row borderline\"><div class=\"col-md-7 row\" style=\"margin: 0\"><div class=form-group ng-if=!Transaction.isReseting><div style=\"padding: 0;margin: 0\" class=\"input-normal verify-acc input-group date date-picker transaction-cal\" ng-class=\"{ \'div-disabled\': InitiateSummary.noOfInstallment == \'no-value\'}\" date-calendar format=DD-MMM-YYYY data-viewmode=days data-date-default=InitiateSummary.endDate data-enabled-dates=InitiateSummary.enabledEndDates data-view-date=InitiateSummary.enabledEndDateView data-min-date=InitiateSummary.enabledEndDates[0] data-max-date=InitiateSummary.maxEndDate data-on-date-change=InitiateSummary.changeStartDate data-enable=true id=endDate-OTM showdefault=false><!-- data-min-date=\"Transaction.formData.minEndDate\"--> <input type=text name=endDate autocomplete=off placeholder={{InitiateSummary.summaryDetails.pauseStartDate}} readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span><label ng-if=Transaction.formData.endDate>Start Date - DD-MMM-YYYY</label><span class=bar></span> <span class=error-input ng-show=\"Transaction.tForm.day.$dirty && Transaction.tForm.day.$error.required\" ng-bind=Transaction.VALIDATE_DATA.MONTH_REQUIRED></span> <span class=error-input ng-show=Transaction.isOTMEndDate ng-bind=Transaction.VALIDATE_DATA.EXPIRY_DATE_VALIDATION_ERROR></span></div></div></div></div></td><tr><td>Pause SIP End Date:</td><td><div class=\"col-md-7 row\"><div class=\"input-select input-normal input-group date date-picker transaction-cal\" style=\"padding: 0;margin: 0\" ng-class=\"{error:Transaction.tForm.startDate.$dirty && Transaction.tForm.startDate.$invalid}\" date-calendar format=DD-MMM-YYYY data-date-default=InitiateSummary.SipPauseEndDate id=startDate-OTM data-enable=true data-on-date-change=InitiateSummary.changeEndDate style=\"position: relative\"><input type=text name=startDate placeholder={{InitiateSummary.summaryDetails.pauseEndDate}} readonly><label ng-if=Transaction.formData.startDate>End Date - DD-MMM-YYYY</label></div></div></td></tr></table></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=form-group><h6 style=padding-bottom:15px>Declaration :</h6><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><div class=email-block-button><!--<span ng-click=\"InitiateSummary.viewLater()\"\n            class=\"btn btn-negative-action\">View Later</span>--> <button ng-click=InitiateSummary.rejectTransactionForPAUSE() class=\"btn btn-negative-action\">Reject Pause</button> <button ng-disabled=\"InitiateSummary.noOfInstallment == \'no-value\' || !InitiateSummary.SipActionHappened || !InitiateSummary.termaAndConditions \" ng-click=InitiateSummary.approveTransactionForPAUSE() class=\"btn btn-primary-action\">Approve Pause</button></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.smart-swap.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType === \"SMART_SWAP\" ? \"SMART SWAP\" : InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Withdrawing From</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr><td>Total Current Value:</td><td class=voilet easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Locked Value:</td><td class=red easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Free Value:</td><td class=green easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit|unitValue}} )</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Withdrawal Options</p><table class=\"table borderless\"><tr><td>SMART SWAP Amount:</td><td>&#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.withDrawalAmount}}</td></tr><tr><td>SMART SWAP Amount in words:</td><td><div id=divDisplayWords></div></td></tr><tr><td>Frequency:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.frequency|frequency}}</td></tr><tr><td>% Percentage (per annum):</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.percentage}}</td></tr><tr><td>SMART SWAP Start Date:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.startDate}}</td></tr></table></div><!--TODO: Not enough details to implement--><div class=\"email-block bank-data\"><p class=email-block-header>Bank Details</p><div class=row><div class=col-md-5><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" ng-model=InitiateSummary.selectedBank ng-options=\"_bank as (_bank.bankName +\'(\'+ _bank.bankAcNo +\')\') for _bank in InitiateSummary.summaryDetails.accountList\" ng-change=InitiateSummary.checkMinorBankFlag() required><option value=\"\" selected>Select Bank</option></select></div></div></div><table class=\"table borderless\" ng-if=InitiateSummary.selectedBank><tr><td>Bank Name:</td><td>{{InitiateSummary.selectedBank.bankName}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.selectedBank.bankAcNo}}</td></tr><tr><td>Branch:</td><td>{{InitiateSummary.selectedBank.branchName?(InitiateSummary.selectedBank.branchName +\', \'+InitiateSummary.selectedBank.bankCity):InitiateSummary.selectedBank.bankCity}}</td></tr><tr><td>IFSC Code:</td><td>{{InitiateSummary.selectedBank.ifscCode}}</td></tr><tr><td>Payment Mode:</td><td>{{InitiateSummary.selectedBank.payMech}}</td></tr></table><div class=form-group><h6 style=padding-bottom:15px>Declaration :</h6><span class=checkbox><input id=tcCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required> <span class=icon-checkbox></span></span><label for=tcCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-click=InitiateSummary.approveTransactionForSWP_REDEMPTION() ng-disabled=\"!InitiateSummary.selectedBank || !InitiateSummary.termaAndConditions\" class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.stp.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType!==\'STPSWING\'\">{{InitiateSummary.summaryDetails.distributorDetails.transactionType==\'STPFLEX\'?\'Flex STP\':InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td><td ng-if=\"InitiateSummary.summaryDetails.distributorDetails.transactionType==\'STPSWING\'\">Swing STP</td></tr></table></div><div class=email-block ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode\"><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.subBrokerArn><td>Sub Broker ARN:</td><td>{{InitiateSummary.summaryDetails.subBrokerArn}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.subBrokerCode><td>Sub Broker Code:</td><td>{{InitiateSummary.summaryDetails.subBrokerCode}}</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Transferring From</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Existing Scheme:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr><td>Total Current Value:</td><td class=voilet easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueUnits}} Units (&#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Locked Value:</td><td class=red easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Free Value:</td><td class=green easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit|unitValue}} )</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Transferring Scheme:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.schemeName}}</td></tr><tr><td>Investment Option:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.investmentOption|investmentOption}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.stpTargetScheme.investmentOption!=\'GROWTH\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.dividendOption|dividendOption}}</td></tr><tr ng-if=\"InitiateSummary.summaryType!=\'STPFLEX\'\"><td>STP Type:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.stpType|schemetype}}</td></tr><tr><td>Payment Frequency:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.paymentFrequency|frequency}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.stpTargetScheme.stpType !== InitiateSummary.appConstants.TRANSACTION.CAPITAL_APPRECIATION\"><td>STP Amount:</td><td>&#x20B9; {{InitiateSummary.summaryDetails.stpTargetScheme.amount|unit:InitiateSummary.summaryDetails.stpTargetScheme.amountUnit}}{{InitiateSummary.summaryDetails.stpTargetScheme.amountUnit|unitValue}}</td></tr><tr><td>STP Start Date:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.startDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.stpTargetScheme.paymentFrequency !== \'DZ\'\"><td>STP End Date:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.endDate}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.stpTargetScheme.paymentFrequency == \'DZ\' || InitiateSummary.summaryDetails.stpTargetScheme.paymentFrequency == \'OW\'\"><td>No of Installments:</td><td>{{InitiateSummary.summaryDetails.stpTargetScheme.installments}}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><ng-bind-html dynamic=InitiateSummary.dynamicNoteStp.content></ng-bind-html></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><button ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</button> <button ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</button> <button ng-click=InitiateSummary.approveTransactionForSWITCH_STP_DTP_REDEEM() ng-disabled=\"InitiateSummary.isActionPerformed\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\" class=\"btn btn-primary-action\">Approve Transaction</button></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.switch.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><td>EUIN Number/Name:</td><td><span>{{InitiateSummary.summaryDetails.euinCode}}</span> <span ng-if=InitiateSummary.summaryDetails.euinCode&&InitiateSummary.summaryDetails.euinName>/</span> <span>{{InitiateSummary.summaryDetails.euinName}}</span></td></tr><tr ng-if=\"!InitiateSummary.summaryDetails.euinCode && !InitiateSummary.oversea_arn\"><td>EUIN Number:</td><!--Choose Option--><td class=euin-options><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=Y> <span class=check></span></span><label for=enterEuin>EUIN Number</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=euinOpted ng-model=InitiateSummary.summaryDetails.euinOpted value=N> <span class=check></span></span><label for=selfDeclaration>Self Declaration</label></div></div></td></tr><!--Input EUIN--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=input-euin><form name=euinObjForm class=euinObjForm><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error: (!InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted && euinObjForm.euinObj.$dirty)}\"><select class=\"browser-default custom-select\" name=euinObj ng-model=InitiateSummary.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateSummary.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=error-euin ng-show=\"euinObjForm.euinObj.$dirty && !InitiateSummary.euinObj && InitiateSummary.summaryDetails.euinOpted\"><span class=error-input>Please select euin</span> </span><span class=req>*</span></div></div></form></td></tr><!--Self Declaration--><tr ng-if=\"!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'N\' && !InitiateSummary.summaryDetails.euinCode)\"><td>&nbsp;</td><td class=self-declaration><div><span class=checkbox><input type=checkbox ng-model=InitiateSummary.selfEuin ng-checked=true name=selfEuin ng-disabled=true> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div><div class=email-block ng-if=\"InitiateSummary.summaryDetails.subBrokerArn || InitiateSummary.summaryDetails.subBrokerCode\"><p class=email-block-header>Sub Broker Details</p><table class=\"table borderless\"><tr ng-if=InitiateSummary.summaryDetails.subBrokerArn><td>Sub Broker ARN:</td><td>{{InitiateSummary.summaryDetails.subBrokerArn}}</td></tr><tr ng-if=InitiateSummary.summaryDetails.subBrokerCode><td>Sub Broker Code:</td><td>{{InitiateSummary.summaryDetails.subBrokerCode}}</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Transferring From</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Existing Scheme:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr><td>Total Current Value:</td><td class=voilet easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Locked Value:</td><td class=red easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Free Value:</td><td class=green easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit|unitValue}} )</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Transferring Scheme:</td><td>{{InitiateSummary.summaryDetails.targetScheme.schemeName}}</td></tr><tr><td>Investment Option:</td><td>{{InitiateSummary.summaryDetails.targetScheme.investmentOption|investmentOption}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.targetScheme.investmentOption.toUpperCase() !== \'GROWTH\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.targetScheme.dividendOption|dividendOption}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionMode!==\'ALL_UNITS\' && InitiateSummary.summaryDetails.transactionMode!==\'UNITS\'\"><td>Switch Amount:</td><td>&#x20B9; {{InitiateSummary.summaryDetails.targetScheme.amount}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.transactionMode ==\'UNITS\'||InitiateSummary.summaryDetails.transactionMode ==\'ALL_UNITS\'\"><td>Switch Units:</td><td>{{InitiateSummary.summaryDetails.transactionMode===\'ALL_UNITS\' ?\'All Free Units\' : InitiateSummary.summaryDetails.targetScheme.units}}</td></tr></table></div><div class=email-block ng-if=InitiateSummary.summaryDetails.checkedNfoAutoSwitch><p class=email-block-header>Auto Switch Scheme to Transfer in</p><table class=\"table borderless\"><tr><td>Auto Switch On Maturity:</td><td>{{InitiateSummary.summaryDetails.checkedNfoAutoSwitch?\'Yes\':\'No\'}}</td></tr><tr><td>Scheme Name:</td><td>{{InitiateSummary.summaryDetails.autoSwitchScheme}}</td></tr><tr ng-if=\"InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption!=\'Z\'\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option:</td><td>{{InitiateSummary.summaryDetails.autoSwitchSchemeDividendOption==\'Y\'?\'Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option\':\'Payout of Income Distribution cum Capital Withdrawal (IDCW) Option\'}}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div><ng-bind-html dynamic=InitiateSummary.dynamicNoteSwitch.content></ng-bind-html></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><button ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</button> <button ng-disabled=InitiateSummary.isActionPerformed ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</button> <button ng-click=InitiateSummary.approveTransactionForSWITCH_STP_DTP_REDEEM() ng-disabled=\"InitiateSummary.isActionPerformed\n              || !InitiateSummary.termaAndConditions\n              || (!InitiateSummary.oversea_arn && (InitiateSummary.summaryDetails.euinOpted == \'Y\' && !InitiateSummary.euinObj))\" class=\"btn btn-primary-action\">Approve Transaction</button></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary.swp.html","<header><div class=logo><img src=../../../assets/images/logo.png></div></header><section><div class=content-header><h5 class=text-capitalize><span>Dear</span> {{InitiateSummary.summaryDetails.investorName}}</h5><p>{{InitiateSummary.summaryDetails.distributorDetails.name}} has initiated a transaction for you which requires your approval to proceed.</p></div><div class=email-block><p class=email-block-header>Distributor Details</p><table class=\"table borderless\"><tr><td>Transaction Initiated by:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.name}}</td></tr><tr><td>ARN Number:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.arnNo}}</td></tr><tr><td>Transaction Type:</td><td>{{InitiateSummary.summaryDetails.distributorDetails.transactionType}}</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Withdrawing From</p><table class=\"table borderless\"><tr><td>Folio Number:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.folioNumber}}</td></tr><tr><td>Existing Scheme:</td><td>{{InitiateSummary.summaryDetails.sourceScheme.schemeName}}</td></tr><tr><td>Total Current Value:</td><td class=voilet easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.totalCurrentValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Locked Value:</td><td class=red easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.lockedValueAmountUnit|unitValue}} )</td></tr><tr><td>Total Free Value:</td><td class=green easyassist-key=mask-element>{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueUnits}} Units ( &#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmount|unit:InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.valuesDTO.freeValueAmountUnit|unitValue}} )</td></tr><tr><td>Withdrawal Amount:</td><td>&#x20B9; {{InitiateSummary.summaryDetails.sourceScheme.withDrawalAmount|unit:InitiateSummary.summaryDetails.sourceScheme.withDrawalAmountUnit}}{{InitiateSummary.summaryDetails.sourceScheme.withDrawalAmountUnit|unitValue}}</td></tr></table></div><div class=email-block><p class=email-block-header>Scheme Withdrawal Options</p><table class=\"table borderless\"><tr><td>SWP Type:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.swpType|schemetype}}</td></tr><tr><td>Frequency:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.frequency|frequency}}</td></tr><tr><td>Start Date:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.startDate}}</td></tr><tr><td>End Date:</td><td>{{InitiateSummary.summaryDetails.swpWithdrawalOptions.endDate}}</td></tr></table></div><!--TODO: Not enough details to implement--><div class=\"email-block bank-data\"><p class=email-block-header>Bank Details</p><div class=row><div class=col-md-5><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" ng-model=InitiateSummary.selectedBank ng-options=\"_bank as (_bank.bankName +\'(\'+ _bank.bankAcNo +\')\') for _bank in InitiateSummary.summaryDetails.accountList\" ng-change=InitiateSummary.checkMinorBankFlag() required><option value=\"\" selected>Select Bank</option></select></div></div></div><table class=\"table borderless\" ng-if=InitiateSummary.selectedBank><tr><td>Bank Name:</td><td>{{InitiateSummary.selectedBank.bankName}}</td></tr><tr><td>Account Number:</td><td easyassist-key=mask-element>{{InitiateSummary.selectedBank.bankAcNo}}</td></tr><tr><td>Branch:</td><td>{{InitiateSummary.selectedBank.branchName?(InitiateSummary.selectedBank.branchName +\', \'+InitiateSummary.selectedBank.bankCity):InitiateSummary.selectedBank.bankCity}}</td></tr><tr><td>IFSC Code:</td><td>{{InitiateSummary.selectedBank.ifscCode}}</td></tr><tr><td>Payment Mode:</td><td>{{InitiateSummary.selectedBank.payMech}}</td></tr></table></div><div class=email-block style=margin-top:0px;padding-top:0px><h6 style=\"padding-bottom: 15px\">Declaration :</h6><hr><div class=\"terms-condition form-group\"><span class=checkbox><input id=tcsCheckbox type=checkbox name=termaAndConditions ng-model=InitiateSummary.termaAndConditions required class=\"ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" aria-invalid=true> <span class=icon-checkbox></span></span><label for=tcsCheckbox class=\"checkbox-text tnc\">I hereby agree to have read, understood and accept the <a href={{InitiateSummary.tncURL}} target=_blank>Terms &amp; Conditions.</a> that are corresponding to the transaction that I have chosen to undertake.</label></div></div><div ng-if=!InitiateSummary.isActionPerformed class=email-block><div class=email-block-button><span ng-click=InitiateSummary.viewLater() class=\"btn btn-negative-action\">View Later</span> <span ng-click=InitiateSummary.rejectTransaction() class=\"btn btn-negative-action\">Reject Transaction</span> <span ng-click=InitiateSummary.approveTransactionForSWP_REDEMPTION() ng-disabled=\"!InitiateSummary.selectedBank || !InitiateSummary.termaAndConditions\" class=\"btn btn-primary-action\">Approve Transaction</span></div></div></section>");
$templateCache.put("app/transactions/initiate/summary/summary_success.html","<!--<header style=\"background-color: #103880;>--><!--<div class=\"logo\">--><!--<img src=\"../../../assets/images/logo-main.png\" style=\"max-height: 30px; padding-right: 20px;\">--><!--<img src=\"../../../assets/images/logo.png\" style=\"max-height: 30px;\">--><!--</div>--><!--</header>--><!--<section style=\"background-color: #e5e5e5; padding: 20px;\">--><!--<div>--><!--<h5 style=\"text-transform: uppercase;\"><span style=\"text-transform: capitalize;\">Dear</span> Aakash Sharma </h5>--><!--<p style=\"font-weight: 700; margin: 10px 0;\">Tejas Consultant has initiated a transaction for you which requires your approval to proceed. </p>--><!--</div>--><!--<div style=\"background-color: #ffffff; box-shadow: 0px 2px 4px rgba(4, 4, 4, 0.13);\">--><!--<h4 style=\"padding: 20px;\">Payment Summary</h4>--><!--<hr/>--><!--<p style=\"margin: 20px;\">Thankyou for making Payment. The details are as follows :</p>--><!--<table style=\"border-collapse: collapse; border-spacing: 0; margin-bottom: 20px;\">--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Bill No. :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">12345</td>--><!--</tr>--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Name of Bank :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">ICICI Bank</td>--><!--</tr>--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Scheme Name :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">HDFC Tax Saver Fund</td>--><!--</tr>--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Investment Type :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">Lumpsum</td>--><!--</tr>--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Investment Amount :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">50,000</td>--><!--</tr>--><!--<tr>--><!--<td style=\"font-size: 0.875em; color: #404040; padding-left: 20px; padding-bottom: 10px;\">Investment Start Date :</td>--><!--<td style=\"font-size: 0.875em; color: #404040;\">24/12/2016</td>--><!--</tr>--><!--</table>--><!--&lt;!&ndash;<hr/>&ndash;&gt;--><!--&lt;!&ndash;<button style=\"border-radius: 4px; background-image: -webkit-linear-gradient(top, #0d41a1, #083280), -webkit-linear-gradient(#6d5cae, #6d5cae); background-image: linear-gradient(to bottom, #0d41a1, #083280), linear-gradient(#6d5cae, #6d5cae); box-shadow: 0px 1px 10px 0 rgba(17, 17, 19, 0.25); border: solid 1px #1f3b71; color: #fff; padding: 10px 20px; float: right; margin: 20px;\">Ok</button>&ndash;&gt;--><!--</div>--> <!--</section>-->");
$templateCache.put("app/components/modal/kyc/ekyc/kyc.modal.html","<div class=modal-content id=register-done><div class=\"modal-body ekyc-success\"><div class=text-center><i class=verify-icon></i><div>Submitted successfully</div></div><p class=text-center>Email to complete eKYC sent to {{Modal.modalData.investorName}}</p><button class=\"btn btn-primary-action\" ng-click=Modal.closeModal()>OK</button></div></div>");
$templateCache.put("app/components/modal/kyc/kycInitiate/kycInitiate.modal.html","<div class=modal-content id=register-done><div class=modal-body><form autocomplete=off name=Modal.investorForm class=kyc-initiate-modal novalidate><p class=text-center>Investor\'s KYC is not complete. Please provide below details and click \'Yes\' button to send email to investor with instructions to complete eKYC process.</p><div class=\"input-select input-normal\" ng-class=\"{error:Modal.investorForm.name.$dirty && Modal.investorForm.name.$invalid}\"><input type=text name=name ng-model=Modal.formData.name capitalize required> <span class=error-input ng-show=\"Modal.investorForm.name.$touched && Modal.investorForm.name.$error.required\" ng-bind=Modal.validateData.INVESTOR_NAME_REQUIRED></span> <span class=highlight></span> <span class=bar></span><label>Investor\'s Name<span class=req>*</span></label></div><div class=\"input-select input-normal\" ng-class=\"{error:Modal.investorForm.email.$dirty && Modal.investorForm.email.$invalid}\"><input type=email name=email ng-model=Modal.formData.email ng-pattern=Modal.AppConstants.email_regex required> <span ng-show=\"Modal.investorForm.email.$touched && Modal.investorForm.email.$invalid\"><span class=error-input ng-show=\"Modal.investorForm.email.$touched && Modal.investorForm.email.$error.required\" ng-bind=Modal.validateData.EMAIL_REQUIRED></span> <span class=error-input ng-show=Modal.investorForm.email.$error.pattern ng-bind=Modal.validateData.EMAIL_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>Email ID<span class=req>*</span></label></div><div class=\"input-select input-normal\" ng-class=\"{error:Modal.investorForm.mobile.$dirty && Modal.investorForm.mobile.$invalid}\"><input type=text name=mobile ng-model=Modal.formData.mobile ng-maxlength=10 ng-minlength=10 required> <span ng-show=\"Modal.investorForm.mobile.$touched && Modal.investorForm.mobile.$invalid\"><span class=error-input ng-show=\"Modal.investorForm.mobile.$touched && Modal.investorForm.mobile.$error.required\" ng-bind=Modal.validateData.MOBILE_REQUIRED></span> <span class=error-input ng-show=Modal.investorForm.mobile.$error.maxlength ng-bind=Modal.validateData.MOBILE_FIELD></span> <span class=error-input ng-show=Modal.investorForm.mobile.$error.minlength ng-bind=Modal.validateData.MOBILE_FIELD></span> </span><span class=highlight></span> <span class=bar></span><label>Mobile Number<span class=req>*</span></label></div><div class=action-section><button ng-disabled=Modal.investorForm.$invalid ng-click=Modal.submitValue() class=\"btn btn-primary-action\">Yes</button> <button ng-click=Modal.closeModal() class=\"btn btn-primary-action\">Not Now</button></div></form><div class=note><p><span>NOTE:</span> E-KYC process is applicable for Resident individuals of Indian Nationality only.</p></div></div></div>");
$templateCache.put("app/components/modal/kyc/nonKyc/nonKyc.modal.html","<div class=modal-content id=register-done><i class=times-icon ng-click=Modal.dismissModal();></i><div class=modal-body><form autocomplete=off class=non-kyc><p class=text-center ng-if=!Modal.modalData.showHtml>{{Modal.modalData.text}}</p><ng-bind-html ng-if=Modal.modalData.showHtml dynamic=Modal.modalData.text></ng-bind-html><div class=text-center><button ng-click=\"Modal.closeModal(\'login\')\" class=\"btn btn-primary-action buttonStylingModal\">{{Modal.modalData.buttonText}}</button></div></form></div></div>");
$templateCache.put("app/components/modal/termcondition/transaction-tnc/termsAndConditionFlexSip.modal.html","<!--dynamic terms and condition sip--><ng-bind-html dynamic=Modal.dynamicTermsFlexSip.content></ng-bind-html><!--mobile terms and condition for sip--><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }\n  .nuture-order-list {\n    list-style-type: decimal;\n    padding-left: 35px;\n    margin-bottom: 30px;\n  }\n  .nuture-order-list > li {\n    padding: 5px 0;\n  }\n  .nuture-clauses p {\n    margin-bottom: 20px !important;\n    line-height: 1.3;\n  }\n  .nuture-tnc a{\n    text-decoration: underline !important;\n    font-size: 14px !important;\n    color: #337ab7 !important;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/transaction-tnc/termsAndConditionSip.modal.html","<!--dynamic terms and condition sip--><ng-bind-html dynamic=Modal.dynamicTermsSip.content></ng-bind-html><!--mobile terms and condition for sip--><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }\n  .nuture-order-list {\n    list-style-type: decimal;\n    padding-left: 35px;\n    margin-bottom: 30px;\n  }\n  .nuture-order-list > li {\n    padding: 5px 0;\n  }\n  .nuture-clauses p {\n    margin-bottom: 20px !important;\n    line-height: 1.3;\n  }\n  .nuture-tnc a{\n    text-decoration: underline !important;\n    font-size: 14px !important;\n    color: #337ab7 !important;\n  }</style>");
$templateCache.put("app/components/modal/termcondition/transaction-tnc/termsAndConditionSipModifyOtm.modal.html","<!--dynamic terms and condition sip--><ng-bind-html dynamic=Modal.dynamicTermsSipModiyOtm.content></ng-bind-html><!--mobile terms and condition for sip--><ng-bind-html dynamic=TermsCondition.content></ng-bind-html><style>.bold-numeric-list{\n    list-style-type: decimal;\n    padding-left: 15px;\n    font-weight: bold;\n    color: #242424;\n  }\n  .bold-numeric-list p{\n    color:#888;\n  }\n  .bold-numeric-list ul {\n    counter-reset: list;\n    margin-left: 20px;\n  }\n  .bold-numeric-list ul > li {\n    list-style: none;\n    position: relative;\n  }\n  .bold-numeric-list ul > li:before {\n    counter-increment: list;\n    content: counter(list, lower-alpha) \") \";\n    position: absolute;\n    left: -1.4em;\n  }\n  .nuture-order-list {\n    list-style-type: decimal;\n    padding-left: 35px;\n    margin-bottom: 30px;\n  }\n  .nuture-order-list > li {\n    padding: 5px 0;\n  }\n  .nuture-clauses p {\n    margin-bottom: 20px !important;\n    line-height: 1.3;\n  }\n  .nuture-tnc a{\n    text-decoration: underline !important;\n    font-size: 14px !important;\n    color: #337ab7 !important;\n  }</style>");
$templateCache.put("app/components/modal/transactionReview/directive/updateEmail.html","<form autocomplete=off class=update-email name=changeEmail style=\"display: contents\" novalidate><table style=\"margin: -19px 0 0 0\"><tr ng-if=currEmail><td>Email ID:</td><td ng-if=!isEdit class=\"grid-control edit-emailmobile-block\"><span easyassist-key=mask-element ng-bind=currEmail></span><!--      <i class=\"edit2-icon\" ng-click=\"makeEdit();\" ng-if=\"!cFlag\"></i>--></td><td ng-if=isEdit ng-class=\"{\'fix-width\': isOTPSent }\"><input easyassist-key=mask-element type=email name=newEmail ng-model=change.newEmailId placeholder=\"Enter New Email\" ng-pattern=AppConstants.email_regex maxlength=150 ng-disabled=isOTPSent style=width:150px> <span ng-if=isOTPSent class=forgot><timer countdown=AppConstants.RESEND_OTP_COUNTER interval=1000><input type=button class=\"btn-small btn-primary-action\" value=\"Resend OTP\" ng-disabled=\"countdown > 0\" ng-click=reSendOTP()> <span ng-show=\"countdown != 0\" style=\"display: flex\">Resend OTP in {{countdown}}s</span></timer></span><span class=btn-block ng-show=\"changeEmail.newEmail.$dirty && changeEmail.newEmail.$invalid\"><span class=error-input ng-show=\"changeEmail.newEmail.$error.pattern && changeEmail.newEmail.$invalid\" style=\"color:#d92018;font-size: 12px\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD }}</span></span></td></tr><tr ng-if=isEdit><td style=\"width: 150px; padding-right: 5px\">Email Id Belongs To</td><td><select name=emailBelongsTo style=\"width: 100px !important; height: 23px\" ng-init=\"change.emailBelongsTo = change.emailBelongsTo ? change.emailBelongsTo : null\" ng-model=change.emailBelongsTo ng-options=\"email.familyCode as email.familyDescription for email in emailList\" required><option value=\"\" selected>Select Value</option></select><div><input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=\"Send OTP\" ng-disabled=\"change.newEmailId==currEmail || changeEmail.newEmail.$error.pattern||isOTPSent || !change.emailBelongsTo\" ng-click=sendOTP()> <button ng-if=!isOTPSent type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button></div></td></tr><tr ng-if=isOTPSent><td colspan=2 class=update-contact-text style=\"padding-left: 10px !important\">{{ sendOtpRespMessage || \'We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.\'}}</td></tr><tr ng-if=isOTPSent><td colspan=2><input type=text easyassist-key=mask-element class=\"update-contact-review update-input-otp\" maxlength=6 ignore-mouse-wheel placeholder=\"Enter OTP 1\" ng-model=change.checkOTP style=\"width: 90%\"><br><span class=update-contact-text>OTP 1 sent to your registered email ID (<span easyassist-key=mask-element>{{currEmail}}</span>) and mobile number ( <span easyassist-key=mask-element ng-if=currMobileNumber>{{currMobileNumber}}</span> <span ng-if=!currMobileNumber>Not Available</span>).</span><br><input type=text easyassist-key=mask-element class=\"update-contact-review update-input-otp\" maxlength=6 ignore-mouse-wheel placeholder=\"Enter OTP 2\" ng-model=change.checkNewOTP style=\"width: 90%\"><br><span class=update-contact-text>OTP 2 sent to new email ID (<span easyassist-key=mask-element>{{change.newEmailId}}</span>) entered.</span><br><input type=button style=\"margin-top: 10px\" class=\"btn-small btn-primary-action\" value=Confirm ng-disabled=\"change.checkOTP == undefined||change.checkOTP.toString().split(\'\').length!==6 || change.checkNewOTP == undefined||change.checkNewOTP.toString().split(\'\').length!==6\" ng-click=verifyOTP();> <input type=button class=\"btn-small btn-secondary-action\" value=Cancel ng-click=cancelEdit();></td></tr></table></form>");
$templateCache.put("app/components/modal/transactionReview/directive/updateFolioEmail.html","<form autocomplete=off class=update-email name=changeEmail style=\"margin-top: 0px\" novalidate><table class=table-data><tr ng-if=currEmail><td style=\"width: 150px\">Email ID</td><td style=\"width: 4px\">:</td><td ng-if=!isEdit><span easyassist-key=mask-element ng-bind=currEmail></span> <i class=edit2-icon ng-click=makeEdit(); ng-if=!cFlag></i></td><td ng-if=isEdit><input easyassist-key=mask-element type=email name=newEmail ng-model=change.newEmailId placeholder=\"Enter New Email\" ng-pattern=AppConstants.email_regex maxlength=150 ng-disabled=isOTPSent> <span class=btn-block ng-show=\"changeEmail.newEmail.$dirty && changeEmail.newEmail.$invalid\"><span class=error-input ng-show=\"changeEmail.newEmail.$error.pattern && changeEmail.newEmail.$invalid\" style=\"color:#d92018;font-size: 12px\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD }}</span></span></td></tr><tr ng-if=isEdit><td style=\"width: 150px\">Email Id Belongs To</td><td style=\"width: 4px\">:</td><td><select name=emailBelongsTo style=\"margin-bottom: 20px; height: 23px\" ng-init=\"change.emailBelongsTo = change.emailBelongsTo ? change.emailBelongsTo : null\" ng-model=change.emailBelongsTo ng-options=\"email.familyCode as email.familyDescription for email in emailList\" required><option value=\"\" selected>Select Value</option></select><div style=\"display: flex\"><input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=\"Send OTP\" ng-disabled=\"change.newEmailId==currEmail || !change.newEmailId || changeEmail.newEmail.$error.pattern || isOTPSent || !change.emailBelongsTo\" ng-click=\"sendOTP(\'folio\')\"> <button type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button></div></td></tr></table></form>");
$templateCache.put("app/components/modal/transactionReview/directive/updateFolioMobile.html","<form autocomplete=off class=update-mobile name=changeMobile style=\"margin-top: 0px\" novalidate><table class=table-data><tr ng-if=currMobileNumber><td style=\"width: 150px\">Mobile No</td><td style=\"width: 4px\">:</td><td ng-if=!isEdit><span easyassist-key=mask-element ng-bind=currMobileNumber></span> <i class=edit2-icon ng-click=makeEdit(); ng-if=!cFlag></i></td><td ng-if=isEdit><input easyassist-key=mask-element type=text name=mobileNumber id=mobileNumberId ng-model=change.newMobileNumber ng-pattern=AppConstants.mobile_regex required minlength=10 maxlength=13 ng-disabled=isOTPSent ng-change=changeMobileNumber()> <span class=btn-block><span class=error-input ng-show=\"(changeMobile.mobileNumber.$error.pattern && changeMobile.mobileNumber.$invalid) || !isValid || isMobileNotValid\" style=\"color:#d92018;font-size: 12px\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.MOBILE_ISD }}</span></span></td></tr><tr ng-if=isEdit><td style=\"width: 150px\">Mobile No. Belongs To</td><td style=\"width: 4px\">:</td><td><select name=mobileBelongsTo style=\"margin-bottom: 20px; height: 23px\" ng-init=\"change.mobileBelongsTo = change.mobileBelongsTo ? change.mobileBelongsTo : null\" ng-model=change.mobileBelongsTo ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in mobileList\" required><option value=\"\" selected>Select Value</option></select><div style=\"display: flex\"><input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=\"Send OTP\" ng-disabled=\"change.newMobileNumber===currMobileNumber\n               || changeMobile.mobileNumber.$error.pattern\n               || changeMobile.mobileNumber.$invalid||isOTPSent\n               || !isValid || isMobileNotValid || !change.mobileBelongsTo\" ng-click=\"sendOTP(\'folio\')\"> <button type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button></div></td></tr></table></form>");
$templateCache.put("app/components/modal/transactionReview/directive/updateMobile.html","<form autocomplete=off class=update-mobile name=changeMobile style=\"display: contents\" novalidate><table style=\"margin-top: 0;margin-bottom: 0px\" class=table-width-fix><tr ng-if=currMobileNumber><!--ng-if=\"Modal.modalData.additionalData.mobileNumber\"--><td>Mobile No:</td><td ng-if=!isEdit class=\"grid-control edit-emailmobile-block\"><span easyassist-key=mask-element ng-bind=currMobileNumber></span><!--      <i class=\"edit2-icon\" ng-click=\"makeEdit();\" ng-if=\"!cFlag\"></i>--></td><td ng-if=isEdit ng-class=\"{\'fix-width\': isOTPSent }\"><input easyassist-key=mask-element type=text name=mobileNumber id=mobileNumberId ng-model=change.newMobileNumber ng-pattern=AppConstants.mobile_regex required minlength=10 maxlength=13 ng-disabled=isOTPSent ng-change=changeMobileNumber() style=\"width: 150px\"> <span ng-if=isOTPSent class=forgot><timer countdown=AppConstants.RESEND_OTP_COUNTER interval=1000><input type=button class=\"btn-small btn-primary-action\" value=\"Resend OTP\" ng-disabled=\"countdown > 0\" ng-click=reSendOTP()> <span ng-show=\"countdown != 0\" style=\"display: flex\">Resend OTP in {{countdown}}s</span></timer></span><span class=btn-block><span class=error-input ng-show=\"(changeMobile.mobileNumber.$error.pattern && changeMobile.mobileNumber.$invalid) || !isValid || isMobileNotValid\" style=\"color:#d92018;font-size: 12px; display: inline-block; width: 80%\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.MOBILE_ISD }}</span></span></td></tr><tr ng-if=isEdit><td style=\"width: 150px; padding-right: 5px\">Mobile No. Belongs To</td><td><select name=mobileBelongsTo style=\"width: 100px !important; height: 23px\" ng-init=\"change.mobileBelongsTo = change.mobileBelongsTo ? change.mobileBelongsTo : null\" ng-model=change.mobileBelongsTo ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in mobileList\" required><option value=\"\" selected>Select Value</option></select><div><input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=\"Send OTP\" ng-disabled=\"change.newMobileNumber===currMobileNumber\n               || changeMobile.mobileNumber.$error.pattern\n               || changeMobile.mobileNumber.$invalid||isOTPSent\n               || isMobileNotValid || !isValid || !change.mobileBelongsTo\" ng-click=sendOTP()> <button ng-if=!isOTPSent type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button></div></td></tr><tr ng-if=isOTPSent><td colspan=2 class=update-contact-text style=\"padding-left: 10px !important\">{{sendOtpRespMessage||\'We have sent two One-time Passwords(OTPs) for authentication purpose. Both OTPs are valid for 15 minutes only.\'}}</td></tr><tr ng-if=isOTPSent><td colspan=2><input type=text easyassist-key=mask-element class=\"update-contact-review update-input-otp\" maxlength=6 ignore-mouse-wheel placeholder=\"Enter OTP 1\" ng-model=change.checkOTP style=\"width: 90%\"><br><span class=update-contact-text>OTP 1 sent to your registered mobile number (<span easyassist-key=mask-element>{{currMobileNumber}}</span>) and email ID ( <span easyassist-key=mask-element ng-if=currEmail>{{currEmail}}</span> <span ng-if=!currEmail>Not Available</span>).</span><br><input type=text easyassist-key=mask-element class=\"update-contact-review update-input-otp\" maxlength=6 ignore-mouse-wheel placeholder=\"Enter OTP 2\" ng-model=change.checkNewOTP style=\"width: 90%\"><br><span class=update-contact-text>OTP 2 sent to new mobile number (<span easyassist-key=mask-element>{{change.newMobileNumber}}</span>) entered.</span><br><input type=button style=\"margin-top: 10px\" class=\"btn-small btn-primary-action\" value=Confirm ng-disabled=\"change.checkOTP == undefined||change.checkOTP.toString().split(\'\').length!==6 || change.checkNewOTP == undefined||change.checkNewOTP.toString().split(\'\').length!==6\" ng-click=verifyOTP();> <input type=button class=\"btn-small btn-secondary-action\" value=Cancel ng-click=cancelEdit();></td></tr></table></form>");
$templateCache.put("app/components/modal/transactionReview/directive/updateNewFolioEmail.html","<table><tr><!-- ng-if=\"currEmail\"--><td ng-style=\"{width: flowType === \'new-investor\' ? \'25%\' : \'auto\' }\">Email ID<span class=req>*</span> :</td><td ng-if=!isEdit><span easyassist-key=mask-element ng-bind=currEmail></span> <span ng-if=!currEmail>Not Updated.</span> <i ng-if=\"((currMobileNumber && currEmail) || (currMobileNumber && !currEmail)) && !hideUi\" class=edit2-icon ng-click=makeEdit(); title=\"Click to update email ID.\"></i></td><td ng-if=isEdit><form autocomplete=off name=changeEmail novalidate style=\"margin-top: 0px\"><span ng-show=isOTPSent ng-bind=change.newEmailId easyassist-key=mask-element></span> <input ng-class=\"{\'new-investor-edit-contact\' : flowType === \'new-investor\'}\" easyassist-key=mask-element type=email name=newEmail ng-model=change.newEmailId placeholder=\"Enter New Email\" ng-pattern=AppConstants.email_regex ng-hide=isOTPSent> <input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=Update ng-disabled=\"change.newEmailId==currEmail || changeEmail.newEmail.$error.pattern && changeEmail.newEmail.$invalid ||isOTPSent || !change.newEmailId\" ng-click=\"sendOTP(\'new_folio\')\"> <button type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button> <span class=btn-block ng-show=\"changeEmail.newEmail.$dirty && changeEmail.newEmail.$invalid\"><span class=error-input ng-show=\"changeEmail.newEmail.$error.pattern && changeEmail.newEmail.$invalid\" style=\"color:#d92018;font-size: 12px\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.EMAIL_FIELD }}</span></span></form></td></tr></table>");
$templateCache.put("app/components/modal/transactionReview/directive/updateNewFolioMobile.html","<table><tr><!--ng-if=\"Modal.modalData.additionalData.mobileNumber\"--><td ng-style=\"{width: flowType === \'new-investor\' ? \'25%\' : \'auto\' }\" style=\"width: 25%\">Mobile No<span class=req>*</span> :</td><td ng-if=!isEdit><span ng-if=currMobileNumber easyassist-key=mask-element ng-bind=currMobileNumber></span> <span ng-if=!currMobileNumber>Not Updated.</span> <i ng-if=\"((currEmail && currMobileNumber) || (currEmail && !currMobileNumber)) && !hideUi\" class=edit2-icon ng-click=makeEdit(); title=\"Click to update mobile number.\"></i></td><td ng-if=isEdit><form autocomplete=off name=changeMobile novalidate style=\"margin-top: 0px\"><span ng-show=isOTPSent ng-bind=change.newMobileNumber></span> <input ng-class=\"{\'new-investor-edit-contact\' : flowType === \'new-investor\'}\" easyassist-key=mask-element type=text name=mobileNumber id=mobileNumberId ng-model=change.newMobileNumber ng-pattern=AppConstants.mobile_regex required minlength=10 maxlength=13 ng-hide=isOTPSent> <input ng-if=!isOTPSent type=button class=\"btn-small btn-primary-action\" value=Update ng-disabled=\"change.newMobileNumber===currMobileNumber\n               || changeMobile.mobileNumber.$error.pattern\n               || changeMobile.mobileNumber.$invalid||isOTPSent\" ng-click=\"sendOTP(\'new_folio\')\"> <button type=button class=btn-secondary-action style=\"padding: 5px 12px\" ng-click=cancelUpdate()>Cancel</button> <span class=btn-block ng-show=\"changeMobile.mobileNumber.$dirty && changeMobile.mobileNumber.$invalid\"><span class=error-input ng-show=\"changeMobile.mobileNumber.$error.pattern && changeMobile.mobileNumber.$invalid\" style=\"color:#d92018;font-size: 12px\">{{ AppConstants.ToastrMessage.VALIDATE_DATA.MOBILE_ISD }}</span></span></form></td></tr></table>");
$templateCache.put("app/investors/list/types/individuals/individuals-investors-list.html","<div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorList()><div id=all class=\"tab-pane fade in active\"><!--<div class=\"search-data row\" ng-if=\"!Investors.analysisType\">\n      <div class=\"col-md-12\">\n\n        <div class=\"search-bar\">\n          <i class=\"search-icon\"></i>&lt;!&ndash;ng-focus=\"Investors.searchList(true)\"&ndash;&gt;\n          <input type=\"search\" class=\"investorFilter\" placeholder=\"Search Investor Name\" ng-model=\"Investors.sortOrder.searchText\"\n                 ng-change=\"Investors.searchList();\" select-on-click class=\"blank-input\">\n        </div>\n        <div class=\"sort-data pull-right\">\n          &lt;!&ndash;<select class=\"pull-right\" ng-change=\"Investors.typeChanged()\" ng-model=\"Investors.selectedSubType\"\n                  ng-options=\"_type.value as _type.key for _type in Investors.SUB_TYPE\" ng-value=\"_type.value\">\n          </select>&ndash;&gt;\n          <select class=\"otmSelect\" ng-change=\"Investors.typeChanged()\" ng-model=\"Investors.selectedOTMType\"\n                  ng-options=\"_type.value as _type.key for _type in Investors.INVESTOR_INVESTORLIST_OTM_TYPE\" value=\"_type.value\">\n          </select>\n\n          <span ng-dropdown-multiselect=\"\"\n                options=\"Investors.TYPE\"\n                selected-model=\"Investors.typeModel\"\n                events=\"Investors.changeEvents\"\n                extra-settings=\"Investors.multiSettings\"\n                translation-texts=\"Investors.typeTranslationTexts\"\n          ></span>\n          <span ng-dropdown-multiselect=\"\"\n                options=\"Investors.SUB_TYPE\"\n                selected-model=\"Investors.subTypeModel\"\n                events=\"Investors.changeEvents\"\n                extra-settings=\"Investors.multiSettings\"\n                translation-texts=\"Investors.subTypeTranslationTexts\"\n                class=\"multiselectInvestorList\"\n          ></span>\n          <span  class=\"download-with-tooltip investor_tooltip\" ng-click=\"Investors.downloadReportList(\'Invester-list\');\">\n              <i tooltips tooltip-template=\"Send Report\" class=\"white-up-icon\" alt=\"Download\"></i>\n            </span>\n        </div>\n      </div>\n    </div>--><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"Investors.sortOrder.sortKey=\'investorName\';Investors.filterByHeader()\">Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'PAN\';Investors.filterByHeader()\">PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'DOB\';Investors.filterByHeader()\">Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><!-- <th>Cost Value</th>\n          <th>Market Value</th> --><th class=text-center>Action</th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN ng-if=investor.pan>{{investor.pan}}</td><td data-th=PAN ng-if=!investor.pan>NA</td><td data-th=\"Date Of Birth\" ng-if=investor.dob>{{investor.dob}}</td><td data-th=\"Date Of Birth\" ng-if=!investor.dob>NA</td><!-- <td data-th=\"Cost Value\"><i class=\"rupee-icon\"></i>\n            {{investor.purchaseValue|unit:investor.purchaseValueUnit}}{{investor.purchaseValueUnit|unitValue}}\n          </td>\n          <td data-th=\"Market Value\"><i class=\"rupee-icon\"></i>\n            {{investor.currentValue|unit:investor.currentValueUnit}}{{investor.currentValueUnit|unitValue}}\n          </td> --><td data-th=Action class=text-center><span class=\"dropdown select-wrapper without-before text-left investorActionMob\"><div class=dropdown-toggle data-toggle=dropdown>Initiate Transaction<i class=drop-arrow-blue-icon></i></div><ul class=dropdown-menu style=\"min-width: 170px\"><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SIP\')\" role=button tabindex=0>SIP or Purchase</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSIP\')\" role=button tabindex=0>Flex SIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Switch\')\" role=button tabindex=0>Switch</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SWP\')\" role=button tabindex=0>SWP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'STP\')\" role=button tabindex=0>STP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Redeem\')\" role=button tabindex=0>Redeem</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'INSTANT_REDEMPTION\')\" role=button tabindex=0>Instant Access Facility</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'DTP\')\" role=button tabindex=0>TIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXINDEX\')\" role=button tabindex=0>Flex Index</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSTP\')\" role=button tabindex=0>Flex STP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'DREAMSIP\')\" role=button tabindex=0>DREAM SIP</li><!--<li class=\"list-group-item\" ng-click=\"Investors.validateInvestor(investor, \'SWINGSTP\')\"\n                      role=\"button\" tabindex=\"0\">Swing STP</li>  commented at FD-1823--></ul></span></td></tr><tr class=text-center ng-if=\"!(Investors.investorsListData.length >0) && !Investor.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div><style>.drp {\n    height: 38px !important;\n    line-height: 31px;\n    padding: 10px 10px !important;\n    text-align: center;\n    font-size: 14px;\n    border-radius: 4px;\n    background: #fff;\n    border: 1px solid #ccc;\n    text-decoration: none !important;\n    font-size: 14px;\n  }\n\n  .op button{\n    padding: 7px;\n    width: 170px;\n\n  }</style>");
$templateCache.put("app/investors/list/types/non-individuals/non-individuals-investors-list.html","<div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorList()><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row\" ng-if=!Investors.analysisType><div class=col-md-12><div class=search-bar><i class=search-icon></i><!--ng-focus=\"Investors.searchList(true)\"--> <input type=search class=investorFilter placeholder=\"Search Investor Name\" ng-model=Investors.sortOrder.searchText ng-change=Investors.searchList(); select-on-click class=blank-input></div><div class=\"sort-data pull-right\"><!--<select class=\"pull-right\" ng-change=\"Investors.typeChanged()\" ng-model=\"Investors.selectedSubType\"\n                  ng-options=\"_type.value as _type.key for _type in Investors.SUB_TYPE\" ng-value=\"_type.value\">\n          </select>--><select class=otmSelect ng-change=Investors.typeChanged() ng-model=Investors.selectedOTMType ng-options=\"_type.value as _type.key for _type in Investors.INVESTOR_INVESTORLIST_OTM_TYPE\" value=_type.value></select><span ng-dropdown-multiselect=\"\" options=Investors.TYPE selected-model=Investors.typeModel events=Investors.changeEvents extra-settings=Investors.multiSettings translation-texts=Investors.typeTranslationTexts></span> <span ng-dropdown-multiselect=\"\" options=Investors.SUB_TYPE selected-model=Investors.subTypeModel events=Investors.changeEvents extra-settings=Investors.multiSettings translation-texts=Investors.subTypeTranslationTexts class=multiselectInvestorList></span> <span class=\"download-with-tooltip investor_tooltip\" ng-click=\"Investors.downloadReportList(\'Invester-list\');\"><i tooltips tooltip-template=\"Email Report\" class=white-up-icon alt=Download></i></span></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"Investors.sortOrder.sortKey=\'investorName\';Investors.filterByHeader()\">Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'PAN\';Investors.filterByHeader()\">PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'DOB\';Investors.filterByHeader()\">Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><!-- <th>Cost Value</th>\n          <th>Market Value</th> --><th class=text-center>Action</th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" ng-click=Investors.investorDetails(investor) class=ng-binding role=button tabindex=0><a href=javascript:void(0)>{{investor.name}}</a></td><td data-th=PAN ng-if=investor.pan>{{investor.pan}}</td><td data-th=PAN ng-if=!investor.pan>NA</td><td data-th=\"Date Of Birth\" ng-if=investor.dob>{{investor.dob}}</td><td data-th=\"Date Of Birth\" ng-if=!investor.dob>NA</td><td data-th=Action class=text-center><span class=\"dropdown select-wrapper without-before text-left investorActionMob\"><div class=dropdown-toggle data-toggle=dropdown>Initiate Transaction<i class=drop-arrow-blue-icon></i></div><ul class=dropdown-menu style=\"min-width: 170px\"><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SIP\')\" role=button tabindex=0>SIP or Purchase</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSIP\')\" role=button tabindex=0>Flex SIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Switch\')\" role=button tabindex=0>Switch</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'SWP\')\" role=button tabindex=0>SWP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'STP\')\" role=button tabindex=0>STP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'Redeem\')\" role=button tabindex=0>Redeem</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'DTP\')\" role=button tabindex=0>TIP</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXINDEX\')\" role=button tabindex=0>Flex Index</li><li class=list-group-item ng-click=\"Investors.validateInvestor(investor, \'FLEXSTP\')\" role=button tabindex=0>Flex STP</li></ul></span></td></tr><tr class=text-center ng-if=\"!(Investors.investorsListData.length >0) && !Investor.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.initInvestorList() rotate=false></ul></div></div></div></div><style>.drp {\n    height: 38px !important;\n    line-height: 31px;\n    padding: 10px 10px !important;\n    text-align: center;\n    font-size: 14px;\n    border-radius: 4px;\n    background: #fff;\n    border: 1px solid #ccc;\n    text-decoration: none !important;\n    font-size: 14px;\n  }\n\n  .op button{\n    padding: 7px;\n    width: 170px;\n\n  }</style>");
$templateCache.put("app/investors/list/types/pending/pending-investors-list.html","<div class=\"tab-content investors-listing\" ng-init=Investors.initInvestorList()><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row\" ng-if=!Investors.analysisType><div class=col-md-12><div class=search-bar><i class=search-icon></i><!--ng-focus=\"Investors.searchList(true)\"--> <input type=search class=investorFilter placeholder=\"Search Investor Name\" ng-model=Investors.sortOrder.searchText ng-change=Investors.searchInvestor(); select-on-click class=blank-input></div></div></div><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th ng-click=\"Investors.sortOrder.sortKey=\'investorName\';Investors.filterByNewInvestorData(\'name\')\">Investor Name<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'PAN\';Investors.filterByNewInvestorData(\'panNumber\')\">PAN<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><th ng-click=\"Investors.sortOrder.sortKey=\'DOB\';Investors.filterByNewInvestorData(\'dob\')\">Date Of Birth<div class=sort-arrow><i class=sort-up-icon></i><i class=sort-down-icon></i></div></th><!-- <th>Cost Value</th>\n          <th>Market Value</th> --><th class=text-center>Action</th></tr></thead><tbody><tr ng-if=Investors.investorsListData ng-repeat=\"investor in Investors.investorsListData\"><td data-th=\"Investor Name\" class=ng-binding>{{investor.name}}</td><td data-th=PAN>{{investor.panNumber}}</td><td data-th=\"Date Of Birth\" ng-if=investor.dob>{{investor.dob}}</td><td data-th=Action class=text-center><span class=\"dropdown select-wrapper without-before text-left investorActionMob\" ng-if=\"investor.status == \'Edit\'\" ng-click=Investors.editNewInvestor(investor)>Edit & Send for approval </span><span class=\"dropdown select-wrapper without-before text-left investorActionMob\" ng-if=\"investor.status == \'Pending\'\" style=cursor:default>Investor Approval Pending </span><span class=\"dropdown select-wrapper without-before text-left investorActionMob\" ng-click=Investors.editNewInvestor(investor) ng-if=\"investor.status == \'Expired\' ||investor.status == \'Rejected\' \">Edit & Re-send Request</span></td></tr><tr class=text-center ng-if=\"!(Investors.investorsListData.length >0) && !Investor.isLoading\"><td colspan=6>No Record found</td></tr></tbody></table><div ng-if=Investors.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"Investors.totalInvestorsListData <= Investors.PAGE_LIMITS[0]\" ng-bind=Investors.totalInvestorsListData></span><select ng-if=\"Investors.totalInvestorsListData > Investors.PAGE_LIMITS[0]\" ng-change=Investors.initInvestorList() ng-model=Investors.pageLimitInvestorsList ng-options=\"_limit as _limit for _limit in Investors.PAGE_LIMITS\" value=_limit></select><span>of</span> <span class=t-black ng-bind=Investors.totalInvestorsListData></span></div><ul uib-pagination total-items=Investors.totalInvestorsListData ng-model=Investors.currentPageInvestorsList max-size=5 items-per-page=Investors.pageLimitInvestorsList class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=Investors.selectpage() rotate=false></ul></div></div></div></div><style>.select-wrapper{\n  width: 180px !important;\n}\n  .drp {\n    height: 38px !important;\n    line-height: 31px;\n    padding: 10px 10px !important;\n    text-align: center;\n    font-size: 14px;\n    border-radius: 4px;\n    background: #fff;\n    border: 1px solid #ccc;\n    text-decoration: none !important;\n    font-size: 14px;\n  }\n\n  .op button{\n    padding: 7px;\n    width: 170px;\n\n  }</style>");
$templateCache.put("app/investors/profile/modifyBank/addBank/addBank.html","<form class=\"main-section clearfix modifyBank\" name=AddBankForm ng-init=AddBank.init()><h5 class=screen-title>Add New Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=\"main.investors.profile.basicinfo({investorId : AddBank.investorId})\">Folio Details </span><i class=breadcrumb-icon></i><span> Add Bank</span></p><div class=folio-addbank><strong>Folio : </strong><span>{{AddBank.folioNumberToDisplay}}</span></div><div class=content-area><div class=col-md-12><div class=row><p class=\"col-md-4 form-title\"><strong>Provide New Bank Details</strong></p></div></div><div class=col-md-12><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid}\"><input type=text ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=AddBank.IFSC_REGEX capitalize ng-change=AddBank.clearBankField() ng-class={ifscBlank:!bankPayload.bankDetails.ifsccode} required ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-readonly=AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode> <span class=highlight></span> <span class=bar></span> <span class=\"glyphicon glyphicon-search search-icon-add\" ng-click=AddBank.selectIFSC()></span><label>IFSC<span class=\"req text-red\">*</span></label><span ng-show=\"AddBankForm.ifsccode.$dirty && AddBankForm.ifsccode.$invalid\"><span class=error-input ng-show=AddBankForm.ifsccode.$error.required ng-bind=AddBank.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=AddBankForm.ifsccode.$error.pattern ng-bind=AddBank.validateData.IFSC_CODE_REGEX></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid}\"><input type=text ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.bankName name=bankName required ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.bankName ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.bankName} ng-readonly=AddBank.formData.folioCreationRequestCO.bankDetails.bankName> <span ng-show=\"AddBankForm.bankName.$dirty && AddBankForm.bankName.$invalid\"><span class=error-input ng-show=AddBankForm.bankName.$error.required ng-bind=AddBank.validateData.BANK_NAME_REQUIRED></span></span><label>Bank Name<span class=req>*</span></label></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield ng-class=\"{error:AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid}\" style=margin-top:0px><select class=\"select-box custom-select selectCustomMob\" name=accountType ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.accountType ng-options=\"_type as _type.accountType for _type in AddBank.bankTypeList\" ng-change=AddBank.setAccountType() required ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"AddBank.formData.folioCreationRequestCO.bankDetails.accountType=AddBank.formData.folioCreationRequestCO.bankDetails.accountType?AddBank.formData.folioCreationRequestCO.bankDetails.accountType:null\" style=margin-top:1px><option value=\"\" selected>Account Type</option></select><span ng-show=\"AddBankForm.accountType.$dirty && AddBankForm.accountType.$invalid\"><span class=error-input ng-show=AddBankForm.accountType.$error.required ng-bind=AddBank.validateData.ACCOUNT_TYPE_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid}\"><input type=text ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.branchLocation name=branchLocation required autocomplete=off capitalize maxlength=40 ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.branchLocation}> <span class=highlight disabled></span> <span class=bar></span><label>Branch Location<span class=req>*</span></label><span ng-show=\"AddBankForm.branchLocation.$dirty && AddBankForm.branchLocation.$invalid\"><span class=error-input ng-show=AddBankForm.branchLocation.$error.required ng-bind=AddBank.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.bankBranch.$dirty && AddBankForm.bankBranch.$invalid}\"><input type=text ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.bankBranch name=bankBranch required autocomplete=off capitalize only-alphabets ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.bankBranch}> <span class=highlight></span> <span class=bar></span><label>Branch City<span class=req>*</span></label><span ng-show=\"AddBankForm.bankBranch.$dirty && AddBankForm.bankBranch.$invalid\"><span class=error-input ng-show=AddBankForm.bankBranch.$error.required ng-bind=AddBank.validateData.BRANCH_CITY_REQUIRED></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=selectfield style=\"margin-top: 0px\" ng-class=\"{error:AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid}\"><select class=\"select-box custom-select selectCustomMob\" name=payoutMechanism style=\"margin-top: 2px\" ng-model=AddBank.payoutMechanism ng-options=\"_type as _type.payoutDescription for _type in AddBank.payoutMechanismList\" ng-change=AddBank.setPayoutMechanism() required ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={disablefield:!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode} ng-init=\"AddBank.payoutMechanism=AddBank.payoutMechanism?AddBank.payoutMechanism:null\"><option value=\"\" selected>Payout Mechanism</option></select><span ng-show=\"AddBankForm.payoutMechanism.$dirty && AddBankForm.payoutMechanism.$invalid\"><span class=error-input ng-show=AddBankForm.payoutMechanism.$error.required ng-bind=AddBank.validateData.PAYOUT_MECH_REQUIRED></span> </span><span class=req>*</span></div></div></div></div><div class=\"row form-grid\"><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:(AddBank.accModelDirty &&\n                 (!AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length || AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1))}\"><input type=text easyassist-key=mask-element ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber maxlength=20 name=accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" required autocomplete=off directive.mask ng-change=AddBank.accFocus(); ng-keydown=AddBank.copyPasteHandler($event) capitalize ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><span ng-show=AddBank.accModelDirty><span class=error-input ng-show=AddBankForm.accountNumber.$error.required ng-bind=AddBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length !=0 && AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<1)\" ng-bind=AddBank.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div></div><div class=col-md-4><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid}\"><input type=text easyassist-key=mask-element ng-model=AddBank.formData.folioCreationRequestCO.bankDetails.verifyAccountNumber maxlength=20 limit-to=20 ng-maxlength=20 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=AddBank.formData.folioCreationRequestCO.bankDetails.accountNumber required autocomplete=off ng-keydown=AddBank.copyPasteHandler($event) capitalize ng-disabled=!AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode ng-class={enable:AddBank.formData.folioCreationRequestCO.bankDetails.ifsccode}> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"AddBankForm.verifyAccountNumber.$dirty && AddBankForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\" ng-bind=AddBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"AddBankForm.verifyAccountNumber.$error.pattern && !AddBankForm.verifyAccountNumber.$error.maxlength && !AddBankForm.verifyAccountNumber.$error.required\" ng-bind=AddBank.validateData.SAME_ACCOUNT_NUMBER_RANGE></span></span></div></div></div></div><div class=row><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox ng-model=AddBank.payload.makeDefaultBank> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div><div class=row style=\"padding-bottom: 12px\"><div class=col-md-12><ng-bind-html dynamic=AddBank.note></ng-bind-html></div></div><div class=\"row form-grid upload-some\"><p><strong>Upload Default Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of default bank to validate bank details.\"></i> </strong></p><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{AddBank.oldBankName}}</span></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"(AddBank.fileTypeold === \'tif\' || AddBank.fileTypeold === \'tiff\') && AddBank.oldChequeLeaf\"><a href=javascript:void(0) ng-click=\"AddBank.downloadFile(AddBank.formData.folioCreationRequestCO.oldChequeLeafUrl,AddBank.fileTypeold,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"(AddBank.fileTypeold == \'jpg\' ||  AddBank.fileTypeold == \'jpeg\') && AddBank.oldChequeLeaf\" ng-click=\"AddBank.openUploadedDoc(AddBank.formData.folioCreationRequestCO.oldChequeLeafUrl,\'old\')\">{{AddBank.oldChequeLeaf}}</span> <span class=upload-button><input id=uploadFileIdOld type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=AddBank.myFile targetimg=showingImgId upload=\"AddBank.uploadFile(file,\'old\')\"><label for=uploadFileIdOld class=\"btn-upload btn-secondary-action choose-label\">{{AddBank.fileTypeold && AddBank.oldChequeLeaf ?\'CHANGE\':\'CHOOSE FILE\'}}</label></span></div></div></div><div class=\"row form-grid upload-some\" ng-if=\"!AddBank.payload.pennyDropValid && (AddBank.folioTaxStatusCode == \'02\' || AddBank.folioTaxStatusCode == \'21\' || AddBank.folioTaxStatusCode == \'24\')\"><p><strong>Upload New Bank Proof <i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement={{Main.tooltipClass}} title=\"Upload cheque leaf of new bank to validate bank details.\"></i> </strong></p><div class=input-section><div class=form-group><span class=\"file-name text-blue\" ng-if=\"(AddBank.fileType === \'tif\' || AddBank.fileType === \'tiff\') && AddBank.isNewCheckLeaf\"><a href=javascript:void(0) ng-click=\"AddBank.downloadFile(AddBank.formData.folioCreationRequestCO.chequeLeafUrl,AddBank.fileType,\'chequeLeaf\')\">Download</a> </span><span class=\"file-name text-blue\" ng-if=\"(AddBank.fileType == \'jpg\' ||  AddBank.fileType == \'jpeg\') && AddBank.isNewCheckLeaf\" ng-click=\"AddBank.openUploadedDoc(AddBank.formData.folioCreationRequestCO.chequeLeafUrl,\'new\')\">{{AddBank.chequeLeaf}}</span> <span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.jpeg,.jpg,.tif,.tiff file-model=AddBank.myFile targetimg=showingImgId upload=\"AddBank.uploadFile(file,\'new\')\"><label for=uploadFileId class=\"btn-upload btn-secondary-action choose-label\">{{AddBank.fileType && AddBank.isNewCheckLeaf ?\'CHANGE\':\'CHOOSE FILE\'}}</label></span></div></div></div><div class=tc-block><h6>Terms & Conditions</h6><div><div class=checkbox><input ng-model=AddBank.isCheckedCobmTandC type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=AddBank.showCobmTermConditions() href=javaScript:void(0)>Terms & Conditions</a> of Investment.</span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=\"pull-left back\" ng-click=AddBank.back()><i class=back-arrow-icon></i>Back</span> <span class=pull-right><input type=button value=Cancel ng-click=AddBank.back() class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=\"Send for Approval\" class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"AddBankForm.$invalid || !AddBank.isCheckedCobmTandC\" ng-click=AddBank.addBankSubmit()></span></div></div></form><style>.point-to-note-tpv{\n    margin: 0;\n  }</style>");
$templateCache.put("app/investors/profile/modifyBank/changeBank/changeBank.html","<form class=\"main-section clearfix modifyBank\" name=modifyBank ng-init=ChangeBank.init()><h5 class=screen-title>Change Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Folio Details </span><i class=breadcrumb-icon></i><span> Modify Bank</span></p><div class=folio-addbank><strong>Folio : </strong><span>{{ChangeBank.folioNumberToDisplay}}</span></div><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.bankName.$dirty && modifyBank.bankName.$invalid}\"><select class=select-box name=bankName ng-model=ChangeBank.selectedBank ng-change=ChangeBank.changeBank() required><option value=\"\" selected>Bank Name</option><option ng-repeat=\"banks in ChangeBank.bankList\" value={{banks}}>{{banks.bankName}}</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.bankName.$error ng-show=modifyBank.bankName.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=selectfield ng-class=\"{error:modifyBank.accountType.$dirty && modifyBank.accountType.$invalid}\"><select class=select-box name=accountType ng-model=ChangeBank.payload.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in ChangeBank.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.accountType.$error ng-show=modifyBank.accountType.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:modifyBank.micrnumber.$dirty && modifyBank.micrnumber.$invalid}\"><input type=text ng-model=ChangeBank.payload.micrnumber ng-maxlength=9 limit-to=9 ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=modifyBank.micrnumber.$error ng-show=modifyBank.micrnumber.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=ChangeBank.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=ChangeBank.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:modifyBank.payoutMechanism.$dirty && modifyBank.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=ChangeBank.payload.payoutMechanism ng-disabled=\"ChangeBank.payload.RGTSCode==\'HDF\'\" ng-options=\"_type.payoutCode as _type.payoutDescription for _type in ChangeBank.payoutMechanismList\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=modifyBank.payoutMechanism.$error ng-show=modifyBank.payoutMechanism.$dirty><span ng-message=required ng-bind=ChangeBank.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(ChangeBank.accModelDirty &&\n                 (!ChangeBank.payload.accountNumber.split(\'\').length ||\n                 ChangeBank.payload.accountNumber.split(\'\').length<9 ||\n                  ChangeBank.payload.accountNumber.split(\'\').length>20))}\"><input type=text ng-model=ChangeBank.payload.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" maxlength=20 name=accountNumber limit-to=20 required autocomplete=off directive.mask ng-change=BankDetails.accFocus() capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=ChangeBank.accModelDirty><span class=error-input ng-show=\"ChangeBank.payload.accountNumber.split(\'\').length==0\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(!ChangeBank.payload.bankDetails.accountNumber.split(\'\').length || ChangeBank.payload.bankDetails.accountNumber.split(\'\').length<9)\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_RANGE></span> <span class=error-input ng-show=\"(!ChangeBank.payload.bankDetails.accountNumber.split(\'\').length || ChangeBank.payload.bankDetails.accountNumber.split(\'\').length>20)\" ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid}\"><input type=text ng-model=ChangeBank.verifyAccountNumber maxlength=20 name=verifyAccountNumber limit-to=20 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=ChangeBank.payload.accountNumber required autocomplete=off ng-keydown=ChangeBank.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.verifyAccountNumber.$dirty && modifyBank.verifyAccountNumber.$invalid\"><span class=error-input ng-show=modifyBank.verifyAccountNumber.$error.required ng-bind=ChangeBank.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\" ng-bind=ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"modifyBank.verifyAccountNumber.$error.pattern\n            && !modifyBank.verifyAccountNumber.$error.maxlength && !modifyBank.verifyAccountNumber.$error.required\">{{ChangeBank.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid}\"><input type=text ng-model=ChangeBank.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=ChangeBank.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.ifsccode.$dirty && modifyBank.ifsccode.$invalid\"><span class=error-input ng-show=modifyBank.ifsccode.$error.required ng-bind=ChangeBank.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=modifyBank.ifsccode.$error.pattern ng-bind=ChangeBank.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankBranch only-alphabets name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchLocation.$dirty && modifyBank.branchLocation.$invalid\"><span class=error-input ng-show=modifyBank.branchLocation.$error.required ng-bind=ChangeBank.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:modifyBank.branchCity.$dirty && modifyBank.branchCity.$invalid}\"><input type=text ng-model=ChangeBank.payload.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"modifyBank.branchCity.$dirty && modifyBank.branchCity  .$invalid\"><span class=error-input ng-show=modifyBank.branchCity.$error.required ng-bind=ChangeBank.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload New Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of new bank to validate bank details. \"></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafNew upload=ChangeBank.uploadChequeLeafFile(file) ng-model=ChangeBank.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileNew>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDoc()>{{ChangeBank.bankDetails.chequeLeaf}}</span></div></div></div><!-- <div class=\"row border-bottom\">\n        <div class=\"col-md-12 mark-default\">\n        <div class=\"checkbox\">\n          <input type=\"checkbox\"/>\n          <i class=\"icon-checkbox\"></i>\n          <span class=\"checkbox-text\">Make it a default bank for this folio </span>\n        </div>\n        </div>\n      </div>--><div class=\"row upload-some\"><span class=leaf-label>Upload Old Bank Proof <i class=\"info-icon base-tooltip\" data-html=true tooltip data-toggle=tooltip data-placement=right title=\"Upload cheque leaf of old bank to validate bank details. \"></i></span><p class=upload-data><span class=grey-text>Bank Name : </span><span>{{ChangeBank.oldBankName}}</span></p><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=ChangeBank.chequeLeafOld upload=ChangeBank.uploadChequeLeafFileOld(file) ng-model=ChangeBank.bankDetails.chequeLeafOld><div class=file-upload><button>Choose File</button> <span ng-if=ChangeBank.chooseAFileOld>No File Chosen</span> <span ng-click=ChangeBank.openUploadedDocOld()>{{ChangeBank.bankDetails.chequeLeafOld}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=\"pull-left back\" ng-click=ChangeBank.back()><i class=arrow-blue-back-icon></i>Back</span> <span class=pull-right><input type=button value=Cancel class=\"btn btn-secondary-action common-btn-padding\" ng-click=ChangeBank.back()> <input type=submit value=Sumbit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"modifyBank.$invalid || !ChangeBank.bankDetails.chequeLeaf || !ChangeBank.bankDetails.chequeLeafOld\" ng-click=ChangeBank.changeBankSubmit()></span></div></div></form>");
$templateCache.put("app/investors/profile/modifyBank/changeMultipleBank/changeMultipleBank.html","<section class=\"main-section clearfix modifyBank\"><h5 class=screen-title>Change1 Bank</h5><p class=breadcrumbs><span class=\"text-primary cursor-pointer\" ui-sref=main.portfolio.list>Folio Details </span><i class=breadcrumb-icon></i><span> Modify Bank</span></p><div class=content-area><p class=\"col-md-12 form-title\"><strong>Provide New Bank Details</strong></p><div class=col-md-12><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:bankDetailsForm.bankName.$dirty && bankDetailsForm.bankName.$invalid}\"><select class=select-box name=bankName ng-model=BankDetails.payload.bankDetails.bankName ng-options=\"_type.bankName as _type.bankName for _type in BankDetails.bankList\" required><option value=\"\" selected>Bank Name</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.bankName.$error ng-show=bankDetailsForm.bankName.$dirty><span ng-message=required ng-bind=BankDetails.validateData.BANK_NAME_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=selectfield ng-class=\"{error:bankDetailsForm.accountType.$dirty && bankDetailsForm.accountType.$invalid}\"><select class=select-box name=accountType ng-model=BankDetails.payload.bankDetails.accountType ng-options=\"_type.accountTypeCode as _type.accountType for _type in BankDetails.bankTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.accountType.$error ng-show=bankDetailsForm.accountType.$dirty><span ng-message=required ng-bind=BankDetails.validateData.ACCOUNT_TYPE_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt8\" ng-class=\"{error:bankDetailsForm.micrnumber.$dirty && bankDetailsForm.micrnumber.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.micrnumber ng-maxlength=9 ng-minlength=9 ng-pattern=\"\'^[0-9]+$\'\" name=micrnumber autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>MICR Number <span class=\"req text-red\">*</span></label><span class=error-input ng-messages=bankDetailsForm.micrnumber.$error ng-show=bankDetailsForm.micrnumber.$dirty><span ng-message=required ng-bind=BankDetails.validateData.MICR_NUMBER_REQUIRED></span> <span ng-message=minlength ng-bind=BankDetails.validateData.MICR_NUMBER_RANGE></span> <span ng-message=maxlength ng-bind=BankDetails.validateData.MICR_NUMBER_RANGE></span> <span ng-message=pattern ng-bind=BankDetails.validateData.DIGITS_ONLY></span></span></div></div></div><div class=row><div class=col-md-3><div class=selectfield ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=BankDetails.payload.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in BankDetails.payoutMechanismList\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=BankDetails.validateData.PAYOUT_MECH_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:(BankDetails.accModelDirty &&\n                 (!BankDetails.payload.bankDetails.accountNumber.split(\'\').length || BankDetails.payload.bankDetails.accountNumber.split(\'\').length>25))}\"><input type=text ng-model=BankDetails.payload.bankDetails.accountNumber onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-maxlength=25 name=accountNumber required autocomplete=off directive.mask ng-change=BankDetails.accFocus(); capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number <span class=\"req text-red\">*</span></label><span ng-show=BankDetails.accModelDirty><span class=error-input ng-show=\"BankDetails.payload.bankDetails.accountNumber.split(\'\').length==0\" ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(!BankDetails.payload.bankDetails.accountNumber.split(\'\').length || BankDetails.payload.bankDetails.accountNumber.split(\'\').length>25)\" ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.verifyAccountNumber maxlength=25 name=verifyAccountNumber onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-pattern=BankDetails.payload.bankDetails.accountNumber required autocomplete=off ng-keydown=BankDetails.copyPasteHandler($event) capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.verifyAccountNumber.$dirty && bankDetailsForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=bankDetailsForm.verifyAccountNumber.$error.required ng-bind=BankDetails.validateData.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\" ng-bind=BankDetails.validateData.SAME_ACCOUNT_NUMBER_RANGE></span> </span><span class=error-input ng-show=\"bankDetailsForm.verifyAccountNumber.$error.pattern\n            && !bankDetailsForm.verifyAccountNumber.$error.maxlength && !bankDetailsForm.verifyAccountNumber.$error.required\">{{BankDetails.validateData.SAME_ACCOUNT_NUMBER_RANGE}}</span></div></div></div><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=BankDetails.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.ifsccode.$dirty && bankDetailsForm.ifsccode.$invalid\"><span class=error-input ng-show=bankDetailsForm.ifsccode.$error.required ng-bind=BankDetails.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=bankDetailsForm.ifsccode.$error.pattern ng-bind=BankDetails.validateData.IFSC_CODE_REGEX></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.bankBranch only-alphabets name=branchLocation required autocomplete=off capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchLocation.$dirty && bankDetailsForm.branchLocation.$invalid\"><span class=error-input ng-show=bankDetailsForm.branchLocation.$error.required ng-bind=BankDetails.validateData.BRANCH_LOCATION_REQUIRED></span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=input-normal ng-class=\"{error:bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity.$invalid}\"><input type=text ng-model=BankDetails.payload.bankDetails.bankCity name=branchCity only-alphabets autocomplete=off capitalize required> <span class=highlight></span> <span class=bar></span><label>Branch City <span class=\"req text-red\">*</span></label><span ng-show=\"bankDetailsForm.branchCity.$dirty && bankDetailsForm.branchCity  .$invalid\"><span class=error-input ng-show=bankDetailsForm.branchCity.$error.required ng-bind=BankDetails.validateData.CITY_REQUIRED></span></span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Cheque Leaf <i class=info-icon></i></span><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=BankDetails.chequeLeaf upload=BankDetails.uploadChequeLeafFile(file) ng-model=BankDetails.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=BankDetails.chooseAFile>No File Chosen</span> <span ng-click=BankDetails.openUploadedDoc()>{{BankDetails.chequeLeafUrl}}</span></div></div></div><div class=\"row border-bottom\"><div class=\"col-md-12 mark-default\"><div class=checkbox><input type=checkbox> <i class=icon-checkbox></i> <span class=checkbox-text>Make it a default bank for this folio</span></div></div></div><div class=\"row upload-some\"><span class=leaf-label>Upload Any of Existing Bank\'s Proof <i class=info-icon></i></span><div class=col-md-3><div class=row><div class=selectfield ng-class=\"{error:bankDetailsForm.payoutMechanism.$dirty && bankDetailsForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=BankDetails.payload.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in BankDetails.payoutMechanismList\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=\"req text-red\">*</span> <span class=error-input ng-messages=bankDetailsForm.payoutMechanism.$error ng-show=bankDetailsForm.payoutMechanism.$dirty><span ng-message=required ng-bind=BankDetails.validateData.PAYOUT_MECH_REQUIRED></span></span><label>Select Existing Bank</label></div></div></div><div class=upload-leaf><input type=file name=pic accept=image/* file-model-profile=BankDetails.chequeLeaf upload=BankDetails.uploadChequeLeafFile(file) ng-model=BankDetails.bankDetails.chequeLeaf><div class=file-upload><button>Choose File</button> <span ng-if=BankDetails.chooseAFile>No File Chosen</span> <span ng-click=BankDetails.openUploadedDoc()>{{BankDetails.chequeLeafUrl}}</span></div></div></div></div><div class=\"form-footer col-md-12\"><span class=\"pull-left back\" ng-click=BankDetails.back()><i class=arrow-blue-back-icon></i>Back</span> <span class=pull-right><input type=button value=Cancel class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Sumbit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"bankDetailsForm.$invalid || !BankDetails.chequeLeafUrl\" ng-click=BankDetails.done()></span></div></div></section>");
$templateCache.put("app/investors/profile/modifyBank/cobmStatus/cobmStatus.html","<div class=\"portfolio tab-content\" ng-init=CobmStatus.init()><h3 class=page-title>COBM Status</h3><div class=\"pull-left breadcrumb-cobmstatus\"><ul class=list-inline><li><a href=javaScript:void(0) ng-click=CobmStatus.goToBasicInfo()>Basic Info </a></li><li><span class=breadcrumb-icon></span></li><li>COBM Status</li></ul></div><div id=portfolio class=tab-pane style=\"display: block\"><div class=\"list data-grid\"><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Bank Name</th><th>Bank Account Number</th><th>Transaction Type</th><th>Transaction Date</th><th>Status</th><th>Rejected Reason</th></tr></thead><tbody><tr ng-if=CobmStatus.cobmDetailList ng-repeat=\"status in CobmStatus.cobmDetailList\"><td data-th=\"Bank Name\" ng-bind-html=status.bankName></td><td data-th=\"Bank Account Number\">{{status.bankAccNo}}</td><td data-th=\"Transaction Type\">{{status.transactionType}}</td><td data-th=\"Transaction Date\">{{status.transactionDate}}</td><td data-th=Status>{{status.status}}</td><td data-th=\"Rejected Reason\">{{status.rejectedReason||\'-\'}}</td></tr><tr ng-if=!CobmStatus.cobmDetailList><td colspan=8>No Record found</td></tr></tbody></table><!--<div ng-if=\"CobmStatus.isInvestorPagination\" class=\"no-overflow\">\n        <div class=\"total-data pagination\">\n          <span>Showing</span>\n          <span ng-if=\"InvestorProfile.totalInvestorsPortfolioData <= InvestorProfile.PAGE_LIMITS[0]\" ng-bind=\"InvestorProfile.totalInvestorsPortfolioData\"></span>\n          <select ng-if=\"InvestorProfile.totalInvestorsPortfolioData > InvestorProfile.PAGE_LIMITS[0]\"\n                  ng-change=\"InvestorProfile.init()\"\n                  ng-model=\"InvestorProfile.pageLimitInvestorsPortfolio\"\n                  ng-options=\"_limit as _limit for _limit in InvestorProfile.PAGE_LIMITS\" ng-value=\"_limit\">\n          </select>\n          <span>of</span>\n          <span class=\"t-black\" ng-bind=\"InvestorProfile.totalInvestorsPortfolioData\">205</span>\n        </div>\n        <ul\n          uib-pagination\n          total-items=\"InvestorProfile.totalInvestorsPortfolioData\"\n          ng-model=\"InvestorProfile.currentPageInvestorsPortfolio\"\n          max-size=\"5\"\n          items-per-page=\"InvestorProfile.pageLimitInvestorsPortfolio\"\n          class=\"pagination-sm pull-right pagination\"\n          boundary-link-numbers=\"true\"\n          previous-text=\"&lsaquo;\"\n          next-text=\"&rsaquo;\"\n          ng-change=\"InvestorProfile.init(false)\"\n          rotate=\"false\">\n\n        </ul>\n      </div>--></div></div></div>");
$templateCache.put("app/investors/profile/modifyBank/updateIFSC/updateIFSC.html","<form class=\"main-section clearfix modifyBank\" name=UpdateIFSCForm ng-init=UpdateIFSC.init()><h5 class=screen-title>Update IFSC</h5><div class=content-area><div class=col-md-12><div class=row><div class=col-md-3><div class=input-normal ng-class=\"{error:UpdateIFSCForm.ifsccode.$dirty && UpdateIFSCForm.ifsccode.$invalid}\"><input type=text ng-model=UpdateIFSC.payload.ifsccode name=ifsccode autocomplete=off maxlength=11 minlength=11 ng-pattern=UpdateIFSC.IFSC_REGEX capitalize required> <span class=highlight></span> <span class=bar></span><label>New IFSC Code <span class=\"req text-red\">*</span></label><span ng-show=\"UpdateIFSCForm.ifsccode.$dirty && UpdateIFSCForm.ifsccode.$invalid\"><span class=error-input ng-show=UpdateIFSCForm.ifsccode.$error.required ng-bind=UpdateIFSC.validateData.IFSC_CODE_FIELD></span> <span class=error-input ng-show=UpdateIFSCForm.ifsccode.$error.pattern ng-bind=UpdateIFSC.validateData.IFSC_CODE_REGEX></span></span></div></div></div><!--<div class=\"row upload-some\">\n        <span class=\"leaf-label\">Upload New Bank Proof\n        <i class=\"info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"  data-placement=\"right\" title=\"Upload cheque leaf of new bank to update its IFSC code. \"></i>\n        </span>\n        <div class=\"upload-leaf\">\n          <input type=\"file\" name=\"pic\" accept=\"image/*\" file-model-profile=\"UpdateIFSC.chequeLeafNew\"\n                 upload=\"AddBank.uploadChequeLeafFile(file,\'add\')\" ng-model=\"UpdateIFSC.bankDetails.chequeLeaf\">\n          <div class=\"file-upload\">\n            <button>Choose File</button>\n            <span ng-if=\"AddBank.chooseAFileNew\">No File Chosen</span>\n            <span ng-click=\"AddBank.openUploadedDoc()\">{{AddBank.chequeLeafUrlNew}}</span></div>\n        </div>\n      </div>\n      <div class=\"row upload-some\">\n        <span class=\"leaf-label\">Upload Old Bank Proof\n        <i class=\"info-icon base-tooltip\" data-html=\"true\" tooltip data-toggle=\"tooltip\"  data-placement=\"right\" title=\"Upload cheque leaf of old/existing bank to update its IFSC code. \"></i>\n        </span>\n        <p class=\"upload-data\">\n          <span class=\"grey-text\">Bank Name : </span><span>{{UpdateIFSC.oldBank.bankName}}</span>\n        </p>\n        <div class=\"upload-leaf\">\n          <input type=\"file\" name=\"pic\" accept=\"image/*\" file-model-profile=\"UpdateIFSC.chequeLeafOld\"\n                 upload=\"UpdateIFSC.uploadOldBankProof(file,\'modify\')\" ng-model=\"BankDetails.bankDetails.chequeLeaf\">\n          <div class=\"file-upload\">\n            <button>Choose File</button>\n            <span ng-if=\"UpdateIFSC.chooseAFileOld\">No File Chosen</span>\n            <span ng-click=\"UpdateIFSC.uploadChequeLeafFile()\">{{UpdateIFSC.chequeLeafUrlOld}}</span></div>\n        </div>\n      </div>--></div><div class=\"form-footer col-md-12\"><span class=\"pull-left back\" ng-click=UpdateIFSC.back()><i class=arrow-blue-back-icon></i>Back</span> <span class=pull-right><input type=button ng-click=UpdateIFSC.back() value=Cancel class=\"btn btn-secondary-action common-btn-padding\"> <input type=submit value=Submit class=\"btn btn-primary-action common-btn-padding\" ng-disabled=\"UpdateIFSCForm.$invalid \" ng-click=UpdateIFSC.updateIFSCSuccessful()></span></div></div></form><!--\n|| !AddBank.chequeLeafUrl-->");
$templateCache.put("app/investors/summary/folioApproval/holderApproval/holder-smartlink.html","<div class=clearfix><div class=email-view ng-if=HolderApproval.isLoaded><div data-ng-include=\"\'app/investors/summary/folioApproval/holderApproval/holder.html\'\"></div></div></div>");
$templateCache.put("app/investors/summary/folioApproval/holderApproval/holder.html","<div class=\"approval main-section\"><h3 class=page-title><strong>Folio Creation Approval</strong><br><span ng-bind=FolioApprovalParent.headerDetails.name>Investor Name</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li class=col-md-4 style=padding-bottom:0px><strong>Unit Holder Name:</strong> <span ng-if=HolderApproval.folioDetails.soleApplicantDetail.middleName ng-bind=\"HolderApproval.folioDetails.soleApplicantDetail.firstName+\' \' + HolderApproval.folioDetails.soleApplicantDetail.middleName + \' \'+HolderApproval.folioDetails.soleApplicantDetail.lastName\">Distributor Name</span> <span ng-if=!HolderApproval.folioDetails.soleApplicantDetail.middleName ng-bind=\"HolderApproval.folioDetails.soleApplicantDetail.firstName+\' \'+HolderApproval.folioDetails.soleApplicantDetail.lastName\">Distributor Name</span></li><li style=padding-bottom:0px><strong>PAN:</strong> <span easyassist-key=mask-element ng-bind=HolderApproval.folioDetails.soleApplicantDetail.panNumber>Distributor Name</span></li></ul><ul><li class=col-md-4><strong>Holder Name:</strong> <span easyassist-key=mask-element ng-bind=HolderApproval.holder.jointHolderName>Distributor Name</span></li><li><strong>PAN:</strong> <span easyassist-key=mask-element ng-bind=HolderApproval.holder.jointHolderApplicantDetail.panNumber></span></li></ul></div><div class=\"box-body folio-approval-investor\"><form autocomplete=off name=JointHolderForm novalidate><h3>Joint Holder Details</h3><div class=\"sole-applicant folio-approval\"><div class=form-content><div class=row><div class=col-md-6><div><p><strong>Email ID :</strong><strong easyassist-key=mask-element>{{HolderApproval.holder.email ? HolderApproval.holder.email :\'Not Available\'}}</strong></p></div><div class=row style=\"margin-bottom: 12px\"><div class=\"col-md-12 mobile-view\"><span style=\"margin-right: 15px\"><strong>Email Id Belongs To</strong></span><select class=\"browser-default custom-select select-width\" name=emailBelongsTo ng-model=HolderApproval.holder.jointHolderApplicantDetail.emailBelongsTo ng-init=\"HolderApproval.holder.jointHolderApplicantDetail.emailBelongsTo = HolderApproval.holder.jointHolderApplicantDetail.emailBelongsTo ? HolderApproval.holder.jointHolderApplicantDetail.emailBelongsTo :null\" ng-options=\"email.familyCode as email.familyDescription for email in HolderApproval.emaillList\" ng-disabled=!HolderApproval.holder.email ng-required=HolderApproval.holder.email><option value=\"\" selected>Select Value</option></select><span class=req ng-if=HolderApproval.holder.email>*</span></div></div></div><div class=col-md-6><div><p><strong>Mobile No :</strong><strong easyassist-key=mask-element>{{HolderApproval.holder.mobileNo ? HolderApproval.holder.mobileNo :\'Not Available\'}}</strong></p></div><div class=row style=\"margin-bottom: 12px\"><div class=\"col-md-12 mobile-view\"><span style=\"margin-right: 15px\"><strong>Mobile No. Belongs To</strong></span><select class=\"browser-default custom-select select-width\" name=mobileBelongsTo ng-model=HolderApproval.holder.jointHolderApplicantDetail.mobileBelongsTo ng-init=\"HolderApproval.holder.jointHolderApplicantDetail.mobileBelongsTo = HolderApproval.holder.jointHolderApplicantDetail.mobileBelongsTo ? HolderApproval.holder.jointHolderApplicantDetail.mobileBelongsTo :null\" ng-options=\"mobile.familyCode as mobile.familyDescription for mobile in HolderApproval.mobileList\" ng-disabled=!HolderApproval.holder.mobileNo ng-required=HolderApproval.holder.mobileNo><option value=\"\" selected>Select Value</option></select><span class=req ng-if=HolderApproval.holder.mobileNo>*</span></div></div></div></div><p><strong>Income Details</strong></p><div class=row><div class=\"col-md-3 pos-relative\"><!--<label class=\"customized-label custom-top\">Tax Status</label>--><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:JointHolderForm.taxStatusCode.$dirty && JointHolderForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=HolderApproval.holder.jointHolderApplicantDetail.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in HolderApproval.taxStatusList\" ng-disabled=\"HolderApproval.folioDetails.jointHolders[0].nriFlag == false\" required><option value=\"\" selected>Tax Status</option></select><span ng-show=\"JointHolderForm.taxStatusCode.$dirty && JointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=JointHolderForm.taxStatusCode.$error.required ng-bind=JointHolders.validateData.TAX_STATUS></span> </span><span class=req>*</span></div></div><div class=\"col-md-3 col-md-offset-1 pos-relative\"><!--<label class=\"customized-label custom-top\">Occupation</label>--><div class=\"input-select selectfield input-normal selectfield\" ng-class=\"{error:JointHolderForm.occupation.$dirty && JointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=occupation ng-model=HolderApproval.holder.jointHolderApplicantDetail.occupation ng-options=\"_type.occupationCode as _type.occupationDescription for _type in HolderApproval.occupationList\" required><option value=\"\" selected>Occupation</option></select><span ng-show=\"JointHolderForm.occupation.$dirty && JointHolderForm.occupation.$invalid\"><span class=error-input ng-show=JointHolderForm.occupation.$error.required ng-bind=JointHolders.validateData.OCCUPATION></span> </span><span class=req>*</span></div></div></div><div class=row><div class=\"col-md-3 pos-relative\"><!--<label class=\"customized-label custom-top\">Gross Annual Income</label>--><div class=\"input-select input-normal selectfield\" ng-class=\"{\n                       error:JointHolderForm.grossAnnualIncome.$dirty\n                       && JointHolderForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=HolderApproval.resetNetWorthDate() ng-model=HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in HolderApproval.incomeSlabList\" ng-required=!(HolderApproval.holder.jointHolderApplicantDetail.netWorth) ng-disabled=HolderApproval.holder.jointHolderApplicantDetail.netWorth><option value=\"\" selected>Gross Annual Income</option></select><span ng-show=\"JointHolderForm.grossAnnualIncome.$dirty && JointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=JointHolderForm.grossAnnualIncome.$error.required ng-bind=JointHolders.validateData.GROSS_ANNUAL_INCOME></span> <span class=error-input ng-show=JointHolderForm.grossAnnualIncome.$error.number ng-bind=JointHolders.validateData.INVALID_AMOUNT></span> </span><span class=req>*</span> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income</label></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-normal mgt18\" ng-class=\"{error:JointHolderForm.netWorth.$dirty\n                           && JointHolderForm.netWorth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel name=netWorth class=pd20 ng-model=HolderApproval.holder.jointHolderApplicantDetail.netWorth ng-required=!(HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome) ng-disabled=HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Net worth (in Rs.)<span class=req>*</span></label><span ng-show=\"JointHolderForm.netWorth.$dirty && JointHolderForm.netWorth.$invalid\"><span class=error-input>{{HolderApproval.CONST.ToastrMessage.VALIDATE_DATA.NET_WORTH_REQUIRED}}</span></span></div></div><div class=\"col-md-3 col-md-offset-1\" ng-class=\"{\'anything-disabled\' : HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome}\"><div class=\"input-select input-normal input-group date date-picker mgt18\" ng-class=\"{error : HolderApproval.holder.jointHolderApplicantDetail.netWorth && !HolderApproval.holder.jointHolderApplicantDetail.netWorthDate}\"><input type=text name=netWorthDate id=soleNetWorthDate2 date-calendar data-enable=true date-default=HolderApproval.defaultDateNetWorthDate format=DD-MMM-YYYY viewmode=days maxdate=now data-min-date=JointHolders.minDate data-on-date-change=HolderApproval.changeStartDateJointHolder ng-disabled=HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome showdefault=\"\'true\'\" required> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i><label>As on DD/MM/YYYY <span ng-if=\"!(holder.jointHolderApplicantDetail.grossAnnualIncome)\n                ||(holder.jointHolderApplicantDetail.netWorth)\" class=req>*</span></label><span ng-show=\"HolderApproval.holder.jointHolderApplicantDetail.netWorth\n                   && !HolderApproval.holder.jointHolderApplicantDetail.netWorthDate\"><span class=error-input>{{HolderApproval.CONST.ToastrMessage.VALIDATE_DATA.DATE_REQUIRED}}</span></span></div></div></div></div><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=row><div class=col-md-6><div class=radio-block><span class=\"radio mg20\"><input type=radio id=politicalStatus1 name=politicalStatus ng-model=HolderApproval.holder.jointHolderApplicantDetail.politicalStatus ng-value=HolderApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=politicalStatus1>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus2 name=politicalStatus ng-model=HolderApproval.holder.jointHolderApplicantDetail.politicalStatus ng-value=HolderApproval.CONST.INVESTOR_POLITICAL_STATUS.RELATED> <span class=check></span></span><label for=politicalStatus2>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio id=politicalStatus3 name=politicalStatus ng-model=HolderApproval.holder.jointHolderApplicantDetail.politicalStatus ng-value=HolderApproval.CONST.INVESTOR_POLITICAL_STATUS.NONE> <span class=check></span></span><label for=politicalStatus3>Not Applicable.</label></div></div></div></div><div class=form-content><div class=\"row pdt10\"><div class=\"col-md-3 pos-relative\"><!--<label class=\"customized-label custom-top top25\">Address Type</label>--><p><strong>FATCA or CRS information</strong></p><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:JointHolderForm.occupation.$dirty && JointHolderForm.occupation.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=HolderApproval.holder.jointHolderApplicantDetail.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in HolderApproval.addressDescriptions\" required><option value=\"\" selected>Address Type</option></select><span ng-show=\"JointHolderForm.fatcaAddressType.$dirty && JointHolderForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=JointHolderForm.fatcaAddressType.$error.required ng-bind=JointHolders.validateData.FOLIO_REQUIRED></span> </span><span class=req>*</span></div></div><div class=\"col-md-3 col-md-offset-1 pos-relative\"><label class=\"customized-label custom-top top25\" ng-if=\"HolderApproval.formData.soleApplicantDetail.birthCountry || HolderApproval.formData.guardianDetails.basicDetails.birthCountry\">Country of Birth</label><div class=\"input-select input-normal selectfield\" style=\"margin-top: 25px\" ng-class=\"{error:JointHolderForm.birthCountry.$dirty && JointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=HolderApproval.holder.jointHolderApplicantDetail.birthCountry ng-options=\"country.countryName as country.countryName for country in HolderApproval.countryList\" required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"JointHolderForm.birthCountry.$dirty && JointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=JointHolderForm.birthCountry.$error.required>{{JointHolderForm.validations.COUNTRY}}</span></span></div></div></div><div class=\"row pdt20\"><div class=col-md-3><div class=\"input-select input-normal\" ng-class=\"{error:JointHolderForm.birthCity.$dirty && JointHolderForm.birthCity.$invalid}\"><input type=text name=birthCity ng-model=HolderApproval.holder.jointHolderApplicantDetail.birthCity ng-pattern=\"/^[a-zA-Z ]+$/\" capitalize required ng-maxlength=35> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><span ng-show=\"JointHolderForm.birthCity.$dirty && JointHolderForm.birthCity.$invalid\"><span class=error-input ng-show=JointHolderForm.birthCity.$error.required>{{HolderApproval.CONST.ToastrMessage.VALIDATE_DATA.CITY}}</span> <span class=error-input ng-show=JointHolderForm.birthCity.$error.maxlength>{{HolderApproval.CONST.ToastrMessage.VALIDATE_DATA.MAX_LENGTH_CITY_OF_BIRTH}}</span></span></div></div></div></div><div class=\"form-content inves-pay\"><div class=row><div class=col-md-6><p>Does the investor pay or file tax other than India?</p><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaYes name=payTaxInIndia ng-model=HolderApproval.holder.jointHolderApplicantDetail.payTaxInIndia ng-change=HolderApproval.fileTaxActionJointHolder() ng-value=false required> <span class=check></span></span><label for=payTaxInIndiaYes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=payTaxInIndiaNo name=payTaxInIndia ng-model=HolderApproval.holder.jointHolderApplicantDetail.payTaxInIndia ng-change=HolderApproval.fileTaxActionJointHolder() ng-value=true required> <span class=check></span></span><label for=payTaxInIndiaNo>No</label></span></div></div></div><div class=form-content ng-show=!HolderApproval.holder.jointHolderApplicantDetail.payTaxInIndia><div class=row><div class=col-md-12><div class=tax-res ng-repeat=\"payoutdata in HolderApproval.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses\"><p><strong>Tax Residency Country</strong> <span ng-show=\"$index>0\" class=remove-item ng-click=HolderApproval.deleteTaxResidencyJointHolder($index)><i class=delete-icon></i></span></p><div class=row><div class=col-md-3><div class=\"input-select input-normal selectfield mgt0\" ng-class=\"{error:JointHolderForm[\'birthCountry-\'+$index].$dirty && JointHolderForm[\'birthCountry-\'+$index].$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry-$index ng-model=payoutdata.countryName ng-options=\"country.countryName as country.countryName for country in HolderApproval.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" required><option value=\"\" selected>Name Of Country</option></select><span class=req>*</span> <span ng-show=\"JointHolderForm[\'birthCountry-\'+$index].$dirty && JointHolderForm[\'birthCountry-\'+$index].$invalid\"><span class=error-input ng-show=\"JointHolderForm[\'birthCountry-\'+$index].$error.required\">{{JointHolders.validations.COUNTRY}}</span></span></div></div><div class=\"col-md-3 col-md-offset-1\"><div class=\"input-select input-normal selectfield mgt0\"><select class=\"browser-default custom-select\" name=taxIdType-{{$index}} ng-model=payoutdata.taxIdType ng-options=\"taxidtype.key as taxidtype.value for taxidtype in HolderApproval.taxIdTypeList\" required><option value=\"\" selected>Tax ID Type</option></select><span class=req>*</span></div></div></div><div class=row><div class=col-md-3><div class=\"input-select input-normal mgt18\"><input type=text name=taxIdNumber-{{$index}} maxlength=20 ng-model=payoutdata.taxIdNumber capitalize required> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label></div></div></div><div class=\"col-md-12 add-another-tax-res\" ng-show=\"payoutdata.countryName &&\n                      payoutdata.taxIdNumber &&\n                      payoutdata.taxIdType\"><a ng-show=\"(HolderApproval.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length)*1<3\n                    && (HolderApproval.holder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length)*1 == ($index*1+1)\" href=\"\" class=text-blue ng-click=HolderApproval.addMoreTaxResidencyJointHolder()><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></div></div></div><!-- <div id=\"tab-container\" class=\"tab-container clearfix\">\n              <ul class=\"mobile-hide nav nav-tabs\">\n                <li>\n                  <h3>Nominee Details</h3>\n                </li>\n              </ul>\n            </div>\n\n            <section class=\"minor-details\">\n              <div class=\"box-body\">\n                <div class=\"box-details clearfix\">\n                  <div class=\"col-md-4\" ng-if=\"HolderApproval.nominees && HolderApproval.nominees.length > 0 ? false : true\">\n                    <p style=\"margin-top: 0px\" class=\"nomargin\"><strong>No data available</strong></p>\n                  </div>\n                  <div class=\"col-md-4\" ng-repeat=\"nominee in HolderApproval.nominees\">\n                    <p style=\"margin-top: 0px\" class=\"nomargin\"><strong>Nominee {{$index+1}} Detail</strong></p>\n                    <table class=\"table\">\n                      <tr>\n                        <td><span><strong>Nominee Name:</strong></span> &nbsp; <span>{{nominee.nomineeName}}</span></td>\n                      </tr>\n                      <tr>\n                        <td><span><strong>Nominee Relation:</strong></span> &nbsp; <span>{{nominee.nomineeRelation}}</span></td>\n                      </tr>\n                      <tr>\n                        <td><span><strong>Nominee Dob:</strong></span> &nbsp; <span>{{nominee.dob}}</span></td>\n                      </tr>\n                      <tr>\n                        <td><span><strong>Nominee Percentage:</strong></span> &nbsp; <span>{{nominee.percentage}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.soleAddressApplicable\">\n                        <td><span><strong>Address Details:</strong></span> &nbsp; <span>Same As Investor</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine1 && !nominee.minor\">\n                        <td><span><strong>Nominee AddressLine1:</strong></span> &nbsp; <span>{{nominee.nomineeAddress.addressLine1}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine2 && !nominee.minor\">\n                        <td><span><strong>Nominee AddressLine2:</strong></span> &nbsp; <span>{{nominee.nomineeAddress.addressLine2}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.addressLine3 && !nominee.minor\">\n                        <td><span><strong>Nominee AddressLine3:</strong></span> &nbsp; <span>{{nominee.nomineeAddress.addressLine3}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.city && !nominee.minor\">\n                        <td><span><strong>Nominee\'s City:</strong></span> &nbsp; <span>{{nominee.nomineeAddress.city}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.countryName && !nominee.minor\">\n                        <td><span><strong>Nominee\'s Country:</strong></span> &nbsp; <span ng-bind=\"nominee.nomineeAddress.countryName\">{{nominee.nomineeAddress.countryName}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.nomineeAddress && nominee.nomineeAddress.pinCode && !nominee.minor\">\n                        <td><span><strong>Nominee\'s PinCode:</strong></span> &nbsp; <span>{{nominee.nomineeAddress.pinCode}}</span></td>\n                      </tr>\n                      <tr>\n                        <td ng-if=\"nominee.guardianName  && nominee.minor\"><span><strong>Guardian Name:</strong></span> &nbsp; <span>{{nominee.guardianName}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine1 && nominee.minor\">\n                        <td><span><strong>Guardian\'s AddressLine1:</strong></span> &nbsp; <span>{{nominee.guardianAddress.addressLine1}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine2  && nominee.minor\">\n                        <td><span><strong>Guardian\'s AddressLine2:</strong></span> &nbsp; <span>{{nominee.guardianAddress.addressLine2}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.addressLine3  && nominee.minor\">\n                        <td><span><strong>Guardian\'s AddressLine3:</strong></span> &nbsp; <span>{{nominee.guardianAddress.addressLine3}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.city  && nominee.minor\">\n                        <td><span><strong>Guardian\'s City:</strong></span> &nbsp; <span>{{nominee.guardianAddress.city}}</span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.countryName  && nominee.minor\">\n                        <td><span><strong>Guardian\'s Country:</strong></span> &nbsp;\n                          <span>\n                            {{nominee.guardianAddress.countryName}}\n                          </span></td>\n                      </tr>\n                      <tr ng-if=\"nominee.guardianAddress && nominee.guardianAddress.pinCode && nominee.minor\">\n                        <td><span><strong>Guardian\'s PinCode:</strong></span> &nbsp; <span>{{nominee.guardianAddress.pinCode}}</span></td>\n                      </tr>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </section>--><div class=\"form-footer form-content\" ng-hide=HolderApproval.actionTaken><button type=button class=\"btn btn-negative-action\" ng-click=HolderApproval.confirmCancelModaltoReject()>Reject Folio</button> <button class=\"btn btn-primary-action\" ng-disabled=\"JointHolderForm.$invalid ||\n              (HolderApproval.holder.jointHolderApplicantDetail.netWorth && !HolderApproval.holder.jointHolderApplicantDetail.netWorthDate) ||\n              (!HolderApproval.holder.jointHolderApplicantDetail.netWorthDate && !HolderApproval.holder.jointHolderApplicantDetail.grossAnnualIncome)\n              \" ng-click=HolderApproval.approveFolioSubmit()>Approve</button></div></div></form></div></div></div></div><style>.box-details .col-md-4.ng-scope {\n    margin: 22px 10px 10px 25px;\n    font-size: 16px;\n  }</style>");
$templateCache.put("app/investors/summary/investorApproval/lumpsum/lumpsumApproval.html","<div class=\"approval investment main-section\" ng-init=Notification.init()><h3 class=page-title><small>Investment for </small><br><span>Aakash Sharma</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li><strong>Distributor Name:</strong> Tejas Consultancy Pvt. Ltd.</li><li><strong>ARN NO:</strong> 4443026</li><li><strong>EUIN NO:</strong> 18900076</li></ul></div><div class=box-body><form autocomplete=off><p><strong>Purchase Investment</strong></p><div class=\"col-md-6 form-row\"><table><tr><td>Selected Scheme</td><td class=col-space>:</td><td class=scheme-name>HDFC Dual Advantage Fund - IDCW</td></tr><tr><td>IDCW Option</td><td class=col-space>:</td><td>Payout</td></tr><tr><td>Amount (in Multiple of 1000)</td><td class=col-space>:</td><td><i class=rupee-grey-icon></i>10000</td></tr></table></div><div class=\"col-md-4 form-row tnc\"><label>Terms & Conditions</label><span class=checkbox><input type=checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>I have read and understood <a href=\"\">Terms &amp; Conditions</a> of Investment</span></span></div><div class=\"form-row form-footer\"><button class=\"btn btn-secondary-action common-btn-padding\">Reject</button> <button class=\"btn btn-primary-action common-btn-padding\">Approve</button></div></form></div></div></div></div>");
$templateCache.put("app/investors/summary/investorApproval/sip/sipApproval.html","<div class=\"approval investment main-section\" ng-init=Notification.init()><h3 class=page-title><small>Investment for </small><br><span>Aakash Sharma</span></h3><div class=box-main><div class=form-box><div class=box-head><ul><li><strong>Distributor Name:</strong> Tejas Consultancy Pvt. Ltd.</li><li><strong>ARN NO:</strong> 4443026</li><li><strong>EUIN NO:</strong> 18900076</li></ul></div><div class=box-body><form autocomplete=off><p><strong>Systematic Investment Plan</strong></p><div class=form-content><div class=row><div class=col-md-6><table><tr><td>Selected Scheme</td><td class=col-space>:</td><td class=scheme-name>HDFC Dual Advantage Fund - IDCW</td></tr><tr><td>Amount (in Multiple of 1000)</td><td class=col-space>:</td><td><i class=rupee-grey-icon></i>10000</td></tr><tr><td>Installment Frequency</td><td class=col-space>:</td><td>Monthly</td></tr><tr><td>Installment Date</td><td class=col-space>:</td><td>1st, April 2017</td></tr></table></div></div></div><div class=form-content><div class=row><div class=col-md-4><label><strong>OTM Details</strong></label><p class=\"text-blue provide-details\">Please provide Bank Details</p></div></div></div><div class=\"form-content bank-info\"><div class=row><div class=col-md-4><div class=selectfield><label>Select Bank</label><select class=\"browser-default custom-select\" name=bankName ng-model=Modal.bankdata><option value=\"\" selected>Select Bank</option><option ng-repeat=\"bank in Modal.bankList\" value={{bank}}>{{bank.bankName}}</option></select></div></div></div></div><div class=form-content><div class=row><div class=col-md-12><label><strong>EUIN Number</strong></label></div></div><div class=\"row choose-euin-options\"><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=enterEuin name=enterEuin ng-model=FolioApproval.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=enterEuin class=radio-label>EUIN</label></div></div><div class=col-md-2><div class=radio-block><span class=\"radio mg20\"><input type=radio id=selfDeclaration name=selfDeclaration ng-model=FolioApproval.formData.folioCreationRequestCO.soleApplicantDetail.politicalStatus ng-value=FolioApproval.CONST.INVESTOR_POLITICAL_STATUS.POLITICAL> <span class=check></span></span><label for=selfDeclaration class=radio-label>EUIN Declaration <i class=tooltip-info-icon></i></label></div></div></div><div class=\"row euin-number\"><div class=col-md-4><div class=\"input-select input-normal selectfield select-euin\" ng-class=\"{error:FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=FolioApproval.formData.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType ng-options=\"_type.value as _type.addressDescription for _type in FolioApproval.addressDescriptions\" required><option value=\"\" selected>Select EUIN Number</option></select><span ng-show=\"FolioApproval.soleApplicantForm.fatcaAddressType.$dirty && FolioApproval.soleApplicantForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=FolioApproval.soleApplicantForm.fatcaAddressType.$error.required ng-bind=FolioApproval.validateData.ADDRESS_TYPE></span> </span><span class=req>*</span></div></div></div><div class=\"row declaration\"><div class=col-md-12><span class=checkbox><input type=checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this transaction is executed without any interaction or advice by the employee/relationship manager/sales person of the above distributor/sub broker or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor/sub broker.</span></span></div></div></div><div class=form-content><div class=row><div class=\"col-md-6 col-xs-12\"><table><tr><td>Bank Name</td><td class=col-space>:</td><td>ICICI Bank Ltd</td></tr><tr><td>Account Type / No</td><td class=col-space>:</td><td>ICI / 07761052228765</td></tr><tr><td>Branch City</td><td class=col-space>:</td><td>Saket, New Delhi</td></tr><tr><td>IFSC Code</td><td class=col-space>:</td><td>KBK 000011115</td></tr></table></div><div class=\"col-md-6 col-xs-12\"><table><tr><td>Payout Method</td><td class=col-space>:</td><td>RTGS/NEFT</td></tr><tr><td>Bank Account</td><td class=col-space>:</td><td>0001298768</td></tr><tr><td>Mode of Holding</td><td class=col-space>:</td><td>Individual</td></tr></table></div></div></div><div class=\"col-md-4 form-row tnc\"><label>Terms & Conditions</label><span class=checkbox><input type=checkbox> <span class=icon-checkbox></span> <span class=checkbox-text>I have read and understood <a href=\"\">Terms &amp; Conditions</a> of Investment</span></span></div><div class=\"form-row form-footer\"><button class=\"btn btn-secondary-action common-btn-padding\">Reject</button> <button class=\"btn btn-primary-action common-btn-padding\">Approve</button></div></form></div></div></div></div>");
$templateCache.put("app/new-investor/investment-detail/scheme-details/investment-goal/investment-goal.html","<div id=investmentgoal ng-init=InvestmentGoal.init()><br><div class=investment-tabs><span ng-repeat=\"folioValue in InvestmentGoal.InvestmentGoalList track by $index\"><span class=investment-capsule data={{$index+1}} style=\"font-size: 12px\" ng-class=\"{\'active\': InvestmentGoal.selectedInvestmentGoalName == folioValue.goalName}\" ng-click=InvestmentGoal.changeInvestmentGoal(folioValue.goalName)><img class=goalicons ng-src=\"{{InvestmentGoal.selectedInvestmentGoalName == folioValue.goalName ? folioValue.iconAcitve : folioValue.icon}}\" alt=\"\" srcset=\"\"> {{folioValue.goalName}}</span></span></div><div><h5 ng-if=\"InvestmentGoal.SelectedInvestmentGoalDetailsList.length == 0\" style=\"color: red\">Records not found!</h5><div class=row style=\"margin: 0\"><div class=\"investment-goal-details col-xs-11 col-sm-6 col-md-4\" ng-repeat=\"details in InvestmentGoal.SelectedInvestmentGoalDetailsArray\" style=\"min-height: 240px\"><div class=innerDiv><label class=title1 style=\"height: 70px\">{{details.fundName}}</label><br><label class=description style=\"font-size: 12px;height: 48px;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;\n          text-overflow: ellipsis;margin-bottom:0px;line-height: 17px\">{{details.description}}</label><br><div class=investment-sub-details><div class=left-box><label style=\"font-size: 12px;color: #689ec7\">Inception Date</label><label>{{details.inceptionDate}}</label></div><div class=right-box><p style=\"font-size: 12px;color: #689ec7\">AUM Value</p><p>{{details.aumValue}}</p></div></div><div class=investment-risk-meter><p style=\"font-size: 11px; color: #689ec7\">Risk Return Profile:</p><p style=\"font-weight: bold\">High Risk</p><img ng-if=details.riskReturnProfile src={{details.riskReturnProfile}} alt=Unavailable srcset=\"\" style=\"width: 95px;height: 71px;margin-left: -14px\"></div><div class=investment-goal-select-scheme><p style=\"font-size: 14px;font-weight: bold; width: 100%; text-align: center\">Select Scheme</p><select ng-model=details.selectedInvestmentGoalcard ng-change=InvestmentGoal.changeInvestmentGoalcard(details) ng-options=\"item.schemeName for item in details.regularSchemes\" ng-selected=\"details.selectedInvestmentGoalcard.schemeCode == value.schemeCode\" style=\"height: 35px;width: 100%;border-radius: 5px;width: 75% !important\"><option value=\"\" selected>Select Scheme</option></select></div></div></div></div><br><div style=\"display: flex;justify-content: flex-end;background: white;padding: 12px\"><p>Pages :</p><p ng-repeat=\"x in InvestmentGoal.pageArray\" ng-click=InvestmentGoal.getPageData(x) ng-class=\"x == InvestmentGoal.CurrentPage ? \'text-primary\' : \'text-dark\' \">{{x}},</p>&nbsp; <button ng-click=InvestmentGoal.prev() ng-disabled=\"InvestmentGoal.CurrentPage == 1\">&#60;</button> &nbsp; <button ng-click=InvestmentGoal.nextPage() ng-disabled=\"InvestmentGoal.CurrentPage == InvestmentGoal.pageArray[InvestmentGoal.pageArray.length - 1 ]\">&#62;</button></div></div><button class=\"continue-btn btn-new-journey-color hdfc-blue-cta-small\" ng-disabled=\"!InvestmentGoal.selectedscheme && !InvestmentGoal.selectedCard\" ng-click=InvestmentGoal.next()>INVEST</button></div><style>.investmentTitle1{\n    font-weight: bold;\n  }\n  .new-investors .kyc-form-container {\n    padding: 8% 30px 10% 6% !important; \n    margin-left: -46px !important;\n  }</style>");
$templateCache.put("app/new-investor/investment-detail/scheme-details/select-scheme/select-scheme.html","<div class=choosescheam ng-init=SelectScheme.init()><br><div class=row><div class=col-md-4><select class=\"browser-default custom-select\" name=schemeCategory ng-model=SelectScheme.selectedschemeCategory ng-options=\"schemeCategoryList for schemeCategoryList in SelectScheme.schemeCategoryList\" ng-change=SelectScheme.changeSchemeCategory() required style=\"width: 100%;height: 40px;border-radius: 6px;background: white\"><option value=\"\" selected>select your scheme</option></select></div><div class=col-md-8><input class=\"form-control search-fund\" type=text name=searchscheam id=searchscheam placeholder=\"&nbsp;&nbsp;&nbsp;Search by fund name\" ng-model=SelectScheme.filterwithname ng-change=SelectScheme.changewithFilterName() style=\"height: 40px\"></div></div><br><div><div style=\"margin-left: 15px\"><h5 ng-if=\"SelectScheme.selectedschemeCategoryDetails.length == 0\" style=\"color: red\">Records Not Found!</h5><div class=\"row schemeRow\" ng-repeat=\"x in SelectScheme.selectedschemeCategoryDetails track by $index\"><div class=\"col-xs-12 col-md-4 m-b5 w-100\"><p class=schemeTitle>{{x.fundName}}</p><!-- <p class=\"schemeTitileHead\">Hybrid Equity Plan</p> --></div><div class=\"col-xs-4 col-md-1 m-b5\"><p class=schemeTitileHeadBold>{{x.aumValue}} (CR)</p><p class=schemeTitileHead>AUM Value</p></div><div class=\"col-xs-4 col-md-1 m-b5\"><p class=schemeTitle>{{x.regularOneYearReturn}} %</p><p class=schemeTitileHead>1 Year return</p></div><div class=\"col-xs-4 col-md-2 m-b5\"><p style=\"font-size: 12px;color: #ff8486;cursor: pointer\" ng-click=SelectScheme.toggleDetails($index) ng-if=!x.Expand>+ SHOW DETAILS</p><p style=\"font-size: 12px;color: #ff8486;cursor: pointer\" ng-click=SelectScheme.toggleDetails($index) ng-if=x.Expand>- HIDE DETAILS</p></div><div class=\"col-xs-12 col-md-2 m-b5\"><select ng-model=x.selectedScheme ng-options=\" item.schemeName for item in x.regularSchemes\" ng-selected=\"x.selectedScheme.schemeCode == value.schemeCode\" style=\"width: 100% !important;height: 40px;border-radius: 6px\"><option value=\"\" selected>Select Scheme</option></select></div><div class=\"col-xs-6 col-md-1 m-b5\"><button class=btn-new-journey-color type=button ng-disabled=!x.selectedScheme style=\"color: white; height: 30px;width: 100px;border: none;border-radius: 15px;color: white;font-size: 12px\" ng-click=SelectScheme.getScheme(x)>INVEST</button></div><div class=col-md-12 ng-if=x.Expand><hr></div><div class=\"col-xs-12 col-md-12\" ng-if=x.Expand style=\"padding-bottom: 10px\"><div class=row><div class=\"col-xs-12 col-md-4 w-100\"><div ng-repeat=\"fundmanager in x.fundManagers\"><p class=\"schemeTitle m-m-top\">{{fundmanager}}</p></div><p class=schemeTitileHead>Fund Manager</p></div><div class=\"col-xs-12 col-md-4 w-100\"><p class=schemeTitle>{{x.suggestedInvestmentPeriod}}</p><p class=schemeTitileHead>Suggested Investment Period</p></div></div></div></div></div></div></div><style>.investmentTitle1{\n    font-weight: bold;\n  }\n  .new-investors .kyc-form-container {\n    padding: 8% 30px 10% 6% !important; \n    margin-left: -46px !important;\n  }</style>");
$templateCache.put("app/transactions/initiate/bulk-transaction/initiate/bulk-initiate.html","<div class=\"content bulk-initiate sip-purchase\" ng-hide=BulkInitiate.isSummaryViewEnabled><form autocomplete=off class=sipPurchase-form name=bulkSipPurchaseForm novalidate><div><div class=\"normal-wrap clearfix\"><div class=choose-type><table class=\"table table-sipPurchase\"><tr><td>Investment Type</td><td>:</td><td><div class=\"radio-block blockalignment\"><span class=radio><input type=radio id=purchase name=investmentType ng-model=BulkInitiate.formData.investmentType ng-value=BulkInitiate.TRANSACTION_FORM_TYPE.PURCHASE ng-change=BulkInitiate.changeInvestmentType()> <span class=check></span></span><label for=purchase>Purchase</label></div><div class=\"radio-block blockalignment\"><span class=radio><input type=radio id=sip name=investmentType ng-model=BulkInitiate.formData.investmentType ng-value=BulkInitiate.TRANSACTION_FORM_TYPE.SIP ng-change=BulkInitiate.changeInvestmentType()> <span class=check></span></span><label for=sip>SIP</label></div></td></tr></table><table class=\"table table-custom-sub-fields\"><tr><td>Sub Broker ARN</td><td>:</td><td colspan=2 class=sub-broker-arn><div class=col-md-10><div class=input-normal><input type=text class=arn-no name=subBrokerARNDesk id=subBrokerARN ng-model=BulkInitiate.formData.subBrokerARN ng-change=BulkInitiate.changeSubBrokerArn() ng-blur=BulkInitiate.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                    <label class=\"sub-broker-arn-label\">Sub Broker ARN</label>--><p ng-if=BulkInitiate.subBrokerName class=info-primary>Sub Broker Name: {{BulkInitiate.subBrokerName}}</p><span class=error-input ng-if=\"bulkSipPurchaseForm.subBrokerARNDesk.$dirty && bulkSipPurchaseForm.subBrokerARNDesk.$invalid && bulkSipPurchaseForm.subBrokerARNDesk.$error.pattern\">{{BulkInitiate.VALIDATE_DATA.BROKER_VALID}}</span> <span class=error-input ng-show=\"BulkInitiate.subBrokerCodeError != \'\'\" ng-bind=BulkInitiate.subBrokerCodeError></span></div></div></td><td>Sub Broker Code</td><td>:</td><td colspan=2 class=sub-broker-code><div class=col-md-10><div class=input-normal ng-class={error:bulkSipPurchaseForm.subBrokerCode.$dirty&&bulkSipPurchaseForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=BulkInitiate.formData.subBrokerCode autocomplete=off ng-disabled=\"!BulkInitiate.formData.subBrokerARN || BulkInitiate.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=bulkSipPurchaseForm.subBrokerCode.$dirty&&bulkSipPurchaseForm.subBrokerCode.$error.required ng-bind=BulkInitiate.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-custom-sub-fields-mobile\"><tr><td>Sub Broker ARN</td><td>:</td><td class=sub-broker-arn><div class=col-sm-12><div class=input-normal><input type=text class=arn-no name=subBrokerARN id=subBrokerARN ng-model=BulkInitiate.formData.subBrokerARN ng-change=BulkInitiate.changeSubBrokerArn() ng-blur=BulkInitiate.fetchEuinListSubBroker() ng-pattern=/^[0-9]{1,10}$/ maxlength=10 autocomplete=off restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span> <span class=arn>ARN -</span><!--                    <label>Sub Broker ARN</label>--><p ng-if=BulkInitiate.subBrokerName class=info-primary>Sub Broker Name: {{BulkInitiate.subBrokerName}}</p><span class=error-input ng-if=\"bulkSipPurchaseForm.subBrokerARN.$dirty && bulkSipPurchaseForm.subBrokerARN.$invalid && bulkSipPurchaseForm.subBrokerARN.$error.pattern\">{{BulkInitiate.VALIDATE_DATA.BROKER_VALID}}</span> <span class=error-input ng-show=\"BulkInitiate.subBrokerCodeError != \'\'\" ng-bind=BulkInitiate.subBrokerCodeError></span></div></div></td></tr><tr><td>Sub Broker Code</td><td>:</td><td class=sub-broker-code><div class=col-sm-12><div class=input-normal ng-class={error:bulkSipPurchaseForm.subBrokerCode.$dirty&&bulkSipPurchaseForm.subBrokerCode.$invalid}><input type=text name=subBrokerCode id=subBrokerCode ng-model=BulkInitiate.formData.subBrokerCode autocomplete=off ng-disabled=\"!BulkInitiate.formData.subBrokerARN || BulkInitiate.subBrokerCodeError !=\'\'\" restrict-special-charcter ng-trim=false> <span class=highlight></span> <span class=bar></span><label>Sub Broker Code<!-- <span class=\"req text-red\" ng-if=\"DreamSip.formData.subBrokerARN\">*</span> --></label><span class=error-input ng-show=bulkSipPurchaseForm.subBrokerCode.$dirty&&bulkSipPurchaseForm.subBrokerCode.$error.required ng-bind=BulkInitiate.VALIDATE_DATA.SUB_BROKER_REQUIRED></span></div></div></td></tr></table><table class=\"table table-sipPurchase\"><tr><td>EUIN</td><td>:</td><td><div class=\"col-md-4 col-sm-6 input-euin\"><div class=\"input-select input-normal selectfield select-euin drop-arrow\"><select class=\"browser-default custom-select\" name=selectEuin ng-change=BulkInitiate.euinChanged() ng-model=BulkInitiate.formData.euinCode ng-options=\"euin.euinCode as (euin.euinName+\' - \'+ euin.euinCode) for euin in BulkInitiate.euinList\" required><option value=\"\" selected>Select EUIN Number</option></select><span class=\"req text-red\">*</span></div></div></td></tr></table></div><div class=purchase-form-box ng-if=\"BulkInitiate.formData.investmentType===BulkInitiate.TRANSACTION_FORM_TYPE.PURCHASE\"><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Add a Purchase Scheme</strong></label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=pInScheme1 ng-change=BulkInitiate.filterPurchaseInSchemeList() ng-model=BulkInitiate.formData.inSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=BulkInitiate.purchaseInSchemeList display-key=scheme hdfc-click=BulkInitiate.purchaseInSchemeChanged(data) model=BulkInitiate.formData.inSchemeCode for=pInScheme1></drop-down></div></div></div><div class=\"col-md-1 form-grid mgt50 clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid mgt50 inline-style\"><a ng-click=BulkInitiate.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=row ng-if=\"BulkInitiate.purchaseValidations && !BulkInitiate.purchaseValidations.isGrowth\"><div class=\"col-md-12 form-grid\"><div class=\"install-freq dividend-opts\"><p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p><div class=\"col-md-6 radio-block alignmentIdcw\" ng-class=\"{\'anything-disabled\': BulkInitiate.purchaseValidations.dividendReinvestmentApplicable === false}\"><span class=radio><input type=radio id=sReinvest ng-model=BulkInitiate.formData.purchaseDividendOption ng-value=BulkInitiate.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"BulkInitiate.purchaseValidations.dividendReinvestmentApplicable === false\" name=pDividendOption> <span class=check></span></span><label for=sReinvest>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=\"col-md-6 radio-block alignmentIdcw\" ng-class=\"{\'anything-disabled\': BulkInitiate.purchaseValidations.dividendPayoutApplicable === false}\"><span class=radio><input type=radio id=sPayout ng-model=BulkInitiate.formData.purchaseDividendOption ng-value=BulkInitiate.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"BulkInitiate.purchaseValidations.dividendPayoutApplicable === false\" name=pDividendOption> <span class=check></span></span><label for=sPayout>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div></div></div><div class=sip-form-box ng-if=\"BulkInitiate.formData.investmentType===BulkInitiate.TRANSACTION_FORM_TYPE.SIP\"><div class=row><div class=\"col-md-4 form-grid\"><label><strong>Add a SIP Scheme</strong></label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=sipScheme1 ng-change=BulkInitiate.filterSipSchemeList() ng-model=BulkInitiate.formData.inSchemeName autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=BulkInitiate.sipSchemeList display-key=scheme hdfc-click=BulkInitiate.selectSipScheme(data) model=BulkInitiate.formData.inSchemeCode for=sipScheme1></drop-down></div></div></div><div class=\"col-md-1 form-grid mgt50 clearfix inline-style\"><span>or</span></div><div class=\"col-md-4 form-grid mgt50 inline-style\"><a ng-click=BulkInitiate.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><!--installment frequency controls--><div class=row ng-if=\"BulkInitiate.sipValidations && !BulkInitiate.sipValidations.isGrowth\"><div class=\"col-md-12 form-grid\"><div class=\"install-freq dividend-opts\"><p><strong>Income Distribution cum Capital Withdrawal (IDCW) Option</strong></p><div class=\"col-md-6 radio-block alignmentIdcw\" ng-class=\"{\'anything-disabled\': BulkInitiate.sipValidationsData.dividendReinvestmentApplicable === false}\"><span class=radio><input type=radio id=sReinvest ng-model=BulkInitiate.formData.dividendOption ng-value=BulkInitiate.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"BulkInitiate.sipValidationsData.dividendReinvestmentApplicable === false\" name=sDividendOption> <span class=check></span></span><label for=sReinvest>Re-investment of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div><div class=\"col-md-6 radio-block alignmentIdcw\" ng-class=\"{\'anything-disabled\': BulkInitiate.sipValidationsData.dividendPayoutApplicable === false}\"><span class=radio><input type=radio id=sPayout ng-model=BulkInitiate.formData.dividendOption ng-value=BulkInitiate.DIVIDEND_OPTIONS.PAYOUT ng-disabled=\"BulkInitiate.sipValidationsData.dividendPayoutApplicable === false\" name=sDividendOption> <span class=check></span></span><label for=sPayout>Payout of Income Distribution cum Capital Withdrawal (IDCW) Option</label></div></div></div></div><div class=row><div class=\"col-md-12 form-grid\" style=padding-top:24px><div class=install-freq><p><strong>Installment Frequency</strong></p><div class=\"col-md-2 radio-block\" ng-repeat=\"freq in BulkInitiate.SIP_FREQ_LIST\" ng-if=\"BulkInitiate.SIP_FREQ_LIST.length > 1\" ng-class=\"{\'anything-disabled\': freq.code === \'BZ\' && BulkInitiate.hideOtmRadio}\"><span class=radio><input type=radio id={{freq.name}} ng-change=BulkInitiate.changeFrequency() ng-model=BulkInitiate.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.name}}>{{freq.name}}</label><i class=\"tooltip-info-icon base-tooltip\" ng-if=\"freq.code === \'BZ\'\" tooltip data-toggle=tooltip data-placement=right title=\"Mode of payment through Daily SIP shall be only through OTM of frequency - As and when presented.\n                       SIP Top Up facility is not available for Daily SIP. For Daily SIP, OTM bank must have OTM Instruction Type as AWP. Daily SIP end date can be only on a business day.\"></i></div></div></div></div><div class=row ng-if=\"BulkInitiate.formData.inSchemeName &&\n              (BulkInitiate.selectedFrequency.code !== \'BZ\' && BulkInitiate.selectedFrequency.code !== \'OW\') \"><div class=col-md-12><div class=\"install-freq frequency sip-fi\"><label><strong>Do you wish to pay First installment with your SIP Registration:</strong></label><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=BulkInitiate.formData.sipFirstInstallment ng-change=BulkInitiate.changeFirstInstallment(true) ng-value=true> <span class=check></span></span><label>Yes</label></div><div class=\"radio-block first-installment-radio\"><span class=radio><input type=radio name=sipFirstInstallment ng-model=BulkInitiate.formData.sipFirstInstallment ng-change=BulkInitiate.changeFirstInstallment(false) ng-value=false> <span class=check></span></span><label>No</label></div></div></div></div><!--Installment date details controls--><div class=row><p class=\"col-md-12 pay-mode\"><strong>Installment Date Details</strong></p><div class=\"col-md-4 radio-values\" ng-class=\"{\'anything-disabled\' : !BulkInitiate.formData.inSchemeCode}\"><!-- && BulkInitiate.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode={{BulkInitiate.viewMode}} data-format={{BulkInitiate.startDateFormat}} data-date-default=BulkInitiate.formData.startDate data-enabled-dates=BulkInitiate.enabledStartDates data-min-date=BulkInitiate.startMinDate data-max-date=BulkInitiate.startMaxDate data-on-date-change=BulkInitiate.changeStartDate id=startDate-biller><!--data-min-date=\"BulkInitiate.minStartDate\"--><!--data-max-date=\"BulkInitiate.maxStartDate\"--> <input type=text name=selectStartDate class=form-control autocomplete=off placeholder=\"SIP Start date - DD-MMM-YYYY\" required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div class=row><div class=\"col-md-4 radio-values\" ng-class=\"{\'anything-disabled\' : !BulkInitiate.formData.inSchemeCode}\"><!-- && BulkInitiate.startDateFlag--><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-enable=true data-viewmode=days data-format={{BulkInitiate.startDateFormat}} data-enabled-dates=BulkInitiate.enabledEndDates data-date-default=BulkInitiate.formData.endDate data-min-date=BulkInitiate.minEndDate data-on-date-change=BulkInitiate.changeEndDate data-view-date=BulkInitiate.enabledEndDates[0] showdefault=false id=endDate-Biller><!----> <input type=text name=selectEndDate ng-disabled=BulkInitiate.isTillPerpetuity autocomplete=off class=form-control placeholder=\"SIP End Date - DD-MMM-YYYY\" ng-model=BulkInitiate.formData.endDate required readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div><div class=\"col-md-1 form-grid text-center optional-or\"><span class=text-uppercase>or</span></div><div class=\"col-md-4 form-grid pdl0\"><span class=checkbox style=\"bottom: -3px\"><input type=checkbox id=default-end-date name=endDateOption ng-model=BulkInitiate.endDateSelectionOption ng-change=BulkInitiate.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span class=default-date><strong>Choose Default End Date, which is 2099</strong></span></div></div></div><!-- bulk file upload controls--><div class=\"file-select-row row\"><div class=col-md-3><p><strong>Upload Bulk Transactions Template:</strong></p></div><div class=col-md-6><div class=form-group><input type=hidden name=bulkSipPurchase ng-model=BulkInitiate.myFile required> <span class=upload-button><input id=uploadFileId type=file focus-me=shouldBeOpen value=Browse.. accept=.xls,.xlsx data-bulk-upload=\"\" data-ng-model=BulkInitiate.myFile required><label for=uploadFileId class=\"upload-label btn-upload btn-secondary-action\" ng-click=BulkInitiate.reInitiateFileSelect()>Choose File</label></span><span class=file-name>{{BulkInitiate.myFile.name ? BulkInitiate.myFile.name : \"No File Chosen\"}}</span></div></div></div><div class=row><div class=col-sm-12><ng-bind-html dynamic=BulkInitiate.dynamicDataSip.content ng-if=\"BulkInitiate.formData.investmentType === BulkInitiate.TRANSACTION_FORM_TYPE.SIP\"></ng-bind-html><ng-bind-html dynamic=BulkInitiate.dynamicDataPurchase.content ng-if=\"BulkInitiate.formData.investmentType === BulkInitiate.TRANSACTION_FORM_TYPE.PURCHASE\"></ng-bind-html></div></div><div class=row><div class=col-sm-12><div class=\"tc-block bulk-tnc\" ng-show=BulkInitiate.showTerms><h6>Terms & Conditions</h6><div><div class=checkbox><input name=isCheckedTandC ng-model=BulkInitiate.isCheckedTandC type=checkbox required> <i class=icon-checkbox></i> <span class=checkbox-text>I have read and understood <a ng-click=BulkInitiate.termsAndContitions() href=javaScript:void(0)>Terms & Conditions</a> of Investment</span></div></div></div></div></div><div class=row><div class=col-sm-12><div class=\"form-footer form-content\"><span class=\"pull-right buttons-block\"><a href=javaScript:void(0); class=\"btn btn-secondary-action\" ng-click=BulkInitiate.cancelTransaction()>Cancel</a> <button class=\"btn btn-primary-action\" ng-disabled=\"bulkSipPurchaseForm.$invalid || !BulkInitiate.isCheckedTandC || BulkInitiate.subBrokerCodeError\" ng-click=BulkInitiate.submitBulkSubmission()>Continue</button></span></div></div></div></div></div></form></div><div ng-if=BulkInitiate.isSummaryViewEnabled><bulk-transaction-summary form-data=BulkInitiate.summaryData is-summary-view-enabled=BulkInitiate.isSummaryViewEnabled transaction-type={{BulkInitiate.transactionType}}></bulk-transaction-summary></div><style>.sip-purchase .sipPurchase-form .normal-wrap .choose-type .table-sipPurchase tr td .blockalignment{\n    width: auto;\n  }\n  @media (min-width:1025px)and (max-width: 1210px) {\n    .alignmentIdcw {\n      display: flex;\n      justify-content: flex-start;\n      align-items: baseline;\n    }\n    .alignmentIdcw label{\n      position: relative;\n      top: -4px !important;\n    }\n  }</style>");
$templateCache.put("app/transactions/initiate/bulk-transaction/summary/bulk-transaction.summary.html","<div class=container-fluid><div class=\"row content bulk-summary sip-purchase\"><div class=col-sm-12><div class=\"row details-row\"><div class=col-sm-12><p class=success>Bulk Transaction File uploaded successfully</p><div class=row><div class=\"col-xs-8 col-sm-3\"><span class=total>Total Transactions</span></div><div class=\"col-xs-1 col-sm-2\"><span class=total>:</span></div><div class=\"col-xs-2 col-sm-7\"><span class=total>{{formValue.stats.TOTAL_COUNT}}</span></div></div><div class=row><div class=\"col-xs-8 col-sm-3\"><span class=success>Transactions loaded successfully</span></div><div class=\"col-xs-1 col-sm-2\"><span class=success>:</span></div><div class=\"col-xs-2 col-sm-7\"><span class=success>{{formValue.stats.SUCCESS}}</span></div></div><div class=row><div class=\"col-xs-8 col-sm-3\"><span class=failed>Transactions loaded with errors</span></div><div class=\"col-xs-1 col-sm-2\"><span class=failed>:</span></div><div class=\"col-xs-2 col-sm-7\"><span class=failed>{{formValue.stats.FAILURE}}</span></div></div><div class=row><div class=col-sm-12><p class=imp-information>NOTE: Only transactions loaded successfully shall be sent for approval to your investors. You can view previous bulk transactions initiated for your investors by clicking on <strong>\"View Status\"</strong> tab.</p></div></div><div class=row><div class=col-sm-12><span class=buttons-block><button class=\"btn btn-primary-action\" ng-disabled=\"formValue.stats.SUCCESS === 0\" ng-click=sendForApproval()>Send for Approval</button> <button class=\"btn btn-primary-action\" ng-click=redirectToInitiate()>Cancel</button></span></div></div></div></div><div class=\"row bulk-row\"><div class=col-sm-12><div class=row><div class=col-sm-4><div class=search-data><div class=search-bar><i class=search-icon></i> <input type=search placeholder=\"Search Investors, Folio No\" ng-model=searchText ng-change=searchList(); select-on-click class=blank-input></div></div></div></div><div class=row><div class=col-sm-12><div class=\"panel-group accordion-group\" id=accordion role=tablist aria-multiselectable=true><div class=\"panel panel-default\"><a role=button data-toggle=collapse data-parent=#accordion href=#collapseOne aria-expanded=false aria-controls=collapseOne ng-click=collapseExpand()><div class=panel-heading role=tab id=heading><span>( <span class=\"glyphicon glyphicon-minus\"></span> )</span><h4 class=panel-title>Bulk Transaction ({{date}} | Transaction - {{transactionType}})</h4></div></a><div id=collapseOne class=\"panel-collapse collapse in\" role=tabpanel aria-labelledby=heading><div class=\"panel-body table-responsive\"><table class=\"table table-striped rwd-table\"><thead><tr><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th ng-if=formValue.sipWithFirstInstallment>SIP First Installment</th><th ng-if=formValue.sipWithFirstInstallment>SIP First Installment Amount</th><th>Status</th><th>Status Description</th></tr></thead><tbody><tr ng-repeat=\"transaction in folioDetailsWithNameCopy track by $index\"><td>{{transaction.investorName}}</td><td>{{transaction.folioNumber}}</td><td><i class=rupee-icon></i>{{transaction.amount}}</td><td>{{formValue.formData.schemeName}}</td><td ng-if=formValue.sipWithFirstInstallment>{{formValue.sipWithFirstInstallment ? \'Yes\': \'No\'}}</td><td ng-if=formValue.sipWithFirstInstallment><i class=rupee-icon></i>{{transaction.amount}}</td><td><span class={{transaction.status.toLowerCase()}}>{{transaction.statusField}}</span></td><td class=status_description><span class={{transaction.status.toLowerCase()}}><span ng-if=\"transaction.statusDescription.length > 70 && !transaction.panAdharUrl\">{{transaction.statusDescription.substring(0, 70)}} ... <a role=button ng-click=showMore(transaction.statusDescription)>More</a> </span><span ng-if=\"transaction.statusDescription.length > 70 && transaction.panAdharUrl\">{{transaction.statusDescription.substring(0, 42)}} ... <a role=button ng-click=showMore(transaction.statusDescription,transaction.panAdharUrl)>More</a> </span><span ng-if=\"transaction.statusDescription.length <= 70\">{{transaction.statusDescription}}</span></span></td></tr><tr class=text-center ng-if=\"!(folioDetailsWithNameCopy.length >0)\"><td colspan=6>No Record found</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/transactions/initiate/bulk-transaction/view-status/bulk-status.html","<div class=\"investors bulk-status\"><div class=\"tab-content investors-listing\"><div id=all class=\"tab-pane fade in active\"><div class=\"search-data row sip-corner-filter\"><div class=search-bar><i class=search-icon></i> <input type=search placeholder=\"Search Investors, Folio No\" ng-model=BulkStatus.searchText ng-change=BulkStatus.searchList(); select-on-click class=blank-input></div><div style=\"float: right\" class=bulk-transaction-selection><select class=custom-select id=transactTypeSIP ng-change=BulkStatus.transactionEvents.onSelectionChanged() ng-model=BulkStatus.transactionType ng-options=\"_type.value as _type.key for _type in BulkStatus.TRANSACTION_TYPES\"><option value=\"\" selected>Transaction Type (All)</option></select><!--<span ng-dropdown-multiselect=\"\" options=\"BulkStatus.TRANSACTION_TYPES\" id=\"transactTypeSIP\"\n                selected-model=\"BulkStatus.transactionType\" events=\"BulkStatus.transactionEvents\"\n                extra-settings=\"BulkStatus.transactionSettings\" translation-texts=\"BulkStatus.transactionTranslationTexts\"\n                class=\"sip-multiselect\">\n          </span>--></div><div class=bulk-date-selection><div><input date-range=\"\" on-date-change=BulkStatus.filterByDate placeholder=\"From Date -> To Date\" date-min=BulkStatus.minDate date-max=BulkStatus.maxDate date-max-span=14 date-default=BulkStatus.dateFilter class=\"date-picker transactSIPdate\" type=text></div></div></div><!-- to display all transaction details--><div class=\"list data-grid bulk-listing\" ng-if=\"BulkStatus.bulkTransactionList.length === 0 && !BulkStatus.isSearching\"><p class=\"text-center no-records\">No bulk transactions initiated by you</p></div><div class=\"list data-grid bulk-listing\" ng-if=!BulkStatus.isSearching><div class=\"panel-group accordion-group\" id=accordion role=tablist aria-multiselectable=true><div class=\"panel panel-default\" ng-repeat=\"option in BulkStatus.bulkTransactionList track by $index\"><a role=button data-toggle=collapse data-parent=#accordion href=#collapseOne-{{$index}} aria-expanded=false aria-controls=collapseOne-{{$index}} ng-click=\"BulkStatus.fetchDetailedRecords(option.referenceNo, \'collapseOne-\' + $index)\"><div class=panel-heading role=tab id=heading><span>( <span class=\"glyphicon glyphicon-plus\"></span> ) &nbsp;</span><h4 class=panel-title>Bulk Transaction (Ref. No. {{option.referenceNo}} | {{option.createdDate}} | Transaction - {{option.transactionType}})</h4></div></a><div id=collapseOne-{{$index}} class=\"panel-collapse collapse\" role=tabpanel aria-labelledby=heading><div class=\"panel-body table-responsive\"><table class=\"table table-striped rwd-table\"><thead><tr><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><th>Status</th><th>Status Description</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"details in BulkStatus.bulkTransactionDetailList\"><td>{{details.investorName}}</td><td>{{details.folioNo}}</td><td><i class=rupee-icon></i>{{details.amount}}</td><td>{{details.schemeName}}</td><td>{{details.createdDate}}</td><td><span class={{BulkStatus.status[details.transactionState.toLowerCase()]}}>{{details.transactionState}}</span></td><td class=status_description><span class={{BulkStatus.status[details.transactionState.toLowerCase()]}}><span ng-if=\"details.statusDescription.length > 70 && !details.panAdharUrl\">{{details.statusDescription.substring(0, 70)}} ... <a role=button ng-click=BulkStatus.showMore(details.statusDescription)>More</a> </span><span ng-if=\"details.statusDescription.length > 70 && details.panAdharUrl\">{{details.statusDescription.substring(0, 42)}} ... <a role=button ng-click=BulkStatus.showMore(details.statusDescription,details.panAdharUrl)>More</a> </span><span ng-if=\"details.statusDescription.length <= 70\">{{details.statusDescription}}</span></span></td><td><span ng-if=details.remark><i class=\"tooltip-info-icon base-tooltip\" tooltip data-toggle=tooltip data-placement=top title={{details.remark}}></i></span></td></tr><tr class=text-center ng-if=\"(BulkStatus.bulkTransactionDetailList.length === 0)\"><td colspan=8>No Record found</td></tr></tbody></table><div ng-if=BulkStatus.isDetailPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"BulkStatus.totalBulkListDetailData <= BulkStatus.PAGE_LIMITS[0]\">{{BulkStatus.totalBulkListDetailData}} of {{BulkStatus.totalBulkListDetailData}}</span><select ng-if=\"BulkStatus.totalBulkListDetailData > BulkStatus.PAGE_LIMITS[0]\" ng-change=BulkStatus.detailLimitChanged() class=bulk-pagination ng-model=BulkStatus.detailPageLimit ng-options=\"_limit as _limit for _limit in BulkStatus.PAGE_LIMITS\"></select><span class=t-black ng-if=\"BulkStatus.totalBulkListDetailData > BulkStatus.PAGE_LIMITS[0]\">of {{BulkStatus.totalBulkListDetailData}}</span></div><ul uib-pagination total-items=BulkStatus.totalBulkListDetailData ng-model=BulkStatus.currentPageBulkListDetails max-size=5 items-per-page=BulkStatus.detailPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=BulkStatus.fetchDetailedRecords(option.referenceNo) rotate=false></ul></div></div></div></div></div><div ng-if=BulkStatus.isPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"BulkStatus.totalBulkListData <= BulkStatus.PAGE_LIMITS[0]\">{{BulkStatus.totalBulkListData}} of {{BulkStatus.totalBulkListData}}</span><select ng-if=\"BulkStatus.totalBulkListData > BulkStatus.PAGE_LIMITS[0]\" ng-change=BulkStatus.limitChanged() class=bulk-pagination ng-model=BulkStatus.selectedPageLimit ng-options=\"_limit as _limit for _limit in BulkStatus.PAGE_LIMITS\"></select><span class=t-black ng-if=\"BulkStatus.totalBulkListData > BulkStatus.PAGE_LIMITS[0]\">of {{BulkStatus.totalBulkListData}}</span></div><ul uib-pagination total-items=BulkStatus.totalBulkListData ng-model=BulkStatus.currentPageBulkList max-size=5 items-per-page=BulkStatus.selectedPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=BulkStatus.init() rotate=false></ul></div></div><div class=\"list data-grid bulk-listing\" ng-if=BulkStatus.isSearching><table class=\"table table-striped table-responsive rwd-table\"><thead><tr><th>Bulk Transaction Ref. No.</th><th>Investor Name</th><th>Folio Number</th><th>Amount</th><th>Scheme</th><th>Transaction Processing Date</th><th>Status</th><th>Status Description</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat=\"details in BulkStatus.searchListData\"><td>{{details.referenceNumber}}</td><td>{{details.investorName}}</td><td>{{details.folioNo}}</td><td><i class=rupee-icon></i>{{details.amount}}</td><td>{{details.schemeName}}<br><span>Type : </span><span>{{details.transactionType}}</span></td><td>{{details.createdDate}}</td><td><span class={{BulkStatus.status[details.transactionState.toLowerCase()]}}>{{details.transactionState}}</span></td><td class=status_description><span class={{BulkStatus.status[details.transactionState.toLowerCase()]}}><span ng-if=\"details.statusDescription.length > 70 && !details.panAdharUrl\">{{details.statusDescription.substring(0, 70)}} ... <a role=button ng-click=BulkStatus.showMore(details.statusDescription)>More</a> </span><span ng-if=\"details.statusDescription.length > 70 && details.panAdharUrl\">{{details.statusDescription.substring(0, 42)}} ... <a role=button ng-click=BulkStatus.showMore(details.statusDescription,details.panAdharUrl)>More</a> </span><span ng-if=\"details.statusDescription.length <= 70\">{{details.statusDescription}}</span></span></td><td><span ng-if=details.remark><span class=info-xirr-icon><a href=# tabindex=0 role=button class=\"base-tooltip info-xirr-margin xirr\" data-toggle=tooltip data-placement=top title={{details.remark}}><img src=assets/images/icons/tooltip-info.png alt=info></a></span></span></td></tr><tr class=text-center ng-if=\"!(BulkStatus.searchListData.length >0)\"><td colspan=9>No Record found</td></tr></tbody></table><div ng-if=BulkStatus.searchPagination class=no-overflow><div class=\"total-data pagination\"><span>Showing</span> <span ng-if=\"BulkStatus.totalSearchListDetailData <= BulkStatus.PAGE_LIMITS[0]\">{{BulkStatus.totalSearchListDetailData}} of {{BulkStatus.totalSearchListDetailData}}</span><select ng-if=\"BulkStatus.totalSearchListDetailData > BulkStatus.PAGE_LIMITS[0]\" ng-change=BulkStatus.searchLimitChanged() class=bulk-pagination ng-model=BulkStatus.searchPageLimit ng-options=\"_limit as _limit for _limit in BulkStatus.PAGE_LIMITS\"></select><span class=t-black ng-if=\"BulkStatus.totalSearchListDetailData > BulkStatus.PAGE_LIMITS[0]\">of {{BulkStatus.totalSearchListDetailData}}</span></div><ul uib-pagination total-items=BulkStatus.totalSearchListDetailData ng-model=BulkStatus.currentSearchPageBulkList max-size=5 items-per-page=BulkStatus.searchPageLimit class=\"pagination-sm pull-right pagination\" boundary-link-numbers=true previous-text=&lsaquo; next-text=&rsaquo; ng-change=BulkStatus.searchList() rotate=false></ul></div></div></div></div></div>");
$templateCache.put("app/transactions/initiate/sip/addscheme/add-scheme.html","<div class=box-main ng-init=InitiateTransactionSip.schemeInit()><div class=form-box><form autocomplete=off name=sipForm ng-keypress=InitiateTransactionSip.handleEnter($event) novalidate><div class=form-row><div class=col-md-4><label class=euin><strong>EUIN No.</strong></label><div class=\"input-select input-normal selectfield req-customised\"><select class=\"browser-default custom-select\" name=euin ng-model=InitiateTransactionSip.euinObj ng-options=\"_type as (_type.euinName+\' - \'+ _type.euinCode) for _type in InitiateTransactionSip.euinList track by _type.euinCode\" required><option value=\"\" selected>Select EUIN</option></select><span class=req>*</span> <span ng-show=\"sipForm.euin.$dirty && sipForm.euin.$invalid\"><span class=error-input ng-show=sipForm.euin.$error.required ng-bind=InitiateTransactionSip.validations.EUIN_REQUIRED></span></span></div></div></div><div class=form-row><label>Add Scheme</label><div class=col-md-12><div class=form-group><label>Select Investment Type</label><div><span class=radio-block><span class=radio><input type=radio id=purchase name=investmentType ng-model=InitiateTransactionSip.investmentType ng-click=InitiateTransactionSip.changeInvestmentType() ng-value=InitiateTransactionSip.TRANSACTION_FORM_TYPE.PURCHASE> <span class=check></span></span><label for=purchase>Lumpsum</label></span><span class=radio-block><span class=radio><input type=radio id=sip name=investmentType ng-model=InitiateTransactionSip.investmentType ng-click=InitiateTransactionSip.changeInvestmentType() ng-value=InitiateTransactionSip.TRANSACTION_FORM_TYPE.SIP> <span class=check></span></span><label for=sip>Systematic Plan</label></span></div></div></div></div><div class=lumpsump-section ng-if=\"InitiateTransactionSip.investmentType===InitiateTransactionSip.TRANSACTION_FORM_TYPE.PURCHASE\"><div class=form-row><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=purchaseScheme id=purchaseScheme ng-change=InitiateTransactionSip.filterPurchaseSchemeList() ng-model=InitiateTransactionSip.purchaseScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSip.purchaseSchemeList display-key=scheme hdfc-click=InitiateTransactionSip.selectPurchaseScheme(data) model=InitiateTransactionSip.purchasePayload.schemeCode for=purchaseScheme></drop-down></div></div><div class=form-group><div class=pull-left><span class=scheme-or>or</span></div><div><a ng-click=InitiateTransactionSip.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=form-group ng-if=InitiateTransactionSip.purchaseScheme><div class=install-freq ng-if=InitiateTransactionSip.purchaseValidations&&!InitiateTransactionSip.purchaseValidations.isGrowth><p><strong>Choose IDCW option</strong></p><span class=radio-block><span class=radio><input type=radio id=pReinvest1 ng-model=InitiateTransactionSip.purchasePayload.dividendOption ng-disabled=\"InitiateTransactionSip.purchaseValidations.endingType===InitiateTransactionSip.ENDING_TYPES.CLOSED\" ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.REINVEST name=pDividendOption> <span class=check></span></span><label for=pReinvest1>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=pPayout1 ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.PAYOUT ng-model=InitiateTransactionSip.purchasePayload.dividendOption name=pDividendOption> <span class=check></span></span><label for=pPayout>Payout</label></span></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class={error:(InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount)}><input type=number ignore-mouse-wheel name=purchaseAmount ng-change=InitiateTransactionSip.changePurchaseAmount() onkeyup=\"NumToWord(this.value,\'divDisplayWords\')\" ng-model=InitiateTransactionSip.purchasePayload.amount autocomplete=off class=pd20 required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSip.minAmountValidation}} </span><span ng-if=\"sipForm.purchaseAmount.$invalid && sipForm.purchaseAmount.$error.number\" class=error-input>{{InitiateTransactionSip.VALIDATE_DATA.INVALID_AMOUNT}}</span></div></div><div ng-if=InitiateTransactionSip.purchasePayload.amount><span>(In Words)&nbsp;</span><div id=divDisplayWords></div></div></div><div class=col-md-12 ng-if=!InitiateTransactionSip.isReinitiate><div ng-if=!InitiateTransactionSip.isSipOptional><div ng-click=InitiateTransactionSip.setOptionalScheme(InitiateTransactionSip.TRANSACTION_FORM_TYPE.SIP) class=text-blue><span>+ &nbsp;&nbsp;&nbsp; Add Systematic Scheme</span> <span>(Optional)</span></div></div><div ng-if=InitiateTransactionSip.isSipOptional><div ng-click=InitiateTransactionSip.removeOptionalScheme(InitiateTransactionSip.TRANSACTION_FORM_TYPE.SIP) class=text-blue><span>- &nbsp;&nbsp;&nbsp; Remove Systematic Scheme</span> <span>(Optional)</span></div></div></div></div><div class=form-row ng-if=InitiateTransactionSip.isSipOptional><div class=\"form-grid col-md-4\"><label>Add Systematic Investment</label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme id=sipScheme ng-change=InitiateTransactionSip.filterSipSchemeList() ng-model=InitiateTransactionSip.sipScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSip.sipSchemeList display-key=scheme hdfc-click=InitiateTransactionSip.selectSipScheme(data) model=InitiateTransactionSip.sipPayload.schemeCode for=sipScheme></drop-down></div></div><div class=form-group><div class=pull-left><span class=scheme-or>or</span></div><div><a ng-click=InitiateTransactionSip.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div ng-if=InitiateTransactionSip.sipScheme><div class=form-group ng-if=InitiateTransactionSip.sipValidations&&!InitiateTransactionSip.sipValidations.isGrowth><label>Choose IDCW Option</label><div><span class=radio-block><span class=radio><input type=radio id=sReinvest1 ng-model=InitiateTransactionSip.sipPayload.dividendOption ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"InitiateTransactionSip.sipValidations.endingType===InitiateTransactionSip.ENDING_TYPES.CLOSED\" name=sDividendOption> <span class=check></span></span><label for=sReinvest>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=sPayout1 ng-model=InitiateTransactionSip.sipPayload.dividendOption ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.PAYOUT name=sDividendOption> <span class=check></span></span><label for=sPayout>Payout</label></span></div></div></div><div class=form-group><label>Installment Frequency</label><div><span class=radio-block ng-repeat=\"freq in InitiateTransactionSip.SIP_FREQ_LIST\"><span class=radio><input type=radio id=\"{{freq.value+\'1\'}}\" ng-change=InitiateTransactionSip.changeFrequency() ng-model=InitiateTransactionSip.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.value}}>{{freq.value}}</label></span></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class={error:(InitiateTransactionSip.isMinSipAmount&&InitiateTransactionSip.sipPayload.installmentAmount)}><input autocomplete=off type=number ignore-mouse-wheel ng-change=InitiateTransactionSip.changeSipAmount() name=installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords223\')\" ng-model=InitiateTransactionSip.sipPayload.installmentAmount required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=\"sipForm.installmentAmount.$valid && InitiateTransactionSip.isMinSipAmount\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSip.sipValidations.minAmount}} </span><span ng-if=\"sipForm.installmentAmount.$invalid && sipForm.installmentAmount.$error.number\" class=error-input>{{InitiateTransactionSip.VALIDATE_DATA.INVALID_AMOUNT}}</span></div></div><div ng-if=InitiateTransactionSip.sipPayload.installmentAmount><span>(In Words)&nbsp;</span><div id=divDisplayWords223></div></div></div><div class=\"form-grid col-md-4\"><!--<label>Installment Date</label>--><!--<div class=\"form-group\">\n              <p><strong>Instalment Frequency</strong></p>\n            </div>\n            <div class=\"install-freq\">\n              <span class=\"radio-block\" ng-repeat=\"freq in InitiateTransactionSip.SIP_FREQ_LIST\">\n                  <span class=\"radio\">\n                    <input type=\"radio\" id=\"{{freq.value}}\"\n                           ng-change=\"InitiateTransactionSip.changeFrequency()\"\n                           ng-model=\"InitiateTransactionSip.selectedFrequency\"\n                           ng-value=\"freq\" name=\"installmentFrequency\"/>\n                    <span class=\"check\"></span>\n                  </span>\n                  <label for=\"{{freq.value}}\">{{freq.value}}</label>\n                </span>\n            </div>--><!--<div class=\"form-group\">\n              <div class=\"selectfield\">\n                <label>Select Day</label>\n                <select class=\"browser-default custom-select\" name=\"day\"\n                        ng-model=\"InitiateTransactionSip.sipDay\"\n                        ng-options=\"day.name for day in InitiateTransactionSip.daysList\"\n                        ng-value=\"day\"\n                        ng-change=\"InitiateTransactionSip.changeDay()\" required>\n                  <option value=\"\" selected>Select Day</option>\n                </select>\n              </div>\n            </div>--><div class=form-group><div class=input-normal><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InitiateTransactionSip.viewMode}} data-enabled-dates=InitiateTransactionSip.enabledStartDates data-date-default=InitiateTransactionSip.startDate data-min-date=InitiateTransactionSip.startDate data-on-date-change=InitiateTransactionSip.changeStartDate id=startDate1><input type=text autocomplete=off class=form-control placeholder=\"SIP Start date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div class=form-group><span class=checkbox style=\"bottom: -3px\"><input type=checkbox ng-model=InitiateTransactionSip.isTillPerpetuity ng-change=InitiateTransactionSip.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span>Default</span></div><div class=form-group ng-if=!InitiateTransactionSip.resetting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InitiateTransactionSip.viewMode}} data-enabled-dates=InitiateTransactionSip.enabledEndDates data-date-default=InitiateTransactionSip.endDate data-min-date=InitiateTransactionSip.startDate data-on-date-change=InitiateTransactionSip.changeEndDate id=endDate1><input type=text autocomplete=off class=form-control placeholder=\"SIP End date - DD/MM/YYYY\" ng-disabled=InitiateTransactionSip.isTillPerpetuity readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div></div></div><div class=sip-section ng-if=\"InitiateTransactionSip.investmentType===InitiateTransactionSip.TRANSACTION_FORM_TYPE.SIP\"><div class=form-row><div class=\"form-grid col-md-4\"><div class=form-group><div class=\"input-select input-normal\"><input type=text name=sipScheme1 id=sipScheme1 ng-change=InitiateTransactionSip.filterSipSchemeList() ng-model=InitiateTransactionSip.sipScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSip.sipSchemeList display-key=scheme hdfc-click=InitiateTransactionSip.selectSipScheme(data) model=InitiateTransactionSip.sipPayload.schemeCode for=sipScheme1></drop-down></div></div><div class=form-group><div class=pull-left><span class=scheme-or>or</span></div><div><a ng-click=InitiateTransactionSip.openSipSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=form-group ng-if=InitiateTransactionSip.sipScheme><div class=install-freq ng-if=InitiateTransactionSip.sipValidations&&!InitiateTransactionSip.sipValidations.isGrowth><p><strong>Choose IDCW option</strong></p><span class=radio-block><span class=radio><input type=radio id=sReinvest ng-model=InitiateTransactionSip.sipPayload.dividendOption ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.REINVEST ng-disabled=\"InitiateTransactionSip.sipValidations.endingType===InitiateTransactionSip.ENDING_TYPES.CLOSED\" name=sDividendOption> <span class=check></span></span><label for=sReinvest>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=sPayout ng-model=InitiateTransactionSip.sipPayload.dividendOption ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.PAYOUT name=sDividendOption> <span class=check></span></span><label for=sPayout>Payout</label></span></div></div><!-- <div class=\"form-group\">\n              <div class=\"install-freq\">\n                <p><strong>Instalment Frequency</strong></p>\n                <span class=\"radio-block\" ng-repeat=\"freq in InitiateTransactionSip.SIP_FREQ_LIST\">\n                  <span class=\"radio\">\n                    <input type=\"radio\" id=\"{{freq.value}}\"\n                           ng-change=\"InitiateTransactionSip.changeFrequency()\"\n                           ng-model=\"InitiateTransactionSip.selectedFrequency\"\n                           ng-value=\"freq\" name=\"installmentFrequency\"/>\n                    <span class=\"check\"></span>\n                  </span>\n                  <label for=\"{{freq.value}}\">{{freq.value}}</label>\n                </span>\n              </div>\n            </div>--></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class={error:(InitiateTransactionSip.isMinSipAmount&&InitiateTransactionSip.sipPayload.installmentAmount)}><input type=number ignore-mouse-wheel ng-change=InitiateTransactionSip.changeSipAmount() name=installmentAmount onkeyup=\"NumToWord(this.value,\'divDisplayWords392\')\" ng-model=InitiateTransactionSip.sipPayload.installmentAmount autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=\"InitiateTransactionSip.isMinSipAmount && sipForm.installmentAmount.$valid\" class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSip.sipValidations.minAmount}} </span><span ng-if=\"sipForm.installmentAmount.$invalid && sipForm.installmentAmount.$error.number\" class=error-input>{{InitiateTransactionSip.VALIDATE_DATA.INVALID_AMOUNT}}</span></div></div><div ng-if=InitiateTransactionSip.sipPayload.installmentAmount><span>(In Words)&nbsp;</span><div id=divDisplayWords392></div></div></div><div ng-if=\"InitiateTransactionSip.sipValidations!=null\" class=\"form-grid col-md-4\"><div class=form-group><p><strong>Installment Frequency</strong></p></div><div class=install-freq><span class=radio-block ng-repeat=\"freq in InitiateTransactionSip.SIP_FREQ_LIST\"><span class=radio><input type=radio id={{freq.value}} ng-change=InitiateTransactionSip.changeFrequency() ng-model=InitiateTransactionSip.selectedFrequency ng-value=freq name=installmentFrequency> <span class=check></span></span><label for={{freq.value}}>{{freq.value}}</label></span></div><!--<div class=\"form-group\">\n              <div class=\"selectfield\">\n                <label>Select Day</label>\n                <select class=\"browser-default custom-select\" name=\"day\"\n                        ng-model=\"InitiateTransactionSip.sipDay\"\n                        ng-options=\"day.name for day in InitiateTransactionSip.daysList track by day.name\"\n                        ng-value=\"day\"\n                        ng-change=\"InitiateTransactionSip.changeDay()\" required>\n                  <option value=\"\" selected>Select Day</option>\n                </select>\n              </div>\n            </div>--><div class=form-group><div class=input-normal><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InitiateTransactionSip.viewMode}} data-date-default=InitiateTransactionSip.startDate data-min-date=InitiateTransactionSip.startMinDate data-on-date-change=InitiateTransactionSip.changeStartDate id=startDate><!--\n                     data-enabled-dates=\"InitiateTransactionSip.enabledStartDates\"--> <input type=text class=form-control autocomplete=off placeholder=\"SIP Start date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div class=form-group><span class=checkbox style=\"bottom: -3px\"><input type=checkbox ng-model=InitiateTransactionSip.isTillPerpetuity ng-change=InitiateTransactionSip.changeTillPerpetuityFlag()> <span class=icon-checkbox></span> </span><span>Default</span></div><div class=form-group ng-if=!InitiateTransactionSip.resetting><div class=\"input-normal verify-acc input-group date date-picker transaction-cal\" date-calendar data-viewmode={{InitiateTransactionSip.viewMode}} data-date-default=InitiateTransactionSip.endDate data-min-date=InitiateTransactionSip.startDate data-on-date-change=InitiateTransactionSip.changeEndDate data-enabled-dates=InitiateTransactionSip.enabledEndDates id=endDate><input type=text ng-disabled=InitiateTransactionSip.isTillPerpetuity autocomplete=off class=form-control placeholder=\"SIP End date - DD/MM/YYYY\" readonly> <span class=input-group-addon><span class=\"glyphicon glyphicon-calendar\"></span> </span><span class=highlight></span> <span class=bar></span></div></div></div><div class=col-md-12 ng-if=!InitiateTransactionSip.isReinitiate><div ng-if=!InitiateTransactionSip.isPurchaseOptional><div ng-click=InitiateTransactionSip.setOptionalScheme(InitiateTransactionSip.TRANSACTION_FORM_TYPE.PURCHASE) class=text-blue><span>+ &nbsp;&nbsp;&nbsp; Add Lumpsum Scheme</span> <span>(Optional)</span></div></div><div ng-if=InitiateTransactionSip.isPurchaseOptional><div ng-click=InitiateTransactionSip.removeOptionalScheme(InitiateTransactionSip.TRANSACTION_FORM_TYPE.PURCHASE) class=text-blue><span>- &nbsp;&nbsp;&nbsp; Remove Lumpsum Scheme</span> <span>(Optional)</span></div></div></div></div><div ng-if=InitiateTransactionSip.isPurchaseOptional><div class=form-row><div class=\"form-grid col-md-4\"><label>Add Lumpsum Investment</label><div class=form-group><div class=\"input-select input-normal\"><input type=text name=purchaseSchemes id=purchaseSchemes ng-change=InitiateTransactionSip.filterPurchaseSchemeList() ng-model=InitiateTransactionSip.purchaseScheme autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Select Scheme</label><drop-down list-data=InitiateTransactionSip.purchaseSchemeList display-key=scheme hdfc-click=InitiateTransactionSip.selectPurchaseScheme(data) model=InitiateTransactionSip.purchasePayload.schemeCode for=purchaseSchemes></drop-down></div></div><div class=form-group><div class=pull-left><span class=scheme-or>or</span></div><div><a ng-click=InitiateTransactionSip.openPurchaseSchemesModal() href=javaScript:void(0);><p class=\"scheme-list text-blue\"><i class=list-icon></i>Select from list</p></a></div></div><div class=form-group ng-if=InitiateTransactionSip.purchaseScheme><div class=install-freq ng-if=InitiateTransactionSip.purchaseValidations&&!InitiateTransactionSip.purchaseValidations.isGrowth><p><strong>Choose Dividend option</strong></p><span class=radio-block><span class=radio><input type=radio id=pReinvest ng-model=InitiateTransactionSip.purchasePayload.dividendOption ng-disabled=\"InitiateTransactionSip.purchaseValidations.endingType===InitiateTransactionSip.ENDING_TYPES.CLOSED\" ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.REINVEST name=pdividendOption> <span class=check></span></span><label for=pReinvest>Re-invest</label></span><span class=radio-block><span class=radio><input type=radio id=pPayout ng-value=InitiateTransactionSip.DIVIDEND_OPTIONS.PAYOUT ng-model=InitiateTransactionSip.purchasePayload.dividendOption name=pDividendOption> <span class=check></span></span><label for=pPayout>Payout</label></span></div></div></div><div class=\"form-grid col-md-4\"><div class=form-group><div class=input-normal ng-class={error:(InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount)}><input type=number ignore-mouse-wheel name=purchaseAmount ng-change=InitiateTransactionSip.changePurchaseAmount() onkeyup=\"NumToWord(this.value,\'divDisplayWords570\')\" autocomplete=off ng-model=InitiateTransactionSip.purchasePayload.amount required> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Amount</label><span ng-if=InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount class=error-input>{{\'Minimum amount should be \'+ InitiateTransactionSip.minAmountValidation}} </span><span ng-if=\"sipForm.purchaseAmount.$invalid && sipForm.purchaseAmount.$error.number\" class=error-input>{{InitiateTransactionSip.VALIDATE_DATA.INVALID_AMOUNT}}</span></div></div><div ng-if=InitiateTransactionSip.purchasePayload.amount><span>(In Words)&nbsp;</span><div id=divDisplayWords570></div></div></div></div></div></div><div class=\"form-footer form-content\"><span ng-if=!InitiateTransactionSip.isReinitiate class=\"pull-left back-btn\" ng-click=InitiateTransactionSip.updatePayload()><i class=back-arrow-icon></i> <span class=text-blue>Back </span></span><span class=pull-right><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button ng-if=!InitiateTransactionSip.isExistingFolio class=\"btn btn-primary-action\" ng-disabled=sipForm.$invalid||InitiateTransactionSip.isSubmitted||(InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount)||(InitiateTransactionSip.isMinSipAmount&&InitiateTransactionSip.sipPayload.installmentAmount) ng-click=InitiateTransactionSip.confirmTransaction()>Initiate Transaction</button> <button ng-if=InitiateTransactionSip.isExistingFolio class=\"btn btn-primary-action\" ng-disabled=sipForm.$invalid||!InitiateTransactionSip.hasFolioEmailId||InitiateTransactionSip.isSubmitted||(InitiateTransactionSip.isMinPurchaseAmount&&InitiateTransactionSip.purchasePayload.amount)||(InitiateTransactionSip.isMinSipAmount&&InitiateTransactionSip.sipPayload.installmentAmount) ng-click=InitiateTransactionSip.finishPurchase()>Initiate Transaction</button></span></div></form></div></div>");
$templateCache.put("app/transactions/initiate/sip/folio/add-joint-holder.html","<div id=add-joint-holder class=\"tab-pane joint-holder\"><ol class=list-inline><li ng-repeat=\"jointHolder in InitiateTransactionSip.investorPayload.folioCreationRequestCO.jointHolders track by $index\" ng-class=\"{active:InitiateTransactionSip.selectedJointHolderIndex===$index}\" ng-click=InitiateTransactionSip.selectJointHolder($index)>{{jointHolder.jointHolderName}} <span ng-click=InitiateTransactionSip.removeJointHolder($index)><span class=remove-item><i class=delete-icon></i></span></span></li><li ng-click=InitiateTransactionSip.selectJointHolder() ng-class={active:!InitiateTransactionSip.selectedJointHolder}>{{InitiateTransactionSip.jointHolder.jointHolderName||\'Joint Holder\'}} <span ng-click=InitiateTransactionSip.removeJointHolder()><span class=remove-item><i class=delete-icon></i></span></span></li></ol><form autocomplete=off novalidate role=form name=jointHolderForm ng-if=InitiateTransactionSip.selectedJointHolder><div class=form-content><h3 class=text-blue>Joint Holder {{InitiateTransactionSip.selectedJointHolderIndex+1}} : <strong>{{InitiateTransactionSip.selectedJointHolder.jointHolderName}}</strong> <small>(KYC Verified)</small></h3><p class=\"pan-detail text-blue\">PAN : <strong easyassist-key=mask-element>{{InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.panNumber}}</strong></p><p><strong>Joint Holder Details</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in InitiateTransactionSip.taxStatusList\" ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified required><option value=\"\" selected>Tax Status</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=jointHolderForm.taxStatusCode.$error.required>{{InitiateTransactionSip.validations.TAX_STATUS}}</span></span></div><div class=input-normal ng-class=\"{error:jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid}\" ng-if=\"InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.occupation!==\'BUSINESS\'\"><input type=text ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.grossAnnualIncome name=grossAnnualIncome required capitalize> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income<span class=req>*</span></label><span ng-show=\"jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.required>{{InitiateTransactionSip.validations.GROSS_ANNUAL_INCOME}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.occupationDescription.$dirty && jointHolderForm.occupationDescription.$invalid}\"><select class=\"browser-default custom-select\" name=occupationDescription ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.occupation ng-options=\"occupation.occupationDescription as occupation.occupationDescription for occupation in InitiateTransactionSip.occupationList\" required><option value=\"\" selected>Occupation</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.occupationDescription.$dirty && jointHolderForm.occupationDescription.$invalid\"><span class=error-input ng-show=jointHolderForm.occupationDescription.$error.required>{{InitiateTransactionSip.validations.OCCUPATION}}</span></span></div></div><div class=\"col-md-4 net-worth-inner\" ng-if=\"InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.occupation===\'BUSINESS\'\"><div class=input-normal class=pd20 ng-class=\"{error:jointHolderForm.networth.$dirty && jointHolderForm.networth.$invalid}\"><input type=text name=networth ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.netWorth autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Net worth (in Rs.)<span class=req>*</span></label><span ng-show=\"jointHolderForm.networth.$dirty && jointHolderForm.networth.$invalid\"><span class=error-input ng-show=jointHolderForm.networth.$error.required>{{InitiateTransactionSip.validations.NET_WORTH}}</span></span></div><div class=input-normal ng-class=\"{error:jointHolderForm.networthDate.$dirty && jointHolderForm.networthDate.$invalid}\"><input type=text ng-if=!InitiateTransactionSip.resetting date-calendar format=DD-MMM-YYYY name=networthDate viewmode=days showdefault={{!!(InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.netWorthDate)}} date-default=InitiateTransactionSip.defaultJointHolderNWDate maxdate=now data-min-date=InitiateTransactionSip.minDate ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified data-on-date-change=InitiateTransactionSip.changeNetWorthDateForJointHolder autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>As on DD/MM/YYYY<span class=req>*</span></label><span ng-show=\"jointHolderForm.networthDate.$dirty && jointHolderForm.networthDate.$invalid\"><span class=error-input ng-show=jointHolderForm.networthDate.$error.required>{{InitiateTransactionSip.validations.NET_WORTH_DATE}}</span></span><p class=input-info>(Not older than 1yr)</p></div></div></div></div><hr><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.POLITICAL ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.RELATED ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.NONE ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>None of the above.</label></div></div><hr><div class=form-content><div class=row><div class=col-md-4><p><strong>Mode of Holding</strong></p><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.holdMode.$dirty && jointHolderForm.holdMode.$invalid}\"><select class=\"browser-default custom-select\" name=holdMode ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.holdMode ng-options=\"_type.key as _type.value for _type in InitiateTransactionSip.HOLD_MODES\" required></select><span ng-show=\"jointHolderForm.holdMode.$dirty && jointHolderForm.holdMode.$invalid\"><span class=error-input ng-show=jointHolderForm.holdMode.$error.required ng-bind=InitiateTransactionSip.validations.INVESTOR_HOLD_STATUS></span></span><p class=input-info>(Will be applied for all added investors)</p></div></div></div></div><hr><div class=form-content><p><strong>FATCA or CRS information</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.fatcaAddressType.$dirty && jointHolderForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.fatcaAddressType ng-options=\"addressType.value as addressType.addressDescription for addressType in InitiateTransactionSip.addressTypeList\" ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified required><option value=\"\" selected>Address Type</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.fatcaAddressType.$dirty && jointHolderForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=jointHolderForm.fatcaAddressType.$error.required>{{InitiateTransactionSip.validations.ADDRESS_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.birthCountry ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\" ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:jointHolderForm.birthCity.$dirty && jointHolderForm.birthCity.$invalid}\"><input type=text name=birthCity ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.birthCity required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><!--<div ng-if=\"InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.birthCountry === \'India\'&&InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.birthCity&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.birthCity track by $index\" ng-click=\"InitiateTransactionSip.selectJointHolderBirthCity(_data,InitiateTransactionSip.selectedJointHolder)\"> {{_data.cityName}}</li></ul>\n            </div>--></div><span ng-show=\"jointHolderForm.birthCity.$dirty && jointHolderForm.birthCity.$invalid\"><span class=error-message ng-show=jointHolderForm.birthCity.$error.required>{{InitiateTransactionSip.validations.CITY}}</span></span></div></div></div><div class=form-content><p><strong>Does the investor pay or file tax other than india?</strong></p><span class=radio-block><span class=radio><input type=radio ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified id=yes1 ng-click=InitiateTransactionSip.changePayOutsideTypeForJointHolder() ng-value=true ng-model=InitiateTransactionSip._jointHolder.isPayOutside name=selectTax> <span class=check></span></span><label for=yes1>Yes</label></span><span class=radio-block><span class=radio><input type=radio ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified id=no1 ng-click=InitiateTransactionSip.changePayOutsideTypeForJointHolder() ng-value=false ng-model=InitiateTransactionSip._jointHolder.isPayOutside name=selectTax> <span class=check></span> </span><label for=no1>No</label></span><div ng-if=InitiateTransactionSip._jointHolder.isPayOutside&&InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length><div ng-repeat=\"payOutside in InitiateTransactionSip.selectedJointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses track by $index\"><p ng-click=InitiateTransactionSip.removePayOutsideCountryForJointHolder($index)><strong>Tax Residency Country</strong><span class=remove-item><i class=delete-icon></i><span>Remove</span></span></p><div class=\"row tax-res\"><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'countryName\'+$index].$dirty && jointHolderForm[\'countryName\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.countryName name=\"{{\'countryName\'+$index}}\" readonly required capitalize> <span class=bar></span> <span class=req>*</span> <span ng-show=\"jointHolderForm[\'countryName\'+$index].$dirty && jointHolderForm[\'countryName\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'countryName\'+$index].$error.required\">{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'taxIdType\'+$index].$dirty && jointHolderForm[\'taxIdType\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.taxIdType name=\"{{\'taxIdType\'+$index}}\" readonly required capitalize> <span class=bar></span> <span class=req>*</span> <span ng-show=\"jointHolderForm[\'taxIdType\'+$index].$dirty && jointHolderForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'taxIdType\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'taxIdNumber\'+$index].$dirty && jointHolderForm[\'taxIdNumber\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.taxIdNumber readonly required> <span class=bar></span> <span class=req>*</span> <span ng-show=\"jointHolderForm[\'taxIdNumber\'+$index].$dirty && jointHolderForm[\'taxIdNumber\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'taxIdNumber\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div></div></div><div ng-if=\"InitiateTransactionSip._jointHolder.isPayOutside && !InitiateTransactionSip._jointHolder.isMaxPayOutsideEntries\"><div class=\"row tax-res\" ng-if=!InitiateTransactionSip.payOutsideResetting><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.residencyCountry.$dirty && jointHolderForm.residencyCountry.$invalid}\"><select class=\"browser-default custom-select\" name=residencyCountry ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.countryName ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList|removeCountry:\'india\'\" ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified required><option value=\"\" selected>Name of country</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.residencyCountry.$dirty && jointHolderForm.residencyCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.residencyCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm.taxIdType.$dirty && jointHolderForm.taxIdType.$invalid}\"><input type=text ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.taxIdType required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID Type<span class=req>*</span></label><span ng-show=\"jointHolderForm.taxIdType.$dirty && jointHolderForm.taxIdType.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType.$error.required>{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm.taxIdNumber.$dirty && jointHolderForm.taxIdNumber.$invalid}\"><input type=text ng-disabled=!InitiateTransactionSip.selectedJointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.taxIdNumber required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label><span ng-show=\"jointHolderForm.taxIdNumber.$dirty && jointHolderForm.taxIdNumber.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdNumber.$error.required>{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div><a href=javaScript:void(0); ng-if=InitiateTransactionSip.selectedJointHolder.kycverified ng-click=InitiateTransactionSip.addPayOutsideCountryForJointHolder() class=text-blue><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div></form><form autocomplete=off novalidate role=form name=jointHolderForm ng-if=!InitiateTransactionSip.selectedJointHolder&&!InitiateTransactionSip.resetting><div class=form-content><h3 class=text-blue>Joint Holder {{InitiateTransactionSip.selectedJointHolderIndex+1}} : <strong>{{InitiateTransactionSip.jointHolder.jointHolderName}}</strong> <small>(KYC Verified)</small></h3><p class=\"pan-detail text-blue\">PAN : <strong>{{InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.panNumber}}</strong></p><p><strong>Joint Holder Details</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.taxStatusCode ng-options=\"_type.taxStatusCode as _type.taxStatusDescription for _type in InitiateTransactionSip.taxStatusList\" ng-disabled=!InitiateTransactionSip.jointHolder.kycverified required><option value=\"\" selected>Tax Status</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.taxStatusCode.$dirty && jointHolderForm.taxStatusCode.$invalid\"><span class=error-input ng-show=jointHolderForm.taxStatusCode.$error.required>{{InitiateTransactionSip.validations.TAX_STATUS}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid}\" ng-if=\"InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.occupation!==\'BUSINESS\'\"><input type=text ng-disabled=!InitiateTransactionSip.jointHolder.kycverified ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.grossAnnualIncome autocomplete=off name=grossAnnualIncome required capitalize> <span class=highlight></span> <span class=bar></span><label>Gross Annual Income<span class=req>*</span></label><span ng-show=\"jointHolderForm.grossAnnualIncome.$dirty && jointHolderForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=jointHolderForm.grossAnnualIncome.$error.required>{{InitiateTransactionSip.validations.GROSS_ANNUAL_INCOME}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.occupationDescription.$dirty && jointHolderForm.occupationDescription.$invalid}\"><select class=\"browser-default custom-select\" name=occupationDescription ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.occupation ng-options=\"occupation.occupationDescription as occupation.occupationDescription for occupation in InitiateTransactionSip.occupationList\" ng-disabled=!InitiateTransactionSip.jointHolder.kycverified required><option value=\"\" selected>Occupation</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.occupationDescription.$dirty && jointHolderForm.occupationDescription.$invalid\"><span class=error-input ng-show=jointHolderForm.occupationDescription.$error.required>{{InitiateTransactionSip.validations.OCCUPATION}}</span></span></div></div><div class=\"col-md-4 net-worth-inner\" ng-if=\"InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.occupation===\'BUSINESS\'\"><div class=input-normal class=pd20 ng-class=\"{error:jointHolderForm.netWorth.$dirty && jointHolderForm.netWorth.$invalid}\"><input type=text name=networth ng-disabled=!InitiateTransactionSip.jointHolder.kycverified ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.netWorth autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Net worth (in Rs.)<span class=req>*</span></label><span ng-show=\"jointHolderForm.netWorth.$dirty && jointHolderForm.netWorth.$invalid\"><span class=error-input ng-show=jointHolderForm.netWorth.$error.required>{{InitiateTransactionSip.validations.NET_WORTH}}</span></span></div><div class=input-normal ng-class=\"{error:jointHolderForm.netWortDate.$dirty && jointHolderForm.netWortDate.$invalid}\"><input type=text date-calendar name=netWortDate format=DD-MMM-YYYY viewmode=days showdefault={{!!(InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.netWorthDate)}} date-default=InitiateTransactionSip.defaultJointHolderNWDate maxdate=now data-min-date=InitiateTransactionSip.minDate ng-disabled=!InitiateTransactionSip.jointHolder.kycverified data-on-date-change=InitiateTransactionSip.changeNetWorthDateForJointHolder autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>As on DD/MM/YYYY<span class=req>*</span></label><span ng-show=\"jointHolderForm.netWortDate.$dirty && jointHolderForm.netWortDate.$invalid\"><span class=error-input ng-show=jointHolderForm.netWortDate.$error.required>{{InitiateTransactionSip.validations.NET_WORTH_DATE}}</span></span><p class=input-info>(Not older than 1yr)</p></div></div></div></div><hr><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.POLITICAL ng-disabled=!InitiateTransactionSip.jointHolder.kycverified ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.RELATED ng-disabled=!InitiateTransactionSip.jointHolder.kycverified ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.NONE ng-disabled=!InitiateTransactionSip.jointHolder.kycverified ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.politicalStatus> <span class=check></span></span><label>None of the above.</label></div></div><hr><div class=form-content><div class=row><div class=col-md-4><p><strong>Mode of Holding</strong></p><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.holdMode.$dirty && jointHolderForm.holdMode.$invalid}\"><select class=\"browser-default custom-select\" name=holdMode ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.holdMode ng-options=\"_type.key as _type.value for _type in InitiateTransactionSip.HOLD_MODES\" required></select><span ng-show=\"jointHolderForm.holdMode.$dirty && jointHolderForm.holdMode.$invalid\"><span class=error-input ng-show=jointHolderForm.holdMode.$error.required ng-bind=InitiateTransactionSip.validations.INVESTOR_HOLD_STATUS></span></span><p class=input-info>(Will be applied for all added investors)</p></div></div></div></div><hr><div class=form-content><p><strong>FATCA or CRS information</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.fatcaAddressType.$dirty && jointHolderForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.fatcaAddressType ng-options=\"addressType.value as addressType.addressDescription for addressType in InitiateTransactionSip.addressTypeList\" ng-disabled=!InitiateTransactionSip.jointHolder.kycverified required><option value=\"\" selected>Address Type</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.fatcaAddressType.$dirty && jointHolderForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=jointHolderForm.fatcaAddressType.$error.required>{{InitiateTransactionSip.validations.ADDRESS_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.birthCountry ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\" ng-disabled=!InitiateTransactionSip.jointHolder.kycverified required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.birthCountry.$dirty && jointHolderForm.birthCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.birthCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:jointHolderForm.birthCity.$dirty && jointHolderForm.birthCity.$invalid}\"><input type=text name=birthCity ng-disabled=!InitiateTransactionSip.jointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.birthCity required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><!--<div ng-if=\"InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.birthCountry === \'India\'&&InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.birthCity&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.birthCity track by $index\" ng-click=\"InitiateTransactionSip.selectJointHolderBirthCity(_data,InitiateTransactionSip.jointHolder)\"> {{_data.cityName}}</li></ul>\n            </div>--></div><span ng-show=\"jointHolderForm.birthCity.$dirty && jointHolderForm.birthCity.$invalid\"><span class=error-message ng-show=jointHolderForm.birthCity.$error.required>{{InitiateTransactionSip.validations.CITY}}</span></span></div></div></div><div class=form-content><p><strong>Does the investor pay or file tax other than india?</strong></p><span class=radio-block><span class=radio><input type=radio ng-disabled=!InitiateTransactionSip.jointHolder.kycverified id=yes ng-click=InitiateTransactionSip.changePayOutsideTypeForJointHolder() ng-value=true ng-model=InitiateTransactionSip._jointHolder.isPayOutside name=selectTax> <span class=check></span></span><label for=yes>Yes</label></span><span class=radio-block><span class=radio><input type=radio ng-disabled=!InitiateTransactionSip.jointHolder.kycverified id=no ng-click=InitiateTransactionSip.changePayOutsideTypeForJointHolder() ng-value=false ng-model=InitiateTransactionSip._jointHolder.isPayOutside name=selectTax> <span class=check></span> </span><label for=no>No</label></span><div ng-if=InitiateTransactionSip._jointHolder.isPayOutside&&InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses.length><div ng-repeat=\"payOutside in InitiateTransactionSip.jointHolder.jointHolderApplicantDetail.payOutsideIndiaAddresses track by $index\"><p ng-click=InitiateTransactionSip.removePayOutsideCountryForJointHolder($index)><strong>Tax Residency Country</strong><span class=remove-item><i class=delete-icon></i><span>Remove</span></span></p><div class=\"row tax-res\"><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'countryName\'+$index].$dirty && jointHolderForm[\'countryName\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.countryName name=\"{{\'countryName\'+$index}}\" readonly required capitalize> <span class=bar></span> <span ng-show=\"jointHolderForm[\'countryName\'+$index].$dirty && jointHolderForm[\'countryName\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'countryName\'+$index].$error.required\">{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'taxIdType\'+$index].$dirty && jointHolderForm[\'taxIdType\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.taxIdType name=\"{{\'taxIdType\'+$index}}\" readonly required capitalize> <span class=bar></span> <span ng-show=\"jointHolderForm[\'taxIdType\'+$index].$dirty && jointHolderForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'taxIdType\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm[\'taxIdNumber\'+$index].$dirty && jointHolderForm[\'taxIdNumber\'+$index].$invalid}\"><input type=text autocomplete=off ng-value=payOutside.taxIdNumber name=\"{{\'taxIdNumber\'+$index}}\" readonly required capitalize> <span class=bar></span> <span ng-show=\"jointHolderForm[\'taxIdNumber\'+$index].$dirty && jointHolderForm[\'taxIdNumber\'+$index].$invalid\"><span class=error-input ng-show=\"jointHolderForm[\'taxIdNumber\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div></div></div><div ng-if=\"InitiateTransactionSip._jointHolder.isPayOutside && !InitiateTransactionSip._jointHolder.isMaxPayOutsideEntries\"><div class=\"row tax-res\" ng-if=!InitiateTransactionSip.payOutsideResetting><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:jointHolderForm.residencyCountry.$dirty && jointHolderForm.residencyCountry.$invalid}\"><select class=\"browser-default custom-select\" name=residencyCountry ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.countryName ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList|removeCountry:\'india\'\" ng-disabled=!InitiateTransactionSip.jointHolder.kycverified required><option value=\"\" selected>Name of country</option></select><span class=req>*</span> <span ng-show=\"jointHolderForm.residencyCountry.$dirty && jointHolderForm.residencyCountry.$invalid\"><span class=error-input ng-show=jointHolderForm.residencyCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm.taxIdType.$dirty && jointHolderForm.taxIdType.$invalid}\"><input type=text ng-disabled=!InitiateTransactionSip.jointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.taxIdType required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID Type<span class=req>*</span></label><span ng-show=\"jointHolderForm.taxIdType.$dirty && jointHolderForm.taxIdType.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdType.$error.required>{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:jointHolderForm.taxIdNumber.$dirty && jointHolderForm.taxIdNumber.$invalid}\"><input type=text ng-disabled=!InitiateTransactionSip.jointHolder.kycverified autocomplete=off ng-model=InitiateTransactionSip._jointHolder.payOutsideModel.taxIdNumber required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label><span ng-show=\"jointHolderForm.taxIdNumber.$dirty && jointHolderForm.taxIdNumber.$invalid\"><span class=error-input ng-show=jointHolderForm.taxIdNumber.$error.required>{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div><a href=javaScript:void(0); ng-if=InitiateTransactionSip.jointHolder.kycverified ng-click=InitiateTransactionSip.addPayOutsideCountryForJointHolder() class=text-blue><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><div class=form-content ng-if=!InitiateTransactionSip.isMaxJointHolder&&!jointHolderForm.$invalid&&InitiateTransactionSip.jointHolder.kycverified><a href=javaScript:void(0); ng-click=InitiateTransactionSip.panVerificationForJointHolders() class=text-blue><strong><i class=expand-icon></i>Add another joint holder</strong></a></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button ng-click=InitiateTransactionSip.goToBankInfo() ng-disabled=jointHolderForm.$invalid class=\"btn btn-primary-action\">Continue</button></div></form></div>");
$templateCache.put("app/transactions/initiate/sip/folio/add-nominee-info.html","<div id=add-nominee class=\"tab-pane add-nominee\"><ol class=list-inline><li ng-repeat=\"nominee in InitiateTransactionSip.investorPayload.folioCreationRequestCO.nominees track by $index\" ng-class=\"{active:InitiateTransactionSip.selectedNomineeIndex===$index}\" ng-click=InitiateTransactionSip.selectNominee($index)>{{nominee.nomineeName}} <span ng-click=InitiateTransactionSip.removeNominee($index)><span class=remove-item><i class=delete-icon></i></span></span></li><li ng-click=InitiateTransactionSip.selectNominee() ng-class={active:!InitiateTransactionSip.selectedNominee}>{{InitiateTransactionSip.nominee.nomineeName||\'Nominee\'}} <span ng-click=InitiateTransactionSip.removeNominee()><span class=remove-item><i class=delete-icon></i></span></span></li></ol><form autocomplete=off novalidate ng-if=InitiateTransactionSip.selectedNominee role=form name=nomineeForm><div class=form-content><p><strong>Personal Details of Nominee</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal\"><input type=text autocomplete=off ng-model=InitiateTransactionSip.selectedNominee.nomineeName name=nomineeName capitalize> <span class=highlight></span> <span class=bar></span><label>Name</label></div><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm.percentage.$dirty && nomineeForm.percentage.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=number ignore-mouse-wheel onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-min=0 ng-max=100 autocomplete=off ng-model=InitiateTransactionSip.selectedNominee.percentage name=percentage required> <span class=highlight></span> <span class=bar></span><label>Proportion in %<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.percentage.$dirty && nomineeForm.percentage.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.percentage.$error.required>Nominee proportion is required</span> <span class=error-input ng-show=!nomineeForm.percentage.$error.required&&nomineeForm.percentage.$error.min>Minimum proportion should be 0</span> <span class=error-input ng-show=!nomineeForm.percentage.$error.required&&nomineeForm.percentage.$error.max>Maximum proportion should be 100</span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm.nomineeRelation.$dirty && nomineeForm.nomineeRelation.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text autocomplete=off ng-model=InitiateTransactionSip.selectedNominee.nomineeRelation name=nomineeRelation required capitalize> <span class=highlight></span> <span class=bar></span><label>Relationship with Applicant<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.nomineeRelation.$dirty && nomineeForm.nomineeRelation.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.nomineeRelation.$error.required>{{InitiateTransactionSip.validations.NOMINEE_RELATIONSHIP}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.nomineeDOB.$dirty && nomineeForm.nomineeDOB.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text name=nomineeDOB ng-if=!InitiateTransactionSip.resetting date-calendar format=DD-MMM-YYYY viewmode=days showdefault={{!!(InitiateTransactionSip.selectedNominee.dob)}} date-default=InitiateTransactionSip.defaultNomineeDobDate maxdate=now autocomplete=off data-on-date-change=InitiateTransactionSip.changeDOB required> <span class=highlight></span> <span class=bar></span><label>DOB - DD/MM/YYYY<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.nomineeDOB.$dirty && nomineeForm.nomineeDOB.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.nomineeDOB.$error.required>{{InitiateTransactionSip.validations.DOB_FIELD}}</span></span></div></div></div></div><hr><div class=form-content><p><strong>Address Details of Nominee</strong></p><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm.addressLine1.$dirty && nomineeForm.addressLine1.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text autocomplete=off name=addressLine1 required easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.addressLine1 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 1<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.addressLine1.$dirty && nomineeForm.addressLine1.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.addressLine1.$error.required>{{InitiateTransactionSip.validations.ADDRESS_LINE1}}</span></span></div><div class=input-normal><input type=text autocomplete=off easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.addressLine3 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 3</label></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:nomineeForm.addressCountry.$dirty && nomineeForm.addressCountry.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><select class=\"browser-default custom-select\" name=addressCountry easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.country ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\" required><option value=\"\" selected>Select Country</option></select><span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span> <span ng-show=\"nomineeForm.addressCountry.$dirty && nomineeForm.addressCountry.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.addressCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=input-normal ng-class=\"{error:nomineeForm.addressLine2.$dirty && nomineeForm.addressLine2.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off name=addressLine2 required ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.addressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.addressLine2.$dirty && nomineeForm.addressLine2.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.addressLine2.$error.required>{{InitiateTransactionSip.validations.ADDRESS_LINE2}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.pinCode.$dirty && nomineeForm.pinCode.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.pinCode name=pinCode required capitalize> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.pinCode.$dirty && nomineeForm.pinCode.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.pinCode.$error.required>{{InitiateTransactionSip.validations.ZIP_CODE}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.addressCity.$dirty && nomineeForm.addressCity.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off name=addressCity ng-model=InitiateTransactionSip.selectedNominee.nomineeAddress.city required capitalize> <span class=highlight></span> <span class=bar></span><label>Select city<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><!--<div ng-if=\"InitiateTransactionSip.selectedNominee.nomineeAddress.country === \'India\'&&InitiateTransactionSip.selectedNominee.nomineeAddress.city&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.selectedNominee.nomineeAddress.city track by $index\" ng-click=\"InitiateTransactionSip.selectNomineeBirthCity(_data,InitiateTransactionSip.selectedNominee)\"> {{_data.cityName}}</li></ul>\n            </div>--></div><span ng-show=\"nomineeForm.addressCity.$dirty && nomineeForm.addressCity.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-message ng-show=nomineeForm.addressCity.$error.required>{{InitiateTransactionSip.validations.CITY}}</span></span></div></div></div><hr><div class=form-content ng-if=InitiateTransactionSip.selectedNominee.minor><p><strong>Address Details of Nominee’s guardian</strong></p><div class=\"row add-nomi\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm.guardianName.$dirty && nomineeForm.guardianName.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.selectedNominee.guardianName name=guardianName required capitalize> <span class=highlight></span> <span class=bar></span><label>Name of the guardian<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.guardianName.$dirty && nomineeForm.guardianName.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.guardianName.$error.required>{{InitiateTransactionSip.validations.GUARDIAN_NAME}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.gAddressLine1.$dirty && nomineeForm.gAddressLine1.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off name=gAddressLine1 required ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.addressLine1 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 1<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.gAddressLine1.$dirty && nomineeForm.gAddressLine1.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.gAddressLine1.$error.required>{{InitiateTransactionSip.validations.ADDRESS_LINE1}}</span></span></div><div class=input-normal><input type=text autocomplete=off easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.addressLine3 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 3</label></div><div class=\"input-select input-normal selectfield\" ng-class=\"{error:nomineeForm.guardianAddressCountry.$dirty && nomineeForm.guardianAddressCountry.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><select class=\"browser-default custom-select\" name=guardianAddressCountry ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.country easyassist-key=mask-element ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\" required><option value=\"\" selected>Select Country</option></select><span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span> <span ng-show=\"nomineeForm.guardianAddressCountry.$dirty && nomineeForm.guardianAddressCountry.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.guardianAddressCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div></div><div class=\"col-md-4 add-nomi-inner\"><div class=input-normal><input type=text autocomplete=off name=gAddressLine2 required easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.addressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 2<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.gAddressLine2.$dirty && nomineeForm.gAddressLine2.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.gAddressLine2.$error.required>{{InitiateTransactionSip.validations.ADDRESS_LINE2}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.gPinCode.$dirty && nomineeForm.gPinCode.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text autocomplete=off required easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.pinCode name=gPinCode capitalize> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.gPinCode.$dirty && nomineeForm.gPinCode.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-input ng-show=nomineeForm.gPinCode.$error.required>{{InitiateTransactionSip.validations.ZIP_CODE}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.guardianAddressCity.$dirty && nomineeForm.guardianAddressCity.$invalid && InitiateTransactionSip.selectedNominee.nomineeName}\"><input type=text autocomplete=off name=guardianAddressCity easyassist-key=mask-element ng-model=InitiateTransactionSip.selectedNominee.guardianAddress.city required capitalize> <span class=highlight></span> <span class=bar></span><label>Select city<span ng-if=InitiateTransactionSip.selectedNominee.nomineeName class=req>*</span></label><!--<div ng-if=\"InitiateTransactionSip.selectedNominee.guardianAddress.country === \'India\'&&InitiateTransactionSip.selectedNominee.guardianAddress.city&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.selectedNominee.guardianAddress.city track by $index\" ng-click=\"InitiateTransactionSip.selectGuardianBirthCity(_data,InitiateTransactionSip.selectedNominee)\"> {{_data.cityName}}</li></ul>\n            </div>--></div><span ng-show=\"nomineeForm.guardianAddressCity.$dirty && nomineeForm.guardianAddressCity.$invalid && InitiateTransactionSip.selectedNominee.nomineeName\"><span class=error-message ng-show=nomineeForm.guardianAddressCity.$error.required>{{InitiateTransactionSip.validations.CITY}}</span></span></div></div></div><hr></form><form autocomplete=off novalidate ng-if=!InitiateTransactionSip.selectedNominee&&!InitiateTransactionSip.resetting role=form name=nomineeForm><div class=form-content><p><strong>Personal Details of Nominee</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal\"><input type=text easyassist-key=mask-element autocomplete=off name=nomineeName ng-model=InitiateTransactionSip.nominee.nomineeName capitalize> <span class=highlight></span> <span class=bar></span><label>Name</label></div><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm.percentage.$dirty && nomineeForm.percentage.$invalid && InitiateTransactionSip.nominee.nomineeName}\"><input type=number ignore-mouse-wheel autocomplete=off onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" ng-max=100 ng-min=0 ng-model=InitiateTransactionSip.nominee.percentage name=percentage required> <span class=highlight></span> <span class=bar></span><label>Proportion in %<span ng-if=InitiateTransactionSip.nominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.percentage.$dirty && nomineeForm.percentage.$invalid && InitiateTransactionSip.nominee.nomineeName\"><span class=error-input ng-show=nomineeForm.percentage.$error.required>Nominee proportion is required</span> <span class=error-input ng-show=!nomineeForm.percentage.$error.required&&nomineeForm.percentage.$error.min>Minimum proportion should be 0</span> <span class=error-input ng-show=!nomineeForm.percentage.$error.required&&nomineeForm.percentage.$error.max>Maximum proportion should be 100</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:nomineeForm.nomineeRelation.$dirty && nomineeForm.nomineeRelation.$invalid && InitiateTransactionSip.nominee.nomineeName}\"><input type=text autocomplete=off ng-model=InitiateTransactionSip.nominee.nomineeRelation name=nomineeRelation required capitalize> <span class=highlight></span> <span class=bar></span><label>Relationship with Applicant<span ng-if=InitiateTransactionSip.nominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.nomineeRelation.$dirty && nomineeForm.nomineeRelation.$invalid && InitiateTransactionSip.nominee.nomineeName\"><span class=error-input ng-show=nomineeForm.nomineeRelation.$error.required>{{InitiateTransactionSip.validations.NOMINEE_RELATIONSHIP}}</span></span></div><div class=input-normal ng-class=\"{error:nomineeForm.nomineeDOB.$dirty && nomineeForm.nomineeDOB.$invalid && InitiateTransactionSip.nominee.nomineeName}\"><input type=text name=nomineeDOB date-calendar format=DD-MMM-YYYY viewmode=days date-default=InitiateTransactionSip.defaultNomineeDobDate showdefault={{!!(InitiateTransactionSip.nominee.dob)}} maxdate=now data-on-date-change=InitiateTransactionSip.changeDOB autocomplete=off required> <span class=highlight></span> <span class=bar></span><label>DOB - DD/MM/YYYY<span ng-if=InitiateTransactionSip.nominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.nomineeDOB.$dirty && nomineeForm.nomineeDOB.$invalid && InitiateTransactionSip.nominee.nomineeName\"><span class=error-input ng-show=nomineeForm.nomineeDOB.$error.required>{{InitiateTransactionSip.validations.DOB_FIELD}}</span></span></div></div></div></div><hr><div class=form-content><p><strong>Address Details of Nominee</strong></p><div class=row><div class=col-md-4><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.nomineeAddress.addressLine1 name=addressLine1 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 1</label></div><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.nomineeAddress.addressLine3 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 3</label></div><div class=\"input-select input-normal selectfield\"><select class=\"browser-default custom-select\" name=addressCountry easyassist-key=mask-element ng-model=InitiateTransactionSip.nominee.nomineeAddress.country ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\"><option value=\"\" selected>Select Country</option></select></div></div><div class=col-md-4><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.nomineeAddress.addressLine2 name=addressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Address Line 2</label></div><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.nomineeAddress.pinCode name=pinCode capitalize> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code</label></div><div ng-if=\"InitiateTransactionSip.nominee.nomineeAddress.country!==\'India\'\" class=input-normal><input type=text easyassist-key=mask-element autocomplete=off name=addressCity ng-model=InitiateTransactionSip.nominee.nomineeAddress.city capitalize> <span class=highlight></span> <span class=bar></span><label>Select city</label><!--<div ng-if=\"InitiateTransactionSip.nominee.nomineeAddress.country === \'India\'&&InitiateTransactionSip.nominee.nomineeAddress.city&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.nominee.nomineeAddress.city track by $index\" ng-click=\"InitiateTransactionSip.selectNomineeBirthCity(_data,InitiateTransactionSip.nominee)\"> {{_data.cityName}}</li></ul>\n            </div>--></div></div></div></div><hr><div class=form-content ng-if=InitiateTransactionSip.nominee.minor><p><strong>Address Details of Nominee’s guardian</strong></p><div class=\"row add-nomi\"><div class=col-md-4><div class=input-normal ng-class=\"{error:nomineeForm.guardianName.$dirty && nomineeForm.guardianName.$invalid && InitiateTransactionSip.nominee.nomineeName}\"><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.guardianName name=guardianName required capitalize> <span class=highlight></span> <span class=bar></span><label>Name of the guardian<span ng-if=InitiateTransactionSip.nominee.nomineeName class=req>*</span></label><span ng-show=\"nomineeForm.guardianName.$dirty && nomineeForm.guardianName.$invalid && InitiateTransactionSip.nominee.nomineeName\"><span class=error-input ng-show=nomineeForm.guardianName.$error.required>{{InitiateTransactionSip.validations.GUARDIAN_NAME}}</span></span></div><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.guardianAddress.addressLine1 name=gAddressLine1 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 1</label></div><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.guardianAddress.addressLine3 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 3</label></div><div class=\"input-select input-normal selectfield\"><select class=\"browser-default custom-select\" name=guardianAddressCountry ng-model=InitiateTransactionSip.nominee.guardianAddress.country ng-options=\"country.countryName as country.countryName for country in InitiateTransactionSip.countryList\"><option value=\"\" selected>Select Country</option></select></div></div><div class=\"col-md-4 add-nomi-inner\"><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.guardianAddress.addressLine2 name=gAddressLine2 capitalize> <span class=highlight></span> <span class=bar></span><label>Guardian address Line 2</label></div><div class=input-normal><input type=text easyassist-key=mask-element autocomplete=off ng-model=InitiateTransactionSip.nominee.guardianAddress.pinCode name=gPinCode capitalize> <span class=highlight></span> <span class=bar></span><label>Zip / Postal Code</label></div><div class=input-normal><input type=text name=guardianAddressCity autocomplete=off easyassist-key=mask-element ng-model=InitiateTransactionSip.nominee.guardianAddress.city capitalize> <span class=highlight></span> <span class=bar></span><label>Select city</label><!--<div ng-if=\"InitiateTransactionSip.nominee.guardianAddress.country === \'India\'&&InitiateTransactionSip.nominee.guardianAddress.city&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.nominee.guardianAddress.city track by $index\" ng-click=\"InitiateTransactionSip.selectGuardianBirthCity(_data,InitiateTransactionSip.nominee)\"> {{_data.cityName}}</li></ul>\n            </div>--></div></div></div></div><div class=form-content ng-if=!InitiateTransactionSip.isMaxNominees&&!nomineeForm.$invalid&&InitiateTransactionSip.nominee.nomineeName><a href=javaScript:void(0); ng-click=InitiateTransactionSip.addNominee() class=text-blue><strong><i class=expand-icon></i>Add another nominee</strong></a></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button class=\"btn btn-primary-action\" ng-click=InitiateTransactionSip.saveAndContinue() ng-disabled=nomineeForm.$invalid&&InitiateTransactionSip.nominee.nomineeName>Continue</button></div></form></div>");
$templateCache.put("app/transactions/initiate/sip/folio/create-folio.html","<div class=box-middle ng-init=InitiateTransactionSip.folioInit()><form autocomplete=off><div class=form-content><div class=select-folio><p><strong>Select Folio</strong></p><span class=radio-block><span class=radio><input type=radio id=existingFolio name=selectFolioType ng-click=InitiateTransactionSip.changeFolioType() ng-model=InitiateTransactionSip.isExistingFolio ng-value=true> <span class=check></span></span><label for=existingFolio>Existing Folio</label></span><span class=radio-block><span class=radio><input type=radio id=newFolio name=selectFolioType ng-click=InitiateTransactionSip.changeFolioType() ng-model=InitiateTransactionSip.isExistingFolio ng-value=false> <span class=check></span></span><label for=newFolio>New Folio</label></span></div><div class=exist-folio ng-if=InitiateTransactionSip.isExistingFolio><p><strong>Existing Folio for {{InitiateTransactionSip.investorInfo.name}}</strong></p><div ng-show=!InitiateTransactionSip.hasFolioEmailId class=\"input-normal error\"><span class=error-input ng-bind=InitiateTransactionSip.validations.FOLIO_EMAIL></span></div><span class=radio-block ng-repeat=\"folio in InitiateTransactionSip.folioList track by $index\"><span class=radio><input ng-disabled=!folio.activeFlag ng-class=\"{\'disabled-radio\':!folio.activeFlag}\" type=radio name=selectFolio ng-value=folio.folioNo ng-click=InitiateTransactionSip.changeFolio() ng-model=InitiateTransactionSip.folioNumber> <span class=check></span></span><label for=existingFolio>Folio #{{folio.folioNo}}</label></span></div></div><div ng-if=InitiateTransactionSip.isExistingFolio class=\"form-footer form-content\"><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button ng-click=InitiateTransactionSip.goToBankInfo() ng-disabled=!InitiateTransactionSip.hasFolioEmailId class=\"btn btn-primary-action\">Continue</button></div></form></div><div ng-if=!InitiateTransactionSip.isExistingFolio class=\"box-main create-folio\"><ul class=\"nav nav-tabs\"><li ng-repeat=\"tab in InitiateTransactionSip.tabs\" ng-if=!tab.disabled ng-class=\"{active:tab.name===InitiateTransactionSip.currentTab.name}\" ng-click=InitiateTransactionSip.changeTab(tab)><a href=javaScript:void(0);><i ng-if=tab.className ng-class=tab.className></i>{{tab.title}}</a></li></ul><div class=tab-content><!--<span class=\"add-joint-holder pull-right\" ng-if=\"!InitiateTransactionSip.isJointHolderTab\" ng-click=\"InitiateTransactionSip.addJointHolder()\">+ Add Joint Holder </span>--><!--<button class=\"mobile-show mobile-accordion clearfix\">\n      <a data-toggle=\"tab\" href=\"javaScript:void(0);\">Add Joint Holder<i class=\"accordian-arrow-up-icon pull-right\"></i></a>\n    </button>--><div id=selectedTab ng-include=InitiateTransactionSip.currentTab.url></div></div></div>");
$templateCache.put("app/transactions/initiate/sip/folio/sole-applicant-details.html","<div id=applicant-details class=\"tab-pane fade in active\"><form autocomplete=off role=form novalidate name=soleForm><div class=form-content><p><strong>Sole Applicant Details</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.taxStatusCode.$dirty && soleForm.taxStatusCode.$invalid}\"><select class=\"browser-default custom-select\" name=taxStatusCode ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.taxStatusCode ng-options=\"taxStatus.taxStatusCode as taxStatus.taxStatusDescription for taxStatus in InitiateTransactionSip.taxStatusList\" required><option value=\"\" selected>Tax Status</option></select><span class=req>*</span> <span ng-show=\"soleForm.taxStatusCode.$dirty && soleForm.taxStatusCode.$invalid\"><span class=error-input ng-show=soleForm.taxStatusCode.$error.required>{{InitiateTransactionSip.validations.TAX_STATUS}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.occupationDescription.$dirty && soleForm.occupationDescription.$invalid}\"><select class=\"browser-default custom-select\" name=occupationDescription ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.occupation ng-options=\"occupation.occupationCode as occupation.occupationDescription for occupation in InitiateTransactionSip.occupationList\" required><option value=\"\" selected>Occupation</option></select><span class=req>*</span> <span ng-show=\"soleForm.occupationDescription.$dirty && soleForm.occupationDescription.$invalid\"><span class=error-input ng-show=soleForm.occupationDescription.$error.required>{{InitiateTransactionSip.validations.OCCUPATION}}</span></span></div></div></div><div class=\"row net-worth-main\"><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.grossAnnualIncome.$dirty && soleForm.grossAnnualIncome.$invalid}\"><select class=\"browser-default custom-select\" name=grossAnnualIncome ng-click=\"InitiateTransactionSip.setOptionalEmpty(\'GrossAnnualIncome\')\" ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome ng-options=\"_type.incomeCode as _type.incomeDescription for _type in InitiateTransactionSip.incomeSlabList\" ng-required=\"!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorth) && !(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\"><option value=\"\" selected>Gross Annual Income</option></select><span ng-if=\"!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorth)\n            &&!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\" class=req>*</span> <span ng-show=\"soleForm.grossAnnualIncome.$dirty && soleForm.grossAnnualIncome.$invalid\"><span class=error-input ng-show=soleForm.grossAnnualIncome.$error.required>{{InitiateTransactionSip.validations.GROSS_ANNUAL_INCOME}}</span></span></div></div><div class=\"col-md-4 net-worth-inner\"><div class=\"input-normal mgt13\" ng-class=\"{error:soleForm.networth.$dirty && soleForm.networth.$invalid}\"><input type=number easyassist-key=mask-element ignore-mouse-wheel name=networth class=pd20 ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorth autocomplete=off ng-required=!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)> <span class=highlight></span> <span class=bar></span> <i class=rupee-grey-icon></i><label>Net worth (in Rs.) <span ng-if=\"!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\n                ||(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate)\" class=req>*</span></label><span ng-show=\"soleForm.networth.$dirty && soleForm.networth.$invalid\"><span class=error-input ng-show=soleForm.networth.$error.number>{{InitiateTransactionSip.validations.INVALID_AMOUNT}}</span></span></div></div><div class=\"col-md-4 net-worth-inner\"><div class=\"input-normal mgt13\" ng-if=InitiateTransactionSip.resetNetWorthDateFlag ng-class=\"{error:soleForm.networth.$dirty\n               && !InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate\n               && !InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome\n               }\"><input type=text id=networthDate name=networthDate date-calendar format=DD-MMM-YYYY viewmode=days showdefault=\"{{\'\'+!!InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate}}\" date-default=InitiateTransactionSip.defaultsoleApplicantNWDate maxdate=now data-min-date=InitiateTransactionSip.minDate data-on-date-change=InitiateTransactionSip.changeNetWorthDateForSoleApplicant autocomplete=off required> <span class=highlight></span> <span class=bar></span> <i class=calendar-icon></i> <i class=times-icon ng-click=InitiateTransactionSip.resetNetWorthDate()></i><label>As on DD/MM/YYYY <span ng-if=\"!(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\n                ||(InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorth)\" class=req>*</span></label></div><span class=\"text-support text-warn text-purple\">(Not older than 1yr)</span></div></div></div><hr><div class=form-content><p><strong>Politically Exposed Person (PEP) Status</strong></p><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.POLITICAL ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.RELATED ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.politicalStatus> <span class=check></span></span><label>Investor is related to politically exposed person.</label></div><div class=radio-block><span class=radio><input type=radio name=politicalExposed ng-value=InitiateTransactionSip.POLITICAL_STATUS.NONE ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.politicalStatus> <span class=check></span></span><label>None of the above.</label></div></div><hr><div class=form-content><p><strong>FATCA or CRS information</strong></p><div class=row><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.fatcaAddressType.$dirty && soleForm.fatcaAddressType.$invalid}\"><select class=\"browser-default custom-select\" name=fatcaAddressType ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.fatcaAddressType ng-options=\"addressType.value as addressType.addressDescription for addressType in InitiateTransactionSip.addressTypeList\" required><option value=\"\" selected>Address Type</option></select><span class=req>*</span> <span ng-show=\"soleForm.fatcaAddressType.$dirty && soleForm.fatcaAddressType.$invalid\"><span class=error-input ng-show=soleForm.fatcaAddressType.$error.required>{{InitiateTransactionSip.validations.ADDRESS_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.birthCountry.$dirty && soleForm.birthCountry.$invalid}\"><select class=\"browser-default custom-select\" name=birthCountry ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.birthCountry ng-options=\"country.countryCode as country.countryName for country in InitiateTransactionSip.countryList\" required><option value=\"\" selected>Country of Birth</option></select><span class=req>*</span> <span ng-show=\"soleForm.birthCountry.$dirty && soleForm.birthCountry.$invalid\"><span class=error-input ng-show=soleForm.birthCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div></div></div><div class=row><div class=col-md-4><div class=input-normal ng-class=\"{error:soleForm.birthCity.$dirty && soleForm.birthCity.$invalid}\"><input type=text name=birthCity autocomplete=off ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.birthCity required capitalize> <span class=highlight></span> <span class=bar></span><label>City of Birth<span class=req>*</span></label><!--<div ng-if=\"InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.birthCountry === \'India\'&&InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.birthCity&&InitiateTransactionSip.cityList.length\" class=\"suggestion box-shadow\">\n              <ul><li ng-repeat=\"_data in InitiateTransactionSip.cityList|filterCity:InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.birthCity track by $index\" ng-click=\"InitiateTransactionSip.selectBirthCity(_data)\"> {{_data.cityName}}</li></ul>\n            </div>--></div><span ng-show=\"soleForm.birthCity.$dirty && soleForm.birthCity.$invalid\"><span class=error-message ng-show=soleForm.birthCity.$error.required>{{InitiateTransactionSip.validations.CITY}}</span></span></div></div></div><div class=form-content><p><strong>Does the investor pay or file tax other than india?</strong></p><span class=radio-block><span class=radio><input type=radio id=yes ng-click=InitiateTransactionSip.changePayOutsideTypeForSoleApplicant() ng-value=true ng-model=InitiateTransactionSip._soleApplicant.isPayOutside name=selectTax> <span class=check></span></span><label for=yes>Yes</label></span><span class=radio-block><span class=radio><input type=radio id=no ng-click=InitiateTransactionSip.changePayOutsideTypeForSoleApplicant() ng-value=false ng-model=InitiateTransactionSip._soleApplicant.isPayOutside name=selectTax> <span class=check></span> </span><label for=no>No</label></span><div ng-if=InitiateTransactionSip._soleApplicant.isPayOutside&&InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses.length><div ng-repeat=\"payOutside in InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.payOutsideIndiaAddresses track by $index\"><p ng-click=InitiateTransactionSip.removePayOutsideCountryForSoleApplicant($index)><strong>Tax Residency Country</strong> <span class=remove-item><i class=delete-icon></i><span>Remove</span></span></p><div class=\"row tax-res\"><div class=col-md-4><div class=input-normal ng-class=\"{error:soleForm[\'countryName\'+$index].$dirty && soleForm[\'countryName\'+$index].$invalid}\"><input type=text autocomplete=off name=\"[\'countryName\'+$index]\" ng-model=payOutside.countryName readonly required capitalize> <span class=bar></span> <span ng-show=\"soleForm[\'countryName\'+$index].$dirty && soleForm[\'countryName\'+$index].$invalid\"><span class=error-input ng-show=\"soleForm[\'countryName\'+$index].$error.required\">{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=input-normal ng-class=\"{error:soleForm[\'taxIdType\'+$index].$dirty && soleForm[\'taxIdType\'+$index].$invalid}\"><input type=text autocomplete=off name=\"[\'taxIdType\'+$index]\" ng-model=payOutside.taxIdType readonly required capitalize> <span class=bar></span> <span ng-show=\"soleForm[\'taxIdType\'+$index].$dirty && soleForm[\'taxIdType\'+$index].$invalid\"><span class=error-input ng-show=\"soleForm[\'taxIdType\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=input-normal ng-class=\"{error:soleForm[\'taxIdNumber\'+$index].$dirty && soleForm[\'taxIdNumber\'+$index].$invalid}\"><input type=text autocomplete=off name=\"[\'taxIdNumber\'+$index]\" ng-model=payOutside.taxIdNumber readonly required capitalize> <span class=bar></span> <span ng-show=\"soleForm[\'taxIdNumber\'+$index].$dirty && soleForm[\'taxIdNumber\'+$index].$invalid\"><span class=error-input ng-show=\"soleForm[\'taxIdNumber\'+$index].$error.required\">{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div></div></div><div ng-if=\"InitiateTransactionSip._soleApplicant.isPayOutside && !InitiateTransactionSip._soleApplicant.isMaxPayOutsideEntries\"><div class=\"row tax-res\" ng-if=!InitiateTransactionSip.payOutsideResetting><div class=col-md-4><div class=\"input-select input-normal selectfield\" ng-class=\"{error:soleForm.residencyCountry.$dirty && soleForm.residencyCountry.$invalid}\"><select class=\"browser-default custom-select\" name=residencyCountry ng-model=InitiateTransactionSip._soleApplicant.payOutsideModel.countryName ng-options=\"_country.countryName as _country.countryName for _country in InitiateTransactionSip.countryList|removeCountry:\'INDIA\'\n                          |removeCountry:\'UNITED STATES\'|removeCountry:\'UNITED STATES MINOR OUTLYINGISLANDS\'|removeCountry:\'CANADA\'\" required><option value=\"\" selected>Name of country</option></select><span class=req>*</span> <span ng-show=\"soleForm.residencyCountry.$dirty && soleForm.residencyCountry.$invalid\"><span class=error-input ng-show=soleForm.residencyCountry.$error.required>{{InitiateTransactionSip.validations.COUNTRY}}</span></span></div><div class=\"input-select input-normal\" ng-class=\"{error:soleForm.taxIdType.$dirty && soleForm.taxIdType.$invalid}\"><input type=text autocomplete=off ng-model=InitiateTransactionSip._soleApplicant.payOutsideModel.taxIdType required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID Type<span class=req>*</span></label><span ng-show=\"soleForm.taxIdType.$dirty && soleForm.taxIdType.$invalid\"><span class=error-input ng-show=soleForm.taxIdType.$error.required>{{InitiateTransactionSip.validations.TAX_ID_TYPE}}</span></span></div></div><div class=col-md-4><div class=\"input-select input-normal\" ng-class=\"{error:soleForm.taxIdNumber.$dirty && soleForm.taxIdNumber.$invalid}\"><input type=text autocomplete=off ng-model=InitiateTransactionSip._soleApplicant.payOutsideModel.taxIdNumber required capitalize> <span class=highlight></span> <span class=bar></span><label>Tax ID number<span class=req>*</span></label><span ng-show=\"soleForm.taxIdNumber.$dirty && soleForm.taxIdNumber.$invalid\"><span class=error-input ng-show=soleForm.taxIdNumber.$error.required>{{InitiateTransactionSip.validations.TAX_ID_NUMBER}}</span></span></div></div></div><a href=javaScript:void(0); ng-click=InitiateTransactionSip.addPayOutsideCountryForSoleApplicant() class=text-blue><strong><i class=expand-icon></i>Add another tax residency country</strong></a></div></div><hr><div class=\"form-footer form-content\"><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button ng-click=InitiateTransactionSip.saveAndContinue() ng-disabled=\"(soleForm.$invalid) ||(!InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.netWorthDate && !InitiateTransactionSip.investorPayload.folioCreationRequestCO.soleApplicantDetail.grossAnnualIncome)\" class=\"btn btn-primary-action\">Continue</button></div></form></div>");
$templateCache.put("app/transactions/initiate/sip/paymentmethod/payment-method.html","<div class=box-main ng-init=InitiateTransactionSip.paymentInit()><div class=form-box><form autocomplete=off name=bankInfoForm ng-if=!InitiateTransactionSip.isExistingFolio novalidate role=form><div class=\"col-md-4 form-grid\"><label>Bank Details</label><p class=pay-sugg>Bank information provided below would be used for payout purposes.</p><div class=form-group><div class=selectfield ng-class=\"{error:bankInfoForm.accountType.$dirty && bankInfoForm.accountType.$invalid}\"><select class=\"browser-default custom-select\" name=accountType ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountType ng-options=\"account.accountTypeCode as account.accountType for account in InitiateTransactionSip.accountTypeList\" required><option value=\"\" selected>Account Type</option></select><span class=req>*</span> <span ng-show=\"bankInfoForm.accountType.$dirty && bankInfoForm.accountType.$invalid\"><span class=error-input ng-show=bankInfoForm.accountType.$error.required>{{InitiateTransactionSip.validations.ACCOUNT_TYPE_REQUIRED}}</span></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:bankInfoForm.payoutMechanism.$dirty && bankInfoForm.payoutMechanism.$invalid}\"><select class=\"browser-default custom-select\" name=payoutMechanism ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.payoutMechanism ng-options=\"_type.payoutCode as _type.payoutDescription for _type in InitiateTransactionSip.payoutMechanismList\" required><option value=\"\" selected>Payout Mechanism</option></select><span class=req>*</span> <span ng-show=\"bankInfoForm.payoutMechanism.$dirty && bankInfoForm.payoutMechanism.$invalid\"><span class=error-input ng-show=bankInfoForm.payoutMechanism.$error.required>{{InitiateTransactionSip.validations.PAYOUT_MECH_REQUIRED}}</span></span></div></div><div class=form-group><div class=selectfield ng-class=\"{error:bankInfoForm.bankName.$dirty && bankInfoForm.bankName.$invalid}\"><select class=\"browser-default custom-select\" name=bankName ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.bankName ng-options=\"bank.bankName as bank.bankName for bank in InitiateTransactionSip.bankList\" required><option value=\"\" selected>Bank Name</option></select><span class=req>*</span> <span ng-show=\"bankInfoForm.bankName.$dirty && bankInfoForm.bankName.$invalid\"><span class=error-input ng-show=bankInfoForm.bankName.$error.required>{{InitiateTransactionSip.validations.BANK_NAME_REQUIRED}}</span></span></div></div></div><div class=\"col-md-4 form-grid mgt50\"><div class=form-group><div class=input-normal ng-class=\"{error:(InitiateTransactionSip.accModelDirty &&\n                 (!InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length\n                 || InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<9))}\"><input type=text name=accountNumber minlength=9 onkeypress=\"return (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39) || (event.charCode >= 48 && event.charCode <= 57)\" directive.mask ng-change=InitiateTransactionSip.accFocus(); ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number<span class=req>*</span></label><!--<span ng-show=\"bankInfoForm.accountNumber.$dirty && bankInfoForm.accountNumber.$invalid\">\n              <span class=\"error-input\" ng-show=\"bankInfoForm.accountNumber.$error.required\">{{InitiateTransactionSip.validations.ACCOUNT_NUMBER_REQUIRED}}</span>\n              <span class=\"error-input\" ng-show=\"bankInfoForm.accountNumber.$error.minlength && !bankInfoForm.accountNumber.$error.required\">{{InitiateTransactionSip.validations.ACCOUNT_NUMBER_RANGE}}</span>\n            </span>--> <span ng-show=InitiateTransactionSip.accModelDirty><span class=error-input ng-show=\"InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length==0\" ng-bind=InitiateTransactionSip.validations.ACCOUNT_NUMBER_REQUIRED></span> <span class=error-input ng-show=\"(!InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length\n                      || InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber.split(\'\').length<9)\" ng-bind=InitiateTransactionSip.validations.ACCOUNT_NUMBER_RANGE></span></span></div></div><div class=form-group><div class=input-normal ng-class=\"{error:bankInfoForm.ifsccode.$dirty && bankInfoForm.ifsccode.$invalid}\"><input type=text name=ifsccode ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.ifsccode autocomplete=off ng-pattern=InitiateTransactionSip.IFSC_REGEX maxlength=11 minlength=11 required capitalize> <span class=highlight></span><!--\'^[A-Za-z]{4}[0-9]{7}$\'--> <span class=bar></span><label>IFSC Code<span class=req>*</span></label><span ng-show=\"bankInfoForm.ifsccode.$dirty && bankInfoForm.ifsccode.$invalid\"><span class=error-input ng-show=bankInfoForm.ifsccode.$error.required>{{InitiateTransactionSip.validations.IFSC_CODE_FIELD}}</span> <span class=error-input ng-show=bankInfoForm.ifsccode.$error.pattern>{{InitiateTransactionSip.validations.IFSC_CODE_REGEX}}</span></span></div></div><div class=form-group><div class=\"input-select input-normal\" ng-class=\"{error:bankInfoForm.bankBranch.$dirty && bankInfoForm.bankBranch.$invalid}\"><input type=text name=bankBranch ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.bankBranch required capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Name<span class=req>*</span></label><span ng-show=\"bankInfoForm.bankBranch.$dirty && bankInfoForm.bankBranch.$invalid\"><span class=error-input ng-show=bankInfoForm.bankBranch.$error.required>{{InitiateTransactionSip.validations.BRANCH_NAME_REQUIRED}}</span></span></div></div><!--<div class=\"form-group\">\n          <div class=\"input-select input-normal\">\n            <input type=\"text\" ng-model=\"InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.rgtsCode\" name=\"rgtsCode\" capitalize>\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n            <label>RGTS Code</label>\n          </div>\n        </div>--></div><div class=\"col-md-4 form-grid mgt50\"><div class=form-group><div class=\"input-normal verify-acc\" ng-class=\"{error:bankInfoForm.verifyAccountNumber.$dirty && bankInfoForm.verifyAccountNumber.$invalid}\"><input type=text name=verifyAccountNumber minlength=9 onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.verifyAccountNumber ng-pattern=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.accountNumber autocomplete=off ng-keydown=InitiateTransactionSip.copyPasteHandler($event) required capitalize> <span class=highlight></span> <span class=bar></span><label>Verify Account Number<span class=req>*</span></label><span ng-show=\"bankInfoForm.verifyAccountNumber.$dirty && bankInfoForm.verifyAccountNumber.$invalid\"><span class=error-input ng-show=bankInfoForm.verifyAccountNumber.$error.required>{{InitiateTransactionSip.validations.ACCOUNT_NUMBER_REQUIRED}}</span> <span class=error-input ng-show=\"bankInfoForm.verifyAccountNumber.$error.minlength && !bankInfoForm.verifyAccountNumber.$error.required\">{{InitiateTransactionSip.validations.ACCOUNT_NUMBER_RANGE}}</span> <span class=error-input ng-show=\"bankInfoForm.verifyAccountNumber.$error.pattern && !bankInfoForm.verifyAccountNumber.$error.minlength && !bankInfoForm.verifyAccountNumber.$error.required\">{{InitiateTransactionSip.validations.SAME_ACCOUNT_NUMBER_RANGE}}</span></span></div></div><div class=form-group><div class=\"input-normal verify-acc\" ng-class={error:bankInfoForm.micrnumber.$dirty&&bankInfoForm.micrnumber.$invalid}><input type=text name=micrnumber maxlength=9 minlength=9 ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.micrnumber autocomplete=off ng-pattern=\"\'^[0-9]+$\'\" required capitalize> <span class=highlight></span> <span class=bar></span><label>MICR Code<span class=req>*</span></label><span ng-show=\"bankInfoForm.micrnumber.$dirty && bankInfoForm.micrnumber.$invalid\"><span class=error-input ng-show=bankInfoForm.micrnumber.$error.required>{{InitiateTransactionSip.validations.MICR_NUMBER_FIELD}}</span> <span class=error-input ng-show=!bankInfoForm.micrnumber.$error.required&&bankInfoForm.micrnumber.$error.minlength>{{InitiateTransactionSip.validations.MICR_NUMBER_RANGE}}</span><!--<span class=\"error-input\" ng-show=\"!bankInfoForm.micrnumber.$error.required&&bankInfoForm.micrnumber.$error.maxlength\">{{InitiateTransactionSip.validations.MICR_NUMBER_RANGE}}</span>--> <span class=error-input ng-show=\"!bankInfoForm.micrnumber.$error.minlength && bankInfoForm.micrnumber.$error.pattern\" ng-bind=InitiateTransactionSip.validations.DIGITS_ONLY>Pattern validation</span></span></div></div><div class=form-group><div class=input-normal ng-class=\"{error:bankInfoForm.branchLocation.$dirty && bankInfoForm.branchLocation.$invalid}\"><input type=text name=branchLocation ng-model=InitiateTransactionSip.investorPayload.folioCreationRequestCO.bankDetails.branchLocation autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location<span class=req>*</span></label><span ng-show=\"bankInfoForm.branchLocation.$dirty && bankInfoForm.branchLocation.$invalid\"><span class=error-input ng-show=bankInfoForm.branchLocation.$error.required>{{InitiateTransactionSip.validations.BRANCH_LOCATION_REQUIRED}}</span></span></div></div></div><div class=\"col-md-12 form-footer form-content\"><span class=pull-right><button class=\"btn btn-negative-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.updatePayload()>Back</button> <button ng-click=InitiateTransactionSip.goToScheme() ng-disabled=bankInfoForm.$invalid class=\"btn btn-primary-action\">Continue</button></span></div></form><form autocomplete=off ng-if=InitiateTransactionSip.isExistingFolio novalidate role=form><div class=\"col-md-4 form-grid\"><label>Bank Details</label><p class=pay-sugg>Bank information provided below would be used for payout purposes.</p><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.payMech autocomplete=off readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>Payout Mechanism</label></div></div><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.bankAcType autocomplete=off readonly focus required capitalize> <span class=highlight></span> <span class=bar></span><label>Account Type</label></div></div><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.bankAcNo autocomplete=off readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>Account Number</label></div></div></div><div class=\"col-md-4 form-grid\"><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.ifscCode autocomplete=off readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>IFSC Code</label></div></div><div class=form-group><div class=\"input-normal verify-acc\"><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.micrnumber autocomplete=off readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>MICR Code</label></div></div></div><div class=\"col-md-4 form-grid\"><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.bankName autocomplete=off readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>Bank Name</label></div></div><div class=form-group><div class=input-normal><input type=text autocomplete=off ng-model=InitiateTransactionSip.primaryBankInfo.bankBranch readonly required capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Name</label></div></div><div class=form-group><div class=input-normal><input type=text ng-model=InitiateTransactionSip.primaryBankInfo.branchLocation readonly autocomplete=off required capitalize> <span class=highlight></span> <span class=bar></span><label>Branch Location</label></div></div></div><div class=\"col-md-12 form-footer form-content\"><span class=\"pull-left back-btn\" ui-sref=main.transactions.initiate.sip.folio><i class=back-arrow-icon></i> <span class=text-blue>Back </span></span><span class=pull-right><button class=\"btn btn-secondary-action\" ng-click=InitiateTransactionSip.cancelTransaction()>Cancel</button> <button ng-click=InitiateTransactionSip.goToScheme() ng-disabled=!InitiateTransactionSip.hasFolioEmailId class=\"btn btn-primary-action\">Continue</button></span></div></form></div></div>");
$templateCache.put("app/transactions/initiate/summary/payment/payment.billdesk.html","<div class=modal-content id=paymentSummary ng-init=PaymentBillDesk.init()><div class=modal-body><p>Thankyou for making Payment. The details are as follows :</p><table class=\"table borderless\"><tr ng-if=!PaymentBillDesk.responseData.transactionId><td>transaction Id :</td><td>{{PaymentBillDesk.responseData.transactionId}}</td></tr><tr ng-if=!PaymentBillDesk.responseData.bankName><td>Name of Bank :</td><td>{{PaymentBillDesk.responseData.bankName}}</td></tr><tr ng-if=!PaymentBillDesk.responseData.amount><td>Investment Amount :</td><td>{{PaymentBillDesk.responseData.amount}}</td></tr><tr ng-if=!PaymentBillDesk.responseData.transactionDate><td>Investment Start Date :</td><td>{{PaymentBillDesk.responseData.transactionDate}}</td></tr></table><div class=email-block ng-if=\"!PaymentBillDesk.isSuccess && !PaymentBillDesk.responseData\"><div class=\"col-md-4 col-md-push-4\"><i class=success-icon></i><h6>Payment Submission Successful</h6><br><hr><button type=submit ng-disabled=!PaymentBillDesk.isActionPerformed ng-click=PaymentBillDesk.approveTransaction() class=\"btn btn-primary-action\">Approve Transaction</button></div></div><div class=email-block ng-if=\"PaymentBillDesk.isSuccess && PaymentBillDesk.responseData\"><div class=\"col-md-4 col-md-push-4\"><i class=reject-icon></i><h6>Payment Submission Rejected</h6><br><hr><button type=submit ng-disabled=PaymentBillDesk.isActionPerformed ng-click=PaymentBillDesk.rejectTransaction() class=\"btn btn btn-negative-action\">Ok</button></div></div></div><!--<div ng-init=\"Payment.init()\">\n  <header>\n    <div class=\"logo\">\n      <img src=\"../../../assets/images/logo.png\">\n    </div>\n  </header>\n  <section>\n    <div class=\"email-block\" ng-if=\"Payment.isSuccess&&Payment.responseData\">\n      <div class=\"col-md-4 col-md-push-4\">\n        <i class=\"success-icon\"></i>\n        <h6>Payment Submission Successful</h6>\n        <br>\n        <hr>\n        <button type=\"submit\" ng-disabled=\"Payment.isActionPerformed\" ng-click=\"Payment.approveTransaction()\"\n                class=\"btn btn-primary-action\">Approve Transaction\n        </button>\n      </div>\n    </div>\n\n    <div class=\"email-block\" ng-if=\"(!Payment.isSuccess&&Payment.responseData)||!Payment.responseData\">\n      <div class=\"col-md-4 col-md-push-4\">\n        <i class=\"reject-icon\"></i>\n        <h6>Payment Submission Rejected</h6>\n        <br>\n        <hr>\n        <button type=\"submit\" ng-disabled=\"Payment.isActionPerformed\" ng-click=\"Payment.rejectTransaction()\"\n                class=\"btn btn btn-negative-action\">Ok\n        </button>\n      </div>\n    </div>\n  </section>\n</div>\n--></div>");
$templateCache.put("app/transactions/initiate/summary/payment/payment.billjunction.html","<div class=modal-content id=paymentSummary ng-init=PaymentBillJunction.init()><div class=modal-body><p>Thankyou for making Payment. The details are as follows :</p><table class=\"table borderless\"><tr ng-if=PaymentBillJunction.responseData.transactionId><td>transaction Id :</td><td>{{PaymentBillJunction.responseData.transactionId}}</td></tr><tr ng-if=PaymentBillJunction.responseData.bankName><td>Name of Bank :</td><td>{{PaymentBillJunction.responseData.bankName}}</td></tr><!--<tr>--><!--<td>Bill No. :</td>--><!--<td>12345</td>--><!--</tr>--><!--<tr>--><!--<td>Scheme Name :</td>--><!--<td>HDFC Tax Saver Fund</td>--><!--</tr>--><!--<tr>--><!--<td>Investment Type :</td>--><!--<td>Lumpsum</td>--><!--</tr>--><tr ng-if=PaymentBillJunction.responseData.amount><td>Investment Amount :</td><td>{{PaymentBillJunction.responseData.amount}}</td></tr><tr ng-if=PaymentBillJunction.responseData.transactionDate><td>Investment Start Date :</td><td>{{PaymentBillJunction.responseData.transactionDate}}</td></tr></table></div><div class=email-block ng-if=\"PaymentBillJunction.isSuccess && PaymentBillJunction.responseData\"><div class=\"col-md-4 col-md-push-4\"><i class=success-icon></i><h6>Payment Submission Successful</h6><br><hr><button type=submit ng-disabled=PaymentBillJunction.isActionPerformed ng-click=PaymentBillJunction.approveTransaction() class=\"btn btn-primary-action\">Approve Transaction</button></div></div><div class=email-block ng-if=\"!PaymentBillJunction.isSuccess && !PaymentBillJunction.responseData\"><div class=\"col-md-4 col-md-push-4\"><i class=reject-icon></i><h6>Payment Submission Rejected</h6><br><hr><button type=submit ng-disabled=PaymentBillJunction.isActionPerformed ng-click=PaymentBillJunction.rejectTransaction() class=\"btn btn btn-negative-action\">Ok</button></div></div><!--<div class=\"modal-footer\">--><!--<div class=\"email-block buttons-block\">--><!--<div class=\"email-block-button\">--><!--<span class=\"btn btn-primary-action\" ng-click=\"Modal.paymentSummery()\">Ok</span>--><!--</div>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/transactions/initiate/summary/transactionFail/fail-transaction.html","<div class=email-view><header><div class=logo><img src=../../../assets/images/logo.png></div></header><section ng-if=\"TransactionFail.formData.paymentOption ==\'OTM\'\" class=summary-sip><div class=tab-content><section class=sip-summary-thankyou><div class=content-header><h5 class=text-uppercase><span>Dear</span> {{TransactionFail.formData.investorName}}</h5><p>Thank you for transacting online using HDFCMF Online Investors.</p><p>We have successfully received your request for {{TransactionFail.formData.transactionType}} via OTM. {{TransactionFail.formData.transactionType}} will be debited from your bank account on the selected date, kindly maintain sufficient balance to stay invested with us.</p></div><div class=content-body><div class=email-block><div class=row style=padding-bottom:30px><div class=col-md-12><p class=email-block-header>Transaction Details:</p><table class=table><tr><td>Folio Number</td><td>: {{TransactionFail.formData.folioNumber}}</td></tr><tr><td>Investor Name</td><td>: {{TransactionFail.formData.folioInvestorName}}</td></tr><tr><td>Transaction Type</td><td>: {{TransactionFail.formData.transactionType}} Registration</td></tr><tr><td>Payment mode</td><td>: OTM</td></tr><tr ng-if=TransactionFail.formData.srnNo><td>{{TransactionFail.formData.transactionType}} Registration Number</td><td>: {{TransactionFail.formData.srnNo}}</td></tr><tr><td>CAMS Transaction Number</td><td>: {{TransactionFail.formData.transactionId}}</td></tr><tr><td>Scheme Name</td><td>: {{TransactionFail.formData.schemeName}}</td></tr><tr ng-if=TransactionFail.formData.investmentOption><td>Investment Option</td><td>: {{TransactionFail.formData.investmentOption}}</td></tr><tr ng-if=\"TransactionFail.formData.investmentOption === TransactionFail.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\"><td>Income Distribution cum Capital Withdrawal (IDCW) Option</td><td>: <span ng-if=\"TransactionFail.formData.investmentOption===TransactionFail.TRANSACTIONS_CONST.INVESTMENT_OPTIONS.DIVIDEND\">{{TransactionFail.TRANSACTIONS_CONST.DESCRIPTIONS[TransactionFail.formData.sipDividendOption]}}</span></td></tr><tr><td>Installment Amount(INR)</td><td>: {{TransactionFail.formData.amount}}</td></tr><tr ng-if=TransactionFail.formData.frequency><td>{{TransactionFail.formData.transactionType}} Frequency</td><td>: {{TransactionFail.formData.frequency}}</td></tr><tr ng-if=TransactionFail.formData.transactionInitiateDate><td>Transaction Initiated Date & Time</td><td>: {{TransactionFail.formData.transactionInitiateDate}}</td></tr><tr ng-if=TransactionFail.formData.startDate><td>{{TransactionFail.formData.transactionType}} From Date</td><td>: {{TransactionFail.formData.startDate}}</td></tr><tr ng-if=\"TransactionFail.formData.transactionType === \'Flex SIP\'\"><td>Flex SIP Tenure</td><td>: {{TransactionFail.tenureDiff}} years</td></tr><tr><td>{{TransactionFail.formData.transactionType}} To Date</td><td>: {{TransactionFail.formData.endDate}}</td></tr><tr><td>Bank Name</td><td>: {{TransactionFail.formData.bankName | uppercase}}</td></tr><tr><td>Bank Account number</td><td>: {{TransactionFail.formData.bankAcNo}}</td></tr><tr ng-if=TransactionFail.formData.mobileNumber><td>Mobile Number</td><td>: {{TransactionFail.formData.mobileNumber}}</td></tr></table></div></div></div></div></section></div></section><section ng-if=\"TransactionFail.formData.paymentOption !=\'OTM\'\" class=summary-sip><div class=tab-content><section class=sip-summary-thankyou><div class=content-header><h5 class=text-uppercase><span>Dear</span> {{TransactionFail.formData.investorName}}</h5><p>Thankyou for providing bank details. Please add HDFC Mutual Fund as a biller to your bank account</p></div><div class=content-body><div class=email-block><p class=email-block-header>SRN No. for your <span ng-if=\"TransactionFail.formData.transactionType == \'DREAMSIP\' \">Dream </span>SIP: <span>{{TransactionFail.formData.srnNo}}</span> &nbsp;<a ng-if=TransactionFail.formData.netBankingUrl target=_blank ng-href={{TransactionFail.formData.netBankingUrl}} style=\"color: #2485bd\">(Please click here for SRN registration)</a></p><form autocomplete=off role=form action=\"\" method=\"\"><p><strong>Here is how you can quickly register HDFC Mutual Fund as a biller to your net banking account</strong></p><p>In order to complete SIP registration, investor should either click on the \"Register SIP with bank\" button or log on to his/her registered banking net banking facility and register for auto debit instruction for SIP installment. We recommend investors to select the auto payment option.</p><ul><li>Please select HDFC Mutual Fund as biller.</li><li>Please input the SIP Registration Number (SRN) in the field requesting the Biller Reference Number.</li><li>Please complete your SIP registration with your bank within 70 days from today. The SRN will be invalid if the registration on your bank\'s website is not completed within the specified period.</li><li>If the SIP registration with your bank is not completed by you, units created in your folio for the aforesaid SIP, if any, will be reversed.</li><li>Investors will not hold HDFC Mutual Fund / HDFC Asset Management Company Limited, its registrars and other service providers responsible if the transaction is delayed or not effected or the Investor\'s bank account is debited in advance or after the spoecific SIP date due to local holidays or any other reason.</li><li>Please register SRN for your SIP with Autopay option to avoid SIP getting cancelled due to non-availability of debit bank account from your bank.</li></ul></form></div></div></section></div></section></div><style>table.table tbody tr td{\n    padding-bottom: 7px;\n    padding-top:7px;\n  }</style>");
$templateCache.put("app/transactions/initiate/summary/transactionFail/transaction.confirmation.html","<div class=\"main-loader success-loader\" style=\"display: block\"><div class=loader-box><h3>Welcome To HDFC MF Online Partners !</h3><p>Thank you for the confirmation</p></div></div>");
$templateCache.put("app/transactions/initiate/summary/transactionFail/transaction.success.html","<div class=\"main-loader success-loader\" style=\"display: block\"><div class=loader-box><h3>Welcome To HDFC MF Online Partners !</h3><p>Your transaction is successful</p></div></div>");}]);